var bde = Object.defineProperty;
var yde = (t, e, n) => e in t ? bde(t, e, { enumerable: !0, configurable: !0, writable: !0, value: n }) : t[e] = n;
var xg = (t, e, n) => (yde(t, typeof e != "symbol" ? e + "" : e, n), n);
import * as x from "react";
import O, { createContext as oi, useContext as fn, useEffect as Re, useRef as Ee, useLayoutEffect as Ua, Component as Do, useState as Le, useMemo as Rn, useCallback as et, forwardRef as gt, useImperativeHandle as wc, cloneElement as Is, isValidElement as Od, PureComponent as Pm, Suspense as xde, createElement as Pe, Fragment as ha, Children as za, useReducer as Nm } from "react";
import * as FH from "react-dom";
import ks, { unstable_batchedUpdates as Cde, flushSync as sc, createPortal as km } from "react-dom";
var ft = typeof globalThis < "u" ? globalThis : typeof window < "u" ? window : typeof global < "u" ? global : typeof self < "u" ? self : {};
function qn(t) {
  return t && t.__esModule && Object.prototype.hasOwnProperty.call(t, "default") ? t.default : t;
}
function LH(t) {
  if (t.__esModule)
    return t;
  var e = t.default;
  if (typeof e == "function") {
    var n = function r() {
      return this instanceof r ? Reflect.construct(e, arguments, this.constructor) : e.apply(this, arguments);
    };
    n.prototype = e.prototype;
  } else
    n = {};
  return Object.defineProperty(n, "__esModule", { value: !0 }), Object.keys(t).forEach(function(r) {
    var i = Object.getOwnPropertyDescriptor(t, r);
    Object.defineProperty(n, r, i.get ? i : {
      enumerable: !0,
      get: function() {
        return t[r];
      }
    });
  }), n;
}
var VH = { exports: {} };
(function(t, e) {
  (function(n, r) {
    t.exports = r();
  })(ft, function() {
    var n = 1e3, r = 6e4, i = 36e5, o = "millisecond", a = "second", s = "minute", u = "hour", l = "day", c = "week", d = "month", f = "quarter", h = "year", p = "date", v = "Invalid Date", m = /^(\d{4})[-/]?(\d{1,2})?[-/]?(\d{0,2})[Tt\s]*(\d{1,2})?:?(\d{1,2})?:?(\d{1,2})?[.:]?(\d+)?$/, b = /\[([^\]]+)]|Y{1,4}|M{1,4}|D{1,2}|d{1,4}|H{1,2}|h{1,2}|a|A|m{1,2}|s{1,2}|Z{1,2}|SSS/g, y = { name: "en", weekdays: "Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday".split("_"), months: "January_February_March_April_May_June_July_August_September_October_November_December".split("_"), ordinal: function(V) {
      var $ = ["th", "st", "nd", "rd"], F = V % 100;
      return "[" + V + ($[(F - 20) % 10] || $[F] || $[0]) + "]";
    } }, w = function(V, $, F) {
      var M = String(V);
      return !M || M.length >= $ ? V : "" + Array($ + 1 - M.length).join(F) + V;
    }, S = { s: w, z: function(V) {
      var $ = -V.utcOffset(), F = Math.abs($), M = Math.floor(F / 60), B = F % 60;
      return ($ <= 0 ? "+" : "-") + w(M, 2, "0") + ":" + w(B, 2, "0");
    }, m: function V($, F) {
      if ($.date() < F.date())
        return -V(F, $);
      var M = 12 * (F.year() - $.year()) + (F.month() - $.month()), B = $.clone().add(M, d), X = F - B < 0, L = $.clone().add(M + (X ? -1 : 1), d);
      return +(-(M + (F - B) / (X ? B - L : L - B)) || 0);
    }, a: function(V) {
      return V < 0 ? Math.ceil(V) || 0 : Math.floor(V);
    }, p: function(V) {
      return { M: d, y: h, w: c, d: l, D: p, h: u, m: s, s: a, ms: o, Q: f }[V] || String(V || "").toLowerCase().replace(/s$/, "");
    }, u: function(V) {
      return V === void 0;
    } }, E = "en", I = {};
    I[E] = y;
    var _ = "$isDayjsObject", A = function(V) {
      return V instanceof D || !(!V || !V[_]);
    }, P = function V($, F, M) {
      var B;
      if (!$)
        return E;
      if (typeof $ == "string") {
        var X = $.toLowerCase();
        I[X] && (B = X), F && (I[X] = F, B = X);
        var L = $.split("-");
        if (!B && L.length > 1)
          return V(L[0]);
      } else {
        var j = $.name;
        I[j] = $, B = j;
      }
      return !M && B && (E = B), B || !M && E;
    }, N = function(V, $) {
      if (A(V))
        return V.clone();
      var F = typeof $ == "object" ? $ : {};
      return F.date = V, F.args = arguments, new D(F);
    }, k = S;
    k.l = P, k.i = A, k.w = function(V, $) {
      return N(V, { locale: $.$L, utc: $.$u, x: $.$x, $offset: $.$offset });
    };
    var D = function() {
      function V(F) {
        this.$L = P(F.locale, null, !0), this.parse(F), this.$x = this.$x || F.x || {}, this[_] = !0;
      }
      var $ = V.prototype;
      return $.parse = function(F) {
        this.$d = function(M) {
          var B = M.date, X = M.utc;
          if (B === null)
            return /* @__PURE__ */ new Date(NaN);
          if (k.u(B))
            return /* @__PURE__ */ new Date();
          if (B instanceof Date)
            return new Date(B);
          if (typeof B == "string" && !/Z$/i.test(B)) {
            var L = B.match(m);
            if (L) {
              var j = L[2] - 1 || 0, K = (L[7] || "0").substring(0, 3);
              return X ? new Date(Date.UTC(L[1], j, L[3] || 1, L[4] || 0, L[5] || 0, L[6] || 0, K)) : new Date(L[1], j, L[3] || 1, L[4] || 0, L[5] || 0, L[6] || 0, K);
            }
          }
          return new Date(B);
        }(F), this.init();
      }, $.init = function() {
        var F = this.$d;
        this.$y = F.getFullYear(), this.$M = F.getMonth(), this.$D = F.getDate(), this.$W = F.getDay(), this.$H = F.getHours(), this.$m = F.getMinutes(), this.$s = F.getSeconds(), this.$ms = F.getMilliseconds();
      }, $.$utils = function() {
        return k;
      }, $.isValid = function() {
        return this.$d.toString() !== v;
      }, $.isSame = function(F, M) {
        var B = N(F);
        return this.startOf(M) <= B && B <= this.endOf(M);
      }, $.isAfter = function(F, M) {
        return N(F) < this.startOf(M);
      }, $.isBefore = function(F, M) {
        return this.endOf(M) < N(F);
      }, $.$g = function(F, M, B) {
        return k.u(F) ? this[M] : this.set(B, F);
      }, $.unix = function() {
        return Math.floor(this.valueOf() / 1e3);
      }, $.valueOf = function() {
        return this.$d.getTime();
      }, $.startOf = function(F, M) {
        var B = this, X = !!k.u(M) || M, L = k.p(F), j = function(ie, oe) {
          var se = k.w(B.$u ? Date.UTC(B.$y, oe, ie) : new Date(B.$y, oe, ie), B);
          return X ? se : se.endOf(l);
        }, K = function(ie, oe) {
          return k.w(B.toDate()[ie].apply(B.toDate("s"), (X ? [0, 0, 0, 0] : [23, 59, 59, 999]).slice(oe)), B);
        }, W = this.$W, Y = this.$M, U = this.$D, Q = "set" + (this.$u ? "UTC" : "");
        switch (L) {
          case h:
            return X ? j(1, 0) : j(31, 11);
          case d:
            return X ? j(1, Y) : j(0, Y + 1);
          case c:
            var Z = this.$locale().weekStart || 0, ee = (W < Z ? W + 7 : W) - Z;
            return j(X ? U - ee : U + (6 - ee), Y);
          case l:
          case p:
            return K(Q + "Hours", 0);
          case u:
            return K(Q + "Minutes", 1);
          case s:
            return K(Q + "Seconds", 2);
          case a:
            return K(Q + "Milliseconds", 3);
          default:
            return this.clone();
        }
      }, $.endOf = function(F) {
        return this.startOf(F, !1);
      }, $.$set = function(F, M) {
        var B, X = k.p(F), L = "set" + (this.$u ? "UTC" : ""), j = (B = {}, B[l] = L + "Date", B[p] = L + "Date", B[d] = L + "Month", B[h] = L + "FullYear", B[u] = L + "Hours", B[s] = L + "Minutes", B[a] = L + "Seconds", B[o] = L + "Milliseconds", B)[X], K = X === l ? this.$D + (M - this.$W) : M;
        if (X === d || X === h) {
          var W = this.clone().set(p, 1);
          W.$d[j](K), W.init(), this.$d = W.set(p, Math.min(this.$D, W.daysInMonth())).$d;
        } else
          j && this.$d[j](K);
        return this.init(), this;
      }, $.set = function(F, M) {
        return this.clone().$set(F, M);
      }, $.get = function(F) {
        return this[k.p(F)]();
      }, $.add = function(F, M) {
        var B, X = this;
        F = Number(F);
        var L = k.p(M), j = function(Y) {
          var U = N(X);
          return k.w(U.date(U.date() + Math.round(Y * F)), X);
        };
        if (L === d)
          return this.set(d, this.$M + F);
        if (L === h)
          return this.set(h, this.$y + F);
        if (L === l)
          return j(1);
        if (L === c)
          return j(7);
        var K = (B = {}, B[s] = r, B[u] = i, B[a] = n, B)[L] || 1, W = this.$d.getTime() + F * K;
        return k.w(W, this);
      }, $.subtract = function(F, M) {
        return this.add(-1 * F, M);
      }, $.format = function(F) {
        var M = this, B = this.$locale();
        if (!this.isValid())
          return B.invalidDate || v;
        var X = F || "YYYY-MM-DDTHH:mm:ssZ", L = k.z(this), j = this.$H, K = this.$m, W = this.$M, Y = B.weekdays, U = B.months, Q = B.meridiem, Z = function(oe, se, te, ge) {
          return oe && (oe[se] || oe(M, X)) || te[se].slice(0, ge);
        }, ee = function(oe) {
          return k.s(j % 12 || 12, oe, "0");
        }, ie = Q || function(oe, se, te) {
          var ge = oe < 12 ? "AM" : "PM";
          return te ? ge.toLowerCase() : ge;
        };
        return X.replace(b, function(oe, se) {
          return se || function(te) {
            switch (te) {
              case "YY":
                return String(M.$y).slice(-2);
              case "YYYY":
                return k.s(M.$y, 4, "0");
              case "M":
                return W + 1;
              case "MM":
                return k.s(W + 1, 2, "0");
              case "MMM":
                return Z(B.monthsShort, W, U, 3);
              case "MMMM":
                return Z(U, W);
              case "D":
                return M.$D;
              case "DD":
                return k.s(M.$D, 2, "0");
              case "d":
                return String(M.$W);
              case "dd":
                return Z(B.weekdaysMin, M.$W, Y, 2);
              case "ddd":
                return Z(B.weekdaysShort, M.$W, Y, 3);
              case "dddd":
                return Y[M.$W];
              case "H":
                return String(j);
              case "HH":
                return k.s(j, 2, "0");
              case "h":
                return ee(1);
              case "hh":
                return ee(2);
              case "a":
                return ie(j, K, !0);
              case "A":
                return ie(j, K, !1);
              case "m":
                return String(K);
              case "mm":
                return k.s(K, 2, "0");
              case "s":
                return String(M.$s);
              case "ss":
                return k.s(M.$s, 2, "0");
              case "SSS":
                return k.s(M.$ms, 3, "0");
              case "Z":
                return L;
            }
            return null;
          }(oe) || L.replace(":", "");
        });
      }, $.utcOffset = function() {
        return 15 * -Math.round(this.$d.getTimezoneOffset() / 15);
      }, $.diff = function(F, M, B) {
        var X, L = this, j = k.p(M), K = N(F), W = (K.utcOffset() - this.utcOffset()) * r, Y = this - K, U = function() {
          return k.m(L, K);
        };
        switch (j) {
          case h:
            X = U() / 12;
            break;
          case d:
            X = U();
            break;
          case f:
            X = U() / 3;
            break;
          case c:
            X = (Y - W) / 6048e5;
            break;
          case l:
            X = (Y - W) / 864e5;
            break;
          case u:
            X = Y / i;
            break;
          case s:
            X = Y / r;
            break;
          case a:
            X = Y / n;
            break;
          default:
            X = Y;
        }
        return B ? X : k.a(X);
      }, $.daysInMonth = function() {
        return this.endOf(d).$D;
      }, $.$locale = function() {
        return I[this.$L];
      }, $.locale = function(F, M) {
        if (!F)
          return this.$L;
        var B = this.clone(), X = P(F, M, !0);
        return X && (B.$L = X), B;
      }, $.clone = function() {
        return k.w(this.$d, this);
      }, $.toDate = function() {
        return new Date(this.valueOf());
      }, $.toJSON = function() {
        return this.isValid() ? this.toISOString() : null;
      }, $.toISOString = function() {
        return this.$d.toISOString();
      }, $.toString = function() {
        return this.$d.toUTCString();
      }, V;
    }(), R = D.prototype;
    return N.prototype = R, [["$ms", o], ["$s", a], ["$m", s], ["$H", u], ["$W", l], ["$M", d], ["$y", h], ["$D", p]].forEach(function(V) {
      R[V[1]] = function($) {
        return this.$g($, V[0], V[1]);
      };
    }), N.extend = function(V, $) {
      return V.$i || (V($, D, N), V.$i = !0), N;
    }, N.locale = P, N.isDayjs = A, N.unix = function(V) {
      return N(1e3 * V);
    }, N.en = I[E], N.Ls = I, N.p = {}, N;
  });
})(VH);
var uc = VH.exports;
const Or = /* @__PURE__ */ qn(uc);
var BH = { exports: {} };
(function(t, e) {
  (function(n, r) {
    t.exports = r();
  })(ft, function() {
    return function(n, r) {
      var i = r.prototype, o = i.format;
      i.format = function(a) {
        var s = this, u = this.$locale();
        if (!this.isValid())
          return o.bind(this)(a);
        var l = this.$utils(), c = (a || "YYYY-MM-DDTHH:mm:ssZ").replace(/\[([^\]]+)]|Q|wo|ww|w|WW|W|zzz|z|gggg|GGGG|Do|X|x|k{1,2}|S/g, function(d) {
          switch (d) {
            case "Q":
              return Math.ceil((s.$M + 1) / 3);
            case "Do":
              return u.ordinal(s.$D);
            case "gggg":
              return s.weekYear();
            case "GGGG":
              return s.isoWeekYear();
            case "wo":
              return u.ordinal(s.week(), "W");
            case "w":
            case "ww":
              return l.s(s.week(), d === "w" ? 1 : 2, "0");
            case "W":
            case "WW":
              return l.s(s.isoWeek(), d === "W" ? 1 : 2, "0");
            case "k":
            case "kk":
              return l.s(String(s.$H === 0 ? 24 : s.$H), d === "k" ? 1 : 2, "0");
            case "X":
              return Math.floor(s.$d.getTime() / 1e3);
            case "x":
              return s.$d.getTime();
            case "z":
              return "[" + s.offsetName() + "]";
            case "zzz":
              return "[" + s.offsetName("long") + "]";
            default:
              return d;
          }
        });
        return o.bind(this)(c);
      };
    };
  });
})(BH);
var HH = BH.exports;
const wde = /* @__PURE__ */ qn(HH);
var WH = { exports: {} };
(function(t, e) {
  (function(n, r) {
    t.exports = r();
  })(ft, function() {
    var n = { LTS: "h:mm:ss A", LT: "h:mm A", L: "MM/DD/YYYY", LL: "MMMM D, YYYY", LLL: "MMMM D, YYYY h:mm A", LLLL: "dddd, MMMM D, YYYY h:mm A" }, r = /(\[[^[]*\])|([-_:/.,()\s]+)|(A|a|YYYY|YY?|MM?M?M?|Do|DD?|hh?|HH?|mm?|ss?|S{1,3}|z|ZZ?)/g, i = /\d\d/, o = /\d\d?/, a = /\d*[^-_:/,()\s\d]+/, s = {}, u = function(v) {
      return (v = +v) + (v > 68 ? 1900 : 2e3);
    }, l = function(v) {
      return function(m) {
        this[v] = +m;
      };
    }, c = [/[+-]\d\d:?(\d\d)?|Z/, function(v) {
      (this.zone || (this.zone = {})).offset = function(m) {
        if (!m || m === "Z")
          return 0;
        var b = m.match(/([+-]|\d\d)/g), y = 60 * b[1] + (+b[2] || 0);
        return y === 0 ? 0 : b[0] === "+" ? -y : y;
      }(v);
    }], d = function(v) {
      var m = s[v];
      return m && (m.indexOf ? m : m.s.concat(m.f));
    }, f = function(v, m) {
      var b, y = s.meridiem;
      if (y) {
        for (var w = 1; w <= 24; w += 1)
          if (v.indexOf(y(w, 0, m)) > -1) {
            b = w > 12;
            break;
          }
      } else
        b = v === (m ? "pm" : "PM");
      return b;
    }, h = { A: [a, function(v) {
      this.afternoon = f(v, !1);
    }], a: [a, function(v) {
      this.afternoon = f(v, !0);
    }], S: [/\d/, function(v) {
      this.milliseconds = 100 * +v;
    }], SS: [i, function(v) {
      this.milliseconds = 10 * +v;
    }], SSS: [/\d{3}/, function(v) {
      this.milliseconds = +v;
    }], s: [o, l("seconds")], ss: [o, l("seconds")], m: [o, l("minutes")], mm: [o, l("minutes")], H: [o, l("hours")], h: [o, l("hours")], HH: [o, l("hours")], hh: [o, l("hours")], D: [o, l("day")], DD: [i, l("day")], Do: [a, function(v) {
      var m = s.ordinal, b = v.match(/\d+/);
      if (this.day = b[0], m)
        for (var y = 1; y <= 31; y += 1)
          m(y).replace(/\[|\]/g, "") === v && (this.day = y);
    }], M: [o, l("month")], MM: [i, l("month")], MMM: [a, function(v) {
      var m = d("months"), b = (d("monthsShort") || m.map(function(y) {
        return y.slice(0, 3);
      })).indexOf(v) + 1;
      if (b < 1)
        throw new Error();
      this.month = b % 12 || b;
    }], MMMM: [a, function(v) {
      var m = d("months").indexOf(v) + 1;
      if (m < 1)
        throw new Error();
      this.month = m % 12 || m;
    }], Y: [/[+-]?\d+/, l("year")], YY: [i, function(v) {
      this.year = u(v);
    }], YYYY: [/\d{4}/, l("year")], Z: c, ZZ: c };
    function p(v) {
      var m, b;
      m = v, b = s && s.formats;
      for (var y = (v = m.replace(/(\[[^\]]+])|(LTS?|l{1,4}|L{1,4})/g, function(P, N, k) {
        var D = k && k.toUpperCase();
        return N || b[k] || n[k] || b[D].replace(/(\[[^\]]+])|(MMMM|MM|DD|dddd)/g, function(R, V, $) {
          return V || $.slice(1);
        });
      })).match(r), w = y.length, S = 0; S < w; S += 1) {
        var E = y[S], I = h[E], _ = I && I[0], A = I && I[1];
        y[S] = A ? { regex: _, parser: A } : E.replace(/^\[|\]$/g, "");
      }
      return function(P) {
        for (var N = {}, k = 0, D = 0; k < w; k += 1) {
          var R = y[k];
          if (typeof R == "string")
            D += R.length;
          else {
            var V = R.regex, $ = R.parser, F = P.slice(D), M = V.exec(F)[0];
            $.call(N, M), P = P.replace(M, "");
          }
        }
        return function(B) {
          var X = B.afternoon;
          if (X !== void 0) {
            var L = B.hours;
            X ? L < 12 && (B.hours += 12) : L === 12 && (B.hours = 0), delete B.afternoon;
          }
        }(N), N;
      };
    }
    return function(v, m, b) {
      b.p.customParseFormat = !0, v && v.parseTwoDigitYear && (u = v.parseTwoDigitYear);
      var y = m.prototype, w = y.parse;
      y.parse = function(S) {
        var E = S.date, I = S.utc, _ = S.args;
        this.$u = I;
        var A = _[1];
        if (typeof A == "string") {
          var P = _[2] === !0, N = _[3] === !0, k = P || N, D = _[2];
          N && (D = _[2]), s = this.$locale(), !P && D && (s = b.Ls[D]), this.$d = function(F, M, B) {
            try {
              if (["x", "X"].indexOf(M) > -1)
                return new Date((M === "X" ? 1e3 : 1) * F);
              var X = p(M)(F), L = X.year, j = X.month, K = X.day, W = X.hours, Y = X.minutes, U = X.seconds, Q = X.milliseconds, Z = X.zone, ee = /* @__PURE__ */ new Date(), ie = K || (L || j ? 1 : ee.getDate()), oe = L || ee.getFullYear(), se = 0;
              L && !j || (se = j > 0 ? j - 1 : ee.getMonth());
              var te = W || 0, ge = Y || 0, he = U || 0, fe = Q || 0;
              return Z ? new Date(Date.UTC(oe, se, ie, te, ge, he, fe + 60 * Z.offset * 1e3)) : B ? new Date(Date.UTC(oe, se, ie, te, ge, he, fe)) : new Date(oe, se, ie, te, ge, he, fe);
            } catch {
              return /* @__PURE__ */ new Date("");
            }
          }(E, A, I), this.init(), D && D !== !0 && (this.$L = this.locale(D).$L), k && E != this.format(A) && (this.$d = /* @__PURE__ */ new Date("")), s = {};
        } else if (A instanceof Array)
          for (var R = A.length, V = 1; V <= R; V += 1) {
            _[1] = A[V - 1];
            var $ = b.apply(this, _);
            if ($.isValid()) {
              this.$d = $.$d, this.$L = $.$L, this.init();
              break;
            }
            V === R && (this.$d = /* @__PURE__ */ new Date(""));
          }
        else
          w.call(this, S);
      };
    };
  });
})(WH);
var jH = WH.exports;
const Ede = /* @__PURE__ */ qn(jH);
var zH = { exports: {} };
(function(t, e) {
  (function(n, r) {
    t.exports = r();
  })(ft, function() {
    return function(n, r, i) {
      var o = r.prototype, a = function(d) {
        return d && (d.indexOf ? d : d.s);
      }, s = function(d, f, h, p, v) {
        var m = d.name ? d : d.$locale(), b = a(m[f]), y = a(m[h]), w = b || y.map(function(E) {
          return E.slice(0, p);
        });
        if (!v)
          return w;
        var S = m.weekStart;
        return w.map(function(E, I) {
          return w[(I + (S || 0)) % 7];
        });
      }, u = function() {
        return i.Ls[i.locale()];
      }, l = function(d, f) {
        return d.formats[f] || function(h) {
          return h.replace(/(\[[^\]]+])|(MMMM|MM|DD|dddd)/g, function(p, v, m) {
            return v || m.slice(1);
          });
        }(d.formats[f.toUpperCase()]);
      }, c = function() {
        var d = this;
        return { months: function(f) {
          return f ? f.format("MMMM") : s(d, "months");
        }, monthsShort: function(f) {
          return f ? f.format("MMM") : s(d, "monthsShort", "months", 3);
        }, firstDayOfWeek: function() {
          return d.$locale().weekStart || 0;
        }, weekdays: function(f) {
          return f ? f.format("dddd") : s(d, "weekdays");
        }, weekdaysMin: function(f) {
          return f ? f.format("dd") : s(d, "weekdaysMin", "weekdays", 2);
        }, weekdaysShort: function(f) {
          return f ? f.format("ddd") : s(d, "weekdaysShort", "weekdays", 3);
        }, longDateFormat: function(f) {
          return l(d.$locale(), f);
        }, meridiem: this.$locale().meridiem, ordinal: this.$locale().ordinal };
      };
      o.localeData = function() {
        return c.bind(this)();
      }, i.localeData = function() {
        var d = u();
        return { firstDayOfWeek: function() {
          return d.weekStart || 0;
        }, weekdays: function() {
          return i.weekdays();
        }, weekdaysShort: function() {
          return i.weekdaysShort();
        }, weekdaysMin: function() {
          return i.weekdaysMin();
        }, months: function() {
          return i.months();
        }, monthsShort: function() {
          return i.monthsShort();
        }, longDateFormat: function(f) {
          return l(d, f);
        }, meridiem: d.meridiem, ordinal: d.ordinal };
      }, i.months = function() {
        return s(u(), "months");
      }, i.monthsShort = function() {
        return s(u(), "monthsShort", "months", 3);
      }, i.weekdays = function(d) {
        return s(u(), "weekdays", null, null, d);
      }, i.weekdaysShort = function(d) {
        return s(u(), "weekdaysShort", "weekdays", 3, d);
      }, i.weekdaysMin = function(d) {
        return s(u(), "weekdaysMin", "weekdays", 2, d);
      };
    };
  });
})(zH);
var GH = zH.exports;
const Sde = /* @__PURE__ */ qn(GH);
var UH = { exports: {} };
(function(t, e) {
  (function(n, r) {
    t.exports = r();
  })(ft, function() {
    var n = { LTS: "h:mm:ss A", LT: "h:mm A", L: "MM/DD/YYYY", LL: "MMMM D, YYYY", LLL: "MMMM D, YYYY h:mm A", LLLL: "dddd, MMMM D, YYYY h:mm A" };
    return function(r, i, o) {
      var a = i.prototype, s = a.format;
      o.en.formats = n, a.format = function(u) {
        u === void 0 && (u = "YYYY-MM-DDTHH:mm:ssZ");
        var l = this.$locale().formats, c = function(d, f) {
          return d.replace(/(\[[^\]]+])|(LTS?|l{1,4}|L{1,4})/g, function(h, p, v) {
            var m = v && v.toUpperCase();
            return p || f[v] || n[v] || f[m].replace(/(\[[^\]]+])|(MMMM|MM|DD|dddd)/g, function(b, y, w) {
              return y || w.slice(1);
            });
          });
        }(u, l === void 0 ? {} : l);
        return s.call(this, c);
      };
    };
  });
})(UH);
var Ide = UH.exports;
const _de = /* @__PURE__ */ qn(Ide);
var XH = { exports: {} };
(function(t, e) {
  (function(n, r) {
    t.exports = r();
  })(ft, function() {
    return function(n, r, i) {
      n = n || {};
      var o = r.prototype, a = { future: "in %s", past: "%s ago", s: "a few seconds", m: "a minute", mm: "%d minutes", h: "an hour", hh: "%d hours", d: "a day", dd: "%d days", M: "a month", MM: "%d months", y: "a year", yy: "%d years" };
      function s(l, c, d, f) {
        return o.fromToBase(l, c, d, f);
      }
      i.en.relativeTime = a, o.fromToBase = function(l, c, d, f, h) {
        for (var p, v, m, b = d.$locale().relativeTime || a, y = n.thresholds || [{ l: "s", r: 44, d: "second" }, { l: "m", r: 89 }, { l: "mm", r: 44, d: "minute" }, { l: "h", r: 89 }, { l: "hh", r: 21, d: "hour" }, { l: "d", r: 35 }, { l: "dd", r: 25, d: "day" }, { l: "M", r: 45 }, { l: "MM", r: 10, d: "month" }, { l: "y", r: 17 }, { l: "yy", d: "year" }], w = y.length, S = 0; S < w; S += 1) {
          var E = y[S];
          E.d && (p = f ? i(l).diff(d, E.d, !0) : d.diff(l, E.d, !0));
          var I = (n.rounding || Math.round)(Math.abs(p));
          if (m = p > 0, I <= E.r || !E.r) {
            I <= 1 && S > 0 && (E = y[S - 1]);
            var _ = b[E.l];
            h && (I = h("" + I)), v = typeof _ == "string" ? _.replace("%d", I) : _(I, c, E.l, m);
            break;
          }
        }
        if (c)
          return v;
        var A = m ? b.future : b.past;
        return typeof A == "function" ? A(v) : A.replace("%s", v);
      }, o.to = function(l, c) {
        return s(l, c, this, !0);
      }, o.from = function(l, c) {
        return s(l, c, this);
      };
      var u = function(l) {
        return l.$u ? i.utc() : i();
      };
      o.toNow = function(l) {
        return this.to(u(this), l);
      }, o.fromNow = function(l) {
        return this.from(u(this), l);
      };
    };
  });
})(XH);
var Ade = XH.exports;
const Tde = /* @__PURE__ */ qn(Ade);
var YH = { exports: {} };
(function(t, e) {
  (function(n, r) {
    t.exports = r();
  })(ft, function() {
    return function(n, r) {
      r.prototype.weekday = function(i) {
        var o = this.$locale().weekStart || 0, a = this.$W, s = (a < o ? a + 7 : a) - o;
        return this.$utils().u(i) ? s : this.subtract(s, "day").add(i, "day");
      };
    };
  });
})(YH);
var ZH = YH.exports;
const Ode = /* @__PURE__ */ qn(ZH);
var JH = { exports: {} };
(function(t, e) {
  (function(n, r) {
    t.exports = r();
  })(ft, function() {
    var n = "week", r = "year";
    return function(i, o, a) {
      var s = o.prototype;
      s.week = function(u) {
        if (u === void 0 && (u = null), u !== null)
          return this.add(7 * (u - this.week()), "day");
        var l = this.$locale().yearStart || 1;
        if (this.month() === 11 && this.date() > 25) {
          var c = a(this).startOf(r).add(1, r).date(l), d = a(this).endOf(n);
          if (c.isBefore(d))
            return 1;
        }
        var f = a(this).startOf(r).date(l).startOf(n).subtract(1, "millisecond"), h = this.diff(f, n, !0);
        return h < 0 ? a(this).startOf("week").week() : Math.ceil(h);
      }, s.weeks = function(u) {
        return u === void 0 && (u = null), this.week(u);
      };
    };
  });
})(JH);
var KH = JH.exports;
const Pde = /* @__PURE__ */ qn(KH);
var qH = { exports: {} };
(function(t, e) {
  (function(n, r) {
    t.exports = r();
  })(ft, function() {
    return function(n, r) {
      r.prototype.weekYear = function() {
        var i = this.month(), o = this.week(), a = this.year();
        return o === 1 && i === 11 ? a + 1 : i === 0 && o >= 52 ? a - 1 : a;
      };
    };
  });
})(qH);
var QH = qH.exports;
const Nde = /* @__PURE__ */ qn(QH);
var eW = { exports: {} };
(function(t, e) {
  (function(n, r) {
    t.exports = r();
  })(ft, function() {
    var n = "day";
    return function(r, i, o) {
      var a = function(l) {
        return l.add(4 - l.isoWeekday(), n);
      }, s = i.prototype;
      s.isoWeekYear = function() {
        return a(this).year();
      }, s.isoWeek = function(l) {
        if (!this.$utils().u(l))
          return this.add(7 * (l - this.isoWeek()), n);
        var c, d, f, h, p = a(this), v = (c = this.isoWeekYear(), d = this.$u, f = (d ? o.utc : o)().year(c).startOf("year"), h = 4 - f.isoWeekday(), f.isoWeekday() > 4 && (h += 7), f.add(h, n));
        return p.diff(v, "week") + 1;
      }, s.isoWeekday = function(l) {
        return this.$utils().u(l) ? this.day() || 7 : this.day(this.day() % 7 ? l : l - 7);
      };
      var u = s.startOf;
      s.startOf = function(l, c) {
        var d = this.$utils(), f = !!d.u(c) || c;
        return d.p(l) === "isoweek" ? f ? this.date(this.date() - (this.isoWeekday() - 1)).startOf("day") : this.date(this.date() - 1 - (this.isoWeekday() - 1) + 7).endOf("day") : u.bind(this)(l, c);
      };
    };
  });
})(eW);
var kde = eW.exports;
const Rde = /* @__PURE__ */ qn(kde);
var aI = { exports: {} }, Cg = {};
/**
 * @license React
 * react-jsx-runtime.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var p7;
function $de() {
  return p7 || (p7 = 1, process.env.NODE_ENV !== "production" && function() {
    var t = O, e = Symbol.for("react.element"), n = Symbol.for("react.portal"), r = Symbol.for("react.fragment"), i = Symbol.for("react.strict_mode"), o = Symbol.for("react.profiler"), a = Symbol.for("react.provider"), s = Symbol.for("react.context"), u = Symbol.for("react.forward_ref"), l = Symbol.for("react.suspense"), c = Symbol.for("react.suspense_list"), d = Symbol.for("react.memo"), f = Symbol.for("react.lazy"), h = Symbol.for("react.offscreen"), p = Symbol.iterator, v = "@@iterator";
    function m(ue) {
      if (ue === null || typeof ue != "object")
        return null;
      var $e = p && ue[p] || ue[v];
      return typeof $e == "function" ? $e : null;
    }
    var b = t.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
    function y(ue) {
      {
        for (var $e = arguments.length, je = new Array($e > 1 ? $e - 1 : 0), At = 1; At < $e; At++)
          je[At - 1] = arguments[At];
        w("error", ue, je);
      }
    }
    function w(ue, $e, je) {
      {
        var At = b.ReactDebugCurrentFrame, $t = At.getStackAddendum();
        $t !== "" && ($e += "%s", je = je.concat([$t]));
        var qe = je.map(function(nt) {
          return String(nt);
        });
        qe.unshift("Warning: " + $e), Function.prototype.apply.call(console[ue], console, qe);
      }
    }
    var S = !1, E = !1, I = !1, _ = !1, A = !1, P;
    P = Symbol.for("react.module.reference");
    function N(ue) {
      return !!(typeof ue == "string" || typeof ue == "function" || ue === r || ue === o || A || ue === i || ue === l || ue === c || _ || ue === h || S || E || I || typeof ue == "object" && ue !== null && (ue.$$typeof === f || ue.$$typeof === d || ue.$$typeof === a || ue.$$typeof === s || ue.$$typeof === u || // This needs to include all possible module reference object
      // types supported by any Flight configuration anywhere since
      // we don't know which Flight build this will end up being used
      // with.
      ue.$$typeof === P || ue.getModuleId !== void 0));
    }
    function k(ue, $e, je) {
      var At = ue.displayName;
      if (At)
        return At;
      var $t = $e.displayName || $e.name || "";
      return $t !== "" ? je + "(" + $t + ")" : je;
    }
    function D(ue) {
      return ue.displayName || "Context";
    }
    function R(ue) {
      if (ue == null)
        return null;
      if (typeof ue.tag == "number" && y("Received an unexpected object in getComponentNameFromType(). This is likely a bug in React. Please file an issue."), typeof ue == "function")
        return ue.displayName || ue.name || null;
      if (typeof ue == "string")
        return ue;
      switch (ue) {
        case r:
          return "Fragment";
        case n:
          return "Portal";
        case o:
          return "Profiler";
        case i:
          return "StrictMode";
        case l:
          return "Suspense";
        case c:
          return "SuspenseList";
      }
      if (typeof ue == "object")
        switch (ue.$$typeof) {
          case s:
            var $e = ue;
            return D($e) + ".Consumer";
          case a:
            var je = ue;
            return D(je._context) + ".Provider";
          case u:
            return k(ue, ue.render, "ForwardRef");
          case d:
            var At = ue.displayName || null;
            return At !== null ? At : R(ue.type) || "Memo";
          case f: {
            var $t = ue, qe = $t._payload, nt = $t._init;
            try {
              return R(nt(qe));
            } catch {
              return null;
            }
          }
        }
      return null;
    }
    var V = Object.assign, $ = 0, F, M, B, X, L, j, K;
    function W() {
    }
    W.__reactDisabledLog = !0;
    function Y() {
      {
        if ($ === 0) {
          F = console.log, M = console.info, B = console.warn, X = console.error, L = console.group, j = console.groupCollapsed, K = console.groupEnd;
          var ue = {
            configurable: !0,
            enumerable: !0,
            value: W,
            writable: !0
          };
          Object.defineProperties(console, {
            info: ue,
            log: ue,
            warn: ue,
            error: ue,
            group: ue,
            groupCollapsed: ue,
            groupEnd: ue
          });
        }
        $++;
      }
    }
    function U() {
      {
        if ($--, $ === 0) {
          var ue = {
            configurable: !0,
            enumerable: !0,
            writable: !0
          };
          Object.defineProperties(console, {
            log: V({}, ue, {
              value: F
            }),
            info: V({}, ue, {
              value: M
            }),
            warn: V({}, ue, {
              value: B
            }),
            error: V({}, ue, {
              value: X
            }),
            group: V({}, ue, {
              value: L
            }),
            groupCollapsed: V({}, ue, {
              value: j
            }),
            groupEnd: V({}, ue, {
              value: K
            })
          });
        }
        $ < 0 && y("disabledDepth fell below zero. This is a bug in React. Please file an issue.");
      }
    }
    var Q = b.ReactCurrentDispatcher, Z;
    function ee(ue, $e, je) {
      {
        if (Z === void 0)
          try {
            throw Error();
          } catch ($t) {
            var At = $t.stack.trim().match(/\n( *(at )?)/);
            Z = At && At[1] || "";
          }
        return `
` + Z + ue;
      }
    }
    var ie = !1, oe;
    {
      var se = typeof WeakMap == "function" ? WeakMap : Map;
      oe = new se();
    }
    function te(ue, $e) {
      if (!ue || ie)
        return "";
      {
        var je = oe.get(ue);
        if (je !== void 0)
          return je;
      }
      var At;
      ie = !0;
      var $t = Error.prepareStackTrace;
      Error.prepareStackTrace = void 0;
      var qe;
      qe = Q.current, Q.current = null, Y();
      try {
        if ($e) {
          var nt = function() {
            throw Error();
          };
          if (Object.defineProperty(nt.prototype, "props", {
            set: function() {
              throw Error();
            }
          }), typeof Reflect == "object" && Reflect.construct) {
            try {
              Reflect.construct(nt, []);
            } catch (gr) {
              At = gr;
            }
            Reflect.construct(ue, [], nt);
          } else {
            try {
              nt.call();
            } catch (gr) {
              At = gr;
            }
            ue.call(nt.prototype);
          }
        } else {
          try {
            throw Error();
          } catch (gr) {
            At = gr;
          }
          ue();
        }
      } catch (gr) {
        if (gr && At && typeof gr.stack == "string") {
          for (var dt = gr.stack.split(`
`), rn = At.stack.split(`
`), on = dt.length - 1, Rt = rn.length - 1; on >= 1 && Rt >= 0 && dt[on] !== rn[Rt]; )
            Rt--;
          for (; on >= 1 && Rt >= 0; on--, Rt--)
            if (dt[on] !== rn[Rt]) {
              if (on !== 1 || Rt !== 1)
                do
                  if (on--, Rt--, Rt < 0 || dt[on] !== rn[Rt]) {
                    var Tt = `
` + dt[on].replace(" at new ", " at ");
                    return ue.displayName && Tt.includes("<anonymous>") && (Tt = Tt.replace("<anonymous>", ue.displayName)), typeof ue == "function" && oe.set(ue, Tt), Tt;
                  }
                while (on >= 1 && Rt >= 0);
              break;
            }
        }
      } finally {
        ie = !1, Q.current = qe, U(), Error.prepareStackTrace = $t;
      }
      var Wn = ue ? ue.displayName || ue.name : "", zr = Wn ? ee(Wn) : "";
      return typeof ue == "function" && oe.set(ue, zr), zr;
    }
    function ge(ue, $e, je) {
      return te(ue, !1);
    }
    function he(ue) {
      var $e = ue.prototype;
      return !!($e && $e.isReactComponent);
    }
    function fe(ue, $e, je) {
      if (ue == null)
        return "";
      if (typeof ue == "function")
        return te(ue, he(ue));
      if (typeof ue == "string")
        return ee(ue);
      switch (ue) {
        case l:
          return ee("Suspense");
        case c:
          return ee("SuspenseList");
      }
      if (typeof ue == "object")
        switch (ue.$$typeof) {
          case u:
            return ge(ue.render);
          case d:
            return fe(ue.type, $e, je);
          case f: {
            var At = ue, $t = At._payload, qe = At._init;
            try {
              return fe(qe($t), $e, je);
            } catch {
            }
          }
        }
      return "";
    }
    var _e = Object.prototype.hasOwnProperty, Ne = {}, ze = b.ReactDebugCurrentFrame;
    function Ve(ue) {
      if (ue) {
        var $e = ue._owner, je = fe(ue.type, ue._source, $e ? $e.type : null);
        ze.setExtraStackFrame(je);
      } else
        ze.setExtraStackFrame(null);
    }
    function ne(ue, $e, je, At, $t) {
      {
        var qe = Function.call.bind(_e);
        for (var nt in ue)
          if (qe(ue, nt)) {
            var dt = void 0;
            try {
              if (typeof ue[nt] != "function") {
                var rn = Error((At || "React class") + ": " + je + " type `" + nt + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof ue[nt] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.");
                throw rn.name = "Invariant Violation", rn;
              }
              dt = ue[nt]($e, nt, At, je, null, "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED");
            } catch (on) {
              dt = on;
            }
            dt && !(dt instanceof Error) && (Ve($t), y("%s: type specification of %s `%s` is invalid; the type checker function must return `null` or an `Error` but returned a %s. You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument).", At || "React class", je, nt, typeof dt), Ve(null)), dt instanceof Error && !(dt.message in Ne) && (Ne[dt.message] = !0, Ve($t), y("Failed %s type: %s", je, dt.message), Ve(null));
          }
      }
    }
    var pe = Array.isArray;
    function ye(ue) {
      return pe(ue);
    }
    function Ae(ue) {
      {
        var $e = typeof Symbol == "function" && Symbol.toStringTag, je = $e && ue[Symbol.toStringTag] || ue.constructor.name || "Object";
        return je;
      }
    }
    function we(ue) {
      try {
        return ce(ue), !1;
      } catch {
        return !0;
      }
    }
    function ce(ue) {
      return "" + ue;
    }
    function ve(ue) {
      if (we(ue))
        return y("The provided key is an unsupported type %s. This value must be coerced to a string before before using it here.", Ae(ue)), ce(ue);
    }
    var Ie = b.ReactCurrentOwner, q = {
      key: !0,
      ref: !0,
      __self: !0,
      __source: !0
    }, Fe, Ze, at;
    at = {};
    function Je(ue) {
      if (_e.call(ue, "ref")) {
        var $e = Object.getOwnPropertyDescriptor(ue, "ref").get;
        if ($e && $e.isReactWarning)
          return !1;
      }
      return ue.ref !== void 0;
    }
    function ut(ue) {
      if (_e.call(ue, "key")) {
        var $e = Object.getOwnPropertyDescriptor(ue, "key").get;
        if ($e && $e.isReactWarning)
          return !1;
      }
      return ue.key !== void 0;
    }
    function Ct(ue, $e) {
      if (typeof ue.ref == "string" && Ie.current && $e && Ie.current.stateNode !== $e) {
        var je = R(Ie.current.type);
        at[je] || (y('Component "%s" contains the string ref "%s". Support for string refs will be removed in a future major release. This case cannot be automatically converted to an arrow function. We ask you to manually fix this case by using useRef() or createRef() instead. Learn more about using refs safely here: https://reactjs.org/link/strict-mode-string-ref', R(Ie.current.type), ue.ref), at[je] = !0);
      }
    }
    function Ke(ue, $e) {
      {
        var je = function() {
          Fe || (Fe = !0, y("%s: `key` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", $e));
        };
        je.isReactWarning = !0, Object.defineProperty(ue, "key", {
          get: je,
          configurable: !0
        });
      }
    }
    function st(ue, $e) {
      {
        var je = function() {
          Ze || (Ze = !0, y("%s: `ref` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", $e));
        };
        je.isReactWarning = !0, Object.defineProperty(ue, "ref", {
          get: je,
          configurable: !0
        });
      }
    }
    var wt = function(ue, $e, je, At, $t, qe, nt) {
      var dt = {
        // This tag allows us to uniquely identify this as a React Element
        $$typeof: e,
        // Built-in properties that belong on the element
        type: ue,
        key: $e,
        ref: je,
        props: nt,
        // Record the component responsible for creating this element.
        _owner: qe
      };
      return dt._store = {}, Object.defineProperty(dt._store, "validated", {
        configurable: !1,
        enumerable: !1,
        writable: !0,
        value: !1
      }), Object.defineProperty(dt, "_self", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: At
      }), Object.defineProperty(dt, "_source", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: $t
      }), Object.freeze && (Object.freeze(dt.props), Object.freeze(dt)), dt;
    };
    function qt(ue, $e, je, At, $t) {
      {
        var qe, nt = {}, dt = null, rn = null;
        je !== void 0 && (ve(je), dt = "" + je), ut($e) && (ve($e.key), dt = "" + $e.key), Je($e) && (rn = $e.ref, Ct($e, $t));
        for (qe in $e)
          _e.call($e, qe) && !q.hasOwnProperty(qe) && (nt[qe] = $e[qe]);
        if (ue && ue.defaultProps) {
          var on = ue.defaultProps;
          for (qe in on)
            nt[qe] === void 0 && (nt[qe] = on[qe]);
        }
        if (dt || rn) {
          var Rt = typeof ue == "function" ? ue.displayName || ue.name || "Unknown" : ue;
          dt && Ke(nt, Rt), rn && st(nt, Rt);
        }
        return wt(ue, dt, rn, $t, At, Ie.current, nt);
      }
    }
    var bt = b.ReactCurrentOwner, Me = b.ReactDebugCurrentFrame;
    function yt(ue) {
      if (ue) {
        var $e = ue._owner, je = fe(ue.type, ue._source, $e ? $e.type : null);
        Me.setExtraStackFrame(je);
      } else
        Me.setExtraStackFrame(null);
    }
    var ct;
    ct = !1;
    function kt(ue) {
      return typeof ue == "object" && ue !== null && ue.$$typeof === e;
    }
    function Vt() {
      {
        if (bt.current) {
          var ue = R(bt.current.type);
          if (ue)
            return `

Check the render method of \`` + ue + "`.";
        }
        return "";
      }
    }
    function Vn(ue) {
      {
        if (ue !== void 0) {
          var $e = ue.fileName.replace(/^.*[\\\/]/, ""), je = ue.lineNumber;
          return `

Check your code at ` + $e + ":" + je + ".";
        }
        return "";
      }
    }
    var tn = {};
    function Xe(ue) {
      {
        var $e = Vt();
        if (!$e) {
          var je = typeof ue == "string" ? ue : ue.displayName || ue.name;
          je && ($e = `

Check the top-level render call using <` + je + ">.");
        }
        return $e;
      }
    }
    function tt(ue, $e) {
      {
        if (!ue._store || ue._store.validated || ue.key != null)
          return;
        ue._store.validated = !0;
        var je = Xe($e);
        if (tn[je])
          return;
        tn[je] = !0;
        var At = "";
        ue && ue._owner && ue._owner !== bt.current && (At = " It was passed a child from " + R(ue._owner.type) + "."), yt(ue), y('Each child in a list should have a unique "key" prop.%s%s See https://reactjs.org/link/warning-keys for more information.', je, At), yt(null);
      }
    }
    function ot(ue, $e) {
      {
        if (typeof ue != "object")
          return;
        if (ye(ue))
          for (var je = 0; je < ue.length; je++) {
            var At = ue[je];
            kt(At) && tt(At, $e);
          }
        else if (kt(ue))
          ue._store && (ue._store.validated = !0);
        else if (ue) {
          var $t = m(ue);
          if (typeof $t == "function" && $t !== ue.entries)
            for (var qe = $t.call(ue), nt; !(nt = qe.next()).done; )
              kt(nt.value) && tt(nt.value, $e);
        }
      }
    }
    function lt(ue) {
      {
        var $e = ue.type;
        if ($e == null || typeof $e == "string")
          return;
        var je;
        if (typeof $e == "function")
          je = $e.propTypes;
        else if (typeof $e == "object" && ($e.$$typeof === u || // Note: Memo only checks outer props here.
        // Inner props are checked in the reconciler.
        $e.$$typeof === d))
          je = $e.propTypes;
        else
          return;
        if (je) {
          var At = R($e);
          ne(je, ue.props, "prop", At, ue);
        } else if ($e.PropTypes !== void 0 && !ct) {
          ct = !0;
          var $t = R($e);
          y("Component %s declared `PropTypes` instead of `propTypes`. Did you misspell the property assignment?", $t || "Unknown");
        }
        typeof $e.getDefaultProps == "function" && !$e.getDefaultProps.isReactClassApproved && y("getDefaultProps is only used on classic React.createClass definitions. Use a static property named `defaultProps` instead.");
      }
    }
    function He(ue) {
      {
        for (var $e = Object.keys(ue.props), je = 0; je < $e.length; je++) {
          var At = $e[je];
          if (At !== "children" && At !== "key") {
            yt(ue), y("Invalid prop `%s` supplied to `React.Fragment`. React.Fragment can only have `key` and `children` props.", At), yt(null);
            break;
          }
        }
        ue.ref !== null && (yt(ue), y("Invalid attribute `ref` supplied to `React.Fragment`."), yt(null));
      }
    }
    function mt(ue, $e, je, At, $t, qe) {
      {
        var nt = N(ue);
        if (!nt) {
          var dt = "";
          (ue === void 0 || typeof ue == "object" && ue !== null && Object.keys(ue).length === 0) && (dt += " You likely forgot to export your component from the file it's defined in, or you might have mixed up default and named imports.");
          var rn = Vn($t);
          rn ? dt += rn : dt += Vt();
          var on;
          ue === null ? on = "null" : ye(ue) ? on = "array" : ue !== void 0 && ue.$$typeof === e ? (on = "<" + (R(ue.type) || "Unknown") + " />", dt = " Did you accidentally export a JSX literal instead of a component?") : on = typeof ue, y("React.jsx: type is invalid -- expected a string (for built-in components) or a class/function (for composite components) but got: %s.%s", on, dt);
        }
        var Rt = qt(ue, $e, je, $t, qe);
        if (Rt == null)
          return Rt;
        if (nt) {
          var Tt = $e.children;
          if (Tt !== void 0)
            if (At)
              if (ye(Tt)) {
                for (var Wn = 0; Wn < Tt.length; Wn++)
                  ot(Tt[Wn], ue);
                Object.freeze && Object.freeze(Tt);
              } else
                y("React.jsx: Static children should always be an array. You are likely explicitly calling React.jsxs or React.jsxDEV. Use the Babel transform instead.");
            else
              ot(Tt, ue);
        }
        return ue === r ? He(Rt) : lt(Rt), Rt;
      }
    }
    function Qt(ue, $e, je) {
      return mt(ue, $e, je, !0);
    }
    function Yt(ue, $e, je) {
      return mt(ue, $e, je, !1);
    }
    var nn = Yt, Nt = Qt;
    Cg.Fragment = r, Cg.jsx = nn, Cg.jsxs = Nt;
  }()), Cg;
}
var wg = {};
/**
 * @license React
 * react-jsx-runtime.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var g7;
function Dde() {
  if (g7)
    return wg;
  g7 = 1;
  var t = O, e = Symbol.for("react.element"), n = Symbol.for("react.fragment"), r = Object.prototype.hasOwnProperty, i = t.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, o = { key: !0, ref: !0, __self: !0, __source: !0 };
  function a(s, u, l) {
    var c, d = {}, f = null, h = null;
    l !== void 0 && (f = "" + l), u.key !== void 0 && (f = "" + u.key), u.ref !== void 0 && (h = u.ref);
    for (c in u)
      r.call(u, c) && !o.hasOwnProperty(c) && (d[c] = u[c]);
    if (s && s.defaultProps)
      for (c in u = s.defaultProps, u)
        d[c] === void 0 && (d[c] = u[c]);
    return { $$typeof: e, type: s, key: f, ref: h, props: d, _owner: i.current };
  }
  return wg.Fragment = n, wg.jsx = a, wg.jsxs = a, wg;
}
process.env.NODE_ENV === "production" ? aI.exports = Dde() : aI.exports = $de();
var Oe = aI.exports, Mde = /* @__PURE__ */ oi({});
const G6 = Mde;
function _t(t) {
  "@babel/helpers - typeof";
  return _t = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(e) {
    return typeof e;
  } : function(e) {
    return e && typeof Symbol == "function" && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
  }, _t(t);
}
function Fde(t, e) {
  if (_t(t) !== "object" || t === null)
    return t;
  var n = t[Symbol.toPrimitive];
  if (n !== void 0) {
    var r = n.call(t, e || "default");
    if (_t(r) !== "object")
      return r;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (e === "string" ? String : Number)(t);
}
function tW(t) {
  var e = Fde(t, "string");
  return _t(e) === "symbol" ? e : String(e);
}
function z(t, e, n) {
  return e = tW(e), e in t ? Object.defineProperty(t, e, {
    value: n,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : t[e] = n, t;
}
function m7(t, e) {
  var n = Object.keys(t);
  if (Object.getOwnPropertySymbols) {
    var r = Object.getOwnPropertySymbols(t);
    e && (r = r.filter(function(i) {
      return Object.getOwnPropertyDescriptor(t, i).enumerable;
    })), n.push.apply(n, r);
  }
  return n;
}
function de(t) {
  for (var e = 1; e < arguments.length; e++) {
    var n = arguments[e] != null ? arguments[e] : {};
    e % 2 ? m7(Object(n), !0).forEach(function(r) {
      z(t, r, n[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(t, Object.getOwnPropertyDescriptors(n)) : m7(Object(n)).forEach(function(r) {
      Object.defineProperty(t, r, Object.getOwnPropertyDescriptor(n, r));
    });
  }
  return t;
}
function nW(t) {
  if (Array.isArray(t))
    return t;
}
function Lde(t, e) {
  var n = t == null ? null : typeof Symbol < "u" && t[Symbol.iterator] || t["@@iterator"];
  if (n != null) {
    var r, i, o, a, s = [], u = !0, l = !1;
    try {
      if (o = (n = n.call(t)).next, e === 0) {
        if (Object(n) !== n)
          return;
        u = !1;
      } else
        for (; !(u = (r = o.call(n)).done) && (s.push(r.value), s.length !== e); u = !0)
          ;
    } catch (c) {
      l = !0, i = c;
    } finally {
      try {
        if (!u && n.return != null && (a = n.return(), Object(a) !== a))
          return;
      } finally {
        if (l)
          throw i;
      }
    }
    return s;
  }
}
function sI(t, e) {
  (e == null || e > t.length) && (e = t.length);
  for (var n = 0, r = new Array(e); n < e; n++)
    r[n] = t[n];
  return r;
}
function U6(t, e) {
  if (t) {
    if (typeof t == "string")
      return sI(t, e);
    var n = Object.prototype.toString.call(t).slice(8, -1);
    if (n === "Object" && t.constructor && (n = t.constructor.name), n === "Map" || n === "Set")
      return Array.from(t);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n))
      return sI(t, e);
  }
}
function rW() {
  throw new TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function be(t, e) {
  return nW(t) || Lde(t, e) || U6(t, e) || rW();
}
function ws(t, e) {
  if (t == null)
    return {};
  var n = {}, r = Object.keys(t), i, o;
  for (o = 0; o < r.length; o++)
    i = r[o], !(e.indexOf(i) >= 0) && (n[i] = t[i]);
  return n;
}
function Gt(t, e) {
  if (t == null)
    return {};
  var n = ws(t, e), r, i;
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(t);
    for (i = 0; i < o.length; i++)
      r = o[i], !(e.indexOf(r) >= 0) && Object.prototype.propertyIsEnumerable.call(t, r) && (n[r] = t[r]);
  }
  return n;
}
var iW = { exports: {} };
/*!
	Copyright (c) 2018 Jed Watson.
	Licensed under the MIT License (MIT), see
	http://jedwatson.github.io/classnames
*/
(function(t) {
  (function() {
    var e = {}.hasOwnProperty;
    function n() {
      for (var r = [], i = 0; i < arguments.length; i++) {
        var o = arguments[i];
        if (o) {
          var a = typeof o;
          if (a === "string" || a === "number")
            r.push(o);
          else if (Array.isArray(o)) {
            if (o.length) {
              var s = n.apply(null, o);
              s && r.push(s);
            }
          } else if (a === "object") {
            if (o.toString !== Object.prototype.toString && !o.toString.toString().includes("[native code]")) {
              r.push(o.toString());
              continue;
            }
            for (var u in o)
              e.call(o, u) && o[u] && r.push(u);
          }
        }
      }
      return r.join(" ");
    }
    t.exports ? (n.default = n, t.exports = n) : window.classNames = n;
  })();
})(iW);
var Vde = iW.exports;
const Ce = /* @__PURE__ */ qn(Vde);
function Wi(t, e) {
  Bde(t) && (t = "100%");
  var n = Hde(t);
  return t = e === 360 ? t : Math.min(e, Math.max(0, parseFloat(t))), n && (t = parseInt(String(t * e), 10) / 100), Math.abs(t - e) < 1e-6 ? 1 : (e === 360 ? t = (t < 0 ? t % e + e : t % e) / parseFloat(String(e)) : t = t % e / parseFloat(String(e)), t);
}
function F1(t) {
  return Math.min(1, Math.max(0, t));
}
function Bde(t) {
  return typeof t == "string" && t.indexOf(".") !== -1 && parseFloat(t) === 1;
}
function Hde(t) {
  return typeof t == "string" && t.indexOf("%") !== -1;
}
function oW(t) {
  return t = parseFloat(t), (isNaN(t) || t < 0 || t > 1) && (t = 1), t;
}
function L1(t) {
  return t <= 1 ? "".concat(Number(t) * 100, "%") : t;
}
function ld(t) {
  return t.length === 1 ? "0" + t : String(t);
}
function Wde(t, e, n) {
  return {
    r: Wi(t, 255) * 255,
    g: Wi(e, 255) * 255,
    b: Wi(n, 255) * 255
  };
}
function v7(t, e, n) {
  t = Wi(t, 255), e = Wi(e, 255), n = Wi(n, 255);
  var r = Math.max(t, e, n), i = Math.min(t, e, n), o = 0, a = 0, s = (r + i) / 2;
  if (r === i)
    a = 0, o = 0;
  else {
    var u = r - i;
    switch (a = s > 0.5 ? u / (2 - r - i) : u / (r + i), r) {
      case t:
        o = (e - n) / u + (e < n ? 6 : 0);
        break;
      case e:
        o = (n - t) / u + 2;
        break;
      case n:
        o = (t - e) / u + 4;
        break;
    }
    o /= 6;
  }
  return { h: o, s: a, l: s };
}
function SS(t, e, n) {
  return n < 0 && (n += 1), n > 1 && (n -= 1), n < 1 / 6 ? t + (e - t) * (6 * n) : n < 1 / 2 ? e : n < 2 / 3 ? t + (e - t) * (2 / 3 - n) * 6 : t;
}
function jde(t, e, n) {
  var r, i, o;
  if (t = Wi(t, 360), e = Wi(e, 100), n = Wi(n, 100), e === 0)
    i = n, o = n, r = n;
  else {
    var a = n < 0.5 ? n * (1 + e) : n + e - n * e, s = 2 * n - a;
    r = SS(s, a, t + 1 / 3), i = SS(s, a, t), o = SS(s, a, t - 1 / 3);
  }
  return { r: r * 255, g: i * 255, b: o * 255 };
}
function uI(t, e, n) {
  t = Wi(t, 255), e = Wi(e, 255), n = Wi(n, 255);
  var r = Math.max(t, e, n), i = Math.min(t, e, n), o = 0, a = r, s = r - i, u = r === 0 ? 0 : s / r;
  if (r === i)
    o = 0;
  else {
    switch (r) {
      case t:
        o = (e - n) / s + (e < n ? 6 : 0);
        break;
      case e:
        o = (n - t) / s + 2;
        break;
      case n:
        o = (t - e) / s + 4;
        break;
    }
    o /= 6;
  }
  return { h: o, s: u, v: a };
}
function zde(t, e, n) {
  t = Wi(t, 360) * 6, e = Wi(e, 100), n = Wi(n, 100);
  var r = Math.floor(t), i = t - r, o = n * (1 - e), a = n * (1 - i * e), s = n * (1 - (1 - i) * e), u = r % 6, l = [n, a, o, o, s, n][u], c = [s, n, n, a, o, o][u], d = [o, o, s, n, n, a][u];
  return { r: l * 255, g: c * 255, b: d * 255 };
}
function lI(t, e, n, r) {
  var i = [
    ld(Math.round(t).toString(16)),
    ld(Math.round(e).toString(16)),
    ld(Math.round(n).toString(16))
  ];
  return r && i[0].startsWith(i[0].charAt(1)) && i[1].startsWith(i[1].charAt(1)) && i[2].startsWith(i[2].charAt(1)) ? i[0].charAt(0) + i[1].charAt(0) + i[2].charAt(0) : i.join("");
}
function Gde(t, e, n, r, i) {
  var o = [
    ld(Math.round(t).toString(16)),
    ld(Math.round(e).toString(16)),
    ld(Math.round(n).toString(16)),
    ld(Ude(r))
  ];
  return i && o[0].startsWith(o[0].charAt(1)) && o[1].startsWith(o[1].charAt(1)) && o[2].startsWith(o[2].charAt(1)) && o[3].startsWith(o[3].charAt(1)) ? o[0].charAt(0) + o[1].charAt(0) + o[2].charAt(0) + o[3].charAt(0) : o.join("");
}
function Ude(t) {
  return Math.round(parseFloat(t) * 255).toString(16);
}
function b7(t) {
  return qo(t) / 255;
}
function qo(t) {
  return parseInt(t, 16);
}
function Xde(t) {
  return {
    r: t >> 16,
    g: (t & 65280) >> 8,
    b: t & 255
  };
}
var cI = {
  aliceblue: "#f0f8ff",
  antiquewhite: "#faebd7",
  aqua: "#00ffff",
  aquamarine: "#7fffd4",
  azure: "#f0ffff",
  beige: "#f5f5dc",
  bisque: "#ffe4c4",
  black: "#000000",
  blanchedalmond: "#ffebcd",
  blue: "#0000ff",
  blueviolet: "#8a2be2",
  brown: "#a52a2a",
  burlywood: "#deb887",
  cadetblue: "#5f9ea0",
  chartreuse: "#7fff00",
  chocolate: "#d2691e",
  coral: "#ff7f50",
  cornflowerblue: "#6495ed",
  cornsilk: "#fff8dc",
  crimson: "#dc143c",
  cyan: "#00ffff",
  darkblue: "#00008b",
  darkcyan: "#008b8b",
  darkgoldenrod: "#b8860b",
  darkgray: "#a9a9a9",
  darkgreen: "#006400",
  darkgrey: "#a9a9a9",
  darkkhaki: "#bdb76b",
  darkmagenta: "#8b008b",
  darkolivegreen: "#556b2f",
  darkorange: "#ff8c00",
  darkorchid: "#9932cc",
  darkred: "#8b0000",
  darksalmon: "#e9967a",
  darkseagreen: "#8fbc8f",
  darkslateblue: "#483d8b",
  darkslategray: "#2f4f4f",
  darkslategrey: "#2f4f4f",
  darkturquoise: "#00ced1",
  darkviolet: "#9400d3",
  deeppink: "#ff1493",
  deepskyblue: "#00bfff",
  dimgray: "#696969",
  dimgrey: "#696969",
  dodgerblue: "#1e90ff",
  firebrick: "#b22222",
  floralwhite: "#fffaf0",
  forestgreen: "#228b22",
  fuchsia: "#ff00ff",
  gainsboro: "#dcdcdc",
  ghostwhite: "#f8f8ff",
  goldenrod: "#daa520",
  gold: "#ffd700",
  gray: "#808080",
  green: "#008000",
  greenyellow: "#adff2f",
  grey: "#808080",
  honeydew: "#f0fff0",
  hotpink: "#ff69b4",
  indianred: "#cd5c5c",
  indigo: "#4b0082",
  ivory: "#fffff0",
  khaki: "#f0e68c",
  lavenderblush: "#fff0f5",
  lavender: "#e6e6fa",
  lawngreen: "#7cfc00",
  lemonchiffon: "#fffacd",
  lightblue: "#add8e6",
  lightcoral: "#f08080",
  lightcyan: "#e0ffff",
  lightgoldenrodyellow: "#fafad2",
  lightgray: "#d3d3d3",
  lightgreen: "#90ee90",
  lightgrey: "#d3d3d3",
  lightpink: "#ffb6c1",
  lightsalmon: "#ffa07a",
  lightseagreen: "#20b2aa",
  lightskyblue: "#87cefa",
  lightslategray: "#778899",
  lightslategrey: "#778899",
  lightsteelblue: "#b0c4de",
  lightyellow: "#ffffe0",
  lime: "#00ff00",
  limegreen: "#32cd32",
  linen: "#faf0e6",
  magenta: "#ff00ff",
  maroon: "#800000",
  mediumaquamarine: "#66cdaa",
  mediumblue: "#0000cd",
  mediumorchid: "#ba55d3",
  mediumpurple: "#9370db",
  mediumseagreen: "#3cb371",
  mediumslateblue: "#7b68ee",
  mediumspringgreen: "#00fa9a",
  mediumturquoise: "#48d1cc",
  mediumvioletred: "#c71585",
  midnightblue: "#191970",
  mintcream: "#f5fffa",
  mistyrose: "#ffe4e1",
  moccasin: "#ffe4b5",
  navajowhite: "#ffdead",
  navy: "#000080",
  oldlace: "#fdf5e6",
  olive: "#808000",
  olivedrab: "#6b8e23",
  orange: "#ffa500",
  orangered: "#ff4500",
  orchid: "#da70d6",
  palegoldenrod: "#eee8aa",
  palegreen: "#98fb98",
  paleturquoise: "#afeeee",
  palevioletred: "#db7093",
  papayawhip: "#ffefd5",
  peachpuff: "#ffdab9",
  peru: "#cd853f",
  pink: "#ffc0cb",
  plum: "#dda0dd",
  powderblue: "#b0e0e6",
  purple: "#800080",
  rebeccapurple: "#663399",
  red: "#ff0000",
  rosybrown: "#bc8f8f",
  royalblue: "#4169e1",
  saddlebrown: "#8b4513",
  salmon: "#fa8072",
  sandybrown: "#f4a460",
  seagreen: "#2e8b57",
  seashell: "#fff5ee",
  sienna: "#a0522d",
  silver: "#c0c0c0",
  skyblue: "#87ceeb",
  slateblue: "#6a5acd",
  slategray: "#708090",
  slategrey: "#708090",
  snow: "#fffafa",
  springgreen: "#00ff7f",
  steelblue: "#4682b4",
  tan: "#d2b48c",
  teal: "#008080",
  thistle: "#d8bfd8",
  tomato: "#ff6347",
  turquoise: "#40e0d0",
  violet: "#ee82ee",
  wheat: "#f5deb3",
  white: "#ffffff",
  whitesmoke: "#f5f5f5",
  yellow: "#ffff00",
  yellowgreen: "#9acd32"
};
function qf(t) {
  var e = { r: 0, g: 0, b: 0 }, n = 1, r = null, i = null, o = null, a = !1, s = !1;
  return typeof t == "string" && (t = Jde(t)), typeof t == "object" && (Du(t.r) && Du(t.g) && Du(t.b) ? (e = Wde(t.r, t.g, t.b), a = !0, s = String(t.r).substr(-1) === "%" ? "prgb" : "rgb") : Du(t.h) && Du(t.s) && Du(t.v) ? (r = L1(t.s), i = L1(t.v), e = zde(t.h, r, i), a = !0, s = "hsv") : Du(t.h) && Du(t.s) && Du(t.l) && (r = L1(t.s), o = L1(t.l), e = jde(t.h, r, o), a = !0, s = "hsl"), Object.prototype.hasOwnProperty.call(t, "a") && (n = t.a)), n = oW(n), {
    ok: a,
    format: t.format || s,
    r: Math.min(255, Math.max(e.r, 0)),
    g: Math.min(255, Math.max(e.g, 0)),
    b: Math.min(255, Math.max(e.b, 0)),
    a: n
  };
}
var Yde = "[-\\+]?\\d+%?", Zde = "[-\\+]?\\d*\\.\\d+%?", Ul = "(?:".concat(Zde, ")|(?:").concat(Yde, ")"), IS = "[\\s|\\(]+(".concat(Ul, ")[,|\\s]+(").concat(Ul, ")[,|\\s]+(").concat(Ul, ")\\s*\\)?"), _S = "[\\s|\\(]+(".concat(Ul, ")[,|\\s]+(").concat(Ul, ")[,|\\s]+(").concat(Ul, ")[,|\\s]+(").concat(Ul, ")\\s*\\)?"), ls = {
  CSS_UNIT: new RegExp(Ul),
  rgb: new RegExp("rgb" + IS),
  rgba: new RegExp("rgba" + _S),
  hsl: new RegExp("hsl" + IS),
  hsla: new RegExp("hsla" + _S),
  hsv: new RegExp("hsv" + IS),
  hsva: new RegExp("hsva" + _S),
  hex3: /^#?([0-9a-fA-F]{1})([0-9a-fA-F]{1})([0-9a-fA-F]{1})$/,
  hex6: /^#?([0-9a-fA-F]{2})([0-9a-fA-F]{2})([0-9a-fA-F]{2})$/,
  hex4: /^#?([0-9a-fA-F]{1})([0-9a-fA-F]{1})([0-9a-fA-F]{1})([0-9a-fA-F]{1})$/,
  hex8: /^#?([0-9a-fA-F]{2})([0-9a-fA-F]{2})([0-9a-fA-F]{2})([0-9a-fA-F]{2})$/
};
function Jde(t) {
  if (t = t.trim().toLowerCase(), t.length === 0)
    return !1;
  var e = !1;
  if (cI[t])
    t = cI[t], e = !0;
  else if (t === "transparent")
    return { r: 0, g: 0, b: 0, a: 0, format: "name" };
  var n = ls.rgb.exec(t);
  return n ? { r: n[1], g: n[2], b: n[3] } : (n = ls.rgba.exec(t), n ? { r: n[1], g: n[2], b: n[3], a: n[4] } : (n = ls.hsl.exec(t), n ? { h: n[1], s: n[2], l: n[3] } : (n = ls.hsla.exec(t), n ? { h: n[1], s: n[2], l: n[3], a: n[4] } : (n = ls.hsv.exec(t), n ? { h: n[1], s: n[2], v: n[3] } : (n = ls.hsva.exec(t), n ? { h: n[1], s: n[2], v: n[3], a: n[4] } : (n = ls.hex8.exec(t), n ? {
    r: qo(n[1]),
    g: qo(n[2]),
    b: qo(n[3]),
    a: b7(n[4]),
    format: e ? "name" : "hex8"
  } : (n = ls.hex6.exec(t), n ? {
    r: qo(n[1]),
    g: qo(n[2]),
    b: qo(n[3]),
    format: e ? "name" : "hex"
  } : (n = ls.hex4.exec(t), n ? {
    r: qo(n[1] + n[1]),
    g: qo(n[2] + n[2]),
    b: qo(n[3] + n[3]),
    a: b7(n[4] + n[4]),
    format: e ? "name" : "hex8"
  } : (n = ls.hex3.exec(t), n ? {
    r: qo(n[1] + n[1]),
    g: qo(n[2] + n[2]),
    b: qo(n[3] + n[3]),
    format: e ? "name" : "hex"
  } : !1)))))))));
}
function Du(t) {
  return !!ls.CSS_UNIT.exec(String(t));
}
var AS = (
  /** @class */
  function() {
    function t(e, n) {
      e === void 0 && (e = ""), n === void 0 && (n = {});
      var r;
      if (e instanceof t)
        return e;
      typeof e == "number" && (e = Xde(e)), this.originalInput = e;
      var i = qf(e);
      this.originalInput = e, this.r = i.r, this.g = i.g, this.b = i.b, this.a = i.a, this.roundA = Math.round(100 * this.a) / 100, this.format = (r = n.format) !== null && r !== void 0 ? r : i.format, this.gradientType = n.gradientType, this.r < 1 && (this.r = Math.round(this.r)), this.g < 1 && (this.g = Math.round(this.g)), this.b < 1 && (this.b = Math.round(this.b)), this.isValid = i.ok;
    }
    return t.prototype.isDark = function() {
      return this.getBrightness() < 128;
    }, t.prototype.isLight = function() {
      return !this.isDark();
    }, t.prototype.getBrightness = function() {
      var e = this.toRgb();
      return (e.r * 299 + e.g * 587 + e.b * 114) / 1e3;
    }, t.prototype.getLuminance = function() {
      var e = this.toRgb(), n, r, i, o = e.r / 255, a = e.g / 255, s = e.b / 255;
      return o <= 0.03928 ? n = o / 12.92 : n = Math.pow((o + 0.055) / 1.055, 2.4), a <= 0.03928 ? r = a / 12.92 : r = Math.pow((a + 0.055) / 1.055, 2.4), s <= 0.03928 ? i = s / 12.92 : i = Math.pow((s + 0.055) / 1.055, 2.4), 0.2126 * n + 0.7152 * r + 0.0722 * i;
    }, t.prototype.getAlpha = function() {
      return this.a;
    }, t.prototype.setAlpha = function(e) {
      return this.a = oW(e), this.roundA = Math.round(100 * this.a) / 100, this;
    }, t.prototype.isMonochrome = function() {
      var e = this.toHsl().s;
      return e === 0;
    }, t.prototype.toHsv = function() {
      var e = uI(this.r, this.g, this.b);
      return { h: e.h * 360, s: e.s, v: e.v, a: this.a };
    }, t.prototype.toHsvString = function() {
      var e = uI(this.r, this.g, this.b), n = Math.round(e.h * 360), r = Math.round(e.s * 100), i = Math.round(e.v * 100);
      return this.a === 1 ? "hsv(".concat(n, ", ").concat(r, "%, ").concat(i, "%)") : "hsva(".concat(n, ", ").concat(r, "%, ").concat(i, "%, ").concat(this.roundA, ")");
    }, t.prototype.toHsl = function() {
      var e = v7(this.r, this.g, this.b);
      return { h: e.h * 360, s: e.s, l: e.l, a: this.a };
    }, t.prototype.toHslString = function() {
      var e = v7(this.r, this.g, this.b), n = Math.round(e.h * 360), r = Math.round(e.s * 100), i = Math.round(e.l * 100);
      return this.a === 1 ? "hsl(".concat(n, ", ").concat(r, "%, ").concat(i, "%)") : "hsla(".concat(n, ", ").concat(r, "%, ").concat(i, "%, ").concat(this.roundA, ")");
    }, t.prototype.toHex = function(e) {
      return e === void 0 && (e = !1), lI(this.r, this.g, this.b, e);
    }, t.prototype.toHexString = function(e) {
      return e === void 0 && (e = !1), "#" + this.toHex(e);
    }, t.prototype.toHex8 = function(e) {
      return e === void 0 && (e = !1), Gde(this.r, this.g, this.b, this.a, e);
    }, t.prototype.toHex8String = function(e) {
      return e === void 0 && (e = !1), "#" + this.toHex8(e);
    }, t.prototype.toHexShortString = function(e) {
      return e === void 0 && (e = !1), this.a === 1 ? this.toHexString(e) : this.toHex8String(e);
    }, t.prototype.toRgb = function() {
      return {
        r: Math.round(this.r),
        g: Math.round(this.g),
        b: Math.round(this.b),
        a: this.a
      };
    }, t.prototype.toRgbString = function() {
      var e = Math.round(this.r), n = Math.round(this.g), r = Math.round(this.b);
      return this.a === 1 ? "rgb(".concat(e, ", ").concat(n, ", ").concat(r, ")") : "rgba(".concat(e, ", ").concat(n, ", ").concat(r, ", ").concat(this.roundA, ")");
    }, t.prototype.toPercentageRgb = function() {
      var e = function(n) {
        return "".concat(Math.round(Wi(n, 255) * 100), "%");
      };
      return {
        r: e(this.r),
        g: e(this.g),
        b: e(this.b),
        a: this.a
      };
    }, t.prototype.toPercentageRgbString = function() {
      var e = function(n) {
        return Math.round(Wi(n, 255) * 100);
      };
      return this.a === 1 ? "rgb(".concat(e(this.r), "%, ").concat(e(this.g), "%, ").concat(e(this.b), "%)") : "rgba(".concat(e(this.r), "%, ").concat(e(this.g), "%, ").concat(e(this.b), "%, ").concat(this.roundA, ")");
    }, t.prototype.toName = function() {
      if (this.a === 0)
        return "transparent";
      if (this.a < 1)
        return !1;
      for (var e = "#" + lI(this.r, this.g, this.b, !1), n = 0, r = Object.entries(cI); n < r.length; n++) {
        var i = r[n], o = i[0], a = i[1];
        if (e === a)
          return o;
      }
      return !1;
    }, t.prototype.toString = function(e) {
      var n = !!e;
      e = e ?? this.format;
      var r = !1, i = this.a < 1 && this.a >= 0, o = !n && i && (e.startsWith("hex") || e === "name");
      return o ? e === "name" && this.a === 0 ? this.toName() : this.toRgbString() : (e === "rgb" && (r = this.toRgbString()), e === "prgb" && (r = this.toPercentageRgbString()), (e === "hex" || e === "hex6") && (r = this.toHexString()), e === "hex3" && (r = this.toHexString(!0)), e === "hex4" && (r = this.toHex8String(!0)), e === "hex8" && (r = this.toHex8String()), e === "name" && (r = this.toName()), e === "hsl" && (r = this.toHslString()), e === "hsv" && (r = this.toHsvString()), r || this.toHexString());
    }, t.prototype.toNumber = function() {
      return (Math.round(this.r) << 16) + (Math.round(this.g) << 8) + Math.round(this.b);
    }, t.prototype.clone = function() {
      return new t(this.toString());
    }, t.prototype.lighten = function(e) {
      e === void 0 && (e = 10);
      var n = this.toHsl();
      return n.l += e / 100, n.l = F1(n.l), new t(n);
    }, t.prototype.brighten = function(e) {
      e === void 0 && (e = 10);
      var n = this.toRgb();
      return n.r = Math.max(0, Math.min(255, n.r - Math.round(255 * -(e / 100)))), n.g = Math.max(0, Math.min(255, n.g - Math.round(255 * -(e / 100)))), n.b = Math.max(0, Math.min(255, n.b - Math.round(255 * -(e / 100)))), new t(n);
    }, t.prototype.darken = function(e) {
      e === void 0 && (e = 10);
      var n = this.toHsl();
      return n.l -= e / 100, n.l = F1(n.l), new t(n);
    }, t.prototype.tint = function(e) {
      return e === void 0 && (e = 10), this.mix("white", e);
    }, t.prototype.shade = function(e) {
      return e === void 0 && (e = 10), this.mix("black", e);
    }, t.prototype.desaturate = function(e) {
      e === void 0 && (e = 10);
      var n = this.toHsl();
      return n.s -= e / 100, n.s = F1(n.s), new t(n);
    }, t.prototype.saturate = function(e) {
      e === void 0 && (e = 10);
      var n = this.toHsl();
      return n.s += e / 100, n.s = F1(n.s), new t(n);
    }, t.prototype.greyscale = function() {
      return this.desaturate(100);
    }, t.prototype.spin = function(e) {
      var n = this.toHsl(), r = (n.h + e) % 360;
      return n.h = r < 0 ? 360 + r : r, new t(n);
    }, t.prototype.mix = function(e, n) {
      n === void 0 && (n = 50);
      var r = this.toRgb(), i = new t(e).toRgb(), o = n / 100, a = {
        r: (i.r - r.r) * o + r.r,
        g: (i.g - r.g) * o + r.g,
        b: (i.b - r.b) * o + r.b,
        a: (i.a - r.a) * o + r.a
      };
      return new t(a);
    }, t.prototype.analogous = function(e, n) {
      e === void 0 && (e = 6), n === void 0 && (n = 30);
      var r = this.toHsl(), i = 360 / n, o = [this];
      for (r.h = (r.h - (i * e >> 1) + 720) % 360; --e; )
        r.h = (r.h + i) % 360, o.push(new t(r));
      return o;
    }, t.prototype.complement = function() {
      var e = this.toHsl();
      return e.h = (e.h + 180) % 360, new t(e);
    }, t.prototype.monochromatic = function(e) {
      e === void 0 && (e = 6);
      for (var n = this.toHsv(), r = n.h, i = n.s, o = n.v, a = [], s = 1 / e; e--; )
        a.push(new t({ h: r, s: i, v: o })), o = (o + s) % 1;
      return a;
    }, t.prototype.splitcomplement = function() {
      var e = this.toHsl(), n = e.h;
      return [
        this,
        new t({ h: (n + 72) % 360, s: e.s, l: e.l }),
        new t({ h: (n + 216) % 360, s: e.s, l: e.l })
      ];
    }, t.prototype.onBackground = function(e) {
      var n = this.toRgb(), r = new t(e).toRgb(), i = n.a + r.a * (1 - n.a);
      return new t({
        r: (n.r * n.a + r.r * r.a * (1 - n.a)) / i,
        g: (n.g * n.a + r.g * r.a * (1 - n.a)) / i,
        b: (n.b * n.a + r.b * r.a * (1 - n.a)) / i,
        a: i
      });
    }, t.prototype.triad = function() {
      return this.polyad(3);
    }, t.prototype.tetrad = function() {
      return this.polyad(4);
    }, t.prototype.polyad = function(e) {
      for (var n = this.toHsl(), r = n.h, i = [this], o = 360 / e, a = 1; a < e; a++)
        i.push(new t({ h: (r + a * o) % 360, s: n.s, l: n.l }));
      return i;
    }, t.prototype.equals = function(e) {
      return this.toRgbString() === new t(e).toRgbString();
    }, t;
  }()
), V1 = 2, y7 = 0.16, Kde = 0.05, qde = 0.05, Qde = 0.15, aW = 5, sW = 4, efe = [{
  index: 7,
  opacity: 0.15
}, {
  index: 6,
  opacity: 0.25
}, {
  index: 5,
  opacity: 0.3
}, {
  index: 5,
  opacity: 0.45
}, {
  index: 5,
  opacity: 0.65
}, {
  index: 5,
  opacity: 0.85
}, {
  index: 4,
  opacity: 0.9
}, {
  index: 3,
  opacity: 0.95
}, {
  index: 2,
  opacity: 0.97
}, {
  index: 1,
  opacity: 0.98
}];
function x7(t) {
  var e = t.r, n = t.g, r = t.b, i = uI(e, n, r);
  return {
    h: i.h * 360,
    s: i.s,
    v: i.v
  };
}
function B1(t) {
  var e = t.r, n = t.g, r = t.b;
  return "#".concat(lI(e, n, r, !1));
}
function tfe(t, e, n) {
  var r = n / 100, i = {
    r: (e.r - t.r) * r + t.r,
    g: (e.g - t.g) * r + t.g,
    b: (e.b - t.b) * r + t.b
  };
  return i;
}
function C7(t, e, n) {
  var r;
  return Math.round(t.h) >= 60 && Math.round(t.h) <= 240 ? r = n ? Math.round(t.h) - V1 * e : Math.round(t.h) + V1 * e : r = n ? Math.round(t.h) + V1 * e : Math.round(t.h) - V1 * e, r < 0 ? r += 360 : r >= 360 && (r -= 360), r;
}
function w7(t, e, n) {
  if (t.h === 0 && t.s === 0)
    return t.s;
  var r;
  return n ? r = t.s - y7 * e : e === sW ? r = t.s + y7 : r = t.s + Kde * e, r > 1 && (r = 1), n && e === aW && r > 0.1 && (r = 0.1), r < 0.06 && (r = 0.06), Number(r.toFixed(2));
}
function E7(t, e, n) {
  var r;
  return n ? r = t.v + qde * e : r = t.v - Qde * e, r > 1 && (r = 1), Number(r.toFixed(2));
}
function L0(t) {
  for (var e = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, n = [], r = qf(t), i = aW; i > 0; i -= 1) {
    var o = x7(r), a = B1(qf({
      h: C7(o, i, !0),
      s: w7(o, i, !0),
      v: E7(o, i, !0)
    }));
    n.push(a);
  }
  n.push(B1(r));
  for (var s = 1; s <= sW; s += 1) {
    var u = x7(r), l = B1(qf({
      h: C7(u, s),
      s: w7(u, s),
      v: E7(u, s)
    }));
    n.push(l);
  }
  return e.theme === "dark" ? efe.map(function(c) {
    var d = c.index, f = c.opacity, h = B1(tfe(qf(e.backgroundColor || "#141414"), qf(n[d]), f * 100));
    return h;
  }) : n;
}
var Mh = {
  red: "#F5222D",
  volcano: "#FA541C",
  orange: "#FA8C16",
  gold: "#FAAD14",
  yellow: "#FADB14",
  lime: "#A0D911",
  green: "#52C41A",
  cyan: "#13C2C2",
  blue: "#1890FF",
  geekblue: "#2F54EB",
  purple: "#722ED1",
  magenta: "#EB2F96",
  grey: "#666666"
}, TS = {}, OS = {};
Object.keys(Mh).forEach(function(t) {
  TS[t] = L0(Mh[t]), TS[t].primary = TS[t][5], OS[t] = L0(Mh[t], {
    theme: "dark",
    backgroundColor: "#141414"
  }), OS[t].primary = OS[t][5];
});
var dI = {}, X6 = [], nfe = function(e) {
  X6.push(e);
};
function rx(t, e) {
  if (process.env.NODE_ENV !== "production" && !t && console !== void 0) {
    var n = X6.reduce(function(r, i) {
      return i(r ?? "", "warning");
    }, e);
    n && console.error("Warning: ".concat(n));
  }
}
function rfe(t, e) {
  if (process.env.NODE_ENV !== "production" && !t && console !== void 0) {
    var n = X6.reduce(function(r, i) {
      return i(r ?? "", "note");
    }, e);
    n && console.warn("Note: ".concat(n));
  }
}
function uW() {
  dI = {};
}
function lW(t, e, n) {
  !e && !dI[n] && (t(!1, n), dI[n] = !0);
}
function Wt(t, e) {
  lW(rx, t, e);
}
function fI(t, e) {
  lW(rfe, t, e);
}
Wt.preMessage = nfe;
Wt.resetWarned = uW;
Wt.noteOnce = fI;
function yu() {
  return !!(typeof window < "u" && window.document && window.document.createElement);
}
function l0(t, e) {
  if (!t)
    return !1;
  if (t.contains)
    return t.contains(e);
  for (var n = e; n; ) {
    if (n === t)
      return !0;
    n = n.parentNode;
  }
  return !1;
}
var S7 = "data-rc-order", I7 = "data-rc-priority", ife = "rc-util-key", hI = /* @__PURE__ */ new Map();
function cW() {
  var t = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, e = t.mark;
  return e ? e.startsWith("data-") ? e : "data-".concat(e) : ife;
}
function Y6(t) {
  if (t.attachTo)
    return t.attachTo;
  var e = document.querySelector("head");
  return e || document.body;
}
function ofe(t) {
  return t === "queue" ? "prependQueue" : t ? "prepend" : "append";
}
function dW(t) {
  return Array.from((hI.get(t) || t).children).filter(function(e) {
    return e.tagName === "STYLE";
  });
}
function fW(t) {
  var e = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
  if (!yu())
    return null;
  var n = e.csp, r = e.prepend, i = e.priority, o = i === void 0 ? 0 : i, a = ofe(r), s = a === "prependQueue", u = document.createElement("style");
  u.setAttribute(S7, a), s && o && u.setAttribute(I7, "".concat(o)), n != null && n.nonce && (u.nonce = n == null ? void 0 : n.nonce), u.innerHTML = t;
  var l = Y6(e), c = l.firstChild;
  if (r) {
    if (s) {
      var d = dW(l).filter(function(f) {
        if (!["prepend", "prependQueue"].includes(f.getAttribute(S7)))
          return !1;
        var h = Number(f.getAttribute(I7) || 0);
        return o >= h;
      });
      if (d.length)
        return l.insertBefore(u, d[d.length - 1].nextSibling), u;
    }
    l.insertBefore(u, c);
  } else
    l.appendChild(u);
  return u;
}
function afe(t) {
  var e = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, n = Y6(e);
  return dW(n).find(function(r) {
    return r.getAttribute(cW(e)) === t;
  });
}
function sfe(t, e) {
  var n = hI.get(t);
  if (!n || !l0(document, n)) {
    var r = fW("", e), i = r.parentNode;
    hI.set(t, i), t.removeChild(r);
  }
}
function Z6(t, e) {
  var n = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {}, r = Y6(n);
  sfe(r, n);
  var i = afe(e, n);
  if (i) {
    var o, a;
    if ((o = n.csp) !== null && o !== void 0 && o.nonce && i.nonce !== ((a = n.csp) === null || a === void 0 ? void 0 : a.nonce)) {
      var s;
      i.nonce = (s = n.csp) === null || s === void 0 ? void 0 : s.nonce;
    }
    return i.innerHTML !== t && (i.innerHTML = t), i;
  }
  var u = fW(t, n);
  return u.setAttribute(cW(n), e), u;
}
var ufe = typeof ft == "object" && ft && ft.Object === Object && ft, hW = ufe, lfe = hW, cfe = typeof self == "object" && self && self.Object === Object && self, dfe = lfe || cfe || Function("return this")(), $s = dfe, ffe = $s, hfe = ffe.Symbol, xp = hfe;
function pfe(t, e) {
  for (var n = -1, r = t == null ? 0 : t.length, i = Array(r); ++n < r; )
    i[n] = e(t[n], n, t);
  return i;
}
var J6 = pfe, gfe = Array.isArray, Mo = gfe;
const iC = /* @__PURE__ */ qn(Mo);
var _7 = xp, pW = Object.prototype, mfe = pW.hasOwnProperty, vfe = pW.toString, Eg = _7 ? _7.toStringTag : void 0;
function bfe(t) {
  var e = mfe.call(t, Eg), n = t[Eg];
  try {
    t[Eg] = void 0;
    var r = !0;
  } catch {
  }
  var i = vfe.call(t);
  return r && (e ? t[Eg] = n : delete t[Eg]), i;
}
var yfe = bfe, xfe = Object.prototype, Cfe = xfe.toString;
function wfe(t) {
  return Cfe.call(t);
}
var Efe = wfe, A7 = xp, Sfe = yfe, Ife = Efe, _fe = "[object Null]", Afe = "[object Undefined]", T7 = A7 ? A7.toStringTag : void 0;
function Tfe(t) {
  return t == null ? t === void 0 ? Afe : _fe : T7 && T7 in Object(t) ? Sfe(t) : Ife(t);
}
var Ec = Tfe;
function Ofe(t) {
  return t != null && typeof t == "object";
}
var xu = Ofe, Pfe = Ec, Nfe = xu, kfe = "[object Symbol]";
function Rfe(t) {
  return typeof t == "symbol" || Nfe(t) && Pfe(t) == kfe;
}
var oC = Rfe, O7 = xp, $fe = J6, Dfe = Mo, Mfe = oC, Ffe = 1 / 0, P7 = O7 ? O7.prototype : void 0, N7 = P7 ? P7.toString : void 0;
function gW(t) {
  if (typeof t == "string")
    return t;
  if (Dfe(t))
    return $fe(t, gW) + "";
  if (Mfe(t))
    return N7 ? N7.call(t) : "";
  var e = t + "";
  return e == "0" && 1 / t == -Ffe ? "-0" : e;
}
var K6 = gW, Lfe = K6;
function Vfe(t) {
  return t == null ? "" : Lfe(t);
}
var zd = Vfe;
function Bfe(t, e, n) {
  var r = -1, i = t.length;
  e < 0 && (e = -e > i ? 0 : i + e), n = n > i ? i : n, n < 0 && (n += i), i = e > n ? 0 : n - e >>> 0, e >>>= 0;
  for (var o = Array(i); ++r < i; )
    o[r] = t[r + e];
  return o;
}
var mW = Bfe, Hfe = mW;
function Wfe(t, e, n) {
  var r = t.length;
  return n = n === void 0 ? r : n, !e && n >= r ? t : Hfe(t, e, n);
}
var q6 = Wfe, jfe = "\\ud800-\\udfff", zfe = "\\u0300-\\u036f", Gfe = "\\ufe20-\\ufe2f", Ufe = "\\u20d0-\\u20ff", Xfe = zfe + Gfe + Ufe, Yfe = "\\ufe0e\\ufe0f", Zfe = "\\u200d", Jfe = RegExp("[" + Zfe + jfe + Xfe + Yfe + "]");
function Kfe(t) {
  return Jfe.test(t);
}
var aC = Kfe;
function qfe(t) {
  return t.split("");
}
var Qfe = qfe, vW = "\\ud800-\\udfff", ehe = "\\u0300-\\u036f", the = "\\ufe20-\\ufe2f", nhe = "\\u20d0-\\u20ff", rhe = ehe + the + nhe, ihe = "\\ufe0e\\ufe0f", ohe = "[" + vW + "]", pI = "[" + rhe + "]", gI = "\\ud83c[\\udffb-\\udfff]", ahe = "(?:" + pI + "|" + gI + ")", bW = "[^" + vW + "]", yW = "(?:\\ud83c[\\udde6-\\uddff]){2}", xW = "[\\ud800-\\udbff][\\udc00-\\udfff]", she = "\\u200d", CW = ahe + "?", wW = "[" + ihe + "]?", uhe = "(?:" + she + "(?:" + [bW, yW, xW].join("|") + ")" + wW + CW + ")*", lhe = wW + CW + uhe, che = "(?:" + [bW + pI + "?", pI, yW, xW, ohe].join("|") + ")", dhe = RegExp(gI + "(?=" + gI + ")|" + che + lhe, "g");
function fhe(t) {
  return t.match(dhe) || [];
}
var hhe = fhe, phe = Qfe, ghe = aC, mhe = hhe;
function vhe(t) {
  return ghe(t) ? mhe(t) : phe(t);
}
var Q6 = vhe, bhe = q6, yhe = aC, xhe = Q6, Che = zd;
function whe(t) {
  return function(e) {
    e = Che(e);
    var n = yhe(e) ? xhe(e) : void 0, r = n ? n[0] : e.charAt(0), i = n ? bhe(n, 1).join("") : e.slice(1);
    return r[t]() + i;
  };
}
var Ehe = whe, She = Ehe, Ihe = She("toUpperCase"), _he = Ihe, Ahe = zd, The = _he;
function Ohe(t) {
  return The(Ahe(t).toLowerCase());
}
var Phe = Ohe;
function Nhe(t, e, n, r) {
  var i = -1, o = t == null ? 0 : t.length;
  for (r && o && (n = t[++i]); ++i < o; )
    n = e(n, t[i], i, t);
  return n;
}
var khe = Nhe;
function Rhe(t) {
  return function(e) {
    return t == null ? void 0 : t[e];
  };
}
var $he = Rhe, Dhe = $he, Mhe = {
  // Latin-1 Supplement block.
  À: "A",
  Á: "A",
  Â: "A",
  Ã: "A",
  Ä: "A",
  Å: "A",
  à: "a",
  á: "a",
  â: "a",
  ã: "a",
  ä: "a",
  å: "a",
  Ç: "C",
  ç: "c",
  Ð: "D",
  ð: "d",
  È: "E",
  É: "E",
  Ê: "E",
  Ë: "E",
  è: "e",
  é: "e",
  ê: "e",
  ë: "e",
  Ì: "I",
  Í: "I",
  Î: "I",
  Ï: "I",
  ì: "i",
  í: "i",
  î: "i",
  ï: "i",
  Ñ: "N",
  ñ: "n",
  Ò: "O",
  Ó: "O",
  Ô: "O",
  Õ: "O",
  Ö: "O",
  Ø: "O",
  ò: "o",
  ó: "o",
  ô: "o",
  õ: "o",
  ö: "o",
  ø: "o",
  Ù: "U",
  Ú: "U",
  Û: "U",
  Ü: "U",
  ù: "u",
  ú: "u",
  û: "u",
  ü: "u",
  Ý: "Y",
  ý: "y",
  ÿ: "y",
  Æ: "Ae",
  æ: "ae",
  Þ: "Th",
  þ: "th",
  ß: "ss",
  // Latin Extended-A block.
  Ā: "A",
  Ă: "A",
  Ą: "A",
  ā: "a",
  ă: "a",
  ą: "a",
  Ć: "C",
  Ĉ: "C",
  Ċ: "C",
  Č: "C",
  ć: "c",
  ĉ: "c",
  ċ: "c",
  č: "c",
  Ď: "D",
  Đ: "D",
  ď: "d",
  đ: "d",
  Ē: "E",
  Ĕ: "E",
  Ė: "E",
  Ę: "E",
  Ě: "E",
  ē: "e",
  ĕ: "e",
  ė: "e",
  ę: "e",
  ě: "e",
  Ĝ: "G",
  Ğ: "G",
  Ġ: "G",
  Ģ: "G",
  ĝ: "g",
  ğ: "g",
  ġ: "g",
  ģ: "g",
  Ĥ: "H",
  Ħ: "H",
  ĥ: "h",
  ħ: "h",
  Ĩ: "I",
  Ī: "I",
  Ĭ: "I",
  Į: "I",
  İ: "I",
  ĩ: "i",
  ī: "i",
  ĭ: "i",
  į: "i",
  ı: "i",
  Ĵ: "J",
  ĵ: "j",
  Ķ: "K",
  ķ: "k",
  ĸ: "k",
  Ĺ: "L",
  Ļ: "L",
  Ľ: "L",
  Ŀ: "L",
  Ł: "L",
  ĺ: "l",
  ļ: "l",
  ľ: "l",
  ŀ: "l",
  ł: "l",
  Ń: "N",
  Ņ: "N",
  Ň: "N",
  Ŋ: "N",
  ń: "n",
  ņ: "n",
  ň: "n",
  ŋ: "n",
  Ō: "O",
  Ŏ: "O",
  Ő: "O",
  ō: "o",
  ŏ: "o",
  ő: "o",
  Ŕ: "R",
  Ŗ: "R",
  Ř: "R",
  ŕ: "r",
  ŗ: "r",
  ř: "r",
  Ś: "S",
  Ŝ: "S",
  Ş: "S",
  Š: "S",
  ś: "s",
  ŝ: "s",
  ş: "s",
  š: "s",
  Ţ: "T",
  Ť: "T",
  Ŧ: "T",
  ţ: "t",
  ť: "t",
  ŧ: "t",
  Ũ: "U",
  Ū: "U",
  Ŭ: "U",
  Ů: "U",
  Ű: "U",
  Ų: "U",
  ũ: "u",
  ū: "u",
  ŭ: "u",
  ů: "u",
  ű: "u",
  ų: "u",
  Ŵ: "W",
  ŵ: "w",
  Ŷ: "Y",
  ŷ: "y",
  Ÿ: "Y",
  Ź: "Z",
  Ż: "Z",
  Ž: "Z",
  ź: "z",
  ż: "z",
  ž: "z",
  Ĳ: "IJ",
  ĳ: "ij",
  Œ: "Oe",
  œ: "oe",
  ŉ: "'n",
  ſ: "s"
}, Fhe = Dhe(Mhe), Lhe = Fhe, Vhe = Lhe, Bhe = zd, Hhe = /[\xc0-\xd6\xd8-\xf6\xf8-\xff\u0100-\u017f]/g, Whe = "\\u0300-\\u036f", jhe = "\\ufe20-\\ufe2f", zhe = "\\u20d0-\\u20ff", Ghe = Whe + jhe + zhe, Uhe = "[" + Ghe + "]", Xhe = RegExp(Uhe, "g");
function Yhe(t) {
  return t = Bhe(t), t && t.replace(Hhe, Vhe).replace(Xhe, "");
}
var Zhe = Yhe, Jhe = /[^\x00-\x2f\x3a-\x40\x5b-\x60\x7b-\x7f]+/g;
function Khe(t) {
  return t.match(Jhe) || [];
}
var qhe = Khe, Qhe = /[a-z][A-Z]|[A-Z]{2}[a-z]|[0-9][a-zA-Z]|[a-zA-Z][0-9]|[^a-zA-Z0-9 ]/;
function epe(t) {
  return Qhe.test(t);
}
var tpe = epe, EW = "\\ud800-\\udfff", npe = "\\u0300-\\u036f", rpe = "\\ufe20-\\ufe2f", ipe = "\\u20d0-\\u20ff", ope = npe + rpe + ipe, SW = "\\u2700-\\u27bf", IW = "a-z\\xdf-\\xf6\\xf8-\\xff", ape = "\\xac\\xb1\\xd7\\xf7", spe = "\\x00-\\x2f\\x3a-\\x40\\x5b-\\x60\\x7b-\\xbf", upe = "\\u2000-\\u206f", lpe = " \\t\\x0b\\f\\xa0\\ufeff\\n\\r\\u2028\\u2029\\u1680\\u180e\\u2000\\u2001\\u2002\\u2003\\u2004\\u2005\\u2006\\u2007\\u2008\\u2009\\u200a\\u202f\\u205f\\u3000", _W = "A-Z\\xc0-\\xd6\\xd8-\\xde", cpe = "\\ufe0e\\ufe0f", AW = ape + spe + upe + lpe, TW = "['’]", k7 = "[" + AW + "]", dpe = "[" + ope + "]", OW = "\\d+", fpe = "[" + SW + "]", PW = "[" + IW + "]", NW = "[^" + EW + AW + OW + SW + IW + _W + "]", hpe = "\\ud83c[\\udffb-\\udfff]", ppe = "(?:" + dpe + "|" + hpe + ")", gpe = "[^" + EW + "]", kW = "(?:\\ud83c[\\udde6-\\uddff]){2}", RW = "[\\ud800-\\udbff][\\udc00-\\udfff]", Qf = "[" + _W + "]", mpe = "\\u200d", R7 = "(?:" + PW + "|" + NW + ")", vpe = "(?:" + Qf + "|" + NW + ")", $7 = "(?:" + TW + "(?:d|ll|m|re|s|t|ve))?", D7 = "(?:" + TW + "(?:D|LL|M|RE|S|T|VE))?", $W = ppe + "?", DW = "[" + cpe + "]?", bpe = "(?:" + mpe + "(?:" + [gpe, kW, RW].join("|") + ")" + DW + $W + ")*", ype = "\\d*(?:1st|2nd|3rd|(?![123])\\dth)(?=\\b|[A-Z_])", xpe = "\\d*(?:1ST|2ND|3RD|(?![123])\\dTH)(?=\\b|[a-z_])", Cpe = DW + $W + bpe, wpe = "(?:" + [fpe, kW, RW].join("|") + ")" + Cpe, Epe = RegExp([
  Qf + "?" + PW + "+" + $7 + "(?=" + [k7, Qf, "$"].join("|") + ")",
  vpe + "+" + D7 + "(?=" + [k7, Qf + R7, "$"].join("|") + ")",
  Qf + "?" + R7 + "+" + $7,
  Qf + "+" + D7,
  xpe,
  ype,
  OW,
  wpe
].join("|"), "g");
function Spe(t) {
  return t.match(Epe) || [];
}
var Ipe = Spe, _pe = qhe, Ape = tpe, Tpe = zd, Ope = Ipe;
function Ppe(t, e, n) {
  return t = Tpe(t), e = n ? void 0 : e, e === void 0 ? Ape(t) ? Ope(t) : _pe(t) : t.match(e) || [];
}
var Npe = Ppe, kpe = khe, Rpe = Zhe, $pe = Npe, Dpe = "['’]", Mpe = RegExp(Dpe, "g");
function Fpe(t) {
  return function(e) {
    return kpe($pe(Rpe(e).replace(Mpe, "")), t, "");
  };
}
var Lpe = Fpe, Vpe = Phe, Bpe = Lpe, Hpe = Bpe(function(t, e, n) {
  return e = e.toLowerCase(), t + (n ? Vpe(e) : e);
}), Wpe = Hpe;
const jpe = /* @__PURE__ */ qn(Wpe);
function zpe(t, e) {
  Wt(t, "[@ant-design/icons] ".concat(e));
}
function M7(t) {
  return _t(t) === "object" && typeof t.name == "string" && typeof t.theme == "string" && (_t(t.icon) === "object" || typeof t.icon == "function");
}
function F7() {
  var t = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
  return Object.keys(t).reduce(function(e, n) {
    var r = t[n];
    switch (n) {
      case "class":
        e.className = r, delete e.class;
        break;
      default:
        delete e[n], e[jpe(n)] = r;
    }
    return e;
  }, {});
}
function mI(t, e, n) {
  return n ? /* @__PURE__ */ O.createElement(t.tag, de(de({
    key: e
  }, F7(t.attrs)), n), (t.children || []).map(function(r, i) {
    return mI(r, "".concat(e, "-").concat(t.tag, "-").concat(i));
  })) : /* @__PURE__ */ O.createElement(t.tag, de({
    key: e
  }, F7(t.attrs)), (t.children || []).map(function(r, i) {
    return mI(r, "".concat(e, "-").concat(t.tag, "-").concat(i));
  }));
}
function MW(t) {
  return L0(t)[0];
}
function FW(t) {
  return t ? Array.isArray(t) ? t : [t] : [];
}
var Gpe = `
.anticon {
  display: inline-block;
  color: inherit;
  font-style: normal;
  line-height: 0;
  text-align: center;
  text-transform: none;
  vertical-align: -0.125em;
  text-rendering: optimizeLegibility;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

.anticon > * {
  line-height: 1;
}

.anticon svg {
  display: inline-block;
}

.anticon::before {
  display: none;
}

.anticon .anticon-icon {
  display: block;
}

.anticon[tabindex] {
  cursor: pointer;
}

.anticon-spin::before,
.anticon-spin {
  display: inline-block;
  -webkit-animation: loadingCircle 1s infinite linear;
  animation: loadingCircle 1s infinite linear;
}

@-webkit-keyframes loadingCircle {
  100% {
    -webkit-transform: rotate(360deg);
    transform: rotate(360deg);
  }
}

@keyframes loadingCircle {
  100% {
    -webkit-transform: rotate(360deg);
    transform: rotate(360deg);
  }
}
`, Upe = function() {
  var e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : Gpe, n = fn(G6), r = n.csp;
  Re(function() {
    Z6(e, "@ant-design-icons", {
      prepend: !0,
      csp: r
    });
  }, []);
}, Xpe = ["icon", "className", "onClick", "style", "primaryColor", "secondaryColor"], c0 = {
  primaryColor: "#333",
  secondaryColor: "#E6E6E6",
  calculated: !1
};
function Ype(t) {
  var e = t.primaryColor, n = t.secondaryColor;
  c0.primaryColor = e, c0.secondaryColor = n || MW(e), c0.calculated = !!n;
}
function Zpe() {
  return de({}, c0);
}
var sC = function(e) {
  var n = e.icon, r = e.className, i = e.onClick, o = e.style, a = e.primaryColor, s = e.secondaryColor, u = Gt(e, Xpe), l = c0;
  if (a && (l = {
    primaryColor: a,
    secondaryColor: s || MW(a)
  }), Upe(), zpe(M7(n), "icon should be icon definiton, but got ".concat(n)), !M7(n))
    return null;
  var c = n;
  return c && typeof c.icon == "function" && (c = de(de({}, c), {}, {
    icon: c.icon(l.primaryColor, l.secondaryColor)
  })), mI(c.icon, "svg-".concat(c.name), de({
    className: r,
    onClick: i,
    style: o,
    "data-icon": c.name,
    width: "1em",
    height: "1em",
    fill: "currentColor",
    "aria-hidden": "true"
  }, u));
};
sC.displayName = "IconReact";
sC.getTwoToneColors = Zpe;
sC.setTwoToneColors = Ype;
const eA = sC;
function LW(t) {
  var e = FW(t), n = be(e, 2), r = n[0], i = n[1];
  return eA.setTwoToneColors({
    primaryColor: r,
    secondaryColor: i
  });
}
function Jpe() {
  var t = eA.getTwoToneColors();
  return t.calculated ? [t.primaryColor, t.secondaryColor] : t.primaryColor;
}
var Kpe = ["className", "icon", "spin", "rotate", "tabIndex", "onClick", "twoToneColor"];
LW("#1890ff");
var uC = /* @__PURE__ */ x.forwardRef(function(t, e) {
  var n, r = t.className, i = t.icon, o = t.spin, a = t.rotate, s = t.tabIndex, u = t.onClick, l = t.twoToneColor, c = Gt(t, Kpe), d = x.useContext(G6), f = d.prefixCls, h = f === void 0 ? "anticon" : f, p = d.rootClassName, v = Ce(p, h, (n = {}, z(n, "".concat(h, "-").concat(i.name), !!i.name), z(n, "".concat(h, "-spin"), !!o || i.name === "loading"), n), r), m = s;
  m === void 0 && u && (m = -1);
  var b = a ? {
    msTransform: "rotate(".concat(a, "deg)"),
    transform: "rotate(".concat(a, "deg)")
  } : void 0, y = FW(l), w = be(y, 2), S = w[0], E = w[1];
  return /* @__PURE__ */ x.createElement("span", de(de({
    role: "img",
    "aria-label": i.name
  }, c), {}, {
    ref: e,
    tabIndex: m,
    onClick: u,
    className: v
  }), /* @__PURE__ */ x.createElement(eA, {
    icon: i,
    primaryColor: S,
    secondaryColor: E,
    style: b
  }));
});
uC.displayName = "AntdIcon";
uC.getTwoToneColor = Jpe;
uC.setTwoToneColor = LW;
const Hn = uC;
var qpe = { icon: { tag: "svg", attrs: { viewBox: "0 0 1024 1024", focusable: "false" }, children: [{ tag: "path", attrs: { d: "M912 192H328c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h584c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm0 284H328c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h584c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm0 284H328c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h584c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zM104 228a56 56 0 10112 0 56 56 0 10-112 0zm0 284a56 56 0 10112 0 56 56 0 10-112 0zm0 284a56 56 0 10112 0 56 56 0 10-112 0z" } }] }, name: "bars", theme: "outlined" };
const Qpe = qpe;
var VW = function(e, n) {
  return /* @__PURE__ */ x.createElement(Hn, de(de({}, e), {}, {
    ref: n,
    icon: Qpe
  }));
};
VW.displayName = "BarsOutlined";
const ege = /* @__PURE__ */ x.forwardRef(VW);
var tge = { icon: { tag: "svg", attrs: { viewBox: "64 64 896 896", focusable: "false" }, children: [{ tag: "path", attrs: { d: "M880 184H712v-64c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v64H384v-64c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v64H144c-17.7 0-32 14.3-32 32v664c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V216c0-17.7-14.3-32-32-32zm-40 656H184V460h656v380zM184 392V256h128v48c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-48h256v48c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-48h128v136H184z" } }] }, name: "calendar", theme: "outlined" };
const nge = tge;
var BW = function(e, n) {
  return /* @__PURE__ */ x.createElement(Hn, de(de({}, e), {}, {
    ref: n,
    icon: nge
  }));
};
BW.displayName = "CalendarOutlined";
const HW = /* @__PURE__ */ x.forwardRef(BW);
var rge = { icon: { tag: "svg", attrs: { viewBox: "64 64 896 896", focusable: "false" }, children: [{ tag: "path", attrs: { d: "M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm193.5 301.7l-210.6 292a31.8 31.8 0 01-51.7 0L318.5 484.9c-3.8-5.3 0-12.7 6.5-12.7h46.9c10.2 0 19.9 4.9 25.9 13.3l71.2 98.8 157.2-218c6-8.3 15.6-13.3 25.9-13.3H699c6.5 0 10.3 7.4 6.5 12.7z" } }] }, name: "check-circle", theme: "filled" };
const ige = rge;
var WW = function(e, n) {
  return /* @__PURE__ */ x.createElement(Hn, de(de({}, e), {}, {
    ref: n,
    icon: ige
  }));
};
WW.displayName = "CheckCircleFilled";
const tA = /* @__PURE__ */ x.forwardRef(WW);
var oge = { icon: { tag: "svg", attrs: { viewBox: "64 64 896 896", focusable: "false" }, children: [{ tag: "path", attrs: { d: "M699 353h-46.9c-10.2 0-19.9 4.9-25.9 13.3L469 584.3l-71.2-98.8c-6-8.3-15.6-13.3-25.9-13.3H325c-6.5 0-10.3 7.4-6.5 12.7l124.6 172.8a31.8 31.8 0 0051.7 0l210.6-292c3.9-5.3.1-12.7-6.4-12.7z" } }, { tag: "path", attrs: { d: "M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm0 820c-205.4 0-372-166.6-372-372s166.6-372 372-372 372 166.6 372 372-166.6 372-372 372z" } }] }, name: "check-circle", theme: "outlined" };
const age = oge;
var jW = function(e, n) {
  return /* @__PURE__ */ x.createElement(Hn, de(de({}, e), {}, {
    ref: n,
    icon: age
  }));
};
jW.displayName = "CheckCircleOutlined";
const sge = /* @__PURE__ */ x.forwardRef(jW);
var uge = { icon: { tag: "svg", attrs: { viewBox: "64 64 896 896", focusable: "false" }, children: [{ tag: "path", attrs: { d: "M912 190h-69.9c-9.8 0-19.1 4.5-25.1 12.2L404.7 724.5 207 474a32 32 0 00-25.1-12.2H112c-6.7 0-10.4 7.7-6.3 12.9l273.9 347c12.8 16.2 37.4 16.2 50.3 0l488.4-618.9c4.1-5.1.4-12.8-6.3-12.8z" } }] }, name: "check", theme: "outlined" };
const lge = uge;
var zW = function(e, n) {
  return /* @__PURE__ */ x.createElement(Hn, de(de({}, e), {}, {
    ref: n,
    icon: lge
  }));
};
zW.displayName = "CheckOutlined";
const GW = /* @__PURE__ */ x.forwardRef(zW);
var cge = { icon: { tag: "svg", attrs: { viewBox: "64 64 896 896", focusable: "false" }, children: [{ tag: "path", attrs: { d: "M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm0 820c-205.4 0-372-166.6-372-372s166.6-372 372-372 372 166.6 372 372-166.6 372-372 372z" } }, { tag: "path", attrs: { d: "M686.7 638.6L544.1 535.5V288c0-4.4-3.6-8-8-8H488c-4.4 0-8 3.6-8 8v275.4c0 2.6 1.2 5 3.3 6.5l165.4 120.6c3.6 2.6 8.6 1.8 11.2-1.7l28.6-39c2.6-3.7 1.8-8.7-1.8-11.2z" } }] }, name: "clock-circle", theme: "outlined" };
const dge = cge;
var UW = function(e, n) {
  return /* @__PURE__ */ x.createElement(Hn, de(de({}, e), {}, {
    ref: n,
    icon: dge
  }));
};
UW.displayName = "ClockCircleOutlined";
const XW = /* @__PURE__ */ x.forwardRef(UW);
var fge = { icon: { tag: "svg", attrs: { "fill-rule": "evenodd", viewBox: "64 64 896 896", focusable: "false" }, children: [{ tag: "path", attrs: { d: "M512 64c247.4 0 448 200.6 448 448S759.4 960 512 960 64 759.4 64 512 264.6 64 512 64zm127.98 274.82h-.04l-.08.06L512 466.75 384.14 338.88c-.04-.05-.06-.06-.08-.06a.12.12 0 00-.07 0c-.03 0-.05.01-.09.05l-45.02 45.02a.2.2 0 00-.05.09.12.12 0 000 .07v.02a.27.27 0 00.06.06L466.75 512 338.88 639.86c-.05.04-.06.06-.06.08a.12.12 0 000 .07c0 .03.01.05.05.09l45.02 45.02a.2.2 0 00.09.05.12.12 0 00.07 0c.02 0 .04-.01.08-.05L512 557.25l127.86 127.87c.04.04.06.05.08.05a.12.12 0 00.07 0c.03 0 .05-.01.09-.05l45.02-45.02a.2.2 0 00.05-.09.12.12 0 000-.07v-.02a.27.27 0 00-.05-.06L557.25 512l127.87-127.86c.04-.04.05-.06.05-.08a.12.12 0 000-.07c0-.03-.01-.05-.05-.09l-45.02-45.02a.2.2 0 00-.09-.05.12.12 0 00-.07 0z" } }] }, name: "close-circle", theme: "filled" };
const hge = fge;
var YW = function(e, n) {
  return /* @__PURE__ */ x.createElement(Hn, de(de({}, e), {}, {
    ref: n,
    icon: hge
  }));
};
YW.displayName = "CloseCircleFilled";
const Sc = /* @__PURE__ */ x.forwardRef(YW);
var pge = { icon: { tag: "svg", attrs: { "fill-rule": "evenodd", viewBox: "64 64 896 896", focusable: "false" }, children: [{ tag: "path", attrs: { d: "M512 64c247.4 0 448 200.6 448 448S759.4 960 512 960 64 759.4 64 512 264.6 64 512 64zm0 76c-205.4 0-372 166.6-372 372s166.6 372 372 372 372-166.6 372-372-166.6-372-372-372zm128.01 198.83c.03 0 .05.01.09.06l45.02 45.01a.2.2 0 01.05.09.12.12 0 010 .07c0 .02-.01.04-.05.08L557.25 512l127.87 127.86a.27.27 0 01.05.06v.02a.12.12 0 010 .07c0 .03-.01.05-.05.09l-45.02 45.02a.2.2 0 01-.09.05.12.12 0 01-.07 0c-.02 0-.04-.01-.08-.05L512 557.25 384.14 685.12c-.04.04-.06.05-.08.05a.12.12 0 01-.07 0c-.03 0-.05-.01-.09-.05l-45.02-45.02a.2.2 0 01-.05-.09.12.12 0 010-.07c0-.02.01-.04.06-.08L466.75 512 338.88 384.14a.27.27 0 01-.05-.06l-.01-.02a.12.12 0 010-.07c0-.03.01-.05.05-.09l45.02-45.02a.2.2 0 01.09-.05.12.12 0 01.07 0c.02 0 .04.01.08.06L512 466.75l127.86-127.86c.04-.05.06-.06.08-.06a.12.12 0 01.07 0z" } }] }, name: "close-circle", theme: "outlined" };
const gge = pge;
var ZW = function(e, n) {
  return /* @__PURE__ */ x.createElement(Hn, de(de({}, e), {}, {
    ref: n,
    icon: gge
  }));
};
ZW.displayName = "CloseCircleOutlined";
const mge = /* @__PURE__ */ x.forwardRef(ZW);
var vge = { icon: { tag: "svg", attrs: { "fill-rule": "evenodd", viewBox: "64 64 896 896", focusable: "false" }, children: [{ tag: "path", attrs: { d: "M799.86 166.31c.02 0 .04.02.08.06l57.69 57.7c.04.03.05.05.06.08a.12.12 0 010 .06c0 .03-.02.05-.06.09L569.93 512l287.7 287.7c.04.04.05.06.06.09a.12.12 0 010 .07c0 .02-.02.04-.06.08l-57.7 57.69c-.03.04-.05.05-.07.06a.12.12 0 01-.07 0c-.03 0-.05-.02-.09-.06L512 569.93l-287.7 287.7c-.04.04-.06.05-.09.06a.12.12 0 01-.07 0c-.02 0-.04-.02-.08-.06l-57.69-57.7c-.04-.03-.05-.05-.06-.07a.12.12 0 010-.07c0-.03.02-.05.06-.09L454.07 512l-287.7-287.7c-.04-.04-.05-.06-.06-.09a.12.12 0 010-.07c0-.02.02-.04.06-.08l57.7-57.69c.03-.04.05-.05.07-.06a.12.12 0 01.07 0c.03 0 .05.02.09.06L512 454.07l287.7-287.7c.04-.04.06-.05.09-.06a.12.12 0 01.07 0z" } }] }, name: "close", theme: "outlined" };
const bge = vge;
var JW = function(e, n) {
  return /* @__PURE__ */ x.createElement(Hn, de(de({}, e), {}, {
    ref: n,
    icon: bge
  }));
};
JW.displayName = "CloseOutlined";
const lC = /* @__PURE__ */ x.forwardRef(JW);
var yge = { icon: { tag: "svg", attrs: { viewBox: "64 64 896 896", focusable: "false" }, children: [{ tag: "path", attrs: { d: "M360 184h-8c4.4 0 8-3.6 8-8v8h304v-8c0 4.4 3.6 8 8 8h-8v72h72v-80c0-35.3-28.7-64-64-64H352c-35.3 0-64 28.7-64 64v80h72v-72zm504 72H160c-17.7 0-32 14.3-32 32v32c0 4.4 3.6 8 8 8h60.4l24.7 523c1.6 34.1 29.8 61 63.9 61h454c34.2 0 62.3-26.8 63.9-61l24.7-523H888c4.4 0 8-3.6 8-8v-32c0-17.7-14.3-32-32-32zM731.3 840H292.7l-24.2-512h487l-24.2 512z" } }] }, name: "delete", theme: "outlined" };
const xge = yge;
var KW = function(e, n) {
  return /* @__PURE__ */ x.createElement(Hn, de(de({}, e), {}, {
    ref: n,
    icon: xge
  }));
};
KW.displayName = "DeleteOutlined";
const nA = /* @__PURE__ */ x.forwardRef(KW);
var Cge = { icon: { tag: "svg", attrs: { viewBox: "64 64 896 896", focusable: "false" }, children: [{ tag: "path", attrs: { d: "M272.9 512l265.4-339.1c4.1-5.2.4-12.9-6.3-12.9h-77.3c-4.9 0-9.6 2.3-12.6 6.1L186.8 492.3a31.99 31.99 0 000 39.5l255.3 326.1c3 3.9 7.7 6.1 12.6 6.1H532c6.7 0 10.4-7.7 6.3-12.9L272.9 512zm304 0l265.4-339.1c4.1-5.2.4-12.9-6.3-12.9h-77.3c-4.9 0-9.6 2.3-12.6 6.1L490.8 492.3a31.99 31.99 0 000 39.5l255.3 326.1c3 3.9 7.7 6.1 12.6 6.1H836c6.7 0 10.4-7.7 6.3-12.9L576.9 512z" } }] }, name: "double-left", theme: "outlined" };
const wge = Cge;
var qW = function(e, n) {
  return /* @__PURE__ */ x.createElement(Hn, de(de({}, e), {}, {
    ref: n,
    icon: wge
  }));
};
qW.displayName = "DoubleLeftOutlined";
const Ege = /* @__PURE__ */ x.forwardRef(qW);
var Sge = { icon: { tag: "svg", attrs: { viewBox: "64 64 896 896", focusable: "false" }, children: [{ tag: "path", attrs: { d: "M533.2 492.3L277.9 166.1c-3-3.9-7.7-6.1-12.6-6.1H188c-6.7 0-10.4 7.7-6.3 12.9L447.1 512 181.7 851.1A7.98 7.98 0 00188 864h77.3c4.9 0 9.6-2.3 12.6-6.1l255.3-326.1c9.1-11.7 9.1-27.9 0-39.5zm304 0L581.9 166.1c-3-3.9-7.7-6.1-12.6-6.1H492c-6.7 0-10.4 7.7-6.3 12.9L751.1 512 485.7 851.1A7.98 7.98 0 00492 864h77.3c4.9 0 9.6-2.3 12.6-6.1l255.3-326.1c9.1-11.7 9.1-27.9 0-39.5z" } }] }, name: "double-right", theme: "outlined" };
const Ige = Sge;
var QW = function(e, n) {
  return /* @__PURE__ */ x.createElement(Hn, de(de({}, e), {}, {
    ref: n,
    icon: Ige
  }));
};
QW.displayName = "DoubleRightOutlined";
const _ge = /* @__PURE__ */ x.forwardRef(QW);
var Age = { icon: { tag: "svg", attrs: { viewBox: "64 64 896 896", focusable: "false" }, children: [{ tag: "path", attrs: { d: "M884 256h-75c-5.1 0-9.9 2.5-12.9 6.6L512 654.2 227.9 262.6c-3-4.1-7.8-6.6-12.9-6.6h-75c-6.5 0-10.3 7.4-6.5 12.7l352.6 486.1c12.8 17.6 39 17.6 51.7 0l352.6-486.1c3.9-5.3.1-12.7-6.4-12.7z" } }] }, name: "down", theme: "outlined" };
const Tge = Age;
var ej = function(e, n) {
  return /* @__PURE__ */ x.createElement(Hn, de(de({}, e), {}, {
    ref: n,
    icon: Tge
  }));
};
ej.displayName = "DownOutlined";
const cC = /* @__PURE__ */ x.forwardRef(ej);
var Oge = { icon: { tag: "svg", attrs: { viewBox: "64 64 896 896", focusable: "false" }, children: [{ tag: "path", attrs: { d: "M505.7 661a8 8 0 0012.6 0l112-141.7c4.1-5.2.4-12.9-6.3-12.9h-74.1V168c0-4.4-3.6-8-8-8h-60c-4.4 0-8 3.6-8 8v338.3H400c-6.7 0-10.4 7.7-6.3 12.9l112 141.8zM878 626h-60c-4.4 0-8 3.6-8 8v154H214V634c0-4.4-3.6-8-8-8h-60c-4.4 0-8 3.6-8 8v198c0 17.7 14.3 32 32 32h684c17.7 0 32-14.3 32-32V634c0-4.4-3.6-8-8-8z" } }] }, name: "download", theme: "outlined" };
const Pge = Oge;
var tj = function(e, n) {
  return /* @__PURE__ */ x.createElement(Hn, de(de({}, e), {}, {
    ref: n,
    icon: Pge
  }));
};
tj.displayName = "DownloadOutlined";
const nj = /* @__PURE__ */ x.forwardRef(tj);
var Nge = { icon: { tag: "svg", attrs: { viewBox: "64 64 896 896", focusable: "false" }, children: [{ tag: "path", attrs: { d: "M176 511a56 56 0 10112 0 56 56 0 10-112 0zm280 0a56 56 0 10112 0 56 56 0 10-112 0zm280 0a56 56 0 10112 0 56 56 0 10-112 0z" } }] }, name: "ellipsis", theme: "outlined" };
const kge = Nge;
var rj = function(e, n) {
  return /* @__PURE__ */ x.createElement(Hn, de(de({}, e), {}, {
    ref: n,
    icon: kge
  }));
};
rj.displayName = "EllipsisOutlined";
const ij = /* @__PURE__ */ x.forwardRef(rj);
var Rge = { icon: { tag: "svg", attrs: { viewBox: "64 64 896 896", focusable: "false" }, children: [{ tag: "path", attrs: { d: "M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm-32 232c0-4.4 3.6-8 8-8h48c4.4 0 8 3.6 8 8v272c0 4.4-3.6 8-8 8h-48c-4.4 0-8-3.6-8-8V296zm32 440a48.01 48.01 0 010-96 48.01 48.01 0 010 96z" } }] }, name: "exclamation-circle", theme: "filled" };
const $ge = Rge;
var oj = function(e, n) {
  return /* @__PURE__ */ x.createElement(Hn, de(de({}, e), {}, {
    ref: n,
    icon: $ge
  }));
};
oj.displayName = "ExclamationCircleFilled";
const aj = /* @__PURE__ */ x.forwardRef(oj);
var Dge = { icon: { tag: "svg", attrs: { viewBox: "64 64 896 896", focusable: "false" }, children: [{ tag: "path", attrs: { d: "M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm0 820c-205.4 0-372-166.6-372-372s166.6-372 372-372 372 166.6 372 372-166.6 372-372 372z" } }, { tag: "path", attrs: { d: "M464 688a48 48 0 1096 0 48 48 0 10-96 0zm24-112h48c4.4 0 8-3.6 8-8V296c0-4.4-3.6-8-8-8h-48c-4.4 0-8 3.6-8 8v272c0 4.4 3.6 8 8 8z" } }] }, name: "exclamation-circle", theme: "outlined" };
const Mge = Dge;
var sj = function(e, n) {
  return /* @__PURE__ */ x.createElement(Hn, de(de({}, e), {}, {
    ref: n,
    icon: Mge
  }));
};
sj.displayName = "ExclamationCircleOutlined";
const Fge = /* @__PURE__ */ x.forwardRef(sj);
var Lge = { icon: { tag: "svg", attrs: { viewBox: "64 64 896 896", focusable: "false" }, children: [{ tag: "path", attrs: { d: "M942.2 486.2Q889.47 375.11 816.7 305l-50.88 50.88C807.31 395.53 843.45 447.4 874.7 512 791.5 684.2 673.4 766 512 766q-72.67 0-133.87-22.38L323 798.75Q408 838 512 838q288.3 0 430.2-300.3a60.29 60.29 0 000-51.5zm-63.57-320.64L836 122.88a8 8 0 00-11.32 0L715.31 232.2Q624.86 186 512 186q-288.3 0-430.2 300.3a60.3 60.3 0 000 51.5q56.69 119.4 136.5 191.41L112.48 835a8 8 0 000 11.31L155.17 889a8 8 0 0011.31 0l712.15-712.12a8 8 0 000-11.32zM149.3 512C232.6 339.8 350.7 258 512 258c54.54 0 104.13 9.36 149.12 28.39l-70.3 70.3a176 176 0 00-238.13 238.13l-83.42 83.42C223.1 637.49 183.3 582.28 149.3 512zm246.7 0a112.11 112.11 0 01146.2-106.69L401.31 546.2A112 112 0 01396 512z" } }, { tag: "path", attrs: { d: "M508 624c-3.46 0-6.87-.16-10.25-.47l-52.82 52.82a176.09 176.09 0 00227.42-227.42l-52.82 52.82c.31 3.38.47 6.79.47 10.25a111.94 111.94 0 01-112 112z" } }] }, name: "eye-invisible", theme: "outlined" };
const Vge = Lge;
var uj = function(e, n) {
  return /* @__PURE__ */ x.createElement(Hn, de(de({}, e), {}, {
    ref: n,
    icon: Vge
  }));
};
uj.displayName = "EyeInvisibleOutlined";
const Bge = /* @__PURE__ */ x.forwardRef(uj);
var Hge = { icon: { tag: "svg", attrs: { viewBox: "64 64 896 896", focusable: "false" }, children: [{ tag: "path", attrs: { d: "M942.2 486.2C847.4 286.5 704.1 186 512 186c-192.2 0-335.4 100.5-430.2 300.3a60.3 60.3 0 000 51.5C176.6 737.5 319.9 838 512 838c192.2 0 335.4-100.5 430.2-300.3 7.7-16.2 7.7-35 0-51.5zM512 766c-161.3 0-279.4-81.8-362.7-254C232.6 339.8 350.7 258 512 258c161.3 0 279.4 81.8 362.7 254C791.5 684.2 673.4 766 512 766zm-4-430c-97.2 0-176 78.8-176 176s78.8 176 176 176 176-78.8 176-176-78.8-176-176-176zm0 288c-61.9 0-112-50.1-112-112s50.1-112 112-112 112 50.1 112 112-50.1 112-112 112z" } }] }, name: "eye", theme: "outlined" };
const Wge = Hge;
var lj = function(e, n) {
  return /* @__PURE__ */ x.createElement(Hn, de(de({}, e), {}, {
    ref: n,
    icon: Wge
  }));
};
lj.displayName = "EyeOutlined";
const cj = /* @__PURE__ */ x.forwardRef(lj);
var jge = { icon: { tag: "svg", attrs: { viewBox: "64 64 896 896", focusable: "false" }, children: [{ tag: "path", attrs: { d: "M854.6 288.6L639.4 73.4c-6-6-14.1-9.4-22.6-9.4H192c-17.7 0-32 14.3-32 32v832c0 17.7 14.3 32 32 32h640c17.7 0 32-14.3 32-32V311.3c0-8.5-3.4-16.7-9.4-22.7zM790.2 326H602V137.8L790.2 326zm1.8 562H232V136h302v216a42 42 0 0042 42h216v494z" } }] }, name: "file", theme: "outlined" };
const zge = jge;
var dj = function(e, n) {
  return /* @__PURE__ */ x.createElement(Hn, de(de({}, e), {}, {
    ref: n,
    icon: zge
  }));
};
dj.displayName = "FileOutlined";
const Gge = /* @__PURE__ */ x.forwardRef(dj);
var Uge = { icon: function(e, n) {
  return { tag: "svg", attrs: { viewBox: "64 64 896 896", focusable: "false" }, children: [{ tag: "path", attrs: { d: "M534 352V136H232v752h560V394H576a42 42 0 01-42-42z", fill: n } }, { tag: "path", attrs: { d: "M854.6 288.6L639.4 73.4c-6-6-14.1-9.4-22.6-9.4H192c-17.7 0-32 14.3-32 32v832c0 17.7 14.3 32 32 32h640c17.7 0 32-14.3 32-32V311.3c0-8.5-3.4-16.7-9.4-22.7zM602 137.8L790.2 326H602V137.8zM792 888H232V136h302v216a42 42 0 0042 42h216v494z", fill: e } }] };
}, name: "file", theme: "twotone" };
const Xge = Uge;
var fj = function(e, n) {
  return /* @__PURE__ */ x.createElement(Hn, de(de({}, e), {}, {
    ref: n,
    icon: Xge
  }));
};
fj.displayName = "FileTwoTone";
const Yge = /* @__PURE__ */ x.forwardRef(fj);
var Zge = { icon: { tag: "svg", attrs: { viewBox: "64 64 896 896", focusable: "false" }, children: [{ tag: "path", attrs: { d: "M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm32 664c0 4.4-3.6 8-8 8h-48c-4.4 0-8-3.6-8-8V456c0-4.4 3.6-8 8-8h48c4.4 0 8 3.6 8 8v272zm-32-344a48.01 48.01 0 010-96 48.01 48.01 0 010 96z" } }] }, name: "info-circle", theme: "filled" };
const Jge = Zge;
var hj = function(e, n) {
  return /* @__PURE__ */ x.createElement(Hn, de(de({}, e), {}, {
    ref: n,
    icon: Jge
  }));
};
hj.displayName = "InfoCircleFilled";
const Kge = /* @__PURE__ */ x.forwardRef(hj);
var qge = { icon: { tag: "svg", attrs: { viewBox: "64 64 896 896", focusable: "false" }, children: [{ tag: "path", attrs: { d: "M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm0 820c-205.4 0-372-166.6-372-372s166.6-372 372-372 372 166.6 372 372-166.6 372-372 372z" } }, { tag: "path", attrs: { d: "M464 336a48 48 0 1096 0 48 48 0 10-96 0zm72 112h-48c-4.4 0-8 3.6-8 8v272c0 4.4 3.6 8 8 8h48c4.4 0 8-3.6 8-8V456c0-4.4-3.6-8-8-8z" } }] }, name: "info-circle", theme: "outlined" };
const Qge = qge;
var pj = function(e, n) {
  return /* @__PURE__ */ x.createElement(Hn, de(de({}, e), {}, {
    ref: n,
    icon: Qge
  }));
};
pj.displayName = "InfoCircleOutlined";
const dC = /* @__PURE__ */ x.forwardRef(pj);
var e0e = { icon: { tag: "svg", attrs: { viewBox: "64 64 896 896", focusable: "false" }, children: [{ tag: "path", attrs: { d: "M724 218.3V141c0-6.7-7.7-10.4-12.9-6.3L260.3 486.8a31.86 31.86 0 000 50.3l450.8 352.1c5.3 4.1 12.9.4 12.9-6.3v-77.3c0-4.9-2.3-9.6-6.1-12.6l-360-281 360-281.1c3.8-3 6.1-7.7 6.1-12.6z" } }] }, name: "left", theme: "outlined" };
const t0e = e0e;
var gj = function(e, n) {
  return /* @__PURE__ */ x.createElement(Hn, de(de({}, e), {}, {
    ref: n,
    icon: t0e
  }));
};
gj.displayName = "LeftOutlined";
const V0 = /* @__PURE__ */ x.forwardRef(gj);
var n0e = { icon: { tag: "svg", attrs: { viewBox: "0 0 1024 1024", focusable: "false" }, children: [{ tag: "path", attrs: { d: "M988 548c-19.9 0-36-16.1-36-36 0-59.4-11.6-117-34.6-171.3a440.45 440.45 0 00-94.3-139.9 437.71 437.71 0 00-139.9-94.3C629 83.6 571.4 72 512 72c-19.9 0-36-16.1-36-36s16.1-36 36-36c69.1 0 136.2 13.5 199.3 40.3C772.3 66 827 103 874 150c47 47 83.9 101.8 109.7 162.7 26.7 63.1 40.2 130.2 40.2 199.3.1 19.9-16 36-35.9 36z" } }] }, name: "loading", theme: "outlined" };
const r0e = n0e;
var mj = function(e, n) {
  return /* @__PURE__ */ x.createElement(Hn, de(de({}, e), {}, {
    ref: n,
    icon: r0e
  }));
};
mj.displayName = "LoadingOutlined";
const lc = /* @__PURE__ */ x.forwardRef(mj);
var i0e = { icon: { tag: "svg", attrs: { viewBox: "64 64 896 896", focusable: "false" }, children: [{ tag: "path", attrs: { d: "M779.3 196.6c-94.2-94.2-247.6-94.2-341.7 0l-261 260.8c-1.7 1.7-2.6 4-2.6 6.4s.9 4.7 2.6 6.4l36.9 36.9a9 9 0 0012.7 0l261-260.8c32.4-32.4 75.5-50.2 121.3-50.2s88.9 17.8 121.2 50.2c32.4 32.4 50.2 75.5 50.2 121.2 0 45.8-17.8 88.8-50.2 121.2l-266 265.9-43.1 43.1c-40.3 40.3-105.8 40.3-146.1 0-19.5-19.5-30.2-45.4-30.2-73s10.7-53.5 30.2-73l263.9-263.8c6.7-6.6 15.5-10.3 24.9-10.3h.1c9.4 0 18.1 3.7 24.7 10.3 6.7 6.7 10.3 15.5 10.3 24.9 0 9.3-3.7 18.1-10.3 24.7L372.4 653c-1.7 1.7-2.6 4-2.6 6.4s.9 4.7 2.6 6.4l36.9 36.9a9 9 0 0012.7 0l215.6-215.6c19.9-19.9 30.8-46.3 30.8-74.4s-11-54.6-30.8-74.4c-41.1-41.1-107.9-41-149 0L463 364 224.8 602.1A172.22 172.22 0 00174 724.8c0 46.3 18.1 89.8 50.8 122.5 33.9 33.8 78.3 50.7 122.7 50.7 44.4 0 88.8-16.9 122.6-50.7l309.2-309C824.8 492.7 850 432 850 367.5c.1-64.6-25.1-125.3-70.7-170.9z" } }] }, name: "paper-clip", theme: "outlined" };
const o0e = i0e;
var vj = function(e, n) {
  return /* @__PURE__ */ x.createElement(Hn, de(de({}, e), {}, {
    ref: n,
    icon: o0e
  }));
};
vj.displayName = "PaperClipOutlined";
const a0e = /* @__PURE__ */ x.forwardRef(vj);
var s0e = { icon: function(e, n) {
  return { tag: "svg", attrs: { viewBox: "64 64 896 896", focusable: "false" }, children: [{ tag: "path", attrs: { d: "M928 160H96c-17.7 0-32 14.3-32 32v640c0 17.7 14.3 32 32 32h832c17.7 0 32-14.3 32-32V192c0-17.7-14.3-32-32-32zm-40 632H136v-39.9l138.5-164.3 150.1 178L658.1 489 888 761.6V792zm0-129.8L664.2 396.8c-3.2-3.8-9-3.8-12.2 0L424.6 666.4l-144-170.7c-3.2-3.8-9-3.8-12.2 0L136 652.7V232h752v430.2z", fill: e } }, { tag: "path", attrs: { d: "M424.6 765.8l-150.1-178L136 752.1V792h752v-30.4L658.1 489z", fill: n } }, { tag: "path", attrs: { d: "M136 652.7l132.4-157c3.2-3.8 9-3.8 12.2 0l144 170.7L652 396.8c3.2-3.8 9-3.8 12.2 0L888 662.2V232H136v420.7zM304 280a88 88 0 110 176 88 88 0 010-176z", fill: n } }, { tag: "path", attrs: { d: "M276 368a28 28 0 1056 0 28 28 0 10-56 0z", fill: n } }, { tag: "path", attrs: { d: "M304 456a88 88 0 100-176 88 88 0 000 176zm0-116c15.5 0 28 12.5 28 28s-12.5 28-28 28-28-12.5-28-28 12.5-28 28-28z", fill: e } }] };
}, name: "picture", theme: "twotone" };
const u0e = s0e;
var bj = function(e, n) {
  return /* @__PURE__ */ x.createElement(Hn, de(de({}, e), {}, {
    ref: n,
    icon: u0e
  }));
};
bj.displayName = "PictureTwoTone";
const l0e = /* @__PURE__ */ x.forwardRef(bj);
var c0e = { icon: { tag: "svg", attrs: { viewBox: "64 64 896 896", focusable: "false" }, children: [{ tag: "path", attrs: { d: "M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm0 820c-205.4 0-372-166.6-372-372s166.6-372 372-372 372 166.6 372 372-166.6 372-372 372z" } }, { tag: "path", attrs: { d: "M623.6 316.7C593.6 290.4 554 276 512 276s-81.6 14.5-111.6 40.7C369.2 344 352 380.7 352 420v7.6c0 4.4 3.6 8 8 8h48c4.4 0 8-3.6 8-8V420c0-44.1 43.1-80 96-80s96 35.9 96 80c0 31.1-22 59.6-56.1 72.7-21.2 8.1-39.2 22.3-52.1 40.9-13.1 19-19.9 41.8-19.9 64.9V620c0 4.4 3.6 8 8 8h48c4.4 0 8-3.6 8-8v-22.7a48.3 48.3 0 0130.9-44.8c59-22.7 97.1-74.7 97.1-132.5.1-39.3-17.1-76-48.3-103.3zM472 732a40 40 0 1080 0 40 40 0 10-80 0z" } }] }, name: "question-circle", theme: "outlined" };
const d0e = c0e;
var yj = function(e, n) {
  return /* @__PURE__ */ x.createElement(Hn, de(de({}, e), {}, {
    ref: n,
    icon: d0e
  }));
};
yj.displayName = "QuestionCircleOutlined";
const f0e = /* @__PURE__ */ x.forwardRef(yj);
var h0e = { icon: { tag: "svg", attrs: { viewBox: "64 64 896 896", focusable: "false" }, children: [{ tag: "path", attrs: { d: "M765.7 486.8L314.9 134.7A7.97 7.97 0 00302 141v77.3c0 4.9 2.3 9.6 6.1 12.6l360 281.1-360 281.1c-3.9 3-6.1 7.7-6.1 12.6V883c0 6.7 7.7 10.4 12.9 6.3l450.8-352.1a31.96 31.96 0 000-50.4z" } }] }, name: "right", theme: "outlined" };
const p0e = h0e;
var xj = function(e, n) {
  return /* @__PURE__ */ x.createElement(Hn, de(de({}, e), {}, {
    ref: n,
    icon: p0e
  }));
};
xj.displayName = "RightOutlined";
const Qh = /* @__PURE__ */ x.forwardRef(xj);
var g0e = { icon: { tag: "svg", attrs: { viewBox: "64 64 896 896", focusable: "false" }, children: [{ tag: "path", attrs: { d: "M909.6 854.5L649.9 594.8C690.2 542.7 712 479 712 412c0-80.2-31.3-155.4-87.9-212.1-56.6-56.7-132-87.9-212.1-87.9s-155.5 31.3-212.1 87.9C143.2 256.5 112 331.8 112 412c0 80.1 31.3 155.5 87.9 212.1C256.5 680.8 331.8 712 412 712c67 0 130.6-21.8 182.7-62l259.7 259.6a8.2 8.2 0 0011.6 0l43.6-43.5a8.2 8.2 0 000-11.6zM570.4 570.4C528 612.7 471.8 636 412 636s-116-23.3-158.4-65.6C211.3 528 188 471.8 188 412s23.3-116.1 65.6-158.4C296 211.3 352.2 188 412 188s116.1 23.2 158.4 65.6S636 352.2 636 412s-23.3 116.1-65.6 158.4z" } }] }, name: "search", theme: "outlined" };
const m0e = g0e;
var Cj = function(e, n) {
  return /* @__PURE__ */ x.createElement(Hn, de(de({}, e), {}, {
    ref: n,
    icon: m0e
  }));
};
Cj.displayName = "SearchOutlined";
const rA = /* @__PURE__ */ x.forwardRef(Cj);
var v0e = { icon: { tag: "svg", attrs: { viewBox: "64 64 896 896", focusable: "false" }, children: [{ tag: "path", attrs: { d: "M908.1 353.1l-253.9-36.9L540.7 86.1c-3.1-6.3-8.2-11.4-14.5-14.5-15.8-7.8-35-1.3-42.9 14.5L369.8 316.2l-253.9 36.9c-7 1-13.4 4.3-18.3 9.3a32.05 32.05 0 00.6 45.3l183.7 179.1-43.4 252.9a31.95 31.95 0 0046.4 33.7L512 754l227.1 119.4c6.2 3.3 13.4 4.4 20.3 3.2 17.4-3 29.1-19.5 26.1-36.9l-43.4-252.9 183.7-179.1c5-4.9 8.3-11.3 9.3-18.3 2.7-17.5-9.5-33.7-27-36.3z" } }] }, name: "star", theme: "filled" };
const b0e = v0e;
var wj = function(e, n) {
  return /* @__PURE__ */ x.createElement(Hn, de(de({}, e), {}, {
    ref: n,
    icon: b0e
  }));
};
wj.displayName = "StarFilled";
const y0e = /* @__PURE__ */ x.forwardRef(wj);
var x0e = { icon: { tag: "svg", attrs: { viewBox: "0 0 1024 1024", focusable: "false" }, children: [{ tag: "path", attrs: { d: "M873.1 596.2l-164-208A32 32 0 00684 376h-64.8c-6.7 0-10.4 7.7-6.3 13l144.3 183H152c-4.4 0-8 3.6-8 8v60c0 4.4 3.6 8 8 8h695.9c26.8 0 41.7-30.8 25.2-51.8z" } }] }, name: "swap-right", theme: "outlined" };
const C0e = x0e;
var Ej = function(e, n) {
  return /* @__PURE__ */ x.createElement(Hn, de(de({}, e), {}, {
    ref: n,
    icon: C0e
  }));
};
Ej.displayName = "SwapRightOutlined";
const w0e = /* @__PURE__ */ x.forwardRef(Ej);
var E0e = { icon: { tag: "svg", attrs: { viewBox: "64 64 896 896", focusable: "false" }, children: [{ tag: "path", attrs: { d: "M890.5 755.3L537.9 269.2c-12.8-17.6-39-17.6-51.7 0L133.5 755.3A8 8 0 00140 768h75c5.1 0 9.9-2.5 12.9-6.6L512 369.8l284.1 391.6c3 4.1 7.8 6.6 12.9 6.6h75c6.5 0 10.3-7.4 6.5-12.7z" } }] }, name: "up", theme: "outlined" };
const S0e = E0e;
var Sj = function(e, n) {
  return /* @__PURE__ */ x.createElement(Hn, de(de({}, e), {}, {
    ref: n,
    icon: S0e
  }));
};
Sj.displayName = "UpOutlined";
const I0e = /* @__PURE__ */ x.forwardRef(Sj);
var _0e = { icon: { tag: "svg", attrs: { viewBox: "64 64 896 896", focusable: "false" }, children: [{ tag: "path", attrs: { d: "M400 317.7h73.9V656c0 4.4 3.6 8 8 8h60c4.4 0 8-3.6 8-8V317.7H624c6.7 0 10.4-7.7 6.3-12.9L518.3 163a8 8 0 00-12.6 0l-112 141.7c-4.1 5.3-.4 13 6.3 13zM878 626h-60c-4.4 0-8 3.6-8 8v154H214V634c0-4.4-3.6-8-8-8h-60c-4.4 0-8 3.6-8 8v198c0 17.7 14.3 32 32 32h684c17.7 0 32-14.3 32-32V634c0-4.4-3.6-8-8-8z" } }] }, name: "upload", theme: "outlined" };
const A0e = _0e;
var Ij = function(e, n) {
  return /* @__PURE__ */ x.createElement(Hn, de(de({}, e), {}, {
    ref: n,
    icon: A0e
  }));
};
Ij.displayName = "UploadOutlined";
const _j = /* @__PURE__ */ x.forwardRef(Ij);
function G() {
  return G = Object.assign ? Object.assign.bind() : function(t) {
    for (var e = 1; e < arguments.length; e++) {
      var n = arguments[e];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (t[r] = n[r]);
    }
    return t;
  }, G.apply(this, arguments);
}
const T0e = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: G
}, Symbol.toStringTag, { value: "Module" }));
function zn(t, e) {
  if (!(t instanceof e))
    throw new TypeError("Cannot call a class as a function");
}
function L7(t, e) {
  for (var n = 0; n < e.length; n++) {
    var r = e[n];
    r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(t, tW(r.key), r);
  }
}
function Gn(t, e, n) {
  return e && L7(t.prototype, e), n && L7(t, n), Object.defineProperty(t, "prototype", {
    writable: !1
  }), t;
}
function ix(t, e) {
  return ix = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(r, i) {
    return r.__proto__ = i, r;
  }, ix(t, e);
}
function Pr(t, e) {
  if (typeof e != "function" && e !== null)
    throw new TypeError("Super expression must either be null or a function");
  t.prototype = Object.create(e && e.prototype, {
    constructor: {
      value: t,
      writable: !0,
      configurable: !0
    }
  }), Object.defineProperty(t, "prototype", {
    writable: !1
  }), e && ix(t, e);
}
function ox(t) {
  return ox = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(n) {
    return n.__proto__ || Object.getPrototypeOf(n);
  }, ox(t);
}
function O0e() {
  if (typeof Reflect > "u" || !Reflect.construct || Reflect.construct.sham)
    return !1;
  if (typeof Proxy == "function")
    return !0;
  try {
    return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    })), !0;
  } catch {
    return !1;
  }
}
function It(t) {
  if (t === void 0)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return t;
}
function P0e(t, e) {
  if (e && (_t(e) === "object" || typeof e == "function"))
    return e;
  if (e !== void 0)
    throw new TypeError("Derived constructors may only return object or undefined");
  return It(t);
}
function Hr(t) {
  var e = O0e();
  return function() {
    var r = ox(t), i;
    if (e) {
      var o = ox(this).constructor;
      i = Reflect.construct(r, arguments, o);
    } else
      i = r.apply(this, arguments);
    return P0e(this, i);
  };
}
var vI = { exports: {} }, tr = {};
/**
 * @license React
 * react-is.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var V7;
function N0e() {
  return V7 || (V7 = 1, process.env.NODE_ENV !== "production" && function() {
    var t = Symbol.for("react.element"), e = Symbol.for("react.portal"), n = Symbol.for("react.fragment"), r = Symbol.for("react.strict_mode"), i = Symbol.for("react.profiler"), o = Symbol.for("react.provider"), a = Symbol.for("react.context"), s = Symbol.for("react.server_context"), u = Symbol.for("react.forward_ref"), l = Symbol.for("react.suspense"), c = Symbol.for("react.suspense_list"), d = Symbol.for("react.memo"), f = Symbol.for("react.lazy"), h = Symbol.for("react.offscreen"), p = !1, v = !1, m = !1, b = !1, y = !1, w;
    w = Symbol.for("react.module.reference");
    function S(he) {
      return !!(typeof he == "string" || typeof he == "function" || he === n || he === i || y || he === r || he === l || he === c || b || he === h || p || v || m || typeof he == "object" && he !== null && (he.$$typeof === f || he.$$typeof === d || he.$$typeof === o || he.$$typeof === a || he.$$typeof === u || // This needs to include all possible module reference object
      // types supported by any Flight configuration anywhere since
      // we don't know which Flight build this will end up being used
      // with.
      he.$$typeof === w || he.getModuleId !== void 0));
    }
    function E(he) {
      if (typeof he == "object" && he !== null) {
        var fe = he.$$typeof;
        switch (fe) {
          case t:
            var _e = he.type;
            switch (_e) {
              case n:
              case i:
              case r:
              case l:
              case c:
                return _e;
              default:
                var Ne = _e && _e.$$typeof;
                switch (Ne) {
                  case s:
                  case a:
                  case u:
                  case f:
                  case d:
                  case o:
                    return Ne;
                  default:
                    return fe;
                }
            }
          case e:
            return fe;
        }
      }
    }
    var I = a, _ = o, A = t, P = u, N = n, k = f, D = d, R = e, V = i, $ = r, F = l, M = c, B = !1, X = !1;
    function L(he) {
      return B || (B = !0, console.warn("The ReactIs.isAsyncMode() alias has been deprecated, and will be removed in React 18+.")), !1;
    }
    function j(he) {
      return X || (X = !0, console.warn("The ReactIs.isConcurrentMode() alias has been deprecated, and will be removed in React 18+.")), !1;
    }
    function K(he) {
      return E(he) === a;
    }
    function W(he) {
      return E(he) === o;
    }
    function Y(he) {
      return typeof he == "object" && he !== null && he.$$typeof === t;
    }
    function U(he) {
      return E(he) === u;
    }
    function Q(he) {
      return E(he) === n;
    }
    function Z(he) {
      return E(he) === f;
    }
    function ee(he) {
      return E(he) === d;
    }
    function ie(he) {
      return E(he) === e;
    }
    function oe(he) {
      return E(he) === i;
    }
    function se(he) {
      return E(he) === r;
    }
    function te(he) {
      return E(he) === l;
    }
    function ge(he) {
      return E(he) === c;
    }
    tr.ContextConsumer = I, tr.ContextProvider = _, tr.Element = A, tr.ForwardRef = P, tr.Fragment = N, tr.Lazy = k, tr.Memo = D, tr.Portal = R, tr.Profiler = V, tr.StrictMode = $, tr.Suspense = F, tr.SuspenseList = M, tr.isAsyncMode = L, tr.isConcurrentMode = j, tr.isContextConsumer = K, tr.isContextProvider = W, tr.isElement = Y, tr.isForwardRef = U, tr.isFragment = Q, tr.isLazy = Z, tr.isMemo = ee, tr.isPortal = ie, tr.isProfiler = oe, tr.isStrictMode = se, tr.isSuspense = te, tr.isSuspenseList = ge, tr.isValidElementType = S, tr.typeOf = E;
  }()), tr;
}
var nr = {};
/**
 * @license React
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var B7;
function k0e() {
  if (B7)
    return nr;
  B7 = 1;
  var t = Symbol.for("react.element"), e = Symbol.for("react.portal"), n = Symbol.for("react.fragment"), r = Symbol.for("react.strict_mode"), i = Symbol.for("react.profiler"), o = Symbol.for("react.provider"), a = Symbol.for("react.context"), s = Symbol.for("react.server_context"), u = Symbol.for("react.forward_ref"), l = Symbol.for("react.suspense"), c = Symbol.for("react.suspense_list"), d = Symbol.for("react.memo"), f = Symbol.for("react.lazy"), h = Symbol.for("react.offscreen"), p;
  p = Symbol.for("react.module.reference");
  function v(m) {
    if (typeof m == "object" && m !== null) {
      var b = m.$$typeof;
      switch (b) {
        case t:
          switch (m = m.type, m) {
            case n:
            case i:
            case r:
            case l:
            case c:
              return m;
            default:
              switch (m = m && m.$$typeof, m) {
                case s:
                case a:
                case u:
                case f:
                case d:
                case o:
                  return m;
                default:
                  return b;
              }
          }
        case e:
          return b;
      }
    }
  }
  return nr.ContextConsumer = a, nr.ContextProvider = o, nr.Element = t, nr.ForwardRef = u, nr.Fragment = n, nr.Lazy = f, nr.Memo = d, nr.Portal = e, nr.Profiler = i, nr.StrictMode = r, nr.Suspense = l, nr.SuspenseList = c, nr.isAsyncMode = function() {
    return !1;
  }, nr.isConcurrentMode = function() {
    return !1;
  }, nr.isContextConsumer = function(m) {
    return v(m) === a;
  }, nr.isContextProvider = function(m) {
    return v(m) === o;
  }, nr.isElement = function(m) {
    return typeof m == "object" && m !== null && m.$$typeof === t;
  }, nr.isForwardRef = function(m) {
    return v(m) === u;
  }, nr.isFragment = function(m) {
    return v(m) === n;
  }, nr.isLazy = function(m) {
    return v(m) === f;
  }, nr.isMemo = function(m) {
    return v(m) === d;
  }, nr.isPortal = function(m) {
    return v(m) === e;
  }, nr.isProfiler = function(m) {
    return v(m) === i;
  }, nr.isStrictMode = function(m) {
    return v(m) === r;
  }, nr.isSuspense = function(m) {
    return v(m) === l;
  }, nr.isSuspenseList = function(m) {
    return v(m) === c;
  }, nr.isValidElementType = function(m) {
    return typeof m == "string" || typeof m == "function" || m === n || m === i || m === r || m === l || m === c || m === h || typeof m == "object" && m !== null && (m.$$typeof === f || m.$$typeof === d || m.$$typeof === o || m.$$typeof === a || m.$$typeof === u || m.$$typeof === p || m.getModuleId !== void 0);
  }, nr.typeOf = v, nr;
}
process.env.NODE_ENV === "production" ? vI.exports = k0e() : vI.exports = N0e();
var Aj = vI.exports;
function Xa(t) {
  var e = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, n = [];
  return O.Children.forEach(t, function(r) {
    r == null && !e.keepEmpty || (Array.isArray(r) ? n = n.concat(Xa(r)) : Aj.isFragment(r) && r.props ? n = n.concat(Xa(r.props.children, e)) : n.push(r));
  }), n;
}
function R0e(t) {
  return t instanceof HTMLElement || t instanceof SVGElement;
}
function md(t) {
  return R0e(t) ? t : t instanceof O.Component ? ks.findDOMNode(t) : null;
}
function Cp(t, e, n) {
  var r = x.useRef({});
  return (!("value" in r.current) || n(r.current.condition, e)) && (r.current.value = t(), r.current.condition = e), r.current.value;
}
function Tj(t, e) {
  typeof t == "function" ? t(e) : _t(t) === "object" && t && "current" in t && (t.current = e);
}
function Ja() {
  for (var t = arguments.length, e = new Array(t), n = 0; n < t; n++)
    e[n] = arguments[n];
  var r = e.filter(function(i) {
    return i;
  });
  return r.length <= 1 ? r[0] : function(i) {
    e.forEach(function(o) {
      Tj(o, i);
    });
  };
}
function iA() {
  for (var t = arguments.length, e = new Array(t), n = 0; n < t; n++)
    e[n] = arguments[n];
  return Cp(function() {
    return Ja.apply(void 0, e);
  }, e, function(r, i) {
    return r.length !== i.length || r.every(function(o, a) {
      return o !== i[a];
    });
  });
}
function Rm(t) {
  var e, n, r = Aj.isMemo(t) ? t.type.type : t.type;
  return !(typeof r == "function" && !((e = r.prototype) !== null && e !== void 0 && e.render) || typeof t == "function" && !((n = t.prototype) !== null && n !== void 0 && n.render));
}
var bI = /* @__PURE__ */ x.createContext(null);
function $0e(t) {
  var e = t.children, n = t.onBatchResize, r = x.useRef(0), i = x.useRef([]), o = x.useContext(bI), a = x.useCallback(function(s, u, l) {
    r.current += 1;
    var c = r.current;
    i.current.push({
      size: s,
      element: u,
      data: l
    }), Promise.resolve().then(function() {
      c === r.current && (n == null || n(i.current), i.current = []);
    }), o == null || o(s, u, l);
  }, [n, o]);
  return /* @__PURE__ */ x.createElement(bI.Provider, {
    value: a
  }, e);
}
var Oj = function() {
  if (typeof Map < "u")
    return Map;
  function t(e, n) {
    var r = -1;
    return e.some(function(i, o) {
      return i[0] === n ? (r = o, !0) : !1;
    }), r;
  }
  return (
    /** @class */
    function() {
      function e() {
        this.__entries__ = [];
      }
      return Object.defineProperty(e.prototype, "size", {
        /**
         * @returns {boolean}
         */
        get: function() {
          return this.__entries__.length;
        },
        enumerable: !0,
        configurable: !0
      }), e.prototype.get = function(n) {
        var r = t(this.__entries__, n), i = this.__entries__[r];
        return i && i[1];
      }, e.prototype.set = function(n, r) {
        var i = t(this.__entries__, n);
        ~i ? this.__entries__[i][1] = r : this.__entries__.push([n, r]);
      }, e.prototype.delete = function(n) {
        var r = this.__entries__, i = t(r, n);
        ~i && r.splice(i, 1);
      }, e.prototype.has = function(n) {
        return !!~t(this.__entries__, n);
      }, e.prototype.clear = function() {
        this.__entries__.splice(0);
      }, e.prototype.forEach = function(n, r) {
        r === void 0 && (r = null);
        for (var i = 0, o = this.__entries__; i < o.length; i++) {
          var a = o[i];
          n.call(r, a[1], a[0]);
        }
      }, e;
    }()
  );
}(), yI = typeof window < "u" && typeof document < "u" && window.document === document, ax = function() {
  return typeof global < "u" && global.Math === Math ? global : typeof self < "u" && self.Math === Math ? self : typeof window < "u" && window.Math === Math ? window : Function("return this")();
}(), D0e = function() {
  return typeof requestAnimationFrame == "function" ? requestAnimationFrame.bind(ax) : function(t) {
    return setTimeout(function() {
      return t(Date.now());
    }, 1e3 / 60);
  };
}(), M0e = 2;
function F0e(t, e) {
  var n = !1, r = !1, i = 0;
  function o() {
    n && (n = !1, t()), r && s();
  }
  function a() {
    D0e(o);
  }
  function s() {
    var u = Date.now();
    if (n) {
      if (u - i < M0e)
        return;
      r = !0;
    } else
      n = !0, r = !1, setTimeout(a, e);
    i = u;
  }
  return s;
}
var L0e = 20, V0e = ["top", "right", "bottom", "left", "width", "height", "size", "weight"], B0e = typeof MutationObserver < "u", H0e = (
  /** @class */
  function() {
    function t() {
      this.connected_ = !1, this.mutationEventsAdded_ = !1, this.mutationsObserver_ = null, this.observers_ = [], this.onTransitionEnd_ = this.onTransitionEnd_.bind(this), this.refresh = F0e(this.refresh.bind(this), L0e);
    }
    return t.prototype.addObserver = function(e) {
      ~this.observers_.indexOf(e) || this.observers_.push(e), this.connected_ || this.connect_();
    }, t.prototype.removeObserver = function(e) {
      var n = this.observers_, r = n.indexOf(e);
      ~r && n.splice(r, 1), !n.length && this.connected_ && this.disconnect_();
    }, t.prototype.refresh = function() {
      var e = this.updateObservers_();
      e && this.refresh();
    }, t.prototype.updateObservers_ = function() {
      var e = this.observers_.filter(function(n) {
        return n.gatherActive(), n.hasActive();
      });
      return e.forEach(function(n) {
        return n.broadcastActive();
      }), e.length > 0;
    }, t.prototype.connect_ = function() {
      !yI || this.connected_ || (document.addEventListener("transitionend", this.onTransitionEnd_), window.addEventListener("resize", this.refresh), B0e ? (this.mutationsObserver_ = new MutationObserver(this.refresh), this.mutationsObserver_.observe(document, {
        attributes: !0,
        childList: !0,
        characterData: !0,
        subtree: !0
      })) : (document.addEventListener("DOMSubtreeModified", this.refresh), this.mutationEventsAdded_ = !0), this.connected_ = !0);
    }, t.prototype.disconnect_ = function() {
      !yI || !this.connected_ || (document.removeEventListener("transitionend", this.onTransitionEnd_), window.removeEventListener("resize", this.refresh), this.mutationsObserver_ && this.mutationsObserver_.disconnect(), this.mutationEventsAdded_ && document.removeEventListener("DOMSubtreeModified", this.refresh), this.mutationsObserver_ = null, this.mutationEventsAdded_ = !1, this.connected_ = !1);
    }, t.prototype.onTransitionEnd_ = function(e) {
      var n = e.propertyName, r = n === void 0 ? "" : n, i = V0e.some(function(o) {
        return !!~r.indexOf(o);
      });
      i && this.refresh();
    }, t.getInstance = function() {
      return this.instance_ || (this.instance_ = new t()), this.instance_;
    }, t.instance_ = null, t;
  }()
), Pj = function(t, e) {
  for (var n = 0, r = Object.keys(e); n < r.length; n++) {
    var i = r[n];
    Object.defineProperty(t, i, {
      value: e[i],
      enumerable: !1,
      writable: !1,
      configurable: !0
    });
  }
  return t;
}, ep = function(t) {
  var e = t && t.ownerDocument && t.ownerDocument.defaultView;
  return e || ax;
}, Nj = fC(0, 0, 0, 0);
function sx(t) {
  return parseFloat(t) || 0;
}
function H7(t) {
  for (var e = [], n = 1; n < arguments.length; n++)
    e[n - 1] = arguments[n];
  return e.reduce(function(r, i) {
    var o = t["border-" + i + "-width"];
    return r + sx(o);
  }, 0);
}
function W0e(t) {
  for (var e = ["top", "right", "bottom", "left"], n = {}, r = 0, i = e; r < i.length; r++) {
    var o = i[r], a = t["padding-" + o];
    n[o] = sx(a);
  }
  return n;
}
function j0e(t) {
  var e = t.getBBox();
  return fC(0, 0, e.width, e.height);
}
function z0e(t) {
  var e = t.clientWidth, n = t.clientHeight;
  if (!e && !n)
    return Nj;
  var r = ep(t).getComputedStyle(t), i = W0e(r), o = i.left + i.right, a = i.top + i.bottom, s = sx(r.width), u = sx(r.height);
  if (r.boxSizing === "border-box" && (Math.round(s + o) !== e && (s -= H7(r, "left", "right") + o), Math.round(u + a) !== n && (u -= H7(r, "top", "bottom") + a)), !U0e(t)) {
    var l = Math.round(s + o) - e, c = Math.round(u + a) - n;
    Math.abs(l) !== 1 && (s -= l), Math.abs(c) !== 1 && (u -= c);
  }
  return fC(i.left, i.top, s, u);
}
var G0e = /* @__PURE__ */ function() {
  return typeof SVGGraphicsElement < "u" ? function(t) {
    return t instanceof ep(t).SVGGraphicsElement;
  } : function(t) {
    return t instanceof ep(t).SVGElement && typeof t.getBBox == "function";
  };
}();
function U0e(t) {
  return t === ep(t).document.documentElement;
}
function X0e(t) {
  return yI ? G0e(t) ? j0e(t) : z0e(t) : Nj;
}
function Y0e(t) {
  var e = t.x, n = t.y, r = t.width, i = t.height, o = typeof DOMRectReadOnly < "u" ? DOMRectReadOnly : Object, a = Object.create(o.prototype);
  return Pj(a, {
    x: e,
    y: n,
    width: r,
    height: i,
    top: n,
    right: e + r,
    bottom: i + n,
    left: e
  }), a;
}
function fC(t, e, n, r) {
  return { x: t, y: e, width: n, height: r };
}
var Z0e = (
  /** @class */
  function() {
    function t(e) {
      this.broadcastWidth = 0, this.broadcastHeight = 0, this.contentRect_ = fC(0, 0, 0, 0), this.target = e;
    }
    return t.prototype.isActive = function() {
      var e = X0e(this.target);
      return this.contentRect_ = e, e.width !== this.broadcastWidth || e.height !== this.broadcastHeight;
    }, t.prototype.broadcastRect = function() {
      var e = this.contentRect_;
      return this.broadcastWidth = e.width, this.broadcastHeight = e.height, e;
    }, t;
  }()
), J0e = (
  /** @class */
  /* @__PURE__ */ function() {
    function t(e, n) {
      var r = Y0e(n);
      Pj(this, { target: e, contentRect: r });
    }
    return t;
  }()
), K0e = (
  /** @class */
  function() {
    function t(e, n, r) {
      if (this.activeObservations_ = [], this.observations_ = new Oj(), typeof e != "function")
        throw new TypeError("The callback provided as parameter 1 is not a function.");
      this.callback_ = e, this.controller_ = n, this.callbackCtx_ = r;
    }
    return t.prototype.observe = function(e) {
      if (!arguments.length)
        throw new TypeError("1 argument required, but only 0 present.");
      if (!(typeof Element > "u" || !(Element instanceof Object))) {
        if (!(e instanceof ep(e).Element))
          throw new TypeError('parameter 1 is not of type "Element".');
        var n = this.observations_;
        n.has(e) || (n.set(e, new Z0e(e)), this.controller_.addObserver(this), this.controller_.refresh());
      }
    }, t.prototype.unobserve = function(e) {
      if (!arguments.length)
        throw new TypeError("1 argument required, but only 0 present.");
      if (!(typeof Element > "u" || !(Element instanceof Object))) {
        if (!(e instanceof ep(e).Element))
          throw new TypeError('parameter 1 is not of type "Element".');
        var n = this.observations_;
        n.has(e) && (n.delete(e), n.size || this.controller_.removeObserver(this));
      }
    }, t.prototype.disconnect = function() {
      this.clearActive(), this.observations_.clear(), this.controller_.removeObserver(this);
    }, t.prototype.gatherActive = function() {
      var e = this;
      this.clearActive(), this.observations_.forEach(function(n) {
        n.isActive() && e.activeObservations_.push(n);
      });
    }, t.prototype.broadcastActive = function() {
      if (this.hasActive()) {
        var e = this.callbackCtx_, n = this.activeObservations_.map(function(r) {
          return new J0e(r.target, r.broadcastRect());
        });
        this.callback_.call(e, n, e), this.clearActive();
      }
    }, t.prototype.clearActive = function() {
      this.activeObservations_.splice(0);
    }, t.prototype.hasActive = function() {
      return this.activeObservations_.length > 0;
    }, t;
  }()
), kj = typeof WeakMap < "u" ? /* @__PURE__ */ new WeakMap() : new Oj(), Rj = (
  /** @class */
  /* @__PURE__ */ function() {
    function t(e) {
      if (!(this instanceof t))
        throw new TypeError("Cannot call a class as a function.");
      if (!arguments.length)
        throw new TypeError("1 argument required, but only 0 present.");
      var n = H0e.getInstance(), r = new K0e(e, n, this);
      kj.set(this, r);
    }
    return t;
  }()
);
[
  "observe",
  "unobserve",
  "disconnect"
].forEach(function(t) {
  Rj.prototype[t] = function() {
    var e;
    return (e = kj.get(this))[t].apply(e, arguments);
  };
});
var $j = function() {
  return typeof ax.ResizeObserver < "u" ? ax.ResizeObserver : Rj;
}(), Xu = /* @__PURE__ */ new Map();
function Dj(t) {
  t.forEach(function(e) {
    var n, r = e.target;
    (n = Xu.get(r)) === null || n === void 0 || n.forEach(function(i) {
      return i(r);
    });
  });
}
var Mj = new $j(Dj);
process.env.NODE_ENV;
process.env.NODE_ENV;
function q0e(t, e) {
  Xu.has(t) || (Xu.set(t, /* @__PURE__ */ new Set()), Mj.observe(t)), Xu.get(t).add(e);
}
function Q0e(t, e) {
  Xu.has(t) && (Xu.get(t).delete(e), Xu.get(t).size || (Mj.unobserve(t), Xu.delete(t)));
}
var eme = /* @__PURE__ */ function(t) {
  Pr(n, t);
  var e = Hr(n);
  function n() {
    return zn(this, n), e.apply(this, arguments);
  }
  return Gn(n, [{
    key: "render",
    value: function() {
      return this.props.children;
    }
  }]), n;
}(x.Component);
function tme(t, e) {
  var n = t.children, r = t.disabled, i = x.useRef(null), o = x.useRef(null), a = x.useContext(bI), s = typeof n == "function", u = s ? n(i) : n, l = x.useRef({
    width: -1,
    height: -1,
    offsetWidth: -1,
    offsetHeight: -1
  }), c = !s && /* @__PURE__ */ x.isValidElement(u) && Rm(u), d = c ? u.ref : null, f = iA(d, i), h = function() {
    var b;
    return md(i.current) || // Support `nativeElement` format
    (i.current && _t(i.current) === "object" ? md((b = i.current) === null || b === void 0 ? void 0 : b.nativeElement) : null) || md(o.current);
  };
  x.useImperativeHandle(e, function() {
    return h();
  });
  var p = x.useRef(t);
  p.current = t;
  var v = x.useCallback(function(m) {
    var b = p.current, y = b.onResize, w = b.data, S = m.getBoundingClientRect(), E = S.width, I = S.height, _ = m.offsetWidth, A = m.offsetHeight, P = Math.floor(E), N = Math.floor(I);
    if (l.current.width !== P || l.current.height !== N || l.current.offsetWidth !== _ || l.current.offsetHeight !== A) {
      var k = {
        width: P,
        height: N,
        offsetWidth: _,
        offsetHeight: A
      };
      l.current = k;
      var D = _ === Math.round(E) ? E : _, R = A === Math.round(I) ? I : A, V = de(de({}, k), {}, {
        offsetWidth: D,
        offsetHeight: R
      });
      a == null || a(V, m, w), y && Promise.resolve().then(function() {
        y(V, m);
      });
    }
  }, []);
  return x.useEffect(function() {
    var m = h();
    return m && !r && q0e(m, v), function() {
      return Q0e(m, v);
    };
  }, [i.current, r]), /* @__PURE__ */ x.createElement(eme, {
    ref: o
  }, c ? /* @__PURE__ */ x.cloneElement(u, {
    ref: f
  }) : u);
}
var Fj = /* @__PURE__ */ x.forwardRef(tme);
process.env.NODE_ENV !== "production" && (Fj.displayName = "SingleObserver");
var nme = "rc-observer-key";
function rme(t, e) {
  var n = t.children, r = typeof n == "function" ? [n] : Xa(n);
  return process.env.NODE_ENV !== "production" && (r.length > 1 ? rx(!1, "Find more than one child node with `children` in ResizeObserver. Please use ResizeObserver.Collection instead.") : r.length === 0 && rx(!1, "`children` of ResizeObserver is empty. Nothing is in observe.")), r.map(function(i, o) {
    var a = (i == null ? void 0 : i.key) || "".concat(nme, "-").concat(o);
    return /* @__PURE__ */ x.createElement(Fj, G({}, t, {
      key: a,
      ref: o === 0 ? e : void 0
    }), i);
  });
}
var Gd = /* @__PURE__ */ x.forwardRef(rme);
process.env.NODE_ENV !== "production" && (Gd.displayName = "ResizeObserver");
Gd.Collection = $0e;
function Pi(t, e) {
  var n = de({}, t);
  return Array.isArray(e) && e.forEach(function(r) {
    delete n[r];
  }), n;
}
function ime(t) {
  if (Array.isArray(t))
    return sI(t);
}
function Lj(t) {
  if (typeof Symbol < "u" && t[Symbol.iterator] != null || t["@@iterator"] != null)
    return Array.from(t);
}
function ome() {
  throw new TypeError(`Invalid attempt to spread non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function Ye(t) {
  return ime(t) || Lj(t) || U6(t) || ome();
}
function Vj(t) {
  return nW(t) || Lj(t) || U6(t) || rW();
}
function _s(t, e) {
  for (var n = t, r = 0; r < e.length; r += 1) {
    if (n == null)
      return;
    n = n[e[r]];
  }
  return n;
}
function Bj(t, e, n, r) {
  if (!e.length)
    return n;
  var i = Vj(e), o = i[0], a = i.slice(1), s;
  return !t && typeof o == "number" ? s = [] : Array.isArray(t) ? s = Ye(t) : s = de({}, t), r && n === void 0 && a.length === 1 ? delete s[o][a[0]] : s[o] = Bj(s[o], a, n, r), s;
}
function bs(t, e, n) {
  var r = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : !1;
  return e.length && r && n === void 0 && !_s(t, e.slice(0, -1)) ? t : Bj(t, e, n, r);
}
function ame(t) {
  return _t(t) === "object" && t !== null && Object.getPrototypeOf(t) === Object.prototype;
}
function W7(t) {
  return Array.isArray(t) ? [] : {};
}
var sme = typeof Reflect > "u" ? Object.keys : Reflect.ownKeys;
function Sh() {
  for (var t = arguments.length, e = new Array(t), n = 0; n < t; n++)
    e[n] = arguments[n];
  var r = W7(e[0]);
  return e.forEach(function(i) {
    function o(a, s) {
      var u = new Set(s), l = _s(i, a), c = Array.isArray(l);
      if (c || ame(l)) {
        if (!u.has(l)) {
          u.add(l);
          var d = _s(r, a);
          c ? r = bs(r, a, []) : (!d || _t(d) !== "object") && (r = bs(r, a, W7(l))), sme(l).forEach(function(f) {
            o([].concat(Ye(a), [f]), u);
          });
        }
      } else
        r = bs(r, a, l);
    }
    o([]);
  }), r;
}
const Hj = /* @__PURE__ */ oi(void 0);
function ume() {
}
var Wj = ume;
process.env.NODE_ENV !== "production" && (Wj = function(e, n, r) {
  Wt(e, "[antd: ".concat(n, "] ").concat(r)), process.env.NODE_ENV === "test" && uW();
});
const gn = Wj, jj = {
  // Options.jsx
  items_per_page: "/ page",
  jump_to: "Go to",
  jump_to_confirm: "confirm",
  page: "Page",
  // Pagination.jsx
  prev_page: "Previous Page",
  next_page: "Next Page",
  prev_5: "Previous 5 Pages",
  next_5: "Next 5 Pages",
  prev_3: "Previous 3 Pages",
  next_3: "Next 3 Pages",
  page_size: "Page Size"
};
var lme = {
  locale: "en_US",
  today: "Today",
  now: "Now",
  backToToday: "Back to today",
  ok: "OK",
  clear: "Clear",
  month: "Month",
  year: "Year",
  timeSelect: "select time",
  dateSelect: "select date",
  weekSelect: "Choose a week",
  monthSelect: "Choose a month",
  yearSelect: "Choose a year",
  decadeSelect: "Choose a decade",
  yearFormat: "YYYY",
  dateFormat: "M/D/YYYY",
  dayFormat: "D",
  dateTimeFormat: "M/D/YYYY HH:mm:ss",
  monthBeforeYear: !0,
  previousMonth: "Previous month (PageUp)",
  nextMonth: "Next month (PageDown)",
  previousYear: "Last year (Control + left)",
  nextYear: "Next year (Control + right)",
  previousDecade: "Last decade",
  nextDecade: "Next decade",
  previousCentury: "Last century",
  nextCentury: "Next century"
}, cme = {
  placeholder: "Select time",
  rangePlaceholder: ["Start time", "End time"]
};
const zj = cme;
var dme = {
  lang: G({
    placeholder: "Select date",
    yearPlaceholder: "Select year",
    quarterPlaceholder: "Select quarter",
    monthPlaceholder: "Select month",
    weekPlaceholder: "Select week",
    rangePlaceholder: ["Start date", "End date"],
    rangeYearPlaceholder: ["Start year", "End year"],
    rangeQuarterPlaceholder: ["Start quarter", "End quarter"],
    rangeMonthPlaceholder: ["Start month", "End month"],
    rangeWeekPlaceholder: ["Start week", "End week"]
  }, lme),
  timePickerLocale: G({}, zj)
};
const ux = dme;
var Zo = "${label} is not a valid ${type}", fme = {
  locale: "en",
  Pagination: jj,
  DatePicker: ux,
  TimePicker: zj,
  Calendar: ux,
  global: {
    placeholder: "Please select"
  },
  Table: {
    filterTitle: "Filter menu",
    filterConfirm: "OK",
    filterReset: "Reset",
    filterEmptyText: "No filters",
    filterCheckall: "Select all items",
    filterSearchPlaceholder: "Search in filters",
    emptyText: "No data",
    selectAll: "Select current page",
    selectInvert: "Invert current page",
    selectNone: "Clear all data",
    selectionAll: "Select all data",
    sortTitle: "Sort",
    expand: "Expand row",
    collapse: "Collapse row",
    triggerDesc: "Click to sort descending",
    triggerAsc: "Click to sort ascending",
    cancelSort: "Click to cancel sorting"
  },
  Modal: {
    okText: "OK",
    cancelText: "Cancel",
    justOkText: "OK"
  },
  Popconfirm: {
    okText: "OK",
    cancelText: "Cancel"
  },
  Transfer: {
    titles: ["", ""],
    searchPlaceholder: "Search here",
    itemUnit: "item",
    itemsUnit: "items",
    remove: "Remove",
    selectCurrent: "Select current page",
    removeCurrent: "Remove current page",
    selectAll: "Select all data",
    removeAll: "Remove all data",
    selectInvert: "Invert current page"
  },
  Upload: {
    uploading: "Uploading...",
    removeFile: "Remove file",
    uploadError: "Upload error",
    previewFile: "Preview file",
    downloadFile: "Download file"
  },
  Empty: {
    description: "No data"
  },
  Icon: {
    icon: "icon"
  },
  Text: {
    edit: "Edit",
    copy: "Copy",
    copied: "Copied",
    expand: "Expand"
  },
  PageHeader: {
    back: "Back"
  },
  Form: {
    optional: "(optional)",
    defaultValidateMessages: {
      default: "Field validation error for ${label}",
      required: "Please enter ${label}",
      enum: "${label} must be one of [${enum}]",
      whitespace: "${label} cannot be a blank character",
      date: {
        format: "${label} date format is invalid",
        parse: "${label} cannot be converted to a date",
        invalid: "${label} is an invalid date"
      },
      types: {
        string: Zo,
        method: Zo,
        array: Zo,
        object: Zo,
        number: Zo,
        date: Zo,
        boolean: Zo,
        integer: Zo,
        float: Zo,
        regexp: Zo,
        email: Zo,
        url: Zo,
        hex: Zo
      },
      string: {
        len: "${label} must be ${len} characters",
        min: "${label} must be at least ${min} characters",
        max: "${label} must be up to ${max} characters",
        range: "${label} must be between ${min}-${max} characters"
      },
      number: {
        len: "${label} must be equal to ${len}",
        min: "${label} must be minimum ${min}",
        max: "${label} must be maximum ${max}",
        range: "${label} must be between ${min}-${max}"
      },
      array: {
        len: "Must be ${len} ${label}",
        min: "At least ${min} ${label}",
        max: "At most ${max} ${label}",
        range: "The amount of ${label} must be between ${min}-${max}"
      },
      pattern: {
        mismatch: "${label} does not match the pattern ${pattern}"
      }
    }
  },
  Image: {
    preview: "Preview"
  }
};
const fu = fme;
var PS = G({}, fu.Modal);
function j7(t) {
  t ? PS = G(G({}, PS), t) : PS = G({}, fu.Modal);
}
var hme = /* @__PURE__ */ oi(void 0);
const oA = hme;
var Gj = "internalMark", pme = function(e) {
  var n = e.locale, r = n === void 0 ? {} : n, i = e.children, o = e._ANT_MARK__;
  process.env.NODE_ENV !== "production" && process.env.NODE_ENV !== "production" && gn(o === Gj, "LocaleProvider", "`LocaleProvider` is deprecated. Please use `locale` with `ConfigProvider` instead: http://u.ant.design/locale"), x.useEffect(function() {
    return j7(r && r.Modal), function() {
      j7();
    };
  }, [r]);
  var a = x.useMemo(function() {
    return G(G({}, r), {
      exist: !0
    });
  }, [r]);
  return /* @__PURE__ */ x.createElement(oA.Provider, {
    value: a
  }, i);
};
const gme = pme;
var mme = function(e) {
  var n = e.componentName, r = n === void 0 ? "global" : n, i = e.defaultLocale, o = e.children, a = x.useContext(oA), s = x.useMemo(function() {
    var l, c = i || fu[r], d = (l = a == null ? void 0 : a[r]) !== null && l !== void 0 ? l : {};
    return G(G({}, c instanceof Function ? c() : c), d || {});
  }, [r, i, a]), u = x.useMemo(function() {
    var l = a && a.locale;
    return a && a.exist && !l ? fu.locale : l;
  }, [a]);
  return o(s, u, a);
};
const Ic = mme;
var vme = function(e, n) {
  var r = x.useContext(oA), i = x.useMemo(function() {
    var o, a = n || fu[e], s = (o = r == null ? void 0 : r[e]) !== null && o !== void 0 ? o : {};
    return G(G({}, typeof a == "function" ? a() : a), s || {});
  }, [e, n, r]);
  return [i];
};
function ai() {
  ai = function() {
    return e;
  };
  var t, e = {}, n = Object.prototype, r = n.hasOwnProperty, i = Object.defineProperty || function(F, M, B) {
    F[M] = B.value;
  }, o = typeof Symbol == "function" ? Symbol : {}, a = o.iterator || "@@iterator", s = o.asyncIterator || "@@asyncIterator", u = o.toStringTag || "@@toStringTag";
  function l(F, M, B) {
    return Object.defineProperty(F, M, {
      value: B,
      enumerable: !0,
      configurable: !0,
      writable: !0
    }), F[M];
  }
  try {
    l({}, "");
  } catch {
    l = function(B, X, L) {
      return B[X] = L;
    };
  }
  function c(F, M, B, X) {
    var L = M && M.prototype instanceof b ? M : b, j = Object.create(L.prototype), K = new V(X || []);
    return i(j, "_invoke", {
      value: N(F, B, K)
    }), j;
  }
  function d(F, M, B) {
    try {
      return {
        type: "normal",
        arg: F.call(M, B)
      };
    } catch (X) {
      return {
        type: "throw",
        arg: X
      };
    }
  }
  e.wrap = c;
  var f = "suspendedStart", h = "suspendedYield", p = "executing", v = "completed", m = {};
  function b() {
  }
  function y() {
  }
  function w() {
  }
  var S = {};
  l(S, a, function() {
    return this;
  });
  var E = Object.getPrototypeOf, I = E && E(E($([])));
  I && I !== n && r.call(I, a) && (S = I);
  var _ = w.prototype = b.prototype = Object.create(S);
  function A(F) {
    ["next", "throw", "return"].forEach(function(M) {
      l(F, M, function(B) {
        return this._invoke(M, B);
      });
    });
  }
  function P(F, M) {
    function B(L, j, K, W) {
      var Y = d(F[L], F, j);
      if (Y.type !== "throw") {
        var U = Y.arg, Q = U.value;
        return Q && _t(Q) == "object" && r.call(Q, "__await") ? M.resolve(Q.__await).then(function(Z) {
          B("next", Z, K, W);
        }, function(Z) {
          B("throw", Z, K, W);
        }) : M.resolve(Q).then(function(Z) {
          U.value = Z, K(U);
        }, function(Z) {
          return B("throw", Z, K, W);
        });
      }
      W(Y.arg);
    }
    var X;
    i(this, "_invoke", {
      value: function(j, K) {
        function W() {
          return new M(function(Y, U) {
            B(j, K, Y, U);
          });
        }
        return X = X ? X.then(W, W) : W();
      }
    });
  }
  function N(F, M, B) {
    var X = f;
    return function(L, j) {
      if (X === p)
        throw new Error("Generator is already running");
      if (X === v) {
        if (L === "throw")
          throw j;
        return {
          value: t,
          done: !0
        };
      }
      for (B.method = L, B.arg = j; ; ) {
        var K = B.delegate;
        if (K) {
          var W = k(K, B);
          if (W) {
            if (W === m)
              continue;
            return W;
          }
        }
        if (B.method === "next")
          B.sent = B._sent = B.arg;
        else if (B.method === "throw") {
          if (X === f)
            throw X = v, B.arg;
          B.dispatchException(B.arg);
        } else
          B.method === "return" && B.abrupt("return", B.arg);
        X = p;
        var Y = d(F, M, B);
        if (Y.type === "normal") {
          if (X = B.done ? v : h, Y.arg === m)
            continue;
          return {
            value: Y.arg,
            done: B.done
          };
        }
        Y.type === "throw" && (X = v, B.method = "throw", B.arg = Y.arg);
      }
    };
  }
  function k(F, M) {
    var B = M.method, X = F.iterator[B];
    if (X === t)
      return M.delegate = null, B === "throw" && F.iterator.return && (M.method = "return", M.arg = t, k(F, M), M.method === "throw") || B !== "return" && (M.method = "throw", M.arg = new TypeError("The iterator does not provide a '" + B + "' method")), m;
    var L = d(X, F.iterator, M.arg);
    if (L.type === "throw")
      return M.method = "throw", M.arg = L.arg, M.delegate = null, m;
    var j = L.arg;
    return j ? j.done ? (M[F.resultName] = j.value, M.next = F.nextLoc, M.method !== "return" && (M.method = "next", M.arg = t), M.delegate = null, m) : j : (M.method = "throw", M.arg = new TypeError("iterator result is not an object"), M.delegate = null, m);
  }
  function D(F) {
    var M = {
      tryLoc: F[0]
    };
    1 in F && (M.catchLoc = F[1]), 2 in F && (M.finallyLoc = F[2], M.afterLoc = F[3]), this.tryEntries.push(M);
  }
  function R(F) {
    var M = F.completion || {};
    M.type = "normal", delete M.arg, F.completion = M;
  }
  function V(F) {
    this.tryEntries = [{
      tryLoc: "root"
    }], F.forEach(D, this), this.reset(!0);
  }
  function $(F) {
    if (F || F === "") {
      var M = F[a];
      if (M)
        return M.call(F);
      if (typeof F.next == "function")
        return F;
      if (!isNaN(F.length)) {
        var B = -1, X = function L() {
          for (; ++B < F.length; )
            if (r.call(F, B))
              return L.value = F[B], L.done = !1, L;
          return L.value = t, L.done = !0, L;
        };
        return X.next = X;
      }
    }
    throw new TypeError(_t(F) + " is not iterable");
  }
  return y.prototype = w, i(_, "constructor", {
    value: w,
    configurable: !0
  }), i(w, "constructor", {
    value: y,
    configurable: !0
  }), y.displayName = l(w, u, "GeneratorFunction"), e.isGeneratorFunction = function(F) {
    var M = typeof F == "function" && F.constructor;
    return !!M && (M === y || (M.displayName || M.name) === "GeneratorFunction");
  }, e.mark = function(F) {
    return Object.setPrototypeOf ? Object.setPrototypeOf(F, w) : (F.__proto__ = w, l(F, u, "GeneratorFunction")), F.prototype = Object.create(_), F;
  }, e.awrap = function(F) {
    return {
      __await: F
    };
  }, A(P.prototype), l(P.prototype, s, function() {
    return this;
  }), e.AsyncIterator = P, e.async = function(F, M, B, X, L) {
    L === void 0 && (L = Promise);
    var j = new P(c(F, M, B, X), L);
    return e.isGeneratorFunction(M) ? j : j.next().then(function(K) {
      return K.done ? K.value : j.next();
    });
  }, A(_), l(_, u, "Generator"), l(_, a, function() {
    return this;
  }), l(_, "toString", function() {
    return "[object Generator]";
  }), e.keys = function(F) {
    var M = Object(F), B = [];
    for (var X in M)
      B.push(X);
    return B.reverse(), function L() {
      for (; B.length; ) {
        var j = B.pop();
        if (j in M)
          return L.value = j, L.done = !1, L;
      }
      return L.done = !0, L;
    };
  }, e.values = $, V.prototype = {
    constructor: V,
    reset: function(M) {
      if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(R), !M)
        for (var B in this)
          B.charAt(0) === "t" && r.call(this, B) && !isNaN(+B.slice(1)) && (this[B] = t);
    },
    stop: function() {
      this.done = !0;
      var M = this.tryEntries[0].completion;
      if (M.type === "throw")
        throw M.arg;
      return this.rval;
    },
    dispatchException: function(M) {
      if (this.done)
        throw M;
      var B = this;
      function X(U, Q) {
        return K.type = "throw", K.arg = M, B.next = U, Q && (B.method = "next", B.arg = t), !!Q;
      }
      for (var L = this.tryEntries.length - 1; L >= 0; --L) {
        var j = this.tryEntries[L], K = j.completion;
        if (j.tryLoc === "root")
          return X("end");
        if (j.tryLoc <= this.prev) {
          var W = r.call(j, "catchLoc"), Y = r.call(j, "finallyLoc");
          if (W && Y) {
            if (this.prev < j.catchLoc)
              return X(j.catchLoc, !0);
            if (this.prev < j.finallyLoc)
              return X(j.finallyLoc);
          } else if (W) {
            if (this.prev < j.catchLoc)
              return X(j.catchLoc, !0);
          } else {
            if (!Y)
              throw new Error("try statement without catch or finally");
            if (this.prev < j.finallyLoc)
              return X(j.finallyLoc);
          }
        }
      }
    },
    abrupt: function(M, B) {
      for (var X = this.tryEntries.length - 1; X >= 0; --X) {
        var L = this.tryEntries[X];
        if (L.tryLoc <= this.prev && r.call(L, "finallyLoc") && this.prev < L.finallyLoc) {
          var j = L;
          break;
        }
      }
      j && (M === "break" || M === "continue") && j.tryLoc <= B && B <= j.finallyLoc && (j = null);
      var K = j ? j.completion : {};
      return K.type = M, K.arg = B, j ? (this.method = "next", this.next = j.finallyLoc, m) : this.complete(K);
    },
    complete: function(M, B) {
      if (M.type === "throw")
        throw M.arg;
      return M.type === "break" || M.type === "continue" ? this.next = M.arg : M.type === "return" ? (this.rval = this.arg = M.arg, this.method = "return", this.next = "end") : M.type === "normal" && B && (this.next = B), m;
    },
    finish: function(M) {
      for (var B = this.tryEntries.length - 1; B >= 0; --B) {
        var X = this.tryEntries[B];
        if (X.finallyLoc === M)
          return this.complete(X.completion, X.afterLoc), R(X), m;
      }
    },
    catch: function(M) {
      for (var B = this.tryEntries.length - 1; B >= 0; --B) {
        var X = this.tryEntries[B];
        if (X.tryLoc === M) {
          var L = X.completion;
          if (L.type === "throw") {
            var j = L.arg;
            R(X);
          }
          return j;
        }
      }
      throw new Error("illegal catch attempt");
    },
    delegateYield: function(M, B, X) {
      return this.delegate = {
        iterator: $(M),
        resultName: B,
        nextLoc: X
      }, this.method === "next" && (this.arg = t), m;
    }
  }, e;
}
function z7(t, e, n, r, i, o, a) {
  try {
    var s = t[o](a), u = s.value;
  } catch (l) {
    n(l);
    return;
  }
  s.done ? e(u) : Promise.resolve(u).then(r, i);
}
function ul(t) {
  return function() {
    var e = this, n = arguments;
    return new Promise(function(r, i) {
      var o = t.apply(e, n);
      function a(u) {
        z7(o, r, i, a, s, "next", u);
      }
      function s(u) {
        z7(o, r, i, a, s, "throw", u);
      }
      a(void 0);
    });
  };
}
var $m = de({}, FH), bme = $m.version, yme = $m.render, xme = $m.unmountComponentAtNode, hC;
try {
  var Cme = Number((bme || "").split(".")[0]);
  Cme >= 18 && (hC = $m.createRoot);
} catch {
}
function G7(t) {
  var e = $m.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
  e && _t(e) === "object" && (e.usingClientEntryPoint = t);
}
var lx = "__rc_react_root__";
function wme(t, e) {
  G7(!0);
  var n = e[lx] || hC(e);
  G7(!1), n.render(t), e[lx] = n;
}
function Eme(t, e) {
  yme(t, e);
}
function Sme(t, e) {
  if (hC) {
    wme(t, e);
    return;
  }
  Eme(t, e);
}
function Ime(t) {
  return xI.apply(this, arguments);
}
function xI() {
  return xI = ul(/* @__PURE__ */ ai().mark(function t(e) {
    return ai().wrap(function(r) {
      for (; ; )
        switch (r.prev = r.next) {
          case 0:
            return r.abrupt("return", Promise.resolve().then(function() {
              var i;
              (i = e[lx]) === null || i === void 0 || i.unmount(), delete e[lx];
            }));
          case 1:
          case "end":
            return r.stop();
        }
    }, t);
  })), xI.apply(this, arguments);
}
function _me(t) {
  xme(t);
}
function Ame(t) {
  return CI.apply(this, arguments);
}
function CI() {
  return CI = ul(/* @__PURE__ */ ai().mark(function t(e) {
    return ai().wrap(function(r) {
      for (; ; )
        switch (r.prev = r.next) {
          case 0:
            if (hC === void 0) {
              r.next = 2;
              break;
            }
            return r.abrupt("return", Ime(e));
          case 2:
            _me(e);
          case 3:
          case "end":
            return r.stop();
        }
    }, t);
  })), CI.apply(this, arguments);
}
var Tme = /* @__PURE__ */ x.createContext({}), Ome = /* @__PURE__ */ function(t) {
  Pr(n, t);
  var e = Hr(n);
  function n() {
    return zn(this, n), e.apply(this, arguments);
  }
  return Gn(n, [{
    key: "render",
    value: function() {
      return this.props.children;
    }
  }]), n;
}(x.Component);
function nc(t) {
  var e = x.useRef(!1), n = x.useState(t), r = be(n, 2), i = r[0], o = r[1];
  x.useEffect(function() {
    return e.current = !1, function() {
      e.current = !0;
    };
  }, []);
  function a(s, u) {
    u && e.current || o(s);
  }
  return [i, a];
}
var ed = "none", H1 = "appear", W1 = "enter", j1 = "leave", U7 = "none", ys = "prepare", Ih = "start", _h = "active", aA = "end", Uj = "prepared";
function X7(t, e) {
  var n = {};
  return n[t.toLowerCase()] = e.toLowerCase(), n["Webkit".concat(t)] = "webkit".concat(e), n["Moz".concat(t)] = "moz".concat(e), n["ms".concat(t)] = "MS".concat(e), n["O".concat(t)] = "o".concat(e.toLowerCase()), n;
}
function Pme(t, e) {
  var n = {
    animationend: X7("Animation", "AnimationEnd"),
    transitionend: X7("Transition", "TransitionEnd")
  };
  return t && ("AnimationEvent" in e || delete n.animationend.animation, "TransitionEvent" in e || delete n.transitionend.transition), n;
}
var Nme = Pme(yu(), typeof window < "u" ? window : {}), Xj = {};
if (yu()) {
  var kme = document.createElement("div");
  Xj = kme.style;
}
var z1 = {};
function Yj(t) {
  if (z1[t])
    return z1[t];
  var e = Nme[t];
  if (e)
    for (var n = Object.keys(e), r = n.length, i = 0; i < r; i += 1) {
      var o = n[i];
      if (Object.prototype.hasOwnProperty.call(e, o) && o in Xj)
        return z1[t] = e[o], z1[t];
    }
  return "";
}
var Zj = Yj("animationend"), Jj = Yj("transitionend"), Kj = !!(Zj && Jj), Y7 = Zj || "animationend", Z7 = Jj || "transitionend";
function J7(t, e) {
  if (!t)
    return null;
  if (_t(t) === "object") {
    var n = e.replace(/-\w/g, function(r) {
      return r[1].toUpperCase();
    });
    return t[n];
  }
  return "".concat(t, "-").concat(e);
}
const Rme = function(t) {
  var e = Ee(), n = Ee(t);
  n.current = t;
  var r = x.useCallback(function(a) {
    n.current(a);
  }, []);
  function i(a) {
    a && (a.removeEventListener(Z7, r), a.removeEventListener(Y7, r));
  }
  function o(a) {
    e.current && e.current !== a && i(e.current), a && a !== e.current && (a.addEventListener(Z7, r), a.addEventListener(Y7, r), e.current = a);
  }
  return x.useEffect(function() {
    return function() {
      i(e.current);
    };
  }, []), [o, i];
};
var qj = yu() ? Ua : Re, Qj = function(e) {
  return +setTimeout(e, 16);
}, ez = function(e) {
  return clearTimeout(e);
};
typeof window < "u" && "requestAnimationFrame" in window && (Qj = function(e) {
  return window.requestAnimationFrame(e);
}, ez = function(e) {
  return window.cancelAnimationFrame(e);
});
var K7 = 0, pC = /* @__PURE__ */ new Map();
function tz(t) {
  pC.delete(t);
}
var En = function(e) {
  var n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 1;
  K7 += 1;
  var r = K7;
  function i(o) {
    if (o === 0)
      tz(r), e();
    else {
      var a = Qj(function() {
        i(o - 1);
      });
      pC.set(r, a);
    }
  }
  return i(n), r;
};
En.cancel = function(t) {
  var e = pC.get(t);
  return tz(t), ez(e);
};
process.env.NODE_ENV !== "production" && (En.ids = function() {
  return pC;
});
const $me = function() {
  var t = x.useRef(null);
  function e() {
    En.cancel(t.current);
  }
  function n(r) {
    var i = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 2;
    e();
    var o = En(function() {
      i <= 1 ? r({
        isCanceled: function() {
          return o !== t.current;
        }
      }) : n(r, i - 1);
    });
    t.current = o;
  }
  return x.useEffect(function() {
    return function() {
      e();
    };
  }, []), [n, e];
};
var Dme = [ys, Ih, _h, aA], Mme = [ys, Uj], nz = !1, Fme = !0;
function rz(t) {
  return t === _h || t === aA;
}
const Lme = function(t, e, n) {
  var r = nc(U7), i = be(r, 2), o = i[0], a = i[1], s = $me(), u = be(s, 2), l = u[0], c = u[1];
  function d() {
    a(ys, !0);
  }
  var f = e ? Mme : Dme;
  return qj(function() {
    if (o !== U7 && o !== aA) {
      var h = f.indexOf(o), p = f[h + 1], v = n(o);
      v === nz ? a(p, !0) : p && l(function(m) {
        function b() {
          m.isCanceled() || a(p, !0);
        }
        v === !0 ? b() : Promise.resolve(v).then(b);
      });
    }
  }, [t, o]), x.useEffect(function() {
    return function() {
      c();
    };
  }, []), [d, o];
};
function Vme(t, e, n, r) {
  var i = r.motionEnter, o = i === void 0 ? !0 : i, a = r.motionAppear, s = a === void 0 ? !0 : a, u = r.motionLeave, l = u === void 0 ? !0 : u, c = r.motionDeadline, d = r.motionLeaveImmediately, f = r.onAppearPrepare, h = r.onEnterPrepare, p = r.onLeavePrepare, v = r.onAppearStart, m = r.onEnterStart, b = r.onLeaveStart, y = r.onAppearActive, w = r.onEnterActive, S = r.onLeaveActive, E = r.onAppearEnd, I = r.onEnterEnd, _ = r.onLeaveEnd, A = r.onVisibleChanged, P = nc(), N = be(P, 2), k = N[0], D = N[1], R = nc(ed), V = be(R, 2), $ = V[0], F = V[1], M = nc(null), B = be(M, 2), X = B[0], L = B[1], j = Ee(!1), K = Ee(null);
  function W() {
    return n();
  }
  var Y = Ee(!1);
  function U() {
    F(ed, !0), L(null, !0);
  }
  function Q(Ve) {
    var ne = W();
    if (!(Ve && !Ve.deadline && Ve.target !== ne)) {
      var pe = Y.current, ye;
      $ === H1 && pe ? ye = E == null ? void 0 : E(ne, Ve) : $ === W1 && pe ? ye = I == null ? void 0 : I(ne, Ve) : $ === j1 && pe && (ye = _ == null ? void 0 : _(ne, Ve)), $ !== ed && pe && ye !== !1 && U();
    }
  }
  var Z = Rme(Q), ee = be(Z, 1), ie = ee[0], oe = function(ne) {
    var pe, ye, Ae;
    switch (ne) {
      case H1:
        return pe = {}, z(pe, ys, f), z(pe, Ih, v), z(pe, _h, y), pe;
      case W1:
        return ye = {}, z(ye, ys, h), z(ye, Ih, m), z(ye, _h, w), ye;
      case j1:
        return Ae = {}, z(Ae, ys, p), z(Ae, Ih, b), z(Ae, _h, S), Ae;
      default:
        return {};
    }
  }, se = x.useMemo(function() {
    return oe($);
  }, [$]), te = Lme($, !t, function(Ve) {
    if (Ve === ys) {
      var ne = se[ys];
      return ne ? ne(W()) : nz;
    }
    if (fe in se) {
      var pe;
      L(((pe = se[fe]) === null || pe === void 0 ? void 0 : pe.call(se, W(), null)) || null);
    }
    return fe === _h && (ie(W()), c > 0 && (clearTimeout(K.current), K.current = setTimeout(function() {
      Q({
        deadline: !0
      });
    }, c))), fe === Uj && U(), Fme;
  }), ge = be(te, 2), he = ge[0], fe = ge[1], _e = rz(fe);
  Y.current = _e, qj(function() {
    D(e);
    var Ve = j.current;
    j.current = !0;
    var ne;
    !Ve && e && s && (ne = H1), Ve && e && o && (ne = W1), (Ve && !e && l || !Ve && d && !e && l) && (ne = j1);
    var pe = oe(ne);
    ne && (t || pe[ys]) ? (F(ne), he()) : F(ed);
  }, [e]), Re(function() {
    // Cancel appear
    ($ === H1 && !s || // Cancel enter
    $ === W1 && !o || // Cancel leave
    $ === j1 && !l) && F(ed);
  }, [s, o, l]), Re(function() {
    return function() {
      j.current = !1, clearTimeout(K.current);
    };
  }, []);
  var Ne = x.useRef(!1);
  Re(function() {
    k && (Ne.current = !0), k !== void 0 && $ === ed && ((Ne.current || k) && (A == null || A(k)), Ne.current = !0);
  }, [k, $]);
  var ze = X;
  return se[ys] && fe === Ih && (ze = de({
    transition: "none"
  }, ze)), [$, fe, ze, k ?? e];
}
function Bme(t) {
  var e = t;
  _t(t) === "object" && (e = t.transitionSupport);
  function n(i, o) {
    return !!(i.motionName && e && o !== !1);
  }
  var r = /* @__PURE__ */ x.forwardRef(function(i, o) {
    var a = i.visible, s = a === void 0 ? !0 : a, u = i.removeOnLeave, l = u === void 0 ? !0 : u, c = i.forceRender, d = i.children, f = i.motionName, h = i.leavedClassName, p = i.eventProps, v = x.useContext(Tme), m = v.motion, b = n(i, m), y = Ee(), w = Ee();
    function S() {
      try {
        return y.current instanceof HTMLElement ? y.current : md(w.current);
      } catch {
        return null;
      }
    }
    var E = Vme(b, s, S, i), I = be(E, 4), _ = I[0], A = I[1], P = I[2], N = I[3], k = x.useRef(N);
    N && (k.current = !0);
    var D = x.useCallback(function(L) {
      y.current = L, Tj(o, L);
    }, [o]), R, V = de(de({}, p), {}, {
      visible: s
    });
    if (!d)
      R = null;
    else if (_ === ed)
      N ? R = d(de({}, V), D) : !l && k.current && h ? R = d(de(de({}, V), {}, {
        className: h
      }), D) : c || !l && !h ? R = d(de(de({}, V), {}, {
        style: {
          display: "none"
        }
      }), D) : R = null;
    else {
      var $, F;
      A === ys ? F = "prepare" : rz(A) ? F = "active" : A === Ih && (F = "start");
      var M = J7(f, "".concat(_, "-").concat(F));
      R = d(de(de({}, V), {}, {
        className: Ce(J7(f, _), ($ = {}, z($, M, M && F), z($, f, typeof f == "string"), $)),
        style: P
      }), D);
    }
    if (/* @__PURE__ */ x.isValidElement(R) && Rm(R)) {
      var B = R, X = B.ref;
      X || (R = /* @__PURE__ */ x.cloneElement(R, {
        ref: D
      }));
    }
    return /* @__PURE__ */ x.createElement(Ome, {
      ref: w
    }, R);
  });
  return r.displayName = "CSSMotion", r;
}
const ll = Bme(Kj);
var wI = "add", EI = "keep", SI = "remove", NS = "removed";
function Hme(t) {
  var e;
  return t && _t(t) === "object" && "key" in t ? e = t : e = {
    key: t
  }, de(de({}, e), {}, {
    key: String(e.key)
  });
}
function II() {
  var t = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [];
  return t.map(Hme);
}
function Wme() {
  var t = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [], e = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : [], n = [], r = 0, i = e.length, o = II(t), a = II(e);
  o.forEach(function(l) {
    for (var c = !1, d = r; d < i; d += 1) {
      var f = a[d];
      if (f.key === l.key) {
        r < d && (n = n.concat(a.slice(r, d).map(function(h) {
          return de(de({}, h), {}, {
            status: wI
          });
        })), r = d), n.push(de(de({}, f), {}, {
          status: EI
        })), r += 1, c = !0;
        break;
      }
    }
    c || n.push(de(de({}, l), {}, {
      status: SI
    }));
  }), r < i && (n = n.concat(a.slice(r).map(function(l) {
    return de(de({}, l), {}, {
      status: wI
    });
  })));
  var s = {};
  n.forEach(function(l) {
    var c = l.key;
    s[c] = (s[c] || 0) + 1;
  });
  var u = Object.keys(s).filter(function(l) {
    return s[l] > 1;
  });
  return u.forEach(function(l) {
    n = n.filter(function(c) {
      var d = c.key, f = c.status;
      return d !== l || f !== SI;
    }), n.forEach(function(c) {
      c.key === l && (c.status = EI);
    });
  }), n;
}
var jme = ["component", "children", "onVisibleChanged", "onAllRemoved"], zme = ["status"], Gme = ["eventProps", "visible", "children", "motionName", "motionAppear", "motionEnter", "motionLeave", "motionLeaveImmediately", "motionDeadline", "removeOnLeave", "leavedClassName", "onAppearPrepare", "onAppearStart", "onAppearActive", "onAppearEnd", "onEnterStart", "onEnterActive", "onEnterEnd", "onLeaveStart", "onLeaveActive", "onLeaveEnd"];
function Ume(t) {
  var e = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : ll, n = /* @__PURE__ */ function(r) {
    Pr(o, r);
    var i = Hr(o);
    function o() {
      var a;
      zn(this, o);
      for (var s = arguments.length, u = new Array(s), l = 0; l < s; l++)
        u[l] = arguments[l];
      return a = i.call.apply(i, [this].concat(u)), z(It(a), "state", {
        keyEntities: []
      }), z(It(a), "removeKey", function(c) {
        var d = a.state.keyEntities, f = d.map(function(h) {
          return h.key !== c ? h : de(de({}, h), {}, {
            status: NS
          });
        });
        return a.setState({
          keyEntities: f
        }), f.filter(function(h) {
          var p = h.status;
          return p !== NS;
        }).length;
      }), a;
    }
    return Gn(o, [{
      key: "render",
      value: function() {
        var s = this, u = this.state.keyEntities, l = this.props, c = l.component, d = l.children, f = l.onVisibleChanged, h = l.onAllRemoved, p = Gt(l, jme), v = c || x.Fragment, m = {};
        return Gme.forEach(function(b) {
          m[b] = p[b], delete p[b];
        }), delete p.keys, /* @__PURE__ */ x.createElement(v, p, u.map(function(b, y) {
          var w = b.status, S = Gt(b, zme), E = w === wI || w === EI;
          return /* @__PURE__ */ x.createElement(e, G({}, m, {
            key: S.key,
            visible: E,
            eventProps: S,
            onVisibleChanged: function(_) {
              if (f == null || f(_, {
                key: S.key
              }), !_) {
                var A = s.removeKey(S.key);
                A === 0 && h && h();
              }
            }
          }), function(I, _) {
            return d(de(de({}, I), {}, {
              index: y
            }), _);
          });
        }));
      }
    }], [{
      key: "getDerivedStateFromProps",
      value: function(s, u) {
        var l = s.keys, c = u.keyEntities, d = II(l), f = Wme(c, d);
        return {
          keyEntities: f.filter(function(h) {
            var p = c.find(function(v) {
              var m = v.key;
              return h.key === m;
            });
            return !(p && p.status === NS && h.status === SI);
          })
        };
      }
    }]), o;
  }(x.Component);
  return z(n, "defaultProps", {
    component: "div"
  }), n;
}
const sA = Ume(Kj);
var uA = /* @__PURE__ */ function(t) {
  Pr(n, t);
  var e = Hr(n);
  function n() {
    var r;
    zn(this, n);
    for (var i = arguments.length, o = new Array(i), a = 0; a < i; a++)
      o[a] = arguments[a];
    return r = e.call.apply(e, [this].concat(o)), r.closeTimer = null, r.close = function(s) {
      s && s.stopPropagation(), r.clearCloseTimer();
      var u = r.props, l = u.onClose, c = u.noticeKey;
      l && l(c);
    }, r.startCloseTimer = function() {
      r.props.duration && (r.closeTimer = window.setTimeout(function() {
        r.close();
      }, r.props.duration * 1e3));
    }, r.clearCloseTimer = function() {
      r.closeTimer && (clearTimeout(r.closeTimer), r.closeTimer = null);
    }, r;
  }
  return Gn(n, [{
    key: "componentDidMount",
    value: function() {
      this.startCloseTimer();
    }
  }, {
    key: "componentDidUpdate",
    value: function(i) {
      (this.props.duration !== i.duration || this.props.updateMark !== i.updateMark || // Visible again need reset timer
      this.props.visible !== i.visible && this.props.visible) && this.restartCloseTimer();
    }
  }, {
    key: "componentWillUnmount",
    value: function() {
      this.clearCloseTimer();
    }
  }, {
    key: "restartCloseTimer",
    value: function() {
      this.clearCloseTimer(), this.startCloseTimer();
    }
  }, {
    key: "render",
    value: function() {
      var i = this, o = this.props, a = o.prefixCls, s = o.className, u = o.closable, l = o.closeIcon, c = o.style, d = o.onClick, f = o.children, h = o.holder, p = "".concat(a, "-notice"), v = Object.keys(this.props).reduce(function(b, y) {
        return (y.substr(0, 5) === "data-" || y.substr(0, 5) === "aria-" || y === "role") && (b[y] = i.props[y]), b;
      }, {}), m = /* @__PURE__ */ x.createElement("div", G({
        className: Ce(p, s, z({}, "".concat(p, "-closable"), u)),
        style: c,
        onMouseEnter: this.clearCloseTimer,
        onMouseLeave: this.startCloseTimer,
        onClick: d
      }, v), /* @__PURE__ */ x.createElement("div", {
        className: "".concat(p, "-content")
      }, f), u ? /* @__PURE__ */ x.createElement("a", {
        tabIndex: 0,
        onClick: this.close,
        className: "".concat(p, "-close")
      }, l || /* @__PURE__ */ x.createElement("span", {
        className: "".concat(p, "-close-x")
      })) : null);
      return h ? /* @__PURE__ */ ks.createPortal(m, h) : m;
    }
  }]), n;
}(Do);
uA.defaultProps = {
  onClose: function() {
  },
  duration: 1.5
};
function lA(t) {
  var e = x.useRef({}), n = x.useState([]), r = be(n, 2), i = r[0], o = r[1];
  function a(s) {
    var u = !0;
    t.add(s, function(l, c) {
      var d = c.key;
      if (l && (!e.current[d] || u)) {
        var f = /* @__PURE__ */ x.createElement(uA, G({}, c, {
          holder: l
        }));
        e.current[d] = f, o(function(h) {
          var p = h.findIndex(function(m) {
            return m.key === c.key;
          });
          if (p === -1)
            return [].concat(Ye(h), [f]);
          var v = Ye(h);
          return v[p] = f, v;
        });
      }
      u = !1;
    });
  }
  return [a, /* @__PURE__ */ x.createElement(x.Fragment, null, i)];
}
var Xme = ["getContainer"], q7 = 0, Yme = Date.now();
function Q7() {
  var t = q7;
  return q7 += 1, "rcNotification_".concat(Yme, "_").concat(t);
}
var vd = /* @__PURE__ */ function(t) {
  Pr(n, t);
  var e = Hr(n);
  function n() {
    var r;
    zn(this, n);
    for (var i = arguments.length, o = new Array(i), a = 0; a < i; a++)
      o[a] = arguments[a];
    return r = e.call.apply(e, [this].concat(o)), r.state = {
      notices: []
    }, r.hookRefs = /* @__PURE__ */ new Map(), r.add = function(s, u) {
      var l, c = (l = s.key) !== null && l !== void 0 ? l : Q7(), d = de(de({}, s), {}, {
        key: c
      }), f = r.props.maxCount;
      r.setState(function(h) {
        var p = h.notices, v = p.map(function(b) {
          return b.notice.key;
        }).indexOf(c), m = p.concat();
        return v !== -1 ? m.splice(v, 1, {
          notice: d,
          holderCallback: u
        }) : (f && p.length >= f && (d.key = m[0].notice.key, d.updateMark = Q7(), d.userPassKey = c, m.shift()), m.push({
          notice: d,
          holderCallback: u
        })), {
          notices: m
        };
      });
    }, r.remove = function(s) {
      r.setState(function(u) {
        var l = u.notices;
        return {
          notices: l.filter(function(c) {
            var d = c.notice, f = d.key, h = d.userPassKey, p = h ?? f;
            return p !== s;
          })
        };
      });
    }, r.noticePropsMap = {}, r;
  }
  return Gn(n, [{
    key: "getTransitionName",
    value: function() {
      var i = this.props, o = i.prefixCls, a = i.animation, s = this.props.transitionName;
      return !s && a && (s = "".concat(o, "-").concat(a)), s;
    }
  }, {
    key: "render",
    value: function() {
      var i = this, o = this.state.notices, a = this.props, s = a.prefixCls, u = a.className, l = a.closeIcon, c = a.style, d = [];
      return o.forEach(function(f, h) {
        var p = f.notice, v = f.holderCallback, m = h === o.length - 1 ? p.updateMark : void 0, b = p.key, y = p.userPassKey, w = de(de(de({
          prefixCls: s,
          closeIcon: l
        }, p), p.props), {}, {
          key: b,
          noticeKey: y || b,
          updateMark: m,
          onClose: function(E) {
            var I;
            i.remove(E), (I = p.onClose) === null || I === void 0 || I.call(p);
          },
          onClick: p.onClick,
          children: p.content
        });
        d.push(b), i.noticePropsMap[b] = {
          props: w,
          holderCallback: v
        };
      }), /* @__PURE__ */ x.createElement("div", {
        className: Ce(s, u),
        style: c
      }, /* @__PURE__ */ x.createElement(sA, {
        keys: d,
        motionName: this.getTransitionName(),
        onVisibleChanged: function(h, p) {
          var v = p.key;
          h || delete i.noticePropsMap[v];
        }
      }, function(f) {
        var h = f.key, p = f.className, v = f.style, m = f.visible, b = i.noticePropsMap[h], y = b.props, w = b.holderCallback;
        return w ? /* @__PURE__ */ x.createElement("div", {
          key: h,
          className: Ce(p, "".concat(s, "-hook-holder")),
          style: de({}, v),
          ref: function(E) {
            typeof h > "u" || (E ? (i.hookRefs.set(h, E), w(E, y)) : i.hookRefs.delete(h));
          }
        }) : /* @__PURE__ */ x.createElement(uA, G({}, y, {
          className: Ce(p, y == null ? void 0 : y.className),
          style: de(de({}, v), y == null ? void 0 : y.style),
          visible: m
        }));
      }));
    }
  }]), n;
}(Do);
vd.newInstance = void 0;
vd.defaultProps = {
  prefixCls: "rc-notification",
  animation: "fade",
  style: {
    top: 65,
    left: "50%"
  }
};
vd.newInstance = function(e, n) {
  var r = e || {}, i = r.getContainer, o = Gt(r, Xme), a = document.createElement("div");
  if (i) {
    var s = i();
    s.appendChild(a);
  } else
    document.body.appendChild(a);
  var u = !1;
  function l(c) {
    u || (u = !0, n({
      notice: function(f) {
        c.add(f);
      },
      removeNotice: function(f) {
        c.remove(f);
      },
      component: c,
      destroy: function() {
        Ame(a), a.parentNode && a.parentNode.removeChild(a);
      },
      // Hooks
      useNotification: function() {
        return lA(c);
      }
    }));
  }
  if (process.env.NODE_ENV === "test" && e.TEST_RENDER) {
    e.TEST_RENDER(/* @__PURE__ */ x.createElement(vd, G({}, o, {
      ref: l
    })));
    return;
  }
  Sme(/* @__PURE__ */ x.createElement(vd, G({}, o, {
    ref: l
  })), a);
};
function Zme(t, e) {
  var n = function() {
    var i, o, a = null, s = {
      add: function(v, m) {
        a == null || a.component.add(v, m);
      }
    }, u = lA(s), l = be(u, 2), c = l[0], d = l[1];
    function f(p) {
      var v = p.prefixCls, m = i("message", v), b = i(), y = p.key || dz(), w = new Promise(function(E) {
        var I = function() {
          return typeof p.onClose == "function" && p.onClose(), E(!0);
        };
        t(G(G({}, p), {
          prefixCls: m,
          rootPrefixCls: b,
          getPopupContainer: o
        }), function(_) {
          var A = _.prefixCls, P = _.instance;
          a = P, c(e(G(G({}, p), {
            key: y,
            onClose: I
          }), A));
        });
      }), S = function() {
        a && a.removeNotice(y);
      };
      return S.then = function(E, I) {
        return w.then(E, I);
      }, S.promise = w, S;
    }
    var h = x.useRef({});
    return h.current.open = f, pz.forEach(function(p) {
      return mz(h.current, p);
    }), [h.current, /* @__PURE__ */ x.createElement(_c, {
      key: "holder"
    }, function(p) {
      return i = p.getPrefixCls, o = p.getPopupContainer, d;
    })];
  };
  return n;
}
var Zi, iz = 3, oz, Jme = 1, az = "", _I = "move-up", sz = !1, uz, lz, cz = !1;
function dz() {
  return Jme++;
}
function Kme(t) {
  t.top !== void 0 && (oz = t.top, Zi = null), t.duration !== void 0 && (iz = t.duration), t.prefixCls !== void 0 && (az = t.prefixCls), t.getContainer !== void 0 && (uz = t.getContainer, Zi = null), t.transitionName !== void 0 && (_I = t.transitionName, Zi = null, sz = !0), t.maxCount !== void 0 && (lz = t.maxCount, Zi = null), t.rtl !== void 0 && (cz = t.rtl);
}
function fz(t, e) {
  var n = t.prefixCls, r = t.getPopupContainer, i = Pz(), o = i.getPrefixCls, a = i.getRootPrefixCls, s = i.getIconPrefixCls, u = o("message", n || az), l = a(t.rootPrefixCls, u), c = s();
  if (Zi) {
    e({
      prefixCls: u,
      rootPrefixCls: l,
      iconPrefixCls: c,
      instance: Zi
    });
    return;
  }
  var d = {
    prefixCls: u,
    transitionName: sz ? _I : "".concat(l, "-").concat(_I),
    style: {
      top: oz
    },
    getContainer: uz || r,
    maxCount: lz
  };
  vd.newInstance(d, function(f) {
    if (Zi) {
      e({
        prefixCls: u,
        rootPrefixCls: l,
        iconPrefixCls: c,
        instance: Zi
      });
      return;
    }
    Zi = f, process.env.NODE_ENV === "test" && (Zi.config = d), e({
      prefixCls: u,
      rootPrefixCls: l,
      iconPrefixCls: c,
      instance: f
    });
  });
}
var hz = {
  info: Kge,
  success: tA,
  error: Sc,
  warning: aj,
  loading: lc
}, pz = Object.keys(hz);
function gz(t, e, n) {
  var r = t.duration !== void 0 ? t.duration : iz, i = hz[t.type], o = Ce("".concat(e, "-custom-content"), z(z({}, "".concat(e, "-").concat(t.type), t.type), "".concat(e, "-rtl"), cz === !0));
  return {
    key: t.key,
    duration: r,
    style: t.style || {},
    className: t.className,
    content: /* @__PURE__ */ x.createElement(cA, {
      iconPrefixCls: n
    }, /* @__PURE__ */ x.createElement("div", {
      className: o
    }, t.icon || i && /* @__PURE__ */ x.createElement(i, null), /* @__PURE__ */ x.createElement("span", null, t.content))),
    onClose: t.onClose,
    onClick: t.onClick
  };
}
function qme(t) {
  var e = t.key || dz(), n = new Promise(function(i) {
    var o = function() {
      return typeof t.onClose == "function" && t.onClose(), i(!0);
    };
    fz(t, function(a) {
      var s = a.prefixCls, u = a.iconPrefixCls, l = a.instance;
      l.notice(gz(G(G({}, t), {
        key: e,
        onClose: o
      }), s, u));
    });
  }), r = function() {
    var o;
    Zi && (Zi.removeNotice(e), (o = t.onClose) === null || o === void 0 || o.call(t));
  };
  return r.then = function(i, o) {
    return n.then(i, o);
  }, r.promise = n, r;
}
function Qme(t) {
  return Object.prototype.toString.call(t) === "[object Object]" && !!t.content;
}
var B0 = {
  open: qme,
  config: Kme,
  destroy: function(e) {
    if (Zi)
      if (e) {
        var n = Zi, r = n.removeNotice;
        r(e);
      } else {
        var i = Zi, o = i.destroy;
        o(), Zi = null;
      }
  }
};
function mz(t, e) {
  t[e] = function(n, r, i) {
    return Qme(n) ? t.open(G(G({}, n), {
      type: e
    })) : (typeof r == "function" && (i = r, r = void 0), t.open({
      content: n,
      duration: r,
      type: e,
      onClose: i
    }));
  };
}
pz.forEach(function(t) {
  return mz(B0, t);
});
B0.warn = B0.warning;
B0.useMessage = Zme(fz, gz);
const eve = B0;
function tve(t, e) {
  var n = function() {
    var i, o = null, a = {
      add: function(p, v) {
        o == null || o.component.add(p, v);
      }
    }, s = lA(a), u = be(s, 2), l = u[0], c = u[1];
    function d(h) {
      var p = h.prefixCls, v = i("notification", p);
      t(G(G({}, h), {
        prefixCls: v
      }), function(m) {
        var b = m.prefixCls, y = m.instance;
        o = y, l(e(h, b));
      });
    }
    var f = x.useRef({});
    return f.current.open = d, ["success", "info", "warning", "error"].forEach(function(h) {
      f.current[h] = function(p) {
        return f.current.open(G(G({}, p), {
          type: h
        }));
      };
    }), [f.current, /* @__PURE__ */ x.createElement(_c, {
      key: "holder"
    }, function(h) {
      return i = h.getPrefixCls, c;
    })];
  };
  return n;
}
var id = {}, vz = 4.5, bz = 24, yz = 24, xz = "", AI = "topRight", Cz, wz, Ez = !1, Sz;
function nve(t) {
  var e = t.duration, n = t.placement, r = t.bottom, i = t.top, o = t.getContainer, a = t.closeIcon, s = t.prefixCls;
  s !== void 0 && (xz = s), e !== void 0 && (vz = e), n !== void 0 ? AI = n : t.rtl && (AI = "topLeft"), r !== void 0 && (yz = r), i !== void 0 && (bz = i), o !== void 0 && (Cz = o), a !== void 0 && (wz = a), t.rtl !== void 0 && (Ez = t.rtl), t.maxCount !== void 0 && (Sz = t.maxCount);
}
function rve(t) {
  var e = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : bz, n = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : yz, r;
  switch (t) {
    case "top":
      r = {
        left: "50%",
        transform: "translateX(-50%)",
        right: "auto",
        top: e,
        bottom: "auto"
      };
      break;
    case "topLeft":
      r = {
        left: 0,
        top: e,
        bottom: "auto"
      };
      break;
    case "topRight":
      r = {
        right: 0,
        top: e,
        bottom: "auto"
      };
      break;
    case "bottom":
      r = {
        left: "50%",
        transform: "translateX(-50%)",
        right: "auto",
        top: "auto",
        bottom: n
      };
      break;
    case "bottomLeft":
      r = {
        left: 0,
        top: "auto",
        bottom: n
      };
      break;
    default:
      r = {
        right: 0,
        top: "auto",
        bottom: n
      };
      break;
  }
  return r;
}
function Iz(t, e) {
  var n = t.placement, r = n === void 0 ? AI : n, i = t.top, o = t.bottom, a = t.getContainer, s = a === void 0 ? Cz : a, u = t.prefixCls, l = Pz(), c = l.getPrefixCls, d = l.getIconPrefixCls, f = c("notification", u || xz), h = d(), p = "".concat(f, "-").concat(r), v = id[p];
  if (v) {
    Promise.resolve(v).then(function(b) {
      e({
        prefixCls: "".concat(f, "-notice"),
        iconPrefixCls: h,
        instance: b
      });
    });
    return;
  }
  var m = Ce("".concat(f, "-").concat(r), z({}, "".concat(f, "-rtl"), Ez === !0));
  id[p] = new Promise(function(b) {
    vd.newInstance({
      prefixCls: f,
      className: m,
      style: rve(r, i, o),
      getContainer: s,
      maxCount: Sz
    }, function(y) {
      b(y), e({
        prefixCls: "".concat(f, "-notice"),
        iconPrefixCls: h,
        instance: y
      });
    });
  });
}
var ive = {
  success: sge,
  info: dC,
  error: mge,
  warning: Fge
};
function _z(t, e, n) {
  var r = t.duration, i = t.icon, o = t.type, a = t.description, s = t.message, u = t.btn, l = t.onClose, c = t.onClick, d = t.key, f = t.style, h = t.className, p = t.closeIcon, v = p === void 0 ? wz : p, m = t.props, b = r === void 0 ? vz : r, y = null;
  i ? y = /* @__PURE__ */ x.createElement("span", {
    className: "".concat(e, "-icon")
  }, t.icon) : o && (y = /* @__PURE__ */ x.createElement(ive[o] || null, {
    className: "".concat(e, "-icon ").concat(e, "-icon-").concat(o)
  }));
  var w = typeof v > "u" ? /* @__PURE__ */ x.createElement("span", {
    className: "".concat(e, "-close-x")
  }, /* @__PURE__ */ x.createElement(lC, {
    className: "".concat(e, "-close-icon")
  })) : v, S = !a && y ? /* @__PURE__ */ x.createElement("span", {
    className: "".concat(e, "-message-single-line-auto-margin")
  }) : null;
  return {
    content: /* @__PURE__ */ x.createElement(cA, {
      iconPrefixCls: n
    }, /* @__PURE__ */ x.createElement("div", {
      className: y ? "".concat(e, "-with-icon") : "",
      role: "alert"
    }, y, /* @__PURE__ */ x.createElement("div", {
      className: "".concat(e, "-message")
    }, S, s), /* @__PURE__ */ x.createElement("div", {
      className: "".concat(e, "-description")
    }, a), u ? /* @__PURE__ */ x.createElement("span", {
      className: "".concat(e, "-btn")
    }, u) : null)),
    duration: b,
    closable: !0,
    closeIcon: w,
    onClose: l,
    onClick: c,
    key: d,
    style: f || {},
    className: Ce(h, z({}, "".concat(e, "-").concat(o), !!o)),
    props: m
  };
}
function ove(t) {
  Iz(t, function(e) {
    var n = e.prefixCls, r = e.iconPrefixCls, i = e.instance;
    i.notice(_z(t, n, r));
  });
}
var tp = {
  open: ove,
  close: function(e) {
    Object.keys(id).forEach(function(n) {
      return Promise.resolve(id[n]).then(function(r) {
        r.removeNotice(e);
      });
    });
  },
  config: nve,
  destroy: function() {
    Object.keys(id).forEach(function(e) {
      Promise.resolve(id[e]).then(function(n) {
        n.destroy();
      }), delete id[e];
    });
  }
};
["success", "info", "warning", "error"].forEach(function(t) {
  tp[t] = function(e) {
    return tp.open(G(G({}, e), {
      type: t
    }));
  };
});
tp.warn = tp.warning;
tp.useNotification = tve(Iz, _z);
const ave = tp;
var sve = function(e, n) {
  return n || (e ? "ant-".concat(e) : "ant");
}, en = /* @__PURE__ */ x.createContext({
  // We provide a default function for Context without provider
  getPrefixCls: sve
}), _c = en.Consumer, uve = "-ant-".concat(Date.now(), "-").concat(Math.random());
function lve(t, e) {
  var n = {}, r = function(c, d) {
    var f = c.clone();
    return f = (d == null ? void 0 : d(f)) || f, f.toRgbString();
  }, i = function(c, d) {
    var f = new AS(c), h = L0(f.toRgbString());
    n["".concat(d, "-color")] = r(f), n["".concat(d, "-color-disabled")] = h[1], n["".concat(d, "-color-hover")] = h[4], n["".concat(d, "-color-active")] = h[6], n["".concat(d, "-color-outline")] = f.clone().setAlpha(0.2).toRgbString(), n["".concat(d, "-color-deprecated-bg")] = h[0], n["".concat(d, "-color-deprecated-border")] = h[2];
  };
  if (e.primaryColor) {
    i(e.primaryColor, "primary");
    var o = new AS(e.primaryColor), a = L0(o.toRgbString());
    a.forEach(function(l, c) {
      n["primary-".concat(c + 1)] = l;
    }), n["primary-color-deprecated-l-35"] = r(o, function(l) {
      return l.lighten(35);
    }), n["primary-color-deprecated-l-20"] = r(o, function(l) {
      return l.lighten(20);
    }), n["primary-color-deprecated-t-20"] = r(o, function(l) {
      return l.tint(20);
    }), n["primary-color-deprecated-t-50"] = r(o, function(l) {
      return l.tint(50);
    }), n["primary-color-deprecated-f-12"] = r(o, function(l) {
      return l.setAlpha(l.getAlpha() * 0.12);
    });
    var s = new AS(a[0]);
    n["primary-color-active-deprecated-f-30"] = r(s, function(l) {
      return l.setAlpha(l.getAlpha() * 0.3);
    }), n["primary-color-active-deprecated-d-02"] = r(s, function(l) {
      return l.darken(2);
    });
  }
  e.successColor && i(e.successColor, "success"), e.warningColor && i(e.warningColor, "warning"), e.errorColor && i(e.errorColor, "error"), e.infoColor && i(e.infoColor, "info");
  var u = Object.keys(n).map(function(l) {
    return "--".concat(t, "-").concat(l, ": ").concat(n[l], ";");
  });
  return `
  :root {
    `.concat(u.join(`
`), `
  }
  `).trim();
}
function cve(t, e) {
  var n = lve(t, e);
  yu() ? Z6(n, "".concat(uve, "-dynamic-theme")) : process.env.NODE_ENV !== "production" && gn(!1, "ConfigProvider", "SSR do not support dynamic theme with css variables.");
}
var TI = /* @__PURE__ */ x.createContext(!1), Az = function(e) {
  var n = e.children, r = e.disabled, i = x.useContext(TI);
  return /* @__PURE__ */ x.createElement(TI.Provider, {
    value: r ?? i
  }, n);
};
const Ka = TI;
var OI = /* @__PURE__ */ x.createContext(void 0), Tz = function(e) {
  var n = e.children, r = e.size;
  return /* @__PURE__ */ x.createElement(OI.Consumer, null, function(i) {
    return /* @__PURE__ */ x.createElement(OI.Provider, {
      value: r || i
    }, n);
  });
};
const qa = OI;
var dve = ["getTargetContainer", "getPopupContainer", "renderEmpty", "pageHeader", "input", "pagination", "form"], fve = "ant", hve = "anticon", cx, Oz;
function sy() {
  return cx || fve;
}
function pve() {
  return Oz || hve;
}
var gve = function(e) {
  var n = e.prefixCls, r = e.iconPrefixCls, i = e.theme;
  n !== void 0 && (cx = n), r !== void 0 && (Oz = r), i && cve(sy(), i);
}, Pz = function() {
  return {
    getPrefixCls: function(n, r) {
      return r || (n ? "".concat(sy(), "-").concat(n) : sy());
    },
    getIconPrefixCls: pve,
    getRootPrefixCls: function(n, r) {
      return n || cx || (r && r.includes("-") ? r.replace(/^(.*)-[^-]*$/, "$1") : sy());
    }
  };
}, mve = function(e) {
  var n = e.children, r = e.csp, i = e.autoInsertSpaceInButton, o = e.form, a = e.locale, s = e.componentSize, u = e.direction, l = e.space, c = e.virtual, d = e.dropdownMatchSelectWidth, f = e.legacyLocale, h = e.parentContext, p = e.iconPrefixCls, v = e.componentDisabled, m = x.useCallback(function(I, _) {
    var A = e.prefixCls;
    if (_)
      return _;
    var P = A || h.getPrefixCls("");
    return I ? "".concat(P, "-").concat(I) : P;
  }, [h.getPrefixCls, e.prefixCls]), b = G(G({}, h), {
    csp: r,
    autoInsertSpaceInButton: i,
    locale: a || f,
    direction: u,
    space: l,
    virtual: c,
    dropdownMatchSelectWidth: d,
    getPrefixCls: m
  });
  dve.forEach(function(I) {
    var _ = e[I];
    _ && (b[I] = _);
  });
  var y = Cp(function() {
    return b;
  }, b, function(I, _) {
    var A = Object.keys(I), P = Object.keys(_);
    return A.length !== P.length || A.some(function(N) {
      return I[N] !== _[N];
    });
  }), w = x.useMemo(function() {
    return {
      prefixCls: p,
      csp: r
    };
  }, [p, r]), S = n, E = x.useMemo(function() {
    var I, _, A, P;
    return Sh(((I = fu.Form) === null || I === void 0 ? void 0 : I.defaultValidateMessages) || {}, ((A = (_ = y.locale) === null || _ === void 0 ? void 0 : _.Form) === null || A === void 0 ? void 0 : A.defaultValidateMessages) || {}, ((P = y.form) === null || P === void 0 ? void 0 : P.validateMessages) || {}, (o == null ? void 0 : o.validateMessages) || {});
  }, [y, o == null ? void 0 : o.validateMessages]);
  return Object.keys(E).length > 0 && (S = /* @__PURE__ */ x.createElement(Hj.Provider, {
    value: E
  }, n)), a && (S = /* @__PURE__ */ x.createElement(gme, {
    locale: a,
    _ANT_MARK__: Gj
  }, S)), (p || r) && (S = /* @__PURE__ */ x.createElement(G6.Provider, {
    value: w
  }, S)), s && (S = /* @__PURE__ */ x.createElement(Tz, {
    size: s
  }, S)), v !== void 0 && (S = /* @__PURE__ */ x.createElement(Az, {
    disabled: v
  }, S)), /* @__PURE__ */ x.createElement(en.Provider, {
    value: y
  }, S);
}, gC = function(e) {
  return x.useEffect(function() {
    e.direction && (eve.config({
      rtl: e.direction === "rtl"
    }), ave.config({
      rtl: e.direction === "rtl"
    }));
  }, [e.direction]), /* @__PURE__ */ x.createElement(Ic, null, function(n, r, i) {
    return /* @__PURE__ */ x.createElement(_c, null, function(o) {
      return /* @__PURE__ */ x.createElement(mve, G({
        parentContext: o,
        legacyLocale: i
      }, e));
    });
  });
};
gC.ConfigContext = en;
gC.SizeContext = qa;
gC.config = gve;
const cA = gC;
function Jg(t, e, n, r) {
  var i = ks.unstable_batchedUpdates ? function(a) {
    ks.unstable_batchedUpdates(n, a);
  } : n;
  return t != null && t.addEventListener && t.addEventListener(e, i, r), {
    remove: function() {
      t != null && t.removeEventListener && t.removeEventListener(e, i, r);
    }
  };
}
function vve(t) {
  return Object.keys(t).reduce(function(e, n) {
    return (n.startsWith("data-") || n.startsWith("aria-") || n === "role") && !n.startsWith("data-__") && (e[n] = t[n]), e;
  }, {});
}
var pa = x.isValidElement;
function Nz(t) {
  return t && pa(t) && t.type === x.Fragment;
}
function bve(t, e, n) {
  return pa(t) ? /* @__PURE__ */ x.cloneElement(t, typeof n == "function" ? n(t.props || {}) : n) : e;
}
function ji(t, e) {
  return bve(t, t, e);
}
function Pd(t) {
  var e = x.useRef();
  e.current = t;
  var n = x.useCallback(function() {
    for (var r, i = arguments.length, o = new Array(i), a = 0; a < i; a++)
      o[a] = arguments[a];
    return (r = e.current) === null || r === void 0 ? void 0 : r.call.apply(r, [e].concat(o));
  }, []);
  return n;
}
var ek = process.env.NODE_ENV !== "test" && yu() ? x.useLayoutEffect : x.useEffect, To = function(e, n) {
  var r = x.useRef(!0);
  ek(function() {
    return e(r.current);
  }, n), ek(function() {
    return r.current = !1, function() {
      r.current = !0;
    };
  }, []);
}, d0 = function(e, n) {
  To(function(r) {
    if (!r)
      return e();
  }, n);
};
function kS(t) {
  return t !== void 0;
}
function Tr(t, e) {
  var n = e || {}, r = n.defaultValue, i = n.value, o = n.onChange, a = n.postState, s = nc(function() {
    return kS(i) ? i : kS(r) ? typeof r == "function" ? r() : r : typeof t == "function" ? t() : t;
  }), u = be(s, 2), l = u[0], c = u[1], d = i !== void 0 ? i : l, f = a ? a(d) : d, h = Pd(o), p = nc([d]), v = be(p, 2), m = v[0], b = v[1];
  d0(function() {
    var w = m[0];
    l !== w && h(l, w);
  }, [m]), d0(function() {
    kS(i) || c(i);
  }, [i]);
  var y = Pd(function(w, S) {
    c(w, S), b([d], S);
  });
  return [f, y];
}
const dA = function() {
  if (typeof navigator > "u" || typeof window > "u")
    return !1;
  var t = navigator.userAgent || navigator.vendor || window.opera;
  return /(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino|android|ipad|playbook|silk/i.test(t) || /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw-(n|u)|c55\/|capi|ccwa|cdm-|cell|chtm|cldc|cmd-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc-s|devi|dica|dmob|do(c|p)o|ds(12|-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(-|_)|g1 u|g560|gene|gf-5|g-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd-(m|p|t)|hei-|hi(pt|ta)|hp( i|ip)|hs-c|ht(c(-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i-(20|go|ma)|i230|iac( |-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|-[a-w])|libw|lynx|m1-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|-([1-8]|c))|phil|pire|pl(ay|uc)|pn-2|po(ck|rt|se)|prox|psio|pt-g|qa-a|qc(07|12|21|32|60|-[2-7]|i-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h-|oo|p-)|sdk\/|se(c(-|0|1)|47|mc|nd|ri)|sgh-|shar|sie(-|m)|sk-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h-|v-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl-|tdg-|tel(i|m)|tim-|t-mo|to(pl|sh)|ts(70|m-|m3|m5)|tx-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas-|your|zeto|zte-/i.test(t == null ? void 0 : t.substr(0, 4));
};
var ke = {
  /**
   * MAC_ENTER
   */
  MAC_ENTER: 3,
  /**
   * BACKSPACE
   */
  BACKSPACE: 8,
  /**
   * TAB
   */
  TAB: 9,
  /**
   * NUMLOCK on FF/Safari Mac
   */
  NUM_CENTER: 12,
  // NUMLOCK on FF/Safari Mac
  /**
   * ENTER
   */
  ENTER: 13,
  /**
   * SHIFT
   */
  SHIFT: 16,
  /**
   * CTRL
   */
  CTRL: 17,
  /**
   * ALT
   */
  ALT: 18,
  /**
   * PAUSE
   */
  PAUSE: 19,
  /**
   * CAPS_LOCK
   */
  CAPS_LOCK: 20,
  /**
   * ESC
   */
  ESC: 27,
  /**
   * SPACE
   */
  SPACE: 32,
  /**
   * PAGE_UP
   */
  PAGE_UP: 33,
  // also NUM_NORTH_EAST
  /**
   * PAGE_DOWN
   */
  PAGE_DOWN: 34,
  // also NUM_SOUTH_EAST
  /**
   * END
   */
  END: 35,
  // also NUM_SOUTH_WEST
  /**
   * HOME
   */
  HOME: 36,
  // also NUM_NORTH_WEST
  /**
   * LEFT
   */
  LEFT: 37,
  // also NUM_WEST
  /**
   * UP
   */
  UP: 38,
  // also NUM_NORTH
  /**
   * RIGHT
   */
  RIGHT: 39,
  // also NUM_EAST
  /**
   * DOWN
   */
  DOWN: 40,
  // also NUM_SOUTH
  /**
   * PRINT_SCREEN
   */
  PRINT_SCREEN: 44,
  /**
   * INSERT
   */
  INSERT: 45,
  // also NUM_INSERT
  /**
   * DELETE
   */
  DELETE: 46,
  // also NUM_DELETE
  /**
   * ZERO
   */
  ZERO: 48,
  /**
   * ONE
   */
  ONE: 49,
  /**
   * TWO
   */
  TWO: 50,
  /**
   * THREE
   */
  THREE: 51,
  /**
   * FOUR
   */
  FOUR: 52,
  /**
   * FIVE
   */
  FIVE: 53,
  /**
   * SIX
   */
  SIX: 54,
  /**
   * SEVEN
   */
  SEVEN: 55,
  /**
   * EIGHT
   */
  EIGHT: 56,
  /**
   * NINE
   */
  NINE: 57,
  /**
   * QUESTION_MARK
   */
  QUESTION_MARK: 63,
  // needs localization
  /**
   * A
   */
  A: 65,
  /**
   * B
   */
  B: 66,
  /**
   * C
   */
  C: 67,
  /**
   * D
   */
  D: 68,
  /**
   * E
   */
  E: 69,
  /**
   * F
   */
  F: 70,
  /**
   * G
   */
  G: 71,
  /**
   * H
   */
  H: 72,
  /**
   * I
   */
  I: 73,
  /**
   * J
   */
  J: 74,
  /**
   * K
   */
  K: 75,
  /**
   * L
   */
  L: 76,
  /**
   * M
   */
  M: 77,
  /**
   * N
   */
  N: 78,
  /**
   * O
   */
  O: 79,
  /**
   * P
   */
  P: 80,
  /**
   * Q
   */
  Q: 81,
  /**
   * R
   */
  R: 82,
  /**
   * S
   */
  S: 83,
  /**
   * T
   */
  T: 84,
  /**
   * U
   */
  U: 85,
  /**
   * V
   */
  V: 86,
  /**
   * W
   */
  W: 87,
  /**
   * X
   */
  X: 88,
  /**
   * Y
   */
  Y: 89,
  /**
   * Z
   */
  Z: 90,
  /**
   * META
   */
  META: 91,
  // WIN_KEY_LEFT
  /**
   * WIN_KEY_RIGHT
   */
  WIN_KEY_RIGHT: 92,
  /**
   * CONTEXT_MENU
   */
  CONTEXT_MENU: 93,
  /**
   * NUM_ZERO
   */
  NUM_ZERO: 96,
  /**
   * NUM_ONE
   */
  NUM_ONE: 97,
  /**
   * NUM_TWO
   */
  NUM_TWO: 98,
  /**
   * NUM_THREE
   */
  NUM_THREE: 99,
  /**
   * NUM_FOUR
   */
  NUM_FOUR: 100,
  /**
   * NUM_FIVE
   */
  NUM_FIVE: 101,
  /**
   * NUM_SIX
   */
  NUM_SIX: 102,
  /**
   * NUM_SEVEN
   */
  NUM_SEVEN: 103,
  /**
   * NUM_EIGHT
   */
  NUM_EIGHT: 104,
  /**
   * NUM_NINE
   */
  NUM_NINE: 105,
  /**
   * NUM_MULTIPLY
   */
  NUM_MULTIPLY: 106,
  /**
   * NUM_PLUS
   */
  NUM_PLUS: 107,
  /**
   * NUM_MINUS
   */
  NUM_MINUS: 109,
  /**
   * NUM_PERIOD
   */
  NUM_PERIOD: 110,
  /**
   * NUM_DIVISION
   */
  NUM_DIVISION: 111,
  /**
   * F1
   */
  F1: 112,
  /**
   * F2
   */
  F2: 113,
  /**
   * F3
   */
  F3: 114,
  /**
   * F4
   */
  F4: 115,
  /**
   * F5
   */
  F5: 116,
  /**
   * F6
   */
  F6: 117,
  /**
   * F7
   */
  F7: 118,
  /**
   * F8
   */
  F8: 119,
  /**
   * F9
   */
  F9: 120,
  /**
   * F10
   */
  F10: 121,
  /**
   * F11
   */
  F11: 122,
  /**
   * F12
   */
  F12: 123,
  /**
   * NUMLOCK
   */
  NUMLOCK: 144,
  /**
   * SEMICOLON
   */
  SEMICOLON: 186,
  // needs localization
  /**
   * DASH
   */
  DASH: 189,
  // needs localization
  /**
   * EQUALS
   */
  EQUALS: 187,
  // needs localization
  /**
   * COMMA
   */
  COMMA: 188,
  // needs localization
  /**
   * PERIOD
   */
  PERIOD: 190,
  // needs localization
  /**
   * SLASH
   */
  SLASH: 191,
  // needs localization
  /**
   * APOSTROPHE
   */
  APOSTROPHE: 192,
  // needs localization
  /**
   * SINGLE_QUOTE
   */
  SINGLE_QUOTE: 222,
  // needs localization
  /**
   * OPEN_SQUARE_BRACKET
   */
  OPEN_SQUARE_BRACKET: 219,
  // needs localization
  /**
   * BACKSLASH
   */
  BACKSLASH: 220,
  // needs localization
  /**
   * CLOSE_SQUARE_BRACKET
   */
  CLOSE_SQUARE_BRACKET: 221,
  // needs localization
  /**
   * WIN_KEY
   */
  WIN_KEY: 224,
  /**
   * MAC_FF_META
   */
  MAC_FF_META: 224,
  // Firefox (Gecko) fires this for the meta key instead of 91
  /**
   * WIN_IME
   */
  WIN_IME: 229,
  // ======================== Function ========================
  /**
   * whether text and modified key is entered at the same time.
   */
  isTextModifyingKeyEvent: function(e) {
    var n = e.keyCode;
    if (e.altKey && !e.ctrlKey || e.metaKey || // Function keys don't generate text
    n >= ke.F1 && n <= ke.F12)
      return !1;
    switch (n) {
      case ke.ALT:
      case ke.CAPS_LOCK:
      case ke.CONTEXT_MENU:
      case ke.CTRL:
      case ke.DOWN:
      case ke.END:
      case ke.ESC:
      case ke.HOME:
      case ke.INSERT:
      case ke.LEFT:
      case ke.MAC_FF_META:
      case ke.META:
      case ke.NUMLOCK:
      case ke.NUM_CENTER:
      case ke.PAGE_DOWN:
      case ke.PAGE_UP:
      case ke.PAUSE:
      case ke.PRINT_SCREEN:
      case ke.RIGHT:
      case ke.SHIFT:
      case ke.UP:
      case ke.WIN_KEY:
      case ke.WIN_KEY_RIGHT:
        return !1;
      default:
        return !0;
    }
  },
  /**
   * whether character is entered.
   */
  isCharacterKey: function(e) {
    if (e >= ke.ZERO && e <= ke.NINE || e >= ke.NUM_ZERO && e <= ke.NUM_MULTIPLY || e >= ke.A && e <= ke.Z || window.navigator.userAgent.indexOf("WebKit") !== -1 && e === 0)
      return !0;
    switch (e) {
      case ke.SPACE:
      case ke.QUESTION_MARK:
      case ke.NUM_PLUS:
      case ke.NUM_MINUS:
      case ke.NUM_PERIOD:
      case ke.NUM_DIVISION:
      case ke.SEMICOLON:
      case ke.DASH:
      case ke.EQUALS:
      case ke.COMMA:
      case ke.PERIOD:
      case ke.SLASH:
      case ke.APOSTROPHE:
      case ke.SINGLE_QUOTE:
      case ke.OPEN_SQUARE_BRACKET:
      case ke.BACKSLASH:
      case ke.CLOSE_SQUARE_BRACKET:
        return !0;
      default:
        return !1;
    }
  }
}, kz = /* @__PURE__ */ x.createContext(null);
function yve() {
  return x.useContext(kz);
}
function xve() {
  var t = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 10, e = x.useState(!1), n = be(e, 2), r = n[0], i = n[1], o = x.useRef(null), a = function() {
    window.clearTimeout(o.current);
  };
  x.useEffect(function() {
    return a;
  }, []);
  var s = function(l, c) {
    a(), o.current = window.setTimeout(function() {
      i(l), c && c();
    }, t);
  };
  return [r, s, a];
}
function Rz() {
  var t = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 250, e = x.useRef(null), n = x.useRef(null);
  x.useEffect(function() {
    return function() {
      window.clearTimeout(n.current);
    };
  }, []);
  function r(i) {
    (i || e.current === null) && (e.current = i), window.clearTimeout(n.current), n.current = window.setTimeout(function() {
      e.current = null;
    }, t);
  }
  return [function() {
    return e.current;
  }, r];
}
function Cve(t, e, n, r) {
  var i = x.useRef(null);
  i.current = {
    open: e,
    triggerOpen: n,
    customizedTrigger: r
  }, x.useEffect(function() {
    function o(a) {
      var s;
      if (!((s = i.current) !== null && s !== void 0 && s.customizedTrigger)) {
        var u = a.target;
        u.shadowRoot && a.composed && (u = a.composedPath()[0] || u), i.current.open && t().filter(function(l) {
          return l;
        }).every(function(l) {
          return !l.contains(u) && l !== u;
        }) && i.current.triggerOpen(!1);
      }
    }
    return window.addEventListener("mousedown", o), function() {
      return window.removeEventListener("mousedown", o);
    };
  }, []);
}
var wve = `accept acceptCharset accessKey action allowFullScreen allowTransparency
    alt async autoComplete autoFocus autoPlay capture cellPadding cellSpacing challenge
    charSet checked classID className colSpan cols content contentEditable contextMenu
    controls coords crossOrigin data dateTime default defer dir disabled download draggable
    encType form formAction formEncType formMethod formNoValidate formTarget frameBorder
    headers height hidden high href hrefLang htmlFor httpEquiv icon id inputMode integrity
    is keyParams keyType kind label lang list loop low manifest marginHeight marginWidth max maxLength media
    mediaGroup method min minLength multiple muted name noValidate nonce open
    optimum pattern placeholder poster preload radioGroup readOnly rel required
    reversed role rowSpan rows sandbox scope scoped scrolling seamless selected
    shape size sizes span spellCheck src srcDoc srcLang srcSet start step style
    summary tabIndex target title type useMap value width wmode wrap`, Eve = `onCopy onCut onPaste onCompositionEnd onCompositionStart onCompositionUpdate onKeyDown
    onKeyPress onKeyUp onFocus onBlur onChange onInput onSubmit onClick onContextMenu onDoubleClick
    onDrag onDragEnd onDragEnter onDragExit onDragLeave onDragOver onDragStart onDrop onMouseDown
    onMouseEnter onMouseLeave onMouseMove onMouseOut onMouseOver onMouseUp onSelect onTouchCancel
    onTouchEnd onTouchMove onTouchStart onScroll onWheel onAbort onCanPlay onCanPlayThrough
    onDurationChange onEmptied onEncrypted onEnded onError onLoadedData onLoadedMetadata
    onLoadStart onPause onPlay onPlaying onProgress onRateChange onSeeked onSeeking onStalled onSuspend onTimeUpdate onVolumeChange onWaiting onLoad onError`, Sve = "".concat(wve, " ").concat(Eve).split(/[\s\n]+/), Ive = "aria-", _ve = "data-";
function tk(t, e) {
  return t.indexOf(e) === 0;
}
function H0(t) {
  var e = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : !1, n;
  e === !1 ? n = {
    aria: !0,
    data: !0,
    attr: !0
  } : e === !0 ? n = {
    aria: !0
  } : n = de({}, e);
  var r = {};
  return Object.keys(t).forEach(function(i) {
    // Aria
    (n.aria && (i === "role" || tk(i, Ive)) || // Data
    n.data && tk(i, _ve) || // Attr
    n.attr && Sve.includes(i)) && (r[i] = t[i]);
  }), r;
}
var Ave = ["prefixCls", "invalidate", "item", "renderItem", "responsive", "responsiveDisabled", "registerSize", "itemKey", "className", "style", "children", "display", "order", "component"], kf = void 0;
function Tve(t, e) {
  var n = t.prefixCls, r = t.invalidate, i = t.item, o = t.renderItem, a = t.responsive, s = t.responsiveDisabled, u = t.registerSize, l = t.itemKey, c = t.className, d = t.style, f = t.children, h = t.display, p = t.order, v = t.component, m = v === void 0 ? "div" : v, b = Gt(t, Ave), y = a && !h;
  function w(A) {
    u(l, A);
  }
  x.useEffect(function() {
    return function() {
      w(null);
    };
  }, []);
  var S = o && i !== kf ? o(i) : f, E;
  r || (E = {
    opacity: y ? 0 : 1,
    height: y ? 0 : kf,
    overflowY: y ? "hidden" : kf,
    order: a ? p : kf,
    pointerEvents: y ? "none" : kf,
    position: y ? "absolute" : kf
  });
  var I = {};
  y && (I["aria-hidden"] = !0);
  var _ = /* @__PURE__ */ x.createElement(m, G({
    className: Ce(!r && n, c),
    style: de(de({}, E), d)
  }, I, b, {
    ref: e
  }), S);
  return a && (_ = /* @__PURE__ */ x.createElement(Gd, {
    onResize: function(P) {
      var N = P.offsetWidth;
      w(N);
    },
    disabled: s
  }, _)), _;
}
var f0 = /* @__PURE__ */ x.forwardRef(Tve);
f0.displayName = "Item";
function Ove(t) {
  if (typeof MessageChannel > "u")
    En(t);
  else {
    var e = new MessageChannel();
    e.port1.onmessage = function() {
      return t();
    }, e.port2.postMessage(void 0);
  }
}
function Pve() {
  var t = x.useRef(null), e = function(r) {
    t.current || (t.current = [], Ove(function() {
      Cde(function() {
        t.current.forEach(function(i) {
          i();
        }), t.current = null;
      });
    })), t.current.push(r);
  };
  return e;
}
function Sg(t, e) {
  var n = x.useState(e), r = be(n, 2), i = r[0], o = r[1], a = Pd(function(s) {
    t(function() {
      o(s);
    });
  });
  return [i, a];
}
var dx = /* @__PURE__ */ O.createContext(null), Nve = ["component"], kve = ["className"], Rve = ["className"], $ve = function(e, n) {
  var r = x.useContext(dx);
  if (!r) {
    var i = e.component, o = i === void 0 ? "div" : i, a = Gt(e, Nve);
    return /* @__PURE__ */ x.createElement(o, G({}, a, {
      ref: n
    }));
  }
  var s = r.className, u = Gt(r, kve), l = e.className, c = Gt(e, Rve);
  return /* @__PURE__ */ x.createElement(dx.Provider, {
    value: null
  }, /* @__PURE__ */ x.createElement(f0, G({
    ref: n,
    className: Ce(s, l)
  }, u, c)));
}, $z = /* @__PURE__ */ x.forwardRef($ve);
$z.displayName = "RawItem";
var Dve = ["prefixCls", "data", "renderItem", "renderRawItem", "itemKey", "itemWidth", "ssr", "style", "className", "maxCount", "renderRest", "renderRawRest", "suffix", "component", "itemComponent", "onVisibleChange"], Dz = "responsive", Mz = "invalidate";
function Mve(t) {
  return "+ ".concat(t.length, " ...");
}
function Fve(t, e) {
  var n = t.prefixCls, r = n === void 0 ? "rc-overflow" : n, i = t.data, o = i === void 0 ? [] : i, a = t.renderItem, s = t.renderRawItem, u = t.itemKey, l = t.itemWidth, c = l === void 0 ? 10 : l, d = t.ssr, f = t.style, h = t.className, p = t.maxCount, v = t.renderRest, m = t.renderRawRest, b = t.suffix, y = t.component, w = y === void 0 ? "div" : y, S = t.itemComponent, E = t.onVisibleChange, I = Gt(t, Dve), _ = d === "full", A = Pve(), P = Sg(A, null), N = be(P, 2), k = N[0], D = N[1], R = k || 0, V = Sg(A, /* @__PURE__ */ new Map()), $ = be(V, 2), F = $[0], M = $[1], B = Sg(A, 0), X = be(B, 2), L = X[0], j = X[1], K = Sg(A, 0), W = be(K, 2), Y = W[0], U = W[1], Q = Sg(A, 0), Z = be(Q, 2), ee = Z[0], ie = Z[1], oe = Le(null), se = be(oe, 2), te = se[0], ge = se[1], he = Le(null), fe = be(he, 2), _e = fe[0], Ne = fe[1], ze = x.useMemo(function() {
    return _e === null && _ ? Number.MAX_SAFE_INTEGER : _e || 0;
  }, [_e, k]), Ve = Le(!1), ne = be(Ve, 2), pe = ne[0], ye = ne[1], Ae = "".concat(r, "-item"), we = Math.max(L, Y), ce = p === Dz, ve = o.length && ce, Ie = p === Mz, q = ve || typeof p == "number" && o.length > p, Fe = Rn(function() {
    var Xe = o;
    return ve ? k === null && _ ? Xe = o : Xe = o.slice(0, Math.min(o.length, R / c)) : typeof p == "number" && (Xe = o.slice(0, p)), Xe;
  }, [o, c, k, p, ve]), Ze = Rn(function() {
    return ve ? o.slice(ze + 1) : o.slice(Fe.length);
  }, [o, Fe, ve, ze]), at = et(function(Xe, tt) {
    var ot;
    return typeof u == "function" ? u(Xe) : (ot = u && (Xe == null ? void 0 : Xe[u])) !== null && ot !== void 0 ? ot : tt;
  }, [u]), Je = et(a || function(Xe) {
    return Xe;
  }, [a]);
  function ut(Xe, tt, ot) {
    _e === Xe && (tt === void 0 || tt === te) || (Ne(Xe), ot || (ye(Xe < o.length - 1), E == null || E(Xe)), tt !== void 0 && ge(tt));
  }
  function Ct(Xe, tt) {
    D(tt.clientWidth);
  }
  function Ke(Xe, tt) {
    M(function(ot) {
      var lt = new Map(ot);
      return tt === null ? lt.delete(Xe) : lt.set(Xe, tt), lt;
    });
  }
  function st(Xe, tt) {
    U(tt), j(Y);
  }
  function wt(Xe, tt) {
    ie(tt);
  }
  function qt(Xe) {
    return F.get(at(Fe[Xe], Xe));
  }
  To(function() {
    if (R && typeof we == "number" && Fe) {
      var Xe = ee, tt = Fe.length, ot = tt - 1;
      if (!tt) {
        ut(0, null);
        return;
      }
      for (var lt = 0; lt < tt; lt += 1) {
        var He = qt(lt);
        if (_ && (He = He || 0), He === void 0) {
          ut(lt - 1, void 0, !0);
          break;
        }
        if (Xe += He, // Only one means `totalWidth` is the final width
        ot === 0 && Xe <= R || // Last two width will be the final width
        lt === ot - 1 && Xe + qt(ot) <= R) {
          ut(ot, null);
          break;
        } else if (Xe + we > R) {
          ut(lt - 1, Xe - He - ee + Y);
          break;
        }
      }
      b && qt(0) + ee > R && ge(null);
    }
  }, [R, F, Y, ee, at, Fe]);
  var bt = pe && !!Ze.length, Me = {};
  te !== null && ve && (Me = {
    position: "absolute",
    left: te,
    top: 0
  });
  var yt = {
    prefixCls: Ae,
    responsive: ve,
    component: S,
    invalidate: Ie
  }, ct = s ? function(Xe, tt) {
    var ot = at(Xe, tt);
    return /* @__PURE__ */ x.createElement(dx.Provider, {
      key: ot,
      value: de(de({}, yt), {}, {
        order: tt,
        item: Xe,
        itemKey: ot,
        registerSize: Ke,
        display: tt <= ze
      })
    }, s(Xe, tt));
  } : function(Xe, tt) {
    var ot = at(Xe, tt);
    return /* @__PURE__ */ x.createElement(f0, G({}, yt, {
      order: tt,
      key: ot,
      item: Xe,
      renderItem: Je,
      itemKey: ot,
      registerSize: Ke,
      display: tt <= ze
    }));
  }, kt, Vt = {
    order: bt ? ze : Number.MAX_SAFE_INTEGER,
    className: "".concat(Ae, "-rest"),
    registerSize: st,
    display: bt
  };
  if (m)
    m && (kt = /* @__PURE__ */ x.createElement(dx.Provider, {
      value: de(de({}, yt), Vt)
    }, m(Ze)));
  else {
    var Vn = v || Mve;
    kt = /* @__PURE__ */ x.createElement(f0, G({}, yt, Vt), typeof Vn == "function" ? Vn(Ze) : Vn);
  }
  var tn = /* @__PURE__ */ x.createElement(w, G({
    className: Ce(!Ie && r, h),
    style: f,
    ref: e
  }, I), Fe.map(ct), q ? kt : null, b && /* @__PURE__ */ x.createElement(f0, G({}, yt, {
    responsive: ce,
    responsiveDisabled: !ve,
    order: ze,
    className: "".concat(Ae, "-suffix"),
    registerSize: wt,
    display: !0,
    style: Me
  }), b));
  return ce && (tn = /* @__PURE__ */ x.createElement(Gd, {
    onResize: Ct,
    disabled: !ve
  }, tn)), tn;
}
var au = /* @__PURE__ */ x.forwardRef(Fve);
au.displayName = "Overflow";
au.Item = $z;
au.RESPONSIVE = Dz;
au.INVALIDATE = Mz;
var fx = function(e) {
  var n = e.className, r = e.customizeIcon, i = e.customizeIconProps, o = e.onMouseDown, a = e.onClick, s = e.children, u;
  return typeof r == "function" ? u = r(i) : u = r, /* @__PURE__ */ x.createElement("span", {
    className: n,
    onMouseDown: function(c) {
      c.preventDefault(), o && o(c);
    },
    style: {
      userSelect: "none",
      WebkitUserSelect: "none"
    },
    unselectable: "on",
    onClick: a,
    "aria-hidden": !0
  }, u !== void 0 ? u : /* @__PURE__ */ x.createElement("span", {
    className: Ce(n.split(/\s+/).map(function(l) {
      return "".concat(l, "-icon");
    }))
  }, s));
}, Lve = function(e, n) {
  var r, i, o = e.prefixCls, a = e.id, s = e.inputElement, u = e.disabled, l = e.tabIndex, c = e.autoFocus, d = e.autoComplete, f = e.editable, h = e.activeDescendantId, p = e.value, v = e.maxLength, m = e.onKeyDown, b = e.onMouseDown, y = e.onChange, w = e.onPaste, S = e.onCompositionStart, E = e.onCompositionEnd, I = e.open, _ = e.attrs, A = s || /* @__PURE__ */ x.createElement("input", null), P = A, N = P.ref, k = P.props, D = k.onKeyDown, R = k.onChange, V = k.onMouseDown, $ = k.onCompositionStart, F = k.onCompositionEnd, M = k.style;
  return rx(!("maxLength" in A.props), "Passing 'maxLength' to input element directly may not work because input in BaseSelect is controlled."), A = /* @__PURE__ */ x.cloneElement(A, de(de(de({
    type: "search"
  }, k), {}, {
    // Override over origin props
    id: a,
    ref: Ja(n, N),
    disabled: u,
    tabIndex: l,
    autoComplete: d || "off",
    autoFocus: c,
    className: Ce("".concat(o, "-selection-search-input"), (r = A) === null || r === void 0 || (i = r.props) === null || i === void 0 ? void 0 : i.className),
    role: "combobox",
    "aria-expanded": I,
    "aria-haspopup": "listbox",
    "aria-owns": "".concat(a, "_list"),
    "aria-autocomplete": "list",
    "aria-controls": "".concat(a, "_list"),
    "aria-activedescendant": h
  }, _), {}, {
    value: f ? p : "",
    maxLength: v,
    readOnly: !f,
    unselectable: f ? null : "on",
    style: de(de({}, M), {}, {
      opacity: f ? null : 0
    }),
    onKeyDown: function(X) {
      m(X), D && D(X);
    },
    onMouseDown: function(X) {
      b(X), V && V(X);
    },
    onChange: function(X) {
      y(X), R && R(X);
    },
    onCompositionStart: function(X) {
      S(X), $ && $(X);
    },
    onCompositionEnd: function(X) {
      E(X), F && F(X);
    },
    onPaste: w
  })), A;
}, fA = /* @__PURE__ */ x.forwardRef(Lve);
fA.displayName = "Input";
function hA(t) {
  return Array.isArray(t) ? t : t !== void 0 ? [t] : [];
}
var Vve = typeof window < "u" && window.document && window.document.documentElement, Bve = process.env.NODE_ENV !== "test" && Vve;
function Hve(t) {
  return t != null;
}
function nk(t) {
  return ["string", "number"].includes(_t(t));
}
function Fz(t) {
  var e = void 0;
  return t && (nk(t.title) ? e = t.title.toString() : nk(t.label) && (e = t.label.toString())), e;
}
function Wve(t, e) {
  Bve ? x.useLayoutEffect(t, e) : x.useEffect(t, e);
}
function jve(t) {
  var e;
  return (e = t.key) !== null && e !== void 0 ? e : t.value;
}
var rk = function(e) {
  e.preventDefault(), e.stopPropagation();
}, zve = function(e) {
  var n = e.id, r = e.prefixCls, i = e.values, o = e.open, a = e.searchValue, s = e.autoClearSearchValue, u = e.inputRef, l = e.placeholder, c = e.disabled, d = e.mode, f = e.showSearch, h = e.autoFocus, p = e.autoComplete, v = e.activeDescendantId, m = e.tabIndex, b = e.removeIcon, y = e.maxTagCount, w = e.maxTagTextLength, S = e.maxTagPlaceholder, E = S === void 0 ? function(ge) {
    return "+ ".concat(ge.length, " ...");
  } : S, I = e.tagRender, _ = e.onToggleOpen, A = e.onRemove, P = e.onInputChange, N = e.onInputPaste, k = e.onInputKeyDown, D = e.onInputMouseDown, R = e.onInputCompositionStart, V = e.onInputCompositionEnd, $ = x.useRef(null), F = Le(0), M = be(F, 2), B = M[0], X = M[1], L = Le(!1), j = be(L, 2), K = j[0], W = j[1], Y = "".concat(r, "-selection"), U = o || d === "multiple" && s === !1 || d === "tags" ? a : "", Q = d === "tags" || d === "multiple" && s === !1 || f && (o || K);
  Wve(function() {
    X($.current.scrollWidth);
  }, [U]);
  function Z(ge, he, fe, _e, Ne) {
    return /* @__PURE__ */ x.createElement("span", {
      className: Ce("".concat(Y, "-item"), z({}, "".concat(Y, "-item-disabled"), fe)),
      title: Fz(ge)
    }, /* @__PURE__ */ x.createElement("span", {
      className: "".concat(Y, "-item-content")
    }, he), _e && /* @__PURE__ */ x.createElement(fx, {
      className: "".concat(Y, "-item-remove"),
      onMouseDown: rk,
      onClick: Ne,
      customizeIcon: b
    }, "×"));
  }
  function ee(ge, he, fe, _e, Ne) {
    var ze = function(ne) {
      rk(ne), _(!o);
    };
    return /* @__PURE__ */ x.createElement("span", {
      onMouseDown: ze
    }, I({
      label: he,
      value: ge,
      disabled: fe,
      closable: _e,
      onClose: Ne
    }));
  }
  function ie(ge) {
    var he = ge.disabled, fe = ge.label, _e = ge.value, Ne = !c && !he, ze = fe;
    if (typeof w == "number" && (typeof fe == "string" || typeof fe == "number")) {
      var Ve = String(ze);
      Ve.length > w && (ze = "".concat(Ve.slice(0, w), "..."));
    }
    var ne = function(ye) {
      ye && ye.stopPropagation(), A(ge);
    };
    return typeof I == "function" ? ee(_e, ze, he, Ne, ne) : Z(ge, ze, he, Ne, ne);
  }
  function oe(ge) {
    var he = typeof E == "function" ? E(ge) : E;
    return Z({
      title: he
    }, he, !1);
  }
  var se = /* @__PURE__ */ x.createElement("div", {
    className: "".concat(Y, "-search"),
    style: {
      width: B
    },
    onFocus: function() {
      W(!0);
    },
    onBlur: function() {
      W(!1);
    }
  }, /* @__PURE__ */ x.createElement(fA, {
    ref: u,
    open: o,
    prefixCls: r,
    id: n,
    inputElement: null,
    disabled: c,
    autoFocus: h,
    autoComplete: p,
    editable: Q,
    activeDescendantId: v,
    value: U,
    onKeyDown: k,
    onMouseDown: D,
    onChange: P,
    onPaste: N,
    onCompositionStart: R,
    onCompositionEnd: V,
    tabIndex: m,
    attrs: H0(e, !0)
  }), /* @__PURE__ */ x.createElement("span", {
    ref: $,
    className: "".concat(Y, "-search-mirror"),
    "aria-hidden": !0
  }, U, " ")), te = /* @__PURE__ */ x.createElement(au, {
    prefixCls: "".concat(Y, "-overflow"),
    data: i,
    renderItem: ie,
    renderRest: oe,
    suffix: se,
    itemKey: jve,
    maxCount: y
  });
  return /* @__PURE__ */ x.createElement(x.Fragment, null, te, !i.length && !U && /* @__PURE__ */ x.createElement("span", {
    className: "".concat(Y, "-placeholder")
  }, l));
}, Gve = function(e) {
  var n = e.inputElement, r = e.prefixCls, i = e.id, o = e.inputRef, a = e.disabled, s = e.autoFocus, u = e.autoComplete, l = e.activeDescendantId, c = e.mode, d = e.open, f = e.values, h = e.placeholder, p = e.tabIndex, v = e.showSearch, m = e.searchValue, b = e.activeValue, y = e.maxLength, w = e.onInputKeyDown, S = e.onInputMouseDown, E = e.onInputChange, I = e.onInputPaste, _ = e.onInputCompositionStart, A = e.onInputCompositionEnd, P = x.useState(!1), N = be(P, 2), k = N[0], D = N[1], R = c === "combobox", V = R || v, $ = f[0], F = m || "";
  R && b && !k && (F = b), x.useEffect(function() {
    R && D(!1);
  }, [R, b]);
  var M = c !== "combobox" && !d && !v ? !1 : !!F, B = Fz($), X = function() {
    if ($)
      return null;
    var j = M ? {
      visibility: "hidden"
    } : void 0;
    return /* @__PURE__ */ x.createElement("span", {
      className: "".concat(r, "-selection-placeholder"),
      style: j
    }, h);
  };
  return /* @__PURE__ */ x.createElement(x.Fragment, null, /* @__PURE__ */ x.createElement("span", {
    className: "".concat(r, "-selection-search")
  }, /* @__PURE__ */ x.createElement(fA, {
    ref: o,
    prefixCls: r,
    id: i,
    open: d,
    inputElement: n,
    disabled: a,
    autoFocus: s,
    autoComplete: u,
    editable: V,
    activeDescendantId: l,
    value: F,
    onKeyDown: w,
    onMouseDown: S,
    onChange: function(j) {
      D(!0), E(j);
    },
    onPaste: I,
    onCompositionStart: _,
    onCompositionEnd: A,
    tabIndex: p,
    attrs: H0(e, !0),
    maxLength: R ? y : void 0
  })), !R && $ ? /* @__PURE__ */ x.createElement("span", {
    className: "".concat(r, "-selection-item"),
    title: B,
    style: M ? {
      visibility: "hidden"
    } : void 0
  }, $.label) : null, X());
};
function Uve(t) {
  return ![
    // System function button
    ke.ESC,
    ke.SHIFT,
    ke.BACKSPACE,
    ke.TAB,
    ke.WIN_KEY,
    ke.ALT,
    ke.META,
    ke.WIN_KEY_RIGHT,
    ke.CTRL,
    ke.SEMICOLON,
    ke.EQUALS,
    ke.CAPS_LOCK,
    ke.CONTEXT_MENU,
    // F1-F12
    ke.F1,
    ke.F2,
    ke.F3,
    ke.F4,
    ke.F5,
    ke.F6,
    ke.F7,
    ke.F8,
    ke.F9,
    ke.F10,
    ke.F11,
    ke.F12
  ].includes(t);
}
var Xve = function(e, n) {
  var r = Ee(null), i = Ee(!1), o = e.prefixCls, a = e.open, s = e.mode, u = e.showSearch, l = e.tokenWithEnter, c = e.autoClearSearchValue, d = e.onSearch, f = e.onSearchSubmit, h = e.onToggleOpen, p = e.onInputKeyDown, v = e.domRef;
  x.useImperativeHandle(n, function() {
    return {
      focus: function() {
        r.current.focus();
      },
      blur: function() {
        r.current.blur();
      }
    };
  });
  var m = Rz(0), b = be(m, 2), y = b[0], w = b[1], S = function(M) {
    var B = M.which;
    (B === ke.UP || B === ke.DOWN) && M.preventDefault(), p && p(M), B === ke.ENTER && s === "tags" && !i.current && !a && (f == null || f(M.target.value)), Uve(B) && h(!0);
  }, E = function() {
    w(!0);
  }, I = Ee(null), _ = function(M) {
    d(M, !0, i.current) !== !1 && h(!0);
  }, A = function() {
    i.current = !0;
  }, P = function(M) {
    i.current = !1, s !== "combobox" && _(M.target.value);
  }, N = function(M) {
    var B = M.target.value;
    if (l && I.current && /[\r\n]/.test(I.current)) {
      var X = I.current.replace(/[\r\n]+$/, "").replace(/\r\n/g, " ").replace(/[\r\n]/g, " ");
      B = B.replace(X, I.current);
    }
    I.current = null, _(B);
  }, k = function(M) {
    var B = M.clipboardData, X = B.getData("text");
    I.current = X;
  }, D = function(M) {
    var B = M.target;
    if (B !== r.current) {
      var X = document.body.style.msTouchAction !== void 0;
      X ? setTimeout(function() {
        r.current.focus();
      }) : r.current.focus();
    }
  }, R = function(M) {
    var B = y();
    M.target !== r.current && !B && s !== "combobox" && M.preventDefault(), (s !== "combobox" && (!u || !B) || !a) && (a && c !== !1 && d("", !0, !1), h());
  }, V = {
    inputRef: r,
    onInputKeyDown: S,
    onInputMouseDown: E,
    onInputChange: N,
    onInputPaste: k,
    onInputCompositionStart: A,
    onInputCompositionEnd: P
  }, $ = s === "multiple" || s === "tags" ? /* @__PURE__ */ x.createElement(zve, G({}, e, V)) : /* @__PURE__ */ x.createElement(Gve, G({}, e, V));
  return /* @__PURE__ */ x.createElement("div", {
    ref: v,
    className: "".concat(o, "-selector"),
    onClick: D,
    onMouseDown: R
  }, $);
}, Lz = /* @__PURE__ */ x.forwardRef(Xve);
Lz.displayName = "Selector";
var Yve = /* @__PURE__ */ gt(function(t, e) {
  var n = t.didUpdate, r = t.getContainer, i = t.children, o = Ee(), a = Ee();
  wc(e, function() {
    return {};
  });
  var s = Ee(!1);
  return !s.current && yu() && (a.current = r(), o.current = a.current.parentNode, s.current = !0), Re(function() {
    n == null || n(t);
  }), Re(function() {
    return a.current.parentNode === null && o.current !== null && o.current.appendChild(a.current), function() {
      var u;
      (u = a.current) === null || u === void 0 || (u = u.parentNode) === null || u === void 0 || u.removeChild(a.current);
    };
  }, []), a.current ? /* @__PURE__ */ ks.createPortal(i, a.current) : null;
});
function Zve(t, e, n) {
  return n ? t[0] === e[0] : t[0] === e[0] && t[1] === e[1];
}
function Jve(t, e, n) {
  var r = t[e] || {};
  return de(de({}, r), n);
}
function Kve(t, e, n, r) {
  for (var i = n.points, o = Object.keys(t), a = 0; a < o.length; a += 1) {
    var s = o[a];
    if (Zve(t[s].points, i, r))
      return "".concat(e, "-placement-").concat(s);
  }
  return "";
}
function Vz(t) {
  var e = t.prefixCls, n = t.motion, r = t.animation, i = t.transitionName;
  return n || (r ? {
    motionName: "".concat(e, "-").concat(r)
  } : i ? {
    motionName: i
  } : null);
}
function qve(t) {
  var e = t.prefixCls, n = t.visible, r = t.zIndex, i = t.mask, o = t.maskMotion, a = t.maskAnimation, s = t.maskTransitionName;
  if (!i)
    return null;
  var u = {};
  return (o || s || a) && (u = de({
    motionAppear: !0
  }, Vz({
    motion: o,
    prefixCls: e,
    transitionName: s,
    animation: a
  }))), /* @__PURE__ */ x.createElement(ll, G({}, u, {
    visible: n,
    removeOnLeave: !0
  }), function(l) {
    var c = l.className;
    return /* @__PURE__ */ x.createElement("div", {
      style: {
        zIndex: r
      },
      className: Ce("".concat(e, "-mask"), c)
    });
  });
}
function ik(t, e) {
  var n = Object.keys(t);
  if (Object.getOwnPropertySymbols) {
    var r = Object.getOwnPropertySymbols(t);
    e && (r = r.filter(function(i) {
      return Object.getOwnPropertyDescriptor(t, i).enumerable;
    })), n.push.apply(n, r);
  }
  return n;
}
function ok(t) {
  for (var e = 1; e < arguments.length; e++) {
    var n = arguments[e] != null ? arguments[e] : {};
    e % 2 ? ik(Object(n), !0).forEach(function(r) {
      Qve(t, r, n[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(t, Object.getOwnPropertyDescriptors(n)) : ik(Object(n)).forEach(function(r) {
      Object.defineProperty(t, r, Object.getOwnPropertyDescriptor(n, r));
    });
  }
  return t;
}
function PI(t) {
  "@babel/helpers - typeof";
  return PI = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(e) {
    return typeof e;
  } : function(e) {
    return e && typeof Symbol == "function" && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
  }, PI(t);
}
function Qve(t, e, n) {
  return e in t ? Object.defineProperty(t, e, {
    value: n,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : t[e] = n, t;
}
var Ig, e1e = {
  Webkit: "-webkit-",
  Moz: "-moz-",
  // IE did it wrong again ...
  ms: "-ms-",
  O: "-o-"
};
function hx() {
  if (Ig !== void 0)
    return Ig;
  Ig = "";
  var t = document.createElement("p").style, e = "Transform";
  for (var n in e1e)
    n + e in t && (Ig = n);
  return Ig;
}
function Bz() {
  return hx() ? "".concat(hx(), "TransitionProperty") : "transitionProperty";
}
function mC() {
  return hx() ? "".concat(hx(), "Transform") : "transform";
}
function ak(t, e) {
  var n = Bz();
  n && (t.style[n] = e, n !== "transitionProperty" && (t.style.transitionProperty = e));
}
function RS(t, e) {
  var n = mC();
  n && (t.style[n] = e, n !== "transform" && (t.style.transform = e));
}
function t1e(t) {
  return t.style.transitionProperty || t.style[Bz()];
}
function n1e(t) {
  var e = window.getComputedStyle(t, null), n = e.getPropertyValue("transform") || e.getPropertyValue(mC());
  if (n && n !== "none") {
    var r = n.replace(/[^0-9\-.,]/g, "").split(",");
    return {
      x: parseFloat(r[12] || r[4], 0),
      y: parseFloat(r[13] || r[5], 0)
    };
  }
  return {
    x: 0,
    y: 0
  };
}
var r1e = /matrix\((.*)\)/, i1e = /matrix3d\((.*)\)/;
function o1e(t, e) {
  var n = window.getComputedStyle(t, null), r = n.getPropertyValue("transform") || n.getPropertyValue(mC());
  if (r && r !== "none") {
    var i, o = r.match(r1e);
    if (o)
      o = o[1], i = o.split(",").map(function(s) {
        return parseFloat(s, 10);
      }), i[4] = e.x, i[5] = e.y, RS(t, "matrix(".concat(i.join(","), ")"));
    else {
      var a = r.match(i1e)[1];
      i = a.split(",").map(function(s) {
        return parseFloat(s, 10);
      }), i[12] = e.x, i[13] = e.y, RS(t, "matrix3d(".concat(i.join(","), ")"));
    }
  } else
    RS(t, "translateX(".concat(e.x, "px) translateY(").concat(e.y, "px) translateZ(0)"));
}
var a1e = /[\-+]?(?:\d*\.|)\d+(?:[eE][\-+]?\d+|)/.source, Dm;
function sk(t) {
  var e = t.style.display;
  t.style.display = "none", t.offsetHeight, t.style.display = e;
}
function Fh(t, e, n) {
  var r = n;
  if (PI(e) === "object") {
    for (var i in e)
      e.hasOwnProperty(i) && Fh(t, i, e[i]);
    return;
  }
  if (typeof r < "u") {
    typeof r == "number" && (r = "".concat(r, "px")), t.style[e] = r;
    return;
  }
  return Dm(t, e);
}
function s1e(t) {
  var e, n, r, i = t.ownerDocument, o = i.body, a = i && i.documentElement;
  return e = t.getBoundingClientRect(), n = Math.floor(e.left), r = Math.floor(e.top), n -= a.clientLeft || o.clientLeft || 0, r -= a.clientTop || o.clientTop || 0, {
    left: n,
    top: r
  };
}
function Hz(t, e) {
  var n = t["page".concat(e ? "Y" : "X", "Offset")], r = "scroll".concat(e ? "Top" : "Left");
  if (typeof n != "number") {
    var i = t.document;
    n = i.documentElement[r], typeof n != "number" && (n = i.body[r]);
  }
  return n;
}
function Wz(t) {
  return Hz(t);
}
function jz(t) {
  return Hz(t, !0);
}
function W0(t) {
  var e = s1e(t), n = t.ownerDocument, r = n.defaultView || n.parentWindow;
  return e.left += Wz(r), e.top += jz(r), e;
}
function pA(t) {
  return t != null && t == t.window;
}
function zz(t) {
  return pA(t) ? t.document : t.nodeType === 9 ? t : t.ownerDocument;
}
function u1e(t, e, n) {
  var r = n, i = "", o = zz(t);
  return r = r || o.defaultView.getComputedStyle(t, null), r && (i = r.getPropertyValue(e) || r[e]), i;
}
var l1e = new RegExp("^(".concat(a1e, ")(?!px)[a-z%]+$"), "i"), c1e = /^(top|right|bottom|left)$/, $S = "currentStyle", DS = "runtimeStyle", Xc = "left", d1e = "px";
function f1e(t, e) {
  var n = t[$S] && t[$S][e];
  if (l1e.test(n) && !c1e.test(e)) {
    var r = t.style, i = r[Xc], o = t[DS][Xc];
    t[DS][Xc] = t[$S][Xc], r[Xc] = e === "fontSize" ? "1em" : n || 0, n = r.pixelLeft + d1e, r[Xc] = i, t[DS][Xc] = o;
  }
  return n === "" ? "auto" : n;
}
typeof window < "u" && (Dm = window.getComputedStyle ? u1e : f1e);
function G1(t, e) {
  return t === "left" ? e.useCssRight ? "right" : t : e.useCssBottom ? "bottom" : t;
}
function uk(t) {
  if (t === "left")
    return "right";
  if (t === "right")
    return "left";
  if (t === "top")
    return "bottom";
  if (t === "bottom")
    return "top";
}
function lk(t, e, n) {
  Fh(t, "position") === "static" && (t.style.position = "relative");
  var r = -999, i = -999, o = G1("left", n), a = G1("top", n), s = uk(o), u = uk(a);
  o !== "left" && (r = 999), a !== "top" && (i = 999);
  var l = "", c = W0(t);
  ("left" in e || "top" in e) && (l = t1e(t) || "", ak(t, "none")), "left" in e && (t.style[s] = "", t.style[o] = "".concat(r, "px")), "top" in e && (t.style[u] = "", t.style[a] = "".concat(i, "px")), sk(t);
  var d = W0(t), f = {};
  for (var h in e)
    if (e.hasOwnProperty(h)) {
      var p = G1(h, n), v = h === "left" ? r : i, m = c[h] - d[h];
      p === h ? f[p] = v + m : f[p] = v - m;
    }
  Fh(t, f), sk(t), ("left" in e || "top" in e) && ak(t, l);
  var b = {};
  for (var y in e)
    if (e.hasOwnProperty(y)) {
      var w = G1(y, n), S = e[y] - c[y];
      y === w ? b[w] = f[w] + S : b[w] = f[w] - S;
    }
  Fh(t, b);
}
function h1e(t, e) {
  var n = W0(t), r = n1e(t), i = {
    x: r.x,
    y: r.y
  };
  "left" in e && (i.x = r.x + e.left - n.left), "top" in e && (i.y = r.y + e.top - n.top), o1e(t, i);
}
function p1e(t, e, n) {
  if (n.ignoreShake) {
    var r = W0(t), i = r.left.toFixed(0), o = r.top.toFixed(0), a = e.left.toFixed(0), s = e.top.toFixed(0);
    if (i === a && o === s)
      return;
  }
  n.useCssRight || n.useCssBottom ? lk(t, e, n) : n.useCssTransform && mC() in document.body.style ? h1e(t, e) : lk(t, e, n);
}
function gA(t, e) {
  for (var n = 0; n < t.length; n++)
    e(t[n]);
}
function Gz(t) {
  return Dm(t, "boxSizing") === "border-box";
}
var g1e = ["margin", "border", "padding"], NI = -1, m1e = 2, kI = 1, v1e = 0;
function b1e(t, e, n) {
  var r = {}, i = t.style, o;
  for (o in e)
    e.hasOwnProperty(o) && (r[o] = i[o], i[o] = e[o]);
  n.call(t);
  for (o in e)
    e.hasOwnProperty(o) && (i[o] = r[o]);
}
function Kg(t, e, n) {
  var r = 0, i, o, a;
  for (o = 0; o < e.length; o++)
    if (i = e[o], i)
      for (a = 0; a < n.length; a++) {
        var s = void 0;
        i === "border" ? s = "".concat(i).concat(n[a], "Width") : s = i + n[a], r += parseFloat(Dm(t, s)) || 0;
      }
  return r;
}
var nu = {
  getParent: function(e) {
    var n = e;
    do
      n.nodeType === 11 && n.host ? n = n.host : n = n.parentNode;
    while (n && n.nodeType !== 1 && n.nodeType !== 9);
    return n;
  }
};
gA(["Width", "Height"], function(t) {
  nu["doc".concat(t)] = function(e) {
    var n = e.document;
    return Math.max(
      // firefox chrome documentElement.scrollHeight< body.scrollHeight
      // ie standard mode : documentElement.scrollHeight> body.scrollHeight
      n.documentElement["scroll".concat(t)],
      // quirks : documentElement.scrollHeight 最大等于可视窗口多一点？
      n.body["scroll".concat(t)],
      nu["viewport".concat(t)](n)
    );
  }, nu["viewport".concat(t)] = function(e) {
    var n = "client".concat(t), r = e.document, i = r.body, o = r.documentElement, a = o[n];
    return r.compatMode === "CSS1Compat" && a || i && i[n] || a;
  };
});
function ck(t, e, n) {
  var r = n;
  if (pA(t))
    return e === "width" ? nu.viewportWidth(t) : nu.viewportHeight(t);
  if (t.nodeType === 9)
    return e === "width" ? nu.docWidth(t) : nu.docHeight(t);
  var i = e === "width" ? ["Left", "Right"] : ["Top", "Bottom"], o = Math.floor(e === "width" ? t.getBoundingClientRect().width : t.getBoundingClientRect().height), a = Gz(t), s = 0;
  (o == null || o <= 0) && (o = void 0, s = Dm(t, e), (s == null || Number(s) < 0) && (s = t.style[e] || 0), s = Math.floor(parseFloat(s)) || 0), r === void 0 && (r = a ? kI : NI);
  var u = o !== void 0 || a, l = o || s;
  return r === NI ? u ? l - Kg(t, ["border", "padding"], i) : s : u ? r === kI ? l : l + (r === m1e ? -Kg(t, ["border"], i) : Kg(t, ["margin"], i)) : s + Kg(t, g1e.slice(r), i);
}
var y1e = {
  position: "absolute",
  visibility: "hidden",
  display: "block"
};
function dk() {
  for (var t = arguments.length, e = new Array(t), n = 0; n < t; n++)
    e[n] = arguments[n];
  var r, i = e[0];
  return i.offsetWidth !== 0 ? r = ck.apply(void 0, e) : b1e(i, y1e, function() {
    r = ck.apply(void 0, e);
  }), r;
}
gA(["width", "height"], function(t) {
  var e = t.charAt(0).toUpperCase() + t.slice(1);
  nu["outer".concat(e)] = function(r, i) {
    return r && dk(r, t, i ? v1e : kI);
  };
  var n = t === "width" ? ["Left", "Right"] : ["Top", "Bottom"];
  nu[t] = function(r, i) {
    var o = i;
    if (o !== void 0) {
      if (r) {
        var a = Gz(r);
        return a && (o += Kg(r, ["padding", "border"], n)), Fh(r, t, o);
      }
      return;
    }
    return r && dk(r, t, NI);
  };
});
function Uz(t, e) {
  for (var n in e)
    e.hasOwnProperty(n) && (t[n] = e[n]);
  return t;
}
var dn = {
  getWindow: function(e) {
    if (e && e.document && e.setTimeout)
      return e;
    var n = e.ownerDocument || e;
    return n.defaultView || n.parentWindow;
  },
  getDocument: zz,
  offset: function(e, n, r) {
    if (typeof n < "u")
      p1e(e, n, r || {});
    else
      return W0(e);
  },
  isWindow: pA,
  each: gA,
  css: Fh,
  clone: function(e) {
    var n, r = {};
    for (n in e)
      e.hasOwnProperty(n) && (r[n] = e[n]);
    var i = e.overflow;
    if (i)
      for (n in e)
        e.hasOwnProperty(n) && (r.overflow[n] = e.overflow[n]);
    return r;
  },
  mix: Uz,
  getWindowScrollLeft: function(e) {
    return Wz(e);
  },
  getWindowScrollTop: function(e) {
    return jz(e);
  },
  merge: function() {
    for (var e = {}, n = 0; n < arguments.length; n++)
      dn.mix(e, n < 0 || arguments.length <= n ? void 0 : arguments[n]);
    return e;
  },
  viewportWidth: 0,
  viewportHeight: 0
};
Uz(dn, nu);
var MS = dn.getParent;
function RI(t) {
  if (dn.isWindow(t) || t.nodeType === 9)
    return null;
  var e = dn.getDocument(t), n = e.body, r, i = dn.css(t, "position"), o = i === "fixed" || i === "absolute";
  if (!o)
    return t.nodeName.toLowerCase() === "html" ? null : MS(t);
  for (r = MS(t); r && r !== n && r.nodeType !== 9; r = MS(r))
    if (i = dn.css(r, "position"), i !== "static")
      return r;
  return null;
}
var fk = dn.getParent;
function x1e(t) {
  if (dn.isWindow(t) || t.nodeType === 9)
    return !1;
  var e = dn.getDocument(t), n = e.body, r = null;
  for (
    r = fk(t);
    // 修复元素位于 document.documentElement 下导致崩溃问题
    r && r !== n && r !== e;
    r = fk(r)
  ) {
    var i = dn.css(r, "position");
    if (i === "fixed")
      return !0;
  }
  return !1;
}
function mA(t, e) {
  for (var n = {
    left: 0,
    right: 1 / 0,
    top: 0,
    bottom: 1 / 0
  }, r = RI(t), i = dn.getDocument(t), o = i.defaultView || i.parentWindow, a = i.body, s = i.documentElement; r; ) {
    if ((navigator.userAgent.indexOf("MSIE") === -1 || r.clientWidth !== 0) && // body may have overflow set on it, yet we still get the entire
    // viewport. In some browsers, el.offsetParent may be
    // document.documentElement, so check for that too.
    r !== a && r !== s && dn.css(r, "overflow") !== "visible") {
      var u = dn.offset(r);
      u.left += r.clientLeft, u.top += r.clientTop, n.top = Math.max(n.top, u.top), n.right = Math.min(
        n.right,
        // consider area without scrollBar
        u.left + r.clientWidth
      ), n.bottom = Math.min(n.bottom, u.top + r.clientHeight), n.left = Math.max(n.left, u.left);
    } else if (r === a || r === s)
      break;
    r = RI(r);
  }
  var l = null;
  if (!dn.isWindow(t) && t.nodeType !== 9) {
    l = t.style.position;
    var c = dn.css(t, "position");
    c === "absolute" && (t.style.position = "fixed");
  }
  var d = dn.getWindowScrollLeft(o), f = dn.getWindowScrollTop(o), h = dn.viewportWidth(o), p = dn.viewportHeight(o), v = s.scrollWidth, m = s.scrollHeight, b = window.getComputedStyle(a);
  if (b.overflowX === "hidden" && (v = o.innerWidth), b.overflowY === "hidden" && (m = o.innerHeight), t.style && (t.style.position = l), e || x1e(t))
    n.left = Math.max(n.left, d), n.top = Math.max(n.top, f), n.right = Math.min(n.right, d + h), n.bottom = Math.min(n.bottom, f + p);
  else {
    var y = Math.max(v, d + h);
    n.right = Math.min(n.right, y);
    var w = Math.max(m, f + p);
    n.bottom = Math.min(n.bottom, w);
  }
  return n.top >= 0 && n.left >= 0 && n.bottom > n.top && n.right > n.left ? n : null;
}
function C1e(t, e, n, r) {
  var i = dn.clone(t), o = {
    width: e.width,
    height: e.height
  };
  return r.adjustX && i.left < n.left && (i.left = n.left), r.resizeWidth && i.left >= n.left && i.left + o.width > n.right && (o.width -= i.left + o.width - n.right), r.adjustX && i.left + o.width > n.right && (i.left = Math.max(n.right - o.width, n.left)), r.adjustY && i.top < n.top && (i.top = n.top), r.resizeHeight && i.top >= n.top && i.top + o.height > n.bottom && (o.height -= i.top + o.height - n.bottom), r.adjustY && i.top + o.height > n.bottom && (i.top = Math.max(n.bottom - o.height, n.top)), dn.mix(i, o);
}
function vA(t) {
  var e, n, r;
  if (!dn.isWindow(t) && t.nodeType !== 9)
    e = dn.offset(t), n = dn.outerWidth(t), r = dn.outerHeight(t);
  else {
    var i = dn.getWindow(t);
    e = {
      left: dn.getWindowScrollLeft(i),
      top: dn.getWindowScrollTop(i)
    }, n = dn.viewportWidth(i), r = dn.viewportHeight(i);
  }
  return e.width = n, e.height = r, e;
}
function hk(t, e) {
  var n = e.charAt(0), r = e.charAt(1), i = t.width, o = t.height, a = t.left, s = t.top;
  return n === "c" ? s += o / 2 : n === "b" && (s += o), r === "c" ? a += i / 2 : r === "r" && (a += i), {
    left: a,
    top: s
  };
}
function U1(t, e, n, r, i) {
  var o = hk(e, n[1]), a = hk(t, n[0]), s = [a.left - o.left, a.top - o.top];
  return {
    left: Math.round(t.left - s[0] + r[0] - i[0]),
    top: Math.round(t.top - s[1] + r[1] - i[1])
  };
}
function pk(t, e, n) {
  return t.left < n.left || t.left + e.width > n.right;
}
function gk(t, e, n) {
  return t.top < n.top || t.top + e.height > n.bottom;
}
function w1e(t, e, n) {
  return t.left > n.right || t.left + e.width < n.left;
}
function E1e(t, e, n) {
  return t.top > n.bottom || t.top + e.height < n.top;
}
function X1(t, e, n) {
  var r = [];
  return dn.each(t, function(i) {
    r.push(i.replace(e, function(o) {
      return n[o];
    }));
  }), r;
}
function Y1(t, e) {
  return t[e] = -t[e], t;
}
function mk(t, e) {
  var n;
  return /%$/.test(t) ? n = parseInt(t.substring(0, t.length - 1), 10) / 100 * e : n = parseInt(t, 10), n || 0;
}
function vk(t, e) {
  t[0] = mk(t[0], e.width), t[1] = mk(t[1], e.height);
}
function Xz(t, e, n, r) {
  var i = n.points, o = n.offset || [0, 0], a = n.targetOffset || [0, 0], s = n.overflow, u = n.source || t;
  o = [].concat(o), a = [].concat(a), s = s || {};
  var l = {}, c = 0, d = !!(s && s.alwaysByViewport), f = mA(u, d), h = vA(u);
  vk(o, h), vk(a, e);
  var p = U1(h, e, i, o, a), v = dn.merge(h, p);
  if (f && (s.adjustX || s.adjustY) && r) {
    if (s.adjustX && pk(p, h, f)) {
      var m = X1(i, /[lr]/gi, {
        l: "r",
        r: "l"
      }), b = Y1(o, 0), y = Y1(a, 0), w = U1(h, e, m, b, y);
      w1e(w, h, f) || (c = 1, i = m, o = b, a = y);
    }
    if (s.adjustY && gk(p, h, f)) {
      var S = X1(i, /[tb]/gi, {
        t: "b",
        b: "t"
      }), E = Y1(o, 1), I = Y1(a, 1), _ = U1(h, e, S, E, I);
      E1e(_, h, f) || (c = 1, i = S, o = E, a = I);
    }
    c && (p = U1(h, e, i, o, a), dn.mix(v, p));
    var A = pk(p, h, f), P = gk(p, h, f);
    if (A || P) {
      var N = i;
      A && (N = X1(i, /[lr]/gi, {
        l: "r",
        r: "l"
      })), P && (N = X1(i, /[tb]/gi, {
        t: "b",
        b: "t"
      })), i = N, o = n.offset || [0, 0], a = n.targetOffset || [0, 0];
    }
    l.adjustX = s.adjustX && A, l.adjustY = s.adjustY && P, (l.adjustX || l.adjustY) && (v = C1e(p, h, f, l));
  }
  return v.width !== h.width && dn.css(u, "width", dn.width(u) + v.width - h.width), v.height !== h.height && dn.css(u, "height", dn.height(u) + v.height - h.height), dn.offset(u, {
    left: v.left,
    top: v.top
  }, {
    useCssRight: n.useCssRight,
    useCssBottom: n.useCssBottom,
    useCssTransform: n.useCssTransform,
    ignoreShake: n.ignoreShake
  }), {
    points: i,
    offset: o,
    targetOffset: a,
    overflow: l
  };
}
function S1e(t, e) {
  var n = mA(t, e), r = vA(t);
  return !n || r.left + r.width <= n.left || r.top + r.height <= n.top || r.left >= n.right || r.top >= n.bottom;
}
function bA(t, e, n) {
  var r = n.target || e, i = vA(r), o = !S1e(r, n.overflow && n.overflow.alwaysByViewport);
  return Xz(t, i, n, o);
}
bA.__getOffsetParent = RI;
bA.__getVisibleRectForElement = mA;
function I1e(t, e, n) {
  var r, i, o = dn.getDocument(t), a = o.defaultView || o.parentWindow, s = dn.getWindowScrollLeft(a), u = dn.getWindowScrollTop(a), l = dn.viewportWidth(a), c = dn.viewportHeight(a);
  "pageX" in e ? r = e.pageX : r = s + e.clientX, "pageY" in e ? i = e.pageY : i = u + e.clientY;
  var d = {
    left: r,
    top: i,
    width: 0,
    height: 0
  }, f = r >= 0 && r <= s + l && i >= 0 && i <= u + c, h = [n.points[0], "cc"];
  return Xz(t, d, ok(ok({}, n), {}, {
    points: h
  }), f);
}
function np(t, e) {
  var n = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : !1, r = /* @__PURE__ */ new Set();
  function i(o, a) {
    var s = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 1, u = r.has(o);
    if (Wt(!u, "Warning: There may be circular references"), u)
      return !1;
    if (o === a)
      return !0;
    if (n && s > 1)
      return !1;
    r.add(o);
    var l = s + 1;
    if (Array.isArray(o)) {
      if (!Array.isArray(a) || o.length !== a.length)
        return !1;
      for (var c = 0; c < o.length; c++)
        if (!i(o[c], a[c], l))
          return !1;
      return !0;
    }
    if (o && a && _t(o) === "object" && _t(a) === "object") {
      var d = Object.keys(o);
      return d.length !== Object.keys(a).length ? !1 : d.every(function(f) {
        return i(o[f], a[f], l);
      });
    }
    return !1;
  }
  return i(t, e);
}
const yA = function(t) {
  if (!t)
    return !1;
  if (t instanceof Element) {
    if (t.offsetParent)
      return !0;
    if (t.getBBox) {
      var e = t.getBBox(), n = e.width, r = e.height;
      if (n || r)
        return !0;
    }
    if (t.getBoundingClientRect) {
      var i = t.getBoundingClientRect(), o = i.width, a = i.height;
      if (o || a)
        return !0;
    }
  }
  return !1;
}, _1e = function(t, e) {
  var n = O.useRef(!1), r = O.useRef(null);
  function i() {
    window.clearTimeout(r.current);
  }
  function o(a) {
    if (i(), !n.current || a === !0) {
      if (t(a) === !1)
        return;
      n.current = !0, r.current = window.setTimeout(function() {
        n.current = !1;
      }, e);
    } else
      r.current = window.setTimeout(function() {
        n.current = !1, o();
      }, e);
  }
  return [o, function() {
    n.current = !1, i();
  }];
};
function A1e(t, e) {
  return t === e ? !0 : !t || !e ? !1 : "pageX" in e && "pageY" in e ? t.pageX === e.pageX && t.pageY === e.pageY : "clientX" in e && "clientY" in e ? t.clientX === e.clientX && t.clientY === e.clientY : !1;
}
function T1e(t, e) {
  t !== document.activeElement && l0(e, t) && typeof t.focus == "function" && t.focus();
}
function bk(t, e) {
  var n = null, r = null;
  function i(a) {
    var s = be(a, 1), u = s[0].target;
    if (document.documentElement.contains(u)) {
      var l = u.getBoundingClientRect(), c = l.width, d = l.height, f = Math.floor(c), h = Math.floor(d);
      (n !== f || r !== h) && Promise.resolve().then(function() {
        e({
          width: f,
          height: h
        });
      }), n = f, r = h;
    }
  }
  var o = new $j(i);
  return t && o.observe(t), function() {
    o.disconnect();
  };
}
function yk(t) {
  return typeof t != "function" ? null : t();
}
function xk(t) {
  return _t(t) !== "object" || !t ? null : t;
}
var O1e = function(e, n) {
  var r = e.children, i = e.disabled, o = e.target, a = e.align, s = e.onAlign, u = e.monitorWindowResize, l = e.monitorBufferTime, c = l === void 0 ? 0 : l, d = O.useRef({}), f = O.useRef(), h = O.Children.only(r), p = O.useRef({});
  p.current.disabled = i, p.current.target = o, p.current.align = a, p.current.onAlign = s;
  var v = _1e(function() {
    var k = p.current, D = k.disabled, R = k.target, V = k.align, $ = k.onAlign, F = f.current;
    if (!D && R && F) {
      var M, B = yk(R), X = xk(R);
      d.current.element = B, d.current.point = X, d.current.align = V;
      var L = document, j = L.activeElement;
      return B && yA(B) ? M = bA(F, B, V) : X && (M = I1e(F, X, V)), T1e(j, F), $ && M && $(F, M), !0;
    }
    return !1;
  }, c), m = be(v, 2), b = m[0], y = m[1], w = O.useState(), S = be(w, 2), E = S[0], I = S[1], _ = O.useState(), A = be(_, 2), P = A[0], N = A[1];
  return To(function() {
    I(yk(o)), N(xk(o));
  }), O.useEffect(function() {
    (d.current.element !== E || !A1e(d.current.point, P) || !np(d.current.align, a)) && b();
  }), O.useEffect(function() {
    var k = bk(f.current, b);
    return k;
  }, [f.current]), O.useEffect(function() {
    var k = bk(E, b);
    return k;
  }, [E]), O.useEffect(function() {
    i ? y() : b();
  }, [i]), O.useEffect(function() {
    if (u) {
      var k = Jg(window, "resize", b);
      return k.remove;
    }
  }, [u]), O.useEffect(function() {
    return function() {
      y();
    };
  }, []), O.useImperativeHandle(n, function() {
    return {
      forceAlign: function() {
        return b(!0);
      }
    };
  }), /* @__PURE__ */ O.isValidElement(h) && (h = /* @__PURE__ */ O.cloneElement(h, {
    ref: Ja(h.ref, f)
  })), h;
}, Yz = /* @__PURE__ */ O.forwardRef(O1e);
Yz.displayName = "Align";
var Ck = ["measure", "alignPre", "align", null, "motion"];
const P1e = function(t, e) {
  var n = nc(null), r = be(n, 2), i = r[0], o = r[1], a = Ee();
  function s(c) {
    o(c, !0);
  }
  function u() {
    En.cancel(a.current);
  }
  function l(c) {
    u(), a.current = En(function() {
      s(function(d) {
        switch (i) {
          case "align":
            return "motion";
          case "motion":
            return "stable";
        }
        return d;
      }), c == null || c();
    });
  }
  return Re(function() {
    s("measure");
  }, [t]), Re(function() {
    switch (i) {
      case "measure":
        e();
        break;
    }
    i && (a.current = En(/* @__PURE__ */ ul(/* @__PURE__ */ ai().mark(function c() {
      var d, f;
      return ai().wrap(function(p) {
        for (; ; )
          switch (p.prev = p.next) {
            case 0:
              d = Ck.indexOf(i), f = Ck[d + 1], f && d !== -1 && s(f);
            case 3:
            case "end":
              return p.stop();
          }
      }, c);
    }))));
  }, [i]), Re(function() {
    return function() {
      u();
    };
  }, []), [i, l];
}, N1e = function(t) {
  var e = x.useState({
    width: 0,
    height: 0
  }), n = be(e, 2), r = n[0], i = n[1];
  function o(s) {
    var u = s.offsetWidth, l = s.offsetHeight, c = s.getBoundingClientRect(), d = c.width, f = c.height;
    Math.abs(u - d) < 1 && Math.abs(l - f) < 1 && (u = d, l = f), i({
      width: u,
      height: l
    });
  }
  var a = x.useMemo(function() {
    var s = {};
    if (t) {
      var u = r.width, l = r.height;
      t.indexOf("height") !== -1 && l ? s.height = l : t.indexOf("minHeight") !== -1 && l && (s.minHeight = l), t.indexOf("width") !== -1 && u ? s.width = u : t.indexOf("minWidth") !== -1 && u && (s.minWidth = u);
    }
    return s;
  }, [t, r]);
  return [a, o];
};
var Zz = /* @__PURE__ */ x.forwardRef(function(t, e) {
  var n = t.visible, r = t.prefixCls, i = t.className, o = t.style, a = t.children, s = t.zIndex, u = t.stretch, l = t.destroyPopupOnHide, c = t.forceRender, d = t.align, f = t.point, h = t.getRootDomNode, p = t.getClassNameFromAlign, v = t.onAlign, m = t.onMouseEnter, b = t.onMouseLeave, y = t.onMouseDown, w = t.onTouchStart, S = t.onClick, E = Ee(), I = Ee(), _ = Le(), A = be(_, 2), P = A[0], N = A[1], k = N1e(u), D = be(k, 2), R = D[0], V = D[1];
  function $() {
    u && V(h());
  }
  var F = P1e(n, $), M = be(F, 2), B = M[0], X = M[1], L = Le(0), j = be(L, 2), K = j[0], W = j[1], Y = Ee();
  To(function() {
    B === "alignPre" && W(0);
  }, [B]);
  function U() {
    return f || h;
  }
  function Q() {
    var ge;
    (ge = E.current) === null || ge === void 0 || ge.forceAlign();
  }
  function Z(ge, he) {
    var fe = p(he);
    P !== fe && N(fe), W(function(_e) {
      return _e + 1;
    }), B === "align" && (v == null || v(ge, he));
  }
  To(function() {
    B === "align" && (K < 3 ? Q() : X(function() {
      var ge;
      (ge = Y.current) === null || ge === void 0 || ge.call(Y);
    }));
  }, [K]);
  var ee = de({}, Vz(t));
  ["onAppearEnd", "onEnterEnd", "onLeaveEnd"].forEach(function(ge) {
    var he = ee[ge];
    ee[ge] = function(fe, _e) {
      return X(), he == null ? void 0 : he(fe, _e);
    };
  });
  function ie() {
    return new Promise(function(ge) {
      Y.current = ge;
    });
  }
  x.useEffect(function() {
    !ee.motionName && B === "motion" && X();
  }, [ee.motionName, B]), x.useImperativeHandle(e, function() {
    return {
      forceAlign: Q,
      getElement: function() {
        return I.current;
      }
    };
  });
  var oe = de(de({}, R), {}, {
    zIndex: s,
    opacity: B === "motion" || B === "stable" || !n ? void 0 : 0,
    // Cannot interact with disappearing elements
    // https://github.com/ant-design/ant-design/issues/35051#issuecomment-1101340714
    pointerEvents: !n && B !== "stable" ? "none" : void 0
  }, o), se = !0;
  d != null && d.points && (B === "align" || B === "stable") && (se = !1);
  var te = a;
  return x.Children.count(a) > 1 && (te = /* @__PURE__ */ x.createElement("div", {
    className: "".concat(r, "-content")
  }, a)), /* @__PURE__ */ x.createElement(ll, G({
    visible: n,
    ref: I,
    leavedClassName: "".concat(r, "-hidden")
  }, ee, {
    onAppearPrepare: ie,
    onEnterPrepare: ie,
    removeOnLeave: l,
    forceRender: c
  }), function(ge, he) {
    var fe = ge.className, _e = ge.style, Ne = Ce(r, i, P, fe);
    return /* @__PURE__ */ x.createElement(Yz, {
      target: U(),
      key: "popup",
      ref: E,
      monitorWindowResize: !0,
      disabled: se,
      align: d,
      onAlign: Z
    }, /* @__PURE__ */ x.createElement("div", {
      ref: he,
      className: Ne,
      onMouseEnter: m,
      onMouseLeave: b,
      onMouseDownCapture: y,
      onTouchStartCapture: w,
      onClick: S,
      style: de(de({}, _e), oe)
    }, te));
  });
});
Zz.displayName = "PopupInner";
var Jz = /* @__PURE__ */ x.forwardRef(function(t, e) {
  var n = t.prefixCls, r = t.visible, i = t.zIndex, o = t.children, a = t.mobile;
  a = a === void 0 ? {} : a;
  var s = a.popupClassName, u = a.popupStyle, l = a.popupMotion, c = l === void 0 ? {} : l, d = a.popupRender, f = t.onClick, h = x.useRef();
  x.useImperativeHandle(e, function() {
    return {
      forceAlign: function() {
      },
      getElement: function() {
        return h.current;
      }
    };
  });
  var p = de({
    zIndex: i
  }, u), v = o;
  return x.Children.count(o) > 1 && (v = /* @__PURE__ */ x.createElement("div", {
    className: "".concat(n, "-content")
  }, o)), d && (v = d(v)), /* @__PURE__ */ x.createElement(ll, G({
    visible: r,
    ref: h,
    removeOnLeave: !0
  }, c), function(m, b) {
    var y = m.className, w = m.style, S = Ce(n, s, y);
    return /* @__PURE__ */ x.createElement("div", {
      ref: b,
      className: S,
      onClick: f,
      style: de(de({}, w), p)
    }, v);
  });
});
Jz.displayName = "MobilePopupInner";
var k1e = ["visible", "mobile"], Kz = /* @__PURE__ */ x.forwardRef(function(t, e) {
  var n = t.visible, r = t.mobile, i = Gt(t, k1e), o = Le(n), a = be(o, 2), s = a[0], u = a[1], l = Le(!1), c = be(l, 2), d = c[0], f = c[1], h = de(de({}, i), {}, {
    visible: s
  });
  Re(function() {
    u(n), n && r && f(dA());
  }, [n, r]);
  var p = d ? /* @__PURE__ */ x.createElement(Jz, G({}, h, {
    mobile: r,
    ref: e
  })) : /* @__PURE__ */ x.createElement(Zz, G({}, h, {
    ref: e
  }));
  return /* @__PURE__ */ x.createElement("div", null, /* @__PURE__ */ x.createElement(qve, h), p);
});
Kz.displayName = "Popup";
var wk = /* @__PURE__ */ x.createContext(null);
function FS() {
}
function R1e() {
  return "";
}
function $1e(t) {
  return t ? t.ownerDocument : window.document;
}
var D1e = ["onClick", "onMouseDown", "onTouchStart", "onMouseEnter", "onMouseLeave", "onFocus", "onBlur", "onContextMenu"];
function M1e(t) {
  var e = /* @__PURE__ */ function(n) {
    Pr(i, n);
    var r = Hr(i);
    function i(o) {
      var a;
      zn(this, i), a = r.call(this, o), z(It(a), "popupRef", /* @__PURE__ */ x.createRef()), z(It(a), "triggerRef", /* @__PURE__ */ x.createRef()), z(It(a), "portalContainer", void 0), z(It(a), "attachId", void 0), z(It(a), "clickOutsideHandler", void 0), z(It(a), "touchOutsideHandler", void 0), z(It(a), "contextMenuOutsideHandler1", void 0), z(It(a), "contextMenuOutsideHandler2", void 0), z(It(a), "mouseDownTimeout", void 0), z(It(a), "focusTime", void 0), z(It(a), "preClickTime", void 0), z(It(a), "preTouchTime", void 0), z(It(a), "delayTimer", void 0), z(It(a), "hasPopupMouseDown", void 0), z(It(a), "onMouseEnter", function(u) {
        var l = a.props.mouseEnterDelay;
        a.fireEvents("onMouseEnter", u), a.delaySetPopupVisible(!0, l, l ? null : u);
      }), z(It(a), "onMouseMove", function(u) {
        a.fireEvents("onMouseMove", u), a.setPoint(u);
      }), z(It(a), "onMouseLeave", function(u) {
        a.fireEvents("onMouseLeave", u), a.delaySetPopupVisible(!1, a.props.mouseLeaveDelay);
      }), z(It(a), "onPopupMouseEnter", function() {
        a.clearDelayTimer();
      }), z(It(a), "onPopupMouseLeave", function(u) {
        var l;
        u.relatedTarget && !u.relatedTarget.setTimeout && l0((l = a.popupRef.current) === null || l === void 0 ? void 0 : l.getElement(), u.relatedTarget) || a.delaySetPopupVisible(!1, a.props.mouseLeaveDelay);
      }), z(It(a), "onFocus", function(u) {
        a.fireEvents("onFocus", u), a.clearDelayTimer(), a.isFocusToShow() && (a.focusTime = Date.now(), a.delaySetPopupVisible(!0, a.props.focusDelay));
      }), z(It(a), "onMouseDown", function(u) {
        a.fireEvents("onMouseDown", u), a.preClickTime = Date.now();
      }), z(It(a), "onTouchStart", function(u) {
        a.fireEvents("onTouchStart", u), a.preTouchTime = Date.now();
      }), z(It(a), "onBlur", function(u) {
        a.fireEvents("onBlur", u), a.clearDelayTimer(), a.isBlurToHide() && a.delaySetPopupVisible(!1, a.props.blurDelay);
      }), z(It(a), "onContextMenu", function(u) {
        u.preventDefault(), a.fireEvents("onContextMenu", u), a.setPopupVisible(!0, u);
      }), z(It(a), "onContextMenuClose", function() {
        a.isContextMenuToShow() && a.close();
      }), z(It(a), "onClick", function(u) {
        if (a.fireEvents("onClick", u), a.focusTime) {
          var l;
          if (a.preClickTime && a.preTouchTime ? l = Math.min(a.preClickTime, a.preTouchTime) : a.preClickTime ? l = a.preClickTime : a.preTouchTime && (l = a.preTouchTime), Math.abs(l - a.focusTime) < 20)
            return;
          a.focusTime = 0;
        }
        a.preClickTime = 0, a.preTouchTime = 0, a.isClickToShow() && (a.isClickToHide() || a.isBlurToHide()) && u && u.preventDefault && u.preventDefault();
        var c = !a.state.popupVisible;
        (a.isClickToHide() && !c || c && a.isClickToShow()) && a.setPopupVisible(!a.state.popupVisible, u);
      }), z(It(a), "onPopupMouseDown", function() {
        if (a.hasPopupMouseDown = !0, clearTimeout(a.mouseDownTimeout), a.mouseDownTimeout = window.setTimeout(function() {
          a.hasPopupMouseDown = !1;
        }, 0), a.context) {
          var u;
          (u = a.context).onPopupMouseDown.apply(u, arguments);
        }
      }), z(It(a), "onDocumentClick", function(u) {
        if (!(a.props.mask && !a.props.maskClosable)) {
          var l = u.target, c = a.getRootDomNode(), d = a.getPopupDomNode();
          // mousedown on the target should also close popup when action is contextMenu.
          // https://github.com/ant-design/ant-design/issues/29853
          (!l0(c, l) || a.isContextMenuOnly()) && !l0(d, l) && !a.hasPopupMouseDown && a.close();
        }
      }), z(It(a), "getRootDomNode", function() {
        var u = a.props.getTriggerDOMNode;
        if (u)
          return u(a.triggerRef.current);
        try {
          var l = md(a.triggerRef.current);
          if (l)
            return l;
        } catch {
        }
        return ks.findDOMNode(It(a));
      }), z(It(a), "getPopupClassNameFromAlign", function(u) {
        var l = [], c = a.props, d = c.popupPlacement, f = c.builtinPlacements, h = c.prefixCls, p = c.alignPoint, v = c.getPopupClassNameFromAlign;
        return d && f && l.push(Kve(f, h, u, p)), v && l.push(v(u)), l.join(" ");
      }), z(It(a), "getComponent", function() {
        var u = a.props, l = u.prefixCls, c = u.destroyPopupOnHide, d = u.popupClassName, f = u.onPopupAlign, h = u.popupMotion, p = u.popupAnimation, v = u.popupTransitionName, m = u.popupStyle, b = u.mask, y = u.maskAnimation, w = u.maskTransitionName, S = u.maskMotion, E = u.zIndex, I = u.popup, _ = u.stretch, A = u.alignPoint, P = u.mobile, N = u.forceRender, k = u.onPopupClick, D = a.state, R = D.popupVisible, V = D.point, $ = a.getPopupAlign(), F = {};
        return a.isMouseEnterToShow() && (F.onMouseEnter = a.onPopupMouseEnter), a.isMouseLeaveToHide() && (F.onMouseLeave = a.onPopupMouseLeave), F.onMouseDown = a.onPopupMouseDown, F.onTouchStart = a.onPopupMouseDown, /* @__PURE__ */ x.createElement(Kz, G({
          prefixCls: l,
          destroyPopupOnHide: c,
          visible: R,
          point: A && V,
          className: d,
          align: $,
          onAlign: f,
          animation: p,
          getClassNameFromAlign: a.getPopupClassNameFromAlign
        }, F, {
          stretch: _,
          getRootDomNode: a.getRootDomNode,
          style: m,
          mask: b,
          zIndex: E,
          transitionName: v,
          maskAnimation: y,
          maskTransitionName: w,
          maskMotion: S,
          ref: a.popupRef,
          motion: h,
          mobile: P,
          forceRender: N,
          onClick: k
        }), typeof I == "function" ? I() : I);
      }), z(It(a), "attachParent", function(u) {
        En.cancel(a.attachId);
        var l = a.props, c = l.getPopupContainer, d = l.getDocument, f = a.getRootDomNode(), h;
        c ? (f || c.length === 0) && (h = c(f)) : h = d(a.getRootDomNode()).body, h ? h.appendChild(u) : a.attachId = En(function() {
          a.attachParent(u);
        });
      }), z(It(a), "getContainer", function() {
        if (!a.portalContainer) {
          var u = a.props.getDocument, l = u(a.getRootDomNode()).createElement("div");
          l.style.position = "absolute", l.style.top = "0", l.style.left = "0", l.style.width = "100%", a.portalContainer = l;
        }
        return a.attachParent(a.portalContainer), a.portalContainer;
      }), z(It(a), "setPoint", function(u) {
        var l = a.props.alignPoint;
        !l || !u || a.setState({
          point: {
            pageX: u.pageX,
            pageY: u.pageY
          }
        });
      }), z(It(a), "handlePortalUpdate", function() {
        a.state.prevPopupVisible !== a.state.popupVisible && a.props.afterPopupVisibleChange(a.state.popupVisible);
      }), z(It(a), "triggerContextValue", {
        onPopupMouseDown: a.onPopupMouseDown
      });
      var s;
      return "popupVisible" in o ? s = !!o.popupVisible : s = !!o.defaultPopupVisible, a.state = {
        prevPopupVisible: s,
        popupVisible: s
      }, D1e.forEach(function(u) {
        a["fire".concat(u)] = function(l) {
          a.fireEvents(u, l);
        };
      }), a;
    }
    return Gn(i, [{
      key: "componentDidMount",
      value: function() {
        this.componentDidUpdate();
      }
    }, {
      key: "componentDidUpdate",
      value: function() {
        var a = this.props, s = this.state;
        if (s.popupVisible) {
          var u;
          !this.clickOutsideHandler && (this.isClickToHide() || this.isContextMenuToShow()) && (u = a.getDocument(this.getRootDomNode()), this.clickOutsideHandler = Jg(u, "mousedown", this.onDocumentClick)), this.touchOutsideHandler || (u = u || a.getDocument(this.getRootDomNode()), this.touchOutsideHandler = Jg(u, "touchstart", this.onDocumentClick)), !this.contextMenuOutsideHandler1 && this.isContextMenuToShow() && (u = u || a.getDocument(this.getRootDomNode()), this.contextMenuOutsideHandler1 = Jg(u, "scroll", this.onContextMenuClose)), !this.contextMenuOutsideHandler2 && this.isContextMenuToShow() && (this.contextMenuOutsideHandler2 = Jg(window, "blur", this.onContextMenuClose));
          return;
        }
        this.clearOutsideHandler();
      }
    }, {
      key: "componentWillUnmount",
      value: function() {
        this.clearDelayTimer(), this.clearOutsideHandler(), clearTimeout(this.mouseDownTimeout), En.cancel(this.attachId);
      }
    }, {
      key: "getPopupDomNode",
      value: function() {
        var a;
        return ((a = this.popupRef.current) === null || a === void 0 ? void 0 : a.getElement()) || null;
      }
    }, {
      key: "getPopupAlign",
      value: function() {
        var a = this.props, s = a.popupPlacement, u = a.popupAlign, l = a.builtinPlacements;
        return s && l ? Jve(l, s, u) : u;
      }
    }, {
      key: "setPopupVisible",
      value: (
        /**
         * @param popupVisible    Show or not the popup element
         * @param event           SyntheticEvent, used for `pointAlign`
         */
        function(a, s) {
          var u = this.props.alignPoint, l = this.state.popupVisible;
          this.clearDelayTimer(), l !== a && ("popupVisible" in this.props || this.setState({
            popupVisible: a,
            prevPopupVisible: l
          }), this.props.onPopupVisibleChange(a)), u && s && a && this.setPoint(s);
        }
      )
    }, {
      key: "delaySetPopupVisible",
      value: function(a, s, u) {
        var l = this, c = s * 1e3;
        if (this.clearDelayTimer(), c) {
          var d = u ? {
            pageX: u.pageX,
            pageY: u.pageY
          } : null;
          this.delayTimer = window.setTimeout(function() {
            l.setPopupVisible(a, d), l.clearDelayTimer();
          }, c);
        } else
          this.setPopupVisible(a, u);
      }
    }, {
      key: "clearDelayTimer",
      value: function() {
        this.delayTimer && (clearTimeout(this.delayTimer), this.delayTimer = null);
      }
    }, {
      key: "clearOutsideHandler",
      value: function() {
        this.clickOutsideHandler && (this.clickOutsideHandler.remove(), this.clickOutsideHandler = null), this.contextMenuOutsideHandler1 && (this.contextMenuOutsideHandler1.remove(), this.contextMenuOutsideHandler1 = null), this.contextMenuOutsideHandler2 && (this.contextMenuOutsideHandler2.remove(), this.contextMenuOutsideHandler2 = null), this.touchOutsideHandler && (this.touchOutsideHandler.remove(), this.touchOutsideHandler = null);
      }
    }, {
      key: "createTwoChains",
      value: function(a) {
        var s = this.props.children.props, u = this.props;
        return s[a] && u[a] ? this["fire".concat(a)] : s[a] || u[a];
      }
    }, {
      key: "isClickToShow",
      value: function() {
        var a = this.props, s = a.action, u = a.showAction;
        return s.indexOf("click") !== -1 || u.indexOf("click") !== -1;
      }
    }, {
      key: "isContextMenuOnly",
      value: function() {
        var a = this.props.action;
        return a === "contextMenu" || a.length === 1 && a[0] === "contextMenu";
      }
    }, {
      key: "isContextMenuToShow",
      value: function() {
        var a = this.props, s = a.action, u = a.showAction;
        return s.indexOf("contextMenu") !== -1 || u.indexOf("contextMenu") !== -1;
      }
    }, {
      key: "isClickToHide",
      value: function() {
        var a = this.props, s = a.action, u = a.hideAction;
        return s.indexOf("click") !== -1 || u.indexOf("click") !== -1;
      }
    }, {
      key: "isMouseEnterToShow",
      value: function() {
        var a = this.props, s = a.action, u = a.showAction;
        return s.indexOf("hover") !== -1 || u.indexOf("mouseEnter") !== -1;
      }
    }, {
      key: "isMouseLeaveToHide",
      value: function() {
        var a = this.props, s = a.action, u = a.hideAction;
        return s.indexOf("hover") !== -1 || u.indexOf("mouseLeave") !== -1;
      }
    }, {
      key: "isFocusToShow",
      value: function() {
        var a = this.props, s = a.action, u = a.showAction;
        return s.indexOf("focus") !== -1 || u.indexOf("focus") !== -1;
      }
    }, {
      key: "isBlurToHide",
      value: function() {
        var a = this.props, s = a.action, u = a.hideAction;
        return s.indexOf("focus") !== -1 || u.indexOf("blur") !== -1;
      }
    }, {
      key: "forcePopupAlign",
      value: function() {
        if (this.state.popupVisible) {
          var a;
          (a = this.popupRef.current) === null || a === void 0 || a.forceAlign();
        }
      }
    }, {
      key: "fireEvents",
      value: function(a, s) {
        var u = this.props.children.props[a];
        u && u(s);
        var l = this.props[a];
        l && l(s);
      }
    }, {
      key: "close",
      value: function() {
        this.setPopupVisible(!1);
      }
    }, {
      key: "render",
      value: function() {
        var a = this.state.popupVisible, s = this.props, u = s.children, l = s.forceRender, c = s.alignPoint, d = s.className, f = s.autoDestroy, h = x.Children.only(u), p = {
          key: "trigger"
        };
        this.isContextMenuToShow() ? p.onContextMenu = this.onContextMenu : p.onContextMenu = this.createTwoChains("onContextMenu"), this.isClickToHide() || this.isClickToShow() ? (p.onClick = this.onClick, p.onMouseDown = this.onMouseDown, p.onTouchStart = this.onTouchStart) : (p.onClick = this.createTwoChains("onClick"), p.onMouseDown = this.createTwoChains("onMouseDown"), p.onTouchStart = this.createTwoChains("onTouchStart")), this.isMouseEnterToShow() ? (p.onMouseEnter = this.onMouseEnter, c && (p.onMouseMove = this.onMouseMove)) : p.onMouseEnter = this.createTwoChains("onMouseEnter"), this.isMouseLeaveToHide() ? p.onMouseLeave = this.onMouseLeave : p.onMouseLeave = this.createTwoChains("onMouseLeave"), this.isFocusToShow() || this.isBlurToHide() ? (p.onFocus = this.onFocus, p.onBlur = this.onBlur) : (p.onFocus = this.createTwoChains("onFocus"), p.onBlur = this.createTwoChains("onBlur"));
        var v = Ce(h && h.props && h.props.className, d);
        v && (p.className = v);
        var m = de({}, p);
        Rm(h) && (m.ref = Ja(this.triggerRef, h.ref));
        var b = /* @__PURE__ */ x.cloneElement(h, m), y;
        return (a || this.popupRef.current || l) && (y = /* @__PURE__ */ x.createElement(t, {
          key: "portal",
          getContainer: this.getContainer,
          didUpdate: this.handlePortalUpdate
        }, this.getComponent())), !a && f && (y = null), /* @__PURE__ */ x.createElement(wk.Provider, {
          value: this.triggerContextValue
        }, b, y);
      }
    }], [{
      key: "getDerivedStateFromProps",
      value: function(a, s) {
        var u = a.popupVisible, l = {};
        return u !== void 0 && s.popupVisible !== u && (l.popupVisible = u, l.prevPopupVisible = s.popupVisible), l;
      }
    }]), i;
  }(x.Component);
  return z(e, "contextType", wk), z(e, "defaultProps", {
    prefixCls: "rc-trigger-popup",
    getPopupClassNameFromAlign: R1e,
    getDocument: $1e,
    onPopupVisibleChange: FS,
    afterPopupVisibleChange: FS,
    onPopupAlign: FS,
    popupClassName: "",
    mouseEnterDelay: 0,
    mouseLeaveDelay: 0.1,
    focusDelay: 0,
    blurDelay: 0.15,
    popupStyle: {},
    destroyPopupOnHide: !1,
    popupAlign: {},
    defaultPopupVisible: !1,
    mask: !1,
    maskClosable: !0,
    action: [],
    showAction: [],
    hideAction: [],
    autoDestroy: !1
  }), e;
}
const Mm = M1e(Yve);
var F1e = ["prefixCls", "disabled", "visible", "children", "popupElement", "containerWidth", "animation", "transitionName", "dropdownStyle", "dropdownClassName", "direction", "placement", "dropdownMatchSelectWidth", "dropdownRender", "dropdownAlign", "getPopupContainer", "empty", "getTriggerDOMNode", "onPopupVisibleChange", "onPopupMouseEnter"], L1e = function(e) {
  var n = e === !0 ? 0 : 1;
  return {
    bottomLeft: {
      points: ["tl", "bl"],
      offset: [0, 4],
      overflow: {
        adjustX: n,
        adjustY: 1
      }
    },
    bottomRight: {
      points: ["tr", "br"],
      offset: [0, 4],
      overflow: {
        adjustX: n,
        adjustY: 1
      }
    },
    topLeft: {
      points: ["bl", "tl"],
      offset: [0, -4],
      overflow: {
        adjustX: n,
        adjustY: 1
      }
    },
    topRight: {
      points: ["br", "tr"],
      offset: [0, -4],
      overflow: {
        adjustX: n,
        adjustY: 1
      }
    }
  };
}, V1e = function(e, n) {
  var r = e.prefixCls;
  e.disabled;
  var i = e.visible, o = e.children, a = e.popupElement, s = e.containerWidth, u = e.animation, l = e.transitionName, c = e.dropdownStyle, d = e.dropdownClassName, f = e.direction, h = f === void 0 ? "ltr" : f, p = e.placement, v = e.dropdownMatchSelectWidth, m = e.dropdownRender, b = e.dropdownAlign, y = e.getPopupContainer, w = e.empty, S = e.getTriggerDOMNode, E = e.onPopupVisibleChange, I = e.onPopupMouseEnter, _ = Gt(e, F1e), A = "".concat(r, "-dropdown"), P = a;
  m && (P = m(a));
  var N = x.useMemo(function() {
    return L1e(v);
  }, [v]), k = u ? "".concat(A, "-").concat(u) : l, D = x.useRef(null);
  x.useImperativeHandle(n, function() {
    return {
      getPopupElement: function() {
        return D.current;
      }
    };
  });
  var R = de({
    minWidth: s
  }, c);
  return typeof v == "number" ? R.width = v : v && (R.width = s), /* @__PURE__ */ x.createElement(Mm, G({}, _, {
    showAction: E ? ["click"] : [],
    hideAction: E ? ["click"] : [],
    popupPlacement: p || (h === "rtl" ? "bottomRight" : "bottomLeft"),
    builtinPlacements: N,
    prefixCls: A,
    popupTransitionName: k,
    popup: /* @__PURE__ */ x.createElement("div", {
      ref: D,
      onMouseEnter: I
    }, P),
    popupAlign: b,
    popupVisible: i,
    getPopupContainer: y,
    popupClassName: Ce(d, z({}, "".concat(A, "-empty"), w)),
    popupStyle: R,
    getTriggerDOMNode: S,
    onPopupVisibleChange: E
  }), o);
}, qz = /* @__PURE__ */ x.forwardRef(V1e);
qz.displayName = "SelectTrigger";
function Ek(t, e) {
  var n = t.key, r;
  return "value" in t && (r = t.value), n ?? (r !== void 0 ? r : "rc-index-key-".concat(e));
}
function Qz(t, e) {
  var n = t || {}, r = n.label, i = n.value, o = n.options;
  return {
    label: r || (e ? "children" : "label"),
    value: i || "value",
    options: o || "options"
  };
}
function B1e(t) {
  var e = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, n = e.fieldNames, r = e.childrenAsData, i = [], o = Qz(n, !1), a = o.label, s = o.value, u = o.options;
  function l(c, d) {
    c.forEach(function(f) {
      var h = f[a];
      if (d || !(u in f)) {
        var p = f[s];
        i.push({
          key: Ek(f, i.length),
          groupOption: d,
          data: f,
          label: h,
          value: p
        });
      } else {
        var v = h;
        v === void 0 && r && (v = f.label), i.push({
          key: Ek(f, i.length),
          group: !0,
          data: f,
          label: v
        }), l(f[u], !0);
      }
    });
  }
  return l(t, !1), i;
}
function $I(t) {
  var e = de({}, t);
  return "props" in e || Object.defineProperty(e, "props", {
    get: function() {
      return Wt(!1, "Return type is option instead of Option instance. Please read value directly instead of reading from `props`."), e;
    }
  }), e;
}
function H1e(t, e) {
  if (!e || !e.length)
    return null;
  var n = !1;
  function r(o, a) {
    var s = Vj(a), u = s[0], l = s.slice(1);
    if (!u)
      return [o];
    var c = o.split(u);
    return n = n || c.length > 1, c.reduce(function(d, f) {
      return [].concat(Ye(d), Ye(r(f, l)));
    }, []).filter(function(d) {
      return d;
    });
  }
  var i = r(t, e);
  return n ? i : null;
}
var W1e = ["id", "prefixCls", "className", "showSearch", "tagRender", "direction", "omitDomProps", "displayValues", "onDisplayValuesChange", "emptyOptions", "notFoundContent", "onClear", "mode", "disabled", "loading", "getInputElement", "getRawInputElement", "open", "defaultOpen", "onDropdownVisibleChange", "activeValue", "onActiveValueChange", "activeDescendantId", "searchValue", "autoClearSearchValue", "onSearch", "onSearchSplit", "tokenSeparators", "allowClear", "showArrow", "inputIcon", "clearIcon", "OptionList", "animation", "transitionName", "dropdownStyle", "dropdownClassName", "dropdownMatchSelectWidth", "dropdownRender", "dropdownAlign", "placement", "getPopupContainer", "showAction", "onFocus", "onBlur", "onKeyUp", "onKeyDown", "onMouseDown"], j1e = ["value", "onChange", "removeIcon", "placeholder", "autoFocus", "maxTagCount", "maxTagTextLength", "maxTagPlaceholder", "choiceTransitionName", "onInputKeyDown", "onPopupScroll", "tabIndex"];
function px(t) {
  return t === "tags" || t === "multiple";
}
var eG = /* @__PURE__ */ x.forwardRef(function(t, e) {
  var n, r, i = t.id, o = t.prefixCls, a = t.className, s = t.showSearch, u = t.tagRender, l = t.direction, c = t.omitDomProps, d = t.displayValues, f = t.onDisplayValuesChange, h = t.emptyOptions, p = t.notFoundContent, v = p === void 0 ? "Not Found" : p, m = t.onClear, b = t.mode, y = t.disabled, w = t.loading, S = t.getInputElement, E = t.getRawInputElement, I = t.open, _ = t.defaultOpen, A = t.onDropdownVisibleChange, P = t.activeValue, N = t.onActiveValueChange, k = t.activeDescendantId, D = t.searchValue, R = t.autoClearSearchValue, V = t.onSearch, $ = t.onSearchSplit, F = t.tokenSeparators, M = t.allowClear, B = t.showArrow, X = t.inputIcon, L = t.clearIcon, j = t.OptionList, K = t.animation, W = t.transitionName, Y = t.dropdownStyle, U = t.dropdownClassName, Q = t.dropdownMatchSelectWidth, Z = t.dropdownRender, ee = t.dropdownAlign, ie = t.placement, oe = t.getPopupContainer, se = t.showAction, te = se === void 0 ? [] : se, ge = t.onFocus, he = t.onBlur, fe = t.onKeyUp, _e = t.onKeyDown, Ne = t.onMouseDown, ze = Gt(t, W1e), Ve = px(b), ne = (s !== void 0 ? s : Ve) || b === "combobox", pe = de({}, ze);
  j1e.forEach(function(an) {
    delete pe[an];
  }), c == null || c.forEach(function(an) {
    delete pe[an];
  });
  var ye = x.useState(!1), Ae = be(ye, 2), we = Ae[0], ce = Ae[1];
  x.useEffect(function() {
    ce(dA());
  }, []);
  var ve = x.useRef(null), Ie = x.useRef(null), q = x.useRef(null), Fe = x.useRef(null), Ze = x.useRef(null), at = xve(), Je = be(at, 3), ut = Je[0], Ct = Je[1], Ke = Je[2];
  x.useImperativeHandle(e, function() {
    var an, jt;
    return {
      focus: (an = Fe.current) === null || an === void 0 ? void 0 : an.focus,
      blur: (jt = Fe.current) === null || jt === void 0 ? void 0 : jt.blur,
      scrollTo: function(qr) {
        var mr;
        return (mr = Ze.current) === null || mr === void 0 ? void 0 : mr.scrollTo(qr);
      }
    };
  });
  var st = x.useMemo(function() {
    var an;
    if (b !== "combobox")
      return D;
    var jt = (an = d[0]) === null || an === void 0 ? void 0 : an.value;
    return typeof jt == "string" || typeof jt == "number" ? String(jt) : "";
  }, [D, b, d]), wt = b === "combobox" && typeof S == "function" && S() || null, qt = typeof E == "function" && E(), bt = iA(Ie, qt == null || (n = qt.props) === null || n === void 0 ? void 0 : n.ref), Me = Tr(void 0, {
    defaultValue: _,
    value: I
  }), yt = be(Me, 2), ct = yt[0], kt = yt[1], Vt = ct, Vn = !v && h;
  (y || Vn && Vt && b === "combobox") && (Vt = !1);
  var tn = Vn ? !1 : Vt, Xe = x.useCallback(function(an) {
    var jt = an !== void 0 ? an : !Vt;
    y || (kt(jt), Vt !== jt && (A == null || A(jt)));
  }, [y, Vt, kt, A]), tt = x.useMemo(function() {
    return (F || []).some(function(an) {
      return [`
`, `\r
`].includes(an);
    });
  }, [F]), ot = function(jt, Nr, qr) {
    var mr = !0, si = jt;
    N == null || N(null);
    var Qr = qr ? null : H1e(jt, F);
    return b !== "combobox" && Qr && (si = "", $ == null || $(Qr), Xe(!1), mr = !1), V && st !== si && V(si, {
      source: Nr ? "typing" : "effect"
    }), mr;
  }, lt = function(jt) {
    !jt || !jt.trim() || V(jt, {
      source: "submit"
    });
  };
  x.useEffect(function() {
    !Vt && !Ve && b !== "combobox" && ot("", !1, !1);
  }, [Vt]), x.useEffect(function() {
    ct && y && kt(!1), y && Ct(!1);
  }, [y]);
  var He = Rz(), mt = be(He, 2), Qt = mt[0], Yt = mt[1], nn = function(jt) {
    var Nr = Qt(), qr = jt.which;
    if (qr === ke.ENTER && (b !== "combobox" && jt.preventDefault(), Vt || Xe(!0)), Yt(!!st), qr === ke.BACKSPACE && !Nr && Ve && !st && d.length) {
      for (var mr = Ye(d), si = null, Qr = mr.length - 1; Qr >= 0; Qr -= 1) {
        var Dn = mr[Qr];
        if (!Dn.disabled) {
          mr.splice(Qr, 1), si = Dn;
          break;
        }
      }
      si && f(mr, {
        type: "remove",
        values: [si]
      });
    }
    for (var hn = arguments.length, Mn = new Array(hn > 1 ? hn - 1 : 0), Qn = 1; Qn < hn; Qn++)
      Mn[Qn - 1] = arguments[Qn];
    if (Vt && Ze.current) {
      var Fr;
      (Fr = Ze.current).onKeyDown.apply(Fr, [jt].concat(Mn));
    }
    _e == null || _e.apply(void 0, [jt].concat(Mn));
  }, Nt = function(jt) {
    for (var Nr = arguments.length, qr = new Array(Nr > 1 ? Nr - 1 : 0), mr = 1; mr < Nr; mr++)
      qr[mr - 1] = arguments[mr];
    if (Vt && Ze.current) {
      var si;
      (si = Ze.current).onKeyUp.apply(si, [jt].concat(qr));
    }
    fe == null || fe.apply(void 0, [jt].concat(qr));
  }, ue = function(jt) {
    var Nr = d.filter(function(qr) {
      return qr !== jt;
    });
    f(Nr, {
      type: "remove",
      values: [jt]
    });
  }, $e = x.useRef(!1), je = function() {
    Ct(!0), y || (ge && !$e.current && ge.apply(void 0, arguments), te.includes("focus") && Xe(!0)), $e.current = !0;
  }, At = function() {
    Ct(!1, function() {
      $e.current = !1, Xe(!1);
    }), !y && (st && (b === "tags" ? V(st, {
      source: "submit"
    }) : b === "multiple" && V("", {
      source: "blur"
    })), he && he.apply(void 0, arguments));
  }, $t = [];
  x.useEffect(function() {
    return function() {
      $t.forEach(function(an) {
        return clearTimeout(an);
      }), $t.splice(0, $t.length);
    };
  }, []);
  var qe = function(jt) {
    var Nr, qr = jt.target, mr = (Nr = q.current) === null || Nr === void 0 ? void 0 : Nr.getPopupElement();
    if (mr && mr.contains(qr)) {
      var si = setTimeout(function() {
        var Mn = $t.indexOf(si);
        if (Mn !== -1 && $t.splice(Mn, 1), Ke(), !we && !mr.contains(document.activeElement)) {
          var Qn;
          (Qn = Fe.current) === null || Qn === void 0 || Qn.focus();
        }
      });
      $t.push(si);
    }
    for (var Qr = arguments.length, Dn = new Array(Qr > 1 ? Qr - 1 : 0), hn = 1; hn < Qr; hn++)
      Dn[hn - 1] = arguments[hn];
    Ne == null || Ne.apply(void 0, [jt].concat(Dn));
  }, nt = x.useState(null), dt = be(nt, 2), rn = dt[0], on = dt[1], Rt = x.useState({}), Tt = be(Rt, 2), Wn = Tt[1];
  function zr() {
    Wn({});
  }
  To(function() {
    if (tn) {
      var an, jt = Math.ceil((an = ve.current) === null || an === void 0 ? void 0 : an.offsetWidth);
      rn !== jt && !Number.isNaN(jt) && on(jt);
    }
  }, [tn]);
  var gr;
  qt && (gr = function(jt) {
    Xe(jt);
  }), Cve(function() {
    var an;
    return [ve.current, (an = q.current) === null || an === void 0 ? void 0 : an.getPopupElement()];
  }, tn, Xe, !!qt);
  var fo = x.useMemo(function() {
    return de(de({}, t), {}, {
      notFoundContent: v,
      open: Vt,
      triggerOpen: tn,
      id: i,
      showSearch: ne,
      multiple: Ve,
      toggleOpen: Xe
    });
  }, [t, v, tn, Vt, i, ne, Ve, Xe]), xl = B !== void 0 ? B : w || !Ve && b !== "combobox", Cl;
  xl && (Cl = /* @__PURE__ */ x.createElement(fx, {
    className: Ce("".concat(o, "-arrow"), z({}, "".concat(o, "-arrow-loading"), w)),
    customizeIcon: X,
    customizeIconProps: {
      loading: w,
      searchValue: st,
      open: Vt,
      focused: ut,
      showSearch: ne
    }
  }));
  var Bs, ho = function() {
    var jt;
    m == null || m(), (jt = Fe.current) === null || jt === void 0 || jt.focus(), f([], {
      type: "clear",
      values: d
    }), ot("", !1, !1);
  };
  !y && M && (d.length || st) && !(b === "combobox" && st === "") && (Bs = /* @__PURE__ */ x.createElement(fx, {
    className: "".concat(o, "-clear"),
    onMouseDown: ho,
    customizeIcon: L
  }, "×"));
  var Ho = /* @__PURE__ */ x.createElement(j, {
    ref: Ze
  }), es = Ce(o, a, (r = {}, z(r, "".concat(o, "-focused"), ut), z(r, "".concat(o, "-multiple"), Ve), z(r, "".concat(o, "-single"), !Ve), z(r, "".concat(o, "-allow-clear"), M), z(r, "".concat(o, "-show-arrow"), xl), z(r, "".concat(o, "-disabled"), y), z(r, "".concat(o, "-loading"), w), z(r, "".concat(o, "-open"), Vt), z(r, "".concat(o, "-customize-input"), wt), z(r, "".concat(o, "-show-search"), ne), r)), wl = /* @__PURE__ */ x.createElement(qz, {
    ref: q,
    disabled: y,
    prefixCls: o,
    visible: tn,
    popupElement: Ho,
    containerWidth: rn,
    animation: K,
    transitionName: W,
    dropdownStyle: Y,
    dropdownClassName: U,
    direction: l,
    dropdownMatchSelectWidth: Q,
    dropdownRender: Z,
    dropdownAlign: ee,
    placement: ie,
    getPopupContainer: oe,
    empty: h,
    getTriggerDOMNode: function() {
      return Ie.current;
    },
    onPopupVisibleChange: gr,
    onPopupMouseEnter: zr
  }, qt ? /* @__PURE__ */ x.cloneElement(qt, {
    ref: bt
  }) : /* @__PURE__ */ x.createElement(Lz, G({}, t, {
    domRef: Ie,
    prefixCls: o,
    inputElement: wt,
    ref: Fe,
    id: i,
    showSearch: ne,
    autoClearSearchValue: R,
    mode: b,
    activeDescendantId: k,
    tagRender: u,
    values: d,
    open: Vt,
    onToggleOpen: Xe,
    activeValue: P,
    searchValue: st,
    onSearch: ot,
    onSearchSubmit: lt,
    onRemove: ue,
    tokenWithEnter: tt
  }))), Hs;
  return qt ? Hs = wl : Hs = /* @__PURE__ */ x.createElement("div", G({
    className: es
  }, pe, {
    ref: ve,
    onMouseDown: qe,
    onKeyDown: nn,
    onKeyUp: Nt,
    onFocus: je,
    onBlur: At
  }), ut && !Vt && /* @__PURE__ */ x.createElement("span", {
    style: {
      width: 0,
      height: 0,
      position: "absolute",
      overflow: "hidden",
      opacity: 0
    },
    "aria-live": "polite"
  }, "".concat(d.map(function(an) {
    var jt = an.label, Nr = an.value;
    return ["number", "string"].includes(_t(jt)) ? jt : Nr;
  }).join(", "))), wl, Cl, Bs), /* @__PURE__ */ x.createElement(kz.Provider, {
    value: fo
  }, Hs);
});
process.env.NODE_ENV !== "production" && (eG.displayName = "BaseSelect");
const z1e = function(t, e) {
  var n = x.useRef({
    values: /* @__PURE__ */ new Map(),
    options: /* @__PURE__ */ new Map()
  }), r = x.useMemo(function() {
    var o = n.current, a = o.values, s = o.options, u = t.map(function(d) {
      if (d.label === void 0) {
        var f;
        return de(de({}, d), {}, {
          label: (f = a.get(d.value)) === null || f === void 0 ? void 0 : f.label
        });
      }
      return d;
    }), l = /* @__PURE__ */ new Map(), c = /* @__PURE__ */ new Map();
    return u.forEach(function(d) {
      l.set(d.value, d), c.set(d.value, e.get(d.value) || s.get(d.value));
    }), n.current.values = l, n.current.options = c, u;
  }, [t, e]), i = x.useCallback(function(o) {
    return e.get(o) || n.current.options.get(o);
  }, [e]);
  return [r, i];
};
function LS(t, e) {
  return hA(t).join("").toUpperCase().includes(e);
}
const G1e = function(t, e, n, r, i) {
  return x.useMemo(function() {
    if (!n || r === !1)
      return t;
    var o = e.options, a = e.label, s = e.value, u = [], l = typeof r == "function", c = n.toUpperCase(), d = l ? r : function(h, p) {
      return i ? LS(p[i], c) : p[o] ? LS(p[a !== "children" ? a : "label"], c) : LS(p[s], c);
    }, f = l ? function(h) {
      return $I(h);
    } : function(h) {
      return h;
    };
    return t.forEach(function(h) {
      if (h[o]) {
        var p = d(n, f(h));
        if (p)
          u.push(h);
        else {
          var v = h[o].filter(function(m) {
            return d(n, f(m));
          });
          v.length && u.push(de(de({}, h), {}, z({}, o, v)));
        }
        return;
      }
      d(n, f(h)) && u.push(h);
    }), u;
  }, [t, r, i, n, e]);
};
var Sk = 0, U1e = process.env.NODE_ENV !== "test" && yu();
function X1e() {
  var t;
  return U1e ? (t = Sk, Sk += 1) : t = "TEST_OR_SSR", t;
}
function Y1e(t) {
  var e = x.useState(), n = be(e, 2), r = n[0], i = n[1];
  return x.useEffect(function() {
    i("rc_select_".concat(X1e()));
  }, []), t || r;
}
var Z1e = ["children", "value"], J1e = ["children"];
function K1e(t) {
  var e = t, n = e.key, r = e.props, i = r.children, o = r.value, a = Gt(r, Z1e);
  return de({
    key: n,
    value: o !== void 0 ? o : n,
    children: i
  }, a);
}
function xA(t) {
  var e = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : !1;
  return Xa(t).map(function(n, r) {
    if (!/* @__PURE__ */ x.isValidElement(n) || !n.type)
      return null;
    var i = n, o = i.type.isSelectOptGroup, a = i.key, s = i.props, u = s.children, l = Gt(s, J1e);
    return e || !o ? K1e(n) : de(de({
      key: "__RC_SELECT_GRP__".concat(a === null ? r : a, "__"),
      label: a
    }, l), {}, {
      options: xA(u)
    });
  }).filter(function(n) {
    return n;
  });
}
function q1e(t, e, n, r, i) {
  return x.useMemo(function() {
    var o = t, a = !t;
    a && (o = xA(e));
    var s = /* @__PURE__ */ new Map(), u = /* @__PURE__ */ new Map(), l = function(f, h, p) {
      p && typeof p == "string" && f.set(h[p], h);
    };
    function c(d) {
      for (var f = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : !1, h = 0; h < d.length; h += 1) {
        var p = d[h];
        !p[n.options] || f ? (s.set(p[n.value], p), l(u, p, n.label), l(u, p, r), l(u, p, i)) : c(p[n.options], !0);
      }
    }
    return c(o), {
      options: o,
      valueOptions: s,
      labelOptions: u
    };
  }, [t, e, n, r, i]);
}
function Ik(t) {
  var e = x.useRef();
  e.current = t;
  var n = x.useCallback(function() {
    return e.current.apply(e, arguments);
  }, []);
  return n;
}
var CA = function() {
  return null;
};
CA.isSelectOptGroup = !0;
var wA = function() {
  return null;
};
wA.isSelectOption = !0;
var tG = /* @__PURE__ */ x.forwardRef(function(t, e) {
  var n = t.height, r = t.offsetY, i = t.offsetX, o = t.children, a = t.prefixCls, s = t.onInnerResize, u = t.innerProps, l = t.rtl, c = t.extra, d = {}, f = {
    display: "flex",
    flexDirection: "column"
  };
  if (r !== void 0) {
    var h;
    d = {
      height: n,
      position: "relative",
      overflow: "hidden"
    }, f = de(de({}, f), {}, (h = {
      transform: "translateY(".concat(r, "px)")
    }, z(h, l ? "marginRight" : "marginLeft", -i), z(h, "position", "absolute"), z(h, "left", 0), z(h, "right", 0), z(h, "top", 0), h));
  }
  return /* @__PURE__ */ x.createElement("div", {
    style: d
  }, /* @__PURE__ */ x.createElement(Gd, {
    onResize: function(v) {
      var m = v.offsetHeight;
      m && s && s();
    }
  }, /* @__PURE__ */ x.createElement("div", G({
    style: f,
    className: Ce(z({}, "".concat(a, "-holder-inner"), a)),
    ref: e
  }, u), o, c)));
});
tG.displayName = "Filler";
function _k(t, e) {
  var n = "touches" in t ? t.touches[0] : t;
  return n[e ? "pageX" : "pageY"];
}
var DI = /* @__PURE__ */ x.forwardRef(function(t, e) {
  var n, r = t.prefixCls, i = t.rtl, o = t.scrollOffset, a = t.scrollRange, s = t.onStartMove, u = t.onStopMove, l = t.onScroll, c = t.horizontal, d = t.spinSize, f = t.containerSize, h = t.style, p = t.thumbStyle, v = x.useState(!1), m = be(v, 2), b = m[0], y = m[1], w = x.useState(null), S = be(w, 2), E = S[0], I = S[1], _ = x.useState(null), A = be(_, 2), P = A[0], N = A[1], k = !i, D = x.useRef(), R = x.useRef(), V = x.useState(!1), $ = be(V, 2), F = $[0], M = $[1], B = x.useRef(), X = function() {
    clearTimeout(B.current), M(!0), B.current = setTimeout(function() {
      M(!1);
    }, 3e3);
  }, L = a - f || 0, j = f - d || 0, K = L > 0, W = x.useMemo(function() {
    if (o === 0 || L === 0)
      return 0;
    var te = o / L;
    return te * j;
  }, [o, L, j]), Y = function(ge) {
    ge.stopPropagation(), ge.preventDefault();
  }, U = x.useRef({
    top: W,
    dragging: b,
    pageY: E,
    startTop: P
  });
  U.current = {
    top: W,
    dragging: b,
    pageY: E,
    startTop: P
  };
  var Q = function(ge) {
    y(!0), I(_k(ge, c)), N(U.current.top), s(), ge.stopPropagation(), ge.preventDefault();
  };
  x.useEffect(function() {
    var te = function(_e) {
      _e.preventDefault();
    }, ge = D.current, he = R.current;
    return ge.addEventListener("touchstart", te), he.addEventListener("touchstart", Q), function() {
      ge.removeEventListener("touchstart", te), he.removeEventListener("touchstart", Q);
    };
  }, []);
  var Z = x.useRef();
  Z.current = L;
  var ee = x.useRef();
  ee.current = j, x.useEffect(function() {
    if (b) {
      var te, ge = function(_e) {
        var Ne = U.current, ze = Ne.dragging, Ve = Ne.pageY, ne = Ne.startTop;
        if (En.cancel(te), ze) {
          var pe = _k(_e, c) - Ve, ye = ne;
          !k && c ? ye -= pe : ye += pe;
          var Ae = Z.current, we = ee.current, ce = we ? ye / we : 0, ve = Math.ceil(ce * Ae);
          ve = Math.max(ve, 0), ve = Math.min(ve, Ae), te = En(function() {
            l(ve, c);
          });
        }
      }, he = function() {
        y(!1), u();
      };
      return window.addEventListener("mousemove", ge), window.addEventListener("touchmove", ge), window.addEventListener("mouseup", he), window.addEventListener("touchend", he), function() {
        window.removeEventListener("mousemove", ge), window.removeEventListener("touchmove", ge), window.removeEventListener("mouseup", he), window.removeEventListener("touchend", he), En.cancel(te);
      };
    }
  }, [b]), x.useEffect(function() {
    X();
  }, [o]), x.useImperativeHandle(e, function() {
    return {
      delayHidden: X
    };
  });
  var ie = "".concat(r, "-scrollbar"), oe = {
    position: "absolute",
    visibility: F && K ? null : "hidden"
  }, se = {
    position: "absolute",
    background: "rgba(0, 0, 0, 0.5)",
    borderRadius: 99,
    cursor: "pointer",
    userSelect: "none"
  };
  return c ? (oe.height = 8, oe.left = 0, oe.right = 0, oe.bottom = 0, se.height = "100%", se.width = d, k ? se.left = W : se.right = W) : (oe.width = 8, oe.top = 0, oe.bottom = 0, k ? oe.right = 0 : oe.left = 0, se.width = "100%", se.height = d, se.top = W), /* @__PURE__ */ x.createElement("div", {
    ref: D,
    className: Ce(ie, (n = {}, z(n, "".concat(ie, "-horizontal"), c), z(n, "".concat(ie, "-vertical"), !c), z(n, "".concat(ie, "-visible"), F), n)),
    style: de(de({}, oe), h),
    onMouseDown: Y,
    onMouseMove: X
  }, /* @__PURE__ */ x.createElement("div", {
    ref: R,
    className: Ce("".concat(ie, "-thumb"), z({}, "".concat(ie, "-thumb-moving"), b)),
    style: de(de({}, se), p),
    onMouseDown: Q
  }));
});
process.env.NODE_ENV !== "production" && (DI.displayName = "ScrollBar");
function Q1e(t) {
  var e = t.children, n = t.setRef, r = x.useCallback(function(i) {
    n(i);
  }, []);
  return /* @__PURE__ */ x.cloneElement(e, {
    ref: r
  });
}
function ebe(t, e, n, r, i, o, a) {
  var s = a.getKey;
  return t.slice(e, n + 1).map(function(u, l) {
    var c = e + l, d = o(u, c, {
      style: {
        width: r
      }
    }), f = s(u);
    return /* @__PURE__ */ x.createElement(Q1e, {
      key: f,
      setRef: function(p) {
        return i(u, p);
      }
    }, d);
  });
}
var tbe = /* @__PURE__ */ function() {
  function t() {
    zn(this, t), this.maps = void 0, this.id = 0, this.maps = /* @__PURE__ */ Object.create(null);
  }
  return Gn(t, [{
    key: "set",
    value: function(n, r) {
      this.maps[n] = r, this.id += 1;
    }
  }, {
    key: "get",
    value: function(n) {
      return this.maps[n];
    }
  }]), t;
}();
function nbe(t, e, n) {
  var r = x.useState(0), i = be(r, 2), o = i[0], a = i[1], s = Ee(/* @__PURE__ */ new Map()), u = Ee(new tbe()), l = Ee();
  function c() {
    En.cancel(l.current);
  }
  function d() {
    var h = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : !1;
    c();
    var p = function() {
      s.current.forEach(function(m, b) {
        if (m && m.offsetParent) {
          var y = md(m), w = y.offsetHeight;
          u.current.get(b) !== w && u.current.set(b, y.offsetHeight);
        }
      }), a(function(m) {
        return m + 1;
      });
    };
    h ? p() : l.current = En(p);
  }
  function f(h, p) {
    var v = t(h), m = s.current.get(v);
    p ? (s.current.set(v, p), d()) : s.current.delete(v), !m != !p && (p ? e == null || e(h) : n == null || n(h));
  }
  return Re(function() {
    return c;
  }, []), [f, d, u.current, o];
}
var Ak = 10;
function rbe(t, e, n, r, i, o, a, s) {
  var u = x.useRef(), l = x.useState(null), c = be(l, 2), d = c[0], f = c[1];
  return To(function() {
    if (d && d.times < Ak) {
      if (!t.current) {
        f(function(X) {
          return de({}, X);
        });
        return;
      }
      o();
      var h = d.targetAlign, p = d.originAlign, v = d.index, m = d.offset, b = t.current.clientHeight, y = !1, w = h, S = null;
      if (b) {
        for (var E = h || p, I = 0, _ = 0, A = 0, P = Math.min(e.length - 1, v), N = 0; N <= P; N += 1) {
          var k = i(e[N]);
          _ = I;
          var D = n.get(k);
          A = _ + (D === void 0 ? r : D), I = A;
        }
        for (var R = E === "top" ? m : b - m, V = P; V >= 0; V -= 1) {
          var $ = i(e[V]), F = n.get($);
          if (F === void 0) {
            y = !0;
            break;
          }
          if (R -= F, R <= 0)
            break;
        }
        switch (E) {
          case "top":
            S = _ - m;
            break;
          case "bottom":
            S = A - b + m;
            break;
          default: {
            var M = t.current.scrollTop, B = M + b;
            _ < M ? w = "top" : A > B && (w = "bottom");
          }
        }
        S !== null && a(S), S !== d.lastTop && (y = !0);
      }
      y && f(de(de({}, d), {}, {
        times: d.times + 1,
        targetAlign: w,
        lastTop: S
      }));
    } else
      process.env.NODE_ENV !== "production" && (d == null ? void 0 : d.times) === Ak && Wt(!1, "Seems `scrollTo` with `rc-virtual-list` reach the max limitation. Please fire issue for us. Thanks.");
  }, [d, t.current]), function(h) {
    if (h == null) {
      s();
      return;
    }
    if (En.cancel(u.current), typeof h == "number")
      a(h);
    else if (h && _t(h) === "object") {
      var p, v = h.align;
      "index" in h ? p = h.index : p = e.findIndex(function(y) {
        return i(y) === h.key;
      });
      var m = h.offset, b = m === void 0 ? 0 : m;
      f({
        times: 0,
        index: p,
        offset: b,
        originAlign: v
      });
    }
  };
}
function ibe(t, e, n) {
  var r = t.length, i = e.length, o, a;
  if (r === 0 && i === 0)
    return null;
  r < i ? (o = t, a = e) : (o = e, a = t);
  var s = {
    __EMPTY_ITEM__: !0
  };
  function u(p) {
    return p !== void 0 ? n(p) : s;
  }
  for (var l = null, c = Math.abs(r - i) !== 1, d = 0; d < a.length; d += 1) {
    var f = u(o[d]), h = u(a[d]);
    if (f !== h) {
      l = d, c = c || f !== u(a[d + 1]);
      break;
    }
  }
  return l === null ? null : {
    index: l,
    multiple: c
  };
}
function obe(t, e, n) {
  var r = x.useState(t), i = be(r, 2), o = i[0], a = i[1], s = x.useState(null), u = be(s, 2), l = u[0], c = u[1];
  return x.useEffect(function() {
    var d = ibe(o || [], t || [], e);
    (d == null ? void 0 : d.index) !== void 0 && (n == null || n(d.index), c(t[d.index])), a(t);
  }, [t]), [l];
}
var Tk = (typeof navigator > "u" ? "undefined" : _t(navigator)) === "object" && /Firefox/i.test(navigator.userAgent);
const nG = function(t, e) {
  var n = Ee(!1), r = Ee(null);
  function i() {
    clearTimeout(r.current), n.current = !0, r.current = setTimeout(function() {
      n.current = !1;
    }, 50);
  }
  var o = Ee({
    top: t,
    bottom: e
  });
  return o.current.top = t, o.current.bottom = e, function(a) {
    var s = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : !1, u = (
      // Pass origin wheel when on the top
      a < 0 && o.current.top || // Pass origin wheel when on the bottom
      a > 0 && o.current.bottom
    );
    return s && u ? (clearTimeout(r.current), n.current = !1) : (!u || n.current) && i(), !n.current && u;
  };
};
function abe(t, e, n, r, i) {
  var o = Ee(0), a = Ee(null), s = Ee(null), u = Ee(!1), l = nG(e, n);
  function c(m, b) {
    En.cancel(a.current), o.current += b, s.current = b, !l(b) && (Tk || m.preventDefault(), a.current = En(function() {
      var y = u.current ? 10 : 1;
      i(o.current * y), o.current = 0;
    }));
  }
  function d(m, b) {
    i(b, !0), Tk || m.preventDefault();
  }
  var f = Ee(null), h = Ee(null);
  function p(m) {
    if (t) {
      En.cancel(h.current), h.current = En(function() {
        f.current = null;
      }, 2);
      var b = m.deltaX, y = m.deltaY, w = m.shiftKey, S = b, E = y;
      (f.current === "sx" || !f.current && w && y && !b) && (S = y, E = 0, f.current = "sx");
      var I = Math.abs(S), _ = Math.abs(E);
      f.current === null && (f.current = r && I > _ ? "x" : "y"), f.current === "y" ? c(m, E) : d(m, S);
    }
  }
  function v(m) {
    t && (u.current = m.detail === s.current);
  }
  return [p, v];
}
var sbe = 14 / 15;
function ube(t, e, n) {
  var r = Ee(!1), i = Ee(0), o = Ee(null), a = Ee(null), s, u = function(f) {
    if (r.current) {
      var h = Math.ceil(f.touches[0].pageY), p = i.current - h;
      i.current = h, n(p) && f.preventDefault(), clearInterval(a.current), a.current = setInterval(function() {
        p *= sbe, (!n(p, !0) || Math.abs(p) <= 0.1) && clearInterval(a.current);
      }, 16);
    }
  }, l = function() {
    r.current = !1, s();
  }, c = function(f) {
    s(), f.touches.length === 1 && !r.current && (r.current = !0, i.current = Math.ceil(f.touches[0].pageY), o.current = f.target, o.current.addEventListener("touchmove", u), o.current.addEventListener("touchend", l));
  };
  s = function() {
    o.current && (o.current.removeEventListener("touchmove", u), o.current.removeEventListener("touchend", l));
  }, To(function() {
    return t && e.current.addEventListener("touchstart", c), function() {
      var d;
      (d = e.current) === null || d === void 0 || d.removeEventListener("touchstart", c), s(), clearInterval(a.current);
    };
  }, [t]);
}
var lbe = 20;
function Ok() {
  var t = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 0, e = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0, n = t / e * 100;
  return isNaN(n) && (n = 0), n = Math.max(n, lbe), n = Math.min(n, t / 2), Math.floor(n);
}
function cbe(t, e, n, r) {
  var i = x.useMemo(function() {
    return [/* @__PURE__ */ new Map(), []];
  }, [t, n.id, r]), o = be(i, 2), a = o[0], s = o[1], u = function(c) {
    var d = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : c, f = a.get(c), h = a.get(d);
    if (f === void 0 || h === void 0)
      for (var p = t.length, v = s.length; v < p; v += 1) {
        var m, b = t[v], y = e(b);
        a.set(y, v);
        var w = (m = n.get(y)) !== null && m !== void 0 ? m : r;
        if (s[v] = (s[v - 1] || 0) + w, y === c && (f = v), y === d && (h = v), f !== void 0 && h !== void 0)
          break;
      }
    return {
      top: s[f - 1] || 0,
      bottom: s[h]
    };
  };
  return u;
}
var dbe = ["prefixCls", "className", "height", "itemHeight", "fullHeight", "style", "data", "children", "itemKey", "virtual", "direction", "scrollWidth", "component", "onScroll", "onVirtualScroll", "onVisibleChange", "innerProps", "extraRender", "styles"], fbe = [], hbe = {
  overflowY: "auto",
  overflowAnchor: "none"
};
function pbe(t, e) {
  var n = t.prefixCls, r = n === void 0 ? "rc-virtual-list" : n, i = t.className, o = t.height, a = t.itemHeight, s = t.fullHeight, u = s === void 0 ? !0 : s, l = t.style, c = t.data, d = t.children, f = t.itemKey, h = t.virtual, p = t.direction, v = t.scrollWidth, m = t.component, b = m === void 0 ? "div" : m, y = t.onScroll, w = t.onVirtualScroll, S = t.onVisibleChange, E = t.innerProps, I = t.extraRender, _ = t.styles, A = Gt(t, dbe), P = !!(h !== !1 && o && a), N = P && c && (a * c.length > o || !!v), k = p === "rtl", D = Ce(r, z({}, "".concat(r, "-rtl"), k), i), R = c || fbe, V = Ee(), $ = Ee(), F = Le(0), M = be(F, 2), B = M[0], X = M[1], L = Le(0), j = be(L, 2), K = j[0], W = j[1], Y = Le(!1), U = be(Y, 2), Q = U[0], Z = U[1], ee = function() {
    Z(!0);
  }, ie = function() {
    Z(!1);
  }, oe = x.useCallback(function(qe) {
    return typeof f == "function" ? f(qe) : qe == null ? void 0 : qe[f];
  }, [f]), se = {
    getKey: oe
  };
  function te(qe) {
    X(function(nt) {
      var dt;
      typeof qe == "function" ? dt = qe(nt) : dt = qe;
      var rn = Me(dt);
      return V.current.scrollTop = rn, rn;
    });
  }
  var ge = Ee({
    start: 0,
    end: R.length
  }), he = Ee(), fe = obe(R, oe), _e = be(fe, 1), Ne = _e[0];
  he.current = Ne;
  var ze = nbe(oe, null, null), Ve = be(ze, 4), ne = Ve[0], pe = Ve[1], ye = Ve[2], Ae = Ve[3], we = x.useMemo(function() {
    if (!P)
      return {
        scrollHeight: void 0,
        start: 0,
        end: R.length - 1,
        offset: void 0
      };
    if (!N) {
      var qe;
      return {
        scrollHeight: ((qe = $.current) === null || qe === void 0 ? void 0 : qe.offsetHeight) || 0,
        start: 0,
        end: R.length - 1,
        offset: void 0
      };
    }
    for (var nt = 0, dt, rn, on, Rt = R.length, Tt = 0; Tt < Rt; Tt += 1) {
      var Wn = R[Tt], zr = oe(Wn), gr = ye.get(zr), fo = nt + (gr === void 0 ? a : gr);
      fo >= B && dt === void 0 && (dt = Tt, rn = nt), fo > B + o && on === void 0 && (on = Tt), nt = fo;
    }
    return dt === void 0 && (dt = 0, rn = 0, on = Math.ceil(o / a)), on === void 0 && (on = R.length - 1), on = Math.min(on + 1, R.length - 1), {
      scrollHeight: nt,
      start: dt,
      end: on,
      offset: rn
    };
  }, [N, P, B, R, Ae, o]), ce = we.scrollHeight, ve = we.start, Ie = we.end, q = we.offset;
  ge.current.start = ve, ge.current.end = Ie;
  var Fe = x.useState({
    width: 0,
    height: o
  }), Ze = be(Fe, 2), at = Ze[0], Je = Ze[1], ut = function(nt) {
    Je({
      width: nt.width || nt.offsetWidth,
      height: nt.height || nt.offsetHeight
    });
  }, Ct = Ee(), Ke = Ee(), st = x.useMemo(function() {
    return Ok(at.width, v);
  }, [at.width, v]), wt = x.useMemo(function() {
    return Ok(at.height, ce);
  }, [at.height, ce]), qt = ce - o, bt = Ee(qt);
  bt.current = qt;
  function Me(qe) {
    var nt = qe;
    return Number.isNaN(bt.current) || (nt = Math.min(nt, bt.current)), nt = Math.max(nt, 0), nt;
  }
  var yt = B <= 0, ct = B >= qt, kt = nG(yt, ct), Vt = function() {
    return {
      x: k ? -K : K,
      y: B
    };
  }, Vn = Ee(Vt()), tn = Pd(function() {
    if (w) {
      var qe = Vt();
      (Vn.current.x !== qe.x || Vn.current.y !== qe.y) && (w(qe), Vn.current = qe);
    }
  });
  function Xe(qe, nt) {
    var dt = qe;
    nt ? (sc(function() {
      W(dt);
    }), tn()) : te(dt);
  }
  function tt(qe) {
    var nt = qe.currentTarget.scrollTop;
    nt !== B && te(nt), y == null || y(qe), tn();
  }
  var ot = function(nt) {
    var dt = nt, rn = v - at.width;
    return dt = Math.max(dt, 0), dt = Math.min(dt, rn), dt;
  }, lt = Pd(function(qe, nt) {
    nt ? (sc(function() {
      W(function(dt) {
        var rn = dt + (k ? -qe : qe);
        return ot(rn);
      });
    }), tn()) : te(function(dt) {
      var rn = dt + qe;
      return rn;
    });
  }), He = abe(P, yt, ct, !!v, lt), mt = be(He, 2), Qt = mt[0], Yt = mt[1];
  ube(P, V, function(qe, nt) {
    return kt(qe, nt) ? !1 : (Qt({
      preventDefault: function() {
      },
      deltaY: qe
    }), !0);
  }), To(function() {
    function qe(dt) {
      P && dt.preventDefault();
    }
    var nt = V.current;
    return nt.addEventListener("wheel", Qt), nt.addEventListener("DOMMouseScroll", Yt), nt.addEventListener("MozMousePixelScroll", qe), function() {
      nt.removeEventListener("wheel", Qt), nt.removeEventListener("DOMMouseScroll", Yt), nt.removeEventListener("MozMousePixelScroll", qe);
    };
  }, [P]), To(function() {
    v && W(function(qe) {
      return ot(qe);
    });
  }, [at.width, v]);
  var nn = function() {
    var nt, dt;
    (nt = Ct.current) === null || nt === void 0 || nt.delayHidden(), (dt = Ke.current) === null || dt === void 0 || dt.delayHidden();
  }, Nt = rbe(V, R, ye, a, oe, function() {
    return pe(!0);
  }, te, nn);
  x.useImperativeHandle(e, function() {
    return {
      getScrollInfo: Vt,
      scrollTo: function(nt) {
        function dt(rn) {
          return rn && _t(rn) === "object" && ("left" in rn || "top" in rn);
        }
        dt(nt) ? (nt.left !== void 0 && W(ot(nt.left)), Nt(nt.top)) : Nt(nt);
      }
    };
  }), To(function() {
    if (S) {
      var qe = R.slice(ve, Ie + 1);
      S(qe, R);
    }
  }, [ve, Ie, R]);
  var ue = cbe(R, oe, ye, a), $e = I == null ? void 0 : I({
    start: ve,
    end: Ie,
    virtual: N,
    offsetX: K,
    offsetY: q,
    rtl: k,
    getSize: ue
  }), je = ebe(R, ve, Ie, v, ne, d, se), At = null;
  o && (At = de(z({}, u ? "height" : "maxHeight", o), hbe), P && (At.overflowY = "hidden", v && (At.overflowX = "hidden"), Q && (At.pointerEvents = "none")));
  var $t = {};
  return k && ($t.dir = "rtl"), /* @__PURE__ */ x.createElement("div", G({
    style: de(de({}, l), {}, {
      position: "relative"
    }),
    className: D
  }, $t, A), /* @__PURE__ */ x.createElement(Gd, {
    onResize: ut
  }, /* @__PURE__ */ x.createElement(b, {
    className: "".concat(r, "-holder"),
    style: At,
    ref: V,
    onScroll: tt,
    onMouseEnter: nn
  }, /* @__PURE__ */ x.createElement(tG, {
    prefixCls: r,
    height: ce,
    offsetX: K,
    offsetY: q,
    scrollWidth: v,
    onInnerResize: pe,
    ref: $,
    innerProps: E,
    rtl: k,
    extra: $e
  }, je))), N && ce > o && /* @__PURE__ */ x.createElement(DI, {
    ref: Ct,
    prefixCls: r,
    scrollOffset: B,
    scrollRange: ce,
    rtl: k,
    onScroll: Xe,
    onStartMove: ee,
    onStopMove: ie,
    spinSize: wt,
    containerSize: at.height,
    style: _ == null ? void 0 : _.verticalScrollBar,
    thumbStyle: _ == null ? void 0 : _.verticalScrollBarThumb
  }), N && v && /* @__PURE__ */ x.createElement(DI, {
    ref: Ke,
    prefixCls: r,
    scrollOffset: K,
    scrollRange: v,
    rtl: k,
    onScroll: Xe,
    onStartMove: ee,
    onStopMove: ie,
    spinSize: st,
    containerSize: at.width,
    horizontal: !0,
    style: _ == null ? void 0 : _.horizontalScrollBar,
    thumbStyle: _ == null ? void 0 : _.horizontalScrollBarThumb
  }));
}
var rG = /* @__PURE__ */ x.forwardRef(pbe);
rG.displayName = "List";
function gbe() {
  return /(mac\sos|macintosh)/i.test(navigator.appVersion);
}
var iG = /* @__PURE__ */ x.createContext(null), mbe = ["disabled", "title", "children", "style", "className"];
function Pk(t) {
  return typeof t == "string" || typeof t == "number";
}
var vbe = function(e, n) {
  var r = yve(), i = r.prefixCls, o = r.id, a = r.open, s = r.multiple, u = r.mode, l = r.searchValue, c = r.toggleOpen, d = r.notFoundContent, f = r.onPopupScroll, h = x.useContext(iG), p = h.flattenOptions, v = h.onActiveValue, m = h.defaultActiveFirstOption, b = h.onSelect, y = h.menuItemSelectedIcon, w = h.rawValues, S = h.fieldNames, E = h.virtual, I = h.listHeight, _ = h.listItemHeight, A = "".concat(i, "-item"), P = Cp(function() {
    return p;
  }, [a, p], function(Y, U) {
    return U[0] && Y[1] !== U[1];
  }), N = x.useRef(null), k = function(U) {
    U.preventDefault();
  }, D = function(U) {
    N.current && N.current.scrollTo(typeof U == "number" ? {
      index: U
    } : U);
  }, R = function(U) {
    for (var Q = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 1, Z = P.length, ee = 0; ee < Z; ee += 1) {
      var ie = (U + ee * Q + Z) % Z, oe = P[ie], se = oe.group, te = oe.data;
      if (!se && !te.disabled)
        return ie;
    }
    return -1;
  }, V = x.useState(function() {
    return R(0);
  }), $ = be(V, 2), F = $[0], M = $[1], B = function(U) {
    var Q = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : !1;
    M(U);
    var Z = {
      source: Q ? "keyboard" : "mouse"
    }, ee = P[U];
    if (!ee) {
      v(null, -1, Z);
      return;
    }
    v(ee.value, U, Z);
  };
  Re(function() {
    B(m !== !1 ? R(0) : -1);
  }, [P.length, l]);
  var X = x.useCallback(function(Y) {
    return w.has(Y) && u !== "combobox";
  }, [u, Ye(w).toString(), w.size]);
  Re(function() {
    var Y = setTimeout(function() {
      if (!s && a && w.size === 1) {
        var Q = Array.from(w)[0], Z = P.findIndex(function(ee) {
          var ie = ee.data;
          return ie.value === Q;
        });
        Z !== -1 && (B(Z), D(Z));
      }
    });
    if (a) {
      var U;
      (U = N.current) === null || U === void 0 || U.scrollTo(void 0);
    }
    return function() {
      return clearTimeout(Y);
    };
  }, [a, l]);
  var L = function(U) {
    U !== void 0 && b(U, {
      selected: !w.has(U)
    }), s || c(!1);
  };
  if (x.useImperativeHandle(n, function() {
    return {
      onKeyDown: function(U) {
        var Q = U.which, Z = U.ctrlKey;
        switch (Q) {
          case ke.N:
          case ke.P:
          case ke.UP:
          case ke.DOWN: {
            var ee = 0;
            if (Q === ke.UP ? ee = -1 : Q === ke.DOWN ? ee = 1 : gbe() && Z && (Q === ke.N ? ee = 1 : Q === ke.P && (ee = -1)), ee !== 0) {
              var ie = R(F + ee, ee);
              D(ie), B(ie, !0);
            }
            break;
          }
          case ke.ENTER: {
            var oe = P[F];
            oe && !oe.data.disabled ? L(oe.value) : L(void 0), a && U.preventDefault();
            break;
          }
          case ke.ESC:
            c(!1), a && U.stopPropagation();
        }
      },
      onKeyUp: function() {
      },
      scrollTo: function(U) {
        D(U);
      }
    };
  }), P.length === 0)
    return /* @__PURE__ */ x.createElement("div", {
      role: "listbox",
      id: "".concat(o, "_list"),
      className: "".concat(A, "-empty"),
      onMouseDown: k
    }, d);
  var j = Object.keys(S).map(function(Y) {
    return S[Y];
  }), K = function(U) {
    return U.label;
  }, W = function(U) {
    var Q = P[U];
    if (!Q)
      return null;
    var Z = Q.data || {}, ee = Z.value, ie = Q.group, oe = H0(Z, !0), se = K(Q);
    return Q ? /* @__PURE__ */ x.createElement("div", G({
      "aria-label": typeof se == "string" && !ie ? se : null
    }, oe, {
      key: U,
      role: ie ? "presentation" : "option",
      id: "".concat(o, "_list_").concat(U),
      "aria-selected": X(ee)
    }), ee) : null;
  };
  return /* @__PURE__ */ x.createElement(x.Fragment, null, /* @__PURE__ */ x.createElement("div", {
    role: "listbox",
    id: "".concat(o, "_list"),
    style: {
      height: 0,
      width: 0,
      overflow: "hidden"
    }
  }, W(F - 1), W(F), W(F + 1)), /* @__PURE__ */ x.createElement(rG, {
    itemKey: "key",
    ref: N,
    data: P,
    height: I,
    itemHeight: _,
    fullHeight: !1,
    onMouseDown: k,
    onScroll: f,
    virtual: E
  }, function(Y, U) {
    var Q, Z = Y.group, ee = Y.groupOption, ie = Y.data, oe = Y.label, se = Y.value, te = ie.key;
    if (Z) {
      var ge, he = (ge = ie.title) !== null && ge !== void 0 ? ge : Pk(oe) ? oe.toString() : void 0;
      return /* @__PURE__ */ x.createElement("div", {
        className: Ce(A, "".concat(A, "-group")),
        title: he
      }, oe !== void 0 ? oe : te);
    }
    var fe = ie.disabled, _e = ie.title;
    ie.children;
    var Ne = ie.style, ze = ie.className, Ve = Gt(ie, mbe), ne = Pi(Ve, j), pe = X(se), ye = "".concat(A, "-option"), Ae = Ce(A, ye, ze, (Q = {}, z(Q, "".concat(ye, "-grouped"), ee), z(Q, "".concat(ye, "-active"), F === U && !fe), z(Q, "".concat(ye, "-disabled"), fe), z(Q, "".concat(ye, "-selected"), pe), Q)), we = K(Y), ce = !y || typeof y == "function" || pe, ve = typeof we == "number" ? we : we || se, Ie = Pk(ve) ? ve.toString() : void 0;
    return _e !== void 0 && (Ie = _e), /* @__PURE__ */ x.createElement("div", G({}, H0(ne), {
      "aria-selected": pe,
      className: Ae,
      title: Ie,
      onMouseMove: function() {
        F === U || fe || B(U);
      },
      onClick: function() {
        fe || L(se);
      },
      style: Ne
    }), /* @__PURE__ */ x.createElement("div", {
      className: "".concat(ye, "-content")
    }, ve), /* @__PURE__ */ x.isValidElement(y) || pe, ce && /* @__PURE__ */ x.createElement(fx, {
      className: "".concat(A, "-option-state"),
      customizeIcon: y,
      customizeIconProps: {
        isSelected: pe
      }
    }, pe ? "✓" : null));
  }));
}, oG = /* @__PURE__ */ x.forwardRef(vbe);
oG.displayName = "OptionList";
function bbe(t) {
  var e = t.mode, n = t.options, r = t.children, i = t.backfill, o = t.allowClear, a = t.placeholder, s = t.getInputElement, u = t.showSearch, l = t.onSearch, c = t.defaultOpen, d = t.autoFocus, f = t.labelInValue, h = t.value, p = t.inputValue, v = t.optionLabelProp, m = px(e), b = u !== void 0 ? u : m || e === "combobox", y = n || xA(r);
  if (Wt(e !== "tags" || y.every(function(I) {
    return !I.disabled;
  }), "Please avoid setting option to disabled in tags mode since user can always type text as tag."), e === "tags" || e === "combobox") {
    var w = y.some(function(I) {
      return I.options ? I.options.some(function(_) {
        return typeof ("value" in _ ? _.value : _.key) == "number";
      }) : typeof ("value" in I ? I.value : I.key) == "number";
    });
    Wt(!w, "`value` of Option should not use number type when `mode` is `tags` or `combobox`.");
  }
  if (Wt(e !== "combobox" || !v, "`combobox` mode not support `optionLabelProp`. Please set `value` on Option directly."), Wt(e === "combobox" || !i, "`backfill` only works with `combobox` mode."), Wt(e === "combobox" || !s, "`getInputElement` only work with `combobox` mode."), fI(e !== "combobox" || !s || !o || !a, "Customize `getInputElement` should customize clear and placeholder logic instead of configuring `allowClear` and `placeholder`."), l && !b && e !== "combobox" && e !== "tags" && Wt(!1, "`onSearch` should work with `showSearch` instead of use alone."), fI(!c || d, "`defaultOpen` makes Select open without focus which means it will not close by click outside. You can set `autoFocus` if needed."), h != null) {
    var S = hA(h);
    Wt(!f || S.every(function(I) {
      return _t(I) === "object" && ("key" in I || "value" in I);
    }), "`value` should in shape of `{ value: string | number, label?: ReactNode }` when you set `labelInValue` to `true`"), Wt(!m || Array.isArray(h), "`value` should be array when `mode` is `multiple` or `tags`");
  }
  if (r) {
    var E = null;
    Xa(r).some(function(I) {
      if (!/* @__PURE__ */ x.isValidElement(I) || !I.type)
        return !1;
      var _ = I, A = _.type;
      if (A.isSelectOption)
        return !1;
      if (A.isSelectOptGroup) {
        var P = Xa(I.props.children).every(function(N) {
          return !/* @__PURE__ */ x.isValidElement(N) || !I.type || N.type.isSelectOption ? !0 : (E = N.type, !1);
        });
        return !P;
      }
      return E = A, !0;
    }), E && Wt(!1, "`children` should be `Select.Option` or `Select.OptGroup` instead of `".concat(E.displayName || E.name || E, "`.")), Wt(p === void 0, "`inputValue` is deprecated, please use `searchValue` instead.");
  }
}
function ybe(t, e) {
  if (t) {
    var n = function r(i) {
      for (var o = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : !1, a = 0; a < i.length; a++) {
        var s = i[a];
        if (s[e == null ? void 0 : e.value] === null)
          return Wt(!1, "`value` in Select options should not be `null`."), !0;
        if (!o && Array.isArray(s[e == null ? void 0 : e.options]) && r(s[e == null ? void 0 : e.options], !0))
          break;
      }
    };
    n(t);
  }
}
var xbe = ["id", "mode", "prefixCls", "backfill", "fieldNames", "inputValue", "searchValue", "onSearch", "autoClearSearchValue", "onSelect", "onDeselect", "dropdownMatchSelectWidth", "filterOption", "filterSort", "optionFilterProp", "optionLabelProp", "options", "children", "defaultActiveFirstOption", "menuItemSelectedIcon", "virtual", "listHeight", "listItemHeight", "value", "defaultValue", "labelInValue", "onChange"], Cbe = ["inputValue"];
function wbe(t) {
  return !t || _t(t) !== "object";
}
var aG = /* @__PURE__ */ x.forwardRef(function(t, e) {
  var n = t.id, r = t.mode, i = t.prefixCls, o = i === void 0 ? "rc-select" : i, a = t.backfill, s = t.fieldNames, u = t.inputValue, l = t.searchValue, c = t.onSearch, d = t.autoClearSearchValue, f = d === void 0 ? !0 : d, h = t.onSelect, p = t.onDeselect, v = t.dropdownMatchSelectWidth, m = v === void 0 ? !0 : v, b = t.filterOption, y = t.filterSort, w = t.optionFilterProp, S = t.optionLabelProp, E = t.options, I = t.children, _ = t.defaultActiveFirstOption, A = t.menuItemSelectedIcon, P = t.virtual, N = t.listHeight, k = N === void 0 ? 200 : N, D = t.listItemHeight, R = D === void 0 ? 20 : D, V = t.value, $ = t.defaultValue, F = t.labelInValue, M = t.onChange, B = Gt(t, xbe), X = Y1e(n), L = px(r), j = !!(!E && I), K = x.useMemo(function() {
    return b === void 0 && r === "combobox" ? !1 : b;
  }, [b, r]), W = x.useMemo(
    function() {
      return Qz(s, j);
    },
    /* eslint-disable react-hooks/exhaustive-deps */
    [
      // We stringify fieldNames to avoid unnecessary re-renders.
      JSON.stringify(s),
      j
    ]
    /* eslint-enable react-hooks/exhaustive-deps */
  ), Y = Tr("", {
    value: l !== void 0 ? l : u,
    postState: function(tt) {
      return tt || "";
    }
  }), U = be(Y, 2), Q = U[0], Z = U[1], ee = q1e(E, I, W, w, S), ie = ee.valueOptions, oe = ee.labelOptions, se = ee.options, te = x.useCallback(function(Xe) {
    var tt = hA(Xe);
    return tt.map(function(ot) {
      var lt, He, mt, Qt, Yt;
      if (wbe(ot))
        lt = ot;
      else {
        var nn;
        mt = ot.key, He = ot.label, lt = (nn = ot.value) !== null && nn !== void 0 ? nn : mt;
      }
      var Nt = ie.get(lt);
      if (Nt) {
        var ue;
        if (He === void 0 && (He = Nt == null ? void 0 : Nt[S || W.label]), mt === void 0 && (mt = (ue = Nt == null ? void 0 : Nt.key) !== null && ue !== void 0 ? ue : lt), Qt = Nt == null ? void 0 : Nt.disabled, Yt = Nt == null ? void 0 : Nt.title, process.env.NODE_ENV !== "production" && !S) {
          var $e = Nt == null ? void 0 : Nt[W.label];
          $e !== void 0 && !/* @__PURE__ */ x.isValidElement($e) && !/* @__PURE__ */ x.isValidElement(He) && $e !== He && Wt(!1, "`label` of `value` is not same as `label` in Select options.");
        }
      }
      return {
        label: He,
        value: lt,
        key: mt,
        disabled: Qt,
        title: Yt
      };
    });
  }, [W, S, ie]), ge = Tr($, {
    value: V
  }), he = be(ge, 2), fe = he[0], _e = he[1], Ne = x.useMemo(function() {
    var Xe, tt = te(fe);
    return r === "combobox" && !((Xe = tt[0]) !== null && Xe !== void 0 && Xe.value) ? [] : tt;
  }, [fe, te, r]), ze = z1e(Ne, ie), Ve = be(ze, 2), ne = Ve[0], pe = Ve[1], ye = x.useMemo(function() {
    if (!r && ne.length === 1) {
      var Xe = ne[0];
      if (Xe.value === null && (Xe.label === null || Xe.label === void 0))
        return [];
    }
    return ne.map(function(tt) {
      var ot;
      return de(de({}, tt), {}, {
        label: (ot = tt.label) !== null && ot !== void 0 ? ot : tt.value
      });
    });
  }, [r, ne]), Ae = x.useMemo(function() {
    return new Set(ne.map(function(Xe) {
      return Xe.value;
    }));
  }, [ne]);
  x.useEffect(function() {
    if (r === "combobox") {
      var Xe, tt = (Xe = ne[0]) === null || Xe === void 0 ? void 0 : Xe.value;
      Z(Hve(tt) ? String(tt) : "");
    }
  }, [ne]);
  var we = Ik(function(Xe, tt) {
    var ot, lt = tt ?? Xe;
    return ot = {}, z(ot, W.value, Xe), z(ot, W.label, lt), ot;
  }), ce = x.useMemo(function() {
    if (r !== "tags")
      return se;
    var Xe = Ye(se), tt = function(lt) {
      return ie.has(lt);
    };
    return Ye(ne).sort(function(ot, lt) {
      return ot.value < lt.value ? -1 : 1;
    }).forEach(function(ot) {
      var lt = ot.value;
      tt(lt) || Xe.push(we(lt, ot.label));
    }), Xe;
  }, [we, se, ie, ne, r]), ve = G1e(ce, W, Q, K, w), Ie = x.useMemo(function() {
    return r !== "tags" || !Q || ve.some(function(Xe) {
      return Xe[w || "value"] === Q;
    }) ? ve : [we(Q)].concat(Ye(ve));
  }, [we, w, r, ve, Q]), q = x.useMemo(function() {
    return y ? Ye(Ie).sort(function(Xe, tt) {
      return y(Xe, tt);
    }) : Ie;
  }, [Ie, y]), Fe = x.useMemo(function() {
    return B1e(q, {
      fieldNames: W,
      childrenAsData: j
    });
  }, [q, W, j]), Ze = function(tt) {
    var ot = te(tt);
    if (_e(ot), M && // Trigger event only when value changed
    (ot.length !== ne.length || ot.some(function(mt, Qt) {
      var Yt;
      return ((Yt = ne[Qt]) === null || Yt === void 0 ? void 0 : Yt.value) !== (mt == null ? void 0 : mt.value);
    }))) {
      var lt = F ? ot : ot.map(function(mt) {
        return mt.value;
      }), He = ot.map(function(mt) {
        return $I(pe(mt.value));
      });
      M(
        // Value
        L ? lt : lt[0],
        // Option
        L ? He : He[0]
      );
    }
  }, at = x.useState(null), Je = be(at, 2), ut = Je[0], Ct = Je[1], Ke = x.useState(0), st = be(Ke, 2), wt = st[0], qt = st[1], bt = _ !== void 0 ? _ : r !== "combobox", Me = x.useCallback(function(Xe, tt) {
    var ot = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {}, lt = ot.source, He = lt === void 0 ? "keyboard" : lt;
    qt(tt), a && r === "combobox" && Xe !== null && He === "keyboard" && Ct(String(Xe));
  }, [a, r]), yt = function(tt, ot, lt) {
    var He = function() {
      var $t, qe = pe(tt);
      return [F ? {
        label: qe == null ? void 0 : qe[W.label],
        value: tt,
        key: ($t = qe == null ? void 0 : qe.key) !== null && $t !== void 0 ? $t : tt
      } : tt, $I(qe)];
    };
    if (ot && h) {
      var mt = He(), Qt = be(mt, 2), Yt = Qt[0], nn = Qt[1];
      h(Yt, nn);
    } else if (!ot && p && lt !== "clear") {
      var Nt = He(), ue = be(Nt, 2), $e = ue[0], je = ue[1];
      p($e, je);
    }
  }, ct = Ik(function(Xe, tt) {
    var ot, lt = L ? tt.selected : !0;
    lt ? ot = L ? [].concat(Ye(ne), [Xe]) : [Xe] : ot = ne.filter(function(He) {
      return He.value !== Xe;
    }), Ze(ot), yt(Xe, lt), r === "combobox" ? Ct("") : (!px || f) && (Z(""), Ct(""));
  }), kt = function(tt, ot) {
    Ze(tt);
    var lt = ot.type, He = ot.values;
    (lt === "remove" || lt === "clear") && He.forEach(function(mt) {
      yt(mt.value, !1, lt);
    });
  }, Vt = function(tt, ot) {
    if (Z(tt), Ct(null), ot.source === "submit") {
      var lt = (tt || "").trim();
      if (lt) {
        var He = Array.from(new Set([].concat(Ye(Ae), [lt])));
        Ze(He), yt(lt, !0), Z("");
      }
      return;
    }
    ot.source !== "blur" && (r === "combobox" && Ze(tt), c == null || c(tt));
  }, Vn = function(tt) {
    var ot = tt;
    r !== "tags" && (ot = tt.map(function(He) {
      var mt = oe.get(He);
      return mt == null ? void 0 : mt.value;
    }).filter(function(He) {
      return He !== void 0;
    }));
    var lt = Array.from(new Set([].concat(Ye(Ae), Ye(ot))));
    Ze(lt), lt.forEach(function(He) {
      yt(He, !0);
    });
  }, tn = x.useMemo(function() {
    var Xe = P !== !1 && m !== !1;
    return de(de({}, ee), {}, {
      flattenOptions: Fe,
      onActiveValue: Me,
      defaultActiveFirstOption: bt,
      onSelect: ct,
      menuItemSelectedIcon: A,
      rawValues: Ae,
      fieldNames: W,
      virtual: Xe,
      listHeight: k,
      listItemHeight: R,
      childrenAsData: j
    });
  }, [ee, Fe, Me, bt, ct, A, Ae, W, P, m, k, R, j]);
  return process.env.NODE_ENV !== "production" && (bbe(t), ybe(se, W)), /* @__PURE__ */ x.createElement(iG.Provider, {
    value: tn
  }, /* @__PURE__ */ x.createElement(eG, G({}, B, {
    // >>> MISC
    id: X,
    prefixCls: o,
    ref: e,
    omitDomProps: Cbe,
    mode: r,
    displayValues: ye,
    onDisplayValuesChange: kt,
    searchValue: Q,
    onSearch: Vt,
    autoClearSearchValue: f,
    onSearchSplit: Vn,
    dropdownMatchSelectWidth: m,
    OptionList: oG,
    emptyOptions: !Fe.length,
    activeValue: ut,
    activeDescendantId: "".concat(X, "_list_").concat(wt)
  })));
});
process.env.NODE_ENV !== "production" && (aG.displayName = "Select");
var EA = aG;
EA.Option = wA;
EA.OptGroup = CA;
var Ebe = function() {
  var e = x.useContext(en), n = e.getPrefixCls, r = n("empty-img-default");
  return /* @__PURE__ */ x.createElement("svg", {
    className: r,
    width: "184",
    height: "152",
    viewBox: "0 0 184 152",
    xmlns: "http://www.w3.org/2000/svg"
  }, /* @__PURE__ */ x.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /* @__PURE__ */ x.createElement("g", {
    transform: "translate(24 31.67)"
  }, /* @__PURE__ */ x.createElement("ellipse", {
    className: "".concat(r, "-ellipse"),
    cx: "67.797",
    cy: "106.89",
    rx: "67.797",
    ry: "12.668"
  }), /* @__PURE__ */ x.createElement("path", {
    className: "".concat(r, "-path-1"),
    d: "M122.034 69.674L98.109 40.229c-1.148-1.386-2.826-2.225-4.593-2.225h-51.44c-1.766 0-3.444.839-4.592 2.225L13.56 69.674v15.383h108.475V69.674z"
  }), /* @__PURE__ */ x.createElement("path", {
    className: "".concat(r, "-path-2"),
    d: "M101.537 86.214L80.63 61.102c-1.001-1.207-2.507-1.867-4.048-1.867H31.724c-1.54 0-3.047.66-4.048 1.867L6.769 86.214v13.792h94.768V86.214z",
    transform: "translate(13.56)"
  }), /* @__PURE__ */ x.createElement("path", {
    className: "".concat(r, "-path-3"),
    d: "M33.83 0h67.933a4 4 0 0 1 4 4v93.344a4 4 0 0 1-4 4H33.83a4 4 0 0 1-4-4V4a4 4 0 0 1 4-4z"
  }), /* @__PURE__ */ x.createElement("path", {
    className: "".concat(r, "-path-4"),
    d: "M42.678 9.953h50.237a2 2 0 0 1 2 2V36.91a2 2 0 0 1-2 2H42.678a2 2 0 0 1-2-2V11.953a2 2 0 0 1 2-2zM42.94 49.767h49.713a2.262 2.262 0 1 1 0 4.524H42.94a2.262 2.262 0 0 1 0-4.524zM42.94 61.53h49.713a2.262 2.262 0 1 1 0 4.525H42.94a2.262 2.262 0 0 1 0-4.525zM121.813 105.032c-.775 3.071-3.497 5.36-6.735 5.36H20.515c-3.238 0-5.96-2.29-6.734-5.36a7.309 7.309 0 0 1-.222-1.79V69.675h26.318c2.907 0 5.25 2.448 5.25 5.42v.04c0 2.971 2.37 5.37 5.277 5.37h34.785c2.907 0 5.277-2.421 5.277-5.393V75.1c0-2.972 2.343-5.426 5.25-5.426h26.318v33.569c0 .617-.077 1.216-.221 1.789z"
  })), /* @__PURE__ */ x.createElement("path", {
    className: "".concat(r, "-path-5"),
    d: "M149.121 33.292l-6.83 2.65a1 1 0 0 1-1.317-1.23l1.937-6.207c-2.589-2.944-4.109-6.534-4.109-10.408C138.802 8.102 148.92 0 161.402 0 173.881 0 184 8.102 184 18.097c0 9.995-10.118 18.097-22.599 18.097-4.528 0-8.744-1.066-12.28-2.902z"
  }), /* @__PURE__ */ x.createElement("g", {
    className: "".concat(r, "-g"),
    transform: "translate(149.65 15.383)"
  }, /* @__PURE__ */ x.createElement("ellipse", {
    cx: "20.654",
    cy: "3.167",
    rx: "2.849",
    ry: "2.815"
  }), /* @__PURE__ */ x.createElement("path", {
    d: "M5.698 5.63H0L2.898.704zM9.259.704h4.985V5.63H9.259z"
  }))));
};
const Sbe = Ebe;
var Ibe = function() {
  var e = x.useContext(en), n = e.getPrefixCls, r = n("empty-img-simple");
  return /* @__PURE__ */ x.createElement("svg", {
    className: r,
    width: "64",
    height: "41",
    viewBox: "0 0 64 41",
    xmlns: "http://www.w3.org/2000/svg"
  }, /* @__PURE__ */ x.createElement("g", {
    transform: "translate(0 1)",
    fill: "none",
    fillRule: "evenodd"
  }, /* @__PURE__ */ x.createElement("ellipse", {
    className: "".concat(r, "-ellipse"),
    cx: "32",
    cy: "33",
    rx: "32",
    ry: "7"
  }), /* @__PURE__ */ x.createElement("g", {
    className: "".concat(r, "-g"),
    fillRule: "nonzero"
  }, /* @__PURE__ */ x.createElement("path", {
    d: "M55 12.76L44.854 1.258C44.367.474 43.656 0 42.907 0H21.093c-.749 0-1.46.474-1.947 1.257L9 12.761V22h46v-9.24z"
  }), /* @__PURE__ */ x.createElement("path", {
    d: "M41.613 15.931c0-1.605.994-2.93 2.227-2.931H55v18.137C55 33.26 53.68 35 52.05 35h-40.1C10.32 35 9 33.259 9 31.137V13h11.16c1.233 0 2.227 1.323 2.227 2.928v.022c0 1.605 1.005 2.901 2.237 2.901h14.752c1.232 0 2.237-1.308 2.237-2.913v-.007z",
    className: "".concat(r, "-path")
  }))));
};
const _be = Ibe;
var Abe = function(t, e) {
  var n = {};
  for (var r in t)
    Object.prototype.hasOwnProperty.call(t, r) && e.indexOf(r) < 0 && (n[r] = t[r]);
  if (t != null && typeof Object.getOwnPropertySymbols == "function")
    for (var i = 0, r = Object.getOwnPropertySymbols(t); i < r.length; i++)
      e.indexOf(r[i]) < 0 && Object.prototype.propertyIsEnumerable.call(t, r[i]) && (n[r[i]] = t[r[i]]);
  return n;
}, sG = /* @__PURE__ */ x.createElement(Sbe, null), uG = /* @__PURE__ */ x.createElement(_be, null), SA = function(e) {
  var n = e.className, r = e.prefixCls, i = e.image, o = i === void 0 ? sG : i, a = e.description, s = e.children, u = e.imageStyle, l = Abe(e, ["className", "prefixCls", "image", "description", "children", "imageStyle"]), c = x.useContext(en), d = c.getPrefixCls, f = c.direction;
  return /* @__PURE__ */ x.createElement(Ic, {
    componentName: "Empty"
  }, function(h) {
    var p = d("empty", r), v = typeof a < "u" ? a : h.description, m = typeof v == "string" ? v : "empty", b = null;
    return typeof o == "string" ? b = /* @__PURE__ */ x.createElement("img", {
      alt: m,
      src: o
    }) : b = o, /* @__PURE__ */ x.createElement("div", G({
      className: Ce(p, z(z({}, "".concat(p, "-normal"), o === uG), "".concat(p, "-rtl"), f === "rtl"), n)
    }, l), /* @__PURE__ */ x.createElement("div", {
      className: "".concat(p, "-image"),
      style: u
    }, b), v && /* @__PURE__ */ x.createElement("div", {
      className: "".concat(p, "-description")
    }, v), s && /* @__PURE__ */ x.createElement("div", {
      className: "".concat(p, "-footer")
    }, s));
  });
};
SA.PRESENTED_IMAGE_DEFAULT = sG;
SA.PRESENTED_IMAGE_SIMPLE = uG;
const _g = SA;
var Tbe = function(e) {
  return /* @__PURE__ */ x.createElement(_c, null, function(n) {
    var r = n.getPrefixCls, i = r("empty");
    switch (e) {
      case "Table":
      case "List":
        return /* @__PURE__ */ x.createElement(_g, {
          image: _g.PRESENTED_IMAGE_SIMPLE
        });
      case "Select":
      case "TreeSelect":
      case "Cascader":
      case "Transfer":
      case "Mentions":
        return /* @__PURE__ */ x.createElement(_g, {
          image: _g.PRESENTED_IMAGE_SIMPLE,
          className: "".concat(i, "-small")
        });
      default:
        return /* @__PURE__ */ x.createElement(_g, null);
    }
  });
};
const lG = Tbe;
var cd = "RC_FORM_INTERNAL_HOOKS", yr = function() {
  Wt(!1, "Can not find FormContext. Please make sure you wrap Field under Form.");
}, Nd = /* @__PURE__ */ x.createContext({
  getFieldValue: yr,
  getFieldsValue: yr,
  getFieldError: yr,
  getFieldWarning: yr,
  getFieldsError: yr,
  isFieldsTouched: yr,
  isFieldTouched: yr,
  isFieldValidating: yr,
  isFieldsValidating: yr,
  resetFields: yr,
  setFields: yr,
  setFieldValue: yr,
  setFieldsValue: yr,
  validateFields: yr,
  submit: yr,
  getInternalHooks: function() {
    return yr(), {
      dispatch: yr,
      initEntityValue: yr,
      registerField: yr,
      useSubscribe: yr,
      setInitialValues: yr,
      destroyForm: yr,
      setCallbacks: yr,
      registerWatch: yr,
      getFields: yr,
      setValidateMessages: yr,
      setPreserve: yr,
      getInitialValue: yr
    };
  }
}), j0 = /* @__PURE__ */ x.createContext(null);
function MI(t) {
  return t == null ? [] : Array.isArray(t) ? t : [t];
}
function Obe(t) {
  return t && !!t._init;
}
function dd() {
  return dd = Object.assign ? Object.assign.bind() : function(t) {
    for (var e = 1; e < arguments.length; e++) {
      var n = arguments[e];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (t[r] = n[r]);
    }
    return t;
  }, dd.apply(this, arguments);
}
function Pbe(t, e) {
  t.prototype = Object.create(e.prototype), t.prototype.constructor = t, z0(t, e);
}
function FI(t) {
  return FI = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(n) {
    return n.__proto__ || Object.getPrototypeOf(n);
  }, FI(t);
}
function z0(t, e) {
  return z0 = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(r, i) {
    return r.__proto__ = i, r;
  }, z0(t, e);
}
function Nbe() {
  if (typeof Reflect > "u" || !Reflect.construct || Reflect.construct.sham)
    return !1;
  if (typeof Proxy == "function")
    return !0;
  try {
    return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    })), !0;
  } catch {
    return !1;
  }
}
function uy(t, e, n) {
  return Nbe() ? uy = Reflect.construct.bind() : uy = function(i, o, a) {
    var s = [null];
    s.push.apply(s, o);
    var u = Function.bind.apply(i, s), l = new u();
    return a && z0(l, a.prototype), l;
  }, uy.apply(null, arguments);
}
function kbe(t) {
  return Function.toString.call(t).indexOf("[native code]") !== -1;
}
function LI(t) {
  var e = typeof Map == "function" ? /* @__PURE__ */ new Map() : void 0;
  return LI = function(r) {
    if (r === null || !kbe(r))
      return r;
    if (typeof r != "function")
      throw new TypeError("Super expression must either be null or a function");
    if (typeof e < "u") {
      if (e.has(r))
        return e.get(r);
      e.set(r, i);
    }
    function i() {
      return uy(r, arguments, FI(this).constructor);
    }
    return i.prototype = Object.create(r.prototype, {
      constructor: {
        value: i,
        enumerable: !1,
        writable: !0,
        configurable: !0
      }
    }), z0(i, r);
  }, LI(t);
}
var Rbe = /%[sdj%]/g, cG = function() {
};
typeof process < "u" && process.env && process.env.NODE_ENV !== "production" && typeof window < "u" && typeof document < "u" && (cG = function(e, n) {
  typeof console < "u" && console.warn && typeof ASYNC_VALIDATOR_NO_WARNING > "u" && n.every(function(r) {
    return typeof r == "string";
  }) && console.warn(e, n);
});
function VI(t) {
  if (!t || !t.length)
    return null;
  var e = {};
  return t.forEach(function(n) {
    var r = n.field;
    e[r] = e[r] || [], e[r].push(n);
  }), e;
}
function oa(t) {
  for (var e = arguments.length, n = new Array(e > 1 ? e - 1 : 0), r = 1; r < e; r++)
    n[r - 1] = arguments[r];
  var i = 0, o = n.length;
  if (typeof t == "function")
    return t.apply(null, n);
  if (typeof t == "string") {
    var a = t.replace(Rbe, function(s) {
      if (s === "%%")
        return "%";
      if (i >= o)
        return s;
      switch (s) {
        case "%s":
          return String(n[i++]);
        case "%d":
          return Number(n[i++]);
        case "%j":
          try {
            return JSON.stringify(n[i++]);
          } catch {
            return "[Circular]";
          }
          break;
        default:
          return s;
      }
    });
    return a;
  }
  return t;
}
function $be(t) {
  return t === "string" || t === "url" || t === "hex" || t === "email" || t === "date" || t === "pattern";
}
function Ci(t, e) {
  return !!(t == null || e === "array" && Array.isArray(t) && !t.length || $be(e) && typeof t == "string" && !t);
}
function Dbe(t, e, n) {
  var r = [], i = 0, o = t.length;
  function a(s) {
    r.push.apply(r, s || []), i++, i === o && n(r);
  }
  t.forEach(function(s) {
    e(s, a);
  });
}
function Nk(t, e, n) {
  var r = 0, i = t.length;
  function o(a) {
    if (a && a.length) {
      n(a);
      return;
    }
    var s = r;
    r = r + 1, s < i ? e(t[s], o) : n([]);
  }
  o([]);
}
function Mbe(t) {
  var e = [];
  return Object.keys(t).forEach(function(n) {
    e.push.apply(e, t[n] || []);
  }), e;
}
var kk = /* @__PURE__ */ function(t) {
  Pbe(e, t);
  function e(n, r) {
    var i;
    return i = t.call(this, "Async Validation Error") || this, i.errors = n, i.fields = r, i;
  }
  return e;
}(/* @__PURE__ */ LI(Error));
function Fbe(t, e, n, r, i) {
  if (e.first) {
    var o = new Promise(function(f, h) {
      var p = function(b) {
        return r(b), b.length ? h(new kk(b, VI(b))) : f(i);
      }, v = Mbe(t);
      Nk(v, n, p);
    });
    return o.catch(function(f) {
      return f;
    }), o;
  }
  var a = e.firstFields === !0 ? Object.keys(t) : e.firstFields || [], s = Object.keys(t), u = s.length, l = 0, c = [], d = new Promise(function(f, h) {
    var p = function(m) {
      if (c.push.apply(c, m), l++, l === u)
        return r(c), c.length ? h(new kk(c, VI(c))) : f(i);
    };
    s.length || (r(c), f(i)), s.forEach(function(v) {
      var m = t[v];
      a.indexOf(v) !== -1 ? Nk(m, n, p) : Dbe(m, n, p);
    });
  });
  return d.catch(function(f) {
    return f;
  }), d;
}
function Lbe(t) {
  return !!(t && t.message !== void 0);
}
function Vbe(t, e) {
  for (var n = t, r = 0; r < e.length; r++) {
    if (n == null)
      return n;
    n = n[e[r]];
  }
  return n;
}
function Rk(t, e) {
  return function(n) {
    var r;
    return t.fullFields ? r = Vbe(e, t.fullFields) : r = e[n.field || t.fullField], Lbe(n) ? (n.field = n.field || t.fullField, n.fieldValue = r, n) : {
      message: typeof n == "function" ? n() : n,
      fieldValue: r,
      field: n.field || t.fullField
    };
  };
}
function $k(t, e) {
  if (e) {
    for (var n in e)
      if (e.hasOwnProperty(n)) {
        var r = e[n];
        typeof r == "object" && typeof t[n] == "object" ? t[n] = dd({}, t[n], r) : t[n] = r;
      }
  }
  return t;
}
var dG = function(e, n, r, i, o, a) {
  e.required && (!r.hasOwnProperty(e.field) || Ci(n, a || e.type)) && i.push(oa(o.messages.required, e.fullField));
}, Bbe = function(e, n, r, i, o) {
  (/^\s+$/.test(n) || n === "") && i.push(oa(o.messages.whitespace, e.fullField));
}, Z1, Hbe = function() {
  if (Z1)
    return Z1;
  var t = "[a-fA-F\\d:]", e = function(S) {
    return S && S.includeBoundaries ? "(?:(?<=\\s|^)(?=" + t + ")|(?<=" + t + ")(?=\\s|$))" : "";
  }, n = "(?:25[0-5]|2[0-4]\\d|1\\d\\d|[1-9]\\d|\\d)(?:\\.(?:25[0-5]|2[0-4]\\d|1\\d\\d|[1-9]\\d|\\d)){3}", r = "[a-fA-F\\d]{1,4}", i = (`
(?:
(?:` + r + ":){7}(?:" + r + `|:)|                                    // 1:2:3:4:5:6:7::  1:2:3:4:5:6:7:8
(?:` + r + ":){6}(?:" + n + "|:" + r + `|:)|                             // 1:2:3:4:5:6::    1:2:3:4:5:6::8   1:2:3:4:5:6::8  1:2:3:4:5:6::1.2.3.4
(?:` + r + ":){5}(?::" + n + "|(?::" + r + `){1,2}|:)|                   // 1:2:3:4:5::      1:2:3:4:5::7:8   1:2:3:4:5::8    1:2:3:4:5::7:1.2.3.4
(?:` + r + ":){4}(?:(?::" + r + "){0,1}:" + n + "|(?::" + r + `){1,3}|:)| // 1:2:3:4::        1:2:3:4::6:7:8   1:2:3:4::8      1:2:3:4::6:7:1.2.3.4
(?:` + r + ":){3}(?:(?::" + r + "){0,2}:" + n + "|(?::" + r + `){1,4}|:)| // 1:2:3::          1:2:3::5:6:7:8   1:2:3::8        1:2:3::5:6:7:1.2.3.4
(?:` + r + ":){2}(?:(?::" + r + "){0,3}:" + n + "|(?::" + r + `){1,5}|:)| // 1:2::            1:2::4:5:6:7:8   1:2::8          1:2::4:5:6:7:1.2.3.4
(?:` + r + ":){1}(?:(?::" + r + "){0,4}:" + n + "|(?::" + r + `){1,6}|:)| // 1::              1::3:4:5:6:7:8   1::8            1::3:4:5:6:7:1.2.3.4
(?::(?:(?::` + r + "){0,5}:" + n + "|(?::" + r + `){1,7}|:))             // ::2:3:4:5:6:7:8  ::2:3:4:5:6:7:8  ::8             ::1.2.3.4
)(?:%[0-9a-zA-Z]{1,})?                                             // %eth0            %1
`).replace(/\s*\/\/.*$/gm, "").replace(/\n/g, "").trim(), o = new RegExp("(?:^" + n + "$)|(?:^" + i + "$)"), a = new RegExp("^" + n + "$"), s = new RegExp("^" + i + "$"), u = function(S) {
    return S && S.exact ? o : new RegExp("(?:" + e(S) + n + e(S) + ")|(?:" + e(S) + i + e(S) + ")", "g");
  };
  u.v4 = function(w) {
    return w && w.exact ? a : new RegExp("" + e(w) + n + e(w), "g");
  }, u.v6 = function(w) {
    return w && w.exact ? s : new RegExp("" + e(w) + i + e(w), "g");
  };
  var l = "(?:(?:[a-z]+:)?//)", c = "(?:\\S+(?::\\S*)?@)?", d = u.v4().source, f = u.v6().source, h = "(?:(?:[a-z\\u00a1-\\uffff0-9][-_]*)*[a-z\\u00a1-\\uffff0-9]+)", p = "(?:\\.(?:[a-z\\u00a1-\\uffff0-9]-*)*[a-z\\u00a1-\\uffff0-9]+)*", v = "(?:\\.(?:[a-z\\u00a1-\\uffff]{2,}))", m = "(?::\\d{2,5})?", b = '(?:[/?#][^\\s"]*)?', y = "(?:" + l + "|www\\.)" + c + "(?:localhost|" + d + "|" + f + "|" + h + p + v + ")" + m + b;
  return Z1 = new RegExp("(?:^" + y + "$)", "i"), Z1;
}, Dk = {
  // http://emailregex.com/
  email: /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]+\.)+[a-zA-Z\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]{2,}))$/,
  // url: new RegExp(
  //   '^(?!mailto:)(?:(?:http|https|ftp)://|//)(?:\\S+(?::\\S*)?@)?(?:(?:(?:[1-9]\\d?|1\\d\\d|2[01]\\d|22[0-3])(?:\\.(?:1?\\d{1,2}|2[0-4]\\d|25[0-5])){2}(?:\\.(?:[0-9]\\d?|1\\d\\d|2[0-4]\\d|25[0-4]))|(?:(?:[a-z\\u00a1-\\uffff0-9]+-*)*[a-z\\u00a1-\\uffff0-9]+)(?:\\.(?:[a-z\\u00a1-\\uffff0-9]+-*)*[a-z\\u00a1-\\uffff0-9]+)*(?:\\.(?:[a-z\\u00a1-\\uffff]{2,})))|localhost)(?::\\d{2,5})?(?:(/|\\?|#)[^\\s]*)?$',
  //   'i',
  // ),
  hex: /^#?([a-f0-9]{6}|[a-f0-9]{3})$/i
}, qg = {
  integer: function(e) {
    return qg.number(e) && parseInt(e, 10) === e;
  },
  float: function(e) {
    return qg.number(e) && !qg.integer(e);
  },
  array: function(e) {
    return Array.isArray(e);
  },
  regexp: function(e) {
    if (e instanceof RegExp)
      return !0;
    try {
      return !!new RegExp(e);
    } catch {
      return !1;
    }
  },
  date: function(e) {
    return typeof e.getTime == "function" && typeof e.getMonth == "function" && typeof e.getYear == "function" && !isNaN(e.getTime());
  },
  number: function(e) {
    return isNaN(e) ? !1 : typeof e == "number";
  },
  object: function(e) {
    return typeof e == "object" && !qg.array(e);
  },
  method: function(e) {
    return typeof e == "function";
  },
  email: function(e) {
    return typeof e == "string" && e.length <= 320 && !!e.match(Dk.email);
  },
  url: function(e) {
    return typeof e == "string" && e.length <= 2048 && !!e.match(Hbe());
  },
  hex: function(e) {
    return typeof e == "string" && !!e.match(Dk.hex);
  }
}, Wbe = function(e, n, r, i, o) {
  if (e.required && n === void 0) {
    dG(e, n, r, i, o);
    return;
  }
  var a = ["integer", "float", "array", "regexp", "object", "method", "email", "number", "date", "url", "hex"], s = e.type;
  a.indexOf(s) > -1 ? qg[s](n) || i.push(oa(o.messages.types[s], e.fullField, e.type)) : s && typeof n !== e.type && i.push(oa(o.messages.types[s], e.fullField, e.type));
}, jbe = function(e, n, r, i, o) {
  var a = typeof e.len == "number", s = typeof e.min == "number", u = typeof e.max == "number", l = /[\uD800-\uDBFF][\uDC00-\uDFFF]/g, c = n, d = null, f = typeof n == "number", h = typeof n == "string", p = Array.isArray(n);
  if (f ? d = "number" : h ? d = "string" : p && (d = "array"), !d)
    return !1;
  p && (c = n.length), h && (c = n.replace(l, "_").length), a ? c !== e.len && i.push(oa(o.messages[d].len, e.fullField, e.len)) : s && !u && c < e.min ? i.push(oa(o.messages[d].min, e.fullField, e.min)) : u && !s && c > e.max ? i.push(oa(o.messages[d].max, e.fullField, e.max)) : s && u && (c < e.min || c > e.max) && i.push(oa(o.messages[d].range, e.fullField, e.min, e.max));
}, Rf = "enum", zbe = function(e, n, r, i, o) {
  e[Rf] = Array.isArray(e[Rf]) ? e[Rf] : [], e[Rf].indexOf(n) === -1 && i.push(oa(o.messages[Rf], e.fullField, e[Rf].join(", ")));
}, Gbe = function(e, n, r, i, o) {
  if (e.pattern) {
    if (e.pattern instanceof RegExp)
      e.pattern.lastIndex = 0, e.pattern.test(n) || i.push(oa(o.messages.pattern.mismatch, e.fullField, n, e.pattern));
    else if (typeof e.pattern == "string") {
      var a = new RegExp(e.pattern);
      a.test(n) || i.push(oa(o.messages.pattern.mismatch, e.fullField, n, e.pattern));
    }
  }
}, $n = {
  required: dG,
  whitespace: Bbe,
  type: Wbe,
  range: jbe,
  enum: zbe,
  pattern: Gbe
}, Ube = function(e, n, r, i, o) {
  var a = [], s = e.required || !e.required && i.hasOwnProperty(e.field);
  if (s) {
    if (Ci(n, "string") && !e.required)
      return r();
    $n.required(e, n, i, a, o, "string"), Ci(n, "string") || ($n.type(e, n, i, a, o), $n.range(e, n, i, a, o), $n.pattern(e, n, i, a, o), e.whitespace === !0 && $n.whitespace(e, n, i, a, o));
  }
  r(a);
}, Xbe = function(e, n, r, i, o) {
  var a = [], s = e.required || !e.required && i.hasOwnProperty(e.field);
  if (s) {
    if (Ci(n) && !e.required)
      return r();
    $n.required(e, n, i, a, o), n !== void 0 && $n.type(e, n, i, a, o);
  }
  r(a);
}, Ybe = function(e, n, r, i, o) {
  var a = [], s = e.required || !e.required && i.hasOwnProperty(e.field);
  if (s) {
    if (n === "" && (n = void 0), Ci(n) && !e.required)
      return r();
    $n.required(e, n, i, a, o), n !== void 0 && ($n.type(e, n, i, a, o), $n.range(e, n, i, a, o));
  }
  r(a);
}, Zbe = function(e, n, r, i, o) {
  var a = [], s = e.required || !e.required && i.hasOwnProperty(e.field);
  if (s) {
    if (Ci(n) && !e.required)
      return r();
    $n.required(e, n, i, a, o), n !== void 0 && $n.type(e, n, i, a, o);
  }
  r(a);
}, Jbe = function(e, n, r, i, o) {
  var a = [], s = e.required || !e.required && i.hasOwnProperty(e.field);
  if (s) {
    if (Ci(n) && !e.required)
      return r();
    $n.required(e, n, i, a, o), Ci(n) || $n.type(e, n, i, a, o);
  }
  r(a);
}, Kbe = function(e, n, r, i, o) {
  var a = [], s = e.required || !e.required && i.hasOwnProperty(e.field);
  if (s) {
    if (Ci(n) && !e.required)
      return r();
    $n.required(e, n, i, a, o), n !== void 0 && ($n.type(e, n, i, a, o), $n.range(e, n, i, a, o));
  }
  r(a);
}, qbe = function(e, n, r, i, o) {
  var a = [], s = e.required || !e.required && i.hasOwnProperty(e.field);
  if (s) {
    if (Ci(n) && !e.required)
      return r();
    $n.required(e, n, i, a, o), n !== void 0 && ($n.type(e, n, i, a, o), $n.range(e, n, i, a, o));
  }
  r(a);
}, Qbe = function(e, n, r, i, o) {
  var a = [], s = e.required || !e.required && i.hasOwnProperty(e.field);
  if (s) {
    if (n == null && !e.required)
      return r();
    $n.required(e, n, i, a, o, "array"), n != null && ($n.type(e, n, i, a, o), $n.range(e, n, i, a, o));
  }
  r(a);
}, eye = function(e, n, r, i, o) {
  var a = [], s = e.required || !e.required && i.hasOwnProperty(e.field);
  if (s) {
    if (Ci(n) && !e.required)
      return r();
    $n.required(e, n, i, a, o), n !== void 0 && $n.type(e, n, i, a, o);
  }
  r(a);
}, tye = "enum", nye = function(e, n, r, i, o) {
  var a = [], s = e.required || !e.required && i.hasOwnProperty(e.field);
  if (s) {
    if (Ci(n) && !e.required)
      return r();
    $n.required(e, n, i, a, o), n !== void 0 && $n[tye](e, n, i, a, o);
  }
  r(a);
}, rye = function(e, n, r, i, o) {
  var a = [], s = e.required || !e.required && i.hasOwnProperty(e.field);
  if (s) {
    if (Ci(n, "string") && !e.required)
      return r();
    $n.required(e, n, i, a, o), Ci(n, "string") || $n.pattern(e, n, i, a, o);
  }
  r(a);
}, iye = function(e, n, r, i, o) {
  var a = [], s = e.required || !e.required && i.hasOwnProperty(e.field);
  if (s) {
    if (Ci(n, "date") && !e.required)
      return r();
    if ($n.required(e, n, i, a, o), !Ci(n, "date")) {
      var u;
      n instanceof Date ? u = n : u = new Date(n), $n.type(e, u, i, a, o), u && $n.range(e, u.getTime(), i, a, o);
    }
  }
  r(a);
}, oye = function(e, n, r, i, o) {
  var a = [], s = Array.isArray(n) ? "array" : typeof n;
  $n.required(e, n, i, a, o, s), r(a);
}, VS = function(e, n, r, i, o) {
  var a = e.type, s = [], u = e.required || !e.required && i.hasOwnProperty(e.field);
  if (u) {
    if (Ci(n, a) && !e.required)
      return r();
    $n.required(e, n, i, s, o, a), Ci(n, a) || $n.type(e, n, i, s, o);
  }
  r(s);
}, aye = function(e, n, r, i, o) {
  var a = [], s = e.required || !e.required && i.hasOwnProperty(e.field);
  if (s) {
    if (Ci(n) && !e.required)
      return r();
    $n.required(e, n, i, a, o);
  }
  r(a);
}, h0 = {
  string: Ube,
  method: Xbe,
  number: Ybe,
  boolean: Zbe,
  regexp: Jbe,
  integer: Kbe,
  float: qbe,
  array: Qbe,
  object: eye,
  enum: nye,
  pattern: rye,
  date: iye,
  url: VS,
  hex: VS,
  email: VS,
  required: oye,
  any: aye
};
function BI() {
  return {
    default: "Validation error on field %s",
    required: "%s is required",
    enum: "%s must be one of %s",
    whitespace: "%s cannot be empty",
    date: {
      format: "%s date %s is invalid for format %s",
      parse: "%s date could not be parsed, %s is invalid ",
      invalid: "%s date %s is invalid"
    },
    types: {
      string: "%s is not a %s",
      method: "%s is not a %s (function)",
      array: "%s is not an %s",
      object: "%s is not an %s",
      number: "%s is not a %s",
      date: "%s is not a %s",
      boolean: "%s is not a %s",
      integer: "%s is not an %s",
      float: "%s is not a %s",
      regexp: "%s is not a valid %s",
      email: "%s is not a valid %s",
      url: "%s is not a valid %s",
      hex: "%s is not a valid %s"
    },
    string: {
      len: "%s must be exactly %s characters",
      min: "%s must be at least %s characters",
      max: "%s cannot be longer than %s characters",
      range: "%s must be between %s and %s characters"
    },
    number: {
      len: "%s must equal %s",
      min: "%s cannot be less than %s",
      max: "%s cannot be greater than %s",
      range: "%s must be between %s and %s"
    },
    array: {
      len: "%s must be exactly %s in length",
      min: "%s cannot be less than %s in length",
      max: "%s cannot be greater than %s in length",
      range: "%s must be between %s and %s in length"
    },
    pattern: {
      mismatch: "%s value %s does not match pattern %s"
    },
    clone: function() {
      var e = JSON.parse(JSON.stringify(this));
      return e.clone = this.clone, e;
    }
  };
}
var HI = BI(), Fm = /* @__PURE__ */ function() {
  function t(n) {
    this.rules = null, this._messages = HI, this.define(n);
  }
  var e = t.prototype;
  return e.define = function(r) {
    var i = this;
    if (!r)
      throw new Error("Cannot configure a schema with no rules");
    if (typeof r != "object" || Array.isArray(r))
      throw new Error("Rules must be an object");
    this.rules = {}, Object.keys(r).forEach(function(o) {
      var a = r[o];
      i.rules[o] = Array.isArray(a) ? a : [a];
    });
  }, e.messages = function(r) {
    return r && (this._messages = $k(BI(), r)), this._messages;
  }, e.validate = function(r, i, o) {
    var a = this;
    i === void 0 && (i = {}), o === void 0 && (o = function() {
    });
    var s = r, u = i, l = o;
    if (typeof u == "function" && (l = u, u = {}), !this.rules || Object.keys(this.rules).length === 0)
      return l && l(null, s), Promise.resolve(s);
    function c(v) {
      var m = [], b = {};
      function y(S) {
        if (Array.isArray(S)) {
          var E;
          m = (E = m).concat.apply(E, S);
        } else
          m.push(S);
      }
      for (var w = 0; w < v.length; w++)
        y(v[w]);
      m.length ? (b = VI(m), l(m, b)) : l(null, s);
    }
    if (u.messages) {
      var d = this.messages();
      d === HI && (d = BI()), $k(d, u.messages), u.messages = d;
    } else
      u.messages = this.messages();
    var f = {}, h = u.keys || Object.keys(this.rules);
    h.forEach(function(v) {
      var m = a.rules[v], b = s[v];
      m.forEach(function(y) {
        var w = y;
        typeof w.transform == "function" && (s === r && (s = dd({}, s)), b = s[v] = w.transform(b)), typeof w == "function" ? w = {
          validator: w
        } : w = dd({}, w), w.validator = a.getValidationMethod(w), w.validator && (w.field = v, w.fullField = w.fullField || v, w.type = a.getType(w), f[v] = f[v] || [], f[v].push({
          rule: w,
          value: b,
          source: s,
          field: v
        }));
      });
    });
    var p = {};
    return Fbe(f, u, function(v, m) {
      var b = v.rule, y = (b.type === "object" || b.type === "array") && (typeof b.fields == "object" || typeof b.defaultField == "object");
      y = y && (b.required || !b.required && v.value), b.field = v.field;
      function w(I, _) {
        return dd({}, _, {
          fullField: b.fullField + "." + I,
          fullFields: b.fullFields ? [].concat(b.fullFields, [I]) : [I]
        });
      }
      function S(I) {
        I === void 0 && (I = []);
        var _ = Array.isArray(I) ? I : [I];
        !u.suppressWarning && _.length && t.warning("async-validator:", _), _.length && b.message !== void 0 && (_ = [].concat(b.message));
        var A = _.map(Rk(b, s));
        if (u.first && A.length)
          return p[b.field] = 1, m(A);
        if (!y)
          m(A);
        else {
          if (b.required && !v.value)
            return b.message !== void 0 ? A = [].concat(b.message).map(Rk(b, s)) : u.error && (A = [u.error(b, oa(u.messages.required, b.field))]), m(A);
          var P = {};
          b.defaultField && Object.keys(v.value).map(function(D) {
            P[D] = b.defaultField;
          }), P = dd({}, P, v.rule.fields);
          var N = {};
          Object.keys(P).forEach(function(D) {
            var R = P[D], V = Array.isArray(R) ? R : [R];
            N[D] = V.map(w.bind(null, D));
          });
          var k = new t(N);
          k.messages(u.messages), v.rule.options && (v.rule.options.messages = u.messages, v.rule.options.error = u.error), k.validate(v.value, v.rule.options || u, function(D) {
            var R = [];
            A && A.length && R.push.apply(R, A), D && D.length && R.push.apply(R, D), m(R.length ? R : null);
          });
        }
      }
      var E;
      if (b.asyncValidator)
        E = b.asyncValidator(b, v.value, S, v.source, u);
      else if (b.validator) {
        try {
          E = b.validator(b, v.value, S, v.source, u);
        } catch (I) {
          console.error == null || console.error(I), u.suppressValidatorError || setTimeout(function() {
            throw I;
          }, 0), S(I.message);
        }
        E === !0 ? S() : E === !1 ? S(typeof b.message == "function" ? b.message(b.fullField || b.field) : b.message || (b.fullField || b.field) + " fails") : E instanceof Array ? S(E) : E instanceof Error && S(E.message);
      }
      E && E.then && E.then(function() {
        return S();
      }, function(I) {
        return S(I);
      });
    }, function(v) {
      c(v);
    }, s);
  }, e.getType = function(r) {
    if (r.type === void 0 && r.pattern instanceof RegExp && (r.type = "pattern"), typeof r.validator != "function" && r.type && !h0.hasOwnProperty(r.type))
      throw new Error(oa("Unknown rule type %s", r.type));
    return r.type || "string";
  }, e.getValidationMethod = function(r) {
    if (typeof r.validator == "function")
      return r.validator;
    var i = Object.keys(r), o = i.indexOf("message");
    return o !== -1 && i.splice(o, 1), i.length === 1 && i[0] === "required" ? h0.required : h0[this.getType(r)] || void 0;
  }, t;
}();
Fm.register = function(e, n) {
  if (typeof n != "function")
    throw new Error("Cannot register a validator by type, validator is not a function");
  h0[e] = n;
};
Fm.warning = cG;
Fm.messages = HI;
Fm.validators = h0;
var Jo = "'${name}' is not a valid ${type}", fG = {
  default: "Validation error on field '${name}'",
  required: "'${name}' is required",
  enum: "'${name}' must be one of [${enum}]",
  whitespace: "'${name}' cannot be empty",
  date: {
    format: "'${name}' is invalid for format date",
    parse: "'${name}' could not be parsed as date",
    invalid: "'${name}' is invalid date"
  },
  types: {
    string: Jo,
    method: Jo,
    array: Jo,
    object: Jo,
    number: Jo,
    date: Jo,
    boolean: Jo,
    integer: Jo,
    float: Jo,
    regexp: Jo,
    email: Jo,
    url: Jo,
    hex: Jo
  },
  string: {
    len: "'${name}' must be exactly ${len} characters",
    min: "'${name}' must be at least ${min} characters",
    max: "'${name}' cannot be longer than ${max} characters",
    range: "'${name}' must be between ${min} and ${max} characters"
  },
  number: {
    len: "'${name}' must equal ${len}",
    min: "'${name}' cannot be less than ${min}",
    max: "'${name}' cannot be greater than ${max}",
    range: "'${name}' must be between ${min} and ${max}"
  },
  array: {
    len: "'${name}' must be exactly ${len} in length",
    min: "'${name}' cannot be less than ${min} in length",
    max: "'${name}' cannot be greater than ${max} in length",
    range: "'${name}' must be between ${min} and ${max} in length"
  },
  pattern: {
    mismatch: "'${name}' does not match pattern ${pattern}"
  }
}, Mk = Fm;
function sye(t, e) {
  return t.replace(/\$\{\w+\}/g, function(n) {
    var r = n.slice(2, -1);
    return e[r];
  });
}
var Fk = "CODE_LOGIC_ERROR";
function WI(t, e, n, r, i) {
  return jI.apply(this, arguments);
}
function jI() {
  return jI = ul(/* @__PURE__ */ ai().mark(function t(e, n, r, i, o) {
    var a, s, u, l, c, d, f, h, p;
    return ai().wrap(function(m) {
      for (; ; )
        switch (m.prev = m.next) {
          case 0:
            return a = de({}, r), delete a.ruleIndex, Mk.warning = function() {
            }, a.validator && (s = a.validator, a.validator = function() {
              try {
                return s.apply(void 0, arguments);
              } catch (b) {
                return console.error(b), Promise.reject(Fk);
              }
            }), u = null, a && a.type === "array" && a.defaultField && (u = a.defaultField, delete a.defaultField), l = new Mk(z({}, e, [a])), c = Sh(fG, i.validateMessages), l.messages(c), d = [], m.prev = 10, m.next = 13, Promise.resolve(l.validate(z({}, e, n), de({}, i)));
          case 13:
            m.next = 18;
            break;
          case 15:
            m.prev = 15, m.t0 = m.catch(10), m.t0.errors && (d = m.t0.errors.map(function(b, y) {
              var w = b.message, S = w === Fk ? c.default : w;
              return /* @__PURE__ */ x.isValidElement(S) ? (
                // Wrap ReactNode with `key`
                x.cloneElement(S, {
                  key: "error_".concat(y)
                })
              ) : S;
            }));
          case 18:
            if (!(!d.length && u)) {
              m.next = 23;
              break;
            }
            return m.next = 21, Promise.all(n.map(function(b, y) {
              return WI("".concat(e, ".").concat(y), b, u, i, o);
            }));
          case 21:
            return f = m.sent, m.abrupt("return", f.reduce(function(b, y) {
              return [].concat(Ye(b), Ye(y));
            }, []));
          case 23:
            return h = de(de({}, r), {}, {
              name: e,
              enum: (r.enum || []).join(", ")
            }, o), p = d.map(function(b) {
              return typeof b == "string" ? sye(b, h) : b;
            }), m.abrupt("return", p);
          case 26:
          case "end":
            return m.stop();
        }
    }, t, null, [[10, 15]]);
  })), jI.apply(this, arguments);
}
function uye(t, e, n, r, i, o) {
  var a = t.join("."), s = n.map(function(c, d) {
    var f = c.validator, h = de(de({}, c), {}, {
      ruleIndex: d
    });
    return f && (h.validator = function(p, v, m) {
      var b = !1, y = function() {
        for (var E = arguments.length, I = new Array(E), _ = 0; _ < E; _++)
          I[_] = arguments[_];
        Promise.resolve().then(function() {
          Wt(!b, "Your validator function has already return a promise. `callback` will be ignored."), b || m.apply(void 0, I);
        });
      }, w = f(p, v, y);
      b = w && typeof w.then == "function" && typeof w.catch == "function", Wt(b, "`callback` is deprecated. Please return a promise instead."), b && w.then(function() {
        m();
      }).catch(function(S) {
        m(S || " ");
      });
    }), h;
  }).sort(function(c, d) {
    var f = c.warningOnly, h = c.ruleIndex, p = d.warningOnly, v = d.ruleIndex;
    return !!f == !!p ? h - v : f ? 1 : -1;
  }), u;
  if (i === !0)
    u = new Promise(/* @__PURE__ */ function() {
      var c = ul(/* @__PURE__ */ ai().mark(function d(f, h) {
        var p, v, m;
        return ai().wrap(function(y) {
          for (; ; )
            switch (y.prev = y.next) {
              case 0:
                p = 0;
              case 1:
                if (!(p < s.length)) {
                  y.next = 12;
                  break;
                }
                return v = s[p], y.next = 5, WI(a, e, v, r, o);
              case 5:
                if (m = y.sent, !m.length) {
                  y.next = 9;
                  break;
                }
                return h([{
                  errors: m,
                  rule: v
                }]), y.abrupt("return");
              case 9:
                p += 1, y.next = 1;
                break;
              case 12:
                f([]);
              case 13:
              case "end":
                return y.stop();
            }
        }, d);
      }));
      return function(d, f) {
        return c.apply(this, arguments);
      };
    }());
  else {
    var l = s.map(function(c) {
      return WI(a, e, c, r, o).then(function(d) {
        return {
          errors: d,
          rule: c
        };
      });
    });
    u = (i ? cye(l) : lye(l)).then(function(c) {
      return Promise.reject(c);
    });
  }
  return u.catch(function(c) {
    return c;
  }), u;
}
function lye(t) {
  return zI.apply(this, arguments);
}
function zI() {
  return zI = ul(/* @__PURE__ */ ai().mark(function t(e) {
    return ai().wrap(function(r) {
      for (; ; )
        switch (r.prev = r.next) {
          case 0:
            return r.abrupt("return", Promise.all(e).then(function(i) {
              var o, a = (o = []).concat.apply(o, Ye(i));
              return a;
            }));
          case 1:
          case "end":
            return r.stop();
        }
    }, t);
  })), zI.apply(this, arguments);
}
function cye(t) {
  return GI.apply(this, arguments);
}
function GI() {
  return GI = ul(/* @__PURE__ */ ai().mark(function t(e) {
    var n;
    return ai().wrap(function(i) {
      for (; ; )
        switch (i.prev = i.next) {
          case 0:
            return n = 0, i.abrupt("return", new Promise(function(o) {
              e.forEach(function(a) {
                a.then(function(s) {
                  s.errors.length && o([s]), n += 1, n === e.length && o([]);
                });
              });
            }));
          case 2:
          case "end":
            return i.stop();
        }
    }, t);
  })), GI.apply(this, arguments);
}
function ri(t) {
  return MI(t);
}
function Lk(t, e) {
  var n = {};
  return e.forEach(function(r) {
    var i = _s(t, r);
    n = bs(n, r, i);
  }), n;
}
function Lh(t, e) {
  var n = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : !1;
  return t && t.some(function(r) {
    return hG(e, r, n);
  });
}
function hG(t, e) {
  var n = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : !1;
  return !t || !e || !n && t.length !== e.length ? !1 : e.every(function(r, i) {
    return t[i] === r;
  });
}
function dye(t, e) {
  if (t === e)
    return !0;
  if (!t && e || t && !e || !t || !e || _t(t) !== "object" || _t(e) !== "object")
    return !1;
  var n = Object.keys(t), r = Object.keys(e), i = new Set([].concat(n, r));
  return Ye(i).every(function(o) {
    var a = t[o], s = e[o];
    return typeof a == "function" && typeof s == "function" ? !0 : a === s;
  });
}
function fye(t) {
  var e = arguments.length <= 1 ? void 0 : arguments[1];
  return e && e.target && _t(e.target) === "object" && t in e.target ? e.target[t] : e;
}
function Vk(t, e, n) {
  var r = t.length;
  if (e < 0 || e >= r || n < 0 || n >= r)
    return t;
  var i = t[e], o = e - n;
  return o > 0 ? [].concat(Ye(t.slice(0, n)), [i], Ye(t.slice(n, e)), Ye(t.slice(e + 1, r))) : o < 0 ? [].concat(Ye(t.slice(0, e)), Ye(t.slice(e + 1, n + 1)), [i], Ye(t.slice(n + 1, r))) : t;
}
var hye = ["name"], Na = [];
function Bk(t, e, n, r, i, o) {
  return typeof t == "function" ? t(e, n, "source" in o ? {
    source: o.source
  } : {}) : r !== i;
}
var IA = /* @__PURE__ */ function(t) {
  Pr(n, t);
  var e = Hr(n);
  function n(r) {
    var i;
    if (zn(this, n), i = e.call(this, r), z(It(i), "state", {
      resetCount: 0
    }), z(It(i), "cancelRegisterFunc", null), z(It(i), "mounted", !1), z(It(i), "touched", !1), z(It(i), "dirty", !1), z(It(i), "validatePromise", void 0), z(It(i), "prevValidating", void 0), z(It(i), "errors", Na), z(It(i), "warnings", Na), z(It(i), "cancelRegister", function() {
      var u = i.props, l = u.preserve, c = u.isListField, d = u.name;
      i.cancelRegisterFunc && i.cancelRegisterFunc(c, l, ri(d)), i.cancelRegisterFunc = null;
    }), z(It(i), "getNamePath", function() {
      var u = i.props, l = u.name, c = u.fieldContext, d = c.prefixName, f = d === void 0 ? [] : d;
      return l !== void 0 ? [].concat(Ye(f), Ye(l)) : [];
    }), z(It(i), "getRules", function() {
      var u = i.props, l = u.rules, c = l === void 0 ? [] : l, d = u.fieldContext;
      return c.map(function(f) {
        return typeof f == "function" ? f(d) : f;
      });
    }), z(It(i), "refresh", function() {
      i.mounted && i.setState(function(u) {
        var l = u.resetCount;
        return {
          resetCount: l + 1
        };
      });
    }), z(It(i), "metaCache", null), z(It(i), "triggerMetaEvent", function(u) {
      var l = i.props.onMetaChange;
      if (l) {
        var c = de(de({}, i.getMeta()), {}, {
          destroy: u
        });
        np(i.metaCache, c) || l(c), i.metaCache = c;
      } else
        i.metaCache = null;
    }), z(It(i), "onStoreChange", function(u, l, c) {
      var d = i.props, f = d.shouldUpdate, h = d.dependencies, p = h === void 0 ? [] : h, v = d.onReset, m = c.store, b = i.getNamePath(), y = i.getValue(u), w = i.getValue(m), S = l && Lh(l, b);
      switch (c.type === "valueUpdate" && c.source === "external" && y !== w && (i.touched = !0, i.dirty = !0, i.validatePromise = null, i.errors = Na, i.warnings = Na, i.triggerMetaEvent()), c.type) {
        case "reset":
          if (!l || S) {
            i.touched = !1, i.dirty = !1, i.validatePromise = void 0, i.errors = Na, i.warnings = Na, i.triggerMetaEvent(), v == null || v(), i.refresh();
            return;
          }
          break;
        case "remove": {
          if (f) {
            i.reRender();
            return;
          }
          break;
        }
        case "setField": {
          var E = c.data;
          if (S) {
            "touched" in E && (i.touched = E.touched), "validating" in E && !("originRCField" in E) && (i.validatePromise = E.validating ? Promise.resolve([]) : null), "errors" in E && (i.errors = E.errors || Na), "warnings" in E && (i.warnings = E.warnings || Na), i.dirty = !0, i.triggerMetaEvent(), i.reRender();
            return;
          } else if ("value" in E && Lh(l, b, !0)) {
            i.reRender();
            return;
          }
          if (f && !b.length && Bk(f, u, m, y, w, c)) {
            i.reRender();
            return;
          }
          break;
        }
        case "dependenciesUpdate": {
          var I = p.map(ri);
          if (I.some(function(_) {
            return Lh(c.relatedFields, _);
          })) {
            i.reRender();
            return;
          }
          break;
        }
        default:
          if (S || (!p.length || b.length || f) && Bk(f, u, m, y, w, c)) {
            i.reRender();
            return;
          }
          break;
      }
      f === !0 && i.reRender();
    }), z(It(i), "validateRules", function(u) {
      var l = i.getNamePath(), c = i.getValue(), d = u || {}, f = d.triggerName, h = d.validateOnly, p = h === void 0 ? !1 : h, v = Promise.resolve().then(/* @__PURE__ */ ul(/* @__PURE__ */ ai().mark(function m() {
        var b, y, w, S, E, I, _;
        return ai().wrap(function(P) {
          for (; ; )
            switch (P.prev = P.next) {
              case 0:
                if (i.mounted) {
                  P.next = 2;
                  break;
                }
                return P.abrupt("return", []);
              case 2:
                if (b = i.props, y = b.validateFirst, w = y === void 0 ? !1 : y, S = b.messageVariables, E = b.validateDebounce, I = i.getRules(), f && (I = I.filter(function(N) {
                  return N;
                }).filter(function(N) {
                  var k = N.validateTrigger;
                  if (!k)
                    return !0;
                  var D = MI(k);
                  return D.includes(f);
                })), !(E && f)) {
                  P.next = 10;
                  break;
                }
                return P.next = 8, new Promise(function(N) {
                  setTimeout(N, E);
                });
              case 8:
                if (i.validatePromise === v) {
                  P.next = 10;
                  break;
                }
                return P.abrupt("return", []);
              case 10:
                return _ = uye(l, c, I, u, w, S), _.catch(function(N) {
                  return N;
                }).then(function() {
                  var N = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : Na;
                  if (i.validatePromise === v) {
                    var k;
                    i.validatePromise = null;
                    var D = [], R = [];
                    (k = N.forEach) === null || k === void 0 || k.call(N, function(V) {
                      var $ = V.rule.warningOnly, F = V.errors, M = F === void 0 ? Na : F;
                      $ ? R.push.apply(R, Ye(M)) : D.push.apply(D, Ye(M));
                    }), i.errors = D, i.warnings = R, i.triggerMetaEvent(), i.reRender();
                  }
                }), P.abrupt("return", _);
              case 13:
              case "end":
                return P.stop();
            }
        }, m);
      })));
      return p || (i.validatePromise = v, i.dirty = !0, i.errors = Na, i.warnings = Na, i.triggerMetaEvent(), i.reRender()), v;
    }), z(It(i), "isFieldValidating", function() {
      return !!i.validatePromise;
    }), z(It(i), "isFieldTouched", function() {
      return i.touched;
    }), z(It(i), "isFieldDirty", function() {
      if (i.dirty || i.props.initialValue !== void 0)
        return !0;
      var u = i.props.fieldContext, l = u.getInternalHooks(cd), c = l.getInitialValue;
      return c(i.getNamePath()) !== void 0;
    }), z(It(i), "getErrors", function() {
      return i.errors;
    }), z(It(i), "getWarnings", function() {
      return i.warnings;
    }), z(It(i), "isListField", function() {
      return i.props.isListField;
    }), z(It(i), "isList", function() {
      return i.props.isList;
    }), z(It(i), "isPreserve", function() {
      return i.props.preserve;
    }), z(It(i), "getMeta", function() {
      i.prevValidating = i.isFieldValidating();
      var u = {
        touched: i.isFieldTouched(),
        validating: i.prevValidating,
        errors: i.errors,
        warnings: i.warnings,
        name: i.getNamePath(),
        validated: i.validatePromise === null
      };
      return u;
    }), z(It(i), "getOnlyChild", function(u) {
      if (typeof u == "function") {
        var l = i.getMeta();
        return de(de({}, i.getOnlyChild(u(i.getControlled(), l, i.props.fieldContext))), {}, {
          isFunction: !0
        });
      }
      var c = Xa(u);
      return c.length !== 1 || !/* @__PURE__ */ x.isValidElement(c[0]) ? {
        child: c,
        isFunction: !1
      } : {
        child: c[0],
        isFunction: !1
      };
    }), z(It(i), "getValue", function(u) {
      var l = i.props.fieldContext.getFieldsValue, c = i.getNamePath();
      return _s(u || l(!0), c);
    }), z(It(i), "getControlled", function() {
      var u = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, l = i.props, c = l.trigger, d = l.validateTrigger, f = l.getValueFromEvent, h = l.normalize, p = l.valuePropName, v = l.getValueProps, m = l.fieldContext, b = d !== void 0 ? d : m.validateTrigger, y = i.getNamePath(), w = m.getInternalHooks, S = m.getFieldsValue, E = w(cd), I = E.dispatch, _ = i.getValue(), A = v || function(D) {
        return z({}, p, D);
      }, P = u[c], N = de(de({}, u), A(_));
      N[c] = function() {
        i.touched = !0, i.dirty = !0, i.triggerMetaEvent();
        for (var D, R = arguments.length, V = new Array(R), $ = 0; $ < R; $++)
          V[$] = arguments[$];
        f ? D = f.apply(void 0, V) : D = fye.apply(void 0, [p].concat(V)), h && (D = h(D, _, S(!0))), I({
          type: "updateValue",
          namePath: y,
          value: D
        }), P && P.apply(void 0, V);
      };
      var k = MI(b || []);
      return k.forEach(function(D) {
        var R = N[D];
        N[D] = function() {
          R && R.apply(void 0, arguments);
          var V = i.props.rules;
          V && V.length && I({
            type: "validateField",
            namePath: y,
            triggerName: D
          });
        };
      }), N;
    }), r.fieldContext) {
      var o = r.fieldContext.getInternalHooks, a = o(cd), s = a.initEntityValue;
      s(It(i));
    }
    return i;
  }
  return Gn(n, [{
    key: "componentDidMount",
    value: function() {
      var i = this.props, o = i.shouldUpdate, a = i.fieldContext;
      if (this.mounted = !0, a) {
        var s = a.getInternalHooks, u = s(cd), l = u.registerField;
        this.cancelRegisterFunc = l(this);
      }
      o === !0 && this.reRender();
    }
  }, {
    key: "componentWillUnmount",
    value: function() {
      this.cancelRegister(), this.triggerMetaEvent(!0), this.mounted = !1;
    }
  }, {
    key: "reRender",
    value: function() {
      this.mounted && this.forceUpdate();
    }
  }, {
    key: "render",
    value: function() {
      var i = this.state.resetCount, o = this.props.children, a = this.getOnlyChild(o), s = a.child, u = a.isFunction, l;
      return u ? l = s : /* @__PURE__ */ x.isValidElement(s) ? l = /* @__PURE__ */ x.cloneElement(s, this.getControlled(s.props)) : (Wt(!s, "`children` of Field is not validate ReactElement."), l = s), /* @__PURE__ */ x.createElement(x.Fragment, {
        key: i
      }, l);
    }
  }]), n;
}(x.Component);
z(IA, "contextType", Nd);
z(IA, "defaultProps", {
  trigger: "onChange",
  valuePropName: "value"
});
function _A(t) {
  var e = t.name, n = Gt(t, hye), r = x.useContext(Nd), i = x.useContext(j0), o = e !== void 0 ? ri(e) : void 0, a = "keep";
  return n.isListField || (a = "_".concat((o || []).join("_"))), process.env.NODE_ENV !== "production" && n.preserve === !1 && n.isListField && o.length <= 1 && Wt(!1, "`preserve` should not apply on Form.List fields."), /* @__PURE__ */ x.createElement(IA, G({
    key: a,
    name: o,
    isListField: !!i
  }, n, {
    fieldContext: r
  }));
}
function pG(t) {
  var e = t.name, n = t.initialValue, r = t.children, i = t.rules, o = t.validateTrigger, a = t.isListField, s = x.useContext(Nd), u = x.useContext(j0), l = x.useRef({
    keys: [],
    id: 0
  }), c = l.current, d = x.useMemo(function() {
    var v = ri(s.prefixName) || [];
    return [].concat(Ye(v), Ye(ri(e)));
  }, [s.prefixName, e]), f = x.useMemo(function() {
    return de(de({}, s), {}, {
      prefixName: d
    });
  }, [s, d]), h = x.useMemo(function() {
    return {
      getKey: function(m) {
        var b = d.length, y = m[b];
        return [c.keys[y], m.slice(b + 1)];
      }
    };
  }, [d]);
  if (typeof r != "function")
    return Wt(!1, "Form.List only accepts function as children."), null;
  var p = function(m, b, y) {
    var w = y.source;
    return w === "internal" ? !1 : m !== b;
  };
  return /* @__PURE__ */ x.createElement(j0.Provider, {
    value: h
  }, /* @__PURE__ */ x.createElement(Nd.Provider, {
    value: f
  }, /* @__PURE__ */ x.createElement(_A, {
    name: [],
    shouldUpdate: p,
    rules: i,
    validateTrigger: o,
    initialValue: n,
    isList: !0,
    isListField: a ?? !!u
  }, function(v, m) {
    var b = v.value, y = b === void 0 ? [] : b, w = v.onChange, S = s.getFieldValue, E = function() {
      var P = S(d || []);
      return P || [];
    }, I = {
      add: function(P, N) {
        var k = E();
        N >= 0 && N <= k.length ? (c.keys = [].concat(Ye(c.keys.slice(0, N)), [c.id], Ye(c.keys.slice(N))), w([].concat(Ye(k.slice(0, N)), [P], Ye(k.slice(N))))) : (process.env.NODE_ENV !== "production" && (N < 0 || N > k.length) && Wt(!1, "The second parameter of the add function should be a valid positive number."), c.keys = [].concat(Ye(c.keys), [c.id]), w([].concat(Ye(k), [P]))), c.id += 1;
      },
      remove: function(P) {
        var N = E(), k = new Set(Array.isArray(P) ? P : [P]);
        k.size <= 0 || (c.keys = c.keys.filter(function(D, R) {
          return !k.has(R);
        }), w(N.filter(function(D, R) {
          return !k.has(R);
        })));
      },
      move: function(P, N) {
        if (P !== N) {
          var k = E();
          P < 0 || P >= k.length || N < 0 || N >= k.length || (c.keys = Vk(c.keys, P, N), w(Vk(k, P, N)));
        }
      }
    }, _ = y || [];
    return Array.isArray(_) || (_ = [], process.env.NODE_ENV !== "production" && Wt(!1, "Current value of '".concat(d.join(" > "), "' is not an array type."))), r(_.map(function(A, P) {
      var N = c.keys[P];
      return N === void 0 && (c.keys[P] = c.id, N = c.keys[P], c.id += 1), {
        name: P,
        key: N,
        isListField: !0
      };
    }), I, m);
  })));
}
function pye(t) {
  var e = !1, n = t.length, r = [];
  return t.length ? new Promise(function(i, o) {
    t.forEach(function(a, s) {
      a.catch(function(u) {
        return e = !0, u;
      }).then(function(u) {
        n -= 1, r[s] = u, !(n > 0) && (e && o(r), i(r));
      });
    });
  }) : Promise.resolve([]);
}
var gG = "__@field_split__";
function BS(t) {
  return t.map(function(e) {
    return "".concat(_t(e), ":").concat(e);
  }).join(gG);
}
var $f = /* @__PURE__ */ function() {
  function t() {
    zn(this, t), z(this, "kvs", /* @__PURE__ */ new Map());
  }
  return Gn(t, [{
    key: "set",
    value: function(n, r) {
      this.kvs.set(BS(n), r);
    }
  }, {
    key: "get",
    value: function(n) {
      return this.kvs.get(BS(n));
    }
  }, {
    key: "update",
    value: function(n, r) {
      var i = this.get(n), o = r(i);
      o ? this.set(n, o) : this.delete(n);
    }
  }, {
    key: "delete",
    value: function(n) {
      this.kvs.delete(BS(n));
    }
    // Since we only use this in test, let simply realize this
  }, {
    key: "map",
    value: function(n) {
      return Ye(this.kvs.entries()).map(function(r) {
        var i = be(r, 2), o = i[0], a = i[1], s = o.split(gG);
        return n({
          key: s.map(function(u) {
            var l = u.match(/^([^:]*):(.*)$/), c = be(l, 3), d = c[1], f = c[2];
            return d === "number" ? Number(f) : f;
          }),
          value: a
        });
      });
    }
  }, {
    key: "toJSON",
    value: function() {
      var n = {};
      return this.map(function(r) {
        var i = r.key, o = r.value;
        return n[i.join(".")] = o, null;
      }), n;
    }
  }]), t;
}(), gye = ["name"], mye = /* @__PURE__ */ Gn(function t(e) {
  var n = this;
  zn(this, t), z(this, "formHooked", !1), z(this, "forceRootUpdate", void 0), z(this, "subscribable", !0), z(this, "store", {}), z(this, "fieldEntities", []), z(this, "initialValues", {}), z(this, "callbacks", {}), z(this, "validateMessages", null), z(this, "preserve", null), z(this, "lastValidatePromise", null), z(this, "getForm", function() {
    return {
      getFieldValue: n.getFieldValue,
      getFieldsValue: n.getFieldsValue,
      getFieldError: n.getFieldError,
      getFieldWarning: n.getFieldWarning,
      getFieldsError: n.getFieldsError,
      isFieldsTouched: n.isFieldsTouched,
      isFieldTouched: n.isFieldTouched,
      isFieldValidating: n.isFieldValidating,
      isFieldsValidating: n.isFieldsValidating,
      resetFields: n.resetFields,
      setFields: n.setFields,
      setFieldValue: n.setFieldValue,
      setFieldsValue: n.setFieldsValue,
      validateFields: n.validateFields,
      submit: n.submit,
      _init: !0,
      getInternalHooks: n.getInternalHooks
    };
  }), z(this, "getInternalHooks", function(r) {
    return r === cd ? (n.formHooked = !0, {
      dispatch: n.dispatch,
      initEntityValue: n.initEntityValue,
      registerField: n.registerField,
      useSubscribe: n.useSubscribe,
      setInitialValues: n.setInitialValues,
      destroyForm: n.destroyForm,
      setCallbacks: n.setCallbacks,
      setValidateMessages: n.setValidateMessages,
      getFields: n.getFields,
      setPreserve: n.setPreserve,
      getInitialValue: n.getInitialValue,
      registerWatch: n.registerWatch
    }) : (Wt(!1, "`getInternalHooks` is internal usage. Should not call directly."), null);
  }), z(this, "useSubscribe", function(r) {
    n.subscribable = r;
  }), z(this, "prevWithoutPreserves", null), z(this, "setInitialValues", function(r, i) {
    if (n.initialValues = r || {}, i) {
      var o, a = Sh(r, n.store);
      (o = n.prevWithoutPreserves) === null || o === void 0 || o.map(function(s) {
        var u = s.key;
        a = bs(a, u, _s(r, u));
      }), n.prevWithoutPreserves = null, n.updateStore(a);
    }
  }), z(this, "destroyForm", function() {
    var r = new $f();
    n.getFieldEntities(!0).forEach(function(i) {
      n.isMergedPreserve(i.isPreserve()) || r.set(i.getNamePath(), !0);
    }), n.prevWithoutPreserves = r;
  }), z(this, "getInitialValue", function(r) {
    var i = _s(n.initialValues, r);
    return r.length ? Sh(i) : i;
  }), z(this, "setCallbacks", function(r) {
    n.callbacks = r;
  }), z(this, "setValidateMessages", function(r) {
    n.validateMessages = r;
  }), z(this, "setPreserve", function(r) {
    n.preserve = r;
  }), z(this, "watchList", []), z(this, "registerWatch", function(r) {
    return n.watchList.push(r), function() {
      n.watchList = n.watchList.filter(function(i) {
        return i !== r;
      });
    };
  }), z(this, "notifyWatch", function() {
    var r = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [];
    if (n.watchList.length) {
      var i = n.getFieldsValue(), o = n.getFieldsValue(!0);
      n.watchList.forEach(function(a) {
        a(i, o, r);
      });
    }
  }), z(this, "timeoutId", null), z(this, "warningUnhooked", function() {
    process.env.NODE_ENV !== "production" && !n.timeoutId && typeof window < "u" && (n.timeoutId = setTimeout(function() {
      n.timeoutId = null, n.formHooked || Wt(!1, "Instance created by `useForm` is not connected to any Form element. Forget to pass `form` prop?");
    }));
  }), z(this, "updateStore", function(r) {
    n.store = r;
  }), z(this, "getFieldEntities", function() {
    var r = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : !1;
    return r ? n.fieldEntities.filter(function(i) {
      return i.getNamePath().length;
    }) : n.fieldEntities;
  }), z(this, "getFieldsMap", function() {
    var r = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : !1, i = new $f();
    return n.getFieldEntities(r).forEach(function(o) {
      var a = o.getNamePath();
      i.set(a, o);
    }), i;
  }), z(this, "getFieldEntitiesForNamePathList", function(r) {
    if (!r)
      return n.getFieldEntities(!0);
    var i = n.getFieldsMap(!0);
    return r.map(function(o) {
      var a = ri(o);
      return i.get(a) || {
        INVALIDATE_NAME_PATH: ri(o)
      };
    });
  }), z(this, "getFieldsValue", function(r, i) {
    n.warningUnhooked();
    var o, a, s;
    if (r === !0 || Array.isArray(r) ? (o = r, a = i) : r && _t(r) === "object" && (s = r.strict, a = r.filter), o === !0 && !a)
      return n.store;
    var u = n.getFieldEntitiesForNamePathList(Array.isArray(o) ? o : null), l = [];
    return u.forEach(function(c) {
      var d, f, h = "INVALIDATE_NAME_PATH" in c ? c.INVALIDATE_NAME_PATH : c.getNamePath();
      if (s) {
        var p, v;
        if ((p = (v = c).isList) !== null && p !== void 0 && p.call(v))
          return;
      } else if (!o && (d = (f = c).isListField) !== null && d !== void 0 && d.call(f))
        return;
      if (!a)
        l.push(h);
      else {
        var m = "getMeta" in c ? c.getMeta() : null;
        a(m) && l.push(h);
      }
    }), Lk(n.store, l.map(ri));
  }), z(this, "getFieldValue", function(r) {
    n.warningUnhooked();
    var i = ri(r);
    return _s(n.store, i);
  }), z(this, "getFieldsError", function(r) {
    n.warningUnhooked();
    var i = n.getFieldEntitiesForNamePathList(r);
    return i.map(function(o, a) {
      return o && !("INVALIDATE_NAME_PATH" in o) ? {
        name: o.getNamePath(),
        errors: o.getErrors(),
        warnings: o.getWarnings()
      } : {
        name: ri(r[a]),
        errors: [],
        warnings: []
      };
    });
  }), z(this, "getFieldError", function(r) {
    n.warningUnhooked();
    var i = ri(r), o = n.getFieldsError([i])[0];
    return o.errors;
  }), z(this, "getFieldWarning", function(r) {
    n.warningUnhooked();
    var i = ri(r), o = n.getFieldsError([i])[0];
    return o.warnings;
  }), z(this, "isFieldsTouched", function() {
    n.warningUnhooked();
    for (var r = arguments.length, i = new Array(r), o = 0; o < r; o++)
      i[o] = arguments[o];
    var a = i[0], s = i[1], u, l = !1;
    i.length === 0 ? u = null : i.length === 1 ? Array.isArray(a) ? (u = a.map(ri), l = !1) : (u = null, l = a) : (u = a.map(ri), l = s);
    var c = n.getFieldEntities(!0), d = function(m) {
      return m.isFieldTouched();
    };
    if (!u)
      return l ? c.every(d) : c.some(d);
    var f = new $f();
    u.forEach(function(v) {
      f.set(v, []);
    }), c.forEach(function(v) {
      var m = v.getNamePath();
      u.forEach(function(b) {
        b.every(function(y, w) {
          return m[w] === y;
        }) && f.update(b, function(y) {
          return [].concat(Ye(y), [v]);
        });
      });
    });
    var h = function(m) {
      return m.some(d);
    }, p = f.map(function(v) {
      var m = v.value;
      return m;
    });
    return l ? p.every(h) : p.some(h);
  }), z(this, "isFieldTouched", function(r) {
    return n.warningUnhooked(), n.isFieldsTouched([r]);
  }), z(this, "isFieldsValidating", function(r) {
    n.warningUnhooked();
    var i = n.getFieldEntities();
    if (!r)
      return i.some(function(a) {
        return a.isFieldValidating();
      });
    var o = r.map(ri);
    return i.some(function(a) {
      var s = a.getNamePath();
      return Lh(o, s) && a.isFieldValidating();
    });
  }), z(this, "isFieldValidating", function(r) {
    return n.warningUnhooked(), n.isFieldsValidating([r]);
  }), z(this, "resetWithFieldInitialValue", function() {
    var r = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, i = new $f(), o = n.getFieldEntities(!0);
    o.forEach(function(u) {
      var l = u.props.initialValue, c = u.getNamePath();
      if (l !== void 0) {
        var d = i.get(c) || /* @__PURE__ */ new Set();
        d.add({
          entity: u,
          value: l
        }), i.set(c, d);
      }
    });
    var a = function(l) {
      l.forEach(function(c) {
        var d = c.props.initialValue;
        if (d !== void 0) {
          var f = c.getNamePath(), h = n.getInitialValue(f);
          if (h !== void 0)
            Wt(!1, "Form already set 'initialValues' with path '".concat(f.join("."), "'. Field can not overwrite it."));
          else {
            var p = i.get(f);
            if (p && p.size > 1)
              Wt(!1, "Multiple Field with path '".concat(f.join("."), "' set 'initialValue'. Can not decide which one to pick."));
            else if (p) {
              var v = n.getFieldValue(f);
              (!r.skipExist || v === void 0) && n.updateStore(bs(n.store, f, Ye(p)[0].value));
            }
          }
        }
      });
    }, s;
    r.entities ? s = r.entities : r.namePathList ? (s = [], r.namePathList.forEach(function(u) {
      var l = i.get(u);
      if (l) {
        var c;
        (c = s).push.apply(c, Ye(Ye(l).map(function(d) {
          return d.entity;
        })));
      }
    })) : s = o, a(s);
  }), z(this, "resetFields", function(r) {
    n.warningUnhooked();
    var i = n.store;
    if (!r) {
      n.updateStore(Sh(n.initialValues)), n.resetWithFieldInitialValue(), n.notifyObservers(i, null, {
        type: "reset"
      }), n.notifyWatch();
      return;
    }
    var o = r.map(ri);
    o.forEach(function(a) {
      var s = n.getInitialValue(a);
      n.updateStore(bs(n.store, a, s));
    }), n.resetWithFieldInitialValue({
      namePathList: o
    }), n.notifyObservers(i, o, {
      type: "reset"
    }), n.notifyWatch(o);
  }), z(this, "setFields", function(r) {
    n.warningUnhooked();
    var i = n.store, o = [];
    r.forEach(function(a) {
      var s = a.name, u = Gt(a, gye), l = ri(s);
      o.push(l), "value" in u && n.updateStore(bs(n.store, l, u.value)), n.notifyObservers(i, [l], {
        type: "setField",
        data: a
      });
    }), n.notifyWatch(o);
  }), z(this, "getFields", function() {
    var r = n.getFieldEntities(!0), i = r.map(function(o) {
      var a = o.getNamePath(), s = o.getMeta(), u = de(de({}, s), {}, {
        name: a,
        value: n.getFieldValue(a)
      });
      return Object.defineProperty(u, "originRCField", {
        value: !0
      }), u;
    });
    return i;
  }), z(this, "initEntityValue", function(r) {
    var i = r.props.initialValue;
    if (i !== void 0) {
      var o = r.getNamePath(), a = _s(n.store, o);
      a === void 0 && n.updateStore(bs(n.store, o, i));
    }
  }), z(this, "isMergedPreserve", function(r) {
    var i = r !== void 0 ? r : n.preserve;
    return i ?? !0;
  }), z(this, "registerField", function(r) {
    n.fieldEntities.push(r);
    var i = r.getNamePath();
    if (n.notifyWatch([i]), r.props.initialValue !== void 0) {
      var o = n.store;
      n.resetWithFieldInitialValue({
        entities: [r],
        skipExist: !0
      }), n.notifyObservers(o, [r.getNamePath()], {
        type: "valueUpdate",
        source: "internal"
      });
    }
    return function(a, s) {
      var u = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : [];
      if (n.fieldEntities = n.fieldEntities.filter(function(d) {
        return d !== r;
      }), !n.isMergedPreserve(s) && (!a || u.length > 1)) {
        var l = a ? void 0 : n.getInitialValue(i);
        if (i.length && n.getFieldValue(i) !== l && n.fieldEntities.every(function(d) {
          return (
            // Only reset when no namePath exist
            !hG(d.getNamePath(), i)
          );
        })) {
          var c = n.store;
          n.updateStore(bs(c, i, l, !0)), n.notifyObservers(c, [i], {
            type: "remove"
          }), n.triggerDependenciesUpdate(c, i);
        }
      }
      n.notifyWatch([i]);
    };
  }), z(this, "dispatch", function(r) {
    switch (r.type) {
      case "updateValue": {
        var i = r.namePath, o = r.value;
        n.updateValue(i, o);
        break;
      }
      case "validateField": {
        var a = r.namePath, s = r.triggerName;
        n.validateFields([a], {
          triggerName: s
        });
        break;
      }
    }
  }), z(this, "notifyObservers", function(r, i, o) {
    if (n.subscribable) {
      var a = de(de({}, o), {}, {
        store: n.getFieldsValue(!0)
      });
      n.getFieldEntities().forEach(function(s) {
        var u = s.onStoreChange;
        u(r, i, a);
      });
    } else
      n.forceRootUpdate();
  }), z(this, "triggerDependenciesUpdate", function(r, i) {
    var o = n.getDependencyChildrenFields(i);
    return o.length && n.validateFields(o), n.notifyObservers(r, o, {
      type: "dependenciesUpdate",
      relatedFields: [i].concat(Ye(o))
    }), o;
  }), z(this, "updateValue", function(r, i) {
    var o = ri(r), a = n.store;
    n.updateStore(bs(n.store, o, i)), n.notifyObservers(a, [o], {
      type: "valueUpdate",
      source: "internal"
    }), n.notifyWatch([o]);
    var s = n.triggerDependenciesUpdate(a, o), u = n.callbacks.onValuesChange;
    if (u) {
      var l = Lk(n.store, [o]);
      u(l, n.getFieldsValue());
    }
    n.triggerOnFieldsChange([o].concat(Ye(s)));
  }), z(this, "setFieldsValue", function(r) {
    n.warningUnhooked();
    var i = n.store;
    if (r) {
      var o = Sh(n.store, r);
      n.updateStore(o);
    }
    n.notifyObservers(i, null, {
      type: "valueUpdate",
      source: "external"
    }), n.notifyWatch();
  }), z(this, "setFieldValue", function(r, i) {
    n.setFields([{
      name: r,
      value: i
    }]);
  }), z(this, "getDependencyChildrenFields", function(r) {
    var i = /* @__PURE__ */ new Set(), o = [], a = new $f();
    n.getFieldEntities().forEach(function(u) {
      var l = u.props.dependencies;
      (l || []).forEach(function(c) {
        var d = ri(c);
        a.update(d, function() {
          var f = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : /* @__PURE__ */ new Set();
          return f.add(u), f;
        });
      });
    });
    var s = function u(l) {
      var c = a.get(l) || /* @__PURE__ */ new Set();
      c.forEach(function(d) {
        if (!i.has(d)) {
          i.add(d);
          var f = d.getNamePath();
          d.isFieldDirty() && f.length && (o.push(f), u(f));
        }
      });
    };
    return s(r), o;
  }), z(this, "triggerOnFieldsChange", function(r, i) {
    var o = n.callbacks.onFieldsChange;
    if (o) {
      var a = n.getFields();
      if (i) {
        var s = new $f();
        i.forEach(function(l) {
          var c = l.name, d = l.errors;
          s.set(c, d);
        }), a.forEach(function(l) {
          l.errors = s.get(l.name) || l.errors;
        });
      }
      var u = a.filter(function(l) {
        var c = l.name;
        return Lh(r, c);
      });
      u.length && o(u, a);
    }
  }), z(this, "validateFields", function(r, i) {
    var o;
    n.warningUnhooked();
    var a, s;
    Array.isArray(r) || typeof r == "string" || typeof i == "string" ? (a = r, s = i) : s = r;
    var u = !!a, l = u ? a.map(ri) : [], c = [], d = String(Date.now()), f = /* @__PURE__ */ new Set(), h = (o = s) === null || o === void 0 ? void 0 : o.recursive;
    n.getFieldEntities(!0).forEach(function(b) {
      if (u || l.push(b.getNamePath()), !(!b.props.rules || !b.props.rules.length)) {
        var y = b.getNamePath();
        if (f.add(y.join(d)), !u || Lh(l, y, h)) {
          var w = b.validateRules(de({
            validateMessages: de(de({}, fG), n.validateMessages)
          }, s));
          c.push(w.then(function() {
            return {
              name: y,
              errors: [],
              warnings: []
            };
          }).catch(function(S) {
            var E, I = [], _ = [];
            return (E = S.forEach) === null || E === void 0 || E.call(S, function(A) {
              var P = A.rule.warningOnly, N = A.errors;
              P ? _.push.apply(_, Ye(N)) : I.push.apply(I, Ye(N));
            }), I.length ? Promise.reject({
              name: y,
              errors: I,
              warnings: _
            }) : {
              name: y,
              errors: I,
              warnings: _
            };
          }));
        }
      }
    });
    var p = pye(c);
    n.lastValidatePromise = p, p.catch(function(b) {
      return b;
    }).then(function(b) {
      var y = b.map(function(w) {
        var S = w.name;
        return S;
      });
      n.notifyObservers(n.store, y, {
        type: "validateFinish"
      }), n.triggerOnFieldsChange(y, b);
    });
    var v = p.then(function() {
      return n.lastValidatePromise === p ? Promise.resolve(n.getFieldsValue(l)) : Promise.reject([]);
    }).catch(function(b) {
      var y = b.filter(function(w) {
        return w && w.errors.length;
      });
      return Promise.reject({
        values: n.getFieldsValue(l),
        errorFields: y,
        outOfDate: n.lastValidatePromise !== p
      });
    });
    v.catch(function(b) {
      return b;
    });
    var m = l.filter(function(b) {
      return f.has(b.join(d));
    });
    return n.triggerOnFieldsChange(m), v;
  }), z(this, "submit", function() {
    n.warningUnhooked(), n.validateFields().then(function(r) {
      var i = n.callbacks.onFinish;
      if (i)
        try {
          i(r);
        } catch (o) {
          console.error(o);
        }
    }).catch(function(r) {
      var i = n.callbacks.onFinishFailed;
      i && i(r);
    });
  }), this.forceRootUpdate = e;
});
function AA(t) {
  var e = x.useRef(), n = x.useState({}), r = be(n, 2), i = r[1];
  if (!e.current)
    if (t)
      e.current = t;
    else {
      var o = function() {
        i({});
      }, a = new mye(o);
      e.current = a.getForm();
    }
  return [e.current];
}
var UI = /* @__PURE__ */ x.createContext({
  triggerFormChange: function() {
  },
  triggerFormFinish: function() {
  },
  registerForm: function() {
  },
  unregisterForm: function() {
  }
}), mG = function(e) {
  var n = e.validateMessages, r = e.onFormChange, i = e.onFormFinish, o = e.children, a = x.useContext(UI), s = x.useRef({});
  return /* @__PURE__ */ x.createElement(UI.Provider, {
    value: de(de({}, a), {}, {
      validateMessages: de(de({}, a.validateMessages), n),
      // =========================================================
      // =                  Global Form Control                  =
      // =========================================================
      triggerFormChange: function(l, c) {
        r && r(l, {
          changedFields: c,
          forms: s.current
        }), a.triggerFormChange(l, c);
      },
      triggerFormFinish: function(l, c) {
        i && i(l, {
          values: c,
          forms: s.current
        }), a.triggerFormFinish(l, c);
      },
      registerForm: function(l, c) {
        l && (s.current = de(de({}, s.current), {}, z({}, l, c))), a.registerForm(l, c);
      },
      unregisterForm: function(l) {
        var c = de({}, s.current);
        delete c[l], s.current = c, a.unregisterForm(l);
      }
    })
  }, o);
}, vye = ["name", "initialValues", "fields", "form", "preserve", "children", "component", "validateMessages", "validateTrigger", "onValuesChange", "onFieldsChange", "onFinish", "onFinishFailed"], bye = function(e, n) {
  var r = e.name, i = e.initialValues, o = e.fields, a = e.form, s = e.preserve, u = e.children, l = e.component, c = l === void 0 ? "form" : l, d = e.validateMessages, f = e.validateTrigger, h = f === void 0 ? "onChange" : f, p = e.onValuesChange, v = e.onFieldsChange, m = e.onFinish, b = e.onFinishFailed, y = Gt(e, vye), w = x.useContext(UI), S = AA(a), E = be(S, 1), I = E[0], _ = I.getInternalHooks(cd), A = _.useSubscribe, P = _.setInitialValues, N = _.setCallbacks, k = _.setValidateMessages, D = _.setPreserve, R = _.destroyForm;
  x.useImperativeHandle(n, function() {
    return I;
  }), x.useEffect(function() {
    return w.registerForm(r, I), function() {
      w.unregisterForm(r);
    };
  }, [w, I, r]), k(de(de({}, w.validateMessages), d)), N({
    onValuesChange: p,
    onFieldsChange: function(K) {
      if (w.triggerFormChange(r, K), v) {
        for (var W = arguments.length, Y = new Array(W > 1 ? W - 1 : 0), U = 1; U < W; U++)
          Y[U - 1] = arguments[U];
        v.apply(void 0, [K].concat(Y));
      }
    },
    onFinish: function(K) {
      w.triggerFormFinish(r, K), m && m(K);
    },
    onFinishFailed: b
  }), D(s);
  var V = x.useRef(null);
  P(i, !V.current), V.current || (V.current = !0), x.useEffect(
    function() {
      return R;
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    []
  );
  var $, F = typeof u == "function";
  if (F) {
    var M = I.getFieldsValue(!0);
    $ = u(M, I);
  } else
    $ = u;
  A(!F);
  var B = x.useRef();
  x.useEffect(function() {
    dye(B.current || [], o || []) || I.setFields(o || []), B.current = o;
  }, [o, I]);
  var X = x.useMemo(function() {
    return de(de({}, I), {}, {
      validateTrigger: h
    });
  }, [I, h]), L = /* @__PURE__ */ x.createElement(j0.Provider, {
    value: null
  }, /* @__PURE__ */ x.createElement(Nd.Provider, {
    value: X
  }, $));
  return c === !1 ? L : /* @__PURE__ */ x.createElement(c, G({}, y, {
    onSubmit: function(K) {
      K.preventDefault(), K.stopPropagation(), I.submit();
    },
    onReset: function(K) {
      var W;
      K.preventDefault(), I.resetFields(), (W = y.onReset) === null || W === void 0 || W.call(y, K);
    }
  }), L);
};
function Hk(t) {
  try {
    return JSON.stringify(t);
  } catch {
    return Math.random();
  }
}
var yye = process.env.NODE_ENV !== "production" ? function(t) {
  var e = t.join("__RC_FIELD_FORM_SPLIT__"), n = Ee(e);
  Wt(n.current === e, "`useWatch` is not support dynamic `namePath`. Please provide static instead.");
} : function() {
};
function vG() {
  for (var t = arguments.length, e = new Array(t), n = 0; n < t; n++)
    e[n] = arguments[n];
  var r = e[0], i = r === void 0 ? [] : r, o = e[1], a = o === void 0 ? {} : o, s = Obe(a) ? {
    form: a
  } : a, u = s.form, l = Le(), c = be(l, 2), d = c[0], f = c[1], h = Rn(function() {
    return Hk(d);
  }, [d]), p = Ee(h);
  p.current = h;
  var v = fn(Nd), m = u || v, b = m && m._init;
  process.env.NODE_ENV !== "production" && Wt(e.length === 2 ? u ? b : !0 : b, "useWatch requires a form instance since it can not auto detect from context.");
  var y = ri(i), w = Ee(y);
  return w.current = y, yye(y), Re(
    function() {
      if (b) {
        var S = m.getFieldsValue, E = m.getInternalHooks, I = E(cd), _ = I.registerWatch, A = _(function(N, k) {
          var D = _s(s.preserve ? k : N, w.current), R = Hk(D);
          p.current !== R && (p.current = R, f(D));
        }), P = _s(s.preserve ? S(!0) : S(), w.current);
        return d !== P && f(P), A;
      }
    },
    // We do not need re-register since namePath content is the same
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [b]
  ), d;
}
var xye = /* @__PURE__ */ x.forwardRef(bye), wp = xye;
wp.FormProvider = mG;
wp.Field = _A;
wp.List = pG;
wp.useForm = AA;
wp.useWatch = vG;
var cc = /* @__PURE__ */ x.createContext({
  labelAlign: "right",
  vertical: !1,
  itemRef: function() {
  }
}), bG = /* @__PURE__ */ x.createContext(null), yG = function(e) {
  var n = Pi(e, ["prefixCls"]);
  return /* @__PURE__ */ x.createElement(mG, G({}, n));
}, TA = /* @__PURE__ */ x.createContext({
  prefixCls: ""
}), Ji = /* @__PURE__ */ x.createContext({}), gx = function(e) {
  var n = e.children, r = e.status, i = e.override, o = fn(Ji), a = Rn(function() {
    var s = G({}, o);
    return i && delete s.isFormItemInput, r && (delete s.status, delete s.hasFeedback, delete s.feedbackIcon), s;
  }, [r, i, o]);
  return /* @__PURE__ */ x.createElement(Ji.Provider, {
    value: a
  }, n);
}, Ki = function() {
  for (var e = arguments.length, n = new Array(e), r = 0; r < e; r++)
    n[r] = arguments[r];
  return n;
}, HS = function() {
  return {
    height: 0,
    opacity: 0
  };
}, Wk = function(e) {
  var n = e.scrollHeight;
  return {
    height: n,
    opacity: 1
  };
}, Cye = function(e) {
  return {
    height: e ? e.offsetHeight : 0
  };
}, WS = function(e, n) {
  return (n == null ? void 0 : n.deadline) === !0 || n.propertyName === "height";
}, wye = {
  motionName: "ant-motion-collapse",
  onAppearStart: HS,
  onEnterStart: HS,
  onAppearActive: Wk,
  onEnterActive: Wk,
  onLeaveStart: Cye,
  onLeaveActive: HS,
  onAppearEnd: WS,
  onEnterEnd: WS,
  onLeaveEnd: WS,
  motionDeadline: 500
};
Ki("bottomLeft", "bottomRight", "topLeft", "topRight");
var Eye = function(e) {
  return e !== void 0 && (e === "topLeft" || e === "topRight") ? "slide-down" : "slide-up";
}, OA = function(e, n, r) {
  return r !== void 0 ? r : "".concat(e, "-").concat(n);
};
const mx = wye;
Ki("warning", "error", "");
function aa(t, e, n) {
  return Ce(z(z(z(z(z({}, "".concat(t, "-status-success"), e === "success"), "".concat(t, "-status-warning"), e === "warning"), "".concat(t, "-status-error"), e === "error"), "".concat(t, "-status-validating"), e === "validating"), "".concat(t, "-has-feedback"), n));
}
var Ac = function(e, n) {
  return n || e;
};
function Sye(t) {
  var e = t.suffixIcon, n = t.clearIcon, r = t.menuItemSelectedIcon, i = t.removeIcon, o = t.loading, a = t.multiple, s = t.hasFeedback, u = t.prefixCls, l = t.showArrow, c = t.feedbackIcon, d = n ?? /* @__PURE__ */ x.createElement(Sc, null), f = function(y) {
    return /* @__PURE__ */ x.createElement(x.Fragment, null, l !== !1 && y, s && c);
  }, h = null;
  if (e !== void 0)
    h = f(e);
  else if (o)
    h = f(/* @__PURE__ */ x.createElement(lc, {
      spin: !0
    }));
  else {
    var p = "".concat(u, "-suffix");
    h = function(y) {
      var w = y.open, S = y.showSearch;
      return f(w && S ? /* @__PURE__ */ x.createElement(rA, {
        className: p
      }) : /* @__PURE__ */ x.createElement(cC, {
        className: p
      }));
    };
  }
  var v = null;
  r !== void 0 ? v = r : a ? v = /* @__PURE__ */ x.createElement(GW, null) : v = null;
  var m = null;
  return i !== void 0 ? m = i : m = /* @__PURE__ */ x.createElement(lC, null), {
    clearIcon: d,
    suffixIcon: h,
    itemIcon: v,
    removeIcon: m
  };
}
var xG = function(t, e) {
  var n = {};
  for (var r in t)
    Object.prototype.hasOwnProperty.call(t, r) && e.indexOf(r) < 0 && (n[r] = t[r]);
  if (t != null && typeof Object.getOwnPropertySymbols == "function")
    for (var i = 0, r = Object.getOwnPropertySymbols(t); i < r.length; i++)
      e.indexOf(r[i]) < 0 && Object.prototype.propertyIsEnumerable.call(t, r[i]) && (n[r[i]] = t[r[i]]);
  return n;
}, vC = /* @__PURE__ */ x.createContext(null), Tc = function(e, n) {
  var r = x.useContext(vC), i = x.useMemo(function() {
    if (!r)
      return "";
    var o = r.compactDirection, a = r.isFirstItem, s = r.isLastItem, u = o === "vertical" ? "-vertical-" : "-";
    return Ce(z(z(z(z({}, "".concat(e, "-compact").concat(u, "item"), !0), "".concat(e, "-compact").concat(u, "first-item"), a), "".concat(e, "-compact").concat(u, "last-item"), s), "".concat(e, "-compact").concat(u, "item-rtl"), n === "rtl"));
  }, [e, n, r]);
  return {
    compactSize: r == null ? void 0 : r.compactSize,
    compactDirection: r == null ? void 0 : r.compactDirection,
    compactItemClassnames: i
  };
}, G0 = function(e) {
  var n = e.children;
  return /* @__PURE__ */ x.createElement(vC.Provider, {
    value: null
  }, n);
}, Iye = function(e) {
  var n = e.children, r = xG(e, ["children"]);
  return /* @__PURE__ */ x.createElement(vC.Provider, {
    value: r
  }, n);
}, _ye = function(e) {
  var n = x.useContext(en), r = n.getPrefixCls, i = n.direction, o = e.size, a = o === void 0 ? "middle" : o, s = e.direction, u = e.block, l = e.prefixCls, c = e.className, d = e.children, f = xG(e, ["size", "direction", "block", "prefixCls", "className", "children"]), h = r("space-compact", l), p = Ce(h, z(z(z({}, "".concat(h, "-rtl"), i === "rtl"), "".concat(h, "-block"), u), "".concat(h, "-vertical"), s === "vertical"), c), v = x.useContext(vC), m = Xa(d), b = x.useMemo(function() {
    return m.map(function(y, w) {
      var S = y && y.key || "".concat(h, "-item-").concat(w);
      return /* @__PURE__ */ x.createElement(Iye, {
        key: S,
        compactSize: a,
        compactDirection: s,
        isFirstItem: w === 0 && (!v || (v == null ? void 0 : v.isFirstItem)),
        isLastItem: w === m.length - 1 && (!v || (v == null ? void 0 : v.isLastItem))
      }, y);
    });
  }, [a, m, v]);
  return m.length === 0 ? null : /* @__PURE__ */ x.createElement("div", G({
    className: p
  }, f), b);
}, Aye = function(t, e) {
  var n = {};
  for (var r in t)
    Object.prototype.hasOwnProperty.call(t, r) && e.indexOf(r) < 0 && (n[r] = t[r]);
  if (t != null && typeof Object.getOwnPropertySymbols == "function")
    for (var i = 0, r = Object.getOwnPropertySymbols(t); i < r.length; i++)
      e.indexOf(r[i]) < 0 && Object.prototype.propertyIsEnumerable.call(t, r[i]) && (n[r[i]] = t[r[i]]);
  return n;
}, CG = "SECRET_COMBOBOX_MODE_DO_NOT_USE", Tye = function(e, n) {
  var r = e.prefixCls, i = e.bordered, o = i === void 0 ? !0 : i, a = e.className, s = e.getPopupContainer, u = e.dropdownClassName, l = e.popupClassName, c = e.listHeight, d = c === void 0 ? 256 : c, f = e.placement, h = e.listItemHeight, p = h === void 0 ? 24 : h, v = e.size, m = e.disabled, b = e.notFoundContent, y = e.status, w = e.showArrow, S = Aye(e, ["prefixCls", "bordered", "className", "getPopupContainer", "dropdownClassName", "popupClassName", "listHeight", "placement", "listItemHeight", "size", "disabled", "notFoundContent", "status", "showArrow"]), E = x.useContext(en), I = E.getPopupContainer, _ = E.getPrefixCls, A = E.renderEmpty, P = E.direction, N = E.virtual, k = E.dropdownMatchSelectWidth, D = x.useContext(qa), R = _("select", r), V = _(), $ = Tc(R, P), F = $.compactSize, M = $.compactItemClassnames, B = x.useMemo(function() {
    var ne = S.mode;
    if (ne !== "combobox")
      return ne === CG ? "combobox" : ne;
  }, [S.mode]), X = B === "multiple" || B === "tags", L = w !== void 0 ? w : S.loading || !(X || B === "combobox");
  process.env.NODE_ENV !== "production" && gn(!u, "Select", "`dropdownClassName` is deprecated which will be removed in next major version. Please use `popupClassName` instead.");
  var j = fn(Ji), K = j.status, W = j.hasFeedback, Y = j.isFormItemInput, U = j.feedbackIcon, Q = Ac(K, y), Z;
  b !== void 0 ? Z = b : B === "combobox" ? Z = null : Z = (A || lG)("Select");
  var ee = Sye(G(G({}, S), {
    multiple: X,
    hasFeedback: W,
    feedbackIcon: U,
    showArrow: L,
    prefixCls: R
  })), ie = ee.suffixIcon, oe = ee.itemIcon, se = ee.removeIcon, te = ee.clearIcon, ge = Pi(S, ["suffixIcon", "itemIcon"]), he = Ce(l || u, z({}, "".concat(R, "-dropdown-").concat(P), P === "rtl")), fe = F || v || D, _e = x.useContext(Ka), Ne = m ?? _e, ze = Ce(z(z(z(z(z({}, "".concat(R, "-lg"), fe === "large"), "".concat(R, "-sm"), fe === "small"), "".concat(R, "-rtl"), P === "rtl"), "".concat(R, "-borderless"), !o), "".concat(R, "-in-form-item"), Y), aa(R, Q, W), M, a), Ve = function() {
    return f !== void 0 ? f : P === "rtl" ? "bottomRight" : "bottomLeft";
  };
  return /* @__PURE__ */ x.createElement(EA, G({
    ref: n,
    virtual: N,
    dropdownMatchSelectWidth: k
  }, ge, {
    transitionName: OA(V, Eye(f), S.transitionName),
    listHeight: d,
    listItemHeight: p,
    mode: B,
    prefixCls: R,
    placement: Ve(),
    direction: P,
    inputIcon: ie,
    menuItemSelectedIcon: oe,
    removeIcon: se,
    clearIcon: te,
    notFoundContent: Z,
    className: ze,
    getPopupContainer: s || I,
    dropdownClassName: he,
    showArrow: W || w,
    disabled: Ne
  }));
}, bC = /* @__PURE__ */ x.forwardRef(Tye);
bC.SECRET_COMBOBOX_MODE_DO_NOT_USE = CG;
bC.Option = wA;
bC.OptGroup = CA;
const As = bC;
var XI = As.Option;
function jk(t) {
  return t && t.type && (t.type.isSelectOption || t.type.isSelectOptGroup);
}
var Oye = function(e, n) {
  var r = e.prefixCls, i = e.className, o = e.popupClassName, a = e.dropdownClassName, s = e.children, u = e.dataSource, l = Xa(s), c;
  if (l.length === 1 && pa(l[0]) && !jk(l[0])) {
    var d = be(l, 1);
    c = d[0];
  }
  var f = c ? function() {
    return c;
  } : void 0, h;
  return l.length && jk(l[0]) ? h = s : h = u ? u.map(function(p) {
    if (pa(p))
      return p;
    switch (_t(p)) {
      case "string":
        return /* @__PURE__ */ x.createElement(XI, {
          key: p,
          value: p
        }, p);
      case "object": {
        var v = p.value;
        return /* @__PURE__ */ x.createElement(XI, {
          key: v,
          value: v
        }, p.text);
      }
      default:
        process.env.NODE_ENV !== "production" && gn(!1, "AutoComplete", "`dataSource` is only supports type `string[] | Object[]`.");
        return;
    }
  }) : [], process.env.NODE_ENV !== "production" && gn(!("dataSource" in e), "AutoComplete", "`dataSource` is deprecated, please use `options` instead."), process.env.NODE_ENV !== "production" && gn(!a, "AutoComplete", "`dropdownClassName` is deprecated which will be removed in next major version. Please use `popupClassName` instead."), process.env.NODE_ENV !== "production" && gn(!c || !("size" in e), "AutoComplete", "You need to control style self instead of setting `size` when using customize input."), /* @__PURE__ */ x.createElement(_c, null, function(p) {
    var v = p.getPrefixCls, m = v("select", r);
    return /* @__PURE__ */ x.createElement(As, G({
      ref: n
    }, Pi(e, ["dataSource"]), {
      prefixCls: m,
      popupClassName: o || a,
      className: Ce("".concat(m, "-auto-complete"), i),
      mode: As.SECRET_COMBOBOX_MODE_DO_NOT_USE
    }, {
      // Internal api
      getInputElement: f
    }), h);
  });
}, wG = /* @__PURE__ */ x.forwardRef(Oye);
wG.Option = XI;
const Pye = wG;
function EG() {
  var t = x.useReducer(function(r) {
    return r + 1;
  }, 0), e = be(t, 2), n = e[1];
  return n;
}
var vx = ["xxl", "xl", "lg", "md", "sm", "xs"], J1 = {
  xs: "(max-width: 575px)",
  sm: "(min-width: 576px)",
  md: "(min-width: 768px)",
  lg: "(min-width: 992px)",
  xl: "(min-width: 1200px)",
  xxl: "(min-width: 1600px)"
}, Yc = /* @__PURE__ */ new Map(), jS = -1, K1 = {}, Nye = {
  matchHandlers: {},
  dispatch: function(e) {
    return K1 = e, Yc.forEach(function(n) {
      return n(K1);
    }), Yc.size >= 1;
  },
  subscribe: function(e) {
    return Yc.size || this.register(), jS += 1, Yc.set(jS, e), e(K1), jS;
  },
  unsubscribe: function(e) {
    Yc.delete(e), Yc.size || this.unregister();
  },
  unregister: function() {
    var e = this;
    Object.keys(J1).forEach(function(n) {
      var r = J1[n], i = e.matchHandlers[r];
      i == null || i.mql.removeListener(i == null ? void 0 : i.listener);
    }), Yc.clear();
  },
  register: function() {
    var e = this;
    Object.keys(J1).forEach(function(n) {
      var r = J1[n], i = function(s) {
        var u = s.matches;
        e.dispatch(G(G({}, K1), z({}, n, u)));
      }, o = window.matchMedia(r);
      o.addListener(i), e.matchHandlers[r] = {
        mql: o,
        listener: i
      }, i(o);
    });
  }
};
const bx = Nye;
function kye() {
  var t = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : !0, e = Ee({}), n = EG();
  return Re(function() {
    var r = bx.subscribe(function(i) {
      e.current = i, t && n();
    });
    return function() {
      return bx.unsubscribe(r);
    };
  }, []), e.current;
}
var zk = function(e) {
  return e ? typeof e == "function" ? e() : e : null;
}, ka = {
  adjustX: 1,
  adjustY: 1
}, Ra = [0, 0], SG = {
  left: {
    points: ["cr", "cl"],
    overflow: ka,
    offset: [-4, 0],
    targetOffset: Ra
  },
  right: {
    points: ["cl", "cr"],
    overflow: ka,
    offset: [4, 0],
    targetOffset: Ra
  },
  top: {
    points: ["bc", "tc"],
    overflow: ka,
    offset: [0, -4],
    targetOffset: Ra
  },
  bottom: {
    points: ["tc", "bc"],
    overflow: ka,
    offset: [0, 4],
    targetOffset: Ra
  },
  topLeft: {
    points: ["bl", "tl"],
    overflow: ka,
    offset: [0, -4],
    targetOffset: Ra
  },
  leftTop: {
    points: ["tr", "tl"],
    overflow: ka,
    offset: [-4, 0],
    targetOffset: Ra
  },
  topRight: {
    points: ["br", "tr"],
    overflow: ka,
    offset: [0, -4],
    targetOffset: Ra
  },
  rightTop: {
    points: ["tl", "tr"],
    overflow: ka,
    offset: [4, 0],
    targetOffset: Ra
  },
  bottomRight: {
    points: ["tr", "br"],
    overflow: ka,
    offset: [0, 4],
    targetOffset: Ra
  },
  rightBottom: {
    points: ["bl", "br"],
    overflow: ka,
    offset: [4, 0],
    targetOffset: Ra
  },
  bottomLeft: {
    points: ["tl", "bl"],
    overflow: ka,
    offset: [0, 4],
    targetOffset: Ra
  },
  leftBottom: {
    points: ["br", "bl"],
    overflow: ka,
    offset: [-4, 0],
    targetOffset: Ra
  }
};
function Rye(t) {
  var e = t.showArrow, n = t.arrowContent, r = t.children, i = t.prefixCls, o = t.id, a = t.overlayInnerStyle, s = t.className, u = t.style;
  return /* @__PURE__ */ x.createElement("div", {
    className: Ce("".concat(i, "-content"), s),
    style: u
  }, e !== !1 && /* @__PURE__ */ x.createElement("div", {
    className: "".concat(i, "-arrow"),
    key: "arrow"
  }, n), /* @__PURE__ */ x.createElement("div", {
    className: "".concat(i, "-inner"),
    id: o,
    role: "tooltip",
    style: a
  }, typeof r == "function" ? r() : r));
}
var $ye = function(e, n) {
  var r = e.overlayClassName, i = e.trigger, o = i === void 0 ? ["hover"] : i, a = e.mouseEnterDelay, s = a === void 0 ? 0 : a, u = e.mouseLeaveDelay, l = u === void 0 ? 0.1 : u, c = e.overlayStyle, d = e.prefixCls, f = d === void 0 ? "rc-tooltip" : d, h = e.children, p = e.onVisibleChange, v = e.afterVisibleChange, m = e.transitionName, b = e.animation, y = e.motion, w = e.placement, S = w === void 0 ? "right" : w, E = e.align, I = E === void 0 ? {} : E, _ = e.destroyTooltipOnHide, A = _ === void 0 ? !1 : _, P = e.defaultVisible, N = e.getTooltipContainer, k = e.overlayInnerStyle, D = e.arrowContent, R = e.overlay, V = e.id, $ = e.showArrow, F = Gt(e, ["overlayClassName", "trigger", "mouseEnterDelay", "mouseLeaveDelay", "overlayStyle", "prefixCls", "children", "onVisibleChange", "afterVisibleChange", "transitionName", "animation", "motion", "placement", "align", "destroyTooltipOnHide", "defaultVisible", "getTooltipContainer", "overlayInnerStyle", "arrowContent", "overlay", "id", "showArrow"]), M = Ee(null);
  wc(n, function() {
    return M.current;
  });
  var B = de({}, F);
  "visible" in e && (B.popupVisible = e.visible);
  var X = function() {
    return /* @__PURE__ */ x.createElement(Rye, {
      showArrow: $,
      arrowContent: D,
      key: "content",
      prefixCls: f,
      id: V,
      overlayInnerStyle: k
    }, R);
  }, L = !1, j = !1;
  if (typeof A == "boolean")
    L = A;
  else if (A && _t(A) === "object") {
    var K = A.keepParent;
    L = K === !0, j = K === !1;
  }
  return /* @__PURE__ */ x.createElement(Mm, G({
    popupClassName: r,
    prefixCls: f,
    popup: X,
    action: o,
    builtinPlacements: SG,
    popupPlacement: S,
    ref: M,
    popupAlign: I,
    getPopupContainer: N,
    onPopupVisibleChange: p,
    afterPopupVisibleChange: v,
    popupTransitionName: m,
    popupAnimation: b,
    popupMotion: y,
    defaultPopupVisible: P,
    destroyPopupOnHide: L,
    autoDestroy: j,
    mouseLeaveDelay: l,
    popupStyle: c,
    mouseEnterDelay: s
  }, B), h);
};
const Dye = /* @__PURE__ */ gt($ye);
var Mye = Ki("success", "processing", "error", "default", "warning"), IG = Ki("pink", "red", "yellow", "orange", "cyan", "green", "blue", "purple", "geekblue", "magenta", "volcano", "gold", "lime"), Fye = {
  adjustX: 1,
  adjustY: 1
}, Gk = {
  adjustX: 0,
  adjustY: 0
}, Lye = [0, 0];
function Uk(t) {
  return typeof t == "boolean" ? t ? Fye : Gk : G(G({}, Gk), t);
}
function _G(t) {
  var e = t.arrowWidth, n = e === void 0 ? 4 : e, r = t.horizontalArrowShift, i = r === void 0 ? 16 : r, o = t.verticalArrowShift, a = o === void 0 ? 8 : o, s = t.autoAdjustOverflow, u = t.arrowPointAtCenter, l = {
    left: {
      points: ["cr", "cl"],
      offset: [-4, 0]
    },
    right: {
      points: ["cl", "cr"],
      offset: [4, 0]
    },
    top: {
      points: ["bc", "tc"],
      offset: [0, -4]
    },
    bottom: {
      points: ["tc", "bc"],
      offset: [0, 4]
    },
    topLeft: {
      points: ["bl", "tc"],
      offset: [-(i + n), -4]
    },
    leftTop: {
      points: ["tr", "cl"],
      offset: [-4, -(a + n)]
    },
    topRight: {
      points: ["br", "tc"],
      offset: [i + n, -4]
    },
    rightTop: {
      points: ["tl", "cr"],
      offset: [4, -(a + n)]
    },
    bottomRight: {
      points: ["tr", "bc"],
      offset: [i + n, 4]
    },
    rightBottom: {
      points: ["bl", "cr"],
      offset: [4, a + n]
    },
    bottomLeft: {
      points: ["tl", "bc"],
      offset: [-(i + n), 4]
    },
    leftBottom: {
      points: ["br", "cl"],
      offset: [-4, a + n]
    }
  };
  return Object.keys(l).forEach(function(c) {
    l[c] = u ? G(G({}, l[c]), {
      overflow: Uk(s),
      targetOffset: Lye
    }) : G(G({}, SG[c]), {
      overflow: Uk(s)
    }), l[c].ignoreShake = !0;
  }), l;
}
var Vye = function(t, e) {
  var n = {};
  for (var r in t)
    Object.prototype.hasOwnProperty.call(t, r) && e.indexOf(r) < 0 && (n[r] = t[r]);
  if (t != null && typeof Object.getOwnPropertySymbols == "function")
    for (var i = 0, r = Object.getOwnPropertySymbols(t); i < r.length; i++)
      e.indexOf(r[i]) < 0 && Object.prototype.propertyIsEnumerable.call(t, r[i]) && (n[r[i]] = t[r[i]]);
  return n;
}, Bye = function(e, n) {
  var r = {}, i = G({}, e);
  return n.forEach(function(o) {
    e && o in e && (r[o] = e[o], delete i[o]);
  }), {
    picked: r,
    omitted: i
  };
}, Xk = new RegExp("^(".concat(IG.join("|"), ")(-inverse)?$"));
function Hye(t, e) {
  var n = t.type;
  if ((n.__ANT_BUTTON === !0 || t.type === "button") && t.props.disabled || n.__ANT_SWITCH === !0 && (t.props.disabled || t.props.loading) || n.__ANT_RADIO === !0 && t.props.disabled) {
    var r = Bye(t.props.style, ["position", "left", "right", "top", "bottom", "float", "display", "zIndex"]), i = r.picked, o = r.omitted, a = G(G({
      display: "inline-block"
    }, i), {
      cursor: "not-allowed",
      width: t.props.block ? "100%" : void 0
    }), s = G(G({}, o), {
      pointerEvents: "none"
    }), u = ji(t, {
      style: s,
      className: null
    });
    return /* @__PURE__ */ x.createElement("span", {
      style: a,
      className: Ce(t.props.className, "".concat(e, "-disabled-compatible-wrapper"))
    }, u);
  }
  return t;
}
var AG = /* @__PURE__ */ x.forwardRef(function(t, e) {
  var n = x.useContext(en), r = n.getPopupContainer, i = n.getPrefixCls, o = n.direction;
  process.env.NODE_ENV !== "production" && [["visible", "open"], ["defaultVisible", "defaultOpen"], ["onVisibleChange", "onOpenChange"], ["afterVisibleChange", "afterOpenChange"]].forEach(function(W) {
    var Y = be(W, 2), U = Y[0], Q = Y[1];
    process.env.NODE_ENV !== "production" && gn(!(U in t), "Tooltip", "`".concat(U, "` is deprecated which will be removed in next major version, please use `").concat(Q, "` instead."));
  });
  var a = Tr(!1, {
    value: t.open !== void 0 ? t.open : t.visible,
    defaultValue: t.defaultOpen !== void 0 ? t.defaultOpen : t.defaultVisible
  }), s = be(a, 2), u = s[0], l = s[1], c = function() {
    var Y = t.title, U = t.overlay;
    return !Y && !U && Y !== 0;
  }, d = function(Y) {
    var U, Q;
    l(c() ? !1 : Y), c() || ((U = t.onOpenChange) === null || U === void 0 || U.call(t, Y), (Q = t.onVisibleChange) === null || Q === void 0 || Q.call(t, Y));
  }, f = function() {
    var Y = t.builtinPlacements, U = t.arrowPointAtCenter, Q = U === void 0 ? !1 : U, Z = t.autoAdjustOverflow, ee = Z === void 0 ? !0 : Z;
    return Y || _G({
      arrowPointAtCenter: Q,
      autoAdjustOverflow: ee
    });
  }, h = function(Y, U) {
    var Q = f(), Z = Object.keys(Q).find(function(oe) {
      var se, te;
      return Q[oe].points[0] === ((se = U.points) === null || se === void 0 ? void 0 : se[0]) && Q[oe].points[1] === ((te = U.points) === null || te === void 0 ? void 0 : te[1]);
    });
    if (Z) {
      var ee = Y.getBoundingClientRect(), ie = {
        top: "50%",
        left: "50%"
      };
      /top|Bottom/.test(Z) ? ie.top = "".concat(ee.height - U.offset[1], "px") : /Top|bottom/.test(Z) && (ie.top = "".concat(-U.offset[1], "px")), /left|Right/.test(Z) ? ie.left = "".concat(ee.width - U.offset[0], "px") : /right|Left/.test(Z) && (ie.left = "".concat(-U.offset[0], "px")), Y.style.transformOrigin = "".concat(ie.left, " ").concat(ie.top);
    }
  }, p = function() {
    var Y = t.title, U = t.overlay;
    return Y === 0 ? Y : U || Y || "";
  }, v = t.getPopupContainer, m = t.placement, b = m === void 0 ? "top" : m, y = t.mouseEnterDelay, w = y === void 0 ? 0.1 : y, S = t.mouseLeaveDelay, E = S === void 0 ? 0.1 : S, I = Vye(t, ["getPopupContainer", "placement", "mouseEnterDelay", "mouseLeaveDelay"]), _ = t.prefixCls, A = t.openClassName, P = t.getTooltipContainer, N = t.overlayClassName, k = t.color, D = t.overlayInnerStyle, R = t.children, V = i("tooltip", _), $ = i(), F = u;
  !("open" in t) && !("visible" in t) && c() && (F = !1);
  var M = Hye(pa(R) && !Nz(R) ? R : /* @__PURE__ */ x.createElement("span", null, R), V), B = M.props, X = !B.className || typeof B.className == "string" ? Ce(B.className, z({}, A || "".concat(V, "-open"), !0)) : B.className, L = Ce(N, z(z({}, "".concat(V, "-rtl"), o === "rtl"), "".concat(V, "-").concat(k), k && Xk.test(k))), j = D, K = {};
  return k && !Xk.test(k) && (j = G(G({}, D), {
    background: k
  }), K = {
    "--antd-arrow-background-color": k
  }), /* @__PURE__ */ x.createElement(Dye, G({}, I, {
    placement: b,
    mouseEnterDelay: w,
    mouseLeaveDelay: E,
    prefixCls: V,
    overlayClassName: L,
    getTooltipContainer: v || P || r,
    ref: e,
    builtinPlacements: f(),
    overlay: p(),
    visible: F,
    onVisibleChange: d,
    onPopupAlign: h,
    overlayInnerStyle: j,
    arrowContent: /* @__PURE__ */ x.createElement("span", {
      className: "".concat(V, "-arrow-content"),
      style: K
    }),
    motion: {
      motionName: OA($, "zoom-big-fast", t.transitionName),
      motionDeadline: 1e3
    }
  }), F ? ji(M, {
    className: X
  }) : M);
});
process.env.NODE_ENV !== "production" && (AG.displayName = "Tooltip");
const Ud = AG;
var Wye = function(t, e) {
  var n = {};
  for (var r in t)
    Object.prototype.hasOwnProperty.call(t, r) && e.indexOf(r) < 0 && (n[r] = t[r]);
  if (t != null && typeof Object.getOwnPropertySymbols == "function")
    for (var i = 0, r = Object.getOwnPropertySymbols(t); i < r.length; i++)
      e.indexOf(r[i]) < 0 && Object.prototype.propertyIsEnumerable.call(t, r[i]) && (n[r[i]] = t[r[i]]);
  return n;
}, jye = function(e) {
  var n = e.title, r = e.content, i = e.prefixCls;
  return /* @__PURE__ */ x.createElement(x.Fragment, null, n && /* @__PURE__ */ x.createElement("div", {
    className: "".concat(i, "-title")
  }, zk(n)), /* @__PURE__ */ x.createElement("div", {
    className: "".concat(i, "-inner-content")
  }, zk(r)));
}, TG = /* @__PURE__ */ x.forwardRef(function(t, e) {
  var n = t.prefixCls, r = t.title, i = t.content, o = t._overlay, a = t.placement, s = a === void 0 ? "top" : a, u = t.trigger, l = u === void 0 ? "hover" : u, c = t.mouseEnterDelay, d = c === void 0 ? 0.1 : c, f = t.mouseLeaveDelay, h = f === void 0 ? 0.1 : f, p = t.overlayStyle, v = p === void 0 ? {} : p, m = Wye(t, ["prefixCls", "title", "content", "_overlay", "placement", "trigger", "mouseEnterDelay", "mouseLeaveDelay", "overlayStyle"]), b = x.useContext(en), y = b.getPrefixCls, w = y("popover", n), S = y(), E = x.useMemo(function() {
    return o || (!r && !i ? null : /* @__PURE__ */ x.createElement(jye, {
      prefixCls: w,
      title: r,
      content: i
    }));
  }, [o, r, i, w]);
  return /* @__PURE__ */ x.createElement(Ud, G({
    placement: s,
    trigger: l,
    mouseEnterDelay: d,
    mouseLeaveDelay: h,
    overlayStyle: v
  }, m, {
    prefixCls: w,
    ref: e,
    overlay: E,
    transitionName: OA(S, "zoom-big", m.transitionName)
  }));
});
process.env.NODE_ENV !== "production" && (TG.displayName = "Popover");
const zye = TG;
var OG = /* @__PURE__ */ x.createContext(null);
function PA(t, e) {
  return t === void 0 ? null : "".concat(t, "-").concat(e);
}
function PG(t) {
  var e = x.useContext(OG);
  return PA(e, t);
}
var Gye = ["children", "locked"], Rs = /* @__PURE__ */ x.createContext(null);
function Uye(t, e) {
  var n = de({}, t);
  return Object.keys(e).forEach(function(r) {
    var i = e[r];
    i !== void 0 && (n[r] = i);
  }), n;
}
function U0(t) {
  var e = t.children, n = t.locked, r = Gt(t, Gye), i = x.useContext(Rs), o = Cp(function() {
    return Uye(i, r);
  }, [i, r], function(a, s) {
    return !n && (a[0] !== s[0] || !np(a[1], s[1], !0));
  });
  return /* @__PURE__ */ x.createElement(Rs.Provider, {
    value: o
  }, e);
}
var Xye = [], NG = /* @__PURE__ */ x.createContext(null);
function yC() {
  return x.useContext(NG);
}
var kG = /* @__PURE__ */ x.createContext(Xye);
function Ep(t) {
  var e = x.useContext(kG);
  return x.useMemo(function() {
    return t !== void 0 ? [].concat(Ye(e), [t]) : e;
  }, [e, t]);
}
var RG = /* @__PURE__ */ x.createContext(null), NA = /* @__PURE__ */ x.createContext({});
function Yk(t) {
  var e = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : !1;
  if (yA(t)) {
    var n = t.nodeName.toLowerCase(), r = (
      // Focusable element
      ["input", "select", "textarea", "button"].includes(n) || // Editable element
      t.isContentEditable || // Anchor with href element
      n === "a" && !!t.getAttribute("href")
    ), i = t.getAttribute("tabindex"), o = Number(i), a = null;
    return i && !Number.isNaN(o) ? a = o : r && a === null && (a = 0), r && t.disabled && (a = null), a !== null && (a >= 0 || e && a < 0);
  }
  return !1;
}
function $G(t) {
  var e = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : !1, n = Ye(t.querySelectorAll("*")).filter(function(r) {
    return Yk(r, e);
  });
  return Yk(t, e) && n.unshift(t), n;
}
var YI = ke.LEFT, ZI = ke.RIGHT, JI = ke.UP, ly = ke.DOWN, cy = ke.ENTER, DG = ke.ESC, Ag = ke.HOME, Tg = ke.END, Zk = [JI, ly, YI, ZI];
function Yye(t, e, n, r) {
  var i, o, a, s, u = "prev", l = "next", c = "children", d = "parent";
  if (t === "inline" && r === cy)
    return {
      inlineTrigger: !0
    };
  var f = (i = {}, z(i, JI, u), z(i, ly, l), i), h = (o = {}, z(o, YI, n ? l : u), z(o, ZI, n ? u : l), z(o, ly, c), z(o, cy, c), o), p = (a = {}, z(a, JI, u), z(a, ly, l), z(a, cy, c), z(a, DG, d), z(a, YI, n ? c : d), z(a, ZI, n ? d : c), a), v = {
    inline: f,
    horizontal: h,
    vertical: p,
    inlineSub: f,
    horizontalSub: p,
    verticalSub: p
  }, m = (s = v["".concat(t).concat(e ? "" : "Sub")]) === null || s === void 0 ? void 0 : s[r];
  switch (m) {
    case u:
      return {
        offset: -1,
        sibling: !0
      };
    case l:
      return {
        offset: 1,
        sibling: !0
      };
    case d:
      return {
        offset: -1,
        sibling: !1
      };
    case c:
      return {
        offset: 1,
        sibling: !1
      };
    default:
      return null;
  }
}
function Zye(t) {
  for (var e = t; e; ) {
    if (e.getAttribute("data-menu-list"))
      return e;
    e = e.parentElement;
  }
  return null;
}
function Jye(t, e) {
  for (var n = t || document.activeElement; n; ) {
    if (e.has(n))
      return n;
    n = n.parentElement;
  }
  return null;
}
function MG(t, e) {
  var n = $G(t, !0);
  return n.filter(function(r) {
    return e.has(r);
  });
}
function Jk(t, e, n) {
  var r = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : 1;
  if (!t)
    return null;
  var i = MG(t, e), o = i.length, a = i.findIndex(function(s) {
    return n === s;
  });
  return r < 0 ? a === -1 ? a = o - 1 : a -= 1 : r > 0 && (a += 1), a = (a + o) % o, i[a];
}
function Kye(t, e, n, r, i, o, a, s, u, l) {
  var c = x.useRef(), d = x.useRef();
  d.current = e;
  var f = function() {
    En.cancel(c.current);
  };
  return x.useEffect(function() {
    return function() {
      f();
    };
  }, []), function(h) {
    var p = h.which;
    if ([].concat(Zk, [cy, DG, Ag, Tg]).includes(p)) {
      var v, m, b, y = function() {
        v = /* @__PURE__ */ new Set(), m = /* @__PURE__ */ new Map(), b = /* @__PURE__ */ new Map();
        var $ = o();
        return $.forEach(function(F) {
          var M = document.querySelector("[data-menu-id='".concat(PA(r, F), "']"));
          M && (v.add(M), b.set(M, F), m.set(F, M));
        }), v;
      };
      y();
      var w = m.get(e), S = Jye(w, v), E = b.get(S), I = Yye(t, a(E, !0).length === 1, n, p);
      if (!I && p !== Ag && p !== Tg)
        return;
      (Zk.includes(p) || [Ag, Tg].includes(p)) && h.preventDefault();
      var _ = function($) {
        if ($) {
          var F = $, M = $.querySelector("a");
          M != null && M.getAttribute("href") && (F = M);
          var B = b.get($);
          s(B), f(), c.current = En(function() {
            d.current === B && F.focus();
          });
        }
      };
      if ([Ag, Tg].includes(p) || I.sibling || !S) {
        var A;
        !S || t === "inline" ? A = i.current : A = Zye(S);
        var P, N = MG(A, v);
        p === Ag ? P = N[0] : p === Tg ? P = N[N.length - 1] : P = Jk(A, v, S, I.offset), _(P);
      } else if (I.inlineTrigger)
        u(E);
      else if (I.offset > 0)
        u(E, !0), f(), c.current = En(function() {
          y();
          var V = S.getAttribute("aria-controls"), $ = document.getElementById(V), F = Jk($, v);
          _(F);
        }, 5);
      else if (I.offset < 0) {
        var k = a(E, !0), D = k[k.length - 2], R = m.get(D);
        u(D, !1), _(R);
      }
    }
    l == null || l(h);
  };
}
function qye(t) {
  Promise.resolve().then(t);
}
var kA = "__RC_UTIL_PATH_SPLIT__", Kk = function(e) {
  return e.join(kA);
}, Qye = function(e) {
  return e.split(kA);
}, KI = "rc-menu-more";
function exe() {
  var t = x.useState({}), e = be(t, 2), n = e[1], r = Ee(/* @__PURE__ */ new Map()), i = Ee(/* @__PURE__ */ new Map()), o = x.useState([]), a = be(o, 2), s = a[0], u = a[1], l = Ee(0), c = Ee(!1), d = function() {
    c.current || n({});
  }, f = et(function(w, S) {
    process.env.NODE_ENV !== "production" && Wt(!r.current.has(w), "Duplicated key '".concat(w, "' used in Menu by path [").concat(S.join(" > "), "]"));
    var E = Kk(S);
    i.current.set(E, w), r.current.set(w, E), l.current += 1;
    var I = l.current;
    qye(function() {
      I === l.current && d();
    });
  }, []), h = et(function(w, S) {
    var E = Kk(S);
    i.current.delete(E), r.current.delete(w);
  }, []), p = et(function(w) {
    u(w);
  }, []), v = et(function(w, S) {
    var E = r.current.get(w) || "", I = Qye(E);
    return S && s.includes(I[0]) && I.unshift(KI), I;
  }, [s]), m = et(function(w, S) {
    return w.some(function(E) {
      var I = v(E, !0);
      return I.includes(S);
    });
  }, [v]), b = function() {
    var S = Ye(r.current.keys());
    return s.length && S.push(KI), S;
  }, y = et(function(w) {
    var S = "".concat(r.current.get(w)).concat(kA), E = /* @__PURE__ */ new Set();
    return Ye(i.current.keys()).forEach(function(I) {
      I.startsWith(S) && E.add(i.current.get(I));
    }), E;
  }, []);
  return x.useEffect(function() {
    return function() {
      c.current = !0;
    };
  }, []), {
    // Register
    registerPath: f,
    unregisterPath: h,
    refreshOverflowKeys: p,
    // Util
    isSubPathKey: m,
    getKeyPath: v,
    getKeys: b,
    getSubPathKeys: y
  };
}
function eh(t) {
  var e = x.useRef(t);
  e.current = t;
  var n = x.useCallback(function() {
    for (var r, i = arguments.length, o = new Array(i), a = 0; a < i; a++)
      o[a] = arguments[a];
    return (r = e.current) === null || r === void 0 ? void 0 : r.call.apply(r, [e].concat(o));
  }, []);
  return t ? n : void 0;
}
var txe = Math.random().toFixed(5).toString().slice(2), qk = 0;
function nxe(t) {
  var e = Tr(t, {
    value: t
  }), n = be(e, 2), r = n[0], i = n[1];
  return x.useEffect(function() {
    qk += 1;
    var o = process.env.NODE_ENV === "test" ? "test" : "".concat(txe, "-").concat(qk);
    i("rc-menu-uuid-".concat(o));
  }, []), r;
}
function FG(t, e, n, r) {
  var i = x.useContext(Rs), o = i.activeKey, a = i.onActive, s = i.onInactive, u = {
    active: o === t
  };
  return e || (u.onMouseEnter = function(l) {
    n == null || n({
      key: t,
      domEvent: l
    }), a(t);
  }, u.onMouseLeave = function(l) {
    r == null || r({
      key: t,
      domEvent: l
    }), s(t);
  }), u;
}
function LG(t) {
  var e = x.useContext(Rs), n = e.mode, r = e.rtl, i = e.inlineIndent;
  if (n !== "inline")
    return null;
  var o = t;
  return r ? {
    paddingRight: o * i
  } : {
    paddingLeft: o * i
  };
}
function VG(t) {
  var e = t.icon, n = t.props, r = t.children, i;
  return typeof e == "function" ? i = /* @__PURE__ */ x.createElement(e, de({}, n)) : i = e, i || r || null;
}
var rxe = ["item"];
function yx(t) {
  var e = t.item, n = Gt(t, rxe);
  return Object.defineProperty(n, "item", {
    get: function() {
      return Wt(!1, "`info.item` is deprecated since we will move to function component that not provides React Node instance in future."), e;
    }
  }), n;
}
var ixe = ["title", "attribute", "elementRef"], oxe = ["style", "className", "eventKey", "warnKey", "disabled", "itemIcon", "children", "role", "onMouseEnter", "onMouseLeave", "onClick", "onKeyDown", "onFocus"], axe = ["active"], sxe = /* @__PURE__ */ function(t) {
  Pr(n, t);
  var e = Hr(n);
  function n() {
    return zn(this, n), e.apply(this, arguments);
  }
  return Gn(n, [{
    key: "render",
    value: function() {
      var i = this.props, o = i.title, a = i.attribute, s = i.elementRef, u = Gt(i, ixe), l = Pi(u, ["eventKey", "popupClassName", "popupOffset", "onTitleClick"]);
      return Wt(!a, "`attribute` of Menu.Item is deprecated. Please pass attribute directly."), /* @__PURE__ */ x.createElement(au.Item, G({}, a, {
        title: typeof o == "string" ? o : void 0
      }, l, {
        ref: s
      }));
    }
  }]), n;
}(x.Component), uxe = /* @__PURE__ */ x.forwardRef(function(t, e) {
  var n, r = t.style, i = t.className, o = t.eventKey, a = t.warnKey, s = t.disabled, u = t.itemIcon, l = t.children, c = t.role, d = t.onMouseEnter, f = t.onMouseLeave, h = t.onClick, p = t.onKeyDown, v = t.onFocus, m = Gt(t, oxe), b = PG(o), y = x.useContext(Rs), w = y.prefixCls, S = y.onItemClick, E = y.disabled, I = y.overflowDisabled, _ = y.itemIcon, A = y.selectedKeys, P = y.onActive, N = x.useContext(NA), k = N._internalRenderMenuItem, D = "".concat(w, "-item"), R = x.useRef(), V = x.useRef(), $ = E || s, F = iA(e, V), M = Ep(o);
  process.env.NODE_ENV !== "production" && a && Wt(!1, "MenuItem should not leave undefined `key`.");
  var B = function(se) {
    return {
      key: o,
      // Note: For legacy code is reversed which not like other antd component
      keyPath: Ye(M).reverse(),
      item: R.current,
      domEvent: se
    };
  }, X = u || _, L = FG(o, $, d, f), j = L.active, K = Gt(L, axe), W = A.includes(o), Y = LG(M.length), U = function(se) {
    if (!$) {
      var te = B(se);
      h == null || h(yx(te)), S(te);
    }
  }, Q = function(se) {
    if (p == null || p(se), se.which === ke.ENTER) {
      var te = B(se);
      h == null || h(yx(te)), S(te);
    }
  }, Z = function(se) {
    P(o), v == null || v(se);
  }, ee = {};
  t.role === "option" && (ee["aria-selected"] = W);
  var ie = /* @__PURE__ */ x.createElement(sxe, G({
    ref: R,
    elementRef: F,
    role: c === null ? "none" : c || "menuitem",
    tabIndex: s ? null : -1,
    "data-menu-id": I && b ? null : b
  }, m, K, ee, {
    component: "li",
    "aria-disabled": s,
    style: de(de({}, Y), r),
    className: Ce(D, (n = {}, z(n, "".concat(D, "-active"), j), z(n, "".concat(D, "-selected"), W), z(n, "".concat(D, "-disabled"), $), n), i),
    onClick: U,
    onKeyDown: Q,
    onFocus: Z
  }), l, /* @__PURE__ */ x.createElement(VG, {
    props: de(de({}, t), {}, {
      isSelected: W
    }),
    icon: X
  }));
  return k && (ie = k(ie, t, {
    selected: W
  })), ie;
});
function lxe(t, e) {
  var n = t.eventKey, r = yC(), i = Ep(n);
  return x.useEffect(function() {
    if (r)
      return r.registerPath(n, i), function() {
        r.unregisterPath(n, i);
      };
  }, [i]), r ? null : /* @__PURE__ */ x.createElement(uxe, G({}, t, {
    ref: e
  }));
}
const xC = /* @__PURE__ */ x.forwardRef(lxe);
var cxe = ["className", "children"], dxe = function(e, n) {
  var r = e.className, i = e.children, o = Gt(e, cxe), a = x.useContext(Rs), s = a.prefixCls, u = a.mode, l = a.rtl;
  return /* @__PURE__ */ x.createElement("ul", G({
    className: Ce(s, l && "".concat(s, "-rtl"), "".concat(s, "-sub"), "".concat(s, "-").concat(u === "inline" ? "inline" : "vertical"), r),
    role: "menu"
  }, o, {
    "data-menu-list": !0,
    ref: n
  }), i);
}, RA = /* @__PURE__ */ x.forwardRef(dxe);
RA.displayName = "SubMenuList";
var fxe = ["label", "children", "key", "type"];
function $A(t, e) {
  return Xa(t).map(function(n, r) {
    if (/* @__PURE__ */ x.isValidElement(n)) {
      var i, o, a = n.key, s = (i = (o = n.props) === null || o === void 0 ? void 0 : o.eventKey) !== null && i !== void 0 ? i : a, u = s == null;
      u && (s = "tmp_key-".concat([].concat(Ye(e), [r]).join("-")));
      var l = {
        key: s,
        eventKey: s
      };
      return process.env.NODE_ENV !== "production" && u && (l.warnKey = !0), /* @__PURE__ */ x.cloneElement(n, l);
    }
    return n;
  });
}
function qI(t) {
  return (t || []).map(function(e, n) {
    if (e && _t(e) === "object") {
      var r = e, i = r.label, o = r.children, a = r.key, s = r.type, u = Gt(r, fxe), l = a ?? "tmp-".concat(n);
      return o || s === "group" ? s === "group" ? /* @__PURE__ */ x.createElement(wC, G({
        key: l
      }, u, {
        title: i
      }), qI(o)) : /* @__PURE__ */ x.createElement(CC, G({
        key: l
      }, u, {
        title: i
      }), qI(o)) : s === "divider" ? /* @__PURE__ */ x.createElement(DA, G({
        key: l
      }, u)) : /* @__PURE__ */ x.createElement(xC, G({
        key: l
      }, u), i);
    }
    return null;
  }).filter(function(e) {
    return e;
  });
}
function hxe(t, e, n) {
  var r = t;
  return e && (r = qI(e)), $A(r, n);
}
var Xl = {
  adjustX: 1,
  adjustY: 1
}, pxe = {
  topLeft: {
    points: ["bl", "tl"],
    overflow: Xl,
    offset: [0, -7]
  },
  bottomLeft: {
    points: ["tl", "bl"],
    overflow: Xl,
    offset: [0, 7]
  },
  leftTop: {
    points: ["tr", "tl"],
    overflow: Xl,
    offset: [-4, 0]
  },
  rightTop: {
    points: ["tl", "tr"],
    overflow: Xl,
    offset: [4, 0]
  }
}, gxe = {
  topLeft: {
    points: ["bl", "tl"],
    overflow: Xl,
    offset: [0, -7]
  },
  bottomLeft: {
    points: ["tl", "bl"],
    overflow: Xl,
    offset: [0, 7]
  },
  rightTop: {
    points: ["tr", "tl"],
    overflow: Xl,
    offset: [-4, 0]
  },
  leftTop: {
    points: ["tl", "tr"],
    overflow: Xl,
    offset: [4, 0]
  }
};
function BG(t, e, n) {
  if (e)
    return e;
  if (n)
    return n[t] || n.other;
}
var mxe = {
  horizontal: "bottomLeft",
  vertical: "rightTop",
  "vertical-left": "rightTop",
  "vertical-right": "leftTop"
};
function vxe(t) {
  var e = t.prefixCls, n = t.visible, r = t.children, i = t.popup, o = t.popupClassName, a = t.popupOffset, s = t.disabled, u = t.mode, l = t.onVisibleChange, c = x.useContext(Rs), d = c.getPopupContainer, f = c.rtl, h = c.subMenuOpenDelay, p = c.subMenuCloseDelay, v = c.builtinPlacements, m = c.triggerSubMenuAction, b = c.forceSubMenuRender, y = c.rootClassName, w = c.motion, S = c.defaultMotions, E = x.useState(!1), I = be(E, 2), _ = I[0], A = I[1], P = de(f ? de({}, gxe) : de({}, pxe), v), N = mxe[u], k = BG(u, w, S), D = x.useRef(k);
  u !== "inline" && (D.current = k);
  var R = de(de({}, D.current), {}, {
    leavedClassName: "".concat(e, "-hidden"),
    removeOnLeave: !1,
    motionAppear: !0
  }), V = x.useRef();
  return x.useEffect(function() {
    return V.current = En(function() {
      A(n);
    }), function() {
      En.cancel(V.current);
    };
  }, [n]), /* @__PURE__ */ x.createElement(Mm, {
    prefixCls: e,
    popupClassName: Ce("".concat(e, "-popup"), z({}, "".concat(e, "-rtl"), f), o, y),
    stretch: u === "horizontal" ? "minWidth" : null,
    getPopupContainer: d,
    builtinPlacements: P,
    popupPlacement: N,
    popupVisible: _,
    popup: i,
    popupAlign: a && {
      offset: a
    },
    action: s ? [] : [m],
    mouseEnterDelay: h,
    mouseLeaveDelay: p,
    onPopupVisibleChange: l,
    forceRender: b,
    popupMotion: R
  }, r);
}
function bxe(t) {
  var e = t.id, n = t.open, r = t.keyPath, i = t.children, o = "inline", a = x.useContext(Rs), s = a.prefixCls, u = a.forceSubMenuRender, l = a.motion, c = a.defaultMotions, d = a.mode, f = x.useRef(!1);
  f.current = d === o;
  var h = x.useState(!f.current), p = be(h, 2), v = p[0], m = p[1], b = f.current ? n : !1;
  x.useEffect(function() {
    f.current && m(!1);
  }, [d]);
  var y = de({}, BG(o, l, c));
  r.length > 1 && (y.motionAppear = !1);
  var w = y.onVisibleChanged;
  return y.onVisibleChanged = function(S) {
    return !f.current && !S && m(!0), w == null ? void 0 : w(S);
  }, v ? null : /* @__PURE__ */ x.createElement(U0, {
    mode: o,
    locked: !f.current
  }, /* @__PURE__ */ x.createElement(ll, G({
    visible: b
  }, y, {
    forceRender: u,
    removeOnLeave: !1,
    leavedClassName: "".concat(s, "-hidden")
  }), function(S) {
    var E = S.className, I = S.style;
    return /* @__PURE__ */ x.createElement(RA, {
      id: e,
      className: E,
      style: I
    }, i);
  }));
}
var yxe = ["style", "className", "title", "eventKey", "warnKey", "disabled", "internalPopupClose", "children", "itemIcon", "expandIcon", "popupClassName", "popupOffset", "onClick", "onMouseEnter", "onMouseLeave", "onTitleClick", "onTitleMouseEnter", "onTitleMouseLeave"], xxe = ["active"], Cxe = function(e) {
  var n, r = e.style, i = e.className, o = e.title, a = e.eventKey, s = e.warnKey, u = e.disabled, l = e.internalPopupClose, c = e.children, d = e.itemIcon, f = e.expandIcon, h = e.popupClassName, p = e.popupOffset, v = e.onClick, m = e.onMouseEnter, b = e.onMouseLeave, y = e.onTitleClick, w = e.onTitleMouseEnter, S = e.onTitleMouseLeave, E = Gt(e, yxe), I = PG(a), _ = x.useContext(Rs), A = _.prefixCls, P = _.mode, N = _.openKeys, k = _.disabled, D = _.overflowDisabled, R = _.activeKey, V = _.selectedKeys, $ = _.itemIcon, F = _.expandIcon, M = _.onItemClick, B = _.onOpenChange, X = _.onActive, L = x.useContext(NA), j = L._internalRenderSubMenuItem, K = x.useContext(RG), W = K.isSubPathKey, Y = Ep(), U = "".concat(A, "-submenu"), Q = k || u, Z = x.useRef(), ee = x.useRef();
  process.env.NODE_ENV !== "production" && s && Wt(!1, "SubMenu should not leave undefined `key`.");
  var ie = d || $, oe = f || F, se = N.includes(a), te = !D && se, ge = W(V, a), he = FG(a, Q, w, S), fe = he.active, _e = Gt(he, xxe), Ne = x.useState(!1), ze = be(Ne, 2), Ve = ze[0], ne = ze[1], pe = function(st) {
    Q || ne(st);
  }, ye = function(st) {
    pe(!0), m == null || m({
      key: a,
      domEvent: st
    });
  }, Ae = function(st) {
    pe(!1), b == null || b({
      key: a,
      domEvent: st
    });
  }, we = x.useMemo(function() {
    return fe || (P !== "inline" ? Ve || W([R], a) : !1);
  }, [P, fe, R, Ve, a, W]), ce = LG(Y.length), ve = function(st) {
    Q || (y == null || y({
      key: a,
      domEvent: st
    }), P === "inline" && B(a, !se));
  }, Ie = eh(function(Ke) {
    v == null || v(yx(Ke)), M(Ke);
  }), q = function(st) {
    P !== "inline" && B(a, st);
  }, Fe = function() {
    X(a);
  }, Ze = I && "".concat(I, "-popup"), at = /* @__PURE__ */ x.createElement("div", G({
    role: "menuitem",
    style: ce,
    className: "".concat(U, "-title"),
    tabIndex: Q ? null : -1,
    ref: Z,
    title: typeof o == "string" ? o : null,
    "data-menu-id": D && I ? null : I,
    "aria-expanded": te,
    "aria-haspopup": !0,
    "aria-controls": Ze,
    "aria-disabled": Q,
    onClick: ve,
    onFocus: Fe
  }, _e), o, /* @__PURE__ */ x.createElement(VG, {
    icon: P !== "horizontal" ? oe : null,
    props: de(de({}, e), {}, {
      isOpen: te,
      // [Legacy] Not sure why need this mark
      isSubMenu: !0
    })
  }, /* @__PURE__ */ x.createElement("i", {
    className: "".concat(U, "-arrow")
  }))), Je = x.useRef(P);
  if (P !== "inline" && Y.length > 1 ? Je.current = "vertical" : Je.current = P, !D) {
    var ut = Je.current;
    at = /* @__PURE__ */ x.createElement(vxe, {
      mode: ut,
      prefixCls: U,
      visible: !l && te && P !== "inline",
      popupClassName: h,
      popupOffset: p,
      popup: /* @__PURE__ */ x.createElement(
        U0,
        {
          mode: ut === "horizontal" ? "vertical" : ut
        },
        /* @__PURE__ */ x.createElement(RA, {
          id: Ze,
          ref: ee
        }, c)
      ),
      disabled: Q,
      onVisibleChange: q
    }, at);
  }
  var Ct = /* @__PURE__ */ x.createElement(au.Item, G({
    role: "none"
  }, E, {
    component: "li",
    style: r,
    className: Ce(U, "".concat(U, "-").concat(P), i, (n = {}, z(n, "".concat(U, "-open"), te), z(n, "".concat(U, "-active"), we), z(n, "".concat(U, "-selected"), ge), z(n, "".concat(U, "-disabled"), Q), n)),
    onMouseEnter: ye,
    onMouseLeave: Ae
  }), at, !D && /* @__PURE__ */ x.createElement(bxe, {
    id: Ze,
    open: te,
    keyPath: Y
  }, c));
  return j && (Ct = j(Ct, e, {
    selected: ge,
    active: we,
    open: te,
    disabled: Q
  })), /* @__PURE__ */ x.createElement(U0, {
    onItemClick: Ie,
    mode: P === "horizontal" ? "vertical" : P,
    itemIcon: ie,
    expandIcon: oe
  }, Ct);
};
function CC(t) {
  var e = t.eventKey, n = t.children, r = Ep(e), i = $A(n, r), o = yC();
  x.useEffect(function() {
    if (o)
      return o.registerPath(e, r), function() {
        o.unregisterPath(e, r);
      };
  }, [r]);
  var a;
  return o ? a = i : a = /* @__PURE__ */ x.createElement(Cxe, t, i), /* @__PURE__ */ x.createElement(kG.Provider, {
    value: r
  }, a);
}
var wxe = ["prefixCls", "rootClassName", "style", "className", "tabIndex", "items", "children", "direction", "id", "mode", "inlineCollapsed", "disabled", "disabledOverflow", "subMenuOpenDelay", "subMenuCloseDelay", "forceSubMenuRender", "defaultOpenKeys", "openKeys", "activeKey", "defaultActiveFirst", "selectable", "multiple", "defaultSelectedKeys", "selectedKeys", "onSelect", "onDeselect", "inlineIndent", "motion", "defaultMotions", "triggerSubMenuAction", "builtinPlacements", "itemIcon", "expandIcon", "overflowedIndicator", "overflowedIndicatorPopupClassName", "getPopupContainer", "onClick", "onOpenChange", "onKeyDown", "openAnimation", "openTransitionName", "_internalRenderMenuItem", "_internalRenderSubMenuItem"], Df = [], Exe = /* @__PURE__ */ x.forwardRef(function(t, e) {
  var n, r, i = t, o = i.prefixCls, a = o === void 0 ? "rc-menu" : o, s = i.rootClassName, u = i.style, l = i.className, c = i.tabIndex, d = c === void 0 ? 0 : c, f = i.items, h = i.children, p = i.direction, v = i.id, m = i.mode, b = m === void 0 ? "vertical" : m, y = i.inlineCollapsed, w = i.disabled, S = i.disabledOverflow, E = i.subMenuOpenDelay, I = E === void 0 ? 0.1 : E, _ = i.subMenuCloseDelay, A = _ === void 0 ? 0.1 : _, P = i.forceSubMenuRender, N = i.defaultOpenKeys, k = i.openKeys, D = i.activeKey, R = i.defaultActiveFirst, V = i.selectable, $ = V === void 0 ? !0 : V, F = i.multiple, M = F === void 0 ? !1 : F, B = i.defaultSelectedKeys, X = i.selectedKeys, L = i.onSelect, j = i.onDeselect, K = i.inlineIndent, W = K === void 0 ? 24 : K, Y = i.motion, U = i.defaultMotions, Q = i.triggerSubMenuAction, Z = Q === void 0 ? "hover" : Q, ee = i.builtinPlacements, ie = i.itemIcon, oe = i.expandIcon, se = i.overflowedIndicator, te = se === void 0 ? "..." : se, ge = i.overflowedIndicatorPopupClassName, he = i.getPopupContainer, fe = i.onClick, _e = i.onOpenChange, Ne = i.onKeyDown, ze = i.openAnimation, Ve = i.openTransitionName, ne = i._internalRenderMenuItem, pe = i._internalRenderSubMenuItem, ye = Gt(i, wxe), Ae = x.useMemo(function() {
    return hxe(h, f, Df);
  }, [h, f]), we = x.useState(!1), ce = be(we, 2), ve = ce[0], Ie = ce[1], q = x.useRef(), Fe = nxe(v), Ze = p === "rtl";
  process.env.NODE_ENV !== "production" && Wt(!ze && !Ve, "`openAnimation` and `openTransitionName` is removed. Please use `motion` or `defaultMotion` instead.");
  var at = Tr(N, {
    value: k,
    postState: function(hn) {
      return hn || Df;
    }
  }), Je = be(at, 2), ut = Je[0], Ct = Je[1], Ke = function(hn) {
    var Mn = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : !1;
    function Qn() {
      Ct(hn), _e == null || _e(hn);
    }
    Mn ? sc(Qn) : Qn();
  }, st = x.useState(ut), wt = be(st, 2), qt = wt[0], bt = wt[1], Me = x.useRef(!1), yt = x.useMemo(function() {
    return (b === "inline" || b === "vertical") && y ? ["vertical", y] : [b, !1];
  }, [b, y]), ct = be(yt, 2), kt = ct[0], Vt = ct[1], Vn = kt === "inline", tn = x.useState(kt), Xe = be(tn, 2), tt = Xe[0], ot = Xe[1], lt = x.useState(Vt), He = be(lt, 2), mt = He[0], Qt = He[1];
  x.useEffect(function() {
    ot(kt), Qt(Vt), Me.current && (Vn ? Ct(qt) : Ke(Df));
  }, [kt, Vt]);
  var Yt = x.useState(0), nn = be(Yt, 2), Nt = nn[0], ue = nn[1], $e = Nt >= Ae.length - 1 || tt !== "horizontal" || S;
  x.useEffect(function() {
    Vn && bt(ut);
  }, [ut]), x.useEffect(function() {
    return Me.current = !0, function() {
      Me.current = !1;
    };
  }, []);
  var je = exe(), At = je.registerPath, $t = je.unregisterPath, qe = je.refreshOverflowKeys, nt = je.isSubPathKey, dt = je.getKeyPath, rn = je.getKeys, on = je.getSubPathKeys, Rt = x.useMemo(function() {
    return {
      registerPath: At,
      unregisterPath: $t
    };
  }, [At, $t]), Tt = x.useMemo(function() {
    return {
      isSubPathKey: nt
    };
  }, [nt]);
  x.useEffect(function() {
    qe($e ? Df : Ae.slice(Nt + 1).map(function(Dn) {
      return Dn.key;
    }));
  }, [Nt, $e]);
  var Wn = Tr(D || R && ((n = Ae[0]) === null || n === void 0 ? void 0 : n.key), {
    value: D
  }), zr = be(Wn, 2), gr = zr[0], fo = zr[1], xl = eh(function(Dn) {
    fo(Dn);
  }), Cl = eh(function() {
    fo(void 0);
  });
  wc(e, function() {
    return {
      list: q.current,
      focus: function(hn) {
        var Mn, Qn = gr ?? ((Mn = Ae.find(function(gf) {
          return !gf.props.disabled;
        })) === null || Mn === void 0 ? void 0 : Mn.key);
        if (Qn) {
          var Fr, po, Ws;
          (Fr = q.current) === null || Fr === void 0 || (po = Fr.querySelector("li[data-menu-id='".concat(PA(Fe, Qn), "']"))) === null || po === void 0 || (Ws = po.focus) === null || Ws === void 0 || Ws.call(po, hn);
        }
      }
    };
  });
  var Bs = Tr(B || [], {
    value: X,
    // Legacy convert key to array
    postState: function(hn) {
      return Array.isArray(hn) ? hn : hn == null ? Df : [hn];
    }
  }), ho = be(Bs, 2), Ho = ho[0], es = ho[1], wl = function(hn) {
    if ($) {
      var Mn = hn.key, Qn = Ho.includes(Mn), Fr;
      M ? Qn ? Fr = Ho.filter(function(Ws) {
        return Ws !== Mn;
      }) : Fr = [].concat(Ye(Ho), [Mn]) : Fr = [Mn], es(Fr);
      var po = de(de({}, hn), {}, {
        selectedKeys: Fr
      });
      Qn ? j == null || j(po) : L == null || L(po);
    }
    !M && ut.length && tt !== "inline" && Ke(Df);
  }, Hs = eh(function(Dn) {
    fe == null || fe(yx(Dn)), wl(Dn);
  }), an = eh(function(Dn, hn) {
    var Mn = ut.filter(function(Fr) {
      return Fr !== Dn;
    });
    if (hn)
      Mn.push(Dn);
    else if (tt !== "inline") {
      var Qn = on(Dn);
      Mn = Mn.filter(function(Fr) {
        return !Qn.has(Fr);
      });
    }
    np(ut, Mn, !0) || Ke(Mn, !0);
  }), jt = eh(he), Nr = function(hn, Mn) {
    var Qn = Mn ?? !ut.includes(hn);
    an(hn, Qn);
  }, qr = Kye(tt, gr, Ze, Fe, q, rn, dt, fo, Nr, Ne);
  x.useEffect(function() {
    Ie(!0);
  }, []);
  var mr = x.useMemo(function() {
    return {
      _internalRenderMenuItem: ne,
      _internalRenderSubMenuItem: pe
    };
  }, [ne, pe]), si = tt !== "horizontal" || S ? Ae : (
    // Need wrap for overflow dropdown that do not response for open
    Ae.map(function(Dn, hn) {
      return (
        // Always wrap provider to avoid sub node re-mount
        /* @__PURE__ */ x.createElement(U0, {
          key: Dn.key,
          overflowDisabled: hn > Nt
        }, Dn)
      );
    })
  ), Qr = /* @__PURE__ */ x.createElement(au, G({
    id: v,
    ref: q,
    prefixCls: "".concat(a, "-overflow"),
    component: "ul",
    itemComponent: xC,
    className: Ce(a, "".concat(a, "-root"), "".concat(a, "-").concat(tt), l, (r = {}, z(r, "".concat(a, "-inline-collapsed"), mt), z(r, "".concat(a, "-rtl"), Ze), r), s),
    dir: p,
    style: u,
    role: "menu",
    tabIndex: d,
    data: si,
    renderRawItem: function(hn) {
      return hn;
    },
    renderRawRest: function(hn) {
      var Mn = hn.length, Qn = Mn ? Ae.slice(-Mn) : null;
      return /* @__PURE__ */ x.createElement(CC, {
        eventKey: KI,
        title: te,
        disabled: $e,
        internalPopupClose: Mn === 0,
        popupClassName: ge
      }, Qn);
    },
    maxCount: tt !== "horizontal" || S ? au.INVALIDATE : au.RESPONSIVE,
    ssr: "full",
    "data-menu-list": !0,
    onVisibleChange: function(hn) {
      ue(hn);
    },
    onKeyDown: qr
  }, ye));
  return /* @__PURE__ */ x.createElement(NA.Provider, {
    value: mr
  }, /* @__PURE__ */ x.createElement(OG.Provider, {
    value: Fe
  }, /* @__PURE__ */ x.createElement(U0, {
    prefixCls: a,
    rootClassName: s,
    mode: tt,
    openKeys: ut,
    rtl: Ze,
    disabled: w,
    motion: ve ? Y : null,
    defaultMotions: ve ? U : null,
    activeKey: gr,
    onActive: xl,
    onInactive: Cl,
    selectedKeys: Ho,
    inlineIndent: W,
    subMenuOpenDelay: I,
    subMenuCloseDelay: A,
    forceSubMenuRender: P,
    builtinPlacements: ee,
    triggerSubMenuAction: Z,
    getPopupContainer: jt,
    itemIcon: ie,
    expandIcon: oe,
    onItemClick: Hs,
    onOpenChange: an
  }, /* @__PURE__ */ x.createElement(RG.Provider, {
    value: Tt
  }, Qr), /* @__PURE__ */ x.createElement("div", {
    style: {
      display: "none"
    },
    "aria-hidden": !0
  }, /* @__PURE__ */ x.createElement(NG.Provider, {
    value: Rt
  }, Ae)))));
}), Sxe = ["className", "title", "eventKey", "children"], Ixe = ["children"], _xe = function(e) {
  var n = e.className, r = e.title;
  e.eventKey;
  var i = e.children, o = Gt(e, Sxe), a = x.useContext(Rs), s = a.prefixCls, u = "".concat(s, "-item-group");
  return /* @__PURE__ */ x.createElement("li", G({
    role: "presentation"
  }, o, {
    onClick: function(c) {
      return c.stopPropagation();
    },
    className: Ce(u, n)
  }), /* @__PURE__ */ x.createElement("div", {
    role: "presentation",
    className: "".concat(u, "-title"),
    title: typeof r == "string" ? r : void 0
  }, r), /* @__PURE__ */ x.createElement("ul", {
    role: "group",
    className: "".concat(u, "-list")
  }, i));
};
function wC(t) {
  var e = t.children, n = Gt(t, Ixe), r = Ep(n.eventKey), i = $A(e, r), o = yC();
  return o ? i : /* @__PURE__ */ x.createElement(_xe, Pi(n, ["warnKey"]), i);
}
function DA(t) {
  var e = t.className, n = t.style, r = x.useContext(Rs), i = r.prefixCls, o = yC();
  return o ? null : /* @__PURE__ */ x.createElement("li", {
    className: Ce("".concat(i, "-item-divider"), e),
    style: n
  });
}
var Lm = Exe;
Lm.Item = xC;
Lm.SubMenu = CC;
Lm.ItemGroup = wC;
Lm.Divider = DA;
var Axe = function(e) {
  return !isNaN(parseFloat(e)) && isFinite(e);
};
const Txe = Axe;
var HG = function(t, e) {
  var n = {};
  for (var r in t)
    Object.prototype.hasOwnProperty.call(t, r) && e.indexOf(r) < 0 && (n[r] = t[r]);
  if (t != null && typeof Object.getOwnPropertySymbols == "function")
    for (var i = 0, r = Object.getOwnPropertySymbols(t); i < r.length; i++)
      e.indexOf(r[i]) < 0 && Object.prototype.propertyIsEnumerable.call(t, r[i]) && (n[r[i]] = t[r[i]]);
  return n;
}, WG = /* @__PURE__ */ x.createContext({
  siderHook: {
    addSider: function() {
      return null;
    },
    removeSider: function() {
      return null;
    }
  }
});
function EC(t) {
  var e = t.suffixCls, n = t.tagName, r = t.displayName;
  return function(i) {
    var o = /* @__PURE__ */ x.forwardRef(function(a, s) {
      var u = x.useContext(en), l = u.getPrefixCls, c = a.prefixCls, d = l(e, c);
      return /* @__PURE__ */ x.createElement(i, G({
        ref: s,
        prefixCls: d,
        tagName: n
      }, a));
    });
    return process.env.NODE_ENV !== "production" && (o.displayName = r), o;
  };
}
var MA = /* @__PURE__ */ x.forwardRef(function(t, e) {
  var n = t.prefixCls, r = t.className, i = t.children, o = t.tagName, a = HG(t, ["prefixCls", "className", "children", "tagName"]), s = Ce(n, r);
  return /* @__PURE__ */ x.createElement(o, G(G({
    className: s
  }, a), {
    ref: e
  }), i);
}), Oxe = /* @__PURE__ */ x.forwardRef(function(t, e) {
  var n = x.useContext(en), r = n.direction, i = x.useState([]), o = be(i, 2), a = o[0], s = o[1], u = t.prefixCls, l = t.className, c = t.children, d = t.hasSider, f = t.tagName, h = HG(t, ["prefixCls", "className", "children", "hasSider", "tagName"]), p = Ce(u, z(z({}, "".concat(u, "-has-sider"), typeof d == "boolean" ? d : a.length > 0), "".concat(u, "-rtl"), r === "rtl"), l), v = x.useMemo(function() {
    return {
      siderHook: {
        addSider: function(b) {
          s(function(y) {
            return [].concat(Ye(y), [b]);
          });
        },
        removeSider: function(b) {
          s(function(y) {
            return y.filter(function(w) {
              return w !== b;
            });
          });
        }
      }
    };
  }, []);
  return /* @__PURE__ */ x.createElement(WG.Provider, {
    value: v
  }, /* @__PURE__ */ x.createElement(f, G({
    ref: e,
    className: p
  }, h), c));
});
EC({
  suffixCls: "layout",
  tagName: "section",
  displayName: "Layout"
})(Oxe);
EC({
  suffixCls: "layout-header",
  tagName: "header",
  displayName: "Header"
})(MA);
EC({
  suffixCls: "layout-footer",
  tagName: "footer",
  displayName: "Footer"
})(MA);
EC({
  suffixCls: "layout-content",
  tagName: "main",
  displayName: "Content"
})(MA);
var Pxe = function(t, e) {
  var n = {};
  for (var r in t)
    Object.prototype.hasOwnProperty.call(t, r) && e.indexOf(r) < 0 && (n[r] = t[r]);
  if (t != null && typeof Object.getOwnPropertySymbols == "function")
    for (var i = 0, r = Object.getOwnPropertySymbols(t); i < r.length; i++)
      e.indexOf(r[i]) < 0 && Object.prototype.propertyIsEnumerable.call(t, r[i]) && (n[r[i]] = t[r[i]]);
  return n;
}, Qk = {
  xs: "479.98px",
  sm: "575.98px",
  md: "767.98px",
  lg: "991.98px",
  xl: "1199.98px",
  xxl: "1599.98px"
}, FA = /* @__PURE__ */ x.createContext({}), Nxe = /* @__PURE__ */ function() {
  var t = 0;
  return function() {
    var e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "";
    return t += 1, "".concat(e).concat(t);
  };
}(), kxe = /* @__PURE__ */ x.forwardRef(function(t, e) {
  var n = t.prefixCls, r = t.className, i = t.trigger, o = t.children, a = t.defaultCollapsed, s = a === void 0 ? !1 : a, u = t.theme, l = u === void 0 ? "dark" : u, c = t.style, d = c === void 0 ? {} : c, f = t.collapsible, h = f === void 0 ? !1 : f, p = t.reverseArrow, v = p === void 0 ? !1 : p, m = t.width, b = m === void 0 ? 200 : m, y = t.collapsedWidth, w = y === void 0 ? 80 : y, S = t.zeroWidthTriggerStyle, E = t.breakpoint, I = t.onCollapse, _ = t.onBreakpoint, A = Pxe(t, ["prefixCls", "className", "trigger", "children", "defaultCollapsed", "theme", "style", "collapsible", "reverseArrow", "width", "collapsedWidth", "zeroWidthTriggerStyle", "breakpoint", "onCollapse", "onBreakpoint"]), P = fn(WG), N = P.siderHook, k = Le("collapsed" in A ? A.collapsed : s), D = be(k, 2), R = D[0], V = D[1], $ = Le(!1), F = be($, 2), M = F[0], B = F[1];
  Re(function() {
    "collapsed" in A && V(A.collapsed);
  }, [A.collapsed]);
  var X = function(Z, ee) {
    "collapsed" in A || V(Z), I == null || I(Z, ee);
  }, L = Ee();
  L.current = function(Q) {
    B(Q.matches), _ == null || _(Q.matches), R !== Q.matches && X(Q.matches, "responsive");
  }, Re(function() {
    function Q(oe) {
      return L.current(oe);
    }
    var Z;
    if (typeof window < "u") {
      var ee = window, ie = ee.matchMedia;
      if (ie && E && E in Qk) {
        Z = ie("(max-width: ".concat(Qk[E], ")"));
        try {
          Z.addEventListener("change", Q);
        } catch {
          Z.addListener(Q);
        }
        Q(Z);
      }
    }
    return function() {
      try {
        Z == null || Z.removeEventListener("change", Q);
      } catch {
        Z == null || Z.removeListener(Q);
      }
    };
  }, [E]), Re(function() {
    var Q = Nxe("ant-sider-");
    return N.addSider(Q), function() {
      return N.removeSider(Q);
    };
  }, []);
  var j = function() {
    X(!R, "clickTrigger");
  }, K = fn(en), W = K.getPrefixCls, Y = function() {
    var Z = W("layout-sider", n), ee = Pi(A, ["collapsed"]), ie = R ? w : b, oe = Txe(ie) ? "".concat(ie, "px") : String(ie), se = parseFloat(String(w || 0)) === 0 ? /* @__PURE__ */ x.createElement("span", {
      onClick: j,
      className: Ce("".concat(Z, "-zero-width-trigger"), "".concat(Z, "-zero-width-trigger-").concat(v ? "right" : "left")),
      style: S
    }, i || /* @__PURE__ */ x.createElement(ege, null)) : null, te = {
      expanded: v ? /* @__PURE__ */ x.createElement(Qh, null) : /* @__PURE__ */ x.createElement(V0, null),
      collapsed: v ? /* @__PURE__ */ x.createElement(V0, null) : /* @__PURE__ */ x.createElement(Qh, null)
    }, ge = R ? "collapsed" : "expanded", he = te[ge], fe = i !== null ? se || /* @__PURE__ */ x.createElement("div", {
      className: "".concat(Z, "-trigger"),
      onClick: j,
      style: {
        width: oe
      }
    }, i || he) : null, _e = G(G({}, d), {
      flex: "0 0 ".concat(oe),
      maxWidth: oe,
      minWidth: oe,
      width: oe
    }), Ne = Ce(Z, "".concat(Z, "-").concat(l), z(z(z(z({}, "".concat(Z, "-collapsed"), !!R), "".concat(Z, "-has-trigger"), h && i !== null && !se), "".concat(Z, "-below"), !!M), "".concat(Z, "-zero-width"), parseFloat(oe) === 0), r);
    return /* @__PURE__ */ x.createElement("aside", G({
      className: Ne
    }, ee, {
      style: _e,
      ref: e
    }), /* @__PURE__ */ x.createElement("div", {
      className: "".concat(Z, "-children")
    }, o), h || M && se ? fe : null);
  }, U = x.useMemo(function() {
    return {
      siderCollapsed: R
    };
  }, [R]);
  return /* @__PURE__ */ x.createElement(FA.Provider, {
    value: U
  }, Y());
});
process.env.NODE_ENV !== "production" && (kxe.displayName = "Sider");
var Rxe = function(t, e) {
  var n = {};
  for (var r in t)
    Object.prototype.hasOwnProperty.call(t, r) && e.indexOf(r) < 0 && (n[r] = t[r]);
  if (t != null && typeof Object.getOwnPropertySymbols == "function")
    for (var i = 0, r = Object.getOwnPropertySymbols(t); i < r.length; i++)
      e.indexOf(r[i]) < 0 && Object.prototype.propertyIsEnumerable.call(t, r[i]) && (n[r[i]] = t[r[i]]);
  return n;
}, $xe = function(e) {
  var n = e.prefixCls, r = e.className, i = e.dashed, o = Rxe(e, ["prefixCls", "className", "dashed"]), a = x.useContext(en), s = a.getPrefixCls, u = s("menu", n), l = Ce(z({}, "".concat(u, "-item-divider-dashed"), !!i), r);
  return /* @__PURE__ */ x.createElement(DA, G({
    className: l
  }, o));
};
const jG = $xe;
var Dxe = /* @__PURE__ */ oi({
  prefixCls: "",
  firstLevel: !0,
  inlineCollapsed: !1
});
const xx = Dxe;
var Mxe = function(t, e) {
  var n = {};
  for (var r in t)
    Object.prototype.hasOwnProperty.call(t, r) && e.indexOf(r) < 0 && (n[r] = t[r]);
  if (t != null && typeof Object.getOwnPropertySymbols == "function")
    for (var i = 0, r = Object.getOwnPropertySymbols(t); i < r.length; i++)
      e.indexOf(r[i]) < 0 && Object.prototype.propertyIsEnumerable.call(t, r[i]) && (n[r[i]] = t[r[i]]);
  return n;
}, LA = /* @__PURE__ */ function(t) {
  Pr(n, t);
  var e = Hr(n);
  function n() {
    var r;
    return zn(this, n), r = e.apply(this, arguments), r.renderItem = function(i) {
      var o = i.siderCollapsed, a, s = r.context, u = s.prefixCls, l = s.firstLevel, c = s.inlineCollapsed, d = s.direction, f = s.disableMenuItemTitleTooltip, h = r.props, p = h.className, v = h.children, m = r.props, b = m.title, y = m.icon, w = m.danger, S = Mxe(m, ["title", "icon", "danger"]), E = b;
      typeof b > "u" ? E = l ? v : "" : b === !1 && (E = "");
      var I = {
        title: E
      };
      !o && !c && (I.title = null, I.open = !1);
      var _ = Xa(v).length, A = /* @__PURE__ */ x.createElement(xC, G({}, S, {
        className: Ce(z(z({}, "".concat(u, "-item-danger"), w), "".concat(u, "-item-only-child"), (y ? _ + 1 : _) === 1), p),
        title: typeof b == "string" ? b : void 0
      }), ji(y, {
        className: Ce(pa(y) ? (a = y.props) === null || a === void 0 ? void 0 : a.className : "", "".concat(u, "-item-icon"))
      }), r.renderItemChildren(c));
      return f || (A = /* @__PURE__ */ x.createElement(Ud, G({}, I, {
        placement: d === "rtl" ? "left" : "right",
        overlayClassName: "".concat(u, "-inline-collapsed-tooltip")
      }), A)), A;
    }, r;
  }
  return Gn(n, [{
    key: "renderItemChildren",
    value: function(i) {
      var o = this.context, a = o.prefixCls, s = o.firstLevel, u = this.props, l = u.icon, c = u.children, d = /* @__PURE__ */ x.createElement("span", {
        className: "".concat(a, "-title-content")
      }, c);
      return (!l || pa(c) && c.type === "span") && c && i && s && typeof c == "string" ? /* @__PURE__ */ x.createElement("div", {
        className: "".concat(a, "-inline-collapsed-noicon")
      }, c.charAt(0)) : d;
    }
  }, {
    key: "render",
    value: function() {
      return /* @__PURE__ */ x.createElement(FA.Consumer, null, this.renderItem);
    }
  }]), n;
}(x.Component);
LA.contextType = xx;
function zG(t) {
  var e, n = t.popupClassName, r = t.icon, i = t.title, o = t.theme, a = x.useContext(xx), s = a.prefixCls, u = a.inlineCollapsed, l = a.antdMenuTheme, c = Ep(), d;
  if (!r)
    d = u && !c.length && i && typeof i == "string" ? /* @__PURE__ */ x.createElement("div", {
      className: "".concat(s, "-inline-collapsed-noicon")
    }, i.charAt(0)) : /* @__PURE__ */ x.createElement("span", {
      className: "".concat(s, "-title-content")
    }, i);
  else {
    var f = pa(i) && i.type === "span";
    d = /* @__PURE__ */ x.createElement(x.Fragment, null, ji(r, {
      className: Ce(pa(r) ? (e = r.props) === null || e === void 0 ? void 0 : e.className : "", "".concat(s, "-item-icon"))
    }), f ? i : /* @__PURE__ */ x.createElement("span", {
      className: "".concat(s, "-title-content")
    }, i));
  }
  var h = x.useMemo(function() {
    return G(G({}, a), {
      firstLevel: !1
    });
  }, [a]);
  return /* @__PURE__ */ x.createElement(xx.Provider, {
    value: h
  }, /* @__PURE__ */ x.createElement(CC, G({}, Pi(t, ["icon"]), {
    title: d,
    popupClassName: Ce(s, "".concat(s, "-").concat(o || l), n)
  })));
}
var Fxe = function(t, e) {
  var n = {};
  for (var r in t)
    Object.prototype.hasOwnProperty.call(t, r) && e.indexOf(r) < 0 && (n[r] = t[r]);
  if (t != null && typeof Object.getOwnPropertySymbols == "function")
    for (var i = 0, r = Object.getOwnPropertySymbols(t); i < r.length; i++)
      e.indexOf(r[i]) < 0 && Object.prototype.propertyIsEnumerable.call(t, r[i]) && (n[r[i]] = t[r[i]]);
  return n;
};
function QI(t) {
  return (t || []).map(function(e, n) {
    if (e && _t(e) === "object") {
      var r = e, i = r.label, o = r.children, a = r.key, s = r.type, u = Fxe(r, ["label", "children", "key", "type"]), l = a ?? "tmp-".concat(n);
      return o || s === "group" ? s === "group" ? /* @__PURE__ */ x.createElement(wC, G({
        key: l
      }, u, {
        title: i
      }), QI(o)) : /* @__PURE__ */ x.createElement(zG, G({
        key: l
      }, u, {
        title: i
      }), QI(o)) : s === "divider" ? /* @__PURE__ */ x.createElement(jG, G({
        key: l
      }, u)) : /* @__PURE__ */ x.createElement(LA, G({
        key: l
      }, u), i);
    }
    return null;
  }).filter(function(e) {
    return e;
  });
}
function Lxe(t) {
  return x.useMemo(function() {
    return t && QI(t);
  }, [t]);
}
var Vxe = function(t, e) {
  var n = {};
  for (var r in t)
    Object.prototype.hasOwnProperty.call(t, r) && e.indexOf(r) < 0 && (n[r] = t[r]);
  if (t != null && typeof Object.getOwnPropertySymbols == "function")
    for (var i = 0, r = Object.getOwnPropertySymbols(t); i < r.length; i++)
      e.indexOf(r[i]) < 0 && Object.prototype.propertyIsEnumerable.call(t, r[i]) && (n[r[i]] = t[r[i]]);
  return n;
}, e_ = /* @__PURE__ */ x.createContext(null), Bxe = function(e) {
  var n = e.children, r = Vxe(e, ["children"]), i = x.useContext(e_), o = x.useMemo(function() {
    return G(G({}, i), r);
  }, [
    i,
    r.prefixCls,
    // restProps.expandIcon, Not mark as deps since this is a ReactNode
    r.mode,
    r.selectable
    // restProps.validator, Not mark as deps since this is a function
  ]);
  return /* @__PURE__ */ x.createElement(e_.Provider, {
    value: o
  }, n);
};
const eR = e_;
var Hxe = function(t, e) {
  var n = {};
  for (var r in t)
    Object.prototype.hasOwnProperty.call(t, r) && e.indexOf(r) < 0 && (n[r] = t[r]);
  if (t != null && typeof Object.getOwnPropertySymbols == "function")
    for (var i = 0, r = Object.getOwnPropertySymbols(t); i < r.length; i++)
      e.indexOf(r[i]) < 0 && Object.prototype.propertyIsEnumerable.call(t, r[i]) && (n[r[i]] = t[r[i]]);
  return n;
}, Wxe = /* @__PURE__ */ gt(function(t, e) {
  var n, r = x.useContext(eR) || {}, i = x.useContext(en), o = i.getPrefixCls, a = i.getPopupContainer, s = i.direction, u = o(), l = t.prefixCls, c = t.className, d = t.theme, f = d === void 0 ? "light" : d, h = t.expandIcon, p = t._internalDisableMenuItemTitleTooltip, v = t.inlineCollapsed, m = t.siderCollapsed, b = t.items, y = t.children, w = t.mode, S = t.selectable, E = t.onClick, I = Hxe(t, ["prefixCls", "className", "theme", "expandIcon", "_internalDisableMenuItemTitleTooltip", "inlineCollapsed", "siderCollapsed", "items", "children", "mode", "selectable", "onClick"]), _ = Pi(I, ["collapsedWidth"]), A = Lxe(b) || y;
  process.env.NODE_ENV !== "production" && gn(!("inlineCollapsed" in t && w !== "inline"), "Menu", "`inlineCollapsed` should only be used when `mode` is inline."), process.env.NODE_ENV !== "production" && gn(!(t.siderCollapsed !== void 0 && "inlineCollapsed" in t), "Menu", "`inlineCollapsed` not control Menu under Sider. Should set `collapsed` on Sider instead."), process.env.NODE_ENV !== "production" && gn("items" in t && !y, "Menu", "`children` will be removed in next major version. Please use `items` instead."), (n = r.validator) === null || n === void 0 || n.call(r, {
    mode: w
  });
  var P = Pd(function() {
    var B;
    E == null || E.apply(void 0, arguments), (B = r == null ? void 0 : r.onClick) === null || B === void 0 || B.call(r);
  }), N = r.mode || w, k = S ?? r.selectable, D = x.useMemo(function() {
    return m !== void 0 ? m : v;
  }, [v, m]), R = {
    horizontal: {
      motionName: "".concat(u, "-slide-up")
    },
    inline: mx,
    other: {
      motionName: "".concat(u, "-zoom-big")
    }
  }, V = o("menu", l || r.prefixCls), $ = Ce("".concat(V, "-").concat(f), c), F;
  typeof h == "function" ? F = h : F = ji(h || r.expandIcon, {
    className: "".concat(V, "-submenu-expand-icon")
  });
  var M = x.useMemo(function() {
    return {
      prefixCls: V,
      inlineCollapsed: D || !1,
      antdMenuTheme: f,
      direction: s,
      firstLevel: !0,
      disableMenuItemTitleTooltip: p
    };
  }, [V, D, f, s, p]);
  return /* @__PURE__ */ x.createElement(eR.Provider, {
    value: null
  }, /* @__PURE__ */ x.createElement(xx.Provider, {
    value: M
  }, /* @__PURE__ */ x.createElement(Lm, G({
    getPopupContainer: a,
    overflowedIndicator: /* @__PURE__ */ x.createElement(ij, null),
    overflowedIndicatorPopupClassName: "".concat(V, "-").concat(f),
    mode: N,
    selectable: k,
    onClick: P
  }, _, {
    inlineCollapsed: D,
    className: $,
    prefixCls: V,
    direction: s,
    defaultMotions: R,
    expandIcon: F,
    ref: e
  }), A)));
}), Vm = /* @__PURE__ */ function(t) {
  Pr(n, t);
  var e = Hr(n);
  function n() {
    var r;
    return zn(this, n), r = e.apply(this, arguments), r.focus = function(i) {
      var o;
      (o = r.menu) === null || o === void 0 || o.focus(i);
    }, r;
  }
  return Gn(n, [{
    key: "render",
    value: function() {
      var i = this;
      return /* @__PURE__ */ x.createElement(FA.Consumer, null, function(o) {
        return /* @__PURE__ */ x.createElement(Wxe, G({
          ref: function(s) {
            i.menu = s;
          }
        }, i.props, o));
      });
    }
  }]), n;
}(x.Component);
Vm.Divider = jG;
Vm.Item = LA;
Vm.SubMenu = zG;
Vm.ItemGroup = wC;
const GG = Vm;
var Mf = {
  adjustX: 1,
  adjustY: 1
}, Ff = [0, 0], jxe = {
  topLeft: {
    points: ["bl", "tl"],
    overflow: Mf,
    offset: [0, -4],
    targetOffset: Ff
  },
  topCenter: {
    points: ["bc", "tc"],
    overflow: Mf,
    offset: [0, -4],
    targetOffset: Ff
  },
  topRight: {
    points: ["br", "tr"],
    overflow: Mf,
    offset: [0, -4],
    targetOffset: Ff
  },
  bottomLeft: {
    points: ["tl", "bl"],
    overflow: Mf,
    offset: [0, 4],
    targetOffset: Ff
  },
  bottomCenter: {
    points: ["tc", "bc"],
    overflow: Mf,
    offset: [0, 4],
    targetOffset: Ff
  },
  bottomRight: {
    points: ["tr", "br"],
    overflow: Mf,
    offset: [0, 4],
    targetOffset: Ff
  }
}, zxe = ke.ESC, Gxe = ke.TAB;
function Uxe(t) {
  var e = t.visible, n = t.setTriggerVisible, r = t.triggerRef, i = t.onVisibleChange, o = t.autoFocus, a = x.useRef(!1), s = function() {
    if (e && r.current) {
      var d, f, h, p;
      (d = r.current) === null || d === void 0 || (f = d.triggerRef) === null || f === void 0 || (h = f.current) === null || h === void 0 || (p = h.focus) === null || p === void 0 || p.call(h), n(!1), typeof i == "function" && i(!1);
    }
  }, u = function() {
    var d, f, h, p, v = $G((d = r.current) === null || d === void 0 || (f = d.popupRef) === null || f === void 0 || (h = f.current) === null || h === void 0 || (p = h.getElement) === null || p === void 0 ? void 0 : p.call(h)), m = v[0];
    return m != null && m.focus ? (m.focus(), a.current = !0, !0) : !1;
  }, l = function(d) {
    switch (d.keyCode) {
      case zxe:
        s();
        break;
      case Gxe: {
        var f = !1;
        a.current || (f = u()), f ? d.preventDefault() : s();
        break;
      }
    }
  };
  x.useEffect(function() {
    return e ? (window.addEventListener("keydown", l), o && En(u, 3), function() {
      window.removeEventListener("keydown", l), a.current = !1;
    }) : function() {
      a.current = !1;
    };
  }, [e]);
}
var Xxe = ["arrow", "prefixCls", "transitionName", "animation", "align", "placement", "placements", "getPopupContainer", "showAction", "hideAction", "overlayClassName", "overlayStyle", "visible", "trigger", "autoFocus"];
function Yxe(t, e) {
  var n = t.arrow, r = n === void 0 ? !1 : n, i = t.prefixCls, o = i === void 0 ? "rc-dropdown" : i, a = t.transitionName, s = t.animation, u = t.align, l = t.placement, c = l === void 0 ? "bottomLeft" : l, d = t.placements, f = d === void 0 ? jxe : d, h = t.getPopupContainer, p = t.showAction, v = t.hideAction, m = t.overlayClassName, b = t.overlayStyle, y = t.visible, w = t.trigger, S = w === void 0 ? ["hover"] : w, E = t.autoFocus, I = Gt(t, Xxe), _ = x.useState(), A = be(_, 2), P = A[0], N = A[1], k = "visible" in t ? y : P, D = x.useRef(null);
  x.useImperativeHandle(e, function() {
    return D.current;
  }), Uxe({
    visible: k,
    setTriggerVisible: N,
    triggerRef: D,
    onVisibleChange: t.onVisibleChange,
    autoFocus: E
  });
  var R = function() {
    var W = t.overlay, Y;
    return typeof W == "function" ? Y = W() : Y = W, Y;
  }, V = function(W) {
    var Y = t.onOverlayClick;
    N(!1), Y && Y(W);
  }, $ = function(W) {
    var Y = t.onVisibleChange;
    N(W), typeof Y == "function" && Y(W);
  }, F = function() {
    var W = R();
    return /* @__PURE__ */ x.createElement(x.Fragment, null, r && /* @__PURE__ */ x.createElement("div", {
      className: "".concat(o, "-arrow")
    }), W);
  }, M = function() {
    var W = t.overlay;
    return typeof W == "function" ? F : F();
  }, B = function() {
    var W = t.minOverlayWidthMatchTrigger, Y = t.alignPoint;
    return "minOverlayWidthMatchTrigger" in t ? W : !Y;
  }, X = function() {
    var W = t.openClassName;
    return W !== void 0 ? W : "".concat(o, "-open");
  }, L = function() {
    var W = t.children, Y = W.props ? W.props : {}, U = Ce(Y.className, X());
    return k && W ? /* @__PURE__ */ x.cloneElement(W, {
      className: U
    }) : W;
  }, j = v;
  return !j && S.indexOf("contextMenu") !== -1 && (j = ["click"]), /* @__PURE__ */ x.createElement(Mm, de(de({
    builtinPlacements: f
  }, I), {}, {
    prefixCls: o,
    ref: D,
    popupClassName: Ce(m, z({}, "".concat(o, "-show-arrow"), r)),
    popupStyle: b,
    action: S,
    showAction: p,
    hideAction: j || [],
    popupPlacement: c,
    popupAlign: u,
    popupTransitionName: a,
    popupAnimation: s,
    popupVisible: k,
    stretch: B() ? "minWidth" : "",
    popup: M(),
    onPopupVisibleChange: $,
    onPopupClick: V,
    getPopupContainer: h
  }), L());
}
const Zxe = /* @__PURE__ */ x.forwardRef(Yxe);
var Jxe = 0, Vh = {};
function Cx(t) {
  var e = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 1, n = Jxe++, r = e;
  function i() {
    r -= 1, r <= 0 ? (t(), delete Vh[n]) : Vh[n] = En(i);
  }
  return Vh[n] = En(i), n;
}
Cx.cancel = function(e) {
  e !== void 0 && (En.cancel(Vh[e]), delete Vh[e]);
};
Cx.ids = Vh;
var zS;
function tR(t) {
  return process.env.NODE_ENV === "test" ? !1 : !t || t.offsetParent === null || t.hidden;
}
function Kxe(t) {
  return t instanceof Document ? t.body : Array.from(t.childNodes).find(function(e) {
    return (e == null ? void 0 : e.nodeType) === Node.ELEMENT_NODE;
  });
}
function qxe(t) {
  var e = (t || "").match(/rgba?\((\d*), (\d*), (\d*)(, [\d.]*)?\)/);
  return e && e[1] && e[2] && e[3] ? !(e[1] === e[2] && e[2] === e[3]) : !0;
}
var UG = /* @__PURE__ */ function(t) {
  Pr(n, t);
  var e = Hr(n);
  function n() {
    var r;
    return zn(this, n), r = e.apply(this, arguments), r.containerRef = /* @__PURE__ */ x.createRef(), r.animationStart = !1, r.destroyed = !1, r.onClick = function(i, o) {
      var a, s, u = r.props, l = u.insertExtraNode, c = u.disabled;
      if (!(c || !i || tR(i) || i.className.includes("-leave"))) {
        r.extraNode = document.createElement("div");
        var d = It(r), f = d.extraNode, h = r.context.getPrefixCls;
        f.className = "".concat(h(""), "-click-animating-node");
        var p = r.getAttributeName();
        if (i.setAttribute(p, "true"), o && o !== "#fff" && o !== "#ffffff" && o !== "rgb(255, 255, 255)" && o !== "rgba(255, 255, 255, 1)" && qxe(o) && !/rgba\((?:\d*, ){3}0\)/.test(o) && // any transparent rgba color
        o !== "transparent") {
          f.style.borderColor = o;
          var v = ((a = i.getRootNode) === null || a === void 0 ? void 0 : a.call(i)) || i.ownerDocument, m = (s = Kxe(v)) !== null && s !== void 0 ? s : v;
          zS = Z6(`
      [`.concat(h(""), "-click-animating-without-extra-node='true']::after, .").concat(h(""), `-click-animating-node {
        --antd-wave-shadow-color: `).concat(o, `;
      }`), "antd-wave", {
            csp: r.csp,
            attachTo: m
          });
        }
        l && i.appendChild(f), ["transition", "animation"].forEach(function(b) {
          i.addEventListener("".concat(b, "start"), r.onTransitionStart), i.addEventListener("".concat(b, "end"), r.onTransitionEnd);
        });
      }
    }, r.onTransitionStart = function(i) {
      if (!r.destroyed) {
        var o = r.containerRef.current;
        !i || i.target !== o || r.animationStart || r.resetEffect(o);
      }
    }, r.onTransitionEnd = function(i) {
      !i || i.animationName !== "fadeEffect" || r.resetEffect(i.target);
    }, r.bindAnimationEvent = function(i) {
      if (!(!i || !i.getAttribute || i.getAttribute("disabled") || i.className.includes("disabled"))) {
        var o = function(s) {
          if (!(s.target.tagName === "INPUT" || tR(s.target))) {
            r.resetEffect(i);
            var u = getComputedStyle(i).getPropertyValue("border-top-color") || // Firefox Compatible
            getComputedStyle(i).getPropertyValue("border-color") || getComputedStyle(i).getPropertyValue("background-color");
            r.clickWaveTimeoutId = window.setTimeout(function() {
              return r.onClick(i, u);
            }, 0), Cx.cancel(r.animationStartId), r.animationStart = !0, r.animationStartId = Cx(function() {
              r.animationStart = !1;
            }, 10);
          }
        };
        return i.addEventListener("click", o, !0), {
          cancel: function() {
            i.removeEventListener("click", o, !0);
          }
        };
      }
    }, r.renderWave = function(i) {
      var o = i.csp, a = r.props.children;
      if (r.csp = o, !/* @__PURE__ */ x.isValidElement(a))
        return a;
      var s = r.containerRef;
      return Rm(a) && (s = Ja(a.ref, r.containerRef)), ji(a, {
        ref: s
      });
    }, r;
  }
  return Gn(n, [{
    key: "componentDidMount",
    value: function() {
      this.destroyed = !1;
      var i = this.containerRef.current;
      !i || i.nodeType !== 1 || (this.instance = this.bindAnimationEvent(i));
    }
  }, {
    key: "componentWillUnmount",
    value: function() {
      this.instance && this.instance.cancel(), this.clickWaveTimeoutId && clearTimeout(this.clickWaveTimeoutId), this.destroyed = !0;
    }
  }, {
    key: "getAttributeName",
    value: function() {
      var i = this.context.getPrefixCls, o = this.props.insertExtraNode;
      return o ? "".concat(i(""), "-click-animating") : "".concat(i(""), "-click-animating-without-extra-node");
    }
  }, {
    key: "resetEffect",
    value: function(i) {
      var o = this;
      if (!(!i || i === this.extraNode || !(i instanceof Element))) {
        var a = this.props.insertExtraNode, s = this.getAttributeName();
        i.setAttribute(s, "false"), zS && (zS.innerHTML = ""), a && this.extraNode && i.contains(this.extraNode) && i.removeChild(this.extraNode), ["transition", "animation"].forEach(function(u) {
          i.removeEventListener("".concat(u, "start"), o.onTransitionStart), i.removeEventListener("".concat(u, "end"), o.onTransitionEnd);
        });
      }
    }
  }, {
    key: "render",
    value: function() {
      return /* @__PURE__ */ x.createElement(_c, null, this.renderWave);
    }
  }]), n;
}(x.Component);
UG.contextType = en;
const VA = UG;
var Qxe = function(t, e) {
  var n = {};
  for (var r in t)
    Object.prototype.hasOwnProperty.call(t, r) && e.indexOf(r) < 0 && (n[r] = t[r]);
  if (t != null && typeof Object.getOwnPropertySymbols == "function")
    for (var i = 0, r = Object.getOwnPropertySymbols(t); i < r.length; i++)
      e.indexOf(r[i]) < 0 && Object.prototype.propertyIsEnumerable.call(t, r[i]) && (n[r[i]] = t[r[i]]);
  return n;
}, XG = /* @__PURE__ */ x.createContext(void 0), e2e = function(e) {
  var n = x.useContext(en), r = n.getPrefixCls, i = n.direction, o = e.prefixCls, a = e.size, s = e.className, u = Qxe(e, ["prefixCls", "size", "className"]), l = r("btn-group", o), c = "";
  switch (a) {
    case "large":
      c = "lg";
      break;
    case "small":
      c = "sm";
      break;
    case "middle":
    case void 0:
      break;
    default:
      process.env.NODE_ENV !== "production" && gn(!a, "Button.Group", "Invalid prop `size`.");
  }
  var d = Ce(l, z(z({}, "".concat(l, "-").concat(c), c), "".concat(l, "-rtl"), i === "rtl"), s);
  return /* @__PURE__ */ x.createElement(XG.Provider, {
    value: a
  }, /* @__PURE__ */ x.createElement("div", G({}, u, {
    className: d
  })));
};
const t2e = e2e;
var GS = function() {
  return {
    width: 0,
    opacity: 0,
    transform: "scale(0)"
  };
}, US = function(e) {
  return {
    width: e.scrollWidth,
    opacity: 1,
    transform: "scale(1)"
  };
}, n2e = function(e) {
  var n = e.prefixCls, r = e.loading, i = e.existIcon, o = !!r;
  return i ? /* @__PURE__ */ O.createElement("span", {
    className: "".concat(n, "-loading-icon")
  }, /* @__PURE__ */ O.createElement(lc, null)) : /* @__PURE__ */ O.createElement(ll, {
    visible: o,
    // We do not really use this motionName
    motionName: "".concat(n, "-loading-icon-motion"),
    removeOnLeave: !0,
    onAppearStart: GS,
    onAppearActive: US,
    onEnterStart: GS,
    onEnterActive: US,
    onLeaveStart: US,
    onLeaveActive: GS
  }, function(a, s) {
    var u = a.className, l = a.style;
    return /* @__PURE__ */ O.createElement("span", {
      className: "".concat(n, "-loading-icon"),
      style: l,
      ref: s
    }, /* @__PURE__ */ O.createElement(lc, {
      className: u
    }));
  });
};
const r2e = n2e;
var i2e = function(t, e) {
  var n = {};
  for (var r in t)
    Object.prototype.hasOwnProperty.call(t, r) && e.indexOf(r) < 0 && (n[r] = t[r]);
  if (t != null && typeof Object.getOwnPropertySymbols == "function")
    for (var i = 0, r = Object.getOwnPropertySymbols(t); i < r.length; i++)
      e.indexOf(r[i]) < 0 && Object.prototype.propertyIsEnumerable.call(t, r[i]) && (n[r[i]] = t[r[i]]);
  return n;
}, nR = /^[\u4e00-\u9fa5]{2}$/, t_ = nR.test.bind(nR);
function o2e(t) {
  return typeof t == "string";
}
function q1(t) {
  return t === "text" || t === "link";
}
function a2e(t, e) {
  if (t != null) {
    var n = e ? " " : "";
    return typeof t != "string" && typeof t != "number" && o2e(t.type) && t_(t.props.children) ? ji(t, {
      children: t.props.children.split("").join(n)
    }) : typeof t == "string" ? t_(t) ? /* @__PURE__ */ x.createElement("span", null, t.split("").join(n)) : /* @__PURE__ */ x.createElement("span", null, t) : Nz(t) ? /* @__PURE__ */ x.createElement("span", null, t) : t;
  }
}
function s2e(t, e) {
  var n = !1, r = [];
  return x.Children.forEach(t, function(i) {
    var o = _t(i), a = o === "string" || o === "number";
    if (n && a) {
      var s = r.length - 1, u = r[s];
      r[s] = "".concat(u).concat(i);
    } else
      r.push(i);
    n = a;
  }), x.Children.map(r, function(i) {
    return a2e(i, e);
  });
}
Ki("default", "primary", "ghost", "dashed", "link", "text");
Ki("default", "circle", "round");
Ki("submit", "button", "reset");
var u2e = function(e, n) {
  var r, i = e.loading, o = i === void 0 ? !1 : i, a = e.prefixCls, s = e.type, u = s === void 0 ? "default" : s, l = e.danger, c = e.shape, d = c === void 0 ? "default" : c, f = e.size, h = e.disabled, p = e.className, v = e.children, m = e.icon, b = e.ghost, y = b === void 0 ? !1 : b, w = e.block, S = w === void 0 ? !1 : w, E = e.htmlType, I = E === void 0 ? "button" : E, _ = i2e(e, ["loading", "prefixCls", "type", "danger", "shape", "size", "disabled", "className", "children", "icon", "ghost", "block", "htmlType"]), A = x.useContext(qa), P = x.useContext(Ka), N = h ?? P, k = x.useContext(XG), D = x.useState(!!o), R = be(D, 2), V = R[0], $ = R[1], F = x.useState(!1), M = be(F, 2), B = M[0], X = M[1], L = x.useContext(en), j = L.getPrefixCls, K = L.autoInsertSpaceInButton, W = L.direction, Y = n || /* @__PURE__ */ x.createRef(), U = function() {
    return x.Children.count(v) === 1 && !m && !q1(u);
  }, Q = function() {
    if (!(!Y || !Y.current || K === !1)) {
      var we = Y.current.textContent;
      U() && t_(we) ? B || X(!0) : B && X(!1);
    }
  }, Z = typeof o == "boolean" ? o : (o == null ? void 0 : o.delay) || !0;
  x.useEffect(function() {
    var Ae = null;
    return typeof Z == "number" ? Ae = window.setTimeout(function() {
      Ae = null, $(Z);
    }, Z) : $(Z), function() {
      Ae && (window.clearTimeout(Ae), Ae = null);
    };
  }, [Z]), x.useEffect(Q, [Y]);
  var ee = function(we) {
    var ce = e.onClick;
    if (V || N) {
      we.preventDefault();
      return;
    }
    ce == null || ce(we);
  };
  process.env.NODE_ENV !== "production" && gn(!(typeof m == "string" && m.length > 2), "Button", "`icon` is using ReactNode instead of string naming in v4. Please check `".concat(m, "` at https://ant.design/components/icon")), process.env.NODE_ENV !== "production" && gn(!(y && q1(u)), "Button", "`link` or `text` button can't be a `ghost` button.");
  var ie = j("btn", a), oe = K !== !1, se = Tc(ie, W), te = se.compactSize, ge = se.compactItemClassnames, he = {
    large: "lg",
    small: "sm",
    middle: void 0
  }, fe = te || k || f || A, _e = fe && he[fe] || "", Ne = V ? "loading" : m, ze = Pi(_, ["navigate"]), Ve = Ce(ie, (r = {}, z(z(z(z(z(z(z(z(z(z(r, "".concat(ie, "-").concat(d), d !== "default" && d), "".concat(ie, "-").concat(u), u), "".concat(ie, "-").concat(_e), _e), "".concat(ie, "-icon-only"), !v && v !== 0 && !!Ne), "".concat(ie, "-background-ghost"), y && !q1(u)), "".concat(ie, "-loading"), V), "".concat(ie, "-two-chinese-chars"), B && oe && !V), "".concat(ie, "-block"), S), "".concat(ie, "-dangerous"), !!l), "".concat(ie, "-rtl"), W === "rtl"), z(r, "".concat(ie, "-disabled"), ze.href !== void 0 && N)), ge, p), ne = m && !V ? m : /* @__PURE__ */ x.createElement(r2e, {
    existIcon: !!m,
    prefixCls: ie,
    loading: !!V
  }), pe = v || v === 0 ? s2e(v, U() && oe) : null;
  if (ze.href !== void 0)
    return /* @__PURE__ */ x.createElement("a", G({}, ze, {
      className: Ve,
      onClick: ee,
      ref: Y
    }), ne, pe);
  var ye = /* @__PURE__ */ x.createElement("button", G({}, _, {
    type: I,
    className: Ve,
    onClick: ee,
    disabled: N,
    ref: Y
  }), ne, pe);
  return q1(u) ? ye : /* @__PURE__ */ x.createElement(VA, {
    disabled: !!V
  }, ye);
}, SC = /* @__PURE__ */ x.forwardRef(u2e);
process.env.NODE_ENV !== "production" && (SC.displayName = "Button");
SC.Group = t2e;
SC.__ANT_BUTTON = !0;
const ko = SC;
var l2e = function() {
  return yu() && window.document.documentElement;
}, Q1, c2e = function() {
  if (!l2e())
    return !1;
  if (Q1 !== void 0)
    return Q1;
  var e = document.createElement("div");
  return e.style.display = "flex", e.style.flexDirection = "column", e.style.rowGap = "1px", e.appendChild(document.createElement("div")), e.appendChild(document.createElement("div")), document.body.appendChild(e), Q1 = e.scrollHeight === 1, document.body.removeChild(e), Q1;
};
const YG = function() {
  var t = x.useState(!1), e = be(t, 2), n = e[0], r = e[1];
  return x.useEffect(function() {
    r(c2e());
  }, []), n;
};
function d2e(t) {
  var e = t.className, n = t.direction, r = t.index, i = t.marginDirection, o = t.children, a = t.split, s = t.wrap, u = x.useContext(ZG), l = u.horizontalSize, c = u.verticalSize, d = u.latestIndex, f = u.supportFlexGap, h = {};
  return f || (n === "vertical" ? r < d && (h = {
    marginBottom: l / (a ? 2 : 1)
  }) : h = G(G({}, r < d && z({}, i, l / (a ? 2 : 1))), s && {
    paddingBottom: c
  })), o == null ? null : /* @__PURE__ */ x.createElement(x.Fragment, null, /* @__PURE__ */ x.createElement("div", {
    className: e,
    style: h
  }, o), r < d && a && /* @__PURE__ */ x.createElement("span", {
    className: "".concat(e, "-split"),
    style: h
  }, a));
}
var f2e = function(t, e) {
  var n = {};
  for (var r in t)
    Object.prototype.hasOwnProperty.call(t, r) && e.indexOf(r) < 0 && (n[r] = t[r]);
  if (t != null && typeof Object.getOwnPropertySymbols == "function")
    for (var i = 0, r = Object.getOwnPropertySymbols(t); i < r.length; i++)
      e.indexOf(r[i]) < 0 && Object.prototype.propertyIsEnumerable.call(t, r[i]) && (n[r[i]] = t[r[i]]);
  return n;
}, ZG = /* @__PURE__ */ x.createContext({
  latestIndex: 0,
  horizontalSize: 0,
  verticalSize: 0,
  supportFlexGap: !1
}), h2e = {
  small: 8,
  middle: 16,
  large: 24
};
function p2e(t) {
  return typeof t == "string" ? h2e[t] : t || 0;
}
var g2e = function(e) {
  var n = x.useContext(en), r = n.getPrefixCls, i = n.space, o = n.direction, a = e.size, s = a === void 0 ? (i == null ? void 0 : i.size) || "small" : a, u = e.align, l = e.className, c = e.children, d = e.direction, f = d === void 0 ? "horizontal" : d, h = e.prefixCls, p = e.split, v = e.style, m = e.wrap, b = m === void 0 ? !1 : m, y = f2e(e, ["size", "align", "className", "children", "direction", "prefixCls", "split", "style", "wrap"]), w = YG(), S = x.useMemo(function() {
    return (Array.isArray(s) ? s : [s, s]).map(function(B) {
      return p2e(B);
    });
  }, [s]), E = be(S, 2), I = E[0], _ = E[1], A = Xa(c, {
    keepEmpty: !0
  }), P = u === void 0 && f === "horizontal" ? "center" : u, N = r("space", h), k = Ce(N, "".concat(N, "-").concat(f), z(z({}, "".concat(N, "-rtl"), o === "rtl"), "".concat(N, "-align-").concat(P), P), l), D = "".concat(N, "-item"), R = o === "rtl" ? "marginLeft" : "marginRight", V = 0, $ = A.map(function(B, X) {
    B != null && (V = X);
    var L = B && B.key || "".concat(D, "-").concat(X);
    return /* @__PURE__ */ x.createElement(d2e, {
      className: D,
      key: L,
      direction: f,
      index: X,
      marginDirection: R,
      split: p,
      wrap: b
    }, B);
  }), F = x.useMemo(function() {
    return {
      horizontalSize: I,
      verticalSize: _,
      latestIndex: V,
      supportFlexGap: w
    };
  }, [I, _, V, w]);
  if (A.length === 0)
    return null;
  var M = {};
  return b && (M.flexWrap = "wrap", w || (M.marginBottom = -_)), w && (M.columnGap = I, M.rowGap = _), /* @__PURE__ */ x.createElement("div", G({
    className: k,
    style: G(G({}, M), v)
  }, y), /* @__PURE__ */ x.createElement(ZG.Provider, {
    value: F
  }, $));
}, JG = g2e;
JG.Compact = _ye;
const X0 = JG;
var m2e = function(t, e) {
  var n = {};
  for (var r in t)
    Object.prototype.hasOwnProperty.call(t, r) && e.indexOf(r) < 0 && (n[r] = t[r]);
  if (t != null && typeof Object.getOwnPropertySymbols == "function")
    for (var i = 0, r = Object.getOwnPropertySymbols(t); i < r.length; i++)
      e.indexOf(r[i]) < 0 && Object.prototype.propertyIsEnumerable.call(t, r[i]) && (n[r[i]] = t[r[i]]);
  return n;
}, KG = function(e) {
  var n = x.useContext(en), r = n.getPopupContainer, i = n.getPrefixCls, o = n.direction, a = e.prefixCls, s = e.type, u = s === void 0 ? "default" : s, l = e.danger, c = e.disabled, d = e.loading, f = e.onClick, h = e.htmlType, p = e.children, v = e.className, m = e.menu, b = e.arrow, y = e.autoFocus, w = e.overlay, S = e.trigger, E = e.align, I = e.visible, _ = e.open, A = e.onVisibleChange, P = e.onOpenChange, N = e.placement, k = e.getPopupContainer, D = e.href, R = e.icon, V = R === void 0 ? /* @__PURE__ */ x.createElement(ij, null) : R, $ = e.title, F = e.buttonsRender, M = F === void 0 ? function(_e) {
    return _e;
  } : F, B = e.mouseEnterDelay, X = e.mouseLeaveDelay, L = e.overlayClassName, j = e.overlayStyle, K = e.destroyPopupOnHide, W = m2e(e, ["prefixCls", "type", "danger", "disabled", "loading", "onClick", "htmlType", "children", "className", "menu", "arrow", "autoFocus", "overlay", "trigger", "align", "visible", "open", "onVisibleChange", "onOpenChange", "placement", "getPopupContainer", "href", "icon", "title", "buttonsRender", "mouseEnterDelay", "mouseLeaveDelay", "overlayClassName", "overlayStyle", "destroyPopupOnHide"]), Y = i("dropdown-button", a), U = {
    menu: m,
    arrow: b,
    autoFocus: y,
    align: E,
    disabled: c,
    trigger: c ? [] : S,
    onOpenChange: P || A,
    getPopupContainer: k || r,
    mouseEnterDelay: B,
    mouseLeaveDelay: X,
    overlayClassName: L,
    overlayStyle: j,
    destroyPopupOnHide: K
  }, Q = Tc(Y, o), Z = Q.compactSize, ee = Q.compactItemClassnames, ie = Ce(Y, ee, v);
  "overlay" in e && (U.overlay = w), "open" in e ? U.open = _ : "visible" in e && (U.open = I), "placement" in e ? U.placement = N : U.placement = o === "rtl" ? "bottomLeft" : "bottomRight";
  var oe = /* @__PURE__ */ x.createElement(ko, {
    type: u,
    danger: l,
    disabled: c,
    loading: d,
    onClick: f,
    htmlType: h,
    href: D,
    title: $
  }, p), se = /* @__PURE__ */ x.createElement(ko, {
    type: u,
    danger: l,
    icon: V
  }), te = M([oe, se]), ge = be(te, 2), he = ge[0], fe = ge[1];
  return /* @__PURE__ */ x.createElement(X0.Compact, G({
    className: ie,
    size: Z,
    block: !0
  }, W), he, /* @__PURE__ */ x.createElement(IC, G({}, U), fe));
};
KG.__ANT_BUTTON = !0;
const v2e = KG;
Ki("topLeft", "topCenter", "topRight", "bottomLeft", "bottomCenter", "bottomRight", "top", "bottom");
var qG = function(e) {
  var n = x.useContext(en), r = n.getPopupContainer, i = n.getPrefixCls, o = n.direction;
  process.env.NODE_ENV !== "production" && ([["visible", "open"], ["onVisibleChange", "onOpenChange"]].forEach(function(U) {
    var Q = be(U, 2), Z = Q[0], ee = Q[1];
    process.env.NODE_ENV !== "production" && gn(!(Z in e), "Dropdown", "`".concat(Z, "` is deprecated which will be removed in next major version, please use `").concat(ee, "` instead."));
  }), process.env.NODE_ENV !== "production" && gn(!("overlay" in e), "Dropdown", "`overlay` is deprecated. Please use `menu` instead."));
  var a = function() {
    var Q = i(), Z = e.placement, ee = Z === void 0 ? "" : Z, ie = e.transitionName;
    return ie !== void 0 ? ie : ee.includes("top") ? "".concat(Q, "-slide-down") : "".concat(Q, "-slide-up");
  }, s = function() {
    var Q = e.placement;
    if (!Q)
      return o === "rtl" ? "bottomRight" : "bottomLeft";
    if (Q.includes("Center")) {
      var Z = Q.slice(0, Q.indexOf("Center"));
      return process.env.NODE_ENV !== "production" && gn(!Q.includes("Center"), "Dropdown", "You are using '".concat(Q, "' placement in Dropdown, which is deprecated. Try to use '").concat(Z, "' instead.")), Z;
    }
    return Q;
  }, u = e.menu, l = e.arrow, c = e.prefixCls, d = e.children, f = e.trigger, h = e.disabled, p = e.dropdownRender, v = e.getPopupContainer, m = e.overlayClassName, b = e.visible, y = e.open, w = e.onVisibleChange, S = e.onOpenChange, E = e.mouseEnterDelay, I = E === void 0 ? 0.15 : E, _ = e.mouseLeaveDelay, A = _ === void 0 ? 0.1 : _, P = e.autoAdjustOverflow, N = P === void 0 ? !0 : P, k = i("dropdown", c), D = x.Children.only(d), R = ji(D, {
    className: Ce("".concat(k, "-trigger"), z({}, "".concat(k, "-rtl"), o === "rtl"), D.props.className),
    disabled: h
  }), V = h ? [] : f, $;
  V && V.includes("contextMenu") && ($ = !0);
  var F = Tr(!1, {
    value: y !== void 0 ? y : b
  }), M = be(F, 2), B = M[0], X = M[1], L = Pd(function(U) {
    w == null || w(U), S == null || S(U), X(U);
  }), j = Ce(m, z({}, "".concat(k, "-rtl"), o === "rtl")), K = _G({
    arrowPointAtCenter: _t(l) === "object" && l.pointAtCenter,
    autoAdjustOverflow: N
  }), W = x.useCallback(function() {
    X(!1);
  }, []), Y = function() {
    var Q = e.overlay, Z;
    return u != null && u.items ? Z = /* @__PURE__ */ x.createElement(GG, G({}, u)) : typeof Q == "function" ? Z = Q() : Z = Q, p && (Z = p(Z)), Z = x.Children.only(typeof Z == "string" ? /* @__PURE__ */ x.createElement("span", null, Z) : Z), /* @__PURE__ */ x.createElement(Bxe, {
      prefixCls: "".concat(k, "-menu"),
      expandIcon: /* @__PURE__ */ x.createElement("span", {
        className: "".concat(k, "-menu-submenu-arrow")
      }, /* @__PURE__ */ x.createElement(Qh, {
        className: "".concat(k, "-menu-submenu-arrow-icon")
      })),
      mode: "vertical",
      selectable: !1,
      onClick: W,
      validator: function(ie) {
        var oe = ie.mode;
        process.env.NODE_ENV !== "production" && gn(!oe || oe === "vertical", "Dropdown", 'mode="'.concat(oe, `" is not supported for Dropdown's Menu.`));
      }
    }, /* @__PURE__ */ x.createElement(G0, null, Z));
  };
  return /* @__PURE__ */ x.createElement(Zxe, G({
    alignPoint: $
  }, e, {
    mouseEnterDelay: I,
    mouseLeaveDelay: A,
    visible: B,
    builtinPlacements: K,
    arrow: !!l,
    overlayClassName: j,
    prefixCls: k,
    getPopupContainer: v || r,
    transitionName: a(),
    trigger: V,
    overlay: Y,
    placement: s(),
    onVisibleChange: L
  }), R);
};
qG.Button = v2e;
const IC = qG;
function b2e(t) {
  return function(e) {
    return e == null ? void 0 : e[t];
  };
}
var QG = b2e, y2e = QG, x2e = y2e("length"), C2e = x2e, eU = "\\ud800-\\udfff", w2e = "\\u0300-\\u036f", E2e = "\\ufe20-\\ufe2f", S2e = "\\u20d0-\\u20ff", I2e = w2e + E2e + S2e, _2e = "\\ufe0e\\ufe0f", A2e = "[" + eU + "]", n_ = "[" + I2e + "]", r_ = "\\ud83c[\\udffb-\\udfff]", T2e = "(?:" + n_ + "|" + r_ + ")", tU = "[^" + eU + "]", nU = "(?:\\ud83c[\\udde6-\\uddff]){2}", rU = "[\\ud800-\\udbff][\\udc00-\\udfff]", O2e = "\\u200d", iU = T2e + "?", oU = "[" + _2e + "]?", P2e = "(?:" + O2e + "(?:" + [tU, nU, rU].join("|") + ")" + oU + iU + ")*", N2e = oU + iU + P2e, k2e = "(?:" + [tU + n_ + "?", n_, nU, rU, A2e].join("|") + ")", rR = RegExp(r_ + "(?=" + r_ + ")|" + k2e + N2e, "g");
function R2e(t) {
  for (var e = rR.lastIndex = 0; rR.test(t); )
    ++e;
  return e;
}
var $2e = R2e, D2e = C2e, M2e = aC, F2e = $2e;
function L2e(t) {
  return M2e(t) ? F2e(t) : D2e(t);
}
var V2e = L2e, B2e = /\s/;
function H2e(t) {
  for (var e = t.length; e-- && B2e.test(t.charAt(e)); )
    ;
  return e;
}
var W2e = H2e, j2e = W2e, z2e = /^\s+/;
function G2e(t) {
  return t && t.slice(0, j2e(t) + 1).replace(z2e, "");
}
var aU = G2e;
function U2e(t) {
  var e = typeof t;
  return t != null && (e == "object" || e == "function");
}
var Ds = U2e, X2e = aU, iR = Ds, Y2e = oC, oR = NaN, Z2e = /^[-+]0x[0-9a-f]+$/i, J2e = /^0b[01]+$/i, K2e = /^0o[0-7]+$/i, q2e = parseInt;
function Q2e(t) {
  if (typeof t == "number")
    return t;
  if (Y2e(t))
    return oR;
  if (iR(t)) {
    var e = typeof t.valueOf == "function" ? t.valueOf() : t;
    t = iR(e) ? e + "" : e;
  }
  if (typeof t != "string")
    return t === 0 ? t : +t;
  t = X2e(t);
  var n = J2e.test(t);
  return n || K2e.test(t) ? q2e(t.slice(2), n ? 2 : 8) : Z2e.test(t) ? oR : +t;
}
var sU = Q2e, eCe = sU, aR = 1 / 0, tCe = 17976931348623157e292;
function nCe(t) {
  if (!t)
    return t === 0 ? t : 0;
  if (t = eCe(t), t === aR || t === -aR) {
    var e = t < 0 ? -1 : 1;
    return e * tCe;
  }
  return t === t ? t : 0;
}
var rCe = nCe, iCe = rCe;
function oCe(t) {
  var e = iCe(t), n = e % 1;
  return e === e ? n ? e - n : e : 0;
}
var aCe = oCe, ga = /* @__PURE__ */ x.createContext({}), eb = {
  visibility: "hidden"
};
function Sp(t) {
  var e = t.prefixCls, n = t.prevIcon, r = n === void 0 ? "‹" : n, i = t.nextIcon, o = i === void 0 ? "›" : i, a = t.superPrevIcon, s = a === void 0 ? "«" : a, u = t.superNextIcon, l = u === void 0 ? "»" : u, c = t.onSuperPrev, d = t.onSuperNext, f = t.onPrev, h = t.onNext, p = t.children, v = x.useContext(ga), m = v.hideNextBtn, b = v.hidePrevBtn;
  return /* @__PURE__ */ x.createElement("div", {
    className: e
  }, c && /* @__PURE__ */ x.createElement("button", {
    type: "button",
    onClick: c,
    tabIndex: -1,
    className: "".concat(e, "-super-prev-btn"),
    style: b ? eb : {}
  }, s), f && /* @__PURE__ */ x.createElement("button", {
    type: "button",
    onClick: f,
    tabIndex: -1,
    className: "".concat(e, "-prev-btn"),
    style: b ? eb : {}
  }, r), /* @__PURE__ */ x.createElement("div", {
    className: "".concat(e, "-view")
  }, p), h && /* @__PURE__ */ x.createElement("button", {
    type: "button",
    onClick: h,
    tabIndex: -1,
    className: "".concat(e, "-next-btn"),
    style: m ? eb : {}
  }, o), d && /* @__PURE__ */ x.createElement("button", {
    type: "button",
    onClick: d,
    tabIndex: -1,
    className: "".concat(e, "-super-next-btn"),
    style: m ? eb : {}
  }, l));
}
function sCe(t) {
  var e = t.prefixCls, n = t.generateConfig, r = t.viewDate, i = t.onPrevDecades, o = t.onNextDecades, a = x.useContext(ga), s = a.hideHeader;
  if (s)
    return null;
  var u = "".concat(e, "-header"), l = n.getYear(r), c = Math.floor(l / Yu) * Yu, d = c + Yu - 1;
  return /* @__PURE__ */ x.createElement(Sp, G({}, t, {
    prefixCls: u,
    onSuperPrev: i,
    onSuperNext: o
  }), c, "-", d);
}
function uU(t, e, n, r, i) {
  var o = t.setHour(e, n);
  return o = t.setMinute(o, r), o = t.setSecond(o, i), o;
}
function lU(t, e, n) {
  if (!n)
    return e;
  var r = e;
  return r = t.setHour(r, t.getHour(n)), r = t.setMinute(r, t.getMinute(n)), r = t.setSecond(r, t.getSecond(n)), r;
}
function uCe(t, e, n, r, i, o) {
  var a = Math.floor(t / r) * r;
  if (a < t)
    return [a, 60 - i, 60 - o];
  var s = Math.floor(e / i) * i;
  if (s < e)
    return [a, s, 60 - o];
  var u = Math.floor(n / o) * o;
  return [a, s, u];
}
function lCe(t, e) {
  var n = t.getYear(e), r = t.getMonth(e) + 1, i = t.getEndDate(t.getFixedDate("".concat(n, "-").concat(r, "-01"))), o = t.getDate(i), a = r < 10 ? "0".concat(r) : "".concat(r);
  return "".concat(n, "-").concat(a, "-").concat(o);
}
function Bm(t) {
  for (var e = t.prefixCls, n = t.disabledDate, r = t.onSelect, i = t.picker, o = t.rowNum, a = t.colNum, s = t.prefixColumn, u = t.rowClassName, l = t.baseDate, c = t.getCellClassName, d = t.getCellText, f = t.getCellNode, h = t.getCellDate, p = t.generateConfig, v = t.titleCell, m = t.headerCells, b = x.useContext(ga), y = b.onDateMouseEnter, w = b.onDateMouseLeave, S = b.mode, E = "".concat(e, "-cell"), I = [], _ = 0; _ < o; _ += 1) {
    for (var A = [], P = void 0, N = function() {
      var R, V = _ * a + k, $ = h(l, V), F = s_({
        cellDate: $,
        mode: S,
        disabledDate: n,
        generateConfig: p
      });
      k === 0 && (P = $, s && A.push(s(P)));
      var M = v && v($);
      A.push(/* @__PURE__ */ x.createElement("td", {
        key: k,
        title: M,
        className: Ce(E, de((R = {}, z(R, "".concat(E, "-disabled"), F), z(R, "".concat(E, "-start"), d($) === 1 || i === "year" && Number(M) % 10 === 0), z(R, "".concat(E, "-end"), M === lCe(p, $) || i === "year" && Number(M) % 10 === 9), R), c($))),
        onClick: function() {
          F || r($);
        },
        onMouseEnter: function() {
          !F && y && y($);
        },
        onMouseLeave: function() {
          !F && w && w($);
        }
      }, f ? f($) : /* @__PURE__ */ x.createElement("div", {
        className: "".concat(E, "-inner")
      }, d($))));
    }, k = 0; k < a; k += 1)
      N();
    I.push(/* @__PURE__ */ x.createElement("tr", {
      key: _,
      className: u && u(P)
    }, A));
  }
  return /* @__PURE__ */ x.createElement("div", {
    className: "".concat(e, "-body")
  }, /* @__PURE__ */ x.createElement("table", {
    className: "".concat(e, "-content")
  }, m && /* @__PURE__ */ x.createElement("thead", null, /* @__PURE__ */ x.createElement("tr", null, m)), /* @__PURE__ */ x.createElement("tbody", null, I)));
}
var i_ = 3, sR = 4;
function cCe(t) {
  var e = Es - 1, n = t.prefixCls, r = t.viewDate, i = t.generateConfig, o = "".concat(n, "-cell"), a = i.getYear(r), s = Math.floor(a / Es) * Es, u = Math.floor(a / Yu) * Yu, l = u + Yu - 1, c = i.setYear(r, u - Math.ceil((i_ * sR * Es - Yu) / 2)), d = function(h) {
    var p, v = i.getYear(h), m = v + e;
    return p = {}, z(p, "".concat(o, "-in-view"), u <= v && m <= l), z(p, "".concat(o, "-selected"), v === s), p;
  };
  return /* @__PURE__ */ x.createElement(Bm, G({}, t, {
    rowNum: sR,
    colNum: i_,
    baseDate: c,
    getCellText: function(h) {
      var p = i.getYear(h);
      return "".concat(p, "-").concat(p + e);
    },
    getCellClassName: d,
    getCellDate: function(h, p) {
      return i.addYear(h, p * Es);
    }
  }));
}
var tb = /* @__PURE__ */ new Map();
function dCe(t, e) {
  var n;
  function r() {
    yA(t) ? e() : n = En(function() {
      r();
    });
  }
  return r(), function() {
    En.cancel(n);
  };
}
function o_(t, e, n) {
  if (tb.get(t) && cancelAnimationFrame(tb.get(t)), n <= 0) {
    tb.set(t, requestAnimationFrame(function() {
      t.scrollTop = e;
    }));
    return;
  }
  var r = e - t.scrollTop, i = r / n * 10;
  tb.set(t, requestAnimationFrame(function() {
    t.scrollTop += i, t.scrollTop !== e && o_(t, e, n - 10);
  }));
}
function Ip(t, e) {
  var n = e.onLeftRight, r = e.onCtrlLeftRight, i = e.onUpDown, o = e.onPageUpDown, a = e.onEnter, s = t.which, u = t.ctrlKey, l = t.metaKey;
  switch (s) {
    case ke.LEFT:
      if (u || l) {
        if (r)
          return r(-1), !0;
      } else if (n)
        return n(-1), !0;
      break;
    case ke.RIGHT:
      if (u || l) {
        if (r)
          return r(1), !0;
      } else if (n)
        return n(1), !0;
      break;
    case ke.UP:
      if (i)
        return i(-1), !0;
      break;
    case ke.DOWN:
      if (i)
        return i(1), !0;
      break;
    case ke.PAGE_UP:
      if (o)
        return o(-1), !0;
      break;
    case ke.PAGE_DOWN:
      if (o)
        return o(1), !0;
      break;
    case ke.ENTER:
      if (a)
        return a(), !0;
      break;
  }
  return !1;
}
function cU(t, e, n, r) {
  var i = t;
  if (!i)
    switch (e) {
      case "time":
        i = r ? "hh:mm:ss a" : "HH:mm:ss";
        break;
      case "week":
        i = "gggg-wo";
        break;
      case "month":
        i = "YYYY-MM";
        break;
      case "quarter":
        i = "YYYY-[Q]Q";
        break;
      case "year":
        i = "YYYY";
        break;
      default:
        i = n ? "YYYY-MM-DD HH:mm:ss" : "YYYY-MM-DD";
    }
  return i;
}
function dU(t, e, n) {
  var r = t === "time" ? 8 : 10, i = typeof e == "function" ? e(n.getNow()).length : e.length;
  return Math.max(r, i) + 2;
}
var Og = null, nb = /* @__PURE__ */ new Set();
function fCe(t) {
  return !Og && typeof window < "u" && window.addEventListener && (Og = function(n) {
    Ye(nb).forEach(function(r) {
      r(n);
    });
  }, window.addEventListener("mousedown", Og)), nb.add(t), function() {
    nb.delete(t), nb.size === 0 && (window.removeEventListener("mousedown", Og), Og = null);
  };
}
function hCe(t) {
  var e = t.target;
  if (t.composed && e.shadowRoot) {
    var n;
    return ((n = t.composedPath) === null || n === void 0 ? void 0 : n.call(t)[0]) || e;
  }
  return e;
}
var pCe = function(e) {
  return e === "month" || e === "date" ? "year" : e;
}, gCe = function(e) {
  return e === "date" ? "month" : e;
}, mCe = function(e) {
  return e === "month" || e === "date" ? "quarter" : e;
}, vCe = function(e) {
  return e === "date" ? "week" : e;
}, bCe = {
  year: pCe,
  month: gCe,
  quarter: mCe,
  week: vCe,
  time: null,
  date: null
};
function fU(t, e) {
  return t.some(function(n) {
    return n && n.contains(e);
  });
}
var Es = 10, Yu = Es * 10;
function yCe(t) {
  var e = t.prefixCls, n = t.onViewDateChange, r = t.generateConfig, i = t.viewDate, o = t.operationRef, a = t.onSelect, s = t.onPanelChange, u = "".concat(e, "-decade-panel");
  o.current = {
    onKeyDown: function(f) {
      return Ip(f, {
        onLeftRight: function(p) {
          a(r.addYear(i, p * Es), "key");
        },
        onCtrlLeftRight: function(p) {
          a(r.addYear(i, p * Yu), "key");
        },
        onUpDown: function(p) {
          a(r.addYear(i, p * Es * i_), "key");
        },
        onEnter: function() {
          s("year", i);
        }
      });
    }
  };
  var l = function(f) {
    var h = r.addYear(i, f * Yu);
    n(h), s(null, h);
  }, c = function(f) {
    a(f, "mouse"), s("year", f);
  };
  return /* @__PURE__ */ x.createElement("div", {
    className: u
  }, /* @__PURE__ */ x.createElement(sCe, G({}, t, {
    prefixCls: e,
    onPrevDecades: function() {
      l(-1);
    },
    onNextDecades: function() {
      l(1);
    }
  })), /* @__PURE__ */ x.createElement(cCe, G({}, t, {
    prefixCls: e,
    onSelect: c
  })));
}
var p0 = 7;
function Xd(t, e) {
  if (!t && !e)
    return !0;
  if (!t || !e)
    return !1;
}
function xCe(t, e, n) {
  var r = Xd(e, n);
  if (typeof r == "boolean")
    return r;
  var i = Math.floor(t.getYear(e) / 10), o = Math.floor(t.getYear(n) / 10);
  return i === o;
}
function Hm(t, e, n) {
  var r = Xd(e, n);
  return typeof r == "boolean" ? r : t.getYear(e) === t.getYear(n);
}
function a_(t, e) {
  var n = Math.floor(t.getMonth(e) / 3);
  return n + 1;
}
function hU(t, e, n) {
  var r = Xd(e, n);
  return typeof r == "boolean" ? r : Hm(t, e, n) && a_(t, e) === a_(t, n);
}
function BA(t, e, n) {
  var r = Xd(e, n);
  return typeof r == "boolean" ? r : Hm(t, e, n) && t.getMonth(e) === t.getMonth(n);
}
function Zu(t, e, n) {
  var r = Xd(e, n);
  return typeof r == "boolean" ? r : t.getYear(e) === t.getYear(n) && t.getMonth(e) === t.getMonth(n) && t.getDate(e) === t.getDate(n);
}
function CCe(t, e, n) {
  var r = Xd(e, n);
  return typeof r == "boolean" ? r : t.getHour(e) === t.getHour(n) && t.getMinute(e) === t.getMinute(n) && t.getSecond(e) === t.getSecond(n);
}
function pU(t, e, n, r) {
  var i = Xd(n, r);
  return typeof i == "boolean" ? i : Hm(t, n, r) && t.locale.getWeek(e, n) === t.locale.getWeek(e, r);
}
function rp(t, e, n) {
  return Zu(t, e, n) && CCe(t, e, n);
}
function rb(t, e, n, r) {
  return !e || !n || !r ? !1 : !Zu(t, e, r) && !Zu(t, n, r) && t.isAfter(r, e) && t.isAfter(n, r);
}
function wCe(t, e, n) {
  var r = e.locale.getWeekFirstDay(t), i = e.setDate(n, 1), o = e.getWeekDay(i), a = e.addDate(i, r - o);
  return e.getMonth(a) === e.getMonth(n) && e.getDate(a) > 1 && (a = e.addDate(a, -7)), a;
}
function g0(t, e, n) {
  var r = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : 1;
  switch (e) {
    case "year":
      return n.addYear(t, r * 10);
    case "quarter":
    case "month":
      return n.addYear(t, r);
    default:
      return n.addMonth(t, r);
  }
}
function Bi(t, e) {
  var n = e.generateConfig, r = e.locale, i = e.format;
  return typeof i == "function" ? i(t) : n.locale.format(r.locale, t, i);
}
function gU(t, e) {
  var n = e.generateConfig, r = e.locale, i = e.formatList;
  return !t || typeof i[0] == "function" ? null : n.locale.parse(r.locale, t, i);
}
function s_(t) {
  var e = t.cellDate, n = t.mode, r = t.disabledDate, i = t.generateConfig;
  if (!r)
    return !1;
  var o = function(p, v, m) {
    for (var b = v; b <= m; ) {
      var y = void 0;
      switch (p) {
        case "date": {
          if (y = i.setDate(e, b), !r(y))
            return !1;
          break;
        }
        case "month": {
          if (y = i.setMonth(e, b), !s_({
            cellDate: y,
            mode: "month",
            generateConfig: i,
            disabledDate: r
          }))
            return !1;
          break;
        }
        case "year": {
          if (y = i.setYear(e, b), !s_({
            cellDate: y,
            mode: "year",
            generateConfig: i,
            disabledDate: r
          }))
            return !1;
          break;
        }
      }
      b += 1;
    }
    return !0;
  };
  switch (n) {
    case "date":
    case "week":
      return r(e);
    case "month": {
      var a = 1, s = i.getDate(i.getEndDate(e));
      return o("date", a, s);
    }
    case "quarter": {
      var u = Math.floor(i.getMonth(e) / 3) * 3, l = u + 2;
      return o("month", u, l);
    }
    case "year":
      return o("month", 0, 11);
    case "decade": {
      var c = i.getYear(e), d = Math.floor(c / Es) * Es, f = d + Es - 1;
      return o("year", d, f);
    }
  }
}
function ECe(t) {
  var e = x.useContext(ga), n = e.hideHeader;
  if (n)
    return null;
  var r = t.prefixCls, i = t.generateConfig, o = t.locale, a = t.value, s = t.format, u = "".concat(r, "-header");
  return /* @__PURE__ */ x.createElement(Sp, {
    prefixCls: u
  }, a ? Bi(a, {
    locale: o,
    format: s,
    generateConfig: i
  }) : " ");
}
function SCe(t) {
  var e = t.value, n = t.generateConfig, r = t.disabledMinutes, i = t.disabledSeconds, o = t.minutes, a = t.seconds, s = t.use12Hours, u = function(c, d, f, h) {
    var p = e || n.getNow(), v = Math.max(0, d), m = Math.max(0, f), b = Math.max(0, h), y = r && r(v);
    if (y != null && y.includes(m)) {
      var w = o.find(function(I) {
        return !y.includes(I.value);
      });
      if (w)
        m = w.value;
      else
        return null;
    }
    var S = i && i(v, m);
    if (S != null && S.includes(b)) {
      var E = a.find(function(I) {
        return !S.includes(I.value);
      });
      if (E)
        b = E.value;
      else
        return null;
    }
    return p = uU(n, p, !s || !c ? v : v + 12, m, b), p;
  };
  return u;
}
function mU(t, e) {
  for (var n = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : "0", r = String(t); r.length < e; )
    r = "".concat(n).concat(t);
  return r;
}
var ICe = function() {
  for (var e = arguments.length, n = new Array(e), r = 0; r < e; r++)
    n[r] = arguments[r];
  return n;
};
function vU(t) {
  return t == null ? [] : Array.isArray(t) ? t : [t];
}
function bU(t) {
  var e = {};
  return Object.keys(t).forEach(function(n) {
    (n.substr(0, 5) === "data-" || n.substr(0, 5) === "aria-" || n === "role" || n === "name") && n.substr(0, 7) !== "data-__" && (e[n] = t[n]);
  }), e;
}
function xn(t, e) {
  return t ? t[e] : null;
}
function Ma(t, e, n) {
  var r = [xn(t, 0), xn(t, 1)];
  return r[n] = typeof e == "function" ? e(r[n]) : e, !r[0] && !r[1] ? null : r;
}
function ib(t) {
  var e = t.prefixCls, n = t.units, r = t.onSelect, i = t.value, o = t.active, a = t.hideDisabledOptions, s = "".concat(e, "-cell"), u = x.useContext(ga), l = u.open, c = Ee(null), d = Ee(/* @__PURE__ */ new Map()), f = Ee();
  return Ua(function() {
    var h = d.current.get(i);
    h && l !== !1 && o_(c.current, h.offsetTop, 120);
  }, [i]), Ua(function() {
    if (l) {
      var h = d.current.get(i);
      h && (f.current = dCe(h, function() {
        o_(c.current, h.offsetTop, 0);
      }));
    }
    return function() {
      var p;
      (p = f.current) === null || p === void 0 || p.call(f);
    };
  }, [l]), /* @__PURE__ */ x.createElement("ul", {
    className: Ce("".concat(e, "-column"), z({}, "".concat(e, "-column-active"), o)),
    ref: c,
    style: {
      position: "relative"
    }
  }, n.map(function(h) {
    var p;
    return a && h.disabled ? null : /* @__PURE__ */ x.createElement("li", {
      key: h.value,
      ref: function(m) {
        d.current.set(h.value, m);
      },
      className: Ce(s, (p = {}, z(p, "".concat(s, "-disabled"), h.disabled), z(p, "".concat(s, "-selected"), i === h.value), p)),
      onClick: function() {
        h.disabled || r(h.value);
      }
    }, /* @__PURE__ */ x.createElement("div", {
      className: "".concat(s, "-inner")
    }, h.label));
  }));
}
function _Ce(t, e) {
  if (t.length !== e.length)
    return !0;
  for (var n = 0; n < t.length; n += 1)
    if (t[n].disabled !== e[n].disabled)
      return !0;
  return !1;
}
function XS(t, e, n, r) {
  for (var i = [], o = n >= 1 ? n | 0 : 1, a = t; a <= e; a += o)
    i.push({
      label: mU(a, 2),
      value: a,
      disabled: (r || []).includes(a)
    });
  return i;
}
function ACe(t) {
  var e = t.generateConfig, n = t.prefixCls, r = t.operationRef, i = t.activeColumnIndex, o = t.value, a = t.showHour, s = t.showMinute, u = t.showSecond, l = t.use12Hours, c = t.hourStep, d = c === void 0 ? 1 : c, f = t.minuteStep, h = f === void 0 ? 1 : f, p = t.secondStep, v = p === void 0 ? 1 : p, m = t.disabledHours, b = t.disabledMinutes, y = t.disabledSeconds, w = t.disabledTime, S = t.hideDisabledOptions, E = t.onSelect, I = [], _ = "".concat(n, "-content"), A = "".concat(n, "-time-panel"), P, N = o ? e.getHour(o) : -1, k = N, D = o ? e.getMinute(o) : -1, R = o ? e.getSecond(o) : -1, V = e.getNow(), $ = x.useMemo(function() {
    if (w) {
      var te = w(V);
      return [te.disabledHours, te.disabledMinutes, te.disabledSeconds];
    }
    return [m, b, y];
  }, [m, b, y, w, V]), F = be($, 3), M = F[0], B = F[1], X = F[2], L = XS(0, 23, d, M && M()), j = Cp(function() {
    return L;
  }, L, _Ce);
  l && (P = k >= 12, k %= 12);
  var K = x.useMemo(function() {
    if (!l)
      return [!1, !1];
    var te = [!0, !0];
    return j.forEach(function(ge) {
      var he = ge.disabled, fe = ge.value;
      he || (fe >= 12 ? te[1] = !1 : te[0] = !1);
    }), te;
  }, [l, j]), W = be(K, 2), Y = W[0], U = W[1], Q = x.useMemo(function() {
    return l ? j.filter(P ? function(te) {
      return te.value >= 12;
    } : function(te) {
      return te.value < 12;
    }).map(function(te) {
      var ge = te.value % 12, he = ge === 0 ? "12" : mU(ge, 2);
      return de(de({}, te), {}, {
        label: he,
        value: ge
      });
    }) : j;
  }, [l, P, j]), Z = XS(0, 59, h, B && B(N)), ee = XS(0, 59, v, X && X(N, D)), ie = SCe({
    value: o,
    generateConfig: e,
    disabledMinutes: B,
    disabledSeconds: X,
    minutes: Z,
    seconds: ee,
    use12Hours: l
  });
  r.current = {
    onUpDown: function(ge) {
      var he = I[i];
      if (he)
        for (var fe = he.units.findIndex(function(Ve) {
          return Ve.value === he.value;
        }), _e = he.units.length, Ne = 1; Ne < _e; Ne += 1) {
          var ze = he.units[(fe + ge * Ne + _e) % _e];
          if (ze.disabled !== !0) {
            he.onSelect(ze.value);
            break;
          }
        }
    }
  };
  function oe(te, ge, he, fe, _e) {
    te !== !1 && I.push({
      node: /* @__PURE__ */ x.cloneElement(ge, {
        prefixCls: A,
        value: he,
        active: i === I.length,
        onSelect: _e,
        units: fe,
        hideDisabledOptions: S
      }),
      onSelect: _e,
      value: he,
      units: fe
    });
  }
  oe(a, /* @__PURE__ */ x.createElement(ib, {
    key: "hour"
  }), k, Q, function(te) {
    E(ie(P, te, D, R), "mouse");
  }), oe(s, /* @__PURE__ */ x.createElement(ib, {
    key: "minute"
  }), D, Z, function(te) {
    E(ie(P, k, te, R), "mouse");
  }), oe(u, /* @__PURE__ */ x.createElement(ib, {
    key: "second"
  }), R, ee, function(te) {
    E(ie(P, k, D, te), "mouse");
  });
  var se = -1;
  return typeof P == "boolean" && (se = P ? 1 : 0), oe(l === !0, /* @__PURE__ */ x.createElement(ib, {
    key: "12hours"
  }), se, [{
    label: "AM",
    value: 0,
    disabled: Y
  }, {
    label: "PM",
    value: 1,
    disabled: U
  }], function(te) {
    E(ie(!!te, k, D, R), "mouse");
  }), /* @__PURE__ */ x.createElement("div", {
    className: _
  }, I.map(function(te) {
    var ge = te.node;
    return ge;
  }));
}
var TCe = function(e) {
  return e.filter(function(n) {
    return n !== !1;
  }).length;
};
function yU(t) {
  var e = t.generateConfig, n = t.format, r = n === void 0 ? "HH:mm:ss" : n, i = t.prefixCls, o = t.active, a = t.operationRef, s = t.showHour, u = t.showMinute, l = t.showSecond, c = t.use12Hours, d = c === void 0 ? !1 : c, f = t.onSelect, h = t.value, p = "".concat(i, "-time-panel"), v = x.useRef(), m = x.useState(-1), b = be(m, 2), y = b[0], w = b[1], S = TCe([s, u, l, d]);
  return a.current = {
    onKeyDown: function(I) {
      return Ip(I, {
        onLeftRight: function(A) {
          w((y + A + S) % S);
        },
        onUpDown: function(A) {
          y === -1 ? w(0) : v.current && v.current.onUpDown(A);
        },
        onEnter: function() {
          f(h || e.getNow(), "key"), w(-1);
        }
      });
    },
    onBlur: function() {
      w(-1);
    }
  }, /* @__PURE__ */ x.createElement("div", {
    className: Ce(p, z({}, "".concat(p, "-active"), o))
  }, /* @__PURE__ */ x.createElement(ECe, G({}, t, {
    format: r,
    prefixCls: i
  })), /* @__PURE__ */ x.createElement(ACe, G({}, t, {
    prefixCls: i,
    activeColumnIndex: y,
    operationRef: v
  })));
}
var _p = /* @__PURE__ */ x.createContext({});
function _C(t) {
  var e = t.cellPrefixCls, n = t.generateConfig, r = t.rangedValue, i = t.hoverRangedValue, o = t.isInView, a = t.isSameCell, s = t.offsetCell, u = t.today, l = t.value;
  function c(d) {
    var f, h = s(d, -1), p = s(d, 1), v = xn(r, 0), m = xn(r, 1), b = xn(i, 0), y = xn(i, 1), w = rb(n, b, y, d);
    function S(N) {
      return a(v, N);
    }
    function E(N) {
      return a(m, N);
    }
    var I = a(b, d), _ = a(y, d), A = (w || _) && (!o(h) || E(h)), P = (w || I) && (!o(p) || S(p));
    return f = {}, z(f, "".concat(e, "-in-view"), o(d)), z(f, "".concat(e, "-in-range"), rb(n, v, m, d)), z(f, "".concat(e, "-range-start"), S(d)), z(f, "".concat(e, "-range-end"), E(d)), z(f, "".concat(e, "-range-start-single"), S(d) && !m), z(f, "".concat(e, "-range-end-single"), E(d) && !v), z(f, "".concat(e, "-range-start-near-hover"), S(d) && (a(h, b) || rb(n, b, y, h))), z(f, "".concat(e, "-range-end-near-hover"), E(d) && (a(p, y) || rb(n, b, y, p))), z(f, "".concat(e, "-range-hover"), w), z(f, "".concat(e, "-range-hover-start"), I), z(f, "".concat(e, "-range-hover-end"), _), z(f, "".concat(e, "-range-hover-edge-start"), A), z(f, "".concat(e, "-range-hover-edge-end"), P), z(f, "".concat(e, "-range-hover-edge-start-near-range"), A && a(h, m)), z(f, "".concat(e, "-range-hover-edge-end-near-range"), P && a(p, v)), z(f, "".concat(e, "-today"), a(u, d)), z(f, "".concat(e, "-selected"), a(l, d)), f;
  }
  return c;
}
function OCe(t) {
  var e = t.prefixCls, n = t.generateConfig, r = t.prefixColumn, i = t.locale, o = t.rowCount, a = t.viewDate, s = t.value, u = t.dateRender, l = x.useContext(_p), c = l.rangedValue, d = l.hoverRangedValue, f = wCe(i.locale, n, a), h = "".concat(e, "-cell"), p = n.locale.getWeekFirstDay(i.locale), v = n.getNow(), m = [], b = i.shortWeekDays || (n.locale.getShortWeekDays ? n.locale.getShortWeekDays(i.locale) : []);
  r && m.push(/* @__PURE__ */ x.createElement("th", {
    key: "empty",
    "aria-label": "empty cell"
  }));
  for (var y = 0; y < p0; y += 1)
    m.push(/* @__PURE__ */ x.createElement("th", {
      key: y
    }, b[(y + p) % p0]));
  var w = _C({
    cellPrefixCls: h,
    today: v,
    value: s,
    generateConfig: n,
    rangedValue: r ? null : c,
    hoverRangedValue: r ? null : d,
    isSameCell: function(I, _) {
      return Zu(n, I, _);
    },
    isInView: function(I) {
      return BA(n, I, a);
    },
    offsetCell: function(I, _) {
      return n.addDate(I, _);
    }
  }), S = u ? function(E) {
    return u(E, v);
  } : void 0;
  return /* @__PURE__ */ x.createElement(Bm, G({}, t, {
    rowNum: o,
    colNum: p0,
    baseDate: f,
    getCellNode: S,
    getCellText: n.getDate,
    getCellClassName: w,
    getCellDate: n.addDate,
    titleCell: function(I) {
      return Bi(I, {
        locale: i,
        format: "YYYY-MM-DD",
        generateConfig: n
      });
    },
    headerCells: m
  }));
}
function PCe(t) {
  var e = t.prefixCls, n = t.generateConfig, r = t.locale, i = t.viewDate, o = t.onNextMonth, a = t.onPrevMonth, s = t.onNextYear, u = t.onPrevYear, l = t.onYearClick, c = t.onMonthClick, d = x.useContext(ga), f = d.hideHeader;
  if (f)
    return null;
  var h = "".concat(e, "-header"), p = r.shortMonths || (n.locale.getShortMonths ? n.locale.getShortMonths(r.locale) : []), v = n.getMonth(i), m = /* @__PURE__ */ x.createElement("button", {
    type: "button",
    key: "year",
    onClick: l,
    tabIndex: -1,
    className: "".concat(e, "-year-btn")
  }, Bi(i, {
    locale: r,
    format: r.yearFormat,
    generateConfig: n
  })), b = /* @__PURE__ */ x.createElement("button", {
    type: "button",
    key: "month",
    onClick: c,
    tabIndex: -1,
    className: "".concat(e, "-month-btn")
  }, r.monthFormat ? Bi(i, {
    locale: r,
    format: r.monthFormat,
    generateConfig: n
  }) : p[v]), y = r.monthBeforeYear ? [b, m] : [m, b];
  return /* @__PURE__ */ x.createElement(Sp, G({}, t, {
    prefixCls: h,
    onSuperPrev: u,
    onPrev: a,
    onNext: o,
    onSuperNext: s
  }), y);
}
var NCe = 6;
function HA(t) {
  var e = t.prefixCls, n = t.panelName, r = n === void 0 ? "date" : n, i = t.keyboardConfig, o = t.active, a = t.operationRef, s = t.generateConfig, u = t.value, l = t.viewDate, c = t.onViewDateChange, d = t.onPanelChange, f = t.onSelect, h = "".concat(e, "-").concat(r, "-panel");
  a.current = {
    onKeyDown: function(b) {
      return Ip(b, de({
        onLeftRight: function(w) {
          f(s.addDate(u || l, w), "key");
        },
        onCtrlLeftRight: function(w) {
          f(s.addYear(u || l, w), "key");
        },
        onUpDown: function(w) {
          f(s.addDate(u || l, w * p0), "key");
        },
        onPageUpDown: function(w) {
          f(s.addMonth(u || l, w), "key");
        }
      }, i));
    }
  };
  var p = function(b) {
    var y = s.addYear(l, b);
    c(y), d(null, y);
  }, v = function(b) {
    var y = s.addMonth(l, b);
    c(y), d(null, y);
  };
  return /* @__PURE__ */ x.createElement("div", {
    className: Ce(h, z({}, "".concat(h, "-active"), o))
  }, /* @__PURE__ */ x.createElement(PCe, G({}, t, {
    prefixCls: e,
    value: u,
    viewDate: l,
    onPrevYear: function() {
      p(-1);
    },
    onNextYear: function() {
      p(1);
    },
    onPrevMonth: function() {
      v(-1);
    },
    onNextMonth: function() {
      v(1);
    },
    onMonthClick: function() {
      d("month", l);
    },
    onYearClick: function() {
      d("year", l);
    }
  })), /* @__PURE__ */ x.createElement(OCe, G({}, t, {
    onSelect: function(b) {
      return f(b, "mouse");
    },
    prefixCls: e,
    value: u,
    viewDate: l,
    rowCount: NCe
  })));
}
var uR = ICe("date", "time");
function kCe(t) {
  var e = t.prefixCls, n = t.operationRef, r = t.generateConfig, i = t.value, o = t.defaultValue, a = t.disabledTime, s = t.showTime, u = t.onSelect, l = "".concat(e, "-datetime-panel"), c = x.useState(null), d = be(c, 2), f = d[0], h = d[1], p = x.useRef({}), v = x.useRef({}), m = _t(s) === "object" ? de({}, s) : {};
  function b(E) {
    var I = uR.indexOf(f) + E, _ = uR[I] || null;
    return _;
  }
  var y = function(I) {
    v.current.onBlur && v.current.onBlur(I), h(null);
  };
  n.current = {
    onKeyDown: function(I) {
      if (I.which === ke.TAB) {
        var _ = b(I.shiftKey ? -1 : 1);
        return h(_), _ && I.preventDefault(), !0;
      }
      if (f) {
        var A = f === "date" ? p : v;
        return A.current && A.current.onKeyDown && A.current.onKeyDown(I), !0;
      }
      return [ke.LEFT, ke.RIGHT, ke.UP, ke.DOWN].includes(I.which) ? (h("date"), !0) : !1;
    },
    onBlur: y,
    onClose: y
  };
  var w = function(I, _) {
    var A = I;
    _ === "date" && !i && m.defaultValue ? (A = r.setHour(A, r.getHour(m.defaultValue)), A = r.setMinute(A, r.getMinute(m.defaultValue)), A = r.setSecond(A, r.getSecond(m.defaultValue))) : _ === "time" && !i && o && (A = r.setYear(A, r.getYear(o)), A = r.setMonth(A, r.getMonth(o)), A = r.setDate(A, r.getDate(o))), u && u(A, "mouse");
  }, S = a ? a(i || null) : {};
  return /* @__PURE__ */ x.createElement("div", {
    className: Ce(l, z({}, "".concat(l, "-active"), f))
  }, /* @__PURE__ */ x.createElement(HA, G({}, t, {
    operationRef: p,
    active: f === "date",
    onSelect: function(I) {
      w(lU(r, I, !i && _t(s) === "object" ? s.defaultValue : null), "date");
    }
  })), /* @__PURE__ */ x.createElement(yU, G({}, t, {
    format: void 0
  }, m, S, {
    disabledTime: null,
    defaultValue: void 0,
    operationRef: v,
    active: f === "time",
    onSelect: function(I) {
      w(I, "time");
    }
  })));
}
function RCe(t) {
  var e = t.prefixCls, n = t.generateConfig, r = t.locale, i = t.value, o = "".concat(e, "-cell"), a = function(c) {
    return /* @__PURE__ */ x.createElement("td", {
      key: "week",
      className: Ce(o, "".concat(o, "-week"))
    }, n.locale.getWeek(r.locale, c));
  }, s = "".concat(e, "-week-panel-row"), u = function(c) {
    return Ce(s, z({}, "".concat(s, "-selected"), pU(n, r.locale, i, c)));
  };
  return /* @__PURE__ */ x.createElement(HA, G({}, t, {
    panelName: "week",
    prefixColumn: a,
    rowClassName: u,
    keyboardConfig: {
      onLeftRight: null
    }
  }));
}
function $Ce(t) {
  var e = t.prefixCls, n = t.generateConfig, r = t.locale, i = t.viewDate, o = t.onNextYear, a = t.onPrevYear, s = t.onYearClick, u = x.useContext(ga), l = u.hideHeader;
  if (l)
    return null;
  var c = "".concat(e, "-header");
  return /* @__PURE__ */ x.createElement(Sp, G({}, t, {
    prefixCls: c,
    onSuperPrev: a,
    onSuperNext: o
  }), /* @__PURE__ */ x.createElement("button", {
    type: "button",
    onClick: s,
    className: "".concat(e, "-year-btn")
  }, Bi(i, {
    locale: r,
    format: r.yearFormat,
    generateConfig: n
  })));
}
var WA = 3, DCe = 4;
function MCe(t) {
  var e = t.prefixCls, n = t.locale, r = t.value, i = t.viewDate, o = t.generateConfig, a = t.monthCellRender, s = x.useContext(_p), u = s.rangedValue, l = s.hoverRangedValue, c = "".concat(e, "-cell"), d = _C({
    cellPrefixCls: c,
    value: r,
    generateConfig: o,
    rangedValue: u,
    hoverRangedValue: l,
    isSameCell: function(m, b) {
      return BA(o, m, b);
    },
    isInView: function() {
      return !0;
    },
    offsetCell: function(m, b) {
      return o.addMonth(m, b);
    }
  }), f = n.shortMonths || (o.locale.getShortMonths ? o.locale.getShortMonths(n.locale) : []), h = o.setMonth(i, 0), p = a ? function(v) {
    return a(v, n);
  } : void 0;
  return /* @__PURE__ */ x.createElement(Bm, G({}, t, {
    rowNum: DCe,
    colNum: WA,
    baseDate: h,
    getCellNode: p,
    getCellText: function(m) {
      return n.monthFormat ? Bi(m, {
        locale: n,
        format: n.monthFormat,
        generateConfig: o
      }) : f[o.getMonth(m)];
    },
    getCellClassName: d,
    getCellDate: o.addMonth,
    titleCell: function(m) {
      return Bi(m, {
        locale: n,
        format: "YYYY-MM",
        generateConfig: o
      });
    }
  }));
}
function FCe(t) {
  var e = t.prefixCls, n = t.operationRef, r = t.onViewDateChange, i = t.generateConfig, o = t.value, a = t.viewDate, s = t.onPanelChange, u = t.onSelect, l = "".concat(e, "-month-panel");
  n.current = {
    onKeyDown: function(f) {
      return Ip(f, {
        onLeftRight: function(p) {
          u(i.addMonth(o || a, p), "key");
        },
        onCtrlLeftRight: function(p) {
          u(i.addYear(o || a, p), "key");
        },
        onUpDown: function(p) {
          u(i.addMonth(o || a, p * WA), "key");
        },
        onEnter: function() {
          s("date", o || a);
        }
      });
    }
  };
  var c = function(f) {
    var h = i.addYear(a, f);
    r(h), s(null, h);
  };
  return /* @__PURE__ */ x.createElement("div", {
    className: l
  }, /* @__PURE__ */ x.createElement($Ce, G({}, t, {
    prefixCls: e,
    onPrevYear: function() {
      c(-1);
    },
    onNextYear: function() {
      c(1);
    },
    onYearClick: function() {
      s("year", a);
    }
  })), /* @__PURE__ */ x.createElement(MCe, G({}, t, {
    prefixCls: e,
    onSelect: function(f) {
      u(f, "mouse"), s("date", f);
    }
  })));
}
function LCe(t) {
  var e = t.prefixCls, n = t.generateConfig, r = t.locale, i = t.viewDate, o = t.onNextYear, a = t.onPrevYear, s = t.onYearClick, u = x.useContext(ga), l = u.hideHeader;
  if (l)
    return null;
  var c = "".concat(e, "-header");
  return /* @__PURE__ */ x.createElement(Sp, G({}, t, {
    prefixCls: c,
    onSuperPrev: a,
    onSuperNext: o
  }), /* @__PURE__ */ x.createElement("button", {
    type: "button",
    onClick: s,
    className: "".concat(e, "-year-btn")
  }, Bi(i, {
    locale: r,
    format: r.yearFormat,
    generateConfig: n
  })));
}
var VCe = 4, BCe = 1;
function HCe(t) {
  var e = t.prefixCls, n = t.locale, r = t.value, i = t.viewDate, o = t.generateConfig, a = x.useContext(_p), s = a.rangedValue, u = a.hoverRangedValue, l = "".concat(e, "-cell"), c = _C({
    cellPrefixCls: l,
    value: r,
    generateConfig: o,
    rangedValue: s,
    hoverRangedValue: u,
    isSameCell: function(h, p) {
      return hU(o, h, p);
    },
    isInView: function() {
      return !0;
    },
    offsetCell: function(h, p) {
      return o.addMonth(h, p * 3);
    }
  }), d = o.setDate(o.setMonth(i, 0), 1);
  return /* @__PURE__ */ x.createElement(Bm, G({}, t, {
    rowNum: BCe,
    colNum: VCe,
    baseDate: d,
    getCellText: function(h) {
      return Bi(h, {
        locale: n,
        format: n.quarterFormat || "[Q]Q",
        generateConfig: o
      });
    },
    getCellClassName: c,
    getCellDate: function(h, p) {
      return o.addMonth(h, p * 3);
    },
    titleCell: function(h) {
      return Bi(h, {
        locale: n,
        format: "YYYY-[Q]Q",
        generateConfig: o
      });
    }
  }));
}
function WCe(t) {
  var e = t.prefixCls, n = t.operationRef, r = t.onViewDateChange, i = t.generateConfig, o = t.value, a = t.viewDate, s = t.onPanelChange, u = t.onSelect, l = "".concat(e, "-quarter-panel");
  n.current = {
    onKeyDown: function(f) {
      return Ip(f, {
        onLeftRight: function(p) {
          u(i.addMonth(o || a, p * 3), "key");
        },
        onCtrlLeftRight: function(p) {
          u(i.addYear(o || a, p), "key");
        },
        onUpDown: function(p) {
          u(i.addYear(o || a, p), "key");
        }
      });
    }
  };
  var c = function(f) {
    var h = i.addYear(a, f);
    r(h), s(null, h);
  };
  return /* @__PURE__ */ x.createElement("div", {
    className: l
  }, /* @__PURE__ */ x.createElement(LCe, G({}, t, {
    prefixCls: e,
    onPrevYear: function() {
      c(-1);
    },
    onNextYear: function() {
      c(1);
    },
    onYearClick: function() {
      s("year", a);
    }
  })), /* @__PURE__ */ x.createElement(HCe, G({}, t, {
    prefixCls: e,
    onSelect: function(f) {
      u(f, "mouse");
    }
  })));
}
function jCe(t) {
  var e = t.prefixCls, n = t.generateConfig, r = t.viewDate, i = t.onPrevDecade, o = t.onNextDecade, a = t.onDecadeClick, s = x.useContext(ga), u = s.hideHeader;
  if (u)
    return null;
  var l = "".concat(e, "-header"), c = n.getYear(r), d = Math.floor(c / Yl) * Yl, f = d + Yl - 1;
  return /* @__PURE__ */ x.createElement(Sp, G({}, t, {
    prefixCls: l,
    onSuperPrev: i,
    onSuperNext: o
  }), /* @__PURE__ */ x.createElement("button", {
    type: "button",
    onClick: a,
    className: "".concat(e, "-decade-btn")
  }, d, "-", f));
}
var u_ = 3, lR = 4;
function zCe(t) {
  var e = t.prefixCls, n = t.value, r = t.viewDate, i = t.locale, o = t.generateConfig, a = x.useContext(_p), s = a.rangedValue, u = a.hoverRangedValue, l = "".concat(e, "-cell"), c = o.getYear(r), d = Math.floor(c / Yl) * Yl, f = d + Yl - 1, h = o.setYear(r, d - Math.ceil((u_ * lR - Yl) / 2)), p = function(b) {
    var y = o.getYear(b);
    return d <= y && y <= f;
  }, v = _C({
    cellPrefixCls: l,
    value: n,
    generateConfig: o,
    rangedValue: s,
    hoverRangedValue: u,
    isSameCell: function(b, y) {
      return Hm(o, b, y);
    },
    isInView: p,
    offsetCell: function(b, y) {
      return o.addYear(b, y);
    }
  });
  return /* @__PURE__ */ x.createElement(Bm, G({}, t, {
    rowNum: lR,
    colNum: u_,
    baseDate: h,
    getCellText: o.getYear,
    getCellClassName: v,
    getCellDate: o.addYear,
    titleCell: function(b) {
      return Bi(b, {
        locale: i,
        format: "YYYY",
        generateConfig: o
      });
    }
  }));
}
var Yl = 10;
function GCe(t) {
  var e = t.prefixCls, n = t.operationRef, r = t.onViewDateChange, i = t.generateConfig, o = t.value, a = t.viewDate, s = t.sourceMode, u = t.onSelect, l = t.onPanelChange, c = "".concat(e, "-year-panel");
  n.current = {
    onKeyDown: function(h) {
      return Ip(h, {
        onLeftRight: function(v) {
          u(i.addYear(o || a, v), "key");
        },
        onCtrlLeftRight: function(v) {
          u(i.addYear(o || a, v * Yl), "key");
        },
        onUpDown: function(v) {
          u(i.addYear(o || a, v * u_), "key");
        },
        onEnter: function() {
          l(s === "date" ? "date" : "month", o || a);
        }
      });
    }
  };
  var d = function(h) {
    var p = i.addYear(a, h * 10);
    r(p), l(null, p);
  };
  return /* @__PURE__ */ x.createElement("div", {
    className: c
  }, /* @__PURE__ */ x.createElement(jCe, G({}, t, {
    prefixCls: e,
    onPrevDecade: function() {
      d(-1);
    },
    onNextDecade: function() {
      d(1);
    },
    onDecadeClick: function() {
      l("decade", a);
    }
  })), /* @__PURE__ */ x.createElement(zCe, G({}, t, {
    prefixCls: e,
    onSelect: function(h) {
      l(s === "date" ? "date" : "month", h), u(h, "mouse");
    }
  })));
}
function xU(t, e, n) {
  return n ? /* @__PURE__ */ x.createElement("div", {
    className: "".concat(t, "-footer-extra")
  }, n(e)) : null;
}
function CU(t) {
  var e = t.prefixCls, n = t.rangeList, r = n === void 0 ? [] : n, i = t.components, o = i === void 0 ? {} : i, a = t.needConfirmButton, s = t.onNow, u = t.onOk, l = t.okDisabled, c = t.showNow, d = t.locale, f, h;
  if (r.length) {
    var p = o.rangeItem || "span";
    f = /* @__PURE__ */ x.createElement(x.Fragment, null, r.map(function(m) {
      var b = m.label, y = m.onClick, w = m.onMouseEnter, S = m.onMouseLeave;
      return /* @__PURE__ */ x.createElement("li", {
        key: b,
        className: "".concat(e, "-preset")
      }, /* @__PURE__ */ x.createElement(p, {
        onClick: y,
        onMouseEnter: w,
        onMouseLeave: S
      }, b));
    }));
  }
  if (a) {
    var v = o.button || "button";
    s && !f && c !== !1 && (f = /* @__PURE__ */ x.createElement("li", {
      className: "".concat(e, "-now")
    }, /* @__PURE__ */ x.createElement("a", {
      className: "".concat(e, "-now-btn"),
      onClick: s
    }, d.now))), h = a && /* @__PURE__ */ x.createElement("li", {
      className: "".concat(e, "-ok")
    }, /* @__PURE__ */ x.createElement(v, {
      disabled: l,
      onClick: u
    }, d.ok));
  }
  return !f && !h ? null : /* @__PURE__ */ x.createElement("ul", {
    className: "".concat(e, "-ranges")
  }, f, h);
}
var UCe = ["date", "month"];
function wU(t) {
  var e, n = t.prefixCls, r = n === void 0 ? "rc-picker" : n, i = t.className, o = t.style, a = t.locale, s = t.generateConfig, u = t.value, l = t.defaultValue, c = t.pickerValue, d = t.defaultPickerValue, f = t.disabledDate, h = t.mode, p = t.picker, v = p === void 0 ? "date" : p, m = t.tabIndex, b = m === void 0 ? 0 : m, y = t.showNow, w = t.showTime, S = t.showToday, E = t.renderExtraFooter, I = t.hideHeader, _ = t.onSelect, A = t.onChange, P = t.onPanelChange, N = t.onMouseDown, k = t.onPickerValueChange, D = t.onOk, R = t.components, V = t.direction, $ = t.hourStep, F = $ === void 0 ? 1 : $, M = t.minuteStep, B = M === void 0 ? 1 : M, X = t.secondStep, L = X === void 0 ? 1 : X, j = v === "date" && !!w || v === "time", K = 24 % F === 0, W = 60 % B === 0, Y = 60 % L === 0;
  process.env.NODE_ENV !== "production" && (Wt(!u || s.isValidate(u), "Invalidate date pass to `value`."), Wt(!u || s.isValidate(u), "Invalidate date pass to `defaultValue`."), Wt(K, "`hourStep` ".concat(F, " is invalid. It should be a factor of 24.")), Wt(W, "`minuteStep` ".concat(B, " is invalid. It should be a factor of 60.")), Wt(Y, "`secondStep` ".concat(L, " is invalid. It should be a factor of 60.")));
  var U = x.useContext(ga), Q = U.operationRef, Z = U.panelRef, ee = U.onSelect, ie = U.hideRanges, oe = U.defaultOpenValue, se = x.useContext(_p), te = se.inRange, ge = se.panelPosition, he = se.rangedValue, fe = se.hoverRangedValue, _e = x.useRef({}), Ne = x.useRef(!0), ze = Tr(null, {
    value: u,
    defaultValue: l,
    postState: function(He) {
      return !He && oe && v === "time" ? oe : He;
    }
  }), Ve = be(ze, 2), ne = Ve[0], pe = Ve[1], ye = Tr(null, {
    value: c,
    defaultValue: d || ne,
    postState: function(He) {
      var mt = s.getNow();
      if (!He)
        return mt;
      if (!ne && w) {
        var Qt = _t(w) === "object" ? w.defaultValue : l;
        return lU(s, Array.isArray(He) ? He[0] : He, Qt || mt);
      }
      return Array.isArray(He) ? He[0] : He;
    }
  }), Ae = be(ye, 2), we = Ae[0], ce = Ae[1], ve = function(He) {
    ce(He), k && k(He);
  }, Ie = function(He) {
    var mt = bCe[v];
    return mt ? mt(He) : He;
  }, q = Tr(function() {
    return v === "time" ? "time" : Ie("date");
  }, {
    value: h
  }), Fe = be(q, 2), Ze = Fe[0], at = Fe[1];
  x.useEffect(function() {
    at(v);
  }, [v]);
  var Je = x.useState(function() {
    return Ze;
  }), ut = be(Je, 2), Ct = ut[0], Ke = ut[1], st = function(He, mt) {
    var Qt = Ie(He || Ze);
    Ke(Ze), at(Qt), P && (Ze !== Qt || rp(s, we, we)) && P(mt, Qt);
  }, wt = function(He, mt) {
    var Qt = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : !1;
    (Ze === v || Qt) && (pe(He), _ && _(He), ee && ee(He, mt), A && !rp(s, He, ne) && !(f != null && f(He)) && A(He));
  }, qt = function(He) {
    if (UCe.includes(Ze)) {
      var mt, Qt, Yt = Ze === "date";
      switch (He === ke.PAGE_UP || He === ke.PAGE_DOWN ? Qt = Yt ? s.addMonth : s.addYear : Qt = Yt ? s.addDate : s.addMonth, He) {
        case ke.LEFT:
        case ke.PAGE_UP:
          mt = Qt(we, -1);
          break;
        case ke.RIGHT:
        case ke.PAGE_DOWN:
          mt = Qt(we, 1);
          break;
        case ke.UP:
        case ke.DOWN:
          mt = Qt(we, Number("".concat(He === ke.UP ? "-" : "").concat(Yt ? p0 : WA)));
          break;
      }
      if (mt)
        return !(f != null && f(mt));
    }
    return !0;
  }, bt = function(He) {
    if (_e.current && _e.current.onKeyDown) {
      var mt = !0, Qt = He.which;
      if ([ke.LEFT, ke.RIGHT, ke.UP, ke.DOWN, ke.PAGE_UP, ke.PAGE_DOWN, ke.ENTER].includes(Qt) && (He.preventDefault(), Qt !== ke.ENTER && b === 0 && (mt = qt(Qt))), mt)
        return _e.current.onKeyDown(He);
    }
    return Wt(!1, "Panel not correct handle keyDown event. Please help to fire issue about this."), !1;
  }, Me = function(He) {
    _e.current && _e.current.onBlur && _e.current.onBlur(He);
  };
  Q && ge !== "right" && (Q.current = {
    onKeyDown: bt,
    onClose: function() {
      _e.current && _e.current.onClose && _e.current.onClose();
    }
  }), x.useEffect(function() {
    u && !Ne.current && ce(u);
  }, [u]), x.useEffect(function() {
    Ne.current = !1;
  }, []);
  var yt, ct = de(de({}, t), {}, {
    operationRef: _e,
    prefixCls: r,
    viewDate: we,
    value: ne,
    onViewDateChange: ve,
    sourceMode: Ct,
    onPanelChange: st,
    disabledDate: f
  });
  switch (delete ct.onChange, delete ct.onSelect, Ze) {
    case "decade":
      yt = /* @__PURE__ */ x.createElement(yCe, G({}, ct, {
        onSelect: function(He, mt) {
          ve(He), wt(He, mt);
        }
      }));
      break;
    case "year":
      yt = /* @__PURE__ */ x.createElement(GCe, G({}, ct, {
        onSelect: function(He, mt) {
          ve(He), wt(He, mt);
        }
      }));
      break;
    case "month":
      yt = /* @__PURE__ */ x.createElement(FCe, G({}, ct, {
        onSelect: function(He, mt) {
          ve(He), wt(He, mt);
        }
      }));
      break;
    case "quarter":
      yt = /* @__PURE__ */ x.createElement(WCe, G({}, ct, {
        onSelect: function(He, mt) {
          ve(He), wt(He, mt);
        }
      }));
      break;
    case "week":
      yt = /* @__PURE__ */ x.createElement(RCe, G({}, ct, {
        onSelect: function(He, mt) {
          ve(He), wt(He, mt);
        }
      }));
      break;
    case "time":
      delete ct.showTime, yt = /* @__PURE__ */ x.createElement(yU, G({}, ct, _t(w) === "object" ? w : null, {
        onSelect: function(He, mt) {
          ve(He), wt(He, mt);
        }
      }));
      break;
    default:
      w ? yt = /* @__PURE__ */ x.createElement(kCe, G({}, ct, {
        onSelect: function(He, mt) {
          ve(He), wt(He, mt);
        }
      })) : yt = /* @__PURE__ */ x.createElement(HA, G({}, ct, {
        onSelect: function(He, mt) {
          ve(He), wt(He, mt);
        }
      }));
  }
  var kt, Vt, Vn = function() {
    var He = s.getNow(), mt = uCe(s.getHour(He), s.getMinute(He), s.getSecond(He), K ? F : 1, W ? B : 1, Y ? L : 1), Qt = uU(
      s,
      He,
      mt[0],
      // hour
      mt[1],
      // minute
      mt[2]
    );
    wt(Qt, "submit");
  };
  ie || (kt = xU(r, Ze, E), Vt = CU({
    prefixCls: r,
    components: R,
    needConfirmButton: j,
    okDisabled: !ne || f && f(ne),
    locale: a,
    showNow: y,
    onNow: j && Vn,
    onOk: function() {
      ne && (wt(ne, "submit", !0), D && D(ne));
    }
  }));
  var tn;
  if (S && Ze === "date" && v === "date" && !w) {
    var Xe = s.getNow(), tt = "".concat(r, "-today-btn"), ot = f && f(Xe);
    tn = /* @__PURE__ */ x.createElement("a", {
      className: Ce(tt, ot && "".concat(tt, "-disabled")),
      "aria-disabled": ot,
      onClick: function() {
        ot || wt(Xe, "mouse", !0);
      }
    }, a.today);
  }
  return /* @__PURE__ */ x.createElement(ga.Provider, {
    value: de(de({}, U), {}, {
      mode: Ze,
      hideHeader: "hideHeader" in t ? I : U.hideHeader,
      hidePrevBtn: te && ge === "right",
      hideNextBtn: te && ge === "left"
    })
  }, /* @__PURE__ */ x.createElement("div", {
    tabIndex: b,
    className: Ce("".concat(r, "-panel"), i, (e = {}, z(e, "".concat(r, "-panel-has-range"), he && he[0] && he[1]), z(e, "".concat(r, "-panel-has-range-hover"), fe && fe[0] && fe[1]), z(e, "".concat(r, "-panel-rtl"), V === "rtl"), e)),
    style: o,
    onKeyDown: bt,
    onBlur: Me,
    onMouseDown: N,
    ref: Z
  }, yt, kt || Vt || tn ? /* @__PURE__ */ x.createElement("div", {
    className: "".concat(r, "-footer")
  }, kt, Vt, tn) : null));
}
var XCe = {
  bottomLeft: {
    points: ["tl", "bl"],
    offset: [0, 4],
    overflow: {
      adjustX: 1,
      adjustY: 1
    }
  },
  bottomRight: {
    points: ["tr", "br"],
    offset: [0, 4],
    overflow: {
      adjustX: 1,
      adjustY: 1
    }
  },
  topLeft: {
    points: ["bl", "tl"],
    offset: [0, -4],
    overflow: {
      adjustX: 0,
      adjustY: 1
    }
  },
  topRight: {
    points: ["br", "tr"],
    offset: [0, -4],
    overflow: {
      adjustX: 0,
      adjustY: 1
    }
  }
};
function EU(t) {
  var e, n = t.prefixCls, r = t.popupElement, i = t.popupStyle, o = t.visible, a = t.dropdownClassName, s = t.dropdownAlign, u = t.transitionName, l = t.getPopupContainer, c = t.children, d = t.range, f = t.popupPlacement, h = t.direction, p = "".concat(n, "-dropdown"), v = function() {
    return f !== void 0 ? f : h === "rtl" ? "bottomRight" : "bottomLeft";
  };
  return /* @__PURE__ */ x.createElement(Mm, {
    showAction: [],
    hideAction: [],
    popupPlacement: v(),
    builtinPlacements: XCe,
    prefixCls: p,
    popupTransitionName: u,
    popup: r,
    popupAlign: s,
    popupVisible: o,
    popupClassName: Ce(a, (e = {}, z(e, "".concat(p, "-range"), d), z(e, "".concat(p, "-rtl"), h === "rtl"), e)),
    popupStyle: i,
    getPopupContainer: l
  }, c);
}
function l_(t) {
  var e = t.open, n = t.value, r = t.isClickOutside, i = t.triggerOpen, o = t.forwardKeyDown, a = t.onKeyDown, s = t.blurToCancel, u = t.onSubmit, l = t.onCancel, c = t.onFocus, d = t.onBlur, f = t.currentFocusedKey, h = t.key, p = h === void 0 ? "start" : h, v = Le(!1), m = be(v, 2), b = m[0], y = m[1], w = Le(!1), S = be(w, 2), E = S[0], I = S[1], _ = Ee(), A = Ee(!1), P = Ee(!1), N = Ee(!1), k = {
    onMouseDown: function() {
      y(!0), i(!0);
    },
    onKeyDown: function(R) {
      var V = function() {
        N.current = !0;
      };
      if (a(R, V), !N.current) {
        switch (R.which) {
          case ke.ENTER: {
            e ? u() !== !1 && y(!0) : i(!0), R.preventDefault();
            return;
          }
          case ke.TAB: {
            b && e && !R.shiftKey ? (y(!1), R.preventDefault()) : !b && e && !o(R) && R.shiftKey && (y(!0), R.preventDefault());
            return;
          }
          case ke.ESC: {
            y(!0), l();
            return;
          }
        }
        !e && ![ke.SHIFT].includes(R.which) ? i(!0) : b || o(R);
      }
    },
    onFocus: function(R) {
      y(!0), I(!0), f && (f.current = p), clearTimeout(_.current), c && c(R);
    },
    onBlur: function(R) {
      if (A.current || !r(document.activeElement)) {
        A.current = !1;
        return;
      }
      s ? setTimeout(function() {
        for (var V = document, $ = V.activeElement; $ && $.shadowRoot; )
          $ = $.shadowRoot.activeElement;
        r($) && l();
      }, 0) : e && (i(!1), P.current && u()), I(!1), f ? (f.current = "", _.current = setTimeout(function() {
        f.current || d == null || d(R);
      }, 100)) : d == null || d(R);
    }
  };
  return Re(function() {
    P.current = !1;
  }, [e]), Re(function() {
    P.current = !0;
  }, [n]), Re(function() {
    return fCe(function(D) {
      var R = hCe(D), V = r(R);
      e ? V ? (!E || V) && i(!1) : (A.current = !0, requestAnimationFrame(function() {
        A.current = !1;
      })) : E && !V && (A.current = !0);
    });
  }), Re(function() {
    return function() {
      return clearTimeout(_.current);
    };
  }, []), [k, {
    focused: E,
    typing: b
  }];
}
function c_(t) {
  var e = t.valueTexts, n = t.onTextChange, r = x.useState(""), i = be(r, 2), o = i[0], a = i[1], s = x.useRef([]);
  s.current = e;
  function u(c) {
    a(c), n(c);
  }
  function l() {
    a(s.current[0]);
  }
  return x.useEffect(function() {
    e.every(function(c) {
      return c !== o;
    }) && l();
  }, [e.join("||")]), [o, u, l];
}
function wx(t, e) {
  var n = e.formatList, r = e.generateConfig, i = e.locale;
  return Cp(function() {
    if (!t)
      return [[""], ""];
    for (var o = "", a = [], s = 0; s < n.length; s += 1) {
      var u = n[s], l = Bi(t, {
        generateConfig: r,
        locale: i,
        format: u
      });
      a.push(l), s === 0 && (o = l);
    }
    return [a, o];
  }, [t, n, i], function(o, a) {
    return (
      // Not Same Date
      !rp(r, o[0], a[0]) || // Not Same format
      !np(o[1], a[1], !0) || // Not Same locale
      !np(o[2], a[2], !0)
    );
  });
}
function d_(t, e) {
  var n = e.formatList, r = e.generateConfig, i = e.locale, o = Le(null), a = be(o, 2), s = a[0], u = a[1], l = Ee(null);
  function c(m) {
    var b = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : !1;
    if (cancelAnimationFrame(l.current), b) {
      u(m);
      return;
    }
    l.current = requestAnimationFrame(function() {
      u(m);
    });
  }
  var d = wx(s, {
    formatList: n,
    generateConfig: r,
    locale: i
  }), f = be(d, 2), h = f[1];
  function p(m) {
    c(m);
  }
  function v() {
    var m = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : !1;
    c(null, m);
  }
  return Re(function() {
    v(!0);
  }, [t]), Re(function() {
    return function() {
      return cancelAnimationFrame(l.current);
    };
  }, []), [h, p, v];
}
function SU(t) {
  var e = t.picker, n = t.disabledHours, r = t.disabledMinutes, i = t.disabledSeconds;
  e === "time" && (n || r || i) && Wt(!1, "'disabledHours', 'disabledMinutes', 'disabledSeconds' will be removed in the next major version, please use 'disabledTime' instead.");
}
function YCe(t) {
  var e, n = t.prefixCls, r = n === void 0 ? "rc-picker" : n, i = t.id, o = t.tabIndex, a = t.style, s = t.className, u = t.dropdownClassName, l = t.dropdownAlign, c = t.popupStyle, d = t.transitionName, f = t.generateConfig, h = t.locale, p = t.inputReadOnly, v = t.allowClear, m = t.autoFocus, b = t.showTime, y = t.picker, w = y === void 0 ? "date" : y, S = t.format, E = t.use12Hours, I = t.value, _ = t.defaultValue, A = t.open, P = t.defaultOpen, N = t.defaultOpenValue, k = t.suffixIcon, D = t.clearIcon, R = t.disabled, V = t.disabledDate, $ = t.placeholder, F = t.getPopupContainer, M = t.pickerRef, B = t.panelRender, X = t.onChange, L = t.onOpenChange, j = t.onFocus, K = t.onBlur, W = t.onMouseDown, Y = t.onMouseUp, U = t.onMouseEnter, Q = t.onMouseLeave, Z = t.onContextMenu, ee = t.onClick, ie = t.onKeyDown, oe = t.onSelect, se = t.direction, te = t.autoComplete, ge = te === void 0 ? "off" : te, he = t.inputRender, fe = x.useRef(null), _e = w === "date" && !!b || w === "time";
  process.env.NODE_ENV !== "production" && SU(t);
  var Ne = vU(cU(S, w, b, E)), ze = x.useRef(null), Ve = x.useRef(null), ne = x.useRef(null), pe = Tr(null, {
    value: I,
    defaultValue: _
  }), ye = be(pe, 2), Ae = ye[0], we = ye[1], ce = x.useState(Ae), ve = be(ce, 2), Ie = ve[0], q = ve[1], Fe = x.useRef(null), Ze = Tr(!1, {
    value: A,
    defaultValue: P,
    postState: function(Tt) {
      return R ? !1 : Tt;
    },
    onChange: function(Tt) {
      L && L(Tt), !Tt && Fe.current && Fe.current.onClose && Fe.current.onClose();
    }
  }), at = be(Ze, 2), Je = at[0], ut = at[1], Ct = wx(Ie, {
    formatList: Ne,
    generateConfig: f,
    locale: h
  }), Ke = be(Ct, 2), st = Ke[0], wt = Ke[1], qt = c_({
    valueTexts: st,
    onTextChange: function(Tt) {
      var Wn = gU(Tt, {
        locale: h,
        formatList: Ne,
        generateConfig: f
      });
      Wn && (!V || !V(Wn)) && q(Wn);
    }
  }), bt = be(qt, 3), Me = bt[0], yt = bt[1], ct = bt[2], kt = function(Tt) {
    q(Tt), we(Tt), X && !rp(f, Ae, Tt) && X(Tt, Tt ? Bi(Tt, {
      generateConfig: f,
      locale: h,
      format: Ne[0]
    }) : "");
  }, Vt = function(Tt) {
    R && Tt || ut(Tt);
  }, Vn = function(Tt) {
    return Je && Fe.current && Fe.current.onKeyDown ? Fe.current.onKeyDown(Tt) : (Wt(!1, "Picker not correct forward KeyDown operation. Please help to fire issue about this."), !1);
  }, tn = function() {
    for (var Tt = arguments.length, Wn = new Array(Tt), zr = 0; zr < Tt; zr++)
      Wn[zr] = arguments[zr];
    ee == null || ee.apply(void 0, Wn), fe.current && (fe.current.focus(), Vt(!0));
  }, Xe = l_({
    blurToCancel: _e,
    open: Je,
    value: Me,
    triggerOpen: Vt,
    forwardKeyDown: Vn,
    isClickOutside: function(Tt) {
      return !fU([ze.current, Ve.current, ne.current], Tt);
    },
    onSubmit: function() {
      return (
        // When user typing disabledDate with keyboard and enter, this value will be empty
        !Ie || // Normal disabled check
        V && V(Ie) ? !1 : (kt(Ie), Vt(!1), ct(), !0)
      );
    },
    onCancel: function() {
      Vt(!1), q(Ae), ct();
    },
    onKeyDown: function(Tt, Wn) {
      ie == null || ie(Tt, Wn);
    },
    onFocus: j,
    onBlur: K
  }), tt = be(Xe, 2), ot = tt[0], lt = tt[1], He = lt.focused, mt = lt.typing;
  x.useEffect(function() {
    Je || (q(Ae), !st.length || st[0] === "" ? yt("") : wt !== Me && ct());
  }, [Je, st]), x.useEffect(function() {
    Je || ct();
  }, [w]), x.useEffect(function() {
    q(Ae);
  }, [Ae]), M && (M.current = {
    focus: function() {
      fe.current && fe.current.focus();
    },
    blur: function() {
      fe.current && fe.current.blur();
    }
  });
  var Qt = d_(Me, {
    formatList: Ne,
    generateConfig: f,
    locale: h
  }), Yt = be(Qt, 3), nn = Yt[0], Nt = Yt[1], ue = Yt[2], $e = de(de({}, t), {}, {
    className: void 0,
    style: void 0,
    pickerValue: void 0,
    onPickerValueChange: void 0,
    onChange: null
  }), je = /* @__PURE__ */ x.createElement(wU, G({}, $e, {
    generateConfig: f,
    className: Ce(z({}, "".concat(r, "-panel-focused"), !mt)),
    value: Ie,
    locale: h,
    tabIndex: -1,
    onSelect: function(Tt) {
      oe == null || oe(Tt), q(Tt);
    },
    direction: se,
    onPanelChange: function(Tt, Wn) {
      var zr = t.onPanelChange;
      ue(!0), zr == null || zr(Tt, Wn);
    }
  }));
  B && (je = B(je));
  var At = /* @__PURE__ */ x.createElement("div", {
    className: "".concat(r, "-panel-container"),
    onMouseDown: function(Tt) {
      Tt.preventDefault();
    }
  }, je), $t;
  k && ($t = /* @__PURE__ */ x.createElement("span", {
    className: "".concat(r, "-suffix")
  }, k));
  var qe;
  v && Ae && !R && (qe = /* @__PURE__ */ x.createElement("span", {
    onMouseDown: function(Tt) {
      Tt.preventDefault(), Tt.stopPropagation();
    },
    onMouseUp: function(Tt) {
      Tt.preventDefault(), Tt.stopPropagation(), kt(null), Vt(!1);
    },
    className: "".concat(r, "-clear"),
    role: "button"
  }, D || /* @__PURE__ */ x.createElement("span", {
    className: "".concat(r, "-clear-btn")
  })));
  var nt = de(de(de({
    id: i,
    tabIndex: o,
    disabled: R,
    readOnly: p || typeof Ne[0] == "function" || !mt,
    value: nn || Me,
    onChange: function(Tt) {
      yt(Tt.target.value);
    },
    autoFocus: m,
    placeholder: $,
    ref: fe,
    title: Me
  }, ot), {}, {
    size: dU(w, Ne[0], f)
  }, bU(t)), {}, {
    autoComplete: ge
  }), dt = he ? he(nt) : /* @__PURE__ */ x.createElement("input", nt);
  process.env.NODE_ENV !== "production" && Wt(!N, "`defaultOpenValue` may confuse user for the current value status. Please use `defaultValue` instead.");
  var rn = function(Tt, Wn) {
    (Wn === "submit" || Wn !== "key" && !_e) && (kt(Tt), Vt(!1));
  }, on = se === "rtl" ? "bottomRight" : "bottomLeft";
  return /* @__PURE__ */ x.createElement(ga.Provider, {
    value: {
      operationRef: Fe,
      hideHeader: w === "time",
      panelRef: ze,
      onSelect: rn,
      open: Je,
      defaultOpenValue: N,
      onDateMouseEnter: Nt,
      onDateMouseLeave: ue
    }
  }, /* @__PURE__ */ x.createElement(EU, {
    visible: Je,
    popupElement: At,
    popupStyle: c,
    prefixCls: r,
    dropdownClassName: u,
    dropdownAlign: l,
    getPopupContainer: F,
    transitionName: d,
    popupPlacement: on,
    direction: se
  }, /* @__PURE__ */ x.createElement("div", {
    ref: ne,
    className: Ce(r, s, (e = {}, z(e, "".concat(r, "-disabled"), R), z(e, "".concat(r, "-focused"), He), z(e, "".concat(r, "-rtl"), se === "rtl"), e)),
    style: a,
    onMouseDown: W,
    onMouseUp: Y,
    onMouseEnter: U,
    onMouseLeave: Q,
    onContextMenu: Z,
    onClick: tn
  }, /* @__PURE__ */ x.createElement("div", {
    className: Ce("".concat(r, "-input"), z({}, "".concat(r, "-input-placeholder"), !!nn)),
    ref: Ve
  }, dt, $t, qe))));
}
var ZCe = /* @__PURE__ */ function(t) {
  Pr(n, t);
  var e = Hr(n);
  function n() {
    var r;
    zn(this, n);
    for (var i = arguments.length, o = new Array(i), a = 0; a < i; a++)
      o[a] = arguments[a];
    return r = e.call.apply(e, [this].concat(o)), r.pickerRef = /* @__PURE__ */ x.createRef(), r.focus = function() {
      r.pickerRef.current && r.pickerRef.current.focus();
    }, r.blur = function() {
      r.pickerRef.current && r.pickerRef.current.blur();
    }, r;
  }
  return Gn(n, [{
    key: "render",
    value: function() {
      return /* @__PURE__ */ x.createElement(YCe, G({}, this.props, {
        pickerRef: this.pickerRef
      }));
    }
  }]), n;
}(x.Component);
function JCe(t, e, n) {
  var r = t.picker, i = t.locale, o = t.selectedValue, a = t.disabledDate, s = t.disabled, u = t.generateConfig, l = xn(o, 0), c = xn(o, 1);
  function d(m) {
    return u.locale.getWeekFirstDate(i.locale, m);
  }
  function f(m) {
    var b = u.getYear(m), y = u.getMonth(m);
    return b * 100 + y;
  }
  function h(m) {
    var b = u.getYear(m), y = a_(u, m);
    return b * 10 + y;
  }
  var p = x.useCallback(function(m) {
    if (a && a(m))
      return !0;
    if (s[1] && c)
      return !Zu(u, m, c) && u.isAfter(m, c);
    if (e && c)
      switch (r) {
        case "quarter":
          return h(m) > h(c);
        case "month":
          return f(m) > f(c);
        case "week":
          return d(m) > d(c);
        default:
          return !Zu(u, m, c) && u.isAfter(m, c);
      }
    return !1;
  }, [a, s[1], c, e]), v = x.useCallback(function(m) {
    if (a && a(m))
      return !0;
    if (s[0] && l)
      return !Zu(u, m, c) && u.isAfter(l, m);
    if (n && l)
      switch (r) {
        case "quarter":
          return h(m) < h(l);
        case "month":
          return f(m) < f(l);
        case "week":
          return d(m) < d(l);
        default:
          return !Zu(u, m, l) && u.isAfter(l, m);
      }
    return !1;
  }, [a, s[0], l, n]);
  return [p, v];
}
function KCe(t, e, n, r) {
  var i = g0(t, n, r, 1);
  function o(a) {
    return a(t, e) ? "same" : a(i, e) ? "closing" : "far";
  }
  switch (n) {
    case "year":
      return o(function(a, s) {
        return xCe(r, a, s);
      });
    case "quarter":
    case "month":
      return o(function(a, s) {
        return Hm(r, a, s);
      });
    default:
      return o(function(a, s) {
        return BA(r, a, s);
      });
  }
}
function qCe(t, e, n, r) {
  var i = xn(t, 0), o = xn(t, 1);
  if (e === 0)
    return i;
  if (i && o) {
    var a = KCe(i, o, n, r);
    switch (a) {
      case "same":
        return i;
      case "closing":
        return i;
      default:
        return g0(o, n, r, -1);
    }
  }
  return i;
}
function QCe(t) {
  var e = t.values, n = t.picker, r = t.defaultDates, i = t.generateConfig, o = x.useState(function() {
    return [xn(r, 0), xn(r, 1)];
  }), a = be(o, 2), s = a[0], u = a[1], l = x.useState(null), c = be(l, 2), d = c[0], f = c[1], h = xn(e, 0), p = xn(e, 1);
  function v(b) {
    return s[b] ? s[b] : xn(d, b) || qCe(e, b, n, i) || h || p || i.getNow();
  }
  function m(b, y) {
    if (b) {
      var w = Ma(d, b, y);
      u(
        // Should always be an array
        Ma(s, null, y) || [null, null]
      );
      var S = (y + 1) % 2;
      xn(e, S) || (w = Ma(w, b, S)), f(w);
    } else
      (h || p) && f(null);
  }
  return [v, m];
}
function cR(t, e) {
  return t && t[0] && t[1] && e.isAfter(t[0], t[1]) ? [t[1], t[0]] : t;
}
function dR(t, e, n, r) {
  return !!(t || r && r[e] || n[(e + 1) % 2]);
}
function ewe(t) {
  var e, n, r, i = t.prefixCls, o = i === void 0 ? "rc-picker" : i, a = t.id, s = t.style, u = t.className, l = t.popupStyle, c = t.dropdownClassName, d = t.transitionName, f = t.dropdownAlign, h = t.getPopupContainer, p = t.generateConfig, v = t.locale, m = t.placeholder, b = t.autoFocus, y = t.disabled, w = t.format, S = t.picker, E = S === void 0 ? "date" : S, I = t.showTime, _ = t.use12Hours, A = t.separator, P = A === void 0 ? "~" : A, N = t.value, k = t.defaultValue, D = t.defaultPickerValue, R = t.open, V = t.defaultOpen, $ = t.disabledDate, F = t.disabledTime, M = t.dateRender, B = t.panelRender, X = t.ranges, L = t.allowEmpty, j = t.allowClear, K = t.suffixIcon, W = t.clearIcon, Y = t.pickerRef, U = t.inputReadOnly, Q = t.mode, Z = t.renderExtraFooter, ee = t.onChange, ie = t.onOpenChange, oe = t.onPanelChange, se = t.onCalendarChange, te = t.onFocus, ge = t.onBlur, he = t.onMouseDown, fe = t.onMouseUp, _e = t.onMouseEnter, Ne = t.onMouseLeave, ze = t.onClick, Ve = t.onOk, ne = t.onKeyDown, pe = t.components, ye = t.order, Ae = t.direction, we = t.activePickerIndex, ce = t.autoComplete, ve = ce === void 0 ? "off" : ce, Ie = E === "date" && !!I || E === "time", q = Ee({}), Fe = Ee(null), Ze = Ee(null), at = Ee(null), Je = Ee(null), ut = Ee(null), Ct = Ee(null), Ke = Ee(null), st = Ee(null);
  process.env.NODE_ENV !== "production" && SU(t);
  var wt = vU(cU(w, E, I, _)), qt = Tr(0, {
    value: we
  }), bt = be(qt, 2), Me = bt[0], yt = bt[1], ct = Ee(null), kt = x.useMemo(function() {
    return Array.isArray(y) ? y : [y || !1, y || !1];
  }, [y]), Vt = Tr(null, {
    value: N,
    defaultValue: k,
    postState: function(ht) {
      return E === "time" && !ye ? ht : cR(ht, p);
    }
  }), Vn = be(Vt, 2), tn = Vn[0], Xe = Vn[1], tt = QCe({
    values: tn,
    picker: E,
    defaultDates: D,
    generateConfig: p
  }), ot = be(tt, 2), lt = ot[0], He = ot[1], mt = Tr(tn, {
    postState: function(ht) {
      var Mt = ht;
      if (kt[0] && kt[1])
        return Mt;
      for (var bn = 0; bn < 2; bn += 1)
        kt[bn] && !Mt && !xn(Mt, bn) && !xn(L, bn) && (Mt = Ma(Mt, p.getNow(), bn));
      return Mt;
    }
  }), Qt = be(mt, 2), Yt = Qt[0], nn = Qt[1], Nt = Tr([E, E], {
    value: Q
  }), ue = be(Nt, 2), $e = ue[0], je = ue[1];
  Re(function() {
    je([E, E]);
  }, [E]);
  var At = function(ht, Mt) {
    je(ht), oe && oe(Mt, ht);
  }, $t = JCe({
    picker: E,
    selectedValue: Yt,
    locale: v,
    disabled: kt,
    disabledDate: $,
    generateConfig: p
  }, q.current[1], q.current[0]), qe = be($t, 2), nt = qe[0], dt = qe[1], rn = Tr(!1, {
    value: R,
    defaultValue: V,
    postState: function(ht) {
      return kt[Me] ? !1 : ht;
    },
    onChange: function(ht) {
      ie && ie(ht), !ht && ct.current && ct.current.onClose && ct.current.onClose();
    }
  }), on = be(rn, 2), Rt = on[0], Tt = on[1], Wn = Rt && Me === 0, zr = Rt && Me === 1, gr = Le(0), fo = be(gr, 2), xl = fo[0], Cl = fo[1];
  Re(function() {
    !Rt && Fe.current && Cl(Fe.current.offsetWidth);
  }, [Rt]);
  var Bs = x.useRef();
  function ho(sn, ht) {
    if (sn)
      clearTimeout(Bs.current), q.current[ht] = !0, yt(ht), Tt(sn), Rt || He(null, ht);
    else if (Me === ht) {
      Tt(sn);
      var Mt = q.current;
      Bs.current = setTimeout(function() {
        Mt === q.current && (q.current = {});
      });
    }
  }
  function Ho(sn) {
    ho(!0, sn), setTimeout(function() {
      var ht = [Ct, Ke][sn];
      ht.current && ht.current.focus();
    }, 0);
  }
  function es(sn, ht) {
    var Mt = sn, bn = xn(Mt, 0), Lr = xn(Mt, 1);
    bn && Lr && p.isAfter(bn, Lr) && (// WeekPicker only compare week
    E === "week" && !pU(p, v.locale, bn, Lr) || // QuotaPicker only compare week
    E === "quarter" && !hU(p, bn, Lr) || // Other non-TimePicker compare date
    E !== "week" && E !== "quarter" && E !== "time" && !Zu(p, bn, Lr) ? (ht === 0 ? (Mt = [bn, null], Lr = null) : (bn = null, Mt = [null, Lr]), q.current = z({}, ht, !0)) : (E !== "time" || ye !== !1) && (Mt = cR(Mt, p))), nn(Mt);
    var Ea = Mt && Mt[0] ? Bi(Mt[0], {
      generateConfig: p,
      locale: v,
      format: wt[0]
    }) : "", Gi = Mt && Mt[1] ? Bi(Mt[1], {
      generateConfig: p,
      locale: v,
      format: wt[0]
    }) : "";
    if (se) {
      var Wo = {
        range: ht === 0 ? "start" : "end"
      };
      se(Mt, [Ea, Gi], Wo);
    }
    var jo = dR(bn, 0, kt, L), Sa = dR(Lr, 1, kt, L), Iu = Mt === null || jo && Sa;
    Iu && (Xe(Mt), ee && (!rp(p, xn(tn, 0), bn) || !rp(p, xn(tn, 1), Lr)) && ee(Mt, [Ea, Gi]));
    var ki = null;
    ht === 0 && !kt[1] ? ki = 1 : ht === 1 && !kt[0] && (ki = 0), ki !== null && ki !== Me && (!q.current[ki] || !xn(Mt, ki)) && xn(Mt, ht) ? Ho(ki) : ho(!1, ht);
  }
  var wl = function(ht) {
    return Rt && ct.current && ct.current.onKeyDown ? ct.current.onKeyDown(ht) : (Wt(!1, "Picker not correct forward KeyDown operation. Please help to fire issue about this."), !1);
  }, Hs = {
    formatList: wt,
    generateConfig: p,
    locale: v
  }, an = wx(xn(Yt, 0), Hs), jt = be(an, 2), Nr = jt[0], qr = jt[1], mr = wx(xn(Yt, 1), Hs), si = be(mr, 2), Qr = si[0], Dn = si[1], hn = function(ht, Mt) {
    var bn = gU(ht, {
      locale: v,
      formatList: wt,
      generateConfig: p
    }), Lr = Mt === 0 ? nt : dt;
    bn && !Lr(bn) && (nn(Ma(Yt, bn, Mt)), He(bn, Mt));
  }, Mn = c_({
    valueTexts: Nr,
    onTextChange: function(ht) {
      return hn(ht, 0);
    }
  }), Qn = be(Mn, 3), Fr = Qn[0], po = Qn[1], Ws = Qn[2], gf = c_({
    valueTexts: Qr,
    onTextChange: function(ht) {
      return hn(ht, 1);
    }
  }), Mc = be(gf, 3), El = Mc[0], Su = Mc[1], Kp = Mc[2], Mv = Le(null), Fv = be(Mv, 2), Lv = Fv[0], qp = Fv[1], Vv = Le(null), Qp = be(Vv, 2), Sl = Qp[0], Bv = Qp[1], gE = d_(Fr, {
    formatList: wt,
    generateConfig: p,
    locale: v
  }), mf = be(gE, 3), Hv = mf[0], mE = mf[1], eg = mf[2], vE = d_(El, {
    formatList: wt,
    generateConfig: p,
    locale: v
  }), Fc = be(vE, 3), Wv = Fc[0], bE = Fc[1], tg = Fc[2], yE = function(ht) {
    Bv(Ma(Yt, ht, Me)), Me === 0 ? mE(ht) : bE(ht);
  }, xE = function() {
    Bv(Ma(Yt, null, Me)), Me === 0 ? eg() : tg();
  }, vr = function(ht, Mt) {
    return {
      blurToCancel: Ie,
      forwardKeyDown: wl,
      onBlur: ge,
      isClickOutside: function(Lr) {
        return !fU([Ze.current, at.current, Je.current, Fe.current], Lr);
      },
      onFocus: function(Lr) {
        yt(ht), te && te(Lr);
      },
      triggerOpen: function(Lr) {
        ho(Lr, ht);
      },
      onSubmit: function() {
        if (
          // When user typing disabledDate with keyboard and enter, this value will be empty
          !Yt || // Normal disabled check
          $ && $(Yt[ht])
        )
          return !1;
        es(Yt, ht), Mt();
      },
      onCancel: function() {
        ho(!1, ht), nn(tn), Mt();
      }
    };
  }, lr = Ee(""), CE = l_(de(de({}, vr(0, Ws)), {}, {
    open: Wn,
    value: Fr,
    currentFocusedKey: lr,
    key: "start",
    onKeyDown: function(ht, Mt) {
      ne == null || ne(ht, Mt);
    }
  })), jv = be(CE, 2), wE = jv[0], zv = jv[1], Gv = zv.focused, Uv = zv.typing, Xv = l_(de(de({}, vr(1, Kp)), {}, {
    open: zr,
    value: El,
    currentFocusedKey: lr,
    key: "end",
    onKeyDown: function(ht, Mt) {
      ne == null || ne(ht, Mt);
    }
  })), Yv = be(Xv, 2), gi = Yv[0], vf = Yv[1], js = vf.focused, ng = vf.typing, rg = function(ht) {
    ze && ze(ht), !Rt && !Ct.current.contains(ht.target) && !Ke.current.contains(ht.target) && (kt[0] ? kt[1] || Ho(1) : Ho(0));
  }, go = function(ht) {
    he && he(ht), Rt && (Gv || js) && !Ct.current.contains(ht.target) && !Ke.current.contains(ht.target) && ht.preventDefault();
  }, Zv = tn && tn[0] ? Bi(tn[0], {
    locale: v,
    format: "YYYYMMDDHHmmss",
    generateConfig: p
  }) : "", Jv = tn && tn[1] ? Bi(tn[1], {
    locale: v,
    format: "YYYYMMDDHHmmss",
    generateConfig: p
  }) : "";
  Re(function() {
    Rt || (nn(tn), !Nr.length || Nr[0] === "" ? po("") : qr !== Fr && Ws(), !Qr.length || Qr[0] === "" ? Su("") : Dn !== El && Kp());
  }, [Rt, Nr, Qr]), Re(function() {
    nn(tn);
  }, [Zv, Jv]), process.env.NODE_ENV !== "production" && N && Array.isArray(y) && (xn(y, 0) && !xn(N, 0) || xn(y, 1) && !xn(N, 1)) && Wt(!1, "`disabled` should not set with empty `value`. You should set `allowEmpty` or `value` instead."), Y && (Y.current = {
    focus: function() {
      Ct.current && Ct.current.focus();
    },
    blur: function() {
      Ct.current && Ct.current.blur(), Ke.current && Ke.current.blur();
    }
  });
  var Kv = Object.keys(X || {}), qv = Kv.map(function(sn) {
    var ht = X[sn], Mt = typeof ht == "function" ? ht() : ht;
    return {
      label: sn,
      onClick: function() {
        es(Mt, null), ho(!1, Me);
      },
      onMouseEnter: function() {
        qp(Mt);
      },
      onMouseLeave: function() {
        qp(null);
      }
    };
  });
  function bf() {
    var sn = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : !1, ht = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, Mt = null;
    Rt && Sl && Sl[0] && Sl[1] && p.isAfter(Sl[1], Sl[0]) && (Mt = Sl);
    var bn = I;
    if (I && _t(I) === "object" && I.defaultValue) {
      var Lr = I.defaultValue;
      bn = de(de({}, I), {}, {
        defaultValue: xn(Lr, Me) || void 0
      });
    }
    var Ea = null;
    return M && (Ea = function(Wo, jo) {
      return M(Wo, jo, {
        range: Me ? "end" : "start"
      });
    }), /* @__PURE__ */ x.createElement(_p.Provider, {
      value: {
        inRange: !0,
        panelPosition: sn,
        rangedValue: Lv || Yt,
        hoverRangedValue: Mt
      }
    }, /* @__PURE__ */ x.createElement(wU, G({}, t, ht, {
      dateRender: Ea,
      showTime: bn,
      mode: $e[Me],
      generateConfig: p,
      style: void 0,
      direction: Ae,
      disabledDate: Me === 0 ? nt : dt,
      disabledTime: function(Wo) {
        return F ? F(Wo, Me === 0 ? "start" : "end") : !1;
      },
      className: Ce(z({}, "".concat(o, "-panel-focused"), Me === 0 ? !Uv : !ng)),
      value: xn(Yt, Me),
      locale: v,
      tabIndex: -1,
      onPanelChange: function(Wo, jo) {
        Me === 0 && eg(!0), Me === 1 && tg(!0), At(Ma($e, jo, Me), Ma(Yt, Wo, Me));
        var Sa = Wo;
        sn === "right" && $e[Me] === jo && (Sa = g0(Sa, jo, p, -1)), He(Sa, Me);
      },
      onOk: null,
      onSelect: void 0,
      onChange: void 0,
      defaultValue: Me === 0 ? xn(Yt, 1) : xn(Yt, 0)
    })));
  }
  var ts = 0, zi = 0;
  if (Me && at.current && ut.current && Ze.current) {
    ts = at.current.offsetWidth + ut.current.offsetWidth;
    var EE = st.current.offsetLeft > ts ? st.current.offsetLeft - ts : st.current.offsetLeft;
    Ze.current.offsetWidth && st.current.offsetWidth && ts > Ze.current.offsetWidth - st.current.offsetWidth - (Ae === "rtl" ? 0 : EE) && (zi = ts);
  }
  var mo = Ae === "rtl" ? {
    right: ts
  } : {
    left: ts
  };
  function SE() {
    var sn, ht = xU(o, $e[Me], Z), Mt = CU({
      prefixCls: o,
      components: pe,
      needConfirmButton: Ie,
      okDisabled: !xn(Yt, Me) || $ && $(Yt[Me]),
      locale: v,
      rangeList: qv,
      onOk: function() {
        xn(Yt, Me) && (es(Yt, Me), Ve && Ve(Yt));
      }
    });
    if (E !== "time" && !I) {
      var bn = lt(Me), Lr = g0(bn, E, p), Ea = $e[Me], Gi = Ea === E, Wo = bf(Gi ? "left" : !1, {
        pickerValue: bn,
        onPickerValueChange: function(ki) {
          He(ki, Me);
        }
      }), jo = bf("right", {
        pickerValue: Lr,
        onPickerValueChange: function(ki) {
          He(g0(ki, E, p, -1), Me);
        }
      });
      Ae === "rtl" ? sn = /* @__PURE__ */ x.createElement(x.Fragment, null, jo, Gi && Wo) : sn = /* @__PURE__ */ x.createElement(x.Fragment, null, Wo, Gi && jo);
    } else
      sn = bf();
    var Sa = /* @__PURE__ */ x.createElement(x.Fragment, null, /* @__PURE__ */ x.createElement("div", {
      className: "".concat(o, "-panels")
    }, sn), (ht || Mt) && /* @__PURE__ */ x.createElement("div", {
      className: "".concat(o, "-footer")
    }, ht, Mt));
    return B && (Sa = B(Sa)), /* @__PURE__ */ x.createElement("div", {
      className: "".concat(o, "-panel-container"),
      style: {
        marginLeft: zi
      },
      ref: Ze,
      onMouseDown: function(ki) {
        ki.preventDefault();
      }
    }, Sa);
  }
  var Qv = /* @__PURE__ */ x.createElement("div", {
    className: Ce("".concat(o, "-range-wrapper"), "".concat(o, "-").concat(E, "-range-wrapper")),
    style: {
      minWidth: xl
    }
  }, /* @__PURE__ */ x.createElement("div", {
    ref: st,
    className: "".concat(o, "-range-arrow"),
    style: mo
  }), SE()), ns;
  K && (ns = /* @__PURE__ */ x.createElement("span", {
    className: "".concat(o, "-suffix")
  }, K));
  var Lc;
  j && (xn(tn, 0) && !kt[0] || xn(tn, 1) && !kt[1]) && (Lc = /* @__PURE__ */ x.createElement("span", {
    onMouseDown: function(ht) {
      ht.preventDefault(), ht.stopPropagation();
    },
    onMouseUp: function(ht) {
      ht.preventDefault(), ht.stopPropagation();
      var Mt = tn;
      kt[0] || (Mt = Ma(Mt, null, 0)), kt[1] || (Mt = Ma(Mt, null, 1)), es(Mt, null), ho(!1, Me);
    },
    className: "".concat(o, "-clear")
  }, W || /* @__PURE__ */ x.createElement("span", {
    className: "".concat(o, "-clear-btn")
  })));
  var yf = {
    size: dU(E, wt[0], p)
  }, br = 0, wa = 0;
  at.current && Je.current && ut.current && (Me === 0 ? wa = at.current.offsetWidth : (br = ts, wa = Je.current.offsetWidth));
  var ig = Ae === "rtl" ? {
    right: br
  } : {
    left: br
  }, IE = function(ht, Mt) {
    var bn = Ma(Yt, ht, Me);
    Mt === "submit" || Mt !== "key" && !Ie ? (es(bn, Me), Me === 0 ? eg() : tg()) : nn(bn);
  };
  return /* @__PURE__ */ x.createElement(ga.Provider, {
    value: {
      operationRef: ct,
      hideHeader: E === "time",
      onDateMouseEnter: yE,
      onDateMouseLeave: xE,
      hideRanges: !0,
      onSelect: IE,
      open: Rt
    }
  }, /* @__PURE__ */ x.createElement(EU, {
    visible: Rt,
    popupElement: Qv,
    popupStyle: l,
    prefixCls: o,
    dropdownClassName: c,
    dropdownAlign: f,
    getPopupContainer: h,
    transitionName: d,
    range: !0,
    direction: Ae
  }, /* @__PURE__ */ x.createElement("div", G({
    ref: Fe,
    className: Ce(o, "".concat(o, "-range"), u, (e = {}, z(e, "".concat(o, "-disabled"), kt[0] && kt[1]), z(e, "".concat(o, "-focused"), Me === 0 ? Gv : js), z(e, "".concat(o, "-rtl"), Ae === "rtl"), e)),
    style: s,
    onClick: rg,
    onMouseEnter: _e,
    onMouseLeave: Ne,
    onMouseDown: go,
    onMouseUp: fe
  }, bU(t)), /* @__PURE__ */ x.createElement("div", {
    className: Ce("".concat(o, "-input"), (n = {}, z(n, "".concat(o, "-input-active"), Me === 0), z(n, "".concat(o, "-input-placeholder"), !!Hv), n)),
    ref: at
  }, /* @__PURE__ */ x.createElement("input", G({
    id: a,
    disabled: kt[0],
    readOnly: U || typeof wt[0] == "function" || !Uv,
    value: Hv || Fr,
    onChange: function(ht) {
      po(ht.target.value);
    },
    autoFocus: b,
    placeholder: xn(m, 0) || "",
    ref: Ct
  }, wE, yf, {
    autoComplete: ve
  }))), /* @__PURE__ */ x.createElement("div", {
    className: "".concat(o, "-range-separator"),
    ref: ut
  }, P), /* @__PURE__ */ x.createElement("div", {
    className: Ce("".concat(o, "-input"), (r = {}, z(r, "".concat(o, "-input-active"), Me === 1), z(r, "".concat(o, "-input-placeholder"), !!Wv), r)),
    ref: Je
  }, /* @__PURE__ */ x.createElement("input", G({
    disabled: kt[1],
    readOnly: U || typeof wt[0] == "function" || !ng,
    value: Wv || El,
    onChange: function(ht) {
      Su(ht.target.value);
    },
    placeholder: xn(m, 1) || "",
    ref: Ke
  }, gi, yf, {
    autoComplete: ve
  }))), /* @__PURE__ */ x.createElement("div", {
    className: "".concat(o, "-active-bar"),
    style: de(de({}, ig), {}, {
      width: wa,
      position: "absolute"
    })
  }), ns, Lc)));
}
var twe = /* @__PURE__ */ function(t) {
  Pr(n, t);
  var e = Hr(n);
  function n() {
    var r;
    zn(this, n);
    for (var i = arguments.length, o = new Array(i), a = 0; a < i; a++)
      o[a] = arguments[a];
    return r = e.call.apply(e, [this].concat(o)), r.pickerRef = /* @__PURE__ */ x.createRef(), r.focus = function() {
      r.pickerRef.current && r.pickerRef.current.focus();
    }, r.blur = function() {
      r.pickerRef.current && r.pickerRef.current.blur();
    }, r;
  }
  return Gn(n, [{
    key: "render",
    value: function() {
      return /* @__PURE__ */ x.createElement(ewe, G({}, this.props, {
        pickerRef: this.pickerRef
      }));
    }
  }]), n;
}(x.Component), IU = /* @__PURE__ */ x.createContext(null), nwe = IU.Provider, _U = /* @__PURE__ */ x.createContext(null), rwe = _U.Provider, iwe = ["prefixCls", "className", "style", "checked", "disabled", "defaultChecked", "type", "onChange"], AU = /* @__PURE__ */ gt(function(t, e) {
  var n, r = t.prefixCls, i = r === void 0 ? "rc-checkbox" : r, o = t.className, a = t.style, s = t.checked, u = t.disabled, l = t.defaultChecked, c = l === void 0 ? !1 : l, d = t.type, f = d === void 0 ? "checkbox" : d, h = t.onChange, p = Gt(t, iwe), v = Ee(null), m = Tr(c, {
    value: s
  }), b = be(m, 2), y = b[0], w = b[1];
  wc(e, function() {
    return {
      focus: function() {
        var _;
        (_ = v.current) === null || _ === void 0 || _.focus();
      },
      blur: function() {
        var _;
        (_ = v.current) === null || _ === void 0 || _.blur();
      },
      input: v.current
    };
  });
  var S = Ce(i, o, (n = {}, z(n, "".concat(i, "-checked"), y), z(n, "".concat(i, "-disabled"), u), n)), E = function(_) {
    u || ("checked" in t || w(_.target.checked), h == null || h({
      target: de(de({}, t), {}, {
        type: f,
        checked: _.target.checked
      }),
      stopPropagation: function() {
        _.stopPropagation();
      },
      preventDefault: function() {
        _.preventDefault();
      },
      nativeEvent: _.nativeEvent
    }));
  };
  return /* @__PURE__ */ x.createElement("span", {
    className: S,
    style: a
  }, /* @__PURE__ */ x.createElement("input", G({}, p, {
    className: "".concat(i, "-input"),
    ref: v,
    onChange: E,
    disabled: u,
    checked: !!y,
    type: f
  })), /* @__PURE__ */ x.createElement("span", {
    className: "".concat(i, "-inner")
  }));
}), owe = function(t, e) {
  var n = {};
  for (var r in t)
    Object.prototype.hasOwnProperty.call(t, r) && e.indexOf(r) < 0 && (n[r] = t[r]);
  if (t != null && typeof Object.getOwnPropertySymbols == "function")
    for (var i = 0, r = Object.getOwnPropertySymbols(t); i < r.length; i++)
      e.indexOf(r[i]) < 0 && Object.prototype.propertyIsEnumerable.call(t, r[i]) && (n[r[i]] = t[r[i]]);
  return n;
}, awe = function(e, n) {
  var r, i, o = x.useContext(IU), a = x.useContext(_U), s = x.useContext(en), u = s.getPrefixCls, l = s.direction, c = x.useRef(), d = Ja(n, c), f = fn(Ji), h = f.isFormItemInput;
  process.env.NODE_ENV !== "production" && gn(!("optionType" in e), "Radio", "`optionType` is only support in Radio.Group.");
  var p = function(N) {
    var k, D;
    (k = e.onChange) === null || k === void 0 || k.call(e, N), (D = o == null ? void 0 : o.onChange) === null || D === void 0 || D.call(o, N);
  }, v = e.prefixCls, m = e.className, b = e.children, y = e.style, w = owe(e, ["prefixCls", "className", "children", "style"]), S = u("radio", v), E = ((o == null ? void 0 : o.optionType) || a) === "button" ? "".concat(S, "-button") : S, I = G({}, w), _ = x.useContext(Ka);
  o && (I.name = o.name, I.onChange = p, I.checked = e.value === o.value, I.disabled = (r = I.disabled) !== null && r !== void 0 ? r : o.disabled), I.disabled = (i = I.disabled) !== null && i !== void 0 ? i : _;
  var A = Ce("".concat(E, "-wrapper"), z(z(z(z({}, "".concat(E, "-wrapper-checked"), I.checked), "".concat(E, "-wrapper-disabled"), I.disabled), "".concat(E, "-wrapper-rtl"), l === "rtl"), "".concat(E, "-wrapper-in-form-item"), h), m);
  return (
    // eslint-disable-next-line jsx-a11y/label-has-associated-control
    /* @__PURE__ */ x.createElement("label", {
      className: A,
      style: y,
      onMouseEnter: e.onMouseEnter,
      onMouseLeave: e.onMouseLeave
    }, /* @__PURE__ */ x.createElement(AU, G({}, I, {
      type: "radio",
      prefixCls: E,
      ref: d
    })), b !== void 0 ? /* @__PURE__ */ x.createElement("span", null, b) : null)
  );
}, TU = /* @__PURE__ */ x.forwardRef(awe);
process.env.NODE_ENV !== "production" && (TU.displayName = "Radio");
const Ex = TU;
var swe = /* @__PURE__ */ x.forwardRef(function(t, e) {
  var n = x.useContext(en), r = n.getPrefixCls, i = n.direction, o = x.useContext(qa), a = Tr(t.defaultValue, {
    value: t.value
  }), s = be(a, 2), u = s[0], l = s[1], c = function(F) {
    var M = u, B = F.target.value;
    "value" in t || l(B);
    var X = t.onChange;
    X && B !== M && X(F);
  }, d = t.prefixCls, f = t.className, h = f === void 0 ? "" : f, p = t.options, v = t.buttonStyle, m = v === void 0 ? "outline" : v, b = t.disabled, y = t.children, w = t.size, S = t.style, E = t.id, I = t.onMouseEnter, _ = t.onMouseLeave, A = t.onFocus, P = t.onBlur, N = r("radio", d), k = "".concat(N, "-group"), D = y;
  p && p.length > 0 && (D = p.map(function($) {
    return typeof $ == "string" || typeof $ == "number" ? /* @__PURE__ */ x.createElement(Ex, {
      key: $.toString(),
      prefixCls: N,
      disabled: b,
      value: $,
      checked: u === $
    }, $) : /* @__PURE__ */ x.createElement(Ex, {
      key: "radio-group-value-options-".concat($.value),
      prefixCls: N,
      disabled: $.disabled || b,
      value: $.value,
      checked: u === $.value,
      style: $.style
    }, $.label);
  }));
  var R = w || o, V = Ce(k, "".concat(k, "-").concat(m), z(z({}, "".concat(k, "-").concat(R), R), "".concat(k, "-rtl"), i === "rtl"), h);
  return /* @__PURE__ */ x.createElement("div", G({}, vve(t), {
    className: V,
    style: S,
    onMouseEnter: I,
    onMouseLeave: _,
    onFocus: A,
    onBlur: P,
    id: E,
    ref: e
  }), /* @__PURE__ */ x.createElement(nwe, {
    value: {
      onChange: c,
      value: u,
      disabled: t.disabled,
      name: t.name,
      optionType: t.optionType
    }
  }, D));
});
const uwe = /* @__PURE__ */ x.memo(swe);
var lwe = function(t, e) {
  var n = {};
  for (var r in t)
    Object.prototype.hasOwnProperty.call(t, r) && e.indexOf(r) < 0 && (n[r] = t[r]);
  if (t != null && typeof Object.getOwnPropertySymbols == "function")
    for (var i = 0, r = Object.getOwnPropertySymbols(t); i < r.length; i++)
      e.indexOf(r[i]) < 0 && Object.prototype.propertyIsEnumerable.call(t, r[i]) && (n[r[i]] = t[r[i]]);
  return n;
}, cwe = function(e, n) {
  var r = x.useContext(en), i = r.getPrefixCls, o = e.prefixCls, a = lwe(e, ["prefixCls"]), s = i("radio", o);
  return /* @__PURE__ */ x.createElement(rwe, {
    value: "button"
  }, /* @__PURE__ */ x.createElement(Ex, G({
    prefixCls: s
  }, a, {
    type: "radio",
    ref: n
  })));
};
const dwe = /* @__PURE__ */ x.forwardRef(cwe);
var AC = Ex;
AC.Button = dwe;
AC.Group = uwe;
AC.__ANT_RADIO = !0;
const YS = AC;
var fwe = function(t, e) {
  var n = {};
  for (var r in t)
    Object.prototype.hasOwnProperty.call(t, r) && e.indexOf(r) < 0 && (n[r] = t[r]);
  if (t != null && typeof Object.getOwnPropertySymbols == "function")
    for (var i = 0, r = Object.getOwnPropertySymbols(t); i < r.length; i++)
      e.indexOf(r[i]) < 0 && Object.prototype.propertyIsEnumerable.call(t, r[i]) && (n[r[i]] = t[r[i]]);
  return n;
}, OU = /* @__PURE__ */ x.createContext(null), hwe = function(e, n) {
  var r = e.defaultValue, i = e.children, o = e.options, a = o === void 0 ? [] : o, s = e.prefixCls, u = e.className, l = e.style, c = e.onChange, d = fwe(e, ["defaultValue", "children", "options", "prefixCls", "className", "style", "onChange"]), f = x.useContext(en), h = f.getPrefixCls, p = f.direction, v = x.useState(d.value || r || []), m = be(v, 2), b = m[0], y = m[1], w = x.useState([]), S = be(w, 2), E = S[0], I = S[1];
  x.useEffect(function() {
    "value" in d && y(d.value || []);
  }, [d.value]);
  var _ = function() {
    return a.map(function(M) {
      return typeof M == "string" || typeof M == "number" ? {
        label: M,
        value: M
      } : M;
    });
  }, A = function(M) {
    I(function(B) {
      return B.filter(function(X) {
        return X !== M;
      });
    });
  }, P = function(M) {
    I(function(B) {
      return [].concat(Ye(B), [M]);
    });
  }, N = function(M) {
    var B = b.indexOf(M.value), X = Ye(b);
    B === -1 ? X.push(M.value) : X.splice(B, 1), "value" in d || y(X);
    var L = _();
    c == null || c(X.filter(function(j) {
      return E.includes(j);
    }).sort(function(j, K) {
      var W = L.findIndex(function(U) {
        return U.value === j;
      }), Y = L.findIndex(function(U) {
        return U.value === K;
      });
      return W - Y;
    }));
  }, k = h("checkbox", s), D = "".concat(k, "-group"), R = Pi(d, ["value", "disabled"]);
  a && a.length > 0 && (i = _().map(function(F) {
    return /* @__PURE__ */ x.createElement(NU, {
      prefixCls: k,
      key: F.value.toString(),
      disabled: "disabled" in F ? F.disabled : d.disabled,
      value: F.value,
      checked: b.includes(F.value),
      onChange: F.onChange,
      className: "".concat(D, "-item"),
      style: F.style
    }, F.label);
  }));
  var V = {
    toggleOption: N,
    value: b,
    disabled: d.disabled,
    name: d.name,
    // https://github.com/ant-design/ant-design/issues/16376
    registerValue: P,
    cancelValue: A
  }, $ = Ce(D, z({}, "".concat(D, "-rtl"), p === "rtl"), u);
  return /* @__PURE__ */ x.createElement("div", G({
    className: $,
    style: l
  }, R, {
    ref: n
  }), /* @__PURE__ */ x.createElement(OU.Provider, {
    value: V
  }, i));
}, pwe = /* @__PURE__ */ x.forwardRef(hwe);
const gwe = /* @__PURE__ */ x.memo(pwe);
var mwe = function(t, e) {
  var n = {};
  for (var r in t)
    Object.prototype.hasOwnProperty.call(t, r) && e.indexOf(r) < 0 && (n[r] = t[r]);
  if (t != null && typeof Object.getOwnPropertySymbols == "function")
    for (var i = 0, r = Object.getOwnPropertySymbols(t); i < r.length; i++)
      e.indexOf(r[i]) < 0 && Object.prototype.propertyIsEnumerable.call(t, r[i]) && (n[r[i]] = t[r[i]]);
  return n;
}, vwe = function(e, n) {
  var r, i = e.prefixCls, o = e.className, a = e.children, s = e.indeterminate, u = s === void 0 ? !1 : s, l = e.style, c = e.onMouseEnter, d = e.onMouseLeave, f = e.skipGroup, h = f === void 0 ? !1 : f, p = e.disabled, v = mwe(e, ["prefixCls", "className", "children", "indeterminate", "style", "onMouseEnter", "onMouseLeave", "skipGroup", "disabled"]), m = x.useContext(en), b = m.getPrefixCls, y = m.direction, w = x.useContext(OU), S = fn(Ji), E = S.isFormItemInput, I = fn(Ka), _ = (r = (w == null ? void 0 : w.disabled) || p) !== null && r !== void 0 ? r : I, A = x.useRef(v.value);
  x.useEffect(function() {
    w == null || w.registerValue(v.value), process.env.NODE_ENV !== "production" && gn("checked" in v || !!w || !("value" in v), "Checkbox", "`value` is not a valid prop, do you mean `checked`?");
  }, []), x.useEffect(function() {
    if (!h)
      return v.value !== A.current && (w == null || w.cancelValue(A.current), w == null || w.registerValue(v.value), A.current = v.value), function() {
        return w == null ? void 0 : w.cancelValue(v.value);
      };
  }, [v.value]);
  var P = b("checkbox", i), N = G({}, v);
  w && !h && (N.onChange = function() {
    v.onChange && v.onChange.apply(v, arguments), w.toggleOption && w.toggleOption({
      label: a,
      value: v.value
    });
  }, N.name = w.name, N.checked = w.value.includes(v.value));
  var k = Ce(z(z(z(z(z({}, "".concat(P, "-wrapper"), !0), "".concat(P, "-rtl"), y === "rtl"), "".concat(P, "-wrapper-checked"), N.checked), "".concat(P, "-wrapper-disabled"), _), "".concat(P, "-wrapper-in-form-item"), E), o), D = Ce(z({}, "".concat(P, "-indeterminate"), u)), R = u ? "mixed" : void 0;
  return (
    // eslint-disable-next-line jsx-a11y/label-has-associated-control
    /* @__PURE__ */ x.createElement("label", {
      className: k,
      style: l,
      onMouseEnter: c,
      onMouseLeave: d
    }, /* @__PURE__ */ x.createElement(AU, G({
      "aria-checked": R
    }, N, {
      prefixCls: P,
      className: D,
      disabled: _,
      ref: n
    })), a !== void 0 && /* @__PURE__ */ x.createElement("span", null, a))
  );
}, PU = /* @__PURE__ */ x.forwardRef(vwe);
process.env.NODE_ENV !== "production" && (PU.displayName = "Checkbox");
const NU = PU;
var jA = NU;
jA.Group = gwe;
jA.__ANT_CHECKBOX = !0;
const Y0 = jA;
var bwe = /* @__PURE__ */ oi({});
const kU = bwe;
var ywe = function(t, e) {
  var n = {};
  for (var r in t)
    Object.prototype.hasOwnProperty.call(t, r) && e.indexOf(r) < 0 && (n[r] = t[r]);
  if (t != null && typeof Object.getOwnPropertySymbols == "function")
    for (var i = 0, r = Object.getOwnPropertySymbols(t); i < r.length; i++)
      e.indexOf(r[i]) < 0 && Object.prototype.propertyIsEnumerable.call(t, r[i]) && (n[r[i]] = t[r[i]]);
  return n;
};
function xwe(t) {
  return typeof t == "number" ? "".concat(t, " ").concat(t, " auto") : /^\d+(\.\d+)?(px|em|rem|%)$/.test(t) ? "0 0 ".concat(t) : t;
}
var Cwe = ["xs", "sm", "md", "lg", "xl", "xxl"], RU = /* @__PURE__ */ x.forwardRef(function(t, e) {
  var n = x.useContext(en), r = n.getPrefixCls, i = n.direction, o = x.useContext(kU), a = o.gutter, s = o.wrap, u = o.supportFlexGap, l = t.prefixCls, c = t.span, d = t.order, f = t.offset, h = t.push, p = t.pull, v = t.className, m = t.children, b = t.flex, y = t.style, w = ywe(t, ["prefixCls", "span", "order", "offset", "push", "pull", "className", "children", "flex", "style"]), S = r("col", l), E = {};
  Cwe.forEach(function(N) {
    var k = {}, D = t[N];
    typeof D == "number" ? k.span = D : _t(D) === "object" && (k = D || {}), delete w[N], E = G(G({}, E), z(z(z(z(z(z({}, "".concat(S, "-").concat(N, "-").concat(k.span), k.span !== void 0), "".concat(S, "-").concat(N, "-order-").concat(k.order), k.order || k.order === 0), "".concat(S, "-").concat(N, "-offset-").concat(k.offset), k.offset || k.offset === 0), "".concat(S, "-").concat(N, "-push-").concat(k.push), k.push || k.push === 0), "".concat(S, "-").concat(N, "-pull-").concat(k.pull), k.pull || k.pull === 0), "".concat(S, "-rtl"), i === "rtl"));
  });
  var I = Ce(S, z(z(z(z(z({}, "".concat(S, "-").concat(c), c !== void 0), "".concat(S, "-order-").concat(d), d), "".concat(S, "-offset-").concat(f), f), "".concat(S, "-push-").concat(h), h), "".concat(S, "-pull-").concat(p), p), v, E), _ = {};
  if (a && a[0] > 0) {
    var A = a[0] / 2;
    _.paddingLeft = A, _.paddingRight = A;
  }
  if (a && a[1] > 0 && !u) {
    var P = a[1] / 2;
    _.paddingTop = P, _.paddingBottom = P;
  }
  return b && (_.flex = xwe(b), s === !1 && !_.minWidth && (_.minWidth = 0)), /* @__PURE__ */ x.createElement("div", G({}, w, {
    style: G(G({}, _), y),
    className: I,
    ref: e
  }), m);
});
process.env.NODE_ENV !== "production" && (RU.displayName = "Col");
const rc = RU;
var wwe = function(t, e) {
  var n = {};
  for (var r in t)
    Object.prototype.hasOwnProperty.call(t, r) && e.indexOf(r) < 0 && (n[r] = t[r]);
  if (t != null && typeof Object.getOwnPropertySymbols == "function")
    for (var i = 0, r = Object.getOwnPropertySymbols(t); i < r.length; i++)
      e.indexOf(r[i]) < 0 && Object.prototype.propertyIsEnumerable.call(t, r[i]) && (n[r[i]] = t[r[i]]);
  return n;
};
Ki("top", "middle", "bottom", "stretch");
Ki("start", "end", "center", "space-around", "space-between", "space-evenly");
function fR(t, e) {
  var n = x.useState(typeof t == "string" ? t : ""), r = be(n, 2), i = r[0], o = r[1], a = function() {
    if (typeof t == "string" && o(t), _t(t) === "object")
      for (var u = 0; u < vx.length; u++) {
        var l = vx[u];
        if (e[l]) {
          var c = t[l];
          if (c !== void 0) {
            o(c);
            return;
          }
        }
      }
  };
  return x.useEffect(function() {
    a();
  }, [JSON.stringify(t), e]), i;
}
var $U = /* @__PURE__ */ x.forwardRef(function(t, e) {
  var n = t.prefixCls, r = t.justify, i = t.align, o = t.className, a = t.style, s = t.children, u = t.gutter, l = u === void 0 ? 0 : u, c = t.wrap, d = wwe(t, ["prefixCls", "justify", "align", "className", "style", "children", "gutter", "wrap"]), f = x.useContext(en), h = f.getPrefixCls, p = f.direction, v = x.useState({
    xs: !0,
    sm: !0,
    md: !0,
    lg: !0,
    xl: !0,
    xxl: !0
  }), m = be(v, 2), b = m[0], y = m[1], w = x.useState({
    xs: !1,
    sm: !1,
    md: !1,
    lg: !1,
    xl: !1,
    xxl: !1
  }), S = be(w, 2), E = S[0], I = S[1], _ = fR(i, E), A = fR(r, E), P = YG(), N = x.useRef(l);
  x.useEffect(function() {
    var W = bx.subscribe(function(Y) {
      I(Y);
      var U = N.current || 0;
      (!Array.isArray(U) && _t(U) === "object" || Array.isArray(U) && (_t(U[0]) === "object" || _t(U[1]) === "object")) && y(Y);
    });
    return function() {
      return bx.unsubscribe(W);
    };
  }, []);
  var k = function() {
    var Y = [void 0, void 0], U = Array.isArray(l) ? l : [l, void 0];
    return U.forEach(function(Q, Z) {
      if (_t(Q) === "object")
        for (var ee = 0; ee < vx.length; ee++) {
          var ie = vx[ee];
          if (b[ie] && Q[ie] !== void 0) {
            Y[Z] = Q[ie];
            break;
          }
        }
      else
        Y[Z] = Q;
    }), Y;
  }, D = h("row", n), R = k(), V = Ce(D, z(z(z(z({}, "".concat(D, "-no-wrap"), c === !1), "".concat(D, "-").concat(A), A), "".concat(D, "-").concat(_), _), "".concat(D, "-rtl"), p === "rtl"), o), $ = {}, F = R[0] != null && R[0] > 0 ? R[0] / -2 : void 0, M = R[1] != null && R[1] > 0 ? R[1] / -2 : void 0;
  if (F && ($.marginLeft = F, $.marginRight = F), P) {
    var B = be(R, 2);
    $.rowGap = B[1];
  } else
    M && ($.marginTop = M, $.marginBottom = M);
  var X = be(R, 2), L = X[0], j = X[1], K = x.useMemo(function() {
    return {
      gutter: [L, j],
      wrap: c,
      supportFlexGap: P
    };
  }, [L, j, c, P]);
  return /* @__PURE__ */ x.createElement(kU.Provider, {
    value: K
  }, /* @__PURE__ */ x.createElement("div", G({}, d, {
    className: V,
    style: G(G({}, $), a),
    ref: e
  }), s));
});
process.env.NODE_ENV !== "production" && ($U.displayName = "Row");
const Wm = $U;
var Ewe = function(e, n, r, i) {
  var o = r ? r.call(i, e, n) : void 0;
  if (o !== void 0)
    return !!o;
  if (e === n)
    return !0;
  if (typeof e != "object" || !e || typeof n != "object" || !n)
    return !1;
  var a = Object.keys(e), s = Object.keys(n);
  if (a.length !== s.length)
    return !1;
  for (var u = Object.prototype.hasOwnProperty.bind(n), l = 0; l < a.length; l++) {
    var c = a[l];
    if (!u(c))
      return !1;
    var d = e[c], f = n[c];
    if (o = r ? r.call(i, d, f, c) : void 0, o === !1 || o === void 0 && d !== f)
      return !1;
  }
  return !0;
};
const Swe = /* @__PURE__ */ qn(Ewe);
function Iwe(t) {
  return /* @__PURE__ */ x.createElement(ko, G({
    size: "small",
    type: "primary"
  }, t));
}
var _we = function(t, e) {
  var n = {};
  for (var r in t)
    Object.prototype.hasOwnProperty.call(t, r) && e.indexOf(r) < 0 && (n[r] = t[r]);
  if (t != null && typeof Object.getOwnPropertySymbols == "function")
    for (var i = 0, r = Object.getOwnPropertySymbols(t); i < r.length; i++)
      e.indexOf(r[i]) < 0 && Object.prototype.propertyIsEnumerable.call(t, r[i]) && (n[r[i]] = t[r[i]]);
  return n;
}, Awe = function(e) {
  var n = e.prefixCls, r = e.className, i = e.checked, o = e.onChange, a = e.onClick, s = _we(e, ["prefixCls", "className", "checked", "onChange", "onClick"]), u = x.useContext(en), l = u.getPrefixCls, c = function(p) {
    o == null || o(!i), a == null || a(p);
  }, d = l("tag", n), f = Ce(d, z(z({}, "".concat(d, "-checkable"), !0), "".concat(d, "-checkable-checked"), i), r);
  return /* @__PURE__ */ x.createElement("span", G({}, s, {
    className: f,
    onClick: c
  }));
};
const Twe = Awe;
var Owe = function(t, e) {
  var n = {};
  for (var r in t)
    Object.prototype.hasOwnProperty.call(t, r) && e.indexOf(r) < 0 && (n[r] = t[r]);
  if (t != null && typeof Object.getOwnPropertySymbols == "function")
    for (var i = 0, r = Object.getOwnPropertySymbols(t); i < r.length; i++)
      e.indexOf(r[i]) < 0 && Object.prototype.propertyIsEnumerable.call(t, r[i]) && (n[r[i]] = t[r[i]]);
  return n;
}, Pwe = new RegExp("^(".concat(IG.join("|"), ")(-inverse)?$")), Nwe = new RegExp("^(".concat(Mye.join("|"), ")$")), kwe = function(e, n) {
  var r = e.prefixCls, i = e.className, o = e.style, a = e.children, s = e.icon, u = e.color, l = e.onClose, c = e.closeIcon, d = e.closable, f = d === void 0 ? !1 : d, h = Owe(e, ["prefixCls", "className", "style", "children", "icon", "color", "onClose", "closeIcon", "closable"]), p = x.useContext(en), v = p.getPrefixCls, m = p.direction, b = x.useState(!0), y = be(b, 2), w = y[0], S = y[1];
  process.env.NODE_ENV !== "production" && process.env.NODE_ENV !== "production" && gn(!("visible" in h), "Tag", "`visible` will be removed in next major version, please use `visible && <Tag />` instead."), x.useEffect(function() {
    "visible" in h && S(h.visible);
  }, [h.visible]);
  var E = function() {
    return u ? Pwe.test(u) || Nwe.test(u) : !1;
  }, I = G({
    backgroundColor: u && !E() ? u : void 0
  }, o), _ = E(), A = v("tag", r), P = Ce(A, z(z(z(z({}, "".concat(A, "-").concat(u), _), "".concat(A, "-has-color"), u && !_), "".concat(A, "-hidden"), !w), "".concat(A, "-rtl"), m === "rtl"), i), N = function(B) {
    B.stopPropagation(), l == null || l(B), !B.defaultPrevented && ("visible" in h || S(!1));
  }, k = function() {
    return f ? c ? /* @__PURE__ */ x.createElement("span", {
      className: "".concat(A, "-close-icon"),
      onClick: N
    }, c) : /* @__PURE__ */ x.createElement(lC, {
      className: "".concat(A, "-close-icon"),
      onClick: N
    }) : null;
  }, D = "onClick" in h || a && a.type === "a", R = Pi(h, ["visible"]), V = s || null, $ = V ? /* @__PURE__ */ x.createElement(x.Fragment, null, V, /* @__PURE__ */ x.createElement("span", null, a)) : a, F = /* @__PURE__ */ x.createElement("span", G({}, R, {
    ref: n,
    className: P,
    style: I
  }), $, k());
  return D ? /* @__PURE__ */ x.createElement(VA, null, F) : F;
}, zA = /* @__PURE__ */ x.forwardRef(kwe);
process.env.NODE_ENV !== "production" && (zA.displayName = "Tag");
zA.CheckableTag = Twe;
const Rwe = zA;
function $we(t) {
  return /* @__PURE__ */ x.createElement(Rwe, G({
    color: "blue"
  }, t));
}
function Dwe(t, e, n) {
  return n !== void 0 ? n : t === "year" && e.lang.yearPlaceholder ? e.lang.yearPlaceholder : t === "quarter" && e.lang.quarterPlaceholder ? e.lang.quarterPlaceholder : t === "month" && e.lang.monthPlaceholder ? e.lang.monthPlaceholder : t === "week" && e.lang.weekPlaceholder ? e.lang.weekPlaceholder : t === "time" && e.timePickerLocale.placeholder ? e.timePickerLocale.placeholder : e.lang.placeholder;
}
function Mwe(t, e, n) {
  return n !== void 0 ? n : t === "year" && e.lang.yearPlaceholder ? e.lang.rangeYearPlaceholder : t === "quarter" && e.lang.quarterPlaceholder ? e.lang.rangeQuarterPlaceholder : t === "month" && e.lang.monthPlaceholder ? e.lang.rangeMonthPlaceholder : t === "week" && e.lang.weekPlaceholder ? e.lang.rangeWeekPlaceholder : t === "time" && e.timePickerLocale.placeholder ? e.timePickerLocale.rangePlaceholder : e.lang.rangePlaceholder;
}
function DU(t, e) {
  var n = {
    adjustX: 1,
    adjustY: 1
  };
  switch (e) {
    case "bottomLeft":
      return {
        points: ["tl", "bl"],
        offset: [0, 4],
        overflow: n
      };
    case "bottomRight":
      return {
        points: ["tr", "br"],
        offset: [0, 4],
        overflow: n
      };
    case "topLeft":
      return {
        points: ["bl", "tl"],
        offset: [0, -4],
        overflow: n
      };
    case "topRight":
      return {
        points: ["br", "tr"],
        offset: [0, -4],
        overflow: n
      };
    default:
      return {
        points: t === "rtl" ? ["tr", "br"] : ["tl", "bl"],
        offset: [0, 4],
        overflow: n
      };
  }
}
var Fwe = function(t, e) {
  var n = {};
  for (var r in t)
    Object.prototype.hasOwnProperty.call(t, r) && e.indexOf(r) < 0 && (n[r] = t[r]);
  if (t != null && typeof Object.getOwnPropertySymbols == "function")
    for (var i = 0, r = Object.getOwnPropertySymbols(t); i < r.length; i++)
      e.indexOf(r[i]) < 0 && Object.prototype.propertyIsEnumerable.call(t, r[i]) && (n[r[i]] = t[r[i]]);
  return n;
};
function Lwe(t) {
  var e = /* @__PURE__ */ gt(function(n, r) {
    var i = n.prefixCls, o = n.getPopupContainer, a = n.className, s = n.placement, u = n.size, l = n.disabled, c = n.bordered, d = c === void 0 ? !0 : c, f = n.placeholder, h = n.popupClassName, p = n.dropdownClassName, v = n.status, m = Fwe(n, ["prefixCls", "getPopupContainer", "className", "placement", "size", "disabled", "bordered", "placeholder", "popupClassName", "dropdownClassName", "status"]), b = x.useRef(null), y = fn(en), w = y.getPrefixCls, S = y.direction, E = y.getPopupContainer, I = w("picker", i), _ = Tc(I, S), A = _.compactSize, P = _.compactItemClassnames, N = n.format, k = n.showTime, D = n.picker, R = w(), V = {};
    V = G(G(G({}, V), k ? Sx(G({
      format: N,
      picker: D
    }, k)) : {}), D === "time" ? Sx(G(G({
      format: N
    }, n), {
      picker: D
    })) : {}), process.env.NODE_ENV !== "production" && gn(!p, "RangePicker", "`dropdownClassName` is deprecated which will be removed in next major version. Please use `popupClassName` instead.");
    var $ = x.useContext(qa), F = A || u || $, M = x.useContext(Ka), B = l ?? M, X = fn(Ji), L = X.hasFeedback, j = X.status, K = X.feedbackIcon, W = /* @__PURE__ */ x.createElement(x.Fragment, null, D === "time" ? /* @__PURE__ */ x.createElement(XW, null) : /* @__PURE__ */ x.createElement(HW, null), L && K);
    return wc(r, function() {
      return {
        focus: function() {
          var U;
          return (U = b.current) === null || U === void 0 ? void 0 : U.focus();
        },
        blur: function() {
          var U;
          return (U = b.current) === null || U === void 0 ? void 0 : U.blur();
        }
      };
    }), /* @__PURE__ */ x.createElement(Ic, {
      componentName: "DatePicker",
      defaultLocale: ux
    }, function(Y) {
      var U = G(G({}, Y), n.locale);
      return /* @__PURE__ */ x.createElement(twe, G({
        separator: /* @__PURE__ */ x.createElement("span", {
          "aria-label": "to",
          className: "".concat(I, "-separator")
        }, /* @__PURE__ */ x.createElement(w0e, null)),
        disabled: B,
        ref: b,
        dropdownAlign: DU(S, s),
        placeholder: Mwe(D, U, f),
        suffixIcon: W,
        clearIcon: /* @__PURE__ */ x.createElement(Sc, null),
        prevIcon: /* @__PURE__ */ x.createElement("span", {
          className: "".concat(I, "-prev-icon")
        }),
        nextIcon: /* @__PURE__ */ x.createElement("span", {
          className: "".concat(I, "-next-icon")
        }),
        superPrevIcon: /* @__PURE__ */ x.createElement("span", {
          className: "".concat(I, "-super-prev-icon")
        }),
        superNextIcon: /* @__PURE__ */ x.createElement("span", {
          className: "".concat(I, "-super-next-icon")
        }),
        allowClear: !0,
        transitionName: "".concat(R, "-slide-up")
      }, m, V, {
        className: Ce(z(z({}, "".concat(I, "-").concat(F), F), "".concat(I, "-borderless"), !d), aa(I, Ac(j, v), L), P, a),
        locale: U.lang,
        prefixCls: I,
        getPopupContainer: o || E,
        generateConfig: t,
        components: MU,
        direction: S,
        dropdownClassName: h || p
      }));
    });
  });
  return e;
}
var Vwe = function(t, e) {
  var n = {};
  for (var r in t)
    Object.prototype.hasOwnProperty.call(t, r) && e.indexOf(r) < 0 && (n[r] = t[r]);
  if (t != null && typeof Object.getOwnPropertySymbols == "function")
    for (var i = 0, r = Object.getOwnPropertySymbols(t); i < r.length; i++)
      e.indexOf(r[i]) < 0 && Object.prototype.propertyIsEnumerable.call(t, r[i]) && (n[r[i]] = t[r[i]]);
  return n;
};
function Bwe(t) {
  function e(u, l) {
    var c = /* @__PURE__ */ gt(function(d, f) {
      var h = d.prefixCls, p = d.getPopupContainer, v = d.className, m = d.size, b = d.bordered, y = b === void 0 ? !0 : b, w = d.placement, S = d.placeholder, E = d.popupClassName, I = d.dropdownClassName, _ = d.disabled, A = d.status, P = Vwe(d, ["prefixCls", "getPopupContainer", "className", "size", "bordered", "placement", "placeholder", "popupClassName", "dropdownClassName", "disabled", "status"]), N = fn(en), k = N.getPrefixCls, D = N.direction, R = N.getPopupContainer, V = k("picker", h), $ = Tc(V, D), F = $.compactSize, M = $.compactItemClassnames, B = x.useRef(null), X = d.format, L = d.showTime;
      wc(f, function() {
        return {
          focus: function() {
            var fe;
            return (fe = B.current) === null || fe === void 0 ? void 0 : fe.focus();
          },
          blur: function() {
            var fe;
            return (fe = B.current) === null || fe === void 0 ? void 0 : fe.blur();
          }
        };
      });
      var j = {
        showToday: !0
      }, K = {};
      u && (K.picker = u);
      var W = u || d.picker;
      K = G(G(G({}, K), L ? Sx(G({
        format: X,
        picker: W
      }, L)) : {}), W === "time" ? Sx(G(G({
        format: X
      }, d), {
        picker: W
      })) : {});
      var Y = k();
      process.env.NODE_ENV !== "production" && gn(u !== "quarter", l, "DatePicker.".concat(l, " is legacy usage. Please use DatePicker[picker='").concat(u, "'] directly.")), process.env.NODE_ENV !== "production" && gn(!I, W === "time" ? "TimePicker" : "DatePicker", "`dropdownClassName` is deprecated which will be removed in next major version. Please use `popupClassName` instead.");
      var U = x.useContext(qa), Q = F || m || U, Z = x.useContext(Ka), ee = _ ?? Z, ie = fn(Ji), oe = ie.hasFeedback, se = ie.status, te = ie.feedbackIcon, ge = /* @__PURE__ */ x.createElement(x.Fragment, null, W === "time" ? /* @__PURE__ */ x.createElement(XW, null) : /* @__PURE__ */ x.createElement(HW, null), oe && te);
      return /* @__PURE__ */ x.createElement(Ic, {
        componentName: "DatePicker",
        defaultLocale: ux
      }, function(he) {
        var fe = G(G({}, he), d.locale);
        return /* @__PURE__ */ x.createElement(ZCe, G({
          ref: B,
          placeholder: Dwe(W, fe, S),
          suffixIcon: ge,
          dropdownAlign: DU(D, w),
          clearIcon: /* @__PURE__ */ x.createElement(Sc, null),
          prevIcon: /* @__PURE__ */ x.createElement("span", {
            className: "".concat(V, "-prev-icon")
          }),
          nextIcon: /* @__PURE__ */ x.createElement("span", {
            className: "".concat(V, "-next-icon")
          }),
          superPrevIcon: /* @__PURE__ */ x.createElement("span", {
            className: "".concat(V, "-super-prev-icon")
          }),
          superNextIcon: /* @__PURE__ */ x.createElement("span", {
            className: "".concat(V, "-super-next-icon")
          }),
          allowClear: !0,
          transitionName: "".concat(Y, "-slide-up")
        }, j, P, K, {
          locale: fe.lang,
          className: Ce(z(z({}, "".concat(V, "-").concat(Q), Q), "".concat(V, "-borderless"), !y), aa(V, Ac(se, A), oe), M, v),
          prefixCls: V,
          getPopupContainer: p || R,
          generateConfig: t,
          components: MU,
          direction: D,
          disabled: ee,
          dropdownClassName: E || I
        }));
      });
    });
    return l && (c.displayName = l), c;
  }
  var n = e(), r = e("week", "WeekPicker"), i = e("month", "MonthPicker"), o = e("year", "YearPicker"), a = e("time", "TimePicker"), s = e("quarter", "QuarterPicker");
  return {
    DatePicker: n,
    WeekPicker: r,
    MonthPicker: i,
    YearPicker: o,
    TimePicker: a,
    QuarterPicker: s
  };
}
var MU = {
  button: Iwe,
  rangeItem: $we
};
function Hwe(t) {
  return t ? Array.isArray(t) ? t : [t] : [];
}
function Sx(t) {
  var e = t.format, n = t.picker, r = t.showHour, i = t.showMinute, o = t.showSecond, a = t.use12Hours, s = Hwe(e)[0], u = G({}, t);
  return s && typeof s == "string" && (!s.includes("s") && o === void 0 && (u.showSecond = !1), !s.includes("m") && i === void 0 && (u.showMinute = !1), !s.includes("H") && !s.includes("h") && r === void 0 && (u.showHour = !1), (s.includes("a") || s.includes("A")) && a === void 0 && (u.use12Hours = !0)), n === "time" ? u : (typeof s == "function" && delete u.format, {
    showTime: u
  });
}
Ki("bottomLeft", "bottomRight", "topLeft", "topRight");
function TC(t) {
  var e = Bwe(t), n = e.DatePicker, r = e.WeekPicker, i = e.MonthPicker, o = e.YearPicker, a = e.TimePicker, s = e.QuarterPicker, u = Lwe(t), l = n;
  return l.WeekPicker = r, l.MonthPicker = i, l.YearPicker = o, l.RangePicker = u, l.TimePicker = a, l.QuarterPicker = s, l;
}
function Ix(t) {
  var e = x.useState(t), n = be(e, 2), r = n[0], i = n[1];
  return x.useEffect(function() {
    var o = setTimeout(function() {
      i(t);
    }, t.length ? 0 : 10);
    return function() {
      clearTimeout(o);
    };
  }, [t]), r;
}
var hR = [];
function ZS(t, e, n) {
  var r = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : 0;
  return {
    key: typeof t == "string" ? t : "".concat(n, "-").concat(r),
    error: t,
    errorStatus: e
  };
}
function FU(t) {
  var e = t.help, n = t.helpStatus, r = t.errors, i = r === void 0 ? hR : r, o = t.warnings, a = o === void 0 ? hR : o, s = t.className, u = t.fieldId, l = t.onVisibleChanged, c = x.useContext(TA), d = c.prefixCls, f = x.useContext(en), h = f.getPrefixCls, p = "".concat(d, "-item-explain"), v = h(), m = Ix(i), b = Ix(a), y = x.useMemo(function() {
    return e != null ? [ZS(e, n, "help")] : [].concat(Ye(m.map(function(S, E) {
      return ZS(S, "error", "error", E);
    })), Ye(b.map(function(S, E) {
      return ZS(S, "warning", "warning", E);
    })));
  }, [e, n, m, b]), w = {};
  return u && (w.id = "".concat(u, "_help")), /* @__PURE__ */ x.createElement(ll, {
    motionDeadline: mx.motionDeadline,
    motionName: "".concat(v, "-show-help"),
    visible: !!y.length,
    onVisibleChanged: l
  }, function(S) {
    var E = S.className, I = S.style;
    return /* @__PURE__ */ x.createElement("div", G({}, w, {
      className: Ce(p, E, s),
      style: I,
      role: "alert"
    }), /* @__PURE__ */ x.createElement(sA, G({
      keys: y
    }, mx, {
      motionName: "".concat(v, "-show-help-item"),
      component: !1
    }), function(_) {
      var A = _.key, P = _.error, N = _.errorStatus, k = _.className, D = _.style;
      return /* @__PURE__ */ x.createElement("div", {
        key: A,
        className: Ce(k, z({}, "".concat(p, "-").concat(N), N)),
        style: D
      }, P);
    }));
  });
}
function pR(t) {
  return typeof t == "object" && t != null && t.nodeType === 1;
}
function gR(t, e) {
  return (!e || t !== "hidden") && t !== "visible" && t !== "clip";
}
function JS(t, e) {
  if (t.clientHeight < t.scrollHeight || t.clientWidth < t.scrollWidth) {
    var n = getComputedStyle(t, null);
    return gR(n.overflowY, e) || gR(n.overflowX, e) || function(r) {
      var i = function(o) {
        if (!o.ownerDocument || !o.ownerDocument.defaultView)
          return null;
        try {
          return o.ownerDocument.defaultView.frameElement;
        } catch {
          return null;
        }
      }(r);
      return !!i && (i.clientHeight < r.scrollHeight || i.clientWidth < r.scrollWidth);
    }(t);
  }
  return !1;
}
function ob(t, e, n, r, i, o, a, s) {
  return o < t && a > e || o > t && a < e ? 0 : o <= t && s <= n || a >= e && s >= n ? o - t - r : a > e && s < n || o < t && s > n ? a - e + i : 0;
}
var mR = function(t, e) {
  var n = window, r = e.scrollMode, i = e.block, o = e.inline, a = e.boundary, s = e.skipOverflowHiddenElements, u = typeof a == "function" ? a : function(he) {
    return he !== a;
  };
  if (!pR(t))
    throw new TypeError("Invalid target");
  for (var l, c, d = document.scrollingElement || document.documentElement, f = [], h = t; pR(h) && u(h); ) {
    if ((h = (c = (l = h).parentElement) == null ? l.getRootNode().host || null : c) === d) {
      f.push(h);
      break;
    }
    h != null && h === document.body && JS(h) && !JS(document.documentElement) || h != null && JS(h, s) && f.push(h);
  }
  for (var p = n.visualViewport ? n.visualViewport.width : innerWidth, v = n.visualViewport ? n.visualViewport.height : innerHeight, m = window.scrollX || pageXOffset, b = window.scrollY || pageYOffset, y = t.getBoundingClientRect(), w = y.height, S = y.width, E = y.top, I = y.right, _ = y.bottom, A = y.left, P = i === "start" || i === "nearest" ? E : i === "end" ? _ : E + w / 2, N = o === "center" ? A + S / 2 : o === "end" ? I : A, k = [], D = 0; D < f.length; D++) {
    var R = f[D], V = R.getBoundingClientRect(), $ = V.height, F = V.width, M = V.top, B = V.right, X = V.bottom, L = V.left;
    if (r === "if-needed" && E >= 0 && A >= 0 && _ <= v && I <= p && E >= M && _ <= X && A >= L && I <= B)
      return k;
    var j = getComputedStyle(R), K = parseInt(j.borderLeftWidth, 10), W = parseInt(j.borderTopWidth, 10), Y = parseInt(j.borderRightWidth, 10), U = parseInt(j.borderBottomWidth, 10), Q = 0, Z = 0, ee = "offsetWidth" in R ? R.offsetWidth - R.clientWidth - K - Y : 0, ie = "offsetHeight" in R ? R.offsetHeight - R.clientHeight - W - U : 0, oe = "offsetWidth" in R ? R.offsetWidth === 0 ? 0 : F / R.offsetWidth : 0, se = "offsetHeight" in R ? R.offsetHeight === 0 ? 0 : $ / R.offsetHeight : 0;
    if (d === R)
      Q = i === "start" ? P : i === "end" ? P - v : i === "nearest" ? ob(b, b + v, v, W, U, b + P, b + P + w, w) : P - v / 2, Z = o === "start" ? N : o === "center" ? N - p / 2 : o === "end" ? N - p : ob(m, m + p, p, K, Y, m + N, m + N + S, S), Q = Math.max(0, Q + b), Z = Math.max(0, Z + m);
    else {
      Q = i === "start" ? P - M - W : i === "end" ? P - X + U + ie : i === "nearest" ? ob(M, X, $, W, U + ie, P, P + w, w) : P - (M + $ / 2) + ie / 2, Z = o === "start" ? N - L - K : o === "center" ? N - (L + F / 2) + ee / 2 : o === "end" ? N - B + Y + ee : ob(L, B, F, K, Y + ee, N, N + S, S);
      var te = R.scrollLeft, ge = R.scrollTop;
      P += ge - (Q = Math.max(0, Math.min(ge + Q / se, R.scrollHeight - $ / se + ie))), N += te - (Z = Math.max(0, Math.min(te + Z / oe, R.scrollWidth - F / oe + ee)));
    }
    k.push({ el: R, top: Q, left: Z });
  }
  return k;
};
function LU(t) {
  return t === Object(t) && Object.keys(t).length !== 0;
}
function Wwe(t, e) {
  e === void 0 && (e = "auto");
  var n = "scrollBehavior" in document.body.style;
  t.forEach(function(r) {
    var i = r.el, o = r.top, a = r.left;
    i.scroll && n ? i.scroll({
      top: o,
      left: a,
      behavior: e
    }) : (i.scrollTop = o, i.scrollLeft = a);
  });
}
function jwe(t) {
  return t === !1 ? {
    block: "end",
    inline: "nearest"
  } : LU(t) ? t : {
    block: "start",
    inline: "nearest"
  };
}
function zwe(t, e) {
  var n = t.isConnected || t.ownerDocument.documentElement.contains(t);
  if (LU(e) && typeof e.behavior == "function")
    return e.behavior(n ? mR(t, e) : []);
  if (n) {
    var r = jwe(e);
    return Wwe(mR(t, r), r.behavior);
  }
}
var Gwe = ["parentNode"], Uwe = "form_item";
function m0(t) {
  return t === void 0 || t === !1 ? [] : Array.isArray(t) ? t : [t];
}
function VU(t, e) {
  if (t.length) {
    var n = t.join("_");
    if (e)
      return "".concat(e, "_").concat(n);
    var r = Gwe.includes(n);
    return r ? "".concat(Uwe, "_").concat(n) : n;
  }
}
function vR(t) {
  var e = m0(t);
  return e.join("_");
}
function BU(t) {
  var e = AA(), n = be(e, 1), r = n[0], i = x.useRef({}), o = x.useMemo(function() {
    return t ?? G(G({}, r), {
      __INTERNAL__: {
        itemRef: function(s) {
          return function(u) {
            var l = vR(s);
            u ? i.current[l] = u : delete i.current[l];
          };
        }
      },
      scrollToField: function(s) {
        var u = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, l = m0(s), c = VU(l, o.__INTERNAL__.name), d = c ? document.getElementById(c) : null;
        d && zwe(d, G({
          scrollMode: "if-needed",
          block: "nearest"
        }, u));
      },
      getFieldInstance: function(s) {
        var u = vR(s);
        return i.current[u];
      }
    });
  }, [t, r]);
  return [o];
}
var Xwe = function(t, e) {
  var n = {};
  for (var r in t)
    Object.prototype.hasOwnProperty.call(t, r) && e.indexOf(r) < 0 && (n[r] = t[r]);
  if (t != null && typeof Object.getOwnPropertySymbols == "function")
    for (var i = 0, r = Object.getOwnPropertySymbols(t); i < r.length; i++)
      e.indexOf(r[i]) < 0 && Object.prototype.propertyIsEnumerable.call(t, r[i]) && (n[r[i]] = t[r[i]]);
  return n;
}, Ywe = function(e, n) {
  var r = x.useContext(qa), i = x.useContext(Ka), o = x.useContext(en), a = o.getPrefixCls, s = o.direction, u = o.form, l = e.prefixCls, c = e.className, d = c === void 0 ? "" : c, f = e.size, h = f === void 0 ? r : f, p = e.disabled, v = p === void 0 ? i : p, m = e.form, b = e.colon, y = e.labelAlign, w = e.labelWrap, S = e.labelCol, E = e.wrapperCol, I = e.hideRequiredMark, _ = e.layout, A = _ === void 0 ? "horizontal" : _, P = e.scrollToFirstError, N = e.requiredMark, k = e.onFinishFailed, D = e.name, R = Xwe(e, ["prefixCls", "className", "size", "disabled", "form", "colon", "labelAlign", "labelWrap", "labelCol", "wrapperCol", "hideRequiredMark", "layout", "scrollToFirstError", "requiredMark", "onFinishFailed", "name"]), V = x.useContext(Hj), $ = Rn(function() {
    return N !== void 0 ? N : u && u.requiredMark !== void 0 ? u.requiredMark : !I;
  }, [I, N, u]), F = b ?? (u == null ? void 0 : u.colon), M = a("form", l), B = Ce(M, z(z(z(z({}, "".concat(M, "-").concat(A), !0), "".concat(M, "-hide-required-mark"), $ === !1), "".concat(M, "-rtl"), s === "rtl"), "".concat(M, "-").concat(h), h), d), X = BU(m), L = be(X, 1), j = L[0], K = j.__INTERNAL__;
  K.name = D;
  var W = Rn(function() {
    return {
      name: D,
      labelAlign: y,
      labelCol: S,
      labelWrap: w,
      wrapperCol: E,
      vertical: A === "vertical",
      colon: F,
      requiredMark: $,
      itemRef: K.itemRef,
      form: j
    };
  }, [D, y, S, E, A, F, $, j]);
  x.useImperativeHandle(n, function() {
    return j;
  });
  var Y = function(Q) {
    k == null || k(Q);
    var Z = {
      block: "nearest"
    };
    P && Q.errorFields.length && (_t(P) === "object" && (Z = P), j.scrollToField(Q.errorFields[0].name, Z));
  };
  return /* @__PURE__ */ x.createElement(Az, {
    disabled: v
  }, /* @__PURE__ */ x.createElement(Tz, {
    size: h
  }, /* @__PURE__ */ x.createElement(yG, G({}, {
    // This is not list in API, we pass with spread
    validateMessages: V
  }), /* @__PURE__ */ x.createElement(cc.Provider, {
    value: W
  }, /* @__PURE__ */ x.createElement(wp, G({
    id: D
  }, R, {
    name: D,
    onFinishFailed: Y,
    form: j,
    className: B
  }))))));
}, Zwe = /* @__PURE__ */ x.forwardRef(Ywe);
const Jwe = Zwe;
var Kwe = function() {
  var e = fn(Ji), n = e.status;
  return process.env.NODE_ENV !== "production" && gn(n !== void 0, "Form.Item", "Form.Item.useStatus should be used under Form.Item component. For more information: ".concat(window.location.protocol, "//").concat(window.location.host, "/components/form-cn/#Form.Item.useStatus")), {
    status: n
  };
};
const qwe = Kwe;
function Qwe(t) {
  var e = x.useState(t), n = be(e, 2), r = n[0], i = n[1], o = Ee(null), a = Ee([]), s = Ee(!1);
  x.useEffect(function() {
    return s.current = !1, function() {
      s.current = !0, En.cancel(o.current), o.current = null;
    };
  }, []);
  function u(l) {
    s.current || (o.current === null && (a.current = [], o.current = En(function() {
      o.current = null, i(function(c) {
        var d = c;
        return a.current.forEach(function(f) {
          d = f(d);
        }), d;
      });
    })), a.current.push(l));
  }
  return [r, u];
}
function eEe() {
  var t = x.useContext(cc), e = t.itemRef, n = x.useRef({});
  function r(i, o) {
    var a = o && _t(o) === "object" && o.ref, s = i.join("_");
    return (n.current.name !== s || n.current.originRef !== a) && (n.current.name = s, n.current.originRef = a, n.current.ref = Ja(e(i), a)), n.current.ref;
  }
  return r;
}
var tEe = function(t, e) {
  var n = {};
  for (var r in t)
    Object.prototype.hasOwnProperty.call(t, r) && e.indexOf(r) < 0 && (n[r] = t[r]);
  if (t != null && typeof Object.getOwnPropertySymbols == "function")
    for (var i = 0, r = Object.getOwnPropertySymbols(t); i < r.length; i++)
      e.indexOf(r[i]) < 0 && Object.prototype.propertyIsEnumerable.call(t, r[i]) && (n[r[i]] = t[r[i]]);
  return n;
};
function nEe(t) {
  return t ? _t(t) === "object" && !/* @__PURE__ */ x.isValidElement(t) ? t : {
    title: t
  } : null;
}
var rEe = function(e) {
  var n = e.prefixCls, r = e.label, i = e.htmlFor, o = e.labelCol, a = e.labelAlign, s = e.colon, u = e.required, l = e.requiredMark, c = e.tooltip, d = vme("Form"), f = be(d, 1), h = f[0];
  return r ? /* @__PURE__ */ x.createElement(cc.Consumer, {
    key: "label"
  }, function(p) {
    var v = p.vertical, m = p.labelAlign, b = p.labelCol, y = p.labelWrap, w = p.colon, S, E = o || b || {}, I = a || m, _ = "".concat(n, "-item-label"), A = Ce(_, I === "left" && "".concat(_, "-left"), E.className, z({}, "".concat(_, "-wrap"), !!y)), P = r, N = s === !0 || w !== !1 && s !== !1, k = N && !v;
    k && typeof r == "string" && r.trim() !== "" && (P = r.replace(/[:|：]\s*$/, ""));
    var D = nEe(c);
    if (D) {
      var R = D.icon, V = R === void 0 ? /* @__PURE__ */ x.createElement(f0e, null) : R, $ = tEe(D, ["icon"]), F = /* @__PURE__ */ x.createElement(Ud, G({}, $), /* @__PURE__ */ x.cloneElement(V, {
        className: "".concat(n, "-item-tooltip"),
        title: ""
      }));
      P = /* @__PURE__ */ x.createElement(x.Fragment, null, P, F);
    }
    l === "optional" && !u && (P = /* @__PURE__ */ x.createElement(x.Fragment, null, P, /* @__PURE__ */ x.createElement("span", {
      className: "".concat(n, "-item-optional"),
      title: ""
    }, (h == null ? void 0 : h.optional) || ((S = fu.Form) === null || S === void 0 ? void 0 : S.optional))));
    var M = Ce(z(z(z({}, "".concat(n, "-item-required"), u), "".concat(n, "-item-required-mark-optional"), l === "optional"), "".concat(n, "-item-no-colon"), !N));
    return /* @__PURE__ */ x.createElement(rc, G({}, E, {
      className: A
    }), /* @__PURE__ */ x.createElement("label", {
      htmlFor: i,
      className: M,
      title: typeof r == "string" ? r : ""
    }, P));
  }) : null;
};
const iEe = rEe;
var oEe = function(e) {
  var n = e.prefixCls, r = e.status, i = e.wrapperCol, o = e.children, a = e.errors, s = e.warnings, u = e._internalItemRender, l = e.extra, c = e.help, d = e.fieldId, f = e.marginBottom, h = e.onErrorVisibleChanged, p = "".concat(n, "-item"), v = x.useContext(cc), m = i || v.wrapperCol || {}, b = Ce("".concat(p, "-control"), m.className), y = x.useMemo(function() {
    return G({}, v);
  }, [v]);
  delete y.labelCol, delete y.wrapperCol;
  var w = /* @__PURE__ */ x.createElement("div", {
    className: "".concat(p, "-control-input")
  }, /* @__PURE__ */ x.createElement("div", {
    className: "".concat(p, "-control-input-content")
  }, o)), S = x.useMemo(function() {
    return {
      prefixCls: n,
      status: r
    };
  }, [n, r]), E = f !== null || a.length || s.length ? /* @__PURE__ */ x.createElement("div", {
    style: {
      display: "flex",
      flexWrap: "nowrap"
    }
  }, /* @__PURE__ */ x.createElement(TA.Provider, {
    value: S
  }, /* @__PURE__ */ x.createElement(FU, {
    fieldId: d,
    errors: a,
    warnings: s,
    help: c,
    helpStatus: r,
    className: "".concat(p, "-explain-connected"),
    onVisibleChanged: h
  })), !!f && /* @__PURE__ */ x.createElement("div", {
    style: {
      width: 0,
      height: f
    }
  })) : null, I = {};
  d && (I.id = "".concat(d, "_extra"));
  var _ = l ? /* @__PURE__ */ x.createElement("div", G({}, I, {
    className: "".concat(p, "-extra")
  }), l) : null, A = u && u.mark === "pro_table_render" && u.render ? u.render(e, {
    input: w,
    errorList: E,
    extra: _
  }) : /* @__PURE__ */ x.createElement(x.Fragment, null, w, E, _);
  return /* @__PURE__ */ x.createElement(cc.Provider, {
    value: y
  }, /* @__PURE__ */ x.createElement(rc, G({}, m, {
    className: b
  }), A));
};
const aEe = oEe;
var sEe = function(t, e) {
  var n = {};
  for (var r in t)
    Object.prototype.hasOwnProperty.call(t, r) && e.indexOf(r) < 0 && (n[r] = t[r]);
  if (t != null && typeof Object.getOwnPropertySymbols == "function")
    for (var i = 0, r = Object.getOwnPropertySymbols(t); i < r.length; i++)
      e.indexOf(r[i]) < 0 && Object.prototype.propertyIsEnumerable.call(t, r[i]) && (n[r[i]] = t[r[i]]);
  return n;
}, uEe = {
  success: tA,
  warning: aj,
  error: Sc,
  validating: lc
};
function lEe(t) {
  var e = t.prefixCls, n = t.className, r = t.style, i = t.help, o = t.errors, a = t.warnings, s = t.validateStatus, u = t.meta, l = t.hasFeedback, c = t.hidden, d = t.children, f = t.fieldId, h = t.isRequired, p = t.onSubItemMetaChange, v = sEe(t, ["prefixCls", "className", "style", "help", "errors", "warnings", "validateStatus", "meta", "hasFeedback", "hidden", "children", "fieldId", "isRequired", "onSubItemMetaChange"]), m = "".concat(e, "-item"), b = x.useContext(cc), y = b.requiredMark, w = x.useRef(null), S = Ix(o), E = Ix(a), I = i != null, _ = !!(I || o.length || a.length), A = x.useState(null), P = be(A, 2), N = P[0], k = P[1];
  To(function() {
    if (_ && w.current) {
      var F = getComputedStyle(w.current);
      k(parseInt(F.marginBottom, 10));
    }
  }, [_]);
  var D = function(M) {
    M || k(null);
  }, R = "";
  s !== void 0 ? R = s : u.validating ? R = "validating" : S.length ? R = "error" : E.length ? R = "warning" : u.touched && (R = "success");
  var V = x.useMemo(function() {
    var F;
    if (l) {
      var M = R && uEe[R];
      F = M ? /* @__PURE__ */ x.createElement("span", {
        className: Ce("".concat(m, "-feedback-icon"), "".concat(m, "-feedback-icon-").concat(R))
      }, /* @__PURE__ */ x.createElement(M, null)) : null;
    }
    return {
      status: R,
      hasFeedback: l,
      feedbackIcon: F,
      isFormItemInput: !0
    };
  }, [R, l]), $ = z(z(z(z(z(z(z(z(z({}, m, !0), "".concat(m, "-with-help"), I || S.length || E.length), "".concat(n), !!n), "".concat(m, "-has-feedback"), R && l), "".concat(m, "-has-success"), R === "success"), "".concat(m, "-has-warning"), R === "warning"), "".concat(m, "-has-error"), R === "error"), "".concat(m, "-is-validating"), R === "validating"), "".concat(m, "-hidden"), c);
  return /* @__PURE__ */ x.createElement("div", {
    className: Ce($),
    style: r,
    ref: w
  }, /* @__PURE__ */ x.createElement(Wm, G({
    className: "".concat(m, "-row")
  }, Pi(v, ["_internalItemRender", "colon", "dependencies", "extra", "fieldKey", "getValueFromEvent", "getValueProps", "htmlFor", "id", "initialValue", "isListField", "label", "labelAlign", "labelCol", "labelWrap", "messageVariables", "name", "normalize", "noStyle", "preserve", "required", "requiredMark", "rules", "shouldUpdate", "trigger", "tooltip", "validateFirst", "validateTrigger", "valuePropName", "wrapperCol"])), /* @__PURE__ */ x.createElement(iEe, G({
    htmlFor: f,
    required: h,
    requiredMark: y
  }, t, {
    prefixCls: e
  })), /* @__PURE__ */ x.createElement(aEe, G({}, t, u, {
    errors: S,
    warnings: E,
    prefixCls: e,
    status: R,
    help: i,
    marginBottom: N,
    onErrorVisibleChanged: D
  }), /* @__PURE__ */ x.createElement(bG.Provider, {
    value: p
  }, /* @__PURE__ */ x.createElement(Ji.Provider, {
    value: V
  }, d)))), !!N && /* @__PURE__ */ x.createElement("div", {
    className: "".concat(m, "-margin-offset"),
    style: {
      marginBottom: -N
    }
  }));
}
var cEe = "__SPLIT__";
Ki("success", "warning", "error", "validating", "");
var dEe = /* @__PURE__ */ x.memo(function(t) {
  var e = t.children;
  return e;
}, function(t, e) {
  return t.value === e.value && t.update === e.update && t.childProps.length === e.childProps.length && t.childProps.every(function(n, r) {
    return n === e.childProps[r];
  });
});
function fEe(t) {
  return t === null && process.env.NODE_ENV !== "production" && gn(!1, "Form.Item", "`null` is passed as `name` property"), t != null;
}
function bR() {
  return {
    errors: [],
    warnings: [],
    touched: !1,
    validating: !1,
    validated: !1,
    name: []
  };
}
function hEe(t) {
  var e = t.name, n = t.noStyle, r = t.dependencies, i = t.prefixCls, o = t.shouldUpdate, a = t.rules, s = t.children, u = t.required, l = t.label, c = t.messageVariables, d = t.trigger, f = d === void 0 ? "onChange" : d, h = t.validateTrigger, p = t.hidden, v = fn(en), m = v.getPrefixCls, b = fn(cc), y = b.name, w = typeof s == "function", S = fn(bG), E = fn(Nd), I = E.validateTrigger, _ = h !== void 0 ? h : I, A = fEe(e), P = m("form", i), N = x.useContext(j0), k = x.useRef(), D = Qwe({}), R = be(D, 2), V = R[0], $ = R[1], F = nc(function() {
    return bR();
  }), M = be(F, 2), B = M[0], X = M[1], L = function(oe) {
    var se = N == null ? void 0 : N.getKey(oe.name);
    if (X(oe.destroy ? bR() : oe, !0), n && S) {
      var te = oe.name;
      if (oe.destroy)
        te = k.current || te;
      else if (se !== void 0) {
        var ge = be(se, 2), he = ge[0], fe = ge[1];
        te = [he].concat(Ye(fe)), k.current = te;
      }
      S(oe, te);
    }
  }, j = function(oe, se) {
    $(function(te) {
      var ge = G({}, te), he = [].concat(Ye(oe.name.slice(0, -1)), Ye(se)), fe = he.join(cEe);
      return oe.destroy ? delete ge[fe] : ge[fe] = oe, ge;
    });
  }, K = x.useMemo(function() {
    var ie = Ye(B.errors), oe = Ye(B.warnings);
    return Object.values(V).forEach(function(se) {
      ie.push.apply(ie, Ye(se.errors || [])), oe.push.apply(oe, Ye(se.warnings || []));
    }), [ie, oe];
  }, [V, B.errors, B.warnings]), W = be(K, 2), Y = W[0], U = W[1], Q = eEe();
  function Z(ie, oe, se) {
    return n && !p ? ie : /* @__PURE__ */ x.createElement(lEe, G({
      key: "row"
    }, t, {
      prefixCls: P,
      fieldId: oe,
      isRequired: se,
      errors: Y,
      warnings: U,
      meta: B,
      onSubItemMetaChange: j
    }), ie);
  }
  if (!A && !w && !r)
    return Z(s);
  var ee = {};
  return typeof l == "string" ? ee.label = l : e && (ee.label = String(e)), c && (ee = G(G({}, ee), c)), /* @__PURE__ */ x.createElement(_A, G({}, t, {
    messageVariables: ee,
    trigger: f,
    validateTrigger: _,
    onMetaChange: L
  }), function(ie, oe, se) {
    var te = m0(e).length && oe ? oe.name : [], ge = VU(te, y), he = u !== void 0 ? u : !!(a && a.some(function(pe) {
      if (pe && _t(pe) === "object" && pe.required && !pe.warningOnly)
        return !0;
      if (typeof pe == "function") {
        var ye = pe(se);
        return ye && ye.required && !ye.warningOnly;
      }
      return !1;
    })), fe = G({}, ie), _e = null;
    if (process.env.NODE_ENV !== "production" && gn(!(o && r), "Form.Item", "`shouldUpdate` and `dependencies` shouldn't be used together. See https://u.ant.design/form-deps."), Array.isArray(s) && A)
      process.env.NODE_ENV !== "production" && gn(!1, "Form.Item", "A `Form.Item` with a `name` prop must have a single child element. For information on how to render more complex form items, see https://u.ant.design/complex-form-item."), _e = s;
    else if (w && (!(o || r) || A))
      process.env.NODE_ENV !== "production" && gn(!!(o || r), "Form.Item", "A `Form.Item` with a render function must have either `shouldUpdate` or `dependencies`."), process.env.NODE_ENV !== "production" && gn(!A, "Form.Item", "A `Form.Item` with a render function cannot be a field, and thus cannot have a `name` prop.");
    else if (r && !w && !A)
      process.env.NODE_ENV !== "production" && gn(!1, "Form.Item", "Must set `name` or use a render function when `dependencies` is set.");
    else if (pa(s)) {
      process.env.NODE_ENV !== "production" && gn(s.props.defaultValue === void 0, "Form.Item", "`defaultValue` will not work on controlled Field. You should use `initialValues` of Form instead.");
      var Ne = G(G({}, s.props), fe);
      if (Ne.id || (Ne.id = ge), t.help || Y.length > 0 || U.length > 0 || t.extra) {
        var ze = [];
        (t.help || Y.length > 0) && ze.push("".concat(ge, "_help")), t.extra && ze.push("".concat(ge, "_extra")), Ne["aria-describedby"] = ze.join(" ");
      }
      Y.length > 0 && (Ne["aria-invalid"] = "true"), he && (Ne["aria-required"] = "true"), Rm(s) && (Ne.ref = Q(te, s));
      var Ve = new Set([].concat(Ye(m0(f)), Ye(m0(_))));
      Ve.forEach(function(pe) {
        Ne[pe] = function() {
          for (var ye, Ae, we, ce, ve, Ie = arguments.length, q = new Array(Ie), Fe = 0; Fe < Ie; Fe++)
            q[Fe] = arguments[Fe];
          (we = fe[pe]) === null || we === void 0 || (ye = we).call.apply(ye, [fe].concat(q)), (ve = (ce = s.props)[pe]) === null || ve === void 0 || (Ae = ve).call.apply(Ae, [ce].concat(q));
        };
      });
      var ne = [Ne["aria-required"], Ne["aria-invalid"], Ne["aria-describedby"]];
      _e = /* @__PURE__ */ x.createElement(dEe, {
        value: fe[t.valuePropName || "value"],
        update: s,
        childProps: ne
      }, ji(s, Ne));
    } else
      w && (o || r) && !A ? _e = s(se) : (process.env.NODE_ENV !== "production" && gn(!te.length, "Form.Item", "`name` is only used for validate React element. If you are using Form.Item as layout display, please remove `name` instead."), _e = s);
    return Z(_e, ge, he);
  });
}
var HU = hEe;
HU.useStatus = qwe;
const pEe = HU;
var gEe = function(t, e) {
  var n = {};
  for (var r in t)
    Object.prototype.hasOwnProperty.call(t, r) && e.indexOf(r) < 0 && (n[r] = t[r]);
  if (t != null && typeof Object.getOwnPropertySymbols == "function")
    for (var i = 0, r = Object.getOwnPropertySymbols(t); i < r.length; i++)
      e.indexOf(r[i]) < 0 && Object.prototype.propertyIsEnumerable.call(t, r[i]) && (n[r[i]] = t[r[i]]);
  return n;
}, mEe = function(e) {
  var n = e.prefixCls, r = e.children, i = gEe(e, ["prefixCls", "children"]);
  process.env.NODE_ENV !== "production" && gn(!!i.name, "Form.List", "Miss `name` prop.");
  var o = x.useContext(en), a = o.getPrefixCls, s = a("form", n), u = x.useMemo(function() {
    return {
      prefixCls: s,
      status: "error"
    };
  }, [s]);
  return /* @__PURE__ */ x.createElement(pG, G({}, i), function(l, c, d) {
    return /* @__PURE__ */ x.createElement(TA.Provider, {
      value: u
    }, r(l.map(function(f) {
      return G(G({}, f), {
        fieldKey: f.key
      });
    }), c, {
      errors: d.errors,
      warnings: d.warnings
    }));
  });
};
const vEe = mEe;
function bEe() {
  var t = fn(cc), e = t.form;
  return e;
}
var cl = Jwe;
cl.Item = pEe;
cl.List = vEe;
cl.ErrorList = FU;
cl.useForm = BU;
cl.useFormInstance = bEe;
cl.useWatch = vG;
cl.Provider = yG;
cl.create = function() {
  process.env.NODE_ENV !== "production" && gn(!1, "Form", "antd v4 removed `Form.create`. Please remove or use `@ant-design/compatible` instead.");
};
const bd = cl;
var yEe = function(e) {
  var n = fn(en), r = n.getPrefixCls, i = n.direction, o = e.prefixCls, a = e.className, s = a === void 0 ? "" : a, u = r("input-group", o), l = Ce(u, z(z(z(z({}, "".concat(u, "-lg"), e.size === "large"), "".concat(u, "-sm"), e.size === "small"), "".concat(u, "-compact"), e.compact), "".concat(u, "-rtl"), i === "rtl"), s), c = fn(Ji), d = Rn(function() {
    return G(G({}, c), {
      isFormItemInput: !1
    });
  }, [c]);
  return /* @__PURE__ */ x.createElement("span", {
    className: l,
    style: e.style,
    onMouseEnter: e.onMouseEnter,
    onMouseLeave: e.onMouseLeave,
    onFocus: e.onFocus,
    onBlur: e.onBlur
  }, /* @__PURE__ */ x.createElement(Ji.Provider, {
    value: d
  }, e.children));
};
const xEe = yEe;
function dy(t) {
  return !!(t.addonBefore || t.addonAfter);
}
function WU(t) {
  return !!(t.prefix || t.suffix || t.allowClear);
}
function yR(t, e, n, r) {
  if (n) {
    var i = e;
    if (e.type === "click") {
      var o = t.cloneNode(!0);
      i = Object.create(e, {
        target: {
          value: o
        },
        currentTarget: {
          value: o
        }
      }), o.value = "", n(i);
      return;
    }
    if (r !== void 0) {
      i = Object.create(e, {
        target: {
          value: t
        },
        currentTarget: {
          value: t
        }
      }), t.value = r, n(i);
      return;
    }
    n(i);
  }
}
function CEe(t, e) {
  if (t) {
    t.focus(e);
    var n = e || {}, r = n.cursor;
    if (r) {
      var i = t.value.length;
      switch (r) {
        case "start":
          t.setSelectionRange(0, 0);
          break;
        case "end":
          t.setSelectionRange(i, i);
          break;
        default:
          t.setSelectionRange(0, i);
      }
    }
  }
}
function xR(t) {
  return typeof t > "u" || t === null ? "" : String(t);
}
var wEe = function(e) {
  var n = e.inputElement, r = e.prefixCls, i = e.prefix, o = e.suffix, a = e.addonBefore, s = e.addonAfter, u = e.className, l = e.style, c = e.affixWrapperClassName, d = e.groupClassName, f = e.wrapperClassName, h = e.disabled, p = e.readOnly, v = e.focused, m = e.triggerFocus, b = e.allowClear, y = e.value, w = e.handleReset, S = e.hidden, E = Ee(null), I = function(B) {
    var X;
    (X = E.current) !== null && X !== void 0 && X.contains(B.target) && (m == null || m());
  }, _ = function() {
    var B;
    if (!b)
      return null;
    var X = !h && !p && y, L = "".concat(r, "-clear-icon"), j = _t(b) === "object" && b !== null && b !== void 0 && b.clearIcon ? b.clearIcon : "✖";
    return /* @__PURE__ */ O.createElement("span", {
      onClick: w,
      onMouseDown: function(W) {
        return W.preventDefault();
      },
      className: Ce(L, (B = {}, z(B, "".concat(L, "-hidden"), !X), z(B, "".concat(L, "-has-suffix"), !!o), B)),
      role: "button",
      tabIndex: -1
    }, j);
  }, A = /* @__PURE__ */ Is(n, {
    value: y,
    hidden: S
  });
  if (WU(e)) {
    var P, N = "".concat(r, "-affix-wrapper"), k = Ce(N, (P = {}, z(P, "".concat(N, "-disabled"), h), z(P, "".concat(N, "-focused"), v), z(P, "".concat(N, "-readonly"), p), z(P, "".concat(N, "-input-with-clear-btn"), o && b && y), P), !dy(e) && u, c), D = (o || b) && /* @__PURE__ */ O.createElement("span", {
      className: "".concat(r, "-suffix")
    }, _(), o);
    A = /* @__PURE__ */ O.createElement("span", {
      className: k,
      style: l,
      hidden: !dy(e) && S,
      onClick: I,
      ref: E
    }, i && /* @__PURE__ */ O.createElement("span", {
      className: "".concat(r, "-prefix")
    }, i), /* @__PURE__ */ Is(n, {
      style: null,
      value: y,
      hidden: null
    }), D);
  }
  if (dy(e)) {
    var R = "".concat(r, "-group"), V = "".concat(R, "-addon"), $ = Ce("".concat(r, "-wrapper"), R, f), F = Ce("".concat(r, "-group-wrapper"), u, d);
    return /* @__PURE__ */ O.createElement("span", {
      className: F,
      style: l,
      hidden: S
    }, /* @__PURE__ */ O.createElement("span", {
      className: $
    }, a && /* @__PURE__ */ O.createElement("span", {
      className: V
    }, a), /* @__PURE__ */ Is(A, {
      style: null,
      hidden: null
    }), s && /* @__PURE__ */ O.createElement("span", {
      className: V
    }, s)));
  }
  return A;
}, EEe = ["autoComplete", "onChange", "onFocus", "onBlur", "onPressEnter", "onKeyDown", "prefixCls", "disabled", "htmlSize", "className", "maxLength", "suffix", "showCount", "type", "inputClassName"], SEe = /* @__PURE__ */ gt(function(t, e) {
  var n = t.autoComplete, r = t.onChange, i = t.onFocus, o = t.onBlur, a = t.onPressEnter, s = t.onKeyDown, u = t.prefixCls, l = u === void 0 ? "rc-input" : u, c = t.disabled, d = t.htmlSize, f = t.className, h = t.maxLength, p = t.suffix, v = t.showCount, m = t.type, b = m === void 0 ? "text" : m, y = t.inputClassName, w = Gt(t, EEe), S = Tr(t.defaultValue, {
    value: t.value
  }), E = be(S, 2), I = E[0], _ = E[1], A = Le(!1), P = be(A, 2), N = P[0], k = P[1], D = Ee(null), R = function(K) {
    D.current && CEe(D.current, K);
  };
  wc(e, function() {
    return {
      focus: R,
      blur: function() {
        var K;
        (K = D.current) === null || K === void 0 || K.blur();
      },
      setSelectionRange: function(K, W, Y) {
        var U;
        (U = D.current) === null || U === void 0 || U.setSelectionRange(K, W, Y);
      },
      select: function() {
        var K;
        (K = D.current) === null || K === void 0 || K.select();
      },
      input: D.current
    };
  }), Re(function() {
    k(function(j) {
      return j && c ? !1 : j;
    });
  }, [c]);
  var V = function(K) {
    t.value === void 0 && _(K.target.value), D.current && yR(D.current, K, r);
  }, $ = function(K) {
    a && K.key === "Enter" && a(K), s == null || s(K);
  }, F = function(K) {
    k(!0), i == null || i(K);
  }, M = function(K) {
    k(!1), o == null || o(K);
  }, B = function(K) {
    _(""), R(), D.current && yR(D.current, K, r);
  }, X = function() {
    var K = Pi(t, [
      "prefixCls",
      "onPressEnter",
      "addonBefore",
      "addonAfter",
      "prefix",
      "suffix",
      "allowClear",
      // Input elements must be either controlled or uncontrolled,
      // specify either the value prop, or the defaultValue prop, but not both.
      "defaultValue",
      "showCount",
      "affixWrapperClassName",
      "groupClassName",
      "inputClassName",
      "wrapperClassName",
      "htmlSize"
    ]);
    return /* @__PURE__ */ O.createElement("input", G({
      autoComplete: n
    }, K, {
      onChange: V,
      onFocus: F,
      onBlur: M,
      onKeyDown: $,
      className: Ce(l, z({}, "".concat(l, "-disabled"), c), y, !dy(t) && !WU(t) && f),
      ref: D,
      size: d,
      type: b
    }));
  }, L = function() {
    var K = Number(h) > 0;
    if (p || v) {
      var W = xR(I), Y = Ye(W).length, U = _t(v) === "object" ? v.formatter({
        value: W,
        count: Y,
        maxLength: h
      }) : "".concat(Y).concat(K ? " / ".concat(h) : "");
      return /* @__PURE__ */ O.createElement(O.Fragment, null, !!v && /* @__PURE__ */ O.createElement("span", {
        className: Ce("".concat(l, "-show-count-suffix"), z({}, "".concat(l, "-show-count-has-suffix"), !!p))
      }, U), p);
    }
    return null;
  };
  return /* @__PURE__ */ O.createElement(wEe, G({}, w, {
    prefixCls: l,
    className: f,
    inputElement: X(),
    handleReset: B,
    value: xR(I),
    focused: N,
    triggerFocus: R,
    suffix: L(),
    disabled: c
  }));
});
function jU(t, e) {
  var n = Ee([]), r = function() {
    n.current.push(setTimeout(function() {
      var o, a, s, u;
      !((o = t.current) === null || o === void 0) && o.input && ((a = t.current) === null || a === void 0 ? void 0 : a.input.getAttribute("type")) === "password" && (!((s = t.current) === null || s === void 0) && s.input.hasAttribute("value")) && ((u = t.current) === null || u === void 0 || u.input.removeAttribute("value"));
    }));
  };
  return Re(function() {
    return e && r(), function() {
      return n.current.forEach(function(i) {
        i && clearTimeout(i);
      });
    };
  }, []), r;
}
function IEe(t) {
  return !!(t.prefix || t.suffix || t.allowClear);
}
var _Ee = function(t, e) {
  var n = {};
  for (var r in t)
    Object.prototype.hasOwnProperty.call(t, r) && e.indexOf(r) < 0 && (n[r] = t[r]);
  if (t != null && typeof Object.getOwnPropertySymbols == "function")
    for (var i = 0, r = Object.getOwnPropertySymbols(t); i < r.length; i++)
      e.indexOf(r[i]) < 0 && Object.prototype.propertyIsEnumerable.call(t, r[i]) && (n[r[i]] = t[r[i]]);
  return n;
};
function AEe(t) {
  return typeof t > "u" || t === null ? "" : String(t);
}
function KS(t, e, n, r) {
  if (n) {
    var i = e;
    if (e.type === "click") {
      var o = t.cloneNode(!0);
      i = Object.create(e, {
        target: {
          value: o
        },
        currentTarget: {
          value: o
        }
      }), o.value = "", n(i);
      return;
    }
    if (r !== void 0) {
      i = Object.create(e, {
        target: {
          value: t
        },
        currentTarget: {
          value: t
        }
      }), t.value = r, n(i);
      return;
    }
    n(i);
  }
}
function TEe(t, e) {
  if (t) {
    t.focus(e);
    var n = e || {}, r = n.cursor;
    if (r) {
      var i = t.value.length;
      switch (r) {
        case "start":
          t.setSelectionRange(0, 0);
          break;
        case "end":
          t.setSelectionRange(i, i);
          break;
        default:
          t.setSelectionRange(0, i);
          break;
      }
    }
  }
}
var OEe = /* @__PURE__ */ gt(function(t, e) {
  var n = t.prefixCls, r = t.bordered, i = r === void 0 ? !0 : r, o = t.status, a = t.size, s = t.disabled, u = t.onBlur, l = t.onFocus, c = t.suffix, d = t.allowClear, f = t.addonAfter, h = t.addonBefore, p = t.className, v = t.onChange, m = _Ee(t, ["prefixCls", "bordered", "status", "size", "disabled", "onBlur", "onFocus", "suffix", "allowClear", "addonAfter", "addonBefore", "className", "onChange"]), b = O.useContext(en), y = b.getPrefixCls, w = b.direction, S = b.input, E = y("input", n), I = Ee(null), _ = Tc(E, w), A = _.compactSize, P = _.compactItemClassnames, N = O.useContext(qa), k = A || a || N, D = O.useContext(Ka), R = s ?? D, V = fn(Ji), $ = V.status, F = V.hasFeedback, M = V.feedbackIcon, B = Ac($, o), X = IEe(t) || !!F, L = Ee(X);
  Re(function() {
    var Z;
    X && !L.current && process.env.NODE_ENV !== "production" && gn(document.activeElement === ((Z = I.current) === null || Z === void 0 ? void 0 : Z.input), "Input", "When Input is focused, dynamic add or remove prefix / suffix will make it lose focus caused by dom structure change. Read more: https://ant.design/components/input/#FAQ"), L.current = X;
  }, [X]);
  var j = jU(I, !0), K = function(ee) {
    j(), u == null || u(ee);
  }, W = function(ee) {
    j(), l == null || l(ee);
  }, Y = function(ee) {
    j(), v == null || v(ee);
  }, U = (F || c) && /* @__PURE__ */ O.createElement(O.Fragment, null, c, F && M), Q;
  return _t(d) === "object" && (d != null && d.clearIcon) ? Q = d : d && (Q = {
    clearIcon: /* @__PURE__ */ O.createElement(Sc, null)
  }), /* @__PURE__ */ O.createElement(SEe, G({
    ref: Ja(e, I),
    prefixCls: E,
    autoComplete: S == null ? void 0 : S.autoComplete
  }, m, {
    disabled: R || void 0,
    onBlur: K,
    onFocus: W,
    suffix: U,
    allowClear: Q,
    className: Ce(p, P),
    onChange: Y,
    addonAfter: f && /* @__PURE__ */ O.createElement(G0, null, /* @__PURE__ */ O.createElement(gx, {
      override: !0,
      status: !0
    }, f)),
    addonBefore: h && /* @__PURE__ */ O.createElement(G0, null, /* @__PURE__ */ O.createElement(gx, {
      override: !0,
      status: !0
    }, h)),
    inputClassName: Ce(z(z(z(z({}, "".concat(E, "-sm"), k === "small"), "".concat(E, "-lg"), k === "large"), "".concat(E, "-rtl"), w === "rtl"), "".concat(E, "-borderless"), !i), !X && aa(E, B)),
    affixWrapperClassName: Ce(z(z(z(z({}, "".concat(E, "-affix-wrapper-sm"), k === "small"), "".concat(E, "-affix-wrapper-lg"), k === "large"), "".concat(E, "-affix-wrapper-rtl"), w === "rtl"), "".concat(E, "-affix-wrapper-borderless"), !i), aa("".concat(E, "-affix-wrapper"), B, F)),
    wrapperClassName: Ce(z({}, "".concat(E, "-group-rtl"), w === "rtl")),
    groupClassName: Ce(z(z(z({}, "".concat(E, "-group-wrapper-sm"), k === "small"), "".concat(E, "-group-wrapper-lg"), k === "large"), "".concat(E, "-group-wrapper-rtl"), w === "rtl"), aa("".concat(E, "-group-wrapper"), B, F))
  }));
});
const GA = OEe;
var PEe = function(t, e) {
  var n = {};
  for (var r in t)
    Object.prototype.hasOwnProperty.call(t, r) && e.indexOf(r) < 0 && (n[r] = t[r]);
  if (t != null && typeof Object.getOwnPropertySymbols == "function")
    for (var i = 0, r = Object.getOwnPropertySymbols(t); i < r.length; i++)
      e.indexOf(r[i]) < 0 && Object.prototype.propertyIsEnumerable.call(t, r[i]) && (n[r[i]] = t[r[i]]);
  return n;
}, NEe = function(e) {
  return e ? /* @__PURE__ */ x.createElement(cj, null) : /* @__PURE__ */ x.createElement(Bge, null);
}, kEe = {
  click: "onClick",
  hover: "onMouseOver"
}, zU = /* @__PURE__ */ x.forwardRef(function(t, e) {
  var n = t.visibilityToggle, r = n === void 0 ? !0 : n, i = _t(r) === "object" && r.visible !== void 0, o = Le(function() {
    return i ? r.visible : !1;
  }), a = be(o, 2), s = a[0], u = a[1], l = Ee(null);
  x.useEffect(function() {
    i && u(r.visible);
  }, [i, r]);
  var c = jU(l), d = function() {
    var v = t.disabled;
    v || (s && c(), u(function(m) {
      var b, y = !m;
      return _t(r) === "object" && ((b = r.onVisibleChange) === null || b === void 0 || b.call(r, y)), y;
    }));
  }, f = function(v) {
    var m = t.action, b = m === void 0 ? "click" : m, y = t.iconRender, w = y === void 0 ? NEe : y, S = kEe[b] || "", E = w(s), I = z(z(z(z(z({}, S, d), "className", "".concat(v, "-icon")), "key", "passwordIcon"), "onMouseDown", function(A) {
      A.preventDefault();
    }), "onMouseUp", function(A) {
      A.preventDefault();
    });
    return /* @__PURE__ */ x.cloneElement(/* @__PURE__ */ x.isValidElement(E) ? E : /* @__PURE__ */ x.createElement("span", null, E), I);
  }, h = function(v) {
    var m = v.getPrefixCls, b = t.className, y = t.prefixCls, w = t.inputPrefixCls, S = t.size, E = PEe(t, ["className", "prefixCls", "inputPrefixCls", "size"]), I = m("input", w), _ = m("input-password", y), A = r && f(_), P = Ce(_, b, z({}, "".concat(_, "-").concat(S), !!S)), N = G(G({}, Pi(E, ["suffix", "iconRender", "visibilityToggle"])), {
      type: s ? "text" : "password",
      className: P,
      prefixCls: I,
      suffix: A
    });
    return S && (N.size = S), /* @__PURE__ */ x.createElement(GA, G({
      ref: Ja(e, l)
    }, N));
  };
  return /* @__PURE__ */ x.createElement(_c, null, h);
});
process.env.NODE_ENV !== "production" && (zU.displayName = "Password");
const REe = zU;
var $Ee = function(t, e) {
  var n = {};
  for (var r in t)
    Object.prototype.hasOwnProperty.call(t, r) && e.indexOf(r) < 0 && (n[r] = t[r]);
  if (t != null && typeof Object.getOwnPropertySymbols == "function")
    for (var i = 0, r = Object.getOwnPropertySymbols(t); i < r.length; i++)
      e.indexOf(r[i]) < 0 && Object.prototype.propertyIsEnumerable.call(t, r[i]) && (n[r[i]] = t[r[i]]);
  return n;
}, GU = /* @__PURE__ */ x.forwardRef(function(t, e) {
  var n = t.prefixCls, r = t.inputPrefixCls, i = t.className, o = t.size, a = t.suffix, s = t.enterButton, u = s === void 0 ? !1 : s, l = t.addonAfter, c = t.loading, d = t.disabled, f = t.onSearch, h = t.onChange, p = t.onCompositionStart, v = t.onCompositionEnd, m = $Ee(t, ["prefixCls", "inputPrefixCls", "className", "size", "suffix", "enterButton", "addonAfter", "loading", "disabled", "onSearch", "onChange", "onCompositionStart", "onCompositionEnd"]), b = x.useContext(en), y = b.getPrefixCls, w = b.direction, S = x.useContext(qa), E = x.useRef(!1), I = y("input-search", n), _ = y("input", r), A = Tc(I, w), P = A.compactSize, N = P || o || S, k = x.useRef(null), D = function(U) {
    U && U.target && U.type === "click" && f && f(U.target.value, U), h && h(U);
  }, R = function(U) {
    var Q;
    document.activeElement === ((Q = k.current) === null || Q === void 0 ? void 0 : Q.input) && U.preventDefault();
  }, V = function(U) {
    var Q, Z;
    f && f((Z = (Q = k.current) === null || Q === void 0 ? void 0 : Q.input) === null || Z === void 0 ? void 0 : Z.value, U);
  }, $ = function(U) {
    E.current || c || V(U);
  }, F = typeof u == "boolean" ? /* @__PURE__ */ x.createElement(rA, null) : null, M = "".concat(I, "-button"), B, X = u || {}, L = X.type && X.type.__ANT_BUTTON === !0;
  L || X.type === "button" ? B = ji(X, G({
    onMouseDown: R,
    onClick: function(U) {
      var Q, Z;
      (Z = (Q = X == null ? void 0 : X.props) === null || Q === void 0 ? void 0 : Q.onClick) === null || Z === void 0 || Z.call(Q, U), V(U);
    },
    key: "enterButton"
  }, L ? {
    className: M,
    size: N
  } : {})) : B = /* @__PURE__ */ x.createElement(ko, {
    className: M,
    type: u ? "primary" : void 0,
    size: N,
    disabled: d,
    key: "enterButton",
    onMouseDown: R,
    onClick: V,
    loading: c,
    icon: F
  }, u), l && (B = [B, ji(l, {
    key: "addonAfter"
  })]);
  var j = Ce(I, z(z(z({}, "".concat(I, "-rtl"), w === "rtl"), "".concat(I, "-").concat(N), !!N), "".concat(I, "-with-button"), !!u), i), K = function(U) {
    E.current = !0, p == null || p(U);
  }, W = function(U) {
    E.current = !1, v == null || v(U);
  };
  return /* @__PURE__ */ x.createElement(GA, G({
    ref: Ja(k, e),
    onPressEnter: $
  }, m, {
    size: N,
    onCompositionStart: K,
    onCompositionEnd: W,
    prefixCls: _,
    addonAfter: B,
    suffix: a,
    onChange: D,
    className: j,
    disabled: d
  }));
});
process.env.NODE_ENV !== "production" && (GU.displayName = "Search");
const DEe = GU;
var MEe = `
  min-height:0 !important;
  max-height:none !important;
  height:0 !important;
  visibility:hidden !important;
  overflow:hidden !important;
  position:absolute !important;
  z-index:-1000 !important;
  top:0 !important;
  right:0 !important;
  pointer-events: none !important;
`, FEe = ["letter-spacing", "line-height", "padding-top", "padding-bottom", "font-family", "font-weight", "font-size", "font-variant", "text-rendering", "text-transform", "width", "text-indent", "padding-left", "padding-right", "border-width", "box-sizing", "word-break"], qS = {}, $a;
function LEe(t) {
  var e = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : !1, n = t.getAttribute("id") || t.getAttribute("data-reactid") || t.getAttribute("name");
  if (e && qS[n])
    return qS[n];
  var r = window.getComputedStyle(t), i = r.getPropertyValue("box-sizing") || r.getPropertyValue("-moz-box-sizing") || r.getPropertyValue("-webkit-box-sizing"), o = parseFloat(r.getPropertyValue("padding-bottom")) + parseFloat(r.getPropertyValue("padding-top")), a = parseFloat(r.getPropertyValue("border-bottom-width")) + parseFloat(r.getPropertyValue("border-top-width")), s = FEe.map(function(l) {
    return "".concat(l, ":").concat(r.getPropertyValue(l));
  }).join(";"), u = {
    sizingStyle: s,
    paddingSize: o,
    borderSize: a,
    boxSizing: i
  };
  return e && n && (qS[n] = u), u;
}
function VEe(t) {
  var e = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : !1, n = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : null, r = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : null;
  $a || ($a = document.createElement("textarea"), $a.setAttribute("tab-index", "-1"), $a.setAttribute("aria-hidden", "true"), document.body.appendChild($a)), t.getAttribute("wrap") ? $a.setAttribute("wrap", t.getAttribute("wrap")) : $a.removeAttribute("wrap");
  var i = LEe(t, e), o = i.paddingSize, a = i.borderSize, s = i.boxSizing, u = i.sizingStyle;
  $a.setAttribute("style", "".concat(u, ";").concat(MEe)), $a.value = t.value || t.placeholder || "";
  var l = void 0, c = void 0, d, f = $a.scrollHeight;
  if (s === "border-box" ? f += a : s === "content-box" && (f -= o), n !== null || r !== null) {
    $a.value = " ";
    var h = $a.scrollHeight - o;
    n !== null && (l = h * n, s === "border-box" && (l = l + o + a), f = Math.max(l, f)), r !== null && (c = h * r, s === "border-box" && (c = c + o + a), d = f > c ? "" : "hidden", f = Math.min(c, f));
  }
  var p = {
    height: f,
    overflowY: d,
    resize: "none"
  };
  return l && (p.minHeight = l), c && (p.maxHeight = c), p;
}
var BEe = ["prefixCls", "onPressEnter", "defaultValue", "value", "autoSize", "onResize", "className", "style", "disabled", "onChange", "onInternalAutoSize"], QS = 0, e3 = 1, t3 = 2, HEe = /* @__PURE__ */ x.forwardRef(function(t, e) {
  var n = t.prefixCls, r = n === void 0 ? "rc-textarea" : n;
  t.onPressEnter;
  var i = t.defaultValue, o = t.value, a = t.autoSize, s = t.onResize, u = t.className, l = t.style, c = t.disabled, d = t.onChange, f = t.onInternalAutoSize, h = Gt(t, BEe), p = Tr(i, {
    value: o,
    postState: function(U) {
      return U ?? "";
    }
  }), v = be(p, 2), m = v[0], b = v[1], y = function(U) {
    b(U.target.value), d == null || d(U);
  }, w = x.useRef();
  x.useImperativeHandle(e, function() {
    return {
      textArea: w.current
    };
  });
  var S = x.useMemo(function() {
    return a && _t(a) === "object" ? [a.minRows, a.maxRows] : [];
  }, [a]), E = be(S, 2), I = E[0], _ = E[1], A = !!a, P = function() {
    try {
      if (document.activeElement === w.current) {
        var U = w.current, Q = U.selectionStart, Z = U.selectionEnd, ee = U.scrollTop;
        w.current.setSelectionRange(Q, Z), w.current.scrollTop = ee;
      }
    } catch {
    }
  }, N = x.useState(t3), k = be(N, 2), D = k[0], R = k[1], V = x.useState(), $ = be(V, 2), F = $[0], M = $[1], B = function() {
    R(QS), process.env.NODE_ENV === "test" && (f == null || f());
  };
  To(function() {
    A && B();
  }, [o, I, _, A]), To(function() {
    if (D === QS)
      R(e3);
    else if (D === e3) {
      var Y = VEe(w.current, !1, I, _);
      R(t3), M(Y);
    } else
      P();
  }, [D]);
  var X = x.useRef(), L = function() {
    En.cancel(X.current);
  }, j = function(U) {
    D === t3 && (s == null || s(U), a && (L(), X.current = En(function() {
      B();
    })));
  };
  x.useEffect(function() {
    return L;
  }, []);
  var K = A ? F : null, W = de(de({}, l), K);
  return (D === QS || D === e3) && (W.overflowY = "hidden", W.overflowX = "hidden"), /* @__PURE__ */ x.createElement(Gd, {
    onResize: j,
    disabled: !(a || s)
  }, /* @__PURE__ */ x.createElement("textarea", G({}, h, {
    ref: w,
    style: W,
    className: Ce(r, u, z({}, "".concat(r, "-disabled"), c)),
    disabled: c,
    value: m,
    onChange: y
  })));
}), WEe = /* @__PURE__ */ function(t) {
  Pr(n, t);
  var e = Hr(n);
  function n(r) {
    var i;
    zn(this, n), i = e.call(this, r), i.resizableTextArea = void 0, i.focus = function() {
      i.resizableTextArea.textArea.focus();
    }, i.saveTextArea = function(a) {
      i.resizableTextArea = a;
    }, i.handleChange = function(a) {
      var s = i.props.onChange;
      i.setValue(a.target.value), s && s(a);
    }, i.handleKeyDown = function(a) {
      var s = i.props, u = s.onPressEnter, l = s.onKeyDown;
      a.keyCode === 13 && u && u(a), l && l(a);
    };
    var o = typeof r.value > "u" || r.value === null ? r.defaultValue : r.value;
    return i.state = {
      value: o
    }, i;
  }
  return Gn(n, [{
    key: "setValue",
    value: function(i, o) {
      "value" in this.props || this.setState({
        value: i
      }, o);
    }
  }, {
    key: "blur",
    value: function() {
      this.resizableTextArea.textArea.blur();
    }
  }, {
    key: "render",
    value: function() {
      return /* @__PURE__ */ x.createElement(HEe, G({}, this.props, {
        value: this.state.value,
        onKeyDown: this.handleKeyDown,
        onChange: this.handleChange,
        ref: this.saveTextArea
      }));
    }
  }], [{
    key: "getDerivedStateFromProps",
    value: function(i) {
      return "value" in i ? {
        value: i.value
      } : null;
    }
  }]), n;
}(x.Component), jEe = Ki("text", "input");
function zEe(t) {
  return !!(t.addonBefore || t.addonAfter);
}
var GEe = /* @__PURE__ */ function(t) {
  Pr(n, t);
  var e = Hr(n);
  function n() {
    return zn(this, n), e.apply(this, arguments);
  }
  return Gn(n, [{
    key: "renderClearIcon",
    value: function(i) {
      var o = this.props, a = o.value, s = o.disabled, u = o.readOnly, l = o.handleReset, c = o.suffix, d = !s && !u && a, f = "".concat(i, "-clear-icon");
      return /* @__PURE__ */ x.createElement(Sc, {
        onClick: l,
        // Do not trigger onBlur when clear input
        // https://github.com/ant-design/ant-design/issues/31200
        onMouseDown: function(p) {
          return p.preventDefault();
        },
        className: Ce(z(z({}, "".concat(f, "-hidden"), !d), "".concat(f, "-has-suffix"), !!c), f),
        role: "button"
      });
    }
  }, {
    key: "renderTextAreaWithClearIcon",
    value: function(i, o, a) {
      var s = this.props, u = s.value, l = s.allowClear, c = s.className, d = s.focused, f = s.style, h = s.direction, p = s.bordered, v = s.hidden, m = s.status, b = a.status, y = a.hasFeedback;
      if (!l)
        return ji(o, {
          value: u
        });
      var w = Ce("".concat(i, "-affix-wrapper"), "".concat(i, "-affix-wrapper-textarea-with-clear-btn"), aa("".concat(i, "-affix-wrapper"), Ac(b, m), y), z(z(z(z({}, "".concat(i, "-affix-wrapper-focused"), d), "".concat(i, "-affix-wrapper-rtl"), h === "rtl"), "".concat(i, "-affix-wrapper-borderless"), !p), "".concat(c), !zEe(this.props) && c));
      return /* @__PURE__ */ x.createElement("span", {
        className: w,
        style: f,
        hidden: v
      }, ji(o, {
        style: null,
        value: u
      }), this.renderClearIcon(i));
    }
  }, {
    key: "render",
    value: function() {
      var i = this;
      return /* @__PURE__ */ x.createElement(Ji.Consumer, null, function(o) {
        var a = i.props, s = a.prefixCls, u = a.inputType, l = a.element;
        if (u === jEe[0])
          return i.renderTextAreaWithClearIcon(s, l, o);
      });
    }
  }]), n;
}(x.Component);
const UEe = GEe;
var XEe = function(t, e) {
  var n = {};
  for (var r in t)
    Object.prototype.hasOwnProperty.call(t, r) && e.indexOf(r) < 0 && (n[r] = t[r]);
  if (t != null && typeof Object.getOwnPropertySymbols == "function")
    for (var i = 0, r = Object.getOwnPropertySymbols(t); i < r.length; i++)
      e.indexOf(r[i]) < 0 && Object.prototype.propertyIsEnumerable.call(t, r[i]) && (n[r[i]] = t[r[i]]);
  return n;
};
function UU(t, e) {
  return Ye(t || "").slice(0, e).join("");
}
function CR(t, e, n, r) {
  var i = n;
  return t ? i = UU(n, r) : Ye(e || "").length < n.length && Ye(n || "").length > r && (i = e), i;
}
var YEe = /* @__PURE__ */ x.forwardRef(function(t, e) {
  var n = t.prefixCls, r = t.bordered, i = r === void 0 ? !0 : r, o = t.showCount, a = o === void 0 ? !1 : o, s = t.maxLength, u = t.className, l = t.style, c = t.size, d = t.disabled, f = t.onCompositionStart, h = t.onCompositionEnd, p = t.onChange, v = t.onFocus, m = t.onBlur, b = t.status, y = XEe(t, ["prefixCls", "bordered", "showCount", "maxLength", "className", "style", "size", "disabled", "onCompositionStart", "onCompositionEnd", "onChange", "onFocus", "onBlur", "status"]), w = x.useContext(en), S = w.getPrefixCls, E = w.direction, I = x.useContext(qa), _ = x.useContext(Ka), A = d ?? _, P = x.useContext(Ji), N = P.status, k = P.hasFeedback, D = P.isFormItemInput, R = P.feedbackIcon, V = Ac(N, b), $ = x.useRef(null), F = x.useRef(null), M = x.useState(!1), B = be(M, 2), X = B[0], L = B[1], j = x.useState(!1), K = be(j, 2), W = K[0], Y = K[1], U = x.useRef(), Q = x.useRef(0), Z = Tr(y.defaultValue, {
    value: y.value
  }), ee = be(Z, 2), ie = ee[0], oe = ee[1], se = y.hidden, te = function(Ie, q) {
    y.value === void 0 && (oe(Ie), q == null || q());
  }, ge = Number(s) > 0, he = function(Ie) {
    L(!0), U.current = ie, Q.current = Ie.currentTarget.selectionStart, f == null || f(Ie);
  }, fe = function(Ie) {
    var q;
    L(!1);
    var Fe = Ie.currentTarget.value;
    if (ge) {
      var Ze = Q.current >= s + 1 || Q.current === ((q = U.current) === null || q === void 0 ? void 0 : q.length);
      Fe = CR(Ze, U.current, Fe, s);
    }
    Fe !== ie && (te(Fe), KS(Ie.currentTarget, Ie, p, Fe)), h == null || h(Ie);
  }, _e = function(Ie) {
    var q = Ie.target.value;
    if (!X && ge) {
      var Fe = Ie.target.selectionStart >= s + 1 || Ie.target.selectionStart === q.length || !Ie.target.selectionStart;
      q = CR(Fe, ie, q, s);
    }
    te(q), KS(Ie.currentTarget, Ie, p, q);
  }, Ne = function(Ie) {
    Y(!1), m == null || m(Ie);
  }, ze = function(Ie) {
    Y(!0), v == null || v(Ie);
  };
  x.useEffect(function() {
    Y(function(ve) {
      return !A && ve;
    });
  }, [A]);
  var Ve = function(Ie) {
    var q, Fe, Ze;
    te(""), (q = $.current) === null || q === void 0 || q.focus(), KS((Ze = (Fe = $.current) === null || Fe === void 0 ? void 0 : Fe.resizableTextArea) === null || Ze === void 0 ? void 0 : Ze.textArea, Ie, p);
  }, ne = S("input", n);
  x.useImperativeHandle(e, function() {
    var ve;
    return {
      resizableTextArea: (ve = $.current) === null || ve === void 0 ? void 0 : ve.resizableTextArea,
      focus: function(q) {
        var Fe, Ze;
        TEe((Ze = (Fe = $.current) === null || Fe === void 0 ? void 0 : Fe.resizableTextArea) === null || Ze === void 0 ? void 0 : Ze.textArea, q);
      },
      blur: function() {
        var q;
        return (q = $.current) === null || q === void 0 ? void 0 : q.blur();
      }
    };
  });
  var pe = /* @__PURE__ */ x.createElement(WEe, G({}, Pi(y, ["allowClear"]), {
    disabled: A,
    className: Ce(z(z(z(z({}, "".concat(ne, "-borderless"), !i), u, u && !a), "".concat(ne, "-sm"), I === "small" || c === "small"), "".concat(ne, "-lg"), I === "large" || c === "large"), aa(ne, V)),
    style: a ? {
      resize: l == null ? void 0 : l.resize
    } : l,
    prefixCls: ne,
    onCompositionStart: he,
    onChange: _e,
    onBlur: Ne,
    onFocus: ze,
    onCompositionEnd: fe,
    ref: $
  })), ye = AEe(ie);
  !X && ge && (y.value === null || y.value === void 0) && (ye = UU(ye, s));
  var Ae = /* @__PURE__ */ x.createElement(UEe, G({
    disabled: A,
    focused: W
  }, y, {
    prefixCls: ne,
    direction: E,
    inputType: "text",
    value: ye,
    element: pe,
    handleReset: Ve,
    ref: F,
    bordered: i,
    status: b,
    style: a ? void 0 : l
  }));
  if (a || k) {
    var we = Ye(ye).length, ce = "";
    return _t(a) === "object" ? ce = a.formatter({
      value: ye,
      count: we,
      maxLength: s
    }) : ce = "".concat(we).concat(ge ? " / ".concat(s) : ""), /* @__PURE__ */ x.createElement("div", {
      hidden: se,
      className: Ce("".concat(ne, "-textarea"), z(z(z({}, "".concat(ne, "-textarea-rtl"), E === "rtl"), "".concat(ne, "-textarea-show-count"), a), "".concat(ne, "-textarea-in-form-item"), D), aa("".concat(ne, "-textarea"), V, k), u),
      style: l,
      "data-count": ce
    }, Ae, k && /* @__PURE__ */ x.createElement("span", {
      className: "".concat(ne, "-textarea-suffix")
    }, R));
  }
  return Ae;
});
const ZEe = YEe;
var jm = GA;
jm.Group = xEe;
jm.Search = DEe;
jm.TextArea = ZEe;
jm.Password = REe;
const ma = jm;
function f_() {
  return typeof BigInt == "function";
}
function yd(t) {
  var e = t.trim(), n = e.startsWith("-");
  n && (e = e.slice(1)), e = e.replace(/(\.\d*[^0])0*$/, "$1").replace(/\.0*$/, "").replace(/^0+/, ""), e.startsWith(".") && (e = "0".concat(e));
  var r = e || "0", i = r.split("."), o = i[0] || "0", a = i[1] || "0";
  o === "0" && a === "0" && (n = !1);
  var s = n ? "-" : "";
  return {
    negative: n,
    negativeStr: s,
    trimStr: r,
    integerStr: o,
    decimalStr: a,
    fullStr: "".concat(s).concat(r)
  };
}
function UA(t) {
  var e = String(t);
  return !Number.isNaN(Number(e)) && e.includes("e");
}
function Z0(t) {
  var e = String(t);
  if (UA(t)) {
    var n = Number(e.slice(e.indexOf("e-") + 2)), r = e.match(/\.(\d+)/);
    return r != null && r[1] && (n += r[1].length), n;
  }
  return e.includes(".") && XA(e) ? e.length - e.indexOf(".") - 1 : 0;
}
function OC(t) {
  var e = String(t);
  if (UA(t)) {
    if (t > Number.MAX_SAFE_INTEGER)
      return String(f_() ? BigInt(t).toString() : Number.MAX_SAFE_INTEGER);
    if (t < Number.MIN_SAFE_INTEGER)
      return String(f_() ? BigInt(t).toString() : Number.MIN_SAFE_INTEGER);
    e = t.toFixed(Z0(e));
  }
  return yd(e).fullStr;
}
function XA(t) {
  return typeof t == "number" ? !Number.isNaN(t) : t ? (
    // Normal type: 11.28
    /^\s*-?\d+(\.\d+)?\s*$/.test(t) || // Pre-number: 1.
    /^\s*-?\d+\.\s*$/.test(t) || // Post-number: .1
    /^\s*-?\.\d+\s*$/.test(t)
  ) : !1;
}
function wR(t) {
  var e = typeof t == "number" ? OC(t) : yd(t).fullStr, n = e.includes(".");
  return n ? yd(e.replace(/(\d)\.(\d)/g, "$1$2.")).fullStr : t + "0";
}
var JEe = /* @__PURE__ */ function() {
  function t(e) {
    if (zn(this, t), this.origin = "", this.number = void 0, this.empty = void 0, !e && e !== 0 || !String(e).trim()) {
      this.empty = !0;
      return;
    }
    this.origin = String(e), this.number = Number(e);
  }
  return Gn(t, [{
    key: "negate",
    value: function() {
      return new t(-this.toNumber());
    }
  }, {
    key: "add",
    value: function(n) {
      if (this.isInvalidate())
        return new t(n);
      var r = Number(n);
      if (Number.isNaN(r))
        return this;
      var i = this.number + r;
      if (i > Number.MAX_SAFE_INTEGER)
        return new t(Number.MAX_SAFE_INTEGER);
      if (i < Number.MIN_SAFE_INTEGER)
        return new t(Number.MIN_SAFE_INTEGER);
      var o = Math.max(Z0(this.number), Z0(r));
      return new t(i.toFixed(o));
    }
  }, {
    key: "isEmpty",
    value: function() {
      return this.empty;
    }
  }, {
    key: "isNaN",
    value: function() {
      return Number.isNaN(this.number);
    }
  }, {
    key: "isInvalidate",
    value: function() {
      return this.isEmpty() || this.isNaN();
    }
  }, {
    key: "equals",
    value: function(n) {
      return this.toNumber() === (n == null ? void 0 : n.toNumber());
    }
  }, {
    key: "lessEquals",
    value: function(n) {
      return this.add(n.negate().toString()).toNumber() <= 0;
    }
  }, {
    key: "toNumber",
    value: function() {
      return this.number;
    }
  }, {
    key: "toString",
    value: function() {
      var n = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : !0;
      return n ? this.isInvalidate() ? "" : OC(this.number) : this.origin;
    }
  }]), t;
}(), KEe = /* @__PURE__ */ function() {
  function t(e) {
    if (zn(this, t), this.origin = "", this.negative = void 0, this.integer = void 0, this.decimal = void 0, this.decimalLen = void 0, this.empty = void 0, this.nan = void 0, !e && e !== 0 || !String(e).trim()) {
      this.empty = !0;
      return;
    }
    if (this.origin = String(e), e === "-") {
      this.nan = !0;
      return;
    }
    var n = e;
    if (UA(n) && (n = Number(n)), n = typeof n == "string" ? n : OC(n), XA(n)) {
      var r = yd(n);
      this.negative = r.negative;
      var i = r.trimStr.split(".");
      this.integer = BigInt(i[0]);
      var o = i[1] || "0";
      this.decimal = BigInt(o), this.decimalLen = o.length;
    } else
      this.nan = !0;
  }
  return Gn(t, [{
    key: "getMark",
    value: function() {
      return this.negative ? "-" : "";
    }
  }, {
    key: "getIntegerStr",
    value: function() {
      return this.integer.toString();
    }
  }, {
    key: "getDecimalStr",
    value: function() {
      return this.decimal.toString().padStart(this.decimalLen, "0");
    }
    /**
     * Align BigIntDecimal with same decimal length. e.g. 12.3 + 5 = 1230000
     * This is used for add function only.
     */
  }, {
    key: "alignDecimal",
    value: function(n) {
      var r = "".concat(this.getMark()).concat(this.getIntegerStr()).concat(this.getDecimalStr().padEnd(n, "0"));
      return BigInt(r);
    }
  }, {
    key: "negate",
    value: function() {
      var n = new t(this.toString());
      return n.negative = !n.negative, n;
    }
  }, {
    key: "add",
    value: function(n) {
      if (this.isInvalidate())
        return new t(n);
      var r = new t(n);
      if (r.isInvalidate())
        return this;
      var i = Math.max(this.getDecimalStr().length, r.getDecimalStr().length), o = this.alignDecimal(i), a = r.alignDecimal(i), s = (o + a).toString(), u = yd(s), l = u.negativeStr, c = u.trimStr, d = "".concat(l).concat(c.padStart(i + 1, "0"));
      return new t("".concat(d.slice(0, -i), ".").concat(d.slice(-i)));
    }
  }, {
    key: "isEmpty",
    value: function() {
      return this.empty;
    }
  }, {
    key: "isNaN",
    value: function() {
      return this.nan;
    }
  }, {
    key: "isInvalidate",
    value: function() {
      return this.isEmpty() || this.isNaN();
    }
  }, {
    key: "equals",
    value: function(n) {
      return this.toString() === (n == null ? void 0 : n.toString());
    }
  }, {
    key: "lessEquals",
    value: function(n) {
      return this.add(n.negate().toString()).toNumber() <= 0;
    }
  }, {
    key: "toNumber",
    value: function() {
      return this.isNaN() ? NaN : Number(this.toString());
    }
  }, {
    key: "toString",
    value: function() {
      var n = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : !0;
      return n ? this.isInvalidate() ? "" : yd("".concat(this.getMark()).concat(this.getIntegerStr(), ".").concat(this.getDecimalStr())).fullStr : this.origin;
    }
  }]), t;
}();
function hs(t) {
  return f_() ? new KEe(t) : new JEe(t);
}
function fy(t, e, n) {
  var r = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : !1;
  if (t === "")
    return "";
  var i = yd(t), o = i.negativeStr, a = i.integerStr, s = i.decimalStr, u = "".concat(e).concat(s), l = "".concat(o).concat(a);
  if (n >= 0) {
    var c = Number(s[n]);
    if (c >= 5 && !r) {
      var d = hs(t).add("".concat(o, "0.").concat("0".repeat(n)).concat(10 - c));
      return fy(d.toString(), e, n, r);
    }
    return n === 0 ? l : "".concat(l).concat(e).concat(s.padEnd(n, "0").slice(0, n));
  }
  return u === ".0" ? l : "".concat(l).concat(u);
}
var qEe = 200, QEe = 600;
function eSe(t) {
  var e = t.prefixCls, n = t.upNode, r = t.downNode, i = t.upDisabled, o = t.downDisabled, a = t.onStep, s = x.useRef(), u = x.useRef();
  u.current = a;
  var l = function(m, b) {
    m.preventDefault(), u.current(b);
    function y() {
      u.current(b), s.current = setTimeout(y, qEe);
    }
    s.current = setTimeout(y, QEe);
  }, c = function() {
    clearTimeout(s.current);
  };
  if (x.useEffect(function() {
    return c;
  }, []), dA())
    return null;
  var d = "".concat(e, "-handler"), f = Ce(d, "".concat(d, "-up"), z({}, "".concat(d, "-up-disabled"), i)), h = Ce(d, "".concat(d, "-down"), z({}, "".concat(d, "-down-disabled"), o)), p = {
    unselectable: "on",
    role: "button",
    onMouseUp: c,
    onMouseLeave: c
  };
  return /* @__PURE__ */ x.createElement("div", {
    className: "".concat(d, "-wrap")
  }, /* @__PURE__ */ x.createElement("span", G({}, p, {
    onMouseDown: function(m) {
      l(m, !0);
    },
    "aria-label": "Increase Value",
    "aria-disabled": i,
    className: f
  }), n || /* @__PURE__ */ x.createElement("span", {
    unselectable: "on",
    className: "".concat(e, "-handler-up-inner")
  })), /* @__PURE__ */ x.createElement("span", G({}, p, {
    onMouseDown: function(m) {
      l(m, !1);
    },
    "aria-label": "Decrease Value",
    "aria-disabled": o,
    className: h
  }), r || /* @__PURE__ */ x.createElement("span", {
    unselectable: "on",
    className: "".concat(e, "-handler-down-inner")
  })));
}
function tSe(t, e) {
  var n = Ee(null);
  function r() {
    try {
      var o = t.selectionStart, a = t.selectionEnd, s = t.value, u = s.substring(0, o), l = s.substring(a);
      n.current = {
        start: o,
        end: a,
        value: s,
        beforeTxt: u,
        afterTxt: l
      };
    } catch {
    }
  }
  function i() {
    if (t && n.current && e)
      try {
        var o = t.value, a = n.current, s = a.beforeTxt, u = a.afterTxt, l = a.start, c = o.length;
        if (o.endsWith(u))
          c = o.length - n.current.afterTxt.length;
        else if (o.startsWith(s))
          c = s.length;
        else {
          var d = s[l - 1], f = o.indexOf(d, l - 1);
          f !== -1 && (c = f + 1);
        }
        t.setSelectionRange(c, c);
      } catch (h) {
        Wt(!1, "Something warning of cursor restore. Please fire issue about this: ".concat(h.message));
      }
  }
  return [r, i];
}
const nSe = function() {
  var t = Ee(0), e = function() {
    En.cancel(t.current);
  };
  return Re(function() {
    return e;
  }, []), function(n) {
    e(), t.current = En(function() {
      n();
    });
  };
};
var rSe = ["prefixCls", "className", "style", "min", "max", "step", "defaultValue", "value", "disabled", "readOnly", "upHandler", "downHandler", "keyboard", "controls", "stringMode", "parser", "formatter", "precision", "decimalSeparator", "onChange", "onInput", "onPressEnter", "onStep"], ER = function(e, n) {
  return e || n.isEmpty() ? n.toString() : n.toNumber();
}, SR = function(e) {
  var n = hs(e);
  return n.isInvalidate() ? null : n;
}, XU = /* @__PURE__ */ x.forwardRef(function(t, e) {
  var n, r = t.prefixCls, i = r === void 0 ? "rc-input-number" : r, o = t.className, a = t.style, s = t.min, u = t.max, l = t.step, c = l === void 0 ? 1 : l, d = t.defaultValue, f = t.value, h = t.disabled, p = t.readOnly, v = t.upHandler, m = t.downHandler, b = t.keyboard, y = t.controls, w = y === void 0 ? !0 : y, S = t.stringMode, E = t.parser, I = t.formatter, _ = t.precision, A = t.decimalSeparator, P = t.onChange, N = t.onInput, k = t.onPressEnter, D = t.onStep, R = Gt(t, rSe), V = "".concat(i, "-input"), $ = x.useRef(null), F = x.useState(!1), M = be(F, 2), B = M[0], X = M[1], L = x.useRef(!1), j = x.useRef(!1), K = x.useRef(!1), W = x.useState(function() {
    return hs(f ?? d);
  }), Y = be(W, 2), U = Y[0], Q = Y[1];
  function Z(bt) {
    f === void 0 && Q(bt);
  }
  var ee = x.useCallback(function(bt, Me) {
    if (!Me)
      return _ >= 0 ? _ : Math.max(Z0(bt), Z0(c));
  }, [_, c]), ie = x.useCallback(function(bt) {
    var Me = String(bt);
    if (E)
      return E(Me);
    var yt = Me;
    return A && (yt = yt.replace(A, ".")), yt.replace(/[^\w.-]+/g, "");
  }, [E, A]), oe = x.useRef(""), se = x.useCallback(function(bt, Me) {
    if (I)
      return I(bt, {
        userTyping: Me,
        input: String(oe.current)
      });
    var yt = typeof bt == "number" ? OC(bt) : bt;
    if (!Me) {
      var ct = ee(yt, Me);
      if (XA(yt) && (A || ct >= 0)) {
        var kt = A || ".";
        yt = fy(yt, kt, ct);
      }
    }
    return yt;
  }, [I, ee, A]), te = x.useState(function() {
    var bt = d ?? f;
    return U.isInvalidate() && ["string", "number"].includes(_t(bt)) ? Number.isNaN(bt) ? "" : bt : se(U.toString(), !1);
  }), ge = be(te, 2), he = ge[0], fe = ge[1];
  oe.current = he;
  function _e(bt, Me) {
    fe(se(
      // Invalidate number is sometime passed by external control, we should let it go
      // Otherwise is controlled by internal interactive logic which check by userTyping
      // You can ref 'show limited value when input is not focused' test for more info.
      bt.isInvalidate() ? bt.toString(!1) : bt.toString(!Me),
      Me
    ));
  }
  var Ne = x.useMemo(function() {
    return SR(u);
  }, [u, _]), ze = x.useMemo(function() {
    return SR(s);
  }, [s, _]), Ve = x.useMemo(function() {
    return !Ne || !U || U.isInvalidate() ? !1 : Ne.lessEquals(U);
  }, [Ne, U]), ne = x.useMemo(function() {
    return !ze || !U || U.isInvalidate() ? !1 : U.lessEquals(ze);
  }, [ze, U]), pe = tSe($.current, B), ye = be(pe, 2), Ae = ye[0], we = ye[1], ce = function(Me) {
    return Ne && !Me.lessEquals(Ne) ? Ne : ze && !ze.lessEquals(Me) ? ze : null;
  }, ve = function(Me) {
    return !ce(Me);
  }, Ie = function(Me, yt) {
    var ct = Me, kt = ve(ct) || ct.isEmpty();
    if (!ct.isEmpty() && !yt && (ct = ce(ct) || ct, kt = !0), !p && !h && kt) {
      var Vt = ct.toString(), Vn = ee(Vt, yt);
      return Vn >= 0 && (ct = hs(fy(Vt, ".", Vn)), ve(ct) || (ct = hs(fy(Vt, ".", Vn, !0)))), ct.equals(U) || (Z(ct), P == null || P(ct.isEmpty() ? null : ER(S, ct)), f === void 0 && _e(ct, yt)), ct;
    }
    return U;
  }, q = nSe(), Fe = function bt(Me) {
    if (Ae(), fe(Me), !j.current) {
      var yt = ie(Me), ct = hs(yt);
      ct.isNaN() || Ie(ct, !0);
    }
    N == null || N(Me), q(function() {
      var kt = Me;
      E || (kt = Me.replace(/。/g, ".")), kt !== Me && bt(kt);
    });
  }, Ze = function() {
    j.current = !0;
  }, at = function() {
    j.current = !1, Fe($.current.value);
  }, Je = function(Me) {
    Fe(Me.target.value);
  }, ut = function(Me) {
    var yt;
    if (!(Me && Ve || !Me && ne)) {
      L.current = !1;
      var ct = hs(K.current ? wR(c) : c);
      Me || (ct = ct.negate());
      var kt = (U || hs(0)).add(ct.toString()), Vt = Ie(kt, !1);
      D == null || D(ER(S, Vt), {
        offset: K.current ? wR(c) : c,
        type: Me ? "up" : "down"
      }), (yt = $.current) === null || yt === void 0 || yt.focus();
    }
  }, Ct = function(Me) {
    var yt = hs(ie(he)), ct = yt;
    yt.isNaN() ? ct = U : ct = Ie(yt, Me), f !== void 0 ? _e(U, !1) : ct.isNaN() || _e(ct, !1);
  }, Ke = function() {
    L.current = !0;
  }, st = function(Me) {
    var yt = Me.which, ct = Me.shiftKey;
    L.current = !0, ct ? K.current = !0 : K.current = !1, yt === ke.ENTER && (j.current || (L.current = !1), Ct(!1), k == null || k(Me)), b !== !1 && !j.current && [ke.UP, ke.DOWN].includes(yt) && (ut(ke.UP === yt), Me.preventDefault());
  }, wt = function() {
    L.current = !1, K.current = !1;
  }, qt = function() {
    Ct(!1), X(!1), L.current = !1;
  };
  return d0(function() {
    U.isInvalidate() || _e(U, !1);
  }, [_]), d0(function() {
    var bt = hs(f);
    Q(bt);
    var Me = hs(ie(he));
    (!bt.equals(Me) || !L.current || I) && _e(bt, L.current);
  }, [f]), d0(function() {
    I && we();
  }, [he]), /* @__PURE__ */ x.createElement("div", {
    className: Ce(i, o, (n = {}, z(n, "".concat(i, "-focused"), B), z(n, "".concat(i, "-disabled"), h), z(n, "".concat(i, "-readonly"), p), z(n, "".concat(i, "-not-a-number"), U.isNaN()), z(n, "".concat(i, "-out-of-range"), !U.isInvalidate() && !ve(U)), n)),
    style: a,
    onFocus: function() {
      X(!0);
    },
    onBlur: qt,
    onKeyDown: st,
    onKeyUp: wt,
    onCompositionStart: Ze,
    onCompositionEnd: at,
    onBeforeInput: Ke
  }, w && /* @__PURE__ */ x.createElement(eSe, {
    prefixCls: i,
    upNode: v,
    downNode: m,
    upDisabled: Ve,
    downDisabled: ne,
    onStep: ut
  }), /* @__PURE__ */ x.createElement("div", {
    className: "".concat(V, "-wrap")
  }, /* @__PURE__ */ x.createElement("input", G({
    autoComplete: "off",
    role: "spinbutton",
    "aria-valuemin": s,
    "aria-valuemax": u,
    "aria-valuenow": U.isInvalidate() ? null : U.toString(),
    step: c
  }, R, {
    ref: Ja($, e),
    className: V,
    value: he,
    onChange: Je,
    disabled: h,
    readOnly: p
  }))));
});
XU.displayName = "InputNumber";
var iSe = function(t, e) {
  var n = {};
  for (var r in t)
    Object.prototype.hasOwnProperty.call(t, r) && e.indexOf(r) < 0 && (n[r] = t[r]);
  if (t != null && typeof Object.getOwnPropertySymbols == "function")
    for (var i = 0, r = Object.getOwnPropertySymbols(t); i < r.length; i++)
      e.indexOf(r[i]) < 0 && Object.prototype.propertyIsEnumerable.call(t, r[i]) && (n[r[i]] = t[r[i]]);
  return n;
}, oSe = /* @__PURE__ */ x.forwardRef(function(t, e) {
  var n = x.useContext(en), r = n.getPrefixCls, i = n.direction, o = x.useContext(qa), a = x.useState(!1), s = be(a, 2), u = s[0], l = s[1], c = x.useRef(null);
  x.useImperativeHandle(e, function() {
    return c.current;
  });
  var d = t.className, f = t.size, h = t.disabled, p = t.prefixCls, v = t.addonBefore, m = t.addonAfter, b = t.prefix, y = t.bordered, w = y === void 0 ? !0 : y, S = t.readOnly, E = t.status, I = t.controls, _ = iSe(t, ["className", "size", "disabled", "prefixCls", "addonBefore", "addonAfter", "prefix", "bordered", "readOnly", "status", "controls"]), A = r("input-number", p), P = Tc(A, i), N = P.compactSize, k = P.compactItemClassnames, D = /* @__PURE__ */ x.createElement(I0e, {
    className: "".concat(A, "-handler-up-inner")
  }), R = /* @__PURE__ */ x.createElement(cC, {
    className: "".concat(A, "-handler-down-inner")
  }), V = typeof I == "boolean" ? I : void 0;
  _t(I) === "object" && (D = typeof I.upIcon > "u" ? D : /* @__PURE__ */ x.createElement("span", {
    className: "".concat(A, "-handler-up-inner")
  }, I.upIcon), R = typeof I.downIcon > "u" ? R : /* @__PURE__ */ x.createElement("span", {
    className: "".concat(A, "-handler-down-inner")
  }, I.downIcon));
  var $ = fn(Ji), F = $.hasFeedback, M = $.status, B = $.isFormItemInput, X = $.feedbackIcon, L = Ac(M, E), j = N || f || o, K = x.useContext(Ka), W = h ?? K, Y = Ce(z(z(z(z(z({}, "".concat(A, "-lg"), j === "large"), "".concat(A, "-sm"), j === "small"), "".concat(A, "-rtl"), i === "rtl"), "".concat(A, "-borderless"), !w), "".concat(A, "-in-form-item"), B), aa(A, L), k, d), U = /* @__PURE__ */ x.createElement(XU, G({
    ref: c,
    disabled: W,
    className: Y,
    upHandler: D,
    downHandler: R,
    prefixCls: A,
    readOnly: S,
    controls: V
  }, _));
  if (b != null || F) {
    var Q = Ce("".concat(A, "-affix-wrapper"), aa("".concat(A, "-affix-wrapper"), L, F), z(z(z(z(z(z(z(z({}, "".concat(A, "-affix-wrapper-focused"), u), "".concat(A, "-affix-wrapper-disabled"), t.disabled), "".concat(A, "-affix-wrapper-sm"), o === "small"), "".concat(A, "-affix-wrapper-lg"), o === "large"), "".concat(A, "-affix-wrapper-rtl"), i === "rtl"), "".concat(A, "-affix-wrapper-readonly"), S), "".concat(A, "-affix-wrapper-borderless"), !w), "".concat(d), !(v || m) && d));
    U = /* @__PURE__ */ x.createElement("div", {
      className: Q,
      style: t.style,
      onMouseUp: function() {
        return c.current.focus();
      }
    }, b && /* @__PURE__ */ x.createElement("span", {
      className: "".concat(A, "-prefix")
    }, b), ji(U, {
      style: null,
      value: t.value,
      onFocus: function(he) {
        var fe;
        l(!0), (fe = t.onFocus) === null || fe === void 0 || fe.call(t, he);
      },
      onBlur: function(he) {
        var fe;
        l(!1), (fe = t.onBlur) === null || fe === void 0 || fe.call(t, he);
      }
    }), F && /* @__PURE__ */ x.createElement("span", {
      className: "".concat(A, "-suffix")
    }, X));
  }
  if (v != null || m != null) {
    var Z = "".concat(A, "-group"), ee = "".concat(Z, "-addon"), ie = v ? /* @__PURE__ */ x.createElement("div", {
      className: ee
    }, v) : null, oe = m ? /* @__PURE__ */ x.createElement("div", {
      className: ee
    }, m) : null, se = Ce("".concat(A, "-wrapper"), Z, z({}, "".concat(Z, "-rtl"), i === "rtl")), te = Ce("".concat(A, "-group-wrapper"), z(z(z({}, "".concat(A, "-group-wrapper-sm"), o === "small"), "".concat(A, "-group-wrapper-lg"), o === "large"), "".concat(A, "-group-wrapper-rtl"), i === "rtl"), aa("".concat(A, "-group-wrapper"), L, F), d);
    U = /* @__PURE__ */ x.createElement("div", {
      className: te,
      style: t.style
    }, /* @__PURE__ */ x.createElement("div", {
      className: se
    }, ie && /* @__PURE__ */ x.createElement(G0, null, /* @__PURE__ */ x.createElement(gx, {
      status: !0,
      override: !0
    }, ie)), ji(U, {
      style: null,
      disabled: W
    }), oe && /* @__PURE__ */ x.createElement(G0, null, /* @__PURE__ */ x.createElement(gx, {
      status: !0,
      override: !0
    }, oe))));
  }
  return U;
});
const aSe = oSe;
var Pg = function(e) {
  var n, r = "".concat(e.rootPrefixCls, "-item"), i = Ce(r, "".concat(r, "-").concat(e.page), (n = {}, z(n, "".concat(r, "-active"), e.active), z(n, "".concat(r, "-disabled"), !e.page), z(n, e.className, !!e.className), n)), o = function() {
    e.onClick(e.page);
  }, a = function(u) {
    e.onKeyPress(u, e.onClick, e.page);
  };
  return /* @__PURE__ */ O.createElement("li", {
    title: e.showTitle ? e.page : null,
    className: i,
    onClick: o,
    onKeyPress: a,
    tabIndex: "0"
  }, e.itemRender(e.page, "page", /* @__PURE__ */ O.createElement("a", {
    rel: "nofollow"
  }, e.page)));
};
const td = {
  ZERO: 48,
  NINE: 57,
  NUMPAD_ZERO: 96,
  NUMPAD_NINE: 105,
  BACKSPACE: 8,
  DELETE: 46,
  ENTER: 13,
  ARROW_UP: 38,
  ARROW_DOWN: 40
};
var YU = /* @__PURE__ */ function(t) {
  Pr(n, t);
  var e = Hr(n);
  function n() {
    var r;
    zn(this, n);
    for (var i = arguments.length, o = new Array(i), a = 0; a < i; a++)
      o[a] = arguments[a];
    return r = e.call.apply(e, [this].concat(o)), r.state = {
      goInputText: ""
    }, r.buildOptionText = function(s) {
      return "".concat(s, " ").concat(r.props.locale.items_per_page);
    }, r.changeSize = function(s) {
      r.props.changeSize(Number(s));
    }, r.handleChange = function(s) {
      r.setState({
        goInputText: s.target.value
      });
    }, r.handleBlur = function(s) {
      var u = r.props, l = u.goButton, c = u.quickGo, d = u.rootPrefixCls, f = r.state.goInputText;
      l || f === "" || (r.setState({
        goInputText: ""
      }), !(s.relatedTarget && (s.relatedTarget.className.indexOf("".concat(d, "-item-link")) >= 0 || s.relatedTarget.className.indexOf("".concat(d, "-item")) >= 0)) && c(r.getValidValue()));
    }, r.go = function(s) {
      var u = r.state.goInputText;
      u !== "" && (s.keyCode === td.ENTER || s.type === "click") && (r.setState({
        goInputText: ""
      }), r.props.quickGo(r.getValidValue()));
    }, r;
  }
  return Gn(n, [{
    key: "getValidValue",
    value: function() {
      var i = this.state.goInputText;
      return !i || isNaN(i) ? void 0 : Number(i);
    }
  }, {
    key: "getPageSizeOptions",
    value: function() {
      var i = this.props, o = i.pageSize, a = i.pageSizeOptions;
      return a.some(function(s) {
        return s.toString() === o.toString();
      }) ? a : a.concat([o.toString()]).sort(function(s, u) {
        var l = isNaN(Number(s)) ? 0 : Number(s), c = isNaN(Number(u)) ? 0 : Number(u);
        return l - c;
      });
    }
  }, {
    key: "render",
    value: function() {
      var i = this, o = this.props, a = o.pageSize, s = o.locale, u = o.rootPrefixCls, l = o.changeSize, c = o.quickGo, d = o.goButton, f = o.selectComponentClass, h = o.buildOptionText, p = o.selectPrefixCls, v = o.disabled, m = this.state.goInputText, b = "".concat(u, "-options"), y = f, w = null, S = null, E = null;
      if (!l && !c)
        return null;
      var I = this.getPageSizeOptions();
      if (l && y) {
        var _ = I.map(function(A, P) {
          return /* @__PURE__ */ O.createElement(y.Option, {
            key: P,
            value: A.toString()
          }, (h || i.buildOptionText)(A));
        });
        w = /* @__PURE__ */ O.createElement(y, {
          disabled: v,
          prefixCls: p,
          showSearch: !1,
          className: "".concat(b, "-size-changer"),
          optionLabelProp: "children",
          dropdownMatchSelectWidth: !1,
          value: (a || I[0]).toString(),
          onChange: this.changeSize,
          getPopupContainer: function(P) {
            return P.parentNode;
          },
          "aria-label": s.page_size,
          defaultOpen: !1
        }, _);
      }
      return c && (d && (E = typeof d == "boolean" ? /* @__PURE__ */ O.createElement("button", {
        type: "button",
        onClick: this.go,
        onKeyUp: this.go,
        disabled: v,
        className: "".concat(b, "-quick-jumper-button")
      }, s.jump_to_confirm) : /* @__PURE__ */ O.createElement("span", {
        onClick: this.go,
        onKeyUp: this.go
      }, d)), S = /* @__PURE__ */ O.createElement("div", {
        className: "".concat(b, "-quick-jumper")
      }, s.jump_to, /* @__PURE__ */ O.createElement("input", {
        disabled: v,
        type: "text",
        value: m,
        onChange: this.handleChange,
        onKeyUp: this.go,
        onBlur: this.handleBlur,
        "aria-label": s.page
      }), s.page, E)), /* @__PURE__ */ O.createElement("li", {
        className: "".concat(b)
      }, w, S);
    }
  }]), n;
}(O.Component);
YU.defaultProps = {
  pageSizeOptions: ["10", "20", "50", "100"]
};
const sSe = {
  // Options.jsx
  items_per_page: "条/页",
  jump_to: "跳至",
  jump_to_confirm: "确定",
  page: "页",
  // Pagination.jsx
  prev_page: "上一页",
  next_page: "下一页",
  prev_5: "向前 5 页",
  next_5: "向后 5 页",
  prev_3: "向前 3 页",
  next_3: "向后 3 页",
  page_size: "页码"
};
function h_() {
}
function IR(t) {
  var e = Number(t);
  return (
    // eslint-disable-next-line no-restricted-globals
    typeof e == "number" && !isNaN(e) && isFinite(e) && Math.floor(e) === e
  );
}
function uSe(t, e, n) {
  return n;
}
function kl(t, e, n) {
  var r = typeof t > "u" ? e.pageSize : t;
  return Math.floor((n.total - 1) / r) + 1;
}
var ZU = /* @__PURE__ */ function(t) {
  Pr(n, t);
  var e = Hr(n);
  function n(r) {
    var i;
    zn(this, n), i = e.call(this, r), i.getJumpPrevPage = function() {
      return Math.max(1, i.state.current - (i.props.showLessItems ? 3 : 5));
    }, i.getJumpNextPage = function() {
      return Math.min(kl(void 0, i.state, i.props), i.state.current + (i.props.showLessItems ? 3 : 5));
    }, i.getItemIcon = function(l, c) {
      var d = i.props.prefixCls, f = l || /* @__PURE__ */ O.createElement("button", {
        type: "button",
        "aria-label": c,
        className: "".concat(d, "-item-link")
      });
      return typeof l == "function" && (f = /* @__PURE__ */ O.createElement(l, de({}, i.props))), f;
    }, i.savePaginationNode = function(l) {
      i.paginationNode = l;
    }, i.isValid = function(l) {
      var c = i.props.total;
      return IR(l) && l !== i.state.current && IR(c) && c > 0;
    }, i.shouldDisplayQuickJumper = function() {
      var l = i.props, c = l.showQuickJumper, d = l.total, f = i.state.pageSize;
      return d <= f ? !1 : c;
    }, i.handleKeyDown = function(l) {
      (l.keyCode === td.ARROW_UP || l.keyCode === td.ARROW_DOWN) && l.preventDefault();
    }, i.handleKeyUp = function(l) {
      var c = i.getValidValue(l), d = i.state.currentInputValue;
      c !== d && i.setState({
        currentInputValue: c
      }), l.keyCode === td.ENTER ? i.handleChange(c) : l.keyCode === td.ARROW_UP ? i.handleChange(c - 1) : l.keyCode === td.ARROW_DOWN && i.handleChange(c + 1);
    }, i.handleBlur = function(l) {
      var c = i.getValidValue(l);
      i.handleChange(c);
    }, i.changePageSize = function(l) {
      var c = i.state.current, d = kl(l, i.state, i.props);
      c = c > d ? d : c, d === 0 && (c = i.state.current), typeof l == "number" && ("pageSize" in i.props || i.setState({
        pageSize: l
      }), "current" in i.props || i.setState({
        current: c,
        currentInputValue: c
      })), i.props.onShowSizeChange(c, l), "onChange" in i.props && i.props.onChange && i.props.onChange(c, l);
    }, i.handleChange = function(l) {
      var c = i.props, d = c.disabled, f = c.onChange, h = i.state, p = h.pageSize, v = h.current, m = h.currentInputValue;
      if (i.isValid(l) && !d) {
        var b = kl(void 0, i.state, i.props), y = l;
        return l > b ? y = b : l < 1 && (y = 1), "current" in i.props || i.setState({
          current: y
        }), y !== m && i.setState({
          currentInputValue: y
        }), f(y, p), y;
      }
      return v;
    }, i.prev = function() {
      i.hasPrev() && i.handleChange(i.state.current - 1);
    }, i.next = function() {
      i.hasNext() && i.handleChange(i.state.current + 1);
    }, i.jumpPrev = function() {
      i.handleChange(i.getJumpPrevPage());
    }, i.jumpNext = function() {
      i.handleChange(i.getJumpNextPage());
    }, i.hasPrev = function() {
      return i.state.current > 1;
    }, i.hasNext = function() {
      return i.state.current < kl(void 0, i.state, i.props);
    }, i.runIfEnter = function(l, c) {
      if (l.key === "Enter" || l.charCode === 13) {
        for (var d = arguments.length, f = new Array(d > 2 ? d - 2 : 0), h = 2; h < d; h++)
          f[h - 2] = arguments[h];
        c.apply(void 0, f);
      }
    }, i.runIfEnterPrev = function(l) {
      i.runIfEnter(l, i.prev);
    }, i.runIfEnterNext = function(l) {
      i.runIfEnter(l, i.next);
    }, i.runIfEnterJumpPrev = function(l) {
      i.runIfEnter(l, i.jumpPrev);
    }, i.runIfEnterJumpNext = function(l) {
      i.runIfEnter(l, i.jumpNext);
    }, i.handleGoTO = function(l) {
      (l.keyCode === td.ENTER || l.type === "click") && i.handleChange(i.state.currentInputValue);
    };
    var o = r.onChange !== h_, a = "current" in r;
    a && !o && console.warn("Warning: You provided a `current` prop to a Pagination component without an `onChange` handler. This will render a read-only component.");
    var s = r.defaultCurrent;
    "current" in r && (s = r.current);
    var u = r.defaultPageSize;
    return "pageSize" in r && (u = r.pageSize), s = Math.min(s, kl(u, void 0, r)), i.state = {
      current: s,
      currentInputValue: s,
      pageSize: u
    }, i;
  }
  return Gn(n, [{
    key: "componentDidUpdate",
    value: function(i, o) {
      var a = this.props.prefixCls;
      if (o.current !== this.state.current && this.paginationNode) {
        var s = this.paginationNode.querySelector(".".concat(a, "-item-").concat(o.current));
        s && document.activeElement === s && s.blur();
      }
    }
  }, {
    key: "getValidValue",
    value: function(i) {
      var o = i.target.value, a = kl(void 0, this.state, this.props), s = this.state.currentInputValue, u;
      return o === "" ? u = o : isNaN(Number(o)) ? u = s : o >= a ? u = a : u = Number(o), u;
    }
  }, {
    key: "getShowSizeChanger",
    value: function() {
      var i = this.props, o = i.showSizeChanger, a = i.total, s = i.totalBoundaryShowSizeChanger;
      return typeof o < "u" ? o : a > s;
    }
  }, {
    key: "renderPrev",
    value: function(i) {
      var o = this.props, a = o.prevIcon, s = o.itemRender, u = s(i, "prev", this.getItemIcon(a, "prev page")), l = !this.hasPrev();
      return /* @__PURE__ */ Od(u) ? /* @__PURE__ */ Is(u, {
        disabled: l
      }) : u;
    }
  }, {
    key: "renderNext",
    value: function(i) {
      var o = this.props, a = o.nextIcon, s = o.itemRender, u = s(i, "next", this.getItemIcon(a, "next page")), l = !this.hasNext();
      return /* @__PURE__ */ Od(u) ? /* @__PURE__ */ Is(u, {
        disabled: l
      }) : u;
    }
  }, {
    key: "render",
    value: function() {
      var i = this, o = this.props, a = o.prefixCls, s = o.className, u = o.style, l = o.disabled, c = o.hideOnSinglePage, d = o.total, f = o.locale, h = o.showQuickJumper, p = o.showLessItems, v = o.showTitle, m = o.showTotal, b = o.simple, y = o.itemRender, w = o.showPrevNextJumpers, S = o.jumpPrevIcon, E = o.jumpNextIcon, I = o.selectComponentClass, _ = o.selectPrefixCls, A = o.pageSizeOptions, P = this.state, N = P.current, k = P.pageSize, D = P.currentInputValue;
      if (c === !0 && d <= k)
        return null;
      var R = kl(void 0, this.state, this.props), V = [], $ = null, F = null, M = null, B = null, X = null, L = h && h.goButton, j = p ? 1 : 2, K = N - 1 > 0 ? N - 1 : 0, W = N + 1 < R ? N + 1 : R, Y = Object.keys(this.props).reduce(function(Ne, ze) {
        return (ze.substr(0, 5) === "data-" || ze.substr(0, 5) === "aria-" || ze === "role") && (Ne[ze] = i.props[ze]), Ne;
      }, {}), U = m && /* @__PURE__ */ O.createElement("li", {
        className: "".concat(a, "-total-text")
      }, m(d, [d === 0 ? 0 : (N - 1) * k + 1, N * k > d ? d : N * k]));
      if (b)
        return L && (typeof L == "boolean" ? X = /* @__PURE__ */ O.createElement("button", {
          type: "button",
          onClick: this.handleGoTO,
          onKeyUp: this.handleGoTO
        }, f.jump_to_confirm) : X = /* @__PURE__ */ O.createElement("span", {
          onClick: this.handleGoTO,
          onKeyUp: this.handleGoTO
        }, L), X = /* @__PURE__ */ O.createElement("li", {
          title: v ? "".concat(f.jump_to).concat(N, "/").concat(R) : null,
          className: "".concat(a, "-simple-pager")
        }, X)), /* @__PURE__ */ O.createElement("ul", G({
          className: Ce(a, "".concat(a, "-simple"), z({}, "".concat(a, "-disabled"), l), s),
          style: u,
          ref: this.savePaginationNode
        }, Y), U, /* @__PURE__ */ O.createElement("li", {
          title: v ? f.prev_page : null,
          onClick: this.prev,
          tabIndex: this.hasPrev() ? 0 : null,
          onKeyPress: this.runIfEnterPrev,
          className: Ce("".concat(a, "-prev"), z({}, "".concat(a, "-disabled"), !this.hasPrev())),
          "aria-disabled": !this.hasPrev()
        }, this.renderPrev(K)), /* @__PURE__ */ O.createElement("li", {
          title: v ? "".concat(N, "/").concat(R) : null,
          className: "".concat(a, "-simple-pager")
        }, /* @__PURE__ */ O.createElement("input", {
          type: "text",
          value: D,
          disabled: l,
          onKeyDown: this.handleKeyDown,
          onKeyUp: this.handleKeyUp,
          onChange: this.handleKeyUp,
          onBlur: this.handleBlur,
          size: "3"
        }), /* @__PURE__ */ O.createElement("span", {
          className: "".concat(a, "-slash")
        }, "/"), R), /* @__PURE__ */ O.createElement("li", {
          title: v ? f.next_page : null,
          onClick: this.next,
          tabIndex: this.hasPrev() ? 0 : null,
          onKeyPress: this.runIfEnterNext,
          className: Ce("".concat(a, "-next"), z({}, "".concat(a, "-disabled"), !this.hasNext())),
          "aria-disabled": !this.hasNext()
        }, this.renderNext(W)), X);
      if (R <= 3 + j * 2) {
        var Q = {
          locale: f,
          rootPrefixCls: a,
          onClick: this.handleChange,
          onKeyPress: this.runIfEnter,
          showTitle: v,
          itemRender: y
        };
        R || V.push(/* @__PURE__ */ O.createElement(Pg, G({}, Q, {
          key: "noPager",
          page: 1,
          className: "".concat(a, "-item-disabled")
        })));
        for (var Z = 1; Z <= R; Z += 1) {
          var ee = N === Z;
          V.push(/* @__PURE__ */ O.createElement(Pg, G({}, Q, {
            key: Z,
            page: Z,
            active: ee
          })));
        }
      } else {
        var ie = p ? f.prev_3 : f.prev_5, oe = p ? f.next_3 : f.next_5;
        w && ($ = /* @__PURE__ */ O.createElement("li", {
          title: v ? ie : null,
          key: "prev",
          onClick: this.jumpPrev,
          tabIndex: "0",
          onKeyPress: this.runIfEnterJumpPrev,
          className: Ce("".concat(a, "-jump-prev"), z({}, "".concat(a, "-jump-prev-custom-icon"), !!S))
        }, y(this.getJumpPrevPage(), "jump-prev", this.getItemIcon(S, "prev page"))), F = /* @__PURE__ */ O.createElement("li", {
          title: v ? oe : null,
          key: "next",
          tabIndex: "0",
          onClick: this.jumpNext,
          onKeyPress: this.runIfEnterJumpNext,
          className: Ce("".concat(a, "-jump-next"), z({}, "".concat(a, "-jump-next-custom-icon"), !!E))
        }, y(this.getJumpNextPage(), "jump-next", this.getItemIcon(E, "next page")))), B = /* @__PURE__ */ O.createElement(Pg, {
          locale: f,
          last: !0,
          rootPrefixCls: a,
          onClick: this.handleChange,
          onKeyPress: this.runIfEnter,
          key: R,
          page: R,
          active: !1,
          showTitle: v,
          itemRender: y
        }), M = /* @__PURE__ */ O.createElement(Pg, {
          locale: f,
          rootPrefixCls: a,
          onClick: this.handleChange,
          onKeyPress: this.runIfEnter,
          key: 1,
          page: 1,
          active: !1,
          showTitle: v,
          itemRender: y
        });
        var se = Math.max(1, N - j), te = Math.min(N + j, R);
        N - 1 <= j && (te = 1 + j * 2), R - N <= j && (se = R - j * 2);
        for (var ge = se; ge <= te; ge += 1) {
          var he = N === ge;
          V.push(/* @__PURE__ */ O.createElement(Pg, {
            locale: f,
            rootPrefixCls: a,
            onClick: this.handleChange,
            onKeyPress: this.runIfEnter,
            key: ge,
            page: ge,
            active: he,
            showTitle: v,
            itemRender: y
          }));
        }
        N - 1 >= j * 2 && N !== 3 && (V[0] = /* @__PURE__ */ Is(V[0], {
          className: "".concat(a, "-item-after-jump-prev")
        }), V.unshift($)), R - N >= j * 2 && N !== R - 2 && (V[V.length - 1] = /* @__PURE__ */ Is(V[V.length - 1], {
          className: "".concat(a, "-item-before-jump-next")
        }), V.push(F)), se !== 1 && V.unshift(M), te !== R && V.push(B);
      }
      var fe = !this.hasPrev() || !R, _e = !this.hasNext() || !R;
      return /* @__PURE__ */ O.createElement("ul", G({
        className: Ce(a, s, z({}, "".concat(a, "-disabled"), l)),
        style: u,
        ref: this.savePaginationNode
      }, Y), U, /* @__PURE__ */ O.createElement("li", {
        title: v ? f.prev_page : null,
        onClick: this.prev,
        tabIndex: fe ? null : 0,
        onKeyPress: this.runIfEnterPrev,
        className: Ce("".concat(a, "-prev"), z({}, "".concat(a, "-disabled"), fe)),
        "aria-disabled": fe
      }, this.renderPrev(K)), V, /* @__PURE__ */ O.createElement("li", {
        title: v ? f.next_page : null,
        onClick: this.next,
        tabIndex: _e ? null : 0,
        onKeyPress: this.runIfEnterNext,
        className: Ce("".concat(a, "-next"), z({}, "".concat(a, "-disabled"), _e)),
        "aria-disabled": _e
      }, this.renderNext(W)), /* @__PURE__ */ O.createElement(YU, {
        disabled: l,
        locale: f,
        rootPrefixCls: a,
        selectComponentClass: I,
        selectPrefixCls: _,
        changeSize: this.getShowSizeChanger() ? this.changePageSize : null,
        current: N,
        pageSize: k,
        pageSizeOptions: A,
        quickGo: this.shouldDisplayQuickJumper() ? this.handleChange : null,
        goButton: L
      }));
    }
  }], [{
    key: "getDerivedStateFromProps",
    value: function(i, o) {
      var a = {};
      if ("current" in i && (a.current = i.current, i.current !== o.current && (a.currentInputValue = a.current)), "pageSize" in i && i.pageSize !== o.pageSize) {
        var s = o.current, u = kl(i.pageSize, o, i);
        s = s > u ? u : s, "current" in i || (a.current = s, a.currentInputValue = s), a.pageSize = i.pageSize;
      }
      return a;
    }
  }]), n;
}(O.Component);
ZU.defaultProps = {
  defaultCurrent: 1,
  total: 0,
  defaultPageSize: 10,
  onChange: h_,
  className: "",
  selectPrefixCls: "rc-select",
  prefixCls: "rc-pagination",
  selectComponentClass: null,
  hideOnSinglePage: !1,
  showPrevNextJumpers: !0,
  showQuickJumper: !1,
  showLessItems: !1,
  showTitle: !0,
  onShowSizeChange: h_,
  locale: sSe,
  style: {},
  itemRender: uSe,
  totalBoundaryShowSizeChanger: 50
};
var JU = function(e) {
  return /* @__PURE__ */ x.createElement(As, G({}, e, {
    size: "small"
  }));
}, KU = function(e) {
  return /* @__PURE__ */ x.createElement(As, G({}, e, {
    size: "middle"
  }));
};
JU.Option = As.Option;
KU.Option = As.Option;
var lSe = function(t, e) {
  var n = {};
  for (var r in t)
    Object.prototype.hasOwnProperty.call(t, r) && e.indexOf(r) < 0 && (n[r] = t[r]);
  if (t != null && typeof Object.getOwnPropertySymbols == "function")
    for (var i = 0, r = Object.getOwnPropertySymbols(t); i < r.length; i++)
      e.indexOf(r[i]) < 0 && Object.prototype.propertyIsEnumerable.call(t, r[i]) && (n[r[i]] = t[r[i]]);
  return n;
}, cSe = function(e) {
  var n = e.prefixCls, r = e.selectPrefixCls, i = e.className, o = e.size, a = e.locale, s = e.selectComponentClass, u = e.responsive, l = e.showSizeChanger, c = lSe(e, ["prefixCls", "selectPrefixCls", "className", "size", "locale", "selectComponentClass", "responsive", "showSizeChanger"]), d = kye(u), f = d.xs, h = x.useContext(en), p = h.getPrefixCls, v = h.direction, m = h.pagination, b = m === void 0 ? {} : m, y = p("pagination", n), w = l ?? b.showSizeChanger, S = function() {
    var I = /* @__PURE__ */ x.createElement("span", {
      className: "".concat(y, "-item-ellipsis")
    }, "•••"), _ = /* @__PURE__ */ x.createElement("button", {
      className: "".concat(y, "-item-link"),
      type: "button",
      tabIndex: -1
    }, /* @__PURE__ */ x.createElement(V0, null)), A = /* @__PURE__ */ x.createElement("button", {
      className: "".concat(y, "-item-link"),
      type: "button",
      tabIndex: -1
    }, /* @__PURE__ */ x.createElement(Qh, null)), P = /* @__PURE__ */ x.createElement("a", {
      className: "".concat(y, "-item-link")
    }, /* @__PURE__ */ x.createElement("div", {
      className: "".concat(y, "-item-container")
    }, /* @__PURE__ */ x.createElement(Ege, {
      className: "".concat(y, "-item-link-icon")
    }), I)), N = /* @__PURE__ */ x.createElement("a", {
      className: "".concat(y, "-item-link")
    }, /* @__PURE__ */ x.createElement("div", {
      className: "".concat(y, "-item-container")
    }, /* @__PURE__ */ x.createElement(_ge, {
      className: "".concat(y, "-item-link-icon")
    }), I));
    if (v === "rtl") {
      var k = [A, _];
      _ = k[0], A = k[1];
      var D = [N, P];
      P = D[0], N = D[1];
    }
    return {
      prevIcon: _,
      nextIcon: A,
      jumpPrevIcon: P,
      jumpNextIcon: N
    };
  };
  return /* @__PURE__ */ x.createElement(Ic, {
    componentName: "Pagination",
    defaultLocale: jj
  }, function(E) {
    var I = G(G({}, E), a), _ = o === "small" || !!(f && !o && u), A = p("select", r), P = Ce(z(z({}, "".concat(y, "-mini"), _), "".concat(y, "-rtl"), v === "rtl"), i);
    return /* @__PURE__ */ x.createElement(ZU, G({}, S(), c, {
      prefixCls: y,
      selectPrefixCls: A,
      className: P,
      selectComponentClass: s || (_ ? JU : KU),
      locale: I,
      showSizeChanger: w
    }));
  });
};
const dSe = cSe;
var fSe = $s, hSe = function() {
  return fSe.Date.now();
}, pSe = hSe, gSe = Ds, n3 = pSe, _R = sU, mSe = "Expected a function", vSe = Math.max, bSe = Math.min;
function ySe(t, e, n) {
  var r, i, o, a, s, u, l = 0, c = !1, d = !1, f = !0;
  if (typeof t != "function")
    throw new TypeError(mSe);
  e = _R(e) || 0, gSe(n) && (c = !!n.leading, d = "maxWait" in n, o = d ? vSe(_R(n.maxWait) || 0, e) : o, f = "trailing" in n ? !!n.trailing : f);
  function h(I) {
    var _ = r, A = i;
    return r = i = void 0, l = I, a = t.apply(A, _), a;
  }
  function p(I) {
    return l = I, s = setTimeout(b, e), c ? h(I) : a;
  }
  function v(I) {
    var _ = I - u, A = I - l, P = e - _;
    return d ? bSe(P, o - A) : P;
  }
  function m(I) {
    var _ = I - u, A = I - l;
    return u === void 0 || _ >= e || _ < 0 || d && A >= o;
  }
  function b() {
    var I = n3();
    if (m(I))
      return y(I);
    s = setTimeout(b, v(I));
  }
  function y(I) {
    return s = void 0, f && r ? h(I) : (r = i = void 0, a);
  }
  function w() {
    s !== void 0 && clearTimeout(s), l = 0, r = u = i = s = void 0;
  }
  function S() {
    return s === void 0 ? a : y(n3());
  }
  function E() {
    var I = n3(), _ = m(I);
    if (r = arguments, i = this, u = I, _) {
      if (s === void 0)
        return p(u);
      if (d)
        return clearTimeout(s), s = setTimeout(b, e), h(u);
    }
    return s === void 0 && (s = setTimeout(b, e)), a;
  }
  return E.cancel = w, E.flush = S, E;
}
var xSe = ySe;
const CSe = /* @__PURE__ */ qn(xSe);
var wSe = function(t, e) {
  var n = {};
  for (var r in t)
    Object.prototype.hasOwnProperty.call(t, r) && e.indexOf(r) < 0 && (n[r] = t[r]);
  if (t != null && typeof Object.getOwnPropertySymbols == "function")
    for (var i = 0, r = Object.getOwnPropertySymbols(t); i < r.length; i++)
      e.indexOf(r[i]) < 0 && Object.prototype.propertyIsEnumerable.call(t, r[i]) && (n[r[i]] = t[r[i]]);
  return n;
}, ESe = {
  border: 0,
  background: "transparent",
  padding: 0,
  lineHeight: "inherit",
  display: "inline-block"
}, SSe = /* @__PURE__ */ x.forwardRef(function(t, e) {
  var n = function(c) {
    var d = c.keyCode;
    d === ke.ENTER && c.preventDefault();
  }, r = function(c) {
    var d = c.keyCode, f = t.onClick;
    d === ke.ENTER && f && f();
  }, i = t.style, o = t.noStyle, a = t.disabled, s = wSe(t, ["style", "noStyle", "disabled"]), u = {};
  return o || (u = G({}, ESe)), a && (u.pointerEvents = "none"), u = G(G({}, u), i), /* @__PURE__ */ x.createElement("div", G({
    role: "button",
    tabIndex: 0,
    ref: e
  }, s, {
    onKeyDown: n,
    onKeyUp: r,
    style: u
  }));
});
const ISe = SSe;
var _Se = {
  percent: 0,
  prefixCls: "rc-progress",
  strokeColor: "#2db7f5",
  strokeLinecap: "round",
  strokeWidth: 1,
  trailColor: "#D9D9D9",
  trailWidth: 1,
  gapPosition: "bottom"
}, ASe = function() {
  var e = Ee([]), n = Ee(null);
  return Re(function() {
    var r = Date.now(), i = !1;
    e.current.forEach(function(o) {
      if (o) {
        i = !0;
        var a = o.style;
        a.transitionDuration = ".3s, .3s, .3s, .06s", n.current && r - n.current < 100 && (a.transitionDuration = "0s, 0s");
      }
    }), i && (n.current = Date.now());
  }), e.current;
};
process.env.NODE_ENV;
var AR = 0, TSe = process.env.NODE_ENV !== "test" && yu();
function OSe() {
  var t;
  return TSe ? (t = AR, AR += 1) : t = "TEST_OR_SSR", t;
}
const PSe = function(t) {
  var e = x.useState(), n = be(e, 2), r = n[0], i = n[1];
  return x.useEffect(function() {
    i("rc_progress_".concat(OSe()));
  }, []), t || r;
};
var NSe = ["id", "prefixCls", "steps", "strokeWidth", "trailWidth", "gapDegree", "gapPosition", "trailColor", "strokeLinecap", "style", "className", "strokeColor", "percent"];
function TR(t) {
  return +t.replace("%", "");
}
function OR(t) {
  var e = t ?? [];
  return Array.isArray(e) ? e : [e];
}
var Ng = 100, r3 = function(e, n, r, i, o, a, s, u, l, c) {
  var d = arguments.length > 10 && arguments[10] !== void 0 ? arguments[10] : 0, f = r / 100 * 360 * ((360 - a) / 360), h = a === 0 ? 0 : {
    bottom: 0,
    top: 180,
    left: 90,
    right: -90
  }[s], p = (100 - i) / 100 * n;
  return l === "round" && i !== 100 && (p += c / 2, p >= n && (p = n - 0.01)), {
    stroke: typeof u == "string" ? u : void 0,
    strokeDasharray: "".concat(n, "px ").concat(e),
    strokeDashoffset: p + d,
    transform: "rotate(".concat(o + f + h, "deg)"),
    transformOrigin: "0 0",
    transition: "stroke-dashoffset .3s ease 0s, stroke-dasharray .3s ease 0s, stroke .3s, stroke-width .06s ease .3s, opacity .3s ease 0s",
    fillOpacity: 0
  };
}, qU = function(e) {
  var n = de(de({}, _Se), e), r = n.id, i = n.prefixCls, o = n.steps, a = n.strokeWidth, s = n.trailWidth, u = n.gapDegree, l = u === void 0 ? 0 : u, c = n.gapPosition, d = n.trailColor, f = n.strokeLinecap, h = n.style, p = n.className, v = n.strokeColor, m = n.percent, b = Gt(n, NSe), y = PSe(r), w = "".concat(y, "-gradient"), S = Ng / 2 - a / 2, E = Math.PI * 2 * S, I = l > 0 ? 90 + l / 2 : -90, _ = E * ((360 - l) / 360), A = _t(o) === "object" ? o : {
    count: o,
    space: 2
  }, P = A.count, N = A.space, k = r3(E, _, 0, 100, I, l, c, d, f, a), D = OR(m), R = OR(v), V = R.find(function(B) {
    return B && _t(B) === "object";
  }), $ = ASe(), F = function() {
    var X = 0;
    return D.map(function(L, j) {
      var K = R[j] || R[R.length - 1], W = K && _t(K) === "object" ? "url(#".concat(w, ")") : void 0, Y = r3(E, _, X, L, I, l, c, K, f, a);
      return X += L, /* @__PURE__ */ x.createElement("circle", {
        key: j,
        className: "".concat(i, "-circle-path"),
        r: S,
        cx: 0,
        cy: 0,
        stroke: W,
        strokeLinecap: f,
        strokeWidth: a,
        opacity: L === 0 ? 0 : 1,
        style: Y,
        ref: function(Q) {
          $[j] = Q;
        }
      });
    }).reverse();
  }, M = function() {
    var X = Math.round(P * (D[0] / 100)), L = 100 / P, j = 0;
    return new Array(P).fill(null).map(function(K, W) {
      var Y = W <= X - 1 ? R[0] : d, U = Y && _t(Y) === "object" ? "url(#".concat(w, ")") : void 0, Q = r3(E, _, j, L, I, l, c, Y, "butt", a, N);
      return j += (_ - Q.strokeDashoffset + N) * 100 / _, /* @__PURE__ */ x.createElement("circle", {
        key: W,
        className: "".concat(i, "-circle-path"),
        r: S,
        cx: 0,
        cy: 0,
        stroke: U,
        strokeWidth: a,
        opacity: 1,
        style: Q,
        ref: function(ee) {
          $[W] = ee;
        }
      });
    });
  };
  return /* @__PURE__ */ x.createElement("svg", G({
    className: Ce("".concat(i, "-circle"), p),
    viewBox: "".concat(-Ng / 2, " ").concat(-Ng / 2, " ").concat(Ng, " ").concat(Ng),
    style: h,
    id: r,
    role: "presentation"
  }, b), V && /* @__PURE__ */ x.createElement("defs", null, /* @__PURE__ */ x.createElement("linearGradient", {
    id: w,
    x1: "100%",
    y1: "0%",
    x2: "0%",
    y2: "0%"
  }, Object.keys(V).sort(function(B, X) {
    return TR(B) - TR(X);
  }).map(function(B, X) {
    return /* @__PURE__ */ x.createElement("stop", {
      key: X,
      offset: B,
      stopColor: V[B]
    });
  }))), !P && /* @__PURE__ */ x.createElement("circle", {
    className: "".concat(i, "-circle-trail"),
    r: S,
    cx: 0,
    cy: 0,
    stroke: d,
    strokeLinecap: f,
    strokeWidth: s || a,
    style: k
  }), P ? M() : F());
};
process.env.NODE_ENV !== "production" && (qU.displayName = "Circle");
function xd(t) {
  return !t || t < 0 ? 0 : t > 100 ? 100 : t;
}
function _x(t) {
  var e = t.success, n = t.successPercent, r = n;
  return e && "progress" in e && (process.env.NODE_ENV !== "production" && gn(!1, "Progress", "`success.progress` is deprecated. Please use `success.percent` instead."), r = e.progress), e && "percent" in e && (r = e.percent), r;
}
function kSe(t) {
  var e = t.percent, n = t.success, r = t.successPercent, i = xd(_x({
    success: n,
    successPercent: r
  }));
  return [i, xd(xd(e) - i)];
}
function RSe(t) {
  var e = t.success, n = e === void 0 ? {} : e, r = t.strokeColor, i = n.strokeColor;
  return [i || Mh.green, r || null];
}
var $Se = function(e) {
  var n = e.prefixCls, r = e.width, i = e.strokeWidth, o = e.trailColor, a = o === void 0 ? null : o, s = e.strokeLinecap, u = s === void 0 ? "round" : s, l = e.gapPosition, c = e.gapDegree, d = e.type, f = e.children, h = e.success, p = r || 120, v = {
    width: p,
    height: p,
    fontSize: p * 0.15 + 6
  }, m = i || 6, b = l || d === "dashboard" && "bottom" || void 0, y = function() {
    if (c || c === 0)
      return c;
    if (d === "dashboard")
      return 75;
  }, w = Object.prototype.toString.call(e.strokeColor) === "[object Object]", S = RSe({
    success: h,
    strokeColor: e.strokeColor
  }), E = Ce("".concat(n, "-inner"), z({}, "".concat(n, "-circle-gradient"), w));
  return /* @__PURE__ */ x.createElement("div", {
    className: E,
    style: v
  }, /* @__PURE__ */ x.createElement(qU, {
    percent: kSe(e),
    strokeWidth: m,
    trailWidth: m,
    strokeColor: S,
    strokeLinecap: u,
    trailColor: a,
    prefixCls: n,
    gapDegree: y(),
    gapPosition: b
  }), f);
};
const DSe = $Se;
var MSe = function(t, e) {
  var n = {};
  for (var r in t)
    Object.prototype.hasOwnProperty.call(t, r) && e.indexOf(r) < 0 && (n[r] = t[r]);
  if (t != null && typeof Object.getOwnPropertySymbols == "function")
    for (var i = 0, r = Object.getOwnPropertySymbols(t); i < r.length; i++)
      e.indexOf(r[i]) < 0 && Object.prototype.propertyIsEnumerable.call(t, r[i]) && (n[r[i]] = t[r[i]]);
  return n;
}, FSe = function(e) {
  var n = [];
  return Object.keys(e).forEach(function(r) {
    var i = parseFloat(r.replace(/%/g, ""));
    isNaN(i) || n.push({
      key: i,
      value: e[r]
    });
  }), n = n.sort(function(r, i) {
    return r.key - i.key;
  }), n.map(function(r) {
    var i = r.key, o = r.value;
    return "".concat(o, " ").concat(i, "%");
  }).join(", ");
}, LSe = function(e, n) {
  var r = e.from, i = r === void 0 ? Mh.blue : r, o = e.to, a = o === void 0 ? Mh.blue : o, s = e.direction, u = s === void 0 ? n === "rtl" ? "to left" : "to right" : s, l = MSe(e, ["from", "to", "direction"]);
  if (Object.keys(l).length !== 0) {
    var c = FSe(l);
    return {
      backgroundImage: "linear-gradient(".concat(u, ", ").concat(c, ")")
    };
  }
  return {
    backgroundImage: "linear-gradient(".concat(u, ", ").concat(i, ", ").concat(a, ")")
  };
}, VSe = function(e) {
  var n = e.prefixCls, r = e.direction, i = e.percent, o = e.strokeWidth, a = e.size, s = e.strokeColor, u = e.strokeLinecap, l = u === void 0 ? "round" : u, c = e.children, d = e.trailColor, f = d === void 0 ? null : d, h = e.success, p = s && typeof s != "string" ? LSe(s, r) : {
    background: s
  }, v = l === "square" || l === "butt" ? 0 : void 0, m = {
    backgroundColor: f || void 0,
    borderRadius: v
  }, b = G({
    width: "".concat(xd(i), "%"),
    height: o || (a === "small" ? 6 : 8),
    borderRadius: v
  }, p), y = _x(e), w = {
    width: "".concat(xd(y), "%"),
    height: o || (a === "small" ? 6 : 8),
    borderRadius: v,
    backgroundColor: h == null ? void 0 : h.strokeColor
  }, S = y !== void 0 ? /* @__PURE__ */ x.createElement("div", {
    className: "".concat(n, "-success-bg"),
    style: w
  }) : null;
  return /* @__PURE__ */ x.createElement(x.Fragment, null, /* @__PURE__ */ x.createElement("div", {
    className: "".concat(n, "-outer")
  }, /* @__PURE__ */ x.createElement("div", {
    className: "".concat(n, "-inner"),
    style: m
  }, /* @__PURE__ */ x.createElement("div", {
    className: "".concat(n, "-bg"),
    style: b
  }), S)), c);
};
const BSe = VSe;
var HSe = function(e) {
  for (var n = e.size, r = e.steps, i = e.percent, o = i === void 0 ? 0 : i, a = e.strokeWidth, s = a === void 0 ? 8 : a, u = e.strokeColor, l = e.trailColor, c = l === void 0 ? null : l, d = e.prefixCls, f = e.children, h = Math.round(r * (o / 100)), p = n === "small" ? 2 : 14, v = new Array(r), m = 0; m < r; m++) {
    var b = Array.isArray(u) ? u[m] : u;
    v[m] = /* @__PURE__ */ x.createElement("div", {
      key: m,
      className: Ce("".concat(d, "-steps-item"), z({}, "".concat(d, "-steps-item-active"), m <= h - 1)),
      style: {
        backgroundColor: m <= h - 1 ? b : c,
        width: p,
        height: s
      }
    });
  }
  return /* @__PURE__ */ x.createElement("div", {
    className: "".concat(d, "-steps-outer")
  }, v, f);
};
const WSe = HSe;
var jSe = function(t, e) {
  var n = {};
  for (var r in t)
    Object.prototype.hasOwnProperty.call(t, r) && e.indexOf(r) < 0 && (n[r] = t[r]);
  if (t != null && typeof Object.getOwnPropertySymbols == "function")
    for (var i = 0, r = Object.getOwnPropertySymbols(t); i < r.length; i++)
      e.indexOf(r[i]) < 0 && Object.prototype.propertyIsEnumerable.call(t, r[i]) && (n[r[i]] = t[r[i]]);
  return n;
};
Ki("line", "circle", "dashboard");
var zSe = Ki("normal", "exception", "active", "success"), GSe = function(e) {
  var n = e.prefixCls, r = e.className, i = e.steps, o = e.strokeColor, a = e.percent, s = a === void 0 ? 0 : a, u = e.size, l = u === void 0 ? "default" : u, c = e.showInfo, d = c === void 0 ? !0 : c, f = e.type, h = f === void 0 ? "line" : f, p = jSe(e, ["prefixCls", "className", "steps", "strokeColor", "percent", "size", "showInfo", "type"]);
  function v() {
    var D = _x(e);
    return parseInt(D !== void 0 ? D.toString() : s.toString(), 10);
  }
  function m() {
    var D = e.status;
    return !zSe.includes(D) && v() >= 100 ? "success" : D || "normal";
  }
  function b(D, R) {
    var V = e.format, $ = _x(e);
    if (!d)
      return null;
    var F, M = V || function(X) {
      return "".concat(X, "%");
    }, B = h === "line";
    return V || R !== "exception" && R !== "success" ? F = M(xd(s), xd($)) : R === "exception" ? F = B ? /* @__PURE__ */ x.createElement(Sc, null) : /* @__PURE__ */ x.createElement(lC, null) : R === "success" && (F = B ? /* @__PURE__ */ x.createElement(tA, null) : /* @__PURE__ */ x.createElement(GW, null)), /* @__PURE__ */ x.createElement("span", {
      className: "".concat(D, "-text"),
      title: typeof F == "string" ? F : void 0
    }, F);
  }
  var y = x.useContext(en), w = y.getPrefixCls, S = y.direction, E = w("progress", n), I = m(), _ = b(E, I);
  process.env.NODE_ENV !== "production" && gn(!("successPercent" in e), "Progress", "`successPercent` is deprecated. Please use `success.percent` instead.");
  var A = Array.isArray(o) ? o[0] : o, P = typeof o == "string" || Array.isArray(o) ? o : void 0, N;
  h === "line" ? N = i ? /* @__PURE__ */ x.createElement(WSe, G({}, e, {
    strokeColor: P,
    prefixCls: E,
    steps: i
  }), _) : /* @__PURE__ */ x.createElement(BSe, G({}, e, {
    strokeColor: A,
    prefixCls: E,
    direction: S
  }), _) : (h === "circle" || h === "dashboard") && (N = /* @__PURE__ */ x.createElement(DSe, G({}, e, {
    strokeColor: A,
    prefixCls: E,
    progressStatus: I
  }), _));
  var k = Ce(E, z(z(z(z(z({}, "".concat(E, "-").concat(h === "dashboard" && "circle" || i && "steps" || h), !0), "".concat(E, "-status-").concat(I), !0), "".concat(E, "-show-info"), d), "".concat(E, "-").concat(l), l), "".concat(E, "-rtl"), S === "rtl"), r);
  return /* @__PURE__ */ x.createElement("div", G({}, Pi(p, ["status", "format", "trailColor", "strokeWidth", "width", "gapDegree", "gapPosition", "strokeLinecap", "success", "successPercent"]), {
    className: k,
    role: "progressbar"
  }), N);
};
const USe = GSe;
function XSe(t) {
  var e = t.pageXOffset, n = "scrollLeft";
  if (typeof e != "number") {
    var r = t.document;
    e = r.documentElement[n], typeof e != "number" && (e = r.body[n]);
  }
  return e;
}
function YSe(t) {
  var e, n, r = t.ownerDocument, i = r.body, o = r && r.documentElement, a = t.getBoundingClientRect();
  return e = a.left, n = a.top, e -= o.clientLeft || i.clientLeft || 0, n -= o.clientTop || i.clientTop || 0, {
    left: e,
    top: n
  };
}
function ZSe(t) {
  var e = YSe(t), n = t.ownerDocument, r = n.defaultView || n.parentWindow;
  return e.left += XSe(r), e.left;
}
var JSe = /* @__PURE__ */ function(t) {
  Pr(n, t);
  var e = Hr(n);
  function n() {
    var r;
    zn(this, n);
    for (var i = arguments.length, o = new Array(i), a = 0; a < i; a++)
      o[a] = arguments[a];
    return r = e.call.apply(e, [this].concat(o)), r.onHover = function(s) {
      var u = r.props, l = u.onHover, c = u.index;
      l(s, c);
    }, r.onClick = function(s) {
      var u = r.props, l = u.onClick, c = u.index;
      l(s, c);
    }, r.onKeyDown = function(s) {
      var u = r.props, l = u.onClick, c = u.index;
      s.keyCode === 13 && l(s, c);
    }, r;
  }
  return Gn(n, [{
    key: "getClassName",
    value: function() {
      var i = this.props, o = i.prefixCls, a = i.index, s = i.value, u = i.allowHalf, l = i.focused, c = a + 1, d = o;
      return s === 0 && a === 0 && l ? d += " ".concat(o, "-focused") : u && s + 0.5 >= c && s < c ? (d += " ".concat(o, "-half ").concat(o, "-active"), l && (d += " ".concat(o, "-focused"))) : (d += c <= s ? " ".concat(o, "-full") : " ".concat(o, "-zero"), c === s && l && (d += " ".concat(o, "-focused"))), d;
    }
  }, {
    key: "render",
    value: function() {
      var i = this.onHover, o = this.onClick, a = this.onKeyDown, s = this.props, u = s.disabled, l = s.prefixCls, c = s.character, d = s.characterRender, f = s.index, h = s.count, p = s.value, v = typeof c == "function" ? c(this.props) : c, m = /* @__PURE__ */ O.createElement("li", {
        className: this.getClassName()
      }, /* @__PURE__ */ O.createElement("div", {
        onClick: u ? null : o,
        onKeyDown: u ? null : a,
        onMouseMove: u ? null : i,
        role: "radio",
        "aria-checked": p > f ? "true" : "false",
        "aria-posinset": f + 1,
        "aria-setsize": h,
        tabIndex: u ? -1 : 0
      }, /* @__PURE__ */ O.createElement("div", {
        className: "".concat(l, "-first")
      }, v), /* @__PURE__ */ O.createElement("div", {
        className: "".concat(l, "-second")
      }, v)));
      return d && (m = d(m, this.props)), m;
    }
  }]), n;
}(O.Component);
function PR() {
}
var QU = /* @__PURE__ */ function(t) {
  Pr(n, t);
  var e = Hr(n);
  function n(r) {
    var i;
    zn(this, n), i = e.call(this, r), i.stars = void 0, i.rate = void 0, i.onHover = function(a, s) {
      var u = i.props.onHoverChange, l = i.getStarValue(s, a.pageX), c = i.state.cleanedValue;
      l !== c && i.setState({
        hoverValue: l,
        cleanedValue: null
      }), u(l);
    }, i.onMouseLeave = function() {
      var a = i.props.onHoverChange;
      i.setState({
        hoverValue: void 0,
        cleanedValue: null
      }), a(void 0);
    }, i.onClick = function(a, s) {
      var u = i.props.allowClear, l = i.state.value, c = i.getStarValue(s, a.pageX), d = !1;
      u && (d = c === l), i.onMouseLeave(), i.changeValue(d ? 0 : c), i.setState({
        cleanedValue: d ? c : null
      });
    }, i.onFocus = function() {
      var a = i.props.onFocus;
      i.setState({
        focused: !0
      }), a && a();
    }, i.onBlur = function() {
      var a = i.props.onBlur;
      i.setState({
        focused: !1
      }), a && a();
    }, i.onKeyDown = function(a) {
      var s = a.keyCode, u = i.props, l = u.count, c = u.allowHalf, d = u.onKeyDown, f = u.direction, h = f === "rtl", p = i.state.value;
      s === ke.RIGHT && p < l && !h ? (c ? p += 0.5 : p += 1, i.changeValue(p), a.preventDefault()) : s === ke.LEFT && p > 0 && !h || s === ke.RIGHT && p > 0 && h ? (c ? p -= 0.5 : p -= 1, i.changeValue(p), a.preventDefault()) : s === ke.LEFT && p < l && h && (c ? p += 0.5 : p += 1, i.changeValue(p), a.preventDefault()), d && d(a);
    }, i.saveRef = function(a) {
      return function(s) {
        i.stars[a] = s;
      };
    }, i.saveRate = function(a) {
      i.rate = a;
    };
    var o = r.value;
    return o === void 0 && (o = r.defaultValue), i.stars = {}, i.state = {
      value: o,
      focused: !1,
      cleanedValue: null
    }, i;
  }
  return Gn(n, [{
    key: "componentDidMount",
    value: function() {
      var i = this.props, o = i.autoFocus, a = i.disabled;
      o && !a && this.focus();
    }
  }, {
    key: "getStarDOM",
    value: function(i) {
      return md(this.stars[i]);
    }
  }, {
    key: "getStarValue",
    value: function(i, o) {
      var a = this.props, s = a.allowHalf, u = a.direction, l = u === "rtl", c = i + 1;
      if (s) {
        var d = this.getStarDOM(i), f = ZSe(d), h = d.clientWidth;
        (l && o - f > h / 2 || !l && o - f < h / 2) && (c -= 0.5);
      }
      return c;
    }
  }, {
    key: "focus",
    value: function() {
      var i = this.props.disabled;
      i || this.rate.focus();
    }
  }, {
    key: "blur",
    value: function() {
      var i = this.props.disabled;
      i || this.rate.blur();
    }
  }, {
    key: "changeValue",
    value: function(i) {
      var o = this.props.onChange;
      "value" in this.props || this.setState({
        value: i
      }), o(i);
    }
  }, {
    key: "render",
    value: function() {
      for (var i = this.props, o = i.count, a = i.allowHalf, s = i.style, u = i.id, l = i.prefixCls, c = i.disabled, d = i.className, f = i.character, h = i.characterRender, p = i.tabIndex, v = i.direction, m = this.state, b = m.value, y = m.hoverValue, w = m.focused, S = [], E = c ? "".concat(l, "-disabled") : "", I = 0; I < o; I += 1)
        S.push(/* @__PURE__ */ O.createElement(JSe, {
          ref: this.saveRef(I),
          index: I,
          count: o,
          disabled: c,
          prefixCls: "".concat(l, "-star"),
          allowHalf: a,
          value: y === void 0 ? b : y,
          onClick: this.onClick,
          onHover: this.onHover,
          key: I,
          character: f,
          characterRender: h,
          focused: w
        }));
      var _ = Ce(l, E, d, z({}, "".concat(l, "-rtl"), v === "rtl"));
      return /* @__PURE__ */ O.createElement("ul", {
        className: _,
        style: s,
        id: u,
        onMouseLeave: c ? null : this.onMouseLeave,
        tabIndex: c ? -1 : p,
        onFocus: c ? null : this.onFocus,
        onBlur: c ? null : this.onBlur,
        onKeyDown: c ? null : this.onKeyDown,
        ref: this.saveRate,
        role: "radiogroup"
      }, S);
    }
  }], [{
    key: "getDerivedStateFromProps",
    value: function(i, o) {
      return "value" in i && i.value !== void 0 ? de(de({}, o), {}, {
        value: i.value
      }) : o;
    }
  }]), n;
}(O.Component);
QU.defaultProps = {
  defaultValue: 0,
  count: 5,
  allowHalf: !1,
  allowClear: !0,
  style: {},
  prefixCls: "rc-rate",
  onChange: PR,
  character: "★",
  onHoverChange: PR,
  tabIndex: 0,
  direction: "ltr"
};
var KSe = function(t, e) {
  var n = {};
  for (var r in t)
    Object.prototype.hasOwnProperty.call(t, r) && e.indexOf(r) < 0 && (n[r] = t[r]);
  if (t != null && typeof Object.getOwnPropertySymbols == "function")
    for (var i = 0, r = Object.getOwnPropertySymbols(t); i < r.length; i++)
      e.indexOf(r[i]) < 0 && Object.prototype.propertyIsEnumerable.call(t, r[i]) && (n[r[i]] = t[r[i]]);
  return n;
}, eX = /* @__PURE__ */ x.forwardRef(function(t, e) {
  var n = t.prefixCls, r = t.tooltips, i = t.character, o = i === void 0 ? /* @__PURE__ */ x.createElement(y0e, null) : i, a = KSe(t, ["prefixCls", "tooltips", "character"]), s = function(h, p) {
    var v = p.index;
    return r ? /* @__PURE__ */ x.createElement(Ud, {
      title: r[v]
    }, h) : h;
  }, u = x.useContext(en), l = u.getPrefixCls, c = u.direction, d = l("rate", n);
  return /* @__PURE__ */ x.createElement(QU, G({
    ref: e,
    character: o,
    characterRender: s
  }, a, {
    prefixCls: d,
    direction: c
  }));
});
process.env.NODE_ENV !== "production" && (eX.displayName = "Rate");
const qSe = eX;
var Yd = /* @__PURE__ */ x.createContext({
  min: 0,
  max: 0,
  direction: "ltr",
  step: 1,
  includedStart: 0,
  includedEnd: 0,
  tabIndex: 0
});
function p_(t, e, n) {
  return (t - e) / (n - e);
}
function YA(t, e, n, r) {
  var i = p_(e, n, r), o = {};
  switch (t) {
    case "rtl":
      o.right = "".concat(i * 100, "%"), o.transform = "translateX(50%)";
      break;
    case "btt":
      o.bottom = "".concat(i * 100, "%"), o.transform = "translateY(50%)";
      break;
    case "ttb":
      o.top = "".concat(i * 100, "%"), o.transform = "translateY(-50%)";
      break;
    default:
      o.left = "".concat(i * 100, "%"), o.transform = "translateX(-50%)";
      break;
  }
  return o;
}
function Ah(t, e) {
  return Array.isArray(t) ? t[e] : t;
}
var QSe = ["prefixCls", "value", "valueIndex", "onStartMove", "style", "render", "dragging", "onOffsetChange"], tX = /* @__PURE__ */ x.forwardRef(function(t, e) {
  var n, r, i = t.prefixCls, o = t.value, a = t.valueIndex, s = t.onStartMove, u = t.style, l = t.render, c = t.dragging, d = t.onOffsetChange, f = Gt(t, QSe), h = x.useContext(Yd), p = h.min, v = h.max, m = h.direction, b = h.disabled, y = h.range, w = h.tabIndex, S = h.ariaLabelForHandle, E = h.ariaLabelledByForHandle, I = h.ariaValueTextFormatterForHandle, _ = "".concat(i, "-handle"), A = function(R) {
    b || s(R, a);
  }, P = function(R) {
    if (!b) {
      var V = null;
      switch (R.which || R.keyCode) {
        case ke.LEFT:
          V = m === "ltr" || m === "btt" ? -1 : 1;
          break;
        case ke.RIGHT:
          V = m === "ltr" || m === "btt" ? 1 : -1;
          break;
        case ke.UP:
          V = m !== "ttb" ? 1 : -1;
          break;
        case ke.DOWN:
          V = m !== "ttb" ? -1 : 1;
          break;
        case ke.HOME:
          V = "min";
          break;
        case ke.END:
          V = "max";
          break;
        case ke.PAGE_UP:
          V = 2;
          break;
        case ke.PAGE_DOWN:
          V = -2;
          break;
      }
      V !== null && (R.preventDefault(), d(V, a));
    }
  }, N = YA(m, o, p, v), k = /* @__PURE__ */ x.createElement("div", G({
    ref: e,
    className: Ce(_, (n = {}, z(n, "".concat(_, "-").concat(a + 1), y), z(n, "".concat(_, "-dragging"), c), n)),
    style: de(de({}, N), u),
    onMouseDown: A,
    onTouchStart: A,
    onKeyDown: P,
    tabIndex: b ? null : Ah(w, a),
    role: "slider",
    "aria-valuemin": p,
    "aria-valuemax": v,
    "aria-valuenow": o,
    "aria-disabled": b,
    "aria-label": Ah(S, a),
    "aria-labelledby": Ah(E, a),
    "aria-valuetext": (r = Ah(I, a)) === null || r === void 0 ? void 0 : r(o)
  }, f));
  return l && (k = l(k, {
    index: a,
    prefixCls: i,
    value: o,
    dragging: c
  })), k;
});
process.env.NODE_ENV !== "production" && (tX.displayName = "Handle");
var e3e = ["prefixCls", "style", "onStartMove", "onOffsetChange", "values", "handleRender", "draggingIndex"], nX = /* @__PURE__ */ x.forwardRef(function(t, e) {
  var n = t.prefixCls, r = t.style, i = t.onStartMove, o = t.onOffsetChange, a = t.values, s = t.handleRender, u = t.draggingIndex, l = Gt(t, e3e), c = x.useRef({});
  return x.useImperativeHandle(e, function() {
    return {
      focus: function(f) {
        var h;
        (h = c.current[f]) === null || h === void 0 || h.focus();
      }
    };
  }), /* @__PURE__ */ x.createElement(x.Fragment, null, a.map(function(d, f) {
    return /* @__PURE__ */ x.createElement(tX, G({
      ref: function(p) {
        p ? c.current[f] = p : delete c.current[f];
      },
      dragging: u === f,
      prefixCls: n,
      style: Ah(r, f),
      key: f,
      value: d,
      valueIndex: f,
      onStartMove: i,
      onOffsetChange: o,
      render: s
    }, l));
  }));
});
process.env.NODE_ENV !== "production" && (nX.displayName = "Handles");
function NR(t) {
  var e = "touches" in t ? t.touches[0] : t;
  return {
    pageX: e.pageX,
    pageY: e.pageY
  };
}
function t3e(t, e, n, r, i, o, a, s, u) {
  var l = x.useState(null), c = be(l, 2), d = c[0], f = c[1], h = x.useState(-1), p = be(h, 2), v = p[0], m = p[1], b = x.useState(n), y = be(b, 2), w = y[0], S = y[1], E = x.useState(n), I = be(E, 2), _ = I[0], A = I[1], P = x.useRef(null), N = x.useRef(null);
  x.useEffect(function() {
    v === -1 && S(n);
  }, [n, v]), x.useEffect(function() {
    return function() {
      document.removeEventListener("mousemove", P.current), document.removeEventListener("mouseup", N.current), document.removeEventListener("touchmove", P.current), document.removeEventListener("touchend", N.current);
    };
  }, []);
  var k = function(M, B) {
    w.some(function(X, L) {
      return X !== M[L];
    }) && (B !== void 0 && f(B), S(M), a(M));
  }, D = function(M, B) {
    if (M === -1) {
      var X = _[0], L = _[_.length - 1], j = r - X, K = i - L, W = B * (i - r);
      W = Math.max(W, j), W = Math.min(W, K);
      var Y = o(X + W);
      W = Y - X;
      var U = _.map(function(ie) {
        return ie + W;
      });
      k(U);
    } else {
      var Q = (i - r) * B, Z = Ye(w);
      Z[M] = _[M];
      var ee = u(Z, Q, M, "dist");
      k(ee.values, ee.value);
    }
  }, R = x.useRef(D);
  R.current = D;
  var V = function(M, B) {
    M.stopPropagation();
    var X = n[B];
    m(B), f(X), A(n);
    var L = NR(M), j = L.pageX, K = L.pageY, W = function(Q) {
      Q.preventDefault();
      var Z = NR(Q), ee = Z.pageX, ie = Z.pageY, oe = ee - j, se = ie - K, te = t.current.getBoundingClientRect(), ge = te.width, he = te.height, fe;
      switch (e) {
        case "btt":
          fe = -se / he;
          break;
        case "ttb":
          fe = se / he;
          break;
        case "rtl":
          fe = -oe / ge;
          break;
        default:
          fe = oe / ge;
      }
      R.current(B, fe);
    }, Y = function U(Q) {
      Q.preventDefault(), document.removeEventListener("mouseup", U), document.removeEventListener("mousemove", W), document.removeEventListener("touchend", U), document.removeEventListener("touchmove", W), P.current = null, N.current = null, m(-1), s();
    };
    document.addEventListener("mouseup", Y), document.addEventListener("mousemove", W), document.addEventListener("touchend", Y), document.addEventListener("touchmove", W), P.current = W, N.current = Y;
  }, $ = x.useMemo(function() {
    var F = Ye(n).sort(function(B, X) {
      return B - X;
    }), M = Ye(w).sort(function(B, X) {
      return B - X;
    });
    return F.every(function(B, X) {
      return B === M[X];
    }) ? w : n;
  }, [n, w]);
  return [v, d, $, V];
}
function n3e(t) {
  var e = t.prefixCls, n = t.style, r = t.start, i = t.end, o = t.index, a = t.onStartMove, s = x.useContext(Yd), u = s.direction, l = s.min, c = s.max, d = s.disabled, f = s.range, h = "".concat(e, "-track"), p = p_(r, l, c), v = p_(i, l, c), m = function(w) {
    !d && a && a(w, -1);
  }, b = {};
  switch (u) {
    case "rtl":
      b.right = "".concat(p * 100, "%"), b.width = "".concat(v * 100 - p * 100, "%");
      break;
    case "btt":
      b.bottom = "".concat(p * 100, "%"), b.height = "".concat(v * 100 - p * 100, "%");
      break;
    case "ttb":
      b.top = "".concat(p * 100, "%"), b.height = "".concat(v * 100 - p * 100, "%");
      break;
    default:
      b.left = "".concat(p * 100, "%"), b.width = "".concat(v * 100 - p * 100, "%");
  }
  return /* @__PURE__ */ x.createElement("div", {
    className: Ce(h, f && "".concat(h, "-").concat(o + 1)),
    style: de(de({}, b), n),
    onMouseDown: m,
    onTouchStart: m
  });
}
function r3e(t) {
  var e = t.prefixCls, n = t.style, r = t.values, i = t.startPoint, o = t.onStartMove, a = x.useContext(Yd), s = a.included, u = a.range, l = a.min, c = x.useMemo(function() {
    if (!u) {
      if (r.length === 0)
        return [];
      var d = i ?? l, f = r[0];
      return [{
        start: Math.min(d, f),
        end: Math.max(d, f)
      }];
    }
    for (var h = [], p = 0; p < r.length - 1; p += 1)
      h.push({
        start: r[p],
        end: r[p + 1]
      });
    return h;
  }, [r, u, i, l]);
  return s ? c.map(function(d, f) {
    var h = d.start, p = d.end;
    return /* @__PURE__ */ x.createElement(n3e, {
      index: f,
      prefixCls: e,
      style: Ah(n, f),
      start: h,
      end: p,
      key: f,
      onStartMove: o
    });
  }) : null;
}
function i3e(t) {
  var e = t.prefixCls, n = t.style, r = t.children, i = t.value, o = t.onClick, a = x.useContext(Yd), s = a.min, u = a.max, l = a.direction, c = a.includedStart, d = a.includedEnd, f = a.included, h = "".concat(e, "-text"), p = YA(l, i, s, u);
  return /* @__PURE__ */ x.createElement("span", {
    className: Ce(h, z({}, "".concat(h, "-active"), f && c <= i && i <= d)),
    style: de(de({}, p), n),
    onMouseDown: function(m) {
      m.stopPropagation();
    },
    onClick: function() {
      o(i);
    }
  }, r);
}
function o3e(t) {
  var e = t.prefixCls, n = t.marks, r = t.onClick, i = "".concat(e, "-mark");
  return n.length ? /* @__PURE__ */ x.createElement("div", {
    className: i
  }, n.map(function(o) {
    var a = o.value, s = o.style, u = o.label;
    return /* @__PURE__ */ x.createElement(i3e, {
      key: a,
      prefixCls: i,
      style: s,
      value: a,
      onClick: r
    }, u);
  })) : null;
}
function a3e(t) {
  var e = t.prefixCls, n = t.value, r = t.style, i = t.activeStyle, o = x.useContext(Yd), a = o.min, s = o.max, u = o.direction, l = o.included, c = o.includedStart, d = o.includedEnd, f = "".concat(e, "-dot"), h = l && c <= n && n <= d, p = de(de({}, YA(u, n, a, s)), typeof r == "function" ? r(n) : r);
  return h && (p = de(de({}, p), typeof i == "function" ? i(n) : i)), /* @__PURE__ */ x.createElement("span", {
    className: Ce(f, z({}, "".concat(f, "-active"), h)),
    style: p
  });
}
function s3e(t) {
  var e = t.prefixCls, n = t.marks, r = t.dots, i = t.style, o = t.activeStyle, a = x.useContext(Yd), s = a.min, u = a.max, l = a.step, c = x.useMemo(function() {
    var d = /* @__PURE__ */ new Set();
    if (n.forEach(function(h) {
      d.add(h.value);
    }), r && l !== null)
      for (var f = s; f <= u; )
        d.add(f), f += l;
    return Array.from(d);
  }, [s, u, l, r, n]);
  return /* @__PURE__ */ x.createElement("div", {
    className: "".concat(e, "-step")
  }, c.map(function(d) {
    return /* @__PURE__ */ x.createElement(a3e, {
      prefixCls: e,
      key: d,
      value: d,
      style: i,
      activeStyle: o
    });
  }));
}
function u3e(t, e, n, r, i, o) {
  var a = x.useCallback(function(h) {
    var p = isFinite(h) ? h : t;
    return p = Math.min(e, h), p = Math.max(t, p), p;
  }, [t, e]), s = x.useCallback(function(h) {
    if (n !== null) {
      var p = t + Math.round((a(h) - t) / n) * n, v = function(w) {
        return (String(w).split(".")[1] || "").length;
      }, m = Math.max(v(n), v(e), v(t)), b = Number(p.toFixed(m));
      return t <= b && b <= e ? b : null;
    }
    return null;
  }, [n, t, e, a]), u = x.useCallback(function(h) {
    var p = a(h), v = r.map(function(y) {
      return y.value;
    });
    n !== null && v.push(s(h)), v.push(t, e);
    var m = v[0], b = e - t;
    return v.forEach(function(y) {
      var w = Math.abs(p - y);
      w <= b && (m = y, b = w);
    }), m;
  }, [t, e, r, n, a, s]), l = function h(p, v, m) {
    var b = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : "unit";
    if (typeof v == "number") {
      var y, w = p[m], S = w + v, E = [];
      r.forEach(function(N) {
        E.push(N.value);
      }), E.push(t, e), E.push(s(w));
      var I = v > 0 ? 1 : -1;
      b === "unit" ? E.push(s(w + I * n)) : E.push(s(S)), E = E.filter(function(N) {
        return N !== null;
      }).filter(function(N) {
        return v < 0 ? N <= w : N >= w;
      }), b === "unit" && (E = E.filter(function(N) {
        return N !== w;
      }));
      var _ = b === "unit" ? w : S;
      y = E[0];
      var A = Math.abs(y - _);
      if (E.forEach(function(N) {
        var k = Math.abs(N - _);
        k < A && (y = N, A = k);
      }), y === void 0)
        return v < 0 ? t : e;
      if (b === "dist")
        return y;
      if (Math.abs(v) > 1) {
        var P = Ye(p);
        return P[m] = y, h(P, v - I, m, b);
      }
      return y;
    } else {
      if (v === "min")
        return t;
      if (v === "max")
        return e;
    }
  }, c = function(p, v, m) {
    var b = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : "unit", y = p[m], w = l(p, v, m, b);
    return {
      value: w,
      changed: w !== y
    };
  }, d = function(p) {
    return o === null && p === 0 || typeof o == "number" && p < o;
  }, f = function(p, v, m) {
    var b = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : "unit", y = p.map(u), w = y[m], S = l(y, v, m, b);
    if (y[m] = S, i === !1) {
      var E = o || 0;
      m > 0 && y[m - 1] !== w && (y[m] = Math.max(y[m], y[m - 1] + E)), m < y.length - 1 && y[m + 1] !== w && (y[m] = Math.min(y[m], y[m + 1] - E));
    } else if (typeof o == "number" || o === null) {
      for (var I = m + 1; I < y.length; I += 1)
        for (var _ = !0; d(y[I] - y[I - 1]) && _; ) {
          var A = c(y, 1, I);
          y[I] = A.value, _ = A.changed;
        }
      for (var P = m; P > 0; P -= 1)
        for (var N = !0; d(y[P] - y[P - 1]) && N; ) {
          var k = c(y, -1, P - 1);
          y[P - 1] = k.value, N = k.changed;
        }
      for (var D = y.length - 1; D > 0; D -= 1)
        for (var R = !0; d(y[D] - y[D - 1]) && R; ) {
          var V = c(y, -1, D - 1);
          y[D - 1] = V.value, R = V.changed;
        }
      for (var $ = 0; $ < y.length - 1; $ += 1)
        for (var F = !0; d(y[$ + 1] - y[$]) && F; ) {
          var M = c(y, 1, $ + 1);
          y[$ + 1] = M.value, F = M.changed;
        }
    }
    return {
      value: y[m],
      values: y
    };
  };
  return [u, f];
}
var rX = /* @__PURE__ */ x.forwardRef(function(t, e) {
  var n, r = t.prefixCls, i = r === void 0 ? "rc-slider" : r, o = t.className, a = t.style, s = t.disabled, u = s === void 0 ? !1 : s, l = t.autoFocus, c = t.onFocus, d = t.onBlur, f = t.min, h = f === void 0 ? 0 : f, p = t.max, v = p === void 0 ? 100 : p, m = t.step, b = m === void 0 ? 1 : m, y = t.value, w = t.defaultValue, S = t.range, E = t.count, I = t.onChange, _ = t.onBeforeChange, A = t.onAfterChange, P = t.allowCross, N = P === void 0 ? !0 : P, k = t.pushable, D = k === void 0 ? !1 : k, R = t.draggableTrack, V = t.reverse, $ = t.vertical, F = t.included, M = F === void 0 ? !0 : F, B = t.startPoint, X = t.trackStyle, L = t.handleStyle, j = t.railStyle, K = t.dotStyle, W = t.activeDotStyle, Y = t.marks, U = t.dots, Q = t.handleRender, Z = t.tabIndex, ee = Z === void 0 ? 0 : Z, ie = t.ariaLabelForHandle, oe = t.ariaLabelledByForHandle, se = t.ariaValueTextFormatterForHandle, te = x.useRef(), ge = x.useRef(), he = x.useMemo(function() {
    return $ ? V ? "ttb" : "btt" : V ? "rtl" : "ltr";
  }, [V, $]), fe = x.useMemo(function() {
    return isFinite(h) ? h : 0;
  }, [h]), _e = x.useMemo(function() {
    return isFinite(v) ? v : 100;
  }, [v]), Ne = x.useMemo(function() {
    return b !== null && b <= 0 ? 1 : b;
  }, [b]), ze = x.useMemo(function() {
    return D === !0 ? Ne : D >= 0 ? D : !1;
  }, [D, Ne]), Ve = x.useMemo(function() {
    var nn = Object.keys(Y || {});
    return nn.map(function(Nt) {
      var ue = Y[Nt], $e = {
        value: Number(Nt)
      };
      return ue && _t(ue) === "object" && !/* @__PURE__ */ x.isValidElement(ue) && ("label" in ue || "style" in ue) ? ($e.style = ue.style, $e.label = ue.label) : $e.label = ue, $e;
    }).filter(function(Nt) {
      var ue = Nt.label;
      return ue || typeof ue == "number";
    }).sort(function(Nt, ue) {
      return Nt.value - ue.value;
    });
  }, [Y]), ne = u3e(fe, _e, Ne, Ve, N, ze), pe = be(ne, 2), ye = pe[0], Ae = pe[1], we = Tr(w, {
    value: y
  }), ce = be(we, 2), ve = ce[0], Ie = ce[1], q = x.useMemo(function() {
    var nn = ve == null ? [] : Array.isArray(ve) ? ve : [ve], Nt = be(nn, 1), ue = Nt[0], $e = ue === void 0 ? fe : ue, je = ve === null ? [] : [$e];
    if (S) {
      if (je = Ye(nn), E || ve === void 0) {
        var At = E >= 0 ? E + 1 : 2;
        for (je = je.slice(0, At); je.length < At; ) {
          var $t;
          je.push(($t = je[je.length - 1]) !== null && $t !== void 0 ? $t : fe);
        }
      }
      je.sort(function(qe, nt) {
        return qe - nt;
      });
    }
    return je.forEach(function(qe, nt) {
      je[nt] = ye(qe);
    }), je;
  }, [ve, S, fe, E, ye]), Fe = x.useRef(q);
  Fe.current = q;
  var Ze = function(Nt) {
    return S ? Nt : Nt[0];
  }, at = function(Nt) {
    var ue = Ye(Nt).sort(function($e, je) {
      return $e - je;
    });
    I && !Swe(ue, Fe.current) && I(Ze(ue)), Ie(ue);
  }, Je = function(Nt) {
    if (!u) {
      var ue = 0, $e = _e - fe;
      q.forEach(function(At, $t) {
        var qe = Math.abs(Nt - At);
        qe <= $e && ($e = qe, ue = $t);
      });
      var je = Ye(q);
      je[ue] = Nt, S && !q.length && E === void 0 && je.push(Nt), _ == null || _(Ze(je)), at(je), A == null || A(Ze(je));
    }
  }, ut = function(Nt) {
    Nt.preventDefault();
    var ue = ge.current.getBoundingClientRect(), $e = ue.width, je = ue.height, At = ue.left, $t = ue.top, qe = ue.bottom, nt = ue.right, dt = Nt.clientX, rn = Nt.clientY, on;
    switch (he) {
      case "btt":
        on = (qe - rn) / je;
        break;
      case "ttb":
        on = (rn - $t) / je;
        break;
      case "rtl":
        on = (nt - dt) / $e;
        break;
      default:
        on = (dt - At) / $e;
    }
    var Rt = fe + on * (_e - fe);
    Je(ye(Rt));
  }, Ct = x.useState(null), Ke = be(Ct, 2), st = Ke[0], wt = Ke[1], qt = function(Nt, ue) {
    if (!u) {
      var $e = Ae(q, Nt, ue);
      _ == null || _(Ze(q)), at($e.values), A == null || A(Ze($e.values)), wt($e.value);
    }
  };
  x.useEffect(function() {
    if (st !== null) {
      var nn = q.indexOf(st);
      nn >= 0 && te.current.focus(nn);
    }
    wt(null);
  }, [st]);
  var bt = x.useMemo(function() {
    return R && Ne === null ? (process.env.NODE_ENV !== "production" && Wt(!1, "`draggableTrack` is not supported when `step` is `null`."), !1) : R;
  }, [R, Ne]), Me = function() {
    A == null || A(Ze(Fe.current));
  }, yt = t3e(ge, he, q, fe, _e, ye, at, Me, Ae), ct = be(yt, 4), kt = ct[0], Vt = ct[1], Vn = ct[2], tn = ct[3], Xe = function(Nt, ue) {
    tn(Nt, ue), _ == null || _(Ze(Fe.current));
  }, tt = kt !== -1;
  x.useEffect(function() {
    if (!tt) {
      var nn = q.lastIndexOf(Vt);
      te.current.focus(nn);
    }
  }, [tt]);
  var ot = x.useMemo(function() {
    return Ye(Vn).sort(function(nn, Nt) {
      return nn - Nt;
    });
  }, [Vn]), lt = x.useMemo(function() {
    return S ? [ot[0], ot[ot.length - 1]] : [fe, ot[0]];
  }, [ot, S, fe]), He = be(lt, 2), mt = He[0], Qt = He[1];
  x.useImperativeHandle(e, function() {
    return {
      focus: function() {
        te.current.focus(0);
      },
      blur: function() {
        var Nt = document, ue = Nt.activeElement;
        ge.current.contains(ue) && (ue == null || ue.blur());
      }
    };
  }), x.useEffect(function() {
    l && te.current.focus(0);
  }, []);
  var Yt = x.useMemo(function() {
    return {
      min: fe,
      max: _e,
      direction: he,
      disabled: u,
      step: Ne,
      included: M,
      includedStart: mt,
      includedEnd: Qt,
      range: S,
      tabIndex: ee,
      ariaLabelForHandle: ie,
      ariaLabelledByForHandle: oe,
      ariaValueTextFormatterForHandle: se
    };
  }, [fe, _e, he, u, Ne, M, mt, Qt, S, ee, ie, oe, se]);
  return /* @__PURE__ */ x.createElement(Yd.Provider, {
    value: Yt
  }, /* @__PURE__ */ x.createElement("div", {
    ref: ge,
    className: Ce(i, o, (n = {}, z(n, "".concat(i, "-disabled"), u), z(n, "".concat(i, "-vertical"), $), z(n, "".concat(i, "-horizontal"), !$), z(n, "".concat(i, "-with-marks"), Ve.length), n)),
    style: a,
    onMouseDown: ut
  }, /* @__PURE__ */ x.createElement("div", {
    className: "".concat(i, "-rail"),
    style: j
  }), /* @__PURE__ */ x.createElement(r3e, {
    prefixCls: i,
    style: X,
    values: ot,
    startPoint: B,
    onStartMove: bt ? Xe : null
  }), /* @__PURE__ */ x.createElement(s3e, {
    prefixCls: i,
    marks: Ve,
    dots: U,
    style: K,
    activeStyle: W
  }), /* @__PURE__ */ x.createElement(nX, {
    ref: te,
    prefixCls: i,
    style: L,
    values: Vn,
    draggingIndex: kt,
    onStartMove: Xe,
    onOffsetChange: qt,
    onFocus: c,
    onBlur: d,
    handleRender: Q
  }), /* @__PURE__ */ x.createElement(o3e, {
    prefixCls: i,
    marks: Ve,
    onClick: Je
  })));
});
process.env.NODE_ENV !== "production" && (rX.displayName = "Slider");
var l3e = /* @__PURE__ */ x.forwardRef(function(t, e) {
  var n = t.open, r = Ee(null), i = Ee(null);
  function o() {
    En.cancel(i.current), i.current = null;
  }
  function a() {
    i.current = En(function() {
      var s;
      (s = r.current) === null || s === void 0 || s.forcePopupAlign(), i.current = null;
    });
  }
  return x.useEffect(function() {
    return n ? a() : o(), o;
  }, [n, t.title]), /* @__PURE__ */ x.createElement(Ud, G({
    ref: Ja(r, e)
  }, t));
});
const c3e = l3e;
var d3e = function(t, e) {
  var n = {};
  for (var r in t)
    Object.prototype.hasOwnProperty.call(t, r) && e.indexOf(r) < 0 && (n[r] = t[r]);
  if (t != null && typeof Object.getOwnPropertySymbols == "function")
    for (var i = 0, r = Object.getOwnPropertySymbols(t); i < r.length; i++)
      e.indexOf(r[i]) < 0 && Object.prototype.propertyIsEnumerable.call(t, r[i]) && (n[r[i]] = t[r[i]]);
  return n;
}, iX = /* @__PURE__ */ x.forwardRef(function(t, e) {
  var n = x.useContext(en), r = n.getPrefixCls, i = n.direction, o = n.getPopupContainer, a = x.useState({}), s = be(a, 2), u = s[0], l = s[1], c = function(A, P) {
    l(function(N) {
      return G(G({}, N), z({}, A, P));
    });
  }, d = function(A, P) {
    return A || (P ? i === "rtl" ? "left" : "right" : "top");
  }, f = t.prefixCls, h = t.range, p = t.className, v = d3e(t, ["prefixCls", "range", "className"]), m = r("slider", f), b = Ce(p, z({}, "".concat(m, "-rtl"), i === "rtl"));
  i === "rtl" && !v.vertical && (v.reverse = !v.reverse);
  var y = x.useMemo(function() {
    return h ? _t(h) === "object" ? [!0, h.draggableTrack] : [!0, !1] : [!1];
  }, [h]), w = be(y, 2), S = w[0], E = w[1];
  process.env.NODE_ENV !== "production" && [["tooltipPrefixCls", "prefixCls"], ["getTooltipPopupContainer", "getPopupContainer"], ["tipFormatter", "formatter"], ["tooltipPlacement", "placement"], ["tooltipVisible", "open"]].forEach(function(_) {
    var A = be(_, 2), P = A[0], N = A[1];
    process.env.NODE_ENV !== "production" && gn(!(P in t), "Slider", "`".concat(P, "` is deprecated which will be removed in next major version, please use `tooltip.").concat(N, "` instead."));
  });
  var I = function(A, P) {
    var N, k = P.index, D = P.dragging, R = r(), V = t.tooltip, $ = V === void 0 ? {} : V, F = t.vertical, M = G({
      formatter: (N = t.tipFormatter) !== null && N !== void 0 ? N : (
        // eslint-disable-next-line func-names
        function(Z) {
          return typeof Z == "number" ? Z.toString() : "";
        }
      ),
      open: t.tooltipVisible,
      placement: t.tooltipPlacement,
      getPopupContainer: t.getTooltipPopupContainer
    }, $), B = M.open, X = M.placement, L = M.getPopupContainer, j = M.prefixCls, K = M.formatter, W = K ? u[k] || D : !1, Y = B || B === void 0 && W, U = G(G({}, A.props), {
      onMouseEnter: function() {
        return c(k, !0);
      },
      onMouseLeave: function() {
        return c(k, !1);
      }
    }), Q = r("tooltip", j);
    return /* @__PURE__ */ x.createElement(c3e, {
      prefixCls: Q,
      title: K ? K(P.value) : "",
      open: Y,
      placement: d(X, F),
      transitionName: "".concat(R, "-zoom-down"),
      key: k,
      overlayClassName: "".concat(m, "-tooltip"),
      getPopupContainer: L || o
    }, /* @__PURE__ */ x.cloneElement(A, U));
  };
  return /* @__PURE__ */ x.createElement(rX, G({}, v, {
    step: v.step,
    range: S,
    draggableTrack: E,
    className: b,
    ref: e,
    prefixCls: m,
    handleRender: I
  }));
});
process.env.NODE_ENV !== "production" && (iX.displayName = "Slider");
const f3e = iX;
var oX = x.forwardRef(function(t, e) {
  var n, r = t.prefixCls, i = r === void 0 ? "rc-switch" : r, o = t.className, a = t.checked, s = t.defaultChecked, u = t.disabled, l = t.loadingIcon, c = t.checkedChildren, d = t.unCheckedChildren, f = t.onClick, h = t.onChange, p = t.onKeyDown, v = Gt(t, ["prefixCls", "className", "checked", "defaultChecked", "disabled", "loadingIcon", "checkedChildren", "unCheckedChildren", "onClick", "onChange", "onKeyDown"]), m = Tr(!1, {
    value: a,
    defaultValue: s
  }), b = be(m, 2), y = b[0], w = b[1];
  function S(A, P) {
    var N = y;
    return u || (N = A, w(N), h == null || h(N, P)), N;
  }
  function E(A) {
    A.which === ke.LEFT ? S(!1, A) : A.which === ke.RIGHT && S(!0, A), p == null || p(A);
  }
  function I(A) {
    var P = S(!y, A);
    f == null || f(P, A);
  }
  var _ = Ce(i, o, (n = {}, z(n, "".concat(i, "-checked"), y), z(n, "".concat(i, "-disabled"), u), n));
  return x.createElement("button", Object.assign({}, v, {
    type: "button",
    role: "switch",
    "aria-checked": y,
    disabled: u,
    className: _,
    ref: e,
    onKeyDown: E,
    onClick: I
  }), l, x.createElement("span", {
    className: "".concat(i, "-inner")
  }, y ? c : d));
});
oX.displayName = "Switch";
var h3e = function(t, e) {
  var n = {};
  for (var r in t)
    Object.prototype.hasOwnProperty.call(t, r) && e.indexOf(r) < 0 && (n[r] = t[r]);
  if (t != null && typeof Object.getOwnPropertySymbols == "function")
    for (var i = 0, r = Object.getOwnPropertySymbols(t); i < r.length; i++)
      e.indexOf(r[i]) < 0 && Object.prototype.propertyIsEnumerable.call(t, r[i]) && (n[r[i]] = t[r[i]]);
  return n;
}, ZA = /* @__PURE__ */ x.forwardRef(function(t, e) {
  var n = t.prefixCls, r = t.size, i = t.disabled, o = t.loading, a = t.className, s = a === void 0 ? "" : a, u = h3e(t, ["prefixCls", "size", "disabled", "loading", "className"]);
  process.env.NODE_ENV !== "production" && gn("checked" in u || !("value" in u), "Switch", "`value` is not a valid prop, do you mean `checked`?");
  var l = x.useContext(en), c = l.getPrefixCls, d = l.direction, f = x.useContext(qa), h = x.useContext(Ka), p = (i ?? h) || o, v = c("switch", n), m = /* @__PURE__ */ x.createElement("div", {
    className: "".concat(v, "-handle")
  }, o && /* @__PURE__ */ x.createElement(lc, {
    className: "".concat(v, "-loading-icon")
  })), b = Ce(z(z(z({}, "".concat(v, "-small"), (r || f) === "small"), "".concat(v, "-loading"), o), "".concat(v, "-rtl"), d === "rtl"), s);
  return /* @__PURE__ */ x.createElement(VA, {
    insertExtraNode: !0
  }, /* @__PURE__ */ x.createElement(oX, G({}, u, {
    prefixCls: v,
    className: b,
    disabled: p,
    ref: e,
    loadingIcon: m
  })));
});
ZA.__ANT_SWITCH = !0;
process.env.NODE_ENV !== "production" && (ZA.displayName = "Switch");
const aX = ZA;
function p3e() {
  this.__data__ = [], this.size = 0;
}
var g3e = p3e;
function m3e(t, e) {
  return t === e || t !== t && e !== e;
}
var PC = m3e, v3e = PC;
function b3e(t, e) {
  for (var n = t.length; n--; )
    if (v3e(t[n][0], e))
      return n;
  return -1;
}
var NC = b3e, y3e = NC, x3e = Array.prototype, C3e = x3e.splice;
function w3e(t) {
  var e = this.__data__, n = y3e(e, t);
  if (n < 0)
    return !1;
  var r = e.length - 1;
  return n == r ? e.pop() : C3e.call(e, n, 1), --this.size, !0;
}
var E3e = w3e, S3e = NC;
function I3e(t) {
  var e = this.__data__, n = S3e(e, t);
  return n < 0 ? void 0 : e[n][1];
}
var _3e = I3e, A3e = NC;
function T3e(t) {
  return A3e(this.__data__, t) > -1;
}
var O3e = T3e, P3e = NC;
function N3e(t, e) {
  var n = this.__data__, r = P3e(n, t);
  return r < 0 ? (++this.size, n.push([t, e])) : n[r][1] = e, this;
}
var k3e = N3e, R3e = g3e, $3e = E3e, D3e = _3e, M3e = O3e, F3e = k3e;
function Ap(t) {
  var e = -1, n = t == null ? 0 : t.length;
  for (this.clear(); ++e < n; ) {
    var r = t[e];
    this.set(r[0], r[1]);
  }
}
Ap.prototype.clear = R3e;
Ap.prototype.delete = $3e;
Ap.prototype.get = D3e;
Ap.prototype.has = M3e;
Ap.prototype.set = F3e;
var kC = Ap, L3e = kC;
function V3e() {
  this.__data__ = new L3e(), this.size = 0;
}
var B3e = V3e;
function H3e(t) {
  var e = this.__data__, n = e.delete(t);
  return this.size = e.size, n;
}
var W3e = H3e;
function j3e(t) {
  return this.__data__.get(t);
}
var z3e = j3e;
function G3e(t) {
  return this.__data__.has(t);
}
var U3e = G3e, X3e = Ec, Y3e = Ds, Z3e = "[object AsyncFunction]", J3e = "[object Function]", K3e = "[object GeneratorFunction]", q3e = "[object Proxy]";
function Q3e(t) {
  if (!Y3e(t))
    return !1;
  var e = X3e(t);
  return e == J3e || e == K3e || e == Z3e || e == q3e;
}
var sX = Q3e, e5e = $s, t5e = e5e["__core-js_shared__"], n5e = t5e, i3 = n5e, kR = function() {
  var t = /[^.]+$/.exec(i3 && i3.keys && i3.keys.IE_PROTO || "");
  return t ? "Symbol(src)_1." + t : "";
}();
function r5e(t) {
  return !!kR && kR in t;
}
var i5e = r5e, o5e = Function.prototype, a5e = o5e.toString;
function s5e(t) {
  if (t != null) {
    try {
      return a5e.call(t);
    } catch {
    }
    try {
      return t + "";
    } catch {
    }
  }
  return "";
}
var uX = s5e, u5e = sX, l5e = i5e, c5e = Ds, d5e = uX, f5e = /[\\^$.*+?()[\]{}|]/g, h5e = /^\[object .+?Constructor\]$/, p5e = Function.prototype, g5e = Object.prototype, m5e = p5e.toString, v5e = g5e.hasOwnProperty, b5e = RegExp(
  "^" + m5e.call(v5e).replace(f5e, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$"
);
function y5e(t) {
  if (!c5e(t) || l5e(t))
    return !1;
  var e = u5e(t) ? b5e : h5e;
  return e.test(d5e(t));
}
var x5e = y5e;
function C5e(t, e) {
  return t == null ? void 0 : t[e];
}
var w5e = C5e, E5e = x5e, S5e = w5e;
function I5e(t, e) {
  var n = S5e(t, e);
  return E5e(n) ? n : void 0;
}
var Zd = I5e, _5e = Zd, A5e = $s, T5e = _5e(A5e, "Map"), JA = T5e, O5e = Zd, P5e = O5e(Object, "create"), RC = P5e, RR = RC;
function N5e() {
  this.__data__ = RR ? RR(null) : {}, this.size = 0;
}
var k5e = N5e;
function R5e(t) {
  var e = this.has(t) && delete this.__data__[t];
  return this.size -= e ? 1 : 0, e;
}
var $5e = R5e, D5e = RC, M5e = "__lodash_hash_undefined__", F5e = Object.prototype, L5e = F5e.hasOwnProperty;
function V5e(t) {
  var e = this.__data__;
  if (D5e) {
    var n = e[t];
    return n === M5e ? void 0 : n;
  }
  return L5e.call(e, t) ? e[t] : void 0;
}
var B5e = V5e, H5e = RC, W5e = Object.prototype, j5e = W5e.hasOwnProperty;
function z5e(t) {
  var e = this.__data__;
  return H5e ? e[t] !== void 0 : j5e.call(e, t);
}
var G5e = z5e, U5e = RC, X5e = "__lodash_hash_undefined__";
function Y5e(t, e) {
  var n = this.__data__;
  return this.size += this.has(t) ? 0 : 1, n[t] = U5e && e === void 0 ? X5e : e, this;
}
var Z5e = Y5e, J5e = k5e, K5e = $5e, q5e = B5e, Q5e = G5e, eIe = Z5e;
function Tp(t) {
  var e = -1, n = t == null ? 0 : t.length;
  for (this.clear(); ++e < n; ) {
    var r = t[e];
    this.set(r[0], r[1]);
  }
}
Tp.prototype.clear = J5e;
Tp.prototype.delete = K5e;
Tp.prototype.get = q5e;
Tp.prototype.has = Q5e;
Tp.prototype.set = eIe;
var tIe = Tp, $R = tIe, nIe = kC, rIe = JA;
function iIe() {
  this.size = 0, this.__data__ = {
    hash: new $R(),
    map: new (rIe || nIe)(),
    string: new $R()
  };
}
var oIe = iIe;
function aIe(t) {
  var e = typeof t;
  return e == "string" || e == "number" || e == "symbol" || e == "boolean" ? t !== "__proto__" : t === null;
}
var sIe = aIe, uIe = sIe;
function lIe(t, e) {
  var n = t.__data__;
  return uIe(e) ? n[typeof e == "string" ? "string" : "hash"] : n.map;
}
var $C = lIe, cIe = $C;
function dIe(t) {
  var e = cIe(this, t).delete(t);
  return this.size -= e ? 1 : 0, e;
}
var fIe = dIe, hIe = $C;
function pIe(t) {
  return hIe(this, t).get(t);
}
var gIe = pIe, mIe = $C;
function vIe(t) {
  return mIe(this, t).has(t);
}
var bIe = vIe, yIe = $C;
function xIe(t, e) {
  var n = yIe(this, t), r = n.size;
  return n.set(t, e), this.size += n.size == r ? 0 : 1, this;
}
var CIe = xIe, wIe = oIe, EIe = fIe, SIe = gIe, IIe = bIe, _Ie = CIe;
function Op(t) {
  var e = -1, n = t == null ? 0 : t.length;
  for (this.clear(); ++e < n; ) {
    var r = t[e];
    this.set(r[0], r[1]);
  }
}
Op.prototype.clear = wIe;
Op.prototype.delete = EIe;
Op.prototype.get = SIe;
Op.prototype.has = IIe;
Op.prototype.set = _Ie;
var KA = Op, AIe = kC, TIe = JA, OIe = KA, PIe = 200;
function NIe(t, e) {
  var n = this.__data__;
  if (n instanceof AIe) {
    var r = n.__data__;
    if (!TIe || r.length < PIe - 1)
      return r.push([t, e]), this.size = ++n.size, this;
    n = this.__data__ = new OIe(r);
  }
  return n.set(t, e), this.size = n.size, this;
}
var kIe = NIe, RIe = kC, $Ie = B3e, DIe = W3e, MIe = z3e, FIe = U3e, LIe = kIe;
function Pp(t) {
  var e = this.__data__ = new RIe(t);
  this.size = e.size;
}
Pp.prototype.clear = $Ie;
Pp.prototype.delete = DIe;
Pp.prototype.get = MIe;
Pp.prototype.has = FIe;
Pp.prototype.set = LIe;
var qA = Pp, VIe = "__lodash_hash_undefined__";
function BIe(t) {
  return this.__data__.set(t, VIe), this;
}
var HIe = BIe;
function WIe(t) {
  return this.__data__.has(t);
}
var jIe = WIe, zIe = KA, GIe = HIe, UIe = jIe;
function Ax(t) {
  var e = -1, n = t == null ? 0 : t.length;
  for (this.__data__ = new zIe(); ++e < n; )
    this.add(t[e]);
}
Ax.prototype.add = Ax.prototype.push = GIe;
Ax.prototype.has = UIe;
var lX = Ax;
function XIe(t, e) {
  for (var n = -1, r = t == null ? 0 : t.length; ++n < r; )
    if (e(t[n], n, t))
      return !0;
  return !1;
}
var cX = XIe;
function YIe(t, e) {
  return t.has(e);
}
var dX = YIe, ZIe = lX, JIe = cX, KIe = dX, qIe = 1, QIe = 2;
function e_e(t, e, n, r, i, o) {
  var a = n & qIe, s = t.length, u = e.length;
  if (s != u && !(a && u > s))
    return !1;
  var l = o.get(t), c = o.get(e);
  if (l && c)
    return l == e && c == t;
  var d = -1, f = !0, h = n & QIe ? new ZIe() : void 0;
  for (o.set(t, e), o.set(e, t); ++d < s; ) {
    var p = t[d], v = e[d];
    if (r)
      var m = a ? r(v, p, d, e, t, o) : r(p, v, d, t, e, o);
    if (m !== void 0) {
      if (m)
        continue;
      f = !1;
      break;
    }
    if (h) {
      if (!JIe(e, function(b, y) {
        if (!KIe(h, y) && (p === b || i(p, b, n, r, o)))
          return h.push(y);
      })) {
        f = !1;
        break;
      }
    } else if (!(p === v || i(p, v, n, r, o))) {
      f = !1;
      break;
    }
  }
  return o.delete(t), o.delete(e), f;
}
var fX = e_e, t_e = $s, n_e = t_e.Uint8Array, hX = n_e;
function r_e(t) {
  var e = -1, n = Array(t.size);
  return t.forEach(function(r, i) {
    n[++e] = [i, r];
  }), n;
}
var i_e = r_e;
function o_e(t) {
  var e = -1, n = Array(t.size);
  return t.forEach(function(r) {
    n[++e] = r;
  }), n;
}
var QA = o_e, DR = xp, MR = hX, a_e = PC, s_e = fX, u_e = i_e, l_e = QA, c_e = 1, d_e = 2, f_e = "[object Boolean]", h_e = "[object Date]", p_e = "[object Error]", g_e = "[object Map]", m_e = "[object Number]", v_e = "[object RegExp]", b_e = "[object Set]", y_e = "[object String]", x_e = "[object Symbol]", C_e = "[object ArrayBuffer]", w_e = "[object DataView]", FR = DR ? DR.prototype : void 0, o3 = FR ? FR.valueOf : void 0;
function E_e(t, e, n, r, i, o, a) {
  switch (n) {
    case w_e:
      if (t.byteLength != e.byteLength || t.byteOffset != e.byteOffset)
        return !1;
      t = t.buffer, e = e.buffer;
    case C_e:
      return !(t.byteLength != e.byteLength || !o(new MR(t), new MR(e)));
    case f_e:
    case h_e:
    case m_e:
      return a_e(+t, +e);
    case p_e:
      return t.name == e.name && t.message == e.message;
    case v_e:
    case y_e:
      return t == e + "";
    case g_e:
      var s = u_e;
    case b_e:
      var u = r & c_e;
      if (s || (s = l_e), t.size != e.size && !u)
        return !1;
      var l = a.get(t);
      if (l)
        return l == e;
      r |= d_e, a.set(t, e);
      var c = s_e(s(t), s(e), r, i, o, a);
      return a.delete(t), c;
    case x_e:
      if (o3)
        return o3.call(t) == o3.call(e);
  }
  return !1;
}
var S_e = E_e;
function I_e(t, e) {
  for (var n = -1, r = e.length, i = t.length; ++n < r; )
    t[i + n] = e[n];
  return t;
}
var e9 = I_e, __e = e9, A_e = Mo;
function T_e(t, e, n) {
  var r = e(t);
  return A_e(t) ? r : __e(r, n(t));
}
var pX = T_e;
function O_e(t, e) {
  for (var n = -1, r = t == null ? 0 : t.length, i = 0, o = []; ++n < r; ) {
    var a = t[n];
    e(a, n, t) && (o[i++] = a);
  }
  return o;
}
var P_e = O_e;
function N_e() {
  return [];
}
var gX = N_e, k_e = P_e, R_e = gX, $_e = Object.prototype, D_e = $_e.propertyIsEnumerable, LR = Object.getOwnPropertySymbols, M_e = LR ? function(t) {
  return t == null ? [] : (t = Object(t), k_e(LR(t), function(e) {
    return D_e.call(t, e);
  }));
} : R_e, t9 = M_e;
function F_e(t, e) {
  for (var n = -1, r = Array(t); ++n < t; )
    r[n] = e(n);
  return r;
}
var L_e = F_e, V_e = Ec, B_e = xu, H_e = "[object Arguments]";
function W_e(t) {
  return B_e(t) && V_e(t) == H_e;
}
var j_e = W_e, VR = j_e, z_e = xu, mX = Object.prototype, G_e = mX.hasOwnProperty, U_e = mX.propertyIsEnumerable, X_e = VR(/* @__PURE__ */ function() {
  return arguments;
}()) ? VR : function(t) {
  return z_e(t) && G_e.call(t, "callee") && !U_e.call(t, "callee");
}, n9 = X_e, Tx = { exports: {} };
function Y_e() {
  return !1;
}
var Z_e = Y_e;
Tx.exports;
(function(t, e) {
  var n = $s, r = Z_e, i = e && !e.nodeType && e, o = i && !0 && t && !t.nodeType && t, a = o && o.exports === i, s = a ? n.Buffer : void 0, u = s ? s.isBuffer : void 0, l = u || r;
  t.exports = l;
})(Tx, Tx.exports);
var r9 = Tx.exports, J_e = 9007199254740991, K_e = /^(?:0|[1-9]\d*)$/;
function q_e(t, e) {
  var n = typeof t;
  return e = e ?? J_e, !!e && (n == "number" || n != "symbol" && K_e.test(t)) && t > -1 && t % 1 == 0 && t < e;
}
var DC = q_e, Q_e = 9007199254740991;
function e4e(t) {
  return typeof t == "number" && t > -1 && t % 1 == 0 && t <= Q_e;
}
var i9 = e4e, t4e = Ec, n4e = i9, r4e = xu, i4e = "[object Arguments]", o4e = "[object Array]", a4e = "[object Boolean]", s4e = "[object Date]", u4e = "[object Error]", l4e = "[object Function]", c4e = "[object Map]", d4e = "[object Number]", f4e = "[object Object]", h4e = "[object RegExp]", p4e = "[object Set]", g4e = "[object String]", m4e = "[object WeakMap]", v4e = "[object ArrayBuffer]", b4e = "[object DataView]", y4e = "[object Float32Array]", x4e = "[object Float64Array]", C4e = "[object Int8Array]", w4e = "[object Int16Array]", E4e = "[object Int32Array]", S4e = "[object Uint8Array]", I4e = "[object Uint8ClampedArray]", _4e = "[object Uint16Array]", A4e = "[object Uint32Array]", Dr = {};
Dr[y4e] = Dr[x4e] = Dr[C4e] = Dr[w4e] = Dr[E4e] = Dr[S4e] = Dr[I4e] = Dr[_4e] = Dr[A4e] = !0;
Dr[i4e] = Dr[o4e] = Dr[v4e] = Dr[a4e] = Dr[b4e] = Dr[s4e] = Dr[u4e] = Dr[l4e] = Dr[c4e] = Dr[d4e] = Dr[f4e] = Dr[h4e] = Dr[p4e] = Dr[g4e] = Dr[m4e] = !1;
function T4e(t) {
  return r4e(t) && n4e(t.length) && !!Dr[t4e(t)];
}
var O4e = T4e;
function P4e(t) {
  return function(e) {
    return t(e);
  };
}
var MC = P4e, Ox = { exports: {} };
Ox.exports;
(function(t, e) {
  var n = hW, r = e && !e.nodeType && e, i = r && !0 && t && !t.nodeType && t, o = i && i.exports === r, a = o && n.process, s = function() {
    try {
      var u = i && i.require && i.require("util").types;
      return u || a && a.binding && a.binding("util");
    } catch {
    }
  }();
  t.exports = s;
})(Ox, Ox.exports);
var FC = Ox.exports, N4e = O4e, k4e = MC, BR = FC, HR = BR && BR.isTypedArray, R4e = HR ? k4e(HR) : N4e, vX = R4e, $4e = L_e, D4e = n9, M4e = Mo, F4e = r9, L4e = DC, V4e = vX, B4e = Object.prototype, H4e = B4e.hasOwnProperty;
function W4e(t, e) {
  var n = M4e(t), r = !n && D4e(t), i = !n && !r && F4e(t), o = !n && !r && !i && V4e(t), a = n || r || i || o, s = a ? $4e(t.length, String) : [], u = s.length;
  for (var l in t)
    (e || H4e.call(t, l)) && !(a && // Safari 9 has enumerable `arguments.length` in strict mode.
    (l == "length" || // Node.js 0.10 has enumerable non-index properties on buffers.
    i && (l == "offset" || l == "parent") || // PhantomJS 2 has enumerable non-index properties on typed arrays.
    o && (l == "buffer" || l == "byteLength" || l == "byteOffset") || // Skip index properties.
    L4e(l, u))) && s.push(l);
  return s;
}
var bX = W4e, j4e = Object.prototype;
function z4e(t) {
  var e = t && t.constructor, n = typeof e == "function" && e.prototype || j4e;
  return t === n;
}
var o9 = z4e;
function G4e(t, e) {
  return function(n) {
    return t(e(n));
  };
}
var yX = G4e, U4e = yX, X4e = U4e(Object.keys, Object), Y4e = X4e, Z4e = o9, J4e = Y4e, K4e = Object.prototype, q4e = K4e.hasOwnProperty;
function Q4e(t) {
  if (!Z4e(t))
    return J4e(t);
  var e = [];
  for (var n in Object(t))
    q4e.call(t, n) && n != "constructor" && e.push(n);
  return e;
}
var e6e = Q4e, t6e = sX, n6e = i9;
function r6e(t) {
  return t != null && n6e(t.length) && !t6e(t);
}
var zm = r6e, i6e = bX, o6e = e6e, a6e = zm;
function s6e(t) {
  return a6e(t) ? i6e(t) : o6e(t);
}
var Gm = s6e, u6e = pX, l6e = t9, c6e = Gm;
function d6e(t) {
  return u6e(t, c6e, l6e);
}
var xX = d6e, WR = xX, f6e = 1, h6e = Object.prototype, p6e = h6e.hasOwnProperty;
function g6e(t, e, n, r, i, o) {
  var a = n & f6e, s = WR(t), u = s.length, l = WR(e), c = l.length;
  if (u != c && !a)
    return !1;
  for (var d = u; d--; ) {
    var f = s[d];
    if (!(a ? f in e : p6e.call(e, f)))
      return !1;
  }
  var h = o.get(t), p = o.get(e);
  if (h && p)
    return h == e && p == t;
  var v = !0;
  o.set(t, e), o.set(e, t);
  for (var m = a; ++d < u; ) {
    f = s[d];
    var b = t[f], y = e[f];
    if (r)
      var w = a ? r(y, b, f, e, t, o) : r(b, y, f, t, e, o);
    if (!(w === void 0 ? b === y || i(b, y, n, r, o) : w)) {
      v = !1;
      break;
    }
    m || (m = f == "constructor");
  }
  if (v && !m) {
    var S = t.constructor, E = e.constructor;
    S != E && "constructor" in t && "constructor" in e && !(typeof S == "function" && S instanceof S && typeof E == "function" && E instanceof E) && (v = !1);
  }
  return o.delete(t), o.delete(e), v;
}
var m6e = g6e, v6e = Zd, b6e = $s, y6e = v6e(b6e, "DataView"), x6e = y6e, C6e = Zd, w6e = $s, E6e = C6e(w6e, "Promise"), S6e = E6e, I6e = Zd, _6e = $s, A6e = I6e(_6e, "Set"), CX = A6e, T6e = Zd, O6e = $s, P6e = T6e(O6e, "WeakMap"), N6e = P6e, g_ = x6e, m_ = JA, v_ = S6e, b_ = CX, y_ = N6e, wX = Ec, Np = uX, jR = "[object Map]", k6e = "[object Object]", zR = "[object Promise]", GR = "[object Set]", UR = "[object WeakMap]", XR = "[object DataView]", R6e = Np(g_), $6e = Np(m_), D6e = Np(v_), M6e = Np(b_), F6e = Np(y_), nd = wX;
(g_ && nd(new g_(new ArrayBuffer(1))) != XR || m_ && nd(new m_()) != jR || v_ && nd(v_.resolve()) != zR || b_ && nd(new b_()) != GR || y_ && nd(new y_()) != UR) && (nd = function(t) {
  var e = wX(t), n = e == k6e ? t.constructor : void 0, r = n ? Np(n) : "";
  if (r)
    switch (r) {
      case R6e:
        return XR;
      case $6e:
        return jR;
      case D6e:
        return zR;
      case M6e:
        return GR;
      case F6e:
        return UR;
    }
  return e;
});
var LC = nd, a3 = qA, L6e = fX, V6e = S_e, B6e = m6e, YR = LC, ZR = Mo, JR = r9, H6e = vX, W6e = 1, KR = "[object Arguments]", qR = "[object Array]", ab = "[object Object]", j6e = Object.prototype, QR = j6e.hasOwnProperty;
function z6e(t, e, n, r, i, o) {
  var a = ZR(t), s = ZR(e), u = a ? qR : YR(t), l = s ? qR : YR(e);
  u = u == KR ? ab : u, l = l == KR ? ab : l;
  var c = u == ab, d = l == ab, f = u == l;
  if (f && JR(t)) {
    if (!JR(e))
      return !1;
    a = !0, c = !1;
  }
  if (f && !c)
    return o || (o = new a3()), a || H6e(t) ? L6e(t, e, n, r, i, o) : V6e(t, e, u, n, r, i, o);
  if (!(n & W6e)) {
    var h = c && QR.call(t, "__wrapped__"), p = d && QR.call(e, "__wrapped__");
    if (h || p) {
      var v = h ? t.value() : t, m = p ? e.value() : e;
      return o || (o = new a3()), i(v, m, n, r, o);
    }
  }
  return f ? (o || (o = new a3()), B6e(t, e, n, r, i, o)) : !1;
}
var G6e = z6e, U6e = G6e, e$ = xu;
function EX(t, e, n, r, i) {
  return t === e ? !0 : t == null || e == null || !e$(t) && !e$(e) ? t !== t && e !== e : U6e(t, e, n, r, EX, i);
}
var a9 = EX, X6e = a9;
function Y6e(t, e) {
  return X6e(t, e);
}
var Z6e = Y6e;
const VC = /* @__PURE__ */ qn(Z6e);
var J6e = function(e) {
  var n = e.renderedText, r = e.renderedEl, i = e.item, o = e.checked, a = e.disabled, s = e.prefixCls, u = e.onClick, l = e.onRemove, c = e.showRemove, d = Ce(z(z(z({}, "".concat(s, "-content-item"), !0), "".concat(s, "-content-item-disabled"), a || i.disabled), "".concat(s, "-content-item-checked"), o)), f;
  return (typeof n == "string" || typeof n == "number") && (f = String(n)), /* @__PURE__ */ x.createElement(Ic, {
    componentName: "Transfer",
    defaultLocale: fu.Transfer
  }, function(h) {
    var p = {
      className: d,
      title: f
    }, v = /* @__PURE__ */ x.createElement("span", {
      className: "".concat(s, "-content-item-text")
    }, r);
    return c ? /* @__PURE__ */ x.createElement("li", G({}, p), v, /* @__PURE__ */ x.createElement(ISe, {
      disabled: a || i.disabled,
      className: "".concat(s, "-content-item-remove"),
      "aria-label": h.remove,
      onClick: function() {
        l == null || l(i);
      }
    }, /* @__PURE__ */ x.createElement(nA, null))) : (p.onClick = a || i.disabled ? void 0 : function() {
      return u(i);
    }, /* @__PURE__ */ x.createElement("li", G({}, p), /* @__PURE__ */ x.createElement(Y0, {
      className: "".concat(s, "-checkbox"),
      checked: o,
      disabled: a || i.disabled
    }), v));
  });
};
const K6e = /* @__PURE__ */ x.memo(J6e);
var q6e = Ki("handleFilter", "handleClear", "checkedKeys");
function s3(t) {
  if (!t)
    return null;
  var e = {
    pageSize: 10,
    simple: !0,
    showSizeChanger: !1,
    showLessItems: !1
  };
  return _t(t) === "object" ? G(G({}, e), t) : e;
}
var Q6e = /* @__PURE__ */ function(t) {
  Pr(n, t);
  var e = Hr(n);
  function n() {
    var r;
    return zn(this, n), r = e.apply(this, arguments), r.state = {
      current: 1
    }, r.onItemSelect = function(i) {
      var o = r.props, a = o.onItemSelect, s = o.selectedKeys, u = s.includes(i.key);
      a(i.key, !u);
    }, r.onItemRemove = function(i) {
      var o = r.props.onItemRemove;
      o == null || o([i.key]);
    }, r.onPageChange = function(i) {
      r.setState({
        current: i
      });
    }, r.getItems = function() {
      var i = r.state.current, o = r.props, a = o.pagination, s = o.filteredRenderItems, u = s3(a), l = s;
      return u && (l = s.slice((i - 1) * u.pageSize, i * u.pageSize)), l;
    }, r;
  }
  return Gn(n, [{
    key: "render",
    value: function() {
      var i = this, o = this.state.current, a = this.props, s = a.prefixCls, u = a.onScroll, l = a.filteredRenderItems, c = a.selectedKeys, d = a.disabled, f = a.showRemove, h = a.pagination, p = s3(h), v = null;
      return p && (v = /* @__PURE__ */ x.createElement(dSe, {
        simple: p.simple,
        showSizeChanger: p.showSizeChanger,
        showLessItems: p.showLessItems,
        size: "small",
        disabled: d,
        className: "".concat(s, "-pagination"),
        total: l.length,
        pageSize: p.pageSize,
        current: o,
        onChange: this.onPageChange
      })), /* @__PURE__ */ x.createElement(x.Fragment, null, /* @__PURE__ */ x.createElement("ul", {
        className: Ce("".concat(s, "-content"), z({}, "".concat(s, "-content-show-remove"), f)),
        onScroll: u
      }, this.getItems().map(function(m) {
        var b = m.renderedEl, y = m.renderedText, w = m.item, S = w.disabled, E = c.includes(w.key);
        return /* @__PURE__ */ x.createElement(K6e, {
          disabled: d || S,
          key: w.key,
          item: w,
          renderedText: y,
          renderedEl: b,
          checked: E,
          prefixCls: s,
          onClick: i.onItemSelect,
          onRemove: i.onItemRemove,
          showRemove: f
        });
      })), v);
    }
  }], [{
    key: "getDerivedStateFromProps",
    value: function(i, o) {
      var a = i.filteredRenderItems, s = i.pagination, u = o.current, l = s3(s);
      if (l) {
        var c = Math.ceil(a.length / l.pageSize);
        if (u > c)
          return {
            current: c
          };
      }
      return null;
    }
  }]), n;
}(x.Component);
const eAe = Q6e;
function SX(t) {
  var e = t.placeholder, n = e === void 0 ? "" : e, r = t.value, i = t.prefixCls, o = t.disabled, a = t.onChange, s = t.handleClear, u = x.useCallback(function(l) {
    a == null || a(l), l.target.value === "" && (s == null || s());
  }, [a]);
  return /* @__PURE__ */ x.createElement(ma, {
    placeholder: n,
    className: i,
    value: r,
    onChange: u,
    disabled: o,
    allowClear: !0,
    prefix: /* @__PURE__ */ x.createElement(rA, null)
  });
}
var tAe = function() {
  return null;
};
function nAe(t) {
  return !!(t && !pa(t) && Object.prototype.toString.call(t) === "[object Object]");
}
function Lf(t) {
  return t.filter(function(e) {
    return !e.disabled;
  }).map(function(e) {
    return e.key;
  });
}
var x_ = /* @__PURE__ */ function(t) {
  Pr(n, t);
  var e = Hr(n);
  function n(r) {
    var i;
    return zn(this, n), i = e.call(this, r), i.defaultListBodyRef = /* @__PURE__ */ x.createRef(), i.handleFilter = function(o) {
      var a = i.props.handleFilter, s = o.target.value;
      i.setState({
        filterValue: s
      }), a(o);
    }, i.handleClear = function() {
      var o = i.props.handleClear;
      i.setState({
        filterValue: ""
      }), o();
    }, i.matchFilter = function(o, a) {
      var s = i.state.filterValue, u = i.props.filterOption;
      return u ? u(s, a) : o.includes(s);
    }, i.renderListBody = function(o, a) {
      var s = o ? o(a) : null, u = !!s;
      return u || (s = /* @__PURE__ */ x.createElement(eAe, G({
        ref: i.defaultListBodyRef
      }, a))), {
        customize: u,
        bodyContent: s
      };
    }, i.renderItem = function(o) {
      var a = i.props.render, s = a === void 0 ? tAe : a, u = s(o), l = nAe(u);
      return {
        renderedText: l ? u.value : u,
        renderedEl: l ? u.label : u,
        item: o
      };
    }, i.getSelectAllLabel = function(o, a) {
      var s = i.props, u = s.itemsUnit, l = s.itemUnit, c = s.selectAllLabel;
      if (c)
        return typeof c == "function" ? c({
          selectedCount: o,
          totalCount: a
        }) : c;
      var d = a > 1 ? u : l;
      return /* @__PURE__ */ x.createElement(x.Fragment, null, (o > 0 ? "".concat(o, "/") : "") + a, " ", d);
    }, i.state = {
      filterValue: ""
    }, i;
  }
  return Gn(n, [{
    key: "componentWillUnmount",
    value: function() {
      clearTimeout(this.triggerScrollTimer);
    }
  }, {
    key: "getCheckStatus",
    value: function(i) {
      var o = this.props.checkedKeys;
      return o.length === 0 ? "none" : i.every(function(a) {
        return o.includes(a.key) || !!a.disabled;
      }) ? "all" : "part";
    }
    // ================================ Item ================================
  }, {
    key: "getFilteredItems",
    value: function(i, o) {
      var a = this, s = [], u = [];
      return i.forEach(function(l) {
        var c = a.renderItem(l), d = c.renderedText;
        if (o && !a.matchFilter(d, l))
          return null;
        s.push(l), u.push(c);
      }), {
        filteredItems: s,
        filteredRenderItems: u
      };
    }
  }, {
    key: "getListBody",
    value: function(i, o, a, s, u, l, c, d, f, h) {
      var p = this, v = f ? /* @__PURE__ */ x.createElement("div", {
        className: "".concat(i, "-body-search-wrapper")
      }, /* @__PURE__ */ x.createElement(SX, {
        prefixCls: "".concat(i, "-search"),
        onChange: this.handleFilter,
        handleClear: this.handleClear,
        placeholder: o,
        value: a,
        disabled: h
      })) : null, m = this.renderListBody(d, G(G({}, Pi(this.props, q6e)), {
        filteredItems: s,
        filteredRenderItems: l,
        selectedKeys: c
      })), b = m.bodyContent, y = m.customize, w = function() {
        var I = p.props.direction === "left" ? 0 : 1;
        return Array.isArray(u) ? u[I] : u;
      }, S;
      return y ? S = /* @__PURE__ */ x.createElement("div", {
        className: "".concat(i, "-body-customize-wrapper")
      }, b) : S = s.length ? b : /* @__PURE__ */ x.createElement("div", {
        className: "".concat(i, "-body-not-found")
      }, w()), /* @__PURE__ */ x.createElement("div", {
        className: Ce(f ? "".concat(i, "-body ").concat(i, "-body-with-search") : "".concat(i, "-body"))
      }, v, S);
    }
  }, {
    key: "getCheckBox",
    value: function(i) {
      var o = i.filteredItems, a = i.onItemSelectAll, s = i.disabled, u = i.prefixCls, l = this.getCheckStatus(o), c = l === "all", d = /* @__PURE__ */ x.createElement(Y0, {
        disabled: s,
        checked: c,
        indeterminate: l === "part",
        className: "".concat(u, "-checkbox"),
        onChange: function() {
          a(o.filter(function(h) {
            return !h.disabled;
          }).map(function(h) {
            var p = h.key;
            return p;
          }), !c);
        }
      });
      return d;
    }
  }, {
    key: "render",
    value: function() {
      var i = this, o = this.state.filterValue, a = this.props, s = a.prefixCls, u = a.dataSource, l = u === void 0 ? [] : u, c = a.titleText, d = c === void 0 ? "" : c, f = a.checkedKeys, h = a.disabled, p = a.footer, v = a.showSearch, m = v === void 0 ? !1 : v, b = a.style, y = a.searchPlaceholder, w = a.notFoundContent, S = a.selectAll, E = a.selectCurrent, I = a.selectInvert, _ = a.removeAll, A = a.removeCurrent, P = a.renderList, N = a.onItemSelectAll, k = a.onItemRemove, D = a.showSelectAll, R = D === void 0 ? !0 : D, V = a.showRemove, $ = a.pagination, F = a.direction, M = p && (p.length < 2 ? p(this.props) : p(this.props, {
        direction: F
      })), B = Ce(s, z(z({}, "".concat(s, "-with-pagination"), !!$), "".concat(s, "-with-footer"), !!M)), X = this.getFilteredItems(l, o), L = X.filteredItems, j = X.filteredRenderItems, K = this.getListBody(s, y, o, L, w, j, f, P, m, h), W = M ? /* @__PURE__ */ x.createElement("div", {
        className: "".concat(s, "-footer")
      }, M) : null, Y = !V && !$ && this.getCheckBox({
        filteredItems: L,
        onItemSelectAll: N,
        disabled: h,
        prefixCls: s
      }), U;
      V ? U = [
        /* Remove Current Page */
        $ ? {
          key: "removeCurrent",
          onClick: function() {
            var ee, ie = Lf((((ee = i.defaultListBodyRef.current) === null || ee === void 0 ? void 0 : ee.getItems()) || []).map(function(oe) {
              return oe.item;
            }));
            k == null || k(ie);
          },
          label: A
        } : null,
        /* Remove All */
        {
          key: "removeAll",
          onClick: function() {
            k == null || k(Lf(L));
          },
          label: _
        }
      ].filter(function(Z) {
        return Z;
      }) : U = [{
        key: "selectAll",
        onClick: function() {
          var ee = Lf(L);
          N(ee, ee.length !== f.length);
        },
        label: S
      }, $ ? {
        key: "selectCurrent",
        onClick: function() {
          var ee, ie = ((ee = i.defaultListBodyRef.current) === null || ee === void 0 ? void 0 : ee.getItems()) || [];
          N(Lf(ie.map(function(oe) {
            return oe.item;
          })), !0);
        },
        label: E
      } : null, {
        key: "selectInvert",
        onClick: function() {
          var ee, ie;
          $ ? ie = Lf((((ee = i.defaultListBodyRef.current) === null || ee === void 0 ? void 0 : ee.getItems()) || []).map(function(ge) {
            return ge.item;
          })) : ie = Lf(L);
          var oe = new Set(f), se = [], te = [];
          ie.forEach(function(ge) {
            oe.has(ge) ? te.push(ge) : se.push(ge);
          }), N(se, !0), N(te, !1);
        },
        label: I
      }];
      var Q = /* @__PURE__ */ x.createElement(IC, {
        className: "".concat(s, "-header-dropdown"),
        menu: {
          items: U
        },
        disabled: h
      }, /* @__PURE__ */ x.createElement(cC, null));
      return /* @__PURE__ */ x.createElement("div", {
        className: B,
        style: b
      }, /* @__PURE__ */ x.createElement("div", {
        className: "".concat(s, "-header")
      }, R ? /* @__PURE__ */ x.createElement(x.Fragment, null, Y, Q) : null, /* @__PURE__ */ x.createElement("span", {
        className: "".concat(s, "-header-selected")
      }, this.getSelectAllLabel(f.length, L.length)), /* @__PURE__ */ x.createElement("span", {
        className: "".concat(s, "-header-title")
      }, d)), K, W);
    }
  }]), n;
}(x.PureComponent), rAe = function(e) {
  var n = e.disabled, r = e.moveToLeft, i = e.moveToRight, o = e.leftArrowText, a = o === void 0 ? "" : o, s = e.rightArrowText, u = s === void 0 ? "" : s, l = e.leftActive, c = e.rightActive, d = e.className, f = e.style, h = e.direction, p = e.oneWay;
  return /* @__PURE__ */ x.createElement("div", {
    className: d,
    style: f
  }, /* @__PURE__ */ x.createElement(ko, {
    type: "primary",
    size: "small",
    disabled: n || !c,
    onClick: i,
    icon: h !== "rtl" ? /* @__PURE__ */ x.createElement(Qh, null) : /* @__PURE__ */ x.createElement(V0, null)
  }, u), !p && /* @__PURE__ */ x.createElement(ko, {
    type: "primary",
    size: "small",
    disabled: n || !l,
    onClick: r,
    icon: h !== "rtl" ? /* @__PURE__ */ x.createElement(V0, null) : /* @__PURE__ */ x.createElement(Qh, null)
  }, a));
};
const IX = rAe;
var BC = /* @__PURE__ */ function(t) {
  Pr(n, t);
  var e = Hr(n);
  function n(r) {
    var i;
    zn(this, n), i = e.call(this, r), i.separatedDataSource = null, i.setStateKeys = function(l, c) {
      l === "left" ? i.setState(function(d) {
        var f = d.sourceSelectedKeys;
        return {
          sourceSelectedKeys: typeof c == "function" ? c(f || []) : c
        };
      }) : i.setState(function(d) {
        var f = d.targetSelectedKeys;
        return {
          targetSelectedKeys: typeof c == "function" ? c(f || []) : c
        };
      });
    }, i.getLocale = function(l, c) {
      var d = i.props.locale, f = d === void 0 ? {} : d;
      return G(G(G({}, l), {
        notFoundContent: c("Transfer")
      }), f);
    }, i.moveTo = function(l) {
      var c = i.props, d = c.targetKeys, f = d === void 0 ? [] : d, h = c.dataSource, p = h === void 0 ? [] : h, v = c.onChange, m = i.state, b = m.sourceSelectedKeys, y = m.targetSelectedKeys, w = l === "right" ? b : y, S = w.filter(function(_) {
        return !p.some(function(A) {
          return !!(_ === A.key && A.disabled);
        });
      }), E = l === "right" ? S.concat(f) : f.filter(function(_) {
        return !S.includes(_);
      }), I = l === "right" ? "left" : "right";
      i.setStateKeys(I, []), i.handleSelectChange(I, []), v == null || v(E, l, S);
    }, i.moveToLeft = function() {
      return i.moveTo("left");
    }, i.moveToRight = function() {
      return i.moveTo("right");
    }, i.onItemSelectAll = function(l, c, d) {
      i.setStateKeys(l, function(f) {
        var h = [];
        return d ? h = Array.from(new Set([].concat(Ye(f), Ye(c)))) : h = f.filter(function(p) {
          return !c.includes(p);
        }), i.handleSelectChange(l, h), h;
      });
    }, i.onLeftItemSelectAll = function(l, c) {
      return i.onItemSelectAll("left", l, c);
    }, i.onRightItemSelectAll = function(l, c) {
      return i.onItemSelectAll("right", l, c);
    }, i.handleFilter = function(l, c) {
      var d = i.props.onSearch, f = c.target.value;
      d == null || d(l, f);
    }, i.handleLeftFilter = function(l) {
      return i.handleFilter("left", l);
    }, i.handleRightFilter = function(l) {
      return i.handleFilter("right", l);
    }, i.handleClear = function(l) {
      var c = i.props.onSearch;
      c == null || c(l, "");
    }, i.handleLeftClear = function() {
      return i.handleClear("left");
    }, i.handleRightClear = function() {
      return i.handleClear("right");
    }, i.onItemSelect = function(l, c, d) {
      var f = i.state, h = f.sourceSelectedKeys, p = f.targetSelectedKeys, v = Ye(l === "left" ? h : p), m = v.indexOf(c);
      m > -1 && v.splice(m, 1), d && v.push(c), i.handleSelectChange(l, v), i.props.selectedKeys || i.setStateKeys(l, v);
    }, i.onLeftItemSelect = function(l, c) {
      return i.onItemSelect("left", l, c);
    }, i.onRightItemSelect = function(l, c) {
      return i.onItemSelect("right", l, c);
    }, i.onRightItemRemove = function(l) {
      var c = i.props, d = c.targetKeys, f = d === void 0 ? [] : d, h = c.onChange;
      i.setStateKeys("right", []), h == null || h(f.filter(function(p) {
        return !l.includes(p);
      }), "left", Ye(l));
    }, i.handleScroll = function(l, c) {
      var d = i.props.onScroll;
      d == null || d(l, c);
    }, i.handleLeftScroll = function(l) {
      return i.handleScroll("left", l);
    }, i.handleRightScroll = function(l) {
      return i.handleScroll("right", l);
    }, i.handleListStyle = function(l, c) {
      return typeof l == "function" ? l({
        direction: c
      }) : l;
    };
    var o = r.selectedKeys, a = o === void 0 ? [] : o, s = r.targetKeys, u = s === void 0 ? [] : s;
    return i.state = {
      sourceSelectedKeys: a.filter(function(l) {
        return !u.includes(l);
      }),
      targetSelectedKeys: a.filter(function(l) {
        return u.includes(l);
      })
    }, i;
  }
  return Gn(n, [{
    key: "getTitles",
    value: function(i) {
      var o, a;
      return (a = (o = this.props.titles) !== null && o !== void 0 ? o : i.titles) !== null && a !== void 0 ? a : [];
    }
  }, {
    key: "handleSelectChange",
    value: function(i, o) {
      var a = this.state, s = a.sourceSelectedKeys, u = a.targetSelectedKeys, l = this.props.onSelectChange;
      l && (i === "left" ? l(o, u) : l(s, o));
    }
  }, {
    key: "separateDataSource",
    value: function() {
      var i = this.props, o = i.dataSource, a = o === void 0 ? [] : o, s = i.rowKey, u = i.targetKeys, l = u === void 0 ? [] : u, c = [], d = new Array(l.length);
      return a.forEach(function(f) {
        s && (f = G(G({}, f), {
          key: s(f)
        }));
        var h = l.indexOf(f.key);
        h !== -1 ? d[h] = f : c.push(f);
      }), {
        leftDataSource: c,
        rightDataSource: d
      };
    }
  }, {
    key: "render",
    value: function() {
      var i = this;
      return /* @__PURE__ */ x.createElement(Ic, {
        componentName: "Transfer",
        defaultLocale: fu.Transfer
      }, function(o) {
        return /* @__PURE__ */ x.createElement(_c, null, function(a) {
          var s = a.getPrefixCls, u = a.renderEmpty, l = a.direction;
          return /* @__PURE__ */ x.createElement(Ji.Consumer, null, function(c) {
            var d = c.hasFeedback, f = c.status, h = i.props, p = h.prefixCls, v = h.className, m = h.disabled, b = h.operations, y = b === void 0 ? [] : b, w = h.showSearch, S = w === void 0 ? !1 : w, E = h.footer, I = h.style, _ = h.listStyle, A = _ === void 0 ? {} : _, P = h.operationStyle, N = h.filterOption, k = h.render, D = h.children, R = h.showSelectAll, V = h.oneWay, $ = h.pagination, F = h.status, M = s("transfer", p), B = i.getLocale(o, u || lG), X = i.state, L = X.sourceSelectedKeys, j = X.targetSelectedKeys, K = Ac(f, F), W = !D && $, Y = i.separateDataSource(), U = Y.leftDataSource, Q = Y.rightDataSource, Z = j.length > 0, ee = L.length > 0, ie = Ce(M, z(z(z({}, "".concat(M, "-disabled"), m), "".concat(M, "-customize-list"), !!D), "".concat(M, "-rtl"), l === "rtl"), aa(M, K, d), v), oe = i.getTitles(B), se = i.props.selectAllLabels || [];
            return /* @__PURE__ */ x.createElement("div", {
              className: ie,
              style: I
            }, /* @__PURE__ */ x.createElement(x_, G({
              prefixCls: "".concat(M, "-list"),
              titleText: oe == null ? void 0 : oe[0],
              dataSource: U,
              filterOption: N,
              style: i.handleListStyle(A, "left"),
              checkedKeys: L,
              handleFilter: i.handleLeftFilter,
              handleClear: i.handleLeftClear,
              onItemSelect: i.onLeftItemSelect,
              onItemSelectAll: i.onLeftItemSelectAll,
              render: k,
              showSearch: S,
              renderList: D,
              footer: E,
              onScroll: i.handleLeftScroll,
              disabled: m,
              direction: l === "rtl" ? "right" : "left",
              showSelectAll: R,
              selectAllLabel: se[0],
              pagination: W
            }, B)), /* @__PURE__ */ x.createElement(IX, {
              className: "".concat(M, "-operation"),
              rightActive: ee,
              rightArrowText: y[0],
              moveToRight: i.moveToRight,
              leftActive: Z,
              leftArrowText: y[1],
              moveToLeft: i.moveToLeft,
              style: P,
              disabled: m,
              direction: l,
              oneWay: V
            }), /* @__PURE__ */ x.createElement(x_, G({
              prefixCls: "".concat(M, "-list"),
              titleText: oe == null ? void 0 : oe[1],
              dataSource: Q,
              filterOption: N,
              style: i.handleListStyle(A, "right"),
              checkedKeys: j,
              handleFilter: i.handleRightFilter,
              handleClear: i.handleRightClear,
              onItemSelect: i.onRightItemSelect,
              onItemSelectAll: i.onRightItemSelectAll,
              onItemRemove: i.onRightItemRemove,
              render: k,
              showSearch: S,
              renderList: D,
              footer: E,
              onScroll: i.handleRightScroll,
              disabled: m,
              direction: l === "rtl" ? "left" : "right",
              showSelectAll: R,
              selectAllLabel: se[1],
              showRemove: V,
              pagination: W
            }, B)));
          });
        });
      });
    }
  }], [{
    key: "getDerivedStateFromProps",
    value: function(i) {
      var o = i.selectedKeys, a = i.targetKeys, s = i.pagination, u = i.children;
      if (o) {
        var l = a || [];
        return {
          sourceSelectedKeys: o.filter(function(c) {
            return !l.includes(c);
          }),
          targetSelectedKeys: o.filter(function(c) {
            return l.includes(c);
          })
        };
      }
      return process.env.NODE_ENV !== "production" && gn(!s || !u, "Transfer", "`pagination` not support customize render list."), null;
    }
  }]), n;
}(x.Component);
BC.List = x_;
BC.Operation = IX;
BC.Search = SX;
const iAe = BC;
function oAe(t, e) {
  var n = "cannot ".concat(t.method, " ").concat(t.action, " ").concat(e.status, "'"), r = new Error(n);
  return r.status = e.status, r.method = t.method, r.url = t.action, r;
}
function t$(t) {
  var e = t.responseText || t.response;
  if (!e)
    return e;
  try {
    return JSON.parse(e);
  } catch {
    return e;
  }
}
function aAe(t) {
  var e = new XMLHttpRequest();
  t.onProgress && e.upload && (e.upload.onprogress = function(o) {
    o.total > 0 && (o.percent = o.loaded / o.total * 100), t.onProgress(o);
  });
  var n = new FormData();
  t.data && Object.keys(t.data).forEach(function(i) {
    var o = t.data[i];
    if (Array.isArray(o)) {
      o.forEach(function(a) {
        n.append("".concat(i, "[]"), a);
      });
      return;
    }
    n.append(i, o);
  }), t.file instanceof Blob ? n.append(t.filename, t.file, t.file.name) : n.append(t.filename, t.file), e.onerror = function(o) {
    t.onError(o);
  }, e.onload = function() {
    return e.status < 200 || e.status >= 300 ? t.onError(oAe(t, e), t$(e)) : t.onSuccess(t$(e), e);
  }, e.open(t.method, t.action, !0), t.withCredentials && "withCredentials" in e && (e.withCredentials = !0);
  var r = t.headers || {};
  return r["X-Requested-With"] !== null && e.setRequestHeader("X-Requested-With", "XMLHttpRequest"), Object.keys(r).forEach(function(i) {
    r[i] !== null && e.setRequestHeader(i, r[i]);
  }), e.send(n), {
    abort: function() {
      e.abort();
    }
  };
}
var sAe = +/* @__PURE__ */ new Date(), uAe = 0;
function u3() {
  return "rc-upload-".concat(sAe, "-").concat(++uAe);
}
const l3 = function(t, e) {
  if (t && e) {
    var n = Array.isArray(e) ? e : e.split(","), r = t.name || "", i = t.type || "", o = i.replace(/\/.*$/, "");
    return n.some(function(a) {
      var s = a.trim();
      if (/^\*(\/\*)?$/.test(a))
        return !0;
      if (s.charAt(0) === ".") {
        var u = r.toLowerCase(), l = s.toLowerCase(), c = [l];
        return (l === ".jpg" || l === ".jpeg") && (c = [".jpg", ".jpeg"]), c.some(function(d) {
          return u.endsWith(d);
        });
      }
      return /\/\*$/.test(s) ? o === s.replace(/\/.*$/, "") : i === s ? !0 : /^\w+$/.test(s) ? (Wt(!1, "Upload takes an invalidate 'accept' type '".concat(s, "'.Skip for check.")), !0) : !1;
    });
  }
  return !0;
};
function lAe(t, e) {
  var n = t.createReader(), r = [];
  function i() {
    n.readEntries(function(o) {
      var a = Array.prototype.slice.apply(o);
      r = r.concat(a);
      var s = !a.length;
      s ? e(r) : i();
    });
  }
  i();
}
var cAe = function(e, n, r) {
  var i = function o(a, s) {
    a && (a.path = s || "", a.isFile ? a.file(function(u) {
      r(u) && (a.fullPath && !u.webkitRelativePath && (Object.defineProperties(u, {
        webkitRelativePath: {
          writable: !0
        }
      }), u.webkitRelativePath = a.fullPath.replace(/^\//, ""), Object.defineProperties(u, {
        webkitRelativePath: {
          writable: !1
        }
      })), n([u]));
    }) : a.isDirectory && lAe(a, function(u) {
      u.forEach(function(l) {
        o(l, "".concat(s).concat(a.name, "/"));
      });
    }));
  };
  e.forEach(function(o) {
    i(o.webkitGetAsEntry());
  });
}, dAe = ["component", "prefixCls", "className", "disabled", "id", "style", "multiple", "accept", "capture", "children", "directory", "openFileDialogOnClick", "onMouseEnter", "onMouseLeave"], fAe = /* @__PURE__ */ function(t) {
  Pr(n, t);
  var e = Hr(n);
  function n() {
    var r;
    zn(this, n);
    for (var i = arguments.length, o = new Array(i), a = 0; a < i; a++)
      o[a] = arguments[a];
    return r = e.call.apply(e, [this].concat(o)), r.state = {
      uid: u3()
    }, r.reqs = {}, r.fileInput = void 0, r._isMounted = void 0, r.onChange = function(s) {
      var u = r.props, l = u.accept, c = u.directory, d = s.target.files, f = Ye(d).filter(function(h) {
        return !c || l3(h, l);
      });
      r.uploadFiles(f), r.reset();
    }, r.onClick = function(s) {
      var u = r.fileInput;
      if (u) {
        var l = r.props, c = l.children, d = l.onClick;
        if (c && c.type === "button") {
          var f = u.parentNode;
          f.focus(), f.querySelector("button").blur();
        }
        u.click(), d && d(s);
      }
    }, r.onKeyDown = function(s) {
      s.key === "Enter" && r.onClick(s);
    }, r.onFileDrop = function(s) {
      var u = r.props.multiple;
      if (s.preventDefault(), s.type !== "dragover")
        if (r.props.directory)
          cAe(Array.prototype.slice.call(s.dataTransfer.items), r.uploadFiles, function(c) {
            return l3(c, r.props.accept);
          });
        else {
          var l = Ye(s.dataTransfer.files).filter(function(c) {
            return l3(c, r.props.accept);
          });
          u === !1 && (l = l.slice(0, 1)), r.uploadFiles(l);
        }
    }, r.uploadFiles = function(s) {
      var u = Ye(s), l = u.map(function(c) {
        return c.uid = u3(), r.processFile(c, u);
      });
      Promise.all(l).then(function(c) {
        var d = r.props.onBatchStart;
        d == null || d(c.map(function(f) {
          var h = f.origin, p = f.parsedFile;
          return {
            file: h,
            parsedFile: p
          };
        })), c.filter(function(f) {
          return f.parsedFile !== null;
        }).forEach(function(f) {
          r.post(f);
        });
      });
    }, r.processFile = /* @__PURE__ */ function() {
      var s = ul(/* @__PURE__ */ ai().mark(function u(l, c) {
        var d, f, h, p, v, m, b, y, w;
        return ai().wrap(function(E) {
          for (; ; )
            switch (E.prev = E.next) {
              case 0:
                if (d = r.props.beforeUpload, f = l, !d) {
                  E.next = 14;
                  break;
                }
                return E.prev = 3, E.next = 6, d(l, c);
              case 6:
                f = E.sent, E.next = 12;
                break;
              case 9:
                E.prev = 9, E.t0 = E.catch(3), f = !1;
              case 12:
                if (f !== !1) {
                  E.next = 14;
                  break;
                }
                return E.abrupt("return", {
                  origin: l,
                  parsedFile: null,
                  action: null,
                  data: null
                });
              case 14:
                if (h = r.props.action, typeof h != "function") {
                  E.next = 21;
                  break;
                }
                return E.next = 18, h(l);
              case 18:
                p = E.sent, E.next = 22;
                break;
              case 21:
                p = h;
              case 22:
                if (v = r.props.data, typeof v != "function") {
                  E.next = 29;
                  break;
                }
                return E.next = 26, v(l);
              case 26:
                m = E.sent, E.next = 30;
                break;
              case 29:
                m = v;
              case 30:
                return b = // string type is from legacy `transformFile`.
                // Not sure if this will work since no related test case works with it
                (_t(f) === "object" || typeof f == "string") && f ? f : l, b instanceof File ? y = b : y = new File([b], l.name, {
                  type: l.type
                }), w = y, w.uid = l.uid, E.abrupt("return", {
                  origin: l,
                  data: m,
                  parsedFile: w,
                  action: p
                });
              case 35:
              case "end":
                return E.stop();
            }
        }, u, null, [[3, 9]]);
      }));
      return function(u, l) {
        return s.apply(this, arguments);
      };
    }(), r.saveFileInput = function(s) {
      r.fileInput = s;
    }, r;
  }
  return Gn(n, [{
    key: "componentDidMount",
    value: function() {
      this._isMounted = !0;
    }
  }, {
    key: "componentWillUnmount",
    value: function() {
      this._isMounted = !1, this.abort();
    }
  }, {
    key: "post",
    value: function(i) {
      var o = this, a = i.data, s = i.origin, u = i.action, l = i.parsedFile;
      if (this._isMounted) {
        var c = this.props, d = c.onStart, f = c.customRequest, h = c.name, p = c.headers, v = c.withCredentials, m = c.method, b = s.uid, y = f || aAe, w = {
          action: u,
          filename: h,
          data: a,
          file: l,
          headers: p,
          withCredentials: v,
          method: m || "post",
          onProgress: function(E) {
            var I = o.props.onProgress;
            I == null || I(E, l);
          },
          onSuccess: function(E, I) {
            var _ = o.props.onSuccess;
            _ == null || _(E, l, I), delete o.reqs[b];
          },
          onError: function(E, I) {
            var _ = o.props.onError;
            _ == null || _(E, I, l), delete o.reqs[b];
          }
        };
        d(s), this.reqs[b] = y(w);
      }
    }
  }, {
    key: "reset",
    value: function() {
      this.setState({
        uid: u3()
      });
    }
  }, {
    key: "abort",
    value: function(i) {
      var o = this.reqs;
      if (i) {
        var a = i.uid ? i.uid : i;
        o[a] && o[a].abort && o[a].abort(), delete o[a];
      } else
        Object.keys(o).forEach(function(s) {
          o[s] && o[s].abort && o[s].abort(), delete o[s];
        });
    }
  }, {
    key: "render",
    value: function() {
      var i, o = this.props, a = o.component, s = o.prefixCls, u = o.className, l = o.disabled, c = o.id, d = o.style, f = o.multiple, h = o.accept, p = o.capture, v = o.children, m = o.directory, b = o.openFileDialogOnClick, y = o.onMouseEnter, w = o.onMouseLeave, S = Gt(o, dAe), E = Ce((i = {}, z(i, s, !0), z(i, "".concat(s, "-disabled"), l), z(i, u, u), i)), I = m ? {
        directory: "directory",
        webkitdirectory: "webkitdirectory"
      } : {}, _ = l ? {} : {
        onClick: b ? this.onClick : function() {
        },
        onKeyDown: b ? this.onKeyDown : function() {
        },
        onMouseEnter: y,
        onMouseLeave: w,
        onDrop: this.onFileDrop,
        onDragOver: this.onFileDrop,
        tabIndex: "0"
      };
      return /* @__PURE__ */ O.createElement(a, G({}, _, {
        className: E,
        role: "button",
        style: d
      }), /* @__PURE__ */ O.createElement("input", G({}, H0(S, {
        aria: !0,
        data: !0
      }), {
        id: c,
        disabled: l,
        type: "file",
        ref: this.saveFileInput,
        onClick: function(P) {
          return P.stopPropagation();
        },
        key: this.state.uid,
        style: {
          display: "none"
        },
        accept: h
      }, I, {
        multiple: f,
        onChange: this.onChange
      }, p != null ? {
        capture: p
      } : {})), v);
    }
  }]), n;
}(Do);
function c3() {
}
var C_ = /* @__PURE__ */ function(t) {
  Pr(n, t);
  var e = Hr(n);
  function n() {
    var r;
    zn(this, n);
    for (var i = arguments.length, o = new Array(i), a = 0; a < i; a++)
      o[a] = arguments[a];
    return r = e.call.apply(e, [this].concat(o)), r.uploader = void 0, r.saveUploader = function(s) {
      r.uploader = s;
    }, r;
  }
  return Gn(n, [{
    key: "abort",
    value: function(i) {
      this.uploader.abort(i);
    }
  }, {
    key: "render",
    value: function() {
      return /* @__PURE__ */ O.createElement(fAe, G({}, this.props, {
        ref: this.saveUploader
      }));
    }
  }]), n;
}(Do);
C_.defaultProps = {
  component: "span",
  prefixCls: "rc-upload",
  data: {},
  headers: {},
  name: "file",
  multipart: !1,
  onStart: c3,
  onError: c3,
  onSuccess: c3,
  multiple: !1,
  beforeUpload: null,
  customRequest: null,
  withCredentials: !1,
  openFileDialogOnClick: !0
};
function sb(t) {
  return G(G({}, t), {
    lastModified: t.lastModified,
    lastModifiedDate: t.lastModifiedDate,
    name: t.name,
    size: t.size,
    type: t.type,
    uid: t.uid,
    percent: 0,
    originFileObj: t
  });
}
function ub(t, e) {
  var n = Ye(e), r = n.findIndex(function(i) {
    var o = i.uid;
    return o === t.uid;
  });
  return r === -1 ? n.push(t) : n[r] = t, n;
}
function d3(t, e) {
  var n = t.uid !== void 0 ? "uid" : "name";
  return e.filter(function(r) {
    return r[n] === t[n];
  })[0];
}
function hAe(t, e) {
  var n = t.uid !== void 0 ? "uid" : "name", r = e.filter(function(i) {
    return i[n] !== t[n];
  });
  return r.length === e.length ? null : r;
}
var pAe = function() {
  var e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "", n = e.split("/"), r = n[n.length - 1], i = r.split(/#|\?/)[0];
  return (/\.[^./\\]*$/.exec(i) || [""])[0];
}, _X = function(e) {
  return e.indexOf("image/") === 0;
}, gAe = function(e) {
  if (e.type && !e.thumbUrl)
    return _X(e.type);
  var n = e.thumbUrl || e.url || "", r = pAe(n);
  return /^data:image\//.test(n) || /(webp|svg|png|gif|jpg|jpeg|jfif|bmp|dpg|ico|heic|heif)$/i.test(r) ? !0 : !(/^data:/.test(n) || r);
}, Rl = 200;
function mAe(t) {
  return new Promise(function(e) {
    if (!t.type || !_X(t.type)) {
      e("");
      return;
    }
    var n = document.createElement("canvas");
    n.width = Rl, n.height = Rl, n.style.cssText = "position: fixed; left: 0; top: 0; width: ".concat(Rl, "px; height: ").concat(Rl, "px; z-index: 9999; display: none;"), document.body.appendChild(n);
    var r = n.getContext("2d"), i = new Image();
    if (i.onload = function() {
      var s = i.width, u = i.height, l = Rl, c = Rl, d = 0, f = 0;
      s > u ? (c = u * (Rl / s), f = -(c - l) / 2) : (l = s * (Rl / u), d = -(l - c) / 2), r.drawImage(i, d, f, l, c);
      var h = n.toDataURL();
      document.body.removeChild(n), window.URL.revokeObjectURL(i.src), e(h);
    }, i.crossOrigin = "anonymous", t.type.startsWith("image/svg+xml")) {
      var o = new FileReader();
      o.onload = function() {
        o.result && (i.src = o.result);
      }, o.readAsDataURL(t);
    } else if (t.type.startsWith("image/gif")) {
      var a = new FileReader();
      a.onload = function() {
        a.result && e(a.result);
      }, a.readAsDataURL(t);
    } else
      i.src = window.URL.createObjectURL(t);
  });
}
var vAe = /* @__PURE__ */ x.forwardRef(function(t, e) {
  var n = t.prefixCls, r = t.className, i = t.style, o = t.locale, a = t.listType, s = t.file, u = t.items, l = t.progress, c = t.iconRender, d = t.actionIconRender, f = t.itemRender, h = t.isImgUrl, p = t.showPreviewIcon, v = t.showRemoveIcon, m = t.showDownloadIcon, b = t.previewIcon, y = t.removeIcon, w = t.downloadIcon, S = t.onPreview, E = t.onDownload, I = t.onClose, _, A, P = s.status, N = x.useState(P), k = be(N, 2), D = k[0], R = k[1];
  x.useEffect(function() {
    P !== "removed" && R(P);
  }, [P]);
  var V = x.useState(!1), $ = be(V, 2), F = $[0], M = $[1], B = x.useRef(null);
  x.useEffect(function() {
    return B.current = setTimeout(function() {
      M(!0);
    }, 300), function() {
      B.current && clearTimeout(B.current);
    };
  }, []);
  var X = "".concat(n, "-span"), L = c(s), j = /* @__PURE__ */ x.createElement("div", {
    className: "".concat(n, "-text-icon")
  }, L);
  if (a === "picture" || a === "picture-card")
    if (D === "uploading" || !s.thumbUrl && !s.url) {
      var K = Ce(z(z({}, "".concat(n, "-list-item-thumbnail"), !0), "".concat(n, "-list-item-file"), D !== "uploading"));
      j = /* @__PURE__ */ x.createElement("div", {
        className: K
      }, L);
    } else {
      var W = h != null && h(s) ? /* @__PURE__ */ x.createElement("img", {
        src: s.thumbUrl || s.url,
        alt: s.name,
        className: "".concat(n, "-list-item-image"),
        crossOrigin: s.crossOrigin
      }) : L, Y = Ce(z(z({}, "".concat(n, "-list-item-thumbnail"), !0), "".concat(n, "-list-item-file"), h && !h(s)));
      j = /* @__PURE__ */ x.createElement("a", {
        className: Y,
        onClick: function(we) {
          return S(s, we);
        },
        href: s.url || s.thumbUrl,
        target: "_blank",
        rel: "noopener noreferrer"
      }, W);
    }
  var U = Ce(z(z(z({}, "".concat(n, "-list-item"), !0), "".concat(n, "-list-item-").concat(D), !0), "".concat(n, "-list-item-list-type-").concat(a), !0)), Q = typeof s.linkProps == "string" ? JSON.parse(s.linkProps) : s.linkProps, Z = v ? d((typeof y == "function" ? y(s) : y) || /* @__PURE__ */ x.createElement(nA, null), function() {
    return I(s);
  }, n, o.removeFile) : null, ee = m && D === "done" ? d((typeof w == "function" ? w(s) : w) || /* @__PURE__ */ x.createElement(nj, null), function() {
    return E(s);
  }, n, o.downloadFile) : null, ie = a !== "picture-card" && /* @__PURE__ */ x.createElement("span", {
    key: "download-delete",
    className: Ce("".concat(n, "-list-item-card-actions"), {
      picture: a === "picture"
    })
  }, ee, Z), oe = Ce("".concat(n, "-list-item-name")), se = s.url ? [/* @__PURE__ */ x.createElement("a", G({
    key: "view",
    target: "_blank",
    rel: "noopener noreferrer",
    className: oe,
    title: s.name
  }, Q, {
    href: s.url,
    onClick: function(we) {
      return S(s, we);
    }
  }), s.name), ie] : [/* @__PURE__ */ x.createElement("span", {
    key: "view",
    className: oe,
    onClick: function(we) {
      return S(s, we);
    },
    title: s.name
  }, s.name), ie], te = {
    pointerEvents: "none",
    opacity: 0.5
  }, ge = p ? /* @__PURE__ */ x.createElement("a", {
    href: s.url || s.thumbUrl,
    target: "_blank",
    rel: "noopener noreferrer",
    style: s.url || s.thumbUrl ? void 0 : te,
    onClick: function(we) {
      return S(s, we);
    },
    title: o.previewFile
  }, typeof b == "function" ? b(s) : b || /* @__PURE__ */ x.createElement(cj, null)) : null, he = a === "picture-card" && D !== "uploading" && /* @__PURE__ */ x.createElement("span", {
    className: "".concat(n, "-list-item-actions")
  }, ge, D === "done" && ee, Z), fe;
  s.response && typeof s.response == "string" ? fe = s.response : fe = ((_ = s.error) === null || _ === void 0 ? void 0 : _.statusText) || ((A = s.error) === null || A === void 0 ? void 0 : A.message) || o.uploadError;
  var _e = /* @__PURE__ */ x.createElement("span", {
    className: X
  }, j, se), Ne = x.useContext(en), ze = Ne.getPrefixCls, Ve = ze(), ne = /* @__PURE__ */ x.createElement("div", {
    className: U
  }, /* @__PURE__ */ x.createElement("div", {
    className: "".concat(n, "-list-item-info")
  }, _e), he, F && /* @__PURE__ */ x.createElement(ll, {
    motionName: "".concat(Ve, "-fade"),
    visible: D === "uploading",
    motionDeadline: 2e3
  }, function(Ae) {
    var we = Ae.className, ce = "percent" in s ? /* @__PURE__ */ x.createElement(USe, G({}, l, {
      type: "line",
      percent: s.percent
    })) : null;
    return /* @__PURE__ */ x.createElement("div", {
      className: Ce("".concat(n, "-list-item-progress"), we)
    }, ce);
  })), pe = Ce("".concat(n, "-list-").concat(a, "-container"), r), ye = D === "error" ? /* @__PURE__ */ x.createElement(Ud, {
    title: fe,
    getPopupContainer: function(we) {
      return we.parentNode;
    }
  }, ne) : ne;
  return /* @__PURE__ */ x.createElement("div", {
    className: pe,
    style: i,
    ref: e
  }, f ? f(ye, s, u, {
    download: E.bind(null, s),
    preview: S.bind(null, s),
    remove: I.bind(null, s)
  }) : ye);
});
const bAe = vAe;
var HC = G({}, mx);
delete HC.onAppearEnd;
delete HC.onEnterEnd;
delete HC.onLeaveEnd;
var yAe = function(e, n) {
  var r = e.listType, i = r === void 0 ? "text" : r, o = e.previewFile, a = o === void 0 ? mAe : o, s = e.onPreview, u = e.onDownload, l = e.onRemove, c = e.locale, d = e.iconRender, f = e.isImageUrl, h = f === void 0 ? gAe : f, p = e.prefixCls, v = e.items, m = v === void 0 ? [] : v, b = e.showPreviewIcon, y = b === void 0 ? !0 : b, w = e.showRemoveIcon, S = w === void 0 ? !0 : w, E = e.showDownloadIcon, I = E === void 0 ? !1 : E, _ = e.removeIcon, A = e.previewIcon, P = e.downloadIcon, N = e.progress, k = N === void 0 ? {
    strokeWidth: 2,
    showInfo: !1
  } : N, D = e.appendAction, R = e.appendActionVisible, V = R === void 0 ? !0 : R, $ = e.itemRender, F = e.disabled, M = EG(), B = x.useState(!1), X = be(B, 2), L = X[0], j = X[1];
  x.useEffect(function() {
    i !== "picture" && i !== "picture-card" || (m || []).forEach(function(fe) {
      typeof document > "u" || typeof window > "u" || !window.FileReader || !window.File || !(fe.originFileObj instanceof File || fe.originFileObj instanceof Blob) || fe.thumbUrl !== void 0 || (fe.thumbUrl = "", a && a(fe.originFileObj).then(function(_e) {
        fe.thumbUrl = _e || "", M();
      }));
    });
  }, [i, m, a]), x.useEffect(function() {
    j(!0);
  }, []);
  var K = function(_e, Ne) {
    if (s)
      return Ne == null || Ne.preventDefault(), s(_e);
  }, W = function(_e) {
    typeof u == "function" ? u(_e) : _e.url && window.open(_e.url);
  }, Y = function(_e) {
    l == null || l(_e);
  }, U = function(_e) {
    if (d)
      return d(_e, i);
    var Ne = _e.status === "uploading", ze = h && h(_e) ? /* @__PURE__ */ x.createElement(l0e, null) : /* @__PURE__ */ x.createElement(Yge, null), Ve = Ne ? /* @__PURE__ */ x.createElement(lc, null) : /* @__PURE__ */ x.createElement(a0e, null);
    return i === "picture" ? Ve = Ne ? /* @__PURE__ */ x.createElement(lc, null) : ze : i === "picture-card" && (Ve = Ne ? c.uploading : ze), Ve;
  }, Q = function(_e, Ne, ze, Ve) {
    var ne = {
      type: "text",
      size: "small",
      title: Ve,
      disabled: F,
      onClick: function(Ae) {
        Ne(), pa(_e) && _e.props.onClick && _e.props.onClick(Ae);
      },
      className: "".concat(ze, "-list-item-card-actions-btn")
    };
    if (pa(_e)) {
      var pe = ji(_e, G(G({}, _e.props), {
        onClick: function() {
        }
      }));
      return /* @__PURE__ */ x.createElement(ko, G({}, ne, {
        icon: pe
      }));
    }
    return /* @__PURE__ */ x.createElement(ko, G({}, ne), /* @__PURE__ */ x.createElement("span", null, _e));
  };
  x.useImperativeHandle(n, function() {
    return {
      handlePreview: K,
      handleDownload: W
    };
  });
  var Z = x.useContext(en), ee = Z.getPrefixCls, ie = Z.direction, oe = ee("upload", p), se = Ce(z(z(z({}, "".concat(oe, "-list"), !0), "".concat(oe, "-list-").concat(i), !0), "".concat(oe, "-list-rtl"), ie === "rtl")), te = Ye(m.map(function(fe) {
    return {
      key: fe.uid,
      file: fe
    };
  })), ge = i === "picture-card" ? "animate-inline" : "animate", he = {
    motionDeadline: 2e3,
    motionName: "".concat(oe, "-").concat(ge),
    keys: te,
    motionAppear: L
  };
  return i !== "picture-card" && (he = G(G({}, HC), he)), /* @__PURE__ */ x.createElement("div", {
    className: se
  }, /* @__PURE__ */ x.createElement(sA, G({}, he, {
    component: !1
  }), function(fe) {
    var _e = fe.key, Ne = fe.file, ze = fe.className, Ve = fe.style;
    return /* @__PURE__ */ x.createElement(bAe, {
      key: _e,
      locale: c,
      prefixCls: oe,
      className: ze,
      style: Ve,
      file: Ne,
      items: m,
      progress: k,
      listType: i,
      isImgUrl: h,
      showPreviewIcon: y,
      showRemoveIcon: S,
      showDownloadIcon: I,
      removeIcon: _,
      previewIcon: A,
      downloadIcon: P,
      iconRender: U,
      actionIconRender: Q,
      itemRender: $,
      onPreview: K,
      onDownload: W,
      onClose: Y
    });
  }), D && /* @__PURE__ */ x.createElement(ll, G({}, he, {
    visible: V,
    forceRender: !0
  }), function(fe) {
    var _e = fe.className, Ne = fe.style;
    return ji(D, function(ze) {
      return {
        className: Ce(ze.className, _e),
        style: G(G(G({}, Ne), {
          // prevent the element has hover css pseudo-class that may cause animation to end prematurely.
          pointerEvents: _e ? "none" : void 0
        }), ze.style)
      };
    });
  }));
}, AX = /* @__PURE__ */ x.forwardRef(yAe);
process.env.NODE_ENV !== "production" && (AX.displayName = "UploadList");
const xAe = AX;
var CAe = function(t, e, n, r) {
  function i(o) {
    return o instanceof n ? o : new n(function(a) {
      a(o);
    });
  }
  return new (n || (n = Promise))(function(o, a) {
    function s(c) {
      try {
        l(r.next(c));
      } catch (d) {
        a(d);
      }
    }
    function u(c) {
      try {
        l(r.throw(c));
      } catch (d) {
        a(d);
      }
    }
    function l(c) {
      c.done ? o(c.value) : i(c.value).then(s, u);
    }
    l((r = r.apply(t, e || [])).next());
  });
}, Qg = "__LIST_IGNORE_".concat(Date.now(), "__"), wAe = function(e, n) {
  var r = e.fileList, i = e.defaultFileList, o = e.onRemove, a = e.showUploadList, s = a === void 0 ? !0 : a, u = e.listType, l = u === void 0 ? "text" : u, c = e.onPreview, d = e.onDownload, f = e.onChange, h = e.onDrop, p = e.previewFile, v = e.disabled, m = e.locale, b = e.iconRender, y = e.isImageUrl, w = e.progress, S = e.prefixCls, E = e.className, I = e.type, _ = I === void 0 ? "select" : I, A = e.children, P = e.style, N = e.itemRender, k = e.maxCount, D = e.data, R = D === void 0 ? {} : D, V = e.multiple, $ = V === void 0 ? !1 : V, F = e.action, M = F === void 0 ? "" : F, B = e.accept, X = B === void 0 ? "" : B, L = e.supportServerRender, j = L === void 0 ? !0 : L, K = x.useContext(Ka), W = v ?? K, Y = Tr(i || [], {
    value: r,
    postState: function(Je) {
      return Je ?? [];
    }
  }), U = be(Y, 2), Q = U[0], Z = U[1], ee = x.useState("drop"), ie = be(ee, 2), oe = ie[0], se = ie[1], te = x.useRef(null);
  process.env.NODE_ENV !== "production" && gn("fileList" in e || !("value" in e), "Upload", "`value` is not a valid prop, do you mean `fileList`?"), process.env.NODE_ENV !== "production" && gn(!("transformFile" in e), "Upload", "`transformFile` is deprecated. Please use `beforeUpload` directly."), x.useMemo(function() {
    var at = Date.now();
    (r || []).forEach(function(Je, ut) {
      !Je.uid && !Object.isFrozen(Je) && (Je.uid = "__AUTO__".concat(at, "_").concat(ut, "__"));
    });
  }, [r]);
  var ge = function(Je, ut, Ct) {
    var Ke = Ye(ut);
    k === 1 ? Ke = Ke.slice(-1) : k && (Ke = Ke.slice(0, k)), sc(function() {
      Z(Ke);
    });
    var st = {
      file: Je,
      fileList: Ke
    };
    Ct && (st.event = Ct), sc(function() {
      f == null || f(st);
    });
  }, he = function(Je, ut) {
    return CAe(void 0, void 0, void 0, /* @__PURE__ */ ai().mark(function Ct() {
      var Ke, st, wt, qt;
      return ai().wrap(function(Me) {
        for (; ; )
          switch (Me.prev = Me.next) {
            case 0:
              if (Ke = e.beforeUpload, st = e.transformFile, wt = Je, !Ke) {
                Me.next = 13;
                break;
              }
              return Me.next = 5, Ke(Je, ut);
            case 5:
              if (qt = Me.sent, qt !== !1) {
                Me.next = 8;
                break;
              }
              return Me.abrupt("return", !1);
            case 8:
              if (delete Je[Qg], qt !== Qg) {
                Me.next = 12;
                break;
              }
              return Object.defineProperty(Je, Qg, {
                value: !0,
                configurable: !0
              }), Me.abrupt("return", !1);
            case 12:
              _t(qt) === "object" && qt && (wt = qt);
            case 13:
              if (!st) {
                Me.next = 17;
                break;
              }
              return Me.next = 16, st(wt);
            case 16:
              wt = Me.sent;
            case 17:
              return Me.abrupt("return", wt);
            case 18:
            case "end":
              return Me.stop();
          }
      }, Ct);
    }));
  }, fe = function(Je) {
    var ut = Je.filter(function(st) {
      return !st.file[Qg];
    });
    if (ut.length) {
      var Ct = ut.map(function(st) {
        return sb(st.file);
      }), Ke = Ye(Q);
      Ct.forEach(function(st) {
        Ke = ub(st, Ke);
      }), Ct.forEach(function(st, wt) {
        var qt = st;
        if (ut[wt].parsedFile)
          st.status = "uploading";
        else {
          var bt = st.originFileObj, Me;
          try {
            Me = new File([bt], bt.name, {
              type: bt.type
            });
          } catch {
            Me = new Blob([bt], {
              type: bt.type
            }), Me.name = bt.name, Me.lastModifiedDate = /* @__PURE__ */ new Date(), Me.lastModified = (/* @__PURE__ */ new Date()).getTime();
          }
          Me.uid = st.uid, qt = Me;
        }
        ge(qt, Ke);
      });
    }
  }, _e = function(Je, ut, Ct) {
    try {
      typeof Je == "string" && (Je = JSON.parse(Je));
    } catch {
    }
    if (d3(ut, Q)) {
      var Ke = sb(ut);
      Ke.status = "done", Ke.percent = 100, Ke.response = Je, Ke.xhr = Ct;
      var st = ub(Ke, Q);
      ge(Ke, st);
    }
  }, Ne = function(Je, ut) {
    if (d3(ut, Q)) {
      var Ct = sb(ut);
      Ct.status = "uploading", Ct.percent = Je.percent;
      var Ke = ub(Ct, Q);
      ge(Ct, Ke, Je);
    }
  }, ze = function(Je, ut, Ct) {
    if (d3(Ct, Q)) {
      var Ke = sb(Ct);
      Ke.error = Je, Ke.response = ut, Ke.status = "error";
      var st = ub(Ke, Q);
      ge(Ke, st);
    }
  }, Ve = function(Je) {
    var ut;
    Promise.resolve(typeof o == "function" ? o(Je) : o).then(function(Ct) {
      var Ke;
      if (Ct !== !1) {
        var st = hAe(Je, Q);
        st && (ut = G(G({}, Je), {
          status: "removed"
        }), Q == null || Q.forEach(function(wt) {
          var qt = ut.uid !== void 0 ? "uid" : "name";
          wt[qt] === ut[qt] && !Object.isFrozen(wt) && (wt.status = "removed");
        }), (Ke = te.current) === null || Ke === void 0 || Ke.abort(ut), ge(ut, st));
      }
    });
  }, ne = function(Je) {
    se(Je.type), Je.type === "drop" && (h == null || h(Je));
  };
  x.useImperativeHandle(n, function() {
    return {
      onBatchStart: fe,
      onSuccess: _e,
      onProgress: Ne,
      onError: ze,
      fileList: Q,
      upload: te.current
    };
  });
  var pe = x.useContext(en), ye = pe.getPrefixCls, Ae = pe.direction, we = ye("upload", S), ce = G(G({
    onBatchStart: fe,
    onError: ze,
    onProgress: Ne,
    onSuccess: _e
  }, e), {
    data: R,
    multiple: $,
    action: M,
    accept: X,
    supportServerRender: j,
    prefixCls: we,
    disabled: W,
    beforeUpload: he,
    onChange: void 0
  });
  delete ce.className, delete ce.style, (!A || W) && delete ce.id;
  var ve = function(Je, ut) {
    return s ? /* @__PURE__ */ x.createElement(Ic, {
      componentName: "Upload",
      defaultLocale: fu.Upload
    }, function(Ct) {
      var Ke = typeof s == "boolean" ? {} : s, st = Ke.showRemoveIcon, wt = Ke.showPreviewIcon, qt = Ke.showDownloadIcon, bt = Ke.removeIcon, Me = Ke.previewIcon, yt = Ke.downloadIcon;
      return /* @__PURE__ */ x.createElement(xAe, {
        prefixCls: we,
        listType: l,
        items: Q,
        previewFile: p,
        onPreview: c,
        onDownload: d,
        onRemove: Ve,
        showRemoveIcon: !W && st,
        showPreviewIcon: wt,
        showDownloadIcon: qt,
        removeIcon: bt,
        previewIcon: Me,
        downloadIcon: yt,
        iconRender: b,
        locale: G(G({}, Ct), m),
        isImageUrl: y,
        progress: w,
        appendAction: Je,
        appendActionVisible: ut,
        itemRender: N,
        disabled: W
      });
    }) : Je;
  };
  if (_ === "drag") {
    var Ie = Ce(we, z(z(z(z(z({}, "".concat(we, "-drag"), !0), "".concat(we, "-drag-uploading"), Q.some(function(at) {
      return at.status === "uploading";
    })), "".concat(we, "-drag-hover"), oe === "dragover"), "".concat(we, "-disabled"), W), "".concat(we, "-rtl"), Ae === "rtl"), E);
    return /* @__PURE__ */ x.createElement("span", null, /* @__PURE__ */ x.createElement("div", {
      className: Ie,
      onDrop: ne,
      onDragOver: ne,
      onDragLeave: ne,
      style: P
    }, /* @__PURE__ */ x.createElement(C_, G({}, ce, {
      ref: te,
      className: "".concat(we, "-btn")
    }), /* @__PURE__ */ x.createElement("div", {
      className: "".concat(we, "-drag-container")
    }, A))), ve());
  }
  var q = Ce(we, z(z(z(z({}, "".concat(we, "-select"), !0), "".concat(we, "-select-").concat(l), !0), "".concat(we, "-disabled"), W), "".concat(we, "-rtl"), Ae === "rtl")), Fe = function(Je) {
    return /* @__PURE__ */ x.createElement("div", {
      className: q,
      style: Je
    }, /* @__PURE__ */ x.createElement(C_, G({}, ce, {
      ref: te
    })));
  }, Ze = Fe(A ? void 0 : {
    display: "none"
  });
  return l === "picture-card" ? /* @__PURE__ */ x.createElement("span", {
    className: Ce("".concat(we, "-picture-card-wrapper"), E)
  }, ve(Ze, !!A)) : /* @__PURE__ */ x.createElement("span", {
    className: E
  }, Ze, ve());
}, TX = /* @__PURE__ */ x.forwardRef(wAe);
process.env.NODE_ENV !== "production" && (TX.displayName = "Upload");
const OX = TX;
var EAe = function(t, e) {
  var n = {};
  for (var r in t)
    Object.prototype.hasOwnProperty.call(t, r) && e.indexOf(r) < 0 && (n[r] = t[r]);
  if (t != null && typeof Object.getOwnPropertySymbols == "function")
    for (var i = 0, r = Object.getOwnPropertySymbols(t); i < r.length; i++)
      e.indexOf(r[i]) < 0 && Object.prototype.propertyIsEnumerable.call(t, r[i]) && (n[r[i]] = t[r[i]]);
  return n;
}, PX = /* @__PURE__ */ x.forwardRef(function(t, e) {
  var n = t.style, r = t.height, i = EAe(t, ["style", "height"]);
  return /* @__PURE__ */ x.createElement(OX, G({
    ref: e
  }, i, {
    type: "drag",
    style: G(G({}, n), {
      height: r
    })
  }));
});
process.env.NODE_ENV !== "production" && (PX.displayName = "Dragger");
const SAe = PX;
var s9 = OX;
s9.Dragger = SAe;
s9.LIST_IGNORE = Qg;
const IAe = s9;
var n$ = xp, _Ae = n9, AAe = Mo, r$ = n$ ? n$.isConcatSpreadable : void 0;
function TAe(t) {
  return AAe(t) || _Ae(t) || !!(r$ && t && t[r$]);
}
var OAe = TAe, PAe = e9, NAe = OAe;
function NX(t, e, n, r, i) {
  var o = -1, a = t.length;
  for (n || (n = NAe), i || (i = []); ++o < a; ) {
    var s = t[o];
    e > 0 && n(s) ? e > 1 ? NX(s, e - 1, n, r, i) : PAe(i, s) : r || (i[i.length] = s);
  }
  return i;
}
var kX = NX, kAe = kX, RAe = 1 / 0;
function $Ae(t) {
  var e = t == null ? 0 : t.length;
  return e ? kAe(t, RAe) : [];
}
var DAe = $Ae;
const Um = /* @__PURE__ */ qn(DAe);
function MAe(t, e) {
  for (var n = -1, r = t == null ? 0 : t.length; ++n < r && e(t[n], n, t) !== !1; )
    ;
  return t;
}
var FAe = MAe, LAe = Zd, VAe = function() {
  try {
    var t = LAe(Object, "defineProperty");
    return t({}, "", {}), t;
  } catch {
  }
}(), RX = VAe, i$ = RX;
function BAe(t, e, n) {
  e == "__proto__" && i$ ? i$(t, e, {
    configurable: !0,
    enumerable: !0,
    value: n,
    writable: !0
  }) : t[e] = n;
}
var $X = BAe, HAe = $X, WAe = PC, jAe = Object.prototype, zAe = jAe.hasOwnProperty;
function GAe(t, e, n) {
  var r = t[e];
  (!(zAe.call(t, e) && WAe(r, n)) || n === void 0 && !(e in t)) && HAe(t, e, n);
}
var u9 = GAe, UAe = u9, XAe = $X;
function YAe(t, e, n, r) {
  var i = !n;
  n || (n = {});
  for (var o = -1, a = e.length; ++o < a; ) {
    var s = e[o], u = r ? r(n[s], t[s], s, n, t) : void 0;
    u === void 0 && (u = t[s]), i ? XAe(n, s, u) : UAe(n, s, u);
  }
  return n;
}
var Xm = YAe, ZAe = Xm, JAe = Gm;
function KAe(t, e) {
  return t && ZAe(e, JAe(e), t);
}
var qAe = KAe;
function QAe(t) {
  var e = [];
  if (t != null)
    for (var n in Object(t))
      e.push(n);
  return e;
}
var e9e = QAe, t9e = Ds, n9e = o9, r9e = e9e, i9e = Object.prototype, o9e = i9e.hasOwnProperty;
function a9e(t) {
  if (!t9e(t))
    return r9e(t);
  var e = n9e(t), n = [];
  for (var r in t)
    r == "constructor" && (e || !o9e.call(t, r)) || n.push(r);
  return n;
}
var s9e = a9e, u9e = bX, l9e = s9e, c9e = zm;
function d9e(t) {
  return c9e(t) ? u9e(t, !0) : l9e(t);
}
var l9 = d9e, f9e = Xm, h9e = l9;
function p9e(t, e) {
  return t && f9e(e, h9e(e), t);
}
var g9e = p9e, Px = { exports: {} };
Px.exports;
(function(t, e) {
  var n = $s, r = e && !e.nodeType && e, i = r && !0 && t && !t.nodeType && t, o = i && i.exports === r, a = o ? n.Buffer : void 0, s = a ? a.allocUnsafe : void 0;
  function u(l, c) {
    if (c)
      return l.slice();
    var d = l.length, f = s ? s(d) : new l.constructor(d);
    return l.copy(f), f;
  }
  t.exports = u;
})(Px, Px.exports);
var m9e = Px.exports;
function v9e(t, e) {
  var n = -1, r = t.length;
  for (e || (e = Array(r)); ++n < r; )
    e[n] = t[n];
  return e;
}
var b9e = v9e, y9e = Xm, x9e = t9;
function C9e(t, e) {
  return y9e(t, x9e(t), e);
}
var w9e = C9e, E9e = yX, S9e = E9e(Object.getPrototypeOf, Object), c9 = S9e, I9e = e9, _9e = c9, A9e = t9, T9e = gX, O9e = Object.getOwnPropertySymbols, P9e = O9e ? function(t) {
  for (var e = []; t; )
    I9e(e, A9e(t)), t = _9e(t);
  return e;
} : T9e, DX = P9e, N9e = Xm, k9e = DX;
function R9e(t, e) {
  return N9e(t, k9e(t), e);
}
var $9e = R9e, D9e = pX, M9e = DX, F9e = l9;
function L9e(t) {
  return D9e(t, F9e, M9e);
}
var MX = L9e, V9e = Object.prototype, B9e = V9e.hasOwnProperty;
function H9e(t) {
  var e = t.length, n = new t.constructor(e);
  return e && typeof t[0] == "string" && B9e.call(t, "index") && (n.index = t.index, n.input = t.input), n;
}
var W9e = H9e, o$ = hX;
function j9e(t) {
  var e = new t.constructor(t.byteLength);
  return new o$(e).set(new o$(t)), e;
}
var d9 = j9e, z9e = d9;
function G9e(t, e) {
  var n = e ? z9e(t.buffer) : t.buffer;
  return new t.constructor(n, t.byteOffset, t.byteLength);
}
var U9e = G9e, X9e = /\w*$/;
function Y9e(t) {
  var e = new t.constructor(t.source, X9e.exec(t));
  return e.lastIndex = t.lastIndex, e;
}
var Z9e = Y9e, a$ = xp, s$ = a$ ? a$.prototype : void 0, u$ = s$ ? s$.valueOf : void 0;
function J9e(t) {
  return u$ ? Object(u$.call(t)) : {};
}
var K9e = J9e, q9e = d9;
function Q9e(t, e) {
  var n = e ? q9e(t.buffer) : t.buffer;
  return new t.constructor(n, t.byteOffset, t.length);
}
var eTe = Q9e, tTe = d9, nTe = U9e, rTe = Z9e, iTe = K9e, oTe = eTe, aTe = "[object Boolean]", sTe = "[object Date]", uTe = "[object Map]", lTe = "[object Number]", cTe = "[object RegExp]", dTe = "[object Set]", fTe = "[object String]", hTe = "[object Symbol]", pTe = "[object ArrayBuffer]", gTe = "[object DataView]", mTe = "[object Float32Array]", vTe = "[object Float64Array]", bTe = "[object Int8Array]", yTe = "[object Int16Array]", xTe = "[object Int32Array]", CTe = "[object Uint8Array]", wTe = "[object Uint8ClampedArray]", ETe = "[object Uint16Array]", STe = "[object Uint32Array]";
function ITe(t, e, n) {
  var r = t.constructor;
  switch (e) {
    case pTe:
      return tTe(t);
    case aTe:
    case sTe:
      return new r(+t);
    case gTe:
      return nTe(t, n);
    case mTe:
    case vTe:
    case bTe:
    case yTe:
    case xTe:
    case CTe:
    case wTe:
    case ETe:
    case STe:
      return oTe(t, n);
    case uTe:
      return new r();
    case lTe:
    case fTe:
      return new r(t);
    case cTe:
      return rTe(t);
    case dTe:
      return new r();
    case hTe:
      return iTe(t);
  }
}
var _Te = ITe, ATe = Ds, l$ = Object.create, TTe = /* @__PURE__ */ function() {
  function t() {
  }
  return function(e) {
    if (!ATe(e))
      return {};
    if (l$)
      return l$(e);
    t.prototype = e;
    var n = new t();
    return t.prototype = void 0, n;
  };
}(), OTe = TTe, PTe = OTe, NTe = c9, kTe = o9;
function RTe(t) {
  return typeof t.constructor == "function" && !kTe(t) ? PTe(NTe(t)) : {};
}
var $Te = RTe, DTe = LC, MTe = xu, FTe = "[object Map]";
function LTe(t) {
  return MTe(t) && DTe(t) == FTe;
}
var VTe = LTe, BTe = VTe, HTe = MC, c$ = FC, d$ = c$ && c$.isMap, WTe = d$ ? HTe(d$) : BTe, jTe = WTe, zTe = LC, GTe = xu, UTe = "[object Set]";
function XTe(t) {
  return GTe(t) && zTe(t) == UTe;
}
var YTe = XTe, ZTe = YTe, JTe = MC, f$ = FC, h$ = f$ && f$.isSet, KTe = h$ ? JTe(h$) : ZTe, qTe = KTe, QTe = qA, eOe = FAe, tOe = u9, nOe = qAe, rOe = g9e, iOe = m9e, oOe = b9e, aOe = w9e, sOe = $9e, uOe = xX, lOe = MX, cOe = LC, dOe = W9e, fOe = _Te, hOe = $Te, pOe = Mo, gOe = r9, mOe = jTe, vOe = Ds, bOe = qTe, yOe = Gm, xOe = l9, COe = 1, wOe = 2, EOe = 4, FX = "[object Arguments]", SOe = "[object Array]", IOe = "[object Boolean]", _Oe = "[object Date]", AOe = "[object Error]", LX = "[object Function]", TOe = "[object GeneratorFunction]", OOe = "[object Map]", POe = "[object Number]", VX = "[object Object]", NOe = "[object RegExp]", kOe = "[object Set]", ROe = "[object String]", $Oe = "[object Symbol]", DOe = "[object WeakMap]", MOe = "[object ArrayBuffer]", FOe = "[object DataView]", LOe = "[object Float32Array]", VOe = "[object Float64Array]", BOe = "[object Int8Array]", HOe = "[object Int16Array]", WOe = "[object Int32Array]", jOe = "[object Uint8Array]", zOe = "[object Uint8ClampedArray]", GOe = "[object Uint16Array]", UOe = "[object Uint32Array]", kr = {};
kr[FX] = kr[SOe] = kr[MOe] = kr[FOe] = kr[IOe] = kr[_Oe] = kr[LOe] = kr[VOe] = kr[BOe] = kr[HOe] = kr[WOe] = kr[OOe] = kr[POe] = kr[VX] = kr[NOe] = kr[kOe] = kr[ROe] = kr[$Oe] = kr[jOe] = kr[zOe] = kr[GOe] = kr[UOe] = !0;
kr[AOe] = kr[LX] = kr[DOe] = !1;
function hy(t, e, n, r, i, o) {
  var a, s = e & COe, u = e & wOe, l = e & EOe;
  if (n && (a = i ? n(t, r, i, o) : n(t)), a !== void 0)
    return a;
  if (!vOe(t))
    return t;
  var c = pOe(t);
  if (c) {
    if (a = dOe(t), !s)
      return oOe(t, a);
  } else {
    var d = cOe(t), f = d == LX || d == TOe;
    if (gOe(t))
      return iOe(t, s);
    if (d == VX || d == FX || f && !i) {
      if (a = u || f ? {} : hOe(t), !s)
        return u ? sOe(t, rOe(a, t)) : aOe(t, nOe(a, t));
    } else {
      if (!kr[d])
        return i ? t : {};
      a = fOe(t, d, s);
    }
  }
  o || (o = new QTe());
  var h = o.get(t);
  if (h)
    return h;
  o.set(t, a), bOe(t) ? t.forEach(function(m) {
    a.add(hy(m, e, n, m, t, o));
  }) : mOe(t) && t.forEach(function(m, b) {
    a.set(b, hy(m, e, n, b, t, o));
  });
  var p = l ? u ? lOe : uOe : u ? xOe : yOe, v = c ? void 0 : p(t);
  return eOe(v || t, function(m, b) {
    v && (b = m, m = t[b]), tOe(a, b, hy(m, e, n, b, t, o));
  }), a;
}
var BX = hy, XOe = Mo, YOe = oC, ZOe = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/, JOe = /^\w*$/;
function KOe(t, e) {
  if (XOe(t))
    return !1;
  var n = typeof t;
  return n == "number" || n == "symbol" || n == "boolean" || t == null || YOe(t) ? !0 : JOe.test(t) || !ZOe.test(t) || e != null && t in Object(e);
}
var f9 = KOe, HX = KA, qOe = "Expected a function";
function h9(t, e) {
  if (typeof t != "function" || e != null && typeof e != "function")
    throw new TypeError(qOe);
  var n = function() {
    var r = arguments, i = e ? e.apply(this, r) : r[0], o = n.cache;
    if (o.has(i))
      return o.get(i);
    var a = t.apply(this, r);
    return n.cache = o.set(i, a) || o, a;
  };
  return n.cache = new (h9.Cache || HX)(), n;
}
h9.Cache = HX;
var QOe = h9, e8e = QOe, t8e = 500;
function n8e(t) {
  var e = e8e(t, function(r) {
    return n.size === t8e && n.clear(), r;
  }), n = e.cache;
  return e;
}
var r8e = n8e, i8e = r8e, o8e = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g, a8e = /\\(\\)?/g, s8e = i8e(function(t) {
  var e = [];
  return t.charCodeAt(0) === 46 && e.push(""), t.replace(o8e, function(n, r, i, o) {
    e.push(i ? o.replace(a8e, "$1") : r || n);
  }), e;
}), u8e = s8e, l8e = Mo, c8e = f9, d8e = u8e, f8e = zd;
function h8e(t, e) {
  return l8e(t) ? t : c8e(t, e) ? [t] : d8e(f8e(t));
}
var Ym = h8e;
function p8e(t) {
  var e = t == null ? 0 : t.length;
  return e ? t[e - 1] : void 0;
}
var g8e = p8e, m8e = oC, v8e = 1 / 0;
function b8e(t) {
  if (typeof t == "string" || m8e(t))
    return t;
  var e = t + "";
  return e == "0" && 1 / t == -v8e ? "-0" : e;
}
var kp = b8e, y8e = Ym, x8e = kp;
function C8e(t, e) {
  e = y8e(e, t);
  for (var n = 0, r = e.length; t != null && n < r; )
    t = t[x8e(e[n++])];
  return n && n == r ? t : void 0;
}
var p9 = C8e, w8e = p9, E8e = mW;
function S8e(t, e) {
  return e.length < 2 ? t : w8e(t, E8e(e, 0, -1));
}
var I8e = S8e, _8e = Ym, A8e = g8e, T8e = I8e, O8e = kp;
function P8e(t, e) {
  return e = _8e(e, t), t = T8e(t, e), t == null || delete t[O8e(A8e(e))];
}
var N8e = P8e, k8e = Ec, R8e = c9, $8e = xu, D8e = "[object Object]", M8e = Function.prototype, F8e = Object.prototype, WX = M8e.toString, L8e = F8e.hasOwnProperty, V8e = WX.call(Object);
function B8e(t) {
  if (!$8e(t) || k8e(t) != D8e)
    return !1;
  var e = R8e(t);
  if (e === null)
    return !0;
  var n = L8e.call(e, "constructor") && e.constructor;
  return typeof n == "function" && n instanceof n && WX.call(n) == V8e;
}
var jX = B8e, H8e = jX;
function W8e(t) {
  return H8e(t) ? void 0 : t;
}
var j8e = W8e, z8e = kX;
function G8e(t) {
  var e = t == null ? 0 : t.length;
  return e ? z8e(t, 1) : [];
}
var U8e = G8e;
function X8e(t, e, n) {
  switch (n.length) {
    case 0:
      return t.call(e);
    case 1:
      return t.call(e, n[0]);
    case 2:
      return t.call(e, n[0], n[1]);
    case 3:
      return t.call(e, n[0], n[1], n[2]);
  }
  return t.apply(e, n);
}
var Y8e = X8e, Z8e = Y8e, p$ = Math.max;
function J8e(t, e, n) {
  return e = p$(e === void 0 ? t.length - 1 : e, 0), function() {
    for (var r = arguments, i = -1, o = p$(r.length - e, 0), a = Array(o); ++i < o; )
      a[i] = r[e + i];
    i = -1;
    for (var s = Array(e + 1); ++i < e; )
      s[i] = r[i];
    return s[e] = n(a), Z8e(t, this, s);
  };
}
var K8e = J8e;
function q8e(t) {
  return function() {
    return t;
  };
}
var Q8e = q8e;
function ePe(t) {
  return t;
}
var g9 = ePe, tPe = Q8e, g$ = RX, nPe = g9, rPe = g$ ? function(t, e) {
  return g$(t, "toString", {
    configurable: !0,
    enumerable: !1,
    value: tPe(e),
    writable: !0
  });
} : nPe, iPe = rPe, oPe = 800, aPe = 16, sPe = Date.now;
function uPe(t) {
  var e = 0, n = 0;
  return function() {
    var r = sPe(), i = aPe - (r - n);
    if (n = r, i > 0) {
      if (++e >= oPe)
        return arguments[0];
    } else
      e = 0;
    return t.apply(void 0, arguments);
  };
}
var lPe = uPe, cPe = iPe, dPe = lPe, fPe = dPe(cPe), hPe = fPe, pPe = U8e, gPe = K8e, mPe = hPe;
function vPe(t) {
  return mPe(gPe(t, void 0, pPe), t + "");
}
var bPe = vPe, yPe = J6, xPe = BX, CPe = N8e, wPe = Ym, EPe = Xm, SPe = j8e, IPe = bPe, _Pe = MX, APe = 1, TPe = 2, OPe = 4, PPe = IPe(function(t, e) {
  var n = {};
  if (t == null)
    return n;
  var r = !1;
  e = yPe(e, function(o) {
    return o = wPe(o, t), r || (r = o.length > 1), o;
  }), EPe(t, _Pe(t), n), r && (n = xPe(n, APe | TPe | OPe, SPe));
  for (var i = e.length; i--; )
    CPe(n, e[i]);
  return n;
}), NPe = PPe;
const va = /* @__PURE__ */ qn(NPe);
var Wa = {}, Zm = {}, kPe = Ec, RPe = Mo, $Pe = xu, DPe = "[object String]";
function MPe(t) {
  return typeof t == "string" || !RPe(t) && $Pe(t) && kPe(t) == DPe;
}
var FPe = MPe;
function LPe(t) {
  return function(e, n, r) {
    for (var i = -1, o = Object(e), a = r(e), s = a.length; s--; ) {
      var u = a[t ? s : ++i];
      if (n(o[u], u, o) === !1)
        break;
    }
    return e;
  };
}
var VPe = LPe, BPe = VPe, HPe = BPe(), WPe = HPe, jPe = WPe, zPe = Gm;
function GPe(t, e) {
  return t && jPe(t, e, zPe);
}
var zX = GPe, UPe = g9;
function XPe(t) {
  return typeof t == "function" ? t : UPe;
}
var YPe = XPe, ZPe = zX, JPe = YPe;
function KPe(t, e) {
  return t && ZPe(t, JPe(e));
}
var m9 = KPe, qPe = qA, QPe = a9, eNe = 1, tNe = 2;
function nNe(t, e, n, r) {
  var i = n.length, o = i, a = !r;
  if (t == null)
    return !o;
  for (t = Object(t); i--; ) {
    var s = n[i];
    if (a && s[2] ? s[1] !== t[s[0]] : !(s[0] in t))
      return !1;
  }
  for (; ++i < o; ) {
    s = n[i];
    var u = s[0], l = t[u], c = s[1];
    if (a && s[2]) {
      if (l === void 0 && !(u in t))
        return !1;
    } else {
      var d = new qPe();
      if (r)
        var f = r(l, c, u, t, e, d);
      if (!(f === void 0 ? QPe(c, l, eNe | tNe, r, d) : f))
        return !1;
    }
  }
  return !0;
}
var rNe = nNe, iNe = Ds;
function oNe(t) {
  return t === t && !iNe(t);
}
var GX = oNe, aNe = GX, sNe = Gm;
function uNe(t) {
  for (var e = sNe(t), n = e.length; n--; ) {
    var r = e[n], i = t[r];
    e[n] = [r, i, aNe(i)];
  }
  return e;
}
var lNe = uNe;
function cNe(t, e) {
  return function(n) {
    return n == null ? !1 : n[t] === e && (e !== void 0 || t in Object(n));
  };
}
var UX = cNe, dNe = rNe, fNe = lNe, hNe = UX;
function pNe(t) {
  var e = fNe(t);
  return e.length == 1 && e[0][2] ? hNe(e[0][0], e[0][1]) : function(n) {
    return n === t || dNe(n, t, e);
  };
}
var gNe = pNe, mNe = p9;
function vNe(t, e, n) {
  var r = t == null ? void 0 : mNe(t, e);
  return r === void 0 ? n : r;
}
var XX = vNe;
const ii = /* @__PURE__ */ qn(XX);
function bNe(t, e) {
  return t != null && e in Object(t);
}
var yNe = bNe, xNe = Ym, CNe = n9, wNe = Mo, ENe = DC, SNe = i9, INe = kp;
function _Ne(t, e, n) {
  e = xNe(e, t);
  for (var r = -1, i = e.length, o = !1; ++r < i; ) {
    var a = INe(e[r]);
    if (!(o = t != null && n(t, a)))
      break;
    t = t[a];
  }
  return o || ++r != i ? o : (i = t == null ? 0 : t.length, !!i && SNe(i) && ENe(a, i) && (wNe(t) || CNe(t)));
}
var ANe = _Ne, TNe = yNe, ONe = ANe;
function PNe(t, e) {
  return t != null && ONe(t, e, TNe);
}
var NNe = PNe, kNe = a9, RNe = XX, $Ne = NNe, DNe = f9, MNe = GX, FNe = UX, LNe = kp, VNe = 1, BNe = 2;
function HNe(t, e) {
  return DNe(t) && MNe(e) ? FNe(LNe(t), e) : function(n) {
    var r = RNe(n, t);
    return r === void 0 && r === e ? $Ne(n, t) : kNe(e, r, VNe | BNe);
  };
}
var WNe = HNe, jNe = p9;
function zNe(t) {
  return function(e) {
    return jNe(e, t);
  };
}
var GNe = zNe, UNe = QG, XNe = GNe, YNe = f9, ZNe = kp;
function JNe(t) {
  return YNe(t) ? UNe(ZNe(t)) : XNe(t);
}
var KNe = JNe, qNe = gNe, QNe = WNe, e7e = g9, t7e = Mo, n7e = KNe;
function r7e(t) {
  return typeof t == "function" ? t : t == null ? e7e : typeof t == "object" ? t7e(t) ? QNe(t[0], t[1]) : qNe(t) : n7e(t);
}
var YX = r7e, i7e = zm;
function o7e(t, e) {
  return function(n, r) {
    if (n == null)
      return n;
    if (!i7e(n))
      return t(n, r);
    for (var i = n.length, o = e ? i : -1, a = Object(n); (e ? o-- : ++o < i) && r(a[o], o, a) !== !1; )
      ;
    return n;
  };
}
var a7e = o7e, s7e = zX, u7e = a7e, l7e = u7e(s7e), ZX = l7e, c7e = ZX, d7e = zm;
function f7e(t, e) {
  var n = -1, r = d7e(t) ? Array(t.length) : [];
  return c7e(t, function(i, o, a) {
    r[++n] = e(i, o, a);
  }), r;
}
var h7e = f7e, p7e = J6, g7e = YX, m7e = h7e, v7e = Mo;
function b7e(t, e) {
  var n = v7e(t) ? p7e : m7e;
  return n(t, g7e(e));
}
var y7e = b7e;
Object.defineProperty(Zm, "__esModule", {
  value: !0
});
Zm.flattenNames = void 0;
var x7e = FPe, C7e = WC(x7e), w7e = m9, E7e = WC(w7e), S7e = jX, I7e = WC(S7e), _7e = y7e, A7e = WC(_7e);
function WC(t) {
  return t && t.__esModule ? t : { default: t };
}
var T7e = Zm.flattenNames = function t() {
  var e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [], n = [];
  return (0, A7e.default)(e, function(r) {
    Array.isArray(r) ? t(r).map(function(i) {
      return n.push(i);
    }) : (0, I7e.default)(r) ? (0, E7e.default)(r, function(i, o) {
      i === !0 && n.push(o), n.push(o + "-" + i);
    }) : (0, C7e.default)(r) && n.push(r);
  }), n;
};
Zm.default = T7e;
var Jm = {}, O7e = BX, P7e = 1, N7e = 4;
function k7e(t) {
  return O7e(t, P7e | N7e);
}
var R7e = k7e;
Object.defineProperty(Jm, "__esModule", {
  value: !0
});
Jm.mergeClasses = void 0;
var $7e = m9, D7e = JX($7e), M7e = R7e, F7e = JX(M7e), L7e = Object.assign || function(t) {
  for (var e = 1; e < arguments.length; e++) {
    var n = arguments[e];
    for (var r in n)
      Object.prototype.hasOwnProperty.call(n, r) && (t[r] = n[r]);
  }
  return t;
};
function JX(t) {
  return t && t.__esModule ? t : { default: t };
}
var V7e = Jm.mergeClasses = function(e) {
  var n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : [], r = e.default && (0, F7e.default)(e.default) || {};
  return n.map(function(i) {
    var o = e[i];
    return o && (0, D7e.default)(o, function(a, s) {
      r[s] || (r[s] = {}), r[s] = L7e({}, r[s], o[s]);
    }), i;
  }), r;
};
Jm.default = V7e;
var Km = {};
Object.defineProperty(Km, "__esModule", {
  value: !0
});
Km.autoprefix = void 0;
var B7e = m9, m$ = W7e(B7e), H7e = Object.assign || function(t) {
  for (var e = 1; e < arguments.length; e++) {
    var n = arguments[e];
    for (var r in n)
      Object.prototype.hasOwnProperty.call(n, r) && (t[r] = n[r]);
  }
  return t;
};
function W7e(t) {
  return t && t.__esModule ? t : { default: t };
}
var j7e = {
  borderRadius: function(e) {
    return {
      msBorderRadius: e,
      MozBorderRadius: e,
      OBorderRadius: e,
      WebkitBorderRadius: e,
      borderRadius: e
    };
  },
  boxShadow: function(e) {
    return {
      msBoxShadow: e,
      MozBoxShadow: e,
      OBoxShadow: e,
      WebkitBoxShadow: e,
      boxShadow: e
    };
  },
  userSelect: function(e) {
    return {
      WebkitTouchCallout: e,
      KhtmlUserSelect: e,
      MozUserSelect: e,
      msUserSelect: e,
      WebkitUserSelect: e,
      userSelect: e
    };
  },
  flex: function(e) {
    return {
      WebkitBoxFlex: e,
      MozBoxFlex: e,
      WebkitFlex: e,
      msFlex: e,
      flex: e
    };
  },
  flexBasis: function(e) {
    return {
      WebkitFlexBasis: e,
      flexBasis: e
    };
  },
  justifyContent: function(e) {
    return {
      WebkitJustifyContent: e,
      justifyContent: e
    };
  },
  transition: function(e) {
    return {
      msTransition: e,
      MozTransition: e,
      OTransition: e,
      WebkitTransition: e,
      transition: e
    };
  },
  transform: function(e) {
    return {
      msTransform: e,
      MozTransform: e,
      OTransform: e,
      WebkitTransform: e,
      transform: e
    };
  },
  absolute: function(e) {
    var n = e && e.split(" ");
    return {
      position: "absolute",
      top: n && n[0],
      right: n && n[1],
      bottom: n && n[2],
      left: n && n[3]
    };
  },
  extend: function(e, n) {
    var r = n[e];
    return r || {
      extend: e
    };
  }
}, z7e = Km.autoprefix = function(e) {
  var n = {};
  return (0, m$.default)(e, function(r, i) {
    var o = {};
    (0, m$.default)(r, function(a, s) {
      var u = j7e[s];
      u ? o = H7e({}, o, u(a)) : o[s] = a;
    }), n[i] = o;
  }), n;
};
Km.default = z7e;
var qm = {};
Object.defineProperty(qm, "__esModule", {
  value: !0
});
qm.hover = void 0;
var G7e = Object.assign || function(t) {
  for (var e = 1; e < arguments.length; e++) {
    var n = arguments[e];
    for (var r in n)
      Object.prototype.hasOwnProperty.call(n, r) && (t[r] = n[r]);
  }
  return t;
}, U7e = O, f3 = X7e(U7e);
function X7e(t) {
  return t && t.__esModule ? t : { default: t };
}
function Y7e(t, e) {
  if (!(t instanceof e))
    throw new TypeError("Cannot call a class as a function");
}
function v$(t, e) {
  if (!t)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e && (typeof e == "object" || typeof e == "function") ? e : t;
}
function Z7e(t, e) {
  if (typeof e != "function" && e !== null)
    throw new TypeError("Super expression must either be null or a function, not " + typeof e);
  t.prototype = Object.create(e && e.prototype, { constructor: { value: t, enumerable: !1, writable: !0, configurable: !0 } }), e && (Object.setPrototypeOf ? Object.setPrototypeOf(t, e) : t.__proto__ = e);
}
var J7e = qm.hover = function(e) {
  var n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "span";
  return function(r) {
    Z7e(i, r);
    function i() {
      var o, a, s, u;
      Y7e(this, i);
      for (var l = arguments.length, c = Array(l), d = 0; d < l; d++)
        c[d] = arguments[d];
      return u = (a = (s = v$(this, (o = i.__proto__ || Object.getPrototypeOf(i)).call.apply(o, [this].concat(c))), s), s.state = { hover: !1 }, s.handleMouseOver = function() {
        return s.setState({ hover: !0 });
      }, s.handleMouseOut = function() {
        return s.setState({ hover: !1 });
      }, s.render = function() {
        return f3.default.createElement(
          n,
          { onMouseOver: s.handleMouseOver, onMouseOut: s.handleMouseOut },
          f3.default.createElement(e, G7e({}, s.props, s.state))
        );
      }, a), v$(s, u);
    }
    return i;
  }(f3.default.Component);
};
qm.default = J7e;
var Qm = {};
Object.defineProperty(Qm, "__esModule", {
  value: !0
});
Qm.active = void 0;
var K7e = Object.assign || function(t) {
  for (var e = 1; e < arguments.length; e++) {
    var n = arguments[e];
    for (var r in n)
      Object.prototype.hasOwnProperty.call(n, r) && (t[r] = n[r]);
  }
  return t;
}, q7e = O, h3 = Q7e(q7e);
function Q7e(t) {
  return t && t.__esModule ? t : { default: t };
}
function eke(t, e) {
  if (!(t instanceof e))
    throw new TypeError("Cannot call a class as a function");
}
function b$(t, e) {
  if (!t)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e && (typeof e == "object" || typeof e == "function") ? e : t;
}
function tke(t, e) {
  if (typeof e != "function" && e !== null)
    throw new TypeError("Super expression must either be null or a function, not " + typeof e);
  t.prototype = Object.create(e && e.prototype, { constructor: { value: t, enumerable: !1, writable: !0, configurable: !0 } }), e && (Object.setPrototypeOf ? Object.setPrototypeOf(t, e) : t.__proto__ = e);
}
var nke = Qm.active = function(e) {
  var n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "span";
  return function(r) {
    tke(i, r);
    function i() {
      var o, a, s, u;
      eke(this, i);
      for (var l = arguments.length, c = Array(l), d = 0; d < l; d++)
        c[d] = arguments[d];
      return u = (a = (s = b$(this, (o = i.__proto__ || Object.getPrototypeOf(i)).call.apply(o, [this].concat(c))), s), s.state = { active: !1 }, s.handleMouseDown = function() {
        return s.setState({ active: !0 });
      }, s.handleMouseUp = function() {
        return s.setState({ active: !1 });
      }, s.render = function() {
        return h3.default.createElement(
          n,
          { onMouseDown: s.handleMouseDown, onMouseUp: s.handleMouseUp },
          h3.default.createElement(e, K7e({}, s.props, s.state))
        );
      }, a), b$(s, u);
    }
    return i;
  }(h3.default.Component);
};
Qm.default = nke;
var v9 = {};
Object.defineProperty(v9, "__esModule", {
  value: !0
});
var rke = function(e, n) {
  var r = {}, i = function(a) {
    var s = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : !0;
    r[a] = s;
  };
  return e === 0 && i("first-child"), e === n - 1 && i("last-child"), (e === 0 || e % 2 === 0) && i("even"), Math.abs(e % 2) === 1 && i("odd"), i("nth-child", e), r;
};
v9.default = rke;
Object.defineProperty(Wa, "__esModule", {
  value: !0
});
Wa.ReactCSS = Wa.loop = Wa.handleActive = b9 = Wa.handleHover = Wa.hover = void 0;
var ike = Zm, oke = Rp(ike), ake = Jm, ske = Rp(ake), uke = Km, lke = Rp(uke), cke = qm, KX = Rp(cke), dke = Qm, fke = Rp(dke), hke = v9, pke = Rp(hke);
function Rp(t) {
  return t && t.__esModule ? t : { default: t };
}
Wa.hover = KX.default;
var b9 = Wa.handleHover = KX.default;
Wa.handleActive = fke.default;
Wa.loop = pke.default;
var gke = Wa.ReactCSS = function(e) {
  for (var n = arguments.length, r = Array(n > 1 ? n - 1 : 0), i = 1; i < n; i++)
    r[i - 1] = arguments[i];
  var o = (0, oke.default)(r), a = (0, ske.default)(e, o);
  return (0, lke.default)(a);
}, un = Wa.default = gke, mke = function(e, n, r, i, o) {
  var a = o.clientWidth, s = o.clientHeight, u = typeof e.pageX == "number" ? e.pageX : e.touches[0].pageX, l = typeof e.pageY == "number" ? e.pageY : e.touches[0].pageY, c = u - (o.getBoundingClientRect().left + window.pageXOffset), d = l - (o.getBoundingClientRect().top + window.pageYOffset);
  if (r === "vertical") {
    var f = void 0;
    if (d < 0 ? f = 0 : d > s ? f = 1 : f = Math.round(d * 100 / s) / 100, n.a !== f)
      return {
        h: n.h,
        s: n.s,
        l: n.l,
        a: f,
        source: "rgb"
      };
  } else {
    var h = void 0;
    if (c < 0 ? h = 0 : c > a ? h = 1 : h = Math.round(c * 100 / a) / 100, i !== h)
      return {
        h: n.h,
        s: n.s,
        l: n.l,
        a: h,
        source: "rgb"
      };
  }
  return null;
}, p3 = {}, vke = function(e, n, r, i) {
  if (typeof document > "u" && !i)
    return null;
  var o = i ? new i() : document.createElement("canvas");
  o.width = r * 2, o.height = r * 2;
  var a = o.getContext("2d");
  return a ? (a.fillStyle = e, a.fillRect(0, 0, o.width, o.height), a.fillStyle = n, a.fillRect(0, 0, r, r), a.translate(r, r), a.fillRect(0, 0, r, r), o.toDataURL()) : null;
}, bke = function(e, n, r, i) {
  var o = e + "-" + n + "-" + r + (i ? "-server" : "");
  if (p3[o])
    return p3[o];
  var a = vke(e, n, r, i);
  return p3[o] = a, a;
}, y$ = Object.assign || function(t) {
  for (var e = 1; e < arguments.length; e++) {
    var n = arguments[e];
    for (var r in n)
      Object.prototype.hasOwnProperty.call(n, r) && (t[r] = n[r]);
  }
  return t;
}, $p = function(e) {
  var n = e.white, r = e.grey, i = e.size, o = e.renderers, a = e.borderRadius, s = e.boxShadow, u = e.children, l = un({
    default: {
      grid: {
        borderRadius: a,
        boxShadow: s,
        absolute: "0px 0px 0px 0px",
        background: "url(" + bke(n, r, i, o.canvas) + ") center left"
      }
    }
  });
  return Od(u) ? O.cloneElement(u, y$({}, u.props, { style: y$({}, u.props.style, l.grid) })) : O.createElement("div", { style: l.grid });
};
$p.defaultProps = {
  size: 8,
  white: "transparent",
  grey: "rgba(0,0,0,.08)",
  renderers: {}
};
var yke = Object.assign || function(t) {
  for (var e = 1; e < arguments.length; e++) {
    var n = arguments[e];
    for (var r in n)
      Object.prototype.hasOwnProperty.call(n, r) && (t[r] = n[r]);
  }
  return t;
}, xke = /* @__PURE__ */ function() {
  function t(e, n) {
    for (var r = 0; r < n.length; r++) {
      var i = n[r];
      i.enumerable = i.enumerable || !1, i.configurable = !0, "value" in i && (i.writable = !0), Object.defineProperty(e, i.key, i);
    }
  }
  return function(e, n, r) {
    return n && t(e.prototype, n), r && t(e, r), e;
  };
}();
function Cke(t, e) {
  if (!(t instanceof e))
    throw new TypeError("Cannot call a class as a function");
}
function x$(t, e) {
  if (!t)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e && (typeof e == "object" || typeof e == "function") ? e : t;
}
function wke(t, e) {
  if (typeof e != "function" && e !== null)
    throw new TypeError("Super expression must either be null or a function, not " + typeof e);
  t.prototype = Object.create(e && e.prototype, { constructor: { value: t, enumerable: !1, writable: !0, configurable: !0 } }), e && (Object.setPrototypeOf ? Object.setPrototypeOf(t, e) : t.__proto__ = e);
}
var y9 = function(t) {
  wke(e, t);
  function e() {
    var n, r, i, o;
    Cke(this, e);
    for (var a = arguments.length, s = Array(a), u = 0; u < a; u++)
      s[u] = arguments[u];
    return o = (r = (i = x$(this, (n = e.__proto__ || Object.getPrototypeOf(e)).call.apply(n, [this].concat(s))), i), i.handleChange = function(l) {
      var c = mke(l, i.props.hsl, i.props.direction, i.props.a, i.container);
      c && typeof i.props.onChange == "function" && i.props.onChange(c, l);
    }, i.handleMouseDown = function(l) {
      i.handleChange(l), window.addEventListener("mousemove", i.handleChange), window.addEventListener("mouseup", i.handleMouseUp);
    }, i.handleMouseUp = function() {
      i.unbindEventListeners();
    }, i.unbindEventListeners = function() {
      window.removeEventListener("mousemove", i.handleChange), window.removeEventListener("mouseup", i.handleMouseUp);
    }, r), x$(i, o);
  }
  return xke(e, [{
    key: "componentWillUnmount",
    value: function() {
      this.unbindEventListeners();
    }
  }, {
    key: "render",
    value: function() {
      var r = this, i = this.props.rgb, o = un({
        default: {
          alpha: {
            absolute: "0px 0px 0px 0px",
            borderRadius: this.props.radius
          },
          checkboard: {
            absolute: "0px 0px 0px 0px",
            overflow: "hidden",
            borderRadius: this.props.radius
          },
          gradient: {
            absolute: "0px 0px 0px 0px",
            background: "linear-gradient(to right, rgba(" + i.r + "," + i.g + "," + i.b + `, 0) 0%,
           rgba(` + i.r + "," + i.g + "," + i.b + ", 1) 100%)",
            boxShadow: this.props.shadow,
            borderRadius: this.props.radius
          },
          container: {
            position: "relative",
            height: "100%",
            margin: "0 3px"
          },
          pointer: {
            position: "absolute",
            left: i.a * 100 + "%"
          },
          slider: {
            width: "4px",
            borderRadius: "1px",
            height: "8px",
            boxShadow: "0 0 2px rgba(0, 0, 0, .6)",
            background: "#fff",
            marginTop: "1px",
            transform: "translateX(-2px)"
          }
        },
        vertical: {
          gradient: {
            background: "linear-gradient(to bottom, rgba(" + i.r + "," + i.g + "," + i.b + `, 0) 0%,
           rgba(` + i.r + "," + i.g + "," + i.b + ", 1) 100%)"
          },
          pointer: {
            left: 0,
            top: i.a * 100 + "%"
          }
        },
        overwrite: yke({}, this.props.style)
      }, {
        vertical: this.props.direction === "vertical",
        overwrite: !0
      });
      return O.createElement(
        "div",
        { style: o.alpha },
        O.createElement(
          "div",
          { style: o.checkboard },
          O.createElement($p, { renderers: this.props.renderers })
        ),
        O.createElement("div", { style: o.gradient }),
        O.createElement(
          "div",
          {
            style: o.container,
            ref: function(s) {
              return r.container = s;
            },
            onMouseDown: this.handleMouseDown,
            onTouchMove: this.handleChange,
            onTouchStart: this.handleChange
          },
          O.createElement(
            "div",
            { style: o.pointer },
            this.props.pointer ? O.createElement(this.props.pointer, this.props) : O.createElement("div", { style: o.slider })
          )
        )
      );
    }
  }]), e;
}(Pm || Do), Eke = /* @__PURE__ */ function() {
  function t(e, n) {
    for (var r = 0; r < n.length; r++) {
      var i = n[r];
      i.enumerable = i.enumerable || !1, i.configurable = !0, "value" in i && (i.writable = !0), Object.defineProperty(e, i.key, i);
    }
  }
  return function(e, n, r) {
    return n && t(e.prototype, n), r && t(e, r), e;
  };
}();
function Ske(t, e, n) {
  return e in t ? Object.defineProperty(t, e, { value: n, enumerable: !0, configurable: !0, writable: !0 }) : t[e] = n, t;
}
function Ike(t, e) {
  if (!(t instanceof e))
    throw new TypeError("Cannot call a class as a function");
}
function _ke(t, e) {
  if (!t)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e && (typeof e == "object" || typeof e == "function") ? e : t;
}
function Ake(t, e) {
  if (typeof e != "function" && e !== null)
    throw new TypeError("Super expression must either be null or a function, not " + typeof e);
  t.prototype = Object.create(e && e.prototype, { constructor: { value: t, enumerable: !1, writable: !0, configurable: !0 } }), e && (Object.setPrototypeOf ? Object.setPrototypeOf(t, e) : t.__proto__ = e);
}
var Tke = 1, qX = 38, Oke = 40, Pke = [qX, Oke], Nke = function(e) {
  return Pke.indexOf(e) > -1;
}, kke = function(e) {
  return Number(String(e).replace(/%/g, ""));
}, Rke = 1, Ln = function(t) {
  Ake(e, t);
  function e(n) {
    Ike(this, e);
    var r = _ke(this, (e.__proto__ || Object.getPrototypeOf(e)).call(this));
    return r.handleBlur = function() {
      r.state.blurValue && r.setState({ value: r.state.blurValue, blurValue: null });
    }, r.handleChange = function(i) {
      r.setUpdatedValue(i.target.value, i);
    }, r.handleKeyDown = function(i) {
      var o = kke(i.target.value);
      if (!isNaN(o) && Nke(i.keyCode)) {
        var a = r.getArrowOffset(), s = i.keyCode === qX ? o + a : o - a;
        r.setUpdatedValue(s, i);
      }
    }, r.handleDrag = function(i) {
      if (r.props.dragLabel) {
        var o = Math.round(r.props.value + i.movementX);
        o >= 0 && o <= r.props.dragMax && r.props.onChange && r.props.onChange(r.getValueObjectWithLabel(o), i);
      }
    }, r.handleMouseDown = function(i) {
      r.props.dragLabel && (i.preventDefault(), r.handleDrag(i), window.addEventListener("mousemove", r.handleDrag), window.addEventListener("mouseup", r.handleMouseUp));
    }, r.handleMouseUp = function() {
      r.unbindEventListeners();
    }, r.unbindEventListeners = function() {
      window.removeEventListener("mousemove", r.handleDrag), window.removeEventListener("mouseup", r.handleMouseUp);
    }, r.state = {
      value: String(n.value).toUpperCase(),
      blurValue: String(n.value).toUpperCase()
    }, r.inputId = "rc-editable-input-" + Rke++, r;
  }
  return Eke(e, [{
    key: "componentDidUpdate",
    value: function(r, i) {
      this.props.value !== this.state.value && (r.value !== this.props.value || i.value !== this.state.value) && (this.input === document.activeElement ? this.setState({ blurValue: String(this.props.value).toUpperCase() }) : this.setState({ value: String(this.props.value).toUpperCase(), blurValue: !this.state.blurValue && String(this.props.value).toUpperCase() }));
    }
  }, {
    key: "componentWillUnmount",
    value: function() {
      this.unbindEventListeners();
    }
  }, {
    key: "getValueObjectWithLabel",
    value: function(r) {
      return Ske({}, this.props.label, r);
    }
  }, {
    key: "getArrowOffset",
    value: function() {
      return this.props.arrowOffset || Tke;
    }
  }, {
    key: "setUpdatedValue",
    value: function(r, i) {
      var o = this.props.label ? this.getValueObjectWithLabel(r) : r;
      this.props.onChange && this.props.onChange(o, i), this.setState({ value: r });
    }
  }, {
    key: "render",
    value: function() {
      var r = this, i = un({
        default: {
          wrap: {
            position: "relative"
          }
        },
        "user-override": {
          wrap: this.props.style && this.props.style.wrap ? this.props.style.wrap : {},
          input: this.props.style && this.props.style.input ? this.props.style.input : {},
          label: this.props.style && this.props.style.label ? this.props.style.label : {}
        },
        "dragLabel-true": {
          label: {
            cursor: "ew-resize"
          }
        }
      }, {
        "user-override": !0
      }, this.props);
      return O.createElement(
        "div",
        { style: i.wrap },
        O.createElement("input", {
          id: this.inputId,
          style: i.input,
          ref: function(a) {
            return r.input = a;
          },
          value: this.state.value,
          onKeyDown: this.handleKeyDown,
          onChange: this.handleChange,
          onBlur: this.handleBlur,
          placeholder: this.props.placeholder,
          spellCheck: "false"
        }),
        this.props.label && !this.props.hideLabel ? O.createElement(
          "label",
          {
            htmlFor: this.inputId,
            style: i.label,
            onMouseDown: this.handleMouseDown
          },
          this.props.label
        ) : null
      );
    }
  }]), e;
}(Pm || Do), $ke = function(e, n, r, i) {
  var o = i.clientWidth, a = i.clientHeight, s = typeof e.pageX == "number" ? e.pageX : e.touches[0].pageX, u = typeof e.pageY == "number" ? e.pageY : e.touches[0].pageY, l = s - (i.getBoundingClientRect().left + window.pageXOffset), c = u - (i.getBoundingClientRect().top + window.pageYOffset);
  if (n === "vertical") {
    var d = void 0;
    if (c < 0)
      d = 359;
    else if (c > a)
      d = 0;
    else {
      var f = -(c * 100 / a) + 100;
      d = 360 * f / 100;
    }
    if (r.h !== d)
      return {
        h: d,
        s: r.s,
        l: r.l,
        a: r.a,
        source: "hsl"
      };
  } else {
    var h = void 0;
    if (l < 0)
      h = 0;
    else if (l > o)
      h = 359;
    else {
      var p = l * 100 / o;
      h = 360 * p / 100;
    }
    if (r.h !== h)
      return {
        h,
        s: r.s,
        l: r.l,
        a: r.a,
        source: "hsl"
      };
  }
  return null;
}, Dke = /* @__PURE__ */ function() {
  function t(e, n) {
    for (var r = 0; r < n.length; r++) {
      var i = n[r];
      i.enumerable = i.enumerable || !1, i.configurable = !0, "value" in i && (i.writable = !0), Object.defineProperty(e, i.key, i);
    }
  }
  return function(e, n, r) {
    return n && t(e.prototype, n), r && t(e, r), e;
  };
}();
function Mke(t, e) {
  if (!(t instanceof e))
    throw new TypeError("Cannot call a class as a function");
}
function C$(t, e) {
  if (!t)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e && (typeof e == "object" || typeof e == "function") ? e : t;
}
function Fke(t, e) {
  if (typeof e != "function" && e !== null)
    throw new TypeError("Super expression must either be null or a function, not " + typeof e);
  t.prototype = Object.create(e && e.prototype, { constructor: { value: t, enumerable: !1, writable: !0, configurable: !0 } }), e && (Object.setPrototypeOf ? Object.setPrototypeOf(t, e) : t.__proto__ = e);
}
var Dp = function(t) {
  Fke(e, t);
  function e() {
    var n, r, i, o;
    Mke(this, e);
    for (var a = arguments.length, s = Array(a), u = 0; u < a; u++)
      s[u] = arguments[u];
    return o = (r = (i = C$(this, (n = e.__proto__ || Object.getPrototypeOf(e)).call.apply(n, [this].concat(s))), i), i.handleChange = function(l) {
      var c = $ke(l, i.props.direction, i.props.hsl, i.container);
      c && typeof i.props.onChange == "function" && i.props.onChange(c, l);
    }, i.handleMouseDown = function(l) {
      i.handleChange(l), window.addEventListener("mousemove", i.handleChange), window.addEventListener("mouseup", i.handleMouseUp);
    }, i.handleMouseUp = function() {
      i.unbindEventListeners();
    }, r), C$(i, o);
  }
  return Dke(e, [{
    key: "componentWillUnmount",
    value: function() {
      this.unbindEventListeners();
    }
  }, {
    key: "unbindEventListeners",
    value: function() {
      window.removeEventListener("mousemove", this.handleChange), window.removeEventListener("mouseup", this.handleMouseUp);
    }
  }, {
    key: "render",
    value: function() {
      var r = this, i = this.props.direction, o = i === void 0 ? "horizontal" : i, a = un({
        default: {
          hue: {
            absolute: "0px 0px 0px 0px",
            borderRadius: this.props.radius,
            boxShadow: this.props.shadow
          },
          container: {
            padding: "0 2px",
            position: "relative",
            height: "100%",
            borderRadius: this.props.radius
          },
          pointer: {
            position: "absolute",
            left: this.props.hsl.h * 100 / 360 + "%"
          },
          slider: {
            marginTop: "1px",
            width: "4px",
            borderRadius: "1px",
            height: "8px",
            boxShadow: "0 0 2px rgba(0, 0, 0, .6)",
            background: "#fff",
            transform: "translateX(-2px)"
          }
        },
        vertical: {
          pointer: {
            left: "0px",
            top: -(this.props.hsl.h * 100 / 360) + 100 + "%"
          }
        }
      }, { vertical: o === "vertical" });
      return O.createElement(
        "div",
        { style: a.hue },
        O.createElement(
          "div",
          {
            className: "hue-" + o,
            style: a.container,
            ref: function(u) {
              return r.container = u;
            },
            onMouseDown: this.handleMouseDown,
            onTouchMove: this.handleChange,
            onTouchStart: this.handleChange
          },
          O.createElement(
            "style",
            null,
            `
            .hue-horizontal {
              background: linear-gradient(to right, #f00 0%, #ff0 17%, #0f0
                33%, #0ff 50%, #00f 67%, #f0f 83%, #f00 100%);
              background: -webkit-linear-gradient(to right, #f00 0%, #ff0
                17%, #0f0 33%, #0ff 50%, #00f 67%, #f0f 83%, #f00 100%);
            }

            .hue-vertical {
              background: linear-gradient(to top, #f00 0%, #ff0 17%, #0f0 33%,
                #0ff 50%, #00f 67%, #f0f 83%, #f00 100%);
              background: -webkit-linear-gradient(to top, #f00 0%, #ff0 17%,
                #0f0 33%, #0ff 50%, #00f 67%, #f0f 83%, #f00 100%);
            }
          `
          ),
          O.createElement(
            "div",
            { style: a.pointer },
            this.props.pointer ? O.createElement(this.props.pointer, this.props) : O.createElement("div", { style: a.slider })
          )
        )
      );
    }
  }]), e;
}(Pm || Do), w_ = { exports: {} }, g3, w$;
function x9() {
  if (w$)
    return g3;
  w$ = 1;
  var t = "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED";
  return g3 = t, g3;
}
var m3, E$;
function Lke() {
  if (E$)
    return m3;
  E$ = 1;
  var t = x9();
  function e() {
  }
  function n() {
  }
  return n.resetWarningCache = e, m3 = function() {
    function r(a, s, u, l, c, d) {
      if (d !== t) {
        var f = new Error(
          "Calling PropTypes validators directly is not supported by the `prop-types` package. Use PropTypes.checkPropTypes() to call them. Read more at http://fb.me/use-check-prop-types"
        );
        throw f.name = "Invariant Violation", f;
      }
    }
    r.isRequired = r;
    function i() {
      return r;
    }
    var o = {
      array: r,
      bigint: r,
      bool: r,
      func: r,
      number: r,
      object: r,
      string: r,
      symbol: r,
      any: r,
      arrayOf: i,
      element: r,
      elementType: r,
      instanceOf: i,
      node: r,
      objectOf: i,
      oneOf: i,
      oneOfType: i,
      shape: i,
      exact: i,
      checkPropTypes: n,
      resetWarningCache: e
    };
    return o.PropTypes = o, o;
  }, m3;
}
var lb = { exports: {} }, rr = {};
/** @license React v16.13.1
 * react-is.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var S$;
function Vke() {
  return S$ || (S$ = 1, process.env.NODE_ENV !== "production" && function() {
    var t = typeof Symbol == "function" && Symbol.for, e = t ? Symbol.for("react.element") : 60103, n = t ? Symbol.for("react.portal") : 60106, r = t ? Symbol.for("react.fragment") : 60107, i = t ? Symbol.for("react.strict_mode") : 60108, o = t ? Symbol.for("react.profiler") : 60114, a = t ? Symbol.for("react.provider") : 60109, s = t ? Symbol.for("react.context") : 60110, u = t ? Symbol.for("react.async_mode") : 60111, l = t ? Symbol.for("react.concurrent_mode") : 60111, c = t ? Symbol.for("react.forward_ref") : 60112, d = t ? Symbol.for("react.suspense") : 60113, f = t ? Symbol.for("react.suspense_list") : 60120, h = t ? Symbol.for("react.memo") : 60115, p = t ? Symbol.for("react.lazy") : 60116, v = t ? Symbol.for("react.block") : 60121, m = t ? Symbol.for("react.fundamental") : 60117, b = t ? Symbol.for("react.responder") : 60118, y = t ? Symbol.for("react.scope") : 60119;
    function w(te) {
      return typeof te == "string" || typeof te == "function" || // Note: its typeof might be other than 'symbol' or 'number' if it's a polyfill.
      te === r || te === l || te === o || te === i || te === d || te === f || typeof te == "object" && te !== null && (te.$$typeof === p || te.$$typeof === h || te.$$typeof === a || te.$$typeof === s || te.$$typeof === c || te.$$typeof === m || te.$$typeof === b || te.$$typeof === y || te.$$typeof === v);
    }
    function S(te) {
      if (typeof te == "object" && te !== null) {
        var ge = te.$$typeof;
        switch (ge) {
          case e:
            var he = te.type;
            switch (he) {
              case u:
              case l:
              case r:
              case o:
              case i:
              case d:
                return he;
              default:
                var fe = he && he.$$typeof;
                switch (fe) {
                  case s:
                  case c:
                  case p:
                  case h:
                  case a:
                    return fe;
                  default:
                    return ge;
                }
            }
          case n:
            return ge;
        }
      }
    }
    var E = u, I = l, _ = s, A = a, P = e, N = c, k = r, D = p, R = h, V = n, $ = o, F = i, M = d, B = !1;
    function X(te) {
      return B || (B = !0, console.warn("The ReactIs.isAsyncMode() alias has been deprecated, and will be removed in React 17+. Update your code to use ReactIs.isConcurrentMode() instead. It has the exact same API.")), L(te) || S(te) === u;
    }
    function L(te) {
      return S(te) === l;
    }
    function j(te) {
      return S(te) === s;
    }
    function K(te) {
      return S(te) === a;
    }
    function W(te) {
      return typeof te == "object" && te !== null && te.$$typeof === e;
    }
    function Y(te) {
      return S(te) === c;
    }
    function U(te) {
      return S(te) === r;
    }
    function Q(te) {
      return S(te) === p;
    }
    function Z(te) {
      return S(te) === h;
    }
    function ee(te) {
      return S(te) === n;
    }
    function ie(te) {
      return S(te) === o;
    }
    function oe(te) {
      return S(te) === i;
    }
    function se(te) {
      return S(te) === d;
    }
    rr.AsyncMode = E, rr.ConcurrentMode = I, rr.ContextConsumer = _, rr.ContextProvider = A, rr.Element = P, rr.ForwardRef = N, rr.Fragment = k, rr.Lazy = D, rr.Memo = R, rr.Portal = V, rr.Profiler = $, rr.StrictMode = F, rr.Suspense = M, rr.isAsyncMode = X, rr.isConcurrentMode = L, rr.isContextConsumer = j, rr.isContextProvider = K, rr.isElement = W, rr.isForwardRef = Y, rr.isFragment = U, rr.isLazy = Q, rr.isMemo = Z, rr.isPortal = ee, rr.isProfiler = ie, rr.isStrictMode = oe, rr.isSuspense = se, rr.isValidElementType = w, rr.typeOf = S;
  }()), rr;
}
var ir = {};
/** @license React v16.13.1
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var I$;
function Bke() {
  if (I$)
    return ir;
  I$ = 1;
  var t = typeof Symbol == "function" && Symbol.for, e = t ? Symbol.for("react.element") : 60103, n = t ? Symbol.for("react.portal") : 60106, r = t ? Symbol.for("react.fragment") : 60107, i = t ? Symbol.for("react.strict_mode") : 60108, o = t ? Symbol.for("react.profiler") : 60114, a = t ? Symbol.for("react.provider") : 60109, s = t ? Symbol.for("react.context") : 60110, u = t ? Symbol.for("react.async_mode") : 60111, l = t ? Symbol.for("react.concurrent_mode") : 60111, c = t ? Symbol.for("react.forward_ref") : 60112, d = t ? Symbol.for("react.suspense") : 60113, f = t ? Symbol.for("react.suspense_list") : 60120, h = t ? Symbol.for("react.memo") : 60115, p = t ? Symbol.for("react.lazy") : 60116, v = t ? Symbol.for("react.block") : 60121, m = t ? Symbol.for("react.fundamental") : 60117, b = t ? Symbol.for("react.responder") : 60118, y = t ? Symbol.for("react.scope") : 60119;
  function w(E) {
    if (typeof E == "object" && E !== null) {
      var I = E.$$typeof;
      switch (I) {
        case e:
          switch (E = E.type, E) {
            case u:
            case l:
            case r:
            case o:
            case i:
            case d:
              return E;
            default:
              switch (E = E && E.$$typeof, E) {
                case s:
                case c:
                case p:
                case h:
                case a:
                  return E;
                default:
                  return I;
              }
          }
        case n:
          return I;
      }
    }
  }
  function S(E) {
    return w(E) === l;
  }
  return ir.AsyncMode = u, ir.ConcurrentMode = l, ir.ContextConsumer = s, ir.ContextProvider = a, ir.Element = e, ir.ForwardRef = c, ir.Fragment = r, ir.Lazy = p, ir.Memo = h, ir.Portal = n, ir.Profiler = o, ir.StrictMode = i, ir.Suspense = d, ir.isAsyncMode = function(E) {
    return S(E) || w(E) === u;
  }, ir.isConcurrentMode = S, ir.isContextConsumer = function(E) {
    return w(E) === s;
  }, ir.isContextProvider = function(E) {
    return w(E) === a;
  }, ir.isElement = function(E) {
    return typeof E == "object" && E !== null && E.$$typeof === e;
  }, ir.isForwardRef = function(E) {
    return w(E) === c;
  }, ir.isFragment = function(E) {
    return w(E) === r;
  }, ir.isLazy = function(E) {
    return w(E) === p;
  }, ir.isMemo = function(E) {
    return w(E) === h;
  }, ir.isPortal = function(E) {
    return w(E) === n;
  }, ir.isProfiler = function(E) {
    return w(E) === o;
  }, ir.isStrictMode = function(E) {
    return w(E) === i;
  }, ir.isSuspense = function(E) {
    return w(E) === d;
  }, ir.isValidElementType = function(E) {
    return typeof E == "string" || typeof E == "function" || E === r || E === l || E === o || E === i || E === d || E === f || typeof E == "object" && E !== null && (E.$$typeof === p || E.$$typeof === h || E.$$typeof === a || E.$$typeof === s || E.$$typeof === c || E.$$typeof === m || E.$$typeof === b || E.$$typeof === y || E.$$typeof === v);
  }, ir.typeOf = w, ir;
}
var _$;
function QX() {
  return _$ || (_$ = 1, process.env.NODE_ENV === "production" ? lb.exports = Bke() : lb.exports = Vke()), lb.exports;
}
/*
object-assign
(c) Sindre Sorhus
@license MIT
*/
var v3, A$;
function Hke() {
  if (A$)
    return v3;
  A$ = 1;
  var t = Object.getOwnPropertySymbols, e = Object.prototype.hasOwnProperty, n = Object.prototype.propertyIsEnumerable;
  function r(o) {
    if (o == null)
      throw new TypeError("Object.assign cannot be called with null or undefined");
    return Object(o);
  }
  function i() {
    try {
      if (!Object.assign)
        return !1;
      var o = new String("abc");
      if (o[5] = "de", Object.getOwnPropertyNames(o)[0] === "5")
        return !1;
      for (var a = {}, s = 0; s < 10; s++)
        a["_" + String.fromCharCode(s)] = s;
      var u = Object.getOwnPropertyNames(a).map(function(c) {
        return a[c];
      });
      if (u.join("") !== "0123456789")
        return !1;
      var l = {};
      return "abcdefghijklmnopqrst".split("").forEach(function(c) {
        l[c] = c;
      }), Object.keys(Object.assign({}, l)).join("") === "abcdefghijklmnopqrst";
    } catch {
      return !1;
    }
  }
  return v3 = i() ? Object.assign : function(o, a) {
    for (var s, u = r(o), l, c = 1; c < arguments.length; c++) {
      s = Object(arguments[c]);
      for (var d in s)
        e.call(s, d) && (u[d] = s[d]);
      if (t) {
        l = t(s);
        for (var f = 0; f < l.length; f++)
          n.call(s, l[f]) && (u[l[f]] = s[l[f]]);
      }
    }
    return u;
  }, v3;
}
var b3, T$;
function eY() {
  return T$ || (T$ = 1, b3 = Function.call.bind(Object.prototype.hasOwnProperty)), b3;
}
var y3, O$;
function Wke() {
  if (O$)
    return y3;
  O$ = 1;
  var t = function() {
  };
  if (process.env.NODE_ENV !== "production") {
    var e = x9(), n = {}, r = eY();
    t = function(o) {
      var a = "Warning: " + o;
      typeof console < "u" && console.error(a);
      try {
        throw new Error(a);
      } catch {
      }
    };
  }
  function i(o, a, s, u, l) {
    if (process.env.NODE_ENV !== "production") {
      for (var c in o)
        if (r(o, c)) {
          var d;
          try {
            if (typeof o[c] != "function") {
              var f = Error(
                (u || "React class") + ": " + s + " type `" + c + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof o[c] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`."
              );
              throw f.name = "Invariant Violation", f;
            }
            d = o[c](a, c, u, s, null, e);
          } catch (p) {
            d = p;
          }
          if (d && !(d instanceof Error) && t(
            (u || "React class") + ": type specification of " + s + " `" + c + "` is invalid; the type checker function must return `null` or an `Error` but returned a " + typeof d + ". You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument)."
          ), d instanceof Error && !(d.message in n)) {
            n[d.message] = !0;
            var h = l ? l() : "";
            t(
              "Failed " + s + " type: " + d.message + (h ?? "")
            );
          }
        }
    }
  }
  return i.resetWarningCache = function() {
    process.env.NODE_ENV !== "production" && (n = {});
  }, y3 = i, y3;
}
var x3, P$;
function jke() {
  if (P$)
    return x3;
  P$ = 1;
  var t = QX(), e = Hke(), n = x9(), r = eY(), i = Wke(), o = function() {
  };
  process.env.NODE_ENV !== "production" && (o = function(s) {
    var u = "Warning: " + s;
    typeof console < "u" && console.error(u);
    try {
      throw new Error(u);
    } catch {
    }
  });
  function a() {
    return null;
  }
  return x3 = function(s, u) {
    var l = typeof Symbol == "function" && Symbol.iterator, c = "@@iterator";
    function d(L) {
      var j = L && (l && L[l] || L[c]);
      if (typeof j == "function")
        return j;
    }
    var f = "<<anonymous>>", h = {
      array: b("array"),
      bigint: b("bigint"),
      bool: b("boolean"),
      func: b("function"),
      number: b("number"),
      object: b("object"),
      string: b("string"),
      symbol: b("symbol"),
      any: y(),
      arrayOf: w,
      element: S(),
      elementType: E(),
      instanceOf: I,
      node: N(),
      objectOf: A,
      oneOf: _,
      oneOfType: P,
      shape: D,
      exact: R
    };
    function p(L, j) {
      return L === j ? L !== 0 || 1 / L === 1 / j : L !== L && j !== j;
    }
    function v(L, j) {
      this.message = L, this.data = j && typeof j == "object" ? j : {}, this.stack = "";
    }
    v.prototype = Error.prototype;
    function m(L) {
      if (process.env.NODE_ENV !== "production")
        var j = {}, K = 0;
      function W(U, Q, Z, ee, ie, oe, se) {
        if (ee = ee || f, oe = oe || Z, se !== n) {
          if (u) {
            var te = new Error(
              "Calling PropTypes validators directly is not supported by the `prop-types` package. Use `PropTypes.checkPropTypes()` to call them. Read more at http://fb.me/use-check-prop-types"
            );
            throw te.name = "Invariant Violation", te;
          } else if (process.env.NODE_ENV !== "production" && typeof console < "u") {
            var ge = ee + ":" + Z;
            !j[ge] && // Avoid spamming the console because they are often not actionable except for lib authors
            K < 3 && (o(
              "You are manually calling a React.PropTypes validation function for the `" + oe + "` prop on `" + ee + "`. This is deprecated and will throw in the standalone `prop-types` package. You may be seeing this warning due to a third-party PropTypes library. See https://fb.me/react-warning-dont-call-proptypes for details."
            ), j[ge] = !0, K++);
          }
        }
        return Q[Z] == null ? U ? Q[Z] === null ? new v("The " + ie + " `" + oe + "` is marked as required " + ("in `" + ee + "`, but its value is `null`.")) : new v("The " + ie + " `" + oe + "` is marked as required in " + ("`" + ee + "`, but its value is `undefined`.")) : null : L(Q, Z, ee, ie, oe);
      }
      var Y = W.bind(null, !1);
      return Y.isRequired = W.bind(null, !0), Y;
    }
    function b(L) {
      function j(K, W, Y, U, Q, Z) {
        var ee = K[W], ie = F(ee);
        if (ie !== L) {
          var oe = M(ee);
          return new v(
            "Invalid " + U + " `" + Q + "` of type " + ("`" + oe + "` supplied to `" + Y + "`, expected ") + ("`" + L + "`."),
            { expectedType: L }
          );
        }
        return null;
      }
      return m(j);
    }
    function y() {
      return m(a);
    }
    function w(L) {
      function j(K, W, Y, U, Q) {
        if (typeof L != "function")
          return new v("Property `" + Q + "` of component `" + Y + "` has invalid PropType notation inside arrayOf.");
        var Z = K[W];
        if (!Array.isArray(Z)) {
          var ee = F(Z);
          return new v("Invalid " + U + " `" + Q + "` of type " + ("`" + ee + "` supplied to `" + Y + "`, expected an array."));
        }
        for (var ie = 0; ie < Z.length; ie++) {
          var oe = L(Z, ie, Y, U, Q + "[" + ie + "]", n);
          if (oe instanceof Error)
            return oe;
        }
        return null;
      }
      return m(j);
    }
    function S() {
      function L(j, K, W, Y, U) {
        var Q = j[K];
        if (!s(Q)) {
          var Z = F(Q);
          return new v("Invalid " + Y + " `" + U + "` of type " + ("`" + Z + "` supplied to `" + W + "`, expected a single ReactElement."));
        }
        return null;
      }
      return m(L);
    }
    function E() {
      function L(j, K, W, Y, U) {
        var Q = j[K];
        if (!t.isValidElementType(Q)) {
          var Z = F(Q);
          return new v("Invalid " + Y + " `" + U + "` of type " + ("`" + Z + "` supplied to `" + W + "`, expected a single ReactElement type."));
        }
        return null;
      }
      return m(L);
    }
    function I(L) {
      function j(K, W, Y, U, Q) {
        if (!(K[W] instanceof L)) {
          var Z = L.name || f, ee = X(K[W]);
          return new v("Invalid " + U + " `" + Q + "` of type " + ("`" + ee + "` supplied to `" + Y + "`, expected ") + ("instance of `" + Z + "`."));
        }
        return null;
      }
      return m(j);
    }
    function _(L) {
      if (!Array.isArray(L))
        return process.env.NODE_ENV !== "production" && (arguments.length > 1 ? o(
          "Invalid arguments supplied to oneOf, expected an array, got " + arguments.length + " arguments. A common mistake is to write oneOf(x, y, z) instead of oneOf([x, y, z])."
        ) : o("Invalid argument supplied to oneOf, expected an array.")), a;
      function j(K, W, Y, U, Q) {
        for (var Z = K[W], ee = 0; ee < L.length; ee++)
          if (p(Z, L[ee]))
            return null;
        var ie = JSON.stringify(L, function(se, te) {
          var ge = M(te);
          return ge === "symbol" ? String(te) : te;
        });
        return new v("Invalid " + U + " `" + Q + "` of value `" + String(Z) + "` " + ("supplied to `" + Y + "`, expected one of " + ie + "."));
      }
      return m(j);
    }
    function A(L) {
      function j(K, W, Y, U, Q) {
        if (typeof L != "function")
          return new v("Property `" + Q + "` of component `" + Y + "` has invalid PropType notation inside objectOf.");
        var Z = K[W], ee = F(Z);
        if (ee !== "object")
          return new v("Invalid " + U + " `" + Q + "` of type " + ("`" + ee + "` supplied to `" + Y + "`, expected an object."));
        for (var ie in Z)
          if (r(Z, ie)) {
            var oe = L(Z, ie, Y, U, Q + "." + ie, n);
            if (oe instanceof Error)
              return oe;
          }
        return null;
      }
      return m(j);
    }
    function P(L) {
      if (!Array.isArray(L))
        return process.env.NODE_ENV !== "production" && o("Invalid argument supplied to oneOfType, expected an instance of array."), a;
      for (var j = 0; j < L.length; j++) {
        var K = L[j];
        if (typeof K != "function")
          return o(
            "Invalid argument supplied to oneOfType. Expected an array of check functions, but received " + B(K) + " at index " + j + "."
          ), a;
      }
      function W(Y, U, Q, Z, ee) {
        for (var ie = [], oe = 0; oe < L.length; oe++) {
          var se = L[oe], te = se(Y, U, Q, Z, ee, n);
          if (te == null)
            return null;
          te.data && r(te.data, "expectedType") && ie.push(te.data.expectedType);
        }
        var ge = ie.length > 0 ? ", expected one of type [" + ie.join(", ") + "]" : "";
        return new v("Invalid " + Z + " `" + ee + "` supplied to " + ("`" + Q + "`" + ge + "."));
      }
      return m(W);
    }
    function N() {
      function L(j, K, W, Y, U) {
        return V(j[K]) ? null : new v("Invalid " + Y + " `" + U + "` supplied to " + ("`" + W + "`, expected a ReactNode."));
      }
      return m(L);
    }
    function k(L, j, K, W, Y) {
      return new v(
        (L || "React class") + ": " + j + " type `" + K + "." + W + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + Y + "`."
      );
    }
    function D(L) {
      function j(K, W, Y, U, Q) {
        var Z = K[W], ee = F(Z);
        if (ee !== "object")
          return new v("Invalid " + U + " `" + Q + "` of type `" + ee + "` " + ("supplied to `" + Y + "`, expected `object`."));
        for (var ie in L) {
          var oe = L[ie];
          if (typeof oe != "function")
            return k(Y, U, Q, ie, M(oe));
          var se = oe(Z, ie, Y, U, Q + "." + ie, n);
          if (se)
            return se;
        }
        return null;
      }
      return m(j);
    }
    function R(L) {
      function j(K, W, Y, U, Q) {
        var Z = K[W], ee = F(Z);
        if (ee !== "object")
          return new v("Invalid " + U + " `" + Q + "` of type `" + ee + "` " + ("supplied to `" + Y + "`, expected `object`."));
        var ie = e({}, K[W], L);
        for (var oe in ie) {
          var se = L[oe];
          if (r(L, oe) && typeof se != "function")
            return k(Y, U, Q, oe, M(se));
          if (!se)
            return new v(
              "Invalid " + U + " `" + Q + "` key `" + oe + "` supplied to `" + Y + "`.\nBad object: " + JSON.stringify(K[W], null, "  ") + `
Valid keys: ` + JSON.stringify(Object.keys(L), null, "  ")
            );
          var te = se(Z, oe, Y, U, Q + "." + oe, n);
          if (te)
            return te;
        }
        return null;
      }
      return m(j);
    }
    function V(L) {
      switch (typeof L) {
        case "number":
        case "string":
        case "undefined":
          return !0;
        case "boolean":
          return !L;
        case "object":
          if (Array.isArray(L))
            return L.every(V);
          if (L === null || s(L))
            return !0;
          var j = d(L);
          if (j) {
            var K = j.call(L), W;
            if (j !== L.entries) {
              for (; !(W = K.next()).done; )
                if (!V(W.value))
                  return !1;
            } else
              for (; !(W = K.next()).done; ) {
                var Y = W.value;
                if (Y && !V(Y[1]))
                  return !1;
              }
          } else
            return !1;
          return !0;
        default:
          return !1;
      }
    }
    function $(L, j) {
      return L === "symbol" ? !0 : j ? j["@@toStringTag"] === "Symbol" || typeof Symbol == "function" && j instanceof Symbol : !1;
    }
    function F(L) {
      var j = typeof L;
      return Array.isArray(L) ? "array" : L instanceof RegExp ? "object" : $(j, L) ? "symbol" : j;
    }
    function M(L) {
      if (typeof L > "u" || L === null)
        return "" + L;
      var j = F(L);
      if (j === "object") {
        if (L instanceof Date)
          return "date";
        if (L instanceof RegExp)
          return "regexp";
      }
      return j;
    }
    function B(L) {
      var j = M(L);
      switch (j) {
        case "array":
        case "object":
          return "an " + j;
        case "boolean":
        case "date":
        case "regexp":
          return "a " + j;
        default:
          return j;
      }
    }
    function X(L) {
      return !L.constructor || !L.constructor.name ? f : L.constructor.name;
    }
    return h.checkPropTypes = i, h.resetWarningCache = i.resetWarningCache, h.PropTypes = h, h;
  }, x3;
}
if (process.env.NODE_ENV !== "production") {
  var zke = QX(), Gke = !0;
  w_.exports = jke()(zke.isElement, Gke);
} else
  w_.exports = Lke()();
var tY = w_.exports;
const le = /* @__PURE__ */ qn(tY);
function Uke() {
  this.__data__ = [], this.size = 0;
}
function ev(t, e) {
  return t === e || t !== t && e !== e;
}
function jC(t, e) {
  for (var n = t.length; n--; )
    if (ev(t[n][0], e))
      return n;
  return -1;
}
var Xke = Array.prototype, Yke = Xke.splice;
function Zke(t) {
  var e = this.__data__, n = jC(e, t);
  if (n < 0)
    return !1;
  var r = e.length - 1;
  return n == r ? e.pop() : Yke.call(e, n, 1), --this.size, !0;
}
function Jke(t) {
  var e = this.__data__, n = jC(e, t);
  return n < 0 ? void 0 : e[n][1];
}
function Kke(t) {
  return jC(this.__data__, t) > -1;
}
function qke(t, e) {
  var n = this.__data__, r = jC(n, t);
  return r < 0 ? (++this.size, n.push([t, e])) : n[r][1] = e, this;
}
function dl(t) {
  var e = -1, n = t == null ? 0 : t.length;
  for (this.clear(); ++e < n; ) {
    var r = t[e];
    this.set(r[0], r[1]);
  }
}
dl.prototype.clear = Uke;
dl.prototype.delete = Zke;
dl.prototype.get = Jke;
dl.prototype.has = Kke;
dl.prototype.set = qke;
function Qke() {
  this.__data__ = new dl(), this.size = 0;
}
function eRe(t) {
  var e = this.__data__, n = e.delete(t);
  return this.size = e.size, n;
}
function tRe(t) {
  return this.__data__.get(t);
}
function nRe(t) {
  return this.__data__.has(t);
}
var rRe = typeof global == "object" && global && global.Object === Object && global;
const nY = rRe;
var iRe = typeof self == "object" && self && self.Object === Object && self, oRe = nY || iRe || Function("return this")();
const Ms = oRe;
var aRe = Ms.Symbol;
const dc = aRe;
var rY = Object.prototype, sRe = rY.hasOwnProperty, uRe = rY.toString, kg = dc ? dc.toStringTag : void 0;
function lRe(t) {
  var e = sRe.call(t, kg), n = t[kg];
  try {
    t[kg] = void 0;
    var r = !0;
  } catch {
  }
  var i = uRe.call(t);
  return r && (e ? t[kg] = n : delete t[kg]), i;
}
var cRe = Object.prototype, dRe = cRe.toString;
function fRe(t) {
  return dRe.call(t);
}
var hRe = "[object Null]", pRe = "[object Undefined]", N$ = dc ? dc.toStringTag : void 0;
function Jd(t) {
  return t == null ? t === void 0 ? pRe : hRe : N$ && N$ in Object(t) ? lRe(t) : fRe(t);
}
function Ya(t) {
  var e = typeof t;
  return t != null && (e == "object" || e == "function");
}
var gRe = "[object AsyncFunction]", mRe = "[object Function]", vRe = "[object GeneratorFunction]", bRe = "[object Proxy]";
function C9(t) {
  if (!Ya(t))
    return !1;
  var e = Jd(t);
  return e == mRe || e == vRe || e == gRe || e == bRe;
}
var yRe = Ms["__core-js_shared__"];
const C3 = yRe;
var k$ = function() {
  var t = /[^.]+$/.exec(C3 && C3.keys && C3.keys.IE_PROTO || "");
  return t ? "Symbol(src)_1." + t : "";
}();
function xRe(t) {
  return !!k$ && k$ in t;
}
var CRe = Function.prototype, wRe = CRe.toString;
function Kd(t) {
  if (t != null) {
    try {
      return wRe.call(t);
    } catch {
    }
    try {
      return t + "";
    } catch {
    }
  }
  return "";
}
var ERe = /[\\^$.*+?()[\]{}|]/g, SRe = /^\[object .+?Constructor\]$/, IRe = Function.prototype, _Re = Object.prototype, ARe = IRe.toString, TRe = _Re.hasOwnProperty, ORe = RegExp(
  "^" + ARe.call(TRe).replace(ERe, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$"
);
function PRe(t) {
  if (!Ya(t) || xRe(t))
    return !1;
  var e = C9(t) ? ORe : SRe;
  return e.test(Kd(t));
}
function NRe(t, e) {
  return t == null ? void 0 : t[e];
}
function qd(t, e) {
  var n = NRe(t, e);
  return PRe(n) ? n : void 0;
}
var kRe = qd(Ms, "Map");
const J0 = kRe;
var RRe = qd(Object, "create");
const K0 = RRe;
function $Re() {
  this.__data__ = K0 ? K0(null) : {}, this.size = 0;
}
function DRe(t) {
  var e = this.has(t) && delete this.__data__[t];
  return this.size -= e ? 1 : 0, e;
}
var MRe = "__lodash_hash_undefined__", FRe = Object.prototype, LRe = FRe.hasOwnProperty;
function VRe(t) {
  var e = this.__data__;
  if (K0) {
    var n = e[t];
    return n === MRe ? void 0 : n;
  }
  return LRe.call(e, t) ? e[t] : void 0;
}
var BRe = Object.prototype, HRe = BRe.hasOwnProperty;
function WRe(t) {
  var e = this.__data__;
  return K0 ? e[t] !== void 0 : HRe.call(e, t);
}
var jRe = "__lodash_hash_undefined__";
function zRe(t, e) {
  var n = this.__data__;
  return this.size += this.has(t) ? 0 : 1, n[t] = K0 && e === void 0 ? jRe : e, this;
}
function kd(t) {
  var e = -1, n = t == null ? 0 : t.length;
  for (this.clear(); ++e < n; ) {
    var r = t[e];
    this.set(r[0], r[1]);
  }
}
kd.prototype.clear = $Re;
kd.prototype.delete = DRe;
kd.prototype.get = VRe;
kd.prototype.has = WRe;
kd.prototype.set = zRe;
function GRe() {
  this.size = 0, this.__data__ = {
    hash: new kd(),
    map: new (J0 || dl)(),
    string: new kd()
  };
}
function URe(t) {
  var e = typeof t;
  return e == "string" || e == "number" || e == "symbol" || e == "boolean" ? t !== "__proto__" : t === null;
}
function zC(t, e) {
  var n = t.__data__;
  return URe(e) ? n[typeof e == "string" ? "string" : "hash"] : n.map;
}
function XRe(t) {
  var e = zC(this, t).delete(t);
  return this.size -= e ? 1 : 0, e;
}
function YRe(t) {
  return zC(this, t).get(t);
}
function ZRe(t) {
  return zC(this, t).has(t);
}
function JRe(t, e) {
  var n = zC(this, t), r = n.size;
  return n.set(t, e), this.size += n.size == r ? 0 : 1, this;
}
function fl(t) {
  var e = -1, n = t == null ? 0 : t.length;
  for (this.clear(); ++e < n; ) {
    var r = t[e];
    this.set(r[0], r[1]);
  }
}
fl.prototype.clear = GRe;
fl.prototype.delete = XRe;
fl.prototype.get = YRe;
fl.prototype.has = ZRe;
fl.prototype.set = JRe;
var KRe = 200;
function qRe(t, e) {
  var n = this.__data__;
  if (n instanceof dl) {
    var r = n.__data__;
    if (!J0 || r.length < KRe - 1)
      return r.push([t, e]), this.size = ++n.size, this;
    n = this.__data__ = new fl(r);
  }
  return n.set(t, e), this.size = n.size, this;
}
function su(t) {
  var e = this.__data__ = new dl(t);
  this.size = e.size;
}
su.prototype.clear = Qke;
su.prototype.delete = eRe;
su.prototype.get = tRe;
su.prototype.has = nRe;
su.prototype.set = qRe;
var QRe = function() {
  try {
    var t = qd(Object, "defineProperty");
    return t({}, "", {}), t;
  } catch {
  }
}();
const Nx = QRe;
function w9(t, e, n) {
  e == "__proto__" && Nx ? Nx(t, e, {
    configurable: !0,
    enumerable: !0,
    value: n,
    writable: !0
  }) : t[e] = n;
}
function E_(t, e, n) {
  (n !== void 0 && !ev(t[e], n) || n === void 0 && !(e in t)) && w9(t, e, n);
}
function e$e(t) {
  return function(e, n, r) {
    for (var i = -1, o = Object(e), a = r(e), s = a.length; s--; ) {
      var u = a[t ? s : ++i];
      if (n(o[u], u, o) === !1)
        break;
    }
    return e;
  };
}
var t$e = e$e();
const iY = t$e;
var oY = typeof exports == "object" && exports && !exports.nodeType && exports, R$ = oY && typeof module == "object" && module && !module.nodeType && module, n$e = R$ && R$.exports === oY, $$ = n$e ? Ms.Buffer : void 0, D$ = $$ ? $$.allocUnsafe : void 0;
function r$e(t, e) {
  if (e)
    return t.slice();
  var n = t.length, r = D$ ? D$(n) : new t.constructor(n);
  return t.copy(r), r;
}
var i$e = Ms.Uint8Array;
const kx = i$e;
function o$e(t) {
  var e = new t.constructor(t.byteLength);
  return new kx(e).set(new kx(t)), e;
}
function a$e(t, e) {
  var n = e ? o$e(t.buffer) : t.buffer;
  return new t.constructor(n, t.byteOffset, t.length);
}
function s$e(t, e) {
  var n = -1, r = t.length;
  for (e || (e = Array(r)); ++n < r; )
    e[n] = t[n];
  return e;
}
var M$ = Object.create, u$e = /* @__PURE__ */ function() {
  function t() {
  }
  return function(e) {
    if (!Ya(e))
      return {};
    if (M$)
      return M$(e);
    t.prototype = e;
    var n = new t();
    return t.prototype = void 0, n;
  };
}();
const l$e = u$e;
function aY(t, e) {
  return function(n) {
    return t(e(n));
  };
}
var c$e = aY(Object.getPrototypeOf, Object);
const sY = c$e;
var d$e = Object.prototype;
function E9(t) {
  var e = t && t.constructor, n = typeof e == "function" && e.prototype || d$e;
  return t === n;
}
function f$e(t) {
  return typeof t.constructor == "function" && !E9(t) ? l$e(sY(t)) : {};
}
function fc(t) {
  return t != null && typeof t == "object";
}
var h$e = "[object Arguments]";
function F$(t) {
  return fc(t) && Jd(t) == h$e;
}
var uY = Object.prototype, p$e = uY.hasOwnProperty, g$e = uY.propertyIsEnumerable, m$e = F$(/* @__PURE__ */ function() {
  return arguments;
}()) ? F$ : function(t) {
  return fc(t) && p$e.call(t, "callee") && !g$e.call(t, "callee");
};
const Rx = m$e;
var v$e = Array.isArray;
const ba = v$e;
var b$e = 9007199254740991;
function S9(t) {
  return typeof t == "number" && t > -1 && t % 1 == 0 && t <= b$e;
}
function Mp(t) {
  return t != null && S9(t.length) && !C9(t);
}
function y$e(t) {
  return fc(t) && Mp(t);
}
function x$e() {
  return !1;
}
var lY = typeof exports == "object" && exports && !exports.nodeType && exports, L$ = lY && typeof module == "object" && module && !module.nodeType && module, C$e = L$ && L$.exports === lY, V$ = C$e ? Ms.Buffer : void 0, w$e = V$ ? V$.isBuffer : void 0, E$e = w$e || x$e;
const $x = E$e;
var S$e = "[object Object]", I$e = Function.prototype, _$e = Object.prototype, cY = I$e.toString, A$e = _$e.hasOwnProperty, T$e = cY.call(Object);
function O$e(t) {
  if (!fc(t) || Jd(t) != S$e)
    return !1;
  var e = sY(t);
  if (e === null)
    return !0;
  var n = A$e.call(e, "constructor") && e.constructor;
  return typeof n == "function" && n instanceof n && cY.call(n) == T$e;
}
var P$e = "[object Arguments]", N$e = "[object Array]", k$e = "[object Boolean]", R$e = "[object Date]", $$e = "[object Error]", D$e = "[object Function]", M$e = "[object Map]", F$e = "[object Number]", L$e = "[object Object]", V$e = "[object RegExp]", B$e = "[object Set]", H$e = "[object String]", W$e = "[object WeakMap]", j$e = "[object ArrayBuffer]", z$e = "[object DataView]", G$e = "[object Float32Array]", U$e = "[object Float64Array]", X$e = "[object Int8Array]", Y$e = "[object Int16Array]", Z$e = "[object Int32Array]", J$e = "[object Uint8Array]", K$e = "[object Uint8ClampedArray]", q$e = "[object Uint16Array]", Q$e = "[object Uint32Array]", Mr = {};
Mr[G$e] = Mr[U$e] = Mr[X$e] = Mr[Y$e] = Mr[Z$e] = Mr[J$e] = Mr[K$e] = Mr[q$e] = Mr[Q$e] = !0;
Mr[P$e] = Mr[N$e] = Mr[j$e] = Mr[k$e] = Mr[z$e] = Mr[R$e] = Mr[$$e] = Mr[D$e] = Mr[M$e] = Mr[F$e] = Mr[L$e] = Mr[V$e] = Mr[B$e] = Mr[H$e] = Mr[W$e] = !1;
function eDe(t) {
  return fc(t) && S9(t.length) && !!Mr[Jd(t)];
}
function tDe(t) {
  return function(e) {
    return t(e);
  };
}
var dY = typeof exports == "object" && exports && !exports.nodeType && exports, v0 = dY && typeof module == "object" && module && !module.nodeType && module, nDe = v0 && v0.exports === dY, w3 = nDe && nY.process, rDe = function() {
  try {
    var t = v0 && v0.require && v0.require("util").types;
    return t || w3 && w3.binding && w3.binding("util");
  } catch {
  }
}();
const B$ = rDe;
var H$ = B$ && B$.isTypedArray, iDe = H$ ? tDe(H$) : eDe;
const I9 = iDe;
function S_(t, e) {
  if (!(e === "constructor" && typeof t[e] == "function") && e != "__proto__")
    return t[e];
}
var oDe = Object.prototype, aDe = oDe.hasOwnProperty;
function sDe(t, e, n) {
  var r = t[e];
  (!(aDe.call(t, e) && ev(r, n)) || n === void 0 && !(e in t)) && w9(t, e, n);
}
function uDe(t, e, n, r) {
  var i = !n;
  n || (n = {});
  for (var o = -1, a = e.length; ++o < a; ) {
    var s = e[o], u = r ? r(n[s], t[s], s, n, t) : void 0;
    u === void 0 && (u = t[s]), i ? w9(n, s, u) : sDe(n, s, u);
  }
  return n;
}
function lDe(t, e) {
  for (var n = -1, r = Array(t); ++n < t; )
    r[n] = e(n);
  return r;
}
var cDe = 9007199254740991, dDe = /^(?:0|[1-9]\d*)$/;
function _9(t, e) {
  var n = typeof t;
  return e = e ?? cDe, !!e && (n == "number" || n != "symbol" && dDe.test(t)) && t > -1 && t % 1 == 0 && t < e;
}
var fDe = Object.prototype, hDe = fDe.hasOwnProperty;
function fY(t, e) {
  var n = ba(t), r = !n && Rx(t), i = !n && !r && $x(t), o = !n && !r && !i && I9(t), a = n || r || i || o, s = a ? lDe(t.length, String) : [], u = s.length;
  for (var l in t)
    (e || hDe.call(t, l)) && !(a && // Safari 9 has enumerable `arguments.length` in strict mode.
    (l == "length" || // Node.js 0.10 has enumerable non-index properties on buffers.
    i && (l == "offset" || l == "parent") || // PhantomJS 2 has enumerable non-index properties on typed arrays.
    o && (l == "buffer" || l == "byteLength" || l == "byteOffset") || // Skip index properties.
    _9(l, u))) && s.push(l);
  return s;
}
function pDe(t) {
  var e = [];
  if (t != null)
    for (var n in Object(t))
      e.push(n);
  return e;
}
var gDe = Object.prototype, mDe = gDe.hasOwnProperty;
function vDe(t) {
  if (!Ya(t))
    return pDe(t);
  var e = E9(t), n = [];
  for (var r in t)
    r == "constructor" && (e || !mDe.call(t, r)) || n.push(r);
  return n;
}
function hY(t) {
  return Mp(t) ? fY(t, !0) : vDe(t);
}
function bDe(t) {
  return uDe(t, hY(t));
}
function yDe(t, e, n, r, i, o, a) {
  var s = S_(t, n), u = S_(e, n), l = a.get(u);
  if (l) {
    E_(t, n, l);
    return;
  }
  var c = o ? o(s, u, n + "", t, e, a) : void 0, d = c === void 0;
  if (d) {
    var f = ba(u), h = !f && $x(u), p = !f && !h && I9(u);
    c = u, f || h || p ? ba(s) ? c = s : y$e(s) ? c = s$e(s) : h ? (d = !1, c = r$e(u, !0)) : p ? (d = !1, c = a$e(u, !0)) : c = [] : O$e(u) || Rx(u) ? (c = s, Rx(s) ? c = bDe(s) : (!Ya(s) || C9(s)) && (c = f$e(u))) : d = !1;
  }
  d && (a.set(u, c), i(c, u, r, o, a), a.delete(u)), E_(t, n, c);
}
function pY(t, e, n, r, i) {
  t !== e && iY(e, function(o, a) {
    if (i || (i = new su()), Ya(o))
      yDe(t, e, a, n, pY, r, i);
    else {
      var s = r ? r(S_(t, a), o, a + "", t, e, i) : void 0;
      s === void 0 && (s = o), E_(t, a, s);
    }
  }, hY);
}
function GC(t) {
  return t;
}
function xDe(t, e, n) {
  switch (n.length) {
    case 0:
      return t.call(e);
    case 1:
      return t.call(e, n[0]);
    case 2:
      return t.call(e, n[0], n[1]);
    case 3:
      return t.call(e, n[0], n[1], n[2]);
  }
  return t.apply(e, n);
}
var W$ = Math.max;
function CDe(t, e, n) {
  return e = W$(e === void 0 ? t.length - 1 : e, 0), function() {
    for (var r = arguments, i = -1, o = W$(r.length - e, 0), a = Array(o); ++i < o; )
      a[i] = r[e + i];
    i = -1;
    for (var s = Array(e + 1); ++i < e; )
      s[i] = r[i];
    return s[e] = n(a), xDe(t, this, s);
  };
}
function wDe(t) {
  return function() {
    return t;
  };
}
var EDe = Nx ? function(t, e) {
  return Nx(t, "toString", {
    configurable: !0,
    enumerable: !1,
    value: wDe(e),
    writable: !0
  });
} : GC;
const SDe = EDe;
var IDe = 800, _De = 16, ADe = Date.now;
function TDe(t) {
  var e = 0, n = 0;
  return function() {
    var r = ADe(), i = _De - (r - n);
    if (n = r, i > 0) {
      if (++e >= IDe)
        return arguments[0];
    } else
      e = 0;
    return t.apply(void 0, arguments);
  };
}
var ODe = TDe(SDe);
const PDe = ODe;
function NDe(t, e) {
  return PDe(CDe(t, e, GC), t + "");
}
function kDe(t, e, n) {
  if (!Ya(n))
    return !1;
  var r = typeof e;
  return (r == "number" ? Mp(n) && _9(e, n.length) : r == "string" && e in n) ? ev(n[e], t) : !1;
}
function RDe(t) {
  return NDe(function(e, n) {
    var r = -1, i = n.length, o = i > 1 ? n[i - 1] : void 0, a = i > 2 ? n[2] : void 0;
    for (o = t.length > 3 && typeof o == "function" ? (i--, o) : void 0, a && kDe(n[0], n[1], a) && (o = i < 3 ? void 0 : o, i = 1), e = Object(e); ++r < i; ) {
      var s = n[r];
      s && t(e, s, r, o);
    }
    return e;
  });
}
var $De = RDe(function(t, e, n) {
  pY(t, e, n);
});
const Fo = $De;
var tv = function(e) {
  var n = e.zDepth, r = e.radius, i = e.background, o = e.children, a = e.styles, s = a === void 0 ? {} : a, u = un(Fo({
    default: {
      wrap: {
        position: "relative",
        display: "inline-block"
      },
      content: {
        position: "relative"
      },
      bg: {
        absolute: "0px 0px 0px 0px",
        boxShadow: "0 " + n + "px " + n * 4 + "px rgba(0,0,0,.24)",
        borderRadius: r,
        background: i
      }
    },
    "zDepth-0": {
      bg: {
        boxShadow: "none"
      }
    },
    "zDepth-1": {
      bg: {
        boxShadow: "0 2px 10px rgba(0,0,0,.12), 0 2px 5px rgba(0,0,0,.16)"
      }
    },
    "zDepth-2": {
      bg: {
        boxShadow: "0 6px 20px rgba(0,0,0,.19), 0 8px 17px rgba(0,0,0,.2)"
      }
    },
    "zDepth-3": {
      bg: {
        boxShadow: "0 17px 50px rgba(0,0,0,.19), 0 12px 15px rgba(0,0,0,.24)"
      }
    },
    "zDepth-4": {
      bg: {
        boxShadow: "0 25px 55px rgba(0,0,0,.21), 0 16px 28px rgba(0,0,0,.22)"
      }
    },
    "zDepth-5": {
      bg: {
        boxShadow: "0 40px 77px rgba(0,0,0,.22), 0 27px 24px rgba(0,0,0,.2)"
      }
    },
    square: {
      bg: {
        borderRadius: "0"
      }
    },
    circle: {
      bg: {
        borderRadius: "50%"
      }
    }
  }, s), { "zDepth-1": n === 1 });
  return O.createElement(
    "div",
    { style: u.wrap },
    O.createElement("div", { style: u.bg }),
    O.createElement(
      "div",
      { style: u.content },
      o
    )
  );
};
tv.propTypes = {
  background: le.string,
  zDepth: le.oneOf([0, 1, 2, 3, 4, 5]),
  radius: le.number,
  styles: le.object
};
tv.defaultProps = {
  background: "#fff",
  zDepth: 1,
  radius: 2,
  styles: {}
};
var DDe = function() {
  return Ms.Date.now();
};
const E3 = DDe;
var MDe = /\s/;
function FDe(t) {
  for (var e = t.length; e-- && MDe.test(t.charAt(e)); )
    ;
  return e;
}
var LDe = /^\s+/;
function VDe(t) {
  return t && t.slice(0, FDe(t) + 1).replace(LDe, "");
}
var BDe = "[object Symbol]";
function UC(t) {
  return typeof t == "symbol" || fc(t) && Jd(t) == BDe;
}
var j$ = NaN, HDe = /^[-+]0x[0-9a-f]+$/i, WDe = /^0b[01]+$/i, jDe = /^0o[0-7]+$/i, zDe = parseInt;
function z$(t) {
  if (typeof t == "number")
    return t;
  if (UC(t))
    return j$;
  if (Ya(t)) {
    var e = typeof t.valueOf == "function" ? t.valueOf() : t;
    t = Ya(e) ? e + "" : e;
  }
  if (typeof t != "string")
    return t === 0 ? t : +t;
  t = VDe(t);
  var n = WDe.test(t);
  return n || jDe.test(t) ? zDe(t.slice(2), n ? 2 : 8) : HDe.test(t) ? j$ : +t;
}
var GDe = "Expected a function", UDe = Math.max, XDe = Math.min;
function gY(t, e, n) {
  var r, i, o, a, s, u, l = 0, c = !1, d = !1, f = !0;
  if (typeof t != "function")
    throw new TypeError(GDe);
  e = z$(e) || 0, Ya(n) && (c = !!n.leading, d = "maxWait" in n, o = d ? UDe(z$(n.maxWait) || 0, e) : o, f = "trailing" in n ? !!n.trailing : f);
  function h(I) {
    var _ = r, A = i;
    return r = i = void 0, l = I, a = t.apply(A, _), a;
  }
  function p(I) {
    return l = I, s = setTimeout(b, e), c ? h(I) : a;
  }
  function v(I) {
    var _ = I - u, A = I - l, P = e - _;
    return d ? XDe(P, o - A) : P;
  }
  function m(I) {
    var _ = I - u, A = I - l;
    return u === void 0 || _ >= e || _ < 0 || d && A >= o;
  }
  function b() {
    var I = E3();
    if (m(I))
      return y(I);
    s = setTimeout(b, v(I));
  }
  function y(I) {
    return s = void 0, f && r ? h(I) : (r = i = void 0, a);
  }
  function w() {
    s !== void 0 && clearTimeout(s), l = 0, r = u = i = s = void 0;
  }
  function S() {
    return s === void 0 ? a : y(E3());
  }
  function E() {
    var I = E3(), _ = m(I);
    if (r = arguments, i = this, u = I, _) {
      if (s === void 0)
        return p(u);
      if (d)
        return clearTimeout(s), s = setTimeout(b, e), h(u);
    }
    return s === void 0 && (s = setTimeout(b, e)), a;
  }
  return E.cancel = w, E.flush = S, E;
}
var YDe = "Expected a function";
function ZDe(t, e, n) {
  var r = !0, i = !0;
  if (typeof t != "function")
    throw new TypeError(YDe);
  return Ya(n) && (r = "leading" in n ? !!n.leading : r, i = "trailing" in n ? !!n.trailing : i), gY(t, e, {
    leading: r,
    maxWait: e,
    trailing: i
  });
}
var JDe = function(e, n, r) {
  var i = r.getBoundingClientRect(), o = i.width, a = i.height, s = typeof e.pageX == "number" ? e.pageX : e.touches[0].pageX, u = typeof e.pageY == "number" ? e.pageY : e.touches[0].pageY, l = s - (r.getBoundingClientRect().left + window.pageXOffset), c = u - (r.getBoundingClientRect().top + window.pageYOffset);
  l < 0 ? l = 0 : l > o && (l = o), c < 0 ? c = 0 : c > a && (c = a);
  var d = l / o, f = 1 - c / a;
  return {
    h: n.h,
    s: d,
    v: f,
    a: n.a,
    source: "hsv"
  };
}, KDe = /* @__PURE__ */ function() {
  function t(e, n) {
    for (var r = 0; r < n.length; r++) {
      var i = n[r];
      i.enumerable = i.enumerable || !1, i.configurable = !0, "value" in i && (i.writable = !0), Object.defineProperty(e, i.key, i);
    }
  }
  return function(e, n, r) {
    return n && t(e.prototype, n), r && t(e, r), e;
  };
}();
function qDe(t, e) {
  if (!(t instanceof e))
    throw new TypeError("Cannot call a class as a function");
}
function QDe(t, e) {
  if (!t)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e && (typeof e == "object" || typeof e == "function") ? e : t;
}
function eMe(t, e) {
  if (typeof e != "function" && e !== null)
    throw new TypeError("Super expression must either be null or a function, not " + typeof e);
  t.prototype = Object.create(e && e.prototype, { constructor: { value: t, enumerable: !1, writable: !0, configurable: !0 } }), e && (Object.setPrototypeOf ? Object.setPrototypeOf(t, e) : t.__proto__ = e);
}
var XC = function(t) {
  eMe(e, t);
  function e(n) {
    qDe(this, e);
    var r = QDe(this, (e.__proto__ || Object.getPrototypeOf(e)).call(this, n));
    return r.handleChange = function(i) {
      typeof r.props.onChange == "function" && r.throttle(r.props.onChange, JDe(i, r.props.hsl, r.container), i);
    }, r.handleMouseDown = function(i) {
      r.handleChange(i);
      var o = r.getContainerRenderWindow();
      o.addEventListener("mousemove", r.handleChange), o.addEventListener("mouseup", r.handleMouseUp);
    }, r.handleMouseUp = function() {
      r.unbindEventListeners();
    }, r.throttle = ZDe(function(i, o, a) {
      i(o, a);
    }, 50), r;
  }
  return KDe(e, [{
    key: "componentWillUnmount",
    value: function() {
      this.throttle.cancel(), this.unbindEventListeners();
    }
  }, {
    key: "getContainerRenderWindow",
    value: function() {
      for (var r = this.container, i = window; !i.document.contains(r) && i.parent !== i; )
        i = i.parent;
      return i;
    }
  }, {
    key: "unbindEventListeners",
    value: function() {
      var r = this.getContainerRenderWindow();
      r.removeEventListener("mousemove", this.handleChange), r.removeEventListener("mouseup", this.handleMouseUp);
    }
  }, {
    key: "render",
    value: function() {
      var r = this, i = this.props.style || {}, o = i.color, a = i.white, s = i.black, u = i.pointer, l = i.circle, c = un({
        default: {
          color: {
            absolute: "0px 0px 0px 0px",
            background: "hsl(" + this.props.hsl.h + ",100%, 50%)",
            borderRadius: this.props.radius
          },
          white: {
            absolute: "0px 0px 0px 0px",
            borderRadius: this.props.radius
          },
          black: {
            absolute: "0px 0px 0px 0px",
            boxShadow: this.props.shadow,
            borderRadius: this.props.radius
          },
          pointer: {
            position: "absolute",
            top: -(this.props.hsv.v * 100) + 100 + "%",
            left: this.props.hsv.s * 100 + "%",
            cursor: "default"
          },
          circle: {
            width: "4px",
            height: "4px",
            boxShadow: `0 0 0 1.5px #fff, inset 0 0 1px 1px rgba(0,0,0,.3),
            0 0 1px 2px rgba(0,0,0,.4)`,
            borderRadius: "50%",
            cursor: "hand",
            transform: "translate(-2px, -2px)"
          }
        },
        custom: {
          color: o,
          white: a,
          black: s,
          pointer: u,
          circle: l
        }
      }, { custom: !!this.props.style });
      return O.createElement(
        "div",
        {
          style: c.color,
          ref: function(f) {
            return r.container = f;
          },
          onMouseDown: this.handleMouseDown,
          onTouchMove: this.handleChange,
          onTouchStart: this.handleChange
        },
        O.createElement(
          "style",
          null,
          `
          .saturation-white {
            background: -webkit-linear-gradient(to right, #fff, rgba(255,255,255,0));
            background: linear-gradient(to right, #fff, rgba(255,255,255,0));
          }
          .saturation-black {
            background: -webkit-linear-gradient(to top, #000, rgba(0,0,0,0));
            background: linear-gradient(to top, #000, rgba(0,0,0,0));
          }
        `
        ),
        O.createElement(
          "div",
          { style: c.white, className: "saturation-white" },
          O.createElement("div", { style: c.black, className: "saturation-black" }),
          O.createElement(
            "div",
            { style: c.pointer },
            this.props.pointer ? O.createElement(this.props.pointer, this.props) : O.createElement("div", { style: c.circle })
          )
        )
      );
    }
  }]), e;
}(Pm || Do);
function tMe(t, e) {
  for (var n = -1, r = t == null ? 0 : t.length; ++n < r && e(t[n], n, t) !== !1; )
    ;
  return t;
}
var nMe = aY(Object.keys, Object);
const rMe = nMe;
var iMe = Object.prototype, oMe = iMe.hasOwnProperty;
function aMe(t) {
  if (!E9(t))
    return rMe(t);
  var e = [];
  for (var n in Object(t))
    oMe.call(t, n) && n != "constructor" && e.push(n);
  return e;
}
function A9(t) {
  return Mp(t) ? fY(t) : aMe(t);
}
function sMe(t, e) {
  return t && iY(t, e, A9);
}
function uMe(t, e) {
  return function(n, r) {
    if (n == null)
      return n;
    if (!Mp(n))
      return t(n, r);
    for (var i = n.length, o = e ? i : -1, a = Object(n); (e ? o-- : ++o < i) && r(a[o], o, a) !== !1; )
      ;
    return n;
  };
}
var lMe = uMe(sMe);
const mY = lMe;
function cMe(t) {
  return typeof t == "function" ? t : GC;
}
function dMe(t, e) {
  var n = ba(t) ? tMe : mY;
  return n(t, cMe(e));
}
function Dx(t) {
  "@babel/helpers - typeof";
  return Dx = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(e) {
    return typeof e;
  } : function(e) {
    return e && typeof Symbol == "function" && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
  }, Dx(t);
}
var fMe = /^\s+/, hMe = /\s+$/;
function Lt(t, e) {
  if (t = t || "", e = e || {}, t instanceof Lt)
    return t;
  if (!(this instanceof Lt))
    return new Lt(t, e);
  var n = pMe(t);
  this._originalInput = t, this._r = n.r, this._g = n.g, this._b = n.b, this._a = n.a, this._roundA = Math.round(100 * this._a) / 100, this._format = e.format || n.format, this._gradientType = e.gradientType, this._r < 1 && (this._r = Math.round(this._r)), this._g < 1 && (this._g = Math.round(this._g)), this._b < 1 && (this._b = Math.round(this._b)), this._ok = n.ok;
}
Lt.prototype = {
  isDark: function() {
    return this.getBrightness() < 128;
  },
  isLight: function() {
    return !this.isDark();
  },
  isValid: function() {
    return this._ok;
  },
  getOriginalInput: function() {
    return this._originalInput;
  },
  getFormat: function() {
    return this._format;
  },
  getAlpha: function() {
    return this._a;
  },
  getBrightness: function() {
    var e = this.toRgb();
    return (e.r * 299 + e.g * 587 + e.b * 114) / 1e3;
  },
  getLuminance: function() {
    var e = this.toRgb(), n, r, i, o, a, s;
    return n = e.r / 255, r = e.g / 255, i = e.b / 255, n <= 0.03928 ? o = n / 12.92 : o = Math.pow((n + 0.055) / 1.055, 2.4), r <= 0.03928 ? a = r / 12.92 : a = Math.pow((r + 0.055) / 1.055, 2.4), i <= 0.03928 ? s = i / 12.92 : s = Math.pow((i + 0.055) / 1.055, 2.4), 0.2126 * o + 0.7152 * a + 0.0722 * s;
  },
  setAlpha: function(e) {
    return this._a = vY(e), this._roundA = Math.round(100 * this._a) / 100, this;
  },
  toHsv: function() {
    var e = U$(this._r, this._g, this._b);
    return {
      h: e.h * 360,
      s: e.s,
      v: e.v,
      a: this._a
    };
  },
  toHsvString: function() {
    var e = U$(this._r, this._g, this._b), n = Math.round(e.h * 360), r = Math.round(e.s * 100), i = Math.round(e.v * 100);
    return this._a == 1 ? "hsv(" + n + ", " + r + "%, " + i + "%)" : "hsva(" + n + ", " + r + "%, " + i + "%, " + this._roundA + ")";
  },
  toHsl: function() {
    var e = G$(this._r, this._g, this._b);
    return {
      h: e.h * 360,
      s: e.s,
      l: e.l,
      a: this._a
    };
  },
  toHslString: function() {
    var e = G$(this._r, this._g, this._b), n = Math.round(e.h * 360), r = Math.round(e.s * 100), i = Math.round(e.l * 100);
    return this._a == 1 ? "hsl(" + n + ", " + r + "%, " + i + "%)" : "hsla(" + n + ", " + r + "%, " + i + "%, " + this._roundA + ")";
  },
  toHex: function(e) {
    return X$(this._r, this._g, this._b, e);
  },
  toHexString: function(e) {
    return "#" + this.toHex(e);
  },
  toHex8: function(e) {
    return bMe(this._r, this._g, this._b, this._a, e);
  },
  toHex8String: function(e) {
    return "#" + this.toHex8(e);
  },
  toRgb: function() {
    return {
      r: Math.round(this._r),
      g: Math.round(this._g),
      b: Math.round(this._b),
      a: this._a
    };
  },
  toRgbString: function() {
    return this._a == 1 ? "rgb(" + Math.round(this._r) + ", " + Math.round(this._g) + ", " + Math.round(this._b) + ")" : "rgba(" + Math.round(this._r) + ", " + Math.round(this._g) + ", " + Math.round(this._b) + ", " + this._roundA + ")";
  },
  toPercentageRgb: function() {
    return {
      r: Math.round(Vr(this._r, 255) * 100) + "%",
      g: Math.round(Vr(this._g, 255) * 100) + "%",
      b: Math.round(Vr(this._b, 255) * 100) + "%",
      a: this._a
    };
  },
  toPercentageRgbString: function() {
    return this._a == 1 ? "rgb(" + Math.round(Vr(this._r, 255) * 100) + "%, " + Math.round(Vr(this._g, 255) * 100) + "%, " + Math.round(Vr(this._b, 255) * 100) + "%)" : "rgba(" + Math.round(Vr(this._r, 255) * 100) + "%, " + Math.round(Vr(this._g, 255) * 100) + "%, " + Math.round(Vr(this._b, 255) * 100) + "%, " + this._roundA + ")";
  },
  toName: function() {
    return this._a === 0 ? "transparent" : this._a < 1 ? !1 : PMe[X$(this._r, this._g, this._b, !0)] || !1;
  },
  toFilter: function(e) {
    var n = "#" + Y$(this._r, this._g, this._b, this._a), r = n, i = this._gradientType ? "GradientType = 1, " : "";
    if (e) {
      var o = Lt(e);
      r = "#" + Y$(o._r, o._g, o._b, o._a);
    }
    return "progid:DXImageTransform.Microsoft.gradient(" + i + "startColorstr=" + n + ",endColorstr=" + r + ")";
  },
  toString: function(e) {
    var n = !!e;
    e = e || this._format;
    var r = !1, i = this._a < 1 && this._a >= 0, o = !n && i && (e === "hex" || e === "hex6" || e === "hex3" || e === "hex4" || e === "hex8" || e === "name");
    return o ? e === "name" && this._a === 0 ? this.toName() : this.toRgbString() : (e === "rgb" && (r = this.toRgbString()), e === "prgb" && (r = this.toPercentageRgbString()), (e === "hex" || e === "hex6") && (r = this.toHexString()), e === "hex3" && (r = this.toHexString(!0)), e === "hex4" && (r = this.toHex8String(!0)), e === "hex8" && (r = this.toHex8String()), e === "name" && (r = this.toName()), e === "hsl" && (r = this.toHslString()), e === "hsv" && (r = this.toHsvString()), r || this.toHexString());
  },
  clone: function() {
    return Lt(this.toString());
  },
  _applyModification: function(e, n) {
    var r = e.apply(null, [this].concat([].slice.call(n)));
    return this._r = r._r, this._g = r._g, this._b = r._b, this.setAlpha(r._a), this;
  },
  lighten: function() {
    return this._applyModification(wMe, arguments);
  },
  brighten: function() {
    return this._applyModification(EMe, arguments);
  },
  darken: function() {
    return this._applyModification(SMe, arguments);
  },
  desaturate: function() {
    return this._applyModification(yMe, arguments);
  },
  saturate: function() {
    return this._applyModification(xMe, arguments);
  },
  greyscale: function() {
    return this._applyModification(CMe, arguments);
  },
  spin: function() {
    return this._applyModification(IMe, arguments);
  },
  _applyCombination: function(e, n) {
    return e.apply(null, [this].concat([].slice.call(n)));
  },
  analogous: function() {
    return this._applyCombination(TMe, arguments);
  },
  complement: function() {
    return this._applyCombination(_Me, arguments);
  },
  monochromatic: function() {
    return this._applyCombination(OMe, arguments);
  },
  splitcomplement: function() {
    return this._applyCombination(AMe, arguments);
  },
  // Disabled until https://github.com/bgrins/TinyColor/issues/254
  // polyad: function (number) {
  //   return this._applyCombination(polyad, [number]);
  // },
  triad: function() {
    return this._applyCombination(Z$, [3]);
  },
  tetrad: function() {
    return this._applyCombination(Z$, [4]);
  }
};
Lt.fromRatio = function(t, e) {
  if (Dx(t) == "object") {
    var n = {};
    for (var r in t)
      t.hasOwnProperty(r) && (r === "a" ? n[r] = t[r] : n[r] = e0(t[r]));
    t = n;
  }
  return Lt(t, e);
};
function pMe(t) {
  var e = {
    r: 0,
    g: 0,
    b: 0
  }, n = 1, r = null, i = null, o = null, a = !1, s = !1;
  return typeof t == "string" && (t = $Me(t)), Dx(t) == "object" && (Mu(t.r) && Mu(t.g) && Mu(t.b) ? (e = gMe(t.r, t.g, t.b), a = !0, s = String(t.r).substr(-1) === "%" ? "prgb" : "rgb") : Mu(t.h) && Mu(t.s) && Mu(t.v) ? (r = e0(t.s), i = e0(t.v), e = vMe(t.h, r, i), a = !0, s = "hsv") : Mu(t.h) && Mu(t.s) && Mu(t.l) && (r = e0(t.s), o = e0(t.l), e = mMe(t.h, r, o), a = !0, s = "hsl"), t.hasOwnProperty("a") && (n = t.a)), n = vY(n), {
    ok: a,
    format: t.format || s,
    r: Math.min(255, Math.max(e.r, 0)),
    g: Math.min(255, Math.max(e.g, 0)),
    b: Math.min(255, Math.max(e.b, 0)),
    a: n
  };
}
function gMe(t, e, n) {
  return {
    r: Vr(t, 255) * 255,
    g: Vr(e, 255) * 255,
    b: Vr(n, 255) * 255
  };
}
function G$(t, e, n) {
  t = Vr(t, 255), e = Vr(e, 255), n = Vr(n, 255);
  var r = Math.max(t, e, n), i = Math.min(t, e, n), o, a, s = (r + i) / 2;
  if (r == i)
    o = a = 0;
  else {
    var u = r - i;
    switch (a = s > 0.5 ? u / (2 - r - i) : u / (r + i), r) {
      case t:
        o = (e - n) / u + (e < n ? 6 : 0);
        break;
      case e:
        o = (n - t) / u + 2;
        break;
      case n:
        o = (t - e) / u + 4;
        break;
    }
    o /= 6;
  }
  return {
    h: o,
    s: a,
    l: s
  };
}
function mMe(t, e, n) {
  var r, i, o;
  t = Vr(t, 360), e = Vr(e, 100), n = Vr(n, 100);
  function a(l, c, d) {
    return d < 0 && (d += 1), d > 1 && (d -= 1), d < 1 / 6 ? l + (c - l) * 6 * d : d < 1 / 2 ? c : d < 2 / 3 ? l + (c - l) * (2 / 3 - d) * 6 : l;
  }
  if (e === 0)
    r = i = o = n;
  else {
    var s = n < 0.5 ? n * (1 + e) : n + e - n * e, u = 2 * n - s;
    r = a(u, s, t + 1 / 3), i = a(u, s, t), o = a(u, s, t - 1 / 3);
  }
  return {
    r: r * 255,
    g: i * 255,
    b: o * 255
  };
}
function U$(t, e, n) {
  t = Vr(t, 255), e = Vr(e, 255), n = Vr(n, 255);
  var r = Math.max(t, e, n), i = Math.min(t, e, n), o, a, s = r, u = r - i;
  if (a = r === 0 ? 0 : u / r, r == i)
    o = 0;
  else {
    switch (r) {
      case t:
        o = (e - n) / u + (e < n ? 6 : 0);
        break;
      case e:
        o = (n - t) / u + 2;
        break;
      case n:
        o = (t - e) / u + 4;
        break;
    }
    o /= 6;
  }
  return {
    h: o,
    s: a,
    v: s
  };
}
function vMe(t, e, n) {
  t = Vr(t, 360) * 6, e = Vr(e, 100), n = Vr(n, 100);
  var r = Math.floor(t), i = t - r, o = n * (1 - e), a = n * (1 - i * e), s = n * (1 - (1 - i) * e), u = r % 6, l = [n, a, o, o, s, n][u], c = [s, n, n, a, o, o][u], d = [o, o, s, n, n, a][u];
  return {
    r: l * 255,
    g: c * 255,
    b: d * 255
  };
}
function X$(t, e, n, r) {
  var i = [Ts(Math.round(t).toString(16)), Ts(Math.round(e).toString(16)), Ts(Math.round(n).toString(16))];
  return r && i[0].charAt(0) == i[0].charAt(1) && i[1].charAt(0) == i[1].charAt(1) && i[2].charAt(0) == i[2].charAt(1) ? i[0].charAt(0) + i[1].charAt(0) + i[2].charAt(0) : i.join("");
}
function bMe(t, e, n, r, i) {
  var o = [Ts(Math.round(t).toString(16)), Ts(Math.round(e).toString(16)), Ts(Math.round(n).toString(16)), Ts(bY(r))];
  return i && o[0].charAt(0) == o[0].charAt(1) && o[1].charAt(0) == o[1].charAt(1) && o[2].charAt(0) == o[2].charAt(1) && o[3].charAt(0) == o[3].charAt(1) ? o[0].charAt(0) + o[1].charAt(0) + o[2].charAt(0) + o[3].charAt(0) : o.join("");
}
function Y$(t, e, n, r) {
  var i = [Ts(bY(r)), Ts(Math.round(t).toString(16)), Ts(Math.round(e).toString(16)), Ts(Math.round(n).toString(16))];
  return i.join("");
}
Lt.equals = function(t, e) {
  return !t || !e ? !1 : Lt(t).toRgbString() == Lt(e).toRgbString();
};
Lt.random = function() {
  return Lt.fromRatio({
    r: Math.random(),
    g: Math.random(),
    b: Math.random()
  });
};
function yMe(t, e) {
  e = e === 0 ? 0 : e || 10;
  var n = Lt(t).toHsl();
  return n.s -= e / 100, n.s = YC(n.s), Lt(n);
}
function xMe(t, e) {
  e = e === 0 ? 0 : e || 10;
  var n = Lt(t).toHsl();
  return n.s += e / 100, n.s = YC(n.s), Lt(n);
}
function CMe(t) {
  return Lt(t).desaturate(100);
}
function wMe(t, e) {
  e = e === 0 ? 0 : e || 10;
  var n = Lt(t).toHsl();
  return n.l += e / 100, n.l = YC(n.l), Lt(n);
}
function EMe(t, e) {
  e = e === 0 ? 0 : e || 10;
  var n = Lt(t).toRgb();
  return n.r = Math.max(0, Math.min(255, n.r - Math.round(255 * -(e / 100)))), n.g = Math.max(0, Math.min(255, n.g - Math.round(255 * -(e / 100)))), n.b = Math.max(0, Math.min(255, n.b - Math.round(255 * -(e / 100)))), Lt(n);
}
function SMe(t, e) {
  e = e === 0 ? 0 : e || 10;
  var n = Lt(t).toHsl();
  return n.l -= e / 100, n.l = YC(n.l), Lt(n);
}
function IMe(t, e) {
  var n = Lt(t).toHsl(), r = (n.h + e) % 360;
  return n.h = r < 0 ? 360 + r : r, Lt(n);
}
function _Me(t) {
  var e = Lt(t).toHsl();
  return e.h = (e.h + 180) % 360, Lt(e);
}
function Z$(t, e) {
  if (isNaN(e) || e <= 0)
    throw new Error("Argument to polyad must be a positive number");
  for (var n = Lt(t).toHsl(), r = [Lt(t)], i = 360 / e, o = 1; o < e; o++)
    r.push(Lt({
      h: (n.h + o * i) % 360,
      s: n.s,
      l: n.l
    }));
  return r;
}
function AMe(t) {
  var e = Lt(t).toHsl(), n = e.h;
  return [Lt(t), Lt({
    h: (n + 72) % 360,
    s: e.s,
    l: e.l
  }), Lt({
    h: (n + 216) % 360,
    s: e.s,
    l: e.l
  })];
}
function TMe(t, e, n) {
  e = e || 6, n = n || 30;
  var r = Lt(t).toHsl(), i = 360 / n, o = [Lt(t)];
  for (r.h = (r.h - (i * e >> 1) + 720) % 360; --e; )
    r.h = (r.h + i) % 360, o.push(Lt(r));
  return o;
}
function OMe(t, e) {
  e = e || 6;
  for (var n = Lt(t).toHsv(), r = n.h, i = n.s, o = n.v, a = [], s = 1 / e; e--; )
    a.push(Lt({
      h: r,
      s: i,
      v: o
    })), o = (o + s) % 1;
  return a;
}
Lt.mix = function(t, e, n) {
  n = n === 0 ? 0 : n || 50;
  var r = Lt(t).toRgb(), i = Lt(e).toRgb(), o = n / 100, a = {
    r: (i.r - r.r) * o + r.r,
    g: (i.g - r.g) * o + r.g,
    b: (i.b - r.b) * o + r.b,
    a: (i.a - r.a) * o + r.a
  };
  return Lt(a);
};
Lt.readability = function(t, e) {
  var n = Lt(t), r = Lt(e);
  return (Math.max(n.getLuminance(), r.getLuminance()) + 0.05) / (Math.min(n.getLuminance(), r.getLuminance()) + 0.05);
};
Lt.isReadable = function(t, e, n) {
  var r = Lt.readability(t, e), i, o;
  switch (o = !1, i = DMe(n), i.level + i.size) {
    case "AAsmall":
    case "AAAlarge":
      o = r >= 4.5;
      break;
    case "AAlarge":
      o = r >= 3;
      break;
    case "AAAsmall":
      o = r >= 7;
      break;
  }
  return o;
};
Lt.mostReadable = function(t, e, n) {
  var r = null, i = 0, o, a, s, u;
  n = n || {}, a = n.includeFallbackColors, s = n.level, u = n.size;
  for (var l = 0; l < e.length; l++)
    o = Lt.readability(t, e[l]), o > i && (i = o, r = Lt(e[l]));
  return Lt.isReadable(t, r, {
    level: s,
    size: u
  }) || !a ? r : (n.includeFallbackColors = !1, Lt.mostReadable(t, ["#fff", "#000"], n));
};
var I_ = Lt.names = {
  aliceblue: "f0f8ff",
  antiquewhite: "faebd7",
  aqua: "0ff",
  aquamarine: "7fffd4",
  azure: "f0ffff",
  beige: "f5f5dc",
  bisque: "ffe4c4",
  black: "000",
  blanchedalmond: "ffebcd",
  blue: "00f",
  blueviolet: "8a2be2",
  brown: "a52a2a",
  burlywood: "deb887",
  burntsienna: "ea7e5d",
  cadetblue: "5f9ea0",
  chartreuse: "7fff00",
  chocolate: "d2691e",
  coral: "ff7f50",
  cornflowerblue: "6495ed",
  cornsilk: "fff8dc",
  crimson: "dc143c",
  cyan: "0ff",
  darkblue: "00008b",
  darkcyan: "008b8b",
  darkgoldenrod: "b8860b",
  darkgray: "a9a9a9",
  darkgreen: "006400",
  darkgrey: "a9a9a9",
  darkkhaki: "bdb76b",
  darkmagenta: "8b008b",
  darkolivegreen: "556b2f",
  darkorange: "ff8c00",
  darkorchid: "9932cc",
  darkred: "8b0000",
  darksalmon: "e9967a",
  darkseagreen: "8fbc8f",
  darkslateblue: "483d8b",
  darkslategray: "2f4f4f",
  darkslategrey: "2f4f4f",
  darkturquoise: "00ced1",
  darkviolet: "9400d3",
  deeppink: "ff1493",
  deepskyblue: "00bfff",
  dimgray: "696969",
  dimgrey: "696969",
  dodgerblue: "1e90ff",
  firebrick: "b22222",
  floralwhite: "fffaf0",
  forestgreen: "228b22",
  fuchsia: "f0f",
  gainsboro: "dcdcdc",
  ghostwhite: "f8f8ff",
  gold: "ffd700",
  goldenrod: "daa520",
  gray: "808080",
  green: "008000",
  greenyellow: "adff2f",
  grey: "808080",
  honeydew: "f0fff0",
  hotpink: "ff69b4",
  indianred: "cd5c5c",
  indigo: "4b0082",
  ivory: "fffff0",
  khaki: "f0e68c",
  lavender: "e6e6fa",
  lavenderblush: "fff0f5",
  lawngreen: "7cfc00",
  lemonchiffon: "fffacd",
  lightblue: "add8e6",
  lightcoral: "f08080",
  lightcyan: "e0ffff",
  lightgoldenrodyellow: "fafad2",
  lightgray: "d3d3d3",
  lightgreen: "90ee90",
  lightgrey: "d3d3d3",
  lightpink: "ffb6c1",
  lightsalmon: "ffa07a",
  lightseagreen: "20b2aa",
  lightskyblue: "87cefa",
  lightslategray: "789",
  lightslategrey: "789",
  lightsteelblue: "b0c4de",
  lightyellow: "ffffe0",
  lime: "0f0",
  limegreen: "32cd32",
  linen: "faf0e6",
  magenta: "f0f",
  maroon: "800000",
  mediumaquamarine: "66cdaa",
  mediumblue: "0000cd",
  mediumorchid: "ba55d3",
  mediumpurple: "9370db",
  mediumseagreen: "3cb371",
  mediumslateblue: "7b68ee",
  mediumspringgreen: "00fa9a",
  mediumturquoise: "48d1cc",
  mediumvioletred: "c71585",
  midnightblue: "191970",
  mintcream: "f5fffa",
  mistyrose: "ffe4e1",
  moccasin: "ffe4b5",
  navajowhite: "ffdead",
  navy: "000080",
  oldlace: "fdf5e6",
  olive: "808000",
  olivedrab: "6b8e23",
  orange: "ffa500",
  orangered: "ff4500",
  orchid: "da70d6",
  palegoldenrod: "eee8aa",
  palegreen: "98fb98",
  paleturquoise: "afeeee",
  palevioletred: "db7093",
  papayawhip: "ffefd5",
  peachpuff: "ffdab9",
  peru: "cd853f",
  pink: "ffc0cb",
  plum: "dda0dd",
  powderblue: "b0e0e6",
  purple: "800080",
  rebeccapurple: "663399",
  red: "f00",
  rosybrown: "bc8f8f",
  royalblue: "4169e1",
  saddlebrown: "8b4513",
  salmon: "fa8072",
  sandybrown: "f4a460",
  seagreen: "2e8b57",
  seashell: "fff5ee",
  sienna: "a0522d",
  silver: "c0c0c0",
  skyblue: "87ceeb",
  slateblue: "6a5acd",
  slategray: "708090",
  slategrey: "708090",
  snow: "fffafa",
  springgreen: "00ff7f",
  steelblue: "4682b4",
  tan: "d2b48c",
  teal: "008080",
  thistle: "d8bfd8",
  tomato: "ff6347",
  turquoise: "40e0d0",
  violet: "ee82ee",
  wheat: "f5deb3",
  white: "fff",
  whitesmoke: "f5f5f5",
  yellow: "ff0",
  yellowgreen: "9acd32"
}, PMe = Lt.hexNames = NMe(I_);
function NMe(t) {
  var e = {};
  for (var n in t)
    t.hasOwnProperty(n) && (e[t[n]] = n);
  return e;
}
function vY(t) {
  return t = parseFloat(t), (isNaN(t) || t < 0 || t > 1) && (t = 1), t;
}
function Vr(t, e) {
  kMe(t) && (t = "100%");
  var n = RMe(t);
  return t = Math.min(e, Math.max(0, parseFloat(t))), n && (t = parseInt(t * e, 10) / 100), Math.abs(t - e) < 1e-6 ? 1 : t % e / parseFloat(e);
}
function YC(t) {
  return Math.min(1, Math.max(0, t));
}
function Qo(t) {
  return parseInt(t, 16);
}
function kMe(t) {
  return typeof t == "string" && t.indexOf(".") != -1 && parseFloat(t) === 1;
}
function RMe(t) {
  return typeof t == "string" && t.indexOf("%") != -1;
}
function Ts(t) {
  return t.length == 1 ? "0" + t : "" + t;
}
function e0(t) {
  return t <= 1 && (t = t * 100 + "%"), t;
}
function bY(t) {
  return Math.round(parseFloat(t) * 255).toString(16);
}
function J$(t) {
  return Qo(t) / 255;
}
var cs = function() {
  var t = "[-\\+]?\\d+%?", e = "[-\\+]?\\d*\\.\\d+%?", n = "(?:" + e + ")|(?:" + t + ")", r = "[\\s|\\(]+(" + n + ")[,|\\s]+(" + n + ")[,|\\s]+(" + n + ")\\s*\\)?", i = "[\\s|\\(]+(" + n + ")[,|\\s]+(" + n + ")[,|\\s]+(" + n + ")[,|\\s]+(" + n + ")\\s*\\)?";
  return {
    CSS_UNIT: new RegExp(n),
    rgb: new RegExp("rgb" + r),
    rgba: new RegExp("rgba" + i),
    hsl: new RegExp("hsl" + r),
    hsla: new RegExp("hsla" + i),
    hsv: new RegExp("hsv" + r),
    hsva: new RegExp("hsva" + i),
    hex3: /^#?([0-9a-fA-F]{1})([0-9a-fA-F]{1})([0-9a-fA-F]{1})$/,
    hex6: /^#?([0-9a-fA-F]{2})([0-9a-fA-F]{2})([0-9a-fA-F]{2})$/,
    hex4: /^#?([0-9a-fA-F]{1})([0-9a-fA-F]{1})([0-9a-fA-F]{1})([0-9a-fA-F]{1})$/,
    hex8: /^#?([0-9a-fA-F]{2})([0-9a-fA-F]{2})([0-9a-fA-F]{2})([0-9a-fA-F]{2})$/
  };
}();
function Mu(t) {
  return !!cs.CSS_UNIT.exec(t);
}
function $Me(t) {
  t = t.replace(fMe, "").replace(hMe, "").toLowerCase();
  var e = !1;
  if (I_[t])
    t = I_[t], e = !0;
  else if (t == "transparent")
    return {
      r: 0,
      g: 0,
      b: 0,
      a: 0,
      format: "name"
    };
  var n;
  return (n = cs.rgb.exec(t)) ? {
    r: n[1],
    g: n[2],
    b: n[3]
  } : (n = cs.rgba.exec(t)) ? {
    r: n[1],
    g: n[2],
    b: n[3],
    a: n[4]
  } : (n = cs.hsl.exec(t)) ? {
    h: n[1],
    s: n[2],
    l: n[3]
  } : (n = cs.hsla.exec(t)) ? {
    h: n[1],
    s: n[2],
    l: n[3],
    a: n[4]
  } : (n = cs.hsv.exec(t)) ? {
    h: n[1],
    s: n[2],
    v: n[3]
  } : (n = cs.hsva.exec(t)) ? {
    h: n[1],
    s: n[2],
    v: n[3],
    a: n[4]
  } : (n = cs.hex8.exec(t)) ? {
    r: Qo(n[1]),
    g: Qo(n[2]),
    b: Qo(n[3]),
    a: J$(n[4]),
    format: e ? "name" : "hex8"
  } : (n = cs.hex6.exec(t)) ? {
    r: Qo(n[1]),
    g: Qo(n[2]),
    b: Qo(n[3]),
    format: e ? "name" : "hex"
  } : (n = cs.hex4.exec(t)) ? {
    r: Qo(n[1] + "" + n[1]),
    g: Qo(n[2] + "" + n[2]),
    b: Qo(n[3] + "" + n[3]),
    a: J$(n[4] + "" + n[4]),
    format: e ? "name" : "hex8"
  } : (n = cs.hex3.exec(t)) ? {
    r: Qo(n[1] + "" + n[1]),
    g: Qo(n[2] + "" + n[2]),
    b: Qo(n[3] + "" + n[3]),
    format: e ? "name" : "hex"
  } : !1;
}
function DMe(t) {
  var e, n;
  return t = t || {
    level: "AA",
    size: "small"
  }, e = (t.level || "AA").toUpperCase(), n = (t.size || "small").toLowerCase(), e !== "AA" && e !== "AAA" && (e = "AA"), n !== "small" && n !== "large" && (n = "small"), {
    level: e,
    size: n
  };
}
var K$ = function(e) {
  var n = ["r", "g", "b", "a", "h", "s", "l", "v"], r = 0, i = 0;
  return dMe(n, function(o) {
    if (e[o] && (r += 1, isNaN(e[o]) || (i += 1), o === "s" || o === "l")) {
      var a = /^\d+%$/;
      a.test(e[o]) && (i += 1);
    }
  }), r === i ? e : !1;
}, t0 = function(e, n) {
  var r = e.hex ? Lt(e.hex) : Lt(e), i = r.toHsl(), o = r.toHsv(), a = r.toRgb(), s = r.toHex();
  i.s === 0 && (i.h = n || 0, o.h = n || 0);
  var u = s === "000000" && a.a === 0;
  return {
    hsl: i,
    hex: u ? "transparent" : "#" + s,
    rgb: a,
    hsv: o,
    oldHue: e.h || n || i.h,
    source: e.source
  };
}, Oc = function(e) {
  if (e === "transparent")
    return !0;
  var n = String(e).charAt(0) === "#" ? 1 : 0;
  return e.length !== 4 + n && e.length < 7 + n && Lt(e).isValid();
}, T9 = function(e) {
  if (!e)
    return "#fff";
  var n = t0(e);
  if (n.hex === "transparent")
    return "rgba(0,0,0,0.4)";
  var r = (n.rgb.r * 299 + n.rgb.g * 587 + n.rgb.b * 114) / 1e3;
  return r >= 128 ? "#000" : "#fff";
}, S3 = function(e, n) {
  var r = e.replace("°", "");
  return Lt(n + " (" + r + ")")._ok;
}, Rg = Object.assign || function(t) {
  for (var e = 1; e < arguments.length; e++) {
    var n = arguments[e];
    for (var r in n)
      Object.prototype.hasOwnProperty.call(n, r) && (t[r] = n[r]);
  }
  return t;
}, MMe = /* @__PURE__ */ function() {
  function t(e, n) {
    for (var r = 0; r < n.length; r++) {
      var i = n[r];
      i.enumerable = i.enumerable || !1, i.configurable = !0, "value" in i && (i.writable = !0), Object.defineProperty(e, i.key, i);
    }
  }
  return function(e, n, r) {
    return n && t(e.prototype, n), r && t(e, r), e;
  };
}();
function FMe(t, e) {
  if (!(t instanceof e))
    throw new TypeError("Cannot call a class as a function");
}
function LMe(t, e) {
  if (!t)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e && (typeof e == "object" || typeof e == "function") ? e : t;
}
function VMe(t, e) {
  if (typeof e != "function" && e !== null)
    throw new TypeError("Super expression must either be null or a function, not " + typeof e);
  t.prototype = Object.create(e && e.prototype, { constructor: { value: t, enumerable: !1, writable: !0, configurable: !0 } }), e && (Object.setPrototypeOf ? Object.setPrototypeOf(t, e) : t.__proto__ = e);
}
var Lo = function(e) {
  var n = function(r) {
    VMe(i, r);
    function i(o) {
      FMe(this, i);
      var a = LMe(this, (i.__proto__ || Object.getPrototypeOf(i)).call(this));
      return a.handleChange = function(s, u) {
        var l = K$(s);
        if (l) {
          var c = t0(s, s.h || a.state.oldHue);
          a.setState(c), a.props.onChangeComplete && a.debounce(a.props.onChangeComplete, c, u), a.props.onChange && a.props.onChange(c, u);
        }
      }, a.handleSwatchHover = function(s, u) {
        var l = K$(s);
        if (l) {
          var c = t0(s, s.h || a.state.oldHue);
          a.props.onSwatchHover && a.props.onSwatchHover(c, u);
        }
      }, a.state = Rg({}, t0(o.color, 0)), a.debounce = gY(function(s, u, l) {
        s(u, l);
      }, 100), a;
    }
    return MMe(i, [{
      key: "render",
      value: function() {
        var a = {};
        return this.props.onSwatchHover && (a.onSwatchHover = this.handleSwatchHover), O.createElement(e, Rg({}, this.props, this.state, {
          onChange: this.handleChange
        }, a));
      }
    }], [{
      key: "getDerivedStateFromProps",
      value: function(a, s) {
        return Rg({}, t0(a.color, s.oldHue));
      }
    }]), i;
  }(Pm || Do);
  return n.propTypes = Rg({}, e.propTypes), n.defaultProps = Rg({}, e.defaultProps, {
    color: {
      h: 250,
      s: 0.5,
      l: 0.2,
      a: 1
    }
  }), n;
}, BMe = Object.assign || function(t) {
  for (var e = 1; e < arguments.length; e++) {
    var n = arguments[e];
    for (var r in n)
      Object.prototype.hasOwnProperty.call(n, r) && (t[r] = n[r]);
  }
  return t;
}, HMe = /* @__PURE__ */ function() {
  function t(e, n) {
    for (var r = 0; r < n.length; r++) {
      var i = n[r];
      i.enumerable = i.enumerable || !1, i.configurable = !0, "value" in i && (i.writable = !0), Object.defineProperty(e, i.key, i);
    }
  }
  return function(e, n, r) {
    return n && t(e.prototype, n), r && t(e, r), e;
  };
}();
function WMe(t, e) {
  if (!(t instanceof e))
    throw new TypeError("Cannot call a class as a function");
}
function q$(t, e) {
  if (!t)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e && (typeof e == "object" || typeof e == "function") ? e : t;
}
function jMe(t, e) {
  if (typeof e != "function" && e !== null)
    throw new TypeError("Super expression must either be null or a function, not " + typeof e);
  t.prototype = Object.create(e && e.prototype, { constructor: { value: t, enumerable: !1, writable: !0, configurable: !0 } }), e && (Object.setPrototypeOf ? Object.setPrototypeOf(t, e) : t.__proto__ = e);
}
var zMe = function(e) {
  var n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "span";
  return function(r) {
    jMe(i, r);
    function i() {
      var o, a, s, u;
      WMe(this, i);
      for (var l = arguments.length, c = Array(l), d = 0; d < l; d++)
        c[d] = arguments[d];
      return u = (a = (s = q$(this, (o = i.__proto__ || Object.getPrototypeOf(i)).call.apply(o, [this].concat(c))), s), s.state = { focus: !1 }, s.handleFocus = function() {
        return s.setState({ focus: !0 });
      }, s.handleBlur = function() {
        return s.setState({ focus: !1 });
      }, a), q$(s, u);
    }
    return HMe(i, [{
      key: "render",
      value: function() {
        return O.createElement(
          n,
          { onFocus: this.handleFocus, onBlur: this.handleBlur },
          O.createElement(e, BMe({}, this.props, this.state))
        );
      }
    }]), i;
  }(O.Component);
}, Q$ = Object.assign || function(t) {
  for (var e = 1; e < arguments.length; e++) {
    var n = arguments[e];
    for (var r in n)
      Object.prototype.hasOwnProperty.call(n, r) && (t[r] = n[r]);
  }
  return t;
}, GMe = 13, UMe = function(e) {
  var n = e.color, r = e.style, i = e.onClick, o = i === void 0 ? function() {
  } : i, a = e.onHover, s = e.title, u = s === void 0 ? n : s, l = e.children, c = e.focus, d = e.focusStyle, f = d === void 0 ? {} : d, h = n === "transparent", p = un({
    default: {
      swatch: Q$({
        background: n,
        height: "100%",
        width: "100%",
        cursor: "pointer",
        position: "relative",
        outline: "none"
      }, r, c ? f : {})
    }
  }), v = function(S) {
    return o(n, S);
  }, m = function(S) {
    return S.keyCode === GMe && o(n, S);
  }, b = function(S) {
    return a(n, S);
  }, y = {};
  return a && (y.onMouseOver = b), O.createElement(
    "div",
    Q$({
      style: p.swatch,
      onClick: v,
      title: u,
      tabIndex: 0,
      onKeyDown: m
    }, y),
    l,
    h && O.createElement($p, {
      borderRadius: p.swatch.borderRadius,
      boxShadow: "inset 0 0 0 1px rgba(0,0,0,0.1)"
    })
  );
};
const Qd = zMe(UMe);
var XMe = function(e) {
  var n = e.direction, r = un({
    default: {
      picker: {
        width: "18px",
        height: "18px",
        borderRadius: "50%",
        transform: "translate(-9px, -1px)",
        backgroundColor: "rgb(248, 248, 248)",
        boxShadow: "0 1px 4px 0 rgba(0, 0, 0, 0.37)"
      }
    },
    vertical: {
      picker: {
        transform: "translate(-3px, -9px)"
      }
    }
  }, { vertical: n === "vertical" });
  return O.createElement("div", { style: r.picker });
}, YMe = Object.assign || function(t) {
  for (var e = 1; e < arguments.length; e++) {
    var n = arguments[e];
    for (var r in n)
      Object.prototype.hasOwnProperty.call(n, r) && (t[r] = n[r]);
  }
  return t;
}, yY = function(e) {
  var n = e.rgb, r = e.hsl, i = e.width, o = e.height, a = e.onChange, s = e.direction, u = e.style, l = e.renderers, c = e.pointer, d = e.className, f = d === void 0 ? "" : d, h = un({
    default: {
      picker: {
        position: "relative",
        width: i,
        height: o
      },
      alpha: {
        radius: "2px",
        style: u
      }
    }
  });
  return O.createElement(
    "div",
    { style: h.picker, className: "alpha-picker " + f },
    O.createElement(y9, YMe({}, h.alpha, {
      rgb: n,
      hsl: r,
      pointer: c,
      renderers: l,
      onChange: a,
      direction: s
    }))
  );
};
yY.defaultProps = {
  width: "316px",
  height: "16px",
  direction: "horizontal",
  pointer: XMe
};
Lo(yY);
function xY(t, e) {
  for (var n = -1, r = t == null ? 0 : t.length, i = Array(r); ++n < r; )
    i[n] = e(t[n], n, t);
  return i;
}
var ZMe = "__lodash_hash_undefined__";
function JMe(t) {
  return this.__data__.set(t, ZMe), this;
}
function KMe(t) {
  return this.__data__.has(t);
}
function Mx(t) {
  var e = -1, n = t == null ? 0 : t.length;
  for (this.__data__ = new fl(); ++e < n; )
    this.add(t[e]);
}
Mx.prototype.add = Mx.prototype.push = JMe;
Mx.prototype.has = KMe;
function qMe(t, e) {
  for (var n = -1, r = t == null ? 0 : t.length; ++n < r; )
    if (e(t[n], n, t))
      return !0;
  return !1;
}
function QMe(t, e) {
  return t.has(e);
}
var eFe = 1, tFe = 2;
function CY(t, e, n, r, i, o) {
  var a = n & eFe, s = t.length, u = e.length;
  if (s != u && !(a && u > s))
    return !1;
  var l = o.get(t), c = o.get(e);
  if (l && c)
    return l == e && c == t;
  var d = -1, f = !0, h = n & tFe ? new Mx() : void 0;
  for (o.set(t, e), o.set(e, t); ++d < s; ) {
    var p = t[d], v = e[d];
    if (r)
      var m = a ? r(v, p, d, e, t, o) : r(p, v, d, t, e, o);
    if (m !== void 0) {
      if (m)
        continue;
      f = !1;
      break;
    }
    if (h) {
      if (!qMe(e, function(b, y) {
        if (!QMe(h, y) && (p === b || i(p, b, n, r, o)))
          return h.push(y);
      })) {
        f = !1;
        break;
      }
    } else if (!(p === v || i(p, v, n, r, o))) {
      f = !1;
      break;
    }
  }
  return o.delete(t), o.delete(e), f;
}
function nFe(t) {
  var e = -1, n = Array(t.size);
  return t.forEach(function(r, i) {
    n[++e] = [i, r];
  }), n;
}
function rFe(t) {
  var e = -1, n = Array(t.size);
  return t.forEach(function(r) {
    n[++e] = r;
  }), n;
}
var iFe = 1, oFe = 2, aFe = "[object Boolean]", sFe = "[object Date]", uFe = "[object Error]", lFe = "[object Map]", cFe = "[object Number]", dFe = "[object RegExp]", fFe = "[object Set]", hFe = "[object String]", pFe = "[object Symbol]", gFe = "[object ArrayBuffer]", mFe = "[object DataView]", eD = dc ? dc.prototype : void 0, I3 = eD ? eD.valueOf : void 0;
function vFe(t, e, n, r, i, o, a) {
  switch (n) {
    case mFe:
      if (t.byteLength != e.byteLength || t.byteOffset != e.byteOffset)
        return !1;
      t = t.buffer, e = e.buffer;
    case gFe:
      return !(t.byteLength != e.byteLength || !o(new kx(t), new kx(e)));
    case aFe:
    case sFe:
    case cFe:
      return ev(+t, +e);
    case uFe:
      return t.name == e.name && t.message == e.message;
    case dFe:
    case hFe:
      return t == e + "";
    case lFe:
      var s = nFe;
    case fFe:
      var u = r & iFe;
      if (s || (s = rFe), t.size != e.size && !u)
        return !1;
      var l = a.get(t);
      if (l)
        return l == e;
      r |= oFe, a.set(t, e);
      var c = CY(s(t), s(e), r, i, o, a);
      return a.delete(t), c;
    case pFe:
      if (I3)
        return I3.call(t) == I3.call(e);
  }
  return !1;
}
function bFe(t, e) {
  for (var n = -1, r = e.length, i = t.length; ++n < r; )
    t[i + n] = e[n];
  return t;
}
function yFe(t, e, n) {
  var r = e(t);
  return ba(t) ? r : bFe(r, n(t));
}
function xFe(t, e) {
  for (var n = -1, r = t == null ? 0 : t.length, i = 0, o = []; ++n < r; ) {
    var a = t[n];
    e(a, n, t) && (o[i++] = a);
  }
  return o;
}
function CFe() {
  return [];
}
var wFe = Object.prototype, EFe = wFe.propertyIsEnumerable, tD = Object.getOwnPropertySymbols, SFe = tD ? function(t) {
  return t == null ? [] : (t = Object(t), xFe(tD(t), function(e) {
    return EFe.call(t, e);
  }));
} : CFe;
const IFe = SFe;
function nD(t) {
  return yFe(t, A9, IFe);
}
var _Fe = 1, AFe = Object.prototype, TFe = AFe.hasOwnProperty;
function OFe(t, e, n, r, i, o) {
  var a = n & _Fe, s = nD(t), u = s.length, l = nD(e), c = l.length;
  if (u != c && !a)
    return !1;
  for (var d = u; d--; ) {
    var f = s[d];
    if (!(a ? f in e : TFe.call(e, f)))
      return !1;
  }
  var h = o.get(t), p = o.get(e);
  if (h && p)
    return h == e && p == t;
  var v = !0;
  o.set(t, e), o.set(e, t);
  for (var m = a; ++d < u; ) {
    f = s[d];
    var b = t[f], y = e[f];
    if (r)
      var w = a ? r(y, b, f, e, t, o) : r(b, y, f, t, e, o);
    if (!(w === void 0 ? b === y || i(b, y, n, r, o) : w)) {
      v = !1;
      break;
    }
    m || (m = f == "constructor");
  }
  if (v && !m) {
    var S = t.constructor, E = e.constructor;
    S != E && "constructor" in t && "constructor" in e && !(typeof S == "function" && S instanceof S && typeof E == "function" && E instanceof E) && (v = !1);
  }
  return o.delete(t), o.delete(e), v;
}
var PFe = qd(Ms, "DataView");
const __ = PFe;
var NFe = qd(Ms, "Promise");
const A_ = NFe;
var kFe = qd(Ms, "Set");
const T_ = kFe;
var RFe = qd(Ms, "WeakMap");
const O_ = RFe;
var rD = "[object Map]", $Fe = "[object Object]", iD = "[object Promise]", oD = "[object Set]", aD = "[object WeakMap]", sD = "[object DataView]", DFe = Kd(__), MFe = Kd(J0), FFe = Kd(A_), LFe = Kd(T_), VFe = Kd(O_), rd = Jd;
(__ && rd(new __(new ArrayBuffer(1))) != sD || J0 && rd(new J0()) != rD || A_ && rd(A_.resolve()) != iD || T_ && rd(new T_()) != oD || O_ && rd(new O_()) != aD) && (rd = function(t) {
  var e = Jd(t), n = e == $Fe ? t.constructor : void 0, r = n ? Kd(n) : "";
  if (r)
    switch (r) {
      case DFe:
        return sD;
      case MFe:
        return rD;
      case FFe:
        return iD;
      case LFe:
        return oD;
      case VFe:
        return aD;
    }
  return e;
});
const uD = rd;
var BFe = 1, lD = "[object Arguments]", cD = "[object Array]", cb = "[object Object]", HFe = Object.prototype, dD = HFe.hasOwnProperty;
function WFe(t, e, n, r, i, o) {
  var a = ba(t), s = ba(e), u = a ? cD : uD(t), l = s ? cD : uD(e);
  u = u == lD ? cb : u, l = l == lD ? cb : l;
  var c = u == cb, d = l == cb, f = u == l;
  if (f && $x(t)) {
    if (!$x(e))
      return !1;
    a = !0, c = !1;
  }
  if (f && !c)
    return o || (o = new su()), a || I9(t) ? CY(t, e, n, r, i, o) : vFe(t, e, u, n, r, i, o);
  if (!(n & BFe)) {
    var h = c && dD.call(t, "__wrapped__"), p = d && dD.call(e, "__wrapped__");
    if (h || p) {
      var v = h ? t.value() : t, m = p ? e.value() : e;
      return o || (o = new su()), i(v, m, n, r, o);
    }
  }
  return f ? (o || (o = new su()), OFe(t, e, n, r, i, o)) : !1;
}
function O9(t, e, n, r, i) {
  return t === e ? !0 : t == null || e == null || !fc(t) && !fc(e) ? t !== t && e !== e : WFe(t, e, n, r, O9, i);
}
var jFe = 1, zFe = 2;
function GFe(t, e, n, r) {
  var i = n.length, o = i, a = !r;
  if (t == null)
    return !o;
  for (t = Object(t); i--; ) {
    var s = n[i];
    if (a && s[2] ? s[1] !== t[s[0]] : !(s[0] in t))
      return !1;
  }
  for (; ++i < o; ) {
    s = n[i];
    var u = s[0], l = t[u], c = s[1];
    if (a && s[2]) {
      if (l === void 0 && !(u in t))
        return !1;
    } else {
      var d = new su();
      if (r)
        var f = r(l, c, u, t, e, d);
      if (!(f === void 0 ? O9(c, l, jFe | zFe, r, d) : f))
        return !1;
    }
  }
  return !0;
}
function wY(t) {
  return t === t && !Ya(t);
}
function UFe(t) {
  for (var e = A9(t), n = e.length; n--; ) {
    var r = e[n], i = t[r];
    e[n] = [r, i, wY(i)];
  }
  return e;
}
function EY(t, e) {
  return function(n) {
    return n == null ? !1 : n[t] === e && (e !== void 0 || t in Object(n));
  };
}
function XFe(t) {
  var e = UFe(t);
  return e.length == 1 && e[0][2] ? EY(e[0][0], e[0][1]) : function(n) {
    return n === t || GFe(n, t, e);
  };
}
var YFe = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/, ZFe = /^\w*$/;
function P9(t, e) {
  if (ba(t))
    return !1;
  var n = typeof t;
  return n == "number" || n == "symbol" || n == "boolean" || t == null || UC(t) ? !0 : ZFe.test(t) || !YFe.test(t) || e != null && t in Object(e);
}
var JFe = "Expected a function";
function N9(t, e) {
  if (typeof t != "function" || e != null && typeof e != "function")
    throw new TypeError(JFe);
  var n = function() {
    var r = arguments, i = e ? e.apply(this, r) : r[0], o = n.cache;
    if (o.has(i))
      return o.get(i);
    var a = t.apply(this, r);
    return n.cache = o.set(i, a) || o, a;
  };
  return n.cache = new (N9.Cache || fl)(), n;
}
N9.Cache = fl;
var KFe = 500;
function qFe(t) {
  var e = N9(t, function(r) {
    return n.size === KFe && n.clear(), r;
  }), n = e.cache;
  return e;
}
var QFe = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g, eLe = /\\(\\)?/g, tLe = qFe(function(t) {
  var e = [];
  return t.charCodeAt(0) === 46 && e.push(""), t.replace(QFe, function(n, r, i, o) {
    e.push(i ? o.replace(eLe, "$1") : r || n);
  }), e;
});
const nLe = tLe;
var rLe = 1 / 0, fD = dc ? dc.prototype : void 0, hD = fD ? fD.toString : void 0;
function SY(t) {
  if (typeof t == "string")
    return t;
  if (ba(t))
    return xY(t, SY) + "";
  if (UC(t))
    return hD ? hD.call(t) : "";
  var e = t + "";
  return e == "0" && 1 / t == -rLe ? "-0" : e;
}
function iLe(t) {
  return t == null ? "" : SY(t);
}
function IY(t, e) {
  return ba(t) ? t : P9(t, e) ? [t] : nLe(iLe(t));
}
var oLe = 1 / 0;
function ZC(t) {
  if (typeof t == "string" || UC(t))
    return t;
  var e = t + "";
  return e == "0" && 1 / t == -oLe ? "-0" : e;
}
function _Y(t, e) {
  e = IY(e, t);
  for (var n = 0, r = e.length; t != null && n < r; )
    t = t[ZC(e[n++])];
  return n && n == r ? t : void 0;
}
function aLe(t, e, n) {
  var r = t == null ? void 0 : _Y(t, e);
  return r === void 0 ? n : r;
}
function sLe(t, e) {
  return t != null && e in Object(t);
}
function uLe(t, e, n) {
  e = IY(e, t);
  for (var r = -1, i = e.length, o = !1; ++r < i; ) {
    var a = ZC(e[r]);
    if (!(o = t != null && n(t, a)))
      break;
    t = t[a];
  }
  return o || ++r != i ? o : (i = t == null ? 0 : t.length, !!i && S9(i) && _9(a, i) && (ba(t) || Rx(t)));
}
function lLe(t, e) {
  return t != null && uLe(t, e, sLe);
}
var cLe = 1, dLe = 2;
function fLe(t, e) {
  return P9(t) && wY(e) ? EY(ZC(t), e) : function(n) {
    var r = aLe(n, t);
    return r === void 0 && r === e ? lLe(n, t) : O9(e, r, cLe | dLe);
  };
}
function hLe(t) {
  return function(e) {
    return e == null ? void 0 : e[t];
  };
}
function pLe(t) {
  return function(e) {
    return _Y(e, t);
  };
}
function gLe(t) {
  return P9(t) ? hLe(ZC(t)) : pLe(t);
}
function mLe(t) {
  return typeof t == "function" ? t : t == null ? GC : typeof t == "object" ? ba(t) ? fLe(t[0], t[1]) : XFe(t) : gLe(t);
}
function vLe(t, e) {
  var n = -1, r = Mp(t) ? Array(t.length) : [];
  return mY(t, function(i, o, a) {
    r[++n] = e(i, o, a);
  }), r;
}
function ef(t, e) {
  var n = ba(t) ? xY : vLe;
  return n(t, mLe(e));
}
var bLe = function(e) {
  var n = e.colors, r = e.onClick, i = e.onSwatchHover, o = un({
    default: {
      swatches: {
        marginRight: "-10px"
      },
      swatch: {
        width: "22px",
        height: "22px",
        float: "left",
        marginRight: "10px",
        marginBottom: "10px",
        borderRadius: "4px"
      },
      clear: {
        clear: "both"
      }
    }
  });
  return O.createElement(
    "div",
    { style: o.swatches },
    ef(n, function(a) {
      return O.createElement(Qd, {
        key: a,
        color: a,
        style: o.swatch,
        onClick: r,
        onHover: i,
        focusStyle: {
          boxShadow: "0 0 4px " + a
        }
      });
    }),
    O.createElement("div", { style: o.clear })
  );
}, k9 = function(e) {
  var n = e.onChange, r = e.onSwatchHover, i = e.hex, o = e.colors, a = e.width, s = e.triangle, u = e.styles, l = u === void 0 ? {} : u, c = e.className, d = c === void 0 ? "" : c, f = i === "transparent", h = function(m, b) {
    Oc(m) && n({
      hex: m,
      source: "hex"
    }, b);
  }, p = un(Fo({
    default: {
      card: {
        width: a,
        background: "#fff",
        boxShadow: "0 1px rgba(0,0,0,.1)",
        borderRadius: "6px",
        position: "relative"
      },
      head: {
        height: "110px",
        background: i,
        borderRadius: "6px 6px 0 0",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        position: "relative"
      },
      body: {
        padding: "10px"
      },
      label: {
        fontSize: "18px",
        color: T9(i),
        position: "relative"
      },
      triangle: {
        width: "0px",
        height: "0px",
        borderStyle: "solid",
        borderWidth: "0 10px 10px 10px",
        borderColor: "transparent transparent " + i + " transparent",
        position: "absolute",
        top: "-10px",
        left: "50%",
        marginLeft: "-10px"
      },
      input: {
        width: "100%",
        fontSize: "12px",
        color: "#666",
        border: "0px",
        outline: "none",
        height: "22px",
        boxShadow: "inset 0 0 0 1px #ddd",
        borderRadius: "4px",
        padding: "0 7px",
        boxSizing: "border-box"
      }
    },
    "hide-triangle": {
      triangle: {
        display: "none"
      }
    }
  }, l), { "hide-triangle": s === "hide" });
  return O.createElement(
    "div",
    { style: p.card, className: "block-picker " + d },
    O.createElement("div", { style: p.triangle }),
    O.createElement(
      "div",
      { style: p.head },
      f && O.createElement($p, { borderRadius: "6px 6px 0 0" }),
      O.createElement(
        "div",
        { style: p.label },
        i
      )
    ),
    O.createElement(
      "div",
      { style: p.body },
      O.createElement(bLe, { colors: o, onClick: h, onSwatchHover: r }),
      O.createElement(Ln, {
        style: { input: p.input },
        value: i,
        onChange: h
      })
    )
  );
};
k9.propTypes = {
  width: le.oneOfType([le.string, le.number]),
  colors: le.arrayOf(le.string),
  triangle: le.oneOf(["top", "hide"]),
  styles: le.object
};
k9.defaultProps = {
  width: 170,
  colors: ["#D9E3F0", "#F47373", "#697689", "#37D67A", "#2CCCE4", "#555555", "#dce775", "#ff8a65", "#ba68c8"],
  triangle: "top",
  styles: {}
};
const yLe = Lo(k9);
var th = { 50: "#ffebee", 100: "#ffcdd2", 200: "#ef9a9a", 300: "#e57373", 400: "#ef5350", 500: "#f44336", 600: "#e53935", 700: "#d32f2f", 800: "#c62828", 900: "#b71c1c", a100: "#ff8a80", a200: "#ff5252", a400: "#ff1744", a700: "#d50000" }, nh = { 50: "#fce4ec", 100: "#f8bbd0", 200: "#f48fb1", 300: "#f06292", 400: "#ec407a", 500: "#e91e63", 600: "#d81b60", 700: "#c2185b", 800: "#ad1457", 900: "#880e4f", a100: "#ff80ab", a200: "#ff4081", a400: "#f50057", a700: "#c51162" }, rh = { 50: "#f3e5f5", 100: "#e1bee7", 200: "#ce93d8", 300: "#ba68c8", 400: "#ab47bc", 500: "#9c27b0", 600: "#8e24aa", 700: "#7b1fa2", 800: "#6a1b9a", 900: "#4a148c", a100: "#ea80fc", a200: "#e040fb", a400: "#d500f9", a700: "#aa00ff" }, ih = { 50: "#ede7f6", 100: "#d1c4e9", 200: "#b39ddb", 300: "#9575cd", 400: "#7e57c2", 500: "#673ab7", 600: "#5e35b1", 700: "#512da8", 800: "#4527a0", 900: "#311b92", a100: "#b388ff", a200: "#7c4dff", a400: "#651fff", a700: "#6200ea" }, oh = { 50: "#e8eaf6", 100: "#c5cae9", 200: "#9fa8da", 300: "#7986cb", 400: "#5c6bc0", 500: "#3f51b5", 600: "#3949ab", 700: "#303f9f", 800: "#283593", 900: "#1a237e", a100: "#8c9eff", a200: "#536dfe", a400: "#3d5afe", a700: "#304ffe" }, ah = { 50: "#e3f2fd", 100: "#bbdefb", 200: "#90caf9", 300: "#64b5f6", 400: "#42a5f5", 500: "#2196f3", 600: "#1e88e5", 700: "#1976d2", 800: "#1565c0", 900: "#0d47a1", a100: "#82b1ff", a200: "#448aff", a400: "#2979ff", a700: "#2962ff" }, sh = { 50: "#e1f5fe", 100: "#b3e5fc", 200: "#81d4fa", 300: "#4fc3f7", 400: "#29b6f6", 500: "#03a9f4", 600: "#039be5", 700: "#0288d1", 800: "#0277bd", 900: "#01579b", a100: "#80d8ff", a200: "#40c4ff", a400: "#00b0ff", a700: "#0091ea" }, uh = { 50: "#e0f7fa", 100: "#b2ebf2", 200: "#80deea", 300: "#4dd0e1", 400: "#26c6da", 500: "#00bcd4", 600: "#00acc1", 700: "#0097a7", 800: "#00838f", 900: "#006064", a100: "#84ffff", a200: "#18ffff", a400: "#00e5ff", a700: "#00b8d4" }, lh = { 50: "#e0f2f1", 100: "#b2dfdb", 200: "#80cbc4", 300: "#4db6ac", 400: "#26a69a", 500: "#009688", 600: "#00897b", 700: "#00796b", 800: "#00695c", 900: "#004d40", a100: "#a7ffeb", a200: "#64ffda", a400: "#1de9b6", a700: "#00bfa5" }, n0 = { 50: "#e8f5e9", 100: "#c8e6c9", 200: "#a5d6a7", 300: "#81c784", 400: "#66bb6a", 500: "#4caf50", 600: "#43a047", 700: "#388e3c", 800: "#2e7d32", 900: "#1b5e20", a100: "#b9f6ca", a200: "#69f0ae", a400: "#00e676", a700: "#00c853" }, ch = { 50: "#f1f8e9", 100: "#dcedc8", 200: "#c5e1a5", 300: "#aed581", 400: "#9ccc65", 500: "#8bc34a", 600: "#7cb342", 700: "#689f38", 800: "#558b2f", 900: "#33691e", a100: "#ccff90", a200: "#b2ff59", a400: "#76ff03", a700: "#64dd17" }, dh = { 50: "#f9fbe7", 100: "#f0f4c3", 200: "#e6ee9c", 300: "#dce775", 400: "#d4e157", 500: "#cddc39", 600: "#c0ca33", 700: "#afb42b", 800: "#9e9d24", 900: "#827717", a100: "#f4ff81", a200: "#eeff41", a400: "#c6ff00", a700: "#aeea00" }, fh = { 50: "#fffde7", 100: "#fff9c4", 200: "#fff59d", 300: "#fff176", 400: "#ffee58", 500: "#ffeb3b", 600: "#fdd835", 700: "#fbc02d", 800: "#f9a825", 900: "#f57f17", a100: "#ffff8d", a200: "#ffff00", a400: "#ffea00", a700: "#ffd600" }, hh = { 50: "#fff8e1", 100: "#ffecb3", 200: "#ffe082", 300: "#ffd54f", 400: "#ffca28", 500: "#ffc107", 600: "#ffb300", 700: "#ffa000", 800: "#ff8f00", 900: "#ff6f00", a100: "#ffe57f", a200: "#ffd740", a400: "#ffc400", a700: "#ffab00" }, ph = { 50: "#fff3e0", 100: "#ffe0b2", 200: "#ffcc80", 300: "#ffb74d", 400: "#ffa726", 500: "#ff9800", 600: "#fb8c00", 700: "#f57c00", 800: "#ef6c00", 900: "#e65100", a100: "#ffd180", a200: "#ffab40", a400: "#ff9100", a700: "#ff6d00" }, gh = { 50: "#fbe9e7", 100: "#ffccbc", 200: "#ffab91", 300: "#ff8a65", 400: "#ff7043", 500: "#ff5722", 600: "#f4511e", 700: "#e64a19", 800: "#d84315", 900: "#bf360c", a100: "#ff9e80", a200: "#ff6e40", a400: "#ff3d00", a700: "#dd2c00" }, mh = { 50: "#efebe9", 100: "#d7ccc8", 200: "#bcaaa4", 300: "#a1887f", 400: "#8d6e63", 500: "#795548", 600: "#6d4c41", 700: "#5d4037", 800: "#4e342e", 900: "#3e2723" }, vh = { 50: "#eceff1", 100: "#cfd8dc", 200: "#b0bec5", 300: "#90a4ae", 400: "#78909c", 500: "#607d8b", 600: "#546e7a", 700: "#455a64", 800: "#37474f", 900: "#263238" }, AY = function(e) {
  var n = e.color, r = e.onClick, i = e.onSwatchHover, o = e.hover, a = e.active, s = e.circleSize, u = e.circleSpacing, l = un({
    default: {
      swatch: {
        width: s,
        height: s,
        marginRight: u,
        marginBottom: u,
        transform: "scale(1)",
        transition: "100ms transform ease"
      },
      Swatch: {
        borderRadius: "50%",
        background: "transparent",
        boxShadow: "inset 0 0 0 " + (s / 2 + 1) + "px " + n,
        transition: "100ms box-shadow ease"
      }
    },
    hover: {
      swatch: {
        transform: "scale(1.2)"
      }
    },
    active: {
      Swatch: {
        boxShadow: "inset 0 0 0 3px " + n
      }
    }
  }, { hover: o, active: a });
  return O.createElement(
    "div",
    { style: l.swatch },
    O.createElement(Qd, {
      style: l.Swatch,
      color: n,
      onClick: r,
      onHover: i,
      focusStyle: { boxShadow: l.Swatch.boxShadow + ", 0 0 5px " + n }
    })
  );
};
AY.defaultProps = {
  circleSize: 28,
  circleSpacing: 14
};
const xLe = b9(AY);
var R9 = function(e) {
  var n = e.width, r = e.onChange, i = e.onSwatchHover, o = e.colors, a = e.hex, s = e.circleSize, u = e.styles, l = u === void 0 ? {} : u, c = e.circleSpacing, d = e.className, f = d === void 0 ? "" : d, h = un(Fo({
    default: {
      card: {
        width: n,
        display: "flex",
        flexWrap: "wrap",
        marginRight: -c,
        marginBottom: -c
      }
    }
  }, l)), p = function(m, b) {
    return r({ hex: m, source: "hex" }, b);
  };
  return O.createElement(
    "div",
    { style: h.card, className: "circle-picker " + f },
    ef(o, function(v) {
      return O.createElement(xLe, {
        key: v,
        color: v,
        onClick: p,
        onSwatchHover: i,
        active: a === v.toLowerCase(),
        circleSize: s,
        circleSpacing: c
      });
    })
  );
};
R9.propTypes = {
  width: le.oneOfType([le.string, le.number]),
  circleSize: le.number,
  circleSpacing: le.number,
  styles: le.object
};
R9.defaultProps = {
  width: 252,
  circleSize: 28,
  circleSpacing: 14,
  colors: [th[500], nh[500], rh[500], ih[500], oh[500], ah[500], sh[500], uh[500], lh[500], n0[500], ch[500], dh[500], fh[500], hh[500], ph[500], gh[500], mh[500], vh[500]],
  styles: {}
};
Lo(R9);
function pD(t) {
  return t === void 0;
}
var TY = {};
Object.defineProperty(TY, "__esModule", {
  value: !0
});
var gD = Object.assign || function(t) {
  for (var e = 1; e < arguments.length; e++) {
    var n = arguments[e];
    for (var r in n)
      Object.prototype.hasOwnProperty.call(n, r) && (t[r] = n[r]);
  }
  return t;
}, CLe = O, mD = wLe(CLe);
function wLe(t) {
  return t && t.__esModule ? t : { default: t };
}
function ELe(t, e) {
  var n = {};
  for (var r in t)
    e.indexOf(r) >= 0 || Object.prototype.hasOwnProperty.call(t, r) && (n[r] = t[r]);
  return n;
}
var db = 24, SLe = TY.default = function(t) {
  var e = t.fill, n = e === void 0 ? "currentColor" : e, r = t.width, i = r === void 0 ? db : r, o = t.height, a = o === void 0 ? db : o, s = t.style, u = s === void 0 ? {} : s, l = ELe(t, ["fill", "width", "height", "style"]);
  return mD.default.createElement(
    "svg",
    gD({
      viewBox: "0 0 " + db + " " + db,
      style: gD({ fill: n, width: i, height: a }, u)
    }, l),
    mD.default.createElement("path", { d: "M12,18.17L8.83,15L7.42,16.41L12,21L16.59,16.41L15.17,15M12,5.83L15.17,9L16.58,7.59L12,3L7.41,7.59L8.83,9L12,5.83Z" })
  );
}, ILe = /* @__PURE__ */ function() {
  function t(e, n) {
    for (var r = 0; r < n.length; r++) {
      var i = n[r];
      i.enumerable = i.enumerable || !1, i.configurable = !0, "value" in i && (i.writable = !0), Object.defineProperty(e, i.key, i);
    }
  }
  return function(e, n, r) {
    return n && t(e.prototype, n), r && t(e, r), e;
  };
}();
function _Le(t, e) {
  if (!(t instanceof e))
    throw new TypeError("Cannot call a class as a function");
}
function ALe(t, e) {
  if (!t)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e && (typeof e == "object" || typeof e == "function") ? e : t;
}
function TLe(t, e) {
  if (typeof e != "function" && e !== null)
    throw new TypeError("Super expression must either be null or a function, not " + typeof e);
  t.prototype = Object.create(e && e.prototype, { constructor: { value: t, enumerable: !1, writable: !0, configurable: !0 } }), e && (Object.setPrototypeOf ? Object.setPrototypeOf(t, e) : t.__proto__ = e);
}
var OY = function(t) {
  TLe(e, t);
  function e(n) {
    _Le(this, e);
    var r = ALe(this, (e.__proto__ || Object.getPrototypeOf(e)).call(this));
    return r.toggleViews = function() {
      r.state.view === "hex" ? r.setState({ view: "rgb" }) : r.state.view === "rgb" ? r.setState({ view: "hsl" }) : r.state.view === "hsl" && (r.props.hsl.a === 1 ? r.setState({ view: "hex" }) : r.setState({ view: "rgb" }));
    }, r.handleChange = function(i, o) {
      i.hex ? Oc(i.hex) && r.props.onChange({
        hex: i.hex,
        source: "hex"
      }, o) : i.r || i.g || i.b ? r.props.onChange({
        r: i.r || r.props.rgb.r,
        g: i.g || r.props.rgb.g,
        b: i.b || r.props.rgb.b,
        source: "rgb"
      }, o) : i.a ? (i.a < 0 ? i.a = 0 : i.a > 1 && (i.a = 1), r.props.onChange({
        h: r.props.hsl.h,
        s: r.props.hsl.s,
        l: r.props.hsl.l,
        a: Math.round(i.a * 100) / 100,
        source: "rgb"
      }, o)) : (i.h || i.s || i.l) && (typeof i.s == "string" && i.s.includes("%") && (i.s = i.s.replace("%", "")), typeof i.l == "string" && i.l.includes("%") && (i.l = i.l.replace("%", "")), i.s == 1 ? i.s = 0.01 : i.l == 1 && (i.l = 0.01), r.props.onChange({
        h: i.h || r.props.hsl.h,
        s: Number(pD(i.s) ? r.props.hsl.s : i.s),
        l: Number(pD(i.l) ? r.props.hsl.l : i.l),
        source: "hsl"
      }, o));
    }, r.showHighlight = function(i) {
      i.currentTarget.style.background = "#eee";
    }, r.hideHighlight = function(i) {
      i.currentTarget.style.background = "transparent";
    }, n.hsl.a !== 1 && n.view === "hex" ? r.state = {
      view: "rgb"
    } : r.state = {
      view: n.view
    }, r;
  }
  return ILe(e, [{
    key: "render",
    value: function() {
      var r = this, i = un({
        default: {
          wrap: {
            paddingTop: "16px",
            display: "flex"
          },
          fields: {
            flex: "1",
            display: "flex",
            marginLeft: "-6px"
          },
          field: {
            paddingLeft: "6px",
            width: "100%"
          },
          alpha: {
            paddingLeft: "6px",
            width: "100%"
          },
          toggle: {
            width: "32px",
            textAlign: "right",
            position: "relative"
          },
          icon: {
            marginRight: "-4px",
            marginTop: "12px",
            cursor: "pointer",
            position: "relative"
          },
          iconHighlight: {
            position: "absolute",
            width: "24px",
            height: "28px",
            background: "#eee",
            borderRadius: "4px",
            top: "10px",
            left: "12px",
            display: "none"
          },
          input: {
            fontSize: "11px",
            color: "#333",
            width: "100%",
            borderRadius: "2px",
            border: "none",
            boxShadow: "inset 0 0 0 1px #dadada",
            height: "21px",
            textAlign: "center"
          },
          label: {
            textTransform: "uppercase",
            fontSize: "11px",
            lineHeight: "11px",
            color: "#969696",
            textAlign: "center",
            display: "block",
            marginTop: "12px"
          },
          svg: {
            fill: "#333",
            width: "24px",
            height: "24px",
            border: "1px transparent solid",
            borderRadius: "5px"
          }
        },
        disableAlpha: {
          alpha: {
            display: "none"
          }
        }
      }, this.props, this.state), o = void 0;
      return this.state.view === "hex" ? o = O.createElement(
        "div",
        { style: i.fields, className: "flexbox-fix" },
        O.createElement(
          "div",
          { style: i.field },
          O.createElement(Ln, {
            style: { input: i.input, label: i.label },
            label: "hex",
            value: this.props.hex,
            onChange: this.handleChange
          })
        )
      ) : this.state.view === "rgb" ? o = O.createElement(
        "div",
        { style: i.fields, className: "flexbox-fix" },
        O.createElement(
          "div",
          { style: i.field },
          O.createElement(Ln, {
            style: { input: i.input, label: i.label },
            label: "r",
            value: this.props.rgb.r,
            onChange: this.handleChange
          })
        ),
        O.createElement(
          "div",
          { style: i.field },
          O.createElement(Ln, {
            style: { input: i.input, label: i.label },
            label: "g",
            value: this.props.rgb.g,
            onChange: this.handleChange
          })
        ),
        O.createElement(
          "div",
          { style: i.field },
          O.createElement(Ln, {
            style: { input: i.input, label: i.label },
            label: "b",
            value: this.props.rgb.b,
            onChange: this.handleChange
          })
        ),
        O.createElement(
          "div",
          { style: i.alpha },
          O.createElement(Ln, {
            style: { input: i.input, label: i.label },
            label: "a",
            value: this.props.rgb.a,
            arrowOffset: 0.01,
            onChange: this.handleChange
          })
        )
      ) : this.state.view === "hsl" && (o = O.createElement(
        "div",
        { style: i.fields, className: "flexbox-fix" },
        O.createElement(
          "div",
          { style: i.field },
          O.createElement(Ln, {
            style: { input: i.input, label: i.label },
            label: "h",
            value: Math.round(this.props.hsl.h),
            onChange: this.handleChange
          })
        ),
        O.createElement(
          "div",
          { style: i.field },
          O.createElement(Ln, {
            style: { input: i.input, label: i.label },
            label: "s",
            value: Math.round(this.props.hsl.s * 100) + "%",
            onChange: this.handleChange
          })
        ),
        O.createElement(
          "div",
          { style: i.field },
          O.createElement(Ln, {
            style: { input: i.input, label: i.label },
            label: "l",
            value: Math.round(this.props.hsl.l * 100) + "%",
            onChange: this.handleChange
          })
        ),
        O.createElement(
          "div",
          { style: i.alpha },
          O.createElement(Ln, {
            style: { input: i.input, label: i.label },
            label: "a",
            value: this.props.hsl.a,
            arrowOffset: 0.01,
            onChange: this.handleChange
          })
        )
      )), O.createElement(
        "div",
        { style: i.wrap, className: "flexbox-fix" },
        o,
        O.createElement(
          "div",
          { style: i.toggle },
          O.createElement(
            "div",
            { style: i.icon, onClick: this.toggleViews, ref: function(s) {
              return r.icon = s;
            } },
            O.createElement(SLe, {
              style: i.svg,
              onMouseOver: this.showHighlight,
              onMouseEnter: this.showHighlight,
              onMouseOut: this.hideHighlight
            })
          )
        )
      );
    }
  }], [{
    key: "getDerivedStateFromProps",
    value: function(r, i) {
      return r.hsl.a !== 1 && i.view === "hex" ? { view: "rgb" } : null;
    }
  }]), e;
}(O.Component);
OY.defaultProps = {
  view: "hex"
};
var vD = function() {
  var e = un({
    default: {
      picker: {
        width: "12px",
        height: "12px",
        borderRadius: "6px",
        transform: "translate(-6px, -1px)",
        backgroundColor: "rgb(248, 248, 248)",
        boxShadow: "0 1px 4px 0 rgba(0, 0, 0, 0.37)"
      }
    }
  });
  return O.createElement("div", { style: e.picker });
}, OLe = function() {
  var e = un({
    default: {
      picker: {
        width: "12px",
        height: "12px",
        borderRadius: "6px",
        boxShadow: "inset 0 0 0 1px #fff",
        transform: "translate(-6px, -6px)"
      }
    }
  });
  return O.createElement("div", { style: e.picker });
}, $9 = function(e) {
  var n = e.width, r = e.onChange, i = e.disableAlpha, o = e.rgb, a = e.hsl, s = e.hsv, u = e.hex, l = e.renderers, c = e.styles, d = c === void 0 ? {} : c, f = e.className, h = f === void 0 ? "" : f, p = e.defaultView, v = un(Fo({
    default: {
      picker: {
        width: n,
        background: "#fff",
        borderRadius: "2px",
        boxShadow: "0 0 2px rgba(0,0,0,.3), 0 4px 8px rgba(0,0,0,.3)",
        boxSizing: "initial",
        fontFamily: "Menlo"
      },
      saturation: {
        width: "100%",
        paddingBottom: "55%",
        position: "relative",
        borderRadius: "2px 2px 0 0",
        overflow: "hidden"
      },
      Saturation: {
        radius: "2px 2px 0 0"
      },
      body: {
        padding: "16px 16px 12px"
      },
      controls: {
        display: "flex"
      },
      color: {
        width: "32px"
      },
      swatch: {
        marginTop: "6px",
        width: "16px",
        height: "16px",
        borderRadius: "8px",
        position: "relative",
        overflow: "hidden"
      },
      active: {
        absolute: "0px 0px 0px 0px",
        borderRadius: "8px",
        boxShadow: "inset 0 0 0 1px rgba(0,0,0,.1)",
        background: "rgba(" + o.r + ", " + o.g + ", " + o.b + ", " + o.a + ")",
        zIndex: "2"
      },
      toggles: {
        flex: "1"
      },
      hue: {
        height: "10px",
        position: "relative",
        marginBottom: "8px"
      },
      Hue: {
        radius: "2px"
      },
      alpha: {
        height: "10px",
        position: "relative"
      },
      Alpha: {
        radius: "2px"
      }
    },
    disableAlpha: {
      color: {
        width: "22px"
      },
      alpha: {
        display: "none"
      },
      hue: {
        marginBottom: "0px"
      },
      swatch: {
        width: "10px",
        height: "10px",
        marginTop: "0px"
      }
    }
  }, d), { disableAlpha: i });
  return O.createElement(
    "div",
    { style: v.picker, className: "chrome-picker " + h },
    O.createElement(
      "div",
      { style: v.saturation },
      O.createElement(XC, {
        style: v.Saturation,
        hsl: a,
        hsv: s,
        pointer: OLe,
        onChange: r
      })
    ),
    O.createElement(
      "div",
      { style: v.body },
      O.createElement(
        "div",
        { style: v.controls, className: "flexbox-fix" },
        O.createElement(
          "div",
          { style: v.color },
          O.createElement(
            "div",
            { style: v.swatch },
            O.createElement("div", { style: v.active }),
            O.createElement($p, { renderers: l })
          )
        ),
        O.createElement(
          "div",
          { style: v.toggles },
          O.createElement(
            "div",
            { style: v.hue },
            O.createElement(Dp, {
              style: v.Hue,
              hsl: a,
              pointer: vD,
              onChange: r
            })
          ),
          O.createElement(
            "div",
            { style: v.alpha },
            O.createElement(y9, {
              style: v.Alpha,
              rgb: o,
              hsl: a,
              pointer: vD,
              renderers: l,
              onChange: r
            })
          )
        )
      ),
      O.createElement(OY, {
        rgb: o,
        hsl: a,
        hex: u,
        view: p,
        onChange: r,
        disableAlpha: i
      })
    )
  );
};
$9.propTypes = {
  width: le.oneOfType([le.string, le.number]),
  disableAlpha: le.bool,
  styles: le.object,
  defaultView: le.oneOf(["hex", "rgb", "hsl"])
};
$9.defaultProps = {
  width: 225,
  disableAlpha: !1,
  styles: {}
};
const PLe = Lo($9);
var NLe = function(e) {
  var n = e.color, r = e.onClick, i = r === void 0 ? function() {
  } : r, o = e.onSwatchHover, a = e.active, s = un({
    default: {
      color: {
        background: n,
        width: "15px",
        height: "15px",
        float: "left",
        marginRight: "5px",
        marginBottom: "5px",
        position: "relative",
        cursor: "pointer"
      },
      dot: {
        absolute: "5px 5px 5px 5px",
        background: T9(n),
        borderRadius: "50%",
        opacity: "0"
      }
    },
    active: {
      dot: {
        opacity: "1"
      }
    },
    "color-#FFFFFF": {
      color: {
        boxShadow: "inset 0 0 0 1px #ddd"
      },
      dot: {
        background: "#000"
      }
    },
    transparent: {
      dot: {
        background: "#000"
      }
    }
  }, { active: a, "color-#FFFFFF": n === "#FFFFFF", transparent: n === "transparent" });
  return O.createElement(
    Qd,
    {
      style: s.color,
      color: n,
      onClick: i,
      onHover: o,
      focusStyle: { boxShadow: "0 0 4px " + n }
    },
    O.createElement("div", { style: s.dot })
  );
}, kLe = function(e) {
  var n = e.hex, r = e.rgb, i = e.onChange, o = un({
    default: {
      fields: {
        display: "flex",
        paddingBottom: "6px",
        paddingRight: "5px",
        position: "relative"
      },
      active: {
        position: "absolute",
        top: "6px",
        left: "5px",
        height: "9px",
        width: "9px",
        background: n
      },
      HEXwrap: {
        flex: "6",
        position: "relative"
      },
      HEXinput: {
        width: "80%",
        padding: "0px",
        paddingLeft: "20%",
        border: "none",
        outline: "none",
        background: "none",
        fontSize: "12px",
        color: "#333",
        height: "16px"
      },
      HEXlabel: {
        display: "none"
      },
      RGBwrap: {
        flex: "3",
        position: "relative"
      },
      RGBinput: {
        width: "70%",
        padding: "0px",
        paddingLeft: "30%",
        border: "none",
        outline: "none",
        background: "none",
        fontSize: "12px",
        color: "#333",
        height: "16px"
      },
      RGBlabel: {
        position: "absolute",
        top: "3px",
        left: "0px",
        lineHeight: "16px",
        textTransform: "uppercase",
        fontSize: "12px",
        color: "#999"
      }
    }
  }), a = function(u, l) {
    u.r || u.g || u.b ? i({
      r: u.r || r.r,
      g: u.g || r.g,
      b: u.b || r.b,
      source: "rgb"
    }, l) : i({
      hex: u.hex,
      source: "hex"
    }, l);
  };
  return O.createElement(
    "div",
    { style: o.fields, className: "flexbox-fix" },
    O.createElement("div", { style: o.active }),
    O.createElement(Ln, {
      style: { wrap: o.HEXwrap, input: o.HEXinput, label: o.HEXlabel },
      label: "hex",
      value: n,
      onChange: a
    }),
    O.createElement(Ln, {
      style: { wrap: o.RGBwrap, input: o.RGBinput, label: o.RGBlabel },
      label: "r",
      value: r.r,
      onChange: a
    }),
    O.createElement(Ln, {
      style: { wrap: o.RGBwrap, input: o.RGBinput, label: o.RGBlabel },
      label: "g",
      value: r.g,
      onChange: a
    }),
    O.createElement(Ln, {
      style: { wrap: o.RGBwrap, input: o.RGBinput, label: o.RGBlabel },
      label: "b",
      value: r.b,
      onChange: a
    })
  );
}, D9 = function(e) {
  var n = e.onChange, r = e.onSwatchHover, i = e.colors, o = e.hex, a = e.rgb, s = e.styles, u = s === void 0 ? {} : s, l = e.className, c = l === void 0 ? "" : l, d = un(Fo({
    default: {
      Compact: {
        background: "#f6f6f6",
        radius: "4px"
      },
      compact: {
        paddingTop: "5px",
        paddingLeft: "5px",
        boxSizing: "initial",
        width: "240px"
      },
      clear: {
        clear: "both"
      }
    }
  }, u)), f = function(p, v) {
    p.hex ? Oc(p.hex) && n({
      hex: p.hex,
      source: "hex"
    }, v) : n(p, v);
  };
  return O.createElement(
    tv,
    { style: d.Compact, styles: u },
    O.createElement(
      "div",
      { style: d.compact, className: "compact-picker " + c },
      O.createElement(
        "div",
        null,
        ef(i, function(h) {
          return O.createElement(NLe, {
            key: h,
            color: h,
            active: h.toLowerCase() === o,
            onClick: f,
            onSwatchHover: r
          });
        }),
        O.createElement("div", { style: d.clear })
      ),
      O.createElement(kLe, { hex: o, rgb: a, onChange: f })
    )
  );
};
D9.propTypes = {
  colors: le.arrayOf(le.string),
  styles: le.object
};
D9.defaultProps = {
  colors: ["#4D4D4D", "#999999", "#FFFFFF", "#F44E3B", "#FE9200", "#FCDC00", "#DBDF00", "#A4DD00", "#68CCCA", "#73D8FF", "#AEA1FF", "#FDA1FF", "#333333", "#808080", "#cccccc", "#D33115", "#E27300", "#FCC400", "#B0BC00", "#68BC00", "#16A5A5", "#009CE0", "#7B64FF", "#FA28FF", "#000000", "#666666", "#B3B3B3", "#9F0500", "#C45100", "#FB9E00", "#808900", "#194D33", "#0C797D", "#0062B1", "#653294", "#AB149E"],
  styles: {}
};
Lo(D9);
var RLe = function(e) {
  var n = e.hover, r = e.color, i = e.onClick, o = e.onSwatchHover, a = {
    position: "relative",
    zIndex: "2",
    outline: "2px solid #fff",
    boxShadow: "0 0 5px 2px rgba(0,0,0,0.25)"
  }, s = un({
    default: {
      swatch: {
        width: "25px",
        height: "25px",
        fontSize: "0"
      }
    },
    hover: {
      swatch: a
    }
  }, { hover: n });
  return O.createElement(
    "div",
    { style: s.swatch },
    O.createElement(Qd, {
      color: r,
      onClick: i,
      onHover: o,
      focusStyle: a
    })
  );
};
const $Le = b9(RLe);
var M9 = function(e) {
  var n = e.width, r = e.colors, i = e.onChange, o = e.onSwatchHover, a = e.triangle, s = e.styles, u = s === void 0 ? {} : s, l = e.className, c = l === void 0 ? "" : l, d = un(Fo({
    default: {
      card: {
        width: n,
        background: "#fff",
        border: "1px solid rgba(0,0,0,0.2)",
        boxShadow: "0 3px 12px rgba(0,0,0,0.15)",
        borderRadius: "4px",
        position: "relative",
        padding: "5px",
        display: "flex",
        flexWrap: "wrap"
      },
      triangle: {
        position: "absolute",
        border: "7px solid transparent",
        borderBottomColor: "#fff"
      },
      triangleShadow: {
        position: "absolute",
        border: "8px solid transparent",
        borderBottomColor: "rgba(0,0,0,0.15)"
      }
    },
    "hide-triangle": {
      triangle: {
        display: "none"
      },
      triangleShadow: {
        display: "none"
      }
    },
    "top-left-triangle": {
      triangle: {
        top: "-14px",
        left: "10px"
      },
      triangleShadow: {
        top: "-16px",
        left: "9px"
      }
    },
    "top-right-triangle": {
      triangle: {
        top: "-14px",
        right: "10px"
      },
      triangleShadow: {
        top: "-16px",
        right: "9px"
      }
    },
    "bottom-left-triangle": {
      triangle: {
        top: "35px",
        left: "10px",
        transform: "rotate(180deg)"
      },
      triangleShadow: {
        top: "37px",
        left: "9px",
        transform: "rotate(180deg)"
      }
    },
    "bottom-right-triangle": {
      triangle: {
        top: "35px",
        right: "10px",
        transform: "rotate(180deg)"
      },
      triangleShadow: {
        top: "37px",
        right: "9px",
        transform: "rotate(180deg)"
      }
    }
  }, u), {
    "hide-triangle": a === "hide",
    "top-left-triangle": a === "top-left",
    "top-right-triangle": a === "top-right",
    "bottom-left-triangle": a === "bottom-left",
    "bottom-right-triangle": a === "bottom-right"
  }), f = function(p, v) {
    return i({ hex: p, source: "hex" }, v);
  };
  return O.createElement(
    "div",
    { style: d.card, className: "github-picker " + c },
    O.createElement("div", { style: d.triangleShadow }),
    O.createElement("div", { style: d.triangle }),
    ef(r, function(h) {
      return O.createElement($Le, {
        color: h,
        key: h,
        onClick: f,
        onSwatchHover: o
      });
    })
  );
};
M9.propTypes = {
  width: le.oneOfType([le.string, le.number]),
  colors: le.arrayOf(le.string),
  triangle: le.oneOf(["hide", "top-left", "top-right", "bottom-left", "bottom-right"]),
  styles: le.object
};
M9.defaultProps = {
  width: 200,
  colors: ["#B80000", "#DB3E00", "#FCCB00", "#008B02", "#006B76", "#1273DE", "#004DCF", "#5300EB", "#EB9694", "#FAD0C3", "#FEF3BD", "#C1E1C5", "#BEDADC", "#C4DEF6", "#BED3F3", "#D4C4FB"],
  triangle: "top-left",
  styles: {}
};
const DLe = Lo(M9);
var MLe = function(e) {
  var n = e.direction, r = un({
    default: {
      picker: {
        width: "18px",
        height: "18px",
        borderRadius: "50%",
        transform: "translate(-9px, -1px)",
        backgroundColor: "rgb(248, 248, 248)",
        boxShadow: "0 1px 4px 0 rgba(0, 0, 0, 0.37)"
      }
    },
    vertical: {
      picker: {
        transform: "translate(-3px, -9px)"
      }
    }
  }, { vertical: n === "vertical" });
  return O.createElement("div", { style: r.picker });
}, FLe = Object.assign || function(t) {
  for (var e = 1; e < arguments.length; e++) {
    var n = arguments[e];
    for (var r in n)
      Object.prototype.hasOwnProperty.call(n, r) && (t[r] = n[r]);
  }
  return t;
}, F9 = function(e) {
  var n = e.width, r = e.height, i = e.onChange, o = e.hsl, a = e.direction, s = e.pointer, u = e.styles, l = u === void 0 ? {} : u, c = e.className, d = c === void 0 ? "" : c, f = un(Fo({
    default: {
      picker: {
        position: "relative",
        width: n,
        height: r
      },
      hue: {
        radius: "2px"
      }
    }
  }, l)), h = function(v) {
    return i({ a: 1, h: v.h, l: 0.5, s: 1 });
  };
  return O.createElement(
    "div",
    { style: f.picker, className: "hue-picker " + d },
    O.createElement(Dp, FLe({}, f.hue, {
      hsl: o,
      pointer: s,
      onChange: h,
      direction: a
    }))
  );
};
F9.propTypes = {
  styles: le.object
};
F9.defaultProps = {
  width: "316px",
  height: "16px",
  direction: "horizontal",
  pointer: MLe,
  styles: {}
};
Lo(F9);
var LLe = function(e) {
  var n = e.onChange, r = e.hex, i = e.rgb, o = e.styles, a = o === void 0 ? {} : o, s = e.className, u = s === void 0 ? "" : s, l = un(Fo({
    default: {
      material: {
        width: "98px",
        height: "98px",
        padding: "16px",
        fontFamily: "Roboto"
      },
      HEXwrap: {
        position: "relative"
      },
      HEXinput: {
        width: "100%",
        marginTop: "12px",
        fontSize: "15px",
        color: "#333",
        padding: "0px",
        border: "0px",
        borderBottom: "2px solid " + r,
        outline: "none",
        height: "30px"
      },
      HEXlabel: {
        position: "absolute",
        top: "0px",
        left: "0px",
        fontSize: "11px",
        color: "#999999",
        textTransform: "capitalize"
      },
      Hex: {
        style: {}
      },
      RGBwrap: {
        position: "relative"
      },
      RGBinput: {
        width: "100%",
        marginTop: "12px",
        fontSize: "15px",
        color: "#333",
        padding: "0px",
        border: "0px",
        borderBottom: "1px solid #eee",
        outline: "none",
        height: "30px"
      },
      RGBlabel: {
        position: "absolute",
        top: "0px",
        left: "0px",
        fontSize: "11px",
        color: "#999999",
        textTransform: "capitalize"
      },
      split: {
        display: "flex",
        marginRight: "-10px",
        paddingTop: "11px"
      },
      third: {
        flex: "1",
        paddingRight: "10px"
      }
    }
  }, a)), c = function(f, h) {
    f.hex ? Oc(f.hex) && n({
      hex: f.hex,
      source: "hex"
    }, h) : (f.r || f.g || f.b) && n({
      r: f.r || i.r,
      g: f.g || i.g,
      b: f.b || i.b,
      source: "rgb"
    }, h);
  };
  return O.createElement(
    tv,
    { styles: a },
    O.createElement(
      "div",
      { style: l.material, className: "material-picker " + u },
      O.createElement(Ln, {
        style: { wrap: l.HEXwrap, input: l.HEXinput, label: l.HEXlabel },
        label: "hex",
        value: r,
        onChange: c
      }),
      O.createElement(
        "div",
        { style: l.split, className: "flexbox-fix" },
        O.createElement(
          "div",
          { style: l.third },
          O.createElement(Ln, {
            style: { wrap: l.RGBwrap, input: l.RGBinput, label: l.RGBlabel },
            label: "r",
            value: i.r,
            onChange: c
          })
        ),
        O.createElement(
          "div",
          { style: l.third },
          O.createElement(Ln, {
            style: { wrap: l.RGBwrap, input: l.RGBinput, label: l.RGBlabel },
            label: "g",
            value: i.g,
            onChange: c
          })
        ),
        O.createElement(
          "div",
          { style: l.third },
          O.createElement(Ln, {
            style: { wrap: l.RGBwrap, input: l.RGBinput, label: l.RGBlabel },
            label: "b",
            value: i.b,
            onChange: c
          })
        )
      )
    )
  );
};
Lo(LLe);
var VLe = function(e) {
  var n = e.onChange, r = e.rgb, i = e.hsv, o = e.hex, a = un({
    default: {
      fields: {
        paddingTop: "5px",
        paddingBottom: "9px",
        width: "80px",
        position: "relative"
      },
      divider: {
        height: "5px"
      },
      RGBwrap: {
        position: "relative"
      },
      RGBinput: {
        marginLeft: "40%",
        width: "40%",
        height: "18px",
        border: "1px solid #888888",
        boxShadow: "inset 0 1px 1px rgba(0,0,0,.1), 0 1px 0 0 #ECECEC",
        marginBottom: "5px",
        fontSize: "13px",
        paddingLeft: "3px",
        marginRight: "10px"
      },
      RGBlabel: {
        left: "0px",
        top: "0px",
        width: "34px",
        textTransform: "uppercase",
        fontSize: "13px",
        height: "18px",
        lineHeight: "22px",
        position: "absolute"
      },
      HEXwrap: {
        position: "relative"
      },
      HEXinput: {
        marginLeft: "20%",
        width: "80%",
        height: "18px",
        border: "1px solid #888888",
        boxShadow: "inset 0 1px 1px rgba(0,0,0,.1), 0 1px 0 0 #ECECEC",
        marginBottom: "6px",
        fontSize: "13px",
        paddingLeft: "3px"
      },
      HEXlabel: {
        position: "absolute",
        top: "0px",
        left: "0px",
        width: "14px",
        textTransform: "uppercase",
        fontSize: "13px",
        height: "18px",
        lineHeight: "22px"
      },
      fieldSymbols: {
        position: "absolute",
        top: "5px",
        right: "-7px",
        fontSize: "13px"
      },
      symbol: {
        height: "20px",
        lineHeight: "22px",
        paddingBottom: "7px"
      }
    }
  }), s = function(l, c) {
    l["#"] ? Oc(l["#"]) && n({
      hex: l["#"],
      source: "hex"
    }, c) : l.r || l.g || l.b ? n({
      r: l.r || r.r,
      g: l.g || r.g,
      b: l.b || r.b,
      source: "rgb"
    }, c) : (l.h || l.s || l.v) && n({
      h: l.h || i.h,
      s: l.s || i.s,
      v: l.v || i.v,
      source: "hsv"
    }, c);
  };
  return O.createElement(
    "div",
    { style: a.fields },
    O.createElement(Ln, {
      style: { wrap: a.RGBwrap, input: a.RGBinput, label: a.RGBlabel },
      label: "h",
      value: Math.round(i.h),
      onChange: s
    }),
    O.createElement(Ln, {
      style: { wrap: a.RGBwrap, input: a.RGBinput, label: a.RGBlabel },
      label: "s",
      value: Math.round(i.s * 100),
      onChange: s
    }),
    O.createElement(Ln, {
      style: { wrap: a.RGBwrap, input: a.RGBinput, label: a.RGBlabel },
      label: "v",
      value: Math.round(i.v * 100),
      onChange: s
    }),
    O.createElement("div", { style: a.divider }),
    O.createElement(Ln, {
      style: { wrap: a.RGBwrap, input: a.RGBinput, label: a.RGBlabel },
      label: "r",
      value: r.r,
      onChange: s
    }),
    O.createElement(Ln, {
      style: { wrap: a.RGBwrap, input: a.RGBinput, label: a.RGBlabel },
      label: "g",
      value: r.g,
      onChange: s
    }),
    O.createElement(Ln, {
      style: { wrap: a.RGBwrap, input: a.RGBinput, label: a.RGBlabel },
      label: "b",
      value: r.b,
      onChange: s
    }),
    O.createElement("div", { style: a.divider }),
    O.createElement(Ln, {
      style: { wrap: a.HEXwrap, input: a.HEXinput, label: a.HEXlabel },
      label: "#",
      value: o.replace("#", ""),
      onChange: s
    }),
    O.createElement(
      "div",
      { style: a.fieldSymbols },
      O.createElement(
        "div",
        { style: a.symbol },
        "°"
      ),
      O.createElement(
        "div",
        { style: a.symbol },
        "%"
      ),
      O.createElement(
        "div",
        { style: a.symbol },
        "%"
      )
    )
  );
}, BLe = function(e) {
  var n = e.hsl, r = un({
    default: {
      picker: {
        width: "12px",
        height: "12px",
        borderRadius: "6px",
        boxShadow: "inset 0 0 0 1px #fff",
        transform: "translate(-6px, -6px)"
      }
    },
    "black-outline": {
      picker: {
        boxShadow: "inset 0 0 0 1px #000"
      }
    }
  }, { "black-outline": n.l > 0.5 });
  return O.createElement("div", { style: r.picker });
}, HLe = function() {
  var e = un({
    default: {
      triangle: {
        width: 0,
        height: 0,
        borderStyle: "solid",
        borderWidth: "4px 0 4px 6px",
        borderColor: "transparent transparent transparent #fff",
        position: "absolute",
        top: "1px",
        left: "1px"
      },
      triangleBorder: {
        width: 0,
        height: 0,
        borderStyle: "solid",
        borderWidth: "5px 0 5px 8px",
        borderColor: "transparent transparent transparent #555"
      },
      left: {
        Extend: "triangleBorder",
        transform: "translate(-13px, -4px)"
      },
      leftInside: {
        Extend: "triangle",
        transform: "translate(-8px, -5px)"
      },
      right: {
        Extend: "triangleBorder",
        transform: "translate(20px, -14px) rotate(180deg)"
      },
      rightInside: {
        Extend: "triangle",
        transform: "translate(-8px, -5px)"
      }
    }
  });
  return O.createElement(
    "div",
    { style: e.pointer },
    O.createElement(
      "div",
      { style: e.left },
      O.createElement("div", { style: e.leftInside })
    ),
    O.createElement(
      "div",
      { style: e.right },
      O.createElement("div", { style: e.rightInside })
    )
  );
}, bD = function(e) {
  var n = e.onClick, r = e.label, i = e.children, o = e.active, a = un({
    default: {
      button: {
        backgroundImage: "linear-gradient(-180deg, #FFFFFF 0%, #E6E6E6 100%)",
        border: "1px solid #878787",
        borderRadius: "2px",
        height: "20px",
        boxShadow: "0 1px 0 0 #EAEAEA",
        fontSize: "14px",
        color: "#000",
        lineHeight: "20px",
        textAlign: "center",
        marginBottom: "10px",
        cursor: "pointer"
      }
    },
    active: {
      button: {
        boxShadow: "0 0 0 1px #878787"
      }
    }
  }, { active: o });
  return O.createElement(
    "div",
    { style: a.button, onClick: n },
    r || i
  );
}, WLe = function(e) {
  var n = e.rgb, r = e.currentColor, i = un({
    default: {
      swatches: {
        border: "1px solid #B3B3B3",
        borderBottom: "1px solid #F0F0F0",
        marginBottom: "2px",
        marginTop: "1px"
      },
      new: {
        height: "34px",
        background: "rgb(" + n.r + "," + n.g + ", " + n.b + ")",
        boxShadow: "inset 1px 0 0 #000, inset -1px 0 0 #000, inset 0 1px 0 #000"
      },
      current: {
        height: "34px",
        background: r,
        boxShadow: "inset 1px 0 0 #000, inset -1px 0 0 #000, inset 0 -1px 0 #000"
      },
      label: {
        fontSize: "14px",
        color: "#000",
        textAlign: "center"
      }
    }
  });
  return O.createElement(
    "div",
    null,
    O.createElement(
      "div",
      { style: i.label },
      "new"
    ),
    O.createElement(
      "div",
      { style: i.swatches },
      O.createElement("div", { style: i.new }),
      O.createElement("div", { style: i.current })
    ),
    O.createElement(
      "div",
      { style: i.label },
      "current"
    )
  );
}, jLe = /* @__PURE__ */ function() {
  function t(e, n) {
    for (var r = 0; r < n.length; r++) {
      var i = n[r];
      i.enumerable = i.enumerable || !1, i.configurable = !0, "value" in i && (i.writable = !0), Object.defineProperty(e, i.key, i);
    }
  }
  return function(e, n, r) {
    return n && t(e.prototype, n), r && t(e, r), e;
  };
}();
function zLe(t, e) {
  if (!(t instanceof e))
    throw new TypeError("Cannot call a class as a function");
}
function GLe(t, e) {
  if (!t)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e && (typeof e == "object" || typeof e == "function") ? e : t;
}
function ULe(t, e) {
  if (typeof e != "function" && e !== null)
    throw new TypeError("Super expression must either be null or a function, not " + typeof e);
  t.prototype = Object.create(e && e.prototype, { constructor: { value: t, enumerable: !1, writable: !0, configurable: !0 } }), e && (Object.setPrototypeOf ? Object.setPrototypeOf(t, e) : t.__proto__ = e);
}
var L9 = function(t) {
  ULe(e, t);
  function e(n) {
    zLe(this, e);
    var r = GLe(this, (e.__proto__ || Object.getPrototypeOf(e)).call(this));
    return r.state = {
      currentColor: n.hex
    }, r;
  }
  return jLe(e, [{
    key: "render",
    value: function() {
      var r = this.props, i = r.styles, o = i === void 0 ? {} : i, a = r.className, s = a === void 0 ? "" : a, u = un(Fo({
        default: {
          picker: {
            background: "#DCDCDC",
            borderRadius: "4px",
            boxShadow: "0 0 0 1px rgba(0,0,0,.25), 0 8px 16px rgba(0,0,0,.15)",
            boxSizing: "initial",
            width: "513px"
          },
          head: {
            backgroundImage: "linear-gradient(-180deg, #F0F0F0 0%, #D4D4D4 100%)",
            borderBottom: "1px solid #B1B1B1",
            boxShadow: "inset 0 1px 0 0 rgba(255,255,255,.2), inset 0 -1px 0 0 rgba(0,0,0,.02)",
            height: "23px",
            lineHeight: "24px",
            borderRadius: "4px 4px 0 0",
            fontSize: "13px",
            color: "#4D4D4D",
            textAlign: "center"
          },
          body: {
            padding: "15px 15px 0",
            display: "flex"
          },
          saturation: {
            width: "256px",
            height: "256px",
            position: "relative",
            border: "2px solid #B3B3B3",
            borderBottom: "2px solid #F0F0F0",
            overflow: "hidden"
          },
          hue: {
            position: "relative",
            height: "256px",
            width: "19px",
            marginLeft: "10px",
            border: "2px solid #B3B3B3",
            borderBottom: "2px solid #F0F0F0"
          },
          controls: {
            width: "180px",
            marginLeft: "10px"
          },
          top: {
            display: "flex"
          },
          previews: {
            width: "60px"
          },
          actions: {
            flex: "1",
            marginLeft: "20px"
          }
        }
      }, o));
      return O.createElement(
        "div",
        { style: u.picker, className: "photoshop-picker " + s },
        O.createElement(
          "div",
          { style: u.head },
          this.props.header
        ),
        O.createElement(
          "div",
          { style: u.body, className: "flexbox-fix" },
          O.createElement(
            "div",
            { style: u.saturation },
            O.createElement(XC, {
              hsl: this.props.hsl,
              hsv: this.props.hsv,
              pointer: BLe,
              onChange: this.props.onChange
            })
          ),
          O.createElement(
            "div",
            { style: u.hue },
            O.createElement(Dp, {
              direction: "vertical",
              hsl: this.props.hsl,
              pointer: HLe,
              onChange: this.props.onChange
            })
          ),
          O.createElement(
            "div",
            { style: u.controls },
            O.createElement(
              "div",
              { style: u.top, className: "flexbox-fix" },
              O.createElement(
                "div",
                { style: u.previews },
                O.createElement(WLe, {
                  rgb: this.props.rgb,
                  currentColor: this.state.currentColor
                })
              ),
              O.createElement(
                "div",
                { style: u.actions },
                O.createElement(bD, { label: "OK", onClick: this.props.onAccept, active: !0 }),
                O.createElement(bD, { label: "Cancel", onClick: this.props.onCancel }),
                O.createElement(VLe, {
                  onChange: this.props.onChange,
                  rgb: this.props.rgb,
                  hsv: this.props.hsv,
                  hex: this.props.hex
                })
              )
            )
          )
        )
      );
    }
  }]), e;
}(O.Component);
L9.propTypes = {
  header: le.string,
  styles: le.object
};
L9.defaultProps = {
  header: "Color Picker",
  styles: {}
};
Lo(L9);
var XLe = function(e) {
  var n = e.onChange, r = e.rgb, i = e.hsl, o = e.hex, a = e.disableAlpha, s = un({
    default: {
      fields: {
        display: "flex",
        paddingTop: "4px"
      },
      single: {
        flex: "1",
        paddingLeft: "6px"
      },
      alpha: {
        flex: "1",
        paddingLeft: "6px"
      },
      double: {
        flex: "2"
      },
      input: {
        width: "80%",
        padding: "4px 10% 3px",
        border: "none",
        boxShadow: "inset 0 0 0 1px #ccc",
        fontSize: "11px"
      },
      label: {
        display: "block",
        textAlign: "center",
        fontSize: "11px",
        color: "#222",
        paddingTop: "3px",
        paddingBottom: "4px",
        textTransform: "capitalize"
      }
    },
    disableAlpha: {
      alpha: {
        display: "none"
      }
    }
  }, { disableAlpha: a }), u = function(c, d) {
    c.hex ? Oc(c.hex) && n({
      hex: c.hex,
      source: "hex"
    }, d) : c.r || c.g || c.b ? n({
      r: c.r || r.r,
      g: c.g || r.g,
      b: c.b || r.b,
      a: r.a,
      source: "rgb"
    }, d) : c.a && (c.a < 0 ? c.a = 0 : c.a > 100 && (c.a = 100), c.a /= 100, n({
      h: i.h,
      s: i.s,
      l: i.l,
      a: c.a,
      source: "rgb"
    }, d));
  };
  return O.createElement(
    "div",
    { style: s.fields, className: "flexbox-fix" },
    O.createElement(
      "div",
      { style: s.double },
      O.createElement(Ln, {
        style: { input: s.input, label: s.label },
        label: "hex",
        value: o.replace("#", ""),
        onChange: u
      })
    ),
    O.createElement(
      "div",
      { style: s.single },
      O.createElement(Ln, {
        style: { input: s.input, label: s.label },
        label: "r",
        value: r.r,
        onChange: u,
        dragLabel: "true",
        dragMax: "255"
      })
    ),
    O.createElement(
      "div",
      { style: s.single },
      O.createElement(Ln, {
        style: { input: s.input, label: s.label },
        label: "g",
        value: r.g,
        onChange: u,
        dragLabel: "true",
        dragMax: "255"
      })
    ),
    O.createElement(
      "div",
      { style: s.single },
      O.createElement(Ln, {
        style: { input: s.input, label: s.label },
        label: "b",
        value: r.b,
        onChange: u,
        dragLabel: "true",
        dragMax: "255"
      })
    ),
    O.createElement(
      "div",
      { style: s.alpha },
      O.createElement(Ln, {
        style: { input: s.input, label: s.label },
        label: "a",
        value: Math.round(r.a * 100),
        onChange: u,
        dragLabel: "true",
        dragMax: "100"
      })
    )
  );
}, YLe = Object.assign || function(t) {
  for (var e = 1; e < arguments.length; e++) {
    var n = arguments[e];
    for (var r in n)
      Object.prototype.hasOwnProperty.call(n, r) && (t[r] = n[r]);
  }
  return t;
}, PY = function(e) {
  var n = e.colors, r = e.onClick, i = r === void 0 ? function() {
  } : r, o = e.onSwatchHover, a = un({
    default: {
      colors: {
        margin: "0 -10px",
        padding: "10px 0 0 10px",
        borderTop: "1px solid #eee",
        display: "flex",
        flexWrap: "wrap",
        position: "relative"
      },
      swatchWrap: {
        width: "16px",
        height: "16px",
        margin: "0 10px 10px 0"
      },
      swatch: {
        borderRadius: "3px",
        boxShadow: "inset 0 0 0 1px rgba(0,0,0,.15)"
      }
    },
    "no-presets": {
      colors: {
        display: "none"
      }
    }
  }, {
    "no-presets": !n || !n.length
  }), s = function(l, c) {
    i({
      hex: l,
      source: "hex"
    }, c);
  };
  return O.createElement(
    "div",
    { style: a.colors, className: "flexbox-fix" },
    n.map(function(u) {
      var l = typeof u == "string" ? { color: u } : u, c = "" + l.color + (l.title || "");
      return O.createElement(
        "div",
        { key: c, style: a.swatchWrap },
        O.createElement(Qd, YLe({}, l, {
          style: a.swatch,
          onClick: s,
          onHover: o,
          focusStyle: {
            boxShadow: "inset 0 0 0 1px rgba(0,0,0,.15), 0 0 4px " + l.color
          }
        }))
      );
    })
  );
};
PY.propTypes = {
  colors: le.arrayOf(le.oneOfType([le.string, le.shape({
    color: le.string,
    title: le.string
  })])).isRequired
};
var ZLe = Object.assign || function(t) {
  for (var e = 1; e < arguments.length; e++) {
    var n = arguments[e];
    for (var r in n)
      Object.prototype.hasOwnProperty.call(n, r) && (t[r] = n[r]);
  }
  return t;
}, V9 = function(e) {
  var n = e.width, r = e.rgb, i = e.hex, o = e.hsv, a = e.hsl, s = e.onChange, u = e.onSwatchHover, l = e.disableAlpha, c = e.presetColors, d = e.renderers, f = e.styles, h = f === void 0 ? {} : f, p = e.className, v = p === void 0 ? "" : p, m = un(Fo({
    default: ZLe({
      picker: {
        width: n,
        padding: "10px 10px 0",
        boxSizing: "initial",
        background: "#fff",
        borderRadius: "4px",
        boxShadow: "0 0 0 1px rgba(0,0,0,.15), 0 8px 16px rgba(0,0,0,.15)"
      },
      saturation: {
        width: "100%",
        paddingBottom: "75%",
        position: "relative",
        overflow: "hidden"
      },
      Saturation: {
        radius: "3px",
        shadow: "inset 0 0 0 1px rgba(0,0,0,.15), inset 0 0 4px rgba(0,0,0,.25)"
      },
      controls: {
        display: "flex"
      },
      sliders: {
        padding: "4px 0",
        flex: "1"
      },
      color: {
        width: "24px",
        height: "24px",
        position: "relative",
        marginTop: "4px",
        marginLeft: "4px",
        borderRadius: "3px"
      },
      activeColor: {
        absolute: "0px 0px 0px 0px",
        borderRadius: "2px",
        background: "rgba(" + r.r + "," + r.g + "," + r.b + "," + r.a + ")",
        boxShadow: "inset 0 0 0 1px rgba(0,0,0,.15), inset 0 0 4px rgba(0,0,0,.25)"
      },
      hue: {
        position: "relative",
        height: "10px",
        overflow: "hidden"
      },
      Hue: {
        radius: "2px",
        shadow: "inset 0 0 0 1px rgba(0,0,0,.15), inset 0 0 4px rgba(0,0,0,.25)"
      },
      alpha: {
        position: "relative",
        height: "10px",
        marginTop: "4px",
        overflow: "hidden"
      },
      Alpha: {
        radius: "2px",
        shadow: "inset 0 0 0 1px rgba(0,0,0,.15), inset 0 0 4px rgba(0,0,0,.25)"
      }
    }, h),
    disableAlpha: {
      color: {
        height: "10px"
      },
      hue: {
        height: "10px"
      },
      alpha: {
        display: "none"
      }
    }
  }, h), { disableAlpha: l });
  return O.createElement(
    "div",
    { style: m.picker, className: "sketch-picker " + v },
    O.createElement(
      "div",
      { style: m.saturation },
      O.createElement(XC, {
        style: m.Saturation,
        hsl: a,
        hsv: o,
        onChange: s
      })
    ),
    O.createElement(
      "div",
      { style: m.controls, className: "flexbox-fix" },
      O.createElement(
        "div",
        { style: m.sliders },
        O.createElement(
          "div",
          { style: m.hue },
          O.createElement(Dp, {
            style: m.Hue,
            hsl: a,
            onChange: s
          })
        ),
        O.createElement(
          "div",
          { style: m.alpha },
          O.createElement(y9, {
            style: m.Alpha,
            rgb: r,
            hsl: a,
            renderers: d,
            onChange: s
          })
        )
      ),
      O.createElement(
        "div",
        { style: m.color },
        O.createElement($p, null),
        O.createElement("div", { style: m.activeColor })
      )
    ),
    O.createElement(XLe, {
      rgb: r,
      hsl: a,
      hex: i,
      onChange: s,
      disableAlpha: l
    }),
    O.createElement(PY, {
      colors: c,
      onClick: s,
      onSwatchHover: u
    })
  );
};
V9.propTypes = {
  disableAlpha: le.bool,
  width: le.oneOfType([le.string, le.number]),
  styles: le.object
};
V9.defaultProps = {
  disableAlpha: !1,
  width: 200,
  styles: {},
  presetColors: ["#D0021B", "#F5A623", "#F8E71C", "#8B572A", "#7ED321", "#417505", "#BD10E0", "#9013FE", "#4A90E2", "#50E3C2", "#B8E986", "#000000", "#4A4A4A", "#9B9B9B", "#FFFFFF"]
};
Lo(V9);
var $g = function(e) {
  var n = e.hsl, r = e.offset, i = e.onClick, o = i === void 0 ? function() {
  } : i, a = e.active, s = e.first, u = e.last, l = un({
    default: {
      swatch: {
        height: "12px",
        background: "hsl(" + n.h + ", 50%, " + r * 100 + "%)",
        cursor: "pointer"
      }
    },
    first: {
      swatch: {
        borderRadius: "2px 0 0 2px"
      }
    },
    last: {
      swatch: {
        borderRadius: "0 2px 2px 0"
      }
    },
    active: {
      swatch: {
        transform: "scaleY(1.8)",
        borderRadius: "3.6px/2px"
      }
    }
  }, { active: a, first: s, last: u }), c = function(f) {
    return o({
      h: n.h,
      s: 0.5,
      l: r,
      source: "hsl"
    }, f);
  };
  return O.createElement("div", { style: l.swatch, onClick: c });
}, JLe = function(e) {
  var n = e.onClick, r = e.hsl, i = un({
    default: {
      swatches: {
        marginTop: "20px"
      },
      swatch: {
        boxSizing: "border-box",
        width: "20%",
        paddingRight: "1px",
        float: "left"
      },
      clear: {
        clear: "both"
      }
    }
  }), o = 0.1;
  return O.createElement(
    "div",
    { style: i.swatches },
    O.createElement(
      "div",
      { style: i.swatch },
      O.createElement($g, {
        hsl: r,
        offset: ".80",
        active: Math.abs(r.l - 0.8) < o && Math.abs(r.s - 0.5) < o,
        onClick: n,
        first: !0
      })
    ),
    O.createElement(
      "div",
      { style: i.swatch },
      O.createElement($g, {
        hsl: r,
        offset: ".65",
        active: Math.abs(r.l - 0.65) < o && Math.abs(r.s - 0.5) < o,
        onClick: n
      })
    ),
    O.createElement(
      "div",
      { style: i.swatch },
      O.createElement($g, {
        hsl: r,
        offset: ".50",
        active: Math.abs(r.l - 0.5) < o && Math.abs(r.s - 0.5) < o,
        onClick: n
      })
    ),
    O.createElement(
      "div",
      { style: i.swatch },
      O.createElement($g, {
        hsl: r,
        offset: ".35",
        active: Math.abs(r.l - 0.35) < o && Math.abs(r.s - 0.5) < o,
        onClick: n
      })
    ),
    O.createElement(
      "div",
      { style: i.swatch },
      O.createElement($g, {
        hsl: r,
        offset: ".20",
        active: Math.abs(r.l - 0.2) < o && Math.abs(r.s - 0.5) < o,
        onClick: n,
        last: !0
      })
    ),
    O.createElement("div", { style: i.clear })
  );
}, KLe = function() {
  var e = un({
    default: {
      picker: {
        width: "14px",
        height: "14px",
        borderRadius: "6px",
        transform: "translate(-7px, -1px)",
        backgroundColor: "rgb(248, 248, 248)",
        boxShadow: "0 1px 4px 0 rgba(0, 0, 0, 0.37)"
      }
    }
  });
  return O.createElement("div", { style: e.picker });
}, B9 = function(e) {
  var n = e.hsl, r = e.onChange, i = e.pointer, o = e.styles, a = o === void 0 ? {} : o, s = e.className, u = s === void 0 ? "" : s, l = un(Fo({
    default: {
      hue: {
        height: "12px",
        position: "relative"
      },
      Hue: {
        radius: "2px"
      }
    }
  }, a));
  return O.createElement(
    "div",
    { style: l.wrap || {}, className: "slider-picker " + u },
    O.createElement(
      "div",
      { style: l.hue },
      O.createElement(Dp, {
        style: l.Hue,
        hsl: n,
        pointer: i,
        onChange: r
      })
    ),
    O.createElement(
      "div",
      { style: l.swatches },
      O.createElement(JLe, { hsl: n, onClick: r })
    )
  );
};
B9.propTypes = {
  styles: le.object
};
B9.defaultProps = {
  pointer: KLe,
  styles: {}
};
Lo(B9);
var NY = {};
Object.defineProperty(NY, "__esModule", {
  value: !0
});
var yD = Object.assign || function(t) {
  for (var e = 1; e < arguments.length; e++) {
    var n = arguments[e];
    for (var r in n)
      Object.prototype.hasOwnProperty.call(n, r) && (t[r] = n[r]);
  }
  return t;
}, qLe = O, xD = QLe(qLe);
function QLe(t) {
  return t && t.__esModule ? t : { default: t };
}
function eVe(t, e) {
  var n = {};
  for (var r in t)
    e.indexOf(r) >= 0 || Object.prototype.hasOwnProperty.call(t, r) && (n[r] = t[r]);
  return n;
}
var fb = 24, tVe = NY.default = function(t) {
  var e = t.fill, n = e === void 0 ? "currentColor" : e, r = t.width, i = r === void 0 ? fb : r, o = t.height, a = o === void 0 ? fb : o, s = t.style, u = s === void 0 ? {} : s, l = eVe(t, ["fill", "width", "height", "style"]);
  return xD.default.createElement(
    "svg",
    yD({
      viewBox: "0 0 " + fb + " " + fb,
      style: yD({ fill: n, width: i, height: a }, u)
    }, l),
    xD.default.createElement("path", { d: "M21,7L9,19L3.5,13.5L4.91,12.09L9,16.17L19.59,5.59L21,7Z" })
  );
}, nVe = function(e) {
  var n = e.color, r = e.onClick, i = r === void 0 ? function() {
  } : r, o = e.onSwatchHover, a = e.first, s = e.last, u = e.active, l = un({
    default: {
      color: {
        width: "40px",
        height: "24px",
        cursor: "pointer",
        background: n,
        marginBottom: "1px"
      },
      check: {
        color: T9(n),
        marginLeft: "8px",
        display: "none"
      }
    },
    first: {
      color: {
        overflow: "hidden",
        borderRadius: "2px 2px 0 0"
      }
    },
    last: {
      color: {
        overflow: "hidden",
        borderRadius: "0 0 2px 2px"
      }
    },
    active: {
      check: {
        display: "block"
      }
    },
    "color-#FFFFFF": {
      color: {
        boxShadow: "inset 0 0 0 1px #ddd"
      },
      check: {
        color: "#333"
      }
    },
    transparent: {
      check: {
        color: "#333"
      }
    }
  }, {
    first: a,
    last: s,
    active: u,
    "color-#FFFFFF": n === "#FFFFFF",
    transparent: n === "transparent"
  });
  return O.createElement(
    Qd,
    {
      color: n,
      style: l.color,
      onClick: i,
      onHover: o,
      focusStyle: { boxShadow: "0 0 4px " + n }
    },
    O.createElement(
      "div",
      { style: l.check },
      O.createElement(tVe, null)
    )
  );
}, rVe = function(e) {
  var n = e.onClick, r = e.onSwatchHover, i = e.group, o = e.active, a = un({
    default: {
      group: {
        paddingBottom: "10px",
        width: "40px",
        float: "left",
        marginRight: "10px"
      }
    }
  });
  return O.createElement(
    "div",
    { style: a.group },
    ef(i, function(s, u) {
      return O.createElement(nVe, {
        key: s,
        color: s,
        active: s.toLowerCase() === o,
        first: u === 0,
        last: u === i.length - 1,
        onClick: n,
        onSwatchHover: r
      });
    })
  );
}, H9 = function(e) {
  var n = e.width, r = e.height, i = e.onChange, o = e.onSwatchHover, a = e.colors, s = e.hex, u = e.styles, l = u === void 0 ? {} : u, c = e.className, d = c === void 0 ? "" : c, f = un(Fo({
    default: {
      picker: {
        width: n,
        height: r
      },
      overflow: {
        height: r,
        overflowY: "scroll"
      },
      body: {
        padding: "16px 0 6px 16px"
      },
      clear: {
        clear: "both"
      }
    }
  }, l)), h = function(v, m) {
    return i({ hex: v, source: "hex" }, m);
  };
  return O.createElement(
    "div",
    { style: f.picker, className: "swatches-picker " + d },
    O.createElement(
      tv,
      null,
      O.createElement(
        "div",
        { style: f.overflow },
        O.createElement(
          "div",
          { style: f.body },
          ef(a, function(p) {
            return O.createElement(rVe, {
              key: p.toString(),
              group: p,
              active: s,
              onClick: h,
              onSwatchHover: o
            });
          }),
          O.createElement("div", { style: f.clear })
        )
      )
    )
  );
};
H9.propTypes = {
  width: le.oneOfType([le.string, le.number]),
  height: le.oneOfType([le.string, le.number]),
  colors: le.arrayOf(le.arrayOf(le.string)),
  styles: le.object
  /* eslint-disable max-len */
};
H9.defaultProps = {
  width: 320,
  height: 240,
  colors: [[th[900], th[700], th[500], th[300], th[100]], [nh[900], nh[700], nh[500], nh[300], nh[100]], [rh[900], rh[700], rh[500], rh[300], rh[100]], [ih[900], ih[700], ih[500], ih[300], ih[100]], [oh[900], oh[700], oh[500], oh[300], oh[100]], [ah[900], ah[700], ah[500], ah[300], ah[100]], [sh[900], sh[700], sh[500], sh[300], sh[100]], [uh[900], uh[700], uh[500], uh[300], uh[100]], [lh[900], lh[700], lh[500], lh[300], lh[100]], ["#194D33", n0[700], n0[500], n0[300], n0[100]], [ch[900], ch[700], ch[500], ch[300], ch[100]], [dh[900], dh[700], dh[500], dh[300], dh[100]], [fh[900], fh[700], fh[500], fh[300], fh[100]], [hh[900], hh[700], hh[500], hh[300], hh[100]], [ph[900], ph[700], ph[500], ph[300], ph[100]], [gh[900], gh[700], gh[500], gh[300], gh[100]], [mh[900], mh[700], mh[500], mh[300], mh[100]], [vh[900], vh[700], vh[500], vh[300], vh[100]], ["#000000", "#525252", "#969696", "#D9D9D9", "#FFFFFF"]],
  styles: {}
};
Lo(H9);
var W9 = function(e) {
  var n = e.onChange, r = e.onSwatchHover, i = e.hex, o = e.colors, a = e.width, s = e.triangle, u = e.styles, l = u === void 0 ? {} : u, c = e.className, d = c === void 0 ? "" : c, f = un(Fo({
    default: {
      card: {
        width: a,
        background: "#fff",
        border: "0 solid rgba(0,0,0,0.25)",
        boxShadow: "0 1px 4px rgba(0,0,0,0.25)",
        borderRadius: "4px",
        position: "relative"
      },
      body: {
        padding: "15px 9px 9px 15px"
      },
      label: {
        fontSize: "18px",
        color: "#fff"
      },
      triangle: {
        width: "0px",
        height: "0px",
        borderStyle: "solid",
        borderWidth: "0 9px 10px 9px",
        borderColor: "transparent transparent #fff transparent",
        position: "absolute"
      },
      triangleShadow: {
        width: "0px",
        height: "0px",
        borderStyle: "solid",
        borderWidth: "0 9px 10px 9px",
        borderColor: "transparent transparent rgba(0,0,0,.1) transparent",
        position: "absolute"
      },
      hash: {
        background: "#F0F0F0",
        height: "30px",
        width: "30px",
        borderRadius: "4px 0 0 4px",
        float: "left",
        color: "#98A1A4",
        display: "flex",
        alignItems: "center",
        justifyContent: "center"
      },
      input: {
        width: "100px",
        fontSize: "14px",
        color: "#666",
        border: "0px",
        outline: "none",
        height: "28px",
        boxShadow: "inset 0 0 0 1px #F0F0F0",
        boxSizing: "content-box",
        borderRadius: "0 4px 4px 0",
        float: "left",
        paddingLeft: "8px"
      },
      swatch: {
        width: "30px",
        height: "30px",
        float: "left",
        borderRadius: "4px",
        margin: "0 6px 6px 0"
      },
      clear: {
        clear: "both"
      }
    },
    "hide-triangle": {
      triangle: {
        display: "none"
      },
      triangleShadow: {
        display: "none"
      }
    },
    "top-left-triangle": {
      triangle: {
        top: "-10px",
        left: "12px"
      },
      triangleShadow: {
        top: "-11px",
        left: "12px"
      }
    },
    "top-right-triangle": {
      triangle: {
        top: "-10px",
        right: "12px"
      },
      triangleShadow: {
        top: "-11px",
        right: "12px"
      }
    }
  }, l), {
    "hide-triangle": s === "hide",
    "top-left-triangle": s === "top-left",
    "top-right-triangle": s === "top-right"
  }), h = function(v, m) {
    Oc(v) && n({
      hex: v,
      source: "hex"
    }, m);
  };
  return O.createElement(
    "div",
    { style: f.card, className: "twitter-picker " + d },
    O.createElement("div", { style: f.triangleShadow }),
    O.createElement("div", { style: f.triangle }),
    O.createElement(
      "div",
      { style: f.body },
      ef(o, function(p, v) {
        return O.createElement(Qd, {
          key: v,
          color: p,
          hex: p,
          style: f.swatch,
          onClick: h,
          onHover: r,
          focusStyle: {
            boxShadow: "0 0 4px " + p
          }
        });
      }),
      O.createElement(
        "div",
        { style: f.hash },
        "#"
      ),
      O.createElement(Ln, {
        label: null,
        style: { input: f.input },
        value: i.replace("#", ""),
        onChange: h
      }),
      O.createElement("div", { style: f.clear })
    )
  );
};
W9.propTypes = {
  width: le.oneOfType([le.string, le.number]),
  triangle: le.oneOf(["hide", "top-left", "top-right"]),
  colors: le.arrayOf(le.string),
  styles: le.object
};
W9.defaultProps = {
  width: 276,
  colors: ["#FF6900", "#FCB900", "#7BDCB5", "#00D084", "#8ED1FC", "#0693E3", "#ABB8C3", "#EB144C", "#F78DA7", "#9900EF"],
  triangle: "top-left",
  styles: {}
};
Lo(W9);
var j9 = function(e) {
  var n = un({
    default: {
      picker: {
        width: "20px",
        height: "20px",
        borderRadius: "22px",
        border: "2px #fff solid",
        transform: "translate(-12px, -13px)",
        background: "hsl(" + Math.round(e.hsl.h) + ", " + Math.round(e.hsl.s * 100) + "%, " + Math.round(e.hsl.l * 100) + "%)"
      }
    }
  });
  return O.createElement("div", { style: n.picker });
};
j9.propTypes = {
  hsl: le.shape({
    h: le.number,
    s: le.number,
    l: le.number,
    a: le.number
  })
};
j9.defaultProps = {
  hsl: { a: 1, h: 249.94, l: 0.2, s: 0.5 }
};
var z9 = function(e) {
  var n = un({
    default: {
      picker: {
        width: "20px",
        height: "20px",
        borderRadius: "22px",
        transform: "translate(-10px, -7px)",
        background: "hsl(" + Math.round(e.hsl.h) + ", 100%, 50%)",
        border: "2px white solid"
      }
    }
  });
  return O.createElement("div", { style: n.picker });
};
z9.propTypes = {
  hsl: le.shape({
    h: le.number,
    s: le.number,
    l: le.number,
    a: le.number
  })
};
z9.defaultProps = {
  hsl: { a: 1, h: 249.94, l: 0.2, s: 0.5 }
};
var iVe = function(e) {
  var n = e.onChange, r = e.rgb, i = e.hsl, o = e.hex, a = e.hsv, s = function(h, p) {
    if (h.hex)
      Oc(h.hex) && n({
        hex: h.hex,
        source: "hex"
      }, p);
    else if (h.rgb) {
      var v = h.rgb.split(",");
      S3(h.rgb, "rgb") && n({
        r: v[0],
        g: v[1],
        b: v[2],
        a: 1,
        source: "rgb"
      }, p);
    } else if (h.hsv) {
      var m = h.hsv.split(",");
      S3(h.hsv, "hsv") && (m[2] = m[2].replace("%", ""), m[1] = m[1].replace("%", ""), m[0] = m[0].replace("°", ""), m[1] == 1 ? m[1] = 0.01 : m[2] == 1 && (m[2] = 0.01), n({
        h: Number(m[0]),
        s: Number(m[1]),
        v: Number(m[2]),
        source: "hsv"
      }, p));
    } else if (h.hsl) {
      var b = h.hsl.split(",");
      S3(h.hsl, "hsl") && (b[2] = b[2].replace("%", ""), b[1] = b[1].replace("%", ""), b[0] = b[0].replace("°", ""), d[1] == 1 ? d[1] = 0.01 : d[2] == 1 && (d[2] = 0.01), n({
        h: Number(b[0]),
        s: Number(b[1]),
        v: Number(b[2]),
        source: "hsl"
      }, p));
    }
  }, u = un({
    default: {
      wrap: {
        display: "flex",
        height: "100px",
        marginTop: "4px"
      },
      fields: {
        width: "100%"
      },
      column: {
        paddingTop: "10px",
        display: "flex",
        justifyContent: "space-between"
      },
      double: {
        padding: "0px 4.4px",
        boxSizing: "border-box"
      },
      input: {
        width: "100%",
        height: "38px",
        boxSizing: "border-box",
        padding: "4px 10% 3px",
        textAlign: "center",
        border: "1px solid #dadce0",
        fontSize: "11px",
        textTransform: "lowercase",
        borderRadius: "5px",
        outline: "none",
        fontFamily: "Roboto,Arial,sans-serif"
      },
      input2: {
        height: "38px",
        width: "100%",
        border: "1px solid #dadce0",
        boxSizing: "border-box",
        fontSize: "11px",
        textTransform: "lowercase",
        borderRadius: "5px",
        outline: "none",
        paddingLeft: "10px",
        fontFamily: "Roboto,Arial,sans-serif"
      },
      label: {
        textAlign: "center",
        fontSize: "12px",
        background: "#fff",
        position: "absolute",
        textTransform: "uppercase",
        color: "#3c4043",
        width: "35px",
        top: "-6px",
        left: "0",
        right: "0",
        marginLeft: "auto",
        marginRight: "auto",
        fontFamily: "Roboto,Arial,sans-serif"
      },
      label2: {
        left: "10px",
        textAlign: "center",
        fontSize: "12px",
        background: "#fff",
        position: "absolute",
        textTransform: "uppercase",
        color: "#3c4043",
        width: "32px",
        top: "-6px",
        fontFamily: "Roboto,Arial,sans-serif"
      },
      single: {
        flexGrow: "1",
        margin: "0px 4.4px"
      }
    }
  }), l = r.r + ", " + r.g + ", " + r.b, c = Math.round(i.h) + "°, " + Math.round(i.s * 100) + "%, " + Math.round(i.l * 100) + "%", d = Math.round(a.h) + "°, " + Math.round(a.s * 100) + "%, " + Math.round(a.v * 100) + "%";
  return O.createElement(
    "div",
    { style: u.wrap, className: "flexbox-fix" },
    O.createElement(
      "div",
      { style: u.fields },
      O.createElement(
        "div",
        { style: u.double },
        O.createElement(Ln, {
          style: { input: u.input, label: u.label },
          label: "hex",
          value: o,
          onChange: s
        })
      ),
      O.createElement(
        "div",
        { style: u.column },
        O.createElement(
          "div",
          { style: u.single },
          O.createElement(Ln, {
            style: { input: u.input2, label: u.label2 },
            label: "rgb",
            value: l,
            onChange: s
          })
        ),
        O.createElement(
          "div",
          { style: u.single },
          O.createElement(Ln, {
            style: { input: u.input2, label: u.label2 },
            label: "hsv",
            value: d,
            onChange: s
          })
        ),
        O.createElement(
          "div",
          { style: u.single },
          O.createElement(Ln, {
            style: { input: u.input2, label: u.label2 },
            label: "hsl",
            value: c,
            onChange: s
          })
        )
      )
    )
  );
}, G9 = function(e) {
  var n = e.width, r = e.onChange, i = e.rgb, o = e.hsl, a = e.hsv, s = e.hex, u = e.header, l = e.styles, c = l === void 0 ? {} : l, d = e.className, f = d === void 0 ? "" : d, h = un(Fo({
    default: {
      picker: {
        width: n,
        background: "#fff",
        border: "1px solid #dfe1e5",
        boxSizing: "initial",
        display: "flex",
        flexWrap: "wrap",
        borderRadius: "8px 8px 0px 0px"
      },
      head: {
        height: "57px",
        width: "100%",
        paddingTop: "16px",
        paddingBottom: "16px",
        paddingLeft: "16px",
        fontSize: "20px",
        boxSizing: "border-box",
        fontFamily: "Roboto-Regular,HelveticaNeue,Arial,sans-serif"
      },
      saturation: {
        width: "70%",
        padding: "0px",
        position: "relative",
        overflow: "hidden"
      },
      swatch: {
        width: "30%",
        height: "228px",
        padding: "0px",
        background: "rgba(" + i.r + ", " + i.g + ", " + i.b + ", 1)",
        position: "relative",
        overflow: "hidden"
      },
      body: {
        margin: "auto",
        width: "95%"
      },
      controls: {
        display: "flex",
        boxSizing: "border-box",
        height: "52px",
        paddingTop: "22px"
      },
      color: {
        width: "32px"
      },
      hue: {
        height: "8px",
        position: "relative",
        margin: "0px 16px 0px 16px",
        width: "100%"
      },
      Hue: {
        radius: "2px"
      }
    }
  }, c));
  return O.createElement(
    "div",
    { style: h.picker, className: "google-picker " + f },
    O.createElement(
      "div",
      { style: h.head },
      u
    ),
    O.createElement("div", { style: h.swatch }),
    O.createElement(
      "div",
      { style: h.saturation },
      O.createElement(XC, {
        hsl: o,
        hsv: a,
        pointer: j9,
        onChange: r
      })
    ),
    O.createElement(
      "div",
      { style: h.body },
      O.createElement(
        "div",
        { style: h.controls, className: "flexbox-fix" },
        O.createElement(
          "div",
          { style: h.hue },
          O.createElement(Dp, {
            style: h.Hue,
            hsl: o,
            radius: "4px",
            pointer: z9,
            onChange: r
          })
        )
      ),
      O.createElement(iVe, {
        rgb: i,
        hsl: o,
        hex: s,
        hsv: a,
        onChange: r
      })
    )
  );
};
G9.propTypes = {
  width: le.oneOfType([le.string, le.number]),
  styles: le.object,
  header: le.string
};
G9.defaultProps = {
  width: 652,
  styles: {},
  header: "Color picker"
};
Lo(G9);
const oVe = (t) => {
  const {
    value: e,
    inputProps: n = {},
    onChange: r
  } = t, {
    type: i = "chrome",
    size: o = "default",
    colors: a
  } = n, [s, u] = Le(!1), [l, c] = Le(e || null);
  Re(() => {
    c(e);
  }, [e]);
  const d = (v) => {
    if (v != null && v.hex) {
      const { hex: m } = v;
      c(m), u(!1), r(m);
    }
  }, f = (v) => {
    const { hex: m } = v;
    c(m), r(m);
  }, h = (v) => u(v), p = /* @__PURE__ */ Oe.jsx("div", { className: "ant-form-colorpicker-swatch", children: /* @__PURE__ */ Oe.jsx(
    "div",
    {
      className: o === "small" ? "ant-form-colorpicker-small-size" : "ant-form-colorpicker-default-size",
      style: { backgroundColor: l || "#FFF" }
    }
  ) });
  return /* @__PURE__ */ Oe.jsx(
    Ud,
    {
      placement: "leftTop",
      title: l || "",
      children: /* @__PURE__ */ Oe.jsx(
        zye,
        {
          trigger: "click",
          overlayClassName: "ant-form-colorpicker-popover",
          open: s,
          onOpenChange: h,
          content: /* @__PURE__ */ Oe.jsxs("div", { className: "ant-form-colorpicker-container", children: [
            (!i || i === "chrome") && /* @__PURE__ */ Oe.jsx("div", { className: "ant-form-colorpicker-chrome-container", children: /* @__PURE__ */ Oe.jsx(
              PLe,
              {
                color: l || "",
                onChangeComplete: f
              }
            ) }),
            i === "github" && /* @__PURE__ */ Oe.jsx(
              DLe,
              {
                color: l || "",
                colors: a,
                triangle: "hide",
                onChangeComplete: d
              }
            ),
            i === "block" && /* @__PURE__ */ Oe.jsx("div", { children: /* @__PURE__ */ Oe.jsx(
              yLe,
              {
                color: l || "",
                colors: a,
                triangle: "hide",
                onChangeComplete: f
              }
            ) })
          ] }),
          children: p
        }
      )
    }
  );
}, aVe = (t) => {
  const {
    onChange: e,
    inputProps: {
      text: n,
      inverted: r = !1,
      ...i
    } = {}
  } = t, [o, a] = Le(t.value || !1), s = (u) => {
    const l = r ? !u : u;
    a(l), e(l);
  };
  return Re(() => a(t.value || !1), [t.value]), /* @__PURE__ */ Oe.jsxs("span", { children: [
    /* @__PURE__ */ Oe.jsx(aX, { onChange: s, checked: r ? !o : o, ...i }),
    n && /* @__PURE__ */ Oe.jsx("span", { style: { marginLeft: 5 }, children: n })
  ] });
};
var kY = {}, sVe = function t(e, n) {
  if (e === n)
    return !0;
  if (e && n && typeof e == "object" && typeof n == "object") {
    if (e.constructor !== n.constructor)
      return !1;
    var r, i, o;
    if (Array.isArray(e)) {
      if (r = e.length, r != n.length)
        return !1;
      for (i = r; i-- !== 0; )
        if (!t(e[i], n[i]))
          return !1;
      return !0;
    }
    if (e.constructor === RegExp)
      return e.source === n.source && e.flags === n.flags;
    if (e.valueOf !== Object.prototype.valueOf)
      return e.valueOf() === n.valueOf();
    if (e.toString !== Object.prototype.toString)
      return e.toString() === n.toString();
    if (o = Object.keys(e), r = o.length, r !== Object.keys(n).length)
      return !1;
    for (i = r; i-- !== 0; )
      if (!Object.prototype.hasOwnProperty.call(n, o[i]))
        return !1;
    for (i = r; i-- !== 0; ) {
      var a = o[i];
      if (!t(e[a], n[a]))
        return !1;
    }
    return !0;
  }
  return e !== e && n !== n;
}, uVe = ft && ft.__extends || /* @__PURE__ */ function() {
  var t = function(e, n) {
    return t = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(r, i) {
      r.__proto__ = i;
    } || function(r, i) {
      for (var o in i)
        Object.prototype.hasOwnProperty.call(i, o) && (r[o] = i[o]);
    }, t(e, n);
  };
  return function(e, n) {
    if (typeof n != "function" && n !== null)
      throw new TypeError("Class extends value " + String(n) + " is not a constructor or null");
    t(e, n);
    function r() {
      this.constructor = e;
    }
    e.prototype = n === null ? Object.create(n) : (r.prototype = n.prototype, new r());
  };
}(), Fx = ft && ft.__assign || function() {
  return Fx = Object.assign || function(t) {
    for (var e, n = 1, r = arguments.length; n < r; n++) {
      e = arguments[n];
      for (var i in e)
        Object.prototype.hasOwnProperty.call(e, i) && (t[i] = e[i]);
    }
    return t;
  }, Fx.apply(this, arguments);
}, lVe = ft && ft.__createBinding || (Object.create ? function(t, e, n, r) {
  r === void 0 && (r = n);
  var i = Object.getOwnPropertyDescriptor(e, n);
  (!i || ("get" in i ? !e.__esModule : i.writable || i.configurable)) && (i = { enumerable: !0, get: function() {
    return e[n];
  } }), Object.defineProperty(t, r, i);
} : function(t, e, n, r) {
  r === void 0 && (r = n), t[r] = e[n];
}), cVe = ft && ft.__setModuleDefault || (Object.create ? function(t, e) {
  Object.defineProperty(t, "default", { enumerable: !0, value: e });
} : function(t, e) {
  t.default = e;
}), RY = ft && ft.__importStar || function(t) {
  if (t && t.__esModule)
    return t;
  var e = {};
  if (t != null)
    for (var n in t)
      n !== "default" && Object.prototype.hasOwnProperty.call(t, n) && lVe(e, t, n);
  return cVe(e, t), e;
}, dVe = ft && ft.__rest || function(t, e) {
  var n = {};
  for (var r in t)
    Object.prototype.hasOwnProperty.call(t, r) && e.indexOf(r) < 0 && (n[r] = t[r]);
  if (t != null && typeof Object.getOwnPropertySymbols == "function")
    for (var i = 0, r = Object.getOwnPropertySymbols(t); i < r.length; i++)
      e.indexOf(r[i]) < 0 && Object.prototype.propertyIsEnumerable.call(t, r[i]) && (n[r[i]] = t[r[i]]);
  return n;
}, fVe = ft && ft.__importDefault || function(t) {
  return t && t.__esModule ? t : { default: t };
};
Object.defineProperty(kY, "__esModule", { value: !0 });
var _3 = RY(O), hVe = fVe(sVe), Fu = RY(tY);
function CD(t) {
  return t && t.replace(/&nbsp;|\u202F|\u00A0/g, " ").replace(/<br \/>/g, "<br>");
}
function pVe(t) {
  var e = document.createTextNode("");
  t.appendChild(e);
  var n = document.activeElement === t;
  if (e !== null && e.nodeValue !== null && n) {
    var r = window.getSelection();
    if (r !== null) {
      var i = document.createRange();
      i.setStart(e, e.nodeValue.length), i.collapse(!0), r.removeAllRanges(), r.addRange(i);
    }
    t instanceof HTMLElement && t.focus();
  }
}
var gVe = (
  /** @class */
  function(t) {
    uVe(e, t);
    function e() {
      var n = t !== null && t.apply(this, arguments) || this;
      return n.lastHtml = n.props.html, n.el = typeof n.props.innerRef == "function" ? { current: null } : _3.createRef(), n.getEl = function() {
        return (n.props.innerRef && typeof n.props.innerRef != "function" ? n.props.innerRef : n.el).current;
      }, n.emitChange = function(r) {
        var i = n.getEl();
        if (i) {
          var o = i.innerHTML;
          if (n.props.onChange && o !== n.lastHtml) {
            var a = Object.assign({}, r, {
              target: {
                value: o
              }
            });
            n.props.onChange(a);
          }
          n.lastHtml = o;
        }
      }, n;
    }
    return e.prototype.render = function() {
      var n = this, r = this.props, i = r.tagName, o = r.html, a = r.innerRef, s = dVe(r, ["tagName", "html", "innerRef"]);
      return _3.createElement(i || "div", Fx(Fx({}, s), { ref: typeof a == "function" ? function(u) {
        a(u), n.el.current = u;
      } : a || this.el, onInput: this.emitChange, onBlur: this.props.onBlur || this.emitChange, onKeyUp: this.props.onKeyUp || this.emitChange, onKeyDown: this.props.onKeyDown || this.emitChange, contentEditable: !this.props.disabled, dangerouslySetInnerHTML: { __html: o } }), this.props.children);
    }, e.prototype.shouldComponentUpdate = function(n) {
      var r = this.props, i = this.getEl();
      return !i || CD(n.html) !== CD(i.innerHTML) ? !0 : r.disabled !== n.disabled || r.tagName !== n.tagName || r.className !== n.className || r.innerRef !== n.innerRef || r.placeholder !== n.placeholder || !(0, hVe.default)(r.style, n.style);
    }, e.prototype.componentDidUpdate = function() {
      var n = this.getEl();
      n && (this.props.html !== n.innerHTML && (n.innerHTML = this.props.html), this.lastHtml = this.props.html, pVe(n));
    }, e.propTypes = {
      html: Fu.string.isRequired,
      onChange: Fu.func,
      disabled: Fu.bool,
      tagName: Fu.string,
      className: Fu.string,
      style: Fu.object,
      innerRef: Fu.oneOfType([
        Fu.object,
        Fu.func
      ])
    }, e;
  }(_3.Component)
), mVe = kY.default = gVe, $Y = {}, q0 = {}, U9 = {}, Q0 = {}, X9 = {};
Object.defineProperty(X9, "__esModule", { value: !0 });
X9.default = new Uint16Array(
  // prettier-ignore
  'ᵁ<Õıʊҝջאٵ۞ޢߖࠏ੊ઑඡ๭༉༦჊ረዡᐕᒝᓃᓟᔥ\0\0\0\0\0\0ᕫᛍᦍᰒᷝ὾⁠↰⊍⏀⏻⑂⠤⤒ⴈ⹈⿎〖㊺㘹㞬㣾㨨㩱㫠㬮ࠀEMabcfglmnoprstu\\bfms¦³¹ÈÏlig耻Æ䃆P耻&䀦cute耻Á䃁reve;䄂Āiyx}rc耻Â䃂;䐐r;쀀𝔄rave耻À䃀pha;䎑acr;䄀d;橓Āgp¡on;䄄f;쀀𝔸plyFunction;恡ing耻Å䃅Ācs¾Ãr;쀀𝒜ign;扔ilde耻Ã䃃ml耻Ä䃄ЀaceforsuåûþėĜĢħĪĀcrêòkslash;或Ŷöø;櫧ed;挆y;䐑ƀcrtąċĔause;戵noullis;愬a;䎒r;쀀𝔅pf;쀀𝔹eve;䋘còēmpeq;扎܀HOacdefhilorsuōőŖƀƞƢƵƷƺǜȕɳɸɾcy;䐧PY耻©䂩ƀcpyŝŢźute;䄆Ā;iŧŨ拒talDifferentialD;慅leys;愭ȀaeioƉƎƔƘron;䄌dil耻Ç䃇rc;䄈nint;戰ot;䄊ĀdnƧƭilla;䂸terDot;䂷òſi;䎧rcleȀDMPTǇǋǑǖot;抙inus;抖lus;投imes;抗oĀcsǢǸkwiseContourIntegral;戲eCurlyĀDQȃȏoubleQuote;思uote;怙ȀlnpuȞȨɇɕonĀ;eȥȦ户;橴ƀgitȯȶȺruent;扡nt;戯ourIntegral;戮ĀfrɌɎ;愂oduct;成nterClockwiseContourIntegral;戳oss;樯cr;쀀𝒞pĀ;Cʄʅ拓ap;才րDJSZacefiosʠʬʰʴʸˋ˗ˡ˦̳ҍĀ;oŹʥtrahd;椑cy;䐂cy;䐅cy;䐏ƀgrsʿ˄ˇger;怡r;憡hv;櫤Āayː˕ron;䄎;䐔lĀ;t˝˞戇a;䎔r;쀀𝔇Āaf˫̧Ācm˰̢riticalȀADGT̖̜̀̆cute;䂴oŴ̋̍;䋙bleAcute;䋝rave;䁠ilde;䋜ond;拄ferentialD;慆Ѱ̽\0\0\0͔͂\0Ѕf;쀀𝔻ƀ;DE͈͉͍䂨ot;惜qual;扐blèCDLRUVͣͲ΂ϏϢϸontourIntegraìȹoɴ͹\0\0ͻ»͉nArrow;懓Āeo·ΤftƀARTΐΖΡrrow;懐ightArrow;懔eåˊngĀLRΫτeftĀARγιrrow;柸ightArrow;柺ightArrow;柹ightĀATϘϞrrow;懒ee;抨pɁϩ\0\0ϯrrow;懑ownArrow;懕erticalBar;戥ǹABLRTaВЪаўѿͼrrowƀ;BUНОТ憓ar;椓pArrow;懵reve;䌑eft˒к\0ц\0ѐightVector;楐eeVector;楞ectorĀ;Bљњ憽ar;楖ightǔѧ\0ѱeeVector;楟ectorĀ;BѺѻ懁ar;楗eeĀ;A҆҇护rrow;憧ĀctҒҗr;쀀𝒟rok;䄐ࠀNTacdfglmopqstuxҽӀӄӋӞӢӧӮӵԡԯԶՒ՝ՠեG;䅊H耻Ð䃐cute耻É䃉ƀaiyӒӗӜron;䄚rc耻Ê䃊;䐭ot;䄖r;쀀𝔈rave耻È䃈ement;戈ĀapӺӾcr;䄒tyɓԆ\0\0ԒmallSquare;旻erySmallSquare;斫ĀgpԦԪon;䄘f;쀀𝔼silon;䎕uĀaiԼՉlĀ;TՂՃ橵ilde;扂librium;懌Āci՗՚r;愰m;橳a;䎗ml耻Ë䃋Āipժկsts;戃onentialE;慇ʀcfiosօֈ֍ֲ׌y;䐤r;쀀𝔉lledɓ֗\0\0֣mallSquare;旼erySmallSquare;斪Ͱֺ\0ֿ\0\0ׄf;쀀𝔽All;戀riertrf;愱cò׋؀JTabcdfgorstר׬ׯ׺؀ؒؖ؛؝أ٬ٲcy;䐃耻>䀾mmaĀ;d׷׸䎓;䏜reve;䄞ƀeiy؇،ؐdil;䄢rc;䄜;䐓ot;䄠r;쀀𝔊;拙pf;쀀𝔾eater̀EFGLSTصلَٖٛ٦qualĀ;Lؾؿ扥ess;招ullEqual;执reater;檢ess;扷lantEqual;橾ilde;扳cr;쀀𝒢;扫ЀAacfiosuڅڋږڛڞڪھۊRDcy;䐪Āctڐڔek;䋇;䁞irc;䄤r;愌lbertSpace;愋ǰگ\0ڲf;愍izontalLine;攀Āctۃۅòکrok;䄦mpńېۘownHumðįqual;扏܀EJOacdfgmnostuۺ۾܃܇܎ܚܞܡܨ݄ݸދޏޕcy;䐕lig;䄲cy;䐁cute耻Í䃍Āiyܓܘrc耻Î䃎;䐘ot;䄰r;愑rave耻Ì䃌ƀ;apܠܯܿĀcgܴܷr;䄪inaryI;慈lieóϝǴ݉\0ݢĀ;eݍݎ戬Āgrݓݘral;戫section;拂isibleĀCTݬݲomma;恣imes;恢ƀgptݿރވon;䄮f;쀀𝕀a;䎙cr;愐ilde;䄨ǫޚ\0ޞcy;䐆l耻Ï䃏ʀcfosuެ޷޼߂ߐĀiyޱ޵rc;䄴;䐙r;쀀𝔍pf;쀀𝕁ǣ߇\0ߌr;쀀𝒥rcy;䐈kcy;䐄΀HJacfosߤߨ߽߬߱ࠂࠈcy;䐥cy;䐌ppa;䎚Āey߶߻dil;䄶;䐚r;쀀𝔎pf;쀀𝕂cr;쀀𝒦րJTaceflmostࠥࠩࠬࡐࡣ঳সে্਷ੇcy;䐉耻<䀼ʀcmnpr࠷࠼ࡁࡄࡍute;䄹bda;䎛g;柪lacetrf;愒r;憞ƀaeyࡗ࡜ࡡron;䄽dil;䄻;䐛Āfsࡨ॰tԀACDFRTUVarࡾࢩࢱࣦ࣠ࣼयज़ΐ४Ānrࢃ࢏gleBracket;柨rowƀ;BR࢙࢚࢞憐ar;懤ightArrow;懆eiling;挈oǵࢷ\0ࣃbleBracket;柦nǔࣈ\0࣒eeVector;楡ectorĀ;Bࣛࣜ懃ar;楙loor;挊ightĀAV࣯ࣵrrow;憔ector;楎Āerँगeƀ;AVउऊऐ抣rrow;憤ector;楚iangleƀ;BEतथऩ抲ar;槏qual;抴pƀDTVषूौownVector;楑eeVector;楠ectorĀ;Bॖॗ憿ar;楘ectorĀ;B॥०憼ar;楒ightáΜs̀EFGLSTॾঋকঝঢভqualGreater;拚ullEqual;扦reater;扶ess;檡lantEqual;橽ilde;扲r;쀀𝔏Ā;eঽা拘ftarrow;懚idot;䄿ƀnpw৔ਖਛgȀLRlr৞৷ਂਐeftĀAR০৬rrow;柵ightArrow;柷ightArrow;柶eftĀarγਊightáοightáϊf;쀀𝕃erĀLRਢਬeftArrow;憙ightArrow;憘ƀchtਾੀੂòࡌ;憰rok;䅁;扪Ѐacefiosuਗ਼੝੠੷੼અઋ઎p;椅y;䐜Ādl੥੯iumSpace;恟lintrf;愳r;쀀𝔐nusPlus;戓pf;쀀𝕄cò੶;䎜ҀJacefostuણધભીଔଙඑ඗ඞcy;䐊cute;䅃ƀaey઴હાron;䅇dil;䅅;䐝ƀgswે૰଎ativeƀMTV૓૟૨ediumSpace;怋hiĀcn૦૘ë૙eryThiî૙tedĀGL૸ଆreaterGreateòٳessLesóੈLine;䀊r;쀀𝔑ȀBnptଢନଷ଺reak;恠BreakingSpace;䂠f;愕ڀ;CDEGHLNPRSTV୕ୖ୪୼஡௫ఄ౞಄ದ೘ൡඅ櫬Āou୛୤ngruent;扢pCap;扭oubleVerticalBar;戦ƀlqxஃஊ஛ement;戉ualĀ;Tஒஓ扠ilde;쀀≂̸ists;戄reater΀;EFGLSTஶஷ஽௉௓௘௥扯qual;扱ullEqual;쀀≧̸reater;쀀≫̸ess;批lantEqual;쀀⩾̸ilde;扵umpń௲௽ownHump;쀀≎̸qual;쀀≏̸eĀfsఊధtTriangleƀ;BEచఛడ拪ar;쀀⧏̸qual;括s̀;EGLSTవశ఼ౄోౘ扮qual;扰reater;扸ess;쀀≪̸lantEqual;쀀⩽̸ilde;扴estedĀGL౨౹reaterGreater;쀀⪢̸essLess;쀀⪡̸recedesƀ;ESಒಓಛ技qual;쀀⪯̸lantEqual;拠ĀeiಫಹverseElement;戌ghtTriangleƀ;BEೋೌ೒拫ar;쀀⧐̸qual;拭ĀquೝഌuareSuĀbp೨೹setĀ;E೰ೳ쀀⊏̸qual;拢ersetĀ;Eഃആ쀀⊐̸qual;拣ƀbcpഓതൎsetĀ;Eഛഞ쀀⊂⃒qual;抈ceedsȀ;ESTലള഻െ抁qual;쀀⪰̸lantEqual;拡ilde;쀀≿̸ersetĀ;E൘൛쀀⊃⃒qual;抉ildeȀ;EFT൮൯൵ൿ扁qual;扄ullEqual;扇ilde;扉erticalBar;戤cr;쀀𝒩ilde耻Ñ䃑;䎝܀Eacdfgmoprstuvලෂ෉෕ෛ෠෧෼ขภยา฿ไlig;䅒cute耻Ó䃓Āiy෎ීrc耻Ô䃔;䐞blac;䅐r;쀀𝔒rave耻Ò䃒ƀaei෮ෲ෶cr;䅌ga;䎩cron;䎟pf;쀀𝕆enCurlyĀDQฎบoubleQuote;怜uote;怘;橔Āclวฬr;쀀𝒪ash耻Ø䃘iŬื฼de耻Õ䃕es;樷ml耻Ö䃖erĀBP๋๠Āar๐๓r;怾acĀek๚๜;揞et;掴arenthesis;揜Ҁacfhilors๿ງຊຏຒດຝະ໼rtialD;戂y;䐟r;쀀𝔓i;䎦;䎠usMinus;䂱Āipຢອncareplanåڝf;愙Ȁ;eio຺ູ໠໤檻cedesȀ;EST່້໏໚扺qual;檯lantEqual;扼ilde;找me;怳Ādp໩໮uct;戏ortionĀ;aȥ໹l;戝Āci༁༆r;쀀𝒫;䎨ȀUfos༑༖༛༟OT耻"䀢r;쀀𝔔pf;愚cr;쀀𝒬؀BEacefhiorsu༾གྷཇའཱིྦྷྪྭ႖ႩႴႾarr;椐G耻®䂮ƀcnrཎནབute;䅔g;柫rĀ;tཛྷཝ憠l;椖ƀaeyཧཬཱron;䅘dil;䅖;䐠Ā;vླྀཹ愜erseĀEUྂྙĀlq྇ྎement;戋uilibrium;懋pEquilibrium;楯r»ཹo;䎡ghtЀACDFTUVa࿁࿫࿳ဢဨၛႇϘĀnr࿆࿒gleBracket;柩rowƀ;BL࿜࿝࿡憒ar;懥eftArrow;懄eiling;按oǵ࿹\0စbleBracket;柧nǔည\0နeeVector;楝ectorĀ;Bဝသ懂ar;楕loor;挋Āerိ၃eƀ;AVဵံြ抢rrow;憦ector;楛iangleƀ;BEၐၑၕ抳ar;槐qual;抵pƀDTVၣၮၸownVector;楏eeVector;楜ectorĀ;Bႂႃ憾ar;楔ectorĀ;B႑႒懀ar;楓Āpuႛ႞f;愝ndImplies;楰ightarrow;懛ĀchႹႼr;愛;憱leDelayed;槴ڀHOacfhimoqstuფჱჷჽᄙᄞᅑᅖᅡᅧᆵᆻᆿĀCcჩხHcy;䐩y;䐨FTcy;䐬cute;䅚ʀ;aeiyᄈᄉᄎᄓᄗ檼ron;䅠dil;䅞rc;䅜;䐡r;쀀𝔖ortȀDLRUᄪᄴᄾᅉownArrow»ОeftArrow»࢚ightArrow»࿝pArrow;憑gma;䎣allCircle;战pf;쀀𝕊ɲᅭ\0\0ᅰt;戚areȀ;ISUᅻᅼᆉᆯ斡ntersection;抓uĀbpᆏᆞsetĀ;Eᆗᆘ抏qual;抑ersetĀ;Eᆨᆩ抐qual;抒nion;抔cr;쀀𝒮ar;拆ȀbcmpᇈᇛሉላĀ;sᇍᇎ拐etĀ;Eᇍᇕqual;抆ĀchᇠህeedsȀ;ESTᇭᇮᇴᇿ扻qual;檰lantEqual;扽ilde;承Tháྌ;我ƀ;esሒሓሣ拑rsetĀ;Eሜም抃qual;抇et»ሓրHRSacfhiorsሾቄ቉ቕ቞ቱቶኟዂወዑORN耻Þ䃞ADE;愢ĀHc቎ቒcy;䐋y;䐦Ābuቚቜ;䀉;䎤ƀaeyብቪቯron;䅤dil;䅢;䐢r;쀀𝔗Āeiቻ኉ǲኀ\0ኇefore;戴a;䎘Ācn኎ኘkSpace;쀀  Space;怉ldeȀ;EFTካኬኲኼ戼qual;扃ullEqual;扅ilde;扈pf;쀀𝕋ipleDot;惛Āctዖዛr;쀀𝒯rok;䅦ૡዷጎጚጦ\0ጬጱ\0\0\0\0\0ጸጽ፷ᎅ\0᏿ᐄᐊᐐĀcrዻጁute耻Ú䃚rĀ;oጇገ憟cir;楉rǣጓ\0጖y;䐎ve;䅬Āiyጞጣrc耻Û䃛;䐣blac;䅰r;쀀𝔘rave耻Ù䃙acr;䅪Ādiፁ፩erĀBPፈ፝Āarፍፐr;䁟acĀekፗፙ;揟et;掵arenthesis;揝onĀ;P፰፱拃lus;抎Āgp፻፿on;䅲f;쀀𝕌ЀADETadps᎕ᎮᎸᏄϨᏒᏗᏳrrowƀ;BDᅐᎠᎤar;椒ownArrow;懅ownArrow;憕quilibrium;楮eeĀ;AᏋᏌ报rrow;憥ownáϳerĀLRᏞᏨeftArrow;憖ightArrow;憗iĀ;lᏹᏺ䏒on;䎥ing;䅮cr;쀀𝒰ilde;䅨ml耻Ü䃜ҀDbcdefosvᐧᐬᐰᐳᐾᒅᒊᒐᒖash;披ar;櫫y;䐒ashĀ;lᐻᐼ抩;櫦Āerᑃᑅ;拁ƀbtyᑌᑐᑺar;怖Ā;iᑏᑕcalȀBLSTᑡᑥᑪᑴar;戣ine;䁼eparator;杘ilde;所ThinSpace;怊r;쀀𝔙pf;쀀𝕍cr;쀀𝒱dash;抪ʀcefosᒧᒬᒱᒶᒼirc;䅴dge;拀r;쀀𝔚pf;쀀𝕎cr;쀀𝒲Ȁfiosᓋᓐᓒᓘr;쀀𝔛;䎞pf;쀀𝕏cr;쀀𝒳ҀAIUacfosuᓱᓵᓹᓽᔄᔏᔔᔚᔠcy;䐯cy;䐇cy;䐮cute耻Ý䃝Āiyᔉᔍrc;䅶;䐫r;쀀𝔜pf;쀀𝕐cr;쀀𝒴ml;䅸ЀHacdefosᔵᔹᔿᕋᕏᕝᕠᕤcy;䐖cute;䅹Āayᕄᕉron;䅽;䐗ot;䅻ǲᕔ\0ᕛoWidtè૙a;䎖r;愨pf;愤cr;쀀𝒵௡ᖃᖊᖐ\0ᖰᖶᖿ\0\0\0\0ᗆᗛᗫᙟ᙭\0ᚕ᚛ᚲᚹ\0ᚾcute耻á䃡reve;䄃̀;Ediuyᖜᖝᖡᖣᖨᖭ戾;쀀∾̳;房rc耻â䃢te肻´̆;䐰lig耻æ䃦Ā;r²ᖺ;쀀𝔞rave耻à䃠ĀepᗊᗖĀfpᗏᗔsym;愵èᗓha;䎱ĀapᗟcĀclᗤᗧr;䄁g;樿ɤᗰ\0\0ᘊʀ;adsvᗺᗻᗿᘁᘇ戧nd;橕;橜lope;橘;橚΀;elmrszᘘᘙᘛᘞᘿᙏᙙ戠;榤e»ᘙsdĀ;aᘥᘦ戡ѡᘰᘲᘴᘶᘸᘺᘼᘾ;榨;榩;榪;榫;榬;榭;榮;榯tĀ;vᙅᙆ戟bĀ;dᙌᙍ抾;榝Āptᙔᙗh;戢»¹arr;捼Āgpᙣᙧon;䄅f;쀀𝕒΀;Eaeiop዁ᙻᙽᚂᚄᚇᚊ;橰cir;橯;扊d;手s;䀧roxĀ;e዁ᚒñᚃing耻å䃥ƀctyᚡᚦᚨr;쀀𝒶;䀪mpĀ;e዁ᚯñʈilde耻ã䃣ml耻ä䃤Āciᛂᛈoninôɲnt;樑ࠀNabcdefiklnoprsu᛭ᛱᜰ᜼ᝃᝈ᝸᝽០៦ᠹᡐᜍ᤽᥈ᥰot;櫭Ācrᛶ᜞kȀcepsᜀᜅᜍᜓong;扌psilon;䏶rime;怵imĀ;e᜚᜛戽q;拍Ŷᜢᜦee;抽edĀ;gᜬᜭ挅e»ᜭrkĀ;t፜᜷brk;掶Āoyᜁᝁ;䐱quo;怞ʀcmprtᝓ᝛ᝡᝤᝨausĀ;eĊĉptyv;榰séᜌnoõēƀahwᝯ᝱ᝳ;䎲;愶een;扬r;쀀𝔟g΀costuvwឍឝឳេ៕៛៞ƀaiuបពរðݠrc;旯p»፱ƀdptឤឨឭot;樀lus;樁imes;樂ɱឹ\0\0ើcup;樆ar;昅riangleĀdu៍្own;施p;斳plus;樄eåᑄåᒭarow;植ƀako៭ᠦᠵĀcn៲ᠣkƀlst៺֫᠂ozenge;槫riangleȀ;dlr᠒᠓᠘᠝斴own;斾eft;旂ight;斸k;搣Ʊᠫ\0ᠳƲᠯ\0ᠱ;斒;斑4;斓ck;斈ĀeoᠾᡍĀ;qᡃᡆ쀀=⃥uiv;쀀≡⃥t;挐Ȁptwxᡙᡞᡧᡬf;쀀𝕓Ā;tᏋᡣom»Ꮜtie;拈؀DHUVbdhmptuvᢅᢖᢪᢻᣗᣛᣬ᣿ᤅᤊᤐᤡȀLRlrᢎᢐᢒᢔ;敗;敔;敖;敓ʀ;DUduᢡᢢᢤᢦᢨ敐;敦;敩;敤;敧ȀLRlrᢳᢵᢷᢹ;敝;敚;敜;教΀;HLRhlrᣊᣋᣍᣏᣑᣓᣕ救;敬;散;敠;敫;敢;敟ox;槉ȀLRlrᣤᣦᣨᣪ;敕;敒;攐;攌ʀ;DUduڽ᣷᣹᣻᣽;敥;敨;攬;攴inus;抟lus;択imes;抠ȀLRlrᤙᤛᤝ᤟;敛;敘;攘;攔΀;HLRhlrᤰᤱᤳᤵᤷ᤻᤹攂;敪;敡;敞;攼;攤;攜Āevģ᥂bar耻¦䂦Ȁceioᥑᥖᥚᥠr;쀀𝒷mi;恏mĀ;e᜚᜜lƀ;bhᥨᥩᥫ䁜;槅sub;柈Ŭᥴ᥾lĀ;e᥹᥺怢t»᥺pƀ;Eeįᦅᦇ;檮Ā;qۜۛೡᦧ\0᧨ᨑᨕᨲ\0ᨷᩐ\0\0᪴\0\0᫁\0\0ᬡᬮ᭍᭒\0᯽\0ᰌƀcpr᦭ᦲ᧝ute;䄇̀;abcdsᦿᧀᧄ᧊᧕᧙戩nd;橄rcup;橉Āau᧏᧒p;橋p;橇ot;橀;쀀∩︀Āeo᧢᧥t;恁îړȀaeiu᧰᧻ᨁᨅǰ᧵\0᧸s;橍on;䄍dil耻ç䃧rc;䄉psĀ;sᨌᨍ橌m;橐ot;䄋ƀdmnᨛᨠᨦil肻¸ƭptyv;榲t脀¢;eᨭᨮ䂢räƲr;쀀𝔠ƀceiᨽᩀᩍy;䑇ckĀ;mᩇᩈ朓ark»ᩈ;䏇r΀;Ecefms᩟᩠ᩢᩫ᪤᪪᪮旋;槃ƀ;elᩩᩪᩭ䋆q;扗eɡᩴ\0\0᪈rrowĀlr᩼᪁eft;憺ight;憻ʀRSacd᪒᪔᪖᪚᪟»ཇ;擈st;抛irc;抚ash;抝nint;樐id;櫯cir;槂ubsĀ;u᪻᪼晣it»᪼ˬ᫇᫔᫺\0ᬊonĀ;eᫍᫎ䀺Ā;qÇÆɭ᫙\0\0᫢aĀ;t᫞᫟䀬;䁀ƀ;fl᫨᫩᫫戁îᅠeĀmx᫱᫶ent»᫩eóɍǧ᫾\0ᬇĀ;dኻᬂot;橭nôɆƀfryᬐᬔᬗ;쀀𝕔oäɔ脀©;sŕᬝr;愗Āaoᬥᬩrr;憵ss;朗Ācuᬲᬷr;쀀𝒸Ābpᬼ᭄Ā;eᭁᭂ櫏;櫑Ā;eᭉᭊ櫐;櫒dot;拯΀delprvw᭠᭬᭷ᮂᮬᯔ᯹arrĀlr᭨᭪;椸;椵ɰ᭲\0\0᭵r;拞c;拟arrĀ;p᭿ᮀ憶;椽̀;bcdosᮏᮐᮖᮡᮥᮨ截rcap;橈Āauᮛᮞp;橆p;橊ot;抍r;橅;쀀∪︀Ȁalrv᮵ᮿᯞᯣrrĀ;mᮼᮽ憷;椼yƀevwᯇᯔᯘqɰᯎ\0\0ᯒreã᭳uã᭵ee;拎edge;拏en耻¤䂤earrowĀlrᯮ᯳eft»ᮀight»ᮽeäᯝĀciᰁᰇoninôǷnt;戱lcty;挭ঀAHabcdefhijlorstuwz᰸᰻᰿ᱝᱩᱵᲊᲞᲬᲷ᳻᳿ᴍᵻᶑᶫᶻ᷆᷍rò΁ar;楥Ȁglrs᱈ᱍ᱒᱔ger;怠eth;愸òᄳhĀ;vᱚᱛ怐»ऊūᱡᱧarow;椏aã̕Āayᱮᱳron;䄏;䐴ƀ;ao̲ᱼᲄĀgrʿᲁr;懊tseq;橷ƀglmᲑᲔᲘ耻°䂰ta;䎴ptyv;榱ĀirᲣᲨsht;楿;쀀𝔡arĀlrᲳᲵ»ࣜ»သʀaegsv᳂͸᳖᳜᳠mƀ;oș᳊᳔ndĀ;ș᳑uit;晦amma;䏝in;拲ƀ;io᳧᳨᳸䃷de脀÷;o᳧ᳰntimes;拇nø᳷cy;䑒cɯᴆ\0\0ᴊrn;挞op;挍ʀlptuwᴘᴝᴢᵉᵕlar;䀤f;쀀𝕕ʀ;emps̋ᴭᴷᴽᵂqĀ;d͒ᴳot;扑inus;戸lus;戔quare;抡blebarwedgåúnƀadhᄮᵝᵧownarrowóᲃarpoonĀlrᵲᵶefôᲴighôᲶŢᵿᶅkaro÷གɯᶊ\0\0ᶎrn;挟op;挌ƀcotᶘᶣᶦĀryᶝᶡ;쀀𝒹;䑕l;槶rok;䄑Ādrᶰᶴot;拱iĀ;fᶺ᠖斿Āah᷀᷃ròЩaòྦangle;榦Āci᷒ᷕy;䑟grarr;柿ऀDacdefglmnopqrstuxḁḉḙḸոḼṉṡṾấắẽỡἪἷὄ὎὚ĀDoḆᴴoôᲉĀcsḎḔute耻é䃩ter;橮ȀaioyḢḧḱḶron;䄛rĀ;cḭḮ扖耻ê䃪lon;払;䑍ot;䄗ĀDrṁṅot;扒;쀀𝔢ƀ;rsṐṑṗ檚ave耻è䃨Ā;dṜṝ檖ot;檘Ȁ;ilsṪṫṲṴ檙nters;揧;愓Ā;dṹṺ檕ot;檗ƀapsẅẉẗcr;䄓tyƀ;svẒẓẕ戅et»ẓpĀ1;ẝẤĳạả;怄;怅怃ĀgsẪẬ;䅋p;怂ĀgpẴẸon;䄙f;쀀𝕖ƀalsỄỎỒrĀ;sỊị拕l;槣us;橱iƀ;lvỚớở䎵on»ớ;䏵ȀcsuvỪỳἋἣĀioữḱrc»Ḯɩỹ\0\0ỻíՈantĀglἂἆtr»ṝess»Ṻƀaeiἒ἖Ἒls;䀽st;扟vĀ;DȵἠD;橸parsl;槥ĀDaἯἳot;打rr;楱ƀcdiἾὁỸr;愯oô͒ĀahὉὋ;䎷耻ð䃰Āmrὓὗl耻ë䃫o;悬ƀcipὡὤὧl;䀡sôծĀeoὬὴctatioîՙnentialåչৡᾒ\0ᾞ\0ᾡᾧ\0\0ῆῌ\0ΐ\0ῦῪ \0 ⁚llingdotseñṄy;䑄male;晀ƀilrᾭᾳ῁lig;耀ﬃɩᾹ\0\0᾽g;耀ﬀig;耀ﬄ;쀀𝔣lig;耀ﬁlig;쀀fjƀaltῙ῜ῡt;晭ig;耀ﬂns;斱of;䆒ǰ΅\0ῳf;쀀𝕗ĀakֿῷĀ;vῼ´拔;櫙artint;樍Āao‌⁕Ācs‑⁒α‚‰‸⁅⁈\0⁐β•‥‧‪‬\0‮耻½䂽;慓耻¼䂼;慕;慙;慛Ƴ‴\0‶;慔;慖ʴ‾⁁\0\0⁃耻¾䂾;慗;慜5;慘ƶ⁌\0⁎;慚;慝8;慞l;恄wn;挢cr;쀀𝒻ࢀEabcdefgijlnorstv₂₉₟₥₰₴⃰⃵⃺⃿℃ℒℸ̗ℾ⅒↞Ā;lٍ₇;檌ƀcmpₐₕ₝ute;䇵maĀ;dₜ᳚䎳;檆reve;䄟Āiy₪₮rc;䄝;䐳ot;䄡Ȁ;lqsؾق₽⃉ƀ;qsؾٌ⃄lanô٥Ȁ;cdl٥⃒⃥⃕c;檩otĀ;o⃜⃝檀Ā;l⃢⃣檂;檄Ā;e⃪⃭쀀⋛︀s;檔r;쀀𝔤Ā;gٳ؛mel;愷cy;䑓Ȁ;Eajٚℌℎℐ;檒;檥;檤ȀEaesℛℝ℩ℴ;扩pĀ;p℣ℤ檊rox»ℤĀ;q℮ℯ檈Ā;q℮ℛim;拧pf;쀀𝕘Āci⅃ⅆr;愊mƀ;el٫ⅎ⅐;檎;檐茀>;cdlqr׮ⅠⅪⅮⅳⅹĀciⅥⅧ;檧r;橺ot;拗Par;榕uest;橼ʀadelsↄⅪ←ٖ↛ǰ↉\0↎proø₞r;楸qĀlqؿ↖lesó₈ií٫Āen↣↭rtneqq;쀀≩︀Å↪ԀAabcefkosy⇄⇇⇱⇵⇺∘∝∯≨≽ròΠȀilmr⇐⇔⇗⇛rsðᒄf»․ilôکĀdr⇠⇤cy;䑊ƀ;cwࣴ⇫⇯ir;楈;憭ar;意irc;䄥ƀalr∁∎∓rtsĀ;u∉∊晥it»∊lip;怦con;抹r;쀀𝔥sĀew∣∩arow;椥arow;椦ʀamopr∺∾≃≞≣rr;懿tht;戻kĀlr≉≓eftarrow;憩ightarrow;憪f;쀀𝕙bar;怕ƀclt≯≴≸r;쀀𝒽asè⇴rok;䄧Ābp⊂⊇ull;恃hen»ᱛૡ⊣\0⊪\0⊸⋅⋎\0⋕⋳\0\0⋸⌢⍧⍢⍿\0⎆⎪⎴cute耻í䃭ƀ;iyݱ⊰⊵rc耻î䃮;䐸Ācx⊼⊿y;䐵cl耻¡䂡ĀfrΟ⋉;쀀𝔦rave耻ì䃬Ȁ;inoܾ⋝⋩⋮Āin⋢⋦nt;樌t;戭fin;槜ta;愩lig;䄳ƀaop⋾⌚⌝ƀcgt⌅⌈⌗r;䄫ƀelpܟ⌏⌓inåގarôܠh;䄱f;抷ed;䆵ʀ;cfotӴ⌬⌱⌽⍁are;愅inĀ;t⌸⌹戞ie;槝doô⌙ʀ;celpݗ⍌⍐⍛⍡al;抺Āgr⍕⍙eróᕣã⍍arhk;樗rod;樼Ȁcgpt⍯⍲⍶⍻y;䑑on;䄯f;쀀𝕚a;䎹uest耻¿䂿Āci⎊⎏r;쀀𝒾nʀ;EdsvӴ⎛⎝⎡ӳ;拹ot;拵Ā;v⎦⎧拴;拳Ā;iݷ⎮lde;䄩ǫ⎸\0⎼cy;䑖l耻ï䃯̀cfmosu⏌⏗⏜⏡⏧⏵Āiy⏑⏕rc;䄵;䐹r;쀀𝔧ath;䈷pf;쀀𝕛ǣ⏬\0⏱r;쀀𝒿rcy;䑘kcy;䑔Ѐacfghjos␋␖␢␧␭␱␵␻ppaĀ;v␓␔䎺;䏰Āey␛␠dil;䄷;䐺r;쀀𝔨reen;䄸cy;䑅cy;䑜pf;쀀𝕜cr;쀀𝓀஀ABEHabcdefghjlmnoprstuv⑰⒁⒆⒍⒑┎┽╚▀♎♞♥♹♽⚚⚲⛘❝❨➋⟀⠁⠒ƀart⑷⑺⑼rò৆òΕail;椛arr;椎Ā;gঔ⒋;檋ar;楢ॣ⒥\0⒪\0⒱\0\0\0\0\0⒵Ⓔ\0ⓆⓈⓍ\0⓹ute;䄺mptyv;榴raîࡌbda;䎻gƀ;dlࢎⓁⓃ;榑åࢎ;檅uo耻«䂫rЀ;bfhlpst࢙ⓞⓦⓩ⓫⓮⓱⓵Ā;f࢝ⓣs;椟s;椝ë≒p;憫l;椹im;楳l;憢ƀ;ae⓿─┄檫il;椙Ā;s┉┊檭;쀀⪭︀ƀabr┕┙┝rr;椌rk;杲Āak┢┬cĀek┨┪;䁻;䁛Āes┱┳;榋lĀdu┹┻;榏;榍Ȁaeuy╆╋╖╘ron;䄾Ādi═╔il;䄼ìࢰâ┩;䐻Ȁcqrs╣╦╭╽a;椶uoĀ;rนᝆĀdu╲╷har;楧shar;楋h;憲ʀ;fgqs▋▌উ◳◿扤tʀahlrt▘▤▷◂◨rrowĀ;t࢙□aé⓶arpoonĀdu▯▴own»њp»०eftarrows;懇ightƀahs◍◖◞rrowĀ;sࣴࢧarpoonó྘quigarro÷⇰hreetimes;拋ƀ;qs▋ও◺lanôবʀ;cdgsব☊☍☝☨c;檨otĀ;o☔☕橿Ā;r☚☛檁;檃Ā;e☢☥쀀⋚︀s;檓ʀadegs☳☹☽♉♋pproøⓆot;拖qĀgq♃♅ôউgtò⒌ôছiíলƀilr♕࣡♚sht;楼;쀀𝔩Ā;Eজ♣;檑š♩♶rĀdu▲♮Ā;l॥♳;楪lk;斄cy;䑙ʀ;achtੈ⚈⚋⚑⚖rò◁orneòᴈard;楫ri;旺Āio⚟⚤dot;䅀ustĀ;a⚬⚭掰che»⚭ȀEaes⚻⚽⛉⛔;扨pĀ;p⛃⛄檉rox»⛄Ā;q⛎⛏檇Ā;q⛎⚻im;拦Ѐabnoptwz⛩⛴⛷✚✯❁❇❐Ānr⛮⛱g;柬r;懽rëࣁgƀlmr⛿✍✔eftĀar০✇ightá৲apsto;柼ightá৽parrowĀlr✥✩efô⓭ight;憬ƀafl✶✹✽r;榅;쀀𝕝us;樭imes;樴š❋❏st;戗áፎƀ;ef❗❘᠀旊nge»❘arĀ;l❤❥䀨t;榓ʀachmt❳❶❼➅➇ròࢨorneòᶌarĀ;d྘➃;業;怎ri;抿̀achiqt➘➝ੀ➢➮➻quo;怹r;쀀𝓁mƀ;egল➪➬;檍;檏Ābu┪➳oĀ;rฟ➹;怚rok;䅂萀<;cdhilqrࠫ⟒☹⟜⟠⟥⟪⟰Āci⟗⟙;檦r;橹reå◲mes;拉arr;楶uest;橻ĀPi⟵⟹ar;榖ƀ;ef⠀भ᠛旃rĀdu⠇⠍shar;楊har;楦Āen⠗⠡rtneqq;쀀≨︀Å⠞܀Dacdefhilnopsu⡀⡅⢂⢎⢓⢠⢥⢨⣚⣢⣤ઃ⣳⤂Dot;戺Ȁclpr⡎⡒⡣⡽r耻¯䂯Āet⡗⡙;時Ā;e⡞⡟朠se»⡟Ā;sျ⡨toȀ;dluျ⡳⡷⡻owîҌefôएðᏑker;斮Āoy⢇⢌mma;権;䐼ash;怔asuredangle»ᘦr;쀀𝔪o;愧ƀcdn⢯⢴⣉ro耻µ䂵Ȁ;acdᑤ⢽⣀⣄sôᚧir;櫰ot肻·Ƶusƀ;bd⣒ᤃ⣓戒Ā;uᴼ⣘;横ţ⣞⣡p;櫛ò−ðઁĀdp⣩⣮els;抧f;쀀𝕞Āct⣸⣽r;쀀𝓂pos»ᖝƀ;lm⤉⤊⤍䎼timap;抸ఀGLRVabcdefghijlmoprstuvw⥂⥓⥾⦉⦘⧚⧩⨕⨚⩘⩝⪃⪕⪤⪨⬄⬇⭄⭿⮮ⰴⱧⱼ⳩Āgt⥇⥋;쀀⋙̸Ā;v⥐௏쀀≫⃒ƀelt⥚⥲⥶ftĀar⥡⥧rrow;懍ightarrow;懎;쀀⋘̸Ā;v⥻ే쀀≪⃒ightarrow;懏ĀDd⦎⦓ash;抯ash;抮ʀbcnpt⦣⦧⦬⦱⧌la»˞ute;䅄g;쀀∠⃒ʀ;Eiop඄⦼⧀⧅⧈;쀀⩰̸d;쀀≋̸s;䅉roø඄urĀ;a⧓⧔普lĀ;s⧓ସǳ⧟\0⧣p肻 ଷmpĀ;e௹ఀʀaeouy⧴⧾⨃⨐⨓ǰ⧹\0⧻;橃on;䅈dil;䅆ngĀ;dൾ⨊ot;쀀⩭̸p;橂;䐽ash;怓΀;Aadqsxஒ⨩⨭⨻⩁⩅⩐rr;懗rĀhr⨳⨶k;椤Ā;oᏲᏰot;쀀≐̸uiöୣĀei⩊⩎ar;椨í஘istĀ;s஠டr;쀀𝔫ȀEest௅⩦⩹⩼ƀ;qs஼⩭௡ƀ;qs஼௅⩴lanô௢ií௪Ā;rஶ⪁»ஷƀAap⪊⪍⪑rò⥱rr;憮ar;櫲ƀ;svྍ⪜ྌĀ;d⪡⪢拼;拺cy;䑚΀AEadest⪷⪺⪾⫂⫅⫶⫹rò⥦;쀀≦̸rr;憚r;急Ȁ;fqs఻⫎⫣⫯tĀar⫔⫙rro÷⫁ightarro÷⪐ƀ;qs఻⪺⫪lanôౕĀ;sౕ⫴»శiíౝĀ;rవ⫾iĀ;eచథiäඐĀpt⬌⬑f;쀀𝕟膀¬;in⬙⬚⬶䂬nȀ;Edvஉ⬤⬨⬮;쀀⋹̸ot;쀀⋵̸ǡஉ⬳⬵;拷;拶iĀ;vಸ⬼ǡಸ⭁⭃;拾;拽ƀaor⭋⭣⭩rȀ;ast୻⭕⭚⭟lleì୻l;쀀⫽⃥;쀀∂̸lint;樔ƀ;ceಒ⭰⭳uåಥĀ;cಘ⭸Ā;eಒ⭽ñಘȀAait⮈⮋⮝⮧rò⦈rrƀ;cw⮔⮕⮙憛;쀀⤳̸;쀀↝̸ghtarrow»⮕riĀ;eೋೖ΀chimpqu⮽⯍⯙⬄୸⯤⯯Ȁ;cerല⯆ഷ⯉uå൅;쀀𝓃ortɭ⬅\0\0⯖ará⭖mĀ;e൮⯟Ā;q൴൳suĀbp⯫⯭å೸åഋƀbcp⯶ⰑⰙȀ;Ees⯿ⰀഢⰄ抄;쀀⫅̸etĀ;eഛⰋqĀ;qണⰀcĀ;eലⰗñസȀ;EesⰢⰣൟⰧ抅;쀀⫆̸etĀ;e൘ⰮqĀ;qൠⰣȀgilrⰽⰿⱅⱇìௗlde耻ñ䃱çృiangleĀlrⱒⱜeftĀ;eచⱚñదightĀ;eೋⱥñ೗Ā;mⱬⱭ䎽ƀ;esⱴⱵⱹ䀣ro;愖p;怇ҀDHadgilrsⲏⲔⲙⲞⲣⲰⲶⳓⳣash;抭arr;椄p;쀀≍⃒ash;抬ĀetⲨⲬ;쀀≥⃒;쀀>⃒nfin;槞ƀAetⲽⳁⳅrr;椂;쀀≤⃒Ā;rⳊⳍ쀀<⃒ie;쀀⊴⃒ĀAtⳘⳜrr;椃rie;쀀⊵⃒im;쀀∼⃒ƀAan⳰⳴ⴂrr;懖rĀhr⳺⳽k;椣Ā;oᏧᏥear;椧ቓ᪕\0\0\0\0\0\0\0\0\0\0\0\0\0ⴭ\0ⴸⵈⵠⵥ⵲ⶄᬇ\0\0ⶍⶫ\0ⷈⷎ\0ⷜ⸙⸫⸾⹃Ācsⴱ᪗ute耻ó䃳ĀiyⴼⵅrĀ;c᪞ⵂ耻ô䃴;䐾ʀabios᪠ⵒⵗǈⵚlac;䅑v;樸old;榼lig;䅓Ācr⵩⵭ir;榿;쀀𝔬ͯ⵹\0\0⵼\0ⶂn;䋛ave耻ò䃲;槁Ābmⶈ෴ar;榵Ȁacitⶕ⶘ⶥⶨrò᪀Āir⶝ⶠr;榾oss;榻nå๒;槀ƀaeiⶱⶵⶹcr;䅍ga;䏉ƀcdnⷀⷅǍron;䎿;榶pf;쀀𝕠ƀaelⷔ⷗ǒr;榷rp;榹΀;adiosvⷪⷫⷮ⸈⸍⸐⸖戨rò᪆Ȁ;efmⷷⷸ⸂⸅橝rĀ;oⷾⷿ愴f»ⷿ耻ª䂪耻º䂺gof;抶r;橖lope;橗;橛ƀclo⸟⸡⸧ò⸁ash耻ø䃸l;折iŬⸯ⸴de耻õ䃵esĀ;aǛ⸺s;樶ml耻ö䃶bar;挽ૡ⹞\0⹽\0⺀⺝\0⺢⺹\0\0⻋ຜ\0⼓\0\0⼫⾼\0⿈rȀ;astЃ⹧⹲຅脀¶;l⹭⹮䂶leìЃɩ⹸\0\0⹻m;櫳;櫽y;䐿rʀcimpt⺋⺏⺓ᡥ⺗nt;䀥od;䀮il;怰enk;怱r;쀀𝔭ƀimo⺨⺰⺴Ā;v⺭⺮䏆;䏕maô੶ne;明ƀ;tv⺿⻀⻈䏀chfork»´;䏖Āau⻏⻟nĀck⻕⻝kĀ;h⇴⻛;愎ö⇴sҀ;abcdemst⻳⻴ᤈ⻹⻽⼄⼆⼊⼎䀫cir;樣ir;樢Āouᵀ⼂;樥;橲n肻±ຝim;樦wo;樧ƀipu⼙⼠⼥ntint;樕f;쀀𝕡nd耻£䂣Ԁ;Eaceinosu່⼿⽁⽄⽇⾁⾉⾒⽾⾶;檳p;檷uå໙Ā;c໎⽌̀;acens່⽙⽟⽦⽨⽾pproø⽃urlyeñ໙ñ໎ƀaes⽯⽶⽺pprox;檹qq;檵im;拨iíໟmeĀ;s⾈ຮ怲ƀEas⽸⾐⽺ð⽵ƀdfp໬⾙⾯ƀals⾠⾥⾪lar;挮ine;挒urf;挓Ā;t໻⾴ï໻rel;抰Āci⿀⿅r;쀀𝓅;䏈ncsp;怈̀fiopsu⿚⋢⿟⿥⿫⿱r;쀀𝔮pf;쀀𝕢rime;恗cr;쀀𝓆ƀaeo⿸〉〓tĀei⿾々rnionóڰnt;樖stĀ;e【】䀿ñἙô༔઀ABHabcdefhilmnoprstux぀けさすムㄎㄫㅇㅢㅲㆎ㈆㈕㈤㈩㉘㉮㉲㊐㊰㊷ƀartぇおがròႳòϝail;検aròᱥar;楤΀cdenqrtとふへみわゔヌĀeuねぱ;쀀∽̱te;䅕iãᅮmptyv;榳gȀ;del࿑らるろ;榒;榥å࿑uo耻»䂻rր;abcfhlpstw࿜ガクシスゼゾダッデナp;極Ā;f࿠ゴs;椠;椳s;椞ë≝ð✮l;楅im;楴l;憣;憝Āaiパフil;椚oĀ;nホボ戶aló༞ƀabrョリヮrò៥rk;杳ĀakンヽcĀekヹ・;䁽;䁝Āes㄂㄄;榌lĀduㄊㄌ;榎;榐Ȁaeuyㄗㄜㄧㄩron;䅙Ādiㄡㄥil;䅗ì࿲âヺ;䑀Ȁclqsㄴㄷㄽㅄa;椷dhar;楩uoĀ;rȎȍh;憳ƀacgㅎㅟངlȀ;ipsླྀㅘㅛႜnåႻarôྩt;断ƀilrㅩဣㅮsht;楽;쀀𝔯ĀaoㅷㆆrĀduㅽㅿ»ѻĀ;l႑ㆄ;楬Ā;vㆋㆌ䏁;䏱ƀgns㆕ㇹㇼht̀ahlrstㆤㆰ㇂㇘㇤㇮rrowĀ;t࿜ㆭaéトarpoonĀduㆻㆿowîㅾp»႒eftĀah㇊㇐rrowó࿪arpoonóՑightarrows;應quigarro÷ニhreetimes;拌g;䋚ingdotseñἲƀahm㈍㈐㈓rò࿪aòՑ;怏oustĀ;a㈞㈟掱che»㈟mid;櫮Ȁabpt㈲㈽㉀㉒Ānr㈷㈺g;柭r;懾rëဃƀafl㉇㉊㉎r;榆;쀀𝕣us;樮imes;樵Āap㉝㉧rĀ;g㉣㉤䀩t;榔olint;樒arò㇣Ȁachq㉻㊀Ⴜ㊅quo;怺r;쀀𝓇Ābu・㊊oĀ;rȔȓƀhir㊗㊛㊠reåㇸmes;拊iȀ;efl㊪ၙᠡ㊫方tri;槎luhar;楨;愞ൡ㋕㋛㋟㌬㌸㍱\0㍺㎤\0\0㏬㏰\0㐨㑈㑚㒭㒱㓊㓱\0㘖\0\0㘳cute;䅛quï➺Ԁ;Eaceinpsyᇭ㋳㋵㋿㌂㌋㌏㌟㌦㌩;檴ǰ㋺\0㋼;檸on;䅡uåᇾĀ;dᇳ㌇il;䅟rc;䅝ƀEas㌖㌘㌛;檶p;檺im;择olint;樓iíሄ;䑁otƀ;be㌴ᵇ㌵担;橦΀Aacmstx㍆㍊㍗㍛㍞㍣㍭rr;懘rĀhr㍐㍒ë∨Ā;oਸ਼਴t耻§䂧i;䀻war;椩mĀin㍩ðnuóñt;朶rĀ;o㍶⁕쀀𝔰Ȁacoy㎂㎆㎑㎠rp;景Āhy㎋㎏cy;䑉;䑈rtɭ㎙\0\0㎜iäᑤaraì⹯耻­䂭Āgm㎨㎴maƀ;fv㎱㎲㎲䏃;䏂Ѐ;deglnprካ㏅㏉㏎㏖㏞㏡㏦ot;橪Ā;q኱ኰĀ;E㏓㏔檞;檠Ā;E㏛㏜檝;檟e;扆lus;樤arr;楲aròᄽȀaeit㏸㐈㐏㐗Āls㏽㐄lsetmé㍪hp;樳parsl;槤Ādlᑣ㐔e;挣Ā;e㐜㐝檪Ā;s㐢㐣檬;쀀⪬︀ƀflp㐮㐳㑂tcy;䑌Ā;b㐸㐹䀯Ā;a㐾㐿槄r;挿f;쀀𝕤aĀdr㑍ЂesĀ;u㑔㑕晠it»㑕ƀcsu㑠㑹㒟Āau㑥㑯pĀ;sᆈ㑫;쀀⊓︀pĀ;sᆴ㑵;쀀⊔︀uĀbp㑿㒏ƀ;esᆗᆜ㒆etĀ;eᆗ㒍ñᆝƀ;esᆨᆭ㒖etĀ;eᆨ㒝ñᆮƀ;afᅻ㒦ְrť㒫ֱ»ᅼaròᅈȀcemt㒹㒾㓂㓅r;쀀𝓈tmîñiì㐕aræᆾĀar㓎㓕rĀ;f㓔ឿ昆Āan㓚㓭ightĀep㓣㓪psiloîỠhé⺯s»⡒ʀbcmnp㓻㕞ሉ㖋㖎Ҁ;Edemnprs㔎㔏㔑㔕㔞㔣㔬㔱㔶抂;櫅ot;檽Ā;dᇚ㔚ot;櫃ult;櫁ĀEe㔨㔪;櫋;把lus;檿arr;楹ƀeiu㔽㕒㕕tƀ;en㔎㕅㕋qĀ;qᇚ㔏eqĀ;q㔫㔨m;櫇Ābp㕚㕜;櫕;櫓c̀;acensᇭ㕬㕲㕹㕻㌦pproø㋺urlyeñᇾñᇳƀaes㖂㖈㌛pproø㌚qñ㌗g;晪ڀ123;Edehlmnps㖩㖬㖯ሜ㖲㖴㗀㗉㗕㗚㗟㗨㗭耻¹䂹耻²䂲耻³䂳;櫆Āos㖹㖼t;檾ub;櫘Ā;dሢ㗅ot;櫄sĀou㗏㗒l;柉b;櫗arr;楻ult;櫂ĀEe㗤㗦;櫌;抋lus;櫀ƀeiu㗴㘉㘌tƀ;enሜ㗼㘂qĀ;qሢ㖲eqĀ;q㗧㗤m;櫈Ābp㘑㘓;櫔;櫖ƀAan㘜㘠㘭rr;懙rĀhr㘦㘨ë∮Ā;oਫ਩war;椪lig耻ß䃟௡㙑㙝㙠ዎ㙳㙹\0㙾㛂\0\0\0\0\0㛛㜃\0㜉㝬\0\0\0㞇ɲ㙖\0\0㙛get;挖;䏄rë๟ƀaey㙦㙫㙰ron;䅥dil;䅣;䑂lrec;挕r;쀀𝔱Ȁeiko㚆㚝㚵㚼ǲ㚋\0㚑eĀ4fኄኁaƀ;sv㚘㚙㚛䎸ym;䏑Ācn㚢㚲kĀas㚨㚮pproø዁im»ኬsðኞĀas㚺㚮ð዁rn耻þ䃾Ǭ̟㛆⋧es膀×;bd㛏㛐㛘䃗Ā;aᤏ㛕r;樱;樰ƀeps㛡㛣㜀á⩍Ȁ;bcf҆㛬㛰㛴ot;挶ir;櫱Ā;o㛹㛼쀀𝕥rk;櫚á㍢rime;怴ƀaip㜏㜒㝤dåቈ΀adempst㜡㝍㝀㝑㝗㝜㝟ngleʀ;dlqr㜰㜱㜶㝀㝂斵own»ᶻeftĀ;e⠀㜾ñम;扜ightĀ;e㊪㝋ñၚot;旬inus;樺lus;樹b;槍ime;樻ezium;揢ƀcht㝲㝽㞁Āry㝷㝻;쀀𝓉;䑆cy;䑛rok;䅧Āio㞋㞎xô᝷headĀlr㞗㞠eftarro÷ࡏightarrow»ཝऀAHabcdfghlmoprstuw㟐㟓㟗㟤㟰㟼㠎㠜㠣㠴㡑㡝㡫㢩㣌㣒㣪㣶ròϭar;楣Ācr㟜㟢ute耻ú䃺òᅐrǣ㟪\0㟭y;䑞ve;䅭Āiy㟵㟺rc耻û䃻;䑃ƀabh㠃㠆㠋ròᎭlac;䅱aòᏃĀir㠓㠘sht;楾;쀀𝔲rave耻ù䃹š㠧㠱rĀlr㠬㠮»ॗ»ႃlk;斀Āct㠹㡍ɯ㠿\0\0㡊rnĀ;e㡅㡆挜r»㡆op;挏ri;旸Āal㡖㡚cr;䅫肻¨͉Āgp㡢㡦on;䅳f;쀀𝕦̀adhlsuᅋ㡸㡽፲㢑㢠ownáᎳarpoonĀlr㢈㢌efô㠭ighô㠯iƀ;hl㢙㢚㢜䏅»ᏺon»㢚parrows;懈ƀcit㢰㣄㣈ɯ㢶\0\0㣁rnĀ;e㢼㢽挝r»㢽op;挎ng;䅯ri;旹cr;쀀𝓊ƀdir㣙㣝㣢ot;拰lde;䅩iĀ;f㜰㣨»᠓Āam㣯㣲rò㢨l耻ü䃼angle;榧ހABDacdeflnoprsz㤜㤟㤩㤭㦵㦸㦽㧟㧤㧨㧳㧹㧽㨁㨠ròϷarĀ;v㤦㤧櫨;櫩asèϡĀnr㤲㤷grt;榜΀eknprst㓣㥆㥋㥒㥝㥤㦖appá␕othinçẖƀhir㓫⻈㥙opô⾵Ā;hᎷ㥢ïㆍĀiu㥩㥭gmá㎳Ābp㥲㦄setneqĀ;q㥽㦀쀀⊊︀;쀀⫋︀setneqĀ;q㦏㦒쀀⊋︀;쀀⫌︀Āhr㦛㦟etá㚜iangleĀlr㦪㦯eft»थight»ၑy;䐲ash»ံƀelr㧄㧒㧗ƀ;beⷪ㧋㧏ar;抻q;扚lip;拮Ābt㧜ᑨaòᑩr;쀀𝔳tré㦮suĀbp㧯㧱»ജ»൙pf;쀀𝕧roð໻tré㦴Ācu㨆㨋r;쀀𝓋Ābp㨐㨘nĀEe㦀㨖»㥾nĀEe㦒㨞»㦐igzag;榚΀cefoprs㨶㨻㩖㩛㩔㩡㩪irc;䅵Ādi㩀㩑Ābg㩅㩉ar;機eĀ;qᗺ㩏;扙erp;愘r;쀀𝔴pf;쀀𝕨Ā;eᑹ㩦atèᑹcr;쀀𝓌ૣណ㪇\0㪋\0㪐㪛\0\0㪝㪨㪫㪯\0\0㫃㫎\0㫘ៜ៟tré៑r;쀀𝔵ĀAa㪔㪗ròσrò৶;䎾ĀAa㪡㪤ròθrò৫að✓is;拻ƀdptឤ㪵㪾Āfl㪺ឩ;쀀𝕩imåឲĀAa㫇㫊ròώròਁĀcq㫒ីr;쀀𝓍Āpt៖㫜ré។Ѐacefiosu㫰㫽㬈㬌㬑㬕㬛㬡cĀuy㫶㫻te耻ý䃽;䑏Āiy㬂㬆rc;䅷;䑋n耻¥䂥r;쀀𝔶cy;䑗pf;쀀𝕪cr;쀀𝓎Ācm㬦㬩y;䑎l耻ÿ䃿Ԁacdefhiosw㭂㭈㭔㭘㭤㭩㭭㭴㭺㮀cute;䅺Āay㭍㭒ron;䅾;䐷ot;䅼Āet㭝㭡træᕟa;䎶r;쀀𝔷cy;䐶grarr;懝pf;쀀𝕫cr;쀀𝓏Ājn㮅㮇;怍j;怌'.split("").map(function(t) {
    return t.charCodeAt(0);
  })
);
var Y9 = {};
Object.defineProperty(Y9, "__esModule", { value: !0 });
Y9.default = new Uint16Array(
  // prettier-ignore
  "Ȁaglq	\x1Bɭ\0\0p;䀦os;䀧t;䀾t;䀼uot;䀢".split("").map(function(t) {
    return t.charCodeAt(0);
  })
);
var P_ = {};
(function(t) {
  var e;
  Object.defineProperty(t, "__esModule", { value: !0 }), t.replaceCodePoint = t.fromCodePoint = void 0;
  var n = /* @__PURE__ */ new Map([
    [0, 65533],
    // C1 Unicode control character reference replacements
    [128, 8364],
    [130, 8218],
    [131, 402],
    [132, 8222],
    [133, 8230],
    [134, 8224],
    [135, 8225],
    [136, 710],
    [137, 8240],
    [138, 352],
    [139, 8249],
    [140, 338],
    [142, 381],
    [145, 8216],
    [146, 8217],
    [147, 8220],
    [148, 8221],
    [149, 8226],
    [150, 8211],
    [151, 8212],
    [152, 732],
    [153, 8482],
    [154, 353],
    [155, 8250],
    [156, 339],
    [158, 382],
    [159, 376]
  ]);
  t.fromCodePoint = // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition, node/no-unsupported-features/es-builtins
  (e = String.fromCodePoint) !== null && e !== void 0 ? e : function(o) {
    var a = "";
    return o > 65535 && (o -= 65536, a += String.fromCharCode(o >>> 10 & 1023 | 55296), o = 56320 | o & 1023), a += String.fromCharCode(o), a;
  };
  function r(o) {
    var a;
    return o >= 55296 && o <= 57343 || o > 1114111 ? 65533 : (a = n.get(o)) !== null && a !== void 0 ? a : o;
  }
  t.replaceCodePoint = r;
  function i(o) {
    return (0, t.fromCodePoint)(r(o));
  }
  t.default = i;
})(P_);
(function(t) {
  var e = ft && ft.__createBinding || (Object.create ? function(k, D, R, V) {
    V === void 0 && (V = R);
    var $ = Object.getOwnPropertyDescriptor(D, R);
    (!$ || ("get" in $ ? !D.__esModule : $.writable || $.configurable)) && ($ = { enumerable: !0, get: function() {
      return D[R];
    } }), Object.defineProperty(k, V, $);
  } : function(k, D, R, V) {
    V === void 0 && (V = R), k[V] = D[R];
  }), n = ft && ft.__setModuleDefault || (Object.create ? function(k, D) {
    Object.defineProperty(k, "default", { enumerable: !0, value: D });
  } : function(k, D) {
    k.default = D;
  }), r = ft && ft.__importStar || function(k) {
    if (k && k.__esModule)
      return k;
    var D = {};
    if (k != null)
      for (var R in k)
        R !== "default" && Object.prototype.hasOwnProperty.call(k, R) && e(D, k, R);
    return n(D, k), D;
  }, i = ft && ft.__importDefault || function(k) {
    return k && k.__esModule ? k : { default: k };
  };
  Object.defineProperty(t, "__esModule", { value: !0 }), t.decodeXML = t.decodeHTMLStrict = t.decodeHTMLAttribute = t.decodeHTML = t.determineBranch = t.EntityDecoder = t.DecodingMode = t.BinTrieFlags = t.fromCodePoint = t.replaceCodePoint = t.decodeCodePoint = t.xmlDecodeTree = t.htmlDecodeTree = void 0;
  var o = i(X9);
  t.htmlDecodeTree = o.default;
  var a = i(Y9);
  t.xmlDecodeTree = a.default;
  var s = r(P_);
  t.decodeCodePoint = s.default;
  var u = P_;
  Object.defineProperty(t, "replaceCodePoint", { enumerable: !0, get: function() {
    return u.replaceCodePoint;
  } }), Object.defineProperty(t, "fromCodePoint", { enumerable: !0, get: function() {
    return u.fromCodePoint;
  } });
  var l;
  (function(k) {
    k[k.NUM = 35] = "NUM", k[k.SEMI = 59] = "SEMI", k[k.EQUALS = 61] = "EQUALS", k[k.ZERO = 48] = "ZERO", k[k.NINE = 57] = "NINE", k[k.LOWER_A = 97] = "LOWER_A", k[k.LOWER_F = 102] = "LOWER_F", k[k.LOWER_X = 120] = "LOWER_X", k[k.LOWER_Z = 122] = "LOWER_Z", k[k.UPPER_A = 65] = "UPPER_A", k[k.UPPER_F = 70] = "UPPER_F", k[k.UPPER_Z = 90] = "UPPER_Z";
  })(l || (l = {}));
  var c = 32, d;
  (function(k) {
    k[k.VALUE_LENGTH = 49152] = "VALUE_LENGTH", k[k.BRANCH_LENGTH = 16256] = "BRANCH_LENGTH", k[k.JUMP_TABLE = 127] = "JUMP_TABLE";
  })(d = t.BinTrieFlags || (t.BinTrieFlags = {}));
  function f(k) {
    return k >= l.ZERO && k <= l.NINE;
  }
  function h(k) {
    return k >= l.UPPER_A && k <= l.UPPER_F || k >= l.LOWER_A && k <= l.LOWER_F;
  }
  function p(k) {
    return k >= l.UPPER_A && k <= l.UPPER_Z || k >= l.LOWER_A && k <= l.LOWER_Z || f(k);
  }
  function v(k) {
    return k === l.EQUALS || p(k);
  }
  var m;
  (function(k) {
    k[k.EntityStart = 0] = "EntityStart", k[k.NumericStart = 1] = "NumericStart", k[k.NumericDecimal = 2] = "NumericDecimal", k[k.NumericHex = 3] = "NumericHex", k[k.NamedEntity = 4] = "NamedEntity";
  })(m || (m = {}));
  var b;
  (function(k) {
    k[k.Legacy = 0] = "Legacy", k[k.Strict = 1] = "Strict", k[k.Attribute = 2] = "Attribute";
  })(b = t.DecodingMode || (t.DecodingMode = {}));
  var y = (
    /** @class */
    function() {
      function k(D, R, V) {
        this.decodeTree = D, this.emitCodePoint = R, this.errors = V, this.state = m.EntityStart, this.consumed = 1, this.result = 0, this.treeIndex = 0, this.excess = 1, this.decodeMode = b.Strict;
      }
      return k.prototype.startEntity = function(D) {
        this.decodeMode = D, this.state = m.EntityStart, this.result = 0, this.treeIndex = 0, this.excess = 1, this.consumed = 1;
      }, k.prototype.write = function(D, R) {
        switch (this.state) {
          case m.EntityStart:
            return D.charCodeAt(R) === l.NUM ? (this.state = m.NumericStart, this.consumed += 1, this.stateNumericStart(D, R + 1)) : (this.state = m.NamedEntity, this.stateNamedEntity(D, R));
          case m.NumericStart:
            return this.stateNumericStart(D, R);
          case m.NumericDecimal:
            return this.stateNumericDecimal(D, R);
          case m.NumericHex:
            return this.stateNumericHex(D, R);
          case m.NamedEntity:
            return this.stateNamedEntity(D, R);
        }
      }, k.prototype.stateNumericStart = function(D, R) {
        return R >= D.length ? -1 : (D.charCodeAt(R) | c) === l.LOWER_X ? (this.state = m.NumericHex, this.consumed += 1, this.stateNumericHex(D, R + 1)) : (this.state = m.NumericDecimal, this.stateNumericDecimal(D, R));
      }, k.prototype.addToNumericResult = function(D, R, V, $) {
        if (R !== V) {
          var F = V - R;
          this.result = this.result * Math.pow($, F) + parseInt(D.substr(R, F), $), this.consumed += F;
        }
      }, k.prototype.stateNumericHex = function(D, R) {
        for (var V = R; R < D.length; ) {
          var $ = D.charCodeAt(R);
          if (f($) || h($))
            R += 1;
          else
            return this.addToNumericResult(D, V, R, 16), this.emitNumericEntity($, 3);
        }
        return this.addToNumericResult(D, V, R, 16), -1;
      }, k.prototype.stateNumericDecimal = function(D, R) {
        for (var V = R; R < D.length; ) {
          var $ = D.charCodeAt(R);
          if (f($))
            R += 1;
          else
            return this.addToNumericResult(D, V, R, 10), this.emitNumericEntity($, 2);
        }
        return this.addToNumericResult(D, V, R, 10), -1;
      }, k.prototype.emitNumericEntity = function(D, R) {
        var V;
        if (this.consumed <= R)
          return (V = this.errors) === null || V === void 0 || V.absenceOfDigitsInNumericCharacterReference(this.consumed), 0;
        if (D === l.SEMI)
          this.consumed += 1;
        else if (this.decodeMode === b.Strict)
          return 0;
        return this.emitCodePoint((0, s.replaceCodePoint)(this.result), this.consumed), this.errors && (D !== l.SEMI && this.errors.missingSemicolonAfterCharacterReference(), this.errors.validateNumericCharacterReference(this.result)), this.consumed;
      }, k.prototype.stateNamedEntity = function(D, R) {
        for (var V = this.decodeTree, $ = V[this.treeIndex], F = ($ & d.VALUE_LENGTH) >> 14; R < D.length; R++, this.excess++) {
          var M = D.charCodeAt(R);
          if (this.treeIndex = S(V, $, this.treeIndex + Math.max(1, F), M), this.treeIndex < 0)
            return this.result === 0 || // If we are parsing an attribute
            this.decodeMode === b.Attribute && // We shouldn't have consumed any characters after the entity,
            (F === 0 || // And there should be no invalid characters.
            v(M)) ? 0 : this.emitNotTerminatedNamedEntity();
          if ($ = V[this.treeIndex], F = ($ & d.VALUE_LENGTH) >> 14, F !== 0) {
            if (M === l.SEMI)
              return this.emitNamedEntityData(this.treeIndex, F, this.consumed + this.excess);
            this.decodeMode !== b.Strict && (this.result = this.treeIndex, this.consumed += this.excess, this.excess = 0);
          }
        }
        return -1;
      }, k.prototype.emitNotTerminatedNamedEntity = function() {
        var D, R = this, V = R.result, $ = R.decodeTree, F = ($[V] & d.VALUE_LENGTH) >> 14;
        return this.emitNamedEntityData(V, F, this.consumed), (D = this.errors) === null || D === void 0 || D.missingSemicolonAfterCharacterReference(), this.consumed;
      }, k.prototype.emitNamedEntityData = function(D, R, V) {
        var $ = this.decodeTree;
        return this.emitCodePoint(R === 1 ? $[D] & ~d.VALUE_LENGTH : $[D + 1], V), R === 3 && this.emitCodePoint($[D + 2], V), V;
      }, k.prototype.end = function() {
        var D;
        switch (this.state) {
          case m.NamedEntity:
            return this.result !== 0 && (this.decodeMode !== b.Attribute || this.result === this.treeIndex) ? this.emitNotTerminatedNamedEntity() : 0;
          case m.NumericDecimal:
            return this.emitNumericEntity(0, 2);
          case m.NumericHex:
            return this.emitNumericEntity(0, 3);
          case m.NumericStart:
            return (D = this.errors) === null || D === void 0 || D.absenceOfDigitsInNumericCharacterReference(this.consumed), 0;
          case m.EntityStart:
            return 0;
        }
      }, k;
    }()
  );
  t.EntityDecoder = y;
  function w(k) {
    var D = "", R = new y(k, function(V) {
      return D += (0, s.fromCodePoint)(V);
    });
    return function($, F) {
      for (var M = 0, B = 0; (B = $.indexOf("&", B)) >= 0; ) {
        D += $.slice(M, B), R.startEntity(F);
        var X = R.write(
          $,
          // Skip the "&"
          B + 1
        );
        if (X < 0) {
          M = B + R.end();
          break;
        }
        M = B + X, B = X === 0 ? M + 1 : M;
      }
      var L = D + $.slice(M);
      return D = "", L;
    };
  }
  function S(k, D, R, V) {
    var $ = (D & d.BRANCH_LENGTH) >> 7, F = D & d.JUMP_TABLE;
    if ($ === 0)
      return F !== 0 && V === F ? R : -1;
    if (F) {
      var M = V - F;
      return M < 0 || M >= $ ? -1 : k[R + M] - 1;
    }
    for (var B = R, X = B + $ - 1; B <= X; ) {
      var L = B + X >>> 1, j = k[L];
      if (j < V)
        B = L + 1;
      else if (j > V)
        X = L - 1;
      else
        return k[L + $];
    }
    return -1;
  }
  t.determineBranch = S;
  var E = w(o.default), I = w(a.default);
  function _(k, D) {
    return D === void 0 && (D = b.Legacy), E(k, D);
  }
  t.decodeHTML = _;
  function A(k) {
    return E(k, b.Attribute);
  }
  t.decodeHTMLAttribute = A;
  function P(k) {
    return E(k, b.Strict);
  }
  t.decodeHTMLStrict = P;
  function N(k) {
    return I(k, b.Strict);
  }
  t.decodeXML = N;
})(Q0);
(function(t) {
  Object.defineProperty(t, "__esModule", { value: !0 }), t.QuoteType = void 0;
  var e = Q0, n;
  (function(f) {
    f[f.Tab = 9] = "Tab", f[f.NewLine = 10] = "NewLine", f[f.FormFeed = 12] = "FormFeed", f[f.CarriageReturn = 13] = "CarriageReturn", f[f.Space = 32] = "Space", f[f.ExclamationMark = 33] = "ExclamationMark", f[f.Number = 35] = "Number", f[f.Amp = 38] = "Amp", f[f.SingleQuote = 39] = "SingleQuote", f[f.DoubleQuote = 34] = "DoubleQuote", f[f.Dash = 45] = "Dash", f[f.Slash = 47] = "Slash", f[f.Zero = 48] = "Zero", f[f.Nine = 57] = "Nine", f[f.Semi = 59] = "Semi", f[f.Lt = 60] = "Lt", f[f.Eq = 61] = "Eq", f[f.Gt = 62] = "Gt", f[f.Questionmark = 63] = "Questionmark", f[f.UpperA = 65] = "UpperA", f[f.LowerA = 97] = "LowerA", f[f.UpperF = 70] = "UpperF", f[f.LowerF = 102] = "LowerF", f[f.UpperZ = 90] = "UpperZ", f[f.LowerZ = 122] = "LowerZ", f[f.LowerX = 120] = "LowerX", f[f.OpeningSquareBracket = 91] = "OpeningSquareBracket";
  })(n || (n = {}));
  var r;
  (function(f) {
    f[f.Text = 1] = "Text", f[f.BeforeTagName = 2] = "BeforeTagName", f[f.InTagName = 3] = "InTagName", f[f.InSelfClosingTag = 4] = "InSelfClosingTag", f[f.BeforeClosingTagName = 5] = "BeforeClosingTagName", f[f.InClosingTagName = 6] = "InClosingTagName", f[f.AfterClosingTagName = 7] = "AfterClosingTagName", f[f.BeforeAttributeName = 8] = "BeforeAttributeName", f[f.InAttributeName = 9] = "InAttributeName", f[f.AfterAttributeName = 10] = "AfterAttributeName", f[f.BeforeAttributeValue = 11] = "BeforeAttributeValue", f[f.InAttributeValueDq = 12] = "InAttributeValueDq", f[f.InAttributeValueSq = 13] = "InAttributeValueSq", f[f.InAttributeValueNq = 14] = "InAttributeValueNq", f[f.BeforeDeclaration = 15] = "BeforeDeclaration", f[f.InDeclaration = 16] = "InDeclaration", f[f.InProcessingInstruction = 17] = "InProcessingInstruction", f[f.BeforeComment = 18] = "BeforeComment", f[f.CDATASequence = 19] = "CDATASequence", f[f.InSpecialComment = 20] = "InSpecialComment", f[f.InCommentLike = 21] = "InCommentLike", f[f.BeforeSpecialS = 22] = "BeforeSpecialS", f[f.SpecialStartSequence = 23] = "SpecialStartSequence", f[f.InSpecialTag = 24] = "InSpecialTag", f[f.BeforeEntity = 25] = "BeforeEntity", f[f.BeforeNumericEntity = 26] = "BeforeNumericEntity", f[f.InNamedEntity = 27] = "InNamedEntity", f[f.InNumericEntity = 28] = "InNumericEntity", f[f.InHexEntity = 29] = "InHexEntity";
  })(r || (r = {}));
  function i(f) {
    return f === n.Space || f === n.NewLine || f === n.Tab || f === n.FormFeed || f === n.CarriageReturn;
  }
  function o(f) {
    return f === n.Slash || f === n.Gt || i(f);
  }
  function a(f) {
    return f >= n.Zero && f <= n.Nine;
  }
  function s(f) {
    return f >= n.LowerA && f <= n.LowerZ || f >= n.UpperA && f <= n.UpperZ;
  }
  function u(f) {
    return f >= n.UpperA && f <= n.UpperF || f >= n.LowerA && f <= n.LowerF;
  }
  var l;
  (function(f) {
    f[f.NoValue = 0] = "NoValue", f[f.Unquoted = 1] = "Unquoted", f[f.Single = 2] = "Single", f[f.Double = 3] = "Double";
  })(l = t.QuoteType || (t.QuoteType = {}));
  var c = {
    Cdata: new Uint8Array([67, 68, 65, 84, 65, 91]),
    CdataEnd: new Uint8Array([93, 93, 62]),
    CommentEnd: new Uint8Array([45, 45, 62]),
    ScriptEnd: new Uint8Array([60, 47, 115, 99, 114, 105, 112, 116]),
    StyleEnd: new Uint8Array([60, 47, 115, 116, 121, 108, 101]),
    TitleEnd: new Uint8Array([60, 47, 116, 105, 116, 108, 101])
    // `</title`
  }, d = (
    /** @class */
    function() {
      function f(h, p) {
        var v = h.xmlMode, m = v === void 0 ? !1 : v, b = h.decodeEntities, y = b === void 0 ? !0 : b;
        this.cbs = p, this.state = r.Text, this.buffer = "", this.sectionStart = 0, this.index = 0, this.baseState = r.Text, this.isSpecial = !1, this.running = !0, this.offset = 0, this.currentSequence = void 0, this.sequenceIndex = 0, this.trieIndex = 0, this.trieCurrent = 0, this.entityResult = 0, this.entityExcess = 0, this.xmlMode = m, this.decodeEntities = y, this.entityTrie = m ? e.xmlDecodeTree : e.htmlDecodeTree;
      }
      return f.prototype.reset = function() {
        this.state = r.Text, this.buffer = "", this.sectionStart = 0, this.index = 0, this.baseState = r.Text, this.currentSequence = void 0, this.running = !0, this.offset = 0;
      }, f.prototype.write = function(h) {
        this.offset += this.buffer.length, this.buffer = h, this.parse();
      }, f.prototype.end = function() {
        this.running && this.finish();
      }, f.prototype.pause = function() {
        this.running = !1;
      }, f.prototype.resume = function() {
        this.running = !0, this.index < this.buffer.length + this.offset && this.parse();
      }, f.prototype.getIndex = function() {
        return this.index;
      }, f.prototype.getSectionStart = function() {
        return this.sectionStart;
      }, f.prototype.stateText = function(h) {
        h === n.Lt || !this.decodeEntities && this.fastForwardTo(n.Lt) ? (this.index > this.sectionStart && this.cbs.ontext(this.sectionStart, this.index), this.state = r.BeforeTagName, this.sectionStart = this.index) : this.decodeEntities && h === n.Amp && (this.state = r.BeforeEntity);
      }, f.prototype.stateSpecialStartSequence = function(h) {
        var p = this.sequenceIndex === this.currentSequence.length, v = p ? (
          // If we are at the end of the sequence, make sure the tag name has ended
          o(h)
        ) : (
          // Otherwise, do a case-insensitive comparison
          (h | 32) === this.currentSequence[this.sequenceIndex]
        );
        if (!v)
          this.isSpecial = !1;
        else if (!p) {
          this.sequenceIndex++;
          return;
        }
        this.sequenceIndex = 0, this.state = r.InTagName, this.stateInTagName(h);
      }, f.prototype.stateInSpecialTag = function(h) {
        if (this.sequenceIndex === this.currentSequence.length) {
          if (h === n.Gt || i(h)) {
            var p = this.index - this.currentSequence.length;
            if (this.sectionStart < p) {
              var v = this.index;
              this.index = p, this.cbs.ontext(this.sectionStart, p), this.index = v;
            }
            this.isSpecial = !1, this.sectionStart = p + 2, this.stateInClosingTagName(h);
            return;
          }
          this.sequenceIndex = 0;
        }
        (h | 32) === this.currentSequence[this.sequenceIndex] ? this.sequenceIndex += 1 : this.sequenceIndex === 0 ? this.currentSequence === c.TitleEnd ? this.decodeEntities && h === n.Amp && (this.state = r.BeforeEntity) : this.fastForwardTo(n.Lt) && (this.sequenceIndex = 1) : this.sequenceIndex = +(h === n.Lt);
      }, f.prototype.stateCDATASequence = function(h) {
        h === c.Cdata[this.sequenceIndex] ? ++this.sequenceIndex === c.Cdata.length && (this.state = r.InCommentLike, this.currentSequence = c.CdataEnd, this.sequenceIndex = 0, this.sectionStart = this.index + 1) : (this.sequenceIndex = 0, this.state = r.InDeclaration, this.stateInDeclaration(h));
      }, f.prototype.fastForwardTo = function(h) {
        for (; ++this.index < this.buffer.length + this.offset; )
          if (this.buffer.charCodeAt(this.index - this.offset) === h)
            return !0;
        return this.index = this.buffer.length + this.offset - 1, !1;
      }, f.prototype.stateInCommentLike = function(h) {
        h === this.currentSequence[this.sequenceIndex] ? ++this.sequenceIndex === this.currentSequence.length && (this.currentSequence === c.CdataEnd ? this.cbs.oncdata(this.sectionStart, this.index, 2) : this.cbs.oncomment(this.sectionStart, this.index, 2), this.sequenceIndex = 0, this.sectionStart = this.index + 1, this.state = r.Text) : this.sequenceIndex === 0 ? this.fastForwardTo(this.currentSequence[0]) && (this.sequenceIndex = 1) : h !== this.currentSequence[this.sequenceIndex - 1] && (this.sequenceIndex = 0);
      }, f.prototype.isTagStartChar = function(h) {
        return this.xmlMode ? !o(h) : s(h);
      }, f.prototype.startSpecial = function(h, p) {
        this.isSpecial = !0, this.currentSequence = h, this.sequenceIndex = p, this.state = r.SpecialStartSequence;
      }, f.prototype.stateBeforeTagName = function(h) {
        if (h === n.ExclamationMark)
          this.state = r.BeforeDeclaration, this.sectionStart = this.index + 1;
        else if (h === n.Questionmark)
          this.state = r.InProcessingInstruction, this.sectionStart = this.index + 1;
        else if (this.isTagStartChar(h)) {
          var p = h | 32;
          this.sectionStart = this.index, !this.xmlMode && p === c.TitleEnd[2] ? this.startSpecial(c.TitleEnd, 3) : this.state = !this.xmlMode && p === c.ScriptEnd[2] ? r.BeforeSpecialS : r.InTagName;
        } else
          h === n.Slash ? this.state = r.BeforeClosingTagName : (this.state = r.Text, this.stateText(h));
      }, f.prototype.stateInTagName = function(h) {
        o(h) && (this.cbs.onopentagname(this.sectionStart, this.index), this.sectionStart = -1, this.state = r.BeforeAttributeName, this.stateBeforeAttributeName(h));
      }, f.prototype.stateBeforeClosingTagName = function(h) {
        i(h) || (h === n.Gt ? this.state = r.Text : (this.state = this.isTagStartChar(h) ? r.InClosingTagName : r.InSpecialComment, this.sectionStart = this.index));
      }, f.prototype.stateInClosingTagName = function(h) {
        (h === n.Gt || i(h)) && (this.cbs.onclosetag(this.sectionStart, this.index), this.sectionStart = -1, this.state = r.AfterClosingTagName, this.stateAfterClosingTagName(h));
      }, f.prototype.stateAfterClosingTagName = function(h) {
        (h === n.Gt || this.fastForwardTo(n.Gt)) && (this.state = r.Text, this.baseState = r.Text, this.sectionStart = this.index + 1);
      }, f.prototype.stateBeforeAttributeName = function(h) {
        h === n.Gt ? (this.cbs.onopentagend(this.index), this.isSpecial ? (this.state = r.InSpecialTag, this.sequenceIndex = 0) : this.state = r.Text, this.baseState = this.state, this.sectionStart = this.index + 1) : h === n.Slash ? this.state = r.InSelfClosingTag : i(h) || (this.state = r.InAttributeName, this.sectionStart = this.index);
      }, f.prototype.stateInSelfClosingTag = function(h) {
        h === n.Gt ? (this.cbs.onselfclosingtag(this.index), this.state = r.Text, this.baseState = r.Text, this.sectionStart = this.index + 1, this.isSpecial = !1) : i(h) || (this.state = r.BeforeAttributeName, this.stateBeforeAttributeName(h));
      }, f.prototype.stateInAttributeName = function(h) {
        (h === n.Eq || o(h)) && (this.cbs.onattribname(this.sectionStart, this.index), this.sectionStart = -1, this.state = r.AfterAttributeName, this.stateAfterAttributeName(h));
      }, f.prototype.stateAfterAttributeName = function(h) {
        h === n.Eq ? this.state = r.BeforeAttributeValue : h === n.Slash || h === n.Gt ? (this.cbs.onattribend(l.NoValue, this.index), this.state = r.BeforeAttributeName, this.stateBeforeAttributeName(h)) : i(h) || (this.cbs.onattribend(l.NoValue, this.index), this.state = r.InAttributeName, this.sectionStart = this.index);
      }, f.prototype.stateBeforeAttributeValue = function(h) {
        h === n.DoubleQuote ? (this.state = r.InAttributeValueDq, this.sectionStart = this.index + 1) : h === n.SingleQuote ? (this.state = r.InAttributeValueSq, this.sectionStart = this.index + 1) : i(h) || (this.sectionStart = this.index, this.state = r.InAttributeValueNq, this.stateInAttributeValueNoQuotes(h));
      }, f.prototype.handleInAttributeValue = function(h, p) {
        h === p || !this.decodeEntities && this.fastForwardTo(p) ? (this.cbs.onattribdata(this.sectionStart, this.index), this.sectionStart = -1, this.cbs.onattribend(p === n.DoubleQuote ? l.Double : l.Single, this.index), this.state = r.BeforeAttributeName) : this.decodeEntities && h === n.Amp && (this.baseState = this.state, this.state = r.BeforeEntity);
      }, f.prototype.stateInAttributeValueDoubleQuotes = function(h) {
        this.handleInAttributeValue(h, n.DoubleQuote);
      }, f.prototype.stateInAttributeValueSingleQuotes = function(h) {
        this.handleInAttributeValue(h, n.SingleQuote);
      }, f.prototype.stateInAttributeValueNoQuotes = function(h) {
        i(h) || h === n.Gt ? (this.cbs.onattribdata(this.sectionStart, this.index), this.sectionStart = -1, this.cbs.onattribend(l.Unquoted, this.index), this.state = r.BeforeAttributeName, this.stateBeforeAttributeName(h)) : this.decodeEntities && h === n.Amp && (this.baseState = this.state, this.state = r.BeforeEntity);
      }, f.prototype.stateBeforeDeclaration = function(h) {
        h === n.OpeningSquareBracket ? (this.state = r.CDATASequence, this.sequenceIndex = 0) : this.state = h === n.Dash ? r.BeforeComment : r.InDeclaration;
      }, f.prototype.stateInDeclaration = function(h) {
        (h === n.Gt || this.fastForwardTo(n.Gt)) && (this.cbs.ondeclaration(this.sectionStart, this.index), this.state = r.Text, this.sectionStart = this.index + 1);
      }, f.prototype.stateInProcessingInstruction = function(h) {
        (h === n.Gt || this.fastForwardTo(n.Gt)) && (this.cbs.onprocessinginstruction(this.sectionStart, this.index), this.state = r.Text, this.sectionStart = this.index + 1);
      }, f.prototype.stateBeforeComment = function(h) {
        h === n.Dash ? (this.state = r.InCommentLike, this.currentSequence = c.CommentEnd, this.sequenceIndex = 2, this.sectionStart = this.index + 1) : this.state = r.InDeclaration;
      }, f.prototype.stateInSpecialComment = function(h) {
        (h === n.Gt || this.fastForwardTo(n.Gt)) && (this.cbs.oncomment(this.sectionStart, this.index, 0), this.state = r.Text, this.sectionStart = this.index + 1);
      }, f.prototype.stateBeforeSpecialS = function(h) {
        var p = h | 32;
        p === c.ScriptEnd[3] ? this.startSpecial(c.ScriptEnd, 4) : p === c.StyleEnd[3] ? this.startSpecial(c.StyleEnd, 4) : (this.state = r.InTagName, this.stateInTagName(h));
      }, f.prototype.stateBeforeEntity = function(h) {
        this.entityExcess = 1, this.entityResult = 0, h === n.Number ? this.state = r.BeforeNumericEntity : h === n.Amp || (this.trieIndex = 0, this.trieCurrent = this.entityTrie[0], this.state = r.InNamedEntity, this.stateInNamedEntity(h));
      }, f.prototype.stateInNamedEntity = function(h) {
        if (this.entityExcess += 1, this.trieIndex = (0, e.determineBranch)(this.entityTrie, this.trieCurrent, this.trieIndex + 1, h), this.trieIndex < 0) {
          this.emitNamedEntity(), this.index--;
          return;
        }
        this.trieCurrent = this.entityTrie[this.trieIndex];
        var p = this.trieCurrent & e.BinTrieFlags.VALUE_LENGTH;
        if (p) {
          var v = (p >> 14) - 1;
          if (!this.allowLegacyEntity() && h !== n.Semi)
            this.trieIndex += v;
          else {
            var m = this.index - this.entityExcess + 1;
            m > this.sectionStart && this.emitPartial(this.sectionStart, m), this.entityResult = this.trieIndex, this.trieIndex += v, this.entityExcess = 0, this.sectionStart = this.index + 1, v === 0 && this.emitNamedEntity();
          }
        }
      }, f.prototype.emitNamedEntity = function() {
        if (this.state = this.baseState, this.entityResult !== 0) {
          var h = (this.entityTrie[this.entityResult] & e.BinTrieFlags.VALUE_LENGTH) >> 14;
          switch (h) {
            case 1: {
              this.emitCodePoint(this.entityTrie[this.entityResult] & ~e.BinTrieFlags.VALUE_LENGTH);
              break;
            }
            case 2: {
              this.emitCodePoint(this.entityTrie[this.entityResult + 1]);
              break;
            }
            case 3:
              this.emitCodePoint(this.entityTrie[this.entityResult + 1]), this.emitCodePoint(this.entityTrie[this.entityResult + 2]);
          }
        }
      }, f.prototype.stateBeforeNumericEntity = function(h) {
        (h | 32) === n.LowerX ? (this.entityExcess++, this.state = r.InHexEntity) : (this.state = r.InNumericEntity, this.stateInNumericEntity(h));
      }, f.prototype.emitNumericEntity = function(h) {
        var p = this.index - this.entityExcess - 1, v = p + 2 + +(this.state === r.InHexEntity);
        v !== this.index && (p > this.sectionStart && this.emitPartial(this.sectionStart, p), this.sectionStart = this.index + Number(h), this.emitCodePoint((0, e.replaceCodePoint)(this.entityResult))), this.state = this.baseState;
      }, f.prototype.stateInNumericEntity = function(h) {
        h === n.Semi ? this.emitNumericEntity(!0) : a(h) ? (this.entityResult = this.entityResult * 10 + (h - n.Zero), this.entityExcess++) : (this.allowLegacyEntity() ? this.emitNumericEntity(!1) : this.state = this.baseState, this.index--);
      }, f.prototype.stateInHexEntity = function(h) {
        h === n.Semi ? this.emitNumericEntity(!0) : a(h) ? (this.entityResult = this.entityResult * 16 + (h - n.Zero), this.entityExcess++) : u(h) ? (this.entityResult = this.entityResult * 16 + ((h | 32) - n.LowerA + 10), this.entityExcess++) : (this.allowLegacyEntity() ? this.emitNumericEntity(!1) : this.state = this.baseState, this.index--);
      }, f.prototype.allowLegacyEntity = function() {
        return !this.xmlMode && (this.baseState === r.Text || this.baseState === r.InSpecialTag);
      }, f.prototype.cleanup = function() {
        this.running && this.sectionStart !== this.index && (this.state === r.Text || this.state === r.InSpecialTag && this.sequenceIndex === 0 ? (this.cbs.ontext(this.sectionStart, this.index), this.sectionStart = this.index) : (this.state === r.InAttributeValueDq || this.state === r.InAttributeValueSq || this.state === r.InAttributeValueNq) && (this.cbs.onattribdata(this.sectionStart, this.index), this.sectionStart = this.index));
      }, f.prototype.shouldContinue = function() {
        return this.index < this.buffer.length + this.offset && this.running;
      }, f.prototype.parse = function() {
        for (; this.shouldContinue(); ) {
          var h = this.buffer.charCodeAt(this.index - this.offset);
          switch (this.state) {
            case r.Text: {
              this.stateText(h);
              break;
            }
            case r.SpecialStartSequence: {
              this.stateSpecialStartSequence(h);
              break;
            }
            case r.InSpecialTag: {
              this.stateInSpecialTag(h);
              break;
            }
            case r.CDATASequence: {
              this.stateCDATASequence(h);
              break;
            }
            case r.InAttributeValueDq: {
              this.stateInAttributeValueDoubleQuotes(h);
              break;
            }
            case r.InAttributeName: {
              this.stateInAttributeName(h);
              break;
            }
            case r.InCommentLike: {
              this.stateInCommentLike(h);
              break;
            }
            case r.InSpecialComment: {
              this.stateInSpecialComment(h);
              break;
            }
            case r.BeforeAttributeName: {
              this.stateBeforeAttributeName(h);
              break;
            }
            case r.InTagName: {
              this.stateInTagName(h);
              break;
            }
            case r.InClosingTagName: {
              this.stateInClosingTagName(h);
              break;
            }
            case r.BeforeTagName: {
              this.stateBeforeTagName(h);
              break;
            }
            case r.AfterAttributeName: {
              this.stateAfterAttributeName(h);
              break;
            }
            case r.InAttributeValueSq: {
              this.stateInAttributeValueSingleQuotes(h);
              break;
            }
            case r.BeforeAttributeValue: {
              this.stateBeforeAttributeValue(h);
              break;
            }
            case r.BeforeClosingTagName: {
              this.stateBeforeClosingTagName(h);
              break;
            }
            case r.AfterClosingTagName: {
              this.stateAfterClosingTagName(h);
              break;
            }
            case r.BeforeSpecialS: {
              this.stateBeforeSpecialS(h);
              break;
            }
            case r.InAttributeValueNq: {
              this.stateInAttributeValueNoQuotes(h);
              break;
            }
            case r.InSelfClosingTag: {
              this.stateInSelfClosingTag(h);
              break;
            }
            case r.InDeclaration: {
              this.stateInDeclaration(h);
              break;
            }
            case r.BeforeDeclaration: {
              this.stateBeforeDeclaration(h);
              break;
            }
            case r.BeforeComment: {
              this.stateBeforeComment(h);
              break;
            }
            case r.InProcessingInstruction: {
              this.stateInProcessingInstruction(h);
              break;
            }
            case r.InNamedEntity: {
              this.stateInNamedEntity(h);
              break;
            }
            case r.BeforeEntity: {
              this.stateBeforeEntity(h);
              break;
            }
            case r.InHexEntity: {
              this.stateInHexEntity(h);
              break;
            }
            case r.InNumericEntity: {
              this.stateInNumericEntity(h);
              break;
            }
            default:
              this.stateBeforeNumericEntity(h);
          }
          this.index++;
        }
        this.cleanup();
      }, f.prototype.finish = function() {
        this.state === r.InNamedEntity && this.emitNamedEntity(), this.sectionStart < this.index && this.handleTrailingData(), this.cbs.onend();
      }, f.prototype.handleTrailingData = function() {
        var h = this.buffer.length + this.offset;
        this.state === r.InCommentLike ? this.currentSequence === c.CdataEnd ? this.cbs.oncdata(this.sectionStart, h, 0) : this.cbs.oncomment(this.sectionStart, h, 0) : this.state === r.InNumericEntity && this.allowLegacyEntity() ? this.emitNumericEntity(!1) : this.state === r.InHexEntity && this.allowLegacyEntity() ? this.emitNumericEntity(!1) : this.state === r.InTagName || this.state === r.BeforeAttributeName || this.state === r.BeforeAttributeValue || this.state === r.AfterAttributeName || this.state === r.InAttributeName || this.state === r.InAttributeValueSq || this.state === r.InAttributeValueDq || this.state === r.InAttributeValueNq || this.state === r.InClosingTagName || this.cbs.ontext(this.sectionStart, h);
      }, f.prototype.emitPartial = function(h, p) {
        this.baseState !== r.Text && this.baseState !== r.InSpecialTag ? this.cbs.onattribdata(h, p) : this.cbs.ontext(h, p);
      }, f.prototype.emitCodePoint = function(h) {
        this.baseState !== r.Text && this.baseState !== r.InSpecialTag ? this.cbs.onattribentity(h) : this.cbs.ontextentity(h);
      }, f;
    }()
  );
  t.default = d;
})(U9);
var vVe = ft && ft.__createBinding || (Object.create ? function(t, e, n, r) {
  r === void 0 && (r = n);
  var i = Object.getOwnPropertyDescriptor(e, n);
  (!i || ("get" in i ? !e.__esModule : i.writable || i.configurable)) && (i = { enumerable: !0, get: function() {
    return e[n];
  } }), Object.defineProperty(t, r, i);
} : function(t, e, n, r) {
  r === void 0 && (r = n), t[r] = e[n];
}), bVe = ft && ft.__setModuleDefault || (Object.create ? function(t, e) {
  Object.defineProperty(t, "default", { enumerable: !0, value: e });
} : function(t, e) {
  t.default = e;
}), yVe = ft && ft.__importStar || function(t) {
  if (t && t.__esModule)
    return t;
  var e = {};
  if (t != null)
    for (var n in t)
      n !== "default" && Object.prototype.hasOwnProperty.call(t, n) && vVe(e, t, n);
  return bVe(e, t), e;
};
Object.defineProperty(q0, "__esModule", { value: !0 });
q0.Parser = void 0;
var hb = yVe(U9), wD = Q0, Vf = /* @__PURE__ */ new Set([
  "input",
  "option",
  "optgroup",
  "select",
  "button",
  "datalist",
  "textarea"
]), xr = /* @__PURE__ */ new Set(["p"]), ED = /* @__PURE__ */ new Set(["thead", "tbody"]), SD = /* @__PURE__ */ new Set(["dd", "dt"]), ID = /* @__PURE__ */ new Set(["rt", "rp"]), xVe = /* @__PURE__ */ new Map([
  ["tr", /* @__PURE__ */ new Set(["tr", "th", "td"])],
  ["th", /* @__PURE__ */ new Set(["th"])],
  ["td", /* @__PURE__ */ new Set(["thead", "th", "td"])],
  ["body", /* @__PURE__ */ new Set(["head", "link", "script"])],
  ["li", /* @__PURE__ */ new Set(["li"])],
  ["p", xr],
  ["h1", xr],
  ["h2", xr],
  ["h3", xr],
  ["h4", xr],
  ["h5", xr],
  ["h6", xr],
  ["select", Vf],
  ["input", Vf],
  ["output", Vf],
  ["button", Vf],
  ["datalist", Vf],
  ["textarea", Vf],
  ["option", /* @__PURE__ */ new Set(["option"])],
  ["optgroup", /* @__PURE__ */ new Set(["optgroup", "option"])],
  ["dd", SD],
  ["dt", SD],
  ["address", xr],
  ["article", xr],
  ["aside", xr],
  ["blockquote", xr],
  ["details", xr],
  ["div", xr],
  ["dl", xr],
  ["fieldset", xr],
  ["figcaption", xr],
  ["figure", xr],
  ["footer", xr],
  ["form", xr],
  ["header", xr],
  ["hr", xr],
  ["main", xr],
  ["nav", xr],
  ["ol", xr],
  ["pre", xr],
  ["section", xr],
  ["table", xr],
  ["ul", xr],
  ["rt", ID],
  ["rp", ID],
  ["tbody", ED],
  ["tfoot", ED]
]), CVe = /* @__PURE__ */ new Set([
  "area",
  "base",
  "basefont",
  "br",
  "col",
  "command",
  "embed",
  "frame",
  "hr",
  "img",
  "input",
  "isindex",
  "keygen",
  "link",
  "meta",
  "param",
  "source",
  "track",
  "wbr"
]), _D = /* @__PURE__ */ new Set(["math", "svg"]), AD = /* @__PURE__ */ new Set([
  "mi",
  "mo",
  "mn",
  "ms",
  "mtext",
  "annotation-xml",
  "foreignobject",
  "desc",
  "title"
]), wVe = /\s|\//, EVe = (
  /** @class */
  function() {
    function t(e, n) {
      n === void 0 && (n = {});
      var r, i, o, a, s;
      this.options = n, this.startIndex = 0, this.endIndex = 0, this.openTagStart = 0, this.tagname = "", this.attribname = "", this.attribvalue = "", this.attribs = null, this.stack = [], this.foreignContext = [], this.buffers = [], this.bufferOffset = 0, this.writeIndex = 0, this.ended = !1, this.cbs = e ?? {}, this.lowerCaseTagNames = (r = n.lowerCaseTags) !== null && r !== void 0 ? r : !n.xmlMode, this.lowerCaseAttributeNames = (i = n.lowerCaseAttributeNames) !== null && i !== void 0 ? i : !n.xmlMode, this.tokenizer = new ((o = n.Tokenizer) !== null && o !== void 0 ? o : hb.default)(this.options, this), (s = (a = this.cbs).onparserinit) === null || s === void 0 || s.call(a, this);
    }
    return t.prototype.ontext = function(e, n) {
      var r, i, o = this.getSlice(e, n);
      this.endIndex = n - 1, (i = (r = this.cbs).ontext) === null || i === void 0 || i.call(r, o), this.startIndex = n;
    }, t.prototype.ontextentity = function(e) {
      var n, r, i = this.tokenizer.getSectionStart();
      this.endIndex = i - 1, (r = (n = this.cbs).ontext) === null || r === void 0 || r.call(n, (0, wD.fromCodePoint)(e)), this.startIndex = i;
    }, t.prototype.isVoidElement = function(e) {
      return !this.options.xmlMode && CVe.has(e);
    }, t.prototype.onopentagname = function(e, n) {
      this.endIndex = n;
      var r = this.getSlice(e, n);
      this.lowerCaseTagNames && (r = r.toLowerCase()), this.emitOpenTag(r);
    }, t.prototype.emitOpenTag = function(e) {
      var n, r, i, o;
      this.openTagStart = this.startIndex, this.tagname = e;
      var a = !this.options.xmlMode && xVe.get(e);
      if (a)
        for (; this.stack.length > 0 && a.has(this.stack[this.stack.length - 1]); ) {
          var s = this.stack.pop();
          (r = (n = this.cbs).onclosetag) === null || r === void 0 || r.call(n, s, !0);
        }
      this.isVoidElement(e) || (this.stack.push(e), _D.has(e) ? this.foreignContext.push(!0) : AD.has(e) && this.foreignContext.push(!1)), (o = (i = this.cbs).onopentagname) === null || o === void 0 || o.call(i, e), this.cbs.onopentag && (this.attribs = {});
    }, t.prototype.endOpenTag = function(e) {
      var n, r;
      this.startIndex = this.openTagStart, this.attribs && ((r = (n = this.cbs).onopentag) === null || r === void 0 || r.call(n, this.tagname, this.attribs, e), this.attribs = null), this.cbs.onclosetag && this.isVoidElement(this.tagname) && this.cbs.onclosetag(this.tagname, !0), this.tagname = "";
    }, t.prototype.onopentagend = function(e) {
      this.endIndex = e, this.endOpenTag(!1), this.startIndex = e + 1;
    }, t.prototype.onclosetag = function(e, n) {
      var r, i, o, a, s, u;
      this.endIndex = n;
      var l = this.getSlice(e, n);
      if (this.lowerCaseTagNames && (l = l.toLowerCase()), (_D.has(l) || AD.has(l)) && this.foreignContext.pop(), this.isVoidElement(l))
        !this.options.xmlMode && l === "br" && ((i = (r = this.cbs).onopentagname) === null || i === void 0 || i.call(r, "br"), (a = (o = this.cbs).onopentag) === null || a === void 0 || a.call(o, "br", {}, !0), (u = (s = this.cbs).onclosetag) === null || u === void 0 || u.call(s, "br", !1));
      else {
        var c = this.stack.lastIndexOf(l);
        if (c !== -1)
          if (this.cbs.onclosetag)
            for (var d = this.stack.length - c; d--; )
              this.cbs.onclosetag(this.stack.pop(), d !== 0);
          else
            this.stack.length = c;
        else
          !this.options.xmlMode && l === "p" && (this.emitOpenTag("p"), this.closeCurrentTag(!0));
      }
      this.startIndex = n + 1;
    }, t.prototype.onselfclosingtag = function(e) {
      this.endIndex = e, this.options.xmlMode || this.options.recognizeSelfClosing || this.foreignContext[this.foreignContext.length - 1] ? (this.closeCurrentTag(!1), this.startIndex = e + 1) : this.onopentagend(e);
    }, t.prototype.closeCurrentTag = function(e) {
      var n, r, i = this.tagname;
      this.endOpenTag(e), this.stack[this.stack.length - 1] === i && ((r = (n = this.cbs).onclosetag) === null || r === void 0 || r.call(n, i, !e), this.stack.pop());
    }, t.prototype.onattribname = function(e, n) {
      this.startIndex = e;
      var r = this.getSlice(e, n);
      this.attribname = this.lowerCaseAttributeNames ? r.toLowerCase() : r;
    }, t.prototype.onattribdata = function(e, n) {
      this.attribvalue += this.getSlice(e, n);
    }, t.prototype.onattribentity = function(e) {
      this.attribvalue += (0, wD.fromCodePoint)(e);
    }, t.prototype.onattribend = function(e, n) {
      var r, i;
      this.endIndex = n, (i = (r = this.cbs).onattribute) === null || i === void 0 || i.call(r, this.attribname, this.attribvalue, e === hb.QuoteType.Double ? '"' : e === hb.QuoteType.Single ? "'" : e === hb.QuoteType.NoValue ? void 0 : null), this.attribs && !Object.prototype.hasOwnProperty.call(this.attribs, this.attribname) && (this.attribs[this.attribname] = this.attribvalue), this.attribvalue = "";
    }, t.prototype.getInstructionName = function(e) {
      var n = e.search(wVe), r = n < 0 ? e : e.substr(0, n);
      return this.lowerCaseTagNames && (r = r.toLowerCase()), r;
    }, t.prototype.ondeclaration = function(e, n) {
      this.endIndex = n;
      var r = this.getSlice(e, n);
      if (this.cbs.onprocessinginstruction) {
        var i = this.getInstructionName(r);
        this.cbs.onprocessinginstruction("!".concat(i), "!".concat(r));
      }
      this.startIndex = n + 1;
    }, t.prototype.onprocessinginstruction = function(e, n) {
      this.endIndex = n;
      var r = this.getSlice(e, n);
      if (this.cbs.onprocessinginstruction) {
        var i = this.getInstructionName(r);
        this.cbs.onprocessinginstruction("?".concat(i), "?".concat(r));
      }
      this.startIndex = n + 1;
    }, t.prototype.oncomment = function(e, n, r) {
      var i, o, a, s;
      this.endIndex = n, (o = (i = this.cbs).oncomment) === null || o === void 0 || o.call(i, this.getSlice(e, n - r)), (s = (a = this.cbs).oncommentend) === null || s === void 0 || s.call(a), this.startIndex = n + 1;
    }, t.prototype.oncdata = function(e, n, r) {
      var i, o, a, s, u, l, c, d, f, h;
      this.endIndex = n;
      var p = this.getSlice(e, n - r);
      this.options.xmlMode || this.options.recognizeCDATA ? ((o = (i = this.cbs).oncdatastart) === null || o === void 0 || o.call(i), (s = (a = this.cbs).ontext) === null || s === void 0 || s.call(a, p), (l = (u = this.cbs).oncdataend) === null || l === void 0 || l.call(u)) : ((d = (c = this.cbs).oncomment) === null || d === void 0 || d.call(c, "[CDATA[".concat(p, "]]")), (h = (f = this.cbs).oncommentend) === null || h === void 0 || h.call(f)), this.startIndex = n + 1;
    }, t.prototype.onend = function() {
      var e, n;
      if (this.cbs.onclosetag) {
        this.endIndex = this.startIndex;
        for (var r = this.stack.length; r > 0; this.cbs.onclosetag(this.stack[--r], !0))
          ;
      }
      (n = (e = this.cbs).onend) === null || n === void 0 || n.call(e);
    }, t.prototype.reset = function() {
      var e, n, r, i;
      (n = (e = this.cbs).onreset) === null || n === void 0 || n.call(e), this.tokenizer.reset(), this.tagname = "", this.attribname = "", this.attribs = null, this.stack.length = 0, this.startIndex = 0, this.endIndex = 0, (i = (r = this.cbs).onparserinit) === null || i === void 0 || i.call(r, this), this.buffers.length = 0, this.bufferOffset = 0, this.writeIndex = 0, this.ended = !1;
    }, t.prototype.parseComplete = function(e) {
      this.reset(), this.end(e);
    }, t.prototype.getSlice = function(e, n) {
      for (; e - this.bufferOffset >= this.buffers[0].length; )
        this.shiftBuffer();
      for (var r = this.buffers[0].slice(e - this.bufferOffset, n - this.bufferOffset); n - this.bufferOffset > this.buffers[0].length; )
        this.shiftBuffer(), r += this.buffers[0].slice(0, n - this.bufferOffset);
      return r;
    }, t.prototype.shiftBuffer = function() {
      this.bufferOffset += this.buffers[0].length, this.writeIndex--, this.buffers.shift();
    }, t.prototype.write = function(e) {
      var n, r;
      if (this.ended) {
        (r = (n = this.cbs).onerror) === null || r === void 0 || r.call(n, new Error(".write() after done!"));
        return;
      }
      this.buffers.push(e), this.tokenizer.running && (this.tokenizer.write(e), this.writeIndex++);
    }, t.prototype.end = function(e) {
      var n, r;
      if (this.ended) {
        (r = (n = this.cbs).onerror) === null || r === void 0 || r.call(n, new Error(".end() after done!"));
        return;
      }
      e && this.write(e), this.ended = !0, this.tokenizer.end();
    }, t.prototype.pause = function() {
      this.tokenizer.pause();
    }, t.prototype.resume = function() {
      for (this.tokenizer.resume(); this.tokenizer.running && this.writeIndex < this.buffers.length; )
        this.tokenizer.write(this.buffers[this.writeIndex++]);
      this.ended && this.tokenizer.end();
    }, t.prototype.parseChunk = function(e) {
      this.write(e);
    }, t.prototype.done = function(e) {
      this.end(e);
    }, t;
  }()
);
q0.Parser = EVe;
var el = {}, Fp = {};
(function(t) {
  Object.defineProperty(t, "__esModule", { value: !0 }), t.Doctype = t.CDATA = t.Tag = t.Style = t.Script = t.Comment = t.Directive = t.Text = t.Root = t.isTag = t.ElementType = void 0;
  var e;
  (function(r) {
    r.Root = "root", r.Text = "text", r.Directive = "directive", r.Comment = "comment", r.Script = "script", r.Style = "style", r.Tag = "tag", r.CDATA = "cdata", r.Doctype = "doctype";
  })(e = t.ElementType || (t.ElementType = {}));
  function n(r) {
    return r.type === e.Tag || r.type === e.Script || r.type === e.Style;
  }
  t.isTag = n, t.Root = e.Root, t.Text = e.Text, t.Directive = e.Directive, t.Comment = e.Comment, t.Script = e.Script, t.Style = e.Style, t.Tag = e.Tag, t.CDATA = e.CDATA, t.Doctype = e.Doctype;
})(Fp);
var On = {}, Pc = ft && ft.__extends || /* @__PURE__ */ function() {
  var t = function(e, n) {
    return t = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(r, i) {
      r.__proto__ = i;
    } || function(r, i) {
      for (var o in i)
        Object.prototype.hasOwnProperty.call(i, o) && (r[o] = i[o]);
    }, t(e, n);
  };
  return function(e, n) {
    if (typeof n != "function" && n !== null)
      throw new TypeError("Class extends value " + String(n) + " is not a constructor or null");
    t(e, n);
    function r() {
      this.constructor = e;
    }
    e.prototype = n === null ? Object.create(n) : (r.prototype = n.prototype, new r());
  };
}(), b0 = ft && ft.__assign || function() {
  return b0 = Object.assign || function(t) {
    for (var e, n = 1, r = arguments.length; n < r; n++) {
      e = arguments[n];
      for (var i in e)
        Object.prototype.hasOwnProperty.call(e, i) && (t[i] = e[i]);
    }
    return t;
  }, b0.apply(this, arguments);
};
Object.defineProperty(On, "__esModule", { value: !0 });
On.cloneNode = On.hasChildren = On.isDocument = On.isDirective = On.isComment = On.isText = On.isCDATA = On.isTag = On.Element = On.Document = On.CDATA = On.NodeWithChildren = On.ProcessingInstruction = On.Comment = On.Text = On.DataNode = On.Node = void 0;
var Oo = Fp, Z9 = (
  /** @class */
  function() {
    function t() {
      this.parent = null, this.prev = null, this.next = null, this.startIndex = null, this.endIndex = null;
    }
    return Object.defineProperty(t.prototype, "parentNode", {
      // Read-write aliases for properties
      /**
       * Same as {@link parent}.
       * [DOM spec](https://dom.spec.whatwg.org)-compatible alias.
       */
      get: function() {
        return this.parent;
      },
      set: function(e) {
        this.parent = e;
      },
      enumerable: !1,
      configurable: !0
    }), Object.defineProperty(t.prototype, "previousSibling", {
      /**
       * Same as {@link prev}.
       * [DOM spec](https://dom.spec.whatwg.org)-compatible alias.
       */
      get: function() {
        return this.prev;
      },
      set: function(e) {
        this.prev = e;
      },
      enumerable: !1,
      configurable: !0
    }), Object.defineProperty(t.prototype, "nextSibling", {
      /**
       * Same as {@link next}.
       * [DOM spec](https://dom.spec.whatwg.org)-compatible alias.
       */
      get: function() {
        return this.next;
      },
      set: function(e) {
        this.next = e;
      },
      enumerable: !1,
      configurable: !0
    }), t.prototype.cloneNode = function(e) {
      return e === void 0 && (e = !1), J9(this, e);
    }, t;
  }()
);
On.Node = Z9;
var JC = (
  /** @class */
  function(t) {
    Pc(e, t);
    function e(n) {
      var r = t.call(this) || this;
      return r.data = n, r;
    }
    return Object.defineProperty(e.prototype, "nodeValue", {
      /**
       * Same as {@link data}.
       * [DOM spec](https://dom.spec.whatwg.org)-compatible alias.
       */
      get: function() {
        return this.data;
      },
      set: function(n) {
        this.data = n;
      },
      enumerable: !1,
      configurable: !0
    }), e;
  }(Z9)
);
On.DataNode = JC;
var DY = (
  /** @class */
  function(t) {
    Pc(e, t);
    function e() {
      var n = t !== null && t.apply(this, arguments) || this;
      return n.type = Oo.ElementType.Text, n;
    }
    return Object.defineProperty(e.prototype, "nodeType", {
      get: function() {
        return 3;
      },
      enumerable: !1,
      configurable: !0
    }), e;
  }(JC)
);
On.Text = DY;
var MY = (
  /** @class */
  function(t) {
    Pc(e, t);
    function e() {
      var n = t !== null && t.apply(this, arguments) || this;
      return n.type = Oo.ElementType.Comment, n;
    }
    return Object.defineProperty(e.prototype, "nodeType", {
      get: function() {
        return 8;
      },
      enumerable: !1,
      configurable: !0
    }), e;
  }(JC)
);
On.Comment = MY;
var FY = (
  /** @class */
  function(t) {
    Pc(e, t);
    function e(n, r) {
      var i = t.call(this, r) || this;
      return i.name = n, i.type = Oo.ElementType.Directive, i;
    }
    return Object.defineProperty(e.prototype, "nodeType", {
      get: function() {
        return 1;
      },
      enumerable: !1,
      configurable: !0
    }), e;
  }(JC)
);
On.ProcessingInstruction = FY;
var KC = (
  /** @class */
  function(t) {
    Pc(e, t);
    function e(n) {
      var r = t.call(this) || this;
      return r.children = n, r;
    }
    return Object.defineProperty(e.prototype, "firstChild", {
      // Aliases
      /** First child of the node. */
      get: function() {
        var n;
        return (n = this.children[0]) !== null && n !== void 0 ? n : null;
      },
      enumerable: !1,
      configurable: !0
    }), Object.defineProperty(e.prototype, "lastChild", {
      /** Last child of the node. */
      get: function() {
        return this.children.length > 0 ? this.children[this.children.length - 1] : null;
      },
      enumerable: !1,
      configurable: !0
    }), Object.defineProperty(e.prototype, "childNodes", {
      /**
       * Same as {@link children}.
       * [DOM spec](https://dom.spec.whatwg.org)-compatible alias.
       */
      get: function() {
        return this.children;
      },
      set: function(n) {
        this.children = n;
      },
      enumerable: !1,
      configurable: !0
    }), e;
  }(Z9)
);
On.NodeWithChildren = KC;
var LY = (
  /** @class */
  function(t) {
    Pc(e, t);
    function e() {
      var n = t !== null && t.apply(this, arguments) || this;
      return n.type = Oo.ElementType.CDATA, n;
    }
    return Object.defineProperty(e.prototype, "nodeType", {
      get: function() {
        return 4;
      },
      enumerable: !1,
      configurable: !0
    }), e;
  }(KC)
);
On.CDATA = LY;
var VY = (
  /** @class */
  function(t) {
    Pc(e, t);
    function e() {
      var n = t !== null && t.apply(this, arguments) || this;
      return n.type = Oo.ElementType.Root, n;
    }
    return Object.defineProperty(e.prototype, "nodeType", {
      get: function() {
        return 9;
      },
      enumerable: !1,
      configurable: !0
    }), e;
  }(KC)
);
On.Document = VY;
var BY = (
  /** @class */
  function(t) {
    Pc(e, t);
    function e(n, r, i, o) {
      i === void 0 && (i = []), o === void 0 && (o = n === "script" ? Oo.ElementType.Script : n === "style" ? Oo.ElementType.Style : Oo.ElementType.Tag);
      var a = t.call(this, i) || this;
      return a.name = n, a.attribs = r, a.type = o, a;
    }
    return Object.defineProperty(e.prototype, "nodeType", {
      get: function() {
        return 1;
      },
      enumerable: !1,
      configurable: !0
    }), Object.defineProperty(e.prototype, "tagName", {
      // DOM Level 1 aliases
      /**
       * Same as {@link name}.
       * [DOM spec](https://dom.spec.whatwg.org)-compatible alias.
       */
      get: function() {
        return this.name;
      },
      set: function(n) {
        this.name = n;
      },
      enumerable: !1,
      configurable: !0
    }), Object.defineProperty(e.prototype, "attributes", {
      get: function() {
        var n = this;
        return Object.keys(this.attribs).map(function(r) {
          var i, o;
          return {
            name: r,
            value: n.attribs[r],
            namespace: (i = n["x-attribsNamespace"]) === null || i === void 0 ? void 0 : i[r],
            prefix: (o = n["x-attribsPrefix"]) === null || o === void 0 ? void 0 : o[r]
          };
        });
      },
      enumerable: !1,
      configurable: !0
    }), e;
  }(KC)
);
On.Element = BY;
function HY(t) {
  return (0, Oo.isTag)(t);
}
On.isTag = HY;
function WY(t) {
  return t.type === Oo.ElementType.CDATA;
}
On.isCDATA = WY;
function jY(t) {
  return t.type === Oo.ElementType.Text;
}
On.isText = jY;
function zY(t) {
  return t.type === Oo.ElementType.Comment;
}
On.isComment = zY;
function GY(t) {
  return t.type === Oo.ElementType.Directive;
}
On.isDirective = GY;
function UY(t) {
  return t.type === Oo.ElementType.Root;
}
On.isDocument = UY;
function SVe(t) {
  return Object.prototype.hasOwnProperty.call(t, "children");
}
On.hasChildren = SVe;
function J9(t, e) {
  e === void 0 && (e = !1);
  var n;
  if (jY(t))
    n = new DY(t.data);
  else if (zY(t))
    n = new MY(t.data);
  else if (HY(t)) {
    var r = e ? A3(t.children) : [], i = new BY(t.name, b0({}, t.attribs), r);
    r.forEach(function(u) {
      return u.parent = i;
    }), t.namespace != null && (i.namespace = t.namespace), t["x-attribsNamespace"] && (i["x-attribsNamespace"] = b0({}, t["x-attribsNamespace"])), t["x-attribsPrefix"] && (i["x-attribsPrefix"] = b0({}, t["x-attribsPrefix"])), n = i;
  } else if (WY(t)) {
    var r = e ? A3(t.children) : [], o = new LY(r);
    r.forEach(function(l) {
      return l.parent = o;
    }), n = o;
  } else if (UY(t)) {
    var r = e ? A3(t.children) : [], a = new VY(r);
    r.forEach(function(l) {
      return l.parent = a;
    }), t["x-mode"] && (a["x-mode"] = t["x-mode"]), n = a;
  } else if (GY(t)) {
    var s = new FY(t.name, t.data);
    t["x-name"] != null && (s["x-name"] = t["x-name"], s["x-publicId"] = t["x-publicId"], s["x-systemId"] = t["x-systemId"]), n = s;
  } else
    throw new Error("Not implemented yet: ".concat(t.type));
  return n.startIndex = t.startIndex, n.endIndex = t.endIndex, t.sourceCodeLocation != null && (n.sourceCodeLocation = t.sourceCodeLocation), n;
}
On.cloneNode = J9;
function A3(t) {
  for (var e = t.map(function(r) {
    return J9(r, !0);
  }), n = 1; n < e.length; n++)
    e[n].prev = e[n - 1], e[n - 1].next = e[n];
  return e;
}
(function(t) {
  var e = ft && ft.__createBinding || (Object.create ? function(s, u, l, c) {
    c === void 0 && (c = l);
    var d = Object.getOwnPropertyDescriptor(u, l);
    (!d || ("get" in d ? !u.__esModule : d.writable || d.configurable)) && (d = { enumerable: !0, get: function() {
      return u[l];
    } }), Object.defineProperty(s, c, d);
  } : function(s, u, l, c) {
    c === void 0 && (c = l), s[c] = u[l];
  }), n = ft && ft.__exportStar || function(s, u) {
    for (var l in s)
      l !== "default" && !Object.prototype.hasOwnProperty.call(u, l) && e(u, s, l);
  };
  Object.defineProperty(t, "__esModule", { value: !0 }), t.DomHandler = void 0;
  var r = Fp, i = On;
  n(On, t);
  var o = {
    withStartIndices: !1,
    withEndIndices: !1,
    xmlMode: !1
  }, a = (
    /** @class */
    function() {
      function s(u, l, c) {
        this.dom = [], this.root = new i.Document(this.dom), this.done = !1, this.tagStack = [this.root], this.lastNode = null, this.parser = null, typeof l == "function" && (c = l, l = o), typeof u == "object" && (l = u, u = void 0), this.callback = u ?? null, this.options = l ?? o, this.elementCB = c ?? null;
      }
      return s.prototype.onparserinit = function(u) {
        this.parser = u;
      }, s.prototype.onreset = function() {
        this.dom = [], this.root = new i.Document(this.dom), this.done = !1, this.tagStack = [this.root], this.lastNode = null, this.parser = null;
      }, s.prototype.onend = function() {
        this.done || (this.done = !0, this.parser = null, this.handleCallback(null));
      }, s.prototype.onerror = function(u) {
        this.handleCallback(u);
      }, s.prototype.onclosetag = function() {
        this.lastNode = null;
        var u = this.tagStack.pop();
        this.options.withEndIndices && (u.endIndex = this.parser.endIndex), this.elementCB && this.elementCB(u);
      }, s.prototype.onopentag = function(u, l) {
        var c = this.options.xmlMode ? r.ElementType.Tag : void 0, d = new i.Element(u, l, void 0, c);
        this.addNode(d), this.tagStack.push(d);
      }, s.prototype.ontext = function(u) {
        var l = this.lastNode;
        if (l && l.type === r.ElementType.Text)
          l.data += u, this.options.withEndIndices && (l.endIndex = this.parser.endIndex);
        else {
          var c = new i.Text(u);
          this.addNode(c), this.lastNode = c;
        }
      }, s.prototype.oncomment = function(u) {
        if (this.lastNode && this.lastNode.type === r.ElementType.Comment) {
          this.lastNode.data += u;
          return;
        }
        var l = new i.Comment(u);
        this.addNode(l), this.lastNode = l;
      }, s.prototype.oncommentend = function() {
        this.lastNode = null;
      }, s.prototype.oncdatastart = function() {
        var u = new i.Text(""), l = new i.CDATA([u]);
        this.addNode(l), u.parent = l, this.lastNode = u;
      }, s.prototype.oncdataend = function() {
        this.lastNode = null;
      }, s.prototype.onprocessinginstruction = function(u, l) {
        var c = new i.ProcessingInstruction(u, l);
        this.addNode(c);
      }, s.prototype.handleCallback = function(u) {
        if (typeof this.callback == "function")
          this.callback(u, this.dom);
        else if (u)
          throw u;
      }, s.prototype.addNode = function(u) {
        var l = this.tagStack[this.tagStack.length - 1], c = l.children[l.children.length - 1];
        this.options.withStartIndices && (u.startIndex = this.parser.startIndex), this.options.withEndIndices && (u.endIndex = this.parser.endIndex), l.children.push(u), c && (u.prev = c, c.next = u), u.parent = l, this.lastNode = null;
      }, s;
    }()
  );
  t.DomHandler = a, t.default = a;
})(el);
var py = {}, na = {}, nv = {}, XY = {}, Rd = {}, K9 = {};
Object.defineProperty(K9, "__esModule", { value: !0 });
function pb(t) {
  for (var e = 1; e < t.length; e++)
    t[e][0] += t[e - 1][0] + 1;
  return t;
}
K9.default = new Map(/* @__PURE__ */ pb([[9, "&Tab;"], [0, "&NewLine;"], [22, "&excl;"], [0, "&quot;"], [0, "&num;"], [0, "&dollar;"], [0, "&percnt;"], [0, "&amp;"], [0, "&apos;"], [0, "&lpar;"], [0, "&rpar;"], [0, "&ast;"], [0, "&plus;"], [0, "&comma;"], [1, "&period;"], [0, "&sol;"], [10, "&colon;"], [0, "&semi;"], [0, { v: "&lt;", n: 8402, o: "&nvlt;" }], [0, { v: "&equals;", n: 8421, o: "&bne;" }], [0, { v: "&gt;", n: 8402, o: "&nvgt;" }], [0, "&quest;"], [0, "&commat;"], [26, "&lbrack;"], [0, "&bsol;"], [0, "&rbrack;"], [0, "&Hat;"], [0, "&lowbar;"], [0, "&DiacriticalGrave;"], [5, { n: 106, o: "&fjlig;" }], [20, "&lbrace;"], [0, "&verbar;"], [0, "&rbrace;"], [34, "&nbsp;"], [0, "&iexcl;"], [0, "&cent;"], [0, "&pound;"], [0, "&curren;"], [0, "&yen;"], [0, "&brvbar;"], [0, "&sect;"], [0, "&die;"], [0, "&copy;"], [0, "&ordf;"], [0, "&laquo;"], [0, "&not;"], [0, "&shy;"], [0, "&circledR;"], [0, "&macr;"], [0, "&deg;"], [0, "&PlusMinus;"], [0, "&sup2;"], [0, "&sup3;"], [0, "&acute;"], [0, "&micro;"], [0, "&para;"], [0, "&centerdot;"], [0, "&cedil;"], [0, "&sup1;"], [0, "&ordm;"], [0, "&raquo;"], [0, "&frac14;"], [0, "&frac12;"], [0, "&frac34;"], [0, "&iquest;"], [0, "&Agrave;"], [0, "&Aacute;"], [0, "&Acirc;"], [0, "&Atilde;"], [0, "&Auml;"], [0, "&angst;"], [0, "&AElig;"], [0, "&Ccedil;"], [0, "&Egrave;"], [0, "&Eacute;"], [0, "&Ecirc;"], [0, "&Euml;"], [0, "&Igrave;"], [0, "&Iacute;"], [0, "&Icirc;"], [0, "&Iuml;"], [0, "&ETH;"], [0, "&Ntilde;"], [0, "&Ograve;"], [0, "&Oacute;"], [0, "&Ocirc;"], [0, "&Otilde;"], [0, "&Ouml;"], [0, "&times;"], [0, "&Oslash;"], [0, "&Ugrave;"], [0, "&Uacute;"], [0, "&Ucirc;"], [0, "&Uuml;"], [0, "&Yacute;"], [0, "&THORN;"], [0, "&szlig;"], [0, "&agrave;"], [0, "&aacute;"], [0, "&acirc;"], [0, "&atilde;"], [0, "&auml;"], [0, "&aring;"], [0, "&aelig;"], [0, "&ccedil;"], [0, "&egrave;"], [0, "&eacute;"], [0, "&ecirc;"], [0, "&euml;"], [0, "&igrave;"], [0, "&iacute;"], [0, "&icirc;"], [0, "&iuml;"], [0, "&eth;"], [0, "&ntilde;"], [0, "&ograve;"], [0, "&oacute;"], [0, "&ocirc;"], [0, "&otilde;"], [0, "&ouml;"], [0, "&div;"], [0, "&oslash;"], [0, "&ugrave;"], [0, "&uacute;"], [0, "&ucirc;"], [0, "&uuml;"], [0, "&yacute;"], [0, "&thorn;"], [0, "&yuml;"], [0, "&Amacr;"], [0, "&amacr;"], [0, "&Abreve;"], [0, "&abreve;"], [0, "&Aogon;"], [0, "&aogon;"], [0, "&Cacute;"], [0, "&cacute;"], [0, "&Ccirc;"], [0, "&ccirc;"], [0, "&Cdot;"], [0, "&cdot;"], [0, "&Ccaron;"], [0, "&ccaron;"], [0, "&Dcaron;"], [0, "&dcaron;"], [0, "&Dstrok;"], [0, "&dstrok;"], [0, "&Emacr;"], [0, "&emacr;"], [2, "&Edot;"], [0, "&edot;"], [0, "&Eogon;"], [0, "&eogon;"], [0, "&Ecaron;"], [0, "&ecaron;"], [0, "&Gcirc;"], [0, "&gcirc;"], [0, "&Gbreve;"], [0, "&gbreve;"], [0, "&Gdot;"], [0, "&gdot;"], [0, "&Gcedil;"], [1, "&Hcirc;"], [0, "&hcirc;"], [0, "&Hstrok;"], [0, "&hstrok;"], [0, "&Itilde;"], [0, "&itilde;"], [0, "&Imacr;"], [0, "&imacr;"], [2, "&Iogon;"], [0, "&iogon;"], [0, "&Idot;"], [0, "&imath;"], [0, "&IJlig;"], [0, "&ijlig;"], [0, "&Jcirc;"], [0, "&jcirc;"], [0, "&Kcedil;"], [0, "&kcedil;"], [0, "&kgreen;"], [0, "&Lacute;"], [0, "&lacute;"], [0, "&Lcedil;"], [0, "&lcedil;"], [0, "&Lcaron;"], [0, "&lcaron;"], [0, "&Lmidot;"], [0, "&lmidot;"], [0, "&Lstrok;"], [0, "&lstrok;"], [0, "&Nacute;"], [0, "&nacute;"], [0, "&Ncedil;"], [0, "&ncedil;"], [0, "&Ncaron;"], [0, "&ncaron;"], [0, "&napos;"], [0, "&ENG;"], [0, "&eng;"], [0, "&Omacr;"], [0, "&omacr;"], [2, "&Odblac;"], [0, "&odblac;"], [0, "&OElig;"], [0, "&oelig;"], [0, "&Racute;"], [0, "&racute;"], [0, "&Rcedil;"], [0, "&rcedil;"], [0, "&Rcaron;"], [0, "&rcaron;"], [0, "&Sacute;"], [0, "&sacute;"], [0, "&Scirc;"], [0, "&scirc;"], [0, "&Scedil;"], [0, "&scedil;"], [0, "&Scaron;"], [0, "&scaron;"], [0, "&Tcedil;"], [0, "&tcedil;"], [0, "&Tcaron;"], [0, "&tcaron;"], [0, "&Tstrok;"], [0, "&tstrok;"], [0, "&Utilde;"], [0, "&utilde;"], [0, "&Umacr;"], [0, "&umacr;"], [0, "&Ubreve;"], [0, "&ubreve;"], [0, "&Uring;"], [0, "&uring;"], [0, "&Udblac;"], [0, "&udblac;"], [0, "&Uogon;"], [0, "&uogon;"], [0, "&Wcirc;"], [0, "&wcirc;"], [0, "&Ycirc;"], [0, "&ycirc;"], [0, "&Yuml;"], [0, "&Zacute;"], [0, "&zacute;"], [0, "&Zdot;"], [0, "&zdot;"], [0, "&Zcaron;"], [0, "&zcaron;"], [19, "&fnof;"], [34, "&imped;"], [63, "&gacute;"], [65, "&jmath;"], [142, "&circ;"], [0, "&caron;"], [16, "&breve;"], [0, "&DiacriticalDot;"], [0, "&ring;"], [0, "&ogon;"], [0, "&DiacriticalTilde;"], [0, "&dblac;"], [51, "&DownBreve;"], [127, "&Alpha;"], [0, "&Beta;"], [0, "&Gamma;"], [0, "&Delta;"], [0, "&Epsilon;"], [0, "&Zeta;"], [0, "&Eta;"], [0, "&Theta;"], [0, "&Iota;"], [0, "&Kappa;"], [0, "&Lambda;"], [0, "&Mu;"], [0, "&Nu;"], [0, "&Xi;"], [0, "&Omicron;"], [0, "&Pi;"], [0, "&Rho;"], [1, "&Sigma;"], [0, "&Tau;"], [0, "&Upsilon;"], [0, "&Phi;"], [0, "&Chi;"], [0, "&Psi;"], [0, "&ohm;"], [7, "&alpha;"], [0, "&beta;"], [0, "&gamma;"], [0, "&delta;"], [0, "&epsi;"], [0, "&zeta;"], [0, "&eta;"], [0, "&theta;"], [0, "&iota;"], [0, "&kappa;"], [0, "&lambda;"], [0, "&mu;"], [0, "&nu;"], [0, "&xi;"], [0, "&omicron;"], [0, "&pi;"], [0, "&rho;"], [0, "&sigmaf;"], [0, "&sigma;"], [0, "&tau;"], [0, "&upsi;"], [0, "&phi;"], [0, "&chi;"], [0, "&psi;"], [0, "&omega;"], [7, "&thetasym;"], [0, "&Upsi;"], [2, "&phiv;"], [0, "&piv;"], [5, "&Gammad;"], [0, "&digamma;"], [18, "&kappav;"], [0, "&rhov;"], [3, "&epsiv;"], [0, "&backepsilon;"], [10, "&IOcy;"], [0, "&DJcy;"], [0, "&GJcy;"], [0, "&Jukcy;"], [0, "&DScy;"], [0, "&Iukcy;"], [0, "&YIcy;"], [0, "&Jsercy;"], [0, "&LJcy;"], [0, "&NJcy;"], [0, "&TSHcy;"], [0, "&KJcy;"], [1, "&Ubrcy;"], [0, "&DZcy;"], [0, "&Acy;"], [0, "&Bcy;"], [0, "&Vcy;"], [0, "&Gcy;"], [0, "&Dcy;"], [0, "&IEcy;"], [0, "&ZHcy;"], [0, "&Zcy;"], [0, "&Icy;"], [0, "&Jcy;"], [0, "&Kcy;"], [0, "&Lcy;"], [0, "&Mcy;"], [0, "&Ncy;"], [0, "&Ocy;"], [0, "&Pcy;"], [0, "&Rcy;"], [0, "&Scy;"], [0, "&Tcy;"], [0, "&Ucy;"], [0, "&Fcy;"], [0, "&KHcy;"], [0, "&TScy;"], [0, "&CHcy;"], [0, "&SHcy;"], [0, "&SHCHcy;"], [0, "&HARDcy;"], [0, "&Ycy;"], [0, "&SOFTcy;"], [0, "&Ecy;"], [0, "&YUcy;"], [0, "&YAcy;"], [0, "&acy;"], [0, "&bcy;"], [0, "&vcy;"], [0, "&gcy;"], [0, "&dcy;"], [0, "&iecy;"], [0, "&zhcy;"], [0, "&zcy;"], [0, "&icy;"], [0, "&jcy;"], [0, "&kcy;"], [0, "&lcy;"], [0, "&mcy;"], [0, "&ncy;"], [0, "&ocy;"], [0, "&pcy;"], [0, "&rcy;"], [0, "&scy;"], [0, "&tcy;"], [0, "&ucy;"], [0, "&fcy;"], [0, "&khcy;"], [0, "&tscy;"], [0, "&chcy;"], [0, "&shcy;"], [0, "&shchcy;"], [0, "&hardcy;"], [0, "&ycy;"], [0, "&softcy;"], [0, "&ecy;"], [0, "&yucy;"], [0, "&yacy;"], [1, "&iocy;"], [0, "&djcy;"], [0, "&gjcy;"], [0, "&jukcy;"], [0, "&dscy;"], [0, "&iukcy;"], [0, "&yicy;"], [0, "&jsercy;"], [0, "&ljcy;"], [0, "&njcy;"], [0, "&tshcy;"], [0, "&kjcy;"], [1, "&ubrcy;"], [0, "&dzcy;"], [7074, "&ensp;"], [0, "&emsp;"], [0, "&emsp13;"], [0, "&emsp14;"], [1, "&numsp;"], [0, "&puncsp;"], [0, "&ThinSpace;"], [0, "&hairsp;"], [0, "&NegativeMediumSpace;"], [0, "&zwnj;"], [0, "&zwj;"], [0, "&lrm;"], [0, "&rlm;"], [0, "&dash;"], [2, "&ndash;"], [0, "&mdash;"], [0, "&horbar;"], [0, "&Verbar;"], [1, "&lsquo;"], [0, "&CloseCurlyQuote;"], [0, "&lsquor;"], [1, "&ldquo;"], [0, "&CloseCurlyDoubleQuote;"], [0, "&bdquo;"], [1, "&dagger;"], [0, "&Dagger;"], [0, "&bull;"], [2, "&nldr;"], [0, "&hellip;"], [9, "&permil;"], [0, "&pertenk;"], [0, "&prime;"], [0, "&Prime;"], [0, "&tprime;"], [0, "&backprime;"], [3, "&lsaquo;"], [0, "&rsaquo;"], [3, "&oline;"], [2, "&caret;"], [1, "&hybull;"], [0, "&frasl;"], [10, "&bsemi;"], [7, "&qprime;"], [7, { v: "&MediumSpace;", n: 8202, o: "&ThickSpace;" }], [0, "&NoBreak;"], [0, "&af;"], [0, "&InvisibleTimes;"], [0, "&ic;"], [72, "&euro;"], [46, "&tdot;"], [0, "&DotDot;"], [37, "&complexes;"], [2, "&incare;"], [4, "&gscr;"], [0, "&hamilt;"], [0, "&Hfr;"], [0, "&Hopf;"], [0, "&planckh;"], [0, "&hbar;"], [0, "&imagline;"], [0, "&Ifr;"], [0, "&lagran;"], [0, "&ell;"], [1, "&naturals;"], [0, "&numero;"], [0, "&copysr;"], [0, "&weierp;"], [0, "&Popf;"], [0, "&Qopf;"], [0, "&realine;"], [0, "&real;"], [0, "&reals;"], [0, "&rx;"], [3, "&trade;"], [1, "&integers;"], [2, "&mho;"], [0, "&zeetrf;"], [0, "&iiota;"], [2, "&bernou;"], [0, "&Cayleys;"], [1, "&escr;"], [0, "&Escr;"], [0, "&Fouriertrf;"], [1, "&Mellintrf;"], [0, "&order;"], [0, "&alefsym;"], [0, "&beth;"], [0, "&gimel;"], [0, "&daleth;"], [12, "&CapitalDifferentialD;"], [0, "&dd;"], [0, "&ee;"], [0, "&ii;"], [10, "&frac13;"], [0, "&frac23;"], [0, "&frac15;"], [0, "&frac25;"], [0, "&frac35;"], [0, "&frac45;"], [0, "&frac16;"], [0, "&frac56;"], [0, "&frac18;"], [0, "&frac38;"], [0, "&frac58;"], [0, "&frac78;"], [49, "&larr;"], [0, "&ShortUpArrow;"], [0, "&rarr;"], [0, "&darr;"], [0, "&harr;"], [0, "&updownarrow;"], [0, "&nwarr;"], [0, "&nearr;"], [0, "&LowerRightArrow;"], [0, "&LowerLeftArrow;"], [0, "&nlarr;"], [0, "&nrarr;"], [1, { v: "&rarrw;", n: 824, o: "&nrarrw;" }], [0, "&Larr;"], [0, "&Uarr;"], [0, "&Rarr;"], [0, "&Darr;"], [0, "&larrtl;"], [0, "&rarrtl;"], [0, "&LeftTeeArrow;"], [0, "&mapstoup;"], [0, "&map;"], [0, "&DownTeeArrow;"], [1, "&hookleftarrow;"], [0, "&hookrightarrow;"], [0, "&larrlp;"], [0, "&looparrowright;"], [0, "&harrw;"], [0, "&nharr;"], [1, "&lsh;"], [0, "&rsh;"], [0, "&ldsh;"], [0, "&rdsh;"], [1, "&crarr;"], [0, "&cularr;"], [0, "&curarr;"], [2, "&circlearrowleft;"], [0, "&circlearrowright;"], [0, "&leftharpoonup;"], [0, "&DownLeftVector;"], [0, "&RightUpVector;"], [0, "&LeftUpVector;"], [0, "&rharu;"], [0, "&DownRightVector;"], [0, "&dharr;"], [0, "&dharl;"], [0, "&RightArrowLeftArrow;"], [0, "&udarr;"], [0, "&LeftArrowRightArrow;"], [0, "&leftleftarrows;"], [0, "&upuparrows;"], [0, "&rightrightarrows;"], [0, "&ddarr;"], [0, "&leftrightharpoons;"], [0, "&Equilibrium;"], [0, "&nlArr;"], [0, "&nhArr;"], [0, "&nrArr;"], [0, "&DoubleLeftArrow;"], [0, "&DoubleUpArrow;"], [0, "&DoubleRightArrow;"], [0, "&dArr;"], [0, "&DoubleLeftRightArrow;"], [0, "&DoubleUpDownArrow;"], [0, "&nwArr;"], [0, "&neArr;"], [0, "&seArr;"], [0, "&swArr;"], [0, "&lAarr;"], [0, "&rAarr;"], [1, "&zigrarr;"], [6, "&larrb;"], [0, "&rarrb;"], [15, "&DownArrowUpArrow;"], [7, "&loarr;"], [0, "&roarr;"], [0, "&hoarr;"], [0, "&forall;"], [0, "&comp;"], [0, { v: "&part;", n: 824, o: "&npart;" }], [0, "&exist;"], [0, "&nexist;"], [0, "&empty;"], [1, "&Del;"], [0, "&Element;"], [0, "&NotElement;"], [1, "&ni;"], [0, "&notni;"], [2, "&prod;"], [0, "&coprod;"], [0, "&sum;"], [0, "&minus;"], [0, "&MinusPlus;"], [0, "&dotplus;"], [1, "&Backslash;"], [0, "&lowast;"], [0, "&compfn;"], [1, "&radic;"], [2, "&prop;"], [0, "&infin;"], [0, "&angrt;"], [0, { v: "&ang;", n: 8402, o: "&nang;" }], [0, "&angmsd;"], [0, "&angsph;"], [0, "&mid;"], [0, "&nmid;"], [0, "&DoubleVerticalBar;"], [0, "&NotDoubleVerticalBar;"], [0, "&and;"], [0, "&or;"], [0, { v: "&cap;", n: 65024, o: "&caps;" }], [0, { v: "&cup;", n: 65024, o: "&cups;" }], [0, "&int;"], [0, "&Int;"], [0, "&iiint;"], [0, "&conint;"], [0, "&Conint;"], [0, "&Cconint;"], [0, "&cwint;"], [0, "&ClockwiseContourIntegral;"], [0, "&awconint;"], [0, "&there4;"], [0, "&becaus;"], [0, "&ratio;"], [0, "&Colon;"], [0, "&dotminus;"], [1, "&mDDot;"], [0, "&homtht;"], [0, { v: "&sim;", n: 8402, o: "&nvsim;" }], [0, { v: "&backsim;", n: 817, o: "&race;" }], [0, { v: "&ac;", n: 819, o: "&acE;" }], [0, "&acd;"], [0, "&VerticalTilde;"], [0, "&NotTilde;"], [0, { v: "&eqsim;", n: 824, o: "&nesim;" }], [0, "&sime;"], [0, "&NotTildeEqual;"], [0, "&cong;"], [0, "&simne;"], [0, "&ncong;"], [0, "&ap;"], [0, "&nap;"], [0, "&ape;"], [0, { v: "&apid;", n: 824, o: "&napid;" }], [0, "&backcong;"], [0, { v: "&asympeq;", n: 8402, o: "&nvap;" }], [0, { v: "&bump;", n: 824, o: "&nbump;" }], [0, { v: "&bumpe;", n: 824, o: "&nbumpe;" }], [0, { v: "&doteq;", n: 824, o: "&nedot;" }], [0, "&doteqdot;"], [0, "&efDot;"], [0, "&erDot;"], [0, "&Assign;"], [0, "&ecolon;"], [0, "&ecir;"], [0, "&circeq;"], [1, "&wedgeq;"], [0, "&veeeq;"], [1, "&triangleq;"], [2, "&equest;"], [0, "&ne;"], [0, { v: "&Congruent;", n: 8421, o: "&bnequiv;" }], [0, "&nequiv;"], [1, { v: "&le;", n: 8402, o: "&nvle;" }], [0, { v: "&ge;", n: 8402, o: "&nvge;" }], [0, { v: "&lE;", n: 824, o: "&nlE;" }], [0, { v: "&gE;", n: 824, o: "&ngE;" }], [0, { v: "&lnE;", n: 65024, o: "&lvertneqq;" }], [0, { v: "&gnE;", n: 65024, o: "&gvertneqq;" }], [0, { v: "&ll;", n: new Map(/* @__PURE__ */ pb([[824, "&nLtv;"], [7577, "&nLt;"]])) }], [0, { v: "&gg;", n: new Map(/* @__PURE__ */ pb([[824, "&nGtv;"], [7577, "&nGt;"]])) }], [0, "&between;"], [0, "&NotCupCap;"], [0, "&nless;"], [0, "&ngt;"], [0, "&nle;"], [0, "&nge;"], [0, "&lesssim;"], [0, "&GreaterTilde;"], [0, "&nlsim;"], [0, "&ngsim;"], [0, "&LessGreater;"], [0, "&gl;"], [0, "&NotLessGreater;"], [0, "&NotGreaterLess;"], [0, "&pr;"], [0, "&sc;"], [0, "&prcue;"], [0, "&sccue;"], [0, "&PrecedesTilde;"], [0, { v: "&scsim;", n: 824, o: "&NotSucceedsTilde;" }], [0, "&NotPrecedes;"], [0, "&NotSucceeds;"], [0, { v: "&sub;", n: 8402, o: "&NotSubset;" }], [0, { v: "&sup;", n: 8402, o: "&NotSuperset;" }], [0, "&nsub;"], [0, "&nsup;"], [0, "&sube;"], [0, "&supe;"], [0, "&NotSubsetEqual;"], [0, "&NotSupersetEqual;"], [0, { v: "&subne;", n: 65024, o: "&varsubsetneq;" }], [0, { v: "&supne;", n: 65024, o: "&varsupsetneq;" }], [1, "&cupdot;"], [0, "&UnionPlus;"], [0, { v: "&sqsub;", n: 824, o: "&NotSquareSubset;" }], [0, { v: "&sqsup;", n: 824, o: "&NotSquareSuperset;" }], [0, "&sqsube;"], [0, "&sqsupe;"], [0, { v: "&sqcap;", n: 65024, o: "&sqcaps;" }], [0, { v: "&sqcup;", n: 65024, o: "&sqcups;" }], [0, "&CirclePlus;"], [0, "&CircleMinus;"], [0, "&CircleTimes;"], [0, "&osol;"], [0, "&CircleDot;"], [0, "&circledcirc;"], [0, "&circledast;"], [1, "&circleddash;"], [0, "&boxplus;"], [0, "&boxminus;"], [0, "&boxtimes;"], [0, "&dotsquare;"], [0, "&RightTee;"], [0, "&dashv;"], [0, "&DownTee;"], [0, "&bot;"], [1, "&models;"], [0, "&DoubleRightTee;"], [0, "&Vdash;"], [0, "&Vvdash;"], [0, "&VDash;"], [0, "&nvdash;"], [0, "&nvDash;"], [0, "&nVdash;"], [0, "&nVDash;"], [0, "&prurel;"], [1, "&LeftTriangle;"], [0, "&RightTriangle;"], [0, { v: "&LeftTriangleEqual;", n: 8402, o: "&nvltrie;" }], [0, { v: "&RightTriangleEqual;", n: 8402, o: "&nvrtrie;" }], [0, "&origof;"], [0, "&imof;"], [0, "&multimap;"], [0, "&hercon;"], [0, "&intcal;"], [0, "&veebar;"], [1, "&barvee;"], [0, "&angrtvb;"], [0, "&lrtri;"], [0, "&bigwedge;"], [0, "&bigvee;"], [0, "&bigcap;"], [0, "&bigcup;"], [0, "&diam;"], [0, "&sdot;"], [0, "&sstarf;"], [0, "&divideontimes;"], [0, "&bowtie;"], [0, "&ltimes;"], [0, "&rtimes;"], [0, "&leftthreetimes;"], [0, "&rightthreetimes;"], [0, "&backsimeq;"], [0, "&curlyvee;"], [0, "&curlywedge;"], [0, "&Sub;"], [0, "&Sup;"], [0, "&Cap;"], [0, "&Cup;"], [0, "&fork;"], [0, "&epar;"], [0, "&lessdot;"], [0, "&gtdot;"], [0, { v: "&Ll;", n: 824, o: "&nLl;" }], [0, { v: "&Gg;", n: 824, o: "&nGg;" }], [0, { v: "&leg;", n: 65024, o: "&lesg;" }], [0, { v: "&gel;", n: 65024, o: "&gesl;" }], [2, "&cuepr;"], [0, "&cuesc;"], [0, "&NotPrecedesSlantEqual;"], [0, "&NotSucceedsSlantEqual;"], [0, "&NotSquareSubsetEqual;"], [0, "&NotSquareSupersetEqual;"], [2, "&lnsim;"], [0, "&gnsim;"], [0, "&precnsim;"], [0, "&scnsim;"], [0, "&nltri;"], [0, "&NotRightTriangle;"], [0, "&nltrie;"], [0, "&NotRightTriangleEqual;"], [0, "&vellip;"], [0, "&ctdot;"], [0, "&utdot;"], [0, "&dtdot;"], [0, "&disin;"], [0, "&isinsv;"], [0, "&isins;"], [0, { v: "&isindot;", n: 824, o: "&notindot;" }], [0, "&notinvc;"], [0, "&notinvb;"], [1, { v: "&isinE;", n: 824, o: "&notinE;" }], [0, "&nisd;"], [0, "&xnis;"], [0, "&nis;"], [0, "&notnivc;"], [0, "&notnivb;"], [6, "&barwed;"], [0, "&Barwed;"], [1, "&lceil;"], [0, "&rceil;"], [0, "&LeftFloor;"], [0, "&rfloor;"], [0, "&drcrop;"], [0, "&dlcrop;"], [0, "&urcrop;"], [0, "&ulcrop;"], [0, "&bnot;"], [1, "&profline;"], [0, "&profsurf;"], [1, "&telrec;"], [0, "&target;"], [5, "&ulcorn;"], [0, "&urcorn;"], [0, "&dlcorn;"], [0, "&drcorn;"], [2, "&frown;"], [0, "&smile;"], [9, "&cylcty;"], [0, "&profalar;"], [7, "&topbot;"], [6, "&ovbar;"], [1, "&solbar;"], [60, "&angzarr;"], [51, "&lmoustache;"], [0, "&rmoustache;"], [2, "&OverBracket;"], [0, "&bbrk;"], [0, "&bbrktbrk;"], [37, "&OverParenthesis;"], [0, "&UnderParenthesis;"], [0, "&OverBrace;"], [0, "&UnderBrace;"], [2, "&trpezium;"], [4, "&elinters;"], [59, "&blank;"], [164, "&circledS;"], [55, "&boxh;"], [1, "&boxv;"], [9, "&boxdr;"], [3, "&boxdl;"], [3, "&boxur;"], [3, "&boxul;"], [3, "&boxvr;"], [7, "&boxvl;"], [7, "&boxhd;"], [7, "&boxhu;"], [7, "&boxvh;"], [19, "&boxH;"], [0, "&boxV;"], [0, "&boxdR;"], [0, "&boxDr;"], [0, "&boxDR;"], [0, "&boxdL;"], [0, "&boxDl;"], [0, "&boxDL;"], [0, "&boxuR;"], [0, "&boxUr;"], [0, "&boxUR;"], [0, "&boxuL;"], [0, "&boxUl;"], [0, "&boxUL;"], [0, "&boxvR;"], [0, "&boxVr;"], [0, "&boxVR;"], [0, "&boxvL;"], [0, "&boxVl;"], [0, "&boxVL;"], [0, "&boxHd;"], [0, "&boxhD;"], [0, "&boxHD;"], [0, "&boxHu;"], [0, "&boxhU;"], [0, "&boxHU;"], [0, "&boxvH;"], [0, "&boxVh;"], [0, "&boxVH;"], [19, "&uhblk;"], [3, "&lhblk;"], [3, "&block;"], [8, "&blk14;"], [0, "&blk12;"], [0, "&blk34;"], [13, "&square;"], [8, "&blacksquare;"], [0, "&EmptyVerySmallSquare;"], [1, "&rect;"], [0, "&marker;"], [2, "&fltns;"], [1, "&bigtriangleup;"], [0, "&blacktriangle;"], [0, "&triangle;"], [2, "&blacktriangleright;"], [0, "&rtri;"], [3, "&bigtriangledown;"], [0, "&blacktriangledown;"], [0, "&dtri;"], [2, "&blacktriangleleft;"], [0, "&ltri;"], [6, "&loz;"], [0, "&cir;"], [32, "&tridot;"], [2, "&bigcirc;"], [8, "&ultri;"], [0, "&urtri;"], [0, "&lltri;"], [0, "&EmptySmallSquare;"], [0, "&FilledSmallSquare;"], [8, "&bigstar;"], [0, "&star;"], [7, "&phone;"], [49, "&female;"], [1, "&male;"], [29, "&spades;"], [2, "&clubs;"], [1, "&hearts;"], [0, "&diamondsuit;"], [3, "&sung;"], [2, "&flat;"], [0, "&natural;"], [0, "&sharp;"], [163, "&check;"], [3, "&cross;"], [8, "&malt;"], [21, "&sext;"], [33, "&VerticalSeparator;"], [25, "&lbbrk;"], [0, "&rbbrk;"], [84, "&bsolhsub;"], [0, "&suphsol;"], [28, "&LeftDoubleBracket;"], [0, "&RightDoubleBracket;"], [0, "&lang;"], [0, "&rang;"], [0, "&Lang;"], [0, "&Rang;"], [0, "&loang;"], [0, "&roang;"], [7, "&longleftarrow;"], [0, "&longrightarrow;"], [0, "&longleftrightarrow;"], [0, "&DoubleLongLeftArrow;"], [0, "&DoubleLongRightArrow;"], [0, "&DoubleLongLeftRightArrow;"], [1, "&longmapsto;"], [2, "&dzigrarr;"], [258, "&nvlArr;"], [0, "&nvrArr;"], [0, "&nvHarr;"], [0, "&Map;"], [6, "&lbarr;"], [0, "&bkarow;"], [0, "&lBarr;"], [0, "&dbkarow;"], [0, "&drbkarow;"], [0, "&DDotrahd;"], [0, "&UpArrowBar;"], [0, "&DownArrowBar;"], [2, "&Rarrtl;"], [2, "&latail;"], [0, "&ratail;"], [0, "&lAtail;"], [0, "&rAtail;"], [0, "&larrfs;"], [0, "&rarrfs;"], [0, "&larrbfs;"], [0, "&rarrbfs;"], [2, "&nwarhk;"], [0, "&nearhk;"], [0, "&hksearow;"], [0, "&hkswarow;"], [0, "&nwnear;"], [0, "&nesear;"], [0, "&seswar;"], [0, "&swnwar;"], [8, { v: "&rarrc;", n: 824, o: "&nrarrc;" }], [1, "&cudarrr;"], [0, "&ldca;"], [0, "&rdca;"], [0, "&cudarrl;"], [0, "&larrpl;"], [2, "&curarrm;"], [0, "&cularrp;"], [7, "&rarrpl;"], [2, "&harrcir;"], [0, "&Uarrocir;"], [0, "&lurdshar;"], [0, "&ldrushar;"], [2, "&LeftRightVector;"], [0, "&RightUpDownVector;"], [0, "&DownLeftRightVector;"], [0, "&LeftUpDownVector;"], [0, "&LeftVectorBar;"], [0, "&RightVectorBar;"], [0, "&RightUpVectorBar;"], [0, "&RightDownVectorBar;"], [0, "&DownLeftVectorBar;"], [0, "&DownRightVectorBar;"], [0, "&LeftUpVectorBar;"], [0, "&LeftDownVectorBar;"], [0, "&LeftTeeVector;"], [0, "&RightTeeVector;"], [0, "&RightUpTeeVector;"], [0, "&RightDownTeeVector;"], [0, "&DownLeftTeeVector;"], [0, "&DownRightTeeVector;"], [0, "&LeftUpTeeVector;"], [0, "&LeftDownTeeVector;"], [0, "&lHar;"], [0, "&uHar;"], [0, "&rHar;"], [0, "&dHar;"], [0, "&luruhar;"], [0, "&ldrdhar;"], [0, "&ruluhar;"], [0, "&rdldhar;"], [0, "&lharul;"], [0, "&llhard;"], [0, "&rharul;"], [0, "&lrhard;"], [0, "&udhar;"], [0, "&duhar;"], [0, "&RoundImplies;"], [0, "&erarr;"], [0, "&simrarr;"], [0, "&larrsim;"], [0, "&rarrsim;"], [0, "&rarrap;"], [0, "&ltlarr;"], [1, "&gtrarr;"], [0, "&subrarr;"], [1, "&suplarr;"], [0, "&lfisht;"], [0, "&rfisht;"], [0, "&ufisht;"], [0, "&dfisht;"], [5, "&lopar;"], [0, "&ropar;"], [4, "&lbrke;"], [0, "&rbrke;"], [0, "&lbrkslu;"], [0, "&rbrksld;"], [0, "&lbrksld;"], [0, "&rbrkslu;"], [0, "&langd;"], [0, "&rangd;"], [0, "&lparlt;"], [0, "&rpargt;"], [0, "&gtlPar;"], [0, "&ltrPar;"], [3, "&vzigzag;"], [1, "&vangrt;"], [0, "&angrtvbd;"], [6, "&ange;"], [0, "&range;"], [0, "&dwangle;"], [0, "&uwangle;"], [0, "&angmsdaa;"], [0, "&angmsdab;"], [0, "&angmsdac;"], [0, "&angmsdad;"], [0, "&angmsdae;"], [0, "&angmsdaf;"], [0, "&angmsdag;"], [0, "&angmsdah;"], [0, "&bemptyv;"], [0, "&demptyv;"], [0, "&cemptyv;"], [0, "&raemptyv;"], [0, "&laemptyv;"], [0, "&ohbar;"], [0, "&omid;"], [0, "&opar;"], [1, "&operp;"], [1, "&olcross;"], [0, "&odsold;"], [1, "&olcir;"], [0, "&ofcir;"], [0, "&olt;"], [0, "&ogt;"], [0, "&cirscir;"], [0, "&cirE;"], [0, "&solb;"], [0, "&bsolb;"], [3, "&boxbox;"], [3, "&trisb;"], [0, "&rtriltri;"], [0, { v: "&LeftTriangleBar;", n: 824, o: "&NotLeftTriangleBar;" }], [0, { v: "&RightTriangleBar;", n: 824, o: "&NotRightTriangleBar;" }], [11, "&iinfin;"], [0, "&infintie;"], [0, "&nvinfin;"], [4, "&eparsl;"], [0, "&smeparsl;"], [0, "&eqvparsl;"], [5, "&blacklozenge;"], [8, "&RuleDelayed;"], [1, "&dsol;"], [9, "&bigodot;"], [0, "&bigoplus;"], [0, "&bigotimes;"], [1, "&biguplus;"], [1, "&bigsqcup;"], [5, "&iiiint;"], [0, "&fpartint;"], [2, "&cirfnint;"], [0, "&awint;"], [0, "&rppolint;"], [0, "&scpolint;"], [0, "&npolint;"], [0, "&pointint;"], [0, "&quatint;"], [0, "&intlarhk;"], [10, "&pluscir;"], [0, "&plusacir;"], [0, "&simplus;"], [0, "&plusdu;"], [0, "&plussim;"], [0, "&plustwo;"], [1, "&mcomma;"], [0, "&minusdu;"], [2, "&loplus;"], [0, "&roplus;"], [0, "&Cross;"], [0, "&timesd;"], [0, "&timesbar;"], [1, "&smashp;"], [0, "&lotimes;"], [0, "&rotimes;"], [0, "&otimesas;"], [0, "&Otimes;"], [0, "&odiv;"], [0, "&triplus;"], [0, "&triminus;"], [0, "&tritime;"], [0, "&intprod;"], [2, "&amalg;"], [0, "&capdot;"], [1, "&ncup;"], [0, "&ncap;"], [0, "&capand;"], [0, "&cupor;"], [0, "&cupcap;"], [0, "&capcup;"], [0, "&cupbrcap;"], [0, "&capbrcup;"], [0, "&cupcup;"], [0, "&capcap;"], [0, "&ccups;"], [0, "&ccaps;"], [2, "&ccupssm;"], [2, "&And;"], [0, "&Or;"], [0, "&andand;"], [0, "&oror;"], [0, "&orslope;"], [0, "&andslope;"], [1, "&andv;"], [0, "&orv;"], [0, "&andd;"], [0, "&ord;"], [1, "&wedbar;"], [6, "&sdote;"], [3, "&simdot;"], [2, { v: "&congdot;", n: 824, o: "&ncongdot;" }], [0, "&easter;"], [0, "&apacir;"], [0, { v: "&apE;", n: 824, o: "&napE;" }], [0, "&eplus;"], [0, "&pluse;"], [0, "&Esim;"], [0, "&Colone;"], [0, "&Equal;"], [1, "&ddotseq;"], [0, "&equivDD;"], [0, "&ltcir;"], [0, "&gtcir;"], [0, "&ltquest;"], [0, "&gtquest;"], [0, { v: "&leqslant;", n: 824, o: "&nleqslant;" }], [0, { v: "&geqslant;", n: 824, o: "&ngeqslant;" }], [0, "&lesdot;"], [0, "&gesdot;"], [0, "&lesdoto;"], [0, "&gesdoto;"], [0, "&lesdotor;"], [0, "&gesdotol;"], [0, "&lap;"], [0, "&gap;"], [0, "&lne;"], [0, "&gne;"], [0, "&lnap;"], [0, "&gnap;"], [0, "&lEg;"], [0, "&gEl;"], [0, "&lsime;"], [0, "&gsime;"], [0, "&lsimg;"], [0, "&gsiml;"], [0, "&lgE;"], [0, "&glE;"], [0, "&lesges;"], [0, "&gesles;"], [0, "&els;"], [0, "&egs;"], [0, "&elsdot;"], [0, "&egsdot;"], [0, "&el;"], [0, "&eg;"], [2, "&siml;"], [0, "&simg;"], [0, "&simlE;"], [0, "&simgE;"], [0, { v: "&LessLess;", n: 824, o: "&NotNestedLessLess;" }], [0, { v: "&GreaterGreater;", n: 824, o: "&NotNestedGreaterGreater;" }], [1, "&glj;"], [0, "&gla;"], [0, "&ltcc;"], [0, "&gtcc;"], [0, "&lescc;"], [0, "&gescc;"], [0, "&smt;"], [0, "&lat;"], [0, { v: "&smte;", n: 65024, o: "&smtes;" }], [0, { v: "&late;", n: 65024, o: "&lates;" }], [0, "&bumpE;"], [0, { v: "&PrecedesEqual;", n: 824, o: "&NotPrecedesEqual;" }], [0, { v: "&sce;", n: 824, o: "&NotSucceedsEqual;" }], [2, "&prE;"], [0, "&scE;"], [0, "&precneqq;"], [0, "&scnE;"], [0, "&prap;"], [0, "&scap;"], [0, "&precnapprox;"], [0, "&scnap;"], [0, "&Pr;"], [0, "&Sc;"], [0, "&subdot;"], [0, "&supdot;"], [0, "&subplus;"], [0, "&supplus;"], [0, "&submult;"], [0, "&supmult;"], [0, "&subedot;"], [0, "&supedot;"], [0, { v: "&subE;", n: 824, o: "&nsubE;" }], [0, { v: "&supE;", n: 824, o: "&nsupE;" }], [0, "&subsim;"], [0, "&supsim;"], [2, { v: "&subnE;", n: 65024, o: "&varsubsetneqq;" }], [0, { v: "&supnE;", n: 65024, o: "&varsupsetneqq;" }], [2, "&csub;"], [0, "&csup;"], [0, "&csube;"], [0, "&csupe;"], [0, "&subsup;"], [0, "&supsub;"], [0, "&subsub;"], [0, "&supsup;"], [0, "&suphsub;"], [0, "&supdsub;"], [0, "&forkv;"], [0, "&topfork;"], [0, "&mlcp;"], [8, "&Dashv;"], [1, "&Vdashl;"], [0, "&Barv;"], [0, "&vBar;"], [0, "&vBarv;"], [1, "&Vbar;"], [0, "&Not;"], [0, "&bNot;"], [0, "&rnmid;"], [0, "&cirmid;"], [0, "&midcir;"], [0, "&topcir;"], [0, "&nhpar;"], [0, "&parsim;"], [9, { v: "&parsl;", n: 8421, o: "&nparsl;" }], [44343, { n: new Map(/* @__PURE__ */ pb([[56476, "&Ascr;"], [1, "&Cscr;"], [0, "&Dscr;"], [2, "&Gscr;"], [2, "&Jscr;"], [0, "&Kscr;"], [2, "&Nscr;"], [0, "&Oscr;"], [0, "&Pscr;"], [0, "&Qscr;"], [1, "&Sscr;"], [0, "&Tscr;"], [0, "&Uscr;"], [0, "&Vscr;"], [0, "&Wscr;"], [0, "&Xscr;"], [0, "&Yscr;"], [0, "&Zscr;"], [0, "&ascr;"], [0, "&bscr;"], [0, "&cscr;"], [0, "&dscr;"], [1, "&fscr;"], [1, "&hscr;"], [0, "&iscr;"], [0, "&jscr;"], [0, "&kscr;"], [0, "&lscr;"], [0, "&mscr;"], [0, "&nscr;"], [1, "&pscr;"], [0, "&qscr;"], [0, "&rscr;"], [0, "&sscr;"], [0, "&tscr;"], [0, "&uscr;"], [0, "&vscr;"], [0, "&wscr;"], [0, "&xscr;"], [0, "&yscr;"], [0, "&zscr;"], [52, "&Afr;"], [0, "&Bfr;"], [1, "&Dfr;"], [0, "&Efr;"], [0, "&Ffr;"], [0, "&Gfr;"], [2, "&Jfr;"], [0, "&Kfr;"], [0, "&Lfr;"], [0, "&Mfr;"], [0, "&Nfr;"], [0, "&Ofr;"], [0, "&Pfr;"], [0, "&Qfr;"], [1, "&Sfr;"], [0, "&Tfr;"], [0, "&Ufr;"], [0, "&Vfr;"], [0, "&Wfr;"], [0, "&Xfr;"], [0, "&Yfr;"], [1, "&afr;"], [0, "&bfr;"], [0, "&cfr;"], [0, "&dfr;"], [0, "&efr;"], [0, "&ffr;"], [0, "&gfr;"], [0, "&hfr;"], [0, "&ifr;"], [0, "&jfr;"], [0, "&kfr;"], [0, "&lfr;"], [0, "&mfr;"], [0, "&nfr;"], [0, "&ofr;"], [0, "&pfr;"], [0, "&qfr;"], [0, "&rfr;"], [0, "&sfr;"], [0, "&tfr;"], [0, "&ufr;"], [0, "&vfr;"], [0, "&wfr;"], [0, "&xfr;"], [0, "&yfr;"], [0, "&zfr;"], [0, "&Aopf;"], [0, "&Bopf;"], [1, "&Dopf;"], [0, "&Eopf;"], [0, "&Fopf;"], [0, "&Gopf;"], [1, "&Iopf;"], [0, "&Jopf;"], [0, "&Kopf;"], [0, "&Lopf;"], [0, "&Mopf;"], [1, "&Oopf;"], [3, "&Sopf;"], [0, "&Topf;"], [0, "&Uopf;"], [0, "&Vopf;"], [0, "&Wopf;"], [0, "&Xopf;"], [0, "&Yopf;"], [1, "&aopf;"], [0, "&bopf;"], [0, "&copf;"], [0, "&dopf;"], [0, "&eopf;"], [0, "&fopf;"], [0, "&gopf;"], [0, "&hopf;"], [0, "&iopf;"], [0, "&jopf;"], [0, "&kopf;"], [0, "&lopf;"], [0, "&mopf;"], [0, "&nopf;"], [0, "&oopf;"], [0, "&popf;"], [0, "&qopf;"], [0, "&ropf;"], [0, "&sopf;"], [0, "&topf;"], [0, "&uopf;"], [0, "&vopf;"], [0, "&wopf;"], [0, "&xopf;"], [0, "&yopf;"], [0, "&zopf;"]])) }], [8906, "&fflig;"], [0, "&filig;"], [0, "&fllig;"], [0, "&ffilig;"], [0, "&ffllig;"]]));
var Lx = {};
(function(t) {
  Object.defineProperty(t, "__esModule", { value: !0 }), t.escapeText = t.escapeAttribute = t.escapeUTF8 = t.escape = t.encodeXML = t.getCodePoint = t.xmlReplacer = void 0, t.xmlReplacer = /["&'<>$\x80-\uFFFF]/g;
  var e = /* @__PURE__ */ new Map([
    [34, "&quot;"],
    [38, "&amp;"],
    [39, "&apos;"],
    [60, "&lt;"],
    [62, "&gt;"]
  ]);
  t.getCodePoint = // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition
  String.prototype.codePointAt != null ? function(i, o) {
    return i.codePointAt(o);
  } : (
    // http://mathiasbynens.be/notes/javascript-encoding#surrogate-formulae
    function(i, o) {
      return (i.charCodeAt(o) & 64512) === 55296 ? (i.charCodeAt(o) - 55296) * 1024 + i.charCodeAt(o + 1) - 56320 + 65536 : i.charCodeAt(o);
    }
  );
  function n(i) {
    for (var o = "", a = 0, s; (s = t.xmlReplacer.exec(i)) !== null; ) {
      var u = s.index, l = i.charCodeAt(u), c = e.get(l);
      c !== void 0 ? (o += i.substring(a, u) + c, a = u + 1) : (o += "".concat(i.substring(a, u), "&#x").concat((0, t.getCodePoint)(i, u).toString(16), ";"), a = t.xmlReplacer.lastIndex += +((l & 64512) === 55296));
    }
    return o + i.substr(a);
  }
  t.encodeXML = n, t.escape = n;
  function r(i, o) {
    return function(s) {
      for (var u, l = 0, c = ""; u = i.exec(s); )
        l !== u.index && (c += s.substring(l, u.index)), c += o.get(u[0].charCodeAt(0)), l = u.index + 1;
      return c + s.substring(l);
    };
  }
  t.escapeUTF8 = r(/[&<>'"]/g, e), t.escapeAttribute = r(/["&\u00A0]/g, /* @__PURE__ */ new Map([
    [34, "&quot;"],
    [38, "&amp;"],
    [160, "&nbsp;"]
  ])), t.escapeText = r(/[&<>\u00A0]/g, /* @__PURE__ */ new Map([
    [38, "&amp;"],
    [60, "&lt;"],
    [62, "&gt;"],
    [160, "&nbsp;"]
  ]));
})(Lx);
var IVe = ft && ft.__importDefault || function(t) {
  return t && t.__esModule ? t : { default: t };
};
Object.defineProperty(Rd, "__esModule", { value: !0 });
Rd.encodeNonAsciiHTML = Rd.encodeHTML = void 0;
var _Ve = IVe(K9), YY = Lx, AVe = /[\t\n!-,./:-@[-`\f{-}$\x80-\uFFFF]/g;
function TVe(t) {
  return ZY(AVe, t);
}
Rd.encodeHTML = TVe;
function OVe(t) {
  return ZY(YY.xmlReplacer, t);
}
Rd.encodeNonAsciiHTML = OVe;
function ZY(t, e) {
  for (var n = "", r = 0, i; (i = t.exec(e)) !== null; ) {
    var o = i.index;
    n += e.substring(r, o);
    var a = e.charCodeAt(o), s = _Ve.default.get(a);
    if (typeof s == "object") {
      if (o + 1 < e.length) {
        var u = e.charCodeAt(o + 1), l = typeof s.n == "number" ? s.n === u ? s.o : void 0 : s.n.get(u);
        if (l !== void 0) {
          n += l, r = t.lastIndex += 1;
          continue;
        }
      }
      s = s.v;
    }
    if (s !== void 0)
      n += s, r = o + 1;
    else {
      var c = (0, YY.getCodePoint)(e, o);
      n += "&#x".concat(c.toString(16), ";"), r = t.lastIndex += +(c !== a);
    }
  }
  return n + e.substr(r);
}
(function(t) {
  Object.defineProperty(t, "__esModule", { value: !0 }), t.decodeXMLStrict = t.decodeHTML5Strict = t.decodeHTML4Strict = t.decodeHTML5 = t.decodeHTML4 = t.decodeHTMLAttribute = t.decodeHTMLStrict = t.decodeHTML = t.decodeXML = t.DecodingMode = t.EntityDecoder = t.encodeHTML5 = t.encodeHTML4 = t.encodeNonAsciiHTML = t.encodeHTML = t.escapeText = t.escapeAttribute = t.escapeUTF8 = t.escape = t.encodeXML = t.encode = t.decodeStrict = t.decode = t.EncodingMode = t.EntityLevel = void 0;
  var e = Q0, n = Rd, r = Lx, i;
  (function(f) {
    f[f.XML = 0] = "XML", f[f.HTML = 1] = "HTML";
  })(i = t.EntityLevel || (t.EntityLevel = {}));
  var o;
  (function(f) {
    f[f.UTF8 = 0] = "UTF8", f[f.ASCII = 1] = "ASCII", f[f.Extensive = 2] = "Extensive", f[f.Attribute = 3] = "Attribute", f[f.Text = 4] = "Text";
  })(o = t.EncodingMode || (t.EncodingMode = {}));
  function a(f, h) {
    h === void 0 && (h = i.XML);
    var p = typeof h == "number" ? h : h.level;
    if (p === i.HTML) {
      var v = typeof h == "object" ? h.mode : void 0;
      return (0, e.decodeHTML)(f, v);
    }
    return (0, e.decodeXML)(f);
  }
  t.decode = a;
  function s(f, h) {
    var p;
    h === void 0 && (h = i.XML);
    var v = typeof h == "number" ? { level: h } : h;
    return (p = v.mode) !== null && p !== void 0 || (v.mode = e.DecodingMode.Strict), a(f, v);
  }
  t.decodeStrict = s;
  function u(f, h) {
    h === void 0 && (h = i.XML);
    var p = typeof h == "number" ? { level: h } : h;
    return p.mode === o.UTF8 ? (0, r.escapeUTF8)(f) : p.mode === o.Attribute ? (0, r.escapeAttribute)(f) : p.mode === o.Text ? (0, r.escapeText)(f) : p.level === i.HTML ? p.mode === o.ASCII ? (0, n.encodeNonAsciiHTML)(f) : (0, n.encodeHTML)(f) : (0, r.encodeXML)(f);
  }
  t.encode = u;
  var l = Lx;
  Object.defineProperty(t, "encodeXML", { enumerable: !0, get: function() {
    return l.encodeXML;
  } }), Object.defineProperty(t, "escape", { enumerable: !0, get: function() {
    return l.escape;
  } }), Object.defineProperty(t, "escapeUTF8", { enumerable: !0, get: function() {
    return l.escapeUTF8;
  } }), Object.defineProperty(t, "escapeAttribute", { enumerable: !0, get: function() {
    return l.escapeAttribute;
  } }), Object.defineProperty(t, "escapeText", { enumerable: !0, get: function() {
    return l.escapeText;
  } });
  var c = Rd;
  Object.defineProperty(t, "encodeHTML", { enumerable: !0, get: function() {
    return c.encodeHTML;
  } }), Object.defineProperty(t, "encodeNonAsciiHTML", { enumerable: !0, get: function() {
    return c.encodeNonAsciiHTML;
  } }), Object.defineProperty(t, "encodeHTML4", { enumerable: !0, get: function() {
    return c.encodeHTML;
  } }), Object.defineProperty(t, "encodeHTML5", { enumerable: !0, get: function() {
    return c.encodeHTML;
  } });
  var d = Q0;
  Object.defineProperty(t, "EntityDecoder", { enumerable: !0, get: function() {
    return d.EntityDecoder;
  } }), Object.defineProperty(t, "DecodingMode", { enumerable: !0, get: function() {
    return d.DecodingMode;
  } }), Object.defineProperty(t, "decodeXML", { enumerable: !0, get: function() {
    return d.decodeXML;
  } }), Object.defineProperty(t, "decodeHTML", { enumerable: !0, get: function() {
    return d.decodeHTML;
  } }), Object.defineProperty(t, "decodeHTMLStrict", { enumerable: !0, get: function() {
    return d.decodeHTMLStrict;
  } }), Object.defineProperty(t, "decodeHTMLAttribute", { enumerable: !0, get: function() {
    return d.decodeHTMLAttribute;
  } }), Object.defineProperty(t, "decodeHTML4", { enumerable: !0, get: function() {
    return d.decodeHTML;
  } }), Object.defineProperty(t, "decodeHTML5", { enumerable: !0, get: function() {
    return d.decodeHTML;
  } }), Object.defineProperty(t, "decodeHTML4Strict", { enumerable: !0, get: function() {
    return d.decodeHTMLStrict;
  } }), Object.defineProperty(t, "decodeHTML5Strict", { enumerable: !0, get: function() {
    return d.decodeHTMLStrict;
  } }), Object.defineProperty(t, "decodeXMLStrict", { enumerable: !0, get: function() {
    return d.decodeXML;
  } });
})(XY);
var ip = {};
Object.defineProperty(ip, "__esModule", { value: !0 });
ip.attributeNames = ip.elementNames = void 0;
ip.elementNames = new Map([
  "altGlyph",
  "altGlyphDef",
  "altGlyphItem",
  "animateColor",
  "animateMotion",
  "animateTransform",
  "clipPath",
  "feBlend",
  "feColorMatrix",
  "feComponentTransfer",
  "feComposite",
  "feConvolveMatrix",
  "feDiffuseLighting",
  "feDisplacementMap",
  "feDistantLight",
  "feDropShadow",
  "feFlood",
  "feFuncA",
  "feFuncB",
  "feFuncG",
  "feFuncR",
  "feGaussianBlur",
  "feImage",
  "feMerge",
  "feMergeNode",
  "feMorphology",
  "feOffset",
  "fePointLight",
  "feSpecularLighting",
  "feSpotLight",
  "feTile",
  "feTurbulence",
  "foreignObject",
  "glyphRef",
  "linearGradient",
  "radialGradient",
  "textPath"
].map(function(t) {
  return [t.toLowerCase(), t];
}));
ip.attributeNames = new Map([
  "definitionURL",
  "attributeName",
  "attributeType",
  "baseFrequency",
  "baseProfile",
  "calcMode",
  "clipPathUnits",
  "diffuseConstant",
  "edgeMode",
  "filterUnits",
  "glyphRef",
  "gradientTransform",
  "gradientUnits",
  "kernelMatrix",
  "kernelUnitLength",
  "keyPoints",
  "keySplines",
  "keyTimes",
  "lengthAdjust",
  "limitingConeAngle",
  "markerHeight",
  "markerUnits",
  "markerWidth",
  "maskContentUnits",
  "maskUnits",
  "numOctaves",
  "pathLength",
  "patternContentUnits",
  "patternTransform",
  "patternUnits",
  "pointsAtX",
  "pointsAtY",
  "pointsAtZ",
  "preserveAlpha",
  "preserveAspectRatio",
  "primitiveUnits",
  "refX",
  "refY",
  "repeatCount",
  "repeatDur",
  "requiredExtensions",
  "requiredFeatures",
  "specularConstant",
  "specularExponent",
  "spreadMethod",
  "startOffset",
  "stdDeviation",
  "stitchTiles",
  "surfaceScale",
  "systemLanguage",
  "tableValues",
  "targetX",
  "targetY",
  "textLength",
  "viewBox",
  "viewTarget",
  "xChannelSelector",
  "yChannelSelector",
  "zoomAndPan"
].map(function(t) {
  return [t.toLowerCase(), t];
}));
var Th = ft && ft.__assign || function() {
  return Th = Object.assign || function(t) {
    for (var e, n = 1, r = arguments.length; n < r; n++) {
      e = arguments[n];
      for (var i in e)
        Object.prototype.hasOwnProperty.call(e, i) && (t[i] = e[i]);
    }
    return t;
  }, Th.apply(this, arguments);
}, PVe = ft && ft.__createBinding || (Object.create ? function(t, e, n, r) {
  r === void 0 && (r = n);
  var i = Object.getOwnPropertyDescriptor(e, n);
  (!i || ("get" in i ? !e.__esModule : i.writable || i.configurable)) && (i = { enumerable: !0, get: function() {
    return e[n];
  } }), Object.defineProperty(t, r, i);
} : function(t, e, n, r) {
  r === void 0 && (r = n), t[r] = e[n];
}), NVe = ft && ft.__setModuleDefault || (Object.create ? function(t, e) {
  Object.defineProperty(t, "default", { enumerable: !0, value: e });
} : function(t, e) {
  t.default = e;
}), kVe = ft && ft.__importStar || function(t) {
  if (t && t.__esModule)
    return t;
  var e = {};
  if (t != null)
    for (var n in t)
      n !== "default" && Object.prototype.hasOwnProperty.call(t, n) && PVe(e, t, n);
  return NVe(e, t), e;
};
Object.defineProperty(nv, "__esModule", { value: !0 });
nv.render = void 0;
var Lu = kVe(Fp), Vx = XY, JY = ip, RVe = /* @__PURE__ */ new Set([
  "style",
  "script",
  "xmp",
  "iframe",
  "noembed",
  "noframes",
  "plaintext",
  "noscript"
]);
function $Ve(t) {
  return t.replace(/"/g, "&quot;");
}
function DVe(t, e) {
  var n;
  if (t) {
    var r = ((n = e.encodeEntities) !== null && n !== void 0 ? n : e.decodeEntities) === !1 ? $Ve : e.xmlMode || e.encodeEntities !== "utf8" ? Vx.encodeXML : Vx.escapeAttribute;
    return Object.keys(t).map(function(i) {
      var o, a, s = (o = t[i]) !== null && o !== void 0 ? o : "";
      return e.xmlMode === "foreign" && (i = (a = JY.attributeNames.get(i)) !== null && a !== void 0 ? a : i), !e.emptyAttrs && !e.xmlMode && s === "" ? i : "".concat(i, '="').concat(r(s), '"');
    }).join(" ");
  }
}
var TD = /* @__PURE__ */ new Set([
  "area",
  "base",
  "basefont",
  "br",
  "col",
  "command",
  "embed",
  "frame",
  "hr",
  "img",
  "input",
  "isindex",
  "keygen",
  "link",
  "meta",
  "param",
  "source",
  "track",
  "wbr"
]);
function qC(t, e) {
  e === void 0 && (e = {});
  for (var n = ("length" in t) ? t : [t], r = "", i = 0; i < n.length; i++)
    r += MVe(n[i], e);
  return r;
}
nv.render = qC;
nv.default = qC;
function MVe(t, e) {
  switch (t.type) {
    case Lu.Root:
      return qC(t.children, e);
    case Lu.Doctype:
    case Lu.Directive:
      return BVe(t);
    case Lu.Comment:
      return jVe(t);
    case Lu.CDATA:
      return WVe(t);
    case Lu.Script:
    case Lu.Style:
    case Lu.Tag:
      return VVe(t, e);
    case Lu.Text:
      return HVe(t, e);
  }
}
var FVe = /* @__PURE__ */ new Set([
  "mi",
  "mo",
  "mn",
  "ms",
  "mtext",
  "annotation-xml",
  "foreignObject",
  "desc",
  "title"
]), LVe = /* @__PURE__ */ new Set(["svg", "math"]);
function VVe(t, e) {
  var n;
  e.xmlMode === "foreign" && (t.name = (n = JY.elementNames.get(t.name)) !== null && n !== void 0 ? n : t.name, t.parent && FVe.has(t.parent.name) && (e = Th(Th({}, e), { xmlMode: !1 }))), !e.xmlMode && LVe.has(t.name) && (e = Th(Th({}, e), { xmlMode: "foreign" }));
  var r = "<".concat(t.name), i = DVe(t.attribs, e);
  return i && (r += " ".concat(i)), t.children.length === 0 && (e.xmlMode ? (
    // In XML mode or foreign mode, and user hasn't explicitly turned off self-closing tags
    e.selfClosingTags !== !1
  ) : (
    // User explicitly asked for self-closing tags, even in HTML mode
    e.selfClosingTags && TD.has(t.name)
  )) ? (e.xmlMode || (r += " "), r += "/>") : (r += ">", t.children.length > 0 && (r += qC(t.children, e)), (e.xmlMode || !TD.has(t.name)) && (r += "</".concat(t.name, ">"))), r;
}
function BVe(t) {
  return "<".concat(t.data, ">");
}
function HVe(t, e) {
  var n, r = t.data || "";
  return ((n = e.encodeEntities) !== null && n !== void 0 ? n : e.decodeEntities) !== !1 && !(!e.xmlMode && t.parent && RVe.has(t.parent.name)) && (r = e.xmlMode || e.encodeEntities !== "utf8" ? (0, Vx.encodeXML)(r) : (0, Vx.escapeText)(r)), r;
}
function WVe(t) {
  return "<![CDATA[".concat(t.children[0].data, "]]>");
}
function jVe(t) {
  return "<!--".concat(t.data, "-->");
}
var zVe = ft && ft.__importDefault || function(t) {
  return t && t.__esModule ? t : { default: t };
};
Object.defineProperty(na, "__esModule", { value: !0 });
na.innerText = na.textContent = na.getText = na.getInnerHTML = na.getOuterHTML = void 0;
var uu = el, GVe = zVe(nv), UVe = Fp;
function KY(t, e) {
  return (0, GVe.default)(t, e);
}
na.getOuterHTML = KY;
function XVe(t, e) {
  return (0, uu.hasChildren)(t) ? t.children.map(function(n) {
    return KY(n, e);
  }).join("") : "";
}
na.getInnerHTML = XVe;
function gy(t) {
  return Array.isArray(t) ? t.map(gy).join("") : (0, uu.isTag)(t) ? t.name === "br" ? `
` : gy(t.children) : (0, uu.isCDATA)(t) ? gy(t.children) : (0, uu.isText)(t) ? t.data : "";
}
na.getText = gy;
function N_(t) {
  return Array.isArray(t) ? t.map(N_).join("") : (0, uu.hasChildren)(t) && !(0, uu.isComment)(t) ? N_(t.children) : (0, uu.isText)(t) ? t.data : "";
}
na.textContent = N_;
function k_(t) {
  return Array.isArray(t) ? t.map(k_).join("") : (0, uu.hasChildren)(t) && (t.type === UVe.ElementType.Tag || (0, uu.isCDATA)(t)) ? k_(t.children) : (0, uu.isText)(t) ? t.data : "";
}
na.innerText = k_;
var _i = {};
Object.defineProperty(_i, "__esModule", { value: !0 });
_i.prevElementSibling = _i.nextElementSibling = _i.getName = _i.hasAttrib = _i.getAttributeValue = _i.getSiblings = _i.getParent = _i.getChildren = void 0;
var q9 = el;
function qY(t) {
  return (0, q9.hasChildren)(t) ? t.children : [];
}
_i.getChildren = qY;
function QY(t) {
  return t.parent || null;
}
_i.getParent = QY;
function YVe(t) {
  var e, n, r = QY(t);
  if (r != null)
    return qY(r);
  for (var i = [t], o = t.prev, a = t.next; o != null; )
    i.unshift(o), e = o, o = e.prev;
  for (; a != null; )
    i.push(a), n = a, a = n.next;
  return i;
}
_i.getSiblings = YVe;
function ZVe(t, e) {
  var n;
  return (n = t.attribs) === null || n === void 0 ? void 0 : n[e];
}
_i.getAttributeValue = ZVe;
function JVe(t, e) {
  return t.attribs != null && Object.prototype.hasOwnProperty.call(t.attribs, e) && t.attribs[e] != null;
}
_i.hasAttrib = JVe;
function KVe(t) {
  return t.name;
}
_i.getName = KVe;
function qVe(t) {
  for (var e, n = t.next; n !== null && !(0, q9.isTag)(n); )
    e = n, n = e.next;
  return n;
}
_i.nextElementSibling = qVe;
function QVe(t) {
  for (var e, n = t.prev; n !== null && !(0, q9.isTag)(n); )
    e = n, n = e.prev;
  return n;
}
_i.prevElementSibling = QVe;
var Io = {};
Object.defineProperty(Io, "__esModule", { value: !0 });
Io.prepend = Io.prependChild = Io.append = Io.appendChild = Io.replaceElement = Io.removeElement = void 0;
function rv(t) {
  if (t.prev && (t.prev.next = t.next), t.next && (t.next.prev = t.prev), t.parent) {
    var e = t.parent.children, n = e.lastIndexOf(t);
    n >= 0 && e.splice(n, 1);
  }
  t.next = null, t.prev = null, t.parent = null;
}
Io.removeElement = rv;
function eBe(t, e) {
  var n = e.prev = t.prev;
  n && (n.next = e);
  var r = e.next = t.next;
  r && (r.prev = e);
  var i = e.parent = t.parent;
  if (i) {
    var o = i.children;
    o[o.lastIndexOf(t)] = e, t.parent = null;
  }
}
Io.replaceElement = eBe;
function tBe(t, e) {
  if (rv(e), e.next = null, e.parent = t, t.children.push(e) > 1) {
    var n = t.children[t.children.length - 2];
    n.next = e, e.prev = n;
  } else
    e.prev = null;
}
Io.appendChild = tBe;
function nBe(t, e) {
  rv(e);
  var n = t.parent, r = t.next;
  if (e.next = r, e.prev = t, t.next = e, e.parent = n, r) {
    if (r.prev = e, n) {
      var i = n.children;
      i.splice(i.lastIndexOf(r), 0, e);
    }
  } else
    n && n.children.push(e);
}
Io.append = nBe;
function rBe(t, e) {
  if (rv(e), e.parent = t, e.prev = null, t.children.unshift(e) !== 1) {
    var n = t.children[1];
    n.prev = e, e.next = n;
  } else
    e.next = null;
}
Io.prependChild = rBe;
function iBe(t, e) {
  rv(e);
  var n = t.parent;
  if (n) {
    var r = n.children;
    r.splice(r.indexOf(t), 0, e);
  }
  t.prev && (t.prev.next = e), e.parent = n, e.prev = t.prev, e.next = t, t.prev = e;
}
Io.prepend = iBe;
var io = {};
Object.defineProperty(io, "__esModule", { value: !0 });
io.findAll = io.existsOne = io.findOne = io.findOneChild = io.find = io.filter = void 0;
var QC = el;
function oBe(t, e, n, r) {
  return n === void 0 && (n = !0), r === void 0 && (r = 1 / 0), eZ(t, Array.isArray(e) ? e : [e], n, r);
}
io.filter = oBe;
function eZ(t, e, n, r) {
  for (var i = [], o = [e], a = [0]; ; ) {
    if (a[0] >= o[0].length) {
      if (a.length === 1)
        return i;
      o.shift(), a.shift();
      continue;
    }
    var s = o[0][a[0]++];
    if (t(s) && (i.push(s), --r <= 0))
      return i;
    n && (0, QC.hasChildren)(s) && s.children.length > 0 && (a.unshift(0), o.unshift(s.children));
  }
}
io.find = eZ;
function aBe(t, e) {
  return e.find(t);
}
io.findOneChild = aBe;
function tZ(t, e, n) {
  n === void 0 && (n = !0);
  for (var r = null, i = 0; i < e.length && !r; i++) {
    var o = e[i];
    if ((0, QC.isTag)(o))
      t(o) ? r = o : n && o.children.length > 0 && (r = tZ(t, o.children, !0));
    else
      continue;
  }
  return r;
}
io.findOne = tZ;
function nZ(t, e) {
  return e.some(function(n) {
    return (0, QC.isTag)(n) && (t(n) || nZ(t, n.children));
  });
}
io.existsOne = nZ;
function sBe(t, e) {
  for (var n = [], r = [e], i = [0]; ; ) {
    if (i[0] >= r[0].length) {
      if (r.length === 1)
        return n;
      r.shift(), i.shift();
      continue;
    }
    var o = r[0][i[0]++];
    (0, QC.isTag)(o) && (t(o) && n.push(o), o.children.length > 0 && (i.unshift(0), r.unshift(o.children)));
  }
}
io.findAll = sBe;
var ra = {};
Object.defineProperty(ra, "__esModule", { value: !0 });
ra.getElementsByTagType = ra.getElementsByTagName = ra.getElementById = ra.getElements = ra.testElement = void 0;
var od = el, ew = io, Bx = {
  tag_name: function(t) {
    return typeof t == "function" ? function(e) {
      return (0, od.isTag)(e) && t(e.name);
    } : t === "*" ? od.isTag : function(e) {
      return (0, od.isTag)(e) && e.name === t;
    };
  },
  tag_type: function(t) {
    return typeof t == "function" ? function(e) {
      return t(e.type);
    } : function(e) {
      return e.type === t;
    };
  },
  tag_contains: function(t) {
    return typeof t == "function" ? function(e) {
      return (0, od.isText)(e) && t(e.data);
    } : function(e) {
      return (0, od.isText)(e) && e.data === t;
    };
  }
};
function rZ(t, e) {
  return typeof e == "function" ? function(n) {
    return (0, od.isTag)(n) && e(n.attribs[t]);
  } : function(n) {
    return (0, od.isTag)(n) && n.attribs[t] === e;
  };
}
function uBe(t, e) {
  return function(n) {
    return t(n) || e(n);
  };
}
function iZ(t) {
  var e = Object.keys(t).map(function(n) {
    var r = t[n];
    return Object.prototype.hasOwnProperty.call(Bx, n) ? Bx[n](r) : rZ(n, r);
  });
  return e.length === 0 ? null : e.reduce(uBe);
}
function lBe(t, e) {
  var n = iZ(t);
  return n ? n(e) : !0;
}
ra.testElement = lBe;
function cBe(t, e, n, r) {
  r === void 0 && (r = 1 / 0);
  var i = iZ(t);
  return i ? (0, ew.filter)(i, e, n, r) : [];
}
ra.getElements = cBe;
function dBe(t, e, n) {
  return n === void 0 && (n = !0), Array.isArray(e) || (e = [e]), (0, ew.findOne)(rZ("id", t), e, n);
}
ra.getElementById = dBe;
function fBe(t, e, n, r) {
  return n === void 0 && (n = !0), r === void 0 && (r = 1 / 0), (0, ew.filter)(Bx.tag_name(t), e, n, r);
}
ra.getElementsByTagName = fBe;
function hBe(t, e, n, r) {
  return n === void 0 && (n = !0), r === void 0 && (r = 1 / 0), (0, ew.filter)(Bx.tag_type(t), e, n, r);
}
ra.getElementsByTagType = hBe;
var oZ = {};
(function(t) {
  Object.defineProperty(t, "__esModule", { value: !0 }), t.uniqueSort = t.compareDocumentPosition = t.DocumentPosition = t.removeSubsets = void 0;
  var e = el;
  function n(a) {
    for (var s = a.length; --s >= 0; ) {
      var u = a[s];
      if (s > 0 && a.lastIndexOf(u, s - 1) >= 0) {
        a.splice(s, 1);
        continue;
      }
      for (var l = u.parent; l; l = l.parent)
        if (a.includes(l)) {
          a.splice(s, 1);
          break;
        }
    }
    return a;
  }
  t.removeSubsets = n;
  var r;
  (function(a) {
    a[a.DISCONNECTED = 1] = "DISCONNECTED", a[a.PRECEDING = 2] = "PRECEDING", a[a.FOLLOWING = 4] = "FOLLOWING", a[a.CONTAINS = 8] = "CONTAINS", a[a.CONTAINED_BY = 16] = "CONTAINED_BY";
  })(r = t.DocumentPosition || (t.DocumentPosition = {}));
  function i(a, s) {
    var u = [], l = [];
    if (a === s)
      return 0;
    for (var c = (0, e.hasChildren)(a) ? a : a.parent; c; )
      u.unshift(c), c = c.parent;
    for (c = (0, e.hasChildren)(s) ? s : s.parent; c; )
      l.unshift(c), c = c.parent;
    for (var d = Math.min(u.length, l.length), f = 0; f < d && u[f] === l[f]; )
      f++;
    if (f === 0)
      return r.DISCONNECTED;
    var h = u[f - 1], p = h.children, v = u[f], m = l[f];
    return p.indexOf(v) > p.indexOf(m) ? h === s ? r.FOLLOWING | r.CONTAINED_BY : r.FOLLOWING : h === a ? r.PRECEDING | r.CONTAINS : r.PRECEDING;
  }
  t.compareDocumentPosition = i;
  function o(a) {
    return a = a.filter(function(s, u, l) {
      return !l.includes(s, u + 1);
    }), a.sort(function(s, u) {
      var l = i(s, u);
      return l & r.PRECEDING ? -1 : l & r.FOLLOWING ? 1 : 0;
    }), a;
  }
  t.uniqueSort = o;
})(oZ);
var tw = {};
Object.defineProperty(tw, "__esModule", { value: !0 });
tw.getFeed = void 0;
var pBe = na, iv = ra;
function gBe(t) {
  var e = Hx(xBe, t);
  return e ? e.name === "feed" ? mBe(e) : vBe(e) : null;
}
tw.getFeed = gBe;
function mBe(t) {
  var e, n = t.children, r = {
    type: "atom",
    items: (0, iv.getElementsByTagName)("entry", n).map(function(a) {
      var s, u = a.children, l = { media: aZ(u) };
      Eo(l, "id", "id", u), Eo(l, "title", "title", u);
      var c = (s = Hx("link", u)) === null || s === void 0 ? void 0 : s.attribs.href;
      c && (l.link = c);
      var d = Zl("summary", u) || Zl("content", u);
      d && (l.description = d);
      var f = Zl("updated", u);
      return f && (l.pubDate = new Date(f)), l;
    })
  };
  Eo(r, "id", "id", n), Eo(r, "title", "title", n);
  var i = (e = Hx("link", n)) === null || e === void 0 ? void 0 : e.attribs.href;
  i && (r.link = i), Eo(r, "description", "subtitle", n);
  var o = Zl("updated", n);
  return o && (r.updated = new Date(o)), Eo(r, "author", "email", n, !0), r;
}
function vBe(t) {
  var e, n, r = (n = (e = Hx("channel", t.children)) === null || e === void 0 ? void 0 : e.children) !== null && n !== void 0 ? n : [], i = {
    type: t.name.substr(0, 3),
    id: "",
    items: (0, iv.getElementsByTagName)("item", t.children).map(function(a) {
      var s = a.children, u = { media: aZ(s) };
      Eo(u, "id", "guid", s), Eo(u, "title", "title", s), Eo(u, "link", "link", s), Eo(u, "description", "description", s);
      var l = Zl("pubDate", s) || Zl("dc:date", s);
      return l && (u.pubDate = new Date(l)), u;
    })
  };
  Eo(i, "title", "title", r), Eo(i, "link", "link", r), Eo(i, "description", "description", r);
  var o = Zl("lastBuildDate", r);
  return o && (i.updated = new Date(o)), Eo(i, "author", "managingEditor", r, !0), i;
}
var bBe = ["url", "type", "lang"], yBe = [
  "fileSize",
  "bitrate",
  "framerate",
  "samplingrate",
  "channels",
  "duration",
  "height",
  "width"
];
function aZ(t) {
  return (0, iv.getElementsByTagName)("media:content", t).map(function(e) {
    for (var n = e.attribs, r = {
      medium: n.medium,
      isDefault: !!n.isDefault
    }, i = 0, o = bBe; i < o.length; i++) {
      var a = o[i];
      n[a] && (r[a] = n[a]);
    }
    for (var s = 0, u = yBe; s < u.length; s++) {
      var a = u[s];
      n[a] && (r[a] = parseInt(n[a], 10));
    }
    return n.expression && (r.expression = n.expression), r;
  });
}
function Hx(t, e) {
  return (0, iv.getElementsByTagName)(t, e, !0, 1)[0];
}
function Zl(t, e, n) {
  return n === void 0 && (n = !1), (0, pBe.textContent)((0, iv.getElementsByTagName)(t, e, n, 1)).trim();
}
function Eo(t, e, n, r, i) {
  i === void 0 && (i = !1);
  var o = Zl(n, r, i);
  o && (t[e] = o);
}
function xBe(t) {
  return t === "rss" || t === "feed" || t === "rdf:RDF";
}
(function(t) {
  var e = ft && ft.__createBinding || (Object.create ? function(i, o, a, s) {
    s === void 0 && (s = a);
    var u = Object.getOwnPropertyDescriptor(o, a);
    (!u || ("get" in u ? !o.__esModule : u.writable || u.configurable)) && (u = { enumerable: !0, get: function() {
      return o[a];
    } }), Object.defineProperty(i, s, u);
  } : function(i, o, a, s) {
    s === void 0 && (s = a), i[s] = o[a];
  }), n = ft && ft.__exportStar || function(i, o) {
    for (var a in i)
      a !== "default" && !Object.prototype.hasOwnProperty.call(o, a) && e(o, i, a);
  };
  Object.defineProperty(t, "__esModule", { value: !0 }), t.hasChildren = t.isDocument = t.isComment = t.isText = t.isCDATA = t.isTag = void 0, n(na, t), n(_i, t), n(Io, t), n(io, t), n(ra, t), n(oZ, t), n(tw, t);
  var r = el;
  Object.defineProperty(t, "isTag", { enumerable: !0, get: function() {
    return r.isTag;
  } }), Object.defineProperty(t, "isCDATA", { enumerable: !0, get: function() {
    return r.isCDATA;
  } }), Object.defineProperty(t, "isText", { enumerable: !0, get: function() {
    return r.isText;
  } }), Object.defineProperty(t, "isComment", { enumerable: !0, get: function() {
    return r.isComment;
  } }), Object.defineProperty(t, "isDocument", { enumerable: !0, get: function() {
    return r.isDocument;
  } }), Object.defineProperty(t, "hasChildren", { enumerable: !0, get: function() {
    return r.hasChildren;
  } });
})(py);
(function(t) {
  var e = ft && ft.__createBinding || (Object.create ? function(b, y, w, S) {
    S === void 0 && (S = w);
    var E = Object.getOwnPropertyDescriptor(y, w);
    (!E || ("get" in E ? !y.__esModule : E.writable || E.configurable)) && (E = { enumerable: !0, get: function() {
      return y[w];
    } }), Object.defineProperty(b, S, E);
  } : function(b, y, w, S) {
    S === void 0 && (S = w), b[S] = y[w];
  }), n = ft && ft.__setModuleDefault || (Object.create ? function(b, y) {
    Object.defineProperty(b, "default", { enumerable: !0, value: y });
  } : function(b, y) {
    b.default = y;
  }), r = ft && ft.__importStar || function(b) {
    if (b && b.__esModule)
      return b;
    var y = {};
    if (b != null)
      for (var w in b)
        w !== "default" && Object.prototype.hasOwnProperty.call(b, w) && e(y, b, w);
    return n(y, b), y;
  }, i = ft && ft.__importDefault || function(b) {
    return b && b.__esModule ? b : { default: b };
  };
  Object.defineProperty(t, "__esModule", { value: !0 }), t.DomUtils = t.parseFeed = t.getFeed = t.ElementType = t.Tokenizer = t.createDomStream = t.parseDOM = t.parseDocument = t.DefaultHandler = t.DomHandler = t.Parser = void 0;
  var o = q0, a = q0;
  Object.defineProperty(t, "Parser", { enumerable: !0, get: function() {
    return a.Parser;
  } });
  var s = el, u = el;
  Object.defineProperty(t, "DomHandler", { enumerable: !0, get: function() {
    return u.DomHandler;
  } }), Object.defineProperty(t, "DefaultHandler", { enumerable: !0, get: function() {
    return u.DomHandler;
  } });
  function l(b, y) {
    var w = new s.DomHandler(void 0, y);
    return new o.Parser(w, y).end(b), w.root;
  }
  t.parseDocument = l;
  function c(b, y) {
    return l(b, y).children;
  }
  t.parseDOM = c;
  function d(b, y, w) {
    var S = new s.DomHandler(b, y, w);
    return new o.Parser(S, y);
  }
  t.createDomStream = d;
  var f = U9;
  Object.defineProperty(t, "Tokenizer", { enumerable: !0, get: function() {
    return i(f).default;
  } }), t.ElementType = r(Fp);
  var h = py, p = py;
  Object.defineProperty(t, "getFeed", { enumerable: !0, get: function() {
    return p.getFeed;
  } });
  var v = { xmlMode: !0 };
  function m(b, y) {
    return y === void 0 && (y = v), (0, h.getFeed)(c(b, y));
  }
  t.parseFeed = m, t.DomUtils = r(py);
})($Y);
var CBe = (t) => {
  if (typeof t != "string")
    throw new TypeError("Expected a string");
  return t.replace(/[|\\{}()[\]^$+*?.]/g, "\\$&").replace(/-/g, "\\x2d");
}, Q9 = {};
Object.defineProperty(Q9, "__esModule", { value: !0 });
/*!
 * is-plain-object <https://github.com/jonschlinkert/is-plain-object>
 *
 * Copyright (c) 2014-2017, Jon Schlinkert.
 * Released under the MIT License.
 */
function OD(t) {
  return Object.prototype.toString.call(t) === "[object Object]";
}
function wBe(t) {
  var e, n;
  return OD(t) === !1 ? !1 : (e = t.constructor, e === void 0 ? !0 : (n = e.prototype, !(OD(n) === !1 || n.hasOwnProperty("isPrototypeOf") === !1)));
}
Q9.isPlainObject = wBe;
var EBe = function(e) {
  return SBe(e) && !IBe(e);
};
function SBe(t) {
  return !!t && typeof t == "object";
}
function IBe(t) {
  var e = Object.prototype.toString.call(t);
  return e === "[object RegExp]" || e === "[object Date]" || TBe(t);
}
var _Be = typeof Symbol == "function" && Symbol.for, ABe = _Be ? Symbol.for("react.element") : 60103;
function TBe(t) {
  return t.$$typeof === ABe;
}
function OBe(t) {
  return Array.isArray(t) ? [] : {};
}
function em(t, e) {
  return e.clone !== !1 && e.isMergeableObject(t) ? op(OBe(t), t, e) : t;
}
function PBe(t, e, n) {
  return t.concat(e).map(function(r) {
    return em(r, n);
  });
}
function NBe(t, e) {
  if (!e.customMerge)
    return op;
  var n = e.customMerge(t);
  return typeof n == "function" ? n : op;
}
function kBe(t) {
  return Object.getOwnPropertySymbols ? Object.getOwnPropertySymbols(t).filter(function(e) {
    return Object.propertyIsEnumerable.call(t, e);
  }) : [];
}
function PD(t) {
  return Object.keys(t).concat(kBe(t));
}
function sZ(t, e) {
  try {
    return e in t;
  } catch {
    return !1;
  }
}
function RBe(t, e) {
  return sZ(t, e) && !(Object.hasOwnProperty.call(t, e) && Object.propertyIsEnumerable.call(t, e));
}
function $Be(t, e, n) {
  var r = {};
  return n.isMergeableObject(t) && PD(t).forEach(function(i) {
    r[i] = em(t[i], n);
  }), PD(e).forEach(function(i) {
    RBe(t, i) || (sZ(t, i) && n.isMergeableObject(e[i]) ? r[i] = NBe(i, n)(t[i], e[i], n) : r[i] = em(e[i], n));
  }), r;
}
function op(t, e, n) {
  n = n || {}, n.arrayMerge = n.arrayMerge || PBe, n.isMergeableObject = n.isMergeableObject || EBe, n.cloneUnlessOtherwiseSpecified = em;
  var r = Array.isArray(e), i = Array.isArray(t), o = r === i;
  return o ? r ? n.arrayMerge(t, e, n) : $Be(t, e, n) : em(e, n);
}
op.all = function(e, n) {
  if (!Array.isArray(e))
    throw new Error("first argument should be an array");
  return e.reduce(function(r, i) {
    return op(r, i, n);
  }, {});
};
var DBe = op, MBe = DBe, uZ = { exports: {} };
(function(t) {
  (function(e, n) {
    t.exports ? t.exports = n() : e.parseSrcset = n();
  })(ft, function() {
    return function(e) {
      function n(S) {
        return S === " " || // space
        S === "	" || // horizontal tab
        S === `
` || // new line
        S === "\f" || // form feed
        S === "\r";
      }
      function r(S) {
        var E, I = S.exec(e.substring(m));
        if (I)
          return E = I[0], m += E.length, E;
      }
      for (var i = e.length, o = /^[ \t\n\r\u000c]+/, a = /^[, \t\n\r\u000c]+/, s = /^[^ \t\n\r\u000c]+/, u = /[,]+$/, l = /^\d+$/, c = /^-?(?:[0-9]+|[0-9]*\.[0-9]+)(?:[eE][+-]?[0-9]+)?$/, d, f, h, p, v, m = 0, b = []; ; ) {
        if (r(a), m >= i)
          return b;
        d = r(s), f = [], d.slice(-1) === "," ? (d = d.replace(u, ""), w()) : y();
      }
      function y() {
        for (r(o), h = "", p = "in descriptor"; ; ) {
          if (v = e.charAt(m), p === "in descriptor")
            if (n(v))
              h && (f.push(h), h = "", p = "after descriptor");
            else if (v === ",") {
              m += 1, h && f.push(h), w();
              return;
            } else if (v === "(")
              h = h + v, p = "in parens";
            else if (v === "") {
              h && f.push(h), w();
              return;
            } else
              h = h + v;
          else if (p === "in parens")
            if (v === ")")
              h = h + v, p = "in descriptor";
            else if (v === "") {
              f.push(h), w();
              return;
            } else
              h = h + v;
          else if (p === "after descriptor" && !n(v))
            if (v === "") {
              w();
              return;
            } else
              p = "in descriptor", m -= 1;
          m += 1;
        }
      }
      function w() {
        var S = !1, E, I, _, A, P = {}, N, k, D, R, V;
        for (A = 0; A < f.length; A++)
          N = f[A], k = N[N.length - 1], D = N.substring(0, N.length - 1), R = parseInt(D, 10), V = parseFloat(D), l.test(D) && k === "w" ? ((E || I) && (S = !0), R === 0 ? S = !0 : E = R) : c.test(D) && k === "x" ? ((E || I || _) && (S = !0), V < 0 ? S = !0 : I = V) : l.test(D) && k === "h" ? ((_ || I) && (S = !0), R === 0 ? S = !0 : _ = R) : S = !0;
        S ? console && console.log && console.log("Invalid srcset descriptor found in '" + e + "' at '" + N + "'.") : (P.url = d, E && (P.w = E), I && (P.d = I), _ && (P.h = _), b.push(P));
      }
    };
  });
})(uZ);
var FBe = uZ.exports, eT = { exports: {} }, $r = String, lZ = function() {
  return { isColorSupported: !1, reset: $r, bold: $r, dim: $r, italic: $r, underline: $r, inverse: $r, hidden: $r, strikethrough: $r, black: $r, red: $r, green: $r, yellow: $r, blue: $r, magenta: $r, cyan: $r, white: $r, gray: $r, bgBlack: $r, bgRed: $r, bgGreen: $r, bgYellow: $r, bgBlue: $r, bgMagenta: $r, bgCyan: $r, bgWhite: $r };
};
eT.exports = lZ();
eT.exports.createColors = lZ;
var LBe = eT.exports;
const VBe = {}, BBe = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: VBe
}, Symbol.toStringTag, { value: "Module" })), Fs = /* @__PURE__ */ LH(BBe);
let ND = LBe, kD = Fs, R_ = class cZ extends Error {
  constructor(e, n, r, i, o, a) {
    super(e), this.name = "CssSyntaxError", this.reason = e, o && (this.file = o), i && (this.source = i), a && (this.plugin = a), typeof n < "u" && typeof r < "u" && (typeof n == "number" ? (this.line = n, this.column = r) : (this.line = n.line, this.column = n.column, this.endLine = r.line, this.endColumn = r.column)), this.setMessage(), Error.captureStackTrace && Error.captureStackTrace(this, cZ);
  }
  setMessage() {
    this.message = this.plugin ? this.plugin + ": " : "", this.message += this.file ? this.file : "<css input>", typeof this.line < "u" && (this.message += ":" + this.line + ":" + this.column), this.message += ": " + this.reason;
  }
  showSourceCode(e) {
    if (!this.source)
      return "";
    let n = this.source;
    e == null && (e = ND.isColorSupported), kD && e && (n = kD(n));
    let r = n.split(/\r?\n/), i = Math.max(this.line - 3, 0), o = Math.min(this.line + 2, r.length), a = String(o).length, s, u;
    if (e) {
      let { bold: l, gray: c, red: d } = ND.createColors(!0);
      s = (f) => l(d(f)), u = (f) => c(f);
    } else
      s = u = (l) => l;
    return r.slice(i, o).map((l, c) => {
      let d = i + 1 + c, f = " " + (" " + d).slice(-a) + " | ";
      if (d === this.line) {
        let h = u(f.replace(/\d/g, " ")) + l.slice(0, this.column - 1).replace(/[^\t]/g, " ");
        return s(">") + u(f) + l + `
 ` + h + s("^");
      }
      return " " + u(f) + l;
    }).join(`
`);
  }
  toString() {
    let e = this.showSourceCode();
    return e && (e = `

` + e + `
`), this.name + ": " + this.message + e;
  }
};
var tT = R_;
R_.default = R_;
var ov = {};
ov.isClean = Symbol("isClean");
ov.my = Symbol("my");
const RD = {
  after: `
`,
  beforeClose: `
`,
  beforeComment: `
`,
  beforeDecl: `
`,
  beforeOpen: " ",
  beforeRule: `
`,
  colon: ": ",
  commentLeft: " ",
  commentRight: " ",
  emptyBody: "",
  indent: "    ",
  semicolon: !1
};
function HBe(t) {
  return t[0].toUpperCase() + t.slice(1);
}
let $_ = class {
  constructor(e) {
    this.builder = e;
  }
  atrule(e, n) {
    let r = "@" + e.name, i = e.params ? this.rawValue(e, "params") : "";
    if (typeof e.raws.afterName < "u" ? r += e.raws.afterName : i && (r += " "), e.nodes)
      this.block(e, r + i);
    else {
      let o = (e.raws.between || "") + (n ? ";" : "");
      this.builder(r + i + o, e);
    }
  }
  beforeAfter(e, n) {
    let r;
    e.type === "decl" ? r = this.raw(e, null, "beforeDecl") : e.type === "comment" ? r = this.raw(e, null, "beforeComment") : n === "before" ? r = this.raw(e, null, "beforeRule") : r = this.raw(e, null, "beforeClose");
    let i = e.parent, o = 0;
    for (; i && i.type !== "root"; )
      o += 1, i = i.parent;
    if (r.includes(`
`)) {
      let a = this.raw(e, null, "indent");
      if (a.length)
        for (let s = 0; s < o; s++)
          r += a;
    }
    return r;
  }
  block(e, n) {
    let r = this.raw(e, "between", "beforeOpen");
    this.builder(n + r + "{", e, "start");
    let i;
    e.nodes && e.nodes.length ? (this.body(e), i = this.raw(e, "after")) : i = this.raw(e, "after", "emptyBody"), i && this.builder(i), this.builder("}", e, "end");
  }
  body(e) {
    let n = e.nodes.length - 1;
    for (; n > 0 && e.nodes[n].type === "comment"; )
      n -= 1;
    let r = this.raw(e, "semicolon");
    for (let i = 0; i < e.nodes.length; i++) {
      let o = e.nodes[i], a = this.raw(o, "before");
      a && this.builder(a), this.stringify(o, n !== i || r);
    }
  }
  comment(e) {
    let n = this.raw(e, "left", "commentLeft"), r = this.raw(e, "right", "commentRight");
    this.builder("/*" + n + e.text + r + "*/", e);
  }
  decl(e, n) {
    let r = this.raw(e, "between", "colon"), i = e.prop + r + this.rawValue(e, "value");
    e.important && (i += e.raws.important || " !important"), n && (i += ";"), this.builder(i, e);
  }
  document(e) {
    this.body(e);
  }
  raw(e, n, r) {
    let i;
    if (r || (r = n), n && (i = e.raws[n], typeof i < "u"))
      return i;
    let o = e.parent;
    if (r === "before" && (!o || o.type === "root" && o.first === e || o && o.type === "document"))
      return "";
    if (!o)
      return RD[r];
    let a = e.root();
    if (a.rawCache || (a.rawCache = {}), typeof a.rawCache[r] < "u")
      return a.rawCache[r];
    if (r === "before" || r === "after")
      return this.beforeAfter(e, r);
    {
      let s = "raw" + HBe(r);
      this[s] ? i = this[s](a, e) : a.walk((u) => {
        if (i = u.raws[n], typeof i < "u")
          return !1;
      });
    }
    return typeof i > "u" && (i = RD[r]), a.rawCache[r] = i, i;
  }
  rawBeforeClose(e) {
    let n;
    return e.walk((r) => {
      if (r.nodes && r.nodes.length > 0 && typeof r.raws.after < "u")
        return n = r.raws.after, n.includes(`
`) && (n = n.replace(/[^\n]+$/, "")), !1;
    }), n && (n = n.replace(/\S/g, "")), n;
  }
  rawBeforeComment(e, n) {
    let r;
    return e.walkComments((i) => {
      if (typeof i.raws.before < "u")
        return r = i.raws.before, r.includes(`
`) && (r = r.replace(/[^\n]+$/, "")), !1;
    }), typeof r > "u" ? r = this.raw(n, null, "beforeDecl") : r && (r = r.replace(/\S/g, "")), r;
  }
  rawBeforeDecl(e, n) {
    let r;
    return e.walkDecls((i) => {
      if (typeof i.raws.before < "u")
        return r = i.raws.before, r.includes(`
`) && (r = r.replace(/[^\n]+$/, "")), !1;
    }), typeof r > "u" ? r = this.raw(n, null, "beforeRule") : r && (r = r.replace(/\S/g, "")), r;
  }
  rawBeforeOpen(e) {
    let n;
    return e.walk((r) => {
      if (r.type !== "decl" && (n = r.raws.between, typeof n < "u"))
        return !1;
    }), n;
  }
  rawBeforeRule(e) {
    let n;
    return e.walk((r) => {
      if (r.nodes && (r.parent !== e || e.first !== r) && typeof r.raws.before < "u")
        return n = r.raws.before, n.includes(`
`) && (n = n.replace(/[^\n]+$/, "")), !1;
    }), n && (n = n.replace(/\S/g, "")), n;
  }
  rawColon(e) {
    let n;
    return e.walkDecls((r) => {
      if (typeof r.raws.between < "u")
        return n = r.raws.between.replace(/[^\s:]/g, ""), !1;
    }), n;
  }
  rawEmptyBody(e) {
    let n;
    return e.walk((r) => {
      if (r.nodes && r.nodes.length === 0 && (n = r.raws.after, typeof n < "u"))
        return !1;
    }), n;
  }
  rawIndent(e) {
    if (e.raws.indent)
      return e.raws.indent;
    let n;
    return e.walk((r) => {
      let i = r.parent;
      if (i && i !== e && i.parent && i.parent === e && typeof r.raws.before < "u") {
        let o = r.raws.before.split(`
`);
        return n = o[o.length - 1], n = n.replace(/\S/g, ""), !1;
      }
    }), n;
  }
  rawSemicolon(e) {
    let n;
    return e.walk((r) => {
      if (r.nodes && r.nodes.length && r.last.type === "decl" && (n = r.raws.semicolon, typeof n < "u"))
        return !1;
    }), n;
  }
  rawValue(e, n) {
    let r = e[n], i = e.raws[n];
    return i && i.value === r ? i.raw : r;
  }
  root(e) {
    this.body(e), e.raws.after && this.builder(e.raws.after);
  }
  rule(e) {
    this.block(e, this.rawValue(e, "selector")), e.raws.ownSemicolon && this.builder(e.raws.ownSemicolon, e, "end");
  }
  stringify(e, n) {
    if (!this[e.type])
      throw new Error(
        "Unknown AST node type " + e.type + ". Maybe you need to change PostCSS stringifier."
      );
    this[e.type](e, n);
  }
};
var dZ = $_;
$_.default = $_;
let WBe = dZ;
function D_(t, e) {
  new WBe(e).stringify(t);
}
var nw = D_;
D_.default = D_;
let { isClean: gb, my: jBe } = ov, zBe = tT, GBe = dZ, UBe = nw;
function M_(t, e) {
  let n = new t.constructor();
  for (let r in t) {
    if (!Object.prototype.hasOwnProperty.call(t, r) || r === "proxyCache")
      continue;
    let i = t[r], o = typeof i;
    r === "parent" && o === "object" ? e && (n[r] = e) : r === "source" ? n[r] = i : Array.isArray(i) ? n[r] = i.map((a) => M_(a, n)) : (o === "object" && i !== null && (i = M_(i)), n[r] = i);
  }
  return n;
}
let F_ = class {
  constructor(e = {}) {
    this.raws = {}, this[gb] = !1, this[jBe] = !0;
    for (let n in e)
      if (n === "nodes") {
        this.nodes = [];
        for (let r of e[n])
          typeof r.clone == "function" ? this.append(r.clone()) : this.append(r);
      } else
        this[n] = e[n];
  }
  addToError(e) {
    if (e.postcssNode = this, e.stack && this.source && /\n\s{4}at /.test(e.stack)) {
      let n = this.source;
      e.stack = e.stack.replace(
        /\n\s{4}at /,
        `$&${n.input.from}:${n.start.line}:${n.start.column}$&`
      );
    }
    return e;
  }
  after(e) {
    return this.parent.insertAfter(this, e), this;
  }
  assign(e = {}) {
    for (let n in e)
      this[n] = e[n];
    return this;
  }
  before(e) {
    return this.parent.insertBefore(this, e), this;
  }
  cleanRaws(e) {
    delete this.raws.before, delete this.raws.after, e || delete this.raws.between;
  }
  clone(e = {}) {
    let n = M_(this);
    for (let r in e)
      n[r] = e[r];
    return n;
  }
  cloneAfter(e = {}) {
    let n = this.clone(e);
    return this.parent.insertAfter(this, n), n;
  }
  cloneBefore(e = {}) {
    let n = this.clone(e);
    return this.parent.insertBefore(this, n), n;
  }
  error(e, n = {}) {
    if (this.source) {
      let { end: r, start: i } = this.rangeBy(n);
      return this.source.input.error(
        e,
        { column: i.column, line: i.line },
        { column: r.column, line: r.line },
        n
      );
    }
    return new zBe(e);
  }
  getProxyProcessor() {
    return {
      get(e, n) {
        return n === "proxyOf" ? e : n === "root" ? () => e.root().toProxy() : e[n];
      },
      set(e, n, r) {
        return e[n] === r || (e[n] = r, (n === "prop" || n === "value" || n === "name" || n === "params" || n === "important" || /* c8 ignore next */
        n === "text") && e.markDirty()), !0;
      }
    };
  }
  markDirty() {
    if (this[gb]) {
      this[gb] = !1;
      let e = this;
      for (; e = e.parent; )
        e[gb] = !1;
    }
  }
  next() {
    if (!this.parent)
      return;
    let e = this.parent.index(this);
    return this.parent.nodes[e + 1];
  }
  positionBy(e, n) {
    let r = this.source.start;
    if (e.index)
      r = this.positionInside(e.index, n);
    else if (e.word) {
      n = this.toString();
      let i = n.indexOf(e.word);
      i !== -1 && (r = this.positionInside(i, n));
    }
    return r;
  }
  positionInside(e, n) {
    let r = n || this.toString(), i = this.source.start.column, o = this.source.start.line;
    for (let a = 0; a < e; a++)
      r[a] === `
` ? (i = 1, o += 1) : i += 1;
    return { column: i, line: o };
  }
  prev() {
    if (!this.parent)
      return;
    let e = this.parent.index(this);
    return this.parent.nodes[e - 1];
  }
  rangeBy(e) {
    let n = {
      column: this.source.start.column,
      line: this.source.start.line
    }, r = this.source.end ? {
      column: this.source.end.column + 1,
      line: this.source.end.line
    } : {
      column: n.column + 1,
      line: n.line
    };
    if (e.word) {
      let i = this.toString(), o = i.indexOf(e.word);
      o !== -1 && (n = this.positionInside(o, i), r = this.positionInside(o + e.word.length, i));
    } else
      e.start ? n = {
        column: e.start.column,
        line: e.start.line
      } : e.index && (n = this.positionInside(e.index)), e.end ? r = {
        column: e.end.column,
        line: e.end.line
      } : e.endIndex ? r = this.positionInside(e.endIndex) : e.index && (r = this.positionInside(e.index + 1));
    return (r.line < n.line || r.line === n.line && r.column <= n.column) && (r = { column: n.column + 1, line: n.line }), { end: r, start: n };
  }
  raw(e, n) {
    return new GBe().raw(this, e, n);
  }
  remove() {
    return this.parent && this.parent.removeChild(this), this.parent = void 0, this;
  }
  replaceWith(...e) {
    if (this.parent) {
      let n = this, r = !1;
      for (let i of e)
        i === this ? r = !0 : r ? (this.parent.insertAfter(n, i), n = i) : this.parent.insertBefore(n, i);
      r || this.remove();
    }
    return this;
  }
  root() {
    let e = this;
    for (; e.parent && e.parent.type !== "document"; )
      e = e.parent;
    return e;
  }
  toJSON(e, n) {
    let r = {}, i = n == null;
    n = n || /* @__PURE__ */ new Map();
    let o = 0;
    for (let a in this) {
      if (!Object.prototype.hasOwnProperty.call(this, a) || a === "parent" || a === "proxyCache")
        continue;
      let s = this[a];
      if (Array.isArray(s))
        r[a] = s.map((u) => typeof u == "object" && u.toJSON ? u.toJSON(null, n) : u);
      else if (typeof s == "object" && s.toJSON)
        r[a] = s.toJSON(null, n);
      else if (a === "source") {
        let u = n.get(s.input);
        u == null && (u = o, n.set(s.input, o), o++), r[a] = {
          end: s.end,
          inputId: u,
          start: s.start
        };
      } else
        r[a] = s;
    }
    return i && (r.inputs = [...n.keys()].map((a) => a.toJSON())), r;
  }
  toProxy() {
    return this.proxyCache || (this.proxyCache = new Proxy(this, this.getProxyProcessor())), this.proxyCache;
  }
  toString(e = UBe) {
    e.stringify && (e = e.stringify);
    let n = "";
    return e(this, (r) => {
      n += r;
    }), n;
  }
  warn(e, n, r) {
    let i = { node: this };
    for (let o in r)
      i[o] = r[o];
    return e.warn(n, i);
  }
  get proxyOf() {
    return this;
  }
};
var rw = F_;
F_.default = F_;
let XBe = rw, L_ = class extends XBe {
  constructor(e) {
    e && typeof e.value < "u" && typeof e.value != "string" && (e = { ...e, value: String(e.value) }), super(e), this.type = "decl";
  }
  get variable() {
    return this.prop.startsWith("--") || this.prop[0] === "$";
  }
};
var iw = L_;
L_.default = L_;
let YBe = "useandom-26T198340PX75pxJACKVERYMINDBUSHWOLF_GQZbfghjklqvwyzrict", ZBe = (t, e = 21) => (n = e) => {
  let r = "", i = n;
  for (; i--; )
    r += t[Math.random() * t.length | 0];
  return r;
}, JBe = (t = 21) => {
  let e = "", n = t;
  for (; n--; )
    e += YBe[Math.random() * 64 | 0];
  return e;
};
var KBe = { nanoid: JBe, customAlphabet: ZBe };
let { SourceMapConsumer: $D, SourceMapGenerator: DD } = Fs, { existsSync: qBe, readFileSync: QBe } = Fs, { dirname: T3, join: eHe } = Fs;
function tHe(t) {
  return Buffer ? Buffer.from(t, "base64").toString() : window.atob(t);
}
let V_ = class {
  constructor(e, n) {
    if (n.map === !1)
      return;
    this.loadAnnotation(e), this.inline = this.startWith(this.annotation, "data:");
    let r = n.map ? n.map.prev : void 0, i = this.loadMap(n.from, r);
    !this.mapFile && n.from && (this.mapFile = n.from), this.mapFile && (this.root = T3(this.mapFile)), i && (this.text = i);
  }
  consumer() {
    return this.consumerCache || (this.consumerCache = new $D(this.text)), this.consumerCache;
  }
  decodeInline(e) {
    let n = /^data:application\/json;charset=utf-?8;base64,/, r = /^data:application\/json;base64,/, i = /^data:application\/json;charset=utf-?8,/, o = /^data:application\/json,/;
    if (i.test(e) || o.test(e))
      return decodeURIComponent(e.substr(RegExp.lastMatch.length));
    if (n.test(e) || r.test(e))
      return tHe(e.substr(RegExp.lastMatch.length));
    let a = e.match(/data:application\/json;([^,]+),/)[1];
    throw new Error("Unsupported source map encoding " + a);
  }
  getAnnotationURL(e) {
    return e.replace(/^\/\*\s*# sourceMappingURL=/, "").trim();
  }
  isMap(e) {
    return typeof e != "object" ? !1 : typeof e.mappings == "string" || typeof e._mappings == "string" || Array.isArray(e.sections);
  }
  loadAnnotation(e) {
    let n = e.match(/\/\*\s*# sourceMappingURL=/gm);
    if (!n)
      return;
    let r = e.lastIndexOf(n.pop()), i = e.indexOf("*/", r);
    r > -1 && i > -1 && (this.annotation = this.getAnnotationURL(e.substring(r, i)));
  }
  loadFile(e) {
    if (this.root = T3(e), qBe(e))
      return this.mapFile = e, QBe(e, "utf-8").toString().trim();
  }
  loadMap(e, n) {
    if (n === !1)
      return !1;
    if (n) {
      if (typeof n == "string")
        return n;
      if (typeof n == "function") {
        let r = n(e);
        if (r) {
          let i = this.loadFile(r);
          if (!i)
            throw new Error(
              "Unable to load previous source map: " + r.toString()
            );
          return i;
        }
      } else {
        if (n instanceof $D)
          return DD.fromSourceMap(n).toString();
        if (n instanceof DD)
          return n.toString();
        if (this.isMap(n))
          return JSON.stringify(n);
        throw new Error(
          "Unsupported previous source map format: " + n.toString()
        );
      }
    } else {
      if (this.inline)
        return this.decodeInline(this.annotation);
      if (this.annotation) {
        let r = this.annotation;
        return e && (r = eHe(T3(e), r)), this.loadFile(r);
      }
    }
  }
  startWith(e, n) {
    return e ? e.substr(0, n.length) === n : !1;
  }
  withContent() {
    return !!(this.consumer().sourcesContent && this.consumer().sourcesContent.length > 0);
  }
};
var fZ = V_;
V_.default = V_;
let { SourceMapConsumer: nHe, SourceMapGenerator: rHe } = Fs, { fileURLToPath: MD, pathToFileURL: mb } = Fs, { isAbsolute: B_, resolve: H_ } = Fs, { nanoid: iHe } = KBe, O3 = Fs, FD = tT, oHe = fZ, P3 = Symbol("fromOffsetCache"), aHe = !!(nHe && rHe), LD = !!(H_ && B_), Wx = class {
  constructor(e, n = {}) {
    if (e === null || typeof e > "u" || typeof e == "object" && !e.toString)
      throw new Error(`PostCSS received ${e} instead of CSS string`);
    if (this.css = e.toString(), this.css[0] === "\uFEFF" || this.css[0] === "￾" ? (this.hasBOM = !0, this.css = this.css.slice(1)) : this.hasBOM = !1, n.from && (!LD || /^\w+:\/\//.test(n.from) || B_(n.from) ? this.file = n.from : this.file = H_(n.from)), LD && aHe) {
      let r = new oHe(this.css, n);
      if (r.text) {
        this.map = r;
        let i = r.consumer().file;
        !this.file && i && (this.file = this.mapResolve(i));
      }
    }
    this.file || (this.id = "<input css " + iHe(6) + ">"), this.map && (this.map.file = this.from);
  }
  error(e, n, r, i = {}) {
    let o, a, s;
    if (n && typeof n == "object") {
      let l = n, c = r;
      if (typeof l.offset == "number") {
        let d = this.fromOffset(l.offset);
        n = d.line, r = d.col;
      } else
        n = l.line, r = l.column;
      if (typeof c.offset == "number") {
        let d = this.fromOffset(c.offset);
        a = d.line, s = d.col;
      } else
        a = c.line, s = c.column;
    } else if (!r) {
      let l = this.fromOffset(n);
      n = l.line, r = l.col;
    }
    let u = this.origin(n, r, a, s);
    return u ? o = new FD(
      e,
      u.endLine === void 0 ? u.line : { column: u.column, line: u.line },
      u.endLine === void 0 ? u.column : { column: u.endColumn, line: u.endLine },
      u.source,
      u.file,
      i.plugin
    ) : o = new FD(
      e,
      a === void 0 ? n : { column: r, line: n },
      a === void 0 ? r : { column: s, line: a },
      this.css,
      this.file,
      i.plugin
    ), o.input = { column: r, endColumn: s, endLine: a, line: n, source: this.css }, this.file && (mb && (o.input.url = mb(this.file).toString()), o.input.file = this.file), o;
  }
  fromOffset(e) {
    let n, r;
    if (this[P3])
      r = this[P3];
    else {
      let o = this.css.split(`
`);
      r = new Array(o.length);
      let a = 0;
      for (let s = 0, u = o.length; s < u; s++)
        r[s] = a, a += o[s].length + 1;
      this[P3] = r;
    }
    n = r[r.length - 1];
    let i = 0;
    if (e >= n)
      i = r.length - 1;
    else {
      let o = r.length - 2, a;
      for (; i < o; )
        if (a = i + (o - i >> 1), e < r[a])
          o = a - 1;
        else if (e >= r[a + 1])
          i = a + 1;
        else {
          i = a;
          break;
        }
    }
    return {
      col: e - r[i] + 1,
      line: i + 1
    };
  }
  mapResolve(e) {
    return /^\w+:\/\//.test(e) ? e : H_(this.map.consumer().sourceRoot || this.map.root || ".", e);
  }
  origin(e, n, r, i) {
    if (!this.map)
      return !1;
    let o = this.map.consumer(), a = o.originalPositionFor({ column: n, line: e });
    if (!a.source)
      return !1;
    let s;
    typeof r == "number" && (s = o.originalPositionFor({ column: i, line: r }));
    let u;
    B_(a.source) ? u = mb(a.source) : u = new URL(
      a.source,
      this.map.consumer().sourceRoot || mb(this.map.mapFile)
    );
    let l = {
      column: a.column,
      endColumn: s && s.column,
      endLine: s && s.line,
      line: a.line,
      url: u.toString()
    };
    if (u.protocol === "file:")
      if (MD)
        l.file = MD(u);
      else
        throw new Error("file: protocol is not available in this PostCSS build");
    let c = o.sourceContentFor(a.source);
    return c && (l.source = c), l;
  }
  toJSON() {
    let e = {};
    for (let n of ["hasBOM", "css", "file", "id"])
      this[n] != null && (e[n] = this[n]);
    return this.map && (e.map = { ...this.map }, e.map.consumerCache && (e.map.consumerCache = void 0)), e;
  }
  get from() {
    return this.file || this.id;
  }
};
var ow = Wx;
Wx.default = Wx;
O3 && O3.registerInput && O3.registerInput(Wx);
let { SourceMapConsumer: hZ, SourceMapGenerator: my } = Fs, { dirname: vy, relative: pZ, resolve: gZ, sep: mZ } = Fs, { pathToFileURL: VD } = Fs, sHe = ow, uHe = !!(hZ && my), lHe = !!(vy && gZ && pZ && mZ), cHe = class {
  constructor(e, n, r, i) {
    this.stringify = e, this.mapOpts = r.map || {}, this.root = n, this.opts = r, this.css = i, this.usesFileUrls = !this.mapOpts.from && this.mapOpts.absolute, this.memoizedFileURLs = /* @__PURE__ */ new Map(), this.memoizedPaths = /* @__PURE__ */ new Map(), this.memoizedURLs = /* @__PURE__ */ new Map();
  }
  addAnnotation() {
    let e;
    this.isInline() ? e = "data:application/json;base64," + this.toBase64(this.map.toString()) : typeof this.mapOpts.annotation == "string" ? e = this.mapOpts.annotation : typeof this.mapOpts.annotation == "function" ? e = this.mapOpts.annotation(this.opts.to, this.root) : e = this.outputFile() + ".map";
    let n = `
`;
    this.css.includes(`\r
`) && (n = `\r
`), this.css += n + "/*# sourceMappingURL=" + e + " */";
  }
  applyPrevMaps() {
    for (let e of this.previous()) {
      let n = this.toUrl(this.path(e.file)), r = e.root || vy(e.file), i;
      this.mapOpts.sourcesContent === !1 ? (i = new hZ(e.text), i.sourcesContent && (i.sourcesContent = i.sourcesContent.map(() => null))) : i = e.consumer(), this.map.applySourceMap(i, n, this.toUrl(this.path(r)));
    }
  }
  clearAnnotation() {
    if (this.mapOpts.annotation !== !1)
      if (this.root) {
        let e;
        for (let n = this.root.nodes.length - 1; n >= 0; n--)
          e = this.root.nodes[n], e.type === "comment" && e.text.indexOf("# sourceMappingURL=") === 0 && this.root.removeChild(n);
      } else
        this.css && (this.css = this.css.replace(/(\n)?\/\*#[\S\s]*?\*\/$/gm, ""));
  }
  generate() {
    if (this.clearAnnotation(), lHe && uHe && this.isMap())
      return this.generateMap();
    {
      let e = "";
      return this.stringify(this.root, (n) => {
        e += n;
      }), [e];
    }
  }
  generateMap() {
    if (this.root)
      this.generateString();
    else if (this.previous().length === 1) {
      let e = this.previous()[0].consumer();
      e.file = this.outputFile(), this.map = my.fromSourceMap(e);
    } else
      this.map = new my({ file: this.outputFile() }), this.map.addMapping({
        generated: { column: 0, line: 1 },
        original: { column: 0, line: 1 },
        source: this.opts.from ? this.toUrl(this.path(this.opts.from)) : "<no source>"
      });
    return this.isSourcesContent() && this.setSourcesContent(), this.root && this.previous().length > 0 && this.applyPrevMaps(), this.isAnnotation() && this.addAnnotation(), this.isInline() ? [this.css] : [this.css, this.map];
  }
  generateString() {
    this.css = "", this.map = new my({ file: this.outputFile() });
    let e = 1, n = 1, r = "<no source>", i = {
      generated: { column: 0, line: 0 },
      original: { column: 0, line: 0 },
      source: ""
    }, o, a;
    this.stringify(this.root, (s, u, l) => {
      if (this.css += s, u && l !== "end" && (i.generated.line = e, i.generated.column = n - 1, u.source && u.source.start ? (i.source = this.sourcePath(u), i.original.line = u.source.start.line, i.original.column = u.source.start.column - 1, this.map.addMapping(i)) : (i.source = r, i.original.line = 1, i.original.column = 0, this.map.addMapping(i))), o = s.match(/\n/g), o ? (e += o.length, a = s.lastIndexOf(`
`), n = s.length - a) : n += s.length, u && l !== "start") {
        let c = u.parent || { raws: {} };
        (!(u.type === "decl" || u.type === "atrule" && !u.nodes) || u !== c.last || c.raws.semicolon) && (u.source && u.source.end ? (i.source = this.sourcePath(u), i.original.line = u.source.end.line, i.original.column = u.source.end.column - 1, i.generated.line = e, i.generated.column = n - 2, this.map.addMapping(i)) : (i.source = r, i.original.line = 1, i.original.column = 0, i.generated.line = e, i.generated.column = n - 1, this.map.addMapping(i)));
      }
    });
  }
  isAnnotation() {
    return this.isInline() ? !0 : typeof this.mapOpts.annotation < "u" ? this.mapOpts.annotation : this.previous().length ? this.previous().some((e) => e.annotation) : !0;
  }
  isInline() {
    if (typeof this.mapOpts.inline < "u")
      return this.mapOpts.inline;
    let e = this.mapOpts.annotation;
    return typeof e < "u" && e !== !0 ? !1 : this.previous().length ? this.previous().some((n) => n.inline) : !0;
  }
  isMap() {
    return typeof this.opts.map < "u" ? !!this.opts.map : this.previous().length > 0;
  }
  isSourcesContent() {
    return typeof this.mapOpts.sourcesContent < "u" ? this.mapOpts.sourcesContent : this.previous().length ? this.previous().some((e) => e.withContent()) : !0;
  }
  outputFile() {
    return this.opts.to ? this.path(this.opts.to) : this.opts.from ? this.path(this.opts.from) : "to.css";
  }
  path(e) {
    if (this.mapOpts.absolute || e.charCodeAt(0) === 60 || /^\w+:\/\//.test(e))
      return e;
    let n = this.memoizedPaths.get(e);
    if (n)
      return n;
    let r = this.opts.to ? vy(this.opts.to) : ".";
    typeof this.mapOpts.annotation == "string" && (r = vy(gZ(r, this.mapOpts.annotation)));
    let i = pZ(r, e);
    return this.memoizedPaths.set(e, i), i;
  }
  previous() {
    if (!this.previousMaps)
      if (this.previousMaps = [], this.root)
        this.root.walk((e) => {
          if (e.source && e.source.input.map) {
            let n = e.source.input.map;
            this.previousMaps.includes(n) || this.previousMaps.push(n);
          }
        });
      else {
        let e = new sHe(this.css, this.opts);
        e.map && this.previousMaps.push(e.map);
      }
    return this.previousMaps;
  }
  setSourcesContent() {
    let e = {};
    if (this.root)
      this.root.walk((n) => {
        if (n.source) {
          let r = n.source.input.from;
          if (r && !e[r]) {
            e[r] = !0;
            let i = this.usesFileUrls ? this.toFileUrl(r) : this.toUrl(this.path(r));
            this.map.setSourceContent(i, n.source.input.css);
          }
        }
      });
    else if (this.css) {
      let n = this.opts.from ? this.toUrl(this.path(this.opts.from)) : "<no source>";
      this.map.setSourceContent(n, this.css);
    }
  }
  sourcePath(e) {
    return this.mapOpts.from ? this.toUrl(this.mapOpts.from) : this.usesFileUrls ? this.toFileUrl(e.source.input.from) : this.toUrl(this.path(e.source.input.from));
  }
  toBase64(e) {
    return Buffer ? Buffer.from(e).toString("base64") : window.btoa(unescape(encodeURIComponent(e)));
  }
  toFileUrl(e) {
    let n = this.memoizedFileURLs.get(e);
    if (n)
      return n;
    if (VD) {
      let r = VD(e).toString();
      return this.memoizedFileURLs.set(e, r), r;
    } else
      throw new Error(
        "`map.absolute` option is not available in this PostCSS build"
      );
  }
  toUrl(e) {
    let n = this.memoizedURLs.get(e);
    if (n)
      return n;
    mZ === "\\" && (e = e.replace(/\\/g, "/"));
    let r = encodeURI(e).replace(/[#?]/g, encodeURIComponent);
    return this.memoizedURLs.set(e, r), r;
  }
};
var vZ = cHe;
let dHe = rw, W_ = class extends dHe {
  constructor(e) {
    super(e), this.type = "comment";
  }
};
var aw = W_;
W_.default = W_;
let { isClean: bZ, my: yZ } = ov, xZ = iw, CZ = aw, fHe = rw, wZ, nT, rT, EZ;
function SZ(t) {
  return t.map((e) => (e.nodes && (e.nodes = SZ(e.nodes)), delete e.source, e));
}
function IZ(t) {
  if (t[bZ] = !1, t.proxyOf.nodes)
    for (let e of t.proxyOf.nodes)
      IZ(e);
}
let tl = class _Z extends fHe {
  append(...e) {
    for (let n of e) {
      let r = this.normalize(n, this.last);
      for (let i of r)
        this.proxyOf.nodes.push(i);
    }
    return this.markDirty(), this;
  }
  cleanRaws(e) {
    if (super.cleanRaws(e), this.nodes)
      for (let n of this.nodes)
        n.cleanRaws(e);
  }
  each(e) {
    if (!this.proxyOf.nodes)
      return;
    let n = this.getIterator(), r, i;
    for (; this.indexes[n] < this.proxyOf.nodes.length && (r = this.indexes[n], i = e(this.proxyOf.nodes[r], r), i !== !1); )
      this.indexes[n] += 1;
    return delete this.indexes[n], i;
  }
  every(e) {
    return this.nodes.every(e);
  }
  getIterator() {
    this.lastEach || (this.lastEach = 0), this.indexes || (this.indexes = {}), this.lastEach += 1;
    let e = this.lastEach;
    return this.indexes[e] = 0, e;
  }
  getProxyProcessor() {
    return {
      get(e, n) {
        return n === "proxyOf" ? e : e[n] ? n === "each" || typeof n == "string" && n.startsWith("walk") ? (...r) => e[n](
          ...r.map((i) => typeof i == "function" ? (o, a) => i(o.toProxy(), a) : i)
        ) : n === "every" || n === "some" ? (r) => e[n](
          (i, ...o) => r(i.toProxy(), ...o)
        ) : n === "root" ? () => e.root().toProxy() : n === "nodes" ? e.nodes.map((r) => r.toProxy()) : n === "first" || n === "last" ? e[n].toProxy() : e[n] : e[n];
      },
      set(e, n, r) {
        return e[n] === r || (e[n] = r, (n === "name" || n === "params" || n === "selector") && e.markDirty()), !0;
      }
    };
  }
  index(e) {
    return typeof e == "number" ? e : (e.proxyOf && (e = e.proxyOf), this.proxyOf.nodes.indexOf(e));
  }
  insertAfter(e, n) {
    let r = this.index(e), i = this.normalize(n, this.proxyOf.nodes[r]).reverse();
    r = this.index(e);
    for (let a of i)
      this.proxyOf.nodes.splice(r + 1, 0, a);
    let o;
    for (let a in this.indexes)
      o = this.indexes[a], r < o && (this.indexes[a] = o + i.length);
    return this.markDirty(), this;
  }
  insertBefore(e, n) {
    let r = this.index(e), i = r === 0 ? "prepend" : !1, o = this.normalize(n, this.proxyOf.nodes[r], i).reverse();
    r = this.index(e);
    for (let s of o)
      this.proxyOf.nodes.splice(r, 0, s);
    let a;
    for (let s in this.indexes)
      a = this.indexes[s], r <= a && (this.indexes[s] = a + o.length);
    return this.markDirty(), this;
  }
  normalize(e, n) {
    if (typeof e == "string")
      e = SZ(wZ(e).nodes);
    else if (Array.isArray(e)) {
      e = e.slice(0);
      for (let i of e)
        i.parent && i.parent.removeChild(i, "ignore");
    } else if (e.type === "root" && this.type !== "document") {
      e = e.nodes.slice(0);
      for (let i of e)
        i.parent && i.parent.removeChild(i, "ignore");
    } else if (e.type)
      e = [e];
    else if (e.prop) {
      if (typeof e.value > "u")
        throw new Error("Value field is missed in node creation");
      typeof e.value != "string" && (e.value = String(e.value)), e = [new xZ(e)];
    } else if (e.selector)
      e = [new nT(e)];
    else if (e.name)
      e = [new rT(e)];
    else if (e.text)
      e = [new CZ(e)];
    else
      throw new Error("Unknown node type in node creation");
    return e.map((i) => (i[yZ] || _Z.rebuild(i), i = i.proxyOf, i.parent && i.parent.removeChild(i), i[bZ] && IZ(i), typeof i.raws.before > "u" && n && typeof n.raws.before < "u" && (i.raws.before = n.raws.before.replace(/\S/g, "")), i.parent = this.proxyOf, i));
  }
  prepend(...e) {
    e = e.reverse();
    for (let n of e) {
      let r = this.normalize(n, this.first, "prepend").reverse();
      for (let i of r)
        this.proxyOf.nodes.unshift(i);
      for (let i in this.indexes)
        this.indexes[i] = this.indexes[i] + r.length;
    }
    return this.markDirty(), this;
  }
  push(e) {
    return e.parent = this, this.proxyOf.nodes.push(e), this;
  }
  removeAll() {
    for (let e of this.proxyOf.nodes)
      e.parent = void 0;
    return this.proxyOf.nodes = [], this.markDirty(), this;
  }
  removeChild(e) {
    e = this.index(e), this.proxyOf.nodes[e].parent = void 0, this.proxyOf.nodes.splice(e, 1);
    let n;
    for (let r in this.indexes)
      n = this.indexes[r], n >= e && (this.indexes[r] = n - 1);
    return this.markDirty(), this;
  }
  replaceValues(e, n, r) {
    return r || (r = n, n = {}), this.walkDecls((i) => {
      n.props && !n.props.includes(i.prop) || n.fast && !i.value.includes(n.fast) || (i.value = i.value.replace(e, r));
    }), this.markDirty(), this;
  }
  some(e) {
    return this.nodes.some(e);
  }
  walk(e) {
    return this.each((n, r) => {
      let i;
      try {
        i = e(n, r);
      } catch (o) {
        throw n.addToError(o);
      }
      return i !== !1 && n.walk && (i = n.walk(e)), i;
    });
  }
  walkAtRules(e, n) {
    return n ? e instanceof RegExp ? this.walk((r, i) => {
      if (r.type === "atrule" && e.test(r.name))
        return n(r, i);
    }) : this.walk((r, i) => {
      if (r.type === "atrule" && r.name === e)
        return n(r, i);
    }) : (n = e, this.walk((r, i) => {
      if (r.type === "atrule")
        return n(r, i);
    }));
  }
  walkComments(e) {
    return this.walk((n, r) => {
      if (n.type === "comment")
        return e(n, r);
    });
  }
  walkDecls(e, n) {
    return n ? e instanceof RegExp ? this.walk((r, i) => {
      if (r.type === "decl" && e.test(r.prop))
        return n(r, i);
    }) : this.walk((r, i) => {
      if (r.type === "decl" && r.prop === e)
        return n(r, i);
    }) : (n = e, this.walk((r, i) => {
      if (r.type === "decl")
        return n(r, i);
    }));
  }
  walkRules(e, n) {
    return n ? e instanceof RegExp ? this.walk((r, i) => {
      if (r.type === "rule" && e.test(r.selector))
        return n(r, i);
    }) : this.walk((r, i) => {
      if (r.type === "rule" && r.selector === e)
        return n(r, i);
    }) : (n = e, this.walk((r, i) => {
      if (r.type === "rule")
        return n(r, i);
    }));
  }
  get first() {
    if (this.proxyOf.nodes)
      return this.proxyOf.nodes[0];
  }
  get last() {
    if (this.proxyOf.nodes)
      return this.proxyOf.nodes[this.proxyOf.nodes.length - 1];
  }
};
tl.registerParse = (t) => {
  wZ = t;
};
tl.registerRule = (t) => {
  nT = t;
};
tl.registerAtRule = (t) => {
  rT = t;
};
tl.registerRoot = (t) => {
  EZ = t;
};
var tf = tl;
tl.default = tl;
tl.rebuild = (t) => {
  t.type === "atrule" ? Object.setPrototypeOf(t, rT.prototype) : t.type === "rule" ? Object.setPrototypeOf(t, nT.prototype) : t.type === "decl" ? Object.setPrototypeOf(t, xZ.prototype) : t.type === "comment" ? Object.setPrototypeOf(t, CZ.prototype) : t.type === "root" && Object.setPrototypeOf(t, EZ.prototype), t[yZ] = !0, t.nodes && t.nodes.forEach((e) => {
    tl.rebuild(e);
  });
};
let hHe = tf, AZ, TZ, tm = class extends hHe {
  constructor(e) {
    super({ type: "document", ...e }), this.nodes || (this.nodes = []);
  }
  toResult(e = {}) {
    return new AZ(new TZ(), this, e).stringify();
  }
};
tm.registerLazyResult = (t) => {
  AZ = t;
};
tm.registerProcessor = (t) => {
  TZ = t;
};
var iT = tm;
tm.default = tm;
let BD = {};
var OZ = function(e) {
  BD[e] || (BD[e] = !0, typeof console < "u" && console.warn && console.warn(e));
};
let j_ = class {
  constructor(e, n = {}) {
    if (this.type = "warning", this.text = e, n.node && n.node.source) {
      let r = n.node.rangeBy(n);
      this.line = r.start.line, this.column = r.start.column, this.endLine = r.end.line, this.endColumn = r.end.column;
    }
    for (let r in n)
      this[r] = n[r];
  }
  toString() {
    return this.node ? this.node.error(this.text, {
      index: this.index,
      plugin: this.plugin,
      word: this.word
    }).message : this.plugin ? this.plugin + ": " + this.text : this.text;
  }
};
var PZ = j_;
j_.default = j_;
let pHe = PZ, z_ = class {
  constructor(e, n, r) {
    this.processor = e, this.messages = [], this.root = n, this.opts = r, this.css = void 0, this.map = void 0;
  }
  toString() {
    return this.css;
  }
  warn(e, n = {}) {
    n.plugin || this.lastPlugin && this.lastPlugin.postcssPlugin && (n.plugin = this.lastPlugin.postcssPlugin);
    let r = new pHe(e, n);
    return this.messages.push(r), r;
  }
  warnings() {
    return this.messages.filter((e) => e.type === "warning");
  }
  get content() {
    return this.css;
  }
};
var oT = z_;
z_.default = z_;
const N3 = 39, HD = 34, vb = 92, WD = 47, bb = 10, Dg = 32, yb = 12, xb = 9, Cb = 13, gHe = 91, mHe = 93, vHe = 40, bHe = 41, yHe = 123, xHe = 125, CHe = 59, wHe = 42, EHe = 58, SHe = 64, wb = /[\t\n\f\r "#'()/;[\\\]{}]/g, Eb = /[\t\n\f\r !"#'():;@[\\\]{}]|\/(?=\*)/g, IHe = /.[\r\n"'(/\\]/, jD = /[\da-f]/i;
var _He = function(e, n = {}) {
  let r = e.css.valueOf(), i = n.ignoreErrors, o, a, s, u, l, c, d, f, h, p, v = r.length, m = 0, b = [], y = [];
  function w() {
    return m;
  }
  function S(A) {
    throw e.error("Unclosed " + A, m);
  }
  function E() {
    return y.length === 0 && m >= v;
  }
  function I(A) {
    if (y.length)
      return y.pop();
    if (m >= v)
      return;
    let P = A ? A.ignoreUnclosed : !1;
    switch (o = r.charCodeAt(m), o) {
      case bb:
      case Dg:
      case xb:
      case Cb:
      case yb: {
        a = m;
        do
          a += 1, o = r.charCodeAt(a);
        while (o === Dg || o === bb || o === xb || o === Cb || o === yb);
        p = ["space", r.slice(m, a)], m = a - 1;
        break;
      }
      case gHe:
      case mHe:
      case yHe:
      case xHe:
      case EHe:
      case CHe:
      case bHe: {
        let N = String.fromCharCode(o);
        p = [N, N, m];
        break;
      }
      case vHe: {
        if (f = b.length ? b.pop()[1] : "", h = r.charCodeAt(m + 1), f === "url" && h !== N3 && h !== HD && h !== Dg && h !== bb && h !== xb && h !== yb && h !== Cb) {
          a = m;
          do {
            if (c = !1, a = r.indexOf(")", a + 1), a === -1)
              if (i || P) {
                a = m;
                break;
              } else
                S("bracket");
            for (d = a; r.charCodeAt(d - 1) === vb; )
              d -= 1, c = !c;
          } while (c);
          p = ["brackets", r.slice(m, a + 1), m, a], m = a;
        } else
          a = r.indexOf(")", m + 1), u = r.slice(m, a + 1), a === -1 || IHe.test(u) ? p = ["(", "(", m] : (p = ["brackets", u, m, a], m = a);
        break;
      }
      case N3:
      case HD: {
        s = o === N3 ? "'" : '"', a = m;
        do {
          if (c = !1, a = r.indexOf(s, a + 1), a === -1)
            if (i || P) {
              a = m + 1;
              break;
            } else
              S("string");
          for (d = a; r.charCodeAt(d - 1) === vb; )
            d -= 1, c = !c;
        } while (c);
        p = ["string", r.slice(m, a + 1), m, a], m = a;
        break;
      }
      case SHe: {
        wb.lastIndex = m + 1, wb.test(r), wb.lastIndex === 0 ? a = r.length - 1 : a = wb.lastIndex - 2, p = ["at-word", r.slice(m, a + 1), m, a], m = a;
        break;
      }
      case vb: {
        for (a = m, l = !0; r.charCodeAt(a + 1) === vb; )
          a += 1, l = !l;
        if (o = r.charCodeAt(a + 1), l && o !== WD && o !== Dg && o !== bb && o !== xb && o !== Cb && o !== yb && (a += 1, jD.test(r.charAt(a)))) {
          for (; jD.test(r.charAt(a + 1)); )
            a += 1;
          r.charCodeAt(a + 1) === Dg && (a += 1);
        }
        p = ["word", r.slice(m, a + 1), m, a], m = a;
        break;
      }
      default: {
        o === WD && r.charCodeAt(m + 1) === wHe ? (a = r.indexOf("*/", m + 2) + 1, a === 0 && (i || P ? a = r.length : S("comment")), p = ["comment", r.slice(m, a + 1), m, a], m = a) : (Eb.lastIndex = m + 1, Eb.test(r), Eb.lastIndex === 0 ? a = r.length - 1 : a = Eb.lastIndex - 2, p = ["word", r.slice(m, a + 1), m, a], b.push(p), m = a);
        break;
      }
    }
    return m++, p;
  }
  function _(A) {
    y.push(A);
  }
  return {
    back: _,
    endOfFile: E,
    nextToken: I,
    position: w
  };
};
let NZ = tf, jx = class extends NZ {
  constructor(e) {
    super(e), this.type = "atrule";
  }
  append(...e) {
    return this.proxyOf.nodes || (this.nodes = []), super.append(...e);
  }
  prepend(...e) {
    return this.proxyOf.nodes || (this.nodes = []), super.prepend(...e);
  }
};
var aT = jx;
jx.default = jx;
NZ.registerAtRule(jx);
let kZ = tf, RZ, $Z, ap = class extends kZ {
  constructor(e) {
    super(e), this.type = "root", this.nodes || (this.nodes = []);
  }
  normalize(e, n, r) {
    let i = super.normalize(e);
    if (n) {
      if (r === "prepend")
        this.nodes.length > 1 ? n.raws.before = this.nodes[1].raws.before : delete n.raws.before;
      else if (this.first !== n)
        for (let o of i)
          o.raws.before = n.raws.before;
    }
    return i;
  }
  removeChild(e, n) {
    let r = this.index(e);
    return !n && r === 0 && this.nodes.length > 1 && (this.nodes[1].raws.before = this.nodes[r].raws.before), super.removeChild(e);
  }
  toResult(e = {}) {
    return new RZ(new $Z(), this, e).stringify();
  }
};
ap.registerLazyResult = (t) => {
  RZ = t;
};
ap.registerProcessor = (t) => {
  $Z = t;
};
var av = ap;
ap.default = ap;
kZ.registerRoot(ap);
let nm = {
  comma(t) {
    return nm.split(t, [","], !0);
  },
  space(t) {
    let e = [" ", `
`, "	"];
    return nm.split(t, e);
  },
  split(t, e, n) {
    let r = [], i = "", o = !1, a = 0, s = !1, u = "", l = !1;
    for (let c of t)
      l ? l = !1 : c === "\\" ? l = !0 : s ? c === u && (s = !1) : c === '"' || c === "'" ? (s = !0, u = c) : c === "(" ? a += 1 : c === ")" ? a > 0 && (a -= 1) : a === 0 && e.includes(c) && (o = !0), o ? (i !== "" && r.push(i.trim()), i = "", o = !1) : i += c;
    return (n || i !== "") && r.push(i.trim()), r;
  }
};
var DZ = nm;
nm.default = nm;
let MZ = tf, AHe = DZ, zx = class extends MZ {
  constructor(e) {
    super(e), this.type = "rule", this.nodes || (this.nodes = []);
  }
  get selectors() {
    return AHe.comma(this.selector);
  }
  set selectors(e) {
    let n = this.selector ? this.selector.match(/,\s*/) : null, r = n ? n[0] : "," + this.raw("between", "beforeOpen");
    this.selector = e.join(r);
  }
};
var sT = zx;
zx.default = zx;
MZ.registerRule(zx);
let THe = iw, OHe = _He, PHe = aw, NHe = aT, kHe = av, zD = sT;
const GD = {
  empty: !0,
  space: !0
};
function RHe(t) {
  for (let e = t.length - 1; e >= 0; e--) {
    let n = t[e], r = n[3] || n[2];
    if (r)
      return r;
  }
}
let $He = class {
  constructor(e) {
    this.input = e, this.root = new kHe(), this.current = this.root, this.spaces = "", this.semicolon = !1, this.customProperty = !1, this.createTokenizer(), this.root.source = { input: e, start: { column: 1, line: 1, offset: 0 } };
  }
  atrule(e) {
    let n = new NHe();
    n.name = e[1].slice(1), n.name === "" && this.unnamedAtrule(n, e), this.init(n, e[2]);
    let r, i, o, a = !1, s = !1, u = [], l = [];
    for (; !this.tokenizer.endOfFile(); ) {
      if (e = this.tokenizer.nextToken(), r = e[0], r === "(" || r === "[" ? l.push(r === "(" ? ")" : "]") : r === "{" && l.length > 0 ? l.push("}") : r === l[l.length - 1] && l.pop(), l.length === 0)
        if (r === ";") {
          n.source.end = this.getPosition(e[2]), n.source.end.offset++, this.semicolon = !0;
          break;
        } else if (r === "{") {
          s = !0;
          break;
        } else if (r === "}") {
          if (u.length > 0) {
            for (o = u.length - 1, i = u[o]; i && i[0] === "space"; )
              i = u[--o];
            i && (n.source.end = this.getPosition(i[3] || i[2]), n.source.end.offset++);
          }
          this.end(e);
          break;
        } else
          u.push(e);
      else
        u.push(e);
      if (this.tokenizer.endOfFile()) {
        a = !0;
        break;
      }
    }
    n.raws.between = this.spacesAndCommentsFromEnd(u), u.length ? (n.raws.afterName = this.spacesAndCommentsFromStart(u), this.raw(n, "params", u), a && (e = u[u.length - 1], n.source.end = this.getPosition(e[3] || e[2]), n.source.end.offset++, this.spaces = n.raws.between, n.raws.between = "")) : (n.raws.afterName = "", n.params = ""), s && (n.nodes = [], this.current = n);
  }
  checkMissedSemicolon(e) {
    let n = this.colon(e);
    if (n === !1)
      return;
    let r = 0, i;
    for (let o = n - 1; o >= 0 && (i = e[o], !(i[0] !== "space" && (r += 1, r === 2))); o--)
      ;
    throw this.input.error(
      "Missed semicolon",
      i[0] === "word" ? i[3] + 1 : i[2]
    );
  }
  colon(e) {
    let n = 0, r, i, o;
    for (let [a, s] of e.entries()) {
      if (r = s, i = r[0], i === "(" && (n += 1), i === ")" && (n -= 1), n === 0 && i === ":")
        if (!o)
          this.doubleColon(r);
        else {
          if (o[0] === "word" && o[1] === "progid")
            continue;
          return a;
        }
      o = r;
    }
    return !1;
  }
  comment(e) {
    let n = new PHe();
    this.init(n, e[2]), n.source.end = this.getPosition(e[3] || e[2]), n.source.end.offset++;
    let r = e[1].slice(2, -2);
    if (/^\s*$/.test(r))
      n.text = "", n.raws.left = r, n.raws.right = "";
    else {
      let i = r.match(/^(\s*)([^]*\S)(\s*)$/);
      n.text = i[2], n.raws.left = i[1], n.raws.right = i[3];
    }
  }
  createTokenizer() {
    this.tokenizer = OHe(this.input);
  }
  decl(e, n) {
    let r = new THe();
    this.init(r, e[0][2]);
    let i = e[e.length - 1];
    for (i[0] === ";" && (this.semicolon = !0, e.pop()), r.source.end = this.getPosition(
      i[3] || i[2] || RHe(e)
    ), r.source.end.offset++; e[0][0] !== "word"; )
      e.length === 1 && this.unknownWord(e), r.raws.before += e.shift()[1];
    for (r.source.start = this.getPosition(e[0][2]), r.prop = ""; e.length; ) {
      let l = e[0][0];
      if (l === ":" || l === "space" || l === "comment")
        break;
      r.prop += e.shift()[1];
    }
    r.raws.between = "";
    let o;
    for (; e.length; )
      if (o = e.shift(), o[0] === ":") {
        r.raws.between += o[1];
        break;
      } else
        o[0] === "word" && /\w/.test(o[1]) && this.unknownWord([o]), r.raws.between += o[1];
    (r.prop[0] === "_" || r.prop[0] === "*") && (r.raws.before += r.prop[0], r.prop = r.prop.slice(1));
    let a = [], s;
    for (; e.length && (s = e[0][0], !(s !== "space" && s !== "comment")); )
      a.push(e.shift());
    this.precheckMissedSemicolon(e);
    for (let l = e.length - 1; l >= 0; l--) {
      if (o = e[l], o[1].toLowerCase() === "!important") {
        r.important = !0;
        let c = this.stringFrom(e, l);
        c = this.spacesFromEnd(e) + c, c !== " !important" && (r.raws.important = c);
        break;
      } else if (o[1].toLowerCase() === "important") {
        let c = e.slice(0), d = "";
        for (let f = l; f > 0; f--) {
          let h = c[f][0];
          if (d.trim().indexOf("!") === 0 && h !== "space")
            break;
          d = c.pop()[1] + d;
        }
        d.trim().indexOf("!") === 0 && (r.important = !0, r.raws.important = d, e = c);
      }
      if (o[0] !== "space" && o[0] !== "comment")
        break;
    }
    e.some((l) => l[0] !== "space" && l[0] !== "comment") && (r.raws.between += a.map((l) => l[1]).join(""), a = []), this.raw(r, "value", a.concat(e), n), r.value.includes(":") && !n && this.checkMissedSemicolon(e);
  }
  doubleColon(e) {
    throw this.input.error(
      "Double colon",
      { offset: e[2] },
      { offset: e[2] + e[1].length }
    );
  }
  emptyRule(e) {
    let n = new zD();
    this.init(n, e[2]), n.selector = "", n.raws.between = "", this.current = n;
  }
  end(e) {
    this.current.nodes && this.current.nodes.length && (this.current.raws.semicolon = this.semicolon), this.semicolon = !1, this.current.raws.after = (this.current.raws.after || "") + this.spaces, this.spaces = "", this.current.parent ? (this.current.source.end = this.getPosition(e[2]), this.current.source.end.offset++, this.current = this.current.parent) : this.unexpectedClose(e);
  }
  endFile() {
    this.current.parent && this.unclosedBlock(), this.current.nodes && this.current.nodes.length && (this.current.raws.semicolon = this.semicolon), this.current.raws.after = (this.current.raws.after || "") + this.spaces, this.root.source.end = this.getPosition(this.tokenizer.position());
  }
  freeSemicolon(e) {
    if (this.spaces += e[1], this.current.nodes) {
      let n = this.current.nodes[this.current.nodes.length - 1];
      n && n.type === "rule" && !n.raws.ownSemicolon && (n.raws.ownSemicolon = this.spaces, this.spaces = "");
    }
  }
  // Helpers
  getPosition(e) {
    let n = this.input.fromOffset(e);
    return {
      column: n.col,
      line: n.line,
      offset: e
    };
  }
  init(e, n) {
    this.current.push(e), e.source = {
      input: this.input,
      start: this.getPosition(n)
    }, e.raws.before = this.spaces, this.spaces = "", e.type !== "comment" && (this.semicolon = !1);
  }
  other(e) {
    let n = !1, r = null, i = !1, o = null, a = [], s = e[1].startsWith("--"), u = [], l = e;
    for (; l; ) {
      if (r = l[0], u.push(l), r === "(" || r === "[")
        o || (o = l), a.push(r === "(" ? ")" : "]");
      else if (s && i && r === "{")
        o || (o = l), a.push("}");
      else if (a.length === 0)
        if (r === ";")
          if (i) {
            this.decl(u, s);
            return;
          } else
            break;
        else if (r === "{") {
          this.rule(u);
          return;
        } else if (r === "}") {
          this.tokenizer.back(u.pop()), n = !0;
          break;
        } else
          r === ":" && (i = !0);
      else
        r === a[a.length - 1] && (a.pop(), a.length === 0 && (o = null));
      l = this.tokenizer.nextToken();
    }
    if (this.tokenizer.endOfFile() && (n = !0), a.length > 0 && this.unclosedBracket(o), n && i) {
      if (!s)
        for (; u.length && (l = u[u.length - 1][0], !(l !== "space" && l !== "comment")); )
          this.tokenizer.back(u.pop());
      this.decl(u, s);
    } else
      this.unknownWord(u);
  }
  parse() {
    let e;
    for (; !this.tokenizer.endOfFile(); )
      switch (e = this.tokenizer.nextToken(), e[0]) {
        case "space":
          this.spaces += e[1];
          break;
        case ";":
          this.freeSemicolon(e);
          break;
        case "}":
          this.end(e);
          break;
        case "comment":
          this.comment(e);
          break;
        case "at-word":
          this.atrule(e);
          break;
        case "{":
          this.emptyRule(e);
          break;
        default:
          this.other(e);
          break;
      }
    this.endFile();
  }
  precheckMissedSemicolon() {
  }
  raw(e, n, r, i) {
    let o, a, s = r.length, u = "", l = !0, c, d;
    for (let f = 0; f < s; f += 1)
      o = r[f], a = o[0], a === "space" && f === s - 1 && !i ? l = !1 : a === "comment" ? (d = r[f - 1] ? r[f - 1][0] : "empty", c = r[f + 1] ? r[f + 1][0] : "empty", !GD[d] && !GD[c] ? u.slice(-1) === "," ? l = !1 : u += o[1] : l = !1) : u += o[1];
    if (!l) {
      let f = r.reduce((h, p) => h + p[1], "");
      e.raws[n] = { raw: f, value: u };
    }
    e[n] = u;
  }
  rule(e) {
    e.pop();
    let n = new zD();
    this.init(n, e[0][2]), n.raws.between = this.spacesAndCommentsFromEnd(e), this.raw(n, "selector", e), this.current = n;
  }
  spacesAndCommentsFromEnd(e) {
    let n, r = "";
    for (; e.length && (n = e[e.length - 1][0], !(n !== "space" && n !== "comment")); )
      r = e.pop()[1] + r;
    return r;
  }
  // Errors
  spacesAndCommentsFromStart(e) {
    let n, r = "";
    for (; e.length && (n = e[0][0], !(n !== "space" && n !== "comment")); )
      r += e.shift()[1];
    return r;
  }
  spacesFromEnd(e) {
    let n, r = "";
    for (; e.length && (n = e[e.length - 1][0], n === "space"); )
      r = e.pop()[1] + r;
    return r;
  }
  stringFrom(e, n) {
    let r = "";
    for (let i = n; i < e.length; i++)
      r += e[i][1];
    return e.splice(n, e.length - n), r;
  }
  unclosedBlock() {
    let e = this.current.source.start;
    throw this.input.error("Unclosed block", e.line, e.column);
  }
  unclosedBracket(e) {
    throw this.input.error(
      "Unclosed bracket",
      { offset: e[2] },
      { offset: e[2] + 1 }
    );
  }
  unexpectedClose(e) {
    throw this.input.error(
      "Unexpected }",
      { offset: e[2] },
      { offset: e[2] + 1 }
    );
  }
  unknownWord(e) {
    throw this.input.error(
      "Unknown word",
      { offset: e[0][2] },
      { offset: e[0][2] + e[0][1].length }
    );
  }
  unnamedAtrule(e, n) {
    throw this.input.error(
      "At-rule without name",
      { offset: n[2] },
      { offset: n[2] + n[1].length }
    );
  }
};
var DHe = $He;
let MHe = tf, FHe = DHe, LHe = ow;
function Gx(t, e) {
  let n = new LHe(t, e), r = new FHe(n);
  try {
    r.parse();
  } catch (i) {
    throw process.env.NODE_ENV !== "production" && i.name === "CssSyntaxError" && e && e.from && (/\.scss$/i.test(e.from) ? i.message += `
You tried to parse SCSS with the standard CSS parser; try again with the postcss-scss parser` : /\.sass/i.test(e.from) ? i.message += `
You tried to parse Sass with the standard CSS parser; try again with the postcss-sass parser` : /\.less$/i.test(e.from) && (i.message += `
You tried to parse Less with the standard CSS parser; try again with the postcss-less parser`)), i;
  }
  return r.root;
}
var uT = Gx;
Gx.default = Gx;
MHe.registerParse(Gx);
let { isClean: Xs, my: VHe } = ov, BHe = vZ, HHe = nw, WHe = tf, jHe = iT, zHe = OZ, UD = oT, GHe = uT, UHe = av;
const XHe = {
  atrule: "AtRule",
  comment: "Comment",
  decl: "Declaration",
  document: "Document",
  root: "Root",
  rule: "Rule"
}, YHe = {
  AtRule: !0,
  AtRuleExit: !0,
  Comment: !0,
  CommentExit: !0,
  Declaration: !0,
  DeclarationExit: !0,
  Document: !0,
  DocumentExit: !0,
  Once: !0,
  OnceExit: !0,
  postcssPlugin: !0,
  prepare: !0,
  Root: !0,
  RootExit: !0,
  Rule: !0,
  RuleExit: !0
}, ZHe = {
  Once: !0,
  postcssPlugin: !0,
  prepare: !0
}, sp = 0;
function Mg(t) {
  return typeof t == "object" && typeof t.then == "function";
}
function FZ(t) {
  let e = !1, n = XHe[t.type];
  return t.type === "decl" ? e = t.prop.toLowerCase() : t.type === "atrule" && (e = t.name.toLowerCase()), e && t.append ? [
    n,
    n + "-" + e,
    sp,
    n + "Exit",
    n + "Exit-" + e
  ] : e ? [n, n + "-" + e, n + "Exit", n + "Exit-" + e] : t.append ? [n, sp, n + "Exit"] : [n, n + "Exit"];
}
function XD(t) {
  let e;
  return t.type === "document" ? e = ["Document", sp, "DocumentExit"] : t.type === "root" ? e = ["Root", sp, "RootExit"] : e = FZ(t), {
    eventIndex: 0,
    events: e,
    iterator: 0,
    node: t,
    visitorIndex: 0,
    visitors: []
  };
}
function G_(t) {
  return t[Xs] = !1, t.nodes && t.nodes.forEach((e) => G_(e)), t;
}
let U_ = {}, up = class LZ {
  constructor(e, n, r) {
    this.stringified = !1, this.processed = !1;
    let i;
    if (typeof n == "object" && n !== null && (n.type === "root" || n.type === "document"))
      i = G_(n);
    else if (n instanceof LZ || n instanceof UD)
      i = G_(n.root), n.map && (typeof r.map > "u" && (r.map = {}), r.map.inline || (r.map.inline = !1), r.map.prev = n.map);
    else {
      let o = GHe;
      r.syntax && (o = r.syntax.parse), r.parser && (o = r.parser), o.parse && (o = o.parse);
      try {
        i = o(n, r);
      } catch (a) {
        this.processed = !0, this.error = a;
      }
      i && !i[VHe] && WHe.rebuild(i);
    }
    this.result = new UD(e, i, r), this.helpers = { ...U_, postcss: U_, result: this.result }, this.plugins = this.processor.plugins.map((o) => typeof o == "object" && o.prepare ? { ...o, ...o.prepare(this.result) } : o);
  }
  async() {
    return this.error ? Promise.reject(this.error) : this.processed ? Promise.resolve(this.result) : (this.processing || (this.processing = this.runAsync()), this.processing);
  }
  catch(e) {
    return this.async().catch(e);
  }
  finally(e) {
    return this.async().then(e, e);
  }
  getAsyncError() {
    throw new Error("Use process(css).then(cb) to work with async plugins");
  }
  handleError(e, n) {
    let r = this.result.lastPlugin;
    try {
      if (n && n.addToError(e), this.error = e, e.name === "CssSyntaxError" && !e.plugin)
        e.plugin = r.postcssPlugin, e.setMessage();
      else if (r.postcssVersion && process.env.NODE_ENV !== "production") {
        let i = r.postcssPlugin, o = r.postcssVersion, a = this.result.processor.version, s = o.split("."), u = a.split(".");
        (s[0] !== u[0] || parseInt(s[1]) > parseInt(u[1])) && console.error(
          "Unknown error from PostCSS plugin. Your current PostCSS version is " + a + ", but " + i + " uses " + o + ". Perhaps this is the source of the error below."
        );
      }
    } catch (i) {
      console && console.error && console.error(i);
    }
    return e;
  }
  prepareVisitors() {
    this.listeners = {};
    let e = (n, r, i) => {
      this.listeners[r] || (this.listeners[r] = []), this.listeners[r].push([n, i]);
    };
    for (let n of this.plugins)
      if (typeof n == "object")
        for (let r in n) {
          if (!YHe[r] && /^[A-Z]/.test(r))
            throw new Error(
              `Unknown event ${r} in ${n.postcssPlugin}. Try to update PostCSS (${this.processor.version} now).`
            );
          if (!ZHe[r])
            if (typeof n[r] == "object")
              for (let i in n[r])
                i === "*" ? e(n, r, n[r][i]) : e(
                  n,
                  r + "-" + i.toLowerCase(),
                  n[r][i]
                );
            else
              typeof n[r] == "function" && e(n, r, n[r]);
        }
    this.hasListener = Object.keys(this.listeners).length > 0;
  }
  async runAsync() {
    this.plugin = 0;
    for (let e = 0; e < this.plugins.length; e++) {
      let n = this.plugins[e], r = this.runOnRoot(n);
      if (Mg(r))
        try {
          await r;
        } catch (i) {
          throw this.handleError(i);
        }
    }
    if (this.prepareVisitors(), this.hasListener) {
      let e = this.result.root;
      for (; !e[Xs]; ) {
        e[Xs] = !0;
        let n = [XD(e)];
        for (; n.length > 0; ) {
          let r = this.visitTick(n);
          if (Mg(r))
            try {
              await r;
            } catch (i) {
              let o = n[n.length - 1].node;
              throw this.handleError(i, o);
            }
        }
      }
      if (this.listeners.OnceExit)
        for (let [n, r] of this.listeners.OnceExit) {
          this.result.lastPlugin = n;
          try {
            if (e.type === "document") {
              let i = e.nodes.map(
                (o) => r(o, this.helpers)
              );
              await Promise.all(i);
            } else
              await r(e, this.helpers);
          } catch (i) {
            throw this.handleError(i);
          }
        }
    }
    return this.processed = !0, this.stringify();
  }
  runOnRoot(e) {
    this.result.lastPlugin = e;
    try {
      if (typeof e == "object" && e.Once) {
        if (this.result.root.type === "document") {
          let n = this.result.root.nodes.map(
            (r) => e.Once(r, this.helpers)
          );
          return Mg(n[0]) ? Promise.all(n) : n;
        }
        return e.Once(this.result.root, this.helpers);
      } else if (typeof e == "function")
        return e(this.result.root, this.result);
    } catch (n) {
      throw this.handleError(n);
    }
  }
  stringify() {
    if (this.error)
      throw this.error;
    if (this.stringified)
      return this.result;
    this.stringified = !0, this.sync();
    let e = this.result.opts, n = HHe;
    e.syntax && (n = e.syntax.stringify), e.stringifier && (n = e.stringifier), n.stringify && (n = n.stringify);
    let i = new BHe(n, this.result.root, this.result.opts).generate();
    return this.result.css = i[0], this.result.map = i[1], this.result;
  }
  sync() {
    if (this.error)
      throw this.error;
    if (this.processed)
      return this.result;
    if (this.processed = !0, this.processing)
      throw this.getAsyncError();
    for (let e of this.plugins) {
      let n = this.runOnRoot(e);
      if (Mg(n))
        throw this.getAsyncError();
    }
    if (this.prepareVisitors(), this.hasListener) {
      let e = this.result.root;
      for (; !e[Xs]; )
        e[Xs] = !0, this.walkSync(e);
      if (this.listeners.OnceExit)
        if (e.type === "document")
          for (let n of e.nodes)
            this.visitSync(this.listeners.OnceExit, n);
        else
          this.visitSync(this.listeners.OnceExit, e);
    }
    return this.result;
  }
  then(e, n) {
    return process.env.NODE_ENV !== "production" && ("from" in this.opts || zHe(
      "Without `from` option PostCSS could generate wrong source map and will not find Browserslist config. Set it to CSS file path or to `undefined` to prevent this warning."
    )), this.async().then(e, n);
  }
  toString() {
    return this.css;
  }
  visitSync(e, n) {
    for (let [r, i] of e) {
      this.result.lastPlugin = r;
      let o;
      try {
        o = i(n, this.helpers);
      } catch (a) {
        throw this.handleError(a, n.proxyOf);
      }
      if (n.type !== "root" && n.type !== "document" && !n.parent)
        return !0;
      if (Mg(o))
        throw this.getAsyncError();
    }
  }
  visitTick(e) {
    let n = e[e.length - 1], { node: r, visitors: i } = n;
    if (r.type !== "root" && r.type !== "document" && !r.parent) {
      e.pop();
      return;
    }
    if (i.length > 0 && n.visitorIndex < i.length) {
      let [a, s] = i[n.visitorIndex];
      n.visitorIndex += 1, n.visitorIndex === i.length && (n.visitors = [], n.visitorIndex = 0), this.result.lastPlugin = a;
      try {
        return s(r.toProxy(), this.helpers);
      } catch (u) {
        throw this.handleError(u, r);
      }
    }
    if (n.iterator !== 0) {
      let a = n.iterator, s;
      for (; s = r.nodes[r.indexes[a]]; )
        if (r.indexes[a] += 1, !s[Xs]) {
          s[Xs] = !0, e.push(XD(s));
          return;
        }
      n.iterator = 0, delete r.indexes[a];
    }
    let o = n.events;
    for (; n.eventIndex < o.length; ) {
      let a = o[n.eventIndex];
      if (n.eventIndex += 1, a === sp) {
        r.nodes && r.nodes.length && (r[Xs] = !0, n.iterator = r.getIterator());
        return;
      } else if (this.listeners[a]) {
        n.visitors = this.listeners[a];
        return;
      }
    }
    e.pop();
  }
  walkSync(e) {
    e[Xs] = !0;
    let n = FZ(e);
    for (let r of n)
      if (r === sp)
        e.nodes && e.each((i) => {
          i[Xs] || this.walkSync(i);
        });
      else {
        let i = this.listeners[r];
        if (i && this.visitSync(i, e.toProxy()))
          return;
      }
  }
  warnings() {
    return this.sync().warnings();
  }
  get content() {
    return this.stringify().content;
  }
  get css() {
    return this.stringify().css;
  }
  get map() {
    return this.stringify().map;
  }
  get messages() {
    return this.sync().messages;
  }
  get opts() {
    return this.result.opts;
  }
  get processor() {
    return this.result.processor;
  }
  get root() {
    return this.sync().root;
  }
  get [Symbol.toStringTag]() {
    return "LazyResult";
  }
};
up.registerPostcss = (t) => {
  U_ = t;
};
var VZ = up;
up.default = up;
UHe.registerLazyResult(up);
jHe.registerLazyResult(up);
let JHe = vZ, KHe = nw, qHe = OZ, QHe = uT;
const eWe = oT;
let X_ = class {
  constructor(e, n, r) {
    n = n.toString(), this.stringified = !1, this._processor = e, this._css = n, this._opts = r, this._map = void 0;
    let i, o = KHe;
    this.result = new eWe(this._processor, i, this._opts), this.result.css = n;
    let a = this;
    Object.defineProperty(this.result, "root", {
      get() {
        return a.root;
      }
    });
    let s = new JHe(o, i, this._opts, n);
    if (s.isMap()) {
      let [u, l] = s.generate();
      u && (this.result.css = u), l && (this.result.map = l);
    }
  }
  async() {
    return this.error ? Promise.reject(this.error) : Promise.resolve(this.result);
  }
  catch(e) {
    return this.async().catch(e);
  }
  finally(e) {
    return this.async().then(e, e);
  }
  sync() {
    if (this.error)
      throw this.error;
    return this.result;
  }
  then(e, n) {
    return process.env.NODE_ENV !== "production" && ("from" in this._opts || qHe(
      "Without `from` option PostCSS could generate wrong source map and will not find Browserslist config. Set it to CSS file path or to `undefined` to prevent this warning."
    )), this.async().then(e, n);
  }
  toString() {
    return this._css;
  }
  warnings() {
    return [];
  }
  get content() {
    return this.result.css;
  }
  get css() {
    return this.result.css;
  }
  get map() {
    return this.result.map;
  }
  get messages() {
    return [];
  }
  get opts() {
    return this.result.opts;
  }
  get processor() {
    return this.result.processor;
  }
  get root() {
    if (this._root)
      return this._root;
    let e, n = QHe;
    try {
      e = n(this._css, this._opts);
    } catch (r) {
      this.error = r;
    }
    if (this.error)
      throw this.error;
    return this._root = e, e;
  }
  get [Symbol.toStringTag]() {
    return "NoWorkResult";
  }
};
var tWe = X_;
X_.default = X_;
let nWe = tWe, rWe = VZ, iWe = iT, oWe = av, rm = class {
  constructor(e = []) {
    this.version = "8.4.32", this.plugins = this.normalize(e);
  }
  normalize(e) {
    let n = [];
    for (let r of e)
      if (r.postcss === !0 ? r = r() : r.postcss && (r = r.postcss), typeof r == "object" && Array.isArray(r.plugins))
        n = n.concat(r.plugins);
      else if (typeof r == "object" && r.postcssPlugin)
        n.push(r);
      else if (typeof r == "function")
        n.push(r);
      else if (typeof r == "object" && (r.parse || r.stringify)) {
        if (process.env.NODE_ENV !== "production")
          throw new Error(
            "PostCSS syntaxes cannot be used as plugins. Instead, please use one of the syntax/parser/stringifier options as outlined in your PostCSS runner documentation."
          );
      } else
        throw new Error(r + " is not a PostCSS plugin");
    return n;
  }
  process(e, n = {}) {
    return this.plugins.length === 0 && typeof n.parser > "u" && typeof n.stringifier > "u" && typeof n.syntax > "u" ? new nWe(this, e, n) : new rWe(this, e, n);
  }
  use(e) {
    return this.plugins = this.plugins.concat(this.normalize([e])), this;
  }
};
var aWe = rm;
rm.default = rm;
oWe.registerProcessor(rm);
iWe.registerProcessor(rm);
let sWe = iw, uWe = fZ, lWe = aw, cWe = aT, dWe = ow, fWe = av, hWe = sT;
function im(t, e) {
  if (Array.isArray(t))
    return t.map((i) => im(i));
  let { inputs: n, ...r } = t;
  if (n) {
    e = [];
    for (let i of n) {
      let o = { ...i, __proto__: dWe.prototype };
      o.map && (o.map = {
        ...o.map,
        __proto__: uWe.prototype
      }), e.push(o);
    }
  }
  if (r.nodes && (r.nodes = t.nodes.map((i) => im(i, e))), r.source) {
    let { inputId: i, ...o } = r.source;
    r.source = o, i != null && (r.source.input = e[i]);
  }
  if (r.type === "root")
    return new fWe(r);
  if (r.type === "decl")
    return new sWe(r);
  if (r.type === "rule")
    return new hWe(r);
  if (r.type === "comment")
    return new lWe(r);
  if (r.type === "atrule")
    return new cWe(r);
  throw new Error("Unknown node type: " + t.type);
}
var pWe = im;
im.default = im;
let gWe = tT, BZ = iw, mWe = VZ, vWe = tf, lT = aWe, bWe = nw, yWe = pWe, HZ = iT, xWe = PZ, WZ = aw, jZ = aT, CWe = oT, wWe = ow, EWe = uT, SWe = DZ, zZ = sT, GZ = av, IWe = rw;
function pr(...t) {
  return t.length === 1 && Array.isArray(t[0]) && (t = t[0]), new lT(t);
}
pr.plugin = function(e, n) {
  let r = !1;
  function i(...a) {
    console && console.warn && !r && (r = !0, console.warn(
      e + `: postcss.plugin was deprecated. Migration guide:
https://evilmartians.com/chronicles/postcss-8-plugin-migration`
    ), process.env.LANG && process.env.LANG.startsWith("cn") && console.warn(
      e + `: 里面 postcss.plugin 被弃用. 迁移指南:
https://www.w3ctech.com/topic/2226`
    ));
    let s = n(...a);
    return s.postcssPlugin = e, s.postcssVersion = new lT().version, s;
  }
  let o;
  return Object.defineProperty(i, "postcss", {
    get() {
      return o || (o = i()), o;
    }
  }), i.process = function(a, s, u) {
    return pr([i(u)]).process(a, s);
  }, i;
};
pr.stringify = bWe;
pr.parse = EWe;
pr.fromJSON = yWe;
pr.list = SWe;
pr.comment = (t) => new WZ(t);
pr.atRule = (t) => new jZ(t);
pr.decl = (t) => new BZ(t);
pr.rule = (t) => new zZ(t);
pr.root = (t) => new GZ(t);
pr.document = (t) => new HZ(t);
pr.CssSyntaxError = gWe;
pr.Declaration = BZ;
pr.Container = vWe;
pr.Processor = lT;
pr.Document = HZ;
pr.Comment = WZ;
pr.Warning = xWe;
pr.AtRule = jZ;
pr.Result = CWe;
pr.Input = wWe;
pr.Rule = zZ;
pr.Root = GZ;
pr.Node = IWe;
mWe.registerPostcss(pr);
var _We = pr;
pr.default = pr;
const AWe = $Y, YD = CBe, { isPlainObject: TWe } = Q9, ZD = MBe, OWe = FBe, { parse: PWe } = _We, NWe = [
  "img",
  "audio",
  "video",
  "picture",
  "svg",
  "object",
  "map",
  "iframe",
  "embed"
], kWe = ["script", "style"];
function r0(t, e) {
  t && Object.keys(t).forEach(function(n) {
    e(t[n], n);
  });
}
function Hu(t, e) {
  return {}.hasOwnProperty.call(t, e);
}
function JD(t, e) {
  const n = [];
  return r0(t, function(r) {
    e(r) && n.push(r);
  }), n;
}
function RWe(t) {
  for (const e in t)
    if (Hu(t, e))
      return !1;
  return !0;
}
function $We(t) {
  return t.map(function(e) {
    if (!e.url)
      throw new Error("URL missing");
    return e.url + (e.w ? ` ${e.w}w` : "") + (e.h ? ` ${e.h}h` : "") + (e.d ? ` ${e.d}x` : "");
  }).join(", ");
}
var DWe = om;
const MWe = /^[^\0\t\n\f\r /<=>]+$/;
function om(t, e, n) {
  if (t == null)
    return "";
  typeof t == "number" && (t = t.toString());
  let r = "", i = "";
  function o($, F) {
    const M = this;
    this.tag = $, this.attribs = F || {}, this.tagPosition = r.length, this.text = "", this.mediaChildren = [], this.updateParentNodeText = function() {
      if (m.length) {
        const B = m[m.length - 1];
        B.text += M.text;
      }
    }, this.updateParentNodeMediaChildren = function() {
      m.length && NWe.includes(this.tag) && m[m.length - 1].mediaChildren.push(this.tag);
    };
  }
  e = Object.assign({}, om.defaults, e), e.parser = Object.assign({}, FWe, e.parser);
  const a = function($) {
    return e.allowedTags === !1 || (e.allowedTags || []).indexOf($) > -1;
  };
  kWe.forEach(function($) {
    a($) && !e.allowVulnerableTags && console.warn(`

⚠️ Your \`allowedTags\` option includes, \`${$}\`, which is inherently
vulnerable to XSS attacks. Please remove it from \`allowedTags\`.
Or, to disable this warning, add the \`allowVulnerableTags\` option
and ensure you are accounting for this risk.

`);
  });
  const s = e.nonTextTags || [
    "script",
    "style",
    "textarea",
    "option"
  ];
  let u, l;
  e.allowedAttributes && (u = {}, l = {}, r0(e.allowedAttributes, function($, F) {
    u[F] = [];
    const M = [];
    $.forEach(function(B) {
      typeof B == "string" && B.indexOf("*") >= 0 ? M.push(YD(B).replace(/\\\*/g, ".*")) : u[F].push(B);
    }), M.length && (l[F] = new RegExp("^(" + M.join("|") + ")$"));
  }));
  const c = {}, d = {}, f = {};
  r0(e.allowedClasses, function($, F) {
    if (u && (Hu(u, F) || (u[F] = []), u[F].push("class")), c[F] = $, Array.isArray($)) {
      const M = [];
      c[F] = [], f[F] = [], $.forEach(function(B) {
        typeof B == "string" && B.indexOf("*") >= 0 ? M.push(YD(B).replace(/\\\*/g, ".*")) : B instanceof RegExp ? f[F].push(B) : c[F].push(B);
      }), M.length && (d[F] = new RegExp("^(" + M.join("|") + ")$"));
    }
  });
  const h = {};
  let p;
  r0(e.transformTags, function($, F) {
    let M;
    typeof $ == "function" ? M = $ : typeof $ == "string" && (M = om.simpleTransform($)), F === "*" ? p = M : h[F] = M;
  });
  let v, m, b, y, w, S, E = !1;
  _();
  const I = new AWe.Parser({
    onopentag: function($, F) {
      if (e.enforceHtmlBoundary && $ === "html" && _(), w) {
        S++;
        return;
      }
      const M = new o($, F);
      m.push(M);
      let B = !1;
      const X = !!M.text;
      let L;
      if (Hu(h, $) && (L = h[$]($, F), M.attribs = F = L.attribs, L.text !== void 0 && (M.innerText = L.text), $ !== L.tagName && (M.name = $ = L.tagName, y[v] = L.tagName)), p && (L = p($, F), M.attribs = F = L.attribs, $ !== L.tagName && (M.name = $ = L.tagName, y[v] = L.tagName)), (!a($) || e.disallowedTagsMode === "recursiveEscape" && !RWe(b) || e.nestingLimit != null && v >= e.nestingLimit) && (B = !0, b[v] = !0, e.disallowedTagsMode === "discard" && s.indexOf($) !== -1 && (w = !0, S = 1), b[v] = !0), v++, B) {
        if (e.disallowedTagsMode === "discard")
          return;
        i = r, r = "";
      }
      r += "<" + $, $ === "script" && (e.allowedScriptHostnames || e.allowedScriptDomains) && (M.innerText = ""), (!u || Hu(u, $) || u["*"]) && r0(F, function(j, K) {
        if (!MWe.test(K)) {
          delete M.attribs[K];
          return;
        }
        if (j === "" && (e.nonBooleanAttributes.includes(K) || e.nonBooleanAttributes.includes("*"))) {
          delete M.attribs[K];
          return;
        }
        let W = !1;
        if (!u || Hu(u, $) && u[$].indexOf(K) !== -1 || u["*"] && u["*"].indexOf(K) !== -1 || Hu(l, $) && l[$].test(K) || l["*"] && l["*"].test(K))
          W = !0;
        else if (u && u[$]) {
          for (const Y of u[$])
            if (TWe(Y) && Y.name && Y.name === K) {
              W = !0;
              let U = "";
              if (Y.multiple === !0) {
                const Q = j.split(" ");
                for (const Z of Q)
                  Y.values.indexOf(Z) !== -1 && (U === "" ? U = Z : U += " " + Z);
              } else
                Y.values.indexOf(j) >= 0 && (U = j);
              j = U;
            }
        }
        if (W) {
          if (e.allowedSchemesAppliedToAttributes.indexOf(K) !== -1 && P($, j)) {
            delete M.attribs[K];
            return;
          }
          if ($ === "script" && K === "src") {
            let Y = !0;
            try {
              const U = N(j);
              if (e.allowedScriptHostnames || e.allowedScriptDomains) {
                const Q = (e.allowedScriptHostnames || []).find(function(ee) {
                  return ee === U.url.hostname;
                }), Z = (e.allowedScriptDomains || []).find(function(ee) {
                  return U.url.hostname === ee || U.url.hostname.endsWith(`.${ee}`);
                });
                Y = Q || Z;
              }
            } catch {
              Y = !1;
            }
            if (!Y) {
              delete M.attribs[K];
              return;
            }
          }
          if ($ === "iframe" && K === "src") {
            let Y = !0;
            try {
              const U = N(j);
              if (U.isRelativeUrl)
                Y = Hu(e, "allowIframeRelativeUrls") ? e.allowIframeRelativeUrls : !e.allowedIframeHostnames && !e.allowedIframeDomains;
              else if (e.allowedIframeHostnames || e.allowedIframeDomains) {
                const Q = (e.allowedIframeHostnames || []).find(function(ee) {
                  return ee === U.url.hostname;
                }), Z = (e.allowedIframeDomains || []).find(function(ee) {
                  return U.url.hostname === ee || U.url.hostname.endsWith(`.${ee}`);
                });
                Y = Q || Z;
              }
            } catch {
              Y = !1;
            }
            if (!Y) {
              delete M.attribs[K];
              return;
            }
          }
          if (K === "srcset")
            try {
              let Y = OWe(j);
              if (Y.forEach(function(U) {
                P("srcset", U.url) && (U.evil = !0);
              }), Y = JD(Y, function(U) {
                return !U.evil;
              }), Y.length)
                j = $We(JD(Y, function(U) {
                  return !U.evil;
                })), M.attribs[K] = j;
              else {
                delete M.attribs[K];
                return;
              }
            } catch {
              delete M.attribs[K];
              return;
            }
          if (K === "class") {
            const Y = c[$], U = c["*"], Q = d[$], Z = f[$], ee = d["*"], ie = [
              Q,
              ee
            ].concat(Z).filter(function(oe) {
              return oe;
            });
            if (Y && U ? j = V(j, ZD(Y, U), ie) : j = V(j, Y || U, ie), !j.length) {
              delete M.attribs[K];
              return;
            }
          }
          if (K === "style") {
            if (e.parseStyleAttributes)
              try {
                const Y = PWe($ + " {" + j + "}"), U = k(Y, e.allowedStyles);
                if (j = D(U), j.length === 0) {
                  delete M.attribs[K];
                  return;
                }
              } catch {
                typeof window < "u" && console.warn('Failed to parse "' + $ + " {" + j + `}", If you're running this in a browser, we recommend to disable style parsing: options.parseStyleAttributes: false, since this only works in a node environment due to a postcss dependency, More info: https://github.com/apostrophecms/sanitize-html/issues/547`), delete M.attribs[K];
                return;
              }
            else if (e.allowedStyles)
              throw new Error("allowedStyles option cannot be used together with parseStyleAttributes: false.");
          }
          r += " " + K, j && j.length && (r += '="' + A(j, !0) + '"');
        } else
          delete M.attribs[K];
      }), e.selfClosing.indexOf($) !== -1 ? r += " />" : (r += ">", M.innerText && !X && !e.textFilter && (r += A(M.innerText), E = !0)), B && (r = i + A(r), i = "");
    },
    ontext: function($) {
      if (w)
        return;
      const F = m[m.length - 1];
      let M;
      if (F && (M = F.tag, $ = F.innerText !== void 0 ? F.innerText : $), e.disallowedTagsMode === "discard" && (M === "script" || M === "style"))
        r += $;
      else {
        const B = A($, !1);
        e.textFilter && !E ? r += e.textFilter(B, M) : E || (r += B);
      }
      if (m.length) {
        const B = m[m.length - 1];
        B.text += $;
      }
    },
    onclosetag: function($, F) {
      if (w)
        if (S--, !S)
          w = !1;
        else
          return;
      const M = m.pop();
      if (!M)
        return;
      if (M.tag !== $) {
        m.push(M);
        return;
      }
      w = e.enforceHtmlBoundary ? $ === "html" : !1, v--;
      const B = b[v];
      if (B) {
        if (delete b[v], e.disallowedTagsMode === "discard") {
          M.updateParentNodeText();
          return;
        }
        i = r, r = "";
      }
      if (y[v] && ($ = y[v], delete y[v]), e.exclusiveFilter && e.exclusiveFilter(M)) {
        r = r.substr(0, M.tagPosition);
        return;
      }
      if (M.updateParentNodeMediaChildren(), M.updateParentNodeText(), // Already output />
      e.selfClosing.indexOf($) !== -1 || // Escaped tag, closing tag is implied
      F && !a($) && ["escape", "recursiveEscape"].indexOf(e.disallowedTagsMode) >= 0) {
        B && (r = i, i = "");
        return;
      }
      r += "</" + $ + ">", B && (r = i + A(r), i = ""), E = !1;
    }
  }, e.parser);
  return I.write(t), I.end(), r;
  function _() {
    r = "", v = 0, m = [], b = {}, y = {}, w = !1, S = 0;
  }
  function A($, F) {
    return typeof $ != "string" && ($ = $ + ""), e.parser.decodeEntities && ($ = $.replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;"), F && ($ = $.replace(/"/g, "&quot;"))), $ = $.replace(/&(?![a-zA-Z0-9#]{1,20};)/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;"), F && ($ = $.replace(/"/g, "&quot;")), $;
  }
  function P($, F) {
    for (F = F.replace(/[\x00-\x20]+/g, ""); ; ) {
      const X = F.indexOf("<!--");
      if (X === -1)
        break;
      const L = F.indexOf("-->", X + 4);
      if (L === -1)
        break;
      F = F.substring(0, X) + F.substring(L + 3);
    }
    const M = F.match(/^([a-zA-Z][a-zA-Z0-9.\-+]*):/);
    if (!M)
      return F.match(/^[/\\]{2}/) ? !e.allowProtocolRelative : !1;
    const B = M[1].toLowerCase();
    return Hu(e.allowedSchemesByTag, $) ? e.allowedSchemesByTag[$].indexOf(B) === -1 : !e.allowedSchemes || e.allowedSchemes.indexOf(B) === -1;
  }
  function N($) {
    if ($ = $.replace(/^(\w+:)?\s*[\\/]\s*[\\/]/, "$1//"), $.startsWith("relative:"))
      throw new Error("relative: exploit attempt");
    let F = "relative://relative-site";
    for (let X = 0; X < 100; X++)
      F += `/${X}`;
    const M = new URL($, F);
    return {
      isRelativeUrl: M && M.hostname === "relative-site" && M.protocol === "relative:",
      url: M
    };
  }
  function k($, F) {
    if (!F)
      return $;
    const M = $.nodes[0];
    let B;
    return F[M.selector] && F["*"] ? B = ZD(
      F[M.selector],
      F["*"]
    ) : B = F[M.selector] || F["*"], B && ($.nodes[0].nodes = M.nodes.reduce(R(B), [])), $;
  }
  function D($) {
    return $.nodes[0].nodes.reduce(function(F, M) {
      return F.push(
        `${M.prop}:${M.value}${M.important ? " !important" : ""}`
      ), F;
    }, []).join(";");
  }
  function R($) {
    return function(F, M) {
      return Hu($, M.prop) && $[M.prop].some(function(X) {
        return X.test(M.value);
      }) && F.push(M), F;
    };
  }
  function V($, F, M) {
    return F ? ($ = $.split(/\s+/), $.filter(function(B) {
      return F.indexOf(B) !== -1 || M.some(function(X) {
        return X.test(B);
      });
    }).join(" ")) : $;
  }
}
const FWe = {
  decodeEntities: !0
};
om.defaults = {
  allowedTags: [
    // Sections derived from MDN element categories and limited to the more
    // benign categories.
    // https://developer.mozilla.org/en-US/docs/Web/HTML/Element
    // Content sectioning
    "address",
    "article",
    "aside",
    "footer",
    "header",
    "h1",
    "h2",
    "h3",
    "h4",
    "h5",
    "h6",
    "hgroup",
    "main",
    "nav",
    "section",
    // Text content
    "blockquote",
    "dd",
    "div",
    "dl",
    "dt",
    "figcaption",
    "figure",
    "hr",
    "li",
    "main",
    "ol",
    "p",
    "pre",
    "ul",
    // Inline text semantics
    "a",
    "abbr",
    "b",
    "bdi",
    "bdo",
    "br",
    "cite",
    "code",
    "data",
    "dfn",
    "em",
    "i",
    "kbd",
    "mark",
    "q",
    "rb",
    "rp",
    "rt",
    "rtc",
    "ruby",
    "s",
    "samp",
    "small",
    "span",
    "strong",
    "sub",
    "sup",
    "time",
    "u",
    "var",
    "wbr",
    // Table content
    "caption",
    "col",
    "colgroup",
    "table",
    "tbody",
    "td",
    "tfoot",
    "th",
    "thead",
    "tr"
  ],
  // Tags that cannot be boolean
  nonBooleanAttributes: [
    "abbr",
    "accept",
    "accept-charset",
    "accesskey",
    "action",
    "allow",
    "alt",
    "as",
    "autocapitalize",
    "autocomplete",
    "blocking",
    "charset",
    "cite",
    "class",
    "color",
    "cols",
    "colspan",
    "content",
    "contenteditable",
    "coords",
    "crossorigin",
    "data",
    "datetime",
    "decoding",
    "dir",
    "dirname",
    "download",
    "draggable",
    "enctype",
    "enterkeyhint",
    "fetchpriority",
    "for",
    "form",
    "formaction",
    "formenctype",
    "formmethod",
    "formtarget",
    "headers",
    "height",
    "hidden",
    "high",
    "href",
    "hreflang",
    "http-equiv",
    "id",
    "imagesizes",
    "imagesrcset",
    "inputmode",
    "integrity",
    "is",
    "itemid",
    "itemprop",
    "itemref",
    "itemtype",
    "kind",
    "label",
    "lang",
    "list",
    "loading",
    "low",
    "max",
    "maxlength",
    "media",
    "method",
    "min",
    "minlength",
    "name",
    "nonce",
    "optimum",
    "pattern",
    "ping",
    "placeholder",
    "popover",
    "popovertarget",
    "popovertargetaction",
    "poster",
    "preload",
    "referrerpolicy",
    "rel",
    "rows",
    "rowspan",
    "sandbox",
    "scope",
    "shape",
    "size",
    "sizes",
    "slot",
    "span",
    "spellcheck",
    "src",
    "srcdoc",
    "srclang",
    "srcset",
    "start",
    "step",
    "style",
    "tabindex",
    "target",
    "title",
    "translate",
    "type",
    "usemap",
    "value",
    "width",
    "wrap",
    // Event handlers
    "onauxclick",
    "onafterprint",
    "onbeforematch",
    "onbeforeprint",
    "onbeforeunload",
    "onbeforetoggle",
    "onblur",
    "oncancel",
    "oncanplay",
    "oncanplaythrough",
    "onchange",
    "onclick",
    "onclose",
    "oncontextlost",
    "oncontextmenu",
    "oncontextrestored",
    "oncopy",
    "oncuechange",
    "oncut",
    "ondblclick",
    "ondrag",
    "ondragend",
    "ondragenter",
    "ondragleave",
    "ondragover",
    "ondragstart",
    "ondrop",
    "ondurationchange",
    "onemptied",
    "onended",
    "onerror",
    "onfocus",
    "onformdata",
    "onhashchange",
    "oninput",
    "oninvalid",
    "onkeydown",
    "onkeypress",
    "onkeyup",
    "onlanguagechange",
    "onload",
    "onloadeddata",
    "onloadedmetadata",
    "onloadstart",
    "onmessage",
    "onmessageerror",
    "onmousedown",
    "onmouseenter",
    "onmouseleave",
    "onmousemove",
    "onmouseout",
    "onmouseover",
    "onmouseup",
    "onoffline",
    "ononline",
    "onpagehide",
    "onpageshow",
    "onpaste",
    "onpause",
    "onplay",
    "onplaying",
    "onpopstate",
    "onprogress",
    "onratechange",
    "onreset",
    "onresize",
    "onrejectionhandled",
    "onscroll",
    "onscrollend",
    "onsecuritypolicyviolation",
    "onseeked",
    "onseeking",
    "onselect",
    "onslotchange",
    "onstalled",
    "onstorage",
    "onsubmit",
    "onsuspend",
    "ontimeupdate",
    "ontoggle",
    "onunhandledrejection",
    "onunload",
    "onvolumechange",
    "onwaiting",
    "onwheel"
  ],
  disallowedTagsMode: "discard",
  allowedAttributes: {
    a: ["href", "name", "target"],
    // We don't currently allow img itself by default, but
    // these attributes would make sense if we did.
    img: ["src", "srcset", "alt", "title", "width", "height", "loading"]
  },
  // Lots of these won't come up by default because we don't allow them
  selfClosing: ["img", "br", "hr", "area", "base", "basefont", "input", "link", "meta"],
  // URL schemes we permit
  allowedSchemes: ["http", "https", "ftp", "mailto", "tel"],
  allowedSchemesByTag: {},
  allowedSchemesAppliedToAttributes: ["href", "src", "cite"],
  allowProtocolRelative: !0,
  enforceHtmlBoundary: !1,
  parseStyleAttributes: !0
};
om.simpleTransform = function(t, e, n) {
  return n = n === void 0 ? !0 : n, e = e || {}, function(r, i) {
    let o;
    if (n)
      for (o in e)
        i[o] = e[o];
    else
      i = e;
    return {
      tagName: t,
      attribs: i
    };
  };
};
const KD = /* @__PURE__ */ qn(DWe), qD = {
  allowedTags: ["br", "div"]
}, LWe = (t) => {
  const {
    value: e,
    inputProps: n = {},
    onChange: r
  } = t, {
    tagName: i = "div",
    className: o = "",
    style: a
  } = n, [s, u] = Le(KD(e || "", qD));
  Re(() => {
    u(e || "");
  }, [e]);
  const l = (d) => {
    const f = KD(d.target.value || "", qD);
    u(f), r(f);
  }, c = t.readOnly || n.readOnly;
  return (
    // @ts-ignore
    /* @__PURE__ */ Oe.jsx(
      mVe,
      {
        disabled: c,
        style: a || {},
        html: s,
        onChange: l,
        tagName: i,
        className: `ant-form-contenteditable ${o} ${c ? "ant-form-contenteditable-disabled" : ""}`
      }
    )
  );
};
var cT = {}, UZ = { exports: {} };
(function(t) {
  function e(n) {
    return n && n.__esModule ? n : {
      default: n
    };
  }
  t.exports = e, t.exports.__esModule = !0, t.exports.default = t.exports;
})(UZ);
var Cu = UZ.exports, Ko = {}, QD;
function VWe() {
  if (QD)
    return Ko;
  QD = 1, Object.defineProperty(Ko, "__esModule", {
    value: !0
  }), Ko.call = a, Ko.default = void 0, Ko.note = i, Ko.noteOnce = u, Ko.preMessage = void 0, Ko.resetWarned = o, Ko.warning = r, Ko.warningOnce = s;
  var t = {}, e = [], n = Ko.preMessage = function(c) {
    e.push(c);
  };
  function r(l, c) {
    if (process.env.NODE_ENV !== "production" && !l && console !== void 0) {
      var d = e.reduce(function(f, h) {
        return h(f ?? "", "warning");
      }, c);
      d && console.error("Warning: ".concat(d));
    }
  }
  function i(l, c) {
    if (process.env.NODE_ENV !== "production" && !l && console !== void 0) {
      var d = e.reduce(function(f, h) {
        return h(f ?? "", "note");
      }, c);
      d && console.warn("Note: ".concat(d));
    }
  }
  function o() {
    t = {};
  }
  function a(l, c, d) {
    !c && !t[d] && (l(!1, d), t[d] = !0);
  }
  function s(l, c) {
    a(r, l, c);
  }
  function u(l, c) {
    a(i, l, c);
  }
  return s.preMessage = n, s.resetWarned = o, s.noteOnce = u, Ko.default = s, Ko;
}
var nf = Cu;
Object.defineProperty(cT, "__esModule", {
  value: !0
});
var sv = cT.default = void 0, So = nf(uc), BWe = VWe(), HWe = nf(ZH), WWe = nf(GH), jWe = nf(KH), zWe = nf(QH), GWe = nf(HH), UWe = nf(jH);
So.default.extend(UWe.default);
So.default.extend(GWe.default);
So.default.extend(HWe.default);
So.default.extend(WWe.default);
So.default.extend(jWe.default);
So.default.extend(zWe.default);
So.default.extend(function(t, e) {
  var n = e.prototype, r = n.format;
  n.format = function(o) {
    var a = (o || "").replace("Wo", "wo");
    return r.bind(this)(a);
  };
});
var XWe = {
  // ar_EG:
  // az_AZ:
  // bg_BG:
  bn_BD: "bn-bd",
  by_BY: "be",
  // ca_ES:
  // cs_CZ:
  // da_DK:
  // de_DE:
  // el_GR:
  en_GB: "en-gb",
  en_US: "en",
  // es_ES:
  // et_EE:
  // fa_IR:
  // fi_FI:
  fr_BE: "fr",
  fr_CA: "fr-ca",
  // fr_FR:
  // ga_IE:
  // gl_ES:
  // he_IL:
  // hi_IN:
  // hr_HR:
  // hu_HU:
  hy_AM: "hy-am",
  // id_ID:
  // is_IS:
  // it_IT:
  // ja_JP:
  // ka_GE:
  // kk_KZ:
  // km_KH:
  kmr_IQ: "ku",
  // kn_IN:
  // ko_KR:
  // ku_IQ: // previous ku in antd
  // lt_LT:
  // lv_LV:
  // mk_MK:
  // ml_IN:
  // mn_MN:
  // ms_MY:
  // nb_NO:
  // ne_NP:
  nl_BE: "nl-be",
  // nl_NL:
  // pl_PL:
  pt_BR: "pt-br",
  // pt_PT:
  // ro_RO:
  // ru_RU:
  // sk_SK:
  // sl_SI:
  // sr_RS:
  // sv_SE:
  // ta_IN:
  // th_TH:
  // tr_TR:
  // uk_UA:
  // ur_PK:
  // vi_VN:
  zh_CN: "zh-cn",
  zh_HK: "zh-hk",
  zh_TW: "zh-tw"
}, Zc = function(e) {
  var n = XWe[e];
  return n || e.split("_")[0];
}, eM = function() {
  (0, BWe.noteOnce)(!1, "Not match any format. Please help to fire a issue about this.");
}, YWe = {
  // get
  getNow: function() {
    return (0, So.default)();
  },
  getFixedDate: function(e) {
    return (0, So.default)(e, ["YYYY-M-DD", "YYYY-MM-DD"]);
  },
  getEndDate: function(e) {
    return e.endOf("month");
  },
  getWeekDay: function(e) {
    var n = e.locale("en");
    return n.weekday() + n.localeData().firstDayOfWeek();
  },
  getYear: function(e) {
    return e.year();
  },
  getMonth: function(e) {
    return e.month();
  },
  getDate: function(e) {
    return e.date();
  },
  getHour: function(e) {
    return e.hour();
  },
  getMinute: function(e) {
    return e.minute();
  },
  getSecond: function(e) {
    return e.second();
  },
  // set
  addYear: function(e, n) {
    return e.add(n, "year");
  },
  addMonth: function(e, n) {
    return e.add(n, "month");
  },
  addDate: function(e, n) {
    return e.add(n, "day");
  },
  setYear: function(e, n) {
    return e.year(n);
  },
  setMonth: function(e, n) {
    return e.month(n);
  },
  setDate: function(e, n) {
    return e.date(n);
  },
  setHour: function(e, n) {
    return e.hour(n);
  },
  setMinute: function(e, n) {
    return e.minute(n);
  },
  setSecond: function(e, n) {
    return e.second(n);
  },
  // Compare
  isAfter: function(e, n) {
    return e.isAfter(n);
  },
  isValidate: function(e) {
    return e.isValid();
  },
  locale: {
    getWeekFirstDay: function(e) {
      return (0, So.default)().locale(Zc(e)).localeData().firstDayOfWeek();
    },
    getWeekFirstDate: function(e, n) {
      return n.locale(Zc(e)).weekday(0);
    },
    getWeek: function(e, n) {
      return n.locale(Zc(e)).week();
    },
    getShortWeekDays: function(e) {
      return (0, So.default)().locale(Zc(e)).localeData().weekdaysMin();
    },
    getShortMonths: function(e) {
      return (0, So.default)().locale(Zc(e)).localeData().monthsShort();
    },
    format: function(e, n, r) {
      return n.locale(Zc(e)).format(r);
    },
    parse: function(e, n, r) {
      for (var i = Zc(e), o = 0; o < r.length; o += 1) {
        var a = r[o], s = n;
        if (a.includes("wo") || a.includes("Wo")) {
          for (var u = s.split("-")[0], l = s.split("-")[1], c = (0, So.default)(u, "YYYY").startOf("year").locale(i), d = 0; d <= 52; d += 1) {
            var f = c.add(d, "week");
            if (f.format("Wo") === l)
              return f;
          }
          return eM(), null;
        }
        var h = (0, So.default)(s, a).locale(i);
        if (h.isValid())
          return h;
      }
      return n && eM(), null;
    }
  }
}, ZWe = YWe;
sv = cT.default = ZWe;
const JWe = TC(sv), { RangePicker: KWe } = JWe, qWe = (t) => {
  const { value: e, onChange: n, name: r, inputProps: i = {} } = t, [o, a] = r, [s, u] = Le(e || {});
  Re(() => {
    u(e || {});
  }, [e]);
  const l = (h) => {
    const p = h ? {
      [o]: h[0],
      [a]: h[1]
    } : {};
    n(p), u(p);
  };
  let c = s[o];
  c && !Or.isDayjs(c) && (c = Or(c).startOf("day"));
  let d = s[a];
  d && !Or.isDayjs(d) && (d = Or(d).startOf("day"));
  const f = [c, d];
  return (
    // @ts-ignore
    /* @__PURE__ */ Oe.jsx(
      KWe,
      {
        ...i || {},
        className: `ant-form-daterange ${(i == null ? void 0 : i.className) || ""}`,
        value: f,
        onChange: l
      }
    )
  );
}, QWe = TC(sv), tM = (t) => t && !Or.isDayjs(t) && Or(t).isValid() ? Or(t) : (t && Or.isDayjs(t), t), eje = (t) => {
  const { readOnly: e = !1, value: n, inputProps: { format: r = "DD/MM/YYYY HH:mm:ss" } = {} } = t, [i, o] = O.useState(tM(n));
  if (Re(() => {
    o(tM(n));
  }, [n]), e) {
    let s = n;
    return s && !Or.isDayjs(s) && Or(s).isValid() && (s = Or(s)), /* @__PURE__ */ Oe.jsx(
      ma,
      {
        readOnly: !0,
        format: r,
        value: i
      }
    );
  }
  const a = va(t, ["renderLabel"]);
  return (
    // @ts-ignore
    /* @__PURE__ */ Oe.jsx(
      QWe,
      {
        style: { width: "100%" },
        ...a || {},
        format: r,
        value: i,
        showTime: !0
      }
    )
  );
}, tje = (t) => {
  const { value: e, inputProps: n = {}, onChange: r } = t, [i, o] = Le(void 0), a = (u = "") => {
    var v;
    if (!u || u && typeof (u == null ? void 0 : u.trim) == "function" && (u == null ? void 0 : u.trim()) === "") {
      o(void 0), r(void 0);
      return;
    }
    let d = ((v = u == null ? void 0 : u.toString()) == null ? void 0 : v.replace(/[^0-9,.]/g, "")).replaceAll(",", ".").split("");
    const f = [];
    let h = !1;
    for (let m = 0; m < d.length; m++)
      d[m] === "." && (h ? f.push(m) : h = !0);
    d = d.filter((m, b) => !f.includes(b));
    const p = d.join("");
    if (!isNaN(p))
      return p;
  };
  Re(() => o(a(e)), [e]);
  const s = ({ target: { value: u } }) => {
    const l = a(u);
    o(l), r(l);
  };
  return /* @__PURE__ */ Oe.jsx("div", { style: { width: n.width ? n.width : "100%" }, children: /* @__PURE__ */ Oe.jsx(ma, { onChange: s, value: i, ...n || {} }) });
}, nje = (t) => {
  var m;
  const {
    inputProps: e = {},
    value: n,
    options: r,
    onChange: i
  } = t, {
    multiple: o = !1,
    separator: a = ", ",
    placeholder: s = "-",
    className: u = ""
  } = e, [l, c] = Le(n || []);
  Re(() => c(n || []), [n]);
  const d = ({ key: b }) => {
    if (o) {
      if (l && l.indexOf(b) === -1) {
        const y = [...l];
        y.push(b), i(y), c(y);
      }
    } else
      i(b), c(b);
  }, f = ({ key: b }) => {
    if (o && Array.isArray(l)) {
      const y = l.indexOf(b), w = [...l].splice(y, 1);
      i(w), c(w);
    } else
      i(void 0), c([]);
  };
  let h = [];
  l && (h = Array.isArray(l) ? l : [l]);
  const p = /* @__PURE__ */ Oe.jsx(
    GG,
    {
      selectable: !0,
      onSelect: d,
      onDeselect: f,
      selectedKeys: h,
      items: r.map((b) => ({
        key: b.value,
        label: b.label
      }))
    }
  );
  let v;
  return n && (v = Array.isArray(l) ? r.filter((b) => l.includes(b.value)).map((b) => b.label).join(a) : (m = r.find((b) => b.value === l)) == null ? void 0 : m.label), v || (v = s), /* @__PURE__ */ Oe.jsx(IC, { overlay: p, children: /* @__PURE__ */ Oe.jsxs("span", { className: `ant-form-dropdown ${u}`, children: [
    v,
    /* @__PURE__ */ Oe.jsx(cC, { style: { marginLeft: 7 } })
  ] }) });
};
var rje = Ec, ije = xu, oje = "[object RegExp]";
function aje(t) {
  return ije(t) && rje(t) == oje;
}
var sje = aje, uje = sje, lje = MC, nM = FC, rM = nM && nM.isRegExp, cje = rM ? lje(rM) : uje, dje = cje, iM = K6, fje = q6, hje = aC, pje = Ds, gje = dje, mje = V2e, vje = Q6, bje = aCe, oM = zd, yje = 30, xje = "...", Cje = /\w*$/;
function wje(t, e) {
  var n = yje, r = xje;
  if (pje(e)) {
    var i = "separator" in e ? e.separator : i;
    n = "length" in e ? bje(e.length) : n, r = "omission" in e ? iM(e.omission) : r;
  }
  t = oM(t);
  var o = t.length;
  if (hje(t)) {
    var a = vje(t);
    o = a.length;
  }
  if (n >= o)
    return t;
  var s = n - mje(r);
  if (s < 1)
    return r;
  var u = a ? fje(a, 0, s).join("") : t.slice(0, s);
  if (i === void 0)
    return u + r;
  if (a && (s += u.length - s), gje(i)) {
    if (t.slice(s).search(i)) {
      var l, c = u;
      for (i.global || (i = RegExp(i.source, oM(Cje.exec(i)) + "g")), i.lastIndex = 0; l = i.exec(c); )
        var d = l.index;
      u = u.slice(0, d === void 0 ? s : d);
    }
  } else if (t.indexOf(iM(i), s) != s) {
    var f = u.lastIndexOf(i);
    f > -1 && (u = u.slice(0, f));
  }
  return u + r;
}
var Eje = wje;
const Sje = /* @__PURE__ */ qn(Eje), dT = oi({
  submitText: "Save",
  layout: "horizontal",
  language: "fr",
  tooltipIcon: /* @__PURE__ */ Oe.jsx(dC, {}),
  dateFormat: "L",
  file: {
    addButtonText: "Add document",
    emptyText: "No file"
  }
}), Ije = () => /* @__PURE__ */ Oe.jsx("svg", { width: "4", height: "15", viewBox: "0 0 4 18", fill: "none", xmlns: "http://www.w3.org/2000/svg", children: /* @__PURE__ */ Oe.jsx(
  "path",
  {
    d: "M-3.93403e-07 9C-3.76112e-07 9.39556 0.117298 9.78224 0.337061 10.1111C0.556823 10.44 0.869181 10.6964 1.23463 10.8478C1.60009 10.9991 2.00222 11.0387 2.39018 10.9616C2.77814 10.8844 3.13451 10.6939 3.41421 10.4142C3.69392 10.1345 3.8844 9.77814 3.96157 9.39018C4.03874 9.00222 3.99913 8.60008 3.84776 8.23463C3.69638 7.86918 3.44004 7.55682 3.11114 7.33706C2.78224 7.1173 2.39556 7 2 7C1.46957 7 0.960859 7.21071 0.585786 7.58579C0.210714 7.96086 -4.16588e-07 8.46957 -3.93403e-07 9ZM-8.74228e-08 16C-7.01322e-08 16.3956 0.117298 16.7822 0.337061 17.1111C0.556824 17.44 0.869181 17.6964 1.23463 17.8478C1.60009 17.9991 2.00222 18.0387 2.39018 17.9616C2.77814 17.8844 3.13451 17.6939 3.41421 17.4142C3.69392 17.1345 3.8844 16.7781 3.96157 16.3902C4.03874 16.0022 3.99913 15.6001 3.84776 15.2346C3.69638 14.8692 3.44004 14.5568 3.11114 14.3371C2.78224 14.1173 2.39556 14 2 14C1.46957 14 0.960859 14.2107 0.585787 14.5858C0.210714 14.9609 -1.10609e-07 15.4696 -8.74228e-08 16ZM-6.99382e-07 2C-6.82092e-07 2.39556 0.117297 2.78224 0.33706 3.11114C0.556823 3.44004 0.869181 3.69638 1.23463 3.84776C1.60009 3.99913 2.00222 4.03874 2.39018 3.96157C2.77814 3.8844 3.13451 3.69392 3.41421 3.41421C3.69392 3.13451 3.8844 2.77814 3.96157 2.39018C4.03874 2.00222 3.99913 1.60008 3.84776 1.23463C3.69638 0.869181 3.44004 0.556824 3.11114 0.337061C2.78224 0.117298 2.39556 -1.04713e-07 2 -8.74228e-08C1.46957 -6.42368e-08 0.960859 0.210714 0.585786 0.585787C0.210713 0.960859 -7.22568e-07 1.46957 -6.99382e-07 2Z",
    fill: "#0F0F0F"
  }
) }), _je = (t, {
  remove: e = void 0,
  showDate: n = !1,
  index: r = 0
}, i = {}) => {
  const o = "__typename" in t, a = [
    o && {
      key: "download",
      label: "Télécharger",
      onClick: () => window.open(t.url),
      icon: /* @__PURE__ */ Oe.jsx(nj, {})
    },
    (!o || t.canDestroy) && e && {
      key: "remove",
      label: "Supprimer",
      onClick: () => e(t),
      danger: !0,
      icon: /* @__PURE__ */ Oe.jsx(nA, {})
    }
  ];
  return /* @__PURE__ */ Oe.jsx(
    "span",
    {
      className: "ant-form-file-input-file-item lighten-background",
      ...i,
      children: /* @__PURE__ */ Oe.jsxs(X0, { children: [
        /* @__PURE__ */ Oe.jsx("span", { className: "ant-form-file-input-file-item--icon path-main-color", children: /* @__PURE__ */ Oe.jsx(Gge, {}) }),
        /* @__PURE__ */ Oe.jsxs("span", { className: "ant-form-file-input-file-item--title main-color", children: [
          t != null && t.name || t != null && t.filename ? Sje(t.name || t.filename, { length: 30, omission: "..." }) : null,
          n && (t == null ? void 0 : t.createdAt) && /* @__PURE__ */ Oe.jsx("div", { className: "ant-form-file-input-file-item--timestamps", children: Or(t.createdAt).format("LLL") })
        ] }),
        a.length > 0 && /* @__PURE__ */ Oe.jsx(IC, { menu: { items: a }, children: /* @__PURE__ */ Oe.jsx("a", { className: "ant-form-file-input-file-item--dropdown-toggler path-main-color", children: /* @__PURE__ */ Oe.jsx(Ije, {}) }) })
      ] })
    },
    o ? t.id : r
  );
}, aM = (t) => {
  var w, S;
  const {
    readOnly: e = !1,
    onChange: n,
    value: r,
    multiple: i = !1,
    showDate: o = !1,
    addButtonProps: a,
    emptyText: s
  } = t, u = Ee(), l = fn(dT), [c, d] = Le(t.defaultFileList), [f, h] = Le(
    Array.isArray(t.value || []) ? t.value || [] : [t.value]
  );
  Re(() => {
    h(Array.isArray(t.value || []) ? t.value || [] : [t.value]);
  }, [r]), Re(() => {
    d(t.defaultFileList);
  }, [c]);
  const p = (E) => {
    const I = f || [];
    if (i) {
      const _ = E && E.id, A = I.findIndex((N) => _ ? N.id === E.id : N.uid === E.uid), P = I.slice();
      t.onRemove && _ && t.onRemove(E), P.splice(A, 1), n(P), h(P.length > 0 ? P : []);
    } else
      n(void 0), t.onRemove && t.onRemove(), h([]);
  };
  if (e && (i && (c || []).length === 0 || f.length === 0))
    return /* @__PURE__ */ Oe.jsx("div", { className: "is-muted", children: s || ((w = l == null ? void 0 : l.file) == null ? void 0 : w.emptyText) || "No file" });
  const v = (E) => {
    const I = E.target.files, _ = [...I, ...f];
    i ? (h([...I, ...f]), n([...I, ...f])) : (h([_[0]]), n(_[0]));
  }, m = () => {
    u.current && u.current.click();
  }, b = [...f, ...c || []], { children: y } = a || {};
  return /* @__PURE__ */ Oe.jsxs(Oe.Fragment, { children: [
    !e && // @ts-ignore
    /* @__PURE__ */ Oe.jsx(
      "input",
      {
        onChange: v,
        type: "file",
        multiple: i,
        style: { display: "none" },
        ref: u
      }
    ),
    /* @__PURE__ */ Oe.jsxs(X0, { direction: "vertical", style: { width: "100%" }, children: [
      !e && (f.length === 0 || i) && /* @__PURE__ */ Oe.jsx(Oe.Fragment, { children: /* @__PURE__ */ Oe.jsx(
        ko,
        {
          onClick: m,
          icon: /* @__PURE__ */ Oe.jsx(_j, {}),
          ...a || {},
          className: `${(a == null ? void 0 : a.className) || ""} ant-form-file-input-add-button tenant-border lighten-background`,
          children: y || ((S = l == null ? void 0 : l.file) == null ? void 0 : S.addButtonText) || "Add a file"
        }
      ) }),
      b && /* @__PURE__ */ Oe.jsx("div", { children: /* @__PURE__ */ Oe.jsx(X0, { wrap: !0, children: (b || []).map(
        (E, I) => _je(E, { remove: p, index: I, showDate: o }, {})
      ) }) })
    ] })
  ] });
}, fT = oi({
  editingField: void 0,
  setEditingField: () => {
  },
  loading: !1,
  inPlace: !1,
  formObject: {},
  onFormSubmit: () => {
  },
  submitText: "Ok",
  cancelText: "Cancel",
  onFieldChange: () => {
  },
  onFieldSubmit: () => {
  },
  errors: {},
  setErrors: () => {
  }
}), Aje = (t) => {
  const {
    children: e,
    editingField: n,
    loading: r = !1,
    inPlace: i,
    formObject: o,
    onFormSubmit: a,
    submitText: s = "Ok",
    cancelText: u = "Cancel",
    setEditingField: l,
    onFieldChange: c,
    onFieldSubmit: d,
    errors: f,
    setErrors: h
  } = t;
  return /* @__PURE__ */ Oe.jsx(
    fT.Provider,
    {
      value: {
        editingField: n,
        setEditingField: l,
        loading: r,
        inPlace: i,
        formObject: o,
        onFormSubmit: a,
        submitText: s,
        cancelText: u,
        onFieldChange: c,
        onFieldSubmit: d,
        errors: f,
        setErrors: h
      },
      children: e
    }
  );
}, Tje = (t) => {
  var v;
  const { inputProps: e, onChange: n, localize: r = !1, readOnly: i = !1, locale: o, value: a, name: s } = t, [u, l] = Le(a), { inPlace: c, editingField: d, setEditingField: f } = fn(fT);
  Re(() => {
    c && l(a);
  }, [a]);
  const h = ({ target: { value: m } }) => {
    const b = r && o ? { ...t.value, [o]: m } : m;
    c ? l(b) : n(b);
  };
  let p = c ? u : a;
  if (r && o && p && (p = o in p && p[o] ? p[o] : void 0), c) {
    const m = s === d;
    if (m && !i) {
      const b = () => {
        f(void 0), n(u);
      }, y = () => {
        f(void 0), l(a);
      }, w = (S) => {
        m && S.keyCode === 13 && b(), m && S.keyCode === 27 && y();
      };
      return /* @__PURE__ */ Oe.jsx("div", { className: "ant-form-InPlace-input-container", onBlur: b, children: /* @__PURE__ */ Oe.jsx(
        ma,
        {
          ...e,
          value: p,
          onKeyDown: w,
          onChange: h,
          autoFocus: !0
        }
      ) });
    }
    return /* @__PURE__ */ Oe.jsx("div", { className: "ant-form-on-place-edit-field-value", onClick: () => f(s), children: p && ((v = p == null ? void 0 : p.toString()) == null ? void 0 : v.trim()) !== "" ? p : "-" });
  }
  return /* @__PURE__ */ Oe.jsx(ma, { name: s, ...e, value: p, readOnly: i, onChange: h });
};
function Oje(t) {
  return t ? t.props !== void 0 : !0;
}
function wu(t) {
  return t && t.name;
}
const Pje = (t, e) => "hidden" in t || !wu(t) ? !0 : (t.hidden, typeof t.hidden == "function" ? !t.hidden(e) : !t.hidden), XZ = (t) => (e, n) => !t.some((i) => ii(e, i) === ii(n, i) ? !1 : !VC(ii(e, i), ii(n, i))), Nje = (t) => Um(t).filter((e) => wu(e) && e.proxy), kje = (t) => Um(t).filter((e) => wu(e) && e.name && !!(e != null && e.condition)), Rje = (t) => kje(t).reduce((e, n) => (wu(n) && (e[n.name] = {
  condition: n.condition
}), e), {}), YZ = (t) => (e) => !(e != null && e.name) || !t.includes(e.name), Sb = (t, e) => {
  if (t.length === 0)
    return e;
  const n = e;
  return t.filter((i) => wu(i)).forEach((i) => {
    const { name: o, proxy: a } = i, s = ii(e, o);
    s !== void 0 && a && (iC(s) ? n[a.name] = s.map((u) => a.path ? ii(u, a.path, null) : u).filter(Boolean) : n[a.name] = a.path ? ii(s, a.path, null) : s);
  }), n;
}, hl = ["renderLabel", "condition", "hidden", "proxy", "inputProps"];
function $je(t) {
  return t == null;
}
var Dje = $je;
const sM = /* @__PURE__ */ qn(Dje);
var Ux = { exports: {} };
/**
 * @license
 * Lodash <https://lodash.com/>
 * Copyright OpenJS Foundation and other contributors <https://openjsf.org/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */
Ux.exports;
(function(t, e) {
  (function() {
    var n, r = "4.17.21", i = 200, o = "Unsupported core-js use. Try https://npms.io/search?q=ponyfill.", a = "Expected a function", s = "Invalid `variable` option passed into `_.template`", u = "__lodash_hash_undefined__", l = 500, c = "__lodash_placeholder__", d = 1, f = 2, h = 4, p = 1, v = 2, m = 1, b = 2, y = 4, w = 8, S = 16, E = 32, I = 64, _ = 128, A = 256, P = 512, N = 30, k = "...", D = 800, R = 16, V = 1, $ = 2, F = 3, M = 1 / 0, B = 9007199254740991, X = 17976931348623157e292, L = NaN, j = 4294967295, K = j - 1, W = j >>> 1, Y = [
      ["ary", _],
      ["bind", m],
      ["bindKey", b],
      ["curry", w],
      ["curryRight", S],
      ["flip", P],
      ["partial", E],
      ["partialRight", I],
      ["rearg", A]
    ], U = "[object Arguments]", Q = "[object Array]", Z = "[object AsyncFunction]", ee = "[object Boolean]", ie = "[object Date]", oe = "[object DOMException]", se = "[object Error]", te = "[object Function]", ge = "[object GeneratorFunction]", he = "[object Map]", fe = "[object Number]", _e = "[object Null]", Ne = "[object Object]", ze = "[object Promise]", Ve = "[object Proxy]", ne = "[object RegExp]", pe = "[object Set]", ye = "[object String]", Ae = "[object Symbol]", we = "[object Undefined]", ce = "[object WeakMap]", ve = "[object WeakSet]", Ie = "[object ArrayBuffer]", q = "[object DataView]", Fe = "[object Float32Array]", Ze = "[object Float64Array]", at = "[object Int8Array]", Je = "[object Int16Array]", ut = "[object Int32Array]", Ct = "[object Uint8Array]", Ke = "[object Uint8ClampedArray]", st = "[object Uint16Array]", wt = "[object Uint32Array]", qt = /\b__p \+= '';/g, bt = /\b(__p \+=) '' \+/g, Me = /(__e\(.*?\)|\b__t\)) \+\n'';/g, yt = /&(?:amp|lt|gt|quot|#39);/g, ct = /[&<>"']/g, kt = RegExp(yt.source), Vt = RegExp(ct.source), Vn = /<%-([\s\S]+?)%>/g, tn = /<%([\s\S]+?)%>/g, Xe = /<%=([\s\S]+?)%>/g, tt = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/, ot = /^\w*$/, lt = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g, He = /[\\^$.*+?()[\]{}|]/g, mt = RegExp(He.source), Qt = /^\s+/, Yt = /\s/, nn = /\{(?:\n\/\* \[wrapped with .+\] \*\/)?\n?/, Nt = /\{\n\/\* \[wrapped with (.+)\] \*/, ue = /,? & /, $e = /[^\x00-\x2f\x3a-\x40\x5b-\x60\x7b-\x7f]+/g, je = /[()=,{}\[\]\/\s]/, At = /\\(\\)?/g, $t = /\$\{([^\\}]*(?:\\.[^\\}]*)*)\}/g, qe = /\w*$/, nt = /^[-+]0x[0-9a-f]+$/i, dt = /^0b[01]+$/i, rn = /^\[object .+?Constructor\]$/, on = /^0o[0-7]+$/i, Rt = /^(?:0|[1-9]\d*)$/, Tt = /[\xc0-\xd6\xd8-\xf6\xf8-\xff\u0100-\u017f]/g, Wn = /($^)/, zr = /['\n\r\u2028\u2029\\]/g, gr = "\\ud800-\\udfff", fo = "\\u0300-\\u036f", xl = "\\ufe20-\\ufe2f", Cl = "\\u20d0-\\u20ff", Bs = fo + xl + Cl, ho = "\\u2700-\\u27bf", Ho = "a-z\\xdf-\\xf6\\xf8-\\xff", es = "\\xac\\xb1\\xd7\\xf7", wl = "\\x00-\\x2f\\x3a-\\x40\\x5b-\\x60\\x7b-\\xbf", Hs = "\\u2000-\\u206f", an = " \\t\\x0b\\f\\xa0\\ufeff\\n\\r\\u2028\\u2029\\u1680\\u180e\\u2000\\u2001\\u2002\\u2003\\u2004\\u2005\\u2006\\u2007\\u2008\\u2009\\u200a\\u202f\\u205f\\u3000", jt = "A-Z\\xc0-\\xd6\\xd8-\\xde", Nr = "\\ufe0e\\ufe0f", qr = es + wl + Hs + an, mr = "['’]", si = "[" + gr + "]", Qr = "[" + qr + "]", Dn = "[" + Bs + "]", hn = "\\d+", Mn = "[" + ho + "]", Qn = "[" + Ho + "]", Fr = "[^" + gr + qr + hn + ho + Ho + jt + "]", po = "\\ud83c[\\udffb-\\udfff]", Ws = "(?:" + Dn + "|" + po + ")", gf = "[^" + gr + "]", Mc = "(?:\\ud83c[\\udde6-\\uddff]){2}", El = "[\\ud800-\\udbff][\\udc00-\\udfff]", Su = "[" + jt + "]", Kp = "\\u200d", Mv = "(?:" + Qn + "|" + Fr + ")", Fv = "(?:" + Su + "|" + Fr + ")", Lv = "(?:" + mr + "(?:d|ll|m|re|s|t|ve))?", qp = "(?:" + mr + "(?:D|LL|M|RE|S|T|VE))?", Vv = Ws + "?", Qp = "[" + Nr + "]?", Sl = "(?:" + Kp + "(?:" + [gf, Mc, El].join("|") + ")" + Qp + Vv + ")*", Bv = "\\d*(?:1st|2nd|3rd|(?![123])\\dth)(?=\\b|[A-Z_])", gE = "\\d*(?:1ST|2ND|3RD|(?![123])\\dTH)(?=\\b|[a-z_])", mf = Qp + Vv + Sl, Hv = "(?:" + [Mn, Mc, El].join("|") + ")" + mf, mE = "(?:" + [gf + Dn + "?", Dn, Mc, El, si].join("|") + ")", eg = RegExp(mr, "g"), vE = RegExp(Dn, "g"), Fc = RegExp(po + "(?=" + po + ")|" + mE + mf, "g"), Wv = RegExp([
      Su + "?" + Qn + "+" + Lv + "(?=" + [Qr, Su, "$"].join("|") + ")",
      Fv + "+" + qp + "(?=" + [Qr, Su + Mv, "$"].join("|") + ")",
      Su + "?" + Mv + "+" + Lv,
      Su + "+" + qp,
      gE,
      Bv,
      hn,
      Hv
    ].join("|"), "g"), bE = RegExp("[" + Kp + gr + Bs + Nr + "]"), tg = /[a-z][A-Z]|[A-Z]{2}[a-z]|[0-9][a-zA-Z]|[a-zA-Z][0-9]|[^a-zA-Z0-9 ]/, yE = [
      "Array",
      "Buffer",
      "DataView",
      "Date",
      "Error",
      "Float32Array",
      "Float64Array",
      "Function",
      "Int8Array",
      "Int16Array",
      "Int32Array",
      "Map",
      "Math",
      "Object",
      "Promise",
      "RegExp",
      "Set",
      "String",
      "Symbol",
      "TypeError",
      "Uint8Array",
      "Uint8ClampedArray",
      "Uint16Array",
      "Uint32Array",
      "WeakMap",
      "_",
      "clearTimeout",
      "isFinite",
      "parseInt",
      "setTimeout"
    ], xE = -1, vr = {};
    vr[Fe] = vr[Ze] = vr[at] = vr[Je] = vr[ut] = vr[Ct] = vr[Ke] = vr[st] = vr[wt] = !0, vr[U] = vr[Q] = vr[Ie] = vr[ee] = vr[q] = vr[ie] = vr[se] = vr[te] = vr[he] = vr[fe] = vr[Ne] = vr[ne] = vr[pe] = vr[ye] = vr[ce] = !1;
    var lr = {};
    lr[U] = lr[Q] = lr[Ie] = lr[q] = lr[ee] = lr[ie] = lr[Fe] = lr[Ze] = lr[at] = lr[Je] = lr[ut] = lr[he] = lr[fe] = lr[Ne] = lr[ne] = lr[pe] = lr[ye] = lr[Ae] = lr[Ct] = lr[Ke] = lr[st] = lr[wt] = !0, lr[se] = lr[te] = lr[ce] = !1;
    var CE = {
      // Latin-1 Supplement block.
      À: "A",
      Á: "A",
      Â: "A",
      Ã: "A",
      Ä: "A",
      Å: "A",
      à: "a",
      á: "a",
      â: "a",
      ã: "a",
      ä: "a",
      å: "a",
      Ç: "C",
      ç: "c",
      Ð: "D",
      ð: "d",
      È: "E",
      É: "E",
      Ê: "E",
      Ë: "E",
      è: "e",
      é: "e",
      ê: "e",
      ë: "e",
      Ì: "I",
      Í: "I",
      Î: "I",
      Ï: "I",
      ì: "i",
      í: "i",
      î: "i",
      ï: "i",
      Ñ: "N",
      ñ: "n",
      Ò: "O",
      Ó: "O",
      Ô: "O",
      Õ: "O",
      Ö: "O",
      Ø: "O",
      ò: "o",
      ó: "o",
      ô: "o",
      õ: "o",
      ö: "o",
      ø: "o",
      Ù: "U",
      Ú: "U",
      Û: "U",
      Ü: "U",
      ù: "u",
      ú: "u",
      û: "u",
      ü: "u",
      Ý: "Y",
      ý: "y",
      ÿ: "y",
      Æ: "Ae",
      æ: "ae",
      Þ: "Th",
      þ: "th",
      ß: "ss",
      // Latin Extended-A block.
      Ā: "A",
      Ă: "A",
      Ą: "A",
      ā: "a",
      ă: "a",
      ą: "a",
      Ć: "C",
      Ĉ: "C",
      Ċ: "C",
      Č: "C",
      ć: "c",
      ĉ: "c",
      ċ: "c",
      č: "c",
      Ď: "D",
      Đ: "D",
      ď: "d",
      đ: "d",
      Ē: "E",
      Ĕ: "E",
      Ė: "E",
      Ę: "E",
      Ě: "E",
      ē: "e",
      ĕ: "e",
      ė: "e",
      ę: "e",
      ě: "e",
      Ĝ: "G",
      Ğ: "G",
      Ġ: "G",
      Ģ: "G",
      ĝ: "g",
      ğ: "g",
      ġ: "g",
      ģ: "g",
      Ĥ: "H",
      Ħ: "H",
      ĥ: "h",
      ħ: "h",
      Ĩ: "I",
      Ī: "I",
      Ĭ: "I",
      Į: "I",
      İ: "I",
      ĩ: "i",
      ī: "i",
      ĭ: "i",
      į: "i",
      ı: "i",
      Ĵ: "J",
      ĵ: "j",
      Ķ: "K",
      ķ: "k",
      ĸ: "k",
      Ĺ: "L",
      Ļ: "L",
      Ľ: "L",
      Ŀ: "L",
      Ł: "L",
      ĺ: "l",
      ļ: "l",
      ľ: "l",
      ŀ: "l",
      ł: "l",
      Ń: "N",
      Ņ: "N",
      Ň: "N",
      Ŋ: "N",
      ń: "n",
      ņ: "n",
      ň: "n",
      ŋ: "n",
      Ō: "O",
      Ŏ: "O",
      Ő: "O",
      ō: "o",
      ŏ: "o",
      ő: "o",
      Ŕ: "R",
      Ŗ: "R",
      Ř: "R",
      ŕ: "r",
      ŗ: "r",
      ř: "r",
      Ś: "S",
      Ŝ: "S",
      Ş: "S",
      Š: "S",
      ś: "s",
      ŝ: "s",
      ş: "s",
      š: "s",
      Ţ: "T",
      Ť: "T",
      Ŧ: "T",
      ţ: "t",
      ť: "t",
      ŧ: "t",
      Ũ: "U",
      Ū: "U",
      Ŭ: "U",
      Ů: "U",
      Ű: "U",
      Ų: "U",
      ũ: "u",
      ū: "u",
      ŭ: "u",
      ů: "u",
      ű: "u",
      ų: "u",
      Ŵ: "W",
      ŵ: "w",
      Ŷ: "Y",
      ŷ: "y",
      Ÿ: "Y",
      Ź: "Z",
      Ż: "Z",
      Ž: "Z",
      ź: "z",
      ż: "z",
      ž: "z",
      Ĳ: "IJ",
      ĳ: "ij",
      Œ: "Oe",
      œ: "oe",
      ŉ: "'n",
      ſ: "s"
    }, jv = {
      "&": "&amp;",
      "<": "&lt;",
      ">": "&gt;",
      '"': "&quot;",
      "'": "&#39;"
    }, wE = {
      "&amp;": "&",
      "&lt;": "<",
      "&gt;": ">",
      "&quot;": '"',
      "&#39;": "'"
    }, zv = {
      "\\": "\\",
      "'": "'",
      "\n": "n",
      "\r": "r",
      "\u2028": "u2028",
      "\u2029": "u2029"
    }, Gv = parseFloat, Uv = parseInt, Xv = typeof ft == "object" && ft && ft.Object === Object && ft, Yv = typeof self == "object" && self && self.Object === Object && self, gi = Xv || Yv || Function("return this")(), vf = e && !e.nodeType && e, js = vf && !0 && t && !t.nodeType && t, ng = js && js.exports === vf, rg = ng && Xv.process, go = function() {
      try {
        var Se = js && js.require && js.require("util").types;
        return Se || rg && rg.binding && rg.binding("util");
      } catch {
      }
    }(), Zv = go && go.isArrayBuffer, Jv = go && go.isDate, Kv = go && go.isMap, qv = go && go.isRegExp, bf = go && go.isSet, ts = go && go.isTypedArray;
    function zi(Se, Be, De) {
      switch (De.length) {
        case 0:
          return Se.call(Be);
        case 1:
          return Se.call(Be, De[0]);
        case 2:
          return Se.call(Be, De[0], De[1]);
        case 3:
          return Se.call(Be, De[0], De[1], De[2]);
      }
      return Se.apply(Be, De);
    }
    function EE(Se, Be, De, Pt) {
      for (var cn = -1, Un = Se == null ? 0 : Se.length; ++cn < Un; ) {
        var mi = Se[cn];
        Be(Pt, mi, De(mi), Se);
      }
      return Pt;
    }
    function mo(Se, Be) {
      for (var De = -1, Pt = Se == null ? 0 : Se.length; ++De < Pt && Be(Se[De], De, Se) !== !1; )
        ;
      return Se;
    }
    function SE(Se, Be) {
      for (var De = Se == null ? 0 : Se.length; De-- && Be(Se[De], De, Se) !== !1; )
        ;
      return Se;
    }
    function Qv(Se, Be) {
      for (var De = -1, Pt = Se == null ? 0 : Se.length; ++De < Pt; )
        if (!Be(Se[De], De, Se))
          return !1;
      return !0;
    }
    function ns(Se, Be) {
      for (var De = -1, Pt = Se == null ? 0 : Se.length, cn = 0, Un = []; ++De < Pt; ) {
        var mi = Se[De];
        Be(mi, De, Se) && (Un[cn++] = mi);
      }
      return Un;
    }
    function Lc(Se, Be) {
      var De = Se == null ? 0 : Se.length;
      return !!De && Gi(Se, Be, 0) > -1;
    }
    function yf(Se, Be, De) {
      for (var Pt = -1, cn = Se == null ? 0 : Se.length; ++Pt < cn; )
        if (De(Be, Se[Pt]))
          return !0;
      return !1;
    }
    function br(Se, Be) {
      for (var De = -1, Pt = Se == null ? 0 : Se.length, cn = Array(Pt); ++De < Pt; )
        cn[De] = Be(Se[De], De, Se);
      return cn;
    }
    function wa(Se, Be) {
      for (var De = -1, Pt = Be.length, cn = Se.length; ++De < Pt; )
        Se[cn + De] = Be[De];
      return Se;
    }
    function ig(Se, Be, De, Pt) {
      var cn = -1, Un = Se == null ? 0 : Se.length;
      for (Pt && Un && (De = Se[++cn]); ++cn < Un; )
        De = Be(De, Se[cn], cn, Se);
      return De;
    }
    function IE(Se, Be, De, Pt) {
      var cn = Se == null ? 0 : Se.length;
      for (Pt && cn && (De = Se[--cn]); cn--; )
        De = Be(De, Se[cn], cn, Se);
      return De;
    }
    function sn(Se, Be) {
      for (var De = -1, Pt = Se == null ? 0 : Se.length; ++De < Pt; )
        if (Be(Se[De], De, Se))
          return !0;
      return !1;
    }
    var ht = Iu("length");
    function Mt(Se) {
      return Se.split("");
    }
    function bn(Se) {
      return Se.match($e) || [];
    }
    function Lr(Se, Be, De) {
      var Pt;
      return De(Se, function(cn, Un, mi) {
        if (Be(cn, Un, mi))
          return Pt = Un, !1;
      }), Pt;
    }
    function Ea(Se, Be, De, Pt) {
      for (var cn = Se.length, Un = De + (Pt ? 1 : -1); Pt ? Un-- : ++Un < cn; )
        if (Be(Se[Un], Un, Se))
          return Un;
      return -1;
    }
    function Gi(Se, Be, De) {
      return Be === Be ? ioe(Se, Be, De) : Ea(Se, jo, De);
    }
    function Wo(Se, Be, De, Pt) {
      for (var cn = De - 1, Un = Se.length; ++cn < Un; )
        if (Pt(Se[cn], Be))
          return cn;
      return -1;
    }
    function jo(Se) {
      return Se !== Se;
    }
    function Sa(Se, Be) {
      var De = Se == null ? 0 : Se.length;
      return De ? _E(Se, Be) / De : L;
    }
    function Iu(Se) {
      return function(Be) {
        return Be == null ? n : Be[Se];
      };
    }
    function ki(Se) {
      return function(Be) {
        return Se == null ? n : Se[Be];
      };
    }
    function yP(Se, Be, De, Pt, cn) {
      return cn(Se, function(Un, mi, Ir) {
        De = Pt ? (Pt = !1, Un) : Be(De, Un, mi, Ir);
      }), De;
    }
    function Yie(Se, Be) {
      var De = Se.length;
      for (Se.sort(Be); De--; )
        Se[De] = Se[De].value;
      return Se;
    }
    function _E(Se, Be) {
      for (var De, Pt = -1, cn = Se.length; ++Pt < cn; ) {
        var Un = Be(Se[Pt]);
        Un !== n && (De = De === n ? Un : De + Un);
      }
      return De;
    }
    function AE(Se, Be) {
      for (var De = -1, Pt = Array(Se); ++De < Se; )
        Pt[De] = Be(De);
      return Pt;
    }
    function Zie(Se, Be) {
      return br(Be, function(De) {
        return [De, Se[De]];
      });
    }
    function xP(Se) {
      return Se && Se.slice(0, SP(Se) + 1).replace(Qt, "");
    }
    function zo(Se) {
      return function(Be) {
        return Se(Be);
      };
    }
    function TE(Se, Be) {
      return br(Be, function(De) {
        return Se[De];
      });
    }
    function og(Se, Be) {
      return Se.has(Be);
    }
    function CP(Se, Be) {
      for (var De = -1, Pt = Se.length; ++De < Pt && Gi(Be, Se[De], 0) > -1; )
        ;
      return De;
    }
    function wP(Se, Be) {
      for (var De = Se.length; De-- && Gi(Be, Se[De], 0) > -1; )
        ;
      return De;
    }
    function Jie(Se, Be) {
      for (var De = Se.length, Pt = 0; De--; )
        Se[De] === Be && ++Pt;
      return Pt;
    }
    var Kie = ki(CE), qie = ki(jv);
    function Qie(Se) {
      return "\\" + zv[Se];
    }
    function eoe(Se, Be) {
      return Se == null ? n : Se[Be];
    }
    function xf(Se) {
      return bE.test(Se);
    }
    function toe(Se) {
      return tg.test(Se);
    }
    function noe(Se) {
      for (var Be, De = []; !(Be = Se.next()).done; )
        De.push(Be.value);
      return De;
    }
    function OE(Se) {
      var Be = -1, De = Array(Se.size);
      return Se.forEach(function(Pt, cn) {
        De[++Be] = [cn, Pt];
      }), De;
    }
    function EP(Se, Be) {
      return function(De) {
        return Se(Be(De));
      };
    }
    function Il(Se, Be) {
      for (var De = -1, Pt = Se.length, cn = 0, Un = []; ++De < Pt; ) {
        var mi = Se[De];
        (mi === Be || mi === c) && (Se[De] = c, Un[cn++] = De);
      }
      return Un;
    }
    function e1(Se) {
      var Be = -1, De = Array(Se.size);
      return Se.forEach(function(Pt) {
        De[++Be] = Pt;
      }), De;
    }
    function roe(Se) {
      var Be = -1, De = Array(Se.size);
      return Se.forEach(function(Pt) {
        De[++Be] = [Pt, Pt];
      }), De;
    }
    function ioe(Se, Be, De) {
      for (var Pt = De - 1, cn = Se.length; ++Pt < cn; )
        if (Se[Pt] === Be)
          return Pt;
      return -1;
    }
    function ooe(Se, Be, De) {
      for (var Pt = De + 1; Pt--; )
        if (Se[Pt] === Be)
          return Pt;
      return Pt;
    }
    function Cf(Se) {
      return xf(Se) ? soe(Se) : ht(Se);
    }
    function rs(Se) {
      return xf(Se) ? uoe(Se) : Mt(Se);
    }
    function SP(Se) {
      for (var Be = Se.length; Be-- && Yt.test(Se.charAt(Be)); )
        ;
      return Be;
    }
    var aoe = ki(wE);
    function soe(Se) {
      for (var Be = Fc.lastIndex = 0; Fc.test(Se); )
        ++Be;
      return Be;
    }
    function uoe(Se) {
      return Se.match(Fc) || [];
    }
    function loe(Se) {
      return Se.match(Wv) || [];
    }
    var coe = function Se(Be) {
      Be = Be == null ? gi : wf.defaults(gi.Object(), Be, wf.pick(gi, yE));
      var De = Be.Array, Pt = Be.Date, cn = Be.Error, Un = Be.Function, mi = Be.Math, Ir = Be.Object, PE = Be.RegExp, doe = Be.String, Ia = Be.TypeError, t1 = De.prototype, foe = Un.prototype, Ef = Ir.prototype, n1 = Be["__core-js_shared__"], r1 = foe.toString, cr = Ef.hasOwnProperty, hoe = 0, IP = function() {
        var g = /[^.]+$/.exec(n1 && n1.keys && n1.keys.IE_PROTO || "");
        return g ? "Symbol(src)_1." + g : "";
      }(), i1 = Ef.toString, poe = r1.call(Ir), goe = gi._, moe = PE(
        "^" + r1.call(cr).replace(He, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$"
      ), o1 = ng ? Be.Buffer : n, _l = Be.Symbol, a1 = Be.Uint8Array, _P = o1 ? o1.allocUnsafe : n, s1 = EP(Ir.getPrototypeOf, Ir), AP = Ir.create, TP = Ef.propertyIsEnumerable, u1 = t1.splice, OP = _l ? _l.isConcatSpreadable : n, ag = _l ? _l.iterator : n, Vc = _l ? _l.toStringTag : n, l1 = function() {
        try {
          var g = zc(Ir, "defineProperty");
          return g({}, "", {}), g;
        } catch {
        }
      }(), voe = Be.clearTimeout !== gi.clearTimeout && Be.clearTimeout, boe = Pt && Pt.now !== gi.Date.now && Pt.now, yoe = Be.setTimeout !== gi.setTimeout && Be.setTimeout, c1 = mi.ceil, d1 = mi.floor, NE = Ir.getOwnPropertySymbols, xoe = o1 ? o1.isBuffer : n, PP = Be.isFinite, Coe = t1.join, woe = EP(Ir.keys, Ir), bi = mi.max, Ui = mi.min, Eoe = Pt.now, Soe = Be.parseInt, NP = mi.random, Ioe = t1.reverse, kE = zc(Be, "DataView"), sg = zc(Be, "Map"), RE = zc(Be, "Promise"), Sf = zc(Be, "Set"), ug = zc(Be, "WeakMap"), lg = zc(Ir, "create"), f1 = ug && new ug(), If = {}, _oe = Gc(kE), Aoe = Gc(sg), Toe = Gc(RE), Ooe = Gc(Sf), Poe = Gc(ug), h1 = _l ? _l.prototype : n, cg = h1 ? h1.valueOf : n, kP = h1 ? h1.toString : n;
      function re(g) {
        if (Gr(g) && !pn(g) && !(g instanceof Nn)) {
          if (g instanceof _a)
            return g;
          if (cr.call(g, "__wrapped__"))
            return RN(g);
        }
        return new _a(g);
      }
      var _f = /* @__PURE__ */ function() {
        function g() {
        }
        return function(C) {
          if (!Wr(C))
            return {};
          if (AP)
            return AP(C);
          g.prototype = C;
          var T = new g();
          return g.prototype = n, T;
        };
      }();
      function p1() {
      }
      function _a(g, C) {
        this.__wrapped__ = g, this.__actions__ = [], this.__chain__ = !!C, this.__index__ = 0, this.__values__ = n;
      }
      re.templateSettings = {
        /**
         * Used to detect `data` property values to be HTML-escaped.
         *
         * @memberOf _.templateSettings
         * @type {RegExp}
         */
        escape: Vn,
        /**
         * Used to detect code to be evaluated.
         *
         * @memberOf _.templateSettings
         * @type {RegExp}
         */
        evaluate: tn,
        /**
         * Used to detect `data` property values to inject.
         *
         * @memberOf _.templateSettings
         * @type {RegExp}
         */
        interpolate: Xe,
        /**
         * Used to reference the data object in the template text.
         *
         * @memberOf _.templateSettings
         * @type {string}
         */
        variable: "",
        /**
         * Used to import variables into the compiled template.
         *
         * @memberOf _.templateSettings
         * @type {Object}
         */
        imports: {
          /**
           * A reference to the `lodash` function.
           *
           * @memberOf _.templateSettings.imports
           * @type {Function}
           */
          _: re
        }
      }, re.prototype = p1.prototype, re.prototype.constructor = re, _a.prototype = _f(p1.prototype), _a.prototype.constructor = _a;
      function Nn(g) {
        this.__wrapped__ = g, this.__actions__ = [], this.__dir__ = 1, this.__filtered__ = !1, this.__iteratees__ = [], this.__takeCount__ = j, this.__views__ = [];
      }
      function Noe() {
        var g = new Nn(this.__wrapped__);
        return g.__actions__ = vo(this.__actions__), g.__dir__ = this.__dir__, g.__filtered__ = this.__filtered__, g.__iteratees__ = vo(this.__iteratees__), g.__takeCount__ = this.__takeCount__, g.__views__ = vo(this.__views__), g;
      }
      function koe() {
        if (this.__filtered__) {
          var g = new Nn(this);
          g.__dir__ = -1, g.__filtered__ = !0;
        } else
          g = this.clone(), g.__dir__ *= -1;
        return g;
      }
      function Roe() {
        var g = this.__wrapped__.value(), C = this.__dir__, T = pn(g), H = C < 0, J = T ? g.length : 0, ae = Gae(0, J, this.__views__), me = ae.start, xe = ae.end, Te = xe - me, Ge = H ? xe : me - 1, Ue = this.__iteratees__, Qe = Ue.length, xt = 0, Ft = Ui(Te, this.__takeCount__);
        if (!T || !H && J == Te && Ft == Te)
          return nN(g, this.__actions__);
        var Zt = [];
        e:
          for (; Te-- && xt < Ft; ) {
            Ge += C;
            for (var yn = -1, Jt = g[Ge]; ++yn < Qe; ) {
              var Tn = Ue[yn], Fn = Tn.iteratee, Xo = Tn.type, to = Fn(Jt);
              if (Xo == $)
                Jt = to;
              else if (!to) {
                if (Xo == V)
                  continue e;
                break e;
              }
            }
            Zt[xt++] = Jt;
          }
        return Zt;
      }
      Nn.prototype = _f(p1.prototype), Nn.prototype.constructor = Nn;
      function Bc(g) {
        var C = -1, T = g == null ? 0 : g.length;
        for (this.clear(); ++C < T; ) {
          var H = g[C];
          this.set(H[0], H[1]);
        }
      }
      function $oe() {
        this.__data__ = lg ? lg(null) : {}, this.size = 0;
      }
      function Doe(g) {
        var C = this.has(g) && delete this.__data__[g];
        return this.size -= C ? 1 : 0, C;
      }
      function Moe(g) {
        var C = this.__data__;
        if (lg) {
          var T = C[g];
          return T === u ? n : T;
        }
        return cr.call(C, g) ? C[g] : n;
      }
      function Foe(g) {
        var C = this.__data__;
        return lg ? C[g] !== n : cr.call(C, g);
      }
      function Loe(g, C) {
        var T = this.__data__;
        return this.size += this.has(g) ? 0 : 1, T[g] = lg && C === n ? u : C, this;
      }
      Bc.prototype.clear = $oe, Bc.prototype.delete = Doe, Bc.prototype.get = Moe, Bc.prototype.has = Foe, Bc.prototype.set = Loe;
      function _u(g) {
        var C = -1, T = g == null ? 0 : g.length;
        for (this.clear(); ++C < T; ) {
          var H = g[C];
          this.set(H[0], H[1]);
        }
      }
      function Voe() {
        this.__data__ = [], this.size = 0;
      }
      function Boe(g) {
        var C = this.__data__, T = g1(C, g);
        if (T < 0)
          return !1;
        var H = C.length - 1;
        return T == H ? C.pop() : u1.call(C, T, 1), --this.size, !0;
      }
      function Hoe(g) {
        var C = this.__data__, T = g1(C, g);
        return T < 0 ? n : C[T][1];
      }
      function Woe(g) {
        return g1(this.__data__, g) > -1;
      }
      function joe(g, C) {
        var T = this.__data__, H = g1(T, g);
        return H < 0 ? (++this.size, T.push([g, C])) : T[H][1] = C, this;
      }
      _u.prototype.clear = Voe, _u.prototype.delete = Boe, _u.prototype.get = Hoe, _u.prototype.has = Woe, _u.prototype.set = joe;
      function Au(g) {
        var C = -1, T = g == null ? 0 : g.length;
        for (this.clear(); ++C < T; ) {
          var H = g[C];
          this.set(H[0], H[1]);
        }
      }
      function zoe() {
        this.size = 0, this.__data__ = {
          hash: new Bc(),
          map: new (sg || _u)(),
          string: new Bc()
        };
      }
      function Goe(g) {
        var C = A1(this, g).delete(g);
        return this.size -= C ? 1 : 0, C;
      }
      function Uoe(g) {
        return A1(this, g).get(g);
      }
      function Xoe(g) {
        return A1(this, g).has(g);
      }
      function Yoe(g, C) {
        var T = A1(this, g), H = T.size;
        return T.set(g, C), this.size += T.size == H ? 0 : 1, this;
      }
      Au.prototype.clear = zoe, Au.prototype.delete = Goe, Au.prototype.get = Uoe, Au.prototype.has = Xoe, Au.prototype.set = Yoe;
      function Hc(g) {
        var C = -1, T = g == null ? 0 : g.length;
        for (this.__data__ = new Au(); ++C < T; )
          this.add(g[C]);
      }
      function Zoe(g) {
        return this.__data__.set(g, u), this;
      }
      function Joe(g) {
        return this.__data__.has(g);
      }
      Hc.prototype.add = Hc.prototype.push = Zoe, Hc.prototype.has = Joe;
      function is(g) {
        var C = this.__data__ = new _u(g);
        this.size = C.size;
      }
      function Koe() {
        this.__data__ = new _u(), this.size = 0;
      }
      function qoe(g) {
        var C = this.__data__, T = C.delete(g);
        return this.size = C.size, T;
      }
      function Qoe(g) {
        return this.__data__.get(g);
      }
      function eae(g) {
        return this.__data__.has(g);
      }
      function tae(g, C) {
        var T = this.__data__;
        if (T instanceof _u) {
          var H = T.__data__;
          if (!sg || H.length < i - 1)
            return H.push([g, C]), this.size = ++T.size, this;
          T = this.__data__ = new Au(H);
        }
        return T.set(g, C), this.size = T.size, this;
      }
      is.prototype.clear = Koe, is.prototype.delete = qoe, is.prototype.get = Qoe, is.prototype.has = eae, is.prototype.set = tae;
      function RP(g, C) {
        var T = pn(g), H = !T && Uc(g), J = !T && !H && Nl(g), ae = !T && !H && !J && Pf(g), me = T || H || J || ae, xe = me ? AE(g.length, doe) : [], Te = xe.length;
        for (var Ge in g)
          (C || cr.call(g, Ge)) && !(me && // Safari 9 has enumerable `arguments.length` in strict mode.
          (Ge == "length" || // Node.js 0.10 has enumerable non-index properties on buffers.
          J && (Ge == "offset" || Ge == "parent") || // PhantomJS 2 has enumerable non-index properties on typed arrays.
          ae && (Ge == "buffer" || Ge == "byteLength" || Ge == "byteOffset") || // Skip index properties.
          Nu(Ge, Te))) && xe.push(Ge);
        return xe;
      }
      function $P(g) {
        var C = g.length;
        return C ? g[zE(0, C - 1)] : n;
      }
      function nae(g, C) {
        return T1(vo(g), Wc(C, 0, g.length));
      }
      function rae(g) {
        return T1(vo(g));
      }
      function $E(g, C, T) {
        (T !== n && !os(g[C], T) || T === n && !(C in g)) && Tu(g, C, T);
      }
      function dg(g, C, T) {
        var H = g[C];
        (!(cr.call(g, C) && os(H, T)) || T === n && !(C in g)) && Tu(g, C, T);
      }
      function g1(g, C) {
        for (var T = g.length; T--; )
          if (os(g[T][0], C))
            return T;
        return -1;
      }
      function iae(g, C, T, H) {
        return Al(g, function(J, ae, me) {
          C(H, J, T(J), me);
        }), H;
      }
      function DP(g, C) {
        return g && Gs(C, Si(C), g);
      }
      function oae(g, C) {
        return g && Gs(C, yo(C), g);
      }
      function Tu(g, C, T) {
        C == "__proto__" && l1 ? l1(g, C, {
          configurable: !0,
          enumerable: !0,
          value: T,
          writable: !0
        }) : g[C] = T;
      }
      function DE(g, C) {
        for (var T = -1, H = C.length, J = De(H), ae = g == null; ++T < H; )
          J[T] = ae ? n : gS(g, C[T]);
        return J;
      }
      function Wc(g, C, T) {
        return g === g && (T !== n && (g = g <= T ? g : T), C !== n && (g = g >= C ? g : C)), g;
      }
      function Aa(g, C, T, H, J, ae) {
        var me, xe = C & d, Te = C & f, Ge = C & h;
        if (T && (me = J ? T(g, H, J, ae) : T(g)), me !== n)
          return me;
        if (!Wr(g))
          return g;
        var Ue = pn(g);
        if (Ue) {
          if (me = Xae(g), !xe)
            return vo(g, me);
        } else {
          var Qe = Xi(g), xt = Qe == te || Qe == ge;
          if (Nl(g))
            return oN(g, xe);
          if (Qe == Ne || Qe == U || xt && !J) {
            if (me = Te || xt ? {} : SN(g), !xe)
              return Te ? Mae(g, oae(me, g)) : Dae(g, DP(me, g));
          } else {
            if (!lr[Qe])
              return J ? g : {};
            me = Yae(g, Qe, xe);
          }
        }
        ae || (ae = new is());
        var Ft = ae.get(g);
        if (Ft)
          return Ft;
        ae.set(g, me), QN(g) ? g.forEach(function(Jt) {
          me.add(Aa(Jt, C, T, Jt, g, ae));
        }) : KN(g) && g.forEach(function(Jt, Tn) {
          me.set(Tn, Aa(Jt, C, T, Tn, g, ae));
        });
        var Zt = Ge ? Te ? tS : eS : Te ? yo : Si, yn = Ue ? n : Zt(g);
        return mo(yn || g, function(Jt, Tn) {
          yn && (Tn = Jt, Jt = g[Tn]), dg(me, Tn, Aa(Jt, C, T, Tn, g, ae));
        }), me;
      }
      function aae(g) {
        var C = Si(g);
        return function(T) {
          return MP(T, g, C);
        };
      }
      function MP(g, C, T) {
        var H = T.length;
        if (g == null)
          return !H;
        for (g = Ir(g); H--; ) {
          var J = T[H], ae = C[J], me = g[J];
          if (me === n && !(J in g) || !ae(me))
            return !1;
        }
        return !0;
      }
      function FP(g, C, T) {
        if (typeof g != "function")
          throw new Ia(a);
        return bg(function() {
          g.apply(n, T);
        }, C);
      }
      function fg(g, C, T, H) {
        var J = -1, ae = Lc, me = !0, xe = g.length, Te = [], Ge = C.length;
        if (!xe)
          return Te;
        T && (C = br(C, zo(T))), H ? (ae = yf, me = !1) : C.length >= i && (ae = og, me = !1, C = new Hc(C));
        e:
          for (; ++J < xe; ) {
            var Ue = g[J], Qe = T == null ? Ue : T(Ue);
            if (Ue = H || Ue !== 0 ? Ue : 0, me && Qe === Qe) {
              for (var xt = Ge; xt--; )
                if (C[xt] === Qe)
                  continue e;
              Te.push(Ue);
            } else
              ae(C, Qe, H) || Te.push(Ue);
          }
        return Te;
      }
      var Al = cN(zs), LP = cN(FE, !0);
      function sae(g, C) {
        var T = !0;
        return Al(g, function(H, J, ae) {
          return T = !!C(H, J, ae), T;
        }), T;
      }
      function m1(g, C, T) {
        for (var H = -1, J = g.length; ++H < J; ) {
          var ae = g[H], me = C(ae);
          if (me != null && (xe === n ? me === me && !Uo(me) : T(me, xe)))
            var xe = me, Te = ae;
        }
        return Te;
      }
      function uae(g, C, T, H) {
        var J = g.length;
        for (T = vn(T), T < 0 && (T = -T > J ? 0 : J + T), H = H === n || H > J ? J : vn(H), H < 0 && (H += J), H = T > H ? 0 : t7(H); T < H; )
          g[T++] = C;
        return g;
      }
      function VP(g, C) {
        var T = [];
        return Al(g, function(H, J, ae) {
          C(H, J, ae) && T.push(H);
        }), T;
      }
      function Ri(g, C, T, H, J) {
        var ae = -1, me = g.length;
        for (T || (T = Jae), J || (J = []); ++ae < me; ) {
          var xe = g[ae];
          C > 0 && T(xe) ? C > 1 ? Ri(xe, C - 1, T, H, J) : wa(J, xe) : H || (J[J.length] = xe);
        }
        return J;
      }
      var ME = dN(), BP = dN(!0);
      function zs(g, C) {
        return g && ME(g, C, Si);
      }
      function FE(g, C) {
        return g && BP(g, C, Si);
      }
      function v1(g, C) {
        return ns(C, function(T) {
          return ku(g[T]);
        });
      }
      function jc(g, C) {
        C = Ol(C, g);
        for (var T = 0, H = C.length; g != null && T < H; )
          g = g[Us(C[T++])];
        return T && T == H ? g : n;
      }
      function HP(g, C, T) {
        var H = C(g);
        return pn(g) ? H : wa(H, T(g));
      }
      function Qi(g) {
        return g == null ? g === n ? we : _e : Vc && Vc in Ir(g) ? zae(g) : rse(g);
      }
      function LE(g, C) {
        return g > C;
      }
      function lae(g, C) {
        return g != null && cr.call(g, C);
      }
      function cae(g, C) {
        return g != null && C in Ir(g);
      }
      function dae(g, C, T) {
        return g >= Ui(C, T) && g < bi(C, T);
      }
      function VE(g, C, T) {
        for (var H = T ? yf : Lc, J = g[0].length, ae = g.length, me = ae, xe = De(ae), Te = 1 / 0, Ge = []; me--; ) {
          var Ue = g[me];
          me && C && (Ue = br(Ue, zo(C))), Te = Ui(Ue.length, Te), xe[me] = !T && (C || J >= 120 && Ue.length >= 120) ? new Hc(me && Ue) : n;
        }
        Ue = g[0];
        var Qe = -1, xt = xe[0];
        e:
          for (; ++Qe < J && Ge.length < Te; ) {
            var Ft = Ue[Qe], Zt = C ? C(Ft) : Ft;
            if (Ft = T || Ft !== 0 ? Ft : 0, !(xt ? og(xt, Zt) : H(Ge, Zt, T))) {
              for (me = ae; --me; ) {
                var yn = xe[me];
                if (!(yn ? og(yn, Zt) : H(g[me], Zt, T)))
                  continue e;
              }
              xt && xt.push(Zt), Ge.push(Ft);
            }
          }
        return Ge;
      }
      function fae(g, C, T, H) {
        return zs(g, function(J, ae, me) {
          C(H, T(J), ae, me);
        }), H;
      }
      function hg(g, C, T) {
        C = Ol(C, g), g = TN(g, C);
        var H = g == null ? g : g[Us(Oa(C))];
        return H == null ? n : zi(H, g, T);
      }
      function WP(g) {
        return Gr(g) && Qi(g) == U;
      }
      function hae(g) {
        return Gr(g) && Qi(g) == Ie;
      }
      function pae(g) {
        return Gr(g) && Qi(g) == ie;
      }
      function pg(g, C, T, H, J) {
        return g === C ? !0 : g == null || C == null || !Gr(g) && !Gr(C) ? g !== g && C !== C : gae(g, C, T, H, pg, J);
      }
      function gae(g, C, T, H, J, ae) {
        var me = pn(g), xe = pn(C), Te = me ? Q : Xi(g), Ge = xe ? Q : Xi(C);
        Te = Te == U ? Ne : Te, Ge = Ge == U ? Ne : Ge;
        var Ue = Te == Ne, Qe = Ge == Ne, xt = Te == Ge;
        if (xt && Nl(g)) {
          if (!Nl(C))
            return !1;
          me = !0, Ue = !1;
        }
        if (xt && !Ue)
          return ae || (ae = new is()), me || Pf(g) ? CN(g, C, T, H, J, ae) : Wae(g, C, Te, T, H, J, ae);
        if (!(T & p)) {
          var Ft = Ue && cr.call(g, "__wrapped__"), Zt = Qe && cr.call(C, "__wrapped__");
          if (Ft || Zt) {
            var yn = Ft ? g.value() : g, Jt = Zt ? C.value() : C;
            return ae || (ae = new is()), J(yn, Jt, T, H, ae);
          }
        }
        return xt ? (ae || (ae = new is()), jae(g, C, T, H, J, ae)) : !1;
      }
      function mae(g) {
        return Gr(g) && Xi(g) == he;
      }
      function BE(g, C, T, H) {
        var J = T.length, ae = J, me = !H;
        if (g == null)
          return !ae;
        for (g = Ir(g); J--; ) {
          var xe = T[J];
          if (me && xe[2] ? xe[1] !== g[xe[0]] : !(xe[0] in g))
            return !1;
        }
        for (; ++J < ae; ) {
          xe = T[J];
          var Te = xe[0], Ge = g[Te], Ue = xe[1];
          if (me && xe[2]) {
            if (Ge === n && !(Te in g))
              return !1;
          } else {
            var Qe = new is();
            if (H)
              var xt = H(Ge, Ue, Te, g, C, Qe);
            if (!(xt === n ? pg(Ue, Ge, p | v, H, Qe) : xt))
              return !1;
          }
        }
        return !0;
      }
      function jP(g) {
        if (!Wr(g) || qae(g))
          return !1;
        var C = ku(g) ? moe : rn;
        return C.test(Gc(g));
      }
      function vae(g) {
        return Gr(g) && Qi(g) == ne;
      }
      function bae(g) {
        return Gr(g) && Xi(g) == pe;
      }
      function yae(g) {
        return Gr(g) && $1(g.length) && !!vr[Qi(g)];
      }
      function zP(g) {
        return typeof g == "function" ? g : g == null ? xo : typeof g == "object" ? pn(g) ? XP(g[0], g[1]) : UP(g) : f7(g);
      }
      function HE(g) {
        if (!vg(g))
          return woe(g);
        var C = [];
        for (var T in Ir(g))
          cr.call(g, T) && T != "constructor" && C.push(T);
        return C;
      }
      function xae(g) {
        if (!Wr(g))
          return nse(g);
        var C = vg(g), T = [];
        for (var H in g)
          H == "constructor" && (C || !cr.call(g, H)) || T.push(H);
        return T;
      }
      function WE(g, C) {
        return g < C;
      }
      function GP(g, C) {
        var T = -1, H = bo(g) ? De(g.length) : [];
        return Al(g, function(J, ae, me) {
          H[++T] = C(J, ae, me);
        }), H;
      }
      function UP(g) {
        var C = rS(g);
        return C.length == 1 && C[0][2] ? _N(C[0][0], C[0][1]) : function(T) {
          return T === g || BE(T, g, C);
        };
      }
      function XP(g, C) {
        return oS(g) && IN(C) ? _N(Us(g), C) : function(T) {
          var H = gS(T, g);
          return H === n && H === C ? mS(T, g) : pg(C, H, p | v);
        };
      }
      function b1(g, C, T, H, J) {
        g !== C && ME(C, function(ae, me) {
          if (J || (J = new is()), Wr(ae))
            Cae(g, C, me, T, b1, H, J);
          else {
            var xe = H ? H(sS(g, me), ae, me + "", g, C, J) : n;
            xe === n && (xe = ae), $E(g, me, xe);
          }
        }, yo);
      }
      function Cae(g, C, T, H, J, ae, me) {
        var xe = sS(g, T), Te = sS(C, T), Ge = me.get(Te);
        if (Ge) {
          $E(g, T, Ge);
          return;
        }
        var Ue = ae ? ae(xe, Te, T + "", g, C, me) : n, Qe = Ue === n;
        if (Qe) {
          var xt = pn(Te), Ft = !xt && Nl(Te), Zt = !xt && !Ft && Pf(Te);
          Ue = Te, xt || Ft || Zt ? pn(xe) ? Ue = xe : ei(xe) ? Ue = vo(xe) : Ft ? (Qe = !1, Ue = oN(Te, !0)) : Zt ? (Qe = !1, Ue = aN(Te, !0)) : Ue = [] : yg(Te) || Uc(Te) ? (Ue = xe, Uc(xe) ? Ue = n7(xe) : (!Wr(xe) || ku(xe)) && (Ue = SN(Te))) : Qe = !1;
        }
        Qe && (me.set(Te, Ue), J(Ue, Te, H, ae, me), me.delete(Te)), $E(g, T, Ue);
      }
      function YP(g, C) {
        var T = g.length;
        if (T)
          return C += C < 0 ? T : 0, Nu(C, T) ? g[C] : n;
      }
      function ZP(g, C, T) {
        C.length ? C = br(C, function(ae) {
          return pn(ae) ? function(me) {
            return jc(me, ae.length === 1 ? ae[0] : ae);
          } : ae;
        }) : C = [xo];
        var H = -1;
        C = br(C, zo(Ut()));
        var J = GP(g, function(ae, me, xe) {
          var Te = br(C, function(Ge) {
            return Ge(ae);
          });
          return { criteria: Te, index: ++H, value: ae };
        });
        return Yie(J, function(ae, me) {
          return $ae(ae, me, T);
        });
      }
      function wae(g, C) {
        return JP(g, C, function(T, H) {
          return mS(g, H);
        });
      }
      function JP(g, C, T) {
        for (var H = -1, J = C.length, ae = {}; ++H < J; ) {
          var me = C[H], xe = jc(g, me);
          T(xe, me) && gg(ae, Ol(me, g), xe);
        }
        return ae;
      }
      function Eae(g) {
        return function(C) {
          return jc(C, g);
        };
      }
      function jE(g, C, T, H) {
        var J = H ? Wo : Gi, ae = -1, me = C.length, xe = g;
        for (g === C && (C = vo(C)), T && (xe = br(g, zo(T))); ++ae < me; )
          for (var Te = 0, Ge = C[ae], Ue = T ? T(Ge) : Ge; (Te = J(xe, Ue, Te, H)) > -1; )
            xe !== g && u1.call(xe, Te, 1), u1.call(g, Te, 1);
        return g;
      }
      function KP(g, C) {
        for (var T = g ? C.length : 0, H = T - 1; T--; ) {
          var J = C[T];
          if (T == H || J !== ae) {
            var ae = J;
            Nu(J) ? u1.call(g, J, 1) : XE(g, J);
          }
        }
        return g;
      }
      function zE(g, C) {
        return g + d1(NP() * (C - g + 1));
      }
      function Sae(g, C, T, H) {
        for (var J = -1, ae = bi(c1((C - g) / (T || 1)), 0), me = De(ae); ae--; )
          me[H ? ae : ++J] = g, g += T;
        return me;
      }
      function GE(g, C) {
        var T = "";
        if (!g || C < 1 || C > B)
          return T;
        do
          C % 2 && (T += g), C = d1(C / 2), C && (g += g);
        while (C);
        return T;
      }
      function In(g, C) {
        return uS(AN(g, C, xo), g + "");
      }
      function Iae(g) {
        return $P(Nf(g));
      }
      function _ae(g, C) {
        var T = Nf(g);
        return T1(T, Wc(C, 0, T.length));
      }
      function gg(g, C, T, H) {
        if (!Wr(g))
          return g;
        C = Ol(C, g);
        for (var J = -1, ae = C.length, me = ae - 1, xe = g; xe != null && ++J < ae; ) {
          var Te = Us(C[J]), Ge = T;
          if (Te === "__proto__" || Te === "constructor" || Te === "prototype")
            return g;
          if (J != me) {
            var Ue = xe[Te];
            Ge = H ? H(Ue, Te, xe) : n, Ge === n && (Ge = Wr(Ue) ? Ue : Nu(C[J + 1]) ? [] : {});
          }
          dg(xe, Te, Ge), xe = xe[Te];
        }
        return g;
      }
      var qP = f1 ? function(g, C) {
        return f1.set(g, C), g;
      } : xo, Aae = l1 ? function(g, C) {
        return l1(g, "toString", {
          configurable: !0,
          enumerable: !1,
          value: bS(C),
          writable: !0
        });
      } : xo;
      function Tae(g) {
        return T1(Nf(g));
      }
      function Ta(g, C, T) {
        var H = -1, J = g.length;
        C < 0 && (C = -C > J ? 0 : J + C), T = T > J ? J : T, T < 0 && (T += J), J = C > T ? 0 : T - C >>> 0, C >>>= 0;
        for (var ae = De(J); ++H < J; )
          ae[H] = g[H + C];
        return ae;
      }
      function Oae(g, C) {
        var T;
        return Al(g, function(H, J, ae) {
          return T = C(H, J, ae), !T;
        }), !!T;
      }
      function y1(g, C, T) {
        var H = 0, J = g == null ? H : g.length;
        if (typeof C == "number" && C === C && J <= W) {
          for (; H < J; ) {
            var ae = H + J >>> 1, me = g[ae];
            me !== null && !Uo(me) && (T ? me <= C : me < C) ? H = ae + 1 : J = ae;
          }
          return J;
        }
        return UE(g, C, xo, T);
      }
      function UE(g, C, T, H) {
        var J = 0, ae = g == null ? 0 : g.length;
        if (ae === 0)
          return 0;
        C = T(C);
        for (var me = C !== C, xe = C === null, Te = Uo(C), Ge = C === n; J < ae; ) {
          var Ue = d1((J + ae) / 2), Qe = T(g[Ue]), xt = Qe !== n, Ft = Qe === null, Zt = Qe === Qe, yn = Uo(Qe);
          if (me)
            var Jt = H || Zt;
          else
            Ge ? Jt = Zt && (H || xt) : xe ? Jt = Zt && xt && (H || !Ft) : Te ? Jt = Zt && xt && !Ft && (H || !yn) : Ft || yn ? Jt = !1 : Jt = H ? Qe <= C : Qe < C;
          Jt ? J = Ue + 1 : ae = Ue;
        }
        return Ui(ae, K);
      }
      function QP(g, C) {
        for (var T = -1, H = g.length, J = 0, ae = []; ++T < H; ) {
          var me = g[T], xe = C ? C(me) : me;
          if (!T || !os(xe, Te)) {
            var Te = xe;
            ae[J++] = me === 0 ? 0 : me;
          }
        }
        return ae;
      }
      function eN(g) {
        return typeof g == "number" ? g : Uo(g) ? L : +g;
      }
      function Go(g) {
        if (typeof g == "string")
          return g;
        if (pn(g))
          return br(g, Go) + "";
        if (Uo(g))
          return kP ? kP.call(g) : "";
        var C = g + "";
        return C == "0" && 1 / g == -M ? "-0" : C;
      }
      function Tl(g, C, T) {
        var H = -1, J = Lc, ae = g.length, me = !0, xe = [], Te = xe;
        if (T)
          me = !1, J = yf;
        else if (ae >= i) {
          var Ge = C ? null : Bae(g);
          if (Ge)
            return e1(Ge);
          me = !1, J = og, Te = new Hc();
        } else
          Te = C ? [] : xe;
        e:
          for (; ++H < ae; ) {
            var Ue = g[H], Qe = C ? C(Ue) : Ue;
            if (Ue = T || Ue !== 0 ? Ue : 0, me && Qe === Qe) {
              for (var xt = Te.length; xt--; )
                if (Te[xt] === Qe)
                  continue e;
              C && Te.push(Qe), xe.push(Ue);
            } else
              J(Te, Qe, T) || (Te !== xe && Te.push(Qe), xe.push(Ue));
          }
        return xe;
      }
      function XE(g, C) {
        return C = Ol(C, g), g = TN(g, C), g == null || delete g[Us(Oa(C))];
      }
      function tN(g, C, T, H) {
        return gg(g, C, T(jc(g, C)), H);
      }
      function x1(g, C, T, H) {
        for (var J = g.length, ae = H ? J : -1; (H ? ae-- : ++ae < J) && C(g[ae], ae, g); )
          ;
        return T ? Ta(g, H ? 0 : ae, H ? ae + 1 : J) : Ta(g, H ? ae + 1 : 0, H ? J : ae);
      }
      function nN(g, C) {
        var T = g;
        return T instanceof Nn && (T = T.value()), ig(C, function(H, J) {
          return J.func.apply(J.thisArg, wa([H], J.args));
        }, T);
      }
      function YE(g, C, T) {
        var H = g.length;
        if (H < 2)
          return H ? Tl(g[0]) : [];
        for (var J = -1, ae = De(H); ++J < H; )
          for (var me = g[J], xe = -1; ++xe < H; )
            xe != J && (ae[J] = fg(ae[J] || me, g[xe], C, T));
        return Tl(Ri(ae, 1), C, T);
      }
      function rN(g, C, T) {
        for (var H = -1, J = g.length, ae = C.length, me = {}; ++H < J; ) {
          var xe = H < ae ? C[H] : n;
          T(me, g[H], xe);
        }
        return me;
      }
      function ZE(g) {
        return ei(g) ? g : [];
      }
      function JE(g) {
        return typeof g == "function" ? g : xo;
      }
      function Ol(g, C) {
        return pn(g) ? g : oS(g, C) ? [g] : kN(er(g));
      }
      var Pae = In;
      function Pl(g, C, T) {
        var H = g.length;
        return T = T === n ? H : T, !C && T >= H ? g : Ta(g, C, T);
      }
      var iN = voe || function(g) {
        return gi.clearTimeout(g);
      };
      function oN(g, C) {
        if (C)
          return g.slice();
        var T = g.length, H = _P ? _P(T) : new g.constructor(T);
        return g.copy(H), H;
      }
      function KE(g) {
        var C = new g.constructor(g.byteLength);
        return new a1(C).set(new a1(g)), C;
      }
      function Nae(g, C) {
        var T = C ? KE(g.buffer) : g.buffer;
        return new g.constructor(T, g.byteOffset, g.byteLength);
      }
      function kae(g) {
        var C = new g.constructor(g.source, qe.exec(g));
        return C.lastIndex = g.lastIndex, C;
      }
      function Rae(g) {
        return cg ? Ir(cg.call(g)) : {};
      }
      function aN(g, C) {
        var T = C ? KE(g.buffer) : g.buffer;
        return new g.constructor(T, g.byteOffset, g.length);
      }
      function sN(g, C) {
        if (g !== C) {
          var T = g !== n, H = g === null, J = g === g, ae = Uo(g), me = C !== n, xe = C === null, Te = C === C, Ge = Uo(C);
          if (!xe && !Ge && !ae && g > C || ae && me && Te && !xe && !Ge || H && me && Te || !T && Te || !J)
            return 1;
          if (!H && !ae && !Ge && g < C || Ge && T && J && !H && !ae || xe && T && J || !me && J || !Te)
            return -1;
        }
        return 0;
      }
      function $ae(g, C, T) {
        for (var H = -1, J = g.criteria, ae = C.criteria, me = J.length, xe = T.length; ++H < me; ) {
          var Te = sN(J[H], ae[H]);
          if (Te) {
            if (H >= xe)
              return Te;
            var Ge = T[H];
            return Te * (Ge == "desc" ? -1 : 1);
          }
        }
        return g.index - C.index;
      }
      function uN(g, C, T, H) {
        for (var J = -1, ae = g.length, me = T.length, xe = -1, Te = C.length, Ge = bi(ae - me, 0), Ue = De(Te + Ge), Qe = !H; ++xe < Te; )
          Ue[xe] = C[xe];
        for (; ++J < me; )
          (Qe || J < ae) && (Ue[T[J]] = g[J]);
        for (; Ge--; )
          Ue[xe++] = g[J++];
        return Ue;
      }
      function lN(g, C, T, H) {
        for (var J = -1, ae = g.length, me = -1, xe = T.length, Te = -1, Ge = C.length, Ue = bi(ae - xe, 0), Qe = De(Ue + Ge), xt = !H; ++J < Ue; )
          Qe[J] = g[J];
        for (var Ft = J; ++Te < Ge; )
          Qe[Ft + Te] = C[Te];
        for (; ++me < xe; )
          (xt || J < ae) && (Qe[Ft + T[me]] = g[J++]);
        return Qe;
      }
      function vo(g, C) {
        var T = -1, H = g.length;
        for (C || (C = De(H)); ++T < H; )
          C[T] = g[T];
        return C;
      }
      function Gs(g, C, T, H) {
        var J = !T;
        T || (T = {});
        for (var ae = -1, me = C.length; ++ae < me; ) {
          var xe = C[ae], Te = H ? H(T[xe], g[xe], xe, T, g) : n;
          Te === n && (Te = g[xe]), J ? Tu(T, xe, Te) : dg(T, xe, Te);
        }
        return T;
      }
      function Dae(g, C) {
        return Gs(g, iS(g), C);
      }
      function Mae(g, C) {
        return Gs(g, wN(g), C);
      }
      function C1(g, C) {
        return function(T, H) {
          var J = pn(T) ? EE : iae, ae = C ? C() : {};
          return J(T, g, Ut(H, 2), ae);
        };
      }
      function Af(g) {
        return In(function(C, T) {
          var H = -1, J = T.length, ae = J > 1 ? T[J - 1] : n, me = J > 2 ? T[2] : n;
          for (ae = g.length > 3 && typeof ae == "function" ? (J--, ae) : n, me && eo(T[0], T[1], me) && (ae = J < 3 ? n : ae, J = 1), C = Ir(C); ++H < J; ) {
            var xe = T[H];
            xe && g(C, xe, H, ae);
          }
          return C;
        });
      }
      function cN(g, C) {
        return function(T, H) {
          if (T == null)
            return T;
          if (!bo(T))
            return g(T, H);
          for (var J = T.length, ae = C ? J : -1, me = Ir(T); (C ? ae-- : ++ae < J) && H(me[ae], ae, me) !== !1; )
            ;
          return T;
        };
      }
      function dN(g) {
        return function(C, T, H) {
          for (var J = -1, ae = Ir(C), me = H(C), xe = me.length; xe--; ) {
            var Te = me[g ? xe : ++J];
            if (T(ae[Te], Te, ae) === !1)
              break;
          }
          return C;
        };
      }
      function Fae(g, C, T) {
        var H = C & m, J = mg(g);
        function ae() {
          var me = this && this !== gi && this instanceof ae ? J : g;
          return me.apply(H ? T : this, arguments);
        }
        return ae;
      }
      function fN(g) {
        return function(C) {
          C = er(C);
          var T = xf(C) ? rs(C) : n, H = T ? T[0] : C.charAt(0), J = T ? Pl(T, 1).join("") : C.slice(1);
          return H[g]() + J;
        };
      }
      function Tf(g) {
        return function(C) {
          return ig(c7(l7(C).replace(eg, "")), g, "");
        };
      }
      function mg(g) {
        return function() {
          var C = arguments;
          switch (C.length) {
            case 0:
              return new g();
            case 1:
              return new g(C[0]);
            case 2:
              return new g(C[0], C[1]);
            case 3:
              return new g(C[0], C[1], C[2]);
            case 4:
              return new g(C[0], C[1], C[2], C[3]);
            case 5:
              return new g(C[0], C[1], C[2], C[3], C[4]);
            case 6:
              return new g(C[0], C[1], C[2], C[3], C[4], C[5]);
            case 7:
              return new g(C[0], C[1], C[2], C[3], C[4], C[5], C[6]);
          }
          var T = _f(g.prototype), H = g.apply(T, C);
          return Wr(H) ? H : T;
        };
      }
      function Lae(g, C, T) {
        var H = mg(g);
        function J() {
          for (var ae = arguments.length, me = De(ae), xe = ae, Te = Of(J); xe--; )
            me[xe] = arguments[xe];
          var Ge = ae < 3 && me[0] !== Te && me[ae - 1] !== Te ? [] : Il(me, Te);
          if (ae -= Ge.length, ae < T)
            return vN(
              g,
              C,
              w1,
              J.placeholder,
              n,
              me,
              Ge,
              n,
              n,
              T - ae
            );
          var Ue = this && this !== gi && this instanceof J ? H : g;
          return zi(Ue, this, me);
        }
        return J;
      }
      function hN(g) {
        return function(C, T, H) {
          var J = Ir(C);
          if (!bo(C)) {
            var ae = Ut(T, 3);
            C = Si(C), T = function(xe) {
              return ae(J[xe], xe, J);
            };
          }
          var me = g(C, T, H);
          return me > -1 ? J[ae ? C[me] : me] : n;
        };
      }
      function pN(g) {
        return Pu(function(C) {
          var T = C.length, H = T, J = _a.prototype.thru;
          for (g && C.reverse(); H--; ) {
            var ae = C[H];
            if (typeof ae != "function")
              throw new Ia(a);
            if (J && !me && _1(ae) == "wrapper")
              var me = new _a([], !0);
          }
          for (H = me ? H : T; ++H < T; ) {
            ae = C[H];
            var xe = _1(ae), Te = xe == "wrapper" ? nS(ae) : n;
            Te && aS(Te[0]) && Te[1] == (_ | w | E | A) && !Te[4].length && Te[9] == 1 ? me = me[_1(Te[0])].apply(me, Te[3]) : me = ae.length == 1 && aS(ae) ? me[xe]() : me.thru(ae);
          }
          return function() {
            var Ge = arguments, Ue = Ge[0];
            if (me && Ge.length == 1 && pn(Ue))
              return me.plant(Ue).value();
            for (var Qe = 0, xt = T ? C[Qe].apply(this, Ge) : Ue; ++Qe < T; )
              xt = C[Qe].call(this, xt);
            return xt;
          };
        });
      }
      function w1(g, C, T, H, J, ae, me, xe, Te, Ge) {
        var Ue = C & _, Qe = C & m, xt = C & b, Ft = C & (w | S), Zt = C & P, yn = xt ? n : mg(g);
        function Jt() {
          for (var Tn = arguments.length, Fn = De(Tn), Xo = Tn; Xo--; )
            Fn[Xo] = arguments[Xo];
          if (Ft)
            var to = Of(Jt), Yo = Jie(Fn, to);
          if (H && (Fn = uN(Fn, H, J, Ft)), ae && (Fn = lN(Fn, ae, me, Ft)), Tn -= Yo, Ft && Tn < Ge) {
            var ti = Il(Fn, to);
            return vN(
              g,
              C,
              w1,
              Jt.placeholder,
              T,
              Fn,
              ti,
              xe,
              Te,
              Ge - Tn
            );
          }
          var as = Qe ? T : this, $u = xt ? as[g] : g;
          return Tn = Fn.length, xe ? Fn = ise(Fn, xe) : Zt && Tn > 1 && Fn.reverse(), Ue && Te < Tn && (Fn.length = Te), this && this !== gi && this instanceof Jt && ($u = yn || mg($u)), $u.apply(as, Fn);
        }
        return Jt;
      }
      function gN(g, C) {
        return function(T, H) {
          return fae(T, g, C(H), {});
        };
      }
      function E1(g, C) {
        return function(T, H) {
          var J;
          if (T === n && H === n)
            return C;
          if (T !== n && (J = T), H !== n) {
            if (J === n)
              return H;
            typeof T == "string" || typeof H == "string" ? (T = Go(T), H = Go(H)) : (T = eN(T), H = eN(H)), J = g(T, H);
          }
          return J;
        };
      }
      function qE(g) {
        return Pu(function(C) {
          return C = br(C, zo(Ut())), In(function(T) {
            var H = this;
            return g(C, function(J) {
              return zi(J, H, T);
            });
          });
        });
      }
      function S1(g, C) {
        C = C === n ? " " : Go(C);
        var T = C.length;
        if (T < 2)
          return T ? GE(C, g) : C;
        var H = GE(C, c1(g / Cf(C)));
        return xf(C) ? Pl(rs(H), 0, g).join("") : H.slice(0, g);
      }
      function Vae(g, C, T, H) {
        var J = C & m, ae = mg(g);
        function me() {
          for (var xe = -1, Te = arguments.length, Ge = -1, Ue = H.length, Qe = De(Ue + Te), xt = this && this !== gi && this instanceof me ? ae : g; ++Ge < Ue; )
            Qe[Ge] = H[Ge];
          for (; Te--; )
            Qe[Ge++] = arguments[++xe];
          return zi(xt, J ? T : this, Qe);
        }
        return me;
      }
      function mN(g) {
        return function(C, T, H) {
          return H && typeof H != "number" && eo(C, T, H) && (T = H = n), C = Ru(C), T === n ? (T = C, C = 0) : T = Ru(T), H = H === n ? C < T ? 1 : -1 : Ru(H), Sae(C, T, H, g);
        };
      }
      function I1(g) {
        return function(C, T) {
          return typeof C == "string" && typeof T == "string" || (C = Pa(C), T = Pa(T)), g(C, T);
        };
      }
      function vN(g, C, T, H, J, ae, me, xe, Te, Ge) {
        var Ue = C & w, Qe = Ue ? me : n, xt = Ue ? n : me, Ft = Ue ? ae : n, Zt = Ue ? n : ae;
        C |= Ue ? E : I, C &= ~(Ue ? I : E), C & y || (C &= ~(m | b));
        var yn = [
          g,
          C,
          J,
          Ft,
          Qe,
          Zt,
          xt,
          xe,
          Te,
          Ge
        ], Jt = T.apply(n, yn);
        return aS(g) && ON(Jt, yn), Jt.placeholder = H, PN(Jt, g, C);
      }
      function QE(g) {
        var C = mi[g];
        return function(T, H) {
          if (T = Pa(T), H = H == null ? 0 : Ui(vn(H), 292), H && PP(T)) {
            var J = (er(T) + "e").split("e"), ae = C(J[0] + "e" + (+J[1] + H));
            return J = (er(ae) + "e").split("e"), +(J[0] + "e" + (+J[1] - H));
          }
          return C(T);
        };
      }
      var Bae = Sf && 1 / e1(new Sf([, -0]))[1] == M ? function(g) {
        return new Sf(g);
      } : CS;
      function bN(g) {
        return function(C) {
          var T = Xi(C);
          return T == he ? OE(C) : T == pe ? roe(C) : Zie(C, g(C));
        };
      }
      function Ou(g, C, T, H, J, ae, me, xe) {
        var Te = C & b;
        if (!Te && typeof g != "function")
          throw new Ia(a);
        var Ge = H ? H.length : 0;
        if (Ge || (C &= ~(E | I), H = J = n), me = me === n ? me : bi(vn(me), 0), xe = xe === n ? xe : vn(xe), Ge -= J ? J.length : 0, C & I) {
          var Ue = H, Qe = J;
          H = J = n;
        }
        var xt = Te ? n : nS(g), Ft = [
          g,
          C,
          T,
          H,
          J,
          Ue,
          Qe,
          ae,
          me,
          xe
        ];
        if (xt && tse(Ft, xt), g = Ft[0], C = Ft[1], T = Ft[2], H = Ft[3], J = Ft[4], xe = Ft[9] = Ft[9] === n ? Te ? 0 : g.length : bi(Ft[9] - Ge, 0), !xe && C & (w | S) && (C &= ~(w | S)), !C || C == m)
          var Zt = Fae(g, C, T);
        else
          C == w || C == S ? Zt = Lae(g, C, xe) : (C == E || C == (m | E)) && !J.length ? Zt = Vae(g, C, T, H) : Zt = w1.apply(n, Ft);
        var yn = xt ? qP : ON;
        return PN(yn(Zt, Ft), g, C);
      }
      function yN(g, C, T, H) {
        return g === n || os(g, Ef[T]) && !cr.call(H, T) ? C : g;
      }
      function xN(g, C, T, H, J, ae) {
        return Wr(g) && Wr(C) && (ae.set(C, g), b1(g, C, n, xN, ae), ae.delete(C)), g;
      }
      function Hae(g) {
        return yg(g) ? n : g;
      }
      function CN(g, C, T, H, J, ae) {
        var me = T & p, xe = g.length, Te = C.length;
        if (xe != Te && !(me && Te > xe))
          return !1;
        var Ge = ae.get(g), Ue = ae.get(C);
        if (Ge && Ue)
          return Ge == C && Ue == g;
        var Qe = -1, xt = !0, Ft = T & v ? new Hc() : n;
        for (ae.set(g, C), ae.set(C, g); ++Qe < xe; ) {
          var Zt = g[Qe], yn = C[Qe];
          if (H)
            var Jt = me ? H(yn, Zt, Qe, C, g, ae) : H(Zt, yn, Qe, g, C, ae);
          if (Jt !== n) {
            if (Jt)
              continue;
            xt = !1;
            break;
          }
          if (Ft) {
            if (!sn(C, function(Tn, Fn) {
              if (!og(Ft, Fn) && (Zt === Tn || J(Zt, Tn, T, H, ae)))
                return Ft.push(Fn);
            })) {
              xt = !1;
              break;
            }
          } else if (!(Zt === yn || J(Zt, yn, T, H, ae))) {
            xt = !1;
            break;
          }
        }
        return ae.delete(g), ae.delete(C), xt;
      }
      function Wae(g, C, T, H, J, ae, me) {
        switch (T) {
          case q:
            if (g.byteLength != C.byteLength || g.byteOffset != C.byteOffset)
              return !1;
            g = g.buffer, C = C.buffer;
          case Ie:
            return !(g.byteLength != C.byteLength || !ae(new a1(g), new a1(C)));
          case ee:
          case ie:
          case fe:
            return os(+g, +C);
          case se:
            return g.name == C.name && g.message == C.message;
          case ne:
          case ye:
            return g == C + "";
          case he:
            var xe = OE;
          case pe:
            var Te = H & p;
            if (xe || (xe = e1), g.size != C.size && !Te)
              return !1;
            var Ge = me.get(g);
            if (Ge)
              return Ge == C;
            H |= v, me.set(g, C);
            var Ue = CN(xe(g), xe(C), H, J, ae, me);
            return me.delete(g), Ue;
          case Ae:
            if (cg)
              return cg.call(g) == cg.call(C);
        }
        return !1;
      }
      function jae(g, C, T, H, J, ae) {
        var me = T & p, xe = eS(g), Te = xe.length, Ge = eS(C), Ue = Ge.length;
        if (Te != Ue && !me)
          return !1;
        for (var Qe = Te; Qe--; ) {
          var xt = xe[Qe];
          if (!(me ? xt in C : cr.call(C, xt)))
            return !1;
        }
        var Ft = ae.get(g), Zt = ae.get(C);
        if (Ft && Zt)
          return Ft == C && Zt == g;
        var yn = !0;
        ae.set(g, C), ae.set(C, g);
        for (var Jt = me; ++Qe < Te; ) {
          xt = xe[Qe];
          var Tn = g[xt], Fn = C[xt];
          if (H)
            var Xo = me ? H(Fn, Tn, xt, C, g, ae) : H(Tn, Fn, xt, g, C, ae);
          if (!(Xo === n ? Tn === Fn || J(Tn, Fn, T, H, ae) : Xo)) {
            yn = !1;
            break;
          }
          Jt || (Jt = xt == "constructor");
        }
        if (yn && !Jt) {
          var to = g.constructor, Yo = C.constructor;
          to != Yo && "constructor" in g && "constructor" in C && !(typeof to == "function" && to instanceof to && typeof Yo == "function" && Yo instanceof Yo) && (yn = !1);
        }
        return ae.delete(g), ae.delete(C), yn;
      }
      function Pu(g) {
        return uS(AN(g, n, MN), g + "");
      }
      function eS(g) {
        return HP(g, Si, iS);
      }
      function tS(g) {
        return HP(g, yo, wN);
      }
      var nS = f1 ? function(g) {
        return f1.get(g);
      } : CS;
      function _1(g) {
        for (var C = g.name + "", T = If[C], H = cr.call(If, C) ? T.length : 0; H--; ) {
          var J = T[H], ae = J.func;
          if (ae == null || ae == g)
            return J.name;
        }
        return C;
      }
      function Of(g) {
        var C = cr.call(re, "placeholder") ? re : g;
        return C.placeholder;
      }
      function Ut() {
        var g = re.iteratee || yS;
        return g = g === yS ? zP : g, arguments.length ? g(arguments[0], arguments[1]) : g;
      }
      function A1(g, C) {
        var T = g.__data__;
        return Kae(C) ? T[typeof C == "string" ? "string" : "hash"] : T.map;
      }
      function rS(g) {
        for (var C = Si(g), T = C.length; T--; ) {
          var H = C[T], J = g[H];
          C[T] = [H, J, IN(J)];
        }
        return C;
      }
      function zc(g, C) {
        var T = eoe(g, C);
        return jP(T) ? T : n;
      }
      function zae(g) {
        var C = cr.call(g, Vc), T = g[Vc];
        try {
          g[Vc] = n;
          var H = !0;
        } catch {
        }
        var J = i1.call(g);
        return H && (C ? g[Vc] = T : delete g[Vc]), J;
      }
      var iS = NE ? function(g) {
        return g == null ? [] : (g = Ir(g), ns(NE(g), function(C) {
          return TP.call(g, C);
        }));
      } : wS, wN = NE ? function(g) {
        for (var C = []; g; )
          wa(C, iS(g)), g = s1(g);
        return C;
      } : wS, Xi = Qi;
      (kE && Xi(new kE(new ArrayBuffer(1))) != q || sg && Xi(new sg()) != he || RE && Xi(RE.resolve()) != ze || Sf && Xi(new Sf()) != pe || ug && Xi(new ug()) != ce) && (Xi = function(g) {
        var C = Qi(g), T = C == Ne ? g.constructor : n, H = T ? Gc(T) : "";
        if (H)
          switch (H) {
            case _oe:
              return q;
            case Aoe:
              return he;
            case Toe:
              return ze;
            case Ooe:
              return pe;
            case Poe:
              return ce;
          }
        return C;
      });
      function Gae(g, C, T) {
        for (var H = -1, J = T.length; ++H < J; ) {
          var ae = T[H], me = ae.size;
          switch (ae.type) {
            case "drop":
              g += me;
              break;
            case "dropRight":
              C -= me;
              break;
            case "take":
              C = Ui(C, g + me);
              break;
            case "takeRight":
              g = bi(g, C - me);
              break;
          }
        }
        return { start: g, end: C };
      }
      function Uae(g) {
        var C = g.match(Nt);
        return C ? C[1].split(ue) : [];
      }
      function EN(g, C, T) {
        C = Ol(C, g);
        for (var H = -1, J = C.length, ae = !1; ++H < J; ) {
          var me = Us(C[H]);
          if (!(ae = g != null && T(g, me)))
            break;
          g = g[me];
        }
        return ae || ++H != J ? ae : (J = g == null ? 0 : g.length, !!J && $1(J) && Nu(me, J) && (pn(g) || Uc(g)));
      }
      function Xae(g) {
        var C = g.length, T = new g.constructor(C);
        return C && typeof g[0] == "string" && cr.call(g, "index") && (T.index = g.index, T.input = g.input), T;
      }
      function SN(g) {
        return typeof g.constructor == "function" && !vg(g) ? _f(s1(g)) : {};
      }
      function Yae(g, C, T) {
        var H = g.constructor;
        switch (C) {
          case Ie:
            return KE(g);
          case ee:
          case ie:
            return new H(+g);
          case q:
            return Nae(g, T);
          case Fe:
          case Ze:
          case at:
          case Je:
          case ut:
          case Ct:
          case Ke:
          case st:
          case wt:
            return aN(g, T);
          case he:
            return new H();
          case fe:
          case ye:
            return new H(g);
          case ne:
            return kae(g);
          case pe:
            return new H();
          case Ae:
            return Rae(g);
        }
      }
      function Zae(g, C) {
        var T = C.length;
        if (!T)
          return g;
        var H = T - 1;
        return C[H] = (T > 1 ? "& " : "") + C[H], C = C.join(T > 2 ? ", " : " "), g.replace(nn, `{
/* [wrapped with ` + C + `] */
`);
      }
      function Jae(g) {
        return pn(g) || Uc(g) || !!(OP && g && g[OP]);
      }
      function Nu(g, C) {
        var T = typeof g;
        return C = C ?? B, !!C && (T == "number" || T != "symbol" && Rt.test(g)) && g > -1 && g % 1 == 0 && g < C;
      }
      function eo(g, C, T) {
        if (!Wr(T))
          return !1;
        var H = typeof C;
        return (H == "number" ? bo(T) && Nu(C, T.length) : H == "string" && C in T) ? os(T[C], g) : !1;
      }
      function oS(g, C) {
        if (pn(g))
          return !1;
        var T = typeof g;
        return T == "number" || T == "symbol" || T == "boolean" || g == null || Uo(g) ? !0 : ot.test(g) || !tt.test(g) || C != null && g in Ir(C);
      }
      function Kae(g) {
        var C = typeof g;
        return C == "string" || C == "number" || C == "symbol" || C == "boolean" ? g !== "__proto__" : g === null;
      }
      function aS(g) {
        var C = _1(g), T = re[C];
        if (typeof T != "function" || !(C in Nn.prototype))
          return !1;
        if (g === T)
          return !0;
        var H = nS(T);
        return !!H && g === H[0];
      }
      function qae(g) {
        return !!IP && IP in g;
      }
      var Qae = n1 ? ku : ES;
      function vg(g) {
        var C = g && g.constructor, T = typeof C == "function" && C.prototype || Ef;
        return g === T;
      }
      function IN(g) {
        return g === g && !Wr(g);
      }
      function _N(g, C) {
        return function(T) {
          return T == null ? !1 : T[g] === C && (C !== n || g in Ir(T));
        };
      }
      function ese(g) {
        var C = k1(g, function(H) {
          return T.size === l && T.clear(), H;
        }), T = C.cache;
        return C;
      }
      function tse(g, C) {
        var T = g[1], H = C[1], J = T | H, ae = J < (m | b | _), me = H == _ && T == w || H == _ && T == A && g[7].length <= C[8] || H == (_ | A) && C[7].length <= C[8] && T == w;
        if (!(ae || me))
          return g;
        H & m && (g[2] = C[2], J |= T & m ? 0 : y);
        var xe = C[3];
        if (xe) {
          var Te = g[3];
          g[3] = Te ? uN(Te, xe, C[4]) : xe, g[4] = Te ? Il(g[3], c) : C[4];
        }
        return xe = C[5], xe && (Te = g[5], g[5] = Te ? lN(Te, xe, C[6]) : xe, g[6] = Te ? Il(g[5], c) : C[6]), xe = C[7], xe && (g[7] = xe), H & _ && (g[8] = g[8] == null ? C[8] : Ui(g[8], C[8])), g[9] == null && (g[9] = C[9]), g[0] = C[0], g[1] = J, g;
      }
      function nse(g) {
        var C = [];
        if (g != null)
          for (var T in Ir(g))
            C.push(T);
        return C;
      }
      function rse(g) {
        return i1.call(g);
      }
      function AN(g, C, T) {
        return C = bi(C === n ? g.length - 1 : C, 0), function() {
          for (var H = arguments, J = -1, ae = bi(H.length - C, 0), me = De(ae); ++J < ae; )
            me[J] = H[C + J];
          J = -1;
          for (var xe = De(C + 1); ++J < C; )
            xe[J] = H[J];
          return xe[C] = T(me), zi(g, this, xe);
        };
      }
      function TN(g, C) {
        return C.length < 2 ? g : jc(g, Ta(C, 0, -1));
      }
      function ise(g, C) {
        for (var T = g.length, H = Ui(C.length, T), J = vo(g); H--; ) {
          var ae = C[H];
          g[H] = Nu(ae, T) ? J[ae] : n;
        }
        return g;
      }
      function sS(g, C) {
        if (!(C === "constructor" && typeof g[C] == "function") && C != "__proto__")
          return g[C];
      }
      var ON = NN(qP), bg = yoe || function(g, C) {
        return gi.setTimeout(g, C);
      }, uS = NN(Aae);
      function PN(g, C, T) {
        var H = C + "";
        return uS(g, Zae(H, ose(Uae(H), T)));
      }
      function NN(g) {
        var C = 0, T = 0;
        return function() {
          var H = Eoe(), J = R - (H - T);
          if (T = H, J > 0) {
            if (++C >= D)
              return arguments[0];
          } else
            C = 0;
          return g.apply(n, arguments);
        };
      }
      function T1(g, C) {
        var T = -1, H = g.length, J = H - 1;
        for (C = C === n ? H : C; ++T < C; ) {
          var ae = zE(T, J), me = g[ae];
          g[ae] = g[T], g[T] = me;
        }
        return g.length = C, g;
      }
      var kN = ese(function(g) {
        var C = [];
        return g.charCodeAt(0) === 46 && C.push(""), g.replace(lt, function(T, H, J, ae) {
          C.push(J ? ae.replace(At, "$1") : H || T);
        }), C;
      });
      function Us(g) {
        if (typeof g == "string" || Uo(g))
          return g;
        var C = g + "";
        return C == "0" && 1 / g == -M ? "-0" : C;
      }
      function Gc(g) {
        if (g != null) {
          try {
            return r1.call(g);
          } catch {
          }
          try {
            return g + "";
          } catch {
          }
        }
        return "";
      }
      function ose(g, C) {
        return mo(Y, function(T) {
          var H = "_." + T[0];
          C & T[1] && !Lc(g, H) && g.push(H);
        }), g.sort();
      }
      function RN(g) {
        if (g instanceof Nn)
          return g.clone();
        var C = new _a(g.__wrapped__, g.__chain__);
        return C.__actions__ = vo(g.__actions__), C.__index__ = g.__index__, C.__values__ = g.__values__, C;
      }
      function ase(g, C, T) {
        (T ? eo(g, C, T) : C === n) ? C = 1 : C = bi(vn(C), 0);
        var H = g == null ? 0 : g.length;
        if (!H || C < 1)
          return [];
        for (var J = 0, ae = 0, me = De(c1(H / C)); J < H; )
          me[ae++] = Ta(g, J, J += C);
        return me;
      }
      function sse(g) {
        for (var C = -1, T = g == null ? 0 : g.length, H = 0, J = []; ++C < T; ) {
          var ae = g[C];
          ae && (J[H++] = ae);
        }
        return J;
      }
      function use() {
        var g = arguments.length;
        if (!g)
          return [];
        for (var C = De(g - 1), T = arguments[0], H = g; H--; )
          C[H - 1] = arguments[H];
        return wa(pn(T) ? vo(T) : [T], Ri(C, 1));
      }
      var lse = In(function(g, C) {
        return ei(g) ? fg(g, Ri(C, 1, ei, !0)) : [];
      }), cse = In(function(g, C) {
        var T = Oa(C);
        return ei(T) && (T = n), ei(g) ? fg(g, Ri(C, 1, ei, !0), Ut(T, 2)) : [];
      }), dse = In(function(g, C) {
        var T = Oa(C);
        return ei(T) && (T = n), ei(g) ? fg(g, Ri(C, 1, ei, !0), n, T) : [];
      });
      function fse(g, C, T) {
        var H = g == null ? 0 : g.length;
        return H ? (C = T || C === n ? 1 : vn(C), Ta(g, C < 0 ? 0 : C, H)) : [];
      }
      function hse(g, C, T) {
        var H = g == null ? 0 : g.length;
        return H ? (C = T || C === n ? 1 : vn(C), C = H - C, Ta(g, 0, C < 0 ? 0 : C)) : [];
      }
      function pse(g, C) {
        return g && g.length ? x1(g, Ut(C, 3), !0, !0) : [];
      }
      function gse(g, C) {
        return g && g.length ? x1(g, Ut(C, 3), !0) : [];
      }
      function mse(g, C, T, H) {
        var J = g == null ? 0 : g.length;
        return J ? (T && typeof T != "number" && eo(g, C, T) && (T = 0, H = J), uae(g, C, T, H)) : [];
      }
      function $N(g, C, T) {
        var H = g == null ? 0 : g.length;
        if (!H)
          return -1;
        var J = T == null ? 0 : vn(T);
        return J < 0 && (J = bi(H + J, 0)), Ea(g, Ut(C, 3), J);
      }
      function DN(g, C, T) {
        var H = g == null ? 0 : g.length;
        if (!H)
          return -1;
        var J = H - 1;
        return T !== n && (J = vn(T), J = T < 0 ? bi(H + J, 0) : Ui(J, H - 1)), Ea(g, Ut(C, 3), J, !0);
      }
      function MN(g) {
        var C = g == null ? 0 : g.length;
        return C ? Ri(g, 1) : [];
      }
      function vse(g) {
        var C = g == null ? 0 : g.length;
        return C ? Ri(g, M) : [];
      }
      function bse(g, C) {
        var T = g == null ? 0 : g.length;
        return T ? (C = C === n ? 1 : vn(C), Ri(g, C)) : [];
      }
      function yse(g) {
        for (var C = -1, T = g == null ? 0 : g.length, H = {}; ++C < T; ) {
          var J = g[C];
          H[J[0]] = J[1];
        }
        return H;
      }
      function FN(g) {
        return g && g.length ? g[0] : n;
      }
      function xse(g, C, T) {
        var H = g == null ? 0 : g.length;
        if (!H)
          return -1;
        var J = T == null ? 0 : vn(T);
        return J < 0 && (J = bi(H + J, 0)), Gi(g, C, J);
      }
      function Cse(g) {
        var C = g == null ? 0 : g.length;
        return C ? Ta(g, 0, -1) : [];
      }
      var wse = In(function(g) {
        var C = br(g, ZE);
        return C.length && C[0] === g[0] ? VE(C) : [];
      }), Ese = In(function(g) {
        var C = Oa(g), T = br(g, ZE);
        return C === Oa(T) ? C = n : T.pop(), T.length && T[0] === g[0] ? VE(T, Ut(C, 2)) : [];
      }), Sse = In(function(g) {
        var C = Oa(g), T = br(g, ZE);
        return C = typeof C == "function" ? C : n, C && T.pop(), T.length && T[0] === g[0] ? VE(T, n, C) : [];
      });
      function Ise(g, C) {
        return g == null ? "" : Coe.call(g, C);
      }
      function Oa(g) {
        var C = g == null ? 0 : g.length;
        return C ? g[C - 1] : n;
      }
      function _se(g, C, T) {
        var H = g == null ? 0 : g.length;
        if (!H)
          return -1;
        var J = H;
        return T !== n && (J = vn(T), J = J < 0 ? bi(H + J, 0) : Ui(J, H - 1)), C === C ? ooe(g, C, J) : Ea(g, jo, J, !0);
      }
      function Ase(g, C) {
        return g && g.length ? YP(g, vn(C)) : n;
      }
      var Tse = In(LN);
      function LN(g, C) {
        return g && g.length && C && C.length ? jE(g, C) : g;
      }
      function Ose(g, C, T) {
        return g && g.length && C && C.length ? jE(g, C, Ut(T, 2)) : g;
      }
      function Pse(g, C, T) {
        return g && g.length && C && C.length ? jE(g, C, n, T) : g;
      }
      var Nse = Pu(function(g, C) {
        var T = g == null ? 0 : g.length, H = DE(g, C);
        return KP(g, br(C, function(J) {
          return Nu(J, T) ? +J : J;
        }).sort(sN)), H;
      });
      function kse(g, C) {
        var T = [];
        if (!(g && g.length))
          return T;
        var H = -1, J = [], ae = g.length;
        for (C = Ut(C, 3); ++H < ae; ) {
          var me = g[H];
          C(me, H, g) && (T.push(me), J.push(H));
        }
        return KP(g, J), T;
      }
      function lS(g) {
        return g == null ? g : Ioe.call(g);
      }
      function Rse(g, C, T) {
        var H = g == null ? 0 : g.length;
        return H ? (T && typeof T != "number" && eo(g, C, T) ? (C = 0, T = H) : (C = C == null ? 0 : vn(C), T = T === n ? H : vn(T)), Ta(g, C, T)) : [];
      }
      function $se(g, C) {
        return y1(g, C);
      }
      function Dse(g, C, T) {
        return UE(g, C, Ut(T, 2));
      }
      function Mse(g, C) {
        var T = g == null ? 0 : g.length;
        if (T) {
          var H = y1(g, C);
          if (H < T && os(g[H], C))
            return H;
        }
        return -1;
      }
      function Fse(g, C) {
        return y1(g, C, !0);
      }
      function Lse(g, C, T) {
        return UE(g, C, Ut(T, 2), !0);
      }
      function Vse(g, C) {
        var T = g == null ? 0 : g.length;
        if (T) {
          var H = y1(g, C, !0) - 1;
          if (os(g[H], C))
            return H;
        }
        return -1;
      }
      function Bse(g) {
        return g && g.length ? QP(g) : [];
      }
      function Hse(g, C) {
        return g && g.length ? QP(g, Ut(C, 2)) : [];
      }
      function Wse(g) {
        var C = g == null ? 0 : g.length;
        return C ? Ta(g, 1, C) : [];
      }
      function jse(g, C, T) {
        return g && g.length ? (C = T || C === n ? 1 : vn(C), Ta(g, 0, C < 0 ? 0 : C)) : [];
      }
      function zse(g, C, T) {
        var H = g == null ? 0 : g.length;
        return H ? (C = T || C === n ? 1 : vn(C), C = H - C, Ta(g, C < 0 ? 0 : C, H)) : [];
      }
      function Gse(g, C) {
        return g && g.length ? x1(g, Ut(C, 3), !1, !0) : [];
      }
      function Use(g, C) {
        return g && g.length ? x1(g, Ut(C, 3)) : [];
      }
      var Xse = In(function(g) {
        return Tl(Ri(g, 1, ei, !0));
      }), Yse = In(function(g) {
        var C = Oa(g);
        return ei(C) && (C = n), Tl(Ri(g, 1, ei, !0), Ut(C, 2));
      }), Zse = In(function(g) {
        var C = Oa(g);
        return C = typeof C == "function" ? C : n, Tl(Ri(g, 1, ei, !0), n, C);
      });
      function Jse(g) {
        return g && g.length ? Tl(g) : [];
      }
      function Kse(g, C) {
        return g && g.length ? Tl(g, Ut(C, 2)) : [];
      }
      function qse(g, C) {
        return C = typeof C == "function" ? C : n, g && g.length ? Tl(g, n, C) : [];
      }
      function cS(g) {
        if (!(g && g.length))
          return [];
        var C = 0;
        return g = ns(g, function(T) {
          if (ei(T))
            return C = bi(T.length, C), !0;
        }), AE(C, function(T) {
          return br(g, Iu(T));
        });
      }
      function VN(g, C) {
        if (!(g && g.length))
          return [];
        var T = cS(g);
        return C == null ? T : br(T, function(H) {
          return zi(C, n, H);
        });
      }
      var Qse = In(function(g, C) {
        return ei(g) ? fg(g, C) : [];
      }), eue = In(function(g) {
        return YE(ns(g, ei));
      }), tue = In(function(g) {
        var C = Oa(g);
        return ei(C) && (C = n), YE(ns(g, ei), Ut(C, 2));
      }), nue = In(function(g) {
        var C = Oa(g);
        return C = typeof C == "function" ? C : n, YE(ns(g, ei), n, C);
      }), rue = In(cS);
      function iue(g, C) {
        return rN(g || [], C || [], dg);
      }
      function oue(g, C) {
        return rN(g || [], C || [], gg);
      }
      var aue = In(function(g) {
        var C = g.length, T = C > 1 ? g[C - 1] : n;
        return T = typeof T == "function" ? (g.pop(), T) : n, VN(g, T);
      });
      function BN(g) {
        var C = re(g);
        return C.__chain__ = !0, C;
      }
      function sue(g, C) {
        return C(g), g;
      }
      function O1(g, C) {
        return C(g);
      }
      var uue = Pu(function(g) {
        var C = g.length, T = C ? g[0] : 0, H = this.__wrapped__, J = function(ae) {
          return DE(ae, g);
        };
        return C > 1 || this.__actions__.length || !(H instanceof Nn) || !Nu(T) ? this.thru(J) : (H = H.slice(T, +T + (C ? 1 : 0)), H.__actions__.push({
          func: O1,
          args: [J],
          thisArg: n
        }), new _a(H, this.__chain__).thru(function(ae) {
          return C && !ae.length && ae.push(n), ae;
        }));
      });
      function lue() {
        return BN(this);
      }
      function cue() {
        return new _a(this.value(), this.__chain__);
      }
      function due() {
        this.__values__ === n && (this.__values__ = e7(this.value()));
        var g = this.__index__ >= this.__values__.length, C = g ? n : this.__values__[this.__index__++];
        return { done: g, value: C };
      }
      function fue() {
        return this;
      }
      function hue(g) {
        for (var C, T = this; T instanceof p1; ) {
          var H = RN(T);
          H.__index__ = 0, H.__values__ = n, C ? J.__wrapped__ = H : C = H;
          var J = H;
          T = T.__wrapped__;
        }
        return J.__wrapped__ = g, C;
      }
      function pue() {
        var g = this.__wrapped__;
        if (g instanceof Nn) {
          var C = g;
          return this.__actions__.length && (C = new Nn(this)), C = C.reverse(), C.__actions__.push({
            func: O1,
            args: [lS],
            thisArg: n
          }), new _a(C, this.__chain__);
        }
        return this.thru(lS);
      }
      function gue() {
        return nN(this.__wrapped__, this.__actions__);
      }
      var mue = C1(function(g, C, T) {
        cr.call(g, T) ? ++g[T] : Tu(g, T, 1);
      });
      function vue(g, C, T) {
        var H = pn(g) ? Qv : sae;
        return T && eo(g, C, T) && (C = n), H(g, Ut(C, 3));
      }
      function bue(g, C) {
        var T = pn(g) ? ns : VP;
        return T(g, Ut(C, 3));
      }
      var yue = hN($N), xue = hN(DN);
      function Cue(g, C) {
        return Ri(P1(g, C), 1);
      }
      function wue(g, C) {
        return Ri(P1(g, C), M);
      }
      function Eue(g, C, T) {
        return T = T === n ? 1 : vn(T), Ri(P1(g, C), T);
      }
      function HN(g, C) {
        var T = pn(g) ? mo : Al;
        return T(g, Ut(C, 3));
      }
      function WN(g, C) {
        var T = pn(g) ? SE : LP;
        return T(g, Ut(C, 3));
      }
      var Sue = C1(function(g, C, T) {
        cr.call(g, T) ? g[T].push(C) : Tu(g, T, [C]);
      });
      function Iue(g, C, T, H) {
        g = bo(g) ? g : Nf(g), T = T && !H ? vn(T) : 0;
        var J = g.length;
        return T < 0 && (T = bi(J + T, 0)), D1(g) ? T <= J && g.indexOf(C, T) > -1 : !!J && Gi(g, C, T) > -1;
      }
      var _ue = In(function(g, C, T) {
        var H = -1, J = typeof C == "function", ae = bo(g) ? De(g.length) : [];
        return Al(g, function(me) {
          ae[++H] = J ? zi(C, me, T) : hg(me, C, T);
        }), ae;
      }), Aue = C1(function(g, C, T) {
        Tu(g, T, C);
      });
      function P1(g, C) {
        var T = pn(g) ? br : GP;
        return T(g, Ut(C, 3));
      }
      function Tue(g, C, T, H) {
        return g == null ? [] : (pn(C) || (C = C == null ? [] : [C]), T = H ? n : T, pn(T) || (T = T == null ? [] : [T]), ZP(g, C, T));
      }
      var Oue = C1(function(g, C, T) {
        g[T ? 0 : 1].push(C);
      }, function() {
        return [[], []];
      });
      function Pue(g, C, T) {
        var H = pn(g) ? ig : yP, J = arguments.length < 3;
        return H(g, Ut(C, 4), T, J, Al);
      }
      function Nue(g, C, T) {
        var H = pn(g) ? IE : yP, J = arguments.length < 3;
        return H(g, Ut(C, 4), T, J, LP);
      }
      function kue(g, C) {
        var T = pn(g) ? ns : VP;
        return T(g, R1(Ut(C, 3)));
      }
      function Rue(g) {
        var C = pn(g) ? $P : Iae;
        return C(g);
      }
      function $ue(g, C, T) {
        (T ? eo(g, C, T) : C === n) ? C = 1 : C = vn(C);
        var H = pn(g) ? nae : _ae;
        return H(g, C);
      }
      function Due(g) {
        var C = pn(g) ? rae : Tae;
        return C(g);
      }
      function Mue(g) {
        if (g == null)
          return 0;
        if (bo(g))
          return D1(g) ? Cf(g) : g.length;
        var C = Xi(g);
        return C == he || C == pe ? g.size : HE(g).length;
      }
      function Fue(g, C, T) {
        var H = pn(g) ? sn : Oae;
        return T && eo(g, C, T) && (C = n), H(g, Ut(C, 3));
      }
      var Lue = In(function(g, C) {
        if (g == null)
          return [];
        var T = C.length;
        return T > 1 && eo(g, C[0], C[1]) ? C = [] : T > 2 && eo(C[0], C[1], C[2]) && (C = [C[0]]), ZP(g, Ri(C, 1), []);
      }), N1 = boe || function() {
        return gi.Date.now();
      };
      function Vue(g, C) {
        if (typeof C != "function")
          throw new Ia(a);
        return g = vn(g), function() {
          if (--g < 1)
            return C.apply(this, arguments);
        };
      }
      function jN(g, C, T) {
        return C = T ? n : C, C = g && C == null ? g.length : C, Ou(g, _, n, n, n, n, C);
      }
      function zN(g, C) {
        var T;
        if (typeof C != "function")
          throw new Ia(a);
        return g = vn(g), function() {
          return --g > 0 && (T = C.apply(this, arguments)), g <= 1 && (C = n), T;
        };
      }
      var dS = In(function(g, C, T) {
        var H = m;
        if (T.length) {
          var J = Il(T, Of(dS));
          H |= E;
        }
        return Ou(g, H, C, T, J);
      }), GN = In(function(g, C, T) {
        var H = m | b;
        if (T.length) {
          var J = Il(T, Of(GN));
          H |= E;
        }
        return Ou(C, H, g, T, J);
      });
      function UN(g, C, T) {
        C = T ? n : C;
        var H = Ou(g, w, n, n, n, n, n, C);
        return H.placeholder = UN.placeholder, H;
      }
      function XN(g, C, T) {
        C = T ? n : C;
        var H = Ou(g, S, n, n, n, n, n, C);
        return H.placeholder = XN.placeholder, H;
      }
      function YN(g, C, T) {
        var H, J, ae, me, xe, Te, Ge = 0, Ue = !1, Qe = !1, xt = !0;
        if (typeof g != "function")
          throw new Ia(a);
        C = Pa(C) || 0, Wr(T) && (Ue = !!T.leading, Qe = "maxWait" in T, ae = Qe ? bi(Pa(T.maxWait) || 0, C) : ae, xt = "trailing" in T ? !!T.trailing : xt);
        function Ft(ti) {
          var as = H, $u = J;
          return H = J = n, Ge = ti, me = g.apply($u, as), me;
        }
        function Zt(ti) {
          return Ge = ti, xe = bg(Tn, C), Ue ? Ft(ti) : me;
        }
        function yn(ti) {
          var as = ti - Te, $u = ti - Ge, h7 = C - as;
          return Qe ? Ui(h7, ae - $u) : h7;
        }
        function Jt(ti) {
          var as = ti - Te, $u = ti - Ge;
          return Te === n || as >= C || as < 0 || Qe && $u >= ae;
        }
        function Tn() {
          var ti = N1();
          if (Jt(ti))
            return Fn(ti);
          xe = bg(Tn, yn(ti));
        }
        function Fn(ti) {
          return xe = n, xt && H ? Ft(ti) : (H = J = n, me);
        }
        function Xo() {
          xe !== n && iN(xe), Ge = 0, H = Te = J = xe = n;
        }
        function to() {
          return xe === n ? me : Fn(N1());
        }
        function Yo() {
          var ti = N1(), as = Jt(ti);
          if (H = arguments, J = this, Te = ti, as) {
            if (xe === n)
              return Zt(Te);
            if (Qe)
              return iN(xe), xe = bg(Tn, C), Ft(Te);
          }
          return xe === n && (xe = bg(Tn, C)), me;
        }
        return Yo.cancel = Xo, Yo.flush = to, Yo;
      }
      var Bue = In(function(g, C) {
        return FP(g, 1, C);
      }), Hue = In(function(g, C, T) {
        return FP(g, Pa(C) || 0, T);
      });
      function Wue(g) {
        return Ou(g, P);
      }
      function k1(g, C) {
        if (typeof g != "function" || C != null && typeof C != "function")
          throw new Ia(a);
        var T = function() {
          var H = arguments, J = C ? C.apply(this, H) : H[0], ae = T.cache;
          if (ae.has(J))
            return ae.get(J);
          var me = g.apply(this, H);
          return T.cache = ae.set(J, me) || ae, me;
        };
        return T.cache = new (k1.Cache || Au)(), T;
      }
      k1.Cache = Au;
      function R1(g) {
        if (typeof g != "function")
          throw new Ia(a);
        return function() {
          var C = arguments;
          switch (C.length) {
            case 0:
              return !g.call(this);
            case 1:
              return !g.call(this, C[0]);
            case 2:
              return !g.call(this, C[0], C[1]);
            case 3:
              return !g.call(this, C[0], C[1], C[2]);
          }
          return !g.apply(this, C);
        };
      }
      function jue(g) {
        return zN(2, g);
      }
      var zue = Pae(function(g, C) {
        C = C.length == 1 && pn(C[0]) ? br(C[0], zo(Ut())) : br(Ri(C, 1), zo(Ut()));
        var T = C.length;
        return In(function(H) {
          for (var J = -1, ae = Ui(H.length, T); ++J < ae; )
            H[J] = C[J].call(this, H[J]);
          return zi(g, this, H);
        });
      }), fS = In(function(g, C) {
        var T = Il(C, Of(fS));
        return Ou(g, E, n, C, T);
      }), ZN = In(function(g, C) {
        var T = Il(C, Of(ZN));
        return Ou(g, I, n, C, T);
      }), Gue = Pu(function(g, C) {
        return Ou(g, A, n, n, n, C);
      });
      function Uue(g, C) {
        if (typeof g != "function")
          throw new Ia(a);
        return C = C === n ? C : vn(C), In(g, C);
      }
      function Xue(g, C) {
        if (typeof g != "function")
          throw new Ia(a);
        return C = C == null ? 0 : bi(vn(C), 0), In(function(T) {
          var H = T[C], J = Pl(T, 0, C);
          return H && wa(J, H), zi(g, this, J);
        });
      }
      function Yue(g, C, T) {
        var H = !0, J = !0;
        if (typeof g != "function")
          throw new Ia(a);
        return Wr(T) && (H = "leading" in T ? !!T.leading : H, J = "trailing" in T ? !!T.trailing : J), YN(g, C, {
          leading: H,
          maxWait: C,
          trailing: J
        });
      }
      function Zue(g) {
        return jN(g, 1);
      }
      function Jue(g, C) {
        return fS(JE(C), g);
      }
      function Kue() {
        if (!arguments.length)
          return [];
        var g = arguments[0];
        return pn(g) ? g : [g];
      }
      function que(g) {
        return Aa(g, h);
      }
      function Que(g, C) {
        return C = typeof C == "function" ? C : n, Aa(g, h, C);
      }
      function ele(g) {
        return Aa(g, d | h);
      }
      function tle(g, C) {
        return C = typeof C == "function" ? C : n, Aa(g, d | h, C);
      }
      function nle(g, C) {
        return C == null || MP(g, C, Si(C));
      }
      function os(g, C) {
        return g === C || g !== g && C !== C;
      }
      var rle = I1(LE), ile = I1(function(g, C) {
        return g >= C;
      }), Uc = WP(/* @__PURE__ */ function() {
        return arguments;
      }()) ? WP : function(g) {
        return Gr(g) && cr.call(g, "callee") && !TP.call(g, "callee");
      }, pn = De.isArray, ole = Zv ? zo(Zv) : hae;
      function bo(g) {
        return g != null && $1(g.length) && !ku(g);
      }
      function ei(g) {
        return Gr(g) && bo(g);
      }
      function ale(g) {
        return g === !0 || g === !1 || Gr(g) && Qi(g) == ee;
      }
      var Nl = xoe || ES, sle = Jv ? zo(Jv) : pae;
      function ule(g) {
        return Gr(g) && g.nodeType === 1 && !yg(g);
      }
      function lle(g) {
        if (g == null)
          return !0;
        if (bo(g) && (pn(g) || typeof g == "string" || typeof g.splice == "function" || Nl(g) || Pf(g) || Uc(g)))
          return !g.length;
        var C = Xi(g);
        if (C == he || C == pe)
          return !g.size;
        if (vg(g))
          return !HE(g).length;
        for (var T in g)
          if (cr.call(g, T))
            return !1;
        return !0;
      }
      function cle(g, C) {
        return pg(g, C);
      }
      function dle(g, C, T) {
        T = typeof T == "function" ? T : n;
        var H = T ? T(g, C) : n;
        return H === n ? pg(g, C, n, T) : !!H;
      }
      function hS(g) {
        if (!Gr(g))
          return !1;
        var C = Qi(g);
        return C == se || C == oe || typeof g.message == "string" && typeof g.name == "string" && !yg(g);
      }
      function fle(g) {
        return typeof g == "number" && PP(g);
      }
      function ku(g) {
        if (!Wr(g))
          return !1;
        var C = Qi(g);
        return C == te || C == ge || C == Z || C == Ve;
      }
      function JN(g) {
        return typeof g == "number" && g == vn(g);
      }
      function $1(g) {
        return typeof g == "number" && g > -1 && g % 1 == 0 && g <= B;
      }
      function Wr(g) {
        var C = typeof g;
        return g != null && (C == "object" || C == "function");
      }
      function Gr(g) {
        return g != null && typeof g == "object";
      }
      var KN = Kv ? zo(Kv) : mae;
      function hle(g, C) {
        return g === C || BE(g, C, rS(C));
      }
      function ple(g, C, T) {
        return T = typeof T == "function" ? T : n, BE(g, C, rS(C), T);
      }
      function gle(g) {
        return qN(g) && g != +g;
      }
      function mle(g) {
        if (Qae(g))
          throw new cn(o);
        return jP(g);
      }
      function vle(g) {
        return g === null;
      }
      function ble(g) {
        return g == null;
      }
      function qN(g) {
        return typeof g == "number" || Gr(g) && Qi(g) == fe;
      }
      function yg(g) {
        if (!Gr(g) || Qi(g) != Ne)
          return !1;
        var C = s1(g);
        if (C === null)
          return !0;
        var T = cr.call(C, "constructor") && C.constructor;
        return typeof T == "function" && T instanceof T && r1.call(T) == poe;
      }
      var pS = qv ? zo(qv) : vae;
      function yle(g) {
        return JN(g) && g >= -B && g <= B;
      }
      var QN = bf ? zo(bf) : bae;
      function D1(g) {
        return typeof g == "string" || !pn(g) && Gr(g) && Qi(g) == ye;
      }
      function Uo(g) {
        return typeof g == "symbol" || Gr(g) && Qi(g) == Ae;
      }
      var Pf = ts ? zo(ts) : yae;
      function xle(g) {
        return g === n;
      }
      function Cle(g) {
        return Gr(g) && Xi(g) == ce;
      }
      function wle(g) {
        return Gr(g) && Qi(g) == ve;
      }
      var Ele = I1(WE), Sle = I1(function(g, C) {
        return g <= C;
      });
      function e7(g) {
        if (!g)
          return [];
        if (bo(g))
          return D1(g) ? rs(g) : vo(g);
        if (ag && g[ag])
          return noe(g[ag]());
        var C = Xi(g), T = C == he ? OE : C == pe ? e1 : Nf;
        return T(g);
      }
      function Ru(g) {
        if (!g)
          return g === 0 ? g : 0;
        if (g = Pa(g), g === M || g === -M) {
          var C = g < 0 ? -1 : 1;
          return C * X;
        }
        return g === g ? g : 0;
      }
      function vn(g) {
        var C = Ru(g), T = C % 1;
        return C === C ? T ? C - T : C : 0;
      }
      function t7(g) {
        return g ? Wc(vn(g), 0, j) : 0;
      }
      function Pa(g) {
        if (typeof g == "number")
          return g;
        if (Uo(g))
          return L;
        if (Wr(g)) {
          var C = typeof g.valueOf == "function" ? g.valueOf() : g;
          g = Wr(C) ? C + "" : C;
        }
        if (typeof g != "string")
          return g === 0 ? g : +g;
        g = xP(g);
        var T = dt.test(g);
        return T || on.test(g) ? Uv(g.slice(2), T ? 2 : 8) : nt.test(g) ? L : +g;
      }
      function n7(g) {
        return Gs(g, yo(g));
      }
      function Ile(g) {
        return g ? Wc(vn(g), -B, B) : g === 0 ? g : 0;
      }
      function er(g) {
        return g == null ? "" : Go(g);
      }
      var _le = Af(function(g, C) {
        if (vg(C) || bo(C)) {
          Gs(C, Si(C), g);
          return;
        }
        for (var T in C)
          cr.call(C, T) && dg(g, T, C[T]);
      }), r7 = Af(function(g, C) {
        Gs(C, yo(C), g);
      }), M1 = Af(function(g, C, T, H) {
        Gs(C, yo(C), g, H);
      }), Ale = Af(function(g, C, T, H) {
        Gs(C, Si(C), g, H);
      }), Tle = Pu(DE);
      function Ole(g, C) {
        var T = _f(g);
        return C == null ? T : DP(T, C);
      }
      var Ple = In(function(g, C) {
        g = Ir(g);
        var T = -1, H = C.length, J = H > 2 ? C[2] : n;
        for (J && eo(C[0], C[1], J) && (H = 1); ++T < H; )
          for (var ae = C[T], me = yo(ae), xe = -1, Te = me.length; ++xe < Te; ) {
            var Ge = me[xe], Ue = g[Ge];
            (Ue === n || os(Ue, Ef[Ge]) && !cr.call(g, Ge)) && (g[Ge] = ae[Ge]);
          }
        return g;
      }), Nle = In(function(g) {
        return g.push(n, xN), zi(i7, n, g);
      });
      function kle(g, C) {
        return Lr(g, Ut(C, 3), zs);
      }
      function Rle(g, C) {
        return Lr(g, Ut(C, 3), FE);
      }
      function $le(g, C) {
        return g == null ? g : ME(g, Ut(C, 3), yo);
      }
      function Dle(g, C) {
        return g == null ? g : BP(g, Ut(C, 3), yo);
      }
      function Mle(g, C) {
        return g && zs(g, Ut(C, 3));
      }
      function Fle(g, C) {
        return g && FE(g, Ut(C, 3));
      }
      function Lle(g) {
        return g == null ? [] : v1(g, Si(g));
      }
      function Vle(g) {
        return g == null ? [] : v1(g, yo(g));
      }
      function gS(g, C, T) {
        var H = g == null ? n : jc(g, C);
        return H === n ? T : H;
      }
      function Ble(g, C) {
        return g != null && EN(g, C, lae);
      }
      function mS(g, C) {
        return g != null && EN(g, C, cae);
      }
      var Hle = gN(function(g, C, T) {
        C != null && typeof C.toString != "function" && (C = i1.call(C)), g[C] = T;
      }, bS(xo)), Wle = gN(function(g, C, T) {
        C != null && typeof C.toString != "function" && (C = i1.call(C)), cr.call(g, C) ? g[C].push(T) : g[C] = [T];
      }, Ut), jle = In(hg);
      function Si(g) {
        return bo(g) ? RP(g) : HE(g);
      }
      function yo(g) {
        return bo(g) ? RP(g, !0) : xae(g);
      }
      function zle(g, C) {
        var T = {};
        return C = Ut(C, 3), zs(g, function(H, J, ae) {
          Tu(T, C(H, J, ae), H);
        }), T;
      }
      function Gle(g, C) {
        var T = {};
        return C = Ut(C, 3), zs(g, function(H, J, ae) {
          Tu(T, J, C(H, J, ae));
        }), T;
      }
      var Ule = Af(function(g, C, T) {
        b1(g, C, T);
      }), i7 = Af(function(g, C, T, H) {
        b1(g, C, T, H);
      }), Xle = Pu(function(g, C) {
        var T = {};
        if (g == null)
          return T;
        var H = !1;
        C = br(C, function(ae) {
          return ae = Ol(ae, g), H || (H = ae.length > 1), ae;
        }), Gs(g, tS(g), T), H && (T = Aa(T, d | f | h, Hae));
        for (var J = C.length; J--; )
          XE(T, C[J]);
        return T;
      });
      function Yle(g, C) {
        return o7(g, R1(Ut(C)));
      }
      var Zle = Pu(function(g, C) {
        return g == null ? {} : wae(g, C);
      });
      function o7(g, C) {
        if (g == null)
          return {};
        var T = br(tS(g), function(H) {
          return [H];
        });
        return C = Ut(C), JP(g, T, function(H, J) {
          return C(H, J[0]);
        });
      }
      function Jle(g, C, T) {
        C = Ol(C, g);
        var H = -1, J = C.length;
        for (J || (J = 1, g = n); ++H < J; ) {
          var ae = g == null ? n : g[Us(C[H])];
          ae === n && (H = J, ae = T), g = ku(ae) ? ae.call(g) : ae;
        }
        return g;
      }
      function Kle(g, C, T) {
        return g == null ? g : gg(g, C, T);
      }
      function qle(g, C, T, H) {
        return H = typeof H == "function" ? H : n, g == null ? g : gg(g, C, T, H);
      }
      var a7 = bN(Si), s7 = bN(yo);
      function Qle(g, C, T) {
        var H = pn(g), J = H || Nl(g) || Pf(g);
        if (C = Ut(C, 4), T == null) {
          var ae = g && g.constructor;
          J ? T = H ? new ae() : [] : Wr(g) ? T = ku(ae) ? _f(s1(g)) : {} : T = {};
        }
        return (J ? mo : zs)(g, function(me, xe, Te) {
          return C(T, me, xe, Te);
        }), T;
      }
      function ece(g, C) {
        return g == null ? !0 : XE(g, C);
      }
      function tce(g, C, T) {
        return g == null ? g : tN(g, C, JE(T));
      }
      function nce(g, C, T, H) {
        return H = typeof H == "function" ? H : n, g == null ? g : tN(g, C, JE(T), H);
      }
      function Nf(g) {
        return g == null ? [] : TE(g, Si(g));
      }
      function rce(g) {
        return g == null ? [] : TE(g, yo(g));
      }
      function ice(g, C, T) {
        return T === n && (T = C, C = n), T !== n && (T = Pa(T), T = T === T ? T : 0), C !== n && (C = Pa(C), C = C === C ? C : 0), Wc(Pa(g), C, T);
      }
      function oce(g, C, T) {
        return C = Ru(C), T === n ? (T = C, C = 0) : T = Ru(T), g = Pa(g), dae(g, C, T);
      }
      function ace(g, C, T) {
        if (T && typeof T != "boolean" && eo(g, C, T) && (C = T = n), T === n && (typeof C == "boolean" ? (T = C, C = n) : typeof g == "boolean" && (T = g, g = n)), g === n && C === n ? (g = 0, C = 1) : (g = Ru(g), C === n ? (C = g, g = 0) : C = Ru(C)), g > C) {
          var H = g;
          g = C, C = H;
        }
        if (T || g % 1 || C % 1) {
          var J = NP();
          return Ui(g + J * (C - g + Gv("1e-" + ((J + "").length - 1))), C);
        }
        return zE(g, C);
      }
      var sce = Tf(function(g, C, T) {
        return C = C.toLowerCase(), g + (T ? u7(C) : C);
      });
      function u7(g) {
        return vS(er(g).toLowerCase());
      }
      function l7(g) {
        return g = er(g), g && g.replace(Tt, Kie).replace(vE, "");
      }
      function uce(g, C, T) {
        g = er(g), C = Go(C);
        var H = g.length;
        T = T === n ? H : Wc(vn(T), 0, H);
        var J = T;
        return T -= C.length, T >= 0 && g.slice(T, J) == C;
      }
      function lce(g) {
        return g = er(g), g && Vt.test(g) ? g.replace(ct, qie) : g;
      }
      function cce(g) {
        return g = er(g), g && mt.test(g) ? g.replace(He, "\\$&") : g;
      }
      var dce = Tf(function(g, C, T) {
        return g + (T ? "-" : "") + C.toLowerCase();
      }), fce = Tf(function(g, C, T) {
        return g + (T ? " " : "") + C.toLowerCase();
      }), hce = fN("toLowerCase");
      function pce(g, C, T) {
        g = er(g), C = vn(C);
        var H = C ? Cf(g) : 0;
        if (!C || H >= C)
          return g;
        var J = (C - H) / 2;
        return S1(d1(J), T) + g + S1(c1(J), T);
      }
      function gce(g, C, T) {
        g = er(g), C = vn(C);
        var H = C ? Cf(g) : 0;
        return C && H < C ? g + S1(C - H, T) : g;
      }
      function mce(g, C, T) {
        g = er(g), C = vn(C);
        var H = C ? Cf(g) : 0;
        return C && H < C ? S1(C - H, T) + g : g;
      }
      function vce(g, C, T) {
        return T || C == null ? C = 0 : C && (C = +C), Soe(er(g).replace(Qt, ""), C || 0);
      }
      function bce(g, C, T) {
        return (T ? eo(g, C, T) : C === n) ? C = 1 : C = vn(C), GE(er(g), C);
      }
      function yce() {
        var g = arguments, C = er(g[0]);
        return g.length < 3 ? C : C.replace(g[1], g[2]);
      }
      var xce = Tf(function(g, C, T) {
        return g + (T ? "_" : "") + C.toLowerCase();
      });
      function Cce(g, C, T) {
        return T && typeof T != "number" && eo(g, C, T) && (C = T = n), T = T === n ? j : T >>> 0, T ? (g = er(g), g && (typeof C == "string" || C != null && !pS(C)) && (C = Go(C), !C && xf(g)) ? Pl(rs(g), 0, T) : g.split(C, T)) : [];
      }
      var wce = Tf(function(g, C, T) {
        return g + (T ? " " : "") + vS(C);
      });
      function Ece(g, C, T) {
        return g = er(g), T = T == null ? 0 : Wc(vn(T), 0, g.length), C = Go(C), g.slice(T, T + C.length) == C;
      }
      function Sce(g, C, T) {
        var H = re.templateSettings;
        T && eo(g, C, T) && (C = n), g = er(g), C = M1({}, C, H, yN);
        var J = M1({}, C.imports, H.imports, yN), ae = Si(J), me = TE(J, ae), xe, Te, Ge = 0, Ue = C.interpolate || Wn, Qe = "__p += '", xt = PE(
          (C.escape || Wn).source + "|" + Ue.source + "|" + (Ue === Xe ? $t : Wn).source + "|" + (C.evaluate || Wn).source + "|$",
          "g"
        ), Ft = "//# sourceURL=" + (cr.call(C, "sourceURL") ? (C.sourceURL + "").replace(/\s/g, " ") : "lodash.templateSources[" + ++xE + "]") + `
`;
        g.replace(xt, function(Jt, Tn, Fn, Xo, to, Yo) {
          return Fn || (Fn = Xo), Qe += g.slice(Ge, Yo).replace(zr, Qie), Tn && (xe = !0, Qe += `' +
__e(` + Tn + `) +
'`), to && (Te = !0, Qe += `';
` + to + `;
__p += '`), Fn && (Qe += `' +
((__t = (` + Fn + `)) == null ? '' : __t) +
'`), Ge = Yo + Jt.length, Jt;
        }), Qe += `';
`;
        var Zt = cr.call(C, "variable") && C.variable;
        if (!Zt)
          Qe = `with (obj) {
` + Qe + `
}
`;
        else if (je.test(Zt))
          throw new cn(s);
        Qe = (Te ? Qe.replace(qt, "") : Qe).replace(bt, "$1").replace(Me, "$1;"), Qe = "function(" + (Zt || "obj") + `) {
` + (Zt ? "" : `obj || (obj = {});
`) + "var __t, __p = ''" + (xe ? ", __e = _.escape" : "") + (Te ? `, __j = Array.prototype.join;
function print() { __p += __j.call(arguments, '') }
` : `;
`) + Qe + `return __p
}`;
        var yn = d7(function() {
          return Un(ae, Ft + "return " + Qe).apply(n, me);
        });
        if (yn.source = Qe, hS(yn))
          throw yn;
        return yn;
      }
      function Ice(g) {
        return er(g).toLowerCase();
      }
      function _ce(g) {
        return er(g).toUpperCase();
      }
      function Ace(g, C, T) {
        if (g = er(g), g && (T || C === n))
          return xP(g);
        if (!g || !(C = Go(C)))
          return g;
        var H = rs(g), J = rs(C), ae = CP(H, J), me = wP(H, J) + 1;
        return Pl(H, ae, me).join("");
      }
      function Tce(g, C, T) {
        if (g = er(g), g && (T || C === n))
          return g.slice(0, SP(g) + 1);
        if (!g || !(C = Go(C)))
          return g;
        var H = rs(g), J = wP(H, rs(C)) + 1;
        return Pl(H, 0, J).join("");
      }
      function Oce(g, C, T) {
        if (g = er(g), g && (T || C === n))
          return g.replace(Qt, "");
        if (!g || !(C = Go(C)))
          return g;
        var H = rs(g), J = CP(H, rs(C));
        return Pl(H, J).join("");
      }
      function Pce(g, C) {
        var T = N, H = k;
        if (Wr(C)) {
          var J = "separator" in C ? C.separator : J;
          T = "length" in C ? vn(C.length) : T, H = "omission" in C ? Go(C.omission) : H;
        }
        g = er(g);
        var ae = g.length;
        if (xf(g)) {
          var me = rs(g);
          ae = me.length;
        }
        if (T >= ae)
          return g;
        var xe = T - Cf(H);
        if (xe < 1)
          return H;
        var Te = me ? Pl(me, 0, xe).join("") : g.slice(0, xe);
        if (J === n)
          return Te + H;
        if (me && (xe += Te.length - xe), pS(J)) {
          if (g.slice(xe).search(J)) {
            var Ge, Ue = Te;
            for (J.global || (J = PE(J.source, er(qe.exec(J)) + "g")), J.lastIndex = 0; Ge = J.exec(Ue); )
              var Qe = Ge.index;
            Te = Te.slice(0, Qe === n ? xe : Qe);
          }
        } else if (g.indexOf(Go(J), xe) != xe) {
          var xt = Te.lastIndexOf(J);
          xt > -1 && (Te = Te.slice(0, xt));
        }
        return Te + H;
      }
      function Nce(g) {
        return g = er(g), g && kt.test(g) ? g.replace(yt, aoe) : g;
      }
      var kce = Tf(function(g, C, T) {
        return g + (T ? " " : "") + C.toUpperCase();
      }), vS = fN("toUpperCase");
      function c7(g, C, T) {
        return g = er(g), C = T ? n : C, C === n ? toe(g) ? loe(g) : bn(g) : g.match(C) || [];
      }
      var d7 = In(function(g, C) {
        try {
          return zi(g, n, C);
        } catch (T) {
          return hS(T) ? T : new cn(T);
        }
      }), Rce = Pu(function(g, C) {
        return mo(C, function(T) {
          T = Us(T), Tu(g, T, dS(g[T], g));
        }), g;
      });
      function $ce(g) {
        var C = g == null ? 0 : g.length, T = Ut();
        return g = C ? br(g, function(H) {
          if (typeof H[1] != "function")
            throw new Ia(a);
          return [T(H[0]), H[1]];
        }) : [], In(function(H) {
          for (var J = -1; ++J < C; ) {
            var ae = g[J];
            if (zi(ae[0], this, H))
              return zi(ae[1], this, H);
          }
        });
      }
      function Dce(g) {
        return aae(Aa(g, d));
      }
      function bS(g) {
        return function() {
          return g;
        };
      }
      function Mce(g, C) {
        return g == null || g !== g ? C : g;
      }
      var Fce = pN(), Lce = pN(!0);
      function xo(g) {
        return g;
      }
      function yS(g) {
        return zP(typeof g == "function" ? g : Aa(g, d));
      }
      function Vce(g) {
        return UP(Aa(g, d));
      }
      function Bce(g, C) {
        return XP(g, Aa(C, d));
      }
      var Hce = In(function(g, C) {
        return function(T) {
          return hg(T, g, C);
        };
      }), Wce = In(function(g, C) {
        return function(T) {
          return hg(g, T, C);
        };
      });
      function xS(g, C, T) {
        var H = Si(C), J = v1(C, H);
        T == null && !(Wr(C) && (J.length || !H.length)) && (T = C, C = g, g = this, J = v1(C, Si(C)));
        var ae = !(Wr(T) && "chain" in T) || !!T.chain, me = ku(g);
        return mo(J, function(xe) {
          var Te = C[xe];
          g[xe] = Te, me && (g.prototype[xe] = function() {
            var Ge = this.__chain__;
            if (ae || Ge) {
              var Ue = g(this.__wrapped__), Qe = Ue.__actions__ = vo(this.__actions__);
              return Qe.push({ func: Te, args: arguments, thisArg: g }), Ue.__chain__ = Ge, Ue;
            }
            return Te.apply(g, wa([this.value()], arguments));
          });
        }), g;
      }
      function jce() {
        return gi._ === this && (gi._ = goe), this;
      }
      function CS() {
      }
      function zce(g) {
        return g = vn(g), In(function(C) {
          return YP(C, g);
        });
      }
      var Gce = qE(br), Uce = qE(Qv), Xce = qE(sn);
      function f7(g) {
        return oS(g) ? Iu(Us(g)) : Eae(g);
      }
      function Yce(g) {
        return function(C) {
          return g == null ? n : jc(g, C);
        };
      }
      var Zce = mN(), Jce = mN(!0);
      function wS() {
        return [];
      }
      function ES() {
        return !1;
      }
      function Kce() {
        return {};
      }
      function qce() {
        return "";
      }
      function Qce() {
        return !0;
      }
      function ede(g, C) {
        if (g = vn(g), g < 1 || g > B)
          return [];
        var T = j, H = Ui(g, j);
        C = Ut(C), g -= j;
        for (var J = AE(H, C); ++T < g; )
          C(T);
        return J;
      }
      function tde(g) {
        return pn(g) ? br(g, Us) : Uo(g) ? [g] : vo(kN(er(g)));
      }
      function nde(g) {
        var C = ++hoe;
        return er(g) + C;
      }
      var rde = E1(function(g, C) {
        return g + C;
      }, 0), ide = QE("ceil"), ode = E1(function(g, C) {
        return g / C;
      }, 1), ade = QE("floor");
      function sde(g) {
        return g && g.length ? m1(g, xo, LE) : n;
      }
      function ude(g, C) {
        return g && g.length ? m1(g, Ut(C, 2), LE) : n;
      }
      function lde(g) {
        return Sa(g, xo);
      }
      function cde(g, C) {
        return Sa(g, Ut(C, 2));
      }
      function dde(g) {
        return g && g.length ? m1(g, xo, WE) : n;
      }
      function fde(g, C) {
        return g && g.length ? m1(g, Ut(C, 2), WE) : n;
      }
      var hde = E1(function(g, C) {
        return g * C;
      }, 1), pde = QE("round"), gde = E1(function(g, C) {
        return g - C;
      }, 0);
      function mde(g) {
        return g && g.length ? _E(g, xo) : 0;
      }
      function vde(g, C) {
        return g && g.length ? _E(g, Ut(C, 2)) : 0;
      }
      return re.after = Vue, re.ary = jN, re.assign = _le, re.assignIn = r7, re.assignInWith = M1, re.assignWith = Ale, re.at = Tle, re.before = zN, re.bind = dS, re.bindAll = Rce, re.bindKey = GN, re.castArray = Kue, re.chain = BN, re.chunk = ase, re.compact = sse, re.concat = use, re.cond = $ce, re.conforms = Dce, re.constant = bS, re.countBy = mue, re.create = Ole, re.curry = UN, re.curryRight = XN, re.debounce = YN, re.defaults = Ple, re.defaultsDeep = Nle, re.defer = Bue, re.delay = Hue, re.difference = lse, re.differenceBy = cse, re.differenceWith = dse, re.drop = fse, re.dropRight = hse, re.dropRightWhile = pse, re.dropWhile = gse, re.fill = mse, re.filter = bue, re.flatMap = Cue, re.flatMapDeep = wue, re.flatMapDepth = Eue, re.flatten = MN, re.flattenDeep = vse, re.flattenDepth = bse, re.flip = Wue, re.flow = Fce, re.flowRight = Lce, re.fromPairs = yse, re.functions = Lle, re.functionsIn = Vle, re.groupBy = Sue, re.initial = Cse, re.intersection = wse, re.intersectionBy = Ese, re.intersectionWith = Sse, re.invert = Hle, re.invertBy = Wle, re.invokeMap = _ue, re.iteratee = yS, re.keyBy = Aue, re.keys = Si, re.keysIn = yo, re.map = P1, re.mapKeys = zle, re.mapValues = Gle, re.matches = Vce, re.matchesProperty = Bce, re.memoize = k1, re.merge = Ule, re.mergeWith = i7, re.method = Hce, re.methodOf = Wce, re.mixin = xS, re.negate = R1, re.nthArg = zce, re.omit = Xle, re.omitBy = Yle, re.once = jue, re.orderBy = Tue, re.over = Gce, re.overArgs = zue, re.overEvery = Uce, re.overSome = Xce, re.partial = fS, re.partialRight = ZN, re.partition = Oue, re.pick = Zle, re.pickBy = o7, re.property = f7, re.propertyOf = Yce, re.pull = Tse, re.pullAll = LN, re.pullAllBy = Ose, re.pullAllWith = Pse, re.pullAt = Nse, re.range = Zce, re.rangeRight = Jce, re.rearg = Gue, re.reject = kue, re.remove = kse, re.rest = Uue, re.reverse = lS, re.sampleSize = $ue, re.set = Kle, re.setWith = qle, re.shuffle = Due, re.slice = Rse, re.sortBy = Lue, re.sortedUniq = Bse, re.sortedUniqBy = Hse, re.split = Cce, re.spread = Xue, re.tail = Wse, re.take = jse, re.takeRight = zse, re.takeRightWhile = Gse, re.takeWhile = Use, re.tap = sue, re.throttle = Yue, re.thru = O1, re.toArray = e7, re.toPairs = a7, re.toPairsIn = s7, re.toPath = tde, re.toPlainObject = n7, re.transform = Qle, re.unary = Zue, re.union = Xse, re.unionBy = Yse, re.unionWith = Zse, re.uniq = Jse, re.uniqBy = Kse, re.uniqWith = qse, re.unset = ece, re.unzip = cS, re.unzipWith = VN, re.update = tce, re.updateWith = nce, re.values = Nf, re.valuesIn = rce, re.without = Qse, re.words = c7, re.wrap = Jue, re.xor = eue, re.xorBy = tue, re.xorWith = nue, re.zip = rue, re.zipObject = iue, re.zipObjectDeep = oue, re.zipWith = aue, re.entries = a7, re.entriesIn = s7, re.extend = r7, re.extendWith = M1, xS(re, re), re.add = rde, re.attempt = d7, re.camelCase = sce, re.capitalize = u7, re.ceil = ide, re.clamp = ice, re.clone = que, re.cloneDeep = ele, re.cloneDeepWith = tle, re.cloneWith = Que, re.conformsTo = nle, re.deburr = l7, re.defaultTo = Mce, re.divide = ode, re.endsWith = uce, re.eq = os, re.escape = lce, re.escapeRegExp = cce, re.every = vue, re.find = yue, re.findIndex = $N, re.findKey = kle, re.findLast = xue, re.findLastIndex = DN, re.findLastKey = Rle, re.floor = ade, re.forEach = HN, re.forEachRight = WN, re.forIn = $le, re.forInRight = Dle, re.forOwn = Mle, re.forOwnRight = Fle, re.get = gS, re.gt = rle, re.gte = ile, re.has = Ble, re.hasIn = mS, re.head = FN, re.identity = xo, re.includes = Iue, re.indexOf = xse, re.inRange = oce, re.invoke = jle, re.isArguments = Uc, re.isArray = pn, re.isArrayBuffer = ole, re.isArrayLike = bo, re.isArrayLikeObject = ei, re.isBoolean = ale, re.isBuffer = Nl, re.isDate = sle, re.isElement = ule, re.isEmpty = lle, re.isEqual = cle, re.isEqualWith = dle, re.isError = hS, re.isFinite = fle, re.isFunction = ku, re.isInteger = JN, re.isLength = $1, re.isMap = KN, re.isMatch = hle, re.isMatchWith = ple, re.isNaN = gle, re.isNative = mle, re.isNil = ble, re.isNull = vle, re.isNumber = qN, re.isObject = Wr, re.isObjectLike = Gr, re.isPlainObject = yg, re.isRegExp = pS, re.isSafeInteger = yle, re.isSet = QN, re.isString = D1, re.isSymbol = Uo, re.isTypedArray = Pf, re.isUndefined = xle, re.isWeakMap = Cle, re.isWeakSet = wle, re.join = Ise, re.kebabCase = dce, re.last = Oa, re.lastIndexOf = _se, re.lowerCase = fce, re.lowerFirst = hce, re.lt = Ele, re.lte = Sle, re.max = sde, re.maxBy = ude, re.mean = lde, re.meanBy = cde, re.min = dde, re.minBy = fde, re.stubArray = wS, re.stubFalse = ES, re.stubObject = Kce, re.stubString = qce, re.stubTrue = Qce, re.multiply = hde, re.nth = Ase, re.noConflict = jce, re.noop = CS, re.now = N1, re.pad = pce, re.padEnd = gce, re.padStart = mce, re.parseInt = vce, re.random = ace, re.reduce = Pue, re.reduceRight = Nue, re.repeat = bce, re.replace = yce, re.result = Jle, re.round = pde, re.runInContext = Se, re.sample = Rue, re.size = Mue, re.snakeCase = xce, re.some = Fue, re.sortedIndex = $se, re.sortedIndexBy = Dse, re.sortedIndexOf = Mse, re.sortedLastIndex = Fse, re.sortedLastIndexBy = Lse, re.sortedLastIndexOf = Vse, re.startCase = wce, re.startsWith = Ece, re.subtract = gde, re.sum = mde, re.sumBy = vde, re.template = Sce, re.times = ede, re.toFinite = Ru, re.toInteger = vn, re.toLength = t7, re.toLower = Ice, re.toNumber = Pa, re.toSafeInteger = Ile, re.toString = er, re.toUpper = _ce, re.trim = Ace, re.trimEnd = Tce, re.trimStart = Oce, re.truncate = Pce, re.unescape = Nce, re.uniqueId = nde, re.upperCase = kce, re.upperFirst = vS, re.each = HN, re.eachRight = WN, re.first = FN, xS(re, function() {
        var g = {};
        return zs(re, function(C, T) {
          cr.call(re.prototype, T) || (g[T] = C);
        }), g;
      }(), { chain: !1 }), re.VERSION = r, mo(["bind", "bindKey", "curry", "curryRight", "partial", "partialRight"], function(g) {
        re[g].placeholder = re;
      }), mo(["drop", "take"], function(g, C) {
        Nn.prototype[g] = function(T) {
          T = T === n ? 1 : bi(vn(T), 0);
          var H = this.__filtered__ && !C ? new Nn(this) : this.clone();
          return H.__filtered__ ? H.__takeCount__ = Ui(T, H.__takeCount__) : H.__views__.push({
            size: Ui(T, j),
            type: g + (H.__dir__ < 0 ? "Right" : "")
          }), H;
        }, Nn.prototype[g + "Right"] = function(T) {
          return this.reverse()[g](T).reverse();
        };
      }), mo(["filter", "map", "takeWhile"], function(g, C) {
        var T = C + 1, H = T == V || T == F;
        Nn.prototype[g] = function(J) {
          var ae = this.clone();
          return ae.__iteratees__.push({
            iteratee: Ut(J, 3),
            type: T
          }), ae.__filtered__ = ae.__filtered__ || H, ae;
        };
      }), mo(["head", "last"], function(g, C) {
        var T = "take" + (C ? "Right" : "");
        Nn.prototype[g] = function() {
          return this[T](1).value()[0];
        };
      }), mo(["initial", "tail"], function(g, C) {
        var T = "drop" + (C ? "" : "Right");
        Nn.prototype[g] = function() {
          return this.__filtered__ ? new Nn(this) : this[T](1);
        };
      }), Nn.prototype.compact = function() {
        return this.filter(xo);
      }, Nn.prototype.find = function(g) {
        return this.filter(g).head();
      }, Nn.prototype.findLast = function(g) {
        return this.reverse().find(g);
      }, Nn.prototype.invokeMap = In(function(g, C) {
        return typeof g == "function" ? new Nn(this) : this.map(function(T) {
          return hg(T, g, C);
        });
      }), Nn.prototype.reject = function(g) {
        return this.filter(R1(Ut(g)));
      }, Nn.prototype.slice = function(g, C) {
        g = vn(g);
        var T = this;
        return T.__filtered__ && (g > 0 || C < 0) ? new Nn(T) : (g < 0 ? T = T.takeRight(-g) : g && (T = T.drop(g)), C !== n && (C = vn(C), T = C < 0 ? T.dropRight(-C) : T.take(C - g)), T);
      }, Nn.prototype.takeRightWhile = function(g) {
        return this.reverse().takeWhile(g).reverse();
      }, Nn.prototype.toArray = function() {
        return this.take(j);
      }, zs(Nn.prototype, function(g, C) {
        var T = /^(?:filter|find|map|reject)|While$/.test(C), H = /^(?:head|last)$/.test(C), J = re[H ? "take" + (C == "last" ? "Right" : "") : C], ae = H || /^find/.test(C);
        J && (re.prototype[C] = function() {
          var me = this.__wrapped__, xe = H ? [1] : arguments, Te = me instanceof Nn, Ge = xe[0], Ue = Te || pn(me), Qe = function(Tn) {
            var Fn = J.apply(re, wa([Tn], xe));
            return H && xt ? Fn[0] : Fn;
          };
          Ue && T && typeof Ge == "function" && Ge.length != 1 && (Te = Ue = !1);
          var xt = this.__chain__, Ft = !!this.__actions__.length, Zt = ae && !xt, yn = Te && !Ft;
          if (!ae && Ue) {
            me = yn ? me : new Nn(this);
            var Jt = g.apply(me, xe);
            return Jt.__actions__.push({ func: O1, args: [Qe], thisArg: n }), new _a(Jt, xt);
          }
          return Zt && yn ? g.apply(this, xe) : (Jt = this.thru(Qe), Zt ? H ? Jt.value()[0] : Jt.value() : Jt);
        });
      }), mo(["pop", "push", "shift", "sort", "splice", "unshift"], function(g) {
        var C = t1[g], T = /^(?:push|sort|unshift)$/.test(g) ? "tap" : "thru", H = /^(?:pop|shift)$/.test(g);
        re.prototype[g] = function() {
          var J = arguments;
          if (H && !this.__chain__) {
            var ae = this.value();
            return C.apply(pn(ae) ? ae : [], J);
          }
          return this[T](function(me) {
            return C.apply(pn(me) ? me : [], J);
          });
        };
      }), zs(Nn.prototype, function(g, C) {
        var T = re[C];
        if (T) {
          var H = T.name + "";
          cr.call(If, H) || (If[H] = []), If[H].push({ name: C, func: T });
        }
      }), If[w1(n, b).name] = [{
        name: "wrapper",
        func: n
      }], Nn.prototype.clone = Noe, Nn.prototype.reverse = koe, Nn.prototype.value = Roe, re.prototype.at = uue, re.prototype.chain = lue, re.prototype.commit = cue, re.prototype.next = due, re.prototype.plant = hue, re.prototype.reverse = pue, re.prototype.toJSON = re.prototype.valueOf = re.prototype.value = gue, re.prototype.first = re.prototype.head, ag && (re.prototype[ag] = fue), re;
    }, wf = coe();
    js ? ((js.exports = wf)._ = wf, vf._ = wf) : gi._ = wf;
  }).call(ft);
})(Ux, Ux.exports);
var uM = Ux.exports;
const Mje = (t) => {
  var P;
  const {
    error: e,
    options: n,
    layout: r = "vertical",
    config: i = {},
    renderLabel: o,
    field: {
      colProps: a,
      name: s,
      input: { type: u, inputProps: l, ...c } = { type: "string" },
      label: d,
      tooltip: f,
      ...h
    }
  } = t, { fieldKey: p, readOnly: v = !1, locale: m } = n || {};
  let b = s;
  if (Array.isArray(b) && (b = b.join("/==")), !((P = z2[u]) != null && P.component))
    return /* @__PURE__ */ Oe.jsxs("div", { children: [
      "Component of type ",
      u,
      " is not handle by your configuration"
    ] });
  const {
    component: y,
    valuePropName: w,
    showFormItemError: S,
    ...E
  } = z2[u], I = {
    readOnly: v,
    ...c,
    layout: r,
    locale: m,
    name: s,
    config: E,
    error: e
  }, _ = f ? {
    title: f,
    icon: i.tooltipIcon || /* @__PURE__ */ Oe.jsx(dC, {})
  } : null, A = u === "list" ? /* @__PURE__ */ Oe.jsx(
    y,
    {
      ...I,
      ...h,
      label: d,
      errors: e,
      inputProps: l
    }
  ) : /* @__PURE__ */ Oe.jsx("span", { "data-testid": b, children: /* @__PURE__ */ Oe.jsx(
    bd.Item,
    {
      name: sM(p) ? b : [p, b],
      ...sM(p) ? {} : { fieldKey: [p, b] },
      ...uM.omit(h, ["condition"]),
      tooltip: o ? void 0 : _,
      className: `${h.className || ""} ant-form-item-${u}`,
      ...w ? { valuePropName: w } : {},
      ...(S === void 0 || S) && e && {
        validateStatus: "error",
        help: iC(e) ? e[0] : e
      },
      ...o ? { colon: !1 } : {},
      label: o && d ? o(d, { tooltip: _ }) : d,
      children: /* @__PURE__ */ Oe.jsx(
        y,
        {
          renderLabel: o,
          ...I,
          ...uM.omit(h, ["defaultValue"]),
          inputProps: l
        }
      )
    }
  ) });
  return a ? /* @__PURE__ */ Oe.jsx(rc, { ...a, children: A }) : A;
}, Fje = O.memo(
  Mje,
  XZ(["field", "error", "options.locale", "options.readOnly"])
);
var Lje = ZX;
function Vje(t, e) {
  var n;
  return Lje(t, function(r, i, o) {
    return n = e(r, i, o), !n;
  }), !!n;
}
var Bje = Vje, Hje = PC, Wje = zm, jje = DC, zje = Ds;
function Gje(t, e, n) {
  if (!zje(n))
    return !1;
  var r = typeof e;
  return (r == "number" ? Wje(n) && jje(e, n.length) : r == "string" && e in n) ? Hje(n[e], t) : !1;
}
var Uje = Gje, Xje = cX, Yje = YX, Zje = Bje, Jje = Mo, Kje = Uje;
function qje(t, e, n) {
  var r = Jje(t) ? Xje : Zje;
  return n && Kje(t, e, n) && (e = void 0), r(t, Yje(e));
}
var Qje = qje;
const eze = /* @__PURE__ */ qn(Qje), tze = (t) => {
  const {
    fields: e,
    readOnlyItems: n = [],
    inactiveItems: r = [],
    config: i = {},
    errors: o,
    rowProps: a,
    layout: s = "horizontal",
    options: u = {},
    renderLabel: l
  } = t;
  if (!e)
    return null;
  const c = eze(e, (f) => f == null ? void 0 : f.colProps), d = e.map((f, h) => /* @__PURE__ */ Oe.jsx(
    hT,
    {
      layout: s,
      readOnlyItems: n,
      inactiveItems: r,
      config: i,
      item: f,
      renderLabel: l,
      errors: o,
      rowProps: a,
      ...u || {}
    },
    h
  ));
  return /* @__PURE__ */ Oe.jsx(ma.Group, { compact: !c, children: c ? /* @__PURE__ */ Oe.jsx(Wm, { ...a || {}, children: d }) : d });
}, hT = (t) => {
  const {
    item: e,
    errors: n,
    config: r = {},
    rowProps: i = {},
    readOnlyItems: o = [],
    readOnly: a = !1,
    locale: s,
    layout: u,
    fieldKey: l,
    fieldName: c,
    inactiveItems: d = [],
    renderLabel: f
  } = t;
  if (iC(e))
    return e.length === 0 || d.length > 0 && e.filter(YZ(d)).length === 0 ? null : /* @__PURE__ */ Oe.jsx(
      tze,
      {
        layout: u,
        inactiveItems: d,
        readOnlyItems: o,
        config: r,
        errors: n,
        renderLabel: f,
        fields: e,
        rowProps: i,
        options: {
          fieldKey: l,
          fieldName: c,
          locale: s,
          readOnly: a
        }
      }
    );
  if (Oje(e))
    return e;
  if (wu(e)) {
    const { errorKey: h, ...p } = e;
    return !Pje(e) || p != null && p.name && d.includes(p.name) ? null : /* @__PURE__ */ Oe.jsx(
      Fje,
      {
        layout: u,
        config: r,
        options: {
          fieldKey: l,
          fieldName: c,
          readOnly: (a || o.includes(p.name)) && p.readOnly !== !1,
          locale: s
        },
        field: p,
        renderLabel: f,
        error: ii(n, h || p.name, null)
      },
      p.key || p.name
    );
  }
  return /* @__PURE__ */ Oe.jsx("div", {});
}, nze = (t) => {
  const {
    name: e,
    schema: n,
    errors: r,
    inputProps: { itemHeader: i, remove: o, add: a }
  } = t;
  return /* @__PURE__ */ Oe.jsx(bd.List, { name: e, children: (s, { add: u, remove: l }) => /* @__PURE__ */ Oe.jsxs(Oe.Fragment, { children: [
    s.map((c) => /* @__PURE__ */ Oe.jsxs(Wm, { children: [
      i && /* @__PURE__ */ Oe.jsx(rc, { span: 24, children: i({ add: u, remove: l, field: c }) }),
      n.map((d, f) => /* @__PURE__ */ Oe.jsx(
        hT,
        {
          item: d,
          errors: r,
          fieldName: c.name,
          fieldKey: c.fieldKey
        },
        f
      )),
      o ? /* @__PURE__ */ Oe.jsx(bd.Item, { children: typeof o == "function" ? o(l) : /* @__PURE__ */ Oe.jsx(ko, { type: "dashed", onClick: () => u(), children: o }) }) : null
    ] }, c.name)),
    u ? /* @__PURE__ */ Oe.jsx(bd.Item, { children: typeof a == "function" ? a(u) : /* @__PURE__ */ Oe.jsx(ko, { type: "dashed", onClick: () => u(), children: a }) }) : "Add"
  ] }) });
}, { Search: rze } = ma, ize = (t) => {
  const {
    value: e,
    inputProps: n = {},
    onChange: r
  } = t, [i, o] = Le(e);
  Re(() => o(e), [e]);
  const a = ({ target: { value: u } }) => {
    r(u), o(u);
  }, s = (u) => {
    r(u), n.onSearch && n.onSearch(u);
  };
  return /* @__PURE__ */ Oe.jsx(
    rze,
    {
      ...n || {},
      onChange: a,
      onSearch: s,
      value: i
    }
  );
}, oze = (t, e) => e.label.toLowerCase().normalize("NFD").replace(/[\u0300-\u036f]/g, "").indexOf(
  t.toLowerCase().normalize("NFD").replace(/[\u0300-\u036f]/g, "")
) >= 0, aze = O.memo((t) => {
  var l;
  const { options: e, onChange: n, value: r, readOnly: i = !1, inputProps: o = {}, ...a } = t, {
    allowClear: s = !0
  } = o;
  if (i && o.mode !== "multiple")
    return /* @__PURE__ */ Oe.jsx(ma, { readOnly: !0, value: r ? (l = e.find((c) => c.value === r)) == null ? void 0 : l.label : void 0 });
  const u = va(a, hl);
  return /* @__PURE__ */ Oe.jsx(
    As,
    {
      filterOption: oze,
      showSearch: !0,
      ...o || {},
      ...u,
      allowClear: s,
      onChange: n,
      value: o.mode && o.mode === "multiple" && !r ? [] : r,
      disabled: i || o.disabled,
      children: e.map(({ value: c, label: d, disabled: f, children: h, options: p }) => p && p.length > 0 ? /* @__PURE__ */ Oe.jsx(As.OptGroup, { label: d, children: p.map((v) => /* @__PURE__ */ Oe.jsx(As.Option, { value: v.value, label: v.label, disabled: v.disabled, children: v.children || v.label }, v.value)) }, d) : /* @__PURE__ */ Oe.jsx(As.Option, { value: c, label: d, disabled: f, children: h || d }, c))
    }
  );
}, XZ(["options", "readOnly", "value"]));
function sze(t, e, n, r) {
  for (var i = t.length, o = n + (r ? 1 : -1); r ? o-- : ++o < i; )
    if (e(t[o], o, t))
      return o;
  return -1;
}
var uze = sze;
function lze(t) {
  return t !== t;
}
var cze = lze;
function dze(t, e, n) {
  for (var r = n - 1, i = t.length; ++r < i; )
    if (t[r] === e)
      return r;
  return -1;
}
var fze = dze, hze = uze, pze = cze, gze = fze;
function mze(t, e, n) {
  return e === e ? gze(t, e, n) : hze(t, pze, n);
}
var pT = mze, vze = pT;
function bze(t, e) {
  for (var n = t.length; n-- && vze(e, t[n], 0) > -1; )
    ;
  return n;
}
var yze = bze, xze = pT;
function Cze(t, e) {
  for (var n = -1, r = t.length; ++n < r && xze(e, t[n], 0) > -1; )
    ;
  return n;
}
var wze = Cze, Eze = K6, Sze = aU, Ize = q6, _ze = yze, Aze = wze, lM = Q6, Tze = zd;
function Oze(t, e, n) {
  if (t = Tze(t), t && (n || e === void 0))
    return Sze(t);
  if (!t || !(e = Eze(e)))
    return t;
  var r = lM(t), i = lM(e), o = Aze(r, i), a = _ze(r, i) + 1;
  return Ize(r, o, a).join("");
}
var Pze = Oze;
const Nze = /* @__PURE__ */ qn(Pze), kze = (t = "") => {
  if (typeof t != "string")
    return t;
  const e = t.split(`
`).filter((n) => Nze(n).length > 0);
  return e.map((n, r) => /* @__PURE__ */ Oe.jsxs(O.Fragment, { children: [
    n,
    r < e.length - 1 && /* @__PURE__ */ Oe.jsx("br", {})
  ] }, `line${r}`));
}, Rze = (t) => {
  var v;
  const { inputProps: e, onChange: n, localize: r = !1, readOnly: i = !1, locale: o, value: a, name: s } = t, {
    inPlace: u,
    editingField: l,
    setEditingField: c
  } = fn(fT), [d, f] = Le(a);
  Re(() => {
    f(a);
  }, [a]);
  const h = ({ target: { value: m } }) => {
    const b = r && o ? { ...t.value, [o]: m } : m;
    u ? f(b) : n(b);
  };
  let p = u ? d : a;
  if (r && o && p && (p = o in p && p[o] ? p[o] : void 0), u) {
    const m = s === l;
    if (m && !i) {
      const y = () => {
        n(d), c(void 0);
      }, w = () => {
        f(a), c(void 0);
      }, S = () => {
        d === a ? w() : y();
      }, E = (I) => {
        m && I.keyCode === 13 && I.shiftKey && y(), m && I.keyCode === 27 && w();
      };
      return /* @__PURE__ */ Oe.jsx("div", { className: "ant-form-InPlace-input-container", onBlur: S, children: /* @__PURE__ */ Oe.jsx(
        ma.TextArea,
        {
          name: s,
          ...e || {},
          value: p,
          autoFocus: !0,
          onKeyDown: E,
          onChange: h,
          autoSize: !0
        }
      ) });
    }
    const b = () => c(s);
    return /* @__PURE__ */ Oe.jsx("div", { onClick: b, children: kze(p && ((v = p == null ? void 0 : p.toString()) == null ? void 0 : v.trim()) !== "" ? p : "-") });
  }
  return /* @__PURE__ */ Oe.jsx(
    ma.TextArea,
    {
      name: s,
      ...e || {},
      readOnly: i,
      value: p,
      onChange: h,
      autoSize: !0
    }
  );
};
class $ze extends O.Component {
  constructor(n) {
    super(n);
    xg(this, "state", {
      value: []
    });
    this.state = {
      value: n.value || (n.multiple ? [] : null)
    };
  }
  static getDerivedStateFromProps(n) {
    return "value" in n ? {
      ...n.value ? { value: n.value } : {}
    } : null;
  }
  render() {
    const {
      readOnly: n = !1,
      buttonProps: r = {},
      onChange: i,
      addComponent: o,
      placeholder: a,
      multiple: s = !1,
      ...u
    } = this.props, l = (h) => (this.setState((p) => {
      const v = s ? [...p.value || [], h] : [h];
      return i(s ? v : v[0]), {
        ...p,
        value: v
      };
    }), !1), c = (h) => (this.setState((p) => {
      const v = p.value || [];
      if (s) {
        const m = v.findIndex((y) => y.uid === h.uid), b = v.slice();
        return this.props.onRemove && this.props.onRemove(m), b.splice(m, 1), i(b), {
          value: b
        };
      } else
        return i(void 0), this.props.onRemove && this.props.onRemove(), {
          value: void 0
        };
    }), !1);
    let d = this.state.value;
    d ? iC(d) || (d = [d]) : d = [];
    const f = va(u, [...hl, "value"]);
    return /* @__PURE__ */ Oe.jsx(
      IAe,
      {
        ...f,
        multiple: s,
        fileList: d,
        onRemove: c,
        beforeUpload: l,
        children: !n && /* @__PURE__ */ Oe.jsx(Oe.Fragment, { children: o || /* @__PURE__ */ Oe.jsx(ko, { icon: /* @__PURE__ */ Oe.jsx(_j, {}), ...r, children: a || "Select file" }) })
      }
    );
  }
}
const Dze = (t) => {
  const { value: e, options: n, onChange: r, inputProps: i } = t, [o, a] = Le(t.value || []);
  Re(() => {
    a(t.value || []);
  }, [e]);
  const s = (l) => {
    a(l), r(l);
  };
  let u = n.map((l) => ({ ...l, key: l.value }));
  return (
    // @ts-ignore
    /* @__PURE__ */ Oe.jsx(
      iAe,
      {
        ...i,
        dataSource: u,
        targetKeys: o,
        render: (l) => l.label,
        onChange: s
      }
    )
  );
}, Mze = TC(sv), Fze = (t) => {
  var a;
  const { readOnly: e, value: n } = t, r = fn(dT);
  let i = n;
  if (i && !uc.isDayjs(i) && Or(i).isValid() && (i = Or(i)), e)
    return /* @__PURE__ */ Oe.jsx(
      ma,
      {
        readOnly: !0,
        value: i && uc.isDayjs(i) ? i.format(((a = t.inputProps) == null ? void 0 : a.format) || (r == null ? void 0 : r.dateFormat) || "L") : void 0
      }
    );
  const o = va(t, ["renderLabel"]);
  return /* @__PURE__ */ Oe.jsx(
    Mze,
    {
      style: { width: "100%" },
      format: "L",
      ...o,
      value: i,
      onChange: t.onChange
    }
  );
}, Lze = TC(sv), Vze = (t) => {
  var n;
  let e;
  return t.value && (e = uc.isDayjs(t.value) ? t.value : Or(t.value)), t.readOnly ? /* @__PURE__ */ Oe.jsx(
    ma,
    {
      readOnly: !0,
      value: e && uc.isDayjs(e) ? e.format(((n = t.inputProps) == null ? void 0 : n.format) || "HH:mm") : void 0
    }
  ) : /* @__PURE__ */ Oe.jsx(Lze, { style: { width: "100%" }, ...t, picker: "time", value: e });
};
var Bze = "2.0.8";
const Cd = "[data-trix-attachment]", gT = { preview: { presentation: "gallery", caption: { name: !0, size: !0 } }, file: { caption: { size: !0 } } }, Po = { default: { tagName: "div", parse: !1 }, quote: { tagName: "blockquote", nestable: !0 }, heading1: { tagName: "h1", terminal: !0, breakOnReturn: !0, group: !1 }, code: { tagName: "pre", terminal: !0, text: { plaintext: !0 } }, bulletList: { tagName: "ul", parse: !1 }, bullet: { tagName: "li", listAttribute: "bulletList", group: !1, nestable: !0, test(t) {
  return cM(t.parentNode) === Po[this.listAttribute].tagName;
} }, numberList: { tagName: "ol", parse: !1 }, number: { tagName: "li", listAttribute: "numberList", group: !1, nestable: !0, test(t) {
  return cM(t.parentNode) === Po[this.listAttribute].tagName;
} }, attachmentGallery: { tagName: "div", exclusive: !0, terminal: !0, parse: !1, group: !1 } }, cM = (t) => {
  var e;
  return t == null || (e = t.tagName) === null || e === void 0 ? void 0 : e.toLowerCase();
}, dM = navigator.userAgent.match(/android\s([0-9]+.*Chrome)/i), k3 = dM && parseInt(dM[1]);
var uv = { composesExistingText: /Android.*Chrome/.test(navigator.userAgent), recentAndroid: k3 && k3 > 12, samsungAndroid: k3 && navigator.userAgent.match(/Android.*SM-/), forcesObjectResizing: /Trident.*rv:11/.test(navigator.userAgent), supportsInputEvents: typeof InputEvent < "u" && ["data", "getTargetRanges", "inputType"].every((t) => t in InputEvent.prototype) }, mn = { attachFiles: "Attach Files", bold: "Bold", bullets: "Bullets", byte: "Byte", bytes: "Bytes", captionPlaceholder: "Add a caption…", code: "Code", heading1: "Heading", indent: "Increase Level", italic: "Italic", link: "Link", numbers: "Numbers", outdent: "Decrease Level", quote: "Quote", redo: "Redo", remove: "Remove", strike: "Strikethrough", undo: "Undo", unlink: "Unlink", url: "URL", urlPlaceholder: "Enter a URL…", GB: "GB", KB: "KB", MB: "MB", PB: "PB", TB: "TB" };
const Hze = [mn.bytes, mn.KB, mn.MB, mn.GB, mn.TB, mn.PB];
var ZZ = { prefix: "IEC", precision: 2, formatter(t) {
  switch (t) {
    case 0:
      return "0 ".concat(mn.bytes);
    case 1:
      return "1 ".concat(mn.byte);
    default:
      let e;
      this.prefix === "SI" ? e = 1e3 : this.prefix === "IEC" && (e = 1024);
      const n = Math.floor(Math.log(t) / Math.log(e)), r = (t / Math.pow(e, n)).toFixed(this.precision).replace(/0*$/, "").replace(/\.$/, "");
      return "".concat(r, " ").concat(Hze[n]);
  }
} };
const sw = "\uFEFF", Gl = " ", JZ = function(t) {
  for (const e in t) {
    const n = t[e];
    this[e] = n;
  }
  return this;
}, mT = document.documentElement, Wze = mT.matches, jr = function(t) {
  let { onElement: e, matchingSelector: n, withCallback: r, inPhase: i, preventDefault: o, times: a } = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
  const s = e || mT, u = n, l = i === "capturing", c = function(d) {
    a != null && --a == 0 && c.destroy();
    const f = hc(d.target, { matchingSelector: u });
    f != null && (r == null || r.call(f, d, f), o && d.preventDefault());
  };
  return c.destroy = () => s.removeEventListener(t, c, l), s.addEventListener(t, c, l), c;
}, y0 = function(t) {
  let { onElement: e, bubbles: n, cancelable: r, attributes: i } = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
  const o = e ?? mT;
  n = n !== !1, r = r !== !1;
  const a = document.createEvent("Events");
  return a.initEvent(t, n, r), i != null && JZ.call(a, i), o.dispatchEvent(a);
}, KZ = function(t, e) {
  if ((t == null ? void 0 : t.nodeType) === 1)
    return Wze.call(t, e);
}, hc = function(t) {
  let { matchingSelector: e, untilNode: n } = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
  for (; t && t.nodeType !== Node.ELEMENT_NODE; )
    t = t.parentNode;
  if (t != null) {
    if (e == null)
      return t;
    if (t.closest && n == null)
      return t.closest(e);
    for (; t && t !== n; ) {
      if (KZ(t, e))
        return t;
      t = t.parentNode;
    }
  }
}, vT = (t) => document.activeElement !== t && fd(t, document.activeElement), fd = function(t, e) {
  if (t && e)
    for (; e; ) {
      if (e === t)
        return !0;
      e = e.parentNode;
    }
}, R3 = function(t) {
  var e;
  if ((e = t) === null || e === void 0 || !e.parentNode)
    return;
  let n = 0;
  for (t = t.previousSibling; t; )
    n++, t = t.previousSibling;
  return n;
}, pc = (t) => {
  var e;
  return t == null || (e = t.parentNode) === null || e === void 0 ? void 0 : e.removeChild(t);
}, Xx = function(t) {
  let { onlyNodesOfType: e, usingFilter: n, expandEntityReferences: r } = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
  const i = (() => {
    switch (e) {
      case "element":
        return NodeFilter.SHOW_ELEMENT;
      case "text":
        return NodeFilter.SHOW_TEXT;
      case "comment":
        return NodeFilter.SHOW_COMMENT;
      default:
        return NodeFilter.SHOW_ALL;
    }
  })();
  return document.createTreeWalker(t, i, n ?? null, r === !0);
}, _o = (t) => {
  var e;
  return t == null || (e = t.tagName) === null || e === void 0 ? void 0 : e.toLowerCase();
}, Pn = function(t) {
  let e, n, r = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
  typeof t == "object" ? (r = t, t = r.tagName) : r = { attributes: r };
  const i = document.createElement(t);
  if (r.editable != null && (r.attributes == null && (r.attributes = {}), r.attributes.contenteditable = r.editable), r.attributes)
    for (e in r.attributes)
      n = r.attributes[e], i.setAttribute(e, n);
  if (r.style)
    for (e in r.style)
      n = r.style[e], i.style[e] = n;
  if (r.data)
    for (e in r.data)
      n = r.data[e], i.dataset[e] = n;
  return r.className && r.className.split(" ").forEach((o) => {
    i.classList.add(o);
  }), r.textContent && (i.textContent = r.textContent), r.childNodes && [].concat(r.childNodes).forEach((o) => {
    i.appendChild(o);
  }), i;
};
let Fg;
const x0 = function() {
  if (Fg != null)
    return Fg;
  Fg = [];
  for (const t in Po) {
    const e = Po[t];
    e.tagName && Fg.push(e.tagName);
  }
  return Fg;
}, $3 = (t) => Bh(t == null ? void 0 : t.firstChild), fM = function(t) {
  let { strict: e } = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : { strict: !0 };
  return e ? Bh(t) : Bh(t) || !Bh(t.firstChild) && function(n) {
    return x0().includes(_o(n)) && !x0().includes(_o(n.firstChild));
  }(t);
}, Bh = (t) => jze(t) && (t == null ? void 0 : t.data) === "block", jze = (t) => (t == null ? void 0 : t.nodeType) === Node.COMMENT_NODE, Hh = function(t) {
  let { name: e } = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
  if (t)
    return C0(t) ? t.data === sw ? !e || t.parentNode.dataset.trixCursorTarget === e : void 0 : Hh(t.firstChild);
}, wd = (t) => KZ(t, Cd), qZ = (t) => C0(t) && (t == null ? void 0 : t.data) === "", C0 = (t) => (t == null ? void 0 : t.nodeType) === Node.TEXT_NODE, bT = { level2Enabled: !0, getLevel() {
  return this.level2Enabled && uv.supportsInputEvents ? 2 : 0;
}, pickFiles(t) {
  const e = Pn("input", { type: "file", multiple: !0, hidden: !0, id: this.fileInputId });
  e.addEventListener("change", () => {
    t(e.files), pc(e);
  }), pc(document.getElementById(this.fileInputId)), document.body.appendChild(e), e.click();
} };
var by = { removeBlankTableCells: !1, tableCellSeparator: " | ", tableRowSeparator: `
` }, $d = { bold: { tagName: "strong", inheritable: !0, parser(t) {
  const e = window.getComputedStyle(t);
  return e.fontWeight === "bold" || e.fontWeight >= 600;
} }, italic: { tagName: "em", inheritable: !0, parser: (t) => window.getComputedStyle(t).fontStyle === "italic" }, href: { groupTagName: "a", parser(t) {
  const e = "a:not(".concat(Cd, ")"), n = t.closest(e);
  if (n)
    return n.getAttribute("href");
} }, strike: { tagName: "del", inheritable: !0 }, frozen: { style: { backgroundColor: "highlight" } } }, QZ = { getDefaultHTML: () => `<div class="trix-button-row">
      <span class="trix-button-group trix-button-group--text-tools" data-trix-button-group="text-tools">
        <button type="button" class="trix-button trix-button--icon trix-button--icon-bold" data-trix-attribute="bold" data-trix-key="b" title="`.concat(mn.bold, '" tabindex="-1">').concat(mn.bold, `</button>
        <button type="button" class="trix-button trix-button--icon trix-button--icon-italic" data-trix-attribute="italic" data-trix-key="i" title="`).concat(mn.italic, '" tabindex="-1">').concat(mn.italic, `</button>
        <button type="button" class="trix-button trix-button--icon trix-button--icon-strike" data-trix-attribute="strike" title="`).concat(mn.strike, '" tabindex="-1">').concat(mn.strike, `</button>
        <button type="button" class="trix-button trix-button--icon trix-button--icon-link" data-trix-attribute="href" data-trix-action="link" data-trix-key="k" title="`).concat(mn.link, '" tabindex="-1">').concat(mn.link, `</button>
      </span>

      <span class="trix-button-group trix-button-group--block-tools" data-trix-button-group="block-tools">
        <button type="button" class="trix-button trix-button--icon trix-button--icon-heading-1" data-trix-attribute="heading1" title="`).concat(mn.heading1, '" tabindex="-1">').concat(mn.heading1, `</button>
        <button type="button" class="trix-button trix-button--icon trix-button--icon-quote" data-trix-attribute="quote" title="`).concat(mn.quote, '" tabindex="-1">').concat(mn.quote, `</button>
        <button type="button" class="trix-button trix-button--icon trix-button--icon-code" data-trix-attribute="code" title="`).concat(mn.code, '" tabindex="-1">').concat(mn.code, `</button>
        <button type="button" class="trix-button trix-button--icon trix-button--icon-bullet-list" data-trix-attribute="bullet" title="`).concat(mn.bullets, '" tabindex="-1">').concat(mn.bullets, `</button>
        <button type="button" class="trix-button trix-button--icon trix-button--icon-number-list" data-trix-attribute="number" title="`).concat(mn.numbers, '" tabindex="-1">').concat(mn.numbers, `</button>
        <button type="button" class="trix-button trix-button--icon trix-button--icon-decrease-nesting-level" data-trix-action="decreaseNestingLevel" title="`).concat(mn.outdent, '" tabindex="-1">').concat(mn.outdent, `</button>
        <button type="button" class="trix-button trix-button--icon trix-button--icon-increase-nesting-level" data-trix-action="increaseNestingLevel" title="`).concat(mn.indent, '" tabindex="-1">').concat(mn.indent, `</button>
      </span>

      <span class="trix-button-group trix-button-group--file-tools" data-trix-button-group="file-tools">
        <button type="button" class="trix-button trix-button--icon trix-button--icon-attach" data-trix-action="attachFiles" title="`).concat(mn.attachFiles, '" tabindex="-1">').concat(mn.attachFiles, `</button>
      </span>

      <span class="trix-button-group-spacer"></span>

      <span class="trix-button-group trix-button-group--history-tools" data-trix-button-group="history-tools">
        <button type="button" class="trix-button trix-button--icon trix-button--icon-undo" data-trix-action="undo" data-trix-key="z" title="`).concat(mn.undo, '" tabindex="-1">').concat(mn.undo, `</button>
        <button type="button" class="trix-button trix-button--icon trix-button--icon-redo" data-trix-action="redo" data-trix-key="shift+z" title="`).concat(mn.redo, '" tabindex="-1">').concat(mn.redo, `</button>
      </span>
    </div>

    <div class="trix-dialogs" data-trix-dialogs>
      <div class="trix-dialog trix-dialog--link" data-trix-dialog="href" data-trix-dialog-attribute="href">
        <div class="trix-dialog__link-fields">
          <input type="url" name="href" class="trix-input trix-input--dialog" placeholder="`).concat(mn.urlPlaceholder, '" aria-label="').concat(mn.url, `" required data-trix-input>
          <div class="trix-button-group">
            <input type="button" class="trix-button trix-button--dialog" value="`).concat(mn.link, `" data-trix-method="setAttribute">
            <input type="button" class="trix-button trix-button--dialog" value="`).concat(mn.unlink, `" data-trix-method="removeAttribute">
          </div>
        </div>
      </div>
    </div>`) };
const Y_ = { interval: 5e3 };
var lv = Object.freeze({ __proto__: null, attachments: gT, blockAttributes: Po, browser: uv, css: { attachment: "attachment", attachmentCaption: "attachment__caption", attachmentCaptionEditor: "attachment__caption-editor", attachmentMetadata: "attachment__metadata", attachmentMetadataContainer: "attachment__metadata-container", attachmentName: "attachment__name", attachmentProgress: "attachment__progress", attachmentSize: "attachment__size", attachmentToolbar: "attachment__toolbar", attachmentGallery: "attachment-gallery" }, fileSize: ZZ, input: bT, keyNames: { 8: "backspace", 9: "tab", 13: "return", 27: "escape", 37: "left", 39: "right", 46: "delete", 68: "d", 72: "h", 79: "o" }, lang: mn, parser: by, textAttributes: $d, toolbar: QZ, undo: Y_ });
let pi = class {
  static proxyMethod(e) {
    const { name: n, toMethod: r, toProperty: i, optional: o } = zze(e);
    this.prototype[n] = function() {
      let a, s;
      var u, l;
      return r ? s = o ? (u = this[r]) === null || u === void 0 ? void 0 : u.call(this) : this[r]() : i && (s = this[i]), o ? (a = (l = s) === null || l === void 0 ? void 0 : l[n], a ? hM.call(a, s, arguments) : void 0) : (a = s[n], hM.call(a, s, arguments));
    };
  }
};
const zze = function(t) {
  const e = t.match(Gze);
  if (!e)
    throw new Error("can't parse @proxyMethod expression: ".concat(t));
  const n = { name: e[4] };
  return e[2] != null ? n.toMethod = e[1] : n.toProperty = e[1], e[3] != null && (n.optional = !0), n;
}, { apply: hM } = Function.prototype, Gze = new RegExp("^(.+?)(\\(\\))?(\\?)?\\.(.+?)$");
var D3, M3, F3;
let am = class extends pi {
  static box() {
    let e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "";
    return e instanceof this ? e : this.fromUCS2String(e == null ? void 0 : e.toString());
  }
  static fromUCS2String(e) {
    return new this(e, Z_(e));
  }
  static fromCodepoints(e) {
    return new this(J_(e), e);
  }
  constructor(e, n) {
    super(...arguments), this.ucs2String = e, this.codepoints = n, this.length = this.codepoints.length, this.ucs2Length = this.ucs2String.length;
  }
  offsetToUCS2Offset(e) {
    return J_(this.codepoints.slice(0, Math.max(0, e))).length;
  }
  offsetFromUCS2Offset(e) {
    return Z_(this.ucs2String.slice(0, Math.max(0, e))).length;
  }
  slice() {
    return this.constructor.fromCodepoints(this.codepoints.slice(...arguments));
  }
  charAt(e) {
    return this.slice(e, e + 1);
  }
  isEqualTo(e) {
    return this.constructor.box(e).ucs2String === this.ucs2String;
  }
  toJSON() {
    return this.ucs2String;
  }
  getCacheKey() {
    return this.ucs2String;
  }
  toString() {
    return this.ucs2String;
  }
};
const Uze = ((D3 = Array.from) === null || D3 === void 0 ? void 0 : D3.call(Array, "👼").length) === 1, Xze = ((M3 = " ".codePointAt) === null || M3 === void 0 ? void 0 : M3.call(" ", 0)) != null, Yze = ((F3 = String.fromCodePoint) === null || F3 === void 0 ? void 0 : F3.call(String, 32, 128124)) === " 👼";
let Z_, J_;
Z_ = Uze && Xze ? (t) => Array.from(t).map((e) => e.codePointAt(0)) : function(t) {
  const e = [];
  let n = 0;
  const { length: r } = t;
  for (; n < r; ) {
    let i = t.charCodeAt(n++);
    if (55296 <= i && i <= 56319 && n < r) {
      const o = t.charCodeAt(n++);
      (64512 & o) == 56320 ? i = ((1023 & i) << 10) + (1023 & o) + 65536 : n--;
    }
    e.push(i);
  }
  return e;
}, J_ = Yze ? (t) => String.fromCodePoint(...Array.from(t || [])) : function(t) {
  return (() => {
    const e = [];
    return Array.from(t).forEach((n) => {
      let r = "";
      n > 65535 && (n -= 65536, r += String.fromCharCode(n >>> 10 & 1023 | 55296), n = 56320 | 1023 & n), e.push(r + String.fromCharCode(n));
    }), e;
  })().join("");
};
let Zze = 0, rf = class extends pi {
  static fromJSONString(e) {
    return this.fromJSON(JSON.parse(e));
  }
  constructor() {
    super(...arguments), this.id = ++Zze;
  }
  hasSameConstructorAs(e) {
    return this.constructor === (e == null ? void 0 : e.constructor);
  }
  isEqualTo(e) {
    return this === e;
  }
  inspect() {
    const e = [], n = this.contentsForInspection() || {};
    for (const r in n) {
      const i = n[r];
      e.push("".concat(r, "=").concat(i));
    }
    return "#<".concat(this.constructor.name, ":").concat(this.id).concat(e.length ? " ".concat(e.join(", ")) : "", ">");
  }
  contentsForInspection() {
  }
  toJSONString() {
    return JSON.stringify(this);
  }
  toUTF16String() {
    return am.box(this);
  }
  getCacheKey() {
    return this.id.toString();
  }
};
const Dd = function() {
  let t = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [], e = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : [];
  if (t.length !== e.length)
    return !1;
  for (let n = 0; n < t.length; n++)
    if (t[n] !== e[n])
      return !1;
  return !0;
}, yT = function(t) {
  const e = t.slice(0);
  for (var n = arguments.length, r = new Array(n > 1 ? n - 1 : 0), i = 1; i < n; i++)
    r[i - 1] = arguments[i];
  return e.splice(...r), e;
}, Jze = /[\u05BE\u05C0\u05C3\u05D0-\u05EA\u05F0-\u05F4\u061B\u061F\u0621-\u063A\u0640-\u064A\u066D\u0671-\u06B7\u06BA-\u06BE\u06C0-\u06CE\u06D0-\u06D5\u06E5\u06E6\u200F\u202B\u202E\uFB1F-\uFB28\uFB2A-\uFB36\uFB38-\uFB3C\uFB3E\uFB40\uFB41\uFB43\uFB44\uFB46-\uFBB1\uFBD3-\uFD3D\uFD50-\uFD8F\uFD92-\uFDC7\uFDF0-\uFDFB\uFE70-\uFE72\uFE74\uFE76-\uFEFC]/, Kze = function() {
  const t = Pn("input", { dir: "auto", name: "x", dirName: "x.dir" }), e = Pn("textarea", { dir: "auto", name: "y", dirName: "y.dir" }), n = Pn("form");
  n.appendChild(t), n.appendChild(e);
  const r = function() {
    try {
      return new FormData(n).has(e.dirName);
    } catch {
      return !1;
    }
  }(), i = function() {
    try {
      return t.matches(":dir(ltr),:dir(rtl)");
    } catch {
      return !1;
    }
  }();
  return r ? function(o) {
    return e.value = o, new FormData(n).get(e.dirName);
  } : i ? function(o) {
    return t.value = o, t.matches(":dir(rtl)") ? "rtl" : "ltr";
  } : function(o) {
    const a = o.trim().charAt(0);
    return Jze.test(a) ? "rtl" : "ltr";
  };
}();
let L3 = null, V3 = null, B3 = null, Ib = null;
const K_ = () => (L3 || (L3 = Qze().concat(qze())), L3), ui = (t) => Po[t], qze = () => (V3 || (V3 = Object.keys(Po)), V3), q_ = (t) => $d[t], Qze = () => (B3 || (B3 = Object.keys($d)), B3), eJ = function(t, e) {
  eGe(t).textContent = e.replace(/%t/g, t);
}, eGe = function(t) {
  const e = document.createElement("style");
  e.setAttribute("type", "text/css"), e.setAttribute("data-tag-name", t.toLowerCase());
  const n = tGe();
  return n && e.setAttribute("nonce", n), document.head.insertBefore(e, document.head.firstChild), e;
}, tGe = function() {
  const t = pM("trix-csp-nonce") || pM("csp-nonce");
  if (t)
    return t.getAttribute("content");
}, pM = (t) => document.head.querySelector("meta[name=".concat(t, "]")), gM = { "application/x-trix-feature-detection": "test" }, tJ = function(t) {
  const e = t.getData("text/plain"), n = t.getData("text/html");
  if (!e || !n)
    return e == null ? void 0 : e.length;
  {
    const { body: r } = new DOMParser().parseFromString(n, "text/html");
    if (r.textContent === e)
      return !r.querySelector("*");
  }
}, nJ = /Mac|^iP/.test(navigator.platform) ? (t) => t.metaKey : (t) => t.ctrlKey, xT = (t) => setTimeout(t, 1), rJ = function() {
  let t = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
  const e = {};
  for (const n in t) {
    const r = t[n];
    e[n] = r;
  }
  return e;
}, cv = function() {
  let t = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, e = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
  if (Object.keys(t).length !== Object.keys(e).length)
    return !1;
  for (const n in t)
    if (t[n] !== e[n])
      return !1;
  return !0;
}, dr = function(t) {
  if (t != null)
    return Array.isArray(t) || (t = [t, t]), [mM(t[0]), mM(t[1] != null ? t[1] : t[0])];
}, Ju = function(t) {
  if (t == null)
    return;
  const [e, n] = dr(t);
  return Q_(e, n);
}, Yx = function(t, e) {
  if (t == null || e == null)
    return;
  const [n, r] = dr(t), [i, o] = dr(e);
  return Q_(n, i) && Q_(r, o);
}, mM = function(t) {
  return typeof t == "number" ? t : rJ(t);
}, Q_ = function(t, e) {
  return typeof t == "number" ? t === e : cv(t, e);
};
let iJ = class extends pi {
  constructor() {
    super(...arguments), this.update = this.update.bind(this), this.selectionManagers = [];
  }
  start() {
    this.started || (this.started = !0, document.addEventListener("selectionchange", this.update, !0));
  }
  stop() {
    if (this.started)
      return this.started = !1, document.removeEventListener("selectionchange", this.update, !0);
  }
  registerSelectionManager(e) {
    if (!this.selectionManagers.includes(e))
      return this.selectionManagers.push(e), this.start();
  }
  unregisterSelectionManager(e) {
    if (this.selectionManagers = this.selectionManagers.filter((n) => n !== e), this.selectionManagers.length === 0)
      return this.stop();
  }
  notifySelectionManagersOfSelectionChange() {
    return this.selectionManagers.map((e) => e.selectionDidChange());
  }
  update() {
    this.notifySelectionManagersOfSelectionChange();
  }
  reset() {
    this.update();
  }
};
const Md = new iJ(), oJ = function() {
  const t = window.getSelection();
  if (t.rangeCount > 0)
    return t;
}, w0 = function() {
  var t;
  const e = (t = oJ()) === null || t === void 0 ? void 0 : t.getRangeAt(0);
  if (e && !nGe(e))
    return e;
}, aJ = function(t) {
  const e = window.getSelection();
  return e.removeAllRanges(), e.addRange(t), Md.update();
}, nGe = (t) => vM(t.startContainer) || vM(t.endContainer), vM = (t) => !Object.getPrototypeOf(t), i0 = (t) => t.replace(new RegExp("".concat(sw), "g"), "").replace(new RegExp("".concat(Gl), "g"), " "), CT = new RegExp("[^\\S".concat(Gl, "]")), wT = (t) => t.replace(new RegExp("".concat(CT.source), "g"), " ").replace(/\ {2,}/g, " "), bM = function(t, e) {
  if (t.isEqualTo(e))
    return ["", ""];
  const n = H3(t, e), { length: r } = n.utf16String;
  let i;
  if (r) {
    const { offset: o } = n, a = t.codepoints.slice(0, o).concat(t.codepoints.slice(o + r));
    i = H3(e, am.fromCodepoints(a));
  } else
    i = H3(e, t);
  return [n.utf16String.toString(), i.utf16String.toString()];
}, H3 = function(t, e) {
  let n = 0, r = t.length, i = e.length;
  for (; n < r && t.charAt(n).isEqualTo(e.charAt(n)); )
    n++;
  for (; r > n + 1 && t.charAt(r - 1).isEqualTo(e.charAt(i - 1)); )
    r--, i--;
  return { utf16String: t.slice(n, r), offset: n };
};
let nl = class yy extends rf {
  static fromCommonAttributesOfObjects() {
    let e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [];
    if (!e.length)
      return new this();
    let n = Lg(e[0]), r = n.getKeys();
    return e.slice(1).forEach((i) => {
      r = n.getKeysCommonToHash(Lg(i)), n = n.slice(r);
    }), n;
  }
  static box(e) {
    return Lg(e);
  }
  constructor() {
    let e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    super(...arguments), this.values = xy(e);
  }
  add(e, n) {
    return this.merge(rGe(e, n));
  }
  remove(e) {
    return new yy(xy(this.values, e));
  }
  get(e) {
    return this.values[e];
  }
  has(e) {
    return e in this.values;
  }
  merge(e) {
    return new yy(iGe(this.values, oGe(e)));
  }
  slice(e) {
    const n = {};
    return Array.from(e).forEach((r) => {
      this.has(r) && (n[r] = this.values[r]);
    }), new yy(n);
  }
  getKeys() {
    return Object.keys(this.values);
  }
  getKeysCommonToHash(e) {
    return e = Lg(e), this.getKeys().filter((n) => this.values[n] === e.values[n]);
  }
  isEqualTo(e) {
    return Dd(this.toArray(), Lg(e).toArray());
  }
  isEmpty() {
    return this.getKeys().length === 0;
  }
  toArray() {
    if (!this.array) {
      const e = [];
      for (const n in this.values) {
        const r = this.values[n];
        e.push(e.push(n, r));
      }
      this.array = e.slice(0);
    }
    return this.array;
  }
  toObject() {
    return xy(this.values);
  }
  toJSON() {
    return this.toObject();
  }
  contentsForInspection() {
    return { values: JSON.stringify(this.values) };
  }
};
const rGe = function(t, e) {
  const n = {};
  return n[t] = e, n;
}, iGe = function(t, e) {
  const n = xy(t);
  for (const r in e) {
    const i = e[r];
    n[r] = i;
  }
  return n;
}, xy = function(t, e) {
  const n = {};
  return Object.keys(t).sort().forEach((r) => {
    r !== e && (n[r] = t[r]);
  }), n;
}, Lg = function(t) {
  return t instanceof nl ? t : new nl(t);
}, oGe = function(t) {
  return t instanceof nl ? t.values : t;
};
let ET = class {
  static groupObjects() {
    let e, n = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [], { depth: r, asTree: i } = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    i && r == null && (r = 0);
    const o = [];
    return Array.from(n).forEach((a) => {
      var s;
      if (e) {
        var u, l, c;
        if ((u = a.canBeGrouped) !== null && u !== void 0 && u.call(a, r) && (l = (c = e[e.length - 1]).canBeGroupedWith) !== null && l !== void 0 && l.call(c, a, r))
          return void e.push(a);
        o.push(new this(e, { depth: r, asTree: i })), e = null;
      }
      (s = a.canBeGrouped) !== null && s !== void 0 && s.call(a, r) ? e = [a] : o.push(a);
    }), e && o.push(new this(e, { depth: r, asTree: i })), o;
  }
  constructor() {
    let e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [], { depth: n, asTree: r } = arguments.length > 1 ? arguments[1] : void 0;
    this.objects = e, r && (this.depth = n, this.objects = this.constructor.groupObjects(this.objects, { asTree: r, depth: this.depth + 1 }));
  }
  getObjects() {
    return this.objects;
  }
  getDepth() {
    return this.depth;
  }
  getCacheKey() {
    const e = ["objectGroup"];
    return Array.from(this.getObjects()).forEach((n) => {
      e.push(n.getCacheKey());
    }), e.join("/");
  }
}, aGe = class extends pi {
  constructor() {
    let e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [];
    super(...arguments), this.objects = {}, Array.from(e).forEach((n) => {
      const r = JSON.stringify(n);
      this.objects[r] == null && (this.objects[r] = n);
    });
  }
  find(e) {
    const n = JSON.stringify(e);
    return this.objects[n];
  }
}, sGe = class {
  constructor(e) {
    this.reset(e);
  }
  add(e) {
    const n = yM(e);
    this.elements[n] = e;
  }
  remove(e) {
    const n = yM(e), r = this.elements[n];
    if (r)
      return delete this.elements[n], r;
  }
  reset() {
    let e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [];
    return this.elements = {}, Array.from(e).forEach((n) => {
      this.add(n);
    }), e;
  }
};
const yM = (t) => t.dataset.trixStoreKey;
let Zx = class extends pi {
  isPerforming() {
    return this.performing === !0;
  }
  hasPerformed() {
    return this.performed === !0;
  }
  hasSucceeded() {
    return this.performed && this.succeeded;
  }
  hasFailed() {
    return this.performed && !this.succeeded;
  }
  getPromise() {
    return this.promise || (this.promise = new Promise((e, n) => (this.performing = !0, this.perform((r, i) => {
      this.succeeded = r, this.performing = !1, this.performed = !0, this.succeeded ? e(i) : n(i);
    })))), this.promise;
  }
  perform(e) {
    return e(!1);
  }
  release() {
    var e, n;
    (e = this.promise) === null || e === void 0 || (n = e.cancel) === null || n === void 0 || n.call(e), this.promise = null, this.performing = null, this.performed = null, this.succeeded = null;
  }
};
Zx.proxyMethod("getPromise().then"), Zx.proxyMethod("getPromise().catch");
let of = class extends pi {
  constructor(e) {
    let n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    super(...arguments), this.object = e, this.options = n, this.childViews = [], this.rootView = this;
  }
  getNodes() {
    return this.nodes || (this.nodes = this.createNodes()), this.nodes.map((e) => e.cloneNode(!0));
  }
  invalidate() {
    var e;
    return this.nodes = null, this.childViews = [], (e = this.parentView) === null || e === void 0 ? void 0 : e.invalidate();
  }
  invalidateViewForObject(e) {
    var n;
    return (n = this.findViewForObject(e)) === null || n === void 0 ? void 0 : n.invalidate();
  }
  findOrCreateCachedChildView(e, n, r) {
    let i = this.getCachedViewForObject(n);
    return i ? this.recordChildView(i) : (i = this.createChildView(...arguments), this.cacheViewForObject(i, n)), i;
  }
  createChildView(e, n) {
    let r = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
    n instanceof ET && (r.viewClass = e, e = uGe);
    const i = new e(n, r);
    return this.recordChildView(i);
  }
  recordChildView(e) {
    return e.parentView = this, e.rootView = this.rootView, this.childViews.push(e), e;
  }
  getAllChildViews() {
    let e = [];
    return this.childViews.forEach((n) => {
      e.push(n), e = e.concat(n.getAllChildViews());
    }), e;
  }
  findElement() {
    return this.findElementForObject(this.object);
  }
  findElementForObject(e) {
    const n = e == null ? void 0 : e.id;
    if (n)
      return this.rootView.element.querySelector("[data-trix-id='".concat(n, "']"));
  }
  findViewForObject(e) {
    for (const n of this.getAllChildViews())
      if (n.object === e)
        return n;
  }
  getViewCache() {
    return this.rootView !== this ? this.rootView.getViewCache() : this.isViewCachingEnabled() ? (this.viewCache || (this.viewCache = {}), this.viewCache) : void 0;
  }
  isViewCachingEnabled() {
    return this.shouldCacheViews !== !1;
  }
  enableViewCaching() {
    this.shouldCacheViews = !0;
  }
  disableViewCaching() {
    this.shouldCacheViews = !1;
  }
  getCachedViewForObject(e) {
    var n;
    return (n = this.getViewCache()) === null || n === void 0 ? void 0 : n[e.getCacheKey()];
  }
  cacheViewForObject(e, n) {
    const r = this.getViewCache();
    r && (r[n.getCacheKey()] = e);
  }
  garbageCollectCachedViews() {
    const e = this.getViewCache();
    if (e) {
      const n = this.getAllChildViews().concat(this).map((r) => r.object.getCacheKey());
      for (const r in e)
        n.includes(r) || delete e[r];
    }
  }
}, uGe = class extends of {
  constructor() {
    super(...arguments), this.objectGroup = this.object, this.viewClass = this.options.viewClass, delete this.options.viewClass;
  }
  getChildViews() {
    return this.childViews.length || Array.from(this.objectGroup.getObjects()).forEach((e) => {
      this.findOrCreateCachedChildView(this.viewClass, e, this.options);
    }), this.childViews;
  }
  createNodes() {
    const e = this.createContainerElement();
    return this.getChildViews().forEach((n) => {
      Array.from(n.getNodes()).forEach((r) => {
        e.appendChild(r);
      });
    }), [e];
  }
  createContainerElement() {
    let e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : this.objectGroup.getDepth();
    return this.getChildViews()[0].createContainerElement(e);
  }
};
const { css: $l } = lv;
let ST = class extends of {
  constructor() {
    super(...arguments), this.attachment = this.object, this.attachment.uploadProgressDelegate = this, this.attachmentPiece = this.options.piece;
  }
  createContentNodes() {
    return [];
  }
  createNodes() {
    let e;
    const n = e = Pn({ tagName: "figure", className: this.getClassName(), data: this.getData(), editable: !1 }), r = this.getHref();
    return r && (e = Pn({ tagName: "a", editable: !1, attributes: { href: r, tabindex: -1 } }), n.appendChild(e)), this.attachment.hasContent() ? e.innerHTML = this.attachment.getContent() : this.createContentNodes().forEach((i) => {
      e.appendChild(i);
    }), e.appendChild(this.createCaptionElement()), this.attachment.isPending() && (this.progressElement = Pn({ tagName: "progress", attributes: { class: $l.attachmentProgress, value: this.attachment.getUploadProgress(), max: 100 }, data: { trixMutable: !0, trixStoreKey: ["progressElement", this.attachment.id].join("/") } }), n.appendChild(this.progressElement)), [xM("left"), n, xM("right")];
  }
  createCaptionElement() {
    const e = Pn({ tagName: "figcaption", className: $l.attachmentCaption }), n = this.attachmentPiece.getCaption();
    if (n)
      e.classList.add("".concat($l.attachmentCaption, "--edited")), e.textContent = n;
    else {
      let r, i;
      const o = this.getCaptionConfig();
      if (o.name && (r = this.attachment.getFilename()), o.size && (i = this.attachment.getFormattedFilesize()), r) {
        const a = Pn({ tagName: "span", className: $l.attachmentName, textContent: r });
        e.appendChild(a);
      }
      if (i) {
        r && e.appendChild(document.createTextNode(" "));
        const a = Pn({ tagName: "span", className: $l.attachmentSize, textContent: i });
        e.appendChild(a);
      }
    }
    return e;
  }
  getClassName() {
    const e = [$l.attachment, "".concat($l.attachment, "--").concat(this.attachment.getType())], n = this.attachment.getExtension();
    return n && e.push("".concat($l.attachment, "--").concat(n)), e.join(" ");
  }
  getData() {
    const e = { trixAttachment: JSON.stringify(this.attachment), trixContentType: this.attachment.getContentType(), trixId: this.attachment.id }, { attributes: n } = this.attachmentPiece;
    return n.isEmpty() || (e.trixAttributes = JSON.stringify(n)), this.attachment.isPending() && (e.trixSerialize = !1), e;
  }
  getHref() {
    if (!lGe(this.attachment.getContent(), "a"))
      return this.attachment.getHref();
  }
  getCaptionConfig() {
    var e;
    const n = this.attachment.getType(), r = rJ((e = gT[n]) === null || e === void 0 ? void 0 : e.caption);
    return n === "file" && (r.name = !0), r;
  }
  findProgressElement() {
    var e;
    return (e = this.findElement()) === null || e === void 0 ? void 0 : e.querySelector("progress");
  }
  attachmentDidChangeUploadProgress() {
    const e = this.attachment.getUploadProgress(), n = this.findProgressElement();
    n && (n.value = e);
  }
};
const xM = (t) => Pn({ tagName: "span", textContent: sw, data: { trixCursorTarget: t, trixSerialize: !1 } }), lGe = function(t, e) {
  const n = Pn("div");
  return n.innerHTML = t || "", n.querySelector(e);
};
let sJ = class extends ST {
  constructor() {
    super(...arguments), this.attachment.previewDelegate = this;
  }
  createContentNodes() {
    return this.image = Pn({ tagName: "img", attributes: { src: "" }, data: { trixMutable: !0 } }), this.refresh(this.image), [this.image];
  }
  createCaptionElement() {
    const e = super.createCaptionElement(...arguments);
    return e.textContent || e.setAttribute("data-trix-placeholder", mn.captionPlaceholder), e;
  }
  refresh(e) {
    var n;
    if (e || (e = (n = this.findElement()) === null || n === void 0 ? void 0 : n.querySelector("img")), e)
      return this.updateAttributesForImage(e);
  }
  updateAttributesForImage(e) {
    const n = this.attachment.getURL(), r = this.attachment.getPreviewURL();
    if (e.src = r || n, r === n)
      e.removeAttribute("data-trix-serialized-attributes");
    else {
      const s = JSON.stringify({ src: n });
      e.setAttribute("data-trix-serialized-attributes", s);
    }
    const i = this.attachment.getWidth(), o = this.attachment.getHeight();
    i != null && (e.width = i), o != null && (e.height = o);
    const a = ["imageElement", this.attachment.id, e.src, e.width, e.height].join("/");
    e.dataset.trixStoreKey = a;
  }
  attachmentDidChangeAttributes() {
    return this.refresh(this.image), this.refresh();
  }
}, uJ = class extends of {
  constructor() {
    super(...arguments), this.piece = this.object, this.attributes = this.piece.getAttributes(), this.textConfig = this.options.textConfig, this.context = this.options.context, this.piece.attachment ? this.attachment = this.piece.attachment : this.string = this.piece.toString();
  }
  createNodes() {
    let e = this.attachment ? this.createAttachmentNodes() : this.createStringNodes();
    const n = this.createElement();
    if (n) {
      const r = function(i) {
        for (; (o = i) !== null && o !== void 0 && o.firstElementChild; ) {
          var o;
          i = i.firstElementChild;
        }
        return i;
      }(n);
      Array.from(e).forEach((i) => {
        r.appendChild(i);
      }), e = [n];
    }
    return e;
  }
  createAttachmentNodes() {
    const e = this.attachment.isPreviewable() ? sJ : ST;
    return this.createChildView(e, this.piece.attachment, { piece: this.piece }).getNodes();
  }
  createStringNodes() {
    var e;
    if ((e = this.textConfig) !== null && e !== void 0 && e.plaintext)
      return [document.createTextNode(this.string)];
    {
      const n = [], r = this.string.split(`
`);
      for (let i = 0; i < r.length; i++) {
        const o = r[i];
        if (i > 0) {
          const a = Pn("br");
          n.push(a);
        }
        if (o.length) {
          const a = document.createTextNode(this.preserveSpaces(o));
          n.push(a);
        }
      }
      return n;
    }
  }
  createElement() {
    let e, n, r;
    const i = {};
    for (n in this.attributes) {
      r = this.attributes[n];
      const a = q_(n);
      if (a) {
        if (a.tagName) {
          var o;
          const s = Pn(a.tagName);
          o ? (o.appendChild(s), o = s) : e = o = s;
        }
        if (a.styleProperty && (i[a.styleProperty] = r), a.style)
          for (n in a.style)
            r = a.style[n], i[n] = r;
      }
    }
    if (Object.keys(i).length)
      for (n in e || (e = Pn("span")), i)
        r = i[n], e.style[n] = r;
    return e;
  }
  createContainerElement() {
    for (const e in this.attributes) {
      const n = this.attributes[e], r = q_(e);
      if (r && r.groupTagName) {
        const i = {};
        return i[e] = n, Pn(r.groupTagName, i);
      }
    }
  }
  preserveSpaces(e) {
    return this.context.isLast && (e = e.replace(/\ $/, Gl)), e = e.replace(/(\S)\ {3}(\S)/g, "$1 ".concat(Gl, " $2")).replace(/\ {2}/g, "".concat(Gl, " ")).replace(/\ {2}/g, " ".concat(Gl)), (this.context.isFirst || this.context.followsWhitespace) && (e = e.replace(/^\ /, Gl)), e;
  }
}, lJ = class extends of {
  constructor() {
    super(...arguments), this.text = this.object, this.textConfig = this.options.textConfig;
  }
  createNodes() {
    const e = [], n = ET.groupObjects(this.getPieces()), r = n.length - 1;
    for (let o = 0; o < n.length; o++) {
      const a = n[o], s = {};
      o === 0 && (s.isFirst = !0), o === r && (s.isLast = !0), cGe(i) && (s.followsWhitespace = !0);
      const u = this.findOrCreateCachedChildView(uJ, a, { textConfig: this.textConfig, context: s });
      e.push(...Array.from(u.getNodes() || []));
      var i = a;
    }
    return e;
  }
  getPieces() {
    return Array.from(this.text.getPieces()).filter((e) => !e.hasAttribute("blockBreak"));
  }
};
const cGe = (t) => /\s$/.test(t == null ? void 0 : t.toString()), { css: CM } = lv;
let cJ = class extends of {
  constructor() {
    super(...arguments), this.block = this.object, this.attributes = this.block.getAttributes();
  }
  createNodes() {
    const e = [document.createComment("block")];
    if (this.block.isEmpty())
      e.push(Pn("br"));
    else {
      var n;
      const r = (n = ui(this.block.getLastAttribute())) === null || n === void 0 ? void 0 : n.text, i = this.findOrCreateCachedChildView(lJ, this.block.text, { textConfig: r });
      e.push(...Array.from(i.getNodes() || [])), this.shouldAddExtraNewlineElement() && e.push(Pn("br"));
    }
    if (this.attributes.length)
      return e;
    {
      let r;
      const { tagName: i } = Po.default;
      this.block.isRTL() && (r = { dir: "rtl" });
      const o = Pn({ tagName: i, attributes: r });
      return e.forEach((a) => o.appendChild(a)), [o];
    }
  }
  createContainerElement(e) {
    let n, r;
    const i = this.attributes[e], { tagName: o } = ui(i);
    if (e === 0 && this.block.isRTL() && (n = { dir: "rtl" }), i === "attachmentGallery") {
      const a = this.block.getBlockBreakPosition();
      r = "".concat(CM.attachmentGallery, " ").concat(CM.attachmentGallery, "--").concat(a);
    }
    return Pn({ tagName: o, className: r, attributes: n });
  }
  shouldAddExtraNewlineElement() {
    return /\n\n$/.test(this.block.toString());
  }
}, uw = class extends of {
  static render(e) {
    const n = Pn("div"), r = new this(e, { element: n });
    return r.render(), r.sync(), n;
  }
  constructor() {
    super(...arguments), this.element = this.options.element, this.elementStore = new sGe(), this.setDocument(this.object);
  }
  setDocument(e) {
    e.isEqualTo(this.document) || (this.document = this.object = e);
  }
  render() {
    if (this.childViews = [], this.shadowElement = Pn("div"), !this.document.isEmpty()) {
      const e = ET.groupObjects(this.document.getBlocks(), { asTree: !0 });
      Array.from(e).forEach((n) => {
        const r = this.findOrCreateCachedChildView(cJ, n);
        Array.from(r.getNodes()).map((i) => this.shadowElement.appendChild(i));
      });
    }
  }
  isSynced() {
    return dGe(this.shadowElement, this.element);
  }
  sync() {
    const e = this.createDocumentFragmentForSync();
    for (; this.element.lastChild; )
      this.element.removeChild(this.element.lastChild);
    return this.element.appendChild(e), this.didSync();
  }
  didSync() {
    return this.elementStore.reset(wM(this.element)), xT(() => this.garbageCollectCachedViews());
  }
  createDocumentFragmentForSync() {
    const e = document.createDocumentFragment();
    return Array.from(this.shadowElement.childNodes).forEach((n) => {
      e.appendChild(n.cloneNode(!0));
    }), Array.from(wM(e)).forEach((n) => {
      const r = this.elementStore.remove(n);
      r && n.parentNode.replaceChild(r, n);
    }), e;
  }
};
const wM = (t) => t.querySelectorAll("[data-trix-store-key]"), dGe = (t, e) => EM(t.innerHTML) === EM(e.innerHTML), EM = (t) => t.replace(/&nbsp;/g, " ");
function sa(t, e, n) {
  return (e = fGe(e)) in t ? Object.defineProperty(t, e, { value: n, enumerable: !0, configurable: !0, writable: !0 }) : t[e] = n, t;
}
function fGe(t) {
  var e = function(n, r) {
    if (typeof n != "object" || n === null)
      return n;
    var i = n[Symbol.toPrimitive];
    if (i !== void 0) {
      var o = i.call(n, r || "default");
      if (typeof o != "object")
        return o;
      throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (r === "string" ? String : Number)(n);
  }(t, "string");
  return typeof e == "symbol" ? e : String(e);
}
let af = class extends rf {
  static registerType(e, n) {
    n.type = e, this.types[e] = n;
  }
  static fromJSON(e) {
    const n = this.types[e.type];
    if (n)
      return n.fromJSON(e);
  }
  constructor(e) {
    let n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    super(...arguments), this.attributes = nl.box(n);
  }
  copyWithAttributes(e) {
    return new this.constructor(this.getValue(), e);
  }
  copyWithAdditionalAttributes(e) {
    return this.copyWithAttributes(this.attributes.merge(e));
  }
  copyWithoutAttribute(e) {
    return this.copyWithAttributes(this.attributes.remove(e));
  }
  copy() {
    return this.copyWithAttributes(this.attributes);
  }
  getAttribute(e) {
    return this.attributes.get(e);
  }
  getAttributesHash() {
    return this.attributes;
  }
  getAttributes() {
    return this.attributes.toObject();
  }
  hasAttribute(e) {
    return this.attributes.has(e);
  }
  hasSameStringValueAsPiece(e) {
    return e && this.toString() === e.toString();
  }
  hasSameAttributesAsPiece(e) {
    return e && (this.attributes === e.attributes || this.attributes.isEqualTo(e.attributes));
  }
  isBlockBreak() {
    return !1;
  }
  isEqualTo(e) {
    return super.isEqualTo(...arguments) || this.hasSameConstructorAs(e) && this.hasSameStringValueAsPiece(e) && this.hasSameAttributesAsPiece(e);
  }
  isEmpty() {
    return this.length === 0;
  }
  isSerializable() {
    return !0;
  }
  toJSON() {
    return { type: this.constructor.type, attributes: this.getAttributes() };
  }
  contentsForInspection() {
    return { type: this.constructor.type, attributes: this.attributes.inspect() };
  }
  canBeGrouped() {
    return this.hasAttribute("href");
  }
  canBeGroupedWith(e) {
    return this.getAttribute("href") === e.getAttribute("href");
  }
  getLength() {
    return this.length;
  }
  canBeConsolidatedWith(e) {
    return !1;
  }
};
sa(af, "types", {});
let dJ = class extends Zx {
  constructor(e) {
    super(...arguments), this.url = e;
  }
  perform(e) {
    const n = new Image();
    n.onload = () => (n.width = this.width = n.naturalWidth, n.height = this.height = n.naturalHeight, e(!0, n)), n.onerror = () => e(!1), n.src = this.url;
  }
}, lw = class fJ extends rf {
  static attachmentForFile(e) {
    const n = new this(this.attributesForFile(e));
    return n.setFile(e), n;
  }
  static attributesForFile(e) {
    return new nl({ filename: e.name, filesize: e.size, contentType: e.type });
  }
  static fromJSON(e) {
    return new this(e);
  }
  constructor() {
    let e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    super(e), this.releaseFile = this.releaseFile.bind(this), this.attributes = nl.box(e), this.didChangeAttributes();
  }
  getAttribute(e) {
    return this.attributes.get(e);
  }
  hasAttribute(e) {
    return this.attributes.has(e);
  }
  getAttributes() {
    return this.attributes.toObject();
  }
  setAttributes() {
    let e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    const n = this.attributes.merge(e);
    var r, i, o, a;
    if (!this.attributes.isEqualTo(n))
      return this.attributes = n, this.didChangeAttributes(), (r = this.previewDelegate) === null || r === void 0 || (i = r.attachmentDidChangeAttributes) === null || i === void 0 || i.call(r, this), (o = this.delegate) === null || o === void 0 || (a = o.attachmentDidChangeAttributes) === null || a === void 0 ? void 0 : a.call(o, this);
  }
  didChangeAttributes() {
    if (this.isPreviewable())
      return this.preloadURL();
  }
  isPending() {
    return this.file != null && !(this.getURL() || this.getHref());
  }
  isPreviewable() {
    return this.attributes.has("previewable") ? this.attributes.get("previewable") : fJ.previewablePattern.test(this.getContentType());
  }
  getType() {
    return this.hasContent() ? "content" : this.isPreviewable() ? "preview" : "file";
  }
  getURL() {
    return this.attributes.get("url");
  }
  getHref() {
    return this.attributes.get("href");
  }
  getFilename() {
    return this.attributes.get("filename") || "";
  }
  getFilesize() {
    return this.attributes.get("filesize");
  }
  getFormattedFilesize() {
    const e = this.attributes.get("filesize");
    return typeof e == "number" ? ZZ.formatter(e) : "";
  }
  getExtension() {
    var e;
    return (e = this.getFilename().match(/\.(\w+)$/)) === null || e === void 0 ? void 0 : e[1].toLowerCase();
  }
  getContentType() {
    return this.attributes.get("contentType");
  }
  hasContent() {
    return this.attributes.has("content");
  }
  getContent() {
    return this.attributes.get("content");
  }
  getWidth() {
    return this.attributes.get("width");
  }
  getHeight() {
    return this.attributes.get("height");
  }
  getFile() {
    return this.file;
  }
  setFile(e) {
    if (this.file = e, this.isPreviewable())
      return this.preloadFile();
  }
  releaseFile() {
    this.releasePreloadedFile(), this.file = null;
  }
  getUploadProgress() {
    return this.uploadProgress != null ? this.uploadProgress : 0;
  }
  setUploadProgress(e) {
    var n, r;
    if (this.uploadProgress !== e)
      return this.uploadProgress = e, (n = this.uploadProgressDelegate) === null || n === void 0 || (r = n.attachmentDidChangeUploadProgress) === null || r === void 0 ? void 0 : r.call(n, this);
  }
  toJSON() {
    return this.getAttributes();
  }
  getCacheKey() {
    return [super.getCacheKey(...arguments), this.attributes.getCacheKey(), this.getPreviewURL()].join("/");
  }
  getPreviewURL() {
    return this.previewURL || this.preloadingURL;
  }
  setPreviewURL(e) {
    var n, r, i, o;
    if (e !== this.getPreviewURL())
      return this.previewURL = e, (n = this.previewDelegate) === null || n === void 0 || (r = n.attachmentDidChangeAttributes) === null || r === void 0 || r.call(n, this), (i = this.delegate) === null || i === void 0 || (o = i.attachmentDidChangePreviewURL) === null || o === void 0 ? void 0 : o.call(i, this);
  }
  preloadURL() {
    return this.preload(this.getURL(), this.releaseFile);
  }
  preloadFile() {
    if (this.file)
      return this.fileObjectURL = URL.createObjectURL(this.file), this.preload(this.fileObjectURL);
  }
  releasePreloadedFile() {
    this.fileObjectURL && (URL.revokeObjectURL(this.fileObjectURL), this.fileObjectURL = null);
  }
  preload(e, n) {
    if (e && e !== this.getPreviewURL())
      return this.preloadingURL = e, new dJ(e).then((r) => {
        let { width: i, height: o } = r;
        return this.getWidth() && this.getHeight() || this.setAttributes({ width: i, height: o }), this.preloadingURL = null, this.setPreviewURL(e), n == null ? void 0 : n();
      }).catch(() => (this.preloadingURL = null, n == null ? void 0 : n()));
  }
};
sa(lw, "previewablePattern", /^image(\/(gif|png|webp|jpe?g)|$)/);
let Jx = class hJ extends af {
  static fromJSON(e) {
    return new this(lw.fromJSON(e.attachment), e.attributes);
  }
  constructor(e) {
    super(...arguments), this.attachment = e, this.length = 1, this.ensureAttachmentExclusivelyHasAttribute("href"), this.attachment.hasContent() || this.removeProhibitedAttributes();
  }
  ensureAttachmentExclusivelyHasAttribute(e) {
    this.hasAttribute(e) && (this.attachment.hasAttribute(e) || this.attachment.setAttributes(this.attributes.slice([e])), this.attributes = this.attributes.remove(e));
  }
  removeProhibitedAttributes() {
    const e = this.attributes.slice(hJ.permittedAttributes);
    e.isEqualTo(this.attributes) || (this.attributes = e);
  }
  getValue() {
    return this.attachment;
  }
  isSerializable() {
    return !this.attachment.isPending();
  }
  getCaption() {
    return this.attributes.get("caption") || "";
  }
  isEqualTo(e) {
    var n;
    return super.isEqualTo(e) && this.attachment.id === (e == null || (n = e.attachment) === null || n === void 0 ? void 0 : n.id);
  }
  toString() {
    return "￼";
  }
  toJSON() {
    const e = super.toJSON(...arguments);
    return e.attachment = this.attachment, e;
  }
  getCacheKey() {
    return [super.getCacheKey(...arguments), this.attachment.getCacheKey()].join("/");
  }
  toConsole() {
    return JSON.stringify(this.toString());
  }
};
sa(Jx, "permittedAttributes", ["caption", "presentation"]), af.registerType("attachment", Jx);
let IT = class extends af {
  static fromJSON(e) {
    return new this(e.string, e.attributes);
  }
  constructor(e) {
    super(...arguments), this.string = ((n) => n.replace(/\r\n?/g, `
`))(e), this.length = this.string.length;
  }
  getValue() {
    return this.string;
  }
  toString() {
    return this.string.toString();
  }
  isBlockBreak() {
    return this.toString() === `
` && this.getAttribute("blockBreak") === !0;
  }
  toJSON() {
    const e = super.toJSON(...arguments);
    return e.string = this.string, e;
  }
  canBeConsolidatedWith(e) {
    return e && this.hasSameConstructorAs(e) && this.hasSameAttributesAsPiece(e);
  }
  consolidateWith(e) {
    return new this.constructor(this.toString() + e.toString(), this.attributes);
  }
  splitAtOffset(e) {
    let n, r;
    return e === 0 ? (n = null, r = this) : e === this.length ? (n = this, r = null) : (n = new this.constructor(this.string.slice(0, e), this.attributes), r = new this.constructor(this.string.slice(e), this.attributes)), [n, r];
  }
  toConsole() {
    let { string: e } = this;
    return e.length > 15 && (e = e.slice(0, 14) + "…"), JSON.stringify(e.toString());
  }
};
af.registerType("string", IT);
let Kx = class extends rf {
  static box(e) {
    return e instanceof this ? e : new this(e);
  }
  constructor() {
    let e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [];
    super(...arguments), this.objects = e.slice(0), this.length = this.objects.length;
  }
  indexOf(e) {
    return this.objects.indexOf(e);
  }
  splice() {
    for (var e = arguments.length, n = new Array(e), r = 0; r < e; r++)
      n[r] = arguments[r];
    return new this.constructor(yT(this.objects, ...n));
  }
  eachObject(e) {
    return this.objects.map((n, r) => e(n, r));
  }
  insertObjectAtIndex(e, n) {
    return this.splice(n, 0, e);
  }
  insertSplittableListAtIndex(e, n) {
    return this.splice(n, 0, ...e.objects);
  }
  insertSplittableListAtPosition(e, n) {
    const [r, i] = this.splitObjectAtPosition(n);
    return new this.constructor(r).insertSplittableListAtIndex(e, i);
  }
  editObjectAtIndex(e, n) {
    return this.replaceObjectAtIndex(n(this.objects[e]), e);
  }
  replaceObjectAtIndex(e, n) {
    return this.splice(n, 1, e);
  }
  removeObjectAtIndex(e) {
    return this.splice(e, 1);
  }
  getObjectAtIndex(e) {
    return this.objects[e];
  }
  getSplittableListInRange(e) {
    const [n, r, i] = this.splitObjectsAtRange(e);
    return new this.constructor(n.slice(r, i + 1));
  }
  selectSplittableList(e) {
    const n = this.objects.filter((r) => e(r));
    return new this.constructor(n);
  }
  removeObjectsInRange(e) {
    const [n, r, i] = this.splitObjectsAtRange(e);
    return new this.constructor(n).splice(r, i - r + 1);
  }
  transformObjectsInRange(e, n) {
    const [r, i, o] = this.splitObjectsAtRange(e), a = r.map((s, u) => i <= u && u <= o ? n(s) : s);
    return new this.constructor(a);
  }
  splitObjectsAtRange(e) {
    let n, [r, i, o] = this.splitObjectAtPosition(pGe(e));
    return [r, n] = new this.constructor(r).splitObjectAtPosition(gGe(e) + o), [r, i, n - 1];
  }
  getObjectAtPosition(e) {
    const { index: n } = this.findIndexAndOffsetAtPosition(e);
    return this.objects[n];
  }
  splitObjectAtPosition(e) {
    let n, r;
    const { index: i, offset: o } = this.findIndexAndOffsetAtPosition(e), a = this.objects.slice(0);
    if (i != null)
      if (o === 0)
        n = i, r = 0;
      else {
        const s = this.getObjectAtIndex(i), [u, l] = s.splitAtOffset(o);
        a.splice(i, 1, u, l), n = i + 1, r = u.getLength() - o;
      }
    else
      n = a.length, r = 0;
    return [a, n, r];
  }
  consolidate() {
    const e = [];
    let n = this.objects[0];
    return this.objects.slice(1).forEach((r) => {
      var i, o;
      (i = (o = n).canBeConsolidatedWith) !== null && i !== void 0 && i.call(o, r) ? n = n.consolidateWith(r) : (e.push(n), n = r);
    }), n && e.push(n), new this.constructor(e);
  }
  consolidateFromIndexToIndex(e, n) {
    const r = this.objects.slice(0).slice(e, n + 1), i = new this.constructor(r).consolidate().toArray();
    return this.splice(e, r.length, ...i);
  }
  findIndexAndOffsetAtPosition(e) {
    let n, r = 0;
    for (n = 0; n < this.objects.length; n++) {
      const i = r + this.objects[n].getLength();
      if (r <= e && e < i)
        return { index: n, offset: e - r };
      r = i;
    }
    return { index: null, offset: null };
  }
  findPositionAtIndexAndOffset(e, n) {
    let r = 0;
    for (let i = 0; i < this.objects.length; i++) {
      const o = this.objects[i];
      if (i < e)
        r += o.getLength();
      else if (i === e) {
        r += n;
        break;
      }
    }
    return r;
  }
  getEndPosition() {
    return this.endPosition == null && (this.endPosition = 0, this.objects.forEach((e) => this.endPosition += e.getLength())), this.endPosition;
  }
  toString() {
    return this.objects.join("");
  }
  toArray() {
    return this.objects.slice(0);
  }
  toJSON() {
    return this.toArray();
  }
  isEqualTo(e) {
    return super.isEqualTo(...arguments) || hGe(this.objects, e == null ? void 0 : e.objects);
  }
  contentsForInspection() {
    return { objects: "[".concat(this.objects.map((e) => e.inspect()).join(", "), "]") };
  }
};
const hGe = function(t) {
  let e = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : [];
  if (t.length !== e.length)
    return !1;
  let n = !0;
  for (let r = 0; r < t.length; r++) {
    const i = t[r];
    n && !i.isEqualTo(e[r]) && (n = !1);
  }
  return n;
}, pGe = (t) => t[0], gGe = (t) => t[1];
let Os = class extends rf {
  static textForAttachmentWithAttributes(e, n) {
    return new this([new Jx(e, n)]);
  }
  static textForStringWithAttributes(e, n) {
    return new this([new IT(e, n)]);
  }
  static fromJSON(e) {
    return new this(Array.from(e).map((n) => af.fromJSON(n)));
  }
  constructor() {
    let e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [];
    super(...arguments);
    const n = e.filter((r) => !r.isEmpty());
    this.pieceList = new Kx(n);
  }
  copy() {
    return this.copyWithPieceList(this.pieceList);
  }
  copyWithPieceList(e) {
    return new this.constructor(e.consolidate().toArray());
  }
  copyUsingObjectMap(e) {
    const n = this.getPieces().map((r) => e.find(r) || r);
    return new this.constructor(n);
  }
  appendText(e) {
    return this.insertTextAtPosition(e, this.getLength());
  }
  insertTextAtPosition(e, n) {
    return this.copyWithPieceList(this.pieceList.insertSplittableListAtPosition(e.pieceList, n));
  }
  removeTextAtRange(e) {
    return this.copyWithPieceList(this.pieceList.removeObjectsInRange(e));
  }
  replaceTextAtRange(e, n) {
    return this.removeTextAtRange(n).insertTextAtPosition(e, n[0]);
  }
  moveTextFromRangeToPosition(e, n) {
    if (e[0] <= n && n <= e[1])
      return;
    const r = this.getTextAtRange(e), i = r.getLength();
    return e[0] < n && (n -= i), this.removeTextAtRange(e).insertTextAtPosition(r, n);
  }
  addAttributeAtRange(e, n, r) {
    const i = {};
    return i[e] = n, this.addAttributesAtRange(i, r);
  }
  addAttributesAtRange(e, n) {
    return this.copyWithPieceList(this.pieceList.transformObjectsInRange(n, (r) => r.copyWithAdditionalAttributes(e)));
  }
  removeAttributeAtRange(e, n) {
    return this.copyWithPieceList(this.pieceList.transformObjectsInRange(n, (r) => r.copyWithoutAttribute(e)));
  }
  setAttributesAtRange(e, n) {
    return this.copyWithPieceList(this.pieceList.transformObjectsInRange(n, (r) => r.copyWithAttributes(e)));
  }
  getAttributesAtPosition(e) {
    var n;
    return ((n = this.pieceList.getObjectAtPosition(e)) === null || n === void 0 ? void 0 : n.getAttributes()) || {};
  }
  getCommonAttributes() {
    const e = Array.from(this.pieceList.toArray()).map((n) => n.getAttributes());
    return nl.fromCommonAttributesOfObjects(e).toObject();
  }
  getCommonAttributesAtRange(e) {
    return this.getTextAtRange(e).getCommonAttributes() || {};
  }
  getExpandedRangeForAttributeAtOffset(e, n) {
    let r, i = r = n;
    const o = this.getLength();
    for (; i > 0 && this.getCommonAttributesAtRange([i - 1, r])[e]; )
      i--;
    for (; r < o && this.getCommonAttributesAtRange([n, r + 1])[e]; )
      r++;
    return [i, r];
  }
  getTextAtRange(e) {
    return this.copyWithPieceList(this.pieceList.getSplittableListInRange(e));
  }
  getStringAtRange(e) {
    return this.pieceList.getSplittableListInRange(e).toString();
  }
  getStringAtPosition(e) {
    return this.getStringAtRange([e, e + 1]);
  }
  startsWithString(e) {
    return this.getStringAtRange([0, e.length]) === e;
  }
  endsWithString(e) {
    const n = this.getLength();
    return this.getStringAtRange([n - e.length, n]) === e;
  }
  getAttachmentPieces() {
    return this.pieceList.toArray().filter((e) => !!e.attachment);
  }
  getAttachments() {
    return this.getAttachmentPieces().map((e) => e.attachment);
  }
  getAttachmentAndPositionById(e) {
    let n = 0;
    for (const i of this.pieceList.toArray()) {
      var r;
      if (((r = i.attachment) === null || r === void 0 ? void 0 : r.id) === e)
        return { attachment: i.attachment, position: n };
      n += i.length;
    }
    return { attachment: null, position: null };
  }
  getAttachmentById(e) {
    const { attachment: n } = this.getAttachmentAndPositionById(e);
    return n;
  }
  getRangeOfAttachment(e) {
    const n = this.getAttachmentAndPositionById(e.id), r = n.position;
    if (e = n.attachment)
      return [r, r + 1];
  }
  updateAttributesForAttachment(e, n) {
    const r = this.getRangeOfAttachment(n);
    return r ? this.addAttributesAtRange(e, r) : this;
  }
  getLength() {
    return this.pieceList.getEndPosition();
  }
  isEmpty() {
    return this.getLength() === 0;
  }
  isEqualTo(e) {
    var n;
    return super.isEqualTo(e) || (e == null || (n = e.pieceList) === null || n === void 0 ? void 0 : n.isEqualTo(this.pieceList));
  }
  isBlockBreak() {
    return this.getLength() === 1 && this.pieceList.getObjectAtIndex(0).isBlockBreak();
  }
  eachPiece(e) {
    return this.pieceList.eachObject(e);
  }
  getPieces() {
    return this.pieceList.toArray();
  }
  getPieceAtPosition(e) {
    return this.pieceList.getObjectAtPosition(e);
  }
  contentsForInspection() {
    return { pieceList: this.pieceList.inspect() };
  }
  toSerializableText() {
    const e = this.pieceList.selectSplittableList((n) => n.isSerializable());
    return this.copyWithPieceList(e);
  }
  toString() {
    return this.pieceList.toString();
  }
  toJSON() {
    return this.pieceList.toJSON();
  }
  toConsole() {
    return JSON.stringify(this.pieceList.toArray().map((e) => JSON.parse(e.toConsole())));
  }
  getDirection() {
    return Kze(this.toString());
  }
  isRTL() {
    return this.getDirection() === "rtl";
  }
}, Oh = class e4 extends rf {
  static fromJSON(e) {
    return new this(Os.fromJSON(e.text), e.attributes);
  }
  constructor(e, n) {
    super(...arguments), this.text = mGe(e || new Os()), this.attributes = n || [];
  }
  isEmpty() {
    return this.text.isBlockBreak();
  }
  isEqualTo(e) {
    return !!super.isEqualTo(e) || this.text.isEqualTo(e == null ? void 0 : e.text) && Dd(this.attributes, e == null ? void 0 : e.attributes);
  }
  copyWithText(e) {
    return new e4(e, this.attributes);
  }
  copyWithoutText() {
    return this.copyWithText(null);
  }
  copyWithAttributes(e) {
    return new e4(this.text, e);
  }
  copyWithoutAttributes() {
    return this.copyWithAttributes(null);
  }
  copyUsingObjectMap(e) {
    const n = e.find(this.text);
    return n ? this.copyWithText(n) : this.copyWithText(this.text.copyUsingObjectMap(e));
  }
  addAttribute(e) {
    const n = this.attributes.concat(SM(e));
    return this.copyWithAttributes(n);
  }
  removeAttribute(e) {
    const { listAttribute: n } = ui(e), r = _M(_M(this.attributes, e), n);
    return this.copyWithAttributes(r);
  }
  removeLastAttribute() {
    return this.removeAttribute(this.getLastAttribute());
  }
  getLastAttribute() {
    return IM(this.attributes);
  }
  getAttributes() {
    return this.attributes.slice(0);
  }
  getAttributeLevel() {
    return this.attributes.length;
  }
  getAttributeAtLevel(e) {
    return this.attributes[e - 1];
  }
  hasAttribute(e) {
    return this.attributes.includes(e);
  }
  hasAttributes() {
    return this.getAttributeLevel() > 0;
  }
  getLastNestableAttribute() {
    return IM(this.getNestableAttributes());
  }
  getNestableAttributes() {
    return this.attributes.filter((e) => ui(e).nestable);
  }
  getNestingLevel() {
    return this.getNestableAttributes().length;
  }
  decreaseNestingLevel() {
    const e = this.getLastNestableAttribute();
    return e ? this.removeAttribute(e) : this;
  }
  increaseNestingLevel() {
    const e = this.getLastNestableAttribute();
    if (e) {
      const n = this.attributes.lastIndexOf(e), r = yT(this.attributes, n + 1, 0, ...SM(e));
      return this.copyWithAttributes(r);
    }
    return this;
  }
  getListItemAttributes() {
    return this.attributes.filter((e) => ui(e).listAttribute);
  }
  isListItem() {
    var e;
    return (e = ui(this.getLastAttribute())) === null || e === void 0 ? void 0 : e.listAttribute;
  }
  isTerminalBlock() {
    var e;
    return (e = ui(this.getLastAttribute())) === null || e === void 0 ? void 0 : e.terminal;
  }
  breaksOnReturn() {
    var e;
    return (e = ui(this.getLastAttribute())) === null || e === void 0 ? void 0 : e.breakOnReturn;
  }
  findLineBreakInDirectionFromPosition(e, n) {
    const r = this.toString();
    let i;
    switch (e) {
      case "forward":
        i = r.indexOf(`
`, n);
        break;
      case "backward":
        i = r.slice(0, n).lastIndexOf(`
`);
    }
    if (i !== -1)
      return i;
  }
  contentsForInspection() {
    return { text: this.text.inspect(), attributes: this.attributes };
  }
  toString() {
    return this.text.toString();
  }
  toJSON() {
    return { text: this.text, attributes: this.attributes };
  }
  getDirection() {
    return this.text.getDirection();
  }
  isRTL() {
    return this.text.isRTL();
  }
  getLength() {
    return this.text.getLength();
  }
  canBeConsolidatedWith(e) {
    return !this.hasAttributes() && !e.hasAttributes() && this.getDirection() === e.getDirection();
  }
  consolidateWith(e) {
    const n = Os.textForStringWithAttributes(`
`), r = this.getTextWithoutBlockBreak().appendText(n);
    return this.copyWithText(r.appendText(e.text));
  }
  splitAtOffset(e) {
    let n, r;
    return e === 0 ? (n = null, r = this) : e === this.getLength() ? (n = this, r = null) : (n = this.copyWithText(this.text.getTextAtRange([0, e])), r = this.copyWithText(this.text.getTextAtRange([e, this.getLength()]))), [n, r];
  }
  getBlockBreakPosition() {
    return this.text.getLength() - 1;
  }
  getTextWithoutBlockBreak() {
    return pJ(this.text) ? this.text.getTextAtRange([0, this.getBlockBreakPosition()]) : this.text.copy();
  }
  canBeGrouped(e) {
    return this.attributes[e];
  }
  canBeGroupedWith(e, n) {
    const r = e.getAttributes(), i = r[n], o = this.attributes[n];
    return o === i && !(ui(o).group === !1 && !(() => {
      if (!Ib) {
        Ib = [];
        for (const a in Po) {
          const { listAttribute: s } = Po[a];
          s != null && Ib.push(s);
        }
      }
      return Ib;
    })().includes(r[n + 1])) && (this.getDirection() === e.getDirection() || e.isEmpty());
  }
};
const mGe = function(t) {
  return t = vGe(t), t = yGe(t);
}, vGe = function(t) {
  let e = !1;
  const n = t.getPieces();
  let r = n.slice(0, n.length - 1);
  const i = n[n.length - 1];
  return i ? (r = r.map((o) => o.isBlockBreak() ? (e = !0, xGe(o)) : o), e ? new Os([...r, i]) : t) : t;
}, bGe = Os.textForStringWithAttributes(`
`, { blockBreak: !0 }), yGe = function(t) {
  return pJ(t) ? t : t.appendText(bGe);
}, pJ = function(t) {
  const e = t.getLength();
  return e === 0 ? !1 : t.getTextAtRange([e - 1, e]).isBlockBreak();
}, xGe = (t) => t.copyWithoutAttribute("blockBreak"), SM = function(t) {
  const { listAttribute: e } = ui(t);
  return e ? [e, t] : [t];
}, IM = (t) => t.slice(-1)[0], _M = function(t, e) {
  const n = t.lastIndexOf(e);
  return n === -1 ? t : yT(t, n, 1);
};
let Va = class extends rf {
  static fromJSON(e) {
    return new this(Array.from(e).map((n) => Oh.fromJSON(n)));
  }
  static fromString(e, n) {
    const r = Os.textForStringWithAttributes(e, n);
    return new this([new Oh(r)]);
  }
  constructor() {
    let e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [];
    super(...arguments), e.length === 0 && (e = [new Oh()]), this.blockList = Kx.box(e);
  }
  isEmpty() {
    const e = this.getBlockAtIndex(0);
    return this.blockList.length === 1 && e.isEmpty() && !e.hasAttributes();
  }
  copy() {
    const e = (arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}).consolidateBlocks ? this.blockList.consolidate().toArray() : this.blockList.toArray();
    return new this.constructor(e);
  }
  copyUsingObjectsFromDocument(e) {
    const n = new aGe(e.getObjects());
    return this.copyUsingObjectMap(n);
  }
  copyUsingObjectMap(e) {
    const n = this.getBlocks().map((r) => e.find(r) || r.copyUsingObjectMap(e));
    return new this.constructor(n);
  }
  copyWithBaseBlockAttributes() {
    let e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [];
    const n = this.getBlocks().map((r) => {
      const i = e.concat(r.getAttributes());
      return r.copyWithAttributes(i);
    });
    return new this.constructor(n);
  }
  replaceBlock(e, n) {
    const r = this.blockList.indexOf(e);
    return r === -1 ? this : new this.constructor(this.blockList.replaceObjectAtIndex(n, r));
  }
  insertDocumentAtRange(e, n) {
    const { blockList: r } = e;
    n = dr(n);
    let [i] = n;
    const { index: o, offset: a } = this.locationFromPosition(i);
    let s = this;
    const u = this.getBlockAtPosition(i);
    return Ju(n) && u.isEmpty() && !u.hasAttributes() ? s = new this.constructor(s.blockList.removeObjectAtIndex(o)) : u.getBlockBreakPosition() === a && i++, s = s.removeTextAtRange(n), new this.constructor(s.blockList.insertSplittableListAtPosition(r, i));
  }
  mergeDocumentAtRange(e, n) {
    let r, i;
    n = dr(n);
    const [o] = n, a = this.locationFromPosition(o), s = this.getBlockAtIndex(a.index).getAttributes(), u = e.getBaseBlockAttributes(), l = s.slice(-u.length);
    if (Dd(u, l)) {
      const f = s.slice(0, -u.length);
      r = e.copyWithBaseBlockAttributes(f);
    } else
      r = e.copy({ consolidateBlocks: !0 }).copyWithBaseBlockAttributes(s);
    const c = r.getBlockCount(), d = r.getBlockAtIndex(0);
    if (Dd(s, d.getAttributes())) {
      const f = d.getTextWithoutBlockBreak();
      if (i = this.insertTextAtRange(f, n), c > 1) {
        r = new this.constructor(r.getBlocks().slice(1));
        const h = o + f.getLength();
        i = i.insertDocumentAtRange(r, h);
      }
    } else
      i = this.insertDocumentAtRange(r, n);
    return i;
  }
  insertTextAtRange(e, n) {
    n = dr(n);
    const [r] = n, { index: i, offset: o } = this.locationFromPosition(r), a = this.removeTextAtRange(n);
    return new this.constructor(a.blockList.editObjectAtIndex(i, (s) => s.copyWithText(s.text.insertTextAtPosition(e, o))));
  }
  removeTextAtRange(e) {
    let n;
    e = dr(e);
    const [r, i] = e;
    if (Ju(e))
      return this;
    const [o, a] = Array.from(this.locationRangeFromRange(e)), s = o.index, u = o.offset, l = this.getBlockAtIndex(s), c = a.index, d = a.offset, f = this.getBlockAtIndex(c);
    if (i - r == 1 && l.getBlockBreakPosition() === u && f.getBlockBreakPosition() !== d && f.text.getStringAtPosition(d) === `
`)
      n = this.blockList.editObjectAtIndex(c, (h) => h.copyWithText(h.text.removeTextAtRange([d, d + 1])));
    else {
      let h;
      const p = l.text.getTextAtRange([0, u]), v = f.text.getTextAtRange([d, f.getLength()]), m = p.appendText(v);
      h = s !== c && u === 0 && l.getAttributeLevel() >= f.getAttributeLevel() ? f.copyWithText(m) : l.copyWithText(m);
      const b = c + 1 - s;
      n = this.blockList.splice(s, b, h);
    }
    return new this.constructor(n);
  }
  moveTextFromRangeToPosition(e, n) {
    let r;
    e = dr(e);
    const [i, o] = e;
    if (i <= n && n <= o)
      return this;
    let a = this.getDocumentAtRange(e), s = this.removeTextAtRange(e);
    const u = i < n;
    u && (n -= a.getLength());
    const [l, ...c] = a.getBlocks();
    return c.length === 0 ? (r = l.getTextWithoutBlockBreak(), u && (n += 1)) : r = l.text, s = s.insertTextAtRange(r, n), c.length === 0 ? s : (a = new this.constructor(c), n += r.getLength(), s.insertDocumentAtRange(a, n));
  }
  addAttributeAtRange(e, n, r) {
    let { blockList: i } = this;
    return this.eachBlockAtRange(r, (o, a, s) => i = i.editObjectAtIndex(s, function() {
      return ui(e) ? o.addAttribute(e, n) : a[0] === a[1] ? o : o.copyWithText(o.text.addAttributeAtRange(e, n, a));
    })), new this.constructor(i);
  }
  addAttribute(e, n) {
    let { blockList: r } = this;
    return this.eachBlock((i, o) => r = r.editObjectAtIndex(o, () => i.addAttribute(e, n))), new this.constructor(r);
  }
  removeAttributeAtRange(e, n) {
    let { blockList: r } = this;
    return this.eachBlockAtRange(n, function(i, o, a) {
      ui(e) ? r = r.editObjectAtIndex(a, () => i.removeAttribute(e)) : o[0] !== o[1] && (r = r.editObjectAtIndex(a, () => i.copyWithText(i.text.removeAttributeAtRange(e, o))));
    }), new this.constructor(r);
  }
  updateAttributesForAttachment(e, n) {
    const r = this.getRangeOfAttachment(n), [i] = Array.from(r), { index: o } = this.locationFromPosition(i), a = this.getTextAtIndex(o);
    return new this.constructor(this.blockList.editObjectAtIndex(o, (s) => s.copyWithText(a.updateAttributesForAttachment(e, n))));
  }
  removeAttributeForAttachment(e, n) {
    const r = this.getRangeOfAttachment(n);
    return this.removeAttributeAtRange(e, r);
  }
  insertBlockBreakAtRange(e) {
    let n;
    e = dr(e);
    const [r] = e, { offset: i } = this.locationFromPosition(r), o = this.removeTextAtRange(e);
    return i === 0 && (n = [new Oh()]), new this.constructor(o.blockList.insertSplittableListAtPosition(new Kx(n), r));
  }
  applyBlockAttributeAtRange(e, n, r) {
    const i = this.expandRangeToLineBreaksAndSplitBlocks(r);
    let o = i.document;
    r = i.range;
    const a = ui(e);
    if (a.listAttribute) {
      o = o.removeLastListAttributeAtRange(r, { exceptAttributeName: e });
      const s = o.convertLineBreaksToBlockBreaksInRange(r);
      o = s.document, r = s.range;
    } else
      o = a.exclusive ? o.removeBlockAttributesAtRange(r) : a.terminal ? o.removeLastTerminalAttributeAtRange(r) : o.consolidateBlocksAtRange(r);
    return o.addAttributeAtRange(e, n, r);
  }
  removeLastListAttributeAtRange(e) {
    let n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, { blockList: r } = this;
    return this.eachBlockAtRange(e, function(i, o, a) {
      const s = i.getLastAttribute();
      s && ui(s).listAttribute && s !== n.exceptAttributeName && (r = r.editObjectAtIndex(a, () => i.removeAttribute(s)));
    }), new this.constructor(r);
  }
  removeLastTerminalAttributeAtRange(e) {
    let { blockList: n } = this;
    return this.eachBlockAtRange(e, function(r, i, o) {
      const a = r.getLastAttribute();
      a && ui(a).terminal && (n = n.editObjectAtIndex(o, () => r.removeAttribute(a)));
    }), new this.constructor(n);
  }
  removeBlockAttributesAtRange(e) {
    let { blockList: n } = this;
    return this.eachBlockAtRange(e, function(r, i, o) {
      r.hasAttributes() && (n = n.editObjectAtIndex(o, () => r.copyWithoutAttributes()));
    }), new this.constructor(n);
  }
  expandRangeToLineBreaksAndSplitBlocks(e) {
    let n;
    e = dr(e);
    let [r, i] = e;
    const o = this.locationFromPosition(r), a = this.locationFromPosition(i);
    let s = this;
    const u = s.getBlockAtIndex(o.index);
    if (o.offset = u.findLineBreakInDirectionFromPosition("backward", o.offset), o.offset != null && (n = s.positionFromLocation(o), s = s.insertBlockBreakAtRange([n, n + 1]), a.index += 1, a.offset -= s.getBlockAtIndex(o.index).getLength(), o.index += 1), o.offset = 0, a.offset === 0 && a.index > o.index)
      a.index -= 1, a.offset = s.getBlockAtIndex(a.index).getBlockBreakPosition();
    else {
      const l = s.getBlockAtIndex(a.index);
      l.text.getStringAtRange([a.offset - 1, a.offset]) === `
` ? a.offset -= 1 : a.offset = l.findLineBreakInDirectionFromPosition("forward", a.offset), a.offset !== l.getBlockBreakPosition() && (n = s.positionFromLocation(a), s = s.insertBlockBreakAtRange([n, n + 1]));
    }
    return r = s.positionFromLocation(o), i = s.positionFromLocation(a), { document: s, range: e = dr([r, i]) };
  }
  convertLineBreaksToBlockBreaksInRange(e) {
    e = dr(e);
    let [n] = e;
    const r = this.getStringAtRange(e).slice(0, -1);
    let i = this;
    return r.replace(/.*?\n/g, function(o) {
      n += o.length, i = i.insertBlockBreakAtRange([n - 1, n]);
    }), { document: i, range: e };
  }
  consolidateBlocksAtRange(e) {
    e = dr(e);
    const [n, r] = e, i = this.locationFromPosition(n).index, o = this.locationFromPosition(r).index;
    return new this.constructor(this.blockList.consolidateFromIndexToIndex(i, o));
  }
  getDocumentAtRange(e) {
    e = dr(e);
    const n = this.blockList.getSplittableListInRange(e).toArray();
    return new this.constructor(n);
  }
  getStringAtRange(e) {
    let n;
    const r = e = dr(e);
    return r[r.length - 1] !== this.getLength() && (n = -1), this.getDocumentAtRange(e).toString().slice(0, n);
  }
  getBlockAtIndex(e) {
    return this.blockList.getObjectAtIndex(e);
  }
  getBlockAtPosition(e) {
    const { index: n } = this.locationFromPosition(e);
    return this.getBlockAtIndex(n);
  }
  getTextAtIndex(e) {
    var n;
    return (n = this.getBlockAtIndex(e)) === null || n === void 0 ? void 0 : n.text;
  }
  getTextAtPosition(e) {
    const { index: n } = this.locationFromPosition(e);
    return this.getTextAtIndex(n);
  }
  getPieceAtPosition(e) {
    const { index: n, offset: r } = this.locationFromPosition(e);
    return this.getTextAtIndex(n).getPieceAtPosition(r);
  }
  getCharacterAtPosition(e) {
    const { index: n, offset: r } = this.locationFromPosition(e);
    return this.getTextAtIndex(n).getStringAtRange([r, r + 1]);
  }
  getLength() {
    return this.blockList.getEndPosition();
  }
  getBlocks() {
    return this.blockList.toArray();
  }
  getBlockCount() {
    return this.blockList.length;
  }
  getEditCount() {
    return this.editCount;
  }
  eachBlock(e) {
    return this.blockList.eachObject(e);
  }
  eachBlockAtRange(e, n) {
    let r, i;
    e = dr(e);
    const [o, a] = e, s = this.locationFromPosition(o), u = this.locationFromPosition(a);
    if (s.index === u.index)
      return r = this.getBlockAtIndex(s.index), i = [s.offset, u.offset], n(r, i, s.index);
    for (let l = s.index; l <= u.index; l++)
      if (r = this.getBlockAtIndex(l), r) {
        switch (l) {
          case s.index:
            i = [s.offset, r.text.getLength()];
            break;
          case u.index:
            i = [0, u.offset];
            break;
          default:
            i = [0, r.text.getLength()];
        }
        n(r, i, l);
      }
  }
  getCommonAttributesAtRange(e) {
    e = dr(e);
    const [n] = e;
    if (Ju(e))
      return this.getCommonAttributesAtPosition(n);
    {
      const r = [], i = [];
      return this.eachBlockAtRange(e, function(o, a) {
        if (a[0] !== a[1])
          return r.push(o.text.getCommonAttributesAtRange(a)), i.push(AM(o));
      }), nl.fromCommonAttributesOfObjects(r).merge(nl.fromCommonAttributesOfObjects(i)).toObject();
    }
  }
  getCommonAttributesAtPosition(e) {
    let n, r;
    const { index: i, offset: o } = this.locationFromPosition(e), a = this.getBlockAtIndex(i);
    if (!a)
      return {};
    const s = AM(a), u = a.text.getAttributesAtPosition(o), l = a.text.getAttributesAtPosition(o - 1), c = Object.keys($d).filter((d) => $d[d].inheritable);
    for (n in l)
      r = l[n], (r === u[n] || c.includes(n)) && (s[n] = r);
    return s;
  }
  getRangeOfCommonAttributeAtPosition(e, n) {
    const { index: r, offset: i } = this.locationFromPosition(n), o = this.getTextAtIndex(r), [a, s] = Array.from(o.getExpandedRangeForAttributeAtOffset(e, i)), u = this.positionFromLocation({ index: r, offset: a }), l = this.positionFromLocation({ index: r, offset: s });
    return dr([u, l]);
  }
  getBaseBlockAttributes() {
    let e = this.getBlockAtIndex(0).getAttributes();
    for (let n = 1; n < this.getBlockCount(); n++) {
      const r = this.getBlockAtIndex(n).getAttributes(), i = Math.min(e.length, r.length);
      e = (() => {
        const o = [];
        for (let a = 0; a < i && r[a] === e[a]; a++)
          o.push(r[a]);
        return o;
      })();
    }
    return e;
  }
  getAttachmentById(e) {
    for (const n of this.getAttachments())
      if (n.id === e)
        return n;
  }
  getAttachmentPieces() {
    let e = [];
    return this.blockList.eachObject((n) => {
      let { text: r } = n;
      return e = e.concat(r.getAttachmentPieces());
    }), e;
  }
  getAttachments() {
    return this.getAttachmentPieces().map((e) => e.attachment);
  }
  getRangeOfAttachment(e) {
    let n = 0;
    const r = this.blockList.toArray();
    for (let i = 0; i < r.length; i++) {
      const { text: o } = r[i], a = o.getRangeOfAttachment(e);
      if (a)
        return dr([n + a[0], n + a[1]]);
      n += o.getLength();
    }
  }
  getLocationRangeOfAttachment(e) {
    const n = this.getRangeOfAttachment(e);
    return this.locationRangeFromRange(n);
  }
  getAttachmentPieceForAttachment(e) {
    for (const n of this.getAttachmentPieces())
      if (n.attachment === e)
        return n;
  }
  findRangesForBlockAttribute(e) {
    let n = 0;
    const r = [];
    return this.getBlocks().forEach((i) => {
      const o = i.getLength();
      i.hasAttribute(e) && r.push([n, n + o]), n += o;
    }), r;
  }
  findRangesForTextAttribute(e) {
    let { withValue: n } = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, r = 0, i = [];
    const o = [];
    return this.getPieces().forEach((a) => {
      const s = a.getLength();
      (function(u) {
        return n ? u.getAttribute(e) === n : u.hasAttribute(e);
      })(a) && (i[1] === r ? i[1] = r + s : o.push(i = [r, r + s])), r += s;
    }), o;
  }
  locationFromPosition(e) {
    const n = this.blockList.findIndexAndOffsetAtPosition(Math.max(0, e));
    if (n.index != null)
      return n;
    {
      const r = this.getBlocks();
      return { index: r.length - 1, offset: r[r.length - 1].getLength() };
    }
  }
  positionFromLocation(e) {
    return this.blockList.findPositionAtIndexAndOffset(e.index, e.offset);
  }
  locationRangeFromPosition(e) {
    return dr(this.locationFromPosition(e));
  }
  locationRangeFromRange(e) {
    if (!(e = dr(e)))
      return;
    const [n, r] = Array.from(e), i = this.locationFromPosition(n), o = this.locationFromPosition(r);
    return dr([i, o]);
  }
  rangeFromLocationRange(e) {
    let n;
    e = dr(e);
    const r = this.positionFromLocation(e[0]);
    return Ju(e) || (n = this.positionFromLocation(e[1])), dr([r, n]);
  }
  isEqualTo(e) {
    return this.blockList.isEqualTo(e == null ? void 0 : e.blockList);
  }
  getTexts() {
    return this.getBlocks().map((e) => e.text);
  }
  getPieces() {
    const e = [];
    return Array.from(this.getTexts()).forEach((n) => {
      e.push(...Array.from(n.getPieces() || []));
    }), e;
  }
  getObjects() {
    return this.getBlocks().concat(this.getTexts()).concat(this.getPieces());
  }
  toSerializableDocument() {
    const e = [];
    return this.blockList.eachObject((n) => e.push(n.copyWithText(n.text.toSerializableText()))), new this.constructor(e);
  }
  toString() {
    return this.blockList.toString();
  }
  toJSON() {
    return this.blockList.toJSON();
  }
  toConsole() {
    return JSON.stringify(this.blockList.toArray().map((e) => JSON.parse(e.text.toConsole())));
  }
};
const AM = function(t) {
  const e = {}, n = t.getLastAttribute();
  return n && (e[n] = !0), e;
}, CGe = "style href src width height class".split(" "), wGe = "javascript:".split(" "), EGe = "script iframe form".split(" ");
let gJ = class extends pi {
  static sanitize(e, n) {
    const r = new this(e, n);
    return r.sanitize(), r;
  }
  constructor(e) {
    let { allowedAttributes: n, forbiddenProtocols: r, forbiddenElements: i } = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    super(...arguments), this.allowedAttributes = n || CGe, this.forbiddenProtocols = r || wGe, this.forbiddenElements = i || EGe, this.body = SGe(e);
  }
  sanitize() {
    return this.sanitizeElements(), this.normalizeListElementNesting();
  }
  getHTML() {
    return this.body.innerHTML;
  }
  getBody() {
    return this.body;
  }
  sanitizeElements() {
    const e = Xx(this.body), n = [];
    for (; e.nextNode(); ) {
      const r = e.currentNode;
      switch (r.nodeType) {
        case Node.ELEMENT_NODE:
          this.elementIsRemovable(r) ? n.push(r) : this.sanitizeElement(r);
          break;
        case Node.COMMENT_NODE:
          n.push(r);
      }
    }
    return n.forEach((r) => pc(r)), this.body;
  }
  sanitizeElement(e) {
    return e.hasAttribute("href") && this.forbiddenProtocols.includes(e.protocol) && e.removeAttribute("href"), Array.from(e.attributes).forEach((n) => {
      let { name: r } = n;
      this.allowedAttributes.includes(r) || r.indexOf("data-trix") === 0 || e.removeAttribute(r);
    }), e;
  }
  normalizeListElementNesting() {
    return Array.from(this.body.querySelectorAll("ul,ol")).forEach((e) => {
      const n = e.previousElementSibling;
      n && _o(n) === "li" && n.appendChild(e);
    }), this.body;
  }
  elementIsRemovable(e) {
    if ((e == null ? void 0 : e.nodeType) === Node.ELEMENT_NODE)
      return this.elementIsForbidden(e) || this.elementIsntSerializable(e);
  }
  elementIsForbidden(e) {
    return this.forbiddenElements.includes(_o(e));
  }
  elementIsntSerializable(e) {
    return e.getAttribute("data-trix-serialize") === "false" && !wd(e);
  }
};
const SGe = function() {
  let t = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "";
  t = t.replace(/<\/html[^>]*>[^]*$/i, "</html>");
  const e = document.implementation.createHTMLDocument("");
  return e.documentElement.innerHTML = t, Array.from(e.head.querySelectorAll("style")).forEach((n) => {
    e.body.appendChild(n);
  }), e.body;
}, W3 = function(t) {
  let e = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
  return { string: t = i0(t), attributes: e, type: "string" };
}, TM = (t, e) => {
  try {
    return JSON.parse(t.getAttribute("data-trix-".concat(e)));
  } catch {
    return {};
  }
};
let sm = class extends pi {
  static parse(e, n) {
    const r = new this(e, n);
    return r.parse(), r;
  }
  constructor(e) {
    let { referenceElement: n } = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    super(...arguments), this.html = e, this.referenceElement = n, this.blocks = [], this.blockElements = [], this.processedElements = [];
  }
  getDocument() {
    return Va.fromJSON(this.blocks);
  }
  parse() {
    try {
      this.createHiddenContainer();
      const e = gJ.sanitize(this.html).getHTML();
      this.containerElement.innerHTML = e;
      const n = Xx(this.containerElement, { usingFilter: _Ge });
      for (; n.nextNode(); )
        this.processNode(n.currentNode);
      return this.translateBlockElementMarginsToNewlines();
    } finally {
      this.removeHiddenContainer();
    }
  }
  createHiddenContainer() {
    return this.referenceElement ? (this.containerElement = this.referenceElement.cloneNode(!1), this.containerElement.removeAttribute("id"), this.containerElement.setAttribute("data-trix-internal", ""), this.containerElement.style.display = "none", this.referenceElement.parentNode.insertBefore(this.containerElement, this.referenceElement.nextSibling)) : (this.containerElement = Pn({ tagName: "div", style: { display: "none" } }), document.body.appendChild(this.containerElement));
  }
  removeHiddenContainer() {
    return pc(this.containerElement);
  }
  processNode(e) {
    switch (e.nodeType) {
      case Node.TEXT_NODE:
        if (!this.isInsignificantTextNode(e))
          return this.appendBlockForTextNode(e), this.processTextNode(e);
        break;
      case Node.ELEMENT_NODE:
        return this.appendBlockForElement(e), this.processElement(e);
    }
  }
  appendBlockForTextNode(e) {
    const n = e.parentNode;
    if (n === this.currentBlockElement && this.isBlockElement(e.previousSibling))
      return this.appendStringWithAttributes(`
`);
    if (n === this.containerElement || this.isBlockElement(n)) {
      var r;
      const i = this.getBlockAttributes(n);
      Dd(i, (r = this.currentBlock) === null || r === void 0 ? void 0 : r.attributes) || (this.currentBlock = this.appendBlockForAttributesWithElement(i, n), this.currentBlockElement = n);
    }
  }
  appendBlockForElement(e) {
    const n = this.isBlockElement(e), r = fd(this.currentBlockElement, e);
    if (n && !this.isBlockElement(e.firstChild)) {
      if (!this.isInsignificantTextNode(e.firstChild) || !this.isBlockElement(e.firstElementChild)) {
        const i = this.getBlockAttributes(e);
        if (e.firstChild) {
          if (r && Dd(i, this.currentBlock.attributes))
            return this.appendStringWithAttributes(`
`);
          this.currentBlock = this.appendBlockForAttributesWithElement(i, e), this.currentBlockElement = e;
        }
      }
    } else if (this.currentBlockElement && !r && !n) {
      const i = this.findParentBlockElement(e);
      if (i)
        return this.appendBlockForElement(i);
      this.currentBlock = this.appendEmptyBlock(), this.currentBlockElement = null;
    }
  }
  findParentBlockElement(e) {
    let { parentElement: n } = e;
    for (; n && n !== this.containerElement; ) {
      if (this.isBlockElement(n) && this.blockElements.includes(n))
        return n;
      n = n.parentElement;
    }
    return null;
  }
  processTextNode(e) {
    let n = e.data;
    var r;
    return OM(e.parentNode) || (n = wT(n), mJ((r = e.previousSibling) === null || r === void 0 ? void 0 : r.textContent) && (n = AGe(n))), this.appendStringWithAttributes(n, this.getTextAttributes(e.parentNode));
  }
  processElement(e) {
    let n;
    if (wd(e)) {
      if (n = TM(e, "attachment"), Object.keys(n).length) {
        const r = this.getTextAttributes(e);
        this.appendAttachmentWithAttributes(n, r), e.innerHTML = "";
      }
      return this.processedElements.push(e);
    }
    switch (_o(e)) {
      case "br":
        return this.isExtraBR(e) || this.isBlockElement(e.nextSibling) || this.appendStringWithAttributes(`
`, this.getTextAttributes(e)), this.processedElements.push(e);
      case "img":
        n = { url: e.getAttribute("src"), contentType: "image" };
        const r = ((i) => {
          const o = i.getAttribute("width"), a = i.getAttribute("height"), s = {};
          return o && (s.width = parseInt(o, 10)), a && (s.height = parseInt(a, 10)), s;
        })(e);
        for (const i in r) {
          const o = r[i];
          n[i] = o;
        }
        return this.appendAttachmentWithAttributes(n, this.getTextAttributes(e)), this.processedElements.push(e);
      case "tr":
        if (this.needsTableSeparator(e))
          return this.appendStringWithAttributes(by.tableRowSeparator);
        break;
      case "td":
        if (this.needsTableSeparator(e))
          return this.appendStringWithAttributes(by.tableCellSeparator);
    }
  }
  appendBlockForAttributesWithElement(e, n) {
    this.blockElements.push(n);
    const r = function() {
      return { text: [], attributes: arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {} };
    }(e);
    return this.blocks.push(r), r;
  }
  appendEmptyBlock() {
    return this.appendBlockForAttributesWithElement([], null);
  }
  appendStringWithAttributes(e, n) {
    return this.appendPiece(W3(e, n));
  }
  appendAttachmentWithAttributes(e, n) {
    return this.appendPiece(function(r) {
      return { attachment: r, attributes: arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, type: "attachment" };
    }(e, n));
  }
  appendPiece(e) {
    return this.blocks.length === 0 && this.appendEmptyBlock(), this.blocks[this.blocks.length - 1].text.push(e);
  }
  appendStringToTextAtIndex(e, n) {
    const { text: r } = this.blocks[n], i = r[r.length - 1];
    if ((i == null ? void 0 : i.type) !== "string")
      return r.push(W3(e));
    i.string += e;
  }
  prependStringToTextAtIndex(e, n) {
    const { text: r } = this.blocks[n], i = r[0];
    if ((i == null ? void 0 : i.type) !== "string")
      return r.unshift(W3(e));
    i.string = e + i.string;
  }
  getTextAttributes(e) {
    let n;
    const r = {};
    for (const i in $d) {
      const o = $d[i];
      if (o.tagName && hc(e, { matchingSelector: o.tagName, untilNode: this.containerElement }))
        r[i] = !0;
      else if (o.parser) {
        if (n = o.parser(e), n) {
          let a = !1;
          for (const s of this.findBlockElementAncestors(e))
            if (o.parser(s) === n) {
              a = !0;
              break;
            }
          a || (r[i] = n);
        }
      } else
        o.styleProperty && (n = e.style[o.styleProperty], n && (r[i] = n));
    }
    if (wd(e)) {
      const i = TM(e, "attributes");
      for (const o in i)
        n = i[o], r[o] = n;
    }
    return r;
  }
  getBlockAttributes(e) {
    const n = [];
    for (; e && e !== this.containerElement; ) {
      for (const i in Po) {
        const o = Po[i];
        var r;
        o.parse !== !1 && _o(e) === o.tagName && ((r = o.test) !== null && r !== void 0 && r.call(o, e) || !o.test) && (n.push(i), o.listAttribute && n.push(o.listAttribute));
      }
      e = e.parentNode;
    }
    return n.reverse();
  }
  findBlockElementAncestors(e) {
    const n = [];
    for (; e && e !== this.containerElement; ) {
      const r = _o(e);
      x0().includes(r) && n.push(e), e = e.parentNode;
    }
    return n;
  }
  isBlockElement(e) {
    if ((e == null ? void 0 : e.nodeType) === Node.ELEMENT_NODE && !wd(e) && !hc(e, { matchingSelector: "td", untilNode: this.containerElement }))
      return x0().includes(_o(e)) || window.getComputedStyle(e).display === "block";
  }
  isInsignificantTextNode(e) {
    if ((e == null ? void 0 : e.nodeType) !== Node.TEXT_NODE || !TGe(e.data))
      return;
    const { parentNode: n, previousSibling: r, nextSibling: i } = e;
    return IGe(n.previousSibling) && !this.isBlockElement(n.previousSibling) || OM(n) ? void 0 : !r || this.isBlockElement(r) || !i || this.isBlockElement(i);
  }
  isExtraBR(e) {
    return _o(e) === "br" && this.isBlockElement(e.parentNode) && e.parentNode.lastChild === e;
  }
  needsTableSeparator(e) {
    if (by.removeBlankTableCells) {
      var n;
      const r = (n = e.previousSibling) === null || n === void 0 ? void 0 : n.textContent;
      return r && /\S/.test(r);
    }
    return e.previousSibling;
  }
  translateBlockElementMarginsToNewlines() {
    const e = this.getMarginOfDefaultBlockElement();
    for (let n = 0; n < this.blocks.length; n++) {
      const r = this.getMarginOfBlockElementAtIndex(n);
      r && (r.top > 2 * e.top && this.prependStringToTextAtIndex(`
`, n), r.bottom > 2 * e.bottom && this.appendStringToTextAtIndex(`
`, n));
    }
  }
  getMarginOfBlockElementAtIndex(e) {
    const n = this.blockElements[e];
    if (n && n.textContent && !x0().includes(_o(n)) && !this.processedElements.includes(n))
      return PM(n);
  }
  getMarginOfDefaultBlockElement() {
    const e = Pn(Po.default.tagName);
    return this.containerElement.appendChild(e), PM(e);
  }
};
const OM = function(t) {
  const { whiteSpace: e } = window.getComputedStyle(t);
  return ["pre", "pre-wrap", "pre-line"].includes(e);
}, IGe = (t) => t && !mJ(t.textContent), PM = function(t) {
  const e = window.getComputedStyle(t);
  if (e.display === "block")
    return { top: parseInt(e.marginTop), bottom: parseInt(e.marginBottom) };
}, _Ge = function(t) {
  return _o(t) === "style" ? NodeFilter.FILTER_REJECT : NodeFilter.FILTER_ACCEPT;
}, AGe = (t) => t.replace(new RegExp("^".concat(CT.source, "+")), ""), TGe = (t) => new RegExp("^".concat(CT.source, "*$")).test(t), mJ = (t) => /\s$/.test(t), OGe = ["contenteditable", "data-trix-id", "data-trix-store-key", "data-trix-mutable", "data-trix-placeholder", "tabindex"], t4 = "data-trix-serialized-attributes", PGe = "[".concat(t4, "]"), NGe = new RegExp("<!--block-->", "g"), kGe = { "application/json": function(t) {
  let e;
  if (t instanceof Va)
    e = t;
  else {
    if (!(t instanceof HTMLElement))
      throw new Error("unserializable object");
    e = sm.parse(t.innerHTML).getDocument();
  }
  return e.toSerializableDocument().toJSONString();
}, "text/html": function(t) {
  let e;
  if (t instanceof Va)
    e = uw.render(t);
  else {
    if (!(t instanceof HTMLElement))
      throw new Error("unserializable object");
    e = t.cloneNode(!0);
  }
  return Array.from(e.querySelectorAll("[data-trix-serialize=false]")).forEach((n) => {
    pc(n);
  }), OGe.forEach((n) => {
    Array.from(e.querySelectorAll("[".concat(n, "]"))).forEach((r) => {
      r.removeAttribute(n);
    });
  }), Array.from(e.querySelectorAll(PGe)).forEach((n) => {
    try {
      const r = JSON.parse(n.getAttribute(t4));
      n.removeAttribute(t4);
      for (const i in r) {
        const o = r[i];
        n.setAttribute(i, o);
      }
    } catch {
    }
  }), e.innerHTML.replace(NGe, "");
} };
var RGe = Object.freeze({ __proto__: null });
let ni = class extends pi {
  constructor(e, n) {
    super(...arguments), this.attachmentManager = e, this.attachment = n, this.id = this.attachment.id, this.file = this.attachment.file;
  }
  remove() {
    return this.attachmentManager.requestRemovalOfAttachment(this.attachment);
  }
};
ni.proxyMethod("attachment.getAttribute"), ni.proxyMethod("attachment.hasAttribute"), ni.proxyMethod("attachment.setAttribute"), ni.proxyMethod("attachment.getAttributes"), ni.proxyMethod("attachment.setAttributes"), ni.proxyMethod("attachment.isPending"), ni.proxyMethod("attachment.isPreviewable"), ni.proxyMethod("attachment.getURL"), ni.proxyMethod("attachment.getHref"), ni.proxyMethod("attachment.getFilename"), ni.proxyMethod("attachment.getFilesize"), ni.proxyMethod("attachment.getFormattedFilesize"), ni.proxyMethod("attachment.getExtension"), ni.proxyMethod("attachment.getContentType"), ni.proxyMethod("attachment.getFile"), ni.proxyMethod("attachment.setFile"), ni.proxyMethod("attachment.releaseFile"), ni.proxyMethod("attachment.getUploadProgress"), ni.proxyMethod("attachment.setUploadProgress");
let vJ = class extends pi {
  constructor() {
    let e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [];
    super(...arguments), this.managedAttachments = {}, Array.from(e).forEach((n) => {
      this.manageAttachment(n);
    });
  }
  getAttachments() {
    const e = [];
    for (const n in this.managedAttachments) {
      const r = this.managedAttachments[n];
      e.push(r);
    }
    return e;
  }
  manageAttachment(e) {
    return this.managedAttachments[e.id] || (this.managedAttachments[e.id] = new ni(this, e)), this.managedAttachments[e.id];
  }
  attachmentIsManaged(e) {
    return e.id in this.managedAttachments;
  }
  requestRemovalOfAttachment(e) {
    var n, r;
    if (this.attachmentIsManaged(e))
      return (n = this.delegate) === null || n === void 0 || (r = n.attachmentManagerDidRequestRemovalOfAttachment) === null || r === void 0 ? void 0 : r.call(n, e);
  }
  unmanageAttachment(e) {
    const n = this.managedAttachments[e.id];
    return delete this.managedAttachments[e.id], n;
  }
}, bJ = class {
  constructor(e) {
    this.composition = e, this.document = this.composition.document;
    const n = this.composition.getSelectedRange();
    this.startPosition = n[0], this.endPosition = n[1], this.startLocation = this.document.locationFromPosition(this.startPosition), this.endLocation = this.document.locationFromPosition(this.endPosition), this.block = this.document.getBlockAtIndex(this.endLocation.index), this.breaksOnReturn = this.block.breaksOnReturn(), this.previousCharacter = this.block.text.getStringAtPosition(this.endLocation.offset - 1), this.nextCharacter = this.block.text.getStringAtPosition(this.endLocation.offset);
  }
  shouldInsertBlockBreak() {
    return this.block.hasAttributes() && this.block.isListItem() && !this.block.isEmpty() ? this.startLocation.offset !== 0 : this.breaksOnReturn && this.nextCharacter !== `
`;
  }
  shouldBreakFormattedBlock() {
    return this.block.hasAttributes() && !this.block.isListItem() && (this.breaksOnReturn && this.nextCharacter === `
` || this.previousCharacter === `
`);
  }
  shouldDecreaseListLevel() {
    return this.block.hasAttributes() && this.block.isListItem() && this.block.isEmpty();
  }
  shouldPrependListItem() {
    return this.block.isListItem() && this.startLocation.offset === 0 && !this.block.isEmpty();
  }
  shouldRemoveLastBlockAttribute() {
    return this.block.hasAttributes() && !this.block.isListItem() && this.block.isEmpty();
  }
}, jl = class extends pi {
  constructor() {
    super(...arguments), this.document = new Va(), this.attachments = [], this.currentAttributes = {}, this.revision = 0;
  }
  setDocument(e) {
    var n, r;
    if (!e.isEqualTo(this.document))
      return this.document = e, this.refreshAttachments(), this.revision++, (n = this.delegate) === null || n === void 0 || (r = n.compositionDidChangeDocument) === null || r === void 0 ? void 0 : r.call(n, e);
  }
  getSnapshot() {
    return { document: this.document, selectedRange: this.getSelectedRange() };
  }
  loadSnapshot(e) {
    var n, r, i, o;
    let { document: a, selectedRange: s } = e;
    return (n = this.delegate) === null || n === void 0 || (r = n.compositionWillLoadSnapshot) === null || r === void 0 || r.call(n), this.setDocument(a ?? new Va()), this.setSelection(s ?? [0, 0]), (i = this.delegate) === null || i === void 0 || (o = i.compositionDidLoadSnapshot) === null || o === void 0 ? void 0 : o.call(i);
  }
  insertText(e) {
    let { updatePosition: n } = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : { updatePosition: !0 };
    const r = this.getSelectedRange();
    this.setDocument(this.document.insertTextAtRange(e, r));
    const i = r[0], o = i + e.getLength();
    return n && this.setSelection(o), this.notifyDelegateOfInsertionAtRange([i, o]);
  }
  insertBlock() {
    let e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : new Oh();
    const n = new Va([e]);
    return this.insertDocument(n);
  }
  insertDocument() {
    let e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : new Va();
    const n = this.getSelectedRange();
    this.setDocument(this.document.insertDocumentAtRange(e, n));
    const r = n[0], i = r + e.getLength();
    return this.setSelection(i), this.notifyDelegateOfInsertionAtRange([r, i]);
  }
  insertString(e, n) {
    const r = this.getCurrentTextAttributes(), i = Os.textForStringWithAttributes(e, r);
    return this.insertText(i, n);
  }
  insertBlockBreak() {
    const e = this.getSelectedRange();
    this.setDocument(this.document.insertBlockBreakAtRange(e));
    const n = e[0], r = n + 1;
    return this.setSelection(r), this.notifyDelegateOfInsertionAtRange([n, r]);
  }
  insertLineBreak() {
    const e = new bJ(this);
    if (e.shouldDecreaseListLevel())
      return this.decreaseListLevel(), this.setSelection(e.startPosition);
    if (e.shouldPrependListItem()) {
      const n = new Va([e.block.copyWithoutText()]);
      return this.insertDocument(n);
    }
    return e.shouldInsertBlockBreak() ? this.insertBlockBreak() : e.shouldRemoveLastBlockAttribute() ? this.removeLastBlockAttribute() : e.shouldBreakFormattedBlock() ? this.breakFormattedBlock(e) : this.insertString(`
`);
  }
  insertHTML(e) {
    const n = sm.parse(e).getDocument(), r = this.getSelectedRange();
    this.setDocument(this.document.mergeDocumentAtRange(n, r));
    const i = r[0], o = i + n.getLength() - 1;
    return this.setSelection(o), this.notifyDelegateOfInsertionAtRange([i, o]);
  }
  replaceHTML(e) {
    const n = sm.parse(e).getDocument().copyUsingObjectsFromDocument(this.document), r = this.getLocationRange({ strict: !1 }), i = this.document.rangeFromLocationRange(r);
    return this.setDocument(n), this.setSelection(i);
  }
  insertFile(e) {
    return this.insertFiles([e]);
  }
  insertFiles(e) {
    const n = [];
    return Array.from(e).forEach((r) => {
      var i;
      if ((i = this.delegate) !== null && i !== void 0 && i.compositionShouldAcceptFile(r)) {
        const o = lw.attachmentForFile(r);
        n.push(o);
      }
    }), this.insertAttachments(n);
  }
  insertAttachment(e) {
    return this.insertAttachments([e]);
  }
  insertAttachments(e) {
    let n = new Os();
    return Array.from(e).forEach((r) => {
      var i;
      const o = r.getType(), a = (i = gT[o]) === null || i === void 0 ? void 0 : i.presentation, s = this.getCurrentTextAttributes();
      a && (s.presentation = a);
      const u = Os.textForAttachmentWithAttributes(r, s);
      n = n.appendText(u);
    }), this.insertText(n);
  }
  shouldManageDeletingInDirection(e) {
    const n = this.getLocationRange();
    if (Ju(n)) {
      if (e === "backward" && n[0].offset === 0 || this.shouldManageMovingCursorInDirection(e))
        return !0;
    } else if (n[0].index !== n[1].index)
      return !0;
    return !1;
  }
  deleteInDirection(e) {
    let n, r, i, { length: o } = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    const a = this.getLocationRange();
    let s = this.getSelectedRange();
    const u = Ju(s);
    if (u ? r = e === "backward" && a[0].offset === 0 : i = a[0].index !== a[1].index, r && this.canDecreaseBlockAttributeLevel()) {
      const l = this.getBlock();
      if (l.isListItem() ? this.decreaseListLevel() : this.decreaseBlockAttributeLevel(), this.setSelection(s[0]), l.isEmpty())
        return !1;
    }
    return u && (s = this.getExpandedRangeInDirection(e, { length: o }), e === "backward" && (n = this.getAttachmentAtRange(s))), n ? (this.editAttachment(n), !1) : (this.setDocument(this.document.removeTextAtRange(s)), this.setSelection(s[0]), !r && !i && void 0);
  }
  moveTextFromRange(e) {
    const [n] = Array.from(this.getSelectedRange());
    return this.setDocument(this.document.moveTextFromRangeToPosition(e, n)), this.setSelection(n);
  }
  removeAttachment(e) {
    const n = this.document.getRangeOfAttachment(e);
    if (n)
      return this.stopEditingAttachment(), this.setDocument(this.document.removeTextAtRange(n)), this.setSelection(n[0]);
  }
  removeLastBlockAttribute() {
    const [e, n] = Array.from(this.getSelectedRange()), r = this.document.getBlockAtPosition(n);
    return this.removeCurrentAttribute(r.getLastAttribute()), this.setSelection(e);
  }
  insertPlaceholder() {
    return this.placeholderPosition = this.getPosition(), this.insertString(" ");
  }
  selectPlaceholder() {
    if (this.placeholderPosition != null)
      return this.setSelectedRange([this.placeholderPosition, this.placeholderPosition + 1]), this.getSelectedRange();
  }
  forgetPlaceholder() {
    this.placeholderPosition = null;
  }
  hasCurrentAttribute(e) {
    const n = this.currentAttributes[e];
    return n != null && n !== !1;
  }
  toggleCurrentAttribute(e) {
    const n = !this.currentAttributes[e];
    return n ? this.setCurrentAttribute(e, n) : this.removeCurrentAttribute(e);
  }
  canSetCurrentAttribute(e) {
    return ui(e) ? this.canSetCurrentBlockAttribute(e) : this.canSetCurrentTextAttribute(e);
  }
  canSetCurrentTextAttribute(e) {
    const n = this.getSelectedDocument();
    if (n) {
      for (const r of Array.from(n.getAttachments()))
        if (!r.hasContent())
          return !1;
      return !0;
    }
  }
  canSetCurrentBlockAttribute(e) {
    const n = this.getBlock();
    if (n)
      return !n.isTerminalBlock();
  }
  setCurrentAttribute(e, n) {
    return ui(e) ? this.setBlockAttribute(e, n) : (this.setTextAttribute(e, n), this.currentAttributes[e] = n, this.notifyDelegateOfCurrentAttributesChange());
  }
  setTextAttribute(e, n) {
    const r = this.getSelectedRange();
    if (!r)
      return;
    const [i, o] = Array.from(r);
    if (i !== o)
      return this.setDocument(this.document.addAttributeAtRange(e, n, r));
    if (e === "href") {
      const a = Os.textForStringWithAttributes(n, { href: n });
      return this.insertText(a);
    }
  }
  setBlockAttribute(e, n) {
    const r = this.getSelectedRange();
    if (this.canSetCurrentAttribute(e))
      return this.setDocument(this.document.applyBlockAttributeAtRange(e, n, r)), this.setSelection(r);
  }
  removeCurrentAttribute(e) {
    return ui(e) ? (this.removeBlockAttribute(e), this.updateCurrentAttributes()) : (this.removeTextAttribute(e), delete this.currentAttributes[e], this.notifyDelegateOfCurrentAttributesChange());
  }
  removeTextAttribute(e) {
    const n = this.getSelectedRange();
    if (n)
      return this.setDocument(this.document.removeAttributeAtRange(e, n));
  }
  removeBlockAttribute(e) {
    const n = this.getSelectedRange();
    if (n)
      return this.setDocument(this.document.removeAttributeAtRange(e, n));
  }
  canDecreaseNestingLevel() {
    var e;
    return ((e = this.getBlock()) === null || e === void 0 ? void 0 : e.getNestingLevel()) > 0;
  }
  canIncreaseNestingLevel() {
    var e;
    const n = this.getBlock();
    if (n) {
      if ((e = ui(n.getLastNestableAttribute())) === null || e === void 0 || !e.listAttribute)
        return n.getNestingLevel() > 0;
      {
        const r = this.getPreviousBlock();
        if (r)
          return function() {
            let i = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : [];
            return Dd((arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : []).slice(0, i.length), i);
          }(r.getListItemAttributes(), n.getListItemAttributes());
      }
    }
  }
  decreaseNestingLevel() {
    const e = this.getBlock();
    if (e)
      return this.setDocument(this.document.replaceBlock(e, e.decreaseNestingLevel()));
  }
  increaseNestingLevel() {
    const e = this.getBlock();
    if (e)
      return this.setDocument(this.document.replaceBlock(e, e.increaseNestingLevel()));
  }
  canDecreaseBlockAttributeLevel() {
    var e;
    return ((e = this.getBlock()) === null || e === void 0 ? void 0 : e.getAttributeLevel()) > 0;
  }
  decreaseBlockAttributeLevel() {
    var e;
    const n = (e = this.getBlock()) === null || e === void 0 ? void 0 : e.getLastAttribute();
    if (n)
      return this.removeCurrentAttribute(n);
  }
  decreaseListLevel() {
    let [e] = Array.from(this.getSelectedRange());
    const { index: n } = this.document.locationFromPosition(e);
    let r = n;
    const i = this.getBlock().getAttributeLevel();
    let o = this.document.getBlockAtIndex(r + 1);
    for (; o && o.isListItem() && !(o.getAttributeLevel() <= i); )
      r++, o = this.document.getBlockAtIndex(r + 1);
    e = this.document.positionFromLocation({ index: n, offset: 0 });
    const a = this.document.positionFromLocation({ index: r, offset: 0 });
    return this.setDocument(this.document.removeLastListAttributeAtRange([e, a]));
  }
  updateCurrentAttributes() {
    const e = this.getSelectedRange({ ignoreLock: !0 });
    if (e) {
      const n = this.document.getCommonAttributesAtRange(e);
      if (Array.from(K_()).forEach((r) => {
        n[r] || this.canSetCurrentAttribute(r) || (n[r] = !1);
      }), !cv(n, this.currentAttributes))
        return this.currentAttributes = n, this.notifyDelegateOfCurrentAttributesChange();
    }
  }
  getCurrentAttributes() {
    return JZ.call({}, this.currentAttributes);
  }
  getCurrentTextAttributes() {
    const e = {};
    for (const n in this.currentAttributes) {
      const r = this.currentAttributes[n];
      r !== !1 && q_(n) && (e[n] = r);
    }
    return e;
  }
  freezeSelection() {
    return this.setCurrentAttribute("frozen", !0);
  }
  thawSelection() {
    return this.removeCurrentAttribute("frozen");
  }
  hasFrozenSelection() {
    return this.hasCurrentAttribute("frozen");
  }
  setSelection(e) {
    var n;
    const r = this.document.locationRangeFromRange(e);
    return (n = this.delegate) === null || n === void 0 ? void 0 : n.compositionDidRequestChangingSelectionToLocationRange(r);
  }
  getSelectedRange() {
    const e = this.getLocationRange();
    if (e)
      return this.document.rangeFromLocationRange(e);
  }
  setSelectedRange(e) {
    const n = this.document.locationRangeFromRange(e);
    return this.getSelectionManager().setLocationRange(n);
  }
  getPosition() {
    const e = this.getLocationRange();
    if (e)
      return this.document.positionFromLocation(e[0]);
  }
  getLocationRange(e) {
    return this.targetLocationRange ? this.targetLocationRange : this.getSelectionManager().getLocationRange(e) || dr({ index: 0, offset: 0 });
  }
  withTargetLocationRange(e, n) {
    let r;
    this.targetLocationRange = e;
    try {
      r = n();
    } finally {
      this.targetLocationRange = null;
    }
    return r;
  }
  withTargetRange(e, n) {
    const r = this.document.locationRangeFromRange(e);
    return this.withTargetLocationRange(r, n);
  }
  withTargetDOMRange(e, n) {
    const r = this.createLocationRangeFromDOMRange(e, { strict: !1 });
    return this.withTargetLocationRange(r, n);
  }
  getExpandedRangeInDirection(e) {
    let { length: n } = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, [r, i] = Array.from(this.getSelectedRange());
    return e === "backward" ? n ? r -= n : r = this.translateUTF16PositionFromOffset(r, -1) : n ? i += n : i = this.translateUTF16PositionFromOffset(i, 1), dr([r, i]);
  }
  shouldManageMovingCursorInDirection(e) {
    if (this.editingAttachment)
      return !0;
    const n = this.getExpandedRangeInDirection(e);
    return this.getAttachmentAtRange(n) != null;
  }
  moveCursorInDirection(e) {
    let n, r;
    if (this.editingAttachment)
      r = this.document.getRangeOfAttachment(this.editingAttachment);
    else {
      const i = this.getSelectedRange();
      r = this.getExpandedRangeInDirection(e), n = !Yx(i, r);
    }
    if (e === "backward" ? this.setSelectedRange(r[0]) : this.setSelectedRange(r[1]), n) {
      const i = this.getAttachmentAtRange(r);
      if (i)
        return this.editAttachment(i);
    }
  }
  expandSelectionInDirection(e) {
    let { length: n } = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    const r = this.getExpandedRangeInDirection(e, { length: n });
    return this.setSelectedRange(r);
  }
  expandSelectionForEditing() {
    if (this.hasCurrentAttribute("href"))
      return this.expandSelectionAroundCommonAttribute("href");
  }
  expandSelectionAroundCommonAttribute(e) {
    const n = this.getPosition(), r = this.document.getRangeOfCommonAttributeAtPosition(e, n);
    return this.setSelectedRange(r);
  }
  selectionContainsAttachments() {
    var e;
    return ((e = this.getSelectedAttachments()) === null || e === void 0 ? void 0 : e.length) > 0;
  }
  selectionIsInCursorTarget() {
    return this.editingAttachment || this.positionIsCursorTarget(this.getPosition());
  }
  positionIsCursorTarget(e) {
    const n = this.document.locationFromPosition(e);
    if (n)
      return this.locationIsCursorTarget(n);
  }
  positionIsBlockBreak(e) {
    var n;
    return (n = this.document.getPieceAtPosition(e)) === null || n === void 0 ? void 0 : n.isBlockBreak();
  }
  getSelectedDocument() {
    const e = this.getSelectedRange();
    if (e)
      return this.document.getDocumentAtRange(e);
  }
  getSelectedAttachments() {
    var e;
    return (e = this.getSelectedDocument()) === null || e === void 0 ? void 0 : e.getAttachments();
  }
  getAttachments() {
    return this.attachments.slice(0);
  }
  refreshAttachments() {
    const e = this.document.getAttachments(), { added: n, removed: r } = function() {
      let i = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [], o = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : [];
      const a = [], s = [], u = /* @__PURE__ */ new Set();
      i.forEach((c) => {
        u.add(c);
      });
      const l = /* @__PURE__ */ new Set();
      return o.forEach((c) => {
        l.add(c), u.has(c) || a.push(c);
      }), i.forEach((c) => {
        l.has(c) || s.push(c);
      }), { added: a, removed: s };
    }(this.attachments, e);
    return this.attachments = e, Array.from(r).forEach((i) => {
      var o, a;
      i.delegate = null, (o = this.delegate) === null || o === void 0 || (a = o.compositionDidRemoveAttachment) === null || a === void 0 || a.call(o, i);
    }), (() => {
      const i = [];
      return Array.from(n).forEach((o) => {
        var a, s;
        o.delegate = this, i.push((a = this.delegate) === null || a === void 0 || (s = a.compositionDidAddAttachment) === null || s === void 0 ? void 0 : s.call(a, o));
      }), i;
    })();
  }
  attachmentDidChangeAttributes(e) {
    var n, r;
    return this.revision++, (n = this.delegate) === null || n === void 0 || (r = n.compositionDidEditAttachment) === null || r === void 0 ? void 0 : r.call(n, e);
  }
  attachmentDidChangePreviewURL(e) {
    var n, r;
    return this.revision++, (n = this.delegate) === null || n === void 0 || (r = n.compositionDidChangeAttachmentPreviewURL) === null || r === void 0 ? void 0 : r.call(n, e);
  }
  editAttachment(e, n) {
    var r, i;
    if (e !== this.editingAttachment)
      return this.stopEditingAttachment(), this.editingAttachment = e, (r = this.delegate) === null || r === void 0 || (i = r.compositionDidStartEditingAttachment) === null || i === void 0 ? void 0 : i.call(r, this.editingAttachment, n);
  }
  stopEditingAttachment() {
    var e, n;
    this.editingAttachment && ((e = this.delegate) === null || e === void 0 || (n = e.compositionDidStopEditingAttachment) === null || n === void 0 || n.call(e, this.editingAttachment), this.editingAttachment = null);
  }
  updateAttributesForAttachment(e, n) {
    return this.setDocument(this.document.updateAttributesForAttachment(e, n));
  }
  removeAttributeForAttachment(e, n) {
    return this.setDocument(this.document.removeAttributeForAttachment(e, n));
  }
  breakFormattedBlock(e) {
    let { document: n } = e;
    const { block: r } = e;
    let i = e.startPosition, o = [i - 1, i];
    r.getBlockBreakPosition() === e.startLocation.offset ? (r.breaksOnReturn() && e.nextCharacter === `
` ? i += 1 : n = n.removeTextAtRange(o), o = [i, i]) : e.nextCharacter === `
` ? e.previousCharacter === `
` ? o = [i - 1, i + 1] : (o = [i, i + 1], i += 1) : e.startLocation.offset - 1 != 0 && (i += 1);
    const a = new Va([r.removeLastAttribute().copyWithoutText()]);
    return this.setDocument(n.insertDocumentAtRange(a, o)), this.setSelection(i);
  }
  getPreviousBlock() {
    const e = this.getLocationRange();
    if (e) {
      const { index: n } = e[0];
      if (n > 0)
        return this.document.getBlockAtIndex(n - 1);
    }
  }
  getBlock() {
    const e = this.getLocationRange();
    if (e)
      return this.document.getBlockAtIndex(e[0].index);
  }
  getAttachmentAtRange(e) {
    const n = this.document.getDocumentAtRange(e);
    if (n.toString() === "".concat("￼", `
`))
      return n.getAttachments()[0];
  }
  notifyDelegateOfCurrentAttributesChange() {
    var e, n;
    return (e = this.delegate) === null || e === void 0 || (n = e.compositionDidChangeCurrentAttributes) === null || n === void 0 ? void 0 : n.call(e, this.currentAttributes);
  }
  notifyDelegateOfInsertionAtRange(e) {
    var n, r;
    return (n = this.delegate) === null || n === void 0 || (r = n.compositionDidPerformInsertionAtRange) === null || r === void 0 ? void 0 : r.call(n, e);
  }
  translateUTF16PositionFromOffset(e, n) {
    const r = this.document.toUTF16String(), i = r.offsetFromUCS2Offset(e);
    return r.offsetToUCS2Offset(i + n);
  }
};
jl.proxyMethod("getSelectionManager().getPointRange"), jl.proxyMethod("getSelectionManager().setLocationRangeFromPointRange"), jl.proxyMethod("getSelectionManager().createLocationRangeFromDOMRange"), jl.proxyMethod("getSelectionManager().locationIsCursorTarget"), jl.proxyMethod("getSelectionManager().selectionIsExpanded"), jl.proxyMethod("delegate?.getSelectionManager");
let n4 = class extends pi {
  constructor(e) {
    super(...arguments), this.composition = e, this.undoEntries = [], this.redoEntries = [];
  }
  recordUndoEntry(e) {
    let { context: n, consolidatable: r } = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    const i = this.undoEntries.slice(-1)[0];
    if (!r || !$Ge(i, e, n)) {
      const o = this.createEntry({ description: e, context: n });
      this.undoEntries.push(o), this.redoEntries = [];
    }
  }
  undo() {
    const e = this.undoEntries.pop();
    if (e) {
      const n = this.createEntry(e);
      return this.redoEntries.push(n), this.composition.loadSnapshot(e.snapshot);
    }
  }
  redo() {
    const e = this.redoEntries.pop();
    if (e) {
      const n = this.createEntry(e);
      return this.undoEntries.push(n), this.composition.loadSnapshot(e.snapshot);
    }
  }
  canUndo() {
    return this.undoEntries.length > 0;
  }
  canRedo() {
    return this.redoEntries.length > 0;
  }
  createEntry() {
    let { description: e, context: n } = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    return { description: e == null ? void 0 : e.toString(), context: JSON.stringify(n), snapshot: this.composition.getSnapshot() };
  }
};
const $Ge = (t, e, n) => (t == null ? void 0 : t.description) === (e == null ? void 0 : e.toString()) && (t == null ? void 0 : t.context) === JSON.stringify(n), j3 = "attachmentGallery";
let yJ = class {
  constructor(e) {
    this.document = e.document, this.selectedRange = e.selectedRange;
  }
  perform() {
    return this.removeBlockAttribute(), this.applyBlockAttribute();
  }
  getSnapshot() {
    return { document: this.document, selectedRange: this.selectedRange };
  }
  removeBlockAttribute() {
    return this.findRangesOfBlocks().map((e) => this.document = this.document.removeAttributeAtRange(j3, e));
  }
  applyBlockAttribute() {
    let e = 0;
    this.findRangesOfPieces().forEach((n) => {
      n[1] - n[0] > 1 && (n[0] += e, n[1] += e, this.document.getCharacterAtPosition(n[1]) !== `
` && (this.document = this.document.insertBlockBreakAtRange(n[1]), n[1] < this.selectedRange[1] && this.moveSelectedRangeForward(), n[1]++, e++), n[0] !== 0 && this.document.getCharacterAtPosition(n[0] - 1) !== `
` && (this.document = this.document.insertBlockBreakAtRange(n[0]), n[0] < this.selectedRange[0] && this.moveSelectedRangeForward(), n[0]++, e++), this.document = this.document.applyBlockAttributeAtRange(j3, !0, n));
    });
  }
  findRangesOfBlocks() {
    return this.document.findRangesForBlockAttribute(j3);
  }
  findRangesOfPieces() {
    return this.document.findRangesForTextAttribute("presentation", { withValue: "gallery" });
  }
  moveSelectedRangeForward() {
    this.selectedRange[0] += 1, this.selectedRange[1] += 1;
  }
};
const xJ = function(t) {
  const e = new yJ(t);
  return e.perform(), e.getSnapshot();
}, DGe = [xJ];
let CJ = class {
  constructor(e, n, r) {
    this.insertFiles = this.insertFiles.bind(this), this.composition = e, this.selectionManager = n, this.element = r, this.undoManager = new n4(this.composition), this.filters = DGe.slice(0);
  }
  loadDocument(e) {
    return this.loadSnapshot({ document: e, selectedRange: [0, 0] });
  }
  loadHTML() {
    let e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "";
    const n = sm.parse(e, { referenceElement: this.element }).getDocument();
    return this.loadDocument(n);
  }
  loadJSON(e) {
    let { document: n, selectedRange: r } = e;
    return n = Va.fromJSON(n), this.loadSnapshot({ document: n, selectedRange: r });
  }
  loadSnapshot(e) {
    return this.undoManager = new n4(this.composition), this.composition.loadSnapshot(e);
  }
  getDocument() {
    return this.composition.document;
  }
  getSelectedDocument() {
    return this.composition.getSelectedDocument();
  }
  getSnapshot() {
    return this.composition.getSnapshot();
  }
  toJSON() {
    return this.getSnapshot();
  }
  deleteInDirection(e) {
    return this.composition.deleteInDirection(e);
  }
  insertAttachment(e) {
    return this.composition.insertAttachment(e);
  }
  insertAttachments(e) {
    return this.composition.insertAttachments(e);
  }
  insertDocument(e) {
    return this.composition.insertDocument(e);
  }
  insertFile(e) {
    return this.composition.insertFile(e);
  }
  insertFiles(e) {
    return this.composition.insertFiles(e);
  }
  insertHTML(e) {
    return this.composition.insertHTML(e);
  }
  insertString(e) {
    return this.composition.insertString(e);
  }
  insertText(e) {
    return this.composition.insertText(e);
  }
  insertLineBreak() {
    return this.composition.insertLineBreak();
  }
  getSelectedRange() {
    return this.composition.getSelectedRange();
  }
  getPosition() {
    return this.composition.getPosition();
  }
  getClientRectAtPosition(e) {
    const n = this.getDocument().locationRangeFromRange([e, e + 1]);
    return this.selectionManager.getClientRectAtLocationRange(n);
  }
  expandSelectionInDirection(e) {
    return this.composition.expandSelectionInDirection(e);
  }
  moveCursorInDirection(e) {
    return this.composition.moveCursorInDirection(e);
  }
  setSelectedRange(e) {
    return this.composition.setSelectedRange(e);
  }
  activateAttribute(e) {
    let n = !(arguments.length > 1 && arguments[1] !== void 0) || arguments[1];
    return this.composition.setCurrentAttribute(e, n);
  }
  attributeIsActive(e) {
    return this.composition.hasCurrentAttribute(e);
  }
  canActivateAttribute(e) {
    return this.composition.canSetCurrentAttribute(e);
  }
  deactivateAttribute(e) {
    return this.composition.removeCurrentAttribute(e);
  }
  canDecreaseNestingLevel() {
    return this.composition.canDecreaseNestingLevel();
  }
  canIncreaseNestingLevel() {
    return this.composition.canIncreaseNestingLevel();
  }
  decreaseNestingLevel() {
    if (this.canDecreaseNestingLevel())
      return this.composition.decreaseNestingLevel();
  }
  increaseNestingLevel() {
    if (this.canIncreaseNestingLevel())
      return this.composition.increaseNestingLevel();
  }
  canRedo() {
    return this.undoManager.canRedo();
  }
  canUndo() {
    return this.undoManager.canUndo();
  }
  recordUndoEntry(e) {
    let { context: n, consolidatable: r } = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    return this.undoManager.recordUndoEntry(e, { context: n, consolidatable: r });
  }
  redo() {
    if (this.canRedo())
      return this.undoManager.redo();
  }
  undo() {
    if (this.canUndo())
      return this.undoManager.undo();
  }
}, wJ = class {
  constructor(e) {
    this.element = e;
  }
  findLocationFromContainerAndOffset(e, n) {
    let { strict: r } = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : { strict: !0 }, i = 0, o = !1;
    const a = { index: 0, offset: 0 }, s = this.findAttachmentElementParentForNode(e);
    s && (e = s.parentNode, n = R3(s));
    const u = Xx(this.element, { usingFilter: EJ });
    for (; u.nextNode(); ) {
      const l = u.currentNode;
      if (l === e && C0(e)) {
        Hh(l) || (a.offset += n);
        break;
      }
      if (l.parentNode === e) {
        if (i++ === n)
          break;
      } else if (!fd(e, l) && i > 0)
        break;
      fM(l, { strict: r }) ? (o && a.index++, a.offset = 0, o = !0) : a.offset += z3(l);
    }
    return a;
  }
  findContainerAndOffsetFromLocation(e) {
    let n, r;
    if (e.index === 0 && e.offset === 0) {
      for (n = this.element, r = 0; n.firstChild; )
        if (n = n.firstChild, $3(n)) {
          r = 1;
          break;
        }
      return [n, r];
    }
    let [i, o] = this.findNodeAndOffsetFromLocation(e);
    if (i) {
      if (C0(i))
        z3(i) === 0 ? (n = i.parentNode.parentNode, r = R3(i.parentNode), Hh(i, { name: "right" }) && r++) : (n = i, r = e.offset - o);
      else {
        if (n = i.parentNode, !fM(i.previousSibling) && !$3(n))
          for (; i === n.lastChild && (i = n, n = n.parentNode, !$3(n)); )
            ;
        r = R3(i), e.offset !== 0 && r++;
      }
      return [n, r];
    }
  }
  findNodeAndOffsetFromLocation(e) {
    let n, r, i = 0;
    for (const o of this.getSignificantNodesForIndex(e.index)) {
      const a = z3(o);
      if (e.offset <= i + a)
        if (C0(o)) {
          if (n = o, r = i, e.offset === r && Hh(n))
            break;
        } else
          n || (n = o, r = i);
      if (i += a, i > e.offset)
        break;
    }
    return [n, r];
  }
  findAttachmentElementParentForNode(e) {
    for (; e && e !== this.element; ) {
      if (wd(e))
        return e;
      e = e.parentNode;
    }
  }
  getSignificantNodesForIndex(e) {
    const n = [], r = Xx(this.element, { usingFilter: MGe });
    let i = !1;
    for (; r.nextNode(); ) {
      const a = r.currentNode;
      var o;
      if (Bh(a)) {
        if (o != null ? o++ : o = 0, o === e)
          i = !0;
        else if (i)
          break;
      } else
        i && n.push(a);
    }
    return n;
  }
};
const z3 = function(t) {
  return t.nodeType === Node.TEXT_NODE ? Hh(t) ? 0 : t.textContent.length : _o(t) === "br" || wd(t) ? 1 : 0;
}, MGe = function(t) {
  return FGe(t) === NodeFilter.FILTER_ACCEPT ? EJ(t) : NodeFilter.FILTER_REJECT;
}, FGe = function(t) {
  return qZ(t) ? NodeFilter.FILTER_REJECT : NodeFilter.FILTER_ACCEPT;
}, EJ = function(t) {
  return wd(t.parentNode) ? NodeFilter.FILTER_REJECT : NodeFilter.FILTER_ACCEPT;
};
let SJ = class {
  createDOMRangeFromPoint(e) {
    let n, { x: r, y: i } = e;
    if (document.caretPositionFromPoint) {
      const { offsetNode: o, offset: a } = document.caretPositionFromPoint(r, i);
      return n = document.createRange(), n.setStart(o, a), n;
    }
    if (document.caretRangeFromPoint)
      return document.caretRangeFromPoint(r, i);
    if (document.body.createTextRange) {
      const o = w0();
      try {
        const a = document.body.createTextRange();
        a.moveToPoint(r, i), a.select();
      } catch {
      }
      return n = w0(), aJ(o), n;
    }
  }
  getClientRectsForDOMRange(e) {
    const n = Array.from(e.getClientRects());
    return [n[0], n[n.length - 1]];
  }
}, ad = class extends pi {
  constructor(e) {
    super(...arguments), this.didMouseDown = this.didMouseDown.bind(this), this.selectionDidChange = this.selectionDidChange.bind(this), this.element = e, this.locationMapper = new wJ(this.element), this.pointMapper = new SJ(), this.lockCount = 0, jr("mousedown", { onElement: this.element, withCallback: this.didMouseDown });
  }
  getLocationRange() {
    let e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    return e.strict === !1 ? this.createLocationRangeFromDOMRange(w0()) : e.ignoreLock ? this.currentLocationRange : this.lockedLocationRange ? this.lockedLocationRange : this.currentLocationRange;
  }
  setLocationRange(e) {
    if (this.lockedLocationRange)
      return;
    e = dr(e);
    const n = this.createDOMRangeFromLocationRange(e);
    n && (aJ(n), this.updateCurrentLocationRange(e));
  }
  setLocationRangeFromPointRange(e) {
    e = dr(e);
    const n = this.getLocationAtPoint(e[0]), r = this.getLocationAtPoint(e[1]);
    this.setLocationRange([n, r]);
  }
  getClientRectAtLocationRange(e) {
    const n = this.createDOMRangeFromLocationRange(e);
    if (n)
      return this.getClientRectsForDOMRange(n)[1];
  }
  locationIsCursorTarget(e) {
    const n = Array.from(this.findNodeAndOffsetFromLocation(e))[0];
    return Hh(n);
  }
  lock() {
    this.lockCount++ == 0 && (this.updateCurrentLocationRange(), this.lockedLocationRange = this.getLocationRange());
  }
  unlock() {
    if (--this.lockCount == 0) {
      const { lockedLocationRange: e } = this;
      if (this.lockedLocationRange = null, e != null)
        return this.setLocationRange(e);
    }
  }
  clearSelection() {
    var e;
    return (e = oJ()) === null || e === void 0 ? void 0 : e.removeAllRanges();
  }
  selectionIsCollapsed() {
    var e;
    return ((e = w0()) === null || e === void 0 ? void 0 : e.collapsed) === !0;
  }
  selectionIsExpanded() {
    return !this.selectionIsCollapsed();
  }
  createLocationRangeFromDOMRange(e, n) {
    if (e == null || !this.domRangeWithinElement(e))
      return;
    const r = this.findLocationFromContainerAndOffset(e.startContainer, e.startOffset, n);
    if (!r)
      return;
    const i = e.collapsed ? void 0 : this.findLocationFromContainerAndOffset(e.endContainer, e.endOffset, n);
    return dr([r, i]);
  }
  didMouseDown() {
    return this.pauseTemporarily();
  }
  pauseTemporarily() {
    let e;
    this.paused = !0;
    const n = () => {
      if (this.paused = !1, clearTimeout(r), Array.from(e).forEach((i) => {
        i.destroy();
      }), fd(document, this.element))
        return this.selectionDidChange();
    }, r = setTimeout(n, 200);
    e = ["mousemove", "keydown"].map((i) => jr(i, { onElement: document, withCallback: n }));
  }
  selectionDidChange() {
    if (!this.paused && !vT(this.element))
      return this.updateCurrentLocationRange();
  }
  updateCurrentLocationRange(e) {
    var n, r;
    if ((e ?? (e = this.createLocationRangeFromDOMRange(w0()))) && !Yx(e, this.currentLocationRange))
      return this.currentLocationRange = e, (n = this.delegate) === null || n === void 0 || (r = n.locationRangeDidChange) === null || r === void 0 ? void 0 : r.call(n, this.currentLocationRange.slice(0));
  }
  createDOMRangeFromLocationRange(e) {
    const n = this.findContainerAndOffsetFromLocation(e[0]), r = Ju(e) ? n : this.findContainerAndOffsetFromLocation(e[1]) || n;
    if (n != null && r != null) {
      const i = document.createRange();
      return i.setStart(...Array.from(n || [])), i.setEnd(...Array.from(r || [])), i;
    }
  }
  getLocationAtPoint(e) {
    const n = this.createDOMRangeFromPoint(e);
    var r;
    if (n)
      return (r = this.createLocationRangeFromDOMRange(n)) === null || r === void 0 ? void 0 : r[0];
  }
  domRangeWithinElement(e) {
    return e.collapsed ? fd(this.element, e.startContainer) : fd(this.element, e.startContainer) && fd(this.element, e.endContainer);
  }
};
ad.proxyMethod("locationMapper.findLocationFromContainerAndOffset"), ad.proxyMethod("locationMapper.findContainerAndOffsetFromLocation"), ad.proxyMethod("locationMapper.findNodeAndOffsetFromLocation"), ad.proxyMethod("pointMapper.createDOMRangeFromPoint"), ad.proxyMethod("pointMapper.getClientRectsForDOMRange");
var IJ = Object.freeze({ __proto__: null, Attachment: lw, AttachmentManager: vJ, AttachmentPiece: Jx, Block: Oh, Composition: jl, Document: Va, Editor: CJ, HTMLParser: sm, HTMLSanitizer: gJ, LineBreakInsertion: bJ, LocationMapper: wJ, ManagedAttachment: ni, Piece: af, PointMapper: SJ, SelectionManager: ad, SplittableList: Kx, StringPiece: IT, Text: Os, UndoManager: n4 }), LGe = Object.freeze({ __proto__: null, ObjectView: of, AttachmentView: ST, BlockView: cJ, DocumentView: uw, PieceView: uJ, PreviewableAttachmentView: sJ, TextView: lJ });
const { lang: G3, css: Jc, keyNames: VGe } = lv, U3 = function(t) {
  return function() {
    const e = t.apply(this, arguments);
    e.do(), this.undos || (this.undos = []), this.undos.push(e.undo);
  };
};
let _J = class extends pi {
  constructor(e, n, r) {
    let i = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : {};
    super(...arguments), sa(this, "makeElementMutable", U3(() => ({ do: () => {
      this.element.dataset.trixMutable = !0;
    }, undo: () => delete this.element.dataset.trixMutable }))), sa(this, "addToolbar", U3(() => {
      const o = Pn({ tagName: "div", className: Jc.attachmentToolbar, data: { trixMutable: !0 }, childNodes: Pn({ tagName: "div", className: "trix-button-row", childNodes: Pn({ tagName: "span", className: "trix-button-group trix-button-group--actions", childNodes: Pn({ tagName: "button", className: "trix-button trix-button--remove", textContent: G3.remove, attributes: { title: G3.remove }, data: { trixAction: "remove" } }) }) }) });
      return this.attachment.isPreviewable() && o.appendChild(Pn({ tagName: "div", className: Jc.attachmentMetadataContainer, childNodes: Pn({ tagName: "span", className: Jc.attachmentMetadata, childNodes: [Pn({ tagName: "span", className: Jc.attachmentName, textContent: this.attachment.getFilename(), attributes: { title: this.attachment.getFilename() } }), Pn({ tagName: "span", className: Jc.attachmentSize, textContent: this.attachment.getFormattedFilesize() })] }) })), jr("click", { onElement: o, withCallback: this.didClickToolbar }), jr("click", { onElement: o, matchingSelector: "[data-trix-action]", withCallback: this.didClickActionButton }), y0("trix-attachment-before-toolbar", { onElement: this.element, attributes: { toolbar: o, attachment: this.attachment } }), { do: () => this.element.appendChild(o), undo: () => pc(o) };
    })), sa(this, "installCaptionEditor", U3(() => {
      const o = Pn({ tagName: "textarea", className: Jc.attachmentCaptionEditor, attributes: { placeholder: G3.captionPlaceholder }, data: { trixMutable: !0 } });
      o.value = this.attachmentPiece.getCaption();
      const a = o.cloneNode();
      a.classList.add("trix-autoresize-clone"), a.tabIndex = -1;
      const s = function() {
        a.value = o.value, o.style.height = a.scrollHeight + "px";
      };
      jr("input", { onElement: o, withCallback: s }), jr("input", { onElement: o, withCallback: this.didInputCaption }), jr("keydown", { onElement: o, withCallback: this.didKeyDownCaption }), jr("change", { onElement: o, withCallback: this.didChangeCaption }), jr("blur", { onElement: o, withCallback: this.didBlurCaption });
      const u = this.element.querySelector("figcaption"), l = u.cloneNode();
      return { do: () => {
        if (u.style.display = "none", l.appendChild(o), l.appendChild(a), l.classList.add("".concat(Jc.attachmentCaption, "--editing")), u.parentElement.insertBefore(l, u), s(), this.options.editCaption)
          return xT(() => o.focus());
      }, undo() {
        pc(l), u.style.display = null;
      } };
    })), this.didClickToolbar = this.didClickToolbar.bind(this), this.didClickActionButton = this.didClickActionButton.bind(this), this.didKeyDownCaption = this.didKeyDownCaption.bind(this), this.didInputCaption = this.didInputCaption.bind(this), this.didChangeCaption = this.didChangeCaption.bind(this), this.didBlurCaption = this.didBlurCaption.bind(this), this.attachmentPiece = e, this.element = n, this.container = r, this.options = i, this.attachment = this.attachmentPiece.attachment, _o(this.element) === "a" && (this.element = this.element.firstChild), this.install();
  }
  install() {
    this.makeElementMutable(), this.addToolbar(), this.attachment.isPreviewable() && this.installCaptionEditor();
  }
  uninstall() {
    var e;
    let n = this.undos.pop();
    for (this.savePendingCaption(); n; )
      n(), n = this.undos.pop();
    (e = this.delegate) === null || e === void 0 || e.didUninstallAttachmentEditor(this);
  }
  savePendingCaption() {
    if (this.pendingCaption != null) {
      const o = this.pendingCaption;
      var e, n, r, i;
      this.pendingCaption = null, o ? (e = this.delegate) === null || e === void 0 || (n = e.attachmentEditorDidRequestUpdatingAttributesForAttachment) === null || n === void 0 || n.call(e, { caption: o }, this.attachment) : (r = this.delegate) === null || r === void 0 || (i = r.attachmentEditorDidRequestRemovingAttributeForAttachment) === null || i === void 0 || i.call(r, "caption", this.attachment);
    }
  }
  didClickToolbar(e) {
    return e.preventDefault(), e.stopPropagation();
  }
  didClickActionButton(e) {
    var n;
    if (e.target.getAttribute("data-trix-action") === "remove")
      return (n = this.delegate) === null || n === void 0 ? void 0 : n.attachmentEditorDidRequestRemovalOfAttachment(this.attachment);
  }
  didKeyDownCaption(e) {
    var n, r;
    if (VGe[e.keyCode] === "return")
      return e.preventDefault(), this.savePendingCaption(), (n = this.delegate) === null || n === void 0 || (r = n.attachmentEditorDidRequestDeselectingAttachment) === null || r === void 0 ? void 0 : r.call(n, this.attachment);
  }
  didInputCaption(e) {
    this.pendingCaption = e.target.value.replace(/\s/g, " ").trim();
  }
  didChangeCaption(e) {
    return this.savePendingCaption();
  }
  didBlurCaption(e) {
    return this.savePendingCaption();
  }
}, AJ = class extends pi {
  constructor(e, n) {
    super(...arguments), this.didFocus = this.didFocus.bind(this), this.didBlur = this.didBlur.bind(this), this.didClickAttachment = this.didClickAttachment.bind(this), this.element = e, this.composition = n, this.documentView = new uw(this.composition.document, { element: this.element }), jr("focus", { onElement: this.element, withCallback: this.didFocus }), jr("blur", { onElement: this.element, withCallback: this.didBlur }), jr("click", { onElement: this.element, matchingSelector: "a[contenteditable=false]", preventDefault: !0 }), jr("mousedown", { onElement: this.element, matchingSelector: Cd, withCallback: this.didClickAttachment }), jr("click", { onElement: this.element, matchingSelector: "a".concat(Cd), preventDefault: !0 });
  }
  didFocus(e) {
    var n;
    const r = () => {
      var i, o;
      if (!this.focused)
        return this.focused = !0, (i = this.delegate) === null || i === void 0 || (o = i.compositionControllerDidFocus) === null || o === void 0 ? void 0 : o.call(i);
    };
    return ((n = this.blurPromise) === null || n === void 0 ? void 0 : n.then(r)) || r();
  }
  didBlur(e) {
    this.blurPromise = new Promise((n) => xT(() => {
      var r, i;
      return vT(this.element) || (this.focused = null, (r = this.delegate) === null || r === void 0 || (i = r.compositionControllerDidBlur) === null || i === void 0 || i.call(r)), this.blurPromise = null, n();
    }));
  }
  didClickAttachment(e, n) {
    var r, i;
    const o = this.findAttachmentForElement(n), a = !!hc(e.target, { matchingSelector: "figcaption" });
    return (r = this.delegate) === null || r === void 0 || (i = r.compositionControllerDidSelectAttachment) === null || i === void 0 ? void 0 : i.call(r, o, { editCaption: a });
  }
  getSerializableElement() {
    return this.isEditingAttachment() ? this.documentView.shadowElement : this.element;
  }
  render() {
    var e, n, r, i, o, a;
    return this.revision !== this.composition.revision && (this.documentView.setDocument(this.composition.document), this.documentView.render(), this.revision = this.composition.revision), this.canSyncDocumentView() && !this.documentView.isSynced() && ((r = this.delegate) === null || r === void 0 || (i = r.compositionControllerWillSyncDocumentView) === null || i === void 0 || i.call(r), this.documentView.sync(), (o = this.delegate) === null || o === void 0 || (a = o.compositionControllerDidSyncDocumentView) === null || a === void 0 || a.call(o)), (e = this.delegate) === null || e === void 0 || (n = e.compositionControllerDidRender) === null || n === void 0 ? void 0 : n.call(e);
  }
  rerenderViewForObject(e) {
    return this.invalidateViewForObject(e), this.render();
  }
  invalidateViewForObject(e) {
    return this.documentView.invalidateViewForObject(e);
  }
  isViewCachingEnabled() {
    return this.documentView.isViewCachingEnabled();
  }
  enableViewCaching() {
    return this.documentView.enableViewCaching();
  }
  disableViewCaching() {
    return this.documentView.disableViewCaching();
  }
  refreshViewCache() {
    return this.documentView.garbageCollectCachedViews();
  }
  isEditingAttachment() {
    return !!this.attachmentEditor;
  }
  installAttachmentEditorForAttachment(e, n) {
    var r;
    if (((r = this.attachmentEditor) === null || r === void 0 ? void 0 : r.attachment) === e)
      return;
    const i = this.documentView.findElementForObject(e);
    if (!i)
      return;
    this.uninstallAttachmentEditor();
    const o = this.composition.document.getAttachmentPieceForAttachment(e);
    this.attachmentEditor = new _J(o, i, this.element, n), this.attachmentEditor.delegate = this;
  }
  uninstallAttachmentEditor() {
    var e;
    return (e = this.attachmentEditor) === null || e === void 0 ? void 0 : e.uninstall();
  }
  didUninstallAttachmentEditor() {
    return this.attachmentEditor = null, this.render();
  }
  attachmentEditorDidRequestUpdatingAttributesForAttachment(e, n) {
    var r, i;
    return (r = this.delegate) === null || r === void 0 || (i = r.compositionControllerWillUpdateAttachment) === null || i === void 0 || i.call(r, n), this.composition.updateAttributesForAttachment(e, n);
  }
  attachmentEditorDidRequestRemovingAttributeForAttachment(e, n) {
    var r, i;
    return (r = this.delegate) === null || r === void 0 || (i = r.compositionControllerWillUpdateAttachment) === null || i === void 0 || i.call(r, n), this.composition.removeAttributeForAttachment(e, n);
  }
  attachmentEditorDidRequestRemovalOfAttachment(e) {
    var n, r;
    return (n = this.delegate) === null || n === void 0 || (r = n.compositionControllerDidRequestRemovalOfAttachment) === null || r === void 0 ? void 0 : r.call(n, e);
  }
  attachmentEditorDidRequestDeselectingAttachment(e) {
    var n, r;
    return (n = this.delegate) === null || n === void 0 || (r = n.compositionControllerDidRequestDeselectingAttachment) === null || r === void 0 ? void 0 : r.call(n, e);
  }
  canSyncDocumentView() {
    return !this.isEditingAttachment();
  }
  findAttachmentForElement(e) {
    return this.composition.document.getAttachmentById(parseInt(e.dataset.trixId, 10));
  }
}, TJ = class extends pi {
};
const OJ = "data-trix-mutable", BGe = "[".concat(OJ, "]"), HGe = { attributes: !0, childList: !0, characterData: !0, characterDataOldValue: !0, subtree: !0 };
let PJ = class extends pi {
  constructor(e) {
    super(e), this.didMutate = this.didMutate.bind(this), this.element = e, this.observer = new window.MutationObserver(this.didMutate), this.start();
  }
  start() {
    return this.reset(), this.observer.observe(this.element, HGe);
  }
  stop() {
    return this.observer.disconnect();
  }
  didMutate(e) {
    var n, r;
    if (this.mutations.push(...Array.from(this.findSignificantMutations(e) || [])), this.mutations.length)
      return (n = this.delegate) === null || n === void 0 || (r = n.elementDidMutate) === null || r === void 0 || r.call(n, this.getMutationSummary()), this.reset();
  }
  reset() {
    this.mutations = [];
  }
  findSignificantMutations(e) {
    return e.filter((n) => this.mutationIsSignificant(n));
  }
  mutationIsSignificant(e) {
    if (this.nodeIsMutable(e.target))
      return !1;
    for (const n of Array.from(this.nodesModifiedByMutation(e)))
      if (this.nodeIsSignificant(n))
        return !0;
    return !1;
  }
  nodeIsSignificant(e) {
    return e !== this.element && !this.nodeIsMutable(e) && !qZ(e);
  }
  nodeIsMutable(e) {
    return hc(e, { matchingSelector: BGe });
  }
  nodesModifiedByMutation(e) {
    const n = [];
    switch (e.type) {
      case "attributes":
        e.attributeName !== OJ && n.push(e.target);
        break;
      case "characterData":
        n.push(e.target.parentNode), n.push(e.target);
        break;
      case "childList":
        n.push(...Array.from(e.addedNodes || [])), n.push(...Array.from(e.removedNodes || []));
    }
    return n;
  }
  getMutationSummary() {
    return this.getTextMutationSummary();
  }
  getTextMutationSummary() {
    const { additions: e, deletions: n } = this.getTextChangesFromCharacterData(), r = this.getTextChangesFromChildList();
    Array.from(r.additions).forEach((s) => {
      Array.from(e).includes(s) || e.push(s);
    }), n.push(...Array.from(r.deletions || []));
    const i = {}, o = e.join("");
    o && (i.textAdded = o);
    const a = n.join("");
    return a && (i.textDeleted = a), i;
  }
  getMutationsByType(e) {
    return Array.from(this.mutations).filter((n) => n.type === e);
  }
  getTextChangesFromChildList() {
    let e, n;
    const r = [], i = [];
    return Array.from(this.getMutationsByType("childList")).forEach((o) => {
      r.push(...Array.from(o.addedNodes || [])), i.push(...Array.from(o.removedNodes || []));
    }), r.length === 0 && i.length === 1 && Bh(i[0]) ? (e = [], n = [`
`]) : (e = r4(r), n = r4(i)), { additions: e.filter((o, a) => o !== n[a]).map(i0), deletions: n.filter((o, a) => o !== e[a]).map(i0) };
  }
  getTextChangesFromCharacterData() {
    let e, n;
    const r = this.getMutationsByType("characterData");
    if (r.length) {
      const i = r[0], o = r[r.length - 1], a = function(s, u) {
        let l, c;
        return s = am.box(s), (u = am.box(u)).length < s.length ? [c, l] = bM(s, u) : [l, c] = bM(u, s), { added: l, removed: c };
      }(i0(i.oldValue), i0(o.target.data));
      e = a.added, n = a.removed;
    }
    return { additions: e ? [e] : [], deletions: n ? [n] : [] };
  }
};
const r4 = function() {
  let t = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [];
  const e = [];
  for (const n of Array.from(t))
    switch (n.nodeType) {
      case Node.TEXT_NODE:
        e.push(n.data);
        break;
      case Node.ELEMENT_NODE:
        _o(n) === "br" ? e.push(`
`) : e.push(...Array.from(r4(n.childNodes) || []));
    }
  return e;
};
let NJ = class extends Zx {
  constructor(e) {
    super(...arguments), this.file = e;
  }
  perform(e) {
    const n = new FileReader();
    return n.onerror = () => e(!1), n.onload = () => {
      n.onerror = null;
      try {
        n.abort();
      } catch {
      }
      return e(!0, this.file);
    }, n.readAsArrayBuffer(this.file);
  }
}, WGe = class {
  constructor(e) {
    this.element = e;
  }
  shouldIgnore(e) {
    return !!uv.samsungAndroid && (this.previousEvent = this.event, this.event = e, this.checkSamsungKeyboardBuggyModeStart(), this.checkSamsungKeyboardBuggyModeEnd(), this.buggyMode);
  }
  checkSamsungKeyboardBuggyModeStart() {
    this.insertingLongTextAfterUnidentifiedChar() && jGe(this.element.innerText, this.event.data) && (this.buggyMode = !0, this.event.preventDefault());
  }
  checkSamsungKeyboardBuggyModeEnd() {
    this.buggyMode && this.event.inputType !== "insertText" && (this.buggyMode = !1);
  }
  insertingLongTextAfterUnidentifiedChar() {
    var e;
    return this.isBeforeInputInsertText() && this.previousEventWasUnidentifiedKeydown() && ((e = this.event.data) === null || e === void 0 ? void 0 : e.length) > 50;
  }
  isBeforeInputInsertText() {
    return this.event.type === "beforeinput" && this.event.inputType === "insertText";
  }
  previousEventWasUnidentifiedKeydown() {
    var e, n;
    return ((e = this.previousEvent) === null || e === void 0 ? void 0 : e.type) === "keydown" && ((n = this.previousEvent) === null || n === void 0 ? void 0 : n.key) === "Unidentified";
  }
};
const jGe = (t, e) => NM(t) === NM(e), zGe = new RegExp("(".concat("￼", "|").concat(sw, "|").concat(Gl, "|\\s)+"), "g"), NM = (t) => t.replace(zGe, " ").trim();
class cw extends pi {
  constructor(e) {
    super(...arguments), this.element = e, this.mutationObserver = new PJ(this.element), this.mutationObserver.delegate = this, this.flakyKeyboardDetector = new WGe(this.element);
    for (const n in this.constructor.events)
      jr(n, { onElement: this.element, withCallback: this.handlerFor(n) });
  }
  elementDidMutate(e) {
  }
  editorWillSyncDocumentView() {
    return this.mutationObserver.stop();
  }
  editorDidSyncDocumentView() {
    return this.mutationObserver.start();
  }
  requestRender() {
    var e, n;
    return (e = this.delegate) === null || e === void 0 || (n = e.inputControllerDidRequestRender) === null || n === void 0 ? void 0 : n.call(e);
  }
  requestReparse() {
    var e, n;
    return (e = this.delegate) === null || e === void 0 || (n = e.inputControllerDidRequestReparse) === null || n === void 0 || n.call(e), this.requestRender();
  }
  attachFiles(e) {
    const n = Array.from(e).map((r) => new NJ(r));
    return Promise.all(n).then((r) => {
      this.handleInput(function() {
        var i, o;
        return (i = this.delegate) === null || i === void 0 || i.inputControllerWillAttachFiles(), (o = this.responder) === null || o === void 0 || o.insertFiles(r), this.requestRender();
      });
    });
  }
  handlerFor(e) {
    return (n) => {
      n.defaultPrevented || this.handleInput(() => {
        if (!vT(this.element)) {
          if (this.flakyKeyboardDetector.shouldIgnore(n))
            return;
          this.eventName = e, this.constructor.events[e].call(this, n);
        }
      });
    };
  }
  handleInput(e) {
    try {
      var n;
      (n = this.delegate) === null || n === void 0 || n.inputControllerWillHandleInput(), e.call(this);
    } finally {
      var r;
      (r = this.delegate) === null || r === void 0 || r.inputControllerDidHandleInput();
    }
  }
  createLinkHTML(e, n) {
    const r = document.createElement("a");
    return r.href = e, r.textContent = n || e, r.outerHTML;
  }
}
var X3;
sa(cw, "events", {});
const { browser: GGe, keyNames: kJ } = lv;
let UGe = 0, ju = class extends cw {
  constructor() {
    super(...arguments), this.resetInputSummary();
  }
  setInputSummary() {
    let e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    this.inputSummary.eventName = this.eventName;
    for (const n in e) {
      const r = e[n];
      this.inputSummary[n] = r;
    }
    return this.inputSummary;
  }
  resetInputSummary() {
    this.inputSummary = {};
  }
  reset() {
    return this.resetInputSummary(), Md.reset();
  }
  elementDidMutate(e) {
    var n, r;
    return this.isComposing() ? (n = this.delegate) === null || n === void 0 || (r = n.inputControllerDidAllowUnhandledInput) === null || r === void 0 ? void 0 : r.call(n) : this.handleInput(function() {
      return this.mutationIsSignificant(e) && (this.mutationIsExpected(e) ? this.requestRender() : this.requestReparse()), this.reset();
    });
  }
  mutationIsExpected(e) {
    let { textAdded: n, textDeleted: r } = e;
    if (this.inputSummary.preferDocument)
      return !0;
    const i = n != null ? n === this.inputSummary.textAdded : !this.inputSummary.textAdded, o = r != null ? this.inputSummary.didDelete : !this.inputSummary.didDelete, a = [`
`, ` 
`].includes(n) && !i, s = r === `
` && !o;
    if (a && !s || s && !a) {
      const l = this.getSelectedRange();
      if (l) {
        var u;
        const c = a ? n.replace(/\n$/, "").length || -1 : (n == null ? void 0 : n.length) || 1;
        if ((u = this.responder) !== null && u !== void 0 && u.positionIsBlockBreak(l[1] + c))
          return !0;
      }
    }
    return i && o;
  }
  mutationIsSignificant(e) {
    var n;
    const r = Object.keys(e).length > 0, i = ((n = this.compositionInput) === null || n === void 0 ? void 0 : n.getEndData()) === "";
    return r || !i;
  }
  getCompositionInput() {
    if (this.isComposing())
      return this.compositionInput;
    this.compositionInput = new Fl(this);
  }
  isComposing() {
    return this.compositionInput && !this.compositionInput.isEnded();
  }
  deleteInDirection(e, n) {
    var r;
    return ((r = this.responder) === null || r === void 0 ? void 0 : r.deleteInDirection(e)) !== !1 ? this.setInputSummary({ didDelete: !0 }) : n ? (n.preventDefault(), this.requestRender()) : void 0;
  }
  serializeSelectionToDataTransfer(e) {
    var n;
    if (!function(i) {
      if (i == null || !i.setData)
        return !1;
      for (const o in gM) {
        const a = gM[o];
        try {
          if (i.setData(o, a), !i.getData(o) === a)
            return !1;
        } catch {
          return !1;
        }
      }
      return !0;
    }(e))
      return;
    const r = (n = this.responder) === null || n === void 0 ? void 0 : n.getSelectedDocument().toSerializableDocument();
    return e.setData("application/x-trix-document", JSON.stringify(r)), e.setData("text/html", uw.render(r).innerHTML), e.setData("text/plain", r.toString().replace(/\n$/, "")), !0;
  }
  canAcceptDataTransfer(e) {
    const n = {};
    return Array.from((e == null ? void 0 : e.types) || []).forEach((r) => {
      n[r] = !0;
    }), n.Files || n["application/x-trix-document"] || n["text/html"] || n["text/plain"];
  }
  getPastedHTMLUsingHiddenElement(e) {
    const n = this.getSelectedRange(), r = { position: "absolute", left: "".concat(window.pageXOffset, "px"), top: "".concat(window.pageYOffset, "px"), opacity: 0 }, i = Pn({ style: r, tagName: "div", editable: !0 });
    return document.body.appendChild(i), i.focus(), requestAnimationFrame(() => {
      const o = i.innerHTML;
      return pc(i), this.setSelectedRange(n), e(o);
    });
  }
};
sa(ju, "events", { keydown(t) {
  this.isComposing() || this.resetInputSummary(), this.inputSummary.didInput = !0;
  const e = kJ[t.keyCode];
  if (e) {
    var n;
    let i = this.keys;
    ["ctrl", "alt", "shift", "meta"].forEach((o) => {
      var a;
      t["".concat(o, "Key")] && (o === "ctrl" && (o = "control"), i = (a = i) === null || a === void 0 ? void 0 : a[o]);
    }), ((n = i) === null || n === void 0 ? void 0 : n[e]) != null && (this.setInputSummary({ keyName: e }), Md.reset(), i[e].call(this, t));
  }
  if (nJ(t)) {
    const i = String.fromCharCode(t.keyCode).toLowerCase();
    if (i) {
      var r;
      const o = ["alt", "shift"].map((a) => {
        if (t["".concat(a, "Key")])
          return a;
      }).filter((a) => a);
      o.push(i), (r = this.delegate) !== null && r !== void 0 && r.inputControllerDidReceiveKeyboardCommand(o) && t.preventDefault();
    }
  }
}, keypress(t) {
  if (this.inputSummary.eventName != null || t.metaKey || t.ctrlKey && !t.altKey)
    return;
  const e = ZGe(t);
  var n, r;
  return e ? ((n = this.delegate) === null || n === void 0 || n.inputControllerWillPerformTyping(), (r = this.responder) === null || r === void 0 || r.insertString(e), this.setInputSummary({ textAdded: e, didDelete: this.selectionIsExpanded() })) : void 0;
}, textInput(t) {
  const { data: e } = t, { textAdded: n } = this.inputSummary;
  if (n && n !== e && n.toUpperCase() === e) {
    var r;
    const i = this.getSelectedRange();
    return this.setSelectedRange([i[0], i[1] + n.length]), (r = this.responder) === null || r === void 0 || r.insertString(e), this.setInputSummary({ textAdded: e }), this.setSelectedRange(i);
  }
}, dragenter(t) {
  t.preventDefault();
}, dragstart(t) {
  var e, n;
  return this.serializeSelectionToDataTransfer(t.dataTransfer), this.draggedRange = this.getSelectedRange(), (e = this.delegate) === null || e === void 0 || (n = e.inputControllerDidStartDrag) === null || n === void 0 ? void 0 : n.call(e);
}, dragover(t) {
  if (this.draggedRange || this.canAcceptDataTransfer(t.dataTransfer)) {
    t.preventDefault();
    const r = { x: t.clientX, y: t.clientY };
    var e, n;
    if (!cv(r, this.draggingPoint))
      return this.draggingPoint = r, (e = this.delegate) === null || e === void 0 || (n = e.inputControllerDidReceiveDragOverPoint) === null || n === void 0 ? void 0 : n.call(e, this.draggingPoint);
  }
}, dragend(t) {
  var e, n;
  (e = this.delegate) === null || e === void 0 || (n = e.inputControllerDidCancelDrag) === null || n === void 0 || n.call(e), this.draggedRange = null, this.draggingPoint = null;
}, drop(t) {
  var e, n;
  t.preventDefault();
  const r = (e = t.dataTransfer) === null || e === void 0 ? void 0 : e.files, i = t.dataTransfer.getData("application/x-trix-document"), o = { x: t.clientX, y: t.clientY };
  if ((n = this.responder) === null || n === void 0 || n.setLocationRangeFromPointRange(o), r != null && r.length)
    this.attachFiles(r);
  else if (this.draggedRange) {
    var a, s;
    (a = this.delegate) === null || a === void 0 || a.inputControllerWillMoveText(), (s = this.responder) === null || s === void 0 || s.moveTextFromRange(this.draggedRange), this.draggedRange = null, this.requestRender();
  } else if (i) {
    var u;
    const l = Va.fromJSONString(i);
    (u = this.responder) === null || u === void 0 || u.insertDocument(l), this.requestRender();
  }
  this.draggedRange = null, this.draggingPoint = null;
}, cut(t) {
  var e, n;
  if ((e = this.responder) !== null && e !== void 0 && e.selectionIsExpanded() && (this.serializeSelectionToDataTransfer(t.clipboardData) && t.preventDefault(), (n = this.delegate) === null || n === void 0 || n.inputControllerWillCutText(), this.deleteInDirection("backward"), t.defaultPrevented))
    return this.requestRender();
}, copy(t) {
  var e;
  (e = this.responder) !== null && e !== void 0 && e.selectionIsExpanded() && this.serializeSelectionToDataTransfer(t.clipboardData) && t.preventDefault();
}, paste(t) {
  const e = t.clipboardData || t.testClipboardData, n = { clipboard: e };
  if (!e || JGe(t))
    return void this.getPastedHTMLUsingHiddenElement((S) => {
      var E, I, _;
      return n.type = "text/html", n.html = S, (E = this.delegate) === null || E === void 0 || E.inputControllerWillPaste(n), (I = this.responder) === null || I === void 0 || I.insertHTML(n.html), this.requestRender(), (_ = this.delegate) === null || _ === void 0 ? void 0 : _.inputControllerDidPaste(n);
    });
  const r = e.getData("URL"), i = e.getData("text/html"), o = e.getData("public.url-name");
  if (r) {
    var a, s, u;
    let S;
    n.type = "text/html", S = o ? wT(o).trim() : r, n.html = this.createLinkHTML(r, S), (a = this.delegate) === null || a === void 0 || a.inputControllerWillPaste(n), this.setInputSummary({ textAdded: S, didDelete: this.selectionIsExpanded() }), (s = this.responder) === null || s === void 0 || s.insertHTML(n.html), this.requestRender(), (u = this.delegate) === null || u === void 0 || u.inputControllerDidPaste(n);
  } else if (tJ(e)) {
    var l, c, d;
    n.type = "text/plain", n.string = e.getData("text/plain"), (l = this.delegate) === null || l === void 0 || l.inputControllerWillPaste(n), this.setInputSummary({ textAdded: n.string, didDelete: this.selectionIsExpanded() }), (c = this.responder) === null || c === void 0 || c.insertString(n.string), this.requestRender(), (d = this.delegate) === null || d === void 0 || d.inputControllerDidPaste(n);
  } else if (i) {
    var f, h, p;
    n.type = "text/html", n.html = i, (f = this.delegate) === null || f === void 0 || f.inputControllerWillPaste(n), (h = this.responder) === null || h === void 0 || h.insertHTML(n.html), this.requestRender(), (p = this.delegate) === null || p === void 0 || p.inputControllerDidPaste(n);
  } else if (Array.from(e.types).includes("Files")) {
    var v, m;
    const S = (v = e.items) === null || v === void 0 || (v = v[0]) === null || v === void 0 || (m = v.getAsFile) === null || m === void 0 ? void 0 : m.call(v);
    if (S) {
      var b, y, w;
      const E = XGe(S);
      !S.name && E && (S.name = "pasted-file-".concat(++UGe, ".").concat(E)), n.type = "File", n.file = S, (b = this.delegate) === null || b === void 0 || b.inputControllerWillAttachFiles(), (y = this.responder) === null || y === void 0 || y.insertFile(n.file), this.requestRender(), (w = this.delegate) === null || w === void 0 || w.inputControllerDidPaste(n);
    }
  }
  t.preventDefault();
}, compositionstart(t) {
  return this.getCompositionInput().start(t.data);
}, compositionupdate(t) {
  return this.getCompositionInput().update(t.data);
}, compositionend(t) {
  return this.getCompositionInput().end(t.data);
}, beforeinput(t) {
  this.inputSummary.didInput = !0;
}, input(t) {
  return this.inputSummary.didInput = !0, t.stopPropagation();
} }), sa(ju, "keys", { backspace(t) {
  var e;
  return (e = this.delegate) === null || e === void 0 || e.inputControllerWillPerformTyping(), this.deleteInDirection("backward", t);
}, delete(t) {
  var e;
  return (e = this.delegate) === null || e === void 0 || e.inputControllerWillPerformTyping(), this.deleteInDirection("forward", t);
}, return(t) {
  var e, n;
  return this.setInputSummary({ preferDocument: !0 }), (e = this.delegate) === null || e === void 0 || e.inputControllerWillPerformTyping(), (n = this.responder) === null || n === void 0 ? void 0 : n.insertLineBreak();
}, tab(t) {
  var e, n;
  (e = this.responder) !== null && e !== void 0 && e.canIncreaseNestingLevel() && ((n = this.responder) === null || n === void 0 || n.increaseNestingLevel(), this.requestRender(), t.preventDefault());
}, left(t) {
  var e;
  if (this.selectionIsInCursorTarget())
    return t.preventDefault(), (e = this.responder) === null || e === void 0 ? void 0 : e.moveCursorInDirection("backward");
}, right(t) {
  var e;
  if (this.selectionIsInCursorTarget())
    return t.preventDefault(), (e = this.responder) === null || e === void 0 ? void 0 : e.moveCursorInDirection("forward");
}, control: { d(t) {
  var e;
  return (e = this.delegate) === null || e === void 0 || e.inputControllerWillPerformTyping(), this.deleteInDirection("forward", t);
}, h(t) {
  var e;
  return (e = this.delegate) === null || e === void 0 || e.inputControllerWillPerformTyping(), this.deleteInDirection("backward", t);
}, o(t) {
  var e, n;
  return t.preventDefault(), (e = this.delegate) === null || e === void 0 || e.inputControllerWillPerformTyping(), (n = this.responder) === null || n === void 0 || n.insertString(`
`, { updatePosition: !1 }), this.requestRender();
} }, shift: { return(t) {
  var e, n;
  (e = this.delegate) === null || e === void 0 || e.inputControllerWillPerformTyping(), (n = this.responder) === null || n === void 0 || n.insertString(`
`), this.requestRender(), t.preventDefault();
}, tab(t) {
  var e, n;
  (e = this.responder) !== null && e !== void 0 && e.canDecreaseNestingLevel() && ((n = this.responder) === null || n === void 0 || n.decreaseNestingLevel(), this.requestRender(), t.preventDefault());
}, left(t) {
  if (this.selectionIsInCursorTarget())
    return t.preventDefault(), this.expandSelectionInDirection("backward");
}, right(t) {
  if (this.selectionIsInCursorTarget())
    return t.preventDefault(), this.expandSelectionInDirection("forward");
} }, alt: { backspace(t) {
  var e;
  return this.setInputSummary({ preferDocument: !1 }), (e = this.delegate) === null || e === void 0 ? void 0 : e.inputControllerWillPerformTyping();
} }, meta: { backspace(t) {
  var e;
  return this.setInputSummary({ preferDocument: !1 }), (e = this.delegate) === null || e === void 0 ? void 0 : e.inputControllerWillPerformTyping();
} } }), ju.proxyMethod("responder?.getSelectedRange"), ju.proxyMethod("responder?.setSelectedRange"), ju.proxyMethod("responder?.expandSelectionInDirection"), ju.proxyMethod("responder?.selectionIsInCursorTarget"), ju.proxyMethod("responder?.selectionIsExpanded");
const XGe = (t) => {
  var e;
  return (e = t.type) === null || e === void 0 || (e = e.match(/\/(\w+)$/)) === null || e === void 0 ? void 0 : e[1];
}, YGe = !((X3 = " ".codePointAt) === null || X3 === void 0 || !X3.call(" ", 0)), ZGe = function(t) {
  if (t.key && YGe && t.key.codePointAt(0) === t.keyCode)
    return t.key;
  {
    let e;
    if (t.which === null ? e = t.keyCode : t.which !== 0 && t.charCode !== 0 && (e = t.charCode), e != null && kJ[e] !== "escape")
      return am.fromCodepoints([e]).toString();
  }
}, JGe = function(t) {
  const e = t.clipboardData;
  if (e) {
    if (e.types.includes("text/html")) {
      for (const n of e.types) {
        const r = /^CorePasteboardFlavorType/.test(n), i = /^dyn\./.test(n) && e.getData(n);
        if (r || i)
          return !0;
      }
      return !1;
    }
    {
      const n = e.types.includes("com.apple.webarchive"), r = e.types.includes("com.apple.flat-rtfd");
      return n || r;
    }
  }
};
let Fl = class extends pi {
  constructor(e) {
    super(...arguments), this.inputController = e, this.responder = this.inputController.responder, this.delegate = this.inputController.delegate, this.inputSummary = this.inputController.inputSummary, this.data = {};
  }
  start(e) {
    if (this.data.start = e, this.isSignificant()) {
      var n, r;
      this.inputSummary.eventName === "keypress" && this.inputSummary.textAdded && ((r = this.responder) === null || r === void 0 || r.deleteInDirection("left")), this.selectionIsExpanded() || (this.insertPlaceholder(), this.requestRender()), this.range = (n = this.responder) === null || n === void 0 ? void 0 : n.getSelectedRange();
    }
  }
  update(e) {
    if (this.data.update = e, this.isSignificant()) {
      const n = this.selectPlaceholder();
      n && (this.forgetPlaceholder(), this.range = n);
    }
  }
  end(e) {
    return this.data.end = e, this.isSignificant() ? (this.forgetPlaceholder(), this.canApplyToDocument() ? (this.setInputSummary({ preferDocument: !0, didInput: !1 }), (n = this.delegate) === null || n === void 0 || n.inputControllerWillPerformTyping(), (r = this.responder) === null || r === void 0 || r.setSelectedRange(this.range), (i = this.responder) === null || i === void 0 || i.insertString(this.data.end), (o = this.responder) === null || o === void 0 ? void 0 : o.setSelectedRange(this.range[0] + this.data.end.length)) : this.data.start != null || this.data.update != null ? (this.requestReparse(), this.inputController.reset()) : void 0) : this.inputController.reset();
    var n, r, i, o;
  }
  getEndData() {
    return this.data.end;
  }
  isEnded() {
    return this.getEndData() != null;
  }
  isSignificant() {
    return !GGe.composesExistingText || this.inputSummary.didInput;
  }
  canApplyToDocument() {
    var e, n;
    return ((e = this.data.start) === null || e === void 0 ? void 0 : e.length) === 0 && ((n = this.data.end) === null || n === void 0 ? void 0 : n.length) > 0 && this.range;
  }
};
Fl.proxyMethod("inputController.setInputSummary"), Fl.proxyMethod("inputController.requestRender"), Fl.proxyMethod("inputController.requestReparse"), Fl.proxyMethod("responder?.selectionIsExpanded"), Fl.proxyMethod("responder?.insertPlaceholder"), Fl.proxyMethod("responder?.selectPlaceholder"), Fl.proxyMethod("responder?.forgetPlaceholder");
let E0 = class extends cw {
  constructor() {
    super(...arguments), this.render = this.render.bind(this);
  }
  elementDidMutate() {
    return this.scheduledRender ? this.composing ? (e = this.delegate) === null || e === void 0 || (n = e.inputControllerDidAllowUnhandledInput) === null || n === void 0 ? void 0 : n.call(e) : void 0 : this.reparse();
    var e, n;
  }
  scheduleRender() {
    return this.scheduledRender ? this.scheduledRender : this.scheduledRender = requestAnimationFrame(this.render);
  }
  render() {
    var e, n;
    cancelAnimationFrame(this.scheduledRender), this.scheduledRender = null, this.composing || (n = this.delegate) === null || n === void 0 || n.render(), (e = this.afterRender) === null || e === void 0 || e.call(this), this.afterRender = null;
  }
  reparse() {
    var e;
    return (e = this.delegate) === null || e === void 0 ? void 0 : e.reparse();
  }
  insertString() {
    var e;
    let n = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "", r = arguments.length > 1 ? arguments[1] : void 0;
    return (e = this.delegate) === null || e === void 0 || e.inputControllerWillPerformTyping(), this.withTargetDOMRange(function() {
      var i;
      return (i = this.responder) === null || i === void 0 ? void 0 : i.insertString(n, r);
    });
  }
  toggleAttributeIfSupported(e) {
    var n;
    if (K_().includes(e))
      return (n = this.delegate) === null || n === void 0 || n.inputControllerWillPerformFormatting(e), this.withTargetDOMRange(function() {
        var r;
        return (r = this.responder) === null || r === void 0 ? void 0 : r.toggleCurrentAttribute(e);
      });
  }
  activateAttributeIfSupported(e, n) {
    var r;
    if (K_().includes(e))
      return (r = this.delegate) === null || r === void 0 || r.inputControllerWillPerformFormatting(e), this.withTargetDOMRange(function() {
        var i;
        return (i = this.responder) === null || i === void 0 ? void 0 : i.setCurrentAttribute(e, n);
      });
  }
  deleteInDirection(e) {
    let { recordUndoEntry: n } = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : { recordUndoEntry: !0 };
    var r;
    n && ((r = this.delegate) === null || r === void 0 || r.inputControllerWillPerformTyping());
    const i = () => {
      var a;
      return (a = this.responder) === null || a === void 0 ? void 0 : a.deleteInDirection(e);
    }, o = this.getTargetDOMRange({ minLength: 2 });
    return o ? this.withTargetDOMRange(o, i) : i();
  }
  withTargetDOMRange(e, n) {
    var r;
    return typeof e == "function" && (n = e, e = this.getTargetDOMRange()), e ? (r = this.responder) === null || r === void 0 ? void 0 : r.withTargetDOMRange(e, n.bind(this)) : (Md.reset(), n.call(this));
  }
  getTargetDOMRange() {
    var e, n;
    let { minLength: r } = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : { minLength: 0 };
    const i = (e = (n = this.event).getTargetRanges) === null || e === void 0 ? void 0 : e.call(n);
    if (i && i.length) {
      const o = KGe(i[0]);
      if (r === 0 || o.toString().length >= r)
        return o;
    }
  }
  withEvent(e, n) {
    let r;
    this.event = e;
    try {
      r = n.call(this);
    } finally {
      this.event = null;
    }
    return r;
  }
};
sa(E0, "events", { keydown(t) {
  if (nJ(t)) {
    var e;
    const n = eUe(t);
    (e = this.delegate) !== null && e !== void 0 && e.inputControllerDidReceiveKeyboardCommand(n) && t.preventDefault();
  } else {
    let n = t.key;
    t.altKey && (n += "+Alt"), t.shiftKey && (n += "+Shift");
    const r = this.constructor.keys[n];
    if (r)
      return this.withEvent(t, r);
  }
}, paste(t) {
  var e;
  let n;
  const r = (e = t.clipboardData) === null || e === void 0 ? void 0 : e.getData("URL");
  return qGe(t) ? (t.preventDefault(), this.attachFiles(t.clipboardData.files)) : QGe(t) ? (t.preventDefault(), n = { type: "text/plain", string: t.clipboardData.getData("text/plain") }, (i = this.delegate) === null || i === void 0 || i.inputControllerWillPaste(n), (o = this.responder) === null || o === void 0 || o.insertString(n.string), this.render(), (a = this.delegate) === null || a === void 0 ? void 0 : a.inputControllerDidPaste(n)) : r ? (t.preventDefault(), n = { type: "text/html", html: this.createLinkHTML(r) }, (s = this.delegate) === null || s === void 0 || s.inputControllerWillPaste(n), (u = this.responder) === null || u === void 0 || u.insertHTML(n.html), this.render(), (l = this.delegate) === null || l === void 0 ? void 0 : l.inputControllerDidPaste(n)) : void 0;
  var i, o, a, s, u, l;
}, beforeinput(t) {
  const e = this.constructor.inputTypes[t.inputType];
  e && (this.withEvent(t, e), this.scheduleRender());
}, input(t) {
  Md.reset();
}, dragstart(t) {
  var e, n;
  (e = this.responder) !== null && e !== void 0 && e.selectionContainsAttachments() && (t.dataTransfer.setData("application/x-trix-dragging", !0), this.dragging = { range: (n = this.responder) === null || n === void 0 ? void 0 : n.getSelectedRange(), point: Z3(t) });
}, dragenter(t) {
  Y3(t) && t.preventDefault();
}, dragover(t) {
  if (this.dragging) {
    t.preventDefault();
    const n = Z3(t);
    var e;
    if (!cv(n, this.dragging.point))
      return this.dragging.point = n, (e = this.responder) === null || e === void 0 ? void 0 : e.setLocationRangeFromPointRange(n);
  } else
    Y3(t) && t.preventDefault();
}, drop(t) {
  var e, n;
  if (this.dragging)
    return t.preventDefault(), (e = this.delegate) === null || e === void 0 || e.inputControllerWillMoveText(), (n = this.responder) === null || n === void 0 || n.moveTextFromRange(this.dragging.range), this.dragging = null, this.scheduleRender();
  if (Y3(t)) {
    var r;
    t.preventDefault();
    const i = Z3(t);
    return (r = this.responder) === null || r === void 0 || r.setLocationRangeFromPointRange(i), this.attachFiles(t.dataTransfer.files);
  }
}, dragend() {
  var t;
  this.dragging && ((t = this.responder) === null || t === void 0 || t.setSelectedRange(this.dragging.range), this.dragging = null);
}, compositionend(t) {
  this.composing && (this.composing = !1, uv.recentAndroid || this.scheduleRender());
} }), sa(E0, "keys", { ArrowLeft() {
  var t, e;
  if ((t = this.responder) !== null && t !== void 0 && t.shouldManageMovingCursorInDirection("backward"))
    return this.event.preventDefault(), (e = this.responder) === null || e === void 0 ? void 0 : e.moveCursorInDirection("backward");
}, ArrowRight() {
  var t, e;
  if ((t = this.responder) !== null && t !== void 0 && t.shouldManageMovingCursorInDirection("forward"))
    return this.event.preventDefault(), (e = this.responder) === null || e === void 0 ? void 0 : e.moveCursorInDirection("forward");
}, Backspace() {
  var t, e, n;
  if ((t = this.responder) !== null && t !== void 0 && t.shouldManageDeletingInDirection("backward"))
    return this.event.preventDefault(), (e = this.delegate) === null || e === void 0 || e.inputControllerWillPerformTyping(), (n = this.responder) === null || n === void 0 || n.deleteInDirection("backward"), this.render();
}, Tab() {
  var t, e;
  if ((t = this.responder) !== null && t !== void 0 && t.canIncreaseNestingLevel())
    return this.event.preventDefault(), (e = this.responder) === null || e === void 0 || e.increaseNestingLevel(), this.render();
}, "Tab+Shift"() {
  var t, e;
  if ((t = this.responder) !== null && t !== void 0 && t.canDecreaseNestingLevel())
    return this.event.preventDefault(), (e = this.responder) === null || e === void 0 || e.decreaseNestingLevel(), this.render();
} }), sa(E0, "inputTypes", { deleteByComposition() {
  return this.deleteInDirection("backward", { recordUndoEntry: !1 });
}, deleteByCut() {
  return this.deleteInDirection("backward");
}, deleteByDrag() {
  return this.event.preventDefault(), this.withTargetDOMRange(function() {
    var t;
    this.deleteByDragRange = (t = this.responder) === null || t === void 0 ? void 0 : t.getSelectedRange();
  });
}, deleteCompositionText() {
  return this.deleteInDirection("backward", { recordUndoEntry: !1 });
}, deleteContent() {
  return this.deleteInDirection("backward");
}, deleteContentBackward() {
  return this.deleteInDirection("backward");
}, deleteContentForward() {
  return this.deleteInDirection("forward");
}, deleteEntireSoftLine() {
  return this.deleteInDirection("forward");
}, deleteHardLineBackward() {
  return this.deleteInDirection("backward");
}, deleteHardLineForward() {
  return this.deleteInDirection("forward");
}, deleteSoftLineBackward() {
  return this.deleteInDirection("backward");
}, deleteSoftLineForward() {
  return this.deleteInDirection("forward");
}, deleteWordBackward() {
  return this.deleteInDirection("backward");
}, deleteWordForward() {
  return this.deleteInDirection("forward");
}, formatBackColor() {
  return this.activateAttributeIfSupported("backgroundColor", this.event.data);
}, formatBold() {
  return this.toggleAttributeIfSupported("bold");
}, formatFontColor() {
  return this.activateAttributeIfSupported("color", this.event.data);
}, formatFontName() {
  return this.activateAttributeIfSupported("font", this.event.data);
}, formatIndent() {
  var t;
  if ((t = this.responder) !== null && t !== void 0 && t.canIncreaseNestingLevel())
    return this.withTargetDOMRange(function() {
      var e;
      return (e = this.responder) === null || e === void 0 ? void 0 : e.increaseNestingLevel();
    });
}, formatItalic() {
  return this.toggleAttributeIfSupported("italic");
}, formatJustifyCenter() {
  return this.toggleAttributeIfSupported("justifyCenter");
}, formatJustifyFull() {
  return this.toggleAttributeIfSupported("justifyFull");
}, formatJustifyLeft() {
  return this.toggleAttributeIfSupported("justifyLeft");
}, formatJustifyRight() {
  return this.toggleAttributeIfSupported("justifyRight");
}, formatOutdent() {
  var t;
  if ((t = this.responder) !== null && t !== void 0 && t.canDecreaseNestingLevel())
    return this.withTargetDOMRange(function() {
      var e;
      return (e = this.responder) === null || e === void 0 ? void 0 : e.decreaseNestingLevel();
    });
}, formatRemove() {
  this.withTargetDOMRange(function() {
    for (const n in (t = this.responder) === null || t === void 0 ? void 0 : t.getCurrentAttributes()) {
      var t, e;
      (e = this.responder) === null || e === void 0 || e.removeCurrentAttribute(n);
    }
  });
}, formatSetBlockTextDirection() {
  return this.activateAttributeIfSupported("blockDir", this.event.data);
}, formatSetInlineTextDirection() {
  return this.activateAttributeIfSupported("textDir", this.event.data);
}, formatStrikeThrough() {
  return this.toggleAttributeIfSupported("strike");
}, formatSubscript() {
  return this.toggleAttributeIfSupported("sub");
}, formatSuperscript() {
  return this.toggleAttributeIfSupported("sup");
}, formatUnderline() {
  return this.toggleAttributeIfSupported("underline");
}, historyRedo() {
  var t;
  return (t = this.delegate) === null || t === void 0 ? void 0 : t.inputControllerWillPerformRedo();
}, historyUndo() {
  var t;
  return (t = this.delegate) === null || t === void 0 ? void 0 : t.inputControllerWillPerformUndo();
}, insertCompositionText() {
  return this.composing = !0, this.insertString(this.event.data);
}, insertFromComposition() {
  return this.composing = !1, this.insertString(this.event.data);
}, insertFromDrop() {
  const t = this.deleteByDragRange;
  var e;
  if (t)
    return this.deleteByDragRange = null, (e = this.delegate) === null || e === void 0 || e.inputControllerWillMoveText(), this.withTargetDOMRange(function() {
      var n;
      return (n = this.responder) === null || n === void 0 ? void 0 : n.moveTextFromRange(t);
    });
}, insertFromPaste() {
  var t;
  const { dataTransfer: e } = this.event, n = { dataTransfer: e }, r = e.getData("URL"), i = e.getData("text/html");
  if (r) {
    var o;
    let l;
    this.event.preventDefault(), n.type = "text/html";
    const c = e.getData("public.url-name");
    l = c ? wT(c).trim() : r, n.html = this.createLinkHTML(r, l), (o = this.delegate) === null || o === void 0 || o.inputControllerWillPaste(n), this.withTargetDOMRange(function() {
      var d;
      return (d = this.responder) === null || d === void 0 ? void 0 : d.insertHTML(n.html);
    }), this.afterRender = () => {
      var d;
      return (d = this.delegate) === null || d === void 0 ? void 0 : d.inputControllerDidPaste(n);
    };
  } else if (tJ(e)) {
    var a;
    n.type = "text/plain", n.string = e.getData("text/plain"), (a = this.delegate) === null || a === void 0 || a.inputControllerWillPaste(n), this.withTargetDOMRange(function() {
      var l;
      return (l = this.responder) === null || l === void 0 ? void 0 : l.insertString(n.string);
    }), this.afterRender = () => {
      var l;
      return (l = this.delegate) === null || l === void 0 ? void 0 : l.inputControllerDidPaste(n);
    };
  } else if (i) {
    var s;
    this.event.preventDefault(), n.type = "text/html", n.html = i, (s = this.delegate) === null || s === void 0 || s.inputControllerWillPaste(n), this.withTargetDOMRange(function() {
      var l;
      return (l = this.responder) === null || l === void 0 ? void 0 : l.insertHTML(n.html);
    }), this.afterRender = () => {
      var l;
      return (l = this.delegate) === null || l === void 0 ? void 0 : l.inputControllerDidPaste(n);
    };
  } else if ((t = e.files) !== null && t !== void 0 && t.length) {
    var u;
    n.type = "File", n.file = e.files[0], (u = this.delegate) === null || u === void 0 || u.inputControllerWillPaste(n), this.withTargetDOMRange(function() {
      var l;
      return (l = this.responder) === null || l === void 0 ? void 0 : l.insertFile(n.file);
    }), this.afterRender = () => {
      var l;
      return (l = this.delegate) === null || l === void 0 ? void 0 : l.inputControllerDidPaste(n);
    };
  }
}, insertFromYank() {
  return this.insertString(this.event.data);
}, insertLineBreak() {
  return this.insertString(`
`);
}, insertLink() {
  return this.activateAttributeIfSupported("href", this.event.data);
}, insertOrderedList() {
  return this.toggleAttributeIfSupported("number");
}, insertParagraph() {
  var t;
  return (t = this.delegate) === null || t === void 0 || t.inputControllerWillPerformTyping(), this.withTargetDOMRange(function() {
    var e;
    return (e = this.responder) === null || e === void 0 ? void 0 : e.insertLineBreak();
  });
}, insertReplacementText() {
  return this.insertString(this.event.dataTransfer.getData("text/plain"), { updatePosition: !1 });
}, insertText() {
  var t;
  return this.insertString(this.event.data || ((t = this.event.dataTransfer) === null || t === void 0 ? void 0 : t.getData("text/plain")));
}, insertTranspose() {
  return this.insertString(this.event.data);
}, insertUnorderedList() {
  return this.toggleAttributeIfSupported("bullet");
} });
const KGe = function(t) {
  const e = document.createRange();
  return e.setStart(t.startContainer, t.startOffset), e.setEnd(t.endContainer, t.endOffset), e;
}, Y3 = (t) => {
  var e;
  return Array.from(((e = t.dataTransfer) === null || e === void 0 ? void 0 : e.types) || []).includes("Files");
}, qGe = function(t) {
  const e = t.clipboardData;
  if (e)
    return e.types.includes("Files") && e.types.length === 1 && e.files.length >= 1;
}, QGe = function(t) {
  const e = t.clipboardData;
  if (e)
    return e.types.includes("text/plain") && e.types.length === 1;
}, eUe = function(t) {
  const e = [];
  return t.altKey && e.push("alt"), t.shiftKey && e.push("shift"), e.push(t.key), e;
}, Z3 = (t) => ({ x: t.clientX, y: t.clientY }), i4 = "[data-trix-attribute]", o4 = "[data-trix-action]", tUe = "".concat(i4, ", ").concat(o4), dw = "[data-trix-dialog]", nUe = "".concat(dw, "[data-trix-active]"), rUe = "".concat(dw, " [data-trix-method]"), kM = "".concat(dw, " [data-trix-input]"), RM = (t, e) => (e || (e = bh(t)), t.querySelector("[data-trix-input][name='".concat(e, "']"))), $M = (t) => t.getAttribute("data-trix-action"), bh = (t) => t.getAttribute("data-trix-attribute") || t.getAttribute("data-trix-dialog-attribute");
let RJ = class extends pi {
  constructor(e) {
    super(e), this.didClickActionButton = this.didClickActionButton.bind(this), this.didClickAttributeButton = this.didClickAttributeButton.bind(this), this.didClickDialogButton = this.didClickDialogButton.bind(this), this.didKeyDownDialogInput = this.didKeyDownDialogInput.bind(this), this.element = e, this.attributes = {}, this.actions = {}, this.resetDialogInputs(), jr("mousedown", { onElement: this.element, matchingSelector: o4, withCallback: this.didClickActionButton }), jr("mousedown", { onElement: this.element, matchingSelector: i4, withCallback: this.didClickAttributeButton }), jr("click", { onElement: this.element, matchingSelector: tUe, preventDefault: !0 }), jr("click", { onElement: this.element, matchingSelector: rUe, withCallback: this.didClickDialogButton }), jr("keydown", { onElement: this.element, matchingSelector: kM, withCallback: this.didKeyDownDialogInput });
  }
  didClickActionButton(e, n) {
    var r;
    (r = this.delegate) === null || r === void 0 || r.toolbarDidClickButton(), e.preventDefault();
    const i = $M(n);
    return this.getDialog(i) ? this.toggleDialog(i) : (o = this.delegate) === null || o === void 0 ? void 0 : o.toolbarDidInvokeAction(i);
    var o;
  }
  didClickAttributeButton(e, n) {
    var r;
    (r = this.delegate) === null || r === void 0 || r.toolbarDidClickButton(), e.preventDefault();
    const i = bh(n);
    var o;
    return this.getDialog(i) ? this.toggleDialog(i) : (o = this.delegate) === null || o === void 0 || o.toolbarDidToggleAttribute(i), this.refreshAttributeButtons();
  }
  didClickDialogButton(e, n) {
    const r = hc(n, { matchingSelector: dw });
    return this[n.getAttribute("data-trix-method")].call(this, r);
  }
  didKeyDownDialogInput(e, n) {
    if (e.keyCode === 13) {
      e.preventDefault();
      const r = n.getAttribute("name"), i = this.getDialog(r);
      this.setAttribute(i);
    }
    if (e.keyCode === 27)
      return e.preventDefault(), this.hideDialog();
  }
  updateActions(e) {
    return this.actions = e, this.refreshActionButtons();
  }
  refreshActionButtons() {
    return this.eachActionButton((e, n) => {
      e.disabled = this.actions[n] === !1;
    });
  }
  eachActionButton(e) {
    return Array.from(this.element.querySelectorAll(o4)).map((n) => e(n, $M(n)));
  }
  updateAttributes(e) {
    return this.attributes = e, this.refreshAttributeButtons();
  }
  refreshAttributeButtons() {
    return this.eachAttributeButton((e, n) => (e.disabled = this.attributes[n] === !1, this.attributes[n] || this.dialogIsVisible(n) ? (e.setAttribute("data-trix-active", ""), e.classList.add("trix-active")) : (e.removeAttribute("data-trix-active"), e.classList.remove("trix-active"))));
  }
  eachAttributeButton(e) {
    return Array.from(this.element.querySelectorAll(i4)).map((n) => e(n, bh(n)));
  }
  applyKeyboardCommand(e) {
    const n = JSON.stringify(e.sort());
    for (const r of Array.from(this.element.querySelectorAll("[data-trix-key]"))) {
      const i = r.getAttribute("data-trix-key").split("+");
      if (JSON.stringify(i.sort()) === n)
        return y0("mousedown", { onElement: r }), !0;
    }
    return !1;
  }
  dialogIsVisible(e) {
    const n = this.getDialog(e);
    if (n)
      return n.hasAttribute("data-trix-active");
  }
  toggleDialog(e) {
    return this.dialogIsVisible(e) ? this.hideDialog() : this.showDialog(e);
  }
  showDialog(e) {
    var n, r;
    this.hideDialog(), (n = this.delegate) === null || n === void 0 || n.toolbarWillShowDialog();
    const i = this.getDialog(e);
    i.setAttribute("data-trix-active", ""), i.classList.add("trix-active"), Array.from(i.querySelectorAll("input[disabled]")).forEach((a) => {
      a.removeAttribute("disabled");
    });
    const o = bh(i);
    if (o) {
      const a = RM(i, e);
      a && (a.value = this.attributes[o] || "", a.select());
    }
    return (r = this.delegate) === null || r === void 0 ? void 0 : r.toolbarDidShowDialog(e);
  }
  setAttribute(e) {
    const n = bh(e), r = RM(e, n);
    return r.willValidate && !r.checkValidity() ? (r.setAttribute("data-trix-validate", ""), r.classList.add("trix-validate"), r.focus()) : ((i = this.delegate) === null || i === void 0 || i.toolbarDidUpdateAttribute(n, r.value), this.hideDialog());
    var i;
  }
  removeAttribute(e) {
    var n;
    const r = bh(e);
    return (n = this.delegate) === null || n === void 0 || n.toolbarDidRemoveAttribute(r), this.hideDialog();
  }
  hideDialog() {
    const e = this.element.querySelector(nUe);
    var n;
    if (e)
      return e.removeAttribute("data-trix-active"), e.classList.remove("trix-active"), this.resetDialogInputs(), (n = this.delegate) === null || n === void 0 ? void 0 : n.toolbarDidHideDialog(((r) => r.getAttribute("data-trix-dialog"))(e));
  }
  resetDialogInputs() {
    Array.from(this.element.querySelectorAll(kM)).forEach((e) => {
      e.setAttribute("disabled", "disabled"), e.removeAttribute("data-trix-validate"), e.classList.remove("trix-validate");
    });
  }
  getDialog(e) {
    return this.element.querySelector("[data-trix-dialog=".concat(e, "]"));
  }
}, S0 = class extends TJ {
  constructor(e) {
    let { editorElement: n, document: r, html: i } = e;
    super(...arguments), this.editorElement = n, this.selectionManager = new ad(this.editorElement), this.selectionManager.delegate = this, this.composition = new jl(), this.composition.delegate = this, this.attachmentManager = new vJ(this.composition.getAttachments()), this.attachmentManager.delegate = this, this.inputController = bT.getLevel() === 2 ? new E0(this.editorElement) : new ju(this.editorElement), this.inputController.delegate = this, this.inputController.responder = this.composition, this.compositionController = new AJ(this.editorElement, this.composition), this.compositionController.delegate = this, this.toolbarController = new RJ(this.editorElement.toolbarElement), this.toolbarController.delegate = this, this.editor = new CJ(this.composition, this.selectionManager, this.editorElement), r ? this.editor.loadDocument(r) : this.editor.loadHTML(i);
  }
  registerSelectionManager() {
    return Md.registerSelectionManager(this.selectionManager);
  }
  unregisterSelectionManager() {
    return Md.unregisterSelectionManager(this.selectionManager);
  }
  render() {
    return this.compositionController.render();
  }
  reparse() {
    return this.composition.replaceHTML(this.editorElement.innerHTML);
  }
  compositionDidChangeDocument(e) {
    if (this.notifyEditorElement("document-change"), !this.handlingInput)
      return this.render();
  }
  compositionDidChangeCurrentAttributes(e) {
    return this.currentAttributes = e, this.toolbarController.updateAttributes(this.currentAttributes), this.updateCurrentActions(), this.notifyEditorElement("attributes-change", { attributes: this.currentAttributes });
  }
  compositionDidPerformInsertionAtRange(e) {
    this.pasting && (this.pastedRange = e);
  }
  compositionShouldAcceptFile(e) {
    return this.notifyEditorElement("file-accept", { file: e });
  }
  compositionDidAddAttachment(e) {
    const n = this.attachmentManager.manageAttachment(e);
    return this.notifyEditorElement("attachment-add", { attachment: n });
  }
  compositionDidEditAttachment(e) {
    this.compositionController.rerenderViewForObject(e);
    const n = this.attachmentManager.manageAttachment(e);
    return this.notifyEditorElement("attachment-edit", { attachment: n }), this.notifyEditorElement("change");
  }
  compositionDidChangeAttachmentPreviewURL(e) {
    return this.compositionController.invalidateViewForObject(e), this.notifyEditorElement("change");
  }
  compositionDidRemoveAttachment(e) {
    const n = this.attachmentManager.unmanageAttachment(e);
    return this.notifyEditorElement("attachment-remove", { attachment: n });
  }
  compositionDidStartEditingAttachment(e, n) {
    return this.attachmentLocationRange = this.composition.document.getLocationRangeOfAttachment(e), this.compositionController.installAttachmentEditorForAttachment(e, n), this.selectionManager.setLocationRange(this.attachmentLocationRange);
  }
  compositionDidStopEditingAttachment(e) {
    this.compositionController.uninstallAttachmentEditor(), this.attachmentLocationRange = null;
  }
  compositionDidRequestChangingSelectionToLocationRange(e) {
    if (!this.loadingSnapshot || this.isFocused())
      return this.requestedLocationRange = e, this.compositionRevisionWhenLocationRangeRequested = this.composition.revision, this.handlingInput ? void 0 : this.render();
  }
  compositionWillLoadSnapshot() {
    this.loadingSnapshot = !0;
  }
  compositionDidLoadSnapshot() {
    this.compositionController.refreshViewCache(), this.render(), this.loadingSnapshot = !1;
  }
  getSelectionManager() {
    return this.selectionManager;
  }
  attachmentManagerDidRequestRemovalOfAttachment(e) {
    return this.removeAttachment(e);
  }
  compositionControllerWillSyncDocumentView() {
    return this.inputController.editorWillSyncDocumentView(), this.selectionManager.lock(), this.selectionManager.clearSelection();
  }
  compositionControllerDidSyncDocumentView() {
    return this.inputController.editorDidSyncDocumentView(), this.selectionManager.unlock(), this.updateCurrentActions(), this.notifyEditorElement("sync");
  }
  compositionControllerDidRender() {
    this.requestedLocationRange && (this.compositionRevisionWhenLocationRangeRequested === this.composition.revision && this.selectionManager.setLocationRange(this.requestedLocationRange), this.requestedLocationRange = null, this.compositionRevisionWhenLocationRangeRequested = null), this.renderedCompositionRevision !== this.composition.revision && (this.runEditorFilters(), this.composition.updateCurrentAttributes(), this.notifyEditorElement("render")), this.renderedCompositionRevision = this.composition.revision;
  }
  compositionControllerDidFocus() {
    return this.isFocusedInvisibly() && this.setLocationRange({ index: 0, offset: 0 }), this.toolbarController.hideDialog(), this.notifyEditorElement("focus");
  }
  compositionControllerDidBlur() {
    return this.notifyEditorElement("blur");
  }
  compositionControllerDidSelectAttachment(e, n) {
    return this.toolbarController.hideDialog(), this.composition.editAttachment(e, n);
  }
  compositionControllerDidRequestDeselectingAttachment(e) {
    const n = this.attachmentLocationRange || this.composition.document.getLocationRangeOfAttachment(e);
    return this.selectionManager.setLocationRange(n[1]);
  }
  compositionControllerWillUpdateAttachment(e) {
    return this.editor.recordUndoEntry("Edit Attachment", { context: e.id, consolidatable: !0 });
  }
  compositionControllerDidRequestRemovalOfAttachment(e) {
    return this.removeAttachment(e);
  }
  inputControllerWillHandleInput() {
    this.handlingInput = !0, this.requestedRender = !1;
  }
  inputControllerDidRequestRender() {
    this.requestedRender = !0;
  }
  inputControllerDidHandleInput() {
    if (this.handlingInput = !1, this.requestedRender)
      return this.requestedRender = !1, this.render();
  }
  inputControllerDidAllowUnhandledInput() {
    return this.notifyEditorElement("change");
  }
  inputControllerDidRequestReparse() {
    return this.reparse();
  }
  inputControllerWillPerformTyping() {
    return this.recordTypingUndoEntry();
  }
  inputControllerWillPerformFormatting(e) {
    return this.recordFormattingUndoEntry(e);
  }
  inputControllerWillCutText() {
    return this.editor.recordUndoEntry("Cut");
  }
  inputControllerWillPaste(e) {
    return this.editor.recordUndoEntry("Paste"), this.pasting = !0, this.notifyEditorElement("before-paste", { paste: e });
  }
  inputControllerDidPaste(e) {
    return e.range = this.pastedRange, this.pastedRange = null, this.pasting = null, this.notifyEditorElement("paste", { paste: e });
  }
  inputControllerWillMoveText() {
    return this.editor.recordUndoEntry("Move");
  }
  inputControllerWillAttachFiles() {
    return this.editor.recordUndoEntry("Drop Files");
  }
  inputControllerWillPerformUndo() {
    return this.editor.undo();
  }
  inputControllerWillPerformRedo() {
    return this.editor.redo();
  }
  inputControllerDidReceiveKeyboardCommand(e) {
    return this.toolbarController.applyKeyboardCommand(e);
  }
  inputControllerDidStartDrag() {
    this.locationRangeBeforeDrag = this.selectionManager.getLocationRange();
  }
  inputControllerDidReceiveDragOverPoint(e) {
    return this.selectionManager.setLocationRangeFromPointRange(e);
  }
  inputControllerDidCancelDrag() {
    this.selectionManager.setLocationRange(this.locationRangeBeforeDrag), this.locationRangeBeforeDrag = null;
  }
  locationRangeDidChange(e) {
    return this.composition.updateCurrentAttributes(), this.updateCurrentActions(), this.attachmentLocationRange && !Yx(this.attachmentLocationRange, e) && this.composition.stopEditingAttachment(), this.notifyEditorElement("selection-change");
  }
  toolbarDidClickButton() {
    if (!this.getLocationRange())
      return this.setLocationRange({ index: 0, offset: 0 });
  }
  toolbarDidInvokeAction(e) {
    return this.invokeAction(e);
  }
  toolbarDidToggleAttribute(e) {
    if (this.recordFormattingUndoEntry(e), this.composition.toggleCurrentAttribute(e), this.render(), !this.selectionFrozen)
      return this.editorElement.focus();
  }
  toolbarDidUpdateAttribute(e, n) {
    if (this.recordFormattingUndoEntry(e), this.composition.setCurrentAttribute(e, n), this.render(), !this.selectionFrozen)
      return this.editorElement.focus();
  }
  toolbarDidRemoveAttribute(e) {
    if (this.recordFormattingUndoEntry(e), this.composition.removeCurrentAttribute(e), this.render(), !this.selectionFrozen)
      return this.editorElement.focus();
  }
  toolbarWillShowDialog(e) {
    return this.composition.expandSelectionForEditing(), this.freezeSelection();
  }
  toolbarDidShowDialog(e) {
    return this.notifyEditorElement("toolbar-dialog-show", { dialogName: e });
  }
  toolbarDidHideDialog(e) {
    return this.thawSelection(), this.editorElement.focus(), this.notifyEditorElement("toolbar-dialog-hide", { dialogName: e });
  }
  freezeSelection() {
    if (!this.selectionFrozen)
      return this.selectionManager.lock(), this.composition.freezeSelection(), this.selectionFrozen = !0, this.render();
  }
  thawSelection() {
    if (this.selectionFrozen)
      return this.composition.thawSelection(), this.selectionManager.unlock(), this.selectionFrozen = !1, this.render();
  }
  canInvokeAction(e) {
    return !!this.actionIsExternal(e) || !((n = this.actions[e]) === null || n === void 0 || (n = n.test) === null || n === void 0 || !n.call(this));
    var n;
  }
  invokeAction(e) {
    return this.actionIsExternal(e) ? this.notifyEditorElement("action-invoke", { actionName: e }) : (n = this.actions[e]) === null || n === void 0 || (n = n.perform) === null || n === void 0 ? void 0 : n.call(this);
    var n;
  }
  actionIsExternal(e) {
    return /^x-./.test(e);
  }
  getCurrentActions() {
    const e = {};
    for (const n in this.actions)
      e[n] = this.canInvokeAction(n);
    return e;
  }
  updateCurrentActions() {
    const e = this.getCurrentActions();
    if (!cv(e, this.currentActions))
      return this.currentActions = e, this.toolbarController.updateActions(this.currentActions), this.notifyEditorElement("actions-change", { actions: this.currentActions });
  }
  runEditorFilters() {
    let e = this.composition.getSnapshot();
    if (Array.from(this.editor.filters).forEach((i) => {
      const { document: o, selectedRange: a } = e;
      e = i.call(this.editor, e) || {}, e.document || (e.document = o), e.selectedRange || (e.selectedRange = a);
    }), n = e, r = this.composition.getSnapshot(), !Yx(n.selectedRange, r.selectedRange) || !n.document.isEqualTo(r.document))
      return this.composition.loadSnapshot(e);
    var n, r;
  }
  updateInputElement() {
    const e = function(n, r) {
      const i = kGe[r];
      if (i)
        return i(n);
      throw new Error("unknown content type: ".concat(r));
    }(this.compositionController.getSerializableElement(), "text/html");
    return this.editorElement.setInputElementValue(e);
  }
  notifyEditorElement(e, n) {
    switch (e) {
      case "document-change":
        this.documentChangedSinceLastRender = !0;
        break;
      case "render":
        this.documentChangedSinceLastRender && (this.documentChangedSinceLastRender = !1, this.notifyEditorElement("change"));
        break;
      case "change":
      case "attachment-add":
      case "attachment-edit":
      case "attachment-remove":
        this.updateInputElement();
    }
    return this.editorElement.notify(e, n);
  }
  removeAttachment(e) {
    return this.editor.recordUndoEntry("Delete Attachment"), this.composition.removeAttachment(e), this.render();
  }
  recordFormattingUndoEntry(e) {
    const n = ui(e), r = this.selectionManager.getLocationRange();
    if (n || !Ju(r))
      return this.editor.recordUndoEntry("Formatting", { context: this.getUndoContext(), consolidatable: !0 });
  }
  recordTypingUndoEntry() {
    return this.editor.recordUndoEntry("Typing", { context: this.getUndoContext(this.currentAttributes), consolidatable: !0 });
  }
  getUndoContext() {
    for (var e = arguments.length, n = new Array(e), r = 0; r < e; r++)
      n[r] = arguments[r];
    return [this.getLocationContext(), this.getTimeContext(), ...Array.from(n)];
  }
  getLocationContext() {
    const e = this.selectionManager.getLocationRange();
    return Ju(e) ? e[0].index : e;
  }
  getTimeContext() {
    return Y_.interval > 0 ? Math.floor((/* @__PURE__ */ new Date()).getTime() / Y_.interval) : 0;
  }
  isFocused() {
    var e;
    return this.editorElement === ((e = this.editorElement.ownerDocument) === null || e === void 0 ? void 0 : e.activeElement);
  }
  isFocusedInvisibly() {
    return this.isFocused() && !this.getLocationRange();
  }
  get actions() {
    return this.constructor.actions;
  }
};
sa(S0, "actions", { undo: { test() {
  return this.editor.canUndo();
}, perform() {
  return this.editor.undo();
} }, redo: { test() {
  return this.editor.canRedo();
}, perform() {
  return this.editor.redo();
} }, link: { test() {
  return this.editor.canActivateAttribute("href");
} }, increaseNestingLevel: { test() {
  return this.editor.canIncreaseNestingLevel();
}, perform() {
  return this.editor.increaseNestingLevel() && this.render();
} }, decreaseNestingLevel: { test() {
  return this.editor.canDecreaseNestingLevel();
}, perform() {
  return this.editor.decreaseNestingLevel() && this.render();
} }, attachFiles: { test: () => !0, perform() {
  return bT.pickFiles(this.editor.insertFiles);
} } }), S0.proxyMethod("getSelectionManager().setLocationRange"), S0.proxyMethod("getSelectionManager().getLocationRange");
var iUe = Object.freeze({ __proto__: null, AttachmentEditorController: _J, CompositionController: AJ, Controller: TJ, EditorController: S0, InputController: cw, Level0InputController: ju, Level2InputController: E0, ToolbarController: RJ }), oUe = Object.freeze({ __proto__: null, MutationObserver: PJ, SelectionChangeObserver: iJ }), aUe = Object.freeze({ __proto__: null, FileVerificationOperation: NJ, ImagePreloadOperation: dJ });
eJ("trix-toolbar", `%t {
  display: block;
}

%t {
  white-space: nowrap;
}

%t [data-trix-dialog] {
  display: none;
}

%t [data-trix-dialog][data-trix-active] {
  display: block;
}

%t [data-trix-dialog] [data-trix-validate]:invalid {
  background-color: #ffdddd;
}`);
let $J = class extends HTMLElement {
  connectedCallback() {
    this.innerHTML === "" && (this.innerHTML = QZ.getDefaultHTML());
  }
}, sUe = 0;
const uUe = function(t) {
  if (!t.hasAttribute("contenteditable"))
    return t.setAttribute("contenteditable", ""), function(e) {
      let n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
      return n.times = 1, jr(e, n);
    }("focus", { onElement: t, withCallback: () => lUe(t) });
}, lUe = function(t) {
  return cUe(t), dUe();
}, cUe = function(t) {
  var e, n;
  if ((e = (n = document).queryCommandSupported) !== null && e !== void 0 && e.call(n, "enableObjectResizing"))
    return document.execCommand("enableObjectResizing", !1, !1), jr("mscontrolselect", { onElement: t, preventDefault: !0 });
}, dUe = function(t) {
  var e, n;
  if ((e = (n = document).queryCommandSupported) !== null && e !== void 0 && e.call(n, "DefaultParagraphSeparator")) {
    const { tagName: r } = Po.default;
    if (["div", "p"].includes(r))
      return document.execCommand("DefaultParagraphSeparator", !1, r);
  }
}, DM = uv.forcesObjectResizing ? { display: "inline", width: "auto" } : { display: "inline-block", width: "1px" };
eJ("trix-editor", `%t {
    display: block;
}

%t:empty:not(:focus)::before {
    content: attr(placeholder);
    color: graytext;
    cursor: text;
    pointer-events: none;
    white-space: pre-line;
}

%t a[contenteditable=false] {
    cursor: text;
}

%t img {
    max-width: 100%;
    height: auto;
}

%t `.concat(Cd, ` figcaption textarea {
    resize: none;
}

%t `).concat(Cd, ` figcaption textarea.trix-autoresize-clone {
    position: absolute;
    left: -9999px;
    max-height: 0px;
}

%t `).concat(Cd, ` figcaption[data-trix-placeholder]:empty::before {
    content: attr(data-trix-placeholder);
    color: graytext;
}

%t [data-trix-cursor-target] {
    display: `).concat(DM.display, ` !important;
    width: `).concat(DM.width, ` !important;
    padding: 0 !important;
    margin: 0 !important;
    border: none !important;
}

%t [data-trix-cursor-target=left] {
    vertical-align: top !important;
    margin-left: -1px !important;
}

%t [data-trix-cursor-target=right] {
    vertical-align: bottom !important;
    margin-right: -1px !important;
}`));
let DJ = class extends HTMLElement {
  get trixId() {
    return this.hasAttribute("trix-id") ? this.getAttribute("trix-id") : (this.setAttribute("trix-id", ++sUe), this.trixId);
  }
  get labels() {
    const e = [];
    this.id && this.ownerDocument && e.push(...Array.from(this.ownerDocument.querySelectorAll("label[for='".concat(this.id, "']")) || []));
    const n = hc(this, { matchingSelector: "label" });
    return n && [this, null].includes(n.control) && e.push(n), e;
  }
  get toolbarElement() {
    var e;
    if (this.hasAttribute("toolbar"))
      return (e = this.ownerDocument) === null || e === void 0 ? void 0 : e.getElementById(this.getAttribute("toolbar"));
    if (this.parentNode) {
      const n = "trix-toolbar-".concat(this.trixId);
      this.setAttribute("toolbar", n);
      const r = Pn("trix-toolbar", { id: n });
      return this.parentNode.insertBefore(r, this), r;
    }
  }
  get form() {
    var e;
    return (e = this.inputElement) === null || e === void 0 ? void 0 : e.form;
  }
  get inputElement() {
    var e;
    if (this.hasAttribute("input"))
      return (e = this.ownerDocument) === null || e === void 0 ? void 0 : e.getElementById(this.getAttribute("input"));
    if (this.parentNode) {
      const n = "trix-input-".concat(this.trixId);
      this.setAttribute("input", n);
      const r = Pn("input", { type: "hidden", id: n });
      return this.parentNode.insertBefore(r, this.nextElementSibling), r;
    }
  }
  get editor() {
    var e;
    return (e = this.editorController) === null || e === void 0 ? void 0 : e.editor;
  }
  get name() {
    var e;
    return (e = this.inputElement) === null || e === void 0 ? void 0 : e.name;
  }
  get value() {
    var e;
    return (e = this.inputElement) === null || e === void 0 ? void 0 : e.value;
  }
  set value(e) {
    var n;
    this.defaultValue = e, (n = this.editor) === null || n === void 0 || n.loadHTML(this.defaultValue);
  }
  notify(e, n) {
    if (this.editorController)
      return y0("trix-".concat(e), { onElement: this, attributes: n });
  }
  setInputElementValue(e) {
    this.inputElement && (this.inputElement.value = e);
  }
  connectedCallback() {
    this.hasAttribute("data-trix-internal") || (uUe(this), function(e) {
      e.hasAttribute("role") || e.setAttribute("role", "textbox");
    }(this), function(e) {
      if (e.hasAttribute("aria-label") || e.hasAttribute("aria-labelledby"))
        return;
      const n = function() {
        const r = Array.from(e.labels).map((o) => {
          if (!o.contains(e))
            return o.textContent;
        }).filter((o) => o), i = r.join(" ");
        return i ? e.setAttribute("aria-label", i) : e.removeAttribute("aria-label");
      };
      n(), jr("focus", { onElement: e, withCallback: n });
    }(this), this.editorController || (y0("trix-before-initialize", { onElement: this }), this.editorController = new S0({ editorElement: this, html: this.defaultValue = this.value }), requestAnimationFrame(() => y0("trix-initialize", { onElement: this }))), this.editorController.registerSelectionManager(), this.registerResetListener(), this.registerClickListener(), function(e) {
      !document.querySelector(":focus") && e.hasAttribute("autofocus") && document.querySelector("[autofocus]") === e && e.focus();
    }(this));
  }
  disconnectedCallback() {
    var e;
    return (e = this.editorController) === null || e === void 0 || e.unregisterSelectionManager(), this.unregisterResetListener(), this.unregisterClickListener();
  }
  registerResetListener() {
    return this.resetListener = this.resetBubbled.bind(this), window.addEventListener("reset", this.resetListener, !1);
  }
  unregisterResetListener() {
    return window.removeEventListener("reset", this.resetListener, !1);
  }
  registerClickListener() {
    return this.clickListener = this.clickBubbled.bind(this), window.addEventListener("click", this.clickListener, !1);
  }
  unregisterClickListener() {
    return window.removeEventListener("click", this.clickListener, !1);
  }
  resetBubbled(e) {
    if (!e.defaultPrevented && e.target === this.form)
      return this.reset();
  }
  clickBubbled(e) {
    if (e.defaultPrevented || this.contains(e.target))
      return;
    const n = hc(e.target, { matchingSelector: "label" });
    return n && Array.from(this.labels).includes(n) ? this.focus() : void 0;
  }
  reset() {
    this.value = this.defaultValue;
  }
};
const qx = { VERSION: Bze, config: lv, core: RGe, models: IJ, views: LGe, controllers: iUe, observers: oUe, operations: aUe, elements: Object.freeze({ __proto__: null, TrixEditorElement: DJ, TrixToolbarElement: $J }), filters: Object.freeze({ __proto__: null, Filter: yJ, attachmentGalleryFilter: xJ }) };
Object.assign(qx, IJ), window.Trix = qx, setTimeout(function() {
  customElements.get("trix-toolbar") || customElements.define("trix-toolbar", $J), customElements.get("trix-editor") || customElements.define("trix-editor", DJ);
}, 0);
const fUe = () => {
  let t = (/* @__PURE__ */ new Date()).getTime();
  return "T" + "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, function(n) {
    const r = (t + Math.random() * 16) % 16 | 0;
    return t = Math.floor(t / 16), (n == "x" ? r : r & 3 | 8).toString(16);
  });
};
class hUe extends O.Component {
  constructor(n) {
    super(n);
    xg(this, "id");
    xg(this, "container");
    xg(this, "editor");
    this.id = fUe(), this.state = {
      showMergeTags: !1,
      tags: []
    };
  }
  componentDidMount() {
    this.container = document.getElementById(`editor-${this.id}`), this.container ? (this.container.addEventListener("trix-initialize", () => {
      qx.config.attachments.preview.caption = {
        name: !1,
        size: !1
      }, qx.config.textAttributes.attachment = {
        remove: {
          action: "removeAttachment",
          text: "Remove"
        }
      }, this.editor = this.container.editor, this.editor || console.error("Cannot find editor!");
    }, !1), this.container.addEventListener("trix-file-accept", function(n) {
      n.preventDefault();
    }), this.container.addEventListener("trix-change", this.handleChange.bind(this), !1)) : console.error("Cannot find container!");
  }
  componentWillUnmount() {
    this.container && (this.container.removeEventListener("trix-file-accept", this.handleChange), this.container.removeEventListener("trix-initialize", this.handleChange), this.container.removeEventListener("trix-change", this.handleChange));
  }
  handleChange(n) {
    this.props.onChange(n);
  }
  handleTagSelected(n, r) {
    r.preventDefault();
    const i = this.state;
    i.showMergeTags = !1, this.setState(i), this.editor.expandSelectionInDirection("backward"), this.editor.insertString(n.tag);
  }
  renderTagSelector(n) {
    if (!n || !this.editor)
      return null;
    const r = document.getElementById("trix-editor-top-level-" + this.id).getBoundingClientRect(), i = this.editor.getClientRectAtPosition(this.editor.getSelectedRange()[0]), o = {
      position: "absolute",
      top: i.top + 25 - r.top,
      left: i.left + 25 - r.left,
      width: "250px",
      boxSizing: "border-box",
      padding: 0,
      margin: ".2em 0 0",
      backgroundColor: "hsla(0,0%,100%,.9)",
      borderRadius: ".3em",
      background: "linear-gradient(to bottom right, white, hsla(0,0%,100%,.8))",
      border: "1px solid rgba(0,0,0,.3)",
      boxShadow: ".05em .2em .6em rgba(0,0,0,.2)",
      textShadow: "none"
    }, a = {
      display: "block",
      padding: ".2em .5em",
      cursor: "pointer"
    };
    return /* @__PURE__ */ Oe.jsx("div", { style: o, className: "react-trix-suggestions", children: n.map((s) => /* @__PURE__ */ Oe.jsx("a", { style: a, href: "#", onClick: this.handleTagSelected.bind(this, s), children: s.name }, s.name)) });
  }
  render() {
    const n = this.state;
    let r = null;
    n.showMergeTags && (r = this.renderTagSelector(n.tags));
    const i = {
      id: `editor-${this.id}`,
      input: `input-${this.id}`
    };
    return /* @__PURE__ */ Oe.jsxs("div", { className: "ant-form-trix-wrapper", id: "trix-editor-top-level-" + this.id, style: { position: "relative" }, children: [
      O.createElement("trix-editor", i),
      /* @__PURE__ */ Oe.jsx(
        "input",
        {
          type: "hidden",
          id: `input-${this.id}`,
          value: this.props.value
        }
      ),
      r
    ] });
  }
}
const pUe = (t) => {
  var s;
  const { text: e, checked: n, readOnly: r = !1, onChange: i, ...o } = t, a = va(o, hl);
  return /* @__PURE__ */ Oe.jsx(
    Y0,
    {
      ...a,
      disabled: r || ((s = t.inputProps) == null ? void 0 : s.disabled),
      checked: n,
      onChange: i,
      children: e
    }
  );
}, gUe = (t) => {
  const { options: e, onChange: n, value: r, readOnly: i = !1, inputProps: o, ...a } = t, s = va(a, hl);
  return /* @__PURE__ */ Oe.jsx(
    Y0.Group,
    {
      ...s,
      ...o,
      value: r,
      style: { width: "100%" },
      onChange: n,
      children: /* @__PURE__ */ Oe.jsx(Wm, { children: e.map((u) => /* @__PURE__ */ Oe.jsx(rc, { ...u.colProps ? u.colProps : { span: 24 }, children: /* @__PURE__ */ Oe.jsx(Y0, { disabled: u.disabled || i, value: u.value, children: u.label }) }, u.value)) })
    }
  );
};
var mUe = Object.defineProperty, vUe = (t, e, n) => e in t ? mUe(t, e, { enumerable: !0, configurable: !0, writable: !0, value: n }) : t[e] = n, Ll = (t, e, n) => vUe(t, typeof e != "symbol" ? e + "" : e, n);
let bUe = class MJ {
  constructor(e = /* @__PURE__ */ new Map()) {
    this.map = e;
  }
  clone() {
    return new MJ(new Map(this.map));
  }
  increment(e) {
    const n = this.map.get(e) ?? 0;
    this.map.set(e, n + 1);
  }
  decrement(e, n) {
    let r = this.map.get(e);
    r !== void 0 && (r -= 1, this.map.set(e, r), r === 0 && n());
  }
}, _b = class {
  constructor() {
    Ll(this, "map", /* @__PURE__ */ new Map());
  }
  getOrCreate(e) {
    let n = this.map.get(e);
    return n === void 0 && (n = /* @__PURE__ */ new Set(), this.map.set(e, n)), n;
  }
  get(e) {
    return this.map.get(e);
  }
  use(e, n) {
    const r = this.get(e);
    r !== void 0 && n(r);
  }
  delete(e) {
    return this.map.delete(e);
  }
};
function hd(t, e) {
  return e(t), t;
}
function _T() {
}
const FJ = "cell";
function MM(t, e) {
  return t === e;
}
const fw = /* @__PURE__ */ new Map();
let yUe = class {
  /**
   * Creates a new realm.
   * @param initialValues - the initial cell values that will populate the realm.
   * Those values will not trigger a recomputation cycle, and will overwrite the initial values specified for each cell.
   */
  constructor(e = {}) {
    Ll(this, "subscriptions", new _b()), Ll(this, "singletonSubscriptions", /* @__PURE__ */ new Map()), Ll(this, "graph", new _b()), Ll(this, "state", /* @__PURE__ */ new Map()), Ll(this, "distinctNodes", /* @__PURE__ */ new Map()), Ll(this, "executionMaps", /* @__PURE__ */ new Map()), Ll(this, "definitionRegistry", /* @__PURE__ */ new Set());
    for (const n of Object.getOwnPropertySymbols(e))
      this.state.set(n, e[n]);
  }
  /**
   * Creates or resolves an existing cell instance in the realm. Useful as a joint point when building your own operators.
   * @returns a reference to the cell.
   * @param value - the initial value of the cell
   * @param distinct - true by default. Pass false to mark the signal as a non-distinct one, meaning that publishing the same value multiple times will re-trigger a recomputation cycle.
   * @param node - optional, a reference to a cell. If the cell has not been touched in the realm before, the realm will instantiate a reference to it. If it's registered already, the function will return the reference.
   */
  cellInstance(e, n = !0, r = Symbol()) {
    return this.state.has(r) || this.state.set(r, e), n !== !1 && !this.distinctNodes.has(r) && this.distinctNodes.set(r, n === !0 ? MM : n), r;
  }
  /**
   * Creates or resolves an existing signal instance in the realm. Useful as a joint point when building your own operators.
   * @returns a reference to the signal.
   * @param distinct - true by default. Pass false to mark the signal as a non-distinct one, meaning that publishing the same value multiple times will re-trigger a recomputation cycle.
   * @param node - optional, a reference to a signal. If the signal has not been touched in the realm before, the realm will instantiate a reference to it. If it's registered already, the function will return the reference.
   */
  signalInstance(e = !0, n = Symbol()) {
    return e !== !1 && this.distinctNodes.set(n, e === !0 ? MM : e), n;
  }
  /**
   * Subscribes to the values published in the referred node.
   * @param node - the cell/signal to subscribe to.
   * @param subscription - the callback to execute when the node receives a new value.
   * @returns a function that, when called, will cancel the subscription.
   *
   * @example
   * ```ts
   * const signal$ = Signal<number>()
   * const r = new Realm()
   * const unsub = r.sub(signal$, console.log)
   * r.pub(signal$, 2)
   * unsub()
   * r.pub(signal$, 3)
   * ```
   */
  sub(e, n) {
    this.register(e);
    const r = this.subscriptions.getOrCreate(e);
    return r.add(n), () => r.delete(n);
  }
  /**
   * Subscribes exclusively to values in the referred node.
   * Calling this multiple times on a single node will remove the previous subscription created through `singletonSub`.
   * Subscriptions created through `sub` are not affected.
   * @returns a function that, when called, will cancel the subscription.
   *
   * @example
   * ```ts
   * const signal$ = Signal<number>()
   * const r = new Realm()
   * // console.log will run only once.
   * r.singletonSub(signal$, console.log)
   * r.singletonSub(signal$, console.log)
   * r.singletonSub(signal$, console.log)
   * r.pub(signal$, 2)
   * ```
   */
  singletonSub(e, n) {
    return this.register(e), n === void 0 ? this.singletonSubscriptions.delete(e) : this.singletonSubscriptions.set(e, n), () => this.singletonSubscriptions.delete(e);
  }
  /**
   * Clears all exclusive subscriptions.
   */
  resetSingletonSubs() {
    this.singletonSubscriptions.clear();
  }
  // biome-ignore lint/suspicious/noExplicitAny: I know why we need any here
  subMultiple(e, n) {
    const r = this.signalInstance();
    return this.connect({
      map: (i) => (...o) => {
        i(o);
      },
      sink: r,
      sources: e
    }), this.sub(r, n);
  }
  /**
   * Publishes into multiple nodes simultaneously, triggering a single re-computation cycle.
   * @param values - a record of node references and their values.
   *
   * @example
   * ```ts
   * const foo$ = Cell('foo')
   * const bar$ = Cell('bar')
   *
   * const r = new Realm()
   * r.pubIn({[foo$]: 'foo1', [bar$]: 'bar1'})
   * ```
   */
  pubIn(e) {
    var n;
    const r = Reflect.ownKeys(e), i = this.getExecutionMap(r), o = i.refCount.clone(), a = i.participatingNodes.slice(), s = new Map(this.state), u = (l) => {
      this.graph.use(l, (c) => {
        for (const { sources: d, sink: f } of c)
          d.has(l) && o.decrement(f, () => {
            a.splice(a.indexOf(f), 1), u(f);
          });
      });
    };
    for (; ; ) {
      const l = a.shift();
      if (l === void 0)
        break;
      const c = l;
      let d = !1;
      const f = (h) => {
        const p = this.distinctNodes.get(c);
        if (p != null && p(s.get(c), h)) {
          d = !1;
          return;
        }
        d = !0, s.set(c, h), this.state.has(c) && this.state.set(c, h);
      };
      if (Object.prototype.hasOwnProperty.call(e, c) ? f(e[c]) : i.projections.use(c, (h) => {
        for (const p of h) {
          const v = [...Array.from(p.sources), ...Array.from(p.pulls)].map((m) => s.get(m));
          p.map(f)(...v);
        }
      }), d) {
        const h = s.get(c);
        this.inContext(() => {
          this.subscriptions.use(c, (p) => {
            for (const v of p)
              v(h);
          });
        }), (n = this.singletonSubscriptions.get(c)) == null || n(h);
      } else
        u(c);
    }
  }
  /**
   * A low-level utility that connects multiple nodes to a sink node with a map function. Used as a foundation for the higher-level operators.
   * The nodes can be active (sources) or passive (pulls).
   */
  connect({
    sources: e,
    pulls: n = [],
    map: r,
    sink: i
  }) {
    const o = {
      map: r,
      pulls: new Set(n),
      sink: this.register(i),
      sources: new Set(e)
    };
    for (const a of [...e, ...n])
      this.register(a), this.graph.getOrCreate(a).add(o);
    this.executionMaps.clear();
  }
  pub(e, n) {
    this.pubIn({ [e]: n });
  }
  pipe(e, ...n) {
    return this.combineOperators(...n)(e);
  }
  transformer(...e) {
    return (n) => hd(this.signalInstance(), (r) => (this.link(this.pipe(r, ...e), n), r));
  }
  /**
   * Links the output of a node to the input of another node.
   */
  link(e, n) {
    this.connect({
      map: (r) => (i) => {
        r(i);
      },
      sink: n,
      sources: [e]
    });
  }
  // prettier-ignore
  combine(...e) {
    return hd(this.signalInstance(), (n) => {
      this.connect({
        map: (r) => (...i) => {
          r(i);
        },
        sink: n,
        sources: e
      });
    });
  }
  // prettier-ignore
  combineCells(...e) {
    return hd(
      this.cellInstance(
        e.map((n) => this.getValue(n)),
        !0
      ),
      (n) => {
        this.connect({
          map: (r) => (...i) => {
            r(i);
          },
          sink: n,
          sources: e
        });
      }
    );
  }
  /**
   * Gets the current value of a node. The node must be stateful.
   * @remark if possible, use {@link withLatestFrom} or {@link combine}, as getValue will not create a dependency to the passed node,
   * which means that if you call it within a computational cycle, you may not get the correct value.
   * @param node - the node instance.
   * @example
   * ```ts
   * const foo$ = Cell('foo')
   *
   * const r = new Realm()
   * r.getValue(foo$) // 'foo'
   * r.pub(foo$, 'bar')
   * //...
   * r.getValue(foo$) // 'bar'
   * ```
   */
  getValue(e) {
    return this.register(e), this.state.get(e);
  }
  getValues(e) {
    return e.map((n) => this.getValue(n));
  }
  /**
   * Explicitly includes the specified cell/signal reference in the realm.
   * Most of the time you don't need to do that, since any interaction with the node through a realm will register it.
   * The only exception of that rule should be when the interaction is conditional, and the node definition includes an init function that needs to be eagerly evaluated.
   */
  register(e) {
    const n = fw.get(e);
    return n === void 0 || this.definitionRegistry.has(e) ? e : (this.definitionRegistry.add(e), hd(
      n.type === FJ ? this.cellInstance(n.initial, n.distinct, e) : this.signalInstance(n.distinct, e),
      (r) => {
        this.inContext(() => {
          n.init(this, r);
        });
      }
    ));
  }
  inContext(e) {
    return e();
  }
  /**
   * Convenient for mutation of cells that contian non-primitive values (e.g. arrays, or objects).
   * Specifies that the cell value should be changed when source emits, with the result of the map callback parameter.
   * the map parameter gets called with the current value of the cell and the value published through the source.
   * @typeParam T - the type of the cell value.
   * @typeParam K - the type of the value published through the source.
   * @example
   * ```ts
   * const items$ = Cell<string[]([])
   * const addItem$ = Signal<string>(false, (r) => {
   *   r.changeWith(items$, addItem$, (items, item) => [...items, item])
   * })
   * const r = new Realm()
   * r.pub(addItem$, 'foo')
   * r.pub(addItem$, 'bar')
   * r.getValue(items$) // ['foo', 'bar']
   * ```
   */
  changeWith(e, n, r) {
    this.connect({
      sources: [n],
      pulls: [e],
      sink: e,
      map: (i) => (o, a) => {
        i(r(a, o));
      }
    });
  }
  calculateExecutionMap(e) {
    const n = [], r = /* @__PURE__ */ new Set(), i = new _b(), o = new bUe(), a = new _b(), s = (u, l = 0) => {
      o.increment(u), !r.has(u) && (this.register(u), i.use(u, (c) => {
        l = Math.max(...Array.from(c).map((d) => n.indexOf(d))) + 1;
      }), this.graph.use(u, (c) => {
        for (const d of c)
          d.sources.has(u) ? (a.getOrCreate(d.sink).add(d), s(d.sink, l)) : i.getOrCreate(d.sink).add(u);
      }), r.add(u), n.splice(l, 0, u));
    };
    return e.forEach(s), { participatingNodes: n, pendingPulls: i, projections: a, refCount: o };
  }
  getExecutionMap(e) {
    let n = e;
    if (e.length === 1) {
      n = e[0];
      const i = this.executionMaps.get(n);
      if (i !== void 0)
        return i;
    } else
      for (const [i, o] of this.executionMaps.entries())
        if (Array.isArray(i) && i.length === e.length && i.every((a) => e.includes(a)))
          return o;
    const r = this.calculateExecutionMap(e);
    return this.executionMaps.set(n, r), r;
  }
  combineOperators(...e) {
    return (n) => {
      for (const r of e)
        n = r(n, this);
      return n;
    };
  }
};
function Ht(t, e = _T, n = !0) {
  return hd(Symbol(), (r) => {
    fw.set(r, { type: FJ, distinct: n, initial: t, init: e });
  });
}
function Ei(t = _T, e = !1) {
  return hd(Symbol(), (n) => {
    fw.set(n, { type: "signal", distinct: e, init: t });
  });
}
function Nc(t = _T) {
  return hd(Symbol(), (e) => {
    fw.set(e, { type: "signal", distinct: !1, init: t });
  });
}
const LJ = x.createContext(null);
function hw() {
  const t = x.useContext(LJ);
  if (t === null)
    throw new Error("useRealm must be used within a RealmContextProvider");
  return t;
}
function ua(t) {
  const e = hw();
  e.register(t);
  const n = x.useCallback((r) => e.sub(t, r), [e, t]);
  return x.useSyncExternalStore(
    n,
    () => e.getValue(t),
    () => e.getValue(t)
  );
}
function ya(...t) {
  const e = hw();
  return ua(e.combineCells.apply(e, t));
}
function Vi(t) {
  const e = hw();
  return e.register(t), x.useCallback(
    (n) => {
      e.pub(t, n);
    },
    [e, t]
  );
}
function Wh(t) {
  return (e, n) => {
    const r = n.signalInstance();
    return n.connect({
      map: (i) => (o) => {
        i(t(o));
      },
      sink: r,
      sources: [e]
    }), r;
  };
}
function Zr(...t) {
  return (e, n) => {
    const r = n.signalInstance();
    return n.connect({
      map: (i) => (...o) => {
        i(o);
      },
      pulls: t,
      sink: r,
      sources: [e]
    }), r;
  };
}
function VJ(t) {
  return (e, n) => {
    const r = n.signalInstance();
    return n.connect({
      map: (i) => () => {
        i(t);
      },
      sink: r,
      sources: [e]
    }), r;
  };
}
function dv(t) {
  return (e, n) => {
    const r = n.signalInstance();
    return n.connect({
      map: (i) => (o) => {
        t(o) && i(o);
      },
      sink: r,
      sources: [e]
    }), r;
  };
}
function BJ(t, e) {
  return (n, r) => {
    const i = r.signalInstance();
    return r.connect({
      map: (o) => (a) => {
        o(e = t(e, a));
      },
      sink: i,
      sources: [n]
    }), i;
  };
}
function xUe(t, e) {
  return e(t), t;
}
function jh() {
}
function pl(t) {
  return function(e) {
    return {
      init: (n) => {
        var r;
        return (r = t.init) == null ? void 0 : r.call(t, n, e);
      },
      postInit: (n) => {
        var r;
        return (r = t.postInit) == null ? void 0 : r.call(t, n, e);
      },
      update: (n) => {
        var r;
        return (r = t.update) == null ? void 0 : r.call(t, n, e);
      }
    };
  };
}
function CUe({ children: t, plugins: e }) {
  const n = O.useMemo(() => xUe(new yUe(), (r) => {
    var i, o;
    for (const a of e)
      (i = a.init) == null || i.call(a, r);
    for (const a of e)
      (o = a.postInit) == null || o.call(a, r);
  }), []);
  return O.useEffect(() => {
    var r;
    for (const i of e)
      (r = i.update) == null || r.call(i, n);
  }), /* @__PURE__ */ O.createElement(LJ.Provider, { value: n }, t);
}
function wUe(t) {
  return t && t.__esModule && Object.prototype.hasOwnProperty.call(t, "default") ? t.default : t;
}
var EUe = wUe(function(t) {
  const e = new URLSearchParams();
  e.append("code", t);
  for (let n = 1; n < arguments.length; n++)
    e.append("v", arguments[n]);
  throw Error(`Minified Lexical error #${t}; visit https://lexical.dev/docs/error?${e} for the full message or use the non-minified dev environment for full errors and additional helpful warnings.`);
});
const Qx = oi(null);
function HJ(t, e) {
  let n = null;
  return t != null && (n = t[1]), { getTheme: function() {
    return e ?? (n != null ? n.getTheme() : null);
  } };
}
function Vo() {
  const t = fn(Qx);
  return t == null && EUe(8), t;
}
function gl(t) {
  return {};
}
const fv = {}, SUe = {}, pw = {}, Ed = {}, zh = {}, um = {}, Gh = {}, hv = {}, a4 = {}, lm = {}, cm = {}, Ku = {}, AT = {}, TT = {}, WJ = {}, jJ = {}, IUe = {}, OT = {}, _Ue = {}, PT = {}, NT = {}, lp = {}, zJ = {}, gw = {}, pv = {}, mw = {}, kT = {}, GJ = {}, RT = {}, s4 = {}, $T = {}, AUe = {}, vw = {}, DT = {}, TUe = {}, bw = {}, MT = {}, u4 = {}, OUe = {}, PUe = {}, Ab = {}, Tb = {}, FT = {}, LT = {}, UJ = {}, Ls = typeof window < "u" && window.document !== void 0 && window.document.createElement !== void 0, NUe = Ls && "documentMode" in document ? document.documentMode : null, ds = Ls && /Mac|iPod|iPhone|iPad/.test(navigator.platform), ic = Ls && /^(?!.*Seamonkey)(?=.*Firefox).*/i.test(navigator.userAgent), e2 = !(!Ls || !("InputEvent" in window) || NUe) && "getTargetRanges" in new window.InputEvent("input"), VT = Ls && /Version\/[\d.]+.*Safari/.test(navigator.userAgent), yw = Ls && /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream, kUe = Ls && /Android/.test(navigator.userAgent), XJ = Ls && /^(?=.*Chrome).*/i.test(navigator.userAgent), RUe = Ls && kUe && XJ, BT = Ls && /AppleWebKit\/[\d.]+/.test(navigator.userAgent) && !XJ, gv = 1, kc = 3, Fd = 0, YJ = 1, cp = 2, $Ue = 0, DUe = 1, MUe = 2, t2 = 4, n2 = 8, HT = 128, FUe = 112 | (3 | t2 | n2) | HT, WT = 1, jT = 2, zT = 3, GT = 4, UT = 5, XT = 6, xw = VT || yw || BT ? " " : "​", rl = `

`, LUe = ic ? " " : xw, ZJ = "֑-߿יִ-﷽ﹰ-ﻼ", JJ = "A-Za-zÀ-ÖØ-öø-ʸ̀-֐ࠀ-῿‎Ⰰ-﬜︀-﹯﻽-￿", VUe = new RegExp("^[^" + JJ + "]*[" + ZJ + "]"), BUe = new RegExp("^[^" + ZJ + "]*[" + JJ + "]"), Qu = { bold: 1, code: 16, highlight: HT, italic: 2, strikethrough: t2, subscript: 32, superscript: 64, underline: n2 }, HUe = { directionless: 1, unmergeable: 2 }, FM = { center: jT, end: XT, justify: GT, left: WT, right: zT, start: UT }, WUe = { [jT]: "center", [XT]: "end", [GT]: "justify", [WT]: "left", [zT]: "right", [UT]: "start" }, jUe = { normal: 0, segmented: 2, token: 1 }, zUe = { [$Ue]: "normal", [MUe]: "segmented", [DUe]: "token" };
function GUe(t) {
  return t && t.__esModule && Object.prototype.hasOwnProperty.call(t, "default") ? t.default : t;
}
var St = GUe(function(t) {
  const e = new URLSearchParams();
  e.append("code", t);
  for (let n = 1; n < arguments.length; n++)
    e.append("v", arguments[n]);
  throw Error(`Minified Lexical error #${t}; visit https://lexical.dev/docs/error?${e} for the full message or use the non-minified dev environment for full errors and additional helpful warnings.`);
});
function r2(...t) {
  const e = [];
  for (const n of t)
    if (n && typeof n == "string")
      for (const [r] of n.matchAll(/\S+/g))
        e.push(r);
  return e;
}
const UUe = 100;
let l4 = !1, YT = 0;
function XUe(t) {
  YT = t.timeStamp;
}
function J3(t, e, n) {
  return e.__lexicalLineBreak === t || t[`__lexicalKey_${n._key}`] !== void 0;
}
function YUe(t, e, n) {
  const r = pu(n._window);
  let i = null, o = null;
  r !== null && r.anchorNode === t && (i = r.anchorOffset, o = r.focusOffset);
  const a = t.nodeValue;
  a !== null && tO(e, a, i, o, !1);
}
function ZUe(t, e, n) {
  if (rt(t)) {
    const r = t.anchor.getNode();
    if (r.is(n) && t.format !== r.getFormat())
      return !1;
  }
  return e.nodeType === kc && n.isAttached();
}
function KJ(t, e, n) {
  l4 = !0;
  const r = performance.now() - YT > UUe;
  try {
    ia(t, () => {
      const i = vt() || function(f) {
        return f.getEditorState().read(() => {
          const h = vt();
          return h !== null ? h.clone() : null;
        });
      }(t), o = /* @__PURE__ */ new Map(), a = t.getRootElement(), s = t._editorState, u = t._blockCursorElement;
      let l = !1, c = "";
      for (let f = 0; f < e.length; f++) {
        const h = e[f], p = h.type, v = h.target;
        let m = hu(v, s);
        if (!(m === null && v !== a || fr(m))) {
          if (p === "characterData")
            r && pt(m) && ZUe(i, v, m) && YUe(v, m, t);
          else if (p === "childList") {
            l = !0;
            const b = h.addedNodes;
            for (let S = 0; S < b.length; S++) {
              const E = b[S], I = nK(E), _ = E.parentNode;
              if (_ != null && E !== u && I === null && (E.nodeName !== "BR" || !J3(E, _, t))) {
                if (ic) {
                  const A = E.innerText || E.nodeValue;
                  A && (c += A);
                }
                _.removeChild(E);
              }
            }
            const y = h.removedNodes, w = y.length;
            if (w > 0) {
              let S = 0;
              for (let E = 0; E < w; E++) {
                const I = y[E];
                (I.nodeName === "BR" && J3(I, v, t) || u === I) && (v.appendChild(I), S++);
              }
              w !== S && (v === a && (m = iK(s)), o.set(v, m));
            }
          }
        }
      }
      if (o.size > 0)
        for (const [f, h] of o)
          if (We(h)) {
            const p = h.getChildrenKeys();
            let v = f.firstChild;
            for (let m = 0; m < p.length; m++) {
              const b = p[m], y = t.getElementByKey(b);
              y !== null && (v == null ? (f.appendChild(y), v = y) : v !== y && f.replaceChild(y, v), v = v.nextSibling);
            }
          } else
            pt(h) && h.markDirty();
      const d = n.takeRecords();
      if (d.length > 0) {
        for (let f = 0; f < d.length; f++) {
          const h = d[f], p = h.addedNodes, v = h.target;
          for (let m = 0; m < p.length; m++) {
            const b = p[m], y = b.parentNode;
            y == null || b.nodeName !== "BR" || J3(b, v, t) || y.removeChild(b);
          }
        }
        n.takeRecords();
      }
      i !== null && (l && (i.dirty = !0, uo(i)), ic && uK(t) && i.insertRawText(c));
    });
  } finally {
    l4 = !1;
  }
}
function qJ(t) {
  const e = t._observer;
  e !== null && KJ(t, e.takeRecords(), e);
}
function QJ(t) {
  (function(e) {
    YT === 0 && Sw(e).addEventListener("textInput", XUe, !0);
  })(t), t._observer = new MutationObserver((e, n) => {
    KJ(t, e, n);
  });
}
function LM(t, e) {
  const n = t.__mode, r = t.__format, i = t.__style, o = e.__mode, a = e.__format, s = e.__style;
  return !(n !== null && n !== o || r !== null && r !== a || i !== null && i !== s);
}
function VM(t, e) {
  const n = t.mergeWithSibling(e), r = Jr()._normalizedNodes;
  return r.add(t.__key), r.add(e.__key), n;
}
function BM(t) {
  let e, n, r = t;
  if (r.__text !== "" || !r.isSimpleText() || r.isUnmergeable()) {
    for (; (e = r.getPreviousSibling()) !== null && pt(e) && e.isSimpleText() && !e.isUnmergeable(); ) {
      if (e.__text !== "") {
        if (LM(e, r)) {
          r = VM(e, r);
          break;
        }
        break;
      }
      e.remove();
    }
    for (; (n = r.getNextSibling()) !== null && pt(n) && n.isSimpleText() && !n.isUnmergeable(); ) {
      if (n.__text !== "") {
        if (LM(r, n)) {
          r = VM(r, n);
          break;
        }
        break;
      }
      n.remove();
    }
  } else
    r.remove();
}
function ZT(t) {
  return HM(t.anchor), HM(t.focus), t;
}
function HM(t) {
  for (; t.type === "element"; ) {
    const e = t.getNode(), n = t.offset;
    let r, i;
    if (n === e.getChildrenSize() ? (r = e.getChildAtIndex(n - 1), i = !0) : (r = e.getChildAtIndex(n), i = !1), pt(r)) {
      t.set(r.__key, i ? r.getTextContentSize() : 0, "text");
      break;
    }
    if (!We(r))
      break;
    t.set(r.__key, i ? r.getChildrenSize() : 0, "element");
  }
}
let JUe = 1;
const KUe = typeof queueMicrotask == "function" ? queueMicrotask : (t) => {
  Promise.resolve().then(t);
};
function JT(t) {
  const e = document.activeElement;
  if (e === null)
    return !1;
  const n = e.nodeName;
  return fr(hu(t)) && (n === "INPUT" || n === "TEXTAREA" || e.contentEditable === "true" && Cw(e) == null);
}
function mv(t, e, n) {
  const r = t.getRootElement();
  try {
    return r !== null && r.contains(e) && r.contains(n) && e !== null && !JT(e) && qT(e) === t;
  } catch {
    return !1;
  }
}
function KT(t) {
  return t instanceof Ow;
}
function qT(t) {
  let e = t;
  for (; e != null; ) {
    const n = Cw(e);
    if (KT(n))
      return n;
    e = Ew(e);
  }
  return null;
}
function Cw(t) {
  return t ? t.__lexicalEditor : null;
}
function yh(t) {
  return t.isToken() || t.isSegmented();
}
function qUe(t) {
  return t.nodeType === kc;
}
function i2(t) {
  let e = t;
  for (; e != null; ) {
    if (qUe(e))
      return e;
    e = e.firstChild;
  }
  return null;
}
function c4(t, e, n) {
  const r = Qu[e];
  if (n !== null && (t & r) == (n & r))
    return t;
  let i = t ^ r;
  return e === "subscript" ? i &= ~Qu.superscript : e === "superscript" && (i &= ~Qu.subscript), i;
}
function eK(t) {
  return pt(t) || lu(t) || fr(t);
}
function tK(t, e) {
  if (e != null)
    return void (t.__key = e);
  Ao(), NK();
  const n = Jr(), r = ml(), i = "" + JUe++;
  r._nodeMap.set(i, t), We(t) ? n._dirtyElements.set(i, !0) : n._dirtyLeaves.add(i), n._cloneNotNeeded.add(i), n._dirtyType = YJ, t.__key = i;
}
function Sd(t) {
  const e = t.getParent();
  if (e !== null) {
    const n = t.getWritable(), r = e.getWritable(), i = t.getPreviousSibling(), o = t.getNextSibling();
    if (i === null)
      if (o !== null) {
        const a = o.getWritable();
        r.__first = o.__key, a.__prev = null;
      } else
        r.__first = null;
    else {
      const a = i.getWritable();
      if (o !== null) {
        const s = o.getWritable();
        s.__prev = a.__key, a.__next = s.__key;
      } else
        a.__next = null;
      n.__prev = null;
    }
    if (o === null)
      if (i !== null) {
        const a = i.getWritable();
        r.__last = i.__key, a.__next = null;
      } else
        r.__last = null;
    else {
      const a = o.getWritable();
      if (i !== null) {
        const s = i.getWritable();
        s.__next = a.__key, a.__prev = s.__key;
      } else
        a.__prev = null;
      n.__next = null;
    }
    r.__size--, n.__parent = null;
  }
}
function o2(t) {
  NK();
  const e = t.getLatest(), n = e.__parent, r = ml(), i = Jr(), o = r._nodeMap, a = i._dirtyElements;
  n !== null && function(u, l, c) {
    let d = u;
    for (; d !== null; ) {
      if (c.has(d))
        return;
      const f = l.get(d);
      if (f === void 0)
        break;
      c.set(d, !1), d = f.__parent;
    }
  }(n, o, a);
  const s = e.__key;
  i._dirtyType = YJ, We(t) ? a.set(s, !0) : i._dirtyLeaves.add(s);
}
function Li(t) {
  Ao();
  const e = Jr(), n = e._compositionKey;
  if (t !== n) {
    if (e._compositionKey = t, n !== null) {
      const r = fi(n);
      r !== null && r.getWritable();
    }
    if (t !== null) {
      const r = fi(t);
      r !== null && r.getWritable();
    }
  }
}
function Jl() {
  return bv() ? null : Jr()._compositionKey;
}
function fi(t, e) {
  const n = (e || ml())._nodeMap.get(t);
  return n === void 0 ? null : n;
}
function nK(t, e) {
  const n = t[`__lexicalKey_${Jr()._key}`];
  return n !== void 0 ? fi(n, e) : null;
}
function hu(t, e) {
  let n = t;
  for (; n != null; ) {
    const r = nK(n, e);
    if (r !== null)
      return r;
    n = Ew(n);
  }
  return null;
}
function rK(t) {
  const e = t._decorators, n = Object.assign({}, e);
  return t._pendingDecorators = n, n;
}
function WM(t) {
  return t.read(() => hr().getTextContent());
}
function hr() {
  return iK(ml());
}
function iK(t) {
  return t._nodeMap.get("root");
}
function uo(t) {
  Ao();
  const e = ml();
  t !== null && (t.dirty = !0, t.setCachedNodes(null)), e._selection = t;
}
function Ph(t) {
  const e = Jr(), n = function(r, i) {
    let o = r;
    for (; o != null; ) {
      const a = o[`__lexicalKey_${i._key}`];
      if (a !== void 0)
        return a;
      o = Ew(o);
    }
    return null;
  }(t, e);
  return n === null ? t === e.getRootElement() ? fi("root") : null : fi(n);
}
function jM(t, e) {
  return e ? t.getTextContentSize() : 0;
}
function oK(t) {
  return /[\uD800-\uDBFF][\uDC00-\uDFFF]/g.test(t);
}
function QT(t) {
  const e = [];
  let n = t;
  for (; n !== null; )
    e.push(n), n = n._parentEditor;
  return e;
}
function aK() {
  return Math.random().toString(36).replace(/[^a-z]+/g, "").substr(0, 5);
}
function sK(t) {
  return t.nodeType === kc ? t.nodeValue : null;
}
function eO(t, e, n) {
  const r = pu(e._window);
  if (r === null)
    return;
  const i = r.anchorNode;
  let { anchorOffset: o, focusOffset: a } = r;
  if (i !== null) {
    let s = sK(i);
    const u = hu(i);
    if (s !== null && pt(u)) {
      if (s === xw && n) {
        const l = n.length;
        s = n, o = l, a = l;
      }
      s !== null && tO(u, s, o, a, t);
    }
  }
}
function tO(t, e, n, r, i) {
  let o = t;
  if (o.isAttached() && (i || !o.isDirty())) {
    const a = o.isComposing();
    let s = e;
    (a || i) && e[e.length - 1] === xw && (s = e.slice(0, -1));
    const u = o.getTextContent();
    if (i || s !== u) {
      if (s === "") {
        if (Li(null), VT || yw || BT)
          o.remove();
        else {
          const v = Jr();
          setTimeout(() => {
            v.update(() => {
              o.isAttached() && o.remove();
            });
          }, 20);
        }
        return;
      }
      const l = o.getParent(), c = Vp(), d = o.getTextContentSize(), f = Jl(), h = o.getKey();
      if (o.isToken() || f !== null && h === f && !a || rt(c) && (l !== null && !l.canInsertTextBefore() && c.anchor.offset === 0 || c.anchor.key === t.__key && c.anchor.offset === 0 && !o.canInsertTextBefore() && !a || c.focus.key === t.__key && c.focus.offset === d && !o.canInsertTextAfter() && !a))
        return void o.markDirty();
      const p = vt();
      if (!rt(p) || n === null || r === null)
        return void o.setTextContent(s);
      if (p.setTextNodeRange(o, n, o, r), o.isSegmented()) {
        const v = Xr(o.getTextContent());
        o.replace(v), o = v;
      }
      o.setTextContent(s);
    }
  }
}
function QUe(t, e) {
  if (e.isSegmented())
    return !0;
  if (!t.isCollapsed())
    return !1;
  const n = t.anchor.offset, r = e.getParentOrThrow(), i = e.isToken();
  return n === 0 ? !e.canInsertTextBefore() || !r.canInsertTextBefore() && !e.isComposing() || i || function(o) {
    const a = o.getPreviousSibling();
    return (pt(a) || We(a) && a.isInline()) && !a.canInsertTextAfter();
  }(e) : n === e.getTextContentSize() && (!e.canInsertTextAfter() || !r.canInsertTextAfter() && !e.isComposing() || i);
}
function zM(t) {
  return t === "ArrowLeft";
}
function GM(t) {
  return t === "ArrowRight";
}
function o0(t, e) {
  return ds ? t : e;
}
function UM(t) {
  return t === "Enter";
}
function Vg(t) {
  return t === "Backspace";
}
function Bg(t) {
  return t === "Delete";
}
function XM(t, e, n) {
  return t.toLowerCase() === "a" && o0(e, n);
}
function eXe() {
  const t = hr();
  uo(ZT(t.select(0, t.getChildrenSize())));
}
function I0(t, e) {
  t.__lexicalClassNameCache === void 0 && (t.__lexicalClassNameCache = {});
  const n = t.__lexicalClassNameCache, r = n[e];
  if (r !== void 0)
    return r;
  const i = t[e];
  if (typeof i == "string") {
    const o = r2(i);
    return n[e] = o, o;
  }
  return i;
}
function nO(t, e, n, r, i) {
  if (n.size === 0)
    return;
  const o = r.__type, a = r.__key, s = e.get(o);
  s === void 0 && St(33, o);
  const u = s.klass;
  let l = t.get(u);
  l === void 0 && (l = /* @__PURE__ */ new Map(), t.set(u, l));
  const c = l.get(a), d = c === "destroyed" && i === "created";
  (c === void 0 || d) && l.set(a, d ? "updated" : i);
}
function YM(t, e, n) {
  const r = t.getParent();
  let i = n, o = t;
  return r !== null && (e && n === 0 ? (i = o.getIndexWithinParent(), o = r) : e || n !== o.getChildrenSize() || (i = o.getIndexWithinParent() + 1, o = r)), o.getChildAtIndex(e ? i - 1 : i);
}
function dm(t, e) {
  const n = t.offset;
  if (t.type === "element")
    return YM(t.getNode(), e, n);
  {
    const r = t.getNode();
    if (e && n === 0 || !e && n === r.getTextContentSize()) {
      const i = e ? r.getPreviousSibling() : r.getNextSibling();
      return i === null ? YM(r.getParentOrThrow(), e, r.getIndexWithinParent() + (e ? 0 : 1)) : i;
    }
  }
  return null;
}
function uK(t) {
  const e = Sw(t).event, n = e && e.inputType;
  return n === "insertFromPaste" || n === "insertFromPasteAsQuotation";
}
function Ot(t, e, n) {
  return RK(t, e, n);
}
function ww(t) {
  return !Hi(t) && !t.isLastChild() && !t.isInline();
}
function a2(t, e) {
  const n = t._keyToDOMMap.get(e);
  return n === void 0 && St(75, e), n;
}
function Ew(t) {
  const e = t.assignedSlot || t.parentElement;
  return e !== null && e.nodeType === 11 ? e.host : e;
}
function d4(t, e) {
  let n = t.getParent();
  for (; n !== null; ) {
    if (n.is(e))
      return !0;
    n = n.getParent();
  }
  return !1;
}
function Sw(t) {
  const e = t._window;
  return e === null && St(78), e;
}
function tXe(t) {
  let e = t.getParentOrThrow();
  for (; e !== null; ) {
    if (Oi(e))
      return e;
    e = e.getParentOrThrow();
  }
  return e;
}
function Oi(t) {
  return Hi(t) || We(t) && t.isShadowRoot();
}
function nXe(t) {
  const e = t.constructor.clone(t);
  return tK(e, null), e;
}
function Qa(t) {
  const e = Jr(), n = t.constructor.getType(), r = e._nodes.get(n);
  r === void 0 && St(97);
  const i = r.replace;
  if (i !== null) {
    const o = i(t);
    return o instanceof t.constructor || St(98), o;
  }
  return t;
}
function K3(t, e) {
  !Hi(t.getParent()) || We(e) || fr(e) || St(99);
}
function q3(t) {
  return (fr(t) || We(t) && !t.canBeEmpty()) && !t.isInline();
}
function rO(t, e, n) {
  n.style.removeProperty("caret-color"), e._blockCursorElement = null;
  const r = t.parentElement;
  r !== null && r.removeChild(t);
}
function rXe(t, e, n) {
  let r = t._blockCursorElement;
  if (rt(n) && n.isCollapsed() && n.anchor.type === "element" && e.contains(document.activeElement)) {
    const i = n.anchor, o = i.getNode(), a = i.offset;
    let s = !1, u = null;
    if (a === o.getChildrenSize())
      q3(o.getChildAtIndex(a - 1)) && (s = !0);
    else {
      const l = o.getChildAtIndex(a);
      if (q3(l)) {
        const c = l.getPreviousSibling();
        (c === null || q3(c)) && (s = !0, u = t.getElementByKey(l.__key));
      }
    }
    if (s) {
      const l = t.getElementByKey(o.__key);
      return r === null && (t._blockCursorElement = r = function(c) {
        const d = c.theme, f = document.createElement("div");
        f.contentEditable = "false", f.setAttribute("data-lexical-cursor", "true");
        let h = d.blockCursor;
        if (h !== void 0) {
          if (typeof h == "string") {
            const p = r2(h);
            h = d.blockCursor = p;
          }
          h !== void 0 && f.classList.add(...h);
        }
        return f;
      }(t._config)), e.style.caretColor = "transparent", void (u === null ? l.appendChild(r) : l.insertBefore(r, u));
    }
  }
  r !== null && rO(r, t, e);
}
function pu(t) {
  return Ls ? (t || window).getSelection() : null;
}
function iXe(t, e) {
  let n = t.getChildAtIndex(e);
  n == null && (n = t), Oi(t) && St(102);
  const r = (a) => {
    const s = a.getParentOrThrow(), u = Oi(s), l = a !== n || u ? nXe(a) : a;
    if (u)
      return We(a) && We(l) || St(133), a.insertAfter(l), [a, l, l];
    {
      const [c, d, f] = r(s), h = a.getNextSiblings();
      return f.append(l, ...h), [c, d, l];
    }
  }, [i, o] = r(n);
  return [i, o];
}
function oXe(t) {
  return gu(t) && t.tagName === "A";
}
function gu(t) {
  return t.nodeType === 1;
}
function f4(t) {
  const e = new RegExp(/^(a|abbr|acronym|b|cite|code|del|em|i|ins|kbd|label|output|q|ruby|s|samp|span|strong|sub|sup|time|u|tt|var|#text)$/, "i");
  return t.nodeName.match(e) !== null;
}
function s2(t) {
  const e = new RegExp(/^(address|article|aside|blockquote|canvas|dd|div|dl|dt|fieldset|figcaption|figure|footer|form|h1|h2|h3|h4|h5|h6|header|hr|li|main|nav|noscript|ol|p|pre|section|table|td|tfoot|ul|video)$/, "i");
  return t.nodeName.match(e) !== null;
}
function xh(t) {
  if (Hi(t) || fr(t) && !t.isInline())
    return !0;
  if (!We(t) || Oi(t))
    return !1;
  const e = t.getFirstChild(), n = e === null || lu(e) || pt(e) || e.isInline();
  return !t.isInline() && t.canBeEmpty() !== !1 && n;
}
function Q3(t, e) {
  let n = t;
  for (; n !== null && n.getParent() !== null && !e(n); )
    n = n.getParentOrThrow();
  return e(n) ? n : null;
}
function aXe() {
  return Jr();
}
const ZM = /* @__PURE__ */ new WeakMap(), sXe = /* @__PURE__ */ new Map();
function uXe(t) {
  if (!t._readOnly && t.isEmpty())
    return sXe;
  t._readOnly || St(192);
  let e = ZM.get(t);
  if (!e) {
    e = /* @__PURE__ */ new Map(), ZM.set(t, e);
    for (const [n, r] of t._nodeMap) {
      const i = r.__type;
      let o = e.get(i);
      o || (o = /* @__PURE__ */ new Map(), e.set(i, o)), o.set(n, r);
    }
  }
  return e;
}
function iO(t) {
  const e = t.constructor.clone(t);
  return e.afterCloneFrom(t), e;
}
function lK(t, e, n, r, i, o) {
  let a = t.getFirstChild();
  for (; a !== null; ) {
    const s = a.__key;
    a.__parent === e && (We(a) && lK(a, s, n, r, i, o), n.has(s) || o.delete(s), i.push(s)), a = a.getNextSibling();
  }
}
let gc, ao, fm, Iw, h4, p4, Ld, Ns, g4, hm, xi = "", oo = "", Ys = null, ps = "", Gu = "", cK = !1, pm = !1, Cy = null;
function u2(t, e) {
  const n = Ld.get(t);
  if (e !== null) {
    const r = b4(t);
    r.parentNode === e && e.removeChild(r);
  }
  if (Ns.has(t) || ao._keyToDOMMap.delete(t), We(n)) {
    const r = c2(n, Ld);
    m4(r, 0, r.length - 1, null);
  }
  n !== void 0 && nO(hm, fm, Iw, n, "destroyed");
}
function m4(t, e, n, r) {
  let i = e;
  for (; i <= n; ++i) {
    const o = t[i];
    o !== void 0 && u2(o, r);
  }
}
function Kc(t, e) {
  t.setProperty("text-align", e);
}
const lXe = "40px";
function dK(t, e) {
  const n = gc.theme.indent;
  if (typeof n == "string") {
    const i = t.classList.contains(n);
    e > 0 && !i ? t.classList.add(n) : e < 1 && i && t.classList.remove(n);
  }
  const r = getComputedStyle(t).getPropertyValue("--lexical-indent-base-value") || lXe;
  t.style.setProperty("padding-inline-start", e === 0 ? "" : `calc(${e} * ${r})`);
}
function fK(t, e) {
  const n = t.style;
  e === 0 ? Kc(n, "") : e === WT ? Kc(n, "left") : e === jT ? Kc(n, "center") : e === zT ? Kc(n, "right") : e === GT ? Kc(n, "justify") : e === UT ? Kc(n, "start") : e === XT && Kc(n, "end");
}
function l2(t, e, n) {
  const r = Ns.get(t);
  r === void 0 && St(60);
  const i = r.createDOM(gc, ao);
  if (function(o, a, s) {
    const u = s._keyToDOMMap;
    a["__lexicalKey_" + s._key] = o, u.set(o, a);
  }(t, i, ao), pt(r) ? i.setAttribute("data-lexical-text", "true") : fr(r) && i.setAttribute("data-lexical-decorator", "true"), We(r)) {
    const o = r.__indent, a = r.__size;
    if (o !== 0 && dK(i, o), a !== 0) {
      const u = a - 1;
      (function(l, c, d, f) {
        const h = oo;
        oo = "", v4(l, d, 0, c, f, null), pK(d, f), oo = h;
      })(c2(r, Ns), u, r, i);
    }
    const s = r.__format;
    s !== 0 && fK(i, s), r.isInline() || hK(null, r, i), ww(r) && (xi += rl, Gu += rl);
  } else {
    const o = r.getTextContent();
    if (fr(r)) {
      const a = r.decorate(ao, gc);
      a !== null && gK(t, a), i.contentEditable = "false";
    } else
      pt(r) && (r.isDirectionless() || (oo += o));
    xi += o, Gu += o;
  }
  if (e !== null)
    if (n != null)
      e.insertBefore(i, n);
    else {
      const o = e.__lexicalLineBreak;
      o != null ? e.insertBefore(i, o) : e.appendChild(i);
    }
  return nO(hm, fm, Iw, r, "created"), i;
}
function v4(t, e, n, r, i, o) {
  const a = xi;
  xi = "";
  let s = n;
  for (; s <= r; ++s) {
    l2(t[s], i, o);
    const u = Ns.get(t[s]);
    u !== null && pt(u) && (Ys === null && (Ys = u.getFormat()), ps === "" && (ps = u.getStyle()));
  }
  ww(e) && (xi += rl), i.__lexicalTextContent = xi, xi = a + xi;
}
function JM(t, e) {
  const n = e.get(t);
  return lu(n) || fr(n) && n.isInline();
}
function hK(t, e, n) {
  const r = t !== null && (t.__size === 0 || JM(t.__last, Ld)), i = e.__size === 0 || JM(e.__last, Ns);
  if (r) {
    if (!i) {
      const o = n.__lexicalLineBreak;
      if (o != null)
        try {
          n.removeChild(o);
        } catch (a) {
          if (typeof a == "object" && a != null) {
            const s = `${a.toString()} Parent: ${n.tagName}, child: ${o.tagName}.`;
            throw new Error(s);
          }
          throw a;
        }
      n.__lexicalLineBreak = null;
    }
  } else if (i) {
    const o = document.createElement("br");
    n.__lexicalLineBreak = o, n.appendChild(o);
  }
}
function pK(t, e) {
  const n = e.__lexicalDirTextContent, r = e.__lexicalDir;
  if (n !== oo || r !== Cy) {
    const o = oo === "", a = o ? Cy : (i = oo, VUe.test(i) ? "rtl" : BUe.test(i) ? "ltr" : null);
    if (a !== r) {
      const s = e.classList, u = gc.theme;
      let l = r !== null ? u[r] : void 0, c = a !== null ? u[a] : void 0;
      if (l !== void 0) {
        if (typeof l == "string") {
          const d = r2(l);
          l = u[r] = d;
        }
        s.remove(...l);
      }
      if (a === null || o && a === "ltr")
        e.removeAttribute("dir");
      else {
        if (c !== void 0) {
          if (typeof c == "string") {
            const d = r2(c);
            c = u[a] = d;
          }
          c !== void 0 && s.add(...c);
        }
        e.dir = a;
      }
      pm || (t.getWritable().__dir = a);
    }
    Cy = a, e.__lexicalDirTextContent = oo, e.__lexicalDir = a;
  }
  var i;
}
function cXe(t, e, n) {
  const r = oo;
  var i;
  oo = "", Ys = null, ps = "", function(o, a, s) {
    const u = xi, l = o.__size, c = a.__size;
    if (xi = "", l === 1 && c === 1) {
      const d = o.__first, f = a.__first;
      if (d === f)
        a0(d, s);
      else {
        const p = b4(d), v = l2(f, null, null);
        try {
          s.replaceChild(v, p);
        } catch (m) {
          if (typeof m == "object" && m != null) {
            const b = `${m.toString()} Parent: ${s.tagName}, new child: {tag: ${v.tagName} key: ${f}}, old child: {tag: ${p.tagName}, key: ${d}}.`;
            throw new Error(b);
          }
          throw m;
        }
        u2(d, null);
      }
      const h = Ns.get(f);
      pt(h) && (Ys === null && (Ys = h.getFormat()), ps === "" && (ps = h.getStyle()));
    } else {
      const d = c2(o, Ld), f = c2(a, Ns);
      if (l === 0)
        c !== 0 && v4(f, a, 0, c - 1, s, null);
      else if (c === 0) {
        if (l !== 0) {
          const h = s.__lexicalLineBreak == null;
          m4(d, 0, l - 1, h ? null : s), h && (s.textContent = "");
        }
      } else
        (function(h, p, v, m, b, y) {
          const w = m - 1, S = b - 1;
          let E, I, _ = (N = y, N.firstChild), A = 0, P = 0;
          for (var N; A <= w && P <= S; ) {
            const R = p[A], V = v[P];
            if (R === V)
              _ = e5(a0(V, y)), A++, P++;
            else {
              E === void 0 && (E = new Set(p)), I === void 0 && (I = new Set(v));
              const F = I.has(R), M = E.has(V);
              if (F)
                if (M) {
                  const B = a2(ao, V);
                  B === _ ? _ = e5(a0(V, y)) : (_ != null ? y.insertBefore(B, _) : y.appendChild(B), a0(V, y)), A++, P++;
                } else
                  l2(V, y, _), P++;
              else
                _ = e5(b4(R)), u2(R, y), A++;
            }
            const $ = Ns.get(V);
            $ !== null && pt($) && (Ys === null && (Ys = $.getFormat()), ps === "" && (ps = $.getStyle()));
          }
          const k = A > w, D = P > S;
          if (k && !D) {
            const R = v[S + 1];
            v4(v, h, P, S, y, R === void 0 ? null : ao.getElementByKey(R));
          } else
            D && !k && m4(p, A, w, y);
        })(a, d, f, l, c, s);
    }
    ww(a) && (xi += rl), s.__lexicalTextContent = xi, xi = u + xi;
  }(t, e, n), pK(e, n), dp(i = e) && Ys != null && Ys !== i.__textFormat && !pm && (i.setTextFormat(Ys), i.setTextStyle(ps)), function(o) {
    dp(o) && ps !== "" && ps !== o.__textStyle && !pm && o.setTextStyle(ps);
  }(e), oo = r;
}
function c2(t, e) {
  const n = [];
  let r = t.__first;
  for (; r !== null; ) {
    const i = e.get(r);
    i === void 0 && St(101), n.push(r), r = i.__next;
  }
  return n;
}
function a0(t, e) {
  const n = Ld.get(t);
  let r = Ns.get(t);
  n !== void 0 && r !== void 0 || St(61);
  const i = cK || p4.has(t) || h4.has(t), o = a2(ao, t);
  if (n === r && !i) {
    if (We(n)) {
      const a = o.__lexicalTextContent;
      a !== void 0 && (xi += a, Gu += a);
      const s = o.__lexicalDirTextContent;
      s !== void 0 && (oo += s);
    } else {
      const a = n.getTextContent();
      pt(n) && !n.isDirectionless() && (oo += a), Gu += a, xi += a;
    }
    return o;
  }
  if (n !== r && i && nO(hm, fm, Iw, r, "updated"), r.updateDOM(n, o, gc)) {
    const a = l2(t, null, null);
    return e === null && St(62), e.replaceChild(a, o), u2(t, null), a;
  }
  if (We(n) && We(r)) {
    const a = r.__indent;
    a !== n.__indent && dK(o, a);
    const s = r.__format;
    s !== n.__format && fK(o, s), i && (cXe(n, r, o), Hi(r) || r.isInline() || hK(n, r, o)), ww(r) && (xi += rl, Gu += rl);
  } else {
    const a = r.getTextContent();
    if (fr(r)) {
      const s = r.decorate(ao, gc);
      s !== null && gK(t, s);
    } else
      pt(r) && !r.isDirectionless() && (oo += a);
    xi += a, Gu += a;
  }
  if (!pm && Hi(r) && r.__cachedText !== Gu) {
    const a = r.getWritable();
    a.__cachedText = Gu, r = a;
  }
  return o;
}
function gK(t, e) {
  let n = ao._pendingDecorators;
  const r = ao._decorators;
  if (n === null) {
    if (r[t] === e)
      return;
    n = rK(ao);
  }
  n[t] = e;
}
function e5(t) {
  let e = t.nextSibling;
  return e !== null && e === ao._blockCursorElement && (e = e.nextSibling), e;
}
function dXe(t, e, n, r, i, o) {
  xi = "", Gu = "", oo = "", cK = r === cp, Cy = null, ao = n, gc = n._config, fm = n._nodes, Iw = ao._listeners.mutation, h4 = i, p4 = o, Ld = t._nodeMap, Ns = e._nodeMap, pm = e._readOnly, g4 = new Map(n._keyToDOMMap);
  const a = /* @__PURE__ */ new Map();
  return hm = a, a0("root", null), ao = void 0, fm = void 0, h4 = void 0, p4 = void 0, Ld = void 0, Ns = void 0, gc = void 0, g4 = void 0, hm = void 0, a;
}
function b4(t) {
  const e = g4.get(t);
  return e === void 0 && St(75, t), e;
}
const Vu = Object.freeze({}), y4 = 30, x4 = [["keydown", function(t, e) {
  if (_0 = t.timeStamp, mK = t.key, e.isComposing())
    return;
  const { key: n, shiftKey: r, ctrlKey: i, metaKey: o, altKey: a } = t;
  Ot(e, WJ, t) || n != null && (function(s, u, l, c) {
    return GM(s) && !u && !c && !l;
  }(n, i, a, o) ? Ot(e, jJ, t) : function(s, u, l, c, d) {
    return GM(s) && !c && !l && (u || d);
  }(n, i, r, a, o) ? Ot(e, IUe, t) : function(s, u, l, c) {
    return zM(s) && !u && !c && !l;
  }(n, i, a, o) ? Ot(e, OT, t) : function(s, u, l, c, d) {
    return zM(s) && !c && !l && (u || d);
  }(n, i, r, a, o) ? Ot(e, _Ue, t) : /* @__PURE__ */ function(s, u, l) {
    return /* @__PURE__ */ function(c) {
      return c === "ArrowUp";
    }(s) && !u && !l;
  }(n, i, o) ? Ot(e, PT, t) : /* @__PURE__ */ function(s, u, l) {
    return /* @__PURE__ */ function(c) {
      return c === "ArrowDown";
    }(s) && !u && !l;
  }(n, i, o) ? Ot(e, NT, t) : function(s, u) {
    return UM(s) && u;
  }(n, r) ? (A0 = !0, Ot(e, lp, t)) : /* @__PURE__ */ function(s) {
    return s === " ";
  }(n) ? Ot(e, zJ, t) : function(s, u) {
    return ds && u && s.toLowerCase() === "o";
  }(n, i) ? (t.preventDefault(), A0 = !0, Ot(e, zh, !0)) : function(s, u) {
    return UM(s) && !u;
  }(n, r) ? (A0 = !1, Ot(e, lp, t)) : function(s, u, l, c) {
    return ds ? !u && !l && (Vg(s) || s.toLowerCase() === "h" && c) : !(c || u || l) && Vg(s);
  }(n, a, o, i) ? Vg(n) ? Ot(e, gw, t) : (t.preventDefault(), Ot(e, Ed, !0)) : /* @__PURE__ */ function(s) {
    return s === "Escape";
  }(n) ? Ot(e, pv, t) : function(s, u, l, c, d) {
    return ds ? !(l || c || d) && (Bg(s) || s.toLowerCase() === "d" && u) : !(u || c || d) && Bg(s);
  }(n, i, r, a, o) ? Bg(n) ? Ot(e, mw, t) : (t.preventDefault(), Ot(e, Ed, !1)) : function(s, u, l) {
    return Vg(s) && (ds ? u : l);
  }(n, a, i) ? (t.preventDefault(), Ot(e, lm, !0)) : function(s, u, l) {
    return Bg(s) && (ds ? u : l);
  }(n, a, i) ? (t.preventDefault(), Ot(e, lm, !1)) : function(s, u) {
    return ds && u && Vg(s);
  }(n, o) ? (t.preventDefault(), Ot(e, cm, !0)) : function(s, u) {
    return ds && u && Bg(s);
  }(n, o) ? (t.preventDefault(), Ot(e, cm, !1)) : function(s, u, l, c) {
    return s.toLowerCase() === "b" && !u && o0(l, c);
  }(n, a, o, i) ? (t.preventDefault(), Ot(e, Ku, "bold")) : function(s, u, l, c) {
    return s.toLowerCase() === "u" && !u && o0(l, c);
  }(n, a, o, i) ? (t.preventDefault(), Ot(e, Ku, "underline")) : function(s, u, l, c) {
    return s.toLowerCase() === "i" && !u && o0(l, c);
  }(n, a, o, i) ? (t.preventDefault(), Ot(e, Ku, "italic")) : /* @__PURE__ */ function(s, u, l, c) {
    return s === "Tab" && !u && !l && !c;
  }(n, a, i, o) ? Ot(e, kT, t) : function(s, u, l, c) {
    return s.toLowerCase() === "z" && !u && o0(l, c);
  }(n, r, o, i) ? (t.preventDefault(), Ot(e, AT, void 0)) : function(s, u, l, c) {
    return ds ? s.toLowerCase() === "z" && l && u : s.toLowerCase() === "y" && c || s.toLowerCase() === "z" && c && u;
  }(n, r, o, i) ? (t.preventDefault(), Ot(e, TT, void 0)) : li(e._editorState._selection) ? function(s, u, l, c) {
    return !u && s.toLowerCase() === "c" && (ds ? l : c);
  }(n, r, o, i) ? (t.preventDefault(), Ot(e, bw, t)) : function(s, u, l, c) {
    return !u && s.toLowerCase() === "x" && (ds ? l : c);
  }(n, r, o, i) ? (t.preventDefault(), Ot(e, MT, t)) : XM(n, o, i) && (t.preventDefault(), Ot(e, u4, t)) : !ic && XM(n, o, i) && (t.preventDefault(), Ot(e, u4, t)), /* @__PURE__ */ function(s, u, l, c) {
    return s || u || l || c;
  }(i, r, a, o) && Ot(e, UJ, t));
}], ["pointerdown", function(t, e) {
  const n = t.target, r = t.pointerType;
  n instanceof Node && r !== "touch" && ia(e, () => {
    fr(hu(n)) || (w4 = !0);
  });
}], ["compositionstart", function(t, e) {
  ia(e, () => {
    const n = vt();
    if (rt(n) && !e.isComposing()) {
      const r = n.anchor, i = n.anchor.getNode();
      Li(r.key), (t.timeStamp < _0 + y4 || r.type === "element" || !n.isCollapsed() || i.getFormat() !== n.format || pt(i) && i.getStyle() !== n.style) && Ot(e, Gh, LUe);
    }
  });
}], ["compositionend", function(t, e) {
  ic ? Hg = !0 : ia(e, () => {
    t5(e, t.data);
  });
}], ["input", function(t, e) {
  t.stopPropagation(), ia(e, () => {
    const n = vt(), r = t.data, i = xK(t);
    if (r != null && rt(n) && yK(n, i, r, t.timeStamp, !1)) {
      Hg && (t5(e, r), Hg = !1);
      const o = n.anchor.getNode(), a = pu(e._window);
      if (a === null)
        return;
      const s = n.isBackward(), u = s ? n.anchor.offset : n.focus.offset, l = s ? n.focus.offset : n.anchor.offset;
      e2 && !n.isCollapsed() && pt(o) && a.anchorNode !== null && o.getTextContent().slice(0, u) + r + o.getTextContent().slice(u + l) === sK(a.anchorNode) || Ot(e, Gh, r);
      const c = r.length;
      ic && c > 1 && t.inputType === "insertCompositionText" && !e.isComposing() && (n.anchor.offset -= c), VT || yw || BT || !e.isComposing() || (_0 = 0, Li(null));
    } else
      eO(!1, e, r !== null ? r : void 0), Hg && (t5(e, r || void 0), Hg = !1);
    Ao(), qJ(Jr());
  }), Ch = null;
}], ["click", function(t, e) {
  ia(e, () => {
    const n = vt(), r = pu(e._window), i = Vp();
    if (r) {
      if (rt(n)) {
        const o = n.anchor, a = o.getNode();
        o.type === "element" && o.offset === 0 && n.isCollapsed() && !Hi(a) && hr().getChildrenSize() === 1 && a.getTopLevelElementOrThrow().isEmpty() && i !== null && n.is(i) ? (r.removeAllRanges(), n.dirty = !0) : t.detail === 3 && !n.isCollapsed() && a !== n.focus.getNode() && (We(a) ? a.select(0) : a.getParentOrThrow().select(0));
      } else if (t.pointerType === "touch") {
        const o = r.anchorNode;
        if (o !== null) {
          const a = o.nodeType;
          (a === gv || a === kc) && uo(lO(i, r, e, t));
        }
      }
    }
    Ot(e, pw, t);
  });
}], ["cut", Vu], ["copy", Vu], ["dragstart", Vu], ["dragover", Vu], ["dragend", Vu], ["paste", Vu], ["focus", Vu], ["blur", Vu], ["drop", Vu]];
e2 && x4.push(["beforeinput", (t, e) => function(n, r) {
  const i = n.inputType, o = xK(n);
  i === "deleteCompositionText" || ic && uK(r) || i !== "insertCompositionText" && ia(r, () => {
    const a = vt();
    if (i === "deleteContentBackward") {
      if (a === null) {
        const h = Vp();
        if (!rt(h))
          return;
        uo(h.clone());
      }
      if (rt(a)) {
        const h = a.anchor.key === a.focus.key;
        if (s = n.timeStamp, mK === "MediaLast" && s < _0 + y4 && r.isComposing() && h) {
          if (Li(null), _0 = 0, setTimeout(() => {
            ia(r, () => {
              Li(null);
            });
          }, y4), rt(a)) {
            const p = a.anchor.getNode();
            p.markDirty(), a.format = p.getFormat(), pt(p) || St(142), a.style = p.getStyle();
          }
        } else {
          Li(null), n.preventDefault();
          const p = a.anchor.getNode().getTextContent(), v = a.anchor.offset === 0 && a.focus.offset === p.length;
          RUe && h && !v || Ot(r, Ed, !0);
        }
        return;
      }
    }
    var s;
    if (!rt(a))
      return;
    const u = n.data;
    Ch !== null && eO(!1, r, Ch), a.dirty && Ch === null || !a.isCollapsed() || Hi(a.anchor.getNode()) || o === null || a.applyDOMRange(o), Ch = null;
    const l = a.anchor, c = a.focus, d = l.getNode(), f = c.getNode();
    if (i !== "insertText" && i !== "insertTranspose")
      switch (n.preventDefault(), i) {
        case "insertFromYank":
        case "insertFromDrop":
        case "insertReplacementText":
          Ot(r, Gh, n);
          break;
        case "insertFromComposition":
          Li(null), Ot(r, Gh, n);
          break;
        case "insertLineBreak":
          Li(null), Ot(r, zh, !1);
          break;
        case "insertParagraph":
          Li(null), A0 && !yw ? (A0 = !1, Ot(r, zh, !1)) : Ot(r, um, void 0);
          break;
        case "insertFromPaste":
        case "insertFromPasteAsQuotation":
          Ot(r, hv, n);
          break;
        case "deleteByComposition":
          (function(h, p) {
            return h !== p || We(h) || We(p) || !h.isToken() || !p.isToken();
          })(d, f) && Ot(r, a4, n);
          break;
        case "deleteByDrag":
        case "deleteByCut":
          Ot(r, a4, n);
          break;
        case "deleteContent":
          Ot(r, Ed, !1);
          break;
        case "deleteWordBackward":
          Ot(r, lm, !0);
          break;
        case "deleteWordForward":
          Ot(r, lm, !1);
          break;
        case "deleteHardLineBackward":
        case "deleteSoftLineBackward":
          Ot(r, cm, !0);
          break;
        case "deleteContentForward":
        case "deleteHardLineForward":
        case "deleteSoftLineForward":
          Ot(r, cm, !1);
          break;
        case "formatStrikeThrough":
          Ot(r, Ku, "strikethrough");
          break;
        case "formatBold":
          Ot(r, Ku, "bold");
          break;
        case "formatItalic":
          Ot(r, Ku, "italic");
          break;
        case "formatUnderline":
          Ot(r, Ku, "underline");
          break;
        case "historyUndo":
          Ot(r, AT, void 0);
          break;
        case "historyRedo":
          Ot(r, TT, void 0);
      }
    else {
      if (u === `
`)
        n.preventDefault(), Ot(r, zh, !1);
      else if (u === rl)
        n.preventDefault(), Ot(r, um, void 0);
      else if (u == null && n.dataTransfer) {
        const h = n.dataTransfer.getData("text/plain");
        n.preventDefault(), a.insertRawText(h);
      } else
        u != null && yK(a, o, u, n.timeStamp, !0) ? (n.preventDefault(), Ot(r, Gh, u)) : Ch = u;
      vK = n.timeStamp;
    }
  });
}(t, e)]);
let _0 = 0, mK = null, vK = 0, Ch = null;
const d2 = /* @__PURE__ */ new WeakMap();
let C4 = !1, w4 = !1, A0 = !1, Hg = !1, bK = [0, "", 0, "root", 0];
function yK(t, e, n, r, i) {
  const o = t.anchor, a = t.focus, s = o.getNode(), u = Jr(), l = pu(u._window), c = l !== null ? l.anchorNode : null, d = o.key, f = u.getElementByKey(d), h = n.length;
  return d !== a.key || !pt(s) || (!i && (!e2 || vK < r + 50) || s.isDirty() && h < 2 || oK(n)) && o.offset !== a.offset && !s.isComposing() || yh(s) || s.isDirty() && h > 1 || (i || !e2) && f !== null && !s.isComposing() && c !== i2(f) || l !== null && e !== null && (!e.collapsed || e.startContainer !== l.anchorNode || e.startOffset !== l.anchorOffset) || s.getFormat() !== t.format || s.getStyle() !== t.style || QUe(t, s);
}
function KM(t, e) {
  return t !== null && t.nodeValue !== null && t.nodeType === kc && e !== 0 && e !== t.nodeValue.length;
}
function qM(t, e, n) {
  const { anchorNode: r, anchorOffset: i, focusNode: o, focusOffset: a } = t;
  C4 && (C4 = !1, KM(r, i) && KM(o, a)) || ia(e, () => {
    if (!n)
      return void uo(null);
    if (!mv(e, r, o))
      return;
    const s = vt();
    if (rt(s)) {
      const u = s.anchor, l = u.getNode();
      if (s.isCollapsed()) {
        t.type === "Range" && t.anchorNode === t.focusNode && (s.dirty = !0);
        const c = Sw(e).event, d = c ? c.timeStamp : performance.now(), [f, h, p, v, m] = bK, b = hr(), y = e.isComposing() === !1 && b.getTextContent() === "";
        if (d < m + 200 && u.offset === p && u.key === v)
          s.format = f, s.style = h;
        else if (u.type === "text")
          pt(l) || St(141), s.format = l.getFormat(), s.style = l.getStyle();
        else if (u.type === "element" && !y) {
          const w = u.getNode();
          s.style = "", w instanceof sf && w.getChildrenSize() === 0 ? (s.format = w.getTextFormat(), s.style = w.getTextStyle()) : s.format = 0;
        }
      } else {
        const c = u.key, d = s.focus.key, f = s.getNodes(), h = f.length, p = s.isBackward(), v = p ? a : i, m = p ? i : a, b = p ? d : c, y = p ? c : d;
        let w = FUe, S = !1;
        for (let E = 0; E < h; E++) {
          const I = f[E], _ = I.getTextContentSize();
          if (pt(I) && _ !== 0 && !(E === 0 && I.__key === b && v === _ || E === h - 1 && I.__key === y && m === 0) && (S = !0, w &= I.getFormat(), w === 0))
            break;
        }
        s.format = S ? w : 0;
      }
    }
    Ot(e, fv, void 0);
  });
}
function xK(t) {
  if (!t.getTargetRanges)
    return null;
  const e = t.getTargetRanges();
  return e.length === 0 ? null : e[0];
}
function t5(t, e) {
  const n = t._compositionKey;
  if (Li(null), n !== null && e != null) {
    if (e === "") {
      const r = fi(n), i = i2(t.getElementByKey(n));
      return void (i !== null && i.nodeValue !== null && pt(r) && tO(r, i.nodeValue, null, null, !0));
    }
    if (e[e.length - 1] === `
`) {
      const r = vt();
      if (rt(r)) {
        const i = r.focus;
        return r.anchor.set(i.key, i.offset, i.type), void Ot(t, lp, null);
      }
    }
  }
  eO(!0, t, e);
}
function CK(t) {
  let e = t.__lexicalEventHandles;
  return e === void 0 && (e = [], t.__lexicalEventHandles = e), e;
}
const Uh = /* @__PURE__ */ new Map();
function wK(t) {
  const e = t.target, n = pu(e == null ? null : e.nodeType === 9 ? e.defaultView : e.ownerDocument.defaultView);
  if (n === null)
    return;
  const r = qT(n.anchorNode);
  if (r === null)
    return;
  w4 && (w4 = !1, ia(r, () => {
    const l = Vp(), c = n.anchorNode;
    if (c === null)
      return;
    const d = c.nodeType;
    d !== gv && d !== kc || uo(lO(l, n, r, t));
  }));
  const i = QT(r), o = i[i.length - 1], a = o._key, s = Uh.get(a), u = s || o;
  u !== r && qM(n, u, !1), qM(n, r, !0), r !== o ? Uh.set(a, r) : s && Uh.delete(a);
}
function QM(t) {
  t._lexicalHandled = !0;
}
function eF(t) {
  return t._lexicalHandled === !0;
}
function fXe(t) {
  const e = t.ownerDocument, n = d2.get(e);
  n === void 0 && St(162);
  const r = n - 1;
  r >= 0 || St(164), d2.set(e, r), r === 0 && e.removeEventListener("selectionchange", wK);
  const i = Cw(t);
  KT(i) ? (function(a) {
    if (a._parentEditor !== null) {
      const s = QT(a), u = s[s.length - 1]._key;
      Uh.get(u) === a && Uh.delete(u);
    } else
      Uh.delete(a._key);
  }(i), t.__lexicalEditor = null) : i && St(198);
  const o = CK(t);
  for (let a = 0; a < o.length; a++)
    o[a]();
  t.__lexicalEventHandles = [];
}
function E4(t, e, n) {
  Ao();
  const r = t.__key, i = t.getParent();
  if (i === null)
    return;
  const o = function(s) {
    const u = vt();
    if (!rt(u) || !We(s))
      return u;
    const { anchor: l, focus: c } = u, d = l.getNode(), f = c.getNode();
    return d4(d, s) && l.set(s.__key, 0, "element"), d4(f, s) && c.set(s.__key, 0, "element"), u;
  }(t);
  let a = !1;
  if (rt(o) && e) {
    const s = o.anchor, u = o.focus;
    s.key === r && (p2(s, t, i, t.getPreviousSibling(), t.getNextSibling()), a = !0), u.key === r && (p2(u, t, i, t.getPreviousSibling(), t.getNextSibling()), a = !0);
  } else
    li(o) && e && t.isSelected() && t.selectPrevious();
  if (rt(o) && e && !a) {
    const s = t.getIndexWithinParent();
    Sd(t), h2(o, i, s, -1);
  } else
    Sd(t);
  n || Oi(i) || i.canBeEmpty() || !i.isEmpty() || E4(i, e), e && Hi(i) && i.isEmpty() && i.selectEnd();
}
let _w = class {
  static getType() {
    St(64, this.name);
  }
  static clone(e) {
    St(65, this.name);
  }
  afterCloneFrom(e) {
    this.__parent = e.__parent, this.__next = e.__next, this.__prev = e.__prev;
  }
  constructor(e) {
    this.__type = this.constructor.getType(), this.__parent = null, this.__prev = null, this.__next = null, tK(this, e);
  }
  getType() {
    return this.__type;
  }
  isInline() {
    St(137, this.constructor.name);
  }
  isAttached() {
    let e = this.__key;
    for (; e !== null; ) {
      if (e === "root")
        return !0;
      const n = fi(e);
      if (n === null)
        break;
      e = n.__parent;
    }
    return !1;
  }
  isSelected(e) {
    const n = e || vt();
    if (n == null)
      return !1;
    const r = n.getNodes().some((i) => i.__key === this.__key);
    if (pt(this))
      return r;
    if (rt(n) && n.anchor.type === "element" && n.focus.type === "element") {
      if (n.isCollapsed())
        return !1;
      const i = this.getParent();
      if (fr(this) && this.isInline() && i) {
        const o = n.isBackward() ? n.focus : n.anchor, a = o.getNode();
        if (o.offset === a.getChildrenSize() && a.is(i) && a.getLastChildOrThrow().is(this))
          return !1;
      }
    }
    return r;
  }
  getKey() {
    return this.__key;
  }
  getIndexWithinParent() {
    const e = this.getParent();
    if (e === null)
      return -1;
    let n = e.getFirstChild(), r = 0;
    for (; n !== null; ) {
      if (this.is(n))
        return r;
      r++, n = n.getNextSibling();
    }
    return -1;
  }
  getParent() {
    const e = this.getLatest().__parent;
    return e === null ? null : fi(e);
  }
  getParentOrThrow() {
    const e = this.getParent();
    return e === null && St(66, this.__key), e;
  }
  getTopLevelElement() {
    let e = this;
    for (; e !== null; ) {
      const n = e.getParent();
      if (Oi(n))
        return We(e) || e === this && fr(e) || St(194), e;
      e = n;
    }
    return null;
  }
  getTopLevelElementOrThrow() {
    const e = this.getTopLevelElement();
    return e === null && St(67, this.__key), e;
  }
  getParents() {
    const e = [];
    let n = this.getParent();
    for (; n !== null; )
      e.push(n), n = n.getParent();
    return e;
  }
  getParentKeys() {
    const e = [];
    let n = this.getParent();
    for (; n !== null; )
      e.push(n.__key), n = n.getParent();
    return e;
  }
  getPreviousSibling() {
    const e = this.getLatest().__prev;
    return e === null ? null : fi(e);
  }
  getPreviousSiblings() {
    const e = [], n = this.getParent();
    if (n === null)
      return e;
    let r = n.getFirstChild();
    for (; r !== null && !r.is(this); )
      e.push(r), r = r.getNextSibling();
    return e;
  }
  getNextSibling() {
    const e = this.getLatest().__next;
    return e === null ? null : fi(e);
  }
  getNextSiblings() {
    const e = [];
    let n = this.getNextSibling();
    for (; n !== null; )
      e.push(n), n = n.getNextSibling();
    return e;
  }
  getCommonAncestor(e) {
    const n = this.getParents(), r = e.getParents();
    We(this) && n.unshift(this), We(e) && r.unshift(e);
    const i = n.length, o = r.length;
    if (i === 0 || o === 0 || n[i - 1] !== r[o - 1])
      return null;
    const a = new Set(r);
    for (let s = 0; s < i; s++) {
      const u = n[s];
      if (a.has(u))
        return u;
    }
    return null;
  }
  is(e) {
    return e != null && this.__key === e.__key;
  }
  isBefore(e) {
    if (this === e)
      return !1;
    if (e.isParentOf(this))
      return !0;
    if (this.isParentOf(e))
      return !1;
    const n = this.getCommonAncestor(e);
    let r = 0, i = 0, o = this;
    for (; ; ) {
      const a = o.getParentOrThrow();
      if (a === n) {
        r = o.getIndexWithinParent();
        break;
      }
      o = a;
    }
    for (o = e; ; ) {
      const a = o.getParentOrThrow();
      if (a === n) {
        i = o.getIndexWithinParent();
        break;
      }
      o = a;
    }
    return r < i;
  }
  isParentOf(e) {
    const n = this.__key;
    if (n === e.__key)
      return !1;
    let r = e;
    for (; r !== null; ) {
      if (r.__key === n)
        return !0;
      r = r.getParent();
    }
    return !1;
  }
  getNodesBetween(e) {
    const n = this.isBefore(e), r = [], i = /* @__PURE__ */ new Set();
    let o = this;
    for (; o !== null; ) {
      const a = o.__key;
      if (i.has(a) || (i.add(a), r.push(o)), o === e)
        break;
      const s = We(o) ? n ? o.getFirstChild() : o.getLastChild() : null;
      if (s !== null) {
        o = s;
        continue;
      }
      const u = n ? o.getNextSibling() : o.getPreviousSibling();
      if (u !== null) {
        o = u;
        continue;
      }
      const l = o.getParentOrThrow();
      if (i.has(l.__key) || r.push(l), l === e)
        break;
      let c = null, d = l;
      do {
        if (d === null && St(68), c = n ? d.getNextSibling() : d.getPreviousSibling(), d = d.getParent(), d === null)
          break;
        c !== null || i.has(d.__key) || r.push(d);
      } while (c === null);
      o = c;
    }
    return n || r.reverse(), r;
  }
  isDirty() {
    const e = Jr()._dirtyLeaves;
    return e !== null && e.has(this.__key);
  }
  getLatest() {
    const e = fi(this.__key);
    return e === null && St(113), e;
  }
  getWritable() {
    Ao();
    const e = ml(), n = Jr(), r = e._nodeMap, i = this.__key, o = this.getLatest(), a = n._cloneNotNeeded, s = vt();
    if (s !== null && s.setCachedNodes(null), a.has(i))
      return o2(o), o;
    const u = iO(o);
    return a.add(i), o2(u), r.set(i, u), u;
  }
  getTextContent() {
    return "";
  }
  getTextContentSize() {
    return this.getTextContent().length;
  }
  createDOM(e, n) {
    St(70);
  }
  updateDOM(e, n, r) {
    St(71);
  }
  exportDOM(e) {
    return { element: this.createDOM(e._config, e) };
  }
  exportJSON() {
    St(72);
  }
  static importJSON(e) {
    St(18, this.name);
  }
  static transform() {
    return null;
  }
  remove(e) {
    E4(this, !0, e);
  }
  replace(e, n) {
    Ao();
    let r = vt();
    r !== null && (r = r.clone()), K3(this, e);
    const i = this.getLatest(), o = this.__key, a = e.__key, s = e.getWritable(), u = this.getParentOrThrow().getWritable(), l = u.__size;
    Sd(s);
    const c = i.getPreviousSibling(), d = i.getNextSibling(), f = i.__prev, h = i.__next, p = i.__parent;
    if (E4(i, !1, !0), c === null ? u.__first = a : c.getWritable().__next = a, s.__prev = f, d === null ? u.__last = a : d.getWritable().__prev = a, s.__next = h, s.__parent = p, u.__size = l, n && (We(this) && We(s) || St(139), this.getChildren().forEach((v) => {
      s.append(v);
    })), rt(r)) {
      uo(r);
      const v = r.anchor, m = r.focus;
      v.key === o && iF(v, s), m.key === o && iF(m, s);
    }
    return Jl() === o && Li(a), s;
  }
  insertAfter(e, n = !0) {
    Ao(), K3(this, e);
    const r = this.getWritable(), i = e.getWritable(), o = i.getParent(), a = vt();
    let s = !1, u = !1;
    if (o !== null) {
      const h = e.getIndexWithinParent();
      if (Sd(i), rt(a)) {
        const p = o.__key, v = a.anchor, m = a.focus;
        s = v.type === "element" && v.key === p && v.offset === h + 1, u = m.type === "element" && m.key === p && m.offset === h + 1;
      }
    }
    const l = this.getNextSibling(), c = this.getParentOrThrow().getWritable(), d = i.__key, f = r.__next;
    if (l === null ? c.__last = d : l.getWritable().__prev = d, c.__size++, r.__next = d, i.__next = f, i.__prev = r.__key, i.__parent = r.__parent, n && rt(a)) {
      const h = this.getIndexWithinParent();
      h2(a, c, h + 1);
      const p = c.__key;
      s && a.anchor.set(p, h + 2, "element"), u && a.focus.set(p, h + 2, "element");
    }
    return e;
  }
  insertBefore(e, n = !0) {
    Ao(), K3(this, e);
    const r = this.getWritable(), i = e.getWritable(), o = i.__key;
    Sd(i);
    const a = this.getPreviousSibling(), s = this.getParentOrThrow().getWritable(), u = r.__prev, l = this.getIndexWithinParent();
    a === null ? s.__first = o : a.getWritable().__next = o, s.__size++, r.__prev = o, i.__prev = u, i.__next = r.__key, i.__parent = r.__parent;
    const c = vt();
    return n && rt(c) && h2(c, this.getParentOrThrow(), l), e;
  }
  isParentRequired() {
    return !1;
  }
  createParentElementNode() {
    return Sr();
  }
  selectStart() {
    return this.selectPrevious();
  }
  selectEnd() {
    return this.selectNext(0, 0);
  }
  selectPrevious(e, n) {
    Ao();
    const r = this.getPreviousSibling(), i = this.getParentOrThrow();
    if (r === null)
      return i.select(0, 0);
    if (We(r))
      return r.select();
    if (!pt(r)) {
      const o = r.getIndexWithinParent() + 1;
      return i.select(o, o);
    }
    return r.select(e, n);
  }
  selectNext(e, n) {
    Ao();
    const r = this.getNextSibling(), i = this.getParentOrThrow();
    if (r === null)
      return i.select();
    if (We(r))
      return r.select(0, 0);
    if (!pt(r)) {
      const o = r.getIndexWithinParent();
      return i.select(o, o);
    }
    return r.select(e, n);
  }
  markDirty() {
    this.getWritable();
  }
}, oO = class EK extends _w {
  static getType() {
    return "linebreak";
  }
  static clone(e) {
    return new EK(e.__key);
  }
  constructor(e) {
    super(e);
  }
  getTextContent() {
    return `
`;
  }
  createDOM() {
    return document.createElement("br");
  }
  updateDOM() {
    return !1;
  }
  static importDOM() {
    return { br: (e) => function(n) {
      const r = n.parentElement;
      if (r !== null && s2(r)) {
        const i = r.firstChild;
        if (i === n || i.nextSibling === n && Ob(i)) {
          const o = r.lastChild;
          if (o === n || o.previousSibling === n && Ob(o))
            return !0;
        }
      }
      return !1;
    }(e) || function(n) {
      const r = n.parentElement;
      if (r !== null && s2(r)) {
        const i = r.firstChild;
        if (i === n || i.nextSibling === n && Ob(i))
          return !1;
        const o = r.lastChild;
        if (o === n || o.previousSibling === n && Ob(o))
          return !0;
      }
      return !1;
    }(e) ? null : { conversion: hXe, priority: 0 } };
  }
  static importJSON(e) {
    return mc();
  }
  exportJSON() {
    return { type: "linebreak", version: 1 };
  }
};
function hXe(t) {
  return { node: mc() };
}
function mc() {
  return Qa(new oO());
}
function lu(t) {
  return t instanceof oO;
}
function Ob(t) {
  return t.nodeType === kc && /^( |\t|\r?\n)+$/.test(t.textContent || "");
}
function n5(t, e) {
  return 16 & e ? "code" : e & HT ? "mark" : 32 & e ? "sub" : 64 & e ? "sup" : null;
}
function r5(t, e) {
  return 1 & e ? "strong" : 2 & e ? "em" : "span";
}
function SK(t, e, n, r, i) {
  const o = r.classList;
  let a = I0(i, "base");
  a !== void 0 && o.add(...a), a = I0(i, "underlineStrikethrough");
  let s = !1;
  const u = e & n2 && e & t2;
  a !== void 0 && (n & n2 && n & t2 ? (s = !0, u || o.add(...a)) : u && o.remove(...a));
  for (const l in Qu) {
    const c = Qu[l];
    if (a = I0(i, l), a !== void 0)
      if (n & c) {
        if (s && (l === "underline" || l === "strikethrough")) {
          e & c && o.remove(...a);
          continue;
        }
        e & c && (!u || l !== "underline") && l !== "strikethrough" || o.add(...a);
      } else
        e & c && o.remove(...a);
  }
}
function IK(t, e, n) {
  const r = e.firstChild, i = n.isComposing(), o = t + (i ? xw : "");
  if (r == null)
    e.textContent = o;
  else {
    const a = r.nodeValue;
    if (a !== o)
      if (i || ic) {
        const [s, u, l] = function(c, d) {
          const f = c.length, h = d.length;
          let p = 0, v = 0;
          for (; p < f && p < h && c[p] === d[p]; )
            p++;
          for (; v + p < f && v + p < h && c[f - v - 1] === d[h - v - 1]; )
            v++;
          return [p, f - p - v, d.slice(p, h - v)];
        }(a, o);
        u !== 0 && r.deleteData(s, u), r.insertData(s, l);
      } else
        r.nodeValue = o;
  }
}
function tF(t, e, n, r, i, o) {
  IK(i, t, e);
  const a = o.theme.text;
  a !== void 0 && SK(0, 0, r, t, a);
}
function Pb(t, e) {
  const n = document.createElement(e);
  return n.appendChild(t), n;
}
let Lp = class _K extends _w {
  static getType() {
    return "text";
  }
  static clone(e) {
    return new _K(e.__text, e.__key);
  }
  afterCloneFrom(e) {
    super.afterCloneFrom(e), this.__format = e.__format, this.__style = e.__style, this.__mode = e.__mode, this.__detail = e.__detail;
  }
  constructor(e, n) {
    super(n), this.__text = e, this.__format = 0, this.__style = "", this.__mode = 0, this.__detail = 0;
  }
  getFormat() {
    return this.getLatest().__format;
  }
  getDetail() {
    return this.getLatest().__detail;
  }
  getMode() {
    const e = this.getLatest();
    return zUe[e.__mode];
  }
  getStyle() {
    return this.getLatest().__style;
  }
  isToken() {
    return this.getLatest().__mode === 1;
  }
  isComposing() {
    return this.__key === Jl();
  }
  isSegmented() {
    return this.getLatest().__mode === 2;
  }
  isDirectionless() {
    return !!(1 & this.getLatest().__detail);
  }
  isUnmergeable() {
    return !!(2 & this.getLatest().__detail);
  }
  hasFormat(e) {
    const n = Qu[e];
    return !!(this.getFormat() & n);
  }
  isSimpleText() {
    return this.__type === "text" && this.__mode === 0;
  }
  getTextContent() {
    return this.getLatest().__text;
  }
  getFormatFlags(e, n) {
    return c4(this.getLatest().__format, e, n);
  }
  canHaveFormat() {
    return !0;
  }
  createDOM(e, n) {
    const r = this.__format, i = n5(0, r), o = r5(0, r), a = i === null ? o : i, s = document.createElement(a);
    let u = s;
    this.hasFormat("code") && s.setAttribute("spellcheck", "false"), i !== null && (u = document.createElement(o), s.appendChild(u)), tF(u, this, 0, r, this.__text, e);
    const l = this.__style;
    return l !== "" && (s.style.cssText = l), s;
  }
  updateDOM(e, n, r) {
    const i = this.__text, o = e.__format, a = this.__format, s = n5(0, o), u = n5(0, a), l = r5(0, o), c = r5(0, a);
    if ((s === null ? l : s) !== (u === null ? c : u))
      return !0;
    if (s === u && l !== c) {
      const v = n.firstChild;
      v == null && St(48);
      const m = document.createElement(c);
      return tF(m, this, 0, a, i, r), n.replaceChild(m, v), !1;
    }
    let d = n;
    u !== null && s !== null && (d = n.firstChild, d == null && St(49)), IK(i, d, this);
    const f = r.theme.text;
    f !== void 0 && o !== a && SK(0, o, a, d, f);
    const h = e.__style, p = this.__style;
    return h !== p && (n.style.cssText = p), !1;
  }
  static importDOM() {
    return { "#text": () => ({ conversion: vXe, priority: 0 }), b: () => ({ conversion: gXe, priority: 0 }), code: () => ({ conversion: Dl, priority: 0 }), em: () => ({ conversion: Dl, priority: 0 }), i: () => ({ conversion: Dl, priority: 0 }), s: () => ({ conversion: Dl, priority: 0 }), span: () => ({ conversion: pXe, priority: 0 }), strong: () => ({ conversion: Dl, priority: 0 }), sub: () => ({ conversion: Dl, priority: 0 }), sup: () => ({ conversion: Dl, priority: 0 }), u: () => ({ conversion: Dl, priority: 0 }) };
  }
  static importJSON(e) {
    const n = Xr(e.text);
    return n.setFormat(e.format), n.setDetail(e.detail), n.setMode(e.mode), n.setStyle(e.style), n;
  }
  exportDOM(e) {
    let { element: n } = super.exportDOM(e);
    return n !== null && gu(n) || St(132), n.style.whiteSpace = "pre-wrap", this.hasFormat("bold") && (n = Pb(n, "b")), this.hasFormat("italic") && (n = Pb(n, "i")), this.hasFormat("strikethrough") && (n = Pb(n, "s")), this.hasFormat("underline") && (n = Pb(n, "u")), { element: n };
  }
  exportJSON() {
    return { detail: this.getDetail(), format: this.getFormat(), mode: this.getMode(), style: this.getStyle(), text: this.getTextContent(), type: "text", version: 1 };
  }
  selectionTransform(e, n) {
  }
  setFormat(e) {
    const n = this.getWritable();
    return n.__format = typeof e == "string" ? Qu[e] : e, n;
  }
  setDetail(e) {
    const n = this.getWritable();
    return n.__detail = typeof e == "string" ? HUe[e] : e, n;
  }
  setStyle(e) {
    const n = this.getWritable();
    return n.__style = e, n;
  }
  toggleFormat(e) {
    const n = c4(this.getFormat(), e, null);
    return this.setFormat(n);
  }
  toggleDirectionless() {
    const e = this.getWritable();
    return e.__detail ^= 1, e;
  }
  toggleUnmergeable() {
    const e = this.getWritable();
    return e.__detail ^= 2, e;
  }
  setMode(e) {
    const n = jUe[e];
    if (this.__mode === n)
      return this;
    const r = this.getWritable();
    return r.__mode = n, r;
  }
  setTextContent(e) {
    if (this.__text === e)
      return this;
    const n = this.getWritable();
    return n.__text = e, n;
  }
  select(e, n) {
    Ao();
    let r = e, i = n;
    const o = vt(), a = this.getTextContent(), s = this.__key;
    if (typeof a == "string") {
      const u = a.length;
      r === void 0 && (r = u), i === void 0 && (i = u);
    } else
      r = 0, i = 0;
    if (!rt(o))
      return PK(s, r, s, i, "text", "text");
    {
      const u = Jl();
      u !== o.anchor.key && u !== o.focus.key || Li(s), o.setTextNodeRange(this, r, this, i);
    }
    return o;
  }
  selectStart() {
    return this.select(0, 0);
  }
  selectEnd() {
    const e = this.getTextContentSize();
    return this.select(e, e);
  }
  spliceText(e, n, r, i) {
    const o = this.getWritable(), a = o.__text, s = r.length;
    let u = e;
    u < 0 && (u = s + u, u < 0 && (u = 0));
    const l = vt();
    if (i && rt(l)) {
      const d = e + s;
      l.setTextNodeRange(o, d, o, d);
    }
    const c = a.slice(0, u) + r + a.slice(u + n);
    return o.__text = c, o;
  }
  canInsertTextBefore() {
    return !0;
  }
  canInsertTextAfter() {
    return !0;
  }
  splitText(...e) {
    Ao();
    const n = this.getLatest(), r = n.getTextContent(), i = n.__key, o = Jl(), a = new Set(e), s = [], u = r.length;
    let l = "";
    for (let E = 0; E < u; E++)
      l !== "" && a.has(E) && (s.push(l), l = ""), l += r[E];
    l !== "" && s.push(l);
    const c = s.length;
    if (c === 0)
      return [];
    if (s[0] === r)
      return [n];
    const d = s[0], f = n.getParent();
    let h;
    const p = n.getFormat(), v = n.getStyle(), m = n.__detail;
    let b = !1;
    n.isSegmented() ? (h = Xr(d), h.__format = p, h.__style = v, h.__detail = m, b = !0) : (h = n.getWritable(), h.__text = d);
    const y = vt(), w = [h];
    let S = d.length;
    for (let E = 1; E < c; E++) {
      const I = s[E], _ = I.length, A = Xr(I).getWritable();
      A.__format = p, A.__style = v, A.__detail = m;
      const P = A.__key, N = S + _;
      if (rt(y)) {
        const k = y.anchor, D = y.focus;
        k.key === i && k.type === "text" && k.offset > S && k.offset <= N && (k.key = P, k.offset -= S, y.dirty = !0), D.key === i && D.type === "text" && D.offset > S && D.offset <= N && (D.key = P, D.offset -= S, y.dirty = !0);
      }
      o === i && Li(P), S = N, w.push(A);
    }
    if (f !== null) {
      (function(_) {
        const A = _.getPreviousSibling(), P = _.getNextSibling();
        A !== null && o2(A), P !== null && o2(P);
      })(this);
      const E = f.getWritable(), I = this.getIndexWithinParent();
      b ? (E.splice(I, 0, w), this.remove()) : E.splice(I, 1, w), rt(y) && h2(y, f, I, c - 1);
    }
    return w;
  }
  mergeWithSibling(e) {
    const n = e === this.getPreviousSibling();
    n || e === this.getNextSibling() || St(50);
    const r = this.__key, i = e.__key, o = this.__text, a = o.length;
    Jl() === i && Li(r);
    const s = vt();
    if (rt(s)) {
      const d = s.anchor, f = s.focus;
      d !== null && d.key === i && (cF(d, n, r, e, a), s.dirty = !0), f !== null && f.key === i && (cF(f, n, r, e, a), s.dirty = !0);
    }
    const u = e.__text, l = n ? u + o : o + u;
    this.setTextContent(l);
    const c = this.getWritable();
    return e.remove(), c;
  }
  isTextEntity() {
    return !1;
  }
};
function pXe(t) {
  return { forChild: aO(t.style), node: null };
}
function gXe(t) {
  const e = t, n = e.style.fontWeight === "normal";
  return { forChild: aO(e.style, n ? void 0 : "bold"), node: null };
}
const nF = /* @__PURE__ */ new WeakMap();
function mXe(t) {
  return t.nodeName === "PRE" || t.nodeType === gv && t.style !== void 0 && t.style.whiteSpace !== void 0 && t.style.whiteSpace.startsWith("pre");
}
function vXe(t) {
  const e = t;
  t.parentElement === null && St(129);
  let n = e.textContent || "";
  if (function(r) {
    let i, o = r.parentNode;
    const a = [r];
    for (; o !== null && (i = nF.get(o)) === void 0 && !mXe(o); )
      a.push(o), o = o.parentNode;
    const s = i === void 0 ? o : i;
    for (let u = 0; u < a.length; u++)
      nF.set(a[u], s);
    return s;
  }(e) !== null) {
    const r = n.split(/(\r?\n|\t)/), i = [], o = r.length;
    for (let a = 0; a < o; a++) {
      const s = r[a];
      s === `
` || s === `\r
` ? i.push(mc()) : s === "	" ? i.push(vv()) : s !== "" && i.push(Xr(s));
    }
    return { node: i };
  }
  if (n = n.replace(/\r/g, "").replace(/[ \t\n]+/g, " "), n === "")
    return { node: null };
  if (n[0] === " ") {
    let r = e, i = !0;
    for (; r !== null && (r = rF(r, !1)) !== null; ) {
      const o = r.textContent || "";
      if (o.length > 0) {
        /[ \t\n]$/.test(o) && (n = n.slice(1)), i = !1;
        break;
      }
    }
    i && (n = n.slice(1));
  }
  if (n[n.length - 1] === " ") {
    let r = e, i = !0;
    for (; r !== null && (r = rF(r, !0)) !== null; )
      if ((r.textContent || "").replace(/^( |\t|\r?\n)+/, "").length > 0) {
        i = !1;
        break;
      }
    i && (n = n.slice(0, n.length - 1));
  }
  return n === "" ? { node: null } : { node: Xr(n) };
}
function rF(t, e) {
  let n = t;
  for (; ; ) {
    let r;
    for (; (r = e ? n.nextSibling : n.previousSibling) === null; ) {
      const o = n.parentElement;
      if (o === null)
        return null;
      n = o;
    }
    if (n = r, n.nodeType === gv) {
      const o = n.style.display;
      if (o === "" && !f4(n) || o !== "" && !o.startsWith("inline"))
        return null;
    }
    let i = n;
    for (; (i = e ? n.firstChild : n.lastChild) !== null; )
      n = i;
    if (n.nodeType === kc)
      return n;
    if (n.nodeName === "BR")
      return null;
  }
}
const bXe = { code: "code", em: "italic", i: "italic", s: "strikethrough", strong: "bold", sub: "subscript", sup: "superscript", u: "underline" };
function Dl(t) {
  const e = bXe[t.nodeName.toLowerCase()];
  return e === void 0 ? { node: null } : { forChild: aO(t.style, e), node: null };
}
function Xr(t = "") {
  return Qa(new Lp(t));
}
function pt(t) {
  return t instanceof Lp;
}
function aO(t, e) {
  const n = t.fontWeight, r = t.textDecoration.split(" "), i = n === "700" || n === "bold", o = r.includes("line-through"), a = t.fontStyle === "italic", s = r.includes("underline"), u = t.verticalAlign;
  return (l) => (pt(l) && (i && !l.hasFormat("bold") && l.toggleFormat("bold"), o && !l.hasFormat("strikethrough") && l.toggleFormat("strikethrough"), a && !l.hasFormat("italic") && l.toggleFormat("italic"), s && !l.hasFormat("underline") && l.toggleFormat("underline"), u !== "sub" || l.hasFormat("subscript") || l.toggleFormat("subscript"), u !== "super" || l.hasFormat("superscript") || l.toggleFormat("superscript"), e && !l.hasFormat(e) && l.toggleFormat(e)), l);
}
let sO = class AK extends Lp {
  static getType() {
    return "tab";
  }
  static clone(e) {
    return new AK(e.__key);
  }
  afterCloneFrom(e) {
    super.afterCloneFrom(e), this.__text = e.__text;
  }
  constructor(e) {
    super("	", e), this.__detail = 2;
  }
  static importDOM() {
    return null;
  }
  static importJSON(e) {
    const n = vv();
    return n.setFormat(e.format), n.setStyle(e.style), n;
  }
  exportJSON() {
    return { ...super.exportJSON(), type: "tab", version: 1 };
  }
  setTextContent(e) {
    St(126);
  }
  setDetail(e) {
    St(127);
  }
  setMode(e) {
    St(128);
  }
  canInsertTextBefore() {
    return !1;
  }
  canInsertTextAfter() {
    return !1;
  }
};
function vv() {
  return Qa(new sO());
}
function yXe(t) {
  return t instanceof sO;
}
class xXe {
  constructor(e, n, r) {
    this._selection = null, this.key = e, this.offset = n, this.type = r;
  }
  is(e) {
    return this.key === e.key && this.offset === e.offset && this.type === e.type;
  }
  isBefore(e) {
    let n = this.getNode(), r = e.getNode();
    const i = this.offset, o = e.offset;
    if (We(n)) {
      const a = n.getDescendantByIndex(i);
      n = a ?? n;
    }
    if (We(r)) {
      const a = r.getDescendantByIndex(o);
      r = a ?? r;
    }
    return n === r ? i < o : n.isBefore(r);
  }
  getNode() {
    const e = fi(this.key);
    return e === null && St(20), e;
  }
  set(e, n, r) {
    const i = this._selection, o = this.key;
    this.key = e, this.offset = n, this.type = r, bv() || (Jl() === o && Li(e), i !== null && (i.setCachedNodes(null), i.dirty = !0));
  }
}
function mu(t, e, n) {
  return new xXe(t, e, n);
}
function i5(t, e) {
  let n = e.__key, r = t.offset, i = "element";
  if (pt(e)) {
    i = "text";
    const o = e.getTextContentSize();
    r > o && (r = o);
  } else if (!We(e)) {
    const o = e.getNextSibling();
    if (pt(o))
      n = o.__key, r = 0, i = "text";
    else {
      const a = e.getParent();
      a && (n = a.__key, r = e.getIndexWithinParent() + 1);
    }
  }
  t.set(n, r, i);
}
function iF(t, e) {
  if (We(e)) {
    const n = e.getLastDescendant();
    We(n) || pt(n) ? i5(t, n) : i5(t, e);
  } else
    i5(t, e);
}
function zl(t, e, n, r) {
  t.key = e, t.offset = n, t.type = r;
}
class Aw {
  constructor(e) {
    this._cachedNodes = null, this._nodes = e, this.dirty = !1;
  }
  getCachedNodes() {
    return this._cachedNodes;
  }
  setCachedNodes(e) {
    this._cachedNodes = e;
  }
  is(e) {
    if (!li(e))
      return !1;
    const n = this._nodes, r = e._nodes;
    return n.size === r.size && Array.from(n).every((i) => r.has(i));
  }
  isCollapsed() {
    return !1;
  }
  isBackward() {
    return !1;
  }
  getStartEndPoints() {
    return null;
  }
  add(e) {
    this.dirty = !0, this._nodes.add(e), this._cachedNodes = null;
  }
  delete(e) {
    this.dirty = !0, this._nodes.delete(e), this._cachedNodes = null;
  }
  clear() {
    this.dirty = !0, this._nodes.clear(), this._cachedNodes = null;
  }
  has(e) {
    return this._nodes.has(e);
  }
  clone() {
    return new Aw(new Set(this._nodes));
  }
  extract() {
    return this.getNodes();
  }
  insertRawText(e) {
  }
  insertText() {
  }
  insertNodes(e) {
    const n = this.getNodes(), r = n.length, i = n[r - 1];
    let o;
    if (pt(i))
      o = i.select();
    else {
      const a = i.getIndexWithinParent() + 1;
      o = i.getParentOrThrow().select(a, a);
    }
    o.insertNodes(e);
    for (let a = 0; a < r; a++)
      n[a].remove();
  }
  getNodes() {
    const e = this._cachedNodes;
    if (e !== null)
      return e;
    const n = this._nodes, r = [];
    for (const i of n) {
      const o = fi(i);
      o !== null && r.push(o);
    }
    return bv() || (this._cachedNodes = r), r;
  }
  getTextContent() {
    const e = this.getNodes();
    let n = "";
    for (let r = 0; r < e.length; r++)
      n += e[r].getTextContent();
    return n;
  }
}
function rt(t) {
  return t instanceof Rc;
}
class Rc {
  constructor(e, n, r, i) {
    this.anchor = e, this.focus = n, e._selection = this, n._selection = this, this._cachedNodes = null, this.format = r, this.style = i, this.dirty = !1;
  }
  getCachedNodes() {
    return this._cachedNodes;
  }
  setCachedNodes(e) {
    this._cachedNodes = e;
  }
  is(e) {
    return !!rt(e) && this.anchor.is(e.anchor) && this.focus.is(e.focus) && this.format === e.format && this.style === e.style;
  }
  isCollapsed() {
    return this.anchor.is(this.focus);
  }
  getNodes() {
    const e = this._cachedNodes;
    if (e !== null)
      return e;
    const n = this.anchor, r = this.focus, i = n.isBefore(r), o = i ? n : r, a = i ? r : n;
    let s = o.getNode(), u = a.getNode();
    const l = o.offset, c = a.offset;
    if (We(s)) {
      const f = s.getDescendantByIndex(l);
      s = f ?? s;
    }
    if (We(u)) {
      let f = u.getDescendantByIndex(c);
      f !== null && f !== s && u.getChildAtIndex(c) === f && (f = f.getPreviousSibling()), u = f ?? u;
    }
    let d;
    return d = s.is(u) ? We(s) && s.getChildrenSize() > 0 ? [] : [s] : s.getNodesBetween(u), bv() || (this._cachedNodes = d), d;
  }
  setTextNodeRange(e, n, r, i) {
    zl(this.anchor, e.__key, n, "text"), zl(this.focus, r.__key, i, "text"), this._cachedNodes = null, this.dirty = !0;
  }
  getTextContent() {
    const e = this.getNodes();
    if (e.length === 0)
      return "";
    const n = e[0], r = e[e.length - 1], i = this.anchor, o = this.focus, a = i.isBefore(o), [s, u] = S4(this);
    let l = "", c = !0;
    for (let d = 0; d < e.length; d++) {
      const f = e[d];
      if (We(f) && !f.isInline())
        c || (l += `
`), c = !f.isEmpty();
      else if (c = !1, pt(f)) {
        let h = f.getTextContent();
        f === n ? f === r ? i.type === "element" && o.type === "element" && o.offset !== i.offset || (h = s < u ? h.slice(s, u) : h.slice(u, s)) : h = a ? h.slice(s) : h.slice(u) : f === r && (h = a ? h.slice(0, u) : h.slice(0, s)), l += h;
      } else
        !fr(f) && !lu(f) || f === r && this.isCollapsed() || (l += f.getTextContent());
    }
    return l;
  }
  applyDOMRange(e) {
    const n = Jr(), r = n.getEditorState()._selection, i = OK(e.startContainer, e.startOffset, e.endContainer, e.endOffset, n, r);
    if (i === null)
      return;
    const [o, a] = i;
    zl(this.anchor, o.key, o.offset, o.type), zl(this.focus, a.key, a.offset, a.type), this._cachedNodes = null;
  }
  clone() {
    const e = this.anchor, n = this.focus;
    return new Rc(mu(e.key, e.offset, e.type), mu(n.key, n.offset, n.type), this.format, this.style);
  }
  toggleFormat(e) {
    this.format = c4(this.format, e, null), this.dirty = !0;
  }
  setStyle(e) {
    this.style = e, this.dirty = !0;
  }
  hasFormat(e) {
    const n = Qu[e];
    return !!(this.format & n);
  }
  insertRawText(e) {
    const n = e.split(/(\r?\n|\t)/), r = [], i = n.length;
    for (let o = 0; o < i; o++) {
      const a = n[o];
      a === `
` || a === `\r
` ? r.push(mc()) : a === "	" ? r.push(vv()) : r.push(Xr(a));
    }
    this.insertNodes(r);
  }
  insertText(e) {
    const n = this.anchor, r = this.focus, i = this.format, o = this.style;
    let a = n, s = r;
    !this.isCollapsed() && r.isBefore(n) && (a = r, s = n), a.type === "element" && function(m, b, y, w) {
      const S = m.getNode(), E = S.getChildAtIndex(m.offset), I = Xr(), _ = Hi(S) ? Sr().append(I) : I;
      I.setFormat(y), I.setStyle(w), E === null ? S.append(_) : E.insertBefore(_), m.is(b) && b.set(I.__key, 0, "text"), m.set(I.__key, 0, "text");
    }(a, s, i, o);
    const u = a.offset;
    let l = s.offset;
    const c = this.getNodes(), d = c.length;
    let f = c[0];
    pt(f) || St(26);
    const h = f.getTextContent().length, p = f.getParentOrThrow();
    let v = c[d - 1];
    if (d === 1 && s.type === "element" && (l = h, s.set(a.key, l, "text")), this.isCollapsed() && u === h && (f.isSegmented() || f.isToken() || !f.canInsertTextAfter() || !p.canInsertTextAfter() && f.getNextSibling() === null)) {
      let m = f.getNextSibling();
      if (pt(m) && m.canInsertTextBefore() && !yh(m) || (m = Xr(), m.setFormat(i), m.setStyle(o), p.canInsertTextAfter() ? f.insertAfter(m) : p.insertAfter(m)), m.select(0, 0), f = m, e !== "")
        return void this.insertText(e);
    } else if (this.isCollapsed() && u === 0 && (f.isSegmented() || f.isToken() || !f.canInsertTextBefore() || !p.canInsertTextBefore() && f.getPreviousSibling() === null)) {
      let m = f.getPreviousSibling();
      if (pt(m) && !yh(m) || (m = Xr(), m.setFormat(i), p.canInsertTextBefore() ? f.insertBefore(m) : p.insertBefore(m)), m.select(), f = m, e !== "")
        return void this.insertText(e);
    } else if (f.isSegmented() && u !== h) {
      const m = Xr(f.getTextContent());
      m.setFormat(i), f.replace(m), f = m;
    } else if (!this.isCollapsed() && e !== "") {
      const m = v.getParent();
      if (!p.canInsertTextBefore() || !p.canInsertTextAfter() || We(m) && (!m.canInsertTextBefore() || !m.canInsertTextAfter()))
        return this.insertText(""), TK(this.anchor, this.focus, null), void this.insertText(e);
    }
    if (d === 1) {
      if (f.isToken()) {
        const w = Xr(e);
        return w.select(), void f.replace(w);
      }
      const m = f.getFormat(), b = f.getStyle();
      if (u !== l || m === i && b === o) {
        if (yXe(f)) {
          const w = Xr(e);
          return w.setFormat(i), w.setStyle(o), w.select(), void f.replace(w);
        }
      } else {
        if (f.getTextContent() !== "") {
          const w = Xr(e);
          if (w.setFormat(i), w.setStyle(o), w.select(), u === 0)
            f.insertBefore(w, !1);
          else {
            const [S] = f.splitText(u);
            S.insertAfter(w, !1);
          }
          return void (w.isComposing() && this.anchor.type === "text" && (this.anchor.offset -= e.length));
        }
        f.setFormat(i), f.setStyle(o);
      }
      const y = l - u;
      f = f.spliceText(u, y, e, !0), f.getTextContent() === "" ? f.remove() : this.anchor.type === "text" && (f.isComposing() ? this.anchor.offset -= e.length : (this.format = m, this.style = b));
    } else {
      const m = /* @__PURE__ */ new Set([...f.getParentKeys(), ...v.getParentKeys()]), b = We(f) ? f : f.getParentOrThrow();
      let y = We(v) ? v : v.getParentOrThrow(), w = v;
      if (!b.is(y) && y.isInline())
        do
          w = y, y = y.getParentOrThrow();
        while (y.isInline());
      if (s.type === "text" && (l !== 0 || v.getTextContent() === "") || s.type === "element" && v.getIndexWithinParent() < l)
        if (pt(v) && !v.isToken() && l !== v.getTextContentSize()) {
          if (v.isSegmented()) {
            const A = Xr(v.getTextContent());
            v.replace(A), v = A;
          }
          Hi(s.getNode()) || s.type !== "text" || (v = v.spliceText(0, l, "")), m.add(v.__key);
        } else {
          const A = v.getParentOrThrow();
          A.canBeEmpty() || A.getChildrenSize() !== 1 ? v.remove() : A.remove();
        }
      else
        m.add(v.__key);
      const S = y.getChildren(), E = new Set(c), I = b.is(y), _ = b.isInline() && f.getNextSibling() === null ? b : f;
      for (let A = S.length - 1; A >= 0; A--) {
        const P = S[A];
        if (P.is(f) || We(P) && P.isParentOf(f))
          break;
        P.isAttached() && (!E.has(P) || P.is(w) ? I || _.insertAfter(P, !1) : P.remove());
      }
      if (!I) {
        let A = y, P = null;
        for (; A !== null; ) {
          const N = A.getChildren(), k = N.length;
          (k === 0 || N[k - 1].is(P)) && (m.delete(A.__key), P = A), A = A.getParent();
        }
      }
      if (f.isToken())
        if (u === h)
          f.select();
        else {
          const A = Xr(e);
          A.select(), f.replace(A);
        }
      else
        f = f.spliceText(u, h - u, e, !0), f.getTextContent() === "" ? f.remove() : f.isComposing() && this.anchor.type === "text" && (this.anchor.offset -= e.length);
      for (let A = 1; A < d; A++) {
        const P = c[A], N = P.__key;
        m.has(N) || P.remove();
      }
    }
  }
  removeText() {
    this.insertText("");
  }
  formatText(e) {
    if (this.isCollapsed())
      return this.toggleFormat(e), void Li(null);
    const n = this.getNodes(), r = [];
    for (const y of n)
      pt(y) && r.push(y);
    const i = r.length;
    if (i === 0)
      return this.toggleFormat(e), void Li(null);
    const o = this.anchor, a = this.focus, s = this.isBackward(), u = s ? a : o, l = s ? o : a;
    let c = 0, d = r[0], f = u.type === "element" ? 0 : u.offset;
    if (u.type === "text" && f === d.getTextContentSize() && (c = 1, d = r[1], f = 0), d == null)
      return;
    const h = d.getFormatFlags(e, null), p = i - 1;
    let v = r[p];
    const m = l.type === "text" ? l.offset : v.getTextContentSize();
    if (d.is(v)) {
      if (f === m)
        return;
      if (yh(d) || f === 0 && m === d.getTextContentSize())
        d.setFormat(h);
      else {
        const y = d.splitText(f, m), w = f === 0 ? y[0] : y[1];
        w.setFormat(h), u.type === "text" && u.set(w.__key, 0, "text"), l.type === "text" && l.set(w.__key, m - f, "text");
      }
      return void (this.format = h);
    }
    f === 0 || yh(d) || ([, d] = d.splitText(f), f = 0), d.setFormat(h);
    const b = v.getFormatFlags(e, h);
    m > 0 && (m === v.getTextContentSize() || yh(v) || ([v] = v.splitText(m)), v.setFormat(b));
    for (let y = c + 1; y < p; y++) {
      const w = r[y], S = w.getFormatFlags(e, b);
      w.setFormat(S);
    }
    u.type === "text" && u.set(d.__key, f, "text"), l.type === "text" && l.set(v.__key, m, "text"), this.format = h | b;
  }
  insertNodes(e) {
    if (e.length === 0)
      return;
    if (this.anchor.key === "root") {
      this.insertParagraph();
      const h = vt();
      return rt(h) || St(134), h.insertNodes(e);
    }
    const n = Q3((this.isBackward() ? this.focus : this.anchor).getNode(), xh), r = e[e.length - 1];
    if ("__language" in n && We(n)) {
      if ("__language" in e[0])
        this.insertText(e[0].getTextContent());
      else {
        const h = o5(this);
        n.splice(h, 0, e), r.selectEnd();
      }
      return;
    }
    if (!e.some((h) => (We(h) || fr(h)) && !h.isInline())) {
      We(n) || St(135);
      const h = o5(this);
      return n.splice(h, 0, e), void r.selectEnd();
    }
    const i = function(h) {
      const p = Sr();
      let v = null;
      for (let m = 0; m < h.length; m++) {
        const b = h[m], y = lu(b);
        if (y || fr(b) && b.isInline() || We(b) && b.isInline() || pt(b) || b.isParentRequired()) {
          if (v === null && (v = b.createParentElementNode(), p.append(v), y))
            continue;
          v !== null && v.append(b);
        } else
          p.append(b), v = null;
      }
      return p;
    }(e), o = i.getLastDescendant(), a = i.getChildren(), s = !We(n) || !n.isEmpty() ? this.insertParagraph() : null, u = a[a.length - 1];
    let l = a[0];
    var c;
    We(c = l) && xh(c) && !c.isEmpty() && We(n) && (!n.isEmpty() || n.canMergeWhenEmpty()) && (We(n) || St(135), n.append(...l.getChildren()), l = a[1]), l && function(h, p, v) {
      const m = p.getParentOrThrow().getLastChild();
      let b = p;
      const y = [p];
      for (; b !== m; )
        b.getNextSibling() || St(140), b = b.getNextSibling(), y.push(b);
      let w = h;
      for (const S of y)
        w = w.insertAfter(S);
    }(n, l);
    const d = Q3(o, xh);
    s && We(d) && (s.canMergeWhenEmpty() || xh(u)) && (d.append(...s.getChildren()), s.remove()), We(n) && n.isEmpty() && n.remove(), o.selectEnd();
    const f = We(n) ? n.getLastChild() : null;
    lu(f) && d !== n && f.remove();
  }
  insertParagraph() {
    if (this.anchor.key === "root") {
      const a = Sr();
      return hr().splice(this.anchor.offset, 0, [a]), a.select(), a;
    }
    const e = o5(this), n = Q3(this.anchor.getNode(), xh);
    We(n) || St(136);
    const r = n.getChildAtIndex(e), i = r ? [r, ...r.getNextSiblings()] : [], o = n.insertNewAfter(this, !1);
    return o ? (o.append(...i), o.selectStart(), o) : null;
  }
  insertLineBreak(e) {
    const n = mc();
    if (this.insertNodes([n]), e) {
      const r = n.getParentOrThrow(), i = n.getIndexWithinParent();
      r.select(i, i);
    }
  }
  extract() {
    const e = this.getNodes(), n = e.length, r = n - 1, i = this.anchor, o = this.focus;
    let a = e[0], s = e[r];
    const [u, l] = S4(this);
    if (n === 0)
      return [];
    if (n === 1) {
      if (pt(a) && !this.isCollapsed()) {
        const d = u > l ? l : u, f = u > l ? u : l, h = a.splitText(d, f), p = d === 0 ? h[0] : h[1];
        return p != null ? [p] : [];
      }
      return [a];
    }
    const c = i.isBefore(o);
    if (pt(a)) {
      const d = c ? u : l;
      d === a.getTextContentSize() ? e.shift() : d !== 0 && ([, a] = a.splitText(d), e[0] = a);
    }
    if (pt(s)) {
      const d = s.getTextContent().length, f = c ? l : u;
      f === 0 ? e.pop() : f !== d && ([s] = s.splitText(f), e[r] = s);
    }
    return e;
  }
  modify(e, n, r) {
    const i = this.focus, o = this.anchor, a = e === "move", s = dm(i, n);
    if (fr(s) && !s.isIsolated()) {
      if (a && s.isKeyboardSelectable()) {
        const h = I4();
        return h.add(s.__key), void uo(h);
      }
      const f = n ? s.getPreviousSibling() : s.getNextSibling();
      if (pt(f)) {
        const h = f.__key, p = n ? f.getTextContent().length : 0;
        return i.set(h, p, "text"), void (a && o.set(h, p, "text"));
      }
      {
        const h = s.getParentOrThrow();
        let p, v;
        return We(f) ? (v = f.__key, p = n ? f.getChildrenSize() : 0) : (p = s.getIndexWithinParent(), v = h.__key, n || p++), i.set(v, p, "element"), void (a && o.set(v, p, "element"));
      }
    }
    const u = Jr(), l = pu(u._window);
    if (!l)
      return;
    const c = u._blockCursorElement, d = u._rootElement;
    if (d === null || c === null || !We(s) || s.isInline() || s.canBeEmpty() || rO(c, u, d), function(f, h, p, v) {
      f.modify(h, p, v);
    }(l, e, n ? "backward" : "forward", r), l.rangeCount > 0) {
      const f = l.getRangeAt(0), h = this.anchor.getNode(), p = Hi(h) ? h : tXe(h);
      if (this.applyDOMRange(f), this.dirty = !0, !a) {
        const v = this.getNodes(), m = [];
        let b = !1;
        for (let y = 0; y < v.length; y++) {
          const w = v[y];
          d4(w, p) ? m.push(w) : b = !0;
        }
        if (b && m.length > 0)
          if (n) {
            const y = m[0];
            We(y) ? y.selectStart() : y.getParentOrThrow().selectStart();
          } else {
            const y = m[m.length - 1];
            We(y) ? y.selectEnd() : y.getParentOrThrow().selectEnd();
          }
        l.anchorNode === f.startContainer && l.anchorOffset === f.startOffset || function(y) {
          const w = y.focus, S = y.anchor, E = S.key, I = S.offset, _ = S.type;
          zl(S, w.key, w.offset, w.type), zl(w, E, I, _), y._cachedNodes = null;
        }(this);
      }
    }
  }
  forwardDeletion(e, n, r) {
    if (!r && (e.type === "element" && We(n) && e.offset === n.getChildrenSize() || e.type === "text" && e.offset === n.getTextContentSize())) {
      const i = n.getParent(), o = n.getNextSibling() || (i === null ? null : i.getNextSibling());
      if (We(o) && o.isShadowRoot())
        return !0;
    }
    return !1;
  }
  deleteCharacter(e) {
    const n = this.isCollapsed();
    if (this.isCollapsed()) {
      const r = this.anchor;
      let i = r.getNode();
      if (this.forwardDeletion(r, i, e))
        return;
      const o = this.focus, a = dm(o, e);
      if (fr(a) && !a.isIsolated()) {
        if (a.isKeyboardSelectable() && We(i) && i.getChildrenSize() === 0) {
          i.remove();
          const s = I4();
          s.add(a.__key), uo(s);
        } else
          a.remove(), Jr().dispatchCommand(fv, void 0);
        return;
      }
      if (!e && We(a) && We(i) && i.isEmpty())
        return i.remove(), void a.selectStart();
      if (this.modify("extend", e, "character"), this.isCollapsed()) {
        if (e && r.offset === 0 && (r.type === "element" ? r.getNode() : r.getNode().getParentOrThrow()).collapseAtStart(this))
          return;
      } else {
        const s = o.type === "text" ? o.getNode() : null;
        if (i = r.type === "text" ? r.getNode() : null, s !== null && s.isSegmented()) {
          const u = o.offset, l = s.getTextContentSize();
          if (s.is(i) || e && u !== l || !e && u !== 0)
            return void aF(s, e, u);
        } else if (i !== null && i.isSegmented()) {
          const u = r.offset, l = i.getTextContentSize();
          if (i.is(s) || e && u !== 0 || !e && u !== l)
            return void aF(i, e, u);
        }
        (function(u, l) {
          const c = u.anchor, d = u.focus, f = c.getNode(), h = d.getNode();
          if (f === h && c.type === "text" && d.type === "text") {
            const p = c.offset, v = d.offset, m = p < v, b = m ? p : v, y = m ? v : p, w = y - 1;
            b !== w && (oK(f.getTextContent().slice(b, y)) || (l ? d.offset = w : c.offset = w));
          }
        })(this, e);
      }
    }
    if (this.removeText(), e && !n && this.isCollapsed() && this.anchor.type === "element" && this.anchor.offset === 0) {
      const r = this.anchor.getNode();
      r.isEmpty() && Hi(r.getParent()) && r.getIndexWithinParent() === 0 && r.collapseAtStart(this);
    }
  }
  deleteLine(e) {
    if (this.isCollapsed()) {
      const n = this.anchor.type === "element";
      if (n && this.insertText(" "), this.modify("extend", e, "lineboundary"), (e ? this.focus : this.anchor).offset === 0 && this.modify("extend", e, "character"), n) {
        const r = e ? this.anchor : this.focus;
        r.set(r.key, r.offset + 1, r.type);
      }
    }
    this.removeText();
  }
  deleteWord(e) {
    if (this.isCollapsed()) {
      const n = this.anchor, r = n.getNode();
      if (this.forwardDeletion(n, r, e))
        return;
      this.modify("extend", e, "word");
    }
    this.removeText();
  }
  isBackward() {
    return this.focus.isBefore(this.anchor);
  }
  getStartEndPoints() {
    return [this.anchor, this.focus];
  }
}
function li(t) {
  return t instanceof Aw;
}
function oF(t) {
  const e = t.offset;
  if (t.type === "text")
    return e;
  const n = t.getNode();
  return e === n.getChildrenSize() ? n.getTextContent().length : 0;
}
function S4(t) {
  const e = t.getStartEndPoints();
  if (e === null)
    return [0, 0];
  const [n, r] = e;
  return n.type === "element" && r.type === "element" && n.key === r.key && n.offset === r.offset ? [0, 0] : [oF(n), oF(r)];
}
function aF(t, e, n) {
  const r = t, i = r.getTextContent().split(/(?=\s)/g), o = i.length;
  let a = 0, s = 0;
  for (let l = 0; l < o; l++) {
    const c = l === o - 1;
    if (s = a, a += i[l].length, e && a === n || a > n || c) {
      i.splice(l, 1), c && (s = void 0);
      break;
    }
  }
  const u = i.join("").trim();
  u === "" ? r.remove() : (r.setTextContent(u), r.select(s, s));
}
function sF(t, e, n, r) {
  let i, o = e;
  if (t.nodeType === gv) {
    let a = !1;
    const s = t.childNodes, u = s.length, l = r._blockCursorElement;
    o === u && (a = !0, o = u - 1);
    let c = s[o], d = !1;
    if (c === l)
      c = s[o + 1], d = !0;
    else if (l !== null) {
      const f = l.parentNode;
      t === f && e > Array.prototype.indexOf.call(f.children, l) && o--;
    }
    if (i = Ph(c), pt(i))
      o = jM(i, a);
    else {
      let f = Ph(t);
      if (f === null)
        return null;
      if (We(f)) {
        o = Math.min(f.getChildrenSize(), o);
        let h = f.getChildAtIndex(o);
        if (We(h) && function(p, v, m) {
          const b = p.getParent();
          return m === null || b === null || !b.canBeEmpty() || b !== m.getNode();
        }(h, 0, n)) {
          const p = a ? h.getLastDescendant() : h.getFirstDescendant();
          p === null ? f = h : (h = p, f = We(h) ? h : h.getParentOrThrow()), o = 0;
        }
        pt(h) ? (i = h, f = null, o = jM(h, a)) : h !== f && a && !d && o++;
      } else {
        const h = f.getIndexWithinParent();
        o = e === 0 && fr(f) && Ph(t) === f ? h : h + 1, f = f.getParentOrThrow();
      }
      if (We(f))
        return mu(f.__key, o, "element");
    }
  } else
    i = Ph(t);
  return pt(i) ? mu(i.__key, o, "text") : null;
}
function uF(t, e, n) {
  const r = t.offset, i = t.getNode();
  if (r === 0) {
    const o = i.getPreviousSibling(), a = i.getParent();
    if (e) {
      if ((n || !e) && o === null && We(a) && a.isInline()) {
        const s = a.getPreviousSibling();
        pt(s) && (t.key = s.__key, t.offset = s.getTextContent().length);
      }
    } else
      We(o) && !n && o.isInline() ? (t.key = o.__key, t.offset = o.getChildrenSize(), t.type = "element") : pt(o) && (t.key = o.__key, t.offset = o.getTextContent().length);
  } else if (r === i.getTextContent().length) {
    const o = i.getNextSibling(), a = i.getParent();
    if (e && We(o) && o.isInline())
      t.key = o.__key, t.offset = 0, t.type = "element";
    else if ((n || e) && o === null && We(a) && a.isInline() && !a.canInsertTextAfter()) {
      const s = a.getNextSibling();
      pt(s) && (t.key = s.__key, t.offset = 0);
    }
  }
}
function TK(t, e, n) {
  if (t.type === "text" && e.type === "text") {
    const r = t.isBefore(e), i = t.is(e);
    uF(t, r, i), uF(e, !r, i), i && (e.key = t.key, e.offset = t.offset, e.type = t.type);
    const o = Jr();
    if (o.isComposing() && o._compositionKey !== t.key && rt(n)) {
      const a = n.anchor, s = n.focus;
      zl(t, a.key, a.offset, a.type), zl(e, s.key, s.offset, s.type);
    }
  }
}
function OK(t, e, n, r, i, o) {
  if (t === null || n === null || !mv(i, t, n))
    return null;
  const a = sF(t, e, rt(o) ? o.anchor : null, i);
  if (a === null)
    return null;
  const s = sF(n, r, rt(o) ? o.focus : null, i);
  if (s === null)
    return null;
  if (a.type === "element" && s.type === "element") {
    const u = Ph(t), l = Ph(n);
    if (fr(u) && fr(l))
      return null;
  }
  return TK(a, s, o), [a, s];
}
function f2(t) {
  return We(t) && !t.isInline();
}
function PK(t, e, n, r, i, o) {
  const a = ml(), s = new Rc(mu(t, e, i), mu(n, r, o), 0, "");
  return s.dirty = !0, a._selection = s, s;
}
function uO() {
  const t = mu("root", 0, "element"), e = mu("root", 0, "element");
  return new Rc(t, e, 0, "");
}
function I4() {
  return new Aw(/* @__PURE__ */ new Set());
}
function lO(t, e, n, r) {
  const i = n._window;
  if (i === null)
    return null;
  const o = r || i.event, a = o ? o.type : void 0, s = a === "selectionchange", u = !l4 && (s || a === "beforeinput" || a === "compositionstart" || a === "compositionend" || a === "click" && o && o.detail === 3 || a === "drop" || a === void 0);
  let l, c, d, f;
  if (rt(t) && !u)
    return t.clone();
  if (e === null)
    return null;
  if (l = e.anchorNode, c = e.focusNode, d = e.anchorOffset, f = e.focusOffset, s && rt(t) && !mv(n, l, c))
    return t.clone();
  const h = OK(l, d, c, f, n, t);
  if (h === null)
    return null;
  const [p, v] = h;
  return new Rc(p, v, rt(t) ? t.format : 0, rt(t) ? t.style : "");
}
function vt() {
  return ml()._selection;
}
function Vp() {
  return Jr()._editorState._selection;
}
function h2(t, e, n, r = 1) {
  const i = t.anchor, o = t.focus, a = i.getNode(), s = o.getNode();
  if (!e.is(a) && !e.is(s))
    return;
  const u = e.__key;
  if (t.isCollapsed()) {
    const l = i.offset;
    if (n <= l && r > 0 || n < l && r < 0) {
      const c = Math.max(0, l + r);
      i.set(u, c, "element"), o.set(u, c, "element"), lF(t);
    }
  } else {
    const l = t.isBackward(), c = l ? o : i, d = c.getNode(), f = l ? i : o, h = f.getNode();
    if (e.is(d)) {
      const p = c.offset;
      (n <= p && r > 0 || n < p && r < 0) && c.set(u, Math.max(0, p + r), "element");
    }
    if (e.is(h)) {
      const p = f.offset;
      (n <= p && r > 0 || n < p && r < 0) && f.set(u, Math.max(0, p + r), "element");
    }
  }
  lF(t);
}
function lF(t) {
  const e = t.anchor, n = e.offset, r = t.focus, i = r.offset, o = e.getNode(), a = r.getNode();
  if (t.isCollapsed()) {
    if (!We(o))
      return;
    const s = o.getChildrenSize(), u = n >= s, l = u ? o.getChildAtIndex(s - 1) : o.getChildAtIndex(n);
    if (pt(l)) {
      let c = 0;
      u && (c = l.getTextContentSize()), e.set(l.__key, c, "text"), r.set(l.__key, c, "text");
    }
  } else {
    if (We(o)) {
      const s = o.getChildrenSize(), u = n >= s, l = u ? o.getChildAtIndex(s - 1) : o.getChildAtIndex(n);
      if (pt(l)) {
        let c = 0;
        u && (c = l.getTextContentSize()), e.set(l.__key, c, "text");
      }
    }
    if (We(a)) {
      const s = a.getChildrenSize(), u = i >= s, l = u ? a.getChildAtIndex(s - 1) : a.getChildAtIndex(i);
      if (pt(l)) {
        let c = 0;
        u && (c = l.getTextContentSize()), r.set(l.__key, c, "text");
      }
    }
  }
}
function p2(t, e, n, r, i) {
  let o = null, a = 0, s = null;
  r !== null ? (o = r.__key, pt(r) ? (a = r.getTextContentSize(), s = "text") : We(r) && (a = r.getChildrenSize(), s = "element")) : i !== null && (o = i.__key, pt(i) ? s = "text" : We(i) && (s = "element")), o !== null && s !== null ? t.set(o, a, s) : (a = e.getIndexWithinParent(), a === -1 && (a = n.getChildrenSize()), t.set(n.__key, a, "element"));
}
function cF(t, e, n, r, i) {
  t.type === "text" ? (t.key = n, e || (t.offset += i)) : t.offset > r.getIndexWithinParent() && (t.offset -= 1);
}
function CXe(t, e, n, r, i, o, a) {
  const s = r.anchorNode, u = r.focusNode, l = r.anchorOffset, c = r.focusOffset, d = document.activeElement;
  if (i.has("collaboration") && d !== o || d !== null && JT(d))
    return;
  if (!rt(e))
    return void (t !== null && mv(n, s, u) && r.removeAllRanges());
  const f = e.anchor, h = e.focus, p = f.key, v = h.key, m = a2(n, p), b = a2(n, v), y = f.offset, w = h.offset, S = e.format, E = e.style, I = e.isCollapsed();
  let _ = m, A = b, P = !1;
  if (f.type === "text") {
    _ = i2(m);
    const $ = f.getNode();
    P = $.getFormat() !== S || $.getStyle() !== E;
  } else
    rt(t) && t.anchor.type === "text" && (P = !0);
  var N, k, D, R, V;
  if (h.type === "text" && (A = i2(b)), _ !== null && A !== null && (I && (t === null || P || rt(t) && (t.format !== S || t.style !== E)) && (N = S, k = E, D = y, R = p, V = performance.now(), bK = [N, k, D, R, V]), l !== y || c !== w || s !== _ || u !== A || r.type === "Range" && I || (d !== null && o.contains(d) || o.focus({ preventScroll: !0 }), f.type === "element"))) {
    try {
      r.setBaseAndExtent(_, y, A, w);
    } catch {
    }
    if (!i.has("skip-scroll-into-view") && e.isCollapsed() && o !== null && o === document.activeElement) {
      const $ = e instanceof Rc && e.anchor.type === "element" ? _.childNodes[y] || null : r.rangeCount > 0 ? r.getRangeAt(0) : null;
      if ($ !== null) {
        let F;
        if ($ instanceof Text) {
          const M = document.createRange();
          M.selectNode($), F = M.getBoundingClientRect();
        } else
          F = $.getBoundingClientRect();
        (function(M, B, X) {
          const L = X.ownerDocument, j = L.defaultView;
          if (j === null)
            return;
          let { top: K, bottom: W } = B, Y = 0, U = 0, Q = X;
          for (; Q !== null; ) {
            const Z = Q === L.body;
            if (Z)
              Y = 0, U = Sw(M).innerHeight;
            else {
              const ie = Q.getBoundingClientRect();
              Y = ie.top, U = ie.bottom;
            }
            let ee = 0;
            if (K < Y ? ee = -(Y - K) : W > U && (ee = W - U), ee !== 0)
              if (Z)
                j.scrollBy(0, ee);
              else {
                const ie = Q.scrollTop;
                Q.scrollTop += ee;
                const oe = Q.scrollTop - ie;
                K -= oe, W -= oe;
              }
            if (Z)
              break;
            Q = Ew(Q);
          }
        })(n, F, o);
      }
    }
    C4 = !0;
  }
}
function Bp(t) {
  let e = vt() || Vp();
  e === null && (e = hr().selectEnd()), e.insertNodes(t);
}
function o5(t) {
  let e = t;
  t.isCollapsed() || e.removeText();
  const n = vt();
  rt(n) && (e = n), rt(e) || St(161);
  const r = e.anchor;
  let i = r.getNode(), o = r.offset;
  for (; !xh(i); )
    [i, o] = wXe(i, o);
  return o;
}
function wXe(t, e) {
  const n = t.getParent();
  if (!n) {
    const i = Sr();
    return hr().append(i), i.select(), [hr(), 0];
  }
  if (pt(t)) {
    const i = t.splitText(e);
    if (i.length === 0)
      return [n, t.getIndexWithinParent()];
    const o = e === 0 ? 0 : 1;
    return [n, i[0].getIndexWithinParent() + o];
  }
  if (!We(t) || e === 0)
    return [n, t.getIndexWithinParent()];
  const r = t.getChildAtIndex(e);
  if (r) {
    const i = new Rc(mu(t.__key, e, "element"), mu(t.__key, e, "element"), 0, ""), o = t.insertNewAfter(i);
    o && o.append(r, ...r.getNextSiblings());
  }
  return [n, t.getIndexWithinParent() + 1];
}
let Ai = null, Ti = null, No = !1, a5 = !1, wy = 0;
const dF = { characterData: !0, childList: !0, subtree: !0 };
function bv() {
  return No || Ai !== null && Ai._readOnly;
}
function Ao() {
  No && St(13);
}
function NK() {
  wy > 99 && St(14);
}
function ml() {
  return Ai === null && St(195, kK()), Ai;
}
function Jr() {
  return Ti === null && St(196, kK()), Ti;
}
function kK() {
  let t = 0;
  const e = /* @__PURE__ */ new Set(), n = Ow.version;
  if (typeof window < "u")
    for (const i of document.querySelectorAll("[contenteditable]")) {
      const o = Cw(i);
      if (KT(o))
        t++;
      else if (o) {
        let a = String(o.constructor.version || "<0.17.1");
        a === n && (a += " (separately built, likely a bundler configuration issue)"), e.add(a);
      }
    }
  let r = ` Detected on the page: ${t} compatible editor(s) with version ${n}`;
  return e.size && (r += ` and incompatible editors with versions ${Array.from(e).join(", ")}`), r;
}
function EXe() {
  return Ti;
}
function fF(t, e, n) {
  const r = e.__type, i = function(s, u) {
    const l = s._nodes.get(u);
    return l === void 0 && St(30, u), l;
  }(t, r);
  let o = n.get(r);
  o === void 0 && (o = Array.from(i.transforms), n.set(r, o));
  const a = o.length;
  for (let s = 0; s < a && (o[s](e), e.isAttached()); s++)
    ;
}
function hF(t, e) {
  return t !== void 0 && t.__key !== e && t.isAttached();
}
function SXe(t) {
  return cO(t, Jr()._nodes);
}
function cO(t, e) {
  const n = t.type, r = e.get(n);
  r === void 0 && St(17, n);
  const i = r.klass;
  t.type !== i.getType() && St(18, i.name);
  const o = i.importJSON(t), a = t.children;
  if (We(o) && Array.isArray(a))
    for (let s = 0; s < a.length; s++) {
      const u = cO(a[s], e);
      o.append(u);
    }
  return o;
}
function pF(t, e, n) {
  const r = Ai, i = No, o = Ti;
  Ai = e, No = !0, Ti = t;
  try {
    return n();
  } finally {
    Ai = r, No = i, Ti = o;
  }
}
function Kl(t, e) {
  const n = t._pendingEditorState, r = t._rootElement, i = t._headless || r === null;
  if (n === null)
    return;
  const o = t._editorState, a = o._selection, s = n._selection, u = t._dirtyType !== Fd, l = Ai, c = No, d = Ti, f = t._updating, h = t._observer;
  let p = null;
  if (t._pendingEditorState = null, t._editorState = n, !i && u && h !== null) {
    Ti = t, Ai = n, No = !1, t._updating = !0;
    try {
      const I = t._dirtyType, _ = t._dirtyElements, A = t._dirtyLeaves;
      h.disconnect(), p = dXe(o, n, t, I, _, A);
    } catch (I) {
      if (I instanceof Error && t._onError(I), a5)
        throw I;
      return MK(t, null, r, n), QJ(t), t._dirtyType = cp, a5 = !0, Kl(t, o), void (a5 = !1);
    } finally {
      h.observe(r, dF), t._updating = f, Ai = l, No = c, Ti = d;
    }
  }
  n._readOnly || (n._readOnly = !0);
  const v = t._dirtyLeaves, m = t._dirtyElements, b = t._normalizedNodes, y = t._updateTags, w = t._deferred;
  u && (t._dirtyType = Fd, t._cloneNotNeeded.clear(), t._dirtyLeaves = /* @__PURE__ */ new Set(), t._dirtyElements = /* @__PURE__ */ new Map(), t._normalizedNodes = /* @__PURE__ */ new Set(), t._updateTags = /* @__PURE__ */ new Set()), function(I, _) {
    const A = I._decorators;
    let P = I._pendingDecorators || A;
    const N = _._nodeMap;
    let k;
    for (k in P)
      N.has(k) || (P === A && (P = rK(I)), delete P[k]);
  }(t, n);
  const S = i ? null : pu(t._window);
  if (t._editable && S !== null && (u || s === null || s.dirty)) {
    Ti = t, Ai = n;
    try {
      if (h !== null && h.disconnect(), u || s === null || s.dirty) {
        const I = t._blockCursorElement;
        I !== null && rO(I, t, r), CXe(a, s, t, S, y, r);
      }
      rXe(t, r, s), h !== null && h.observe(r, dF);
    } finally {
      Ti = d, Ai = l;
    }
  }
  p !== null && function(I, _, A, P, N) {
    const k = Array.from(I._listeners.mutation), D = k.length;
    for (let R = 0; R < D; R++) {
      const [V, $] = k[R], F = _.get($);
      F !== void 0 && V(F, { dirtyLeaves: P, prevEditorState: N, updateTags: A });
    }
  }(t, p, y, v, o), rt(s) || s === null || a !== null && a.is(s) || t.dispatchCommand(fv, void 0);
  const E = t._pendingDecorators;
  E !== null && (t._decorators = E, t._pendingDecorators = null, T0("decorator", t, !0, E)), function(I, _, A) {
    const P = WM(_), N = WM(A);
    P !== N && T0("textcontent", I, !0, N);
  }(t, e || o, n), T0("update", t, !0, { dirtyElements: m, dirtyLeaves: v, editorState: n, normalizedNodes: b, prevEditorState: e || o, tags: y }), function(I, _) {
    if (I._deferred = [], _.length !== 0) {
      const A = I._updating;
      I._updating = !0;
      try {
        for (let P = 0; P < _.length; P++)
          _[P]();
      } finally {
        I._updating = A;
      }
    }
  }(t, w), function(I) {
    const _ = I._updates;
    if (_.length !== 0) {
      const A = _.shift();
      if (A) {
        const [P, N] = A;
        $K(I, P, N);
      }
    }
  }(t);
}
function T0(t, e, n, ...r) {
  const i = e._updating;
  e._updating = n;
  try {
    const o = Array.from(e._listeners[t]);
    for (let a = 0; a < o.length; a++)
      o[a].apply(null, r);
  } finally {
    e._updating = i;
  }
}
function RK(t, e, n) {
  if (t._updating === !1 || Ti !== t) {
    let i = !1;
    return t.update(() => {
      i = RK(t, e, n);
    }), i;
  }
  const r = QT(t);
  for (let i = 4; i >= 0; i--)
    for (let o = 0; o < r.length; o++) {
      const a = r[o]._commands.get(e);
      if (a !== void 0) {
        const s = a[i];
        if (s !== void 0) {
          const u = Array.from(s), l = u.length;
          for (let c = 0; c < l; c++)
            if (u[c](n, t) === !0)
              return !0;
        }
      }
    }
  return !1;
}
function gF(t, e) {
  const n = t._updates;
  let r = e || !1;
  for (; n.length !== 0; ) {
    const i = n.shift();
    if (i) {
      const [o, a] = i;
      let s, u;
      if (a !== void 0) {
        if (s = a.onUpdate, u = a.tag, a.skipTransforms && (r = !0), a.discrete) {
          const l = t._pendingEditorState;
          l === null && St(191), l._flushSync = !0;
        }
        s && t._deferred.push(s), u && t._updateTags.add(u);
      }
      o();
    }
  }
  return r;
}
function $K(t, e, n) {
  const r = t._updateTags;
  let i, o, a = !1, s = !1;
  n !== void 0 && (i = n.onUpdate, o = n.tag, o != null && r.add(o), a = n.skipTransforms || !1, s = n.discrete || !1), i && t._deferred.push(i);
  const u = t._editorState;
  let l = t._pendingEditorState, c = !1;
  (l === null || l._readOnly) && (l = t._pendingEditorState = new Tw(new Map((l || u)._nodeMap)), c = !0), l._flushSync = s;
  const d = Ai, f = No, h = Ti, p = t._updating;
  Ai = l, No = !1, t._updating = !0, Ti = t;
  try {
    c && (t._headless ? u._selection !== null && (l._selection = u._selection.clone()) : l._selection = function(y) {
      const w = y.getEditorState()._selection, S = pu(y._window);
      return rt(w) || w == null ? lO(w, S, y, null) : w.clone();
    }(t));
    const m = t._compositionKey;
    e(), a = gF(t, a), function(y, w) {
      const S = w.getEditorState()._selection, E = y._selection;
      if (rt(E)) {
        const I = E.anchor, _ = E.focus;
        let A;
        if (I.type === "text" && (A = I.getNode(), A.selectionTransform(S, E)), _.type === "text") {
          const P = _.getNode();
          A !== P && P.selectionTransform(S, E);
        }
      }
    }(l, t), t._dirtyType !== Fd && (a ? function(y, w) {
      const S = w._dirtyLeaves, E = y._nodeMap;
      for (const I of S) {
        const _ = E.get(I);
        pt(_) && _.isAttached() && _.isSimpleText() && !_.isUnmergeable() && BM(_);
      }
    }(l, t) : function(y, w) {
      const S = w._dirtyLeaves, E = w._dirtyElements, I = y._nodeMap, _ = Jl(), A = /* @__PURE__ */ new Map();
      let P = S, N = P.size, k = E, D = k.size;
      for (; N > 0 || D > 0; ) {
        if (N > 0) {
          w._dirtyLeaves = /* @__PURE__ */ new Set();
          for (const R of P) {
            const V = I.get(R);
            pt(V) && V.isAttached() && V.isSimpleText() && !V.isUnmergeable() && BM(V), V !== void 0 && hF(V, _) && fF(w, V, A), S.add(R);
          }
          if (P = w._dirtyLeaves, N = P.size, N > 0) {
            wy++;
            continue;
          }
        }
        w._dirtyLeaves = /* @__PURE__ */ new Set(), w._dirtyElements = /* @__PURE__ */ new Map();
        for (const R of k) {
          const V = R[0], $ = R[1];
          if (V !== "root" && !$)
            continue;
          const F = I.get(V);
          F !== void 0 && hF(F, _) && fF(w, F, A), E.set(V, $);
        }
        P = w._dirtyLeaves, N = P.size, k = w._dirtyElements, D = k.size, wy++;
      }
      w._dirtyLeaves = S, w._dirtyElements = E;
    }(l, t), gF(t), function(y, w, S, E) {
      const I = y._nodeMap, _ = w._nodeMap, A = [];
      for (const [P] of E) {
        const N = _.get(P);
        N !== void 0 && (N.isAttached() || (We(N) && lK(N, P, I, _, A, E), I.has(P) || E.delete(P), A.push(P)));
      }
      for (const P of A)
        _.delete(P);
      for (const P of S) {
        const N = _.get(P);
        N === void 0 || N.isAttached() || (I.has(P) || S.delete(P), _.delete(P));
      }
    }(u, l, t._dirtyLeaves, t._dirtyElements)), m !== t._compositionKey && (l._flushSync = !0);
    const b = l._selection;
    if (rt(b)) {
      const y = l._nodeMap, w = b.anchor.key, S = b.focus.key;
      y.get(w) !== void 0 && y.get(S) !== void 0 || St(19);
    } else
      li(b) && b._nodes.size === 0 && (l._selection = null);
  } catch (m) {
    return m instanceof Error && t._onError(m), t._pendingEditorState = u, t._dirtyType = cp, t._cloneNotNeeded.clear(), t._dirtyLeaves = /* @__PURE__ */ new Set(), t._dirtyElements.clear(), void Kl(t);
  } finally {
    Ai = d, No = f, Ti = h, t._updating = p, wy = 0;
  }
  t._dirtyType !== Fd || function(m, b) {
    const y = b.getEditorState()._selection, w = m._selection;
    if (w !== null) {
      if (w.dirty || !w.is(y))
        return !0;
    } else if (y !== null)
      return !0;
    return !1;
  }(l, t) ? l._flushSync ? (l._flushSync = !1, Kl(t)) : c && KUe(() => {
    Kl(t);
  }) : (l._flushSync = !1, c && (r.clear(), t._deferred = [], t._pendingEditorState = null));
}
function ia(t, e, n) {
  t._updating ? t._updates.push([e, n]) : $K(t, e, n);
}
class Eu extends _w {
  constructor(e) {
    super(e), this.__first = null, this.__last = null, this.__size = 0, this.__format = 0, this.__style = "", this.__indent = 0, this.__dir = null;
  }
  afterCloneFrom(e) {
    super.afterCloneFrom(e), this.__first = e.__first, this.__last = e.__last, this.__size = e.__size, this.__indent = e.__indent, this.__format = e.__format, this.__style = e.__style, this.__dir = e.__dir;
  }
  getFormat() {
    return this.getLatest().__format;
  }
  getFormatType() {
    const e = this.getFormat();
    return WUe[e] || "";
  }
  getStyle() {
    return this.getLatest().__style;
  }
  getIndent() {
    return this.getLatest().__indent;
  }
  getChildren() {
    const e = [];
    let n = this.getFirstChild();
    for (; n !== null; )
      e.push(n), n = n.getNextSibling();
    return e;
  }
  getChildrenKeys() {
    const e = [];
    let n = this.getFirstChild();
    for (; n !== null; )
      e.push(n.__key), n = n.getNextSibling();
    return e;
  }
  getChildrenSize() {
    return this.getLatest().__size;
  }
  isEmpty() {
    return this.getChildrenSize() === 0;
  }
  isDirty() {
    const e = Jr()._dirtyElements;
    return e !== null && e.has(this.__key);
  }
  isLastChild() {
    const e = this.getLatest(), n = this.getParentOrThrow().getLastChild();
    return n !== null && n.is(e);
  }
  getAllTextNodes() {
    const e = [];
    let n = this.getFirstChild();
    for (; n !== null; ) {
      if (pt(n) && e.push(n), We(n)) {
        const r = n.getAllTextNodes();
        e.push(...r);
      }
      n = n.getNextSibling();
    }
    return e;
  }
  getFirstDescendant() {
    let e = this.getFirstChild();
    for (; We(e); ) {
      const n = e.getFirstChild();
      if (n === null)
        break;
      e = n;
    }
    return e;
  }
  getLastDescendant() {
    let e = this.getLastChild();
    for (; We(e); ) {
      const n = e.getLastChild();
      if (n === null)
        break;
      e = n;
    }
    return e;
  }
  getDescendantByIndex(e) {
    const n = this.getChildren(), r = n.length;
    if (e >= r) {
      const o = n[r - 1];
      return We(o) && o.getLastDescendant() || o || null;
    }
    const i = n[e];
    return We(i) && i.getFirstDescendant() || i || null;
  }
  getFirstChild() {
    const e = this.getLatest().__first;
    return e === null ? null : fi(e);
  }
  getFirstChildOrThrow() {
    const e = this.getFirstChild();
    return e === null && St(45, this.__key), e;
  }
  getLastChild() {
    const e = this.getLatest().__last;
    return e === null ? null : fi(e);
  }
  getLastChildOrThrow() {
    const e = this.getLastChild();
    return e === null && St(96, this.__key), e;
  }
  getChildAtIndex(e) {
    const n = this.getChildrenSize();
    let r, i;
    if (e < n / 2) {
      for (r = this.getFirstChild(), i = 0; r !== null && i <= e; ) {
        if (i === e)
          return r;
        r = r.getNextSibling(), i++;
      }
      return null;
    }
    for (r = this.getLastChild(), i = n - 1; r !== null && i >= e; ) {
      if (i === e)
        return r;
      r = r.getPreviousSibling(), i--;
    }
    return null;
  }
  getTextContent() {
    let e = "";
    const n = this.getChildren(), r = n.length;
    for (let i = 0; i < r; i++) {
      const o = n[i];
      e += o.getTextContent(), We(o) && i !== r - 1 && !o.isInline() && (e += rl);
    }
    return e;
  }
  getTextContentSize() {
    let e = 0;
    const n = this.getChildren(), r = n.length;
    for (let i = 0; i < r; i++) {
      const o = n[i];
      e += o.getTextContentSize(), We(o) && i !== r - 1 && !o.isInline() && (e += rl.length);
    }
    return e;
  }
  getDirection() {
    return this.getLatest().__dir;
  }
  hasFormat(e) {
    if (e !== "") {
      const n = FM[e];
      return !!(this.getFormat() & n);
    }
    return !1;
  }
  select(e, n) {
    Ao();
    const r = vt();
    let i = e, o = n;
    const a = this.getChildrenSize();
    if (!this.canBeEmpty()) {
      if (e === 0 && n === 0) {
        const u = this.getFirstChild();
        if (pt(u) || We(u))
          return u.select(0, 0);
      } else if (!(e !== void 0 && e !== a || n !== void 0 && n !== a)) {
        const u = this.getLastChild();
        if (pt(u) || We(u))
          return u.select();
      }
    }
    i === void 0 && (i = a), o === void 0 && (o = a);
    const s = this.__key;
    return rt(r) ? (r.anchor.set(s, i, "element"), r.focus.set(s, o, "element"), r.dirty = !0, r) : PK(s, i, s, o, "element", "element");
  }
  selectStart() {
    const e = this.getFirstDescendant();
    return e ? e.selectStart() : this.select();
  }
  selectEnd() {
    const e = this.getLastDescendant();
    return e ? e.selectEnd() : this.select();
  }
  clear() {
    const e = this.getWritable();
    return this.getChildren().forEach((n) => n.remove()), e;
  }
  append(...e) {
    return this.splice(this.getChildrenSize(), 0, e);
  }
  setDirection(e) {
    const n = this.getWritable();
    return n.__dir = e, n;
  }
  setFormat(e) {
    return this.getWritable().__format = e !== "" ? FM[e] : 0, this;
  }
  setStyle(e) {
    return this.getWritable().__style = e || "", this;
  }
  setIndent(e) {
    return this.getWritable().__indent = e, this;
  }
  splice(e, n, r) {
    const i = r.length, o = this.getChildrenSize(), a = this.getWritable(), s = a.__key, u = [], l = [], c = this.getChildAtIndex(e + n);
    let d = null, f = o - n + i;
    if (e !== 0)
      if (e === o)
        d = this.getLastChild();
      else {
        const p = this.getChildAtIndex(e);
        p !== null && (d = p.getPreviousSibling());
      }
    if (n > 0) {
      let p = d === null ? this.getFirstChild() : d.getNextSibling();
      for (let v = 0; v < n; v++) {
        p === null && St(100);
        const m = p.getNextSibling(), b = p.__key;
        Sd(p.getWritable()), l.push(b), p = m;
      }
    }
    let h = d;
    for (let p = 0; p < i; p++) {
      const v = r[p];
      h !== null && v.is(h) && (d = h = h.getPreviousSibling());
      const m = v.getWritable();
      m.__parent === s && f--, Sd(m);
      const b = v.__key;
      if (h === null)
        a.__first = b, m.__prev = null;
      else {
        const y = h.getWritable();
        y.__next = b, m.__prev = y.__key;
      }
      v.__key === s && St(76), m.__parent = s, u.push(b), h = v;
    }
    if (e + n === o)
      h !== null && (h.getWritable().__next = null, a.__last = h.__key);
    else if (c !== null) {
      const p = c.getWritable();
      if (h !== null) {
        const v = h.getWritable();
        p.__prev = h.__key, v.__next = c.__key;
      } else
        p.__prev = null;
    }
    if (a.__size = f, l.length) {
      const p = vt();
      if (rt(p)) {
        const v = new Set(l), m = new Set(u), { anchor: b, focus: y } = p;
        mF(b, v, m) && p2(b, b.getNode(), this, d, c), mF(y, v, m) && p2(y, y.getNode(), this, d, c), f !== 0 || this.canBeEmpty() || Oi(this) || this.remove();
      }
    }
    return a;
  }
  exportJSON() {
    return { children: [], direction: this.getDirection(), format: this.getFormatType(), indent: this.getIndent(), type: "element", version: 1 };
  }
  insertNewAfter(e, n) {
    return null;
  }
  canIndent() {
    return !0;
  }
  collapseAtStart(e) {
    return !1;
  }
  excludeFromCopy(e) {
    return !1;
  }
  canReplaceWith(e) {
    return !0;
  }
  canInsertAfter(e) {
    return !0;
  }
  canBeEmpty() {
    return !0;
  }
  canInsertTextBefore() {
    return !0;
  }
  canInsertTextAfter() {
    return !0;
  }
  isInline() {
    return !1;
  }
  isShadowRoot() {
    return !1;
  }
  canMergeWith(e) {
    return !1;
  }
  extractWithChild(e, n, r) {
    return !1;
  }
  canMergeWhenEmpty() {
    return !1;
  }
}
function We(t) {
  return t instanceof Eu;
}
function mF(t, e, n) {
  let r = t.getNode();
  for (; r; ) {
    const i = r.__key;
    if (e.has(i) && !n.has(i))
      return !0;
    r = r.getParent();
  }
  return !1;
}
class yv extends _w {
  constructor(e) {
    super(e);
  }
  decorate(e, n) {
    St(47);
  }
  isIsolated() {
    return !1;
  }
  isInline() {
    return !0;
  }
  isKeyboardSelectable() {
    return !0;
  }
}
function fr(t) {
  return t instanceof yv;
}
class xv extends Eu {
  static getType() {
    return "root";
  }
  static clone() {
    return new xv();
  }
  constructor() {
    super("root"), this.__cachedText = null;
  }
  getTopLevelElementOrThrow() {
    St(51);
  }
  getTextContent() {
    const e = this.__cachedText;
    return !bv() && Jr()._dirtyType !== Fd || e === null ? super.getTextContent() : e;
  }
  remove() {
    St(52);
  }
  replace(e) {
    St(53);
  }
  insertBefore(e) {
    St(54);
  }
  insertAfter(e) {
    St(55);
  }
  updateDOM(e, n) {
    return !1;
  }
  append(...e) {
    for (let n = 0; n < e.length; n++) {
      const r = e[n];
      We(r) || fr(r) || St(56);
    }
    return super.append(...e);
  }
  static importJSON(e) {
    const n = hr();
    return n.setFormat(e.format), n.setIndent(e.indent), n.setDirection(e.direction), n;
  }
  exportJSON() {
    return { children: [], direction: this.getDirection(), format: this.getFormatType(), indent: this.getIndent(), type: "root", version: 1 };
  }
  collapseAtStart() {
    return !0;
  }
}
function Hi(t) {
  return t instanceof xv;
}
function dO() {
  return new Tw(/* @__PURE__ */ new Map([["root", new xv()]]));
}
function DK(t) {
  const e = t.exportJSON(), n = t.constructor;
  if (e.type !== n.getType() && St(130, n.name), We(t)) {
    const r = e.children;
    Array.isArray(r) || St(59, n.name);
    const i = t.getChildren();
    for (let o = 0; o < i.length; o++) {
      const a = DK(i[o]);
      r.push(a);
    }
  }
  return e;
}
class Tw {
  constructor(e, n) {
    this._nodeMap = e, this._selection = n || null, this._flushSync = !1, this._readOnly = !1;
  }
  isEmpty() {
    return this._nodeMap.size === 1 && this._selection === null;
  }
  read(e, n) {
    return pF(n && n.editor || null, this, e);
  }
  clone(e) {
    const n = new Tw(this._nodeMap, e === void 0 ? this._selection : e);
    return n._readOnly = !0, n;
  }
  toJSON() {
    return pF(null, this, () => ({ root: DK(hr()) }));
  }
}
class fO extends Eu {
  static getType() {
    return "artificial";
  }
  createDOM(e) {
    return document.createElement("div");
  }
}
class sf extends Eu {
  constructor(e) {
    super(e), this.__textFormat = 0, this.__textStyle = "";
  }
  static getType() {
    return "paragraph";
  }
  getTextFormat() {
    return this.getLatest().__textFormat;
  }
  setTextFormat(e) {
    const n = this.getWritable();
    return n.__textFormat = e, n;
  }
  hasTextFormat(e) {
    const n = Qu[e];
    return !!(this.getTextFormat() & n);
  }
  getTextStyle() {
    return this.getLatest().__textStyle;
  }
  setTextStyle(e) {
    const n = this.getWritable();
    return n.__textStyle = e, n;
  }
  static clone(e) {
    return new sf(e.__key);
  }
  afterCloneFrom(e) {
    super.afterCloneFrom(e), this.__textFormat = e.__textFormat, this.__textStyle = e.__textStyle;
  }
  createDOM(e) {
    const n = document.createElement("p"), r = I0(e.theme, "paragraph");
    return r !== void 0 && n.classList.add(...r), n;
  }
  updateDOM(e, n, r) {
    return !1;
  }
  static importDOM() {
    return { p: (e) => ({ conversion: IXe, priority: 0 }) };
  }
  exportDOM(e) {
    const { element: n } = super.exportDOM(e);
    if (n && gu(n)) {
      this.isEmpty() && n.append(document.createElement("br"));
      const r = this.getFormatType();
      n.style.textAlign = r;
      const i = this.getDirection();
      i && (n.dir = i);
      const o = this.getIndent();
      o > 0 && (n.style.textIndent = 20 * o + "px");
    }
    return { element: n };
  }
  static importJSON(e) {
    const n = Sr();
    return n.setFormat(e.format), n.setIndent(e.indent), n.setDirection(e.direction), n.setTextFormat(e.textFormat), n;
  }
  exportJSON() {
    return { ...super.exportJSON(), textFormat: this.getTextFormat(), textStyle: this.getTextStyle(), type: "paragraph", version: 1 };
  }
  insertNewAfter(e, n) {
    const r = Sr();
    r.setTextFormat(e.format), r.setTextStyle(e.style);
    const i = this.getDirection();
    return r.setDirection(i), r.setFormat(this.getFormatType()), r.setStyle(this.getTextStyle()), this.insertAfter(r, n), r;
  }
  collapseAtStart() {
    const e = this.getChildren();
    if (e.length === 0 || pt(e[0]) && e[0].getTextContent().trim() === "") {
      if (this.getNextSibling() !== null)
        return this.selectNext(), this.remove(), !0;
      if (this.getPreviousSibling() !== null)
        return this.selectPrevious(), this.remove(), !0;
    }
    return !1;
  }
}
function IXe(t) {
  const e = Sr();
  if (t.style) {
    e.setFormat(t.style.textAlign);
    const n = parseInt(t.style.textIndent, 10) / 20;
    n > 0 && e.setIndent(n);
  }
  return { node: e };
}
function Sr() {
  return Qa(new sf());
}
function dp(t) {
  return t instanceof sf;
}
const kn = 0, Ar = 1, _4 = 3, vc = 4;
function MK(t, e, n, r) {
  const i = t._keyToDOMMap;
  i.clear(), t._editorState = dO(), t._pendingEditorState = r, t._compositionKey = null, t._dirtyType = Fd, t._cloneNotNeeded.clear(), t._dirtyLeaves = /* @__PURE__ */ new Set(), t._dirtyElements.clear(), t._normalizedNodes = /* @__PURE__ */ new Set(), t._updateTags = /* @__PURE__ */ new Set(), t._updates = [], t._blockCursorElement = null;
  const o = t._observer;
  o !== null && (o.disconnect(), t._observer = null), e !== null && (e.textContent = ""), n !== null && (n.textContent = "", i.set("root", n));
}
function FK(t) {
  const e = t || {}, n = EXe(), r = e.theme || {}, i = t === void 0 ? n : e.parentEditor || null, o = e.disableEvents || !1, a = dO(), s = e.namespace || (i !== null ? i._config.namespace : aK()), u = e.editorState, l = [xv, Lp, oO, sO, sf, fO, ...e.nodes || []], { onError: c, html: d } = e, f = e.editable === void 0 || e.editable;
  let h;
  if (t === void 0 && n !== null)
    h = n._nodes;
  else {
    h = /* @__PURE__ */ new Map();
    for (let v = 0; v < l.length; v++) {
      let m = l[v], b = null, y = null;
      if (typeof m != "function") {
        const I = m;
        m = I.replace, b = I.with, y = I.withKlass || null;
      }
      const w = m.getType(), S = m.transform(), E = /* @__PURE__ */ new Set();
      S !== null && E.add(S), h.set(w, { exportDOM: d && d.export ? d.export.get(m) : void 0, klass: m, replace: b, replaceWithKlass: y, transforms: E });
    }
  }
  const p = new Ow(a, i, h, { disableEvents: o, namespace: s, theme: r }, c || console.error, function(v, m) {
    const b = /* @__PURE__ */ new Map(), y = /* @__PURE__ */ new Set(), w = (S) => {
      Object.keys(S).forEach((E) => {
        let I = b.get(E);
        I === void 0 && (I = [], b.set(E, I)), I.push(S[E]);
      });
    };
    return v.forEach((S) => {
      const E = S.klass.importDOM;
      if (E == null || y.has(E))
        return;
      y.add(E);
      const I = E.call(S.klass);
      I !== null && w(I);
    }), m && w(m), b;
  }(h, d ? d.import : void 0), f);
  return u !== void 0 && (p._pendingEditorState = u, p._dirtyType = cp), p;
}
class Ow {
  constructor(e, n, r, i, o, a, s) {
    this._parentEditor = n, this._rootElement = null, this._editorState = e, this._pendingEditorState = null, this._compositionKey = null, this._deferred = [], this._keyToDOMMap = /* @__PURE__ */ new Map(), this._updates = [], this._updating = !1, this._listeners = { decorator: /* @__PURE__ */ new Set(), editable: /* @__PURE__ */ new Set(), mutation: /* @__PURE__ */ new Map(), root: /* @__PURE__ */ new Set(), textcontent: /* @__PURE__ */ new Set(), update: /* @__PURE__ */ new Set() }, this._commands = /* @__PURE__ */ new Map(), this._config = i, this._nodes = r, this._decorators = {}, this._pendingDecorators = null, this._dirtyType = Fd, this._cloneNotNeeded = /* @__PURE__ */ new Set(), this._dirtyLeaves = /* @__PURE__ */ new Set(), this._dirtyElements = /* @__PURE__ */ new Map(), this._normalizedNodes = /* @__PURE__ */ new Set(), this._updateTags = /* @__PURE__ */ new Set(), this._observer = null, this._key = aK(), this._onError = o, this._htmlConversions = a, this._editable = s, this._headless = n !== null && n._headless, this._window = null, this._blockCursorElement = null;
  }
  isComposing() {
    return this._compositionKey != null;
  }
  registerUpdateListener(e) {
    const n = this._listeners.update;
    return n.add(e), () => {
      n.delete(e);
    };
  }
  registerEditableListener(e) {
    const n = this._listeners.editable;
    return n.add(e), () => {
      n.delete(e);
    };
  }
  registerDecoratorListener(e) {
    const n = this._listeners.decorator;
    return n.add(e), () => {
      n.delete(e);
    };
  }
  registerTextContentListener(e) {
    const n = this._listeners.textcontent;
    return n.add(e), () => {
      n.delete(e);
    };
  }
  registerRootListener(e) {
    const n = this._listeners.root;
    return e(this._rootElement, null), n.add(e), () => {
      e(null, this._rootElement), n.delete(e);
    };
  }
  registerCommand(e, n, r) {
    r === void 0 && St(35);
    const i = this._commands;
    i.has(e) || i.set(e, [/* @__PURE__ */ new Set(), /* @__PURE__ */ new Set(), /* @__PURE__ */ new Set(), /* @__PURE__ */ new Set(), /* @__PURE__ */ new Set()]);
    const o = i.get(e);
    o === void 0 && St(36, String(e));
    const a = o[r];
    return a.add(n), () => {
      a.delete(n), o.every((s) => s.size === 0) && i.delete(e);
    };
  }
  registerMutationListener(e, n, r) {
    const i = this.resolveRegisteredNodeAfterReplacements(this.getRegisteredNode(e)).klass, o = this._listeners.mutation;
    o.set(n, i);
    const a = r && r.skipInitialization;
    return a === void 0 || a || this.initializeMutationListener(n, i), () => {
      o.delete(n);
    };
  }
  getRegisteredNode(e) {
    const n = this._nodes.get(e.getType());
    return n === void 0 && St(37, e.name), n;
  }
  resolveRegisteredNodeAfterReplacements(e) {
    for (; e.replaceWithKlass; )
      e = this.getRegisteredNode(e.replaceWithKlass);
    return e;
  }
  initializeMutationListener(e, n) {
    const r = this._editorState, i = uXe(r).get(n.getType());
    if (!i)
      return;
    const o = /* @__PURE__ */ new Map();
    for (const a of i.keys())
      o.set(a, "created");
    o.size > 0 && e(o, { dirtyLeaves: /* @__PURE__ */ new Set(), prevEditorState: r, updateTags: /* @__PURE__ */ new Set(["registerMutationListener"]) });
  }
  registerNodeTransformToKlass(e, n) {
    const r = this.getRegisteredNode(e);
    return r.transforms.add(n), r;
  }
  registerNodeTransform(e, n) {
    const r = this.registerNodeTransformToKlass(e, n), i = [r], o = r.replaceWithKlass;
    if (o != null) {
      const u = this.registerNodeTransformToKlass(o, n);
      i.push(u);
    }
    var a, s;
    return a = this, s = e.getType(), ia(a, () => {
      const u = ml();
      if (u.isEmpty())
        return;
      if (s === "root")
        return void hr().markDirty();
      const l = u._nodeMap;
      for (const [, c] of l)
        c.markDirty();
    }, a._pendingEditorState === null ? { tag: "history-merge" } : void 0), () => {
      i.forEach((u) => u.transforms.delete(n));
    };
  }
  hasNode(e) {
    return this._nodes.has(e.getType());
  }
  hasNodes(e) {
    return e.every(this.hasNode.bind(this));
  }
  dispatchCommand(e, n) {
    return Ot(this, e, n);
  }
  getDecorators() {
    return this._decorators;
  }
  getRootElement() {
    return this._rootElement;
  }
  getKey() {
    return this._key;
  }
  setRootElement(e) {
    const n = this._rootElement;
    if (e !== n) {
      const r = I0(this._config.theme, "root"), i = this._pendingEditorState || this._editorState;
      if (this._rootElement = e, MK(this, n, e, i), n !== null && (this._config.disableEvents || fXe(n), r != null && n.classList.remove(...r)), e !== null) {
        const o = function(s) {
          const u = s.ownerDocument;
          return u && u.defaultView || null;
        }(e), a = e.style;
        a.userSelect = "text", a.whiteSpace = "pre-wrap", a.wordBreak = "break-word", e.setAttribute("data-lexical-editor", "true"), this._window = o, this._dirtyType = cp, QJ(this), this._updateTags.add("history-merge"), Kl(this), this._config.disableEvents || function(s, u) {
          const l = s.ownerDocument, c = d2.get(l);
          (c === void 0 || c < 1) && l.addEventListener("selectionchange", wK), d2.set(l, (c || 0) + 1), s.__lexicalEditor = u;
          const d = CK(s);
          for (let f = 0; f < x4.length; f++) {
            const [h, p] = x4[f], v = typeof p == "function" ? (m) => {
              eF(m) || (QM(m), (u.isEditable() || h === "click") && p(m, u));
            } : (m) => {
              if (eF(m))
                return;
              QM(m);
              const b = u.isEditable();
              switch (h) {
                case "cut":
                  return b && Ot(u, MT, m);
                case "copy":
                  return Ot(u, bw, m);
                case "paste":
                  return b && Ot(u, hv, m);
                case "dragstart":
                  return b && Ot(u, vw, m);
                case "dragover":
                  return b && Ot(u, DT, m);
                case "dragend":
                  return b && Ot(u, TUe, m);
                case "focus":
                  return b && Ot(u, FT, m);
                case "blur":
                  return b && Ot(u, LT, m);
                case "drop":
                  return b && Ot(u, $T, m);
              }
            };
            s.addEventListener(h, v), d.push(() => {
              s.removeEventListener(h, v);
            });
          }
        }(e, this), r != null && e.classList.add(...r);
      } else
        this._editorState = i, this._pendingEditorState = null, this._window = null;
      T0("root", this, !1, e, n);
    }
  }
  getElementByKey(e) {
    return this._keyToDOMMap.get(e) || null;
  }
  getEditorState() {
    return this._editorState;
  }
  setEditorState(e, n) {
    e.isEmpty() && St(38), qJ(this);
    const r = this._pendingEditorState, i = this._updateTags, o = n !== void 0 ? n.tag : null;
    r === null || r.isEmpty() || (o != null && i.add(o), Kl(this)), this._pendingEditorState = e, this._dirtyType = cp, this._dirtyElements.set("root", !1), this._compositionKey = null, o != null && i.add(o), Kl(this);
  }
  parseEditorState(e, n) {
    return function(r, i, o) {
      const a = dO(), s = Ai, u = No, l = Ti, c = i._dirtyElements, d = i._dirtyLeaves, f = i._cloneNotNeeded, h = i._dirtyType;
      i._dirtyElements = /* @__PURE__ */ new Map(), i._dirtyLeaves = /* @__PURE__ */ new Set(), i._cloneNotNeeded = /* @__PURE__ */ new Set(), i._dirtyType = 0, Ai = a, No = !1, Ti = i;
      try {
        const p = i._nodes;
        cO(r.root, p), o && o(), a._readOnly = !0;
      } catch (p) {
        p instanceof Error && i._onError(p);
      } finally {
        i._dirtyElements = c, i._dirtyLeaves = d, i._cloneNotNeeded = f, i._dirtyType = h, Ai = s, No = u, Ti = l;
      }
      return a;
    }(typeof e == "string" ? JSON.parse(e) : e, this, n);
  }
  read(e) {
    return Kl(this), this.getEditorState().read(e, { editor: this });
  }
  update(e, n) {
    ia(this, e, n);
  }
  focus(e, n = {}) {
    const r = this._rootElement;
    r !== null && (r.setAttribute("autocapitalize", "off"), ia(this, () => {
      const i = vt(), o = hr();
      i !== null ? i.dirty = !0 : o.getChildrenSize() !== 0 && (n.defaultSelection === "rootStart" ? o.selectStart() : o.selectEnd());
    }, { onUpdate: () => {
      r.removeAttribute("autocapitalize"), e && e();
    }, tag: "focus" }), this._pendingEditorState === null && r.removeAttribute("autocapitalize"));
  }
  blur() {
    const e = this._rootElement;
    e !== null && e.blur();
    const n = pu(this._window);
    n !== null && n.removeAllRanges();
  }
  isEditable() {
    return this._editable;
  }
  setEditable(e) {
    this._editable !== e && (this._editable = e, T0("editable", this, !0, e));
  }
  toJSON() {
    return { editorState: this._editorState.toJSON() };
  }
}
Ow.version = "0.17.1+prod.esm";
function _Xe(t) {
  return t && t.__esModule && Object.prototype.hasOwnProperty.call(t, "default") ? t.default : t;
}
var LK = _Xe(function(t) {
  const e = new URLSearchParams();
  e.append("code", t);
  for (let n = 1; n < arguments.length; n++)
    e.append("v", arguments[n]);
  throw Error(`Minified Lexical error #${t}; visit https://lexical.dev/docs/error?${e} for the full message or use the non-minified dev environment for full errors and additional helpful warnings.`);
});
const AXe = /* @__PURE__ */ new Map();
function TXe(t) {
  const e = {}, n = t.split(";");
  for (const r of n)
    if (r !== "") {
      const [i, o] = r.split(/:([^]+)/);
      i && o && (e[i.trim()] = o.trim());
    }
  return e;
}
function VK(t, e) {
  const n = t.getStartEndPoints();
  if (e.isSelected(t) && !e.isSegmented() && !e.isToken() && n !== null) {
    const [r, i] = n, o = t.isBackward(), a = r.getNode(), s = i.getNode(), u = e.is(a), l = e.is(s);
    if (u || l) {
      const [c, d] = S4(t), f = a.is(s), h = e.is(o ? s : a), p = e.is(o ? a : s);
      let v, m = 0;
      return f ? (m = c > d ? d : c, v = c > d ? c : d) : h ? (m = o ? d : c, v = void 0) : p && (m = 0, v = o ? c : d), e.__text = e.__text.slice(m, v), e;
    }
  }
  return e;
}
function vF(t) {
  if (t.type === "text")
    return t.offset === t.getNode().getTextContentSize();
  const e = t.getNode();
  return We(e) || LK(177), t.offset === e.getChildrenSize();
}
function OXe(t) {
  const e = t.getStyle(), n = TXe(e);
  AXe.set(e, n);
}
function PXe(t, e) {
  if (t === null)
    return;
  const n = t.getStartEndPoints(), r = n ? n[0] : null;
  if (r !== null && r.key === "root") {
    const a = e(), s = hr(), u = s.getFirstChild();
    return void (u ? u.replace(a, !0) : s.append(a));
  }
  const i = t.getNodes(), o = r !== null && function(a, s) {
    let u = a;
    for (; u !== null && u.getParent() !== null && !s(u); )
      u = u.getParentOrThrow();
    return s(u) ? u : null;
  }(r.getNode(), xF);
  o && i.indexOf(o) === -1 && i.push(o);
  for (let a = 0; a < i.length; a++) {
    const s = i[a];
    if (!xF(s))
      continue;
    We(s) || LK(178);
    const u = e();
    u.setFormat(s.getFormatType()), u.setIndent(s.getIndent()), s.replace(u, !0);
  }
}
function bF(t, e) {
  const n = dm(t.focus, e);
  return fr(n) && !n.isIsolated() || We(n) && !n.isInline() && !n.canBeEmpty();
}
function NXe(t, e, n, r) {
  t.modify(e ? "extend" : "move", n, r);
}
function kXe(t) {
  const e = t.anchor.getNode();
  return (Hi(e) ? e : e.getParentOrThrow()).getDirection() === "rtl";
}
function yF(t, e, n) {
  const r = kXe(t);
  NXe(t, e, n ? !r : r, "character");
}
function xF(t) {
  if (fr(t) || !We(t) || Oi(t))
    return !1;
  const e = t.getFirstChild(), n = e === null || lu(e) || pt(e) || e.isInline();
  return !t.isInline() && t.canBeEmpty() !== !1 && n;
}
function RXe(t) {
  return t && t.__esModule && Object.prototype.hasOwnProperty.call(t, "default") ? t.default : t;
}
var $Xe = RXe(function(t) {
  const e = new URLSearchParams();
  e.append("code", t);
  for (let n = 1; n < arguments.length; n++)
    e.append("v", arguments[n]);
  throw Error(`Minified Lexical error #${t}; visit https://lexical.dev/docs/error?${e} for the full message or use the non-minified dev environment for full errors and additional helpful warnings.`);
});
const hO = typeof window < "u" && window.document !== void 0 && window.document.createElement !== void 0, DXe = hO && "documentMode" in document ? document.documentMode : null, MXe = hO && /^(?!.*Seamonkey)(?=.*Firefox).*/i.test(navigator.userAgent);
!(!hO || !("InputEvent" in window) || DXe) && "getTargetRanges" in new window.InputEvent("input");
function BK(...t) {
  const e = [];
  for (const n of t)
    if (n && typeof n == "string")
      for (const [r] of n.matchAll(/\S+/g))
        e.push(r);
  return e;
}
function xa(...t) {
  return () => {
    for (let e = t.length - 1; e >= 0; e--)
      t[e]();
    t.length = 0;
  };
}
const FXe = MXe;
function uf(t, ...e) {
  const n = BK(...e);
  n.length > 0 && t.classList.add(...n);
}
function pO(t, ...e) {
  const n = BK(...e);
  n.length > 0 && t.classList.remove(...n);
}
function HK(t, e) {
  let n = t;
  for (; n != null; ) {
    if (n instanceof e)
      return n;
    n = n.getParent();
  }
  return null;
}
function WK(t) {
  const e = Hp(t, (n) => We(n) && !n.isInline());
  return We(e) || $Xe(4, t.__key), e;
}
const Hp = (t, e) => {
  let n = t;
  for (; n !== hr() && n != null; ) {
    if (e(n))
      return n;
    n = n.getParent();
  }
  return null;
};
function jK(t) {
  const e = vt() || Vp();
  if (rt(e)) {
    const { focus: n } = e, r = n.getNode(), i = n.offset;
    if (Oi(r)) {
      const o = r.getChildAtIndex(i);
      o == null ? r.append(t) : o.insertBefore(t), t.selectNext();
    } else {
      let o, a;
      pt(r) ? (o = r.getParentOrThrow(), a = r.getIndexWithinParent(), i > 0 && (a += 1, r.splitText(i))) : (o = r, a = i);
      const [, s] = iXe(o, a);
      s.insertBefore(t), s.selectStart();
    }
  } else {
    if (e != null) {
      const r = e.getNodes();
      r[r.length - 1].getTopLevelElementOrThrow().insertAfter(t);
    } else
      hr().append(t);
    const n = Sr();
    t.insertAfter(n), n.select();
  }
  return t.getLatest();
}
function gO(t, e) {
  const n = e();
  return t.replace(n), n.append(t), n;
}
function ql(t, e) {
  return t !== null && Object.getPrototypeOf(t).constructor.name === e.name;
}
function LXe(t, e) {
  const n = [];
  for (let r = 0; r < t.length; r++) {
    const i = e(t[r]);
    i !== null && n.push(i);
  }
  return n;
}
function VXe(t) {
  if (FXe)
    return 1;
  let e = 1;
  for (; t; )
    e *= Number(window.getComputedStyle(t).getPropertyValue("zoom")), t = t.parentElement;
  return e;
}
const Nb = 0, A4 = 1, T4 = 2, gs = 0, BXe = 1, CF = 2, HXe = 3, WXe = 4;
function jXe(t, e, n, r, i) {
  if (t === null || n.size === 0 && r.size === 0 && !i)
    return gs;
  const o = e._selection, a = t._selection;
  if (i)
    return BXe;
  if (!(rt(o) && rt(a) && a.isCollapsed() && o.isCollapsed()))
    return gs;
  const s = function(b, y, w) {
    const S = b._nodeMap, E = [];
    for (const I of y) {
      const _ = S.get(I);
      _ !== void 0 && E.push(_);
    }
    for (const [I, _] of w) {
      if (!_)
        continue;
      const A = S.get(I);
      A === void 0 || Hi(A) || E.push(A);
    }
    return E;
  }(e, n, r);
  if (s.length === 0)
    return gs;
  if (s.length > 1) {
    const b = e._nodeMap, y = b.get(o.anchor.key), w = b.get(a.anchor.key);
    return y && w && !t._nodeMap.has(y.__key) && pt(y) && y.__text.length === 1 && o.anchor.offset === 1 ? CF : gs;
  }
  const u = s[0], l = t._nodeMap.get(u.__key);
  if (!pt(l) || !pt(u) || l.__mode !== u.__mode)
    return gs;
  const c = l.__text, d = u.__text;
  if (c === d)
    return gs;
  const f = o.anchor, h = a.anchor;
  if (f.key !== h.key || f.type !== "text")
    return gs;
  const p = f.offset, v = h.offset, m = d.length - c.length;
  return m === 1 && v === p - 1 ? CF : m === -1 && v === p + 1 ? HXe : m === -1 && v === p ? WXe : gs;
}
function zXe(t, e) {
  let n = Date.now(), r = gs;
  return (i, o, a, s, u, l) => {
    const c = Date.now();
    if (l.has("historic"))
      return r = gs, n = c, T4;
    const d = jXe(i, o, s, u, t.isComposing()), f = (() => {
      const h = a === null || a.editor === t, p = l.has("history-push");
      if (!p && h && l.has("history-merge"))
        return Nb;
      if (i === null)
        return A4;
      const v = o._selection;
      return s.size > 0 || u.size > 0 ? p === !1 && d !== gs && d === r && c < n + e && h || s.size === 1 && function(m, b, y) {
        const w = b._nodeMap.get(m), S = y._nodeMap.get(m), E = b._selection, I = y._selection;
        return !(rt(E) && rt(I) && E.anchor.type === "element" && E.focus.type === "element" && I.anchor.type === "text" && I.focus.type === "text" || !pt(w) || !pt(S) || w.__parent !== S.__parent) && JSON.stringify(b.read(() => w.exportJSON())) === JSON.stringify(y.read(() => S.exportJSON()));
      }(Array.from(s)[0], i, o) ? Nb : A4 : v !== null ? Nb : T4;
    })();
    return n = c, r = d, f;
  };
}
function wF(t) {
  t.undoStack = [], t.redoStack = [], t.current = null;
}
function GXe(t, e, n) {
  const r = zXe(t, n);
  return xa(t.registerCommand(AT, () => (function(o, a) {
    const s = a.redoStack, u = a.undoStack;
    if (u.length !== 0) {
      const l = a.current, c = u.pop();
      l !== null && (s.push(l), o.dispatchCommand(Ab, !0)), u.length === 0 && o.dispatchCommand(Tb, !1), a.current = c || null, c && c.editor.setEditorState(c.editorState, { tag: "historic" });
    }
  }(t, e), !0), kn), t.registerCommand(TT, () => (function(o, a) {
    const s = a.redoStack, u = a.undoStack;
    if (s.length !== 0) {
      const l = a.current;
      l !== null && (u.push(l), o.dispatchCommand(Tb, !0));
      const c = s.pop();
      s.length === 0 && o.dispatchCommand(Ab, !1), a.current = c || null, c && c.editor.setEditorState(c.editorState, { tag: "historic" });
    }
  }(t, e), !0), kn), t.registerCommand(OUe, () => (wF(e), !1), kn), t.registerCommand(PUe, () => (wF(e), t.dispatchCommand(Ab, !1), t.dispatchCommand(Tb, !1), !0), kn), t.registerUpdateListener(({ editorState: o, prevEditorState: a, dirtyLeaves: s, dirtyElements: u, tags: l }) => {
    const c = e.current, d = e.redoStack, f = e.undoStack, h = c === null ? null : c.editorState;
    if (c !== null && o === h)
      return;
    const p = r(a, o, c, s, u, l);
    if (p === A4)
      d.length !== 0 && (e.redoStack = [], t.dispatchCommand(Ab, !1)), c !== null && (f.push({ ...c }), t.dispatchCommand(Tb, !0));
    else if (p === T4)
      return;
    e.current = { editor: t, editorState: o };
  }));
}
function zK() {
  return { current: null, redoStack: [], undoStack: [] };
}
function GK({ delay: t, externalHistoryState: e }) {
  const [n] = Vo();
  return function(r, i, o = 1e3) {
    const a = Rn(() => i || zK(), [i]);
    Re(() => GXe(r, a, o), [o, r, a]);
  }(n, e, t), null;
}
function UXe(t, e) {
  const n = e.body ? e.body.childNodes : [];
  let r = [];
  const i = [];
  for (let o = 0; o < n.length; o++) {
    const a = n[o];
    if (!XK.has(a.nodeName)) {
      const s = YK(a, t, i, !1);
      s !== null && (r = r.concat(s));
    }
  }
  return function(o) {
    for (const a of o)
      a.getNextSibling() instanceof fO && a.insertAfter(mc());
    for (const a of o) {
      const s = a.getChildren();
      for (const u of s)
        a.insertBefore(u);
      a.remove();
    }
  }(i), r;
}
function XXe(t, e) {
  if (typeof document > "u" || typeof window > "u" && global.window === void 0)
    throw new Error("To use $generateHtmlFromNodes in headless mode please initialize a headless browser implementation such as JSDom before calling this function.");
  const n = document.createElement("div"), r = hr().getChildren();
  for (let i = 0; i < r.length; i++)
    UK(t, r[i], n, e);
  return n.innerHTML;
}
function UK(t, e, n, r = null) {
  let i = r === null || e.isSelected(r);
  const o = We(e) && e.excludeFromCopy("html");
  let a = e;
  if (r !== null) {
    let h = iO(e);
    h = pt(h) && r !== null ? VK(r, h) : h, a = h;
  }
  const s = We(a) ? a.getChildren() : [], u = t._nodes.get(a.getType());
  let l;
  l = u && u.exportDOM !== void 0 ? u.exportDOM(t, a) : a.exportDOM(t);
  const { element: c, after: d } = l;
  if (!c)
    return !1;
  const f = document.createDocumentFragment();
  for (let h = 0; h < s.length; h++) {
    const p = s[h], v = UK(t, p, f, r);
    !i && We(e) && v && e.extractWithChild(p, r, "html") && (i = !0);
  }
  if (i && !o) {
    if (gu(c) && c.append(f), n.append(c), d) {
      const h = d.call(a, c);
      h && c.replaceWith(h);
    }
  } else
    n.append(f);
  return i;
}
const XK = /* @__PURE__ */ new Set(["STYLE", "SCRIPT"]);
function YK(t, e, n, r, i = /* @__PURE__ */ new Map(), o) {
  let a = [];
  if (XK.has(t.nodeName))
    return a;
  let s = null;
  const u = function(p, v) {
    const { nodeName: m } = p, b = v._htmlConversions.get(m.toLowerCase());
    let y = null;
    if (b !== void 0)
      for (const w of b) {
        const S = w(p);
        S !== null && (y === null || (y.priority || 0) < (S.priority || 0)) && (y = S);
      }
    return y !== null ? y.conversion : null;
  }(t, e), l = u ? u(t) : null;
  let c = null;
  if (l !== null) {
    c = l.after;
    const p = l.node;
    if (s = Array.isArray(p) ? p[p.length - 1] : p, s !== null) {
      for (const [, v] of i)
        if (s = v(s, o), !s)
          break;
      s && a.push(...Array.isArray(p) ? p : [s]);
    }
    l.forChild != null && i.set(t.nodeName, l.forChild);
  }
  const d = t.childNodes;
  let f = [];
  const h = (s == null || !Oi(s)) && (s != null && f2(s) || r);
  for (let p = 0; p < d.length; p++)
    f.push(...YK(d[p], e, n, h, new Map(i), s));
  return c != null && (f = c(f)), s2(t) && (f = YXe(t, f, h ? () => {
    const p = new fO();
    return n.push(p), p;
  } : Sr)), s == null ? f.length > 0 ? a = a.concat(f) : s2(t) && function(p) {
    return p.nextSibling == null || p.previousSibling == null ? !1 : f4(p.nextSibling) && f4(p.previousSibling);
  }(t) && (a = a.concat(mc())) : We(s) && s.append(...f), a;
}
function YXe(t, e, n) {
  const r = t.style.textAlign, i = [];
  let o = [];
  for (let a = 0; a < e.length; a++) {
    const s = e[a];
    if (f2(s))
      r && !s.getFormat() && s.setFormat(r), i.push(s);
    else if (o.push(s), a === e.length - 1 || a < e.length - 1 && f2(e[a + 1])) {
      const u = n();
      u.setFormat(r), u.append(...o), i.push(u), o = [];
    }
  }
  return i;
}
function ZXe(t) {
  return t && t.__esModule && Object.prototype.hasOwnProperty.call(t, "default") ? t.default : t;
}
var g2 = ZXe(function(t) {
  const e = new URLSearchParams();
  e.append("code", t);
  for (let n = 1; n < arguments.length; n++)
    e.append("v", arguments[n]);
  throw Error(`Minified Lexical error #${t}; visit https://lexical.dev/docs/error?${e} for the full message or use the non-minified dev environment for full errors and additional helpful warnings.`);
});
const JXe = typeof window < "u" && window.document !== void 0 && window.document.createElement !== void 0, ZK = (t) => JXe ? (t || window).getSelection() : null;
function KXe(t, e = vt()) {
  return e == null && g2(166), rt(e) && e.isCollapsed() || e.getNodes().length === 0 ? "" : XXe(t, e);
}
function qXe(t, e = vt()) {
  return e == null && g2(166), rt(e) && e.isCollapsed() || e.getNodes().length === 0 ? null : JSON.stringify(QXe(t, e));
}
function EF(t, e, n) {
  const r = t.getData("application/x-lexical-editor");
  if (r)
    try {
      const a = JSON.parse(r);
      if (a.namespace === n._config.namespace && Array.isArray(a.nodes))
        return SF(n, eYe(a.nodes), e);
    } catch {
    }
  const i = t.getData("text/html");
  if (i)
    try {
      const a = new DOMParser().parseFromString(i, "text/html");
      return SF(n, UXe(n, a), e);
    } catch {
    }
  const o = t.getData("text/plain") || t.getData("text/uri-list");
  if (o != null)
    if (rt(e)) {
      const a = o.split(/(\r?\n|\t)/);
      a[a.length - 1] === "" && a.pop();
      for (let s = 0; s < a.length; s++) {
        const u = vt();
        if (rt(u)) {
          const l = a[s];
          l === `
` || l === `\r
` ? u.insertParagraph() : l === "	" ? u.insertNodes([vv()]) : u.insertText(l);
        }
      }
    } else
      e.insertRawText(o);
}
function SF(t, e, n) {
  t.dispatchCommand(SUe, { nodes: e, selection: n }) || n.insertNodes(e);
}
function JK(t, e, n, r = []) {
  let i = e === null || n.isSelected(e);
  const o = We(n) && n.excludeFromCopy("html");
  let a = n;
  if (e !== null) {
    let l = iO(n);
    l = pt(l) && e !== null ? VK(e, l) : l, a = l;
  }
  const s = We(a) ? a.getChildren() : [], u = function(l) {
    const c = l.exportJSON(), d = l.constructor;
    if (c.type !== d.getType() && g2(58, d.name), We(l)) {
      const f = c.children;
      Array.isArray(f) || g2(59, d.name);
    }
    return c;
  }(a);
  if (pt(a)) {
    const l = a.__text;
    l.length > 0 ? u.text = l : i = !1;
  }
  for (let l = 0; l < s.length; l++) {
    const c = s[l], d = JK(t, e, c, u.children);
    !i && We(n) && d && n.extractWithChild(c, e, "clone") && (i = !0);
  }
  if (i && !o)
    r.push(u);
  else if (Array.isArray(u.children))
    for (let l = 0; l < u.children.length; l++) {
      const c = u.children[l];
      r.push(c);
    }
  return i;
}
function QXe(t, e) {
  const n = [], r = hr().getChildren();
  for (let i = 0; i < r.length; i++)
    JK(t, e, r[i], n);
  return { namespace: t._config.namespace, nodes: n };
}
function eYe(t) {
  const e = [];
  for (let n = 0; n < t.length; n++) {
    const r = t[n], i = SXe(r);
    pt(i) && OXe(i), e.push(i);
  }
  return e;
}
let Bf = null;
async function IF(t, e, n) {
  if (Bf !== null)
    return !1;
  if (e !== null)
    return new Promise((u, l) => {
      t.update(() => {
        u(_F(t, e, n));
      });
    });
  const r = t.getRootElement(), i = t._window == null ? window.document : t._window.document, o = ZK(t._window);
  if (r === null || o === null)
    return !1;
  const a = i.createElement("span");
  a.style.cssText = "position: fixed; top: -1000px;", a.append(i.createTextNode("#")), r.append(a);
  const s = new Range();
  return s.setStart(a, 0), s.setEnd(a, 1), o.removeAllRanges(), o.addRange(s), new Promise((u, l) => {
    const c = t.registerCommand(bw, (d) => (ql(d, ClipboardEvent) && (c(), Bf !== null && (window.clearTimeout(Bf), Bf = null), u(_F(t, d, n))), !0), vc);
    Bf = window.setTimeout(() => {
      c(), Bf = null, u(!1);
    }, 50), i.execCommand("copy"), a.remove();
  });
}
function _F(t, e, n) {
  if (n === void 0) {
    const i = ZK(t._window);
    if (!i)
      return !1;
    const o = i.anchorNode, a = i.focusNode;
    if (o !== null && a !== null && !mv(t, o, a))
      return !1;
    const s = vt();
    if (s === null)
      return !1;
    n = nYe(s);
  }
  e.preventDefault();
  const r = e.clipboardData;
  return r !== null && (rYe(r, n), !0);
}
const tYe = [["text/html", KXe], ["application/x-lexical-editor", qXe]];
function nYe(t = vt()) {
  const e = { "text/plain": t ? t.getTextContent() : "" };
  if (t) {
    const n = aXe();
    for (const [r, i] of tYe) {
      const o = i(n, t);
      o !== null && (e[r] = o);
    }
  }
  return e;
}
function rYe(t, e) {
  for (const n in e) {
    const r = e[n];
    r !== void 0 && t.setData(n, r);
  }
}
function AF(t, e) {
  if (document.caretRangeFromPoint !== void 0) {
    const n = document.caretRangeFromPoint(t, e);
    return n === null ? null : { node: n.startContainer, offset: n.startOffset };
  }
  if (document.caretPositionFromPoint !== "undefined") {
    const n = document.caretPositionFromPoint(t, e);
    return n === null ? null : { node: n.offsetNode, offset: n.offset };
  }
  return null;
}
const Wp = typeof window < "u" && window.document !== void 0 && window.document.createElement !== void 0, iYe = Wp && "documentMode" in document ? document.documentMode : null, oYe = !(!Wp || !("InputEvent" in window) || iYe) && "getTargetRanges" in new window.InputEvent("input"), aYe = Wp && /Version\/[\d.]+.*Safari/.test(navigator.userAgent), sYe = Wp && /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream, uYe = Wp && /^(?=.*Chrome).*/i.test(navigator.userAgent), lYe = Wp && /AppleWebKit\/[\d.]+/.test(navigator.userAgent) && !uYe, TF = gl();
let cYe = class KK extends Eu {
  static getType() {
    return "quote";
  }
  static clone(e) {
    return new KK(e.__key);
  }
  constructor(e) {
    super(e);
  }
  createDOM(e) {
    const n = document.createElement("blockquote");
    return uf(n, e.theme.quote), n;
  }
  updateDOM(e, n) {
    return !1;
  }
  static importDOM() {
    return { blockquote: (e) => ({ conversion: dYe, priority: 0 }) };
  }
  exportDOM(e) {
    const { element: n } = super.exportDOM(e);
    if (n && gu(n)) {
      this.isEmpty() && n.append(document.createElement("br"));
      const r = this.getFormatType();
      n.style.textAlign = r;
      const i = this.getDirection();
      i && (n.dir = i);
    }
    return { element: n };
  }
  static importJSON(e) {
    const n = mO();
    return n.setFormat(e.format), n.setIndent(e.indent), n.setDirection(e.direction), n;
  }
  exportJSON() {
    return { ...super.exportJSON(), type: "quote" };
  }
  insertNewAfter(e, n) {
    const r = Sr(), i = this.getDirection();
    return r.setDirection(i), this.insertAfter(r, n), r;
  }
  collapseAtStart() {
    const e = Sr();
    return this.getChildren().forEach((n) => e.append(n)), this.replace(e), !0;
  }
  canMergeWhenEmpty() {
    return !0;
  }
};
function mO() {
  return Qa(new cYe());
}
let vO = class qK extends Eu {
  static getType() {
    return "heading";
  }
  static clone(e) {
    return new qK(e.__tag, e.__key);
  }
  constructor(e, n) {
    super(n), this.__tag = e;
  }
  getTag() {
    return this.__tag;
  }
  createDOM(e) {
    const n = this.__tag, r = document.createElement(n), i = e.theme.heading;
    if (i !== void 0) {
      const o = i[n];
      uf(r, o);
    }
    return r;
  }
  updateDOM(e, n) {
    return !1;
  }
  static importDOM() {
    return { h1: (e) => ({ conversion: Hf, priority: 0 }), h2: (e) => ({ conversion: Hf, priority: 0 }), h3: (e) => ({ conversion: Hf, priority: 0 }), h4: (e) => ({ conversion: Hf, priority: 0 }), h5: (e) => ({ conversion: Hf, priority: 0 }), h6: (e) => ({ conversion: Hf, priority: 0 }), p: (e) => {
      const n = e.firstChild;
      return n !== null && OF(n) ? { conversion: () => ({ node: null }), priority: 3 } : null;
    }, span: (e) => OF(e) ? { conversion: (n) => ({ node: Ql("h1") }), priority: 3 } : null };
  }
  exportDOM(e) {
    const { element: n } = super.exportDOM(e);
    if (n && gu(n)) {
      this.isEmpty() && n.append(document.createElement("br"));
      const r = this.getFormatType();
      n.style.textAlign = r;
      const i = this.getDirection();
      i && (n.dir = i);
    }
    return { element: n };
  }
  static importJSON(e) {
    const n = Ql(e.tag);
    return n.setFormat(e.format), n.setIndent(e.indent), n.setDirection(e.direction), n;
  }
  exportJSON() {
    return { ...super.exportJSON(), tag: this.getTag(), type: "heading", version: 1 };
  }
  insertNewAfter(e, n = !0) {
    const r = e ? e.anchor.offset : 0, i = this.getLastDescendant(), o = !i || e && e.anchor.key === i.getKey() && r === i.getTextContentSize() || !e ? Sr() : Ql(this.getTag()), a = this.getDirection();
    if (o.setDirection(a), this.insertAfter(o, n), r === 0 && !this.isEmpty() && e) {
      const s = Sr();
      s.select(), this.replace(s, !0);
    }
    return o;
  }
  collapseAtStart() {
    const e = this.isEmpty() ? Sr() : Ql(this.getTag());
    return this.getChildren().forEach((n) => e.append(n)), this.replace(e), !0;
  }
  extractWithChild() {
    return !0;
  }
};
function OF(t) {
  return t.nodeName.toLowerCase() === "span" && t.style.fontSize === "26pt";
}
function Hf(t) {
  const e = t.nodeName.toLowerCase();
  let n = null;
  return e !== "h1" && e !== "h2" && e !== "h3" && e !== "h4" && e !== "h5" && e !== "h6" || (n = Ql(e), t.style !== null && n.setFormat(t.style.textAlign)), { node: n };
}
function dYe(t) {
  const e = mO();
  return t.style !== null && e.setFormat(t.style.textAlign), { node: e };
}
function Ql(t) {
  return Qa(new vO(t));
}
function QK(t) {
  return t instanceof vO;
}
function kb(t) {
  let e = null;
  if (ql(t, DragEvent) ? e = t.dataTransfer : ql(t, ClipboardEvent) && (e = t.clipboardData), e === null)
    return [!1, [], !1];
  const n = e.types, r = n.includes("Files"), i = n.includes("text/html") || n.includes("text/plain");
  return [r, Array.from(e.files), i];
}
function PF(t) {
  const e = vt();
  if (!rt(e))
    return !1;
  const n = /* @__PURE__ */ new Set(), r = e.getNodes();
  for (let i = 0; i < r.length; i++) {
    const o = r[i], a = o.getKey();
    if (n.has(a))
      continue;
    const s = Hp(o, (l) => We(l) && !l.isInline());
    if (s === null)
      continue;
    const u = s.getKey();
    s.canIndent() && !n.has(u) && (n.add(u), t(s));
  }
  return n.size > 0;
}
function Rb(t) {
  const e = hu(t);
  return fr(e);
}
function fYe(t) {
  return xa(t.registerCommand(pw, (e) => {
    const n = vt();
    return !!li(n) && (n.clear(), !0);
  }, 0), t.registerCommand(Ed, (e) => {
    const n = vt();
    return !!rt(n) && (n.deleteCharacter(e), !0);
  }, kn), t.registerCommand(lm, (e) => {
    const n = vt();
    return !!rt(n) && (n.deleteWord(e), !0);
  }, kn), t.registerCommand(cm, (e) => {
    const n = vt();
    return !!rt(n) && (n.deleteLine(e), !0);
  }, kn), t.registerCommand(Gh, (e) => {
    const n = vt();
    if (typeof e == "string")
      n !== null && n.insertText(e);
    else {
      if (n === null)
        return !1;
      const r = e.dataTransfer;
      if (r != null)
        EF(r, n, t);
      else if (rt(n)) {
        const i = e.data;
        return i && n.insertText(i), !0;
      }
    }
    return !0;
  }, kn), t.registerCommand(a4, () => {
    const e = vt();
    return !!rt(e) && (e.removeText(), !0);
  }, kn), t.registerCommand(Ku, (e) => {
    const n = vt();
    return !!rt(n) && (n.formatText(e), !0);
  }, kn), t.registerCommand(AUe, (e) => {
    const n = vt();
    if (!rt(n) && !li(n))
      return !1;
    const r = n.getNodes();
    for (const i of r) {
      const o = Hp(i, (a) => We(a) && !a.isInline());
      o !== null && o.setFormat(e);
    }
    return !0;
  }, kn), t.registerCommand(zh, (e) => {
    const n = vt();
    return !!rt(n) && (n.insertLineBreak(e), !0);
  }, kn), t.registerCommand(um, () => {
    const e = vt();
    return !!rt(e) && (e.insertParagraph(), !0);
  }, kn), t.registerCommand(GJ, () => (Bp([vv()]), !0), kn), t.registerCommand(RT, () => PF((e) => {
    const n = e.getIndent();
    e.setIndent(n + 1);
  }), kn), t.registerCommand(s4, () => PF((e) => {
    const n = e.getIndent();
    n > 0 && e.setIndent(n - 1);
  }), kn), t.registerCommand(PT, (e) => {
    const n = vt();
    if (li(n) && !Rb(e.target)) {
      const r = n.getNodes();
      if (r.length > 0)
        return r[0].selectPrevious(), !0;
    } else if (rt(n)) {
      const r = dm(n.focus, !0);
      if (!e.shiftKey && fr(r) && !r.isIsolated() && !r.isInline())
        return r.selectPrevious(), e.preventDefault(), !0;
    }
    return !1;
  }, kn), t.registerCommand(NT, (e) => {
    const n = vt();
    if (li(n)) {
      const r = n.getNodes();
      if (r.length > 0)
        return r[0].selectNext(0, 0), !0;
    } else if (rt(n)) {
      if (function(i) {
        const o = i.focus;
        return o.key === "root" && o.offset === hr().getChildrenSize();
      }(n))
        return e.preventDefault(), !0;
      const r = dm(n.focus, !1);
      if (!e.shiftKey && fr(r) && !r.isIsolated() && !r.isInline())
        return r.selectNext(), e.preventDefault(), !0;
    }
    return !1;
  }, kn), t.registerCommand(OT, (e) => {
    const n = vt();
    if (li(n)) {
      const r = n.getNodes();
      if (r.length > 0)
        return e.preventDefault(), r[0].selectPrevious(), !0;
    }
    if (!rt(n))
      return !1;
    if (bF(n, !0)) {
      const r = e.shiftKey;
      return e.preventDefault(), yF(n, r, !0), !0;
    }
    return !1;
  }, kn), t.registerCommand(jJ, (e) => {
    const n = vt();
    if (li(n) && !Rb(e.target)) {
      const i = n.getNodes();
      if (i.length > 0)
        return e.preventDefault(), i[0].selectNext(0, 0), !0;
    }
    if (!rt(n))
      return !1;
    const r = e.shiftKey;
    return !!bF(n, !1) && (e.preventDefault(), yF(n, r, !1), !0);
  }, kn), t.registerCommand(gw, (e) => {
    if (Rb(e.target))
      return !1;
    const n = vt();
    if (!rt(n))
      return !1;
    e.preventDefault();
    const { anchor: r } = n, i = r.getNode();
    return n.isCollapsed() && r.offset === 0 && !Hi(i) && WK(i).getIndent() > 0 ? t.dispatchCommand(s4, void 0) : t.dispatchCommand(Ed, !0);
  }, kn), t.registerCommand(mw, (e) => {
    if (Rb(e.target))
      return !1;
    const n = vt();
    return !!rt(n) && (e.preventDefault(), t.dispatchCommand(Ed, !1));
  }, kn), t.registerCommand(lp, (e) => {
    const n = vt();
    if (!rt(n))
      return !1;
    if (e !== null) {
      if ((sYe || aYe || lYe) && oYe)
        return !1;
      if (e.preventDefault(), e.shiftKey)
        return t.dispatchCommand(zh, !1);
    }
    return t.dispatchCommand(um, void 0);
  }, kn), t.registerCommand(pv, () => {
    const e = vt();
    return !!rt(e) && (t.blur(), !0);
  }, kn), t.registerCommand($T, (e) => {
    const [, n] = kb(e);
    if (n.length > 0) {
      const i = AF(e.clientX, e.clientY);
      if (i !== null) {
        const { offset: o, node: a } = i, s = hu(a);
        if (s !== null) {
          const u = uO();
          if (pt(s))
            u.anchor.set(s.getKey(), o, "text"), u.focus.set(s.getKey(), o, "text");
          else {
            const c = s.getParentOrThrow().getKey(), d = s.getIndexWithinParent() + 1;
            u.anchor.set(c, d, "element"), u.focus.set(c, d, "element");
          }
          const l = ZT(u);
          uo(l);
        }
        t.dispatchCommand(TF, n);
      }
      return e.preventDefault(), !0;
    }
    const r = vt();
    return !!rt(r);
  }, kn), t.registerCommand(vw, (e) => {
    const [n] = kb(e), r = vt();
    return !(n && !rt(r));
  }, kn), t.registerCommand(DT, (e) => {
    const [n] = kb(e), r = vt();
    if (n && !rt(r))
      return !1;
    const i = AF(e.clientX, e.clientY);
    if (i !== null) {
      const o = hu(i.node);
      fr(o) && e.preventDefault();
    }
    return !0;
  }, kn), t.registerCommand(u4, () => (eXe(), !0), kn), t.registerCommand(bw, (e) => (IF(t, ql(e, ClipboardEvent) ? e : null), !0), kn), t.registerCommand(MT, (e) => (async function(n, r) {
    await IF(r, ql(n, ClipboardEvent) ? n : null), r.update(() => {
      const i = vt();
      rt(i) ? i.removeText() : li(i) && i.getNodes().forEach((o) => o.remove());
    });
  }(e, t), !0), kn), t.registerCommand(hv, (e) => {
    const [, n, r] = kb(e);
    return n.length > 0 && !r ? (t.dispatchCommand(TF, n), !0) : JT(e.target) ? !1 : vt() !== null && (function(i, o) {
      i.preventDefault(), o.update(() => {
        const a = vt(), s = ql(i, InputEvent) || ql(i, KeyboardEvent) ? null : i.clipboardData;
        s != null && a !== null && EF(s, a, o);
      }, { tag: "paste" });
    }(e, t), !0);
  }, kn));
}
function la(t, e, n, r) {
  const i = t.length;
  let o = 0, a;
  if (e < 0 ? e = -e > i ? 0 : i + e : e = e > i ? i : e, n = n > 0 ? n : 0, r.length < 1e4)
    a = Array.from(r), a.unshift(e, n), t.splice(...a);
  else
    for (n && t.splice(e, n); o < r.length; )
      a = r.slice(o, o + 1e4), a.unshift(e, 0), t.splice(...a), o += 1e4, e += 1e4;
}
function Ba(t, e) {
  return t.length > 0 ? (la(t, t.length, 0, e), t) : e;
}
const hYe = $c(new RegExp("\\p{P}", "u")), qs = $c(/[A-Za-z]/), Ps = $c(/[\dA-Za-z]/), pYe = $c(/[#-'*+\--9=?A-Z^-~]/);
function O4(t) {
  return (
    // Special whitespace codes (which have negative values), C0 and Control
    // character DEL
    t !== null && (t < 32 || t === 127)
  );
}
const P4 = $c(/\d/), gYe = $c(/[\dA-Fa-f]/), eq = $c(/[!-/:-@[-`{-~]/);
function Dt(t) {
  return t !== null && t < -2;
}
function Br(t) {
  return t !== null && (t < 0 || t === 32);
}
function Cn(t) {
  return t === -2 || t === -1 || t === 32;
}
function mYe(t) {
  return eq(t) || hYe(t);
}
const Wu = $c(/\s/);
function $c(t) {
  return e;
  function e(n) {
    return n !== null && n > -1 && t.test(String.fromCharCode(n));
  }
}
function m2(t) {
  if (t === null || Br(t) || Wu(t))
    return 1;
  if (mYe(t))
    return 2;
}
function Pw(t, e, n) {
  const r = [];
  let i = -1;
  for (; ++i < t.length; ) {
    const o = t[i].resolveAll;
    o && !r.includes(o) && (e = o(e, n), r.push(o));
  }
  return e;
}
function vYe(t) {
  let n = (t || {}).singleTilde;
  const r = {
    name: "strikethrough",
    tokenize: o,
    resolveAll: i
  };
  return n == null && (n = !0), {
    text: {
      126: r
    },
    insideSpan: {
      null: [r]
    },
    attentionMarkers: {
      null: [126]
    }
  };
  function i(a, s) {
    let u = -1;
    for (; ++u < a.length; )
      if (a[u][0] === "enter" && a[u][1].type === "strikethroughSequenceTemporary" && a[u][1]._close) {
        let l = u;
        for (; l--; )
          if (a[l][0] === "exit" && a[l][1].type === "strikethroughSequenceTemporary" && a[l][1]._open && // If the sizes are the same:
          a[u][1].end.offset - a[u][1].start.offset === a[l][1].end.offset - a[l][1].start.offset) {
            a[u][1].type = "strikethroughSequence", a[l][1].type = "strikethroughSequence";
            const c = {
              type: "strikethrough",
              start: Object.assign({}, a[l][1].start),
              end: Object.assign({}, a[u][1].end)
            }, d = {
              type: "strikethroughText",
              start: Object.assign({}, a[l][1].end),
              end: Object.assign({}, a[u][1].start)
            }, f = [["enter", c, s], ["enter", a[l][1], s], ["exit", a[l][1], s], ["enter", d, s]], h = s.parser.constructs.insideSpan.null;
            h && la(f, f.length, 0, Pw(h, a.slice(l + 1, u), s)), la(f, f.length, 0, [["exit", d, s], ["enter", a[u][1], s], ["exit", a[u][1], s], ["exit", c, s]]), la(a, l - 1, u - l + 3, f), u = l + f.length - 2;
            break;
          }
      }
    for (u = -1; ++u < a.length; )
      a[u][1].type === "strikethroughSequenceTemporary" && (a[u][1].type = "data");
    return a;
  }
  function o(a, s, u) {
    const l = this.previous, c = this.events;
    let d = 0;
    return f;
    function f(p) {
      return l === 126 && c[c.length - 1][1].type !== "characterEscape" ? u(p) : (a.enter("strikethroughSequenceTemporary"), h(p));
    }
    function h(p) {
      const v = m2(l);
      if (p === 126)
        return d > 1 ? u(p) : (a.consume(p), d++, h);
      if (d < 2 && !n)
        return u(p);
      const m = a.exit("strikethroughSequenceTemporary"), b = m2(p);
      return m._open = !b || b === 2 && !!v, m._close = !v || v === 2 && !!b, s(p);
    }
  }
}
const bYe = [
  "autolink",
  "destinationLiteral",
  "destinationRaw",
  "reference",
  "titleQuote",
  "titleApostrophe"
];
tq.peek = EYe;
function yYe() {
  return {
    canContainEols: ["delete"],
    enter: { strikethrough: CYe },
    exit: { strikethrough: wYe }
  };
}
function xYe() {
  return {
    unsafe: [
      {
        character: "~",
        inConstruct: "phrasing",
        notInConstruct: bYe
      }
    ],
    handlers: { delete: tq }
  };
}
function CYe(t) {
  this.enter({ type: "delete", children: [] }, t);
}
function wYe(t) {
  this.exit(t);
}
function tq(t, e, n, r) {
  const i = n.createTracker(r), o = n.enter("strikethrough");
  let a = i.move("~~");
  return a += n.containerPhrasing(t, {
    ...i.current(),
    before: a,
    after: "~"
  }), a += i.move("~~"), o(), a;
}
function EYe() {
  return "~";
}
function NF(t, e) {
  const n = String(t);
  if (typeof e != "string")
    throw new TypeError("Expected character");
  let r = 0, i = n.indexOf(e);
  for (; i !== -1; )
    r++, i = n.indexOf(e, i + e.length);
  return r;
}
const SYe = [
  "AElig",
  "AMP",
  "Aacute",
  "Acirc",
  "Agrave",
  "Aring",
  "Atilde",
  "Auml",
  "COPY",
  "Ccedil",
  "ETH",
  "Eacute",
  "Ecirc",
  "Egrave",
  "Euml",
  "GT",
  "Iacute",
  "Icirc",
  "Igrave",
  "Iuml",
  "LT",
  "Ntilde",
  "Oacute",
  "Ocirc",
  "Ograve",
  "Oslash",
  "Otilde",
  "Ouml",
  "QUOT",
  "REG",
  "THORN",
  "Uacute",
  "Ucirc",
  "Ugrave",
  "Uuml",
  "Yacute",
  "aacute",
  "acirc",
  "acute",
  "aelig",
  "agrave",
  "amp",
  "aring",
  "atilde",
  "auml",
  "brvbar",
  "ccedil",
  "cedil",
  "cent",
  "copy",
  "curren",
  "deg",
  "divide",
  "eacute",
  "ecirc",
  "egrave",
  "eth",
  "euml",
  "frac12",
  "frac14",
  "frac34",
  "gt",
  "iacute",
  "icirc",
  "iexcl",
  "igrave",
  "iquest",
  "iuml",
  "laquo",
  "lt",
  "macr",
  "micro",
  "middot",
  "nbsp",
  "not",
  "ntilde",
  "oacute",
  "ocirc",
  "ograve",
  "ordf",
  "ordm",
  "oslash",
  "otilde",
  "ouml",
  "para",
  "plusmn",
  "pound",
  "quot",
  "raquo",
  "reg",
  "sect",
  "shy",
  "sup1",
  "sup2",
  "sup3",
  "szlig",
  "thorn",
  "times",
  "uacute",
  "ucirc",
  "ugrave",
  "uml",
  "uuml",
  "yacute",
  "yen",
  "yuml"
], kF = {
  0: "�",
  128: "€",
  130: "‚",
  131: "ƒ",
  132: "„",
  133: "…",
  134: "†",
  135: "‡",
  136: "ˆ",
  137: "‰",
  138: "Š",
  139: "‹",
  140: "Œ",
  142: "Ž",
  145: "‘",
  146: "’",
  147: "“",
  148: "”",
  149: "•",
  150: "–",
  151: "—",
  152: "˜",
  153: "™",
  154: "š",
  155: "›",
  156: "œ",
  158: "ž",
  159: "Ÿ"
};
function nq(t) {
  const e = typeof t == "string" ? t.charCodeAt(0) : t;
  return e >= 48 && e <= 57;
}
function IYe(t) {
  const e = typeof t == "string" ? t.charCodeAt(0) : t;
  return e >= 97 && e <= 102 || e >= 65 && e <= 70 || e >= 48 && e <= 57;
}
function _Ye(t) {
  const e = typeof t == "string" ? t.charCodeAt(0) : t;
  return e >= 97 && e <= 122 || e >= 65 && e <= 90;
}
function RF(t) {
  return _Ye(t) || nq(t);
}
const $F = document.createElement("i");
function gm(t) {
  const e = "&" + t + ";";
  $F.innerHTML = e;
  const n = $F.textContent;
  return n.charCodeAt(n.length - 1) === 59 && t !== "semi" || n === e ? !1 : n;
}
const Wf = String.fromCharCode, AYe = [
  "",
  /* 1: Non terminated (named) */
  "Named character references must be terminated by a semicolon",
  /* 2: Non terminated (numeric) */
  "Numeric character references must be terminated by a semicolon",
  /* 3: Empty (named) */
  "Named character references cannot be empty",
  /* 4: Empty (numeric) */
  "Numeric character references cannot be empty",
  /* 5: Unknown (named) */
  "Named character references must be known",
  /* 6: Disallowed (numeric) */
  "Numeric character references cannot be disallowed",
  /* 7: Prohibited (numeric) */
  "Numeric character references cannot be outside the permissible Unicode range"
];
function TYe(t, e = {}) {
  const n = typeof e.additional == "string" ? e.additional.charCodeAt(0) : e.additional, r = [];
  let i = 0, o = -1, a = "", s, u;
  e.position && ("start" in e.position || "indent" in e.position ? (u = e.position.indent, s = e.position.start) : s = e.position);
  let l = (s ? s.line : 0) || 1, c = (s ? s.column : 0) || 1, d = h(), f;
  for (i--; ++i <= t.length; )
    if (f === 10 && (c = (u ? u[o] : 0) || 1), f = t.charCodeAt(i), f === 38) {
      const m = t.charCodeAt(i + 1);
      if (m === 9 || m === 10 || m === 12 || m === 32 || m === 38 || m === 60 || Number.isNaN(m) || n && m === n) {
        a += Wf(f), c++;
        continue;
      }
      const b = i + 1;
      let y = b, w = b, S;
      if (m === 35) {
        w = ++y;
        const D = t.charCodeAt(w);
        D === 88 || D === 120 ? (S = "hexadecimal", w = ++y) : S = "decimal";
      } else
        S = "named";
      let E = "", I = "", _ = "";
      const A = S === "named" ? RF : S === "decimal" ? nq : IYe;
      for (w--; ++w <= t.length; ) {
        const D = t.charCodeAt(w);
        if (!A(D))
          break;
        _ += Wf(D), S === "named" && SYe.includes(_) && (E = _, I = gm(_));
      }
      let P = t.charCodeAt(w) === 59;
      if (P) {
        w++;
        const D = S === "named" ? gm(_) : !1;
        D && (E = _, I = D);
      }
      let N = 1 + w - b, k = "";
      if (!(!P && e.nonTerminated === !1))
        if (!_)
          S !== "named" && p(4, N);
        else if (S === "named") {
          if (P && !I)
            p(5, 1);
          else if (E !== _ && (w = y + E.length, N = 1 + w - y, P = !1), !P) {
            const D = E ? 1 : 3;
            if (e.attribute) {
              const R = t.charCodeAt(w);
              R === 61 ? (p(D, N), I = "") : RF(R) ? I = "" : p(D, N);
            } else
              p(D, N);
          }
          k = I;
        } else {
          P || p(2, N);
          let D = Number.parseInt(
            _,
            S === "hexadecimal" ? 16 : 10
          );
          if (OYe(D))
            p(7, N), k = Wf(
              65533
              /* `�` */
            );
          else if (D in kF)
            p(6, N), k = kF[D];
          else {
            let R = "";
            PYe(D) && p(6, N), D > 65535 && (D -= 65536, R += Wf(D >>> 10 | 55296), D = 56320 | D & 1023), k = R + Wf(D);
          }
        }
      if (k) {
        v(), d = h(), i = w - 1, c += w - b + 1, r.push(k);
        const D = h();
        D.offset++, e.reference && e.reference.call(
          e.referenceContext,
          k,
          { start: d, end: D },
          t.slice(b - 1, w)
        ), d = D;
      } else
        _ = t.slice(b - 1, w), a += _, c += _.length, i = w - 1;
    } else
      f === 10 && (l++, o++, c = 0), Number.isNaN(f) ? v() : (a += Wf(f), c++);
  return r.join("");
  function h() {
    return {
      line: l,
      column: c,
      offset: i + ((s ? s.offset : 0) || 0)
    };
  }
  function p(m, b) {
    let y;
    e.warning && (y = h(), y.column += b, y.offset += b, e.warning.call(
      e.warningContext,
      AYe[m],
      y,
      m
    ));
  }
  function v() {
    a && (r.push(a), e.text && e.text.call(e.textContext, a, {
      start: d,
      end: h()
    }), a = "");
  }
}
function OYe(t) {
  return t >= 55296 && t <= 57343 || t > 1114111;
}
function PYe(t) {
  return t >= 1 && t <= 8 || t === 11 || t >= 13 && t <= 31 || t >= 127 && t <= 159 || t >= 64976 && t <= 65007 || (t & 65535) === 65535 || (t & 65535) === 65534;
}
function NYe(t, e) {
  if (t = t.replace(
    e.subset ? kYe(e.subset) : /["&'<>`]/g,
    r
  ), e.subset || e.escapeOnly)
    return t;
  return t.replace(/[\uD800-\uDBFF][\uDC00-\uDFFF]/g, n).replace(
    // eslint-disable-next-line no-control-regex, unicorn/no-hex-escape
    /[\x01-\t\v\f\x0E-\x1F\x7F\x81\x8D\x8F\x90\x9D\xA0-\uFFFF]/g,
    r
  );
  function n(i, o, a) {
    return e.format(
      (i.charCodeAt(0) - 55296) * 1024 + i.charCodeAt(1) - 56320 + 65536,
      a.charCodeAt(o + 2),
      e
    );
  }
  function r(i, o, a) {
    return e.format(
      i.charCodeAt(0),
      a.charCodeAt(o + 1),
      e
    );
  }
}
function kYe(t) {
  const e = [];
  let n = -1;
  for (; ++n < t.length; )
    e.push(t[n].replace(/[|\\{}()[\]^$+*?.]/g, "\\$&"));
  return new RegExp("(?:" + e.join("|") + ")", "g");
}
function RYe(t) {
  return "&#x" + t.toString(16).toUpperCase() + ";";
}
function $Ye(t, e) {
  return NYe(t, Object.assign({ format: RYe }, e));
}
function qu(t) {
  return !t || typeof t != "object" ? "" : "position" in t || "type" in t ? DF(t.position) : "start" in t || "end" in t ? DF(t) : "line" in t || "column" in t ? N4(t) : "";
}
function N4(t) {
  return MF(t && t.line) + ":" + MF(t && t.column);
}
function DF(t) {
  return N4(t && t.start) + "-" + N4(t && t.end);
}
function MF(t) {
  return t && typeof t == "number" ? t : 1;
}
class Er extends Error {
  /**
   * Create a message for `reason`.
   *
   * > 🪦 **Note**: also has obsolete signatures.
   *
   * @overload
   * @param {string} reason
   * @param {Options | null | undefined} [options]
   * @returns
   *
   * @overload
   * @param {string} reason
   * @param {Node | NodeLike | null | undefined} parent
   * @param {string | null | undefined} [origin]
   * @returns
   *
   * @overload
   * @param {string} reason
   * @param {Point | Position | null | undefined} place
   * @param {string | null | undefined} [origin]
   * @returns
   *
   * @overload
   * @param {string} reason
   * @param {string | null | undefined} [origin]
   * @returns
   *
   * @overload
   * @param {Error | VFileMessage} cause
   * @param {Node | NodeLike | null | undefined} parent
   * @param {string | null | undefined} [origin]
   * @returns
   *
   * @overload
   * @param {Error | VFileMessage} cause
   * @param {Point | Position | null | undefined} place
   * @param {string | null | undefined} [origin]
   * @returns
   *
   * @overload
   * @param {Error | VFileMessage} cause
   * @param {string | null | undefined} [origin]
   * @returns
   *
   * @param {Error | VFileMessage | string} causeOrReason
   *   Reason for message, should use markdown.
   * @param {Node | NodeLike | Options | Point | Position | string | null | undefined} [optionsOrParentOrPlace]
   *   Configuration (optional).
   * @param {string | null | undefined} [origin]
   *   Place in code where the message originates (example:
   *   `'my-package:my-rule'` or `'my-rule'`).
   * @returns
   *   Instance of `VFileMessage`.
   */
  // eslint-disable-next-line complexity
  constructor(e, n, r) {
    super(), typeof n == "string" && (r = n, n = void 0);
    let i = "", o = {}, a = !1;
    if (n && ("line" in n && "column" in n ? o = { place: n } : "start" in n && "end" in n ? o = { place: n } : "type" in n ? o = {
      ancestors: [n],
      place: n.position
    } : o = { ...n }), typeof e == "string" ? i = e : !o.cause && e && (a = !0, i = e.message, o.cause = e), !o.ruleId && !o.source && typeof r == "string") {
      const u = r.indexOf(":");
      u === -1 ? o.ruleId = r : (o.source = r.slice(0, u), o.ruleId = r.slice(u + 1));
    }
    if (!o.place && o.ancestors && o.ancestors) {
      const u = o.ancestors[o.ancestors.length - 1];
      u && (o.place = u.position);
    }
    const s = o.place && "start" in o.place ? o.place.start : o.place;
    this.ancestors = o.ancestors || void 0, this.cause = o.cause || void 0, this.column = s ? s.column : void 0, this.fatal = void 0, this.file, this.message = i, this.line = s ? s.line : void 0, this.name = qu(o.place) || "1:1", this.place = o.place || void 0, this.reason = this.message, this.ruleId = o.ruleId || void 0, this.source = o.source || void 0, this.stack = a && o.cause && typeof o.cause.stack == "string" ? o.cause.stack : "", this.actual, this.expected, this.note, this.url;
  }
}
Er.prototype.file = "";
Er.prototype.name = "";
Er.prototype.reason = "";
Er.prototype.message = "";
Er.prototype.stack = "";
Er.prototype.column = void 0;
Er.prototype.line = void 0;
Er.prototype.ancestors = void 0;
Er.prototype.cause = void 0;
Er.prototype.fatal = void 0;
Er.prototype.place = void 0;
Er.prototype.ruleId = void 0;
Er.prototype.source = void 0;
const rq = "  ";
function DYe() {
  return {
    canContainEols: ["mdxJsxTextElement"],
    enter: {
      mdxJsxFlowTag: n,
      mdxJsxFlowTagClosingMarker: r,
      mdxJsxFlowTagAttribute: c,
      mdxJsxFlowTagExpressionAttribute: d,
      mdxJsxFlowTagAttributeValueLiteral: t,
      mdxJsxFlowTagAttributeValueExpression: t,
      mdxJsxFlowTagSelfClosingMarker: o,
      mdxJsxTextTag: n,
      mdxJsxTextTagClosingMarker: r,
      mdxJsxTextTagAttribute: c,
      mdxJsxTextTagExpressionAttribute: d,
      mdxJsxTextTagAttributeValueLiteral: t,
      mdxJsxTextTagAttributeValueExpression: t,
      mdxJsxTextTagSelfClosingMarker: o
    },
    exit: {
      mdxJsxFlowTagClosingMarker: a,
      mdxJsxFlowTagNamePrimary: s,
      mdxJsxFlowTagNameMember: u,
      mdxJsxFlowTagNameLocal: l,
      mdxJsxFlowTagExpressionAttribute: f,
      mdxJsxFlowTagExpressionAttributeValue: e,
      mdxJsxFlowTagAttributeNamePrimary: h,
      mdxJsxFlowTagAttributeNameLocal: p,
      mdxJsxFlowTagAttributeValueLiteral: v,
      mdxJsxFlowTagAttributeValueLiteralValue: e,
      mdxJsxFlowTagAttributeValueExpression: m,
      mdxJsxFlowTagAttributeValueExpressionValue: e,
      mdxJsxFlowTagSelfClosingMarker: b,
      mdxJsxFlowTag: y,
      mdxJsxTextTagClosingMarker: a,
      mdxJsxTextTagNamePrimary: s,
      mdxJsxTextTagNameMember: u,
      mdxJsxTextTagNameLocal: l,
      mdxJsxTextTagExpressionAttribute: f,
      mdxJsxTextTagExpressionAttributeValue: e,
      mdxJsxTextTagAttributeNamePrimary: h,
      mdxJsxTextTagAttributeNameLocal: p,
      mdxJsxTextTagAttributeValueLiteral: v,
      mdxJsxTextTagAttributeValueLiteralValue: e,
      mdxJsxTextTagAttributeValueExpression: m,
      mdxJsxTextTagAttributeValueExpressionValue: e,
      mdxJsxTextTagSelfClosingMarker: b,
      mdxJsxTextTag: y
    }
  };
  function t() {
    this.buffer();
  }
  function e(I) {
    this.config.enter.data.call(this, I), this.config.exit.data.call(this, I);
  }
  function n(I) {
    const _ = {
      name: void 0,
      attributes: [],
      close: !1,
      selfClosing: !1,
      start: I.start,
      end: I.end
    };
    this.data.mdxJsxTagStack || (this.data.mdxJsxTagStack = []), this.data.mdxJsxTag = _, this.buffer();
  }
  function r(I) {
    if (this.data.mdxJsxTagStack.length === 0)
      throw new Er(
        "Unexpected closing slash `/` in tag, expected an open tag first",
        { start: I.start, end: I.end },
        "mdast-util-mdx-jsx:unexpected-closing-slash"
      );
  }
  function i(I) {
    if (this.data.mdxJsxTag.close)
      throw new Er(
        "Unexpected attribute in closing tag, expected the end of the tag",
        { start: I.start, end: I.end },
        "mdast-util-mdx-jsx:unexpected-attribute"
      );
  }
  function o(I) {
    if (this.data.mdxJsxTag.close)
      throw new Er(
        "Unexpected self-closing slash `/` in closing tag, expected the end of the tag",
        { start: I.start, end: I.end },
        "mdast-util-mdx-jsx:unexpected-self-closing-slash"
      );
  }
  function a() {
    const I = this.data.mdxJsxTag;
    I.close = !0;
  }
  function s(I) {
    const _ = this.data.mdxJsxTag;
    _.name = this.sliceSerialize(I);
  }
  function u(I) {
    const _ = this.data.mdxJsxTag;
    _.name += "." + this.sliceSerialize(I);
  }
  function l(I) {
    const _ = this.data.mdxJsxTag;
    _.name += ":" + this.sliceSerialize(I);
  }
  function c(I) {
    const _ = this.data.mdxJsxTag;
    i.call(this, I), _.attributes.push({ type: "mdxJsxAttribute", name: "", value: null });
  }
  function d(I) {
    const _ = this.data.mdxJsxTag;
    i.call(this, I), _.attributes.push({ type: "mdxJsxExpressionAttribute", value: "" }), this.buffer();
  }
  function f(I) {
    const _ = this.data.mdxJsxTag, A = _.attributes[_.attributes.length - 1];
    A.type;
    const P = I.estree;
    A.value = this.resume(), P && (A.data = { estree: P });
  }
  function h(I) {
    const _ = this.data.mdxJsxTag, A = _.attributes[_.attributes.length - 1];
    A.type, A.name = this.sliceSerialize(I);
  }
  function p(I) {
    const _ = this.data.mdxJsxTag, A = _.attributes[_.attributes.length - 1];
    A.type, A.name += ":" + this.sliceSerialize(I);
  }
  function v() {
    const I = this.data.mdxJsxTag;
    I.attributes[I.attributes.length - 1].value = TYe(
      this.resume(),
      { nonTerminated: !1 }
    );
  }
  function m(I) {
    const _ = this.data.mdxJsxTag, A = _.attributes[_.attributes.length - 1];
    A.type;
    const P = { type: "mdxJsxAttributeValueExpression", value: this.resume() }, N = I.estree;
    N && (P.data = { estree: N }), A.value = P;
  }
  function b() {
    const I = this.data.mdxJsxTag;
    I.selfClosing = !0;
  }
  function y(I) {
    const _ = this.data.mdxJsxTag, A = this.data.mdxJsxTagStack, P = A[A.length - 1];
    if (_.close && P.name !== _.name)
      throw new Er(
        "Unexpected closing tag `" + E(_) + "`, expected corresponding closing tag for `" + E(P) + "` (" + qu(P) + ")",
        { start: I.start, end: I.end },
        "mdast-util-mdx-jsx:end-tag-mismatch"
      );
    this.resume(), _.close ? A.pop() : this.enter(
      {
        type: I.type === "mdxJsxTextTag" ? "mdxJsxTextElement" : "mdxJsxFlowElement",
        name: _.name || null,
        attributes: _.attributes,
        children: []
      },
      I,
      w
    ), _.selfClosing || _.close ? this.exit(I, S) : A.push(_);
  }
  function w(I, _) {
    const A = this.data.mdxJsxTag, P = I ? " before the end of `" + I.type + "`" : "", N = I ? { start: I.start, end: I.end } : void 0;
    throw new Er(
      "Expected a closing tag for `" + E(A) + "` (" + qu({ start: _.start, end: _.end }) + ")" + P,
      N,
      "mdast-util-mdx-jsx:end-tag-mismatch"
    );
  }
  function S(I, _) {
    const A = this.data.mdxJsxTag;
    throw new Er(
      "Expected the closing tag `" + E(A) + "` either after the end of `" + _.type + "` (" + qu(_.end) + ") or another opening tag after the start of `" + _.type + "` (" + qu(_.start) + ")",
      { start: I.start, end: I.end },
      "mdast-util-mdx-jsx:end-tag-mismatch"
    );
  }
  function E(I) {
    return "<" + (I.close ? "/" : "") + (I.name || "") + ">";
  }
}
function MYe(t) {
  const e = t || {}, n = e.quote || '"', r = e.quoteSmart || !1, i = e.tightSelfClosing || !1, o = e.printWidth || Number.POSITIVE_INFINITY, a = n === '"' ? "'" : '"';
  if (n !== '"' && n !== "'")
    throw new Error(
      "Cannot serialize attribute values with `" + n + "` for `options.quote`, expected `\"`, or `'`"
    );
  return s.peek = LYe, {
    handlers: {
      mdxJsxFlowElement: s,
      mdxJsxTextElement: s
    },
    unsafe: [
      { character: "<", inConstruct: ["phrasing"] },
      { atBreak: !0, character: "<" }
    ],
    // Always generate fenced code (never indented code).
    fences: !0,
    // Always generate links with resources (never autolinks).
    resourceLink: !0
  };
  function s(u, l, c, d) {
    const f = u.type === "mdxJsxFlowElement", h = u.name ? !u.children || u.children.length === 0 : !1, p = iq(c), v = oq(p), m = c.createTracker(d), b = c.createTracker(d), y = [], w = (f ? v : "") + "<" + (u.name || ""), S = c.enter(u.type);
    if (m.move(w), b.move(w), u.attributes && u.attributes.length > 0) {
      if (!u.name)
        throw new Error("Cannot serialize fragment w/ attributes");
      let P = -1;
      for (; ++P < u.attributes.length; ) {
        const N = u.attributes[P];
        let k;
        if (N.type === "mdxJsxExpressionAttribute")
          k = "{" + (N.value || "") + "}";
        else {
          if (!N.name)
            throw new Error("Cannot serialize attribute w/o name");
          const D = N.value, R = N.name;
          let V = "";
          if (D != null)
            if (typeof D == "object")
              V = "{" + (D.value || "") + "}";
            else {
              const $ = r && NF(D, n) > NF(D, a) ? a : n;
              V = $ + $Ye(D, { subset: [$] }) + $;
            }
          k = R + (V ? "=" : "") + V;
        }
        y.push(k);
      }
    }
    let E = !1;
    const I = y.join(" ");
    // Block:
    f && // Including a line ending (expressions).
    (/\r?\n|\r/.test(I) || // Current position (including `<tag`).
    m.current().now.column + // -1 because columns, +1 for ` ` before attributes.
    // Attributes joined by spaces.
    I.length + // ` />`.
    (h ? i ? 2 : 3 : 1) > o) && (E = !0);
    let _ = m, A = w;
    if (E) {
      _ = b;
      let P = -1;
      for (; ++P < y.length; )
        y[P] = v + rq + y[P];
      A += _.move(
        `
` + y.join(`
`) + `
` + v
      );
    } else
      I && (A += _.move(" " + I));
    return h && (A += _.move(
      (i || E ? "" : " ") + "/"
    )), A += _.move(">"), u.children && u.children.length > 0 && (u.type === "mdxJsxTextElement" ? A += _.move(
      // @ts-expect-error: `containerPhrasing` is typed correctly, but TS
      // generates *hardcoded* types, which means that our dynamically added
      // directives are not present.
      // At some point, TS should fix that, and `from-markdown` should be fine.
      c.containerPhrasing(u, {
        ..._.current(),
        before: ">",
        after: "<"
      })
    ) : (_.shift(2), A += _.move(`
`), A += _.move(FYe(u, c, _.current())), A += _.move(`
`))), h || (A += _.move(
      (f ? v : "") + "</" + (u.name || "") + ">"
    )), S(), A;
  }
}
function FYe(t, e, n) {
  const r = e.indexStack, i = t.children, o = e.createTracker(n), a = oq(iq(e)), s = [];
  let u = -1;
  for (r.push(-1); ++u < i.length; ) {
    const l = i[u];
    r[r.length - 1] = u;
    const c = { before: `
`, after: `
`, ...o.current() }, d = e.handle(l, t, e, c), f = l.type === "mdxJsxFlowElement" ? d : e.indentLines(d, function(h, p, v) {
      return (v ? "" : a) + h;
    });
    s.push(o.move(f)), l.type !== "list" && (e.bulletLastUsed = void 0), u < i.length - 1 && s.push(o.move(`

`));
  }
  return r.pop(), s.join("");
}
function iq(t) {
  let e = 0;
  for (const n of t.stack)
    n === "mdxJsxFlowElement" && e++;
  return e;
}
function oq(t) {
  return rq.repeat(t);
}
function LYe() {
  return "<";
}
const VYe = /[$_\p{ID_Start}]/u, BYe = /[$_\u{200C}\u{200D}\p{ID_Continue}]/u, HYe = /[-$_\u{200C}\u{200D}\p{ID_Continue}]/u, WYe = {};
function ss(t) {
  return t ? VYe.test(String.fromCodePoint(t)) : !1;
}
function Wg(t, e) {
  const r = (e || WYe).jsx ? HYe : BYe;
  return t ? r.test(String.fromCodePoint(t)) : !1;
}
const jYe = {}.hasOwnProperty, zYe = Symbol("continue"), s5 = Symbol("exit"), GYe = Symbol("skip");
function UYe(t, e) {
  let n, r;
  typeof e == "function" ? n = e : e && typeof e == "object" && (e.enter && (n = e.enter), e.leave && (r = e.leave)), i(t, void 0, void 0, [])();
  function i(o, a, s, u) {
    return u5(o) && (l.displayName = "node (" + o.type + ")"), l;
    function l() {
      const c = n ? FF(n(o, a, s, u)) : [];
      if (c[0] === s5)
        return c;
      if (c[0] !== GYe) {
        let d;
        for (d in o)
          if (jYe.call(o, d) && o[d] && typeof o[d] == "object" && // @ts-expect-error: custom esast extension.
          d !== "data" && // @ts-expect-error: custom esast extension.
          d !== "position") {
            const f = u.concat(o), h = o[d];
            if (Array.isArray(h)) {
              const p = (
                /** @type {Array<unknown>} */
                h
              );
              let v = 0;
              for (; v > -1 && v < p.length; ) {
                const m = p[v];
                if (u5(m)) {
                  const b = i(
                    m,
                    d,
                    v,
                    f
                  )();
                  if (b[0] === s5)
                    return b;
                  v = typeof b[1] == "number" ? b[1] : v + 1;
                } else
                  v++;
              }
            } else if (u5(h)) {
              const p = i(h, d, void 0, f)();
              if (p[0] === s5)
                return p;
            }
          }
      }
      return r ? FF(r(o, a, s, u)) : c;
    }
  }
}
function FF(t) {
  return Array.isArray(t) ? t : typeof t == "number" ? [zYe, t] : [t];
}
function u5(t) {
  return !!(t && typeof t == "object" && "type" in t && typeof t.type == "string" && t.type.length > 0);
}
function XYe(t, e) {
  const n = e.prefix || "", r = e.suffix || "", i = Object.assign({}, e.acornOptions), o = [], a = [], s = i.onComment, u = i.onToken;
  let l = !1, c, d;
  const f = Object.assign({}, i, {
    onComment: o,
    preserveParens: !0
  });
  u && (f.onToken = a);
  const h = YYe(t, e.tokenTypes), p = h.value, v = n + p + r, m = e.expression && LF(p);
  if (m && !e.allowEmpty)
    throw new Er("Unexpected empty expression", {
      place: y(0),
      ruleId: "unexpected-empty-expression",
      source: "micromark-extension-mdx-expression"
    });
  try {
    c = e.expression && !m ? e.acorn.parseExpressionAt(v, 0, f) : e.acorn.parse(v, f);
  } catch (w) {
    const S = (
      /** @type {AcornError} */
      w
    ), E = y(S.pos);
    S.message = String(S.message).replace(/ \(\d+:\d+\)$/, ""), S.pos = E.offset, S.loc = {
      line: E.line,
      column: E.column - 1
    }, d = S, l = S.raisedAt >= n.length + p.length || // Broken comments are raised at their start, not their end.
    S.message === "Unterminated comment";
  }
  if (c && e.expression && !m)
    if (LF(v.slice(c.end, v.length - r.length)))
      c = {
        type: "Program",
        start: 0,
        end: n.length + p.length,
        // @ts-expect-error: It’s good.
        body: [{
          type: "ExpressionStatement",
          expression: c,
          start: 0,
          end: n.length + p.length
        }],
        sourceType: "module",
        comments: []
      };
    else {
      const w = y(c.end), S = (
        /** @type {AcornError} */
        new Error("Unexpected content after expression")
      );
      S.pos = w.offset, S.loc = {
        line: w.line,
        column: w.column - 1
      }, d = S, c = void 0;
    }
  if (c) {
    if (c.comments = o, UYe(c, function(w, S, E, I) {
      let _ = (
        /** @type {AcornNode | Array<AcornNode>} */
        I[I.length - 1]
      ), A = S;
      w.type === "ParenthesizedExpression" && _ && A && (typeof E == "number" && (_ = _[A], A = E), _[A] = w.expression), b(w);
    }), Array.isArray(s))
      s.push(...o);
    else if (typeof s == "function")
      for (const w of o)
        s(w.type === "Block", w.value, w.start, w.end, w.loc.start, w.loc.end);
    for (const w of a)
      w.end <= n.length || w.start - n.length >= p.length || (b(w), Array.isArray(u) ? u.push(w) : u(w));
  }
  return {
    estree: c,
    error: d,
    swallow: l
  };
  function b(w) {
    const S = y(w.start), E = y(w.end);
    w.start = S.offset, w.end = E.offset, w.loc = {
      start: {
        line: S.line,
        column: S.column - 1,
        offset: S.offset
      },
      end: {
        line: E.line,
        column: E.column - 1,
        offset: E.offset
      }
    }, w.range = [w.start, w.end];
  }
  function y(w) {
    let S = w - n.length;
    S < 0 ? S = 0 : S > p.length && (S = p.length);
    let E = ZYe(h.stops, S);
    return E || (E = {
      line: e.start.line,
      column: e.start.column,
      offset: e.start.offset
    }), E;
  }
}
function LF(t) {
  return /^\s*$/.test(t.replace(/\/\*[\s\S]*?\*\//g, "").replace(/\/\/[^\r\n]*(\r\n|\n|\r)/g, ""));
}
function YYe(t, e) {
  const n = {
    value: "",
    stops: []
  };
  let r = -1;
  for (; ++r < t.length; ) {
    const i = t[r];
    if (i[0] === "enter") {
      const o = i[1].type;
      if (o === "lineEnding" || e.includes(o)) {
        const a = i[2].sliceStream(i[1]);
        for (; a.length > 0 && a[0] === -1; )
          a.shift();
        const s = JYe(a);
        n.stops.push([n.value.length, i[1].start]), n.value += s, n.stops.push([n.value.length, i[1].end]);
      }
    }
  }
  return n;
}
function ZYe(t, e) {
  let n = 0;
  for (; n < t.length && t[n][0] <= e; )
    n += 1;
  if (n === 0)
    return;
  const [r, i] = t[n - 1], o = e - r;
  return {
    line: i.line,
    column: i.column + o,
    offset: i.offset + o
  };
}
function JYe(t) {
  let e = -1;
  const n = [];
  let r;
  for (; ++e < t.length; ) {
    const i = t[e];
    let o;
    if (typeof i == "string")
      o = i;
    else
      switch (i) {
        case -5: {
          o = "\r";
          break;
        }
        case -4: {
          o = `
`;
          break;
        }
        case -3: {
          o = `\r
`;
          break;
        }
        case -2: {
          o = "	";
          break;
        }
        case -1: {
          if (r)
            continue;
          o = " ";
          break;
        }
        default:
          o = String.fromCharCode(i);
      }
    r = i === -2, n.push(o);
  }
  return n.join("");
}
function l5(t) {
  const e = t || {}, n = e.loc || {}, r = e.range || [void 0, void 0], i = VF(n.start, r[0] || e.start), o = VF(n.end, r[1] || e.end);
  if (i && o)
    return { start: i, end: o };
}
function VF(t, e) {
  if (t && typeof t == "object") {
    const n = "line" in t ? c5(t.line) : void 0, r = "column" in t ? c5(t.column) : void 0;
    if (n && r !== void 0)
      return {
        line: n,
        column: r + 1,
        offset: c5(e)
      };
  }
}
function c5(t) {
  return typeof t == "number" && t > -1 ? t : void 0;
}
const Nh = "https://github.com/micromark/micromark-extension-mdx-expression/tree/main/packages/micromark-extension-mdx-expression", KYe = "#unexpected-end-of-file-in-expression-expected-a-corresponding-closing-brace-for-", qYe = "#unexpected-lazy-line-in-expression-in-container-expected-line-to-be-prefixed", BF = "#unexpected-type-in-code-expected-an-object-spread-spread", QYe = "#unexpected-extra-content-in-spread-only-a-single-spread-is-supported", eZe = "#could-not-parse-expression-with-acorn";
function HF(t, e, n, r, i, o, a, s, u, l, c) {
  const d = this, f = this.events.length + 3;
  let h = 0, p, v;
  return m;
  function m(S) {
    return t.enter(n), t.enter(r), t.consume(S), t.exit(r), p = d.now(), b;
  }
  function b(S) {
    if (S === null) {
      if (v)
        throw v;
      const E = new Er(
        "Unexpected end of file in expression, expected a corresponding closing brace for `{`",
        {
          place: d.now(),
          ruleId: "unexpected-eof",
          source: "micromark-extension-mdx-expression"
        }
      );
      throw E.url = Nh + KYe, E;
    }
    if (Dt(S))
      return t.enter("lineEnding"), t.consume(S), t.exit("lineEnding"), w;
    if (S === 125 && h === 0) {
      const E = o ? tZe.call(
        d,
        o,
        a,
        i,
        f,
        p,
        l || !1,
        u || !1
      ) : {
        type: "ok",
        estree: void 0
      };
      if (E.type === "ok") {
        t.enter(r), t.consume(S), t.exit(r);
        const I = t.exit(n);
        return s && E.estree && Object.assign(I, {
          estree: E.estree
        }), e;
      }
      return v = E.message, t.enter(i), t.consume(S), y;
    }
    return t.enter(i), y(S);
  }
  function y(S) {
    return S === 125 && h === 0 || S === null || Dt(S) ? (t.exit(i), b(S)) : (S === 123 && !o ? h += 1 : S === 125 && (h -= 1), t.consume(S), y);
  }
  function w(S) {
    const E = d.now();
    if (E.line !== p.line && !c && d.parser.lazy[E.line]) {
      const I = new Er(
        "Unexpected lazy line in expression in container, expected line to be prefixed with `>` when in a block quote, whitespace when in a list, etc",
        {
          place: d.now(),
          ruleId: "unexpected-lazy",
          source: "micromark-extension-mdx-expression"
        }
      );
      throw I.url = Nh + qYe, I;
    }
    return b(S);
  }
}
function tZe(t, e, n, r, i, o, a) {
  const s = XYe(this.events.slice(r), {
    acorn: t,
    tokenTypes: [n],
    acornOptions: e,
    start: i,
    expression: !0,
    allowEmpty: o,
    prefix: a ? "({" : "",
    suffix: a ? "})" : ""
  }), u = s.estree;
  if (a && u) {
    const l = u.body[0];
    if (l.type !== "ExpressionStatement" || l.expression.type !== "ObjectExpression") {
      const c = l5(l), d = new Er(
        "Unexpected `" + l.type + "` in code: expected an object spread (`{...spread}`)",
        {
          place: c.start,
          ruleId: "non-spread",
          source: "micromark-extension-mdx-expression"
        }
      );
      throw d.url = Nh + BF, d;
    }
    if (l.expression.properties[1]) {
      const c = l5(l.expression.properties[1]), d = new Er(
        "Unexpected extra content in spread: only a single spread is supported",
        {
          place: c.start,
          ruleId: "spread-extra",
          source: "micromark-extension-mdx-expression"
        }
      );
      throw d.url = Nh + QYe, d;
    }
    if (l.expression.properties[0] && l.expression.properties[0].type !== "SpreadElement") {
      const c = l5(l.expression.properties[0]), d = new Er(
        "Unexpected `" + l.expression.properties[0].type + "` in code: only spread elements are supported",
        {
          place: c.start,
          ruleId: "non-spread",
          source: "micromark-extension-mdx-expression"
        }
      );
      throw d.url = Nh + BF, d;
    }
  }
  if (s.error) {
    const l = new Er("Could not parse expression with acorn", {
      cause: s.error,
      place: {
        line: s.error.loc.line,
        column: s.error.loc.column + 1,
        offset: s.error.pos
      },
      ruleId: "acorn",
      source: "micromark-extension-mdx-expression"
    });
    return l.url = Nh + eZe, {
      type: "nok",
      message: l
    };
  }
  return {
    type: "ok",
    estree: u
  };
}
const WF = "https://github.com/micromark/micromark-extension-mdx-jsx";
function aq(t, e, n, r, i, o, a, s, u, l, c, d, f, h, p, v, m, b, y, w, S, E, I, _, A, P, N, k, D, R, V, $) {
  const F = this;
  let M, B;
  return X;
  function X(q) {
    return t.enter(s), t.enter(u), t.consume(q), t.exit(u), L;
  }
  function L(q) {
    return Br(q) ? n(q) : (M = j, we(q));
  }
  function j(q) {
    if (q === 47)
      return t.enter(l), t.consume(q), t.exit(l), M = K, we;
    if (q === 62)
      return Ae(q);
    if (q !== null && q >= 0 && ss(q))
      return t.enter(d), t.enter(f), t.consume(q), W;
    Ie(q, "before name", "a character that can start a name, such as a letter, `$`, or `_`" + (q === 33 ? " (note: to create a comment in MDX, use `{/* text */}`)" : ""));
  }
  function K(q) {
    if (q === 62)
      return Ae(q);
    if (q !== null && q >= 0 && ss(q))
      return t.enter(d), t.enter(f), t.consume(q), W;
    Ie(q, "before name", "a character that can start a name, such as a letter, `$`, or `_`" + (q === 42 || q === 47 ? " (note: JS comments in JSX tags are not supported in MDX)" : ""));
  }
  function W(q) {
    if (q !== null && q >= 0 && Wg(q, {
      jsx: !0
    }))
      return t.consume(q), W;
    if (q === 46 || q === 47 || q === 58 || q === 62 || q === 123 || Br(q) || Wu(q))
      return t.exit(f), M = Y, we(q);
    Ie(q, "in name", "a name character such as letters, digits, `$`, or `_`; whitespace before attributes; or the end of the tag" + (q === 64 ? " (note: to create a link in MDX, use `[text](url)`)" : ""));
  }
  function Y(q) {
    if (q === 46)
      return t.enter(h), t.consume(q), t.exit(h), M = U, we;
    if (q === 58)
      return t.enter(v), t.consume(q), t.exit(v), M = ee, we;
    if (q === 47 || q === 62 || q === 123 || q !== null && q >= 0 && ss(q))
      return t.exit(d), se(q);
    Ie(q, "after name", "a character that can start an attribute name, such as a letter, `$`, or `_`; whitespace before attributes; or the end of the tag");
  }
  function U(q) {
    if (q !== null && q >= 0 && ss(q))
      return t.enter(p), t.consume(q), Q;
    Ie(q, "before member name", "a character that can start an attribute name, such as a letter, `$`, or `_`; whitespace before attributes; or the end of the tag");
  }
  function Q(q) {
    if (q !== null && q >= 0 && Wg(q, {
      jsx: !0
    }))
      return t.consume(q), Q;
    if (q === 46 || q === 47 || q === 62 || q === 123 || Br(q) || Wu(q))
      return t.exit(p), M = Z, we(q);
    Ie(q, "in member name", "a name character such as letters, digits, `$`, or `_`; whitespace before attributes; or the end of the tag" + (q === 64 ? " (note: to create a link in MDX, use `[text](url)`)" : ""));
  }
  function Z(q) {
    if (q === 46)
      return t.enter(h), t.consume(q), t.exit(h), M = U, we;
    if (q === 47 || q === 62 || q === 123 || q !== null && q >= 0 && ss(q))
      return t.exit(d), se(q);
    Ie(q, "after member name", "a character that can start an attribute name, such as a letter, `$`, or `_`; whitespace before attributes; or the end of the tag");
  }
  function ee(q) {
    if (q !== null && q >= 0 && ss(q))
      return t.enter(m), t.consume(q), ie;
    Ie(q, "before local name", "a character that can start a name, such as a letter, `$`, or `_`" + (q === 43 || q !== null && q > 46 && q < 58 ? " (note: to create a link in MDX, use `[text](url)`)" : ""));
  }
  function ie(q) {
    if (q !== null && q >= 0 && Wg(q, {
      jsx: !0
    }))
      return t.consume(q), ie;
    if (q === 47 || q === 62 || q === 123 || Br(q) || Wu(q))
      return t.exit(m), M = oe, we(q);
    Ie(q, "in local name", "a name character such as letters, digits, `$`, or `_`; whitespace before attributes; or the end of the tag");
  }
  function oe(q) {
    if (q === 47 || q === 62 || q === 123 || q !== null && q >= 0 && ss(q))
      return t.exit(d), se(q);
    Ie(q, "after local name", "a character that can start an attribute name, such as a letter, `$`, or `_`; whitespace before attributes; or the end of the tag");
  }
  function se(q) {
    if (q === 47)
      return t.enter(c), t.consume(q), t.exit(c), M = ye, we;
    if (q === 62)
      return Ae(q);
    if (q === 123)
      return HF.call(F, t, te, b, y, w, r, i, o, !0, !1, a)(q);
    if (q !== null && q >= 0 && ss(q))
      return t.enter(S), t.enter(E), t.enter(I), t.consume(q), ge;
    Ie(q, "before attribute name", "a character that can start an attribute name, such as a letter, `$`, or `_`; whitespace before attributes; or the end of the tag");
  }
  function te(q) {
    return M = se, we(q);
  }
  function ge(q) {
    if (q !== null && q >= 0 && Wg(q, {
      jsx: !0
    }))
      return t.consume(q), ge;
    if (q === 47 || q === 58 || q === 61 || q === 62 || q === 123 || Br(q) || Wu(q))
      return t.exit(I), M = he, we(q);
    Ie(q, "in attribute name", "an attribute name character such as letters, digits, `$`, or `_`; `=` to initialize a value; whitespace before attributes; or the end of the tag");
  }
  function he(q) {
    if (q === 58)
      return t.enter(_), t.consume(q), t.exit(_), M = fe, we;
    if (q === 61)
      return t.exit(E), t.enter(P), t.consume(q), t.exit(P), M = ze, we;
    if (q === 47 || q === 62 || q === 123 || Br(q) || Wu(q) || q !== null && q >= 0 && ss(q))
      return t.exit(E), t.exit(S), M = se, we(q);
    Ie(q, "after attribute name", "a character that can start an attribute name, such as a letter, `$`, or `_`; `=` to initialize a value; or the end of the tag");
  }
  function fe(q) {
    if (q !== null && q >= 0 && ss(q))
      return t.enter(A), t.consume(q), _e;
    Ie(q, "before local attribute name", "a character that can start an attribute name, such as a letter, `$`, or `_`; `=` to initialize a value; or the end of the tag");
  }
  function _e(q) {
    if (q !== null && q >= 0 && Wg(q, {
      jsx: !0
    }))
      return t.consume(q), _e;
    if (q === 47 || q === 61 || q === 62 || q === 123 || Br(q) || Wu(q))
      return t.exit(A), t.exit(E), M = Ne, we(q);
    Ie(q, "in local attribute name", "an attribute name character such as letters, digits, `$`, or `_`; `=` to initialize a value; whitespace before attributes; or the end of the tag");
  }
  function Ne(q) {
    if (q === 61)
      return t.enter(P), t.consume(q), t.exit(P), M = ze, we;
    if (q === 47 || q === 62 || q === 123 || q !== null && q >= 0 && ss(q))
      return t.exit(S), se(q);
    Ie(q, "after local attribute name", "a character that can start an attribute name, such as a letter, `$`, or `_`; `=` to initialize a value; or the end of the tag");
  }
  function ze(q) {
    if (q === 34 || q === 39)
      return t.enter(N), t.enter(k), t.consume(q), t.exit(k), B = q, ne;
    if (q === 123)
      return HF.call(F, t, Ve, R, V, $, r, i, o, !1, !1, a)(q);
    Ie(q, "before attribute value", "a character that can start an attribute value, such as `\"`, `'`, or `{`" + (q === 60 ? " (note: to use an element or fragment as a prop value in MDX, use `{<element />}`)" : ""));
  }
  function Ve(q) {
    return t.exit(S), M = se, we(q);
  }
  function ne(q) {
    return q === null && Ie(q, "in attribute value", "a corresponding closing quote `" + String.fromCodePoint(B) + "`"), q === B ? (t.enter(k), t.consume(q), t.exit(k), t.exit(N), t.exit(S), B = void 0, M = se, we) : Dt(q) ? (M = ne, we(q)) : (t.enter(D), pe(q));
  }
  function pe(q) {
    return q === null || q === B || Dt(q) ? (t.exit(D), ne(q)) : (t.consume(q), pe);
  }
  function ye(q) {
    if (q === 62)
      return Ae(q);
    Ie(q, "after self-closing slash", "`>` to end the tag" + (q === 42 || q === 47 ? " (note: JS comments in JSX tags are not supported in MDX)" : ""));
  }
  function Ae(q) {
    return t.enter(u), t.consume(q), t.exit(u), t.exit(s), e;
  }
  function we(q) {
    return Dt(q) ? (t.enter("lineEnding"), t.consume(q), t.exit("lineEnding"), ve) : Cn(q) || Wu(q) ? (t.enter("esWhitespace"), ce(q)) : M(q);
  }
  function ce(q) {
    return Dt(q) ? (t.exit("esWhitespace"), we(q)) : Cn(q) || Wu(q) ? (t.consume(q), ce) : (t.exit("esWhitespace"), M(q));
  }
  function ve(q) {
    if (!a && F.parser.lazy[F.now().line]) {
      const Fe = new Er("Unexpected lazy line in container, expected line to be prefixed with `>` when in a block quote, whitespace when in a list, etc", F.now(), "micromark-extension-mdx-jsx:unexpected-lazy");
      throw Fe.url = WF + "#unexpected-lazy-line-in-container-expected-line-to-be", Fe;
    }
    return we(q);
  }
  function Ie(q, Fe, Ze) {
    const at = new Er("Unexpected " + (q === null ? "end of file" : "character `" + (q === 96 ? "` ` `" : String.fromCodePoint(q)) + "` (" + nZe(q) + ")") + " " + Fe + ", expected " + Ze, F.now(), "micromark-extension-mdx-jsx:unexpected-" + (q === null ? "eof" : "character"));
    throw at.url = WF + (q === null ? "#unexpected-end-of-file-at-expected-expect" : "#unexpected-character-at-expected-expect"), at;
  }
}
function nZe(t) {
  return "U+" + t.toString(16).toUpperCase().padStart(4, "0");
}
function rZe(t, e) {
  return {
    name: "mdxJsxTextTag",
    tokenize: n
  };
  function n(r, i, o) {
    return aq.call(this, r, i, o, t, e.acornOptions, e.addResult, !0, "mdxJsxTextTag", "mdxJsxTextTagMarker", "mdxJsxTextTagClosingMarker", "mdxJsxTextTagSelfClosingMarker", "mdxJsxTextTagName", "mdxJsxTextTagNamePrimary", "mdxJsxTextTagNameMemberMarker", "mdxJsxTextTagNameMember", "mdxJsxTextTagNamePrefixMarker", "mdxJsxTextTagNameLocal", "mdxJsxTextTagExpressionAttribute", "mdxJsxTextTagExpressionAttributeMarker", "mdxJsxTextTagExpressionAttributeValue", "mdxJsxTextTagAttribute", "mdxJsxTextTagAttributeName", "mdxJsxTextTagAttributeNamePrimary", "mdxJsxTextTagAttributeNamePrefixMarker", "mdxJsxTextTagAttributeNameLocal", "mdxJsxTextTagAttributeInitializerMarker", "mdxJsxTextTagAttributeValueLiteral", "mdxJsxTextTagAttributeValueLiteralMarker", "mdxJsxTextTagAttributeValueLiteralValue", "mdxJsxTextTagAttributeValueExpression", "mdxJsxTextTagAttributeValueExpressionMarker", "mdxJsxTextTagAttributeValueExpressionValue");
  }
}
function Bn(t, e, n, r) {
  const i = r ? r - 1 : Number.POSITIVE_INFINITY;
  let o = 0;
  return a;
  function a(u) {
    return Cn(u) ? (t.enter(n), s(u)) : e(u);
  }
  function s(u) {
    return Cn(u) && o++ < i ? (t.consume(u), s) : (t.exit(n), e(u));
  }
}
function iZe(t, e) {
  return {
    name: "mdxJsxFlowTag",
    tokenize: n,
    concrete: !0
  };
  function n(r, i, o) {
    const a = this;
    return s;
    function s(d) {
      return u(d);
    }
    function u(d) {
      return aq.call(a, r, l, o, t, e.acornOptions, e.addResult, !1, "mdxJsxFlowTag", "mdxJsxFlowTagMarker", "mdxJsxFlowTagClosingMarker", "mdxJsxFlowTagSelfClosingMarker", "mdxJsxFlowTagName", "mdxJsxFlowTagNamePrimary", "mdxJsxFlowTagNameMemberMarker", "mdxJsxFlowTagNameMember", "mdxJsxFlowTagNamePrefixMarker", "mdxJsxFlowTagNameLocal", "mdxJsxFlowTagExpressionAttribute", "mdxJsxFlowTagExpressionAttributeMarker", "mdxJsxFlowTagExpressionAttributeValue", "mdxJsxFlowTagAttribute", "mdxJsxFlowTagAttributeName", "mdxJsxFlowTagAttributeNamePrimary", "mdxJsxFlowTagAttributeNamePrefixMarker", "mdxJsxFlowTagAttributeNameLocal", "mdxJsxFlowTagAttributeInitializerMarker", "mdxJsxFlowTagAttributeValueLiteral", "mdxJsxFlowTagAttributeValueLiteralMarker", "mdxJsxFlowTagAttributeValueLiteralValue", "mdxJsxFlowTagAttributeValueExpression", "mdxJsxFlowTagAttributeValueExpressionMarker", "mdxJsxFlowTagAttributeValueExpressionValue")(d);
    }
    function l(d) {
      return Cn(d) ? Bn(r, c, "whitespace")(d) : c(d);
    }
    function c(d) {
      const f = a.parser.constructs.flow[123], p = (Array.isArray(f) ? f : f ? [f] : []).find((v) => v.name === "mdxFlowExpression");
      return d === 60 ? (
        // We can’t just say: fine. Lines of blocks have to be parsed until an eol/eof.
        s(d)
      ) : d === 123 && p ? r.attempt(p, c, o)(d) : d === null || Dt(d) ? i(d) : o(d);
    }
  }
}
function oZe(t) {
  const e = t || {}, n = e.acorn;
  let r;
  if (n) {
    if (!n.parse || !n.parseExpressionAt)
      throw new Error("Expected a proper `acorn` instance passed in as `options.acorn`");
    r = Object.assign({
      ecmaVersion: 2024,
      sourceType: "module"
    }, e.acornOptions, {
      locations: !0
    });
  } else if (e.acornOptions || e.addResult)
    throw new Error("Expected an `acorn` instance passed in as `options.acorn`");
  return {
    flow: {
      60: iZe(n || void 0, {
        acornOptions: r,
        addResult: e.addResult || void 0
      })
    },
    text: {
      60: rZe(n || void 0, {
        acornOptions: r,
        addResult: e.addResult || void 0
      })
    }
  };
}
function aZe() {
  return {
    disable: { null: ["autolink", "codeIndented", "htmlFlow", "htmlText"] }
  };
}
const jF = {}.hasOwnProperty;
function sZe(t, e) {
  const n = e || {};
  function r(i, ...o) {
    let a = r.invalid;
    const s = r.handlers;
    if (i && jF.call(i, t)) {
      const u = String(i[t]);
      a = jF.call(s, u) ? s[u] : r.unknown;
    }
    if (a)
      return a.call(this, i, ...o);
  }
  return r.handlers = n.handlers || {}, r.invalid = n.invalid, r.unknown = n.unknown, r;
}
const uZe = {}.hasOwnProperty;
function sq(t, e) {
  let n = -1, r;
  if (e.extensions)
    for (; ++n < e.extensions.length; )
      sq(t, e.extensions[n]);
  for (r in e)
    if (uZe.call(e, r))
      switch (r) {
        case "extensions":
          break;
        case "unsafe": {
          zF(t[r], e[r]);
          break;
        }
        case "join": {
          zF(t[r], e[r]);
          break;
        }
        case "handlers": {
          lZe(t[r], e[r]);
          break;
        }
        default:
          t.options[r] = e[r];
      }
  return t;
}
function zF(t, e) {
  e && t.push(...e);
}
function lZe(t, e) {
  e && Object.assign(t, e);
}
function cZe(t, e, n, r) {
  const i = n.enter("blockquote"), o = n.createTracker(r);
  o.move("> "), o.shift(2);
  const a = n.indentLines(
    n.containerFlow(t, o.current()),
    dZe
  );
  return i(), a;
}
function dZe(t, e, n) {
  return ">" + (n ? "" : " ") + t;
}
function uq(t, e) {
  return GF(t, e.inConstruct, !0) && !GF(t, e.notInConstruct, !1);
}
function GF(t, e, n) {
  if (typeof e == "string" && (e = [e]), !e || e.length === 0)
    return n;
  let r = -1;
  for (; ++r < e.length; )
    if (t.includes(e[r]))
      return !0;
  return !1;
}
function UF(t, e, n, r) {
  let i = -1;
  for (; ++i < n.unsafe.length; )
    if (n.unsafe[i].character === `
` && uq(n.stack, n.unsafe[i]))
      return /[ \t]/.test(r.before) ? "" : " ";
  return `\\
`;
}
function fZe(t, e) {
  const n = String(t);
  let r = n.indexOf(e), i = r, o = 0, a = 0;
  if (typeof e != "string")
    throw new TypeError("Expected substring");
  for (; r !== -1; )
    r === i ? ++o > a && (a = o) : o = 1, i = r + e.length, r = n.indexOf(e, i);
  return a;
}
function k4(t, e) {
  return !!(e.options.fences === !1 && t.value && // If there’s no info…
  !t.lang && // And there’s a non-whitespace character…
  /[^ \r\n]/.test(t.value) && // And the value doesn’t start or end in a blank…
  !/^[\t ]*(?:[\r\n]|$)|(?:^|[\r\n])[\t ]*$/.test(t.value));
}
function hZe(t) {
  const e = t.options.fence || "`";
  if (e !== "`" && e !== "~")
    throw new Error(
      "Cannot serialize code with `" + e + "` for `options.fence`, expected `` ` `` or `~`"
    );
  return e;
}
function pZe(t, e, n, r) {
  const i = hZe(n), o = t.value || "", a = i === "`" ? "GraveAccent" : "Tilde";
  if (k4(t, n)) {
    const d = n.enter("codeIndented"), f = n.indentLines(o, gZe);
    return d(), f;
  }
  const s = n.createTracker(r), u = i.repeat(Math.max(fZe(o, i) + 1, 3)), l = n.enter("codeFenced");
  let c = s.move(u);
  if (t.lang) {
    const d = n.enter(`codeFencedLang${a}`);
    c += s.move(
      n.safe(t.lang, {
        before: c,
        after: " ",
        encode: ["`"],
        ...s.current()
      })
    ), d();
  }
  if (t.lang && t.meta) {
    const d = n.enter(`codeFencedMeta${a}`);
    c += s.move(" "), c += s.move(
      n.safe(t.meta, {
        before: c,
        after: `
`,
        encode: ["`"],
        ...s.current()
      })
    ), d();
  }
  return c += s.move(`
`), o && (c += s.move(o + `
`)), c += s.move(u), l(), c;
}
function gZe(t, e, n) {
  return (n ? "" : "    ") + t;
}
function bO(t) {
  const e = t.options.quote || '"';
  if (e !== '"' && e !== "'")
    throw new Error(
      "Cannot serialize title with `" + e + "` for `options.quote`, expected `\"`, or `'`"
    );
  return e;
}
function mZe(t, e, n, r) {
  const i = bO(n), o = i === '"' ? "Quote" : "Apostrophe", a = n.enter("definition");
  let s = n.enter("label");
  const u = n.createTracker(r);
  let l = u.move("[");
  return l += u.move(
    n.safe(n.associationId(t), {
      before: l,
      after: "]",
      ...u.current()
    })
  ), l += u.move("]: "), s(), // If there’s no url, or…
  !t.url || // If there are control characters or whitespace.
  /[\0- \u007F]/.test(t.url) ? (s = n.enter("destinationLiteral"), l += u.move("<"), l += u.move(
    n.safe(t.url, { before: l, after: ">", ...u.current() })
  ), l += u.move(">")) : (s = n.enter("destinationRaw"), l += u.move(
    n.safe(t.url, {
      before: l,
      after: t.title ? " " : `
`,
      ...u.current()
    })
  )), s(), t.title && (s = n.enter(`title${o}`), l += u.move(" " + i), l += u.move(
    n.safe(t.title, {
      before: l,
      after: i,
      ...u.current()
    })
  ), l += u.move(i), s()), a(), l;
}
function vZe(t) {
  const e = t.options.emphasis || "*";
  if (e !== "*" && e !== "_")
    throw new Error(
      "Cannot serialize emphasis with `" + e + "` for `options.emphasis`, expected `*`, or `_`"
    );
  return e;
}
lq.peek = bZe;
function lq(t, e, n, r) {
  const i = vZe(n), o = n.enter("emphasis"), a = n.createTracker(r);
  let s = a.move(i);
  return s += a.move(
    n.containerPhrasing(t, {
      before: s,
      after: i,
      ...a.current()
    })
  ), s += a.move(i), o(), s;
}
function bZe(t, e, n) {
  return n.options.emphasis || "*";
}
const cq = (
  // Note: overloads in JSDoc can’t yet use different `@template`s.
  /**
   * @type {(
   *   (<Condition extends string>(test: Condition) => (node: unknown, index?: number | null | undefined, parent?: Parent | null | undefined, context?: unknown) => node is Node & {type: Condition}) &
   *   (<Condition extends Props>(test: Condition) => (node: unknown, index?: number | null | undefined, parent?: Parent | null | undefined, context?: unknown) => node is Node & Condition) &
   *   (<Condition extends TestFunction>(test: Condition) => (node: unknown, index?: number | null | undefined, parent?: Parent | null | undefined, context?: unknown) => node is Node & Predicate<Condition, Node>) &
   *   ((test?: null | undefined) => (node?: unknown, index?: number | null | undefined, parent?: Parent | null | undefined, context?: unknown) => node is Node) &
   *   ((test?: Test) => Check)
   * )}
   */
  /**
   * @param {Test} [test]
   * @returns {Check}
   */
  function(t) {
    if (t == null)
      return wZe;
    if (typeof t == "function")
      return Nw(t);
    if (typeof t == "object")
      return Array.isArray(t) ? yZe(t) : xZe(t);
    if (typeof t == "string")
      return CZe(t);
    throw new Error("Expected function, string, or object as test");
  }
);
function yZe(t) {
  const e = [];
  let n = -1;
  for (; ++n < t.length; )
    e[n] = cq(t[n]);
  return Nw(r);
  function r(...i) {
    let o = -1;
    for (; ++o < e.length; )
      if (e[o].apply(this, i))
        return !0;
    return !1;
  }
}
function xZe(t) {
  const e = (
    /** @type {Record<string, unknown>} */
    t
  );
  return Nw(n);
  function n(r) {
    const i = (
      /** @type {Record<string, unknown>} */
      /** @type {unknown} */
      r
    );
    let o;
    for (o in t)
      if (i[o] !== e[o])
        return !1;
    return !0;
  }
}
function CZe(t) {
  return Nw(e);
  function e(n) {
    return n && n.type === t;
  }
}
function Nw(t) {
  return e;
  function e(n, r, i) {
    return !!(EZe(n) && t.call(
      this,
      n,
      typeof r == "number" ? r : void 0,
      i || void 0
    ));
  }
}
function wZe() {
  return !0;
}
function EZe(t) {
  return t !== null && typeof t == "object" && "type" in t;
}
const dq = [], SZe = !0, R4 = !1, IZe = "skip";
function _Ze(t, e, n, r) {
  let i;
  typeof e == "function" && typeof n != "function" ? (r = n, n = e) : i = e;
  const o = cq(i), a = r ? -1 : 1;
  s(t, void 0, [])();
  function s(u, l, c) {
    const d = (
      /** @type {Record<string, unknown>} */
      u && typeof u == "object" ? u : {}
    );
    if (typeof d.type == "string") {
      const h = (
        // `hast`
        typeof d.tagName == "string" ? d.tagName : (
          // `xast`
          typeof d.name == "string" ? d.name : void 0
        )
      );
      Object.defineProperty(f, "name", {
        value: "node (" + (u.type + (h ? "<" + h + ">" : "")) + ")"
      });
    }
    return f;
    function f() {
      let h = dq, p, v, m;
      if ((!e || o(u, l, c[c.length - 1] || void 0)) && (h = AZe(n(u, c)), h[0] === R4))
        return h;
      if ("children" in u && u.children) {
        const b = (
          /** @type {UnistParent} */
          u
        );
        if (b.children && h[0] !== IZe)
          for (v = (r ? b.children.length : -1) + a, m = c.concat(b); v > -1 && v < b.children.length; ) {
            const y = b.children[v];
            if (p = s(y, v, m)(), p[0] === R4)
              return p;
            v = typeof p[1] == "number" ? p[1] : v + a;
          }
      }
      return h;
    }
  }
}
function AZe(t) {
  return Array.isArray(t) ? t : typeof t == "number" ? [SZe, t] : t == null ? dq : [t];
}
function TZe(t, e, n, r) {
  let i, o, a;
  typeof e == "function" && typeof n != "function" ? (o = void 0, a = e, i = n) : (o = e, a = n, i = r), _Ze(t, o, s, i);
  function s(u, l) {
    const c = l[l.length - 1], d = c ? c.children.indexOf(u) : void 0;
    return a(u, d, c);
  }
}
const OZe = {};
function fq(t, e) {
  const n = e || OZe, r = typeof n.includeImageAlt == "boolean" ? n.includeImageAlt : !0, i = typeof n.includeHtml == "boolean" ? n.includeHtml : !0;
  return hq(t, r, i);
}
function hq(t, e, n) {
  if (PZe(t)) {
    if ("value" in t)
      return t.type === "html" && !n ? "" : t.value;
    if (e && "alt" in t && t.alt)
      return t.alt;
    if ("children" in t)
      return XF(t.children, e, n);
  }
  return Array.isArray(t) ? XF(t, e, n) : "";
}
function XF(t, e, n) {
  const r = [];
  let i = -1;
  for (; ++i < t.length; )
    r[i] = hq(t[i], e, n);
  return r.join("");
}
function PZe(t) {
  return !!(t && typeof t == "object");
}
function pq(t, e) {
  let n = !1;
  return TZe(t, function(r) {
    if ("value" in r && /\r?\n|\r/.test(r.value) || r.type === "break")
      return n = !0, R4;
  }), !!((!t.depth || t.depth < 3) && fq(t) && (e.options.setext || n));
}
function NZe(t, e, n, r) {
  const i = Math.max(Math.min(6, t.depth || 1), 1), o = n.createTracker(r);
  if (pq(t, n)) {
    const c = n.enter("headingSetext"), d = n.enter("phrasing"), f = n.containerPhrasing(t, {
      ...o.current(),
      before: `
`,
      after: `
`
    });
    return d(), c(), f + `
` + (i === 1 ? "=" : "-").repeat(
      // The whole size…
      f.length - // Minus the position of the character after the last EOL (or
      // 0 if there is none)…
      (Math.max(f.lastIndexOf("\r"), f.lastIndexOf(`
`)) + 1)
    );
  }
  const a = "#".repeat(i), s = n.enter("headingAtx"), u = n.enter("phrasing");
  o.move(a + " ");
  let l = n.containerPhrasing(t, {
    before: "# ",
    after: `
`,
    ...o.current()
  });
  return /^[\t ]/.test(l) && (l = "&#x" + l.charCodeAt(0).toString(16).toUpperCase() + ";" + l.slice(1)), l = l ? a + " " + l : a, n.options.closeAtx && (l += " " + a), u(), s(), l;
}
gq.peek = kZe;
function gq(t) {
  return t.value || "";
}
function kZe() {
  return "<";
}
mq.peek = RZe;
function mq(t, e, n, r) {
  const i = bO(n), o = i === '"' ? "Quote" : "Apostrophe", a = n.enter("image");
  let s = n.enter("label");
  const u = n.createTracker(r);
  let l = u.move("![");
  return l += u.move(
    n.safe(t.alt, { before: l, after: "]", ...u.current() })
  ), l += u.move("]("), s(), // If there’s no url but there is a title…
  !t.url && t.title || // If there are control characters or whitespace.
  /[\0- \u007F]/.test(t.url) ? (s = n.enter("destinationLiteral"), l += u.move("<"), l += u.move(
    n.safe(t.url, { before: l, after: ">", ...u.current() })
  ), l += u.move(">")) : (s = n.enter("destinationRaw"), l += u.move(
    n.safe(t.url, {
      before: l,
      after: t.title ? " " : ")",
      ...u.current()
    })
  )), s(), t.title && (s = n.enter(`title${o}`), l += u.move(" " + i), l += u.move(
    n.safe(t.title, {
      before: l,
      after: i,
      ...u.current()
    })
  ), l += u.move(i), s()), l += u.move(")"), a(), l;
}
function RZe() {
  return "!";
}
vq.peek = $Ze;
function vq(t, e, n, r) {
  const i = t.referenceType, o = n.enter("imageReference");
  let a = n.enter("label");
  const s = n.createTracker(r);
  let u = s.move("![");
  const l = n.safe(t.alt, {
    before: u,
    after: "]",
    ...s.current()
  });
  u += s.move(l + "]["), a();
  const c = n.stack;
  n.stack = [], a = n.enter("reference");
  const d = n.safe(n.associationId(t), {
    before: u,
    after: "]",
    ...s.current()
  });
  return a(), n.stack = c, o(), i === "full" || !l || l !== d ? u += s.move(d + "]") : i === "shortcut" ? u = u.slice(0, -1) : u += s.move("]"), u;
}
function $Ze() {
  return "!";
}
bq.peek = DZe;
function bq(t, e, n) {
  let r = t.value || "", i = "`", o = -1;
  for (; new RegExp("(^|[^`])" + i + "([^`]|$)").test(r); )
    i += "`";
  for (/[^ \r\n]/.test(r) && (/^[ \r\n]/.test(r) && /[ \r\n]$/.test(r) || /^`|`$/.test(r)) && (r = " " + r + " "); ++o < n.unsafe.length; ) {
    const a = n.unsafe[o], s = n.compilePattern(a);
    let u;
    if (a.atBreak)
      for (; u = s.exec(r); ) {
        let l = u.index;
        r.charCodeAt(l) === 10 && r.charCodeAt(l - 1) === 13 && l--, r = r.slice(0, l) + " " + r.slice(u.index + 1);
      }
  }
  return i + r + i;
}
function DZe() {
  return "`";
}
function yq(t, e) {
  const n = fq(t);
  return !!(!e.options.resourceLink && // If there’s a url…
  t.url && // And there’s a no title…
  !t.title && // And the content of `node` is a single text node…
  t.children && t.children.length === 1 && t.children[0].type === "text" && // And if the url is the same as the content…
  (n === t.url || "mailto:" + n === t.url) && // And that starts w/ a protocol…
  /^[a-z][a-z+.-]+:/i.test(t.url) && // And that doesn’t contain ASCII control codes (character escapes and
  // references don’t work), space, or angle brackets…
  !/[\0- <>\u007F]/.test(t.url));
}
xq.peek = MZe;
function xq(t, e, n, r) {
  const i = bO(n), o = i === '"' ? "Quote" : "Apostrophe", a = n.createTracker(r);
  let s, u;
  if (yq(t, n)) {
    const c = n.stack;
    n.stack = [], s = n.enter("autolink");
    let d = a.move("<");
    return d += a.move(
      n.containerPhrasing(t, {
        before: d,
        after: ">",
        ...a.current()
      })
    ), d += a.move(">"), s(), n.stack = c, d;
  }
  s = n.enter("link"), u = n.enter("label");
  let l = a.move("[");
  return l += a.move(
    n.containerPhrasing(t, {
      before: l,
      after: "](",
      ...a.current()
    })
  ), l += a.move("]("), u(), // If there’s no url but there is a title…
  !t.url && t.title || // If there are control characters or whitespace.
  /[\0- \u007F]/.test(t.url) ? (u = n.enter("destinationLiteral"), l += a.move("<"), l += a.move(
    n.safe(t.url, { before: l, after: ">", ...a.current() })
  ), l += a.move(">")) : (u = n.enter("destinationRaw"), l += a.move(
    n.safe(t.url, {
      before: l,
      after: t.title ? " " : ")",
      ...a.current()
    })
  )), u(), t.title && (u = n.enter(`title${o}`), l += a.move(" " + i), l += a.move(
    n.safe(t.title, {
      before: l,
      after: i,
      ...a.current()
    })
  ), l += a.move(i), u()), l += a.move(")"), s(), l;
}
function MZe(t, e, n) {
  return yq(t, n) ? "<" : "[";
}
Cq.peek = FZe;
function Cq(t, e, n, r) {
  const i = t.referenceType, o = n.enter("linkReference");
  let a = n.enter("label");
  const s = n.createTracker(r);
  let u = s.move("[");
  const l = n.containerPhrasing(t, {
    before: u,
    after: "]",
    ...s.current()
  });
  u += s.move(l + "]["), a();
  const c = n.stack;
  n.stack = [], a = n.enter("reference");
  const d = n.safe(n.associationId(t), {
    before: u,
    after: "]",
    ...s.current()
  });
  return a(), n.stack = c, o(), i === "full" || !l || l !== d ? u += s.move(d + "]") : i === "shortcut" ? u = u.slice(0, -1) : u += s.move("]"), u;
}
function FZe() {
  return "[";
}
function yO(t) {
  const e = t.options.bullet || "*";
  if (e !== "*" && e !== "+" && e !== "-")
    throw new Error(
      "Cannot serialize items with `" + e + "` for `options.bullet`, expected `*`, `+`, or `-`"
    );
  return e;
}
function LZe(t) {
  const e = yO(t), n = t.options.bulletOther;
  if (!n)
    return e === "*" ? "-" : "*";
  if (n !== "*" && n !== "+" && n !== "-")
    throw new Error(
      "Cannot serialize items with `" + n + "` for `options.bulletOther`, expected `*`, `+`, or `-`"
    );
  if (n === e)
    throw new Error(
      "Expected `bullet` (`" + e + "`) and `bulletOther` (`" + n + "`) to be different"
    );
  return n;
}
function VZe(t) {
  const e = t.options.bulletOrdered || ".";
  if (e !== "." && e !== ")")
    throw new Error(
      "Cannot serialize items with `" + e + "` for `options.bulletOrdered`, expected `.` or `)`"
    );
  return e;
}
function wq(t) {
  const e = t.options.rule || "*";
  if (e !== "*" && e !== "-" && e !== "_")
    throw new Error(
      "Cannot serialize rules with `" + e + "` for `options.rule`, expected `*`, `-`, or `_`"
    );
  return e;
}
function BZe(t, e, n, r) {
  const i = n.enter("list"), o = n.bulletCurrent;
  let a = t.ordered ? VZe(n) : yO(n);
  const s = t.ordered ? a === "." ? ")" : "." : LZe(n);
  let u = e && n.bulletLastUsed ? a === n.bulletLastUsed : !1;
  if (!t.ordered) {
    const c = t.children ? t.children[0] : void 0;
    if (
      // Bullet could be used as a thematic break marker:
      (a === "*" || a === "-") && // Empty first list item:
      c && (!c.children || !c.children[0]) && // Directly in two other list items:
      n.stack[n.stack.length - 1] === "list" && n.stack[n.stack.length - 2] === "listItem" && n.stack[n.stack.length - 3] === "list" && n.stack[n.stack.length - 4] === "listItem" && // That are each the first child.
      n.indexStack[n.indexStack.length - 1] === 0 && n.indexStack[n.indexStack.length - 2] === 0 && n.indexStack[n.indexStack.length - 3] === 0 && (u = !0), wq(n) === a && c
    ) {
      let d = -1;
      for (; ++d < t.children.length; ) {
        const f = t.children[d];
        if (f && f.type === "listItem" && f.children && f.children[0] && f.children[0].type === "thematicBreak") {
          u = !0;
          break;
        }
      }
    }
  }
  u && (a = s), n.bulletCurrent = a;
  const l = n.containerFlow(t, r);
  return n.bulletLastUsed = a, n.bulletCurrent = o, i(), l;
}
function HZe(t) {
  const e = t.options.listItemIndent || "one";
  if (e !== "tab" && e !== "one" && e !== "mixed")
    throw new Error(
      "Cannot serialize items with `" + e + "` for `options.listItemIndent`, expected `tab`, `one`, or `mixed`"
    );
  return e;
}
function WZe(t, e, n, r) {
  const i = HZe(n);
  let o = n.bulletCurrent || yO(n);
  e && e.type === "list" && e.ordered && (o = (typeof e.start == "number" && e.start > -1 ? e.start : 1) + (n.options.incrementListMarker === !1 ? 0 : e.children.indexOf(t)) + o);
  let a = o.length + 1;
  (i === "tab" || i === "mixed" && (e && e.type === "list" && e.spread || t.spread)) && (a = Math.ceil(a / 4) * 4);
  const s = n.createTracker(r);
  s.move(o + " ".repeat(a - o.length)), s.shift(a);
  const u = n.enter("listItem"), l = n.indentLines(
    n.containerFlow(t, s.current()),
    c
  );
  return u(), l;
  function c(d, f, h) {
    return f ? (h ? "" : " ".repeat(a)) + d : (h ? o : o + " ".repeat(a - o.length)) + d;
  }
}
function jZe(t, e, n, r) {
  const i = n.enter("paragraph"), o = n.enter("phrasing"), a = n.containerPhrasing(t, r);
  return o(), i(), a;
}
const Eq = (
  // Note: overloads in JSDoc can’t yet use different `@template`s.
  /**
   * @type {(
   *   (<Condition extends string>(test: Condition) => (node: unknown, index?: number | null | undefined, parent?: Parent | null | undefined, context?: unknown) => node is Node & {type: Condition}) &
   *   (<Condition extends Props>(test: Condition) => (node: unknown, index?: number | null | undefined, parent?: Parent | null | undefined, context?: unknown) => node is Node & Condition) &
   *   (<Condition extends TestFunction>(test: Condition) => (node: unknown, index?: number | null | undefined, parent?: Parent | null | undefined, context?: unknown) => node is Node & Predicate<Condition, Node>) &
   *   ((test?: null | undefined) => (node?: unknown, index?: number | null | undefined, parent?: Parent | null | undefined, context?: unknown) => node is Node) &
   *   ((test?: Test) => Check)
   * )}
   */
  /**
   * @param {Test} [test]
   * @returns {Check}
   */
  function(t) {
    if (t == null)
      return XZe;
    if (typeof t == "function")
      return kw(t);
    if (typeof t == "object")
      return Array.isArray(t) ? zZe(t) : GZe(t);
    if (typeof t == "string")
      return UZe(t);
    throw new Error("Expected function, string, or object as test");
  }
);
function zZe(t) {
  const e = [];
  let n = -1;
  for (; ++n < t.length; )
    e[n] = Eq(t[n]);
  return kw(r);
  function r(...i) {
    let o = -1;
    for (; ++o < e.length; )
      if (e[o].apply(this, i))
        return !0;
    return !1;
  }
}
function GZe(t) {
  const e = (
    /** @type {Record<string, unknown>} */
    t
  );
  return kw(n);
  function n(r) {
    const i = (
      /** @type {Record<string, unknown>} */
      /** @type {unknown} */
      r
    );
    let o;
    for (o in t)
      if (i[o] !== e[o])
        return !1;
    return !0;
  }
}
function UZe(t) {
  return kw(e);
  function e(n) {
    return n && n.type === t;
  }
}
function kw(t) {
  return e;
  function e(n, r, i) {
    return !!(YZe(n) && t.call(
      this,
      n,
      typeof r == "number" ? r : void 0,
      i || void 0
    ));
  }
}
function XZe() {
  return !0;
}
function YZe(t) {
  return t !== null && typeof t == "object" && "type" in t;
}
const ZZe = (
  /** @type {(node?: unknown) => node is PhrasingContent} */
  Eq([
    "break",
    "delete",
    "emphasis",
    "footnote",
    "footnoteReference",
    "image",
    "imageReference",
    "inlineCode",
    "link",
    "linkReference",
    "strong",
    "text"
  ])
);
function JZe(t, e, n, r) {
  return (t.children.some(function(a) {
    return ZZe(a);
  }) ? n.containerPhrasing : n.containerFlow).call(n, t, r);
}
function KZe(t) {
  const e = t.options.strong || "*";
  if (e !== "*" && e !== "_")
    throw new Error(
      "Cannot serialize strong with `" + e + "` for `options.strong`, expected `*`, or `_`"
    );
  return e;
}
Sq.peek = qZe;
function Sq(t, e, n, r) {
  const i = KZe(n), o = n.enter("strong"), a = n.createTracker(r);
  let s = a.move(i + i);
  return s += a.move(
    n.containerPhrasing(t, {
      before: s,
      after: i,
      ...a.current()
    })
  ), s += a.move(i + i), o(), s;
}
function qZe(t, e, n) {
  return n.options.strong || "*";
}
function QZe(t, e, n, r) {
  return n.safe(t.value, r);
}
function eJe(t) {
  const e = t.options.ruleRepetition || 3;
  if (e < 3)
    throw new Error(
      "Cannot serialize rules with repetition `" + e + "` for `options.ruleRepetition`, expected `3` or more"
    );
  return e;
}
function tJe(t, e, n) {
  const r = (wq(n) + (n.options.ruleSpaces ? " " : "")).repeat(eJe(n));
  return n.options.ruleSpaces ? r.slice(0, -1) : r;
}
const xO = {
  blockquote: cZe,
  break: UF,
  code: pZe,
  definition: mZe,
  emphasis: lq,
  hardBreak: UF,
  heading: NZe,
  html: gq,
  image: mq,
  imageReference: vq,
  inlineCode: bq,
  link: xq,
  linkReference: Cq,
  list: BZe,
  listItem: WZe,
  paragraph: jZe,
  root: JZe,
  strong: Sq,
  text: QZe,
  thematicBreak: tJe
}, nJe = [rJe];
function rJe(t, e, n, r) {
  if (e.type === "code" && k4(e, r) && (t.type === "list" || t.type === e.type && k4(t, r)))
    return !1;
  if ("spread" in n && typeof n.spread == "boolean")
    return t.type === "paragraph" && // Two paragraphs.
    (t.type === e.type || e.type === "definition" || // Paragraph followed by a setext heading.
    e.type === "heading" && pq(e, r)) ? void 0 : n.spread ? 1 : 0;
}
const qc = [
  "autolink",
  "destinationLiteral",
  "destinationRaw",
  "reference",
  "titleQuote",
  "titleApostrophe"
], iJe = [
  { character: "	", after: "[\\r\\n]", inConstruct: "phrasing" },
  { character: "	", before: "[\\r\\n]", inConstruct: "phrasing" },
  {
    character: "	",
    inConstruct: ["codeFencedLangGraveAccent", "codeFencedLangTilde"]
  },
  {
    character: "\r",
    inConstruct: [
      "codeFencedLangGraveAccent",
      "codeFencedLangTilde",
      "codeFencedMetaGraveAccent",
      "codeFencedMetaTilde",
      "destinationLiteral",
      "headingAtx"
    ]
  },
  {
    character: `
`,
    inConstruct: [
      "codeFencedLangGraveAccent",
      "codeFencedLangTilde",
      "codeFencedMetaGraveAccent",
      "codeFencedMetaTilde",
      "destinationLiteral",
      "headingAtx"
    ]
  },
  { character: " ", after: "[\\r\\n]", inConstruct: "phrasing" },
  { character: " ", before: "[\\r\\n]", inConstruct: "phrasing" },
  {
    character: " ",
    inConstruct: ["codeFencedLangGraveAccent", "codeFencedLangTilde"]
  },
  // An exclamation mark can start an image, if it is followed by a link or
  // a link reference.
  {
    character: "!",
    after: "\\[",
    inConstruct: "phrasing",
    notInConstruct: qc
  },
  // A quote can break out of a title.
  { character: '"', inConstruct: "titleQuote" },
  // A number sign could start an ATX heading if it starts a line.
  { atBreak: !0, character: "#" },
  { character: "#", inConstruct: "headingAtx", after: `(?:[\r
]|$)` },
  // Dollar sign and percentage are not used in markdown.
  // An ampersand could start a character reference.
  { character: "&", after: "[#A-Za-z]", inConstruct: "phrasing" },
  // An apostrophe can break out of a title.
  { character: "'", inConstruct: "titleApostrophe" },
  // A left paren could break out of a destination raw.
  { character: "(", inConstruct: "destinationRaw" },
  // A left paren followed by `]` could make something into a link or image.
  {
    before: "\\]",
    character: "(",
    inConstruct: "phrasing",
    notInConstruct: qc
  },
  // A right paren could start a list item or break out of a destination
  // raw.
  { atBreak: !0, before: "\\d+", character: ")" },
  { character: ")", inConstruct: "destinationRaw" },
  // An asterisk can start thematic breaks, list items, emphasis, strong.
  { atBreak: !0, character: "*", after: `(?:[ 	\r
*])` },
  { character: "*", inConstruct: "phrasing", notInConstruct: qc },
  // A plus sign could start a list item.
  { atBreak: !0, character: "+", after: `(?:[ 	\r
])` },
  // A dash can start thematic breaks, list items, and setext heading
  // underlines.
  { atBreak: !0, character: "-", after: `(?:[ 	\r
-])` },
  // A dot could start a list item.
  { atBreak: !0, before: "\\d+", character: ".", after: `(?:[ 	\r
]|$)` },
  // Slash, colon, and semicolon are not used in markdown for constructs.
  // A less than can start html (flow or text) or an autolink.
  // HTML could start with an exclamation mark (declaration, cdata, comment),
  // slash (closing tag), question mark (instruction), or a letter (tag).
  // An autolink also starts with a letter.
  // Finally, it could break out of a destination literal.
  { atBreak: !0, character: "<", after: "[!/?A-Za-z]" },
  {
    character: "<",
    after: "[!/?A-Za-z]",
    inConstruct: "phrasing",
    notInConstruct: qc
  },
  { character: "<", inConstruct: "destinationLiteral" },
  // An equals to can start setext heading underlines.
  { atBreak: !0, character: "=" },
  // A greater than can start block quotes and it can break out of a
  // destination literal.
  { atBreak: !0, character: ">" },
  { character: ">", inConstruct: "destinationLiteral" },
  // Question mark and at sign are not used in markdown for constructs.
  // A left bracket can start definitions, references, labels,
  { atBreak: !0, character: "[" },
  { character: "[", inConstruct: "phrasing", notInConstruct: qc },
  { character: "[", inConstruct: ["label", "reference"] },
  // A backslash can start an escape (when followed by punctuation) or a
  // hard break (when followed by an eol).
  // Note: typical escapes are handled in `safe`!
  { character: "\\", after: "[\\r\\n]", inConstruct: "phrasing" },
  // A right bracket can exit labels.
  { character: "]", inConstruct: ["label", "reference"] },
  // Caret is not used in markdown for constructs.
  // An underscore can start emphasis, strong, or a thematic break.
  { atBreak: !0, character: "_" },
  { character: "_", inConstruct: "phrasing", notInConstruct: qc },
  // A grave accent can start code (fenced or text), or it can break out of
  // a grave accent code fence.
  { atBreak: !0, character: "`" },
  {
    character: "`",
    inConstruct: ["codeFencedLangGraveAccent", "codeFencedMetaGraveAccent"]
  },
  { character: "`", inConstruct: "phrasing", notInConstruct: qc },
  // Left brace, vertical bar, right brace are not used in markdown for
  // constructs.
  // A tilde can start code (fenced).
  { atBreak: !0, character: "~" }
];
function Iq(t, e) {
  const n = Number.parseInt(t, e);
  return (
    // C0 except for HT, LF, FF, CR, space.
    n < 9 || n === 11 || n > 13 && n < 32 || // Control character (DEL) of C0, and C1 controls.
    n > 126 && n < 160 || // Lone high surrogates and low surrogates.
    n > 55295 && n < 57344 || // Noncharacters.
    n > 64975 && n < 65008 || /* eslint-disable no-bitwise */
    (n & 65535) === 65535 || (n & 65535) === 65534 || /* eslint-enable no-bitwise */
    // Out of range
    n > 1114111 ? "�" : String.fromCodePoint(n)
  );
}
const oJe = /\\([!-/:-@[-`{-~])|&(#(?:\d{1,7}|x[\da-f]{1,6})|[\da-z]{1,31});/gi;
function _q(t) {
  return t.replace(oJe, aJe);
}
function aJe(t, e, n) {
  if (e)
    return e;
  if (n.charCodeAt(0) === 35) {
    const i = n.charCodeAt(1), o = i === 120 || i === 88;
    return Iq(n.slice(o ? 2 : 1), o ? 16 : 10);
  }
  return gm(n) || t;
}
function sJe(t) {
  return t.label || !t.identifier ? t.label || "" : _q(t.identifier);
}
function uJe(t) {
  if (!t._compiled) {
    const e = (t.atBreak ? "[\\r\\n][\\t ]*" : "") + (t.before ? "(?:" + t.before + ")" : "");
    t._compiled = new RegExp(
      (e ? "(" + e + ")" : "") + (/[|\\{}()[\]^$+*?.-]/.test(t.character) ? "\\" : "") + t.character + (t.after ? "(?:" + t.after + ")" : ""),
      "g"
    );
  }
  return t._compiled;
}
function lJe(t, e, n) {
  const r = e.indexStack, i = t.children || [], o = [];
  let a = -1, s = n.before;
  r.push(-1);
  let u = e.createTracker(n);
  for (; ++a < i.length; ) {
    const l = i[a];
    let c;
    if (r[r.length - 1] = a, a + 1 < i.length) {
      let d = e.handle.handlers[i[a + 1].type];
      d && d.peek && (d = d.peek), c = d ? d(i[a + 1], t, e, {
        before: "",
        after: "",
        ...u.current()
      }).charAt(0) : "";
    } else
      c = n.after;
    o.length > 0 && (s === "\r" || s === `
`) && l.type === "html" && (o[o.length - 1] = o[o.length - 1].replace(
      /(\r?\n|\r)$/,
      " "
    ), s = " ", u = e.createTracker(n), u.move(o.join(""))), o.push(
      u.move(
        e.handle(l, t, e, {
          ...u.current(),
          before: s,
          after: c
        })
      )
    ), s = o[o.length - 1].slice(-1);
  }
  return r.pop(), o.join("");
}
function cJe(t, e, n) {
  const r = e.indexStack, i = t.children || [], o = e.createTracker(n), a = [];
  let s = -1;
  for (r.push(-1); ++s < i.length; ) {
    const u = i[s];
    r[r.length - 1] = s, a.push(
      o.move(
        e.handle(u, t, e, {
          before: `
`,
          after: `
`,
          ...o.current()
        })
      )
    ), u.type !== "list" && (e.bulletLastUsed = void 0), s < i.length - 1 && a.push(
      o.move(dJe(u, i[s + 1], t, e))
    );
  }
  return r.pop(), a.join("");
}
function dJe(t, e, n, r) {
  let i = r.join.length;
  for (; i--; ) {
    const o = r.join[i](t, e, n, r);
    if (o === !0 || o === 1)
      break;
    if (typeof o == "number")
      return `
`.repeat(1 + o);
    if (o === !1)
      return `

<!---->

`;
  }
  return `

`;
}
const fJe = /\r?\n|\r/g;
function hJe(t, e) {
  const n = [];
  let r = 0, i = 0, o;
  for (; o = fJe.exec(t); )
    a(t.slice(r, o.index)), n.push(o[0]), r = o.index + o[0].length, i++;
  return a(t.slice(r)), n.join("");
  function a(s) {
    n.push(e(s, i, !s));
  }
}
function pJe(t, e, n) {
  const r = (n.before || "") + (e || "") + (n.after || ""), i = [], o = [], a = {};
  let s = -1;
  for (; ++s < t.unsafe.length; ) {
    const c = t.unsafe[s];
    if (!uq(t.stack, c))
      continue;
    const d = t.compilePattern(c);
    let f;
    for (; f = d.exec(r); ) {
      const h = "before" in c || !!c.atBreak, p = "after" in c, v = f.index + (h ? f[1].length : 0);
      i.includes(v) ? (a[v].before && !h && (a[v].before = !1), a[v].after && !p && (a[v].after = !1)) : (i.push(v), a[v] = { before: h, after: p });
    }
  }
  i.sort(gJe);
  let u = n.before ? n.before.length : 0;
  const l = r.length - (n.after ? n.after.length : 0);
  for (s = -1; ++s < i.length; ) {
    const c = i[s];
    c < u || c >= l || c + 1 < l && i[s + 1] === c + 1 && a[c].after && !a[c + 1].before && !a[c + 1].after || i[s - 1] === c - 1 && a[c].before && !a[c - 1].before && !a[c - 1].after || (u !== c && o.push(YF(r.slice(u, c), "\\")), u = c, /[!-/:-@[-`{-~]/.test(r.charAt(c)) && (!n.encode || !n.encode.includes(r.charAt(c))) ? o.push("\\") : (o.push(
      "&#x" + r.charCodeAt(c).toString(16).toUpperCase() + ";"
    ), u++));
  }
  return o.push(YF(r.slice(u, l), n.after)), o.join("");
}
function gJe(t, e) {
  return t - e;
}
function YF(t, e) {
  const n = /\\(?=[!-/:-@[-`{-~])/g, r = [], i = [], o = t + e;
  let a = -1, s = 0, u;
  for (; u = n.exec(o); )
    r.push(u.index);
  for (; ++a < r.length; )
    s !== r[a] && i.push(t.slice(s, r[a])), i.push("\\"), s = r[a];
  return i.push(t.slice(s)), i.join("");
}
function mJe(t) {
  const e = t || {}, n = e.now || {};
  let r = e.lineShift || 0, i = n.line || 1, o = n.column || 1;
  return { move: u, current: a, shift: s };
  function a() {
    return { now: { line: i, column: o }, lineShift: r };
  }
  function s(l) {
    r += l;
  }
  function u(l) {
    const c = l || "", d = c.split(/\r?\n|\r/g), f = d[d.length - 1];
    return i += d.length - 1, o = d.length === 1 ? o + f.length : 1 + f.length + r, c;
  }
}
function Aq(t, e = {}) {
  const n = {
    enter: i,
    indentLines: hJe,
    associationId: sJe,
    containerPhrasing: xJe,
    containerFlow: CJe,
    createTracker: mJe,
    compilePattern: uJe,
    safe: wJe,
    stack: [],
    unsafe: [...iJe],
    join: [...nJe],
    // @ts-expect-error: GFM / frontmatter are typed in `mdast` but not defined
    // here.
    handlers: { ...xO },
    options: {},
    indexStack: [],
    // @ts-expect-error: add `handle` in a second.
    handle: void 0
  };
  sq(n, e), n.options.tightDefinitions && n.join.push(yJe), n.handle = sZe("type", {
    invalid: vJe,
    unknown: bJe,
    handlers: n.handlers
  });
  let r = n.handle(t, void 0, n, {
    before: `
`,
    after: `
`,
    now: { line: 1, column: 1 },
    lineShift: 0
  });
  return r && r.charCodeAt(r.length - 1) !== 10 && r.charCodeAt(r.length - 1) !== 13 && (r += `
`), r;
  function i(o) {
    return n.stack.push(o), a;
    function a() {
      n.stack.pop();
    }
  }
}
function vJe(t) {
  throw new Error("Cannot handle value `" + t + "`, expected node");
}
function bJe(t) {
  const e = (
    /** @type {Nodes} */
    t
  );
  throw new Error("Cannot handle unknown node `" + e.type + "`");
}
function yJe(t, e) {
  if (t.type === "definition" && t.type === e.type)
    return 0;
}
function xJe(t, e) {
  return lJe(t, this, e);
}
function CJe(t, e) {
  return cJe(t, this, e);
}
function wJe(t, e) {
  return pJe(this, t, e);
}
const EJe = ["mdxJsxTextElement", "mdxJsxFlowElement"];
function Tq(t) {
  return EJe.includes(t.type) && SJe.includes(t.name.toLowerCase());
}
const SJe = [
  "a",
  "abbr",
  "address",
  "area",
  "article",
  "aside",
  "audio",
  "b",
  "base",
  "bdi",
  "bdo",
  "blockquote",
  "body",
  "br",
  "button",
  "canvas",
  "caption",
  "cite",
  "code",
  "col",
  "colgroup",
  "data",
  "datalist",
  "dd",
  "del",
  "details",
  "dfn",
  "dialog",
  "div",
  "dl",
  "dt",
  "em",
  "embed",
  "fieldset",
  "figcaption",
  "figure",
  "footer",
  "form",
  "h1",
  "h2",
  "h3",
  "h4",
  "h5",
  "h6",
  "head",
  "header",
  "hgroup",
  "hr",
  "html",
  "i",
  "iframe",
  // 'img',
  "input",
  "ins",
  "kbd",
  "label",
  "legend",
  "li",
  "link",
  "main",
  "map",
  "mark",
  "meta",
  "meter",
  "nav",
  "noscript",
  "object",
  "ol",
  "optgroup",
  "option",
  "output",
  "p",
  "param",
  "picture",
  "pre",
  "progress",
  "q",
  "rp",
  "rt",
  "ruby",
  "s",
  "samp",
  "script",
  "section",
  "select",
  "small",
  "source",
  "span",
  "strong",
  "style",
  "sub",
  "summary",
  "sup",
  "table",
  "tbody",
  "td",
  "template",
  "textarea",
  "tfoot",
  "th",
  "thead",
  "time",
  "title",
  "tr",
  "track",
  "u",
  "ul",
  "var",
  "video",
  "wbr"
];
function IJe(t, e) {
  const n = ZF(t), r = ZF(e), i = { ...n, ...r };
  return _Je(i);
}
function ZF(t) {
  const e = {};
  return t.split(";").filter((r) => r.trim() !== "").forEach((r) => {
    const [i, o] = r.split(":").map((a) => a.trim());
    e[i] = o;
  }), e;
}
function _Je(t) {
  return Object.entries(t).map(([e, n]) => `${e}: ${n}`).join("; ");
}
function AJe(t) {
  return t.children instanceof Array;
}
function Oq({
  root: t,
  visitors: e,
  jsxComponentDescriptors: n,
  jsxIsAvailable: r,
  addImportStatements: i = !0
}) {
  let o = null;
  const a = /* @__PURE__ */ new Set();
  e = e.sort((m, b) => (b.priority ?? 0) - (m.priority ?? 0)), c(t, null);
  function s(m) {
    a.add(m);
  }
  function u(m, b) {
    if (o === null)
      return o = b, o;
    if (!AJe(m))
      throw new Error("Attempting to append children to a non-parent");
    const y = m.children, w = y.at(-1);
    if (w) {
      const S = e.find((E) => {
        var I;
        return (I = E.shouldJoin) == null ? void 0 : I.call(E, w, b);
      });
      if (S) {
        const E = S.join(w, b);
        return y.splice(y.length - 1, 1, E), E;
      }
    }
    return y.push(b), b;
  }
  function l(m, b) {
    m.getChildren().forEach((y) => {
      c(y, b);
    });
  }
  function c(m, b) {
    var y;
    const w = e.find((S) => {
      var E;
      return (E = S.testLexicalNode) == null ? void 0 : E.call(S, m);
    });
    if (!w)
      throw new Error(`no lexical visitor found for ${m.getType()}`, {
        cause: m
      });
    (y = w.visitLexicalNode) == null || y.call(w, {
      lexicalNode: m,
      mdastParent: b,
      actions: {
        addAndStepInto(S, E = {}, I = !0) {
          const _ = {
            type: S,
            ...E,
            ...I ? { children: [] } : {}
          };
          u(b, _), We(m) && I && l(m, _);
        },
        appendToParent: u,
        visitChildren: l,
        registerReferredComponent: s
      }
    });
  }
  if (o === null)
    throw new Error("traversal ended with no root element");
  const d = /* @__PURE__ */ new Map(), f = /* @__PURE__ */ new Map();
  for (const m of a) {
    const b = n.find((y) => y.name === m) ?? n.find((y) => y.name === "*");
    if (!b)
      throw new Error(`Component ${m} is used but not imported`);
    if (b.source)
      if (b.defaultExport)
        f.set(m, b.source);
      else {
        const { source: y } = b, w = d.get(y);
        w ? w.push(m) : d.set(y, [m]);
      }
  }
  const h = Array.from(d).map(([m, b]) => ({
    type: "mdxjsEsm",
    value: `import { ${b.join(", ")} } from '${m}'`
  }));
  h.push(
    ...Array.from(f).map(([m, b]) => ({
      type: "mdxjsEsm",
      value: `import ${m} from '${b}'`
    }))
  );
  const p = o, v = p.children.find((m) => m.type === "yaml");
  return i && (v ? p.children.splice(p.children.indexOf(v) + 1, 0, ...h) : p.children.unshift(...h)), Ey(p, []), Pq(p), r || Nq(p), p;
}
function Pq(t) {
  if ("children" in t && t.children.length > 0) {
    if (Tq(t) && t.children.length === 1) {
      const e = t.children[0];
      e.type === "mdxJsxTextElement" && e.name === "span" && (e.attributes.forEach((n) => {
        if (n.type === "mdxJsxAttribute") {
          const r = t.attributes.find((i) => i.type === "mdxJsxAttribute" && i.name === n.name);
          if (r)
            if (n.name === "className") {
              const i = /* @__PURE__ */ new Set([
                ...r.value.split(" "),
                ...n.value.split(" ")
              ]);
              r.value = Array.from(i).join(" ");
            } else
              n.name === "style" && (r.value = IJe(r.value, n.value));
          else
            t.attributes.push(n);
        }
      }), t.children = e.children);
    }
    t.children.forEach((e) => {
      Pq(e);
    });
  }
}
function Nq(t) {
  if (Object.hasOwn(t, "children")) {
    const e = t, n = [];
    e.children.forEach((r) => {
      r.type === "mdxJsxTextElement" && r.name === "u" ? n.push({ type: "html", value: "<u>" }, ...r.children, { type: "html", value: "</u>" }) : (n.push(r), Nq(r));
    }), e.children = n;
  }
}
const JF = /\s+$/, KF = /^\s+/;
function Ey(t, e) {
  if (t.type === "strong" || t.type === "emphasis") {
    const n = t.children.at(-1);
    if ((n == null ? void 0 : n.type) === "text") {
      const i = n.value.match(JF);
      if (i) {
        n.value = n.value.replace(JF, "");
        const o = e.at(-1);
        o && (o.children.splice(o.children.indexOf(t) + 1, 0, {
          type: "text",
          value: i[0]
        }), Ey(o, e.slice(0, -1)));
      }
    }
    const r = t.children.at(0);
    if ((r == null ? void 0 : r.type) === "text") {
      const i = r.value.match(KF);
      if (i) {
        r.value = r.value.replace(KF, "");
        const o = e.at(-1);
        o && (o.children.splice(o.children.indexOf(t), 0, {
          type: "text",
          value: i[0]
        }), Ey(o, e.slice(0, -1)));
      }
    }
  }
  if ("children" in t && t.children.length > 0) {
    const n = t;
    n.children.forEach((r) => {
      Ey(r, [...e, n]);
    });
  }
}
function TJe({
  root: t,
  toMarkdownOptions: e,
  toMarkdownExtensions: n,
  visitors: r,
  jsxComponentDescriptors: i,
  jsxIsAvailable: o
}) {
  return Aq(Oq({ root: t, visitors: r, jsxComponentDescriptors: i, jsxIsAvailable: o }), {
    extensions: n,
    ...e
  }) + `
`;
}
const OJe = {};
function PJe(t, e) {
  const n = e || OJe, r = typeof n.includeImageAlt == "boolean" ? n.includeImageAlt : !0, i = typeof n.includeHtml == "boolean" ? n.includeHtml : !0;
  return kq(t, r, i);
}
function kq(t, e, n) {
  if (NJe(t)) {
    if ("value" in t)
      return t.type === "html" && !n ? "" : t.value;
    if (e && "alt" in t && t.alt)
      return t.alt;
    if ("children" in t)
      return qF(t.children, e, n);
  }
  return Array.isArray(t) ? qF(t, e, n) : "";
}
function qF(t, e, n) {
  const r = [];
  let i = -1;
  for (; ++i < t.length; )
    r[i] = kq(t[i], e, n);
  return r.join("");
}
function NJe(t) {
  return !!(t && typeof t == "object");
}
const QF = {}.hasOwnProperty;
function kJe(t) {
  const e = {};
  let n = -1;
  for (; ++n < t.length; )
    RJe(e, t[n]);
  return e;
}
function RJe(t, e) {
  let n;
  for (n in e) {
    const i = (QF.call(t, n) ? t[n] : void 0) || (t[n] = {}), o = e[n];
    let a;
    if (o)
      for (a in o) {
        QF.call(i, a) || (i[a] = []);
        const s = o[a];
        $Je(
          // @ts-expect-error Looks like a list.
          i[a],
          Array.isArray(s) ? s : s ? [s] : []
        );
      }
  }
}
function $Je(t, e) {
  let n = -1;
  const r = [];
  for (; ++n < e.length; )
    (e[n].add === "after" ? t : r).push(e[n]);
  la(t, 0, 0, r);
}
function Xh(t) {
  return t.replace(/[\t\n\r ]+/g, " ").replace(/^ | $/g, "").toLowerCase().toUpperCase();
}
const DJe = {
  tokenize: MJe
};
function MJe(t) {
  const e = t.attempt(
    this.parser.constructs.contentInitial,
    r,
    i
  );
  let n;
  return e;
  function r(s) {
    if (s === null) {
      t.consume(s);
      return;
    }
    return t.enter("lineEnding"), t.consume(s), t.exit("lineEnding"), Bn(t, e, "linePrefix");
  }
  function i(s) {
    return t.enter("paragraph"), o(s);
  }
  function o(s) {
    const u = t.enter("chunkText", {
      contentType: "text",
      previous: n
    });
    return n && (n.next = u), n = u, a(s);
  }
  function a(s) {
    if (s === null) {
      t.exit("chunkText"), t.exit("paragraph"), t.consume(s);
      return;
    }
    return Dt(s) ? (t.consume(s), t.exit("chunkText"), o) : (t.consume(s), a);
  }
}
const FJe = {
  tokenize: LJe
}, eL = {
  tokenize: VJe
};
function LJe(t) {
  const e = this, n = [];
  let r = 0, i, o, a;
  return s;
  function s(w) {
    if (r < n.length) {
      const S = n[r];
      return e.containerState = S[1], t.attempt(
        S[0].continuation,
        u,
        l
      )(w);
    }
    return l(w);
  }
  function u(w) {
    if (r++, e.containerState._closeFlow) {
      e.containerState._closeFlow = void 0, i && y();
      const S = e.events.length;
      let E = S, I;
      for (; E--; )
        if (e.events[E][0] === "exit" && e.events[E][1].type === "chunkFlow") {
          I = e.events[E][1].end;
          break;
        }
      b(r);
      let _ = S;
      for (; _ < e.events.length; )
        e.events[_][1].end = Object.assign({}, I), _++;
      return la(
        e.events,
        E + 1,
        0,
        e.events.slice(S)
      ), e.events.length = _, l(w);
    }
    return s(w);
  }
  function l(w) {
    if (r === n.length) {
      if (!i)
        return f(w);
      if (i.currentConstruct && i.currentConstruct.concrete)
        return p(w);
      e.interrupt = !!(i.currentConstruct && !i._gfmTableDynamicInterruptHack);
    }
    return e.containerState = {}, t.check(
      eL,
      c,
      d
    )(w);
  }
  function c(w) {
    return i && y(), b(r), f(w);
  }
  function d(w) {
    return e.parser.lazy[e.now().line] = r !== n.length, a = e.now().offset, p(w);
  }
  function f(w) {
    return e.containerState = {}, t.attempt(
      eL,
      h,
      p
    )(w);
  }
  function h(w) {
    return r++, n.push([e.currentConstruct, e.containerState]), f(w);
  }
  function p(w) {
    if (w === null) {
      i && y(), b(0), t.consume(w);
      return;
    }
    return i = i || e.parser.flow(e.now()), t.enter("chunkFlow", {
      contentType: "flow",
      previous: o,
      _tokenizer: i
    }), v(w);
  }
  function v(w) {
    if (w === null) {
      m(t.exit("chunkFlow"), !0), b(0), t.consume(w);
      return;
    }
    return Dt(w) ? (t.consume(w), m(t.exit("chunkFlow")), r = 0, e.interrupt = void 0, s) : (t.consume(w), v);
  }
  function m(w, S) {
    const E = e.sliceStream(w);
    if (S && E.push(null), w.previous = o, o && (o.next = w), o = w, i.defineSkip(w.start), i.write(E), e.parser.lazy[w.start.line]) {
      let I = i.events.length;
      for (; I--; )
        if (
          // The token starts before the line ending…
          i.events[I][1].start.offset < a && // …and either is not ended yet…
          (!i.events[I][1].end || // …or ends after it.
          i.events[I][1].end.offset > a)
        )
          return;
      const _ = e.events.length;
      let A = _, P, N;
      for (; A--; )
        if (e.events[A][0] === "exit" && e.events[A][1].type === "chunkFlow") {
          if (P) {
            N = e.events[A][1].end;
            break;
          }
          P = !0;
        }
      for (b(r), I = _; I < e.events.length; )
        e.events[I][1].end = Object.assign({}, N), I++;
      la(
        e.events,
        A + 1,
        0,
        e.events.slice(_)
      ), e.events.length = I;
    }
  }
  function b(w) {
    let S = n.length;
    for (; S-- > w; ) {
      const E = n[S];
      e.containerState = E[1], E[0].exit.call(e, t);
    }
    n.length = w;
  }
  function y() {
    i.write([null]), o = void 0, i = void 0, e.containerState._closeFlow = void 0;
  }
}
function VJe(t, e, n) {
  return Bn(
    t,
    t.attempt(this.parser.constructs.document, e, n),
    "linePrefix",
    this.parser.constructs.disable.null.includes("codeIndented") ? void 0 : 4
  );
}
const $4 = {
  name: "attention",
  tokenize: HJe,
  resolveAll: BJe
};
function BJe(t, e) {
  let n = -1, r, i, o, a, s, u, l, c;
  for (; ++n < t.length; )
    if (t[n][0] === "enter" && t[n][1].type === "attentionSequence" && t[n][1]._close) {
      for (r = n; r--; )
        if (t[r][0] === "exit" && t[r][1].type === "attentionSequence" && t[r][1]._open && // If the markers are the same:
        e.sliceSerialize(t[r][1]).charCodeAt(0) === e.sliceSerialize(t[n][1]).charCodeAt(0)) {
          if ((t[r][1]._close || t[n][1]._open) && (t[n][1].end.offset - t[n][1].start.offset) % 3 && !((t[r][1].end.offset - t[r][1].start.offset + t[n][1].end.offset - t[n][1].start.offset) % 3))
            continue;
          u = t[r][1].end.offset - t[r][1].start.offset > 1 && t[n][1].end.offset - t[n][1].start.offset > 1 ? 2 : 1;
          const d = Object.assign({}, t[r][1].end), f = Object.assign({}, t[n][1].start);
          tL(d, -u), tL(f, u), a = {
            type: u > 1 ? "strongSequence" : "emphasisSequence",
            start: d,
            end: Object.assign({}, t[r][1].end)
          }, s = {
            type: u > 1 ? "strongSequence" : "emphasisSequence",
            start: Object.assign({}, t[n][1].start),
            end: f
          }, o = {
            type: u > 1 ? "strongText" : "emphasisText",
            start: Object.assign({}, t[r][1].end),
            end: Object.assign({}, t[n][1].start)
          }, i = {
            type: u > 1 ? "strong" : "emphasis",
            start: Object.assign({}, a.start),
            end: Object.assign({}, s.end)
          }, t[r][1].end = Object.assign({}, a.start), t[n][1].start = Object.assign({}, s.end), l = [], t[r][1].end.offset - t[r][1].start.offset && (l = Ba(l, [
            ["enter", t[r][1], e],
            ["exit", t[r][1], e]
          ])), l = Ba(l, [
            ["enter", i, e],
            ["enter", a, e],
            ["exit", a, e],
            ["enter", o, e]
          ]), l = Ba(
            l,
            Pw(
              e.parser.constructs.insideSpan.null,
              t.slice(r + 1, n),
              e
            )
          ), l = Ba(l, [
            ["exit", o, e],
            ["enter", s, e],
            ["exit", s, e],
            ["exit", i, e]
          ]), t[n][1].end.offset - t[n][1].start.offset ? (c = 2, l = Ba(l, [
            ["enter", t[n][1], e],
            ["exit", t[n][1], e]
          ])) : c = 0, la(t, r - 1, n - r + 3, l), n = r + l.length - c - 2;
          break;
        }
    }
  for (n = -1; ++n < t.length; )
    t[n][1].type === "attentionSequence" && (t[n][1].type = "data");
  return t;
}
function HJe(t, e) {
  const n = this.parser.constructs.attentionMarkers.null, r = this.previous, i = m2(r);
  let o;
  return a;
  function a(u) {
    return o = u, t.enter("attentionSequence"), s(u);
  }
  function s(u) {
    if (u === o)
      return t.consume(u), s;
    const l = t.exit("attentionSequence"), c = m2(u), d = !c || c === 2 && i || n.includes(u), f = !i || i === 2 && c || n.includes(r);
    return l._open = !!(o === 42 ? d : d && (i || !f)), l._close = !!(o === 42 ? f : f && (c || !d)), e(u);
  }
}
function tL(t, e) {
  t.column += e, t.offset += e, t._bufferIndex += e;
}
const WJe = {
  name: "autolink",
  tokenize: jJe
};
function jJe(t, e, n) {
  let r = 0;
  return i;
  function i(h) {
    return t.enter("autolink"), t.enter("autolinkMarker"), t.consume(h), t.exit("autolinkMarker"), t.enter("autolinkProtocol"), o;
  }
  function o(h) {
    return qs(h) ? (t.consume(h), a) : l(h);
  }
  function a(h) {
    return h === 43 || h === 45 || h === 46 || Ps(h) ? (r = 1, s(h)) : l(h);
  }
  function s(h) {
    return h === 58 ? (t.consume(h), r = 0, u) : (h === 43 || h === 45 || h === 46 || Ps(h)) && r++ < 32 ? (t.consume(h), s) : (r = 0, l(h));
  }
  function u(h) {
    return h === 62 ? (t.exit("autolinkProtocol"), t.enter("autolinkMarker"), t.consume(h), t.exit("autolinkMarker"), t.exit("autolink"), e) : h === null || h === 32 || h === 60 || O4(h) ? n(h) : (t.consume(h), u);
  }
  function l(h) {
    return h === 64 ? (t.consume(h), c) : pYe(h) ? (t.consume(h), l) : n(h);
  }
  function c(h) {
    return Ps(h) ? d(h) : n(h);
  }
  function d(h) {
    return h === 46 ? (t.consume(h), r = 0, c) : h === 62 ? (t.exit("autolinkProtocol").type = "autolinkEmail", t.enter("autolinkMarker"), t.consume(h), t.exit("autolinkMarker"), t.exit("autolink"), e) : f(h);
  }
  function f(h) {
    if ((h === 45 || Ps(h)) && r++ < 63) {
      const p = h === 45 ? f : d;
      return t.consume(h), p;
    }
    return n(h);
  }
}
const Rw = {
  tokenize: zJe,
  partial: !0
};
function zJe(t, e, n) {
  return r;
  function r(o) {
    return Cn(o) ? Bn(t, i, "linePrefix")(o) : i(o);
  }
  function i(o) {
    return o === null || Dt(o) ? e(o) : n(o);
  }
}
const Rq = {
  name: "blockQuote",
  tokenize: GJe,
  continuation: {
    tokenize: UJe
  },
  exit: XJe
};
function GJe(t, e, n) {
  const r = this;
  return i;
  function i(a) {
    if (a === 62) {
      const s = r.containerState;
      return s.open || (t.enter("blockQuote", {
        _container: !0
      }), s.open = !0), t.enter("blockQuotePrefix"), t.enter("blockQuoteMarker"), t.consume(a), t.exit("blockQuoteMarker"), o;
    }
    return n(a);
  }
  function o(a) {
    return Cn(a) ? (t.enter("blockQuotePrefixWhitespace"), t.consume(a), t.exit("blockQuotePrefixWhitespace"), t.exit("blockQuotePrefix"), e) : (t.exit("blockQuotePrefix"), e(a));
  }
}
function UJe(t, e, n) {
  const r = this;
  return i;
  function i(a) {
    return Cn(a) ? Bn(
      t,
      o,
      "linePrefix",
      r.parser.constructs.disable.null.includes("codeIndented") ? void 0 : 4
    )(a) : o(a);
  }
  function o(a) {
    return t.attempt(Rq, e, n)(a);
  }
}
function XJe(t) {
  t.exit("blockQuote");
}
const $q = {
  name: "characterEscape",
  tokenize: YJe
};
function YJe(t, e, n) {
  return r;
  function r(o) {
    return t.enter("characterEscape"), t.enter("escapeMarker"), t.consume(o), t.exit("escapeMarker"), i;
  }
  function i(o) {
    return eq(o) ? (t.enter("characterEscapeValue"), t.consume(o), t.exit("characterEscapeValue"), t.exit("characterEscape"), e) : n(o);
  }
}
const Dq = {
  name: "characterReference",
  tokenize: ZJe
};
function ZJe(t, e, n) {
  const r = this;
  let i = 0, o, a;
  return s;
  function s(d) {
    return t.enter("characterReference"), t.enter("characterReferenceMarker"), t.consume(d), t.exit("characterReferenceMarker"), u;
  }
  function u(d) {
    return d === 35 ? (t.enter("characterReferenceMarkerNumeric"), t.consume(d), t.exit("characterReferenceMarkerNumeric"), l) : (t.enter("characterReferenceValue"), o = 31, a = Ps, c(d));
  }
  function l(d) {
    return d === 88 || d === 120 ? (t.enter("characterReferenceMarkerHexadecimal"), t.consume(d), t.exit("characterReferenceMarkerHexadecimal"), t.enter("characterReferenceValue"), o = 6, a = gYe, c) : (t.enter("characterReferenceValue"), o = 7, a = P4, c(d));
  }
  function c(d) {
    if (d === 59 && i) {
      const f = t.exit("characterReferenceValue");
      return a === Ps && !gm(r.sliceSerialize(f)) ? n(d) : (t.enter("characterReferenceMarker"), t.consume(d), t.exit("characterReferenceMarker"), t.exit("characterReference"), e);
    }
    return a(d) && i++ < o ? (t.consume(d), c) : n(d);
  }
}
const nL = {
  tokenize: KJe,
  partial: !0
}, rL = {
  name: "codeFenced",
  tokenize: JJe,
  concrete: !0
};
function JJe(t, e, n) {
  const r = this, i = {
    tokenize: E,
    partial: !0
  };
  let o = 0, a = 0, s;
  return u;
  function u(I) {
    return l(I);
  }
  function l(I) {
    const _ = r.events[r.events.length - 1];
    return o = _ && _[1].type === "linePrefix" ? _[2].sliceSerialize(_[1], !0).length : 0, s = I, t.enter("codeFenced"), t.enter("codeFencedFence"), t.enter("codeFencedFenceSequence"), c(I);
  }
  function c(I) {
    return I === s ? (a++, t.consume(I), c) : a < 3 ? n(I) : (t.exit("codeFencedFenceSequence"), Cn(I) ? Bn(t, d, "whitespace")(I) : d(I));
  }
  function d(I) {
    return I === null || Dt(I) ? (t.exit("codeFencedFence"), r.interrupt ? e(I) : t.check(nL, v, S)(I)) : (t.enter("codeFencedFenceInfo"), t.enter("chunkString", {
      contentType: "string"
    }), f(I));
  }
  function f(I) {
    return I === null || Dt(I) ? (t.exit("chunkString"), t.exit("codeFencedFenceInfo"), d(I)) : Cn(I) ? (t.exit("chunkString"), t.exit("codeFencedFenceInfo"), Bn(t, h, "whitespace")(I)) : I === 96 && I === s ? n(I) : (t.consume(I), f);
  }
  function h(I) {
    return I === null || Dt(I) ? d(I) : (t.enter("codeFencedFenceMeta"), t.enter("chunkString", {
      contentType: "string"
    }), p(I));
  }
  function p(I) {
    return I === null || Dt(I) ? (t.exit("chunkString"), t.exit("codeFencedFenceMeta"), d(I)) : I === 96 && I === s ? n(I) : (t.consume(I), p);
  }
  function v(I) {
    return t.attempt(i, S, m)(I);
  }
  function m(I) {
    return t.enter("lineEnding"), t.consume(I), t.exit("lineEnding"), b;
  }
  function b(I) {
    return o > 0 && Cn(I) ? Bn(
      t,
      y,
      "linePrefix",
      o + 1
    )(I) : y(I);
  }
  function y(I) {
    return I === null || Dt(I) ? t.check(nL, v, S)(I) : (t.enter("codeFlowValue"), w(I));
  }
  function w(I) {
    return I === null || Dt(I) ? (t.exit("codeFlowValue"), y(I)) : (t.consume(I), w);
  }
  function S(I) {
    return t.exit("codeFenced"), e(I);
  }
  function E(I, _, A) {
    let P = 0;
    return N;
    function N($) {
      return I.enter("lineEnding"), I.consume($), I.exit("lineEnding"), k;
    }
    function k($) {
      return I.enter("codeFencedFence"), Cn($) ? Bn(
        I,
        D,
        "linePrefix",
        r.parser.constructs.disable.null.includes("codeIndented") ? void 0 : 4
      )($) : D($);
    }
    function D($) {
      return $ === s ? (I.enter("codeFencedFenceSequence"), R($)) : A($);
    }
    function R($) {
      return $ === s ? (P++, I.consume($), R) : P >= a ? (I.exit("codeFencedFenceSequence"), Cn($) ? Bn(I, V, "whitespace")($) : V($)) : A($);
    }
    function V($) {
      return $ === null || Dt($) ? (I.exit("codeFencedFence"), _($)) : A($);
    }
  }
}
function KJe(t, e, n) {
  const r = this;
  return i;
  function i(a) {
    return a === null ? n(a) : (t.enter("lineEnding"), t.consume(a), t.exit("lineEnding"), o);
  }
  function o(a) {
    return r.parser.lazy[r.now().line] ? n(a) : e(a);
  }
}
const d5 = {
  name: "codeIndented",
  tokenize: QJe
}, qJe = {
  tokenize: eKe,
  partial: !0
};
function QJe(t, e, n) {
  const r = this;
  return i;
  function i(l) {
    return t.enter("codeIndented"), Bn(t, o, "linePrefix", 5)(l);
  }
  function o(l) {
    const c = r.events[r.events.length - 1];
    return c && c[1].type === "linePrefix" && c[2].sliceSerialize(c[1], !0).length >= 4 ? a(l) : n(l);
  }
  function a(l) {
    return l === null ? u(l) : Dt(l) ? t.attempt(qJe, a, u)(l) : (t.enter("codeFlowValue"), s(l));
  }
  function s(l) {
    return l === null || Dt(l) ? (t.exit("codeFlowValue"), a(l)) : (t.consume(l), s);
  }
  function u(l) {
    return t.exit("codeIndented"), e(l);
  }
}
function eKe(t, e, n) {
  const r = this;
  return i;
  function i(a) {
    return r.parser.lazy[r.now().line] ? n(a) : Dt(a) ? (t.enter("lineEnding"), t.consume(a), t.exit("lineEnding"), i) : Bn(t, o, "linePrefix", 5)(a);
  }
  function o(a) {
    const s = r.events[r.events.length - 1];
    return s && s[1].type === "linePrefix" && s[2].sliceSerialize(s[1], !0).length >= 4 ? e(a) : Dt(a) ? i(a) : n(a);
  }
}
const tKe = {
  name: "codeText",
  tokenize: iKe,
  resolve: nKe,
  previous: rKe
};
function nKe(t) {
  let e = t.length - 4, n = 3, r, i;
  if ((t[n][1].type === "lineEnding" || t[n][1].type === "space") && (t[e][1].type === "lineEnding" || t[e][1].type === "space")) {
    for (r = n; ++r < e; )
      if (t[r][1].type === "codeTextData") {
        t[n][1].type = "codeTextPadding", t[e][1].type = "codeTextPadding", n += 2, e -= 2;
        break;
      }
  }
  for (r = n - 1, e++; ++r <= e; )
    i === void 0 ? r !== e && t[r][1].type !== "lineEnding" && (i = r) : (r === e || t[r][1].type === "lineEnding") && (t[i][1].type = "codeTextData", r !== i + 2 && (t[i][1].end = t[r - 1][1].end, t.splice(i + 2, r - i - 2), e -= r - i - 2, r = i + 2), i = void 0);
  return t;
}
function rKe(t) {
  return t !== 96 || this.events[this.events.length - 1][1].type === "characterEscape";
}
function iKe(t, e, n) {
  let r = 0, i, o;
  return a;
  function a(d) {
    return t.enter("codeText"), t.enter("codeTextSequence"), s(d);
  }
  function s(d) {
    return d === 96 ? (t.consume(d), r++, s) : (t.exit("codeTextSequence"), u(d));
  }
  function u(d) {
    return d === null ? n(d) : d === 32 ? (t.enter("space"), t.consume(d), t.exit("space"), u) : d === 96 ? (o = t.enter("codeTextSequence"), i = 0, c(d)) : Dt(d) ? (t.enter("lineEnding"), t.consume(d), t.exit("lineEnding"), u) : (t.enter("codeTextData"), l(d));
  }
  function l(d) {
    return d === null || d === 32 || d === 96 || Dt(d) ? (t.exit("codeTextData"), u(d)) : (t.consume(d), l);
  }
  function c(d) {
    return d === 96 ? (t.consume(d), i++, c) : i === r ? (t.exit("codeTextSequence"), t.exit("codeText"), e(d)) : (o.type = "codeTextData", l(d));
  }
}
function Mq(t) {
  const e = {};
  let n = -1, r, i, o, a, s, u, l;
  for (; ++n < t.length; ) {
    for (; n in e; )
      n = e[n];
    if (r = t[n], n && r[1].type === "chunkFlow" && t[n - 1][1].type === "listItemPrefix" && (u = r[1]._tokenizer.events, o = 0, o < u.length && u[o][1].type === "lineEndingBlank" && (o += 2), o < u.length && u[o][1].type === "content"))
      for (; ++o < u.length && u[o][1].type !== "content"; )
        u[o][1].type === "chunkText" && (u[o][1]._isInFirstContentOfListItem = !0, o++);
    if (r[0] === "enter")
      r[1].contentType && (Object.assign(e, oKe(t, n)), n = e[n], l = !0);
    else if (r[1]._container) {
      for (o = n, i = void 0; o-- && (a = t[o], a[1].type === "lineEnding" || a[1].type === "lineEndingBlank"); )
        a[0] === "enter" && (i && (t[i][1].type = "lineEndingBlank"), a[1].type = "lineEnding", i = o);
      i && (r[1].end = Object.assign({}, t[i][1].start), s = t.slice(i, n), s.unshift(r), la(t, i, n - i + 1, s));
    }
  }
  return !l;
}
function oKe(t, e) {
  const n = t[e][1], r = t[e][2];
  let i = e - 1;
  const o = [], a = n._tokenizer || r.parser[n.contentType](n.start), s = a.events, u = [], l = {};
  let c, d, f = -1, h = n, p = 0, v = 0;
  const m = [v];
  for (; h; ) {
    for (; t[++i][1] !== h; )
      ;
    o.push(i), h._tokenizer || (c = r.sliceStream(h), h.next || c.push(null), d && a.defineSkip(h.start), h._isInFirstContentOfListItem && (a._gfmTasklistFirstContentOfListItem = !0), a.write(c), h._isInFirstContentOfListItem && (a._gfmTasklistFirstContentOfListItem = void 0)), d = h, h = h.next;
  }
  for (h = n; ++f < s.length; )
    // Find a void token that includes a break.
    s[f][0] === "exit" && s[f - 1][0] === "enter" && s[f][1].type === s[f - 1][1].type && s[f][1].start.line !== s[f][1].end.line && (v = f + 1, m.push(v), h._tokenizer = void 0, h.previous = void 0, h = h.next);
  for (a.events = [], h ? (h._tokenizer = void 0, h.previous = void 0) : m.pop(), f = m.length; f--; ) {
    const b = s.slice(m[f], m[f + 1]), y = o.pop();
    u.unshift([y, y + b.length - 1]), la(t, y, 2, b);
  }
  for (f = -1; ++f < u.length; )
    l[p + u[f][0]] = p + u[f][1], p += u[f][1] - u[f][0] - 1;
  return l;
}
const aKe = {
  tokenize: lKe,
  resolve: uKe
}, sKe = {
  tokenize: cKe,
  partial: !0
};
function uKe(t) {
  return Mq(t), t;
}
function lKe(t, e) {
  let n;
  return r;
  function r(s) {
    return t.enter("content"), n = t.enter("chunkContent", {
      contentType: "content"
    }), i(s);
  }
  function i(s) {
    return s === null ? o(s) : Dt(s) ? t.check(
      sKe,
      a,
      o
    )(s) : (t.consume(s), i);
  }
  function o(s) {
    return t.exit("chunkContent"), t.exit("content"), e(s);
  }
  function a(s) {
    return t.consume(s), t.exit("chunkContent"), n.next = t.enter("chunkContent", {
      contentType: "content",
      previous: n
    }), n = n.next, i;
  }
}
function cKe(t, e, n) {
  const r = this;
  return i;
  function i(a) {
    return t.exit("chunkContent"), t.enter("lineEnding"), t.consume(a), t.exit("lineEnding"), Bn(t, o, "linePrefix");
  }
  function o(a) {
    if (a === null || Dt(a))
      return n(a);
    const s = r.events[r.events.length - 1];
    return !r.parser.constructs.disable.null.includes("codeIndented") && s && s[1].type === "linePrefix" && s[2].sliceSerialize(s[1], !0).length >= 4 ? e(a) : t.interrupt(r.parser.constructs.flow, n, e)(a);
  }
}
function Fq(t, e, n, r, i, o, a, s, u) {
  const l = u || Number.POSITIVE_INFINITY;
  let c = 0;
  return d;
  function d(b) {
    return b === 60 ? (t.enter(r), t.enter(i), t.enter(o), t.consume(b), t.exit(o), f) : b === null || b === 32 || b === 41 || O4(b) ? n(b) : (t.enter(r), t.enter(a), t.enter(s), t.enter("chunkString", {
      contentType: "string"
    }), v(b));
  }
  function f(b) {
    return b === 62 ? (t.enter(o), t.consume(b), t.exit(o), t.exit(i), t.exit(r), e) : (t.enter(s), t.enter("chunkString", {
      contentType: "string"
    }), h(b));
  }
  function h(b) {
    return b === 62 ? (t.exit("chunkString"), t.exit(s), f(b)) : b === null || b === 60 || Dt(b) ? n(b) : (t.consume(b), b === 92 ? p : h);
  }
  function p(b) {
    return b === 60 || b === 62 || b === 92 ? (t.consume(b), h) : h(b);
  }
  function v(b) {
    return !c && (b === null || b === 41 || Br(b)) ? (t.exit("chunkString"), t.exit(s), t.exit(a), t.exit(r), e(b)) : c < l && b === 40 ? (t.consume(b), c++, v) : b === 41 ? (t.consume(b), c--, v) : b === null || b === 32 || b === 40 || O4(b) ? n(b) : (t.consume(b), b === 92 ? m : v);
  }
  function m(b) {
    return b === 40 || b === 41 || b === 92 ? (t.consume(b), v) : v(b);
  }
}
function Lq(t, e, n, r, i, o) {
  const a = this;
  let s = 0, u;
  return l;
  function l(h) {
    return t.enter(r), t.enter(i), t.consume(h), t.exit(i), t.enter(o), c;
  }
  function c(h) {
    return s > 999 || h === null || h === 91 || h === 93 && !u || // To do: remove in the future once we’ve switched from
    // `micromark-extension-footnote` to `micromark-extension-gfm-footnote`,
    // which doesn’t need this.
    // Hidden footnotes hook.
    /* c8 ignore next 3 */
    h === 94 && !s && "_hiddenFootnoteSupport" in a.parser.constructs ? n(h) : h === 93 ? (t.exit(o), t.enter(i), t.consume(h), t.exit(i), t.exit(r), e) : Dt(h) ? (t.enter("lineEnding"), t.consume(h), t.exit("lineEnding"), c) : (t.enter("chunkString", {
      contentType: "string"
    }), d(h));
  }
  function d(h) {
    return h === null || h === 91 || h === 93 || Dt(h) || s++ > 999 ? (t.exit("chunkString"), c(h)) : (t.consume(h), u || (u = !Cn(h)), h === 92 ? f : d);
  }
  function f(h) {
    return h === 91 || h === 92 || h === 93 ? (t.consume(h), s++, d) : d(h);
  }
}
function Vq(t, e, n, r, i, o) {
  let a;
  return s;
  function s(f) {
    return f === 34 || f === 39 || f === 40 ? (t.enter(r), t.enter(i), t.consume(f), t.exit(i), a = f === 40 ? 41 : f, u) : n(f);
  }
  function u(f) {
    return f === a ? (t.enter(i), t.consume(f), t.exit(i), t.exit(r), e) : (t.enter(o), l(f));
  }
  function l(f) {
    return f === a ? (t.exit(o), u(a)) : f === null ? n(f) : Dt(f) ? (t.enter("lineEnding"), t.consume(f), t.exit("lineEnding"), Bn(t, l, "linePrefix")) : (t.enter("chunkString", {
      contentType: "string"
    }), c(f));
  }
  function c(f) {
    return f === a || f === null || Dt(f) ? (t.exit("chunkString"), l(f)) : (t.consume(f), f === 92 ? d : c);
  }
  function d(f) {
    return f === a || f === 92 ? (t.consume(f), c) : c(f);
  }
}
function O0(t, e) {
  let n;
  return r;
  function r(i) {
    return Dt(i) ? (t.enter("lineEnding"), t.consume(i), t.exit("lineEnding"), n = !0, r) : Cn(i) ? Bn(
      t,
      r,
      n ? "linePrefix" : "lineSuffix"
    )(i) : e(i);
  }
}
const dKe = {
  name: "definition",
  tokenize: hKe
}, fKe = {
  tokenize: pKe,
  partial: !0
};
function hKe(t, e, n) {
  const r = this;
  let i;
  return o;
  function o(h) {
    return t.enter("definition"), a(h);
  }
  function a(h) {
    return Lq.call(
      r,
      t,
      s,
      // Note: we don’t need to reset the way `markdown-rs` does.
      n,
      "definitionLabel",
      "definitionLabelMarker",
      "definitionLabelString"
    )(h);
  }
  function s(h) {
    return i = Xh(
      r.sliceSerialize(r.events[r.events.length - 1][1]).slice(1, -1)
    ), h === 58 ? (t.enter("definitionMarker"), t.consume(h), t.exit("definitionMarker"), u) : n(h);
  }
  function u(h) {
    return Br(h) ? O0(t, l)(h) : l(h);
  }
  function l(h) {
    return Fq(
      t,
      c,
      // Note: we don’t need to reset the way `markdown-rs` does.
      n,
      "definitionDestination",
      "definitionDestinationLiteral",
      "definitionDestinationLiteralMarker",
      "definitionDestinationRaw",
      "definitionDestinationString"
    )(h);
  }
  function c(h) {
    return t.attempt(fKe, d, d)(h);
  }
  function d(h) {
    return Cn(h) ? Bn(t, f, "whitespace")(h) : f(h);
  }
  function f(h) {
    return h === null || Dt(h) ? (t.exit("definition"), r.parser.defined.push(i), e(h)) : n(h);
  }
}
function pKe(t, e, n) {
  return r;
  function r(s) {
    return Br(s) ? O0(t, i)(s) : n(s);
  }
  function i(s) {
    return Vq(
      t,
      o,
      n,
      "definitionTitle",
      "definitionTitleMarker",
      "definitionTitleString"
    )(s);
  }
  function o(s) {
    return Cn(s) ? Bn(t, a, "whitespace")(s) : a(s);
  }
  function a(s) {
    return s === null || Dt(s) ? e(s) : n(s);
  }
}
const gKe = {
  name: "hardBreakEscape",
  tokenize: mKe
};
function mKe(t, e, n) {
  return r;
  function r(o) {
    return t.enter("hardBreakEscape"), t.consume(o), i;
  }
  function i(o) {
    return Dt(o) ? (t.exit("hardBreakEscape"), e(o)) : n(o);
  }
}
const vKe = {
  name: "headingAtx",
  tokenize: yKe,
  resolve: bKe
};
function bKe(t, e) {
  let n = t.length - 2, r = 3, i, o;
  return t[r][1].type === "whitespace" && (r += 2), n - 2 > r && t[n][1].type === "whitespace" && (n -= 2), t[n][1].type === "atxHeadingSequence" && (r === n - 1 || n - 4 > r && t[n - 2][1].type === "whitespace") && (n -= r + 1 === n ? 2 : 4), n > r && (i = {
    type: "atxHeadingText",
    start: t[r][1].start,
    end: t[n][1].end
  }, o = {
    type: "chunkText",
    start: t[r][1].start,
    end: t[n][1].end,
    contentType: "text"
  }, la(t, r, n - r + 1, [
    ["enter", i, e],
    ["enter", o, e],
    ["exit", o, e],
    ["exit", i, e]
  ])), t;
}
function yKe(t, e, n) {
  let r = 0;
  return i;
  function i(c) {
    return t.enter("atxHeading"), o(c);
  }
  function o(c) {
    return t.enter("atxHeadingSequence"), a(c);
  }
  function a(c) {
    return c === 35 && r++ < 6 ? (t.consume(c), a) : c === null || Br(c) ? (t.exit("atxHeadingSequence"), s(c)) : n(c);
  }
  function s(c) {
    return c === 35 ? (t.enter("atxHeadingSequence"), u(c)) : c === null || Dt(c) ? (t.exit("atxHeading"), e(c)) : Cn(c) ? Bn(t, s, "whitespace")(c) : (t.enter("atxHeadingText"), l(c));
  }
  function u(c) {
    return c === 35 ? (t.consume(c), u) : (t.exit("atxHeadingSequence"), s(c));
  }
  function l(c) {
    return c === null || c === 35 || Br(c) ? (t.exit("atxHeadingText"), s(c)) : (t.consume(c), l);
  }
}
const xKe = [
  "address",
  "article",
  "aside",
  "base",
  "basefont",
  "blockquote",
  "body",
  "caption",
  "center",
  "col",
  "colgroup",
  "dd",
  "details",
  "dialog",
  "dir",
  "div",
  "dl",
  "dt",
  "fieldset",
  "figcaption",
  "figure",
  "footer",
  "form",
  "frame",
  "frameset",
  "h1",
  "h2",
  "h3",
  "h4",
  "h5",
  "h6",
  "head",
  "header",
  "hr",
  "html",
  "iframe",
  "legend",
  "li",
  "link",
  "main",
  "menu",
  "menuitem",
  "nav",
  "noframes",
  "ol",
  "optgroup",
  "option",
  "p",
  "param",
  "search",
  "section",
  "summary",
  "table",
  "tbody",
  "td",
  "tfoot",
  "th",
  "thead",
  "title",
  "tr",
  "track",
  "ul"
], iL = ["pre", "script", "style", "textarea"], CKe = {
  name: "htmlFlow",
  tokenize: IKe,
  resolveTo: SKe,
  concrete: !0
}, wKe = {
  tokenize: AKe,
  partial: !0
}, EKe = {
  tokenize: _Ke,
  partial: !0
};
function SKe(t) {
  let e = t.length;
  for (; e-- && !(t[e][0] === "enter" && t[e][1].type === "htmlFlow"); )
    ;
  return e > 1 && t[e - 2][1].type === "linePrefix" && (t[e][1].start = t[e - 2][1].start, t[e + 1][1].start = t[e - 2][1].start, t.splice(e - 2, 2)), t;
}
function IKe(t, e, n) {
  const r = this;
  let i, o, a, s, u;
  return l;
  function l(W) {
    return c(W);
  }
  function c(W) {
    return t.enter("htmlFlow"), t.enter("htmlFlowData"), t.consume(W), d;
  }
  function d(W) {
    return W === 33 ? (t.consume(W), f) : W === 47 ? (t.consume(W), o = !0, v) : W === 63 ? (t.consume(W), i = 3, r.interrupt ? e : L) : qs(W) ? (t.consume(W), a = String.fromCharCode(W), m) : n(W);
  }
  function f(W) {
    return W === 45 ? (t.consume(W), i = 2, h) : W === 91 ? (t.consume(W), i = 5, s = 0, p) : qs(W) ? (t.consume(W), i = 4, r.interrupt ? e : L) : n(W);
  }
  function h(W) {
    return W === 45 ? (t.consume(W), r.interrupt ? e : L) : n(W);
  }
  function p(W) {
    const Y = "CDATA[";
    return W === Y.charCodeAt(s++) ? (t.consume(W), s === Y.length ? r.interrupt ? e : D : p) : n(W);
  }
  function v(W) {
    return qs(W) ? (t.consume(W), a = String.fromCharCode(W), m) : n(W);
  }
  function m(W) {
    if (W === null || W === 47 || W === 62 || Br(W)) {
      const Y = W === 47, U = a.toLowerCase();
      return !Y && !o && iL.includes(U) ? (i = 1, r.interrupt ? e(W) : D(W)) : xKe.includes(a.toLowerCase()) ? (i = 6, Y ? (t.consume(W), b) : r.interrupt ? e(W) : D(W)) : (i = 7, r.interrupt && !r.parser.lazy[r.now().line] ? n(W) : o ? y(W) : w(W));
    }
    return W === 45 || Ps(W) ? (t.consume(W), a += String.fromCharCode(W), m) : n(W);
  }
  function b(W) {
    return W === 62 ? (t.consume(W), r.interrupt ? e : D) : n(W);
  }
  function y(W) {
    return Cn(W) ? (t.consume(W), y) : N(W);
  }
  function w(W) {
    return W === 47 ? (t.consume(W), N) : W === 58 || W === 95 || qs(W) ? (t.consume(W), S) : Cn(W) ? (t.consume(W), w) : N(W);
  }
  function S(W) {
    return W === 45 || W === 46 || W === 58 || W === 95 || Ps(W) ? (t.consume(W), S) : E(W);
  }
  function E(W) {
    return W === 61 ? (t.consume(W), I) : Cn(W) ? (t.consume(W), E) : w(W);
  }
  function I(W) {
    return W === null || W === 60 || W === 61 || W === 62 || W === 96 ? n(W) : W === 34 || W === 39 ? (t.consume(W), u = W, _) : Cn(W) ? (t.consume(W), I) : A(W);
  }
  function _(W) {
    return W === u ? (t.consume(W), u = null, P) : W === null || Dt(W) ? n(W) : (t.consume(W), _);
  }
  function A(W) {
    return W === null || W === 34 || W === 39 || W === 47 || W === 60 || W === 61 || W === 62 || W === 96 || Br(W) ? E(W) : (t.consume(W), A);
  }
  function P(W) {
    return W === 47 || W === 62 || Cn(W) ? w(W) : n(W);
  }
  function N(W) {
    return W === 62 ? (t.consume(W), k) : n(W);
  }
  function k(W) {
    return W === null || Dt(W) ? D(W) : Cn(W) ? (t.consume(W), k) : n(W);
  }
  function D(W) {
    return W === 45 && i === 2 ? (t.consume(W), F) : W === 60 && i === 1 ? (t.consume(W), M) : W === 62 && i === 4 ? (t.consume(W), j) : W === 63 && i === 3 ? (t.consume(W), L) : W === 93 && i === 5 ? (t.consume(W), X) : Dt(W) && (i === 6 || i === 7) ? (t.exit("htmlFlowData"), t.check(
      wKe,
      K,
      R
    )(W)) : W === null || Dt(W) ? (t.exit("htmlFlowData"), R(W)) : (t.consume(W), D);
  }
  function R(W) {
    return t.check(
      EKe,
      V,
      K
    )(W);
  }
  function V(W) {
    return t.enter("lineEnding"), t.consume(W), t.exit("lineEnding"), $;
  }
  function $(W) {
    return W === null || Dt(W) ? R(W) : (t.enter("htmlFlowData"), D(W));
  }
  function F(W) {
    return W === 45 ? (t.consume(W), L) : D(W);
  }
  function M(W) {
    return W === 47 ? (t.consume(W), a = "", B) : D(W);
  }
  function B(W) {
    if (W === 62) {
      const Y = a.toLowerCase();
      return iL.includes(Y) ? (t.consume(W), j) : D(W);
    }
    return qs(W) && a.length < 8 ? (t.consume(W), a += String.fromCharCode(W), B) : D(W);
  }
  function X(W) {
    return W === 93 ? (t.consume(W), L) : D(W);
  }
  function L(W) {
    return W === 62 ? (t.consume(W), j) : W === 45 && i === 2 ? (t.consume(W), L) : D(W);
  }
  function j(W) {
    return W === null || Dt(W) ? (t.exit("htmlFlowData"), K(W)) : (t.consume(W), j);
  }
  function K(W) {
    return t.exit("htmlFlow"), e(W);
  }
}
function _Ke(t, e, n) {
  const r = this;
  return i;
  function i(a) {
    return Dt(a) ? (t.enter("lineEnding"), t.consume(a), t.exit("lineEnding"), o) : n(a);
  }
  function o(a) {
    return r.parser.lazy[r.now().line] ? n(a) : e(a);
  }
}
function AKe(t, e, n) {
  return r;
  function r(i) {
    return t.enter("lineEnding"), t.consume(i), t.exit("lineEnding"), t.attempt(Rw, e, n);
  }
}
const TKe = {
  name: "htmlText",
  tokenize: OKe
};
function OKe(t, e, n) {
  const r = this;
  let i, o, a;
  return s;
  function s(L) {
    return t.enter("htmlText"), t.enter("htmlTextData"), t.consume(L), u;
  }
  function u(L) {
    return L === 33 ? (t.consume(L), l) : L === 47 ? (t.consume(L), E) : L === 63 ? (t.consume(L), w) : qs(L) ? (t.consume(L), A) : n(L);
  }
  function l(L) {
    return L === 45 ? (t.consume(L), c) : L === 91 ? (t.consume(L), o = 0, p) : qs(L) ? (t.consume(L), y) : n(L);
  }
  function c(L) {
    return L === 45 ? (t.consume(L), h) : n(L);
  }
  function d(L) {
    return L === null ? n(L) : L === 45 ? (t.consume(L), f) : Dt(L) ? (a = d, M(L)) : (t.consume(L), d);
  }
  function f(L) {
    return L === 45 ? (t.consume(L), h) : d(L);
  }
  function h(L) {
    return L === 62 ? F(L) : L === 45 ? f(L) : d(L);
  }
  function p(L) {
    const j = "CDATA[";
    return L === j.charCodeAt(o++) ? (t.consume(L), o === j.length ? v : p) : n(L);
  }
  function v(L) {
    return L === null ? n(L) : L === 93 ? (t.consume(L), m) : Dt(L) ? (a = v, M(L)) : (t.consume(L), v);
  }
  function m(L) {
    return L === 93 ? (t.consume(L), b) : v(L);
  }
  function b(L) {
    return L === 62 ? F(L) : L === 93 ? (t.consume(L), b) : v(L);
  }
  function y(L) {
    return L === null || L === 62 ? F(L) : Dt(L) ? (a = y, M(L)) : (t.consume(L), y);
  }
  function w(L) {
    return L === null ? n(L) : L === 63 ? (t.consume(L), S) : Dt(L) ? (a = w, M(L)) : (t.consume(L), w);
  }
  function S(L) {
    return L === 62 ? F(L) : w(L);
  }
  function E(L) {
    return qs(L) ? (t.consume(L), I) : n(L);
  }
  function I(L) {
    return L === 45 || Ps(L) ? (t.consume(L), I) : _(L);
  }
  function _(L) {
    return Dt(L) ? (a = _, M(L)) : Cn(L) ? (t.consume(L), _) : F(L);
  }
  function A(L) {
    return L === 45 || Ps(L) ? (t.consume(L), A) : L === 47 || L === 62 || Br(L) ? P(L) : n(L);
  }
  function P(L) {
    return L === 47 ? (t.consume(L), F) : L === 58 || L === 95 || qs(L) ? (t.consume(L), N) : Dt(L) ? (a = P, M(L)) : Cn(L) ? (t.consume(L), P) : F(L);
  }
  function N(L) {
    return L === 45 || L === 46 || L === 58 || L === 95 || Ps(L) ? (t.consume(L), N) : k(L);
  }
  function k(L) {
    return L === 61 ? (t.consume(L), D) : Dt(L) ? (a = k, M(L)) : Cn(L) ? (t.consume(L), k) : P(L);
  }
  function D(L) {
    return L === null || L === 60 || L === 61 || L === 62 || L === 96 ? n(L) : L === 34 || L === 39 ? (t.consume(L), i = L, R) : Dt(L) ? (a = D, M(L)) : Cn(L) ? (t.consume(L), D) : (t.consume(L), V);
  }
  function R(L) {
    return L === i ? (t.consume(L), i = void 0, $) : L === null ? n(L) : Dt(L) ? (a = R, M(L)) : (t.consume(L), R);
  }
  function V(L) {
    return L === null || L === 34 || L === 39 || L === 60 || L === 61 || L === 96 ? n(L) : L === 47 || L === 62 || Br(L) ? P(L) : (t.consume(L), V);
  }
  function $(L) {
    return L === 47 || L === 62 || Br(L) ? P(L) : n(L);
  }
  function F(L) {
    return L === 62 ? (t.consume(L), t.exit("htmlTextData"), t.exit("htmlText"), e) : n(L);
  }
  function M(L) {
    return t.exit("htmlTextData"), t.enter("lineEnding"), t.consume(L), t.exit("lineEnding"), B;
  }
  function B(L) {
    return Cn(L) ? Bn(
      t,
      X,
      "linePrefix",
      r.parser.constructs.disable.null.includes("codeIndented") ? void 0 : 4
    )(L) : X(L);
  }
  function X(L) {
    return t.enter("htmlTextData"), a(L);
  }
}
const CO = {
  name: "labelEnd",
  tokenize: DKe,
  resolveTo: $Ke,
  resolveAll: RKe
}, PKe = {
  tokenize: MKe
}, NKe = {
  tokenize: FKe
}, kKe = {
  tokenize: LKe
};
function RKe(t) {
  let e = -1;
  for (; ++e < t.length; ) {
    const n = t[e][1];
    (n.type === "labelImage" || n.type === "labelLink" || n.type === "labelEnd") && (t.splice(e + 1, n.type === "labelImage" ? 4 : 2), n.type = "data", e++);
  }
  return t;
}
function $Ke(t, e) {
  let n = t.length, r = 0, i, o, a, s;
  for (; n--; )
    if (i = t[n][1], o) {
      if (i.type === "link" || i.type === "labelLink" && i._inactive)
        break;
      t[n][0] === "enter" && i.type === "labelLink" && (i._inactive = !0);
    } else if (a) {
      if (t[n][0] === "enter" && (i.type === "labelImage" || i.type === "labelLink") && !i._balanced && (o = n, i.type !== "labelLink")) {
        r = 2;
        break;
      }
    } else
      i.type === "labelEnd" && (a = n);
  const u = {
    type: t[o][1].type === "labelLink" ? "link" : "image",
    start: Object.assign({}, t[o][1].start),
    end: Object.assign({}, t[t.length - 1][1].end)
  }, l = {
    type: "label",
    start: Object.assign({}, t[o][1].start),
    end: Object.assign({}, t[a][1].end)
  }, c = {
    type: "labelText",
    start: Object.assign({}, t[o + r + 2][1].end),
    end: Object.assign({}, t[a - 2][1].start)
  };
  return s = [
    ["enter", u, e],
    ["enter", l, e]
  ], s = Ba(s, t.slice(o + 1, o + r + 3)), s = Ba(s, [["enter", c, e]]), s = Ba(
    s,
    Pw(
      e.parser.constructs.insideSpan.null,
      t.slice(o + r + 4, a - 3),
      e
    )
  ), s = Ba(s, [
    ["exit", c, e],
    t[a - 2],
    t[a - 1],
    ["exit", l, e]
  ]), s = Ba(s, t.slice(a + 1)), s = Ba(s, [["exit", u, e]]), la(t, o, t.length, s), t;
}
function DKe(t, e, n) {
  const r = this;
  let i = r.events.length, o, a;
  for (; i--; )
    if ((r.events[i][1].type === "labelImage" || r.events[i][1].type === "labelLink") && !r.events[i][1]._balanced) {
      o = r.events[i][1];
      break;
    }
  return s;
  function s(f) {
    return o ? o._inactive ? d(f) : (a = r.parser.defined.includes(
      Xh(
        r.sliceSerialize({
          start: o.end,
          end: r.now()
        })
      )
    ), t.enter("labelEnd"), t.enter("labelMarker"), t.consume(f), t.exit("labelMarker"), t.exit("labelEnd"), u) : n(f);
  }
  function u(f) {
    return f === 40 ? t.attempt(
      PKe,
      c,
      a ? c : d
    )(f) : f === 91 ? t.attempt(
      NKe,
      c,
      a ? l : d
    )(f) : a ? c(f) : d(f);
  }
  function l(f) {
    return t.attempt(
      kKe,
      c,
      d
    )(f);
  }
  function c(f) {
    return e(f);
  }
  function d(f) {
    return o._balanced = !0, n(f);
  }
}
function MKe(t, e, n) {
  return r;
  function r(d) {
    return t.enter("resource"), t.enter("resourceMarker"), t.consume(d), t.exit("resourceMarker"), i;
  }
  function i(d) {
    return Br(d) ? O0(t, o)(d) : o(d);
  }
  function o(d) {
    return d === 41 ? c(d) : Fq(
      t,
      a,
      s,
      "resourceDestination",
      "resourceDestinationLiteral",
      "resourceDestinationLiteralMarker",
      "resourceDestinationRaw",
      "resourceDestinationString",
      32
    )(d);
  }
  function a(d) {
    return Br(d) ? O0(t, u)(d) : c(d);
  }
  function s(d) {
    return n(d);
  }
  function u(d) {
    return d === 34 || d === 39 || d === 40 ? Vq(
      t,
      l,
      n,
      "resourceTitle",
      "resourceTitleMarker",
      "resourceTitleString"
    )(d) : c(d);
  }
  function l(d) {
    return Br(d) ? O0(t, c)(d) : c(d);
  }
  function c(d) {
    return d === 41 ? (t.enter("resourceMarker"), t.consume(d), t.exit("resourceMarker"), t.exit("resource"), e) : n(d);
  }
}
function FKe(t, e, n) {
  const r = this;
  return i;
  function i(s) {
    return Lq.call(
      r,
      t,
      o,
      a,
      "reference",
      "referenceMarker",
      "referenceString"
    )(s);
  }
  function o(s) {
    return r.parser.defined.includes(
      Xh(
        r.sliceSerialize(r.events[r.events.length - 1][1]).slice(1, -1)
      )
    ) ? e(s) : n(s);
  }
  function a(s) {
    return n(s);
  }
}
function LKe(t, e, n) {
  return r;
  function r(o) {
    return t.enter("reference"), t.enter("referenceMarker"), t.consume(o), t.exit("referenceMarker"), i;
  }
  function i(o) {
    return o === 93 ? (t.enter("referenceMarker"), t.consume(o), t.exit("referenceMarker"), t.exit("reference"), e) : n(o);
  }
}
const VKe = {
  name: "labelStartImage",
  tokenize: BKe,
  resolveAll: CO.resolveAll
};
function BKe(t, e, n) {
  const r = this;
  return i;
  function i(s) {
    return t.enter("labelImage"), t.enter("labelImageMarker"), t.consume(s), t.exit("labelImageMarker"), o;
  }
  function o(s) {
    return s === 91 ? (t.enter("labelMarker"), t.consume(s), t.exit("labelMarker"), t.exit("labelImage"), a) : n(s);
  }
  function a(s) {
    return s === 94 && "_hiddenFootnoteSupport" in r.parser.constructs ? n(s) : e(s);
  }
}
const HKe = {
  name: "labelStartLink",
  tokenize: WKe,
  resolveAll: CO.resolveAll
};
function WKe(t, e, n) {
  const r = this;
  return i;
  function i(a) {
    return t.enter("labelLink"), t.enter("labelMarker"), t.consume(a), t.exit("labelMarker"), t.exit("labelLink"), o;
  }
  function o(a) {
    return a === 94 && "_hiddenFootnoteSupport" in r.parser.constructs ? n(a) : e(a);
  }
}
const f5 = {
  name: "lineEnding",
  tokenize: jKe
};
function jKe(t, e) {
  return n;
  function n(r) {
    return t.enter("lineEnding"), t.consume(r), t.exit("lineEnding"), Bn(t, e, "linePrefix");
  }
}
const Sy = {
  name: "thematicBreak",
  tokenize: zKe
};
function zKe(t, e, n) {
  let r = 0, i;
  return o;
  function o(l) {
    return t.enter("thematicBreak"), a(l);
  }
  function a(l) {
    return i = l, s(l);
  }
  function s(l) {
    return l === i ? (t.enter("thematicBreakSequence"), u(l)) : r >= 3 && (l === null || Dt(l)) ? (t.exit("thematicBreak"), e(l)) : n(l);
  }
  function u(l) {
    return l === i ? (t.consume(l), r++, u) : (t.exit("thematicBreakSequence"), Cn(l) ? Bn(t, s, "whitespace")(l) : s(l));
  }
}
const Co = {
  name: "list",
  tokenize: XKe,
  continuation: {
    tokenize: YKe
  },
  exit: JKe
}, GKe = {
  tokenize: KKe,
  partial: !0
}, UKe = {
  tokenize: ZKe,
  partial: !0
};
function XKe(t, e, n) {
  const r = this, i = r.events[r.events.length - 1];
  let o = i && i[1].type === "linePrefix" ? i[2].sliceSerialize(i[1], !0).length : 0, a = 0;
  return s;
  function s(h) {
    const p = r.containerState.type || (h === 42 || h === 43 || h === 45 ? "listUnordered" : "listOrdered");
    if (p === "listUnordered" ? !r.containerState.marker || h === r.containerState.marker : P4(h)) {
      if (r.containerState.type || (r.containerState.type = p, t.enter(p, {
        _container: !0
      })), p === "listUnordered")
        return t.enter("listItemPrefix"), h === 42 || h === 45 ? t.check(Sy, n, l)(h) : l(h);
      if (!r.interrupt || h === 49)
        return t.enter("listItemPrefix"), t.enter("listItemValue"), u(h);
    }
    return n(h);
  }
  function u(h) {
    return P4(h) && ++a < 10 ? (t.consume(h), u) : (!r.interrupt || a < 2) && (r.containerState.marker ? h === r.containerState.marker : h === 41 || h === 46) ? (t.exit("listItemValue"), l(h)) : n(h);
  }
  function l(h) {
    return t.enter("listItemMarker"), t.consume(h), t.exit("listItemMarker"), r.containerState.marker = r.containerState.marker || h, t.check(
      Rw,
      // Can’t be empty when interrupting.
      r.interrupt ? n : c,
      t.attempt(
        GKe,
        f,
        d
      )
    );
  }
  function c(h) {
    return r.containerState.initialBlankLine = !0, o++, f(h);
  }
  function d(h) {
    return Cn(h) ? (t.enter("listItemPrefixWhitespace"), t.consume(h), t.exit("listItemPrefixWhitespace"), f) : n(h);
  }
  function f(h) {
    return r.containerState.size = o + r.sliceSerialize(t.exit("listItemPrefix"), !0).length, e(h);
  }
}
function YKe(t, e, n) {
  const r = this;
  return r.containerState._closeFlow = void 0, t.check(Rw, i, o);
  function i(s) {
    return r.containerState.furtherBlankLines = r.containerState.furtherBlankLines || r.containerState.initialBlankLine, Bn(
      t,
      e,
      "listItemIndent",
      r.containerState.size + 1
    )(s);
  }
  function o(s) {
    return r.containerState.furtherBlankLines || !Cn(s) ? (r.containerState.furtherBlankLines = void 0, r.containerState.initialBlankLine = void 0, a(s)) : (r.containerState.furtherBlankLines = void 0, r.containerState.initialBlankLine = void 0, t.attempt(UKe, e, a)(s));
  }
  function a(s) {
    return r.containerState._closeFlow = !0, r.interrupt = void 0, Bn(
      t,
      t.attempt(Co, e, n),
      "linePrefix",
      r.parser.constructs.disable.null.includes("codeIndented") ? void 0 : 4
    )(s);
  }
}
function ZKe(t, e, n) {
  const r = this;
  return Bn(
    t,
    i,
    "listItemIndent",
    r.containerState.size + 1
  );
  function i(o) {
    const a = r.events[r.events.length - 1];
    return a && a[1].type === "listItemIndent" && a[2].sliceSerialize(a[1], !0).length === r.containerState.size ? e(o) : n(o);
  }
}
function JKe(t) {
  t.exit(this.containerState.type);
}
function KKe(t, e, n) {
  const r = this;
  return Bn(
    t,
    i,
    "listItemPrefixWhitespace",
    r.parser.constructs.disable.null.includes("codeIndented") ? void 0 : 5
  );
  function i(o) {
    const a = r.events[r.events.length - 1];
    return !Cn(o) && a && a[1].type === "listItemPrefixWhitespace" ? e(o) : n(o);
  }
}
const oL = {
  name: "setextUnderline",
  tokenize: QKe,
  resolveTo: qKe
};
function qKe(t, e) {
  let n = t.length, r, i, o;
  for (; n--; )
    if (t[n][0] === "enter") {
      if (t[n][1].type === "content") {
        r = n;
        break;
      }
      t[n][1].type === "paragraph" && (i = n);
    } else
      t[n][1].type === "content" && t.splice(n, 1), !o && t[n][1].type === "definition" && (o = n);
  const a = {
    type: "setextHeading",
    start: Object.assign({}, t[i][1].start),
    end: Object.assign({}, t[t.length - 1][1].end)
  };
  return t[i][1].type = "setextHeadingText", o ? (t.splice(i, 0, ["enter", a, e]), t.splice(o + 1, 0, ["exit", t[r][1], e]), t[r][1].end = Object.assign({}, t[o][1].end)) : t[r][1] = a, t.push(["exit", a, e]), t;
}
function QKe(t, e, n) {
  const r = this;
  let i;
  return o;
  function o(l) {
    let c = r.events.length, d;
    for (; c--; )
      if (r.events[c][1].type !== "lineEnding" && r.events[c][1].type !== "linePrefix" && r.events[c][1].type !== "content") {
        d = r.events[c][1].type === "paragraph";
        break;
      }
    return !r.parser.lazy[r.now().line] && (r.interrupt || d) ? (t.enter("setextHeadingLine"), i = l, a(l)) : n(l);
  }
  function a(l) {
    return t.enter("setextHeadingLineSequence"), s(l);
  }
  function s(l) {
    return l === i ? (t.consume(l), s) : (t.exit("setextHeadingLineSequence"), Cn(l) ? Bn(t, u, "lineSuffix")(l) : u(l));
  }
  function u(l) {
    return l === null || Dt(l) ? (t.exit("setextHeadingLine"), e(l)) : n(l);
  }
}
const eqe = {
  tokenize: tqe
};
function tqe(t) {
  const e = this, n = t.attempt(
    // Try to parse a blank line.
    Rw,
    r,
    // Try to parse initial flow (essentially, only code).
    t.attempt(
      this.parser.constructs.flowInitial,
      i,
      Bn(
        t,
        t.attempt(
          this.parser.constructs.flow,
          i,
          t.attempt(aKe, i)
        ),
        "linePrefix"
      )
    )
  );
  return n;
  function r(o) {
    if (o === null) {
      t.consume(o);
      return;
    }
    return t.enter("lineEndingBlank"), t.consume(o), t.exit("lineEndingBlank"), e.currentConstruct = void 0, n;
  }
  function i(o) {
    if (o === null) {
      t.consume(o);
      return;
    }
    return t.enter("lineEnding"), t.consume(o), t.exit("lineEnding"), e.currentConstruct = void 0, n;
  }
}
const nqe = {
  resolveAll: Hq()
}, rqe = Bq("string"), iqe = Bq("text");
function Bq(t) {
  return {
    tokenize: e,
    resolveAll: Hq(
      t === "text" ? oqe : void 0
    )
  };
  function e(n) {
    const r = this, i = this.parser.constructs[t], o = n.attempt(i, a, s);
    return a;
    function a(c) {
      return l(c) ? o(c) : s(c);
    }
    function s(c) {
      if (c === null) {
        n.consume(c);
        return;
      }
      return n.enter("data"), n.consume(c), u;
    }
    function u(c) {
      return l(c) ? (n.exit("data"), o(c)) : (n.consume(c), u);
    }
    function l(c) {
      if (c === null)
        return !0;
      const d = i[c];
      let f = -1;
      if (d)
        for (; ++f < d.length; ) {
          const h = d[f];
          if (!h.previous || h.previous.call(r, r.previous))
            return !0;
        }
      return !1;
    }
  }
}
function Hq(t) {
  return e;
  function e(n, r) {
    let i = -1, o;
    for (; ++i <= n.length; )
      o === void 0 ? n[i] && n[i][1].type === "data" && (o = i, i++) : (!n[i] || n[i][1].type !== "data") && (i !== o + 2 && (n[o][1].end = n[i - 1][1].end, n.splice(o + 2, i - o - 2), i = o + 2), o = void 0);
    return t ? t(n, r) : n;
  }
}
function oqe(t, e) {
  let n = 0;
  for (; ++n <= t.length; )
    if ((n === t.length || t[n][1].type === "lineEnding") && t[n - 1][1].type === "data") {
      const r = t[n - 1][1], i = e.sliceStream(r);
      let o = i.length, a = -1, s = 0, u;
      for (; o--; ) {
        const l = i[o];
        if (typeof l == "string") {
          for (a = l.length; l.charCodeAt(a - 1) === 32; )
            s++, a--;
          if (a)
            break;
          a = -1;
        } else if (l === -2)
          u = !0, s++;
        else if (l !== -1) {
          o++;
          break;
        }
      }
      if (s) {
        const l = {
          type: n === t.length || u || s < 2 ? "lineSuffix" : "hardBreakTrailing",
          start: {
            line: r.end.line,
            column: r.end.column - s,
            offset: r.end.offset - s,
            _index: r.start._index + o,
            _bufferIndex: o ? a : r.start._bufferIndex + a
          },
          end: Object.assign({}, r.end)
        };
        r.end = Object.assign({}, l.start), r.start.offset === r.end.offset ? Object.assign(r, l) : (t.splice(
          n,
          0,
          ["enter", l, e],
          ["exit", l, e]
        ), n += 2);
      }
      n++;
    }
  return t;
}
function aqe(t, e, n) {
  let r = Object.assign(
    n ? Object.assign({}, n) : {
      line: 1,
      column: 1,
      offset: 0
    },
    {
      _index: 0,
      _bufferIndex: -1
    }
  );
  const i = {}, o = [];
  let a = [], s = [];
  const u = {
    consume: y,
    enter: w,
    exit: S,
    attempt: _(E),
    check: _(I),
    interrupt: _(I, {
      interrupt: !0
    })
  }, l = {
    previous: null,
    code: null,
    containerState: {},
    events: [],
    parser: t,
    sliceStream: h,
    sliceSerialize: f,
    now: p,
    defineSkip: v,
    write: d
  };
  let c = e.tokenize.call(l, u);
  return e.resolveAll && o.push(e), l;
  function d(k) {
    return a = Ba(a, k), m(), a[a.length - 1] !== null ? [] : (A(e, 0), l.events = Pw(o, l.events, l), l.events);
  }
  function f(k, D) {
    return uqe(h(k), D);
  }
  function h(k) {
    return sqe(a, k);
  }
  function p() {
    const { line: k, column: D, offset: R, _index: V, _bufferIndex: $ } = r;
    return {
      line: k,
      column: D,
      offset: R,
      _index: V,
      _bufferIndex: $
    };
  }
  function v(k) {
    i[k.line] = k.column, N();
  }
  function m() {
    let k;
    for (; r._index < a.length; ) {
      const D = a[r._index];
      if (typeof D == "string")
        for (k = r._index, r._bufferIndex < 0 && (r._bufferIndex = 0); r._index === k && r._bufferIndex < D.length; )
          b(D.charCodeAt(r._bufferIndex));
      else
        b(D);
    }
  }
  function b(k) {
    c = c(k);
  }
  function y(k) {
    Dt(k) ? (r.line++, r.column = 1, r.offset += k === -3 ? 2 : 1, N()) : k !== -1 && (r.column++, r.offset++), r._bufferIndex < 0 ? r._index++ : (r._bufferIndex++, r._bufferIndex === a[r._index].length && (r._bufferIndex = -1, r._index++)), l.previous = k;
  }
  function w(k, D) {
    const R = D || {};
    return R.type = k, R.start = p(), l.events.push(["enter", R, l]), s.push(R), R;
  }
  function S(k) {
    const D = s.pop();
    return D.end = p(), l.events.push(["exit", D, l]), D;
  }
  function E(k, D) {
    A(k, D.from);
  }
  function I(k, D) {
    D.restore();
  }
  function _(k, D) {
    return R;
    function R(V, $, F) {
      let M, B, X, L;
      return Array.isArray(V) ? K(V) : "tokenize" in V ? (
        // @ts-expect-error Looks like a construct.
        K([V])
      ) : j(V);
      function j(Q) {
        return Z;
        function Z(ee) {
          const ie = ee !== null && Q[ee], oe = ee !== null && Q.null, se = [
            // To do: add more extension tests.
            /* c8 ignore next 2 */
            ...Array.isArray(ie) ? ie : ie ? [ie] : [],
            ...Array.isArray(oe) ? oe : oe ? [oe] : []
          ];
          return K(se)(ee);
        }
      }
      function K(Q) {
        return M = Q, B = 0, Q.length === 0 ? F : W(Q[B]);
      }
      function W(Q) {
        return Z;
        function Z(ee) {
          return L = P(), X = Q, Q.partial || (l.currentConstruct = Q), Q.name && l.parser.constructs.disable.null.includes(Q.name) ? U() : Q.tokenize.call(
            // If we do have fields, create an object w/ `context` as its
            // prototype.
            // This allows a “live binding”, which is needed for `interrupt`.
            D ? Object.assign(Object.create(l), D) : l,
            u,
            Y,
            U
          )(ee);
        }
      }
      function Y(Q) {
        return k(X, L), $;
      }
      function U(Q) {
        return L.restore(), ++B < M.length ? W(M[B]) : F;
      }
    }
  }
  function A(k, D) {
    k.resolveAll && !o.includes(k) && o.push(k), k.resolve && la(
      l.events,
      D,
      l.events.length - D,
      k.resolve(l.events.slice(D), l)
    ), k.resolveTo && (l.events = k.resolveTo(l.events, l));
  }
  function P() {
    const k = p(), D = l.previous, R = l.currentConstruct, V = l.events.length, $ = Array.from(s);
    return {
      restore: F,
      from: V
    };
    function F() {
      r = k, l.previous = D, l.currentConstruct = R, l.events.length = V, s = $, N();
    }
  }
  function N() {
    r.line in i && r.column < 2 && (r.column = i[r.line], r.offset += i[r.line] - 1);
  }
}
function sqe(t, e) {
  const n = e.start._index, r = e.start._bufferIndex, i = e.end._index, o = e.end._bufferIndex;
  let a;
  if (n === i)
    a = [t[n].slice(r, o)];
  else {
    if (a = t.slice(n, i), r > -1) {
      const s = a[0];
      typeof s == "string" ? a[0] = s.slice(r) : a.shift();
    }
    o > 0 && a.push(t[i].slice(0, o));
  }
  return a;
}
function uqe(t, e) {
  let n = -1;
  const r = [];
  let i;
  for (; ++n < t.length; ) {
    const o = t[n];
    let a;
    if (typeof o == "string")
      a = o;
    else
      switch (o) {
        case -5: {
          a = "\r";
          break;
        }
        case -4: {
          a = `
`;
          break;
        }
        case -3: {
          a = `\r
`;
          break;
        }
        case -2: {
          a = e ? " " : "	";
          break;
        }
        case -1: {
          if (!e && i)
            continue;
          a = " ";
          break;
        }
        default:
          a = String.fromCharCode(o);
      }
    i = o === -2, r.push(a);
  }
  return r.join("");
}
const lqe = {
  42: Co,
  43: Co,
  45: Co,
  48: Co,
  49: Co,
  50: Co,
  51: Co,
  52: Co,
  53: Co,
  54: Co,
  55: Co,
  56: Co,
  57: Co,
  62: Rq
}, cqe = {
  91: dKe
}, dqe = {
  [-2]: d5,
  [-1]: d5,
  32: d5
}, fqe = {
  35: vKe,
  42: Sy,
  45: [oL, Sy],
  60: CKe,
  61: oL,
  95: Sy,
  96: rL,
  126: rL
}, hqe = {
  38: Dq,
  92: $q
}, pqe = {
  [-5]: f5,
  [-4]: f5,
  [-3]: f5,
  33: VKe,
  38: Dq,
  42: $4,
  60: [WJe, TKe],
  91: HKe,
  92: [gKe, $q],
  93: CO,
  95: $4,
  96: tKe
}, gqe = {
  null: [$4, nqe]
}, mqe = {
  null: [42, 95]
}, vqe = {
  null: []
}, bqe = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  attentionMarkers: mqe,
  contentInitial: cqe,
  disable: vqe,
  document: lqe,
  flow: fqe,
  flowInitial: dqe,
  insideSpan: gqe,
  string: hqe,
  text: pqe
}, Symbol.toStringTag, { value: "Module" }));
function yqe(t) {
  const n = (
    /** @type {FullNormalizedExtension} */
    kJe([bqe, ...(t || {}).extensions || []])
  ), r = {
    defined: [],
    lazy: {},
    constructs: n,
    content: i(DJe),
    document: i(FJe),
    flow: i(eqe),
    string: i(rqe),
    text: i(iqe)
  };
  return r;
  function i(o) {
    return a;
    function a(s) {
      return aqe(r, o, s);
    }
  }
}
function xqe(t) {
  for (; !Mq(t); )
    ;
  return t;
}
const aL = /[\0\t\n\r]/g;
function Cqe() {
  let t = 1, e = "", n = !0, r;
  return i;
  function i(o, a, s) {
    const u = [];
    let l, c, d, f, h;
    for (o = e + (typeof o == "string" ? o.toString() : new TextDecoder(a || void 0).decode(o)), d = 0, e = "", n && (o.charCodeAt(0) === 65279 && d++, n = void 0); d < o.length; ) {
      if (aL.lastIndex = d, l = aL.exec(o), f = l && l.index !== void 0 ? l.index : o.length, h = o.charCodeAt(f), !l) {
        e = o.slice(d);
        break;
      }
      if (h === 10 && d === f && r)
        u.push(-3), r = void 0;
      else
        switch (r && (u.push(-5), r = void 0), d < f && (u.push(o.slice(d, f)), t += f - d), h) {
          case 0: {
            u.push(65533), t++;
            break;
          }
          case 9: {
            for (c = Math.ceil(t / 4) * 4, u.push(-2); t++ < c; )
              u.push(-1);
            break;
          }
          case 10: {
            u.push(-4), t = 1;
            break;
          }
          default:
            r = !0, t = 1;
        }
      d = f + 1;
    }
    return s && (r && u.push(-5), e && u.push(e), u.push(null)), u;
  }
}
const Wq = {}.hasOwnProperty;
function wqe(t, e, n) {
  return typeof e != "string" && (n = e, e = void 0), Eqe(n)(
    xqe(
      yqe(n).document().write(Cqe()(t, e, !0))
    )
  );
}
function Eqe(t) {
  const e = {
    transforms: [],
    canContainEols: ["emphasis", "fragment", "heading", "paragraph", "strong"],
    enter: {
      autolink: o(ze),
      autolinkProtocol: P,
      autolinkEmail: P,
      atxHeading: o(he),
      blockQuote: o(ie),
      characterEscape: P,
      characterReference: P,
      codeFenced: o(oe),
      codeFencedFenceInfo: a,
      codeFencedFenceMeta: a,
      codeIndented: o(oe, a),
      codeText: o(se, a),
      codeTextData: P,
      data: P,
      codeFlowValue: P,
      definition: o(te),
      definitionDestinationString: a,
      definitionLabelString: a,
      definitionTitleString: a,
      emphasis: o(ge),
      hardBreakEscape: o(fe),
      hardBreakTrailing: o(fe),
      htmlFlow: o(_e, a),
      htmlFlowData: P,
      htmlText: o(_e, a),
      htmlTextData: P,
      image: o(Ne),
      label: a,
      link: o(ze),
      listItem: o(ne),
      listItemValue: f,
      listOrdered: o(Ve, d),
      listUnordered: o(Ve),
      paragraph: o(pe),
      reference: W,
      referenceString: a,
      resourceDestinationString: a,
      resourceTitleString: a,
      setextHeading: o(he),
      strong: o(ye),
      thematicBreak: o(we)
    },
    exit: {
      atxHeading: u(),
      atxHeadingSequence: E,
      autolink: u(),
      autolinkEmail: ee,
      autolinkProtocol: Z,
      blockQuote: u(),
      characterEscapeValue: N,
      characterReferenceMarkerHexadecimal: U,
      characterReferenceMarkerNumeric: U,
      characterReferenceValue: Q,
      codeFenced: u(m),
      codeFencedFence: v,
      codeFencedFenceInfo: h,
      codeFencedFenceMeta: p,
      codeFlowValue: N,
      codeIndented: u(b),
      codeText: u($),
      codeTextData: N,
      data: N,
      definition: u(),
      definitionDestinationString: S,
      definitionLabelString: y,
      definitionTitleString: w,
      emphasis: u(),
      hardBreakEscape: u(D),
      hardBreakTrailing: u(D),
      htmlFlow: u(R),
      htmlFlowData: N,
      htmlText: u(V),
      htmlTextData: N,
      image: u(M),
      label: X,
      labelText: B,
      lineEnding: k,
      link: u(F),
      listItem: u(),
      listOrdered: u(),
      listUnordered: u(),
      paragraph: u(),
      referenceString: Y,
      resourceDestinationString: L,
      resourceTitleString: j,
      resource: K,
      setextHeading: u(A),
      setextHeadingLineSequence: _,
      setextHeadingText: I,
      strong: u(),
      thematicBreak: u()
    }
  };
  jq(e, (t || {}).mdastExtensions || []);
  const n = {};
  return r;
  function r(ce) {
    let ve = {
      type: "root",
      children: []
    };
    const Ie = {
      stack: [ve],
      tokenStack: [],
      config: e,
      enter: s,
      exit: l,
      buffer: a,
      resume: c,
      data: n
    }, q = [];
    let Fe = -1;
    for (; ++Fe < ce.length; )
      if (ce[Fe][1].type === "listOrdered" || ce[Fe][1].type === "listUnordered")
        if (ce[Fe][0] === "enter")
          q.push(Fe);
        else {
          const Ze = q.pop();
          Fe = i(ce, Ze, Fe);
        }
    for (Fe = -1; ++Fe < ce.length; ) {
      const Ze = e[ce[Fe][0]];
      Wq.call(Ze, ce[Fe][1].type) && Ze[ce[Fe][1].type].call(
        Object.assign(
          {
            sliceSerialize: ce[Fe][2].sliceSerialize
          },
          Ie
        ),
        ce[Fe][1]
      );
    }
    if (Ie.tokenStack.length > 0) {
      const Ze = Ie.tokenStack[Ie.tokenStack.length - 1];
      (Ze[1] || sL).call(Ie, void 0, Ze[0]);
    }
    for (ve.position = {
      start: Ml(
        ce.length > 0 ? ce[0][1].start : {
          line: 1,
          column: 1,
          offset: 0
        }
      ),
      end: Ml(
        ce.length > 0 ? ce[ce.length - 2][1].end : {
          line: 1,
          column: 1,
          offset: 0
        }
      )
    }, Fe = -1; ++Fe < e.transforms.length; )
      ve = e.transforms[Fe](ve) || ve;
    return ve;
  }
  function i(ce, ve, Ie) {
    let q = ve - 1, Fe = -1, Ze = !1, at, Je, ut, Ct;
    for (; ++q <= Ie; ) {
      const Ke = ce[q];
      switch (Ke[1].type) {
        case "listUnordered":
        case "listOrdered":
        case "blockQuote": {
          Ke[0] === "enter" ? Fe++ : Fe--, Ct = void 0;
          break;
        }
        case "lineEndingBlank": {
          Ke[0] === "enter" && (at && !Ct && !Fe && !ut && (ut = q), Ct = void 0);
          break;
        }
        case "linePrefix":
        case "listItemValue":
        case "listItemMarker":
        case "listItemPrefix":
        case "listItemPrefixWhitespace":
          break;
        default:
          Ct = void 0;
      }
      if (!Fe && Ke[0] === "enter" && Ke[1].type === "listItemPrefix" || Fe === -1 && Ke[0] === "exit" && (Ke[1].type === "listUnordered" || Ke[1].type === "listOrdered")) {
        if (at) {
          let st = q;
          for (Je = void 0; st--; ) {
            const wt = ce[st];
            if (wt[1].type === "lineEnding" || wt[1].type === "lineEndingBlank") {
              if (wt[0] === "exit")
                continue;
              Je && (ce[Je][1].type = "lineEndingBlank", Ze = !0), wt[1].type = "lineEnding", Je = st;
            } else if (!(wt[1].type === "linePrefix" || wt[1].type === "blockQuotePrefix" || wt[1].type === "blockQuotePrefixWhitespace" || wt[1].type === "blockQuoteMarker" || wt[1].type === "listItemIndent"))
              break;
          }
          ut && (!Je || ut < Je) && (at._spread = !0), at.end = Object.assign(
            {},
            Je ? ce[Je][1].start : Ke[1].end
          ), ce.splice(Je || q, 0, ["exit", at, Ke[2]]), q++, Ie++;
        }
        if (Ke[1].type === "listItemPrefix") {
          const st = {
            type: "listItem",
            _spread: !1,
            start: Object.assign({}, Ke[1].start),
            // @ts-expect-error: we’ll add `end` in a second.
            end: void 0
          };
          at = st, ce.splice(q, 0, ["enter", st, Ke[2]]), q++, Ie++, ut = void 0, Ct = !0;
        }
      }
    }
    return ce[ve][1]._spread = Ze, Ie;
  }
  function o(ce, ve) {
    return Ie;
    function Ie(q) {
      s.call(this, ce(q), q), ve && ve.call(this, q);
    }
  }
  function a() {
    this.stack.push({
      type: "fragment",
      children: []
    });
  }
  function s(ce, ve, Ie) {
    this.stack[this.stack.length - 1].children.push(ce), this.stack.push(ce), this.tokenStack.push([ve, Ie]), ce.position = {
      start: Ml(ve.start),
      // @ts-expect-error: `end` will be patched later.
      end: void 0
    };
  }
  function u(ce) {
    return ve;
    function ve(Ie) {
      ce && ce.call(this, Ie), l.call(this, Ie);
    }
  }
  function l(ce, ve) {
    const Ie = this.stack.pop(), q = this.tokenStack.pop();
    if (q)
      q[0].type !== ce.type && (ve ? ve.call(this, ce, q[0]) : (q[1] || sL).call(this, ce, q[0]));
    else
      throw new Error(
        "Cannot close `" + ce.type + "` (" + qu({
          start: ce.start,
          end: ce.end
        }) + "): it’s not open"
      );
    Ie.position.end = Ml(ce.end);
  }
  function c() {
    return PJe(this.stack.pop());
  }
  function d() {
    this.data.expectingFirstListItemValue = !0;
  }
  function f(ce) {
    if (this.data.expectingFirstListItemValue) {
      const ve = this.stack[this.stack.length - 2];
      ve.start = Number.parseInt(this.sliceSerialize(ce), 10), this.data.expectingFirstListItemValue = void 0;
    }
  }
  function h() {
    const ce = this.resume(), ve = this.stack[this.stack.length - 1];
    ve.lang = ce;
  }
  function p() {
    const ce = this.resume(), ve = this.stack[this.stack.length - 1];
    ve.meta = ce;
  }
  function v() {
    this.data.flowCodeInside || (this.buffer(), this.data.flowCodeInside = !0);
  }
  function m() {
    const ce = this.resume(), ve = this.stack[this.stack.length - 1];
    ve.value = ce.replace(/^(\r?\n|\r)|(\r?\n|\r)$/g, ""), this.data.flowCodeInside = void 0;
  }
  function b() {
    const ce = this.resume(), ve = this.stack[this.stack.length - 1];
    ve.value = ce.replace(/(\r?\n|\r)$/g, "");
  }
  function y(ce) {
    const ve = this.resume(), Ie = this.stack[this.stack.length - 1];
    Ie.label = ve, Ie.identifier = Xh(
      this.sliceSerialize(ce)
    ).toLowerCase();
  }
  function w() {
    const ce = this.resume(), ve = this.stack[this.stack.length - 1];
    ve.title = ce;
  }
  function S() {
    const ce = this.resume(), ve = this.stack[this.stack.length - 1];
    ve.url = ce;
  }
  function E(ce) {
    const ve = this.stack[this.stack.length - 1];
    if (!ve.depth) {
      const Ie = this.sliceSerialize(ce).length;
      ve.depth = Ie;
    }
  }
  function I() {
    this.data.setextHeadingSlurpLineEnding = !0;
  }
  function _(ce) {
    const ve = this.stack[this.stack.length - 1];
    ve.depth = this.sliceSerialize(ce).codePointAt(0) === 61 ? 1 : 2;
  }
  function A() {
    this.data.setextHeadingSlurpLineEnding = void 0;
  }
  function P(ce) {
    const Ie = this.stack[this.stack.length - 1].children;
    let q = Ie[Ie.length - 1];
    (!q || q.type !== "text") && (q = Ae(), q.position = {
      start: Ml(ce.start),
      // @ts-expect-error: we’ll add `end` later.
      end: void 0
    }, Ie.push(q)), this.stack.push(q);
  }
  function N(ce) {
    const ve = this.stack.pop();
    ve.value += this.sliceSerialize(ce), ve.position.end = Ml(ce.end);
  }
  function k(ce) {
    const ve = this.stack[this.stack.length - 1];
    if (this.data.atHardBreak) {
      const Ie = ve.children[ve.children.length - 1];
      Ie.position.end = Ml(ce.end), this.data.atHardBreak = void 0;
      return;
    }
    !this.data.setextHeadingSlurpLineEnding && e.canContainEols.includes(ve.type) && (P.call(this, ce), N.call(this, ce));
  }
  function D() {
    this.data.atHardBreak = !0;
  }
  function R() {
    const ce = this.resume(), ve = this.stack[this.stack.length - 1];
    ve.value = ce;
  }
  function V() {
    const ce = this.resume(), ve = this.stack[this.stack.length - 1];
    ve.value = ce;
  }
  function $() {
    const ce = this.resume(), ve = this.stack[this.stack.length - 1];
    ve.value = ce;
  }
  function F() {
    const ce = this.stack[this.stack.length - 1];
    if (this.data.inReference) {
      const ve = this.data.referenceType || "shortcut";
      ce.type += "Reference", ce.referenceType = ve, delete ce.url, delete ce.title;
    } else
      delete ce.identifier, delete ce.label;
    this.data.referenceType = void 0;
  }
  function M() {
    const ce = this.stack[this.stack.length - 1];
    if (this.data.inReference) {
      const ve = this.data.referenceType || "shortcut";
      ce.type += "Reference", ce.referenceType = ve, delete ce.url, delete ce.title;
    } else
      delete ce.identifier, delete ce.label;
    this.data.referenceType = void 0;
  }
  function B(ce) {
    const ve = this.sliceSerialize(ce), Ie = this.stack[this.stack.length - 2];
    Ie.label = _q(ve), Ie.identifier = Xh(ve).toLowerCase();
  }
  function X() {
    const ce = this.stack[this.stack.length - 1], ve = this.resume(), Ie = this.stack[this.stack.length - 1];
    if (this.data.inReference = !0, Ie.type === "link") {
      const q = ce.children;
      Ie.children = q;
    } else
      Ie.alt = ve;
  }
  function L() {
    const ce = this.resume(), ve = this.stack[this.stack.length - 1];
    ve.url = ce;
  }
  function j() {
    const ce = this.resume(), ve = this.stack[this.stack.length - 1];
    ve.title = ce;
  }
  function K() {
    this.data.inReference = void 0;
  }
  function W() {
    this.data.referenceType = "collapsed";
  }
  function Y(ce) {
    const ve = this.resume(), Ie = this.stack[this.stack.length - 1];
    Ie.label = ve, Ie.identifier = Xh(
      this.sliceSerialize(ce)
    ).toLowerCase(), this.data.referenceType = "full";
  }
  function U(ce) {
    this.data.characterReferenceType = ce.type;
  }
  function Q(ce) {
    const ve = this.sliceSerialize(ce), Ie = this.data.characterReferenceType;
    let q;
    Ie ? (q = Iq(
      ve,
      Ie === "characterReferenceMarkerNumeric" ? 10 : 16
    ), this.data.characterReferenceType = void 0) : q = gm(ve);
    const Fe = this.stack.pop();
    Fe.value += q, Fe.position.end = Ml(ce.end);
  }
  function Z(ce) {
    N.call(this, ce);
    const ve = this.stack[this.stack.length - 1];
    ve.url = this.sliceSerialize(ce);
  }
  function ee(ce) {
    N.call(this, ce);
    const ve = this.stack[this.stack.length - 1];
    ve.url = "mailto:" + this.sliceSerialize(ce);
  }
  function ie() {
    return {
      type: "blockquote",
      children: []
    };
  }
  function oe() {
    return {
      type: "code",
      lang: null,
      meta: null,
      value: ""
    };
  }
  function se() {
    return {
      type: "inlineCode",
      value: ""
    };
  }
  function te() {
    return {
      type: "definition",
      identifier: "",
      label: null,
      title: null,
      url: ""
    };
  }
  function ge() {
    return {
      type: "emphasis",
      children: []
    };
  }
  function he() {
    return {
      type: "heading",
      // @ts-expect-error `depth` will be set later.
      depth: 0,
      children: []
    };
  }
  function fe() {
    return {
      type: "break"
    };
  }
  function _e() {
    return {
      type: "html",
      value: ""
    };
  }
  function Ne() {
    return {
      type: "image",
      title: null,
      url: "",
      alt: null
    };
  }
  function ze() {
    return {
      type: "link",
      title: null,
      url: "",
      children: []
    };
  }
  function Ve(ce) {
    return {
      type: "list",
      ordered: ce.type === "listOrdered",
      start: null,
      spread: ce._spread,
      children: []
    };
  }
  function ne(ce) {
    return {
      type: "listItem",
      spread: ce._spread,
      checked: null,
      children: []
    };
  }
  function pe() {
    return {
      type: "paragraph",
      children: []
    };
  }
  function ye() {
    return {
      type: "strong",
      children: []
    };
  }
  function Ae() {
    return {
      type: "text",
      value: ""
    };
  }
  function we() {
    return {
      type: "thematicBreak"
    };
  }
}
function Ml(t) {
  return {
    line: t.line,
    column: t.column,
    offset: t.offset
  };
}
function jq(t, e) {
  let n = -1;
  for (; ++n < e.length; ) {
    const r = e[n];
    Array.isArray(r) ? jq(t, r) : Sqe(t, r);
  }
}
function Sqe(t, e) {
  let n;
  for (n in e)
    if (Wq.call(e, n))
      switch (n) {
        case "canContainEols": {
          const r = e[n];
          r && t[n].push(...r);
          break;
        }
        case "transforms": {
          const r = e[n];
          r && t[n].push(...r);
          break;
        }
        case "enter":
        case "exit": {
          const r = e[n];
          r && Object.assign(t[n], r);
          break;
        }
      }
}
function sL(t, e) {
  throw t ? new Error(
    "Cannot close `" + t.type + "` (" + qu({
      start: t.start,
      end: t.end
    }) + "): a different token (`" + e.type + "`, " + qu({
      start: e.start,
      end: e.end
    }) + ") is open"
  ) : new Error(
    "Cannot close document, a token (`" + e.type + "`, " + qu({
      start: e.start,
      end: e.end
    }) + ") is still open"
  );
}
function $b(t) {
  return t.children instanceof Array;
}
class D4 extends Error {
  constructor(e, n) {
    super(e), this.name = "MarkdownParseError", this.cause = n;
  }
}
class M4 extends Error {
  constructor(e) {
    super(e), this.name = "UnrecognizedMarkdownConstructError";
  }
}
function Iqe({
  root: t,
  markdown: e,
  visitors: n,
  syntaxExtensions: r,
  mdastExtensions: i,
  ...o
}) {
  var a;
  let s;
  try {
    s = wqe(e, {
      extensions: r,
      mdastExtensions: i
    });
  } catch (u) {
    throw u instanceof Error ? new D4(`Error parsing markdown: ${u.message}`, u) : new D4(`Error parsing markdown: ${u}`, u);
  }
  s.children.length === 0 && s.children.push({ type: "paragraph", children: [] }), ((a = s.children.at(-1)) == null ? void 0 : a.type) !== "paragraph" && s.children.push({ type: "paragraph", children: [] }), zq({ root: t, mdastRoot: s, visitors: n, ...o });
}
function zq({ root: t, mdastRoot: e, visitors: n, ...r }) {
  const i = /* @__PURE__ */ new WeakMap();
  n = n.sort((s, u) => (u.priority ?? 0) - (s.priority ?? 0));
  function o(s, u) {
    if (!$b(s))
      throw new Error("Attempting to visit children of a non-parent");
    s.children.forEach((l) => {
      a(l, u, s);
    });
  }
  function a(s, u, l) {
    const c = n.find((d) => typeof d.testNode == "string" ? d.testNode === s.type : d.testNode(s, r));
    if (!c)
      try {
        throw new M4(`Unsupported markdown syntax: ${Aq(s)}`);
      } catch {
        throw new M4(
          `Parsing of the following markdown structure failed: ${JSON.stringify({
            type: s.type,
            name: "name" in s ? s.name : "N/A"
          })}`
        );
      }
    c.visitNode({
      //@ts-expect-error root type is glitching
      mdastNode: s,
      lexicalParent: u,
      mdastParent: l,
      descriptors: r,
      actions: {
        visitChildren: o,
        addAndStepInto(d) {
          u.append(d), $b(s) && o(s, d);
        },
        addFormatting(d, f) {
          f || $b(s) && (f = s), f && i.set(f, d | (i.get(l) ?? 0));
        },
        removeFormatting(d, f) {
          f || $b(s) && (f = s), f && i.set(f, d ^ (i.get(l) ?? 0));
        },
        getParentFormatting() {
          return i.get(l) ?? 0;
        }
      }
    });
  }
  a(e, t, null);
}
var _qe = Object.defineProperty, Aqe = (t, e, n) => e in t ? _qe(t, e, { enumerable: !0, configurable: !0, writable: !0, value: n }) : t[e] = n, h5 = (t, e, n) => (Aqe(t, typeof e != "symbol" ? e + "" : e, n), n);
const uL = "generic-html";
class Cv extends Eu {
  /**
   * Constructs a new {@link GenericHTMLNode} with the specified MDAST HTML node as the object to edit.
   */
  constructor(e, n, r, i) {
    super(i), h5(this, "__tag"), h5(this, "__nodeType"), h5(this, "__attributes"), this.__tag = e, this.__nodeType = n, this.__attributes = r;
  }
  /** @internal */
  static getType() {
    return uL;
  }
  /** @internal */
  static clone(e) {
    return new Cv(e.__tag, e.__nodeType, e.__attributes, e.__key);
  }
  getTag() {
    return this.__tag;
  }
  getNodeType() {
    return this.__nodeType;
  }
  getAttributes() {
    return this.__attributes;
  }
  updateAttributes(e) {
    const n = this.getWritable();
    n.__attributes = e;
  }
  getStyle() {
    var e;
    return (e = this.__attributes.find((n) => n.name === "style")) == null ? void 0 : e.value;
  }
  // View
  createDOM() {
    const e = this.__tag, n = document.createElement(e);
    return this.__attributes.forEach((r) => {
      n.setAttribute(r.name, r.value);
    }), n;
  }
  updateDOM() {
    return !1;
  }
  static importDOM() {
    return {};
  }
  exportDOM(e) {
    const { element: n } = super.exportDOM(e);
    return {
      element: n
    };
  }
  static importJSON(e) {
    const n = Gq(e.tag, e.mdxType, e.attributes);
    return n.setFormat(e.format), n.setIndent(e.indent), n.setDirection(e.direction), n;
  }
  exportJSON() {
    return {
      ...super.exportJSON(),
      tag: this.getTag(),
      attributes: this.__attributes,
      mdxType: this.__nodeType,
      type: uL,
      version: 1
    };
  }
  /*
    // Mutation
    insertNewAfter(selection?: RangeSelection, restoreSelection = true): ParagraphNode | GenericHTMLNode {
      const anchorOffet = selection ? selection.anchor.offset : 0
      const newElement =
        anchorOffet > 0 && anchorOffet < this.getTextContentSize() ? $createHeadingNode(this.getTag()) : $createParagraphNode()
      const direction = this.getDirection()
      newElement.setDirection(direction)
      this.insertAfter(newElement, restoreSelection)
      return newElement
    }
  
    collapseAtStart(): true {
      const newElement = !this.isEmpty() ? $createHeadingNode(this.getTag()) : $createParagraphNode()
      const children = this.getChildren()
      children.forEach((child) => newElement.append(child))
      this.replace(newElement)
      return true
    }*/
  extractWithChild() {
    return !0;
  }
  isInline() {
    return this.__nodeType === "mdxJsxTextElement";
  }
}
function Gq(t, e, n) {
  return Qa(new Cv(t, e, n));
}
function Tqe(t) {
  return t instanceof Cv;
}
const Oqe = {
  testLexicalNode: Tqe,
  visitLexicalNode({ actions: t, lexicalNode: e }) {
    t.addAndStepInto("mdxJsxTextElement", {
      name: e.getTag(),
      type: e.getNodeType(),
      attributes: e.getAttributes()
    });
  },
  priority: -100
}, Pqe = {
  testLexicalNode: lu,
  visitLexicalNode: ({ mdastParent: t, actions: e }) => {
    e.appendToParent(t, { type: "text", value: `
` });
  }
}, Nqe = {
  testLexicalNode: dp,
  visitLexicalNode: ({ actions: t }) => {
    t.addAndStepInto("paragraph");
  }
}, kqe = {
  testLexicalNode: Hi,
  visitLexicalNode: ({ actions: t }) => {
    t.addAndStepInto("root");
  }
}, P0 = 1, N0 = 2, Iy = 4, k0 = 8, wO = 16, _y = 32, Ay = 64;
function lL(t) {
  return t.type === "text";
}
const Rqe = ["u", "span", "sub", "sup"], $qe = {
  shouldJoin: (t, e) => {
    if (["text", "emphasis", "strong"].includes(t.type))
      return t.type === e.type;
    if (t.type === "mdxJsxTextElement" && // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition
    e.type === "mdxJsxTextElement" && Rqe.includes(e.name)) {
      const n = e;
      return t.name === n.name && JSON.stringify(t.attributes) === JSON.stringify(n.attributes);
    }
    return !1;
  },
  join(t, e) {
    return lL(t) && lL(e) ? {
      type: "text",
      value: t.value + e.value
    } : {
      ...t,
      children: [...t.children, ...e.children]
    };
  },
  testLexicalNode: pt,
  visitLexicalNode: ({ lexicalNode: t, mdastParent: e, actions: n }) => {
    const r = t.getPreviousSibling(), i = pt(r) ? r.getFormat() : 0, o = t.getTextContent(), a = t.getFormat(), s = t.getStyle();
    let u = e;
    if (s && (u = n.appendToParent(u, {
      type: "mdxJsxTextElement",
      name: "span",
      children: [],
      attributes: [{ type: "mdxJsxAttribute", name: "style", value: s }]
    })), i & a & N0 && (u = n.appendToParent(u, {
      type: "emphasis",
      children: []
    })), i & a & P0 && (u = n.appendToParent(u, {
      type: "strong",
      children: []
    })), i & a & k0 && (u = n.appendToParent(u, {
      type: "mdxJsxTextElement",
      name: "u",
      children: [],
      attributes: []
    })), i & a & Iy && (u = n.appendToParent(u, {
      type: "delete",
      children: []
    })), i & a & Ay && (u = n.appendToParent(u, {
      type: "mdxJsxTextElement",
      name: "sup",
      children: [],
      attributes: []
    })), i & a & _y && (u = n.appendToParent(u, {
      type: "mdxJsxTextElement",
      name: "sub",
      children: [],
      attributes: []
    })), a & N0 && !(i & N0) && (u = n.appendToParent(u, {
      type: "emphasis",
      children: []
    })), a & P0 && !(i & P0) && (u = n.appendToParent(u, {
      type: "strong",
      children: []
    })), a & k0 && !(i & k0) && (u = n.appendToParent(u, {
      type: "mdxJsxTextElement",
      name: "u",
      children: [],
      attributes: []
    })), a & Iy && !(i & Iy) && (u = n.appendToParent(u, {
      type: "delete",
      children: []
    })), a & Ay && !(i & Ay) && (u = n.appendToParent(u, {
      type: "mdxJsxTextElement",
      name: "sup",
      children: [],
      attributes: []
    })), a & _y && !(i & _y) && (u = n.appendToParent(u, {
      type: "mdxJsxTextElement",
      name: "sub",
      children: [],
      attributes: []
    })), a & wO) {
      n.appendToParent(u, {
        type: "inlineCode",
        value: o
      });
      return;
    }
    n.appendToParent(u, {
      type: "text",
      value: o
    });
  }
}, Dqe = {
  testNode: "break",
  visitNode: function({ lexicalParent: t }) {
    t.append(mc());
  }
};
function Db(t, e) {
  return [
    {
      testNode: (n) => n.type === "mdxJsxTextElement" && n.name === t,
      visitNode({ actions: n, mdastNode: r, lexicalParent: i }) {
        n.addFormatting(e), n.visitChildren(r, i);
      }
    },
    {
      testNode: (n) => n.type === "html" && n.value === `<${t}>`,
      visitNode({ actions: n, mdastParent: r }) {
        n.addFormatting(e, r);
      }
    },
    {
      testNode: (n) => n.type === "html" && n.value === `</${t}>`,
      visitNode({ actions: n, mdastParent: r }) {
        n.removeFormatting(e, r);
      }
    }
  ];
}
const Mqe = {
  testNode: "delete",
  visitNode({ mdastNode: t, actions: e, lexicalParent: n }) {
    e.addFormatting(Iy), e.visitChildren(t, n);
  }
}, Fqe = {
  testNode: "inlineCode",
  visitNode({ mdastNode: t, actions: e }) {
    e.addAndStepInto(Xr(t.value).setFormat(e.getParentFormatting() | wO));
  }
}, Lqe = {
  testNode: "emphasis",
  visitNode({ mdastNode: t, actions: e, lexicalParent: n }) {
    e.addFormatting(N0), e.visitChildren(t, n);
  }
}, Vqe = {
  testNode: "strong",
  visitNode({ mdastNode: t, actions: e, lexicalParent: n }) {
    e.addFormatting(P0), e.visitChildren(t, n);
  }
}, Bqe = [
  // emphasis
  Lqe,
  // strong
  Vqe,
  // underline
  ...Db("u", k0),
  // code
  ...Db("code", wO),
  Fqe,
  // strikethrough
  Mqe,
  // superscript
  ...Db("sup", Ay),
  // subscript
  ...Db("sub", _y)
], Hqe = {
  testNode: Tq,
  visitNode: function({ mdastNode: t, actions: e }) {
    e.addAndStepInto(Gq(t.name, t.type, t.attributes));
  },
  priority: -100
}, Wqe = ["listitem", "quote", "admonition"], jqe = {
  testNode: "paragraph",
  visitNode: function({ mdastNode: t, lexicalParent: e, actions: n }) {
    Wqe.includes(e.getType()) ? n.visitChildren(t, e) : n.addAndStepInto(Sr());
  }
}, zqe = {
  testNode: "root",
  visitNode({ actions: t, mdastNode: e, lexicalParent: n }) {
    t.visitChildren(e, n);
  }
}, Gqe = {
  testNode: "text",
  visitNode({ mdastNode: t, actions: e }) {
    e.addAndStepInto(Xr(t.value).setFormat(e.getParentFormatting()));
  }
}, Uqe = () => /* @__PURE__ */ O.createElement(GK, { externalHistoryState: ua(wQe) }), us = (
  /** @type {const} */
  {
    carriageReturn: -5,
    lineFeed: -4,
    carriageReturnLineFeed: -3,
    horizontalTab: -2,
    virtualSpace: -1,
    eof: null,
    nul: 0,
    soh: 1,
    stx: 2,
    etx: 3,
    eot: 4,
    enq: 5,
    ack: 6,
    bel: 7,
    bs: 8,
    ht: 9,
    // `\t`
    lf: 10,
    // `\n`
    vt: 11,
    // `\v`
    ff: 12,
    // `\f`
    cr: 13,
    // `\r`
    so: 14,
    si: 15,
    dle: 16,
    dc1: 17,
    dc2: 18,
    dc3: 19,
    dc4: 20,
    nak: 21,
    syn: 22,
    etb: 23,
    can: 24,
    em: 25,
    sub: 26,
    esc: 27,
    fs: 28,
    gs: 29,
    rs: 30,
    us: 31,
    space: 32,
    exclamationMark: 33,
    // `!`
    quotationMark: 34,
    // `"`
    numberSign: 35,
    // `#`
    dollarSign: 36,
    // `$`
    percentSign: 37,
    // `%`
    ampersand: 38,
    // `&`
    apostrophe: 39,
    // `'`
    leftParenthesis: 40,
    // `(`
    rightParenthesis: 41,
    // `)`
    asterisk: 42,
    // `*`
    plusSign: 43,
    // `+`
    comma: 44,
    // `,`
    dash: 45,
    // `-`
    dot: 46,
    // `.`
    slash: 47,
    // `/`
    digit0: 48,
    // `0`
    digit1: 49,
    // `1`
    digit2: 50,
    // `2`
    digit3: 51,
    // `3`
    digit4: 52,
    // `4`
    digit5: 53,
    // `5`
    digit6: 54,
    // `6`
    digit7: 55,
    // `7`
    digit8: 56,
    // `8`
    digit9: 57,
    // `9`
    colon: 58,
    // `:`
    semicolon: 59,
    // `;`
    lessThan: 60,
    // `<`
    equalsTo: 61,
    // `=`
    greaterThan: 62,
    // `>`
    questionMark: 63,
    // `?`
    atSign: 64,
    // `@`
    uppercaseA: 65,
    // `A`
    uppercaseB: 66,
    // `B`
    uppercaseC: 67,
    // `C`
    uppercaseD: 68,
    // `D`
    uppercaseE: 69,
    // `E`
    uppercaseF: 70,
    // `F`
    uppercaseG: 71,
    // `G`
    uppercaseH: 72,
    // `H`
    uppercaseI: 73,
    // `I`
    uppercaseJ: 74,
    // `J`
    uppercaseK: 75,
    // `K`
    uppercaseL: 76,
    // `L`
    uppercaseM: 77,
    // `M`
    uppercaseN: 78,
    // `N`
    uppercaseO: 79,
    // `O`
    uppercaseP: 80,
    // `P`
    uppercaseQ: 81,
    // `Q`
    uppercaseR: 82,
    // `R`
    uppercaseS: 83,
    // `S`
    uppercaseT: 84,
    // `T`
    uppercaseU: 85,
    // `U`
    uppercaseV: 86,
    // `V`
    uppercaseW: 87,
    // `W`
    uppercaseX: 88,
    // `X`
    uppercaseY: 89,
    // `Y`
    uppercaseZ: 90,
    // `Z`
    leftSquareBracket: 91,
    // `[`
    backslash: 92,
    // `\`
    rightSquareBracket: 93,
    // `]`
    caret: 94,
    // `^`
    underscore: 95,
    // `_`
    graveAccent: 96,
    // `` ` ``
    lowercaseA: 97,
    // `a`
    lowercaseB: 98,
    // `b`
    lowercaseC: 99,
    // `c`
    lowercaseD: 100,
    // `d`
    lowercaseE: 101,
    // `e`
    lowercaseF: 102,
    // `f`
    lowercaseG: 103,
    // `g`
    lowercaseH: 104,
    // `h`
    lowercaseI: 105,
    // `i`
    lowercaseJ: 106,
    // `j`
    lowercaseK: 107,
    // `k`
    lowercaseL: 108,
    // `l`
    lowercaseM: 109,
    // `m`
    lowercaseN: 110,
    // `n`
    lowercaseO: 111,
    // `o`
    lowercaseP: 112,
    // `p`
    lowercaseQ: 113,
    // `q`
    lowercaseR: 114,
    // `r`
    lowercaseS: 115,
    // `s`
    lowercaseT: 116,
    // `t`
    lowercaseU: 117,
    // `u`
    lowercaseV: 118,
    // `v`
    lowercaseW: 119,
    // `w`
    lowercaseX: 120,
    // `x`
    lowercaseY: 121,
    // `y`
    lowercaseZ: 122,
    // `z`
    leftCurlyBrace: 123,
    // `{`
    verticalBar: 124,
    // `|`
    rightCurlyBrace: 125,
    // `}`
    tilde: 126,
    // `~`
    del: 127,
    // Unicode Specials block.
    byteOrderMarker: 65279,
    // Unicode Specials block.
    replacementCharacter: 65533
    // `�`
  }
), Qc = (
  /** @type {const} */
  {
    // Generic type for data, such as in a title, a destination, etc.
    data: "data",
    // Generic type for syntactic whitespace (tabs, virtual spaces, spaces).
    // Such as, between a fenced code fence and an info string.
    whitespace: "whitespace",
    // Generic type for line endings (line feed, carriage return, carriage return +
    // line feed).
    lineEnding: "lineEnding",
    // A line ending, but ending a blank line.
    lineEndingBlank: "lineEndingBlank",
    // Generic type for whitespace (tabs, virtual spaces, spaces) at the start of a
    // line.
    linePrefix: "linePrefix",
    // Generic type for whitespace (tabs, virtual spaces, spaces) at the end of a
    // line.
    lineSuffix: "lineSuffix",
    // Whole ATX heading:
    //
    // ```markdown
    // #
    // ## Alpha
    // ### Bravo ###
    // ```
    //
    // Includes `atxHeadingSequence`, `whitespace`, `atxHeadingText`.
    atxHeading: "atxHeading",
    // Sequence of number signs in an ATX heading (`###`).
    atxHeadingSequence: "atxHeadingSequence",
    // Content in an ATX heading (`alpha`).
    // Includes text.
    atxHeadingText: "atxHeadingText",
    // Whole autolink (`<https://example.com>` or `<admin@example.com>`)
    // Includes `autolinkMarker` and `autolinkProtocol` or `autolinkEmail`.
    autolink: "autolink",
    // Email autolink w/o markers (`admin@example.com`)
    autolinkEmail: "autolinkEmail",
    // Marker around an `autolinkProtocol` or `autolinkEmail` (`<` or `>`).
    autolinkMarker: "autolinkMarker",
    // Protocol autolink w/o markers (`https://example.com`)
    autolinkProtocol: "autolinkProtocol",
    // A whole character escape (`\-`).
    // Includes `escapeMarker` and `characterEscapeValue`.
    characterEscape: "characterEscape",
    // The escaped character (`-`).
    characterEscapeValue: "characterEscapeValue",
    // A whole character reference (`&amp;`, `&#8800;`, or `&#x1D306;`).
    // Includes `characterReferenceMarker`, an optional
    // `characterReferenceMarkerNumeric`, in which case an optional
    // `characterReferenceMarkerHexadecimal`, and a `characterReferenceValue`.
    characterReference: "characterReference",
    // The start or end marker (`&` or `;`).
    characterReferenceMarker: "characterReferenceMarker",
    // Mark reference as numeric (`#`).
    characterReferenceMarkerNumeric: "characterReferenceMarkerNumeric",
    // Mark reference as numeric (`x` or `X`).
    characterReferenceMarkerHexadecimal: "characterReferenceMarkerHexadecimal",
    // Value of character reference w/o markers (`amp`, `8800`, or `1D306`).
    characterReferenceValue: "characterReferenceValue",
    // Whole fenced code:
    //
    // ````markdown
    // ```js
    // alert(1)
    // ```
    // ````
    codeFenced: "codeFenced",
    // A fenced code fence, including whitespace, sequence, info, and meta
    // (` ```js `).
    codeFencedFence: "codeFencedFence",
    // Sequence of grave accent or tilde characters (` ``` `) in a fence.
    codeFencedFenceSequence: "codeFencedFenceSequence",
    // Info word (`js`) in a fence.
    // Includes string.
    codeFencedFenceInfo: "codeFencedFenceInfo",
    // Meta words (`highlight="1"`) in a fence.
    // Includes string.
    codeFencedFenceMeta: "codeFencedFenceMeta",
    // A line of code.
    codeFlowValue: "codeFlowValue",
    // Whole indented code:
    //
    // ```markdown
    //     alert(1)
    // ```
    //
    // Includes `lineEnding`, `linePrefix`, and `codeFlowValue`.
    codeIndented: "codeIndented",
    // A text code (``` `alpha` ```).
    // Includes `codeTextSequence`, `codeTextData`, `lineEnding`, and can include
    // `codeTextPadding`.
    codeText: "codeText",
    codeTextData: "codeTextData",
    // A space or line ending right after or before a tick.
    codeTextPadding: "codeTextPadding",
    // A text code fence (` `` `).
    codeTextSequence: "codeTextSequence",
    // Whole content:
    //
    // ```markdown
    // [a]: b
    // c
    // =
    // d
    // ```
    //
    // Includes `paragraph` and `definition`.
    content: "content",
    // Whole definition:
    //
    // ```markdown
    // [micromark]: https://github.com/micromark/micromark
    // ```
    //
    // Includes `definitionLabel`, `definitionMarker`, `whitespace`,
    // `definitionDestination`, and optionally `lineEnding` and `definitionTitle`.
    definition: "definition",
    // Destination of a definition (`https://github.com/micromark/micromark` or
    // `<https://github.com/micromark/micromark>`).
    // Includes `definitionDestinationLiteral` or `definitionDestinationRaw`.
    definitionDestination: "definitionDestination",
    // Enclosed destination of a definition
    // (`<https://github.com/micromark/micromark>`).
    // Includes `definitionDestinationLiteralMarker` and optionally
    // `definitionDestinationString`.
    definitionDestinationLiteral: "definitionDestinationLiteral",
    // Markers of an enclosed definition destination (`<` or `>`).
    definitionDestinationLiteralMarker: "definitionDestinationLiteralMarker",
    // Unenclosed destination of a definition
    // (`https://github.com/micromark/micromark`).
    // Includes `definitionDestinationString`.
    definitionDestinationRaw: "definitionDestinationRaw",
    // Text in an destination (`https://github.com/micromark/micromark`).
    // Includes string.
    definitionDestinationString: "definitionDestinationString",
    // Label of a definition (`[micromark]`).
    // Includes `definitionLabelMarker` and `definitionLabelString`.
    definitionLabel: "definitionLabel",
    // Markers of a definition label (`[` or `]`).
    definitionLabelMarker: "definitionLabelMarker",
    // Value of a definition label (`micromark`).
    // Includes string.
    definitionLabelString: "definitionLabelString",
    // Marker between a label and a destination (`:`).
    definitionMarker: "definitionMarker",
    // Title of a definition (`"x"`, `'y'`, or `(z)`).
    // Includes `definitionTitleMarker` and optionally `definitionTitleString`.
    definitionTitle: "definitionTitle",
    // Marker around a title of a definition (`"`, `'`, `(`, or `)`).
    definitionTitleMarker: "definitionTitleMarker",
    // Data without markers in a title (`z`).
    // Includes string.
    definitionTitleString: "definitionTitleString",
    // Emphasis (`*alpha*`).
    // Includes `emphasisSequence` and `emphasisText`.
    emphasis: "emphasis",
    // Sequence of emphasis markers (`*` or `_`).
    emphasisSequence: "emphasisSequence",
    // Emphasis text (`alpha`).
    // Includes text.
    emphasisText: "emphasisText",
    // The character escape marker (`\`).
    escapeMarker: "escapeMarker",
    // A hard break created with a backslash (`\\n`).
    // Note: does not include the line ending.
    hardBreakEscape: "hardBreakEscape",
    // A hard break created with trailing spaces (`  \n`).
    // Does not include the line ending.
    hardBreakTrailing: "hardBreakTrailing",
    // Flow HTML:
    //
    // ```markdown
    // <div
    // ```
    //
    // Inlcudes `lineEnding`, `htmlFlowData`.
    htmlFlow: "htmlFlow",
    htmlFlowData: "htmlFlowData",
    // HTML in text (the tag in `a <i> b`).
    // Includes `lineEnding`, `htmlTextData`.
    htmlText: "htmlText",
    htmlTextData: "htmlTextData",
    // Whole image (`![alpha](bravo)`, `![alpha][bravo]`, `![alpha][]`, or
    // `![alpha]`).
    // Includes `label` and an optional `resource` or `reference`.
    image: "image",
    // Whole link label (`[*alpha*]`).
    // Includes `labelLink` or `labelImage`, `labelText`, and `labelEnd`.
    label: "label",
    // Text in an label (`*alpha*`).
    // Includes text.
    labelText: "labelText",
    // Start a link label (`[`).
    // Includes a `labelMarker`.
    labelLink: "labelLink",
    // Start an image label (`![`).
    // Includes `labelImageMarker` and `labelMarker`.
    labelImage: "labelImage",
    // Marker of a label (`[` or `]`).
    labelMarker: "labelMarker",
    // Marker to start an image (`!`).
    labelImageMarker: "labelImageMarker",
    // End a label (`]`).
    // Includes `labelMarker`.
    labelEnd: "labelEnd",
    // Whole link (`[alpha](bravo)`, `[alpha][bravo]`, `[alpha][]`, or `[alpha]`).
    // Includes `label` and an optional `resource` or `reference`.
    link: "link",
    // Whole paragraph:
    //
    // ```markdown
    // alpha
    // bravo.
    // ```
    //
    // Includes text.
    paragraph: "paragraph",
    // A reference (`[alpha]` or `[]`).
    // Includes `referenceMarker` and an optional `referenceString`.
    reference: "reference",
    // A reference marker (`[` or `]`).
    referenceMarker: "referenceMarker",
    // Reference text (`alpha`).
    // Includes string.
    referenceString: "referenceString",
    // A resource (`(https://example.com "alpha")`).
    // Includes `resourceMarker`, an optional `resourceDestination` with an optional
    // `whitespace` and `resourceTitle`.
    resource: "resource",
    // A resource destination (`https://example.com`).
    // Includes `resourceDestinationLiteral` or `resourceDestinationRaw`.
    resourceDestination: "resourceDestination",
    // A literal resource destination (`<https://example.com>`).
    // Includes `resourceDestinationLiteralMarker` and optionally
    // `resourceDestinationString`.
    resourceDestinationLiteral: "resourceDestinationLiteral",
    // A resource destination marker (`<` or `>`).
    resourceDestinationLiteralMarker: "resourceDestinationLiteralMarker",
    // A raw resource destination (`https://example.com`).
    // Includes `resourceDestinationString`.
    resourceDestinationRaw: "resourceDestinationRaw",
    // Resource destination text (`https://example.com`).
    // Includes string.
    resourceDestinationString: "resourceDestinationString",
    // A resource marker (`(` or `)`).
    resourceMarker: "resourceMarker",
    // A resource title (`"alpha"`, `'alpha'`, or `(alpha)`).
    // Includes `resourceTitleMarker` and optionally `resourceTitleString`.
    resourceTitle: "resourceTitle",
    // A resource title marker (`"`, `'`, `(`, or `)`).
    resourceTitleMarker: "resourceTitleMarker",
    // Resource destination title (`alpha`).
    // Includes string.
    resourceTitleString: "resourceTitleString",
    // Whole setext heading:
    //
    // ```markdown
    // alpha
    // bravo
    // =====
    // ```
    //
    // Includes `setextHeadingText`, `lineEnding`, `linePrefix`, and
    // `setextHeadingLine`.
    setextHeading: "setextHeading",
    // Content in a setext heading (`alpha\nbravo`).
    // Includes text.
    setextHeadingText: "setextHeadingText",
    // Underline in a setext heading, including whitespace suffix (`==`).
    // Includes `setextHeadingLineSequence`.
    setextHeadingLine: "setextHeadingLine",
    // Sequence of equals or dash characters in underline in a setext heading (`-`).
    setextHeadingLineSequence: "setextHeadingLineSequence",
    // Strong (`**alpha**`).
    // Includes `strongSequence` and `strongText`.
    strong: "strong",
    // Sequence of strong markers (`**` or `__`).
    strongSequence: "strongSequence",
    // Strong text (`alpha`).
    // Includes text.
    strongText: "strongText",
    // Whole thematic break:
    //
    // ```markdown
    // * * *
    // ```
    //
    // Includes `thematicBreakSequence` and `whitespace`.
    thematicBreak: "thematicBreak",
    // A sequence of one or more thematic break markers (`***`).
    thematicBreakSequence: "thematicBreakSequence",
    // Whole block quote:
    //
    // ```markdown
    // > a
    // >
    // > b
    // ```
    //
    // Includes `blockQuotePrefix` and flow.
    blockQuote: "blockQuote",
    // The `>` or `> ` of a block quote.
    blockQuotePrefix: "blockQuotePrefix",
    // The `>` of a block quote prefix.
    blockQuoteMarker: "blockQuoteMarker",
    // The optional ` ` of a block quote prefix.
    blockQuotePrefixWhitespace: "blockQuotePrefixWhitespace",
    // Whole unordered list:
    //
    // ```markdown
    // - a
    //   b
    // ```
    //
    // Includes `listItemPrefix`, flow, and optionally  `listItemIndent` on further
    // lines.
    listOrdered: "listOrdered",
    // Whole ordered list:
    //
    // ```markdown
    // 1. a
    //    b
    // ```
    //
    // Includes `listItemPrefix`, flow, and optionally  `listItemIndent` on further
    // lines.
    listUnordered: "listUnordered",
    // The indent of further list item lines.
    listItemIndent: "listItemIndent",
    // A marker, as in, `*`, `+`, `-`, `.`, or `)`.
    listItemMarker: "listItemMarker",
    // The thing that starts a list item, such as `1. `.
    // Includes `listItemValue` if ordered, `listItemMarker`, and
    // `listItemPrefixWhitespace` (unless followed by a line ending).
    listItemPrefix: "listItemPrefix",
    // The whitespace after a marker.
    listItemPrefixWhitespace: "listItemPrefixWhitespace",
    // The numerical value of an ordered item.
    listItemValue: "listItemValue",
    // Internal types used for subtokenizers, compiled away
    chunkDocument: "chunkDocument",
    chunkContent: "chunkContent",
    chunkFlow: "chunkFlow",
    chunkText: "chunkText",
    chunkString: "chunkString"
  }
);
function Xqe(t) {
  return {
    canContainEols: ["comment"],
    enter: {
      comment(e) {
        this.buffer();
      }
    },
    exit: {
      comment(e) {
        const n = this.resume();
        t.ast && (this.enter(
          {
            // @ts-expect-error: not typing this
            type: "comment",
            value: "",
            commentValue: n.slice(0, -2)
          },
          e
        ), this.exit(e));
      }
    }
  };
}
const cL = (t, e, n) => {
  return r;
  function r(p) {
    return t.enter("comment"), t.consume(p), i;
  }
  function i(p) {
    return p === us.exclamationMark ? (t.consume(p), o) : n(p);
  }
  function o(p) {
    return p === us.dash ? (t.consume(p), a) : n(p);
  }
  function a(p) {
    return p === us.dash ? (t.consume(p), s) : n(p);
  }
  function s(p) {
    return p === us.greaterThan ? n(p) : Dt(p) ? c(p) : (t.enter(Qc.data), p === us.dash ? (t.consume(p), u) : l(p));
  }
  function u(p) {
    return p === us.greaterThan ? n(p) : l(p);
  }
  function l(p) {
    return p === us.eof ? n(p) : p === us.dash ? (t.consume(p), f) : Dt(p) ? (t.exit(Qc.data), c(p)) : (t.consume(p), l);
  }
  function c(p) {
    return t.enter(Qc.lineEnding), t.consume(p), t.exit(Qc.lineEnding), Bn(t, d, Qc.linePrefix);
  }
  function d(p) {
    return Dt(p) ? c(p) : (t.enter(Qc.data), l(p));
  }
  function f(p) {
    return p === us.dash ? (t.consume(p), h) : l(p);
  }
  function h(p) {
    return p === us.greaterThan ? (t.exit(Qc.data), t.enter("commentEnd"), t.consume(p), t.exit("commentEnd"), t.exit("comment"), e(p)) : p === us.dash ? (t.consume(p), h) : l(p);
  }
}, Yqe = {
  flow: { 60: { tokenize: cL, concrete: !0 } },
  text: { 60: { tokenize: cL } }
}, Zqe = "_light_1tncs_1", Jqe = "_light-theme_1tncs_1", Kqe = "_dark_1tncs_1", qqe = "_dark-theme_1tncs_1", Qqe = "_bold_1tncs_10", eQe = "_italic_1tncs_14", tQe = "_underline_1tncs_18", nQe = "_strikethrough_1tncs_34", rQe = "_underlineStrikethrough_1tncs_38", iQe = "_subscript_1tncs_42", oQe = "_superscript_1tncs_47", aQe = "_code_1tncs_52", sQe = "_nestedListItem_1tncs_59", uQe = "_listitem_1tncs_69", lQe = "_listItemChecked_1tncs_73", cQe = "_listItemUnchecked_1tncs_74", dQe = "_admonitionDanger_1tncs_151", fQe = "_admonitionInfo_1tncs_152", hQe = "_admonitionNote_1tncs_153", pQe = "_admonitionTip_1tncs_154", gQe = "_admonitionCaution_1tncs_155", mQe = "_mdxExpression_1tncs_188", $i = {
  light: Zqe,
  lightTheme: Jqe,
  dark: Kqe,
  darkTheme: qqe,
  bold: Qqe,
  italic: eQe,
  underline: tQe,
  strikethrough: nQe,
  underlineStrikethrough: rQe,
  subscript: iQe,
  superscript: oQe,
  code: aQe,
  nestedListItem: sQe,
  listitem: uQe,
  listItemChecked: lQe,
  listItemUnchecked: cQe,
  admonitionDanger: dQe,
  admonitionInfo: fQe,
  admonitionNote: hQe,
  admonitionTip: pQe,
  admonitionCaution: gQe,
  mdxExpression: mQe
}, $w = {
  text: {
    bold: $i.bold,
    italic: $i.italic,
    underline: $i.underline,
    code: $i.code,
    strikethrough: $i.strikethrough,
    subscript: $i.subscript,
    superscript: $i.superscript,
    underlineStrikethrough: $i.underlineStrikethrough
  },
  list: {
    listitem: $i.listitem,
    listitemChecked: $i.listItemChecked,
    listitemUnchecked: $i.listItemUnchecked,
    nested: {
      listitem: $i.nestedListItem
    }
  },
  admonition: {
    danger: $i.admonitionDanger,
    info: $i.admonitionInfo,
    note: $i.admonitionNote,
    tip: $i.admonitionTip,
    caution: $i.admonitionCaution
  }
}, v2 = gl(), vl = Ht(null), hi = Ht(null), F4 = Ht(""), L4 = Ht(!0), vu = Ht(!1, (t) => {
  t.sub(t.pipe(vu, Zr(vl)), ([e, n]) => {
    n == null || n.setEditable(!e);
  });
}), V4 = Ht(""), dL = Ht(!1), mm = Ht(!1), Uq = Ht(0), b2 = Ht(null), B4 = Ei((t) => {
  t.link(
    t.pipe(
      b2,
      dv((e) => e !== null)
    ),
    B4
  );
}), Xq = Ei((t) => {
  t.sub(t.pipe(Xq, Zr(hi)), ([e, n]) => {
    n == null || n.dispatchCommand(Ku, e);
  });
}), fp = Ht(null, (t) => {
  t.sub(t.pipe(fp, Zr(hi)), ([e, n]) => {
    if (!e || !n)
      return;
    const r = e.anchor.getNode();
    let i = r.getKey() === "root" ? r : Hp(r, (s) => {
      const u = s.getParent();
      return u !== null && Oi(u);
    });
    i === null && (i = r.getTopLevelElementOrThrow());
    const o = i.getKey();
    if (n.getElementByKey(o) !== null) {
      const s = QK(i) ? i.getTag() : i.getType();
      t.pub(cQ, s);
    }
  });
}), Yq = Ht(""), Vd = Ht(""), Dw = Ei((t) => {
  t.link(Vd, Dw), t.link(Yq, Vd);
}), H4 = Ei((t) => {
  t.link(
    t.pipe(
      Dw,
      Zr(j4),
      dv(([, e]) => !e),
      Wh(([e]) => e)
    ),
    H4
  );
}), EO = Ht([]), SO = Ht([]), Zq = Ht([]), Jq = Ht([]), IO = Ht([]), Kq = Ht([]), W4 = Ht({}), qq = Ht(!1), _O = Ht([]), Qq = Ht([]), eQ = Ht([]), lf = Ht(null), vQe = Ht(null), cf = Ca(SO), bc = Ca(EO), y2 = Ca(Zq), x2 = Ca(Jq), df = Ca(IO), AO = Ca(Kq), j4 = Ht(!1), TO = Ei((t) => {
  t.sub(
    t.pipe(
      TO,
      Zr(Vd, vl, mm),
      dv(([e, n]) => e.trim() !== n.trim())
    ),
    ([e, , n, r]) => {
      t.pub(j4, !0), n == null || n.update(
        () => {
          hr().clear(), OO(t, hr(), e), r ? n.focus() : uo(null);
        },
        {
          onUpdate: () => {
            t.pub(j4, !1);
          }
        }
      );
    }
  );
}), tQ = Ei((t) => {
  t.sub(t.pipe(tQ, Zr(hi, mm)), ([e, n, r]) => {
    n == null || n.update(() => {
      const i = vt();
      if (i !== null) {
        const o = {
          children: [],
          append(a) {
            this.children.push(a);
          },
          getType() {
            return i.getNodes()[0].getType();
          }
        };
        OO(t, o, e), Bp(o.children);
      }
      r ? n.focus() : uo(null);
    });
  });
});
function nQ() {
  return BJ((t, [e, n]) => (t.forEach((r) => {
    if (!r)
      throw new Error("You have a subscription that does not return a teardown");
    r();
  }), n ? e.map((r) => r(n)) : []), []);
}
const rQ = Ht([], (t) => {
  t.pipe(t.combine(rQ, hi), nQ());
}), iQ = Ht([], (t) => {
  t.pipe(t.combine(iQ, vl), nQ());
}), bQe = Ht(null), z4 = Ei(), Bo = Ht((t) => {
  throw new Error(`No icon component for ${t}`);
});
function Ca(t, e) {
  return Ei((n, r) => {
    n.changeWith(t, r, (i, o) => {
      Array.isArray(o) || (o = [o]);
      let a = i;
      for (const s of o)
        i.includes(s) || (a = [...a, s]);
      return a;
    }), e == null || e(n, r);
  });
}
function oQ(t) {
  const e = vt();
  rt(e) && t.pubIn({
    [fp]: e,
    [Uq]: e.format
  });
}
const aQ = Ca(iQ, (t, e) => {
  t.pub(e, [
    (n) => n.registerCommand(
      fv,
      (r, i) => (t.pubIn({
        [hi]: i,
        [mm]: !0
      }), i._parentEditor === null && i.getEditorState().read(() => {
        t.pub(bQe, {
          rootNode: hr(),
          editorType: "lexical"
        });
      }), oQ(t), !1),
      vc
    ),
    // Export handler
    (n) => n.registerUpdateListener(({ dirtyElements: r, dirtyLeaves: i, editorState: o }) => {
      if (t.getValue(b2) !== null || r.size === 0 && i.size === 0)
        return;
      let s;
      o.read(() => {
        hr().getLastChild() instanceof yv && n.update(
          () => {
            hr().append(Sr());
          },
          { discrete: !0 }
        ), s = TJe({
          root: hr(),
          visitors: t.getValue(IO),
          jsxComponentDescriptors: t.getValue(_O),
          toMarkdownExtensions: t.getValue(Kq),
          toMarkdownOptions: t.getValue(W4),
          jsxIsAvailable: t.getValue(qq)
        });
      }), t.pub(Vd, s.trim());
    }),
    (n) => n.registerCommand(
      FT,
      () => (t.pub(mm, !0), !1),
      vc
    )
    /*
        // Fixes select all when frontmatter is present
        (rootEditor) => {
          return rootEditor.registerCommand<KeyboardEvent>(
            KEY_DOWN_COMMAND,
            (event) => {
              const { keyCode, ctrlKey, metaKey } = event
              if (keyCode === 65 && controlOrMeta(metaKey, ctrlKey)) {
                let shouldOverride = false
    
                rootEditor.getEditorState().read(() => {
                  shouldOverride = $isDecoratorNode($getRoot().getFirstChild()) || $isDecoratorNode($getRoot().getLastChild())
                })
    
                // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition
                if (shouldOverride) {
                  event.preventDefault()
                  event.stopImmediatePropagation()
                  rootEditor.update(() => {
                    const rootElement = rootEditor.getRootElement() as HTMLDivElement
                    window.getSelection()?.selectAllChildren(rootElement)
                    rootElement.focus({
                      preventScroll: true
                    })
                  })
                  return true
                }
              }
    
              return false
            },
            COMMAND_PRIORITY_CRITICAL
          )
        }*/
  ]);
}), C2 = Ca(rQ, (t, e) => {
  t.pub(e, [
    (n) => n.registerUpdateListener(({ editorState: r }) => {
      r.read(() => {
        oQ(t);
      });
    }),
    (n) => n.registerCommand(
      LT,
      (r) => {
        var i;
        const o = t.getValue(vl);
        return o && !((i = o.getRootElement()) != null && i.contains(r.relatedTarget)) && t.pubIn({
          [mm]: !1,
          [z4]: r
        }), !1;
      },
      vc
    )
  ]);
});
function OO(t, e, n) {
  try {
    Iqe({
      root: e,
      visitors: t.getValue(EO),
      mdastExtensions: t.getValue(Jq),
      markdown: n,
      syntaxExtensions: t.getValue(Zq),
      jsxComponentDescriptors: t.getValue(_O),
      directiveDescriptors: t.getValue(Qq),
      codeBlockEditorDescriptors: t.getValue(eQ)
    }), t.pub(b2, null);
  } catch (r) {
    if (r instanceof D4 || r instanceof M4)
      t.pubIn({
        [Vd]: n,
        [b2]: {
          error: r.message,
          source: n
        }
      });
    else
      throw r;
  }
}
const sQ = Ht([]), jp = Ca(sQ), uQ = Ht([]), yQe = Ca(uQ), lQ = Ht([]);
Ca(lQ);
const xQe = Ht([]), CQe = Ca(xQe), wQe = Ht(zK()), cQ = Ht("");
Ei();
const w2 = Ei((t) => {
  t.sub(t.pipe(w2, Zr(hi)), ([e, n]) => {
    n == null || n.update(() => {
      const r = vt();
      rt(r) && (PXe(r, e), setTimeout(() => {
        n.focus();
      }));
    });
  });
}), dQ = Ei((t) => {
  t.sub(t.pipe(dQ, Zr(hi)), ([e, n]) => {
    n == null || n.focus(
      () => {
        n.getEditorState().read(() => {
          const r = vt();
          rt(r) && (n.update(() => {
            const i = e();
            i.isInline() ? (Bp([i]), Oi(i.getParentOrThrow()) && gO(i, Sr).selectEnd()) : jK(i), setTimeout(() => {
              "select" in i && typeof i.select == "function" && i.select();
            });
          }), setTimeout(() => {
            n.dispatchCommand(v2, void 0);
          }));
        });
      },
      { defaultSelection: "rootEnd" }
    );
  });
}), G4 = Ht("rich-text", (t) => {
  function e() {
    return BJ(
      (n, r) => ({
        current: n.next,
        next: r
      }),
      { current: "rich-text", next: "rich-text" }
    );
  }
  t.sub(t.pipe(G4, e(), Zr(E2)), ([{ current: n }, r]) => {
    (n === "source" || n === "diff") && t.pub(TO, r);
  }), t.sub(
    t.pipe(
      G4,
      e(),
      dv((n) => n.current === "rich-text"),
      Zr(hi)
    ),
    ([, n]) => {
      n == null || n.dispatchCommand(v2, void 0);
    }
  );
}), E2 = Ht("", (t) => {
  t.link(Vd, E2), t.link(E2, Dw);
}), fQ = Ht([]), PO = Ca(fQ), hQ = Ht(() => {
  throw new Error("No translation function provided");
}), fL = Ht($w), EQe = pl({
  init(t, e) {
    const n = (e == null ? void 0 : e.initialMarkdown) ?? "";
    t.register(aQ), t.register(C2), t.register(Dw), t.pubIn({
      [Yq]: e != null && e.trim ? n.trim() : n,
      [Bo]: e == null ? void 0 : e.iconComponentFor,
      [bc]: [zqe, jqe, Gqe, Dqe, ...Bqe],
      [cf]: [sf, Lp, Cv],
      [df]: [
        kqe,
        Nqe,
        $qe,
        Pqe,
        Oqe
      ],
      [jp]: Uqe,
      [F4]: e == null ? void 0 : e.contentEditableClassName,
      [L4]: e == null ? void 0 : e.spellCheck,
      [W4]: e == null ? void 0 : e.toMarkdownOptions,
      [dL]: e == null ? void 0 : e.autoFocus,
      [V4]: e == null ? void 0 : e.placeholder,
      [vu]: e == null ? void 0 : e.readOnly,
      [hQ]: e == null ? void 0 : e.translation,
      [x2]: yYe(),
      [y2]: vYe(),
      [AO]: [MYe(), xYe()],
      [fL]: (e == null ? void 0 : e.lexicalTheme) ?? $w
    }), t.singletonSub(B4, e == null ? void 0 : e.onError), t.singletonSub(H4, e == null ? void 0 : e.onChange), t.singletonSub(z4, e == null ? void 0 : e.onBlur), e != null && e.suppressHtmlProcessing || t.pubIn({
      [x2]: [DYe(), Xqe({ ast: !1 })],
      [y2]: [oZe(), aZe(), Yqe],
      [bc]: Hqe
    });
  },
  postInit(t, e) {
    const n = FK({
      editable: (e == null ? void 0 : e.readOnly) !== !0,
      namespace: "MDXEditor",
      nodes: t.getValue(SO),
      onError: (r) => {
        throw r;
      },
      theme: t.getValue(fL)
    });
    n.update(() => {
      const r = (e == null ? void 0 : e.initialMarkdown.trim()) ?? "";
      OO(t, hr(), r);
      const i = e == null ? void 0 : e.autoFocus;
      if (i) {
        if (i === !0) {
          setTimeout(() => {
            n.focus(jh, { defaultSelection: "rootStart" });
          });
          return;
        }
        setTimeout(() => {
          n.focus(jh, {
            defaultSelection: i.defaultSelection ?? "rootStart"
          });
        });
      }
    }), t.pub(vl, n), t.pub(hi, n);
  },
  update(t, e) {
    t.pubIn({
      [F4]: e == null ? void 0 : e.contentEditableClassName,
      [L4]: e == null ? void 0 : e.spellCheck,
      [W4]: e == null ? void 0 : e.toMarkdownOptions,
      [dL]: e == null ? void 0 : e.autoFocus,
      [V4]: e == null ? void 0 : e.placeholder,
      [vu]: e == null ? void 0 : e.readOnly
    }), t.singletonSub(H4, e == null ? void 0 : e.onChange), t.singletonSub(z4, e == null ? void 0 : e.onBlur), t.singletonSub(B4, e == null ? void 0 : e.onError);
  }
});
function qi() {
  return ua(hQ);
}
function SQe() {
  return hr().getTextContent();
}
function IQe(t, e = !0) {
  if (t)
    return !1;
  let n = SQe();
  return e && (n = n.trim()), n === "";
}
function _Qe(t) {
  if (!IQe(t, !1))
    return !1;
  const e = hr().getChildren(), n = e.length;
  if (n > 1)
    return !1;
  for (let r = 0; r < n; r++) {
    const i = e[r];
    if (fr(i))
      return !1;
    if (We(i)) {
      if (!dp(i) || i.__indent !== 0)
        return !1;
      const o = i.getChildren(), a = o.length;
      for (let s = 0; s < a; s++) {
        const u = o[r];
        if (!pt(u))
          return !1;
      }
    }
  }
  return !0;
}
function pQ(t) {
  return () => _Qe(t);
}
function AQe(t) {
  return t && t.__esModule && Object.prototype.hasOwnProperty.call(t, "default") ? t.default : t;
}
AQe(function(t) {
  const e = new URLSearchParams();
  e.append("code", t);
  for (let n = 1; n < arguments.length; n++)
    e.append("v", arguments[n]);
  throw Error(`Minified Lexical error #${t}; visit https://lexical.dev/docs/error?${e} for the full message or use the non-minified dev environment for full errors and additional helpful warnings.`);
});
const gQ = typeof window < "u" && window.document !== void 0 && window.document.createElement !== void 0 ? Ua : Re;
function TQe({ editor: t, ariaActiveDescendant: e, ariaAutoComplete: n, ariaControls: r, ariaDescribedBy: i, ariaExpanded: o, ariaLabel: a, ariaLabelledBy: s, ariaMultiline: u, ariaOwns: l, ariaRequired: c, autoCapitalize: d, className: f, id: h, role: p = "textbox", spellCheck: v = !0, style: m, tabIndex: b, "data-testid": y, ...w }, S) {
  const [E, I] = Le(t.isEditable()), _ = et((P) => {
    P && P.ownerDocument && P.ownerDocument.defaultView ? t.setRootElement(P) : t.setRootElement(null);
  }, [t]), A = Rn(() => /* @__PURE__ */ function(...P) {
    return (N) => {
      P.forEach((k) => {
        typeof k == "function" ? k(N) : k != null && (k.current = N);
      });
    };
  }(S, _), [_, S]);
  return gQ(() => (I(t.isEditable()), t.registerEditableListener((P) => {
    I(P);
  })), [t]), Oe.jsx("div", { ...w, "aria-activedescendant": E ? e : void 0, "aria-autocomplete": E ? n : "none", "aria-controls": E ? r : void 0, "aria-describedby": i, "aria-expanded": E && p === "combobox" ? !!o : void 0, "aria-label": a, "aria-labelledby": s, "aria-multiline": u, "aria-owns": E ? l : void 0, "aria-readonly": !E || void 0, "aria-required": c, autoCapitalize: d, className: f, contentEditable: E, "data-testid": y, id: h, ref: A, role: E ? p : void 0, spellCheck: v, style: m, tabIndex: b });
}
const OQe = gt(TQe);
function hL(t) {
  return t.getEditorState().read(pQ(t.isComposing()));
}
const mQ = gt(PQe);
function PQe(t, e) {
  const { placeholder: n, ...r } = t, [i] = Vo();
  return Oe.jsxs(Oe.Fragment, { children: [Oe.jsx(OQe, { editor: i, ...r, ref: e }), n != null && Oe.jsx(NQe, { editor: i, content: n })] });
}
function NQe({ content: t, editor: e }) {
  const n = function(a) {
    const [s, u] = Le(() => hL(a));
    return gQ(() => {
      function l() {
        const c = hL(a);
        u(c);
      }
      return l(), xa(a.registerUpdateListener(() => {
        l();
      }), a.registerEditableListener(() => {
        l();
      }));
    }, [a]), s;
  }(e), [r, i] = Le(e.isEditable());
  if (Ua(() => (i(e.isEditable()), e.registerEditableListener((a) => {
    i(a);
  })), [e]), !n)
    return null;
  let o = null;
  return typeof t == "function" ? o = t(r) : t !== null && (o = t), o === null ? null : Oe.jsx("div", { "aria-hidden": !0, children: o });
}
function U4(t, e) {
  return U4 = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(n, r) {
    return n.__proto__ = r, n;
  }, U4(t, e);
}
var pL = { error: null }, kQe = function(t) {
  var e, n;
  function r() {
    for (var o, a = arguments.length, s = new Array(a), u = 0; u < a; u++)
      s[u] = arguments[u];
    return (o = t.call.apply(t, [this].concat(s)) || this).state = pL, o.resetErrorBoundary = function() {
      for (var l, c = arguments.length, d = new Array(c), f = 0; f < c; f++)
        d[f] = arguments[f];
      o.props.onReset == null || (l = o.props).onReset.apply(l, d), o.reset();
    }, o;
  }
  n = t, (e = r).prototype = Object.create(n.prototype), e.prototype.constructor = e, U4(e, n), r.getDerivedStateFromError = function(o) {
    return { error: o };
  };
  var i = r.prototype;
  return i.reset = function() {
    this.setState(pL);
  }, i.componentDidCatch = function(o, a) {
    var s, u;
    (s = (u = this.props).onError) == null || s.call(u, o, a);
  }, i.componentDidUpdate = function(o, a) {
    var s, u, l, c, d = this.state.error, f = this.props.resetKeys;
    d !== null && a.error !== null && ((l = o.resetKeys) === void 0 && (l = []), (c = f) === void 0 && (c = []), l.length !== c.length || l.some(function(h, p) {
      return !Object.is(h, c[p]);
    })) && ((s = (u = this.props).onResetKeysChange) == null || s.call(u, o.resetKeys, f), this.reset());
  }, i.render = function() {
    var o = this.state.error, a = this.props, s = a.fallbackRender, u = a.FallbackComponent, l = a.fallback;
    if (o !== null) {
      var c = { error: o, resetErrorBoundary: this.resetErrorBoundary };
      if (x.isValidElement(l))
        return l;
      if (typeof s == "function")
        return s(c);
      if (u)
        return x.createElement(u, c);
      throw new Error("react-error-boundary requires either a fallback, fallbackRender, or FallbackComponent prop");
    }
    return this.props.children;
  }, r;
}(x.Component);
function vQ({ children: t, onError: e }) {
  return Oe.jsx(kQe, { fallback: Oe.jsx("div", { style: { border: "1px solid #f00", color: "#f00", padding: "8px" }, children: "An error was thrown." }), onError: e, children: t });
}
const RQe = typeof window < "u" && window.document !== void 0 && window.document.createElement !== void 0 ? Ua : Re;
function $Qe(t) {
  return { initialValueFn: () => t.isEditable(), subscribe: (e) => t.registerEditableListener(e) };
}
function DQe() {
  return function(t) {
    const [e] = Vo(), n = Rn(() => t(e), [e, t]), r = Ee(n.initialValueFn()), [i, o] = Le(r.current);
    return RQe(() => {
      const { initialValueFn: a, subscribe: s } = n, u = a();
      return r.current !== u && (r.current = u, o(u)), s((l) => {
        r.current = l, o(l);
      });
    }, [n, t]), i;
  }($Qe);
}
function MQe(t) {
  const e = window.location.origin, n = (r) => {
    if (r.origin !== e)
      return;
    const i = t.getRootElement();
    if (document.activeElement !== i)
      return;
    const o = r.data;
    if (typeof o == "string") {
      let a;
      try {
        a = JSON.parse(o);
      } catch {
        return;
      }
      if (a && a.protocol === "nuanria_messaging" && a.type === "request") {
        const s = a.payload;
        if (s && s.functionId === "makeChanges") {
          const u = s.args;
          if (u) {
            const [l, c, d, f, h, p] = u;
            t.update(() => {
              const v = vt();
              if (rt(v)) {
                const m = v.anchor;
                let b = m.getNode(), y = 0, w = 0;
                if (pt(b) && l >= 0 && c >= 0 && (y = l, w = l + c, v.setTextNodeRange(b, y, b, w)), y === w && d === "" || (v.insertRawText(d), b = m.getNode()), pt(b)) {
                  y = f, w = f + h;
                  const S = b.getTextContentSize();
                  y = y > S ? S : y, w = w > S ? S : w, v.setTextNodeRange(b, y, b, w);
                }
                r.stopImmediatePropagation();
              }
            });
          }
        }
      }
    }
  };
  return window.addEventListener("message", n, !0), () => {
    window.removeEventListener("message", n, !0);
  };
}
const X4 = typeof window < "u" && window.document !== void 0 && window.document.createElement !== void 0 ? Ua : Re;
function gL(t) {
  return t.getEditorState().read(pQ(t.isComposing()));
}
function bQ({ contentEditable: t, placeholder: e = null, ErrorBoundary: n }) {
  const [r] = Vo(), i = function(o, a) {
    const [s, u] = Le(() => o.getDecorators());
    return X4(() => o.registerDecoratorListener((l) => {
      sc(() => {
        u(l);
      });
    }), [o]), Re(() => {
      u(o.getDecorators());
    }, [o]), Rn(() => {
      const l = [], c = Object.keys(s);
      for (let d = 0; d < c.length; d++) {
        const f = c[d], h = Oe.jsx(a, { onError: (v) => o._onError(v), children: Oe.jsx(xde, { fallback: null, children: s[f] }) }), p = o.getElementByKey(f);
        p !== null && l.push(km(h, p, f));
      }
      return l;
    }, [a, s, o]);
  }(r, n);
  return function(o) {
    X4(() => xa(fYe(o), MQe(o)), [o]);
  }(r), Oe.jsxs(Oe.Fragment, { children: [t, Oe.jsx(FQe, { content: e }), i] });
}
function FQe({ content: t }) {
  const [e] = Vo(), n = function(i) {
    const [o, a] = Le(() => gL(i));
    return X4(() => {
      function s() {
        const u = gL(i);
        a(u);
      }
      return s(), xa(i.registerUpdateListener(() => {
        s();
      }), i.registerEditableListener(() => {
        s();
      }));
    }, [i]), o;
  }(e), r = DQe();
  return n ? typeof t == "function" ? t(r) : t : null;
}
const LQe = "_editorRoot_uazmk_53", VQe = "_editorWrapper_uazmk_154", BQe = "_nestedListItem_uazmk_156", HQe = "_toolbarRoot_uazmk_160", WQe = "_readOnlyToolbarRoot_uazmk_187", jQe = "_toolbarModeSwitch_uazmk_196", zQe = "_toolbarToggleItem_uazmk_206", GQe = "_toolbarGroupOfGroups_uazmk_217", UQe = "_toolbarToggleSingleGroup_uazmk_222", XQe = "_toolbarButton_uazmk_237", YQe = "_activeToolbarButton_uazmk_274", ZQe = "_toolbarNodeKindSelectContainer_uazmk_284", JQe = "_toolbarButtonDropdownContainer_uazmk_285", KQe = "_toolbarCodeBlockLanguageSelectContent_uazmk_286", qQe = "_selectContainer_uazmk_287", QQe = "_selectItem_uazmk_300", eet = "_toolbarNodeKindSelectTrigger_uazmk_305", tet = "_toolbarButtonSelectTrigger_uazmk_306", net = "_selectTrigger_uazmk_307", ret = "_toolbarCodeBlockLanguageSelectTrigger_uazmk_342", iet = "_toolbarNodeKindSelectItem_uazmk_347", oet = "_toolbarNodeKindSelectDropdownArrow_uazmk_372", aet = "_selectDropdownArrow_uazmk_373", set = "_contentEditable_uazmk_379", uet = "_codeMirrorWrapper_uazmk_391", cet = "_sandPackWrapper_uazmk_400", det = "_codeMirrorToolbar_uazmk_408", fet = "_frontmatterWrapper_uazmk_412", het = "_frontmatterToggleButton_uazmk_422", pet = "_propertyPanelTitle_uazmk_430", get = "_propertyEditorTable_uazmk_438", met = "_iconButton_uazmk_456", vet = "_readOnlyColumnCell_uazmk_461", bet = "_propertyEditorLabelCell_uazmk_466", yet = "_buttonsFooter_uazmk_474", xet = "_propertyEditorInput_uazmk_480", Cet = "_primaryButton_uazmk_506", wet = "_secondaryButton_uazmk_507", Eet = "_smallButton_uazmk_522", Iet = "_dialogForm_uazmk_534", _et = "_linkDialogEditForm_uazmk_540", Aet = "_linkDialogInputContainer_uazmk_548", Tet = "_linkDialogInputWrapper_uazmk_554", Oet = "_linkDialogInput_uazmk_548", Pet = "_dialogInput_uazmk_575", Net = "_linkDialogAnchor_uazmk_586", ket = "_linkDialogPopoverContent_uazmk_600", Ret = "_tableColumnEditorPopoverContent_uazmk_601", $et = "_dialogContent_uazmk_602", Det = "_largeDialogContent_uazmk_614", Met = "_dialogTitle_uazmk_624", Fet = "_dialogCloseButton_uazmk_630", Let = "_popoverContent_uazmk_637", Vet = "_popoverArrow_uazmk_649", Bet = "_linkDialogPreviewAnchor_uazmk_653", Het = "_tooltipTrigger_uazmk_676", Wet = "_tooltipContent_uazmk_680", jet = "_actionButton_uazmk_694", zet = "_primaryActionButton_uazmk_701", Get = "_tableEditor_uazmk_713", Uet = "_toolCell_uazmk_724", Xet = "_tableColumnEditorTrigger_uazmk_743", Yet = "_tableRowEditorTrigger_uazmk_744", Zet = "_addRowButton_uazmk_745", Jet = "_addColumnButton_uazmk_746", Ket = "_tableColumnEditorToolbar_uazmk_789", qet = "_toggleGroupRoot_uazmk_803", Qet = "_tableToolsColumn_uazmk_821", ett = "_leftAlignedCell_uazmk_830", ttt = "_rightAlignedCell_uazmk_834", ntt = "_centeredCell_uazmk_838", rtt = "_dialogOverlay_uazmk_871", itt = "_overlayShow_uazmk_1", ott = "_contentShow_uazmk_1", att = "_focusedImage_uazmk_918", stt = "_imageWrapper_uazmk_922", utt = "_editImageToolbar_uazmk_935", ltt = "_editImageButton_uazmk_939", ctt = "_inlineEditor_uazmk_945", dtt = "_blockEditor_uazmk_954", ftt = "_nestedEditor_uazmk_963", htt = "_genericComponentName_uazmk_982", ptt = "_diffSourceToggle_uazmk_988", gtt = "_selectWithLabel_uazmk_1002", mtt = "_toolbarTitleMode_uazmk_1017", vtt = "_imageControlWrapperResizing_uazmk_1023", btt = "_imageResizer_uazmk_1027", ytt = "_imageResizerN_uazmk_1036", xtt = "_imageResizerNe_uazmk_1042", Ctt = "_imageResizerE_uazmk_1048", wtt = "_imageResizerSe_uazmk_1054", Ett = "_imageResizerS_uazmk_1054", Stt = "_imageResizerSw_uazmk_1066", Itt = "_imageResizerW_uazmk_1072", _tt = "_imageResizerNw_uazmk_1078", Att = "_placeholder_uazmk_1084", Ttt = "_rootContentEditableWrapper_uazmk_1097", Ott = "_downshiftContainer_uazmk_1103", Ptt = "_downshiftInputWrapper_uazmk_1109", Ntt = "_downshiftInput_uazmk_1109", ktt = "_downshiftAutocompleteContainer_uazmk_1140", Rtt = "_textInput_uazmk_1186", $tt = "_multiFieldForm_uazmk_1194", Dtt = "_formField_uazmk_1200", Mtt = "_markdownParseError_uazmk_1211", Ftt = "_popupContainer_uazmk_1220", Ltt = "_inputSizer_uazmk_1225", it = {
  editorRoot: LQe,
  editorWrapper: VQe,
  nestedListItem: BQe,
  toolbarRoot: HQe,
  readOnlyToolbarRoot: WQe,
  toolbarModeSwitch: jQe,
  toolbarToggleItem: zQe,
  toolbarGroupOfGroups: GQe,
  toolbarToggleSingleGroup: UQe,
  toolbarButton: XQe,
  activeToolbarButton: YQe,
  toolbarNodeKindSelectContainer: ZQe,
  toolbarButtonDropdownContainer: JQe,
  toolbarCodeBlockLanguageSelectContent: KQe,
  selectContainer: qQe,
  selectItem: QQe,
  toolbarNodeKindSelectTrigger: eet,
  toolbarButtonSelectTrigger: tet,
  selectTrigger: net,
  toolbarCodeBlockLanguageSelectTrigger: ret,
  toolbarNodeKindSelectItem: iet,
  toolbarNodeKindSelectDropdownArrow: oet,
  selectDropdownArrow: aet,
  contentEditable: set,
  codeMirrorWrapper: uet,
  sandPackWrapper: cet,
  codeMirrorToolbar: det,
  frontmatterWrapper: fet,
  frontmatterToggleButton: het,
  propertyPanelTitle: pet,
  propertyEditorTable: get,
  iconButton: met,
  readOnlyColumnCell: vet,
  propertyEditorLabelCell: bet,
  buttonsFooter: yet,
  propertyEditorInput: xet,
  primaryButton: Cet,
  secondaryButton: wet,
  smallButton: Eet,
  dialogForm: Iet,
  linkDialogEditForm: _et,
  linkDialogInputContainer: Aet,
  linkDialogInputWrapper: Tet,
  linkDialogInput: Oet,
  dialogInput: Pet,
  linkDialogAnchor: Net,
  linkDialogPopoverContent: ket,
  tableColumnEditorPopoverContent: Ret,
  dialogContent: $et,
  largeDialogContent: Det,
  dialogTitle: Met,
  dialogCloseButton: Fet,
  popoverContent: Let,
  popoverArrow: Vet,
  linkDialogPreviewAnchor: Bet,
  tooltipTrigger: Het,
  tooltipContent: Wet,
  actionButton: jet,
  primaryActionButton: zet,
  tableEditor: Get,
  toolCell: Uet,
  tableColumnEditorTrigger: Xet,
  tableRowEditorTrigger: Yet,
  addRowButton: Zet,
  addColumnButton: Jet,
  tableColumnEditorToolbar: Ket,
  toggleGroupRoot: qet,
  tableToolsColumn: Qet,
  leftAlignedCell: ett,
  rightAlignedCell: ttt,
  centeredCell: ntt,
  dialogOverlay: rtt,
  overlayShow: itt,
  contentShow: ott,
  focusedImage: att,
  imageWrapper: stt,
  editImageToolbar: utt,
  editImageButton: ltt,
  inlineEditor: ctt,
  blockEditor: dtt,
  nestedEditor: ftt,
  genericComponentName: htt,
  diffSourceToggle: ptt,
  selectWithLabel: gtt,
  toolbarTitleMode: mtt,
  imageControlWrapperResizing: vtt,
  imageResizer: btt,
  imageResizerN: ytt,
  imageResizerNe: xtt,
  imageResizerE: Ctt,
  imageResizerSe: wtt,
  imageResizerS: Ett,
  imageResizerSw: Stt,
  imageResizerW: Itt,
  imageResizerNw: _tt,
  placeholder: Att,
  rootContentEditableWrapper: Ttt,
  downshiftContainer: Ott,
  downshiftInputWrapper: Ptt,
  downshiftInput: Ntt,
  downshiftAutocompleteContainer: ktt,
  textInput: Rtt,
  multiFieldForm: $tt,
  formField: Dtt,
  markdownParseError: Mtt,
  popupContainer: Ftt,
  inputSizer: Ltt
}, Vtt = {
  undo: /* @__PURE__ */ O.createElement("svg", { width: "24", height: "24", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, /* @__PURE__ */ O.createElement(
    "path",
    {
      d: "M7.202 18.5V17H14.3788C15.4224 17 16.3205 16.6554 17.073 15.9663C17.8257 15.2773 18.202 14.4263 18.202 13.4135C18.202 12.4007 17.8257 11.5512 17.073 10.8652C16.3205 10.1794 15.4224 9.8365 14.3788 9.8365H7.35775L10.1402 12.6193L9.0865 13.673L4.5 9.0865L9.0865 4.5L10.1402 5.55375L7.35775 8.3365H14.3788C15.8416 8.3365 17.0945 8.82467 18.1375 9.801C19.1805 10.7773 19.702 11.9815 19.702 13.4135C19.702 14.8455 19.1805 16.0513 18.1375 17.0308C17.0945 18.0103 15.8416 18.5 14.3788 18.5H7.202Z",
      fill: "currentColor"
    }
  )),
  redo: /* @__PURE__ */ O.createElement("svg", { width: "24", height: "24", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, /* @__PURE__ */ O.createElement(
    "path",
    {
      d: "M9.6211 18.5C8.15827 18.5 6.90535 18.0103 5.86235 17.0308C4.81935 16.0513 4.29785 14.8455 4.29785 13.4135C4.29785 11.9815 4.81935 10.7773 5.86235 9.801C6.90535 8.82467 8.15827 8.3365 9.6211 8.3365H16.6421L13.8596 5.55375L14.9134 4.5L19.4999 9.0865L14.9134 13.673L13.8596 12.6193L16.6421 9.8365H9.6211C8.57744 9.8365 7.67935 10.1794 6.92685 10.8652C6.17418 11.5512 5.79785 12.4007 5.79785 13.4135C5.79785 14.4263 6.17418 15.2773 6.92685 15.9663C7.67935 16.6554 8.57744 17 9.6211 17H16.7979V18.5H9.6211Z",
      fill: "currentColor"
    }
  )),
  format_bold: /* @__PURE__ */ O.createElement("svg", { width: "24", height: "24", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, /* @__PURE__ */ O.createElement(
    "path",
    {
      d: "M7.33838 18.625V5.375H12.1999C13.219 5.375 14.1405 5.69233 14.9644 6.327C15.788 6.9615 16.1999 7.816 16.1999 8.8905C16.1999 9.63783 16.0194 10.2471 15.6584 10.7182C15.2975 11.1894 14.9088 11.5314 14.4921 11.7442C15.005 11.9211 15.4947 12.2708 15.9614 12.7933C16.428 13.3158 16.6614 14.0193 16.6614 14.9038C16.6614 16.1819 16.1902 17.1217 15.2479 17.723C14.3055 18.3243 13.3562 18.625 12.3999 18.625H7.33838ZM9.48838 16.6328H12.3191C13.1063 16.6328 13.6627 16.4142 13.9884 15.977C14.314 15.5398 14.4769 15.1206 14.4769 14.7192C14.4769 14.3179 14.314 13.8987 13.9884 13.4615C13.6627 13.0243 13.0909 12.8058 12.2729 12.8058H9.48838V16.6328ZM9.48838 10.875H12.0826C12.6903 10.875 13.172 10.7013 13.5279 10.3538C13.8835 10.0064 14.0614 9.59042 14.0614 9.10575C14.0614 8.59042 13.8733 8.16925 13.4971 7.84225C13.1208 7.51542 12.6595 7.352 12.1134 7.352H9.48838V10.875Z",
      fill: "currentColor"
    }
  )),
  format_italic: /* @__PURE__ */ O.createElement("svg", { width: "24", height: "24", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, /* @__PURE__ */ O.createElement(
    "path",
    {
      d: "M5.39404 18.625V16.8173H9.21129L12.4518 7.18275H8.63454V5.375H17.7883V7.18275H14.2785L11.0383 16.8173H14.5478V18.625H5.39404Z",
      fill: "currentColor"
    }
  )),
  format_underlined: /* @__PURE__ */ O.createElement("svg", { width: "24", height: "24", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, /* @__PURE__ */ O.createElement(
    "path",
    {
      d: "M5.34619 22.125V20.625H18.6537V22.125H5.34619ZM11.9999 18.5287C10.4448 18.5287 9.23102 18.0566 8.35869 17.1125C7.48619 16.1683 7.04994 14.9032 7.04994 13.3172V5.41345H8.90369V13.4095C8.90369 14.4198 9.17228 15.2295 9.70944 15.8385C10.2466 16.4475 11.0101 16.752 11.9999 16.752C12.9898 16.752 13.7533 16.4475 14.2904 15.8385C14.8276 15.2295 15.0962 14.4198 15.0962 13.4095V5.41345H16.9499V13.3172C16.9499 14.9032 16.5137 16.1683 15.6412 17.1125C14.7689 18.0566 13.5551 18.5287 11.9999 18.5287Z",
      fill: "currentColor"
    }
  )),
  code: /* @__PURE__ */ O.createElement("svg", { width: "24", height: "24", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, /* @__PURE__ */ O.createElement(
    "path",
    {
      d: "M7.99994 17.6537L2.34619 11.9999L7.99994 6.34619L9.06919 7.41544L4.46919 12.0154L9.05369 16.5999L7.99994 17.6537ZM15.9999 17.6537L14.9307 16.5844L19.5307 11.9844L14.9462 7.39994L15.9999 6.34619L21.6537 11.9999L15.9999 17.6537Z",
      fill: "currentColor"
    }
  )),
  strikeThrough: /* @__PURE__ */ O.createElement("svg", { width: "24", height: "24", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, /* @__PURE__ */ O.createElement(
    "path",
    {
      d: "M12.15 19.6923C10.9732 19.6923 9.9315 19.359 9.025 18.6923C8.11867 18.0256 7.45525 17.1128 7.03475 15.9538L8.6385 15.2635C8.91667 16.0444 9.3545 16.6867 9.952 17.1905C10.5493 17.6944 11.2923 17.9463 12.1808 17.9463C12.9578 17.9463 13.6744 17.7508 14.3307 17.3598C14.9872 16.9686 15.3155 16.3487 15.3155 15.5C15.3155 15.123 15.2555 14.7968 15.1355 14.5213C15.0157 14.2456 14.8462 13.9885 14.627 13.75H16.677C16.7987 13.9705 16.8932 14.2256 16.9605 14.5153C17.0278 14.8051 17.0615 15.1334 17.0615 15.5C17.0615 16.8372 16.5747 17.8702 15.601 18.599C14.6272 19.3279 13.4768 19.6923 12.15 19.6923ZM2.25 11.75V10.25H21.75V11.75H2.25ZM12.05 4.19629C13.0475 4.19629 13.9123 4.42704 14.6443 4.88854C15.3763 5.35004 15.9673 6.05896 16.4173 7.01529L14.823 7.73079C14.6218 7.26029 14.2978 6.84462 13.851 6.48379C13.4042 6.12279 12.8141 5.94229 12.0808 5.94229C11.2244 5.94229 10.5392 6.16221 10.025 6.60204C9.51083 7.04171 9.264 7.59104 9.2845 8.25004H7.5385C7.50133 7.16421 7.89783 6.21712 8.728 5.40879C9.558 4.60046 10.6653 4.19629 12.05 4.19629Z",
      fill: "currentColor"
    }
  )),
  superscript: /* @__PURE__ */ O.createElement("svg", { width: "24", height: "24", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, /* @__PURE__ */ O.createElement(
    "path",
    {
      d: "M16.6924 8V6.2115C16.6924 5.95383 16.7786 5.73875 16.9511 5.56625C17.1235 5.39392 17.3385 5.30775 17.5961 5.30775H19.5001V4.38475H16.6924V3.5H19.4809C19.7385 3.5 19.9536 3.58625 20.1261 3.75875C20.2985 3.93108 20.3846 4.14617 20.3846 4.404V5.2885C20.3846 5.54617 20.2985 5.76125 20.1261 5.93375C19.9536 6.10608 19.7385 6.19225 19.4809 6.19225H17.5771V7.1155H20.3846V8H16.6924ZM4.44238 18.5L8.84638 11.6287L4.77713 5.30775H6.74438L9.95963 10.404H10.0214L13.2501 5.30775H15.2329L11.1194 11.6287L15.5579 18.5H13.5751L10.0214 12.9308H9.95963L6.42513 18.5H4.44238Z",
      fill: "currentColor"
    }
  )),
  subscript: /* @__PURE__ */ O.createElement("svg", { width: "24", height: "24", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, /* @__PURE__ */ O.createElement(
    "path",
    {
      d: "M16.6924 20.5V18.7115C16.6924 18.4538 16.7786 18.2387 16.9511 18.0662C17.1235 17.8939 17.3385 17.8077 17.5961 17.8077H19.5001V16.8845H16.6924V16H19.4809C19.7385 16 19.9536 16.0863 20.1261 16.2587C20.2985 16.4311 20.3846 16.6461 20.3846 16.9038V17.7885C20.3846 18.0462 20.2985 18.2612 20.1261 18.4337C19.9536 18.6061 19.7385 18.6923 19.4809 18.6923H17.5771V19.6152H20.3846V20.5H16.6924ZM4.44238 18.6923L8.84638 11.8212L4.77713 5.5H6.74438L9.95963 10.5962H10.0214L13.2501 5.5H15.2329L11.1194 11.8212L15.5579 18.6923H13.5751L10.0214 13.123H9.95963L6.42513 18.6923H4.44238Z",
      fill: "currentColor"
    }
  )),
  format_list_bulleted: /* @__PURE__ */ O.createElement("svg", { width: "24", height: "24", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, /* @__PURE__ */ O.createElement(
    "path",
    {
      d: "M9.30775 18.75V17.25H20.5V18.75H9.30775ZM9.30775 12.75V11.25H20.5V12.75H9.30775ZM9.30775 6.75005V5.25005H20.5V6.75005H9.30775ZM5.1635 19.6635C4.706 19.6635 4.31442 19.5006 3.98875 19.1748C3.66292 18.8491 3.5 18.4575 3.5 18C3.5 17.5425 3.66292 17.151 3.98875 16.8253C4.31442 16.4995 4.706 16.3365 5.1635 16.3365C5.621 16.3365 6.01258 16.4995 6.33825 16.8253C6.66408 17.151 6.827 17.5425 6.827 18C6.827 18.4575 6.66408 18.8491 6.33825 19.1748C6.01258 19.5006 5.621 19.6635 5.1635 19.6635ZM5.1635 13.6635C4.706 13.6635 4.31442 13.5006 3.98875 13.1748C3.66292 12.8491 3.5 12.4575 3.5 12C3.5 11.5425 3.66292 11.151 3.98875 10.8253C4.31442 10.4995 4.706 10.3365 5.1635 10.3365C5.621 10.3365 6.01258 10.4995 6.33825 10.8253C6.66408 11.151 6.827 11.5425 6.827 12C6.827 12.4575 6.66408 12.8491 6.33825 13.1748C6.01258 13.5006 5.621 13.6635 5.1635 13.6635ZM5.1635 7.66355C4.706 7.66355 4.31442 7.50063 3.98875 7.1748C3.66292 6.84913 3.5 6.45755 3.5 6.00005C3.5 5.54255 3.66292 5.15096 3.98875 4.8253C4.31442 4.49946 4.706 4.33655 5.1635 4.33655C5.621 4.33655 6.01258 4.49946 6.33825 4.8253C6.66408 5.15096 6.827 5.54255 6.827 6.00005C6.827 6.45755 6.66408 6.84913 6.33825 7.1748C6.01258 7.50063 5.621 7.66355 5.1635 7.66355Z",
      fill: "currentColor"
    }
  )),
  format_list_numbered: /* @__PURE__ */ O.createElement("svg", { width: "24", height: "24", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, /* @__PURE__ */ O.createElement(
    "path",
    {
      d: "M3.5 21.5V20.3078H6V19.25H4.5V18.0577H6V17H3.5V15.8077H6.34625C6.58592 15.8077 6.78683 15.8888 6.949 16.051C7.11117 16.2132 7.19225 16.4141 7.19225 16.6538V17.8462C7.19225 18.0859 7.11117 18.2868 6.949 18.449C6.78683 18.6112 6.58592 18.6923 6.34625 18.6923C6.58592 18.6923 6.78683 18.7733 6.949 18.9355C7.11117 19.0977 7.19225 19.2987 7.19225 19.5385V20.6538C7.19225 20.8936 7.11117 21.0946 6.949 21.2568C6.78683 21.4189 6.58592 21.5 6.34625 21.5H3.5ZM3.5 14.8463V12.25C3.5 12.0103 3.58108 11.8093 3.74325 11.647C3.90542 11.4848 4.10642 11.4038 4.34625 11.4038H6V10.3462H3.5V9.15375H6.34625C6.58592 9.15375 6.78683 9.23483 6.949 9.397C7.11117 9.55933 7.19225 9.76033 7.19225 10V11.75C7.19225 11.9897 7.11117 12.1907 6.949 12.353C6.78683 12.5152 6.58592 12.5963 6.34625 12.5963H4.69225V13.6538H7.19225V14.8463H3.5ZM5 8.19225V3.69225H3.5V2.5H6.19225V8.19225H5ZM9.30775 18.75V17.25H20.5V18.75H9.30775ZM9.30775 12.75V11.25H20.5V12.75H9.30775ZM9.30775 6.75V5.25H20.5V6.75H9.30775Z",
      fill: "currentColor"
    }
  )),
  format_list_checked: /* @__PURE__ */ O.createElement("svg", { width: "24", height: "24", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, /* @__PURE__ */ O.createElement(
    "path",
    {
      d: "M5.69425 18.452L2.5 15.2578L3.54425 14.2135L5.66925 16.3385L9.91925 12.0885L10.9635 13.1578L5.69425 18.452ZM5.69425 10.8365L2.5 7.64227L3.54425 6.59802L5.66925 8.72302L9.91925 4.47302L10.9635 5.54227L5.69425 10.8365ZM13.0095 16.5578V15.0578H21.5095V16.5578H13.0095ZM13.0095 8.94227V7.44227H21.5095V8.94227H13.0095Z",
      fill: "currentColor"
    }
  )),
  link: /* @__PURE__ */ O.createElement("svg", { width: "24", height: "24", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, /* @__PURE__ */ O.createElement(
    "path",
    {
      d: "M10.8077 16.5385H7.0385C5.78283 16.5385 4.7125 16.096 3.8275 15.211C2.9425 14.3262 2.5 13.256 2.5 12.0005C2.5 10.745 2.9425 9.67471 3.8275 8.78955C4.7125 7.90421 5.78283 7.46155 7.0385 7.46155H10.8077V8.96155H7.0385C6.19867 8.96155 5.48233 9.25805 4.8895 9.85105C4.2965 10.444 4 11.1604 4 12C4 12.8397 4.2965 13.556 4.8895 14.149C5.48233 14.742 6.19867 15.0385 7.0385 15.0385H10.8077V16.5385ZM8.25 12.75V11.25H15.75V12.75H8.25ZM13.1923 16.5385V15.0385H16.9615C17.8013 15.0385 18.5177 14.742 19.1105 14.149C19.7035 13.556 20 12.8397 20 12C20 11.1604 19.7035 10.444 19.1105 9.85105C18.5177 9.25805 17.8013 8.96155 16.9615 8.96155H13.1923V7.46155H16.9615C18.2172 7.46155 19.2875 7.90405 20.1725 8.78905C21.0575 9.67388 21.5 10.744 21.5 11.9995C21.5 13.255 21.0575 14.3254 20.1725 15.2105C19.2875 16.0959 18.2172 16.5385 16.9615 16.5385H13.1923Z",
      fill: "currentColor"
    }
  )),
  add_photo: /* @__PURE__ */ O.createElement("svg", { width: "24", height: "24", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, /* @__PURE__ */ O.createElement(
    "path",
    {
      d: "M5.11537 20.5C4.6182 20.5 4.19262 20.323 3.83862 19.969C3.48462 19.615 3.30762 19.1894 3.30762 18.6922V5.30773C3.30762 4.81056 3.48462 4.38498 3.83862 4.03098C4.19262 3.67698 4.6182 3.49998 5.11537 3.49998H13.8076V4.99998H5.11537C5.02553 4.99998 4.95178 5.02881 4.89412 5.08648C4.83645 5.14415 4.80762 5.2179 4.80762 5.30773V18.6922C4.80762 18.7821 4.83645 18.8558 4.89412 18.9135C4.95178 18.9711 5.02553 19 5.11537 19H18.4999C18.5895 19 18.6633 18.9711 18.7211 18.9135C18.7788 18.8558 18.8076 18.7821 18.8076 18.6922V9.99998H20.3076V18.6922C20.3076 19.1894 20.1306 19.615 19.7766 19.969C19.4226 20.323 18.997 20.5 18.4999 20.5H5.11537ZM17.1921 8.61523V6.61523H15.1921V5.11548H17.1921V3.11548H18.6921V5.11548H20.6921V6.61523H18.6921V8.61523H17.1921ZM6.55762 16.75H17.1344L13.8459 12.3655L11.0384 16.0192L9.03837 13.4615L6.55762 16.75Z",
      fill: "currentColor"
    }
  )),
  table: /* @__PURE__ */ O.createElement("svg", { width: "24", height: "24", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, /* @__PURE__ */ O.createElement(
    "path",
    {
      d: "M3.5 18.6923V5.30775C3.5 4.81058 3.677 4.385 4.031 4.031C4.385 3.677 4.81058 3.5 5.30775 3.5H18.6923C19.1894 3.5 19.615 3.677 19.969 4.031C20.323 4.385 20.5 4.81058 20.5 5.30775V18.6923C20.5 19.1894 20.323 19.615 19.969 19.969C19.615 20.323 19.1894 20.5 18.6923 20.5H5.30775C4.81058 20.5 4.385 20.323 4.031 19.969C3.677 19.615 3.5 19.1894 3.5 18.6923ZM5 9.077H19V5.30775C19 5.21792 18.9712 5.14417 18.9135 5.0865C18.8558 5.02883 18.7821 5 18.6923 5H5.30775C5.21792 5 5.14417 5.02883 5.0865 5.0865C5.02883 5.14417 5 5.21792 5 5.30775V9.077ZM10.1615 14.0385H13.8385V10.577H10.1615V14.0385ZM10.1615 19H13.8385V15.5385H10.1615V19ZM5 14.0385H8.6615V10.577H5V14.0385ZM15.3385 14.0385H19V10.577H15.3385V14.0385ZM5.30775 19H8.6615V15.5385H5V18.6923C5 18.7821 5.02883 18.8558 5.0865 18.9135C5.14417 18.9712 5.21792 19 5.30775 19ZM15.3385 19H18.6923C18.7821 19 18.8558 18.9712 18.9135 18.9135C18.9712 18.8558 19 18.7821 19 18.6923V15.5385H15.3385V19Z",
      fill: "currentColor"
    }
  )),
  horizontal_rule: /* @__PURE__ */ O.createElement("svg", { width: "24", height: "24", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, /* @__PURE__ */ O.createElement("path", { d: "M4.5 12.75V11.25H19.5V12.75H4.5Z", fill: "currentColor" })),
  frontmatter: /* @__PURE__ */ O.createElement("svg", { width: "24", height: "24", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, /* @__PURE__ */ O.createElement("path", { d: "M4.5 8.75V7.25H8.5V8.75H4.5Z", fill: "currentColor" }), /* @__PURE__ */ O.createElement("path", { d: "M4.5 14.75V13.25H8.5V14.75H4.5Z", fill: "currentColor" }), /* @__PURE__ */ O.createElement("path", { d: "M9.5 8.75V7.25H13.5V8.75H9.5Z", fill: "currentColor" }), /* @__PURE__ */ O.createElement("path", { d: "M9.5 14.75V13.25H13.5V14.75H9.5Z", fill: "currentColor" }), /* @__PURE__ */ O.createElement("path", { d: "M14.5 8.75V7.25H18.5V8.75H14.5Z", fill: "currentColor" }), /* @__PURE__ */ O.createElement("path", { d: "M14.5 14.75V13.25H18.5V14.75H14.5Z", fill: "currentColor" })),
  frame_source: /* @__PURE__ */ O.createElement("svg", { width: "24", height: "24", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, /* @__PURE__ */ O.createElement(
    "path",
    {
      d: "M8.6 15.2443L5.35575 12L8.6 8.75575L9.64425 9.825L7.46925 12L9.64425 14.175L8.6 15.2443ZM15.4 15.2443L14.3558 14.175L16.5307 12L14.3558 9.825L15.4 8.75575L18.6443 12L15.4 15.2443ZM5.30775 20.5C4.80258 20.5 4.375 20.325 4.025 19.975C3.675 19.625 3.5 19.1974 3.5 18.6923V15H5V18.6923C5 18.7692 5.03208 18.8398 5.09625 18.9038C5.16025 18.9679 5.23075 19 5.30775 19H9V20.5H5.30775ZM15 20.5V19H18.6923C18.7692 19 18.8398 18.9679 18.9038 18.9038C18.9679 18.8398 19 18.7692 19 18.6923V15H20.5V18.6923C20.5 19.1974 20.325 19.625 19.975 19.975C19.625 20.325 19.1974 20.5 18.6923 20.5H15ZM3.5 9V5.30775C3.5 4.80258 3.675 4.375 4.025 4.025C4.375 3.675 4.80258 3.5 5.30775 3.5H9V5H5.30775C5.23075 5 5.16025 5.03208 5.09625 5.09625C5.03208 5.16025 5 5.23075 5 5.30775V9H3.5ZM19 9V5.30775C19 5.23075 18.9679 5.16025 18.9038 5.09625C18.8398 5.03208 18.7692 5 18.6923 5H15V3.5H18.6923C19.1974 3.5 19.625 3.675 19.975 4.025C20.325 4.375 20.5 4.80258 20.5 5.30775V9H19Z",
      fill: "currentColor"
    }
  )),
  arrow_drop_down: /* @__PURE__ */ O.createElement("svg", { width: "24", height: "24", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, /* @__PURE__ */ O.createElement("path", { d: "M11.9999 14.6537L7.59619 10.25H16.4037L11.9999 14.6537Z", fill: "currentColor" })),
  admonition: /* @__PURE__ */ O.createElement("svg", { width: "24", height: "24", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, /* @__PURE__ */ O.createElement(
    "path",
    {
      d: "M12.0001 21.4C11.7654 21.4 11.5385 21.3548 11.3193 21.2645C11.1002 21.174 10.9002 21.0435 10.7193 20.873L3.1271 13.2807C2.9566 13.0999 2.8261 12.8999 2.7356 12.6807C2.64526 12.4616 2.6001 12.2346 2.6001 12C2.6001 11.7653 2.64526 11.5358 2.7356 11.3115C2.8261 11.0871 2.9566 10.8897 3.1271 10.7192L10.7193 3.12698C10.9002 2.94614 11.1002 2.81314 11.3193 2.72798C11.5385 2.64264 11.7654 2.59998 12.0001 2.59998C12.2348 2.59998 12.4643 2.64264 12.6886 2.72798C12.9129 2.81314 13.1103 2.94614 13.2808 3.12698L20.8731 10.7192C21.0539 10.8897 21.1869 11.0871 21.2721 11.3115C21.3574 11.5358 21.4001 11.7653 21.4001 12C21.4001 12.2346 21.3574 12.4616 21.2721 12.6807C21.1869 12.8999 21.0539 13.0999 20.8731 13.2807L13.2808 20.873C13.1103 21.0435 12.9129 21.174 12.6886 21.2645C12.4643 21.3548 12.2348 21.4 12.0001 21.4ZM12.2213 19.8037L19.8039 12.2212C19.8552 12.1699 19.8808 12.0961 19.8808 12C19.8808 11.9038 19.8552 11.8301 19.8039 11.7787L12.2213 4.19623C12.17 4.14489 12.0963 4.11923 12.0001 4.11923C11.9039 4.11923 11.8302 4.14489 11.7788 4.19623L4.19635 11.7787C4.14501 11.8301 4.11935 11.9038 4.11935 12C4.11935 12.0961 4.14501 12.1699 4.19635 12.2212L11.7788 19.8037C11.8302 19.8551 11.9039 19.8807 12.0001 19.8807C12.0963 19.8807 12.17 19.8551 12.2213 19.8037ZM11.2501 13.0865H12.7501V7.47123H11.2501V13.0865ZM12.0001 15.702C12.2258 15.702 12.4168 15.6237 12.5731 15.4672C12.7296 15.3109 12.8078 15.1199 12.8078 14.8942C12.8078 14.6686 12.7296 14.4776 12.5731 14.3212C12.4168 14.1647 12.2258 14.0865 12.0001 14.0865C11.7744 14.0865 11.5834 14.1647 11.4271 14.3212C11.2706 14.4776 11.1923 14.6686 11.1923 14.8942C11.1923 15.1199 11.2706 15.3109 11.4271 15.4672C11.5834 15.6237 11.7744 15.702 12.0001 15.702Z",
      fill: "currentColor"
    }
  )),
  sandpack: /* @__PURE__ */ O.createElement("svg", { width: "24", height: "24", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, /* @__PURE__ */ O.createElement(
    "path",
    {
      d: "M12.9999 22.5C12.4947 22.5 12.0671 22.325 11.7171 21.975C11.3671 21.625 11.1921 21.1974 11.1921 20.6922V7.30775C11.1921 6.80258 11.3671 6.375 11.7171 6.025C12.0671 5.675 12.4947 5.5 12.9999 5.5H16.3844C16.8895 5.5 17.3171 5.675 17.6671 6.025C18.0171 6.375 18.1921 6.80258 18.1921 7.30775V20.6922C18.1921 21.1974 18.0171 21.625 17.6671 21.975C17.3171 22.325 16.8895 22.5 16.3844 22.5H12.9999ZM12.6921 7.30775V20.6922C12.6921 20.7692 12.7242 20.8398 12.7884 20.9038C12.8524 20.9679 12.9229 21 12.9999 21H16.3844C16.4614 21 16.5319 20.9679 16.5959 20.9038C16.66 20.8398 16.6921 20.7692 16.6921 20.6922V7.30775C16.6921 7.23075 16.66 7.16025 16.5959 7.09625C16.5319 7.03208 16.4614 7 16.3844 7H12.9999C12.9229 7 12.8524 7.03208 12.7884 7.09625C12.7242 7.16025 12.6921 7.23075 12.6921 7.30775ZM6.61537 18.5C6.1102 18.5 5.68262 18.325 5.33262 17.975C4.98262 17.625 4.80762 17.1974 4.80762 16.6923V3.30775C4.80762 2.80258 4.98262 2.375 5.33262 2.025C5.68262 1.675 6.1102 1.5 6.61537 1.5H9.99987C10.505 1.5 10.9326 1.675 11.2826 2.025C11.6326 2.375 11.8076 2.80258 11.8076 3.30775V16.6923C11.8076 17.1974 11.6326 17.625 11.2826 17.975C10.9326 18.325 10.505 18.5 9.99987 18.5H6.61537ZM6.30762 3.30775V16.6923C6.30762 16.7692 6.3397 16.8398 6.40387 16.9038C6.46787 16.9679 6.53837 17 6.61537 17H9.99987C10.0769 17 10.1474 16.9679 10.2114 16.9038C10.2755 16.8398 10.3076 16.7692 10.3076 16.6923V3.30775C10.3076 3.23075 10.2755 3.16025 10.2114 3.09625C10.1474 3.03208 10.0769 3 9.99987 3H6.61537C6.53837 3 6.46787 3.03208 6.40387 3.09625C6.3397 3.16025 6.30762 3.23075 6.30762 3.30775Z",
      fill: "currentColor"
    }
  )),
  rich_text: /* @__PURE__ */ O.createElement("svg", { width: "24", height: "24", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, /* @__PURE__ */ O.createElement(
    "path",
    {
      d: "M5.30775 20.5C4.80258 20.5 4.375 20.325 4.025 19.975C3.675 19.625 3.5 19.1974 3.5 18.6923V5.30775C3.5 4.80258 3.675 4.375 4.025 4.025C4.375 3.675 4.80258 3.5 5.30775 3.5H18.6923C19.1974 3.5 19.625 3.675 19.975 4.025C20.325 4.375 20.5 4.80258 20.5 5.30775V18.6923C20.5 19.1974 20.325 19.625 19.975 19.975C19.625 20.325 19.1974 20.5 18.6923 20.5H5.30775ZM5.30775 19H18.6923C18.7692 19 18.8398 18.9679 18.9038 18.9038C18.9679 18.8398 19 18.7692 19 18.6923V5.30775C19 5.23075 18.9679 5.16025 18.9038 5.09625C18.8398 5.03208 18.7692 5 18.6923 5H5.30775C5.23075 5 5.16025 5.03208 5.09625 5.09625C5.03208 5.16025 5 5.23075 5 5.30775V18.6923C5 18.7692 5.03208 18.8398 5.09625 18.9038C5.16025 18.9679 5.23075 19 5.30775 19ZM6.75 17H17.3268L14 12.3655L11.2308 16.0192L9 13.4615L6.75 17Z",
      fill: "currentColor"
    }
  ), /* @__PURE__ */ O.createElement(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M6 12V6.5H9.1925C9.5925 6.5 9.9425 6.65 10.2425 6.95C10.5425 7.25 10.6925 7.6 10.6925 8V8.6925C10.6925 9.03733 10.605 9.32675 10.43 9.56075C10.255 9.79458 10.0168 9.97817 9.7155 10.1115L10.6155 12H9.404L8.504 10.1925H7.1925V12H6ZM9.1925 9H7.1925V7.6925H9.1925C9.26933 7.6925 9.33983 7.7245 9.404 7.7885C9.468 7.85267 9.5 7.92317 9.5 8V8.6925C9.5 8.76933 9.468 8.83983 9.404 8.904C9.33983 8.968 9.26933 9 9.1925 9Z",
      fill: "currentColor"
    }
  ), /* @__PURE__ */ O.createElement("path", { d: "M12.5 7H17.5V8.25H12.5V7Z", fill: "currentColor" }), /* @__PURE__ */ O.createElement("path", { d: "M12.5 9.25H17.5V10.5H12.5V9.25Z", fill: "currentColor" })),
  difference: /* @__PURE__ */ O.createElement("svg", { width: "24", height: "24", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, /* @__PURE__ */ O.createElement(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M5.30775 20.5C4.80258 20.5 4.375 20.325 4.025 19.975C3.675 19.625 3.5 19.1974 3.5 18.6923V5.30775C3.5 4.80258 3.675 4.375 4.025 4.025C4.375 3.675 4.80258 3.5 5.30775 3.5H18.6923C19.1974 3.5 19.625 3.675 19.975 4.025C20.325 4.375 20.5 4.80258 20.5 5.30775V18.6923C20.5 19.1974 20.325 19.625 19.975 19.975C19.625 20.325 19.1974 20.5 18.6923 20.5H5.30775ZM18.6923 19H5.30775C5.23075 19 5.16025 18.9679 5.09625 18.9038C5.03208 18.8398 5 18.7692 5 18.6923V5.30775C5 5.23075 5.03208 5.16025 5.09625 5.09625C5.16025 5.03208 5.23075 5 5.30775 5H18.6923C18.7692 5 18.8398 5.03208 18.9038 5.09625C18.9679 5.16025 19 5.23075 19 5.30775V18.6923C19 18.7692 18.9679 18.8398 18.9038 18.9038C18.8398 18.9679 18.7692 19 18.6923 19Z",
      fill: "currentColor"
    }
  ), /* @__PURE__ */ O.createElement("rect", { x: "9", y: "10", width: "5.5", height: "1.5", fill: "currentColor" }), /* @__PURE__ */ O.createElement("rect", { x: "9", y: "15", width: "5.5", height: "1.5", fill: "currentColor" }), /* @__PURE__ */ O.createElement("rect", { x: "11", y: "8", width: "1.5", height: "5.5", fill: "currentColor" })),
  markdown: /* @__PURE__ */ O.createElement("svg", { width: "24", height: "24", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, /* @__PURE__ */ O.createElement(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M5.30775 20.5C4.80258 20.5 4.375 20.325 4.025 19.975C3.675 19.625 3.5 19.1974 3.5 18.6923V5.30775C3.5 4.80258 3.675 4.375 4.025 4.025C4.375 3.675 4.80258 3.5 5.30775 3.5H18.6923C19.1974 3.5 19.625 3.675 19.975 4.025C20.325 4.375 20.5 4.80258 20.5 5.30775V18.6923C20.5 19.1974 20.325 19.625 19.975 19.975C19.625 20.325 19.1974 20.5 18.6923 20.5H5.30775ZM18.6923 19H5.30775C5.23075 19 5.16025 18.9679 5.09625 18.9038C5.03208 18.8398 5 18.7692 5 18.6923V5.30775C5 5.23075 5.03208 5.16025 5.09625 5.09625C5.16025 5.03208 5.23075 5 5.30775 5H18.6923C18.7692 5 18.8398 5.03208 18.9038 5.09625C18.9679 5.16025 19 5.23075 19 5.30775V18.6923C19 18.7692 18.9679 18.8398 18.9038 18.9038C18.8398 18.9679 18.7692 19 18.6923 19Z",
      fill: "currentColor"
    }
  ), /* @__PURE__ */ O.createElement("path", { d: "M13 15H11.5V11L9.5 14L7.5 11V15H6V8H7.5L9.5 11L11.5 8H13V15Z", fill: "currentColor" }), /* @__PURE__ */ O.createElement(
    "path",
    {
      d: "M15.9921 15.5833L13.2886 12.8797L14.0546 12.1137L15.4504 13.5016V7.99597L16.5336 7.99993V13.5016L17.9296 12.1137L18.6954 12.8797L15.9921 15.5833Z",
      fill: "currentColor"
    }
  )),
  open_in_new: /* @__PURE__ */ O.createElement("svg", { width: "24", height: "24", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, /* @__PURE__ */ O.createElement(
    "path",
    {
      d: "M5.30775 20.5C4.80258 20.5 4.375 20.325 4.025 19.975C3.675 19.625 3.5 19.1974 3.5 18.6923V5.30775C3.5 4.80258 3.675 4.375 4.025 4.025C4.375 3.675 4.80258 3.5 5.30775 3.5H11.6152V5H5.30775C5.23075 5 5.16025 5.03208 5.09625 5.09625C5.03208 5.16025 5 5.23075 5 5.30775V18.6923C5 18.7692 5.03208 18.8398 5.09625 18.9038C5.16025 18.9679 5.23075 19 5.30775 19H18.6923C18.7692 19 18.8398 18.9679 18.9038 18.9038C18.9679 18.8398 19 18.7692 19 18.6923V12.3848H20.5V18.6923C20.5 19.1974 20.325 19.625 19.975 19.975C19.625 20.325 19.1974 20.5 18.6923 20.5H5.30775ZM9.71925 15.3345L8.6655 14.2808L17.9462 5H14V3.5H20.5V10H19V6.05375L9.71925 15.3345Z",
      fill: "currentColor"
    }
  )),
  link_off: /* @__PURE__ */ O.createElement("svg", { width: "24", height: "24", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, /* @__PURE__ */ O.createElement(
    "path",
    {
      d: "M18.8843 16.1038L17.7498 14.9385C18.4228 14.7552 18.9661 14.3946 19.3796 13.8568C19.7931 13.319 19.9998 12.7 19.9998 12C19.9998 11.1604 19.705 10.444 19.1153 9.85105C18.5255 9.25805 17.8139 8.96155 16.9806 8.96155H13.1728V7.46155H16.9806C18.2293 7.46155 19.2947 7.90422 20.1768 8.78955C21.0588 9.67472 21.4998 10.7449 21.4998 12C21.4998 12.8859 21.262 13.6951 20.7863 14.4278C20.3107 15.1606 19.6767 15.7193 18.8843 16.1038ZM15.5806 12.75L14.0806 11.25H15.7306V12.75H15.5806ZM20.1461 22.2538L1.74609 3.8538L2.79984 2.80005L21.1998 21.2L20.1461 22.2538ZM10.8268 16.5386H7.03834C5.78318 16.5386 4.71301 16.0959 3.82784 15.2105C2.94251 14.3254 2.49984 13.2552 2.49984 12C2.49984 10.8885 2.85784 9.91322 3.57384 9.07405C4.28984 8.23505 5.18826 7.72838 6.26909 7.55405H6.49984L7.90759 8.96155H7.03834C6.19851 8.96155 5.48218 9.25805 4.88934 9.85105C4.29634 10.444 3.99984 11.1604 3.99984 12C3.99984 12.8397 4.29634 13.556 4.88934 14.149C5.48218 14.742 6.19851 15.0385 7.03834 15.0385H10.8268V16.5386ZM8.26909 12.75V11.25H10.2113L11.6863 12.75H8.26909Z",
      fill: "currentColor"
    }
  )),
  edit: /* @__PURE__ */ O.createElement("svg", { width: "24", height: "24", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, /* @__PURE__ */ O.createElement(
    "path",
    {
      d: "M5 19H6.2615L16.498 8.7635L15.2365 7.502L5 17.7385V19ZM3.5 20.5V17.1155L16.6905 3.93075C16.8417 3.79342 17.0086 3.68733 17.1913 3.6125C17.3741 3.5375 17.5658 3.5 17.7663 3.5C17.9668 3.5 18.1609 3.53558 18.3488 3.60675C18.5367 3.67792 18.7032 3.79108 18.848 3.94625L20.0693 5.18275C20.2244 5.32758 20.335 5.49425 20.401 5.68275C20.467 5.87125 20.5 6.05975 20.5 6.24825C20.5 6.44942 20.4657 6.64133 20.397 6.824C20.3283 7.00683 20.2191 7.17383 20.0693 7.325L6.8845 20.5H3.5ZM15.8562 8.14375L15.2365 7.502L16.498 8.7635L15.8562 8.14375Z",
      fill: "currentColor"
    }
  )),
  content_copy: /* @__PURE__ */ O.createElement("svg", { width: "24", height: "24", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, /* @__PURE__ */ O.createElement(
    "path",
    {
      d: "M9.05775 17.5C8.55258 17.5 8.125 17.325 7.775 16.975C7.425 16.625 7.25 16.1974 7.25 15.6923V4.30775C7.25 3.80258 7.425 3.375 7.775 3.025C8.125 2.675 8.55258 2.5 9.05775 2.5H17.4423C17.9474 2.5 18.375 2.675 18.725 3.025C19.075 3.375 19.25 3.80258 19.25 4.30775V15.6923C19.25 16.1974 19.075 16.625 18.725 16.975C18.375 17.325 17.9474 17.5 17.4423 17.5H9.05775ZM9.05775 16H17.4423C17.5192 16 17.5898 15.9679 17.6538 15.9038C17.7179 15.8398 17.75 15.7692 17.75 15.6923V4.30775C17.75 4.23075 17.7179 4.16025 17.6538 4.09625C17.5898 4.03208 17.5192 4 17.4423 4H9.05775C8.98075 4 8.91025 4.03208 8.84625 4.09625C8.78208 4.16025 8.75 4.23075 8.75 4.30775V15.6923C8.75 15.7692 8.78208 15.8398 8.84625 15.9038C8.91025 15.9679 8.98075 16 9.05775 16ZM5.55775 21C5.05258 21 4.625 20.825 4.275 20.475C3.925 20.125 3.75 19.6974 3.75 19.1923V6.30775H5.25V19.1923C5.25 19.2693 5.28208 19.3398 5.34625 19.4038C5.41025 19.4679 5.48075 19.5 5.55775 19.5H15.4423V21H5.55775Z",
      fill: "currentColor"
    }
  )),
  more_horiz: /* @__PURE__ */ O.createElement("svg", { width: "24", height: "24", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, /* @__PURE__ */ O.createElement(
    "path",
    {
      d: "M6.23096 13.5C5.81846 13.5 5.46537 13.3531 5.17171 13.0592C4.87787 12.7656 4.73096 12.4125 4.73096 12C4.73096 11.5875 4.87787 11.2344 5.17171 10.9408C5.46537 10.6469 5.81846 10.5 6.23096 10.5C6.64346 10.5 6.99662 10.6469 7.29046 10.9408C7.58412 11.2344 7.73096 11.5875 7.73096 12C7.73096 12.4125 7.58412 12.7656 7.29046 13.0592C6.99662 13.3531 6.64346 13.5 6.23096 13.5ZM12.0002 13.5C11.5877 13.5 11.2346 13.3531 10.941 13.0592C10.6471 12.7656 10.5002 12.4125 10.5002 12C10.5002 11.5875 10.6471 11.2344 10.941 10.9408C11.2346 10.6469 11.5877 10.5 12.0002 10.5C12.4127 10.5 12.7658 10.6469 13.0595 10.9408C13.3533 11.2344 13.5002 11.5875 13.5002 12C13.5002 12.4125 13.3533 12.7656 13.0595 13.0592C12.7658 13.3531 12.4127 13.5 12.0002 13.5ZM17.7695 13.5C17.357 13.5 17.0038 13.3531 16.71 13.0592C16.4163 12.7656 16.2695 12.4125 16.2695 12C16.2695 11.5875 16.4163 11.2344 16.71 10.9408C17.0038 10.6469 17.357 10.5 17.7695 10.5C18.182 10.5 18.535 10.6469 18.8287 10.9408C19.1225 11.2344 19.2695 11.5875 19.2695 12C19.2695 12.4125 19.1225 12.7656 18.8287 13.0592C18.535 13.3531 18.182 13.5 17.7695 13.5Z",
      fill: "currentColor"
    }
  )),
  more_vert: /* @__PURE__ */ O.createElement("svg", { width: "24", height: "24", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, /* @__PURE__ */ O.createElement(
    "path",
    {
      d: "M12 19.2692C11.5875 19.2692 11.2344 19.1223 10.9408 18.8285C10.6469 18.5348 10.5 18.1817 10.5 17.7692C10.5 17.3567 10.6469 17.0035 10.9408 16.7097C11.2344 16.416 11.5875 16.2692 12 16.2692C12.4125 16.2692 12.7656 16.416 13.0592 16.7097C13.3531 17.0035 13.5 17.3567 13.5 17.7692C13.5 18.1817 13.3531 18.5348 13.0592 18.8285C12.7656 19.1223 12.4125 19.2692 12 19.2692ZM12 13.5C11.5875 13.5 11.2344 13.353 10.9408 13.0592C10.6469 12.7655 10.5 12.4125 10.5 12C10.5 11.5875 10.6469 11.2344 10.9408 10.9407C11.2344 10.6469 11.5875 10.5 12 10.5C12.4125 10.5 12.7656 10.6469 13.0592 10.9407C13.3531 11.2344 13.5 11.5875 13.5 12C13.5 12.4125 13.3531 12.7655 13.0592 13.0592C12.7656 13.353 12.4125 13.5 12 13.5ZM12 7.73071C11.5875 7.73071 11.2344 7.58388 10.9408 7.29021C10.6469 6.99638 10.5 6.64321 10.5 6.23071C10.5 5.81821 10.6469 5.46513 10.9408 5.17146C11.2344 4.87763 11.5875 4.73071 12 4.73071C12.4125 4.73071 12.7656 4.87763 13.0592 5.17146C13.3531 5.46513 13.5 5.81821 13.5 6.23071C13.5 6.64321 13.3531 6.99638 13.0592 7.29021C12.7656 7.58388 12.4125 7.73071 12 7.73071Z",
      fill: "currentColor"
    }
  )),
  close: /* @__PURE__ */ O.createElement("svg", { width: "24", height: "24", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, /* @__PURE__ */ O.createElement(
    "path",
    {
      d: "M6.39994 18.6538L5.34619 17.6L10.9462 12L5.34619 6.4L6.39994 5.34625L11.9999 10.9463L17.5999 5.34625L18.6537 6.4L13.0537 12L18.6537 17.6L17.5999 18.6538L11.9999 13.0538L6.39994 18.6538Z",
      fill: "currentColor"
    }
  )),
  settings: /* @__PURE__ */ O.createElement("svg", { width: "24", height: "24", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, /* @__PURE__ */ O.createElement(
    "path",
    {
      d: "M9.69225 21.5L9.3115 18.4538C9.04367 18.3641 8.769 18.2385 8.4875 18.077C8.20617 17.9153 7.95459 17.7422 7.73275 17.5577L4.9115 18.75L2.604 14.75L5.04425 12.9058C5.02125 12.7571 5.00492 12.6077 4.99525 12.4578C4.98559 12.3078 4.98075 12.1583 4.98075 12.0095C4.98075 11.8673 4.98559 11.7228 4.99525 11.576C5.00492 11.4292 5.02125 11.2686 5.04425 11.0943L2.604 9.25L4.9115 5.26925L7.723 6.452C7.96417 6.261 8.22159 6.08633 8.49525 5.928C8.76892 5.76967 9.03784 5.64242 9.302 5.54625L9.69225 2.5H14.3078L14.6885 5.55575C14.9885 5.66475 15.2599 5.792 15.5028 5.9375C15.7458 6.083 15.991 6.2545 16.2385 6.452L19.0885 5.26925L21.396 9.25L18.9173 11.123C18.9531 11.2845 18.9727 11.4355 18.976 11.576C18.9792 11.7163 18.9808 11.8577 18.9808 12C18.9808 12.1358 18.9775 12.274 18.971 12.4145C18.9647 12.5548 18.9417 12.7154 18.902 12.8963L21.3615 14.75L19.0538 18.75L16.2385 17.548C15.991 17.7455 15.7384 17.9202 15.4808 18.072C15.2231 18.224 14.959 18.3481 14.6885 18.4443L14.3078 21.5H9.69225ZM11 20H12.9655L13.325 17.3212C13.8353 17.1879 14.3017 16.9985 14.724 16.753C15.1465 16.5073 15.5539 16.1916 15.9463 15.8057L18.4308 16.85L19.4155 15.15L17.2463 13.5155C17.3296 13.2565 17.3863 13.0026 17.4163 12.7537C17.4464 12.5051 17.4615 12.2538 17.4615 12C17.4615 11.7397 17.4464 11.4884 17.4163 11.2463C17.3863 11.0039 17.3296 10.7564 17.2463 10.5038L19.4345 8.85L18.45 7.15L15.9365 8.2095C15.6018 7.85183 15.2009 7.53583 14.7338 7.2615C14.2664 6.98717 13.7937 6.79292 13.3155 6.67875L13 4H11.0155L10.6845 6.66925C10.1743 6.78975 9.70325 6.97433 9.27125 7.223C8.83909 7.47183 8.42684 7.79233 8.0345 8.1845L5.55 7.15L4.5655 8.85L6.725 10.4595C6.64167 10.6968 6.58334 10.9437 6.55 11.2C6.51667 11.4563 6.5 11.7262 6.5 12.0095C6.5 12.2698 6.51667 12.525 6.55 12.775C6.58334 13.025 6.6385 13.2718 6.7155 13.5155L4.5655 15.15L5.55 16.85L8.025 15.8C8.4045 16.1897 8.81025 16.5089 9.24225 16.7578C9.67442 17.0064 10.152 17.1974 10.675 17.3307L11 20ZM12.0115 15C12.8435 15 13.5515 14.708 14.1355 14.124C14.7195 13.54 15.0115 12.832 15.0115 12C15.0115 11.168 14.7195 10.46 14.1355 9.876C13.5515 9.292 12.8435 9 12.0115 9C11.1692 9 10.4586 9.292 9.87975 9.876C9.30092 10.46 9.0115 11.168 9.0115 12C9.0115 12.832 9.30092 13.54 9.87975 14.124C10.4586 14.708 11.1692 15 12.0115 15Z",
      fill: "currentColor"
    }
  )),
  delete_big: /* @__PURE__ */ O.createElement("svg", { width: "24", height: "24", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, /* @__PURE__ */ O.createElement(
    "path",
    {
      d: "M7.30775 20.5C6.80908 20.5 6.38308 20.3234 6.02975 19.9702C5.67658 19.6169 5.5 19.1909 5.5 18.6922V5.99998H4.5V4.49998H9V3.61548H15V4.49998H19.5V5.99998H18.5V18.6922C18.5 19.1974 18.325 19.625 17.975 19.975C17.625 20.325 17.1974 20.5 16.6923 20.5H7.30775ZM17 5.99998H7V18.6922C7 18.7821 7.02883 18.8558 7.0865 18.9135C7.14417 18.9711 7.21792 19 7.30775 19H16.6923C16.7692 19 16.8398 18.9679 16.9038 18.9037C16.9679 18.8397 17 18.7692 17 18.6922V5.99998ZM9.404 17H10.9037V7.99998H9.404V17ZM13.0962 17H14.596V7.99998H13.0962V17Z",
      fill: "currentColor"
    }
  )),
  delete_small: /* @__PURE__ */ O.createElement("svg", { width: "24", height: "24", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, /* @__PURE__ */ O.createElement(
    "path",
    {
      d: "M7.30775 20.5C6.80908 20.5 6.38308 20.3234 6.02975 19.9702C5.67658 19.6169 5.5 19.1909 5.5 18.6922V5.99998H4.5V4.49998H9V3.61548H15V4.49998H19.5V5.99998H18.5V18.6922C18.5 19.1974 18.325 19.625 17.975 19.975C17.625 20.325 17.1974 20.5 16.6923 20.5H7.30775ZM17 5.99998H7V18.6922C7 18.7821 7.02883 18.8558 7.0865 18.9135C7.14417 18.9711 7.21792 19 7.30775 19H16.6923C16.7692 19 16.8398 18.9679 16.9038 18.9037C16.9679 18.8397 17 18.7692 17 18.6922V5.99998ZM9.404 17H10.9037V7.99998H9.404V17ZM13.0962 17H14.596V7.99998H13.0962V17Z",
      fill: "currentColor"
    }
  )),
  format_align_center: /* @__PURE__ */ O.createElement("svg", { width: "24", height: "24", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, /* @__PURE__ */ O.createElement(
    "path",
    {
      d: "M3.5 20.5V19H20.5V20.5H3.5ZM7.5 16.625V15.125H16.5V16.625H7.5ZM3.5 12.75V11.25H20.5V12.75H3.5ZM7.5 8.875V7.375H16.5V8.875H7.5ZM3.5 5V3.5H20.5V5H3.5Z",
      fill: "currentColor"
    }
  )),
  format_align_left: /* @__PURE__ */ O.createElement("svg", { width: "24", height: "24", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, /* @__PURE__ */ O.createElement(
    "path",
    {
      d: "M3.5 20.5V19H20.5V20.5H3.5ZM3.5 16.625V15.125H14.5V16.625H3.5ZM3.5 12.75V11.25H20.5V12.75H3.5ZM3.5 8.875V7.375H14.5V8.875H3.5ZM3.5 5V3.5H20.5V5H3.5Z",
      fill: "currentColor"
    }
  )),
  format_align_right: /* @__PURE__ */ O.createElement("svg", { width: "24", height: "24", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, /* @__PURE__ */ O.createElement(
    "path",
    {
      d: "M3.5 5V3.5H20.5V5H3.5ZM9.5 8.875V7.375H20.5V8.875H9.5ZM3.5 12.75V11.25H20.5V12.75H3.5ZM9.5 16.625V15.125H20.5V16.625H9.5ZM3.5 20.5V19H20.5V20.5H3.5Z",
      fill: "currentColor"
    }
  )),
  add_row: /* @__PURE__ */ O.createElement("svg", { width: "24", height: "24", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, /* @__PURE__ */ O.createElement(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M4.025 10.2077C4.375 9.85775 4.80258 9.68275 5.30775 9.68275H6.5V11.1827H5.30775C5.21792 11.1827 5.14417 11.2116 5.0865 11.2693C5.02883 11.3269 5 11.4007 5 11.4905V16.1923C5 16.2821 5.02883 16.3558 5.0865 16.4135C5.14417 16.4712 5.21792 16.5 5.30775 16.5H18.6923C18.7821 16.5 18.8558 16.4712 18.9135 16.4135C18.9712 16.3558 19 16.2821 19 16.1923V11.4905C19 11.4007 18.9712 11.3269 18.9135 11.2693C18.8558 11.2116 18.7821 11.1827 18.6923 11.1827H17.6923V9.68275H18.6923C19.1974 9.68275 19.625 9.85775 19.975 10.2077C20.325 10.5577 20.5 10.9853 20.5 11.4905V16.1923C20.5 16.6974 20.325 17.125 19.975 17.475C19.625 17.825 19.1974 18 18.6923 18H5.30775C4.80258 18 4.375 17.825 4.025 17.475C3.675 17.125 3.5 16.6974 3.5 16.1923V11.4905C3.5 10.9853 3.675 10.5577 4.025 10.2077Z",
      fill: "currentColor"
    }
  ), /* @__PURE__ */ O.createElement(
    "path",
    {
      d: "M11.3848 9.68275V7.5H12.8848V9.68275H15V11.1827H12.8848V13.2307H11.3848V11.1827H9.26925V9.68275H11.3848Z",
      fill: "currentColor"
    }
  )),
  add_column: /* @__PURE__ */ O.createElement("svg", { width: "24", height: "24", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, /* @__PURE__ */ O.createElement(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M9.70775 4.025C9.35775 4.375 9.18275 4.80258 9.18275 5.30775V6.5H10.6827V5.30775C10.6827 5.21792 10.7116 5.14417 10.7693 5.0865C10.8269 5.02883 10.9007 5 10.9905 5H15.6923C15.7821 5 15.8558 5.02883 15.9135 5.0865C15.9712 5.14417 16 5.21792 16 5.30775V18.6923C16 18.7821 15.9712 18.8558 15.9135 18.9135C15.8558 18.9712 15.7821 19 15.6923 19H10.9905C10.9007 19 10.8269 18.9712 10.7693 18.9135C10.7116 18.8558 10.6827 18.7821 10.6827 18.6923V17.6923H9.18275V18.6923C9.18275 19.1974 9.35775 19.625 9.70775 19.975C10.0577 20.325 10.4853 20.5 10.9905 20.5H15.6923C16.1974 20.5 16.625 20.325 16.975 19.975C17.325 19.625 17.5 19.1974 17.5 18.6923V5.30775C17.5 4.80258 17.325 4.375 16.975 4.025C16.625 3.675 16.1974 3.5 15.6923 3.5H10.9905C10.4853 3.5 10.0577 3.675 9.70775 4.025Z",
      fill: "currentColor"
    }
  ), /* @__PURE__ */ O.createElement(
    "path",
    {
      d: "M9.18275 11.3848H7V12.8848H9.18275V15H10.6827V12.8848H12.7307V11.3848H10.6827V9.26925H9.18275V11.3848Z",
      fill: "currentColor"
    }
  )),
  insert_col_left: /* @__PURE__ */ O.createElement("svg", { width: "24", height: "24", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, /* @__PURE__ */ O.createElement(
    "path",
    {
      d: "M13.0001 20.1152H8.67713H8.75388H8.69238H13.0001ZM7.19238 19.8075C7.19238 20.3127 7.36738 20.7402 7.71738 21.0902C8.06738 21.4402 8.49497 21.6152 9.00013 21.6152H12.6924C13.1975 21.6152 13.6251 21.4402 13.9751 21.0902C14.3251 20.7402 14.5001 20.3127 14.5001 19.8075V10.423H13.0001V19.8075C13.0001 19.8973 12.9713 19.9711 12.9136 20.0287C12.856 20.0864 12.7822 20.1152 12.6924 20.1152H9.00013C8.9103 20.1152 8.83655 20.0864 8.77888 20.0287C8.72122 19.9711 8.69238 19.8973 8.69238 19.8075V4.69223C8.26422 4.74357 7.90722 4.93299 7.62138 5.26048C7.33538 5.58798 7.19238 5.97548 7.19238 6.42298V19.8075ZM13.0001 2.49998V4.61523H10.8846V6.11523H13.0001V8.23073H14.5001V6.11523H16.6154V4.61523H14.5001V2.49998H13.0001Z",
      fill: "currentColor"
    }
  )),
  insert_row_above: /* @__PURE__ */ O.createElement("svg", { width: "24", height: "24", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, /* @__PURE__ */ O.createElement(
    "path",
    {
      d: "M20.1152 9.99987V14.3229V14.2461V14.3076V9.99987ZM19.8075 15.8076C20.3127 15.8076 20.7402 15.6326 21.0902 15.2826C21.4402 14.9326 21.6152 14.505 21.6152 13.9999V10.3076C21.6152 9.80245 21.4402 9.37487 21.0902 9.02487C20.7402 8.67487 20.3127 8.49987 19.8075 8.49987H10.423V9.99987H19.8075C19.8973 9.99987 19.9711 10.0287 20.0287 10.0864C20.0864 10.144 20.1152 10.2178 20.1152 10.3076V13.9999C20.1152 14.0897 20.0864 14.1635 20.0287 14.2211C19.9711 14.2788 19.8973 14.3076 19.8075 14.3076H4.69223C4.74357 14.7358 4.93299 15.0928 5.26048 15.3786C5.58798 15.6646 5.97548 15.8076 6.42298 15.8076H19.8075ZM2.49998 9.99987H4.61523V12.1154H6.11523V9.99987H8.23073V8.49987H6.11523V6.38462H4.61523V8.49987H2.49998V9.99987Z",
      fill: "currentColor"
    }
  )),
  insert_row_below: /* @__PURE__ */ O.createElement("svg", { width: "24", height: "24", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, /* @__PURE__ */ O.createElement(
    "path",
    {
      d: "M20.1152 14.1924V9.86939V9.94614V9.88464V14.1924ZM19.8075 8.38464C20.3127 8.38464 20.7402 8.55964 21.0902 8.90964C21.4402 9.25964 21.6152 9.68723 21.6152 10.1924V13.8846C21.6152 14.3898 21.4402 14.8174 21.0902 15.1674C20.7402 15.5174 20.3127 15.6924 19.8075 15.6924H10.423V14.1924H19.8075C19.8973 14.1924 19.9711 14.1636 20.0287 14.1059C20.0864 14.0482 20.1152 13.9745 20.1152 13.8846V10.1924C20.1152 10.1026 20.0864 10.0288 20.0287 9.97114C19.9711 9.91348 19.8973 9.88464 19.8075 9.88464H4.69223C4.74357 9.45648 4.93299 9.09948 5.26048 8.81364C5.58798 8.52764 5.97548 8.38464 6.42298 8.38464H19.8075ZM2.49998 14.1924H4.61523V12.0769H6.11523V14.1924H8.23073V15.6924H6.11523V17.8076H4.61523V15.6924H2.49998V14.1924Z",
      fill: "currentColor"
    }
  )),
  insert_col_right: /* @__PURE__ */ O.createElement("svg", { width: "24", height: "24", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, /* @__PURE__ */ O.createElement(
    "path",
    {
      d: "M10.8075 20.1152H15.1305H15.0537H15.1152H10.8075ZM16.6152 19.8075C16.6152 20.3127 16.4402 20.7402 16.0902 21.0902C15.7402 21.4402 15.3127 21.6152 14.8075 21.6152H11.1152C10.6101 21.6152 10.1825 21.4402 9.83248 21.0902C9.48248 20.7402 9.30748 20.3127 9.30748 19.8075V10.423H10.8075V19.8075C10.8075 19.8973 10.8363 19.9711 10.894 20.0287C10.9517 20.0864 11.0254 20.1152 11.1152 20.1152H14.8075C14.8973 20.1152 14.9711 20.0864 15.0287 20.0287C15.0864 19.9711 15.1152 19.8973 15.1152 19.8075V4.69223C15.5434 4.74357 15.9004 4.93299 16.1862 5.26048C16.4722 5.58798 16.6152 5.97548 16.6152 6.42298V19.8075ZM10.8075 2.49998V4.61523H12.923V6.11523H10.8075V8.23073H9.30748V6.11523H7.19223V4.61523H9.30748V2.49998H10.8075Z",
      fill: "currentColor"
    }
  )),
  check: /* @__PURE__ */ O.createElement("svg", { width: "24", height: "24", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, /* @__PURE__ */ O.createElement(
    "path",
    {
      d: "M9.54983 17.6537L4.21533 12.3192L5.28433 11.25L9.54983 15.5155L18.7153 6.34998L19.7843 7.41923L9.54983 17.6537Z",
      fill: "currentColor"
    }
  ))
}, Btt = ({ children: t }) => {
  const e = ua(vl), n = O.useMemo(() => [e, HJ(null, $w)], [e]);
  return /* @__PURE__ */ O.createElement(Qx.Provider, { value: n }, t);
}, Htt = () => {
  const t = qi(), e = Vi(vQe), n = (l) => {
    e({ current: l });
  }, [r, i, o, a, s, u] = ya(
    F4,
    L4,
    sQ,
    uQ,
    lQ,
    V4
  );
  return /* @__PURE__ */ O.createElement(O.Fragment, null, a.map((l, c) => /* @__PURE__ */ O.createElement(l, { key: c })), /* @__PURE__ */ O.createElement(yQ, { wrappers: s }, /* @__PURE__ */ O.createElement("div", { className: Ce(it.rootContentEditableWrapper, "mdxeditor-root-contenteditable") }, /* @__PURE__ */ O.createElement(
    bQ,
    {
      contentEditable: /* @__PURE__ */ O.createElement("div", { ref: n }, /* @__PURE__ */ O.createElement(
        mQ,
        {
          className: Ce(it.contentEditable, r),
          ariaLabel: t("contentArea.editableMarkdown", "editable markdown"),
          spellCheck: i
        }
      )),
      placeholder: /* @__PURE__ */ O.createElement("div", { className: Ce(it.contentEditable, it.placeholder, r) }, /* @__PURE__ */ O.createElement("p", null, u)),
      ErrorBoundary: vQ
    }
  ))), o.map((l, c) => /* @__PURE__ */ O.createElement(l, { key: c })));
}, Wtt = {
  listItemIndent: "one"
}, jtt = (t) => Vtt[t];
function ztt(t, e, n = {}) {
  let r = e;
  for (const [i, o] of Object.entries(n))
    r = r.replaceAll(`{{${i}}}`, String(o));
  return r;
}
const yQ = ({ wrappers: t, children: e }) => {
  if (t.length === 0)
    return /* @__PURE__ */ O.createElement(O.Fragment, null, e);
  const n = t[0];
  return /* @__PURE__ */ O.createElement(n, null, /* @__PURE__ */ O.createElement(yQ, { wrappers: t.slice(1) }, e));
}, Gtt = ({ children: t, className: e }) => {
  const n = O.useRef(null), r = Vi(lf);
  return O.useEffect(() => {
    const i = document.createElement("div");
    return i.classList.add(
      "mdxeditor-popup-container",
      it.editorRoot,
      it.popupContainer,
      ...(e ?? "").trim().split(" ").filter(Boolean)
    ), document.body.appendChild(i), n.current = i, r(n), () => {
      i.remove();
    };
  }, [e, n, r]), /* @__PURE__ */ O.createElement("div", { className: Ce("mdxeditor", it.editorRoot, it.editorWrapper, e) }, t);
}, Utt = ({ mdxRef: t }) => {
  const e = hw();
  return O.useImperativeHandle(
    t,
    () => ({
      getMarkdown: () => e.getValue(G4) === "source" ? e.getValue(E2) : e.getValue(Vd),
      setMarkdown: (n) => {
        e.pub(TO, n);
      },
      insertMarkdown: (n) => {
        e.pub(tQ, n);
      },
      focus: (n, r) => {
        var i;
        (i = e.getValue(vl)) == null || i.focus(n, r);
      }
    }),
    [e]
  ), null;
}, Xtt = O.forwardRef((t, e) => /* @__PURE__ */ O.createElement(
  CUe,
  {
    plugins: [
      EQe({
        contentEditableClassName: t.contentEditableClassName ?? "",
        spellCheck: t.spellCheck ?? !0,
        initialMarkdown: t.markdown,
        onChange: t.onChange ?? jh,
        onBlur: t.onBlur ?? jh,
        toMarkdownOptions: t.toMarkdownOptions ?? Wtt,
        autoFocus: t.autoFocus ?? !1,
        placeholder: t.placeholder ?? "",
        readOnly: !!t.readOnly,
        iconComponentFor: t.iconComponentFor ?? jtt,
        suppressHtmlProcessing: t.suppressHtmlProcessing ?? !1,
        onError: t.onError ?? jh,
        translation: t.translation ?? ztt,
        trim: t.trim ?? !0,
        lexicalTheme: t.lexicalTheme
      }),
      ...t.plugins ?? []
    ]
  },
  /* @__PURE__ */ O.createElement(Gtt, { className: t.className }, /* @__PURE__ */ O.createElement(Btt, null, /* @__PURE__ */ O.createElement(Htt, null))),
  /* @__PURE__ */ O.createElement(Utt, { mdxRef: e })
)), xQ = typeof window < "u" && typeof window.document.createElement < "u", CQ = xQ && /Mac|iPod|iPhone|iPad/.test(navigator.platform);
function Ytt(t, e) {
  return CQ ? t : e;
}
const Ztt = {
  testLexicalNode: QK,
  visitLexicalNode: ({ lexicalNode: t, actions: e }) => {
    const n = parseInt(t.getTag()[1], 10);
    e.addAndStepInto("heading", { depth: n });
  }
}, Jtt = {
  testNode: "heading",
  visitNode: function({ mdastNode: t, actions: e }) {
    e.addAndStepInto(Ql(`h${t.depth}`));
  }
}, Ktt = [48, 49, 50, 51, 52, 53, 54], wQ = [1, 2, 3, 4, 5, 6], qtt = {
  49: 1,
  50: 2,
  51: 3,
  52: 4,
  53: 5,
  54: 6
}, NO = Ht(wQ, (t) => {
  t.pub(aQ, (e) => e.registerCommand(
    WJ,
    (n) => {
      const { keyCode: r, ctrlKey: i, metaKey: o, altKey: a } = n;
      return Ktt.includes(r) && Ytt(o, i) && a ? (n.preventDefault(), e.update(() => {
        if (r === 48)
          t.pub(w2, () => Sr());
        else {
          const s = t.getValue(NO), u = qtt[r];
          s.includes(u) || t.pub(w2, () => Ql(`h${u}`));
        }
      }), !0) : !1;
    },
    Ar
  ));
}), Qtt = pl({
  init(t) {
    t.pubIn({
      [PO]: "headings",
      [bc]: Jtt,
      [cf]: vO,
      [df]: Ztt
    });
  },
  update(t, e) {
    t.pub(NO, (e == null ? void 0 : e.allowedHeadingLevels) ?? wQ);
  }
});
function mL(t, e) {
  return t.getEditorState().read(() => {
    const n = fi(e);
    return n !== null && n.isSelected();
  });
}
function EQ(t) {
  const [e] = Vo(), [n, r] = Le(() => mL(e, t));
  return Re(() => {
    let i = !0;
    const o = e.registerUpdateListener(() => {
      i && r(mL(e, t));
    });
    return () => {
      i = !1, o();
    };
  }, [e, t]), [n, et((i) => {
    e.update(() => {
      let o = vt();
      li(o) || (o = I4(), uo(o)), li(o) && (i ? o.add(t) : o.delete(t));
    });
  }, [e, t]), et(() => {
    e.update(() => {
      const i = vt();
      li(i) && i.clear();
    });
  }, [e])];
}
const SQ = gl();
function ent({ nodeKey: t }) {
  const [e] = Vo(), [n, r, i] = EQ(t), o = et((a) => {
    const s = vt();
    return n && li(s) && (a.preventDefault(), e.update(() => {
      s.getNodes().forEach((u) => {
        _Q(u) && u.remove();
      });
    })), !1;
  }, [e, n]);
  return Re(() => xa(e.registerCommand(pw, (a) => {
    const s = e.getElementByKey(t);
    return a.target === s && (a.shiftKey || i(), r(!n), !0);
  }, Ar), e.registerCommand(mw, o, Ar), e.registerCommand(gw, o, Ar)), [i, e, n, t, o, r]), Re(() => {
    const a = e.getElementByKey(t), s = "selected";
    a !== null && (n ? uf(a, s) : pO(a, s));
  }, [e, n, t]), null;
}
let kO = class IQ extends yv {
  static getType() {
    return "horizontalrule";
  }
  static clone(e) {
    return new IQ(e.__key);
  }
  static importJSON(e) {
    return Mw();
  }
  static importDOM() {
    return { hr: () => ({ conversion: tnt, priority: 0 }) };
  }
  exportJSON() {
    return { type: "horizontalrule", version: 1 };
  }
  exportDOM() {
    return { element: document.createElement("hr") };
  }
  createDOM(e) {
    const n = document.createElement("hr");
    return uf(n, e.theme.hr), n;
  }
  getTextContent() {
    return `
`;
  }
  isInline() {
    return !1;
  }
  updateDOM() {
    return !1;
  }
  decorate() {
    return Oe.jsx(ent, { nodeKey: this.__key });
  }
};
function tnt() {
  return { node: Mw() };
}
function Mw() {
  return Qa(new kO());
}
function _Q(t) {
  return t instanceof kO;
}
function nnt() {
  const [t] = Vo();
  return Re(() => t.registerCommand(SQ, (e) => {
    const n = vt();
    if (!rt(n))
      return !1;
    if (n.focus.getNode() !== null) {
      const r = Mw();
      jK(r);
    }
    return !0;
  }, kn), [t]), null;
}
const rnt = {
  testLexicalNode: _Q,
  visitLexicalNode({ actions: t }) {
    t.addAndStepInto("thematicBreak");
  }
}, int = {
  testNode: "thematicBreak",
  visitNode({ actions: t }) {
    t.addAndStepInto(Mw());
  }
}, AQ = Nc((t) => {
  t.sub(t.pipe(AQ, Zr(hi)), ([, e]) => {
    e == null || e.dispatchCommand(SQ, void 0);
  });
}), ont = pl({
  init(t) {
    t.pubIn({
      [bc]: int,
      [cf]: kO,
      [df]: rnt,
      [jp]: nnt
    });
  }
});
function ant(t) {
  return t && t.__esModule && Object.prototype.hasOwnProperty.call(t, "default") ? t.default : t;
}
var Qs = ant(function(t) {
  const e = new URLSearchParams();
  e.append("code", t);
  for (let n = 1; n < arguments.length; n++)
    e.append("v", arguments[n]);
  throw Error(`Minified Lexical error #${t}; visit https://lexical.dev/docs/error?${e} for the full message or use the non-minified dev environment for full errors and additional helpful warnings.`);
});
function Y4(t) {
  let e = 1, n = t.getParent();
  for (; n != null; ) {
    if (jn(n)) {
      const r = n.getParent();
      if (wn(r)) {
        e++, n = r.getParent();
        continue;
      }
      Qs(40);
    }
    return e;
  }
  return e;
}
function Z4(t) {
  let e = t.getParent();
  wn(e) || Qs(40);
  let n = e;
  for (; n !== null; )
    n = n.getParent(), wn(n) && (e = n);
  return e;
}
function TQ(t) {
  let e = [];
  const n = t.getChildren().filter(jn);
  for (let r = 0; r < n.length; r++) {
    const i = n[r], o = i.getFirstChild();
    wn(o) ? e = e.concat(TQ(o)) : e.push(i);
  }
  return e;
}
function eu(t) {
  return jn(t) && wn(t.getFirstChild());
}
function vL(t) {
  return lo().append(t);
}
function OQ(t, e) {
  return jn(t) && (e.length === 0 || e.length === 1 && t.is(e[0]) && t.getChildrenSize() === 0);
}
function J4(t, e) {
  t.update(() => {
    const n = vt();
    if (n !== null) {
      const r = n.getNodes();
      if (rt(n)) {
        const o = n.getStartEndPoints();
        o === null && Qs(143);
        const [a] = o, s = a.getNode(), u = s.getParent();
        if (OQ(s, r)) {
          const l = so(e);
          if (Oi(u)) {
            s.replace(l);
            const c = lo();
            We(s) && (c.setFormat(s.getFormatType()), c.setIndent(s.getIndent())), l.append(c);
          } else if (jn(s)) {
            const c = s.getParentOrThrow();
            Bd(l, c.getChildren()), c.replace(l);
          }
          return;
        }
      }
      const i = /* @__PURE__ */ new Set();
      for (let o = 0; o < r.length; o++) {
        const a = r[o];
        if (!We(a) || !a.isEmpty() || jn(a) || i.has(a.getKey())) {
          if (eK(a)) {
            let s = a.getParent();
            for (; s != null; ) {
              const u = s.getKey();
              if (wn(s)) {
                if (!i.has(u)) {
                  const l = so(e);
                  Bd(l, s.getChildren()), s.replace(l), i.add(u);
                }
                break;
              }
              {
                const l = s.getParent();
                if (Oi(l) && !i.has(u)) {
                  i.add(u), bL(s, e);
                  break;
                }
                s = l;
              }
            }
          }
        } else
          bL(a, e);
      }
    }
  });
}
function Bd(t, e) {
  t.splice(t.getChildrenSize(), 0, e);
}
function bL(t, e) {
  if (wn(t))
    return t;
  const n = t.getPreviousSibling(), r = t.getNextSibling(), i = lo();
  if (i.setFormat(t.getFormatType()), i.setIndent(t.getIndent()), Bd(i, t.getChildren()), wn(n) && e === n.getListType())
    return n.append(i), t.remove(), wn(r) && e === r.getListType() && (Bd(n, r.getChildren()), r.remove()), n;
  if (wn(r) && e === r.getListType())
    return r.getFirstChildOrThrow().insertBefore(i), t.remove(), r;
  {
    const o = so(e);
    return o.append(i), t.replace(o), o;
  }
}
function RO(t, e) {
  const n = t.getLastChild(), r = e.getFirstChild();
  n && r && eu(n) && eu(r) && (RO(n.getFirstChild(), r.getFirstChild()), r.remove());
  const i = e.getChildren();
  i.length > 0 && t.append(...i), e.remove();
}
function snt(t) {
  t.update(() => {
    const e = vt();
    if (rt(e)) {
      const n = /* @__PURE__ */ new Set(), r = e.getNodes(), i = e.anchor.getNode();
      if (OQ(i, r))
        n.add(Z4(i));
      else
        for (let o = 0; o < r.length; o++) {
          const a = r[o];
          if (eK(a)) {
            const s = HK(a, wv);
            s != null && n.add(Z4(s));
          }
        }
      for (const o of n) {
        let a = o;
        const s = TQ(o);
        for (const u of s) {
          const l = Sr();
          Bd(l, u.getChildren()), a.insertAfter(l), a = l, u.__key === e.anchor.key && e.anchor.set(l.getKey(), 0, "element"), u.__key === e.focus.key && e.focus.set(l.getKey(), 0, "element"), u.remove();
        }
        o.remove();
      }
    }
  });
}
function unt(t) {
  const e = /* @__PURE__ */ new Set();
  if (eu(t) || e.has(t.getKey()))
    return;
  const n = t.getParent(), r = t.getNextSibling(), i = t.getPreviousSibling();
  if (eu(r) && eu(i)) {
    const o = i.getFirstChild();
    if (wn(o)) {
      o.append(t);
      const a = r.getFirstChild();
      wn(a) && (Bd(o, a.getChildren()), r.remove(), e.add(r.getKey()));
    }
  } else if (eu(r)) {
    const o = r.getFirstChild();
    if (wn(o)) {
      const a = o.getFirstChild();
      a !== null && a.insertBefore(t);
    }
  } else if (eu(i)) {
    const o = i.getFirstChild();
    wn(o) && o.append(t);
  } else if (wn(n)) {
    const o = lo(), a = so(n.getListType());
    o.append(a), a.append(t), i ? i.insertAfter(o) : r ? r.insertBefore(o) : n.append(o);
  }
}
function lnt(t) {
  if (eu(t))
    return;
  const e = t.getParent(), n = e ? e.getParent() : void 0;
  if (wn(n ? n.getParent() : void 0) && jn(n) && wn(e)) {
    const r = e ? e.getFirstChild() : void 0, i = e ? e.getLastChild() : void 0;
    if (t.is(r))
      n.insertBefore(t), e.isEmpty() && n.remove();
    else if (t.is(i))
      n.insertAfter(t), e.isEmpty() && n.remove();
    else {
      const o = e.getListType(), a = lo(), s = so(o);
      a.append(s), t.getPreviousSiblings().forEach((c) => s.append(c));
      const u = lo(), l = so(o);
      u.append(l), Bd(l, t.getNextSiblings()), n.insertBefore(a), n.insertAfter(u), n.replace(t);
    }
  }
}
function cnt() {
  const t = vt();
  if (!rt(t) || !t.isCollapsed())
    return !1;
  const e = t.anchor.getNode();
  if (!jn(e) || e.getChildrenSize() !== 0)
    return !1;
  const n = Z4(e), r = e.getParent();
  wn(r) || Qs(40);
  const i = r.getParent();
  let o;
  if (Oi(i))
    o = Sr(), n.insertAfter(o);
  else {
    if (!jn(i))
      return !1;
    o = lo(), i.insertAfter(o);
  }
  o.select();
  const a = e.getNextSiblings();
  if (a.length > 0) {
    const s = so(r.getListType());
    if (dp(o))
      o.insertAfter(s);
    else {
      const u = lo();
      u.append(s), o.insertAfter(u);
    }
    a.forEach((u) => {
      u.remove(), s.append(u);
    });
  }
  return function(s) {
    let u = s;
    for (; u.getNextSibling() == null && u.getPreviousSibling() == null; ) {
      const l = u.getParent();
      if (l == null || !jn(u) && !wn(u))
        break;
      u = l;
    }
    u.remove();
  }(e), !0;
}
function S2(...t) {
  const e = [];
  for (const n of t)
    if (n && typeof n == "string")
      for (const [r] of n.matchAll(/\S+/g))
        e.push(r);
  return e;
}
let wv = class PQ extends Eu {
  static getType() {
    return "listitem";
  }
  static clone(e) {
    return new PQ(e.__value, e.__checked, e.__key);
  }
  constructor(e, n, r) {
    super(r), this.__value = e === void 0 ? 1 : e, this.__checked = n;
  }
  createDOM(e) {
    const n = document.createElement("li"), r = this.getParent();
    return wn(r) && r.getListType() === "check" && xL(n, this, null), n.value = this.__value, yL(n, e.theme, this), n;
  }
  updateDOM(e, n, r) {
    const i = this.getParent();
    return wn(i) && i.getListType() === "check" && xL(n, this, e), n.value = this.__value, yL(n, r.theme, this), !1;
  }
  static transform() {
    return (e) => {
      if (jn(e) || Qs(144), e.__checked == null)
        return;
      const n = e.getParent();
      wn(n) && n.getListType() !== "check" && e.getChecked() != null && e.setChecked(void 0);
    };
  }
  static importDOM() {
    return { li: () => ({ conversion: dnt, priority: 0 }) };
  }
  static importJSON(e) {
    const n = lo();
    return n.setChecked(e.checked), n.setValue(e.value), n.setFormat(e.format), n.setDirection(e.direction), n;
  }
  exportDOM(e) {
    const n = this.createDOM(e._config);
    return n.style.textAlign = this.getFormatType(), { element: n };
  }
  exportJSON() {
    return { ...super.exportJSON(), checked: this.getChecked(), type: "listitem", value: this.getValue(), version: 1 };
  }
  append(...e) {
    for (let n = 0; n < e.length; n++) {
      const r = e[n];
      if (We(r) && this.canMergeWith(r)) {
        const i = r.getChildren();
        this.append(...i), r.remove();
      } else
        super.append(r);
    }
    return this;
  }
  replace(e, n) {
    if (jn(e))
      return super.replace(e);
    this.setIndent(0);
    const r = this.getParentOrThrow();
    if (!wn(r))
      return e;
    if (r.__first === this.getKey())
      r.insertBefore(e);
    else if (r.__last === this.getKey())
      r.insertAfter(e);
    else {
      const i = so(r.getListType());
      let o = this.getNextSibling();
      for (; o; ) {
        const a = o;
        o = o.getNextSibling(), i.append(a);
      }
      r.insertAfter(e), e.insertAfter(i);
    }
    return n && (We(e) || Qs(139), this.getChildren().forEach((i) => {
      e.append(i);
    })), this.remove(), r.getChildrenSize() === 0 && r.remove(), e;
  }
  insertAfter(e, n = !0) {
    const r = this.getParentOrThrow();
    if (wn(r) || Qs(39), jn(e))
      return super.insertAfter(e, n);
    const i = this.getNextSiblings();
    if (r.insertAfter(e, n), i.length !== 0) {
      const o = so(r.getListType());
      i.forEach((a) => o.append(a)), e.insertAfter(o, n);
    }
    return e;
  }
  remove(e) {
    const n = this.getPreviousSibling(), r = this.getNextSibling();
    super.remove(e), n && r && eu(n) && eu(r) && (RO(n.getFirstChild(), r.getFirstChild()), r.remove());
  }
  insertNewAfter(e, n = !0) {
    const r = lo(this.__checked == null && void 0);
    return this.insertAfter(r, n), r;
  }
  collapseAtStart(e) {
    const n = Sr();
    this.getChildren().forEach((a) => n.append(a));
    const r = this.getParentOrThrow(), i = r.getParentOrThrow(), o = jn(i);
    if (r.getChildrenSize() === 1)
      if (o)
        r.remove(), i.select();
      else {
        r.insertBefore(n), r.remove();
        const a = e.anchor, s = e.focus, u = n.getKey();
        a.type === "element" && a.getNode().is(this) && a.set(u, a.offset, "element"), s.type === "element" && s.getNode().is(this) && s.set(u, s.offset, "element");
      }
    else
      r.insertBefore(n), this.remove();
    return !0;
  }
  getValue() {
    return this.getLatest().__value;
  }
  setValue(e) {
    this.getWritable().__value = e;
  }
  getChecked() {
    const e = this.getLatest();
    let n;
    const r = this.getParent();
    return wn(r) && (n = r.getListType()), n === "check" ? !!e.__checked : void 0;
  }
  setChecked(e) {
    this.getWritable().__checked = e;
  }
  toggleChecked() {
    this.setChecked(!this.__checked);
  }
  getIndent() {
    const e = this.getParent();
    if (e === null)
      return this.getLatest().__indent;
    let n = e.getParentOrThrow(), r = 0;
    for (; jn(n); )
      n = n.getParentOrThrow().getParentOrThrow(), r++;
    return r;
  }
  setIndent(e) {
    typeof e != "number" && Qs(117), (e = Math.floor(e)) >= 0 || Qs(199);
    let n = this.getIndent();
    for (; n !== e; )
      n < e ? (unt(this), n++) : (lnt(this), n--);
    return this;
  }
  canInsertAfter(e) {
    return jn(e);
  }
  canReplaceWith(e) {
    return jn(e);
  }
  canMergeWith(e) {
    return dp(e) || jn(e);
  }
  extractWithChild(e, n) {
    if (!rt(n))
      return !1;
    const r = n.anchor.getNode(), i = n.focus.getNode();
    return this.isParentOf(r) && this.isParentOf(i) && this.getTextContent().length === n.getTextContent().length;
  }
  isParentRequired() {
    return !0;
  }
  createParentElementNode() {
    return so("bullet");
  }
  canMergeWhenEmpty() {
    return !0;
  }
};
function yL(t, e, n) {
  const r = [], i = [], o = e.list, a = o ? o.listitem : void 0;
  let s;
  if (o && o.nested && (s = o.nested.listitem), a !== void 0 && r.push(...S2(a)), o) {
    const u = n.getParent(), l = wn(u) && u.getListType() === "check", c = n.getChecked();
    l && !c || i.push(o.listitemUnchecked), l && c || i.push(o.listitemChecked), l && r.push(c ? o.listitemChecked : o.listitemUnchecked);
  }
  if (s !== void 0) {
    const u = S2(s);
    n.getChildren().some((l) => wn(l)) ? r.push(...u) : i.push(...u);
  }
  i.length > 0 && pO(t, ...i), r.length > 0 && uf(t, ...r);
}
function xL(t, e, n, r) {
  wn(e.getFirstChild()) ? (t.removeAttribute("role"), t.removeAttribute("tabIndex"), t.removeAttribute("aria-checked")) : (t.setAttribute("role", "checkbox"), t.setAttribute("tabIndex", "-1"), n && e.__checked === n.__checked || t.setAttribute("aria-checked", e.getChecked() ? "true" : "false"));
}
function dnt(t) {
  if (t.classList.contains("task-list-item")) {
    for (const n of t.children)
      if (n.tagName === "INPUT")
        return fnt(n);
  }
  const e = t.getAttribute("aria-checked");
  return { node: lo(e === "true" || e !== "false" && void 0) };
}
function fnt(t) {
  return t.getAttribute("type") !== "checkbox" ? { node: null } : { node: lo(t.hasAttribute("checked")) };
}
function lo(t) {
  return Qa(new wv(void 0, t));
}
function jn(t) {
  return t instanceof wv;
}
let Ev = class NQ extends Eu {
  static getType() {
    return "list";
  }
  static clone(e) {
    const n = e.__listType || EL[e.__tag];
    return new NQ(n, e.__start, e.__key);
  }
  constructor(e, n, r) {
    super(r);
    const i = EL[e] || e;
    this.__listType = i, this.__tag = i === "number" ? "ol" : "ul", this.__start = n;
  }
  getTag() {
    return this.__tag;
  }
  setListType(e) {
    const n = this.getWritable();
    n.__listType = e, n.__tag = e === "number" ? "ol" : "ul";
  }
  getListType() {
    return this.__listType;
  }
  getStart() {
    return this.__start;
  }
  createDOM(e, n) {
    const r = this.__tag, i = document.createElement(r);
    return this.__start !== 1 && i.setAttribute("start", String(this.__start)), i.__lexicalListType = this.__listType, CL(i, e.theme, this), i;
  }
  updateDOM(e, n, r) {
    return e.__tag !== this.__tag || (CL(n, r.theme, this), !1);
  }
  static transform() {
    return (e) => {
      wn(e) || Qs(163), function(n) {
        const r = n.getNextSibling();
        wn(r) && n.getListType() === r.getListType() && RO(n, r);
      }(e), function(n) {
        const r = n.getListType() !== "check";
        let i = n.getStart();
        for (const o of n.getChildren())
          jn(o) && (o.getValue() !== i && o.setValue(i), r && o.getLatest().__checked != null && o.setChecked(void 0), wn(o.getFirstChild()) || i++);
      }(e);
    };
  }
  static importDOM() {
    return { ol: () => ({ conversion: wL, priority: 0 }), ul: () => ({ conversion: wL, priority: 0 }) };
  }
  static importJSON(e) {
    const n = so(e.listType, e.start);
    return n.setFormat(e.format), n.setIndent(e.indent), n.setDirection(e.direction), n;
  }
  exportDOM(e) {
    const { element: n } = super.exportDOM(e);
    return n && gu(n) && (this.__start !== 1 && n.setAttribute("start", String(this.__start)), this.__listType === "check" && n.setAttribute("__lexicalListType", "check")), { element: n };
  }
  exportJSON() {
    return { ...super.exportJSON(), listType: this.getListType(), start: this.getStart(), tag: this.getTag(), type: "list", version: 1 };
  }
  canBeEmpty() {
    return !1;
  }
  canIndent() {
    return !1;
  }
  append(...e) {
    for (let n = 0; n < e.length; n++) {
      const r = e[n];
      if (jn(r))
        super.append(r);
      else {
        const i = lo();
        if (wn(r))
          i.append(r);
        else if (We(r)) {
          const o = Xr(r.getTextContent());
          i.append(o);
        } else
          i.append(r);
        super.append(i);
      }
    }
    return this;
  }
  extractWithChild(e) {
    return jn(e);
  }
};
function CL(t, e, n) {
  const r = [], i = [], o = e.list;
  if (o !== void 0) {
    const a = o[`${n.__tag}Depth`] || [], s = Y4(n) - 1, u = s % a.length, l = a[u], c = o[n.__tag];
    let d;
    const f = o.nested, h = o.checklist;
    if (f !== void 0 && f.list && (d = f.list), c !== void 0 && r.push(c), h !== void 0 && n.__listType === "check" && r.push(h), l !== void 0) {
      r.push(...S2(l));
      for (let p = 0; p < a.length; p++)
        p !== u && i.push(n.__tag + p);
    }
    if (d !== void 0) {
      const p = S2(d);
      s > 1 ? r.push(...p) : i.push(...p);
    }
  }
  i.length > 0 && pO(t, ...i), r.length > 0 && uf(t, ...r);
}
function hnt(t) {
  const e = [];
  for (let n = 0; n < t.length; n++) {
    const r = t[n];
    if (jn(r)) {
      e.push(r);
      const i = r.getChildren();
      i.length > 1 && i.forEach((o) => {
        wn(o) && e.push(vL(o));
      });
    } else
      e.push(vL(r));
  }
  return e;
}
function wL(t) {
  const e = t.nodeName.toLowerCase();
  let n = null;
  return e === "ol" ? n = so("number", t.start) : e === "ul" && (n = function(r) {
    if (r.getAttribute("__lexicallisttype") === "check" || r.classList.contains("contains-task-list"))
      return !0;
    for (const i of r.childNodes)
      if (gu(i) && i.hasAttribute("aria-checked"))
        return !0;
    return !1;
  }(t) ? so("check") : so("bullet")), { after: hnt, node: n };
}
const EL = { ol: "number", ul: "bullet" };
function so(t, e = 1) {
  return Qa(new Ev(t, e));
}
function wn(t) {
  return t instanceof Ev;
}
const kQ = gl(), RQ = gl(), $Q = gl(), DQ = gl(), pnt = {
  testNode: "list",
  visitNode: function({ mdastNode: t, lexicalParent: e, actions: n }) {
    const r = t.children.some((o) => typeof o.checked == "boolean") ? "check" : t.ordered ? "number" : "bullet", i = so(r);
    if (jn(e)) {
      const o = lo();
      o.append(i), e.insertAfter(o);
    } else
      e.append(i);
    n.visitChildren(t, i);
  }
}, gnt = {
  testNode: "listItem",
  visitNode({ mdastNode: t, actions: e, lexicalParent: n }) {
    const r = n.getListType() === "check" ? t.checked ?? !1 : void 0;
    e.addAndStepInto(lo(r));
  }
}, mnt = {
  testLexicalNode: wn,
  visitLexicalNode: ({ lexicalNode: t, actions: e }) => {
    e.addAndStepInto("list", {
      ordered: t.getListType() === "number",
      spread: !1
    });
  }
}, vnt = {
  testLexicalNode: jn,
  visitLexicalNode: ({ lexicalNode: t, mdastParent: e, actions: n }) => {
    const r = t.getChildren(), i = r[0];
    if (r.length === 1 && wn(i)) {
      const o = e.children.at(-1);
      o ? n.visitChildren(t, o) : n.visitChildren(i, e);
    } else {
      const o = t.getParent(), a = n.appendToParent(e, {
        type: "listItem",
        checked: o.getListType() === "check" ? !!t.getChecked() : void 0,
        spread: !1,
        children: [{ type: "paragraph", children: [] }]
      });
      n.visitChildren(t, a.children[0]);
    }
  }
};
function bnt(t) {
  return t.registerCommand(kT, (e) => {
    const n = vt();
    if (!rt(n))
      return !1;
    e.preventDefault();
    const r = function(i) {
      const o = i.getNodes();
      if (LXe(o, (d) => f2(d) && d.canIndent() ? d : null).length > 0)
        return !0;
      const a = i.anchor, s = i.focus, u = s.isBefore(a) ? s : a, l = u.getNode(), c = WK(l);
      if (c.canIndent()) {
        const d = c.getKey();
        let f = uO();
        if (f.anchor.set(d, 0, "element"), f.focus.set(d, 0, "element"), f = ZT(f), f.anchor.is(u))
          return !0;
      }
      return !1;
    }(n) ? e.shiftKey ? s4 : RT : GJ;
    return t.dispatchCommand(r, void 0);
  }, kn);
}
function SL() {
  const [t] = Vo();
  return Re(() => bnt(t)), null;
}
function IL() {
  const [t] = Vo();
  return Re(() => xa(t.registerCommand($Q, () => (J4(t, "check"), !0), Ar), t.registerCommand(NT, (e) => TL(e, t, !1), Ar), t.registerCommand(PT, (e) => TL(e, t, !0), Ar), t.registerCommand(pv, (e) => {
    if (K4() != null) {
      const n = t.getRootElement();
      return n != null && n.focus(), !0;
    }
    return !1;
  }, Ar), t.registerCommand(zJ, (e) => {
    const n = K4();
    return !(n == null || !t.isEditable()) && (t.update(() => {
      const r = hu(n);
      jn(r) && (e.preventDefault(), r.toggleChecked());
    }), !0);
  }, Ar), t.registerCommand(OT, (e) => t.getEditorState().read(() => {
    const n = vt();
    if (rt(n) && n.isCollapsed()) {
      const { anchor: r } = n, i = r.type === "element";
      if (i || r.offset === 0) {
        const o = r.getNode(), a = Hp(o, (s) => We(s) && !s.isInline());
        if (jn(a)) {
          const s = a.getParent();
          if (wn(s) && s.getListType() === "check" && (i || a.getFirstDescendant() === o)) {
            const u = t.getElementByKey(a.__key);
            if (u != null && document.activeElement !== u)
              return u.focus(), e.preventDefault(), !0;
          }
        }
      }
    }
    return !1;
  }), Ar), t.registerRootListener((e, n) => {
    e !== null && (e.addEventListener("click", _L), e.addEventListener("pointerdown", AL)), n !== null && (n.removeEventListener("click", _L), n.removeEventListener("pointerdown", AL));
  }))), null;
}
function MQ(t, e) {
  const n = t.target;
  if (n === null || !gu(n))
    return;
  const r = n.firstChild;
  if (r != null && gu(r) && (r.tagName === "UL" || r.tagName === "OL"))
    return;
  const i = n.parentNode;
  if (!i || i.__lexicalListType !== "check")
    return;
  const o = n.getBoundingClientRect(), a = t.pageX / VXe(n);
  (n.dir === "rtl" ? a < o.right && a > o.right - 20 : a > o.left && a < o.left + 20) && e();
}
function _L(t) {
  MQ(t, () => {
    if (t.target instanceof HTMLElement) {
      const e = t.target, n = qT(e);
      n != null && n.isEditable() && n.update(() => {
        const r = hu(e);
        jn(r) && (e.focus(), r.toggleChecked());
      });
    }
  });
}
function AL(t) {
  MQ(t, () => {
    t.preventDefault();
  });
}
function K4() {
  const t = document.activeElement;
  return t != null && t.tagName === "LI" && t.parentNode != null && t.parentNode.__lexicalListType === "check" ? t : null;
}
function TL(t, e, n) {
  const r = K4();
  return r != null && e.update(() => {
    const i = hu(r);
    if (!jn(i))
      return;
    const o = function(a, s) {
      let u = s ? a.getPreviousSibling() : a.getNextSibling(), l = a;
      for (; u == null && jn(l); )
        l = l.getParentOrThrow().getParent(), l != null && (u = s ? l.getPreviousSibling() : l.getNextSibling());
      for (; jn(u); ) {
        const c = s ? u.getLastChild() : u.getFirstChild();
        if (!wn(c))
          return u;
        u = s ? c.getLastChild() : c.getFirstChild();
      }
      return null;
    }(i, n);
    if (o != null) {
      o.selectStart();
      const a = e.getElementByKey(o.__key);
      a != null && (t.preventDefault(), setTimeout(() => {
        a.focus();
      }, 0));
    }
  }), !1;
}
function OL() {
  const [t] = Vo();
  return Re(() => {
    if (!t.hasNodes([Ev, wv]))
      throw new Error("ListPlugin: ListNode and/or ListItemNode not registered on editor");
  }, [t]), function(e) {
    Re(() => xa(e.registerCommand(RQ, () => (J4(e, "number"), !0), Ar), e.registerCommand(kQ, () => (J4(e, "bullet"), !0), Ar), e.registerCommand(DQ, () => (snt(e), !0), Ar), e.registerCommand(um, () => !!cnt(), Ar)), [e]);
  }(t), null;
}
const ynt = {
  tokenize: Cnt
};
function xnt() {
  return {
    text: {
      91: ynt
    }
  };
}
function Cnt(t, e, n) {
  const r = this;
  return i;
  function i(u) {
    return (
      // Exit if there’s stuff before.
      r.previous !== null || // Exit if not in the first content that is the first child of a list
      // item.
      !r._gfmTasklistFirstContentOfListItem ? n(u) : (t.enter("taskListCheck"), t.enter("taskListCheckMarker"), t.consume(u), t.exit("taskListCheckMarker"), o)
    );
  }
  function o(u) {
    return Br(u) ? (t.enter("taskListCheckValueUnchecked"), t.consume(u), t.exit("taskListCheckValueUnchecked"), a) : u === 88 || u === 120 ? (t.enter("taskListCheckValueChecked"), t.consume(u), t.exit("taskListCheckValueChecked"), a) : n(u);
  }
  function a(u) {
    return u === 93 ? (t.enter("taskListCheckMarker"), t.consume(u), t.exit("taskListCheckMarker"), t.exit("taskListCheck"), s) : n(u);
  }
  function s(u) {
    return Dt(u) ? e(u) : Cn(u) ? t.check(
      {
        tokenize: wnt
      },
      e,
      n
    )(u) : n(u);
  }
}
function wnt(t, e, n) {
  return Bn(t, r, "whitespace");
  function r(i) {
    return i === null ? n(i) : e(i);
  }
}
function Ent() {
  return {
    exit: {
      taskListCheckValueChecked: PL,
      taskListCheckValueUnchecked: PL,
      paragraph: Int
    }
  };
}
function Snt() {
  return {
    unsafe: [{ atBreak: !0, character: "-", after: "[:|-]" }],
    handlers: { listItem: _nt }
  };
}
function PL(t) {
  const e = this.stack[this.stack.length - 2];
  e.type, e.checked = t.type === "taskListCheckValueChecked";
}
function Int(t) {
  const e = this.stack[this.stack.length - 2];
  if (e && e.type === "listItem" && typeof e.checked == "boolean") {
    const n = this.stack[this.stack.length - 1];
    n.type;
    const r = n.children[0];
    if (r && r.type === "text") {
      const i = e.children;
      let o = -1, a;
      for (; ++o < i.length; ) {
        const s = i[o];
        if (s.type === "paragraph") {
          a = s;
          break;
        }
      }
      a === n && (r.value = r.value.slice(1), r.value.length === 0 ? n.children.shift() : n.position && r.position && typeof r.position.start.offset == "number" && (r.position.start.column++, r.position.start.offset++, n.position.start = Object.assign({}, r.position.start)));
    }
  }
  this.exit(t);
}
function _nt(t, e, n, r) {
  const i = t.children[0], o = typeof t.checked == "boolean" && i && i.type === "paragraph", a = "[" + (t.checked ? "x" : " ") + "] ", s = n.createTracker(r);
  o && s.move(a);
  let u = xO.listItem(t, e, n, {
    ...r,
    ...s.current()
  });
  return o && (u = u.replace(/^(?:[*+-]|\d+\.)([\r\n]| {1,3})/, l)), u;
  function l(c) {
    return c + a;
  }
}
const Ant = /* @__PURE__ */ new Map([
  ["number", RQ],
  ["bullet", kQ],
  ["check", $Q],
  ["", DQ]
]), q4 = Ht("", (t) => {
  t.sub(t.pipe(fp, Zr(hi)), ([e, n]) => {
    if (!e || !n)
      return;
    const r = e.anchor.getNode();
    let i = r.getKey() === "root" ? r : Hp(r, (s) => {
      const u = s.getParent();
      return u !== null && Oi(u);
    });
    i === null && (i = r.getTopLevelElementOrThrow());
    const o = i.getKey();
    if (n.getElementByKey(o) !== null)
      if (wn(i)) {
        const s = HK(r, Ev), u = s ? s.getListType() : i.getListType();
        t.pub(q4, u);
      } else
        t.pub(q4, "");
  });
}), FQ = Ei((t) => {
  t.sub(t.pipe(FQ, Zr(hi)), ([e, n]) => {
    n == null || n.dispatchCommand(Ant.get(e), void 0);
  });
}), Tnt = pl({
  init(t) {
    var e;
    (e = t.getValue(vl)) == null || e.registerCommand(RT, () => !Pnt(7), vc), t.pubIn({
      [PO]: "lists",
      [x2]: Ent(),
      [y2]: xnt(),
      [bc]: [pnt, gnt],
      [cf]: [wv, Ev],
      [df]: [mnt, vnt],
      [AO]: Snt(),
      [jp]: [SL, OL, IL],
      [CQe]: [SL, OL, IL]
    });
  }
});
function Ont(t) {
  const e = t.getNodes();
  return e.length === 0 ? /* @__PURE__ */ new Set([t.anchor.getNode().getParentOrThrow(), t.focus.getNode().getParentOrThrow()]) : new Set(e.map((n) => We(n) ? n : n.getParentOrThrow()));
}
function Pnt(t) {
  const e = vt();
  if (!rt(e))
    return !1;
  const n = Ont(e);
  let r = 0;
  for (const i of n)
    if (wn(i))
      r = Math.max(Y4(i) + 1, r);
    else if (jn(i)) {
      const o = i.getParent();
      if ((o == null ? void 0 : o.getChildren().length) === 1) {
        const a = o.getParent();
        if (jn(a) && a.getChildren().length === 1)
          return !1;
      }
      if (!wn(o))
        throw new Error("ListMaxIndentLevelPlugin: A ListItemNode must have a ListNode for a parent.");
      r = Math.max(Y4(o) + 1, r);
    }
  return r <= t;
}
function Nnt(t, e = {}) {
  const n = (e.align || []).concat(), r = e.stringLength || Rnt, i = [], o = [], a = [], s = [];
  let u = 0, l = -1;
  for (; ++l < t.length; ) {
    const p = [], v = [];
    let m = -1;
    for (t[l].length > u && (u = t[l].length); ++m < t[l].length; ) {
      const b = knt(t[l][m]);
      if (e.alignDelimiters !== !1) {
        const y = r(b);
        v[m] = y, (s[m] === void 0 || y > s[m]) && (s[m] = y);
      }
      p.push(b);
    }
    o[l] = p, a[l] = v;
  }
  let c = -1;
  if (typeof n == "object" && "length" in n)
    for (; ++c < u; )
      i[c] = NL(n[c]);
  else {
    const p = NL(n);
    for (; ++c < u; )
      i[c] = p;
  }
  c = -1;
  const d = [], f = [];
  for (; ++c < u; ) {
    const p = i[c];
    let v = "", m = "";
    p === 99 ? (v = ":", m = ":") : p === 108 ? v = ":" : p === 114 && (m = ":");
    let b = e.alignDelimiters === !1 ? 1 : Math.max(
      1,
      s[c] - v.length - m.length
    );
    const y = v + "-".repeat(b) + m;
    e.alignDelimiters !== !1 && (b = v.length + b + m.length, b > s[c] && (s[c] = b), f[c] = b), d[c] = y;
  }
  o.splice(1, 0, d), a.splice(1, 0, f), l = -1;
  const h = [];
  for (; ++l < o.length; ) {
    const p = o[l], v = a[l];
    c = -1;
    const m = [];
    for (; ++c < u; ) {
      const b = p[c] || "";
      let y = "", w = "";
      if (e.alignDelimiters !== !1) {
        const S = s[c] - (v[c] || 0), E = i[c];
        E === 114 ? y = " ".repeat(S) : E === 99 ? S % 2 ? (y = " ".repeat(S / 2 + 0.5), w = " ".repeat(S / 2 - 0.5)) : (y = " ".repeat(S / 2), w = y) : w = " ".repeat(S);
      }
      e.delimiterStart !== !1 && !c && m.push("|"), e.padding !== !1 && // Don’t add the opening space if we’re not aligning and the cell is
      // empty: there will be a closing space.
      !(e.alignDelimiters === !1 && b === "") && (e.delimiterStart !== !1 || c) && m.push(" "), e.alignDelimiters !== !1 && m.push(y), m.push(b), e.alignDelimiters !== !1 && m.push(w), e.padding !== !1 && m.push(" "), (e.delimiterEnd !== !1 || c !== u - 1) && m.push("|");
    }
    h.push(
      e.delimiterEnd === !1 ? m.join("").replace(/ +$/, "") : m.join("")
    );
  }
  return h.join(`
`);
}
function knt(t) {
  return t == null ? "" : String(t);
}
function Rnt(t) {
  return t.length;
}
function NL(t) {
  const e = typeof t == "string" ? t.codePointAt(0) : 0;
  return e === 67 || e === 99 ? 99 : e === 76 || e === 108 ? 108 : e === 82 || e === 114 ? 114 : 0;
}
function $nt() {
  return {
    enter: {
      table: Dnt,
      tableData: kL,
      tableHeader: kL,
      tableRow: Fnt
    },
    exit: {
      codeText: Lnt,
      table: Mnt,
      tableData: p5,
      tableHeader: p5,
      tableRow: p5
    }
  };
}
function Dnt(t) {
  const e = t._align;
  this.enter(
    {
      type: "table",
      align: e.map(function(n) {
        return n === "none" ? null : n;
      }),
      children: []
    },
    t
  ), this.data.inTable = !0;
}
function Mnt(t) {
  this.exit(t), this.data.inTable = void 0;
}
function Fnt(t) {
  this.enter({ type: "tableRow", children: [] }, t);
}
function p5(t) {
  this.exit(t);
}
function kL(t) {
  this.enter({ type: "tableCell", children: [] }, t);
}
function Lnt(t) {
  let e = this.resume();
  this.data.inTable && (e = e.replace(/\\([\\|])/g, Vnt));
  const n = this.stack[this.stack.length - 1];
  n.type, n.value = e, this.exit(t);
}
function Vnt(t, e) {
  return e === "|" ? e : t;
}
function Bnt(t) {
  const e = t || {}, n = e.tableCellPadding, r = e.tablePipeAlign, i = e.stringLength, o = n ? " " : "|";
  return {
    unsafe: [
      { character: "\r", inConstruct: "tableCell" },
      { character: `
`, inConstruct: "tableCell" },
      // A pipe, when followed by a tab or space (padding), or a dash or colon
      // (unpadded delimiter row), could result in a table.
      { atBreak: !0, character: "|", after: "[	 :-]" },
      // A pipe in a cell must be encoded.
      { character: "|", inConstruct: "tableCell" },
      // A colon must be followed by a dash, in which case it could start a
      // delimiter row.
      { atBreak: !0, character: ":", after: "-" },
      // A delimiter row can also start with a dash, when followed by more
      // dashes, a colon, or a pipe.
      // This is a stricter version than the built in check for lists, thematic
      // breaks, and setex heading underlines though:
      // <https://github.com/syntax-tree/mdast-util-to-markdown/blob/51a2038/lib/unsafe.js#L57>
      { atBreak: !0, character: "-", after: "[:|-]" }
    ],
    handlers: {
      inlineCode: f,
      table: a,
      tableCell: u,
      tableRow: s
    }
  };
  function a(h, p, v, m) {
    return l(c(h, v, m), h.align);
  }
  function s(h, p, v, m) {
    const b = d(h, v, m), y = l([b]);
    return y.slice(0, y.indexOf(`
`));
  }
  function u(h, p, v, m) {
    const b = v.enter("tableCell"), y = v.enter("phrasing"), w = v.containerPhrasing(h, {
      ...m,
      before: o,
      after: o
    });
    return y(), b(), w;
  }
  function l(h, p) {
    return Nnt(h, {
      align: p,
      // @ts-expect-error: `markdown-table` types should support `null`.
      alignDelimiters: r,
      // @ts-expect-error: `markdown-table` types should support `null`.
      padding: n,
      // @ts-expect-error: `markdown-table` types should support `null`.
      stringLength: i
    });
  }
  function c(h, p, v) {
    const m = h.children;
    let b = -1;
    const y = [], w = p.enter("table");
    for (; ++b < m.length; )
      y[b] = d(m[b], p, v);
    return w(), y;
  }
  function d(h, p, v) {
    const m = h.children;
    let b = -1;
    const y = [], w = p.enter("tableRow");
    for (; ++b < m.length; )
      y[b] = u(m[b], h, p, v);
    return w(), y;
  }
  function f(h, p, v) {
    let m = xO.inlineCode(h, p, v);
    return v.stack.includes("tableCell") && (m = m.replace(/\|/g, "\\$&")), m;
  }
}
class Hnt {
  /**
   * Create a new edit map.
   */
  constructor() {
    this.map = [];
  }
  /**
   * Create an edit: a remove and/or add at a certain place.
   *
   * @param {number} index
   * @param {number} remove
   * @param {Array<Event>} add
   * @returns {undefined}
   */
  add(e, n, r) {
    Wnt(this, e, n, r);
  }
  // To do: add this when moving to `micromark`.
  // /**
  //  * Create an edit: but insert `add` before existing additions.
  //  *
  //  * @param {number} index
  //  * @param {number} remove
  //  * @param {Array<Event>} add
  //  * @returns {undefined}
  //  */
  // addBefore(index, remove, add) {
  //   addImpl(this, index, remove, add, true)
  // }
  /**
   * Done, change the events.
   *
   * @param {Array<Event>} events
   * @returns {undefined}
   */
  consume(e) {
    if (this.map.sort(function(o, a) {
      return o[0] - a[0];
    }), this.map.length === 0)
      return;
    let n = this.map.length;
    const r = [];
    for (; n > 0; )
      n -= 1, r.push(
        e.slice(this.map[n][0] + this.map[n][1]),
        this.map[n][2]
      ), e.length = this.map[n][0];
    r.push([...e]), e.length = 0;
    let i = r.pop();
    for (; i; )
      e.push(...i), i = r.pop();
    this.map.length = 0;
  }
}
function Wnt(t, e, n, r) {
  let i = 0;
  if (!(n === 0 && r.length === 0)) {
    for (; i < t.map.length; ) {
      if (t.map[i][0] === e) {
        t.map[i][1] += n, t.map[i][2].push(...r);
        return;
      }
      i += 1;
    }
    t.map.push([e, n, r]);
  }
}
function jnt(t, e) {
  let n = !1;
  const r = [];
  for (; e < t.length; ) {
    const i = t[e];
    if (n) {
      if (i[0] === "enter")
        i[1].type === "tableContent" && r.push(
          t[e + 1][1].type === "tableDelimiterMarker" ? "left" : "none"
        );
      else if (i[1].type === "tableContent") {
        if (t[e - 1][1].type === "tableDelimiterMarker") {
          const o = r.length - 1;
          r[o] = r[o] === "left" ? "center" : "right";
        }
      } else if (i[1].type === "tableDelimiterRow")
        break;
    } else
      i[0] === "enter" && i[1].type === "tableDelimiterRow" && (n = !0);
    e += 1;
  }
  return r;
}
function znt() {
  return {
    flow: {
      null: {
        tokenize: Gnt,
        resolveAll: Unt
      }
    }
  };
}
function Gnt(t, e, n) {
  const r = this;
  let i = 0, o = 0, a;
  return s;
  function s(N) {
    let k = r.events.length - 1;
    for (; k > -1; ) {
      const V = r.events[k][1].type;
      if (V === "lineEnding" || // Note: markdown-rs uses `whitespace` instead of `linePrefix`
      V === "linePrefix")
        k--;
      else
        break;
    }
    const D = k > -1 ? r.events[k][1].type : null, R = D === "tableHead" || D === "tableRow" ? I : u;
    return R === I && r.parser.lazy[r.now().line] ? n(N) : R(N);
  }
  function u(N) {
    return t.enter("tableHead"), t.enter("tableRow"), l(N);
  }
  function l(N) {
    return N === 124 || (a = !0, o += 1), c(N);
  }
  function c(N) {
    return N === null ? n(N) : Dt(N) ? o > 1 ? (o = 0, r.interrupt = !0, t.exit("tableRow"), t.enter("lineEnding"), t.consume(N), t.exit("lineEnding"), h) : n(N) : Cn(N) ? Bn(t, c, "whitespace")(N) : (o += 1, a && (a = !1, i += 1), N === 124 ? (t.enter("tableCellDivider"), t.consume(N), t.exit("tableCellDivider"), a = !0, c) : (t.enter("data"), d(N)));
  }
  function d(N) {
    return N === null || N === 124 || Br(N) ? (t.exit("data"), c(N)) : (t.consume(N), N === 92 ? f : d);
  }
  function f(N) {
    return N === 92 || N === 124 ? (t.consume(N), d) : d(N);
  }
  function h(N) {
    return r.interrupt = !1, r.parser.lazy[r.now().line] ? n(N) : (t.enter("tableDelimiterRow"), a = !1, Cn(N) ? Bn(
      t,
      p,
      "linePrefix",
      r.parser.constructs.disable.null.includes("codeIndented") ? void 0 : 4
    )(N) : p(N));
  }
  function p(N) {
    return N === 45 || N === 58 ? m(N) : N === 124 ? (a = !0, t.enter("tableCellDivider"), t.consume(N), t.exit("tableCellDivider"), v) : E(N);
  }
  function v(N) {
    return Cn(N) ? Bn(t, m, "whitespace")(N) : m(N);
  }
  function m(N) {
    return N === 58 ? (o += 1, a = !0, t.enter("tableDelimiterMarker"), t.consume(N), t.exit("tableDelimiterMarker"), b) : N === 45 ? (o += 1, b(N)) : N === null || Dt(N) ? S(N) : E(N);
  }
  function b(N) {
    return N === 45 ? (t.enter("tableDelimiterFiller"), y(N)) : E(N);
  }
  function y(N) {
    return N === 45 ? (t.consume(N), y) : N === 58 ? (a = !0, t.exit("tableDelimiterFiller"), t.enter("tableDelimiterMarker"), t.consume(N), t.exit("tableDelimiterMarker"), w) : (t.exit("tableDelimiterFiller"), w(N));
  }
  function w(N) {
    return Cn(N) ? Bn(t, S, "whitespace")(N) : S(N);
  }
  function S(N) {
    return N === 124 ? p(N) : N === null || Dt(N) ? !a || i !== o ? E(N) : (t.exit("tableDelimiterRow"), t.exit("tableHead"), e(N)) : E(N);
  }
  function E(N) {
    return n(N);
  }
  function I(N) {
    return t.enter("tableRow"), _(N);
  }
  function _(N) {
    return N === 124 ? (t.enter("tableCellDivider"), t.consume(N), t.exit("tableCellDivider"), _) : N === null || Dt(N) ? (t.exit("tableRow"), e(N)) : Cn(N) ? Bn(t, _, "whitespace")(N) : (t.enter("data"), A(N));
  }
  function A(N) {
    return N === null || N === 124 || Br(N) ? (t.exit("data"), _(N)) : (t.consume(N), N === 92 ? P : A);
  }
  function P(N) {
    return N === 92 || N === 124 ? (t.consume(N), A) : A(N);
  }
}
function Unt(t, e) {
  let n = -1, r = !0, i = 0, o = [0, 0, 0, 0], a = [0, 0, 0, 0], s = !1, u = 0, l, c, d;
  const f = new Hnt();
  for (; ++n < t.length; ) {
    const h = t[n], p = h[1];
    h[0] === "enter" ? p.type === "tableHead" ? (s = !1, u !== 0 && (RL(f, e, u, l, c), c = void 0, u = 0), l = {
      type: "table",
      start: Object.assign({}, p.start),
      // Note: correct end is set later.
      end: Object.assign({}, p.end)
    }, f.add(n, 0, [["enter", l, e]])) : p.type === "tableRow" || p.type === "tableDelimiterRow" ? (r = !0, d = void 0, o = [0, 0, 0, 0], a = [0, n + 1, 0, 0], s && (s = !1, c = {
      type: "tableBody",
      start: Object.assign({}, p.start),
      // Note: correct end is set later.
      end: Object.assign({}, p.end)
    }, f.add(n, 0, [["enter", c, e]])), i = p.type === "tableDelimiterRow" ? 2 : c ? 3 : 1) : i && (p.type === "data" || p.type === "tableDelimiterMarker" || p.type === "tableDelimiterFiller") ? (r = !1, a[2] === 0 && (o[1] !== 0 && (a[0] = a[1], d = Mb(
      f,
      e,
      o,
      i,
      void 0,
      d
    ), o = [0, 0, 0, 0]), a[2] = n)) : p.type === "tableCellDivider" && (r ? r = !1 : (o[1] !== 0 && (a[0] = a[1], d = Mb(
      f,
      e,
      o,
      i,
      void 0,
      d
    )), o = a, a = [o[1], n, 0, 0])) : p.type === "tableHead" ? (s = !0, u = n) : p.type === "tableRow" || p.type === "tableDelimiterRow" ? (u = n, o[1] !== 0 ? (a[0] = a[1], d = Mb(
      f,
      e,
      o,
      i,
      n,
      d
    )) : a[1] !== 0 && (d = Mb(f, e, a, i, n, d)), i = 0) : i && (p.type === "data" || p.type === "tableDelimiterMarker" || p.type === "tableDelimiterFiller") && (a[3] = n);
  }
  for (u !== 0 && RL(f, e, u, l, c), f.consume(e.events), n = -1; ++n < e.events.length; ) {
    const h = e.events[n];
    h[0] === "enter" && h[1].type === "table" && (h[1]._align = jnt(e.events, n));
  }
  return t;
}
function Mb(t, e, n, r, i, o) {
  const a = r === 1 ? "tableHeader" : r === 2 ? "tableDelimiter" : "tableData", s = "tableContent";
  n[0] !== 0 && (o.end = Object.assign({}, wh(e.events, n[0])), t.add(n[0], 0, [["exit", o, e]]));
  const u = wh(e.events, n[1]);
  if (o = {
    type: a,
    start: Object.assign({}, u),
    // Note: correct end is set later.
    end: Object.assign({}, u)
  }, t.add(n[1], 0, [["enter", o, e]]), n[2] !== 0) {
    const l = wh(e.events, n[2]), c = wh(e.events, n[3]), d = {
      type: s,
      start: Object.assign({}, l),
      end: Object.assign({}, c)
    };
    if (t.add(n[2], 0, [["enter", d, e]]), r !== 2) {
      const f = e.events[n[2]], h = e.events[n[3]];
      if (f[1].end = Object.assign({}, h[1].end), f[1].type = "chunkText", f[1].contentType = "text", n[3] > n[2] + 1) {
        const p = n[2] + 1, v = n[3] - n[2] - 1;
        t.add(p, v, []);
      }
    }
    t.add(n[3] + 1, 0, [["exit", d, e]]);
  }
  return i !== void 0 && (o.end = Object.assign({}, wh(e.events, i)), t.add(i, 0, [["exit", o, e]]), o = void 0), o;
}
function RL(t, e, n, r, i) {
  const o = [], a = wh(e.events, n);
  i && (i.end = Object.assign({}, a), o.push(["exit", i, e])), r.end = Object.assign({}, a), o.push(["exit", r, e]), t.add(n + 1, 0, o);
}
function wh(t, e) {
  const n = t[e], r = n[0] === "enter" ? "start" : "end";
  return n[1][r];
}
const $L = [["Cat", "rgb(125, 50, 0)"], ["Dog", "rgb(100, 0, 0)"], ["Rabbit", "rgb(150, 0, 0)"], ["Frog", "rgb(200, 0, 0)"], ["Fox", "rgb(200, 75, 0)"], ["Hedgehog", "rgb(0, 75, 0)"], ["Pigeon", "rgb(0, 125, 0)"], ["Squirrel", "rgb(75, 100, 0)"], ["Bear", "rgb(125, 100, 0)"], ["Tiger", "rgb(0, 0, 150)"], ["Leopard", "rgb(0, 0, 200)"], ["Zebra", "rgb(0, 0, 250)"], ["Wolf", "rgb(0, 100, 150)"], ["Owl", "rgb(0, 100, 100)"], ["Gull", "rgb(100, 0, 100)"], ["Squid", "rgb(150, 0, 150)"]], DL = $L[Math.floor(Math.random() * $L.length)], Xnt = oi({ clientID: 0, color: DL[1], isCollabActive: !1, name: DL[0], yjsDocMap: /* @__PURE__ */ new Map() });
function Ynt(t, e) {
  const n = fn(Xnt);
  return t != null && (n.name = t), e != null && (n.color = e), n;
}
function Znt(t) {
  return t && t.__esModule && Object.prototype.hasOwnProperty.call(t, "default") ? t.default : t;
}
var Jnt = Znt(function(t) {
  const e = new URLSearchParams();
  e.append("code", t);
  for (let n = 1; n < arguments.length; n++)
    e.append("v", arguments[n]);
  throw Error(`Minified Lexical error #${t}; visit https://lexical.dev/docs/error?${e} for the full message or use the non-minified dev environment for full errors and additional helpful warnings.`);
});
function ML(t) {
  const e = t.transform();
  return e !== null ? /* @__PURE__ */ new Set([e]) : /* @__PURE__ */ new Set();
}
function Knt({ initialEditor: t, children: e, initialNodes: n, initialTheme: r, skipCollabChecks: i }) {
  const o = Ee(!1), a = fn(Qx);
  a == null && Jnt(9);
  const [s, { getTheme: u }] = a, l = Rn(() => {
    const h = r || u() || void 0, p = HJ(a, h);
    if (h !== void 0 && (t._config.theme = h), t._parentEditor = s, n)
      for (let v of n) {
        let m = null, b = null;
        if (typeof v != "function") {
          const w = v;
          v = w.replace, m = w.with, b = w.withKlass || null;
        }
        const y = t._nodes.get(v.getType());
        t._nodes.set(v.getType(), { exportDOM: y ? y.exportDOM : void 0, klass: v, replace: m, replaceWithKlass: b, transforms: ML(v) });
      }
    else {
      const v = t._nodes = new Map(s._nodes);
      for (const [m, b] of v)
        t._nodes.set(m, { exportDOM: b.exportDOM, klass: b.klass, replace: b.replace, replaceWithKlass: b.replaceWithKlass, transforms: ML(b.klass) });
    }
    return t._config.namespace = s._config.namespace, t._editable = s._editable, [t, p];
  }, []), { isCollabActive: c, yjsDocMap: d } = Ynt(), f = i || o.current || d.has(t.getKey());
  return Re(() => {
    f && (o.current = !0);
  }, [f]), Re(() => s.registerEditableListener((h) => {
    t.setEditable(h);
  }), [t, s]), Oe.jsx(Qx.Provider, { value: l, children: !c || f ? e : null });
}
function ln(t, e, { checkForDefaultPrevented: n = !0 } = {}) {
  return function(i) {
    if (t == null || t(i), n === !1 || !i.defaultPrevented)
      return e == null ? void 0 : e(i);
  };
}
function qnt(t, e) {
  typeof t == "function" ? t(e) : t != null && (t.current = e);
}
function LQ(...t) {
  return (e) => t.forEach(
    (n) => qnt(n, e)
  );
}
function Kn(...t) {
  return et(LQ(...t), t);
}
function Vs(t, e = []) {
  let n = [];
  function r(o, a) {
    const s = /* @__PURE__ */ oi(a), u = n.length;
    n = [
      ...n,
      a
    ];
    function l(d) {
      const { scope: f, children: h, ...p } = d, v = (f == null ? void 0 : f[t][u]) || s, m = Rn(
        () => p,
        Object.values(p)
      );
      return /* @__PURE__ */ Pe(v.Provider, {
        value: m
      }, h);
    }
    function c(d, f) {
      const h = (f == null ? void 0 : f[t][u]) || s, p = fn(h);
      if (p)
        return p;
      if (a !== void 0)
        return a;
      throw new Error(`\`${d}\` must be used within \`${o}\``);
    }
    return l.displayName = o + "Provider", [
      l,
      c
    ];
  }
  const i = () => {
    const o = n.map((a) => /* @__PURE__ */ oi(a));
    return function(s) {
      const u = (s == null ? void 0 : s[t]) || o;
      return Rn(
        () => ({
          [`__scope${t}`]: {
            ...s,
            [t]: u
          }
        }),
        [
          s,
          u
        ]
      );
    };
  };
  return i.scopeName = t, [
    r,
    Qnt(i, ...e)
  ];
}
function Qnt(...t) {
  const e = t[0];
  if (t.length === 1)
    return e;
  const n = () => {
    const r = t.map(
      (i) => ({
        useScope: i(),
        scopeName: i.scopeName
      })
    );
    return function(o) {
      const a = r.reduce((s, { useScope: u, scopeName: l }) => {
        const d = u(o)[`__scope${l}`];
        return {
          ...s,
          ...d
        };
      }, {});
      return Rn(
        () => ({
          [`__scope${e.scopeName}`]: a
        }),
        [
          a
        ]
      );
    };
  };
  return n.scopeName = e.scopeName, n;
}
const Hd = /* @__PURE__ */ gt((t, e) => {
  const { children: n, ...r } = t, i = za.toArray(n), o = i.find(ert);
  if (o) {
    const a = o.props.children, s = i.map((u) => u === o ? za.count(a) > 1 ? za.only(null) : /* @__PURE__ */ Od(a) ? a.props.children : null : u);
    return /* @__PURE__ */ Pe(Q4, G({}, r, {
      ref: e
    }), /* @__PURE__ */ Od(a) ? /* @__PURE__ */ Is(a, void 0, s) : null);
  }
  return /* @__PURE__ */ Pe(Q4, G({}, r, {
    ref: e
  }), n);
});
Hd.displayName = "Slot";
const Q4 = /* @__PURE__ */ gt((t, e) => {
  const { children: n, ...r } = t;
  return /* @__PURE__ */ Od(n) ? /* @__PURE__ */ Is(n, {
    ...trt(r, n.props),
    ref: e ? LQ(e, n.ref) : n.ref
  }) : za.count(n) > 1 ? za.only(null) : null;
});
Q4.displayName = "SlotClone";
const VQ = ({ children: t }) => /* @__PURE__ */ Pe(ha, null, t);
function ert(t) {
  return /* @__PURE__ */ Od(t) && t.type === VQ;
}
function trt(t, e) {
  const n = {
    ...e
  };
  for (const r in e) {
    const i = t[r], o = e[r];
    /^on[A-Z]/.test(r) ? i && o ? n[r] = (...s) => {
      o(...s), i(...s);
    } : i && (n[r] = i) : r === "style" ? n[r] = {
      ...i,
      ...o
    } : r === "className" && (n[r] = [
      i,
      o
    ].filter(Boolean).join(" "));
  }
  return {
    ...t,
    ...n
  };
}
const nrt = [
  "a",
  "button",
  "div",
  "form",
  "h2",
  "h3",
  "img",
  "input",
  "label",
  "li",
  "nav",
  "ol",
  "p",
  "span",
  "svg",
  "ul"
], Sn = nrt.reduce((t, e) => {
  const n = /* @__PURE__ */ gt((r, i) => {
    const { asChild: o, ...a } = r, s = o ? Hd : e;
    return Re(() => {
      window[Symbol.for("radix-ui")] = !0;
    }, []), /* @__PURE__ */ Pe(s, G({}, a, {
      ref: i
    }));
  });
  return n.displayName = `Primitive.${e}`, {
    ...t,
    [e]: n
  };
}, {});
function Fw(t, e) {
  t && sc(
    () => t.dispatchEvent(e)
  );
}
function Kr(t) {
  const e = Ee(t);
  return Re(() => {
    e.current = t;
  }), Rn(
    () => (...n) => {
      var r;
      return (r = e.current) === null || r === void 0 ? void 0 : r.call(e, ...n);
    },
    []
  );
}
function Lw(t, e = globalThis == null ? void 0 : globalThis.document) {
  const n = Kr(t);
  Re(() => {
    const r = (i) => {
      i.key === "Escape" && n(i);
    };
    return e.addEventListener("keydown", r), () => e.removeEventListener("keydown", r);
  }, [
    n,
    e
  ]);
}
const e6 = "dismissableLayer.update", rrt = "dismissableLayer.pointerDownOutside", irt = "dismissableLayer.focusOutside";
let FL;
const ort = /* @__PURE__ */ oi({
  layers: /* @__PURE__ */ new Set(),
  layersWithOutsidePointerEventsDisabled: /* @__PURE__ */ new Set(),
  branches: /* @__PURE__ */ new Set()
}), art = /* @__PURE__ */ gt((t, e) => {
  var n;
  const { disableOutsidePointerEvents: r = !1, onEscapeKeyDown: i, onPointerDownOutside: o, onFocusOutside: a, onInteractOutside: s, onDismiss: u, ...l } = t, c = fn(ort), [d, f] = Le(null), h = (n = d == null ? void 0 : d.ownerDocument) !== null && n !== void 0 ? n : globalThis == null ? void 0 : globalThis.document, [, p] = Le({}), v = Kn(
    e,
    (A) => f(A)
  ), m = Array.from(c.layers), [b] = [
    ...c.layersWithOutsidePointerEventsDisabled
  ].slice(-1), y = m.indexOf(b), w = d ? m.indexOf(d) : -1, S = c.layersWithOutsidePointerEventsDisabled.size > 0, E = w >= y, I = srt((A) => {
    const P = A.target, N = [
      ...c.branches
    ].some(
      (k) => k.contains(P)
    );
    !E || N || (o == null || o(A), s == null || s(A), A.defaultPrevented || u == null || u());
  }, h), _ = urt((A) => {
    const P = A.target;
    [
      ...c.branches
    ].some(
      (k) => k.contains(P)
    ) || (a == null || a(A), s == null || s(A), A.defaultPrevented || u == null || u());
  }, h);
  return Lw((A) => {
    w === c.layers.size - 1 && (i == null || i(A), !A.defaultPrevented && u && (A.preventDefault(), u()));
  }, h), Re(() => {
    if (d)
      return r && (c.layersWithOutsidePointerEventsDisabled.size === 0 && (FL = h.body.style.pointerEvents, h.body.style.pointerEvents = "none"), c.layersWithOutsidePointerEventsDisabled.add(d)), c.layers.add(d), LL(), () => {
        r && c.layersWithOutsidePointerEventsDisabled.size === 1 && (h.body.style.pointerEvents = FL);
      };
  }, [
    d,
    h,
    r,
    c
  ]), Re(() => () => {
    d && (c.layers.delete(d), c.layersWithOutsidePointerEventsDisabled.delete(d), LL());
  }, [
    d,
    c
  ]), Re(() => {
    const A = () => p({});
    return document.addEventListener(e6, A), () => document.removeEventListener(e6, A);
  }, []), /* @__PURE__ */ Pe(Sn.div, G({}, l, {
    ref: v,
    style: {
      pointerEvents: S ? E ? "auto" : "none" : void 0,
      ...t.style
    },
    onFocusCapture: ln(t.onFocusCapture, _.onFocusCapture),
    onBlurCapture: ln(t.onBlurCapture, _.onBlurCapture),
    onPointerDownCapture: ln(t.onPointerDownCapture, I.onPointerDownCapture)
  }));
});
function srt(t, e = globalThis == null ? void 0 : globalThis.document) {
  const n = Kr(t), r = Ee(!1), i = Ee(() => {
  });
  return Re(() => {
    const o = (s) => {
      if (s.target && !r.current) {
        let l = function() {
          BQ(rrt, n, u, {
            discrete: !0
          });
        };
        const u = {
          originalEvent: s
        };
        s.pointerType === "touch" ? (e.removeEventListener("click", i.current), i.current = l, e.addEventListener("click", i.current, {
          once: !0
        })) : l();
      } else
        e.removeEventListener("click", i.current);
      r.current = !1;
    }, a = window.setTimeout(() => {
      e.addEventListener("pointerdown", o);
    }, 0);
    return () => {
      window.clearTimeout(a), e.removeEventListener("pointerdown", o), e.removeEventListener("click", i.current);
    };
  }, [
    e,
    n
  ]), {
    // ensures we check React component tree (not just DOM tree)
    onPointerDownCapture: () => r.current = !0
  };
}
function urt(t, e = globalThis == null ? void 0 : globalThis.document) {
  const n = Kr(t), r = Ee(!1);
  return Re(() => {
    const i = (o) => {
      o.target && !r.current && BQ(irt, n, {
        originalEvent: o
      }, {
        discrete: !1
      });
    };
    return e.addEventListener("focusin", i), () => e.removeEventListener("focusin", i);
  }, [
    e,
    n
  ]), {
    onFocusCapture: () => r.current = !0,
    onBlurCapture: () => r.current = !1
  };
}
function LL() {
  const t = new CustomEvent(e6);
  document.dispatchEvent(t);
}
function BQ(t, e, n, { discrete: r }) {
  const i = n.originalEvent.target, o = new CustomEvent(t, {
    bubbles: !1,
    cancelable: !0,
    detail: n
  });
  e && i.addEventListener(t, e, {
    once: !0
  }), r ? Fw(i, o) : i.dispatchEvent(o);
}
let g5 = 0;
function $O() {
  Re(() => {
    var t, e;
    const n = document.querySelectorAll("[data-radix-focus-guard]");
    return document.body.insertAdjacentElement("afterbegin", (t = n[0]) !== null && t !== void 0 ? t : VL()), document.body.insertAdjacentElement("beforeend", (e = n[1]) !== null && e !== void 0 ? e : VL()), g5++, () => {
      g5 === 1 && document.querySelectorAll("[data-radix-focus-guard]").forEach(
        (r) => r.remove()
      ), g5--;
    };
  }, []);
}
function VL() {
  const t = document.createElement("span");
  return t.setAttribute("data-radix-focus-guard", ""), t.tabIndex = 0, t.style.cssText = "outline: none; opacity: 0; position: fixed; pointer-events: none", t;
}
const m5 = "focusScope.autoFocusOnMount", v5 = "focusScope.autoFocusOnUnmount", BL = {
  bubbles: !1,
  cancelable: !0
}, lrt = /* @__PURE__ */ gt((t, e) => {
  const { loop: n = !1, trapped: r = !1, onMountAutoFocus: i, onUnmountAutoFocus: o, ...a } = t, [s, u] = Le(null), l = Kr(i), c = Kr(o), d = Ee(null), f = Kn(
    e,
    (v) => u(v)
  ), h = Ee({
    paused: !1,
    pause() {
      this.paused = !0;
    },
    resume() {
      this.paused = !1;
    }
  }).current;
  Re(() => {
    if (r) {
      let v = function(w) {
        if (h.paused || !s)
          return;
        const S = w.target;
        s.contains(S) ? d.current = S : Vl(d.current, {
          select: !0
        });
      }, m = function(w) {
        if (h.paused || !s)
          return;
        const S = w.relatedTarget;
        S !== null && (s.contains(S) || Vl(d.current, {
          select: !0
        }));
      }, b = function(w) {
        if (document.activeElement === document.body)
          for (const E of w)
            E.removedNodes.length > 0 && Vl(s);
      };
      document.addEventListener("focusin", v), document.addEventListener("focusout", m);
      const y = new MutationObserver(b);
      return s && y.observe(s, {
        childList: !0,
        subtree: !0
      }), () => {
        document.removeEventListener("focusin", v), document.removeEventListener("focusout", m), y.disconnect();
      };
    }
  }, [
    r,
    s,
    h.paused
  ]), Re(() => {
    if (s) {
      WL.add(h);
      const v = document.activeElement;
      if (!s.contains(v)) {
        const b = new CustomEvent(m5, BL);
        s.addEventListener(m5, l), s.dispatchEvent(b), b.defaultPrevented || (crt(grt(HQ(s)), {
          select: !0
        }), document.activeElement === v && Vl(s));
      }
      return () => {
        s.removeEventListener(m5, l), setTimeout(() => {
          const b = new CustomEvent(v5, BL);
          s.addEventListener(v5, c), s.dispatchEvent(b), b.defaultPrevented || Vl(v ?? document.body, {
            select: !0
          }), s.removeEventListener(v5, c), WL.remove(h);
        }, 0);
      };
    }
  }, [
    s,
    l,
    c,
    h
  ]);
  const p = et((v) => {
    if (!n && !r || h.paused)
      return;
    const m = v.key === "Tab" && !v.altKey && !v.ctrlKey && !v.metaKey, b = document.activeElement;
    if (m && b) {
      const y = v.currentTarget, [w, S] = drt(y);
      w && S ? !v.shiftKey && b === S ? (v.preventDefault(), n && Vl(w, {
        select: !0
      })) : v.shiftKey && b === w && (v.preventDefault(), n && Vl(S, {
        select: !0
      })) : b === y && v.preventDefault();
    }
  }, [
    n,
    r,
    h.paused
  ]);
  return /* @__PURE__ */ Pe(Sn.div, G({
    tabIndex: -1
  }, a, {
    ref: f,
    onKeyDown: p
  }));
});
function crt(t, { select: e = !1 } = {}) {
  const n = document.activeElement;
  for (const r of t)
    if (Vl(r, {
      select: e
    }), document.activeElement !== n)
      return;
}
function drt(t) {
  const e = HQ(t), n = HL(e, t), r = HL(e.reverse(), t);
  return [
    n,
    r
  ];
}
function HQ(t) {
  const e = [], n = document.createTreeWalker(t, NodeFilter.SHOW_ELEMENT, {
    acceptNode: (r) => {
      const i = r.tagName === "INPUT" && r.type === "hidden";
      return r.disabled || r.hidden || i ? NodeFilter.FILTER_SKIP : r.tabIndex >= 0 ? NodeFilter.FILTER_ACCEPT : NodeFilter.FILTER_SKIP;
    }
  });
  for (; n.nextNode(); )
    e.push(n.currentNode);
  return e;
}
function HL(t, e) {
  for (const n of t)
    if (!frt(n, {
      upTo: e
    }))
      return n;
}
function frt(t, { upTo: e }) {
  if (getComputedStyle(t).visibility === "hidden")
    return !0;
  for (; t; ) {
    if (e !== void 0 && t === e)
      return !1;
    if (getComputedStyle(t).display === "none")
      return !0;
    t = t.parentElement;
  }
  return !1;
}
function hrt(t) {
  return t instanceof HTMLInputElement && "select" in t;
}
function Vl(t, { select: e = !1 } = {}) {
  if (t && t.focus) {
    const n = document.activeElement;
    t.focus({
      preventScroll: !0
    }), t !== n && hrt(t) && e && t.select();
  }
}
const WL = prt();
function prt() {
  let t = [];
  return {
    add(e) {
      const n = t[0];
      e !== n && (n == null || n.pause()), t = jL(t, e), t.unshift(e);
    },
    remove(e) {
      var n;
      t = jL(t, e), (n = t[0]) === null || n === void 0 || n.resume();
    }
  };
}
function jL(t, e) {
  const n = [
    ...t
  ], r = n.indexOf(e);
  return r !== -1 && n.splice(r, 1), n;
}
function grt(t) {
  return t.filter(
    (e) => e.tagName !== "A"
  );
}
const co = globalThis != null && globalThis.document ? Ua : () => {
}, mrt = x.useId || (() => {
});
let vrt = 0;
function oc(t) {
  const [e, n] = x.useState(mrt());
  return co(() => {
    t || n(
      (r) => r ?? String(vrt++)
    );
  }, [
    t
  ]), t || (e ? `radix-${e}` : "");
}
const brt = ["top", "right", "bottom", "left"], yc = Math.min, ta = Math.max, I2 = Math.round, Fb = Math.floor, xc = (t) => ({
  x: t,
  y: t
}), yrt = {
  left: "right",
  right: "left",
  bottom: "top",
  top: "bottom"
}, xrt = {
  start: "end",
  end: "start"
};
function t6(t, e, n) {
  return ta(t, yc(e, n));
}
function il(t, e) {
  return typeof t == "function" ? t(e) : t;
}
function ol(t) {
  return t.split("-")[0];
}
function zp(t) {
  return t.split("-")[1];
}
function DO(t) {
  return t === "x" ? "y" : "x";
}
function MO(t) {
  return t === "y" ? "height" : "width";
}
function Gp(t) {
  return ["top", "bottom"].includes(ol(t)) ? "y" : "x";
}
function FO(t) {
  return DO(Gp(t));
}
function Crt(t, e, n) {
  n === void 0 && (n = !1);
  const r = zp(t), i = FO(t), o = MO(i);
  let a = i === "x" ? r === (n ? "end" : "start") ? "right" : "left" : r === "start" ? "bottom" : "top";
  return e.reference[o] > e.floating[o] && (a = _2(a)), [a, _2(a)];
}
function wrt(t) {
  const e = _2(t);
  return [n6(t), e, n6(e)];
}
function n6(t) {
  return t.replace(/start|end/g, (e) => xrt[e]);
}
function Ert(t, e, n) {
  const r = ["left", "right"], i = ["right", "left"], o = ["top", "bottom"], a = ["bottom", "top"];
  switch (t) {
    case "top":
    case "bottom":
      return n ? e ? i : r : e ? r : i;
    case "left":
    case "right":
      return e ? o : a;
    default:
      return [];
  }
}
function Srt(t, e, n, r) {
  const i = zp(t);
  let o = Ert(ol(t), n === "start", r);
  return i && (o = o.map((a) => a + "-" + i), e && (o = o.concat(o.map(n6)))), o;
}
function _2(t) {
  return t.replace(/left|right|bottom|top/g, (e) => yrt[e]);
}
function Irt(t) {
  return {
    top: 0,
    right: 0,
    bottom: 0,
    left: 0,
    ...t
  };
}
function WQ(t) {
  return typeof t != "number" ? Irt(t) : {
    top: t,
    right: t,
    bottom: t,
    left: t
  };
}
function A2(t) {
  return {
    ...t,
    top: t.y,
    left: t.x,
    right: t.x + t.width,
    bottom: t.y + t.height
  };
}
function zL(t, e, n) {
  let {
    reference: r,
    floating: i
  } = t;
  const o = Gp(e), a = FO(e), s = MO(a), u = ol(e), l = o === "y", c = r.x + r.width / 2 - i.width / 2, d = r.y + r.height / 2 - i.height / 2, f = r[s] / 2 - i[s] / 2;
  let h;
  switch (u) {
    case "top":
      h = {
        x: c,
        y: r.y - i.height
      };
      break;
    case "bottom":
      h = {
        x: c,
        y: r.y + r.height
      };
      break;
    case "right":
      h = {
        x: r.x + r.width,
        y: d
      };
      break;
    case "left":
      h = {
        x: r.x - i.width,
        y: d
      };
      break;
    default:
      h = {
        x: r.x,
        y: r.y
      };
  }
  switch (zp(e)) {
    case "start":
      h[a] -= f * (n && l ? -1 : 1);
      break;
    case "end":
      h[a] += f * (n && l ? -1 : 1);
      break;
  }
  return h;
}
const _rt = async (t, e, n) => {
  const {
    placement: r = "bottom",
    strategy: i = "absolute",
    middleware: o = [],
    platform: a
  } = n, s = o.filter(Boolean), u = await (a.isRTL == null ? void 0 : a.isRTL(e));
  let l = await a.getElementRects({
    reference: t,
    floating: e,
    strategy: i
  }), {
    x: c,
    y: d
  } = zL(l, r, u), f = r, h = {}, p = 0;
  for (let v = 0; v < s.length; v++) {
    const {
      name: m,
      fn: b
    } = s[v], {
      x: y,
      y: w,
      data: S,
      reset: E
    } = await b({
      x: c,
      y: d,
      initialPlacement: r,
      placement: f,
      strategy: i,
      middlewareData: h,
      rects: l,
      platform: a,
      elements: {
        reference: t,
        floating: e
      }
    });
    if (c = y ?? c, d = w ?? d, h = {
      ...h,
      [m]: {
        ...h[m],
        ...S
      }
    }, E && p <= 50) {
      p++, typeof E == "object" && (E.placement && (f = E.placement), E.rects && (l = E.rects === !0 ? await a.getElementRects({
        reference: t,
        floating: e,
        strategy: i
      }) : E.rects), {
        x: c,
        y: d
      } = zL(l, f, u)), v = -1;
      continue;
    }
  }
  return {
    x: c,
    y: d,
    placement: f,
    strategy: i,
    middlewareData: h
  };
};
async function vm(t, e) {
  var n;
  e === void 0 && (e = {});
  const {
    x: r,
    y: i,
    platform: o,
    rects: a,
    elements: s,
    strategy: u
  } = t, {
    boundary: l = "clippingAncestors",
    rootBoundary: c = "viewport",
    elementContext: d = "floating",
    altBoundary: f = !1,
    padding: h = 0
  } = il(e, t), p = WQ(h), m = s[f ? d === "floating" ? "reference" : "floating" : d], b = A2(await o.getClippingRect({
    element: (n = await (o.isElement == null ? void 0 : o.isElement(m))) == null || n ? m : m.contextElement || await (o.getDocumentElement == null ? void 0 : o.getDocumentElement(s.floating)),
    boundary: l,
    rootBoundary: c,
    strategy: u
  })), y = d === "floating" ? {
    ...a.floating,
    x: r,
    y: i
  } : a.reference, w = await (o.getOffsetParent == null ? void 0 : o.getOffsetParent(s.floating)), S = await (o.isElement == null ? void 0 : o.isElement(w)) ? await (o.getScale == null ? void 0 : o.getScale(w)) || {
    x: 1,
    y: 1
  } : {
    x: 1,
    y: 1
  }, E = A2(o.convertOffsetParentRelativeRectToViewportRelativeRect ? await o.convertOffsetParentRelativeRectToViewportRelativeRect({
    rect: y,
    offsetParent: w,
    strategy: u
  }) : y);
  return {
    top: (b.top - E.top + p.top) / S.y,
    bottom: (E.bottom - b.bottom + p.bottom) / S.y,
    left: (b.left - E.left + p.left) / S.x,
    right: (E.right - b.right + p.right) / S.x
  };
}
const GL = (t) => ({
  name: "arrow",
  options: t,
  async fn(e) {
    const {
      x: n,
      y: r,
      placement: i,
      rects: o,
      platform: a,
      elements: s,
      middlewareData: u
    } = e, {
      element: l,
      padding: c = 0
    } = il(t, e) || {};
    if (l == null)
      return {};
    const d = WQ(c), f = {
      x: n,
      y: r
    }, h = FO(i), p = MO(h), v = await a.getDimensions(l), m = h === "y", b = m ? "top" : "left", y = m ? "bottom" : "right", w = m ? "clientHeight" : "clientWidth", S = o.reference[p] + o.reference[h] - f[h] - o.floating[p], E = f[h] - o.reference[h], I = await (a.getOffsetParent == null ? void 0 : a.getOffsetParent(l));
    let _ = I ? I[w] : 0;
    (!_ || !await (a.isElement == null ? void 0 : a.isElement(I))) && (_ = s.floating[w] || o.floating[p]);
    const A = S / 2 - E / 2, P = _ / 2 - v[p] / 2 - 1, N = yc(d[b], P), k = yc(d[y], P), D = N, R = _ - v[p] - k, V = _ / 2 - v[p] / 2 + A, $ = t6(D, V, R), F = !u.arrow && zp(i) != null && V != $ && o.reference[p] / 2 - (V < D ? N : k) - v[p] / 2 < 0, M = F ? V < D ? V - D : V - R : 0;
    return {
      [h]: f[h] + M,
      data: {
        [h]: $,
        centerOffset: V - $ - M,
        ...F && {
          alignmentOffset: M
        }
      },
      reset: F
    };
  }
}), LO = function(t) {
  return t === void 0 && (t = {}), {
    name: "flip",
    options: t,
    async fn(e) {
      var n, r;
      const {
        placement: i,
        middlewareData: o,
        rects: a,
        initialPlacement: s,
        platform: u,
        elements: l
      } = e, {
        mainAxis: c = !0,
        crossAxis: d = !0,
        fallbackPlacements: f,
        fallbackStrategy: h = "bestFit",
        fallbackAxisSideDirection: p = "none",
        flipAlignment: v = !0,
        ...m
      } = il(t, e);
      if ((n = o.arrow) != null && n.alignmentOffset)
        return {};
      const b = ol(i), y = ol(s) === s, w = await (u.isRTL == null ? void 0 : u.isRTL(l.floating)), S = f || (y || !v ? [_2(s)] : wrt(s));
      !f && p !== "none" && S.push(...Srt(s, v, p, w));
      const E = [s, ...S], I = await vm(e, m), _ = [];
      let A = ((r = o.flip) == null ? void 0 : r.overflows) || [];
      if (c && _.push(I[b]), d) {
        const D = Crt(i, a, w);
        _.push(I[D[0]], I[D[1]]);
      }
      if (A = [...A, {
        placement: i,
        overflows: _
      }], !_.every((D) => D <= 0)) {
        var P, N;
        const D = (((P = o.flip) == null ? void 0 : P.index) || 0) + 1, R = E[D];
        if (R)
          return {
            data: {
              index: D,
              overflows: A
            },
            reset: {
              placement: R
            }
          };
        let V = (N = A.filter(($) => $.overflows[0] <= 0).sort(($, F) => $.overflows[1] - F.overflows[1])[0]) == null ? void 0 : N.placement;
        if (!V)
          switch (h) {
            case "bestFit": {
              var k;
              const $ = (k = A.map((F) => [F.placement, F.overflows.filter((M) => M > 0).reduce((M, B) => M + B, 0)]).sort((F, M) => F[1] - M[1])[0]) == null ? void 0 : k[0];
              $ && (V = $);
              break;
            }
            case "initialPlacement":
              V = s;
              break;
          }
        if (i !== V)
          return {
            reset: {
              placement: V
            }
          };
      }
      return {};
    }
  };
};
function UL(t, e) {
  return {
    top: t.top - e.height,
    right: t.right - e.width,
    bottom: t.bottom - e.height,
    left: t.left - e.width
  };
}
function XL(t) {
  return brt.some((e) => t[e] >= 0);
}
const VO = function(t) {
  return t === void 0 && (t = {}), {
    name: "hide",
    options: t,
    async fn(e) {
      const {
        rects: n
      } = e, {
        strategy: r = "referenceHidden",
        ...i
      } = il(t, e);
      switch (r) {
        case "referenceHidden": {
          const o = await vm(e, {
            ...i,
            elementContext: "reference"
          }), a = UL(o, n.reference);
          return {
            data: {
              referenceHiddenOffsets: a,
              referenceHidden: XL(a)
            }
          };
        }
        case "escaped": {
          const o = await vm(e, {
            ...i,
            altBoundary: !0
          }), a = UL(o, n.floating);
          return {
            data: {
              escapedOffsets: a,
              escaped: XL(a)
            }
          };
        }
        default:
          return {};
      }
    }
  };
};
async function Art(t, e) {
  const {
    placement: n,
    platform: r,
    elements: i
  } = t, o = await (r.isRTL == null ? void 0 : r.isRTL(i.floating)), a = ol(n), s = zp(n), u = Gp(n) === "y", l = ["left", "top"].includes(a) ? -1 : 1, c = o && u ? -1 : 1, d = il(e, t);
  let {
    mainAxis: f,
    crossAxis: h,
    alignmentAxis: p
  } = typeof d == "number" ? {
    mainAxis: d,
    crossAxis: 0,
    alignmentAxis: null
  } : {
    mainAxis: 0,
    crossAxis: 0,
    alignmentAxis: null,
    ...d
  };
  return s && typeof p == "number" && (h = s === "end" ? p * -1 : p), u ? {
    x: h * c,
    y: f * l
  } : {
    x: f * l,
    y: h * c
  };
}
const BO = function(t) {
  return t === void 0 && (t = 0), {
    name: "offset",
    options: t,
    async fn(e) {
      var n, r;
      const {
        x: i,
        y: o,
        placement: a,
        middlewareData: s
      } = e, u = await Art(e, t);
      return a === ((n = s.offset) == null ? void 0 : n.placement) && (r = s.arrow) != null && r.alignmentOffset ? {} : {
        x: i + u.x,
        y: o + u.y,
        data: {
          ...u,
          placement: a
        }
      };
    }
  };
}, HO = function(t) {
  return t === void 0 && (t = {}), {
    name: "shift",
    options: t,
    async fn(e) {
      const {
        x: n,
        y: r,
        placement: i
      } = e, {
        mainAxis: o = !0,
        crossAxis: a = !1,
        limiter: s = {
          fn: (m) => {
            let {
              x: b,
              y
            } = m;
            return {
              x: b,
              y
            };
          }
        },
        ...u
      } = il(t, e), l = {
        x: n,
        y: r
      }, c = await vm(e, u), d = Gp(ol(i)), f = DO(d);
      let h = l[f], p = l[d];
      if (o) {
        const m = f === "y" ? "top" : "left", b = f === "y" ? "bottom" : "right", y = h + c[m], w = h - c[b];
        h = t6(y, h, w);
      }
      if (a) {
        const m = d === "y" ? "top" : "left", b = d === "y" ? "bottom" : "right", y = p + c[m], w = p - c[b];
        p = t6(y, p, w);
      }
      const v = s.fn({
        ...e,
        [f]: h,
        [d]: p
      });
      return {
        ...v,
        data: {
          x: v.x - n,
          y: v.y - r
        }
      };
    }
  };
}, WO = function(t) {
  return t === void 0 && (t = {}), {
    options: t,
    fn(e) {
      const {
        x: n,
        y: r,
        placement: i,
        rects: o,
        middlewareData: a
      } = e, {
        offset: s = 0,
        mainAxis: u = !0,
        crossAxis: l = !0
      } = il(t, e), c = {
        x: n,
        y: r
      }, d = Gp(i), f = DO(d);
      let h = c[f], p = c[d];
      const v = il(s, e), m = typeof v == "number" ? {
        mainAxis: v,
        crossAxis: 0
      } : {
        mainAxis: 0,
        crossAxis: 0,
        ...v
      };
      if (u) {
        const w = f === "y" ? "height" : "width", S = o.reference[f] - o.floating[w] + m.mainAxis, E = o.reference[f] + o.reference[w] - m.mainAxis;
        h < S ? h = S : h > E && (h = E);
      }
      if (l) {
        var b, y;
        const w = f === "y" ? "width" : "height", S = ["top", "left"].includes(ol(i)), E = o.reference[d] - o.floating[w] + (S && ((b = a.offset) == null ? void 0 : b[d]) || 0) + (S ? 0 : m.crossAxis), I = o.reference[d] + o.reference[w] + (S ? 0 : ((y = a.offset) == null ? void 0 : y[d]) || 0) - (S ? m.crossAxis : 0);
        p < E ? p = E : p > I && (p = I);
      }
      return {
        [f]: h,
        [d]: p
      };
    }
  };
}, jO = function(t) {
  return t === void 0 && (t = {}), {
    name: "size",
    options: t,
    async fn(e) {
      const {
        placement: n,
        rects: r,
        platform: i,
        elements: o
      } = e, {
        apply: a = () => {
        },
        ...s
      } = il(t, e), u = await vm(e, s), l = ol(n), c = zp(n), d = Gp(n) === "y", {
        width: f,
        height: h
      } = r.floating;
      let p, v;
      l === "top" || l === "bottom" ? (p = l, v = c === (await (i.isRTL == null ? void 0 : i.isRTL(o.floating)) ? "start" : "end") ? "left" : "right") : (v = l, p = c === "end" ? "top" : "bottom");
      const m = h - u[p], b = f - u[v], y = !e.middlewareData.shift;
      let w = m, S = b;
      if (d) {
        const I = f - u.left - u.right;
        S = c || y ? yc(b, I) : I;
      } else {
        const I = h - u.top - u.bottom;
        w = c || y ? yc(m, I) : I;
      }
      if (y && !c) {
        const I = ta(u.left, 0), _ = ta(u.right, 0), A = ta(u.top, 0), P = ta(u.bottom, 0);
        d ? S = f - 2 * (I !== 0 || _ !== 0 ? I + _ : ta(u.left, u.right)) : w = h - 2 * (A !== 0 || P !== 0 ? A + P : ta(u.top, u.bottom));
      }
      await a({
        ...e,
        availableWidth: S,
        availableHeight: w
      });
      const E = await i.getDimensions(o.floating);
      return f !== E.width || h !== E.height ? {
        reset: {
          rects: !0
        }
      } : {};
    }
  };
};
function Cc(t) {
  return jQ(t) ? (t.nodeName || "").toLowerCase() : "#document";
}
function ca(t) {
  var e;
  return (t == null || (e = t.ownerDocument) == null ? void 0 : e.defaultView) || window;
}
function bl(t) {
  var e;
  return (e = (jQ(t) ? t.ownerDocument : t.document) || window.document) == null ? void 0 : e.documentElement;
}
function jQ(t) {
  return t instanceof Node || t instanceof ca(t).Node;
}
function al(t) {
  return t instanceof Element || t instanceof ca(t).Element;
}
function bu(t) {
  return t instanceof HTMLElement || t instanceof ca(t).HTMLElement;
}
function YL(t) {
  return typeof ShadowRoot > "u" ? !1 : t instanceof ShadowRoot || t instanceof ca(t).ShadowRoot;
}
function Sv(t) {
  const {
    overflow: e,
    overflowX: n,
    overflowY: r,
    display: i
  } = Za(t);
  return /auto|scroll|overlay|hidden|clip/.test(e + r + n) && !["inline", "contents"].includes(i);
}
function Trt(t) {
  return ["table", "td", "th"].includes(Cc(t));
}
function zO(t) {
  const e = GO(), n = Za(t);
  return n.transform !== "none" || n.perspective !== "none" || (n.containerType ? n.containerType !== "normal" : !1) || !e && (n.backdropFilter ? n.backdropFilter !== "none" : !1) || !e && (n.filter ? n.filter !== "none" : !1) || ["transform", "perspective", "filter"].some((r) => (n.willChange || "").includes(r)) || ["paint", "layout", "strict", "content"].some((r) => (n.contain || "").includes(r));
}
function Ort(t) {
  let e = hp(t);
  for (; bu(e) && !Vw(e); ) {
    if (zO(e))
      return e;
    e = hp(e);
  }
  return null;
}
function GO() {
  return typeof CSS > "u" || !CSS.supports ? !1 : CSS.supports("-webkit-backdrop-filter", "none");
}
function Vw(t) {
  return ["html", "body", "#document"].includes(Cc(t));
}
function Za(t) {
  return ca(t).getComputedStyle(t);
}
function Bw(t) {
  return al(t) ? {
    scrollLeft: t.scrollLeft,
    scrollTop: t.scrollTop
  } : {
    scrollLeft: t.pageXOffset,
    scrollTop: t.pageYOffset
  };
}
function hp(t) {
  if (Cc(t) === "html")
    return t;
  const e = (
    // Step into the shadow DOM of the parent of a slotted node.
    t.assignedSlot || // DOM Element detected.
    t.parentNode || // ShadowRoot detected.
    YL(t) && t.host || // Fallback.
    bl(t)
  );
  return YL(e) ? e.host : e;
}
function zQ(t) {
  const e = hp(t);
  return Vw(e) ? t.ownerDocument ? t.ownerDocument.body : t.body : bu(e) && Sv(e) ? e : zQ(e);
}
function bm(t, e, n) {
  var r;
  e === void 0 && (e = []), n === void 0 && (n = !0);
  const i = zQ(t), o = i === ((r = t.ownerDocument) == null ? void 0 : r.body), a = ca(i);
  return o ? e.concat(a, a.visualViewport || [], Sv(i) ? i : [], a.frameElement && n ? bm(a.frameElement) : []) : e.concat(i, bm(i, [], n));
}
function GQ(t) {
  const e = Za(t);
  let n = parseFloat(e.width) || 0, r = parseFloat(e.height) || 0;
  const i = bu(t), o = i ? t.offsetWidth : n, a = i ? t.offsetHeight : r, s = I2(n) !== o || I2(r) !== a;
  return s && (n = o, r = a), {
    width: n,
    height: r,
    $: s
  };
}
function UO(t) {
  return al(t) ? t : t.contextElement;
}
function Yh(t) {
  const e = UO(t);
  if (!bu(e))
    return xc(1);
  const n = e.getBoundingClientRect(), {
    width: r,
    height: i,
    $: o
  } = GQ(e);
  let a = (o ? I2(n.width) : n.width) / r, s = (o ? I2(n.height) : n.height) / i;
  return (!a || !Number.isFinite(a)) && (a = 1), (!s || !Number.isFinite(s)) && (s = 1), {
    x: a,
    y: s
  };
}
const Prt = /* @__PURE__ */ xc(0);
function UQ(t) {
  const e = ca(t);
  return !GO() || !e.visualViewport ? Prt : {
    x: e.visualViewport.offsetLeft,
    y: e.visualViewport.offsetTop
  };
}
function Nrt(t, e, n) {
  return e === void 0 && (e = !1), !n || e && n !== ca(t) ? !1 : e;
}
function Wd(t, e, n, r) {
  e === void 0 && (e = !1), n === void 0 && (n = !1);
  const i = t.getBoundingClientRect(), o = UO(t);
  let a = xc(1);
  e && (r ? al(r) && (a = Yh(r)) : a = Yh(t));
  const s = Nrt(o, n, r) ? UQ(o) : xc(0);
  let u = (i.left + s.x) / a.x, l = (i.top + s.y) / a.y, c = i.width / a.x, d = i.height / a.y;
  if (o) {
    const f = ca(o), h = r && al(r) ? ca(r) : r;
    let p = f.frameElement;
    for (; p && r && h !== f; ) {
      const v = Yh(p), m = p.getBoundingClientRect(), b = Za(p), y = m.left + (p.clientLeft + parseFloat(b.paddingLeft)) * v.x, w = m.top + (p.clientTop + parseFloat(b.paddingTop)) * v.y;
      u *= v.x, l *= v.y, c *= v.x, d *= v.y, u += y, l += w, p = ca(p).frameElement;
    }
  }
  return A2({
    width: c,
    height: d,
    x: u,
    y: l
  });
}
function krt(t) {
  let {
    rect: e,
    offsetParent: n,
    strategy: r
  } = t;
  const i = bu(n), o = bl(n);
  if (n === o)
    return e;
  let a = {
    scrollLeft: 0,
    scrollTop: 0
  }, s = xc(1);
  const u = xc(0);
  if ((i || !i && r !== "fixed") && ((Cc(n) !== "body" || Sv(o)) && (a = Bw(n)), bu(n))) {
    const l = Wd(n);
    s = Yh(n), u.x = l.x + n.clientLeft, u.y = l.y + n.clientTop;
  }
  return {
    width: e.width * s.x,
    height: e.height * s.y,
    x: e.x * s.x - a.scrollLeft * s.x + u.x,
    y: e.y * s.y - a.scrollTop * s.y + u.y
  };
}
function Rrt(t) {
  return Array.from(t.getClientRects());
}
function XQ(t) {
  return Wd(bl(t)).left + Bw(t).scrollLeft;
}
function $rt(t) {
  const e = bl(t), n = Bw(t), r = t.ownerDocument.body, i = ta(e.scrollWidth, e.clientWidth, r.scrollWidth, r.clientWidth), o = ta(e.scrollHeight, e.clientHeight, r.scrollHeight, r.clientHeight);
  let a = -n.scrollLeft + XQ(t);
  const s = -n.scrollTop;
  return Za(r).direction === "rtl" && (a += ta(e.clientWidth, r.clientWidth) - i), {
    width: i,
    height: o,
    x: a,
    y: s
  };
}
function Drt(t, e) {
  const n = ca(t), r = bl(t), i = n.visualViewport;
  let o = r.clientWidth, a = r.clientHeight, s = 0, u = 0;
  if (i) {
    o = i.width, a = i.height;
    const l = GO();
    (!l || l && e === "fixed") && (s = i.offsetLeft, u = i.offsetTop);
  }
  return {
    width: o,
    height: a,
    x: s,
    y: u
  };
}
function Mrt(t, e) {
  const n = Wd(t, !0, e === "fixed"), r = n.top + t.clientTop, i = n.left + t.clientLeft, o = bu(t) ? Yh(t) : xc(1), a = t.clientWidth * o.x, s = t.clientHeight * o.y, u = i * o.x, l = r * o.y;
  return {
    width: a,
    height: s,
    x: u,
    y: l
  };
}
function ZL(t, e, n) {
  let r;
  if (e === "viewport")
    r = Drt(t, n);
  else if (e === "document")
    r = $rt(bl(t));
  else if (al(e))
    r = Mrt(e, n);
  else {
    const i = UQ(t);
    r = {
      ...e,
      x: e.x - i.x,
      y: e.y - i.y
    };
  }
  return A2(r);
}
function YQ(t, e) {
  const n = hp(t);
  return n === e || !al(n) || Vw(n) ? !1 : Za(n).position === "fixed" || YQ(n, e);
}
function Frt(t, e) {
  const n = e.get(t);
  if (n)
    return n;
  let r = bm(t, [], !1).filter((s) => al(s) && Cc(s) !== "body"), i = null;
  const o = Za(t).position === "fixed";
  let a = o ? hp(t) : t;
  for (; al(a) && !Vw(a); ) {
    const s = Za(a), u = zO(a);
    !u && s.position === "fixed" && (i = null), (o ? !u && !i : !u && s.position === "static" && !!i && ["absolute", "fixed"].includes(i.position) || Sv(a) && !u && YQ(t, a)) ? r = r.filter((c) => c !== a) : i = s, a = hp(a);
  }
  return e.set(t, r), r;
}
function Lrt(t) {
  let {
    element: e,
    boundary: n,
    rootBoundary: r,
    strategy: i
  } = t;
  const a = [...n === "clippingAncestors" ? Frt(e, this._c) : [].concat(n), r], s = a[0], u = a.reduce((l, c) => {
    const d = ZL(e, c, i);
    return l.top = ta(d.top, l.top), l.right = yc(d.right, l.right), l.bottom = yc(d.bottom, l.bottom), l.left = ta(d.left, l.left), l;
  }, ZL(e, s, i));
  return {
    width: u.right - u.left,
    height: u.bottom - u.top,
    x: u.left,
    y: u.top
  };
}
function Vrt(t) {
  return GQ(t);
}
function Brt(t, e, n) {
  const r = bu(e), i = bl(e), o = n === "fixed", a = Wd(t, !0, o, e);
  let s = {
    scrollLeft: 0,
    scrollTop: 0
  };
  const u = xc(0);
  if (r || !r && !o)
    if ((Cc(e) !== "body" || Sv(i)) && (s = Bw(e)), r) {
      const l = Wd(e, !0, o, e);
      u.x = l.x + e.clientLeft, u.y = l.y + e.clientTop;
    } else
      i && (u.x = XQ(i));
  return {
    x: a.left + s.scrollLeft - u.x,
    y: a.top + s.scrollTop - u.y,
    width: a.width,
    height: a.height
  };
}
function JL(t, e) {
  return !bu(t) || Za(t).position === "fixed" ? null : e ? e(t) : t.offsetParent;
}
function ZQ(t, e) {
  const n = ca(t);
  if (!bu(t))
    return n;
  let r = JL(t, e);
  for (; r && Trt(r) && Za(r).position === "static"; )
    r = JL(r, e);
  return r && (Cc(r) === "html" || Cc(r) === "body" && Za(r).position === "static" && !zO(r)) ? n : r || Ort(t) || n;
}
const Hrt = async function(t) {
  let {
    reference: e,
    floating: n,
    strategy: r
  } = t;
  const i = this.getOffsetParent || ZQ, o = this.getDimensions;
  return {
    reference: Brt(e, await i(n), r),
    floating: {
      x: 0,
      y: 0,
      ...await o(n)
    }
  };
};
function Wrt(t) {
  return Za(t).direction === "rtl";
}
const jrt = {
  convertOffsetParentRelativeRectToViewportRelativeRect: krt,
  getDocumentElement: bl,
  getClippingRect: Lrt,
  getOffsetParent: ZQ,
  getElementRects: Hrt,
  getClientRects: Rrt,
  getDimensions: Vrt,
  getScale: Yh,
  isElement: al,
  isRTL: Wrt
};
function zrt(t, e) {
  let n = null, r;
  const i = bl(t);
  function o() {
    clearTimeout(r), n && n.disconnect(), n = null;
  }
  function a(s, u) {
    s === void 0 && (s = !1), u === void 0 && (u = 1), o();
    const {
      left: l,
      top: c,
      width: d,
      height: f
    } = t.getBoundingClientRect();
    if (s || e(), !d || !f)
      return;
    const h = Fb(c), p = Fb(i.clientWidth - (l + d)), v = Fb(i.clientHeight - (c + f)), m = Fb(l), y = {
      rootMargin: -h + "px " + -p + "px " + -v + "px " + -m + "px",
      threshold: ta(0, yc(1, u)) || 1
    };
    let w = !0;
    function S(E) {
      const I = E[0].intersectionRatio;
      if (I !== u) {
        if (!w)
          return a();
        I ? a(!1, I) : r = setTimeout(() => {
          a(!1, 1e-7);
        }, 100);
      }
      w = !1;
    }
    try {
      n = new IntersectionObserver(S, {
        ...y,
        // Handle <iframe>s
        root: i.ownerDocument
      });
    } catch {
      n = new IntersectionObserver(S, y);
    }
    n.observe(t);
  }
  return a(!0), o;
}
function XO(t, e, n, r) {
  r === void 0 && (r = {});
  const {
    ancestorScroll: i = !0,
    ancestorResize: o = !0,
    elementResize: a = typeof ResizeObserver == "function",
    layoutShift: s = typeof IntersectionObserver == "function",
    animationFrame: u = !1
  } = r, l = UO(t), c = i || o ? [...l ? bm(l) : [], ...bm(e)] : [];
  c.forEach((b) => {
    i && b.addEventListener("scroll", n, {
      passive: !0
    }), o && b.addEventListener("resize", n);
  });
  const d = l && s ? zrt(l, n) : null;
  let f = -1, h = null;
  a && (h = new ResizeObserver((b) => {
    let [y] = b;
    y && y.target === l && h && (h.unobserve(e), cancelAnimationFrame(f), f = requestAnimationFrame(() => {
      h && h.observe(e);
    })), n();
  }), l && !u && h.observe(l), h.observe(e));
  let p, v = u ? Wd(t) : null;
  u && m();
  function m() {
    const b = Wd(t);
    v && (b.x !== v.x || b.y !== v.y || b.width !== v.width || b.height !== v.height) && n(), v = b, p = requestAnimationFrame(m);
  }
  return n(), () => {
    c.forEach((b) => {
      i && b.removeEventListener("scroll", n), o && b.removeEventListener("resize", n);
    }), d && d(), h && h.disconnect(), h = null, u && cancelAnimationFrame(p);
  };
}
const Grt = (t, e, n) => {
  const r = /* @__PURE__ */ new Map(), i = {
    platform: jrt,
    ...n
  }, o = {
    ...i.platform,
    _c: r
  };
  return _rt(t, e, {
    ...i,
    platform: o
  });
}, YO = (t) => {
  function e(n) {
    return {}.hasOwnProperty.call(n, "current");
  }
  return {
    name: "arrow",
    options: t,
    fn(n) {
      const {
        element: r,
        padding: i
      } = typeof t == "function" ? t(n) : t;
      return r && e(r) ? r.current != null ? GL({
        element: r.current,
        padding: i
      }).fn(n) : {} : r ? GL({
        element: r,
        padding: i
      }).fn(n) : {};
    }
  };
};
var Ty = typeof document < "u" ? Ua : Re;
function T2(t, e) {
  if (t === e)
    return !0;
  if (typeof t != typeof e)
    return !1;
  if (typeof t == "function" && t.toString() === e.toString())
    return !0;
  let n, r, i;
  if (t && e && typeof t == "object") {
    if (Array.isArray(t)) {
      if (n = t.length, n != e.length)
        return !1;
      for (r = n; r-- !== 0; )
        if (!T2(t[r], e[r]))
          return !1;
      return !0;
    }
    if (i = Object.keys(t), n = i.length, n !== Object.keys(e).length)
      return !1;
    for (r = n; r-- !== 0; )
      if (!{}.hasOwnProperty.call(e, i[r]))
        return !1;
    for (r = n; r-- !== 0; ) {
      const o = i[r];
      if (!(o === "_owner" && t.$$typeof) && !T2(t[o], e[o]))
        return !1;
    }
    return !0;
  }
  return t !== t && e !== e;
}
function JQ(t) {
  return typeof window > "u" ? 1 : (t.ownerDocument.defaultView || window).devicePixelRatio || 1;
}
function KL(t, e) {
  const n = JQ(t);
  return Math.round(e * n) / n;
}
function qL(t) {
  const e = x.useRef(t);
  return Ty(() => {
    e.current = t;
  }), e;
}
function ZO(t) {
  t === void 0 && (t = {});
  const {
    placement: e = "bottom",
    strategy: n = "absolute",
    middleware: r = [],
    platform: i,
    elements: {
      reference: o,
      floating: a
    } = {},
    transform: s = !0,
    whileElementsMounted: u,
    open: l
  } = t, [c, d] = x.useState({
    x: 0,
    y: 0,
    strategy: n,
    placement: e,
    middlewareData: {},
    isPositioned: !1
  }), [f, h] = x.useState(r);
  T2(f, r) || h(r);
  const [p, v] = x.useState(null), [m, b] = x.useState(null), y = x.useCallback((F) => {
    F != I.current && (I.current = F, v(F));
  }, [v]), w = x.useCallback((F) => {
    F !== _.current && (_.current = F, b(F));
  }, [b]), S = o || p, E = a || m, I = x.useRef(null), _ = x.useRef(null), A = x.useRef(c), P = qL(u), N = qL(i), k = x.useCallback(() => {
    if (!I.current || !_.current)
      return;
    const F = {
      placement: e,
      strategy: n,
      middleware: f
    };
    N.current && (F.platform = N.current), Grt(I.current, _.current, F).then((M) => {
      const B = {
        ...M,
        isPositioned: !0
      };
      D.current && !T2(A.current, B) && (A.current = B, FH.flushSync(() => {
        d(B);
      }));
    });
  }, [f, e, n, N]);
  Ty(() => {
    l === !1 && A.current.isPositioned && (A.current.isPositioned = !1, d((F) => ({
      ...F,
      isPositioned: !1
    })));
  }, [l]);
  const D = x.useRef(!1);
  Ty(() => (D.current = !0, () => {
    D.current = !1;
  }), []), Ty(() => {
    if (S && (I.current = S), E && (_.current = E), S && E) {
      if (P.current)
        return P.current(S, E, k);
      k();
    }
  }, [S, E, k, P]);
  const R = x.useMemo(() => ({
    reference: I,
    floating: _,
    setReference: y,
    setFloating: w
  }), [y, w]), V = x.useMemo(() => ({
    reference: S,
    floating: E
  }), [S, E]), $ = x.useMemo(() => {
    const F = {
      position: n,
      left: 0,
      top: 0
    };
    if (!V.floating)
      return F;
    const M = KL(V.floating, c.x), B = KL(V.floating, c.y);
    return s ? {
      ...F,
      transform: "translate(" + M + "px, " + B + "px)",
      ...JQ(V.floating) >= 1.5 && {
        willChange: "transform"
      }
    } : {
      position: n,
      left: M,
      top: B
    };
  }, [n, s, V.floating, c.x, c.y]);
  return x.useMemo(() => ({
    ...c,
    update: k,
    refs: R,
    elements: V,
    floatingStyles: $
  }), [c, k, R, V, $]);
}
const Urt = /* @__PURE__ */ gt((t, e) => {
  const { children: n, width: r = 10, height: i = 5, ...o } = t;
  return /* @__PURE__ */ Pe(Sn.svg, G({}, o, {
    ref: e,
    width: r,
    height: i,
    viewBox: "0 0 30 10",
    preserveAspectRatio: "none"
  }), t.asChild ? n : /* @__PURE__ */ Pe("polygon", {
    points: "0,0 30,0 15,10"
  }));
}), KQ = Urt;
function JO(t) {
  const [e, n] = Le(void 0);
  return co(() => {
    if (t) {
      n({
        width: t.offsetWidth,
        height: t.offsetHeight
      });
      const r = new ResizeObserver((i) => {
        if (!Array.isArray(i) || !i.length)
          return;
        const o = i[0];
        let a, s;
        if ("borderBoxSize" in o) {
          const u = o.borderBoxSize, l = Array.isArray(u) ? u[0] : u;
          a = l.inlineSize, s = l.blockSize;
        } else
          a = t.offsetWidth, s = t.offsetHeight;
        n({
          width: a,
          height: s
        });
      });
      return r.observe(t, {
        box: "border-box"
      }), () => r.unobserve(t);
    } else
      n(void 0);
  }, [
    t
  ]), e;
}
const qQ = "Popper", [QQ, eee] = Vs(qQ), [Xrt, tee] = QQ(qQ), Yrt = (t) => {
  const { __scopePopper: e, children: n } = t, [r, i] = Le(null);
  return /* @__PURE__ */ Pe(Xrt, {
    scope: e,
    anchor: r,
    onAnchorChange: i
  }, n);
}, Zrt = "PopperAnchor", Jrt = /* @__PURE__ */ gt((t, e) => {
  const { __scopePopper: n, virtualRef: r, ...i } = t, o = tee(Zrt, n), a = Ee(null), s = Kn(e, a);
  return Re(() => {
    o.onAnchorChange((r == null ? void 0 : r.current) || a.current);
  }), r ? null : /* @__PURE__ */ Pe(Sn.div, G({}, i, {
    ref: s
  }));
}), nee = "PopperContent", [Krt, qrt] = QQ(nee), Qrt = /* @__PURE__ */ gt((t, e) => {
  var n, r, i, o, a, s, u, l;
  const { __scopePopper: c, side: d = "bottom", sideOffset: f = 0, align: h = "center", alignOffset: p = 0, arrowPadding: v = 0, avoidCollisions: m = !0, collisionBoundary: b = [], collisionPadding: y = 0, sticky: w = "partial", hideWhenDetached: S = !1, updatePositionStrategy: E = "optimized", onPlaced: I, ..._ } = t, A = tee(nee, c), [P, N] = Le(null), k = Kn(
    e,
    (fe) => N(fe)
  ), [D, R] = Le(null), V = JO(D), $ = (n = V == null ? void 0 : V.width) !== null && n !== void 0 ? n : 0, F = (r = V == null ? void 0 : V.height) !== null && r !== void 0 ? r : 0, M = d + (h !== "center" ? "-" + h : ""), B = typeof y == "number" ? y : {
    top: 0,
    right: 0,
    bottom: 0,
    left: 0,
    ...y
  }, X = Array.isArray(b) ? b : [
    b
  ], L = X.length > 0, j = {
    padding: B,
    boundary: X.filter(rit),
    // with `strategy: 'fixed'`, this is the only way to get it to respect boundaries
    altBoundary: L
  }, { refs: K, floatingStyles: W, placement: Y, isPositioned: U, middlewareData: Q } = ZO({
    // default to `fixed` strategy so users don't have to pick and we also avoid focus scroll issues
    strategy: "fixed",
    placement: M,
    whileElementsMounted: (...fe) => XO(...fe, {
      animationFrame: E === "always"
    }),
    elements: {
      reference: A.anchor
    },
    middleware: [
      BO({
        mainAxis: f + F,
        alignmentAxis: p
      }),
      m && HO({
        mainAxis: !0,
        crossAxis: !1,
        limiter: w === "partial" ? WO() : void 0,
        ...j
      }),
      m && LO({
        ...j
      }),
      jO({
        ...j,
        apply: ({ elements: fe, rects: _e, availableWidth: Ne, availableHeight: ze }) => {
          const { width: Ve, height: ne } = _e.reference, pe = fe.floating.style;
          pe.setProperty("--radix-popper-available-width", `${Ne}px`), pe.setProperty("--radix-popper-available-height", `${ze}px`), pe.setProperty("--radix-popper-anchor-width", `${Ve}px`), pe.setProperty("--radix-popper-anchor-height", `${ne}px`);
        }
      }),
      D && YO({
        element: D,
        padding: v
      }),
      iit({
        arrowWidth: $,
        arrowHeight: F
      }),
      S && VO({
        strategy: "referenceHidden",
        ...j
      })
    ]
  }), [Z, ee] = ree(Y), ie = Kr(I);
  co(() => {
    U && (ie == null || ie());
  }, [
    U,
    ie
  ]);
  const oe = (i = Q.arrow) === null || i === void 0 ? void 0 : i.x, se = (o = Q.arrow) === null || o === void 0 ? void 0 : o.y, te = ((a = Q.arrow) === null || a === void 0 ? void 0 : a.centerOffset) !== 0, [ge, he] = Le();
  return co(() => {
    P && he(window.getComputedStyle(P).zIndex);
  }, [
    P
  ]), /* @__PURE__ */ Pe("div", {
    ref: K.setFloating,
    "data-radix-popper-content-wrapper": "",
    style: {
      ...W,
      transform: U ? W.transform : "translate(0, -200%)",
      // keep off the page when measuring
      minWidth: "max-content",
      zIndex: ge,
      "--radix-popper-transform-origin": [
        (s = Q.transformOrigin) === null || s === void 0 ? void 0 : s.x,
        (u = Q.transformOrigin) === null || u === void 0 ? void 0 : u.y
      ].join(" ")
    },
    dir: t.dir
  }, /* @__PURE__ */ Pe(Krt, {
    scope: c,
    placedSide: Z,
    onArrowChange: R,
    arrowX: oe,
    arrowY: se,
    shouldHideArrow: te
  }, /* @__PURE__ */ Pe(Sn.div, G({
    "data-side": Z,
    "data-align": ee
  }, _, {
    ref: k,
    style: {
      ..._.style,
      // if the PopperContent hasn't been placed yet (not all measurements done)
      // we prevent animations so that users's animation don't kick in too early referring wrong sides
      animation: U ? void 0 : "none",
      // hide the content if using the hide middleware and should be hidden
      opacity: (l = Q.hide) !== null && l !== void 0 && l.referenceHidden ? 0 : void 0
    }
  }))));
}), eit = "PopperArrow", tit = {
  top: "bottom",
  right: "left",
  bottom: "top",
  left: "right"
}, nit = /* @__PURE__ */ gt(function(e, n) {
  const { __scopePopper: r, ...i } = e, o = qrt(eit, r), a = tit[o.placedSide];
  return (
    // we have to use an extra wrapper because `ResizeObserver` (used by `useSize`)
    // doesn't report size as we'd expect on SVG elements.
    // it reports their bounding box which is effectively the largest path inside the SVG.
    /* @__PURE__ */ Pe("span", {
      ref: o.onArrowChange,
      style: {
        position: "absolute",
        left: o.arrowX,
        top: o.arrowY,
        [a]: 0,
        transformOrigin: {
          top: "",
          right: "0 0",
          bottom: "center 0",
          left: "100% 0"
        }[o.placedSide],
        transform: {
          top: "translateY(100%)",
          right: "translateY(50%) rotate(90deg) translateX(-50%)",
          bottom: "rotate(180deg)",
          left: "translateY(50%) rotate(-90deg) translateX(50%)"
        }[o.placedSide],
        visibility: o.shouldHideArrow ? "hidden" : void 0
      }
    }, /* @__PURE__ */ Pe(KQ, G({}, i, {
      ref: n,
      style: {
        ...i.style,
        // ensures the element can be measured correctly (mostly for if SVG)
        display: "block"
      }
    })))
  );
});
function rit(t) {
  return t !== null;
}
const iit = (t) => ({
  name: "transformOrigin",
  options: t,
  fn(e) {
    var n, r, i, o, a;
    const { placement: s, rects: u, middlewareData: l } = e, d = ((n = l.arrow) === null || n === void 0 ? void 0 : n.centerOffset) !== 0, f = d ? 0 : t.arrowWidth, h = d ? 0 : t.arrowHeight, [p, v] = ree(s), m = {
      start: "0%",
      center: "50%",
      end: "100%"
    }[v], b = ((r = (i = l.arrow) === null || i === void 0 ? void 0 : i.x) !== null && r !== void 0 ? r : 0) + f / 2, y = ((o = (a = l.arrow) === null || a === void 0 ? void 0 : a.y) !== null && o !== void 0 ? o : 0) + h / 2;
    let w = "", S = "";
    return p === "bottom" ? (w = d ? m : `${b}px`, S = `${-h}px`) : p === "top" ? (w = d ? m : `${b}px`, S = `${u.floating.height + h}px`) : p === "right" ? (w = `${-h}px`, S = d ? m : `${y}px`) : p === "left" && (w = `${u.floating.width + h}px`, S = d ? m : `${y}px`), {
      data: {
        x: w,
        y: S
      }
    };
  }
});
function ree(t) {
  const [e, n = "center"] = t.split("-");
  return [
    e,
    n
  ];
}
const oit = Yrt, iee = Jrt, ait = Qrt, sit = nit, uit = /* @__PURE__ */ gt((t, e) => {
  var n;
  const { container: r = globalThis == null || (n = globalThis.document) === null || n === void 0 ? void 0 : n.body, ...i } = t;
  return r ? /* @__PURE__ */ ks.createPortal(/* @__PURE__ */ Pe(Sn.div, G({}, i, {
    ref: e
  })), r) : null;
});
function lit(t, e) {
  return Nm((n, r) => {
    const i = e[n][r];
    return i ?? n;
  }, t);
}
const Dc = (t) => {
  const { present: e, children: n } = t, r = cit(e), i = typeof n == "function" ? n({
    present: r.isPresent
  }) : za.only(n), o = Kn(r.ref, i.ref);
  return typeof n == "function" || r.isPresent ? /* @__PURE__ */ Is(i, {
    ref: o
  }) : null;
};
Dc.displayName = "Presence";
function cit(t) {
  const [e, n] = Le(), r = Ee({}), i = Ee(t), o = Ee("none"), a = t ? "mounted" : "unmounted", [s, u] = lit(a, {
    mounted: {
      UNMOUNT: "unmounted",
      ANIMATION_OUT: "unmountSuspended"
    },
    unmountSuspended: {
      MOUNT: "mounted",
      ANIMATION_END: "unmounted"
    },
    unmounted: {
      MOUNT: "mounted"
    }
  });
  return Re(() => {
    const l = Lb(r.current);
    o.current = s === "mounted" ? l : "none";
  }, [
    s
  ]), co(() => {
    const l = r.current, c = i.current;
    if (c !== t) {
      const f = o.current, h = Lb(l);
      t ? u("MOUNT") : h === "none" || (l == null ? void 0 : l.display) === "none" ? u("UNMOUNT") : u(c && f !== h ? "ANIMATION_OUT" : "UNMOUNT"), i.current = t;
    }
  }, [
    t,
    u
  ]), co(() => {
    if (e) {
      const l = (d) => {
        const h = Lb(r.current).includes(d.animationName);
        d.target === e && h && sc(
          () => u("ANIMATION_END")
        );
      }, c = (d) => {
        d.target === e && (o.current = Lb(r.current));
      };
      return e.addEventListener("animationstart", c), e.addEventListener("animationcancel", l), e.addEventListener("animationend", l), () => {
        e.removeEventListener("animationstart", c), e.removeEventListener("animationcancel", l), e.removeEventListener("animationend", l);
      };
    } else
      u("ANIMATION_END");
  }, [
    e,
    u
  ]), {
    isPresent: [
      "mounted",
      "unmountSuspended"
    ].includes(s),
    ref: et((l) => {
      l && (r.current = getComputedStyle(l)), n(l);
    }, [])
  };
}
function Lb(t) {
  return (t == null ? void 0 : t.animationName) || "none";
}
function sl({ prop: t, defaultProp: e, onChange: n = () => {
} }) {
  const [r, i] = dit({
    defaultProp: e,
    onChange: n
  }), o = t !== void 0, a = o ? t : r, s = Kr(n), u = et((l) => {
    if (o) {
      const d = typeof l == "function" ? l(t) : l;
      d !== t && s(d);
    } else
      i(l);
  }, [
    o,
    t,
    i,
    s
  ]);
  return [
    a,
    u
  ];
}
function dit({ defaultProp: t, onChange: e }) {
  const n = Le(t), [r] = n, i = Ee(r), o = Kr(e);
  return Re(() => {
    i.current !== r && (o(r), i.current = r);
  }, [
    r,
    i,
    o
  ]), n;
}
var fit = function(t) {
  if (typeof document > "u")
    return null;
  var e = Array.isArray(t) ? t[0] : t;
  return e.ownerDocument.body;
}, jf = /* @__PURE__ */ new WeakMap(), Vb = /* @__PURE__ */ new WeakMap(), Bb = {}, b5 = 0, oee = function(t) {
  return t && (t.host || oee(t.parentNode));
}, hit = function(t, e) {
  return e.map(function(n) {
    if (t.contains(n))
      return n;
    var r = oee(n);
    return r && t.contains(r) ? r : (console.error("aria-hidden", n, "in not contained inside", t, ". Doing nothing"), null);
  }).filter(function(n) {
    return !!n;
  });
}, pit = function(t, e, n, r) {
  var i = hit(e, Array.isArray(t) ? t : [t]);
  Bb[n] || (Bb[n] = /* @__PURE__ */ new WeakMap());
  var o = Bb[n], a = [], s = /* @__PURE__ */ new Set(), u = new Set(i), l = function(d) {
    !d || s.has(d) || (s.add(d), l(d.parentNode));
  };
  i.forEach(l);
  var c = function(d) {
    !d || u.has(d) || Array.prototype.forEach.call(d.children, function(f) {
      if (s.has(f))
        c(f);
      else {
        var h = f.getAttribute(r), p = h !== null && h !== "false", v = (jf.get(f) || 0) + 1, m = (o.get(f) || 0) + 1;
        jf.set(f, v), o.set(f, m), a.push(f), v === 1 && p && Vb.set(f, !0), m === 1 && f.setAttribute(n, "true"), p || f.setAttribute(r, "true");
      }
    });
  };
  return c(e), s.clear(), b5++, function() {
    a.forEach(function(d) {
      var f = jf.get(d) - 1, h = o.get(d) - 1;
      jf.set(d, f), o.set(d, h), f || (Vb.has(d) || d.removeAttribute(r), Vb.delete(d)), h || d.removeAttribute(n);
    }), b5--, b5 || (jf = /* @__PURE__ */ new WeakMap(), jf = /* @__PURE__ */ new WeakMap(), Vb = /* @__PURE__ */ new WeakMap(), Bb = {});
  };
}, KO = function(t, e, n) {
  n === void 0 && (n = "data-aria-hidden");
  var r = Array.from(Array.isArray(t) ? t : [t]), i = e || fit(t);
  return i ? (r.push.apply(r, Array.from(i.querySelectorAll("[aria-live]"))), pit(r, i, n, "aria-hidden")) : function() {
    return null;
  };
}, ja = function() {
  return ja = Object.assign || function(e) {
    for (var n, r = 1, i = arguments.length; r < i; r++) {
      n = arguments[r];
      for (var o in n)
        Object.prototype.hasOwnProperty.call(n, o) && (e[o] = n[o]);
    }
    return e;
  }, ja.apply(this, arguments);
};
function aee(t, e) {
  var n = {};
  for (var r in t)
    Object.prototype.hasOwnProperty.call(t, r) && e.indexOf(r) < 0 && (n[r] = t[r]);
  if (t != null && typeof Object.getOwnPropertySymbols == "function")
    for (var i = 0, r = Object.getOwnPropertySymbols(t); i < r.length; i++)
      e.indexOf(r[i]) < 0 && Object.prototype.propertyIsEnumerable.call(t, r[i]) && (n[r[i]] = t[r[i]]);
  return n;
}
function git(t, e) {
  var n = typeof Symbol == "function" && t[Symbol.iterator];
  if (!n)
    return t;
  var r = n.call(t), i, o = [], a;
  try {
    for (; (e === void 0 || e-- > 0) && !(i = r.next()).done; )
      o.push(i.value);
  } catch (s) {
    a = { error: s };
  } finally {
    try {
      i && !i.done && (n = r.return) && n.call(r);
    } finally {
      if (a)
        throw a.error;
    }
  }
  return o;
}
function see(t, e, n) {
  if (n || arguments.length === 2)
    for (var r = 0, i = e.length, o; r < i; r++)
      (o || !(r in e)) && (o || (o = Array.prototype.slice.call(e, 0, r)), o[r] = e[r]);
  return t.concat(o || Array.prototype.slice.call(e));
}
var Oy = "right-scroll-bar-position", Py = "width-before-scroll-bar", mit = "with-scroll-bars-hidden", vit = "--removed-body-scroll-bar-size";
function bit(t, e) {
  return typeof t == "function" ? t(e) : t && (t.current = e), t;
}
function yit(t, e) {
  var n = Le(function() {
    return {
      // value
      value: t,
      // last callback
      callback: e,
      // "memoized" public interface
      facade: {
        get current() {
          return n.value;
        },
        set current(r) {
          var i = n.value;
          i !== r && (n.value = r, n.callback(r, i));
        }
      }
    };
  })[0];
  return n.callback = e, n.facade;
}
function xit(t, e) {
  return yit(e || null, function(n) {
    return t.forEach(function(r) {
      return bit(r, n);
    });
  });
}
function Cit(t) {
  return t;
}
function wit(t, e) {
  e === void 0 && (e = Cit);
  var n = [], r = !1, i = {
    read: function() {
      if (r)
        throw new Error("Sidecar: could not `read` from an `assigned` medium. `read` could be used only with `useMedium`.");
      return n.length ? n[n.length - 1] : t;
    },
    useMedium: function(o) {
      var a = e(o, r);
      return n.push(a), function() {
        n = n.filter(function(s) {
          return s !== a;
        });
      };
    },
    assignSyncMedium: function(o) {
      for (r = !0; n.length; ) {
        var a = n;
        n = [], a.forEach(o);
      }
      n = {
        push: function(s) {
          return o(s);
        },
        filter: function() {
          return n;
        }
      };
    },
    assignMedium: function(o) {
      r = !0;
      var a = [];
      if (n.length) {
        var s = n;
        n = [], s.forEach(o), a = n;
      }
      var u = function() {
        var c = a;
        a = [], c.forEach(o);
      }, l = function() {
        return Promise.resolve().then(u);
      };
      l(), n = {
        push: function(c) {
          a.push(c), l();
        },
        filter: function(c) {
          return a = a.filter(c), n;
        }
      };
    }
  };
  return i;
}
function Eit(t) {
  t === void 0 && (t = {});
  var e = wit(null);
  return e.options = ja({ async: !0, ssr: !1 }, t), e;
}
var uee = function(t) {
  var e = t.sideCar, n = aee(t, ["sideCar"]);
  if (!e)
    throw new Error("Sidecar: please provide `sideCar` property to import the right car");
  var r = e.read();
  if (!r)
    throw new Error("Sidecar medium not found");
  return x.createElement(r, ja({}, n));
};
uee.isSideCarExport = !0;
function Sit(t, e) {
  return t.useMedium(e), uee;
}
var lee = Eit(), y5 = function() {
}, Hw = x.forwardRef(function(t, e) {
  var n = x.useRef(null), r = x.useState({
    onScrollCapture: y5,
    onWheelCapture: y5,
    onTouchMoveCapture: y5
  }), i = r[0], o = r[1], a = t.forwardProps, s = t.children, u = t.className, l = t.removeScrollBar, c = t.enabled, d = t.shards, f = t.sideCar, h = t.noIsolation, p = t.inert, v = t.allowPinchZoom, m = t.as, b = m === void 0 ? "div" : m, y = aee(t, ["forwardProps", "children", "className", "removeScrollBar", "enabled", "shards", "sideCar", "noIsolation", "inert", "allowPinchZoom", "as"]), w = f, S = xit([n, e]), E = ja(ja({}, y), i);
  return x.createElement(
    x.Fragment,
    null,
    c && x.createElement(w, { sideCar: lee, removeScrollBar: l, shards: d, noIsolation: h, inert: p, setCallbacks: o, allowPinchZoom: !!v, lockRef: n }),
    a ? x.cloneElement(x.Children.only(s), ja(ja({}, E), { ref: S })) : x.createElement(b, ja({}, E, { className: u, ref: S }), s)
  );
});
Hw.defaultProps = {
  enabled: !0,
  removeScrollBar: !0,
  inert: !1
};
Hw.classNames = {
  fullWidth: Py,
  zeroRight: Oy
};
var QL, Iit = function() {
  if (QL)
    return QL;
  if (typeof __webpack_nonce__ < "u")
    return __webpack_nonce__;
};
function _it() {
  if (!document)
    return null;
  var t = document.createElement("style");
  t.type = "text/css";
  var e = Iit();
  return e && t.setAttribute("nonce", e), t;
}
function Ait(t, e) {
  t.styleSheet ? t.styleSheet.cssText = e : t.appendChild(document.createTextNode(e));
}
function Tit(t) {
  var e = document.head || document.getElementsByTagName("head")[0];
  e.appendChild(t);
}
var Oit = function() {
  var t = 0, e = null;
  return {
    add: function(n) {
      t == 0 && (e = _it()) && (Ait(e, n), Tit(e)), t++;
    },
    remove: function() {
      t--, !t && e && (e.parentNode && e.parentNode.removeChild(e), e = null);
    }
  };
}, Pit = function() {
  var t = Oit();
  return function(e, n) {
    x.useEffect(function() {
      return t.add(e), function() {
        t.remove();
      };
    }, [e && n]);
  };
}, cee = function() {
  var t = Pit(), e = function(n) {
    var r = n.styles, i = n.dynamic;
    return t(r, i), null;
  };
  return e;
}, Nit = {
  left: 0,
  top: 0,
  right: 0,
  gap: 0
}, x5 = function(t) {
  return parseInt(t || "", 10) || 0;
}, kit = function(t) {
  var e = window.getComputedStyle(document.body), n = e[t === "padding" ? "paddingLeft" : "marginLeft"], r = e[t === "padding" ? "paddingTop" : "marginTop"], i = e[t === "padding" ? "paddingRight" : "marginRight"];
  return [x5(n), x5(r), x5(i)];
}, Rit = function(t) {
  if (t === void 0 && (t = "margin"), typeof window > "u")
    return Nit;
  var e = kit(t), n = document.documentElement.clientWidth, r = window.innerWidth;
  return {
    left: e[0],
    top: e[1],
    right: e[2],
    gap: Math.max(0, r - n + e[2] - e[0])
  };
}, $it = cee(), Dit = function(t, e, n, r) {
  var i = t.left, o = t.top, a = t.right, s = t.gap;
  return n === void 0 && (n = "margin"), `
  .`.concat(mit, ` {
   overflow: hidden `).concat(r, `;
   padding-right: `).concat(s, "px ").concat(r, `;
  }
  body {
    overflow: hidden `).concat(r, `;
    overscroll-behavior: contain;
    `).concat([
    e && "position: relative ".concat(r, ";"),
    n === "margin" && `
    padding-left: `.concat(i, `px;
    padding-top: `).concat(o, `px;
    padding-right: `).concat(a, `px;
    margin-left:0;
    margin-top:0;
    margin-right: `).concat(s, "px ").concat(r, `;
    `),
    n === "padding" && "padding-right: ".concat(s, "px ").concat(r, ";")
  ].filter(Boolean).join(""), `
  }
  
  .`).concat(Oy, ` {
    right: `).concat(s, "px ").concat(r, `;
  }
  
  .`).concat(Py, ` {
    margin-right: `).concat(s, "px ").concat(r, `;
  }
  
  .`).concat(Oy, " .").concat(Oy, ` {
    right: 0 `).concat(r, `;
  }
  
  .`).concat(Py, " .").concat(Py, ` {
    margin-right: 0 `).concat(r, `;
  }
  
  body {
    `).concat(vit, ": ").concat(s, `px;
  }
`);
}, Mit = function(t) {
  var e = t.noRelative, n = t.noImportant, r = t.gapMode, i = r === void 0 ? "margin" : r, o = x.useMemo(function() {
    return Rit(i);
  }, [i]);
  return x.createElement($it, { styles: Dit(o, !e, i, n ? "" : "!important") });
}, r6 = !1;
if (typeof window < "u")
  try {
    var Hb = Object.defineProperty({}, "passive", {
      get: function() {
        return r6 = !0, !0;
      }
    });
    window.addEventListener("test", Hb, Hb), window.removeEventListener("test", Hb, Hb);
  } catch {
    r6 = !1;
  }
var zf = r6 ? { passive: !1 } : !1, Fit = function(t) {
  return t.tagName === "TEXTAREA";
}, dee = function(t, e) {
  var n = window.getComputedStyle(t);
  return (
    // not-not-scrollable
    n[e] !== "hidden" && // contains scroll inside self
    !(n.overflowY === n.overflowX && !Fit(t) && n[e] === "visible")
  );
}, Lit = function(t) {
  return dee(t, "overflowY");
}, Vit = function(t) {
  return dee(t, "overflowX");
}, eV = function(t, e) {
  var n = e;
  do {
    typeof ShadowRoot < "u" && n instanceof ShadowRoot && (n = n.host);
    var r = fee(t, n);
    if (r) {
      var i = hee(t, n), o = i[1], a = i[2];
      if (o > a)
        return !0;
    }
    n = n.parentNode;
  } while (n && n !== document.body);
  return !1;
}, Bit = function(t) {
  var e = t.scrollTop, n = t.scrollHeight, r = t.clientHeight;
  return [
    e,
    n,
    r
  ];
}, Hit = function(t) {
  var e = t.scrollLeft, n = t.scrollWidth, r = t.clientWidth;
  return [
    e,
    n,
    r
  ];
}, fee = function(t, e) {
  return t === "v" ? Lit(e) : Vit(e);
}, hee = function(t, e) {
  return t === "v" ? Bit(e) : Hit(e);
}, Wit = function(t, e) {
  return t === "h" && e === "rtl" ? -1 : 1;
}, jit = function(t, e, n, r, i) {
  var o = Wit(t, window.getComputedStyle(e).direction), a = o * r, s = n.target, u = e.contains(s), l = !1, c = a > 0, d = 0, f = 0;
  do {
    var h = hee(t, s), p = h[0], v = h[1], m = h[2], b = v - m - o * p;
    (p || b) && fee(t, s) && (d += b, f += p), s = s.parentNode;
  } while (
    // portaled content
    !u && s !== document.body || // self content
    u && (e.contains(s) || e === s)
  );
  return (c && (i && d === 0 || !i && a > d) || !c && (i && f === 0 || !i && -a > f)) && (l = !0), l;
}, Wb = function(t) {
  return "changedTouches" in t ? [t.changedTouches[0].clientX, t.changedTouches[0].clientY] : [0, 0];
}, tV = function(t) {
  return [t.deltaX, t.deltaY];
}, nV = function(t) {
  return t && "current" in t ? t.current : t;
}, zit = function(t, e) {
  return t[0] === e[0] && t[1] === e[1];
}, Git = function(t) {
  return `
  .block-interactivity-`.concat(t, ` {pointer-events: none;}
  .allow-interactivity-`).concat(t, ` {pointer-events: all;}
`);
}, Uit = 0, Gf = [];
function Xit(t) {
  var e = x.useRef([]), n = x.useRef([0, 0]), r = x.useRef(), i = x.useState(Uit++)[0], o = x.useState(function() {
    return cee();
  })[0], a = x.useRef(t);
  x.useEffect(function() {
    a.current = t;
  }, [t]), x.useEffect(function() {
    if (t.inert) {
      document.body.classList.add("block-interactivity-".concat(i));
      var v = see([t.lockRef.current], (t.shards || []).map(nV), !0).filter(Boolean);
      return v.forEach(function(m) {
        return m.classList.add("allow-interactivity-".concat(i));
      }), function() {
        document.body.classList.remove("block-interactivity-".concat(i)), v.forEach(function(m) {
          return m.classList.remove("allow-interactivity-".concat(i));
        });
      };
    }
  }, [t.inert, t.lockRef.current, t.shards]);
  var s = x.useCallback(function(v, m) {
    if ("touches" in v && v.touches.length === 2)
      return !a.current.allowPinchZoom;
    var b = Wb(v), y = n.current, w = "deltaX" in v ? v.deltaX : y[0] - b[0], S = "deltaY" in v ? v.deltaY : y[1] - b[1], E, I = v.target, _ = Math.abs(w) > Math.abs(S) ? "h" : "v";
    if ("touches" in v && _ === "h" && I.type === "range")
      return !1;
    var A = eV(_, I);
    if (!A)
      return !0;
    if (A ? E = _ : (E = _ === "v" ? "h" : "v", A = eV(_, I)), !A)
      return !1;
    if (!r.current && "changedTouches" in v && (w || S) && (r.current = E), !E)
      return !0;
    var P = r.current || E;
    return jit(P, m, v, P === "h" ? w : S, !0);
  }, []), u = x.useCallback(function(v) {
    var m = v;
    if (!(!Gf.length || Gf[Gf.length - 1] !== o)) {
      var b = "deltaY" in m ? tV(m) : Wb(m), y = e.current.filter(function(E) {
        return E.name === m.type && E.target === m.target && zit(E.delta, b);
      })[0];
      if (y && y.should) {
        m.cancelable && m.preventDefault();
        return;
      }
      if (!y) {
        var w = (a.current.shards || []).map(nV).filter(Boolean).filter(function(E) {
          return E.contains(m.target);
        }), S = w.length > 0 ? s(m, w[0]) : !a.current.noIsolation;
        S && m.cancelable && m.preventDefault();
      }
    }
  }, []), l = x.useCallback(function(v, m, b, y) {
    var w = { name: v, delta: m, target: b, should: y };
    e.current.push(w), setTimeout(function() {
      e.current = e.current.filter(function(S) {
        return S !== w;
      });
    }, 1);
  }, []), c = x.useCallback(function(v) {
    n.current = Wb(v), r.current = void 0;
  }, []), d = x.useCallback(function(v) {
    l(v.type, tV(v), v.target, s(v, t.lockRef.current));
  }, []), f = x.useCallback(function(v) {
    l(v.type, Wb(v), v.target, s(v, t.lockRef.current));
  }, []);
  x.useEffect(function() {
    return Gf.push(o), t.setCallbacks({
      onScrollCapture: d,
      onWheelCapture: d,
      onTouchMoveCapture: f
    }), document.addEventListener("wheel", u, zf), document.addEventListener("touchmove", u, zf), document.addEventListener("touchstart", c, zf), function() {
      Gf = Gf.filter(function(v) {
        return v !== o;
      }), document.removeEventListener("wheel", u, zf), document.removeEventListener("touchmove", u, zf), document.removeEventListener("touchstart", c, zf);
    };
  }, []);
  var h = t.removeScrollBar, p = t.inert;
  return x.createElement(
    x.Fragment,
    null,
    p ? x.createElement(o, { styles: Git(i) }) : null,
    h ? x.createElement(Mit, { gapMode: "margin" }) : null
  );
}
const Yit = Sit(lee, Xit);
var pee = x.forwardRef(function(t, e) {
  return x.createElement(Hw, ja({}, t, { ref: e, sideCar: Yit }));
});
pee.classNames = Hw.classNames;
const qO = pee, gee = "Popover", [mee, Sbt] = Vs(gee, [
  eee
]), Iv = eee(), [Zit, ff] = mee(gee), Jit = (t) => {
  const { __scopePopover: e, children: n, open: r, defaultOpen: i, onOpenChange: o, modal: a = !1 } = t, s = Iv(e), u = Ee(null), [l, c] = Le(!1), [d = !1, f] = sl({
    prop: r,
    defaultProp: i,
    onChange: o
  });
  return /* @__PURE__ */ Pe(oit, s, /* @__PURE__ */ Pe(Zit, {
    scope: e,
    contentId: oc(),
    triggerRef: u,
    open: d,
    onOpenChange: f,
    onOpenToggle: et(
      () => f(
        (h) => !h
      ),
      [
        f
      ]
    ),
    hasCustomAnchor: l,
    onCustomAnchorAdd: et(
      () => c(!0),
      []
    ),
    onCustomAnchorRemove: et(
      () => c(!1),
      []
    ),
    modal: a
  }, n));
}, Kit = "PopoverAnchor", qit = /* @__PURE__ */ gt((t, e) => {
  const { __scopePopover: n, ...r } = t, i = ff(Kit, n), o = Iv(n), { onCustomAnchorAdd: a, onCustomAnchorRemove: s } = i;
  return Re(() => (a(), () => s()), [
    a,
    s
  ]), /* @__PURE__ */ Pe(iee, G({}, o, r, {
    ref: e
  }));
}), Qit = "PopoverTrigger", vee = /* @__PURE__ */ gt((t, e) => {
  const { __scopePopover: n, ...r } = t, i = ff(Qit, n), o = Iv(n), a = Kn(e, i.triggerRef), s = /* @__PURE__ */ Pe(Sn.button, G({
    type: "button",
    "aria-haspopup": "dialog",
    "aria-expanded": i.open,
    "aria-controls": i.contentId,
    "data-state": xee(i.open)
  }, r, {
    ref: a,
    onClick: ln(t.onClick, i.onOpenToggle)
  }));
  return i.hasCustomAnchor ? s : /* @__PURE__ */ Pe(iee, G({
    asChild: !0
  }, o), s);
}), bee = "PopoverPortal", [eot, tot] = mee(bee, {
  forceMount: void 0
}), not = (t) => {
  const { __scopePopover: e, forceMount: n, children: r, container: i } = t, o = ff(bee, e);
  return /* @__PURE__ */ Pe(eot, {
    scope: e,
    forceMount: n
  }, /* @__PURE__ */ Pe(Dc, {
    present: n || o.open
  }, /* @__PURE__ */ Pe(uit, {
    asChild: !0,
    container: i
  }, r)));
}, ym = "PopoverContent", QO = /* @__PURE__ */ gt((t, e) => {
  const n = tot(ym, t.__scopePopover), { forceMount: r = n.forceMount, ...i } = t, o = ff(ym, t.__scopePopover);
  return /* @__PURE__ */ Pe(Dc, {
    present: r || o.open
  }, o.modal ? /* @__PURE__ */ Pe(rot, G({}, i, {
    ref: e
  })) : /* @__PURE__ */ Pe(iot, G({}, i, {
    ref: e
  })));
}), rot = /* @__PURE__ */ gt((t, e) => {
  const n = ff(ym, t.__scopePopover), r = Ee(null), i = Kn(e, r), o = Ee(!1);
  return Re(() => {
    const a = r.current;
    if (a)
      return KO(a);
  }, []), /* @__PURE__ */ Pe(qO, {
    as: Hd,
    allowPinchZoom: !0
  }, /* @__PURE__ */ Pe(yee, G({}, t, {
    ref: i,
    trapFocus: n.open,
    disableOutsidePointerEvents: !0,
    onCloseAutoFocus: ln(t.onCloseAutoFocus, (a) => {
      var s;
      a.preventDefault(), o.current || (s = n.triggerRef.current) === null || s === void 0 || s.focus();
    }),
    onPointerDownOutside: ln(t.onPointerDownOutside, (a) => {
      const s = a.detail.originalEvent, u = s.button === 0 && s.ctrlKey === !0, l = s.button === 2 || u;
      o.current = l;
    }, {
      checkForDefaultPrevented: !1
    }),
    onFocusOutside: ln(
      t.onFocusOutside,
      (a) => a.preventDefault(),
      {
        checkForDefaultPrevented: !1
      }
    )
  })));
}), iot = /* @__PURE__ */ gt((t, e) => {
  const n = ff(ym, t.__scopePopover), r = Ee(!1), i = Ee(!1);
  return /* @__PURE__ */ Pe(yee, G({}, t, {
    ref: e,
    trapFocus: !1,
    disableOutsidePointerEvents: !1,
    onCloseAutoFocus: (o) => {
      var a;
      if ((a = t.onCloseAutoFocus) === null || a === void 0 || a.call(t, o), !o.defaultPrevented) {
        var s;
        r.current || (s = n.triggerRef.current) === null || s === void 0 || s.focus(), o.preventDefault();
      }
      r.current = !1, i.current = !1;
    },
    onInteractOutside: (o) => {
      var a, s;
      (a = t.onInteractOutside) === null || a === void 0 || a.call(t, o), o.defaultPrevented || (r.current = !0, o.detail.originalEvent.type === "pointerdown" && (i.current = !0));
      const u = o.target;
      ((s = n.triggerRef.current) === null || s === void 0 ? void 0 : s.contains(u)) && o.preventDefault(), o.detail.originalEvent.type === "focusin" && i.current && o.preventDefault();
    }
  }));
}), yee = /* @__PURE__ */ gt((t, e) => {
  const { __scopePopover: n, trapFocus: r, onOpenAutoFocus: i, onCloseAutoFocus: o, disableOutsidePointerEvents: a, onEscapeKeyDown: s, onPointerDownOutside: u, onFocusOutside: l, onInteractOutside: c, ...d } = t, f = ff(ym, n), h = Iv(n);
  return $O(), /* @__PURE__ */ Pe(lrt, {
    asChild: !0,
    loop: !0,
    trapped: r,
    onMountAutoFocus: i,
    onUnmountAutoFocus: o
  }, /* @__PURE__ */ Pe(art, {
    asChild: !0,
    disableOutsidePointerEvents: a,
    onInteractOutside: c,
    onEscapeKeyDown: s,
    onPointerDownOutside: u,
    onFocusOutside: l,
    onDismiss: () => f.onOpenChange(!1)
  }, /* @__PURE__ */ Pe(ait, G({
    "data-state": xee(f.open),
    role: "dialog",
    id: f.contentId
  }, h, d, {
    ref: e,
    style: {
      ...d.style,
      "--radix-popover-content-transform-origin": "var(--radix-popper-transform-origin)",
      "--radix-popover-content-available-width": "var(--radix-popper-available-width)",
      "--radix-popover-content-available-height": "var(--radix-popper-available-height)",
      "--radix-popover-trigger-width": "var(--radix-popper-anchor-width)",
      "--radix-popover-trigger-height": "var(--radix-popper-anchor-height)"
    }
  }))));
}), oot = /* @__PURE__ */ gt((t, e) => {
  const { __scopePopover: n, ...r } = t, i = Iv(n);
  return /* @__PURE__ */ Pe(sit, G({}, i, r, {
    ref: e
  }));
});
function xee(t) {
  return t ? "open" : "closed";
}
const e8 = Jit, aot = qit, t8 = not, sot = QO, n8 = oot;
function Cee(t) {
  const e = t + "CollectionProvider", [n, r] = Vs(e), [i, o] = n(e, {
    collectionRef: {
      current: null
    },
    itemMap: /* @__PURE__ */ new Map()
  }), a = (h) => {
    const { scope: p, children: v } = h, m = O.useRef(null), b = O.useRef(/* @__PURE__ */ new Map()).current;
    return /* @__PURE__ */ O.createElement(i, {
      scope: p,
      itemMap: b,
      collectionRef: m
    }, v);
  }, s = t + "CollectionSlot", u = /* @__PURE__ */ O.forwardRef((h, p) => {
    const { scope: v, children: m } = h, b = o(s, v), y = Kn(p, b.collectionRef);
    return /* @__PURE__ */ O.createElement(Hd, {
      ref: y
    }, m);
  }), l = t + "CollectionItemSlot", c = "data-radix-collection-item", d = /* @__PURE__ */ O.forwardRef((h, p) => {
    const { scope: v, children: m, ...b } = h, y = O.useRef(null), w = Kn(p, y), S = o(l, v);
    return O.useEffect(() => (S.itemMap.set(y, {
      ref: y,
      ...b
    }), () => void S.itemMap.delete(y))), /* @__PURE__ */ O.createElement(Hd, {
      [c]: "",
      ref: w
    }, m);
  });
  function f(h) {
    const p = o(t + "CollectionConsumer", h);
    return O.useCallback(() => {
      const m = p.collectionRef.current;
      if (!m)
        return [];
      const b = Array.from(m.querySelectorAll(`[${c}]`));
      return Array.from(p.itemMap.values()).sort(
        (S, E) => b.indexOf(S.ref.current) - b.indexOf(E.ref.current)
      );
    }, [
      p.collectionRef,
      p.itemMap
    ]);
  }
  return [
    {
      Provider: a,
      Slot: u,
      ItemSlot: d
    },
    f,
    r
  ];
}
const uot = /* @__PURE__ */ oi(void 0);
function Ww(t) {
  const e = fn(uot);
  return t || e || "ltr";
}
const C5 = "rovingFocusGroup.onEntryFocus", lot = {
  bubbles: !1,
  cancelable: !0
}, r8 = "RovingFocusGroup", [i6, wee, cot] = Cee(r8), [dot, jw] = Vs(r8, [
  cot
]), [fot, hot] = dot(r8), pot = /* @__PURE__ */ gt((t, e) => /* @__PURE__ */ Pe(i6.Provider, {
  scope: t.__scopeRovingFocusGroup
}, /* @__PURE__ */ Pe(i6.Slot, {
  scope: t.__scopeRovingFocusGroup
}, /* @__PURE__ */ Pe(got, G({}, t, {
  ref: e
}))))), got = /* @__PURE__ */ gt((t, e) => {
  const { __scopeRovingFocusGroup: n, orientation: r, loop: i = !1, dir: o, currentTabStopId: a, defaultCurrentTabStopId: s, onCurrentTabStopIdChange: u, onEntryFocus: l, ...c } = t, d = Ee(null), f = Kn(e, d), h = Ww(o), [p = null, v] = sl({
    prop: a,
    defaultProp: s,
    onChange: u
  }), [m, b] = Le(!1), y = Kr(l), w = wee(n), S = Ee(!1), [E, I] = Le(0);
  return Re(() => {
    const _ = d.current;
    if (_)
      return _.addEventListener(C5, y), () => _.removeEventListener(C5, y);
  }, [
    y
  ]), /* @__PURE__ */ Pe(fot, {
    scope: n,
    orientation: r,
    dir: h,
    loop: i,
    currentTabStopId: p,
    onItemFocus: et(
      (_) => v(_),
      [
        v
      ]
    ),
    onItemShiftTab: et(
      () => b(!0),
      []
    ),
    onFocusableItemAdd: et(
      () => I(
        (_) => _ + 1
      ),
      []
    ),
    onFocusableItemRemove: et(
      () => I(
        (_) => _ - 1
      ),
      []
    )
  }, /* @__PURE__ */ Pe(Sn.div, G({
    tabIndex: m || E === 0 ? -1 : 0,
    "data-orientation": r
  }, c, {
    ref: f,
    style: {
      outline: "none",
      ...t.style
    },
    onMouseDown: ln(t.onMouseDown, () => {
      S.current = !0;
    }),
    onFocus: ln(t.onFocus, (_) => {
      const A = !S.current;
      if (_.target === _.currentTarget && A && !m) {
        const P = new CustomEvent(C5, lot);
        if (_.currentTarget.dispatchEvent(P), !P.defaultPrevented) {
          const N = w().filter(
            ($) => $.focusable
          ), k = N.find(
            ($) => $.active
          ), D = N.find(
            ($) => $.id === p
          ), V = [
            k,
            D,
            ...N
          ].filter(Boolean).map(
            ($) => $.ref.current
          );
          Eee(V);
        }
      }
      S.current = !1;
    }),
    onBlur: ln(
      t.onBlur,
      () => b(!1)
    )
  })));
}), mot = "RovingFocusGroupItem", vot = /* @__PURE__ */ gt((t, e) => {
  const { __scopeRovingFocusGroup: n, focusable: r = !0, active: i = !1, tabStopId: o, ...a } = t, s = oc(), u = o || s, l = hot(mot, n), c = l.currentTabStopId === u, d = wee(n), { onFocusableItemAdd: f, onFocusableItemRemove: h } = l;
  return Re(() => {
    if (r)
      return f(), () => h();
  }, [
    r,
    f,
    h
  ]), /* @__PURE__ */ Pe(i6.ItemSlot, {
    scope: n,
    id: u,
    focusable: r,
    active: i
  }, /* @__PURE__ */ Pe(Sn.span, G({
    tabIndex: c ? 0 : -1,
    "data-orientation": l.orientation
  }, a, {
    ref: e,
    onMouseDown: ln(t.onMouseDown, (p) => {
      r ? l.onItemFocus(u) : p.preventDefault();
    }),
    onFocus: ln(
      t.onFocus,
      () => l.onItemFocus(u)
    ),
    onKeyDown: ln(t.onKeyDown, (p) => {
      if (p.key === "Tab" && p.shiftKey) {
        l.onItemShiftTab();
        return;
      }
      if (p.target !== p.currentTarget)
        return;
      const v = xot(p, l.orientation, l.dir);
      if (v !== void 0) {
        p.preventDefault();
        let b = d().filter(
          (y) => y.focusable
        ).map(
          (y) => y.ref.current
        );
        if (v === "last")
          b.reverse();
        else if (v === "prev" || v === "next") {
          v === "prev" && b.reverse();
          const y = b.indexOf(p.currentTarget);
          b = l.loop ? Cot(b, y + 1) : b.slice(y + 1);
        }
        setTimeout(
          () => Eee(b)
        );
      }
    })
  })));
}), bot = {
  ArrowLeft: "prev",
  ArrowUp: "prev",
  ArrowRight: "next",
  ArrowDown: "next",
  PageUp: "first",
  Home: "first",
  PageDown: "last",
  End: "last"
};
function yot(t, e) {
  return e !== "rtl" ? t : t === "ArrowLeft" ? "ArrowRight" : t === "ArrowRight" ? "ArrowLeft" : t;
}
function xot(t, e, n) {
  const r = yot(t.key, n);
  if (!(e === "vertical" && [
    "ArrowLeft",
    "ArrowRight"
  ].includes(r)) && !(e === "horizontal" && [
    "ArrowUp",
    "ArrowDown"
  ].includes(r)))
    return bot[r];
}
function Eee(t) {
  const e = document.activeElement;
  for (const n of t)
    if (n === e || (n.focus(), document.activeElement !== e))
      return;
}
function Cot(t, e) {
  return t.map(
    (n, r) => t[(e + r) % t.length]
  );
}
const See = pot, Iee = vot, o6 = "horizontal", wot = [
  "horizontal",
  "vertical"
], _ee = /* @__PURE__ */ gt((t, e) => {
  const { decorative: n, orientation: r = o6, ...i } = t, o = Aee(r) ? r : o6, s = n ? {
    role: "none"
  } : {
    "aria-orientation": o === "vertical" ? o : void 0,
    role: "separator"
  };
  return /* @__PURE__ */ Pe(Sn.div, G({
    "data-orientation": o
  }, s, i, {
    ref: e
  }));
});
_ee.propTypes = {
  orientation(t, e, n) {
    const r = t[e], i = String(r);
    return r && !Aee(r) ? new Error(Eot(i, n)) : null;
  }
};
function Eot(t, e) {
  return `Invalid prop \`orientation\` of value \`${t}\` supplied to \`${e}\`, expected one of:
  - horizontal
  - vertical

Defaulting to \`${o6}\`.`;
}
function Aee(t) {
  return wot.includes(t);
}
const Sot = _ee, Iot = /* @__PURE__ */ gt((t, e) => {
  const { pressed: n, defaultPressed: r = !1, onPressedChange: i, ...o } = t, [a = !1, s] = sl({
    prop: n,
    onChange: i,
    defaultProp: r
  });
  return /* @__PURE__ */ Pe(Sn.button, G({
    type: "button",
    "aria-pressed": a,
    "data-state": a ? "on" : "off",
    "data-disabled": t.disabled ? "" : void 0
  }, o, {
    ref: e,
    onClick: ln(t.onClick, () => {
      t.disabled || s(!a);
    })
  }));
}), zw = "ToggleGroup", [Tee, Oee] = Vs(zw, [
  jw
]), Pee = jw(), _ot = /* @__PURE__ */ O.forwardRef((t, e) => {
  const { type: n, ...r } = t;
  if (n === "single") {
    const i = r;
    return /* @__PURE__ */ O.createElement(Aot, G({}, i, {
      ref: e
    }));
  }
  if (n === "multiple") {
    const i = r;
    return /* @__PURE__ */ O.createElement(Tot, G({}, i, {
      ref: e
    }));
  }
  throw new Error(`Missing prop \`type\` expected on \`${zw}\``);
}), [Nee, kee] = Tee(zw), Aot = /* @__PURE__ */ O.forwardRef((t, e) => {
  const { value: n, defaultValue: r, onValueChange: i = () => {
  }, ...o } = t, [a, s] = sl({
    prop: n,
    defaultProp: r,
    onChange: i
  });
  return /* @__PURE__ */ O.createElement(Nee, {
    scope: t.__scopeToggleGroup,
    type: "single",
    value: a ? [
      a
    ] : [],
    onItemActivate: s,
    onItemDeactivate: O.useCallback(
      () => s(""),
      [
        s
      ]
    )
  }, /* @__PURE__ */ O.createElement(Ree, G({}, o, {
    ref: e
  })));
}), Tot = /* @__PURE__ */ O.forwardRef((t, e) => {
  const { value: n, defaultValue: r, onValueChange: i = () => {
  }, ...o } = t, [a = [], s] = sl({
    prop: n,
    defaultProp: r,
    onChange: i
  }), u = O.useCallback(
    (c) => s(
      (d = []) => [
        ...d,
        c
      ]
    ),
    [
      s
    ]
  ), l = O.useCallback(
    (c) => s(
      (d = []) => d.filter(
        (f) => f !== c
      )
    ),
    [
      s
    ]
  );
  return /* @__PURE__ */ O.createElement(Nee, {
    scope: t.__scopeToggleGroup,
    type: "multiple",
    value: a,
    onItemActivate: u,
    onItemDeactivate: l
  }, /* @__PURE__ */ O.createElement(Ree, G({}, o, {
    ref: e
  })));
}), [Oot, Pot] = Tee(zw), Ree = /* @__PURE__ */ O.forwardRef((t, e) => {
  const { __scopeToggleGroup: n, disabled: r = !1, rovingFocus: i = !0, orientation: o, dir: a, loop: s = !0, ...u } = t, l = Pee(n), c = Ww(a), d = {
    role: "group",
    dir: c,
    ...u
  };
  return /* @__PURE__ */ O.createElement(Oot, {
    scope: n,
    rovingFocus: i,
    disabled: r
  }, i ? /* @__PURE__ */ O.createElement(See, G({
    asChild: !0
  }, l, {
    orientation: o,
    dir: c,
    loop: s
  }), /* @__PURE__ */ O.createElement(Sn.div, G({}, d, {
    ref: e
  }))) : /* @__PURE__ */ O.createElement(Sn.div, G({}, d, {
    ref: e
  })));
}), a6 = "ToggleGroupItem", Not = /* @__PURE__ */ O.forwardRef((t, e) => {
  const n = kee(a6, t.__scopeToggleGroup), r = Pot(a6, t.__scopeToggleGroup), i = Pee(t.__scopeToggleGroup), o = n.value.includes(t.value), a = r.disabled || t.disabled, s = {
    ...t,
    pressed: o,
    disabled: a
  }, u = O.useRef(null);
  return r.rovingFocus ? /* @__PURE__ */ O.createElement(Iee, G({
    asChild: !0
  }, i, {
    focusable: !a,
    active: o,
    ref: u
  }), /* @__PURE__ */ O.createElement(rV, G({}, s, {
    ref: e
  }))) : /* @__PURE__ */ O.createElement(rV, G({}, s, {
    ref: e
  }));
}), rV = /* @__PURE__ */ O.forwardRef((t, e) => {
  const { __scopeToggleGroup: n, value: r, ...i } = t, o = kee(a6, n), a = {
    role: "radio",
    "aria-checked": t.pressed,
    "aria-pressed": void 0
  }, s = o.type === "single" ? a : void 0;
  return /* @__PURE__ */ O.createElement(Iot, G({}, s, i, {
    ref: e,
    onPressedChange: (u) => {
      u ? o.onItemActivate(r) : o.onItemDeactivate(r);
    }
  }));
}), kot = _ot, Rot = Not, $ee = "Toolbar", [$ot, Ibt] = Vs($ee, [
  jw,
  Oee
]), Dee = jw(), Mee = Oee(), [Dot, Fee] = $ot($ee), Mot = /* @__PURE__ */ gt((t, e) => {
  const { __scopeToolbar: n, orientation: r = "horizontal", dir: i, loop: o = !0, ...a } = t, s = Dee(n), u = Ww(i);
  return /* @__PURE__ */ Pe(Dot, {
    scope: n,
    orientation: r,
    dir: u
  }, /* @__PURE__ */ Pe(See, G({
    asChild: !0
  }, s, {
    orientation: r,
    dir: u,
    loop: o
  }), /* @__PURE__ */ Pe(Sn.div, G({
    role: "toolbar",
    "aria-orientation": r,
    dir: u
  }, a, {
    ref: e
  }))));
}), Fot = "ToolbarSeparator", Lot = /* @__PURE__ */ gt((t, e) => {
  const { __scopeToolbar: n, ...r } = t, i = Fee(Fot, n);
  return /* @__PURE__ */ Pe(Sot, G({
    orientation: i.orientation === "horizontal" ? "vertical" : "horizontal"
  }, r, {
    ref: e
  }));
}), Lee = /* @__PURE__ */ gt((t, e) => {
  const { __scopeToolbar: n, ...r } = t, i = Dee(n);
  return /* @__PURE__ */ Pe(Iee, G({
    asChild: !0
  }, i, {
    focusable: !t.disabled
  }), /* @__PURE__ */ Pe(Sn.button, G({
    type: "button"
  }, r, {
    ref: e
  })));
}), Vot = "ToolbarToggleGroup", Bot = /* @__PURE__ */ gt((t, e) => {
  const { __scopeToolbar: n, ...r } = t, i = Fee(Vot, n), o = Mee(n);
  return /* @__PURE__ */ Pe(kot, G({
    "data-orientation": i.orientation,
    dir: i.dir
  }, o, r, {
    ref: e,
    rovingFocus: !1
  }));
}), Hot = /* @__PURE__ */ gt((t, e) => {
  const { __scopeToolbar: n, ...r } = t, i = Mee(n), o = {
    __scopeToolbar: t.__scopeToolbar
  };
  return /* @__PURE__ */ Pe(Lee, G({
    asChild: !0
  }, o), /* @__PURE__ */ Pe(Rot, G({}, i, r, {
    ref: e
  })));
}), i8 = Mot, Wot = Lot, ac = Lee, Gw = Bot, Ny = Hot;
function Vee(t, e) {
  return t === null || t === e ? !1 : t.dataset.editorDialog !== void 0 || t.dataset.toolbarItem !== void 0 || t.dataset.editorDropdown ? !0 : Vee(t.parentElement, e);
}
function jot() {
  const t = [...Array(256).keys()].map((n) => n.toString(16).padStart(2, "0")), e = crypto.getRandomValues(new Uint8Array(16));
  return e[6] = e[6] & 15 | 64, e[8] = e[8] & 63 | 128, [...e.entries()].map(([n, r]) => [4, 6, 8, 10].includes(n) ? `-${t[r]}` : t[r]).join("");
}
const Bee = (t) => t === 0 ? "th" : "td", Hee = {
  center: it.centeredCell,
  left: it.leftAlignedCell,
  right: it.rightAlignedCell
}, zot = ({ mdastNode: t, parentEditor: e, lexicalTable: n }) => {
  const [r, i] = O.useState(null), [o, a] = ya(Bo, vu), s = O.useMemo(() => (v) => (v.__cacheKey || (v.__cacheKey = jot()), v.__cacheKey), []), u = O.useCallback(
    (v) => {
      const m = n.getColCount();
      if (v === null) {
        i(null);
        return;
      }
      let [b, y] = v;
      if (b > m - 1 && (b = 0, y++), b < 0 && (b = m - 1, y -= 1), y > n.getRowCount() - 1) {
        i(null), e.update(() => {
          if (n.getLatest().getNextSibling())
            n.getLatest().selectNext();
          else {
            const S = Sr();
            n.insertAfter(S), S.select();
          }
        });
        return;
      }
      if (y < 0) {
        i(null), e.update(() => {
          n.getLatest().selectPrevious();
        });
        return;
      }
      i([b, y]);
    },
    [n, e]
  );
  O.useEffect(() => {
    n.focusEmitter.subscribe(u);
  }, [n, u]);
  const l = O.useCallback(
    (v) => {
      v.preventDefault(), e.update(() => {
        n.addRowToBottom(), i([0, n.getRowCount()]);
      });
    },
    [e, n]
  ), c = O.useCallback(
    (v) => {
      v.preventDefault(), e.update(() => {
        n.addColumnToRight(), i([n.getColCount(), 0]);
      });
    },
    [e, n]
  ), [d, f] = O.useState([-1, -1]), h = O.useCallback((v) => {
    let m = v.target;
    for (; m && !["TH", "TD"].includes(m.tagName); ) {
      if (m === v.currentTarget)
        return;
      m = m.parentElement;
    }
    if (m === null)
      return;
    const b = m.parentElement, w = b.parentElement.tagName === "TFOOT" ? -1 : Array.from(b.children).indexOf(m), S = m.tagName === "TH" ? -1 : Array.from(b.parentElement.children).indexOf(b);
    f([w, S]);
  }, []), p = qi();
  return /* @__PURE__ */ O.createElement(
    "table",
    {
      className: it.tableEditor,
      onMouseOver: h,
      onMouseLeave: () => {
        f([-1, -1]);
      }
    },
    /* @__PURE__ */ O.createElement("colgroup", null, a ? null : /* @__PURE__ */ O.createElement("col", null), Array.from({ length: t.children[0].children.length }, (v, m) => {
      const y = (t.align ?? [])[m] ?? "left", w = Hee[y];
      return /* @__PURE__ */ O.createElement("col", { key: m, className: w });
    }), a ? null : /* @__PURE__ */ O.createElement("col", null)),
    a || /* @__PURE__ */ O.createElement("thead", null, /* @__PURE__ */ O.createElement("tr", null, /* @__PURE__ */ O.createElement("th", { className: it.tableToolsColumn }), Array.from({ length: t.children[0].children.length }, (v, m) => /* @__PURE__ */ O.createElement("th", { key: m, "data-tool-cell": !0 }, /* @__PURE__ */ O.createElement(
      Xot,
      {
        setActiveCellWithBoundaries: u,
        parentEditor: e,
        colIndex: m,
        highlightedCoordinates: d,
        lexicalTable: n,
        align: (t.align ?? [])[m]
      }
    ))), /* @__PURE__ */ O.createElement("th", { className: it.tableToolsColumn, "data-tool-cell": !0 }, /* @__PURE__ */ O.createElement(
      "button",
      {
        className: it.iconButton,
        type: "button",
        title: p("table.deleteTable", "Delete table"),
        onClick: (v) => {
          v.preventDefault(), e.update(() => {
            n.selectNext(), n.remove();
          });
        }
      },
      o("delete_small")
    )))),
    /* @__PURE__ */ O.createElement("tbody", null, t.children.map((v, m) => {
      const b = Bee(m);
      return /* @__PURE__ */ O.createElement("tr", { key: m }, a || /* @__PURE__ */ O.createElement(b, { className: it.toolCell, "data-tool-cell": !0 }, /* @__PURE__ */ O.createElement(Yot, { setActiveCellWithBoundaries: u, parentEditor: e, rowIndex: m, highlightedCoordinates: d, lexicalTable: n })), v.children.map((y, w) => {
        var S;
        return /* @__PURE__ */ O.createElement(
          Got,
          {
            align: (S = t.align) == null ? void 0 : S[w],
            key: s(y),
            contents: y.children,
            setActiveCell: u,
            rowIndex: m,
            colIndex: w,
            lexicalTable: n,
            parentEditor: e,
            activeCell: a ? [-1, -1] : r
          }
        );
      }), a || m === 0 && /* @__PURE__ */ O.createElement("th", { rowSpan: n.getRowCount(), "data-tool-cell": !0 }, /* @__PURE__ */ O.createElement("button", { type: "button", className: it.addColumnButton, onClick: c }, o("add_column"))));
    })),
    a || /* @__PURE__ */ O.createElement("tfoot", null, /* @__PURE__ */ O.createElement("tr", null, /* @__PURE__ */ O.createElement("th", null), /* @__PURE__ */ O.createElement("th", { colSpan: n.getColCount() }, /* @__PURE__ */ O.createElement("button", { type: "button", className: it.addRowButton, onClick: l }, o("add_row"))), /* @__PURE__ */ O.createElement("th", null)))
  );
}, Got = ({ align: t, ...e }) => {
  const { activeCell: n, setActiveCell: r } = e, i = !!(n && n[0] === e.colIndex && n[1] === e.rowIndex), o = Hee[t ?? "left"], a = Bee(e.rowIndex);
  return /* @__PURE__ */ O.createElement(
    a,
    {
      className: o,
      "data-active": i,
      onClick: () => {
        r([e.colIndex, e.rowIndex]);
      }
    },
    /* @__PURE__ */ O.createElement(Uot, { ...e, focus: i })
  );
}, Uot = ({ focus: t, setActiveCell: e, parentEditor: n, lexicalTable: r, contents: i, colIndex: o, rowIndex: a }) => {
  const [
    s,
    u,
    l,
    c,
    d,
    f,
    h,
    p
  ] = ya(
    EO,
    IO,
    SO,
    _O,
    Qq,
    eQ,
    qq,
    vl
  ), [v] = O.useState(() => {
    const b = FK({
      nodes: l,
      theme: $w
    });
    return b.update(() => {
      zq({
        root: hr(),
        mdastRoot: { type: "root", children: [{ type: "paragraph", children: i }] },
        visitors: s,
        jsxComponentDescriptors: c,
        directiveDescriptors: d,
        codeBlockEditorDescriptors: f
      });
    }), b;
  }), m = O.useCallback(
    (b) => {
      v.getEditorState().read(() => {
        const y = Oq({
          root: hr(),
          jsxComponentDescriptors: c,
          visitors: u,
          jsxIsAvailable: h
        });
        n.update(
          () => {
            r.updateCellContents(o, a, y.children[0].children);
          },
          { discrete: !0 }
        ), n.dispatchCommand(v2, void 0);
      }), e(b);
    },
    [o, v, u, c, h, r, n, a, e]
  );
  return O.useEffect(() => xa(
    v.registerCommand(
      kT,
      (b) => {
        b.preventDefault();
        const y = b.shiftKey ? [o - 1, a] : [o + 1, a];
        return m(y), !0;
      },
      vc
    ),
    v.registerCommand(
      FT,
      () => (e([o, a]), !1),
      Ar
    ),
    v.registerCommand(
      lp,
      (b) => {
        b == null || b.preventDefault();
        const y = b != null && b.shiftKey ? [o, a - 1] : [o, a + 1];
        return m(y), !0;
      },
      vc
    ),
    v.registerCommand(
      LT,
      (b) => {
        const y = b.relatedTarget;
        return Vee(y, p.getRootElement()) ? !1 : (m(null), !0);
      },
      kn
    ),
    v.registerCommand(
      v2,
      () => (m(null), !0),
      kn
    )
  ), [o, v, p, a, m, e]), O.useEffect(() => {
    t && v.focus();
  }, [t, v]), /* @__PURE__ */ O.createElement(Knt, { initialEditor: v }, /* @__PURE__ */ O.createElement(bQ, { contentEditable: /* @__PURE__ */ O.createElement(mQ, null), placeholder: /* @__PURE__ */ O.createElement("div", null), ErrorBoundary: vQ }), /* @__PURE__ */ O.createElement(GK, null));
}, Xot = ({
  parentEditor: t,
  highlightedCoordinates: e,
  align: n,
  lexicalTable: r,
  colIndex: i,
  setActiveCellWithBoundaries: o
}) => {
  const [a, s] = ya(lf, Bo), u = O.useCallback(
    (f) => {
      t.update(() => {
        r.insertColumnAt(f);
      }), o([f, 0]);
    },
    [t, r, o]
  ), l = O.useCallback(
    (f) => {
      t.update(() => {
        r.deleteColumnAt(f);
      });
    },
    [t, r]
  ), c = O.useCallback(
    (f, h) => {
      t.update(() => {
        r.setColumnAlign(f, h);
      });
    },
    [t, r]
  ), d = qi();
  return /* @__PURE__ */ O.createElement(e8, null, /* @__PURE__ */ O.createElement(
    vee,
    {
      className: it.tableColumnEditorTrigger,
      "data-active": e[0] === i + 1,
      title: d("table.columnMenu", "Column menu")
    },
    s("more_horiz")
  ), /* @__PURE__ */ O.createElement(t8, { container: a == null ? void 0 : a.current }, /* @__PURE__ */ O.createElement(
    QO,
    {
      className: Ce(it.tableColumnEditorPopoverContent),
      onOpenAutoFocus: (f) => {
        f.preventDefault();
      },
      sideOffset: 5,
      side: "top"
    },
    /* @__PURE__ */ O.createElement(i8, { className: it.tableColumnEditorToolbar }, /* @__PURE__ */ O.createElement(
      Gw,
      {
        className: it.toggleGroupRoot,
        onValueChange: (f) => {
          c(i, f);
        },
        value: n ?? "left",
        type: "single",
        "aria-label": d("table.textAlignment", "Text alignment")
      },
      /* @__PURE__ */ O.createElement(Ny, { value: "left", title: d("table.alignLeft", "Align left") }, s("format_align_left")),
      /* @__PURE__ */ O.createElement(Ny, { value: "center", title: d("table.alignCenter", "Align center") }, s("format_align_center")),
      /* @__PURE__ */ O.createElement(Ny, { value: "right", title: d("table.alignRight", "Align right") }, s("format_align_right"))
    ), /* @__PURE__ */ O.createElement(Wot, null), /* @__PURE__ */ O.createElement(
      ac,
      {
        onClick: u.bind(null, i),
        title: d("table.insertColumnLeft", "Insert a column to the left of this one")
      },
      s("insert_col_left")
    ), /* @__PURE__ */ O.createElement(
      ac,
      {
        onClick: u.bind(null, i + 1),
        title: d("table.insertColumnRight", "Insert a column to the right of this one")
      },
      s("insert_col_right")
    ), /* @__PURE__ */ O.createElement(ac, { onClick: l.bind(null, i), title: d("table.deleteColumn", "Delete this column") }, s("delete_small"))),
    /* @__PURE__ */ O.createElement(n8, { className: it.popoverArrow })
  )));
}, Yot = ({
  parentEditor: t,
  highlightedCoordinates: e,
  lexicalTable: n,
  rowIndex: r,
  setActiveCellWithBoundaries: i
}) => {
  const [o, a] = ya(lf, Bo), s = O.useCallback(
    (c) => {
      t.update(() => {
        n.insertRowAt(c);
      }), i([0, c]);
    },
    [t, n, i]
  ), u = O.useCallback(
    (c) => {
      t.update(() => {
        n.deleteRowAt(c);
      });
    },
    [t, n]
  ), l = qi();
  return /* @__PURE__ */ O.createElement(e8, null, /* @__PURE__ */ O.createElement(
    vee,
    {
      className: it.tableColumnEditorTrigger,
      "data-active": e[1] === r,
      title: l("table.rowMenu", "Row menu")
    },
    a("more_horiz")
  ), /* @__PURE__ */ O.createElement(t8, { container: o == null ? void 0 : o.current }, /* @__PURE__ */ O.createElement(
    QO,
    {
      className: Ce(it.tableColumnEditorPopoverContent),
      onOpenAutoFocus: (c) => {
        c.preventDefault();
      },
      sideOffset: 5,
      side: "bottom"
    },
    /* @__PURE__ */ O.createElement(i8, { className: it.tableColumnEditorToolbar }, /* @__PURE__ */ O.createElement(
      ac,
      {
        onClick: s.bind(null, r),
        title: l("table.insertRowAbove", "Insert a row above this one")
      },
      a("insert_row_above")
    ), /* @__PURE__ */ O.createElement(
      ac,
      {
        onClick: s.bind(null, r + 1),
        title: l("table.insertRowBelow", "Insert a row below this one")
      },
      a("insert_row_below")
    ), /* @__PURE__ */ O.createElement(ac, { onClick: u.bind(null, r), title: l("table.deleteRow", "Delete this row") }, a("delete_small"))),
    /* @__PURE__ */ O.createElement(n8, { className: it.popoverArrow })
  )));
};
var Zot = Object.defineProperty, Jot = (t, e, n) => e in t ? Zot(t, e, { enumerable: !0, configurable: !0, writable: !0, value: n }) : t[e] = n, iV = (t, e, n) => (Jot(t, typeof e != "symbol" ? e + "" : e, n), n);
const oV = { type: "tableCell", children: [] };
function Kot() {
  let t = jh;
  return {
    publish: (e) => {
      t(e);
    },
    subscribe: (e) => {
      t = e;
    }
  };
}
class _v extends yv {
  /**
   * Constructs a new {@link TableNode} with the specified MDAST table node as the object to edit.
   * See {@link https://github.com/micromark/micromark-extension-gfm-table | micromark/micromark-extension-gfm-table} for more information on the MDAST table node.
   */
  constructor(e, n) {
    super(n), iV(this, "__mdastNode"), iV(this, "focusEmitter", Kot()), this.__mdastNode = e ?? { type: "table", children: [] };
  }
  /** @internal */
  static getType() {
    return "table";
  }
  /** @internal */
  static clone(e) {
    return new _v(structuredClone(e.__mdastNode), e.__key);
  }
  /** @internal */
  static importJSON(e) {
    return o8(e.mdastNode);
  }
  /** @internal */
  exportJSON() {
    return {
      mdastNode: structuredClone(this.__mdastNode),
      type: "table",
      version: 1
    };
  }
  /**
   * Returns the mdast node that this node is constructed from.
   */
  getMdastNode() {
    return this.__mdastNode;
  }
  /**
   * Returns the number of rows in the table.
   */
  getRowCount() {
    return this.__mdastNode.children.length;
  }
  /**
   * Returns the number of columns in the table.
   */
  getColCount() {
    var e;
    return ((e = this.__mdastNode.children[0]) == null ? void 0 : e.children.length) || 0;
  }
  /** @internal */
  createDOM() {
    return document.createElement("div");
  }
  /** @internal */
  updateDOM() {
    return !1;
  }
  /** @internal */
  updateCellContents(e, n, r) {
    const o = this.getWritable().__mdastNode, a = o.children[n], s = a.children, u = s[e], l = Array.from(s), c = { ...u, children: r }, d = { ...a, children: l };
    l[e] = c, o.children[n] = d;
  }
  insertColumnAt(e) {
    const r = this.getWritable().__mdastNode;
    for (let i = 0; i < r.children.length; i++) {
      const o = r.children[i], a = o.children, s = Array.from(a), u = { ...o, children: s };
      s.splice(e, 0, structuredClone(oV)), r.children[i] = u;
    }
    r.align && r.align.length > 0 && r.align.splice(e, 0, "left");
  }
  deleteColumnAt(e) {
    const r = this.getWritable().__mdastNode;
    for (let i = 0; i < r.children.length; i++) {
      const o = r.children[i], a = o.children, s = Array.from(a), u = { ...o, children: s };
      s.splice(e, 1), r.children[i] = u;
    }
  }
  insertRowAt(e) {
    const r = this.getWritable().__mdastNode, i = {
      type: "tableRow",
      children: Array.from({ length: this.getColCount() }, () => structuredClone(oV))
    };
    r.children.splice(e, 0, i);
  }
  deleteRowAt(e) {
    this.getRowCount() === 1 ? (this.selectNext(), this.remove()) : this.getWritable().__mdastNode.children.splice(e, 1);
  }
  addRowToBottom() {
    this.insertRowAt(this.getRowCount());
  }
  addColumnToRight() {
    this.insertColumnAt(this.getColCount());
  }
  setColumnAlign(e, n) {
    const i = this.getWritable().__mdastNode;
    i.align == null && (i.align = []), i.align[e] = n;
  }
  /** @internal */
  decorate(e) {
    return /* @__PURE__ */ O.createElement(zot, { lexicalTable: this, mdastNode: this.__mdastNode, parentEditor: e });
  }
  /**
   * Focuses the table cell at the specified coordinates.
   * Pass `undefined` to remove the focus.
   */
  select(e) {
    this.focusEmitter.publish(e ?? [0, 0]);
  }
  /** @internal */
  isInline() {
    return !1;
  }
}
function qot(t) {
  return t instanceof _v;
}
function o8(t) {
  return new _v(t);
}
const Qot = {
  testLexicalNode: qot,
  visitLexicalNode({ actions: t, mdastParent: e, lexicalNode: n }) {
    t.appendToParent(e, n.getMdastNode());
  }
}, eat = {
  testNode: "table",
  visitNode({ mdastNode: t, lexicalParent: e }) {
    e.append(o8(t));
  }
};
function tat(t = 1, e = 1) {
  const n = {
    type: "table",
    children: []
  };
  for (let r = 0; r < t; r++) {
    const i = {
      type: "tableRow",
      children: []
    };
    for (let o = 0; o < e; o++) {
      const a = {
        type: "tableCell",
        children: []
      };
      i.children.push(a);
    }
    n.children.push(i);
  }
  return n;
}
const Wee = Ei((t) => {
  t.link(
    t.pipe(
      Wee,
      Wh(({ rows: e, columns: n }) => () => o8(tat(e, n)))
    ),
    dQ
  );
}), nat = pl({
  init(t, e) {
    t.pubIn({
      // import
      [x2]: $nt(),
      [y2]: znt(),
      [bc]: eat,
      // export
      [cf]: _v,
      [df]: Qot,
      [AO]: Bnt({
        tableCellPadding: (e == null ? void 0 : e.tableCellPadding) ?? !0,
        tablePipeAlign: (e == null ? void 0 : e.tablePipeAlign) ?? !0
      })
    });
  }
}), rat = /* @__PURE__ */ new Set(["http:", "https:", "mailto:", "sms:", "tel:"]);
let Av = class jee extends Eu {
  static getType() {
    return "link";
  }
  static clone(e) {
    return new jee(e.__url, { rel: e.__rel, target: e.__target, title: e.__title }, e.__key);
  }
  constructor(e, n = {}, r) {
    super(r);
    const { target: i = null, rel: o = null, title: a = null } = n;
    this.__url = e, this.__target = i, this.__rel = o, this.__title = a;
  }
  createDOM(e) {
    const n = document.createElement("a");
    return n.href = this.sanitizeUrl(this.__url), this.__target !== null && (n.target = this.__target), this.__rel !== null && (n.rel = this.__rel), this.__title !== null && (n.title = this.__title), uf(n, e.theme.link), n;
  }
  updateDOM(e, n, r) {
    if (n instanceof HTMLAnchorElement) {
      const i = this.__url, o = this.__target, a = this.__rel, s = this.__title;
      i !== e.__url && (n.href = i), o !== e.__target && (o ? n.target = o : n.removeAttribute("target")), a !== e.__rel && (a ? n.rel = a : n.removeAttribute("rel")), s !== e.__title && (s ? n.title = s : n.removeAttribute("title"));
    }
    return !1;
  }
  static importDOM() {
    return { a: (e) => ({ conversion: iat, priority: 1 }) };
  }
  static importJSON(e) {
    const n = pp(e.url, { rel: e.rel, target: e.target, title: e.title });
    return n.setFormat(e.format), n.setIndent(e.indent), n.setDirection(e.direction), n;
  }
  sanitizeUrl(e) {
    try {
      const n = new URL(e);
      if (!rat.has(n.protocol))
        return "about:blank";
    } catch {
      return e;
    }
    return e;
  }
  exportJSON() {
    return { ...super.exportJSON(), rel: this.getRel(), target: this.getTarget(), title: this.getTitle(), type: "link", url: this.getURL(), version: 1 };
  }
  getURL() {
    return this.getLatest().__url;
  }
  setURL(e) {
    this.getWritable().__url = e;
  }
  getTarget() {
    return this.getLatest().__target;
  }
  setTarget(e) {
    this.getWritable().__target = e;
  }
  getRel() {
    return this.getLatest().__rel;
  }
  setRel(e) {
    this.getWritable().__rel = e;
  }
  getTitle() {
    return this.getLatest().__title;
  }
  setTitle(e) {
    this.getWritable().__title = e;
  }
  insertNewAfter(e, n = !0) {
    const r = pp(this.__url, { rel: this.__rel, target: this.__target, title: this.__title });
    return this.insertAfter(r, n), r;
  }
  canInsertTextBefore() {
    return !1;
  }
  canInsertTextAfter() {
    return !1;
  }
  canBeEmpty() {
    return !1;
  }
  isInline() {
    return !0;
  }
  extractWithChild(e, n, r) {
    if (!rt(n))
      return !1;
    const i = n.anchor.getNode(), o = n.focus.getNode();
    return this.isParentOf(i) && this.isParentOf(o) && n.getTextContent().length > 0;
  }
  isEmailURI() {
    return this.__url.startsWith("mailto:");
  }
  isWebSiteURI() {
    return this.__url.startsWith("https://") || this.__url.startsWith("http://");
  }
};
function iat(t) {
  let e = null;
  if (oXe(t)) {
    const n = t.textContent;
    (n !== null && n !== "" || t.children.length > 0) && (e = pp(t.getAttribute("href") || "", { rel: t.getAttribute("rel"), target: t.getAttribute("target"), title: t.getAttribute("title") }));
  }
  return { node: e };
}
function pp(t, e) {
  return Qa(new Av(t, e));
}
function Uu(t) {
  return t instanceof Av;
}
class Up extends Av {
  constructor(e, n = {}, r) {
    super(e, n, r), this.__isUnlinked = n.isUnlinked !== void 0 && n.isUnlinked !== null && n.isUnlinked;
  }
  static getType() {
    return "autolink";
  }
  static clone(e) {
    return new Up(e.__url, { isUnlinked: e.__isUnlinked, rel: e.__rel, target: e.__target, title: e.__title }, e.__key);
  }
  getIsUnlinked() {
    return this.__isUnlinked;
  }
  setIsUnlinked(e) {
    const n = this.getWritable();
    return n.__isUnlinked = e, n;
  }
  createDOM(e) {
    return this.__isUnlinked ? document.createElement("span") : super.createDOM(e);
  }
  updateDOM(e, n, r) {
    return super.updateDOM(e, n, r) || e.__isUnlinked !== this.__isUnlinked;
  }
  static importJSON(e) {
    const n = s6(e.url, { isUnlinked: e.isUnlinked, rel: e.rel, target: e.target, title: e.title });
    return n.setFormat(e.format), n.setIndent(e.indent), n.setDirection(e.direction), n;
  }
  static importDOM() {
    return null;
  }
  exportJSON() {
    return { ...super.exportJSON(), isUnlinked: this.__isUnlinked, type: "autolink", version: 1 };
  }
  insertNewAfter(e, n = !0) {
    const r = this.getParentOrThrow().insertNewAfter(e, n);
    if (We(r)) {
      const i = s6(this.__url, { isUnlinked: this.__isUnlinked, rel: this.__rel, target: this.__target, title: this.__title });
      return r.append(i), i;
    }
    return null;
  }
}
function s6(t, e) {
  return Qa(new Up(t, e));
}
function Eh(t) {
  return t instanceof Up;
}
const gp = gl();
function w5(t, e = {}) {
  const { target: n, title: r } = e, i = e.rel === void 0 ? "noreferrer" : e.rel, o = vt();
  if (!rt(o))
    return;
  const a = o.extract();
  if (t === null)
    a.forEach((s) => {
      const u = s.getParent();
      if (!Eh(u) && Uu(u)) {
        const l = u.getChildren();
        for (let c = 0; c < l.length; c++)
          u.insertBefore(l[c]);
        u.remove();
      }
    });
  else {
    if (a.length === 1) {
      const l = function(c, d) {
        let f = c;
        for (; f !== null && f.getParent() !== null && !d(f); )
          f = f.getParentOrThrow();
        return d(f) ? f : null;
      }(a[0], Uu);
      if (l !== null)
        return l.setURL(t), n !== void 0 && l.setTarget(n), i !== null && l.setRel(i), void (r !== void 0 && l.setTitle(r));
    }
    let s = null, u = null;
    a.forEach((l) => {
      const c = l.getParent();
      if (c !== u && c !== null && (!We(l) || l.isInline())) {
        if (Uu(c))
          return u = c, c.setURL(t), n !== void 0 && c.setTarget(n), i !== null && u.setRel(i), void (r !== void 0 && u.setTitle(r));
        if (c.is(s) || (s = c, u = pp(t, { rel: i, target: n, title: r }), Uu(c) ? l.getPreviousSibling() === null ? c.insertBefore(u) : c.insertAfter(u) : l.insertBefore(u)), Uu(l)) {
          if (l.is(u))
            return;
          if (u !== null) {
            const d = l.getChildren();
            for (let f = 0; f < d.length; f++)
              u.append(d[f]);
          }
          l.remove();
        } else
          u !== null && u.append(l);
      }
    });
  }
}
const oat = {
  testNode: "link",
  visitNode({ mdastNode: t, actions: e }) {
    e.addAndStepInto(
      pp(t.url, {
        title: t.title
      })
    );
  }
}, aat = {
  testLexicalNode: Uu,
  visitLexicalNode: ({ lexicalNode: t, actions: e }) => {
    e.addAndStepInto("link", { url: t.getURL(), title: t.getTitle() });
  }
};
function sat({ validateUrl: t }) {
  const [e] = Vo();
  return Re(() => {
    if (!e.hasNodes([Av]))
      throw new Error("LinkPlugin: LinkNode not registered on editor");
    return xa(e.registerCommand(gp, (n) => {
      if (n === null)
        return w5(n), !0;
      if (typeof n == "string")
        return !(t !== void 0 && !t(n)) && (w5(n), !0);
      {
        const { url: r, target: i, rel: o, title: a } = n;
        return w5(r, { rel: o, target: i, title: a }), !0;
      }
    }, Ar), t !== void 0 ? e.registerCommand(hv, (n) => {
      const r = vt();
      if (!rt(r) || r.isCollapsed() || !ql(n, ClipboardEvent))
        return !1;
      const i = n;
      if (i.clipboardData === null)
        return !1;
      const o = i.clipboardData.getData("text");
      return !!t(o) && !r.getNodes().some((a) => We(a)) && (e.dispatchCommand(gp, o), n.preventDefault(), !0);
    }, Ar) : () => {
    });
  }, [e, t]), null;
}
function uat(t) {
  return t && t.__esModule && Object.prototype.hasOwnProperty.call(t, "default") ? t.default : t;
}
var lat = uat(function(t) {
  const e = new URLSearchParams();
  e.append("code", t);
  for (let n = 1; n < arguments.length; n++)
    e.append("v", arguments[n]);
  throw Error(`Minified Lexical error #${t}; visit https://lexical.dev/docs/error?${e} for the full message or use the non-minified dev environment for full errors and additional helpful warnings.`);
});
function aV(t, e = (n) => n) {
  return (n) => {
    const r = t.exec(n);
    return r === null ? null : { index: r.index, length: r[0].length, text: r[0], url: e(r[0]) };
  };
}
function zee(t, e) {
  for (let n = 0; n < e.length; n++) {
    const r = e[n](t);
    if (r)
      return r;
  }
  return null;
}
const cat = /[.,;\s]/;
function O2(t) {
  return cat.test(t);
}
function Gee(t) {
  return O2(t[t.length - 1]);
}
function u6(t) {
  return O2(t[0]);
}
function Uee(t) {
  let e = t.getPreviousSibling();
  return We(e) && (e = e.getLastDescendant()), e === null || lu(e) || pt(e) && Gee(e.getTextContent());
}
function Xee(t) {
  let e = t.getNextSibling();
  return We(e) && (e = e.getFirstDescendant()), e === null || lu(e) || pt(e) && u6(e.getTextContent());
}
function dat(t, e, n, r) {
  return (t > 0 ? O2(n[t - 1]) : Uee(r[0])) ? e < n.length ? O2(n[e]) : Xee(r[r.length - 1]) : !1;
}
function fat(t, e, n) {
  const r = [], i = [], o = [];
  let a = 0, s = 0;
  const u = [...t];
  for (; u.length > 0; ) {
    const l = u[0], c = l.getTextContent().length, d = s;
    s + c <= e ? (r.push(l), a += c) : d >= n ? o.push(l) : i.push(l), s += c, u.shift();
  }
  return [a, r, i, o];
}
function hat(t, e, n, r) {
  const i = s6(r.url, r.attributes);
  if (t.length === 1) {
    let o, a = t[0];
    e === 0 ? [o, a] = a.splitText(n) : [, o, a] = a.splitText(e, n);
    const s = Xr(r.text);
    return s.setFormat(o.getFormat()), s.setDetail(o.getDetail()), s.setStyle(o.getStyle()), i.append(s), o.replace(i), a;
  }
  if (t.length > 1) {
    const o = t[0];
    let a, s = o.getTextContent().length;
    e === 0 ? a = o : [, a] = o.splitText(e);
    const u = [];
    let l;
    for (let h = 1; h < t.length; h++) {
      const p = t[h], v = p.getTextContent().length, m = s;
      if (m < n)
        if (s + v <= n)
          u.push(p);
        else {
          const [b, y] = p.splitText(n - m);
          u.push(b), l = y;
        }
      s += v;
    }
    const c = vt(), d = c ? c.getNodes().find(pt) : void 0, f = Xr(a.getTextContent());
    return f.setFormat(a.getFormat()), f.setDetail(a.getDetail()), f.setStyle(a.getStyle()), i.append(f, ...u), d && d === a && (rt(c) ? f.select(c.anchor.offset, c.focus.offset) : li(c) && f.select(0, f.getTextContent().length)), a.replace(i), l;
  }
}
function E5(t, e, n) {
  const r = t.getChildren(), i = r.length;
  for (let u = 0; u < i; u++) {
    const l = r[u];
    if (!pt(l) || !l.isSimpleText())
      return ky(t), void n(null, t.getURL());
  }
  const o = t.getTextContent(), a = zee(o, e);
  if (a === null || a.text !== o || !Uee(t) || !Xee(t))
    return ky(t), void n(null, t.getURL());
  const s = t.getURL();
  if (s !== a.url && (t.setURL(a.url), n(a.url, s)), a.attributes) {
    const u = t.getRel();
    u !== a.attributes.rel && (t.setRel(a.attributes.rel || null), n(a.attributes.rel || null, u));
    const l = t.getTarget();
    l !== a.attributes.target && (t.setTarget(a.attributes.target || null), n(a.attributes.target || null, l));
  }
}
function ky(t) {
  const e = t.getChildren();
  for (let n = e.length - 1; n >= 0; n--)
    t.insertAfter(e[n]);
  return t.remove(), e.map((n) => n.getLatest());
}
function pat(t, e, n) {
  Re(() => {
    t.hasNodes([Up]) || lat(77);
    const r = (i, o) => {
      n && n(i, o);
    };
    return xa(t.registerNodeTransform(Lp, (i) => {
      const o = i.getParentOrThrow(), a = i.getPreviousSibling();
      if (Eh(o) && !o.getIsUnlinked())
        E5(o, e, r);
      else if (!Uu(o)) {
        if (i.isSimpleText() && (u6(i.getTextContent()) || !Eh(a))) {
          const s = function(u) {
            const l = [u];
            let c = u.getNextSibling();
            for (; c !== null && pt(c) && c.isSimpleText() && (l.push(c), !/[\s]/.test(c.getTextContent())); )
              c = c.getNextSibling();
            return l;
          }(i);
          (function(u, l, c) {
            let d = [...u];
            const f = d.map((m) => m.getTextContent()).join("");
            let h, p = f, v = 0;
            for (; (h = zee(p, l)) && h !== null; ) {
              const m = h.index, b = m + h.length;
              if (dat(v + m, v + b, f, d)) {
                const [y, , w, S] = fat(d, v + m, v + b), E = hat(w, v + m - y, v + b - y, h);
                d = E ? [E, ...S] : S, c(h.url, null), v = 0;
              } else
                v += b;
              p = p.substring(b);
            }
          })(s, e, r);
        }
        (function(s, u, l) {
          const c = s.getPreviousSibling(), d = s.getNextSibling(), f = s.getTextContent();
          var h;
          !Eh(c) || c.getIsUnlinked() || u6(f) && (h = f, !(c.isEmailURI() ? /^\.[a-zA-Z]{2,}/.test(h) : /^\.[a-zA-Z0-9]{1,}/.test(h))) || (c.append(s), E5(c, u, l), l(null, c.getURL())), !Eh(d) || d.getIsUnlinked() || Gee(f) || (ky(d), E5(d, u, l), l(null, d.getURL()));
        })(i, e, r);
      }
    }), t.registerCommand(gp, (i) => {
      const o = vt();
      return i !== null || !rt(o) || o.extract().forEach((a) => {
        const s = a.getParent();
        if (Eh(s))
          return s.setIsUnlinked(!s.getIsUnlinked()), s.markDirty(), !0;
      }), !1;
    }, Ar));
  }, [t, e, n]);
}
function gat({ matchers: t, onChange: e }) {
  const [n] = Vo();
  return pat(n, t, e), null;
}
const mat = /((https?:\/\/(www\.)?)|(www\.))[-a-zA-Z0-9@:%._+~#=]{1,256}\.[a-zA-Z0-9()]{1,6}\b([-a-zA-Z0-9()@:%_+.~#?&//=]*)/, vat = /(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))/, bat = [
  aV(mat, (t) => t.startsWith("http") ? t : `https://${t}`),
  aV(vat, (t) => `mailto:${t}`)
], yat = () => /* @__PURE__ */ O.createElement(gat, { matchers: bat }), xat = Ht(!1), Cat = pl({
  init(t, e) {
    const n = !!(e != null && e.disableAutoLink), r = e != null && e.validateUrl ? { validateUrl: e.validateUrl } : {};
    t.pubIn({
      [PO]: "link",
      [bc]: oat,
      [cf]: [Av, Up],
      [df]: aat,
      [xat]: n,
      [jp]: () => /* @__PURE__ */ O.createElement(O.Fragment, null, /* @__PURE__ */ O.createElement(sat, { ...r }), n ? null : /* @__PURE__ */ O.createElement(yat, null))
    });
  }
}), l6 = "dismissableLayer.update", wat = "dismissableLayer.pointerDownOutside", Eat = "dismissableLayer.focusOutside";
let sV;
const Sat = /* @__PURE__ */ oi({
  layers: /* @__PURE__ */ new Set(),
  layersWithOutsidePointerEventsDisabled: /* @__PURE__ */ new Set(),
  branches: /* @__PURE__ */ new Set()
}), Iat = /* @__PURE__ */ gt((t, e) => {
  var n;
  const { disableOutsidePointerEvents: r = !1, onEscapeKeyDown: i, onPointerDownOutside: o, onFocusOutside: a, onInteractOutside: s, onDismiss: u, ...l } = t, c = fn(Sat), [d, f] = Le(null), h = (n = d == null ? void 0 : d.ownerDocument) !== null && n !== void 0 ? n : globalThis == null ? void 0 : globalThis.document, [, p] = Le({}), v = Kn(
    e,
    (A) => f(A)
  ), m = Array.from(c.layers), [b] = [
    ...c.layersWithOutsidePointerEventsDisabled
  ].slice(-1), y = m.indexOf(b), w = d ? m.indexOf(d) : -1, S = c.layersWithOutsidePointerEventsDisabled.size > 0, E = w >= y, I = _at((A) => {
    const P = A.target, N = [
      ...c.branches
    ].some(
      (k) => k.contains(P)
    );
    !E || N || (o == null || o(A), s == null || s(A), A.defaultPrevented || u == null || u());
  }, h), _ = Aat((A) => {
    const P = A.target;
    [
      ...c.branches
    ].some(
      (k) => k.contains(P)
    ) || (a == null || a(A), s == null || s(A), A.defaultPrevented || u == null || u());
  }, h);
  return Lw((A) => {
    w === c.layers.size - 1 && (i == null || i(A), !A.defaultPrevented && u && (A.preventDefault(), u()));
  }, h), Re(() => {
    if (d)
      return r && (c.layersWithOutsidePointerEventsDisabled.size === 0 && (sV = h.body.style.pointerEvents, h.body.style.pointerEvents = "none"), c.layersWithOutsidePointerEventsDisabled.add(d)), c.layers.add(d), uV(), () => {
        r && c.layersWithOutsidePointerEventsDisabled.size === 1 && (h.body.style.pointerEvents = sV);
      };
  }, [
    d,
    h,
    r,
    c
  ]), Re(() => () => {
    d && (c.layers.delete(d), c.layersWithOutsidePointerEventsDisabled.delete(d), uV());
  }, [
    d,
    c
  ]), Re(() => {
    const A = () => p({});
    return document.addEventListener(l6, A), () => document.removeEventListener(l6, A);
  }, []), /* @__PURE__ */ Pe(Sn.div, G({}, l, {
    ref: v,
    style: {
      pointerEvents: S ? E ? "auto" : "none" : void 0,
      ...t.style
    },
    onFocusCapture: ln(t.onFocusCapture, _.onFocusCapture),
    onBlurCapture: ln(t.onBlurCapture, _.onBlurCapture),
    onPointerDownCapture: ln(t.onPointerDownCapture, I.onPointerDownCapture)
  }));
});
function _at(t, e = globalThis == null ? void 0 : globalThis.document) {
  const n = Kr(t), r = Ee(!1), i = Ee(() => {
  });
  return Re(() => {
    const o = (s) => {
      if (s.target && !r.current) {
        let l = function() {
          Yee(wat, n, u, {
            discrete: !0
          });
        };
        const u = {
          originalEvent: s
        };
        s.pointerType === "touch" ? (e.removeEventListener("click", i.current), i.current = l, e.addEventListener("click", i.current, {
          once: !0
        })) : l();
      } else
        e.removeEventListener("click", i.current);
      r.current = !1;
    }, a = window.setTimeout(() => {
      e.addEventListener("pointerdown", o);
    }, 0);
    return () => {
      window.clearTimeout(a), e.removeEventListener("pointerdown", o), e.removeEventListener("click", i.current);
    };
  }, [
    e,
    n
  ]), {
    // ensures we check React component tree (not just DOM tree)
    onPointerDownCapture: () => r.current = !0
  };
}
function Aat(t, e = globalThis == null ? void 0 : globalThis.document) {
  const n = Kr(t), r = Ee(!1);
  return Re(() => {
    const i = (o) => {
      o.target && !r.current && Yee(Eat, n, {
        originalEvent: o
      }, {
        discrete: !1
      });
    };
    return e.addEventListener("focusin", i), () => e.removeEventListener("focusin", i);
  }, [
    e,
    n
  ]), {
    onFocusCapture: () => r.current = !0,
    onBlurCapture: () => r.current = !1
  };
}
function uV() {
  const t = new CustomEvent(l6);
  document.dispatchEvent(t);
}
function Yee(t, e, n, { discrete: r }) {
  const i = n.originalEvent.target, o = new CustomEvent(t, {
    bubbles: !1,
    cancelable: !0,
    detail: n
  });
  e && i.addEventListener(t, e, {
    once: !0
  }), r ? Fw(i, o) : i.dispatchEvent(o);
}
const S5 = "focusScope.autoFocusOnMount", I5 = "focusScope.autoFocusOnUnmount", lV = {
  bubbles: !1,
  cancelable: !0
}, Tat = /* @__PURE__ */ gt((t, e) => {
  const { loop: n = !1, trapped: r = !1, onMountAutoFocus: i, onUnmountAutoFocus: o, ...a } = t, [s, u] = Le(null), l = Kr(i), c = Kr(o), d = Ee(null), f = Kn(
    e,
    (v) => u(v)
  ), h = Ee({
    paused: !1,
    pause() {
      this.paused = !0;
    },
    resume() {
      this.paused = !1;
    }
  }).current;
  Re(() => {
    if (r) {
      let v = function(w) {
        if (h.paused || !s)
          return;
        const S = w.target;
        s.contains(S) ? d.current = S : Bl(d.current, {
          select: !0
        });
      }, m = function(w) {
        if (h.paused || !s)
          return;
        const S = w.relatedTarget;
        S !== null && (s.contains(S) || Bl(d.current, {
          select: !0
        }));
      }, b = function(w) {
        if (document.activeElement === document.body)
          for (const E of w)
            E.removedNodes.length > 0 && Bl(s);
      };
      document.addEventListener("focusin", v), document.addEventListener("focusout", m);
      const y = new MutationObserver(b);
      return s && y.observe(s, {
        childList: !0,
        subtree: !0
      }), () => {
        document.removeEventListener("focusin", v), document.removeEventListener("focusout", m), y.disconnect();
      };
    }
  }, [
    r,
    s,
    h.paused
  ]), Re(() => {
    if (s) {
      dV.add(h);
      const v = document.activeElement;
      if (!s.contains(v)) {
        const b = new CustomEvent(S5, lV);
        s.addEventListener(S5, l), s.dispatchEvent(b), b.defaultPrevented || (Oat($at(Zee(s)), {
          select: !0
        }), document.activeElement === v && Bl(s));
      }
      return () => {
        s.removeEventListener(S5, l), setTimeout(() => {
          const b = new CustomEvent(I5, lV);
          s.addEventListener(I5, c), s.dispatchEvent(b), b.defaultPrevented || Bl(v ?? document.body, {
            select: !0
          }), s.removeEventListener(I5, c), dV.remove(h);
        }, 0);
      };
    }
  }, [
    s,
    l,
    c,
    h
  ]);
  const p = et((v) => {
    if (!n && !r || h.paused)
      return;
    const m = v.key === "Tab" && !v.altKey && !v.ctrlKey && !v.metaKey, b = document.activeElement;
    if (m && b) {
      const y = v.currentTarget, [w, S] = Pat(y);
      w && S ? !v.shiftKey && b === S ? (v.preventDefault(), n && Bl(w, {
        select: !0
      })) : v.shiftKey && b === w && (v.preventDefault(), n && Bl(S, {
        select: !0
      })) : b === y && v.preventDefault();
    }
  }, [
    n,
    r,
    h.paused
  ]);
  return /* @__PURE__ */ Pe(Sn.div, G({
    tabIndex: -1
  }, a, {
    ref: f,
    onKeyDown: p
  }));
});
function Oat(t, { select: e = !1 } = {}) {
  const n = document.activeElement;
  for (const r of t)
    if (Bl(r, {
      select: e
    }), document.activeElement !== n)
      return;
}
function Pat(t) {
  const e = Zee(t), n = cV(e, t), r = cV(e.reverse(), t);
  return [
    n,
    r
  ];
}
function Zee(t) {
  const e = [], n = document.createTreeWalker(t, NodeFilter.SHOW_ELEMENT, {
    acceptNode: (r) => {
      const i = r.tagName === "INPUT" && r.type === "hidden";
      return r.disabled || r.hidden || i ? NodeFilter.FILTER_SKIP : r.tabIndex >= 0 ? NodeFilter.FILTER_ACCEPT : NodeFilter.FILTER_SKIP;
    }
  });
  for (; n.nextNode(); )
    e.push(n.currentNode);
  return e;
}
function cV(t, e) {
  for (const n of t)
    if (!Nat(n, {
      upTo: e
    }))
      return n;
}
function Nat(t, { upTo: e }) {
  if (getComputedStyle(t).visibility === "hidden")
    return !0;
  for (; t; ) {
    if (e !== void 0 && t === e)
      return !1;
    if (getComputedStyle(t).display === "none")
      return !0;
    t = t.parentElement;
  }
  return !1;
}
function kat(t) {
  return t instanceof HTMLInputElement && "select" in t;
}
function Bl(t, { select: e = !1 } = {}) {
  if (t && t.focus) {
    const n = document.activeElement;
    t.focus({
      preventScroll: !0
    }), t !== n && kat(t) && e && t.select();
  }
}
const dV = Rat();
function Rat() {
  let t = [];
  return {
    add(e) {
      const n = t[0];
      e !== n && (n == null || n.pause()), t = fV(t, e), t.unshift(e);
    },
    remove(e) {
      var n;
      t = fV(t, e), (n = t[0]) === null || n === void 0 || n.resume();
    }
  };
}
function fV(t, e) {
  const n = [
    ...t
  ], r = n.indexOf(e);
  return r !== -1 && n.splice(r, 1), n;
}
function $at(t) {
  return t.filter(
    (e) => e.tagName !== "A"
  );
}
const Dat = /* @__PURE__ */ gt((t, e) => {
  var n;
  const { container: r = globalThis == null || (n = globalThis.document) === null || n === void 0 ? void 0 : n.body, ...i } = t;
  return r ? /* @__PURE__ */ ks.createPortal(/* @__PURE__ */ Pe(Sn.div, G({}, i, {
    ref: e
  })), r) : null;
}), Jee = "Dialog", [Kee, _bt] = Vs(Jee), [Mat, yl] = Kee(Jee), Fat = (t) => {
  const { __scopeDialog: e, children: n, open: r, defaultOpen: i, onOpenChange: o, modal: a = !0 } = t, s = Ee(null), u = Ee(null), [l = !1, c] = sl({
    prop: r,
    defaultProp: i,
    onChange: o
  });
  return /* @__PURE__ */ Pe(Mat, {
    scope: e,
    triggerRef: s,
    contentRef: u,
    contentId: oc(),
    titleId: oc(),
    descriptionId: oc(),
    open: l,
    onOpenChange: c,
    onOpenToggle: et(
      () => c(
        (d) => !d
      ),
      [
        c
      ]
    ),
    modal: a
  }, n);
}, qee = "DialogPortal", [Lat, Qee] = Kee(qee, {
  forceMount: void 0
}), Vat = (t) => {
  const { __scopeDialog: e, forceMount: n, children: r, container: i } = t, o = yl(qee, e);
  return /* @__PURE__ */ Pe(Lat, {
    scope: e,
    forceMount: n
  }, za.map(
    r,
    (a) => /* @__PURE__ */ Pe(Dc, {
      present: n || o.open
    }, /* @__PURE__ */ Pe(Dat, {
      asChild: !0,
      container: i
    }, a))
  ));
}, c6 = "DialogOverlay", Bat = /* @__PURE__ */ gt((t, e) => {
  const n = Qee(c6, t.__scopeDialog), { forceMount: r = n.forceMount, ...i } = t, o = yl(c6, t.__scopeDialog);
  return o.modal ? /* @__PURE__ */ Pe(Dc, {
    present: r || o.open
  }, /* @__PURE__ */ Pe(Hat, G({}, i, {
    ref: e
  }))) : null;
}), Hat = /* @__PURE__ */ gt((t, e) => {
  const { __scopeDialog: n, ...r } = t, i = yl(c6, n);
  return (
    // Make sure `Content` is scrollable even when it doesn't live inside `RemoveScroll`
    // ie. when `Overlay` and `Content` are siblings
    /* @__PURE__ */ Pe(qO, {
      as: Hd,
      allowPinchZoom: !0,
      shards: [
        i.contentRef
      ]
    }, /* @__PURE__ */ Pe(Sn.div, G({
      "data-state": tte(i.open)
    }, r, {
      ref: e,
      style: {
        pointerEvents: "auto",
        ...r.style
      }
    })))
  );
}), xm = "DialogContent", Wat = /* @__PURE__ */ gt((t, e) => {
  const n = Qee(xm, t.__scopeDialog), { forceMount: r = n.forceMount, ...i } = t, o = yl(xm, t.__scopeDialog);
  return /* @__PURE__ */ Pe(Dc, {
    present: r || o.open
  }, o.modal ? /* @__PURE__ */ Pe(jat, G({}, i, {
    ref: e
  })) : /* @__PURE__ */ Pe(zat, G({}, i, {
    ref: e
  })));
}), jat = /* @__PURE__ */ gt((t, e) => {
  const n = yl(xm, t.__scopeDialog), r = Ee(null), i = Kn(e, n.contentRef, r);
  return Re(() => {
    const o = r.current;
    if (o)
      return KO(o);
  }, []), /* @__PURE__ */ Pe(ete, G({}, t, {
    ref: i,
    trapFocus: n.open,
    disableOutsidePointerEvents: !0,
    onCloseAutoFocus: ln(t.onCloseAutoFocus, (o) => {
      var a;
      o.preventDefault(), (a = n.triggerRef.current) === null || a === void 0 || a.focus();
    }),
    onPointerDownOutside: ln(t.onPointerDownOutside, (o) => {
      const a = o.detail.originalEvent, s = a.button === 0 && a.ctrlKey === !0;
      (a.button === 2 || s) && o.preventDefault();
    }),
    onFocusOutside: ln(
      t.onFocusOutside,
      (o) => o.preventDefault()
    )
  }));
}), zat = /* @__PURE__ */ gt((t, e) => {
  const n = yl(xm, t.__scopeDialog), r = Ee(!1), i = Ee(!1);
  return /* @__PURE__ */ Pe(ete, G({}, t, {
    ref: e,
    trapFocus: !1,
    disableOutsidePointerEvents: !1,
    onCloseAutoFocus: (o) => {
      var a;
      if ((a = t.onCloseAutoFocus) === null || a === void 0 || a.call(t, o), !o.defaultPrevented) {
        var s;
        r.current || (s = n.triggerRef.current) === null || s === void 0 || s.focus(), o.preventDefault();
      }
      r.current = !1, i.current = !1;
    },
    onInteractOutside: (o) => {
      var a, s;
      (a = t.onInteractOutside) === null || a === void 0 || a.call(t, o), o.defaultPrevented || (r.current = !0, o.detail.originalEvent.type === "pointerdown" && (i.current = !0));
      const u = o.target;
      ((s = n.triggerRef.current) === null || s === void 0 ? void 0 : s.contains(u)) && o.preventDefault(), o.detail.originalEvent.type === "focusin" && i.current && o.preventDefault();
    }
  }));
}), ete = /* @__PURE__ */ gt((t, e) => {
  const { __scopeDialog: n, trapFocus: r, onOpenAutoFocus: i, onCloseAutoFocus: o, ...a } = t, s = yl(xm, n), u = Ee(null), l = Kn(e, u);
  return $O(), /* @__PURE__ */ Pe(ha, null, /* @__PURE__ */ Pe(Tat, {
    asChild: !0,
    loop: !0,
    trapped: r,
    onMountAutoFocus: i,
    onUnmountAutoFocus: o
  }, /* @__PURE__ */ Pe(Iat, G({
    role: "dialog",
    id: s.contentId,
    "aria-describedby": s.descriptionId,
    "aria-labelledby": s.titleId,
    "data-state": tte(s.open)
  }, a, {
    ref: l,
    onDismiss: () => s.onOpenChange(!1)
  }))), !1);
}), Gat = "DialogTitle", Uat = /* @__PURE__ */ gt((t, e) => {
  const { __scopeDialog: n, ...r } = t, i = yl(Gat, n);
  return /* @__PURE__ */ Pe(Sn.h2, G({
    id: i.titleId
  }, r, {
    ref: e
  }));
}), Xat = "DialogClose", Yat = /* @__PURE__ */ gt((t, e) => {
  const { __scopeDialog: n, ...r } = t, i = yl(Xat, n);
  return /* @__PURE__ */ Pe(Sn.button, G({
    type: "button"
  }, r, {
    ref: e,
    onClick: ln(
      t.onClick,
      () => i.onOpenChange(!1)
    )
  }));
});
function tte(t) {
  return t ? "open" : "closed";
}
const Zat = Fat, Jat = Vat, Kat = Bat, qat = Wat, Qat = Uat, est = Yat;
var Tv = (t) => t.type === "checkbox", kh = (t) => t instanceof Date, no = (t) => t == null;
const nte = (t) => typeof t == "object";
var wi = (t) => !no(t) && !Array.isArray(t) && nte(t) && !kh(t), rte = (t) => wi(t) && t.target ? Tv(t.target) ? t.target.checked : t.target.value : t, tst = (t) => t.substring(0, t.search(/\.\d+(\.|$)/)) || t, ite = (t, e) => t.has(tst(e)), nst = (t) => {
  const e = t.constructor && t.constructor.prototype;
  return wi(e) && e.hasOwnProperty("isPrototypeOf");
}, a8 = typeof window < "u" && typeof window.HTMLElement < "u" && typeof document < "u";
function ms(t) {
  let e;
  const n = Array.isArray(t);
  if (t instanceof Date)
    e = new Date(t);
  else if (t instanceof Set)
    e = new Set(t);
  else if (!(a8 && (t instanceof Blob || t instanceof FileList)) && (n || wi(t)))
    if (e = n ? [] : {}, !n && !nst(t))
      e = t;
    else
      for (const r in t)
        t.hasOwnProperty(r) && (e[r] = ms(t[r]));
  else
    return t;
  return e;
}
var Ov = (t) => Array.isArray(t) ? t.filter(Boolean) : [], Yr = (t) => t === void 0, Et = (t, e, n) => {
  if (!e || !wi(t))
    return n;
  const r = Ov(e.split(/[,[\].]+?/)).reduce((i, o) => no(i) ? i : i[o], t);
  return Yr(r) || r === t ? Yr(t[e]) ? n : t[e] : r;
}, Ha = (t) => typeof t == "boolean";
const P2 = {
  BLUR: "blur",
  FOCUS_OUT: "focusout",
  CHANGE: "change"
}, Ss = {
  onBlur: "onBlur",
  onChange: "onChange",
  onSubmit: "onSubmit",
  onTouched: "onTouched",
  all: "all"
}, Bu = {
  max: "max",
  min: "min",
  maxLength: "maxLength",
  minLength: "minLength",
  pattern: "pattern",
  required: "required",
  validate: "validate"
}, rst = O.createContext(null), s8 = () => O.useContext(rst);
var ote = (t, e, n, r = !0) => {
  const i = {
    defaultValues: e._defaultValues
  };
  for (const o in t)
    Object.defineProperty(i, o, {
      get: () => {
        const a = o;
        return e._proxyFormState[a] !== Ss.all && (e._proxyFormState[a] = !r || Ss.all), n && (n[a] = !0), t[a];
      }
    });
  return i;
}, Fa = (t) => wi(t) && !Object.keys(t).length, ate = (t, e, n, r) => {
  n(t);
  const { name: i, ...o } = t;
  return Fa(o) || Object.keys(o).length >= Object.keys(e).length || Object.keys(o).find((a) => e[a] === (!r || Ss.all));
}, Ry = (t) => Array.isArray(t) ? t : [t], ste = (t, e, n) => !t || !e || t === e || Ry(t).some((r) => r && (n ? r === e : r.startsWith(e) || e.startsWith(r)));
function u8(t) {
  const e = O.useRef(t);
  e.current = t, O.useEffect(() => {
    const n = !t.disabled && e.current.subject && e.current.subject.subscribe({
      next: e.current.next
    });
    return () => {
      n && n.unsubscribe();
    };
  }, [t.disabled]);
}
function ist(t) {
  const e = s8(), { control: n = e.control, disabled: r, name: i, exact: o } = t || {}, [a, s] = O.useState(n._formState), u = O.useRef(!0), l = O.useRef({
    isDirty: !1,
    isLoading: !1,
    dirtyFields: !1,
    touchedFields: !1,
    isValidating: !1,
    isValid: !1,
    errors: !1
  }), c = O.useRef(i);
  return c.current = i, u8({
    disabled: r,
    next: (d) => u.current && ste(c.current, d.name, o) && ate(d, l.current, n._updateFormState) && s({
      ...n._formState,
      ...d
    }),
    subject: n._subjects.state
  }), O.useEffect(() => (u.current = !0, l.current.isValid && n._updateValid(!0), () => {
    u.current = !1;
  }), [n]), ote(a, n, l.current, !1);
}
var ru = (t) => typeof t == "string", ute = (t, e, n, r, i) => ru(t) ? (r && e.watch.add(t), Et(n, t, i)) : Array.isArray(t) ? t.map((o) => (r && e.watch.add(o), Et(n, o))) : (r && (e.watchAll = !0), n);
function ost(t) {
  const e = s8(), { control: n = e.control, name: r, defaultValue: i, disabled: o, exact: a } = t || {}, s = O.useRef(r);
  s.current = r, u8({
    disabled: o,
    subject: n._subjects.values,
    next: (c) => {
      ste(s.current, c.name, a) && l(ms(ute(s.current, n._names, c.values || n._formValues, !1, i)));
    }
  });
  const [u, l] = O.useState(n._getWatch(r, i));
  return O.useEffect(() => n._removeUnmounted()), u;
}
var l8 = (t) => /^\w*$/.test(t), lte = (t) => Ov(t.replace(/["|']|\]/g, "").split(/\.|\[/)), Rr = (t, e, n) => {
  let r = -1;
  const i = l8(e) ? [e] : lte(e), o = i.length, a = o - 1;
  for (; ++r < o; ) {
    const s = i[r];
    let u = n;
    if (r !== a) {
      const l = t[s];
      u = wi(l) || Array.isArray(l) ? l : isNaN(+i[r + 1]) ? {} : [];
    }
    t[s] = u, t = t[s];
  }
  return t;
};
function ast(t) {
  const e = s8(), { name: n, disabled: r, control: i = e.control, shouldUnregister: o } = t, a = ite(i._names.array, n), s = ost({
    control: i,
    name: n,
    defaultValue: Et(i._formValues, n, Et(i._defaultValues, n, t.defaultValue)),
    exact: !0
  }), u = ist({
    control: i,
    name: n
  }), l = O.useRef(i.register(n, {
    ...t.rules,
    value: s,
    ...Ha(t.disabled) ? { disabled: t.disabled } : {}
  }));
  return O.useEffect(() => {
    const c = i._options.shouldUnregister || o, d = (f, h) => {
      const p = Et(i._fields, f);
      p && (p._f.mount = h);
    };
    if (d(n, !0), c) {
      const f = ms(Et(i._options.defaultValues, n));
      Rr(i._defaultValues, n, f), Yr(Et(i._formValues, n)) && Rr(i._formValues, n, f);
    }
    return () => {
      (a ? c && !i._state.action : c) ? i.unregister(n) : d(n, !1);
    };
  }, [n, i, a, o]), O.useEffect(() => {
    Et(i._fields, n) && i._updateDisabledField({
      disabled: r,
      fields: i._fields,
      name: n,
      value: Et(i._fields, n)._f.value
    });
  }, [r, n, i]), {
    field: {
      name: n,
      value: s,
      ...Ha(r) || Ha(u.disabled) ? { disabled: u.disabled || r } : {},
      onChange: O.useCallback((c) => l.current.onChange({
        target: {
          value: rte(c),
          name: n
        },
        type: P2.CHANGE
      }), [n]),
      onBlur: O.useCallback(() => l.current.onBlur({
        target: {
          value: Et(i._formValues, n),
          name: n
        },
        type: P2.BLUR
      }), [n, i]),
      ref: (c) => {
        const d = Et(i._fields, n);
        d && c && (d._f.ref = {
          focus: () => c.focus(),
          select: () => c.select(),
          setCustomValidity: (f) => c.setCustomValidity(f),
          reportValidity: () => c.reportValidity()
        });
      }
    },
    formState: u,
    fieldState: Object.defineProperties({}, {
      invalid: {
        enumerable: !0,
        get: () => !!Et(u.errors, n)
      },
      isDirty: {
        enumerable: !0,
        get: () => !!Et(u.dirtyFields, n)
      },
      isTouched: {
        enumerable: !0,
        get: () => !!Et(u.touchedFields, n)
      },
      error: {
        enumerable: !0,
        get: () => Et(u.errors, n)
      }
    })
  };
}
const sst = (t) => t.render(ast(t));
var ust = (t, e, n, r, i) => e ? {
  ...n[t],
  types: {
    ...n[t] && n[t].types ? n[t].types : {},
    [r]: i || !0
  }
} : {}, hV = (t) => ({
  isOnSubmit: !t || t === Ss.onSubmit,
  isOnBlur: t === Ss.onBlur,
  isOnChange: t === Ss.onChange,
  isOnAll: t === Ss.all,
  isOnTouch: t === Ss.onTouched
}), pV = (t, e, n) => !n && (e.watchAll || e.watch.has(t) || [...e.watch].some((r) => t.startsWith(r) && /^\.\w+/.test(t.slice(r.length))));
const R0 = (t, e, n, r) => {
  for (const i of n || Object.keys(t)) {
    const o = Et(t, i);
    if (o) {
      const { _f: a, ...s } = o;
      if (a) {
        if (a.refs && a.refs[0] && e(a.refs[0], i) && !r)
          break;
        if (a.ref && e(a.ref, a.name) && !r)
          break;
        R0(s, e);
      } else
        wi(s) && R0(s, e);
    }
  }
};
var lst = (t, e, n) => {
  const r = Ov(Et(t, n));
  return Rr(r, "root", e[n]), Rr(t, n, r), t;
}, c8 = (t) => t.type === "file", ec = (t) => typeof t == "function", N2 = (t) => {
  if (!a8)
    return !1;
  const e = t ? t.ownerDocument : 0;
  return t instanceof (e && e.defaultView ? e.defaultView.HTMLElement : HTMLElement);
}, $y = (t) => ru(t), d8 = (t) => t.type === "radio", k2 = (t) => t instanceof RegExp;
const gV = {
  value: !1,
  isValid: !1
}, mV = { value: !0, isValid: !0 };
var cte = (t) => {
  if (Array.isArray(t)) {
    if (t.length > 1) {
      const e = t.filter((n) => n && n.checked && !n.disabled).map((n) => n.value);
      return { value: e, isValid: !!e.length };
    }
    return t[0].checked && !t[0].disabled ? (
      // @ts-expect-error expected to work in the browser
      t[0].attributes && !Yr(t[0].attributes.value) ? Yr(t[0].value) || t[0].value === "" ? mV : { value: t[0].value, isValid: !0 } : mV
    ) : gV;
  }
  return gV;
};
const vV = {
  isValid: !1,
  value: null
};
var dte = (t) => Array.isArray(t) ? t.reduce((e, n) => n && n.checked && !n.disabled ? {
  isValid: !0,
  value: n.value
} : e, vV) : vV;
function bV(t, e, n = "validate") {
  if ($y(t) || Array.isArray(t) && t.every($y) || Ha(t) && !t)
    return {
      type: n,
      message: $y(t) ? t : "",
      ref: e
    };
}
var Uf = (t) => wi(t) && !k2(t) ? t : {
  value: t,
  message: ""
}, yV = async (t, e, n, r, i) => {
  const { ref: o, refs: a, required: s, maxLength: u, minLength: l, min: c, max: d, pattern: f, validate: h, name: p, valueAsNumber: v, mount: m, disabled: b } = t._f, y = Et(e, p);
  if (!m || b)
    return {};
  const w = a ? a[0] : o, S = (D) => {
    r && w.reportValidity && (w.setCustomValidity(Ha(D) ? "" : D || ""), w.reportValidity());
  }, E = {}, I = d8(o), _ = Tv(o), A = I || _, P = (v || c8(o)) && Yr(o.value) && Yr(y) || N2(o) && o.value === "" || y === "" || Array.isArray(y) && !y.length, N = ust.bind(null, p, n, E), k = (D, R, V, $ = Bu.maxLength, F = Bu.minLength) => {
    const M = D ? R : V;
    E[p] = {
      type: D ? $ : F,
      message: M,
      ref: o,
      ...N(D ? $ : F, M)
    };
  };
  if (i ? !Array.isArray(y) || !y.length : s && (!A && (P || no(y)) || Ha(y) && !y || _ && !cte(a).isValid || I && !dte(a).isValid)) {
    const { value: D, message: R } = $y(s) ? { value: !!s, message: s } : Uf(s);
    if (D && (E[p] = {
      type: Bu.required,
      message: R,
      ref: w,
      ...N(Bu.required, R)
    }, !n))
      return S(R), E;
  }
  if (!P && (!no(c) || !no(d))) {
    let D, R;
    const V = Uf(d), $ = Uf(c);
    if (!no(y) && !isNaN(y)) {
      const F = o.valueAsNumber || y && +y;
      no(V.value) || (D = F > V.value), no($.value) || (R = F < $.value);
    } else {
      const F = o.valueAsDate || new Date(y), M = (L) => /* @__PURE__ */ new Date((/* @__PURE__ */ new Date()).toDateString() + " " + L), B = o.type == "time", X = o.type == "week";
      ru(V.value) && y && (D = B ? M(y) > M(V.value) : X ? y > V.value : F > new Date(V.value)), ru($.value) && y && (R = B ? M(y) < M($.value) : X ? y < $.value : F < new Date($.value));
    }
    if ((D || R) && (k(!!D, V.message, $.message, Bu.max, Bu.min), !n))
      return S(E[p].message), E;
  }
  if ((u || l) && !P && (ru(y) || i && Array.isArray(y))) {
    const D = Uf(u), R = Uf(l), V = !no(D.value) && y.length > +D.value, $ = !no(R.value) && y.length < +R.value;
    if ((V || $) && (k(V, D.message, R.message), !n))
      return S(E[p].message), E;
  }
  if (f && !P && ru(y)) {
    const { value: D, message: R } = Uf(f);
    if (k2(D) && !y.match(D) && (E[p] = {
      type: Bu.pattern,
      message: R,
      ref: o,
      ...N(Bu.pattern, R)
    }, !n))
      return S(R), E;
  }
  if (h) {
    if (ec(h)) {
      const D = await h(y, e), R = bV(D, w);
      if (R && (E[p] = {
        ...R,
        ...N(Bu.validate, R.message)
      }, !n))
        return S(R.message), E;
    } else if (wi(h)) {
      let D = {};
      for (const R in h) {
        if (!Fa(D) && !n)
          break;
        const V = bV(await h[R](y, e), w, R);
        V && (D = {
          ...V,
          ...N(R, V.message)
        }, S(V.message), n && (E[p] = D));
      }
      if (!Fa(D) && (E[p] = {
        ref: w,
        ...D
      }, !n))
        return E;
    }
  }
  return S(!0), E;
};
function cst(t, e) {
  const n = e.slice(0, -1).length;
  let r = 0;
  for (; r < n; )
    t = Yr(t) ? r++ : t[e[r++]];
  return t;
}
function dst(t) {
  for (const e in t)
    if (t.hasOwnProperty(e) && !Yr(t[e]))
      return !1;
  return !0;
}
function Di(t, e) {
  const n = Array.isArray(e) ? e : l8(e) ? [e] : lte(e), r = n.length === 1 ? t : cst(t, n), i = n.length - 1, o = n[i];
  return r && delete r[o], i !== 0 && (wi(r) && Fa(r) || Array.isArray(r) && dst(r)) && Di(t, n.slice(0, -1)), t;
}
var _5 = () => {
  let t = [];
  return {
    get observers() {
      return t;
    },
    next: (i) => {
      for (const o of t)
        o.next && o.next(i);
    },
    subscribe: (i) => (t.push(i), {
      unsubscribe: () => {
        t = t.filter((o) => o !== i);
      }
    }),
    unsubscribe: () => {
      t = [];
    }
  };
}, R2 = (t) => no(t) || !nte(t);
function pd(t, e) {
  if (R2(t) || R2(e))
    return t === e;
  if (kh(t) && kh(e))
    return t.getTime() === e.getTime();
  const n = Object.keys(t), r = Object.keys(e);
  if (n.length !== r.length)
    return !1;
  for (const i of n) {
    const o = t[i];
    if (!r.includes(i))
      return !1;
    if (i !== "ref") {
      const a = e[i];
      if (kh(o) && kh(a) || wi(o) && wi(a) || Array.isArray(o) && Array.isArray(a) ? !pd(o, a) : o !== a)
        return !1;
    }
  }
  return !0;
}
var fte = (t) => t.type === "select-multiple", fst = (t) => d8(t) || Tv(t), A5 = (t) => N2(t) && t.isConnected, hte = (t) => {
  for (const e in t)
    if (ec(t[e]))
      return !0;
  return !1;
};
function $2(t, e = {}) {
  const n = Array.isArray(t);
  if (wi(t) || n)
    for (const r in t)
      Array.isArray(t[r]) || wi(t[r]) && !hte(t[r]) ? (e[r] = Array.isArray(t[r]) ? [] : {}, $2(t[r], e[r])) : no(t[r]) || (e[r] = !0);
  return e;
}
function pte(t, e, n) {
  const r = Array.isArray(t);
  if (wi(t) || r)
    for (const i in t)
      Array.isArray(t[i]) || wi(t[i]) && !hte(t[i]) ? Yr(e) || R2(n[i]) ? n[i] = Array.isArray(t[i]) ? $2(t[i], []) : { ...$2(t[i]) } : pte(t[i], no(e) ? {} : e[i], n[i]) : n[i] = !pd(t[i], e[i]);
  return n;
}
var T5 = (t, e) => pte(t, e, $2(e)), gte = (t, { valueAsNumber: e, valueAsDate: n, setValueAs: r }) => Yr(t) ? t : e ? t === "" ? NaN : t && +t : n && ru(t) ? new Date(t) : r ? r(t) : t;
function O5(t) {
  const e = t.ref;
  if (!(t.refs ? t.refs.every((n) => n.disabled) : e.disabled))
    return c8(e) ? e.files : d8(e) ? dte(t.refs).value : fte(e) ? [...e.selectedOptions].map(({ value: n }) => n) : Tv(e) ? cte(t.refs).value : gte(Yr(e.value) ? t.ref.value : e.value, t);
}
var hst = (t, e, n, r) => {
  const i = {};
  for (const o of t) {
    const a = Et(e, o);
    a && Rr(i, o, a._f);
  }
  return {
    criteriaMode: n,
    names: [...t],
    fields: i,
    shouldUseNativeValidation: r
  };
}, jg = (t) => Yr(t) ? t : k2(t) ? t.source : wi(t) ? k2(t.value) ? t.value.source : t.value : t, pst = (t) => t.mount && (t.required || t.min || t.max || t.maxLength || t.minLength || t.pattern || t.validate);
function xV(t, e, n) {
  const r = Et(t, n);
  if (r || l8(n))
    return {
      error: r,
      name: n
    };
  const i = n.split(".");
  for (; i.length; ) {
    const o = i.join("."), a = Et(e, o), s = Et(t, o);
    if (a && !Array.isArray(a) && n !== o)
      return { name: n };
    if (s && s.type)
      return {
        name: o,
        error: s
      };
    i.pop();
  }
  return {
    name: n
  };
}
var gst = (t, e, n, r, i) => i.isOnAll ? !1 : !n && i.isOnTouch ? !(e || t) : (n ? r.isOnBlur : i.isOnBlur) ? !t : (n ? r.isOnChange : i.isOnChange) ? t : !0, mst = (t, e) => !Ov(Et(t, e)).length && Di(t, e);
const vst = {
  mode: Ss.onSubmit,
  reValidateMode: Ss.onChange,
  shouldFocusError: !0
};
function bst(t = {}, e) {
  let n = {
    ...vst,
    ...t
  }, r = {
    submitCount: 0,
    isDirty: !1,
    isLoading: ec(n.defaultValues),
    isValidating: !1,
    isSubmitted: !1,
    isSubmitting: !1,
    isSubmitSuccessful: !1,
    isValid: !1,
    touchedFields: {},
    dirtyFields: {},
    errors: n.errors || {},
    disabled: !1
  }, i = {}, o = wi(n.defaultValues) || wi(n.values) ? ms(n.defaultValues || n.values) || {} : {}, a = n.shouldUnregister ? {} : ms(o), s = {
    action: !1,
    mount: !1,
    watch: !1
  }, u = {
    mount: /* @__PURE__ */ new Set(),
    unMount: /* @__PURE__ */ new Set(),
    array: /* @__PURE__ */ new Set(),
    watch: /* @__PURE__ */ new Set()
  }, l, c = 0;
  const d = {
    isDirty: !1,
    dirtyFields: !1,
    touchedFields: !1,
    isValidating: !1,
    isValid: !1,
    errors: !1
  }, f = {
    values: _5(),
    array: _5(),
    state: _5()
  }, h = t.resetOptions && t.resetOptions.keepDirtyValues, p = hV(n.mode), v = hV(n.reValidateMode), m = n.criteriaMode === Ss.all, b = (ne) => (pe) => {
    clearTimeout(c), c = setTimeout(ne, pe);
  }, y = async (ne) => {
    if (d.isValid || ne) {
      const pe = n.resolver ? Fa((await N()).errors) : await D(i, !0);
      pe !== r.isValid && f.state.next({
        isValid: pe
      });
    }
  }, w = (ne) => d.isValidating && f.state.next({
    isValidating: ne
  }), S = (ne, pe = [], ye, Ae, we = !0, ce = !0) => {
    if (Ae && ye) {
      if (s.action = !0, ce && Array.isArray(Et(i, ne))) {
        const ve = ye(Et(i, ne), Ae.argA, Ae.argB);
        we && Rr(i, ne, ve);
      }
      if (ce && Array.isArray(Et(r.errors, ne))) {
        const ve = ye(Et(r.errors, ne), Ae.argA, Ae.argB);
        we && Rr(r.errors, ne, ve), mst(r.errors, ne);
      }
      if (d.touchedFields && ce && Array.isArray(Et(r.touchedFields, ne))) {
        const ve = ye(Et(r.touchedFields, ne), Ae.argA, Ae.argB);
        we && Rr(r.touchedFields, ne, ve);
      }
      d.dirtyFields && (r.dirtyFields = T5(o, a)), f.state.next({
        name: ne,
        isDirty: V(ne, pe),
        dirtyFields: r.dirtyFields,
        errors: r.errors,
        isValid: r.isValid
      });
    } else
      Rr(a, ne, pe);
  }, E = (ne, pe) => {
    Rr(r.errors, ne, pe), f.state.next({
      errors: r.errors
    });
  }, I = (ne) => {
    r.errors = ne, f.state.next({
      errors: r.errors,
      isValid: !1
    });
  }, _ = (ne, pe, ye, Ae) => {
    const we = Et(i, ne);
    if (we) {
      const ce = Et(a, ne, Yr(ye) ? Et(o, ne) : ye);
      Yr(ce) || Ae && Ae.defaultChecked || pe ? Rr(a, ne, pe ? ce : O5(we._f)) : M(ne, ce), s.mount && y();
    }
  }, A = (ne, pe, ye, Ae, we) => {
    let ce = !1, ve = !1;
    const Ie = {
      name: ne
    }, q = !!(Et(i, ne) && Et(i, ne)._f.disabled);
    if (!ye || Ae) {
      d.isDirty && (ve = r.isDirty, r.isDirty = Ie.isDirty = V(), ce = ve !== Ie.isDirty);
      const Fe = q || pd(Et(o, ne), pe);
      ve = !!(!q && Et(r.dirtyFields, ne)), Fe || q ? Di(r.dirtyFields, ne) : Rr(r.dirtyFields, ne, !0), Ie.dirtyFields = r.dirtyFields, ce = ce || d.dirtyFields && ve !== !Fe;
    }
    if (ye) {
      const Fe = Et(r.touchedFields, ne);
      Fe || (Rr(r.touchedFields, ne, ye), Ie.touchedFields = r.touchedFields, ce = ce || d.touchedFields && Fe !== ye);
    }
    return ce && we && f.state.next(Ie), ce ? Ie : {};
  }, P = (ne, pe, ye, Ae) => {
    const we = Et(r.errors, ne), ce = d.isValid && Ha(pe) && r.isValid !== pe;
    if (t.delayError && ye ? (l = b(() => E(ne, ye)), l(t.delayError)) : (clearTimeout(c), l = null, ye ? Rr(r.errors, ne, ye) : Di(r.errors, ne)), (ye ? !pd(we, ye) : we) || !Fa(Ae) || ce) {
      const ve = {
        ...Ae,
        ...ce && Ha(pe) ? { isValid: pe } : {},
        errors: r.errors,
        name: ne
      };
      r = {
        ...r,
        ...ve
      }, f.state.next(ve);
    }
    w(!1);
  }, N = async (ne) => n.resolver(a, n.context, hst(ne || u.mount, i, n.criteriaMode, n.shouldUseNativeValidation)), k = async (ne) => {
    const { errors: pe } = await N(ne);
    if (ne)
      for (const ye of ne) {
        const Ae = Et(pe, ye);
        Ae ? Rr(r.errors, ye, Ae) : Di(r.errors, ye);
      }
    else
      r.errors = pe;
    return pe;
  }, D = async (ne, pe, ye = {
    valid: !0
  }) => {
    for (const Ae in ne) {
      const we = ne[Ae];
      if (we) {
        const { _f: ce, ...ve } = we;
        if (ce) {
          const Ie = u.array.has(ce.name), q = await yV(we, a, m, n.shouldUseNativeValidation && !pe, Ie);
          if (q[ce.name] && (ye.valid = !1, pe))
            break;
          !pe && (Et(q, ce.name) ? Ie ? lst(r.errors, q, ce.name) : Rr(r.errors, ce.name, q[ce.name]) : Di(r.errors, ce.name));
        }
        ve && await D(ve, pe, ye);
      }
    }
    return ye.valid;
  }, R = () => {
    for (const ne of u.unMount) {
      const pe = Et(i, ne);
      pe && (pe._f.refs ? pe._f.refs.every((ye) => !A5(ye)) : !A5(pe._f.ref)) && ee(ne);
    }
    u.unMount = /* @__PURE__ */ new Set();
  }, V = (ne, pe) => (ne && pe && Rr(a, ne, pe), !pd(W(), o)), $ = (ne, pe, ye) => ute(ne, u, {
    ...s.mount ? a : Yr(pe) ? o : ru(ne) ? { [ne]: pe } : pe
  }, ye, pe), F = (ne) => Ov(Et(s.mount ? a : o, ne, t.shouldUnregister ? Et(o, ne, []) : [])), M = (ne, pe, ye = {}) => {
    const Ae = Et(i, ne);
    let we = pe;
    if (Ae) {
      const ce = Ae._f;
      ce && (!ce.disabled && Rr(a, ne, gte(pe, ce)), we = N2(ce.ref) && no(pe) ? "" : pe, fte(ce.ref) ? [...ce.ref.options].forEach((ve) => ve.selected = we.includes(ve.value)) : ce.refs ? Tv(ce.ref) ? ce.refs.length > 1 ? ce.refs.forEach((ve) => (!ve.defaultChecked || !ve.disabled) && (ve.checked = Array.isArray(we) ? !!we.find((Ie) => Ie === ve.value) : we === ve.value)) : ce.refs[0] && (ce.refs[0].checked = !!we) : ce.refs.forEach((ve) => ve.checked = ve.value === we) : c8(ce.ref) ? ce.ref.value = "" : (ce.ref.value = we, ce.ref.type || f.values.next({
        name: ne,
        values: { ...a }
      })));
    }
    (ye.shouldDirty || ye.shouldTouch) && A(ne, we, ye.shouldTouch, ye.shouldDirty, !0), ye.shouldValidate && K(ne);
  }, B = (ne, pe, ye) => {
    for (const Ae in pe) {
      const we = pe[Ae], ce = `${ne}.${Ae}`, ve = Et(i, ce);
      (u.array.has(ne) || !R2(we) || ve && !ve._f) && !kh(we) ? B(ce, we, ye) : M(ce, we, ye);
    }
  }, X = (ne, pe, ye = {}) => {
    const Ae = Et(i, ne), we = u.array.has(ne), ce = ms(pe);
    Rr(a, ne, ce), we ? (f.array.next({
      name: ne,
      values: { ...a }
    }), (d.isDirty || d.dirtyFields) && ye.shouldDirty && f.state.next({
      name: ne,
      dirtyFields: T5(o, a),
      isDirty: V(ne, ce)
    })) : Ae && !Ae._f && !no(ce) ? B(ne, ce, ye) : M(ne, ce, ye), pV(ne, u) && f.state.next({ ...r }), f.values.next({
      name: ne,
      values: { ...a }
    }), !s.mount && e();
  }, L = async (ne) => {
    const pe = ne.target;
    let ye = pe.name, Ae = !0;
    const we = Et(i, ye), ce = () => pe.type ? O5(we._f) : rte(ne), ve = (Ie) => {
      Ae = Number.isNaN(Ie) || Ie === Et(a, ye, Ie);
    };
    if (we) {
      let Ie, q;
      const Fe = ce(), Ze = ne.type === P2.BLUR || ne.type === P2.FOCUS_OUT, at = !pst(we._f) && !n.resolver && !Et(r.errors, ye) && !we._f.deps || gst(Ze, Et(r.touchedFields, ye), r.isSubmitted, v, p), Je = pV(ye, u, Ze);
      Rr(a, ye, Fe), Ze ? (we._f.onBlur && we._f.onBlur(ne), l && l(0)) : we._f.onChange && we._f.onChange(ne);
      const ut = A(ye, Fe, Ze, !1), Ct = !Fa(ut) || Je;
      if (!Ze && f.values.next({
        name: ye,
        type: ne.type,
        values: { ...a }
      }), at)
        return d.isValid && y(), Ct && f.state.next({ name: ye, ...Je ? {} : ut });
      if (!Ze && Je && f.state.next({ ...r }), w(!0), n.resolver) {
        const { errors: Ke } = await N([ye]);
        if (ve(Fe), Ae) {
          const st = xV(r.errors, i, ye), wt = xV(Ke, i, st.name || ye);
          Ie = wt.error, ye = wt.name, q = Fa(Ke);
        }
      } else
        Ie = (await yV(we, a, m, n.shouldUseNativeValidation))[ye], ve(Fe), Ae && (Ie ? q = !1 : d.isValid && (q = await D(i, !0)));
      Ae && (we._f.deps && K(we._f.deps), P(ye, q, Ie, ut));
    }
  }, j = (ne, pe) => {
    if (Et(r.errors, pe) && ne.focus)
      return ne.focus(), 1;
  }, K = async (ne, pe = {}) => {
    let ye, Ae;
    const we = Ry(ne);
    if (w(!0), n.resolver) {
      const ce = await k(Yr(ne) ? ne : we);
      ye = Fa(ce), Ae = ne ? !we.some((ve) => Et(ce, ve)) : ye;
    } else
      ne ? (Ae = (await Promise.all(we.map(async (ce) => {
        const ve = Et(i, ce);
        return await D(ve && ve._f ? { [ce]: ve } : ve);
      }))).every(Boolean), !(!Ae && !r.isValid) && y()) : Ae = ye = await D(i);
    return f.state.next({
      ...!ru(ne) || d.isValid && ye !== r.isValid ? {} : { name: ne },
      ...n.resolver || !ne ? { isValid: ye } : {},
      errors: r.errors,
      isValidating: !1
    }), pe.shouldFocus && !Ae && R0(i, j, ne ? we : u.mount), Ae;
  }, W = (ne) => {
    const pe = {
      ...o,
      ...s.mount ? a : {}
    };
    return Yr(ne) ? pe : ru(ne) ? Et(pe, ne) : ne.map((ye) => Et(pe, ye));
  }, Y = (ne, pe) => ({
    invalid: !!Et((pe || r).errors, ne),
    isDirty: !!Et((pe || r).dirtyFields, ne),
    isTouched: !!Et((pe || r).touchedFields, ne),
    error: Et((pe || r).errors, ne)
  }), U = (ne) => {
    ne && Ry(ne).forEach((pe) => Di(r.errors, pe)), f.state.next({
      errors: ne ? r.errors : {}
    });
  }, Q = (ne, pe, ye) => {
    const Ae = (Et(i, ne, { _f: {} })._f || {}).ref;
    Rr(r.errors, ne, {
      ...pe,
      ref: Ae
    }), f.state.next({
      name: ne,
      errors: r.errors,
      isValid: !1
    }), ye && ye.shouldFocus && Ae && Ae.focus && Ae.focus();
  }, Z = (ne, pe) => ec(ne) ? f.values.subscribe({
    next: (ye) => ne($(void 0, pe), ye)
  }) : $(ne, pe, !0), ee = (ne, pe = {}) => {
    for (const ye of ne ? Ry(ne) : u.mount)
      u.mount.delete(ye), u.array.delete(ye), pe.keepValue || (Di(i, ye), Di(a, ye)), !pe.keepError && Di(r.errors, ye), !pe.keepDirty && Di(r.dirtyFields, ye), !pe.keepTouched && Di(r.touchedFields, ye), !n.shouldUnregister && !pe.keepDefaultValue && Di(o, ye);
    f.values.next({
      values: { ...a }
    }), f.state.next({
      ...r,
      ...pe.keepDirty ? { isDirty: V() } : {}
    }), !pe.keepIsValid && y();
  }, ie = ({ disabled: ne, name: pe, field: ye, fields: Ae, value: we }) => {
    if (Ha(ne)) {
      const ce = ne ? void 0 : Yr(we) ? O5(ye ? ye._f : Et(Ae, pe)._f) : we;
      Rr(a, pe, ce), A(pe, ce, !1, !1, !0);
    }
  }, oe = (ne, pe = {}) => {
    let ye = Et(i, ne);
    const Ae = Ha(pe.disabled);
    return Rr(i, ne, {
      ...ye || {},
      _f: {
        ...ye && ye._f ? ye._f : { ref: { name: ne } },
        name: ne,
        mount: !0,
        ...pe
      }
    }), u.mount.add(ne), ye ? ie({
      field: ye,
      disabled: pe.disabled,
      name: ne,
      value: pe.value
    }) : _(ne, !0, pe.value), {
      ...Ae ? { disabled: pe.disabled } : {},
      ...n.progressive ? {
        required: !!pe.required,
        min: jg(pe.min),
        max: jg(pe.max),
        minLength: jg(pe.minLength),
        maxLength: jg(pe.maxLength),
        pattern: jg(pe.pattern)
      } : {},
      name: ne,
      onChange: L,
      onBlur: L,
      ref: (we) => {
        if (we) {
          oe(ne, pe), ye = Et(i, ne);
          const ce = Yr(we.value) && we.querySelectorAll && we.querySelectorAll("input,select,textarea")[0] || we, ve = fst(ce), Ie = ye._f.refs || [];
          if (ve ? Ie.find((q) => q === ce) : ce === ye._f.ref)
            return;
          Rr(i, ne, {
            _f: {
              ...ye._f,
              ...ve ? {
                refs: [
                  ...Ie.filter(A5),
                  ce,
                  ...Array.isArray(Et(o, ne)) ? [{}] : []
                ],
                ref: { type: ce.type, name: ne }
              } : { ref: ce }
            }
          }), _(ne, !1, void 0, ce);
        } else
          ye = Et(i, ne, {}), ye._f && (ye._f.mount = !1), (n.shouldUnregister || pe.shouldUnregister) && !(ite(u.array, ne) && s.action) && u.unMount.add(ne);
      }
    };
  }, se = () => n.shouldFocusError && R0(i, j, u.mount), te = (ne) => {
    Ha(ne) && (f.state.next({ disabled: ne }), R0(i, (pe, ye) => {
      let Ae = ne;
      const we = Et(i, ye);
      we && Ha(we._f.disabled) && (Ae || (Ae = we._f.disabled)), pe.disabled = Ae;
    }, 0, !1));
  }, ge = (ne, pe) => async (ye) => {
    ye && (ye.preventDefault && ye.preventDefault(), ye.persist && ye.persist());
    let Ae = ms(a);
    if (f.state.next({
      isSubmitting: !0
    }), n.resolver) {
      const { errors: we, values: ce } = await N();
      r.errors = we, Ae = ce;
    } else
      await D(i);
    Di(r.errors, "root"), Fa(r.errors) ? (f.state.next({
      errors: {}
    }), await ne(Ae, ye)) : (pe && await pe({ ...r.errors }, ye), se(), setTimeout(se)), f.state.next({
      isSubmitted: !0,
      isSubmitting: !1,
      isSubmitSuccessful: Fa(r.errors),
      submitCount: r.submitCount + 1,
      errors: r.errors
    });
  }, he = (ne, pe = {}) => {
    Et(i, ne) && (Yr(pe.defaultValue) ? X(ne, Et(o, ne)) : (X(ne, pe.defaultValue), Rr(o, ne, pe.defaultValue)), pe.keepTouched || Di(r.touchedFields, ne), pe.keepDirty || (Di(r.dirtyFields, ne), r.isDirty = pe.defaultValue ? V(ne, Et(o, ne)) : V()), pe.keepError || (Di(r.errors, ne), d.isValid && y()), f.state.next({ ...r }));
  }, fe = (ne, pe = {}) => {
    const ye = ne ? ms(ne) : o, Ae = ms(ye), we = ne && !Fa(ne) ? Ae : o;
    if (pe.keepDefaultValues || (o = ye), !pe.keepValues) {
      if (pe.keepDirtyValues || h)
        for (const ce of u.mount)
          Et(r.dirtyFields, ce) ? Rr(we, ce, Et(a, ce)) : X(ce, Et(we, ce));
      else {
        if (a8 && Yr(ne))
          for (const ce of u.mount) {
            const ve = Et(i, ce);
            if (ve && ve._f) {
              const Ie = Array.isArray(ve._f.refs) ? ve._f.refs[0] : ve._f.ref;
              if (N2(Ie)) {
                const q = Ie.closest("form");
                if (q) {
                  q.reset();
                  break;
                }
              }
            }
          }
        i = {};
      }
      a = t.shouldUnregister ? pe.keepDefaultValues ? ms(o) : {} : ms(we), f.array.next({
        values: { ...we }
      }), f.values.next({
        values: { ...we }
      });
    }
    u = {
      mount: /* @__PURE__ */ new Set(),
      unMount: /* @__PURE__ */ new Set(),
      array: /* @__PURE__ */ new Set(),
      watch: /* @__PURE__ */ new Set(),
      watchAll: !1,
      focus: ""
    }, !s.mount && e(), s.mount = !d.isValid || !!pe.keepIsValid, s.watch = !!t.shouldUnregister, f.state.next({
      submitCount: pe.keepSubmitCount ? r.submitCount : 0,
      isDirty: pe.keepDirty ? r.isDirty : !!(pe.keepDefaultValues && !pd(ne, o)),
      isSubmitted: pe.keepIsSubmitted ? r.isSubmitted : !1,
      dirtyFields: pe.keepDirtyValues ? r.dirtyFields : pe.keepDefaultValues && ne ? T5(o, ne) : {},
      touchedFields: pe.keepTouched ? r.touchedFields : {},
      errors: pe.keepErrors ? r.errors : {},
      isSubmitSuccessful: pe.keepIsSubmitSuccessful ? r.isSubmitSuccessful : !1,
      isSubmitting: !1
    });
  }, _e = (ne, pe) => fe(ec(ne) ? ne(a) : ne, pe);
  return {
    control: {
      register: oe,
      unregister: ee,
      getFieldState: Y,
      handleSubmit: ge,
      setError: Q,
      _executeSchema: N,
      _getWatch: $,
      _getDirty: V,
      _updateValid: y,
      _removeUnmounted: R,
      _updateFieldArray: S,
      _updateDisabledField: ie,
      _getFieldArray: F,
      _reset: fe,
      _resetDefaultValues: () => ec(n.defaultValues) && n.defaultValues().then((ne) => {
        _e(ne, n.resetOptions), f.state.next({
          isLoading: !1
        });
      }),
      _updateFormState: (ne) => {
        r = {
          ...r,
          ...ne
        };
      },
      _disableForm: te,
      _subjects: f,
      _proxyFormState: d,
      _setErrors: I,
      get _fields() {
        return i;
      },
      get _formValues() {
        return a;
      },
      get _state() {
        return s;
      },
      set _state(ne) {
        s = ne;
      },
      get _defaultValues() {
        return o;
      },
      get _names() {
        return u;
      },
      set _names(ne) {
        u = ne;
      },
      get _formState() {
        return r;
      },
      set _formState(ne) {
        r = ne;
      },
      get _options() {
        return n;
      },
      set _options(ne) {
        n = {
          ...n,
          ...ne
        };
      }
    },
    trigger: K,
    register: oe,
    handleSubmit: ge,
    watch: Z,
    setValue: X,
    getValues: W,
    reset: _e,
    resetField: he,
    clearErrors: U,
    unregister: ee,
    setError: Q,
    setFocus: (ne, pe = {}) => {
      const ye = Et(i, ne), Ae = ye && ye._f;
      if (Ae) {
        const we = Ae.refs ? Ae.refs[0] : Ae.ref;
        we.focus && (we.focus(), pe.shouldSelect && we.select());
      }
    },
    getFieldState: Y
  };
}
function mte(t = {}) {
  const e = O.useRef(), n = O.useRef(), [r, i] = O.useState({
    isDirty: !1,
    isValidating: !1,
    isLoading: ec(t.defaultValues),
    isSubmitted: !1,
    isSubmitting: !1,
    isSubmitSuccessful: !1,
    isValid: !1,
    submitCount: 0,
    dirtyFields: {},
    touchedFields: {},
    errors: t.errors || {},
    disabled: !1,
    defaultValues: ec(t.defaultValues) ? void 0 : t.defaultValues
  });
  e.current || (e.current = {
    ...bst(t, () => i((a) => ({ ...a }))),
    formState: r
  });
  const o = e.current.control;
  return o._options = t, u8({
    subject: o._subjects.state,
    next: (a) => {
      ate(a, o._proxyFormState, o._updateFormState, !0) && i({ ...o._formState });
    }
  }), O.useEffect(() => o._disableForm(t.disabled), [o, t.disabled]), O.useEffect(() => {
    if (o._proxyFormState.isDirty) {
      const a = o._getDirty();
      a !== r.isDirty && o._subjects.state.next({
        isDirty: a
      });
    }
  }, [o, r.isDirty]), O.useEffect(() => {
    t.values && !pd(t.values, n.current) ? (o._reset(t.values, o._options.resetOptions), n.current = t.values, i((a) => ({ ...a }))) : o._resetDefaultValues();
  }, [t.values, o]), O.useEffect(() => {
    t.errors && o._setErrors(t.errors);
  }, [t.errors, o]), O.useEffect(() => {
    o._state.mount || (o._updateValid(), o._state.mount = !0), o._state.watch && (o._state.watch = !1, o._subjects.state.next({ ...o._formState })), o._removeUnmounted();
  }), e.current.formState = ote(r, o), e.current;
}
function yst(t, e) {
  t.prototype = Object.create(e.prototype), t.prototype.constructor = t, ix(t, e);
}
var d6 = { exports: {} }, Cr = {};
/** @license React v17.0.2
 * react-is.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var CV;
function xst() {
  return CV || (CV = 1, process.env.NODE_ENV !== "production" && function() {
    var t = 60103, e = 60106, n = 60107, r = 60108, i = 60114, o = 60109, a = 60110, s = 60112, u = 60113, l = 60120, c = 60115, d = 60116, f = 60121, h = 60122, p = 60117, v = 60129, m = 60131;
    if (typeof Symbol == "function" && Symbol.for) {
      var b = Symbol.for;
      t = b("react.element"), e = b("react.portal"), n = b("react.fragment"), r = b("react.strict_mode"), i = b("react.profiler"), o = b("react.provider"), a = b("react.context"), s = b("react.forward_ref"), u = b("react.suspense"), l = b("react.suspense_list"), c = b("react.memo"), d = b("react.lazy"), f = b("react.block"), h = b("react.server.block"), p = b("react.fundamental"), b("react.scope"), b("react.opaque.id"), v = b("react.debug_trace_mode"), b("react.offscreen"), m = b("react.legacy_hidden");
    }
    var y = !1;
    function w(se) {
      return !!(typeof se == "string" || typeof se == "function" || se === n || se === i || se === v || se === r || se === u || se === l || se === m || y || typeof se == "object" && se !== null && (se.$$typeof === d || se.$$typeof === c || se.$$typeof === o || se.$$typeof === a || se.$$typeof === s || se.$$typeof === p || se.$$typeof === f || se[0] === h));
    }
    function S(se) {
      if (typeof se == "object" && se !== null) {
        var te = se.$$typeof;
        switch (te) {
          case t:
            var ge = se.type;
            switch (ge) {
              case n:
              case i:
              case r:
              case u:
              case l:
                return ge;
              default:
                var he = ge && ge.$$typeof;
                switch (he) {
                  case a:
                  case s:
                  case d:
                  case c:
                  case o:
                    return he;
                  default:
                    return te;
                }
            }
          case e:
            return te;
        }
      }
    }
    var E = a, I = o, _ = t, A = s, P = n, N = d, k = c, D = e, R = i, V = r, $ = u, F = !1, M = !1;
    function B(se) {
      return F || (F = !0, console.warn("The ReactIs.isAsyncMode() alias has been deprecated, and will be removed in React 18+.")), !1;
    }
    function X(se) {
      return M || (M = !0, console.warn("The ReactIs.isConcurrentMode() alias has been deprecated, and will be removed in React 18+.")), !1;
    }
    function L(se) {
      return S(se) === a;
    }
    function j(se) {
      return S(se) === o;
    }
    function K(se) {
      return typeof se == "object" && se !== null && se.$$typeof === t;
    }
    function W(se) {
      return S(se) === s;
    }
    function Y(se) {
      return S(se) === n;
    }
    function U(se) {
      return S(se) === d;
    }
    function Q(se) {
      return S(se) === c;
    }
    function Z(se) {
      return S(se) === e;
    }
    function ee(se) {
      return S(se) === i;
    }
    function ie(se) {
      return S(se) === r;
    }
    function oe(se) {
      return S(se) === u;
    }
    Cr.ContextConsumer = E, Cr.ContextProvider = I, Cr.Element = _, Cr.ForwardRef = A, Cr.Fragment = P, Cr.Lazy = N, Cr.Memo = k, Cr.Portal = D, Cr.Profiler = R, Cr.StrictMode = V, Cr.Suspense = $, Cr.isAsyncMode = B, Cr.isConcurrentMode = X, Cr.isContextConsumer = L, Cr.isContextProvider = j, Cr.isElement = K, Cr.isForwardRef = W, Cr.isFragment = Y, Cr.isLazy = U, Cr.isMemo = Q, Cr.isPortal = Z, Cr.isProfiler = ee, Cr.isStrictMode = ie, Cr.isSuspense = oe, Cr.isValidElementType = w, Cr.typeOf = S;
  }()), Cr;
}
var wr = {};
/** @license React v17.0.2
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var wV;
function Cst() {
  if (wV)
    return wr;
  wV = 1;
  var t = 60103, e = 60106, n = 60107, r = 60108, i = 60114, o = 60109, a = 60110, s = 60112, u = 60113, l = 60120, c = 60115, d = 60116, f = 60121, h = 60122, p = 60117, v = 60129, m = 60131;
  if (typeof Symbol == "function" && Symbol.for) {
    var b = Symbol.for;
    t = b("react.element"), e = b("react.portal"), n = b("react.fragment"), r = b("react.strict_mode"), i = b("react.profiler"), o = b("react.provider"), a = b("react.context"), s = b("react.forward_ref"), u = b("react.suspense"), l = b("react.suspense_list"), c = b("react.memo"), d = b("react.lazy"), f = b("react.block"), h = b("react.server.block"), p = b("react.fundamental"), v = b("react.debug_trace_mode"), m = b("react.legacy_hidden");
  }
  function y(R) {
    if (typeof R == "object" && R !== null) {
      var V = R.$$typeof;
      switch (V) {
        case t:
          switch (R = R.type, R) {
            case n:
            case i:
            case r:
            case u:
            case l:
              return R;
            default:
              switch (R = R && R.$$typeof, R) {
                case a:
                case s:
                case d:
                case c:
                case o:
                  return R;
                default:
                  return V;
              }
          }
        case e:
          return V;
      }
    }
  }
  var w = o, S = t, E = s, I = n, _ = d, A = c, P = e, N = i, k = r, D = u;
  return wr.ContextConsumer = a, wr.ContextProvider = w, wr.Element = S, wr.ForwardRef = E, wr.Fragment = I, wr.Lazy = _, wr.Memo = A, wr.Portal = P, wr.Profiler = N, wr.StrictMode = k, wr.Suspense = D, wr.isAsyncMode = function() {
    return !1;
  }, wr.isConcurrentMode = function() {
    return !1;
  }, wr.isContextConsumer = function(R) {
    return y(R) === a;
  }, wr.isContextProvider = function(R) {
    return y(R) === o;
  }, wr.isElement = function(R) {
    return typeof R == "object" && R !== null && R.$$typeof === t;
  }, wr.isForwardRef = function(R) {
    return y(R) === s;
  }, wr.isFragment = function(R) {
    return y(R) === n;
  }, wr.isLazy = function(R) {
    return y(R) === d;
  }, wr.isMemo = function(R) {
    return y(R) === c;
  }, wr.isPortal = function(R) {
    return y(R) === e;
  }, wr.isProfiler = function(R) {
    return y(R) === i;
  }, wr.isStrictMode = function(R) {
    return y(R) === r;
  }, wr.isSuspense = function(R) {
    return y(R) === u;
  }, wr.isValidElementType = function(R) {
    return typeof R == "string" || typeof R == "function" || R === n || R === i || R === v || R === r || R === u || R === l || R === m || typeof R == "object" && R !== null && (R.$$typeof === d || R.$$typeof === c || R.$$typeof === o || R.$$typeof === a || R.$$typeof === s || R.$$typeof === p || R.$$typeof === f || R[0] === h);
  }, wr.typeOf = y, wr;
}
process.env.NODE_ENV === "production" ? d6.exports = Cst() : d6.exports = xst();
var EV = d6.exports;
let SV = (t) => typeof t == "object" && t != null && t.nodeType === 1, IV = (t, e) => (!e || t !== "hidden") && t !== "visible" && t !== "clip", P5 = (t, e) => {
  if (t.clientHeight < t.scrollHeight || t.clientWidth < t.scrollWidth) {
    let n = getComputedStyle(t, null);
    return IV(n.overflowY, e) || IV(n.overflowX, e) || ((r) => {
      let i = ((o) => {
        if (!o.ownerDocument || !o.ownerDocument.defaultView)
          return null;
        try {
          return o.ownerDocument.defaultView.frameElement;
        } catch {
          return null;
        }
      })(r);
      return !!i && (i.clientHeight < r.scrollHeight || i.clientWidth < r.scrollWidth);
    })(t);
  }
  return !1;
}, jb = (t, e, n, r, i, o, a, s) => o < t && a > e || o > t && a < e ? 0 : o <= t && s <= n || a >= e && s >= n ? o - t - r : a > e && s < n || o < t && s > n ? a - e + i : 0, wst = (t) => {
  let e = t.parentElement;
  return e ?? (t.getRootNode().host || null);
};
var Est = (t, e) => {
  var n, r, i, o, a, s;
  if (typeof document > "u")
    return [];
  let { scrollMode: u, block: l, inline: c, boundary: d, skipOverflowHiddenElements: f } = e, h = typeof d == "function" ? d : (V) => V !== d;
  if (!SV(t))
    throw new TypeError("Invalid target");
  let p = document.scrollingElement || document.documentElement, v = [], m = t;
  for (; SV(m) && h(m); ) {
    if (m = wst(m), m === p) {
      v.push(m);
      break;
    }
    m != null && m === document.body && P5(m) && !P5(document.documentElement) || m != null && P5(m, f) && v.push(m);
  }
  let b = (r = (n = window.visualViewport) == null ? void 0 : n.width) != null ? r : innerWidth, y = (o = (i = window.visualViewport) == null ? void 0 : i.height) != null ? o : innerHeight, w = (a = window.scrollX) != null ? a : pageXOffset, S = (s = window.scrollY) != null ? s : pageYOffset, { height: E, width: I, top: _, right: A, bottom: P, left: N } = t.getBoundingClientRect(), k = l === "start" || l === "nearest" ? _ : l === "end" ? P : _ + E / 2, D = c === "center" ? N + I / 2 : c === "end" ? A : N, R = [];
  for (let V = 0; V < v.length; V++) {
    let $ = v[V], { height: F, width: M, top: B, right: X, bottom: L, left: j } = $.getBoundingClientRect();
    if (u === "if-needed" && _ >= 0 && N >= 0 && P <= y && A <= b && _ >= B && P <= L && N >= j && A <= X)
      return R;
    let K = getComputedStyle($), W = parseInt(K.borderLeftWidth, 10), Y = parseInt(K.borderTopWidth, 10), U = parseInt(K.borderRightWidth, 10), Q = parseInt(K.borderBottomWidth, 10), Z = 0, ee = 0, ie = "offsetWidth" in $ ? $.offsetWidth - $.clientWidth - W - U : 0, oe = "offsetHeight" in $ ? $.offsetHeight - $.clientHeight - Y - Q : 0, se = "offsetWidth" in $ ? $.offsetWidth === 0 ? 0 : M / $.offsetWidth : 0, te = "offsetHeight" in $ ? $.offsetHeight === 0 ? 0 : F / $.offsetHeight : 0;
    if (p === $)
      Z = l === "start" ? k : l === "end" ? k - y : l === "nearest" ? jb(S, S + y, y, Y, Q, S + k, S + k + E, E) : k - y / 2, ee = c === "start" ? D : c === "center" ? D - b / 2 : c === "end" ? D - b : jb(w, w + b, b, W, U, w + D, w + D + I, I), Z = Math.max(0, Z + S), ee = Math.max(0, ee + w);
    else {
      Z = l === "start" ? k - B - Y : l === "end" ? k - L + Q + oe : l === "nearest" ? jb(B, L, F, Y, Q + oe, k, k + E, E) : k - (B + F / 2) + oe / 2, ee = c === "start" ? D - j - W : c === "center" ? D - (j + M / 2) + ie / 2 : c === "end" ? D - X + U + ie : jb(j, X, M, W, U + ie, D, D + I, I);
      let { scrollLeft: ge, scrollTop: he } = $;
      Z = Math.max(0, Math.min(he + Z / te, $.scrollHeight - F / te + oe)), ee = Math.max(0, Math.min(ge + ee / se, $.scrollWidth - M / se + ie)), k += he - Z, D += ge - ee;
    }
    R.push({ el: $, top: Z, left: ee });
  }
  return R;
}, Sst = 0;
function _V(t) {
  return typeof t == "function" ? t : La;
}
function La() {
}
function vte(t, e) {
  if (t) {
    var n = Est(t, {
      boundary: e,
      block: "nearest",
      scrollMode: "if-needed"
    });
    n.forEach(function(r) {
      var i = r.el, o = r.top, a = r.left;
      i.scrollTop = o, i.scrollLeft = a;
    });
  }
}
function AV(t, e, n) {
  var r = t === e || e instanceof n.Node && t.contains && t.contains(e);
  return r;
}
function f8(t, e) {
  var n;
  function r() {
    n && clearTimeout(n);
  }
  function i() {
    for (var o = arguments.length, a = new Array(o), s = 0; s < o; s++)
      a[s] = arguments[s];
    r(), n = setTimeout(function() {
      n = null, t.apply(void 0, a);
    }, e);
  }
  return i.cancel = r, i;
}
function yi() {
  for (var t = arguments.length, e = new Array(t), n = 0; n < t; n++)
    e[n] = arguments[n];
  return function(r) {
    for (var i = arguments.length, o = new Array(i > 1 ? i - 1 : 0), a = 1; a < i; a++)
      o[a - 1] = arguments[a];
    return e.some(function(s) {
      return s && s.apply(void 0, [r].concat(o)), r.preventDownshiftDefault || r.hasOwnProperty("nativeEvent") && r.nativeEvent.preventDownshiftDefault;
    });
  };
}
function Rh() {
  for (var t = arguments.length, e = new Array(t), n = 0; n < t; n++)
    e[n] = arguments[n];
  return function(r) {
    e.forEach(function(i) {
      typeof i == "function" ? i(r) : i && (i.current = r);
    });
  };
}
function bte() {
  return String(Sst++);
}
function yte(t) {
  var e = t.isOpen, n = t.resultCount, r = t.previousResultCount;
  return e ? n ? n !== r ? n + " result" + (n === 1 ? " is" : "s are") + " available, use up and down arrow keys to navigate. Press Enter key to select." : "" : "No results are available." : "";
}
function TV(t, e) {
  return t = Array.isArray(t) ? (
    /* istanbul ignore next (preact) */
    t[0]
  ) : t, !t && e ? e : t;
}
function xte(t) {
  return typeof t.type == "string";
}
function Cte(t) {
  return t.props;
}
function Ist(t, e) {
  console.error('The property "' + e + '" is required in "' + t + '"');
}
var _st = ["highlightedIndex", "inputValue", "isOpen", "selectedItem", "type"];
function zb(t) {
  t === void 0 && (t = {});
  var e = {};
  return _st.forEach(function(n) {
    t.hasOwnProperty(n) && (e[n] = t[n]);
  }), e;
}
function D2(t, e) {
  return Object.keys(t).reduce(function(n, r) {
    return n[r] = M2(e, r) ? e[r] : t[r], n;
  }, {});
}
function M2(t, e) {
  return t[e] !== void 0;
}
function f6(t) {
  var e = t.key, n = t.keyCode;
  return n >= 37 && n <= 40 && e.indexOf("Arrow") !== 0 ? "Arrow" + e : e;
}
function Ast(t) {
  return Object.prototype.toString.call(t) === "[object Object]";
}
function gd(t, e, n, r, i) {
  if (i === void 0 && (i = !0), n === 0)
    return -1;
  var o = n - 1;
  (typeof e != "number" || e < 0 || e >= n) && (e = t > 0 ? -1 : o + 1);
  var a = e + t;
  a < 0 ? a = i ? o : 0 : a > o && (a = i ? 0 : o);
  var s = jd(t, a, n, r, i);
  return s === -1 ? e >= n ? -1 : e : s;
}
function jd(t, e, n, r, i) {
  var o = r(e);
  if (!o || !o.hasAttribute("disabled"))
    return e;
  if (t > 0) {
    for (var a = e + 1; a < n; a++)
      if (!r(a).hasAttribute("disabled"))
        return a;
  } else
    for (var s = e - 1; s >= 0; s--)
      if (!r(s).hasAttribute("disabled"))
        return s;
  return i ? t > 0 ? jd(1, 0, n, r, !1) : jd(-1, n - 1, n, r, !1) : -1;
}
function F2(t, e, n, r) {
  return r === void 0 && (r = !0), e.some(function(i) {
    return i && (AV(i, t, n) || r && AV(i, n.document.activeElement, n));
  });
}
var h8 = La;
process.env.NODE_ENV !== "production" && (h8 = function(e, n, r) {
  var i = "This prop should not switch from controlled to uncontrolled (or vice versa). Decide between using a controlled or uncontrolled Downshift element for the lifetime of the component. More info: https://github.com/downshift-js/downshift#control-props";
  Object.keys(e).forEach(function(o) {
    n[o] !== void 0 && r[o] === void 0 ? console.error('downshift: A component has changed the controlled prop "' + o + '" to be uncontrolled. ' + i) : n[o] === void 0 && r[o] !== void 0 && console.error('downshift: A component has changed the uncontrolled prop "' + o + '" to be controlled. ' + i);
  });
});
var Tst = f8(function(t) {
  Ete(t).textContent = "";
}, 500);
function wte(t, e) {
  var n = Ete(e);
  t && (n.textContent = t, Tst(e));
}
function Ete(t) {
  t === void 0 && (t = document);
  var e = t.getElementById("a11y-status-message");
  return e || (e = t.createElement("div"), e.setAttribute("id", "a11y-status-message"), e.setAttribute("role", "status"), e.setAttribute("aria-live", "polite"), e.setAttribute("aria-relevant", "additions text"), Object.assign(e.style, {
    border: "0",
    clip: "rect(0 0 0 0)",
    height: "1px",
    margin: "-1px",
    overflow: "hidden",
    padding: "0",
    position: "absolute",
    width: "1px"
  }), t.body.appendChild(e), e);
}
var Ste = process.env.NODE_ENV !== "production" ? "__autocomplete_unknown__" : 0, Ite = process.env.NODE_ENV !== "production" ? "__autocomplete_mouseup__" : 1, _te = process.env.NODE_ENV !== "production" ? "__autocomplete_item_mouseenter__" : 2, Dy = process.env.NODE_ENV !== "production" ? "__autocomplete_keydown_arrow_up__" : 3, My = process.env.NODE_ENV !== "production" ? "__autocomplete_keydown_arrow_down__" : 4, Ate = process.env.NODE_ENV !== "production" ? "__autocomplete_keydown_escape__" : 5, Tte = process.env.NODE_ENV !== "production" ? "__autocomplete_keydown_enter__" : 6, Ote = process.env.NODE_ENV !== "production" ? "__autocomplete_keydown_home__" : 7, Pte = process.env.NODE_ENV !== "production" ? "__autocomplete_keydown_end__" : 8, Nte = process.env.NODE_ENV !== "production" ? "__autocomplete_click_item__" : 9, kte = process.env.NODE_ENV !== "production" ? "__autocomplete_blur_input__" : 10, Rte = process.env.NODE_ENV !== "production" ? "__autocomplete_change_input__" : 11, $te = process.env.NODE_ENV !== "production" ? "__autocomplete_keydown_space_button__" : 12, h6 = process.env.NODE_ENV !== "production" ? "__autocomplete_click_button__" : 13, Dte = process.env.NODE_ENV !== "production" ? "__autocomplete_blur_button__" : 14, Mte = process.env.NODE_ENV !== "production" ? "__autocomplete_controlled_prop_updated_selected_item__" : 15, Fte = process.env.NODE_ENV !== "production" ? "__autocomplete_touchend__" : 16, Ost = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  unknown: Ste,
  mouseUp: Ite,
  itemMouseEnter: _te,
  keyDownArrowUp: Dy,
  keyDownArrowDown: My,
  keyDownEscape: Ate,
  keyDownEnter: Tte,
  keyDownHome: Ote,
  keyDownEnd: Pte,
  clickItem: Nte,
  blurInput: kte,
  changeInput: Rte,
  keyDownSpaceButton: $te,
  clickButton: h6,
  blurButton: Dte,
  controlledPropUpdatedSelectedItem: Mte,
  touchEnd: Fte
}), Pst = ["refKey", "ref"], Nst = ["onClick", "onPress", "onKeyDown", "onKeyUp", "onBlur"], kst = ["onKeyDown", "onBlur", "onChange", "onInput", "onChangeText"], Rst = ["refKey", "ref"], $st = ["onMouseMove", "onMouseDown", "onClick", "onPress", "index", "item"], Dst = /* @__PURE__ */ function() {
  var t = /* @__PURE__ */ function(e) {
    yst(n, e);
    function n(i) {
      var o;
      o = e.call(this, i) || this, o.id = o.props.id || "downshift-" + bte(), o.menuId = o.props.menuId || o.id + "-menu", o.labelId = o.props.labelId || o.id + "-label", o.inputId = o.props.inputId || o.id + "-input", o.getItemId = o.props.getItemId || function(y) {
        return o.id + "-item-" + y;
      }, o.input = null, o.items = [], o.itemCount = null, o.previousResultCount = 0, o.timeoutIds = [], o.internalSetTimeout = function(y, w) {
        var S = setTimeout(function() {
          o.timeoutIds = o.timeoutIds.filter(function(E) {
            return E !== S;
          }), y();
        }, w);
        o.timeoutIds.push(S);
      }, o.setItemCount = function(y) {
        o.itemCount = y;
      }, o.unsetItemCount = function() {
        o.itemCount = null;
      }, o.setHighlightedIndex = function(y, w) {
        y === void 0 && (y = o.props.defaultHighlightedIndex), w === void 0 && (w = {}), w = zb(w), o.internalSetState(G({
          highlightedIndex: y
        }, w));
      }, o.clearSelection = function(y) {
        o.internalSetState({
          selectedItem: null,
          inputValue: "",
          highlightedIndex: o.props.defaultHighlightedIndex,
          isOpen: o.props.defaultIsOpen
        }, y);
      }, o.selectItem = function(y, w, S) {
        w = zb(w), o.internalSetState(G({
          isOpen: o.props.defaultIsOpen,
          highlightedIndex: o.props.defaultHighlightedIndex,
          selectedItem: y,
          inputValue: o.props.itemToString(y)
        }, w), S);
      }, o.selectItemAtIndex = function(y, w, S) {
        var E = o.items[y];
        E != null && o.selectItem(E, w, S);
      }, o.selectHighlightedItem = function(y, w) {
        return o.selectItemAtIndex(o.getState().highlightedIndex, y, w);
      }, o.internalSetState = function(y, w) {
        var S, E, I = {}, _ = typeof y == "function";
        return !_ && y.hasOwnProperty("inputValue") && o.props.onInputValueChange(y.inputValue, G({}, o.getStateAndHelpers(), y)), o.setState(function(A) {
          A = o.getState(A);
          var P = _ ? y(A) : y;
          P = o.props.stateReducer(A, P), S = P.hasOwnProperty("selectedItem");
          var N = {};
          return S && P.selectedItem !== A.selectedItem && (E = P.selectedItem), P.type = P.type || Ste, Object.keys(P).forEach(function(k) {
            A[k] !== P[k] && (I[k] = P[k]), k !== "type" && (P[k], M2(o.props, k) || (N[k] = P[k]));
          }), _ && P.hasOwnProperty("inputValue") && o.props.onInputValueChange(P.inputValue, G({}, o.getStateAndHelpers(), P)), N;
        }, function() {
          _V(w)();
          var A = Object.keys(I).length > 1;
          A && o.props.onStateChange(I, o.getStateAndHelpers()), S && o.props.onSelect(y.selectedItem, o.getStateAndHelpers()), E !== void 0 && o.props.onChange(E, o.getStateAndHelpers()), o.props.onUserAction(I, o.getStateAndHelpers());
        });
      }, o.rootRef = function(y) {
        return o._rootNode = y;
      }, o.getRootProps = function(y, w) {
        var S, E = y === void 0 ? {} : y, I = E.refKey, _ = I === void 0 ? "ref" : I, A = E.ref, P = ws(E, Pst), N = w === void 0 ? {} : w, k = N.suppressRefError, D = k === void 0 ? !1 : k;
        o.getRootProps.called = !0, o.getRootProps.refKey = _, o.getRootProps.suppressRefError = D;
        var R = o.getState(), V = R.isOpen;
        return G((S = {}, S[_] = Rh(A, o.rootRef), S.role = "combobox", S["aria-expanded"] = V, S["aria-haspopup"] = "listbox", S["aria-owns"] = V ? o.menuId : null, S["aria-labelledby"] = o.labelId, S), P);
      }, o.keyDownHandlers = {
        ArrowDown: function(w) {
          var S = this;
          if (w.preventDefault(), this.getState().isOpen) {
            var E = w.shiftKey ? 5 : 1;
            this.moveHighlightedIndex(E, {
              type: My
            });
          } else
            this.internalSetState({
              isOpen: !0,
              type: My
            }, function() {
              var I = S.getItemCount();
              if (I > 0) {
                var _ = S.getState(), A = _.highlightedIndex, P = gd(1, A, I, function(N) {
                  return S.getItemNodeFromIndex(N);
                });
                S.setHighlightedIndex(P, {
                  type: My
                });
              }
            });
        },
        ArrowUp: function(w) {
          var S = this;
          if (w.preventDefault(), this.getState().isOpen) {
            var E = w.shiftKey ? -5 : -1;
            this.moveHighlightedIndex(E, {
              type: Dy
            });
          } else
            this.internalSetState({
              isOpen: !0,
              type: Dy
            }, function() {
              var I = S.getItemCount();
              if (I > 0) {
                var _ = S.getState(), A = _.highlightedIndex, P = gd(-1, A, I, function(N) {
                  return S.getItemNodeFromIndex(N);
                });
                S.setHighlightedIndex(P, {
                  type: Dy
                });
              }
            });
        },
        Enter: function(w) {
          if (w.which !== 229) {
            var S = this.getState(), E = S.isOpen, I = S.highlightedIndex;
            if (E && I != null) {
              w.preventDefault();
              var _ = this.items[I], A = this.getItemNodeFromIndex(I);
              if (_ == null || A && A.hasAttribute("disabled"))
                return;
              this.selectHighlightedItem({
                type: Tte
              });
            }
          }
        },
        Escape: function(w) {
          w.preventDefault(), this.reset(G({
            type: Ate
          }, !this.state.isOpen && {
            selectedItem: null,
            inputValue: ""
          }));
        }
      }, o.buttonKeyDownHandlers = G({}, o.keyDownHandlers, {
        " ": function(w) {
          w.preventDefault(), this.toggleMenu({
            type: $te
          });
        }
      }), o.inputKeyDownHandlers = G({}, o.keyDownHandlers, {
        Home: function(w) {
          var S = this, E = this.getState(), I = E.isOpen;
          if (I) {
            w.preventDefault();
            var _ = this.getItemCount();
            if (!(_ <= 0 || !I)) {
              var A = jd(1, 0, _, function(P) {
                return S.getItemNodeFromIndex(P);
              }, !1);
              this.setHighlightedIndex(A, {
                type: Ote
              });
            }
          }
        },
        End: function(w) {
          var S = this, E = this.getState(), I = E.isOpen;
          if (I) {
            w.preventDefault();
            var _ = this.getItemCount();
            if (!(_ <= 0 || !I)) {
              var A = jd(-1, _ - 1, _, function(P) {
                return S.getItemNodeFromIndex(P);
              }, !1);
              this.setHighlightedIndex(A, {
                type: Pte
              });
            }
          }
        }
      }), o.getToggleButtonProps = function(y) {
        var w = y === void 0 ? {} : y, S = w.onClick;
        w.onPress;
        var E = w.onKeyDown, I = w.onKeyUp, _ = w.onBlur, A = ws(w, Nst), P = o.getState(), N = P.isOpen, k = {
          onClick: yi(S, o.buttonHandleClick),
          onKeyDown: yi(E, o.buttonHandleKeyDown),
          onKeyUp: yi(I, o.buttonHandleKeyUp),
          onBlur: yi(_, o.buttonHandleBlur)
        }, D = A.disabled ? {} : k;
        return G({
          type: "button",
          role: "button",
          "aria-label": N ? "close menu" : "open menu",
          "aria-haspopup": !0,
          "data-toggle": !0
        }, D, A);
      }, o.buttonHandleKeyUp = function(y) {
        y.preventDefault();
      }, o.buttonHandleKeyDown = function(y) {
        var w = f6(y);
        o.buttonKeyDownHandlers[w] && o.buttonKeyDownHandlers[w].call(It(o), y);
      }, o.buttonHandleClick = function(y) {
        y.preventDefault(), o.props.environment.document.activeElement === o.props.environment.document.body && y.target.focus(), process.env.NODE_ENV === "test" ? o.toggleMenu({
          type: h6
        }) : o.internalSetTimeout(function() {
          return o.toggleMenu({
            type: h6
          });
        });
      }, o.buttonHandleBlur = function(y) {
        var w = y.target;
        o.internalSetTimeout(function() {
          !o.isMouseDown && (o.props.environment.document.activeElement == null || o.props.environment.document.activeElement.id !== o.inputId) && o.props.environment.document.activeElement !== w && o.reset({
            type: Dte
          });
        });
      }, o.getLabelProps = function(y) {
        return G({
          htmlFor: o.inputId,
          id: o.labelId
        }, y);
      }, o.getInputProps = function(y) {
        var w = y === void 0 ? {} : y, S = w.onKeyDown, E = w.onBlur, I = w.onChange, _ = w.onInput;
        w.onChangeText;
        var A = ws(w, kst), P, N = {};
        P = "onChange";
        var k = o.getState(), D = k.inputValue, R = k.isOpen, V = k.highlightedIndex;
        if (!A.disabled) {
          var $;
          N = ($ = {}, $[P] = yi(I, _, o.inputHandleChange), $.onKeyDown = yi(S, o.inputHandleKeyDown), $.onBlur = yi(E, o.inputHandleBlur), $);
        }
        return G({
          "aria-autocomplete": "list",
          "aria-activedescendant": R && typeof V == "number" && V >= 0 ? o.getItemId(V) : null,
          "aria-controls": R ? o.menuId : null,
          "aria-labelledby": A && A["aria-label"] ? void 0 : o.labelId,
          // https://developer.mozilla.org/en-US/docs/Web/Security/Securing_your_site/Turning_off_form_autocompletion
          // revert back since autocomplete="nope" is ignored on latest Chrome and Opera
          autoComplete: "off",
          value: D,
          id: o.inputId
        }, N, A);
      }, o.inputHandleKeyDown = function(y) {
        var w = f6(y);
        w && o.inputKeyDownHandlers[w] && o.inputKeyDownHandlers[w].call(It(o), y);
      }, o.inputHandleChange = function(y) {
        o.internalSetState({
          type: Rte,
          isOpen: !0,
          inputValue: y.target.value,
          highlightedIndex: o.props.defaultHighlightedIndex
        });
      }, o.inputHandleBlur = function() {
        o.internalSetTimeout(function() {
          var y = o.props.environment.document && !!o.props.environment.document.activeElement && !!o.props.environment.document.activeElement.dataset && o.props.environment.document.activeElement.dataset.toggle && o._rootNode && o._rootNode.contains(o.props.environment.document.activeElement);
          !o.isMouseDown && !y && o.reset({
            type: kte
          });
        });
      }, o.menuRef = function(y) {
        o._menuNode = y;
      }, o.getMenuProps = function(y, w) {
        var S, E = y === void 0 ? {} : y, I = E.refKey, _ = I === void 0 ? "ref" : I, A = E.ref, P = ws(E, Rst), N = w === void 0 ? {} : w, k = N.suppressRefError, D = k === void 0 ? !1 : k;
        return o.getMenuProps.called = !0, o.getMenuProps.refKey = _, o.getMenuProps.suppressRefError = D, G((S = {}, S[_] = Rh(A, o.menuRef), S.role = "listbox", S["aria-labelledby"] = P && P["aria-label"] ? null : o.labelId, S.id = o.menuId, S), P);
      }, o.getItemProps = function(y) {
        var w, S = y === void 0 ? {} : y, E = S.onMouseMove, I = S.onMouseDown, _ = S.onClick;
        S.onPress;
        var A = S.index, P = S.item, N = P === void 0 ? process.env.NODE_ENV === "production" ? (
          /* istanbul ignore next */
          void 0
        ) : Ist("getItemProps", "item") : P, k = ws(S, $st);
        A === void 0 ? (o.items.push(N), A = o.items.indexOf(N)) : o.items[A] = N;
        var D = "onClick", R = _, V = (w = {
          // onMouseMove is used over onMouseEnter here. onMouseMove
          // is only triggered on actual mouse movement while onMouseEnter
          // can fire on DOM changes, interrupting keyboard navigation
          onMouseMove: yi(E, function() {
            A !== o.getState().highlightedIndex && (o.setHighlightedIndex(A, {
              type: _te
            }), o.avoidScrolling = !0, o.internalSetTimeout(function() {
              return o.avoidScrolling = !1;
            }, 250));
          }),
          onMouseDown: yi(I, function(F) {
            F.preventDefault();
          })
        }, w[D] = yi(R, function() {
          o.selectItemAtIndex(A, {
            type: Nte
          });
        }), w), $ = k.disabled ? {
          onMouseDown: V.onMouseDown
        } : V;
        return G({
          id: o.getItemId(A),
          role: "option",
          "aria-selected": o.getState().highlightedIndex === A
        }, $, k);
      }, o.clearItems = function() {
        o.items = [];
      }, o.reset = function(y, w) {
        y === void 0 && (y = {}), y = zb(y), o.internalSetState(function(S) {
          var E = S.selectedItem;
          return G({
            isOpen: o.props.defaultIsOpen,
            highlightedIndex: o.props.defaultHighlightedIndex,
            inputValue: o.props.itemToString(E)
          }, y);
        }, w);
      }, o.toggleMenu = function(y, w) {
        y === void 0 && (y = {}), y = zb(y), o.internalSetState(function(S) {
          var E = S.isOpen;
          return G({
            isOpen: !E
          }, E && {
            highlightedIndex: o.props.defaultHighlightedIndex
          }, y);
        }, function() {
          var S = o.getState(), E = S.isOpen, I = S.highlightedIndex;
          E && o.getItemCount() > 0 && typeof I == "number" && o.setHighlightedIndex(I, y), _V(w)();
        });
      }, o.openMenu = function(y) {
        o.internalSetState({
          isOpen: !0
        }, y);
      }, o.closeMenu = function(y) {
        o.internalSetState({
          isOpen: !1
        }, y);
      }, o.updateStatus = f8(function() {
        var y = o.getState(), w = o.items[y.highlightedIndex], S = o.getItemCount(), E = o.props.getA11yStatusMessage(G({
          itemToString: o.props.itemToString,
          previousResultCount: o.previousResultCount,
          resultCount: S,
          highlightedItem: w
        }, y));
        o.previousResultCount = S, wte(E, o.props.environment.document);
      }, 200);
      var a = o.props, s = a.defaultHighlightedIndex, u = a.initialHighlightedIndex, l = u === void 0 ? s : u, c = a.defaultIsOpen, d = a.initialIsOpen, f = d === void 0 ? c : d, h = a.initialInputValue, p = h === void 0 ? "" : h, v = a.initialSelectedItem, m = v === void 0 ? null : v, b = o.getState({
        highlightedIndex: l,
        isOpen: f,
        inputValue: p,
        selectedItem: m
      });
      return b.selectedItem != null && o.props.initialInputValue === void 0 && (b.inputValue = o.props.itemToString(b.selectedItem)), o.state = b, o;
    }
    var r = n.prototype;
    return r.internalClearTimeouts = function() {
      this.timeoutIds.forEach(function(o) {
        clearTimeout(o);
      }), this.timeoutIds = [];
    }, r.getState = function(o) {
      return o === void 0 && (o = this.state), D2(o, this.props);
    }, r.getItemCount = function() {
      var o = this.items.length;
      return this.itemCount != null ? o = this.itemCount : this.props.itemCount !== void 0 && (o = this.props.itemCount), o;
    }, r.getItemNodeFromIndex = function(o) {
      return this.props.environment.document.getElementById(this.getItemId(o));
    }, r.scrollHighlightedItemIntoView = function() {
      {
        var o = this.getItemNodeFromIndex(this.getState().highlightedIndex);
        this.props.scrollIntoView(o, this._menuNode);
      }
    }, r.moveHighlightedIndex = function(o, a) {
      var s = this, u = this.getItemCount(), l = this.getState(), c = l.highlightedIndex;
      if (u > 0) {
        var d = gd(o, c, u, function(f) {
          return s.getItemNodeFromIndex(f);
        });
        this.setHighlightedIndex(d, a);
      }
    }, r.getStateAndHelpers = function() {
      var o = this.getState(), a = o.highlightedIndex, s = o.inputValue, u = o.selectedItem, l = o.isOpen, c = this.props.itemToString, d = this.id, f = this.getRootProps, h = this.getToggleButtonProps, p = this.getLabelProps, v = this.getMenuProps, m = this.getInputProps, b = this.getItemProps, y = this.openMenu, w = this.closeMenu, S = this.toggleMenu, E = this.selectItem, I = this.selectItemAtIndex, _ = this.selectHighlightedItem, A = this.setHighlightedIndex, P = this.clearSelection, N = this.clearItems, k = this.reset, D = this.setItemCount, R = this.unsetItemCount, V = this.internalSetState;
      return {
        // prop getters
        getRootProps: f,
        getToggleButtonProps: h,
        getLabelProps: p,
        getMenuProps: v,
        getInputProps: m,
        getItemProps: b,
        // actions
        reset: k,
        openMenu: y,
        closeMenu: w,
        toggleMenu: S,
        selectItem: E,
        selectItemAtIndex: I,
        selectHighlightedItem: _,
        setHighlightedIndex: A,
        clearSelection: P,
        clearItems: N,
        setItemCount: D,
        unsetItemCount: R,
        setState: V,
        // props
        itemToString: c,
        // derived
        id: d,
        // state
        highlightedIndex: a,
        inputValue: s,
        isOpen: l,
        selectedItem: u
      };
    }, r.componentDidMount = function() {
      var o = this;
      process.env.NODE_ENV !== "production" && this.getMenuProps.called && !this.getMenuProps.suppressRefError && OV(this._menuNode, this.getMenuProps);
      {
        var a = function() {
          o.isMouseDown = !0;
        }, s = function(h) {
          o.isMouseDown = !1;
          var p = F2(h.target, [o._rootNode, o._menuNode], o.props.environment);
          !p && o.getState().isOpen && o.reset({
            type: Ite
          }, function() {
            return o.props.onOuterClick(o.getStateAndHelpers());
          });
        }, u = function() {
          o.isTouchMove = !1;
        }, l = function() {
          o.isTouchMove = !0;
        }, c = function(h) {
          var p = F2(h.target, [o._rootNode, o._menuNode], o.props.environment, !1);
          !o.isTouchMove && !p && o.getState().isOpen && o.reset({
            type: Fte
          }, function() {
            return o.props.onOuterClick(o.getStateAndHelpers());
          });
        }, d = this.props.environment;
        d.addEventListener("mousedown", a), d.addEventListener("mouseup", s), d.addEventListener("touchstart", u), d.addEventListener("touchmove", l), d.addEventListener("touchend", c), this.cleanup = function() {
          o.internalClearTimeouts(), o.updateStatus.cancel(), d.removeEventListener("mousedown", a), d.removeEventListener("mouseup", s), d.removeEventListener("touchstart", u), d.removeEventListener("touchmove", l), d.removeEventListener("touchend", c);
        };
      }
    }, r.shouldScroll = function(o, a) {
      var s = this.props.highlightedIndex === void 0 ? this.getState() : this.props, u = s.highlightedIndex, l = a.highlightedIndex === void 0 ? o : a, c = l.highlightedIndex, d = u && this.getState().isOpen && !o.isOpen, f = u !== c;
      return d || f;
    }, r.componentDidUpdate = function(o, a) {
      process.env.NODE_ENV !== "production" && (h8(this.state, o, this.props), this.getMenuProps.called && !this.getMenuProps.suppressRefError && OV(this._menuNode, this.getMenuProps)), M2(this.props, "selectedItem") && this.props.selectedItemChanged(o.selectedItem, this.props.selectedItem) && this.internalSetState({
        type: Mte,
        inputValue: this.props.itemToString(this.props.selectedItem)
      }), !this.avoidScrolling && this.shouldScroll(a, o) && this.scrollHighlightedItemIntoView(), this.updateStatus();
    }, r.componentWillUnmount = function() {
      this.cleanup();
    }, r.render = function() {
      var o = TV(this.props.children, La);
      this.clearItems(), this.getRootProps.called = !1, this.getRootProps.refKey = void 0, this.getRootProps.suppressRefError = void 0, this.getMenuProps.called = !1, this.getMenuProps.refKey = void 0, this.getMenuProps.suppressRefError = void 0, this.getLabelProps.called = !1, this.getInputProps.called = !1;
      var a = TV(o(this.getStateAndHelpers()));
      if (!a)
        return null;
      if (this.getRootProps.called || this.props.suppressRefError)
        return process.env.NODE_ENV !== "production" && !this.getRootProps.suppressRefError && !this.props.suppressRefError && Mst(a, this.getRootProps), a;
      if (xte(a))
        return /* @__PURE__ */ Is(a, this.getRootProps(Cte(a)));
      if (process.env.NODE_ENV !== "production")
        throw new Error("downshift: If you return a non-DOM element, you must apply the getRootProps function");
    }, n;
  }(Do);
  return t.defaultProps = {
    defaultHighlightedIndex: null,
    defaultIsOpen: !1,
    getA11yStatusMessage: yte,
    itemToString: function(n) {
      return n == null ? "" : (process.env.NODE_ENV !== "production" && Ast(n) && !n.hasOwnProperty("toString") && console.warn("downshift: An object was passed to the default implementation of `itemToString`. You should probably provide your own `itemToString` implementation. Please refer to the `itemToString` API documentation.", "The object that was passed:", n), String(n));
    },
    onStateChange: La,
    onInputValueChange: La,
    onUserAction: La,
    onChange: La,
    onSelect: La,
    onOuterClick: La,
    selectedItemChanged: function(n, r) {
      return n !== r;
    },
    environment: (
      /* istanbul ignore next (ssr) */
      typeof window > "u" ? {} : window
    ),
    stateReducer: function(n, r) {
      return r;
    },
    suppressRefError: !1,
    scrollIntoView: vte
  }, t.stateChangeTypes = Ost, t;
}();
process.env.NODE_ENV !== "production" && (Dst.propTypes = {
  children: le.func,
  defaultHighlightedIndex: le.number,
  defaultIsOpen: le.bool,
  initialHighlightedIndex: le.number,
  initialSelectedItem: le.any,
  initialInputValue: le.string,
  initialIsOpen: le.bool,
  getA11yStatusMessage: le.func,
  itemToString: le.func,
  onChange: le.func,
  onSelect: le.func,
  onStateChange: le.func,
  onInputValueChange: le.func,
  onUserAction: le.func,
  onOuterClick: le.func,
  selectedItemChanged: le.func,
  stateReducer: le.func,
  itemCount: le.number,
  id: le.string,
  environment: le.shape({
    addEventListener: le.func,
    removeEventListener: le.func,
    document: le.shape({
      getElementById: le.func,
      activeElement: le.any,
      body: le.any
    })
  }),
  suppressRefError: le.bool,
  scrollIntoView: le.func,
  // things we keep in state for uncontrolled components
  // but can accept as props for controlled components
  /* eslint-disable react/no-unused-prop-types */
  selectedItem: le.any,
  isOpen: le.bool,
  inputValue: le.string,
  highlightedIndex: le.number,
  labelId: le.string,
  inputId: le.string,
  menuId: le.string,
  getItemId: le.func
  /* eslint-enable react/no-unused-prop-types */
});
function OV(t, e) {
  var n = e.refKey;
  t || console.error('downshift: The ref prop "' + n + '" from getMenuProps was not applied correctly on your menu element.');
}
function Mst(t, e) {
  var n = e.refKey, r = n !== "ref", i = !xte(t);
  i && !r && !EV.isForwardRef(t) ? console.error("downshift: You returned a non-DOM element. You must specify a refKey in getRootProps") : !i && r && console.error('downshift: You returned a DOM element. You should not specify a refKey in getRootProps. You specified "' + n + '"'), !EV.isForwardRef(t) && !Cte(t)[n] && console.error('downshift: You must apply the ref prop "' + n + '" from getRootProps onto your root element.');
}
var Fst = ["isInitialMount", "highlightedIndex", "items", "environment"], Lte = {
  highlightedIndex: -1,
  isOpen: !1,
  selectedItem: null,
  inputValue: ""
};
function Lst(t, e, n) {
  var r = t.props, i = t.type, o = {};
  Object.keys(e).forEach(function(a) {
    Vst(a, t, e, n), n[a] !== e[a] && (o[a] = n[a]);
  }), r.onStateChange && Object.keys(o).length && r.onStateChange(G({
    type: i
  }, o));
}
function Vst(t, e, n, r) {
  var i = e.props, o = e.type, a = "on" + p8(t) + "Change";
  i[a] && r[t] !== void 0 && r[t] !== n[t] && i[a](G({
    type: o
  }, r));
}
function Bst(t, e) {
  return e.changes;
}
function Hst(t) {
  var e = t.selectedItem, n = t.itemToString;
  return e ? n(e) + " has been selected." : "";
}
var Wst = f8(function(t, e) {
  wte(t(), e);
}, 200), jst = typeof window < "u" && typeof window.document < "u" && typeof window.document.createElement < "u" ? Ua : Re;
function zst(t) {
  var e = t.id, n = e === void 0 ? "downshift-" + bte() : e, r = t.labelId, i = t.menuId, o = t.getItemId, a = t.toggleButtonId, s = t.inputId, u = Ee({
    labelId: r || n + "-label",
    menuId: i || n + "-menu",
    getItemId: o || function(l) {
      return n + "-item-" + l;
    },
    toggleButtonId: a || n + "-toggle-button",
    inputId: s || n + "-input"
  });
  return u.current;
}
function Gst(t, e, n, r) {
  var i, o;
  if (t === void 0) {
    if (e === void 0)
      throw new Error(r);
    i = n[e], o = e;
  } else
    o = e === void 0 ? n.indexOf(t) : e, i = t;
  return [i, o];
}
function Ust(t) {
  return t ? String(t) : "";
}
function p8(t) {
  return "" + t.slice(0, 1).toUpperCase() + t.slice(1);
}
function Vte(t) {
  var e = Ee(t);
  return e.current = t, e;
}
function Xst(t, e, n) {
  var r = Ee(), i = Ee(), o = et(function(f, h) {
    i.current = h, f = D2(f, h.props);
    var p = t(f, h), v = h.props.stateReducer(f, G({}, h, {
      changes: p
    }));
    return v;
  }, [t]), a = Nm(o, e), s = a[0], u = a[1], l = Vte(n), c = et(function(f) {
    return u(G({
      props: l.current
    }, f));
  }, [l]), d = i.current;
  return Re(function() {
    d && r.current && r.current !== s && Lst(d, D2(r.current, d.props), s), r.current = s;
  }, [s, n, d]), [s, c];
}
var $0 = {
  itemToString: Ust,
  stateReducer: Bst,
  getA11ySelectionMessage: Hst,
  scrollIntoView: vte,
  environment: (
    /* istanbul ignore next (ssr) */
    typeof window > "u" ? {} : window
  )
};
function iu(t, e, n) {
  n === void 0 && (n = Lte);
  var r = t["default" + p8(e)];
  return r !== void 0 ? r : n[e];
}
function Gb(t, e, n) {
  n === void 0 && (n = Lte);
  var r = t[e];
  if (r !== void 0)
    return r;
  var i = t["initial" + p8(e)];
  return i !== void 0 ? i : iu(t, e, n);
}
function Yst(t) {
  var e = Gb(t, "selectedItem"), n = Gb(t, "isOpen"), r = Gb(t, "highlightedIndex"), i = Gb(t, "inputValue");
  return {
    highlightedIndex: r < 0 && e && n ? t.items.indexOf(e) : r,
    isOpen: n,
    selectedItem: e,
    inputValue: i
  };
}
function D0(t, e, n) {
  var r = t.items, i = t.initialHighlightedIndex, o = t.defaultHighlightedIndex, a = e.selectedItem, s = e.highlightedIndex;
  return r.length === 0 ? -1 : i !== void 0 && s === i ? i : o !== void 0 ? o : a ? r.indexOf(a) : n === 0 ? -1 : n < 0 ? r.length - 1 : 0;
}
function Zst(t, e, n, r) {
  var i = Ee({
    isMouseDown: !1,
    isTouchMove: !1
  });
  return Re(function() {
    if ((n == null ? void 0 : n.addEventListener) != null) {
      var o = function() {
        i.current.isMouseDown = !0;
      }, a = function(d) {
        i.current.isMouseDown = !1, t && !F2(d.target, e.map(function(f) {
          return f.current;
        }), n) && r();
      }, s = function() {
        i.current.isTouchMove = !1;
      }, u = function() {
        i.current.isTouchMove = !0;
      }, l = function(d) {
        t && !i.current.isTouchMove && !F2(d.target, e.map(function(f) {
          return f.current;
        }), n, !1) && r();
      };
      return n.addEventListener("mousedown", o), n.addEventListener("mouseup", a), n.addEventListener("touchstart", s), n.addEventListener("touchmove", u), n.addEventListener("touchend", l), function() {
        n.removeEventListener("mousedown", o), n.removeEventListener("mouseup", a), n.removeEventListener("touchstart", s), n.removeEventListener("touchmove", u), n.removeEventListener("touchend", l);
      };
    }
  }, [t, n]), i;
}
var Bte = function() {
  return La;
};
process.env.NODE_ENV !== "production" && (Bte = function() {
  for (var e = Ee(!0), n = arguments.length, r = new Array(n), i = 0; i < n; i++)
    r[i] = arguments[i];
  var o = Ee(r.reduce(function(s, u) {
    return s[u] = {}, s;
  }, {}));
  Re(function() {
    Object.keys(o.current).forEach(function(s) {
      var u = o.current[s];
      if (e.current && !Object.keys(u).length) {
        console.error("downshift: You forgot to call the " + s + " getter function on your component / element.");
        return;
      }
      var l = u.suppressRefError, c = u.refKey, d = u.elementRef;
      (!d || !d.current) && !l && console.error('downshift: The ref prop "' + c + '" from ' + s + " was not applied correctly on your element.");
    }), e.current = !1;
  });
  var a = et(function(s, u, l, c) {
    o.current[s] = {
      suppressRefError: u,
      refKey: l,
      elementRef: c
    };
  }, []);
  return a;
});
function PV(t, e, n) {
  var r = n.isInitialMount, i = n.highlightedIndex, o = n.items, a = n.environment, s = ws(n, Fst);
  Re(function() {
    r || Wst(function() {
      return t(G({
        highlightedIndex: i,
        highlightedItem: o[i],
        resultCount: o.length
      }, s));
    }, a.document);
  }, e);
}
function Jst(t) {
  var e = t.highlightedIndex, n = t.isOpen, r = t.itemRefs, i = t.getItemNodeFromIndex, o = t.menuElement, a = t.scrollIntoView, s = Ee(!0);
  return jst(function() {
    e < 0 || !n || !Object.keys(r.current).length || (s.current === !1 ? s.current = !0 : a(i(e), o));
  }, [e]), s;
}
var Hte = La;
process.env.NODE_ENV !== "production" && (Hte = function(e) {
  var n = e.isInitialMount, r = e.props, i = e.state, o = Ee(r);
  Re(function() {
    n || (h8(i, o.current, r), o.current = r);
  }, [i, r, n]);
});
function NV(t, e, n) {
  var r;
  n === void 0 && (n = !0);
  var i = ((r = t.items) == null ? void 0 : r.length) && e >= 0;
  return G({
    isOpen: !1,
    highlightedIndex: -1
  }, i && G({
    selectedItem: t.items[e],
    isOpen: iu(t, "isOpen"),
    highlightedIndex: iu(t, "highlightedIndex")
  }, n && {
    inputValue: t.itemToString(t.items[e])
  }));
}
function Kst(t, e, n) {
  var r = e.type, i = e.props, o;
  switch (r) {
    case n.ItemMouseMove:
      o = {
        highlightedIndex: e.disabled ? -1 : e.index
      };
      break;
    case n.MenuMouseLeave:
      o = {
        highlightedIndex: -1
      };
      break;
    case n.ToggleButtonClick:
    case n.FunctionToggleMenu:
      o = {
        isOpen: !t.isOpen,
        highlightedIndex: t.isOpen ? -1 : D0(i, t, 0)
      };
      break;
    case n.FunctionOpenMenu:
      o = {
        isOpen: !0,
        highlightedIndex: D0(i, t, 0)
      };
      break;
    case n.FunctionCloseMenu:
      o = {
        isOpen: !1
      };
      break;
    case n.FunctionSetHighlightedIndex:
      o = {
        highlightedIndex: e.highlightedIndex
      };
      break;
    case n.FunctionSetInputValue:
      o = {
        inputValue: e.inputValue
      };
      break;
    case n.FunctionReset:
      o = {
        highlightedIndex: iu(i, "highlightedIndex"),
        isOpen: iu(i, "isOpen"),
        selectedItem: iu(i, "selectedItem"),
        inputValue: iu(i, "inputValue")
      };
      break;
    default:
      throw new Error("Reducer called without proper action type.");
  }
  return G({}, t, o);
}
le.array.isRequired, le.func, le.func, le.func, le.number, le.number, le.number, le.bool, le.bool, le.bool, le.any, le.any, le.any, le.string, le.string, le.string, le.func, le.string, le.func, le.func, le.func, le.func, le.func, le.shape({
  addEventListener: le.func,
  removeEventListener: le.func,
  document: le.shape({
    getElementById: le.func,
    activeElement: le.any,
    body: le.any
  })
});
function qst(t) {
  var e = t.isOpen, n = t.resultCount, r = t.previousResultCount;
  return e ? n ? n !== r ? "".concat(n, " result").concat(n === 1 ? " is" : "s are", " available, use up and down arrow keys to navigate. Press Enter or Space Bar keys to select.") : "" : "No results are available." : "";
}
ja(ja({}, $0), { getA11yStatusMessage: qst });
process.env.NODE_ENV;
process.env.NODE_ENV;
process.env.NODE_ENV;
process.env.NODE_ENV;
process.env.NODE_ENV;
process.env.NODE_ENV;
process.env.NODE_ENV;
process.env.NODE_ENV;
process.env.NODE_ENV;
process.env.NODE_ENV;
process.env.NODE_ENV;
process.env.NODE_ENV;
process.env.NODE_ENV;
process.env.NODE_ENV;
process.env.NODE_ENV;
process.env.NODE_ENV;
process.env.NODE_ENV;
process.env.NODE_ENV;
process.env.NODE_ENV;
process.env.NODE_ENV;
process.env.NODE_ENV;
process.env.NODE_ENV;
process.env.NODE_ENV;
var g8 = process.env.NODE_ENV !== "production" ? "__input_keydown_arrow_down__" : 0, m8 = process.env.NODE_ENV !== "production" ? "__input_keydown_arrow_up__" : 1, v8 = process.env.NODE_ENV !== "production" ? "__input_keydown_escape__" : 2, b8 = process.env.NODE_ENV !== "production" ? "__input_keydown_home__" : 3, y8 = process.env.NODE_ENV !== "production" ? "__input_keydown_end__" : 4, x8 = process.env.NODE_ENV !== "production" ? "__input_keydown_page_up__" : 5, C8 = process.env.NODE_ENV !== "production" ? "__input_keydown_page_down__" : 6, w8 = process.env.NODE_ENV !== "production" ? "__input_keydown_enter__" : 7, E8 = process.env.NODE_ENV !== "production" ? "__input_change__" : 8, L2 = process.env.NODE_ENV !== "production" ? "__input_blur__" : 9, S8 = process.env.NODE_ENV !== "production" ? "__input_focus__" : 10, Wte = process.env.NODE_ENV !== "production" ? "__menu_mouse_leave__" : 11, jte = process.env.NODE_ENV !== "production" ? "__item_mouse_move__" : 12, I8 = process.env.NODE_ENV !== "production" ? "__item_click__" : 13, zte = process.env.NODE_ENV !== "production" ? "__togglebutton_click__" : 14, Gte = process.env.NODE_ENV !== "production" ? "__function_toggle_menu__" : 15, Ute = process.env.NODE_ENV !== "production" ? "__function_open_menu__" : 16, Xte = process.env.NODE_ENV !== "production" ? "__function_close_menu__" : 17, Yte = process.env.NODE_ENV !== "production" ? "__function_set_highlighted_index__" : 18, _8 = process.env.NODE_ENV !== "production" ? "__function_select_item__" : 19, Zte = process.env.NODE_ENV !== "production" ? "__function_set_input_value__" : 20, Jte = process.env.NODE_ENV !== "production" ? "__function_reset__" : 21, A8 = process.env.NODE_ENV !== "production" ? "__controlled_prop_updated_selected_item__" : 22, Kte = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  InputKeyDownArrowDown: g8,
  InputKeyDownArrowUp: m8,
  InputKeyDownEscape: v8,
  InputKeyDownHome: b8,
  InputKeyDownEnd: y8,
  InputKeyDownPageUp: x8,
  InputKeyDownPageDown: C8,
  InputKeyDownEnter: w8,
  InputChange: E8,
  InputBlur: L2,
  InputFocus: S8,
  MenuMouseLeave: Wte,
  ItemMouseMove: jte,
  ItemClick: I8,
  ToggleButtonClick: zte,
  FunctionToggleMenu: Gte,
  FunctionOpenMenu: Ute,
  FunctionCloseMenu: Xte,
  FunctionSetHighlightedIndex: Yte,
  FunctionSelectItem: _8,
  FunctionSetInputValue: Zte,
  FunctionReset: Jte,
  ControlledPropUpdatedSelectedItem: A8
});
function Qst(t) {
  var e = Yst(t), n = e.selectedItem, r = e.inputValue;
  return r === "" && n && t.defaultInputValue === void 0 && t.initialInputValue === void 0 && t.inputValue === void 0 && (r = t.itemToString(n)), G({}, e, {
    inputValue: r
  });
}
var eut = {
  items: le.array.isRequired,
  itemToString: le.func,
  selectedItemChanged: le.func,
  getA11yStatusMessage: le.func,
  getA11ySelectionMessage: le.func,
  highlightedIndex: le.number,
  defaultHighlightedIndex: le.number,
  initialHighlightedIndex: le.number,
  isOpen: le.bool,
  defaultIsOpen: le.bool,
  initialIsOpen: le.bool,
  selectedItem: le.any,
  initialSelectedItem: le.any,
  defaultSelectedItem: le.any,
  inputValue: le.string,
  defaultInputValue: le.string,
  initialInputValue: le.string,
  id: le.string,
  labelId: le.string,
  menuId: le.string,
  getItemId: le.func,
  inputId: le.string,
  toggleButtonId: le.string,
  stateReducer: le.func,
  onSelectedItemChange: le.func,
  onHighlightedIndexChange: le.func,
  onStateChange: le.func,
  onIsOpenChange: le.func,
  onInputValueChange: le.func,
  environment: le.shape({
    addEventListener: le.func,
    removeEventListener: le.func,
    document: le.shape({
      getElementById: le.func,
      activeElement: le.any,
      body: le.any
    })
  })
};
function tut(t, e, n) {
  var r = Ee(), i = Xst(t, e, n), o = i[0], a = i[1];
  return Re(function() {
    M2(n, "selectedItem") && (n.selectedItemChanged(r.current, n.selectedItem) && a({
      type: A8,
      inputValue: n.itemToString(n.selectedItem)
    }), r.current = o.selectedItem === r.current ? n.selectedItem : o.selectedItem);
  }, [o.selectedItem, n.selectedItem]), [D2(o, n), a];
}
var qte = La;
process.env.NODE_ENV !== "production" && (qte = function(e, n) {
  le.checkPropTypes(eut, e, "prop", n.name);
});
var nut = G({}, $0, {
  selectedItemChanged: function(e, n) {
    return e !== n;
  },
  getA11yStatusMessage: yte
});
function rut(t, e) {
  var n, r = e.type, i = e.props, o = e.altKey, a;
  switch (r) {
    case I8:
      a = {
        isOpen: iu(i, "isOpen"),
        highlightedIndex: iu(i, "highlightedIndex"),
        selectedItem: i.items[e.index],
        inputValue: i.itemToString(i.items[e.index])
      };
      break;
    case g8:
      t.isOpen ? a = {
        highlightedIndex: gd(1, t.highlightedIndex, i.items.length, e.getItemNodeFromIndex, !0)
      } : a = {
        highlightedIndex: o && t.selectedItem == null ? -1 : D0(i, t, 1, e.getItemNodeFromIndex),
        isOpen: i.items.length >= 0
      };
      break;
    case m8:
      t.isOpen ? o ? a = NV(i, t.highlightedIndex) : a = {
        highlightedIndex: gd(-1, t.highlightedIndex, i.items.length, e.getItemNodeFromIndex, !0)
      } : a = {
        highlightedIndex: D0(i, t, -1, e.getItemNodeFromIndex),
        isOpen: i.items.length >= 0
      };
      break;
    case w8:
      a = NV(i, t.highlightedIndex);
      break;
    case v8:
      a = G({
        isOpen: !1,
        highlightedIndex: -1
      }, !t.isOpen && {
        selectedItem: null,
        inputValue: ""
      });
      break;
    case x8:
      a = {
        highlightedIndex: gd(-10, t.highlightedIndex, i.items.length, e.getItemNodeFromIndex, !1)
      };
      break;
    case C8:
      a = {
        highlightedIndex: gd(10, t.highlightedIndex, i.items.length, e.getItemNodeFromIndex, !1)
      };
      break;
    case b8:
      a = {
        highlightedIndex: jd(1, 0, i.items.length, e.getItemNodeFromIndex, !1)
      };
      break;
    case y8:
      a = {
        highlightedIndex: jd(-1, i.items.length - 1, i.items.length, e.getItemNodeFromIndex, !1)
      };
      break;
    case L2:
      a = G({
        isOpen: !1,
        highlightedIndex: -1
      }, t.highlightedIndex >= 0 && ((n = i.items) == null ? void 0 : n.length) && e.selectItem && {
        selectedItem: i.items[t.highlightedIndex],
        inputValue: i.itemToString(i.items[t.highlightedIndex])
      });
      break;
    case E8:
      a = {
        isOpen: !0,
        highlightedIndex: iu(i, "highlightedIndex"),
        inputValue: e.inputValue
      };
      break;
    case S8:
      a = {
        isOpen: !0,
        highlightedIndex: D0(i, t, 0)
      };
      break;
    case _8:
      a = {
        selectedItem: e.selectedItem,
        inputValue: i.itemToString(e.selectedItem)
      };
      break;
    case A8:
      a = {
        inputValue: e.inputValue
      };
      break;
    default:
      return Kst(t, e, Kte);
  }
  return G({}, t, a);
}
var iut = ["onMouseLeave", "refKey", "ref"], out = ["item", "index", "refKey", "ref", "onMouseMove", "onMouseDown", "onClick", "onPress", "disabled"], aut = ["onClick", "onPress", "refKey", "ref"], sut = ["onKeyDown", "onChange", "onInput", "onFocus", "onBlur", "onChangeText", "refKey", "ref"];
T8.stateChangeTypes = Kte;
function T8(t) {
  t === void 0 && (t = {}), qte(t, T8);
  var e = G({}, nut, t), n = e.initialIsOpen, r = e.defaultIsOpen, i = e.items, o = e.scrollIntoView, a = e.environment, s = e.getA11yStatusMessage, u = e.getA11ySelectionMessage, l = e.itemToString, c = Qst(e), d = tut(rut, c, e), f = d[0], h = d[1], p = f.isOpen, v = f.highlightedIndex, m = f.selectedItem, b = f.inputValue, y = Ee(null), w = Ee({}), S = Ee(null), E = Ee(null), I = Ee(!0), _ = zst(e), A = Ee(), P = Vte({
    state: f,
    props: e
  }), N = et(function(Z) {
    return w.current[_.getItemId(Z)];
  }, [_]);
  PV(s, [p, v, b, i], G({
    isInitialMount: I.current,
    previousResultCount: A.current,
    items: i,
    environment: a,
    itemToString: l
  }, f)), PV(u, [m], G({
    isInitialMount: I.current,
    previousResultCount: A.current,
    items: i,
    environment: a,
    itemToString: l
  }, f));
  var k = Jst({
    menuElement: y.current,
    highlightedIndex: v,
    isOpen: p,
    itemRefs: w,
    scrollIntoView: o,
    getItemNodeFromIndex: N
  });
  Hte({
    isInitialMount: I.current,
    props: e,
    state: f
  }), Re(function() {
    var Z = n || r || p;
    Z && S.current && S.current.focus();
  }, []), Re(function() {
    I.current || (A.current = i.length);
  });
  var D = Zst(p, [S, y, E], a, function() {
    h({
      type: L2,
      selectItem: !1
    });
  }), R = Bte("getInputProps", "getMenuProps");
  Re(function() {
    return I.current = !1, function() {
      I.current = !0;
    };
  }, []), Re(function() {
    var Z;
    if (!p)
      w.current = {};
    else if (((Z = a.document) == null ? void 0 : Z.activeElement) !== S.current) {
      var ee;
      S == null || (ee = S.current) == null || ee.focus();
    }
  }, [p, a]);
  var V = Rn(function() {
    return {
      ArrowDown: function(ee) {
        ee.preventDefault(), h({
          type: g8,
          altKey: ee.altKey,
          getItemNodeFromIndex: N
        });
      },
      ArrowUp: function(ee) {
        ee.preventDefault(), h({
          type: m8,
          altKey: ee.altKey,
          getItemNodeFromIndex: N
        });
      },
      Home: function(ee) {
        P.current.state.isOpen && (ee.preventDefault(), h({
          type: b8,
          getItemNodeFromIndex: N
        }));
      },
      End: function(ee) {
        P.current.state.isOpen && (ee.preventDefault(), h({
          type: y8,
          getItemNodeFromIndex: N
        }));
      },
      Escape: function(ee) {
        var ie = P.current.state;
        (ie.isOpen || ie.inputValue || ie.selectedItem || ie.highlightedIndex > -1) && (ee.preventDefault(), h({
          type: v8
        }));
      },
      Enter: function(ee) {
        var ie = P.current.state;
        !ie.isOpen || ee.which === 229 || (ee.preventDefault(), h({
          type: w8,
          getItemNodeFromIndex: N
        }));
      },
      PageUp: function(ee) {
        P.current.state.isOpen && (ee.preventDefault(), h({
          type: x8,
          getItemNodeFromIndex: N
        }));
      },
      PageDown: function(ee) {
        P.current.state.isOpen && (ee.preventDefault(), h({
          type: C8,
          getItemNodeFromIndex: N
        }));
      }
    };
  }, [h, P, N]), $ = et(function(Z) {
    return G({
      id: _.labelId,
      htmlFor: _.inputId
    }, Z);
  }, [_]), F = et(function(Z, ee) {
    var ie, oe = Z === void 0 ? {} : Z, se = oe.onMouseLeave, te = oe.refKey, ge = te === void 0 ? "ref" : te, he = oe.ref, fe = ws(oe, iut), _e = ee === void 0 ? {} : ee, Ne = _e.suppressRefError, ze = Ne === void 0 ? !1 : Ne;
    return R("getMenuProps", ze, ge, y), G((ie = {}, ie[ge] = Rh(he, function(Ve) {
      y.current = Ve;
    }), ie.id = _.menuId, ie.role = "listbox", ie["aria-labelledby"] = fe && fe["aria-label"] ? void 0 : "" + _.labelId, ie.onMouseLeave = yi(se, function() {
      h({
        type: Wte
      });
    }), ie), fe);
  }, [h, R, _]), M = et(function(Z) {
    var ee, ie, oe = Z === void 0 ? {} : Z, se = oe.item, te = oe.index, ge = oe.refKey, he = ge === void 0 ? "ref" : ge, fe = oe.ref, _e = oe.onMouseMove, Ne = oe.onMouseDown, ze = oe.onClick;
    oe.onPress;
    var Ve = oe.disabled, ne = ws(oe, out), pe = P.current, ye = pe.props, Ae = pe.state, we = Gst(se, te, ye.items, "Pass either item or index to getItemProps!"), ce = we[1], ve = "onClick", Ie = ze, q = function() {
      ce !== Ae.highlightedIndex && (k.current = !1, h({
        type: jte,
        index: ce,
        disabled: Ve
      }));
    }, Fe = function() {
      h({
        type: I8,
        index: ce
      });
    }, Ze = function(Je) {
      return Je.preventDefault();
    };
    return G((ee = {}, ee[he] = Rh(fe, function(at) {
      at && (w.current[_.getItemId(ce)] = at);
    }), ee.disabled = Ve, ee.role = "option", ee["aria-selected"] = "" + (ce === Ae.highlightedIndex), ee.id = _.getItemId(ce), ee), !Ve && (ie = {}, ie[ve] = yi(Ie, Fe), ie), {
      onMouseMove: yi(_e, q),
      onMouseDown: yi(Ne, Ze)
    }, ne);
  }, [h, P, k, _]), B = et(function(Z) {
    var ee, ie = Z === void 0 ? {} : Z, oe = ie.onClick;
    ie.onPress;
    var se = ie.refKey, te = se === void 0 ? "ref" : se, ge = ie.ref, he = ws(ie, aut), fe = P.current.state, _e = function() {
      h({
        type: zte
      });
    };
    return G((ee = {}, ee[te] = Rh(ge, function(Ne) {
      E.current = Ne;
    }), ee["aria-controls"] = _.menuId, ee["aria-expanded"] = fe.isOpen, ee.id = _.toggleButtonId, ee.tabIndex = -1, ee), !he.disabled && G({}, {
      onClick: yi(oe, _e)
    }), he);
  }, [h, P, _]), X = et(function(Z, ee) {
    var ie, oe = Z === void 0 ? {} : Z, se = oe.onKeyDown, te = oe.onChange, ge = oe.onInput, he = oe.onFocus, fe = oe.onBlur;
    oe.onChangeText;
    var _e = oe.refKey, Ne = _e === void 0 ? "ref" : _e, ze = oe.ref, Ve = ws(oe, sut), ne = ee === void 0 ? {} : ee, pe = ne.suppressRefError, ye = pe === void 0 ? !1 : pe;
    R("getInputProps", ye, Ne, S);
    var Ae = P.current.state, we = function(Je) {
      var ut = f6(Je);
      ut && V[ut] && V[ut](Je);
    }, ce = function(Je) {
      h({
        type: E8,
        inputValue: Je.target.value
      });
    }, ve = function(Je) {
      if (Ae.isOpen && !D.current.isMouseDown) {
        var ut = Je.relatedTarget === null && a.document.activeElement !== a.document.body;
        h({
          type: L2,
          selectItem: !ut
        });
      }
    }, Ie = function() {
      Ae.isOpen || h({
        type: S8
      });
    }, q = "onChange", Fe = {};
    if (!Ve.disabled) {
      var Ze;
      Fe = (Ze = {}, Ze[q] = yi(te, ge, ce), Ze.onKeyDown = yi(se, we), Ze.onBlur = yi(fe, ve), Ze.onFocus = yi(he, Ie), Ze);
    }
    return G((ie = {}, ie[Ne] = Rh(ze, function(at) {
      S.current = at;
    }), ie["aria-activedescendant"] = Ae.isOpen && Ae.highlightedIndex > -1 ? _.getItemId(Ae.highlightedIndex) : "", ie["aria-autocomplete"] = "list", ie["aria-controls"] = _.menuId, ie["aria-expanded"] = Ae.isOpen, ie["aria-labelledby"] = Ve && Ve["aria-label"] ? void 0 : "" + _.labelId, ie.autoComplete = "off", ie.id = _.inputId, ie.role = "combobox", ie.value = Ae.inputValue, ie), Fe, Ve);
  }, [R, P, _, V, h, D, a]), L = et(function() {
    h({
      type: Gte
    });
  }, [h]), j = et(function() {
    h({
      type: Xte
    });
  }, [h]), K = et(function() {
    h({
      type: Ute
    });
  }, [h]), W = et(function(Z) {
    h({
      type: Yte,
      highlightedIndex: Z
    });
  }, [h]), Y = et(function(Z) {
    h({
      type: _8,
      selectedItem: Z
    });
  }, [h]), U = et(function(Z) {
    h({
      type: Zte,
      inputValue: Z
    });
  }, [h]), Q = et(function() {
    h({
      type: Jte
    });
  }, [h]);
  return {
    // prop getters.
    getItemProps: M,
    getLabelProps: $,
    getMenuProps: F,
    getInputProps: X,
    getToggleButtonProps: B,
    // actions.
    toggleMenu: L,
    openMenu: K,
    closeMenu: j,
    setHighlightedIndex: W,
    setInputValue: U,
    selectItem: Y,
    reset: Q,
    // state.
    highlightedIndex: v,
    isOpen: p,
    selectedItem: m,
    inputValue: b
  };
}
function uut(t) {
  var e = t.removedSelectedItem, n = t.itemToString;
  return n(e) + " has been removed.";
}
le.array, le.array, le.array, le.func, le.func, le.func, le.number, le.number, le.number, le.func, le.func, le.string, le.string, le.shape({
  addEventListener: le.func,
  removeEventListener: le.func,
  document: le.shape({
    getElementById: le.func,
    activeElement: le.any,
    body: le.any
  })
});
$0.itemToString, $0.stateReducer, $0.environment;
process.env.NODE_ENV;
process.env.NODE_ENV;
process.env.NODE_ENV;
process.env.NODE_ENV;
process.env.NODE_ENV;
process.env.NODE_ENV;
process.env.NODE_ENV;
process.env.NODE_ENV;
process.env.NODE_ENV;
process.env.NODE_ENV;
process.env.NODE_ENV;
process.env.NODE_ENV;
process.env.NODE_ENV;
process.env.NODE_ENV;
const kV = 20, Qte = (t) => t.suggestions.length > 0 ? /* @__PURE__ */ O.createElement(lut, { ...t }) : /* @__PURE__ */ O.createElement("input", { className: it.textInput, size: 40, autoFocus: !0, ...t.register(t.inputName) }), lut = ({
  autofocus: t,
  suggestions: e,
  control: n,
  inputName: r,
  placeholder: i,
  initialInputValue: o,
  setValue: a
}) => {
  const [s, u] = O.useState(e.slice(0, kV)), l = ua(Bo), c = e.length > 0, { isOpen: d, getToggleButtonProps: f, getMenuProps: h, getInputProps: p, highlightedIndex: v, getItemProps: m, selectedItem: b } = T8({
    initialInputValue: o,
    onInputValueChange({ inputValue: w = "" }) {
      a(r, w), w = w.toLowerCase() || "";
      const S = [];
      for (const E of e)
        if (E.toLowerCase().includes(w) && (S.push(E), S.length >= kV))
          break;
      u(S);
    },
    items: s,
    itemToString(w) {
      return w ?? "";
    }
  }), y = d && s.length > 0;
  return /* @__PURE__ */ O.createElement("div", { className: it.downshiftAutocompleteContainer }, /* @__PURE__ */ O.createElement("div", { "data-visible-dropdown": y, className: it.downshiftInputWrapper }, /* @__PURE__ */ O.createElement(
    sst,
    {
      name: r,
      control: n,
      render: ({ field: w }) => {
        const S = p();
        return /* @__PURE__ */ O.createElement(
          "input",
          {
            ...S,
            name: w.name,
            placeholder: i,
            className: it.downshiftInput,
            size: 30,
            "data-editor-dialog": !0,
            autoFocus: t
          }
        );
      }
    }
  ), c && /* @__PURE__ */ O.createElement("button", { "aria-label": "toggle menu", type: "button", ...f() }, l("arrow_drop_down"))), /* @__PURE__ */ O.createElement("div", { className: it.downshiftAutocompleteContainer }, /* @__PURE__ */ O.createElement("ul", { ...h(), "data-visible": y }, s.map((w, S) => /* @__PURE__ */ O.createElement(
    "li",
    {
      "data-selected": b === w,
      "data-highlighted": v === S,
      key: `${w}${S}`,
      ...m({ item: w, index: S })
    },
    w
  )))));
}, cut = () => {
  const [t, e, n, r] = ya(
    p6,
    Id,
    lf,
    tc
  ), i = Vi(ine), o = Vi(nne), a = qi(), { register: s, handleSubmit: u, control: l, setValue: c, reset: d } = mte({
    // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
    values: e.type === "editing" ? e.initialValues : {}
  });
  return /* @__PURE__ */ O.createElement(
    Zat,
    {
      open: e.type !== "inactive",
      onOpenChange: (f) => {
        f || (o(), d({ src: "", title: "", altText: "" }));
      }
    },
    /* @__PURE__ */ O.createElement(Jat, { container: n == null ? void 0 : n.current }, /* @__PURE__ */ O.createElement(Kat, { className: it.dialogOverlay }), /* @__PURE__ */ O.createElement(
      qat,
      {
        className: it.dialogContent,
        onOpenAutoFocus: (f) => {
          f.preventDefault();
        }
      },
      /* @__PURE__ */ O.createElement(Qat, null, a("uploadImage.dialogTitle", "Upload an image")),
      /* @__PURE__ */ O.createElement(
        "form",
        {
          onSubmit: (f) => {
            u(i)(f), d({ src: "", title: "", altText: "" }), f.preventDefault(), f.stopPropagation();
          },
          className: it.multiFieldForm
        },
        r === null ? /* @__PURE__ */ O.createElement("input", { type: "hidden", accept: "image/*", ...s("file") }) : /* @__PURE__ */ O.createElement("div", { className: it.formField }, /* @__PURE__ */ O.createElement("label", { htmlFor: "file" }, a("uploadImage.uploadInstructions", "Upload an image from your device:")), /* @__PURE__ */ O.createElement("input", { type: "file", accept: "image/*", ...s("file") })),
        /* @__PURE__ */ O.createElement("div", { className: it.formField }, /* @__PURE__ */ O.createElement("label", { htmlFor: "src" }, r !== null ? a("uploadImage.addViaUrlInstructions", "Or add an image from an URL:") : a("uploadImage.addViaUrlInstructionsNoUpload", "Add an image from an URL:")), /* @__PURE__ */ O.createElement(
          Qte,
          {
            register: s,
            initialInputValue: e.type === "editing" ? e.initialValues.src ?? "" : "",
            inputName: "src",
            suggestions: t,
            setValue: c,
            control: l,
            placeholder: a("uploadImage.autoCompletePlaceholder", "Select or paste an image src")
          }
        )),
        /* @__PURE__ */ O.createElement("div", { className: it.formField }, /* @__PURE__ */ O.createElement("label", { htmlFor: "alt" }, a("uploadImage.alt", "Alt:")), /* @__PURE__ */ O.createElement("input", { type: "text", ...s("altText"), className: it.textInput })),
        /* @__PURE__ */ O.createElement("div", { className: it.formField }, /* @__PURE__ */ O.createElement("label", { htmlFor: "title" }, a("uploadImage.title", "Title:")), /* @__PURE__ */ O.createElement("input", { type: "text", ...s("title"), className: it.textInput })),
        /* @__PURE__ */ O.createElement("div", { style: { display: "flex", justifyContent: "flex-end", gap: "var(--spacing-2)" } }, /* @__PURE__ */ O.createElement(
          "button",
          {
            type: "submit",
            title: a("dialogControls.save", "Save"),
            "aria-label": a("dialogControls.save", "Save"),
            className: Ce(it.primaryButton)
          },
          a("dialogControls.save", "Save")
        ), /* @__PURE__ */ O.createElement(est, { asChild: !0 }, /* @__PURE__ */ O.createElement(
          "button",
          {
            type: "reset",
            title: a("dialogControls.cancel", "Cancel"),
            "aria-label": a("dialogControls.cancel", "Cancel"),
            className: Ce(it.secondaryButton)
          },
          a("dialogControls.cancel", "Cancel")
        )))
      )
    ))
  );
};
function N5(t, e, n) {
  return Math.min(Math.max(t, e), n);
}
const _r = {
  east: 1,
  north: 8,
  south: 2,
  west: 4
};
function dut({
  onResizeStart: t,
  onResizeEnd: e,
  imageRef: n,
  maxWidth: r,
  editor: i
}) {
  const o = Ee(null), a = Ee({
    priority: "",
    value: "default"
  }), s = Ee({
    currentHeight: 0,
    currentWidth: 0,
    direction: 0,
    isResizing: !1,
    ratio: 0,
    startHeight: 0,
    startWidth: 0,
    startX: 0,
    startY: 0
  }), u = i.getRootElement(), l = r || (u !== null ? u.getBoundingClientRect().width - 20 : 100), c = u !== null ? u.getBoundingClientRect().height - 20 : 100, d = 100, f = 100, h = (y) => {
    const w = y === _r.east || y === _r.west, S = y === _r.north || y === _r.south, E = y & _r.north && y & _r.west || y & _r.south && y & _r.east, I = w ? "ew" : S ? "ns" : E ? "nwse" : "nesw";
    u !== null && u.style.setProperty("cursor", `${I}-resize`, "important"), document.body !== null && (document.body.style.setProperty("cursor", `${I}-resize`, "important"), a.current.value = document.body.style.getPropertyValue("-webkit-user-select"), a.current.priority = document.body.style.getPropertyPriority("-webkit-user-select"), document.body.style.setProperty("-webkit-user-select", "none", "important"));
  }, p = () => {
    u !== null && u.style.setProperty("cursor", "text"), document.body !== null && (document.body.style.setProperty("cursor", "default"), document.body.style.setProperty("-webkit-user-select", a.current.value, a.current.priority));
  }, v = (y, w) => {
    if (!i.isEditable())
      return;
    const S = n.current, E = o.current;
    if (S !== null && E !== null) {
      y.preventDefault();
      const { width: I, height: _ } = S.getBoundingClientRect(), A = s.current;
      A.startWidth = I, A.startHeight = _, A.ratio = I / _, A.currentWidth = I, A.currentHeight = _, A.startX = y.clientX, A.startY = y.clientY, A.isResizing = !0, A.direction = w, h(w), t(), E.classList.add(it.imageControlWrapperResizing), S.style.height = `${_}px`, S.style.width = `${I}px`, document.addEventListener("pointermove", m), document.addEventListener("pointerup", b);
    }
  }, m = (y) => {
    const w = n.current, S = s.current, E = S.direction & (_r.east | _r.west), I = S.direction & (_r.south | _r.north);
    if (w !== null && S.isResizing)
      if (E && I) {
        let _ = Math.floor(S.startX - y.clientX);
        _ = S.direction & _r.east ? -_ : _;
        const A = N5(S.startWidth + _, d, l), P = A / S.ratio;
        w.style.width = `${A}px`, w.style.height = `${P}px`, S.currentHeight = P, S.currentWidth = A;
      } else if (I) {
        let _ = Math.floor(S.startY - y.clientY);
        _ = S.direction & _r.south ? -_ : _;
        const A = N5(S.startHeight + _, f, c);
        w.style.height = `${A}px`, S.currentHeight = A;
      } else {
        let _ = Math.floor(S.startX - y.clientX);
        _ = S.direction & _r.east ? -_ : _;
        const A = N5(S.startWidth + _, d, l);
        w.style.width = `${A}px`, S.currentWidth = A;
      }
  }, b = () => {
    const y = n.current, w = s.current, S = o.current;
    if (y !== null && S !== null && w.isResizing) {
      const E = w.currentWidth, I = w.currentHeight;
      w.startWidth = 0, w.startHeight = 0, w.ratio = 0, w.startX = 0, w.startY = 0, w.currentWidth = 0, w.currentHeight = 0, w.isResizing = !1, S.classList.remove(it.imageControlWrapperResizing), p(), e(E, I), document.removeEventListener("pointermove", m), document.removeEventListener("pointerup", b);
    }
  };
  return /* @__PURE__ */ x.createElement("div", { ref: o }, /* @__PURE__ */ x.createElement(
    "div",
    {
      className: Ce(it.imageResizer, it.imageResizerN),
      onPointerDown: (y) => {
        v(y, _r.north);
      }
    }
  ), /* @__PURE__ */ x.createElement(
    "div",
    {
      className: Ce(it.imageResizer, it.imageResizerNe),
      onPointerDown: (y) => {
        v(y, _r.north | _r.east);
      }
    }
  ), /* @__PURE__ */ x.createElement(
    "div",
    {
      className: Ce(it.imageResizer, it.imageResizerE),
      onPointerDown: (y) => {
        v(y, _r.east);
      }
    }
  ), /* @__PURE__ */ x.createElement(
    "div",
    {
      className: Ce(it.imageResizer, it.imageResizerSe),
      onPointerDown: (y) => {
        v(y, _r.south | _r.east);
      }
    }
  ), /* @__PURE__ */ x.createElement(
    "div",
    {
      className: Ce(it.imageResizer, it.imageResizerS),
      onPointerDown: (y) => {
        v(y, _r.south);
      }
    }
  ), /* @__PURE__ */ x.createElement(
    "div",
    {
      className: Ce(it.imageResizer, it.imageResizerSw),
      onPointerDown: (y) => {
        v(y, _r.south | _r.west);
      }
    }
  ), /* @__PURE__ */ x.createElement(
    "div",
    {
      className: Ce(it.imageResizer, it.imageResizerW),
      onPointerDown: (y) => {
        v(y, _r.west);
      }
    }
  ), /* @__PURE__ */ x.createElement(
    "div",
    {
      className: Ce(it.imageResizer, it.imageResizerNw),
      onPointerDown: (y) => {
        v(y, _r.north | _r.west);
      }
    }
  ));
}
const RV = /* @__PURE__ */ new Set();
function fut(t) {
  if (!RV.has(t))
    throw new Promise((e) => {
      const n = new Image();
      n.src = t, n.onerror = n.onload = () => {
        RV.add(t), e(null);
      };
    });
}
function hut({
  title: t,
  alt: e,
  className: n,
  imageRef: r,
  src: i,
  width: o,
  height: a
}) {
  return fut(i), /* @__PURE__ */ O.createElement(
    "img",
    {
      className: n ?? void 0,
      alt: e,
      src: i,
      title: t,
      ref: r,
      draggable: "false",
      width: o,
      height: a
    }
  );
}
function put({ src: t, title: e, alt: n, nodeKey: r, width: i, height: o, rest: a }) {
  const [s, u, l, c, d] = ya(
    g6,
    rne,
    m6,
    Bo,
    vu
  ), f = Vi(tne), h = O.useRef(null), p = O.useRef(null), [v, m, b] = EQ(r), [y] = Vo(), [w, S] = O.useState(null), E = O.useRef(null), [I, _] = O.useState(!1), [A, P] = O.useState(null), [N, k] = O.useState(null), D = qi(), R = O.useCallback(
    (j) => {
      if (v && li(vt())) {
        j.preventDefault();
        const W = fi(r);
        V2(W) && W.remove();
      }
      return !1;
    },
    [v, r]
  ), V = O.useCallback(
    (j) => {
      const K = vt(), W = p.current;
      return v && li(K) && K.getNodes().length === 1 && W !== null && W !== document.activeElement ? (j.preventDefault(), W.focus(), !0) : !1;
    },
    [v]
  ), $ = O.useCallback(
    (j) => p.current === j.target ? (uo(null), y.update(() => {
      m(!0);
      const K = y.getRootElement();
      K !== null && K.focus();
    }), !0) : !1,
    [y, m]
  );
  O.useEffect(() => {
    l ? (async () => {
      N || k(t);
      const K = await l(t);
      P(K);
    })().catch((K) => {
      console.error(K);
    }) : P(t);
  }, [t, l, N]), O.useEffect(() => {
    let j = !0;
    const K = xa(
      y.registerUpdateListener(({ editorState: W }) => {
        j && S(W.read(() => vt()));
      }),
      y.registerCommand(
        fv,
        (W, Y) => (E.current = Y, !1),
        Ar
      ),
      y.registerCommand(
        pw,
        (W) => {
          const Y = W;
          return I ? !0 : Y.target === h.current ? (Y.shiftKey ? m(!v) : (b(), m(!0)), !0) : !1;
        },
        Ar
      ),
      y.registerCommand(
        vw,
        (W) => W.target === h.current ? (W.preventDefault(), !0) : !1,
        Ar
      ),
      y.registerCommand(mw, R, Ar),
      y.registerCommand(gw, R, Ar),
      y.registerCommand(lp, V, Ar),
      y.registerCommand(pv, $, Ar)
    );
    return () => {
      j = !1, K();
    };
  }, [b, y, I, v, r, R, V, $, m]);
  const F = (j, K) => {
    setTimeout(() => {
      _(!1);
    }, 200), y.update(() => {
      const W = fi(r);
      V2(W) && W.setWidthAndHeight(j, K);
    });
  }, M = () => {
    _(!0);
  }, B = li(w), X = v, L = O.useMemo(() => {
    if (a.length === 0)
      return null;
    const j = a.find((K) => K.type === "mdxJsxAttribute" && (K.name === "class" || K.name === "className"));
    return j ? j.value : null;
  }, [a]);
  return A !== null ? /* @__PURE__ */ O.createElement(O.Suspense, { fallback: null }, /* @__PURE__ */ O.createElement("div", { className: it.imageWrapper, "data-editor-block-type": "image" }, /* @__PURE__ */ O.createElement("div", { draggable: B }, /* @__PURE__ */ O.createElement(
    hut,
    {
      width: i,
      height: o,
      className: Ce(
        {
          [it.focusedImage]: X
        },
        L
      ),
      src: A,
      title: e ?? "",
      alt: n ?? "",
      imageRef: h
    }
  )), B && X && !s && /* @__PURE__ */ O.createElement(dut, { editor: y, imageRef: h, onResizeStart: M, onResizeEnd: F }), d || /* @__PURE__ */ O.createElement("div", { className: it.editImageToolbar }, /* @__PURE__ */ O.createElement(
    "button",
    {
      className: it.iconButton,
      type: "button",
      title: D("imageEditor.deleteImage", "Delete image"),
      disabled: d,
      onClick: (j) => {
        j.preventDefault(), y.update(() => {
          var K;
          (K = fi(r)) == null || K.remove();
        });
      }
    },
    c("delete_small")
  ), !u && /* @__PURE__ */ O.createElement(
    "button",
    {
      type: "button",
      className: Ce(it.iconButton, it.editImageButton),
      title: D("imageEditor.editImage", "Edit image"),
      disabled: d,
      onClick: () => {
        f({
          nodeKey: r,
          initialValues: {
            src: N || A,
            title: e ?? "",
            altText: n ?? ""
          }
        });
      }
    },
    c("settings")
  )))) : null;
}
var gut = Object.defineProperty, mut = (t, e, n) => e in t ? gut(t, e, { enumerable: !0, configurable: !0, writable: !0, value: n }) : t[e] = n, Xf = (t, e, n) => (mut(t, typeof e != "symbol" ? e + "" : e, n), n);
function vut(t) {
  if (t instanceof HTMLImageElement) {
    const { alt: e, src: n, title: r, width: i, height: o } = t;
    return { node: hf({ altText: e, src: n, title: r, width: i, height: o }) };
  }
  return null;
}
class Pv extends yv {
  /**
   * Constructs a new {@link ImageNode} with the specified image parameters.
   * Use {@link $createImageNode} to construct one.
   */
  constructor(e, n, r, i, o, a, s) {
    super(s), Xf(this, "__src"), Xf(this, "__altText"), Xf(this, "__title"), Xf(this, "__width"), Xf(this, "__height"), Xf(this, "__rest"), this.__src = e, this.__title = r, this.__altText = n, this.__width = i || "inherit", this.__height = o || "inherit", this.__rest = a ?? [];
  }
  /** @internal */
  static getType() {
    return "image";
  }
  /** @internal */
  static clone(e) {
    return new Pv(e.__src, e.__altText, e.__title, e.__width, e.__height, e.__rest, e.__key);
  }
  /** @internal */
  static importJSON(e) {
    const { altText: n, title: r, src: i, width: o, rest: a, height: s } = e;
    return hf({
      altText: n,
      title: r,
      src: i,
      height: s,
      width: o,
      rest: a
    });
  }
  /** @internal */
  exportDOM() {
    const e = document.createElement("img");
    return e.setAttribute("src", this.__src), e.setAttribute("alt", this.__altText), this.__title && e.setAttribute("title", this.__title), this.__width && e.setAttribute("width", this.__width.toString()), this.__height && e.setAttribute("height", this.__height.toString()), { element: e };
  }
  /** @internal */
  static importDOM() {
    return {
      img: () => ({
        conversion: vut,
        priority: 0
      })
    };
  }
  /** @internal */
  exportJSON() {
    return {
      altText: this.getAltText(),
      title: this.getTitle(),
      height: this.__height === "inherit" ? 0 : this.__height,
      width: this.__width === "inherit" ? 0 : this.__width,
      src: this.getSrc(),
      rest: this.__rest,
      type: "image",
      version: 1
    };
  }
  /**
   * Sets the image dimensions
   */
  setWidthAndHeight(e, n) {
    const r = this.getWritable();
    r.__width = e, r.__height = n;
  }
  /** @internal */
  createDOM(e) {
    const n = document.createElement("span"), i = e.theme.image;
    return i !== void 0 && (n.className = i), n;
  }
  /** @internal */
  updateDOM() {
    return !1;
  }
  getSrc() {
    return this.__src;
  }
  getAltText() {
    return this.__altText;
  }
  getTitle() {
    return this.__title;
  }
  getHeight() {
    return this.__height;
  }
  getWidth() {
    return this.__width;
  }
  getRest() {
    return this.__rest;
  }
  setTitle(e) {
    this.getWritable().__title = e;
  }
  setSrc(e) {
    this.getWritable().__src = e;
  }
  setAltText(e) {
    this.getWritable().__altText = e ?? "";
  }
  /** @internal */
  shouldBeSerializedAsElement() {
    return this.__width !== "inherit" || this.__height !== "inherit" || this.__rest.length > 0;
  }
  /** @internal */
  decorate(e) {
    return /* @__PURE__ */ O.createElement(
      put,
      {
        src: this.getSrc(),
        title: this.getTitle(),
        nodeKey: this.getKey(),
        width: this.__width,
        height: this.__height,
        alt: this.__altText,
        rest: this.__rest
      }
    );
  }
}
function hf(t) {
  const { altText: e, title: n, src: r, key: i, width: o, height: a, rest: s } = t;
  return new Pv(r, e, n, o, a, s, i);
}
function V2(t) {
  return t instanceof Pv;
}
const but = {
  testLexicalNode: V2,
  visitLexicalNode({ mdastParent: t, lexicalNode: e, actions: n }) {
    if (e.shouldBeSerializedAsElement()) {
      const r = new Image();
      e.getHeight() !== "inherit" && (r.height = e.getHeight()), e.getWidth() !== "inherit" && (r.width = e.getWidth()), e.getAltText() && (r.alt = e.getAltText()), e.getTitle() && (r.title = e.getTitle());
      for (const i of e.getRest())
        i.type === "mdxJsxAttribute" && typeof i.value == "string" && r.setAttribute(i.name, i.value);
      n.appendToParent(t, {
        type: "html",
        value: r.outerHTML.replace(/>$/, ` src="${e.getSrc()}" />`)
      });
    } else
      n.appendToParent(t, {
        type: "image",
        url: e.getSrc(),
        alt: e.getAltText(),
        title: e.getTitle()
      });
  }
}, yut = {
  testNode: "image",
  visitNode({ mdastNode: t, actions: e }) {
    e.addAndStepInto(
      hf({
        src: t.url,
        altText: t.alt ?? "",
        title: t.title ?? ""
      })
    );
  }
}, xut = {
  testNode: (t) => t.type === "html" && t.value.trim().startsWith("<img"),
  visitNode({ mdastNode: t, lexicalParent: e }) {
    const n = document.createElement("div");
    n.innerHTML = t.value;
    const r = n.querySelector("img");
    if (!r)
      throw new Error("Invalid HTML image");
    const i = r.src, o = r.alt, a = r.title, s = r.width, u = r.height, l = hf({
      src: i || "",
      altText: o,
      title: a,
      width: s,
      height: u
    });
    if (e.getType() === "root") {
      const c = Sr();
      c.append(l), e.append(c);
    } else
      e.append(l);
  }
};
function zg(t, e) {
  const n = t.attributes.find((r) => r.type === "mdxJsxAttribute" && r.name === e);
  if (n)
    return n.value;
}
const Cut = {
  testNode: (t) => (t.type === "mdxJsxTextElement" || t.type === "mdxJsxFlowElement") && t.name === "img",
  visitNode({ mdastNode: t, lexicalParent: e }) {
    const n = zg(t, "src");
    if (!n)
      return;
    const r = zg(t, "alt") ?? "", i = zg(t, "title"), o = zg(t, "height"), a = zg(t, "width"), s = t.attributes.filter((l) => l.type === "mdxJsxAttribute" && !["src", "alt", "title", "height", "width"].includes(l.name)), u = hf({
      src: n,
      altText: r,
      title: i,
      width: a ? parseInt(a, 10) : void 0,
      height: o ? parseInt(o, 10) : void 0,
      rest: s
    });
    if (e.getType() === "root") {
      const l = Sr();
      l.append(u), e.append(l);
    } else
      e.append(u);
  }
}, O8 = Ei((t) => {
  t.sub(t.pipe(O8, Zr(hi)), ([e, n]) => {
    n == null || n.update(() => {
      const r = hf({ altText: e.altText ?? "", src: e.src, title: e.title ?? "" });
      Bp([r]), Oi(r.getParentOrThrow()) && gO(r, Sr).selectEnd();
    });
  });
}), wut = Ei((t) => {
  t.sub(t.pipe(wut, Zr(tc)), ([e, n]) => {
    const r = (i) => {
      t.pub(O8, { ...e, src: i });
    };
    "file" in e ? n == null || n(e.file).then(r).catch((i) => {
      throw i;
    }) : r(e.src);
  });
}), p6 = Ht([]), g6 = Ht(!1), tc = Ht(null), m6 = Ht(null), Id = Ht(
  { type: "inactive" },
  (t) => {
    t.sub(
      t.pipe(ine, Zr(hi, tc, Id)),
      ([e, n, r, i]) => {
        const o = i.type === "editing" ? (a) => {
          n == null || n.update(() => {
            const { nodeKey: s } = i, u = fi(s);
            u.setTitle(e.title), u.setAltText(e.altText), u.setSrc(a);
          }), t.pub(Id, { type: "inactive" });
        } : (a) => {
          t.pub(O8, { ...e, src: a }), t.pub(Id, { type: "inactive" });
        };
        e.file.length > 0 ? r == null || r(e.file.item(0)).then(o).catch((a) => {
          throw a;
        }) : e.src && o(e.src);
      }
    ), t.pub(C2, (e) => {
      const n = t.getValue(tc);
      return xa(
        e.registerCommand(
          B2,
          (r) => {
            const i = hf(r);
            return Bp([i]), Oi(i.getParentOrThrow()) && gO(i, Sr).selectEnd(), !0;
          },
          kn
        ),
        e.registerCommand(
          vw,
          (r) => _ut(r),
          _4
        ),
        e.registerCommand(
          DT,
          (r) => Aut(r, !!n),
          Ar
        ),
        e.registerCommand(
          $T,
          (r) => Tut(r, e, t.getValue(tc)),
          _4
        ),
        e.registerCommand(
          hv,
          (r) => {
            var i, o;
            if (!n) {
              let l = Array.from(((i = r.clipboardData) == null ? void 0 : i.items) ?? []);
              return l = l.filter((c) => c.type.includes("text")), !l.length || l.length === 0;
            }
            const a = Array.from(((o = r.clipboardData) == null ? void 0 : o.items) ?? []);
            if (a.some((l) => !l.type.includes("image")) || !a.length || a.length === 0)
              return !1;
            const u = t.getValue(tc);
            return Promise.all(a.map((l) => u(l.getAsFile()))).then((l) => {
              l.forEach((c) => {
                e.dispatchCommand(B2, {
                  src: c,
                  altText: ""
                });
              });
            }).catch((l) => {
              throw l;
            }), !0;
          },
          vc
        )
      );
    });
  }
), ene = Nc((t) => {
  t.link(t.pipe(ene, VJ({ type: "new" })), Id);
}), tne = Ei((t) => {
  t.link(
    t.pipe(
      tne,
      Wh((e) => ({ type: "editing", ...e }))
    ),
    Id
  );
}), nne = Nc((t) => {
  t.link(t.pipe(nne, VJ({ type: "inactive" })), Id);
}), rne = Ht(!1), ine = Ei(), Eut = pl({
  init(t, e) {
    t.pubIn({
      [bc]: [yut, xut, Cut],
      [cf]: Pv,
      [df]: but,
      [jp]: (e == null ? void 0 : e.ImageDialog) ?? cut,
      [tc]: (e == null ? void 0 : e.imageUploadHandler) ?? null,
      [p6]: (e == null ? void 0 : e.imageAutocompleteSuggestions) ?? [],
      [g6]: !!(e != null && e.disableImageResize),
      [rne]: !!(e != null && e.disableImageSettingsButton),
      [m6]: (e == null ? void 0 : e.imagePreviewHandler) ?? null
    });
  },
  update(t, e) {
    t.pubIn({
      [tc]: (e == null ? void 0 : e.imageUploadHandler) ?? null,
      [p6]: (e == null ? void 0 : e.imageAutocompleteSuggestions) ?? [],
      [g6]: !!(e != null && e.disableImageResize),
      [m6]: (e == null ? void 0 : e.imagePreviewHandler) ?? null
    });
  }
}), Sut = (t) => xQ ? (t ?? window).getSelection() : null, B2 = gl(), Iut = "data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA7";
function _ut(t) {
  const e = P8();
  if (!e)
    return !1;
  const n = t.dataTransfer;
  if (!n)
    return !1;
  n.setData("text/plain", "_");
  const r = document.createElement("img");
  return r.src = Iut, n.setDragImage(r, 0, 0), n.setData(
    "application/x-lexical-drag",
    JSON.stringify({
      data: {
        altText: e.__altText,
        title: e.__title,
        key: e.getKey(),
        src: e.__src
      },
      type: "image"
    })
  ), !0;
}
function Aut(t, e) {
  var n;
  if (e) {
    let i = Array.from(((n = t.dataTransfer) == null ? void 0 : n.items) ?? []);
    if (i = i.filter((o) => o.type.includes("image")), i.length > 0)
      return t.preventDefault(), !0;
  }
  return P8() ? (one(t) || t.preventDefault(), !0) : !1;
}
function Tut(t, e, n) {
  var r;
  let i = Array.from(((r = t.dataTransfer) == null ? void 0 : r.items) ?? []);
  if (i = i.filter((s) => s.type.includes("image")), i.length > 0 && n !== null)
    return t.preventDefault(), Promise.all(i.map((s) => n(s.getAsFile()))).then((s) => {
      s.forEach((u) => {
        e.dispatchCommand(B2, {
          src: u,
          altText: ""
        });
      });
    }).catch((s) => {
      throw s;
    }), !0;
  const o = P8();
  if (!o)
    return !1;
  const a = Out(t);
  if (!a)
    return !1;
  if (t.preventDefault(), one(t)) {
    const s = Put(t);
    o.remove();
    const u = uO();
    s != null && u.applyDOMRange(s), uo(u), e.dispatchCommand(B2, a);
  }
  return !0;
}
function P8() {
  const t = vt();
  if (!li(t))
    return null;
  const n = t.getNodes()[0];
  return V2(n) ? n : null;
}
function Out(t) {
  var e;
  const n = (e = t.dataTransfer) == null ? void 0 : e.getData("application/x-lexical-drag");
  if (!n)
    return null;
  const { type: r, data: i } = JSON.parse(n);
  return r !== "image" ? null : i;
}
function one(t) {
  const e = t.target;
  return !!(e && e instanceof HTMLElement && e.parentElement);
}
function Put(t) {
  let e;
  const n = t.target, r = n == null ? null : n.nodeType === 9 ? n.defaultView : n.ownerDocument.defaultView, i = Sut(r);
  if (document.caretRangeFromPoint)
    e = document.caretRangeFromPoint(t.clientX, t.clientY);
  else if (t.rangeParent && i !== null)
    i.collapse(t.rangeParent, t.rangeOffset ?? 0), e = i.getRangeAt(0);
  else
    throw Error("Cannot get the selection when dragging");
  return e;
}
function $V(t, [e, n]) {
  return Math.min(n, Math.max(e, t));
}
const v6 = "dismissableLayer.update", Nut = "dismissableLayer.pointerDownOutside", kut = "dismissableLayer.focusOutside";
let DV;
const Rut = /* @__PURE__ */ oi({
  layers: /* @__PURE__ */ new Set(),
  layersWithOutsidePointerEventsDisabled: /* @__PURE__ */ new Set(),
  branches: /* @__PURE__ */ new Set()
}), $ut = /* @__PURE__ */ gt((t, e) => {
  var n;
  const { disableOutsidePointerEvents: r = !1, onEscapeKeyDown: i, onPointerDownOutside: o, onFocusOutside: a, onInteractOutside: s, onDismiss: u, ...l } = t, c = fn(Rut), [d, f] = Le(null), h = (n = d == null ? void 0 : d.ownerDocument) !== null && n !== void 0 ? n : globalThis == null ? void 0 : globalThis.document, [, p] = Le({}), v = Kn(
    e,
    (A) => f(A)
  ), m = Array.from(c.layers), [b] = [
    ...c.layersWithOutsidePointerEventsDisabled
  ].slice(-1), y = m.indexOf(b), w = d ? m.indexOf(d) : -1, S = c.layersWithOutsidePointerEventsDisabled.size > 0, E = w >= y, I = Dut((A) => {
    const P = A.target, N = [
      ...c.branches
    ].some(
      (k) => k.contains(P)
    );
    !E || N || (o == null || o(A), s == null || s(A), A.defaultPrevented || u == null || u());
  }, h), _ = Mut((A) => {
    const P = A.target;
    [
      ...c.branches
    ].some(
      (k) => k.contains(P)
    ) || (a == null || a(A), s == null || s(A), A.defaultPrevented || u == null || u());
  }, h);
  return Lw((A) => {
    w === c.layers.size - 1 && (i == null || i(A), !A.defaultPrevented && u && (A.preventDefault(), u()));
  }, h), Re(() => {
    if (d)
      return r && (c.layersWithOutsidePointerEventsDisabled.size === 0 && (DV = h.body.style.pointerEvents, h.body.style.pointerEvents = "none"), c.layersWithOutsidePointerEventsDisabled.add(d)), c.layers.add(d), MV(), () => {
        r && c.layersWithOutsidePointerEventsDisabled.size === 1 && (h.body.style.pointerEvents = DV);
      };
  }, [
    d,
    h,
    r,
    c
  ]), Re(() => () => {
    d && (c.layers.delete(d), c.layersWithOutsidePointerEventsDisabled.delete(d), MV());
  }, [
    d,
    c
  ]), Re(() => {
    const A = () => p({});
    return document.addEventListener(v6, A), () => document.removeEventListener(v6, A);
  }, []), /* @__PURE__ */ Pe(Sn.div, G({}, l, {
    ref: v,
    style: {
      pointerEvents: S ? E ? "auto" : "none" : void 0,
      ...t.style
    },
    onFocusCapture: ln(t.onFocusCapture, _.onFocusCapture),
    onBlurCapture: ln(t.onBlurCapture, _.onBlurCapture),
    onPointerDownCapture: ln(t.onPointerDownCapture, I.onPointerDownCapture)
  }));
});
function Dut(t, e = globalThis == null ? void 0 : globalThis.document) {
  const n = Kr(t), r = Ee(!1), i = Ee(() => {
  });
  return Re(() => {
    const o = (s) => {
      if (s.target && !r.current) {
        let l = function() {
          ane(Nut, n, u, {
            discrete: !0
          });
        };
        const u = {
          originalEvent: s
        };
        s.pointerType === "touch" ? (e.removeEventListener("click", i.current), i.current = l, e.addEventListener("click", i.current, {
          once: !0
        })) : l();
      } else
        e.removeEventListener("click", i.current);
      r.current = !1;
    }, a = window.setTimeout(() => {
      e.addEventListener("pointerdown", o);
    }, 0);
    return () => {
      window.clearTimeout(a), e.removeEventListener("pointerdown", o), e.removeEventListener("click", i.current);
    };
  }, [
    e,
    n
  ]), {
    // ensures we check React component tree (not just DOM tree)
    onPointerDownCapture: () => r.current = !0
  };
}
function Mut(t, e = globalThis == null ? void 0 : globalThis.document) {
  const n = Kr(t), r = Ee(!1);
  return Re(() => {
    const i = (o) => {
      o.target && !r.current && ane(kut, n, {
        originalEvent: o
      }, {
        discrete: !1
      });
    };
    return e.addEventListener("focusin", i), () => e.removeEventListener("focusin", i);
  }, [
    e,
    n
  ]), {
    onFocusCapture: () => r.current = !0,
    onBlurCapture: () => r.current = !1
  };
}
function MV() {
  const t = new CustomEvent(v6);
  document.dispatchEvent(t);
}
function ane(t, e, n, { discrete: r }) {
  const i = n.originalEvent.target, o = new CustomEvent(t, {
    bubbles: !1,
    cancelable: !0,
    detail: n
  });
  e && i.addEventListener(t, e, {
    once: !0
  }), r ? Fw(i, o) : i.dispatchEvent(o);
}
const k5 = "focusScope.autoFocusOnMount", R5 = "focusScope.autoFocusOnUnmount", FV = {
  bubbles: !1,
  cancelable: !0
}, Fut = /* @__PURE__ */ gt((t, e) => {
  const { loop: n = !1, trapped: r = !1, onMountAutoFocus: i, onUnmountAutoFocus: o, ...a } = t, [s, u] = Le(null), l = Kr(i), c = Kr(o), d = Ee(null), f = Kn(
    e,
    (v) => u(v)
  ), h = Ee({
    paused: !1,
    pause() {
      this.paused = !0;
    },
    resume() {
      this.paused = !1;
    }
  }).current;
  Re(() => {
    if (r) {
      let v = function(w) {
        if (h.paused || !s)
          return;
        const S = w.target;
        s.contains(S) ? d.current = S : Hl(d.current, {
          select: !0
        });
      }, m = function(w) {
        if (h.paused || !s)
          return;
        const S = w.relatedTarget;
        S !== null && (s.contains(S) || Hl(d.current, {
          select: !0
        }));
      }, b = function(w) {
        if (document.activeElement === document.body)
          for (const E of w)
            E.removedNodes.length > 0 && Hl(s);
      };
      document.addEventListener("focusin", v), document.addEventListener("focusout", m);
      const y = new MutationObserver(b);
      return s && y.observe(s, {
        childList: !0,
        subtree: !0
      }), () => {
        document.removeEventListener("focusin", v), document.removeEventListener("focusout", m), y.disconnect();
      };
    }
  }, [
    r,
    s,
    h.paused
  ]), Re(() => {
    if (s) {
      VV.add(h);
      const v = document.activeElement;
      if (!s.contains(v)) {
        const b = new CustomEvent(k5, FV);
        s.addEventListener(k5, l), s.dispatchEvent(b), b.defaultPrevented || (Lut(jut(sne(s)), {
          select: !0
        }), document.activeElement === v && Hl(s));
      }
      return () => {
        s.removeEventListener(k5, l), setTimeout(() => {
          const b = new CustomEvent(R5, FV);
          s.addEventListener(R5, c), s.dispatchEvent(b), b.defaultPrevented || Hl(v ?? document.body, {
            select: !0
          }), s.removeEventListener(R5, c), VV.remove(h);
        }, 0);
      };
    }
  }, [
    s,
    l,
    c,
    h
  ]);
  const p = et((v) => {
    if (!n && !r || h.paused)
      return;
    const m = v.key === "Tab" && !v.altKey && !v.ctrlKey && !v.metaKey, b = document.activeElement;
    if (m && b) {
      const y = v.currentTarget, [w, S] = Vut(y);
      w && S ? !v.shiftKey && b === S ? (v.preventDefault(), n && Hl(w, {
        select: !0
      })) : v.shiftKey && b === w && (v.preventDefault(), n && Hl(S, {
        select: !0
      })) : b === y && v.preventDefault();
    }
  }, [
    n,
    r,
    h.paused
  ]);
  return /* @__PURE__ */ Pe(Sn.div, G({
    tabIndex: -1
  }, a, {
    ref: f,
    onKeyDown: p
  }));
});
function Lut(t, { select: e = !1 } = {}) {
  const n = document.activeElement;
  for (const r of t)
    if (Hl(r, {
      select: e
    }), document.activeElement !== n)
      return;
}
function Vut(t) {
  const e = sne(t), n = LV(e, t), r = LV(e.reverse(), t);
  return [
    n,
    r
  ];
}
function sne(t) {
  const e = [], n = document.createTreeWalker(t, NodeFilter.SHOW_ELEMENT, {
    acceptNode: (r) => {
      const i = r.tagName === "INPUT" && r.type === "hidden";
      return r.disabled || r.hidden || i ? NodeFilter.FILTER_SKIP : r.tabIndex >= 0 ? NodeFilter.FILTER_ACCEPT : NodeFilter.FILTER_SKIP;
    }
  });
  for (; n.nextNode(); )
    e.push(n.currentNode);
  return e;
}
function LV(t, e) {
  for (const n of t)
    if (!But(n, {
      upTo: e
    }))
      return n;
}
function But(t, { upTo: e }) {
  if (getComputedStyle(t).visibility === "hidden")
    return !0;
  for (; t; ) {
    if (e !== void 0 && t === e)
      return !1;
    if (getComputedStyle(t).display === "none")
      return !0;
    t = t.parentElement;
  }
  return !1;
}
function Hut(t) {
  return t instanceof HTMLInputElement && "select" in t;
}
function Hl(t, { select: e = !1 } = {}) {
  if (t && t.focus) {
    const n = document.activeElement;
    t.focus({
      preventScroll: !0
    }), t !== n && Hut(t) && e && t.select();
  }
}
const VV = Wut();
function Wut() {
  let t = [];
  return {
    add(e) {
      const n = t[0];
      e !== n && (n == null || n.pause()), t = BV(t, e), t.unshift(e);
    },
    remove(e) {
      var n;
      t = BV(t, e), (n = t[0]) === null || n === void 0 || n.resume();
    }
  };
}
function BV(t, e) {
  const n = [
    ...t
  ], r = n.indexOf(e);
  return r !== -1 && n.splice(r, 1), n;
}
function jut(t) {
  return t.filter(
    (e) => e.tagName !== "A"
  );
}
const une = "Popper", [lne, cne] = Vs(une), [zut, dne] = lne(une), Gut = (t) => {
  const { __scopePopper: e, children: n } = t, [r, i] = Le(null);
  return /* @__PURE__ */ Pe(zut, {
    scope: e,
    anchor: r,
    onAnchorChange: i
  }, n);
}, Uut = "PopperAnchor", Xut = /* @__PURE__ */ gt((t, e) => {
  const { __scopePopper: n, virtualRef: r, ...i } = t, o = dne(Uut, n), a = Ee(null), s = Kn(e, a);
  return Re(() => {
    o.onAnchorChange((r == null ? void 0 : r.current) || a.current);
  }), r ? null : /* @__PURE__ */ Pe(Sn.div, G({}, i, {
    ref: s
  }));
}), fne = "PopperContent", [Yut, Abt] = lne(fne), Zut = /* @__PURE__ */ gt((t, e) => {
  var n, r, i, o, a, s, u, l;
  const { __scopePopper: c, side: d = "bottom", sideOffset: f = 0, align: h = "center", alignOffset: p = 0, arrowPadding: v = 0, avoidCollisions: m = !0, collisionBoundary: b = [], collisionPadding: y = 0, sticky: w = "partial", hideWhenDetached: S = !1, updatePositionStrategy: E = "optimized", onPlaced: I, ..._ } = t, A = dne(fne, c), [P, N] = Le(null), k = Kn(
    e,
    (fe) => N(fe)
  ), [D, R] = Le(null), V = JO(D), $ = (n = V == null ? void 0 : V.width) !== null && n !== void 0 ? n : 0, F = (r = V == null ? void 0 : V.height) !== null && r !== void 0 ? r : 0, M = d + (h !== "center" ? "-" + h : ""), B = typeof y == "number" ? y : {
    top: 0,
    right: 0,
    bottom: 0,
    left: 0,
    ...y
  }, X = Array.isArray(b) ? b : [
    b
  ], L = X.length > 0, j = {
    padding: B,
    boundary: X.filter(Jut),
    // with `strategy: 'fixed'`, this is the only way to get it to respect boundaries
    altBoundary: L
  }, { refs: K, floatingStyles: W, placement: Y, isPositioned: U, middlewareData: Q } = ZO({
    // default to `fixed` strategy so users don't have to pick and we also avoid focus scroll issues
    strategy: "fixed",
    placement: M,
    whileElementsMounted: (...fe) => XO(...fe, {
      animationFrame: E === "always"
    }),
    elements: {
      reference: A.anchor
    },
    middleware: [
      BO({
        mainAxis: f + F,
        alignmentAxis: p
      }),
      m && HO({
        mainAxis: !0,
        crossAxis: !1,
        limiter: w === "partial" ? WO() : void 0,
        ...j
      }),
      m && LO({
        ...j
      }),
      jO({
        ...j,
        apply: ({ elements: fe, rects: _e, availableWidth: Ne, availableHeight: ze }) => {
          const { width: Ve, height: ne } = _e.reference, pe = fe.floating.style;
          pe.setProperty("--radix-popper-available-width", `${Ne}px`), pe.setProperty("--radix-popper-available-height", `${ze}px`), pe.setProperty("--radix-popper-anchor-width", `${Ve}px`), pe.setProperty("--radix-popper-anchor-height", `${ne}px`);
        }
      }),
      D && YO({
        element: D,
        padding: v
      }),
      Kut({
        arrowWidth: $,
        arrowHeight: F
      }),
      S && VO({
        strategy: "referenceHidden",
        ...j
      })
    ]
  }), [Z, ee] = hne(Y), ie = Kr(I);
  co(() => {
    U && (ie == null || ie());
  }, [
    U,
    ie
  ]);
  const oe = (i = Q.arrow) === null || i === void 0 ? void 0 : i.x, se = (o = Q.arrow) === null || o === void 0 ? void 0 : o.y, te = ((a = Q.arrow) === null || a === void 0 ? void 0 : a.centerOffset) !== 0, [ge, he] = Le();
  return co(() => {
    P && he(window.getComputedStyle(P).zIndex);
  }, [
    P
  ]), /* @__PURE__ */ Pe("div", {
    ref: K.setFloating,
    "data-radix-popper-content-wrapper": "",
    style: {
      ...W,
      transform: U ? W.transform : "translate(0, -200%)",
      // keep off the page when measuring
      minWidth: "max-content",
      zIndex: ge,
      "--radix-popper-transform-origin": [
        (s = Q.transformOrigin) === null || s === void 0 ? void 0 : s.x,
        (u = Q.transformOrigin) === null || u === void 0 ? void 0 : u.y
      ].join(" ")
    },
    dir: t.dir
  }, /* @__PURE__ */ Pe(Yut, {
    scope: c,
    placedSide: Z,
    onArrowChange: R,
    arrowX: oe,
    arrowY: se,
    shouldHideArrow: te
  }, /* @__PURE__ */ Pe(Sn.div, G({
    "data-side": Z,
    "data-align": ee
  }, _, {
    ref: k,
    style: {
      ..._.style,
      // if the PopperContent hasn't been placed yet (not all measurements done)
      // we prevent animations so that users's animation don't kick in too early referring wrong sides
      animation: U ? void 0 : "none",
      // hide the content if using the hide middleware and should be hidden
      opacity: (l = Q.hide) !== null && l !== void 0 && l.referenceHidden ? 0 : void 0
    }
  }))));
});
function Jut(t) {
  return t !== null;
}
const Kut = (t) => ({
  name: "transformOrigin",
  options: t,
  fn(e) {
    var n, r, i, o, a;
    const { placement: s, rects: u, middlewareData: l } = e, d = ((n = l.arrow) === null || n === void 0 ? void 0 : n.centerOffset) !== 0, f = d ? 0 : t.arrowWidth, h = d ? 0 : t.arrowHeight, [p, v] = hne(s), m = {
      start: "0%",
      center: "50%",
      end: "100%"
    }[v], b = ((r = (i = l.arrow) === null || i === void 0 ? void 0 : i.x) !== null && r !== void 0 ? r : 0) + f / 2, y = ((o = (a = l.arrow) === null || a === void 0 ? void 0 : a.y) !== null && o !== void 0 ? o : 0) + h / 2;
    let w = "", S = "";
    return p === "bottom" ? (w = d ? m : `${b}px`, S = `${-h}px`) : p === "top" ? (w = d ? m : `${b}px`, S = `${u.floating.height + h}px`) : p === "right" ? (w = `${-h}px`, S = d ? m : `${y}px`) : p === "left" && (w = `${u.floating.width + h}px`, S = d ? m : `${y}px`), {
      data: {
        x: w,
        y: S
      }
    };
  }
});
function hne(t) {
  const [e, n = "center"] = t.split("-");
  return [
    e,
    n
  ];
}
const qut = Gut, Qut = Xut, elt = Zut, tlt = /* @__PURE__ */ gt((t, e) => {
  var n;
  const { container: r = globalThis == null || (n = globalThis.document) === null || n === void 0 ? void 0 : n.body, ...i } = t;
  return r ? /* @__PURE__ */ ks.createPortal(/* @__PURE__ */ Pe(Sn.div, G({}, i, {
    ref: e
  })), r) : null;
});
function nlt(t) {
  const e = Ee({
    value: t,
    previous: t
  });
  return Rn(() => (e.current.value !== t && (e.current.previous = e.current.value, e.current.value = t), e.current.previous), [
    t
  ]);
}
const pne = /* @__PURE__ */ gt((t, e) => /* @__PURE__ */ Pe(Sn.span, G({}, t, {
  ref: e,
  style: {
    // See: https://github.com/twbs/bootstrap/blob/master/scss/mixins/_screen-reader.scss
    position: "absolute",
    border: 0,
    width: 1,
    height: 1,
    padding: 0,
    margin: -1,
    overflow: "hidden",
    clip: "rect(0, 0, 0, 0)",
    whiteSpace: "nowrap",
    wordWrap: "normal",
    ...t.style
  }
}))), rlt = pne, ilt = [
  " ",
  "Enter",
  "ArrowUp",
  "ArrowDown"
], olt = [
  " ",
  "Enter"
], Uw = "Select", [Xw, N8, alt] = Cee(Uw), [Xp, Tbt] = Vs(Uw, [
  alt,
  cne
]), k8 = cne(), [slt, pf] = Xp(Uw), [ult, llt] = Xp(Uw), clt = (t) => {
  const { __scopeSelect: e, children: n, open: r, defaultOpen: i, onOpenChange: o, value: a, defaultValue: s, onValueChange: u, dir: l, name: c, autoComplete: d, disabled: f, required: h } = t, p = k8(e), [v, m] = Le(null), [b, y] = Le(null), [w, S] = Le(!1), E = Ww(l), [I = !1, _] = sl({
    prop: r,
    defaultProp: i,
    onChange: o
  }), [A, P] = sl({
    prop: a,
    defaultProp: s,
    onChange: u
  }), N = Ee(null), k = v ? !!v.closest("form") : !0, [D, R] = Le(/* @__PURE__ */ new Set()), V = Array.from(D).map(
    ($) => $.props.value
  ).join(";");
  return /* @__PURE__ */ Pe(qut, p, /* @__PURE__ */ Pe(slt, {
    required: h,
    scope: e,
    trigger: v,
    onTriggerChange: m,
    valueNode: b,
    onValueNodeChange: y,
    valueNodeHasChildren: w,
    onValueNodeHasChildrenChange: S,
    contentId: oc(),
    value: A,
    onValueChange: P,
    open: I,
    onOpenChange: _,
    dir: E,
    triggerPointerDownPosRef: N,
    disabled: f
  }, /* @__PURE__ */ Pe(Xw.Provider, {
    scope: e
  }, /* @__PURE__ */ Pe(ult, {
    scope: t.__scopeSelect,
    onNativeOptionAdd: et(($) => {
      R(
        (F) => new Set(F).add($)
      );
    }, []),
    onNativeOptionRemove: et(($) => {
      R((F) => {
        const M = new Set(F);
        return M.delete($), M;
      });
    }, [])
  }, n)), k ? /* @__PURE__ */ Pe(vne, {
    key: V,
    "aria-hidden": !0,
    required: h,
    tabIndex: -1,
    name: c,
    autoComplete: d,
    value: A,
    onChange: ($) => P($.target.value),
    disabled: f
  }, A === void 0 ? /* @__PURE__ */ Pe("option", {
    value: ""
  }) : null, Array.from(D)) : null));
}, dlt = "SelectTrigger", flt = /* @__PURE__ */ gt((t, e) => {
  const { __scopeSelect: n, disabled: r = !1, ...i } = t, o = k8(n), a = pf(dlt, n), s = a.disabled || r, u = Kn(e, a.onTriggerChange), l = N8(n), [c, d, f] = bne((p) => {
    const v = l().filter(
      (y) => !y.disabled
    ), m = v.find(
      (y) => y.value === a.value
    ), b = yne(v, p, m);
    b !== void 0 && a.onValueChange(b.value);
  }), h = () => {
    s || (a.onOpenChange(!0), f());
  };
  return /* @__PURE__ */ Pe(Qut, G({
    asChild: !0
  }, o), /* @__PURE__ */ Pe(Sn.button, G({
    type: "button",
    role: "combobox",
    "aria-controls": a.contentId,
    "aria-expanded": a.open,
    "aria-required": a.required,
    "aria-autocomplete": "none",
    dir: a.dir,
    "data-state": a.open ? "open" : "closed",
    disabled: s,
    "data-disabled": s ? "" : void 0,
    "data-placeholder": mne(a.value) ? "" : void 0
  }, i, {
    ref: u,
    onClick: ln(i.onClick, (p) => {
      p.currentTarget.focus();
    }),
    onPointerDown: ln(i.onPointerDown, (p) => {
      const v = p.target;
      v.hasPointerCapture(p.pointerId) && v.releasePointerCapture(p.pointerId), p.button === 0 && p.ctrlKey === !1 && (h(), a.triggerPointerDownPosRef.current = {
        x: Math.round(p.pageX),
        y: Math.round(p.pageY)
      }, p.preventDefault());
    }),
    onKeyDown: ln(i.onKeyDown, (p) => {
      const v = c.current !== "";
      !(p.ctrlKey || p.altKey || p.metaKey) && p.key.length === 1 && d(p.key), !(v && p.key === " ") && ilt.includes(p.key) && (h(), p.preventDefault());
    })
  })));
}), hlt = "SelectValue", plt = /* @__PURE__ */ gt((t, e) => {
  const { __scopeSelect: n, className: r, style: i, children: o, placeholder: a = "", ...s } = t, u = pf(hlt, n), { onValueNodeHasChildrenChange: l } = u, c = o !== void 0, d = Kn(e, u.onValueNodeChange);
  return co(() => {
    l(c);
  }, [
    l,
    c
  ]), /* @__PURE__ */ Pe(Sn.span, G({}, s, {
    ref: d,
    style: {
      pointerEvents: "none"
    }
  }), mne(u.value) ? /* @__PURE__ */ Pe(ha, null, a) : o);
}), glt = /* @__PURE__ */ gt((t, e) => {
  const { __scopeSelect: n, children: r, ...i } = t;
  return /* @__PURE__ */ Pe(Sn.span, G({
    "aria-hidden": !0
  }, i, {
    ref: e
  }), r || "▼");
}), mlt = (t) => /* @__PURE__ */ Pe(tlt, G({
  asChild: !0
}, t)), mp = "SelectContent", vlt = /* @__PURE__ */ gt((t, e) => {
  const n = pf(mp, t.__scopeSelect), [r, i] = Le();
  if (co(() => {
    i(new DocumentFragment());
  }, []), !n.open) {
    const o = r;
    return o ? /* @__PURE__ */ km(/* @__PURE__ */ Pe(gne, {
      scope: t.__scopeSelect
    }, /* @__PURE__ */ Pe(Xw.Slot, {
      scope: t.__scopeSelect
    }, /* @__PURE__ */ Pe("div", null, t.children))), o) : null;
  }
  return /* @__PURE__ */ Pe(blt, G({}, t, {
    ref: e
  }));
}), zu = 10, [gne, Yw] = Xp(mp), blt = /* @__PURE__ */ gt((t, e) => {
  const {
    __scopeSelect: n,
    position: r = "item-aligned",
    onCloseAutoFocus: i,
    onEscapeKeyDown: o,
    onPointerDownOutside: a,
    side: s,
    sideOffset: u,
    align: l,
    alignOffset: c,
    arrowPadding: d,
    collisionBoundary: f,
    collisionPadding: h,
    sticky: p,
    hideWhenDetached: v,
    avoidCollisions: m,
    //
    ...b
  } = t, y = pf(mp, n), [w, S] = Le(null), [E, I] = Le(null), _ = Kn(
    e,
    (Z) => S(Z)
  ), [A, P] = Le(null), [N, k] = Le(null), D = N8(n), [R, V] = Le(!1), $ = Ee(!1);
  Re(() => {
    if (w)
      return KO(w);
  }, [
    w
  ]), $O();
  const F = et((Z) => {
    const [ee, ...ie] = D().map(
      (te) => te.ref.current
    ), [oe] = ie.slice(-1), se = document.activeElement;
    for (const te of Z)
      if (te === se || (te == null || te.scrollIntoView({
        block: "nearest"
      }), te === ee && E && (E.scrollTop = 0), te === oe && E && (E.scrollTop = E.scrollHeight), te == null || te.focus(), document.activeElement !== se))
        return;
  }, [
    D,
    E
  ]), M = et(
    () => F([
      A,
      w
    ]),
    [
      F,
      A,
      w
    ]
  );
  Re(() => {
    R && M();
  }, [
    R,
    M
  ]);
  const { onOpenChange: B, triggerPointerDownPosRef: X } = y;
  Re(() => {
    if (w) {
      let Z = {
        x: 0,
        y: 0
      };
      const ee = (oe) => {
        var se, te, ge, he;
        Z = {
          x: Math.abs(Math.round(oe.pageX) - ((se = (te = X.current) === null || te === void 0 ? void 0 : te.x) !== null && se !== void 0 ? se : 0)),
          y: Math.abs(Math.round(oe.pageY) - ((ge = (he = X.current) === null || he === void 0 ? void 0 : he.y) !== null && ge !== void 0 ? ge : 0))
        };
      }, ie = (oe) => {
        Z.x <= 10 && Z.y <= 10 ? oe.preventDefault() : w.contains(oe.target) || B(!1), document.removeEventListener("pointermove", ee), X.current = null;
      };
      return X.current !== null && (document.addEventListener("pointermove", ee), document.addEventListener("pointerup", ie, {
        capture: !0,
        once: !0
      })), () => {
        document.removeEventListener("pointermove", ee), document.removeEventListener("pointerup", ie, {
          capture: !0
        });
      };
    }
  }, [
    w,
    B,
    X
  ]), Re(() => {
    const Z = () => B(!1);
    return window.addEventListener("blur", Z), window.addEventListener("resize", Z), () => {
      window.removeEventListener("blur", Z), window.removeEventListener("resize", Z);
    };
  }, [
    B
  ]);
  const [L, j] = bne((Z) => {
    const ee = D().filter(
      (se) => !se.disabled
    ), ie = ee.find(
      (se) => se.ref.current === document.activeElement
    ), oe = yne(ee, Z, ie);
    oe && setTimeout(
      () => oe.ref.current.focus()
    );
  }), K = et((Z, ee, ie) => {
    const oe = !$.current && !ie;
    (y.value !== void 0 && y.value === ee || oe) && (P(Z), oe && ($.current = !0));
  }, [
    y.value
  ]), W = et(
    () => w == null ? void 0 : w.focus(),
    [
      w
    ]
  ), Y = et((Z, ee, ie) => {
    const oe = !$.current && !ie;
    (y.value !== void 0 && y.value === ee || oe) && k(Z);
  }, [
    y.value
  ]), U = r === "popper" ? HV : ylt, Q = U === HV ? {
    side: s,
    sideOffset: u,
    align: l,
    alignOffset: c,
    arrowPadding: d,
    collisionBoundary: f,
    collisionPadding: h,
    sticky: p,
    hideWhenDetached: v,
    avoidCollisions: m
  } : {};
  return /* @__PURE__ */ Pe(gne, {
    scope: n,
    content: w,
    viewport: E,
    onViewportChange: I,
    itemRefCallback: K,
    selectedItem: A,
    onItemLeave: W,
    itemTextRefCallback: Y,
    focusSelectedItem: M,
    selectedItemText: N,
    position: r,
    isPositioned: R,
    searchRef: L
  }, /* @__PURE__ */ Pe(qO, {
    as: Hd,
    allowPinchZoom: !0
  }, /* @__PURE__ */ Pe(Fut, {
    asChild: !0,
    trapped: y.open,
    onMountAutoFocus: (Z) => {
      Z.preventDefault();
    },
    onUnmountAutoFocus: ln(i, (Z) => {
      var ee;
      (ee = y.trigger) === null || ee === void 0 || ee.focus({
        preventScroll: !0
      }), Z.preventDefault();
    })
  }, /* @__PURE__ */ Pe($ut, {
    asChild: !0,
    disableOutsidePointerEvents: !0,
    onEscapeKeyDown: o,
    onPointerDownOutside: a,
    onFocusOutside: (Z) => Z.preventDefault(),
    onDismiss: () => y.onOpenChange(!1)
  }, /* @__PURE__ */ Pe(U, G({
    role: "listbox",
    id: y.contentId,
    "data-state": y.open ? "open" : "closed",
    dir: y.dir,
    onContextMenu: (Z) => Z.preventDefault()
  }, b, Q, {
    onPlaced: () => V(!0),
    ref: _,
    style: {
      // flex layout so we can place the scroll buttons properly
      display: "flex",
      flexDirection: "column",
      // reset the outline by default as the content MAY get focused
      outline: "none",
      ...b.style
    },
    onKeyDown: ln(b.onKeyDown, (Z) => {
      const ee = Z.ctrlKey || Z.altKey || Z.metaKey;
      if (Z.key === "Tab" && Z.preventDefault(), !ee && Z.key.length === 1 && j(Z.key), [
        "ArrowUp",
        "ArrowDown",
        "Home",
        "End"
      ].includes(Z.key)) {
        let oe = D().filter(
          (se) => !se.disabled
        ).map(
          (se) => se.ref.current
        );
        if ([
          "ArrowUp",
          "End"
        ].includes(Z.key) && (oe = oe.slice().reverse()), [
          "ArrowUp",
          "ArrowDown"
        ].includes(Z.key)) {
          const se = Z.target, te = oe.indexOf(se);
          oe = oe.slice(te + 1);
        }
        setTimeout(
          () => F(oe)
        ), Z.preventDefault();
      }
    })
  }))))));
}), ylt = /* @__PURE__ */ gt((t, e) => {
  const { __scopeSelect: n, onPlaced: r, ...i } = t, o = pf(mp, n), a = Yw(mp, n), [s, u] = Le(null), [l, c] = Le(null), d = Kn(
    e,
    (_) => c(_)
  ), f = N8(n), h = Ee(!1), p = Ee(!0), { viewport: v, selectedItem: m, selectedItemText: b, focusSelectedItem: y } = a, w = et(() => {
    if (o.trigger && o.valueNode && s && l && v && m && b) {
      const _ = o.trigger.getBoundingClientRect(), A = l.getBoundingClientRect(), P = o.valueNode.getBoundingClientRect(), N = b.getBoundingClientRect();
      if (o.dir !== "rtl") {
        const se = N.left - A.left, te = P.left - se, ge = _.left - te, he = _.width + ge, fe = Math.max(he, A.width), _e = window.innerWidth - zu, Ne = $V(te, [
          zu,
          _e - fe
        ]);
        s.style.minWidth = he + "px", s.style.left = Ne + "px";
      } else {
        const se = A.right - N.right, te = window.innerWidth - P.right - se, ge = window.innerWidth - _.right - te, he = _.width + ge, fe = Math.max(he, A.width), _e = window.innerWidth - zu, Ne = $V(te, [
          zu,
          _e - fe
        ]);
        s.style.minWidth = he + "px", s.style.right = Ne + "px";
      }
      const k = f(), D = window.innerHeight - zu * 2, R = v.scrollHeight, V = window.getComputedStyle(l), $ = parseInt(V.borderTopWidth, 10), F = parseInt(V.paddingTop, 10), M = parseInt(V.borderBottomWidth, 10), B = parseInt(V.paddingBottom, 10), X = $ + F + R + B + M, L = Math.min(m.offsetHeight * 5, X), j = window.getComputedStyle(v), K = parseInt(j.paddingTop, 10), W = parseInt(j.paddingBottom, 10), Y = _.top + _.height / 2 - zu, U = D - Y, Q = m.offsetHeight / 2, Z = m.offsetTop + Q, ee = $ + F + Z, ie = X - ee;
      if (ee <= Y) {
        const se = m === k[k.length - 1].ref.current;
        s.style.bottom = "0px";
        const te = l.clientHeight - v.offsetTop - v.offsetHeight, ge = Math.max(U, Q + (se ? W : 0) + te + M), he = ee + ge;
        s.style.height = he + "px";
      } else {
        const se = m === k[0].ref.current;
        s.style.top = "0px";
        const ge = Math.max(Y, $ + v.offsetTop + (se ? K : 0) + Q) + ie;
        s.style.height = ge + "px", v.scrollTop = ee - Y + v.offsetTop;
      }
      s.style.margin = `${zu}px 0`, s.style.minHeight = L + "px", s.style.maxHeight = D + "px", r == null || r(), requestAnimationFrame(
        () => h.current = !0
      );
    }
  }, [
    f,
    o.trigger,
    o.valueNode,
    s,
    l,
    v,
    m,
    b,
    o.dir,
    r
  ]);
  co(
    () => w(),
    [
      w
    ]
  );
  const [S, E] = Le();
  co(() => {
    l && E(window.getComputedStyle(l).zIndex);
  }, [
    l
  ]);
  const I = et((_) => {
    _ && p.current === !0 && (w(), y == null || y(), p.current = !1);
  }, [
    w,
    y
  ]);
  return /* @__PURE__ */ Pe(xlt, {
    scope: n,
    contentWrapper: s,
    shouldExpandOnScrollRef: h,
    onScrollButtonChange: I
  }, /* @__PURE__ */ Pe("div", {
    ref: u,
    style: {
      display: "flex",
      flexDirection: "column",
      position: "fixed",
      zIndex: S
    }
  }, /* @__PURE__ */ Pe(Sn.div, G({}, i, {
    ref: d,
    style: {
      // When we get the height of the content, it includes borders. If we were to set
      // the height without having `boxSizing: 'border-box'` it would be too big.
      boxSizing: "border-box",
      // We need to ensure the content doesn't get taller than the wrapper
      maxHeight: "100%",
      ...i.style
    }
  }))));
}), HV = /* @__PURE__ */ gt((t, e) => {
  const { __scopeSelect: n, align: r = "start", collisionPadding: i = zu, ...o } = t, a = k8(n);
  return /* @__PURE__ */ Pe(elt, G({}, a, o, {
    ref: e,
    align: r,
    collisionPadding: i,
    style: {
      // Ensure border-box for floating-ui calculations
      boxSizing: "border-box",
      ...o.style,
      "--radix-select-content-transform-origin": "var(--radix-popper-transform-origin)",
      "--radix-select-content-available-width": "var(--radix-popper-available-width)",
      "--radix-select-content-available-height": "var(--radix-popper-available-height)",
      "--radix-select-trigger-width": "var(--radix-popper-anchor-width)",
      "--radix-select-trigger-height": "var(--radix-popper-anchor-height)"
    }
  }));
}), [xlt, Clt] = Xp(mp, {}), WV = "SelectViewport", wlt = /* @__PURE__ */ gt((t, e) => {
  const { __scopeSelect: n, ...r } = t, i = Yw(WV, n), o = Clt(WV, n), a = Kn(e, i.onViewportChange), s = Ee(0);
  return /* @__PURE__ */ Pe(ha, null, /* @__PURE__ */ Pe("style", {
    dangerouslySetInnerHTML: {
      __html: "[data-radix-select-viewport]{scrollbar-width:none;-ms-overflow-style:none;-webkit-overflow-scrolling:touch;}[data-radix-select-viewport]::-webkit-scrollbar{display:none}"
    }
  }), /* @__PURE__ */ Pe(Xw.Slot, {
    scope: n
  }, /* @__PURE__ */ Pe(Sn.div, G({
    "data-radix-select-viewport": "",
    role: "presentation"
  }, r, {
    ref: a,
    style: {
      // we use position: 'relative' here on the `viewport` so that when we call
      // `selectedItem.offsetTop` in calculations, the offset is relative to the viewport
      // (independent of the scrollUpButton).
      position: "relative",
      flex: 1,
      overflow: "auto",
      ...r.style
    },
    onScroll: ln(r.onScroll, (u) => {
      const l = u.currentTarget, { contentWrapper: c, shouldExpandOnScrollRef: d } = o;
      if (d != null && d.current && c) {
        const f = Math.abs(s.current - l.scrollTop);
        if (f > 0) {
          const h = window.innerHeight - zu * 2, p = parseFloat(c.style.minHeight), v = parseFloat(c.style.height), m = Math.max(p, v);
          if (m < h) {
            const b = m + f, y = Math.min(h, b), w = b - y;
            c.style.height = y + "px", c.style.bottom === "0px" && (l.scrollTop = w > 0 ? w : 0, c.style.justifyContent = "flex-end");
          }
        }
      }
      s.current = l.scrollTop;
    })
  }))));
}), Elt = "SelectGroup";
Xp(Elt);
const b6 = "SelectItem", [Slt, Ilt] = Xp(b6), _lt = /* @__PURE__ */ gt((t, e) => {
  const { __scopeSelect: n, value: r, disabled: i = !1, textValue: o, ...a } = t, s = pf(b6, n), u = Yw(b6, n), l = s.value === r, [c, d] = Le(o ?? ""), [f, h] = Le(!1), p = Kn(e, (b) => {
    var y;
    return (y = u.itemRefCallback) === null || y === void 0 ? void 0 : y.call(u, b, r, i);
  }), v = oc(), m = () => {
    i || (s.onValueChange(r), s.onOpenChange(!1));
  };
  if (r === "")
    throw new Error("A <Select.Item /> must have a value prop that is not an empty string. This is because the Select value can be set to an empty string to clear the selection and show the placeholder.");
  return /* @__PURE__ */ Pe(Slt, {
    scope: n,
    value: r,
    disabled: i,
    textId: v,
    isSelected: l,
    onItemTextChange: et((b) => {
      d((y) => {
        var w;
        return y || ((w = b == null ? void 0 : b.textContent) !== null && w !== void 0 ? w : "").trim();
      });
    }, [])
  }, /* @__PURE__ */ Pe(Xw.ItemSlot, {
    scope: n,
    value: r,
    disabled: i,
    textValue: c
  }, /* @__PURE__ */ Pe(Sn.div, G({
    role: "option",
    "aria-labelledby": v,
    "data-highlighted": f ? "" : void 0,
    "aria-selected": l && f,
    "data-state": l ? "checked" : "unchecked",
    "aria-disabled": i || void 0,
    "data-disabled": i ? "" : void 0,
    tabIndex: i ? void 0 : -1
  }, a, {
    ref: p,
    onFocus: ln(
      a.onFocus,
      () => h(!0)
    ),
    onBlur: ln(
      a.onBlur,
      () => h(!1)
    ),
    onPointerUp: ln(a.onPointerUp, m),
    onPointerMove: ln(a.onPointerMove, (b) => {
      if (i) {
        var y;
        (y = u.onItemLeave) === null || y === void 0 || y.call(u);
      } else
        b.currentTarget.focus({
          preventScroll: !0
        });
    }),
    onPointerLeave: ln(a.onPointerLeave, (b) => {
      if (b.currentTarget === document.activeElement) {
        var y;
        (y = u.onItemLeave) === null || y === void 0 || y.call(u);
      }
    }),
    onKeyDown: ln(a.onKeyDown, (b) => {
      var y;
      ((y = u.searchRef) === null || y === void 0 ? void 0 : y.current) !== "" && b.key === " " || (olt.includes(b.key) && m(), b.key === " " && b.preventDefault());
    })
  }))));
}), Ub = "SelectItemText", Alt = /* @__PURE__ */ gt((t, e) => {
  const { __scopeSelect: n, className: r, style: i, ...o } = t, a = pf(Ub, n), s = Yw(Ub, n), u = Ilt(Ub, n), l = llt(Ub, n), [c, d] = Le(null), f = Kn(
    e,
    (b) => d(b),
    u.onItemTextChange,
    (b) => {
      var y;
      return (y = s.itemTextRefCallback) === null || y === void 0 ? void 0 : y.call(s, b, u.value, u.disabled);
    }
  ), h = c == null ? void 0 : c.textContent, p = Rn(
    () => /* @__PURE__ */ Pe("option", {
      key: u.value,
      value: u.value,
      disabled: u.disabled
    }, h),
    [
      u.disabled,
      u.value,
      h
    ]
  ), { onNativeOptionAdd: v, onNativeOptionRemove: m } = l;
  return co(() => (v(p), () => m(p)), [
    v,
    m,
    p
  ]), /* @__PURE__ */ Pe(ha, null, /* @__PURE__ */ Pe(Sn.span, G({
    id: u.textId
  }, o, {
    ref: f
  })), u.isSelected && a.valueNode && !a.valueNodeHasChildren ? /* @__PURE__ */ km(o.children, a.valueNode) : null);
}), Tlt = /* @__PURE__ */ gt((t, e) => {
  const { __scopeSelect: n, ...r } = t;
  return /* @__PURE__ */ Pe(Sn.div, G({
    "aria-hidden": !0
  }, r, {
    ref: e
  }));
});
function mne(t) {
  return t === "" || t === void 0;
}
const vne = /* @__PURE__ */ gt((t, e) => {
  const { value: n, ...r } = t, i = Ee(null), o = Kn(e, i), a = nlt(n);
  return Re(() => {
    const s = i.current, u = window.HTMLSelectElement.prototype, c = Object.getOwnPropertyDescriptor(u, "value").set;
    if (a !== n && c) {
      const d = new Event("change", {
        bubbles: !0
      });
      c.call(s, n), s.dispatchEvent(d);
    }
  }, [
    a,
    n
  ]), /* @__PURE__ */ Pe(pne, {
    asChild: !0
  }, /* @__PURE__ */ Pe("select", G({}, r, {
    ref: o,
    defaultValue: n
  })));
});
vne.displayName = "BubbleSelect";
function bne(t) {
  const e = Kr(t), n = Ee(""), r = Ee(0), i = et((a) => {
    const s = n.current + a;
    e(s), function u(l) {
      n.current = l, window.clearTimeout(r.current), l !== "" && (r.current = window.setTimeout(
        () => u(""),
        1e3
      ));
    }(s);
  }, [
    e
  ]), o = et(() => {
    n.current = "", window.clearTimeout(r.current);
  }, []);
  return Re(() => () => window.clearTimeout(r.current), []), [
    n,
    i,
    o
  ];
}
function yne(t, e, n) {
  const i = e.length > 1 && Array.from(e).every(
    (l) => l === e[0]
  ) ? e[0] : e, o = n ? t.indexOf(n) : -1;
  let a = Olt(t, Math.max(o, 0));
  i.length === 1 && (a = a.filter(
    (l) => l !== n
  ));
  const u = a.find(
    (l) => l.textValue.toLowerCase().startsWith(i.toLowerCase())
  );
  return u !== n ? u : void 0;
}
function Olt(t, e) {
  return t.map(
    (n, r) => t[(e + r) % t.length]
  );
}
const Plt = clt, Nlt = flt, klt = plt, Rlt = glt, $lt = mlt, Dlt = vlt, Mlt = wlt, Flt = _lt, Llt = Alt, Vlt = Tlt, y6 = "dismissableLayer.update", Blt = "dismissableLayer.pointerDownOutside", Hlt = "dismissableLayer.focusOutside";
let jV;
const Wlt = /* @__PURE__ */ oi({
  layers: /* @__PURE__ */ new Set(),
  layersWithOutsidePointerEventsDisabled: /* @__PURE__ */ new Set(),
  branches: /* @__PURE__ */ new Set()
}), jlt = /* @__PURE__ */ gt((t, e) => {
  var n;
  const { disableOutsidePointerEvents: r = !1, onEscapeKeyDown: i, onPointerDownOutside: o, onFocusOutside: a, onInteractOutside: s, onDismiss: u, ...l } = t, c = fn(Wlt), [d, f] = Le(null), h = (n = d == null ? void 0 : d.ownerDocument) !== null && n !== void 0 ? n : globalThis == null ? void 0 : globalThis.document, [, p] = Le({}), v = Kn(
    e,
    (A) => f(A)
  ), m = Array.from(c.layers), [b] = [
    ...c.layersWithOutsidePointerEventsDisabled
  ].slice(-1), y = m.indexOf(b), w = d ? m.indexOf(d) : -1, S = c.layersWithOutsidePointerEventsDisabled.size > 0, E = w >= y, I = zlt((A) => {
    const P = A.target, N = [
      ...c.branches
    ].some(
      (k) => k.contains(P)
    );
    !E || N || (o == null || o(A), s == null || s(A), A.defaultPrevented || u == null || u());
  }, h), _ = Glt((A) => {
    const P = A.target;
    [
      ...c.branches
    ].some(
      (k) => k.contains(P)
    ) || (a == null || a(A), s == null || s(A), A.defaultPrevented || u == null || u());
  }, h);
  return Lw((A) => {
    w === c.layers.size - 1 && (i == null || i(A), !A.defaultPrevented && u && (A.preventDefault(), u()));
  }, h), Re(() => {
    if (d)
      return r && (c.layersWithOutsidePointerEventsDisabled.size === 0 && (jV = h.body.style.pointerEvents, h.body.style.pointerEvents = "none"), c.layersWithOutsidePointerEventsDisabled.add(d)), c.layers.add(d), zV(), () => {
        r && c.layersWithOutsidePointerEventsDisabled.size === 1 && (h.body.style.pointerEvents = jV);
      };
  }, [
    d,
    h,
    r,
    c
  ]), Re(() => () => {
    d && (c.layers.delete(d), c.layersWithOutsidePointerEventsDisabled.delete(d), zV());
  }, [
    d,
    c
  ]), Re(() => {
    const A = () => p({});
    return document.addEventListener(y6, A), () => document.removeEventListener(y6, A);
  }, []), /* @__PURE__ */ Pe(Sn.div, G({}, l, {
    ref: v,
    style: {
      pointerEvents: S ? E ? "auto" : "none" : void 0,
      ...t.style
    },
    onFocusCapture: ln(t.onFocusCapture, _.onFocusCapture),
    onBlurCapture: ln(t.onBlurCapture, _.onBlurCapture),
    onPointerDownCapture: ln(t.onPointerDownCapture, I.onPointerDownCapture)
  }));
});
function zlt(t, e = globalThis == null ? void 0 : globalThis.document) {
  const n = Kr(t), r = Ee(!1), i = Ee(() => {
  });
  return Re(() => {
    const o = (s) => {
      if (s.target && !r.current) {
        let l = function() {
          xne(Blt, n, u, {
            discrete: !0
          });
        };
        const u = {
          originalEvent: s
        };
        s.pointerType === "touch" ? (e.removeEventListener("click", i.current), i.current = l, e.addEventListener("click", i.current, {
          once: !0
        })) : l();
      } else
        e.removeEventListener("click", i.current);
      r.current = !1;
    }, a = window.setTimeout(() => {
      e.addEventListener("pointerdown", o);
    }, 0);
    return () => {
      window.clearTimeout(a), e.removeEventListener("pointerdown", o), e.removeEventListener("click", i.current);
    };
  }, [
    e,
    n
  ]), {
    // ensures we check React component tree (not just DOM tree)
    onPointerDownCapture: () => r.current = !0
  };
}
function Glt(t, e = globalThis == null ? void 0 : globalThis.document) {
  const n = Kr(t), r = Ee(!1);
  return Re(() => {
    const i = (o) => {
      o.target && !r.current && xne(Hlt, n, {
        originalEvent: o
      }, {
        discrete: !1
      });
    };
    return e.addEventListener("focusin", i), () => e.removeEventListener("focusin", i);
  }, [
    e,
    n
  ]), {
    onFocusCapture: () => r.current = !0,
    onBlurCapture: () => r.current = !1
  };
}
function zV() {
  const t = new CustomEvent(y6);
  document.dispatchEvent(t);
}
function xne(t, e, n, { discrete: r }) {
  const i = n.originalEvent.target, o = new CustomEvent(t, {
    bubbles: !1,
    cancelable: !0,
    detail: n
  });
  e && i.addEventListener(t, e, {
    once: !0
  }), r ? Fw(i, o) : i.dispatchEvent(o);
}
const Cne = "Popper", [wne, Ene] = Vs(Cne), [Ult, Sne] = wne(Cne), Xlt = (t) => {
  const { __scopePopper: e, children: n } = t, [r, i] = Le(null);
  return /* @__PURE__ */ Pe(Ult, {
    scope: e,
    anchor: r,
    onAnchorChange: i
  }, n);
}, Ylt = "PopperAnchor", Zlt = /* @__PURE__ */ gt((t, e) => {
  const { __scopePopper: n, virtualRef: r, ...i } = t, o = Sne(Ylt, n), a = Ee(null), s = Kn(e, a);
  return Re(() => {
    o.onAnchorChange((r == null ? void 0 : r.current) || a.current);
  }), r ? null : /* @__PURE__ */ Pe(Sn.div, G({}, i, {
    ref: s
  }));
}), Ine = "PopperContent", [Jlt, Klt] = wne(Ine), qlt = /* @__PURE__ */ gt((t, e) => {
  var n, r, i, o, a, s, u, l;
  const { __scopePopper: c, side: d = "bottom", sideOffset: f = 0, align: h = "center", alignOffset: p = 0, arrowPadding: v = 0, avoidCollisions: m = !0, collisionBoundary: b = [], collisionPadding: y = 0, sticky: w = "partial", hideWhenDetached: S = !1, updatePositionStrategy: E = "optimized", onPlaced: I, ..._ } = t, A = Sne(Ine, c), [P, N] = Le(null), k = Kn(
    e,
    (fe) => N(fe)
  ), [D, R] = Le(null), V = JO(D), $ = (n = V == null ? void 0 : V.width) !== null && n !== void 0 ? n : 0, F = (r = V == null ? void 0 : V.height) !== null && r !== void 0 ? r : 0, M = d + (h !== "center" ? "-" + h : ""), B = typeof y == "number" ? y : {
    top: 0,
    right: 0,
    bottom: 0,
    left: 0,
    ...y
  }, X = Array.isArray(b) ? b : [
    b
  ], L = X.length > 0, j = {
    padding: B,
    boundary: X.filter(nct),
    // with `strategy: 'fixed'`, this is the only way to get it to respect boundaries
    altBoundary: L
  }, { refs: K, floatingStyles: W, placement: Y, isPositioned: U, middlewareData: Q } = ZO({
    // default to `fixed` strategy so users don't have to pick and we also avoid focus scroll issues
    strategy: "fixed",
    placement: M,
    whileElementsMounted: (...fe) => XO(...fe, {
      animationFrame: E === "always"
    }),
    elements: {
      reference: A.anchor
    },
    middleware: [
      BO({
        mainAxis: f + F,
        alignmentAxis: p
      }),
      m && HO({
        mainAxis: !0,
        crossAxis: !1,
        limiter: w === "partial" ? WO() : void 0,
        ...j
      }),
      m && LO({
        ...j
      }),
      jO({
        ...j,
        apply: ({ elements: fe, rects: _e, availableWidth: Ne, availableHeight: ze }) => {
          const { width: Ve, height: ne } = _e.reference, pe = fe.floating.style;
          pe.setProperty("--radix-popper-available-width", `${Ne}px`), pe.setProperty("--radix-popper-available-height", `${ze}px`), pe.setProperty("--radix-popper-anchor-width", `${Ve}px`), pe.setProperty("--radix-popper-anchor-height", `${ne}px`);
        }
      }),
      D && YO({
        element: D,
        padding: v
      }),
      rct({
        arrowWidth: $,
        arrowHeight: F
      }),
      S && VO({
        strategy: "referenceHidden",
        ...j
      })
    ]
  }), [Z, ee] = _ne(Y), ie = Kr(I);
  co(() => {
    U && (ie == null || ie());
  }, [
    U,
    ie
  ]);
  const oe = (i = Q.arrow) === null || i === void 0 ? void 0 : i.x, se = (o = Q.arrow) === null || o === void 0 ? void 0 : o.y, te = ((a = Q.arrow) === null || a === void 0 ? void 0 : a.centerOffset) !== 0, [ge, he] = Le();
  return co(() => {
    P && he(window.getComputedStyle(P).zIndex);
  }, [
    P
  ]), /* @__PURE__ */ Pe("div", {
    ref: K.setFloating,
    "data-radix-popper-content-wrapper": "",
    style: {
      ...W,
      transform: U ? W.transform : "translate(0, -200%)",
      // keep off the page when measuring
      minWidth: "max-content",
      zIndex: ge,
      "--radix-popper-transform-origin": [
        (s = Q.transformOrigin) === null || s === void 0 ? void 0 : s.x,
        (u = Q.transformOrigin) === null || u === void 0 ? void 0 : u.y
      ].join(" ")
    },
    dir: t.dir
  }, /* @__PURE__ */ Pe(Jlt, {
    scope: c,
    placedSide: Z,
    onArrowChange: R,
    arrowX: oe,
    arrowY: se,
    shouldHideArrow: te
  }, /* @__PURE__ */ Pe(Sn.div, G({
    "data-side": Z,
    "data-align": ee
  }, _, {
    ref: k,
    style: {
      ..._.style,
      // if the PopperContent hasn't been placed yet (not all measurements done)
      // we prevent animations so that users's animation don't kick in too early referring wrong sides
      animation: U ? void 0 : "none",
      // hide the content if using the hide middleware and should be hidden
      opacity: (l = Q.hide) !== null && l !== void 0 && l.referenceHidden ? 0 : void 0
    }
  }))));
}), Qlt = "PopperArrow", ect = {
  top: "bottom",
  right: "left",
  bottom: "top",
  left: "right"
}, tct = /* @__PURE__ */ gt(function(e, n) {
  const { __scopePopper: r, ...i } = e, o = Klt(Qlt, r), a = ect[o.placedSide];
  return (
    // we have to use an extra wrapper because `ResizeObserver` (used by `useSize`)
    // doesn't report size as we'd expect on SVG elements.
    // it reports their bounding box which is effectively the largest path inside the SVG.
    /* @__PURE__ */ Pe("span", {
      ref: o.onArrowChange,
      style: {
        position: "absolute",
        left: o.arrowX,
        top: o.arrowY,
        [a]: 0,
        transformOrigin: {
          top: "",
          right: "0 0",
          bottom: "center 0",
          left: "100% 0"
        }[o.placedSide],
        transform: {
          top: "translateY(100%)",
          right: "translateY(50%) rotate(90deg) translateX(-50%)",
          bottom: "rotate(180deg)",
          left: "translateY(50%) rotate(-90deg) translateX(50%)"
        }[o.placedSide],
        visibility: o.shouldHideArrow ? "hidden" : void 0
      }
    }, /* @__PURE__ */ Pe(KQ, G({}, i, {
      ref: n,
      style: {
        ...i.style,
        // ensures the element can be measured correctly (mostly for if SVG)
        display: "block"
      }
    })))
  );
});
function nct(t) {
  return t !== null;
}
const rct = (t) => ({
  name: "transformOrigin",
  options: t,
  fn(e) {
    var n, r, i, o, a;
    const { placement: s, rects: u, middlewareData: l } = e, d = ((n = l.arrow) === null || n === void 0 ? void 0 : n.centerOffset) !== 0, f = d ? 0 : t.arrowWidth, h = d ? 0 : t.arrowHeight, [p, v] = _ne(s), m = {
      start: "0%",
      center: "50%",
      end: "100%"
    }[v], b = ((r = (i = l.arrow) === null || i === void 0 ? void 0 : i.x) !== null && r !== void 0 ? r : 0) + f / 2, y = ((o = (a = l.arrow) === null || a === void 0 ? void 0 : a.y) !== null && o !== void 0 ? o : 0) + h / 2;
    let w = "", S = "";
    return p === "bottom" ? (w = d ? m : `${b}px`, S = `${-h}px`) : p === "top" ? (w = d ? m : `${b}px`, S = `${u.floating.height + h}px`) : p === "right" ? (w = `${-h}px`, S = d ? m : `${y}px`) : p === "left" && (w = `${u.floating.width + h}px`, S = d ? m : `${y}px`), {
      data: {
        x: w,
        y: S
      }
    };
  }
});
function _ne(t) {
  const [e, n = "center"] = t.split("-");
  return [
    e,
    n
  ];
}
const ict = Xlt, oct = Zlt, act = qlt, sct = tct, uct = /* @__PURE__ */ gt((t, e) => {
  var n;
  const { container: r = globalThis == null || (n = globalThis.document) === null || n === void 0 ? void 0 : n.body, ...i } = t;
  return r ? /* @__PURE__ */ ks.createPortal(/* @__PURE__ */ Pe(Sn.div, G({}, i, {
    ref: e
  })), r) : null;
}), [Zw, Obt] = Vs("Tooltip", [
  Ene
]), Jw = Ene(), lct = "TooltipProvider", cct = 700, x6 = "tooltip.open", [dct, R8] = Zw(lct), fct = (t) => {
  const { __scopeTooltip: e, delayDuration: n = cct, skipDelayDuration: r = 300, disableHoverableContent: i = !1, children: o } = t, [a, s] = Le(!0), u = Ee(!1), l = Ee(0);
  return Re(() => {
    const c = l.current;
    return () => window.clearTimeout(c);
  }, []), /* @__PURE__ */ Pe(dct, {
    scope: e,
    isOpenDelayed: a,
    delayDuration: n,
    onOpen: et(() => {
      window.clearTimeout(l.current), s(!1);
    }, []),
    onClose: et(() => {
      window.clearTimeout(l.current), l.current = window.setTimeout(
        () => s(!0),
        r
      );
    }, [
      r
    ]),
    isPointerInTransitRef: u,
    onPointerInTransitChange: et((c) => {
      u.current = c;
    }, []),
    disableHoverableContent: i
  }, o);
}, $8 = "Tooltip", [hct, Nv] = Zw($8), pct = (t) => {
  const { __scopeTooltip: e, children: n, open: r, defaultOpen: i = !1, onOpenChange: o, disableHoverableContent: a, delayDuration: s } = t, u = R8($8, t.__scopeTooltip), l = Jw(e), [c, d] = Le(null), f = oc(), h = Ee(0), p = a ?? u.disableHoverableContent, v = s ?? u.delayDuration, m = Ee(!1), [b = !1, y] = sl({
    prop: r,
    defaultProp: i,
    onChange: (_) => {
      _ ? (u.onOpen(), document.dispatchEvent(new CustomEvent(x6))) : u.onClose(), o == null || o(_);
    }
  }), w = Rn(() => b ? m.current ? "delayed-open" : "instant-open" : "closed", [
    b
  ]), S = et(() => {
    window.clearTimeout(h.current), m.current = !1, y(!0);
  }, [
    y
  ]), E = et(() => {
    window.clearTimeout(h.current), y(!1);
  }, [
    y
  ]), I = et(() => {
    window.clearTimeout(h.current), h.current = window.setTimeout(() => {
      m.current = !0, y(!0);
    }, v);
  }, [
    v,
    y
  ]);
  return Re(() => () => window.clearTimeout(h.current), []), /* @__PURE__ */ Pe(ict, l, /* @__PURE__ */ Pe(hct, {
    scope: e,
    contentId: f,
    open: b,
    stateAttribute: w,
    trigger: c,
    onTriggerChange: d,
    onTriggerEnter: et(() => {
      u.isOpenDelayed ? I() : S();
    }, [
      u.isOpenDelayed,
      I,
      S
    ]),
    onTriggerLeave: et(() => {
      p ? E() : window.clearTimeout(h.current);
    }, [
      E,
      p
    ]),
    onOpen: S,
    onClose: E,
    disableHoverableContent: p
  }, n));
}, GV = "TooltipTrigger", gct = /* @__PURE__ */ gt((t, e) => {
  const { __scopeTooltip: n, ...r } = t, i = Nv(GV, n), o = R8(GV, n), a = Jw(n), s = Ee(null), u = Kn(e, s, i.onTriggerChange), l = Ee(!1), c = Ee(!1), d = et(
    () => l.current = !1,
    []
  );
  return Re(() => () => document.removeEventListener("pointerup", d), [
    d
  ]), /* @__PURE__ */ Pe(oct, G({
    asChild: !0
  }, a), /* @__PURE__ */ Pe(Sn.button, G({
    // We purposefully avoid adding `type=button` here because tooltip triggers are also
    // commonly anchors and the anchor `type` attribute signifies MIME type.
    "aria-describedby": i.open ? i.contentId : void 0,
    "data-state": i.stateAttribute
  }, r, {
    ref: u,
    onPointerMove: ln(t.onPointerMove, (f) => {
      f.pointerType !== "touch" && !c.current && !o.isPointerInTransitRef.current && (i.onTriggerEnter(), c.current = !0);
    }),
    onPointerLeave: ln(t.onPointerLeave, () => {
      i.onTriggerLeave(), c.current = !1;
    }),
    onPointerDown: ln(t.onPointerDown, () => {
      l.current = !0, document.addEventListener("pointerup", d, {
        once: !0
      });
    }),
    onFocus: ln(t.onFocus, () => {
      l.current || i.onOpen();
    }),
    onBlur: ln(t.onBlur, i.onClose),
    onClick: ln(t.onClick, i.onClose)
  })));
}), Ane = "TooltipPortal", [mct, vct] = Zw(Ane, {
  forceMount: void 0
}), bct = (t) => {
  const { __scopeTooltip: e, forceMount: n, children: r, container: i } = t, o = Nv(Ane, e);
  return /* @__PURE__ */ Pe(mct, {
    scope: e,
    forceMount: n
  }, /* @__PURE__ */ Pe(Dc, {
    present: n || o.open
  }, /* @__PURE__ */ Pe(uct, {
    asChild: !0,
    container: i
  }, r)));
}, Cm = "TooltipContent", yct = /* @__PURE__ */ gt((t, e) => {
  const n = vct(Cm, t.__scopeTooltip), { forceMount: r = n.forceMount, side: i = "top", ...o } = t, a = Nv(Cm, t.__scopeTooltip);
  return /* @__PURE__ */ Pe(Dc, {
    present: r || a.open
  }, a.disableHoverableContent ? /* @__PURE__ */ Pe(Tne, G({
    side: i
  }, o, {
    ref: e
  })) : /* @__PURE__ */ Pe(xct, G({
    side: i
  }, o, {
    ref: e
  })));
}), xct = /* @__PURE__ */ gt((t, e) => {
  const n = Nv(Cm, t.__scopeTooltip), r = R8(Cm, t.__scopeTooltip), i = Ee(null), o = Kn(e, i), [a, s] = Le(null), { trigger: u, onClose: l } = n, c = i.current, { onPointerInTransitChange: d } = r, f = et(() => {
    s(null), d(!1);
  }, [
    d
  ]), h = et((p, v) => {
    const m = p.currentTarget, b = {
      x: p.clientX,
      y: p.clientY
    }, y = Ict(b, m.getBoundingClientRect()), w = _ct(b, y), S = Act(v.getBoundingClientRect()), E = Oct([
      ...w,
      ...S
    ]);
    s(E), d(!0);
  }, [
    d
  ]);
  return Re(() => () => f(), [
    f
  ]), Re(() => {
    if (u && c) {
      const p = (m) => h(m, c), v = (m) => h(m, u);
      return u.addEventListener("pointerleave", p), c.addEventListener("pointerleave", v), () => {
        u.removeEventListener("pointerleave", p), c.removeEventListener("pointerleave", v);
      };
    }
  }, [
    u,
    c,
    h,
    f
  ]), Re(() => {
    if (a) {
      const p = (v) => {
        const m = v.target, b = {
          x: v.clientX,
          y: v.clientY
        }, y = (u == null ? void 0 : u.contains(m)) || (c == null ? void 0 : c.contains(m)), w = !Tct(b, a);
        y ? f() : w && (f(), l());
      };
      return document.addEventListener("pointermove", p), () => document.removeEventListener("pointermove", p);
    }
  }, [
    u,
    c,
    a,
    l,
    f
  ]), /* @__PURE__ */ Pe(Tne, G({}, t, {
    ref: o
  }));
}), [Cct, wct] = Zw($8, {
  isInside: !1
}), Tne = /* @__PURE__ */ gt((t, e) => {
  const { __scopeTooltip: n, children: r, "aria-label": i, onEscapeKeyDown: o, onPointerDownOutside: a, ...s } = t, u = Nv(Cm, n), l = Jw(n), { onClose: c } = u;
  return Re(() => (document.addEventListener(x6, c), () => document.removeEventListener(x6, c)), [
    c
  ]), Re(() => {
    if (u.trigger) {
      const d = (f) => {
        const h = f.target;
        h != null && h.contains(u.trigger) && c();
      };
      return window.addEventListener("scroll", d, {
        capture: !0
      }), () => window.removeEventListener("scroll", d, {
        capture: !0
      });
    }
  }, [
    u.trigger,
    c
  ]), /* @__PURE__ */ Pe(jlt, {
    asChild: !0,
    disableOutsidePointerEvents: !1,
    onEscapeKeyDown: o,
    onPointerDownOutside: a,
    onFocusOutside: (d) => d.preventDefault(),
    onDismiss: c
  }, /* @__PURE__ */ Pe(act, G({
    "data-state": u.stateAttribute
  }, l, s, {
    ref: e,
    style: {
      ...s.style,
      "--radix-tooltip-content-transform-origin": "var(--radix-popper-transform-origin)",
      "--radix-tooltip-content-available-width": "var(--radix-popper-available-width)",
      "--radix-tooltip-content-available-height": "var(--radix-popper-available-height)",
      "--radix-tooltip-trigger-width": "var(--radix-popper-anchor-width)",
      "--radix-tooltip-trigger-height": "var(--radix-popper-anchor-height)"
    }
  }), /* @__PURE__ */ Pe(VQ, null, r), /* @__PURE__ */ Pe(Cct, {
    scope: n,
    isInside: !0
  }, /* @__PURE__ */ Pe(rlt, {
    id: u.contentId,
    role: "tooltip"
  }, i || r))));
}), Ect = "TooltipArrow", Sct = /* @__PURE__ */ gt((t, e) => {
  const { __scopeTooltip: n, ...r } = t, i = Jw(n);
  return wct(Ect, n).isInside ? null : /* @__PURE__ */ Pe(sct, G({}, i, r, {
    ref: e
  }));
});
function Ict(t, e) {
  const n = Math.abs(e.top - t.y), r = Math.abs(e.bottom - t.y), i = Math.abs(e.right - t.x), o = Math.abs(e.left - t.x);
  switch (Math.min(n, r, i, o)) {
    case o:
      return "left";
    case i:
      return "right";
    case n:
      return "top";
    case r:
      return "bottom";
    default:
      throw new Error("unreachable");
  }
}
function _ct(t, e, n = 5) {
  const r = [];
  switch (e) {
    case "top":
      r.push({
        x: t.x - n,
        y: t.y + n
      }, {
        x: t.x + n,
        y: t.y + n
      });
      break;
    case "bottom":
      r.push({
        x: t.x - n,
        y: t.y - n
      }, {
        x: t.x + n,
        y: t.y - n
      });
      break;
    case "left":
      r.push({
        x: t.x + n,
        y: t.y - n
      }, {
        x: t.x + n,
        y: t.y + n
      });
      break;
    case "right":
      r.push({
        x: t.x - n,
        y: t.y - n
      }, {
        x: t.x - n,
        y: t.y + n
      });
      break;
  }
  return r;
}
function Act(t) {
  const { top: e, right: n, bottom: r, left: i } = t;
  return [
    {
      x: i,
      y: e
    },
    {
      x: n,
      y: e
    },
    {
      x: n,
      y: r
    },
    {
      x: i,
      y: r
    }
  ];
}
function Tct(t, e) {
  const { x: n, y: r } = t;
  let i = !1;
  for (let o = 0, a = e.length - 1; o < e.length; a = o++) {
    const s = e[o].x, u = e[o].y, l = e[a].x, c = e[a].y;
    u > r != c > r && n < (l - s) * (r - u) / (c - u) + s && (i = !i);
  }
  return i;
}
function Oct(t) {
  const e = t.slice();
  return e.sort((n, r) => n.x < r.x ? -1 : n.x > r.x ? 1 : n.y < r.y ? -1 : n.y > r.y ? 1 : 0), Pct(e);
}
function Pct(t) {
  if (t.length <= 1)
    return t.slice();
  const e = [];
  for (let r = 0; r < t.length; r++) {
    const i = t[r];
    for (; e.length >= 2; ) {
      const o = e[e.length - 1], a = e[e.length - 2];
      if ((o.x - a.x) * (i.y - a.y) >= (o.y - a.y) * (i.x - a.x))
        e.pop();
      else
        break;
    }
    e.push(i);
  }
  e.pop();
  const n = [];
  for (let r = t.length - 1; r >= 0; r--) {
    const i = t[r];
    for (; n.length >= 2; ) {
      const o = n[n.length - 1], a = n[n.length - 2];
      if ((o.x - a.x) * (i.y - a.y) >= (o.y - a.y) * (i.x - a.x))
        n.pop();
      else
        break;
    }
    n.push(i);
  }
  return n.pop(), e.length === 1 && n.length === 1 && e[0].x === n[0].x && e[0].y === n[0].y ? e : e.concat(n);
}
const One = fct, Pne = pct, Nne = gct, kne = bct, Rne = yct, Nct = Sct, kv = O.forwardRef(({ title: t, children: e }, n) => {
  const r = ua(lf);
  return /* @__PURE__ */ O.createElement(One, { delayDuration: 100 }, /* @__PURE__ */ O.createElement(Pne, null, /* @__PURE__ */ O.createElement(Nne, { ref: n, asChild: !0 }, /* @__PURE__ */ O.createElement("span", { className: it.tooltipTrigger }, e)), /* @__PURE__ */ O.createElement(kne, { container: r == null ? void 0 : r.current }, /* @__PURE__ */ O.createElement(Rne, { className: Ce(it.tooltipContent), sideOffset: 10 }, t))));
}), kct = O.forwardRef(
  ({ children: t, className: e, ...n }, r) => /* @__PURE__ */ O.createElement(Flt, { ...n, ref: r, className: Ce(e, it.selectItem) }, /* @__PURE__ */ O.createElement(Llt, null, t))
), Rct = ({ title: t, placeholder: e, className: n }) => {
  const [r, i] = ya(vu, Bo);
  return /* @__PURE__ */ O.createElement(kv, { title: t }, /* @__PURE__ */ O.createElement(
    Nlt,
    {
      "aria-label": e,
      className: Ce(it.selectTrigger, n),
      "data-toolbar-item": !0,
      disabled: r
    },
    /* @__PURE__ */ O.createElement(klt, { placeholder: e }),
    /* @__PURE__ */ O.createElement(Rlt, { className: it.selectDropdownArrow }, i("arrow_drop_down"))
  ));
}, $ct = ({
  children: t,
  className: e = it.selectContainer
}) => {
  const n = ua(lf);
  return /* @__PURE__ */ O.createElement($lt, { container: n == null ? void 0 : n.current }, /* @__PURE__ */ O.createElement(
    Dlt,
    {
      className: Ce(e, "mdxeditor-select-content"),
      onCloseAutoFocus: (r) => {
        r.preventDefault();
      },
      position: "popper"
    },
    /* @__PURE__ */ O.createElement(Mlt, { "data-editor-dropdown": !0 }, t)
  ));
}, Dct = (t) => /* @__PURE__ */ O.createElement(Plt, { value: t.value || void 0, onValueChange: t.onChange }, /* @__PURE__ */ O.createElement(Rct, { title: t.triggerTitle, placeholder: t.placeholder }), /* @__PURE__ */ O.createElement($ct, null, t.items.map((e, n) => e === "separator" ? /* @__PURE__ */ O.createElement(Vlt, { key: n }) : /* @__PURE__ */ O.createElement(kct, { key: n, value: e.value }, e.label))));
function Mct(t) {
  try {
    const e = t.anchor, n = t.focus, r = t.anchor.getNode(), i = t.focus.getNode();
    return r === i ? r : t.isBackward() ? vF(n) ? r : i : vF(e) ? r : i;
  } catch {
    return null;
  }
}
function $ne(t) {
  const e = vt(), n = window.getSelection(), r = document.activeElement, i = t.getRootElement();
  if (e !== null && n !== null && i !== null && i.contains(n.anchorNode) && t.isEditable()) {
    const o = n.getRangeAt(0);
    let a;
    if (n.isCollapsed) {
      let s = n.anchorNode;
      (s == null ? void 0 : s.nodeType) == 3 && (s = s.parentNode), a = s.getBoundingClientRect(), a.width = 0;
    } else if (n.anchorNode === i) {
      let s = i;
      for (; s.firstElementChild != null; )
        s = s.firstElementChild;
      a = s.getBoundingClientRect();
    } else
      a = o.getBoundingClientRect();
    return {
      top: Math.round(a.top),
      left: Math.round(a.left),
      width: Math.round(a.width),
      height: Math.round(a.height)
    };
  } else if (!r || r.className !== "link-input")
    return null;
  return null;
}
function Fct({ url: t, title: e, onSubmit: n, onCancel: r, linkAutocompleteSuggestions: i }) {
  const {
    register: o,
    handleSubmit: a,
    control: s,
    setValue: u,
    reset: l
  } = mte({
    values: {
      url: t,
      title: e
    }
  }), c = qi();
  return /* @__PURE__ */ O.createElement(
    "form",
    {
      onSubmit: (d) => {
        a(n)(d), d.stopPropagation(), d.preventDefault();
      },
      onReset: (d) => {
        d.stopPropagation(), r();
      },
      className: Ce(it.multiFieldForm, it.linkDialogEditForm)
    },
    /* @__PURE__ */ O.createElement("div", { className: it.formField }, /* @__PURE__ */ O.createElement("label", { htmlFor: "link-url" }, c("createLink.url", "URL")), /* @__PURE__ */ O.createElement(
      Qte,
      {
        register: o,
        initialInputValue: t,
        inputName: "url",
        suggestions: i,
        setValue: u,
        control: s,
        placeholder: c("createLink.urlPlaceholder", "Select or paste an URL"),
        autofocus: !0
      }
    )),
    /* @__PURE__ */ O.createElement("div", { className: it.formField }, /* @__PURE__ */ O.createElement("label", { htmlFor: "link-title" }, c("createLink.title", "Title")), /* @__PURE__ */ O.createElement("input", { id: "link-title", className: it.textInput, size: 40, ...o("title") })),
    /* @__PURE__ */ O.createElement("div", { style: { display: "flex", justifyContent: "flex-end", gap: "var(--spacing-2)" } }, /* @__PURE__ */ O.createElement(
      "button",
      {
        type: "submit",
        title: c("createLink.saveTooltip", "Set URL"),
        "aria-label": c("createLink.saveTooltip", "Set URL"),
        className: Ce(it.primaryButton)
      },
      c("dialogControls.save", "Save")
    ), /* @__PURE__ */ O.createElement(
      "button",
      {
        type: "reset",
        title: c("createLink.cancelTooltip", "Cancel change"),
        "aria-label": c("createLink.cancelTooltip", "Cancel change"),
        className: Ce(it.secondaryButton)
      },
      c("dialogControls.cancel", "Cancel")
    ))
  );
}
const Lct = () => {
  const [t, e, n, r, i, o] = ya(
    lf,
    hi,
    Bo,
    wo,
    Bne,
    Hne
  ), a = Vi(Dne), s = Vi(Mne), u = Vi(Fne), l = Vi(Lne), c = Vi(Vne);
  O.useEffect(() => {
    const m = () => {
      e == null || e.getEditorState().read(() => {
        a(!0);
      });
    };
    return window.addEventListener("resize", m), window.addEventListener("scroll", m), () => {
      window.removeEventListener("resize", m), window.removeEventListener("scroll", m);
    };
  }, [e, a]);
  const [d, f] = O.useState(!1), h = qi(), p = r.rectangle, v = r.type === "preview" && r.url.startsWith("http");
  return /* @__PURE__ */ O.createElement(e8, { open: r.type !== "inactive" }, /* @__PURE__ */ O.createElement(
    aot,
    {
      "data-visible": r.type === "edit",
      className: it.linkDialogAnchor,
      style: {
        top: `${(p == null ? void 0 : p.top) ?? 0}px`,
        left: `${(p == null ? void 0 : p.left) ?? 0}px`,
        width: `${(p == null ? void 0 : p.width) ?? 0}px`,
        height: `${(p == null ? void 0 : p.height) ?? 0}px`
      }
    }
  ), /* @__PURE__ */ O.createElement(t8, { container: t == null ? void 0 : t.current }, /* @__PURE__ */ O.createElement(
    sot,
    {
      className: Ce(it.linkDialogPopoverContent),
      sideOffset: 5,
      onOpenAutoFocus: (m) => {
        m.preventDefault();
      },
      key: r.linkNodeKey
    },
    r.type === "edit" && /* @__PURE__ */ O.createElement(
      Fct,
      {
        url: r.url,
        title: r.title,
        onSubmit: s,
        onCancel: u.bind(null),
        linkAutocompleteSuggestions: i
      }
    ),
    r.type === "preview" && /* @__PURE__ */ O.createElement(O.Fragment, null, /* @__PURE__ */ O.createElement(
      "a",
      {
        className: it.linkDialogPreviewAnchor,
        href: r.url,
        ...v ? { target: "_blank", rel: "noreferrer" } : {},
        onClick: (m) => {
          o !== null && (m.preventDefault(), o(r.url));
        },
        title: v ? h("linkPreview.open", "Open {{url}} in new window", { url: r.url }) : r.url
      },
      /* @__PURE__ */ O.createElement("span", null, r.url),
      v && n("open_in_new")
    ), /* @__PURE__ */ O.createElement(
      $5,
      {
        onClick: () => {
          l();
        },
        title: h("linkPreview.edit", "Edit link URL"),
        "aria-label": h("linkPreview.edit", "Edit link URL")
      },
      n("edit")
    ), /* @__PURE__ */ O.createElement(One, null, /* @__PURE__ */ O.createElement(Pne, { open: d }, /* @__PURE__ */ O.createElement(Nne, { asChild: !0 }, /* @__PURE__ */ O.createElement(
      $5,
      {
        title: h("linkPreview.copyToClipboard", "Copy to clipboard"),
        "aria-label": h("linkPreview.copyToClipboard", "Copy to clipboard"),
        onClick: () => {
          window.navigator.clipboard.writeText(r.url).then(() => {
            f(!0), setTimeout(() => {
              f(!1);
            }, 1e3);
          });
        }
      },
      n(d ? "check" : "content_copy")
    )), /* @__PURE__ */ O.createElement(kne, { container: t == null ? void 0 : t.current }, /* @__PURE__ */ O.createElement(Rne, { className: Ce(it.tooltipContent), sideOffset: 5 }, h("linkPreview.copied", "Copied!"), /* @__PURE__ */ O.createElement(Nct, null))))), /* @__PURE__ */ O.createElement(
      $5,
      {
        title: h("linkPreview.remove", "Remove link"),
        "aria-label": h("linkPreview.remove", "Remove link"),
        onClick: () => {
          c();
        }
      },
      n("link_off")
    )),
    /* @__PURE__ */ O.createElement(n8, { className: it.popoverArrow })
  )));
}, $5 = O.forwardRef(({ className: t, ...e }, n) => /* @__PURE__ */ O.createElement("button", { className: Ce(it.actionButton, t), ref: n, ...e }));
function C6(t) {
  if (!t)
    return null;
  const e = Mct(t);
  if (e === null)
    return null;
  const n = e.getParent();
  return Uu(n) ? n : Uu(e) ? e : null;
}
const Dne = Ei(), wo = Ht({ type: "inactive" }, (t) => {
  t.pub(C2, (e) => e.registerCommand(
    pv,
    () => t.getValue(wo).type === "preview" ? (t.pub(wo, { type: "inactive" }), !0) : !1,
    Ar
  )), t.pub(C2, (e) => e.registerCommand(
    UJ,
    (n) => {
      if (n.key === "k" && (CQ ? n.metaKey : n.ctrlKey) && !t.getValue(vu)) {
        const r = vt();
        return rt(r) ? (t.pub(D8), n.stopPropagation(), n.preventDefault(), !0) : !1;
      }
      return !1;
    },
    _4
  )), t.link(
    t.pipe(
      Lne,
      Zr(wo),
      Wh(([, e]) => {
        if (e.type === "preview")
          return {
            type: "edit",
            initialUrl: e.url,
            url: e.url,
            title: e.title,
            linkNodeKey: e.linkNodeKey,
            rectangle: e.rectangle
          };
        throw new Error("Cannot switch to edit mode when not in preview mode");
      })
    ),
    wo
  ), t.sub(t.pipe(Mne, Zr(hi, wo, fp)), ([e, n, r, i]) => {
    var o, a;
    const s = ((o = e.url) == null ? void 0 : o.trim()) ?? "", u = ((a = e.title) == null ? void 0 : a.trim()) ?? "";
    if (s !== "") {
      if (i != null && i.isCollapsed()) {
        const l = u || s;
        n == null || n.update(
          () => {
            const c = C6(i);
            if (c)
              c.setURL(s), c.setTitle(u);
            else {
              const d = pp(s, { title: u });
              d.append(Xr(l)), Bp([d]), d.select();
            }
          },
          { discrete: !0 }
        );
      } else
        n == null || n.dispatchCommand(gp, { url: s, title: u });
      t.pub(wo, {
        type: "preview",
        linkNodeKey: r.linkNodeKey,
        rectangle: r.rectangle,
        title: u,
        url: s
      });
    } else
      r.type === "edit" && r.initialUrl !== "" && (n == null || n.dispatchCommand(gp, null)), t.pub(wo, {
        type: "inactive"
      });
  }), t.link(
    t.pipe(
      Fne,
      Zr(wo, hi),
      Wh(([, e, n]) => {
        if (e.type === "edit")
          return n == null || n.focus(), e.initialUrl === "" ? {
            type: "inactive"
          } : {
            type: "preview",
            url: e.initialUrl,
            linkNodeKey: e.linkNodeKey,
            rectangle: e.rectangle
          };
        throw new Error("Cannot cancel edit when not in edit mode");
      })
    ),
    wo
  ), t.link(
    t.pipe(
      t.combine(fp, Dne),
      Zr(hi, wo, vu),
      Wh(([[e], n, r, i]) => {
        if (rt(e) && n && !i) {
          const o = C6(e);
          return o ? {
            type: "preview",
            url: o.getURL(),
            linkNodeKey: o.getKey(),
            title: o.getTitle(),
            rectangle: $ne(n)
          } : { type: "inactive" };
        } else
          return { type: "inactive" };
      })
    ),
    wo
  );
}), Mne = Ei(), Fne = Nc();
Nc();
const Lne = Nc(), Vne = Nc((t) => {
  t.sub(t.pipe(Vne, Zr(hi)), ([, e]) => {
    e == null || e.dispatchCommand(gp, null);
  });
}), D8 = Nc((t) => {
  t.sub(
    t.pipe(
      D8,
      Zr(fp, hi),
      dv(([, e]) => rt(e))
    ),
    ([, e, n]) => {
      n == null || n.focus(() => {
        n.getEditorState().read(() => {
          const r = C6(e), i = $ne(n);
          r ? t.pub(wo, {
            type: "edit",
            initialUrl: r.getURL(),
            initialTitle: r.getTitle() ?? "",
            url: r.getURL(),
            title: r.getTitle() ?? "",
            linkNodeKey: r.getKey(),
            rectangle: i
          }) : t.pub(wo, {
            type: "edit",
            initialUrl: "",
            initialTitle: "",
            title: "",
            url: "",
            linkNodeKey: "",
            rectangle: i
          });
        });
      });
    }
  );
}), Bne = Ht([]), Hne = Ht(null), Vct = pl({
  init(t, e) {
    t.pub(jp, (e == null ? void 0 : e.LinkDialog) ?? Lct), t.pub(Hne, (e == null ? void 0 : e.onClickLinkCallback) ?? null);
  },
  update(t, e = {}) {
    t.pub(Bne, e.linkAutocompleteSuggestions ?? []);
  }
});
function M8(t, e) {
  return O.forwardRef((n, r) => {
    const i = Ce(e.className, n.className);
    return /* @__PURE__ */ O.createElement(t, { ...e, ...n, className: i, ref: r });
  });
}
function Bct(t) {
  return ({ title: e, children: n, ...r }) => /* @__PURE__ */ O.createElement(t, { ...r }, /* @__PURE__ */ O.createElement(kv, { title: e }, n));
}
const Hct = ({ readOnly: t, children: e, className: n }) => /* @__PURE__ */ O.createElement(
  i8,
  {
    className: Ce("mdxeditor-toolbar", it.toolbarRoot, { [it.readOnlyToolbarRoot]: t }, n),
    ...t ? { tabIndex: -1 } : {}
  },
  e
), Wct = M8(ac, { className: it.toolbarButton, "data-toolbar-item": !0 }), F8 = Bct(Wct), Wne = M8(Ny, {
  className: it.toolbarToggleItem,
  "data-toolbar-item": !0
});
M8(Gw, {
  type: "single",
  className: it.toolbarToggleSingleGroup
});
const jct = O.forwardRef(({ on: t, title: e, children: n, disabled: r, ...i }, o) => /* @__PURE__ */ O.createElement(
  Gw,
  {
    type: "single",
    className: it.toolbarToggleSingleGroup,
    ...i,
    value: t ? "on" : "off",
    ref: o
  },
  /* @__PURE__ */ O.createElement(Wne, { title: e, value: "on", disabled: r }, /* @__PURE__ */ O.createElement(kv, { title: e }, n))
)), zct = ({
  value: t,
  onChange: e,
  className: n,
  items: r
}) => {
  const i = qi();
  return /* @__PURE__ */ O.createElement("div", { className: it.toolbarGroupOfGroups }, /* @__PURE__ */ O.createElement(
    Gw,
    {
      "aria-label": i("toolbar.toggleGroup", "toggle group"),
      type: "single",
      className: Ce(it.toolbarToggleSingleGroup, n),
      onValueChange: e,
      value: t || "",
      onFocus: (o) => {
        o.preventDefault();
      }
    },
    r.map((o, a) => /* @__PURE__ */ O.createElement(Wne, { key: a, "aria-label": o.title, value: o.value }, /* @__PURE__ */ O.createElement(kv, { title: o.title }, o.contents)))
  ));
}, D5 = Ht(() => null), M5 = Ht(""), UV = () => "This is an empty toolbar. Pass `{toolbarContents: () => { return <>toolbar components</> }}` to the toolbarPlugin to customize it.", Gct = pl({
  init(t, e) {
    t.pubIn({
      [D5]: (e == null ? void 0 : e.toolbarContents) ?? UV,
      [M5]: (e == null ? void 0 : e.toolbarClassName) ?? "",
      [yQe]: () => {
        const [n, r, i] = ya(D5, vu, M5);
        return /* @__PURE__ */ O.createElement(Hct, { className: i, readOnly: r }, n());
      }
    });
  },
  update(t, e) {
    t.pub(D5, (e == null ? void 0 : e.toolbarContents) ?? UV), t.pub(M5, (e == null ? void 0 : e.toolbarClassName) ?? "");
  }
}), Uct = () => {
  const t = Vi(w2), e = ua(cQ), n = ua(fQ), r = n.includes("quote"), i = n.includes("headings"), o = qi();
  if (!r && !i)
    return null;
  const a = [
    { label: o("toolbar.blockTypes.paragraph", "Paragraph"), value: "paragraph" }
  ];
  if (r && a.push({ label: o("toolbar.blockTypes.quote", "Quote"), value: "quote" }), i) {
    const s = ua(NO);
    a.push(
      ...s.map(
        (u) => ({ label: o("toolbar.blockTypes.heading", "Heading {{level}}", { level: u }), value: `h${u}` })
      )
    );
  }
  return /* @__PURE__ */ O.createElement(
    Dct,
    {
      value: e,
      onChange: (s) => {
        switch (s) {
          case "quote":
            t(() => mO());
            break;
          case "paragraph":
            t(() => Sr());
            break;
          case "":
            break;
          default:
            if (s.startsWith("h"))
              t(() => Ql(s));
            else
              throw new Error(`Unknown block type: ${s}`);
        }
      },
      triggerTitle: o("toolbar.blockTypeSelect.selectBlockTypeTooltip", "Select block type"),
      placeholder: o("toolbar.blockTypeSelect.placeholder", "Block type"),
      items: a
    }
  );
}, F5 = ({ format: t, addTitle: e, removeTitle: n, icon: r, formatName: i }) => {
  const [o, a] = ya(Uq, Bo), s = Vi(Xq), u = (o & t) !== 0;
  return /* @__PURE__ */ O.createElement(
    jct,
    {
      title: u ? n : e,
      on: u,
      onValueChange: () => {
        s(i);
      }
    },
    a(r)
  );
}, Xct = ({ options: t }) => {
  const e = qi(), n = typeof t > "u";
  return /* @__PURE__ */ O.createElement("div", { className: it.toolbarGroupOfGroups }, n || t.includes("Bold") ? /* @__PURE__ */ O.createElement(
    F5,
    {
      format: P0,
      addTitle: e("toolbar.bold", "Bold"),
      removeTitle: e("toolbar.removeBold", "Remove bold"),
      icon: "format_bold",
      formatName: "bold"
    }
  ) : null, n || t.includes("Italic") ? /* @__PURE__ */ O.createElement(
    F5,
    {
      format: N0,
      addTitle: e("toolbar.italic", "Italic"),
      removeTitle: e("toolbar.removeItalic", "Remove italic"),
      icon: "format_italic",
      formatName: "italic"
    }
  ) : null, n || t.includes("Underline") ? /* @__PURE__ */ O.createElement(
    F5,
    {
      format: k0,
      addTitle: e("toolbar.underline", "Underline"),
      removeTitle: e("toolbar.removeUnderline", "Remove underline"),
      icon: "format_underlined",
      formatName: "underline"
    }
  ) : null);
}, Yct = () => {
  const t = Vi(D8), e = ua(Bo), n = qi();
  return /* @__PURE__ */ O.createElement(
    F8,
    {
      "aria-label": n("toolbar.link", "Create link"),
      title: n("toolbar.link", "Create link"),
      onClick: (r) => {
        t();
      }
    },
    e("link")
  );
}, Zct = O.forwardRef((t, e) => {
  const n = Vi(ene), [r, i] = ya(vu, Bo), o = qi();
  return /* @__PURE__ */ O.createElement(
    ac,
    {
      className: it.toolbarButton,
      ref: e,
      disabled: r,
      onClick: () => {
        n();
      }
    },
    /* @__PURE__ */ O.createElement(kv, { title: o("toolbar.image", "Insert image") }, i("add_photo"))
  );
}), Jct = () => {
  const t = ua(Bo), e = Vi(Wee), n = qi();
  return /* @__PURE__ */ O.createElement(
    F8,
    {
      title: n("toolbar.table", "Insert Table"),
      onClick: () => {
        e({ rows: 3, columns: 3 });
      }
    },
    t("table")
  );
}, Kct = () => {
  const t = Vi(AQ), e = ua(Bo), n = qi();
  return /* @__PURE__ */ O.createElement(
    F8,
    {
      title: n("toolbar.thematicBreak", "Insert thematic break"),
      onClick: () => {
        t();
      }
    },
    e("horizontal_rule")
  );
}, qct = {
  bullet: "format_list_bulleted",
  number: "format_list_numbered",
  check: "format_list_checked"
}, Qct = ({ options: t = ["bullet", "number", "check"] }) => {
  const [e, n] = ya(q4, Bo), r = Vi(FQ), i = qi(), o = {
    bullet: i("toolbar.bulletedList", "Bulleted list"),
    number: i("toolbar.numberedList", "Numbered list"),
    check: i("toolbar.checkList", "Check list")
  }, a = t.map((s) => ({
    value: s,
    title: o[s],
    contents: n(qct[s])
  }));
  return /* @__PURE__ */ O.createElement(zct, { value: e || "", items: a, onChange: r });
}, edt = {
  readOnly: !1
}, XV = () => Math.random().toString(36).substring(7), tdt = (t) => {
  const { value: e, onChange: n, inputProps: r = edt } = t, [i, o] = O.useState(e || ""), [a, s] = O.useState(XV());
  Re(() => {
    o(e || ""), i || s(XV());
  }, [e]);
  const u = (c) => {
    o(c), n(c);
  }, { readOnly: l } = r;
  return /* @__PURE__ */ Oe.jsx("div", { className: "ant-form-markdown-wrapper", children: /* @__PURE__ */ Oe.jsx(
    Xtt,
    {
      onChange: u,
      markdown: i,
      readOnly: l,
      plugins: [
        Qtt(),
        nat(),
        Tnt(),
        Eut(),
        Cat(),
        Vct(),
        ont(),
        Gct({
          toolbarContents: () => /* @__PURE__ */ Oe.jsxs(Oe.Fragment, { children: [
            /* @__PURE__ */ Oe.jsx(Xct, { options: ["Bold", "Italic"] }),
            /* @__PURE__ */ Oe.jsx(Qct, {}),
            /* @__PURE__ */ Oe.jsx(Uct, {}),
            /* @__PURE__ */ Oe.jsx(Yct, {}),
            /* @__PURE__ */ Oe.jsx(Zct, {}),
            /* @__PURE__ */ Oe.jsx(Jct, {}),
            /* @__PURE__ */ Oe.jsx(Kct, {})
          ] })
        })
      ]
    },
    a
  ) });
};
function ndt(t) {
  if (Array.isArray(t)) {
    for (var e = 0, n = new Array(t.length); e < t.length; e++)
      n[e] = t[e];
    return n;
  }
}
function rdt(t) {
  if (Symbol.iterator in Object(t) || Object.prototype.toString.call(t) === "[object Arguments]")
    return Array.from(t);
}
function idt() {
  throw new TypeError("Invalid attempt to spread non-iterable instance");
}
function H2(t) {
  return ndt(t) || rdt(t) || idt();
}
function Ga() {
  return Ga = Object.assign || function(t) {
    for (var e = 1; e < arguments.length; e++) {
      var n = arguments[e];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (t[r] = n[r]);
    }
    return t;
  }, Ga.apply(this, arguments);
}
function odt(t, e) {
  if (!(t instanceof e))
    throw new TypeError("Cannot call a class as a function");
}
function YV(t, e) {
  for (var n = 0; n < e.length; n++) {
    var r = e[n];
    r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(t, r.key, r);
  }
}
function adt(t, e, n) {
  return e && YV(t.prototype, e), n && YV(t, n), t;
}
function An(t) {
  if (t === void 0)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return t;
}
function w6(t, e) {
  return w6 = Object.setPrototypeOf || function(r, i) {
    return r.__proto__ = i, r;
  }, w6(t, e);
}
function sdt(t, e) {
  if (typeof e != "function" && e !== null)
    throw new TypeError("Super expression must either be null or a function");
  t.prototype = Object.create(e && e.prototype, {
    constructor: {
      value: t,
      writable: !0,
      configurable: !0
    }
  }), e && w6(t, e);
}
function Zh(t) {
  return typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? Zh = function(n) {
    return typeof n;
  } : Zh = function(n) {
    return n && typeof Symbol == "function" && n.constructor === Symbol && n !== Symbol.prototype ? "symbol" : typeof n;
  }, Zh(t);
}
function Fy(t) {
  return typeof Symbol == "function" && Zh(Symbol.iterator) === "symbol" ? Fy = function(n) {
    return Zh(n);
  } : Fy = function(n) {
    return n && typeof Symbol == "function" && n.constructor === Symbol && n !== Symbol.prototype ? "symbol" : Zh(n);
  }, Fy(t);
}
function udt(t, e) {
  return e && (Fy(e) === "object" || typeof e == "function") ? e : An(t);
}
function W2(t) {
  return W2 = Object.setPrototypeOf ? Object.getPrototypeOf : function(n) {
    return n.__proto__ || Object.getPrototypeOf(n);
  }, W2(t);
}
function _n(t, e, n) {
  return e in t ? Object.defineProperty(t, e, {
    value: n,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : t[e] = n, t;
}
var ldt = function(t, e, n, r, i, o, a, s) {
  if (process.env.NODE_ENV !== "production" && e === void 0)
    throw new Error("invariant requires an error message argument");
  if (!t) {
    var u;
    if (e === void 0)
      u = new Error(
        "Minified exception occurred; use the non-minified dev environment for the full error message and additional helpful warnings."
      );
    else {
      var l = [n, r, i, o, a, s], c = 0;
      u = new Error(
        e.replace(/%s/g, function() {
          return l[c++];
        })
      ), u.name = "Invariant Violation";
    }
    throw u.framesToPop = 1, u;
  }
}, cdt = ldt;
const vp = /* @__PURE__ */ qn(cdt);
function ddt(t) {
  if (Array.isArray(t))
    return t;
}
function fdt(t, e) {
  var n = [], r = !0, i = !1, o = void 0;
  try {
    for (var a = t[Symbol.iterator](), s; !(r = (s = a.next()).done) && (n.push(s.value), !(e && n.length === e)); r = !0)
      ;
  } catch (u) {
    i = !0, o = u;
  } finally {
    try {
      !r && a.return != null && a.return();
    } finally {
      if (i)
        throw o;
    }
  }
  return n;
}
function hdt() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance");
}
function j2(t, e) {
  return ddt(t) || fdt(t, e) || hdt();
}
function pdt(t, e) {
  if (t == null)
    return {};
  var n = {}, r = Object.keys(t), i, o;
  for (o = 0; o < r.length; o++)
    i = r[o], !(e.indexOf(i) >= 0) && (n[i] = t[i]);
  return n;
}
function gdt(t, e) {
  if (t == null)
    return {};
  var n = pdt(t, e), r, i;
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(t);
    for (i = 0; i < o.length; i++)
      r = o[i], !(e.indexOf(r) >= 0) && Object.prototype.propertyIsEnumerable.call(t, r) && (n[r] = t[r]);
  }
  return n;
}
var Yp = function(e) {
  return e === Object(e) ? Object.keys(e) : [];
}, jne = function(e) {
  return e === Object(e) ? Object.values(e) : [];
};
function zne(t, e) {
  var n = Object.assign({}, t);
  return Ly(t) && Ly(e) && Yp(e).forEach(function(r) {
    Ly(e[r]) ? r in t ? n[r] = zne(t[r], e[r]) : Object.assign(n, z({}, r, e[r])) : Object.assign(n, z({}, r, e[r]));
  }), n;
}
var E6 = function(e) {
  for (var n = arguments.length, r = new Array(n > 1 ? n - 1 : 0), i = 1; i < n; i++)
    r[i - 1] = arguments[i];
  return r.reduce(function(o, a) {
    return zne(o, a);
  }, e);
}, mdt = function(e, n) {
  var r = Object.assign({}, e);
  if (n)
    for (var i = 0; i < n.length; i++)
      delete r[n[i]];
  return r;
}, Ly = function(e) {
  return e === Object(e) && !(e instanceof Date) && !Array.isArray(e);
}, vdt = function(e) {
  return (e || []).filter(Boolean);
}, L8 = function(e) {
  return e[0] === "&";
}, bdt = function(e) {
  return !L8(e);
}, ZV = function(e) {
  return e.replace(/-(\w)/g, function(n, r) {
    return r.toUpperCase();
  });
}, ydt = function(e) {
  for (var n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : [], r = Yp(e), i = {}, o = 0, a = r.length; o < a; o += 1) {
    var s = r[o], u = Object.prototype.toString.call(e[s]) !== "[object Object]" || // style defs
    s[0] === ":" || // pseudo selectors
    s[0] === "@" || // @media / @keyframes / @supports / @font-face
    n.indexOf(s) >= 0;
    u && (i[s] = e[s]);
  }
  return i;
}, Gne = function(e, n) {
  for (var r = n.map(ZV), i = Yp(e), o = {}, a = 0, s = i.length; a < s; a += 1) {
    var u = i[a];
    (n.indexOf(u) >= 0 || r.indexOf(ZV(u)) >= 0) && (o[u] = e[u]);
  }
  return o;
}, xdt = function t(e, n) {
  for (var r = E6.apply(void 0, [{}, mdt(e, n)].concat(Ye(jne(Gne(e, n))))), i = Yp(r).filter(L8), o = 0, a = i.length; o < a; o += 1) {
    var s = i[o], u = t(r[s], n);
    n.indexOf(s) >= 0 ? (delete r[s], r = E6({}, r, u)) : r[s] = u;
  }
  return r;
};
function JV(t, e) {
  var n = Object.keys(t);
  if (Object.getOwnPropertySymbols) {
    var r = Object.getOwnPropertySymbols(t);
    e && (r = r.filter(function(i) {
      return Object.getOwnPropertyDescriptor(t, i).enumerable;
    })), n.push.apply(n, r);
  }
  return n;
}
function KV(t) {
  for (var e = 1; e < arguments.length; e++) {
    var n = arguments[e] != null ? arguments[e] : {};
    e % 2 ? JV(Object(n), !0).forEach(function(r) {
      z(t, r, n[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(t, Object.getOwnPropertyDescriptors(n)) : JV(Object(n)).forEach(function(r) {
      Object.defineProperty(t, r, Object.getOwnPropertyDescriptor(n, r));
    });
  }
  return t;
}
var Cdt = ["animationName"], wdt = function(e) {
  var n = e.style, r = e.className;
  return KV(KV({}, n ? {
    style: ydt(n, Cdt)
  } : {}), r ? {
    className: r
  } : {});
};
const Une = wdt;
var Xne = /* @__PURE__ */ oi(Une);
Xne.Provider;
var Edt = function(e) {
  if (e) {
    if (typeof e == "string")
      return [e];
    if (!Array.isArray(e)) {
      var n = e;
      return Yp(e).reduce(function(r, i) {
        return r.concat(n[i] ? [i] : []);
      }, []);
    }
  } else
    return [];
  return e;
};
const Yne = Edt;
var Sdt = {}, Idt = function(e) {
  return function(n, r) {
    var i = r || Sdt;
    e.memoize = e.memoize || /* @__PURE__ */ new WeakMap();
    var o;
    e.memoize.has(i) ? o = e.memoize.get(i) : (o = {}, e.memoize.set(i, o));
    var a = Yne(n).join(" ");
    return a in o ? o[a] : o[a] = e(n || [], r);
  };
};
const _dt = Idt;
function qV(t, e) {
  var n = Object.keys(t);
  if (Object.getOwnPropertySymbols) {
    var r = Object.getOwnPropertySymbols(t);
    e && (r = r.filter(function(i) {
      return Object.getOwnPropertyDescriptor(t, i).enumerable;
    })), n.push.apply(n, r);
  }
  return n;
}
function Yf(t) {
  for (var e = 1; e < arguments.length; e++) {
    var n = arguments[e] != null ? arguments[e] : {};
    e % 2 ? qV(Object(n), !0).forEach(function(r) {
      z(t, r, n[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(t, Object.getOwnPropertyDescriptors(n)) : qV(Object(n)).forEach(function(r) {
      Object.defineProperty(t, r, Object.getOwnPropertyDescriptor(n, r));
    });
  }
  return t;
}
var Adt = function(e) {
  var n = e && Yp(e)[0];
  return n && n.split("__")[0].split("--")[0];
}, Tdt = function(e, n, r) {
  if (e) {
    var i = e.split(" ")[0], o = [].concat(Ye(n.length === 0 ? r.map(function(a) {
      return "".concat(i, "--").concat(a.substring(1));
    }) : []), Ye(n.map(function(a) {
      return "".concat(i, "__").concat(a);
    })));
    return n.length === 0 ? [e].concat(Ye(o)) : o;
  }
};
function Zne(t) {
  var e = t.style, n = t.className, r = t.classNames, i = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : Une, o = n || Adt(r) || (e == null ? void 0 : e.className), a = typeof e == "function" ? e : _dt(function(d, f) {
    var h = Yne(d);
    vp(Array.isArray(h), "First parameter must be a string, an array of strings, a plain object with boolean values, or a falsy value."), vp(!f || Ly(f), "Optional second parameter must be a plain object.");
    var p = h.filter(L8), v = h.filter(bdt), m = v.length > 0 ? function(w) {
      return jne(Gne(w, v));
    } : function(w) {
      return [w];
    }, b = function() {
      var S = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
      return m(xdt(S, p));
    }, y = Tdt(o, v, p);
    return Zne(Yf(Yf(Yf({}, (e || f) && {
      style: E6.apply(void 0, [{}].concat(Ye(b(f)), Ye(b(e))))
    }), y && {
      className: y.join(" ")
    }), r && {
      classNames: r
    }), i);
  }), s = Yf({}, typeof e == "function" ? e : {
    style: e
  }), u = Ye(new Set([].concat(Ye(s.className ? s.className.split(" ") : []), Ye(o ? o.split(" ") : [])))), l = r ? vdt(u.map(function(d) {
    return r[d];
  })) : u, c = i(Yf(Yf({}, s), l.length > 0 ? {
    className: l.join(" ")
  } : {}));
  return Object.assign(a, c), a;
}
function QV(t, e) {
  var n = Object.keys(t);
  if (Object.getOwnPropertySymbols) {
    var r = Object.getOwnPropertySymbols(t);
    e && (r = r.filter(function(i) {
      return Object.getOwnPropertyDescriptor(t, i).enumerable;
    })), n.push.apply(n, r);
  }
  return n;
}
function Gg(t) {
  for (var e = 1; e < arguments.length; e++) {
    var n = arguments[e] != null ? arguments[e] : {};
    e % 2 ? QV(Object(n), !0).forEach(function(r) {
      z(t, r, n[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(t, Object.getOwnPropertyDescriptors(n)) : QV(Object(n)).forEach(function(r) {
      Object.defineProperty(t, r, Object.getOwnPropertyDescriptor(n, r));
    });
  }
  return t;
}
var Odt = function() {
  for (var e = arguments.length, n = new Array(e), r = 0; r < e; r++)
    n[r] = arguments[r];
  return n.reduce(function(i, o) {
    return Gg(Gg(Gg({}, i), typeof o == "function" ? o : {}), {}, {
      style: Gg(Gg({}, i.style), typeof o == "function" ? o.style : o)
    });
  }, {});
};
const Pdt = Odt;
var Ndt = function(e, n, r) {
  var i = n.style, o = n.className, a = n.classNames, s = fn(Xne), u = Rn(function() {
    return Zne({
      style: i,
      className: o,
      classNames: a
    }, s);
  }, [i, o, a, s]);
  return u(r, e);
};
const V8 = Ndt;
var Vy = function(e) {
  return e.replace(/[-[\]{}()*+?.,\\^$|#\s]/g, "\\$&");
}, Zs = {
  id: "__id__",
  display: "__display__"
}, eB = function(e, n) {
  vp(n === "id" || n === "display", 'Second arg must be either "id" or "display", got: "'.concat(n, '"'));
  var r = e.indexOf(Zs.display), i = e.indexOf(Zs.id);
  return r < 0 && (r = null), i < 0 && (i = null), vp(r !== null || i !== null, "The markup '".concat(e, "' does not contain either of the placeholders '__id__' or '__display__'")), r !== null && i !== null ? n === "id" && i <= r || n === "display" && r <= i ? 0 : 1 : 0;
}, kdt = function(e) {
  var n = /^\/(.+)\/(\w+)?$/;
  return new RegExp(e.map(function(r) {
    var i = n.exec(r.toString()), o = j2(i, 3), a = o[1], s = o[2];
    return vp(!s, "RegExp flags are not supported. Change /".concat(a, "/").concat(s, " into /").concat(a, "/")), "(".concat(a, ")");
  }).join("|"), "g");
}, Jne = function(e) {
  var n = 0;
  return e.indexOf("__id__") >= 0 && n++, e.indexOf("__display__") >= 0 && n++, n;
}, Rdt = function() {
}, Rv = function(e, n, r) {
  for (var i = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : Rdt, o = kdt(n.map(function(E) {
    return E.regex;
  })), a = 2, s = n.map(function(E) {
    var I = E.markup, _ = a;
    return a += Jne(I) + 1, _;
  }), u, l = 0, c = 0; (u = o.exec(e)) !== null; ) {
    var d = s.find(function(E) {
      return !!u[E];
    }), f = s.indexOf(d), h = n[f], p = h.markup, v = h.displayTransform, m = d + eB(p, "id"), b = d + eB(p, "display"), y = u[m], w = v(y, u[b]), S = e.substring(l, u.index);
    i(S, l, c), c += S.length, r(u[0], u.index, c, y, w, f, l), c += w.length, l = o.lastIndex;
  }
  l < e.length && i(e.substring(l), l, c);
}, sd = function(e, n) {
  var r = "";
  return Rv(e, n, function(i, o, a, s, u) {
    r += u;
  }, function(i) {
    r += i;
  }), r;
}, ro = function(e, n, r) {
  var i = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : "START";
  if (typeof r != "number")
    return r;
  var o, a = function(l, c, d) {
    o === void 0 && d + l.length >= r && (o = c + r - d);
  }, s = function(l, c, d, f, h, p, v) {
    o === void 0 && d + h.length > r && (i === "NULL" ? o = null : o = c + (i === "END" ? l.length : 0));
  };
  return Rv(e, n, s, a), o === void 0 ? e.length : o;
}, M0 = function(e, n, r, i) {
  return e.substring(0, n) + i + e.substring(r);
}, $dt = function(e, n, r, i) {
  var o = r.selectionStartBefore, a = r.selectionEndBefore, s = r.selectionEndAfter, u = sd(e, i), l = u.length - n.length;
  o === "undefined" && (o = s + l), a === "undefined" && (a = o), o === a && a === s && u.length === n.length && (o = o - 1);
  var c = n.slice(o, s), d = Math.min(o, s), f = a;
  o === s && (f = Math.max(a, o + l));
  var h = ro(e, i, d, "START"), p = ro(e, i, f, "END"), v = ro(e, i, d, "NULL"), m = ro(e, i, f, "NULL"), b = v === null || m === null, y = M0(e, h, p, c);
  if (!b) {
    var w = sd(y, i);
    if (w !== n) {
      for (d = 0; n[d] === w[d]; )
        d++;
      c = n.slice(d, s), f = u.lastIndexOf(n.substring(s)), h = ro(e, i, d, "START"), p = ro(e, i, f, "END"), y = M0(e, h, p, c);
    }
  }
  return y;
}, tB = function(e, n, r) {
  var i = r, o = !1, a = function(u, l, c, d, f, h, p) {
    c <= r && c + f.length > r && (i = c, o = !0);
  };
  if (Rv(e, n, a), o)
    return i;
}, s0 = function(e, n) {
  var r = [];
  return Rv(e, n, function(i, o, a, s, u, l, c) {
    r.push({
      id: s,
      display: u,
      childIndex: l,
      index: o,
      plainTextIndex: a
    });
  }), r;
}, Kne = function(e, n) {
  return "".concat(e, "-").concat(n);
}, Xb = function(e) {
  return Object.values(e).reduce(function(n, r) {
    var i = r.results;
    return n + i.length;
  }, 0);
}, Ddt = function(e, n) {
  var r = s0(e, n), i = r[r.length - 1];
  return i ? i.plainTextIndex + i.display.length : 0;
}, Mdt = function(e) {
  var n = Vy(e), r = e[e.indexOf(Zs.display) + Zs.display.length], i = e[e.indexOf(Zs.id) + Zs.id.length];
  return new RegExp(n.replace(Zs.display, "([^".concat(Vy(r || ""), "]+?)")).replace(Zs.id, "([^".concat(Vy(i || ""), "]+?)")));
}, Wl = function(e) {
  return za.toArray(e).map(function(n) {
    var r = n.props, i = r.markup, o = r.regex, a = r.displayTransform;
    return {
      markup: i,
      regex: o ? Fdt(o, i) : Mdt(i),
      displayTransform: a || function(s, u) {
        return u || s;
      }
    };
  });
}, Fdt = function(e, n) {
  var r = new RegExp(e.toString() + "|").exec("").length - 1, i = Jne(n);
  return vp(r === i, "Number of capturing groups in RegExp ".concat(e.toString(), " (").concat(r, ") does not match the number of placeholders in the markup '").concat(n, "' (").concat(i, ")")), e;
}, Ldt = function(e, n, r) {
  return e.replace(Zs.id, n).replace(Zs.display, r);
}, Vdt = [{
  base: "A",
  letters: /(&#65;|&#9398;|&#65313;|&#192;|&#193;|&#194;|&#7846;|&#7844;|&#7850;|&#7848;|&#195;|&#256;|&#258;|&#7856;|&#7854;|&#7860;|&#7858;|&#550;|&#480;|&#196;|&#478;|&#7842;|&#197;|&#506;|&#461;|&#512;|&#514;|&#7840;|&#7852;|&#7862;|&#7680;|&#260;|&#570;|&#11375;|[\u0041\u24B6\uFF21\u00C0\u00C1\u00C2\u1EA6\u1EA4\u1EAA\u1EA8\u00C3\u0100\u0102\u1EB0\u1EAE\u1EB4\u1EB2\u0226\u01E0\u00C4\u01DE\u1EA2\u00C5\u01FA\u01CD\u0200\u0202\u1EA0\u1EAC\u1EB6\u1E00\u0104\u023A\u2C6F])/g
}, {
  base: "AA",
  letters: /(&#42802;|[\uA732])/g
}, {
  base: "AE",
  letters: /(&#198;|&#508;|&#482;|[\u00C6\u01FC\u01E2])/g
}, {
  base: "AO",
  letters: /(&#42804;|[\uA734])/g
}, {
  base: "AU",
  letters: /(&#42806;|[\uA736])/g
}, {
  base: "AV",
  letters: /(&#42808;|&#42810;|[\uA738\uA73A])/g
}, {
  base: "AY",
  letters: /(&#42812;|[\uA73C])/g
}, {
  base: "B",
  letters: /(&#66;|&#9399;|&#65314;|&#7682;|&#7684;|&#7686;|&#579;|&#386;|&#385;|[\u0042\u24B7\uFF22\u1E02\u1E04\u1E06\u0243\u0182\u0181])/g
}, {
  base: "C",
  letters: /(&#67;|&#9400;|&#65315;|&#262;|&#264;|&#266;|&#268;|&#199;|&#7688;|&#391;|&#571;|&#42814;|[\u0043\u24B8\uFF23\u0106\u0108\u010A\u010C\u00C7\u1E08\u0187\u023B\uA73E])/g
}, {
  base: "D",
  letters: /(&#68;|&#9401;|&#65316;|&#7690;|&#270;|&#7692;|&#7696;|&#7698;|&#7694;|&#272;|&#395;|&#394;|&#393;|&#42873;|&#208;|[\u0044\u24B9\uFF24\u1E0A\u010E\u1E0C\u1E10\u1E12\u1E0E\u0110\u018B\u018A\u0189\uA779\u00D0])/g
}, {
  base: "DZ",
  letters: /(&#497;|&#452;|[\u01F1\u01C4])/g
}, {
  base: "Dz",
  letters: /(&#498;|&#453;|[\u01F2\u01C5])/g
}, {
  base: "E",
  letters: /(&#69;|&#9402;|&#65317;|&#200;|&#201;|&#202;|&#7872;|&#7870;|&#7876;|&#7874;|&#7868;|&#274;|&#7700;|&#7702;|&#276;|&#278;|&#203;|&#7866;|&#282;|&#516;|&#518;|&#7864;|&#7878;|&#552;|&#7708;|&#280;|&#7704;|&#7706;|&#400;|&#398;|[\u0045\u24BA\uFF25\u00C8\u00C9\u00CA\u1EC0\u1EBE\u1EC4\u1EC2\u1EBC\u0112\u1E14\u1E16\u0114\u0116\u00CB\u1EBA\u011A\u0204\u0206\u1EB8\u1EC6\u0228\u1E1C\u0118\u1E18\u1E1A\u0190\u018E])/g
}, {
  base: "F",
  letters: /(&#70;|&#9403;|&#65318;|&#7710;|&#401;|&#42875;|[\u0046\u24BB\uFF26\u1E1E\u0191\uA77B])/g
}, {
  base: "G",
  letters: /(&#71;|&#9404;|&#65319;|&#500;|&#284;|&#7712;|&#286;|&#288;|&#486;|&#290;|&#484;|&#403;|&#42912;|&#42877;|&#42878;|[\u0047\u24BC\uFF27\u01F4\u011C\u1E20\u011E\u0120\u01E6\u0122\u01E4\u0193\uA7A0\uA77D\uA77E])/g
}, {
  base: "H",
  letters: /(&#72;|&#9405;|&#65320;|&#292;|&#7714;|&#7718;|&#542;|&#7716;|&#7720;|&#7722;|&#294;|&#11367;|&#11381;|&#42893;|[\u0048\u24BD\uFF28\u0124\u1E22\u1E26\u021E\u1E24\u1E28\u1E2A\u0126\u2C67\u2C75\uA78D])/g
}, {
  base: "I",
  letters: /(&#73;|&#9406;|&#65321;|&#204;|&#205;|&#206;|&#296;|&#298;|&#300;|&#304;|&#207;|&#7726;|&#7880;|&#463;|&#520;|&#522;|&#7882;|&#302;|&#7724;|&#407;|[\u0049\u24BE\uFF29\u00CC\u00CD\u00CE\u0128\u012A\u012C\u0130\u00CF\u1E2E\u1EC8\u01CF\u0208\u020A\u1ECA\u012E\u1E2C\u0197])/g
}, {
  base: "J",
  letters: /(&#74;|&#9407;|&#65322;|&#308;|&#584;|[\u004A\u24BF\uFF2A\u0134\u0248])/g
}, {
  base: "K",
  letters: /(&#75;|&#9408;|&#65323;|&#7728;|&#488;|&#7730;|&#310;|&#7732;|&#408;|&#11369;|&#42816;|&#42818;|&#42820;|&#42914;|[\u004B\u24C0\uFF2B\u1E30\u01E8\u1E32\u0136\u1E34\u0198\u2C69\uA740\uA742\uA744\uA7A2])/g
}, {
  base: "L",
  letters: /(&#76;|&#9409;|&#65324;|&#319;|&#313;|&#317;|&#7734;|&#7736;|&#315;|&#7740;|&#7738;|&#321;|&#573;|&#11362;|&#11360;|&#42824;|&#42822;|&#42880;|[\u004C\u24C1\uFF2C\u013F\u0139\u013D\u1E36\u1E38\u013B\u1E3C\u1E3A\u0141\u023D\u2C62\u2C60\uA748\uA746\uA780])/g
}, {
  base: "LJ",
  letters: /(&#455;|[\u01C7])/g
}, {
  base: "Lj",
  letters: /(&#456;|[\u01C8])/g
}, {
  base: "M",
  letters: /(&#77;|&#9410;|&#65325;|&#7742;|&#7744;|&#7746;|&#11374;|&#412;|[\u004D\u24C2\uFF2D\u1E3E\u1E40\u1E42\u2C6E\u019C])/g
}, {
  base: "N",
  letters: /(&#78;|&#9411;|&#65326;|&#504;|&#323;|&#209;|&#7748;|&#327;|&#7750;|&#325;|&#7754;|&#7752;|&#544;|&#413;|&#42896;|&#42916;|&#330;|[\u004E\u24C3\uFF2E\u01F8\u0143\u00D1\u1E44\u0147\u1E46\u0145\u1E4A\u1E48\u0220\u019D\uA790\uA7A4\u014A])/g
}, {
  base: "NJ",
  letters: /(&#458;|[\u01CA])/g
}, {
  base: "Nj",
  letters: /(&#459;|[\u01CB])/g
}, {
  base: "O",
  letters: /(&#79;|&#9412;|&#65327;|&#210;|&#211;|&#212;|&#7890;|&#7888;|&#7894;|&#7892;|&#213;|&#7756;|&#556;|&#7758;|&#332;|&#7760;|&#7762;|&#334;|&#558;|&#560;|&#214;|&#554;|&#7886;|&#336;|&#465;|&#524;|&#526;|&#416;|&#7900;|&#7898;|&#7904;|&#7902;|&#7906;|&#7884;|&#7896;|&#490;|&#492;|&#216;|&#510;|&#390;|&#415;|&#42826;|&#42828;|[\u004F\u24C4\uFF2F\u00D2\u00D3\u00D4\u1ED2\u1ED0\u1ED6\u1ED4\u00D5\u1E4C\u022C\u1E4E\u014C\u1E50\u1E52\u014E\u022E\u0230\u00D6\u022A\u1ECE\u0150\u01D1\u020C\u020E\u01A0\u1EDC\u1EDA\u1EE0\u1EDE\u1EE2\u1ECC\u1ED8\u01EA\u01EC\u00D8\u01FE\u0186\u019F\uA74A\uA74C])/g
}, {
  base: "OE",
  letters: /(&#338;|[\u0152])/g
}, {
  base: "OI",
  letters: /(&#418;|[\u01A2])/g
}, {
  base: "OO",
  letters: /(&#42830;|[\uA74E])/g
}, {
  base: "OU",
  letters: /(&#546;|[\u0222])/g
}, {
  base: "P",
  letters: /(&#80;|&#9413;|&#65328;|&#7764;|&#7766;|&#420;|&#11363;|&#42832;|&#42834;|&#42836;|[\u0050\u24C5\uFF30\u1E54\u1E56\u01A4\u2C63\uA750\uA752\uA754])/g
}, {
  base: "Q",
  letters: /(&#81;|&#9414;|&#65329;|&#42838;|&#42840;|&#586;|[\u0051\u24C6\uFF31\uA756\uA758\u024A])/g
}, {
  base: "R",
  letters: /(&#82;|&#9415;|&#65330;|&#340;|&#7768;|&#344;|&#528;|&#530;|&#7770;|&#7772;|&#342;|&#7774;|&#588;|&#11364;|&#42842;|&#42918;|&#42882;|[\u0052\u24C7\uFF32\u0154\u1E58\u0158\u0210\u0212\u1E5A\u1E5C\u0156\u1E5E\u024C\u2C64\uA75A\uA7A6\uA782])/g
}, {
  base: "S",
  letters: /(&#83;|&#9416;|&#65331;|&#7838;|&#346;|&#7780;|&#348;|&#7776;|&#352;|&#7782;|&#7778;|&#7784;|&#536;|&#350;|&#11390;|&#42920;|&#42884;|[\u0053\u24C8\uFF33\u1E9E\u015A\u1E64\u015C\u1E60\u0160\u1E66\u1E62\u1E68\u0218\u015E\u2C7E\uA7A8\uA784])/g
}, {
  base: "T",
  letters: /(&#84;|&#9417;|&#65332;|&#7786;|&#356;|&#7788;|&#538;|&#354;|&#7792;|&#7790;|&#358;|&#428;|&#430;|&#574;|&#42886;|[\u0054\u24C9\uFF34\u1E6A\u0164\u1E6C\u021A\u0162\u1E70\u1E6E\u0166\u01AC\u01AE\u023E\uA786])/g
}, {
  base: "TH",
  letters: /(&#222;|[\u00DE])/g
}, {
  base: "TZ",
  letters: /(&#42792;|[\uA728])/g
}, {
  base: "U",
  letters: /(&#85;|&#9418;|&#65333;|&#217;|&#218;|&#219;|&#360;|&#7800;|&#362;|&#7802;|&#364;|&#220;|&#475;|&#471;|&#469;|&#473;|&#7910;|&#366;|&#368;|&#467;|&#532;|&#534;|&#431;|&#7914;|&#7912;|&#7918;|&#7916;|&#7920;|&#7908;|&#7794;|&#370;|&#7798;|&#7796;|&#580;|[\u0055\u24CA\uFF35\u00D9\u00DA\u00DB\u0168\u1E78\u016A\u1E7A\u016C\u00DC\u01DB\u01D7\u01D5\u01D9\u1EE6\u016E\u0170\u01D3\u0214\u0216\u01AF\u1EEA\u1EE8\u1EEE\u1EEC\u1EF0\u1EE4\u1E72\u0172\u1E76\u1E74\u0244])/g
}, {
  base: "V",
  letters: /(&#86;|&#9419;|&#65334;|&#7804;|&#7806;|&#434;|&#42846;|&#581;|[\u0056\u24CB\uFF36\u1E7C\u1E7E\u01B2\uA75E\u0245])/g
}, {
  base: "VY",
  letters: /(&#42848;|[\uA760])/g
}, {
  base: "W",
  letters: /(&#87;|&#9420;|&#65335;|&#7808;|&#7810;|&#372;|&#7814;|&#7812;|&#7816;|&#11378;|[\u0057\u24CC\uFF37\u1E80\u1E82\u0174\u1E86\u1E84\u1E88\u2C72])/g
}, {
  base: "X",
  letters: /(&#88;|&#9421;|&#65336;|&#7818;|&#7820;|[\u0058\u24CD\uFF38\u1E8A\u1E8C])/g
}, {
  base: "Y",
  letters: /(&#89;|&#9422;|&#65337;|&#7922;|&#221;|&#374;|&#7928;|&#562;|&#7822;|&#376;|&#7926;|&#7924;|&#435;|&#590;|&#7934;|[\u0059\u24CE\uFF39\u1EF2\u00DD\u0176\u1EF8\u0232\u1E8E\u0178\u1EF6\u1EF4\u01B3\u024E\u1EFE])/g
}, {
  base: "Z",
  letters: /(&#90;|&#9423;|&#65338;|&#377;|&#7824;|&#379;|&#381;|&#7826;|&#7828;|&#437;|&#548;|&#11391;|&#11371;|&#42850;|[\u005A\u24CF\uFF3A\u0179\u1E90\u017B\u017D\u1E92\u1E94\u01B5\u0224\u2C7F\u2C6B\uA762])/g
}, {
  base: "a",
  letters: /(&#97;|&#9424;|&#65345;|&#7834;|&#224;|&#225;|&#226;|&#7847;|&#7845;|&#7851;|&#7849;|&#227;|&#257;|&#259;|&#7857;|&#7855;|&#7861;|&#7859;|&#551;|&#481;|&#228;|&#479;|&#7843;|&#229;|&#507;|&#462;|&#513;|&#515;|&#7841;|&#7853;|&#7863;|&#7681;|&#261;|&#11365;|&#592;|[\u0061\u24D0\uFF41\u1E9A\u00E0\u00E1\u00E2\u1EA7\u1EA5\u1EAB\u1EA9\u00E3\u0101\u0103\u1EB1\u1EAF\u1EB5\u1EB3\u0227\u01E1\u00E4\u01DF\u1EA3\u00E5\u01FB\u01CE\u0201\u0203\u1EA1\u1EAD\u1EB7\u1E01\u0105\u2C65\u0250])/g
}, {
  base: "aa",
  letters: /(&#42803;|[\uA733])/g
}, {
  base: "ae",
  letters: /(&#230;|&#509;|&#483;|[\u00E6\u01FD\u01E3])/g
}, {
  base: "ao",
  letters: /(&#42805;|[\uA735])/g
}, {
  base: "au",
  letters: /(&#42807;|[\uA737])/g
}, {
  base: "av",
  letters: /(&#42809;|&#42811;|[\uA739\uA73B])/g
}, {
  base: "ay",
  letters: /(&#42813;|[\uA73D])/g
}, {
  base: "b",
  letters: /(&#98;|&#9425;|&#65346;|&#7683;|&#7685;|&#7687;|&#384;|&#387;|&#595;|[\u0062\u24D1\uFF42\u1E03\u1E05\u1E07\u0180\u0183\u0253])/g
}, {
  base: "c",
  letters: /(&#99;|&#9426;|&#65347;|&#263;|&#265;|&#267;|&#269;|&#231;|&#7689;|&#392;|&#572;|&#42815;|&#8580;|[\u0063\u24D2\uFF43\u0107\u0109\u010B\u010D\u00E7\u1E09\u0188\u023C\uA73F\u2184])/g
}, {
  base: "d",
  letters: /(&#100;|&#9427;|&#65348;|&#7691;|&#271;|&#7693;|&#7697;|&#7699;|&#7695;|&#273;|&#396;|&#598;|&#599;|&#42874;|&#240;|[\u0064\u24D3\uFF44\u1E0B\u010F\u1E0D\u1E11\u1E13\u1E0F\u0111\u018C\u0256\u0257\uA77A\u00F0])/g
}, {
  base: "dz",
  letters: /(&#499;|&#454;|[\u01F3\u01C6])/g
}, {
  base: "e",
  letters: /(&#101;|&#9428;|&#65349;|&#232;|&#233;|&#234;|&#7873;|&#7871;|&#7877;|&#7875;|&#7869;|&#275;|&#7701;|&#7703;|&#277;|&#279;|&#235;|&#7867;|&#283;|&#517;|&#519;|&#7865;|&#7879;|&#553;|&#7709;|&#281;|&#7705;|&#7707;|&#583;|&#603;|&#477;|[\u0065\u24D4\uFF45\u00E8\u00E9\u00EA\u1EC1\u1EBF\u1EC5\u1EC3\u1EBD\u0113\u1E15\u1E17\u0115\u0117\u00EB\u1EBB\u011B\u0205\u0207\u1EB9\u1EC7\u0229\u1E1D\u0119\u1E19\u1E1B\u0247\u025B\u01DD])/g
}, {
  base: "f",
  letters: /(&#102;|&#9429;|&#65350;|&#7711;|&#402;|&#42876;|[\u0066\u24D5\uFF46\u1E1F\u0192\uA77C])/g
}, {
  base: "g",
  letters: /(&#103;|&#9430;|&#65351;|&#501;|&#285;|&#7713;|&#287;|&#289;|&#487;|&#291;|&#485;|&#608;|&#42913;|&#7545;|&#42879;|[\u0067\u24D6\uFF47\u01F5\u011D\u1E21\u011F\u0121\u01E7\u0123\u01E5\u0260\uA7A1\u1D79\uA77F])/g
}, {
  base: "h",
  letters: /(&#104;|&#9431;|&#65352;|&#293;|&#7715;|&#7719;|&#543;|&#7717;|&#7721;|&#7723;|&#7830;|&#295;|&#11368;|&#11382;|&#613;|[\u0068\u24D7\uFF48\u0125\u1E23\u1E27\u021F\u1E25\u1E29\u1E2B\u1E96\u0127\u2C68\u2C76\u0265])/g
}, {
  base: "hv",
  letters: /(&#405;|[\u0195])/g
}, {
  base: "i",
  letters: /(&#105;|&#9432;|&#65353;|&#236;|&#237;|&#238;|&#297;|&#299;|&#301;|&#239;|&#7727;|&#7881;|&#464;|&#521;|&#523;|&#7883;|&#303;|&#7725;|&#616;|&#305;|[\u0069\u24D8\uFF49\u00EC\u00ED\u00EE\u0129\u012B\u012D\u00EF\u1E2F\u1EC9\u01D0\u0209\u020B\u1ECB\u012F\u1E2D\u0268\u0131])/g
}, {
  base: "ij",
  letters: /(&#307;|[\u0133])/g
}, {
  base: "j",
  letters: /(&#106;|&#9433;|&#65354;|&#309;|&#496;|&#585;|[\u006A\u24D9\uFF4A\u0135\u01F0\u0249])/g
}, {
  base: "k",
  letters: /(&#107;|&#9434;|&#65355;|&#7729;|&#489;|&#7731;|&#311;|&#7733;|&#409;|&#11370;|&#42817;|&#42819;|&#42821;|&#42915;|[\u006B\u24DA\uFF4B\u1E31\u01E9\u1E33\u0137\u1E35\u0199\u2C6A\uA741\uA743\uA745\uA7A3])/g
}, {
  base: "l",
  letters: /(&#108;|&#9435;|&#65356;|&#320;|&#314;|&#318;|&#7735;|&#7737;|&#316;|&#7741;|&#7739;|&#322;|&#410;|&#619;|&#11361;|&#42825;|&#42881;|&#42823;|[\u006C\u24DB\uFF4C\u0140\u013A\u013E\u1E37\u1E39\u013C\u1E3D\u1E3B\u0142\u019A\u026B\u2C61\uA749\uA781\uA747])/g
}, {
  base: "lj",
  letters: /(&#457;|[\u01C9])/g
}, {
  base: "m",
  letters: /(&#109;|&#9436;|&#65357;|&#7743;|&#7745;|&#7747;|&#625;|&#623;|[\u006D\u24DC\uFF4D\u1E3F\u1E41\u1E43\u0271\u026F])/g
}, {
  base: "n",
  letters: /(&#110;|&#9437;|&#65358;|&#505;|&#324;|&#241;|&#7749;|&#328;|&#7751;|&#326;|&#7755;|&#7753;|&#414;|&#626;|&#329;|&#42897;|&#42917;|&#331;|[\u006E\u24DD\uFF4E\u01F9\u0144\u00F1\u1E45\u0148\u1E47\u0146\u1E4B\u1E49\u019E\u0272\u0149\uA791\uA7A5\u014B])/g
}, {
  base: "nj",
  letters: /(&#460;|[\u01CC])/g
}, {
  base: "o",
  letters: /(&#111;|&#9438;|&#65359;|&#242;|&#243;|&#244;|&#7891;|&#7889;|&#7895;|&#7893;|&#245;|&#7757;|&#557;|&#7759;|&#333;|&#7761;|&#7763;|&#335;|&#559;|&#561;|&#246;|&#555;|&#7887;|&#337;|&#466;|&#525;|&#527;|&#417;|&#7901;|&#7899;|&#7905;|&#7903;|&#7907;|&#7885;|&#7897;|&#491;|&#493;|&#248;|&#511;|&#596;|&#42827;|&#42829;|&#629;|[\u006F\u24DE\uFF4F\u00F2\u00F3\u00F4\u1ED3\u1ED1\u1ED7\u1ED5\u00F5\u1E4D\u022D\u1E4F\u014D\u1E51\u1E53\u014F\u022F\u0231\u00F6\u022B\u1ECF\u0151\u01D2\u020D\u020F\u01A1\u1EDD\u1EDB\u1EE1\u1EDF\u1EE3\u1ECD\u1ED9\u01EB\u01ED\u00F8\u01FF\u0254\uA74B\uA74D\u0275])/g
}, {
  base: "oe",
  letters: /(&#339;|[\u0153])/g
}, {
  base: "oi",
  letters: /(&#419;|[\u01A3])/g
}, {
  base: "ou",
  letters: /(&#547;|[\u0223])/g
}, {
  base: "oo",
  letters: /(&#42831;|[\uA74F])/g
}, {
  base: "p",
  letters: /(&#112;|&#9439;|&#65360;|&#7765;|&#7767;|&#421;|&#7549;|&#42833;|&#42835;|&#42837;|[\u0070\u24DF\uFF50\u1E55\u1E57\u01A5\u1D7D\uA751\uA753\uA755])/g
}, {
  base: "q",
  letters: /(&#113;|&#9440;|&#65361;|&#587;|&#42839;|&#42841;|[\u0071\u24E0\uFF51\u024B\uA757\uA759])/g
}, {
  base: "r",
  letters: /(&#114;|&#9441;|&#65362;|&#341;|&#7769;|&#345;|&#529;|&#531;|&#7771;|&#7773;|&#343;|&#7775;|&#589;|&#637;|&#42843;|&#42919;|&#42883;|[\u0072\u24E1\uFF52\u0155\u1E59\u0159\u0211\u0213\u1E5B\u1E5D\u0157\u1E5F\u024D\u027D\uA75B\uA7A7\uA783])/g
}, {
  base: "s",
  letters: /(&#115;|&#9442;|&#65363;|&#347;|&#7781;|&#349;|&#7777;|&#353;|&#7783;|&#7779;|&#7785;|&#537;|&#351;|&#575;|&#42921;|&#42885;|&#7835;|&#383;|[\u0073\u24E2\uFF53\u015B\u1E65\u015D\u1E61\u0161\u1E67\u1E63\u1E69\u0219\u015F\u023F\uA7A9\uA785\u1E9B\u017F])/g
}, {
  base: "ss",
  letters: /(&#223;|[\u00DF])/g
}, {
  base: "t",
  letters: /(&#116;|&#9443;|&#65364;|&#7787;|&#7831;|&#357;|&#7789;|&#539;|&#355;|&#7793;|&#7791;|&#359;|&#429;|&#648;|&#11366;|&#42887;|[\u0074\u24E3\uFF54\u1E6B\u1E97\u0165\u1E6D\u021B\u0163\u1E71\u1E6F\u0167\u01AD\u0288\u2C66\uA787])/g
}, {
  base: "th",
  letters: /(&#254;|[\u00FE])/g
}, {
  base: "tz",
  letters: /(&#42793;|[\uA729])/g
}, {
  base: "u",
  letters: /(&#117;|&#9444;|&#65365;|&#249;|&#250;|&#251;|&#361;|&#7801;|&#363;|&#7803;|&#365;|&#252;|&#476;|&#472;|&#470;|&#474;|&#7911;|&#367;|&#369;|&#468;|&#533;|&#535;|&#432;|&#7915;|&#7913;|&#7919;|&#7917;|&#7921;|&#7909;|&#7795;|&#371;|&#7799;|&#7797;|&#649;|[\u0075\u24E4\uFF55\u00F9\u00FA\u00FB\u0169\u1E79\u016B\u1E7B\u016D\u00FC\u01DC\u01D8\u01D6\u01DA\u1EE7\u016F\u0171\u01D4\u0215\u0217\u01B0\u1EEB\u1EE9\u1EEF\u1EED\u1EF1\u1EE5\u1E73\u0173\u1E77\u1E75\u0289])/g
}, {
  base: "v",
  letters: /(&#118;|&#9445;|&#65366;|&#7805;|&#7807;|&#651;|&#42847;|&#652;|[\u0076\u24E5\uFF56\u1E7D\u1E7F\u028B\uA75F\u028C])/g
}, {
  base: "vy",
  letters: /(&#42849;|[\uA761])/g
}, {
  base: "w",
  letters: /(&#119;|&#9446;|&#65367;|&#7809;|&#7811;|&#373;|&#7815;|&#7813;|&#7832;|&#7817;|&#11379;|[\u0077\u24E6\uFF57\u1E81\u1E83\u0175\u1E87\u1E85\u1E98\u1E89\u2C73])/g
}, {
  base: "x",
  letters: /(&#120;|&#9447;|&#65368;|&#7819;|&#7821;|[\u0078\u24E7\uFF58\u1E8B\u1E8D])/g
}, {
  base: "y",
  letters: /(&#121;|&#9448;|&#65369;|&#7923;|&#253;|&#375;|&#7929;|&#563;|&#7823;|&#255;|&#7927;|&#7833;|&#7925;|&#436;|&#591;|&#7935;|[\u0079\u24E8\uFF59\u1EF3\u00FD\u0177\u1EF9\u0233\u1E8F\u00FF\u1EF7\u1E99\u1EF5\u01B4\u024F\u1EFF])/g
}, {
  base: "z",
  letters: /(&#122;|&#9449;|&#65370;|&#378;|&#7825;|&#380;|&#382;|&#7827;|&#7829;|&#438;|&#549;|&#576;|&#11372;|&#42851;|[\u007A\u24E9\uFF5A\u017A\u1E91\u017C\u017E\u1E93\u1E95\u01B6\u0225\u0240\u2C6C\uA763])/g
}], Bdt = function(e) {
  var n = e;
  return Vdt.forEach(function(r) {
    n = n.replace(r.letters, r.base);
  }), n;
}, nB = function(e) {
  return Bdt(e).toLowerCase();
}, qne = function(e, n, r) {
  return r ? nB(e).indexOf(nB(n)) : e.toLowerCase().indexOf(n.toLowerCase());
}, Hdt = function() {
  return !!document.documentMode;
}, S6 = function(e) {
  return typeof e == "number";
}, Wdt = function(e) {
  return e === Object(e) ? Object.keys(e) : [];
}, jdt = function(e) {
  for (var n, r = arguments.length, i = new Array(r > 1 ? r - 1 : 0), o = 1; o < r; o++)
    i[o - 1] = arguments[o];
  var a = (n = []).concat.apply(n, i);
  return Object.keys(e).reduce(function(s, u) {
    return e.hasOwnProperty(u) && !a.includes(u) && e[u] !== void 0 && (s[u] = e[u]), s;
  }, {});
}, zdt = ["style", "className", "classNames"];
function rB(t, e) {
  var n = Object.keys(t);
  if (Object.getOwnPropertySymbols) {
    var r = Object.getOwnPropertySymbols(t);
    e && (r = r.filter(function(i) {
      return Object.getOwnPropertyDescriptor(t, i).enumerable;
    })), n.push.apply(n, r);
  }
  return n;
}
function iB(t) {
  for (var e = 1; e < arguments.length; e++) {
    var n = arguments[e] != null ? arguments[e] : {};
    e % 2 ? rB(Object(n), !0).forEach(function(r) {
      _n(t, r, n[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(t, Object.getOwnPropertyDescriptors(n)) : rB(Object(n)).forEach(function(r) {
      Object.defineProperty(t, r, Object.getOwnPropertyDescriptor(n, r));
    });
  }
  return t;
}
function Kw(t, e) {
  var n = function(i) {
    var o = function(u) {
      var l = u.style, c = u.className, d = u.classNames, f = gdt(u, zdt), h = e ? e(f) : void 0, p = V8(t, {
        style: l,
        className: c,
        classNames: d
      }, h);
      return /* @__PURE__ */ O.createElement(i, Ga({}, f, {
        style: p
      }));
    }, a = i.displayName || i.name || "Component";
    return o.displayName = "defaultStyle(".concat(a, ")"), /* @__PURE__ */ O.forwardRef(function(s, u) {
      return o(iB(iB({}, s), {}, {
        ref: u
      }));
    });
  };
  return n;
}
var Gdt = function(e, n) {
  return e.hasOwnProperty(n) ? e[n]++ : e[n] = 0, n + "_" + e[n];
};
function Qne(t) {
  var e = t.selectionStart, n = t.selectionEnd, r = t.value, i = r === void 0 ? "" : r, o = t.onCaretPositionChange, a = t.containerRef, s = t.children;
  t.singleLine;
  var u = t.style, l = Le({
    left: void 0,
    top: void 0
  }), c = j2(l, 2), d = c[0], f = c[1], h = Le(), p = j2(h, 2), v = p[0], m = p[1];
  Re(function() {
    b();
  });
  var b = function() {
    if (v) {
      var V = v.offsetLeft, $ = v.offsetTop;
      if (!(d.left === V && d.top === $)) {
        var F = {
          left: V,
          top: $
        };
        f(F), o(F);
      }
    }
  }, y = Wl(s), w;
  n === e && (w = ro(i, y, e, "START"));
  var S = [], E = {}, I = S, _ = 0, A = function(V, $, F) {
    if (S6(w) && w >= $ && w <= $ + V.length) {
      var M = w - $;
      I.push(N(V.substring(0, M), _)), I = [N(V.substring(M), _)];
    } else
      I.push(N(V, _));
    _++;
  }, P = function(V, $, F, M, B, X, L) {
    var j = Gdt(E, M);
    I.push(k(M, B, X, j));
  }, N = function(V, $) {
    return /* @__PURE__ */ O.createElement("span", Ga({}, u("substring"), {
      key: $
    }), V);
  }, k = function(V, $, F, M) {
    var B = {
      id: V,
      display: $,
      key: M
    }, X = za.toArray(s)[F];
    return /* @__PURE__ */ O.cloneElement(X, B);
  }, D = function(V) {
    return /* @__PURE__ */ O.createElement("span", Ga({}, u("caret"), {
      ref: m,
      key: "caret"
    }), V);
  };
  return Rv(i, y, P, A), I.push(" "), I !== S && S.push(D(I)), /* @__PURE__ */ O.createElement("div", Ga({}, u, {
    ref: a
  }), S);
}
Qne.propTypes = {
  selectionStart: le.number,
  selectionEnd: le.number,
  value: le.string.isRequired,
  onCaretPositionChange: le.func.isRequired,
  containerRef: le.oneOfType([le.func, le.shape({
    current: typeof Element > "u" ? le.any : le.instanceOf(Element)
  })]),
  children: le.oneOfType([le.element, le.arrayOf(le.element)]).isRequired
};
var Udt = Kw({
  position: "relative",
  boxSizing: "border-box",
  width: "100%",
  color: "transparent",
  overflow: "hidden",
  whiteSpace: "pre-wrap",
  wordWrap: "break-word",
  border: "1px solid transparent",
  textAlign: "start",
  "&singleLine": {
    whiteSpace: "pre",
    wordWrap: null
  },
  substring: {
    visibility: "hidden"
  }
}, function(t) {
  return {
    "&singleLine": t.singleLine
  };
}), Xdt = Udt(Qne);
function ere(t) {
  var e = t.id, n = t.focused, r = t.ignoreAccents, i = t.index, o = t.onClick, a = t.onMouseEnter, s = t.query, u = t.renderSuggestion, l = t.suggestion, c = t.style;
  t.className, t.classNames;
  var d = {
    onClick: o,
    onMouseEnter: a
  }, f = function() {
    var m = h(), b = p(m);
    return u ? u(l, s, b, i, n) : b;
  }, h = function() {
    if (typeof l == "string")
      return l;
    var m = l.id, b = l.display;
    return m === void 0 || !b ? m : b;
  }, p = function(m) {
    var b = qne(m, s, r);
    return b === -1 ? /* @__PURE__ */ O.createElement("span", c("display"), m) : /* @__PURE__ */ O.createElement("span", c("display"), m.substring(0, b), /* @__PURE__ */ O.createElement("b", c("highlight"), m.substring(b, b + s.length)), m.substring(b + s.length));
  };
  return /* @__PURE__ */ O.createElement("li", Ga({
    id: e,
    role: "option",
    "aria-selected": n
  }, d, c), f());
}
ere.propTypes = {
  id: le.string.isRequired,
  query: le.string.isRequired,
  index: le.number.isRequired,
  ignoreAccents: le.bool,
  suggestion: le.oneOfType([le.string, le.shape({
    id: le.oneOfType([le.string, le.number]).isRequired,
    display: le.string
  })]).isRequired,
  renderSuggestion: le.func,
  focused: le.bool
};
var Ydt = Kw({
  cursor: "pointer"
}, function(t) {
  return {
    "&focused": t.focused
  };
}), Zdt = Ydt(ere);
function Jdt(t) {
  var e = t.style, n = t.className, r = t.classNames, i = V8(Kdt, {
    style: e,
    className: n,
    classNames: r
  }), o = i("spinner");
  return /* @__PURE__ */ O.createElement("div", i, /* @__PURE__ */ O.createElement("div", o, /* @__PURE__ */ O.createElement("div", o(["element", "element1"])), /* @__PURE__ */ O.createElement("div", o(["element", "element2"])), /* @__PURE__ */ O.createElement("div", o(["element", "element3"])), /* @__PURE__ */ O.createElement("div", o(["element", "element4"])), /* @__PURE__ */ O.createElement("div", o(["element", "element5"]))));
}
var Kdt = {};
function tre(t) {
  var e = t.id, n = t.suggestions, r = n === void 0 ? {} : n, i = t.a11ySuggestionsListLabel, o = t.focusIndex, a = t.position, s = t.left, u = t.right, l = t.top, c = t.scrollFocusedIntoView, d = t.isLoading, f = t.isOpened, h = t.onSelect, p = h === void 0 ? function() {
    return null;
  } : h, v = t.ignoreAccents, m = t.containerRef, b = t.children, y = t.style, w = t.customSuggestionsContainer, S = t.onMouseDown, E = t.onMouseEnter, I = Le(void 0), _ = j2(I, 2), A = _[0], P = _[1];
  Re(function() {
    if (!(!A || A.offsetHeight >= A.scrollHeight || !c)) {
      var F = A.scrollTop, M = A.children[o].getBoundingClientRect(), B = M.top, X = M.bottom, L = A.getBoundingClientRect(), j = L.top;
      B = B - j + F, X = X - j + F, B < F ? A.scrollTop = B : X > A.offsetHeight && (A.scrollTop = X - A.offsetHeight);
    }
  }, [o, c, A]);
  var N = function() {
    var M = /* @__PURE__ */ O.createElement("ul", Ga({
      ref: P,
      id: e,
      role: "listbox",
      "aria-label": i
    }, y("list")), Object.values(r).reduce(function(B, X) {
      var L = X.results, j = X.queryInfo;
      return [].concat(H2(B), H2(L.map(function(K, W) {
        return k(K, j, B.length + W);
      })));
    }, []));
    return w ? w(M) : M;
  }, k = function(M, B, X) {
    var L = X === o, j = B.childIndex, K = B.query, W = za.toArray(b)[j].props.renderSuggestion;
    return /* @__PURE__ */ O.createElement(Zdt, {
      style: y("item"),
      key: "".concat(j, "-").concat($(M)),
      id: Kne(e, X),
      query: K,
      index: X,
      ignoreAccents: v,
      renderSuggestion: W,
      suggestion: M,
      focused: L,
      onClick: function() {
        return V(M, B);
      },
      onMouseEnter: function() {
        return R(X);
      }
    });
  }, D = function() {
    if (d)
      return /* @__PURE__ */ O.createElement(Jdt, {
        style: y("loadingIndicator")
      });
  }, R = function(M, B) {
    E && E(M);
  }, V = function(M, B) {
    p(M, B);
  }, $ = function(M) {
    return typeof M == "string" ? M : M.id;
  };
  return f ? /* @__PURE__ */ O.createElement("div", Ga({}, Pdt({
    position: a || "absolute",
    left: s,
    right: u,
    top: l
  }, y), {
    onMouseDown: S,
    ref: m
  }), N(), D()) : null;
}
tre.propTypes = {
  id: le.string.isRequired,
  suggestions: le.object.isRequired,
  a11ySuggestionsListLabel: le.string,
  focusIndex: le.number,
  position: le.string,
  left: le.number,
  right: le.number,
  top: le.number,
  scrollFocusedIntoView: le.bool,
  isLoading: le.bool,
  isOpened: le.bool.isRequired,
  onSelect: le.func,
  ignoreAccents: le.bool,
  customSuggestionsContainer: le.func,
  containerRef: le.oneOfType([le.func, le.shape({
    current: typeof Element > "u" ? le.any : le.instanceOf(Element)
  })])
};
var qdt = Kw({
  zIndex: 1,
  backgroundColor: "white",
  marginTop: 14,
  minWidth: 100,
  list: {
    margin: 0,
    padding: 0,
    listStyleType: "none"
  }
}), Qdt = qdt(tre);
function oB(t, e) {
  var n = Object.keys(t);
  if (Object.getOwnPropertySymbols) {
    var r = Object.getOwnPropertySymbols(t);
    e && (r = r.filter(function(i) {
      return Object.getOwnPropertyDescriptor(t, i).enumerable;
    })), n.push.apply(n, r);
  }
  return n;
}
function fs(t) {
  for (var e = 1; e < arguments.length; e++) {
    var n = arguments[e] != null ? arguments[e] : {};
    e % 2 ? oB(Object(n), !0).forEach(function(r) {
      _n(t, r, n[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(t, Object.getOwnPropertyDescriptors(n)) : oB(Object(n)).forEach(function(r) {
      Object.defineProperty(t, r, Object.getOwnPropertyDescriptor(n, r));
    });
  }
  return t;
}
function eft(t) {
  var e = tft();
  return function() {
    var r = W2(t), i;
    if (e) {
      var o = W2(this).constructor;
      i = Reflect.construct(r, arguments, o);
    } else
      i = r.apply(this, arguments);
    return udt(this, i);
  };
}
function tft() {
  if (typeof Reflect > "u" || !Reflect.construct || Reflect.construct.sham)
    return !1;
  if (typeof Proxy == "function")
    return !0;
  try {
    return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    })), !0;
  } catch {
    return !1;
  }
}
var nft = function(e) {
  var n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
  if (e instanceof RegExp)
    return e;
  var r = n.allowSpaceInQuery, i = Vy(e);
  return new RegExp("(?:^|\\s)(".concat(i, "([^").concat(r ? "" : "\\s").concat(i, "]*))$"));
}, rft = function(e, n) {
  return e instanceof Array ? function(r, i) {
    for (var o = [], a = 0, s = e.length; a < s; ++a) {
      var u = e[a].display || e[a].id;
      qne(u, r, n) >= 0 && o.push(e[a]);
    }
    return o;
  } : e;
}, Zf = {
  TAB: 9,
  RETURN: 13,
  ESC: 27,
  UP: 38,
  DOWN: 40
}, Yb = !1, nre = {
  /**
   * If set to `true` a regular text input element will be rendered
   * instead of a textarea
   */
  singleLine: le.bool,
  allowSpaceInQuery: le.bool,
  allowSuggestionsAboveCursor: le.bool,
  forceSuggestionsAboveCursor: le.bool,
  ignoreAccents: le.bool,
  a11ySuggestionsListLabel: le.string,
  value: le.string,
  onKeyDown: le.func,
  customSuggestionsContainer: le.func,
  onSelect: le.func,
  onBlur: le.func,
  onChange: le.func,
  suggestionsPortalHost: typeof Element > "u" ? le.any : le.PropTypes.instanceOf(Element),
  inputRef: le.oneOfType([le.func, le.shape({
    current: typeof Element > "u" ? le.any : le.instanceOf(Element)
  })]),
  children: le.oneOfType([le.element, le.arrayOf(le.element)]).isRequired
}, B8 = /* @__PURE__ */ function(t) {
  sdt(n, t);
  var e = eft(n);
  function n(r) {
    var i;
    return odt(this, n), i = e.call(this, r), _n(An(i), "setContainerElement", function(o) {
      i.containerElement = o;
    }), _n(An(i), "getInputProps", function() {
      var o = i.props, a = o.readOnly, s = o.disabled, u = o.style, l = jdt(
        i.props,
        ["style", "classNames", "className"],
        // substyle props
        Wdt(nre)
      );
      return fs(fs(fs(fs({}, l), u("input")), {}, {
        value: i.getPlainText(),
        onScroll: i.updateHighlighterScroll
      }, !a && !s && {
        onChange: i.handleChange,
        onSelect: i.handleSelect,
        onKeyDown: i.handleKeyDown,
        onBlur: i.handleBlur,
        onCompositionStart: i.handleCompositionStart,
        onCompositionEnd: i.handleCompositionEnd
      }), i.isOpened() && {
        role: "combobox",
        "aria-controls": i.uuidSuggestionsOverlay,
        "aria-expanded": !0,
        "aria-autocomplete": "list",
        "aria-haspopup": "listbox",
        "aria-activedescendant": Kne(i.uuidSuggestionsOverlay, i.state.focusIndex)
      });
    }), _n(An(i), "renderControl", function() {
      var o = i.props, a = o.singleLine, s = o.style, u = i.getInputProps();
      return /* @__PURE__ */ O.createElement("div", s("control"), i.renderHighlighter(), a ? i.renderInput(u) : i.renderTextarea(u));
    }), _n(An(i), "renderInput", function(o) {
      return /* @__PURE__ */ O.createElement("input", Ga({
        type: "text",
        ref: i.setInputRef
      }, o));
    }), _n(An(i), "renderTextarea", function(o) {
      return /* @__PURE__ */ O.createElement("textarea", Ga({
        ref: i.setInputRef
      }, o));
    }), _n(An(i), "setInputRef", function(o) {
      i.inputElement = o;
      var a = i.props.inputRef;
      typeof a == "function" ? a(o) : a && (a.current = o);
    }), _n(An(i), "setSuggestionsElement", function(o) {
      i.suggestionsElement = o;
    }), _n(An(i), "renderSuggestionsOverlay", function() {
      if (!S6(i.state.selectionStart))
        return null;
      var o = i.state.suggestionsPosition, a = o.position, s = o.left, u = o.top, l = o.right, c = /* @__PURE__ */ O.createElement(Qdt, {
        id: i.uuidSuggestionsOverlay,
        style: i.props.style("suggestions"),
        position: a,
        left: s,
        top: u,
        right: l,
        focusIndex: i.state.focusIndex,
        scrollFocusedIntoView: i.state.scrollFocusedIntoView,
        containerRef: i.setSuggestionsElement,
        suggestions: i.state.suggestions,
        customSuggestionsContainer: i.props.customSuggestionsContainer,
        onSelect: i.addMention,
        onMouseDown: i.handleSuggestionsMouseDown,
        onMouseEnter: i.handleSuggestionsMouseEnter,
        isLoading: i.isLoading(),
        isOpened: i.isOpened(),
        ignoreAccents: i.props.ignoreAccents,
        a11ySuggestionsListLabel: i.props.a11ySuggestionsListLabel
      }, i.props.children);
      return i.props.suggestionsPortalHost ? /* @__PURE__ */ ks.createPortal(c, i.props.suggestionsPortalHost) : c;
    }), _n(An(i), "renderHighlighter", function() {
      var o = i.state, a = o.selectionStart, s = o.selectionEnd, u = i.props, l = u.singleLine, c = u.children, d = u.value, f = u.style;
      return /* @__PURE__ */ O.createElement(Xdt, {
        containerRef: i.setHighlighterElement,
        style: f("highlighter"),
        value: d,
        singleLine: l,
        selectionStart: a,
        selectionEnd: s,
        onCaretPositionChange: i.handleCaretPositionChange
      }, c);
    }), _n(An(i), "setHighlighterElement", function(o) {
      i.highlighterElement = o;
    }), _n(An(i), "handleCaretPositionChange", function(o) {
      i.setState({
        caretPosition: o
      });
    }), _n(An(i), "getPlainText", function() {
      return sd(i.props.value || "", Wl(i.props.children));
    }), _n(An(i), "executeOnChange", function(o) {
      for (var a = arguments.length, s = new Array(a > 1 ? a - 1 : 0), u = 1; u < a; u++)
        s[u - 1] = arguments[u];
      if (i.props.onChange) {
        var l;
        return (l = i.props).onChange.apply(l, [o].concat(s));
      }
      if (i.props.valueLink) {
        var c;
        return (c = i.props.valueLink).requestChange.apply(c, [o.target.value].concat(s));
      }
    }), _n(An(i), "handleChange", function(o) {
      if (Yb = !1, Hdt()) {
        var a = document.activeElement && document.activeElement.contentDocument || document;
        if (a.activeElement !== o.target)
          return;
      }
      var s = i.props.value || "", u = Wl(i.props.children), l = o.target.value, c = i.state.selectionStart;
      c == null && (c = o.target.selectionStart);
      var d = i.state.selectionEnd;
      d == null && (d = o.target.selectionEnd);
      var f = $dt(s, l, {
        selectionStartBefore: c,
        selectionEndBefore: d,
        selectionEndAfter: o.target.selectionEnd
      }, u);
      l = sd(f, u);
      var h = o.target.selectionStart, p = o.target.selectionEnd, v = !1, m = tB(s, u, h);
      m !== void 0 && i.state.selectionEnd > m && (h = m + (o.nativeEvent.data ? o.nativeEvent.data.length : 0), p = h, v = !0), i.setState({
        selectionStart: h,
        selectionEnd: p,
        setSelectionAfterMentionChange: v
      });
      var b = s0(f, u);
      o.nativeEvent.isComposing && h === p && i.updateMentionsQueries(i.inputElement.value, h);
      var y = {
        target: {
          value: f
        }
      };
      i.executeOnChange(y, f, l, b);
    }), _n(An(i), "handleSelect", function(o) {
      if (i.setState({
        selectionStart: o.target.selectionStart,
        selectionEnd: o.target.selectionEnd
      }), !Yb) {
        var a = i.inputElement;
        o.target.selectionStart === o.target.selectionEnd ? i.updateMentionsQueries(a.value, o.target.selectionStart) : i.clearSuggestions(), i.updateHighlighterScroll(), i.props.onSelect(o);
      }
    }), _n(An(i), "handleKeyDown", function(o) {
      var a = Xb(i.state.suggestions);
      if (a === 0 || !i.suggestionsElement) {
        i.props.onKeyDown(o);
        return;
      }
      switch (Object.values(Zf).indexOf(o.keyCode) >= 0 && (o.preventDefault(), o.stopPropagation()), o.keyCode) {
        case Zf.ESC: {
          i.clearSuggestions();
          return;
        }
        case Zf.DOWN: {
          i.shiftFocus(1);
          return;
        }
        case Zf.UP: {
          i.shiftFocus(-1);
          return;
        }
        case Zf.RETURN: {
          i.selectFocused();
          return;
        }
        case Zf.TAB: {
          i.selectFocused();
          return;
        }
        default:
          return;
      }
    }), _n(An(i), "shiftFocus", function(o) {
      var a = Xb(i.state.suggestions);
      i.setState({
        focusIndex: (a + i.state.focusIndex + o) % a,
        scrollFocusedIntoView: !0
      });
    }), _n(An(i), "selectFocused", function() {
      var o = i.state, a = o.suggestions, s = o.focusIndex, u = Object.values(a).reduce(function(d, f) {
        var h = f.results, p = f.queryInfo;
        return [].concat(H2(d), H2(h.map(function(v) {
          return {
            result: v,
            queryInfo: p
          };
        })));
      }, [])[s], l = u.result, c = u.queryInfo;
      i.addMention(l, c), i.setState({
        focusIndex: 0
      });
    }), _n(An(i), "handleBlur", function(o) {
      var a = i._suggestionsMouseDown;
      i._suggestionsMouseDown = !1, a || i.setState({
        selectionStart: null,
        selectionEnd: null
      }), window.setTimeout(function() {
        i.updateHighlighterScroll();
      }, 1), i.props.onBlur(o, a);
    }), _n(An(i), "handleSuggestionsMouseDown", function(o) {
      i._suggestionsMouseDown = !0;
    }), _n(An(i), "handleSuggestionsMouseEnter", function(o) {
      i.setState({
        focusIndex: o,
        scrollFocusedIntoView: !1
      });
    }), _n(An(i), "updateSuggestionsPosition", function() {
      var o = i.state.caretPosition, a = i.props, s = a.suggestionsPortalHost, u = a.allowSuggestionsAboveCursor, l = a.forceSuggestionsAboveCursor;
      if (!(!o || !i.suggestionsElement)) {
        var c = i.suggestionsElement, d = i.highlighterElement, f = d.getBoundingClientRect(), h = L5(d, "font-size"), p = {
          left: f.left + o.left,
          top: f.top + o.top + h
        }, v = Math.max(document.documentElement.clientHeight, window.innerHeight || 0);
        if (c) {
          var m = {};
          if (s) {
            m.position = "fixed";
            var b = p.left, y = p.top;
            b -= L5(c, "margin-left"), y -= L5(c, "margin-top"), b -= d.scrollLeft, y -= d.scrollTop;
            var w = Math.max(document.documentElement.clientWidth, window.innerWidth || 0);
            b + c.offsetWidth > w ? m.left = Math.max(0, w - c.offsetWidth) : m.left = b, u && y + c.offsetHeight > v && c.offsetHeight < y - h || l ? m.top = Math.max(0, y - c.offsetHeight - h) : m.top = y;
          } else {
            var S = o.left - d.scrollLeft, E = o.top - d.scrollTop;
            S + c.offsetWidth > i.containerElement.offsetWidth ? m.right = 0 : m.left = S, u && p.top - d.scrollTop + c.offsetHeight > v && c.offsetHeight < f.top - h - d.scrollTop || l ? m.top = E - c.offsetHeight - h : m.top = E;
          }
          m.left === i.state.suggestionsPosition.left && m.top === i.state.suggestionsPosition.top && m.position === i.state.suggestionsPosition.position || i.setState({
            suggestionsPosition: m
          });
        }
      }
    }), _n(An(i), "updateHighlighterScroll", function() {
      var o = i.inputElement, a = i.highlighterElement;
      !o || !a || (a.scrollLeft = o.scrollLeft, a.scrollTop = o.scrollTop, a.height = o.height);
    }), _n(An(i), "handleCompositionStart", function() {
      Yb = !0;
    }), _n(An(i), "handleCompositionEnd", function() {
      Yb = !1;
    }), _n(An(i), "setSelection", function(o, a) {
      if (!(o === null || a === null)) {
        var s = i.inputElement;
        if (s.setSelectionRange)
          s.setSelectionRange(o, a);
        else if (s.createTextRange) {
          var u = s.createTextRange();
          u.collapse(!0), u.moveEnd("character", a), u.moveStart("character", o), u.select();
        }
      }
    }), _n(An(i), "updateMentionsQueries", function(o, a) {
      i._queryId++, i.suggestions = {}, i.setState({
        suggestions: {}
      });
      var s = i.props.value || "", u = i.props.children, l = Wl(u), c = ro(s, l, a, "NULL");
      if (c !== null) {
        var d = Ddt(s.substring(0, c), l), f = o.substring(d, a);
        O.Children.forEach(u, function(h, p) {
          if (h) {
            var v = nft(h.props.trigger, i.props), m = f.match(v);
            if (m) {
              var b = d + f.indexOf(m[1], m.index);
              i.queryData(m[2], p, b, b + m[1].length, o);
            }
          }
        });
      }
    }), _n(An(i), "clearSuggestions", function() {
      i._queryId++, i.suggestions = {}, i.setState({
        suggestions: {},
        focusIndex: 0
      });
    }), _n(An(i), "queryData", function(o, a, s, u, l) {
      var c = i.props, d = c.children, f = c.ignoreAccents, h = za.toArray(d)[a], p = rft(h.props.data, f), v = p(o, i.updateSuggestions.bind(null, i._queryId, a, o, s, u, l));
      v instanceof Array && i.updateSuggestions(i._queryId, a, o, s, u, l, v);
    }), _n(An(i), "updateSuggestions", function(o, a, s, u, l, c, d) {
      if (o === i._queryId) {
        i.suggestions = fs(fs({}, i.suggestions), {}, _n({}, a, {
          queryInfo: {
            childIndex: a,
            query: s,
            querySequenceStart: u,
            querySequenceEnd: l,
            plainTextValue: c
          },
          results: d
        }));
        var f = i.state.focusIndex, h = Xb(i.suggestions);
        i.setState({
          suggestions: i.suggestions,
          focusIndex: f >= h ? Math.max(h - 1, 0) : f
        });
      }
    }), _n(An(i), "addMention", function(o, a) {
      var s = o.id, u = o.display, l = a.childIndex, c = a.querySequenceStart, d = a.querySequenceEnd, f = a.plainTextValue, h = i.props.value || "", p = Wl(i.props.children), v = za.toArray(i.props.children)[l], m = v.props, b = m.markup, y = m.displayTransform, w = m.appendSpaceOnAdd, S = m.onAdd, E = ro(h, p, c, "START"), I = E + d - c, _ = Ldt(b, s, u);
      w && (_ += " ");
      var A = M0(h, E, I, _);
      i.inputElement.focus();
      var P = y(s, u);
      w && (P += " ");
      var N = c + P.length;
      i.setState({
        selectionStart: N,
        selectionEnd: N,
        setSelectionAfterMentionChange: !0
      });
      var k = {
        target: {
          value: A
        }
      }, D = s0(A, p), R = M0(f, c, d, P);
      i.executeOnChange(k, A, R, D), S && S(s, u, E, I), i.clearSuggestions();
    }), _n(An(i), "isLoading", function() {
      var o = !1;
      return O.Children.forEach(i.props.children, function(a) {
        o = o || a && a.props.isLoading;
      }), o;
    }), _n(An(i), "isOpened", function() {
      return S6(i.state.selectionStart) && (Xb(i.state.suggestions) !== 0 || i.isLoading());
    }), _n(An(i), "_queryId", 0), i.suggestions = {}, i.uuidSuggestionsOverlay = Math.random().toString(16).substring(2), i.handleCopy = i.handleCopy.bind(An(i)), i.handleCut = i.handleCut.bind(An(i)), i.handlePaste = i.handlePaste.bind(An(i)), i.state = {
      focusIndex: 0,
      selectionStart: null,
      selectionEnd: null,
      suggestions: {},
      caretPosition: null,
      suggestionsPosition: {},
      setSelectionAfterHandlePaste: !1
    }, i;
  }
  return adt(n, [{
    key: "componentDidMount",
    value: function() {
      document.addEventListener("copy", this.handleCopy), document.addEventListener("cut", this.handleCut), document.addEventListener("paste", this.handlePaste), this.updateSuggestionsPosition();
    }
  }, {
    key: "componentDidUpdate",
    value: function(i, o) {
      o.suggestionsPosition === this.state.suggestionsPosition && this.updateSuggestionsPosition(), this.state.setSelectionAfterMentionChange && (this.setState({
        setSelectionAfterMentionChange: !1
      }), this.setSelection(this.state.selectionStart, this.state.selectionEnd)), this.state.setSelectionAfterHandlePaste && (this.setState({
        setSelectionAfterHandlePaste: !1
      }), this.setSelection(this.state.selectionStart, this.state.selectionEnd));
    }
  }, {
    key: "componentWillUnmount",
    value: function() {
      document.removeEventListener("copy", this.handleCopy), document.removeEventListener("cut", this.handleCut), document.removeEventListener("paste", this.handlePaste);
    }
  }, {
    key: "render",
    value: function() {
      return /* @__PURE__ */ O.createElement("div", Ga({
        ref: this.setContainerElement
      }, this.props.style), this.renderControl(), this.renderSuggestionsOverlay());
    }
  }, {
    key: "handlePaste",
    value: function(i) {
      if (i.target === this.inputElement && this.supportsClipboardActions(i)) {
        i.preventDefault();
        var o = this.state, a = o.selectionStart, s = o.selectionEnd, u = this.props, l = u.value, c = u.children, d = Wl(c), f = ro(l, d, a, "START"), h = ro(l, d, s, "END"), p = i.clipboardData.getData("text/react-mentions"), v = i.clipboardData.getData("text/plain"), m = M0(l, f, h, p || v).replace(/\r/g, ""), b = sd(m, d), y = {
          target: fs(fs({}, i.target), {}, {
            value: m
          })
        };
        this.executeOnChange(y, m, b, s0(m, d));
        var w = tB(l, d, a), S = (w || a) + sd(p || v, d).length;
        this.setState({
          selectionStart: S,
          selectionEnd: S,
          setSelectionAfterHandlePaste: !0
        });
      }
    }
  }, {
    key: "saveSelectionToClipboard",
    value: function(i) {
      var o = this.inputElement.selectionStart, a = this.inputElement.selectionEnd, s = this.props, u = s.children, l = s.value, c = Wl(u), d = ro(l, c, o, "START"), f = ro(l, c, a, "END");
      i.clipboardData.setData("text/plain", i.target.value.slice(o, a)), i.clipboardData.setData("text/react-mentions", l.slice(d, f));
    }
  }, {
    key: "supportsClipboardActions",
    value: function(i) {
      return !!i.clipboardData;
    }
  }, {
    key: "handleCopy",
    value: function(i) {
      i.target === this.inputElement && this.supportsClipboardActions(i) && (i.preventDefault(), this.saveSelectionToClipboard(i));
    }
  }, {
    key: "handleCut",
    value: function(i) {
      if (i.target === this.inputElement && this.supportsClipboardActions(i)) {
        i.preventDefault(), this.saveSelectionToClipboard(i);
        var o = this.state, a = o.selectionStart, s = o.selectionEnd, u = this.props, l = u.children, c = u.value, d = Wl(l), f = ro(c, d, a, "START"), h = ro(c, d, s, "END"), p = [c.slice(0, f), c.slice(h)].join(""), v = sd(p, d), m = {
          target: fs(fs({}, i.target), {}, {
            value: v
          })
        };
        this.executeOnChange(m, p, v, s0(c, d));
      }
    }
    // Handle input element's change event
  }]), n;
}(O.Component);
_n(B8, "propTypes", nre);
_n(B8, "defaultProps", {
  ignoreAccents: !1,
  singleLine: !1,
  allowSuggestionsAboveCursor: !1,
  onKeyDown: function() {
    return null;
  },
  onSelect: function() {
    return null;
  },
  onBlur: function() {
    return null;
  }
});
var L5 = function(e, n) {
  var r = parseFloat(window.getComputedStyle(e, null).getPropertyValue(n));
  return isFinite(r) ? r : 0;
}, ift = typeof navigator < "u" && /iPhone|iPad|iPod/i.test(navigator.userAgent), oft = Kw({
  position: "relative",
  overflowY: "visible",
  input: {
    display: "block",
    width: "100%",
    position: "absolute",
    margin: 0,
    top: 0,
    left: 0,
    boxSizing: "border-box",
    backgroundColor: "transparent",
    fontFamily: "inherit",
    fontSize: "inherit",
    letterSpacing: "inherit"
  },
  "&multiLine": {
    input: fs({
      height: "100%",
      bottom: 0,
      overflow: "hidden",
      resize: "none"
    }, ift ? {
      marginTop: 1,
      marginLeft: -3
    } : null)
  }
}, function(t) {
  var e = t.singleLine;
  return {
    "&singleLine": e,
    "&multiLine": !e
  };
}), aft = oft(B8), sft = {
  fontWeight: "inherit"
}, H8 = function(e) {
  var n = e.display, r = e.style, i = e.className, o = e.classNames, a = V8(sft, {
    style: r,
    className: i,
    classNames: o
  });
  return /* @__PURE__ */ O.createElement("strong", a, n);
};
H8.propTypes = {
  /**
   * Called when a new mention is added in the input
   *
   * Example:
   *
   * ```js
   * function(id, display) {
   *   console.log("user " + display + " was mentioned!");
   * }
   * ```
   */
  onAdd: le.func,
  onRemove: le.func,
  renderSuggestion: le.func,
  trigger: le.oneOfType([le.string, le.instanceOf(RegExp)]),
  markup: le.string,
  displayTransform: le.func,
  /**
   * If set to `true` spaces will not interrupt matching suggestions
   */
  allowSpaceInQuery: le.bool,
  isLoading: le.bool
};
H8.defaultProps = {
  trigger: "@",
  markup: "@[__display__](__id__)",
  displayTransform: function(e, n) {
    return n || e;
  },
  onAdd: function() {
    return null;
  },
  onRemove: function() {
    return null;
  },
  renderSuggestion: null,
  isLoading: !1,
  appendSpaceOnAdd: !1
};
const uft = (t) => {
  const {
    value: e,
    onChange: n,
    inputProps: r = {}
  } = t, {
    trigger: i = "@",
    customSuggestionsContainer: o,
    loadOptions: a,
    options: s = []
  } = r, u = r.markup || `${i}[__display__](__id__)`, [l, c] = Le(e), d = (p, v) => {
    c(v), n(v);
  }, f = async function(p, v) {
    const m = await a(p);
    return v(m.map((b) => ({ id: b.id, display: b.display || b.label })));
  }, h = (p) => {
    const v = p.props.children.map((m) => {
      var b;
      return { ...m.props.suggestion, onClick: (b = m.props) == null ? void 0 : b.onClick };
    });
    return o ? o(v) : /* @__PURE__ */ Oe.jsx("div", { className: "ant-form-mentions", children: v.map((m) => /* @__PURE__ */ Oe.jsx("div", { onClick: m.onClick, children: m.display }, m.id)) });
  };
  return /* @__PURE__ */ Oe.jsx(
    aft,
    {
      value: l,
      className: "ant-form-mentions",
      onChange: d,
      customSuggestionsContainer: h,
      children: /* @__PURE__ */ Oe.jsx(
        H8,
        {
          className: "ant-form-mentions__mention",
          trigger: i,
          markup: u,
          data: a ? f : s
        }
      )
    }
  );
}, { Password: lft } = ma, cft = (t) => {
  const {
    options: e,
    style: n = "bullet",
    readOnly: r = !1,
    layout: i = "inline",
    onChange: o,
    value: a,
    ...s
  } = t, u = i === "vertical" && n === "bullet" ? {
    display: "block",
    height: "30px",
    lineHeight: "30px"
  } : {}, l = n === "button" ? YS.Button : YS;
  return /* @__PURE__ */ Oe.jsx(YS.Group, { ...s, value: a, style: { width: "100%" }, onChange: o, children: e.map((c) => /* @__PURE__ */ Oe.jsxs(
    l,
    {
      style: u,
      disabled: c.disabled || r,
      value: c.value,
      children: [
        c.label,
        c.help
      ]
    },
    c.value
  )) });
}, dft = (t) => {
  const { options: e, onSearch: n, ...r } = t;
  return /* @__PURE__ */ Oe.jsx(Pye, { ...r, onSearch: n, options: e });
}, fft = ({ inputProps: t = {}, ...e }) => /* @__PURE__ */ Oe.jsx(qSe, { ...va(e, hl), ...t || {} }), hft = ({ inputProps: t = {}, ...e }) => /* @__PURE__ */ Oe.jsx(aX, { ...va(e, hl), ...t || {} }), pft = ({ inputProps: t = {}, ...e }) => /* @__PURE__ */ Oe.jsx(aSe, { ...va(e, hl), ...t || {} }), gft = ({ inputProps: t = {}, ...e }) => /* @__PURE__ */ Oe.jsx(f3e, { ...va(e, hl), ...t || {} }), mft = ({ inputProps: t = {}, ...e }) => /* @__PURE__ */ Oe.jsx(lft, { ...va(e, hl), ...t || {} }), vft = {
  switch: {
    valuePropName: "checked",
    component: hft
  },
  boolean: {
    component: aVe
  },
  rate: {
    component: fft
  },
  text: {
    component: Rze
  },
  slider: {
    component: gft
  },
  string: {
    component: Tje
  },
  number: {
    component: pft
  },
  select: {
    component: aze
  },
  checkbox: {
    valuePropName: "checked",
    component: pUe
  },
  checkboxes: {
    component: gUe
  },
  radio: {
    component: cft
  },
  autoComplete: {
    component: dft
  },
  date: {
    component: Fze
  },
  time: {
    component: Vze
  },
  list: {
    component: nze
  },
  upload: {
    component: $ze
  },
  decimal: {
    component: tje
  },
  password: {
    component: mft
  },
  datetime: {
    component: eje
  },
  dropdown: {
    component: nje
  },
  daterange: {
    component: qWe
  },
  trix: {
    component: hUe
  },
  search: {
    component: ize
  },
  contenteditable: {
    component: LWe
  },
  color: {
    component: oVe
  },
  file: {
    component: aM
  },
  files: {
    component: aM,
    props: {
      multiple: !0
    }
  },
  transfer: {
    component: Dze
  },
  markdown: {
    component: tdt
  },
  mentions: {
    component: uft
  }
}, z2 = {
  ...vft
}, bft = (t, e) => (z2[t] = e, z2);
var rre = {}, qw = {};
Object.defineProperty(qw, "__esModule", {
  value: !0
});
qw.default = void 0;
var yft = {
  // Options.jsx
  items_per_page: "/ page",
  jump_to: "Go to",
  jump_to_confirm: "confirm",
  page: "Page",
  // Pagination.jsx
  prev_page: "Previous Page",
  next_page: "Next Page",
  prev_5: "Previous 5 Pages",
  next_5: "Next 5 Pages",
  prev_3: "Previous 3 Pages",
  next_3: "Next 3 Pages",
  page_size: "Page Size"
};
qw.default = yft;
var ire = {}, W8 = {};
const j8 = /* @__PURE__ */ LH(T0e);
var Qw = {};
Object.defineProperty(Qw, "__esModule", {
  value: !0
});
Qw.default = void 0;
var xft = {
  locale: "en_GB",
  today: "Today",
  now: "Now",
  backToToday: "Back to today",
  ok: "OK",
  clear: "Clear",
  month: "Month",
  year: "Year",
  timeSelect: "Select time",
  dateSelect: "Select date",
  monthSelect: "Choose a month",
  yearSelect: "Choose a year",
  decadeSelect: "Choose a decade",
  yearFormat: "YYYY",
  dateFormat: "D/M/YYYY",
  dayFormat: "D",
  dateTimeFormat: "D/M/YYYY HH:mm:ss",
  monthBeforeYear: !0,
  previousMonth: "Previous month (PageUp)",
  nextMonth: "Next month (PageDown)",
  previousYear: "Last year (Control + left)",
  nextYear: "Next year (Control + right)",
  previousDecade: "Last decade",
  nextDecade: "Next decade",
  previousCentury: "Last century",
  nextCentury: "Next century"
}, Cft = xft;
Qw.default = Cft;
var z8 = {};
(function(t) {
  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.default = void 0;
  var e = {
    placeholder: "Select time"
  };
  t.default = e;
})(z8);
(function(t) {
  var e = Cu.default;
  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.default = void 0;
  var n = e(j8), r = e(Qw), i = e(z8), o = {
    lang: (0, n.default)({
      placeholder: "Select date",
      yearPlaceholder: "Select year",
      quarterPlaceholder: "Select quarter",
      monthPlaceholder: "Select month",
      weekPlaceholder: "Select week",
      rangePlaceholder: ["Start date", "End date"],
      rangeYearPlaceholder: ["Start year", "End year"],
      rangeQuarterPlaceholder: ["Start quarter", "End quarter"],
      rangeMonthPlaceholder: ["Start month", "End month"],
      rangeWeekPlaceholder: ["Start week", "End week"]
    }, r.default),
    timePickerLocale: (0, n.default)({}, i.default)
  };
  t.default = o;
})(W8);
(function(t) {
  var e = Cu.default;
  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.default = void 0;
  var n = e(W8);
  t.default = n.default;
})(ire);
(function(t) {
  var e = Cu.default;
  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.default = void 0;
  var n = e(qw), r = e(ire), i = e(W8), o = e(z8), a = "${label} is not a valid ${type}", s = {
    locale: "en-gb",
    Pagination: n.default,
    DatePicker: i.default,
    TimePicker: o.default,
    Calendar: r.default,
    global: {
      placeholder: "Please select"
    },
    Table: {
      filterTitle: "Filter menu",
      filterConfirm: "OK",
      filterReset: "Reset",
      filterEmptyText: "No filters",
      filterCheckall: "Select all items",
      filterSearchPlaceholder: "Search in filters",
      emptyText: "No data",
      selectAll: "Select current page",
      selectInvert: "Invert current page",
      selectNone: "Clear all data",
      selectionAll: "Select all data",
      sortTitle: "Sort",
      expand: "Expand row",
      collapse: "Collapse row",
      triggerDesc: "Click to sort descending",
      triggerAsc: "Click to sort ascending",
      cancelSort: "Click to cancel sorting"
    },
    Modal: {
      okText: "OK",
      cancelText: "Cancel",
      justOkText: "OK"
    },
    Popconfirm: {
      okText: "OK",
      cancelText: "Cancel"
    },
    Transfer: {
      titles: ["", ""],
      searchPlaceholder: "Search here",
      itemUnit: "item",
      itemsUnit: "items",
      remove: "Remove",
      selectCurrent: "Select current page",
      removeCurrent: "Remove current page",
      selectAll: "Select all data",
      removeAll: "Remove all data",
      selectInvert: "Invert current page"
    },
    Upload: {
      uploading: "Uploading...",
      removeFile: "Remove file",
      uploadError: "Upload error",
      previewFile: "Preview file",
      downloadFile: "Download file"
    },
    Empty: {
      description: "No Data"
    },
    Icon: {
      icon: "icon"
    },
    Text: {
      edit: "Edit",
      copy: "Copy",
      copied: "Copied",
      expand: "Expand"
    },
    PageHeader: {
      back: "Back"
    },
    Form: {
      optional: "(optional)",
      defaultValidateMessages: {
        default: "Field validation error for ${label}",
        required: "Please enter ${label}",
        enum: "${label} must be one of [${enum}]",
        whitespace: "${label} cannot be a blank character",
        date: {
          format: "${label} date format is invalid",
          parse: "${label} cannot be converted to a date",
          invalid: "${label} is an invalid date"
        },
        types: {
          string: a,
          method: a,
          array: a,
          object: a,
          number: a,
          date: a,
          boolean: a,
          integer: a,
          float: a,
          regexp: a,
          email: a,
          url: a,
          hex: a
        },
        string: {
          len: "${label} must be ${len} characters",
          min: "${label} must be at least ${min} characters",
          max: "${label} must be up to ${max} characters",
          range: "${label} must be between ${min}-${max} characters"
        },
        number: {
          len: "${label} must be equal to ${len}",
          min: "${label} must be minimum ${min}",
          max: "${label} must be maximum ${max}",
          range: "${label} must be between ${min}-${max}"
        },
        array: {
          len: "Must be ${len} ${label}",
          min: "At least ${min} ${label}",
          max: "At most ${max} ${label}",
          range: "The amount of ${label} must be between ${min}-${max}"
        },
        pattern: {
          mismatch: "${label} does not match the pattern ${pattern}"
        }
      }
    },
    Image: {
      preview: "Preview"
    }
  };
  t.default = s;
})(rre);
const wft = /* @__PURE__ */ qn(rre);
var ore = {}, eE = {};
Object.defineProperty(eE, "__esModule", {
  value: !0
});
eE.default = void 0;
var Eft = {
  // Options.jsx
  items_per_page: "/ página",
  jump_to: "Ir a",
  jump_to_confirm: "confirmar",
  page: "Página",
  // Pagination.jsx
  prev_page: "Página anterior",
  next_page: "Página siguiente",
  prev_5: "5 páginas previas",
  next_5: "5 páginas siguientes",
  prev_3: "3 páginas previas",
  next_3: "3 páginas siguientes",
  page_size: "tamaño de página"
};
eE.default = Eft;
var are = {}, G8 = {}, tE = {};
Object.defineProperty(tE, "__esModule", {
  value: !0
});
tE.default = void 0;
var Sft = {
  locale: "es_ES",
  today: "Hoy",
  now: "Ahora",
  backToToday: "Volver a hoy",
  ok: "Aceptar",
  clear: "Limpiar",
  month: "Mes",
  year: "Año",
  timeSelect: "Seleccionar hora",
  dateSelect: "Seleccionar fecha",
  monthSelect: "Elegir un mes",
  yearSelect: "Elegir un año",
  decadeSelect: "Elegir una década",
  yearFormat: "YYYY",
  dateFormat: "D/M/YYYY",
  dayFormat: "D",
  dateTimeFormat: "D/M/YYYY HH:mm:ss",
  monthBeforeYear: !0,
  previousMonth: "Mes anterior (PageUp)",
  nextMonth: "Mes siguiente (PageDown)",
  previousYear: "Año anterior (Control + left)",
  nextYear: "Año siguiente (Control + right)",
  previousDecade: "Década anterior",
  nextDecade: "Década siguiente",
  previousCentury: "Siglo anterior",
  nextCentury: "Siglo siguiente"
}, Ift = Sft;
tE.default = Ift;
var U8 = {};
(function(t) {
  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.default = void 0;
  var e = {
    placeholder: "Seleccionar hora"
  };
  t.default = e;
})(U8);
(function(t) {
  var e = Cu.default;
  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.default = void 0;
  var n = e(j8), r = e(tE), i = e(U8), o = {
    lang: (0, n.default)({
      placeholder: "Seleccionar fecha",
      rangePlaceholder: ["Fecha inicial", "Fecha final"]
    }, r.default),
    timePickerLocale: (0, n.default)({}, i.default)
  };
  t.default = o;
})(G8);
(function(t) {
  var e = Cu.default;
  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.default = void 0;
  var n = e(G8);
  t.default = n.default;
})(are);
(function(t) {
  var e = Cu.default;
  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.default = void 0;
  var n = e(eE), r = e(are), i = e(G8), o = e(U8), a = "${label} no es un ${type} válido", s = {
    locale: "es",
    Pagination: n.default,
    DatePicker: i.default,
    TimePicker: o.default,
    Calendar: r.default,
    global: {
      placeholder: "Seleccione"
    },
    Table: {
      filterTitle: "Filtrar menú",
      filterConfirm: "Aceptar",
      filterReset: "Reiniciar",
      filterEmptyText: "Sin filtros",
      filterCheckall: "Seleccionar todo",
      filterSearchPlaceholder: "Buscar en filtros",
      emptyText: "Sin datos",
      selectAll: "Seleccionar todo",
      selectInvert: "Invertir selección",
      selectNone: "Vacíe todo",
      selectionAll: "Seleccionar todos los datos",
      sortTitle: "Ordenar",
      expand: "Expandir fila",
      collapse: "Colapsar fila",
      triggerDesc: "Click para ordenar en orden descendente",
      triggerAsc: "Click para ordenar en orden ascendente",
      cancelSort: "Click para cancelar ordenamiento"
    },
    Modal: {
      okText: "Aceptar",
      cancelText: "Cancelar",
      justOkText: "Aceptar"
    },
    Popconfirm: {
      okText: "Aceptar",
      cancelText: "Cancelar"
    },
    Transfer: {
      titles: ["", ""],
      searchPlaceholder: "Buscar aquí",
      itemUnit: "elemento",
      itemsUnit: "elementos",
      remove: "Eliminar",
      selectCurrent: "Seleccionar página actual",
      removeCurrent: "Remover página actual",
      selectAll: "Seleccionar todos los datos",
      removeAll: "Eliminar todos los datos",
      selectInvert: "Invertir página actual"
    },
    Upload: {
      uploading: "Subiendo...",
      removeFile: "Eliminar archivo",
      uploadError: "Error al subir el archivo",
      previewFile: "Vista previa",
      downloadFile: "Descargar archivo"
    },
    Empty: {
      description: "No hay datos"
    },
    Icon: {
      icon: "ícono"
    },
    Text: {
      edit: "Editar",
      copy: "Copiar",
      copied: "Copiado",
      expand: "Expandir"
    },
    PageHeader: {
      back: "Volver"
    },
    Form: {
      optional: "(opcional)",
      defaultValidateMessages: {
        default: "Error de validación del campo ${label}",
        required: "Por favor ingresar ${label}",
        enum: "${label} debe ser uno de [${enum}]",
        whitespace: "${label} no puede ser un carácter en blanco",
        date: {
          format: "El formato de fecha de ${label} es inválido",
          parse: "${label} no se puede convertir a una fecha",
          invalid: "${label} es una fecha inválida"
        },
        types: {
          string: a,
          method: a,
          array: a,
          object: a,
          number: a,
          date: a,
          boolean: a,
          integer: a,
          float: a,
          regexp: a,
          email: a,
          url: a,
          hex: a
        },
        string: {
          len: "${label} debe tener ${len} caracteres",
          min: "${label} debe tener al menos ${min} caracteres",
          max: "${label} debe tener hasta ${max} caracteres",
          range: "${label} debe tener entre ${min}-${max} caracteres"
        },
        number: {
          len: "${label} debe ser igual a ${len}",
          min: "${label} valor mínimo es ${min}",
          max: "${label} valor máximo es ${max}",
          range: "${label} debe estar entre ${min}-${max}"
        },
        array: {
          len: "Debe ser ${len} ${label}",
          min: "Al menos ${min} ${label}",
          max: "A lo mucho ${max} ${label}",
          range: "El monto de ${label} debe estar entre ${min}-${max}"
        },
        pattern: {
          mismatch: "${label} no coincide con el patrón ${pattern}"
        }
      }
    },
    Image: {
      preview: "Previsualización"
    }
  };
  t.default = s;
})(ore);
const _ft = /* @__PURE__ */ qn(ore);
var sre = {}, nE = {};
Object.defineProperty(nE, "__esModule", {
  value: !0
});
nE.default = void 0;
var Aft = {
  // Options.jsx
  items_per_page: "/ page",
  jump_to: "Aller à",
  jump_to_confirm: "confirmer",
  page: "Page",
  // Pagination.jsx
  prev_page: "Page précédente",
  next_page: "Page suivante",
  prev_5: "5 Pages précédentes",
  next_5: "5 Pages suivantes",
  prev_3: "3 Pages précédentes",
  next_3: "3 Pages suivantes",
  page_size: "taille de la page"
};
nE.default = Aft;
var ure = {}, X8 = {}, rE = {};
Object.defineProperty(rE, "__esModule", {
  value: !0
});
rE.default = void 0;
var Tft = {
  locale: "fr_FR",
  today: "Aujourd'hui",
  now: "Maintenant",
  backToToday: "Aujourd'hui",
  ok: "OK",
  clear: "Rétablir",
  month: "Mois",
  year: "Année",
  timeSelect: "Sélectionner l'heure",
  dateSelect: "Sélectionner la date",
  monthSelect: "Choisissez un mois",
  yearSelect: "Choisissez une année",
  decadeSelect: "Choisissez une décennie",
  yearFormat: "YYYY",
  dateFormat: "DD/MM/YYYY",
  dayFormat: "DD",
  dateTimeFormat: "DD/MM/YYYY HH:mm:ss",
  monthBeforeYear: !0,
  previousMonth: "Mois précédent (PageUp)",
  nextMonth: "Mois suivant (PageDown)",
  previousYear: "Année précédente (Ctrl + gauche)",
  nextYear: "Année prochaine (Ctrl + droite)",
  previousDecade: "Décennie précédente",
  nextDecade: "Décennie suivante",
  previousCentury: "Siècle précédent",
  nextCentury: "Siècle suivant"
}, Oft = Tft;
rE.default = Oft;
var Y8 = {};
(function(t) {
  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.default = void 0;
  var e = {
    placeholder: "Sélectionner l'heure",
    rangePlaceholder: ["Heure de début", "Heure de fin"]
  };
  t.default = e;
})(Y8);
(function(t) {
  var e = Cu.default;
  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.default = void 0;
  var n = e(j8), r = e(rE), i = e(Y8), o = {
    lang: (0, n.default)({
      placeholder: "Sélectionner une date",
      yearPlaceholder: "Sélectionner une année",
      quarterPlaceholder: "Sélectionner un trimestre",
      monthPlaceholder: "Sélectionner un mois",
      weekPlaceholder: "Sélectionner une semaine",
      rangePlaceholder: ["Date de début", "Date de fin"],
      rangeYearPlaceholder: ["Année de début", "Année de fin"],
      rangeMonthPlaceholder: ["Mois de début", "Mois de fin"],
      rangeWeekPlaceholder: ["Semaine de début", "Semaine de fin"]
    }, r.default),
    timePickerLocale: (0, n.default)({}, i.default)
  };
  t.default = o;
})(X8);
(function(t) {
  var e = Cu.default;
  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.default = void 0;
  var n = e(X8);
  t.default = n.default;
})(ure);
(function(t) {
  var e = Cu.default;
  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.default = void 0;
  var n = e(nE), r = e(ure), i = e(X8), o = e(Y8), a = "La valeur du champ ${label} n'est pas valide pour le type ${type}", s = {
    locale: "fr",
    Pagination: n.default,
    DatePicker: i.default,
    TimePicker: o.default,
    Calendar: r.default,
    Table: {
      filterTitle: "Filtrer",
      filterConfirm: "OK",
      filterReset: "Réinitialiser",
      filterEmptyText: "Aucun filtre",
      filterCheckall: "Tout sélectionner",
      filterSearchPlaceholder: "Chercher dans les filtres",
      emptyText: "Aucune donnée",
      selectAll: "Sélectionner la page actuelle",
      selectInvert: "Inverser la sélection de la page actuelle",
      selectNone: "Désélectionner toutes les données",
      selectionAll: "Sélectionner toutes les données",
      sortTitle: "Trier",
      expand: "Développer la ligne",
      collapse: "Réduire la ligne",
      triggerDesc: "Trier par ordre décroissant",
      triggerAsc: "Trier par ordre croissant",
      cancelSort: "Annuler le tri"
    },
    Modal: {
      okText: "OK",
      cancelText: "Annuler",
      justOkText: "OK"
    },
    Popconfirm: {
      okText: "OK",
      cancelText: "Annuler"
    },
    Transfer: {
      titles: ["", ""],
      searchPlaceholder: "Rechercher",
      itemUnit: "élément",
      itemsUnit: "éléments",
      remove: "Désélectionner",
      selectCurrent: "Sélectionner la page actuelle",
      removeCurrent: "Désélectionner la page actuelle",
      selectAll: "Sélectionner toutes les données",
      removeAll: "Désélectionner toutes les données",
      selectInvert: "Inverser la sélection de la page actuelle"
    },
    Upload: {
      uploading: "Téléchargement...",
      removeFile: "Effacer le fichier",
      uploadError: "Erreur de téléchargement",
      previewFile: "Fichier de prévisualisation",
      downloadFile: "Télécharger un fichier"
    },
    Empty: {
      description: "Aucune donnée"
    },
    Icon: {
      icon: "icône"
    },
    Text: {
      edit: "Éditer",
      copy: "Copier",
      copied: "Copie effectuée",
      expand: "Développer"
    },
    PageHeader: {
      back: "Retour"
    },
    Form: {
      optional: "(optionnel)",
      defaultValidateMessages: {
        default: "Erreur de validation pour le champ ${label}",
        required: "Le champ ${label} est obligatoire",
        enum: "La valeur du champ ${label} doit être parmi [${enum}]",
        whitespace: "La valeur du champ ${label} ne peut pas être vide",
        date: {
          format: "La valeur du champ ${label} n'est pas au format date",
          parse: "La valeur du champ ${label} ne peut pas être convertie vers une date",
          invalid: "La valeur du champ ${label} n'est pas une date valide"
        },
        types: {
          string: a,
          method: a,
          array: a,
          object: a,
          number: a,
          date: a,
          boolean: a,
          integer: a,
          float: a,
          regexp: a,
          email: a,
          url: a,
          hex: a
        },
        string: {
          len: "La taille du champ ${label} doit être de ${len} caractères",
          min: "La taille du champ ${label} doit être au minimum de ${min} caractères",
          max: "La taille du champ ${label} doit être au maximum de ${max} caractères",
          range: "La taille du champ ${label} doit être entre ${min} et ${max} caractères"
        },
        number: {
          len: "La valeur du champ ${label} doit être égale à ${len}",
          min: "La valeur du champ ${label} doit être plus grande que ${min}",
          max: "La valeur du champ ${label} doit être plus petit que ${max}",
          range: "La valeur du champ ${label} doit être entre ${min} et ${max}"
        },
        array: {
          len: "La taille du tableau ${label} doit être de ${len}",
          min: "La taille du tableau ${label} doit être au minimum de ${min}",
          max: "La taille du tableau ${label} doit être au maximum de ${max}",
          range: "La taille du tableau ${label} doit être entre ${min}-${max}"
        },
        pattern: {
          mismatch: "La valeur du champ ${label} ne correspond pas au modèle ${pattern}"
        }
      }
    },
    Image: {
      preview: "Aperçu"
    }
  };
  t.default = s;
})(sre);
const Pft = /* @__PURE__ */ qn(sre);
var Nft = { exports: {} };
(function(t, e) {
  (function(n, r) {
    t.exports = r();
  })(ft, function() {
    return { name: "en", weekdays: "Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday".split("_"), months: "January_February_March_April_May_June_July_August_September_October_November_December".split("_"), ordinal: function(n) {
      var r = ["th", "st", "nd", "rd"], i = n % 100;
      return "[" + n + (r[(i - 20) % 10] || r[i] || r[0]) + "]";
    } };
  });
})(Nft);
var kft = { exports: {} };
(function(t, e) {
  (function(n, r) {
    t.exports = r(uc);
  })(ft, function(n) {
    function r(a) {
      return a && typeof a == "object" && "default" in a ? a : { default: a };
    }
    var i = r(n), o = { name: "fr", weekdays: "dimanche_lundi_mardi_mercredi_jeudi_vendredi_samedi".split("_"), weekdaysShort: "dim._lun._mar._mer._jeu._ven._sam.".split("_"), weekdaysMin: "di_lu_ma_me_je_ve_sa".split("_"), months: "janvier_février_mars_avril_mai_juin_juillet_août_septembre_octobre_novembre_décembre".split("_"), monthsShort: "janv._févr._mars_avr._mai_juin_juil._août_sept._oct._nov._déc.".split("_"), weekStart: 1, yearStart: 4, formats: { LT: "HH:mm", LTS: "HH:mm:ss", L: "DD/MM/YYYY", LL: "D MMMM YYYY", LLL: "D MMMM YYYY HH:mm", LLLL: "dddd D MMMM YYYY HH:mm" }, relativeTime: { future: "dans %s", past: "il y a %s", s: "quelques secondes", m: "une minute", mm: "%d minutes", h: "une heure", hh: "%d heures", d: "un jour", dd: "%d jours", M: "un mois", MM: "%d mois", y: "un an", yy: "%d ans" }, ordinal: function(a) {
      return "" + a + (a === 1 ? "er" : "");
    } };
    return i.default.locale(o, null, !0), o;
  });
})(kft);
var Rft = { exports: {} };
(function(t, e) {
  (function(n, r) {
    t.exports = r(uc);
  })(ft, function(n) {
    function r(a) {
      return a && typeof a == "object" && "default" in a ? a : { default: a };
    }
    var i = r(n), o = { name: "es", monthsShort: "ene_feb_mar_abr_may_jun_jul_ago_sep_oct_nov_dic".split("_"), weekdays: "domingo_lunes_martes_miércoles_jueves_viernes_sábado".split("_"), weekdaysShort: "dom._lun._mar._mié._jue._vie._sáb.".split("_"), weekdaysMin: "do_lu_ma_mi_ju_vi_sá".split("_"), months: "enero_febrero_marzo_abril_mayo_junio_julio_agosto_septiembre_octubre_noviembre_diciembre".split("_"), weekStart: 1, formats: { LT: "H:mm", LTS: "H:mm:ss", L: "DD/MM/YYYY", LL: "D [de] MMMM [de] YYYY", LLL: "D [de] MMMM [de] YYYY H:mm", LLLL: "dddd, D [de] MMMM [de] YYYY H:mm" }, relativeTime: { future: "en %s", past: "hace %s", s: "unos segundos", m: "un minuto", mm: "%d minutos", h: "una hora", hh: "%d horas", d: "un día", dd: "%d días", M: "un mes", MM: "%d meses", y: "un año", yy: "%d años" }, ordinal: function(a) {
      return a + "º";
    } };
    return i.default.locale(o, null, !0), o;
  });
})(Rft);
var $ft = u9, Dft = Ym, Mft = DC, aB = Ds, Fft = kp;
function Lft(t, e, n, r) {
  if (!aB(t))
    return t;
  e = Dft(e, t);
  for (var i = -1, o = e.length, a = o - 1, s = t; s != null && ++i < o; ) {
    var u = Fft(e[i]), l = n;
    if (u === "__proto__" || u === "constructor" || u === "prototype")
      return t;
    if (i != a) {
      var c = s[u];
      l = r ? r(c, u, s) : void 0, l === void 0 && (l = aB(c) ? c : Mft(e[i + 1]) ? [] : {});
    }
    $ft(s, u, l), s = s[u];
  }
  return t;
}
var Vft = Lft, Bft = Vft;
function Hft(t, e, n) {
  return t == null ? t : Bft(t, e, n);
}
var Wft = Hft;
const sB = /* @__PURE__ */ qn(Wft), uB = (t, e) => {
  switch (t) {
    case "daterange":
    case "date":
      if (e)
        return Or.isDayjs(e) ? e : Or(e);
      break;
    case "upload":
      return e || [];
  }
  return e;
}, lB = (t, e) => {
  const n = {
    ...t
  };
  return Um(e).filter((r) => r).filter(wu).filter((r) => r.input).forEach((r) => {
    if (Array.isArray(r.name)) {
      const i = r.name.join("/==");
      n[i] = r.name.reduce((o, a) => (o[a] = uB(r.input.type, n[a]), o), {});
    } else
      n[r.name] = uB(r.input.type, ii(n, r.name));
  }), n;
}, Zb = (t, e, n = !1) => {
  const r = {};
  return Um(e).filter((i) => i).filter(wu).filter((i) => i.input).forEach((i) => {
    if (Array.isArray(i.name)) {
      const o = i.name.join("/==");
      i.name.forEach((a) => {
        r[a] = ii(t, [o, a], void 0);
      }), delete r[o];
    } else if ((!n || t[i.name]) && sB(r, i.name, t[i.name]), i.proxy) {
      let o = t[i.name];
      i.proxy.path && (Array.isArray(o) ? o = (t[i.name] || []).map(
        (a) => ii(a || {}, i.proxy.path, null)
      ) : o = ii(t[i.name] || {}, i.proxy.path, null)), (!n || o) && sB(r, i.proxy.name, o);
    }
  }), r;
}, jft = (t) => {
  let e = { ...t };
  return Object.keys(e).forEach((r) => {
    const i = r.match(/(.+)\[(\d+)\]\.(.+)/);
    if (i) {
      const [o, a, s, u] = i;
      e[a] || (e[a] = []), e[a][s] || (e[a][s] = {}), e[a][s][u] = e[r];
    }
  }), e;
};
let vs = {
  submitText: "Save",
  layout: "horizontal",
  locale: "fr",
  tooltipIcon: /* @__PURE__ */ Oe.jsx(dC, {})
};
const zft = {
  fr: Pft,
  en: wft,
  es: _ft
}, Gft = (t, e) => {
  const n = Um(t).filter(wu), r = {};
  return n.forEach((i) => {
    e[i.name] ? r[i.name] = e[i.name] : i.defaultValue && (r[i.name] = i.defaultValue || void 0);
  }), r;
}, V5 = (t, e) => Object.keys(t).filter((r) => {
  var i;
  return t && t[r] && !((i = t[r]) != null && i.condition(e));
}), Uft = (t) => {
  if (t)
    return zft[t];
}, lre = {
  inactiveItems: [],
  readOnlyItems: [],
  editingField: void 0
}, Xft = (t = lre, e) => {
  switch (e.type) {
    case "SET_INACTIVE_ITEMS":
      return {
        ...t,
        inactiveItems: e.payload
      };
    case "SET_READ_ONLY_ITEMS":
      return {
        ...t,
        readOnlyItems: e.payload
      };
    case "SET_EDITING_FIELD":
      return {
        ...t,
        editingField: e.payload
      };
    default:
      return t;
  }
}, Yft = (t) => {
  const {
    inPlace: e = !1,
    schema: n,
    locale: r = vs.locale || "en",
    loading: i,
    readOnly: o = !1,
    actionsWrapperProps: a,
    submitButtonProps: s,
    extraActions: u = null,
    rowProps: l = {
      gutter: 16
    },
    cancelText: c,
    submitText: d,
    onSubmit: f,
    renderLabel: h,
    onChange: p,
    ...v
  } = t, m = t.object || {}, [b] = bd.useForm(), y = Rn(() => {
    const F = Rje(n);
    if (Object.keys(F).length !== 0)
      return F;
  }, []), [{
    inactiveItems: w,
    readOnlyItems: S,
    editingField: E
  }, I] = Nm(Xft, {
    ...lre,
    inactiveItems: y ? V5(y, m) : []
  }), _ = et(() => YZ(w), [w]);
  Re(() => {
    b.setFieldsValue(lB(m, n) || {}), I({
      type: "SET_INACTIVE_ITEMS",
      payload: y ? V5(y, m) : []
    });
    const M = n.filter(wu).filter((B) => B.readOnly).filter((B) => typeof B.readOnly == "function" ? B.readOnly(m) : B.readOnly).map((B) => B.name);
    I({
      type: "SET_READ_ONLY_ITEMS",
      payload: M
    });
  }, [m, n]);
  const A = Uft(vs.language || vs.locale), P = lB(Gft(n, m), n), N = Nje(n), k = (F) => I({ type: "SET_EDITING_FIELD", payload: F }), D = (F) => I({ type: "SET_INACTIVE_ITEMS", payload: F }), R = () => {
    if (f && !o) {
      const F = b.getFieldsValue(!0), M = Zb(Sb(N, va(F, w)), n);
      f(M);
    }
  }, V = (F) => {
    const M = b.getFieldsValue(!0), B = y ? V5(
      y,
      Zb(Sb(N, M), n)
    ) : void 0;
    y && D(B || []), p && !o && p(
      Zb(Sb(N, F), n, !0),
      Zb(
        // @ts-ignore
        Sb(N, va(M, B)),
        n
      )
    );
  };
  if (!n || n.length === 0)
    return null;
  const $ = jft(t.errors);
  return /* @__PURE__ */ Oe.jsx(dT.Provider, { value: vs, children: /* @__PURE__ */ Oe.jsx(cA, { locale: A, children: /* @__PURE__ */ Oe.jsx(
    Aje,
    {
      loading: i,
      inPlace: e,
      formObject: m,
      onFormSubmit: f,
      submitText: d,
      cancelText: c,
      editingField: E,
      setEditingField: k,
      children: /* @__PURE__ */ Oe.jsxs(
        bd,
        {
          form: b,
          onFinish: R,
          initialValues: P,
          ...p ? { onValuesChange: V } : {},
          ...vs.formProps || {},
          ...v,
          children: [
            n.filter(_).map((F, M) => /* @__PURE__ */ Oe.jsx(
              hT,
              {
                inactiveItems: w,
                readOnlyItems: S,
                renderLabel: h,
                layout: v.layout,
                item: F,
                errors: $,
                readOnly: o,
                locale: r,
                config: vs,
                rowProps: l
              },
              M
            )),
            (u || f) && (!o || o && u) && /* @__PURE__ */ Oe.jsx("div", { ...vs.actionsWrapperProps || {}, ...a || {}, children: /* @__PURE__ */ Oe.jsxs(X0, { children: [
              u || null,
              f && !o && /* @__PURE__ */ Oe.jsx(
                ko,
                {
                  ...s || {},
                  htmlType: "submit",
                  type: "primary",
                  loading: i,
                  children: d || vs.submitText || "Save"
                }
              )
            ] }) })
          ]
        }
      )
    }
  ) }) });
}, Zft = (t) => (vs = { ...vs, ...t }, vs), Jft = bft;
var Kft = pT;
function qft(t, e) {
  var n = t == null ? 0 : t.length;
  return !!n && Kft(t, e, 0) > -1;
}
var Qft = qft;
function eht(t, e, n) {
  for (var r = -1, i = t == null ? 0 : t.length; ++r < i; )
    if (n(e, t[r]))
      return !0;
  return !1;
}
var tht = eht;
function nht() {
}
var rht = nht, B5 = CX, iht = rht, oht = QA, aht = 1 / 0, sht = B5 && 1 / oht(new B5([, -0]))[1] == aht ? function(t) {
  return new B5(t);
} : iht, uht = sht, lht = lX, cht = Qft, dht = tht, fht = dX, hht = uht, pht = QA, ght = 200;
function mht(t, e, n) {
  var r = -1, i = cht, o = t.length, a = !0, s = [], u = s;
  if (n)
    a = !1, i = dht;
  else if (o >= ght) {
    var l = e ? null : hht(t);
    if (l)
      return pht(l);
    a = !1, i = fht, u = new lht();
  } else
    u = e ? [] : s;
  e:
    for (; ++r < o; ) {
      var c = t[r], d = e ? e(c) : c;
      if (c = n || c !== 0 ? c : 0, a && d === d) {
        for (var f = u.length; f--; )
          if (u[f] === d)
            continue e;
        e && u.push(d), s.push(c);
      } else
        i(u, d, n) || (u !== s && u.push(d), s.push(c));
    }
  return s;
}
var vht = mht, bht = vht;
function yht(t) {
  return t && t.length ? bht(t) : [];
}
var xht = yht;
const Cht = /* @__PURE__ */ qn(xht), wht = (t, e) => {
  switch (e.type) {
    case "set":
      return {
        object: e.payload,
        dirty: !1,
        initialValue: e.payload,
        changes: []
      };
    case "change":
      return {
        ...t,
        object: {
          ...t.object || {},
          ...e.payload
        },
        dirty: !VC({
          ...t.object || {},
          ...e.payload
        }, t.initialValue),
        changes: Cht([...t.changes, ...e.changes || []])
      };
    default:
      return t;
  }
}, Pbt = (t) => {
  const e = {
    object: t || {},
    initialValue: t || {},
    dirty: !1,
    changes: []
  }, [n, r] = Nm(
    wht,
    e
  ), i = (u) => r({ type: "set", payload: u }), o = (u, l) => {
    r({ type: "change", payload: l, changes: Object.keys(u) });
  }, a = () => r({ type: "set", payload: t || {} }), s = () => r({ type: "set", payload: {} });
  return {
    object: n.object,
    dirty: n.dirty,
    changes: n.changes,
    dispatch: r,
    onCancel: a,
    onReset: s,
    onChange: o,
    set: i
  };
}, Z8 = Yft;
Z8.configure = Zft;
Z8.addField = Jft;
/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */
var _d = function() {
  return _d = Object.assign || function(t) {
    for (var e, n = 1, r = arguments.length; n < r; n++)
      for (var i in e = arguments[n])
        Object.prototype.hasOwnProperty.call(e, i) && (t[i] = e[i]);
    return t;
  }, _d.apply(this, arguments);
};
function Eht(t, e, n, r) {
  return new (n || (n = Promise))(function(i, o) {
    function a(l) {
      try {
        u(r.next(l));
      } catch (c) {
        o(c);
      }
    }
    function s(l) {
      try {
        u(r.throw(l));
      } catch (c) {
        o(c);
      }
    }
    function u(l) {
      var c;
      l.done ? i(l.value) : (c = l.value, c instanceof n ? c : new n(function(d) {
        d(c);
      })).then(a, s);
    }
    u((r = r.apply(t, e || [])).next());
  });
}
function Sht(t, e) {
  var n, r, i, o, a = { label: 0, sent: function() {
    if (1 & i[0])
      throw i[1];
    return i[1];
  }, trys: [], ops: [] };
  return o = { next: s(0), throw: s(1), return: s(2) }, typeof Symbol == "function" && (o[Symbol.iterator] = function() {
    return this;
  }), o;
  function s(u) {
    return function(l) {
      return function(c) {
        if (n)
          throw new TypeError("Generator is already executing.");
        for (; a; )
          try {
            if (n = 1, r && (i = 2 & c[0] ? r.return : c[0] ? r.throw || ((i = r.return) && i.call(r), 0) : r.next) && !(i = i.call(r, c[1])).done)
              return i;
            switch (r = 0, i && (c = [2 & c[0], i.value]), c[0]) {
              case 0:
              case 1:
                i = c;
                break;
              case 4:
                return a.label++, { value: c[1], done: !1 };
              case 5:
                a.label++, r = c[1], c = [0];
                continue;
              case 7:
                c = a.ops.pop(), a.trys.pop();
                continue;
              default:
                if (i = a.trys, !((i = i.length > 0 && i[i.length - 1]) || c[0] !== 6 && c[0] !== 2)) {
                  a = 0;
                  continue;
                }
                if (c[0] === 3 && (!i || c[1] > i[0] && c[1] < i[3])) {
                  a.label = c[1];
                  break;
                }
                if (c[0] === 6 && a.label < i[1]) {
                  a.label = i[1], i = c;
                  break;
                }
                if (i && a.label < i[2]) {
                  a.label = i[2], a.ops.push(c);
                  break;
                }
                i[2] && a.ops.pop(), a.trys.pop();
                continue;
            }
            c = e.call(t, a);
          } catch (d) {
            c = [6, d], r = 0;
          } finally {
            n = i = 0;
          }
        if (5 & c[0])
          throw c[1];
        return { value: c[0] ? c[1] : void 0, done: !0 };
      }([u, l]);
    };
  }
}
function Kt() {
  return Kt = Object.assign ? Object.assign.bind() : function(t) {
    for (var e = 1; e < arguments.length; e++) {
      var n = arguments[e];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (t[r] = n[r]);
    }
    return t;
  }, Kt.apply(this, arguments);
}
function Ad(t) {
  return Ad = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(e) {
    return typeof e;
  } : function(e) {
    return e && typeof Symbol == "function" && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
  }, Ad(t);
}
function cre(t) {
  var e = function(n, r) {
    if (Ad(n) !== "object" || n === null)
      return n;
    var i = n[Symbol.toPrimitive];
    if (i !== void 0) {
      var o = i.call(n, r || "default");
      if (Ad(o) !== "object")
        return o;
      throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (r === "string" ? String : Number)(n);
  }(t, "string");
  return Ad(e) === "symbol" ? e : String(e);
}
function $h(t, e, n) {
  return (e = cre(e)) in t ? Object.defineProperty(t, e, { value: n, enumerable: !0, configurable: !0, writable: !0 }) : t[e] = n, t;
}
function cB(t, e) {
  var n = Object.keys(t);
  if (Object.getOwnPropertySymbols) {
    var r = Object.getOwnPropertySymbols(t);
    e && (r = r.filter(function(i) {
      return Object.getOwnPropertyDescriptor(t, i).enumerable;
    })), n.push.apply(n, r);
  }
  return n;
}
function Bt(t) {
  for (var e = 1; e < arguments.length; e++) {
    var n = arguments[e] != null ? arguments[e] : {};
    e % 2 ? cB(Object(n), !0).forEach(function(r) {
      $h(t, r, n[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(t, Object.getOwnPropertyDescriptors(n)) : cB(Object(n)).forEach(function(r) {
      Object.defineProperty(t, r, Object.getOwnPropertyDescriptor(n, r));
    });
  }
  return t;
}
function dB(t, e) {
  for (var n = 0; n < e.length; n++) {
    var r = e[n];
    r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(t, cre(r.key), r);
  }
}
function I6(t, e) {
  return I6 = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(n, r) {
    return n.__proto__ = r, n;
  }, I6(t, e);
}
function G2(t) {
  return G2 = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(e) {
    return e.__proto__ || Object.getPrototypeOf(e);
  }, G2(t);
}
function Iht(t, e) {
  if (e && (Ad(e) === "object" || typeof e == "function"))
    return e;
  if (e !== void 0)
    throw new TypeError("Derived constructors may only return object or undefined");
  return function(n) {
    if (n === void 0)
      throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return n;
  }(t);
}
function _ht(t) {
  var e = function() {
    if (typeof Reflect > "u" || !Reflect.construct || Reflect.construct.sham)
      return !1;
    if (typeof Proxy == "function")
      return !0;
    try {
      return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
      })), !0;
    } catch {
      return !1;
    }
  }();
  return function() {
    var n, r = G2(t);
    if (e) {
      var i = G2(this).constructor;
      n = Reflect.construct(r, arguments, i);
    } else
      n = r.apply(this, arguments);
    return Iht(this, n);
  };
}
function _6(t, e) {
  (e == null || e > t.length) && (e = t.length);
  for (var n = 0, r = new Array(e); n < e; n++)
    r[n] = t[n];
  return r;
}
function dre(t, e) {
  if (t) {
    if (typeof t == "string")
      return _6(t, e);
    var n = Object.prototype.toString.call(t).slice(8, -1);
    return n === "Object" && t.constructor && (n = t.constructor.name), n === "Map" || n === "Set" ? Array.from(t) : n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n) ? _6(t, e) : void 0;
  }
}
function J8(t) {
  return function(e) {
    if (Array.isArray(e))
      return _6(e);
  }(t) || function(e) {
    if (typeof Symbol < "u" && e[Symbol.iterator] != null || e["@@iterator"] != null)
      return Array.from(e);
  }(t) || dre(t) || function() {
    throw new TypeError(`Invalid attempt to spread non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
  }();
}
var Aht = function() {
  function t(n) {
    var r = this;
    this._insertTag = function(i) {
      var o;
      o = r.tags.length === 0 ? r.insertionPoint ? r.insertionPoint.nextSibling : r.prepend ? r.container.firstChild : r.before : r.tags[r.tags.length - 1].nextSibling, r.container.insertBefore(i, o), r.tags.push(i);
    }, this.isSpeedy = n.speedy === void 0 ? process.env.NODE_ENV === "production" : n.speedy, this.tags = [], this.ctr = 0, this.nonce = n.nonce, this.key = n.key, this.container = n.container, this.prepend = n.prepend, this.insertionPoint = n.insertionPoint, this.before = null;
  }
  var e = t.prototype;
  return e.hydrate = function(n) {
    n.forEach(this._insertTag);
  }, e.insert = function(n) {
    this.ctr % (this.isSpeedy ? 65e3 : 1) == 0 && this._insertTag(function(a) {
      var s = document.createElement("style");
      return s.setAttribute("data-emotion", a.key), a.nonce !== void 0 && s.setAttribute("nonce", a.nonce), s.appendChild(document.createTextNode("")), s.setAttribute("data-s", ""), s;
    }(this));
    var r = this.tags[this.tags.length - 1];
    if (process.env.NODE_ENV !== "production") {
      var i = n.charCodeAt(0) === 64 && n.charCodeAt(1) === 105;
      i && this._alreadyInsertedOrderInsensitiveRule && console.error(`You're attempting to insert the following rule:
` + n + "\n\n`@import` rules must be before all other types of rules in a stylesheet but other rules have already been inserted. Please ensure that `@import` rules are before all other rules."), this._alreadyInsertedOrderInsensitiveRule = this._alreadyInsertedOrderInsensitiveRule || !i;
    }
    if (this.isSpeedy) {
      var o = function(a) {
        if (a.sheet)
          return a.sheet;
        for (var s = 0; s < document.styleSheets.length; s++)
          if (document.styleSheets[s].ownerNode === a)
            return document.styleSheets[s];
      }(r);
      try {
        o.insertRule(n, o.cssRules.length);
      } catch (a) {
        process.env.NODE_ENV === "production" || /:(-moz-placeholder|-moz-focus-inner|-moz-focusring|-ms-input-placeholder|-moz-read-write|-moz-read-only|-ms-clear|-ms-expand|-ms-reveal){/.test(n) || console.error('There was a problem inserting the following rule: "' + n + '"', a);
      }
    } else
      r.appendChild(document.createTextNode(n));
    this.ctr++;
  }, e.flush = function() {
    this.tags.forEach(function(n) {
      return n.parentNode && n.parentNode.removeChild(n);
    }), this.tags = [], this.ctr = 0, process.env.NODE_ENV !== "production" && (this._alreadyInsertedOrderInsensitiveRule = !1);
  }, t;
}(), Da = "-ms-", fB = "-moz-", Xn = "-webkit-", K8 = "decl", fre = "@keyframes", Tht = Math.abs, iE = String.fromCharCode, Oht = Object.assign;
function hre(t) {
  return t.trim();
}
function sr(t, e, n) {
  return t.replace(e, n);
}
function A6(t, e) {
  return t.indexOf(e);
}
function Mi(t, e) {
  return 0 | t.charCodeAt(e);
}
function wm(t, e, n) {
  return t.slice(e, n);
}
function Js(t) {
  return t.length;
}
function q8(t) {
  return t.length;
}
function Jb(t, e) {
  return e.push(t), t;
}
var oE = 1, bp = 1, pre = 0, Ro = 0, ci = 0, Zp = "";
function aE(t, e, n, r, i, o, a) {
  return { value: t, root: e, parent: n, type: r, props: i, children: o, line: oE, column: bp, length: a, return: "" };
}
function Ug(t, e) {
  return Oht(aE("", null, null, "", null, null, 0), t, { length: -t.length }, e);
}
function da() {
  return ci = Ro < pre ? Mi(Zp, Ro++) : 0, bp++, ci === 10 && (bp = 1, oE++), ci;
}
function cu() {
  return Mi(Zp, Ro);
}
function By() {
  return Ro;
}
function $v(t, e) {
  return wm(Zp, t, e);
}
function Em(t) {
  switch (t) {
    case 0:
    case 9:
    case 10:
    case 13:
    case 32:
      return 5;
    case 33:
    case 43:
    case 44:
    case 47:
    case 62:
    case 64:
    case 126:
    case 59:
    case 123:
    case 125:
      return 4;
    case 58:
      return 3;
    case 34:
    case 39:
    case 40:
    case 91:
      return 2;
    case 41:
    case 93:
      return 1;
  }
  return 0;
}
function gre(t) {
  return oE = bp = 1, pre = Js(Zp = t), Ro = 0, [];
}
function mre(t) {
  return Zp = "", t;
}
function Hy(t) {
  return hre($v(Ro - 1, T6(t === 91 ? t + 2 : t === 40 ? t + 1 : t)));
}
function Pht(t) {
  for (; (ci = cu()) && ci < 33; )
    da();
  return Em(t) > 2 || Em(ci) > 3 ? "" : " ";
}
function Nht(t, e) {
  for (; --e && da() && !(ci < 48 || ci > 102 || ci > 57 && ci < 65 || ci > 70 && ci < 97); )
    ;
  return $v(t, By() + (e < 6 && cu() == 32 && da() == 32));
}
function T6(t) {
  for (; da(); )
    switch (ci) {
      case t:
        return Ro;
      case 34:
      case 39:
        t !== 34 && t !== 39 && T6(ci);
        break;
      case 40:
        t === 41 && T6(t);
        break;
      case 92:
        da();
    }
  return Ro;
}
function kht(t, e) {
  for (; da() && t + ci !== 57 && (t + ci !== 84 || cu() !== 47); )
    ;
  return "/*" + $v(e, Ro - 1) + "*" + iE(t === 47 ? t : da());
}
function Rht(t) {
  for (; !Em(cu()); )
    da();
  return $v(t, Ro);
}
function hB(t) {
  return mre(Wy("", null, null, null, [""], t = gre(t), 0, [0], t));
}
function Wy(t, e, n, r, i, o, a, s, u) {
  for (var l = 0, c = 0, d = a, f = 0, h = 0, p = 0, v = 1, m = 1, b = 1, y = 0, w = "", S = i, E = o, I = r, _ = w; m; )
    switch (p = y, y = da()) {
      case 40:
        if (p != 108 && Mi(_, d - 1) == 58) {
          A6(_ += sr(Hy(y), "&", "&\f"), "&\f") != -1 && (b = -1);
          break;
        }
      case 34:
      case 39:
      case 91:
        _ += Hy(y);
        break;
      case 9:
      case 10:
      case 13:
      case 32:
        _ += Pht(p);
        break;
      case 92:
        _ += Nht(By() - 1, 7);
        continue;
      case 47:
        switch (cu()) {
          case 42:
          case 47:
            Jb($ht(kht(da(), By()), e, n), u);
            break;
          default:
            _ += "/";
        }
        break;
      case 123 * v:
        s[l++] = Js(_) * b;
      case 125 * v:
      case 59:
      case 0:
        switch (y) {
          case 0:
          case 125:
            m = 0;
          case 59 + c:
            h > 0 && Js(_) - d && Jb(h > 32 ? gB(_ + ";", r, n, d - 1) : gB(sr(_, " ", "") + ";", r, n, d - 2), u);
            break;
          case 59:
            _ += ";";
          default:
            if (Jb(I = pB(_, e, n, l, c, i, s, w, S = [], E = [], d), o), y === 123)
              if (c === 0)
                Wy(_, e, I, I, S, o, d, s, E);
              else
                switch (f === 99 && Mi(_, 3) === 110 ? 100 : f) {
                  case 100:
                  case 109:
                  case 115:
                    Wy(t, I, I, r && Jb(pB(t, I, I, 0, 0, i, s, w, i, S = [], d), E), i, E, d, s, r ? S : E);
                    break;
                  default:
                    Wy(_, I, I, I, [""], E, 0, s, E);
                }
        }
        l = c = h = 0, v = b = 1, w = _ = "", d = a;
        break;
      case 58:
        d = 1 + Js(_), h = p;
      default:
        if (v < 1) {
          if (y == 123)
            --v;
          else if (y == 125 && v++ == 0 && (ci = Ro > 0 ? Mi(Zp, --Ro) : 0, bp--, ci === 10 && (bp = 1, oE--), ci == 125))
            continue;
        }
        switch (_ += iE(y), y * v) {
          case 38:
            b = c > 0 ? 1 : (_ += "\f", -1);
            break;
          case 44:
            s[l++] = (Js(_) - 1) * b, b = 1;
            break;
          case 64:
            cu() === 45 && (_ += Hy(da())), f = cu(), c = d = Js(w = _ += Rht(By())), y++;
            break;
          case 45:
            p === 45 && Js(_) == 2 && (v = 0);
        }
    }
  return o;
}
function pB(t, e, n, r, i, o, a, s, u, l, c) {
  for (var d = i - 1, f = i === 0 ? o : [""], h = q8(f), p = 0, v = 0, m = 0; p < r; ++p)
    for (var b = 0, y = wm(t, d + 1, d = Tht(v = a[p])), w = t; b < h; ++b)
      (w = hre(v > 0 ? f[b] + " " + y : sr(y, /&\f/g, f[b]))) && (u[m++] = w);
  return aE(t, e, n, i === 0 ? "rule" : s, u, l, c);
}
function $ht(t, e, n) {
  return aE(t, e, n, "comm", iE(ci), wm(t, 2, -2), 0);
}
function gB(t, e, n, r) {
  return aE(t, e, n, K8, wm(t, 0, r), wm(t, r + 1, -1), r);
}
function Td(t, e) {
  for (var n = "", r = q8(t), i = 0; i < r; i++)
    n += e(t[i], i, t, e) || "";
  return n;
}
function mB(t, e, n, r) {
  switch (t.type) {
    case "@import":
    case K8:
      return t.return = t.return || t.value;
    case "comm":
      return "";
    case fre:
      return t.return = t.value + "{" + Td(t.children, r) + "}";
    case "rule":
      t.value = t.props.join(",");
  }
  return Js(n = Td(t.children, r)) ? t.return = t.value + "{" + n + "}" : "";
}
function vB(t) {
  var e = q8(t);
  return function(n, r, i, o) {
    for (var a = "", s = 0; s < e; s++)
      a += t[s](n, r, i, o) || "";
    return a;
  };
}
function Dht(t) {
  return function(e) {
    e.root || (e = e.return) && t(e);
  };
}
function vre(t) {
  var e = /* @__PURE__ */ Object.create(null);
  return function(n) {
    return e[n] === void 0 && (e[n] = t(n)), e[n];
  };
}
var Mht = function(t, e, n) {
  for (var r = 0, i = 0; r = i, i = cu(), r === 38 && i === 12 && (e[n] = 1), !Em(i); )
    da();
  return $v(t, Ro);
}, Fht = function(t, e) {
  return mre(function(n, r) {
    var i = -1, o = 44;
    do
      switch (Em(o)) {
        case 0:
          o === 38 && cu() === 12 && (r[i] = 1), n[i] += Mht(Ro - 1, r, i);
          break;
        case 2:
          n[i] += Hy(o);
          break;
        case 4:
          if (o === 44) {
            n[++i] = cu() === 58 ? "&\f" : "", r[i] = n[i].length;
            break;
          }
        default:
          n[i] += iE(o);
      }
    while (o = da());
    return n;
  }(gre(t), e));
}, bB = /* @__PURE__ */ new WeakMap(), Lht = function(t) {
  if (t.type === "rule" && t.parent && !(t.length < 1)) {
    for (var e = t.value, n = t.parent, r = t.column === n.column && t.line === n.line; n.type !== "rule"; )
      if (!(n = n.parent))
        return;
    if ((t.props.length !== 1 || e.charCodeAt(0) === 58 || bB.get(n)) && !r) {
      bB.set(t, !0);
      for (var i = [], o = Fht(e, i), a = n.props, s = 0, u = 0; s < o.length; s++)
        for (var l = 0; l < a.length; l++, u++)
          t.props[u] = i[s] ? o[s].replace(/&\f/g, a[l]) : a[l] + " " + o[s];
    }
  }
}, Vht = function(t) {
  if (t.type === "decl") {
    var e = t.value;
    e.charCodeAt(0) === 108 && e.charCodeAt(2) === 98 && (t.return = "", t.value = "");
  }
}, Bht = function(t) {
  return t.type === "comm" && t.children.indexOf("emotion-disable-server-rendering-unsafe-selector-warning-please-do-not-use-this-the-warning-exists-for-a-reason") > -1;
}, yB = function(t) {
  return t.type.charCodeAt(1) === 105 && t.type.charCodeAt(0) === 64;
}, xB = function(t) {
  t.type = "", t.value = "", t.return = "", t.children = "", t.props = "";
}, Hht = function(t, e, n) {
  yB(t) && (t.parent ? (console.error("`@import` rules can't be nested inside other rules. Please move it to the top level and put it before regular rules. Keep in mind that they can only be used within global styles."), xB(t)) : function(r, i) {
    for (var o = r - 1; o >= 0; o--)
      if (!yB(i[o]))
        return !0;
    return !1;
  }(e, n) && (console.error("`@import` rules can't be after other rules. Please put your `@import` rules before your other rules."), xB(t)));
};
function bre(t, e) {
  switch (function(n, r) {
    return 45 ^ Mi(n, 0) ? (((r << 2 ^ Mi(n, 0)) << 2 ^ Mi(n, 1)) << 2 ^ Mi(n, 2)) << 2 ^ Mi(n, 3) : 0;
  }(t, e)) {
    case 5103:
      return Xn + "print-" + t + t;
    case 5737:
    case 4201:
    case 3177:
    case 3433:
    case 1641:
    case 4457:
    case 2921:
    case 5572:
    case 6356:
    case 5844:
    case 3191:
    case 6645:
    case 3005:
    case 6391:
    case 5879:
    case 5623:
    case 6135:
    case 4599:
    case 4855:
    case 4215:
    case 6389:
    case 5109:
    case 5365:
    case 5621:
    case 3829:
      return Xn + t + t;
    case 5349:
    case 4246:
    case 4810:
    case 6968:
    case 2756:
      return Xn + t + fB + t + Da + t + t;
    case 6828:
    case 4268:
      return Xn + t + Da + t + t;
    case 6165:
      return Xn + t + Da + "flex-" + t + t;
    case 5187:
      return Xn + t + sr(t, /(\w+).+(:[^]+)/, Xn + "box-$1$2-ms-flex-$1$2") + t;
    case 5443:
      return Xn + t + Da + "flex-item-" + sr(t, /flex-|-self/, "") + t;
    case 4675:
      return Xn + t + Da + "flex-line-pack" + sr(t, /align-content|flex-|-self/, "") + t;
    case 5548:
      return Xn + t + Da + sr(t, "shrink", "negative") + t;
    case 5292:
      return Xn + t + Da + sr(t, "basis", "preferred-size") + t;
    case 6060:
      return Xn + "box-" + sr(t, "-grow", "") + Xn + t + Da + sr(t, "grow", "positive") + t;
    case 4554:
      return Xn + sr(t, /([^-])(transform)/g, "$1" + Xn + "$2") + t;
    case 6187:
      return sr(sr(sr(t, /(zoom-|grab)/, Xn + "$1"), /(image-set)/, Xn + "$1"), t, "") + t;
    case 5495:
    case 3959:
      return sr(t, /(image-set\([^]*)/, Xn + "$1$`$1");
    case 4968:
      return sr(sr(t, /(.+:)(flex-)?(.*)/, Xn + "box-pack:$3-ms-flex-pack:$3"), /s.+-b[^;]+/, "justify") + Xn + t + t;
    case 4095:
    case 3583:
    case 4068:
    case 2532:
      return sr(t, /(.+)-inline(.+)/, Xn + "$1$2") + t;
    case 8116:
    case 7059:
    case 5753:
    case 5535:
    case 5445:
    case 5701:
    case 4933:
    case 4677:
    case 5533:
    case 5789:
    case 5021:
    case 4765:
      if (Js(t) - 1 - e > 6)
        switch (Mi(t, e + 1)) {
          case 109:
            if (Mi(t, e + 4) !== 45)
              break;
          case 102:
            return sr(t, /(.+:)(.+)-([^]+)/, "$1" + Xn + "$2-$3$1" + fB + (Mi(t, e + 3) == 108 ? "$3" : "$2-$3")) + t;
          case 115:
            return ~A6(t, "stretch") ? bre(sr(t, "stretch", "fill-available"), e) + t : t;
        }
      break;
    case 4949:
      if (Mi(t, e + 1) !== 115)
        break;
    case 6444:
      switch (Mi(t, Js(t) - 3 - (~A6(t, "!important") && 10))) {
        case 107:
          return sr(t, ":", ":" + Xn) + t;
        case 101:
          return sr(t, /(.+:)([^;!]+)(;|!.+)?/, "$1" + Xn + (Mi(t, 14) === 45 ? "inline-" : "") + "box$3$1" + Xn + "$2$3$1-ms-$2box$3") + t;
      }
      break;
    case 5936:
      switch (Mi(t, e + 11)) {
        case 114:
          return Xn + t + Da + sr(t, /[svh]\w+-[tblr]{2}/, "tb") + t;
        case 108:
          return Xn + t + Da + sr(t, /[svh]\w+-[tblr]{2}/, "tb-rl") + t;
        case 45:
          return Xn + t + Da + sr(t, /[svh]\w+-[tblr]{2}/, "lr") + t;
      }
      return Xn + t + Da + t + t;
  }
  return t;
}
var CB, Kb, jy = typeof document < "u", Wht = jy ? void 0 : (CB = function() {
  return vre(function() {
    var t = {};
    return function(e) {
      return t[e];
    };
  });
}, Kb = /* @__PURE__ */ new WeakMap(), function(t) {
  if (Kb.has(t))
    return Kb.get(t);
  var e = CB(t);
  return Kb.set(t, e), e;
}), jht = [function(t, e, n, r) {
  if (t.length > -1 && !t.return)
    switch (t.type) {
      case K8:
        t.return = bre(t.value, t.length);
        break;
      case fre:
        return Td([Ug(t, { value: sr(t.value, "@", "@" + Xn) })], r);
      case "rule":
        if (t.length)
          return function(i, o) {
            return i.map(o).join("");
          }(t.props, function(i) {
            switch (function(o, a) {
              return (o = a.exec(o)) ? o[0] : o;
            }(i, /(::plac\w+|:read-\w+)/)) {
              case ":read-only":
              case ":read-write":
                return Td([Ug(t, { props: [sr(i, /:(read-\w+)/, ":-moz-$1")] })], r);
              case "::placeholder":
                return Td([Ug(t, { props: [sr(i, /:(plac\w+)/, ":" + Xn + "input-$1")] }), Ug(t, { props: [sr(i, /:(plac\w+)/, ":-moz-$1")] }), Ug(t, { props: [sr(i, /:(plac\w+)/, "-ms-input-$1")] })], r);
            }
            return "";
          });
    }
}], yre = function(t) {
  var e = t.key;
  if (process.env.NODE_ENV !== "production" && !e)
    throw new Error(`You have to configure \`key\` for your cache. Please make sure it's unique (and not equal to 'css') as it's used for linking styles to your cache.
If multiple caches share the same key they might "fight" for each other's style elements.`);
  if (jy && e === "css") {
    var n = document.querySelectorAll("style[data-emotion]:not([data-s])");
    Array.prototype.forEach.call(n, function(b) {
      b.getAttribute("data-emotion").indexOf(" ") !== -1 && (document.head.appendChild(b), b.setAttribute("data-s", ""));
    });
  }
  var r = t.stylisPlugins || jht;
  if (process.env.NODE_ENV !== "production" && /[^a-z-]/.test(e))
    throw new Error('Emotion key must only contain lower case alphabetical characters and - but "' + e + '" was passed');
  var i, o, a = {}, s = [];
  jy && (i = t.container || document.head, Array.prototype.forEach.call(document.querySelectorAll('style[data-emotion^="' + e + ' "]'), function(b) {
    for (var y = b.getAttribute("data-emotion").split(" "), w = 1; w < y.length; w++)
      a[y[w]] = !0;
    s.push(b);
  }));
  var u = [Lht, Vht];
  if (process.env.NODE_ENV !== "production" && u.push(/* @__PURE__ */ function(b) {
    return function(y, w, S) {
      if (y.type === "rule" && !b.compat) {
        var E = y.value.match(/(:first|:nth|:nth-last)-child/g);
        if (E) {
          for (var I = y.parent === S[0] ? S[0].children : S, _ = I.length - 1; _ >= 0; _--) {
            var A = I[_];
            if (A.line < y.line)
              break;
            if (A.column < y.column) {
              if (Bht(A))
                return;
              break;
            }
          }
          E.forEach(function(P) {
            console.error('The pseudo class "' + P + '" is potentially unsafe when doing server-side rendering. Try changing it to "' + P.split("-child")[0] + '-of-type".');
          });
        }
      }
    };
  }({ get compat() {
    return m.compat;
  } }), Hht), jy) {
    var l, c = [mB, process.env.NODE_ENV !== "production" ? function(b) {
      b.root || (b.return ? l.insert(b.return) : b.value && b.type !== "comm" && l.insert(b.value + "{}"));
    } : Dht(function(b) {
      l.insert(b);
    })], d = vB(u.concat(r, c));
    o = function(b, y, w, S) {
      l = w, process.env.NODE_ENV !== "production" && y.map !== void 0 && (l = { insert: function(E) {
        w.insert(E + y.map);
      } }), Td(hB(b ? b + "{" + y.styles + "}" : y.styles), d), S && (m.inserted[y.name] = !0);
    };
  } else {
    var f = [mB], h = vB(u.concat(r, f)), p = Wht(r)(e), v = function(b, y) {
      var w = y.name;
      return p[w] === void 0 && (p[w] = Td(hB(b ? b + "{" + y.styles + "}" : y.styles), h)), p[w];
    };
    o = function(b, y, w, S) {
      var E = y.name, I = v(b, y);
      return m.compat === void 0 ? (S && (m.inserted[E] = !0), process.env.NODE_ENV === "development" && y.map !== void 0 ? I + y.map : I) : S ? void (m.inserted[E] = I) : I;
    };
  }
  var m = { key: e, sheet: new Aht({ key: e, container: i, nonce: t.nonce, speedy: t.speedy, prepend: t.prepend, insertionPoint: t.insertionPoint }), nonce: t.nonce, inserted: a, registered: {}, insert: o };
  return m.sheet.hydrate(s), m;
};
function ur(t, e, n) {
  return t(n = { path: e, exports: {}, require: function(r, i) {
    return function() {
      throw new Error("Dynamic requires are not currently supported by @rollup/plugin-commonjs");
    }(i == null && n.path);
  } }, n.exports), n.exports;
}
var Ni = typeof Symbol == "function" && Symbol.for, O6 = Ni ? Symbol.for("react.element") : 60103, P6 = Ni ? Symbol.for("react.portal") : 60106, zy = Ni ? Symbol.for("react.fragment") : 60107, Gy = Ni ? Symbol.for("react.strict_mode") : 60108, Uy = Ni ? Symbol.for("react.profiler") : 60114, Xy = Ni ? Symbol.for("react.provider") : 60109, Yy = Ni ? Symbol.for("react.context") : 60110, N6 = Ni ? Symbol.for("react.async_mode") : 60111, U2 = Ni ? Symbol.for("react.concurrent_mode") : 60111, Zy = Ni ? Symbol.for("react.forward_ref") : 60112, Jy = Ni ? Symbol.for("react.suspense") : 60113, zht = Ni ? Symbol.for("react.suspense_list") : 60120, Ky = Ni ? Symbol.for("react.memo") : 60115, qy = Ni ? Symbol.for("react.lazy") : 60116, Ght = Ni ? Symbol.for("react.block") : 60121, Uht = Ni ? Symbol.for("react.fundamental") : 60117, Xht = Ni ? Symbol.for("react.responder") : 60118, Yht = Ni ? Symbol.for("react.scope") : 60119;
function ea(t) {
  if (typeof t == "object" && t !== null) {
    var e = t.$$typeof;
    switch (e) {
      case O6:
        switch (t = t.type) {
          case N6:
          case U2:
          case zy:
          case Uy:
          case Gy:
          case Jy:
            return t;
          default:
            switch (t = t && t.$$typeof) {
              case Yy:
              case Zy:
              case qy:
              case Ky:
              case Xy:
                return t;
              default:
                return e;
            }
        }
      case P6:
        return e;
    }
  }
}
function wB(t) {
  return ea(t) === U2;
}
var Zht = { AsyncMode: N6, ConcurrentMode: U2, ContextConsumer: Yy, ContextProvider: Xy, Element: O6, ForwardRef: Zy, Fragment: zy, Lazy: qy, Memo: Ky, Portal: P6, Profiler: Uy, StrictMode: Gy, Suspense: Jy, isAsyncMode: function(t) {
  return wB(t) || ea(t) === N6;
}, isConcurrentMode: wB, isContextConsumer: function(t) {
  return ea(t) === Yy;
}, isContextProvider: function(t) {
  return ea(t) === Xy;
}, isElement: function(t) {
  return typeof t == "object" && t !== null && t.$$typeof === O6;
}, isForwardRef: function(t) {
  return ea(t) === Zy;
}, isFragment: function(t) {
  return ea(t) === zy;
}, isLazy: function(t) {
  return ea(t) === qy;
}, isMemo: function(t) {
  return ea(t) === Ky;
}, isPortal: function(t) {
  return ea(t) === P6;
}, isProfiler: function(t) {
  return ea(t) === Uy;
}, isStrictMode: function(t) {
  return ea(t) === Gy;
}, isSuspense: function(t) {
  return ea(t) === Jy;
}, isValidElementType: function(t) {
  return typeof t == "string" || typeof t == "function" || t === zy || t === U2 || t === Uy || t === Gy || t === Jy || t === zht || typeof t == "object" && t !== null && (t.$$typeof === qy || t.$$typeof === Ky || t.$$typeof === Xy || t.$$typeof === Yy || t.$$typeof === Zy || t.$$typeof === Uht || t.$$typeof === Xht || t.$$typeof === Yht || t.$$typeof === Ght);
}, typeOf: ea }, Jht = ur(function(t, e) {
  process.env.NODE_ENV !== "production" && function() {
    var n = typeof Symbol == "function" && Symbol.for, r = n ? Symbol.for("react.element") : 60103, i = n ? Symbol.for("react.portal") : 60106, o = n ? Symbol.for("react.fragment") : 60107, a = n ? Symbol.for("react.strict_mode") : 60108, s = n ? Symbol.for("react.profiler") : 60114, u = n ? Symbol.for("react.provider") : 60109, l = n ? Symbol.for("react.context") : 60110, c = n ? Symbol.for("react.async_mode") : 60111, d = n ? Symbol.for("react.concurrent_mode") : 60111, f = n ? Symbol.for("react.forward_ref") : 60112, h = n ? Symbol.for("react.suspense") : 60113, p = n ? Symbol.for("react.suspense_list") : 60120, v = n ? Symbol.for("react.memo") : 60115, m = n ? Symbol.for("react.lazy") : 60116, b = n ? Symbol.for("react.block") : 60121, y = n ? Symbol.for("react.fundamental") : 60117, w = n ? Symbol.for("react.responder") : 60118, S = n ? Symbol.for("react.scope") : 60119;
    function E(j) {
      if (typeof j == "object" && j !== null) {
        var K = j.$$typeof;
        switch (K) {
          case r:
            var W = j.type;
            switch (W) {
              case c:
              case d:
              case o:
              case s:
              case a:
              case h:
                return W;
              default:
                var Y = W && W.$$typeof;
                switch (Y) {
                  case l:
                  case f:
                  case m:
                  case v:
                  case u:
                    return Y;
                  default:
                    return K;
                }
            }
          case i:
            return K;
        }
      }
    }
    var I = c, _ = d, A = l, P = u, N = r, k = f, D = o, R = m, V = v, $ = i, F = s, M = a, B = h, X = !1;
    function L(j) {
      return E(j) === d;
    }
    e.AsyncMode = I, e.ConcurrentMode = _, e.ContextConsumer = A, e.ContextProvider = P, e.Element = N, e.ForwardRef = k, e.Fragment = D, e.Lazy = R, e.Memo = V, e.Portal = $, e.Profiler = F, e.StrictMode = M, e.Suspense = B, e.isAsyncMode = function(j) {
      return X || (X = !0, console.warn("The ReactIs.isAsyncMode() alias has been deprecated, and will be removed in React 17+. Update your code to use ReactIs.isConcurrentMode() instead. It has the exact same API.")), L(j) || E(j) === c;
    }, e.isConcurrentMode = L, e.isContextConsumer = function(j) {
      return E(j) === l;
    }, e.isContextProvider = function(j) {
      return E(j) === u;
    }, e.isElement = function(j) {
      return typeof j == "object" && j !== null && j.$$typeof === r;
    }, e.isForwardRef = function(j) {
      return E(j) === f;
    }, e.isFragment = function(j) {
      return E(j) === o;
    }, e.isLazy = function(j) {
      return E(j) === m;
    }, e.isMemo = function(j) {
      return E(j) === v;
    }, e.isPortal = function(j) {
      return E(j) === i;
    }, e.isProfiler = function(j) {
      return E(j) === s;
    }, e.isStrictMode = function(j) {
      return E(j) === a;
    }, e.isSuspense = function(j) {
      return E(j) === h;
    }, e.isValidElementType = function(j) {
      return typeof j == "string" || typeof j == "function" || j === o || j === d || j === s || j === a || j === h || j === p || typeof j == "object" && j !== null && (j.$$typeof === m || j.$$typeof === v || j.$$typeof === u || j.$$typeof === l || j.$$typeof === f || j.$$typeof === y || j.$$typeof === w || j.$$typeof === S || j.$$typeof === b);
    }, e.typeOf = E;
  }();
}), EB = ur(function(t) {
  process.env.NODE_ENV === "production" ? t.exports = Zht : t.exports = Jht;
}), SB = {};
SB[EB.ForwardRef] = { $$typeof: !0, render: !0, defaultProps: !0, displayName: !0, propTypes: !0 }, SB[EB.Memo] = { $$typeof: !0, compare: !0, defaultProps: !0, displayName: !0, propTypes: !0, type: !0 };
var k6 = typeof document < "u";
function xre(t, e, n) {
  var r = "";
  return n.split(" ").forEach(function(i) {
    t[i] !== void 0 ? e.push(t[i] + ";") : r += i + " ";
  }), r;
}
var Q8 = function(t, e, n) {
  var r = t.key + "-" + e.name;
  (n === !1 || k6 === !1 && t.compat !== void 0) && t.registered[r] === void 0 && (t.registered[r] = e.styles);
}, eP = function(t, e, n) {
  Q8(t, e, n);
  var r = t.key + "-" + e.name;
  if (t.inserted[e.name] === void 0) {
    var i = "", o = e;
    do {
      var a = t.insert(e === o ? "." + r : "", o, t.sheet, !0);
      k6 || a === void 0 || (i += a), o = o.next;
    } while (o !== void 0);
    if (!k6 && i.length !== 0)
      return i;
  }
}, Kht = { animationIterationCount: 1, borderImageOutset: 1, borderImageSlice: 1, borderImageWidth: 1, boxFlex: 1, boxFlexGroup: 1, boxOrdinalGroup: 1, columnCount: 1, columns: 1, flex: 1, flexGrow: 1, flexPositive: 1, flexShrink: 1, flexNegative: 1, flexOrder: 1, gridRow: 1, gridRowEnd: 1, gridRowSpan: 1, gridRowStart: 1, gridColumn: 1, gridColumnEnd: 1, gridColumnSpan: 1, gridColumnStart: 1, msGridRow: 1, msGridRowSpan: 1, msGridColumn: 1, msGridColumnSpan: 1, fontWeight: 1, lineHeight: 1, opacity: 1, order: 1, orphans: 1, tabSize: 1, widows: 1, zIndex: 1, zoom: 1, WebkitLineClamp: 1, fillOpacity: 1, floodOpacity: 1, stopOpacity: 1, strokeDasharray: 1, strokeDashoffset: 1, strokeMiterlimit: 1, strokeOpacity: 1, strokeWidth: 1 }, IB = `You have illegal escape sequence in your template literal, most likely inside content's property value.
Because you write your CSS inside a JavaScript string you actually have to do double escaping, so for example "content: '\\00d7';" should become "content: '\\\\00d7';".
You can read more about this here:
https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Template_literals#ES2018_revision_of_illegal_escape_sequences`, qht = "You have passed in falsy value as style object's key (can happen when in example you pass unexported component as computed key).", Qht = /[A-Z]|^ms/g, Cre = /_EMO_([^_]+?)_([^]*?)_EMO_/g, tP = function(t) {
  return t.charCodeAt(1) === 45;
}, _B = function(t) {
  return t != null && typeof t != "boolean";
}, H5 = vre(function(t) {
  return tP(t) ? t : t.replace(Qht, "-$&").toLowerCase();
}), X2 = function(t, e) {
  switch (t) {
    case "animation":
    case "animationName":
      if (typeof e == "string")
        return e.replace(Cre, function(n, r, i) {
          return xs = { name: r, styles: i, next: xs }, r;
        });
  }
  return Kht[t] === 1 || tP(t) || typeof e != "number" || e === 0 ? e : e + "px";
};
if (process.env.NODE_ENV !== "production") {
  var ept = /(var|attr|counters?|url|element|(((repeating-)?(linear|radial))|conic)-gradient)\(|(no-)?(open|close)-quote/, tpt = ["normal", "none", "initial", "inherit", "unset"], npt = X2, rpt = /^-ms-/, ipt = /-(.)/g, AB = {};
  X2 = function(t, e) {
    if (t === "content" && (typeof e != "string" || tpt.indexOf(e) === -1 && !ept.test(e) && (e.charAt(0) !== e.charAt(e.length - 1) || e.charAt(0) !== '"' && e.charAt(0) !== "'")))
      throw new Error("You seem to be using a value for 'content' without quotes, try replacing it with `content: '\"" + e + "\"'`");
    var n = npt(t, e);
    return n === "" || tP(t) || t.indexOf("-") === -1 || AB[t] !== void 0 || (AB[t] = !0, console.error("Using kebab-case for css properties in objects is not supported. Did you mean " + t.replace(rpt, "ms-").replace(ipt, function(r, i) {
      return i.toUpperCase();
    }) + "?")), n;
  };
}
var TB = "Component selectors can only be used in conjunction with @emotion/babel-plugin, the swc Emotion plugin, or another Emotion-aware compiler transform.";
function F0(t, e, n) {
  if (n == null)
    return "";
  if (n.__emotion_styles !== void 0) {
    if (process.env.NODE_ENV !== "production" && n.toString() === "NO_COMPONENT_SELECTOR")
      throw new Error(TB);
    return n;
  }
  switch (typeof n) {
    case "boolean":
      return "";
    case "object":
      if (n.anim === 1)
        return xs = { name: n.name, styles: n.styles, next: xs }, n.name;
      if (n.styles !== void 0) {
        var r = n.next;
        if (r !== void 0)
          for (; r !== void 0; )
            xs = { name: r.name, styles: r.styles, next: xs }, r = r.next;
        var i = n.styles + ";";
        return process.env.NODE_ENV !== "production" && n.map !== void 0 && (i += n.map), i;
      }
      return function(c, d, f) {
        var h = "";
        if (Array.isArray(f))
          for (var p = 0; p < f.length; p++)
            h += F0(c, d, f[p]) + ";";
        else
          for (var v in f) {
            var m = f[v];
            if (typeof m != "object")
              d != null && d[m] !== void 0 ? h += v + "{" + d[m] + "}" : _B(m) && (h += H5(v) + ":" + X2(v, m) + ";");
            else {
              if (v === "NO_COMPONENT_SELECTOR" && process.env.NODE_ENV !== "production")
                throw new Error(TB);
              if (!Array.isArray(m) || typeof m[0] != "string" || d != null && d[m[0]] !== void 0) {
                var b = F0(c, d, m);
                switch (v) {
                  case "animation":
                  case "animationName":
                    h += H5(v) + ":" + b + ";";
                    break;
                  default:
                    process.env.NODE_ENV !== "production" && v === "undefined" && console.error(qht), h += v + "{" + b + "}";
                }
              } else
                for (var y = 0; y < m.length; y++)
                  _B(m[y]) && (h += H5(v) + ":" + X2(v, m[y]) + ";");
            }
          }
        return h;
      }(t, e, n);
    case "function":
      if (t !== void 0) {
        var o = xs, a = n(t);
        return xs = o, F0(t, e, a);
      }
      process.env.NODE_ENV !== "production" && console.error("Functions that are interpolated in css calls will be stringified.\nIf you want to have a css call based on props, create a function that returns a css call like this\nlet dynamicStyle = (props) => css`color: ${props.color}`\nIt can be called directly with props or interpolated in a styled call like this\nlet SomeComponent = styled('div')`${dynamicStyle}`");
      break;
    case "string":
      if (process.env.NODE_ENV !== "production") {
        var s = [], u = n.replace(Cre, function(c, d, f) {
          var h = "animation" + s.length;
          return s.push("const " + h + " = keyframes`" + f.replace(/^@keyframes animation-\w+/, "") + "`"), "${" + h + "}";
        });
        s.length && console.error("`keyframes` output got interpolated into plain string, please wrap it with `css`.\n\nInstead of doing this:\n\n" + [].concat(s, ["`" + u + "`"]).join(`
`) + `

You should wrap it with \`css\` like this:

css\`` + u + "`");
      }
  }
  if (e == null)
    return n;
  var l = e[n];
  return l !== void 0 ? l : n;
}
var wre, xs, OB = /label:\s*([^\s;\n{]+)\s*(;|$)/g;
process.env.NODE_ENV !== "production" && (wre = /\/\*#\ssourceMappingURL=data:application\/json;\S+\s+\*\//g);
var Sm = function(t, e, n) {
  if (t.length === 1 && typeof t[0] == "object" && t[0] !== null && t[0].styles !== void 0)
    return t[0];
  var r = !0, i = "";
  xs = void 0;
  var o, a = t[0];
  a == null || a.raw === void 0 ? (r = !1, i += F0(n, e, a)) : (process.env.NODE_ENV !== "production" && a[0] === void 0 && console.error(IB), i += a[0]);
  for (var s = 1; s < t.length; s++)
    i += F0(n, e, t[s]), r && (process.env.NODE_ENV !== "production" && a[s] === void 0 && console.error(IB), i += a[s]);
  process.env.NODE_ENV !== "production" && (i = i.replace(wre, function(d) {
    return o = d, "";
  })), OB.lastIndex = 0;
  for (var u, l = ""; (u = OB.exec(i)) !== null; )
    l += "-" + u[1];
  var c = function(d) {
    for (var f, h = 0, p = 0, v = d.length; v >= 4; ++p, v -= 4)
      f = 1540483477 * (65535 & (f = 255 & d.charCodeAt(p) | (255 & d.charCodeAt(++p)) << 8 | (255 & d.charCodeAt(++p)) << 16 | (255 & d.charCodeAt(++p)) << 24)) + (59797 * (f >>> 16) << 16), h = 1540483477 * (65535 & (f ^= f >>> 24)) + (59797 * (f >>> 16) << 16) ^ 1540483477 * (65535 & h) + (59797 * (h >>> 16) << 16);
    switch (v) {
      case 3:
        h ^= (255 & d.charCodeAt(p + 2)) << 16;
      case 2:
        h ^= (255 & d.charCodeAt(p + 1)) << 8;
      case 1:
        h = 1540483477 * (65535 & (h ^= 255 & d.charCodeAt(p))) + (59797 * (h >>> 16) << 16);
    }
    return (((h = 1540483477 * (65535 & (h ^= h >>> 13)) + (59797 * (h >>> 16) << 16)) ^ h >>> 15) >>> 0).toString(36);
  }(i) + l;
  return process.env.NODE_ENV !== "production" ? { name: c, styles: i, map: o, next: xs, toString: function() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
  } } : { name: c, styles: i, next: xs };
}, opt = typeof document < "u", apt = function(t) {
  return t();
}, Ere = !!x.useInsertionEffect && x.useInsertionEffect, Sre = opt && Ere || apt, PB = Ere || Ua, Jh = typeof document < "u", nP = {}.hasOwnProperty, Im = oi(typeof HTMLElement < "u" ? yre({ key: "css" }) : null);
process.env.NODE_ENV !== "production" && (Im.displayName = "EmotionCacheContext"), Im.Provider;
var sE = function(t) {
  return gt(function(e, n) {
    var r = fn(Im);
    return t(e, r, n);
  });
};
Jh || (sE = function(t) {
  return function(e) {
    var n = fn(Im);
    return n === null ? (n = yre({ key: "css" }), Pe(Im.Provider, { value: n }, t(e, n))) : t(e, n);
  };
});
var uE = oi({});
process.env.NODE_ENV !== "production" && (uE.displayName = "EmotionThemeContext");
var spt = function(t) {
  var e = t.split(".");
  return e[e.length - 1];
}, upt = /* @__PURE__ */ new Set(["renderWithHooks", "processChild", "finishClassComponent", "renderToString"]), R6 = "__EMOTION_TYPE_PLEASE_DO_NOT_USE__", $6 = "__EMOTION_LABEL_PLEASE_DO_NOT_USE__", lpt = function(t, e) {
  if (process.env.NODE_ENV !== "production" && typeof e.css == "string" && e.css.indexOf(":") !== -1)
    throw new Error("Strings are not allowed as css prop values, please wrap it in a css template literal from '@emotion/react' like this: css`" + e.css + "`");
  var n = {};
  for (var r in e)
    nP.call(e, r) && (n[r] = e[r]);
  if (n[R6] = t, process.env.NODE_ENV !== "production" && e.css && (typeof e.css != "object" || typeof e.css.name != "string" || e.css.name.indexOf("-") === -1)) {
    var i = function(o) {
      if (o)
        for (var a, s, u = o.split(`
`), l = 0; l < u.length; l++) {
          var c = (a = u[l], s = void 0, (s = /^\s+at\s+([A-Za-z0-9$.]+)\s/.exec(a)) || (s = /^([A-Za-z0-9$.]+)@/.exec(a)) ? spt(s[1]) : void 0);
          if (c) {
            if (upt.has(c))
              break;
            if (/^[A-Z]/.test(c))
              return c.replace(/\$/g, "-");
          }
        }
    }(new Error().stack);
    i && (n[$6] = i);
  }
  return n;
}, cpt = function(t) {
  var e = t.cache, n = t.serialized, r = t.isStringTag;
  Q8(e, n, r);
  var i = Sre(function() {
    return eP(e, n, r);
  });
  if (!Jh && i !== void 0) {
    for (var o, a = n.name, s = n.next; s !== void 0; )
      a += " " + s.name, s = s.next;
    return Pe("style", ((o = {})["data-emotion"] = e.key + " " + a, o.dangerouslySetInnerHTML = { __html: i }, o.nonce = e.sheet.nonce, o));
  }
  return null;
}, Ire = sE(function(t, e, n) {
  var r = t.css;
  typeof r == "string" && e.registered[r] !== void 0 && (r = e.registered[r]);
  var i = t[R6], o = [r], a = "";
  typeof t.className == "string" ? a = xre(e.registered, o, t.className) : t.className != null && (a = t.className + " ");
  var s = Sm(o, void 0, fn(uE));
  if (process.env.NODE_ENV !== "production" && s.name.indexOf("-") === -1) {
    var u = t[$6];
    u && (s = Sm([s, "label:" + u + ";"]));
  }
  a += e.key + "-" + s.name;
  var l = {};
  for (var c in t)
    !nP.call(t, c) || c === "css" || c === R6 || process.env.NODE_ENV !== "production" && c === $6 || (l[c] = t[c]);
  return l.ref = n, l.className = a, Pe(ha, null, Pe(cpt, { cache: e, serialized: s, isStringTag: typeof i == "string" }), Pe(i, l));
});
process.env.NODE_ENV !== "production" && (Ire.displayName = "EmotionCssPropInternal"), ur(function(t) {
  function e() {
    return t.exports = e = Object.assign ? Object.assign.bind() : function(n) {
      for (var r = 1; r < arguments.length; r++) {
        var i = arguments[r];
        for (var o in i)
          Object.prototype.hasOwnProperty.call(i, o) && (n[o] = i[o]);
      }
      return n;
    }, t.exports.__esModule = !0, t.exports.default = t.exports, e.apply(this, arguments);
  }
  t.exports = e, t.exports.__esModule = !0, t.exports.default = t.exports;
});
var zt = function(t, e) {
  var n = arguments;
  if (e == null || !nP.call(e, "css"))
    return Pe.apply(void 0, n);
  var r = n.length, i = new Array(r);
  i[0] = Ire, i[1] = lpt(t, e);
  for (var o = 2; o < r; o++)
    i[o] = n[o];
  return Pe.apply(null, i);
}, NB = !1, dpt = sE(function(t, e) {
  process.env.NODE_ENV === "production" || NB || !t.className && !t.css || (console.error("It looks like you're using the css prop on Global, did you mean to use the styles prop instead?"), NB = !0);
  var n = t.styles, r = Sm([n], void 0, fn(uE));
  if (!Jh) {
    for (var i, o = r.name, a = r.styles, s = r.next; s !== void 0; )
      o += " " + s.name, a += s.styles, s = s.next;
    var u = e.compat === !0, l = e.insert("", { name: o, styles: a }, e.sheet, u);
    return u ? null : Pe("style", ((i = {})["data-emotion"] = e.key + "-global " + o, i.dangerouslySetInnerHTML = { __html: l }, i.nonce = e.sheet.nonce, i));
  }
  var c = Ee();
  return PB(function() {
    var d = e.key + "-global", f = new e.sheet.constructor({ key: d, nonce: e.sheet.nonce, container: e.sheet.container, speedy: e.sheet.isSpeedy }), h = !1, p = document.querySelector('style[data-emotion="' + d + " " + r.name + '"]');
    return e.sheet.tags.length && (f.before = e.sheet.tags[0]), p !== null && (h = !0, p.setAttribute("data-emotion", d), f.hydrate([p])), c.current = [f, h], function() {
      f.flush();
    };
  }, [e]), PB(function() {
    var d = c.current, f = d[0];
    if (d[1])
      d[1] = !1;
    else {
      if (r.next !== void 0 && eP(e, r.next, !0), f.tags.length) {
        var h = f.tags[f.tags.length - 1].nextElementSibling;
        f.before = h, f.flush();
      }
      e.insert("", r, f, !1);
    }
  }, [e, r.name]), null;
});
function rP() {
  for (var t = arguments.length, e = new Array(t), n = 0; n < t; n++)
    e[n] = arguments[n];
  return Sm(e);
}
process.env.NODE_ENV !== "production" && (dpt.displayName = "EmotionGlobal");
var fpt = function t(e) {
  for (var n = e.length, r = 0, i = ""; r < n; r++) {
    var o = e[r];
    if (o != null) {
      var a = void 0;
      switch (typeof o) {
        case "boolean":
          break;
        case "object":
          if (Array.isArray(o))
            a = t(o);
          else
            for (var s in process.env.NODE_ENV !== "production" && o.styles !== void 0 && o.name !== void 0 && console.error("You have passed styles created with `css` from `@emotion/react` package to the `cx`.\n`cx` is meant to compose class names (strings) so you should convert those styles to a class name by passing them to the `css` received from <ClassNames/> component."), a = "", o)
              o[s] && s && (a && (a += " "), a += s);
          break;
        default:
          a = o;
      }
      a && (i && (i += " "), i += a);
    }
  }
  return i;
};
function hpt(t, e, n) {
  var r = [], i = xre(t, r, n);
  return r.length < 2 ? n : i + e(r);
}
var ppt = function(t) {
  var e, n = t.cache, r = t.serializedArr, i = Sre(function() {
    for (var o = "", a = 0; a < r.length; a++) {
      var s = eP(n, r[a], !1);
      Jh || s === void 0 || (o += s);
    }
    if (!Jh)
      return o;
  });
  return Jh || i.length === 0 ? null : Pe("style", ((e = {})["data-emotion"] = n.key + " " + r.map(function(o) {
    return o.name;
  }).join(" "), e.dangerouslySetInnerHTML = { __html: i }, e.nonce = n.sheet.nonce, e));
}, gpt = sE(function(t, e) {
  var n = !1, r = [], i = function() {
    if (n && process.env.NODE_ENV !== "production")
      throw new Error("css can only be used during render");
    for (var s = arguments.length, u = new Array(s), l = 0; l < s; l++)
      u[l] = arguments[l];
    var c = Sm(u, e.registered);
    return r.push(c), Q8(e, c, !1), e.key + "-" + c.name;
  }, o = { css: i, cx: function() {
    if (n && process.env.NODE_ENV !== "production")
      throw new Error("cx can only be used during render");
    for (var s = arguments.length, u = new Array(s), l = 0; l < s; l++)
      u[l] = arguments[l];
    return hpt(e.registered, i, fpt(u));
  }, theme: fn(uE) }, a = t.children(o);
  return n = !0, Pe(ha, null, Pe(ppt, { cache: e, serializedArr: r }), a);
});
if (process.env.NODE_ENV !== "production" && (gpt.displayName = "EmotionClassNames"), process.env.NODE_ENV !== "production") {
  var kB = typeof document < "u", mpt = typeof jest < "u" || typeof vi < "u";
  if (kB && !mpt) {
    var RB = typeof globalThis < "u" ? globalThis : kB ? window : global, $B = "__EMOTION_REACT_" + "11.10.5".split(".")[0] + "__";
    RB[$B] && console.warn("You are loading @emotion/react when it is already loaded. Running multiple instances may cause problems. This can happen if multiple versions are used, or if multiple builds of the same version are used."), RB[$B] = !0;
  }
}
function Ii(t, e) {
  return function(n) {
    if (Array.isArray(n))
      return n;
  }(t) || function(n, r) {
    var i = n == null ? null : typeof Symbol < "u" && n[Symbol.iterator] || n["@@iterator"];
    if (i != null) {
      var o, a, s, u, l = [], c = !0, d = !1;
      try {
        if (s = (i = i.call(n)).next, r === 0) {
          if (Object(i) !== i)
            return;
          c = !1;
        } else
          for (; !(c = (o = s.call(i)).done) && (l.push(o.value), l.length !== r); c = !0)
            ;
      } catch (f) {
        d = !0, a = f;
      } finally {
        try {
          if (!c && i.return != null && (u = i.return(), Object(u) !== u))
            return;
        } finally {
          if (d)
            throw a;
        }
      }
      return l;
    }
  }(t, e) || dre(t, e) || function() {
    throw new TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
  }();
}
function tu(t, e) {
  if (t == null)
    return {};
  var n, r, i = function(a, s) {
    if (a == null)
      return {};
    var u, l, c = {}, d = Object.keys(a);
    for (l = 0; l < d.length; l++)
      u = d[l], s.indexOf(u) >= 0 || (c[u] = a[u]);
    return c;
  }(t, e);
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(t);
    for (r = 0; r < o.length; r++)
      n = o[r], e.indexOf(n) >= 0 || Object.prototype.propertyIsEnumerable.call(t, n) && (i[n] = t[n]);
  }
  return i;
}
function ou(t) {
  var e;
  return ((e = t.ownerDocument) == null ? void 0 : e.defaultView) || window;
}
function _re(t) {
  return ou(t).getComputedStyle(t);
}
const qb = Math.round;
function Are(t) {
  return Ore(t) ? (t.nodeName || "").toLowerCase() : "";
}
let Qb;
function Tre(t) {
  return t instanceof ou(t).HTMLElement;
}
function Kh(t) {
  return t instanceof ou(t).Element;
}
function Ore(t) {
  return t instanceof ou(t).Node;
}
function DB(t) {
  return typeof ShadowRoot > "u" ? !1 : t instanceof ou(t).ShadowRoot || t instanceof ShadowRoot;
}
function Pre(t) {
  const { overflow: e, overflowX: n, overflowY: r, display: i } = _re(t);
  return /auto|scroll|overlay|hidden|clip/.test(e + r + n) && !["inline", "contents"].includes(i);
}
function vpt() {
  return /^((?!chrome|android).)*safari/i.test(function() {
    if (Qb)
      return Qb;
    const t = navigator.userAgentData;
    return t && Array.isArray(t.brands) ? (Qb = t.brands.map((e) => e.brand + "/" + e.version).join(" "), Qb) : navigator.userAgent;
  }());
}
function Nre(t) {
  return Kh(t) ? t : t.contextElement;
}
const kre = { x: 1, y: 1 };
function W5(t) {
  const e = Nre(t);
  if (!Tre(e))
    return kre;
  const n = e.getBoundingClientRect(), { width: r, height: i, fallback: o } = function(u) {
    const l = _re(u);
    let c = parseFloat(l.width), d = parseFloat(l.height);
    const f = u.offsetWidth, h = u.offsetHeight, p = qb(c) !== f || qb(d) !== h;
    return p && (c = f, d = h), { width: c, height: d, fallback: p };
  }(e);
  let a = (o ? qb(n.width) : n.width) / r, s = (o ? qb(n.height) : n.height) / i;
  return a && Number.isFinite(a) || (a = 1), s && Number.isFinite(s) || (s = 1), { x: a, y: s };
}
function MB(t, e, n, r) {
  var i, o;
  e === void 0 && (e = !1), n === void 0 && (n = !1);
  const a = t.getBoundingClientRect(), s = Nre(t);
  let u = kre;
  e && (r ? Kh(r) && (u = W5(r)) : u = W5(t));
  const l = s ? ou(s) : window, c = vpt() && n;
  let d = (a.left + (c && ((i = l.visualViewport) == null ? void 0 : i.offsetLeft) || 0)) / u.x, f = (a.top + (c && ((o = l.visualViewport) == null ? void 0 : o.offsetTop) || 0)) / u.y, h = a.width / u.x, p = a.height / u.y;
  if (s) {
    const v = ou(s), m = r && Kh(r) ? ou(r) : r;
    let b = v.frameElement;
    for (; b && r && m !== v; ) {
      const y = W5(b), w = b.getBoundingClientRect(), S = getComputedStyle(b);
      w.x += (b.clientLeft + parseFloat(S.paddingLeft)) * y.x, w.y += (b.clientTop + parseFloat(S.paddingTop)) * y.y, d *= y.x, f *= y.y, h *= y.x, p *= y.y, d += w.x, f += w.y, b = ou(b).frameElement;
    }
  }
  return { width: h, height: p, top: f, right: d + h, bottom: f + p, left: d, x: d, y: f };
}
function bpt(t) {
  if (Are(t) === "html")
    return t;
  const e = t.assignedSlot || t.parentNode || DB(t) && t.host || function(n) {
    return ((Ore(n) ? n.ownerDocument : n.document) || window.document).documentElement;
  }(t);
  return DB(e) ? e.host : e;
}
function Rre(t) {
  const e = bpt(t);
  return function(n) {
    return ["html", "body", "#document"].includes(Are(n));
  }(e) ? e.ownerDocument.body : Tre(e) && Pre(e) ? e : Rre(e);
}
function Qy(t, e) {
  var n;
  e === void 0 && (e = []);
  const r = Rre(t), i = r === ((n = t.ownerDocument) == null ? void 0 : n.body), o = ou(r);
  return i ? e.concat(o, o.visualViewport || [], Pre(r) ? r : []) : e.concat(r, Qy(r));
}
var D6 = typeof document < "u" ? Ua : Re, ypt = ["className", "clearValue", "cx", "getStyles", "getClassNames", "getValue", "hasValue", "isMulti", "isRtl", "options", "selectOption", "selectProps", "setValue", "theme"], Y2 = function() {
};
function xpt(t, e) {
  return e ? e[0] === "-" ? t + e : t + "__" + e : t;
}
function Cpt(t, e) {
  for (var n = arguments.length, r = new Array(n > 2 ? n - 2 : 0), i = 2; i < n; i++)
    r[i - 2] = arguments[i];
  var o = [].concat(r);
  if (e && t)
    for (var a in e)
      e.hasOwnProperty(a) && e[a] && o.push("".concat(xpt(t, a)));
  return o.filter(function(s) {
    return s;
  }).map(function(s) {
    return String(s).trim();
  }).join(" ");
}
var FB = function(t) {
  return e = t, Array.isArray(e) ? t.filter(Boolean) : Ad(t) === "object" && t !== null ? [t] : [];
  var e;
}, LB = function(t) {
  return t.className, t.clearValue, t.cx, t.getStyles, t.getClassNames, t.getValue, t.hasValue, t.isMulti, t.isRtl, t.options, t.selectOption, t.selectProps, t.setValue, t.theme, Bt({}, tu(t, ypt));
}, Ur = function(t, e, n) {
  var r = t.cx, i = t.getStyles, o = t.getClassNames, a = t.className;
  return { css: i(e, t), className: r(n ?? {}, o(e, t), a) };
};
function lE(t) {
  return [document.documentElement, document.body, window].indexOf(t) > -1;
}
function $re(t) {
  return lE(t) ? window.pageYOffset : t.scrollTop;
}
function Z2(t, e) {
  lE(t) ? window.scrollTo(0, e) : t.scrollTop = e;
}
function wpt(t, e, n, r) {
  return n * ((t = t / r - 1) * t * t + 1) + e;
}
function ey(t, e) {
  var n = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 200, r = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : Y2, i = $re(t), o = e - i, a = 10, s = 0;
  function u() {
    var l = wpt(s += a, i, o, n);
    Z2(t, l), s < n ? window.requestAnimationFrame(u) : r(t);
  }
  u();
}
function VB(t, e) {
  var n = t.getBoundingClientRect(), r = e.getBoundingClientRect(), i = e.offsetHeight / 3;
  r.bottom + i > n.bottom ? Z2(t, Math.min(e.offsetTop + e.clientHeight - t.offsetHeight + i, t.scrollHeight)) : r.top - i < n.top && Z2(t, Math.max(e.offsetTop - i, 0));
}
function BB() {
  try {
    return document.createEvent("TouchEvent"), !0;
  } catch {
    return !1;
  }
}
var Dre = !1, Ept = { get passive() {
  return Dre = !0;
} }, ty = typeof window < "u" ? window : {};
ty.addEventListener && ty.removeEventListener && (ty.addEventListener("p", Y2, Ept), ty.removeEventListener("p", Y2, !1));
var Spt = Dre;
function Ipt(t) {
  return t != null;
}
function ny(t, e, n) {
  return t ? e : n;
}
var _pt = ["children", "innerProps"], Apt = ["children", "innerProps"];
function Tpt(t) {
  var e = t.maxHeight, n = t.menuEl, r = t.minHeight, i = t.placement, o = t.shouldScroll, a = t.isFixedPosition, s = t.controlHeight, u = function($) {
    var F = getComputedStyle($), M = F.position === "absolute", B = /(auto|scroll)/;
    if (F.position === "fixed")
      return document.documentElement;
    for (var X = $; X = X.parentElement; )
      if (F = getComputedStyle(X), (!M || F.position !== "static") && B.test(F.overflow + F.overflowY + F.overflowX))
        return X;
    return document.documentElement;
  }(n), l = { placement: "bottom", maxHeight: e };
  if (!n || !n.offsetParent)
    return l;
  var c, d = u.getBoundingClientRect().height, f = n.getBoundingClientRect(), h = f.bottom, p = f.height, v = f.top, m = n.offsetParent.getBoundingClientRect().top, b = a || lE(c = u) ? window.innerHeight : c.clientHeight, y = $re(u), w = parseInt(getComputedStyle(n).marginBottom, 10), S = parseInt(getComputedStyle(n).marginTop, 10), E = m - S, I = b - v, _ = E + y, A = d - y - v, P = h - b + y + w, N = y + v - S, k = 160;
  switch (i) {
    case "auto":
    case "bottom":
      if (I >= p)
        return { placement: "bottom", maxHeight: e };
      if (A >= p && !a)
        return o && ey(u, P, k), { placement: "bottom", maxHeight: e };
      if (!a && A >= r || a && I >= r)
        return o && ey(u, P, k), { placement: "bottom", maxHeight: a ? I - w : A - w };
      if (i === "auto" || a) {
        var D = e, R = a ? E : _;
        return R >= r && (D = Math.min(R - w - s, e)), { placement: "top", maxHeight: D };
      }
      if (i === "bottom")
        return o && Z2(u, P), { placement: "bottom", maxHeight: e };
      break;
    case "top":
      if (E >= p)
        return { placement: "top", maxHeight: e };
      if (_ >= p && !a)
        return o && ey(u, N, k), { placement: "top", maxHeight: e };
      if (!a && _ >= r || a && E >= r) {
        var V = e;
        return (!a && _ >= r || a && E >= r) && (V = a ? E - S : _ - S), o && ey(u, N, k), { placement: "top", maxHeight: V };
      }
      return { placement: "bottom", maxHeight: e };
    default:
      throw new Error('Invalid placement provided "'.concat(i, '".'));
  }
  return l;
}
var HB, Mre = function(t) {
  return t === "auto" ? "bottom" : t;
}, Fre = oi(null), Opt = function(t) {
  var e = t.children, n = t.minMenuHeight, r = t.maxMenuHeight, i = t.menuPlacement, o = t.menuPosition, a = t.menuShouldScrollIntoView, s = t.theme, u = (fn(Fre) || {}).setPortalPlacement, l = Ee(null), c = Ii(Le(r), 2), d = c[0], f = c[1], h = Ii(Le(null), 2), p = h[0], v = h[1], m = s.spacing.controlHeight;
  return D6(function() {
    var b = l.current;
    if (b) {
      var y = o === "fixed", w = Tpt({ maxHeight: r, menuEl: b, minHeight: n, placement: i, shouldScroll: a && !y, isFixedPosition: y, controlHeight: m });
      f(w.maxHeight), v(w.placement), u == null || u(w.placement);
    }
  }, [r, i, o, a, n, u, m]), e({ ref: l, placerProps: Bt(Bt({}, t), {}, { placement: p || Mre(i), maxHeight: d }) });
}, Ppt = function(t) {
  var e = t.children, n = t.innerRef, r = t.innerProps;
  return zt("div", Kt({}, Ur(t, "menu", { menu: !0 }), { ref: n }, r), e);
}, Lre = function(t, e) {
  var n = t.theme, r = n.spacing.baseUnit, i = n.colors;
  return Bt({ textAlign: "center" }, e ? {} : { color: i.neutral40, padding: "".concat(2 * r, "px ").concat(3 * r, "px") });
}, Npt = Lre, kpt = Lre, Rpt = ["size"], $pt = ["innerProps", "isRtl", "size"], j5, z5, Dpt = process.env.NODE_ENV === "production" ? { name: "8mmkcg", styles: "display:inline-block;fill:currentColor;line-height:1;stroke:currentColor;stroke-width:0" } : { name: "tj5bde-Svg", styles: "display:inline-block;fill:currentColor;line-height:1;stroke:currentColor;stroke-width:0;label:Svg;", map: "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */", toString: function() {
  return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
} }, Vre = function(t) {
  var e = t.size, n = tu(t, Rpt);
  return zt("svg", Kt({ height: e, width: e, viewBox: "0 0 20 20", "aria-hidden": "true", focusable: "false", css: Dpt }, n));
}, G5 = function(t) {
  return zt(Vre, Kt({ size: 20 }, t), zt("path", { d: "M14.348 14.849c-0.469 0.469-1.229 0.469-1.697 0l-2.651-3.030-2.651 3.029c-0.469 0.469-1.229 0.469-1.697 0-0.469-0.469-0.469-1.229 0-1.697l2.758-3.15-2.759-3.152c-0.469-0.469-0.469-1.228 0-1.697s1.228-0.469 1.697 0l2.652 3.031 2.651-3.031c0.469-0.469 1.228-0.469 1.697 0s0.469 1.229 0 1.697l-2.758 3.152 2.758 3.15c0.469 0.469 0.469 1.229 0 1.698z" }));
}, WB = function(t) {
  return zt(Vre, Kt({ size: 20 }, t), zt("path", { d: "M4.516 7.548c0.436-0.446 1.043-0.481 1.576 0l3.908 3.747 3.908-3.747c0.533-0.481 1.141-0.446 1.574 0 0.436 0.445 0.408 1.197 0 1.615-0.406 0.418-4.695 4.502-4.695 4.502-0.217 0.223-0.502 0.335-0.787 0.335s-0.57-0.112-0.789-0.335c0 0-4.287-4.084-4.695-4.502s-0.436-1.17 0-1.615z" }));
}, Bre = function(t, e) {
  var n = t.isFocused, r = t.theme, i = r.spacing.baseUnit, o = r.colors;
  return Bt({ label: "indicatorContainer", display: "flex", transition: "color 150ms" }, e ? {} : { color: n ? o.neutral60 : o.neutral20, padding: 2 * i, ":hover": { color: n ? o.neutral80 : o.neutral40 } });
}, Mpt = Bre, Fpt = Bre, Lpt = function() {
  var t = rP.apply(void 0, arguments), e = "animation-" + t.name;
  return { name: e, styles: "@keyframes " + e + "{" + t.styles + "}", anim: 1, toString: function() {
    return "_EMO_" + this.name + "_" + this.styles + "_EMO_";
  } };
}(HB || (j5 = [`
  0%, 80%, 100% { opacity: 0; }
  40% { opacity: 1; }
`], z5 || (z5 = j5.slice(0)), HB = Object.freeze(Object.defineProperties(j5, { raw: { value: Object.freeze(z5) } })))), U5 = function(t) {
  var e = t.delay, n = t.offset;
  return zt("span", { css: rP({ animation: "".concat(Lpt, " 1s ease-in-out ").concat(e, "ms infinite;"), backgroundColor: "currentColor", borderRadius: "1em", display: "inline-block", marginLeft: n ? "1em" : void 0, height: "1em", verticalAlign: "top", width: "1em" }, process.env.NODE_ENV === "production" ? "" : ";label:LoadingDot;", process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */") });
}, Vpt = function(t) {
  var e = t.children, n = t.isDisabled, r = t.isFocused, i = t.innerRef, o = t.innerProps, a = t.menuIsOpen;
  return zt("div", Kt({ ref: i }, Ur(t, "control", { control: !0, "control--is-disabled": n, "control--is-focused": r, "control--menu-is-open": a }), o, { "aria-disabled": n || void 0 }), e);
}, Bpt = ["data"], Hpt = function(t) {
  var e = t.children, n = t.cx, r = t.getStyles, i = t.getClassNames, o = t.Heading, a = t.headingProps, s = t.innerProps, u = t.label, l = t.theme, c = t.selectProps;
  return zt("div", Kt({}, Ur(t, "group", { group: !0 }), s), zt(o, Kt({}, a, { selectProps: c, theme: l, getStyles: r, getClassNames: i, cx: n }), u), zt("div", null, e));
}, Wpt = ["innerRef", "isDisabled", "isHidden", "inputClassName"], Hre = { gridArea: "1 / 2", font: "inherit", minWidth: "2px", border: 0, margin: 0, outline: 0, padding: 0 }, jpt = { flex: "1 1 auto", display: "inline-grid", gridArea: "1 / 1 / 2 / 3", gridTemplateColumns: "0 min-content", "&:after": Bt({ content: 'attr(data-value) " "', visibility: "hidden", whiteSpace: "pre" }, Hre) }, zpt = function(t) {
  return Bt({ label: "input", color: "inherit", background: 0, opacity: t ? 0 : 1, width: "100%" }, Hre);
}, jB = function(t) {
  var e = t.children, n = t.innerProps;
  return zt("div", n, e);
}, Gpt = function(t) {
  var e = t.children, n = t.components, r = t.data, i = t.innerProps, o = t.isDisabled, a = t.removeProps, s = t.selectProps, u = n.Container, l = n.Label, c = n.Remove;
  return zt(u, { data: r, innerProps: Bt(Bt({}, Ur(t, "multiValue", { "multi-value": !0, "multi-value--is-disabled": o })), i), selectProps: s }, zt(l, { data: r, innerProps: Bt({}, Ur(t, "multiValueLabel", { "multi-value__label": !0 })), selectProps: s }, e), zt(c, { data: r, innerProps: Bt(Bt({}, Ur(t, "multiValueRemove", { "multi-value__remove": !0 })), {}, { "aria-label": "Remove ".concat(e || "option") }, a), selectProps: s }));
}, Upt = { ClearIndicator: function(t) {
  var e = t.children, n = t.innerProps;
  return zt("div", Kt({}, Ur(t, "clearIndicator", { indicator: !0, "clear-indicator": !0 }), n), e || zt(G5, null));
}, Control: Vpt, DropdownIndicator: function(t) {
  var e = t.children, n = t.innerProps;
  return zt("div", Kt({}, Ur(t, "dropdownIndicator", { indicator: !0, "dropdown-indicator": !0 }), n), e || zt(WB, null));
}, DownChevron: WB, CrossIcon: G5, Group: Hpt, GroupHeading: function(t) {
  var e = LB(t);
  e.data;
  var n = tu(e, Bpt);
  return zt("div", Kt({}, Ur(t, "groupHeading", { "group-heading": !0 }), n));
}, IndicatorsContainer: function(t) {
  var e = t.children, n = t.innerProps;
  return zt("div", Kt({}, Ur(t, "indicatorsContainer", { indicators: !0 }), n), e);
}, IndicatorSeparator: function(t) {
  var e = t.innerProps;
  return zt("span", Kt({}, e, Ur(t, "indicatorSeparator", { "indicator-separator": !0 })));
}, Input: function(t) {
  var e = t.cx, n = t.value, r = LB(t), i = r.innerRef, o = r.isDisabled, a = r.isHidden, s = r.inputClassName, u = tu(r, Wpt);
  return zt("div", Kt({}, Ur(t, "input", { "input-container": !0 }), { "data-value": n || "" }), zt("input", Kt({ className: e({ input: !0 }, s), ref: i, style: zpt(a), disabled: o }, u)));
}, LoadingIndicator: function(t) {
  var e = t.innerProps, n = t.isRtl, r = t.size, i = r === void 0 ? 4 : r, o = tu(t, $pt);
  return zt("div", Kt({}, Ur(Bt(Bt({}, o), {}, { innerProps: e, isRtl: n, size: i }), "loadingIndicator", { indicator: !0, "loading-indicator": !0 }), e), zt(U5, { delay: 0, offset: n }), zt(U5, { delay: 160, offset: !0 }), zt(U5, { delay: 320, offset: !n }));
}, Menu: Ppt, MenuList: function(t) {
  var e = t.children, n = t.innerProps, r = t.innerRef, i = t.isMulti;
  return zt("div", Kt({}, Ur(t, "menuList", { "menu-list": !0, "menu-list--is-multi": i }), { ref: r }, n), e);
}, MenuPortal: function(t) {
  var e = t.appendTo, n = t.children, r = t.controlElement, i = t.innerProps, o = t.menuPlacement, a = t.menuPosition, s = Ee(null), u = Ee(null), l = Ii(Le(Mre(o)), 2), c = l[0], d = l[1], f = Rn(function() {
    return { setPortalPlacement: d };
  }, []), h = Ii(Le(null), 2), p = h[0], v = h[1], m = et(function() {
    if (r) {
      var S = function(_) {
        var A = _.getBoundingClientRect();
        return { bottom: A.bottom, height: A.height, left: A.left, right: A.right, top: A.top, width: A.width };
      }(r), E = a === "fixed" ? 0 : window.pageYOffset, I = S[c] + E;
      I === (p == null ? void 0 : p.offset) && S.left === (p == null ? void 0 : p.rect.left) && S.width === (p == null ? void 0 : p.rect.width) || v({ offset: I, rect: S });
    }
  }, [r, a, c, p == null ? void 0 : p.offset, p == null ? void 0 : p.rect.left, p == null ? void 0 : p.rect.width]);
  D6(function() {
    m();
  }, [m]);
  var b = et(function() {
    typeof u.current == "function" && (u.current(), u.current = null), r && s.current && (u.current = function(S, E, I, _) {
      _ === void 0 && (_ = {});
      const { ancestorScroll: A = !0, ancestorResize: P = !0, elementResize: N = !0, animationFrame: k = !1 } = _, D = A && !k, R = D || P ? [...Kh(S) ? Qy(S) : S.contextElement ? Qy(S.contextElement) : [], ...Qy(E)] : [];
      R.forEach((M) => {
        D && M.addEventListener("scroll", I, { passive: !0 }), P && M.addEventListener("resize", I);
      });
      let V, $ = null;
      if (N) {
        let M = !0;
        $ = new ResizeObserver(() => {
          M || I(), M = !1;
        }), Kh(S) && !k && $.observe(S), Kh(S) || !S.contextElement || k || $.observe(S.contextElement), $.observe(E);
      }
      let F = k ? MB(S) : null;
      return k && function M() {
        const B = MB(S);
        !F || B.x === F.x && B.y === F.y && B.width === F.width && B.height === F.height || I(), F = B, V = requestAnimationFrame(M);
      }(), I(), () => {
        var M;
        R.forEach((B) => {
          D && B.removeEventListener("scroll", I), P && B.removeEventListener("resize", I);
        }), (M = $) == null || M.disconnect(), $ = null, k && cancelAnimationFrame(V);
      };
    }(r, s.current, m, { elementResize: "ResizeObserver" in window }));
  }, [r, m]);
  D6(function() {
    b();
  }, [b]);
  var y = et(function(S) {
    s.current = S, b();
  }, [b]);
  if (!e && a !== "fixed" || !p)
    return null;
  var w = zt("div", Kt({ ref: y }, Ur(Bt(Bt({}, t), {}, { offset: p.offset, position: a, rect: p.rect }), "menuPortal", { "menu-portal": !0 }), i), n);
  return zt(Fre.Provider, { value: f }, e ? km(w, e) : w);
}, LoadingMessage: function(t) {
  var e = t.children, n = e === void 0 ? "Loading..." : e, r = t.innerProps, i = tu(t, Apt);
  return zt("div", Kt({}, Ur(Bt(Bt({}, i), {}, { children: n, innerProps: r }), "loadingMessage", { "menu-notice": !0, "menu-notice--loading": !0 }), r), n);
}, NoOptionsMessage: function(t) {
  var e = t.children, n = e === void 0 ? "No options" : e, r = t.innerProps, i = tu(t, _pt);
  return zt("div", Kt({}, Ur(Bt(Bt({}, i), {}, { children: n, innerProps: r }), "noOptionsMessage", { "menu-notice": !0, "menu-notice--no-options": !0 }), r), n);
}, MultiValue: Gpt, MultiValueContainer: jB, MultiValueLabel: jB, MultiValueRemove: function(t) {
  var e = t.children, n = t.innerProps;
  return zt("div", Kt({ role: "button" }, n), e || zt(G5, { size: 14 }));
}, Option: function(t) {
  var e = t.children, n = t.isDisabled, r = t.isFocused, i = t.isSelected, o = t.innerRef, a = t.innerProps;
  return zt("div", Kt({}, Ur(t, "option", { option: !0, "option--is-disabled": n, "option--is-focused": r, "option--is-selected": i }), { ref: o, "aria-disabled": n }, a), e);
}, Placeholder: function(t) {
  var e = t.children, n = t.innerProps;
  return zt("div", Kt({}, Ur(t, "placeholder", { placeholder: !0 }), n), e);
}, SelectContainer: function(t) {
  var e = t.children, n = t.innerProps, r = t.isDisabled, i = t.isRtl;
  return zt("div", Kt({}, Ur(t, "container", { "--is-disabled": r, "--is-rtl": i }), n), e);
}, SingleValue: function(t) {
  var e = t.children, n = t.isDisabled, r = t.innerProps;
  return zt("div", Kt({}, Ur(t, "singleValue", { "single-value": !0, "single-value--is-disabled": n }), r), e);
}, ValueContainer: function(t) {
  var e = t.children, n = t.innerProps, r = t.isMulti, i = t.hasValue;
  return zt("div", Kt({}, Ur(t, "valueContainer", { "value-container": !0, "value-container--is-multi": r, "value-container--has-value": i }), n), e);
} }, zB = Number.isNaN || function(t) {
  return typeof t == "number" && t != t;
};
function Xpt(t, e) {
  if (t.length !== e.length)
    return !1;
  for (var n = 0; n < t.length; n++)
    if (r = t[n], i = e[n], !(r === i || zB(r) && zB(i)))
      return !1;
  var r, i;
  return !0;
}
for (var Ypt = process.env.NODE_ENV === "production" ? { name: "7pg0cj-a11yText", styles: "label:a11yText;z-index:9999;border:0;clip:rect(1px, 1px, 1px, 1px);height:1px;width:1px;position:absolute;overflow:hidden;padding:0;white-space:nowrap" } : { name: "1f43avz-a11yText-A11yText", styles: "label:a11yText;z-index:9999;border:0;clip:rect(1px, 1px, 1px, 1px);height:1px;width:1px;position:absolute;overflow:hidden;padding:0;white-space:nowrap;label:A11yText;", map: "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIkExMXlUZXh0LnRzeCJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFNSSIsImZpbGUiOiJBMTF5VGV4dC50c3giLCJzb3VyY2VzQ29udGVudCI6WyIvKiogQGpzeCBqc3ggKi9cbmltcG9ydCB7IGpzeCB9IGZyb20gJ0BlbW90aW9uL3JlYWN0JztcblxuLy8gQXNzaXN0aXZlIHRleHQgdG8gZGVzY3JpYmUgdmlzdWFsIGVsZW1lbnRzLiBIaWRkZW4gZm9yIHNpZ2h0ZWQgdXNlcnMuXG5jb25zdCBBMTF5VGV4dCA9IChwcm9wczogSlNYLkludHJpbnNpY0VsZW1lbnRzWydzcGFuJ10pID0+IChcbiAgPHNwYW5cbiAgICBjc3M9e3tcbiAgICAgIGxhYmVsOiAnYTExeVRleHQnLFxuICAgICAgekluZGV4OiA5OTk5LFxuICAgICAgYm9yZGVyOiAwLFxuICAgICAgY2xpcDogJ3JlY3QoMXB4LCAxcHgsIDFweCwgMXB4KScsXG4gICAgICBoZWlnaHQ6IDEsXG4gICAgICB3aWR0aDogMSxcbiAgICAgIHBvc2l0aW9uOiAnYWJzb2x1dGUnLFxuICAgICAgb3ZlcmZsb3c6ICdoaWRkZW4nLFxuICAgICAgcGFkZGluZzogMCxcbiAgICAgIHdoaXRlU3BhY2U6ICdub3dyYXAnLFxuICAgIH19XG4gICAgey4uLnByb3BzfVxuICAvPlxuKTtcblxuZXhwb3J0IGRlZmF1bHQgQTExeVRleHQ7XG4iXX0= */", toString: function() {
  return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
} }, GB = function(t) {
  return zt("span", Kt({ css: Ypt }, t));
}, Zpt = { guidance: function(t) {
  var e = t.isSearchable, n = t.isMulti, r = t.tabSelectsValue, i = t.context, o = t.isInitialFocus;
  switch (i) {
    case "menu":
      return "Use Up and Down to choose options, press Enter to select the currently focused option, press Escape to exit the menu".concat(r ? ", press Tab to select the option and exit the menu" : "", ".");
    case "input":
      return o ? "".concat(t["aria-label"] || "Select", " is focused ").concat(e ? ",type to refine list" : "", ", press Down to open the menu, ").concat(n ? " press left to focus selected values" : "") : "";
    case "value":
      return "Use left and right to toggle between focused values, press Backspace to remove the currently focused value";
    default:
      return "";
  }
}, onChange: function(t) {
  var e = t.action, n = t.label, r = n === void 0 ? "" : n, i = t.labels, o = t.isDisabled;
  switch (e) {
    case "deselect-option":
    case "pop-value":
    case "remove-value":
      return "option ".concat(r, ", deselected.");
    case "clear":
      return "All selected options have been cleared.";
    case "initial-input-focus":
      return "option".concat(i.length > 1 ? "s" : "", " ").concat(i.join(","), ", selected.");
    case "select-option":
      return "option ".concat(r, o ? " is disabled. Select another option." : ", selected.");
    default:
      return "";
  }
}, onFocus: function(t) {
  var e = t.context, n = t.focused, r = t.options, i = t.label, o = i === void 0 ? "" : i, a = t.selectValue, s = t.isDisabled, u = t.isSelected, l = t.isAppleDevice, c = function(h, p) {
    return h && h.length ? "".concat(h.indexOf(p) + 1, " of ").concat(h.length) : "";
  };
  if (e === "value" && a)
    return "value ".concat(o, " focused, ").concat(c(a, n), ".");
  if (e === "menu" && l) {
    var d = s ? " disabled" : "", f = "".concat(u ? " selected" : "").concat(d);
    return "".concat(o).concat(f, ", ").concat(c(r, n), ".");
  }
  return "";
}, onFilter: function(t) {
  var e = t.inputValue, n = t.resultsMessage;
  return "".concat(n).concat(e ? " for search term " + e : "", ".");
} }, Jpt = function(t) {
  var e = t.ariaSelection, n = t.focusedOption, r = t.focusedValue, i = t.focusableOptions, o = t.isFocused, a = t.selectValue, s = t.selectProps, u = t.id, l = t.isAppleDevice, c = s.ariaLiveMessages, d = s.getOptionLabel, f = s.inputValue, h = s.isMulti, p = s.isOptionDisabled, v = s.isSearchable, m = s.menuIsOpen, b = s.options, y = s.screenReaderStatus, w = s.tabSelectsValue, S = s.isLoading, E = s["aria-label"], I = s["aria-live"], _ = Rn(function() {
    return Bt(Bt({}, Zpt), c || {});
  }, [c]), A = Rn(function() {
    var V, $ = "";
    if (e && _.onChange) {
      var F = e.option, M = e.options, B = e.removedValue, X = e.removedValues, L = e.value, j = B || F || (V = L, Array.isArray(V) ? null : V), K = j ? d(j) : "", W = M || X || void 0, Y = W ? W.map(d) : [], U = Bt({ isDisabled: j && p(j, a), label: K, labels: Y }, e);
      $ = _.onChange(U);
    }
    return $;
  }, [e, _, p, a, d]), P = Rn(function() {
    var V = "", $ = n || r, F = !!(n && a && a.includes(n));
    if ($ && _.onFocus) {
      var M = { focused: $, label: d($), isDisabled: p($, a), isSelected: F, options: i, context: $ === n ? "menu" : "value", selectValue: a, isAppleDevice: l };
      V = _.onFocus(M);
    }
    return V;
  }, [n, r, d, p, _, i, a, l]), N = Rn(function() {
    var V = "";
    if (m && b.length && !S && _.onFilter) {
      var $ = y({ count: i.length });
      V = _.onFilter({ inputValue: f, resultsMessage: $ });
    }
    return V;
  }, [i, f, m, _, b, y, S]), k = (e == null ? void 0 : e.action) === "initial-input-focus", D = Rn(function() {
    var V = "";
    if (_.guidance) {
      var $ = r ? "value" : m ? "menu" : "input";
      V = _.guidance({ "aria-label": E, context: $, isDisabled: n && p(n, a), isMulti: h, isSearchable: v, tabSelectsValue: w, isInitialFocus: k });
    }
    return V;
  }, [E, n, r, h, p, v, m, _, a, w, k]), R = zt(ha, null, zt("span", { id: "aria-selection" }, A), zt("span", { id: "aria-focused" }, P), zt("span", { id: "aria-results" }, N), zt("span", { id: "aria-guidance" }, D));
  return zt(ha, null, zt(GB, { id: u }, k && R), zt(GB, { "aria-live": I, "aria-atomic": "false", "aria-relevant": "additions text", role: "log" }, o && !k && R));
}, X5 = [{ base: "A", letters: "AⒶＡÀÁÂẦẤẪẨÃĀĂẰẮẴẲȦǠÄǞẢÅǺǍȀȂẠẬẶḀĄȺⱯ" }, { base: "AA", letters: "Ꜳ" }, { base: "AE", letters: "ÆǼǢ" }, { base: "AO", letters: "Ꜵ" }, { base: "AU", letters: "Ꜷ" }, { base: "AV", letters: "ꜸꜺ" }, { base: "AY", letters: "Ꜽ" }, { base: "B", letters: "BⒷＢḂḄḆɃƂƁ" }, { base: "C", letters: "CⒸＣĆĈĊČÇḈƇȻꜾ" }, { base: "D", letters: "DⒹＤḊĎḌḐḒḎĐƋƊƉꝹ" }, { base: "DZ", letters: "ǱǄ" }, { base: "Dz", letters: "ǲǅ" }, { base: "E", letters: "EⒺＥÈÉÊỀẾỄỂẼĒḔḖĔĖËẺĚȄȆẸỆȨḜĘḘḚƐƎ" }, { base: "F", letters: "FⒻＦḞƑꝻ" }, { base: "G", letters: "GⒼＧǴĜḠĞĠǦĢǤƓꞠꝽꝾ" }, { base: "H", letters: "HⒽＨĤḢḦȞḤḨḪĦⱧⱵꞍ" }, { base: "I", letters: "IⒾＩÌÍÎĨĪĬİÏḮỈǏȈȊỊĮḬƗ" }, { base: "J", letters: "JⒿＪĴɈ" }, { base: "K", letters: "KⓀＫḰǨḲĶḴƘⱩꝀꝂꝄꞢ" }, { base: "L", letters: "LⓁＬĿĹĽḶḸĻḼḺŁȽⱢⱠꝈꝆꞀ" }, { base: "LJ", letters: "Ǉ" }, { base: "Lj", letters: "ǈ" }, { base: "M", letters: "MⓂＭḾṀṂⱮƜ" }, { base: "N", letters: "NⓃＮǸŃÑṄŇṆŅṊṈȠƝꞐꞤ" }, { base: "NJ", letters: "Ǌ" }, { base: "Nj", letters: "ǋ" }, { base: "O", letters: "OⓄＯÒÓÔỒỐỖỔÕṌȬṎŌṐṒŎȮȰÖȪỎŐǑȌȎƠỜỚỠỞỢỌỘǪǬØǾƆƟꝊꝌ" }, { base: "OI", letters: "Ƣ" }, { base: "OO", letters: "Ꝏ" }, { base: "OU", letters: "Ȣ" }, { base: "P", letters: "PⓅＰṔṖƤⱣꝐꝒꝔ" }, { base: "Q", letters: "QⓆＱꝖꝘɊ" }, { base: "R", letters: "RⓇＲŔṘŘȐȒṚṜŖṞɌⱤꝚꞦꞂ" }, { base: "S", letters: "SⓈＳẞŚṤŜṠŠṦṢṨȘŞⱾꞨꞄ" }, { base: "T", letters: "TⓉＴṪŤṬȚŢṰṮŦƬƮȾꞆ" }, { base: "TZ", letters: "Ꜩ" }, { base: "U", letters: "UⓊＵÙÚÛŨṸŪṺŬÜǛǗǕǙỦŮŰǓȔȖƯỪỨỮỬỰỤṲŲṶṴɄ" }, { base: "V", letters: "VⓋＶṼṾƲꝞɅ" }, { base: "VY", letters: "Ꝡ" }, { base: "W", letters: "WⓌＷẀẂŴẆẄẈⱲ" }, { base: "X", letters: "XⓍＸẊẌ" }, { base: "Y", letters: "YⓎＹỲÝŶỸȲẎŸỶỴƳɎỾ" }, { base: "Z", letters: "ZⓏＺŹẐŻŽẒẔƵȤⱿⱫꝢ" }, { base: "a", letters: "aⓐａẚàáâầấẫẩãāăằắẵẳȧǡäǟảåǻǎȁȃạậặḁąⱥɐ" }, { base: "aa", letters: "ꜳ" }, { base: "ae", letters: "æǽǣ" }, { base: "ao", letters: "ꜵ" }, { base: "au", letters: "ꜷ" }, { base: "av", letters: "ꜹꜻ" }, { base: "ay", letters: "ꜽ" }, { base: "b", letters: "bⓑｂḃḅḇƀƃɓ" }, { base: "c", letters: "cⓒｃćĉċčçḉƈȼꜿↄ" }, { base: "d", letters: "dⓓｄḋďḍḑḓḏđƌɖɗꝺ" }, { base: "dz", letters: "ǳǆ" }, { base: "e", letters: "eⓔｅèéêềếễểẽēḕḗĕėëẻěȅȇẹệȩḝęḙḛɇɛǝ" }, { base: "f", letters: "fⓕｆḟƒꝼ" }, { base: "g", letters: "gⓖｇǵĝḡğġǧģǥɠꞡᵹꝿ" }, { base: "h", letters: "hⓗｈĥḣḧȟḥḩḫẖħⱨⱶɥ" }, { base: "hv", letters: "ƕ" }, { base: "i", letters: "iⓘｉìíîĩīĭïḯỉǐȉȋịįḭɨı" }, { base: "j", letters: "jⓙｊĵǰɉ" }, { base: "k", letters: "kⓚｋḱǩḳķḵƙⱪꝁꝃꝅꞣ" }, { base: "l", letters: "lⓛｌŀĺľḷḹļḽḻſłƚɫⱡꝉꞁꝇ" }, { base: "lj", letters: "ǉ" }, { base: "m", letters: "mⓜｍḿṁṃɱɯ" }, { base: "n", letters: "nⓝｎǹńñṅňṇņṋṉƞɲŉꞑꞥ" }, { base: "nj", letters: "ǌ" }, { base: "o", letters: "oⓞｏòóôồốỗổõṍȭṏōṑṓŏȯȱöȫỏőǒȍȏơờớỡởợọộǫǭøǿɔꝋꝍɵ" }, { base: "oi", letters: "ƣ" }, { base: "ou", letters: "ȣ" }, { base: "oo", letters: "ꝏ" }, { base: "p", letters: "pⓟｐṕṗƥᵽꝑꝓꝕ" }, { base: "q", letters: "qⓠｑɋꝗꝙ" }, { base: "r", letters: "rⓡｒŕṙřȑȓṛṝŗṟɍɽꝛꞧꞃ" }, { base: "s", letters: "sⓢｓßśṥŝṡšṧṣṩșşȿꞩꞅẛ" }, { base: "t", letters: "tⓣｔṫẗťṭțţṱṯŧƭʈⱦꞇ" }, { base: "tz", letters: "ꜩ" }, { base: "u", letters: "uⓤｕùúûũṹūṻŭüǜǘǖǚủůűǔȕȗưừứữửựụṳųṷṵʉ" }, { base: "v", letters: "vⓥｖṽṿʋꝟʌ" }, { base: "vy", letters: "ꝡ" }, { base: "w", letters: "wⓦｗẁẃŵẇẅẘẉⱳ" }, { base: "x", letters: "xⓧｘẋẍ" }, { base: "y", letters: "yⓨｙỳýŷỹȳẏÿỷẙỵƴɏỿ" }, { base: "z", letters: "zⓩｚźẑżžẓẕƶȥɀⱬꝣ" }], Kpt = new RegExp("[" + X5.map(function(t) {
  return t.letters;
}).join("") + "]", "g"), Wre = {}, Y5 = 0; Y5 < X5.length; Y5++)
  for (var Z5 = X5[Y5], J5 = 0; J5 < Z5.letters.length; J5++)
    Wre[Z5.letters[J5]] = Z5.base;
var jre = function(t) {
  return t.replace(Kpt, function(e) {
    return Wre[e];
  });
}, qpt = function(t, e) {
  e === void 0 && (e = Xpt);
  var n = null;
  function r() {
    for (var i = [], o = 0; o < arguments.length; o++)
      i[o] = arguments[o];
    if (n && n.lastThis === this && e(i, n.lastArgs))
      return n.lastResult;
    var a = t.apply(this, i);
    return n = { lastResult: a, lastArgs: i, lastThis: this }, a;
  }
  return r.clear = function() {
    n = null;
  }, r;
}(jre), UB = function(t) {
  return t.replace(/^\s+|\s+$/g, "");
}, Qpt = function(t) {
  return "".concat(t.label, " ").concat(t.value);
}, egt = ["innerRef"];
function tgt(t) {
  var e = t.innerRef, n = function(r) {
    for (var i = arguments.length, o = new Array(i > 1 ? i - 1 : 0), a = 1; a < i; a++)
      o[a - 1] = arguments[a];
    var s = Object.entries(r).filter(function(u) {
      var l = Ii(u, 1)[0];
      return !o.includes(l);
    });
    return s.reduce(function(u, l) {
      var c = Ii(l, 2), d = c[0], f = c[1];
      return u[d] = f, u;
    }, {});
  }(tu(t, egt), "onExited", "in", "enter", "exit", "appear");
  return zt("input", Kt({ ref: e }, n, { css: rP({ label: "dummyInput", background: 0, border: 0, caretColor: "transparent", fontSize: "inherit", gridArea: "1 / 1 / 2 / 3", outline: 0, padding: 0, width: 1, color: "transparent", left: -100, opacity: 0, position: "relative", transform: "scale(.01)" }, process.env.NODE_ENV === "production" ? "" : ";label:DummyInput;", process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIkR1bW15SW5wdXQudHN4Il0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQXlCTSIsImZpbGUiOiJEdW1teUlucHV0LnRzeCIsInNvdXJjZXNDb250ZW50IjpbIi8qKiBAanN4IGpzeCAqL1xuaW1wb3J0IHsgUmVmIH0gZnJvbSAncmVhY3QnO1xuaW1wb3J0IHsganN4IH0gZnJvbSAnQGVtb3Rpb24vcmVhY3QnO1xuaW1wb3J0IHsgcmVtb3ZlUHJvcHMgfSBmcm9tICcuLi91dGlscyc7XG5cbmV4cG9ydCBkZWZhdWx0IGZ1bmN0aW9uIER1bW15SW5wdXQoe1xuICBpbm5lclJlZixcbiAgLi4ucHJvcHNcbn06IEpTWC5JbnRyaW5zaWNFbGVtZW50c1snaW5wdXQnXSAmIHtcbiAgcmVhZG9ubHkgaW5uZXJSZWY6IFJlZjxIVE1MSW5wdXRFbGVtZW50Pjtcbn0pIHtcbiAgLy8gUmVtb3ZlIGFuaW1hdGlvbiBwcm9wcyBub3QgbWVhbnQgZm9yIEhUTUwgZWxlbWVudHNcbiAgY29uc3QgZmlsdGVyZWRQcm9wcyA9IHJlbW92ZVByb3BzKFxuICAgIHByb3BzLFxuICAgICdvbkV4aXRlZCcsXG4gICAgJ2luJyxcbiAgICAnZW50ZXInLFxuICAgICdleGl0JyxcbiAgICAnYXBwZWFyJ1xuICApO1xuXG4gIHJldHVybiAoXG4gICAgPGlucHV0XG4gICAgICByZWY9e2lubmVyUmVmfVxuICAgICAgey4uLmZpbHRlcmVkUHJvcHN9XG4gICAgICBjc3M9e3tcbiAgICAgICAgbGFiZWw6ICdkdW1teUlucHV0JyxcbiAgICAgICAgLy8gZ2V0IHJpZCBvZiBhbnkgZGVmYXVsdCBzdHlsZXNcbiAgICAgICAgYmFja2dyb3VuZDogMCxcbiAgICAgICAgYm9yZGVyOiAwLFxuICAgICAgICAvLyBpbXBvcnRhbnQhIHRoaXMgaGlkZXMgdGhlIGZsYXNoaW5nIGN1cnNvclxuICAgICAgICBjYXJldENvbG9yOiAndHJhbnNwYXJlbnQnLFxuICAgICAgICBmb250U2l6ZTogJ2luaGVyaXQnLFxuICAgICAgICBncmlkQXJlYTogJzEgLyAxIC8gMiAvIDMnLFxuICAgICAgICBvdXRsaW5lOiAwLFxuICAgICAgICBwYWRkaW5nOiAwLFxuICAgICAgICAvLyBpbXBvcnRhbnQhIHdpdGhvdXQgYHdpZHRoYCBicm93c2VycyB3b24ndCBhbGxvdyBmb2N1c1xuICAgICAgICB3aWR0aDogMSxcblxuICAgICAgICAvLyByZW1vdmUgY3Vyc29yIG9uIGRlc2t0b3BcbiAgICAgICAgY29sb3I6ICd0cmFuc3BhcmVudCcsXG5cbiAgICAgICAgLy8gcmVtb3ZlIGN1cnNvciBvbiBtb2JpbGUgd2hpbHN0IG1haW50YWluaW5nIFwic2Nyb2xsIGludG8gdmlld1wiIGJlaGF2aW91clxuICAgICAgICBsZWZ0OiAtMTAwLFxuICAgICAgICBvcGFjaXR5OiAwLFxuICAgICAgICBwb3NpdGlvbjogJ3JlbGF0aXZlJyxcbiAgICAgICAgdHJhbnNmb3JtOiAnc2NhbGUoLjAxKScsXG4gICAgICB9fVxuICAgIC8+XG4gICk7XG59XG4iXX0= */") }));
}
var XB = ["boxSizing", "height", "overflow", "paddingRight", "position"], YB = { boxSizing: "border-box", overflow: "hidden", position: "relative", height: "100%" };
function ZB(t) {
  t.preventDefault();
}
function JB(t) {
  t.stopPropagation();
}
function KB() {
  var t = this.scrollTop, e = this.scrollHeight, n = t + this.offsetHeight;
  t === 0 ? this.scrollTop = 1 : n === e && (this.scrollTop = t - 1);
}
function qB() {
  return "ontouchstart" in window || navigator.maxTouchPoints;
}
var QB = !(typeof window > "u" || !window.document || !window.document.createElement), Xg = 0, Jf = { capture: !1, passive: !1 }, ngt = function(t) {
  var e = t.target;
  return e.ownerDocument.activeElement && e.ownerDocument.activeElement.blur();
}, rgt = process.env.NODE_ENV === "production" ? { name: "1kfdb0e", styles: "position:fixed;left:0;bottom:0;right:0;top:0" } : { name: "bp8cua-ScrollManager", styles: "position:fixed;left:0;bottom:0;right:0;top:0;label:ScrollManager;", map: "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */", toString: function() {
  return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
} };
function igt(t) {
  var e = t.children, n = t.lockEnabled, r = t.captureEnabled, i = function(a) {
    var s = a.isEnabled, u = a.onBottomArrive, l = a.onBottomLeave, c = a.onTopArrive, d = a.onTopLeave, f = Ee(!1), h = Ee(!1), p = Ee(0), v = Ee(null), m = et(function(I, _) {
      if (v.current !== null) {
        var A = v.current, P = A.scrollTop, N = A.scrollHeight, k = A.clientHeight, D = v.current, R = _ > 0, V = N - k - P, $ = !1;
        V > _ && f.current && (l && l(I), f.current = !1), R && h.current && (d && d(I), h.current = !1), R && _ > V ? (u && !f.current && u(I), D.scrollTop = N, $ = !0, f.current = !0) : !R && -_ > P && (c && !h.current && c(I), D.scrollTop = 0, $ = !0, h.current = !0), $ && function(F) {
          F.cancelable && F.preventDefault(), F.stopPropagation();
        }(I);
      }
    }, [u, l, c, d]), b = et(function(I) {
      m(I, I.deltaY);
    }, [m]), y = et(function(I) {
      p.current = I.changedTouches[0].clientY;
    }, []), w = et(function(I) {
      var _ = p.current - I.changedTouches[0].clientY;
      m(I, _);
    }, [m]), S = et(function(I) {
      if (I) {
        var _ = !!Spt && { passive: !1 };
        I.addEventListener("wheel", b, _), I.addEventListener("touchstart", y, _), I.addEventListener("touchmove", w, _);
      }
    }, [w, y, b]), E = et(function(I) {
      I && (I.removeEventListener("wheel", b, !1), I.removeEventListener("touchstart", y, !1), I.removeEventListener("touchmove", w, !1));
    }, [w, y, b]);
    return Re(function() {
      if (s) {
        var I = v.current;
        return S(I), function() {
          E(I);
        };
      }
    }, [s, S, E]), function(I) {
      v.current = I;
    };
  }({ isEnabled: r === void 0 || r, onBottomArrive: t.onBottomArrive, onBottomLeave: t.onBottomLeave, onTopArrive: t.onTopArrive, onTopLeave: t.onTopLeave }), o = function(a) {
    var s = a.isEnabled, u = a.accountForScrollbars, l = u === void 0 || u, c = Ee({}), d = Ee(null), f = et(function(p) {
      if (QB) {
        var v = document.body, m = v && v.style;
        if (l && XB.forEach(function(S) {
          var E = m && m[S];
          c.current[S] = E;
        }), l && Xg < 1) {
          var b = parseInt(c.current.paddingRight, 10) || 0, y = document.body ? document.body.clientWidth : 0, w = window.innerWidth - y + b || 0;
          Object.keys(YB).forEach(function(S) {
            var E = YB[S];
            m && (m[S] = E);
          }), m && (m.paddingRight = "".concat(w, "px"));
        }
        v && qB() && (v.addEventListener("touchmove", ZB, Jf), p && (p.addEventListener("touchstart", KB, Jf), p.addEventListener("touchmove", JB, Jf))), Xg += 1;
      }
    }, [l]), h = et(function(p) {
      if (QB) {
        var v = document.body, m = v && v.style;
        Xg = Math.max(Xg - 1, 0), l && Xg < 1 && XB.forEach(function(b) {
          var y = c.current[b];
          m && (m[b] = y);
        }), v && qB() && (v.removeEventListener("touchmove", ZB, Jf), p && (p.removeEventListener("touchstart", KB, Jf), p.removeEventListener("touchmove", JB, Jf)));
      }
    }, [l]);
    return Re(function() {
      if (s) {
        var p = d.current;
        return f(p), function() {
          h(p);
        };
      }
    }, [s, f, h]), function(p) {
      d.current = p;
    };
  }({ isEnabled: n });
  return zt(ha, null, n && zt("div", { onClick: ngt, css: rgt }), e(function(a) {
    i(a), o(a);
  }));
}
var ogt = process.env.NODE_ENV === "production" ? { name: "1a0ro4n-requiredInput", styles: "label:requiredInput;opacity:0;pointer-events:none;position:absolute;bottom:0;left:0;right:0;width:100%" } : { name: "5kkxb2-requiredInput-RequiredInput", styles: "label:requiredInput;opacity:0;pointer-events:none;position:absolute;bottom:0;left:0;right:0;width:100%;label:RequiredInput;", map: "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIlJlcXVpcmVkSW5wdXQudHN4Il0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQWNJIiwiZmlsZSI6IlJlcXVpcmVkSW5wdXQudHN4Iiwic291cmNlc0NvbnRlbnQiOlsiLyoqIEBqc3gganN4ICovXG5pbXBvcnQgeyBGb2N1c0V2ZW50SGFuZGxlciwgRnVuY3Rpb25Db21wb25lbnQgfSBmcm9tICdyZWFjdCc7XG5pbXBvcnQgeyBqc3ggfSBmcm9tICdAZW1vdGlvbi9yZWFjdCc7XG5cbmNvbnN0IFJlcXVpcmVkSW5wdXQ6IEZ1bmN0aW9uQ29tcG9uZW50PHtcbiAgcmVhZG9ubHkgbmFtZT86IHN0cmluZztcbiAgcmVhZG9ubHkgb25Gb2N1czogRm9jdXNFdmVudEhhbmRsZXI8SFRNTElucHV0RWxlbWVudD47XG59PiA9ICh7IG5hbWUsIG9uRm9jdXMgfSkgPT4gKFxuICA8aW5wdXRcbiAgICByZXF1aXJlZFxuICAgIG5hbWU9e25hbWV9XG4gICAgdGFiSW5kZXg9ey0xfVxuICAgIGFyaWEtaGlkZGVuPVwidHJ1ZVwiXG4gICAgb25Gb2N1cz17b25Gb2N1c31cbiAgICBjc3M9e3tcbiAgICAgIGxhYmVsOiAncmVxdWlyZWRJbnB1dCcsXG4gICAgICBvcGFjaXR5OiAwLFxuICAgICAgcG9pbnRlckV2ZW50czogJ25vbmUnLFxuICAgICAgcG9zaXRpb246ICdhYnNvbHV0ZScsXG4gICAgICBib3R0b206IDAsXG4gICAgICBsZWZ0OiAwLFxuICAgICAgcmlnaHQ6IDAsXG4gICAgICB3aWR0aDogJzEwMCUnLFxuICAgIH19XG4gICAgLy8gUHJldmVudCBgU3dpdGNoaW5nIGZyb20gdW5jb250cm9sbGVkIHRvIGNvbnRyb2xsZWRgIGVycm9yXG4gICAgdmFsdWU9XCJcIlxuICAgIG9uQ2hhbmdlPXsoKSA9PiB7fX1cbiAgLz5cbik7XG5cbmV4cG9ydCBkZWZhdWx0IFJlcXVpcmVkSW5wdXQ7XG4iXX0= */", toString: function() {
  return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
} }, agt = function(t) {
  var e = t.name, n = t.onFocus;
  return zt("input", { required: !0, name: e, tabIndex: -1, "aria-hidden": "true", onFocus: n, css: ogt, value: "", onChange: function() {
  } });
};
function M6(t) {
  var e;
  return typeof window < "u" && window.navigator != null && t.test(((e = window.navigator.userAgentData) === null || e === void 0 ? void 0 : e.platform) || window.navigator.platform);
}
function zre() {
  return M6(/^Mac/i);
}
function sgt() {
  return M6(/^iPhone/i) || M6(/^iPad/i) || zre() && navigator.maxTouchPoints > 1;
}
var ugt, lgt = { clearIndicator: Fpt, container: function(t) {
  var e = t.isDisabled;
  return { label: "container", direction: t.isRtl ? "rtl" : void 0, pointerEvents: e ? "none" : void 0, position: "relative" };
}, control: function(t, e) {
  var n = t.isDisabled, r = t.isFocused, i = t.theme, o = i.colors, a = i.borderRadius;
  return Bt({ label: "control", alignItems: "center", cursor: "default", display: "flex", flexWrap: "wrap", justifyContent: "space-between", minHeight: i.spacing.controlHeight, outline: "0 !important", position: "relative", transition: "all 100ms" }, e ? {} : { backgroundColor: n ? o.neutral5 : o.neutral0, borderColor: n ? o.neutral10 : r ? o.primary : o.neutral20, borderRadius: a, borderStyle: "solid", borderWidth: 1, boxShadow: r ? "0 0 0 1px ".concat(o.primary) : void 0, "&:hover": { borderColor: r ? o.primary : o.neutral30 } });
}, dropdownIndicator: Mpt, group: function(t, e) {
  var n = t.theme.spacing;
  return e ? {} : { paddingBottom: 2 * n.baseUnit, paddingTop: 2 * n.baseUnit };
}, groupHeading: function(t, e) {
  var n = t.theme, r = n.colors, i = n.spacing;
  return Bt({ label: "group", cursor: "default", display: "block" }, e ? {} : { color: r.neutral40, fontSize: "75%", fontWeight: 500, marginBottom: "0.25em", paddingLeft: 3 * i.baseUnit, paddingRight: 3 * i.baseUnit, textTransform: "uppercase" });
}, indicatorsContainer: function() {
  return { alignItems: "center", alignSelf: "stretch", display: "flex", flexShrink: 0 };
}, indicatorSeparator: function(t, e) {
  var n = t.isDisabled, r = t.theme, i = r.spacing.baseUnit, o = r.colors;
  return Bt({ label: "indicatorSeparator", alignSelf: "stretch", width: 1 }, e ? {} : { backgroundColor: n ? o.neutral10 : o.neutral20, marginBottom: 2 * i, marginTop: 2 * i });
}, input: function(t, e) {
  var n = t.isDisabled, r = t.value, i = t.theme, o = i.spacing, a = i.colors;
  return Bt(Bt({ visibility: n ? "hidden" : "visible", transform: r ? "translateZ(0)" : "" }, jpt), e ? {} : { margin: o.baseUnit / 2, paddingBottom: o.baseUnit / 2, paddingTop: o.baseUnit / 2, color: a.neutral80 });
}, loadingIndicator: function(t, e) {
  var n = t.isFocused, r = t.size, i = t.theme, o = i.colors, a = i.spacing.baseUnit;
  return Bt({ label: "loadingIndicator", display: "flex", transition: "color 150ms", alignSelf: "center", fontSize: r, lineHeight: 1, marginRight: r, textAlign: "center", verticalAlign: "middle" }, e ? {} : { color: n ? o.neutral60 : o.neutral20, padding: 2 * a });
}, loadingMessage: kpt, menu: function(t, e) {
  var n, r = t.placement, i = t.theme, o = i.borderRadius, a = i.spacing, s = i.colors;
  return Bt(($h(n = { label: "menu" }, function(u) {
    return u ? { bottom: "top", top: "bottom" }[u] : "bottom";
  }(r), "100%"), $h(n, "position", "absolute"), $h(n, "width", "100%"), $h(n, "zIndex", 1), n), e ? {} : { backgroundColor: s.neutral0, borderRadius: o, boxShadow: "0 0 0 1px hsla(0, 0%, 0%, 0.1), 0 4px 11px hsla(0, 0%, 0%, 0.1)", marginBottom: a.menuGutter, marginTop: a.menuGutter });
}, menuList: function(t, e) {
  var n = t.maxHeight, r = t.theme.spacing.baseUnit;
  return Bt({ maxHeight: n, overflowY: "auto", position: "relative", WebkitOverflowScrolling: "touch" }, e ? {} : { paddingBottom: r, paddingTop: r });
}, menuPortal: function(t) {
  var e = t.rect, n = t.offset, r = t.position;
  return { left: e.left, position: r, top: n, width: e.width, zIndex: 1 };
}, multiValue: function(t, e) {
  var n = t.theme, r = n.spacing, i = n.borderRadius, o = n.colors;
  return Bt({ label: "multiValue", display: "flex", minWidth: 0 }, e ? {} : { backgroundColor: o.neutral10, borderRadius: i / 2, margin: r.baseUnit / 2 });
}, multiValueLabel: function(t, e) {
  var n = t.theme, r = n.borderRadius, i = n.colors, o = t.cropWithEllipsis;
  return Bt({ overflow: "hidden", textOverflow: o || o === void 0 ? "ellipsis" : void 0, whiteSpace: "nowrap" }, e ? {} : { borderRadius: r / 2, color: i.neutral80, fontSize: "85%", padding: 3, paddingLeft: 6 });
}, multiValueRemove: function(t, e) {
  var n = t.theme, r = n.spacing, i = n.borderRadius, o = n.colors, a = t.isFocused;
  return Bt({ alignItems: "center", display: "flex" }, e ? {} : { borderRadius: i / 2, backgroundColor: a ? o.dangerLight : void 0, paddingLeft: r.baseUnit, paddingRight: r.baseUnit, ":hover": { backgroundColor: o.dangerLight, color: o.danger } });
}, noOptionsMessage: Npt, option: function(t, e) {
  var n = t.isDisabled, r = t.isFocused, i = t.isSelected, o = t.theme, a = o.spacing, s = o.colors;
  return Bt({ label: "option", cursor: "default", display: "block", fontSize: "inherit", width: "100%", userSelect: "none", WebkitTapHighlightColor: "rgba(0, 0, 0, 0)" }, e ? {} : { backgroundColor: i ? s.primary : r ? s.primary25 : "transparent", color: n ? s.neutral20 : i ? s.neutral0 : "inherit", padding: "".concat(2 * a.baseUnit, "px ").concat(3 * a.baseUnit, "px"), ":active": { backgroundColor: n ? void 0 : i ? s.primary : s.primary50 } });
}, placeholder: function(t, e) {
  var n = t.theme, r = n.spacing, i = n.colors;
  return Bt({ label: "placeholder", gridArea: "1 / 1 / 2 / 3" }, e ? {} : { color: i.neutral50, marginLeft: r.baseUnit / 2, marginRight: r.baseUnit / 2 });
}, singleValue: function(t, e) {
  var n = t.isDisabled, r = t.theme, i = r.spacing, o = r.colors;
  return Bt({ label: "singleValue", gridArea: "1 / 1 / 2 / 3", maxWidth: "100%", overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }, e ? {} : { color: n ? o.neutral40 : o.neutral80, marginLeft: i.baseUnit / 2, marginRight: i.baseUnit / 2 });
}, valueContainer: function(t, e) {
  var n = t.theme.spacing, r = t.isMulti, i = t.hasValue, o = t.selectProps.controlShouldRenderValue;
  return Bt({ alignItems: "center", display: r && i && o ? "flex" : "grid", flex: 1, flexWrap: "wrap", WebkitOverflowScrolling: "touch", position: "relative", overflow: "hidden" }, e ? {} : { padding: "".concat(n.baseUnit / 2, "px ").concat(2 * n.baseUnit, "px") });
} }, K5 = { borderRadius: 4, colors: { primary: "#2684FF", primary75: "#4C9AFF", primary50: "#B2D4FF", primary25: "#DEEBFF", danger: "#DE350B", dangerLight: "#FFBDAD", neutral0: "hsl(0, 0%, 100%)", neutral5: "hsl(0, 0%, 95%)", neutral10: "hsl(0, 0%, 90%)", neutral20: "hsl(0, 0%, 80%)", neutral30: "hsl(0, 0%, 70%)", neutral40: "hsl(0, 0%, 60%)", neutral50: "hsl(0, 0%, 50%)", neutral60: "hsl(0, 0%, 40%)", neutral70: "hsl(0, 0%, 30%)", neutral80: "hsl(0, 0%, 20%)", neutral90: "hsl(0, 0%, 10%)" }, spacing: { baseUnit: 4, controlHeight: 38, menuGutter: 8 } }, cgt = { "aria-live": "polite", backspaceRemovesValue: !0, blurInputOnSelect: BB(), captureMenuScroll: !BB(), classNames: {}, closeMenuOnSelect: !0, closeMenuOnScroll: !1, components: {}, controlShouldRenderValue: !0, escapeClearsValue: !1, filterOption: function(t, e) {
  if (t.data.__isNew__)
    return !0;
  var n = Bt({ ignoreCase: !0, ignoreAccents: !0, stringify: Qpt, trim: !0, matchFrom: "any" }, ugt), r = n.ignoreCase, i = n.ignoreAccents, o = n.stringify, a = n.trim, s = n.matchFrom, u = a ? UB(e) : e, l = a ? UB(o(t)) : o(t);
  return r && (u = u.toLowerCase(), l = l.toLowerCase()), i && (u = qpt(u), l = jre(l)), s === "start" ? l.substr(0, u.length) === u : l.indexOf(u) > -1;
}, formatGroupLabel: function(t) {
  return t.label;
}, getOptionLabel: function(t) {
  return t.label;
}, getOptionValue: function(t) {
  return t.value;
}, isDisabled: !1, isLoading: !1, isMulti: !1, isRtl: !1, isSearchable: !0, isOptionDisabled: function(t) {
  return !!t.isDisabled;
}, loadingMessage: function() {
  return "Loading...";
}, maxMenuHeight: 300, minMenuHeight: 140, menuIsOpen: !1, menuPlacement: "bottom", menuPosition: "absolute", menuShouldBlockScroll: !1, menuShouldScrollIntoView: !function() {
  try {
    return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
  } catch {
    return !1;
  }
}(), noOptionsMessage: function() {
  return "No options";
}, openMenuOnFocus: !1, openMenuOnClick: !0, options: [], pageSize: 5, placeholder: "Select...", screenReaderStatus: function(t) {
  var e = t.count;
  return "".concat(e, " result").concat(e !== 1 ? "s" : "", " available");
}, styles: {}, tabIndex: 0, tabSelectsValue: !0, unstyled: !1 };
function eH(t, e, n, r) {
  return { type: "option", data: e, isDisabled: Ure(t, e, n), isSelected: Xre(t, e, n), label: Gre(t, e), value: J2(t, e), index: r };
}
function ry(t, e) {
  return t.options.map(function(n, r) {
    if ("options" in n) {
      var i = n.options.map(function(a, s) {
        return eH(t, a, e, s);
      }).filter(function(a) {
        return rH(t, a);
      });
      return i.length > 0 ? { type: "group", data: n, options: i, index: r } : void 0;
    }
    var o = eH(t, n, e, r);
    return rH(t, o) ? o : void 0;
  }).filter(Ipt);
}
function tH(t) {
  return t.reduce(function(e, n) {
    return n.type === "group" ? e.push.apply(e, J8(n.options.map(function(r) {
      return r.data;
    }))) : e.push(n.data), e;
  }, []);
}
function nH(t, e) {
  return t.reduce(function(n, r) {
    return r.type === "group" ? n.push.apply(n, J8(r.options.map(function(i) {
      return { data: i.data, id: "".concat(e, "-").concat(r.index, "-").concat(i.index) };
    }))) : n.push({ data: r.data, id: "".concat(e, "-").concat(r.index) }), n;
  }, []);
}
function rH(t, e) {
  var n = t.inputValue, r = n === void 0 ? "" : n, i = e.data, o = e.isSelected, a = e.label, s = e.value;
  return (!Zre(t) || !o) && Yre(t, { label: a, value: s, data: i }, r);
}
var q5 = function(t, e) {
  var n;
  return ((n = t.find(function(r) {
    return r.data === e;
  })) === null || n === void 0 ? void 0 : n.id) || null;
}, Gre = function(t, e) {
  return t.getOptionLabel(e);
}, J2 = function(t, e) {
  return t.getOptionValue(e);
};
function Ure(t, e, n) {
  return typeof t.isOptionDisabled == "function" && t.isOptionDisabled(e, n);
}
function Xre(t, e, n) {
  if (n.indexOf(e) > -1)
    return !0;
  if (typeof t.isOptionSelected == "function")
    return t.isOptionSelected(e, n);
  var r = J2(t, e);
  return n.some(function(i) {
    return J2(t, i) === r;
  });
}
function Yre(t, e, n) {
  return !t.filterOption || t.filterOption(e, n);
}
var Zre = function(t) {
  var e = t.hideSelectedOptions, n = t.isMulti;
  return e === void 0 ? n : e;
}, dgt = 1, Jre = function(t) {
  (function(a, s) {
    if (typeof s != "function" && s !== null)
      throw new TypeError("Super expression must either be null or a function");
    a.prototype = Object.create(s && s.prototype, { constructor: { value: a, writable: !0, configurable: !0 } }), Object.defineProperty(a, "prototype", { writable: !1 }), s && I6(a, s);
  })(o, Do);
  var e, n, r, i = _ht(o);
  function o(a) {
    var s;
    if (function(d, f) {
      if (!(d instanceof f))
        throw new TypeError("Cannot call a class as a function");
    }(this, o), (s = i.call(this, a)).state = { ariaSelection: null, focusedOption: null, focusedOptionId: null, focusableOptionsWithIds: [], focusedValue: null, inputIsHidden: !1, isFocused: !1, selectValue: [], clearFocusValueOnUpdate: !1, prevWasFocused: !1, inputIsHiddenAfterUpdate: void 0, prevProps: void 0, instancePrefix: "" }, s.blockOptionHover = !1, s.isComposing = !1, s.commonProps = void 0, s.initialTouchX = 0, s.initialTouchY = 0, s.openAfterFocus = !1, s.scrollToFocusedOptionOnUpdate = !1, s.userIsDragging = void 0, s.isAppleDevice = zre() || sgt(), s.controlRef = null, s.getControlRef = function(d) {
      s.controlRef = d;
    }, s.focusedOptionRef = null, s.getFocusedOptionRef = function(d) {
      s.focusedOptionRef = d;
    }, s.menuListRef = null, s.getMenuListRef = function(d) {
      s.menuListRef = d;
    }, s.inputRef = null, s.getInputRef = function(d) {
      s.inputRef = d;
    }, s.focus = s.focusInput, s.blur = s.blurInput, s.onChange = function(d, f) {
      var h = s.props, p = h.onChange, v = h.name;
      f.name = v, s.ariaOnChange(d, f), p(d, f);
    }, s.setValue = function(d, f, h) {
      var p = s.props, v = p.closeMenuOnSelect, m = p.isMulti, b = p.inputValue;
      s.onInputChange("", { action: "set-value", prevInputValue: b }), v && (s.setState({ inputIsHiddenAfterUpdate: !m }), s.onMenuClose()), s.setState({ clearFocusValueOnUpdate: !0 }), s.onChange(d, { action: f, option: h });
    }, s.selectOption = function(d) {
      var f = s.props, h = f.blurInputOnSelect, p = f.isMulti, v = f.name, m = s.state.selectValue, b = p && s.isOptionSelected(d, m), y = s.isOptionDisabled(d, m);
      if (b) {
        var w = s.getOptionValue(d);
        s.setValue(m.filter(function(S) {
          return s.getOptionValue(S) !== w;
        }), "deselect-option", d);
      } else {
        if (y)
          return void s.ariaOnChange(d, { action: "select-option", option: d, name: v });
        p ? s.setValue([].concat(J8(m), [d]), "select-option", d) : s.setValue(d, "select-option");
      }
      h && s.blurInput();
    }, s.removeValue = function(d) {
      var f = s.props.isMulti, h = s.state.selectValue, p = s.getOptionValue(d), v = h.filter(function(b) {
        return s.getOptionValue(b) !== p;
      }), m = ny(f, v, v[0] || null);
      s.onChange(m, { action: "remove-value", removedValue: d }), s.focusInput();
    }, s.clearValue = function() {
      var d = s.state.selectValue;
      s.onChange(ny(s.props.isMulti, [], null), { action: "clear", removedValues: d });
    }, s.popValue = function() {
      var d = s.props.isMulti, f = s.state.selectValue, h = f[f.length - 1], p = f.slice(0, f.length - 1), v = ny(d, p, p[0] || null);
      s.onChange(v, { action: "pop-value", removedValue: h });
    }, s.getFocusedOptionId = function(d) {
      return q5(s.state.focusableOptionsWithIds, d);
    }, s.getFocusableOptionsWithIds = function() {
      return nH(ry(s.props, s.state.selectValue), s.getElementId("option"));
    }, s.getValue = function() {
      return s.state.selectValue;
    }, s.cx = function() {
      for (var d = arguments.length, f = new Array(d), h = 0; h < d; h++)
        f[h] = arguments[h];
      return Cpt.apply(void 0, [s.props.classNamePrefix].concat(f));
    }, s.getOptionLabel = function(d) {
      return Gre(s.props, d);
    }, s.getOptionValue = function(d) {
      return J2(s.props, d);
    }, s.getStyles = function(d, f) {
      var h = s.props.unstyled, p = lgt[d](f, h);
      p.boxSizing = "border-box";
      var v = s.props.styles[d];
      return v ? v(p, f) : p;
    }, s.getClassNames = function(d, f) {
      var h, p;
      return (h = (p = s.props.classNames)[d]) === null || h === void 0 ? void 0 : h.call(p, f);
    }, s.getElementId = function(d) {
      return "".concat(s.state.instancePrefix, "-").concat(d);
    }, s.getComponents = function() {
      return d = s.props, Bt(Bt({}, Upt), d.components);
      var d;
    }, s.buildCategorizedOptions = function() {
      return ry(s.props, s.state.selectValue);
    }, s.getCategorizedOptions = function() {
      return s.props.menuIsOpen ? s.buildCategorizedOptions() : [];
    }, s.buildFocusableOptions = function() {
      return tH(s.buildCategorizedOptions());
    }, s.getFocusableOptions = function() {
      return s.props.menuIsOpen ? s.buildFocusableOptions() : [];
    }, s.ariaOnChange = function(d, f) {
      s.setState({ ariaSelection: Bt({ value: d }, f) });
    }, s.onMenuMouseDown = function(d) {
      d.button === 0 && (d.stopPropagation(), d.preventDefault(), s.focusInput());
    }, s.onMenuMouseMove = function(d) {
      s.blockOptionHover = !1;
    }, s.onControlMouseDown = function(d) {
      if (!d.defaultPrevented) {
        var f = s.props.openMenuOnClick;
        s.state.isFocused ? s.props.menuIsOpen ? d.target.tagName !== "INPUT" && d.target.tagName !== "TEXTAREA" && s.onMenuClose() : f && s.openMenu("first") : (f && (s.openAfterFocus = !0), s.focusInput()), d.target.tagName !== "INPUT" && d.target.tagName !== "TEXTAREA" && d.preventDefault();
      }
    }, s.onDropdownIndicatorMouseDown = function(d) {
      if (!(d && d.type === "mousedown" && d.button !== 0 || s.props.isDisabled)) {
        var f = s.props, h = f.isMulti, p = f.menuIsOpen;
        s.focusInput(), p ? (s.setState({ inputIsHiddenAfterUpdate: !h }), s.onMenuClose()) : s.openMenu("first"), d.preventDefault();
      }
    }, s.onClearIndicatorMouseDown = function(d) {
      d && d.type === "mousedown" && d.button !== 0 || (s.clearValue(), d.preventDefault(), s.openAfterFocus = !1, d.type === "touchend" ? s.focusInput() : setTimeout(function() {
        return s.focusInput();
      }));
    }, s.onScroll = function(d) {
      typeof s.props.closeMenuOnScroll == "boolean" ? d.target instanceof HTMLElement && lE(d.target) && s.props.onMenuClose() : typeof s.props.closeMenuOnScroll == "function" && s.props.closeMenuOnScroll(d) && s.props.onMenuClose();
    }, s.onCompositionStart = function() {
      s.isComposing = !0;
    }, s.onCompositionEnd = function() {
      s.isComposing = !1;
    }, s.onTouchStart = function(d) {
      var f = d.touches, h = f && f.item(0);
      h && (s.initialTouchX = h.clientX, s.initialTouchY = h.clientY, s.userIsDragging = !1);
    }, s.onTouchMove = function(d) {
      var f = d.touches, h = f && f.item(0);
      if (h) {
        var p = Math.abs(h.clientX - s.initialTouchX), v = Math.abs(h.clientY - s.initialTouchY);
        s.userIsDragging = p > 5 || v > 5;
      }
    }, s.onTouchEnd = function(d) {
      s.userIsDragging || (s.controlRef && !s.controlRef.contains(d.target) && s.menuListRef && !s.menuListRef.contains(d.target) && s.blurInput(), s.initialTouchX = 0, s.initialTouchY = 0);
    }, s.onControlTouchEnd = function(d) {
      s.userIsDragging || s.onControlMouseDown(d);
    }, s.onClearIndicatorTouchEnd = function(d) {
      s.userIsDragging || s.onClearIndicatorMouseDown(d);
    }, s.onDropdownIndicatorTouchEnd = function(d) {
      s.userIsDragging || s.onDropdownIndicatorMouseDown(d);
    }, s.handleInputChange = function(d) {
      var f = s.props.inputValue, h = d.currentTarget.value;
      s.setState({ inputIsHiddenAfterUpdate: !1 }), s.onInputChange(h, { action: "input-change", prevInputValue: f }), s.props.menuIsOpen || s.onMenuOpen();
    }, s.onInputFocus = function(d) {
      s.props.onFocus && s.props.onFocus(d), s.setState({ inputIsHiddenAfterUpdate: !1, isFocused: !0 }), (s.openAfterFocus || s.props.openMenuOnFocus) && s.openMenu("first"), s.openAfterFocus = !1;
    }, s.onInputBlur = function(d) {
      var f = s.props.inputValue;
      s.menuListRef && s.menuListRef.contains(document.activeElement) ? s.inputRef.focus() : (s.props.onBlur && s.props.onBlur(d), s.onInputChange("", { action: "input-blur", prevInputValue: f }), s.onMenuClose(), s.setState({ focusedValue: null, isFocused: !1 }));
    }, s.onOptionHover = function(d) {
      if (!s.blockOptionHover && s.state.focusedOption !== d) {
        var f = s.getFocusableOptions().indexOf(d);
        s.setState({ focusedOption: d, focusedOptionId: f > -1 ? s.getFocusedOptionId(d) : null });
      }
    }, s.shouldHideSelectedOptions = function() {
      return Zre(s.props);
    }, s.onValueInputFocus = function(d) {
      d.preventDefault(), d.stopPropagation(), s.focus();
    }, s.onKeyDown = function(d) {
      var f = s.props, h = f.isMulti, p = f.backspaceRemovesValue, v = f.escapeClearsValue, m = f.inputValue, b = f.isClearable, y = f.isDisabled, w = f.menuIsOpen, S = f.onKeyDown, E = f.tabSelectsValue, I = f.openMenuOnFocus, _ = s.state, A = _.focusedOption, P = _.focusedValue, N = _.selectValue;
      if (!(y || typeof S == "function" && (S(d), d.defaultPrevented))) {
        switch (s.blockOptionHover = !0, d.key) {
          case "ArrowLeft":
            if (!h || m)
              return;
            s.focusValue("previous");
            break;
          case "ArrowRight":
            if (!h || m)
              return;
            s.focusValue("next");
            break;
          case "Delete":
          case "Backspace":
            if (m)
              return;
            if (P)
              s.removeValue(P);
            else {
              if (!p)
                return;
              h ? s.popValue() : b && s.clearValue();
            }
            break;
          case "Tab":
            if (s.isComposing || d.shiftKey || !w || !E || !A || I && s.isOptionSelected(A, N))
              return;
            s.selectOption(A);
            break;
          case "Enter":
            if (d.keyCode === 229)
              break;
            if (w) {
              if (!A || s.isComposing)
                return;
              s.selectOption(A);
              break;
            }
            return;
          case "Escape":
            w ? (s.setState({ inputIsHiddenAfterUpdate: !1 }), s.onInputChange("", { action: "menu-close", prevInputValue: m }), s.onMenuClose()) : b && v && s.clearValue();
            break;
          case " ":
            if (m)
              return;
            if (!w) {
              s.openMenu("first");
              break;
            }
            if (!A)
              return;
            s.selectOption(A);
            break;
          case "ArrowUp":
            w ? s.focusOption("up") : s.openMenu("last");
            break;
          case "ArrowDown":
            w ? s.focusOption("down") : s.openMenu("first");
            break;
          case "PageUp":
            if (!w)
              return;
            s.focusOption("pageup");
            break;
          case "PageDown":
            if (!w)
              return;
            s.focusOption("pagedown");
            break;
          case "Home":
            if (!w)
              return;
            s.focusOption("first");
            break;
          case "End":
            if (!w)
              return;
            s.focusOption("last");
            break;
          default:
            return;
        }
        d.preventDefault();
      }
    }, s.state.instancePrefix = "react-select-" + (s.props.instanceId || ++dgt), s.state.selectValue = FB(a.value), a.menuIsOpen && s.state.selectValue.length) {
      var u = s.getFocusableOptionsWithIds(), l = s.buildFocusableOptions(), c = l.indexOf(s.state.selectValue[0]);
      s.state.focusableOptionsWithIds = u, s.state.focusedOption = l[c], s.state.focusedOptionId = q5(u, l[c]);
    }
    return s;
  }
  return e = o, n = [{ key: "componentDidMount", value: function() {
    this.startListeningComposition(), this.startListeningToTouch(), this.props.closeMenuOnScroll && document && document.addEventListener && document.addEventListener("scroll", this.onScroll, !0), this.props.autoFocus && this.focusInput(), this.props.menuIsOpen && this.state.focusedOption && this.menuListRef && this.focusedOptionRef && VB(this.menuListRef, this.focusedOptionRef);
  } }, { key: "componentDidUpdate", value: function(a) {
    var s = this.props, u = s.isDisabled, l = s.menuIsOpen, c = this.state.isFocused;
    (c && !u && a.isDisabled || c && l && !a.menuIsOpen) && this.focusInput(), c && u && !a.isDisabled ? this.setState({ isFocused: !1 }, this.onMenuClose) : c || u || !a.isDisabled || this.inputRef !== document.activeElement || this.setState({ isFocused: !0 }), this.menuListRef && this.focusedOptionRef && this.scrollToFocusedOptionOnUpdate && (VB(this.menuListRef, this.focusedOptionRef), this.scrollToFocusedOptionOnUpdate = !1);
  } }, { key: "componentWillUnmount", value: function() {
    this.stopListeningComposition(), this.stopListeningToTouch(), document.removeEventListener("scroll", this.onScroll, !0);
  } }, { key: "onMenuOpen", value: function() {
    this.props.onMenuOpen();
  } }, { key: "onMenuClose", value: function() {
    this.onInputChange("", { action: "menu-close", prevInputValue: this.props.inputValue }), this.props.onMenuClose();
  } }, { key: "onInputChange", value: function(a, s) {
    this.props.onInputChange(a, s);
  } }, { key: "focusInput", value: function() {
    this.inputRef && this.inputRef.focus();
  } }, { key: "blurInput", value: function() {
    this.inputRef && this.inputRef.blur();
  } }, { key: "openMenu", value: function(a) {
    var s = this, u = this.state, l = u.selectValue, c = u.isFocused, d = this.buildFocusableOptions(), f = a === "first" ? 0 : d.length - 1;
    if (!this.props.isMulti) {
      var h = d.indexOf(l[0]);
      h > -1 && (f = h);
    }
    this.scrollToFocusedOptionOnUpdate = !(c && this.menuListRef), this.setState({ inputIsHiddenAfterUpdate: !1, focusedValue: null, focusedOption: d[f], focusedOptionId: this.getFocusedOptionId(d[f]) }, function() {
      return s.onMenuOpen();
    });
  } }, { key: "focusValue", value: function(a) {
    var s = this.state, u = s.selectValue, l = s.focusedValue;
    if (this.props.isMulti) {
      this.setState({ focusedOption: null });
      var c = u.indexOf(l);
      l || (c = -1);
      var d = u.length - 1, f = -1;
      if (u.length) {
        switch (a) {
          case "previous":
            f = c === 0 ? 0 : c === -1 ? d : c - 1;
            break;
          case "next":
            c > -1 && c < d && (f = c + 1);
        }
        this.setState({ inputIsHidden: f !== -1, focusedValue: u[f] });
      }
    }
  } }, { key: "focusOption", value: function() {
    var a = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "first", s = this.props.pageSize, u = this.state.focusedOption, l = this.getFocusableOptions();
    if (l.length) {
      var c = 0, d = l.indexOf(u);
      u || (d = -1), a === "up" ? c = d > 0 ? d - 1 : l.length - 1 : a === "down" ? c = (d + 1) % l.length : a === "pageup" ? (c = d - s) < 0 && (c = 0) : a === "pagedown" ? (c = d + s) > l.length - 1 && (c = l.length - 1) : a === "last" && (c = l.length - 1), this.scrollToFocusedOptionOnUpdate = !0, this.setState({ focusedOption: l[c], focusedValue: null, focusedOptionId: this.getFocusedOptionId(l[c]) });
    }
  } }, { key: "getTheme", value: function() {
    return this.props.theme ? typeof this.props.theme == "function" ? this.props.theme(K5) : Bt(Bt({}, K5), this.props.theme) : K5;
  } }, { key: "getCommonProps", value: function() {
    var a = this.clearValue, s = this.cx, u = this.getStyles, l = this.getClassNames, c = this.getValue, d = this.selectOption, f = this.setValue, h = this.props, p = h.isMulti, v = h.isRtl, m = h.options;
    return { clearValue: a, cx: s, getStyles: u, getClassNames: l, getValue: c, hasValue: this.hasValue(), isMulti: p, isRtl: v, options: m, selectOption: d, selectProps: h, setValue: f, theme: this.getTheme() };
  } }, { key: "hasValue", value: function() {
    return this.state.selectValue.length > 0;
  } }, { key: "hasOptions", value: function() {
    return !!this.getFocusableOptions().length;
  } }, { key: "isClearable", value: function() {
    var a = this.props, s = a.isClearable, u = a.isMulti;
    return s === void 0 ? u : s;
  } }, { key: "isOptionDisabled", value: function(a, s) {
    return Ure(this.props, a, s);
  } }, { key: "isOptionSelected", value: function(a, s) {
    return Xre(this.props, a, s);
  } }, { key: "filterOption", value: function(a, s) {
    return Yre(this.props, a, s);
  } }, { key: "formatOptionLabel", value: function(a, s) {
    if (typeof this.props.formatOptionLabel == "function") {
      var u = this.props.inputValue, l = this.state.selectValue;
      return this.props.formatOptionLabel(a, { context: s, inputValue: u, selectValue: l });
    }
    return this.getOptionLabel(a);
  } }, { key: "formatGroupLabel", value: function(a) {
    return this.props.formatGroupLabel(a);
  } }, { key: "startListeningComposition", value: function() {
    document && document.addEventListener && (document.addEventListener("compositionstart", this.onCompositionStart, !1), document.addEventListener("compositionend", this.onCompositionEnd, !1));
  } }, { key: "stopListeningComposition", value: function() {
    document && document.removeEventListener && (document.removeEventListener("compositionstart", this.onCompositionStart), document.removeEventListener("compositionend", this.onCompositionEnd));
  } }, { key: "startListeningToTouch", value: function() {
    document && document.addEventListener && (document.addEventListener("touchstart", this.onTouchStart, !1), document.addEventListener("touchmove", this.onTouchMove, !1), document.addEventListener("touchend", this.onTouchEnd, !1));
  } }, { key: "stopListeningToTouch", value: function() {
    document && document.removeEventListener && (document.removeEventListener("touchstart", this.onTouchStart), document.removeEventListener("touchmove", this.onTouchMove), document.removeEventListener("touchend", this.onTouchEnd));
  } }, { key: "renderInput", value: function() {
    var a = this.props, s = a.isDisabled, u = a.isSearchable, l = a.inputId, c = a.inputValue, d = a.tabIndex, f = a.form, h = a.menuIsOpen, p = a.required, v = this.getComponents().Input, m = this.state, b = m.inputIsHidden, y = m.ariaSelection, w = this.commonProps, S = l || this.getElementId("input"), E = Bt(Bt(Bt({ "aria-autocomplete": "list", "aria-expanded": h, "aria-haspopup": !0, "aria-errormessage": this.props["aria-errormessage"], "aria-invalid": this.props["aria-invalid"], "aria-label": this.props["aria-label"], "aria-labelledby": this.props["aria-labelledby"], "aria-required": p, role: "combobox", "aria-activedescendant": this.isAppleDevice ? void 0 : this.state.focusedOptionId || "" }, h && { "aria-controls": this.getElementId("listbox") }), !u && { "aria-readonly": !0 }), this.hasValue() ? (y == null ? void 0 : y.action) === "initial-input-focus" && { "aria-describedby": this.getElementId("live-region") } : { "aria-describedby": this.getElementId("placeholder") });
    return u ? x.createElement(v, Kt({}, w, { autoCapitalize: "none", autoComplete: "off", autoCorrect: "off", id: S, innerRef: this.getInputRef, isDisabled: s, isHidden: b, onBlur: this.onInputBlur, onChange: this.handleInputChange, onFocus: this.onInputFocus, spellCheck: "false", tabIndex: d, form: f, type: "text", value: c }, E)) : x.createElement(tgt, Kt({ id: S, innerRef: this.getInputRef, onBlur: this.onInputBlur, onChange: Y2, onFocus: this.onInputFocus, disabled: s, tabIndex: d, inputMode: "none", form: f, value: "" }, E));
  } }, { key: "renderPlaceholderOrValue", value: function() {
    var a = this, s = this.getComponents(), u = s.MultiValue, l = s.MultiValueContainer, c = s.MultiValueLabel, d = s.MultiValueRemove, f = s.SingleValue, h = s.Placeholder, p = this.commonProps, v = this.props, m = v.controlShouldRenderValue, b = v.isDisabled, y = v.isMulti, w = v.inputValue, S = v.placeholder, E = this.state, I = E.selectValue, _ = E.focusedValue, A = E.isFocused;
    if (!this.hasValue() || !m)
      return w ? null : x.createElement(h, Kt({}, p, { key: "placeholder", isDisabled: b, isFocused: A, innerProps: { id: this.getElementId("placeholder") } }), S);
    if (y)
      return I.map(function(N, k) {
        var D = N === _, R = "".concat(a.getOptionLabel(N), "-").concat(a.getOptionValue(N));
        return x.createElement(u, Kt({}, p, { components: { Container: l, Label: c, Remove: d }, isFocused: D, isDisabled: b, key: R, index: k, removeProps: { onClick: function() {
          return a.removeValue(N);
        }, onTouchEnd: function() {
          return a.removeValue(N);
        }, onMouseDown: function(V) {
          V.preventDefault();
        } }, data: N }), a.formatOptionLabel(N, "value"));
      });
    if (w)
      return null;
    var P = I[0];
    return x.createElement(f, Kt({}, p, { data: P, isDisabled: b }), this.formatOptionLabel(P, "value"));
  } }, { key: "renderClearIndicator", value: function() {
    var a = this.getComponents().ClearIndicator, s = this.commonProps, u = this.props, l = u.isDisabled, c = u.isLoading, d = this.state.isFocused;
    if (!this.isClearable() || !a || l || !this.hasValue() || c)
      return null;
    var f = { onMouseDown: this.onClearIndicatorMouseDown, onTouchEnd: this.onClearIndicatorTouchEnd, "aria-hidden": "true" };
    return x.createElement(a, Kt({}, s, { innerProps: f, isFocused: d }));
  } }, { key: "renderLoadingIndicator", value: function() {
    var a = this.getComponents().LoadingIndicator, s = this.commonProps, u = this.props, l = u.isDisabled, c = u.isLoading, d = this.state.isFocused;
    return a && c ? x.createElement(a, Kt({}, s, { innerProps: { "aria-hidden": "true" }, isDisabled: l, isFocused: d })) : null;
  } }, { key: "renderIndicatorSeparator", value: function() {
    var a = this.getComponents(), s = a.DropdownIndicator, u = a.IndicatorSeparator;
    if (!s || !u)
      return null;
    var l = this.commonProps, c = this.props.isDisabled, d = this.state.isFocused;
    return x.createElement(u, Kt({}, l, { isDisabled: c, isFocused: d }));
  } }, { key: "renderDropdownIndicator", value: function() {
    var a = this.getComponents().DropdownIndicator;
    if (!a)
      return null;
    var s = this.commonProps, u = this.props.isDisabled, l = this.state.isFocused, c = { onMouseDown: this.onDropdownIndicatorMouseDown, onTouchEnd: this.onDropdownIndicatorTouchEnd, "aria-hidden": "true" };
    return x.createElement(a, Kt({}, s, { innerProps: c, isDisabled: u, isFocused: l }));
  } }, { key: "renderMenu", value: function() {
    var a = this, s = this.getComponents(), u = s.Group, l = s.GroupHeading, c = s.Menu, d = s.MenuList, f = s.MenuPortal, h = s.LoadingMessage, p = s.NoOptionsMessage, v = s.Option, m = this.commonProps, b = this.state.focusedOption, y = this.props, w = y.captureMenuScroll, S = y.inputValue, E = y.isLoading, I = y.loadingMessage, _ = y.minMenuHeight, A = y.maxMenuHeight, P = y.menuIsOpen, N = y.menuPlacement, k = y.menuPosition, D = y.menuPortalTarget, R = y.menuShouldBlockScroll, V = y.menuShouldScrollIntoView, $ = y.noOptionsMessage, F = y.onMenuScrollToTop, M = y.onMenuScrollToBottom;
    if (!P)
      return null;
    var B, X = function(Y, U) {
      var Q = Y.type, Z = Y.data, ee = Y.isDisabled, ie = Y.isSelected, oe = Y.label, se = Y.value, te = b === Z, ge = ee ? void 0 : function() {
        return a.onOptionHover(Z);
      }, he = ee ? void 0 : function() {
        return a.selectOption(Z);
      }, fe = "".concat(a.getElementId("option"), "-").concat(U), _e = { id: fe, onClick: he, onMouseMove: ge, onMouseOver: ge, tabIndex: -1, role: "option", "aria-selected": a.isAppleDevice ? void 0 : ie };
      return x.createElement(v, Kt({}, m, { innerProps: _e, data: Z, isDisabled: ee, isSelected: ie, key: fe, label: oe, type: Q, value: se, isFocused: te, innerRef: te ? a.getFocusedOptionRef : void 0 }), a.formatOptionLabel(Y.data, "menu"));
    };
    if (this.hasOptions())
      B = this.getCategorizedOptions().map(function(Y) {
        if (Y.type === "group") {
          var U = Y.data, Q = Y.options, Z = Y.index, ee = "".concat(a.getElementId("group"), "-").concat(Z), ie = "".concat(ee, "-heading");
          return x.createElement(u, Kt({}, m, { key: ee, data: U, options: Q, Heading: l, headingProps: { id: ie, data: Y.data }, label: a.formatGroupLabel(Y.data) }), Y.options.map(function(oe) {
            return X(oe, "".concat(Z, "-").concat(oe.index));
          }));
        }
        if (Y.type === "option")
          return X(Y, "".concat(Y.index));
      });
    else if (E) {
      var L = I({ inputValue: S });
      if (L === null)
        return null;
      B = x.createElement(h, m, L);
    } else {
      var j = $({ inputValue: S });
      if (j === null)
        return null;
      B = x.createElement(p, m, j);
    }
    var K = { minMenuHeight: _, maxMenuHeight: A, menuPlacement: N, menuPosition: k, menuShouldScrollIntoView: V }, W = x.createElement(Opt, Kt({}, m, K), function(Y) {
      var U = Y.ref, Q = Y.placerProps, Z = Q.placement, ee = Q.maxHeight;
      return x.createElement(c, Kt({}, m, K, { innerRef: U, innerProps: { onMouseDown: a.onMenuMouseDown, onMouseMove: a.onMenuMouseMove }, isLoading: E, placement: Z }), x.createElement(igt, { captureEnabled: w, onTopArrive: F, onBottomArrive: M, lockEnabled: R }, function(ie) {
        return x.createElement(d, Kt({}, m, { innerRef: function(oe) {
          a.getMenuListRef(oe), ie(oe);
        }, innerProps: { role: "listbox", "aria-multiselectable": m.isMulti, id: a.getElementId("listbox") }, isLoading: E, maxHeight: ee, focusedOption: b }), B);
      }));
    });
    return D || k === "fixed" ? x.createElement(f, Kt({}, m, { appendTo: D, controlElement: this.controlRef, menuPlacement: N, menuPosition: k }), W) : W;
  } }, { key: "renderFormField", value: function() {
    var a = this, s = this.props, u = s.delimiter, l = s.isDisabled, c = s.isMulti, d = s.name, f = s.required, h = this.state.selectValue;
    if (f && !this.hasValue() && !l)
      return x.createElement(agt, { name: d, onFocus: this.onValueInputFocus });
    if (d && !l) {
      if (c) {
        if (u) {
          var p = h.map(function(b) {
            return a.getOptionValue(b);
          }).join(u);
          return x.createElement("input", { name: d, type: "hidden", value: p });
        }
        var v = h.length > 0 ? h.map(function(b, y) {
          return x.createElement("input", { key: "i-".concat(y), name: d, type: "hidden", value: a.getOptionValue(b) });
        }) : x.createElement("input", { name: d, type: "hidden", value: "" });
        return x.createElement("div", null, v);
      }
      var m = h[0] ? this.getOptionValue(h[0]) : "";
      return x.createElement("input", { name: d, type: "hidden", value: m });
    }
  } }, { key: "renderLiveRegion", value: function() {
    var a = this.commonProps, s = this.state, u = s.ariaSelection, l = s.focusedOption, c = s.focusedValue, d = s.isFocused, f = s.selectValue, h = this.getFocusableOptions();
    return x.createElement(Jpt, Kt({}, a, { id: this.getElementId("live-region"), ariaSelection: u, focusedOption: l, focusedValue: c, isFocused: d, selectValue: f, focusableOptions: h, isAppleDevice: this.isAppleDevice }));
  } }, { key: "render", value: function() {
    var a = this.getComponents(), s = a.Control, u = a.IndicatorsContainer, l = a.SelectContainer, c = a.ValueContainer, d = this.props, f = d.className, h = d.id, p = d.isDisabled, v = d.menuIsOpen, m = this.state.isFocused, b = this.commonProps = this.getCommonProps();
    return x.createElement(l, Kt({}, b, { className: f, innerProps: { id: h, onKeyDown: this.onKeyDown }, isDisabled: p, isFocused: m }), this.renderLiveRegion(), x.createElement(s, Kt({}, b, { innerRef: this.getControlRef, innerProps: { onMouseDown: this.onControlMouseDown, onTouchEnd: this.onControlTouchEnd }, isDisabled: p, isFocused: m, menuIsOpen: v }), x.createElement(c, Kt({}, b, { isDisabled: p }), this.renderPlaceholderOrValue(), this.renderInput()), x.createElement(u, Kt({}, b, { isDisabled: p }), this.renderClearIndicator(), this.renderLoadingIndicator(), this.renderIndicatorSeparator(), this.renderDropdownIndicator())), this.renderMenu(), this.renderFormField());
  } }], r = [{ key: "getDerivedStateFromProps", value: function(a, s) {
    var u = s.prevProps, l = s.clearFocusValueOnUpdate, c = s.inputIsHiddenAfterUpdate, d = s.ariaSelection, f = s.isFocused, h = s.prevWasFocused, p = s.instancePrefix, v = a.options, m = a.value, b = a.menuIsOpen, y = a.inputValue, w = a.isMulti, S = FB(m), E = {};
    if (u && (m !== u.value || v !== u.options || b !== u.menuIsOpen || y !== u.inputValue)) {
      var I = b ? function(R, V) {
        return tH(ry(R, V));
      }(a, S) : [], _ = b ? nH(ry(a, S), "".concat(p, "-option")) : [], A = l ? function(R, V) {
        var $ = R.focusedValue, F = R.selectValue.indexOf($);
        if (F > -1) {
          if (V.indexOf($) > -1)
            return $;
          if (F < V.length)
            return V[F];
        }
        return null;
      }(s, S) : null, P = function(R, V) {
        var $ = R.focusedOption;
        return $ && V.indexOf($) > -1 ? $ : V[0];
      }(s, I);
      E = { selectValue: S, focusedOption: P, focusedOptionId: q5(_, P), focusableOptionsWithIds: _, focusedValue: A, clearFocusValueOnUpdate: !1 };
    }
    var N = c != null && a !== u ? { inputIsHidden: c, inputIsHiddenAfterUpdate: void 0 } : {}, k = d, D = f && h;
    return f && !D && (k = { value: ny(w, S, S[0] || null), options: S, action: "initial-input-focus" }, D = !h), (d == null ? void 0 : d.action) === "initial-input-focus" && (k = null), Bt(Bt(Bt({}, E), N), {}, { prevProps: a, ariaSelection: k, prevWasFocused: D });
  } }], n && dB(e.prototype, n), r && dB(e, r), Object.defineProperty(e, "prototype", { writable: !1 }), o;
}();
Jre.defaultProps = cgt;
var fgt = ["defaultInputValue", "defaultMenuIsOpen", "defaultValue", "inputValue", "menuIsOpen", "onChange", "onInputChange", "onMenuClose", "onMenuOpen", "value"], hgt = ["defaultOptions", "cacheOptions", "loadOptions", "options", "isLoading", "onInputChange", "filterOption"], iP = ur(function(t) {
  function e(n) {
    return t.exports = e = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(r) {
      return typeof r;
    } : function(r) {
      return r && typeof Symbol == "function" && r.constructor === Symbol && r !== Symbol.prototype ? "symbol" : typeof r;
    }, t.exports.__esModule = !0, t.exports.default = t.exports, e(n);
  }
  t.exports = e, t.exports.__esModule = !0, t.exports.default = t.exports;
}), pgt = ur(function(t) {
  var e = iP.default;
  t.exports = function(n, r) {
    if (e(n) !== "object" || n === null)
      return n;
    var i = n[Symbol.toPrimitive];
    if (i !== void 0) {
      var o = i.call(n, r || "default");
      if (e(o) !== "object")
        return o;
      throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (r === "string" ? String : Number)(n);
  }, t.exports.__esModule = !0, t.exports.default = t.exports;
}), Kre = ur(function(t) {
  var e = iP.default;
  t.exports = function(n) {
    var r = pgt(n, "string");
    return e(r) === "symbol" ? r : String(r);
  }, t.exports.__esModule = !0, t.exports.default = t.exports;
}), ggt = ur(function(t) {
  t.exports = function(e, n, r) {
    return (n = Kre(n)) in e ? Object.defineProperty(e, n, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : e[n] = r, e;
  }, t.exports.__esModule = !0, t.exports.default = t.exports;
});
ur(function(t) {
  function e(n, r) {
    var i = Object.keys(n);
    if (Object.getOwnPropertySymbols) {
      var o = Object.getOwnPropertySymbols(n);
      r && (o = o.filter(function(a) {
        return Object.getOwnPropertyDescriptor(n, a).enumerable;
      })), i.push.apply(i, o);
    }
    return i;
  }
  t.exports = function(n) {
    for (var r = 1; r < arguments.length; r++) {
      var i = arguments[r] != null ? arguments[r] : {};
      r % 2 ? e(Object(i), !0).forEach(function(o) {
        ggt(n, o, i[o]);
      }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(n, Object.getOwnPropertyDescriptors(i)) : e(Object(i)).forEach(function(o) {
        Object.defineProperty(n, o, Object.getOwnPropertyDescriptor(i, o));
      });
    }
    return n;
  }, t.exports.__esModule = !0, t.exports.default = t.exports;
}), ur(function(t) {
  t.exports = function(e, n) {
    if (!(e instanceof n))
      throw new TypeError("Cannot call a class as a function");
  }, t.exports.__esModule = !0, t.exports.default = t.exports;
}), ur(function(t) {
  function e(n, r) {
    for (var i = 0; i < r.length; i++) {
      var o = r[i];
      o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(n, Kre(o.key), o);
    }
  }
  t.exports = function(n, r, i) {
    return r && e(n.prototype, r), i && e(n, i), Object.defineProperty(n, "prototype", { writable: !1 }), n;
  }, t.exports.__esModule = !0, t.exports.default = t.exports;
});
var mgt = ur(function(t) {
  function e(n, r) {
    return t.exports = e = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(i, o) {
      return i.__proto__ = o, i;
    }, t.exports.__esModule = !0, t.exports.default = t.exports, e(n, r);
  }
  t.exports = e, t.exports.__esModule = !0, t.exports.default = t.exports;
});
ur(function(t) {
  t.exports = function(e, n) {
    if (typeof n != "function" && n !== null)
      throw new TypeError("Super expression must either be null or a function");
    e.prototype = Object.create(n && n.prototype, { constructor: { value: e, writable: !0, configurable: !0 } }), Object.defineProperty(e, "prototype", { writable: !1 }), n && mgt(e, n);
  }, t.exports.__esModule = !0, t.exports.default = t.exports;
});
var iH = ur(function(t) {
  function e(n) {
    return t.exports = e = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(r) {
      return r.__proto__ || Object.getPrototypeOf(r);
    }, t.exports.__esModule = !0, t.exports.default = t.exports, e(n);
  }
  t.exports = e, t.exports.__esModule = !0, t.exports.default = t.exports;
}), vgt = ur(function(t) {
  t.exports = function() {
    if (typeof Reflect > "u" || !Reflect.construct || Reflect.construct.sham)
      return !1;
    if (typeof Proxy == "function")
      return !0;
    try {
      return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
      })), !0;
    } catch {
      return !1;
    }
  }, t.exports.__esModule = !0, t.exports.default = t.exports;
}), bgt = ur(function(t) {
  t.exports = function(e) {
    if (e === void 0)
      throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return e;
  }, t.exports.__esModule = !0, t.exports.default = t.exports;
}), ygt = ur(function(t) {
  var e = iP.default;
  t.exports = function(n, r) {
    if (r && (e(r) === "object" || typeof r == "function"))
      return r;
    if (r !== void 0)
      throw new TypeError("Derived constructors may only return object or undefined");
    return bgt(n);
  }, t.exports.__esModule = !0, t.exports.default = t.exports;
});
ur(function(t) {
  t.exports = function(e) {
    var n = vgt();
    return function() {
      var r, i = iH(e);
      if (n) {
        var o = iH(this).constructor;
        r = Reflect.construct(i, arguments, o);
      } else
        r = i.apply(this, arguments);
      return ygt(this, r);
    };
  }, t.exports.__esModule = !0, t.exports.default = t.exports;
});
var F6 = ur(function(t) {
  t.exports = function(e, n) {
    (n == null || n > e.length) && (n = e.length);
    for (var r = 0, i = new Array(n); r < n; r++)
      i[r] = e[r];
    return i;
  }, t.exports.__esModule = !0, t.exports.default = t.exports;
}), xgt = ur(function(t) {
  t.exports = function(e) {
    if (Array.isArray(e))
      return F6(e);
  }, t.exports.__esModule = !0, t.exports.default = t.exports;
}), Cgt = ur(function(t) {
  t.exports = function(e) {
    if (typeof Symbol < "u" && e[Symbol.iterator] != null || e["@@iterator"] != null)
      return Array.from(e);
  }, t.exports.__esModule = !0, t.exports.default = t.exports;
}), qre = ur(function(t) {
  t.exports = function(e, n) {
    if (e) {
      if (typeof e == "string")
        return F6(e, n);
      var r = Object.prototype.toString.call(e).slice(8, -1);
      return r === "Object" && e.constructor && (r = e.constructor.name), r === "Map" || r === "Set" ? Array.from(e) : r === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r) ? F6(e, n) : void 0;
    }
  }, t.exports.__esModule = !0, t.exports.default = t.exports;
}), wgt = ur(function(t) {
  t.exports = function() {
    throw new TypeError(`Invalid attempt to spread non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
  }, t.exports.__esModule = !0, t.exports.default = t.exports;
});
ur(function(t) {
  t.exports = function(e) {
    return xgt(e) || Cgt(e) || qre(e) || wgt();
  }, t.exports.__esModule = !0, t.exports.default = t.exports;
});
var Egt = ur(function(t) {
  t.exports = function(e) {
    if (Array.isArray(e))
      return e;
  }, t.exports.__esModule = !0, t.exports.default = t.exports;
}), Sgt = ur(function(t) {
  t.exports = function(e, n) {
    var r = e == null ? null : typeof Symbol < "u" && e[Symbol.iterator] || e["@@iterator"];
    if (r != null) {
      var i, o, a, s, u = [], l = !0, c = !1;
      try {
        if (a = (r = r.call(e)).next, n === 0) {
          if (Object(r) !== r)
            return;
          l = !1;
        } else
          for (; !(l = (i = a.call(r)).done) && (u.push(i.value), u.length !== n); l = !0)
            ;
      } catch (d) {
        c = !0, o = d;
      } finally {
        try {
          if (!l && r.return != null && (s = r.return(), Object(s) !== s))
            return;
        } finally {
          if (c)
            throw o;
        }
      }
      return u;
    }
  }, t.exports.__esModule = !0, t.exports.default = t.exports;
}), Igt = ur(function(t) {
  t.exports = function() {
    throw new TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
  }, t.exports.__esModule = !0, t.exports.default = t.exports;
});
ur(function(t) {
  t.exports = function(e, n) {
    return Egt(e) || Sgt(e, n) || qre(e, n) || Igt();
  }, t.exports.__esModule = !0, t.exports.default = t.exports;
});
var _gt = ur(function(t) {
  t.exports = function(e, n) {
    if (e == null)
      return {};
    var r, i, o = {}, a = Object.keys(e);
    for (i = 0; i < a.length; i++)
      r = a[i], n.indexOf(r) >= 0 || (o[r] = e[r]);
    return o;
  }, t.exports.__esModule = !0, t.exports.default = t.exports;
});
ur(function(t) {
  t.exports = function(e, n) {
    if (e == null)
      return {};
    var r, i, o = _gt(e, n);
    if (Object.getOwnPropertySymbols) {
      var a = Object.getOwnPropertySymbols(e);
      for (i = 0; i < a.length; i++)
        r = a[i], n.indexOf(r) >= 0 || Object.prototype.propertyIsEnumerable.call(e, r) && (o[r] = e[r]);
    }
    return o;
  }, t.exports.__esModule = !0, t.exports.default = t.exports;
}), ur(function(t) {
  t.exports = function(e, n) {
    return n || (n = e.slice(0)), Object.freeze(Object.defineProperties(e, { raw: { value: Object.freeze(n) } }));
  }, t.exports.__esModule = !0, t.exports.default = t.exports;
});
var Agt = gt(function(t, e) {
  var n = function(i) {
    var o = i.defaultOptions, a = o !== void 0 && o, s = i.cacheOptions, u = s !== void 0 && s, l = i.loadOptions;
    i.options;
    var c = i.isLoading, d = c !== void 0 && c, f = i.onInputChange, h = i.filterOption, p = h === void 0 ? null : h, v = tu(i, hgt), m = v.inputValue, b = Ee(void 0), y = Ee(!1), w = Ii(Le(Array.isArray(a) ? a : void 0), 2), S = w[0], E = w[1], I = Ii(Le(m !== void 0 ? m : ""), 2), _ = I[0], A = I[1], P = Ii(Le(a === !0), 2), N = P[0], k = P[1], D = Ii(Le(void 0), 2), R = D[0], V = D[1], $ = Ii(Le([]), 2), F = $[0], M = $[1], B = Ii(Le(!1), 2), X = B[0], L = B[1], j = Ii(Le({}), 2), K = j[0], W = j[1], Y = Ii(Le(void 0), 2), U = Y[0], Q = Y[1], Z = Ii(Le(void 0), 2), ee = Z[0], ie = Z[1];
    u !== ee && (W({}), ie(u)), a !== U && (E(Array.isArray(a) ? a : void 0), Q(a)), Re(function() {
      return y.current = !0, function() {
        y.current = !1;
      };
    }, []);
    var oe = et(function(ge, he) {
      if (!l)
        return he();
      var fe = l(ge, he);
      fe && typeof fe.then == "function" && fe.then(he, function() {
        return he();
      });
    }, [l]);
    Re(function() {
      a === !0 && oe(_, function(ge) {
        y.current && (E(ge || []), k(!!b.current));
      });
    }, []);
    var se = et(function(ge, he) {
      var fe = function(Ne, ze, Ve) {
        if (Ve) {
          var ne = Ve(Ne, ze);
          if (typeof ne == "string")
            return ne;
        }
        return Ne;
      }(ge, he, f);
      if (!fe)
        return b.current = void 0, A(""), V(""), M([]), k(!1), void L(!1);
      if (u && K[fe])
        A(fe), V(fe), M(K[fe]), k(!1), L(!1);
      else {
        var _e = b.current = {};
        A(fe), k(!0), L(!R), oe(fe, function(Ne) {
          y && _e === b.current && (b.current = void 0, k(!1), V(fe), M(Ne || []), L(!1), W(Ne ? Bt(Bt({}, K), {}, $h({}, fe, Ne)) : K));
        });
      }
    }, [u, oe, R, K, f]), te = X ? [] : _ && R ? F : S || [];
    return Bt(Bt({}, v), {}, { options: te, isLoading: N || d, onInputChange: se, filterOption: p });
  }(t), r = function(i) {
    var o = i.defaultInputValue, a = o === void 0 ? "" : o, s = i.defaultMenuIsOpen, u = s !== void 0 && s, l = i.defaultValue, c = l === void 0 ? null : l, d = i.inputValue, f = i.menuIsOpen, h = i.onChange, p = i.onInputChange, v = i.onMenuClose, m = i.onMenuOpen, b = i.value, y = tu(i, fgt), w = Ii(Le(d !== void 0 ? d : a), 2), S = w[0], E = w[1], I = Ii(Le(f !== void 0 ? f : u), 2), _ = I[0], A = I[1], P = Ii(Le(b !== void 0 ? b : c), 2), N = P[0], k = P[1], D = et(function(X, L) {
      typeof h == "function" && h(X, L), k(X);
    }, [h]), R = et(function(X, L) {
      var j;
      typeof p == "function" && (j = p(X, L)), E(j !== void 0 ? j : X);
    }, [p]), V = et(function() {
      typeof m == "function" && m(), A(!0);
    }, [m]), $ = et(function() {
      typeof v == "function" && v(), A(!1);
    }, [v]), F = d !== void 0 ? d : S, M = f !== void 0 ? f : _, B = b !== void 0 ? b : N;
    return Bt(Bt({}, y), {}, { inputValue: F, menuIsOpen: M, onChange: D, onInputChange: R, onMenuClose: $, onMenuOpen: V, value: B });
  }(n);
  return x.createElement(Jre, Kt({ ref: e }, r));
}), Tgt = Agt, Ogt = function t(e, n) {
  if (e === n)
    return !0;
  if (e && n && typeof e == "object" && typeof n == "object") {
    if (e.constructor !== n.constructor)
      return !1;
    var r, i, o;
    if (Array.isArray(e)) {
      if ((r = e.length) != n.length)
        return !1;
      for (i = r; i-- != 0; )
        if (!t(e[i], n[i]))
          return !1;
      return !0;
    }
    if (e.constructor === RegExp)
      return e.source === n.source && e.flags === n.flags;
    if (e.valueOf !== Object.prototype.valueOf)
      return e.valueOf() === n.valueOf();
    if (e.toString !== Object.prototype.toString)
      return e.toString() === n.toString();
    if ((r = (o = Object.keys(e)).length) !== Object.keys(n).length)
      return !1;
    for (i = r; i-- != 0; )
      if (!Object.prototype.hasOwnProperty.call(n, o[i]))
        return !1;
    for (i = r; i-- != 0; ) {
      var a = o[i];
      if (!t(e[a], n[a]))
        return !1;
    }
    return !0;
  }
  return e != e && n != n;
}, Dh;
(function(t) {
  t[t.INITIALIZED = 0] = "INITIALIZED", t[t.LOADING = 1] = "LOADING", t[t.SUCCESS = 2] = "SUCCESS", t[t.FAILURE = 3] = "FAILURE";
})(Dh || (Dh = {}));
class ud {
  constructor({ apiKey: e, authReferrerPolicy: n, channel: r, client: i, id: o = "__googleMapsScriptId", language: a, libraries: s = [], mapIds: u, nonce: l, region: c, retries: d = 3, url: f = "https://maps.googleapis.com/maps/api/js", version: h }) {
    if (this.CALLBACK = "__googleMapsCallback", this.callbacks = [], this.done = !1, this.loading = !1, this.errors = [], this.apiKey = e, this.authReferrerPolicy = n, this.channel = r, this.client = i, this.id = o || "__googleMapsScriptId", this.language = a, this.libraries = s, this.mapIds = u, this.nonce = l, this.region = c, this.retries = d, this.url = f, this.version = h, ud.instance) {
      if (!Ogt(this.options, ud.instance.options))
        throw new Error(`Loader must not be called again with different options. ${JSON.stringify(this.options)} !== ${JSON.stringify(ud.instance.options)}`);
      return ud.instance;
    }
    ud.instance = this;
  }
  get options() {
    return { version: this.version, apiKey: this.apiKey, channel: this.channel, client: this.client, id: this.id, libraries: this.libraries, language: this.language, region: this.region, mapIds: this.mapIds, nonce: this.nonce, url: this.url, authReferrerPolicy: this.authReferrerPolicy };
  }
  get status() {
    return this.errors.length ? Dh.FAILURE : this.done ? Dh.SUCCESS : this.loading ? Dh.LOADING : Dh.INITIALIZED;
  }
  get failed() {
    return this.done && !this.loading && this.errors.length >= this.retries + 1;
  }
  createUrl() {
    let e = this.url;
    return e += `?callback=${this.CALLBACK}`, this.apiKey && (e += `&key=${this.apiKey}`), this.channel && (e += `&channel=${this.channel}`), this.client && (e += `&client=${this.client}`), this.libraries.length > 0 && (e += `&libraries=${this.libraries.join(",")}`), this.language && (e += `&language=${this.language}`), this.region && (e += `&region=${this.region}`), this.version && (e += `&v=${this.version}`), this.mapIds && (e += `&map_ids=${this.mapIds.join(",")}`), this.authReferrerPolicy && (e += `&auth_referrer_policy=${this.authReferrerPolicy}`), e;
  }
  deleteScript() {
    const e = document.getElementById(this.id);
    e && e.remove();
  }
  load() {
    return this.loadPromise();
  }
  loadPromise() {
    return new Promise((e, n) => {
      this.loadCallback((r) => {
        r ? n(r.error) : e(window.google);
      });
    });
  }
  loadCallback(e) {
    this.callbacks.push(e), this.execute();
  }
  setScript() {
    if (document.getElementById(this.id))
      return void this.callback();
    const e = this.createUrl(), n = document.createElement("script");
    n.id = this.id, n.type = "text/javascript", n.src = e, n.onerror = this.loadErrorCallback.bind(this), n.defer = !0, n.async = !0, this.nonce && (n.nonce = this.nonce), document.head.appendChild(n);
  }
  reset() {
    this.deleteScript(), this.done = !1, this.loading = !1, this.errors = [], this.onerrorEvent = null;
  }
  resetIfRetryingFailed() {
    this.failed && this.reset();
  }
  loadErrorCallback(e) {
    if (this.errors.push(e), this.errors.length <= this.retries) {
      const n = this.errors.length * Math.pow(2, this.errors.length);
      console.log(`Failed to load Google Maps script, retrying in ${n} ms.`), setTimeout(() => {
        this.deleteScript(), this.setScript();
      }, n);
    } else
      this.onerrorEvent = e, this.callback();
  }
  setCallback() {
    window.__googleMapsCallback = this.callback.bind(this);
  }
  callback() {
    this.done = !0, this.loading = !1, this.callbacks.forEach((e) => {
      e(this.onerrorEvent);
    }), this.callbacks = [];
  }
  execute() {
    if (this.resetIfRetryingFailed(), this.done)
      this.callback();
    else {
      if (window.google && window.google.maps && window.google.maps.version)
        return console.warn("Google Maps already loaded outside @googlemaps/js-api-loader.This may result in undesirable behavior as options and script parameters may not match."), void this.callback();
      this.loading || (this.loading = !0, this.setCallback(), this.setScript());
    }
  }
}
var Pgt = function(t, e, n) {
  var r, i = t.bounds, o = t.location, a = function(u, l) {
    var c = {};
    for (var d in u)
      Object.prototype.hasOwnProperty.call(u, d) && l.indexOf(d) < 0 && (c[d] = u[d]);
    if (u != null && typeof Object.getOwnPropertySymbols == "function") {
      var f = 0;
      for (d = Object.getOwnPropertySymbols(u); f < d.length; f++)
        l.indexOf(d[f]) < 0 && Object.prototype.propertyIsEnumerable.call(u, d[f]) && (c[d[f]] = u[d[f]]);
    }
    return c;
  }(t, ["bounds", "location"]), s = _d({ input: e }, a);
  return n && (s.sessionToken = n), i && (s.bounds = new ((r = google.maps.LatLngBounds).bind.apply(r, function() {
    for (var u = 0, l = 0, c = arguments.length; l < c; l++)
      u += arguments[l].length;
    var d = Array(u), f = 0;
    for (l = 0; l < c; l++)
      for (var h = arguments[l], p = 0, v = h.length; p < v; p++, f++)
        d[f] = h[p];
    return d;
  }([void 0], i)))()), o && (s.location = new google.maps.LatLng(o)), s;
}, Ngt = function(t) {
  var e = t.autocompletionRequest, n = t.debounce, r = t.minLengthAutocomplete, i = t.placesService, o = t.sessionToken, a = t.withSessionToken, s = function(u, l, c) {
    c === void 0 && (c = {});
    var d = c.maxWait, f = Ee(null), h = Ee([]), p = c.leading, v = c.trailing === void 0 || c.trailing, m = Ee(!1), b = Ee(null), y = Ee(!1), w = Ee(u);
    w.current = u;
    var S = et(function() {
      clearTimeout(b.current), clearTimeout(f.current), f.current = null, h.current = [], b.current = null, m.current = !1;
    }, []);
    Re(function() {
      return y.current = !1, function() {
        y.current = !0;
      };
    }, []);
    var E = et(function() {
      for (var _ = [], A = 0; A < arguments.length; A++)
        _[A] = arguments[A];
      h.current = _, clearTimeout(b.current), m.current && (m.current = !1), b.current || !p || m.current || (w.current.apply(w, _), m.current = !0), b.current = setTimeout(function() {
        var P = !0;
        p && m.current && (P = !1), S(), !y.current && v && P && w.current.apply(w, _);
      }, l), d && !f.current && v && (f.current = setTimeout(function() {
        var P = h.current;
        S(), y.current || w.current.apply(null, P);
      }, d));
    }, [d, l, S, p, v]), I = et(function() {
      b.current && (w.current.apply(null, h.current), S());
    }, [S]);
    return [E, S, I];
  }(function(u, l) {
    if (!i)
      return l([]);
    if (u.length < r)
      return l([]);
    var c = _d({}, e);
    i.getPlacePredictions(Pgt(c, u, a && o), function(d) {
      l((d || []).map(function(f) {
        return { label: f.description, value: f };
      }));
    });
  }, n)[0];
  return s;
}, kgt = gt(function(t, e) {
  var n, r, i, o, a, s, u, l, c = function(v) {
    var m = v.apiKey, b = v.apiOptions, y = v.onLoadFailed, w = Le(void 0), S = w[0], E = w[1], I = Le(void 0), _ = I[0], A = I[1], P = function() {
      if (!window.google)
        throw new Error("[react-google-places-autocomplete]: Google script not loaded");
      if (!window.google.maps)
        throw new Error("[react-google-places-autocomplete]: Google maps script not loaded");
      if (!window.google.maps.places)
        throw new Error("[react-google-places-autocomplete]: Google maps places script not loaded");
      E(new window.google.maps.places.AutocompleteService()), A(new google.maps.places.AutocompleteSessionToken());
    };
    return Re(function() {
      m ? Eht(void 0, void 0, void 0, function() {
        var N;
        return Sht(this, function(k) {
          switch (k.label) {
            case 0:
              if (!m)
                return [2];
              k.label = 1;
            case 1:
              return k.trys.push([1, 4, , 5]), window.google && window.google.maps && window.google.maps.places ? [3, 3] : [4, new ud(_d({ apiKey: m }, _d({ libraries: ["places"] }, b))).load()];
            case 2:
              k.sent(), k.label = 3;
            case 3:
              return P(), [3, 5];
            case 4:
              return N = k.sent(), typeof y == "function" && y(N), [3, 5];
            case 5:
              return [2];
          }
        });
      }) : P();
    }, []), { placesService: S, sessionToken: _, setSessionToken: A };
  }({ apiKey: (n = t.apiKey) !== null && n !== void 0 ? n : "", apiOptions: (r = t.apiOptions) !== null && r !== void 0 ? r : {}, onLoadFailed: (i = t.onLoadFailed) !== null && i !== void 0 ? i : console.error }), d = c.placesService, f = c.sessionToken, h = c.setSessionToken, p = Ngt({ autocompletionRequest: (o = t.autocompletionRequest) !== null && o !== void 0 ? o : {}, debounce: (a = t.debounce) !== null && a !== void 0 ? a : 300, minLengthAutocomplete: (s = t.minLengthAutocomplete) !== null && s !== void 0 ? s : 0, placesService: d, sessionToken: f, withSessionToken: (u = t.withSessionToken) !== null && u !== void 0 && u });
  return wc(e, function() {
    return { getSessionToken: function() {
      return f;
    }, refreshSessionToken: function() {
      h(new google.maps.places.AutocompleteSessionToken());
    } };
  }, [f]), O.createElement(Tgt, _d({}, (l = t.selectProps) !== null && l !== void 0 ? l : {}, { loadOptions: p, getOptionValue: function(v) {
    return v.value.place_id;
  } }));
}), Rgt = function(t) {
  var e = new window.google.maps.Geocoder(), n = window.google.maps.GeocoderStatus.OK;
  return new Promise(function(r, i) {
    e.geocode({ placeId: t }, function(o, a) {
      return a !== n ? i(a) : r(o);
    });
  });
};
const Nbt = (t) => {
  const {
    value: e,
    config: {
      selectProps: n = {},
      apiKey: r,
      ...i
    } = {},
    renderFormattedAddress: o,
    onChange: a
  } = t, [s, u] = Le(e || void 0);
  if (Re(() => {
    u(e);
  }, [e]), !i || !r)
    return /* @__PURE__ */ Oe.jsx("div", { children: "API KEY must be provided to config" });
  const l = ({ value: f }) => {
    f && Rgt(f.place_id).then((h) => {
      var p, v, m, b, y, w, S, E;
      if (h.length > 0) {
        const I = h[0], _ = {
          formattedAddress: o ? o(I) : I.formatted_address,
          route: (p = I.address_components.find((A) => A.types.includes("route"))) == null ? void 0 : p.long_name,
          streetNumber: (v = I.address_components.find((A) => A.types.includes("street_number"))) == null ? void 0 : v.long_name,
          city: (m = I.address_components.find((A) => A.types.includes("locality"))) == null ? void 0 : m.long_name,
          zipCode: (b = I.address_components.find((A) => A.types.includes("postal_code"))) == null ? void 0 : b.long_name,
          lat: (y = I.geometry) == null ? void 0 : y.location.lat(),
          lng: (w = I.geometry) == null ? void 0 : w.location.lng(),
          administrativeAreaLevels: I.address_components.filter((A) => A.types.some((P) => P.includes("administrative_area_level"))),
          countryIso: (S = I.address_components.find((A) => A.types.includes("country"))) == null ? void 0 : S.short_name,
          country: (E = I.address_components.find((A) => A.types.includes("country"))) == null ? void 0 : E.long_name
        };
        a(_), u(_);
      }
    }).catch((h) => console.error(h));
  };
  let c;
  s && typeof s == "string" ? c = { value: s, label: s } : s != null && s.formattedAddress && (c = { value: s.formattedAddress, label: s.formattedAddress });
  const d = {
    ...(i == null ? void 0 : i.autocompletionRequest) || {},
    ...t.autocompletionRequest || {}
  };
  return /* @__PURE__ */ Pe(
    kgt,
    {
      ...i || {},
      autocompletionRequest: d,
      key: c == null ? void 0 : c.value,
      selectProps: {
        onChange: l,
        value: c,
        ...n || {},
        ...t.selectProps || {}
      },
      apiKey: r
    }
  );
};
var Qre = function(t) {
  return typeof t == "function";
}, $gt = process.env.NODE_ENV === "development" || process.env.NODE_ENV === "test";
const eie = $gt;
function tie(t) {
  var e = Ee(t);
  return e.current = t, e;
}
var Dgt = function(t) {
  eie && (Qre(t) || console.error("useUnmount expected parameter is a function, got ".concat(typeof t)));
  var e = tie(t);
  Re(function() {
    return function() {
      e.current();
    };
  }, []);
};
const Mgt = Dgt;
function Fgt(t, e) {
  var n;
  eie && (Qre(t) || console.error("useDebounceFn expected parameter is a function, got ".concat(typeof t)));
  var r = tie(t), i = (n = e == null ? void 0 : e.wait) !== null && n !== void 0 ? n : 1e3, o = Rn(function() {
    return CSe(function() {
      for (var a = [], s = 0; s < arguments.length; s++)
        a[s] = arguments[s];
      return r.current.apply(r, see([], git(a), !1));
    }, i, e);
  }, []);
  return Mgt(function() {
    o.cancel();
  }), {
    run: o,
    cancel: o.cancel,
    flush: o.flush
  };
}
const nie = (t) => (e, n) => !t.some((i) => ii(e, i) === ii(n, i) ? !1 : !VC(ii(e, i), ii(n, i))), Lgt = (t) => {
  const {
    item: e,
    onAdd: n,
    itemHeader: r,
    onRemove: i,
    index: o,
    number: a,
    readOnly: s,
    layout: u = "horizontal",
    renderLabel: l,
    onChange: c,
    schema: d,
    removeComponent: f,
    errors: h,
    formProps: p = {},
    separator: v = null
  } = t;
  return e._destroy ? null : /* @__PURE__ */ Oe.jsxs(Wm, { children: [
    r && /* @__PURE__ */ Oe.jsx(rc, { span: 24, children: r({
      readOnly: s,
      add: n,
      remove: () => i(o),
      field: e,
      index: o
    }) }),
    /* @__PURE__ */ Oe.jsx(rc, { span: 24, className: "nested-form", children: /* @__PURE__ */ Oe.jsx(
      Z8,
      {
        renderLabel: l,
        layout: u,
        ...p,
        readOnly: s,
        onChange: (m, b) => c(o, b),
        schema: typeof d == "function" ? d(e, o, { onRemove: () => i(o), onAdd: n, number: a }) : d,
        object: e,
        errors: h
      }
    ) }),
    !s && f ? /* @__PURE__ */ Oe.jsx(rc, { span: 24, children: /* @__PURE__ */ Oe.jsx(bd.Item, { children: typeof f == "function" ? f(() => i(o)) : f }) }) : null,
    v
  ] });
}, Vgt = O.memo(
  Lgt,
  nie(["item", "schema", "errors"])
), Bgt = ({ onChange: t, beforeChange: e }) => (n, r) => {
  switch (r.type) {
    case "SET_VALUES":
      return r.payload;
    case "CHANGE_VALUES":
      const i = [...n];
      let o = {};
      return e ? o = e(i[r.index], r.payload) : o = {
        ...i[r.index],
        ...r.payload
      }, i[r.index] = o, t(i), i;
    case "ADD":
      const a = [...n || [], {}];
      return t(a), a;
    case "REMOVE_VALUES":
      const s = [...n || []];
      let u = { ...s[r.index] };
      return u.id ? s[r.index] = { ...u, _destroy: !0 } : s.splice(r.index, 1), t(s), s;
    default:
      return n;
  }
}, Hgt = (t) => {
  const {
    value: e,
    error: n,
    separator: r,
    schema: i,
    maxLength: o,
    itemHeader: a,
    renderLabel: s,
    layout: u = "horizontal",
    className: l = "",
    formProps: c = {},
    remove: d,
    add: f,
    beforeChange: h,
    readOnly: p = !1
  } = t, { run: v } = Fgt((I) => {
    t.onChange && t.onChange(I);
  }, { wait: 200 }), [m, b] = Nm(
    Bgt({ onChange: v, beforeChange: h }),
    e || []
  );
  Re(() => b({ type: "SET_VALUES", payload: e || [] }), [
    e
  ]);
  const y = () => b({
    type: "ADD"
    /* ADD */
  }), w = (I) => b({ type: "REMOVE_VALUES", index: I }), S = (I, _) => b({ type: "CHANGE_VALUES", payload: _, index: I });
  let E = 0;
  return /* @__PURE__ */ Oe.jsxs("div", { className: l, children: [
    (m || []).map((I, _) => (I._destroy || (E = E + 1), /* @__PURE__ */ Oe.jsx(
      Vgt,
      {
        layout: u,
        renderLabel: s,
        item: I,
        index: _,
        number: E,
        formProps: c,
        itemHeader: a,
        onRemove: w,
        removeComponent: d,
        schema: i,
        onAdd: y,
        onChange: S,
        errors: ii(n, _, {}),
        readOnly: p,
        separator: _ < m.length - 1 && r && r
      }
    ))),
    !p && (!o || (m || []).filter((I) => !I._destroy).length < o) && /* @__PURE__ */ Oe.jsx(Oe.Fragment, { children: f ? /* @__PURE__ */ Oe.jsx("div", { children: typeof f == "function" ? f(y) : /* @__PURE__ */ Oe.jsx(ko, { type: "dashed", onClick: y, children: f }) }) : /* @__PURE__ */ Oe.jsx("a", { onClick: y, children: "Add" }) })
  ] });
}, kbt = O.memo(
  Hgt,
  nie(["value", "schema", "error"])
);
function Wgt(t) {
  if (t.sheet)
    return t.sheet;
  for (var e = 0; e < document.styleSheets.length; e++)
    if (document.styleSheets[e].ownerNode === t)
      return document.styleSheets[e];
}
function jgt(t) {
  var e = document.createElement("style");
  return e.setAttribute("data-emotion", t.key), t.nonce !== void 0 && e.setAttribute("nonce", t.nonce), e.appendChild(document.createTextNode("")), e.setAttribute("data-s", ""), e;
}
var zgt = /* @__PURE__ */ function() {
  function t(n) {
    var r = this;
    this._insertTag = function(i) {
      var o;
      r.tags.length === 0 ? r.insertionPoint ? o = r.insertionPoint.nextSibling : r.prepend ? o = r.container.firstChild : o = r.before : o = r.tags[r.tags.length - 1].nextSibling, r.container.insertBefore(i, o), r.tags.push(i);
    }, this.isSpeedy = n.speedy === void 0 ? process.env.NODE_ENV === "production" : n.speedy, this.tags = [], this.ctr = 0, this.nonce = n.nonce, this.key = n.key, this.container = n.container, this.prepend = n.prepend, this.insertionPoint = n.insertionPoint, this.before = null;
  }
  var e = t.prototype;
  return e.hydrate = function(r) {
    r.forEach(this._insertTag);
  }, e.insert = function(r) {
    this.ctr % (this.isSpeedy ? 65e3 : 1) === 0 && this._insertTag(jgt(this));
    var i = this.tags[this.tags.length - 1];
    if (process.env.NODE_ENV !== "production") {
      var o = r.charCodeAt(0) === 64 && r.charCodeAt(1) === 105;
      o && this._alreadyInsertedOrderInsensitiveRule && console.error(`You're attempting to insert the following rule:
` + r + "\n\n`@import` rules must be before all other types of rules in a stylesheet but other rules have already been inserted. Please ensure that `@import` rules are before all other rules."), this._alreadyInsertedOrderInsensitiveRule = this._alreadyInsertedOrderInsensitiveRule || !o;
    }
    if (this.isSpeedy) {
      var a = Wgt(i);
      try {
        a.insertRule(r, a.cssRules.length);
      } catch (s) {
        process.env.NODE_ENV !== "production" && !/:(-moz-placeholder|-moz-focus-inner|-moz-focusring|-ms-input-placeholder|-moz-read-write|-moz-read-only|-ms-clear|-ms-expand|-ms-reveal){/.test(r) && console.error('There was a problem inserting the following rule: "' + r + '"', s);
      }
    } else
      i.appendChild(document.createTextNode(r));
    this.ctr++;
  }, e.flush = function() {
    this.tags.forEach(function(r) {
      return r.parentNode && r.parentNode.removeChild(r);
    }), this.tags = [], this.ctr = 0, process.env.NODE_ENV !== "production" && (this._alreadyInsertedOrderInsensitiveRule = !1);
  }, t;
}(), Yi = "-ms-", K2 = "-moz-", Yn = "-webkit-", oP = "comm", aP = "rule", sP = "decl", Ggt = "@import", rie = "@keyframes", Ugt = "@layer", Xgt = Math.abs, cE = String.fromCharCode, Ygt = Object.assign;
function Zgt(t, e) {
  return Fi(t, 0) ^ 45 ? (((e << 2 ^ Fi(t, 0)) << 2 ^ Fi(t, 1)) << 2 ^ Fi(t, 2)) << 2 ^ Fi(t, 3) : 0;
}
function iie(t) {
  return t.trim();
}
function Jgt(t, e) {
  return (t = e.exec(t)) ? t[0] : t;
}
function Zn(t, e, n) {
  return t.replace(e, n);
}
function L6(t, e) {
  return t.indexOf(e);
}
function Fi(t, e) {
  return t.charCodeAt(e) | 0;
}
function _m(t, e, n) {
  return t.slice(e, n);
}
function Ks(t) {
  return t.length;
}
function uP(t) {
  return t.length;
}
function iy(t, e) {
  return e.push(t), t;
}
function Kgt(t, e) {
  return t.map(e).join("");
}
var dE = 1, yp = 1, oie = 0, $o = 0, di = 0, Jp = "";
function fE(t, e, n, r, i, o, a) {
  return { value: t, root: e, parent: n, type: r, props: i, children: o, line: dE, column: yp, length: a, return: "" };
}
function Yg(t, e) {
  return Ygt(fE("", null, null, "", null, null, 0), t, { length: -t.length }, e);
}
function qgt() {
  return di;
}
function Qgt() {
  return di = $o > 0 ? Fi(Jp, --$o) : 0, yp--, di === 10 && (yp = 1, dE--), di;
}
function fa() {
  return di = $o < oie ? Fi(Jp, $o++) : 0, yp++, di === 10 && (yp = 1, dE++), di;
}
function du() {
  return Fi(Jp, $o);
}
function ex() {
  return $o;
}
function Dv(t, e) {
  return _m(Jp, t, e);
}
function Am(t) {
  switch (t) {
    case 0:
    case 9:
    case 10:
    case 13:
    case 32:
      return 5;
    case 33:
    case 43:
    case 44:
    case 47:
    case 62:
    case 64:
    case 126:
    case 59:
    case 123:
    case 125:
      return 4;
    case 58:
      return 3;
    case 34:
    case 39:
    case 40:
    case 91:
      return 2;
    case 41:
    case 93:
      return 1;
  }
  return 0;
}
function aie(t) {
  return dE = yp = 1, oie = Ks(Jp = t), $o = 0, [];
}
function sie(t) {
  return Jp = "", t;
}
function tx(t) {
  return iie(Dv($o - 1, V6(t === 91 ? t + 2 : t === 40 ? t + 1 : t)));
}
function e0t(t) {
  for (; (di = du()) && di < 33; )
    fa();
  return Am(t) > 2 || Am(di) > 3 ? "" : " ";
}
function t0t(t, e) {
  for (; --e && fa() && !(di < 48 || di > 102 || di > 57 && di < 65 || di > 70 && di < 97); )
    ;
  return Dv(t, ex() + (e < 6 && du() == 32 && fa() == 32));
}
function V6(t) {
  for (; fa(); )
    switch (di) {
      case t:
        return $o;
      case 34:
      case 39:
        t !== 34 && t !== 39 && V6(di);
        break;
      case 40:
        t === 41 && V6(t);
        break;
      case 92:
        fa();
        break;
    }
  return $o;
}
function n0t(t, e) {
  for (; fa() && t + di !== 57; )
    if (t + di === 84 && du() === 47)
      break;
  return "/*" + Dv(e, $o - 1) + "*" + cE(t === 47 ? t : fa());
}
function r0t(t) {
  for (; !Am(du()); )
    fa();
  return Dv(t, $o);
}
function i0t(t) {
  return sie(nx("", null, null, null, [""], t = aie(t), 0, [0], t));
}
function nx(t, e, n, r, i, o, a, s, u) {
  for (var l = 0, c = 0, d = a, f = 0, h = 0, p = 0, v = 1, m = 1, b = 1, y = 0, w = "", S = i, E = o, I = r, _ = w; m; )
    switch (p = y, y = fa()) {
      case 40:
        if (p != 108 && Fi(_, d - 1) == 58) {
          L6(_ += Zn(tx(y), "&", "&\f"), "&\f") != -1 && (b = -1);
          break;
        }
      case 34:
      case 39:
      case 91:
        _ += tx(y);
        break;
      case 9:
      case 10:
      case 13:
      case 32:
        _ += e0t(p);
        break;
      case 92:
        _ += t0t(ex() - 1, 7);
        continue;
      case 47:
        switch (du()) {
          case 42:
          case 47:
            iy(o0t(n0t(fa(), ex()), e, n), u);
            break;
          default:
            _ += "/";
        }
        break;
      case 123 * v:
        s[l++] = Ks(_) * b;
      case 125 * v:
      case 59:
      case 0:
        switch (y) {
          case 0:
          case 125:
            m = 0;
          case 59 + c:
            b == -1 && (_ = Zn(_, /\f/g, "")), h > 0 && Ks(_) - d && iy(h > 32 ? aH(_ + ";", r, n, d - 1) : aH(Zn(_, " ", "") + ";", r, n, d - 2), u);
            break;
          case 59:
            _ += ";";
          default:
            if (iy(I = oH(_, e, n, l, c, i, s, w, S = [], E = [], d), o), y === 123)
              if (c === 0)
                nx(_, e, I, I, S, o, d, s, E);
              else
                switch (f === 99 && Fi(_, 3) === 110 ? 100 : f) {
                  case 100:
                  case 108:
                  case 109:
                  case 115:
                    nx(t, I, I, r && iy(oH(t, I, I, 0, 0, i, s, w, i, S = [], d), E), i, E, d, s, r ? S : E);
                    break;
                  default:
                    nx(_, I, I, I, [""], E, 0, s, E);
                }
        }
        l = c = h = 0, v = b = 1, w = _ = "", d = a;
        break;
      case 58:
        d = 1 + Ks(_), h = p;
      default:
        if (v < 1) {
          if (y == 123)
            --v;
          else if (y == 125 && v++ == 0 && Qgt() == 125)
            continue;
        }
        switch (_ += cE(y), y * v) {
          case 38:
            b = c > 0 ? 1 : (_ += "\f", -1);
            break;
          case 44:
            s[l++] = (Ks(_) - 1) * b, b = 1;
            break;
          case 64:
            du() === 45 && (_ += tx(fa())), f = du(), c = d = Ks(w = _ += r0t(ex())), y++;
            break;
          case 45:
            p === 45 && Ks(_) == 2 && (v = 0);
        }
    }
  return o;
}
function oH(t, e, n, r, i, o, a, s, u, l, c) {
  for (var d = i - 1, f = i === 0 ? o : [""], h = uP(f), p = 0, v = 0, m = 0; p < r; ++p)
    for (var b = 0, y = _m(t, d + 1, d = Xgt(v = a[p])), w = t; b < h; ++b)
      (w = iie(v > 0 ? f[b] + " " + y : Zn(y, /&\f/g, f[b]))) && (u[m++] = w);
  return fE(t, e, n, i === 0 ? aP : s, u, l, c);
}
function o0t(t, e, n) {
  return fE(t, e, n, oP, cE(qgt()), _m(t, 2, -2), 0);
}
function aH(t, e, n, r) {
  return fE(t, e, n, sP, _m(t, 0, r), _m(t, r + 1, -1), r);
}
function qh(t, e) {
  for (var n = "", r = uP(t), i = 0; i < r; i++)
    n += e(t[i], i, t, e) || "";
  return n;
}
function a0t(t, e, n, r) {
  switch (t.type) {
    case Ugt:
      if (t.children.length)
        break;
    case Ggt:
    case sP:
      return t.return = t.return || t.value;
    case oP:
      return "";
    case rie:
      return t.return = t.value + "{" + qh(t.children, r) + "}";
    case aP:
      t.value = t.props.join(",");
  }
  return Ks(n = qh(t.children, r)) ? t.return = t.value + "{" + n + "}" : "";
}
function s0t(t) {
  var e = uP(t);
  return function(n, r, i, o) {
    for (var a = "", s = 0; s < e; s++)
      a += t[s](n, r, i, o) || "";
    return a;
  };
}
function u0t(t) {
  return function(e) {
    e.root || (e = e.return) && t(e);
  };
}
function l0t(t) {
  var e = /* @__PURE__ */ Object.create(null);
  return function(n) {
    return e[n] === void 0 && (e[n] = t(n)), e[n];
  };
}
var c0t = function(e, n, r) {
  for (var i = 0, o = 0; i = o, o = du(), i === 38 && o === 12 && (n[r] = 1), !Am(o); )
    fa();
  return Dv(e, $o);
}, d0t = function(e, n) {
  var r = -1, i = 44;
  do
    switch (Am(i)) {
      case 0:
        i === 38 && du() === 12 && (n[r] = 1), e[r] += c0t($o - 1, n, r);
        break;
      case 2:
        e[r] += tx(i);
        break;
      case 4:
        if (i === 44) {
          e[++r] = du() === 58 ? "&\f" : "", n[r] = e[r].length;
          break;
        }
      default:
        e[r] += cE(i);
    }
  while (i = fa());
  return e;
}, f0t = function(e, n) {
  return sie(d0t(aie(e), n));
}, sH = /* @__PURE__ */ new WeakMap(), h0t = function(e) {
  if (!(e.type !== "rule" || !e.parent || // positive .length indicates that this rule contains pseudo
  // negative .length indicates that this rule has been already prefixed
  e.length < 1)) {
    for (var n = e.value, r = e.parent, i = e.column === r.column && e.line === r.line; r.type !== "rule"; )
      if (r = r.parent, !r)
        return;
    if (!(e.props.length === 1 && n.charCodeAt(0) !== 58 && !sH.get(r)) && !i) {
      sH.set(e, !0);
      for (var o = [], a = f0t(n, o), s = r.props, u = 0, l = 0; u < a.length; u++)
        for (var c = 0; c < s.length; c++, l++)
          e.props[l] = o[u] ? a[u].replace(/&\f/g, s[c]) : s[c] + " " + a[u];
    }
  }
}, p0t = function(e) {
  if (e.type === "decl") {
    var n = e.value;
    // charcode for l
    n.charCodeAt(0) === 108 && // charcode for b
    n.charCodeAt(2) === 98 && (e.return = "", e.value = "");
  }
}, g0t = "emotion-disable-server-rendering-unsafe-selector-warning-please-do-not-use-this-the-warning-exists-for-a-reason", m0t = function(e) {
  return e.type === "comm" && e.children.indexOf(g0t) > -1;
}, v0t = function(e) {
  return function(n, r, i) {
    if (!(n.type !== "rule" || e.compat)) {
      var o = n.value.match(/(:first|:nth|:nth-last)-child/g);
      if (o) {
        for (var a = !!n.parent, s = a ? n.parent.children : (
          // global rule at the root level
          i
        ), u = s.length - 1; u >= 0; u--) {
          var l = s[u];
          if (l.line < n.line)
            break;
          if (l.column < n.column) {
            if (m0t(l))
              return;
            break;
          }
        }
        o.forEach(function(c) {
          console.error('The pseudo class "' + c + '" is potentially unsafe when doing server-side rendering. Try changing it to "' + c.split("-child")[0] + '-of-type".');
        });
      }
    }
  };
}, uie = function(e) {
  return e.type.charCodeAt(1) === 105 && e.type.charCodeAt(0) === 64;
}, b0t = function(e, n) {
  for (var r = e - 1; r >= 0; r--)
    if (!uie(n[r]))
      return !0;
  return !1;
}, uH = function(e) {
  e.type = "", e.value = "", e.return = "", e.children = "", e.props = "";
}, y0t = function(e, n, r) {
  uie(e) && (e.parent ? (console.error("`@import` rules can't be nested inside other rules. Please move it to the top level and put it before regular rules. Keep in mind that they can only be used within global styles."), uH(e)) : b0t(n, r) && (console.error("`@import` rules can't be after other rules. Please put your `@import` rules before your other rules."), uH(e)));
};
function lie(t, e) {
  switch (Zgt(t, e)) {
    case 5103:
      return Yn + "print-" + t + t;
    case 5737:
    case 4201:
    case 3177:
    case 3433:
    case 1641:
    case 4457:
    case 2921:
    case 5572:
    case 6356:
    case 5844:
    case 3191:
    case 6645:
    case 3005:
    case 6391:
    case 5879:
    case 5623:
    case 6135:
    case 4599:
    case 4855:
    case 4215:
    case 6389:
    case 5109:
    case 5365:
    case 5621:
    case 3829:
      return Yn + t + t;
    case 5349:
    case 4246:
    case 4810:
    case 6968:
    case 2756:
      return Yn + t + K2 + t + Yi + t + t;
    case 6828:
    case 4268:
      return Yn + t + Yi + t + t;
    case 6165:
      return Yn + t + Yi + "flex-" + t + t;
    case 5187:
      return Yn + t + Zn(t, /(\w+).+(:[^]+)/, Yn + "box-$1$2" + Yi + "flex-$1$2") + t;
    case 5443:
      return Yn + t + Yi + "flex-item-" + Zn(t, /flex-|-self/, "") + t;
    case 4675:
      return Yn + t + Yi + "flex-line-pack" + Zn(t, /align-content|flex-|-self/, "") + t;
    case 5548:
      return Yn + t + Yi + Zn(t, "shrink", "negative") + t;
    case 5292:
      return Yn + t + Yi + Zn(t, "basis", "preferred-size") + t;
    case 6060:
      return Yn + "box-" + Zn(t, "-grow", "") + Yn + t + Yi + Zn(t, "grow", "positive") + t;
    case 4554:
      return Yn + Zn(t, /([^-])(transform)/g, "$1" + Yn + "$2") + t;
    case 6187:
      return Zn(Zn(Zn(t, /(zoom-|grab)/, Yn + "$1"), /(image-set)/, Yn + "$1"), t, "") + t;
    case 5495:
    case 3959:
      return Zn(t, /(image-set\([^]*)/, Yn + "$1$`$1");
    case 4968:
      return Zn(Zn(t, /(.+:)(flex-)?(.*)/, Yn + "box-pack:$3" + Yi + "flex-pack:$3"), /s.+-b[^;]+/, "justify") + Yn + t + t;
    case 4095:
    case 3583:
    case 4068:
    case 2532:
      return Zn(t, /(.+)-inline(.+)/, Yn + "$1$2") + t;
    case 8116:
    case 7059:
    case 5753:
    case 5535:
    case 5445:
    case 5701:
    case 4933:
    case 4677:
    case 5533:
    case 5789:
    case 5021:
    case 4765:
      if (Ks(t) - 1 - e > 6)
        switch (Fi(t, e + 1)) {
          case 109:
            if (Fi(t, e + 4) !== 45)
              break;
          case 102:
            return Zn(t, /(.+:)(.+)-([^]+)/, "$1" + Yn + "$2-$3$1" + K2 + (Fi(t, e + 3) == 108 ? "$3" : "$2-$3")) + t;
          case 115:
            return ~L6(t, "stretch") ? lie(Zn(t, "stretch", "fill-available"), e) + t : t;
        }
      break;
    case 4949:
      if (Fi(t, e + 1) !== 115)
        break;
    case 6444:
      switch (Fi(t, Ks(t) - 3 - (~L6(t, "!important") && 10))) {
        case 107:
          return Zn(t, ":", ":" + Yn) + t;
        case 101:
          return Zn(t, /(.+:)([^;!]+)(;|!.+)?/, "$1" + Yn + (Fi(t, 14) === 45 ? "inline-" : "") + "box$3$1" + Yn + "$2$3$1" + Yi + "$2box$3") + t;
      }
      break;
    case 5936:
      switch (Fi(t, e + 11)) {
        case 114:
          return Yn + t + Yi + Zn(t, /[svh]\w+-[tblr]{2}/, "tb") + t;
        case 108:
          return Yn + t + Yi + Zn(t, /[svh]\w+-[tblr]{2}/, "tb-rl") + t;
        case 45:
          return Yn + t + Yi + Zn(t, /[svh]\w+-[tblr]{2}/, "lr") + t;
      }
      return Yn + t + Yi + t + t;
  }
  return t;
}
var x0t = function(e, n, r, i) {
  if (e.length > -1 && !e.return)
    switch (e.type) {
      case sP:
        e.return = lie(e.value, e.length);
        break;
      case rie:
        return qh([Yg(e, {
          value: Zn(e.value, "@", "@" + Yn)
        })], i);
      case aP:
        if (e.length)
          return Kgt(e.props, function(o) {
            switch (Jgt(o, /(::plac\w+|:read-\w+)/)) {
              case ":read-only":
              case ":read-write":
                return qh([Yg(e, {
                  props: [Zn(o, /:(read-\w+)/, ":" + K2 + "$1")]
                })], i);
              case "::placeholder":
                return qh([Yg(e, {
                  props: [Zn(o, /:(plac\w+)/, ":" + Yn + "input-$1")]
                }), Yg(e, {
                  props: [Zn(o, /:(plac\w+)/, ":" + K2 + "$1")]
                }), Yg(e, {
                  props: [Zn(o, /:(plac\w+)/, Yi + "input-$1")]
                })], i);
            }
            return "";
          });
    }
}, C0t = [x0t], w0t = function(e) {
  var n = e.key;
  if (process.env.NODE_ENV !== "production" && !n)
    throw new Error(`You have to configure \`key\` for your cache. Please make sure it's unique (and not equal to 'css') as it's used for linking styles to your cache.
If multiple caches share the same key they might "fight" for each other's style elements.`);
  if (n === "css") {
    var r = document.querySelectorAll("style[data-emotion]:not([data-s])");
    Array.prototype.forEach.call(r, function(v) {
      var m = v.getAttribute("data-emotion");
      m.indexOf(" ") !== -1 && (document.head.appendChild(v), v.setAttribute("data-s", ""));
    });
  }
  var i = e.stylisPlugins || C0t;
  if (process.env.NODE_ENV !== "production" && /[^a-z-]/.test(n))
    throw new Error('Emotion key must only contain lower case alphabetical characters and - but "' + n + '" was passed');
  var o = {}, a, s = [];
  a = e.container || document.head, Array.prototype.forEach.call(
    // this means we will ignore elements which don't have a space in them which
    // means that the style elements we're looking at are only Emotion 11 server-rendered style elements
    document.querySelectorAll('style[data-emotion^="' + n + ' "]'),
    function(v) {
      for (var m = v.getAttribute("data-emotion").split(" "), b = 1; b < m.length; b++)
        o[m[b]] = !0;
      s.push(v);
    }
  );
  var u, l = [h0t, p0t];
  process.env.NODE_ENV !== "production" && l.push(v0t({
    get compat() {
      return p.compat;
    }
  }), y0t);
  {
    var c, d = [a0t, process.env.NODE_ENV !== "production" ? function(v) {
      v.root || (v.return ? c.insert(v.return) : v.value && v.type !== oP && c.insert(v.value + "{}"));
    } : u0t(function(v) {
      c.insert(v);
    })], f = s0t(l.concat(i, d)), h = function(m) {
      return qh(i0t(m), f);
    };
    u = function(m, b, y, w) {
      c = y, process.env.NODE_ENV !== "production" && b.map !== void 0 && (c = {
        insert: function(E) {
          y.insert(E + b.map);
        }
      }), h(m ? m + "{" + b.styles + "}" : b.styles), w && (p.inserted[b.name] = !0);
    };
  }
  var p = {
    key: n,
    sheet: new zgt({
      key: n,
      container: a,
      nonce: e.nonce,
      speedy: e.speedy,
      prepend: e.prepend,
      insertionPoint: e.insertionPoint
    }),
    nonce: e.nonce,
    inserted: o,
    registered: {},
    insert: u
  };
  return p.sheet.hydrate(s), p;
}, B6 = { exports: {} }, or = {};
/** @license React v16.13.1
 * react-is.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var lH;
function E0t() {
  return lH || (lH = 1, process.env.NODE_ENV !== "production" && function() {
    var t = typeof Symbol == "function" && Symbol.for, e = t ? Symbol.for("react.element") : 60103, n = t ? Symbol.for("react.portal") : 60106, r = t ? Symbol.for("react.fragment") : 60107, i = t ? Symbol.for("react.strict_mode") : 60108, o = t ? Symbol.for("react.profiler") : 60114, a = t ? Symbol.for("react.provider") : 60109, s = t ? Symbol.for("react.context") : 60110, u = t ? Symbol.for("react.async_mode") : 60111, l = t ? Symbol.for("react.concurrent_mode") : 60111, c = t ? Symbol.for("react.forward_ref") : 60112, d = t ? Symbol.for("react.suspense") : 60113, f = t ? Symbol.for("react.suspense_list") : 60120, h = t ? Symbol.for("react.memo") : 60115, p = t ? Symbol.for("react.lazy") : 60116, v = t ? Symbol.for("react.block") : 60121, m = t ? Symbol.for("react.fundamental") : 60117, b = t ? Symbol.for("react.responder") : 60118, y = t ? Symbol.for("react.scope") : 60119;
    function w(te) {
      return typeof te == "string" || typeof te == "function" || // Note: its typeof might be other than 'symbol' or 'number' if it's a polyfill.
      te === r || te === l || te === o || te === i || te === d || te === f || typeof te == "object" && te !== null && (te.$$typeof === p || te.$$typeof === h || te.$$typeof === a || te.$$typeof === s || te.$$typeof === c || te.$$typeof === m || te.$$typeof === b || te.$$typeof === y || te.$$typeof === v);
    }
    function S(te) {
      if (typeof te == "object" && te !== null) {
        var ge = te.$$typeof;
        switch (ge) {
          case e:
            var he = te.type;
            switch (he) {
              case u:
              case l:
              case r:
              case o:
              case i:
              case d:
                return he;
              default:
                var fe = he && he.$$typeof;
                switch (fe) {
                  case s:
                  case c:
                  case p:
                  case h:
                  case a:
                    return fe;
                  default:
                    return ge;
                }
            }
          case n:
            return ge;
        }
      }
    }
    var E = u, I = l, _ = s, A = a, P = e, N = c, k = r, D = p, R = h, V = n, $ = o, F = i, M = d, B = !1;
    function X(te) {
      return B || (B = !0, console.warn("The ReactIs.isAsyncMode() alias has been deprecated, and will be removed in React 17+. Update your code to use ReactIs.isConcurrentMode() instead. It has the exact same API.")), L(te) || S(te) === u;
    }
    function L(te) {
      return S(te) === l;
    }
    function j(te) {
      return S(te) === s;
    }
    function K(te) {
      return S(te) === a;
    }
    function W(te) {
      return typeof te == "object" && te !== null && te.$$typeof === e;
    }
    function Y(te) {
      return S(te) === c;
    }
    function U(te) {
      return S(te) === r;
    }
    function Q(te) {
      return S(te) === p;
    }
    function Z(te) {
      return S(te) === h;
    }
    function ee(te) {
      return S(te) === n;
    }
    function ie(te) {
      return S(te) === o;
    }
    function oe(te) {
      return S(te) === i;
    }
    function se(te) {
      return S(te) === d;
    }
    or.AsyncMode = E, or.ConcurrentMode = I, or.ContextConsumer = _, or.ContextProvider = A, or.Element = P, or.ForwardRef = N, or.Fragment = k, or.Lazy = D, or.Memo = R, or.Portal = V, or.Profiler = $, or.StrictMode = F, or.Suspense = M, or.isAsyncMode = X, or.isConcurrentMode = L, or.isContextConsumer = j, or.isContextProvider = K, or.isElement = W, or.isForwardRef = Y, or.isFragment = U, or.isLazy = Q, or.isMemo = Z, or.isPortal = ee, or.isProfiler = ie, or.isStrictMode = oe, or.isSuspense = se, or.isValidElementType = w, or.typeOf = S;
  }()), or;
}
var ar = {};
/** @license React v16.13.1
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var cH;
function S0t() {
  if (cH)
    return ar;
  cH = 1;
  var t = typeof Symbol == "function" && Symbol.for, e = t ? Symbol.for("react.element") : 60103, n = t ? Symbol.for("react.portal") : 60106, r = t ? Symbol.for("react.fragment") : 60107, i = t ? Symbol.for("react.strict_mode") : 60108, o = t ? Symbol.for("react.profiler") : 60114, a = t ? Symbol.for("react.provider") : 60109, s = t ? Symbol.for("react.context") : 60110, u = t ? Symbol.for("react.async_mode") : 60111, l = t ? Symbol.for("react.concurrent_mode") : 60111, c = t ? Symbol.for("react.forward_ref") : 60112, d = t ? Symbol.for("react.suspense") : 60113, f = t ? Symbol.for("react.suspense_list") : 60120, h = t ? Symbol.for("react.memo") : 60115, p = t ? Symbol.for("react.lazy") : 60116, v = t ? Symbol.for("react.block") : 60121, m = t ? Symbol.for("react.fundamental") : 60117, b = t ? Symbol.for("react.responder") : 60118, y = t ? Symbol.for("react.scope") : 60119;
  function w(E) {
    if (typeof E == "object" && E !== null) {
      var I = E.$$typeof;
      switch (I) {
        case e:
          switch (E = E.type, E) {
            case u:
            case l:
            case r:
            case o:
            case i:
            case d:
              return E;
            default:
              switch (E = E && E.$$typeof, E) {
                case s:
                case c:
                case p:
                case h:
                case a:
                  return E;
                default:
                  return I;
              }
          }
        case n:
          return I;
      }
    }
  }
  function S(E) {
    return w(E) === l;
  }
  return ar.AsyncMode = u, ar.ConcurrentMode = l, ar.ContextConsumer = s, ar.ContextProvider = a, ar.Element = e, ar.ForwardRef = c, ar.Fragment = r, ar.Lazy = p, ar.Memo = h, ar.Portal = n, ar.Profiler = o, ar.StrictMode = i, ar.Suspense = d, ar.isAsyncMode = function(E) {
    return S(E) || w(E) === u;
  }, ar.isConcurrentMode = S, ar.isContextConsumer = function(E) {
    return w(E) === s;
  }, ar.isContextProvider = function(E) {
    return w(E) === a;
  }, ar.isElement = function(E) {
    return typeof E == "object" && E !== null && E.$$typeof === e;
  }, ar.isForwardRef = function(E) {
    return w(E) === c;
  }, ar.isFragment = function(E) {
    return w(E) === r;
  }, ar.isLazy = function(E) {
    return w(E) === p;
  }, ar.isMemo = function(E) {
    return w(E) === h;
  }, ar.isPortal = function(E) {
    return w(E) === n;
  }, ar.isProfiler = function(E) {
    return w(E) === o;
  }, ar.isStrictMode = function(E) {
    return w(E) === i;
  }, ar.isSuspense = function(E) {
    return w(E) === d;
  }, ar.isValidElementType = function(E) {
    return typeof E == "string" || typeof E == "function" || E === r || E === l || E === o || E === i || E === d || E === f || typeof E == "object" && E !== null && (E.$$typeof === p || E.$$typeof === h || E.$$typeof === a || E.$$typeof === s || E.$$typeof === c || E.$$typeof === m || E.$$typeof === b || E.$$typeof === y || E.$$typeof === v);
  }, ar.typeOf = w, ar;
}
process.env.NODE_ENV === "production" ? B6.exports = S0t() : B6.exports = E0t();
var I0t = B6.exports, cie = I0t, _0t = {
  $$typeof: !0,
  render: !0,
  defaultProps: !0,
  displayName: !0,
  propTypes: !0
}, A0t = {
  $$typeof: !0,
  compare: !0,
  defaultProps: !0,
  displayName: !0,
  propTypes: !0,
  type: !0
}, die = {};
die[cie.ForwardRef] = _0t;
die[cie.Memo] = A0t;
var T0t = !0;
function fie(t, e, n) {
  var r = "";
  return n.split(" ").forEach(function(i) {
    t[i] !== void 0 ? e.push(t[i] + ";") : r += i + " ";
  }), r;
}
var lP = function(e, n, r) {
  var i = e.key + "-" + n.name;
  // we only need to add the styles to the registered cache if the
  // class name could be used further down
  // the tree but if it's a string tag, we know it won't
  // so we don't have to add it to registered cache.
  // this improves memory usage since we can avoid storing the whole style string
  (r === !1 || // we need to always store it if we're in compat mode and
  // in node since emotion-server relies on whether a style is in
  // the registered cache to know whether a style is global or not
  // also, note that this check will be dead code eliminated in the browser
  T0t === !1) && e.registered[i] === void 0 && (e.registered[i] = n.styles);
}, cP = function(e, n, r) {
  lP(e, n, r);
  var i = e.key + "-" + n.name;
  if (e.inserted[n.name] === void 0) {
    var o = n;
    do
      e.insert(n === o ? "." + i : "", o, e.sheet, !0), o = o.next;
    while (o !== void 0);
  }
};
function O0t(t) {
  for (var e = 0, n, r = 0, i = t.length; i >= 4; ++r, i -= 4)
    n = t.charCodeAt(r) & 255 | (t.charCodeAt(++r) & 255) << 8 | (t.charCodeAt(++r) & 255) << 16 | (t.charCodeAt(++r) & 255) << 24, n = /* Math.imul(k, m): */
    (n & 65535) * 1540483477 + ((n >>> 16) * 59797 << 16), n ^= /* k >>> r: */
    n >>> 24, e = /* Math.imul(k, m): */
    (n & 65535) * 1540483477 + ((n >>> 16) * 59797 << 16) ^ /* Math.imul(h, m): */
    (e & 65535) * 1540483477 + ((e >>> 16) * 59797 << 16);
  switch (i) {
    case 3:
      e ^= (t.charCodeAt(r + 2) & 255) << 16;
    case 2:
      e ^= (t.charCodeAt(r + 1) & 255) << 8;
    case 1:
      e ^= t.charCodeAt(r) & 255, e = /* Math.imul(h, m): */
      (e & 65535) * 1540483477 + ((e >>> 16) * 59797 << 16);
  }
  return e ^= e >>> 13, e = /* Math.imul(h, m): */
  (e & 65535) * 1540483477 + ((e >>> 16) * 59797 << 16), ((e ^ e >>> 15) >>> 0).toString(36);
}
var P0t = {
  animationIterationCount: 1,
  aspectRatio: 1,
  borderImageOutset: 1,
  borderImageSlice: 1,
  borderImageWidth: 1,
  boxFlex: 1,
  boxFlexGroup: 1,
  boxOrdinalGroup: 1,
  columnCount: 1,
  columns: 1,
  flex: 1,
  flexGrow: 1,
  flexPositive: 1,
  flexShrink: 1,
  flexNegative: 1,
  flexOrder: 1,
  gridRow: 1,
  gridRowEnd: 1,
  gridRowSpan: 1,
  gridRowStart: 1,
  gridColumn: 1,
  gridColumnEnd: 1,
  gridColumnSpan: 1,
  gridColumnStart: 1,
  msGridRow: 1,
  msGridRowSpan: 1,
  msGridColumn: 1,
  msGridColumnSpan: 1,
  fontWeight: 1,
  lineHeight: 1,
  opacity: 1,
  order: 1,
  orphans: 1,
  tabSize: 1,
  widows: 1,
  zIndex: 1,
  zoom: 1,
  WebkitLineClamp: 1,
  // SVG-related properties
  fillOpacity: 1,
  floodOpacity: 1,
  stopOpacity: 1,
  strokeDasharray: 1,
  strokeDashoffset: 1,
  strokeMiterlimit: 1,
  strokeOpacity: 1,
  strokeWidth: 1
}, dH = `You have illegal escape sequence in your template literal, most likely inside content's property value.
Because you write your CSS inside a JavaScript string you actually have to do double escaping, so for example "content: '\\00d7';" should become "content: '\\\\00d7';".
You can read more about this here:
https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Template_literals#ES2018_revision_of_illegal_escape_sequences`, N0t = "You have passed in falsy value as style object's key (can happen when in example you pass unexported component as computed key).", k0t = /[A-Z]|^ms/g, hie = /_EMO_([^_]+?)_([^]*?)_EMO_/g, dP = function(e) {
  return e.charCodeAt(1) === 45;
}, fH = function(e) {
  return e != null && typeof e != "boolean";
}, Q5 = /* @__PURE__ */ l0t(function(t) {
  return dP(t) ? t : t.replace(k0t, "-$&").toLowerCase();
}), q2 = function(e, n) {
  switch (e) {
    case "animation":
    case "animationName":
      if (typeof n == "string")
        return n.replace(hie, function(r, i, o) {
          return Cs = {
            name: i,
            styles: o,
            next: Cs
          }, i;
        });
  }
  return P0t[e] !== 1 && !dP(e) && typeof n == "number" && n !== 0 ? n + "px" : n;
};
if (process.env.NODE_ENV !== "production") {
  var R0t = /(var|attr|counters?|url|element|(((repeating-)?(linear|radial))|conic)-gradient)\(|(no-)?(open|close)-quote/, $0t = ["normal", "none", "initial", "inherit", "unset"], D0t = q2, M0t = /^-ms-/, F0t = /-(.)/g, hH = {};
  q2 = function(e, n) {
    if (e === "content" && (typeof n != "string" || $0t.indexOf(n) === -1 && !R0t.test(n) && (n.charAt(0) !== n.charAt(n.length - 1) || n.charAt(0) !== '"' && n.charAt(0) !== "'")))
      throw new Error("You seem to be using a value for 'content' without quotes, try replacing it with `content: '\"" + n + "\"'`");
    var r = D0t(e, n);
    return r !== "" && !dP(e) && e.indexOf("-") !== -1 && hH[e] === void 0 && (hH[e] = !0, console.error("Using kebab-case for css properties in objects is not supported. Did you mean " + e.replace(M0t, "ms-").replace(F0t, function(i, o) {
      return o.toUpperCase();
    }) + "?")), r;
  };
}
var pie = "Component selectors can only be used in conjunction with @emotion/babel-plugin, the swc Emotion plugin, or another Emotion-aware compiler transform.";
function Tm(t, e, n) {
  if (n == null)
    return "";
  if (n.__emotion_styles !== void 0) {
    if (process.env.NODE_ENV !== "production" && n.toString() === "NO_COMPONENT_SELECTOR")
      throw new Error(pie);
    return n;
  }
  switch (typeof n) {
    case "boolean":
      return "";
    case "object": {
      if (n.anim === 1)
        return Cs = {
          name: n.name,
          styles: n.styles,
          next: Cs
        }, n.name;
      if (n.styles !== void 0) {
        var r = n.next;
        if (r !== void 0)
          for (; r !== void 0; )
            Cs = {
              name: r.name,
              styles: r.styles,
              next: Cs
            }, r = r.next;
        var i = n.styles + ";";
        return process.env.NODE_ENV !== "production" && n.map !== void 0 && (i += n.map), i;
      }
      return L0t(t, e, n);
    }
    case "function": {
      if (t !== void 0) {
        var o = Cs, a = n(t);
        return Cs = o, Tm(t, e, a);
      } else
        process.env.NODE_ENV !== "production" && console.error("Functions that are interpolated in css calls will be stringified.\nIf you want to have a css call based on props, create a function that returns a css call like this\nlet dynamicStyle = (props) => css`color: ${props.color}`\nIt can be called directly with props or interpolated in a styled call like this\nlet SomeComponent = styled('div')`${dynamicStyle}`");
      break;
    }
    case "string":
      if (process.env.NODE_ENV !== "production") {
        var s = [], u = n.replace(hie, function(c, d, f) {
          var h = "animation" + s.length;
          return s.push("const " + h + " = keyframes`" + f.replace(/^@keyframes animation-\w+/, "") + "`"), "${" + h + "}";
        });
        s.length && console.error("`keyframes` output got interpolated into plain string, please wrap it with `css`.\n\nInstead of doing this:\n\n" + [].concat(s, ["`" + u + "`"]).join(`
`) + `

You should wrap it with \`css\` like this:

` + ("css`" + u + "`"));
      }
      break;
  }
  if (e == null)
    return n;
  var l = e[n];
  return l !== void 0 ? l : n;
}
function L0t(t, e, n) {
  var r = "";
  if (Array.isArray(n))
    for (var i = 0; i < n.length; i++)
      r += Tm(t, e, n[i]) + ";";
  else
    for (var o in n) {
      var a = n[o];
      if (typeof a != "object")
        e != null && e[a] !== void 0 ? r += o + "{" + e[a] + "}" : fH(a) && (r += Q5(o) + ":" + q2(o, a) + ";");
      else {
        if (o === "NO_COMPONENT_SELECTOR" && process.env.NODE_ENV !== "production")
          throw new Error(pie);
        if (Array.isArray(a) && typeof a[0] == "string" && (e == null || e[a[0]] === void 0))
          for (var s = 0; s < a.length; s++)
            fH(a[s]) && (r += Q5(o) + ":" + q2(o, a[s]) + ";");
        else {
          var u = Tm(t, e, a);
          switch (o) {
            case "animation":
            case "animationName": {
              r += Q5(o) + ":" + u + ";";
              break;
            }
            default:
              process.env.NODE_ENV !== "production" && o === "undefined" && console.error(N0t), r += o + "{" + u + "}";
          }
        }
      }
    }
  return r;
}
var pH = /label:\s*([^\s;\n{]+)\s*(;|$)/g, gie;
process.env.NODE_ENV !== "production" && (gie = /\/\*#\ssourceMappingURL=data:application\/json;\S+\s+\*\//g);
var Cs, Om = function(e, n, r) {
  if (e.length === 1 && typeof e[0] == "object" && e[0] !== null && e[0].styles !== void 0)
    return e[0];
  var i = !0, o = "";
  Cs = void 0;
  var a = e[0];
  a == null || a.raw === void 0 ? (i = !1, o += Tm(r, n, a)) : (process.env.NODE_ENV !== "production" && a[0] === void 0 && console.error(dH), o += a[0]);
  for (var s = 1; s < e.length; s++)
    o += Tm(r, n, e[s]), i && (process.env.NODE_ENV !== "production" && a[s] === void 0 && console.error(dH), o += a[s]);
  var u;
  process.env.NODE_ENV !== "production" && (o = o.replace(gie, function(f) {
    return u = f, "";
  })), pH.lastIndex = 0;
  for (var l = "", c; (c = pH.exec(o)) !== null; )
    l += "-" + // $FlowFixMe we know it's not null
    c[1];
  var d = O0t(o) + l;
  return process.env.NODE_ENV !== "production" ? {
    name: d,
    styles: o,
    map: u,
    next: Cs,
    toString: function() {
      return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
    }
  } : {
    name: d,
    styles: o,
    next: Cs
  };
}, V0t = function(e) {
  return e();
}, mie = x.useInsertionEffect ? x.useInsertionEffect : !1, vie = mie || V0t, gH = mie || x.useLayoutEffect, fP = {}.hasOwnProperty, hP = /* @__PURE__ */ x.createContext(
  // we're doing this to avoid preconstruct's dead code elimination in this one case
  // because this module is primarily intended for the browser and node
  // but it's also required in react native and similar environments sometimes
  // and we could have a special build just for that
  // but this is much easier and the native packages
  // might use a different theme context in the future anyway
  typeof HTMLElement < "u" ? /* @__PURE__ */ w0t({
    key: "css"
  }) : null
);
process.env.NODE_ENV !== "production" && (hP.displayName = "EmotionCacheContext");
hP.Provider;
var pP = function(e) {
  return /* @__PURE__ */ gt(function(n, r) {
    var i = fn(hP);
    return e(n, i, r);
  });
}, hE = /* @__PURE__ */ x.createContext({});
process.env.NODE_ENV !== "production" && (hE.displayName = "EmotionThemeContext");
var mH = function(e) {
  var n = e.split(".");
  return n[n.length - 1];
}, B0t = function(e) {
  var n = /^\s+at\s+([A-Za-z0-9$.]+)\s/.exec(e);
  if (n || (n = /^([A-Za-z0-9$.]+)@/.exec(e), n))
    return mH(n[1]);
}, H0t = /* @__PURE__ */ new Set(["renderWithHooks", "processChild", "finishClassComponent", "renderToString"]), W0t = function(e) {
  return e.replace(/\$/g, "-");
}, j0t = function(e) {
  if (e)
    for (var n = e.split(`
`), r = 0; r < n.length; r++) {
      var i = B0t(n[r]);
      if (i) {
        if (H0t.has(i))
          break;
        if (/^[A-Z]/.test(i))
          return W0t(i);
      }
    }
}, H6 = "__EMOTION_TYPE_PLEASE_DO_NOT_USE__", W6 = "__EMOTION_LABEL_PLEASE_DO_NOT_USE__", z0t = function(e, n) {
  if (process.env.NODE_ENV !== "production" && typeof n.css == "string" && // check if there is a css declaration
  n.css.indexOf(":") !== -1)
    throw new Error("Strings are not allowed as css prop values, please wrap it in a css template literal from '@emotion/react' like this: css`" + n.css + "`");
  var r = {};
  for (var i in n)
    fP.call(n, i) && (r[i] = n[i]);
  if (r[H6] = e, process.env.NODE_ENV !== "production" && n.css && (typeof n.css != "object" || typeof n.css.name != "string" || n.css.name.indexOf("-") === -1)) {
    var o = j0t(new Error().stack);
    o && (r[W6] = o);
  }
  return r;
}, G0t = function(e) {
  var n = e.cache, r = e.serialized, i = e.isStringTag;
  return lP(n, r, i), vie(function() {
    return cP(n, r, i);
  }), null;
}, bie = /* @__PURE__ */ pP(function(t, e, n) {
  var r = t.css;
  typeof r == "string" && e.registered[r] !== void 0 && (r = e.registered[r]);
  var i = t[H6], o = [r], a = "";
  typeof t.className == "string" ? a = fie(e.registered, o, t.className) : t.className != null && (a = t.className + " ");
  var s = Om(o, void 0, x.useContext(hE));
  if (process.env.NODE_ENV !== "production" && s.name.indexOf("-") === -1) {
    var u = t[W6];
    u && (s = Om([s, "label:" + u + ";"]));
  }
  a += e.key + "-" + s.name;
  var l = {};
  for (var c in t)
    fP.call(t, c) && c !== "css" && c !== H6 && (process.env.NODE_ENV === "production" || c !== W6) && (l[c] = t[c]);
  return l.ref = n, l.className = a, /* @__PURE__ */ x.createElement(x.Fragment, null, /* @__PURE__ */ x.createElement(G0t, {
    cache: e,
    serialized: s,
    isStringTag: typeof i == "string"
  }), /* @__PURE__ */ x.createElement(i, l));
});
process.env.NODE_ENV !== "production" && (bie.displayName = "EmotionCssPropInternal");
var U0t = bie, X0t = {
  name: "@emotion/react",
  version: "11.11.4",
  main: "dist/emotion-react.cjs.js",
  module: "dist/emotion-react.esm.js",
  browser: {
    "./dist/emotion-react.esm.js": "./dist/emotion-react.browser.esm.js"
  },
  exports: {
    ".": {
      module: {
        worker: "./dist/emotion-react.worker.esm.js",
        browser: "./dist/emotion-react.browser.esm.js",
        default: "./dist/emotion-react.esm.js"
      },
      import: "./dist/emotion-react.cjs.mjs",
      default: "./dist/emotion-react.cjs.js"
    },
    "./jsx-runtime": {
      module: {
        worker: "./jsx-runtime/dist/emotion-react-jsx-runtime.worker.esm.js",
        browser: "./jsx-runtime/dist/emotion-react-jsx-runtime.browser.esm.js",
        default: "./jsx-runtime/dist/emotion-react-jsx-runtime.esm.js"
      },
      import: "./jsx-runtime/dist/emotion-react-jsx-runtime.cjs.mjs",
      default: "./jsx-runtime/dist/emotion-react-jsx-runtime.cjs.js"
    },
    "./_isolated-hnrs": {
      module: {
        worker: "./_isolated-hnrs/dist/emotion-react-_isolated-hnrs.worker.esm.js",
        browser: "./_isolated-hnrs/dist/emotion-react-_isolated-hnrs.browser.esm.js",
        default: "./_isolated-hnrs/dist/emotion-react-_isolated-hnrs.esm.js"
      },
      import: "./_isolated-hnrs/dist/emotion-react-_isolated-hnrs.cjs.mjs",
      default: "./_isolated-hnrs/dist/emotion-react-_isolated-hnrs.cjs.js"
    },
    "./jsx-dev-runtime": {
      module: {
        worker: "./jsx-dev-runtime/dist/emotion-react-jsx-dev-runtime.worker.esm.js",
        browser: "./jsx-dev-runtime/dist/emotion-react-jsx-dev-runtime.browser.esm.js",
        default: "./jsx-dev-runtime/dist/emotion-react-jsx-dev-runtime.esm.js"
      },
      import: "./jsx-dev-runtime/dist/emotion-react-jsx-dev-runtime.cjs.mjs",
      default: "./jsx-dev-runtime/dist/emotion-react-jsx-dev-runtime.cjs.js"
    },
    "./package.json": "./package.json",
    "./types/css-prop": "./types/css-prop.d.ts",
    "./macro": {
      types: {
        import: "./macro.d.mts",
        default: "./macro.d.ts"
      },
      default: "./macro.js"
    }
  },
  types: "types/index.d.ts",
  files: [
    "src",
    "dist",
    "jsx-runtime",
    "jsx-dev-runtime",
    "_isolated-hnrs",
    "types/*.d.ts",
    "macro.*"
  ],
  sideEffects: !1,
  author: "Emotion Contributors",
  license: "MIT",
  scripts: {
    "test:typescript": "dtslint types"
  },
  dependencies: {
    "@babel/runtime": "^7.18.3",
    "@emotion/babel-plugin": "^11.11.0",
    "@emotion/cache": "^11.11.0",
    "@emotion/serialize": "^1.1.3",
    "@emotion/use-insertion-effect-with-fallbacks": "^1.0.1",
    "@emotion/utils": "^1.2.1",
    "@emotion/weak-memoize": "^0.3.1",
    "hoist-non-react-statics": "^3.3.1"
  },
  peerDependencies: {
    react: ">=16.8.0"
  },
  peerDependenciesMeta: {
    "@types/react": {
      optional: !0
    }
  },
  devDependencies: {
    "@definitelytyped/dtslint": "0.0.112",
    "@emotion/css": "11.11.2",
    "@emotion/css-prettifier": "1.1.3",
    "@emotion/server": "11.11.0",
    "@emotion/styled": "11.11.0",
    "html-tag-names": "^1.1.2",
    react: "16.14.0",
    "svg-tag-names": "^1.1.1",
    typescript: "^4.5.5"
  },
  repository: "https://github.com/emotion-js/emotion/tree/main/packages/react",
  publishConfig: {
    access: "public"
  },
  "umd:main": "dist/emotion-react.umd.min.js",
  preconstruct: {
    entrypoints: [
      "./index.js",
      "./jsx-runtime.js",
      "./jsx-dev-runtime.js",
      "./_isolated-hnrs.js"
    ],
    umdName: "emotionReact",
    exports: {
      envConditions: [
        "browser",
        "worker"
      ],
      extra: {
        "./types/css-prop": "./types/css-prop.d.ts",
        "./macro": {
          types: {
            import: "./macro.d.mts",
            default: "./macro.d.ts"
          },
          default: "./macro.js"
        }
      }
    }
  }
}, Xt = function(e, n) {
  var r = arguments;
  if (n == null || !fP.call(n, "css"))
    return x.createElement.apply(void 0, r);
  var i = r.length, o = new Array(i);
  o[0] = U0t, o[1] = z0t(e, n);
  for (var a = 2; a < i; a++)
    o[a] = r[a];
  return x.createElement.apply(null, o);
}, vH = !1, Y0t = /* @__PURE__ */ pP(function(t, e) {
  process.env.NODE_ENV !== "production" && !vH && // check for className as well since the user is
  // probably using the custom createElement which
  // means it will be turned into a className prop
  // $FlowFixMe I don't really want to add it to the type since it shouldn't be used
  (t.className || t.css) && (console.error("It looks like you're using the css prop on Global, did you mean to use the styles prop instead?"), vH = !0);
  var n = t.styles, r = Om([n], void 0, x.useContext(hE)), i = x.useRef();
  return gH(function() {
    var o = e.key + "-global", a = new e.sheet.constructor({
      key: o,
      nonce: e.sheet.nonce,
      container: e.sheet.container,
      speedy: e.sheet.isSpeedy
    }), s = !1, u = document.querySelector('style[data-emotion="' + o + " " + r.name + '"]');
    return e.sheet.tags.length && (a.before = e.sheet.tags[0]), u !== null && (s = !0, u.setAttribute("data-emotion", o), a.hydrate([u])), i.current = [a, s], function() {
      a.flush();
    };
  }, [e]), gH(function() {
    var o = i.current, a = o[0], s = o[1];
    if (s) {
      o[1] = !1;
      return;
    }
    if (r.next !== void 0 && cP(e, r.next, !0), a.tags.length) {
      var u = a.tags[a.tags.length - 1].nextElementSibling;
      a.before = u, a.flush();
    }
    e.insert("", r, a, !1);
  }, [e, r.name]), null;
});
process.env.NODE_ENV !== "production" && (Y0t.displayName = "EmotionGlobal");
function gP() {
  for (var t = arguments.length, e = new Array(t), n = 0; n < t; n++)
    e[n] = arguments[n];
  return Om(e);
}
var Z0t = function() {
  var e = gP.apply(void 0, arguments), n = "animation-" + e.name;
  return {
    name: n,
    styles: "@keyframes " + n + "{" + e.styles + "}",
    anim: 1,
    toString: function() {
      return "_EMO_" + this.name + "_" + this.styles + "_EMO_";
    }
  };
}, J0t = function t(e) {
  for (var n = e.length, r = 0, i = ""; r < n; r++) {
    var o = e[r];
    if (o != null) {
      var a = void 0;
      switch (typeof o) {
        case "boolean":
          break;
        case "object": {
          if (Array.isArray(o))
            a = t(o);
          else {
            process.env.NODE_ENV !== "production" && o.styles !== void 0 && o.name !== void 0 && console.error("You have passed styles created with `css` from `@emotion/react` package to the `cx`.\n`cx` is meant to compose class names (strings) so you should convert those styles to a class name by passing them to the `css` received from <ClassNames/> component."), a = "";
            for (var s in o)
              o[s] && s && (a && (a += " "), a += s);
          }
          break;
        }
        default:
          a = o;
      }
      a && (i && (i += " "), i += a);
    }
  }
  return i;
};
function K0t(t, e, n) {
  var r = [], i = fie(t, r, n);
  return r.length < 2 ? n : i + e(r);
}
var q0t = function(e) {
  var n = e.cache, r = e.serializedArr;
  return vie(function() {
    for (var i = 0; i < r.length; i++)
      cP(n, r[i], !1);
  }), null;
}, yie = /* @__PURE__ */ pP(function(t, e) {
  var n = !1, r = [], i = function() {
    if (n && process.env.NODE_ENV !== "production")
      throw new Error("css can only be used during render");
    for (var l = arguments.length, c = new Array(l), d = 0; d < l; d++)
      c[d] = arguments[d];
    var f = Om(c, e.registered);
    return r.push(f), lP(e, f, !1), e.key + "-" + f.name;
  }, o = function() {
    if (n && process.env.NODE_ENV !== "production")
      throw new Error("cx can only be used during render");
    for (var l = arguments.length, c = new Array(l), d = 0; d < l; d++)
      c[d] = arguments[d];
    return K0t(e.registered, i, J0t(c));
  }, a = {
    css: i,
    cx: o,
    theme: x.useContext(hE)
  }, s = t.children(a);
  return n = !0, /* @__PURE__ */ x.createElement(x.Fragment, null, /* @__PURE__ */ x.createElement(q0t, {
    cache: e,
    serializedArr: r
  }), s);
});
process.env.NODE_ENV !== "production" && (yie.displayName = "EmotionClassNames");
if (process.env.NODE_ENV !== "production") {
  var bH = !0, Q0t = typeof jest < "u" || typeof vi < "u";
  if (bH && !Q0t) {
    var yH = (
      // $FlowIgnore
      typeof globalThis < "u" ? globalThis : bH ? window : global
    ), xH = "__EMOTION_REACT_" + X0t.version.split(".")[0] + "__";
    yH[xH] && console.warn("You are loading @emotion/react when it is already loaded. Running multiple instances may cause problems. This can happen if multiple versions are used, or if multiple builds of the same version are used."), yH[xH] = !0;
  }
}
function emt(t, e) {
  return e || (e = t.slice(0)), Object.freeze(Object.defineProperties(t, {
    raw: {
      value: Object.freeze(e)
    }
  }));
}
function tmt(t, e, n) {
  return e in t ? Object.defineProperty(t, e, {
    value: n,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : t[e] = n, t;
}
function CH(t, e) {
  var n = Object.keys(t);
  if (Object.getOwnPropertySymbols) {
    var r = Object.getOwnPropertySymbols(t);
    e && (r = r.filter(function(i) {
      return Object.getOwnPropertyDescriptor(t, i).enumerable;
    })), n.push.apply(n, r);
  }
  return n;
}
function Jn(t) {
  for (var e = 1; e < arguments.length; e++) {
    var n = arguments[e] != null ? arguments[e] : {};
    e % 2 ? CH(Object(n), !0).forEach(function(r) {
      tmt(t, r, n[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(t, Object.getOwnPropertyDescriptors(n)) : CH(Object(n)).forEach(function(r) {
      Object.defineProperty(t, r, Object.getOwnPropertyDescriptor(n, r));
    });
  }
  return t;
}
function Q2(t) {
  return Q2 = Object.setPrototypeOf ? Object.getPrototypeOf : function(n) {
    return n.__proto__ || Object.getPrototypeOf(n);
  }, Q2(t);
}
function nmt() {
  if (typeof Reflect > "u" || !Reflect.construct || Reflect.construct.sham)
    return !1;
  if (typeof Proxy == "function")
    return !0;
  try {
    return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    })), !0;
  } catch {
    return !1;
  }
}
function rmt(t) {
  if (t === void 0)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return t;
}
function imt(t, e) {
  return e && (typeof e == "object" || typeof e == "function") ? e : rmt(t);
}
function mP(t) {
  var e = nmt();
  return function() {
    var r = Q2(t), i;
    if (e) {
      var o = Q2(this).constructor;
      i = Reflect.construct(r, arguments, o);
    } else
      i = r.apply(this, arguments);
    return imt(this, i);
  };
}
var omt = ["className", "clearValue", "cx", "getStyles", "getValue", "hasValue", "isMulti", "isRtl", "options", "selectOption", "selectProps", "setValue", "theme"], eC = function() {
};
function amt(t, e) {
  return e ? e[0] === "-" ? t + e : t + "__" + e : t;
}
function smt(t, e, n) {
  var r = [n];
  if (e && t)
    for (var i in e)
      e.hasOwnProperty(i) && e[i] && r.push("".concat(amt(t, i)));
  return r.filter(function(o) {
    return o;
  }).map(function(o) {
    return String(o).trim();
  }).join(" ");
}
var tC = function(e) {
  return bmt(e) ? e.filter(Boolean) : _t(e) === "object" && e !== null ? [e] : [];
}, xie = function(e) {
  e.className, e.clearValue, e.cx, e.getStyles, e.getValue, e.hasValue, e.isMulti, e.isRtl, e.options, e.selectOption, e.selectProps, e.setValue, e.theme;
  var n = Gt(e, omt);
  return Jn({}, n);
};
function umt(t, e, n) {
  if (n) {
    var r = n(t, e);
    if (typeof r == "string")
      return r;
  }
  return t;
}
function pE(t) {
  return [document.documentElement, document.body, window].indexOf(t) > -1;
}
function lmt(t) {
  return pE(t) ? window.innerHeight : t.clientHeight;
}
function Cie(t) {
  return pE(t) ? window.pageYOffset : t.scrollTop;
}
function nC(t, e) {
  if (pE(t)) {
    window.scrollTo(0, e);
    return;
  }
  t.scrollTop = e;
}
function cmt(t) {
  var e = getComputedStyle(t), n = e.position === "absolute", r = /(auto|scroll)/;
  if (e.position === "fixed")
    return document.documentElement;
  for (var i = t; i = i.parentElement; )
    if (e = getComputedStyle(i), !(n && e.position === "static") && r.test(e.overflow + e.overflowY + e.overflowX))
      return i;
  return document.documentElement;
}
function dmt(t, e, n, r) {
  return n * ((t = t / r - 1) * t * t + 1) + e;
}
function oy(t, e) {
  var n = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 200, r = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : eC, i = Cie(t), o = e - i, a = 10, s = 0;
  function u() {
    s += a;
    var l = dmt(s, i, o, n);
    nC(t, l), s < n ? window.requestAnimationFrame(u) : r(t);
  }
  u();
}
function fmt(t, e) {
  var n = t.getBoundingClientRect(), r = e.getBoundingClientRect(), i = e.offsetHeight / 3;
  r.bottom + i > n.bottom ? nC(t, Math.min(e.offsetTop + e.clientHeight - t.offsetHeight + i, t.scrollHeight)) : r.top - i < n.top && nC(t, Math.max(e.offsetTop - i, 0));
}
function hmt(t) {
  var e = t.getBoundingClientRect();
  return {
    bottom: e.bottom,
    height: e.height,
    left: e.left,
    right: e.right,
    top: e.top,
    width: e.width
  };
}
function wH() {
  try {
    return document.createEvent("TouchEvent"), !0;
  } catch {
    return !1;
  }
}
function pmt() {
  try {
    return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
  } catch {
    return !1;
  }
}
var wie = !1, gmt = {
  get passive() {
    return wie = !0;
  }
}, ay = typeof window < "u" ? window : {};
ay.addEventListener && ay.removeEventListener && (ay.addEventListener("p", eC, gmt), ay.removeEventListener("p", eC, !1));
var mmt = wie;
function vmt(t) {
  return t != null;
}
function bmt(t) {
  return Array.isArray(t);
}
function u0(t, e, n) {
  return t ? e : n;
}
var ymt = function(e) {
  for (var n = arguments.length, r = new Array(n > 1 ? n - 1 : 0), i = 1; i < n; i++)
    r[i - 1] = arguments[i];
  var o = Object.entries(e).filter(function(a) {
    var s = be(a, 1), u = s[0];
    return !r.includes(u);
  });
  return o.reduce(function(a, s) {
    var u = be(s, 2), l = u[0], c = u[1];
    return a[l] = c, a;
  }, {});
};
function xmt(t) {
  var e = t.maxHeight, n = t.menuEl, r = t.minHeight, i = t.placement, o = t.shouldScroll, a = t.isFixedPosition, s = t.theme, u = s.spacing, l = cmt(n), c = {
    placement: "bottom",
    maxHeight: e
  };
  if (!n || !n.offsetParent)
    return c;
  var d = l.getBoundingClientRect(), f = d.height, h = n.getBoundingClientRect(), p = h.bottom, v = h.height, m = h.top, b = n.offsetParent.getBoundingClientRect(), y = b.top, w = a ? window.innerHeight : lmt(l), S = Cie(l), E = parseInt(getComputedStyle(n).marginBottom, 10), I = parseInt(getComputedStyle(n).marginTop, 10), _ = y - I, A = w - m, P = _ + S, N = f - S - m, k = p - w + S + E, D = S + m - I, R = 160;
  switch (i) {
    case "auto":
    case "bottom":
      if (A >= v)
        return {
          placement: "bottom",
          maxHeight: e
        };
      if (N >= v && !a)
        return o && oy(l, k, R), {
          placement: "bottom",
          maxHeight: e
        };
      if (!a && N >= r || a && A >= r) {
        o && oy(l, k, R);
        var V = a ? A - E : N - E;
        return {
          placement: "bottom",
          maxHeight: V
        };
      }
      if (i === "auto" || a) {
        var $ = e, F = a ? _ : P;
        return F >= r && ($ = Math.min(F - E - u.controlHeight, e)), {
          placement: "top",
          maxHeight: $
        };
      }
      if (i === "bottom")
        return o && nC(l, k), {
          placement: "bottom",
          maxHeight: e
        };
      break;
    case "top":
      if (_ >= v)
        return {
          placement: "top",
          maxHeight: e
        };
      if (P >= v && !a)
        return o && oy(l, D, R), {
          placement: "top",
          maxHeight: e
        };
      if (!a && P >= r || a && _ >= r) {
        var M = e;
        return (!a && P >= r || a && _ >= r) && (M = a ? _ - I : P - I), o && oy(l, D, R), {
          placement: "top",
          maxHeight: M
        };
      }
      return {
        placement: "bottom",
        maxHeight: e
      };
    default:
      throw new Error('Invalid placement provided "'.concat(i, '".'));
  }
  return c;
}
function Cmt(t) {
  var e = {
    bottom: "top",
    top: "bottom"
  };
  return t ? e[t] : "bottom";
}
var j6 = function(e) {
  return e === "auto" ? "bottom" : e;
}, wmt = function(e) {
  var n, r = e.placement, i = e.theme, o = i.borderRadius, a = i.spacing, s = i.colors;
  return n = {
    label: "menu"
  }, z(n, Cmt(r), "100%"), z(n, "backgroundColor", s.neutral0), z(n, "borderRadius", o), z(n, "boxShadow", "0 0 0 1px hsla(0, 0%, 0%, 0.1), 0 4px 11px hsla(0, 0%, 0%, 0.1)"), z(n, "marginBottom", a.menuGutter), z(n, "marginTop", a.menuGutter), z(n, "position", "absolute"), z(n, "width", "100%"), z(n, "zIndex", 1), n;
}, Eie = /* @__PURE__ */ oi({
  getPortalPlacement: null
}), Sie = /* @__PURE__ */ function(t) {
  Pr(n, t);
  var e = mP(n);
  function n() {
    var r;
    zn(this, n);
    for (var i = arguments.length, o = new Array(i), a = 0; a < i; a++)
      o[a] = arguments[a];
    return r = e.call.apply(e, [this].concat(o)), r.state = {
      maxHeight: r.props.maxMenuHeight,
      placement: null
    }, r.context = void 0, r.getPlacement = function(s) {
      var u = r.props, l = u.minMenuHeight, c = u.maxMenuHeight, d = u.menuPlacement, f = u.menuPosition, h = u.menuShouldScrollIntoView, p = u.theme;
      if (s) {
        var v = f === "fixed", m = h && !v, b = xmt({
          maxHeight: c,
          menuEl: s,
          minHeight: l,
          placement: d,
          shouldScroll: m,
          isFixedPosition: v,
          theme: p
        }), y = r.context.getPortalPlacement;
        y && y(b), r.setState(b);
      }
    }, r.getUpdatedProps = function() {
      var s = r.props.menuPlacement, u = r.state.placement || j6(s);
      return Jn(Jn({}, r.props), {}, {
        placement: u,
        maxHeight: r.state.maxHeight
      });
    }, r;
  }
  return Gn(n, [{
    key: "render",
    value: function() {
      var i = this.props.children;
      return i({
        ref: this.getPlacement,
        placerProps: this.getUpdatedProps()
      });
    }
  }]), n;
}(Do);
Sie.contextType = Eie;
var Emt = function(e) {
  var n = e.children, r = e.className, i = e.cx, o = e.getStyles, a = e.innerRef, s = e.innerProps;
  return Xt("div", G({
    css: o("menu", e),
    className: i({
      menu: !0
    }, r),
    ref: a
  }, s), n);
}, Smt = function(e) {
  var n = e.maxHeight, r = e.theme.spacing.baseUnit;
  return {
    maxHeight: n,
    overflowY: "auto",
    paddingBottom: r,
    paddingTop: r,
    position: "relative",
    // required for offset[Height, Top] > keyboard scroll
    WebkitOverflowScrolling: "touch"
  };
}, Imt = function(e) {
  var n = e.children, r = e.className, i = e.cx, o = e.getStyles, a = e.innerProps, s = e.innerRef, u = e.isMulti;
  return Xt("div", G({
    css: o("menuList", e),
    className: i({
      "menu-list": !0,
      "menu-list--is-multi": u
    }, r),
    ref: s
  }, a), n);
}, Iie = function(e) {
  var n = e.theme, r = n.spacing.baseUnit, i = n.colors;
  return {
    color: i.neutral40,
    padding: "".concat(r * 2, "px ").concat(r * 3, "px"),
    textAlign: "center"
  };
}, _mt = Iie, Amt = Iie, _ie = function(e) {
  var n = e.children, r = e.className, i = e.cx, o = e.getStyles, a = e.innerProps;
  return Xt("div", G({
    css: o("noOptionsMessage", e),
    className: i({
      "menu-notice": !0,
      "menu-notice--no-options": !0
    }, r)
  }, a), n);
};
_ie.defaultProps = {
  children: "No options"
};
var Aie = function(e) {
  var n = e.children, r = e.className, i = e.cx, o = e.getStyles, a = e.innerProps;
  return Xt("div", G({
    css: o("loadingMessage", e),
    className: i({
      "menu-notice": !0,
      "menu-notice--loading": !0
    }, r)
  }, a), n);
};
Aie.defaultProps = {
  children: "Loading..."
};
var Tmt = function(e) {
  var n = e.rect, r = e.offset, i = e.position;
  return {
    left: n.left,
    position: i,
    top: r,
    width: n.width,
    zIndex: 1
  };
}, Omt = /* @__PURE__ */ function(t) {
  Pr(n, t);
  var e = mP(n);
  function n() {
    var r;
    zn(this, n);
    for (var i = arguments.length, o = new Array(i), a = 0; a < i; a++)
      o[a] = arguments[a];
    return r = e.call.apply(e, [this].concat(o)), r.state = {
      placement: null
    }, r.getPortalPlacement = function(s) {
      var u = s.placement, l = j6(r.props.menuPlacement);
      u !== l && r.setState({
        placement: u
      });
    }, r;
  }
  return Gn(n, [{
    key: "render",
    value: function() {
      var i = this.props, o = i.appendTo, a = i.children, s = i.className, u = i.controlElement, l = i.cx, c = i.innerProps, d = i.menuPlacement, f = i.menuPosition, h = i.getStyles, p = f === "fixed";
      if (!o && !p || !u)
        return null;
      var v = this.state.placement || j6(d), m = hmt(u), b = p ? 0 : window.pageYOffset, y = m[v] + b, w = {
        offset: y,
        position: f,
        rect: m
      }, S = Xt("div", G({
        css: h("menuPortal", w),
        className: l({
          "menu-portal": !0
        }, s)
      }, c), a);
      return Xt(Eie.Provider, {
        value: {
          getPortalPlacement: this.getPortalPlacement
        }
      }, o ? /* @__PURE__ */ km(S, o) : S);
    }
  }]), n;
}(Do), Pmt = function(e) {
  var n = e.isDisabled, r = e.isRtl;
  return {
    label: "container",
    direction: r ? "rtl" : void 0,
    pointerEvents: n ? "none" : void 0,
    // cancel mouse events when disabled
    position: "relative"
  };
}, Nmt = function(e) {
  var n = e.children, r = e.className, i = e.cx, o = e.getStyles, a = e.innerProps, s = e.isDisabled, u = e.isRtl;
  return Xt("div", G({
    css: o("container", e),
    className: i({
      "--is-disabled": s,
      "--is-rtl": u
    }, r)
  }, a), n);
}, kmt = function(e) {
  var n = e.theme.spacing, r = e.isMulti, i = e.hasValue, o = e.selectProps.controlShouldRenderValue;
  return {
    alignItems: "center",
    display: r && i && o ? "flex" : "grid",
    flex: 1,
    flexWrap: "wrap",
    padding: "".concat(n.baseUnit / 2, "px ").concat(n.baseUnit * 2, "px"),
    WebkitOverflowScrolling: "touch",
    position: "relative",
    overflow: "hidden"
  };
}, Rmt = function(e) {
  var n = e.children, r = e.className, i = e.cx, o = e.innerProps, a = e.isMulti, s = e.getStyles, u = e.hasValue;
  return Xt("div", G({
    css: s("valueContainer", e),
    className: i({
      "value-container": !0,
      "value-container--is-multi": a,
      "value-container--has-value": u
    }, r)
  }, o), n);
}, $mt = function() {
  return {
    alignItems: "center",
    alignSelf: "stretch",
    display: "flex",
    flexShrink: 0
  };
}, Dmt = function(e) {
  var n = e.children, r = e.className, i = e.cx, o = e.innerProps, a = e.getStyles;
  return Xt("div", G({
    css: a("indicatorsContainer", e),
    className: i({
      indicators: !0
    }, r)
  }, o), n);
}, EH, Mmt = ["size"];
function Fmt() {
  return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
var Lmt = process.env.NODE_ENV === "production" ? {
  name: "8mmkcg",
  styles: "display:inline-block;fill:currentColor;line-height:1;stroke:currentColor;stroke-width:0"
} : {
  name: "tj5bde-Svg",
  styles: "display:inline-block;fill:currentColor;line-height:1;stroke:currentColor;stroke-width:0;label:Svg;",
  map: "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */",
  toString: Fmt
}, Tie = function(e) {
  var n = e.size, r = Gt(e, Mmt);
  return Xt("svg", G({
    height: n,
    width: n,
    viewBox: "0 0 20 20",
    "aria-hidden": "true",
    focusable: "false",
    css: Lmt
  }, r));
}, vP = function(e) {
  return Xt(Tie, G({
    size: 20
  }, e), Xt("path", {
    d: "M14.348 14.849c-0.469 0.469-1.229 0.469-1.697 0l-2.651-3.030-2.651 3.029c-0.469 0.469-1.229 0.469-1.697 0-0.469-0.469-0.469-1.229 0-1.697l2.758-3.15-2.759-3.152c-0.469-0.469-0.469-1.228 0-1.697s1.228-0.469 1.697 0l2.652 3.031 2.651-3.031c0.469-0.469 1.228-0.469 1.697 0s0.469 1.229 0 1.697l-2.758 3.152 2.758 3.15c0.469 0.469 0.469 1.229 0 1.698z"
  }));
}, Oie = function(e) {
  return Xt(Tie, G({
    size: 20
  }, e), Xt("path", {
    d: "M4.516 7.548c0.436-0.446 1.043-0.481 1.576 0l3.908 3.747 3.908-3.747c0.533-0.481 1.141-0.446 1.574 0 0.436 0.445 0.408 1.197 0 1.615-0.406 0.418-4.695 4.502-4.695 4.502-0.217 0.223-0.502 0.335-0.787 0.335s-0.57-0.112-0.789-0.335c0 0-4.287-4.084-4.695-4.502s-0.436-1.17 0-1.615z"
  }));
}, Pie = function(e) {
  var n = e.isFocused, r = e.theme, i = r.spacing.baseUnit, o = r.colors;
  return {
    label: "indicatorContainer",
    color: n ? o.neutral60 : o.neutral20,
    display: "flex",
    padding: i * 2,
    transition: "color 150ms",
    ":hover": {
      color: n ? o.neutral80 : o.neutral40
    }
  };
}, Vmt = Pie, Bmt = function(e) {
  var n = e.children, r = e.className, i = e.cx, o = e.getStyles, a = e.innerProps;
  return Xt("div", G({
    css: o("dropdownIndicator", e),
    className: i({
      indicator: !0,
      "dropdown-indicator": !0
    }, r)
  }, a), n || Xt(Oie, null));
}, Hmt = Pie, Wmt = function(e) {
  var n = e.children, r = e.className, i = e.cx, o = e.getStyles, a = e.innerProps;
  return Xt("div", G({
    css: o("clearIndicator", e),
    className: i({
      indicator: !0,
      "clear-indicator": !0
    }, r)
  }, a), n || Xt(vP, null));
}, jmt = function(e) {
  var n = e.isDisabled, r = e.theme, i = r.spacing.baseUnit, o = r.colors;
  return {
    label: "indicatorSeparator",
    alignSelf: "stretch",
    backgroundColor: n ? o.neutral10 : o.neutral20,
    marginBottom: i * 2,
    marginTop: i * 2,
    width: 1
  };
}, zmt = function(e) {
  var n = e.className, r = e.cx, i = e.getStyles, o = e.innerProps;
  return Xt("span", G({}, o, {
    css: i("indicatorSeparator", e),
    className: r({
      "indicator-separator": !0
    }, n)
  }));
}, Gmt = Z0t(EH || (EH = emt([`
  0%, 80%, 100% { opacity: 0; }
  40% { opacity: 1; }
`]))), Umt = function(e) {
  var n = e.isFocused, r = e.size, i = e.theme, o = i.colors, a = i.spacing.baseUnit;
  return {
    label: "loadingIndicator",
    color: n ? o.neutral60 : o.neutral20,
    display: "flex",
    padding: a * 2,
    transition: "color 150ms",
    alignSelf: "center",
    fontSize: r,
    lineHeight: 1,
    marginRight: r,
    textAlign: "center",
    verticalAlign: "middle"
  };
}, eI = function(e) {
  var n = e.delay, r = e.offset;
  return Xt("span", {
    css: /* @__PURE__ */ gP({
      animation: "".concat(Gmt, " 1s ease-in-out ").concat(n, "ms infinite;"),
      backgroundColor: "currentColor",
      borderRadius: "1em",
      display: "inline-block",
      marginLeft: r ? "1em" : void 0,
      height: "1em",
      verticalAlign: "top",
      width: "1em"
    }, process.env.NODE_ENV === "production" ? "" : ";label:LoadingDot;", process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */")
  });
}, Nie = function(e) {
  var n = e.className, r = e.cx, i = e.getStyles, o = e.innerProps, a = e.isRtl;
  return Xt("div", G({
    css: i("loadingIndicator", e),
    className: r({
      indicator: !0,
      "loading-indicator": !0
    }, n)
  }, o), Xt(eI, {
    delay: 0,
    offset: a
  }), Xt(eI, {
    delay: 160,
    offset: !0
  }), Xt(eI, {
    delay: 320,
    offset: !a
  }));
};
Nie.defaultProps = {
  size: 4
};
var Xmt = function(e) {
  var n = e.isDisabled, r = e.isFocused, i = e.theme, o = i.colors, a = i.borderRadius, s = i.spacing;
  return {
    label: "control",
    alignItems: "center",
    backgroundColor: n ? o.neutral5 : o.neutral0,
    borderColor: n ? o.neutral10 : r ? o.primary : o.neutral20,
    borderRadius: a,
    borderStyle: "solid",
    borderWidth: 1,
    boxShadow: r ? "0 0 0 1px ".concat(o.primary) : void 0,
    cursor: "default",
    display: "flex",
    flexWrap: "wrap",
    justifyContent: "space-between",
    minHeight: s.controlHeight,
    outline: "0 !important",
    position: "relative",
    transition: "all 100ms",
    "&:hover": {
      borderColor: r ? o.primary : o.neutral30
    }
  };
}, Ymt = function(e) {
  var n = e.children, r = e.cx, i = e.getStyles, o = e.className, a = e.isDisabled, s = e.isFocused, u = e.innerRef, l = e.innerProps, c = e.menuIsOpen;
  return Xt("div", G({
    ref: u,
    css: i("control", e),
    className: r({
      control: !0,
      "control--is-disabled": a,
      "control--is-focused": s,
      "control--menu-is-open": c
    }, o)
  }, l), n);
}, Zmt = ["data"], Jmt = function(e) {
  var n = e.theme.spacing;
  return {
    paddingBottom: n.baseUnit * 2,
    paddingTop: n.baseUnit * 2
  };
}, Kmt = function(e) {
  var n = e.children, r = e.className, i = e.cx, o = e.getStyles, a = e.Heading, s = e.headingProps, u = e.innerProps, l = e.label, c = e.theme, d = e.selectProps;
  return Xt("div", G({
    css: o("group", e),
    className: i({
      group: !0
    }, r)
  }, u), Xt(a, G({}, s, {
    selectProps: d,
    theme: c,
    getStyles: o,
    cx: i
  }), l), Xt("div", null, n));
}, qmt = function(e) {
  var n = e.theme.spacing;
  return {
    label: "group",
    color: "#999",
    cursor: "default",
    display: "block",
    fontSize: "75%",
    fontWeight: 500,
    marginBottom: "0.25em",
    paddingLeft: n.baseUnit * 3,
    paddingRight: n.baseUnit * 3,
    textTransform: "uppercase"
  };
}, Qmt = function(e) {
  var n = e.getStyles, r = e.cx, i = e.className, o = xie(e);
  o.data;
  var a = Gt(o, Zmt);
  return Xt("div", G({
    css: n("groupHeading", e),
    className: r({
      "group-heading": !0
    }, i)
  }, a));
}, evt = ["innerRef", "isDisabled", "isHidden", "inputClassName"], tvt = function(e) {
  var n = e.isDisabled, r = e.value, i = e.theme, o = i.spacing, a = i.colors;
  return Jn({
    margin: o.baseUnit / 2,
    paddingBottom: o.baseUnit / 2,
    paddingTop: o.baseUnit / 2,
    visibility: n ? "hidden" : "visible",
    color: a.neutral80,
    // force css to recompute when value change due to @emotion bug.
    // We can remove it whenever the bug is fixed.
    transform: r ? "translateZ(0)" : ""
  }, nvt);
}, kie = {
  gridArea: "1 / 2",
  font: "inherit",
  minWidth: "2px",
  border: 0,
  margin: 0,
  outline: 0,
  padding: 0
}, nvt = {
  flex: "1 1 auto",
  display: "inline-grid",
  gridArea: "1 / 1 / 2 / 3",
  gridTemplateColumns: "0 min-content",
  "&:after": Jn({
    content: 'attr(data-value) " "',
    visibility: "hidden",
    whiteSpace: "pre"
  }, kie)
}, rvt = function(e) {
  return Jn({
    label: "input",
    color: "inherit",
    background: 0,
    opacity: e ? 0 : 1,
    width: "100%"
  }, kie);
}, ivt = function(e) {
  var n = e.className, r = e.cx, i = e.getStyles, o = e.value, a = xie(e), s = a.innerRef, u = a.isDisabled, l = a.isHidden, c = a.inputClassName, d = Gt(a, evt);
  return Xt("div", {
    className: r({
      "input-container": !0
    }, n),
    css: i("input", e),
    "data-value": o || ""
  }, Xt("input", G({
    className: r({
      input: !0
    }, c),
    ref: s,
    style: rvt(l),
    disabled: u
  }, d)));
}, ovt = function(e) {
  var n = e.theme, r = n.spacing, i = n.borderRadius, o = n.colors;
  return {
    label: "multiValue",
    backgroundColor: o.neutral10,
    borderRadius: i / 2,
    display: "flex",
    margin: r.baseUnit / 2,
    minWidth: 0
    // resolves flex/text-overflow bug
  };
}, avt = function(e) {
  var n = e.theme, r = n.borderRadius, i = n.colors, o = e.cropWithEllipsis;
  return {
    borderRadius: r / 2,
    color: i.neutral80,
    fontSize: "85%",
    overflow: "hidden",
    padding: 3,
    paddingLeft: 6,
    textOverflow: o || o === void 0 ? "ellipsis" : void 0,
    whiteSpace: "nowrap"
  };
}, svt = function(e) {
  var n = e.theme, r = n.spacing, i = n.borderRadius, o = n.colors, a = e.isFocused;
  return {
    alignItems: "center",
    borderRadius: i / 2,
    backgroundColor: a ? o.dangerLight : void 0,
    display: "flex",
    paddingLeft: r.baseUnit,
    paddingRight: r.baseUnit,
    ":hover": {
      backgroundColor: o.dangerLight,
      color: o.danger
    }
  };
}, Rie = function(e) {
  var n = e.children, r = e.innerProps;
  return Xt("div", r, n);
}, uvt = Rie, lvt = Rie;
function cvt(t) {
  var e = t.children, n = t.innerProps;
  return Xt("div", G({
    role: "button"
  }, n), e || Xt(vP, {
    size: 14
  }));
}
var dvt = function(e) {
  var n = e.children, r = e.className, i = e.components, o = e.cx, a = e.data, s = e.getStyles, u = e.innerProps, l = e.isDisabled, c = e.removeProps, d = e.selectProps, f = i.Container, h = i.Label, p = i.Remove;
  return Xt(yie, null, function(v) {
    var m = v.css, b = v.cx;
    return Xt(f, {
      data: a,
      innerProps: Jn({
        className: b(m(s("multiValue", e)), o({
          "multi-value": !0,
          "multi-value--is-disabled": l
        }, r))
      }, u),
      selectProps: d
    }, Xt(h, {
      data: a,
      innerProps: {
        className: b(m(s("multiValueLabel", e)), o({
          "multi-value__label": !0
        }, r))
      },
      selectProps: d
    }, n), Xt(p, {
      data: a,
      innerProps: Jn({
        className: b(m(s("multiValueRemove", e)), o({
          "multi-value__remove": !0
        }, r)),
        "aria-label": "Remove ".concat(n || "option")
      }, c),
      selectProps: d
    }));
  });
}, fvt = function(e) {
  var n = e.isDisabled, r = e.isFocused, i = e.isSelected, o = e.theme, a = o.spacing, s = o.colors;
  return {
    label: "option",
    backgroundColor: i ? s.primary : r ? s.primary25 : "transparent",
    color: n ? s.neutral20 : i ? s.neutral0 : "inherit",
    cursor: "default",
    display: "block",
    fontSize: "inherit",
    padding: "".concat(a.baseUnit * 2, "px ").concat(a.baseUnit * 3, "px"),
    width: "100%",
    userSelect: "none",
    WebkitTapHighlightColor: "rgba(0, 0, 0, 0)",
    // provide some affordance on touch devices
    ":active": {
      backgroundColor: n ? void 0 : i ? s.primary : s.primary50
    }
  };
}, hvt = function(e) {
  var n = e.children, r = e.className, i = e.cx, o = e.getStyles, a = e.isDisabled, s = e.isFocused, u = e.isSelected, l = e.innerRef, c = e.innerProps;
  return Xt("div", G({
    css: o("option", e),
    className: i({
      option: !0,
      "option--is-disabled": a,
      "option--is-focused": s,
      "option--is-selected": u
    }, r),
    ref: l,
    "aria-disabled": a
  }, c), n);
}, pvt = function(e) {
  var n = e.theme, r = n.spacing, i = n.colors;
  return {
    label: "placeholder",
    color: i.neutral50,
    gridArea: "1 / 1 / 2 / 3",
    marginLeft: r.baseUnit / 2,
    marginRight: r.baseUnit / 2
  };
}, gvt = function(e) {
  var n = e.children, r = e.className, i = e.cx, o = e.getStyles, a = e.innerProps;
  return Xt("div", G({
    css: o("placeholder", e),
    className: i({
      placeholder: !0
    }, r)
  }, a), n);
}, mvt = function(e) {
  var n = e.isDisabled, r = e.theme, i = r.spacing, o = r.colors;
  return {
    label: "singleValue",
    color: n ? o.neutral40 : o.neutral80,
    gridArea: "1 / 1 / 2 / 3",
    marginLeft: i.baseUnit / 2,
    marginRight: i.baseUnit / 2,
    maxWidth: "100%",
    overflow: "hidden",
    textOverflow: "ellipsis",
    whiteSpace: "nowrap"
  };
}, vvt = function(e) {
  var n = e.children, r = e.className, i = e.cx, o = e.getStyles, a = e.isDisabled, s = e.innerProps;
  return Xt("div", G({
    css: o("singleValue", e),
    className: i({
      "single-value": !0,
      "single-value--is-disabled": a
    }, r)
  }, s), n);
}, bvt = {
  ClearIndicator: Wmt,
  Control: Ymt,
  DropdownIndicator: Bmt,
  DownChevron: Oie,
  CrossIcon: vP,
  Group: Kmt,
  GroupHeading: Qmt,
  IndicatorsContainer: Dmt,
  IndicatorSeparator: zmt,
  Input: ivt,
  LoadingIndicator: Nie,
  Menu: Emt,
  MenuList: Imt,
  MenuPortal: Omt,
  LoadingMessage: Aie,
  NoOptionsMessage: _ie,
  MultiValue: dvt,
  MultiValueContainer: uvt,
  MultiValueLabel: lvt,
  MultiValueRemove: cvt,
  Option: hvt,
  Placeholder: gvt,
  SelectContainer: Nmt,
  SingleValue: vvt,
  ValueContainer: Rmt
}, yvt = function(e) {
  return Jn(Jn({}, bvt), e.components);
}, SH = Number.isNaN || function(e) {
  return typeof e == "number" && e !== e;
};
function xvt(t, e) {
  return !!(t === e || SH(t) && SH(e));
}
function Cvt(t, e) {
  if (t.length !== e.length)
    return !1;
  for (var n = 0; n < t.length; n++)
    if (!xvt(t[n], e[n]))
      return !1;
  return !0;
}
function wvt(t, e) {
  e === void 0 && (e = Cvt);
  var n, r = [], i, o = !1;
  function a() {
    for (var s = [], u = 0; u < arguments.length; u++)
      s[u] = arguments[u];
    return o && n === this && e(s, r) || (i = t.apply(this, s), o = !0, n = this, r = s), i;
  }
  return a;
}
function Evt() {
  return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
var Svt = process.env.NODE_ENV === "production" ? {
  name: "7pg0cj-a11yText",
  styles: "label:a11yText;z-index:9999;border:0;clip:rect(1px, 1px, 1px, 1px);height:1px;width:1px;position:absolute;overflow:hidden;padding:0;white-space:nowrap"
} : {
  name: "1f43avz-a11yText-A11yText",
  styles: "label:a11yText;z-index:9999;border:0;clip:rect(1px, 1px, 1px, 1px);height:1px;width:1px;position:absolute;overflow:hidden;padding:0;white-space:nowrap;label:A11yText;",
  map: "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIkExMXlUZXh0LnRzeCJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFNSSIsImZpbGUiOiJBMTF5VGV4dC50c3giLCJzb3VyY2VzQ29udGVudCI6WyIvKiogQGpzeCBqc3ggKi9cbmltcG9ydCB7IGpzeCB9IGZyb20gJ0BlbW90aW9uL3JlYWN0JztcblxuLy8gQXNzaXN0aXZlIHRleHQgdG8gZGVzY3JpYmUgdmlzdWFsIGVsZW1lbnRzLiBIaWRkZW4gZm9yIHNpZ2h0ZWQgdXNlcnMuXG5jb25zdCBBMTF5VGV4dCA9IChwcm9wczogSlNYLkludHJpbnNpY0VsZW1lbnRzWydzcGFuJ10pID0+IChcbiAgPHNwYW5cbiAgICBjc3M9e3tcbiAgICAgIGxhYmVsOiAnYTExeVRleHQnLFxuICAgICAgekluZGV4OiA5OTk5LFxuICAgICAgYm9yZGVyOiAwLFxuICAgICAgY2xpcDogJ3JlY3QoMXB4LCAxcHgsIDFweCwgMXB4KScsXG4gICAgICBoZWlnaHQ6IDEsXG4gICAgICB3aWR0aDogMSxcbiAgICAgIHBvc2l0aW9uOiAnYWJzb2x1dGUnLFxuICAgICAgb3ZlcmZsb3c6ICdoaWRkZW4nLFxuICAgICAgcGFkZGluZzogMCxcbiAgICAgIHdoaXRlU3BhY2U6ICdub3dyYXAnLFxuICAgIH19XG4gICAgey4uLnByb3BzfVxuICAvPlxuKTtcblxuZXhwb3J0IGRlZmF1bHQgQTExeVRleHQ7XG4iXX0= */",
  toString: Evt
}, IH = function(e) {
  return Xt("span", G({
    css: Svt
  }, e));
}, Ivt = {
  guidance: function(e) {
    var n = e.isSearchable, r = e.isMulti, i = e.isDisabled, o = e.tabSelectsValue, a = e.context;
    switch (a) {
      case "menu":
        return "Use Up and Down to choose options".concat(i ? "" : ", press Enter to select the currently focused option", ", press Escape to exit the menu").concat(o ? ", press Tab to select the option and exit the menu" : "", ".");
      case "input":
        return "".concat(e["aria-label"] || "Select", " is focused ").concat(n ? ",type to refine list" : "", ", press Down to open the menu, ").concat(r ? " press left to focus selected values" : "");
      case "value":
        return "Use left and right to toggle between focused values, press Backspace to remove the currently focused value";
      default:
        return "";
    }
  },
  onChange: function(e) {
    var n = e.action, r = e.label, i = r === void 0 ? "" : r, o = e.labels, a = e.isDisabled;
    switch (n) {
      case "deselect-option":
      case "pop-value":
      case "remove-value":
        return "option ".concat(i, ", deselected.");
      case "clear":
        return "All selected options have been cleared.";
      case "initial-input-focus":
        return "option".concat(o.length > 1 ? "s" : "", " ").concat(o.join(","), ", selected.");
      case "select-option":
        return a ? "option ".concat(i, " is disabled. Select another option.") : "option ".concat(i, ", selected.");
      default:
        return "";
    }
  },
  onFocus: function(e) {
    var n = e.context, r = e.focused, i = e.options, o = e.label, a = o === void 0 ? "" : o, s = e.selectValue, u = e.isDisabled, l = e.isSelected, c = function(p, v) {
      return p && p.length ? "".concat(p.indexOf(v) + 1, " of ").concat(p.length) : "";
    };
    if (n === "value" && s)
      return "value ".concat(a, " focused, ").concat(c(s, r), ".");
    if (n === "menu") {
      var d = u ? " disabled" : "", f = "".concat(l ? "selected" : "focused").concat(d);
      return "option ".concat(a, " ").concat(f, ", ").concat(c(i, r), ".");
    }
    return "";
  },
  onFilter: function(e) {
    var n = e.inputValue, r = e.resultsMessage;
    return "".concat(r).concat(n ? " for search term " + n : "", ".");
  }
}, _vt = function(e) {
  var n = e.ariaSelection, r = e.focusedOption, i = e.focusedValue, o = e.focusableOptions, a = e.isFocused, s = e.selectValue, u = e.selectProps, l = e.id, c = u.ariaLiveMessages, d = u.getOptionLabel, f = u.inputValue, h = u.isMulti, p = u.isOptionDisabled, v = u.isSearchable, m = u.menuIsOpen, b = u.options, y = u.screenReaderStatus, w = u.tabSelectsValue, S = u["aria-label"], E = u["aria-live"], I = Rn(function() {
    return Jn(Jn({}, Ivt), c || {});
  }, [c]), _ = Rn(function() {
    var V = "";
    if (n && I.onChange) {
      var $ = n.option, F = n.options, M = n.removedValue, B = n.removedValues, X = n.value, L = function(Z) {
        return Array.isArray(Z) ? null : Z;
      }, j = M || $ || L(X), K = j ? d(j) : "", W = F || B || void 0, Y = W ? W.map(d) : [], U = Jn({
        // multiSelected items are usually items that have already been selected
        // or set by the user as a default value so we assume they are not disabled
        isDisabled: j && p(j, s),
        label: K,
        labels: Y
      }, n);
      V = I.onChange(U);
    }
    return V;
  }, [n, I, p, s, d]), A = Rn(function() {
    var V = "", $ = r || i, F = !!(r && s && s.includes(r));
    if ($ && I.onFocus) {
      var M = {
        focused: $,
        label: d($),
        isDisabled: p($, s),
        isSelected: F,
        options: b,
        context: $ === r ? "menu" : "value",
        selectValue: s
      };
      V = I.onFocus(M);
    }
    return V;
  }, [r, i, d, p, I, b, s]), P = Rn(function() {
    var V = "";
    if (m && b.length && I.onFilter) {
      var $ = y({
        count: o.length
      });
      V = I.onFilter({
        inputValue: f,
        resultsMessage: $
      });
    }
    return V;
  }, [o, f, m, I, b, y]), N = Rn(function() {
    var V = "";
    if (I.guidance) {
      var $ = i ? "value" : m ? "menu" : "input";
      V = I.guidance({
        "aria-label": S,
        context: $,
        isDisabled: r && p(r, s),
        isMulti: h,
        isSearchable: v,
        tabSelectsValue: w
      });
    }
    return V;
  }, [S, r, i, h, p, v, m, I, s, w]), k = "".concat(A, " ").concat(P, " ").concat(N), D = Xt(ha, null, Xt("span", {
    id: "aria-selection"
  }, _), Xt("span", {
    id: "aria-context"
  }, k)), R = (n == null ? void 0 : n.action) === "initial-input-focus";
  return Xt(ha, null, Xt(IH, {
    id: l
  }, R && D), Xt(IH, {
    "aria-live": E,
    "aria-atomic": "false",
    "aria-relevant": "additions text"
  }, a && !R && D));
}, z6 = [{
  base: "A",
  letters: "AⒶＡÀÁÂẦẤẪẨÃĀĂẰẮẴẲȦǠÄǞẢÅǺǍȀȂẠẬẶḀĄȺⱯ"
}, {
  base: "AA",
  letters: "Ꜳ"
}, {
  base: "AE",
  letters: "ÆǼǢ"
}, {
  base: "AO",
  letters: "Ꜵ"
}, {
  base: "AU",
  letters: "Ꜷ"
}, {
  base: "AV",
  letters: "ꜸꜺ"
}, {
  base: "AY",
  letters: "Ꜽ"
}, {
  base: "B",
  letters: "BⒷＢḂḄḆɃƂƁ"
}, {
  base: "C",
  letters: "CⒸＣĆĈĊČÇḈƇȻꜾ"
}, {
  base: "D",
  letters: "DⒹＤḊĎḌḐḒḎĐƋƊƉꝹ"
}, {
  base: "DZ",
  letters: "ǱǄ"
}, {
  base: "Dz",
  letters: "ǲǅ"
}, {
  base: "E",
  letters: "EⒺＥÈÉÊỀẾỄỂẼĒḔḖĔĖËẺĚȄȆẸỆȨḜĘḘḚƐƎ"
}, {
  base: "F",
  letters: "FⒻＦḞƑꝻ"
}, {
  base: "G",
  letters: "GⒼＧǴĜḠĞĠǦĢǤƓꞠꝽꝾ"
}, {
  base: "H",
  letters: "HⒽＨĤḢḦȞḤḨḪĦⱧⱵꞍ"
}, {
  base: "I",
  letters: "IⒾＩÌÍÎĨĪĬİÏḮỈǏȈȊỊĮḬƗ"
}, {
  base: "J",
  letters: "JⒿＪĴɈ"
}, {
  base: "K",
  letters: "KⓀＫḰǨḲĶḴƘⱩꝀꝂꝄꞢ"
}, {
  base: "L",
  letters: "LⓁＬĿĹĽḶḸĻḼḺŁȽⱢⱠꝈꝆꞀ"
}, {
  base: "LJ",
  letters: "Ǉ"
}, {
  base: "Lj",
  letters: "ǈ"
}, {
  base: "M",
  letters: "MⓂＭḾṀṂⱮƜ"
}, {
  base: "N",
  letters: "NⓃＮǸŃÑṄŇṆŅṊṈȠƝꞐꞤ"
}, {
  base: "NJ",
  letters: "Ǌ"
}, {
  base: "Nj",
  letters: "ǋ"
}, {
  base: "O",
  letters: "OⓄＯÒÓÔỒỐỖỔÕṌȬṎŌṐṒŎȮȰÖȪỎŐǑȌȎƠỜỚỠỞỢỌỘǪǬØǾƆƟꝊꝌ"
}, {
  base: "OI",
  letters: "Ƣ"
}, {
  base: "OO",
  letters: "Ꝏ"
}, {
  base: "OU",
  letters: "Ȣ"
}, {
  base: "P",
  letters: "PⓅＰṔṖƤⱣꝐꝒꝔ"
}, {
  base: "Q",
  letters: "QⓆＱꝖꝘɊ"
}, {
  base: "R",
  letters: "RⓇＲŔṘŘȐȒṚṜŖṞɌⱤꝚꞦꞂ"
}, {
  base: "S",
  letters: "SⓈＳẞŚṤŜṠŠṦṢṨȘŞⱾꞨꞄ"
}, {
  base: "T",
  letters: "TⓉＴṪŤṬȚŢṰṮŦƬƮȾꞆ"
}, {
  base: "TZ",
  letters: "Ꜩ"
}, {
  base: "U",
  letters: "UⓊＵÙÚÛŨṸŪṺŬÜǛǗǕǙỦŮŰǓȔȖƯỪỨỮỬỰỤṲŲṶṴɄ"
}, {
  base: "V",
  letters: "VⓋＶṼṾƲꝞɅ"
}, {
  base: "VY",
  letters: "Ꝡ"
}, {
  base: "W",
  letters: "WⓌＷẀẂŴẆẄẈⱲ"
}, {
  base: "X",
  letters: "XⓍＸẊẌ"
}, {
  base: "Y",
  letters: "YⓎＹỲÝŶỸȲẎŸỶỴƳɎỾ"
}, {
  base: "Z",
  letters: "ZⓏＺŹẐŻŽẒẔƵȤⱿⱫꝢ"
}, {
  base: "a",
  letters: "aⓐａẚàáâầấẫẩãāăằắẵẳȧǡäǟảåǻǎȁȃạậặḁąⱥɐ"
}, {
  base: "aa",
  letters: "ꜳ"
}, {
  base: "ae",
  letters: "æǽǣ"
}, {
  base: "ao",
  letters: "ꜵ"
}, {
  base: "au",
  letters: "ꜷ"
}, {
  base: "av",
  letters: "ꜹꜻ"
}, {
  base: "ay",
  letters: "ꜽ"
}, {
  base: "b",
  letters: "bⓑｂḃḅḇƀƃɓ"
}, {
  base: "c",
  letters: "cⓒｃćĉċčçḉƈȼꜿↄ"
}, {
  base: "d",
  letters: "dⓓｄḋďḍḑḓḏđƌɖɗꝺ"
}, {
  base: "dz",
  letters: "ǳǆ"
}, {
  base: "e",
  letters: "eⓔｅèéêềếễểẽēḕḗĕėëẻěȅȇẹệȩḝęḙḛɇɛǝ"
}, {
  base: "f",
  letters: "fⓕｆḟƒꝼ"
}, {
  base: "g",
  letters: "gⓖｇǵĝḡğġǧģǥɠꞡᵹꝿ"
}, {
  base: "h",
  letters: "hⓗｈĥḣḧȟḥḩḫẖħⱨⱶɥ"
}, {
  base: "hv",
  letters: "ƕ"
}, {
  base: "i",
  letters: "iⓘｉìíîĩīĭïḯỉǐȉȋịįḭɨı"
}, {
  base: "j",
  letters: "jⓙｊĵǰɉ"
}, {
  base: "k",
  letters: "kⓚｋḱǩḳķḵƙⱪꝁꝃꝅꞣ"
}, {
  base: "l",
  letters: "lⓛｌŀĺľḷḹļḽḻſłƚɫⱡꝉꞁꝇ"
}, {
  base: "lj",
  letters: "ǉ"
}, {
  base: "m",
  letters: "mⓜｍḿṁṃɱɯ"
}, {
  base: "n",
  letters: "nⓝｎǹńñṅňṇņṋṉƞɲŉꞑꞥ"
}, {
  base: "nj",
  letters: "ǌ"
}, {
  base: "o",
  letters: "oⓞｏòóôồốỗổõṍȭṏōṑṓŏȯȱöȫỏőǒȍȏơờớỡởợọộǫǭøǿɔꝋꝍɵ"
}, {
  base: "oi",
  letters: "ƣ"
}, {
  base: "ou",
  letters: "ȣ"
}, {
  base: "oo",
  letters: "ꝏ"
}, {
  base: "p",
  letters: "pⓟｐṕṗƥᵽꝑꝓꝕ"
}, {
  base: "q",
  letters: "qⓠｑɋꝗꝙ"
}, {
  base: "r",
  letters: "rⓡｒŕṙřȑȓṛṝŗṟɍɽꝛꞧꞃ"
}, {
  base: "s",
  letters: "sⓢｓßśṥŝṡšṧṣṩșşȿꞩꞅẛ"
}, {
  base: "t",
  letters: "tⓣｔṫẗťṭțţṱṯŧƭʈⱦꞇ"
}, {
  base: "tz",
  letters: "ꜩ"
}, {
  base: "u",
  letters: "uⓤｕùúûũṹūṻŭüǜǘǖǚủůűǔȕȗưừứữửựụṳųṷṵʉ"
}, {
  base: "v",
  letters: "vⓥｖṽṿʋꝟʌ"
}, {
  base: "vy",
  letters: "ꝡ"
}, {
  base: "w",
  letters: "wⓦｗẁẃŵẇẅẘẉⱳ"
}, {
  base: "x",
  letters: "xⓧｘẋẍ"
}, {
  base: "y",
  letters: "yⓨｙỳýŷỹȳẏÿỷẙỵƴɏỿ"
}, {
  base: "z",
  letters: "zⓩｚźẑżžẓẕƶȥɀⱬꝣ"
}], Avt = new RegExp("[" + z6.map(function(t) {
  return t.letters;
}).join("") + "]", "g"), $ie = {};
for (var tI = 0; tI < z6.length; tI++)
  for (var nI = z6[tI], rI = 0; rI < nI.letters.length; rI++)
    $ie[nI.letters[rI]] = nI.base;
var Die = function(e) {
  return e.replace(Avt, function(n) {
    return $ie[n];
  });
}, Tvt = wvt(Die), _H = function(e) {
  return e.replace(/^\s+|\s+$/g, "");
}, Ovt = function(e) {
  return "".concat(e.label, " ").concat(e.value);
}, Pvt = function(e) {
  return function(n, r) {
    if (n.data.__isNew__)
      return !0;
    var i = Jn({
      ignoreCase: !0,
      ignoreAccents: !0,
      stringify: Ovt,
      trim: !0,
      matchFrom: "any"
    }, e), o = i.ignoreCase, a = i.ignoreAccents, s = i.stringify, u = i.trim, l = i.matchFrom, c = u ? _H(r) : r, d = u ? _H(s(n)) : s(n);
    return o && (c = c.toLowerCase(), d = d.toLowerCase()), a && (c = Tvt(c), d = Die(d)), l === "start" ? d.substr(0, c.length) === c : d.indexOf(c) > -1;
  };
}, Nvt = ["innerRef"];
function kvt(t) {
  var e = t.innerRef, n = Gt(t, Nvt), r = ymt(n, "onExited", "in", "enter", "exit", "appear");
  return Xt("input", G({
    ref: e
  }, r, {
    css: /* @__PURE__ */ gP({
      label: "dummyInput",
      // get rid of any default styles
      background: 0,
      border: 0,
      // important! this hides the flashing cursor
      caretColor: "transparent",
      fontSize: "inherit",
      gridArea: "1 / 1 / 2 / 3",
      outline: 0,
      padding: 0,
      // important! without `width` browsers won't allow focus
      width: 1,
      // remove cursor on desktop
      color: "transparent",
      // remove cursor on mobile whilst maintaining "scroll into view" behaviour
      left: -100,
      opacity: 0,
      position: "relative",
      transform: "scale(.01)"
    }, process.env.NODE_ENV === "production" ? "" : ";label:DummyInput;", process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIkR1bW15SW5wdXQudHN4Il0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQXlCTSIsImZpbGUiOiJEdW1teUlucHV0LnRzeCIsInNvdXJjZXNDb250ZW50IjpbIi8qKiBAanN4IGpzeCAqL1xuaW1wb3J0IHsgUmVmIH0gZnJvbSAncmVhY3QnO1xuaW1wb3J0IHsganN4IH0gZnJvbSAnQGVtb3Rpb24vcmVhY3QnO1xuaW1wb3J0IHsgcmVtb3ZlUHJvcHMgfSBmcm9tICcuLi91dGlscyc7XG5cbmV4cG9ydCBkZWZhdWx0IGZ1bmN0aW9uIER1bW15SW5wdXQoe1xuICBpbm5lclJlZixcbiAgLi4ucHJvcHNcbn06IEpTWC5JbnRyaW5zaWNFbGVtZW50c1snaW5wdXQnXSAmIHtcbiAgcmVhZG9ubHkgaW5uZXJSZWY6IFJlZjxIVE1MSW5wdXRFbGVtZW50Pjtcbn0pIHtcbiAgLy8gUmVtb3ZlIGFuaW1hdGlvbiBwcm9wcyBub3QgbWVhbnQgZm9yIEhUTUwgZWxlbWVudHNcbiAgY29uc3QgZmlsdGVyZWRQcm9wcyA9IHJlbW92ZVByb3BzKFxuICAgIHByb3BzLFxuICAgICdvbkV4aXRlZCcsXG4gICAgJ2luJyxcbiAgICAnZW50ZXInLFxuICAgICdleGl0JyxcbiAgICAnYXBwZWFyJ1xuICApO1xuXG4gIHJldHVybiAoXG4gICAgPGlucHV0XG4gICAgICByZWY9e2lubmVyUmVmfVxuICAgICAgey4uLmZpbHRlcmVkUHJvcHN9XG4gICAgICBjc3M9e3tcbiAgICAgICAgbGFiZWw6ICdkdW1teUlucHV0JyxcbiAgICAgICAgLy8gZ2V0IHJpZCBvZiBhbnkgZGVmYXVsdCBzdHlsZXNcbiAgICAgICAgYmFja2dyb3VuZDogMCxcbiAgICAgICAgYm9yZGVyOiAwLFxuICAgICAgICAvLyBpbXBvcnRhbnQhIHRoaXMgaGlkZXMgdGhlIGZsYXNoaW5nIGN1cnNvclxuICAgICAgICBjYXJldENvbG9yOiAndHJhbnNwYXJlbnQnLFxuICAgICAgICBmb250U2l6ZTogJ2luaGVyaXQnLFxuICAgICAgICBncmlkQXJlYTogJzEgLyAxIC8gMiAvIDMnLFxuICAgICAgICBvdXRsaW5lOiAwLFxuICAgICAgICBwYWRkaW5nOiAwLFxuICAgICAgICAvLyBpbXBvcnRhbnQhIHdpdGhvdXQgYHdpZHRoYCBicm93c2VycyB3b24ndCBhbGxvdyBmb2N1c1xuICAgICAgICB3aWR0aDogMSxcblxuICAgICAgICAvLyByZW1vdmUgY3Vyc29yIG9uIGRlc2t0b3BcbiAgICAgICAgY29sb3I6ICd0cmFuc3BhcmVudCcsXG5cbiAgICAgICAgLy8gcmVtb3ZlIGN1cnNvciBvbiBtb2JpbGUgd2hpbHN0IG1haW50YWluaW5nIFwic2Nyb2xsIGludG8gdmlld1wiIGJlaGF2aW91clxuICAgICAgICBsZWZ0OiAtMTAwLFxuICAgICAgICBvcGFjaXR5OiAwLFxuICAgICAgICBwb3NpdGlvbjogJ3JlbGF0aXZlJyxcbiAgICAgICAgdHJhbnNmb3JtOiAnc2NhbGUoLjAxKScsXG4gICAgICB9fVxuICAgIC8+XG4gICk7XG59XG4iXX0= */")
  }));
}
var Rvt = function(e) {
  e.preventDefault(), e.stopPropagation();
};
function $vt(t) {
  var e = t.isEnabled, n = t.onBottomArrive, r = t.onBottomLeave, i = t.onTopArrive, o = t.onTopLeave, a = Ee(!1), s = Ee(!1), u = Ee(0), l = Ee(null), c = et(function(m, b) {
    if (l.current !== null) {
      var y = l.current, w = y.scrollTop, S = y.scrollHeight, E = y.clientHeight, I = l.current, _ = b > 0, A = S - E - w, P = !1;
      A > b && a.current && (r && r(m), a.current = !1), _ && s.current && (o && o(m), s.current = !1), _ && b > A ? (n && !a.current && n(m), I.scrollTop = S, P = !0, a.current = !0) : !_ && -b > w && (i && !s.current && i(m), I.scrollTop = 0, P = !0, s.current = !0), P && Rvt(m);
    }
  }, [n, r, i, o]), d = et(function(m) {
    c(m, m.deltaY);
  }, [c]), f = et(function(m) {
    u.current = m.changedTouches[0].clientY;
  }, []), h = et(function(m) {
    var b = u.current - m.changedTouches[0].clientY;
    c(m, b);
  }, [c]), p = et(function(m) {
    if (m) {
      var b = mmt ? {
        passive: !1
      } : !1;
      m.addEventListener("wheel", d, b), m.addEventListener("touchstart", f, b), m.addEventListener("touchmove", h, b);
    }
  }, [h, f, d]), v = et(function(m) {
    m && (m.removeEventListener("wheel", d, !1), m.removeEventListener("touchstart", f, !1), m.removeEventListener("touchmove", h, !1));
  }, [h, f, d]);
  return Re(function() {
    if (e) {
      var m = l.current;
      return p(m), function() {
        v(m);
      };
    }
  }, [e, p, v]), function(m) {
    l.current = m;
  };
}
var AH = ["boxSizing", "height", "overflow", "paddingRight", "position"], TH = {
  boxSizing: "border-box",
  // account for possible declaration `width: 100%;` on body
  overflow: "hidden",
  position: "relative",
  height: "100%"
};
function OH(t) {
  t.preventDefault();
}
function PH(t) {
  t.stopPropagation();
}
function NH() {
  var t = this.scrollTop, e = this.scrollHeight, n = t + this.offsetHeight;
  t === 0 ? this.scrollTop = 1 : n === e && (this.scrollTop = t - 1);
}
function kH() {
  return "ontouchstart" in window || navigator.maxTouchPoints;
}
var RH = !!(typeof window < "u" && window.document && window.document.createElement), Zg = 0, Kf = {
  capture: !1,
  passive: !1
};
function Dvt(t) {
  var e = t.isEnabled, n = t.accountForScrollbars, r = n === void 0 ? !0 : n, i = Ee({}), o = Ee(null), a = et(function(u) {
    if (RH) {
      var l = document.body, c = l && l.style;
      if (r && AH.forEach(function(p) {
        var v = c && c[p];
        i.current[p] = v;
      }), r && Zg < 1) {
        var d = parseInt(i.current.paddingRight, 10) || 0, f = document.body ? document.body.clientWidth : 0, h = window.innerWidth - f + d || 0;
        Object.keys(TH).forEach(function(p) {
          var v = TH[p];
          c && (c[p] = v);
        }), c && (c.paddingRight = "".concat(h, "px"));
      }
      l && kH() && (l.addEventListener("touchmove", OH, Kf), u && (u.addEventListener("touchstart", NH, Kf), u.addEventListener("touchmove", PH, Kf))), Zg += 1;
    }
  }, [r]), s = et(function(u) {
    if (RH) {
      var l = document.body, c = l && l.style;
      Zg = Math.max(Zg - 1, 0), r && Zg < 1 && AH.forEach(function(d) {
        var f = i.current[d];
        c && (c[d] = f);
      }), l && kH() && (l.removeEventListener("touchmove", OH, Kf), u && (u.removeEventListener("touchstart", NH, Kf), u.removeEventListener("touchmove", PH, Kf)));
    }
  }, [r]);
  return Re(function() {
    if (e) {
      var u = o.current;
      return a(u), function() {
        s(u);
      };
    }
  }, [e, a, s]), function(u) {
    o.current = u;
  };
}
function Mvt() {
  return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
var Fvt = function() {
  return document.activeElement && document.activeElement.blur();
}, Lvt = process.env.NODE_ENV === "production" ? {
  name: "1kfdb0e",
  styles: "position:fixed;left:0;bottom:0;right:0;top:0"
} : {
  name: "bp8cua-ScrollManager",
  styles: "position:fixed;left:0;bottom:0;right:0;top:0;label:ScrollManager;",
  map: "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */",
  toString: Mvt
};
function Vvt(t) {
  var e = t.children, n = t.lockEnabled, r = t.captureEnabled, i = r === void 0 ? !0 : r, o = t.onBottomArrive, a = t.onBottomLeave, s = t.onTopArrive, u = t.onTopLeave, l = $vt({
    isEnabled: i,
    onBottomArrive: o,
    onBottomLeave: a,
    onTopArrive: s,
    onTopLeave: u
  }), c = Dvt({
    isEnabled: n
  }), d = function(h) {
    l(h), c(h);
  };
  return Xt(ha, null, n && Xt("div", {
    onClick: Fvt,
    css: Lvt
  }), e(d));
}
var Bvt = function(e) {
  return e.label;
}, Mie = function(e) {
  return e.label;
}, Fie = function(e) {
  return e.value;
}, Hvt = function(e) {
  return !!e.isDisabled;
}, Wvt = {
  clearIndicator: Hmt,
  container: Pmt,
  control: Xmt,
  dropdownIndicator: Vmt,
  group: Jmt,
  groupHeading: qmt,
  indicatorsContainer: $mt,
  indicatorSeparator: jmt,
  input: tvt,
  loadingIndicator: Umt,
  loadingMessage: Amt,
  menu: wmt,
  menuList: Smt,
  menuPortal: Tmt,
  multiValue: ovt,
  multiValueLabel: avt,
  multiValueRemove: svt,
  noOptionsMessage: _mt,
  option: fvt,
  placeholder: pvt,
  singleValue: mvt,
  valueContainer: kmt
}, jvt = {
  primary: "#2684FF",
  primary75: "#4C9AFF",
  primary50: "#B2D4FF",
  primary25: "#DEEBFF",
  danger: "#DE350B",
  dangerLight: "#FFBDAD",
  neutral0: "hsl(0, 0%, 100%)",
  neutral5: "hsl(0, 0%, 95%)",
  neutral10: "hsl(0, 0%, 90%)",
  neutral20: "hsl(0, 0%, 80%)",
  neutral30: "hsl(0, 0%, 70%)",
  neutral40: "hsl(0, 0%, 60%)",
  neutral50: "hsl(0, 0%, 50%)",
  neutral60: "hsl(0, 0%, 40%)",
  neutral70: "hsl(0, 0%, 30%)",
  neutral80: "hsl(0, 0%, 20%)",
  neutral90: "hsl(0, 0%, 10%)"
}, zvt = 4, Lie = 4, Gvt = 38, Uvt = Lie * 2, Xvt = {
  baseUnit: Lie,
  controlHeight: Gvt,
  menuGutter: Uvt
}, iI = {
  borderRadius: zvt,
  colors: jvt,
  spacing: Xvt
}, Yvt = {
  "aria-live": "polite",
  backspaceRemovesValue: !0,
  blurInputOnSelect: wH(),
  captureMenuScroll: !wH(),
  closeMenuOnSelect: !0,
  closeMenuOnScroll: !1,
  components: {},
  controlShouldRenderValue: !0,
  escapeClearsValue: !1,
  filterOption: Pvt(),
  formatGroupLabel: Bvt,
  getOptionLabel: Mie,
  getOptionValue: Fie,
  isDisabled: !1,
  isLoading: !1,
  isMulti: !1,
  isRtl: !1,
  isSearchable: !0,
  isOptionDisabled: Hvt,
  loadingMessage: function() {
    return "Loading...";
  },
  maxMenuHeight: 300,
  minMenuHeight: 140,
  menuIsOpen: !1,
  menuPlacement: "bottom",
  menuPosition: "absolute",
  menuShouldBlockScroll: !1,
  menuShouldScrollIntoView: !pmt(),
  noOptionsMessage: function() {
    return "No options";
  },
  openMenuOnFocus: !1,
  openMenuOnClick: !0,
  options: [],
  pageSize: 5,
  placeholder: "Select...",
  screenReaderStatus: function(e) {
    var n = e.count;
    return "".concat(n, " result").concat(n !== 1 ? "s" : "", " available");
  },
  styles: {},
  tabIndex: 0,
  tabSelectsValue: !0
};
function $H(t, e, n, r) {
  var i = Wie(t, e, n), o = jie(t, e, n), a = Hie(t, e), s = rC(t, e);
  return {
    type: "option",
    data: e,
    isDisabled: i,
    isSelected: o,
    label: a,
    value: s,
    index: r
  };
}
function Vie(t, e) {
  return t.options.map(function(n, r) {
    if ("options" in n) {
      var i = n.options.map(function(a, s) {
        return $H(t, a, e, s);
      }).filter(function(a) {
        return DH(t, a);
      });
      return i.length > 0 ? {
        type: "group",
        data: n,
        options: i,
        index: r
      } : void 0;
    }
    var o = $H(t, n, e, r);
    return DH(t, o) ? o : void 0;
  }).filter(vmt);
}
function Bie(t) {
  return t.reduce(function(e, n) {
    return n.type === "group" ? e.push.apply(e, Ye(n.options.map(function(r) {
      return r.data;
    }))) : e.push(n.data), e;
  }, []);
}
function Zvt(t, e) {
  return Bie(Vie(t, e));
}
function DH(t, e) {
  var n = t.inputValue, r = n === void 0 ? "" : n, i = e.data, o = e.isSelected, a = e.label, s = e.value;
  return (!Gie(t) || !o) && zie(t, {
    label: a,
    value: s,
    data: i
  }, r);
}
function Jvt(t, e) {
  var n = t.focusedValue, r = t.selectValue, i = r.indexOf(n);
  if (i > -1) {
    var o = e.indexOf(n);
    if (o > -1)
      return n;
    if (i < e.length)
      return e[i];
  }
  return null;
}
function Kvt(t, e) {
  var n = t.focusedOption;
  return n && e.indexOf(n) > -1 ? n : e[0];
}
var Hie = function(e, n) {
  return e.getOptionLabel(n);
}, rC = function(e, n) {
  return e.getOptionValue(n);
};
function Wie(t, e, n) {
  return typeof t.isOptionDisabled == "function" ? t.isOptionDisabled(e, n) : !1;
}
function jie(t, e, n) {
  if (n.indexOf(e) > -1)
    return !0;
  if (typeof t.isOptionSelected == "function")
    return t.isOptionSelected(e, n);
  var r = rC(t, e);
  return n.some(function(i) {
    return rC(t, i) === r;
  });
}
function zie(t, e, n) {
  return t.filterOption ? t.filterOption(e, n) : !0;
}
var Gie = function(e) {
  var n = e.hideSelectedOptions, r = e.isMulti;
  return n === void 0 ? r : n;
}, qvt = 1, bP = /* @__PURE__ */ function(t) {
  Pr(n, t);
  var e = mP(n);
  function n(r) {
    var i;
    return zn(this, n), i = e.call(this, r), i.state = {
      ariaSelection: null,
      focusedOption: null,
      focusedValue: null,
      inputIsHidden: !1,
      isFocused: !1,
      selectValue: [],
      clearFocusValueOnUpdate: !1,
      prevWasFocused: !1,
      inputIsHiddenAfterUpdate: void 0,
      prevProps: void 0
    }, i.blockOptionHover = !1, i.isComposing = !1, i.commonProps = void 0, i.initialTouchX = 0, i.initialTouchY = 0, i.instancePrefix = "", i.openAfterFocus = !1, i.scrollToFocusedOptionOnUpdate = !1, i.userIsDragging = void 0, i.controlRef = null, i.getControlRef = function(o) {
      i.controlRef = o;
    }, i.focusedOptionRef = null, i.getFocusedOptionRef = function(o) {
      i.focusedOptionRef = o;
    }, i.menuListRef = null, i.getMenuListRef = function(o) {
      i.menuListRef = o;
    }, i.inputRef = null, i.getInputRef = function(o) {
      i.inputRef = o;
    }, i.focus = i.focusInput, i.blur = i.blurInput, i.onChange = function(o, a) {
      var s = i.props, u = s.onChange, l = s.name;
      a.name = l, i.ariaOnChange(o, a), u(o, a);
    }, i.setValue = function(o, a, s) {
      var u = i.props, l = u.closeMenuOnSelect, c = u.isMulti, d = u.inputValue;
      i.onInputChange("", {
        action: "set-value",
        prevInputValue: d
      }), l && (i.setState({
        inputIsHiddenAfterUpdate: !c
      }), i.onMenuClose()), i.setState({
        clearFocusValueOnUpdate: !0
      }), i.onChange(o, {
        action: a,
        option: s
      });
    }, i.selectOption = function(o) {
      var a = i.props, s = a.blurInputOnSelect, u = a.isMulti, l = a.name, c = i.state.selectValue, d = u && i.isOptionSelected(o, c), f = i.isOptionDisabled(o, c);
      if (d) {
        var h = i.getOptionValue(o);
        i.setValue(c.filter(function(p) {
          return i.getOptionValue(p) !== h;
        }), "deselect-option", o);
      } else if (!f)
        u ? i.setValue([].concat(Ye(c), [o]), "select-option", o) : i.setValue(o, "select-option");
      else {
        i.ariaOnChange(o, {
          action: "select-option",
          option: o,
          name: l
        });
        return;
      }
      s && i.blurInput();
    }, i.removeValue = function(o) {
      var a = i.props.isMulti, s = i.state.selectValue, u = i.getOptionValue(o), l = s.filter(function(d) {
        return i.getOptionValue(d) !== u;
      }), c = u0(a, l, l[0] || null);
      i.onChange(c, {
        action: "remove-value",
        removedValue: o
      }), i.focusInput();
    }, i.clearValue = function() {
      var o = i.state.selectValue;
      i.onChange(u0(i.props.isMulti, [], null), {
        action: "clear",
        removedValues: o
      });
    }, i.popValue = function() {
      var o = i.props.isMulti, a = i.state.selectValue, s = a[a.length - 1], u = a.slice(0, a.length - 1), l = u0(o, u, u[0] || null);
      i.onChange(l, {
        action: "pop-value",
        removedValue: s
      });
    }, i.getValue = function() {
      return i.state.selectValue;
    }, i.cx = function() {
      for (var o = arguments.length, a = new Array(o), s = 0; s < o; s++)
        a[s] = arguments[s];
      return smt.apply(void 0, [i.props.classNamePrefix].concat(a));
    }, i.getOptionLabel = function(o) {
      return Hie(i.props, o);
    }, i.getOptionValue = function(o) {
      return rC(i.props, o);
    }, i.getStyles = function(o, a) {
      var s = Wvt[o](a);
      s.boxSizing = "border-box";
      var u = i.props.styles[o];
      return u ? u(s, a) : s;
    }, i.getElementId = function(o) {
      return "".concat(i.instancePrefix, "-").concat(o);
    }, i.getComponents = function() {
      return yvt(i.props);
    }, i.buildCategorizedOptions = function() {
      return Vie(i.props, i.state.selectValue);
    }, i.getCategorizedOptions = function() {
      return i.props.menuIsOpen ? i.buildCategorizedOptions() : [];
    }, i.buildFocusableOptions = function() {
      return Bie(i.buildCategorizedOptions());
    }, i.getFocusableOptions = function() {
      return i.props.menuIsOpen ? i.buildFocusableOptions() : [];
    }, i.ariaOnChange = function(o, a) {
      i.setState({
        ariaSelection: Jn({
          value: o
        }, a)
      });
    }, i.onMenuMouseDown = function(o) {
      o.button === 0 && (o.stopPropagation(), o.preventDefault(), i.focusInput());
    }, i.onMenuMouseMove = function(o) {
      i.blockOptionHover = !1;
    }, i.onControlMouseDown = function(o) {
      if (!o.defaultPrevented) {
        var a = i.props.openMenuOnClick;
        i.state.isFocused ? i.props.menuIsOpen ? o.target.tagName !== "INPUT" && o.target.tagName !== "TEXTAREA" && i.onMenuClose() : a && i.openMenu("first") : (a && (i.openAfterFocus = !0), i.focusInput()), o.target.tagName !== "INPUT" && o.target.tagName !== "TEXTAREA" && o.preventDefault();
      }
    }, i.onDropdownIndicatorMouseDown = function(o) {
      if (!(o && o.type === "mousedown" && o.button !== 0) && !i.props.isDisabled) {
        var a = i.props, s = a.isMulti, u = a.menuIsOpen;
        i.focusInput(), u ? (i.setState({
          inputIsHiddenAfterUpdate: !s
        }), i.onMenuClose()) : i.openMenu("first"), o.preventDefault();
      }
    }, i.onClearIndicatorMouseDown = function(o) {
      o && o.type === "mousedown" && o.button !== 0 || (i.clearValue(), o.preventDefault(), i.openAfterFocus = !1, o.type === "touchend" ? i.focusInput() : setTimeout(function() {
        return i.focusInput();
      }));
    }, i.onScroll = function(o) {
      typeof i.props.closeMenuOnScroll == "boolean" ? o.target instanceof HTMLElement && pE(o.target) && i.props.onMenuClose() : typeof i.props.closeMenuOnScroll == "function" && i.props.closeMenuOnScroll(o) && i.props.onMenuClose();
    }, i.onCompositionStart = function() {
      i.isComposing = !0;
    }, i.onCompositionEnd = function() {
      i.isComposing = !1;
    }, i.onTouchStart = function(o) {
      var a = o.touches, s = a && a.item(0);
      s && (i.initialTouchX = s.clientX, i.initialTouchY = s.clientY, i.userIsDragging = !1);
    }, i.onTouchMove = function(o) {
      var a = o.touches, s = a && a.item(0);
      if (s) {
        var u = Math.abs(s.clientX - i.initialTouchX), l = Math.abs(s.clientY - i.initialTouchY), c = 5;
        i.userIsDragging = u > c || l > c;
      }
    }, i.onTouchEnd = function(o) {
      i.userIsDragging || (i.controlRef && !i.controlRef.contains(o.target) && i.menuListRef && !i.menuListRef.contains(o.target) && i.blurInput(), i.initialTouchX = 0, i.initialTouchY = 0);
    }, i.onControlTouchEnd = function(o) {
      i.userIsDragging || i.onControlMouseDown(o);
    }, i.onClearIndicatorTouchEnd = function(o) {
      i.userIsDragging || i.onClearIndicatorMouseDown(o);
    }, i.onDropdownIndicatorTouchEnd = function(o) {
      i.userIsDragging || i.onDropdownIndicatorMouseDown(o);
    }, i.handleInputChange = function(o) {
      var a = i.props.inputValue, s = o.currentTarget.value;
      i.setState({
        inputIsHiddenAfterUpdate: !1
      }), i.onInputChange(s, {
        action: "input-change",
        prevInputValue: a
      }), i.props.menuIsOpen || i.onMenuOpen();
    }, i.onInputFocus = function(o) {
      i.props.onFocus && i.props.onFocus(o), i.setState({
        inputIsHiddenAfterUpdate: !1,
        isFocused: !0
      }), (i.openAfterFocus || i.props.openMenuOnFocus) && i.openMenu("first"), i.openAfterFocus = !1;
    }, i.onInputBlur = function(o) {
      var a = i.props.inputValue;
      if (i.menuListRef && i.menuListRef.contains(document.activeElement)) {
        i.inputRef.focus();
        return;
      }
      i.props.onBlur && i.props.onBlur(o), i.onInputChange("", {
        action: "input-blur",
        prevInputValue: a
      }), i.onMenuClose(), i.setState({
        focusedValue: null,
        isFocused: !1
      });
    }, i.onOptionHover = function(o) {
      i.blockOptionHover || i.state.focusedOption === o || i.setState({
        focusedOption: o
      });
    }, i.shouldHideSelectedOptions = function() {
      return Gie(i.props);
    }, i.onKeyDown = function(o) {
      var a = i.props, s = a.isMulti, u = a.backspaceRemovesValue, l = a.escapeClearsValue, c = a.inputValue, d = a.isClearable, f = a.isDisabled, h = a.menuIsOpen, p = a.onKeyDown, v = a.tabSelectsValue, m = a.openMenuOnFocus, b = i.state, y = b.focusedOption, w = b.focusedValue, S = b.selectValue;
      if (!f && !(typeof p == "function" && (p(o), o.defaultPrevented))) {
        switch (i.blockOptionHover = !0, o.key) {
          case "ArrowLeft":
            if (!s || c)
              return;
            i.focusValue("previous");
            break;
          case "ArrowRight":
            if (!s || c)
              return;
            i.focusValue("next");
            break;
          case "Delete":
          case "Backspace":
            if (c)
              return;
            if (w)
              i.removeValue(w);
            else {
              if (!u)
                return;
              s ? i.popValue() : d && i.clearValue();
            }
            break;
          case "Tab":
            if (i.isComposing || o.shiftKey || !h || !v || !y || // don't capture the event if the menu opens on focus and the focused
            // option is already selected; it breaks the flow of navigation
            m && i.isOptionSelected(y, S))
              return;
            i.selectOption(y);
            break;
          case "Enter":
            if (o.keyCode === 229)
              break;
            if (h) {
              if (!y || i.isComposing)
                return;
              i.selectOption(y);
              break;
            }
            return;
          case "Escape":
            h ? (i.setState({
              inputIsHiddenAfterUpdate: !1
            }), i.onInputChange("", {
              action: "menu-close",
              prevInputValue: c
            }), i.onMenuClose()) : d && l && i.clearValue();
            break;
          case " ":
            if (c)
              return;
            if (!h) {
              i.openMenu("first");
              break;
            }
            if (!y)
              return;
            i.selectOption(y);
            break;
          case "ArrowUp":
            h ? i.focusOption("up") : i.openMenu("last");
            break;
          case "ArrowDown":
            h ? i.focusOption("down") : i.openMenu("first");
            break;
          case "PageUp":
            if (!h)
              return;
            i.focusOption("pageup");
            break;
          case "PageDown":
            if (!h)
              return;
            i.focusOption("pagedown");
            break;
          case "Home":
            if (!h)
              return;
            i.focusOption("first");
            break;
          case "End":
            if (!h)
              return;
            i.focusOption("last");
            break;
          default:
            return;
        }
        o.preventDefault();
      }
    }, i.instancePrefix = "react-select-" + (i.props.instanceId || ++qvt), i.state.selectValue = tC(r.value), i;
  }
  return Gn(n, [{
    key: "componentDidMount",
    value: function() {
      this.startListeningComposition(), this.startListeningToTouch(), this.props.closeMenuOnScroll && document && document.addEventListener && document.addEventListener("scroll", this.onScroll, !0), this.props.autoFocus && this.focusInput();
    }
  }, {
    key: "componentDidUpdate",
    value: function(i) {
      var o = this.props, a = o.isDisabled, s = o.menuIsOpen, u = this.state.isFocused;
      // ensure focus is restored correctly when the control becomes enabled
      (u && !a && i.isDisabled || // ensure focus is on the Input when the menu opens
      u && s && !i.menuIsOpen) && this.focusInput(), u && a && !i.isDisabled && this.setState({
        isFocused: !1
      }, this.onMenuClose), this.menuListRef && this.focusedOptionRef && this.scrollToFocusedOptionOnUpdate && (fmt(this.menuListRef, this.focusedOptionRef), this.scrollToFocusedOptionOnUpdate = !1);
    }
  }, {
    key: "componentWillUnmount",
    value: function() {
      this.stopListeningComposition(), this.stopListeningToTouch(), document.removeEventListener("scroll", this.onScroll, !0);
    }
    // ==============================
    // Consumer Handlers
    // ==============================
  }, {
    key: "onMenuOpen",
    value: function() {
      this.props.onMenuOpen();
    }
  }, {
    key: "onMenuClose",
    value: function() {
      this.onInputChange("", {
        action: "menu-close",
        prevInputValue: this.props.inputValue
      }), this.props.onMenuClose();
    }
  }, {
    key: "onInputChange",
    value: function(i, o) {
      this.props.onInputChange(i, o);
    }
    // ==============================
    // Methods
    // ==============================
  }, {
    key: "focusInput",
    value: function() {
      this.inputRef && this.inputRef.focus();
    }
  }, {
    key: "blurInput",
    value: function() {
      this.inputRef && this.inputRef.blur();
    }
    // aliased for consumers
  }, {
    key: "openMenu",
    value: function(i) {
      var o = this, a = this.state, s = a.selectValue, u = a.isFocused, l = this.buildFocusableOptions(), c = i === "first" ? 0 : l.length - 1;
      if (!this.props.isMulti) {
        var d = l.indexOf(s[0]);
        d > -1 && (c = d);
      }
      this.scrollToFocusedOptionOnUpdate = !(u && this.menuListRef), this.setState({
        inputIsHiddenAfterUpdate: !1,
        focusedValue: null,
        focusedOption: l[c]
      }, function() {
        return o.onMenuOpen();
      });
    }
  }, {
    key: "focusValue",
    value: function(i) {
      var o = this.state, a = o.selectValue, s = o.focusedValue;
      if (this.props.isMulti) {
        this.setState({
          focusedOption: null
        });
        var u = a.indexOf(s);
        s || (u = -1);
        var l = a.length - 1, c = -1;
        if (a.length) {
          switch (i) {
            case "previous":
              u === 0 ? c = 0 : u === -1 ? c = l : c = u - 1;
              break;
            case "next":
              u > -1 && u < l && (c = u + 1);
              break;
          }
          this.setState({
            inputIsHidden: c !== -1,
            focusedValue: a[c]
          });
        }
      }
    }
  }, {
    key: "focusOption",
    value: function() {
      var i = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "first", o = this.props.pageSize, a = this.state.focusedOption, s = this.getFocusableOptions();
      if (s.length) {
        var u = 0, l = s.indexOf(a);
        a || (l = -1), i === "up" ? u = l > 0 ? l - 1 : s.length - 1 : i === "down" ? u = (l + 1) % s.length : i === "pageup" ? (u = l - o, u < 0 && (u = 0)) : i === "pagedown" ? (u = l + o, u > s.length - 1 && (u = s.length - 1)) : i === "last" && (u = s.length - 1), this.scrollToFocusedOptionOnUpdate = !0, this.setState({
          focusedOption: s[u],
          focusedValue: null
        });
      }
    }
  }, {
    key: "getTheme",
    value: (
      // ==============================
      // Getters
      // ==============================
      function() {
        return this.props.theme ? typeof this.props.theme == "function" ? this.props.theme(iI) : Jn(Jn({}, iI), this.props.theme) : iI;
      }
    )
  }, {
    key: "getCommonProps",
    value: function() {
      var i = this.clearValue, o = this.cx, a = this.getStyles, s = this.getValue, u = this.selectOption, l = this.setValue, c = this.props, d = c.isMulti, f = c.isRtl, h = c.options, p = this.hasValue();
      return {
        clearValue: i,
        cx: o,
        getStyles: a,
        getValue: s,
        hasValue: p,
        isMulti: d,
        isRtl: f,
        options: h,
        selectOption: u,
        selectProps: c,
        setValue: l,
        theme: this.getTheme()
      };
    }
  }, {
    key: "hasValue",
    value: function() {
      var i = this.state.selectValue;
      return i.length > 0;
    }
  }, {
    key: "hasOptions",
    value: function() {
      return !!this.getFocusableOptions().length;
    }
  }, {
    key: "isClearable",
    value: function() {
      var i = this.props, o = i.isClearable, a = i.isMulti;
      return o === void 0 ? a : o;
    }
  }, {
    key: "isOptionDisabled",
    value: function(i, o) {
      return Wie(this.props, i, o);
    }
  }, {
    key: "isOptionSelected",
    value: function(i, o) {
      return jie(this.props, i, o);
    }
  }, {
    key: "filterOption",
    value: function(i, o) {
      return zie(this.props, i, o);
    }
  }, {
    key: "formatOptionLabel",
    value: function(i, o) {
      if (typeof this.props.formatOptionLabel == "function") {
        var a = this.props.inputValue, s = this.state.selectValue;
        return this.props.formatOptionLabel(i, {
          context: o,
          inputValue: a,
          selectValue: s
        });
      } else
        return this.getOptionLabel(i);
    }
  }, {
    key: "formatGroupLabel",
    value: function(i) {
      return this.props.formatGroupLabel(i);
    }
    // ==============================
    // Mouse Handlers
    // ==============================
  }, {
    key: "startListeningComposition",
    value: (
      // ==============================
      // Composition Handlers
      // ==============================
      function() {
        document && document.addEventListener && (document.addEventListener("compositionstart", this.onCompositionStart, !1), document.addEventListener("compositionend", this.onCompositionEnd, !1));
      }
    )
  }, {
    key: "stopListeningComposition",
    value: function() {
      document && document.removeEventListener && (document.removeEventListener("compositionstart", this.onCompositionStart), document.removeEventListener("compositionend", this.onCompositionEnd));
    }
  }, {
    key: "startListeningToTouch",
    value: (
      // ==============================
      // Touch Handlers
      // ==============================
      function() {
        document && document.addEventListener && (document.addEventListener("touchstart", this.onTouchStart, !1), document.addEventListener("touchmove", this.onTouchMove, !1), document.addEventListener("touchend", this.onTouchEnd, !1));
      }
    )
  }, {
    key: "stopListeningToTouch",
    value: function() {
      document && document.removeEventListener && (document.removeEventListener("touchstart", this.onTouchStart), document.removeEventListener("touchmove", this.onTouchMove), document.removeEventListener("touchend", this.onTouchEnd));
    }
  }, {
    key: "renderInput",
    value: (
      // ==============================
      // Renderers
      // ==============================
      function() {
        var i = this.props, o = i.isDisabled, a = i.isSearchable, s = i.inputId, u = i.inputValue, l = i.tabIndex, c = i.form, d = i.menuIsOpen, f = this.getComponents(), h = f.Input, p = this.state, v = p.inputIsHidden, m = p.ariaSelection, b = this.commonProps, y = s || this.getElementId("input"), w = Jn(Jn(Jn({
          "aria-autocomplete": "list",
          "aria-expanded": d,
          "aria-haspopup": !0,
          "aria-errormessage": this.props["aria-errormessage"],
          "aria-invalid": this.props["aria-invalid"],
          "aria-label": this.props["aria-label"],
          "aria-labelledby": this.props["aria-labelledby"],
          role: "combobox"
        }, d && {
          "aria-controls": this.getElementId("listbox"),
          "aria-owns": this.getElementId("listbox")
        }), !a && {
          "aria-readonly": !0
        }), this.hasValue() ? (m == null ? void 0 : m.action) === "initial-input-focus" && {
          "aria-describedby": this.getElementId("live-region")
        } : {
          "aria-describedby": this.getElementId("placeholder")
        });
        return a ? /* @__PURE__ */ x.createElement(h, G({}, b, {
          autoCapitalize: "none",
          autoComplete: "off",
          autoCorrect: "off",
          id: y,
          innerRef: this.getInputRef,
          isDisabled: o,
          isHidden: v,
          onBlur: this.onInputBlur,
          onChange: this.handleInputChange,
          onFocus: this.onInputFocus,
          spellCheck: "false",
          tabIndex: l,
          form: c,
          type: "text",
          value: u
        }, w)) : /* @__PURE__ */ x.createElement(kvt, G({
          id: y,
          innerRef: this.getInputRef,
          onBlur: this.onInputBlur,
          onChange: eC,
          onFocus: this.onInputFocus,
          disabled: o,
          tabIndex: l,
          inputMode: "none",
          form: c,
          value: ""
        }, w));
      }
    )
  }, {
    key: "renderPlaceholderOrValue",
    value: function() {
      var i = this, o = this.getComponents(), a = o.MultiValue, s = o.MultiValueContainer, u = o.MultiValueLabel, l = o.MultiValueRemove, c = o.SingleValue, d = o.Placeholder, f = this.commonProps, h = this.props, p = h.controlShouldRenderValue, v = h.isDisabled, m = h.isMulti, b = h.inputValue, y = h.placeholder, w = this.state, S = w.selectValue, E = w.focusedValue, I = w.isFocused;
      if (!this.hasValue() || !p)
        return b ? null : /* @__PURE__ */ x.createElement(d, G({}, f, {
          key: "placeholder",
          isDisabled: v,
          isFocused: I,
          innerProps: {
            id: this.getElementId("placeholder")
          }
        }), y);
      if (m)
        return S.map(function(A, P) {
          var N = A === E, k = "".concat(i.getOptionLabel(A), "-").concat(i.getOptionValue(A));
          return /* @__PURE__ */ x.createElement(a, G({}, f, {
            components: {
              Container: s,
              Label: u,
              Remove: l
            },
            isFocused: N,
            isDisabled: v,
            key: k,
            index: P,
            removeProps: {
              onClick: function() {
                return i.removeValue(A);
              },
              onTouchEnd: function() {
                return i.removeValue(A);
              },
              onMouseDown: function(R) {
                R.preventDefault();
              }
            },
            data: A
          }), i.formatOptionLabel(A, "value"));
        });
      if (b)
        return null;
      var _ = S[0];
      return /* @__PURE__ */ x.createElement(c, G({}, f, {
        data: _,
        isDisabled: v
      }), this.formatOptionLabel(_, "value"));
    }
  }, {
    key: "renderClearIndicator",
    value: function() {
      var i = this.getComponents(), o = i.ClearIndicator, a = this.commonProps, s = this.props, u = s.isDisabled, l = s.isLoading, c = this.state.isFocused;
      if (!this.isClearable() || !o || u || !this.hasValue() || l)
        return null;
      var d = {
        onMouseDown: this.onClearIndicatorMouseDown,
        onTouchEnd: this.onClearIndicatorTouchEnd,
        "aria-hidden": "true"
      };
      return /* @__PURE__ */ x.createElement(o, G({}, a, {
        innerProps: d,
        isFocused: c
      }));
    }
  }, {
    key: "renderLoadingIndicator",
    value: function() {
      var i = this.getComponents(), o = i.LoadingIndicator, a = this.commonProps, s = this.props, u = s.isDisabled, l = s.isLoading, c = this.state.isFocused;
      if (!o || !l)
        return null;
      var d = {
        "aria-hidden": "true"
      };
      return /* @__PURE__ */ x.createElement(o, G({}, a, {
        innerProps: d,
        isDisabled: u,
        isFocused: c
      }));
    }
  }, {
    key: "renderIndicatorSeparator",
    value: function() {
      var i = this.getComponents(), o = i.DropdownIndicator, a = i.IndicatorSeparator;
      if (!o || !a)
        return null;
      var s = this.commonProps, u = this.props.isDisabled, l = this.state.isFocused;
      return /* @__PURE__ */ x.createElement(a, G({}, s, {
        isDisabled: u,
        isFocused: l
      }));
    }
  }, {
    key: "renderDropdownIndicator",
    value: function() {
      var i = this.getComponents(), o = i.DropdownIndicator;
      if (!o)
        return null;
      var a = this.commonProps, s = this.props.isDisabled, u = this.state.isFocused, l = {
        onMouseDown: this.onDropdownIndicatorMouseDown,
        onTouchEnd: this.onDropdownIndicatorTouchEnd,
        "aria-hidden": "true"
      };
      return /* @__PURE__ */ x.createElement(o, G({}, a, {
        innerProps: l,
        isDisabled: s,
        isFocused: u
      }));
    }
  }, {
    key: "renderMenu",
    value: function() {
      var i = this, o = this.getComponents(), a = o.Group, s = o.GroupHeading, u = o.Menu, l = o.MenuList, c = o.MenuPortal, d = o.LoadingMessage, f = o.NoOptionsMessage, h = o.Option, p = this.commonProps, v = this.state.focusedOption, m = this.props, b = m.captureMenuScroll, y = m.inputValue, w = m.isLoading, S = m.loadingMessage, E = m.minMenuHeight, I = m.maxMenuHeight, _ = m.menuIsOpen, A = m.menuPlacement, P = m.menuPosition, N = m.menuPortalTarget, k = m.menuShouldBlockScroll, D = m.menuShouldScrollIntoView, R = m.noOptionsMessage, V = m.onMenuScrollToTop, $ = m.onMenuScrollToBottom;
      if (!_)
        return null;
      var F = function(W, Y) {
        var U = W.type, Q = W.data, Z = W.isDisabled, ee = W.isSelected, ie = W.label, oe = W.value, se = v === Q, te = Z ? void 0 : function() {
          return i.onOptionHover(Q);
        }, ge = Z ? void 0 : function() {
          return i.selectOption(Q);
        }, he = "".concat(i.getElementId("option"), "-").concat(Y), fe = {
          id: he,
          onClick: ge,
          onMouseMove: te,
          onMouseOver: te,
          tabIndex: -1
        };
        return /* @__PURE__ */ x.createElement(h, G({}, p, {
          innerProps: fe,
          data: Q,
          isDisabled: Z,
          isSelected: ee,
          key: he,
          label: ie,
          type: U,
          value: oe,
          isFocused: se,
          innerRef: se ? i.getFocusedOptionRef : void 0
        }), i.formatOptionLabel(W.data, "menu"));
      }, M;
      if (this.hasOptions())
        M = this.getCategorizedOptions().map(function(K) {
          if (K.type === "group") {
            var W = K.data, Y = K.options, U = K.index, Q = "".concat(i.getElementId("group"), "-").concat(U), Z = "".concat(Q, "-heading");
            return /* @__PURE__ */ x.createElement(a, G({}, p, {
              key: Q,
              data: W,
              options: Y,
              Heading: s,
              headingProps: {
                id: Z,
                data: K.data
              },
              label: i.formatGroupLabel(K.data)
            }), K.options.map(function(ee) {
              return F(ee, "".concat(U, "-").concat(ee.index));
            }));
          } else if (K.type === "option")
            return F(K, "".concat(K.index));
        });
      else if (w) {
        var B = S({
          inputValue: y
        });
        if (B === null)
          return null;
        M = /* @__PURE__ */ x.createElement(d, p, B);
      } else {
        var X = R({
          inputValue: y
        });
        if (X === null)
          return null;
        M = /* @__PURE__ */ x.createElement(f, p, X);
      }
      var L = {
        minMenuHeight: E,
        maxMenuHeight: I,
        menuPlacement: A,
        menuPosition: P,
        menuShouldScrollIntoView: D
      }, j = /* @__PURE__ */ x.createElement(Sie, G({}, p, L), function(K) {
        var W = K.ref, Y = K.placerProps, U = Y.placement, Q = Y.maxHeight;
        return /* @__PURE__ */ x.createElement(u, G({}, p, L, {
          innerRef: W,
          innerProps: {
            onMouseDown: i.onMenuMouseDown,
            onMouseMove: i.onMenuMouseMove,
            id: i.getElementId("listbox")
          },
          isLoading: w,
          placement: U
        }), /* @__PURE__ */ x.createElement(Vvt, {
          captureEnabled: b,
          onTopArrive: V,
          onBottomArrive: $,
          lockEnabled: k
        }, function(Z) {
          return /* @__PURE__ */ x.createElement(l, G({}, p, {
            innerRef: function(ie) {
              i.getMenuListRef(ie), Z(ie);
            },
            isLoading: w,
            maxHeight: Q,
            focusedOption: v
          }), M);
        }));
      });
      return N || P === "fixed" ? /* @__PURE__ */ x.createElement(c, G({}, p, {
        appendTo: N,
        controlElement: this.controlRef,
        menuPlacement: A,
        menuPosition: P
      }), j) : j;
    }
  }, {
    key: "renderFormField",
    value: function() {
      var i = this, o = this.props, a = o.delimiter, s = o.isDisabled, u = o.isMulti, l = o.name, c = this.state.selectValue;
      if (!(!l || s))
        if (u)
          if (a) {
            var d = c.map(function(p) {
              return i.getOptionValue(p);
            }).join(a);
            return /* @__PURE__ */ x.createElement("input", {
              name: l,
              type: "hidden",
              value: d
            });
          } else {
            var f = c.length > 0 ? c.map(function(p, v) {
              return /* @__PURE__ */ x.createElement("input", {
                key: "i-".concat(v),
                name: l,
                type: "hidden",
                value: i.getOptionValue(p)
              });
            }) : /* @__PURE__ */ x.createElement("input", {
              name: l,
              type: "hidden"
            });
            return /* @__PURE__ */ x.createElement("div", null, f);
          }
        else {
          var h = c[0] ? this.getOptionValue(c[0]) : "";
          return /* @__PURE__ */ x.createElement("input", {
            name: l,
            type: "hidden",
            value: h
          });
        }
    }
  }, {
    key: "renderLiveRegion",
    value: function() {
      var i = this.commonProps, o = this.state, a = o.ariaSelection, s = o.focusedOption, u = o.focusedValue, l = o.isFocused, c = o.selectValue, d = this.getFocusableOptions();
      return /* @__PURE__ */ x.createElement(_vt, G({}, i, {
        id: this.getElementId("live-region"),
        ariaSelection: a,
        focusedOption: s,
        focusedValue: u,
        isFocused: l,
        selectValue: c,
        focusableOptions: d
      }));
    }
  }, {
    key: "render",
    value: function() {
      var i = this.getComponents(), o = i.Control, a = i.IndicatorsContainer, s = i.SelectContainer, u = i.ValueContainer, l = this.props, c = l.className, d = l.id, f = l.isDisabled, h = l.menuIsOpen, p = this.state.isFocused, v = this.commonProps = this.getCommonProps();
      return /* @__PURE__ */ x.createElement(s, G({}, v, {
        className: c,
        innerProps: {
          id: d,
          onKeyDown: this.onKeyDown
        },
        isDisabled: f,
        isFocused: p
      }), this.renderLiveRegion(), /* @__PURE__ */ x.createElement(o, G({}, v, {
        innerRef: this.getControlRef,
        innerProps: {
          onMouseDown: this.onControlMouseDown,
          onTouchEnd: this.onControlTouchEnd
        },
        isDisabled: f,
        isFocused: p,
        menuIsOpen: h
      }), /* @__PURE__ */ x.createElement(u, G({}, v, {
        isDisabled: f
      }), this.renderPlaceholderOrValue(), this.renderInput()), /* @__PURE__ */ x.createElement(a, G({}, v, {
        isDisabled: f
      }), this.renderClearIndicator(), this.renderLoadingIndicator(), this.renderIndicatorSeparator(), this.renderDropdownIndicator())), this.renderMenu(), this.renderFormField());
    }
  }], [{
    key: "getDerivedStateFromProps",
    value: function(i, o) {
      var a = o.prevProps, s = o.clearFocusValueOnUpdate, u = o.inputIsHiddenAfterUpdate, l = o.ariaSelection, c = o.isFocused, d = o.prevWasFocused, f = i.options, h = i.value, p = i.menuIsOpen, v = i.inputValue, m = i.isMulti, b = tC(h), y = {};
      if (a && (h !== a.value || f !== a.options || p !== a.menuIsOpen || v !== a.inputValue)) {
        var w = p ? Zvt(i, b) : [], S = s ? Jvt(o, b) : null, E = Kvt(o, w);
        y = {
          selectValue: b,
          focusedOption: E,
          focusedValue: S,
          clearFocusValueOnUpdate: !1
        };
      }
      var I = u != null && i !== a ? {
        inputIsHidden: u,
        inputIsHiddenAfterUpdate: void 0
      } : {}, _ = l, A = c && d;
      return c && !A && (_ = {
        value: u0(m, b, b[0] || null),
        options: b,
        action: "initial-input-focus"
      }, A = !d), (l == null ? void 0 : l.action) === "initial-input-focus" && (_ = null), Jn(Jn(Jn({}, y), I), {}, {
        prevProps: i,
        ariaSelection: _,
        prevWasFocused: A
      });
    }
  }]), n;
}(Do);
bP.defaultProps = Yvt;
var Qvt = ["defaultInputValue", "defaultMenuIsOpen", "defaultValue", "inputValue", "menuIsOpen", "onChange", "onInputChange", "onMenuClose", "onMenuOpen", "value"];
function Uie(t) {
  var e = t.defaultInputValue, n = e === void 0 ? "" : e, r = t.defaultMenuIsOpen, i = r === void 0 ? !1 : r, o = t.defaultValue, a = o === void 0 ? null : o, s = t.inputValue, u = t.menuIsOpen, l = t.onChange, c = t.onInputChange, d = t.onMenuClose, f = t.onMenuOpen, h = t.value, p = Gt(t, Qvt), v = Le(s !== void 0 ? s : n), m = be(v, 2), b = m[0], y = m[1], w = Le(u !== void 0 ? u : i), S = be(w, 2), E = S[0], I = S[1], _ = Le(h !== void 0 ? h : a), A = be(_, 2), P = A[0], N = A[1], k = et(function(B, X) {
    typeof l == "function" && l(B, X), N(B);
  }, [l]), D = et(function(B, X) {
    var L;
    typeof c == "function" && (L = c(B, X)), y(L !== void 0 ? L : B);
  }, [c]), R = et(function() {
    typeof f == "function" && f(), I(!0);
  }, [f]), V = et(function() {
    typeof d == "function" && d(), I(!1);
  }, [d]), $ = s !== void 0 ? s : b, F = u !== void 0 ? u : E, M = h !== void 0 ? h : P;
  return Jn(Jn({}, p), {}, {
    inputValue: $,
    menuIsOpen: F,
    onChange: k,
    onInputChange: D,
    onMenuClose: V,
    onMenuOpen: R,
    value: M
  });
}
var e1t = ["defaultOptions", "cacheOptions", "loadOptions", "options", "isLoading", "onInputChange", "filterOption"];
function Xie(t) {
  var e = t.defaultOptions, n = e === void 0 ? !1 : e, r = t.cacheOptions, i = r === void 0 ? !1 : r, o = t.loadOptions;
  t.options;
  var a = t.isLoading, s = a === void 0 ? !1 : a, u = t.onInputChange, l = t.filterOption, c = l === void 0 ? null : l, d = Gt(t, e1t), f = d.inputValue, h = Ee(void 0), p = Ee(!1), v = Le(Array.isArray(n) ? n : void 0), m = be(v, 2), b = m[0], y = m[1], w = Le(typeof f < "u" ? f : ""), S = be(w, 2), E = S[0], I = S[1], _ = Le(n === !0), A = be(_, 2), P = A[0], N = A[1], k = Le(void 0), D = be(k, 2), R = D[0], V = D[1], $ = Le([]), F = be($, 2), M = F[0], B = F[1], X = Le(!1), L = be(X, 2), j = L[0], K = L[1], W = Le({}), Y = be(W, 2), U = Y[0], Q = Y[1], Z = Le(void 0), ee = be(Z, 2), ie = ee[0], oe = ee[1], se = Le(void 0), te = be(se, 2), ge = te[0], he = te[1];
  i !== ge && (Q({}), he(i)), n !== ie && (y(Array.isArray(n) ? n : void 0), oe(n)), Re(function() {
    return p.current = !0, function() {
      p.current = !1;
    };
  }, []);
  var fe = et(function(ze, Ve) {
    if (!o)
      return Ve();
    var ne = o(ze, Ve);
    ne && typeof ne.then == "function" && ne.then(Ve, function() {
      return Ve();
    });
  }, [o]);
  Re(function() {
    n === !0 && fe(E, function(ze) {
      p.current && (y(ze || []), N(!!h.current));
    });
  }, []);
  var _e = et(function(ze, Ve) {
    var ne = umt(ze, Ve, u);
    if (!ne) {
      h.current = void 0, I(""), V(""), B([]), N(!1), K(!1);
      return;
    }
    if (i && U[ne])
      I(ne), V(ne), B(U[ne]), N(!1), K(!1);
    else {
      var pe = h.current = {};
      I(ne), N(!0), K(!R), fe(ne, function(ye) {
        p && pe === h.current && (h.current = void 0, N(!1), V(ne), B(ye || []), K(!1), Q(ye ? Jn(Jn({}, U), {}, z({}, ne, ye)) : U));
      });
    }
  }, [i, fe, R, U, u]), Ne = j ? [] : E && R ? M : b || [];
  return Jn(Jn({}, d), {}, {
    options: Ne,
    isLoading: P || s,
    onInputChange: _e,
    filterOption: c
  });
}
var t1t = /* @__PURE__ */ gt(function(t, e) {
  var n = Xie(t), r = Uie(n);
  return /* @__PURE__ */ x.createElement(bP, G({
    ref: e
  }, r));
});
const n1t = t1t;
var r1t = ["allowCreateWhileLoading", "createOptionPosition", "formatCreateLabel", "isValidNewOption", "getNewOptionData", "onCreateOption", "options", "onChange"], MH = function() {
  var e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "", n = arguments.length > 1 ? arguments[1] : void 0, r = arguments.length > 2 ? arguments[2] : void 0, i = String(e).toLowerCase(), o = String(r.getOptionValue(n)).toLowerCase(), a = String(r.getOptionLabel(n)).toLowerCase();
  return o === i || a === i;
}, oI = {
  formatCreateLabel: function(e) {
    return 'Create "'.concat(e, '"');
  },
  isValidNewOption: function(e, n, r, i) {
    return !(!e || n.some(function(o) {
      return MH(e, o, i);
    }) || r.some(function(o) {
      return MH(e, o, i);
    }));
  },
  getNewOptionData: function(e, n) {
    return {
      label: n,
      value: e,
      __isNew__: !0
    };
  }
};
function i1t(t) {
  var e = t.allowCreateWhileLoading, n = e === void 0 ? !1 : e, r = t.createOptionPosition, i = r === void 0 ? "last" : r, o = t.formatCreateLabel, a = o === void 0 ? oI.formatCreateLabel : o, s = t.isValidNewOption, u = s === void 0 ? oI.isValidNewOption : s, l = t.getNewOptionData, c = l === void 0 ? oI.getNewOptionData : l, d = t.onCreateOption, f = t.options, h = f === void 0 ? [] : f, p = t.onChange, v = Gt(t, r1t), m = v.getOptionValue, b = m === void 0 ? Fie : m, y = v.getOptionLabel, w = y === void 0 ? Mie : y, S = v.inputValue, E = v.isLoading, I = v.isMulti, _ = v.value, A = v.name, P = Rn(function() {
    return u(S, tC(_), h, {
      getOptionValue: b,
      getOptionLabel: w
    }) ? c(S, a(S)) : void 0;
  }, [a, c, w, b, S, u, h, _]), N = Rn(function() {
    return (n || !E) && P ? i === "first" ? [P].concat(Ye(h)) : [].concat(Ye(h), [P]) : h;
  }, [n, i, E, P, h]), k = et(function(D, R) {
    if (R.action !== "select-option")
      return p(D, R);
    var V = Array.isArray(D) ? D : [D];
    if (V[V.length - 1] === P) {
      if (d)
        d(S);
      else {
        var $ = c(S, S), F = {
          action: "create-option",
          name: A,
          option: $
        };
        p(u0(I, [].concat(Ye(tC(_)), [$]), $), F);
      }
      return;
    }
    p(D, R);
  }, [c, S, I, A, P, d, p, _]);
  return Jn(Jn({}, v), {}, {
    options: N,
    onChange: k
  });
}
var o1t = /* @__PURE__ */ gt(function(t, e) {
  var n = Xie(t), r = Uie(n), i = i1t(r);
  return /* @__PURE__ */ x.createElement(bP, G({
    ref: e
  }, i));
});
const a1t = o1t, s1t = (t) => (e, n) => !t.some((i) => ii(e, i) === ii(n, i) ? !1 : !VC(ii(e, i), ii(n, i))), u1t = (t) => {
  const {
    value: e,
    config: n,
    options: { optionLabel: r, valueType: i = "object", optionValue: o },
    creatable: a = !1,
    loadOptions: s,
    onChange: u,
    disabled: l = !1,
    isMulti: c,
    ...d
  } = t, { style: f, ...h } = n, [p, v] = Le(e || null);
  Re(() => {
    v(e);
  }, [e]);
  let m = e || p;
  i === "string" && (c ? m = (m || []).map((E) => ({ [o]: E })) : m = e ? { [o]: e } : null);
  const b = a ? a1t : n1t, y = (E) => {
    if (i === "string") {
      let I = null;
      c && E ? I = E.map((_) => _[o]) : E && (I = E[o]), v(I), u(I);
    } else
      v(E), u(E);
  }, w = (E, I) => ({
    [r]: I,
    [o]: I
  }), S = (E) => E;
  return /* @__PURE__ */ Oe.jsx(
    b,
    {
      cacheOptions: !0,
      isDisabled: l,
      formatCreateLabel: S,
      placeholder: "",
      getNewOptionData: w,
      classNamePrefix: "ant-form-react-select",
      styles: n.styles || {},
      ...h || {},
      ...d,
      isMulti: c,
      value: m || null,
      onChange: y,
      loadOptions: s,
      getOptionLabel: typeof r == "function" ? r : (E) => E[r],
      getOptionValue: typeof o == "function" ? o : (E) => E[o]
    }
  );
};
O.memo(
  u1t,
  s1t(["value", "loadOptions", "disabled"])
);
Or.extend(Ede);
Or.extend(wde);
Or.extend(Ode);
Or.extend(Sde);
Or.extend(Pde);
Or.extend(Rde);
Or.extend(Nde);
Or.extend(_de);
Or.extend(Tde);
Or().format("L LT LLL");
export {
  oVe as AntFormColorPicker,
  Nbt as AntFormGooglePlaces,
  kbt as AntFormRailsNested,
  u1t as AntFormReactSelect,
  Z8 as default,
  Pbt as useAntForm
};
